(function () {
    'use strict';

    angular.module('redcap.location', []);
})();


(function () {
    'use strict';
    paymentPeriSettingsController.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.location')
        .component('paymentPeriSettings', {
            templateUrl: 'app/areas/location/components/payments/providers/peri/peri-settings.view.html',
            controller: paymentPeriSettingsController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });
    function paymentPeriSettingsController(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }

    }
})();

(function () {
    'use strict';
    paymentCenposSettingsController.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.location')
        .component('paymentCenposSettings', {
            templateUrl: 'app/areas/location/components/payments/providers/cenpos/cenpos-settings.view.html',
            controller: paymentCenposSettingsController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });
    function paymentCenposSettingsController(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }

    }
})();

(function () {
    'use strict';

    cardConnectTerminals.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.location')
        .component('cardConnectTerminals', {
            templateUrl: 'app/areas/location/components/payments/providers/cardconnect/cardconnect-terminals.view.html',
            controller: cardConnectTerminals,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function cardConnectTerminals(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
            vm.items = vm.items || [];
            vm.selectedIndex = 0;
            vm.terminals = this.ngModel || [];

            vm.addTerminal = function() {
                vm.terminals.push({
                    name: vm.name,
                    terminalId: vm.terminalId,
                    authorizationToken: vm.authorizationToken
                });

                this.ngModel = vm.terminals;
                vm.name = null;
                vm.terminalId = null;
                vm.authorizationToken = null;
            };
        }
    }
})();

(function () {
    'use strict';
    paymentCardConnectSettingsController.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.location')
        .component('paymentCardConnectSettings', {
            templateUrl: 'app/areas/location/components/payments/providers/cardconnect/cardconnect-settings.view.html',
            controller: paymentCardConnectSettingsController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });
    function paymentCardConnectSettingsController(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }
    }
})();

(function () {
    'use strict';

    VehicleConfigController.$inject = ["loanerSettingsService", "appointmentUtilService"];
    angular
        .module('redcap.location')
        .component('loanerSettingsVehicleConfig', {
            templateUrl: 'app/areas/location/components/loaner/settings/vehicle-config/vehicle-config.view.html',
            controller: VehicleConfigController,
            bindings: {
                ngModel: '<',
                onAdd: '&',
                onRemove: '&',
                upchargeEnabled : '<',
                pointsEnabled: '<',
                makes: '<',
                dealerId: '<'
            },
            controllerAs: 'vm'
        });

    function VehicleConfigController(loanerSettingsService, appointmentUtilService) {
        this.$onInit = function() {
            var vm = this;
            vm.ngModel.make = vm.ngModel.make || '';
            vm.ngModel.model = vm.ngModel.model || '';
            vm.myUniqueId = appointmentUtilService.getUniqueDOMID();

            vm.makeChanged = function() {
                if (vm.ngModel.make) {
                    loanerSettingsService.getModels(this.dealerId, this.ngModel.make).then(function(result) {
                        vm.models = result;
                    });
                }
            };

            vm.makeChanged();
        }
    }
})();

angular.module('heremaps-routes-module', [])
        .service('HereMapsRoutesService', ['$q', 'HereMapsMarkerService',
function ($q, HereMapsMarkerService) {
    return {
        calculateRoute: calculateRoute,
        addRouteToMap: addRouteToMap,
        removeRoutesFromMap: removeRoutesFromMap,
        cleanRoutes: cleanRoutes
    };

    function calculateRoute(heremaps, config) {

        var platform = heremaps.platform,
            map = heremaps.map,
            router = platform.getRoutingService(null, 8),
            dir = config.direction,
            waypoints = dir.waypoints,
            vias = [],
            routeRequestParams = null,
            length = waypoints.length,
            origin = waypoints[0],
            destination = waypoints[length-1],
            cnt;

        if (length > 2) {
            for (cnt = 1; cnt < length -1; cnt++) {
                vias.push(waypoints[cnt].lat + ',' + waypoints[cnt].lng);
            }
        }

        if (vias.length > 0) {
            routeRequestParams = {
                'origin': origin.lat + ',' + origin.lng,
                'destination': destination.lat + ',' + destination.lng,
                // defines multiple waypoints
                'via': new H.service.Url.MultiValueQueryParameter(vias),
                // returns route shape as a polyline in response
                'return': 'polyline',
                'transportMode': 'car',                
                'departureTime': 'any'
            };
        } else {
            routeRequestParams = {
                'origin': origin.lat + ',' + origin.lng,
                'destination': destination.lat + ',' + destination.lng,
                // returns route shape as a polyline in response
                'return': 'polyline',
                'transportMode': 'car',                
                'departureTime': 'any'
            };
        }

        var deferred = $q.defer();
        router.calculateRoute(routeRequestParams, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;

    }

    function cleanRoutes(map) {
        var group = map.routesGroup;

        if (!group)
            return;

        group.removeAll();
        map.removeObject(group);
        map.routesGroup = null;
    }

    function addRouteToMap(map, routeData, clean, metaData) {
        if (clean)
            cleanRoutes(map);

        var route = routeData.route;

        if (Array.isArray(route)) {
            route = route[0];
        }

        if (!map || !route || !route.shape)
            return;

        var strip = new H.geo.LineString(), polyline = null;

        route.shape.forEach(function (point) {
            var parts = point.split(',');
            strip.pushLatLngAlt(parts[0], parts[1]);
        });

        var style = routeData.style || {};
        var opacity = style.opacity || .6;
        var routeOptions = {
            style: {
                lineWidth: style.lineWidth || 4,
                strokeColor: style.color || 'rgba(0, 128, 255, ' + opacity + ')'
            }
        };

        if (metaData) {
            routeOptions.data = metaData;
        }

        polyline = new H.map.Polyline(strip, routeOptions);

        var group = map.routesGroup;

        if (!group) {
            group = map.routesGroup = new H.map.Group();
            map.addObject(group);
        }

        group.addObject(polyline);

        if (routeData.zoomToBounds) {
            HereMapsMarkerService.setViewBounds(map, polyline.getBoundingBox(), true);
        }
    }

    function removeRoutesFromMap(map, routes) {
        var group = map.routesGroup;

        if (!group)
            return;

        if (routes && routes.length) {
            _.forEach(routes, function(route) {
                if (group.contains(route)) {
                    group.removeObject(route);    
                }
            });            
        }            
    }
1
}]);

angular.module('heremaps-markers-module', []);
angular.module('heremaps-markers-module')
.factory('HereMapsSVGMarker', ['HereMapsMarkerInterface', function(HereMapsMarkerInterface) {
    function SVGMarker(place){
        this.place = place;
        this.setCoords();
    }
    
    var proto = SVGMarker.prototype = new HereMapsMarkerInterface();
    proto.constructor = SVGMarker;
    
    proto.create = create;
    proto.getIcon = getIcon;
    
    return SVGMarker;
    
    function create(){
        var marker = new H.map.Marker(this.coords, {
            icon: this.getIcon()
        });
        
        return marker;
    }
    
    function getIcon(){
        var icon = this.place.markup;
         if(!icon)
            throw new Error('markup missed');

        return new H.map.Icon(icon);
    }
}]);

angular.module('heremaps-markers-module')
.service('HereMapsMarkerService', ['HereMapsDefaultMarker',
'HereMapsDOMMarker',
'HereMapsSVGMarker',
'HereMapsCONSTS',
'HereMapsAPIService',
'SYSTEM_ENUMS',
'mapObjectFactory',
 function(HereMapsDefaultMarker, HereMapsDOMMarker, HereMapsSVGMarker, HereMapsCONSTS, HereMapsAPIService, SYSTEM_ENUMS, mapObjectFactory) {
    var MARKER_TYPES = HereMapsCONSTS.MARKER_TYPES,
        _lastOpenBubble,
        // Create an icon to represent the noise points
        // Note that same icon will be used for all noise points
        noiseIcon = new H.map.Icon('/assets/images/dealer-pin2.png', {
            size: {w: 41, h: 70},
            anchor: {x: 41, y: 70}
        });

    var clusterSvgTemplate =
    '<svg xmlns="http://www.w3.org/2000/svg" height="50px" width="50px"><circle cx="25px" cy="25px" r="20" fill="#5c85ec" stroke="white" stroke-width="2" stroke-opacity="0.5" />' +
    '<text x="24" y="32" font-size="{fontsize}pt" font-family="arial" font-weight="bold" text-anchor="middle" fill="white">{text}</text>' +
    '</svg>';

    return {
        addMarkersToMap: addMarkersToMap,
        addUserMarker: addUserMarker,
        updateMarkers: updateMarkers,
        getMarkers: getMarkers,
        isMarkerInstance: isMarkerInstance,
        setViewBounds: setViewBounds,
        getClusterTheme: getClusterTheme
    };

    function isMarkerInstance(target) {
        return target instanceof H.map.Marker || target instanceof H.map.DomMarker;
    }

    function addUserMarker(map, place) {
        if (map.userMarker)
            return map.userMarker;

        place.markup = '<svg width="35px" height="35px" viewBox="0 0 90 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
            '<defs><circle id="path-1" cx="302" cy="802" r="15"></circle>' +
            '<mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="-30" y="-30" width="90" height="90">' +
            '<rect x="257" y="757" width="90" height="90" fill="white"></rect><use xlink:href="#path-1" fill="black"></use>' +
            '</mask></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
            '<g id="Service-Options---directions---map" transform="translate(-257.000000, -757.000000)"><g id="Oval-15">' +
            '<use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use>' +
            '<use stroke-opacity="0.29613904" stroke="#3F34A0" mask="url(#mask-2)" stroke-width="60" xlink:href="#path-1"></use>' +
            '<use stroke="#3F34A0" stroke-width="5" xlink:href="#path-1"></use></g></g></g></svg>';

        map.userMarker = new HereMapsSVGMarker(place).create();

        map.addObject(map.userMarker);

        return map.userMarker;
    }

    function addMarkersToMap(map, places, refreshViewbounds, platform) {
        if (!places || !places.length)
            return;

        if (!(map instanceof H.Map))
            throw new Error('Unsupported map instance');

        if (!map.markersGroup)
            map.markersGroup = new H.map.Group();

        map.markersGroup.addEventListener('tap', function (evt) {
            var marker = evt.target;

            if (marker && marker.data && marker.data.popup && platform) {
                var ui = platform.ui;

                if (_lastOpenBubble) {
                    _lastOpenBubble.close();
                }
                
                _lastOpenBubble = new H.ui.InfoBubble(marker.getGeometry(), {
                    content: marker.data.popup
                });

                ui.addBubble(_lastOpenBubble);
            }            
        }, false);

        places.forEach(function (place, i) {
            var creator = _getMarkerCreator(place),
                marker = place.draggable ? _draggableMarkerMixin(creator.create()) : creator.create();

            var markerData = marker.getData() || {};
            if (place.data) angular.extend(markerData, place.data);
            
            markerData.objectType = markerData.objectType || SYSTEM_ENUMS.hereObjectType.marker;
            
            marker.setData(markerData);
            map.markersGroup.addObject(marker);
        });

        map.addObject(map.markersGroup);

        if (refreshViewbounds) {
            setViewBounds(map, map.markersGroup.getBoundingBox());
            if (places.length === 1)
                map.setZoom(HereMapsCONSTS.DEFAULT_MAP_OPTIONS.zoom);
        }
    }

    function setViewBounds(map, bounds, opt_animate) {
        map.getViewModel().setLookAtData({ bounds: bounds });
    }

    function updateMarkers(map, places, refreshViewbounds, platform) {
        
        if (map.markersGroup) {
            map.removeObject(map.markersGroup);
            map.markersGroup.removeAll();
            map.markersGroup = null;
        } 

        addMarkersToMap(map, places, refreshViewbounds, platform);
    }

    function getMarkers(map) {
        return map.markersGroup;
    }


    function _getMarkerCreator(place) {
        var ConcreteMarker,
            type = place.type ? place.type.toUpperCase() : null;

        switch (type) {
            case MARKER_TYPES.DOM:
                ConcreteMarker = HereMapsDOMMarker;
                break;
            case MARKER_TYPES.SVG:
                ConcreteMarker = HereMapsSVGMarker;
                break;
            default:
                ConcreteMarker = HereMapsDefaultMarker;
        }

        return new ConcreteMarker(place);
    }


    function _draggableMarkerMixin(marker) {
        marker.draggable = true;

        return marker;
    }
    

    function getClusterTheme(hereMap) {
        
                    
        return {
            getClusterPresentation: function(cluster) {
                // Use cluster weight to change the icon size
                var weight = cluster.getWeight(),
                // Calculate circle size
                radius = 15, //weight * 5,
                diameter = radius * 2,
                clusterSvgTemplate = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"' +
                ' height="30px" width="30px">' + 
                  '<g id="UrTavla">' + 
                   ' <circle fill="#378edb" cx="15px" cy="15px" r="15px">' + 
                    '</circle>' + 
                    '<text x="50%" y="50%" text-anchor="middle" font-family="arial" font-size="12px" stroke="#fff"  dy=".3em">' + weight + '</text>' + 
                  '</g>' + 
                '</svg>', //'<svg xmlns="http://www.w3.org/2000/svg" height="30px" width="30px"><circle cx="5px" cy="5px" r="5px" fill="orange" /></svg>',
                // Replace variables in the icon template
                svgString = clusterSvgTemplate.replace(/\{radius\}/g, radius).replace(/\{diameter\}/g, diameter),
        
                // Create an icon
                // Note that we create a different icon depending from the weight of the cluster
                // clusterIcon = new H.map.DomIcon(svgString, {
                //     size: {w: diameter, h: diameter},
                //     anchor: {x: radius, y: radius}
                // }),
                clusterIcon = new H.map.Icon(svgString),
        
                // Create a marker for the cluster
                clusterMarker = new H.map.Marker(cluster.getPosition(), {
                    icon: clusterIcon,
        
                    // Set min/max zoom with values from the cluster, otherwise
                    // clusters will be shown at all zoom levels
                    min: cluster.getMinZoom(),
                    max: cluster.getMaxZoom()
                });

                // Bind cluster data to the marker
                clusterMarker.setData(cluster);
        
                return clusterMarker;
            },
            getNoisePresentation: function(noisePoint) {
                
                var data = noisePoint.getData(),
                    // Create a marker for the noisePoint
                    noiseMarker = new H.map.Marker(noisePoint.getPosition(), {
                        // Use min zoom from a noise point
                        // to show it correctly at certain zoom levels:
                        min: noisePoint.getMinZoom(),
                        icon: noiseIcon
                    });

                    var ui = hereMap.getPlatform().ui;

                    noiseMarker.addEventListener('tap', function (evt) {
                        // event target is the marker itself, group is a parent event target
                        // for all objects that it contains
                        if (!noiseMarker.infoBubble) {
                            if (_lastOpenBubble) {
                                _lastOpenBubble.close();
                            }

                            var bubble = new H.ui.InfoBubble(noisePoint.getPosition(), {
                            // read custom data
                            content: mapObjectFactory.buildPopupContent({
                                    name: data.name,
                                    streetAddress: data.address,
                                    city: data.city,
                                    state: data.state,
                                    zip: data.zip
                                })
                            });
                            noiseMarker.infoBubble = bubble;
                            _lastOpenBubble = noiseMarker.infoBubble;
                            // show info bubble
                            ui.addBubble(bubble);
                        } else {
                            if (_lastOpenBubble) {
                                _lastOpenBubble.close();
                            }

                            _lastOpenBubble = noiseMarker.infoBubble;
                            noiseMarker.infoBubble.open();
                        }
                      }, false);

                   
                // Link a data from the point to the marker
                // to make it accessible inside onMarkerClick
                noiseMarker.setData(data);

                return noiseMarker;

            }    
        };
    }
}]);

angular.module('heremaps-markers-module')
.factory('HereMapsMarkerInterface', function() {
    function MarkerInterface(){
        throw new Error('Abstract class! The Instance should be created');
    }
    
    var proto = MarkerInterface.prototype;
    
    proto.create = create;
    proto.setCoords = setCoords;
    
    function Marker(){}
    
    Marker.prototype = proto;
    
    return Marker;
    
    function create(){
        throw new Error('create:: not implemented'); 
    }
    
    function setCoords() {
        this.coords = {
            lat: this.place.pos.lat,
            lng: this.place.pos.lng
        };
    }
});

angular.module('heremaps-markers-module')
.factory('HereMapsDOMMarker', ['HereMapsMarkerInterface', function(HereMapsMarkerInterface) {
    function DOMMarker(place){
        this.place = place;
        this.setCoords();
    }

    var proto = DOMMarker.prototype = new HereMapsMarkerInterface();
    proto.constructor = DOMMarker;

    proto.create = create;
    proto.getIcon = getIcon;
    proto.setupEvents = setupEvents;

    return DOMMarker;
    
    function create(){
        var options = angular.extend({ icon: this.getIcon(), data: this.place.options });

        var marker = new H.map.DomMarker(this.coords, options); 
        
        this.setupEvents(marker, this.place.events);
        return marker;
    }
    
    function getIcon(){
        var icon = this.place.markup;
         if (!icon)
            throw new Error('markup missed');

        if (this.place.anchor)
            return new H.map.DomIcon(icon, { anchor: new H.math.Point(this.place.anchor[0], this.place.anchor[1])});
        else
            return new H.map.DomIcon(icon);
    }
    
    function setupEvents(el, events, remove) {
        if (!el || !events) return;

        for (var key in events) {
            if (!events.hasOwnProperty(key))
                continue;

            if (remove) {
                el.removeEventListener(key, events[key]);
            } else {
                el.addEventListener(key, events[key]);
            }
        }
    }
}]);
angular.module('heremaps-markers-module')
.factory('HereMapsDefaultMarker', ['HereMapsMarkerInterface', function(HereMapsMarkerInterface) {
    function DefaultMarker(place){
        this.place = place;
        this.setCoords();
    }

    var proto = DefaultMarker.prototype = new HereMapsMarkerInterface();
    proto.constructor = DefaultMarker;

    proto.create = create;

    return DefaultMarker;
    
    function create(){
        var marker = new H.map.Marker(this.coords, this.place.options);
        
        return marker;
    }
}]);
angular.module('heremaps-events-module', []);
    
angular.module('heremaps-ui-module', []);
angular.module('heremaps-ui-module')
.factory('HereMapsUiFactory', ['HereMapsAPIService',
'HereMapsMarkerService',
'HereMapsUtilsService',
'HereMapsCONSTS', function(HereMapsAPIService, HereMapsMarkerService, HereMapsUtilsService, HereMapsCONSTS) {
    var vm = this;
    function UI(platform, alignment) {
        this.map = platform.map;
        this.layers = platform.layers;
        this.alignment = alignment;
        this.ui = platform.ui = H.ui.UI.createDefault(this.map, this.layers);

        this.setupControls();
    }

    UI.isValidAlignment = isValidAlignment;

    var proto = UI.prototype;

    proto.setupControls = setupControls;
    proto.createUserControl = createUserControl;
    proto.setControlsAlignment = setControlsAlignment;
    proto.showNearbyDriversButton = showNearbyDriversButton;

    return {
        start: function(args) {
            if (!(args.platform.map instanceof H.Map) && !args.platform.layers) {
                return console.error('Missed ui module dependencies');
            }
            
            var ui = new UI(args.platform, args.alignment);

            return ui;
        }
    };

    function setupControls() {
        var NAMES = HereMapsCONSTS.CONTROLS.NAMES;

        //this.ui.getControl(NAMES.SETTINGS).setIncidentsLayer(false);
        this.setControlsAlignment(NAMES);
    }

    function createUserControl() {
        var self = this,
            userControl = new H.ui.Control(),
            markup = '<svg class="H_icon" fill="#fff" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path class="middle_location_stroke" d="M8 12c-2.206 0-4-1.795-4-4 0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.205-1.794 4-4 4M8 1.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5"></path><path class="inner_location_stroke" d="M8 5a3 3 0 1 1 .001 6A3 3 0 0 1 8 5m0-1C5.794 4 4 5.794 4 8c0 2.205 1.794 4 4 4s4-1.795 4-4c0-2.206-1.794-4-4-4"></path><path class="outer_location_stroke" d="M8 1.25a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5M8 0C3.59 0 0 3.59 0 8c0 4.411 3.59 8 8 8s8-3.589 8-8c0-4.41-3.59-8-8-8"></path></svg>';

        var userControlButton = new H.ui.base.Button({
            label: markup,
            onStateChange: function(evt) {
                if (userControlButton.getState() === H.ui.base.Button.State.DOWN)
                    return;

                HereMapsAPIService.getPosition().then(function(response) {
                    var position = {
                        lng: response.coords.longitude,
                        lat: response.coords.latitude
                    };
                    
                    self.map.setCenter(position);
                    
                    HereMapsUtilsService.zoom(self.map, 17, .08);

                    if (self.userMarker) {
                        self.userMarker.setGeometry(position);
                        return;
                    }
                    
                    self.userMarker = HereMapsMarkerService.addUserMarker(self.map, {
                        pos: position
                    });
                });
            }
        });

        userControl.addChild(userControlButton);

        return userControl;
    }

    function showNearbyDriversButton(callback) {
        var driverControl = createNearbyDriversControl(callback);
        driverControl.setAlignment(this.alignment);
        this.ui.addControl(HereMapsCONSTS.CONTROLS.NAMES.NEARBY_DRIVERS, driverControl);
    }

    function createNearbyDriversControl(callback) {
        var driverControl = new H.ui.Control(),
            markup = '<div class="H_icon centered-content"><i class="material-icons md-24">directions_car</i></div>';
        var driverControlButton = new H.ui.base.Button({
            label: markup,
            onStateChange: function(evt) {
                if (driverControlButton.getState() === H.ui.base.Button.State.DOWN)
                    return;

                if (callback) callback();
            }
        });

        driverControl.addChild(driverControlButton);

        return driverControl;
    }

    function setControlsAlignment(NAMES) {
        if (!UI.isValidAlignment(this.alignment))
            return;

        for (var id in NAMES) {
            var control = this.ui.getControl(NAMES[id]);

            if (!NAMES.hasOwnProperty(id) || !control)
                continue;

            control.setAlignment(this.alignment);
        }
    }

    function isValidAlignment(alignment) {
        return !!(HereMapsCONSTS.CONTROLS.POSITIONS.indexOf(alignment) + 1);
    }
}]);

angular.module('heremaps-events-module')
.factory('HereMapsInfoBubbleFactory', ['HereMapsMarkerService',
'HereMapsUtilsService',
'HereMapsCONSTS', function(HereMapsMarkerService, HereMapsUtilsService, HereMapsCONSTS){
    function InfoBubble() {}

    var proto = InfoBubble.prototype;
        
    proto.create = create;
    proto.update = update;
    proto.toggle = toggle;
    proto.show = show;
    proto.close = close;

    return {
        create: function(){
            return new InfoBubble();
        }
    };

    function toggle(e, ui) {
        if (HereMapsMarkerService.isMarkerInstance(e.target))
            this.show(e, ui);
        else
            this.close(e, ui);
    }

    function update(bubble, data) {
        bubble.display = data.display;

        bubble.setPosition(data.position);
        bubble.setContent(data.markup);

        bubble.setState(HereMapsCONSTS.INFOBUBBLE.STATE.OPEN);
    }

    function create(source) {
        var bubble = new H.ui.InfoBubble(source.position, {
            content: source.markup
        });

        bubble.display = source.display;
        bubble.addClass(HereMapsCONSTS.INFOBUBBLE.STATE.OPEN);

        HereMapsUtilsService.addEventListener(bubble, 'statechange', function(e) {
            var state = this.getState(),
                el = this.getElement();
            if (state === HereMapsCONSTS.INFOBUBBLE.STATE.CLOSED) {
                el.classList.remove(HereMapsCONSTS.INFOBUBBLE.STATE.OPEN);
            } else
                this.addClass(state);
        });

        return bubble;
    }

    function show(e, ui, data) {
        var target = e.target,
            data = target.getData(),
            el = null;

        if (!data || !data.display || !data.markup || data.display !== HereMapsCONSTS.INFOBUBBLE.DISPLAY_EVENT[e.type])
            return;

        var source = {
            position: target.getGeometry(),
            markup: data.markup,
            display: data.display
        };

        if (!ui.bubble) {
            ui.bubble = this.create(source);
            ui.addBubble(ui.bubble);

            return;
        }

        this.update(ui.bubble, source);
    }

    function close(e, ui) {
        if (!ui.bubble || ui.bubble.display !== HereMapsCONSTS.INFOBUBBLE.DISPLAY_EVENT[e.type]) {
            return;
        }

        ui.bubble.setState(HereMapsCONSTS.INFOBUBBLE.STATE.CLOSED);
    }
}]);

angular.module('heremaps-events-module')
.factory('HereMapsEventsFactory', ['HereMapsUtilsService',
'HereMapsMarkerService',
'HereMapsCONSTS',
'HereMapsInfoBubbleFactory', function(HereMapsUtilsService, HereMapsMarkerService, HereMapsCONSTS, HereMapsInfoBubbleFactory) {
    function Events(platform, Injector, listeners) {
        this.map = platform.map;
        this.listeners = listeners;
        this.inject = new Injector();
        this.events = platform.events = new H.mapevents.MapEvents(this.map);
        this.behavior = platform.behavior = new H.mapevents.Behavior(this.events);
        this.bubble = HereMapsInfoBubbleFactory.create();

        this.setupEventListeners();
    }

    var proto = Events.prototype;

    proto.setupEventListeners = setupEventListeners;
    proto.setupOptions = setupOptions;
    proto.triggerUserListener = triggerUserListener;
    proto.infoBubbleHandler = infoBubbleHandler;  

    return {
        start: function(args) {
            if (!(args.platform.map instanceof H.Map))
                return console.error('Missed required map instance');

            var events = new Events(args.platform, args.injector, args.listeners);
            args.options && events.setupOptions(args.options);
        }
    };

    function setupEventListeners() {
        var self = this;
        HereMapsUtilsService.addEventListener(this.map, 'tap', this.infoBubbleHandler.bind(this));

        HereMapsUtilsService.addEventListener(this.map, 'pointermove', this.infoBubbleHandler.bind(this));

        HereMapsUtilsService.addEventListener(this.map, 'dragstart', function(e) {
            if (HereMapsMarkerService.isMarkerInstance(e.target)) {
                self.behavior.disable();
            }

            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });

        HereMapsUtilsService.addEventListener(this.map, 'drag', function(e) {
            var pointer = e.currentPointer,
                target = e.target;

            if (HereMapsMarkerService.isMarkerInstance(target)) {
                target.setGeometry(self.map.screenToGeo(pointer.viewportX, pointer.viewportY));
            }

            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });

        HereMapsUtilsService.addEventListener(this.map, 'dragend', function(e) {
            if (HereMapsMarkerService.isMarkerInstance(e.target)) {
                self.behavior.enable();
            }

            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });

        HereMapsUtilsService.addEventListener(this.map, 'mapviewchangestart', function(e) {
            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });

        HereMapsUtilsService.addEventListener(this.map, 'mapviewchange', function(e) {
            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });

        HereMapsUtilsService.addEventListener(this.map, 'mapviewchangeend', function(e) {
            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });

        HereMapsUtilsService.addEventListener(this.map, 'wheel', function (e) {
            self.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);
        });
    }

    function setupOptions(options) {
        if (!options)
            return;

        this.map.draggable = !!options.draggable;

        if (options.draggable === false) {
            this.behavior.disable(window.H.mapevents.Behavior.WHEELZOOM);
            this.behavior.disable(window.H.mapevents.Behavior.PINCH_ZOOM);
            this.behavior.disable(window.H.mapevents.Behavior.DBL_TAP_ZOOM);
        }
    }

    function triggerUserListener(eventName, e) {
        if (!this.listeners)
            return;

        var callback = this.listeners[eventName];

        callback && callback(e);
    }
    
    function infoBubbleHandler(e){
        var ui = this.inject('ui');
        
        if(ui)
            this.bubble.toggle(e, ui);
            
        this.triggerUserListener(HereMapsCONSTS.USER_EVENTS[e.type], e);      
    }
}]);

(function () {
    'use strict';

    LocationTabLoanerSettingsPreferencesController.$inject = ["$filter", "eventAlertService", "dealerHasCheckin", "loanerSettingsService", "resolvedLocation", "resolvedSettings", "resolvedVehicleMakes", "modalService", "resolvedTripTypInstances"];
    angular
        .module('redcap.location')
        .controller('LocationTabLoanerSettingsPreferencesController', LocationTabLoanerSettingsPreferencesController);

    function LocationTabLoanerSettingsPreferencesController($filter, eventAlertService, dealerHasCheckin, loanerSettingsService, resolvedLocation, resolvedSettings, resolvedVehicleMakes, modalService, resolvedTripTypInstances) {
        let vm = this;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedTripTypInstances;
        vm.resolvedLocation = resolvedLocation;
        vm.resolvedSettings = resolvedSettings || {};
        vm.makes = resolvedVehicleMakes;
        vm.resolvedSettings.vehicles = vm.resolvedSettings.vehicles || [{}];
        vm.lyftCredit = $filter('filter')(resolvedTripTypInstances, {systemTripTypeId: 20, status: 1}, true);
        vm.hasLyftCredit = vm.lyftCredit && vm.lyftCredit.length > 0;

        if (vm.hasLyftCredit === false) {
            vm.resolvedSettings.enableLyftCreditAlternative = false;
        }

        vm.addNewVehicle = function () {
            vm.resolvedSettings.vehicles.push({});
        };

        vm.removeVehicle = function (index) {
            modalService.showYesNo('Confirm delete', 'Are you sure you want to delete this item?', 'No', 'Yes').then((result) => {
                if (result === true) {
                    vm.resolvedSettings.vehicles.splice(index, 1);
                }
            });
        };

        vm.saveChanges = function(isValid) {
            if (isValid) {
                vm.saving = true;
                loanerSettingsService.saveSettings(resolvedLocation.id, vm.resolvedSettings).then((result) => {
                    vm.saving = false;
                    eventAlertService.createAlert('Settings saved successfully.');
                });
            }
        };

        vm.enableUpchargeChanged = function () {
            if (!vm.resolvedSettings.enableUpchargeFee) {
                vm.resolvedSettings.enableLarPointsUpcharge = false;
            }
        };
    }
})();

(function () {
    'use strict';

    LocationTabLoanerSettingsNotificationsController.$inject = ["dealerHasCheckin", "resolvedDealerTripTypes", "resolvedSettings", "resolvedLocation", "loanerSettingsService", "eventAlertService"];
    angular
        .module('redcap.location')
        .controller('LocationTabLoanerSettingsNotificationsController', LocationTabLoanerSettingsNotificationsController);

    function LocationTabLoanerSettingsNotificationsController(dealerHasCheckin, resolvedDealerTripTypes, resolvedSettings, resolvedLocation, loanerSettingsService, eventAlertService) {
        let vm = this;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.reminder = resolvedSettings.reminder;
        vm.homework = resolvedSettings.homework;

        vm.saveChanges = function (valid) {

            if (valid) {
                this.saving = true;
                loanerSettingsService.saveNotificationSettings(resolvedLocation.id, {
                    homework: vm.homework,
                    reminder: vm.reminder
                }).then((result) => {
                    eventAlertService.createAlert('Settings saved successfully.');
                }).finally(() => {
                    vm.saving = false;
                });

            }
        };
    }
})();

(function () {
    'use strict';

    TaskSelectionsController.$inject = ["SYSTEM_ENUMS"];
    angular
        .module('redcap.location')
        .component('taskSelections', {
            bindings: {
                ngModel: '<'
            },
            templateUrl: 'app/areas/location/components/tasks/selections/selection.component.view.html',
            controller: TaskSelectionsController,
            controllerAs: 'vm'
        });

    function TaskSelectionsController(SYSTEM_ENUMS) {
        this.$onInit = function() {
            var vm = this;
            vm.ngModel.items = vm.ngModel && vm.ngModel.items || [];

            vm.getItemCount = function() {
                if (!vm.ngModel.items) return 0;
                return vm.ngModel.items.filter(function(item) {
                    return !item.disabled;
                }).length;
            };

            vm.addItem = function() {
                vm.ngModel.items.push({
                    id: null,
                    text: '',
                    disabled: false
                });
            };

        }

    }
})();

(function () {
    'use strict';

    angular.module('redcap.loaner', []);
})();

(function () {
    'use strict';

    VehicleAddDetailsController.$inject = ["SYSTEM_ENUMS", "loanerService", "rcUtilService", "vehicleService", "modalService", "$scope", "$filter", "$state"];
    angular
        .module('redcap.loaner')
        .controller('VehicleAddDetailsController', VehicleAddDetailsController);

    function VehicleAddDetailsController(SYSTEM_ENUMS, loanerService, rcUtilService, vehicleService, modalService, $scope, $filter, $state) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        parent_vm.child = this;

        vm.vehicleYears = [];
        vm.vehicleMakes = [];
        vm.vehicleModels = [];
        vm.vehicleColors = [];

        vm.selectedMake = null;
        vm.selectedModel = null;
        vm.selectedTrim = null;
        vm.usStates = SYSTEM_ENUMS.usStates;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.dealerConfigurations = parent_vm.dealerConfigurations;
        vm.availableOn = vm.today = moment(new Date());


        vm.checkVin = function () {
            vm.invalidVin = true;

            if (vm.vin.trim().length === 17 && vm.vin.match(/^[a-zA-Z0-9]+$/)) {
                vm.invalidVin = false;
                vehicleService.decodeVin(parent_vm.location.id, vm.vin).then((response) => {
                    if (response) {
                        
                        vm.year = response.year;
                        vm.yearUpdated(response.makeName, response.modelName, response.subModelName, true);
                    } else {
                        vm.decodeFailWarning();
                    }
                });
            } else {
                vm.year = null;
                vm.make = null;
                vm.model = null;
                vm.trim = null;
            }     
        };

        vm.loadVehicleYears = function () {
            vm.updatingVehicleYears = true;
            vehicleService.getYears(parent_vm.location.id).then((years) => {
                vm.vehicleYears = years;              
            }).finally(() => {
                vm.updatingVehicleYears = false;
            });

            vm.loadingColors = true;
            vehicleService.getColors(parent_vm.location.id).then((colors) => {
                vm.vehicleColors = colors;
                vm.vehicleColors.push("Other");                
            }).finally(() => {
                vm.loadingColors = false;
            });
        };

        vm.yearUpdated = function (makeToSelect, modelToSelect, subModelToSelect, initiatedFromVinDecode) {

            vm.updatingVehicleMakes = true;
            vehicleService.getMakesInYear(parent_vm.location.id, vm.year)
                .then((result) => {
                    vm.vehicleMakes = result;

                    if (makeToSelect) {
                        vm.ensureVehicleMakeInDropDown(makeToSelect);
                        vm.selectMakeInDropDown(makeToSelect);
                    }

                    vm.makeUpdated(modelToSelect, subModelToSelect, initiatedFromVinDecode);
                    vm.updatingVehicleMakes = false;
                })
                .finally(() => {
                    vm.updatingVehicleMakes = false;
                });
        };

        vm.ensureVehicleMakeInDropDown = function (makeToSelect) {
            let make = makeToSelect;
            let exists = (vm.vehicleMakes || []).some((o) => { return o.make && o.make.toLowerCase() === make.toLowerCase();  });

            if (!exists) {
                if (!vm.vehicleMakes) {
                    vm.vehicleMakes = [];
                }

                vm.vehicleMakes.push({make: make, makeCode: make});
            }

        };

        vm.selectMakeInDropDown = function (makeToSelect) {
            let compareTo = makeToSelect.toLowerCase();
            let findMake = $filter('filter')(vm.vehicleMakes, (item) => {
                    return item.makeCode.toLowerCase() === compareTo || item.make.toLowerCase() === compareTo;
                }, true);

            if (findMake && findMake.length > 0) {
                vm.selectedMake = findMake[0];
                //vm.make = vm.selectedMake ? vm.selectedMake : null;
            }

        };

        vm.makeUpdated = function (modelToSelect, subModelToSelect, initiatedFromVinDecode) {
            //vm.make = vm.selectedMake
            if (vm.selectedMake) {
                vm.updatingVehicleModels = true;
                vehicleService.getModels(parent_vm.location.id, vm.year, vm.selectedMake.make)
                    .then((result) => {
                        vm.vehicleModels = result;
                        vm.selectedModel = null;

                        if (modelToSelect) {
                            vm.ensureVehicleModelInDropDown(modelToSelect);
                            vm.selectModelInDropDown(modelToSelect, subModelToSelect, initiatedFromVinDecode);

                        }

                        vm.updatingVehicleModels = false;
                    })
                    .finally(() => {
                        vm.updatingVehicleModels = false;
                    });
            }
        };

        vm.ensureVehicleModelInDropDown = function (modelToSelect) {
            let model = modelToSelect;
            let exists = (vm.vehicleModels || []).some((o) => { return o.model && o.model.toLowerCase() === model.toLowerCase(); });

            if (!exists) {
                if (!vm.vehicleModels) {
                    vm.vehicleModels = [];
                }

                vm.vehicleModels.push({model: model, modelCode: model});
            }

        };

        vm.selectModelInDropDown = function (modelToSelect, subModelToSelect, initiatedFromVinDecode) {
            let compareTo = modelToSelect.toLowerCase();
            let findModel = $filter('filter')(vm.vehicleModels, (item) => {
                    if (item.modelCode) {
                        return item.modelCode.toLowerCase() === compareTo || item.model.toLowerCase() === compareTo;
                    } else {
                        return false;
                    }
                }, true);

            if (findModel && findModel.length > 0) {
                vm.selectedModel = findModel[0];
                //vm.model = vm.selectedModel ? vm.selectedModel.modelCode : null;

                if (subModelToSelect) {
                    vehicleService.getSubModels(parent_vm.location.id, vm.year, vm.selectedMake.make, vm.selectedModel.model)
                        .then((submodels) => {
                            vm.vehicleSubModels = submodels;
                            let compareTo = subModelToSelect.toLowerCase();
                            let findSubModel = $filter('filter')(submodels, (item) => {
                                    return item.toLowerCase() === compareTo;
                                }, true);

                            vm.selectedTrim = findSubModel[0];
                        });
                }

            }

        };

        vm.modelUpdated = function () {
            if (vm.selectedModel) {
                vm.updatingVehicleSubModels = true;
                vehicleService.getSubModels(parent_vm.location.id, vm.year, vm.selectedMake.make, vm.selectedModel.model)
                    .then((result) => {
                        vm.vehicleSubModels = result;
                    })
                    .finally(() => {
                        vm.updatingVehicleSubModels = false;
                    });
            } else {
                vm.vehicleSubModels = null;
            }
        };

        vm.submitForm = function () {
            //TODO Save Form
            vm.loading = true;
            const vehicle = {
                stockNumber: vm.stockNum,
                availableOn: vm.availableOn.format('YYYY-MM-DD'),
                license: vm.licensePlate,
                year: vm.year,
                make: vm.selectedMake.make,
                model: vm.selectedModel.model,
                trim: vm.selectedTrim,
                color: vm.selectedColor === "Other" ? vm.color : vm.selectedColor,
                vin: vm.vin,
                vehicleClass: vm.vehicleGroup,
                licenseSubregion: vm.state,
                tollTag: vm.tollTag,
                tollTagVerified: vm.tollTagVerified,
                status: vm.status
            };

            if (parent_vm.resolvedVehicle) {
                loanerService.updateVehicle(vehicle, parent_vm.vehicleId, parent_vm.location.id).then(result => {
                    vm.redirectSummary(result);             
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    vm.loading = false;
                });
             } else {
                loanerService.saveVehicle(vehicle, parent_vm.location.id).then(result => {
                    vm.redirectSummary(result);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    vm.loading = false;
                });
                
            }
        };

        vm.redirectSummary = function (result) {
            const details = { 
                vehicleId: result.content.id ? result.content.id : result.content.vin, 
                locationId: parent_vm.location.id 
            };

            $state.go('loaner-vehicle-summary', details);
        };

        vm.initEdit = function () {
            vm.stockNum = parent_vm.resolvedVehicle.stockNumber;
            vm.availableOn = parent_vm.resolvedVehicle.availableDate ? moment(new Date(parent_vm.resolvedVehicle.availableDate)) : moment(new Date(parent_vm.resolvedVehicle.inServiceDate));
            vm.licensePlate = parent_vm.resolvedVehicle.license;
            vm.year = parent_vm.resolvedVehicle.year;
            vm.vin = parent_vm.resolvedVehicle.vin;
            vm.yearUpdated(parent_vm.resolvedVehicle.make, parent_vm.resolvedVehicle.model, parent_vm.resolvedVehicle.trim, true);
            vm.color = parent_vm.resolvedVehicle.color;
            vm.selectedColor = vm.color ?? vm.color[0].toUpperCase() + vm.color.slice(1).toLowerCase();
            vm.vehicleGroup = parent_vm.resolvedVehicle.vehicleClass;
            vm.state = parent_vm.resolvedVehicle.licenseState;
            vm.tollTag = parent_vm.resolvedVehicle.tollTagNumber;
            vm.tollTagVerified = parent_vm.resolvedVehicle.tollTagVerified;
            vm.status = parent_vm.resolvedVehicle.status;
        };

        vm.validation = {
            validVin: function (vin) {
                return rcUtilService.isValidVin(vin);
            }
        };

        if (parent_vm.resolvedVehicle) {
            vm.initEdit();
        }

        vm.loadVehicleYears();

        vm.decodeFailWarning = function () {
            modalService.showYesNo('Error', 'Unable to decode VIN. If you are sure it is correct, click OK to continue.', null, 'OK');
        };
    }
})();

(function () {
    'use strict';

    VehiclesChooseLocationController.$inject = ["$scope"];
    angular
        .module('redcap.loaner')
        .controller('VehiclesChooseLocationController', VehiclesChooseLocationController);

    function VehiclesChooseLocationController($scope) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        parent_vm.child = this;
        vm.locations = parent_vm.resolvedLocations;
        vm.locationSearchThreshold = 5;

        vm.locationClicked = function (location) {
            parent_vm.location = location;
            parent_vm.locationSelected();
        };
    }
})();

(function () {
    'use strict';

    ContractsChooseTimeController.$inject = ["$scope", "$q", "$state", "repairOrderService", "tripService", "loanerService"];
    angular
        .module('redcap.loaner')
        .controller('ContractsChooseTimeController', ContractsChooseTimeController);

    function ContractsChooseTimeController($scope, $q, $state, repairOrderService, tripService, loanerService) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        parent_vm.child = this;
        let pageSize = 100;

        vm.locations = parent_vm.resolvedLocations;
        vm.cancelPromise = null;

        let defaultOptions = function (callback) {
            return {
                width: '100%',
                placeholder: 'Search by trip id, mobile # or name',
                minimumInputLength: 3,
                maximumSelectionLength: 1,
                allowClear: true,
                ajax: {
                    type: 'GET',
                    dataType: 'json',
                    data: function (parameters) {
                        let query = {
                            search: parameters.term,
                            page: parameters.page,
                            locationId: parent_vm.location.id,
                            advisorId: null,
                            pageSize: pageSize
                        };

                        return query;
                    },
                    transport: function (params, success, failure) {
                        let data = params.data;

                        if (vm.cancelPromise) {
                            vm.cancelPromise.resolve();
                        }

                        vm.cancelPromise = $q.defer();

                        if (callback) {
                            return callback(data.locationId, data.search, data.page, data.pageSize, vm.cancelPromise.promise).then((results) => {
                                success(results);
                            }).catch((err) => {
                                failure(err);
                            });
                        }
                        
                    },
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    }
                },
                templateSelection: function (item) {
                    if (!item.id) return item.text;

                    if (item.tripDateTime) {
                        item.tripDateTime = new moment(item.tripDateTime).format('MM/DD/YYYY');
                        vm.pickupDate = new Date(item.tripDateTime);
                        
                        try {
                            $scope.$apply();
                        } catch (ex) {
                            //already applying
                        }
                    }

                    return item.id + ' ' + item.firstName + ' ' + item.lastName + ' (' + (item.tripDateTime || 'No Date') + ')';
                },
                templateResult: function (item) {
                    if (item.loading) {
                        return "Searching...";
                    }

                    if (item.tripDateTime) {
                        item.tripDateTime = new moment(item.tripDateTime).format('MM/DD/YYYY');
                    }

                    return item.id + ' ' + item.firstName + ' ' + item.lastName + ' (' + (item.tripDateTime || 'No Date') + ')';
                }
            };
        };

        vm.searchTripsOptions = defaultOptions(loanerService.searchTrips);
        vm.searchAppointmentsOptions = defaultOptions(loanerService.searchAppointments);

        vm.submitForm = function () {
            vm.loading = true;
            loanerService.saveReservation(parent_vm.location.id, {
                customer: parent_vm.customer,
                reservationDate: vm.pickupDate,
                tripId: vm.tripId && Array.isArray(vm.tripId) && vm.tripId.length && vm.tripId[0] || null
            }).then((reservationId) => {
                $state.go('loaner-reservation-edit', {'reservationId': reservationId, 'locationId': parent_vm.location.id});
                vm.loading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    ContractsChooseLocationController.$inject = ["$scope"];
    angular
        .module('redcap.loaner')
        .controller('ContractsChooseLocationController', ContractsChooseLocationController);

    function ContractsChooseLocationController($scope) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        parent_vm.child = this;
        vm.locations = parent_vm.resolvedLocations;
        vm.locationSearchThreshold = 5;

        vm.locationClicked = function (location) {
            parent_vm.location = location;
            parent_vm.locationSelected();
        };
    }
})();

(function () {
    'use strict';

    ContractsChooseCustomerController.$inject = ["loanerService", "$scope", "$timeout", "$filter", "$q"];
    angular
        .module('redcap.loaner')
        .controller('ContractsChooseCustomerController', ContractsChooseCustomerController);

    function ContractsChooseCustomerController(loanerService, $scope, $timeout, $filter, $q) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        parent_vm.child = this;
        
        vm.repairOrderPage = 0;
        let pageSize = 25;

        vm.selectedContact = false;
        vm.selectedRepairOrder = false;

        vm.cancelPromise = null;
        vm.phoneSearchOptions = {
            width: '100%',
            placeholder: 'Search by mobile # or name',
            minimumInputLength: 3,
            maximumSelectionLength: 1,
            allowClear: true,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        locationId: parent_vm.location.id,
                        advisorId: null,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return loanerService.searchCustomers(data.locationId, data.search, vm.cancelPromise.promise).then((results) => {
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                return $filter('tel')(item.phoneNumber) + ' ' + item.firstName + ' ' + item.lastName;
            },
            templateResult: function (item) {
                if (item.loading) {
                    return "Searching...";
                }

                return $filter('tel')(item.phoneNumber) + ' ' + item.firstName + ' ' + item.lastName;
            }
        };

        vm.setCustomerData = function (params) {
            if (!parent_vm.isCreatingNew) {
                angular.element("#phoneselect").prop('disabled', true);
            }
            
            vm.selectedRepairOrder = params.data;
            vm.firstName = params.data.customerFirstName;
            vm.lastName = params.data.customerLastName;
            vm.mobilePhone = params.data.phoneNumber;

            if (vm.mobilePhone && vm.firstName && vm.lastName) {
                vm.submitForm();
            }
        };
        
        vm.setupPhoneSelect = function() {
            $timeout(() => {
                    let element = angular.element("#phoneselect");

                    if (element.length) {
                        element.on('select2:select',
                            (e) => {
                                if (!parent_vm.isCreatingNew) {
                                    angular.element("#roselect").prop('disabled', true);
                                }

                                vm.selectedContact = e.params.data;
                                vm.firstName = e.params.data.firstName;
                                vm.lastName = e.params.data.lastName;
                                vm.mobilePhone = e.params.data.phoneNumber;
                                $scope.$apply();

                                if (vm.mobilePhone && vm.firstName && vm.lastName) {
                                    vm.submitForm();
                                }
                            }).on('select2:unselect',
                            (e) => {
                                angular.element("#roselect").prop('disabled', false);
                                vm.selectedContact = null;
                            });
                    } else {
                        vm.setupPhoneSelect();
                    }
                },
                100,
                1);
        };

        vm.submitForm = function () {
            parent_vm.customer = parent_vm.customer || {};
            parent_vm.customer.selectedContact = vm.selectedContact;
            parent_vm.customer.firstName = vm.firstName;
            parent_vm.customer.lastName = vm.lastName;
            parent_vm.customer.mobilePhone = vm.mobilePhone;

            parent_vm.billToSelected();
        };

        vm.setupPhoneSelect();
    }
})();

(function () {
    'use strict';

    angular.module('redcap.consumer.components', []);
})();

(function () {
    'use strict';

    ConsumerTermsController.$inject = ["consumerService", "$transition$", "dealerBranding", "CONSUMER_APPS_TYPE", "consumerOwnercareService"];
    angular
        .module('redcap.consumer.components')
        .controller('ConsumerTermsController', ConsumerTermsController);

    function ConsumerTermsController(consumerService, $transition$, dealerBranding, CONSUMER_APPS_TYPE, consumerOwnercareService) {
        var vm = this;
        vm.dealer = dealerBranding;
        vm.tripTypeId = $transition$.params()['tripTypeId'];
        vm.tripTypeInstanceId = $transition$.params()['tripTypeInstanceId'];
        vm.appType = $transition$.params()['appType'];

        // Startup
        init();

        function init() {
            // Set default value if not defined
            vm.appType = vm.appType || CONSUMER_APPS_TYPE.serviceValet;

            vm.getOwnerCareTerms = function() {
                consumerOwnercareService.getTerms(vm.dealer.id || vm.dealer.dealerId).then(
                    function (result) {
                        // Success
                        if (result) {
                            // Set HTML binding
                            vm.terms = result;
                        } else {
                            // Something was missing or not returned
                            vm.hasError = true;
                        }
                    },
                    function (error) {
                        // Failure
                        vm.hasError = true;
                    }
                );
            };

            vm.getNormalTerms = function() {
                var dealerId = vm.dealer.id || vm.dealer.dealerId;
                consumerService.getTerms(dealerId, vm.appType, vm.tripTypeId, vm.tripTypeInstanceId).then(
                    function(result) {
                        // Success
                        if (result.value) {
                            // Set HTML binding
                            vm.terms = result.value;
                        } else {
                            // Something was missing or not returned
                            vm.hasError = true;
                        }
                    },
                    function(error) {
                        // Failure
                        vm.hasError = true;
                    }
                );
            };

            switch (+vm.appType) {
            case CONSUMER_APPS_TYPE.ownerCare:
                vm.getOwnerCareTerms();
                break;
            default:
                vm.getNormalTerms();
                break;
            }
        }
    }
})();

(function () {
    'use strict';

    ConsumerFAQController.$inject = ["consumerService", "$transition$", "dealerBranding", "CONSUMER_APPS_TYPE"];
    angular
        .module('redcap.consumer.components')
        .controller('ConsumerFAQController', ConsumerFAQController);

    function ConsumerFAQController(consumerService, $transition$, dealerBranding, CONSUMER_APPS_TYPE) {
        var vm = this;
        vm.dealer = dealerBranding;
        vm.tripTypeId = $transition$.params()['tripTypeId'];
        vm.tripTypeInstanceId = $transition$.params()['tripTypeInstanceId'];
        vm.appType = $transition$.params()['appType'];

        // Startup
        init();

        function init() {
            // Set default value if not defined
            vm.appType = vm.appType || CONSUMER_APPS_TYPE.serviceValet;

            consumerService.getFAQs(vm.dealer.id || vm.dealer.dealerId, vm.appType, vm.tripTypeId, vm.tripTypeInstanceId).then(
                function(result) {
                    // Success
                    if (result.value) {
                        // Set HTML binding
                        vm.faq = result.value;
                    } else {
                        // Something was missing or not returned
                        vm.hasError = true;
                    }
                },
                function(error) {
                    // Failure
                    vm.hasError = true;
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.consumer.components')
        .component('contactFooter', {
            templateUrl: 'app/areas/consumer/shared/components/contactfooter/contactfooter.view.html',
            controller: consumerContactFooterController,
            controllerAs: 'vm',
            bindings: {
                'next': '&?',
                'back': '&?',
                'nextText': '<?',
                'nextIcon': '<?',
                'backText': '<?',
                'backIcon': '<?',
                'disabled': '<?',
                'loading': '<?',
                'class': '<?'
            }
        });

    function consumerContactFooterController() {
        this.$onInit = function() {
            var vm = this;

            window.addEventListener('keyup',
                function(event) {
                    event.preventDefault();

                    if (event.key === 'Enter') {
                        if (!vm.disabled) {
                            vm.next();
                        }
                    }
                });
        };
    }
})();

(function () {
    'use strict';

    ConsumerPrivacyController.$inject = ["consumerService", "rcUtilService", "$transition$", "dealerBranding", "CONSUMER_APPS_TYPE"];
    angular
        .module('redcap.consumer.components')
        .controller('ConsumerPrivacyController', ConsumerPrivacyController);

    function ConsumerPrivacyController(consumerService, rcUtilService, $transition$, dealerBranding, CONSUMER_APPS_TYPE) {
        var vm = this;
        vm.dealer = dealerBranding;
        vm.tripTypeId = $transition$.params()['tripTypeId'];
        vm.tripTypeInstanceId = $transition$.params()['tripTypeInstanceId'];
        vm.appType = $transition$.params()['appType'];
        vm.draft = rcUtilService.isProd() ? 'published' : 'draft';
        // Startup
        init();

        function init() {
            // Set default value if not defined
            vm.appType = vm.appType || CONSUMER_APPS_TYPE.serviceValet;
            
            consumerService.getPrivacy(vm.dealer.id || vm.dealer.dealerId, vm.appType, vm.tripTypeId, vm.tripTypeInstanceId).then(
                function(result) {
                    // Success
                    vm.privacy = result.value;
                     
                },
                function(error) {
                    // Failure
                    vm.hasError = true;
                }
            );
        }
    }
})();

(function () {
    'use strict';

    consumerHeaderController.$inject = ["consumerModalService"];
    angular
        .module('redcap.consumer.components')
        .component('consumerHeader', {
            templateUrl: 'app/areas/consumer/shared/components/header/consumerheader.view.html',
            controller: consumerHeaderController,
            controllerAs: 'vm',
            bindings: {
                'name': '<?',
                'description': '<?',
                'smsNumber': '<?',
                'phoneNumber': '<?',
                'address': '<?',
                'city': '<?',
                'state': '<?',
                'zip': '<?',
                'lat': '<?',
                'lng': '<?',
                'tripTypeId': '<?',
                'tripTypeInstanceId': '<?',
                'appType': '<?',
                'dealerId': '<?',
                'image': '<?',
                'descriptionImage': '<?',
                'descriptionImageClass': '<?',
                'externalTermsPageUrl': '<?',
                'externalPrivacyPageUrl': '<?',
                'showTerms': '<?',
                'providerName': '<?'
            }
        });

    function consumerHeaderController(consumerModalService) {
        this.$onInit = function() {
            let vm = this;

           vm.showDealerDetails = function() {
                consumerModalService.showDealerDetails({
                        name: vm.name,
                        logo: vm.logoUrl,
                        mainPhoneNumber: vm.phoneNumber,
                        smsNumber: vm.smsNumber,
                        address: vm.address,
                        city: vm.city,
                        state: vm.state,
                        zip: vm.zip,
                        lat: vm.lat,
                        lng: vm.lng,
                        id: vm.dealerId,
                        externalTermsPageUrl: vm.externalTermsPageUrl || 'None',
                        externalPrivacyPageUrl: vm.externalPrivacyPageUrl || 'None',
                        showTerms: vm.showTerms,
                        providerName: vm.providerName
                    },
                    {
                        tripTypeId: vm.tripTypeId,
                        tripTypeInstanceId: vm.tripTypeInstanceId,
                        appType: vm.appType
                    });
            };
        };
    }
})();

(function () {
    'use strict';

    ConsumerCancelReasonController.$inject = ["$uibModalInstance", "resolvedReasonRequired", "resolvedTitle"];
    angular
        .module('redcap.consumer.components')
        .controller('ConsumerCancelReasonController', ConsumerCancelReasonController);

    function ConsumerCancelReasonController($uibModalInstance, resolvedReasonRequired, resolvedTitle) {
        var vm = this;

        vm.close = close;
        vm.performCancel = performCancel;
        vm.submitted = false;
        vm.title = resolvedTitle;
        vm.reasonRequired = resolvedReasonRequired;

        function performCancel(valid) {
            if (valid) {
                $uibModalInstance.close(vm.reason);
            } else {
                vm.submitted = true;
            }
        }

        function close() {
            vm.canceled = true;
            $uibModalInstance.dismiss();
        }
    }
})();

(function () {
    'use strict';

    angular.module('redcap.consumer.repairorderauthorizations', []);
})();

(function () {
    'use strict';

    ConsumerRepairOrderAuthorizationsHomeworkServicesController.$inject = ["$scope", "$state", "$transition$", "appointmentUtilService", "SYSTEM_ENUMS", "APPOINTMENT_CUSTOMERTYPE", "CONSUMER_APPS_TYPE", "resolvedDealerOpCodes", "resolvedDealerBranding", "resolvedKey", "resolvedRepairOrder", "resolvedPendingAuthorizations", "resolvedApprovedTotals", "resolvedTerms", "resolvedLocationTransportationTypes", "consumerRepairOrderAuthorizationsService", "azureBlob", "liberatedAsideService", "INSPECT_CONSTANTS", "inspectionService", "dealerInspectionService"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .controller('ConsumerRepairOrderAuthorizationsHomeworkServicesController', ConsumerRepairOrderAuthorizationsHomeworkServicesController);

    function ConsumerRepairOrderAuthorizationsHomeworkServicesController($scope, $state, $transition$, appointmentUtilService, SYSTEM_ENUMS, 
        APPOINTMENT_CUSTOMERTYPE, CONSUMER_APPS_TYPE, resolvedDealerOpCodes, 
        resolvedDealerBranding, resolvedKey, resolvedRepairOrder, resolvedPendingAuthorizations, resolvedApprovedTotals, resolvedTerms, resolvedLocationTransportationTypes,
        consumerRepairOrderAuthorizationsService, azureBlob, liberatedAsideService, INSPECT_CONSTANTS, inspectionService, dealerInspectionService) {
        let vm = this;
        let _shopTaxes = null;

        vm.repairOrder = resolvedRepairOrder;      
        vm.showConditions = false;
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.customerType = APPOINTMENT_CUSTOMERTYPE;
        vm.transportationTypes = resolvedLocationTransportationTypes;
        vm.dealer = resolvedDealerBranding;
        vm.resolvedKey = resolvedKey;
        vm.configValues = vm.dealer.configValues;
        vm.headerImageUrl = vm.configValues.headerImageUrl;    
        vm.pendingAuthorizations = null;
        vm.terms = resolvedTerms;
        vm.lineItemStatus = INSPECT_CONSTANTS.lineItemStatus;
        
        function updateYMM(origValue) {
            return consumerRepairOrderAuthorizationsService.updateYMM(origValue, vm.repairOrder);
        }

        function init() {           
            vm.mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(resolvedDealerOpCodes, vm.repairOrder);            
            vm.configValues.homeworkServicesPageTitle2 = updateYMM(vm.configValues.homeworkServicesPageTitle2);
            vm.pendingAuthorizations = consumerRepairOrderAuthorizationsService.getServicesFromAuthorizations(resolvedPendingAuthorizations, vm.mappedOpCodes, vm.repairOrder, vm.resolvedKey);            
            vm.inspectionHasStarted = vm.repairOrder.inspectionStatus !== INSPECT_CONSTANTS.inspectionStatus.notStarted;
            vm.itemizationEnabled = vm.pendingAuthorizations.some(op => op.itemizedPricingEnabled);

            dealerInspectionService.getShopTaxes(vm.dealer.dealerId).then((shopTaxes) => {
                _shopTaxes = shopTaxes.filter(tax => tax.isEnabled && tax.isFixedEnabled && tax.fixedTax?.fixedAmount != null);
                vm.recalculateFixedTaxesAndFees();
            });
        }

        function gotoNextPage() {
            vm.loading = true;
            $state.go('consumer-repairorder-authorizations-confirminfo', $transition$.params()).finally(() => {
                vm.loading = false;
            });            
        }

        function signOffAuthorization(signatureObj) {
            consumerRepairOrderAuthorizationsService.signAuthorization(vm.dealer.dealerId, vm.repairOrder.id, signatureObj, vm.resolvedKey)
                .then(() => {
                    gotoNextPage();
                });
        }
      
        init();
        
        vm.clear = function (a, b, c) {
            if (vm.dataurl) {
                $scope.clear();
            }

            vm.dataurl = '';
        };

        $scope.$watch(() => {
                return vm.dataurl;
            }, (newVal, oldVal) => {
                vm.signatureImageData = newVal;
        });

        vm.getTotalEstimate = function () {
            return appointmentUtilService.getPendingLineItemTotalEstimate(vm.pendingAuthorizations);
        };

        vm.showInspectionSummary = function() {
            liberatedAsideService.showInspectionSummary(vm.repairOrder, true, $transition$.params().key);            
        };

        vm.prevPage = function () {
            vm.loading = true;
            $state.go('consumer-repairorder-authorizations-landing', $transition$.params()).finally(() => {
                vm.loading = false;
            });
        };

        vm.nextPage = function () {
            let isBusiness = vm.repairOrder.customer.customerType === vm.customerType.business;
                let signingName = isBusiness
                    ? vm.repairOrder.customer.businessName
                    : vm.repairOrder.customer.firstName + ' ' + vm.repairOrder.customer.lastName;

            vm.loading = true;
            consumerRepairOrderAuthorizationsService.createSignatureToken(vm.dealer.dealerId, vm.repairOrder.id, signingName, vm.resolvedKey)
                .then((result) => {
                    let blobData = appointmentUtilService.dataURItoBlob(vm.signatureImageData);

                        let config = {
                            baseUrl: result.imageUrl,
                            file: blobData,
                            complete: function () {
                                // sign authorization
                                let signatureObj = {
                                    signatureDataId: result.id,
                                    signatureName: signingName,
                                    authorizedServices: vm.pendingAuthorizations,
                                    termsAgreedOn: _.map(vm.terms, (item) => { return item.id; })
                                };

                                signOffAuthorization(signatureObj);
                            },
                            error: function (err) {
                                alert("Unable to save signature at the moment, please try again.");
                                vm.loading = false;
                            },
                            blockSize: 4000000000
                        };

                    azureBlob.upload(config);
                });
        };

        vm.recalculateFixedTaxesAndFees = function() {
            const newlyApprovedServices = vm.pendingAuthorizations.filter((auth) => auth.authorizationStatus === vm.lineItemStatus.approved || auth.approved === true);
            
            vm.fixedTaxesAndFees = inspectionService.getFixedTaxesAndFees(_shopTaxes, newlyApprovedServices, vm.itemizationEnabled, resolvedApprovedTotals);
        };

        vm.getTotals = function() {
            const estimateTotal = vm.getTotalEstimate();
            const fixedFeesTotal = vm.fixedTaxesAndFees?.reduce((sum, fee) => sum + fee.amount, 0) || 0;
            const total = estimateTotal + fixedFeesTotal;
                
            return total;
        };
    }
})();

(function () {
    'use strict';

    ConsumerRepairOrderAuthorizationsHomeworkLandingController.$inject = ["$state", "$transition$", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "resolvedDealerBranding", "resolvedKey", "resolvedRepairOrder", "resolvedPendingAuthorizations", "consumerRepairOrderAuthorizationsService", "resolvedDealerOpCodes", "INSPECT_CONSTANTS"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .controller('ConsumerRepairOrderAuthorizationsHomeworkLandingController', ConsumerRepairOrderAuthorizationsHomeworkLandingController);

    function ConsumerRepairOrderAuthorizationsHomeworkLandingController($state, $transition$, SYSTEM_ENUMS, CONSUMER_APPS_TYPE,
        resolvedDealerBranding, resolvedKey, resolvedRepairOrder, resolvedPendingAuthorizations, consumerRepairOrderAuthorizationsService, resolvedDealerOpCodes, INSPECT_CONSTANTS) {
        let vm = this;
    
        vm.dealer = resolvedDealerBranding;
        vm.ro = resolvedRepairOrder;
        vm.configValues = vm.dealer.configValues;
        vm.resolvedKey = resolvedKey;
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.headerImageUrl = vm.configValues.headerImageUrl;
        vm.loading = true;
        vm.mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(resolvedDealerOpCodes, resolvedRepairOrder);
        vm.lineItemStatus = INSPECT_CONSTANTS.lineItemStatus;
        vm.pendingAuthorizations = consumerRepairOrderAuthorizationsService.getServicesFromAuthorizations(resolvedPendingAuthorizations, vm.mappedOpCodes, vm.ro, vm.resolvedKey);

        if (this.pendingAuthorizations.length === 0) {
            // they've completed everything .. just go to the completed page
            $state.go('consumer-repairorder-authorizations-confirminfo', $transition$.params()).finally(() => {
                
            });
        } else {
            vm.loading = false;
        }  
        
        function initializeTasks() {
            let rawTasks = vm.configValues.homeworkLandingPageTasks ? vm.configValues.homeworkLandingPageTasks.split('*') : null;

            vm.tasks = [];

            _.each(rawTasks, (task) => {
                vm.tasks.push({
                    text: task
                });
            });
        }

        function updateYMM(origValue) {
            return consumerRepairOrderAuthorizationsService.updateYMM(origValue, vm.appointment);
        }

        initializeTasks();

        vm.configValues.homeworkLandingPageTitle2 = updateYMM(vm.configValues.homeworkLandingPageTitle2);
        
        vm.nextPage = function () {
            vm.loading = true;
            $state.go('consumer-repairorder-authorizations-services', $transition$.params()).finally(() => {
                vm.loading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    ConsumerRepairOrderAuthorizationsHomeworkConfirmInfoController.$inject = ["$state", "$transition$", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "resolvedDealerBranding", "resolvedKey", "resolvedRepairOrder", "resolvedServiceLines", "resolvedAuthHistory", "resolvedLocationTransportationTypes", "liberatedAsideService", "consumerRepairOrderAuthorizationsService", "resolvedDealerOpCodes", "INSPECT_CONSTANTS"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .controller('ConsumerRepairOrderAuthorizationsHomeworkConfirmInfoController', ConsumerRepairOrderAuthorizationsHomeworkConfirmInfoController);


    function ConsumerRepairOrderAuthorizationsHomeworkConfirmInfoController($state, $transition$, SYSTEM_ENUMS, CONSUMER_APPS_TYPE,
        resolvedDealerBranding, resolvedKey, resolvedRepairOrder, resolvedServiceLines, resolvedAuthHistory, resolvedLocationTransportationTypes, liberatedAsideService, 
        consumerRepairOrderAuthorizationsService, resolvedDealerOpCodes, INSPECT_CONSTANTS) {
        let vm = this;

        vm.dealer = resolvedDealerBranding;
        vm.configValues = vm.dealer.configValues;
        vm.resolvedKey = resolvedKey;
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.headerImageUrl = vm.configValues.headerImageUrl;
        vm.transportationTypes = resolvedLocationTransportationTypes;
        vm.repairOrder = resolvedRepairOrder; 
        vm.authorizationHistory = resolvedAuthHistory;
        vm.key = resolvedKey;
        
        function updateYMM(origValue) {
            return consumerRepairOrderAuthorizationsService.updateYMM(origValue, vm.repairOrder);
        }

        function init() {
            vm.configValues.homeworkConfirmInfoTitle2 = updateYMM(vm.configValues.homeworkConfirmInfoTitle2);
            vm.mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(resolvedDealerOpCodes, vm.repairOrder);
            vm.previousAuthorizations = consumerRepairOrderAuthorizationsService.getServicesFromAuthorizations(resolvedServiceLines, vm.mappedOpCodes, vm.repairOrder, vm.resolvedKey);
            //consumerAppointmentService.postProcessAPIAuthorizationServices(vm.pendingAuthorizations, resolvedDealerOpCodes, vm.repairOrder);

            let authorizedServiceList = [];
            let authorized = _.filter(vm.previousAuthorizations, (o) => { 
                return o.authorizationStatus === 2; 
            });
       
            _.forEach(authorized, (service) => {
                service.approved = true;
                authorizedServiceList.push(service);
            });

            vm.authorizedServices = authorizedServiceList;
            vm.inspectionHasStarted =  vm.repairOrder.inspectionStatus !== INSPECT_CONSTANTS.inspectionStatus.notStarted;  
        }

        vm.showInspectionSummary = function() {
            liberatedAsideService.showInspectionSummary(vm.repairOrder, true, $transition$.params().key);
        };
        
        init();
        
        // TODO: If this file is still needed, these routes need to change
        vm.prevPage = function () {
            vm.loading = true;
            $state.go('consumer-appointment-homeworklanding', $transition$.params()).finally(() => {
                vm.loading = false;
            });
        };

        vm.nextPage = function () {
            vm.loading = true;
            $state.go('consumer-appointment-homeworkconfirminfo', $transition$.params()).finally(() => {
                vm.loading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    ConsumerRepairOrderAuthorizationsHomeworkAuthorizationHistoryController.$inject = ["$state", "$transition$", "CONSUMER_APPS_TYPE", "resolvedDealerBranding", "resolvedKey", "resolvedAuthorizationGroup", "resolvedRepairOrder", "consumerRepairOrderAuthorizationsService", "resolvedDealerOpCodes", "INSPECT_CONSTANTS"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .controller('ConsumerRepairOrderAuthorizationsHomeworkAuthorizationHistoryController', ConsumerRepairOrderAuthorizationsHomeworkAuthorizationHistoryController);


    function ConsumerRepairOrderAuthorizationsHomeworkAuthorizationHistoryController($state, $transition$, CONSUMER_APPS_TYPE, resolvedDealerBranding, resolvedKey, resolvedAuthorizationGroup, resolvedRepairOrder, consumerRepairOrderAuthorizationsService, resolvedDealerOpCodes, INSPECT_CONSTANTS) {
        let vm = this;

        vm.dealer = resolvedDealerBranding;

        vm.configValues = vm.dealer.configValues; 
        vm.resolvedKey = resolvedKey;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.headerImageUrl = vm.configValues.headerImageUrl;
        vm.repairOrder = resolvedRepairOrder;
        vm.authorizationGroup = resolvedAuthorizationGroup;
        vm.repairOrder = resolvedRepairOrder;
        const mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(resolvedDealerOpCodes, resolvedRepairOrder);

		vm.authorizationStatuses = INSPECT_CONSTANTS.lineItemStatus;

        function init() {
            // TODO: this is a temporary measure to be able to use the authorize-pending-lineitem component.
            //  This will be refactored as part of the auth refactor in another branch.
            const lines = resolvedAuthorizationGroup.authorizations.map((auth) => {
                auth.serviceOperations = [auth.serviceOperation];
                auth.comments = auth.serviceOperation.comments;

                return auth;
            });

            vm.authorizations = consumerRepairOrderAuthorizationsService.getServicesFromAuthorizations(lines, mappedOpCodes, vm.repairOrder, vm.resolvedKey);
        }

        vm.back = function () {
            vm.loading = true;
            $state.go('consumer-repairorder-authorizations-confirminfo', $transition$.params()).finally(() => {
                vm.loading = false;
            });
        };
        
        init();
        
        
    }
})();

(function () {
    'use strict';

    consumerRepairOrderAuthorizationsService.$inject = ["consumerApi", "rcUtilService", "$filter", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .factory('consumerRepairOrderAuthorizationsService', consumerRepairOrderAuthorizationsService);

    function consumerRepairOrderAuthorizationsService(consumerApi, rcUtilService, $filter, SYSTEM_ENUMS) {
        const CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH = 'consumer/v2/';        
        const DEFAULT_SERVICE_OPCODE_DESCRIPTION = 'Generic Maintenance';
        const LINEITEM_SOURCETYPE = SYSTEM_ENUMS.lineItemSource;

        return {
            getRepairOrder: getRepairOrder,
            getAuthorizationGroupDetail: getAuthorizationGroupDetail,
            getAuthorizationHistory: getAuthorizationHistory, 
            getRoMedia: getRoMedia, 
            getRoLineItems: getRoLineItems,
            getInspectionSections: getInspectionSections,
            updateYMM: updateYMM,
            getServicesFromAuthorizations: getServicesFromAuthorizations,
            signAuthorization: signAuthorization,
            createSignatureToken: createSignatureToken,
            getMappedOpCodes: getMappedOpCodes,
            addMediaImpression: addMediaImpression,
            buildServiceOpViewModel: buildServiceOpViewModel,
            getPendingAuthorizations: getPendingAuthorizations,
            getApprovedTotals: getApprovedTotals
        };

        function getAuthorizationGroupDetail(dealerId, repairOrderId, authorizationGroupId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/authorizationgroup/' + authorizationGroupId + '?key=' + key);
        }

        function getAuthorizationHistory(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/authorizations/?key=' + key);
        }

        function getRoLineItems(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/services?key=' + key);
        }

        function getPendingAuthorizations(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/pendingauthorizations?key=' + key);
        }

        function getApprovedTotals(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/approvedtotals?key=' + key);
        }

        function getRoMedia(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/media?key=' + key);
        }

        function createSignatureToken(dealerId, repairOrderId, fullName, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/createsignaturetoken?fullName=' + fullName + '&key=' + key);
        }

        function getInspectionSections(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/inspection/sections/?key=' + key);
        }
    
        function addMediaImpression(dealerId, repairOrderId, mediaItemId, key) {
            return consumerApi.post(`${CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH}dealer/${dealerId}/repairorder/${repairOrderId}/media/${mediaItemId}/impression?key=${key}`);
        }

        function updateYMM(origValue, repairOrder) {
            if (!repairOrder || !repairOrder.vehicle) return "";

            let vehicle = repairOrder.vehicle;
            let vin = vehicle.vin && vehicle.vin.length >= 8 ? "#" + vehicle.vin.slice(-8) : "N/A";

            if (origValue) {
                let new1 = rcUtilService.replaceAll(origValue, "[YEAR]", vehicle.year);
                    let new2 = rcUtilService.replaceAll(new1, "[MAKE]", vehicle.make);
                    let new3 = rcUtilService.replaceAll(new2, "[MODEL]", vehicle.model);
                    let new4 = rcUtilService.replaceAll(new3, "[MILES]", $filter('number')(vehicle.estimatedMileage) || '0');
                    let new5 = rcUtilService.replaceAll(new4, "[VIN8]", vin);
                    let new6 = rcUtilService.replaceAll(new5, "[MILEAGETYPE]", vehicle.isKilometer ? 'KM' : 'MI');

                return new6;
            } else {
                return "";
            }
        }

        // TODO: Remove this completely once the authorizations are refactored to use the data model coming directly from the server.
        function getServicesFromAuthorizations(serviceLines, mappedDeptOpCodes, repairOrder, consumerKey) {
            let opCodes = [];

            if (!serviceLines || !serviceLines.length) {
                return opCodes;
            }

            serviceLines.forEach((line) => {
                let operations = line.serviceOperations || [line];
                   
                operations.forEach((op) => {
                    let name = op.name;

                    if (!name || name === null || name === '') {
                        name = DEFAULT_SERVICE_OPCODE_DESCRIPTION;
                    }

                    let matchedOpCode = null;
                    
                    if (mappedDeptOpCodes?.length) {
                        matchedOpCode = mappedDeptOpCodes.find(moc => moc.opCode === op.opCode);
                    }
                    
                    opCodes.push(buildServiceOpViewModel(op, line, consumerKey, repairOrder, name, matchedOpCode));
                });
            });

            return opCodes;
        }

        // TODO: Remove this completely once the authorizations are refactored to use the data model coming directly from the server.
        function buildServiceOpViewModel(op, line, consumerKey, repairOrder, opCodeName, matchedOpCode) {
            let note = op.complaintString || op.correctionString || op.note;

            // TODO: Bridging the gap between the old data model and the new data model.  Comments in the new datamodel have ShopNotes in them,
            //  which we don't want to display.  
            if (line && (!note || !note.length)) {
                note = line.comments;
            }

            return {
                id: op.id,
                overrideName: op.overrideName || (op.sourceType === LINEITEM_SOURCETYPE.originalCustomerRequest ? op.description : null),
                opCodeDescription: op.description || op.opCodeDescription,
                consumerDescription: op.consumerDescription || op.dealerAppointmentServiceOpCode?.consumerDescription || op.authorization?.serviceOperation?.consumerDescription,
                consumerName: op.consumerName || op.dealerAppointmentServiceOpCode?.consumerName,
                dashboardName: op.dealerAppointmentServiceOpCode?.dashboardName,
                dashboardDescription: op.dealerAppointmentServiceOpCode?.dashboardDescription || line?.dashboardDescription,
                dealerAppointmentServiceOpCode: {
                    name: opCodeName || op.name
                },
                name: op.name,
                createdBy: op.createdBy ? op.createdBy : {
                    firstName: '',
                    lastName: ''
                },
                opCode: op.opCode, // so we can check if the name is actually the op code
                description: op.description || op.opCodeDescription, // in some cases we have the op code showing in name so we're going to get the description for those
                note: note,
                complaintString: op.complaintString || op.note,
                correctionString: op.correctionString,
                formattedCorrection: op.formattedCorrection,
                formattedComplaint: op.formattedComplaint,
                retailPrice: op.totalAmount || op.pricing?.totalAmount || op.dealerAppointmentServiceOpCode?.retailPrice || op.retailPrice,
                isGeneric: line?.isGeneric || matchedOpCode?.isGeneric || false,
                isRecall: line?.isRecall || matchedOpCode?.isRecall || false,
                isOther: line?.isOther || matchedOpCode?.isOther || false,
                isAutomatic: line?.isAutomatic || matchedOpCode?.isAutomatic || false,
                pricing: op.pricing,
                parts: op.parts,
                useFlatPrice: op.useFlatPrice,
                noLaborCharge: op.noLaborCharge,
                noPartsCharge: op.noPartsCharge,
                itemizedPricingEnabled: op.itemizedPricingEnabled,
                isRecommendedMaintenance: line?.isRecommendedMaintenance || matchedOpCode?.isRecommendedMaintenance || false,
                isPreviouslyDeferred: line?.isPreviouslyDeferred || matchedOpCode?.isPreviouslyDeferred || false,
                authorizationStatus: op.authorizationStatus,
                severity: op.severity,
                mediaItems: [...(op.mediaItems || []), ...(op.images || [])],
                source: op.sourceType,
                repairOrderId: repairOrder ? repairOrder.id : null,
                dealerId: repairOrder ? repairOrder.dealerId : null,
                consumerKey: consumerKey,
                authorization: op.authorization,
                authorizationId: op.authorization?.id,
                laborHours: op.laborHours,
                domId: rcUtilService.getRandomNumber(),
                getName: function(forConsumer) {
                    let serviceName = null;

                    if (forConsumer) {
                        serviceName = this.consumerName;
                    } else {
                        serviceName = this.dashboardName;
                    }
                    
                    return serviceName || this.name || this.overrideName;
                },
                getDescription(forConsumer) {
                    let serviceDescription = null;

                    if (forConsumer) {
                        serviceDescription = this.consumerDescription;
                    } else {
                        serviceDescription = this.dashboardDescription;
                    }

                    return serviceDescription || this.description || this.getName(forConsumer);
                }
            };
        }

        function signAuthorization(dealerId, repairOrderId, signatureData, key) {
            let route = CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + '/signauthorization/' + "?key=" + key;

            return consumerApi.post(route, signatureData);
        }

        function getRepairOrder(dealerId, repairOrderId, key) {
            return consumerApi.get(CONSUMER_INSPECT_AUTHORIZATIONS_BASEPATH + 'dealer/' + dealerId + '/repairorder/' + repairOrderId + "?key=" + key);
        }

        function getMappedOpCodes(allOpCodes, repairOrder) {

            let mappedOpCodes = null;
            
            if (repairOrder.dealerDepartmentId) {
                let deptOpcodes = $filter('filter')(allOpCodes.all, {dealerDepartmentId: repairOrder.dealerDepartmentId}, true);
                let automaticOpCodes =  $filter('filter')(allOpCodes.all, {isAutomatic: true}, true);

                mappedOpCodes = deptOpcodes.concat(automaticOpCodes);
            } else {
                mappedOpCodes = allOpCodes.all;
            }

            return mappedOpCodes;

        }
        
    }
})();

(function () {
    'use strict';

    controller.$inject = ["modalService", "appointmentService", "consumerAppointmentService", "consumerRepairOrderAuthorizationsService", "roService", "appointmentUtilService", "rcUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .component('repairOrderVehicleDetailsIssues', {
            templateUrl: 'app/areas/consumer/repairorders/authorizations/components/vehicle-details-issues.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                repairOrder: '<',
                consumerKey: '<'
            }
        });

    function controller(modalService, appointmentService, consumerAppointmentService, consumerRepairOrderAuthorizationsService, roService, appointmentUtilService, rcUtilService, SYSTEM_ENUMS) {
        this.$onInit = function() {
            let vm = this;

            vm.loadingImages = true;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.showConditions = false;
            vm.showPredefinedMediaItems = false;

            vm.getMediaType = function (fileExtension) {
                if (!fileExtension) return SYSTEM_ENUMS.mediaTypes.photo;

                return appointmentUtilService.getMediaType(fileExtension);
            };

            vm.getOdometerAbbreviation = rcUtilService.getOdometerAbbreviation;

            vm.openImageModal = function (url, description, mediaType) {
                modalService.showImageViewer(url, description, mediaType);
            };
            
            function groupBy(xs, key) {
                return xs.reduce((rv, x) => {
                    (rv[x[key]] = rv[x[key]] || []).push(x);

                    return rv;
                }, {});
            }

            function getPredefinedMediaItems() {              
                const mediaPromise = vm.consumerKey ? consumerRepairOrderAuthorizationsService.getRoMedia(vm.repairOrder.dealerId, vm.repairOrder.id, vm.consumerKey) :
                                                       roService.getRoMedia(vm.repairOrder.dealerId, vm.repairOrder.id);

                mediaPromise.then((media) => {
                    let predefinedMedias = media.filter((item) => {
                        return item.heading && item.heading.toLowerCase() !== 'damage and issues' && item.heading.toLowerCase() !== 'vehicle overview' && item.azureImageId !== null && item.fileExtension !== null;
                    }).map((mediaItem) => {
                        return {
                            id: mediaItem.id,
                            heading: mediaItem.heading,
                            url: mediaItem.mediaUrl,
                            description: mediaItem.description,
                            type: mediaItem.mediaType === 2 ? vm.mediaTypes.video : vm.mediaTypes.photo,
                            dateTaken: mediaItem.createdDate
                        };
                    });
    
                    vm.totalpredefinedImages = predefinedMedias.length;
                    vm.predefinedImageGroup = groupBy(predefinedMedias, 'heading');
    
                    vm.predefinedImages = Object.keys(vm.predefinedImageGroup).map((key) => {
                        return {
                            heading: key,
                            mediaItems: vm.predefinedImageGroup[key]
                        };
                    }); 
                });
            }

            function getVehicleConditions() {
                if (vm.repairOrder.dealerAppointmentId) {
                    const conditionsPromise = vm.consumerKey ? consumerAppointmentService.getVehicleConditionImages(vm.repairOrder.dealerId, vm.repairOrder.dealerAppointmentId, vm.consumerKey) :
                                                               appointmentService.getVehicleConditionImages(vm.repairOrder.dealerId, vm.repairOrder.dealerAppointmentId);

                    conditionsPromise.then((issues) => {
                        vm.vehicleConditions = appointmentUtilService.processVehicleConditions(issues, true);
                    });
                } else {
                    vm.vehicleConditions = [];
                }
            }

            function init() {
                getVehicleConditions();
                getPredefinedMediaItems();
            }

            init();
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$state", "INSPECT_CONSTANTS", "roService"];
    angular
        .module('redcap.consumer.repairorderauthorizations')
        .component('consumerRepairOrderAuthorizationHistorySummary', {
            templateUrl: 'app/areas/consumer/repairorders/authorizations/components/authorization-history-summary.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'repairOrderId': '<',
                'isDashboard': '=',
                'key': '<'
            }
        });

    function controller($state, INSPECT_CONSTANTS, roService) {
        this.$onInit = function() {
            let vm = this;
            
            vm.authorizations = (vm.ngModel || []).filter(item => !roService.isOpenOrPendingAuthGroup(item, INSPECT_CONSTANTS));
            vm.authorizationStatuses = INSPECT_CONSTANTS.lineItemStatus;

            vm.gotoAuthHistory = function (index, authorizationGroup) {
                $state.go('consumer-repairorder-authorizations-authhistory',
                    {
                        repairOrderId: vm.repairOrderId,
                        authorizationGroupId: authorizationGroup.id,
                        key: vm.key
                    });
                
            };
        };
    }

    
})();

(function () {
    'use strict';

    angular.module('redcap.consumer.payments', []);
})();

(function () {
    'use strict';
    angular
        .module('redcap.consumer.payments')
        .controller('periVerifyController', periVerifyController);

    function periVerifyController() {
        window.parent.angular.element('#smsIFrame').scope().$emit('peri-validate-transaction');
    }
})();

(function () {
    'use strict';
    periPaymentController.$inject = ["$sce", "$scope", "$stateParams", "$state", "periPaymentsService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.payments')
        .component('periPayment', {
            templateUrl: 'app/areas/consumer/payments/views/partials/peri-payment.view.html',
            controller: periPaymentController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'params': '<'
            }
        });

    function periPaymentController($sce, $scope, $stateParams, $state, periPaymentsService, SYSTEM_ENUMS) {
        this.$onInit = function() {
            var vm = this;
            var host = `${location.protocol}//${location.host}`;
            var path = $state.href('payment-peri-processed');
            var redirectUrl = `${host}${path}`;
            periPaymentsService.createTransaction(vm.params.invoice.dealerId, vm.params.invoiceGuid, redirectUrl).then(
                function(response) {
                    vm.transactionData = response;
                    vm.url = $sce.trustAsResourceUrl(response.url);

                });
            vm.initialLoading = true;
            vm.iFrameOnload = function() {
                if (vm.initialLoading) {
                    vm.initialLoading = false;
                }
            }
            $scope.$on('peri-validate-transaction',
                function() {
                    vm.processedComplete = true;
                    vm.saving = true;
                    vm.next();
                });
            vm.next = function() {
                periPaymentsService
                    .verifyPayment(vm.params.invoice.dealerId, vm.params.invoiceGuid, vm.transactionData.transactionId)
                    .then(
                        function(result) {
                            if (result.success) {
                                //vm.invoice.status = SYSTEM_ENUMS.invoiceStatus.paid;
                                $state.go('payment-success', { result: result }, { reload: true });
                            }
                        })
                    .finally(function() {
                        vm.saving = false;
                    });

            };
            vm.back = function() {
                $state.go('payment-review-charges', $stateParams);
            };
        }
    }
})();

(function () {
    'use strict';

    cenposPaymentController.$inject = ["$window", "$scope", "$stateParams", "$state", "$timeout", "PAYMENT_PROVIDER_ENVIRONMENT", "CENPOS_SETTINGS"];
    angular
        .module('redcap.consumer.payments')
        .component('cenposPayment', {
            templateUrl: 'app/areas/consumer/payments/views/partials/cenpos-payment.view.html',
            controller: cenposPaymentController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'params': '<'
            }
        });

    function cenposPaymentController($window, $scope, $stateParams, $state, $timeout, PAYMENT_PROVIDER_ENVIRONMENT, CENPOS_SETTINGS) {
        this.$onInit = function() {
            let vm = this;

            vm.data = this.ngModel;
            vm.params = this.params;
            vm.paymentName = 'payment-provider' + new Date().getTime();

            // Update if existing cc
            if (vm.params.paymentInfo != null) {
                vm.selectedToken =
                    vm.params.paymentInfo.selectedToken == null ? '0' : vm.params.paymentInfo.selectedToken;
                vm.billing = vm.params.paymentInfo.billingAddress == null ? {} : vm.params.paymentInfo.billingAddress;
                vm.data.cardsOnFile =
                    vm.params.paymentInfo.cardsOnFile == null ? [] : vm.params.paymentInfo.cardsOnFile;
            } else {
                vm.billing = {};
            }

            vm.cardSelected = function() {
                vm.hideCards = true;

                if (vm.selectedToken === '0') {
                    vm.loadPaymentWindow();
                }
            };

            vm.showOtherCards = function() {
                vm.hideCards = false;
                vm.selectedToken = null;
            };

            vm.successCallback = function(result) {
                vm.data.cardsOnFile.push({
                    tokenId: result.RecurringSaleTokenId,
                    cardType: result.CardType,
                    cardNumber: result.ProtectedCardNumber.substr(result.ProtectedCardNumber.length - 4),
                    cardExpirationDate: result.CardExpirationDate.substr(0, 2) +
                        '/' +
                        result.CardExpirationDate.substr(2, 2)
                });

                vm.selectedToken = result.RecurringSaleTokenId;
                $scope.$apply();
            };

            vm.cancelCallback = function(result) {
                if (result && result.Message) {
                    vm.cardError = result.Message;
                    $scope.$apply();
                    $window.scrollTo(0, 0);
                }
            };

            vm.loadPaymentWindow = function() {
                if (!vm.paymentContainer) {
                    let paymentContainer = $('#' + vm.paymentName);

                    if (!paymentContainer || !paymentContainer.length || !paymentContainer.createWebpay) {
                        return $timeout(vm.loadPaymentWindow, 100);
                    }

                    vm.paymentContainer = paymentContainer;
                    vm.showCC = true;
                    
                    let webPayUrl = vm.data.invoice.providerEnvironment === PAYMENT_PROVIDER_ENVIRONMENT.Production
                        ? CENPOS_SETTINGS.simpleWebPayUrl
                        : CENPOS_SETTINGS.simpleWebPayDevUrl;

                    vm.paymentContainer.createWebpay({
                        url: webPayUrl,
                        height: 475,
                        sessionToken: true,
                        params: 'isCvv=true' +
                            '&verifyingpost=' +
                            vm.data.initializationToken.data,
                        success: vm.successCallback,
                        cancel: vm.cancelCallback
                    });
                }
            };

            vm.addCard = function() {
                vm.cardError = null;
                vm.paymentContainer.submitAction();
            };

            if (!vm.data.cardsOnFile.length) {
                vm.selectedToken = '0';
                vm.loadPaymentWindow();
            }

            vm.next = function() {
                if (vm.selectedToken === '0') {
                    vm.addCard();
                } else {
                    if (vm.data.invoice.isPodCheckout) {
                        $state.go('payment-delivery-options',
                            {
                                paymentInfo: {
                                    selectedToken: vm.selectedToken,
                                    billingAddress: vm.billing,
                                    emailAddress: $stateParams.paymentInfo.emailAddress,
                                    cardsOnFile: vm.data.cardsOnFile
                                }
                            },
                            {reload: true});
                    } else {
                        $state.go('payment-confirmation',
                            {
                                bookingInfo: {},
                                paymentInfo: {
                                    selectedToken: vm.selectedToken,
                                    billingAddress: vm.billing,
                                    emailAddress: $stateParams.paymentInfo.emailAddress,
                                    cardsOnFile: vm.data.cardsOnFile
                                }
                            },
                            {reload: true});
                    }
                }
            };

            vm.back = function() {
                if (vm.hideCards) {
                    vm.showOtherCards();
                } else {
                    $state.go('payment-review-charges', $stateParams);
                }
            };
        };
    }
})();

(function () {
    'use strict';

    cardconnectPaymentController.$inject = ["CARDCONNECT_SETTINGS", "$sce", "$scope", "$stateParams", "$state"];
    angular
        .module('redcap.consumer.payments')
        .component('cardconnectPayment', {
            templateUrl: 'app/areas/consumer/payments/views/partials/cardconnect-payment.view.html',
            controller: cardconnectPaymentController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'params': '<'
            }
        });

    function cardconnectPaymentController(CARDCONNECT_SETTINGS, $sce, $scope, $stateParams, $state) {
        this.$onInit = function() {
            var vm = this;
            vm.data = this.ngModel;
            vm.params = this.params;
            vm.tempToken = null;

            // Update if existing cc
            if (vm.params.paymentInfo != null) {
                vm.selectedToken =
                    vm.params.paymentInfo.selectedToken == null ? '0' : vm.params.paymentInfo.selectedToken;
                vm.billing = vm.params.paymentInfo.billingAddress == null ? {} : vm.params.paymentInfo.billingAddress;
                vm.data.cardsOnFile =
                    vm.params.paymentInfo.cardsOnFile == null ? [] : vm.params.paymentInfo.cardsOnFile;
            } else {
                vm.billing = {};
            }

            var css =
                'body{font-family:"open sans","Helvetica Neue",Helvetica,Arial,sans-serif;line-height:1.42857;color:#626262;margin:0}' +
                    'label+br{display: none}' +
                    'label{width:30%;min-width:100px;font-size:13px;font-weight:bold;white-space:pre-wrap;}' +
                    'label,input,select{display:inline-block;margin-bottom:10px;}' +
                    'input{font-size:16px;padding:6px 12px;}' +
                    'select{font-size:16px;padding:6px 12px;}' +
                    '#ccnumfield{width:55%}' +
                    '#ccexpirymonth{margin-right:-4px}';

            vm.formUrl = $sce.trustAsResourceUrl(CARDCONNECT_SETTINGS.url +
                "?useexpiry=true&usecvv=true&invalidinputevent=true&unique=true&formatinput=true&enhancedresponse=true&css=" +
                encodeURIComponent(css));

            if (!vm.data.cardsOnFile.length) {
                vm.selectedToken = '0';
            }

            vm.cardSelected = function() {
                vm.enableNext = vm.selectedToken && vm.selectedToken !== '0';
            };

            window.addEventListener('message',
                function(resp) {
                    $scope.$apply(function() {
                        vm.ccError = null;
                        var data = JSON.parse(resp.data);
                        vm.ccError = data.validationError;
                        if (!data.message) vm.enableNext = false;

                        if (!vm.ccError && data.message) {
                            var tempExpiryMonth = data.expiry.substring(4),
                                tempExpiryYear = data.expiry.substring(0, 4);
                            vm.tempExpiry = _.padStart(tempExpiryMonth, 2, '0') + '/' + tempExpiryYear.substring(2);
                            vm.tempToken = data.message || '0';
                            vm.enableNext = true;
                            vm.isNewCard = true;
                        }
                    });
                });

            vm.next = function() {
                if (!vm.selectedToken || vm.selectedToken === '0') {
                    vm.selectedToken = vm.tempToken;
                    vm.data.cardsOnFile.push({
                        tokenId: vm.selectedToken,
                        cardType: 'New Card',
                        cardNumber: vm.selectedToken.substr(vm.selectedToken.length - 4),
                        cardExpirationDate: vm.tempExpiry
                    });
                } else {
                    if (vm.data.invoice.isPodCheckout) {
                        $state.go('payment-delivery-options',
                            {
                                paymentInfo: {
                                    selectedToken: vm.selectedToken,
                                    billingAddress: vm.billing,
                                    emailAddress: $stateParams.paymentInfo.emailAddress,
                                    cardsOnFile: vm.data.cardsOnFile
                                }
                            },
                            { reload: true });
                    } else {
                        $state.go('payment-confirmation',
                            {
                                bookingInfo: {},
                                paymentInfo: {
                                    selectedToken: vm.selectedToken,
                                    billingAddress: vm.billing,
                                    emailAddress: $stateParams.paymentInfo.emailAddress,
                                    cardsOnFile: vm.data.cardsOnFile
                                }
                            },
                            { reload: true });
                    }
                }
            };

            vm.back = function() {
                if (vm.selectedToken && vm.selectedToken !== '0') {
                    vm.selectedToken = '0';
                    vm.enableNext = false;
                    vm.isNewCard = false;
                } else {
                    $state.go('payment-review-charges', $stateParams);
                }
            };
        }
    }
})();

(function () {
    'use strict';

    consumerSecure3dController.$inject = ["$scope", "$sce", "$transition$", "htmlToShow", "$uibModalInstance", "consumerPaymentService"];
    angular
        .module('redcap.consumer.payments')
        .controller('ConsumerSecure3dController', consumerSecure3dController);

    function consumerSecure3dController($scope, $sce, $transition$, htmlToShow, $uibModalInstance, consumerPaymentService) {
        var vm = this;
        vm.html = $sce.trustAsHtml(htmlToShow);

        vm.handle3DSecure = function (result) {
            var jsonResult = JSON.parse(result);
            jsonResult.AuthorizationNumber = jsonResult.AuthorizationNumber || jsonResult.AutorizationNumber;
            consumerPaymentService.validateTransaction($transition$.params()['invoiceGuid'], jsonResult).then(function (result) {
                if (result && result.success) {
                    $uibModalInstance.close(result);
                }
                else {
                    vm.html = "Error: " + result.message;
                }
            }).catch(function (err) {
                vm.html = "Error: " + err.data.message;
            });
        };

        vm.close = $uibModalInstance.close;

        window['handle3DSecure'] = vm.handle3DSecure;

        $scope.$on('destroy', function () {
            window['handle3DSecure'] = null;
        });
    }
})();

(function () {
    'use strict';

    angular.module('redcap.consumer.loaner', []);
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$scope", "$state", "consumerLoanerService"];
    angular
        .module('redcap.consumer.loaner')
        .component('tsdnewReview', {
            templateUrl: 'app/areas/consumer/loaner/components/tsdnew-review-component/tsdnew-review.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'form': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $scope, $state, consumerLoanerService) {
        this.$onInit = function() {
            var vm = this;
            vm.mileage = this.ngModel.mileage;
            vm.fuel = this.ngModel.fuel;
            vm.issues = this.ngModel.issues;
            vm.vin = this.ngModel.vin;
            vm.year = this.ngModel.year;
            vm.make = this.ngModel.make;
            vm.model = this.ngModel.model;
            vm.routeParams = this.ngModel.routeParams;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.fieldsDisabled = this.ngModel.fieldsDisabled;
            vm.contractLink = this.ngModel.contractLink;
            vm.inputForm = this.form;
            vm.terms = this.ngModel.terms;

            vm.sliderOptions = {
                hidePointerLabels: true,
                hideLimitLabels: true,
                enforceStep: false,
                step: 1,
                floor: 0,
                ceil: 100,
                disabled: true,
                showSelectionBar: true,
                ticksArray: [
                    { value: 0, legend: 'E' },
                    { value: 12.5, legend: '1/8' },
                    { value: 25, legend: '1/4' },
                    { value: 37.5, legend: '3/8' },
                    { value: 50, legend: '1/2' },
                    { value: 62.5, legend: '5/8' },
                    { value: 75, legend: '3/4' },
                    { value: 87.5, legend: '7/8' },
                    { value: 100, legend: 'F' }
                ]
            };

            vm.nextPage = function() {
                vm.saving = true;
                vm.error = null;
                var agreedTerms = vm.terms.filter(function(item) {
                    return item.accepted;
                }).map(function(item) {
                    return item.id;
                });
                consumerLoanerService
                    .signContract($state.params.dealerId, $state.params.userGuid, vm.dataurl, agreedTerms)
                    .then(function() {
                        $state.go('loaner-signature-complete',
                                {
                                    issues: vm.issues,
                                    signatureImageUrl: vm.dataurl,
                                    terms: vm.terms
                                })
                            .then(function() {
                                vm.saving = false;
                            }).catch(function(err) {
                                vm.saving = false;
                                vm.error = err.data && err.data.message || err.message;
                            });
                    }).catch(function(err) {
                        $state.go('loaner-error',
                            {
                                error: err.data && err.data.message || err.message,
                                title: 'Oops. Your loaner agreement is incomplete!'
                            });
                    });

            };

            vm.clear = function() {
                if (vm.dataurl) {
                    $scope.clear();
                }

                vm.dataurl = '';
            };
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$scope", "$state", "consumerLoanerService", "signalRService", "$timeout", "$window"];
    angular
        .module('redcap.consumer.loaner')
        .component('tsdReview', {
            templateUrl: 'app/areas/consumer/loaner/components/tsd-review-component/tsd-review.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'form': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $scope, $state, consumerLoanerService, signalRService, $timeout, $window) {
        var vm = this;
        this.$onInit = function () {
            
            vm.mileage = this.ngModel.mileage;
            vm.fuel = this.ngModel.fuel;
            vm.issues = this.ngModel.issues;
            vm.vin = this.ngModel.vin;
            vm.year = this.ngModel.year;
            vm.make = this.ngModel.make;
            vm.model = this.ngModel.model;
            vm.routeParams = this.ngModel.routeParams;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.fieldsDisabled = this.ngModel.fieldsDisabled;
            vm.contractLink = this.ngModel.contractLink;
            vm.inputForm = this.form;
            vm.terms = this.ngModel.terms;
            vm.loanerListener = signalRService.registerConsumerLoanerListener(vm.ngModel.resolvedUser.referenceNumber);
            vm.loanerListener.on(signalRService.events.loaner.broadcastTsdMessageReceived,
                function(message) {
                    if (message.isSigned) {
                        completeSignContract();
                    }
                }).start();
            vm.contractStarted = false;

            vm.sliderOptions = {
                hidePointerLabels: true,
                hideLimitLabels: true,
                enforceStep: false,
                step: 1,
                floor: 0,
                ceil: 100,
                disabled: true,
                showSelectionBar: true,
                ticksArray: [
                    { value: 0, legend: 'E' },
                    { value: 12.5, legend: '1/8' },
                    { value: 25, legend: '1/4' },
                    { value: 37.5, legend: '3/8' },
                    { value: 50, legend: '1/2' },
                    { value: 62.5, legend: '5/8' },
                    { value: 75, legend: '3/4' },
                    { value: 87.5, legend: '7/8' },
                    { value: 100, legend: 'F' }
                ]
            };

            vm.signContract = function() {
                vm.contractStarted = true;
                $window.open(vm.contractLink, '_signContract');
            };

            

            vm.clear = function() {
                if (vm.dataurl) {
                    $scope.clear();
                }

                vm.dataurl = '';
            };


            function completeSignContract() {
                vm.saving = true;
                vm.error = null;
                var agreedTerms = vm.terms.filter(function(item) {
                    return item.accepted;
                }).map(function(item) {
                    return item.id;
                });
                consumerLoanerService
                    .signContract($state.params.dealerId, $state.params.userGuid, vm.dataurl, agreedTerms)
                    .then(function() {
                        $state.go('loaner-signature-complete',
                                {
                                    issues: vm.issues,
                                    signatureImageUrl: vm.dataurl,
                                    terms: vm.terms
                                })
                            .then(function() {
                                vm.saving = false;
                            }).catch(function(err) {
                                vm.saving = false;
                                vm.error = err.data && err.data.message || err.message;
                            });
                    }).catch(function(err) {
                        $state.go('loaner-error',
                            {
                                error: err.data && err.data.message || err.message,
                                title: 'Oops. Your loaner agreement is incomplete!'
                            });
                    });
            }
        }
        vm.$onDestroy = function () {
            if (vm.loanerListener) {
                vm.loanerListener.disconnect();
                vm.loanerListener = null;
            }
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$scope", "$rootScope", "$sce", "consumerLoanerService"];
    angular
        .module('redcap.consumer.loaner')
        .component('consumerDamageIssues', {
            templateUrl: 'app/areas/consumer/loaner/components/damage-issues/damage-issues.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'routeParams': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $scope, $rootScope, $sce, consumerLoanerService) {
        this.$onInit = function() {
            var vm = this;

            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$scope", "$state", "consumerLoanerService"];
    angular
        .module('redcap.consumer.loaner')
        .component('dealerwareReview', {
            templateUrl: 'app/areas/consumer/loaner/components/dealerware-review-component/dealerware-review.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'form': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $scope, $state, consumerLoanerService) {
        this.$onInit = function() {
            var vm = this;
            vm.mileage = this.ngModel.mileage;
            vm.fuel = this.ngModel.fuel;
            vm.issues = this.ngModel.issues;
            vm.vin = this.ngModel.vin;
            vm.year = this.ngModel.year;
            vm.make = this.ngModel.make;
            vm.model = this.ngModel.model;
            vm.routeParams = this.ngModel.routeParams;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.fieldsDisabled = this.ngModel.fieldsDisabled;
            vm.contractLink = this.ngModel.contractLink;
            vm.inputForm = this.form;
            vm.terms = this.ngModel.terms;

            vm.sliderOptions = {
                hidePointerLabels: true,
                hideLimitLabels: true,
                enforceStep: false,
                step: 1,
                floor: 0,
                ceil: 100,
                disabled: true,
                showSelectionBar: true,
                ticksArray: [
                    { value: 0, legend: 'E' },
                    { value: 12.5, legend: '1/8' },
                    { value: 25, legend: '1/4' },
                    { value: 37.5, legend: '3/8' },
                    { value: 50, legend: '1/2' },
                    { value: 62.5, legend: '5/8' },
                    { value: 75, legend: '3/4' },
                    { value: 87.5, legend: '7/8' },
                    { value: 100, legend: 'F' }
                ]
            };

            vm.nextPage = function() {
                vm.saving = true;
                vm.error = null;
                var agreedTerms = vm.terms.filter(function(item) {
                    return item.accepted;
                }).map(function(item) {
                    return item.id;
                });
                consumerLoanerService
                    .signContract($state.params.dealerId, $state.params.userGuid, vm.dataurl, agreedTerms)
                    .then(function() {
                        $state.go('loaner-signature-complete',
                                {
                                    issues: vm.issues,
                                    signatureImageUrl: vm.dataurl,
                                    terms: vm.terms
                                })
                            .then(function() {
                                vm.saving = false;
                            }).catch(function(err) {
                                vm.saving = false;
                                vm.error = err.data && err.data.message || err.message;
                            });
                    }).catch(function(err) {
                        $state.go('loaner-error',
                            {
                                error: err.data && err.data.message || err.message,
                                title: 'Oops. Your loaner agreement is incomplete!'
                            });
                    });

            };

            vm.clear = function() {
                if (vm.dataurl) {
                    $scope.clear();
                }

                vm.dataurl = '';
            };
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$scope", "$state", "consumerLoanerService"];
    angular
        .module('redcap.consumer.loaner')
        .component('arsReview', {
            templateUrl: 'app/areas/consumer/loaner/components/ars-review-component/ars-review.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'form': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $scope, $state, consumerLoanerService) {
        this.$onInit = function() {
            var vm = this;
            vm.mileage = this.ngModel.mileage;
            vm.fuel = this.ngModel.fuel;
            vm.issues = this.ngModel.issues;
            vm.vin = this.ngModel.vin;
            vm.year = this.ngModel.year;
            vm.make = this.ngModel.make;
            vm.model = this.ngModel.model;
            vm.routeParams = this.ngModel.routeParams;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.fieldsDisabled = this.ngModel.fieldsDisabled;
            vm.contractLink = this.ngModel.contractLink;
            vm.inputForm = this.form;
            vm.terms = this.ngModel.terms;

            vm.sliderOptions = {
                hidePointerLabels: true,
                hideLimitLabels: true,
                enforceStep: false,
                step: 1,
                floor: 0,
                ceil: 100,
                disabled: true,
                showSelectionBar: true,
                ticksArray: [
                    { value: 0, legend: 'E' },
                    { value: 12.5, legend: '1/8' },
                    { value: 25, legend: '1/4' },
                    { value: 37.5, legend: '3/8' },
                    { value: 50, legend: '1/2' },
                    { value: 62.5, legend: '5/8' },
                    { value: 75, legend: '3/4' },
                    { value: 87.5, legend: '7/8' },
                    { value: 100, legend: 'F' }
                ]
            };

            vm.nextPage = function() {
                vm.saving = true;
                vm.error = null;
                var agreedTerms = vm.terms.filter(function(item) {
                    return item.accepted;
                }).map(function(item) {
                    return item.id;
                });
                consumerLoanerService
                    .signContract($state.params.dealerId, $state.params.userGuid, vm.dataurl, agreedTerms)
                    .then(function() {
                        $state.go('loaner-signature-complete',
                                {
                                    issues: vm.issues,
                                    signatureImageUrl: vm.dataurl,
                                    terms: vm.terms
                                })
                            .then(function() {
                                vm.saving = false;
                            }).catch(function(err) {
                                vm.saving = false;
                                vm.error = err.data && err.data.message || err.message;
                            });
                    }).catch(function(err) {
                        $state.go('loaner-error',
                            {
                                error: err.data && err.data.message || err.message,
                                title: 'Oops. Your loaner agreement is incomplete!'
                            });
                    });

            };

            vm.clear = function() {
                if (vm.dataurl) {
                    $scope.clear();
                }

                vm.dataurl = '';
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('redcap.consumer.ownercare', []);
})();

(function () {
    'use strict';

    mediaWindowController.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.consumer.ownercare')
        .component('mediaWindow', {
            templateUrl: 'app/areas/consumer/ownercare/components/media-window/view.html',
            controller: mediaWindowController,
            controllerAs: 'vm',
            bindings: {
                'items': '<'
            }
        });

    function mediaWindowController(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
            vm.items = vm.items || [];
            vm.selectedIndex = 0;
            vm.types = SYSTEM_ENUMS.ownerCareRecommendationTypes;

            vm.getUrl = function(item) {
                return $sce.trustAsResourceUrl(item.url);
            };
        }
    }


})();

(function () {
    'use strict';

    summaryCardController.$inject = ["SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.ownercare')
        .component('summaryCard', {
            templateUrl: 'app/areas/consumer/ownercare/components/summary-card/view.html',
            controller: summaryCardController,
            controllerAs: 'vm',
            bindings: {
                'titleText': '<',
                'items': '<',
                'subText': '<',
                'collapsable': '<?',
                'collapsed': '<?',
                'cardType': '<?'
            }
        });

    function summaryCardController(SYSTEM_ENUMS) {
        this.$onInit = function() {
            var vm = this;
            vm.statuses = SYSTEM_ENUMS.ownerCareItemStatus;
            this.items = this.items || [];

            vm.formatText = function(text) {
                if (!text) return '';
                if (vm.items.length === 1) {
                    return text.replace('(s)', '');
                } else {
                    return text.replace('(s)', 's');
                }
            };
            this.title = vm.formatText(this.titleText);
            this.subText = vm.formatText(this.subText);

            vm.getDescription = function(item) {
                return (item.name || item.description) + (item.isOriginalConcern ? ' (Orig Concern)' : '');
            };
        }
    }
})();

(function () {
    'use strict';

    serviceCardController.$inject = ["SYSTEM_ENUMS", "$timeout"];
    angular
        .module('redcap.consumer.ownercare')
        .component('serviceCard', {
            templateUrl: 'app/areas/consumer/ownercare/components/service-card/view.html',
            controller: serviceCardController,
            controllerAs: 'vm',
            bindings: {
                'item': '<'
            }
        });

    var servicesScrollTop = 0;

    function serviceCardController(SYSTEM_ENUMS, $timeout) {
        this.$onInit = function() {
            var vm = this;
            this.item = this.item || {};

            vm.types = SYSTEM_ENUMS.ownerCareRecommendationTypes;
            vm.status = SYSTEM_ENUMS.ownerCareItemStatus;


            $timeout(function() { $(window).scrollTop(servicesScrollTop); }, 1);

            vm.setScrollPosition = function() {
                servicesScrollTop = $(window).scrollTop();
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('redcap.inspect', []);
})();



(function () {
    'use strict';

    CheckInAuthorizeServicesController.$inject = ["$scope", "appointmentUtilService", "modalService", "locationService", "authorizationService", "roService", "consumerRepairOrderAuthorizationsService", "INSPECT_CONSTANTS", "APPOINTMENT_APPOINTMENTSTATUS", "azureBlob", "dealerInspectionService", "inspectionService"];
    angular
        .module('redcap.inspect')
        .component('authorizeServices', {
            templateUrl: 'app/shared/components/authorizations/authorize-services/authorize-services.view.html',
            controller: CheckInAuthorizeServicesController,
            controllerAs: 'vm',
            bindings: {
                appointment: '=',
                isLoading: '=',
                showCheckinSummary: '<',
                registerStepFn: '&',
                repairOrder: '<',
                selectedServiceIds: '<'
            }
        });

    function CheckInAuthorizeServicesController($scope, appointmentUtilService, modalService, locationService, authorizationService, roService, consumerRepairOrderAuthorizationsService, INSPECT_CONSTANTS, APPOINTMENT_APPOINTMENTSTATUS, azureBlob, dealerInspectionService, inspectionService) {
        this.$onInit = function() {
            let vm = this;
            let mappedOpCodes = [];
            const dealerId = vm.repairOrder?.dealerId || vm.appointment?.dealerId;
            const roId = vm.repairOrder?.id || vm.appointment?.repairOrderId;

            vm.appointmentStatuses = APPOINTMENT_APPOINTMENTSTATUS;
            vm.lineItemStatuses = INSPECT_CONSTANTS.lineItemStatus;

            vm.getTotalEstimate = function() {
                return appointmentUtilService.getPendingLineItemTotalEstimate(vm.servicesToAuthorize);
            };

            vm.verbalAuthorizationClicked = function() {
                if (vm.isVerbalAuthorization) {
                    modalService.showYesNo('Warning', 'By checking this box you affirm the customer has provided verbal authorization for these services.', null, 'OK');   
                }
            };

            function openServicesFilter (service) {
                return (service.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.open || service.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.pendingReApproval || vm.selectedServiceIds?.includes(service.id)) && !service.isAutomatic;
            }

            function processStep() {
                return new Promise((resolve, reject) => {
                    if (vm.isVerbalAuthorization) {
                        let signatureObj = {
                            signatureDataId: null,
                            signatureName: null,
                            isVerbalSignOff: true
                        };
        
                        signOffAuthorization(signatureObj);
                    } else {
                        const signingName = `${vm.repairOrder.customer.firstName} ${vm.repairOrder.customer.lastName}`;
        
                        roService.createSignature(dealerId, roId, signingName).then((result) => {
                            if (vm.signatureImageData) {
                                const blobData = appointmentUtilService.dataURItoBlob(vm.signatureImageData);
                                const config = {
                                    baseUrl: result.imageUrl,
                                    file: blobData,
                                    complete: function () {
                                        const signatureObj = {
                                            signatureDataId: result.id,
                                            signatureName: signingName
                                        };
        
                                        signOffAuthorization(signatureObj);
                                    },
                                    error: function (err) {
                                        console.error("Unable to save signature at the moment, please try again.");
                                    },
                                    blockSize: 4000000000
                                };
        
                                azureBlob.upload(config);
                            } else {
                                console.error("Signature data is missing.");
                            }
                        }).catch((err) => reject(err));
                    }

                    function signOffAuthorization(signatureObj) {
                        signatureObj.authorizedServices = vm.servicesToAuthorize;
                        signatureObj.termsAgreedOn = vm.terms.map((term) => term.id);
                        signatureObj.pendingRideDetail = vm.appointment?.pendingRideDetails ? JSON.parse(vm.appointment.pendingRideDetails).pendingRideDetail : null;

                        roService.signAuthorization(dealerId, roId, signatureObj, null).then(async (response) => {
                            vm.services = consumerRepairOrderAuthorizationsService.getServicesFromAuthorizations(response.updatedServices, mappedOpCodes);
                            
                            if (signatureObj.pendingRideDetail?.pendingBookLaterPhone) {
                                await authorizationService.sendBookLaterSms(vm.appointment, signatureObj.pendingRideDetail.pendingBookLaterPhone);
                            }

                            if (response.transportationError) {
                                await modalService.showYesNo('Error processing transportation option', 
                                                             `An error occurred while trying to send a credit or book a ride: ${response.transportationError}`, null, 'OK', false);
                            }

                            vm.showCheckinSummary = true;

                            resolve(true);
                        }).catch((err) => reject(err));
                    }
                });
            }

            function init() {
                vm.registerStepFn()(processStep);

                vm.isLoading = true;

                const promises = [];

                if (!vm.repairOrder) {
                    if (!vm.appointment) {
                        throw new Error('An appointment must be provided if an repair order is not.');
                    }

                    const repairOrderPromise = roService.getRo(dealerId, roId).then((ro) => {
                        vm.repairOrder = ro;
                    });

                    promises.push(repairOrderPromise);
                }

                const transTypePromise = locationService.getLocationTransportationTypes(dealerId).then((response) => {
                    vm.dealerTransportationTypes = response;
                });

                const servicesPromise = roService.getRoLineItems(dealerId, roId).then((lineItems) => {
                    vm.services = lineItems.flatMap((line) => line.serviceOperations);
                });

                const opCodePromise = locationService.getLocationOpCodes(dealerId).then((opCodes) => {
                    vm.dealerOpCodes = opCodes;
                });

                const termsPromise = roService.getActiveTerms(dealerId, roId).then((terms) => {
                    vm.terms = terms;
                }); 

                promises.push(servicesPromise, opCodePromise, termsPromise, transTypePromise);            

                Promise.all(promises).then(() => {
                    mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(vm.dealerOpCodes, vm.repairOrder);

                    // TODO: remove this step eventually once we standardize the component to use what's coming from the API directly. 
                    vm.services = vm.services.map((op) => { return {...consumerRepairOrderAuthorizationsService.buildServiceOpViewModel(op, mappedOpCodes.find(moc => moc.opCode === op.opCode)), hideBreakdown: true}; });
                    vm.servicesToAuthorize = vm.services.filter(openServicesFilter);
                    vm.itemizationEnabled = vm.services?.some(s => s.itemizedPricingEnabled);
                    
                    dealerInspectionService.getShopTaxes(dealerId).then((shopTaxes) => {
                        vm.shopTaxes = shopTaxes.filter(tax => tax.isEnabled && tax.isFixedEnabled && tax.fixedTax?.fixedAmount != null);
                        
                        vm.recalculateFixedTaxesAndFees();
                    });
                }).finally(() => { vm.isLoading = false; });
            }

            init();

            // TODO: Seems like there should be a better way to do this.  Investigate options in the future
            $scope.$watch(() => {
                return vm.dataurl;
            }, (newVal, oldVal) => {
                vm.signatureImageData = newVal;
            });

            vm.getTotals = function() {
                const estimateTotal = vm.getTotalEstimate();
                const fixedFeesTotal = vm.fixedTaxesAndFees?.reduce((sum, fee) => sum + fee.amount, 0) || 0;
                const total = estimateTotal + fixedFeesTotal;
                
                return total;
            };
   
            vm.recalculateFixedTaxesAndFees = function() {
                const approvedServices = vm.services.filter(service => service.authorizationStatus === vm.lineItemStatuses.approved || service.approved === true);
                
                vm.fixedTaxesAndFees = inspectionService.getFixedTaxesAndFeesTotal(vm.shopTaxes, approvedServices, vm.itemizationEnabled);
            };
        };
    }
})();

angular.module('heremaps', ['heremaps-markers-module','heremaps-routes-module',	'heremaps-events-module',
'heremaps-ui-module']);

angular.module('heremaps')
.service('HereMapsUtilsService', [
    '$rootScope', 
    '$timeout', 
    'HereMapsCONSTS', function ($rootScope, $timeout, HereMapsCONSTS) {
        return {
            throttle: throttle,
            createScriptTag: createScriptTag,
            createLinkTag: createLinkTag,
            runScopeDigestIfNeed: runScopeDigestIfNeed,
            isValidCoords: isValidCoords,
            addEventListener: addEventListener,
            zoom: zoom,
            getBoundsRectFromPoints: getBoundsRectFromPoints,
            generateId: generateId,
            getMapFactory: getMapFactory,
            getBoundsRectFromMultiplePoints: getBoundsRectFromMultiplePoints,
            getHaversineDistance: getHaversineDistance
        };
    
        //#region PUBLIC
        function throttle(fn, period) {
            var timeout = null;
    
            return function () {
                if ($timeout)
                    $timeout.cancel(timeout);
    
                timeout = $timeout(fn, period);
            };
        }
    
        function addEventListener(obj, eventName, listener, useCapture) {
            obj.addEventListener(eventName, listener, !!useCapture);
        }
    
        function runScopeDigestIfNeed(scope, cb) {
            if (scope.$root && scope.$root.$$phase !== '$apply' && scope.$root.$$phase !== '$digest') {
                scope.$digest(cb || angular.noop);
                return true;
            }
            return false;
        }
    
        function createScriptTag(attrs) {
            var script = document.getElementById(attrs.src);
    
            if (script)
                return false;
    
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = attrs.src;
            _setAttrs(script, attrs);
    
            return script;
        }
    
        function createLinkTag(attrs) {
            var link = document.getElementById(attrs.href);
    
            if (link)
                return false;
    
            link = document.createElement('link');
            link.id = attrs.href;
            _setAttrs(link, attrs);
    
            return link;
        }
    
        function isValidCoords(coords) {
            return coords &&
                (typeof coords.latitude === 'string' || typeof coords.latitude === 'number') &&
                (typeof coords.longitude === 'string' || typeof coords.longitude === 'number');
        }
    
        function zoom(map, value, step) {
            map.setZoom(value, step);
        }
    
        function getMapFactory(){
            return H;
        }

        /**
         * @method getBoundsRectFromMultiplePoints
         * @param {Array<{lat,lng}>} points Array of objects with lat and lng parameters
         *  @property {Number} lat
         *  @property {Number} lng
         * @return {H.geo.Rect} bounds rect
         */
        function getBoundsRectFromMultiplePoints(points) {
            var lats = points.filter(function (item) { return item; }).map(function (item) { return item.lat; }),
                lngs = points.filter(function (item) { return item; }).map(function (item) { return item.lng; });
             
            var top = Math.max.apply(null, lats),
                bottom = Math.min.apply(null, lats),
                left = Math.min.apply(null, lngs),
                right = Math.max.apply(null, lngs);

            var topLeft = {
                lat: top,
                lng: left
            },
            bottomRight = {
                lat: bottom,
                lng: right
            };

            return getBoundsRectFromPoints(topLeft, bottomRight);
        }

        /**
         * @method getBoundsRectFromPoints
         * @param {Object} topLeft top left
         *  @property {Number|String} lat
         *  @property {Number|String} lng
         * @param {Object} bottomRight bottom right
         *  @property {Number|String} lat
         *  @property {Number|String} lng
         * 
         * @return {H.geo.Rect} bounds rect
         */
        function getBoundsRectFromPoints(topLeft, bottomRight) {
            return H.geo.Rect.fromPoints(topLeft, bottomRight, true);
        }
    
        function generateId() {
            var mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx',
                regexp = /[xy]/g,
                d = new Date().getTime(),
                uuid = mask.replace(regexp, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
    
            return uuid;
        }

        function getHaversineDistance(latLng1, latLng2, isMiles) {
            function toRad(x) {
                return x * Math.PI / 180;
            }

            var lon1 = latLng1.lng;
            var lat1 = latLng1.lat;

            var lon2 = latLng2.lng;
            var lat2 = latLng2.lat;

            var R = 6371; // km

            var x1 = lat2 - lat1;
            var dLat = toRad(x1);
            var x2 = lon2 - lon1;
            var dLon = toRad(x2);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;

            if (isMiles) d /= 1.60934;

            return d;
        }
    
        //#endregion PUBLIC 
    
        function _setAttrs(el, attrs) {
            if (!el || !attrs)
                throw new Error('Missed attributes');
    
            for (var key in attrs) {
                if (!attrs.hasOwnProperty(key))
                    continue;
    
                el[key] = attrs[key];
            }
        }
}]);

angular.module('heremaps')
.provider('HereMapsConfig', function() {
    var options = {};
    var DEFAULT_API_VERSION = "3.1";

    this.$get = function(){
        return {
            apiKey: options.apiKey,
            apiVersion: options.apiVersion || DEFAULT_API_VERSION,
            useHTTPS: options.useHTTPS,
            useCIT: !!options.useCIT,
            mapTileConfig: options.mapTileConfig
        };
    };

    this.setOptions = function(opts){
        options = opts;
    };
});
angular.module('heremaps')
.constant('HereMapsCONSTS', {
    UPDATE_MAP_RESIZE_TIMEOUT: 500,
    ANIMATION_ZOOM_STEP: .05,
    MODULES: {
        UI: 'controls',
        EVENTS: 'events',
        PANO: 'pano'
    },
    DEFAULT_MAP_OPTIONS: {
        height: 480,
        width: 640,
        zoom: 13,
        maxZoom: 2,
        resize: false,
        draggable: false,
        coords: {
            longitude: 0,
            latitude: 0
        }
    },
    MARKER_TYPES: {
        DOM: "DOM",
        SVG: "SVG"
    },
    CONTROLS: {
        NAMES: {
            SCALE: 'scalebar',
            SETTINGS: 'mapsettings',
            ZOOM: 'zoom',
            USER: 'userposition',
            NEARBY_DRIVERS: 'nearbydrivers'
        },
        POSITIONS: [
            'top-right',
            'top-center',
            'top-left',
            'left-top',
            'left-middle',
            'left-bottom',
            'right-top',
            'right-middle',
            'right-bottom',
            'bottom-right',
            'bottom-center',
            'bottom-left'
        ]
    },
    INFOBUBBLE: {
        STATE: {
            OPEN: 'open',
            CLOSED: 'closed'
        },
        DISPLAY_EVENT: {
            pointermove: 'onHover',
            tap: 'onClick'
        }
    },
    USER_EVENTS: {
        tap: 'click',
        pointermove: 'mousemove',
        pointerleave: 'mouseleave',
        pointerenter: 'mouseenter',
        drag: 'drag',
        dragstart: 'dragstart',
        dragend: 'dragend',
        mapviewchange: 'mapviewchange',
        mapviewchangestart: 'mapviewchangestart',
        mapviewchangeend: 'mapviewchangeend',
        wheel: 'wheel'
    }
});

angular.module('heremaps')
.service('HereMapsAPIService', [
    '$q',
    '$http',
    'HereMapsConfig',
    'HereMapsUtilsService',
    'HereMapsCONSTS', 
    function ($q, $http, HereMapsConfig, HereMapsUtilsService, HereMapsCONSTS) {
    var version = HereMapsConfig.apiVersion,
        protocol = HereMapsConfig.useHTTPS ? 'https' : 'http';

    var API_VERSION = {
        V: parseInt(version),
        SUB: version
    };

    var CONFIG = {
        BASE: "://js.api.here.com/v",
        CORE: "mapsjs-core.js",
        SERVICE: "mapsjs-service.js",
        UI: {
            src: "mapsjs-ui.js",
            href: "mapsjs-ui.css"
        },
        EVENTS: "mapsjs-mapevents.js",
        CLUSTERING: 'mapsjs-clustering.js',
        AUTOCOMPLETE_URL: "://autocomplete.geocoder.api.here.com/6.2/suggest.json",
        LOCATION_URL: "://geocoder.api.here.com/6.2/geocode.json"        
    };

    var API_DEFERSQueue = {};

    API_DEFERSQueue[CONFIG.CORE] = [];
    API_DEFERSQueue[CONFIG.SERVICE] = [];
    API_DEFERSQueue[CONFIG.UI.src] = [];
    API_DEFERSQueue[CONFIG.PANO] = [];
    API_DEFERSQueue[CONFIG.EVENTS] = [];
    API_DEFERSQueue[CONFIG.CLUSTERING] = [];

    var head = document.getElementsByTagName('head')[0];

    return {
        loadApi: loadApi,
        loadClustering: loadClustering,
        loadModules: loadModules,
        getPosition: getPosition,
        geocodeAddress: geocodeAddress
    };

    //#region PUBLIC
    function loadApi() {
        return _getLoader(CONFIG.CORE)
            .then(function () {
                return _getLoader(CONFIG.SERVICE);
            });
    }

    function loadModules(attrs, handlers) {
        for (var key in handlers) {
            if (!handlers.hasOwnProperty(key) || !attrs[key])
                continue;

            var loader = _getLoaderByAttr(key);

            loader()
                .then(handlers[key]);
        }
    }

    function loadClustering() {
        return _getLoader(CONFIG.CLUSTERING);
    }

    function getPosition(options) {
        var deferred = $q.defer();

        if (options && HereMapsUtilsService.isValidCoords(options.coords)) {
            deferred.resolve({ coords: options.coords });
        } else {
            navigator.geolocation.getCurrentPosition(function (response) {
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            }, options);
        }

        return deferred.promise;
    }

    function geocodeAddress(platform, params) {
        if (!params)
            return console.error('Missed required parameters');

        var geocoder = platform.getGeocodingService(),
            deferred = $q.defer(),
            _params = { gen: 8 };

        for (var key in params) { _params[key] = params[key]; }

        geocoder.geocode(_params, function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    //#endregion PUBLIC

    function _getLoaderByAttr(attr) {
        var loader;

        switch (attr) {
            case HereMapsCONSTS.MODULES.UI:
                loader = _loadUIModule;
                break;
            case HereMapsCONSTS.MODULES.EVENTS:
                loader = _loadEventsModule;
                break;
            default:
                throw new Error('Unknown module', attr);
        }

        return loader;
    }


    function _loadUIModule() {
        if (!_isLoaded(CONFIG.UI.src)) {
            var link = HereMapsUtilsService.createLinkTag({
                rel: 'stylesheet',
                type: 'text/css',
                href: _getURL(CONFIG.UI.href)
            });

            link && head.appendChild(link);
        }

        return _getLoader(CONFIG.UI.src);
    }

    function _loadEventsModule() {
        return _getLoader(CONFIG.EVENTS);
    }

    /**
     * @param {String} sourceName the source name
     * @return {String} e.g http://js.api.here.com/v{VER}/{SUBVERSION}/{SOURCE}
     */
    function _getURL(sourceName) {
        if (sourceName && sourceName[0] === ':') {
            return protocol + sourceName;
        } else if(sourceName && _.startsWith(sourceName, 'https://')) {
            return sourceName;
        }

        return [
            protocol,
            CONFIG.BASE,
            API_VERSION.V,
            "/",
            API_VERSION.SUB,
            "/",
            sourceName
        ].join("");
    }

    function _getLoader(sourceName) {
        var defer = $q.defer(), src, script;

        if (_isLoaded(sourceName)) {
            defer.resolve();
        } else {
            src = _getURL(sourceName);
            script = HereMapsUtilsService.createScriptTag({ src: src });

            script && head.appendChild(script);

            API_DEFERSQueue[sourceName].push(defer);

            script.onload = _onLoad.bind(null, sourceName);
            script.onerror = _onError.bind(null, sourceName);
        }

        return defer.promise;
    }

    function _isLoaded(sourceName) {
        var checker = null;

        switch (sourceName) {
            case CONFIG.CORE:
                checker = _isCoreLoaded;
                break;
            case CONFIG.SERVICE:
                checker = _isServiceLoaded;
                break;
            case CONFIG.UI.src:
                checker = _isUILoaded;
                break;
            case CONFIG.EVENTS:
                checker = _isEventsLoaded;
                break;
            case CONFIG.CLUSTERING:
                checker = _isClusteringLoaded;
                break;
            default:
                checker = function () { return false; };
        }

        return checker();
    }

    function _isCoreLoaded() {
        return !!window.H;
    }

    function _isServiceLoaded() {
        return !!(window.H && window.H.service);
    }

    function _isUILoaded() {
        return !!(window.H && window.H.ui);
    }

    function _isEventsLoaded() {
        return !!(window.H && window.H.mapevents);
    }

    function _isClusteringLoaded() {
        return !!(window.H && window.H.clustring);
    }
    

    function _onLoad(sourceName) {
        var deferQueue = API_DEFERSQueue[sourceName];
        for (var i = 0, l = deferQueue.length; i < l; ++i) {
            var defer = deferQueue[i];
            defer.resolve();
        }

        API_DEFERSQueue[sourceName] = [];
    }

    function _onError(sourceName) {
        var deferQueue = API_DEFERSQueue[sourceName];
        for (var i = 0, l = deferQueue.length; i < l; ++i) {
            var defer = deferQueue[i];
            defer.reject();
        }

        API_DEFERSQueue[sourceName] = [];
    }
}]);

(function () {
    'use strict';

    AddLineItemController.$inject = ["$timeout", "$scope", "$rootScope", "$transitions", "SYSTEM_ENUMS", "modalService", "inspectModalService", "rcUtilService", "roService", "SYSTEM_VARIABLES", "resolvedRo", "resolvedDealerId", "resolvedInspectionSection", "resolvedTask", "inspectionService", "liberatedAsideService", "INSPECT_CONSTANTS", "authService", "appointmentService", "azureBlob", "appointmentUtilService", "ValidationService", "$q", "signalRService"];
    angular
        .module('redcap.inspect')
        .controller('AddLineItemController', AddLineItemController);

    function AddLineItemController($timeout, $scope, $rootScope, $transitions, SYSTEM_ENUMS, modalService, inspectModalService, rcUtilService, roService, SYSTEM_VARIABLES,
        resolvedRo, resolvedDealerId, resolvedInspectionSection, resolvedTask, inspectionService, liberatedAsideService, INSPECT_CONSTANTS, authService, appointmentService, azureBlob, appointmentUtilService, ValidationService, $q, signalRService) {
        const vm = this;
        const delimiter = '; ';
        let originalResponseLevel = resolvedTask?.taskResponse;
        let myValidation = new ValidationService({
            validateOnEmpty: true
        });

        vm.roAnswerTypes = INSPECT_CONSTANTS.roTaskAnswerType;
        vm.inpsectionSection = resolvedInspectionSection;
        vm.selectedSearchObservation = [];
        vm.selectedSearchRecommendation = [];
        vm.mediaViewerDisplayed = false;
        vm.unsavedChanges = false;
        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
        vm.lineItemSeverities = SYSTEM_ENUMS.lineItemSeverity;
        vm.soleraLogoUrl = SYSTEM_VARIABLES.soleraLogoUrl;      
        vm.ro = resolvedRo;
        vm.roMedia = [];
        vm.dealerId = resolvedDealerId;
        vm.mediaListeners = {};

        // clone so we don't make changes to the original objects
        // in case they do not save.
        if (resolvedTask) {
            vm.task = _.cloneDeep(resolvedTask); 

            if (vm.task.lineItems.length) {
                vm.task.lineItems.forEach(li => {
                    li.shopNote = li.notes.map(note => note.message).join(delimiter);
                });

                expandLineItem(vm.task.lineItems[0]);
            } else {
                vm.task.lineItems.push(newLineItem());
            }            

            vm.isAdHoc = false;
        } else {
            vm.isAdHoc = true;
            vm.task = {
                lineItems: []
            };

            vm.task.lineItems.push(newLineItem());
        }

        vm.associatedObservations = null;
        vm.associatedRecommendations = null;
        vm.possibleAnswerTypes = inspectionService.getPossibleAnswerTypes();

        function closeAfterSave () {
            const data = {
                ro: vm.ro,
                task: vm.task
            };

            vm.unsavedChanges = false;
            $rootScope.$broadcast('lineItemAdded', data);
            liberatedAsideService.closeLiberatedAside(data);
        }

        /*
         * the media viewer that displays all media associated with the current RO so the user can add/remove images from that vs. uploading new images
         */
        function loadMediaViewer (lineItem) {
            if (!vm.mediaViewerDisplayed) {
                vm.mediaViewerDisplayed = true;
                
                inspectModalService.showMediaViewer(vm.ro, vm.dealerId, lineItem).then((lineItem) => {

                    if (lineItem !== false) {
                        roService.getRoMedia(vm.dealerId, vm.ro.id).then((roMedia) => {
                            if (roMedia) {
                                vm.roMedia = roMedia;
                            }

                            updateLineImageCollections(lineItem);
                        });
                    }

                    vm.mediaViewerDisplayed = false;
                });
            }
        }

        function updateLineImageCollections(lineItem) {
            lineItem.availImages = vm.roMedia.filter(img => img.serviceOperationId !== lineItem.id);
            lineItem.existingImages = vm.roMedia.filter(img => img.serviceOperationId === lineItem.id);
            lineItem.media = lineItem.existingImages;
        }

        function setupMediaListener(lineItem) {
            if (lineItem?.id && !vm.mediaListeners[lineItem.id]) {
                const listener = signalRService.registerInspectionMediaListener(lineItem.id);
                
                listener
                    .on(signalRService.events.inspectionMedia.broadcastMediaUploaded, (mediaUpload) => handleMediaUploaded(mediaUpload, lineItem))
                    .on(signalRService.events.inspectionMedia.broadcastMediaDeleted, (mediaDelete) => handleMediaDeleted(mediaDelete, lineItem))
                    .start();
                
                vm.mediaListeners[lineItem.id] = listener;
            }
        }

        function handleMediaUploaded(mediaUpload, targetLineItem) {
            if (mediaUpload?.media && mediaUpload.lineItemId === targetLineItem.id) {
                targetLineItem.mediaItems = targetLineItem.mediaItems || [];
                
                if (!targetLineItem.mediaItems.find(media => media.azureImageId === mediaUpload.media.azureImageId)) {
                    targetLineItem.mediaItems.push(mediaUpload.media);
                }
            }
        }

        function handleMediaDeleted(mediaDelete, targetLineItem) {
            if (mediaDelete?.lineItemId === targetLineItem.id && targetLineItem.mediaItems?.length) {
                const filteredItems = targetLineItem.mediaItems.filter(media => media.id !== mediaDelete.mediaId);
                
                if (filteredItems.length < targetLineItem.mediaItems.length) {
                    targetLineItem.mediaItems = filteredItems;
                }
            }
        }

        function cleanupMediaListeners() {
            Object.values(vm.mediaListeners).forEach(listener => listener?.disconnect());
            vm.mediaListeners = {};
        }

        function stopEvents (evt) {
            rcUtilService.stopEvents(evt);
        }

        function expandLineItem (lineToOpen) {
            let matchingLine = vm.task.lineItems.find(line => line.id === lineToOpen?.id);

            if (matchingLine) {
                matchingLine.isExpanded = true;
                vm.expandedLineItem = matchingLine;
            } else {
                vm.expandedLineItem = vm.task.lineItems[0];
            }
        }

        function collapseLineitems() {
            vm.task.lineItems.forEach(li => {li.isExpanded = false; });
        }
        
        function populateDefaultObservations () {
            let results = [];
           
            vm.task.associatedObservations.forEach(observation => {           
                let data = {
                    id: observation.id,
                    text: observation.name,
                    displayName: observation.displayName || observation.name,
                    name: observation.name
                };
                
                results.push(data);
            });

            vm.defaultObservations = results;         
        }

        function populateDefaultRecommendations () {
            let results = [];

            vm.task.associatedRecommendations.forEach(rec => {
                let data = {
                    id: rec.id,
                    text: rec.name,
                    displayName: rec.displayName || rec.name,
                    name: rec.name
                };
                
                results.push(data);
            });

            vm.defaultRecs = results; 
        }

        function getDefaultObservationsAndRecommendations() {
            vm.loadingRecsAndObservations = true;

            inspectionService.getRecsAndObservations(vm.dealerId, vm.task.taskId).then((taskDetail) => {
                if (taskDetail) {
                    vm.task.associatedObservations = taskDetail.observations;
                    vm.task.associatedRecommendations = taskDetail.recommendations;
                    
                    populateDefaultRecommendations();
                    populateDefaultObservations();
                }

                vm.loadingRecsAndObservations = false;                    
            });
            
        }

        function init() {   
            if (vm.task && vm.task.inputOptions && vm.task.measurementChoices.length) {
                vm.task.measurementButtonWidth = Math.round(100 / vm.task.measurementChoices.length) + '%';
            }

            if (vm.task.lineItems && vm.task.lineItems.length > 0) {
                vm.task.lineItems.forEach(item => {
                    setupMediaListener(item);
                });
            }

            if (vm.task && vm.task.taskId && (!vm.task.associatedObservations || !vm.task.associatedRecommendations)) {
                getDefaultObservationsAndRecommendations();
            } else {
                if (vm.task && vm.task.taskId) {
                    populateDefaultRecommendations();
                    populateDefaultObservations();    
                }        
            }

            if (vm.task && vm.task.taskId) {
                roService.getMediaUploadLink(vm.dealerId, vm.ro.id, null, vm.task.taskId, vm.task.name)
                    .then((link) => {
                        vm.mediaUploadUrl = link;
                    });
            }

            expandLineItem();
        }

        function addImagesToLineItem(lineItem, images) {
            return roService.saveRecMedia(vm.dealerId, vm.ro.id, lineItem.id, images).then((response) => {
                vm.unsavedChanges = false;
            }).catch((error) => {
                console.error('Error saving or fetching media', error);
            });
        }

        vm.uploadLineItemImage = function ($model, file, $files, $event, $id, reference, container, forceAdd) {
            const lineItem = vm.task.lineItems.find(li => li.id === reference);
            const deferred = $q.defer();
            const currentUser = authService.getCurrentUser();
            
            vm.unsavedChanges = true;
            vm.imageType = appointmentUtilService.getImageTypes();
            vm.addingImage = true;            

            appointmentService.getImageToken(vm.dealerId, vm.imageType.recommendedMaintenance).then((result) => {
                const config = {
                    baseUrl: result.url,
                    file: file,
                    complete: function () {
                        $model.azureImageId = result.imageId;
                        $model.url = result.url;
                        $model.mediaUrl = result.url;
                        $model.mediaType = appointmentUtilService.getMediaType(file.type);
                        $model.fileExtension = file.type;
                        $model.dateTaken = new Date();
                        $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);
                        $model.createdByUserId = currentUser.userId;
                        
                        const mediaObject = _.cloneDeep($model);

                        // We can't add images to line items that haven't been saved to the database yet, but if this is an existing line, 
                        //  go ahead and associate the image with the line item. 
                        if (!lineItem.isNew) {
                            addImagesToLineItem(lineItem, [mediaObject]);
                        }

                        deferred.resolve(mediaObject);
                        
                        vm.addingImage = false;
                    },
                    error: function (err) {
                        console.error('Image upload failed', err);
                        deferred.reject(err);
                        vm.addingImage = false;
                    },
                    blockSize: 4000000 
                };
    
                azureBlob.upload(config);
            }).catch((err) => {
                console.error('Failed to retrieve image token', err);
                deferred.reject(err);
            });
        
            return deferred.promise; 
        };        

        vm.addLineItem = function () {
            vm.unsavedChanges = true;
            vm.imageToUpload = {};

            const lineItem = newLineItem();

            collapseLineitems();

            vm.task.lineItems.push(lineItem);
            expandLineItem(lineItem);
        };

        vm.removeLineItem = function (evt, lineItem) {
            evt.stopPropagation();
            evt.preventDefault();
            const confirm = modalService.showYesNo('Please Confirm', 'Are you sure you wish to remove the recommendation?', 'No', 'Yes');

            confirm.then((confirmed) => {
                if (confirmed) {
                    if (!lineItem.isNew) {
                        vm.unsavedChanges = true;

                        roService.removeLineItem(vm.dealerId, vm.ro.id, lineItem.id).then((result) => {                
                            if (result) {
                                if (vm.expandedLineItem && vm.expandedLineItem.id === lineItem.id) {
                                    vm.expandedLineItem.isExpanded = false;
                                    vm.expandedLineItem = null;
                                }
    
                                lineItem.isDeleted = true;
                                vm.task.lineItems = vm.task.lineItems.filter(li => li.id !== lineItem.id);
                                vm.unsavedChanges = false;
                            }
                        }).catch((err) => {
                            console.error('Failed to remove redcap line item', err);
                        });    
                    } else {
                        vm.task.lineItems = vm.task.lineItems.filter(li => li.id !== lineItem.id);
                    }
                }
            });
        };

        vm.openImageModal = function (mediaItem, mediaType) {
            if (mediaItem) {
                modalService.showImageViewer(mediaItem.url, 'Recommendation Image', mediaType);
            }
        };
        
        /*
         * Loads ro media for the current ro if it hasn't been loaded, and then loads the media viewer
         */
        vm.mediaBtnClicked = function (lineItem) {
            if (!vm.roMedia || vm.roMedia.length === 0) {
                roService.getRoMedia(vm.dealerId, vm.ro.id).then((roMedia) => {

                    if (roMedia) {
                        vm.roMedia = roMedia;
                    }

                    loadMediaViewer(lineItem);
                });
            } else {
                loadMediaViewer(lineItem);
            }
        };

        vm.close = function () {
            if (vm.unsavedChanges) {
                const confirm = modalService.showYesNo('Please Confirm', 'You had unsaved changes, are you sure you wish to cancel?', 'No', 'Yes');

                confirm.then((confirmed) => {
                    if (confirmed) {
                        vm.unsavedChanges = false;
                        cleanupMediaListeners();
                        liberatedAsideService.closeLiberatedAside();
                    }
                });
            } else {
                if (vm.inpsectionSection && vm.inpsectionSection.tasks) {
                    setInspectionSectionTask();
                }

                cleanupMediaListeners();
                liberatedAsideService.closeLiberatedAside();
            }
        };

        /*
         * when someone updates tire tread depth, or other input option we display on the task
         */
        vm.updateTaskMeasurement = function(inputOption, measurementChoice) {
            vm.unsavedChanges = true;
            inputOption.isChanged = true;
            inputOption.measurementChoice = measurementChoice;

            // We're setting a measurement choice on the input option
            inputOption.taskMeasurementChoiceId =  _.get(measurementChoice, 'id', null);
            inputOption.taskAnswer = _.get(measurementChoice, 'taskAnswerType.taskAnswerTypeId', null);

            if (measurementChoice) {
                inputOption.choiceResponseId = inputOption.taskMeasurementChoiceId;
            }       
            
            const maxResponseLevel = getMaxMeasurementResponseLevel(vm.task.taskResponse);

            if (maxResponseLevel !== 0 && maxResponseLevel !== INSPECT_CONSTANTS.roTaskAnswerType.na) {
                vm.task.taskResponse = maxResponseLevel;
            }  
        };

        vm.updateTaskStatus = async function (status) {
            myValidation.checkFormValidity($scope.inputForm);
               
            if (status !== vm.task.taskResponse || status !== originalResponseLevel) {
                if (!await inspectionService.proceedWithInspectionChange(vm.ro.inspectionStatus)) {
                    return false;
                }      

                vm.unsavedChanges = true;
                vm.task.taskResponse = status;
                
                if (!vm.isAdHoc && !vm.isTaskInvalid()) {
                    let inspectionTaskStatusUpdate = {
                        repairOrderId: vm.ro.id,
                        taskId: vm.task.taskId,
                        taskStatusType: status
                    };

                    inspectionService.updateTaskStatus(vm.dealerId, inspectionTaskStatusUpdate).then((response) => {
                        if (!response) {
                            vm.task.taskResponse = originalResponseLevel;                            
                        } else {
                            originalResponseLevel = vm.task.taskResponse;

                            vm.ro.inspectionStatus = INSPECT_CONSTANTS.inspectionStatus.inProgress;
                        }

                        vm.unsavedChanges = false;
                    });
                }
            }

            return true;
        };

        vm.isTaskInvalid = function() {
            if (!vm.task.lineItems || vm.task.lineItems.length === 0) {
                return false;
            }

            let taskSeverity = getSeverityFromTaskResponse(vm.task.taskResponse);  
            let maxMeasurementSeverity = 0;

            if (_.get(vm.task, 'inputOptions[0].inputType', null) === INSPECT_CONSTANTS.measurementInputType.range) {
                const maxResponseLevel = getMaxMeasurementResponseLevel(vm.task.taskResponse);

                maxMeasurementSeverity = getSeverityFromTaskResponse(maxResponseLevel);     
            }
            
            return !vm.task.taskResponse || (maxMeasurementSeverity > 0 && taskSeverity !== maxMeasurementSeverity);
        };

        function processAddedLineItems (addedLineItemPromises) {
            // It's possible to have lines with no complaints/corrections if the user selects "NA" or "Pass" as the task response.  In these cases
            //  we remove the required validation from the complaints/corrections to allow the form to be saved, but we don't want line items
            //  with no complaint/correction to be added.
            const addedLineItems = vm.task.lineItems.filter(line => line.isNew && line.corrections?.length > 0 && line.complaints?.length > 0);

            addedLineItems.forEach(li => {
                buildLineItemModel(li);

                addedLineItemPromises.push(roService.addLineItem(vm.dealerId, vm.ro.id, li));
            });   
        }

        function processUpdatedLineItems (updatedLineItemPromises) {
            const updatedLineItems = vm.task.lineItems.filter(line => !line.isNew && !line.isDeleted);

            updatedLineItems.forEach((li) => {
                // This function can run out of process with the updateLineItem.  They can execute independently.
                roService.calculateDefaultLaborRate(vm.dealerId, vm.ro.id, li.id, li.laborHours);

                buildLineItemModel(li);

                const servicePromise = roService.updateLineItem(vm.dealerId, vm.ro.id, li.id, li);

                updatedLineItemPromises.push(servicePromise);
            });  
        }

        function processTaskMeasurementUpdates(taskMeasurementPromises) {
            const updatedTaskMeasurements = vm.task.inputOptions.filter(io => io.isChanged === true);

            if (updatedTaskMeasurements && updatedTaskMeasurements.length === 0) { // to handle unnecessary api calls
                return;
            }

            const measurementsToUpdate = [];

            updatedTaskMeasurements.forEach(inputOption => {
                let measurementResult = {
                    taskId: vm.task.taskId,
                    taskInputOptionId: inputOption.id,
                    repairOrderId: vm.ro.id,
                    taskMeasurementChoiceId: inputOption.taskMeasurementChoiceId,
                    taskAnswer: inputOption.taskAnswer,
                    taskMeasurementInputValue: inputOption.inputResponse
                };

                measurementsToUpdate.push(measurementResult);             
            });

            const saveMeasurementPromise = inspectionService.saveTaskMeasurement(vm.dealerId, measurementsToUpdate);

            taskMeasurementPromises.push(saveMeasurementPromise);  
        }

        vm.save = async function () {
            if (!vm.isAdHoc && vm.isTaskInvalid()) {
                modalService.showError('You cannot set the status of a task lower than the highest measurement severity.');

                return;
            }

            if (!await inspectionService.proceedWithInspectionChange(vm.ro.inspectionStatus)) {
                return;
            }

            vm.savingChanges = true;
         
            const taskMeasurementPromises = [];
            const updatedLineItemPromises = [];
            const addedLineItemPromises = [];

            if (!vm.isAdHoc) {
                processTaskMeasurementUpdates(taskMeasurementPromises);
                await Promise.all(taskMeasurementPromises);
            }

            if (vm.isAdHoc || (vm.task.taskResponse && vm.task.taskResponse !== vm.roAnswerTypes.pass)) {
                processAddedLineItems(addedLineItemPromises);
            }

            processUpdatedLineItems(updatedLineItemPromises);

            await Promise.all(addedLineItemPromises.concat(updatedLineItemPromises));

            vm.ro.inspectionStatus = INSPECT_CONSTANTS.inspectionStatus.inProgress;

            await vm.updateTaskStatus(vm.task.taskResponse);

            vm.savingChanges = false;
            
            closeAfterSave();
        };

        vm.severityChanged = function(lineItem) {
            lineItem.isChanged = true;
            myValidation.checkFormValidity($scope.inputForm);
        };

        vm.validation = {
            valDecimal: function(value, exactDecimalPlaces) {
                if (value == null || value === '') return {isValid: true, message: ' '};

                return appointmentUtilService.validateDecimal(value, null, exactDecimalPlaces);
            }
        };
        
        vm.tagClicked = function(tag, lineItem, forComplaints) {
            lineItem.isEditingComplaint = forComplaints;
            lineItem.isEditingCorrection = !forComplaints;
            lineItem.tagToEdit = tag;
            lineItem.tagContent = tag.name;
        };

        vm.closeTagEdit = function(shouldSave, lineItem) {
            if (shouldSave) {
                const elementId = (lineItem.isEditingComplaint ? '#observation_search' : '#recommendation_search') + `_${lineItem.id}`;
                const collectionToEdit = lineItem.isEditingComplaint ? lineItem.complaints : lineItem.corrections;
                const indexToEdit = collectionToEdit.findIndex((c) => c === lineItem.tagToEdit.name);

                // Because the tag-inputs component does not send the event that triggered the click, we have to manually find the element based on the index :/
                const tagElement = document.querySelectorAll(`${elementId} li span`)[indexToEdit];

                // Since the tags component doesn't provide a direct way to edit tags, we update each portion of the tag manually here.
                $timeout(() => {
                    lineItem.tagToEdit.name = lineItem.tagContent;
                    collectionToEdit[indexToEdit] = lineItem.tagContent;
                    tagElement.innerHTML = lineItem.tagContent;
                }, 0);            
            }

            lineItem.isEditingComplaint = false;
            lineItem.isEditingCorrection = false;            
        };

        vm.onTagRemoved = function(tag, lineItem, forObservations) {
            if ((forObservations && lineItem.isEditingComplaint) || (!forObservations && lineItem.isEditingCorrection)) {
                if (lineItem.tagToEdit && lineItem.tagToEdit.name === tag.name) {
                    vm.closeTagEdit(false, lineItem);
                }
            }
        };

        vm.searchObservations = function(searchTerm) {
            return inspectionService.searchObservations(vm.dealerId, searchTerm, true).then((observationResults) => {
                if (observationResults && vm.task?.lineItems?.length > 0) {
                    const allSelectedObservations = vm.task.lineItems.reduce((selectedObservations, lineItem) => {
                        if (lineItem.complaints && lineItem.complaints.length > 0) {
                            return selectedObservations.concat(lineItem.complaints);
                        }

                        return selectedObservations; //build selectedObservations array
                    }, []);
                    
                    if (allSelectedObservations.length > 0) {
                        return observationResults.filter(obs1 => !allSelectedObservations.some(obs2 => obs1.id === obs2.id)); // filter out already selected observations
                    }
                }

                return observationResults;
            });
        };

        vm.searchRecommendations = function(searchTerm) {
            return inspectionService.searchRecommendations(vm.dealerId, searchTerm, true).then((recommendationResults) => {
                if (recommendationResults && vm.task?.lineItems?.length > 0) {
                    const allSelectedRecommendations = vm.task.lineItems.reduce((selectedRecommendations, lineItem) => {
                        if (lineItem.corrections && lineItem.corrections.length > 0) {
                            return selectedRecommendations.concat(lineItem.corrections);
                        }

                        return selectedRecommendations; //build selectedRecommendations array
                    }, []);
                    
                    if (allSelectedRecommendations.length > 0) {
                        return recommendationResults.filter(rec1 => !allSelectedRecommendations.some(rec2 => rec1.id === rec2.id)); // filter out already selected recommendations
                    }
                }

                return recommendationResults;
            });
        };

        function getMaxMeasurementResponseLevel(taskResponse) {
            let inputOptions = vm.task.inputOptions.filter(io => io.choiceResponseId);

            if (inputOptions.length > 0) {
                let measurementChoices = vm.task.measurementChoices.filter(mc => inputOptions.some(io => io.choiceResponseId === mc.id));
                
                return measurementChoices.reduce((max, measurement) => {
                    return measurement.taskAnswerType.taskAnswerTypeId > max ? measurement.taskAnswerType.taskAnswerTypeId : max;
                }, 0);            
            } else {
               return taskResponse;
            }
       }

        function getSeverityFromTaskResponse(taskResponse)  {
            return taskResponse === INSPECT_CONSTANTS.roTaskAnswerType.caution ? 1 :
                    taskResponse === INSPECT_CONSTANTS.roTaskAnswerType.fail ? 2 : 0;
        }

        function buildLineItemModel (li) {
            li.opCodeId = li.selectedOpCode?.dealerAppointmentOpCodeId;
            li.opCode = li.selectedOpCode?.opCode;
            li.opCodeDescription = li.selectedOpCode?.text;
           
            if (li.severity != null && li.severity !== '') {
                li.severity = Number(li.severity);
            }

            if (Array.isArray(li.corrections)) {
                li.corrections = li.corrections.map(item => 
                    typeof item === 'object' ? (item.name || item) : item
                );
            }

            if (Array.isArray(li.complaints)) {
                li.complaints = li.complaints.map(item => 
                    typeof item === 'object' ? (item.name || item) : item
                );
            }

            if (!li.isNew) {
                if (li.notes?.length) {
                    li.notes[0].message = li.shopNote;
                } else if (li.shopNote) {
                    li.notes = [{message: li.shopNote}];
                }            
            }
  
            li.sourceType = vm.isAdHoc 
                ? SYSTEM_ENUMS.lineItemSource.adHoc 
                : SYSTEM_ENUMS.lineItemSource.inspection;
                
            if (!vm.isAdHoc) {
                li.taskId = vm.task.taskId;
            }
        }

        function setInspectionSectionTask() {
            if (vm.inspectionSection && vm.inspectionSection.tasks) {
                vm.inspectionSection.tasks.forEach((task) => {
                    if (task.id === vm.task.id) {
                        Object.assign(task, vm.task);
                    }
                });
            }
        }
        
        vm.isSaveDisabled = function() {
            return vm.savingChanges || 
                   ($scope.inputForm && $scope.inputForm.$invalid) || 
                   vm.task.lineItems.some(lineItem => {
                       const hasComplaints = lineItem.complaints?.length > 0;
                       const hasCorrections = lineItem.corrections?.length > 0;
                       const hasSeverity = !!(lineItem.severity !== null && lineItem.severity !== '');
                       
                       return hasComplaints && hasCorrections && !hasSeverity;
                   });
        };

        function newLineItem() {
            return {
                id: rcUtilService.getRandomNumber(),
                mediaItems: [],
                corrections: [],
                complaints: [],
                isNew: true,
                isExpanded: true,
                severity: getSeverityFromTaskResponse(vm.task.taskResponse)
            };
        }

        // if something transitions us away from the page, close the aside
        $transitions.onBefore({}, (trans) => { 
            cleanupMediaListeners();
            vm.close();
        });
        
        init();
    }
})();



(function () {
    'use strict';

    angular.module('redcap.trip', []);
})();
(function () {
    'use strict';

    setTripChargeModalController.$inject = ["$scope", "resolvedTrip", "chargeToEdit", "tripService", "$uibModalInstance", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('SetTripChargeModalController', setTripChargeModalController);

    function setTripChargeModalController($scope, resolvedTrip, chargeToEdit, tripService, $uibModalInstance, SYSTEM_ENUMS) {
        var vm = this;
        vm.trip = resolvedTrip;
        vm.charge = {
            comment: null
        };

        if (chargeToEdit) {
            var item = chargeToEdit.customerCharge || chargeToEdit.driverPay;

            vm.charge.existingChargeId = item.id;
            vm.charge.chargeAmount = chargeToEdit.customerCharge ? chargeToEdit.customerCharge.amount.toFixed(2) : 0;
            vm.charge.driverPayAmount = chargeToEdit.driverPay ? chargeToEdit.driverPay.amount.toFixed(2) : 0;
            vm.charge.chargeId = chargeToEdit.customerCharge ? chargeToEdit.customerCharge.id : null;
            vm.charge.driverPayId = chargeToEdit.driverPay ? chargeToEdit.driverPay.id : 0;
            vm.charge.type = item.chargeType;
        }

        vm.chargeTypeOptions = [
            { id: 2, text: 'Toll'},
            { id: 3, text: 'Gas'},
            { id: 4, text: 'Parking Fine'},
            { id: 5, text: 'Transportation'},
            { id: 6, text: 'Roadside Service'},
            { id: 7, text: 'Other'},
            { id: 10, text: 'Bonus'},
            { id: 11, text: 'Cancel Fee'}
        ];

        vm.close = function(associatedCharge) {
            $uibModalInstance.close(associatedCharge);
        };

        vm.save = function () {
            vm.saving = true;

            tripService.saveCharge(vm.trip.id, vm.charge).then(function (associatedCharge) {
                vm.saving = false;
                vm.close(associatedCharge);
            });
        };

        vm.deleteCharge = function() {
            vm.deleting = true;

            tripService.deleteCharge(vm.trip.id, vm.charge.existingChargeId, vm.charge.comment).then(function (historyItem) {
                vm.deleting = false;
                
                vm.close({ historyItem: historyItem, deleted: true, existingChargeId: vm.charge.existingChargeId });
            });
        };
    }
})();

(function () {
    'use strict';

    setBillingTimeModalController.$inject = ["$scope", "resolvedTrip", "chargeToEdit", "tripService", "$uibModalInstance", "billingModalService"];
    angular
        .module('redcap.trip')
        .controller('SetBillingTimeModalController', setBillingTimeModalController);

    function setBillingTimeModalController($scope, resolvedTrip, chargeToEdit, tripService, $uibModalInstance, billingModalService) {
        var vm = this;

        // The billingStart/End Dates are provided in UTC, so we display that time relative to the timezone of the dealer        
        var startMoment = moment.utc(chargeToEdit.billingStartDate).tz(resolvedTrip.dealerTimeZone);
        var endMoment = moment.utc(chargeToEdit.billingEndDate).tz(resolvedTrip.dealerTimeZone);
        var startDate = new Date(startMoment.format('MM/DD/YYYY HH:mm'));
        var endDate = new Date(endMoment.format('MM/DD/YYYY HH:mm'));
        var bufferTimeout = null; // Buffer timeout to wait before recalculating charges after times have been changed.
 
        vm.trip = resolvedTrip;

        vm.charge = {
            chargeAmount: chargeToEdit.customerCharge.amount.toFixed(2),
            driverPayAmount: chargeToEdit.driverPay.amount.toFixed(2),
            chargeId: chargeToEdit.customerCharge.id,
            driverPayId: chargeToEdit.driverPay.id,
            type: chargeToEdit.customerCharge.chargeType,
            startDate: startDate,
            endDate: endDate,
            totalTime: endMoment.diff(startMoment, 'seconds')
        };

        vm.updatedBilling = { };

        vm.billingTimeChanged = function() {            
            if(!isValidBillingTime())
                return;
            
            clearTimeout(bufferTimeout);    
            
            vm.calculatingBilling = true;
            bufferTimeout = setTimeout(function() {
                tripService.calculateBillingTime(resolvedTrip.id, vm.charge.startDate, vm.charge.endDate).then(function(updatedBilling) {
                    vm.updatedBilling.chargeAmount = updatedBilling.totalChargeAmount;
                    vm.updatedBilling.driverPayAmount = updatedBilling.totalPayAmount;
    
                    vm.updatedBilling.totalTime = moment(vm.charge.endDate).diff(vm.charge.startDate, 'seconds');
                    
                    vm.calculatingBilling = false;                
                });
                
                bufferTimeout = null;
            }, 800);
           
        };

        vm.close = function(associatedCharge) {
            $uibModalInstance.close(associatedCharge);
        };

        vm.save = function () {
            vm.saving = true;

            if(!isValidBillingTime()) 
                return;

            // Here, the date and time are correct, but the offset is wrong, because the browser forces it to "local time,"
            //  so we want to force the offset to be in the dealer timezone (without adjusting the actual date and time),
            //  then convert that to UTC.
            var utcStart = billingModalService.convertToTimezoneUtc(vm.charge.startDate, resolvedTrip.dealerTimeZone);
            var utcEnd = billingModalService.convertToTimezoneUtc(vm.charge.endDate, resolvedTrip.dealerTimeZone);
            
            tripService.addBillingTime(vm.trip.id, utcStart, utcEnd, vm.charge.comment).then(function (historyItem) {
                vm.saving = false;

                var associatedCharge = {
                    customerCharge: {
                        amount: vm.updatedBilling.chargeAmount
                    },
                    driverPay: {
                        amount: vm.updatedBilling.driverPayAmount
                    },
                    historyItem: historyItem
                };
                
                chargeToEdit.billingStartDate = utcStart;
                chargeToEdit.billingEndDate = utcEnd;

                vm.close(associatedCharge);
            });
        };

        function isValidBillingTime() {
            if(vm.charge.startDate > vm.charge.endDate) {
                vm.validationMsg = 'Start Date must be before End Date';
                return false;
            }

            vm.validationMsg = null;
            return true;
        }
    }
})();

(function () {
    'use strict';

    duplicateLyftTripModalController.$inject = ["resolvedLyftResult", "$uibModalInstance"];
    angular
        .module('redcap.trip')
        .controller('DuplicateLyftTripModalController', duplicateLyftTripModalController);

    function duplicateLyftTripModalController(resolvedLyftResult, $uibModalInstance) {
        var vm = this;
        vm.close = $uibModalInstance.close;
        vm.tripId = resolvedLyftResult.tripId;
        vm.lyftTripId = resolvedLyftResult.error.current_ride_id;
    }
})();

(function () {
    'use strict';

    duplicateActiveTripModal.$inject = ["activeTripIds", "$uibModalInstance"];
    angular
        .module('redcap.trip')
        .controller('DuplicateActiveTripModalController', duplicateActiveTripModal);

    function duplicateActiveTripModal(activeTripIds, $uibModalInstance) {
        var vm = this;
        vm.close = $uibModalInstance.close;
        vm.activeTripIds = activeTripIds;
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.trip')
        .component('rcTripSummaryPhotos', {
            bindings: {
                task: '<'
            },
            templateUrl: 'app/areas/trip/components/summary-photos/summary-photos.view.html',
            controller: TripSummaryPhotosController,
            controllerAs: 'vm'
        });

    function TripSummaryPhotosController() {

        this.$onInit = function() {
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.trip')
        .component('rcTripSummaryTasks', {
            bindings: {
                task: '<'
            },
            templateUrl: 'app/areas/trip/components/summary-tasks/summary-tasks.view.html',
            controller: TripSummaryTasksController,
            controllerAs: 'vm'
        });

    function TripSummaryTasksController() {

        this.$onInit = function() {
        };
    }
})();

(function () {
    'use strict';

    TripSummaryVehicleController.$inject = ["rcUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .component('rcTripSummaryVehicle', {
            bindings: {
                task: '<'
            },
            templateUrl: 'app/areas/trip/components/summary-vehicle/summary-vehicle.view.html',
            controller: TripSummaryVehicleController,
            controllerAs: 'vm'
        });

    function TripSummaryVehicleController(rcUtilService, SYSTEM_ENUMS) {
        this.$onInit = function() {
            var vm = this;

            vm.workflowTaskTypes = SYSTEM_ENUMS.workflowTaskTypes;

            vm.getRangleDisplayFuelLevel = function (fuelLevel) {
                return rcUtilService.setFuelLevel(fuelLevel);
            };

            if (vm.task.driverResponse && vm.task.driverResponse.vehicle) {
                var fuelLevel = 0;
                if (vm.task.driverResponse.vehicle === null) {
                    fuelLevel = 0;
                } else {
                    fuelLevel = vm.task.driverResponse.vehicle.fuel;
                }
                vm.levelFuel = rcUtilService.setFuelLevel(fuelLevel);
            }

            if (vm.task.driverResponse && vm.task.driverResponse.vehicles){
                vm.task.driverResponse.vehicles.forEach(vehicle => {
                    vehicle.vehicleIssues = vm.task.vehicleIssues ? vm.task.vehicleIssues.filter((x) => x.multipleOrder === vehicle.multipleOrder) : [];
                    vehicle.media = vm.task.media ? vm.task.media.filter((x) => x.multipleOrder === vehicle.multipleOrder) : [];
                });
            }

        };
    }
})();

(function () {
    'use strict';

    TripSummaryImageController.$inject = ["$element", "SYSTEM_ENUMS", "$timeout", "tripService", "$stateParams", "modalService"];
    angular
        .module('redcap.trip')
        .component('rcTripSummaryImage', {
            bindings: {
                media: '<',
                isGenericViewer: '<'
            },
            templateUrl: 'app/areas/trip/components/summary-image/summary-image.view.html',
            controller: TripSummaryImageController,
            controllerAs: 'vm'
        });

    function TripSummaryImageController($element, SYSTEM_ENUMS, $timeout, tripService, $stateParams, modalService) {

        this.$onInit = function() {
            var vm = this,
                maxHeight = 130;

            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            $timeout(function() {
                var imgs = angular.element('img, video', $element);
                for (var i = 0; i < imgs.length; i++) {
                    vm.setElementWidth($element, imgs[i]);
                }
            });

            vm.setElementWidth = function(container, image) {
                image.addEventListener('loadeddata',
                    (e) => {
                        if (image.readyState >= 3) {
                            if (image.tagName === 'VIDEO') {
                                var multiplier = maxHeight / image.videoHeight;
                                container.css('width', image.videoWidth * multiplier);
                            } else {
                                container.css('width', image.scrollWidth);
                            }
                        }
                    });
            };

            vm.generateDownloadLink = function() {
                return tripService.getTripPhotoSasDownloadUrl($stateParams.tripId, vm.media.filePath, vm.media.type)
                    .then(function(result) {
                        return result.blobUrl;
                    });
            };

            vm.openMedia = function() {
                // added code in appointments viewer that will be using this
                // as well as the consumer page, and we don't wanto pass the generate download link to those 
                if (vm.isGenericViewer === 1) {
                    modalService.showImageViewer(this.media.path, ' ', this.media.type);
                } else {
                    var createNewDlg = modalService.showImageViewer(this.media.path,
                        this.media.description,
                        this.media.type,
                        vm.generateDownloadLink);
                    createNewDlg.then(function(results) {});
                }
            };
        };
    }
})();

(function () {
    'use strict';

    angular.module('redcap.appointment', []);
})();

(function () {
    'use strict';

    AppointmentScriptTabController.$inject = ["appointmentService", "$scope"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentScriptTabController', AppointmentScriptTabController);


    function AppointmentScriptTabController(appointmentService, $scope) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        vm.content = null;
    
         function updateContent() {
            let step = parent_vm.accordion.selectedStep;

            if (!step) return;
            appointmentService.getScriptContent(step, parent_vm.appointment.location.id).then((response) => {
                vm.content = response;
                parent_vm.gotoTab(1);
            });
        }

        $scope.$on('stepChanged', (event, data) => {
            updateContent();
        });

        updateContent();
        
    }


})();

(function () {
    'use strict';

    AppointmentMessagesTabController.$inject = ["$scope", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentMessagesTabController', AppointmentMessagesTabController);


    function AppointmentMessagesTabController($scope, SYSTEM_ENUMS) {
        var vm = this;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.parent_vm = $scope.$parent.vm;
        vm.contactError = vm.parent_vm.contactError;
        
    }


})();

(function () {
    'use strict';

    AppointmentFAQTabController.$inject = ["appointmentService", "$scope"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentFAQTabController', AppointmentFAQTabController);


    function AppointmentFAQTabController(appointmentService, $scope) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        vm.content = null;
    
        function updateContent() {
            let step = parent_vm.accordion.selectedStep;

            if (!step) return;
            appointmentService.getFAQContent(step, parent_vm.appointment.location.id).then((response) => {
                vm.content = response;
            });
        }

        $scope.$on('stepChanged', (event, data) => {
            updateContent();
        });


        updateContent();
    }


})();

(function () {
    'use strict';

    AppointmentScheduleTransportationController.$inject = ["$scope", "$timeout", "$rootScope", "$filter", "$interval", "$q", "$sce", "APPOINTMENTSTATUS_LABELS", "APPOINTMENT_TRANSPORTATION_TYPE_GROUP", "APPOINTMENT_TRANSPORTATION_TYPE", "CONSTRAINT_REASON_CODES", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", "HERE_MAPS_CONFIG", "rcUtilService", "modalService", "ValidationService", "appointmentUtilService", "appointmentService", "SYSTEM_ENUMS", "promiseTimeService", "constraintService", "timeUtilService", "permissions"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentScheduleTransportationController', AppointmentScheduleTransportationController)
        .filter('distinct', () => {
            return function (arr, distinctProperty) {
                if (distinctProperty === false || arr === undefined || arr === null || !Array.isArray(arr)) {
                    // Shortcut to allow optional distinct filters
                    return arr;
                }

                let distinct = []; let index = -1;

                for (let i = 0; i < arr.length; i++) {
                    index = distinct.findIndex((o) => { return o[distinctProperty] == arr[i][distinctProperty]; });

                    if (index === -1) {
                        distinct.push(arr[i]);
                    }
                }

                return distinct;
            };
        });

    function AppointmentScheduleTransportationController($scope, $timeout, $rootScope, $filter, $interval, $q, $sce,
            APPOINTMENTSTATUS_LABELS, APPOINTMENT_TRANSPORTATION_TYPE_GROUP, APPOINTMENT_TRANSPORTATION_TYPE, CONSTRAINT_REASON_CODES, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE, HERE_MAPS_CONFIG, rcUtilService,
            modalService, ValidationService, appointmentUtilService, appointmentService, SYSTEM_ENUMS, promiseTimeService, constraintService, timeUtilService, permissions) {

        let vmSchedulePnl = this;
        let parent_vm = $scope.$parent.vm;
        let _steps = parent_vm.accordion.steps;
        let _slotsTimer;
        let _summaryMap = null;
        let _unavailableMGTimeslotsDict = {};
        let _nonOveridableReasonCodes = [CONSTRAINT_REASON_CODES.UnderCapacityDueToAdvisorOff, CONSTRAINT_REASON_CODES.UnderCapacityDueToAllAdvisorsOff];
        
        const AVAILSLOTS_DURATION = 600000;
        const NUMBER_OF_DAYS = 7;
        const MAP_MIN_HEIGHT = 150;
        const MAP_MAX_HEIGHT = 500;
        const MIN_TRIP_BOOKING_INTERVAL_MINUTES = 15;

        vmSchedulePnl.isAdminLevelUser = permissions.isAdminLevelUser();
        vmSchedulePnl.fakeInput = "";
        vmSchedulePnl.transTypeGroups = APPOINTMENT_TRANSPORTATION_TYPE_GROUP;
        vmSchedulePnl.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
        vmSchedulePnl.apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
        vmSchedulePnl.servicesVisible = true;
        vmSchedulePnl.mobileMapVisible = true;
        vmSchedulePnl.transmissions = SYSTEM_ENUMS.transmissions;
        vmSchedulePnl.today = moment(new Date()).format('YYYY-MM-DD');
        vmSchedulePnl.isPastAppt = false;
        vmSchedulePnl.displayAdvisor = false;
		vmSchedulePnl.initialLoad = true;
		vmSchedulePnl.userHasOverrideApptRuleRole = permissions.isOverrideApptCapacity() || vmSchedulePnl.isAdminLevelUser;
        vmSchedulePnl.canSelectAnyAdvisor = parent_vm.appointment.dealerDMSSystem !== vmSchedulePnl.dmsProviderTypes.Tekion;
        vmSchedulePnl.currentTooltipBlock = null;

        if (parent_vm.appointment.departmentId) {
            promiseTimeService.getDepartmentHours(parent_vm.appointment.location.id, parent_vm.appointment.departmentId, parent_vm.selectedDepartment).then((hours) => {
                vmSchedulePnl.deptHours = hours;

                if (parent_vm.appointment.promiseDateTime) {
                    let promiseDateTime = moment(parent_vm.appointment.promiseDateTime);

                    parent_vm.appointment.promiseDate = promiseDateTime;
                    let promiseTimeHours = promiseTimeService.generateHoursFromDate(promiseDateTime, parent_vm.appointment.apptDateTime, hours, parent_vm.selectedDepartment);
                    let time = promiseDateTime.format('hh:mm A');

                    promiseTimeService.setHours(promiseTimeHours, time);
                
                    vmSchedulePnl.promiseTimeHours = promiseTimeHours;
                    parent_vm.appointment.promiseTime = time;
                }
            });
        }

        if (!parent_vm.resolvedAppointmentId) {
            vmSchedulePnl.displayAdvisor = true;
        }

        vmSchedulePnl.options = {
            watchEnter: true,
            country: 'us,can'
        };

        parent_vm.appointment.pickupDropoff = "";

        vmSchedulePnl.pickupLocation = {
            formattedLocation: null,
            streetAddress: null,
            city: null,
            state: null,
            zip: null,
            county: null,
            countryShortCode: null,
            lat: null,
            lng: null
        };

        function adjustClosedColumn () {
            $timeout(() => {
                let tableEl = angular.element("#time-slots-table");

                if (tableEl && tableEl.length) {
                    let tableHeight = tableEl[0].offsetHeight - 10;

                    angular.element(document.getElementsByClassName("list-unstyled closed")).css('height', tableHeight + 'px');
                }
            }, 1);
        }

        vmSchedulePnl.apptIdIsValid = function (apptId) {
            return rcUtilService.isValidID(apptId);
        };

        vmSchedulePnl.removePipedData = function (apptId) {
            return appointmentUtilService.removePipedData(apptId);
        };

        vmSchedulePnl.calendarOptions = {
            calendarId: 'calendar1',
            date: parent_vm.appointment.apptDateTime ? moment(parent_vm.appointment.apptDateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            calendar: null,
            numberOfDays: NUMBER_OF_DAYS
        };

        vmSchedulePnl.getTransportationTypeLabel = function (data) {
            if (!data)  return '';
            let types = parent_vm.dealerTransportationTypes;
            let transportationType = (types || []).filter((type) => type.id === data);
            let strLabel = '';

            if (transportationType.length > 0) {
                strLabel = transportationType[0].dashboardDescription;
            }

            return strLabel;
        };

        vmSchedulePnl.pickupLocationUpdated = function (formattedAddress) {
            if (formattedAddress && formattedAddress.location && formattedAddress.location.lat) {
                let loc = formattedAddress.location;

                vmSchedulePnl.pickupLocation.name = loc.name !== loc.streetAddress ? loc.name : "Customer location";
                vmSchedulePnl.pickupLocation.city = loc.city;
                vmSchedulePnl.pickupLocation.state = loc.state;
                vmSchedulePnl.pickupLocation.zip = loc.zip;
                vmSchedulePnl.pickupLocation.countryShortCode = loc.countryShortCode,
                vmSchedulePnl.pickupLocation.streetAddress = loc.streetAddress;
                vmSchedulePnl.pickupLocation.lat = loc.lat;
                vmSchedulePnl.pickupLocation.lng = loc.lng;
                vmSchedulePnl.availTimeSlots = null;
                vmSchedulePnl.calendarOptionsChanged();
            }

            vmSchedulePnl.isInServiceArea(formattedAddress.location);
        };

        vmSchedulePnl.dateChanged = function (newValue, oldValue) {
            if (!vmSchedulePnl.calendarOptions.date._i || vmSchedulePnl.calendarOptions.date._i !== newValue._i) {
                vmSchedulePnl.calendarOptions.date = newValue._i;
                vmSchedulePnl.calendarOptionsChanged(true);
            } else {
                vmSchedulePnl.displayCalendar = false;
            }
        };

        function displayTripLocationsOnMap(data, map) {
            data.locationList.forEach((location) => {
                location.latLng = {lat: location.lat, lng: location.lng};
            });

            let stops = angular.copy(data.locationList);

            map.updateMap({stops: stops});
        }

        vmSchedulePnl.updateErrorCheckbox = function (error) {
            // Ensure that we actually have a list defined
            if (!vmSchedulePnl.confirmedErrors) {
                vmSchedulePnl.confirmedErrors = [];
            }

            if (error.isChecked) {
                vmSchedulePnl.confirmedErrors.push(error.code);
            } else {
                vmSchedulePnl.confirmedErrors.splice(vmSchedulePnl.confirmedErrors.indexOf(error.code));
            }

            parent_vm.disableNext = vmSchedulePnl.confirmedErrors.length < vmSchedulePnl.tripErrors.length;
            
            parent_vm.appointment.bypassValidation = !parent_vm.disableNext;

            
        };

        function hasUnresolvedErrors () {
            if (!vmSchedulePnl.tripErrors) {
                return false;
            }

            let tripErrors = vmSchedulePnl.tripErrors;
            let confirmedErrors = vmSchedulePnl.confirmedErrors;

            return !(tripErrors.length === (confirmedErrors === undefined ? 0 : confirmedErrors.length));
        }

        // get the pickup or mobile trip type instance
        function getTripType(tripType) {
            let allTripTypes = parent_vm.tripTypeInstances;
            let dealerTripType = allTripTypes.find((item) => item.systemTripTypeId === tripType && item.status === 1 && item.isDefault === false);

            if (!dealerTripType) {
                dealerTripType = allTripTypes.find((item) => item.systemTripTypeId === tripType && item.status === 1);
            }

            return dealerTripType;
        }

        function validateTrip() {
           
            vmSchedulePnl.userHasOverrideRuleRole = vmSchedulePnl.isAdminLevelUser === true || permissions.isOverrideTripRule() === true;
            let tripType = parent_vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.pickup ? SYSTEM_ENUMS.systemTripType.pickup : SYSTEM_ENUMS.systemTripType.mobileGarage;
            let dealerTripType = getTripType(tripType);
            let appt = parent_vm.appointment;
            let locId = appt.location.id;

            appointmentService.validateTrip(locId, appt, dealerTripType).then((result) => {
                if (result.errorMessages && result.errorMessages.length > 0) {
                    vmSchedulePnl.tripErrors = result.errorMessages;
                    parent_vm.disableNext = true;
                    appointmentService.getRules(locId, dealerTripType.systemTripTypeId, dealerTripType.id).then((rules) => {
                        vmSchedulePnl.bookingRules = rules;
                        parent_vm.nextBusy = false;
                    });
                } else {
                    parent_vm.nextBusy = false;
                }

                vmSchedulePnl.displayedTripLocations = {locationList: appointmentUtilService.getTripLocations(result)};
                displayTripLocationsOnMap(vmSchedulePnl.displayedTripLocations, _map);

                if (result.errors) {
                    console.log(result.errors);
                }
            });
        }

        vmSchedulePnl.timeSlotFilter = function (value) {
            if (!parent_vm.appointment.transportationType) return !!value.pickupTime;

            return isMGTimeSlotAvailable(value) && (!appointmentUtilService.isTripTypePickupOrMobile(parent_vm.appointment.transportationType) || !!value.pickupTime);
        };

        function isMGTimeSlotAvailable(block) {
            let startDateTime = null;

            if (block.appointmentDataList.length > 0) {
                let {firstHour} = promiseTimeService.getFirstAndLastHoursFromApptDataList(block.appointmentDataList);

                startDateTime = new Date(firstHour);
                // get out of unavailableMGTimeslotsDict blocking timeframe
                startDateTime.setSeconds(startDateTime.getSeconds() - 1);
            } else {
                startDateTime = new Date(block.blockTime);
            }

            if (_unavailableMGTimeslotsDict[startDateTime.toLocaleDateString()]) {
                let dayTimeFrames = _unavailableMGTimeslotsDict[startDateTime.toLocaleDateString()];
                let isUnavailable = dayTimeFrames.some(timeFrame => {
                    let endtime = new Date(timeFrame.endTime.getTime() + (vmSchedulePnl.mobileGarageBuffer * 60 * 1000));

                    return startDateTime >= timeFrame.startTime && startDateTime < endtime;
                });

                return !isUnavailable;
            }

            return true;
        }

        vmSchedulePnl.distinctBy = function () {
            return parent_vm.appointment.transportationType && appointmentUtilService.isTripTypePickupOrMobile(parent_vm.appointment.transportationType) ? 'pickupTime' : false;
        };

        vmSchedulePnl.isLoanerSelected = function () {
            if (parent_vm.appointment && parent_vm.appointment.transportationType) {
                switch (parent_vm.appointment.transportationType.dealerSystemTransportationTypeId) {
                    case APPOINTMENT_TRANSPORTATION_TYPE.dropOffLoaner:
                    case APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner:
                        return true;
                    default:
                        return false;
                }
            }

            return false;
        };

        vmSchedulePnl.isMGSelected = function () {
            if (parent_vm.appointment && parent_vm.appointment.transportationType) {
                return parent_vm.appointment.transportationType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage;
            }

            return false;
        };

        vmSchedulePnl.allSlotsNonOverridable = function (block) {
            return block.slots.every(slot => 
                slot.constraintReasonCodes.some(constraint => _nonOveridableReasonCodes.includes(constraint))
            );
        };


        function getUniqueReasonCodes(slot, isOverridable) {
            let reasonCodesText = [];
            let constraintsArray = slot.constraintReasonCodes.map((code, index) => ({
                code: code,
                text: slot.constraintReasonCodesText[index]
            }));

            constraintsArray.forEach((constraint) => {
                if (!reasonCodesText.includes(constraint.text) &&
                    (isOverridable ? !_nonOveridableReasonCodes.includes(constraint.code)
                                    : _nonOveridableReasonCodes.includes(constraint.code))) {
                    reasonCodesText.push(constraint.text);
                }
            });

            return reasonCodesText;
        }

        function getFirstOverridableSlot(block) {
            return block.slots.find(slot => 
                slot.constraintReasonCodes.every(constraint => 
                    !_nonOveridableReasonCodes.includes(constraint)
                )
            );
        }

        vmSchedulePnl.selectTimeSlot = function (block) {
            vmSchedulePnl.confirmedErrors = [];
            vmSchedulePnl.tripErrors = null;
            vmSchedulePnl.bookingRules = null;
            parent_vm.nextBusy = true;
            vmSchedulePnl.displayedTripLocations = null;
            let selectedTimeSlotPromise = $q.when(true); 
            let firstAvailableTimeSlot = null;

            if (block.unavailable) {
                firstAvailableTimeSlot = vmSchedulePnl.allSlotsNonOverridable(block) ? block.slots[0] : getFirstOverridableSlot(block);
                let uniqueOverridableReasonCodes = getUniqueReasonCodes(firstAvailableTimeSlot, true);
                let uniqueNonOverridableReasonCodes = getUniqueReasonCodes(firstAvailableTimeSlot, false);

                if (vmSchedulePnl.userHasOverrideApptRuleRole && !vmSchedulePnl.allSlotsNonOverridable(block)) {
                    selectedTimeSlotPromise = modalService.showYesNo('Override Appointment Time?', 'This time slot is unavailable for the following reasons: <br /><br />' + uniqueOverridableReasonCodes.join('<br />'), 'Choose Another Time', 'Override', true);
                } else {
                    parent_vm.nextBusy = false;
                    if (!vmSchedulePnl.userHasOverrideApptRuleRole) uniqueNonOverridableReasonCodes = uniqueNonOverridableReasonCodes.concat(uniqueOverridableReasonCodes);
                    modalService.showYesNo('Override Appointment Time?', 'This time slot is unavailable for the reason(s) below and cannot be overridden: <br /><br />' + uniqueNonOverridableReasonCodes.join('<br />'), null, 'OK');

                    return;
                }   
            } else {
                vmSchedulePnl.overriddenTimeSlot = null;
                vmSchedulePnl.overrideTimeSlot = false;
            }

            selectedTimeSlotPromise.then((confirmed) => {
                if (confirmed) { 
                    vmSchedulePnl.selectedTimeSlot = block;
                    parent_vm.appointment.selectedTimeSlot = block;
                    vmSchedulePnl.overrideTimeSlot = true;
                    
                    let isMobile = parent_vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.mobile;
                    let promiseTimeMeasurement = isMobile ? 'minutes' : 'days';
                    let tmpDuration = vmSchedulePnl.isLoanerSelected() ? parent_vm.appointment.lengthOfLoan : isMobile ? vmSchedulePnl.estLaborMinutes : parent_vm.bookingRules.promiseTimeDuration;
                    
                    let promiseTime = promiseTimeService.getPromiseTime(block.blockTime, tmpDuration, promiseTimeMeasurement, vmSchedulePnl.deptHours, parent_vm.selectedDepartment);
                    
                    
                    if (promiseTime) {
                        vmSchedulePnl.promiseDateChangedFromUi = false;
                        vmSchedulePnl.promiseTimeHours = promiseTime.hours;
                        parent_vm.appointment.promiseTime = promiseTime.promiseTime;
                        parent_vm.appointment.promiseDate = promiseTime.promiseDate;
                    }
                    
                    if (!firstAvailableTimeSlot) {
                        firstAvailableTimeSlot = appointmentUtilService.getFirstAvailableTimeSlot(block.slots);
                    } else {
                        vmSchedulePnl.overriddenTimeSlot = firstAvailableTimeSlot;
                    }

                    if (appointmentUtilService.isTripTypePickupOrMobile(parent_vm.appointment.transportationType)) {
                        // Apply our trip properties if a pickup and validate the booking now that we have a pickup time
                        if (firstAvailableTimeSlot.driverCustomerExpectedTimeUtc) {
                            parent_vm.appointment.tripPickupTime = moment.utc(firstAvailableTimeSlot.driverCustomerExpectedTimeUtc);
                            parent_vm.appointment.tripPickupTimeDisplay = moment.tz(firstAvailableTimeSlot.driverCustomerExpectedTimeUtc, vmSchedulePnl.availTimeSlots.timeZoneId).format('h:mm a');
                        }

                        parent_vm.appointment.tripPickupLocation = vmSchedulePnl.pickupLocation;
                        validateTrip();
                    } else {
                        parent_vm.nextBusy = false;
                    }
                } else {
                    vmSchedulePnl.overrideTimeSlot = false;
                    parent_vm.nextBusy = false;
                }
            });
        };

        function clearSlotsTimer() {
            if (angular.isDefined(_slotsTimer)) {
                $interval.cancel(_slotsTimer);
                _slotsTimer = undefined;
            }
        }

        function timeExpiredSlots () {
            modalService.showYesNo("Oops!", "Date and time availability must be refreshed.  Please click OK to refresh avail times and continue booking this appointment.", null, "OK").then((result) => {
                vmSchedulePnl.calendarOptionsChanged(true);
            });
        }

        vmSchedulePnl.departmentChanged = function () {
            parent_vm.showUpdateWarning(vmSchedulePnl);
            vmSchedulePnl.selectedAdvisor = null;
           
            parent_vm.departmentChanged(false).then(() => {
                selectInitialServiceAdvisor();
                updateDepartmentTransportationTypes();

                appointmentUtilService.setLastBookedDepartment(parent_vm.appointment.location.id, parent_vm.appointment.departmentId);

                if (parent_vm.appointment.departmentId) {
                    promiseTimeService.getDepartmentHours(parent_vm.appointment.location.id, parent_vm.appointment.departmentId, parent_vm.selectedDepartment).then((hours) => {
                        vmSchedulePnl.deptHours = hours;
                    });
                } else {
                    vmSchedulePnl.deptHours = [];
                }
            });
        };

        $scope.$on('defaultDepartmentLoaded', () => {
            if (parent_vm.appointment.departmentId) {
                promiseTimeService.getDepartmentHours(parent_vm.appointment.location.id, parent_vm.appointment.departmentId, parent_vm.selectedDepartment).then((hours) => {
                    vmSchedulePnl.deptHours = hours;
                });
            }
        });

        vmSchedulePnl.getColClass = function (idx) {
            return 'calendar-col-' + idx;
        };

        vmSchedulePnl.getLineItemsCodes = function(lineItems) {
            if (!lineItems || lineItems.length === 0) return 'N/A';

            return lineItems.map(item => item.opCode).join(', ');
        };

        vmSchedulePnl.getDisplayLineItemDescription = function(lineItem) {
            return appointmentUtilService.getDisplayLineItemDescription(lineItem);
        };

        vmSchedulePnl.getFirstLastHours = function(appointmentDataList) {
            return promiseTimeService.getFirstAndLastHoursFromApptDataList(appointmentDataList);
        };

        vmSchedulePnl.timeSlotHover = function(block) {
            if (!block.appointmentDataList || block.appointmentDataList.length === 0) {
                vmSchedulePnl.currentTooltipBlock = null;

                return null;
            }

            if (!block.tooltip || block.gettingTooltip) {
                vmSchedulePnl.currentTooltipBlock = block;
                getApptsToolTip(block);

                return vmSchedulePnl.loadingAppts;
            } else {
                vmSchedulePnl.currentTooltipBlock = block;
            }
        };

        function getApptsToolTip (block) {
            if (block.tooltip) {
                return block.tooltip;
            } else {
                $timeout(() => {
                    if (!block.gettingTooltip && !block.tooltip) {
                        block.gettingTooltip = true;
                        let appointmentPromises = block.appointmentDataList.map(({appointmentId}) => appointmentService.getAppointment(parent_vm.appointment.location.id, appointmentId));

                        Promise.all(appointmentPromises).then((result) => {
                            let sortedResult = result.slice().sort((a, b) => {
                                return new Date(a.apptDateTime) - new Date(b.apptDateTime);
                            });
                            
                            block.tooltip = {
                                appointments: sortedResult
                            };

                            block.gettingTooltip = false;
                        }, (errorResponse) => {
                            block.gettingTooltip = false;
                        });
                    }
                }, 250);

                return "Loading Services ...";
            }
        }

        vmSchedulePnl.getMGApptTimeSlotHeight = function (block) {
            if (block.timeslotHeight) return block.timeslotHeight;

            let appts = block.appointmentDataList;
            let intervals = 0;
            
            if (appts.length > 0) {
                let {firstHour, lastHour} = promiseTimeService.getFirstAndLastHoursFromApptDataList(appts);
                let deptIntervalMinutes = timeUtilService.getTotalMinutes(parent_vm.selectedDepartment.appointmentDuration);
                let apptInterval = deptIntervalMinutes > MIN_TRIP_BOOKING_INTERVAL_MINUTES ? deptIntervalMinutes : MIN_TRIP_BOOKING_INTERVAL_MINUTES;
                let firstDateTime = new Date(firstHour);
                let lastDateTime = new Date(lastHour);
                let firstTime = firstDateTime ? (firstDateTime.getHours() * 60) + firstDateTime.getMinutes() : 0;
                let lastTime = lastDateTime ? (lastDateTime.getHours() * 60) + lastDateTime.getMinutes() : 0;

                intervals = Math.floor((lastTime - firstTime) / apptInterval);
                addUnavailableMGTimeSlot(firstDateTime, lastDateTime);
            }

            let height = (1 + intervals) * 27.7031;

            block.timeslotHeight = height + 'px';

            return height + 'px';
        };

        function addUnavailableMGTimeSlot(startTime, endTime) {
            let date = startTime.toLocaleDateString();

            if (!_unavailableMGTimeslotsDict[date]) {
                _unavailableMGTimeslotsDict[date] = [];
            }

            let isExistingTimeSlot = _unavailableMGTimeslotsDict[date].some(slot => 
                slot.startTime.getTime() === startTime.getTime() && slot.endTime.getTime() === endTime.getTime()
            );

            if (!isExistingTimeSlot) _unavailableMGTimeslotsDict[date].push({startTime, endTime});
        }

        vmSchedulePnl.calendarOptionsChanged = function (ignoreUpdateWarning = false) {
            parent_vm.showUpdateWarning(vmSchedulePnl, ignoreUpdateWarning);
            
            clearSlotsTimer();
            _unavailableMGTimeslotsDict = {};
            vmSchedulePnl.displayedTripLocations = null;
            vmSchedulePnl.tripErrors = null;
            vmSchedulePnl.confirmedErrors = [];
            vmSchedulePnl.availTimeSlots = null;
            parent_vm.appointment.bypassValidation = false;
            parent_vm.disableNext = true;
            vmSchedulePnl.errorRetrievingSlots = false;
            vmSchedulePnl.selectedTimeSlot = null;
            parent_vm.appointment.selectedTimeSlot = null;
            vmSchedulePnl.overrideTimeSlot = false;
            vmSchedulePnl.setMapLocation(_map, parent_vm.appointment.location);
            
            let loc = parent_vm.appointment.location;
            let pickup = vmSchedulePnl.pickupLocation.formattedLocation ? vmSchedulePnl.pickupLocation : null;
            let pickupDropoff = parent_vm.appointment.pickupDropoff.toLowerCase();
            let missingPickupFields = !pickup || !vmSchedulePnl.selectedTransmission || vmSchedulePnl.selectedTransmission === null;
            const promises = [];
            let mgBufferPromise = null;

            if (!parent_vm.appointment.transportationType || 
                !parent_vm.appointment.departmentId ||
                (pickupDropoff === vmSchedulePnl.transTypeGroups.pickup && missingPickupFields) ||
                (pickupDropoff === vmSchedulePnl.transTypeGroups.mobile && !pickup)) {
                    return;
            }

            if (vmSchedulePnl.isMGSelected()) {

                vmSchedulePnl.estLaborMinutes = parent_vm.appointment.lineItems.filter(item => item.checked).reduce((sum, item) => {
                    return sum + (item.laborHours * 60 || 0);
                }, 0);

                if (!vmSchedulePnl.mobileGarageBuffer && !vmSchedulePnl.fetchingConstraints) {
                    vmSchedulePnl.fetchingConstraints = true;

                    if (parent_vm.editingExistingAppointment && !parent_vm.needsScheduleTransportationUpdate) {
                        // get previous buffer when editing appt
                        let deltaMilliseconds = moment(parent_vm.appointment.apptDateTime).diff(moment(parent_vm.appointment.tripPickupTime));
                        
                        vmSchedulePnl.mobileGarageBuffer = deltaMilliseconds / (1000 * 60);
                        vmSchedulePnl.fetchingConstraints = false;
                    } else {
                        mgBufferPromise = constraintService.getConstraintsByType(parent_vm.appointment.location.id, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointmentBuffer).then((response) => {
                            let bufferTime = (response || []).find((item) => {
                                                                            return item.constraintDataParsed.TransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage &&
                                                                                    item.departmentId === parent_vm.appointment.departmentId;
                                                                        })?.constraintDataParsed?.BufferHours ?? null;

                            if (bufferTime && bufferTime > 0) vmSchedulePnl.mobileGarageBuffer = bufferTime;

                        }).finally(() => {
                            vmSchedulePnl.fetchingConstraints = false;
                        });

                        promises.push(mgBufferPromise);
                    }
                }
            }
            
            Promise.all(promises).then(() => {
                if (vmSchedulePnl.isMGSelected() && (!vmSchedulePnl.mobileGarageBuffer || vmSchedulePnl.mobileGarageBuffer === 0)) {
                    return;
                }
                
                if (vmSchedulePnl.isLoanerSelected() && !parent_vm.appointment.lengthOfLoan) {
                    parent_vm.appointment.lengthOfLoan = parent_vm.bookingRules.promiseTimeDuration;
                }

                parent_vm.nextBusy = true;
                vmSchedulePnl.gettingSlots = true;

                appointmentService.getAvailability(loc.id,
                    parent_vm.appointment.id,
                    moment.utc(vmSchedulePnl.calendarOptions.date),
                    null,
                    parent_vm.appointment.departmentId,
                    vmSchedulePnl.selectedAdvisor || null,
                    parent_vm.appointment.transportationType || null,
                    pickup,
                    parent_vm.appointment.lineItems.map((item) => { return item.opCode; }),
                    parent_vm.appointment.lengthOfLoan,
                    parent_vm.appointment.tripDriver || null,
                    vmSchedulePnl.mobileGarageBuffer || 0).then((result) => {
                    if (!result) {
                        vmSchedulePnl.errorRetrievingSlots = true;
                        parent_vm.disableNext = true;
                        vmSchedulePnl.availTimeSlots = null;
                        vmSchedulePnl.availabilityErrors = ['An error occurred retrieving availability'];
                    } else {
                        parent_vm.disableNext = false;
                        vmSchedulePnl.availabilityErrors = null;
                        vmSchedulePnl.availTimeSlots = result;
                        selectExistingAppointmentTime();
                    }

                    parent_vm.nextBusy = false;
                    vmSchedulePnl.gettingSlots = false;
                    adjustClosedColumn();

                    if (!_slotsTimer) {
                        _slotsTimer = $interval(() => {
                            clearSlotsTimer();
                            timeExpiredSlots();
                        }, AVAILSLOTS_DURATION);
                    }
                });
            });
        };

        vmSchedulePnl.mgBufferChanged = function (oldVal, newVal) {
            if (isNaN(newVal) || newVal < 1) {
                vmSchedulePnl.mobileGarageBuffer = (oldVal && parseInt(oldVal)) || null;

                return;
            }

            vmSchedulePnl.calendarOptionsChanged();
        };

        vmSchedulePnl.mobileTechChanged = function () {
            _unavailableMGTimeslotsDict = {};
            vmSchedulePnl.calendarOptionsChanged();
        };

        vmSchedulePnl.lengthOfLoanChanged = function (oldVal, newVal) {
            if (!isNaN(newVal) && newVal < 1) {
                parent_vm.appointment.lengthOfLoan = (oldVal && parseInt(oldVal)) || null;

                return;
            }

            if (parent_vm.appointment.selectedTimeSlot) {
                modalService.showYesNo('Refresh Loaner Availability?', 'Changing Estimated Return will recalculate availability, and the selected time may no longer be available.  Are you sure you want to do this?', 'No', 'Yes', true, false).then(result => {
                    if (!result) {
                        parent_vm.appointment.lengthOfLoan = (oldVal && parseInt(oldVal)) || null;

                        return;
                    }
                    
                    parent_vm.appointment.selectedTimeSlot = null;
                    vmSchedulePnl.calendarOptionsChanged();
                });
            } else {
                vmSchedulePnl.calendarOptionsChanged();
            }
        };

        vmSchedulePnl.pickupDropoffSelected = function () {
            if (parent_vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.mobile) {
                parent_vm.appointment.transportationType = vmSchedulePnl.mobileTransportationTypes[0];
            } else {
                parent_vm.appointment.transportationType = null;
            }

            if (parent_vm.appointment.transportationType?.isMobileGarage) {
                parent_vm.getMobileTechs();
            }

            vmSchedulePnl.calendarOptionsChanged();
        };

        vmSchedulePnl.transportationName = function () {
            return parent_vm.appointment.pickupDropoff == vmSchedulePnl.transTypeGroups.mobile ? 'SERVICE LOCATION' : 'PICK UP LOCATION';
        };

        vmSchedulePnl.transportationTypeSelected = function () {
            vmSchedulePnl.calendarOptionsChanged();
        };

        vmSchedulePnl.transmissionTypeSelected = function () {
            parent_vm.appointment.isManual = vmSchedulePnl.selectedTransmission.value;
            vmSchedulePnl.calendarOptionsChanged();
        };

        vmSchedulePnl.validation = {
            isValidDepartment: function () {
                return appointmentUtilService.validateDepartment(parent_vm.dealerDepartments, parent_vm.appointment.departmentId);
            }
        };

        vmSchedulePnl.getDepartmentName = function () {
            let dept = parent_vm.getAppointmentDepartment(parent_vm.appointment.departmentId);

            if (dept) {
                return dept.name;
            } else {
                return "";
            }
        };

        vmSchedulePnl.disableNextBtn = function () {
            if (!parent_vm.appointment.transportationType || 
                !vmSchedulePnl.calendarOptions.calendarId) {
                return true;
            }

            if (parent_vm.appointment.transportationType && 
                parent_vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.pickup) {
                if (!vmSchedulePnl.selectedTimeSlot || 
                    !vmSchedulePnl.pickupLocation.formattedLocation) {
                    return true;
                }
            } else {
                if (!vmSchedulePnl.selectedTimeSlot) {
                    return true;
                }
            }

            return hasUnresolvedErrors();
        };

        vmSchedulePnl.nextClicked = function () {
            let myValidation = new ValidationService();

            if (!myValidation.checkFormValidity($scope.bookApptForm) || !vmSchedulePnl.selectedTimeSlot) {
                vmSchedulePnl.submitted = true;

                return false;
            }

            let timeSlotAdvisor;

            if (!vmSchedulePnl.selectedAdvisor) {
                parent_vm.appointment.advisor = null;
                parent_vm.appointment.dealerEmployeeId = null;
                parent_vm.appointment.serviceAdvisorNumber = null;
                
            } else {
                timeSlotAdvisor = vmSchedulePnl.selectedTimeSlot.slots.find((slot) => slot.advisorId === vmSchedulePnl.selectedAdvisor.id);

                if (!timeSlotAdvisor && vmSchedulePnl.overriddenTimeSlot) {
                    timeSlotAdvisor = vmSchedulePnl.overriddenTimeSlot;
                    parent_vm.appointment.dealerEmployeeId = timeSlotAdvisor.advisorId;
                    parent_vm.appointment.serviceAdvisorNumber = timeSlotAdvisor.advisorNumber;
                } else {
                    parent_vm.appointment.dealerEmployeeId = vmSchedulePnl.selectedAdvisor.id;
                    parent_vm.appointment.serviceAdvisorNumber = vmSchedulePnl.selectedAdvisor.employeeNumber;
                    parent_vm.appointment.dealerEmployeeFirstName = vmSchedulePnl.selectedAdvisor.firstName;
                    parent_vm.appointment.dealerEmployeeLastName = vmSchedulePnl.selectedAdvisor.lastName;
                    parent_vm.appointment.dealerEmployeeOfficePhone = vmSchedulePnl.selectedAdvisor.officePhone;
                }
            }

            let promiseDate = parent_vm.appointment.promiseDate.format('MM/DD/YYYY');

            parent_vm.appointment.promiseDateTime = moment(`${promiseDate} ${parent_vm.appointment.promiseTime}`, 'MM/DD/YYYY hh:mm A').format('MM/DD/YYYY HH:mm');

            parent_vm.appointment.apptDateTime = vmSchedulePnl.selectedTimeSlot.blockTime;

            if (appointmentUtilService.isTripTypePickupOrMobile(parent_vm.appointment.transportationType)) {
                if (!timeSlotAdvisor) {
                    timeSlotAdvisor = vmSchedulePnl.selectedTimeSlot.slots[0];
                }

                parent_vm.appointment.tripPickupTime = moment.utc(timeSlotAdvisor.driverCustomerExpectedTimeUtc);
                parent_vm.appointment.tripPickupTimeDisplay = moment.tz(timeSlotAdvisor.driverCustomerExpectedTimeUtc, vmSchedulePnl.availTimeSlots.timeZoneId).format('h:mm a');
                parent_vm.appointment.tripPickupLocation = vmSchedulePnl.pickupLocation;
                parent_vm.appointment.tripCustomer = {
                    firstName: parent_vm.appointment.customerFirstName,
                    lastName: parent_vm.appointment.customerLastName,
                    companyName: parent_vm.appointment.customerCompany,
                    phoneNumber: parent_vm.appointment.customerPhone,
                    email: parent_vm.appointment.customerEmail
                };
            } else {
                parent_vm.appointment.tripPickupTime = null;
                parent_vm.appointment.tripPickupLocation = null;
                parent_vm.appointment.tripCustomer = null;
                parent_vm.appointment.tripStops = null;
            }
            
            parent_vm.appointment.notes = vmSchedulePnl.tripNote;
            parent_vm.appointment.dealerTransportationTypeId = parent_vm.appointment.transportationType.id;
            let bypassValidation = parent_vm.appointment.bypassValidation;
            let tempSelectedDriver = parent_vm.appointment.tripDriver;

            if (parent_vm.appointment.appointmentStatus === parent_vm.getStatus(APPOINTMENTSTATUS_LABELS.draft)) {
                parent_vm.nextBusy = true;
                appointmentService.createOrUpdateAppointment(parent_vm.appointment.location.id, parent_vm.appointment, false).then((result) => {
                    parent_vm.nextBusy = false;

                    if (result && !result.errors && !result.dmsSyncError) {
                        // We need to merge the resulting object back to our UI
                        parent_vm.loadAppointment(result);
                        parent_vm.appointment.overrideTimeSlot = vmSchedulePnl.overrideTimeSlot;
                        parent_vm.appointment.bypassValidation = bypassValidation;
                        parent_vm.appointment.tripDriver = tempSelectedDriver;
                        vmSchedulePnl.loadSummaryPanel();
                    } else if (result && result.dmsSyncError) {
                        let alert = $q.when();

                        alert = modalService.showDetailedErrorDlg(result.dmsSyncError, true);
                        alert.then(() => {
                            parent_vm.loadAppointment(result);
                            parent_vm.appointment.overrideTimeSlot = vmSchedulePnl.overrideTimeSlot;
                            parent_vm.appointment.bypassValidation = bypassValidation;
                            vmSchedulePnl.loadSummaryPanel();
                        });
                    } else {
                        if (result.errors && result.errors.length > 0) {
                            modalService.showDetailedErrorDlg(result.errors.join(". "));
                        } else {
                            modalService.showGenericApptError();
                        }
                    }
                });
            } else {
                // we need to see if they didn't select a new time.. and if not validate the trip first
                // PROD-9581
                if (parent_vm.requiresCapacityValidation(true) && vmSchedulePnl.overrideTimeSlot !== true) {
                    appointmentService.validateCapacity(parent_vm.appointment.location.id, parent_vm.appointment).then((result) => {
                        parent_vm.nextBusy = false;

                        if (result.errors) {
                            modalService.showYesNo('Override Appointment Time?', 
                            'This time slot is unavailable for the following reasons: <br /><br />' + result.errors.join('<br />'),
                            'Choose Another Time', 'Override', true).then((userChoice) => {
                                if (userChoice) {
                                    vmSchedulePnl.overrideTimeSlot = true;
                                    parent_vm.appointment.overrideTimeSlot = vmSchedulePnl.overrideTimeSlot;
                                    vmSchedulePnl.loadSummaryPanel();
                                }
                            });
                        } else {
                            vmSchedulePnl.loadSummaryPanel();
                        }
                    });
                } else {
					parent_vm.appointment.overrideTimeSlot = vmSchedulePnl.overrideTimeSlot;
                    parent_vm.appointment.bypassValidation = bypassValidation;
                    vmSchedulePnl.loadSummaryPanel();
                }
            }
        };

        vmSchedulePnl.getApptStatusLabel = function () {
            return appointmentService.getAppointmentStatusLabel(parent_vm.appointment, parent_vm.appointmentStatuses);
        };

        vmSchedulePnl.loadSummaryPanel = function () {
            $timeout(() => {
                // need timeout so the step getting changed doesn't cause
                // next to get fired in the following step as well.
                parent_vm.accordion.selectedStep = _steps.summary;
                $rootScope.$broadcast('stepChanged');
            }, 1);
        };

        vmSchedulePnl.clearTransportation = function () {
            vmSchedulePnl.pickupLocation = {
                formattedLocation: null,
                address1: null,
                city: null,
                state: null,
                zipCode: null,
                county: null,
                lat: null,
                lng: null
            };

            vmSchedulePnl.calendarOptions = {
                calendarId: 'calendar1',
                date: parent_vm.appointment.apptDateTime ? moment(parent_vm.appointment.apptDateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                calendar: null,
                numberOfDays: NUMBER_OF_DAYS
            };

            parent_vm.accordion.selectedStep = _steps.scheduleTransportation;
            $rootScope.$broadcast('stepChanged');
        };

        function selectExistingAppointmentTime () {
            let apptDate = parent_vm.appointment.apptDateTime;
            let startDate = moment(apptDate).format('YYYY-MM-DD');
            let date = vmSchedulePnl.availTimeSlots.days.find((x) => { return x.day.startsWith(startDate); });

            if (date && date.timeSlotBlocks.length > 0) {
                let block = date.timeSlotBlocks.find((x) => {
                    return x.blockTime === apptDate; 
                });
                
                if ((block && block.unavailable === false) || 
                    (parent_vm.editingExistingAppointment && vmSchedulePnl.initialLoad) ||
                    (parent_vm.editingExistingAppointment && !parent_vm.needsScheduleTransportationUpdate)) {
                    vmSchedulePnl.selectedTimeSlot = block;
                    parent_vm.appointment.selectedTimeSlot = block;
                } else {
                    vmSchedulePnl.selectedTimeSlot = null;
                    parent_vm.appointment.selectedTimeSlot = null;
                }
            }

            // is the appointment one from the past?
            if (moment.tz(apptDate, vmSchedulePnl.availTimeSlots.timeZoneId).isBefore(moment.tz(vmSchedulePnl.availTimeSlots.timeZoneId))) {
                vmSchedulePnl.isPastAppt = true;
            }

            vmSchedulePnl.initialLoad = false;
        }

        vmSchedulePnl.showAppointmentStatus = function () {
            return appointmentService.showAppointmentStatus(parent_vm.appointment.pickupDropoff, vmSchedulePnl.getApptStatusLabel().toUpperCase());
        };

        vmSchedulePnl.resizeMap = function (maximize) {
            let mapHeight = maximize === true ? MAP_MAX_HEIGHT : MAP_MIN_HEIGHT;
            let resizerTop = mapHeight + 15;
            let mapHeightProp = mapHeight + 'px';
            
            $timeout(() => {
                angular.element('#appt-map-addedit').css('height', mapHeightProp);
                angular.element('#appt-map-addedit-map').css('height', mapHeightProp);
                angular.element('#resizer').css('top', resizerTop + 'px');

                if (_map) {
                    _map.setMapSizes(mapHeightProp, null);
                }
            }, 250);
            
        };

        function selectInitialServiceAdvisor() {
            let appt = parent_vm.appointment;
            let advisors = parent_vm.serviceAdvisors;
            let advisor = null;

            if (appt && advisors && appt.dealerEmployeeId) {
                advisor = advisors.filter((item) => item.id === appt.dealerEmployeeId);
            }

            if (!appt.dealerEmployeeId && parent_vm.lastServiceAdvisor && parent_vm.defaultToPreviousAdvisor === true) {
                advisor = (advisors || []).filter((item) => item.id === parent_vm.lastServiceAdvisor.id);
            }

            if (advisor?.length) {
                vmSchedulePnl.selectedAdvisor = advisor[0];
            } else {
                vmSchedulePnl.selectedAdvisor = null;
            }

            vmSchedulePnl.displayAdvisor = true;

        }

        function updateDepartmentTransportationTypes () {
            if (parent_vm.appointment.departmentId) {
                let allTransportationTypes = parent_vm.dealerTransportationTypes;
                let currPickupDropoff = parent_vm.appointment.pickupDropoff;
                let currTransportationType = parent_vm.appointment.transportationType;
                let currSystemTransportationTypeId = currTransportationType ? currTransportationType.dealerSystemTransportationTypeId : null;

                parent_vm.dealerDepartmentTransportationTypes = (allTransportationTypes || []).filter((type) => type.dealerDepartmentId === parent_vm.appointment.departmentId);

                // check to see if the main pick up has 'showInConsumer' turned off, if this is the case, all pick ups
                // should be turned off for department we're looking at
                let pickupWithLoaner = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner);

                if (pickupWithLoaner.length > 0) {
                    if (pickupWithLoaner[0].showInDashboard === false) {
                        vmSchedulePnl.pickUpTransportationTypes = [];
                    } else {
                        vmSchedulePnl.pickUpTransportationTypes = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.isPickup === true && type.showInDashboard === true);
                    }
                }
                
                // check to see if the main drop off has 'showInConsumer' turned off, if this is the case, all drop offs
                // should be turned off for department we're looking at
                let dropOffOwnTransportation = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.dropOff);

                if (dropOffOwnTransportation.length > 0) {
                    if (dropOffOwnTransportation[0].showInDashboard === false) {
                        vmSchedulePnl.dropOffTransportationTypes = [];
                    } else {
                        vmSchedulePnl.dropOffTransportationTypes = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.isDropOff === true && type.showInDashboard === true);
                    }
                }

                if (dealerHasMobileGarage()) {
                    let mobileGarage = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage);

                    if (mobileGarage.length > 0 && mobileGarage[0].showInDashboard === true) {
                        vmSchedulePnl.mobileTransportationTypes = mobileGarage;
                    } else {
                        vmSchedulePnl.mobileTransportationTypes = [];
                    }
                }
                
                
                // find the loaner pick up an see if show in dashboard is turned off.. because JS did this a bit weird in the admin screen, and 
                // we need to force drop offs to be hidden as well
                let pickupLoanerOption = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.isPickup === true && type.hasLoaner === true);

                if (pickupLoanerOption.length > 0 && pickupLoanerOption[0].showInDashboard === false) {
                    let dropOffLoanerOption = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.isDropOff === true && type.hasLoaner === true);

                    if (dropOffLoanerOption.length > 0) {
                        if (dropOffLoanerOption[0].id !== parent_vm.appointment.dealerTransportationTypeId) {
                            dropOffLoanerOption[0].showInDashboard = false;
                        }
                    }
                }

                let bFound = false;

                // can we set the transportation type back to what it was for the last selected department?
                if (currPickupDropoff) {
                    if (currPickupDropoff === vmSchedulePnl.transTypeGroups.dropoff) {
                        if (vmSchedulePnl.dropOffTransportationTypes && vmSchedulePnl.dropOffTransportationTypes.length > 0) {
                            bFound = true;
                        }
                    } else if (currPickupDropoff === vmSchedulePnl.transTypeGroups.pickup) {
                        if (vmSchedulePnl.pickUpTransportationTypes && vmSchedulePnl.dropOffTransportationTypes.length > 0) {
                            bFound = true;
                        }
                    } else if (currPickupDropoff === vmSchedulePnl.transTypeGroups.mobile) {
                        if (vmSchedulePnl.mobileTransportationTypes && vmSchedulePnl.mobileTransportationTypes.length > 0) {
                            bFound = true;
                        }
                    }
                } 
                
                if (bFound === true) {
                    parent_vm.appointment.pickupDropoff = currPickupDropoff;

                    if (currSystemTransportationTypeId) {
                        // the transporation type they previously had selected exists in this dept
                        // select it again 
                        let deptTransportationType = (parent_vm.dealerDepartmentTransportationTypes || []).filter((type) => type.dealerSystemTransportationTypeId === currSystemTransportationTypeId);

                        if (deptTransportationType.length > 0) {
                            parent_vm.appointment.transportationType = deptTransportationType[0];
                        }
                    }
                } else if (vmSchedulePnl.dropOffTransportationTypes.length !== 0) {
                    parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.dropoff;
                    parent_vm.appointment.transportationType = null;
                } else if (vmSchedulePnl.pickUpTransportationTypes.length !== 0) {
                    parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.pickup;
                    parent_vm.appointment.transportationType = null;
                } else if (vmSchedulePnl.mobileTransportationTypes.length !== 0) {
                    parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.mobile;
                    parent_vm.appointment.transportationType = vmSchedulePnl.mobileTransportationTypes[0];
                }
     
            } else {
                parent_vm.dealerDepartmentTransportationTypes = null;
            }

            vmSchedulePnl.calendarOptionsChanged();
        }

        function dealerHasMobileGarage () { 
            let mobileGarageTT = (parent_vm.tripTypeInstances || []).filter((tripType) => tripType.systemTripTypeId === SYSTEM_ENUMS.systemTripType.mobileGarage && tripType.isDefault === true);

            if (mobileGarageTT.length > 0) {
                return true;
            } else {
                return false;
            }
        }

        function initPanel() {
            
            let allTransportationTypes = parent_vm.dealerTransportationTypes;
            let deptId = parent_vm.appointment.departmentId;
            let rideShareCreditTripTypeInstance = parent_vm.tripTypeInstances.find((tripType) => tripType.systemTripTypeId === SYSTEM_ENUMS.systemTripType.lyftCredit && tripType.status === 1);
            let hasRideshareCredits = false;

            if (rideShareCreditTripTypeInstance) {
                hasRideshareCredits = true;
            }

            if (!hasRideshareCredits) {
                let rideShareCreditTransType = (allTransportationTypes || []).filter((type) => type.dealerSystemTransportationTypeId === vmSchedulePnl.apptTransportationTypes.rideshareCredits && type.dealerDepartmentId === deptId);

                if (rideShareCreditTransType.length > 0) {
                    rideShareCreditTransType[0].showInDashboard = false;
                }
            }

            if (parent_vm.editingExistingAppointment) {
                let transporationId = parent_vm.appointment.dealerTransportationTypeId;

                if (transporationId) {
                    let tempTransportationType = (allTransportationTypes || []).find((type) => type.id === transporationId);

                    if (tempTransportationType) {
                        tempTransportationType.showInDashboard = true;
                    }
                }
            }
            
            updateDepartmentTransportationTypes();
            
            // find the loaner pick up an see if show in dashboard is turned off.. because JS did this a bit weird in the admin screen, and 
            // we need to force drop offs to be hidden as well
            let pickupLoanerOption = (vmSchedulePnl.pickUpTransportationTypes || []).filter((type) => type.isPickup === true && type.hasLoaner === true);

            if (pickupLoanerOption.length > 0 && pickupLoanerOption[0].showInDashboard === false) {
                let dropOffLoanerOption = (vmSchedulePnl.dropOffTransportationTypes || []).filter((type) => type.isDropOff === true && type.hasLoaner === true);

                if (dropOffLoanerOption.length > 0) {
                    if (dropOffLoanerOption[0].id !== parent_vm.appointment.dealerTransportationTypeId) {
                        dropOffLoanerOption[0].showInDashboard = false;
                    }
                }
            }

            if (vmSchedulePnl.dropOffTransportationTypes.length !== 0) {
                parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.dropoff;
            } else if (vmSchedulePnl.pickUpTransportationTypes.length !== 0) {
                parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.pickup;
            }

            if (parent_vm.editingExistingAppointment) {
                let transId = parent_vm.appointment.dealerTransportationTypeId;
                let pickupLoc = parent_vm.appointment.tripPickupLocation;

                if (transId) {
                    parent_vm.appointment.transportationType = (allTransportationTypes || []).find((type) => type.id === transId);
                    parent_vm.appointment.pickupDropoff = parent_vm.appointment.transportationType.isPickup ? vmSchedulePnl.transTypeGroups.pickup : parent_vm.appointment.transportationType.isMobileGarage ? vmSchedulePnl.transTypeGroups.mobile : vmSchedulePnl.transTypeGroups.dropoff;
                }

                if (parent_vm.appointment.transportationType && appointmentUtilService.isTripTypePickupOrMobile(parent_vm.appointment.transportationType)) {

                    vmSchedulePnl.selectedTransmission = parent_vm.appointment.isManual ? SYSTEM_ENUMS.transmissions[1] : SYSTEM_ENUMS.transmissions[0];

                    if (pickupLoc) {
                        vmSchedulePnl.pickupLocation = {
                            formattedLocation: pickupLoc.streetAddress + ' ' + pickupLoc.city + ' ' + pickupLoc.state + ' ' + pickupLoc.zip,
                            name: pickupLoc.name,
                            streetAddress: pickupLoc.streetAddress,
                            city: pickupLoc.city,
                            state: pickupLoc.state,
                            zip: pickupLoc.zip,
                            countryShortCode: pickupLoc.countryShortCode,
                            county: null,
                            lat: pickupLoc.lat,
                            lng: pickupLoc.lng
                        };
                    }
                }

            } else {
                // default is a drop off
                let defaultDropOff = (vmSchedulePnl.dropOffTransportationTypes || []).filter((type) => type.isDefault === true);

                if (defaultDropOff.length > 0) {
                    defaultDropOff = defaultDropOff[0];
                } else {
                    defaultDropOff = vmSchedulePnl.dropOffTransportationTypes[0];
                }

                if (defaultDropOff) {
                    parent_vm.appointment.transportationType = defaultDropOff;
                } else if (vmSchedulePnl.mobileTransportationTypes.length !== 0) {
                    parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.mobile;
                    parent_vm.appointment.transportationType = vmSchedulePnl.mobileTransportationTypes[0];
                } else if (vmSchedulePnl.pickUpTransportationTypes.length !== 0) {
                    parent_vm.appointment.pickupDropoff = vmSchedulePnl.transTypeGroups.pickup;
                    parent_vm.appointment.transportationType = vmSchedulePnl.pickUpTransportationTypes[0];
                }
            }

            if (!parent_vm.mobileTechs && parent_vm.appointment.transportationType?.isMobileGarage) {
                parent_vm.getMobileTechs();
            }

            selectInitialServiceAdvisor();
            vmSchedulePnl.calendarOptionsChanged();
        }

        $scope.$on('apptBackClicked', (event, data) => {
            parent_vm.disableNext = false;
            vmSchedulePnl.initialLoad = true;

            if (parent_vm.accordion.selectedStep === _steps.scheduleTransportation) {
                clearSlotsTimer();
                vmSchedulePnl.submitted = false;
                vmSchedulePnl.calendarOptions = {
                    calendarId: 'calendar1',
                    date: parent_vm.appointment.apptDateTime ? moment(parent_vm.appointment.apptDateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                    calendar: null,
                    numberOfDays: NUMBER_OF_DAYS
                };
                parent_vm.accordion.selectedStep = _steps.customerVehicle;
                $rootScope.$broadcast('stepChanged');
            } else if (parent_vm.accordion.selectedStep === _steps.summary) {
                $timeout(() => {
                    vmSchedulePnl.overrideTimeSlot = parent_vm.appointment.overrideTimeSlot;
                }, 1);
            }
        });

        $scope.$on('apptNextClicked', (event, data) => {
            if (parent_vm.accordion.selectedStep === _steps.scheduleTransportation) {
                clearSlotsTimer();
                vmSchedulePnl.nextClicked();
            }
        });


        $scope.$on('serviceAdvisorsLoaded', (event, data) => {
            selectInitialServiceAdvisor();          
        });

        /**
          * fires when this step is loaded, a vin will be selected from previous step
          */
        $scope.$on('loadScheduleTransportation', (event, data) => {
            let dealerLoc = parent_vm.appointment.location;

            vmSchedulePnl.options.startLat = parseFloat(dealerLoc.lat);
            vmSchedulePnl.options.startLng = parseFloat(dealerLoc.lng);

            $timeout(() => {
                initPanel();
            }, 50);
        });

        // detach when controller removed.
        $scope.$on('$destroy', (event, next, current) => {
            clearSlotsTimer();
        });

        // here maps stuff
        vmSchedulePnl.mapOptions = {
            showSegmentOverlay: false,
            fillHeight: false,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: false,
            showControls: false,
            disableLiveTracking: true,
            height: '150px'
        };

        vmSchedulePnl.summaryMapOptions = {
            showSegmentOverlay: false,
            fillHeight: false,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: false,
            showControls: false,
            disableLiveTracking: true,
            height: '200px'
        };

        vmSchedulePnl.setMapLocation = function (map, location, stopType) {
            // this prevents the map from showing the dealer location over the resolved routes
            if (!map /*|| (resolvedTrip && resolvedTrip.id)*/) return;

            location.stopType = stopType || SYSTEM_ENUMS.destinationType.dealer;
            location.latLng = {lat: location.lat, lng: location.lng};

            map.updateMap({stops: [location]});
            map.setZoom(16);
        };

        let _map = null;

        vmSchedulePnl.onMapLoaded = function(map) {
            _map = map;

            let appt = parent_vm.appointment;

            if (appt.tripStops && appt.tripStops.length > 1) {
                let stops = angular.copy(appt.tripStops);

                _map.updateMap({stops: stops});
            } else if (appt.location) {
                vmSchedulePnl.setMapLocation(_map, appt.location);
            }
        };

        vmSchedulePnl.onSummaryMapLoaded = function(summaryMap) {
            _summaryMap = summaryMap;

            let appt = parent_vm.appointment;

            if (vmSchedulePnl.displayedTripLocations && vmSchedulePnl.displayedTripLocations.locationList.length > 1) {
                vmSchedulePnl.displayTripLocations(vmSchedulePnl.displayedTripLocations, _summaryMap);
            } else if (appt.tripStops && appt.tripStops.length > 1) {
                let stops = angular.copy(appt.tripStops);

                _summaryMap.updateMap({stops: stops});
            } else if (appt.location) {
                vmSchedulePnl.setMapLocation(_summaryMap, appt.location);
            }
        };

        vmSchedulePnl.promiseDateChangedFromUi = true;

        vmSchedulePnl.promiseDateChanged = function (newValue, oldValue) {
            if (!vmSchedulePnl.promiseDateChangedFromUi) {
                vmSchedulePnl.promiseDateChangedFromUi = true;

                return;
            }

            if (!vmSchedulePnl.selectedTimeSlot) {
                return;
            }

            let selectedBlockTime = vmSchedulePnl.selectedTimeSlot.blockTime;

            vmSchedulePnl.promiseTimeHours = promiseTimeService.generateHoursFromDate(newValue, selectedBlockTime, vmSchedulePnl.deptHours, parent_vm.selectedDepartment);

            if (vmSchedulePnl.isLoanerSelected() && oldValue && parent_vm.appointment.selectedTimeSlot && moment(newValue) > moment(oldValue)) {
                modalService.showYesNo('Refresh Loaner Availability?', 'Changing Estimated Return will recalculate availability, and the selected time may no longer be available.  Are you sure you want to do this?', 'No', 'Yes', true, false).then(result => {
                    if (!result) {
                        parent_vm.appointment.promiseDate = oldValue;
                        vmSchedulePnl.promiseDateChangedFromUi = false;

                        return;
                    }

                    let days = moment(newValue).diff(moment(selectedBlockTime).startOf('day'), 'days');

                    parent_vm.appointment.lengthOfLoan = days || null;
                    parent_vm.selectedTimeSlot = null;
                    parent_vm.appointment.promiseDate = null;
                    parent_vm.appointment.promiseTime = null;
                    vmSchedulePnl.calendarOptionsChanged();
                });
            }

            angular.element('#promise-date').change();
        };

        vmSchedulePnl.isDateSelectable = function (date, type) {
            return promiseTimeService.isPromiseDateSelectable(vmSchedulePnl.selectedTimeSlot.blockTime, date, vmSchedulePnl.deptHours);
        };

        vmSchedulePnl.isInServiceArea = function (location) {    
            appointmentService.isInServiceArea(parent_vm.appointment.location.id, location).then(
                (result) => {
                    vmSchedulePnl.pickupLocation.isInServiceArea = result;
                },
                (error) => {
                }).finally(() => { });
        };

    }
})();

(function () {
    'use strict';

    AppointmentCustomerVehicleController.$inject = ["$q", "$rootScope", "$scope", "$filter", "$timeout", "$window", "$state", "$document", "rcUtilService", "azureBlob", "SYSTEM_ENUMS", "APPOINTMENTSTATUS_LABELS", "APPOINTMENT_APPOINTMENTSTATUS", "OLDER_VEHICLES", "ValidationService", "locationService", "appointmentService", "appointmentUtilService", "customerService", "vehicleService", "modalService", "messagesService", "appointmentLineItemClass", "typeaheadSelectionService"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentCustomerVehicleController', AppointmentCustomerVehicleController);

    function AppointmentCustomerVehicleController($q, $rootScope, $scope, $filter, $timeout, $window, $state, $document, rcUtilService, azureBlob, SYSTEM_ENUMS, APPOINTMENTSTATUS_LABELS,
        APPOINTMENT_APPOINTMENTSTATUS, OLDER_VEHICLES, ValidationService, locationService, appointmentService, appointmentUtilService, customerService, vehicleService,
        modalService, messagesService, appointmentLineItemClass, typeaheadSelectionService) {
        
        let vmCustomerPnl = this;
        let parent_vm = $scope.$parent.vm;
        let _validationService = new ValidationService({
            validateOnEmpty: true
        });
        let _revalidate = 'angularValidation.revalidate';
        let _steps = parent_vm.accordion.steps;
        let _currentYear = new Date().getFullYear();
        let _customerSearchRequestId = 0;
        let appointment = parent_vm.appointment;
        let lastRecordedMileage = 0;
        
        function isRequiredAdditionalFieldInvalid (required, value) {
            return required && (!value || value === "");
        }

        function addCreateNewToCustomerVehicles () {
            if (!parent_vm.availableCustomerVehicles) {
                parent_vm.availableCustomerVehicles = [];
            }

            if (parent_vm.appointment.mileageType === null) {
                parent_vm.appointment.mileageType = parent_vm.odometerTypes.find((r) => {
                    return r.type === parent_vm.appointment.location.country.measurementType; 
                });
            }

            if (!parent_vm.availableCustomerVehicles.some((vehicle) => vehicle.vehicleId === -998)) {
                parent_vm.availableCustomerVehicles.push({
                    vehicleId: -998,
                    name: '[NEW VEHICLE]',
                    vin: null,
                    make: null,
                    model: null,
                    year: null,
                    mileage: null
                });
            }
        }

        function createNewVehicle (initializing) {
            parent_vm.decodedVin = false;
            parent_vm.updateCustomerVehicleModelAfterLoad();
            parent_vm.addingCustomerVehicle = true;

            if (!initializing) {
                parent_vm.clearVehicle();
                parent_vm.currentVehicle = parent_vm.availableCustomerVehicles.find((vehicle) => { return vehicle.vehicleId === -998; });
            }
        }

        vmCustomerPnl.ymmOlderVehicles = false;
        parent_vm.ymmForceInsertedYear = false;
        parent_vm.ymmForceInsertedMake = false;
        parent_vm.ymmForceInsertedModel = false;
        vmCustomerPnl.activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
        vmCustomerPnl.suffix = appointmentUtilService.getProductSuffix(vmCustomerPnl.activeProduct);
        vmCustomerPnl.yearMakeModelMismatch = false;
        vmCustomerPnl.displayAdditionalFields = !!(parent_vm.dmsRequiredFields && (isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.customerAddress, appointment.customerAddress1) ||
            isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.customerCity, appointment.customerCity) ||
            isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.customerState, appointment.customerState) ||
            isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.customerZip, appointment.customerZip) ||
            isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.customerCountry, appointment.customerCountryShortCode) ||
            isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.customerCounty, appointment.customerCounty) ||
            isRequiredAdditionalFieldInvalid (parent_vm.dmsRequiredFields.language, appointment.language)));
        vmCustomerPnl.parent_vm = parent_vm;
        vmCustomerPnl.supportedCountries = SYSTEM_ENUMS.supportedCountries;
        vmCustomerPnl.appointmentLanguages = SYSTEM_ENUMS.appointmentLanguages;
        vmCustomerPnl.searchingCustomers = false;
        vmCustomerPnl.dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;
        vmCustomerPnl.initialLoad = true;
        vmCustomerPnl.initialYMMLoad = true;
        vmCustomerPnl.showNoDecodedVinMessage = false;
       
       function revalidateForm () {
            if (parent_vm.recMaintData && parent_vm.recMaintData.length > 0) {
                parent_vm.recMaintData.forEach((recmaint) => {
                    appointmentUtilService.revalidateLineItem($scope, parent_vm.dmsSystem, recmaint);
                });
            }

            parent_vm.appointment.lineItems.forEach((lineItem) => {
                appointmentUtilService.revalidateLineItem($scope, parent_vm.dmsSystem, lineItem);
            });
            

            $timeout(() => {
                _validationService.checkFormValidity($scope.bookApptForm);
            }, 250);
        }
        
        vmCustomerPnl.isCreateNewSuggestion = function (suggestion) {
            return suggestion?.item?.customerId == -998;
        };

        vmCustomerPnl.formatForSelection = function (item) {
            return appointmentUtilService.formatOpCodeSearchForSelection(item);
        };

        vmCustomerPnl.isOpCodeSelected = function (item) {
            return appointmentUtilService.opCodeSelected(item);
        };

        vmCustomerPnl.confirmedCreateDuplicate = false;

        vmCustomerPnl.imageType = appointmentUtilService.getImageTypes();

        vmCustomerPnl.openVinScan = function () {
            modalService.showVinScanModal().then((scannedVin) => {
                if (!parent_vm.customer) { // scanned in customer field
                    searchCustomerByVin(scannedVin);
                } else { // scanned in VIN field
                    parent_vm.appointment.vin = scannedVin;
                    vmCustomerPnl.checkValidVin();
                }
            });
        };

        function updateVehicleDropdown() {
            let vin = parent_vm.appointment.vin;

            if (parent_vm.currentVehicle && parent_vm.currentVehicle.vin && parent_vm.currentVehicle.vin === vin) return;

            // Check if there's a list, and if the vehicle is in it
            if (parent_vm.availableCustomerVehicles.length >= 2) {
                let foundVehicle = parent_vm.availableCustomerVehicles.find((vehicle) => vehicle.vin === vin);

                if (foundVehicle) {
                    parent_vm.currentVehicle = foundVehicle;
                    vmCustomerPnl.customerVehicleSelected(parent_vm.currentVehicle);
                } else {
                    setNewCurrentVehicle();
                }
            } else {
                setNewCurrentVehicle();
            }
        }

        function setNewCurrentVehicle () {
            const newVehicle = parent_vm.availableCustomerVehicles.find((vehicle) => { return vehicle.vehicleId === -998; });
            
            if (newVehicle) {
                parent_vm.currentVehicle = newVehicle;
                
                const vehicleTypeAheadData = appointmentUtilService.buildVehicleTypeAheadData(parent_vm.availableCustomerVehicles, '', vmCustomerPnl.typeAheadVehicleFormat);
                
                const newVehicleSuggestion = vehicleTypeAheadData.suggestions.find((s) => { return s.item?.vehicleId === -998;});
                
                if (newVehicleSuggestion) {
                    vmCustomerPnl.vehicleTypeAheadSelectedItems = [newVehicleSuggestion.id];
                }
            }
        }

        function searchCustomerByVin(customer) {

            if (!parent_vm.appointment.location || !customer || customer.length < 3) {
                return [];
            }

            vmCustomerPnl.searchingCustomers = true;

            return customerService.searchCustomersFromDms(parent_vm.appointment.location.id, customer).then((customerResults) => {
                if (customerResults && customerResults.length > 0) {
                    vmCustomerPnl.availableCustomers = appointmentUtilService.flattenCustomersForTypeAhead(customerResults);

                    const customerTypeAheadData = appointmentUtilService.buildCustomerTypeAheadData(vmCustomerPnl.availableCustomers, customer, vmCustomerPnl.typeAheadFormat, addCreateNewRecordOption);

                    vmCustomerPnl.customerTypeAheadSuggestions = customerTypeAheadData.suggestions;
                    parent_vm.selectedCustomer = null;
                    customerTypeAheadCtrl?.triggerSearch(customer);
                } else {
                    const location = parent_vm.appointment.location;

                    vehicleService.decodeVin(location.id, customer).then((decoded) => {
                        const ymm = decoded?.year && decoded?.makeName && decoded?.modelName
                            ? `${decoded.year} ${decoded.makeName} ${decoded.modelName}`
                            : '';

                        modalService.showVinNotFound(customer, location, ymm, $state.name).then((confirmed) => {
                            if (!confirmed) return;
                            vmCustomerPnl.availableCustomers = [];
                            vmCustomerPnl.addNewCustomer(true);
                            parent_vm.selectedCustomer = appointmentUtilService.createNewCustomerEntry();
                            angular.extend(parent_vm.appointment, parent_vm.selectedCustomer);
                            parent_vm.customer = true;
                            parent_vm.appointment.vin = customer;
                            parent_vm.preselectedVin = customer;

                            $timeout(() => {
                                parent_vm.forceNewCustomerOnLoad = false;
                                parent_vm.accordion.selectedStep = _steps.customerVehicle;
                                parent_vm.gotoTab(0);

                                if (parent_vm.appointment.vin) {
                                    vmCustomerPnl.checkValidVin();
                                }
                            }, 100);
                        }).catch(() => console.log('VIN modal cancelled'));
                    });
                }

                vmCustomerPnl.searchingCustomers = false;
            }, (errorResponse) => {
                modalService.showVinNotFound();
                vmCustomerPnl.availableCustomers = [];

                const {suggestions} = appointmentUtilService.buildCustomerTypeAheadData([], customer, vmCustomerPnl.typeAheadFormat, addCreateNewRecordOption);

                vmCustomerPnl.customerTypeAheadSuggestions = suggestions;
                customerTypeAheadCtrl?.triggerSearch(customer);
                vmCustomerPnl.searchingCustomers = false;
            });
        }

        vmCustomerPnl.openDlScan = function () {
            modalService.showLicenseScanModal().then((scannedVin) => {
                parent_vm.appointment.customerFirstName = scannedVin.firstName;
                parent_vm.appointment.customerLastName = scannedVin.lastName;
                parent_vm.appointment.customerAddress1 = scannedVin.address1;
                parent_vm.appointment.customerCity = scannedVin.city;
                parent_vm.appointment.customerState = scannedVin.state?.toUpperCase() || null;
                parent_vm.appointment.customerZip = scannedVin.zip?.substring(0, 5) || null;
                parent_vm.appointment.customerCountryShortCode = scannedVin.country?.substring(0, 2) || null;
                //County not provided by DL scan
                //vm.appointment.customerCounty = "";
            });
        };

        vmCustomerPnl.upload = function ($model, file, $files, $event, $id, reference, container) {
            let deferred = $q.defer();
            let imageType = vmCustomerPnl.imageType[$id];

            if ($model.imageId && $model.url) {
                let config = {
                    baseUrl: $model.url,
                    file: file,
                    complete: function () {
                        $model.fileExtension = file.type;
                        $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);  
                        let existingIndex = parent_vm.appointment.lineItems?.findIndex((l) => { return l.dealerAppointmentServiceOpCodeId === reference.id; }) ?? -1;

                        if (existingIndex > -1) {
                            parent_vm.appointment.lineItems[existingIndex].images = container;
                        }

                        deferred.resolve('Upload successful');
                    },
                    error: function(err) {
                        deferred.reject(err);
                    },
                    blockSize: 4000000000
                };

                azureBlob.upload(config);
            } else {
                appointmentService.getImageToken(parent_vm.appointment.location.id, imageType).then((result) => {
                    let config = {
                        baseUrl: result.url,
                        file: file,
                        complete: function () {
                            $model.imageId = result.imageId;
                            $model.url = result.url;
                            $model.fileExtension = file.type;
                            $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);  

                            let existingIndex = parent_vm.appointment.lineItems?.findIndex((l) => { return l.dealerAppointmentServiceOpCodeId === reference.id; }) ?? -1;

                            if (existingIndex > -1) {
                                parent_vm.appointment.lineItems[existingIndex].images = container;
                            }

                            deferred.resolve('Upload successful');
                        },
                        error: function(err) {
                            deferred.reject(err);
                        },
                        blockSize: 4000000000
                    };

                    azureBlob.upload(config);
                });
            }

            return deferred.promise;
        };

       vmCustomerPnl.opCodeSearchSelected = function (lineItem, selectedItem) {
            let defaultDispatchCode = parent_vm.selectedDepartment?.defaultDispatchCode;

            appointmentUtilService.processDashboardOpCodeSearchSelected(lineItem, selectedItem, parent_vm.dmsSystem, defaultDispatchCode, false);

            if (selectedItem && selectedItem.length === 1) {
                if (allOtherLineItemsValid() && !hasNewOtherLine()) {
                    parent_vm.addOtherLineItem();
                }
            }

            let filterOther = parent_vm.appointment.lineItems.filter((lineItem) => lineItem.isOther === true);

            for (let i = 0; i < filterOther.length; i++) {
                $scope.$broadcast(_revalidate, 'opcode-' + filterOther[i].uniqueDOMId);
            }
        };

        vmCustomerPnl.maxVehicleYear = _currentYear + 1;
        vmCustomerPnl.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
        vmCustomerPnl.availableCustomers = [];
        vmCustomerPnl.vehicleSubModels = [];

        let customerTypeAheadCtrl = null;
        let vehicleTypeAheadCtrl = null;

        // so we can call methods directly on the ctrl from the parent vm when needed without having to use $broadcast and events for everything
        vmCustomerPnl.registerCustomerTypeAhead = function (ctrl) {
            customerTypeAheadCtrl = ctrl;
        };

        vmCustomerPnl.registerVehicleTypeAhead = function (ctrl) {
            vehicleTypeAheadCtrl = ctrl;
        };

        vmCustomerPnl.loading = false;

        vmCustomerPnl.usStates = SYSTEM_ENUMS.usStates;
        vmCustomerPnl.lastContactPhoneNumber = null;
        vmCustomerPnl.lastGetMakesYear = null;
        vmCustomerPnl.lastGetModelMake = {
            make: null,
            makeCode: null
        };
        parent_vm.appointment.noLineItemsSelected = false;
        vmCustomerPnl.deferred = null;
        vmCustomerPnl.options = {
            watchEnter: true,
            country: 'us,can'
        };

        function setPlacesBounds () {
            if (!parent_vm.appointment || !parent_vm.appointment.location) return;
            let dealerLoc = parent_vm.appointment.location;

            vmCustomerPnl.options.startLat = parseFloat(dealerLoc.lat);
            vmCustomerPnl.options.startLng = parseFloat(dealerLoc.lng);
        }
        
        vmCustomerPnl.isCustomerRequest = function (lineItem) {
            return appointmentUtilService.isLineItemCustomerRequest(lineItem);
        };

        vmCustomerPnl.isUserRequest = function (lineItem) {
            return appointmentUtilService.isLineItemUserRequest(lineItem);
        };

        function getServiceTypes() {
            let locId = parent_vm.appointment.location.id;

            locationService.getLocationDMS(locId).then((result) => {
                if (result) {
                    locationService.lookupServiceTypes(locId, result).then((response) => {
                        parent_vm.serviceTypes = response;
                    });
                }
            });
        }

        vmCustomerPnl.removeOtherLineItem = function (uniqueDomId) {
            rcUtilService.removeFromArray(parent_vm.appointment.lineItems, (lineItem) => lineItem.isOther === true && lineItem.uniqueDOMId === uniqueDomId);
        };

        vmCustomerPnl.lineItemToggle = function(lineItem) {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            if (lineItem.images === 'undefined' || !lineItem.images) lineItem.images = new Array(1).fill({});

            let toggleNewItem = false;

            $timeout(() => {
                let existingIndex = -1;

                lineItem.checked = !lineItem.checked;

                if (lineItem.checked) {
                    parent_vm.servicesModified = true;

                    if (lineItem.id === 0) {
                        toggleNewItem = true;
                    }

                    // Check the parent original line items, unless a generic item was checked since they are only toggle-able
                    if (!lineItem.isGeneric && !lineItem.isOther) {
                        existingIndex = (parent_vm.originalAppointmentLineItems || []).findIndex((l) => { return l.dealerAppointmentServiceOpCodeId === lineItem.id; });

                        if (existingIndex > -1) {
                            // Shallow copy the line, in the case we've toggled the line on and off, there is no reason to not send the original already saved line
                            let existingLineItem = appointmentLineItemClass.new(parent_vm.originalAppointmentLineItems[existingIndex]);

                            existingLineItem.checked = lineItem.checked;
                            parent_vm.appointment.lineItems.push(existingLineItem);
                        } else {
                            // Reset the note on the view
                            lineItem.note = lineItem.defaultDashboardNote;
                            // Create a new line
                            let newLineItem = appointmentLineItemClass.new(lineItem);

                            // The id of the mapped op code does not need to be copied over
                            newLineItem.dealerAppointmentServiceOpCodeId = newLineItem.id;
                            newLineItem.id = null;
                            newLineItem.opCodeDescription = lineItem.dashboardDescription.substr(0, appointmentUtilService.getOpCodeDescriptionMaxLength(vmCustomerPnl.dmsSystem));
                            newLineItem.checked = lineItem.checked;
                            newLineItem.dateCreated = moment.utc();
                            newLineItem.isUpsell = false;
                            parent_vm.appointment.lineItems.push(newLineItem);
                        }
                    }

                    parent_vm.appointment.noLineItemsSelected = false;
                    // We need to re-validate every op code line when checking this line because none of the custom conditional validators
                    // fire when running checkFormValidity()
                    let filterOther = parent_vm.appointment.lineItems.filter((lineItem) => lineItem.isOther === true);

                    for (let i = 0; i < filterOther.length; i++) {
                        $scope.$broadcast(_revalidate, 'opcode-' + filterOther[i].uniqueDOMId);
                    }

                    parent_vm.getSelectedServicesCounts();
                } else {
                    // Remove the existing line from the set, unless it is a generic line item, those are toggle-able and will be filtered off before the save
                    if (!lineItem.isGeneric && !lineItem.isOther) {
                        existingIndex = parent_vm.appointment.lineItems.findIndex((l) => { return l.dealerAppointmentServiceOpCodeId === lineItem.id; });
                        parent_vm.appointment.lineItems.splice(existingIndex, 1);
                    }

                    // We need to re-validate any op codes that were declared invalid because of potential duplicates
                    // This validation library does not actaully revalidate the form for any conditionals
                    for (let j = 0; j < $scope.bookApptForm.$validationSummary.length; j++) {
                        if ($scope.bookApptForm.$validationSummary[j].field.search('opcode-') > -1) {
                            $scope.$broadcast(_revalidate, $scope.bookApptForm.$validationSummary[j].field);
                        }
                    }

                    parent_vm.getSelectedServicesCounts();
                }

                if (!toggleNewItem) {
                    $timeout(() => {
                        revalidateForm();
                    }, 25);
                }
            }, 1);
        };

        vmCustomerPnl.commonServicesToggle = function () {
            parent_vm.commonServicesChecked = !parent_vm.commonServicesChecked;
            $timeout(() => {
                revalidateForm();
            }, 1); 
        };

        vmCustomerPnl.prevDeclinedServicesToggle = function () {
            parent_vm.prevDeclinedServicesChecked = !parent_vm.prevDeclinedServicesChecked;
        };

        vmCustomerPnl.recallsToggle = function () {
            parent_vm.recallsChecked = !parent_vm.recallsChecked;
        };

        vmCustomerPnl.recMaintToggle = function () {
            parent_vm.recMaintChecked = !parent_vm.recMaintChecked;
        };

        vmCustomerPnl.recMaintItemChanged = function (recMaint) {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            appointmentUtilService.processDashboardRecMaintItemUpdated(parent_vm.appointment.lineItems, recMaint);
            revalidateForm();
        };

        function appendOlderVehicles (years) {
            if (vmCustomerPnl.dmsSystem !== vmCustomerPnl.dmsEnum.CDK) {
                if (!years) {
                    years = [];
                }

                years.push(OLDER_VEHICLES);
            }
        }

        function loadVehicleYears () {
            if (!parent_vm.appointment.location) return;
            
            vmCustomerPnl.updatingYears = true;
            vehicleService.getYears(parent_vm.appointment.location.id).then((years) => {
                appendOlderVehicles(years);
                vmCustomerPnl.vehicleYears = years;

                if (parent_vm.appointment.year) {
                    ensureVehicleYearInDropDown();
                }

                let make = appointmentUtilService.getDisplayMake(parent_vm.appointment);
                let model = appointmentUtilService.getDisplayModel(parent_vm.appointment);

                if (parent_vm.appointment.make) {
                    vmCustomerPnl.yearUpdated(make, model, parent_vm.appointment.subModel);
                }
                
            }).catch(() => {
                vmCustomerPnl.vehicleYears = null;
            }).finally(() => {
                vmCustomerPnl.updatingYears = false;
            });
        }

        function ensureVehicleYearInDropDown (yearToSelect) {
            let year = yearToSelect || parent_vm.appointment.year;
            let exists = vmCustomerPnl.vehicleYears?.includes(parseInt(year));

            if (!exists && vmCustomerPnl.vehicleYears) {
                vmCustomerPnl.vehicleYears.push(year);
                parent_vm.ymmForceInsertedYear = true;
            }

        }

        function ensureVehicleMakeInDropDown(makeToSelect) {
            let make = makeToSelect || parent_vm.appointment.make;
            let exists = vmCustomerPnl.vehicleMakes?.findIndex((o) => { return o.make?.toLowerCase() === make.toLowerCase(); }) > -1;

            if (!exists) {
                if (!vmCustomerPnl.vehicleMakes) {
                    vmCustomerPnl.vehicleMakes = [];
                }

                vmCustomerPnl.vehicleMakes.push({make: make, makeCode: make});
                parent_vm.ymmForceInsertedMake = true;
            }
        }

        function ensureVehicleModelInDropDown(modelToSelect) {
            let model = modelToSelect || parent_vm.appointment.model;

            if (!model) return;
            let exists = vmCustomerPnl.vehicleModels?.some((o) => { return o.model?.toLowerCase() === model.toLowerCase(); });

            if (!exists) {
                if (!vmCustomerPnl.vehicleModels) {
                    vmCustomerPnl.vehicleModels = [];
                }

                vmCustomerPnl.vehicleModels.push({model: model, modelCode: model});
                parent_vm.ymmForceInsertedModel = true;
            }
        }

        function getNoteMaxLength () {
            return appointmentUtilService.getNoteMaxLength(vmCustomerPnl.dmsSystem);
        }

        vmCustomerPnl.getCustomerFirstNameMaxLength = function () {
            return appointmentUtilService.getCustomerFirstNameMaxLength(vmCustomerPnl.dmsSystem);
        };

        vmCustomerPnl.getCustomerLastNameMaxLength = function () {
            return appointmentUtilService.getCustomerLastNameMaxLength(vmCustomerPnl.dmsSystem);
        };

        vmCustomerPnl.validation = {
            valYear: function () {
                return rcUtilService.isValidYear(parent_vm.appointment.year, 1900, vmCustomerPnl.maxVehicleYear);
            },
            licensePlate: function (plate) {
                let regexp = /^[a-zA-Z0-9 -]*$/;

                return {isValid: regexp.test(plate), message: 'No special characters.'};
            },
            tagNumber: function (tag) {
                let regexp = /^[a-zA-Z0-9.]*$/;

                return {isValid: regexp.test(tag), message: 'Invalid char'};
            },
            phoneNumberRequired: function (number) {
                return appointmentUtilService.validatePhoneNumber(number);
            },
            valOpCode: function (opCode, lineItem) {
                return appointmentUtilService.validateDashboardOpCode(parent_vm.appointment.lineItems, parent_vm.dealerOpCodes, opCode, lineItem, vmCustomerPnl.dmsSystem);
            },
            valDecimal: function (value, lineItem, exactDecimalPlaces) {
                return appointmentUtilService.validateDecimal(value, null, exactDecimalPlaces);
            },
            valRecalls: function () {
                return appointmentUtilService.validateRecalls(parent_vm.dealerRecallOpCodes, parent_vm.appointment.departmentId, parent_vm.appointment.lineItems, getNoteMaxLength(), vmCustomerPnl.validatingRecalls);
            },
            combinedCustomerNameLength: function () {
                return appointmentUtilService.validateCombinedCustomerNameLength(vmCustomerPnl.dmsSystem, parent_vm.appointment.customerFirstName, parent_vm.appointment.customerLastName, parent_vm.appointment.customerIsBusiness);
            },
			isValidDepartment: function () {
                return appointmentUtilService.validateDepartment(parent_vm.dealerDepartments, parent_vm.appointment.departmentId);
            },
            uniqueNote: function (lineItem) {
                return appointmentUtilService.validateUniqueNoteForDuplicateOpCodes(parent_vm.appointment.lineItems, lineItem);
            },
            validVin: function (vin) {
                return rcUtilService.isValidVin(vin);
            },
            validOdometer: function (odometer) {
                if (odometer && odometer <= lastRecordedMileage) {
                    return {isValid: false, message: `Must be greater than last value of ${lastRecordedMileage}.`};
                } else {
                    return {isValid: true, message: ''};              
                }
            }
        };

        function isValidOpCode (opCode) {
            return !!opCode?.trim()?.length;
        }

        function allOtherLineItemsValid () {
            let lineItems = parent_vm.appointment.lineItems.filter((lineItem) => lineItem.checked === true && lineItem.isOther === true);
            let valid = true;

            if (lineItems?.length > 0) {
                lineItems.forEach((lineItem) => {
                    if (!isValidOpCode(lineItem.opCode)) {
                        valid = false;

                        return false;
                    }
                });
            }

            return valid;
        }

        function hasNewOtherLine () {
            let newOtherLine = parent_vm.appointment.lineItems.filter((lineItem) => lineItem.checked === false && lineItem.isOther === true);

            return !!newOtherLine?.length;
        }

        function addCreateNewRecordOption (searchTerm) {
            return {
                displayMessage: "Create a New Record.",
                customerLastName: "",
                customerFirstName: "",
                customerPhone: (searchTerm && /^\d{10}$/.test(searchTerm)) ? searchTerm : null,
                customerId: -998
            };
        }

        function createCustomerNotFound (customer) {
            let isAutoSoft = vmCustomerPnl.dmsSystem === vmCustomerPnl.dmsEnum.Motive &&
                             parent_vm.dmsData.dmsDataSource === SYSTEM_ENUMS.motiveDataSourceEnum.AutoSoft;
            let isDealerTrack = vmCustomerPnl.dmsSystem === vmCustomerPnl.dmsEnum.DealerTrack;
            let isNameOnly = !!customer && !/[\s@0-9]/.test(customer);
            let needsFullNameHint = isAutoSoft && isNameOnly;
            let needsLastNameHint = isDealerTrack && isNameOnly;
            let hint = needsFullNameHint ? '<br>Please use the customer\'s full name.'
                     : needsLastNameHint ? '<br>Please search by last name, or try first and last name together.'
                     : '';
            let message = 'No results found for ' + customer + '.' + hint;

            vmCustomerPnl.availableCustomers = [{
                displayMessage: message,
                customerLastName: '',
                customerFirstName: '',
                customerId: -999
            }];
        }

        vmCustomerPnl.mobilePhoneUpdated = function (phoneNumber, loadingFromRecord) {
            
            // Only continue checking if we have a valid phone number
            if (phoneNumber?.length === 10) {
                vmCustomerPnl.checkPhoneType(phoneNumber);
                parent_vm.loadingCustomerDetails = true;
                vmCustomerPnl.checkForDuplicateCustomer().then(() => {
                    // Only load the messages if we have a customer (not a new customer)
                    
                    if (parent_vm.selectedCustomer && parent_vm.selectedCustomer.customerId !== -999 && parent_vm.selectedCustomer.customerId !== -998) {
                        if (vmCustomerPnl.lastContactPhoneNumber !== phoneNumber) {
                            vmCustomerPnl.lastContactPhoneNumber = phoneNumber;

                            if (phoneNumber) {
                                parent_vm.loadContactForMessagingPanel();
                            }
                        }
                    }
                }).finally(() => {
                    parent_vm.loadingCustomerDetails = false;
                });
            } else if (vmCustomerPnl.lastContactPhoneNumber !== phoneNumber) {
                vmCustomerPnl.lastContactPhoneNumber = phoneNumber;
                parent_vm.loadContactForMessagingPanel();
            }
        };

        vmCustomerPnl.emailUpdated = function () {
            vmCustomerPnl.checkForDuplicateCustomer();
        };

        vmCustomerPnl.lineItemUpdated = function (lineItem) {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            appointmentUtilService.processDashboardLineItemUpdated(parent_vm.appointment, lineItem);
            appointmentUtilService.revalidateLineItem($scope, parent_vm.dmsSystem, lineItem);
            $timeout(() => {
                _validationService.checkFormValidity($scope.bookApptForm);
            }, 250);
        };

        vmCustomerPnl.typeAheadFormat = function (customer) {
            let out = '';

            if (customer) {
                if (customer.customerId === -999) {
                    // Customer was not found, return the message that was placed in the lastName
                    return customer.displayMessage;
                } else if (customer.customerId === -998) {
                    return "<span class='theme-link no-underline text-normal-case'>Can't find it?  </span><span class='theme-link create-new'>Create a New Record.</span>";
                }

                let name = customer.customerLastName;
                let custId = customer.customerId;
                let phoneNumber = '';

                if (customer.customerType === parent_vm.customerType.business) {
                    name = customer.customerLastName;
                } else if (customer.customerFirstName) {
                    name = customer.customerFirstName + ' ' + customer.customerLastName;
                }

                if (customer.customerPhone && customer.customerPhone !== '0') {
                    phoneNumber = $filter('tel')(customer.customerPhone);
                }

                out = '<b>' + name + '</b>' + (custId ? ' #' + custId + ' ' : ' ') + '<b>' + phoneNumber + '</b>';

                if (customer.vehicle) {
                    let vin = !customer.vehicle.vin || customer.vehicle.vin === '' ? 'NO VIN' : customer.vehicle.vin;

                    out += '<br>' + customer.vehicle.year + ' ' + customer.vehicle.make + ' ' + customer.vehicle.model + ' (' + vin + ')';
                }
            }

            return out;
        };

        vmCustomerPnl.typeAheadVehicleFormat = function (vehicle) {
            let out = '';

            if (vehicle) {
                if (vehicle.vehicleId === -998) {
                    return "<u class='theme-link create-new'>ENTER A NEW VEHICLE</u>";
                }

                let year = vehicle.year;
                let make = vehicle.makeName || vehicle.make;
                let model = vehicle.model;
                let vin = vehicle.vin;

                out = year + ' ' + make + ' ' + model;

                if (vin?.trim().length > 0) {
                    out += ' (' + vin + ')';
                }
            }

            return out;
        };

        vmCustomerPnl.resetCustomerTypeAheadOnEmptyFocus = function () {
            vmCustomerPnl.searchingCustomers = false;
            vmCustomerPnl.availableCustomers = [];
            vmCustomerPnl.customerTypeAheadSuggestions = [];
        };

        function resetCustomerTypeAhead () {
            customerTypeAheadCtrl?.reset?.();
        }

        function clearCustomerTypeAheadState () {
            vmCustomerPnl.searchingCustomers = false;
            vmCustomerPnl.isCustomerTypeAheadFocused = false;
            vmCustomerPnl.customerTypeAheadSuggestions = [];
            vmCustomerPnl.customerTypeAheadSelectedItems = [];
            vmCustomerPnl.customerTypeAheadSearchQuery = '';
            resetCustomerTypeAhead();
        }

        function resetVehicleTypeAhead () {
            vehicleTypeAheadCtrl?.reset?.();
        }

        vmCustomerPnl.customerTypeAheadSelected = function (tag) {
            if (tag) {
                const selected = typeaheadSelectionService.resolveSelection(tag, null, vmCustomerPnl.customerTypeAheadSuggestions);

                if (!selected || selected.customerId == -999) {
                    resetCustomerTypeAhead();
                } else if (selected.customerId == -998) {
                    vmCustomerPnl.forceAddCustomer();
                } else {
                    parent_vm.selectedCustomer = selected;
                    vmCustomerPnl.customerSelected();
                }
            }

            vmCustomerPnl.isCustomerTypeAheadFocused = false;
        };

        vmCustomerPnl.customerTypeAheadRemoved = function () {
            vmCustomerPnl.searchingCustomers = false;
            resetCustomerTypeAhead();
        };

        vmCustomerPnl.onVehicleTypeAheadFocus = function () {
            vmCustomerPnl.isVehicleTypeAheadFocused = true;
            vmCustomerPnl.refreshVehicleSuggestions(vmCustomerPnl.vehicleTypeAheadSearchQuery || '');
        };

        vmCustomerPnl.refreshVehicleSuggestions = function (searchTerm) {
            vmCustomerPnl.vehicleTypeAheadSearchQuery = searchTerm;

            const vehicleTypeAheadData = appointmentUtilService.buildVehicleTypeAheadData(parent_vm.availableCustomerVehicles, searchTerm, vmCustomerPnl.typeAheadVehicleFormat);

            vmCustomerPnl.vehicleTypeAheadSuggestions = vehicleTypeAheadData.suggestions;

            return vehicleTypeAheadData.suggestions;
        };

        vmCustomerPnl.vehicleTypeAheadSelected = function (tag) {
            if (tag) {
                let selectedVehicle = typeaheadSelectionService.resolveSelection(tag, null, vmCustomerPnl.vehicleTypeAheadSuggestions);

                if (selectedVehicle) {
                    parent_vm.currentVehicle = selectedVehicle;
                    vmCustomerPnl.customerVehicleSelected(selectedVehicle);
                } else {
                    resetVehicleTypeAhead();
                    vmCustomerPnl.refreshVehicleSuggestions('');
                }
            }

            vmCustomerPnl.isVehicleTypeAheadFocused = false;
        };

        vmCustomerPnl.vehicleTypeAheadRemoved = function () {
            resetVehicleTypeAhead();
            vmCustomerPnl.refreshVehicleSuggestions('');
        };

        vmCustomerPnl.refreshCustomers = function(customer) {
            const currentQuery = vmCustomerPnl.customerTypeAheadSearchQuery || '';

            if (customer !== currentQuery) {
                _customerSearchRequestId++;
                vmCustomerPnl.searchingCustomers = false;

                if (currentQuery.length < 3) {
                    vmCustomerPnl.availableCustomers = [];
                    vmCustomerPnl.customerTypeAheadSuggestions = [];
                }

                return vmCustomerPnl.customerTypeAheadSuggestions;
            }

            if (!parent_vm.appointment.location || customer.length < 3) {
                _customerSearchRequestId++;
                vmCustomerPnl.searchingCustomers = false;
                vmCustomerPnl.availableCustomers = [];
                vmCustomerPnl.customerTypeAheadSuggestions = [];

                return [];
            }

            const requestId = ++_customerSearchRequestId;

            vmCustomerPnl.searchingCustomers = true;
            
            return customerService.searchCustomersFromDms(parent_vm.appointment.location.id, customer).then((customerResults) => {
                if (requestId !== _customerSearchRequestId) {
                    if ((vmCustomerPnl.customerTypeAheadSearchQuery || '').length < 3) vmCustomerPnl.searchingCustomers = false;

                    return vmCustomerPnl.customerTypeAheadSuggestions;
                }

                if (customerResults?.length > 0) {
                    vmCustomerPnl.availableCustomers = appointmentUtilService.flattenCustomersForTypeAhead(customerResults);
                } else {
                    createCustomerNotFound(customer);
                }

                const {suggestions} = appointmentUtilService.buildCustomerTypeAheadData(vmCustomerPnl.availableCustomers, customer, vmCustomerPnl.typeAheadFormat, addCreateNewRecordOption);

                vmCustomerPnl.customerTypeAheadSuggestions = suggestions;

                vmCustomerPnl.searchingCustomers = false;

                return vmCustomerPnl.customerTypeAheadSuggestions;
            }, (errorResponse) => {
                if (requestId !== _customerSearchRequestId) {
                    if ((vmCustomerPnl.customerTypeAheadSearchQuery || '').length < 3) vmCustomerPnl.searchingCustomers = false;

                    return vmCustomerPnl.customerTypeAheadSuggestions;
                }

                vmCustomerPnl.availableCustomers = [];

                const {suggestions} = appointmentUtilService.buildCustomerTypeAheadData([], customer, vmCustomerPnl.typeAheadFormat, addCreateNewRecordOption);

                vmCustomerPnl.customerTypeAheadSuggestions = suggestions;
                vmCustomerPnl.searchingCustomers = false;

                return vmCustomerPnl.customerTypeAheadSuggestions;
            });
        };

        function hasValidVehicleData () {
            let appt = parent_vm.appointment;
            let hasYMM = appt.year && appt.make && appt.model && vmCustomerPnl.selectedMake && vmCustomerPnl.selectedModel;

            return !!(appt.vin || hasYMM);
        }        

        vmCustomerPnl.getRecommendedMaint = function () {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            if (vmCustomerPnl.activeProduct === 'checkin-list') {
                return;
            }

            let appt = parent_vm.appointment;
            let preExistingRecMaint = false;
            let recMaintEnabled = parent_vm.recMaintEnabled();

            parent_vm.recMaintData = null;
            parent_vm.noRecMaintFound = false;

            if (!appt.mileage) {
                vmCustomerPnl.getPreviouslyDeclinedServices();

                return;
            }

            if (recMaintEnabled && hasValidVehicleData()) {
                parent_vm.retrievingMaint = true;
                let make = vmCustomerPnl.selectedMake ? vmCustomerPnl.selectedMake.make : null;
                let model = vmCustomerPnl.selectedModel ? vmCustomerPnl.selectedModel.model : null;
                let defaultDispatchCode = parent_vm.selectedDepartment?.defaultDispatchCode;

                vehicleService.getRecommendedMaintenance(parent_vm.appointment.location.id, appt.vin, appt.year, make, model, appt.mileage, appt.mileageType.type === SYSTEM_ENUMS.measurementTypes.imperical, defaultDispatchCode).then((response) => {
                    parent_vm.recMaintData = response.maintenanceIntervals;
                    parent_vm.recMaintDisclaimer = response.motorDisclaimer;
                  
                    let currLineItem = null;

                    for (let i = parent_vm.appointment.lineItems.length - 1; i >= 0; i--) {
                        currLineItem = parent_vm.appointment.lineItems[i];

                        if (!currLineItem.isRecommendedMaintenance) {
                            continue;
                        }

                        let recMaintToCheck = (parent_vm.recMaintData || []).filter((item) => {
                            return appointmentUtilService.getRecommendedMaintenanceName(item, appt.mileageType) === currLineItem.overrideName;
                        });

                        if (!vmCustomerPnl.yearMakeModelMismatch && recMaintToCheck?.length > 0) {
                            recMaintToCheck[0].checked = true;
                            recMaintToCheck[0].retailPrice = currLineItem.retailPrice;
                            recMaintToCheck[0].laborHours = currLineItem.laborHours;
                            recMaintToCheck[0].payType = currLineItem.payType;
                            parent_vm.selectedRecMaint = recMaintToCheck[0].interval;
                            preExistingRecMaint = true;
                        } else {
                            // The rec maint data has changed, this previous recMaint is no longer relevant
                            parent_vm.appointment.lineItems.splice(i, 1);
                        }
                    }

                    if (!parent_vm.previouslyDeclinedServices) {
                        vmCustomerPnl.getPreviouslyDeclinedServices();
                    } else {
                        appointmentUtilService.removePreviouslyDeclinedRecMaint(appt, parent_vm.recMaintData, parent_vm.previouslyDeclinedServices);
                    }

                    if (preExistingRecMaint) {
                        vmCustomerPnl.recMaintToggle();
                    }

                    parent_vm.getSelectedServicesCounts();
                    parent_vm.retrievingMaint = false;
                    vmCustomerPnl.initialLoad = false;
                }, (errorResponse) => {
                    parent_vm.noRecMaintFound = true;

                    for (let i = parent_vm.appointment.lineItems.length - 1; i >= 0; i--) {
                        if (parent_vm.appointment.lineItems[i].isRecommendedMaintenance) {
                            parent_vm.appointment.lineItems.splice(i, 1);
                        }
                    }

                    parent_vm.recMaintData = null;
                    parent_vm.retrievingMaint = false;
                    parent_vm.getSelectedServicesCounts();
                    vmCustomerPnl.initialLoad = false;
                });
            } else {
                vmCustomerPnl.initialLoad = false;
                vmCustomerPnl.getPreviouslyDeclinedServices();
            }
        };

        vmCustomerPnl.getRecalls = function () {
            if (vmCustomerPnl.activeProduct === 'checkin-list') {
                return;
            }

            let appt = parent_vm.appointment;
            let preExistingRecalls = false;
            // get the recall op code for the current department
            let recallOpCodes = appointmentUtilService.getDeptOpCodes(parent_vm.dealerRecallOpCodes, appt.departmentId);
            let recallsEnabled = parent_vm.recallsEnabled();
            let recallsConfigured = !!(recallsEnabled && recallOpCodes[0].recallOpCodeType);

            parent_vm.noRecallsFound = false;
            parent_vm.recalls = null;

            if (recallsEnabled && recallsConfigured && appt.vin) {
                parent_vm.retrievingRecalls = true;
                let make = vmCustomerPnl.selectedMake ? vmCustomerPnl.selectedMake.make : null;
                let model = vmCustomerPnl.selectedModel ? vmCustomerPnl.selectedModel.model : null;

                vehicleService.getRecalls(parent_vm.appointment.location.id, appt.vin).then((recalls) => {
                    parent_vm.recalls = recalls;
                    let recall = null;

                    for (let i = parent_vm.appointment.lineItems.length - 1; i >= 0; i--) {
                        recall = parent_vm.appointment.lineItems[i];

                        if (!recall.isRecall) {
                            continue;
                        }

                        let recallToCheck = $filter('filter')(parent_vm.recalls, (item) => {
                            return item.manufacturerNumber === recall.manufacturerNumber;
                        }, true);

                        if (!vmCustomerPnl.yearMakeModelMismatch && recallToCheck?.length > 0) {
                            recallToCheck[0].checked = true;
                            preExistingRecalls = true;
                        } else {
                            // The recall data has changed, this previous recall is no longer relevant
                            parent_vm.appointment.lineItems.splice(i, 1);
                        }
                    }

                    parent_vm.recallsLoaded();

                    if (preExistingRecalls) {
                        vmCustomerPnl.recallsToggle();
                    }

                    parent_vm.getSelectedServicesCounts();
                    parent_vm.retrievingRecalls = false;
                }, (errorResponse) => {
                    parent_vm.noRecallsFound = true;

                    for (let i = parent_vm.appointment.lineItems.length - 1; i >= 0; i--) {
                        if (parent_vm.appointment.lineItems[i].isRecall) {
                            parent_vm.appointment.lineItems.splice(i, 1);
                        }
                    }

                    parent_vm.recalls = null;
                    parent_vm.retrievingRecalls = false;
                    parent_vm.recallsLoaded();
                    parent_vm.getSelectedServicesCounts();
                });
            }
        };

        vmCustomerPnl.getPreviouslyDeclinedServices = function () {
            if (vmCustomerPnl.activeProduct === 'checkin-list') {
                return;
            }
            
            let appt = parent_vm.appointment;

            if (!parent_vm.addingCustomer && appt.vin && appt.customerId && !parent_vm.retrievingDeclinedServices && parent_vm.selectedDepartment && parent_vm.selectedDepartment.showPreviouslyDeclinedServicesDashboard) {
                parent_vm.previouslyDeclinedServices = null;
                parent_vm.retrievingDeclinedServices = true;
                appointmentService.getPreviouslyDeclinedServices(appt.location.id, appt.customerId, appt.vin).then((response) => {
                    let nonRecalls = null;

                    if (response) {
                        nonRecalls = response.filter((item) => item.isRecall === false);

                        appointmentUtilService.processPreviouslyDeclinedLineItems(nonRecalls, parent_vm.dealerOpCodesAll, parent_vm.dealerOpCodes, true);
                    }
                   
                    parent_vm.previouslyDeclinedServices = nonRecalls;

                    if (parent_vm.recMaintData) {
                        appointmentUtilService.removePreviouslyDeclinedRecMaint(appt, parent_vm.recMaintData, parent_vm.previouslyDeclinedServices);
                    }

                }, (errorResponse) => {
                    parent_vm.retrievingDeclinedServices = false;
                });
            }

        };

        function selectMakeInDropDown(makeToSelect) {
            let compareTo = makeToSelect.toLowerCase();
            let findMake = vmCustomerPnl.vehicleMakes.filter((item) => {
                return item.makeCode.toLowerCase() === compareTo || item.make.toLowerCase() === compareTo;
            });

            if (findMake && findMake.length > 0) {
                vmCustomerPnl.selectedMake = findMake[0];
                parent_vm.appointment.make = vmCustomerPnl.selectedMake ? vmCustomerPnl.selectedMake.makeCode : null;
            } 
            
        }

        vmCustomerPnl.cdkMissingVehicle = function () {
            let vehicleWasInserted = parent_vm.ymmForceInsertedYear ||
                                     parent_vm.ymmForceInsertedMake ||
                                     parent_vm.ymmForceInsertedModel;
            
            if (vmCustomerPnl.dmsSystem === vmCustomerPnl.dmsEnum.CDK && vehicleWasInserted) {
                if (parent_vm.editingExistingAppointment && parent_vm.appointment.dmsSyncError) {
                    return true;
                } else if (!parent_vm.editingExistingAppointment) {
                    return true;
                } else {
                    return false;
                }
            }
            
            return false;
        };

        vmCustomerPnl.selectModelInDropDown = function(modelToSelect, subModelToSelect, initiatedFromVinDecode) {
            let compareTo = modelToSelect.toLowerCase();
            let findModel = vmCustomerPnl.vehicleModels.filter((item) => {
                if (item.modelCode) {
                    return item.modelCode.toLowerCase() === compareTo || item.model.toLowerCase() === compareTo;
                } else {
                    return false;
                }
            });

            if (findModel && findModel.length > 0) {
                vmCustomerPnl.selectedModel = findModel[0];
                parent_vm.appointment.model = vmCustomerPnl.selectedModel ? vmCustomerPnl.selectedModel.modelCode : null;

                if (subModelToSelect) {
                    vehicleService.getSubModels(parent_vm.appointment.location.id, parent_vm.appointment.year, parent_vm.appointment.make, parent_vm.appointment.model).then((submodels) => {
                        vmCustomerPnl.vehicleSubModels = submodels;
                        let compareTo = subModelToSelect.toLowerCase();
                        let findSubModel = submodels.filter((item) => {
                            return item.toLowerCase() === compareTo;
                        });

                        vmCustomerPnl.selectedSubModel = findSubModel[0];
                    });
                }

                vmCustomerPnl.resetRecallMaintData();
            }

            if (initiatedFromVinDecode && vmCustomerPnl.cdkMissingVehicle()) {
                let confirm = modalService.showYesNo('Warning', 'This VIN decoded to a Year/Make/Model that is not supported by your DMS.  We recommend clicking CANCEL below and manually selecting the Year/Make/Model from the dropdown lists.<br/><br/>You can keep the selections by clicking OK, however you will get a DMS error that will prevent this appointment from being pushed or updated in your DMS.', 'CANCEL', 'OK');

                confirm.then((confirmed) => {
                    if (!confirmed) {
                        // clear out the YMM fields
                        parent_vm.appointment.make = null;
                        parent_vm.appointment.model = null;
                        parent_vm.appointment.year = null;
                        vmCustomerPnl.vehicleMakes = null;
                        vmCustomerPnl.vehicleModels = null;
                        vmCustomerPnl.selectedMake = null;
                        vmCustomerPnl.selectedModel = null;
                        vmCustomerPnl.selectedSubModel = null;
                        vmCustomerPnl.vehicleSubModels = null;
                    }
                });
            }   
        };

        vmCustomerPnl.isOwnedByOtherCustomer = function () {
            let appt = parent_vm.appointment;
            let customerId = appt.customerId === -998 ? "" : appt.customerId;

            vehicleService.isOwnedByOtherCustomer(parent_vm.appointment.location.id, appt.vin, customerId).then((response) => {
                if (response === true) {
                    modalService.showYesNo('Warning', 'This VIN is associated with another customer.  If you continue, the VIN will be associated with this customer.', null, 'OK');
                }
            });
        };

        vmCustomerPnl.isYMMSameAsOriginalApptYMM = function (year, make, model) {
            return appointmentUtilService.isYMMSameAsOriginalApptYMM(year, make, model, parent_vm.originalApptYear, parent_vm.originalApptMake, parent_vm.originalApptModel);
        };

        vmCustomerPnl.isValidVin = function (vin) {
            return rcUtilService.isValidVin(vin);
        };

        vmCustomerPnl.checkValidVin = function () {
            parent_vm.showUpdateWarning(vmCustomerPnl);
            
            let vin = parent_vm.appointment.vin;
            let vinValidObject = vmCustomerPnl.isValidVin(vin);

            parent_vm.decodedVin = false;
            vmCustomerPnl.showNoDecodedVinMessage = false;

            if (!parent_vm.appointment.vin) {
                parent_vm.decodedVin = false;
            } else if (vinValidObject?.isValid && !vinValidObject?.message) {
                vmCustomerPnl.decodingVin = true;
                parent_vm.ymmForceInsertedYear = false;
                parent_vm.ymmForceInsertedMake = false;
                parent_vm.ymmForceInsertedModel = false;
                vehicleService.decodeVin(parent_vm.appointment.location.id, parent_vm.appointment.vin).then((response) => {
                    vmCustomerPnl.decodingVin = false;

                    if (parent_vm.editingExistingAppointment && response) {
                        vmCustomerPnl.yearMakeModelMismatch = !vmCustomerPnl.isYMMSameAsOriginalApptYMM(response.year, response.makeName, response.modelName);
                    }

                    if (response !== null && response.baseVehicleID) {
                        parent_vm.decodedVin = true;
                        parent_vm.appointment.year = response.year;
                        lastRecordedMileage = parseInt(response.lastRecordedMileage, 10) || 0;
                        vmCustomerPnl.isOwnedByOtherCustomer();

                        if (response.subModelID) {
                            vmCustomerPnl.vehicleSubModels = [
                                response.subModelName
                            ];

                            vmCustomerPnl.selectedSubModel = vmCustomerPnl.vehicleSubModels[0];
                        } else {
                            vmCustomerPnl.vehicleSubModels = [];
                        }

                        vmCustomerPnl.getRecommendedMaint();
                        vmCustomerPnl.getRecalls();
                        ensureVehicleYearInDropDown();
                        vmCustomerPnl.yearUpdated(response.makeName, response.modelName, null, true);                       
                        updateVehicleDropdown();
                    } else {
                        vmCustomerPnl.showNoDecodedVinMessage = true;
                    }
                }, (errorResponse) => {
                    vmCustomerPnl.decodingVin = false;
                    vmCustomerPnl.showNoDecodedVinMessage = true;
                });
            }
        };

        vmCustomerPnl.checkPhoneType = function(phoneNumber) {
            if (phoneNumber && phoneNumber.length === 10) {
                vmCustomerPnl.isPhoneNumberValidating = true;
                messagesService.checkPhoneNumber(phoneNumber, parent_vm.appointment.location.id).then((response) => {
                    parent_vm.customerPhoneType = response;
                    parent_vm.appointment.invalidPhone = false;
                }).finally(() => {
                    vmCustomerPnl.isPhoneNumberValidating = false;
                });
            } else {
                parent_vm.customerPhoneType = {type: parent_vm.phoneTypes.unknown};
                parent_vm.appointment.invalidPhone = true;
            }
        };

        vmCustomerPnl.customerSelected = function (initializing) {
            if (parent_vm.addingCustomer === true) {
                vmCustomerPnl.cancelAddCustomer(null, true);
            }

            let selCustomer = parent_vm.selectedCustomer;
            let appt = parent_vm.appointment;
            let year = parseInt(appt.year);
            let make = appt.make;
            let model = appt.model;
            let vin = appt.vin;

            // todo clean this up in PROD-16765 and stop using this property and use appointment.location.id everywhere
            appt.dealerId = appt.location.id;

            if (selCustomer) {
                if (selCustomer.customerId === -998 || selCustomer.customerId === "-998") {
                    vmCustomerPnl.addNewCustomer(initializing);
                    angular.extend(parent_vm.appointment, selCustomer);
                    parent_vm.customer = true;

                    if (parent_vm.appointment.customerPhone) {
                        vmCustomerPnl.mobilePhoneUpdated(parent_vm.appointment.customerPhone, true);
                    }

                    if (parent_vm.appointment.year !== null) {
                        $timeout(() => {
                            addCreateNewToCustomerVehicles();
                            setNewCurrentVehicle();
                            parent_vm.updateCustomerVehicleModelAfterLoad();
                        }, 1);
                    }
                } else {
                    if (selCustomer.customerType === parent_vm.customerType.business) {
                        parent_vm.appointment.customerIsBusiness = true;
                        vmCustomerPnl.isBusinessUpdated();
                    } 
                    
                    parent_vm.availableCustomerVehicles = null;
                    vmCustomerPnl.selCustomerVehicles = null;

                    //Motive-AutoSoft is silly and may not return customers with customer ids, by design.  AutoSoft creates customers only when a repair order is created.
                    //Check if we have a customer id, except in the case of AutoSoft (only Motive Integration at the moment.)
                    const advisorFromId = !selCustomer.lastServiceAdvisor && selCustomer.lastServiceAdvisorId
                        ? parent_vm.serviceAdvisors.find((advisor) => advisor.employeeNumber === selCustomer.lastServiceAdvisorId)
                        : null;
                    const customerLastServiceAdvisor = selCustomer.lastServiceAdvisor || advisorFromId;

                    if (selCustomer.customerId || (vmCustomerPnl.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.Motive && selCustomer)) {
                        vmCustomerPnl.loadingCustomer = false;

                        if (!parent_vm.resolvedAppointmentId && selCustomer) {
                            angular.extend(parent_vm.appointment, selCustomer);
                            parent_vm.lastServiceAdvisor = customerLastServiceAdvisor;
                        } else if (selCustomer) {
                            // PROD-15908: Preserve manually entered address when customer from DMS has no address
                            const addressFields = ['customerZip', 'customerCity', 'customerAddress1', 'customerState'];
                            const preservedAddress = {};
                            
                            addressFields.forEach(field => {
                                preservedAddress[field] = parent_vm.appointment[field];
                            });
                            
                            angular.extend(parent_vm.appointment, selCustomer);
                            
                            addressFields.forEach(field => {
                                if (!selCustomer[field] || selCustomer[field] === "") {
                                    parent_vm.appointment[field] = preservedAddress[field];
                                }
                            });
                        }

                        parent_vm.originalApptFirstName = parent_vm.appointment.customerFirstName;
                        parent_vm.originalApptLastName = parent_vm.appointment.customerLastName;
                        parent_vm.originalApptMobile = parent_vm.appointment.customerPhone;
                        parent_vm.originalApptEmail = parent_vm.appointment.customerEmail;

                        parent_vm.availableCustomerVehicles = selCustomer.customerVehicles;
                        addCreateNewToCustomerVehicles();
                        vmCustomerPnl.fillAvailableCustomerVehicles(year, make, model, vin, selCustomer);
                        
                        parent_vm.customer = true;
                        parent_vm.updateCustomerVehicleModelAfterLoad();
                        vmCustomerPnl.mobilePhoneUpdated(parent_vm.appointment.customerPhone, true);
                    } else {
                        vmCustomerPnl.loadingCustomer = false;
                        angular.extend(parent_vm.appointment, selCustomer);
                        parent_vm.lastServiceAdvisor = customerLastServiceAdvisor;

                        parent_vm.originalApptFirstName = parent_vm.appointment.customerFirstName;
                        parent_vm.originalApptLastName = parent_vm.appointment.customerLastName;
                        parent_vm.originalApptMobile = parent_vm.appointment.customerPhone;
                        parent_vm.originalApptEmail = parent_vm.appointment.customerEmail;

                        parent_vm.availableCustomerVehicles = selCustomer.customerVehicles;
                        addCreateNewToCustomerVehicles();
                        parent_vm.appointment.year = parseInt(year);
                        vmCustomerPnl.fillAvailableCustomerVehicles(year, make, model, vin, selCustomer);
                        
                        parent_vm.customer = true;
                        parent_vm.updateCustomerVehicleModelAfterLoad();
                        vmCustomerPnl.mobilePhoneUpdated(parent_vm.appointment.customerPhone, true);
                    }

                }
            }
        };

        vmCustomerPnl.fillAvailableCustomerVehicles = function (year, make, model, vin, selCustomer) {
            let customerVehicleCount = parent_vm.availableCustomerVehicles.length;
            let selectedVehicle = selCustomer.vehicle;
            let allCustomerVehicles =  parent_vm.availableCustomerVehicles;

            if (customerVehicleCount > 1) {
                parent_vm.appointment.year = parseInt(year);
                let filterObj = null;

                if (vin && vin.trim().length > 0) {
                    filterObj = {
                        vin: vin
                    };
                } else if (year) {
                    filterObj = {
                        year: year,
                        make: make,
                        model: model
                    };
                }
        
                if (filterObj) {
                    parent_vm.currentVehicle = allCustomerVehicles.find((vehicle) => Object.keys(filterObj).every((key) => vehicle[key] === filterObj[key]));
                } else if (customerVehicleCount === 2) {
                    parent_vm.currentVehicle = allCustomerVehicles[0];
                    vmCustomerPnl.customerVehicleSelected(parent_vm.currentVehicle);
                } else if (customerVehicleCount > 2 && selectedVehicle && selectedVehicle.vehicleId) { // If we have more than one vehicle to select, and we've selected a customer with vehicle info
                    parent_vm.currentVehicle = allCustomerVehicles.find((vehicle) => vehicle.vehicleId === selectedVehicle.vehicleId);
                    vmCustomerPnl.customerVehicleSelected(parent_vm.currentVehicle);
                } else if (customerVehicleCount > 2 && selectedVehicle && selectedVehicle.vin) { // If we have more than one vehicle to select, and we've selected a customer with vehicle info
                    parent_vm.currentVehicle = allCustomerVehicles.find((vehicle) => vehicle.vin === selectedVehicle.vin);
                    vmCustomerPnl.customerVehicleSelected(parent_vm.currentVehicle);
                }
        
                if (!parent_vm.currentVehicle && parent_vm.editingExistingAppointment) {
                    setNewCurrentVehicle();
                }
        
                if (year) {
                    ensureVehicleYearInDropDown();
                    ensureVehicleMakeInDropDown();
                    ensureVehicleModelInDropDown();
                }
            } else {
                setNewCurrentVehicle();
            }
        };

        vmCustomerPnl.displayAddressFields = function () {
            return appointmentUtilService.displayAddressFields(parent_vm.editingExistingAppointment, vmCustomerPnl.displayAdditionalFields, parent_vm.dmsRequiredFields);
        };

        vmCustomerPnl.displayCountyCountry = function () {
            return appointmentUtilService.displayCountyCountry(parent_vm.editingExistingAppointment, vmCustomerPnl.displayAdditionalFields, parent_vm.dmsRequiredFields);
        };

        vmCustomerPnl.displayLanguage = function () {
            return appointmentUtilService.displayLanguage(parent_vm.editingExistingAppointment, vmCustomerPnl.displayAdditionalFields, parent_vm.dmsRequiredFields);
        };

        vmCustomerPnl.displayAddtionalFieldsLink = function () {
            return parent_vm.dmsRequiredFields && parent_vm.editingExistingAppointment && (parent_vm.dmsRequiredFields.customerCity || parent_vm.dmsRequiredFields.customerState || parent_vm.dmsRequiredFields.customerZip || parent_vm.dmsRequiredFields.customerAddress || parent_vm.dmsRequiredFields.customerCountry || parent_vm.dmsRequiredFields.customerCounty || parent_vm.dmsRequiredFields.language);
        };

        vmCustomerPnl.displayAdditionalFieldsClicked = function () {
            vmCustomerPnl.displayAdditionalFields = !vmCustomerPnl.displayAdditionalFields;
        };

        vmCustomerPnl.forceAddCustomer = function () {
            if (parent_vm.addingCustomer === true) {
                vmCustomerPnl.cancelAddCustomer(null, true);
            }

            parent_vm.selectedCustomer = appointmentUtilService.createNewCustomerEntry();

            let selCustomer = parent_vm.selectedCustomer;

            vmCustomerPnl.addNewCustomer();
            angular.extend(parent_vm.appointment, selCustomer);
            parent_vm.customer = true;
        };

        vmCustomerPnl.hasSelectedCustomer = function () {
            return parent_vm.appointment.customerType !== null;
        };

        vmCustomerPnl.customerVehicleSelected = function (selectedVehicle) {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            parent_vm.decodedVin = false;

            if (parent_vm.addingCustomerVehicle === true) {
                vmCustomerPnl.cancelAddCustomerVehicle(null, true);
            }

            // fixes odd issue that was occuring w/ select2 component
            if (parent_vm.currentVehicle !== selectedVehicle) {
                parent_vm.currentVehicle = selectedVehicle;
            }

            if (selectedVehicle && selectedVehicle.vehicleId === -998) {
                vmCustomerPnl.selectedMake = null;
                vmCustomerPnl.selectedModel = null;
                parent_vm.appointment.mileage = null;
                createNewVehicle();
            } else if (selectedVehicle) {
                parent_vm.appointment.vehicleId = selectedVehicle.vehicleId;
                parent_vm.appointment.year = selectedVehicle.year;
                parent_vm.appointment.make = selectedVehicle.make;
                parent_vm.appointment.model = selectedVehicle.model;
                parent_vm.appointment.vin = selectedVehicle.vin;
                parent_vm.appointment.mileage = selectedVehicle.mileage;
                let make = appointmentUtilService.getDisplayMake(parent_vm.appointment);
                let model = appointmentUtilService.getDisplayModel(parent_vm.appointment);

                vmCustomerPnl.yearUpdated(make, model);

                if (selectedVehicle.vin) {
                    $timeout(() => {
                        vmCustomerPnl.checkValidVin();
                    }, 1);
                }
            }

            vmCustomerPnl.yearMakeModelMismatch = !vmCustomerPnl.isYMMSameAsOriginalApptYMM(parent_vm.appointment.year, parent_vm.appointment.make, parent_vm.appointment.model);

            let odometerEl = $window.document.getElementById('odometer');

            if (odometerEl) {
                $timeout(() => {
                    odometerEl.focus();
                }, 0);
            }
        };

        vmCustomerPnl.resetRecallMaintData = function () {
            parent_vm.recMaintData = null;
            parent_vm.recalls = null;
            parent_vm.recMaintChecked = false;
            parent_vm.recallsChecked = false;

            if (parent_vm.appointment.vin) {
                vmCustomerPnl.getRecalls();

                if (parent_vm.appointment.mileage) {
                    vmCustomerPnl.getRecommendedMaint();
                }
            }
        };

        vmCustomerPnl.vehicleKeyDown = function (e) {
            rcUtilService.vehicleKeyDown(e);
        };

        vmCustomerPnl.switchYMMToDropDowns = function () {
            vmCustomerPnl.ymmOlderVehicles = false;
            parent_vm.appointment.year = null;
            parent_vm.appointment.make = null;
            parent_vm.appointment.model = null;
        };

        vmCustomerPnl.switchYMMToTextInputs = function () {
            vmCustomerPnl.ymmOlderVehicles = true;
            parent_vm.appointment.year = null;
        };

        vmCustomerPnl.yearUpdated = function (makeToSelect, modelToSelect, subModelToSelect, initiatedFromVinDecode) {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            if (parent_vm.appointment.year === OLDER_VEHICLES) {
                vmCustomerPnl.switchYMMToTextInputs();

                return;
            }

            if (vmCustomerPnl.lastGetMakesYear !== parent_vm.appointment.year || !vmCustomerPnl.vehicleMakes) {
                vmCustomerPnl.updateVehicleMakes = true;
                parent_vm.nextBusy = true;
                vmCustomerPnl.lastGetMakesYear = parent_vm.appointment.year;
                vehicleService.getMakesInYear(parent_vm.appointment.location.id, parent_vm.appointment.year).then((result) => {
                    vmCustomerPnl.vehicleMakes = result;
                    parent_vm.appointment.make = null;
                    parent_vm.appointment.model = null;
                    vmCustomerPnl.selectedMake = null;
                    vmCustomerPnl.selectedModel = null;
                    vmCustomerPnl.lastGetModelMake.makeCode = null;
                    vmCustomerPnl.lastGetModelMake.modelCode = null;

                    if (makeToSelect) {
                        ensureVehicleMakeInDropDown(makeToSelect);
                        selectMakeInDropDown(makeToSelect);
                    }

                    if (!modelToSelect) {
                        vmCustomerPnl.resetRecallMaintData();
                    }

                    vmCustomerPnl.makeUpdated(modelToSelect, subModelToSelect, initiatedFromVinDecode);
                    parent_vm.nextBusy = false;
                    vmCustomerPnl.updateVehicleMakes = false;
                }).finally(() => {
                    parent_vm.nextBusy = false;
                    vmCustomerPnl.updateVehicleMakes = false;
                });
            } else {
                if (makeToSelect) {
                    ensureVehicleMakeInDropDown(makeToSelect);
                    selectMakeInDropDown(makeToSelect);
                }

                vmCustomerPnl.makeUpdated(modelToSelect, subModelToSelect, initiatedFromVinDecode);
            }
        };

        vmCustomerPnl.makeUpdated = function (modelToSelect, subModelToSelect, initiatedFromVinDecode) {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            let make = vmCustomerPnl.selectedMake;

            parent_vm.appointment.make = make ? make.makeCode : null;

            if (make && vmCustomerPnl.lastGetModelMake.makeCode !== make.makeCode) {
                vmCustomerPnl.updateVehicleModels = true;
                parent_vm.nextBusy = true;
                vmCustomerPnl.lastGetModelMake = make;
                vmCustomerPnl.deferred = $q.defer();
                vehicleService.getModels(parent_vm.appointment.location.id, parent_vm.appointment.year, make.make).then((result) => {
                    vmCustomerPnl.vehicleModels = result;
                    vmCustomerPnl.selectedModel = null;

                    if (modelToSelect) {
                        ensureVehicleModelInDropDown(modelToSelect);
                        setTimeout(() => {
                            vmCustomerPnl.selectModelInDropDown(modelToSelect, subModelToSelect, initiatedFromVinDecode);

                            if (vmCustomerPnl.initialYMMLoad) {
                                //TODO: Revisit after release, determine why the UpdateWarning popup was still displaying
                                setTimeout(() => {
                                    vmCustomerPnl.initialYMMLoad = false;
                                }, 750);
                            }
                        }, 1);
                    }

                    if (!modelToSelect) {
                        vmCustomerPnl.resetRecallMaintData();
                    }

                    if (parent_vm.decodedVin) {
                        ensureVehicleModelInDropDown();
                    }

                    vmCustomerPnl.deferred.resolve(true);

                    vmCustomerPnl.updateVehicleModels = false;
                    parent_vm.nextBusy = false;

                }).finally(() => {
                    vmCustomerPnl.updateVehicleModels = false;
                    parent_vm.nextBusy = false;
                });
            }
        };

        vmCustomerPnl.modelUpdated = function () {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            let model = vmCustomerPnl.selectedModel;

            parent_vm.appointment.model = model ? model.modelCode : null;

            if (parent_vm.appointment.model) {
                vehicleService.getSubModels(parent_vm.appointment.location.id, parent_vm.appointment.year, vmCustomerPnl.selectedMake.make, model.model).then((result) => {
                    vmCustomerPnl.vehicleSubModels = result;
                    vmCustomerPnl.deferred.resolve(true);
                    parent_vm.nextBusy = false;
                }).finally(() => {
                    vmCustomerPnl.resetRecallMaintData(true);
                    vmCustomerPnl.updateVehicleModels = false;
                    parent_vm.nextBusy = false;
                });
            } else {
                vmCustomerPnl.vehicleSubModels = null;
            }
        };

        vmCustomerPnl.subModelUpdated = function () {
            parent_vm.showUpdateWarning(vmCustomerPnl);
            parent_vm.appointment.subModel = vmCustomerPnl.selectedSubModel;
        };

        vmCustomerPnl.clearSelectedVehicle = function (loadYears) {
            parent_vm.showUpdateWarning(vmCustomerPnl);
            parent_vm.clearVehicle();
            parent_vm.decodedVin = false;
            parent_vm.ymmForceInsertedYear = false;
            parent_vm.ymmForceInsertedMake = false;
            parent_vm.ymmForceInsertedModel = false;
            parent_vm.addingCustomerVehicle = null;

            if (loadYears === true) {
                loadVehicleYears();
            }

            parent_vm.previouslyDeclinedServices = null;
            parent_vm.recalls = null;
            parent_vm.recMaintData = null;
            parent_vm.vehicleHistory = null;
            parent_vm.appointment.make = null;
            parent_vm.appointment.model = null;
            parent_vm.appointment.year = null;
            vmCustomerPnl.vehicleMakes = null;
            vmCustomerPnl.vehicleModels = null;
            vmCustomerPnl.selectedMake = null;
            vmCustomerPnl.selectedModel = null;
            vmCustomerPnl.selectedSubModel = null;
            vmCustomerPnl.vehicleSubModels = null;
            vmCustomerPnl.vehicleTypeAheadSuggestions = [];
            resetVehicleTypeAhead();
            // Repopulate vehicle options so customer vehicles are available immediately.
            vmCustomerPnl.refreshVehicleSuggestions('');
        };

        function resetVehicleData() {
            vmCustomerPnl.ymmOlderVehicles = false;
            vmCustomerPnl.clearSelectedVehicle(true);
            parent_vm.availableCustomerVehicles = null;
            parent_vm.currentVehicle = null;
            parent_vm.appointment.lineItems = [];
            parent_vm.getSelectedServicesCounts();
        }

        vmCustomerPnl.isBusinessUpdated = function () {
            parent_vm.appointment.customerType = parent_vm.appointment.customerIsBusiness ? parent_vm.customerType.business : parent_vm.customerType.individual;
        };

        vmCustomerPnl.addNewCustomer = function (initializing) {
            parent_vm.clearCustomer();
            parent_vm.updateCustomerVehicleModelAfterLoad();
            addCreateNewToCustomerVehicles();
            createNewVehicle(initializing);
            parent_vm.addingCustomer = true;

        };

        vmCustomerPnl.checkForDuplicateCustomer = function () {
            return new Promise((resolve, reject) => {
                let appt = parent_vm.appointment;
                let lastDupChecked = parent_vm.lastDuplicateCustomerChecked;

                let loadCustomer = function (result) {
                    if (result) {
                        customerService.getCustomersByDMSCustNo(appt.location.id, result.custNo).then((customerResult) => {
                            if (customerResult) {
                                angular.extend(parent_vm.selectedCustomer, customerResult);
                                vmCustomerPnl.customerSelected();
                            }

                            resolve();
                        });
    
                    } else {
                        vmCustomerPnl.confirmedCreateDuplicate = true;
                        resolve();
                    }
    
                    vmCustomerPnl.checkingDuplicateCustomer = false;
                };
        
        
                if (!appt.customerPhone || !appt.customerEmail || vmCustomerPnl.checkingDuplicateCustomer === true) {
                    resolve();

                    return;
                }
        
                let isValidEmail = rcUtilService.isValidEmail(appt.customerEmail);

                if (appt.customerPhone.length !== 10 || (isValidEmail && isValidEmail.isValid === false)) {
                    resolve();

                    return;
                }
                
               
                if (appt.customerPhone === lastDupChecked.phone && appt.customerEmail === lastDupChecked.email && vmCustomerPnl.confirmedCreateDuplicate === true) {
                    resolve();

                    return;
                }
        
                if (!parent_vm.editingExistingAppointment && parent_vm.addingCustomer) {
                    vmCustomerPnl.checkingDuplicateCustomer = true;
                    parent_vm.lastDuplicateCustomerChecked = {
                        email: appt.customerEmail,
                        phone: appt.customerPhone
                    };
        
                    customerService.checkDuplicateCustomer(appt.location.id, appt.customerEmail, appt.customerPhone)
                        .then((result) => {
                            let foundDmsMatch = result.foundDmsMatch;
                            let customers = result.customers;

                            // CAZ FOUNDDMSMATCH IS NOT WORKING CORRECTLY FOR ALL DMS ... ESPECIALLY REYNOLDS.. NEED TO REVISIT IT.
                            /*if (foundDmsMatch && customers && customers.length === 1) {
                            modalService.showYesNo("Customer Exists", "Matching customer record found in your DMS.  Click 'OK' to continue.", null, "OK")
                            .then(function(result) {
                                loadCustomer(customers[0]);
                            });
                        } else*/ if (customers && customers.length > 0 && parent_vm.accordion.selectedStep === _steps.customerVehicle) {
                                // show modal to have user select customer.
                                modalService.showDuplicateCustomerModal(customers).then((result) => {
                                    loadCustomer(result);
                                });
                            } else {
                                resolve();
                            }
                        });
                } else {
                    resolve();
                }
            });
        };

        vmCustomerPnl.cancelAddCustomer = function (nextStep, fromCustomerSelected) {

            resetVehicleData();

            if (!nextStep) {
                nextStep = _steps.customerVehicle;
            }

            parent_vm.disableNext = false;
            vmCustomerPnl.submitted = false;
            parent_vm.addingCustomer = false;
            parent_vm.nextBusy = false;
            parent_vm.resetAppointment();
            parent_vm.accordion.selectedStep = nextStep;
            clearCustomerTypeAheadState();

            if (!fromCustomerSelected) {
                $rootScope.$broadcast('stepChanged');
            }
        };

        vmCustomerPnl.cancelAddCustomerVehicle = function () {
            resetVehicleData();
        };

        vmCustomerPnl.clearSelectedCustomer = function (selectEl) {
            vmCustomerPnl.cancelAddCustomer(_steps.customerVehicle);
            parent_vm.lastServiceAdvisor = null;
            parent_vm.resetAppointment();

            if (parent_vm.customerPhoneType) {
                parent_vm.customerPhoneType.type = null;
            }
        };

        vmCustomerPnl.returnToCustomerStep = function () {
            parent_vm.accordion.selectedStep = _steps.customerVehicle;
            $rootScope.$broadcast('stepChanged');
        };

        vmCustomerPnl.recallRecMaintUncheckedNote = function () {
            let message = "";
            let appt = parent_vm.appointment;

            if (appt.departmentRecallForceUnchecked === true && appt.departmentRecMaintForceUnchecked === true) {
                message += "Recalls and Recommended Maintenance are";
            } else if (appt.departmentRecallForceUnchecked === true) {
                message += "Recalls are";
            } else {
                message += "Recommended Maintenance is";
            }

            message += " not supported in this department.";

            return message;
        };

        vmCustomerPnl.recallLineItemToggled = function (recall) {
            $timeout(() => {
                parent_vm.showUpdateWarning(vmCustomerPnl);
                let existingIndex = -1;

                recall.checked = !recall.checked;

                if (recall.checked) {
                    parent_vm.servicesModified = true;
                    // Check the parent original line items
                    existingIndex = parent_vm.originalAppointmentLineItems.findIndex((l) => {
                        return l.manufacturerNumber === recall.manufacturerNumber;
                    });

                    if (existingIndex > -1) {
                        // Shallow copy the line, in the case we've toggled the line on and off, there is no reason to not send the original already saved line
                        let existingRecall = appointmentLineItemClass.new(parent_vm.originalAppointmentLineItems[existingIndex]);

                        // Throw back on the recall data for the UI
                        existingRecall.checked = recall.checked;
                        existingRecall.nhtsaId = recall.nhtsaId;
                        existingRecall.recallDisplayName = recall.displayName;
                        parent_vm.appointment.lineItems.push(existingRecall);
                    } else {
                        // Create a new line
                        let recallOpCodes = appointmentUtilService.getDeptOpCodes(parent_vm.dealerRecallOpCodes, parent_vm.appointment.departmentId);
                        let newRecallLineItem = appointmentUtilService.createNewRecallLineItem(recallOpCodes[0], recall);
                        
                        newRecallLineItem.dateCreated = moment.utc();
                        newRecallLineItem.isRecall = true;
                        newRecallLineItem.isUpsell = false;
                        parent_vm.appointment.lineItems.push(newRecallLineItem);
                    }
                } else {
                    // Remove the existing line from the set
                    existingIndex = parent_vm.appointment.lineItems.findIndex((l) => { return l.manufacturerNumber === recall.manufacturerNumber; });
                    parent_vm.appointment.lineItems.splice(existingIndex, 1);
                }

                // clear out all the ids .. so the created by gets reset
                let allRecalls = parent_vm.appointment.lineItems.filter((lineItem) => lineItem.isRecall === true);

                if (allRecalls && allRecalls.length > 0) {
                    allRecalls.forEach((lineItem) => {
                        lineItem.id = null;
                    });
                }

                let validRecalls = vmCustomerPnl.validation.valRecalls();

                if (validRecalls.isValid === true) {
                    parent_vm.tooManyRecalls = false;
                    revalidateForm();
                } else {
                    parent_vm.tooManyRecalls = true;
                }

                parent_vm.getSelectedServicesCounts();
            }, 1);
        };

        vmCustomerPnl.recMaintItemToggle = function (recMaint, event) {
            parent_vm.showUpdateWarning(vmCustomerPnl);
            let existingIndex = -1;

            // Properly handle change events, as well as deselecting events
            (parent_vm.recMaintData || []).forEach((item) => {
                // Deselect previous items
                if (item.interval !== recMaint.interval) {
                    item.checked = false;
                }
            });
            recMaint.checked = !recMaint.checked;

            if (recMaint.checked) {
                parent_vm.servicesModified = true;
                appointmentUtilService.processDashboardRecMaintChecked(parent_vm.appointment, parent_vm.appointment.lineItems, vmCustomerPnl.dmsSystem, parent_vm.dealerRecommendedMaintenanceOpCodes, recMaint, false);

                if (parent_vm.previouslyDeclinedServices) {
                    let recMaintToUncheck = parent_vm.previouslyDeclinedServices.filter((service) => service.checked === true && service.isRecommendedMaintenance === true); 
    
                    if (recMaintToUncheck && recMaintToUncheck.length > 0) {
                        recMaintToUncheck[0].checked = false;
                    }
                }
            } else {
                parent_vm.selectedRecMaint = null;

                // Remove the existing line from the set
                existingIndex = parent_vm.appointment.lineItems.findIndex((l) => { return l.isRecommendedMaintenance; });
                parent_vm.appointment.lineItems.splice(existingIndex, 1);
            }

            parent_vm.getSelectedServicesCounts();
        };

        vmCustomerPnl.disableYear = function () {
            if (vmCustomerPnl.cdkMissingVehicle()) return false;

            return vmCustomerPnl.decodingVin || parent_vm.decodedVin || (parent_vm.resolvedAppointmentId && !parent_vm.addingCustomerVehicle);
        };

        vmCustomerPnl.disableMake = function () {
            if (vmCustomerPnl.cdkMissingVehicle()) return false;

            return vmCustomerPnl.decodingVin || parent_vm.decodedVin || !parent_vm.appointment.year || vmCustomerPnl.updateVehicleMakes || vmCustomerPnl.updatingYears || (parent_vm.resolvedAppointmentId && !parent_vm.addingCustomerVehicle);
        };

        vmCustomerPnl.disableModel = function () {
            if (vmCustomerPnl.cdkMissingVehicle()) return false;

            return vmCustomerPnl.decodingVin || parent_vm.decodedVin || !vmCustomerPnl.selectedMake || vmCustomerPnl.decodingVin || vmCustomerPnl.updatingYears || vmCustomerPnl.updateVehicleModels || vmCustomerPnl.updateVehicleMakes || (parent_vm.resolvedAppointmentId && !parent_vm.addingCustomerVehicle);
        };

        function gotoWalkIn () {

            parent_vm.appointment.isWalkin = true;
            parent_vm.appointment.appointmentStatus = APPOINTMENT_APPOINTMENTSTATUS.walkIn;
          
            let now = moment();
            let dateString = now.format('MM/DD/YYYY');
            let dateTimeString = now.format('MM/DD/YYYY hh:mm A');

            parent_vm.appointment.apptDate = dateString;
            parent_vm.appointment.apptDateTime = dateTimeString;

            // set the appropriate transportation type
            let allTransportationTypes = parent_vm.dealerTransportationTypes;
            let dropOffTransportationTypes = allTransportationTypes.filter((transportationType) => transportationType.isDropOff === true);
            let defaultDropOff = dropOffTransportationTypes.filter((transportationType) => transportationType.isDefault === true);
    
            if (defaultDropOff.length > 0) {
                defaultDropOff = defaultDropOff[0];
            } else {
                defaultDropOff = dropOffTransportationTypes[0];
            }

            parent_vm.appointment.lineItems = [];
            parent_vm.appointment.transportationType = defaultDropOff;
            parent_vm.appointment.dealerTransportationTypeId = parent_vm.appointment.transportationType.id;

            parent_vm.appointment.disableNotifications = true;
            parent_vm.appointment.disableSendLoanerHomework = true;
            parent_vm.nextBusy = true;
            appointmentService.createOrUpdateAppointment(parent_vm.appointment.location.id, parent_vm.appointment, false).then((result) => {
                parent_vm.nextBusy = true;

                if (result && !result.errors) {
                    $state.go('appointment-checkin' + vmCustomerPnl.suffix, { 
                        locationId: parent_vm.appointment.location.id,
                        customerId: parent_vm.appointment.customerId,
                        appointmentId: result.id
                    });
                } else {
                    console.log(result.errors);
                }
            });
        }

        function customerDataChanged() {
            if (parent_vm.addingCustomer) return false;
            
            let appt = parent_vm.appointment;

            return parent_vm.originalApptFirstName !== appt.customerFirstName || parent_vm.originalApptLastName !== appt.customerLastName || parent_vm.originalApptMobile !== appt.customerPhone || parent_vm.originalApptEmail !== appt.customerEmail;
        }

        vmCustomerPnl.nextClicked = function () {
            let valid;
            let invalidVin;
            let appt = parent_vm.appointment;
            let dmsSystem = vmCustomerPnl.dmsSystem;
            let dmsEnum = vmCustomerPnl.dmsEnum;

            saveAllServices();       

            if (parent_vm.getSelectedLineItemCount() === 0 && vmCustomerPnl.activeProduct === 'appointment-list') {
                vmCustomerPnl.submitted = true;
                parent_vm.appointment.noLineItemsSelected = true;
            } else {
                parent_vm.appointment.noLineItemsSelected = false;
            }

            valid = _validationService.checkFormValidity($scope.bookApptForm);
            invalidVin = appt.vin && appt.vin.length > 0 && appt.vin.length < 17;

            if (!valid || !appt.customerType || parent_vm.appointment.invalidPhone || parent_vm.appointment.noLineItemsSelected || invalidVin) {
                vmCustomerPnl.submitted = true;

                return false;
            }

            parent_vm.appointment.noLineItemsSelected = false;

            if (!parent_vm.appointment.appointmentStatus) {
                parent_vm.appointment.appointmentStatus = parent_vm.getStatus(APPOINTMENTSTATUS_LABELS.draft);
            }


            let continueNext = function () {
                let phoneWarning = $q.when;  // Do not show any warning
                let phoneType = parent_vm.customerPhoneType;

                if (phoneType.type === parent_vm.phoneTypes.landline) {
                    phoneWarning = modalService.showLandlineWarning;
                } else if (phoneType.type === parent_vm.phoneTypes.voip) {
                    phoneWarning = modalService.showVoIPWarning;
                }

                phoneWarning().then(() => {
                    if (vmCustomerPnl.activeProduct === 'checkin-list') {
                        gotoWalkIn();
                    } else if (parent_vm.appointment.appointmentStatus === parent_vm.getStatus(APPOINTMENTSTATUS_LABELS.draft)) {
                        parent_vm.nextBusy = true;
                        // Remove that last empty line
                        rcUtilService.removeFromArray(parent_vm.appointment.lineItems, (lineItem) => lineItem.isOther === true && lineItem.checked === false);

                        if (parent_vm.previouslyDeclinedServices?.length > 0) {
                            parent_vm.appointment.previouslyDeclinedItems = parent_vm.previouslyDeclinedServices.map((service) => { return {id: service.id, deleted: service.isDeleted, decline: false}; });
                        }
                        
                        appointmentService.createOrUpdateAppointment(parent_vm.appointment.location.id, parent_vm.appointment, false).then((result) => {
                            parent_vm.nextBusy = false;
                            let defaultDepartmentPromise = $q.when(false);

                            if (result && !result.errors) {
                                let defaultDept = parent_vm.dealerDepartments.find(d => d.id === result.defaultDealerDepartmentId);
                                let isDefaultDeptDisabled = defaultDept ? defaultDept.isDisabled : false;

                                if (result.canUseDefaultDepartment && result.defaultDealerDepartmentId !== result.departmentId && !isDefaultDeptDisabled) {
                                    let defaultDepartment = parent_vm.dealerDepartments.find((department) => department.id === result.defaultDealerDepartmentId);

                                    defaultDepartmentPromise = modalService.showYesNo('Use Default Department?', 'All line items on this appointment route to the same default department: <strong>' + defaultDepartment.name + '</strong>.<br />Would you like to set the appointment to the default department?', 'Keep Current Department', 'Use Default Department', true);
                                }

                                defaultDepartmentPromise.then((confirmed) => {
                                    if (confirmed) {
                                        result.departmentId = result.defaultDealerDepartmentId;
                                    }

                                    parent_vm.loadAppointment(result);
                                    parent_vm.getSelectedServicesCounts();
                                    loadScheduleTransportationPanel();
                                });
                            } else if (result && result.errors && result.errors.length > 0) {
                                modalService.showError('Sorry, there was a problem saving your appointment:', result.errors);
                            } else {
                                modalService.showGenericApptError();
                            }
                        });
                    } else {
                        // Save checked 'other services' on appointment edit
                        let notSavedServices = parent_vm.appointment.lineItems.filter((lineItem) => lineItem.isOther === true && lineItem.checked === true && lineItem.id === 0);

                        if (notSavedServices && notSavedServices.length > 0) {
                            notSavedServices.forEach((notSavedService) => {
                                notSavedService.id = -1;
                            });
                        }   

                        // In the case that line items have been edited, we need to recheck our default department
                        appointmentService.getDefaultDepartment(parent_vm.appointment.location.id, parent_vm.appointment).then((response) => {
                            let defaultDepartmentPromise = $q.when(false);

                            parent_vm.appointment.canUseDefaultDepartment = response.canUseDefaultDepartment;
                            parent_vm.appointment.defaultDealerDepartmentId = response.defaultDealerDepartmentId;

                            let defaultDept = parent_vm.dealerDepartments.find(d => d.id === response.defaultDealerDepartmentId);
                            let isDefaultDeptDisabled = defaultDept ? defaultDept.isDisabled : false;

                            if (response.canUseDefaultDepartment && response.defaultDealerDepartmentId !== parent_vm.appointment.departmentId && !isDefaultDeptDisabled) {
                                let defaultDepartment = parent_vm.dealerDepartments.find((department) => department.id === response.defaultDealerDepartmentId);

                                defaultDepartmentPromise = modalService.showYesNo('Use Default Department?', 'Based on the configuration of the selected services, this appointment should be booked to the following department: <strong>' + defaultDepartment.name + '</strong>.<br />Would you like to set the appointment to the default department?', 'Keep Current Department', 'Use Default Department', true);
                            }

                            defaultDepartmentPromise.then((confirmed) => {
                                if (confirmed) {
                                    parent_vm.appointment.departmentId = response.defaultDealerDepartmentId;
                                }

                                loadScheduleTransportationPanel();
                            });
                        });
                    }
                });
            };

            if (parent_vm.accordion.selectedStep === _steps.customerVehicle) {
                let custDataChanged = customerDataChanged();
                
                if (custDataChanged && dmsSystem !== dmsEnum.None) {
                    modalService.showYesNo('Customer Data Changed', 'Customer details have been changed.  Are you sure you want to update the customer’s record in your DMS?', 'No', 'Yes', true).then((confirmed) => {
                        if (confirmed) {
                            continueNext();
                        }
                    });
                } else {
                    continueNext();
                }
            }
        };

        function saveAllServices() {
            let allServices = [];

            // For some reason all of these services exist in different collections, so we need to consolidate the updates into
            //   the authorizedService collection before saving.  This will be handled more generically in the upcoming rewrite.
            // Because these collections are not reliably set and could be null, we have to check each individually before adding them
            if (parent_vm.dealerOpCodes?.length > 0)
                allServices = allServices.concat(parent_vm.dealerOpCodes);

            if (parent_vm.recalls?.length > 0)
                allServices = allServices.concat(parent_vm.recalls);
            
            if (parent_vm.previouslyDeclinedServices?.length > 0)
                allServices = allServices.concat(parent_vm.previouslyDeclinedServices);

            if (parent_vm.recMaintData?.length > 0)
                allServices = allServices.concat(parent_vm.recMaintData);

            if (parent_vm.appointment.lineItems?.length > 0)
                allServices = allServices.concat(parent_vm.appointment.lineItems);
                 
            allServices.filter((op) => op.checked).forEach((op) => {
                appointmentUtilService.processDashboardLineItemUpdated(parent_vm.appointment, op);
            });  
        }

        function loadScheduleTransportationPanel () {
            $timeout(() => {
                parent_vm.accordion.selectedStep = _steps.scheduleTransportation;
                $rootScope.$broadcast('loadScheduleTransportation');
                $rootScope.$broadcast('stepChanged');
            }, 1);
        }

        parent_vm.openRoHistory = function () {
            parent_vm.roHistoryPanelOpen = true;
        };

        $scope.$on('stepChanged', (event, data) => {
            if (parent_vm.accordion.selectedStep === _steps.customerVehicle) {
                if (!vmCustomerPnl.vehicleYears) {
                    loadVehicleYears();
                }
            }

            setPlacesBounds();

            $timeout(() => {
                if (allOtherLineItemsValid()
                    && !hasNewOtherLine()
                    && parent_vm.accordion.selectedStep === _steps.customerVehicle) {
                    parent_vm.addOtherLineItem();
                }
            }, 1);
        });

        $rootScope.$on('declinedServiceToggled', (event, data) => {
            parent_vm.showUpdateWarning(vmCustomerPnl);

            // check to see if we need to uncheck any recmaint
            if (parent_vm.recMaintData) {
                let recMaint = parent_vm.previouslyDeclinedServices.filter((service) => service.checked === true && service.isRecommendedMaintenance === true); 

                if (recMaint && recMaint.length > 0) {
                    let checkedRecMaint = parent_vm.recMaintData.filter((item) => item.checked === true);
 
                    if (checkedRecMaint && checkedRecMaint.length > 0) {
                        checkedRecMaint[0].checked = false;
                        parent_vm.selectedRecMaint = null;
                    }
                }
            }

            parent_vm.servicesModified = true;
            parent_vm.getSelectedServicesCounts();
        });

        $scope.$on('selectedLocationCleared', (event, data) => {
            vmCustomerPnl.cancelAddCustomer(_steps.chooseLocation);
        });

        $scope.$on('apptBackClicked', (event, data) => {
            if (parent_vm.accordion.selectedStep === _steps.customerVehicle && parent_vm.editingExistingAppointment === false) {
                vmCustomerPnl.cancelAddCustomer();
            }
        });

        $scope.$on('apptNextClicked', (event, data) => {
            vmCustomerPnl.nextClicked();
        });

        $scope.$on('locationLoadedForEdit', (event, data) => {
            parent_vm.updateCustomerVehicleModelAfterLoad();
            setPlacesBounds();
        });

        $rootScope.$on('opCodeSearchSelected', (event, data) => {
            vmCustomerPnl.opCodeSearchSelected(data.lineItem, data.selectedItem);
        });


        function processLocationChanged () {
            vmCustomerPnl.dmsSystem = parent_vm.appointment.dealerDMSSystem;

            // isAutoSoft logic can be set elsewhere if needed
            if (parent_vm.dmsData) {
                vmCustomerPnl.isAutoSoft = vmCustomerPnl.dmsSystem === vmCustomerPnl.dmsEnum.Motive && parent_vm.dmsData.dmsDataSource === SYSTEM_ENUMS.motiveDataSourceEnum.AutoSoft;
            }
                             

            if (vmCustomerPnl.dmsSystem === vmCustomerPnl.dmsEnum.DealerTrack) {
                getServiceTypes();
            }

            loadVehicleYears();
        } 

        // The broadcasted event happens before controller initialization
        // If we haven't populated the years yet and we have a locationId, do so now
        if (!vmCustomerPnl.vehicleYears && (parent_vm.appointment && parent_vm.appointment.location && parent_vm.appointment.location.id)) {
            processLocationChanged();
        }

        $scope.$on('selectedLocationChanged', (event, locationId) => {
            processLocationChanged();
            parent_vm.addingCustomer = false;
            parent_vm.selectedCustomer = null;
            parent_vm.clearCustomer();
            clearCustomerTypeAheadState();
        });

        function init() {
            let appt = parent_vm.appointment;

            vmCustomerPnl.dmsSystem = appt.dealerDMSSystem;

            if (vmCustomerPnl.dmsSystem === vmCustomerPnl.dmsEnum.DealerTrack) {
                getServiceTypes();
            }

            if (parent_vm.resolvedCustomerId) {
                customerService.getCustomersByDMSCustNo(parent_vm.appointment.location.id, parent_vm.resolvedCustomerId).then((customer) => {
                    parent_vm.selectedCustomer = customer;
                    vmCustomerPnl.customerSelected();
                });
            } else if (appt.customerId) {
                
                if (rcUtilService.isEmpty(appt.customerCity) || rcUtilService.isEmpty(appt.customerState) || rcUtilService.isEmpty(appt.zip)) {
                    obtainInformationAtCityStateZip();
                }
                
                vmCustomerPnl.availableCustomers = [
                    {
                        customerId: appt.customerId,
                        customerFirstName: appt.customerFirstName,
                        customerLastName: appt.customerLastName,
                        customerPhone: appt.customerPhone,
                        customerEmail: appt.customerEmail,
                        customerCompany: appt.customerCompany,
                        customerType: appt.customerType,
                        customerVehicles: [
                            {
                                make: appt.make,
                                makeName: appt.makeName,
                                model: appt.model,
                                modelName: appt.modelName,
                                year: parseInt(appt.year),
                                mileage: appt.mileage,
                                vin: appt.vin
                            }
                        ]
                    }
                ];

                parent_vm.selectedCustomer = vmCustomerPnl.availableCustomers[0];
                vmCustomerPnl.customerSelected(true);

            } else if (appt.customerLastName || appt.customerCompany) {
                vmCustomerPnl.availableCustomers = [
                    {
                        customerId: -998,
                        customerFirstName: appt.customerFirstName ? appt.customerFirstName : '',
                        customerLastName: appt.customerLastName,
                        customerPhone: appt.customerPhone,
                        customerEmail: appt.customerEmail,
                        customerCompany: appt.customerCompany
                    }
                ];

                parent_vm.selectedCustomer = vmCustomerPnl.availableCustomers[0];
                vmCustomerPnl.customerSelected(init);

            } else if (parent_vm.forceNewCustomerOnLoad) {
                vmCustomerPnl.addNewCustomer(true);
                parent_vm.forceNewCustomerOnLoad = false;

                if (parent_vm.preselectedVin) {
                    parent_vm.appointment.vin = parent_vm.preselectedVin;
                }

                $timeout(() => {
                    if (parent_vm.appointment.vin) {
                        vmCustomerPnl.checkValidVin();
                    }
                });
            }
        }

        function obtainInformationAtCityStateZip() {
            let value = parent_vm.appointment.customerCityStateZip;

            if (rcUtilService.isEmpty(value))
                return;
            
            let idx = value.indexOf(',');
            let secondPart = value.substring(idx + 1, value.length).replace(/,/g, "").trim();
            let city; let state; let zip;
                
            if (secondPart.includes(' ')) {
                // Format is [CITY, STATE ZIP]
                city = value.substring(0, idx);
                state = secondPart.split(" ")[0];
                zip = secondPart.split(" ")[1];
            } else {
                // Format is [CITY STATE, ZIP]
                city = value.substring(0, idx).slice(0, -2).trim();
                state = value.substring(0, idx).slice(-2);
                zip = secondPart;
            }

            parent_vm.appointment.customerCity = rcUtilService.isEmpty(parent_vm.appointment.customerCity) ? city : parent_vm.appointment.customerCity;
            parent_vm.appointment.customerState = rcUtilService.isEmpty(parent_vm.appointment.customerState) ? state : parent_vm.appointment.customerState;
            parent_vm.appointment.customerZip = rcUtilService.isEmpty(parent_vm.appointment.customerZip) ? zip : parent_vm.appointment.customerZip;
        }

        vmCustomerPnl.alwaysEnableCustomerNote = function () {
            return true;
        };

        vmCustomerPnl.displayServiceHistory = function () {
            return appointmentUtilService.displayServiceHistory(parent_vm.appointment, vmCustomerPnl.dmsSystem);
        };

        vmCustomerPnl.customerNameRequired = function () {
            return appointmentUtilService.customerNameRequired(vmCustomerPnl.dmsSystem);
        };

        vmCustomerPnl.departmentChanged = function () {
            parent_vm.departmentChanged();
            $timeout(() => {
                if (parent_vm.recallsEnabled() && !parent_vm.recalls) {
                    vmCustomerPnl.getRecalls();
                }
                
                vmCustomerPnl.getRecommendedMaint();
                
            }, 1);
        };

        init ();
    }
})();

(function () {
    'use strict';

    AppointmentChooseLocationController.$inject = ["$rootScope", "$scope", "$filter", "$timeout", "localStorageService", "tripService", "locationService", "appointmentService", "appointmentUtilService", "tripTypeService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentChooseLocationController', AppointmentChooseLocationController);

    function AppointmentChooseLocationController($rootScope, $scope, $filter, $timeout, localStorageService, tripService, locationService, 
        appointmentService, appointmentUtilService, tripTypeService, SYSTEM_ENUMS) {
        let vmLocPnl = this;
        let parent_vm = $scope.$parent.vm;
        let _steps = parent_vm.accordion.steps;

        vmLocPnl.availableLocations = parent_vm.locationList;
        vmLocPnl.selectedLocation = null;
        vmLocPnl.locationSearchThreshold = 5;

        function getLastBookedDepartment () {
            let locationId = localStorageService.get('lastBookedDealer') || null;
            
            if (locationId === parent_vm.appointment.location.id) {
                return localStorageService.get('lastBookedDepartment') || null;
            } else {
                return null;
            }
        }

        function getDefaultDepartment () {
            let apptTripType = $filter('filter')(parent_vm.tripTypeInstances, {systemTripTypeId: SYSTEM_ENUMS.systemTripType.appointment}, true);

            if (apptTripType && apptTripType.length > 0 && parent_vm.appointment.location) {
                tripTypeService.getTripTypeInternal(parent_vm.appointment.location.id, apptTripType[0].id, [], ['ApptConsumerDepartmentId', 'DefaultToPreviousAdvisor']).then((result) => {
                    let configs = result.tripTypeSpecificConfigs;
                    let deptId = getLastBookedDepartment();

                    if (deptId) {
                        parent_vm.appointment.departmentId = deptId;
                        parent_vm.departmentChanged(true);
                    } else if (configs.ApptConsumerDepartmentId && configs.ApptConsumerDepartmentId.value !== "") {
                        parent_vm.appointment.departmentId = parseInt(configs.ApptConsumerDepartmentId.value);
                        parent_vm.departmentChanged(true);
                    } else if (parent_vm.dealerDepartments.length === 1) {
                        parent_vm.appointment.departmentId = parent_vm.dealerDepartments[0].id;
                        parent_vm.departmentChanged(true);
                    }

                    if (parent_vm.appointment.departmentId) {
                        $scope.$emit('departmentIdSet', parent_vm.appointment.departmentId);
                    }

                    appointmentUtilService.setLastBookedDepartment(parent_vm.appointment.location.id, parent_vm.appointment.departmentId);

                    parent_vm.defaultToPreviousAdvisor = configs.DefaultToPreviousAdvisor ? configs.DefaultToPreviousAdvisor.value : false;
                });
            }
        }

        vmLocPnl.locationClicked = function (location) {
            vmLocPnl.selectedLocation = location;
            vmLocPnl.locationSelected();
        };

        vmLocPnl.locationSelected = function (loadForEdit) {
            if (vmLocPnl.selectedLocation) {
                parent_vm.appointment.location = vmLocPnl.selectedLocation;
                parent_vm.appointment.dealerDMSSystem = parent_vm.appointment.location.dmsSystem;
                parent_vm.dealerTransportationTypes = [];
                parent_vm.dealerOpCodes = [];
                parent_vm.dealerGenericOpCodes = [];
                parent_vm.dealerOpCodesAll = [];
                parent_vm.loadingOpCodes = true;
                parent_vm.dispatchCodes = [];
                parent_vm.loadingDispatchCodes = false;
                let locId = parent_vm.appointment.location.id;

                // Preload DMS, TransportationTypes, and Departments for all locations
                let promises = [];
                const locationDMSPromise = locationService.getLocationDMS(locId).then((dmsData) => {
                    parent_vm.dmsData = dmsData;

                    if (vmLocPnl.selectedLocation.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.CDK) {
                        parent_vm.loadingDispatchCodes = true;
                        parent_vm.requireDispatchCode = dmsData.requireDispatchCode;
                        locationService.lookupDispatchCodes(vmLocPnl.selectedLocation.id, dmsData).then((data) => {
                            parent_vm.dispatchCodes = data;
                            parent_vm.loadingDispatchCodes = false;
                        });
                    }
                });

                const loadTransportationTypesPromise = locationService.getLocationTransportationTypes(locId).then((transportationTypes) => {
                    parent_vm.dealerTransportationTypes = transportationTypes;
                    parent_vm.appointment.transportationType = appointmentUtilService.getDefaultTranportationType(parent_vm.appointment.dealerTransportationTypeId, transportationTypes);
                    parent_vm.appointment.pickupDropoff = appointmentUtilService.getPickupDropOffOption(parent_vm.appointment);
                });

                const locationDepartmentsPromise = locationService.getLocationDepartments(locId, true).then((result) => {
                    parent_vm.dealerDepartments = result;
                });

                const requiredFieldsPromise = appointmentService.getDMSRequiredFields(locId).then((result) => {
                    parent_vm.dmsRequiredFields = result;
                });

                const bookingConfigPromise = appointmentService.getBookingConfig(locId).then((result) => {
                    parent_vm.bookingRules = result;
                });

                const tripTypesPromise = locationService.getLocationTripTypeInstances(locId).then((tripTypes) => {
                    parent_vm.tripTypeInstances = tripTypes;
                });

                const opCodesPromise =  locationService.getLocationOpCodes(locId).then((result) => {
                    parent_vm.commonServicesChecked = false;
                    parent_vm.cleanDealerOpCodes = result.opCodes;
                    parent_vm.cleanDealerGenericOpCodes = result.genericOpCodes;
                    parent_vm.cleanDealerRecallOpCodes = result.recallOpCodes;
                    parent_vm.cleanDealerRecommendedMaintenanceOpCodes = result.recommendedMaintenanceOpCodes;
                    parent_vm.cleanDealerOpCodesAll = result.all;
                    parent_vm.opCodesLoaded();
                }).finally(() => {
                    parent_vm.loadingOpCodes = false;
                });
                
                promises.push(locationDMSPromise, loadTransportationTypesPromise, locationDepartmentsPromise, requiredFieldsPromise, bookingConfigPromise, tripTypesPromise, opCodesPromise);

                Promise.all(promises).then(() => {
                    tripService.hasMessaging(locId).then((result) => {
                        if (parent_vm.appointment?.location) {
                            parent_vm.appointment.location.hasMessaging = result;
                        }
                    });
                   
                    if (!parent_vm.appointment.departmentId) {
                        getDefaultDepartment();
                    } 
                    
                    $rootScope.$broadcast('selectedLocationChanged', locId);

                    if (loadForEdit) {
                        if (parent_vm.appointment.departmentId) {
                            parent_vm.departmentChanged(true);
                        }

                        $rootScope.$broadcast('locationLoadedForEdit');
                    }
                    
                    if (parent_vm.appointment.location && !loadForEdit) {
                        parent_vm.updateState();
                        parent_vm.accordion.selectedStep = _steps.customerVehicle;
                        $timeout(() => {
                            parent_vm.gotoTab(0);
                        });
                    }

                    $rootScope.$broadcast('stepChanged');
                });
            }
        };

        vmLocPnl.clearSelectedLocation = function () {
            parent_vm.disableNext = false;
            parent_vm.appointment.departmentId = null;
            parent_vm.resetAppointment();
            parent_vm.contact = null;
            parent_vm.serviceTypes = null;
            parent_vm.bookingRules = null;
            parent_vm.appointment.location = vmLocPnl.selectedLocation = null;
            parent_vm.appointment.dealerDMSSystem = null;
            parent_vm.accordion.selectedStep = _steps.chooseLocation;
            parent_vm.dealerTransportationTypes = null;
            parent_vm.dealerOpCodes = [];
            parent_vm.selectedCustomer = null;
            parent_vm.dispatchCodes = [];
            $rootScope.$broadcast('selectedLocationCleared');
            $rootScope.$broadcast('stepChanged');
            parent_vm.resetAppointment();
            parent_vm.updateState();
            $timeout(() => {
                parent_vm.gotoTab(0);
            });
        };

        if (vmLocPnl.availableLocations && vmLocPnl.availableLocations.length === 1 && !parent_vm.resolvedAppointmentId) {
            vmLocPnl.selectedLocation = vmLocPnl.availableLocations[0];
            vmLocPnl.locationSelected();
        } else if (parent_vm.resolvedLocation) {
            vmLocPnl.selectedLocation = parent_vm.resolvedLocation;
            vmLocPnl.locationSelected(!!parent_vm.resolvedAppointmentId);
        }

        $scope.$on('appointmentLoaded', (event, data) => {
            if (parent_vm.accordion.selectedStep === _steps.chooseLocation && vmLocPnl.selectedLocation && parent_vm.appointment) {
                vmLocPnl.locationSelected(true);
            }
        });
    }
})();

(function () {
    'use strict';

    AppointmentBookingSummaryController.$inject = ["$rootScope", "$scope", "$state", "appointmentService", "appointmentUtilService", "modalService", "tripService", "APPOINTMENTSTATUS_LABELS", "$q", "$filter"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentBookingSummaryController', AppointmentBookingSummaryController);
    
    /* this codde is fired when you are on the final page of booking */
    /* this is not what is shown on the appointment tab when clicked from the list */
    function AppointmentBookingSummaryController($rootScope, $scope, $state, appointmentService, appointmentUtilService, modalService, tripService, APPOINTMENTSTATUS_LABELS, $q, $filter) {
        let vmSummaryPnl = this;
        let parent_vm = $scope.$parent.vm;

        vmSummaryPnl.activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
        vmSummaryPnl.suffix = appointmentUtilService.getProductSuffix(vmSummaryPnl.activeProduct);

        vmSummaryPnl.bookClicked = function () {

            if (!parent_vm.appointment.mobileSmsOptedIn && parent_vm.customerPhoneType.type !== parent_vm.phoneTypes.landline) {
                parent_vm.bookClicked = true;

                return false;
            }

            parent_vm.fakeBookingSpinner = true;

            parent_vm.nextBusy = true;

            if (parent_vm.appointment.appointmentStatus === parent_vm.getStatus(APPOINTMENTSTATUS_LABELS.draft) || parent_vm.appointment.appointmentStatus === parent_vm.getStatus(APPOINTMENTSTATUS_LABELS.imported)) {
                parent_vm.appointment.addingNew = true;
                parent_vm.appointment.appointmentStatus = parent_vm.getStatus(APPOINTMENTSTATUS_LABELS.new);
            } else {
                parent_vm.appointment.addingNew = false;
            }

            // Reset Id of checked 'other services' saved on appointment edit
            let notSavedServices = $filter('filter')(parent_vm.appointment.lineItems, {isOther: true, checked: true, id: -1}, true);

            _.forEach(notSavedServices, (notSavedService) => {
                notSavedService.id = 0;
            });

            // As our last portion of filtering, ensure we have removed any toggled off generic line items and any unchecked "other" line items
            _.remove(parent_vm.appointment.lineItems, {isGeneric: true, checked: false});
            _.remove(parent_vm.appointment.lineItems, {isOther: true, checked: false});
            

            if (!parent_vm.appointment.overrideTimeSlot && parent_vm.requiresCapacityValidation(true) === false) {
                parent_vm.appointment.bypassValidation = true;
            } 

            appointmentService.createOrUpdateAppointment(parent_vm.appointment.location.id, parent_vm.appointment, true).then((result) => {
                let alert = $q.when();

                if (result.hasLoanerManagementBookingError) {
                    let errorMessage = 'Error: The Appointment has been successfully booked, but there was an error creating the loaner reservation.  Please contact the Client Success Team if this problem persists.';

                    if (result.loanerManagementBookingError) {
                        errorMessage += ' Response from loaner provider: ' + result.loanerManagementBookingError;
                    }

                    alert = modalService.showError(errorMessage);
                }

                alert.then(() => {
                    vmSummaryPnl.finishBookingAppointment(result);
                });
            });
        };

        vmSummaryPnl.finishBookingAppointment = function (result) {

            parent_vm.nextBusy = false;
            parent_vm.bookClicked = false;

            const navigateToDetails = (appointmentId) => {
                $state.go('appointment-details' + vmSummaryPnl.suffix, {
                    locationId: parent_vm.appointment.location.id,
                    appointmentId
                });
            };

            if (result && !result.errors && !result.dmsSyncError) {
                if (parent_vm.appointment.tripDriver) {
                    let driverToSelect = parent_vm.appointment.tripDriver.id ? parent_vm.appointment.tripDriver.id : parent_vm.appointment.tripDriver;

                    tripService.assignDriver(result.tripId, driverToSelect).then((response) => {
                        // We update the driver's photo with the response
                        if (response && parent_vm.appointment.tripDriver) {
                            parent_vm.appointment.tripDriver.driverPhoto = response;
                        }
                    },
                    (errorResponse) => {
                        modalService.showDetailedErrorDlg(errorResponse);
                    }).finally(() => {
                        navigateToDetails(result.id);
                    });
                } else {
                    navigateToDetails(result.id);
                }
            } else if (result && result.dmsSyncError) {
                let alert = $q.when();

                alert = modalService.showDetailedErrorDlg(result.dmsSyncError, true);
                alert.then(() => {
                    navigateToDetails(result.id);
                });
            } else if (result && result.errors && result.errors[0].status === 409) {
                modalService.showError('The DMS has indicated the appointment was canceled. The status has been updated.')
                    .then(() => {
                        navigateToDetails(parent_vm.appointment.id);
                    });
            } else {
                if (result.errors && result.errors.length > 0) {
                        modalService.showDetailedErrorDlg(result.errors.join(". "));
                } else {
                    modalService.showGenericApptError();
                }
            }
        };

        $scope.$on('apptBackClicked', (event, data) => {
            if (parent_vm.accordion.selectedStep === parent_vm.accordion.steps.summary) {
                parent_vm.accordion.selectedStep = parent_vm.accordion.steps.scheduleTransportation;
                $rootScope.$broadcast('stepChanged');
            }
        });

        $scope.$on('apptNextClicked', (event, data) => {
            if (parent_vm.accordion.selectedStep === parent_vm.accordion.steps.summary) {
                vmSummaryPnl.bookClicked();
            }
        });
        
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$state", "INSPECT_CONSTANTS", "roService", "locationService", "appointmentUtilService", "consumerRepairOrderAuthorizationsService"];
    angular
        .module('redcap.appointment')
        .component('checkinSummary', {
            templateUrl: 'app/areas/appointment/components/summaries/checkin-summary.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                repairOrder: '<'
            }
        });

    function controller($state, INSPECT_CONSTANTS, roService, locationService, appointmentUtilService, consumerRepairOrderAuthorizationsService) {
        this.$onInit = function() {
            let vm = this;

            vm.activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
            vm.suffix = appointmentUtilService.getProductSuffix(vm.activeProduct);
            
            vm.approvedServicesFilter = function(service) {
                return service.approved == true || service.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.approved;
            };

            vm.openServicesFilter = function(service) {
                return service.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.open;
            };

            const promises = [];

            const servicesPromise = roService.getRoLineItems(vm.repairOrder.dealerId, vm.repairOrder.id).then((lineItems) => {
                vm.services = lineItems.flatMap((line) => line.serviceOperations);                    
            });

            const opCodePromise = locationService.getLocationOpCodes(vm.repairOrder.dealerId).then((opCodes) => {
                vm.dealerOpCodes = opCodes;
            });

            promises.push(servicesPromise, opCodePromise);

            vm.isLoading = true;
        
            Promise.all(promises).then(() => {
                const mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(vm.dealerOpCodes, vm.repairOrder);

                vm.services = vm.services.map((op) => { return {...consumerRepairOrderAuthorizationsService.buildServiceOpViewModel(op, mappedOpCodes.find(moc => moc.opCode === op.opCode)), hideBreakdown: true}; });
                vm.hasPendingServices = vm.services.filter(vm.openServicesFilter).length;
                vm.hasApprovedServices = vm.services.filter(vm.approvedServicesFilter).length;
            }).finally(() => vm.isLoading = false);
            
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$filter", "APPOINTMENT_TRANSPORTATION_TYPE", "appointmentUtilService", "APPOINTMENT_APPOINTMENTSTATUS"];
    angular
        .module('redcap.appointment')
        .component('appointmentTransportationSummary', {
            templateUrl: 'app/areas/appointment/components/summaries/appointment-transportation-summary.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'locationTransportationTypes': '<',
                'isAdminView': '<'
            }
        });

    function controller($filter,
        APPOINTMENT_TRANSPORTATION_TYPE,
        appointmentUtilService,
        APPOINTMENT_APPOINTMENTSTATUS) {
        this.$onInit = function() {
            let vm = this;
            
            vm.appointment = vm.ngModel;
            vm.apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
            vm.apptStatus = APPOINTMENT_APPOINTMENTSTATUS;

            function initialize() {
                let appt = vm.appointment;
                let allTransportationTypes = vm.locationTransportationTypes;
                let transId = appt.dealerTransportationTypeId;

                if (appt.pendingRideDetails) {
                    vm.pendingRideDetail = JSON.parse(appt.pendingRideDetails);
                }

                vm.transportationType = $filter('filter')(allTransportationTypes, {id: transId}, true)[0];

            }

            vm.getRideShareCreditsDescription = function() {
                return appointmentUtilService.getCreditDescription(vm.locationTransportationTypes);
            };

            initialize();

        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$state", "$filter", "$q", "eventAlertService", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "APPOINTMENT_CUSTOMERTYPE", "APPOINTMENT_TRANSPORTATION_TYPE_GROUP", "APPOINTMENT_APPOINTMENTSTATUS", "APPOINTMENT_TRANSPORTATION_TYPE", "APPOINTMENTSTATUS_LABELS", "permissions", "appointmentService", "appointmentUtilService", "tripService", "modalService", "rcUtilService"];
    angular
        .module('redcap.appointment')
        .component('appointmentSummary', {
            templateUrl: 'app/areas/appointment/components/summaries/appointment-summary.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'locationTransportationTypes': '<',
                'appointmentStatuses': '<',
                'locationDepartment': '<',
                'credit': '<',
                'parent': '<'
            }
        });

    function controller($state,
        $filter,
        $q,
        eventAlertService,
        SYSTEM_ENUMS,
        HERE_MAPS_CONFIG,
        APPOINTMENT_CUSTOMERTYPE,
        APPOINTMENT_TRANSPORTATION_TYPE_GROUP,
        APPOINTMENT_APPOINTMENTSTATUS,
        APPOINTMENT_TRANSPORTATION_TYPE,
        APPOINTMENTSTATUS_LABELS,
        permissions,
        appointmentService,
        appointmentUtilService,
        tripService,
        modalService,
        rcUtilService) {
        this.$onInit = function() {
            let vm = this;
                let _summaryMap = null;

                
            vm.transTypeGroups = APPOINTMENT_TRANSPORTATION_TYPE_GROUP;
            vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
            vm.servicesVisible = true;
            vm.mobileMapVisible = true;
            vm.apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
            vm.apptStatus = APPOINTMENT_APPOINTMENTSTATUS;
            vm.summaryMapOptions = {
                showSegmentOverlay: false,
                fillHeight: false,
                defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
                useImagesInPin: true,
                showActualRoute: false,
                showControls: false,
                disableLiveTracking: true,
                height: '200px'
            };

            vm.appointment = vm.ngModel;

            vm.apptIdIsValid = function(apptId) {
                return rcUtilService.isValidID(apptId);
            };

            vm.removePipedData = function(apptId) {
                return appointmentUtilService.removePipedData(apptId);
            };

            vm.isAdvisorUnmapped = function() {
                return appointmentUtilService.isAdvisorUnmapped(vm.appointment);
            };

            vm.isHideRideShareCreditTransportationType = function() {
                if (!vm.credit) return false;

                if (vm.credit &&
                    vm.transportationType &&
                    vm.transportationType.dealerSystemTransportationTypeId ===
                    vm.apptTransportationTypes.rideshareCredits) return true;

                return false;
            };

            vm.customerType = APPOINTMENT_CUSTOMERTYPE;
            vm.dealer = {
                lat: vm.appointment.dealerLat,
                lng: vm.appointment.dealerLng
            };

            vm.getRideShareCreditsDescription = function() {
                return appointmentUtilService.getCreditDescription(vm.locationTransportationTypes);
            };

            vm.getDisplayLineItemDescription = function(lineItem) {
                return appointmentUtilService.getDisplayLineItemDescription(lineItem);
            };

            function initialize(showResubmittedMessage) {
                let appt = vm.appointment;
                    let transTypeGroups = vm.transTypeGroups;
                    let allTransportationTypes = vm.locationTransportationTypes;
                    let transId = appt.dealerTransportationTypeId;

                vm.transportationType = $filter('filter')(allTransportationTypes, {id: transId}, true)[0];

                if (!vm.transportationType) {
                    let defaultType = $filter('filter')(allTransportationTypes, {isDefault: true}, true);

                    if (defaultType && defaultType.length > 0) {
                        vm.transportationType = defaultType[0];
                    } else {
                        vm.transportationType = allTransportationTypes[0];
                    }
                }

                vm.pickupDropoff = vm.transportationType.isPickup
                    ? transTypeGroups.pickup
                    : vm.transportationType.isDropOff
                    ? transTypeGroups.dropoff
                    : transTypeGroups.mobile;

                let pickupLoc = vm.appointment.tripPickupLocation;

                if (vm.transportationType && appointmentUtilService.isTripTypePickupOrMobile(vm.transportationType)) {

                    if (pickupLoc) {
                        vm.pickupLocation = {
                            formattedLocation: pickupLoc.streetAddress +
                                ' ' +
                                pickupLoc.city +
                                ' ' +
                                pickupLoc.state +
                                ' ' +
                                pickupLoc.zip,
                            name: pickupLoc.name,
                            streetAddress: pickupLoc.streetAddress,
                            city: pickupLoc.city,
                            state: pickupLoc.state,
                            zip: pickupLoc.zip,
                            countryShortCode: pickupLoc.countryShortCode,
                            county: null,
                            lat: pickupLoc.lat,
                            lng: pickupLoc.lng
                        };
                    }
                }

                if (showResubmittedMessage && vm.parent) {
                    eventAlertService.createAlert('Appointment Successfully Pushed To DMS.');
                }
            }

            vm.getApptStatusLabel = function() {
                let label = appointmentService.getAppointmentStatusLabel(vm.appointment, vm.appointmentStatuses);

                if (vm.appointment.isCheckinSkipped) {
                    label += " (CHECK-IN SKIPPED)";
                }

                return label;
            };

            vm.showAppointmentStatus = function() {
                return appointmentService.showAppointmentStatus(vm.pickupDropoff,
                    vm.getApptStatusLabel().toUpperCase());
            };

            vm.isDraftAppointment = function() {
                return appointmentService.isDraftAppointment(vm.appointmentStatuses, vm.appointment);
            };

            vm.setMapLocation = function(map, location, stopType) {
                // this prevents the map from showing the dealer location over the resolved routes
                if (!map /*|| (resolvedTrip && resolvedTrip.id)*/) return;

                location.stopType = stopType || SYSTEM_ENUMS.destinationType.dealer;
                location.latLng = {lat: location.lat, lng: location.lng};

                map.updateMap({stops: [location]});
                map.setZoom(16);
            };

            vm.onSummaryMapLoaded = function(summaryMap) {
                _summaryMap = summaryMap;

                let appt = vm.appointment;
                    let stops = _.cloneDeep(appt.tripStops);

                if (appt.tripStops && appt.tripStops.length > 1) {
                    _summaryMap.updateMap({stops: stops});
                } else if (vm.dealer) {
                    vm.setMapLocation(_summaryMap, vm.dealer);
                }

            };

            vm.saveNewDriver = function(driverId, previousDriverId) {
                vm.savingDriver = true;
                let assignOrUnassign = !driverId || !vm.appointment.tripDriver.id
                        ? tripService.unassignDriver
                        : tripService.assignDriver;
                    let driver = !driverId || !vm.appointment.tripDriver.id ? previousDriverId : driverId;

                // If the driver is null, signalr might not have updated the trip with the current driver's information
                if (!driver) {
                    vm.displayToastError('There was an error assigning the driver, please try again');
                }

                let driverToSelect = driver.id ? driver.id : driver;

                assignOrUnassign(vm.appointment.tripId, driverToSelect).then((response) => {
                        // We update the driver's photo with the response
                        if (response && vm.appointment.tripDriver) {
                            vm.appointment.tripDriver.driverPhoto = response;
                        }

                        vm.changeDriver = false;
                        vm.savingDriver = false;
                    },
                    (errorResponse) => {
                        vm.displayToastError(errorResponse);
                        vm.savingDriver = false;
                    });
            };

            vm.displayDriverUnavailableWarning = function(previousDriver) {
                let confirm = modalService.showYesNo('Please Confirm',
                    'The driver you selected is already booked for another trip at this time. Are you sure you want to continue changing the driver for this trip?',
                    'No',
                    'Yes');

                confirm.then((confirmed) => {
                    if (!confirmed) {
                        vm.appointment.tripDriver.id = previousDriver;
                    } else {
                        vm.saveNewDriver(vm.appointment.tripDriver.id, previousDriver);
                    }
                });
            };

            vm.displayAreYourSureWarning = function(previousDriver) {
                let confirmMessage = 'Are you sure you want to assign this trip to this driver?';

                if (vm.appointment.isManual) {
                    confirmMessage = 'Note, driver must be able to operate a manual transmission. ' + confirmMessage;
                }

                let confirm = modalService.showYesNo('Please Confirm', confirmMessage, 'No', 'Yes');

                confirm.then((confirmed) => {
                    if (!confirmed) {
                        vm.appointment.tripDriver.id = previousDriver;
                    } else {
                        if (vm.appointment.tripDriver && vm.appointment.tripDriver.id) {
                            vm.saveNewDriver(vm.appointment.tripDriver.id, previousDriver);
                        } else {
                            vm.saveNewDriver(null, previousDriver);
                        }
                    }
                });
            };

            vm.driverSelectionModified = function(updatedDriver, originalDriver) {
                vm.saveSuccessful = false;
                let driverId = updatedDriver ? updatedDriver.id : null;
                    let tempDriver = $filter('filter')(vm.activeDrivers, {id: driverId}, true)[0];

                if (tempDriver) {
                    if (tempDriver.isAvailable === false) {
                        vm.displayDriverUnavailableWarning(originalDriver);
                    } else {
                        vm.displayAreYourSureWarning(originalDriver);
                    }
                } else {
                    vm.displayAreYourSureWarning(originalDriver);
                }
            };

            vm.changeDriverClick = function() {
                if (vm.changeDriver) {
                    return;
                }

                vm.changeDriver = true;

                if (!vm.activeDrivers) {
                    vm.retrievingDrivers = true;
                    let appt = vm.appointment;
                        let startTime = moment(appt.expectedStartTime).format('MM/DD/YYYY hh:mm A');
                        let endTime =
                            moment(appt.expectedEndTime)
                                .format('MM/DD/YYYY hh:mm A'); // lower case am/pm seems to have a sporadic issue.
                        let driverId = appt.tripDriver.id || null;
                        let tripType = appointmentUtilService.transportationTripTypeMap(vm.transportationType
                            .dealerSystemTransportationTypeId);

                    tripService.getActiveDrivers(appt.dealerId,
                        startTime.toLowerCase(),
                        endTime.toLowerCase(),
                        driverId,
                        vm.appointment.tripId,
                        tripType).then((response) => {
                            if (response.errorMessage) {
                                vm.errors = response.errorMessage;
                            } else if (response) {
                                // insert in the --- line
                                for (let idx = response.length - 1; idx >= 0; idx--) {
                                    if (response[idx].isPreferred) {
                                        response.splice(idx + 1,
                                            0,
                                            {
                                                id: -999,
                                                name: '------------------------------------------------',
                                                isAvailable: true
                                            });
                                        break;
                                    }
                                }

                                vm.activeDrivers = response;
                            }

                            vm.retrievingDrivers = false;
                        },
                        (errorResponse) => {
                            vm.displayToastError(errorResponse);
                            vm.retrievingDrivers = false;
                        });
                }
            };

            vm.enableDispatchControls = function() {
                return vm.appointment.dealerEnableDispatchControls === true ||
                    permissions.isSysAdmin() ||
                    permissions.isRedCapAdmin();
            };

            vm.canEditDriver = function() {
                if (!vm.enableDispatchControls() || !vm.appointment || !vm.appointment.canChangeDriver) {
                    return false;
                }

                return true;
            };

            vm.formatDriverDropDown = function(driver, tripDriver) {
                return tripService.formatDriverDropDown(driver, tripDriver);
            };

            vm.resubmit = function() {
                if (vm.parent) vm.parent.nextBusy = true;
                vm.appointment.disableNotifications = true;
                vm.appointment.disableSendLoanerHomework = true;
                appointmentService.createOrUpdateAppointment(vm.appointment.dealerId, vm.appointment, true)
                    .then((result) => {

                        if (vm.parent) vm.parent.nextBusy = false;

                        if (result && !result.errors && !result.dmsSyncError) {
                            // We need to merge the resulting object back to our UI
                            vm.appointment = result;
                            initialize(true);
                        } else if (result && result.dmsSyncError) {
                            let alert = $q.when();

                            alert = modalService.showDetailedErrorDlg(result.dmsSyncError, true);
                            alert.then(() => {

                            });
                        } else if (result && result.errors && result.errors[0].status === 409) {
                            modalService
                                .showError(
                                    'The DMS has indicated the appointment was canceled. The status has been updated.')
                                .then(() => {
                                    $state.go('appointment-details' + vm.parent.suffix,
                                        {
                                            locationId: vm.appointment.location.id,
                                            appointmentId: vm.appointment.id
                                        });
                                });
                        } else {
                            if (result.errors && result.errors.length > 0)
                                modalService.showDetailedErrorDlg(result.errors.join(". "));
                            else
                                modalService.showGenericApptError();
                        }
                    });
            };

            vm.getDisplayMake = function(appt) {
                return appointmentUtilService.getDisplayMake(appt);
            };

            vm.getDisplayModel = function(appt) {
                return appointmentUtilService.getDisplayModel(appt);
            };

            initialize();

        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce", "$scope", "modalService", "rcUtilService", "deviceDetector"];
    angular
        .module('redcap.appointment')
        .component('dragDropIconOnly', {
            templateUrl: 'app/areas/appointment/components/drag-drop-icon-only/drag-drop-icon-only.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '=',
                'placeholder': '@',
                'onLoad': '&',
                'loadingText': '@',
                'errorText': '@',
                'useIcon': '<',
                'dropReference': '=',
                'imageType': '@?',
                'ngRequired': '<',
                'allowVideo': '<',
                'unique': '=',
                'declinedService': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce, $scope, modalService, rcUtilService, deviceDetector) {
        this.$onInit = function() {
            var vm = this;
            var onLoadFunc = vm.onLoad && vm.onLoad();

            function init() {
                vm.supportsVideoCapture = false;
                vm.buttonDisabled = true;
                vm.pattern = vm.allowVideo ? 'image/*,video/*' : 'image/*';
                vm.name = vm.unique ? 'filedata' + vm.unique : 'filedata';
                vm.id = vm.unique ? 'filedata' + vm.unique : 'filedata';
                vm.file = {};
                vm.ngModel = vm.ngModel || {};
                vm.file.$ngfBlobUrl = vm.ngModel.fileData || vm.ngModel.url;
                vm.ngModel.fileData = vm.ngModel.fileData || vm.ngModel.url;
                vm.ngModel.fileChanged = vm.ngModel.fileChanged || false;
                vm.file_backup = vm.file;
                vm.options = {
                    updateOn: 'change',
                    allowInvalid: false,
                    debounce: 0
                };

                // Determine if the camera is supported/should be used.
                if (deviceDetector.isMobile()) {
                    rcUtilService.supportsVideoCapture().then(function(isSupported) {
                        vm.supportsVideoCapture = isSupported;
                    }).finally(function() {
                        vm.buttonDisabled = false;
                    });
                } else {
                    vm.buttonDisabled = false;
                }
            }

            init();

            vm.launchCamera = function() {
                if (vm.buttonDisabled) return;

                modalService.showPhotoCapture(vm.photoCaptured);
            };

            vm.photoCaptured = function(blob) {
                onLoadFunc(vm.ngModel, blob, [blob], null, vm.imageType, vm.dropReference, vm.declinedService);
            };

            vm.upload = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
                if (!$file) {
                    vm.file = vm.file_backup;
                    return;
                }

                vm.file_backup = $file;
                var reader = new FileReader();
                reader.readAsDataURL($file);

                reader.onload = function() {
                    vm.ngModel.errorMessage = null;

                    vm.ngModel.fileChanged = true;

                    if (onLoadFunc) {
                        vm.isLoading = true;
                        try {
                            var result = onLoadFunc(vm.ngModel,
                                $file,
                                $files,
                                $event,
                                vm.imageType,
                                vm.dropReference,
                                vm.declinedService);
                            if (result && result.catch) {
                                result.catch(function(ex) {
                                    vm.isLoading = false;
                                    vm.ngModel.errorMessage = vm.errorText;
                                    vm.ngModel.hasError = true;
                                    vm.ngModel.exception = ex;
                                });
                            }
                            if (result && result.finally) {
                                result.finally(function() {
                                    vm.isLoading = false;
                                    vm.ngModel.fileData = reader.result;
                                });
                            } else {
                                vm.isLoading = false;
                                vm.ngModel.fileData = reader.result;
                            }
                        } catch (ex) {
                            vm.isLoading = false;
                            vm.ngModel.errorMessage = vm.errorText;
                            vm.ngModel.hasError = true;
                            vm.ngModel.exception = ex;
                        }
                    } else {
                        vm.ngModel.fileData = reader.result;
                    }

                    if (vm.repeatContainer && vm.repeatContainer.push) {
                        vm.repeatContainer.push({});
                    }
                };

            };
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('redcap.appointment')
        .component('apptListDatePicker', {
            templateUrl: 'app/areas/appointment/components/appt-list-date-picker/appt-list-date-picker.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'apptList': '<'            
            }
        });

    function controller() {
        this.$onInit = function() {
            let vm = this;
        };
    }
})();

(function () {
    'use strict';

    angular.module('redcap.payments', []);
})();

(function () {
    'use strict';

    paymentRefundModalController.$inject = ["$uibModalInstance"];
    angular
        .module('redcap.payments')
        .controller('PaymentRefundModalController', paymentRefundModalController);

    function paymentRefundModalController($uibModalInstance) {
        var vm = this;
        vm.close = function () {
            $uibModalInstance.close();
        };
    }
})();

(function () {
    'use strict';

    paymentRefundModalController.$inject = ["$uibModalInstance", "resolvedInvoice", "$rootScope", "paymentService"];
    angular
        .module('redcap.payments')
        .controller('PeriPaymentRefundModalController', paymentRefundModalController);

    function paymentRefundModalController($uibModalInstance, resolvedInvoice, $rootScope, paymentService) {
        let vm = this;

        vm.invoice = resolvedInvoice;
        vm.loading = true;
        vm.refunding = false;
        vm.refundResolved = false;
        vm.paymentDetailsError = null;

        paymentService.getPaymentDetails(vm.invoice.id).then((response) => {
            vm.paymentDetails = response;
        }).catch((error) => {
            if (error && error.data && error.data.message) {
                vm.paymentDetailsError = error.data.message;
            } else {
                vm.paymentDetailsError = error;
            }
        }).finally(() => {
            vm.loading = false;
        });

        vm.close = function (result) {
            $uibModalInstance.close(result || false);
        };

        vm.issueRefund = function () {
            if (vm.refunding || vm.loading) return;

            vm.refunding = true;
            vm.refundResolved = false;
            vm.success = false;
            vm.error = null;
            paymentService.refundPayment(vm.invoice.id).then((result) => {
                    vm.success = true;
                    $rootScope.$broadcast('refresh:invoices');
                    $rootScope.$broadcast('Payment.refreshInvoice');
                }).catch((error) => {
                    if (error && error.data && error.data.message) {
                        vm.error = error.data.message;
                    } else {
                        vm.error = error;
                    }
                }).finally(() => {
                    vm.refunding = false;
                    vm.refundResolved = true;
                });
        
        };
    }
})();

(function () {
    'use strict';
    periPayNowModalController.$inject = ["$scope", "resolvedInvoice", "resolvedTerminals", "paymentService", "$uibModalInstance", "periPaymentsService"];
    angular
        .module('redcap.payments')
        .controller('periPayNowModalController', periPayNowModalController);

    function periPayNowModalController($scope, resolvedInvoice, resolvedTerminals, paymentService, $uibModalInstance, periPaymentsService) {
        let vm = this;

        vm.PAYMENT_VIEW_STATES = {
            SELECT_TERMINAL: 0,
            TERMINAL_ENTRY: 1,
            MANUAL_ENTRY: 2,
            PROCESSING: 3,
            SUCCESS: 4,
            FAILURE: 5,
            ERROR: 6
        };

        vm.currentState = vm.PAYMENT_VIEW_STATES.SELECT_TERMINAL;
        vm.manualEntryParams = null;
        vm.invoice = resolvedInvoice;
        vm.terminals = resolvedTerminals;

        // Add static method "Enter On Screen" for processing payment
        vm.terminals.push({
            terminalId: 'manualEntry',
            name: 'Enter Manually On Screen',
            type: 'manualEntry'
        });


        // If we only have one option (it's the manual entry option), select it by default
        if (vm.terminals.length === 1) {
            vm.terminal = vm.terminals[0];
        }

        vm.selectManuallEntryPayment = () => {
            vm.currentState = vm.PAYMENT_VIEW_STATES.MANUAL_ENTRY;

            vm.manualEntryParams = {
                invoiceGuid: vm.invoice.referenceId,
                dealerId: vm.invoice.dealerId,
                invoiceId: vm.invoice.id
            };
        };

        // Listen for the event to validate the transaction
        $scope.$on('peri-validate-dashboard-transaction', () => { vm.validateManualPayment(); });

        vm.validateManualPayment = () => {
            vm.currentState = vm.PAYMENT_VIEW_STATES.VERIFYING;

            periPaymentsService
                .verifyPayment(vm.invoice.dealerId, vm.invoice.referenceId, vm.transactionData.transactionId)
                .then(
                    (result) => {
                        if (result.success) {
                            vm.currentState = vm.PAYMENT_VIEW_STATES.SUCCESS;
                            vm.paymentResult = {
                                result: 0,
                                message: result.message
                            };
                        } else {
                            console.log('Payment failed', result);
                            vm.currentState = vm.PAYMENT_VIEW_STATES.FAILURE;
                            vm.paymentResult = {
                                result: -1,
                                message: result.message
                            };
                        }
                    })
                .catch((err) => {
                    vm.currentState = vm.PAYMENT_VIEW_STATES.ERROR;
                    vm.paymentResult = {
                        result: -1,
                        message: err.data && err.data.message || err.message
                    };
                })
                .finally(() => {
                    vm.saving = false;
                });

        };

        vm.collectPayment = (terminal, isManualEntry) => {
            vm.saving = true;
            vm.processedComplete = false;
            paymentService.collectPayment(resolvedInvoice.id, terminal.terminalId, isManualEntry).then((result) => {
                vm.currentState = vm.PAYMENT_VIEW_STATES.SUCCESS;
                vm.paymentResult = {
                    result: 0
                };
            }).catch((err) => {
                vm.currentState = vm.PAYMENT_VIEW_STATES.ERROR;
                vm.paymentResult = {
                    result: -1,
                    message: err.data && err.data.message || err.message
                };
            }).finally(() => {
                vm.saving = false;
                vm.processedComplete = true;
            });
        };

        vm.close = $uibModalInstance.close;
    }
})();

(function () {
    'use strict';

    paymentGetLinkModalController.$inject = ["$scope", "resolvedInvoice", "$uibModalInstance", "authService", "paymentService"];
    angular
        .module('redcap.payments')
        .controller('PaymentGetLinkModalController', paymentGetLinkModalController);

    function paymentGetLinkModalController($scope, resolvedInvoice, $uibModalInstance, authService, paymentService) {
        var vm = this;
        vm.invoice = resolvedInvoice;

        vm.close = function () {
            $uibModalInstance.close();
        };

        vm.copy = function() {
            angular.element('#link').select();
            document.execCommand("copy");
        };
    }
})();

(function () {
    'use strict';

    cenPosPayNowModalController.$inject = ["$scope", "$sce", "resolvedInvoice", "resolvedPaymentConfig", "$state", "$http", "CENPOS_SETTINGS", "PAYMENT_PROVIDER_ENVIRONMENT", "$compile", "paymentService", "$uibModalInstance", "$timeout", "$location"];
    angular
        .module('redcap.payments')
        .controller('CenPosPayNowModalController', cenPosPayNowModalController);

    function cenPosPayNowModalController($scope, $sce, resolvedInvoice, resolvedPaymentConfig, $state, $http, CENPOS_SETTINGS, PAYMENT_PROVIDER_ENVIRONMENT, $compile, paymentService, $uibModalInstance, $timeout, $location) {
        let vm = this;

        vm.invoice = resolvedInvoice;
        vm.url = $state.get('payment-cenpos-loader').templateUrl;
        let a = document.createElement('a');

        a.href = $state.get('payment-cenpos-processed').templateUrl;

        let cenPosUrl = vm.invoice.paymentProcessorEnvironment === PAYMENT_PROVIDER_ENVIRONMENT.Production
            ? CENPOS_SETTINGS.url
            : CENPOS_SETTINGS.devUrl;

        vm.cenposSettings = {
            url: cenPosUrl,
            type: 'sale',
            amount: resolvedInvoice.total,
            merchantid: resolvedPaymentConfig.merchantId,
            password: btoa(resolvedPaymentConfig.password),
            userid: resolvedPaymentConfig.userName,
            redirecttype: 'self',
            urlresponse: btoa(a.href),
            postresponse: true,
            autosubmit: true,
            receipts: true,
            responsetype: 'restful',
            invoiceId: resolvedInvoice.id,
            contactId: resolvedInvoice.contactId
        };

        $scope.$on('cenpos-loader:loaded', (events, args) => {
            vm.cenposSettings.document = args;
            $compile(args)($scope);
        });
        $scope.$on('cenpos-loader:processed', (events, args) => {
            vm.processedComplete = true;
            vm.saving = true;
            vm.paymentResult = args;
            args.invoice = args.invoice || resolvedInvoice.id;
            paymentService.processPayment(args).then((result) => {
                

            }).finally(() => {
                if (args && args.result === '-1' && args.message && args.message.toLowerCase() === 'canceled') {
                    $uibModalInstance.close();
                } else {
                    vm.saving = false;
                }
            });
        });

        vm.retry = function() {
            vm.processedComplete = false;
            vm.paymentResult = null;
            vm.saving = false;
            formInitializer();
        };

        vm.close = $uibModalInstance.close;

        vm.formUrl = $sce.trustAsResourceUrl(vm.cenposSettings.url);

        function formInitializer() {
            let form = angular.element('#submitForm', vm.cenposSettings.document);

            if (!form || !form.length) {
                return $timeout(formInitializer, 50);
            }

            angular.element('#submitForm', vm.cenposSettings.document).submit();
        }

        $scope.onInit = $timeout(formInitializer, 50);
    }
})();

(function () {
    'use strict';

    cardConnectPayNowModalController.$inject = ["$scope", "$sce", "resolvedInvoice", "resolvedPaymentConfig", "resolvedTerminals", "$state", "$http", "$compile", "paymentService", "$uibModalInstance", "$timeout", "$location"];
    angular
        .module('redcap.payments')
        .controller('CardConnectPayNowModalController', cardConnectPayNowModalController);

    function cardConnectPayNowModalController($scope, $sce, resolvedInvoice, resolvedPaymentConfig, resolvedTerminals, $state, $http, $compile, paymentService, $uibModalInstance, $timeout, $location) {
        var vm = this;
        vm.invoice = resolvedInvoice;
        vm.terminals = resolvedTerminals;

        vm.collectPayment = function (terminal, isManualEntry) {
            vm.saving = true;
            vm.processedComplete = false;
            paymentService.collectPayment(resolvedInvoice.id, terminal.terminalId, isManualEntry).then(function (result) {
                vm.paymentResult = {
                    result: 0
                };
            }).catch(function (err) {
                vm.paymentResult = {
                    result: -1,
                    message: err.data && err.data.message || err.message
            };
            }).finally(function() {
                vm.saving = false;
                vm.processedComplete = true;
            });
        };

        vm.close = $uibModalInstance.close;
    }
})();

(function () {
    'use strict';

    angular.module('redcap.directives', []);
})();

(function() {
    'use strict';

    LocationSubMenu.$inject = ["permissions"];
    angular
        .module('redcap.directives')
        .directive('locationSubMenu', LocationSubMenu);

    function LocationSubMenu(permissions) {
        return {
            restrict: 'E',
            scope: {
                tripTypes: '<',
                hasCheckIn: '<',
                currentLocation: '<'
            },
            templateUrl: "app/areas/location/views/submenu/location-submenu.view.html",
            bindToController: true,
            controllerAs: 'vm',
            controller: ["$filter", "$rootScope", "SYSTEM_ENUMS", function($filter, $rootScope, SYSTEM_ENUMS) {
                this.$onInit = function() {
                    let vm = this;

                    vm.tripTypes = vm.tripTypes.filter((el) => {
                        return el.systemTripTypeId !== SYSTEM_ENUMS.systemTripType.personalDriver && el.systemTripTypeId  !== SYSTEM_ENUMS.systemTripType.recalls;
                    });

                    vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin(); 
                    vm.isAppointmentAdmin = permissions.isAppointmentAdmin();
                    vm.isAdminLevelUser = permissions.isAdminLevelUser();
                    vm.isDepartmentAdmin = permissions.hasRole(SYSTEM_ENUMS.roleNames.departmentAdmin);
                    vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
                    vm.appointmentTripType = null;
                    vm.productType = SYSTEM_ENUMS.productPermission;

                    let appt = $filter('filter')(vm.tripTypes, {systemTripTypeId: vm.systemTripTypes.appointment}, true);
                  
                    if (appt && appt.length > 0) {
                        vm.appointmentTripType = appt[0];
                    }
                    
                    vm.showCheckIn = function () {
                        if (!vm.appointmentTripType) return false;
            
                        return vm.hasCheckIn;
                    };

                    vm.showInspect = function () {            
                        return permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.inspect) && 
                               permissions.hasDealerPermission(SYSTEM_ENUMS.permissionTypes.inspect) &&
                               (permissions.isSysAdmin() || permissions.isRedCapAdmin() || permissions.isDealerAdmin());            
                    };

                    vm.getEnabledProducts = function () {     
                        let assignedRoles = vm.currentLocation.assignedRoles;
            
                        vm.productEnabled = [];
            
                        assignedRoles.forEach((role) => {
                            {
                                switch (role.name) {
                                    case SYSTEM_ENUMS.permissionTypes.appointments:
                                        vm.productEnabled.Appointments = role.assigned;
                                    break;
                                    case SYSTEM_ENUMS.permissionTypes.checkIn:
                                        vm.productEnabled.CheckIn = role.assigned;
                                    break;
                                    case SYSTEM_ENUMS.permissionTypes.inspect:
                                        vm.productEnabled.Inspect = role.assigned;
                                    break;
                                    case SYSTEM_ENUMS.permissionTypes.loanerManagement:
                                        vm.productEnabled.LoanerManagement = role.assigned;
                                    break;
                                    case SYSTEM_ENUMS.permissionTypes.messaging:
                                        vm.productEnabled.Messaging = role.assigned;
                                    break;
                                    case SYSTEM_ENUMS.permissionTypes.transportation:
                                        vm.productEnabled.Transportation = role.assigned;
                                    break;
                                }
                            }
                        });
                    };

                    vm.tripTypeSwitch = function (tripTypeName, tripTypeId, productPermissionId) {
                        $rootScope.$broadcast('tripTypeSwitched', {
                            tripTypeName: tripTypeName,
                            tripTypeId: tripTypeId,
                            productPermissionId: productPermissionId
                        });
                    };
                    
                    vm.getEnabledProducts();

                    $rootScope.$on('locationUpdated', (event, data) => {
                        vm.getEnabledProducts();
                    });

                    vm.subMenMouseLeave = function() {
                        $rootScope.$broadcast('subMenuMouseLeave');
                    };
                    
                };
            }]
        };
    }

})();


(function () {
    'use strict';

    ImportMatrixLaborRatesModalController.$inject = ["$uibModalInstance", "MAX_MATRIX_ROWS", "MAX_MATRIX_COLUMNS", "SYSTEM_ENUMS"];
    angular
        .module('redcap.location')
        .controller('ImportMatrixLaborRatesModalController', ImportMatrixLaborRatesModalController);

    function ImportMatrixLaborRatesModalController($uibModalInstance, MAX_MATRIX_ROWS, MAX_MATRIX_COLUMNS, SYSTEM_ENUMS) {
        let vm = this;
        const MAX_ROWS = MAX_MATRIX_ROWS;
        const MAX_COLUMNS = MAX_MATRIX_COLUMNS;

        vm.csvMatrixData = '';
        vm.matrixName = '';
        vm.loading = false;
        vm.error = null;

        vm.matrixRateTypes = [
            {value: SYSTEM_ENUMS.matrixRateTypes.rate, label: 'Rate'},
            {value: SYSTEM_ENUMS.matrixRateTypes.price, label: 'Price'}
        ];

        vm.matrixRateType = SYSTEM_ENUMS.matrixRateTypes.rate;

        let isValid = (inputValue) => inputValue && inputValue.trim().length > 0;

        vm.close = function() {
            $uibModalInstance.close(false);
        };

        vm.importMatrix = function() {
            if (!isValid(vm.csvMatrixData)) {
                vm.error = 'Please enter CSV content';

                return;
            }

            if (!isValid(vm.matrixName)) {
                vm.error = 'Please enter a name for the matrix';

                return;
            }

            try {
                let importedLaborRateMatrix = parseCSVToMatrix(vm.csvMatrixData);

                $uibModalInstance.close({
                    name: vm.matrixName.trim(),
                    type: vm.matrixRateType,
                    matrix: importedLaborRateMatrix
                });
            } catch (err) {
                vm.error = 'Error parsing CSV: ' + err.message;
            }
        };

        function parseCSVToMatrix(csvContent) {
            let lines = csvContent.split('\n').map(parseCSVLine).filter(row => row.some(cell => cell.trim().length > 0));
            let headerIndex = lines.findIndex(row => row[0]?.trim().length > 0);
            
            if (headerIndex === -1) {
                throw new Error('No valid header row found in CSV');
            }
            
            let headerRow = lines[headerIndex];

            if (headerRow.length < MAX_COLUMNS + 1) {
                throw new Error('Header row must have at least ' + (MAX_COLUMNS + 1) + ' columns');
            }

            const hourPattern = /^\d+(\.\d+)?$/;
            let dataRows = lines.slice(headerIndex + 1).filter(row => hourPattern.test((row[0] || '').trim()));
            
            if (dataRows.length === 0) {
                throw new Error('No valid data rows found in CSV');
            }
            
            let sparseMatrix = {};
            
            dataRows.forEach(row => {
                let rowNum = parseInt((row[0] || '0').trim());

                if (rowNum >= MAX_ROWS) {
                    return;
                }

                sparseMatrix[rowNum] = {};

                for (let colIndex = 0; colIndex < MAX_COLUMNS; colIndex++) {
                    let cellValue = row[colIndex + 1];
                    
                    if (cellValue && cellValue.trim().length > 0) {
                        let parsedValue = parseMatrixValue(cellValue);
                        
                        if (parsedValue === null) {
                            throw new Error('Invalid value at row ' + rowNum + ', column ' + (colIndex + 1) + ': "' + cellValue + '"');
                        }
                        
                        sparseMatrix[rowNum][colIndex] = parsedValue;
                    } else {
                        sparseMatrix[rowNum][colIndex] = 0.00;
                    }
                }
            });
            
            let matrix = [];
            
            for (let rowNum = 0; rowNum < MAX_ROWS; rowNum++) {
                let matrixRow = [];
                
                if (sparseMatrix[rowNum]) {
                    for (let colIndex = 0; colIndex < MAX_COLUMNS; colIndex++) {
                        matrixRow.push(sparseMatrix[rowNum][colIndex] ?? 0.00);
                    }
                } else {
                    for (let colIndex = 0; colIndex < MAX_COLUMNS; colIndex++) {
                        matrixRow.push(0.00);
                    }
                }
                
                matrix.push(matrixRow);
            }
            
            return matrix;
        }

        function parseCSVLine(line) {
            const pattern = /(?:^|,)(?:"((?:[^"]|"")*)"|([^,]*))/g;
            let result = [];

            for (let match of line.matchAll(pattern)) {
                let value = match[1] !== undefined ? match[1].replace(/""/g, '"') : match[2];

                result.push((value || '').trim());
            }

            return result;
        }

        function parseMatrixValue(laborRateInput) {
            if (!laborRateInput?.trim()) {
                return null;
            }

            if (laborRateInput.trim().toUpperCase() === 'FREE') {
                return 0.00;
            } 

            let parsedLaborRate = parseFloat(laborRateInput.replace(/[$,\s"]/g, ''));

            return isNaN(parsedLaborRate) ? null : Math.round(parsedLaborRate * 100) / 100;
        }

        vm.onMatrixRateTypeChange = function (rateType) {
            vm.matrixRateType = rateType;
        };
    }
})();

(function () {
    'use strict';

    tsdnewIntegration.$inject = ["SYSTEM_ENUMS", "$sce", "loanerService"];
    angular
        .module('redcap.location')
        .component('tsdnewIntegration', {
            templateUrl: 'app/areas/location/views/loaner/tsdnew-integration.view.html',
            controller: tsdnewIntegration,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'dealerId': '<'
            }
        });

    function tsdnewIntegration(SYSTEM_ENUMS, $sce, loanerService) {
        this.$onInit = function() {
            let vm = this;
        };
    }
})();

(function () {
    'use strict';

    tsdIntegration.$inject = ["SYSTEM_ENUMS", "$sce", "loanerService"];
    angular
        .module('redcap.location')
        .component('tsdIntegration', {
            templateUrl: 'app/areas/location/views/loaner/tsd-integration.view.html',
            controller: tsdIntegration,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'dealerId': '<'
            }
        });

    function tsdIntegration(SYSTEM_ENUMS, $sce, loanerService) {
        this.$onInit = function() {
            var vm = this,
                tsdSystem = SYSTEM_ENUMS.loanerManagementSystemsEnum.TSD,
                dealerId = vm.dealerId;

            loanerService.getLocations(dealerId, tsdSystem, vm.ngModel.centerId).then(function(locations) {
                _.forEach(locations,
                    function(location) {
                        location.displayText = loanerService.formatLocationForDropdown(location, 'TSD');
                    });
                vm.locations = locations;
            });

            if (vm.ngModel.locationId) {
                loanerService.getAdvisors(dealerId, vm.ngModel.locationId, tsdSystem, vm.ngModel.centerId).then(
                    function(advisors) {
                        vm.advisors = advisors;
                    });
            }

            if (vm.ngModel.defaultBusinessSourceId) {
                loanerService.getBusinessSources(dealerId, vm.ngModel.locationId, tsdSystem, vm.ngModel.centerId).then(
                    function(businessSources) {
                        vm.businessSources = businessSources;
                    });
            }

            if (vm.ngModel.defaultServiceAdvisorId) {
                vm.ngModel.defaultServiceAdvisorId = vm.ngModel.defaultServiceAdvisorId;
            }

            vm.getLocations = function() {
                loanerService.getLocations(dealerId, tsdSystem, vm.ngModel.centerId).then(function(locations) {
                    _.forEach(locations,
                        function(location) {
                            location.displayText = loanerService.formatLocationForDropdown(location, 'TSD');
                        });
                    vm.locations = locations;
                    vm.ngModel.locationId = null;
                });
            };

            vm.getBusinessSources = function() {
                loanerService.getBusinessSources(dealerId, vm.ngModel.locationId, tsdSystem, vm.ngModel.centerId).then(
                    function(businessSources) {
                        vm.businessSources = businessSources;
                        vm.ngModel.defaultBusinessSourceId = null;
                    });
            };

            vm.getAdvisors = function() {
                if (vm.ngModel.locationId) {
                    loanerService.getAdvisors(dealerId, vm.ngModel.locationId, tsdSystem, vm.ngModel.centerId).then(
                        function(advisors) {
                            vm.advisors = advisors;
                            vm.ngModel.defaultServiceAdvisorId = null;
                        });
                } else {
                    vm.clearAdvisors();
                }
            };

            vm.clearAdvisors = function() {
                vm.advisors = [];
                vm.ngModel.defaultServiceAdvisorId = null;
            };
        };
    }
})();

(function () {
    'use strict';

    loanerIntegration.$inject = ["SYSTEM_ENUMS", "$filter"];
    angular
        .module('redcap.location')
        .component('loanerIntegration', {
            templateUrl: 'app/areas/location/views/loaner/loaner-integration.view.html',
            controller: loanerIntegration,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'dealerId': '<'
            }
        });

    function loanerIntegration(SYSTEM_ENUMS, $filter) {
        this.$onInit = function() {
            let vm = this;
            
            vm.providers = SYSTEM_ENUMS.loanerManagementSystems;
            vm.fakeInput = 1; // do not remove.  solving issue with ghis validation bug

            if (!vm.ngModel.providerType) {
                vm.ngModel.providerType = $filter('filter')(vm.providers, {value: 0}, true)[0].value;
            }
        };
    }
})();

(function () {
    'use strict';

    dealerwareIntegration.$inject = ["SYSTEM_ENUMS", "loanerService"];
    angular
        .module('redcap.location')
        .component('dealerwareIntegration', {
            templateUrl: 'app/areas/location/views/loaner/dealerware-integration.view.html',
            controller: dealerwareIntegration,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'dealerId': '<'
            }
        });

    function dealerwareIntegration(SYSTEM_ENUMS, loanerService) {
        this.$onInit = function() {
            var vm = this,
                dwSystem = SYSTEM_ENUMS.loanerManagementSystemsEnum.DealerWare,
                dealerId = vm.dealerId;

            loanerService.getLocations(dealerId, dwSystem).then(function(locations) {
                _.forEach(locations,
                    function(location) {
                        location.displayText = loanerService.formatLocationForDropdown(location, 'DW');
                    });
                vm.locations = locations;
            });

            if (vm.ngModel.locationId) {
                loanerService.getAdvisors(dealerId, vm.ngModel.locationId, dwSystem).then(function(advisors) {
                    vm.advisors = advisors;
                });
            }

            if (vm.ngModel.defaultServiceAdvisorId) {
                vm.ngModel.defaultServiceAdvisorId = vm.ngModel.defaultServiceAdvisorId;
            }

            vm.getLocations = function() {
                loanerService.getLocations(dealerId, dwSystem).then(function(locations) {
                    _.forEach(locations,
                        function(location) {
                            location.displayText = loanerService.formatLocationForDropdown(location, 'DW');
                        });
                    vm.locations = locations;
                    vm.ngModel.locationId = null;
                });
            };

            vm.getAdvisors = function() {
                if (vm.ngModel.locationId) {
                    loanerService.getAdvisors(dealerId, vm.ngModel.locationId, dwSystem).then(function(advisors) {
                        vm.advisors = advisors;
                        vm.ngModel.defaultServiceAdvisorId = null;
                    });
                } else {
                    vm.clearAdvisors();
                }
            };

            vm.clearAdvisors = function() {
                vm.advisors = [];
                vm.ngModel.defaultServiceAdvisorId = null;
            };

        };
    }
})();

(function () {
    'use strict';

    contractTermsController.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.location')
        .component('loanerContractTerms', {
            templateUrl: 'app/areas/location/views/loaner/contract-terms.view.html',
            controller: contractTermsController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function contractTermsController(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        };
    }
})();

(function () {
    'use strict';

    arsIntegration.$inject = ["SYSTEM_ENUMS", "$sce", "loanerService"];
    angular
        .module('redcap.location')
        .component('arsIntegration', {
            templateUrl: 'app/areas/location/views/loaner/ars-integration.view.html',
            controller: arsIntegration,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'dealerId': '<'
            }
        });

    function arsIntegration(SYSTEM_ENUMS, $sce, loanerService) {
        this.$onInit = function() {
            var vm = this;
        }
    }
})();

(function () {
    'use strict';

    LocationProductSettingsController.$inject = ["resolvedDealerTripTypes", "dealerHasCheckin", "$transition$", "resolvedLocation", "resolvedSettings", "productSettingsService", "eventAlertService"];
    angular
        .module('redcap.location')
        .controller('LocationProductSettingsController', LocationProductSettingsController);

    function LocationProductSettingsController(resolvedDealerTripTypes, dealerHasCheckin, $transition$, resolvedLocation, resolvedSettings, productSettingsService, eventAlertService) {
        let vm = this;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.location = resolvedLocation;
        vm.settings = resolvedSettings;

        vm.settings.forEach((item) => {
            if (item.inputType === 'number') {
                item.value = parseInt(item.value);
            }
        });

        vm.save = function () {
            vm.saving = true;
            productSettingsService.saveSettings($transition$.params().locationId, $transition$.params().productPermissionId, vm.settings).then(() => {
                eventAlertService.createAlert('Settings Successfully Updated.');
            }).finally(() => { 
                vm.saving = false; 
            });
        };
    }
})();

(function () {
    'use strict';

    LocationProductAutomationController.$inject = ["resolvedDealerTripTypes", "dealerHasCheckin", "$transition$", "resolvedLocation", "resolvedSettings", "productSettingsService", "eventAlertService"];
    angular
        .module('redcap.location')
        .controller('LocationProductAutomationController', LocationProductAutomationController);

    function LocationProductAutomationController(resolvedDealerTripTypes, dealerHasCheckin, $transition$, resolvedLocation, resolvedSettings, productSettingsService, eventAlertService) {
        let vm = this;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.location = resolvedLocation;
        vm.settings = resolvedSettings;

        vm.setValues = function() {
            vm.settings.forEach((item) => {
                if (item.inputType === 'number') {
                    item.inputValue = parseInt(item.inputValue);
                }
            });
        };

        vm.setValues();

        vm.addBlankROStatusNotification = function() {
            this.settings.push({
                id: null,
                title: 'RO Status Change - SMS',
                description: 'Sent to a customer when an  RO is imported with the status indicated',
                inputType: 'text',
                inputValue: '',
                value: '',
                Key: "ROStatus",
                canDelete: true,
                enabled: true,
                subText: 'Status'
            });
        };

        vm.deleteSetting = function(idx) {
            vm.settings.splice(idx, 1);
        };

        vm.save = function () {
            vm.saving = true;
            productSettingsService.saveAutomationSettings($transition$.params().locationId, $transition$.params().productPermissionId, vm.settings).then(() => {
                eventAlertService.createAlert('Settings Successfully Updated.');
                productSettingsService.getAutomationSettings($transition$.params().locationId, $transition$.params().productPermissionId).then((result) => {
                    vm.settings = result;
                    vm.setValues();
                });
            }).finally(() => {
                 vm.saving = false;
            });
        };
    }
})();

(function () {
    'use strict';

    LocationTabInspectTaxesController.$inject = ["SYSTEM_ENUMS", "modalService", "dealerInspectionService", "eventAlertService", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "$scope", "$timeout", "rcUtilService", "ValidationService"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectTaxesController', LocationTabInspectTaxesController);

    function LocationTabInspectTaxesController(SYSTEM_ENUMS, modalService, dealerInspectionService, eventAlertService, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, $scope, $timeout, rcUtilService, ValidationService) {
        let vm = this;
        let validationService = new ValidationService({ });

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.taxTypes = SYSTEM_ENUMS.taxTypes;
        vm.taxFeeApplyTypes = SYSTEM_ENUMS.taxFeeApplyType;
        vm.taxes = [];
        vm.isValid = true;

        let taxesToAdd = [];
        let taxesToUpdate = [];
        let taxesToDelete = [];        
        const dealerId = resolvedLocation.id;

        init();

        vm.addNewTax = function () {
            vm.taxes.push({
                id: null,
                shopTaxFeeName: '',
                order: vm.taxes.length + 1,
                dealerId: dealerId,
                isFixedEnabled: true,
                fixedTax: { 
                    fixedAmount: null 
                },
                variableTax: {
                    partsPercent: null,
                    shopSupplies: null,
                    discounts: null,
                    minAmount: null,
                    laborPercent: null,
                    fees: null,
                    totalPercent: null,
                    maxAmount: null                    
                },
                minAmount: null,
                isTaxNameInValid: true,
                onlyApplyTaxIfGreaterThan: null,
                taxFeeApplyType: null               
            });            
        };
        
        vm.onTaxesReorder = function (e, ui) {
            vm.taxes.forEach((tax, index) => {
                tax.order = index + 1;               
            });
        };        
        
        vm.isValidTaxEntry = function (tax) {
            vm.isValid = true;

            if (!tax.isFixedEnabled) {
                if (tax.variableTax.partsPercent == null && tax.variableTax.shopSupplies == null && tax.variableTax.discounts == null && tax.variableTax.minAmount == null && tax.variableTax.laborPercent == null && tax.variableTax.fees == null && tax.variableTax.totalPercent == null && tax.variableTax.maxAmount == null) { 
                    vm.isValid = false;
                    vm.validationMsg = 'At least one field is required';

                    return false;
                } else {
                    vm.isValid = true;

                    return true;
                }
            } else {
                return true;
            }
        };

        vm.saveChanges = function () {
            vm.saving = true;
            const promises = [];
            
            taxesToAdd = [];
            taxesToUpdate = [];

            vm.isValid = true;

            vm.taxes.forEach(tax => {
                if (vm.isValidTaxEntry(tax) === true) {

                if (tax.id) {
                    if (!taxesToUpdate.includes(tax))
                    taxesToUpdate.push(tax);
                } else {
                    if (!taxesToAdd.includes(tax))
                    taxesToAdd.push(tax);
                }
            } else {
                vm.isValid = false;

                return;
            }
            });

            if (!vm.isValid) {
                vm.saving = false;

                return;
            }

            if (taxesToUpdate.length > 0) {
                const taxesToUpdatePromise = dealerInspectionService.updateTaxes(dealerId, taxesToUpdate).then(()  => {                    
                   taxesToUpdate = [];                  
                }).catch((err) => {                    
                    console.error('Error updating Taxes.', err);
                });

                promises.push(taxesToUpdatePromise);
            }
            
            if (taxesToAdd.length > 0) {
                const taxesToAddPromise = dealerInspectionService.addNewTaxes(dealerId, taxesToAdd).then(() => {
                   taxesToAdd = [];                  
                }).catch((err) => {
                console.error('Error adding Taxes.', err);
                });
                
                promises.push(taxesToAddPromise);
            }
            
            if (taxesToDelete.length > 0) {
                const taxesToDeletePromise = dealerInspectionService.deleteTaxes(dealerId, taxesToDelete).then(() => {
                   taxesToDelete = [];
                }).catch((err) => {
                console.error('Error deleting Taxes.', err);
                }); 
                
                promises.push(taxesToDeletePromise);
            }
            
            Promise.all(promises).then(responses => {
                vm.saving = false;
                eventAlertService.createAlert('Taxes were updated successfully');
                
                return getTaxes(); // Call getTaxes() after successful update
            }).then(() => {
            }).catch((err) => {
                vm.saving = false;
                console.error('Error in one of the operations:', err);
            });
        };

        vm.validation = {
            minTaxAmount: function (tax) {    
                if (!tax.isEnabled) return true;

                return vm.checkMinMax(tax);
            },
            maxTaxAmount: function (tax) {    
                if (!tax.isEnabled) return true;

                return vm.checkMinMax(tax);
            },
            minAmount: function (tax) {   
                if (!tax.isEnabled) return true;

                const isInvalid = tax.taxFeeApplyType && !tax.onlyApplyTaxIfGreaterThan;

                return {isValid: !isInvalid};
            },
            taxFeeApplyType: function (tax) {
                if (!tax.isEnabled) return true;

                if (!rcUtilService.isEmpty(tax.onlyApplyTaxIfGreaterThan) && rcUtilService.isEmpty(tax.taxFeeApplyType)) {
                    return false;
                } else {
                    return true;
                }
            }, 
            fixedAmount: function (tax) {
                if (tax.isFixedEnabled && tax.isEnabled) {
                    if (rcUtilService.isEmpty(tax.fixedTax.fixedAmount)) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
            shopTaxFeeName: function (tax) {
                if (!tax.isEnabled) return true;

                if (rcUtilService.isEmpty(tax.shopTaxFeeName)) {
                    return {isValid: false};
                } else if (! vm.checkDuplicateTaxName(tax)) {
                    return {isValid: false};
                } else {
                    return {isValid: true};
                }
            }           
        };      

        vm.revalidate = function (controlToValidate) {
            if (controlToValidate) {
                $timeout(() => {
                    $scope.$broadcast('angularValidation.revalidate', controlToValidate);
                });
            } 
        };        

        vm.taxEnableUpdated = function (tax) {
            $timeout(() => {
                if (tax.isEnabled) {
                    validationService.checkFormValidity($scope.inputForm);
                }
            }, 1);
            
        };

        vm.checkMinMax = function (taxSetting) {
			if (taxSetting.variableTax !== undefined) {
                if ((rcUtilService.isEmpty(taxSetting.variableTax.minAmount)) && (rcUtilService.isEmpty(taxSetting.variableTax.maxAmount))) {
                    return true;                   
                } else if (parseFloat(taxSetting.variableTax.minAmount) <= parseFloat(taxSetting.variableTax.maxAmount)) {
                    return true;
                } else if (parseFloat(taxSetting.variableTax.minAmount) > parseFloat(taxSetting.variableTax.maxAmount)) {
                    return false;
                } else if ((!rcUtilService.isEmpty(taxSetting.variableTax.minAmount)) && (rcUtilService.isEmpty(taxSetting.variableTax.maxAmount))) {
                    return false;
                }
			}
		};
        
        vm.checkDuplicateTaxName = function (tax) {
            const duplicateTax = vm.taxes.find(t => t.shopTaxFeeName.toLowerCase() === tax.shopTaxFeeName.toLowerCase() && t.id !== tax.id);

            if (duplicateTax) {
                return false;
            } else {
                return true;
            }
        };    

        function init() {
            getTaxes();
            
            $scope.$on(SYSTEM_ENUMS.eventNames.locationTabCanChange, (e, cb) => {
                const hasChanges = !angular.equals(vm.initialTaxesState, vm.taxes);
                
                cb(hasChanges);
            });
        }

        function getTaxes() {
            return dealerInspectionService.getShopTaxes(dealerId).then(taxes => {
                if (taxes) {
                    vm.taxes = _.sortBy(taxes, 'order');
                    vm.initialTaxesState = angular.copy(vm.taxes);

                    $timeout(() => {
                        validationService.checkFormValidity($scope.inputForm);
                    }, 1);
                }
            }).catch((err) => {
                console.error('Error getting taxes.', err);
            });
        }
        
        vm.removeTaxes = function (tax, index) {
            modalService.showYesNo('Are you sure?',
                'Are you sure you want to delete this Tax?',
                'No',
                'Yes')
                .then(deleteConfirmed => {
                    if (deleteConfirmed) {
                        if (tax.id) {
                            vm.taxes.splice(index, 1);
                            taxesToDelete.push(tax);
                        } else {
                            vm.taxes.splice(index, 1);

                            const i = taxesToAdd.findIndex(shopTax => shopTax.name === tax.name && shopTax.order === tax.order);
                            
                            taxesToAdd.splice(i, 1);
                        }
                    }
                });
        };
    }
})();

(function () {
    'use strict';

    LocationTabInspectShopFlagsController.$inject = ["$scope", "modalService", "dealerInspectionService", "eventAlertService", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "SYSTEM_ENUMS"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectShopFlagsController', LocationTabInspectShopFlagsController);

    function LocationTabInspectShopFlagsController($scope, modalService, dealerInspectionService, eventAlertService, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, SYSTEM_ENUMS) {
        const vm = this; 
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.shopFlags = [];     
        vm.isValid = true;
        vm.initialShopFlagsState = [];

        const dealerId = resolvedLocation.id;
        let shopFlagsToAdd = [];
        let shopFlagsToUpdate = [];
        let shopFlagsToDelete = [];        

        init();

        vm.addNewShopFlag = function () {
            vm.shopFlags.push({
                id: null,
                name: '',
                color: '',
                textColor: '',
                order: vm.shopFlags.length + 1
            });

            vm.isValid = false;
        };

        vm.onColumnReorder = function (e, ui) {
            vm.shopFlags.forEach((shopFlag, index) => {
                shopFlag.order = index + 1;
                trackShopFlagUpdate(shopFlag);
            });
        };

        vm.saveChanges = function () {
            vm.saving = true;
            const promises = [];

            if (shopFlagsToUpdate.length > 0) {
                const shopFlagsToUpdatePromise = dealerInspectionService.updateShopFlags(dealerId, shopFlagsToUpdate).then(() => {                    
                   shopFlagsToUpdate = [];                  
                }).catch((err) => {                    
                    console.error('Error updating shop flags.', err);
                });

                promises.push(shopFlagsToUpdatePromise);    
            }
            
            if (shopFlagsToAdd.length > 0) {
                const shopFlagsToAddPromise = dealerInspectionService.addShopFlags(dealerId, shopFlagsToAdd).then(() => {
                   shopFlagsToAdd = [];                  
                }).catch((err) => {
                   console.error('Error adding shop flags.', err);
                });

                promises.push(shopFlagsToAddPromise);                
            }
            
            if (shopFlagsToDelete.length > 0) {
                const shopFlagsToDeletePromise = dealerInspectionService.removeShopFlag(dealerId, shopFlagsToDelete).then(() => {
                   shopFlagsToDelete = [];
                }).catch((err) => {
                   console.error('Error deleting shop flags.', err);
                });
                
                promises.push(shopFlagsToDeletePromise);              
            }            

            Promise.all(promises).then((responses) => {
                vm.saving = false;
                eventAlertService.createAlert('Shop Flags were updated successfully');
                
                return getShopFlags();
            }).catch((err) => {
                console.error('Error during save operation.', err);
            });
        };

        function trackShopFlagUpdate(shopFlag) {
            if (shopFlag.id != null) {
                if (!shopFlagsToUpdate.includes(shopFlag)) {
                    shopFlagsToUpdate.push(shopFlag);
                }
            } else {
                if (!shopFlagsToAdd.includes(shopFlag)) {
                    shopFlagsToAdd.push(shopFlag);
                }
            }
        }

        function init() {
            getShopFlags();
            vm.isValid = true;
            vm.validationMsg = '';
            
            $scope.$on(SYSTEM_ENUMS.eventNames.locationTabCanChange, (e, cb) => {
                const hasChanges = !angular.equals(vm.initialShopFlagsState, vm.shopFlags);
                
                cb(hasChanges);
            });
        }

        function getShopFlags() {
            return dealerInspectionService.getShopFlags(dealerId).then((shopFlags) => {
                if (shopFlags) {
                    vm.shopFlags = _.sortBy(shopFlags, 'order');
                    vm.initialShopFlagsState = angular.copy(vm.shopFlags);
                }
            }).catch((err) => {
                console.error('Error getting shop flags.', err);
            });
        }     

        vm.shopFlagChanged = function (shopFlag) {
            if (vm.shopFlags.length === 1) {
                vm.validationMsg = '';
                vm.isValid = true;
            } else if (shopFlag.name && shopFlag.color) {
                const duplicateExists = vm.shopFlags.some((flag) => flag.id !== shopFlag.id && 
                                                                    (flag.name.trim().toUpperCase() === shopFlag.name.trim().toUpperCase() || 
                                                                     flag.color === shopFlag.color));

                if (duplicateExists) {
                    vm.validationMsg = `Shop Flag ${shopFlag.name} already exists with same name and/or color.`;
                    vm.isValid = false;
                } else {
                    vm.validationMsg = '';
                    vm.isValid = true;
                }
            } else {
                vm.validationMsg = shopFlag.name ? '' : 'Name is Required';
                vm.validationMsg = shopFlag.color ? vm.validationMsg : 'Color is Required';
                vm.isValid = false;
            }

            if (vm.isValid) {
                trackShopFlagUpdate(shopFlag);
            }
        };

        vm.removeShopFlag = function (shopFlag, index) {
            modalService.showYesNo('Are you sure?',
                'Are you sure you want to delete this ShopFlag?',
                'No',
                'Yes').then((deleteConfirmed) => {
                if (deleteConfirmed) {
                    if (shopFlag.id) {
                        vm.shopFlags.splice(index, 1);
                        shopFlagsToDelete.push(shopFlag);

                        if (shopFlagsToUpdate.includes(shopFlag)) {
                            const updateIndex = shopFlagsToUpdate.findIndex(flag => flag.id === shopFlag.id);
                            
                            shopFlagsToUpdate.splice(updateIndex, 1);
                        }
                    } else {
                        vm.shopFlags.splice(index, 1);
                        const i = shopFlagsToAdd.findIndex(flag => flag.name === shopFlag.name && flag.color === shopFlag.color);
                        
                        shopFlagsToAdd.splice(i, 1);
                    }
                }
            });
        }; 
    }
})();

(function () {
    'use strict';

    LocationTabInspectRoStatusController.$inject = ["$scope", "SYSTEM_ENUMS", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "rcUtilService", "eventAlertService", "employeeService", "dealerInspectionService", "userRolesService", "modalService"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectRoStatusController', LocationTabInspectRoStatusController);

    function LocationTabInspectRoStatusController($scope, SYSTEM_ENUMS, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, rcUtilService, eventAlertService, employeeService, dealerInspectionService, userRolesService, modalService) {
        const vm = this;
        const dealerId = resolvedLocation.id;
        const assignableRoles = [SYSTEM_ENUMS.roleNames.serviceAdvisor.toLowerCase(), SYSTEM_ENUMS.roleNames.serviceManager.toLowerCase(), SYSTEM_ENUMS.roleNames.technician.toLowerCase(), SYSTEM_ENUMS.roleNames.partsAssociate.toLowerCase()];
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.inspectStatusRoles = SYSTEM_ENUMS.inspectStatusRole;  
        vm.statuses = [];
        vm.roles = [];
        vm.users = []; 
        vm.statusToDelete = [];        
        vm.validationMsg = '';  
        vm.saving = false;

        function init() {
            vm.isLoading = true;
        
            const dealerUsersPromise = employeeService.getConfiguredEmployeesByLocation(dealerId);            
            const statusesPromise = dealerInspectionService.getRoStatuses(dealerId);
            const rolesPromise = userRolesService.getRolesForUserFilter().then((roles) => { 
                return roles.filter((role) => assignableRoles.includes(role.name.toLowerCase())); 
            });

            Promise.all([dealerUsersPromise, statusesPromise, rolesPromise]).then((results) => {
                vm.dealerUsers = results[0];
                vm.statuses = results[1];
                vm.roles = results[2];
 
                vm.statuses.forEach((status) => {
                    status.original = angular.copy(status);
                });

                vm.initialStatusesState = angular.copy(vm.statuses);
            }).catch((error) => {
                console.error('Error initializing:', error);
            }).finally(() => {
                vm.isLoading = false;
            });

            $scope.$on(SYSTEM_ENUMS.eventNames.locationTabCanChange, (e, cb) => {
                const hasChanges = !angular.equals(vm.initialStatusesState, vm.statuses);
                
                cb(hasChanges);
            });
        }

        vm.addNewStatus = function() {
            vm.statuses.push({
                name: '',
                dealerId: dealerId,
                isFixed: 0,
                colorHex: '#ffffff',
                textColor: '',
                roleId: null,
                alwaysAssignedUserId: null,
                customerStatusUpdate: false,
                order: vm.statuses.length + 1,
                description: ''
            });
        };

        vm.deleteStatus = (status, index) => {
            modalService.showYesNo(
                'Are you sure?',
                'Are you sure you want to delete this Status?',
                'No',
                'Yes'
            ).then((deleteConfirmed) => {
                if (deleteConfirmed) {
                    if (status) {
                        vm.statusToDelete.push(status);
                    }
                    
                    vm.statuses.splice(index, 1);
                }
            });
        };
        
        vm.save = function() {
            vm.saving = true;

            const promisesForDelete = [];

            vm.statusToDelete.forEach((status) => {
                if (status.id) {
                    const deletePromise = dealerInspectionService.deleteRoStatus(dealerId, status.id).then(response => {
                        if (!response) {
                            console.error('Failed to delete status:', response);
                        }
                    });

                    promisesForDelete.push(deletePromise);
                }
            });

            Promise.all(promisesForDelete).then(() => {
                vm.statusToDelete = [];
                const promises = [];
            
                vm.statuses.forEach((status) => {   
                    if (!status.id) {
                        const createPromise = dealerInspectionService.createRoStatus(dealerId, status).then((savedStatus) => {
                            if (savedStatus) {
                                status.id = savedStatus.id;
                                status.original = angular.copy(status);
                            } else {
                                console.error('Failed to create status:', savedStatus);
                            }
                        }).catch((error) => {
                            console.error('Error creating status:', error);
                        });
    
                        promises.push(createPromise);
                    } else {
                        if (hasStatusChanged(status, status.original)) {
                            const updatedStatus = {
                                name: status.name,
                                colorHex: status.colorHex,
                                textColor: status.textColor,
                                roleId: status.roleId,
                                alwaysAssignedUserId: status.alwaysAssignedUserId,
                                customerStatusUpdate: status.customerStatusUpdate,
                                order: status.order
                            };
    
                            const updatePromise = dealerInspectionService.updateInspectRoStatus(dealerId, status.id, updatedStatus).then((response) => {
                                if (response) {
                                    status.original = angular.copy(status);
                                }
                            }).catch((error) => {
                                console.error('Error updating status:', error);
                            });
    
                            promises.push(updatePromise);
                        }
                    }
                });
    
                Promise.all(promises).then(() => {
                    eventAlertService.createAlert('Statuses Updated Successfully!');
                    vm.initialStatusesState = angular.copy(vm.statuses);
                }).finally(() => {
                    vm.saving = false;
                });
            });
        };

        vm.validation = {
            statusName: function(changedStatus) {
                if (rcUtilService.isEmpty(changedStatus.name)) {
                    return false;
                }               
          
                const hasDupeName = vm.statuses.some((status) => { return status.id !== changedStatus.id && status.name.trim().toLowerCase() === changedStatus.name.trim().toLowerCase(); });
                
                if (hasDupeName) {
                    return false;
                }

                 return true;
            }
        };

        function hasStatusChanged(updated, original) {
            return original.name !== updated.name ||
                original.colorHex !== updated.colorHex ||
                original.textColor !== updated.textColor ||
                original.customerStatusUpdate !== updated.customerStatusUpdate ||
                original.roleId !== updated.roleId ||
                original.alwaysAssignedUserId !== updated.alwaysAssignedUserId |
                original.order !== updated.order;
        }

        vm.onStatusReorder = function(e, ui) {
            vm.statuses.forEach((status, index) => {
                status.order = index + 1; 
            });
        };

        init();
    }
})();

(function () {
    'use strict';

    LocationTabInspectRoShopSuppliesController.$inject = ["SYSTEM_ENUMS", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "eventAlertService", "dealerInspectionService", "modalService", "$scope"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectRoShopSuppliesController', LocationTabInspectRoShopSuppliesController);

    function LocationTabInspectRoShopSuppliesController(SYSTEM_ENUMS, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, eventAlertService, dealerInspectionService, modalService, $scope) {
        const vm = this;
        const dealerId = resolvedLocation.id;
        let initialShopSupplies = {};
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.shopSupplies = {};
        vm.saving = false;

        vm.shopSupplyCalculationTypes = [
            {value: '1', label: 'Retail Total'},
            {value: '2', label: 'Parts'},
            {value: '3', label: 'Labor'}
        ];
     
        function init() {
            dealerInspectionService.getShopSupplies(dealerId).then((shopSupplies) => {
                if (!shopSupplies) {
                    return;
                }
        
                vm.shopSupplies = {
                    shopSupplyRate: shopSupplies.shopSupplyRate,
                    shopSupplyCalculationType: shopSupplies.shopSupplyCalculationType.toString(),
                    shopSupplyMinimum: shopSupplies.shopSupplyMinimum,
                    shopSupplyMaximum: shopSupplies.shopSupplyMaximum
                };
                
                initialShopSupplies = angular.copy(vm.shopSupplies);
            }).catch((error) => {
                console.error('Error fetching shop supplies:', error);
            });

            $scope.$on(SYSTEM_ENUMS.eventNames.locationTabCanChange, (e, cb) => {
                const hasChanges = !angular.equals(normalizeShopSupplies(vm.shopSupplies), normalizeShopSupplies(initialShopSupplies));
                
                cb(hasChanges);
            });
        }

        function updateShopSupplies(shopSuppliesData) {
            dealerInspectionService.updateShopSupplies(dealerId, shopSuppliesData).then(() => {
                vm.saving = false;
                eventAlertService.createAlert('ShopSupplies Updated Successfully!');
                
                initialShopSupplies = angular.copy(shopSuppliesData);
            }).catch((error) => {
                vm.saving = false;
                console.error('Error updating shop supplies:', error);
            });
        }

        vm.save = function() {
            if (parseFloat(vm.shopSupplyMinimum) >= parseFloat(vm.shopSupplyMaximum)) {
                modalService.showError('Minimum charge must be less than maximum charge.');
                
                return;
            }

            let shopSuppliesData = angular.copy(vm.shopSupplies);
            
            vm.saving = true;

            updateShopSupplies(shopSuppliesData);
        };

        vm.validation = {
            checkMinMaxValues: function () {
                const min = parseFloat(vm.shopSupplies.shopSupplyMinimum);
                const max = parseFloat(vm.shopSupplies.shopSupplyMaximum);
        
                return !isNaN(min) && !isNaN(max) && min < max;
            }
        };        

        function normalizeShopSupplies(shopSupplies) {
            return {
                shopSupplyRate: parseFloat(shopSupplies.shopSupplyRate).toFixed(2),
                shopSupplyMinimum: parseFloat(shopSupplies.shopSupplyMinimum).toFixed(2),
                shopSupplyMaximum: parseFloat(shopSupplies.shopSupplyMaximum).toFixed(2),
                shopSupplyCalculationType: shopSupplies.shopSupplyCalculationType
            };
        }

        init();
    }
})();

(function () {
    'use strict';

    LocationTabInspectPartsAvailabilityController.$inject = ["SYSTEM_ENUMS", "modalService", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "eventAlertService", "dealerInspectionService", "$scope"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectPartsAvailabilityController', LocationTabInspectPartsAvailabilityController);

    function LocationTabInspectPartsAvailabilityController(SYSTEM_ENUMS, modalService, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, eventAlertService, dealerInspectionService, $scope) {
        let vm = this;
        let partsStatusToAdd = [];
        let partsStatusToUpdate = [];
        let partsStatusToDelete = [];
        const dealerId = resolvedLocation.id;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.partsStatus = [];
        vm.isValid = true;
        vm.initialPartsStatusState = [];

        init();

        vm.addNewStatus = function () {
            vm.partsStatus.push({
                id: null,
                name: '',
                description: '',
                order: vm.partsStatus.length + 1,
                isFixed: false
            });
            
            vm.isValid = false;
        };

        vm.onColumnReorder = function (e, ui) {
            vm.partsStatus.forEach((part, index) => {
                part.order = index + 1;
                vm.trackPartsStatusUpdate(part);
            });
        };

        function init() {
            getPartsStatus().then(() => {
                vm.isValid = true;
                vm.validationMsg = '';
            }).catch((err) => {
                console.error('Error during initialization.', err);
            });

            $scope.$on(SYSTEM_ENUMS.eventNames.locationTabCanChange, (e, cb) => {
                const hasChanges = !angular.equals(vm.initialPartsStatusState, vm.partsStatus);
                
                cb(hasChanges);
            });
        }

        function getPartsStatus() {
            return dealerInspectionService.getPartsStatus(dealerId)
                .then((partsStatus) => {
                    vm.partsStatus = _.sortBy(partsStatus, 'order');
                    vm.initialPartsStatusState = angular.copy(vm.partsStatus);
                })
                .catch((err) => {
                    console.error('Error getting parts status availability.', err);
                });
        }

        vm.removePartsStatus = function (partsStatus, index) {
            modalService.showYesNo('Are you sure?', 'Are you sure you want to delete this PartsStatus?',
                 'No',
                 'Yes').then((deleteConfirmed) => {
                    if (deleteConfirmed) {
                        if (partsStatus.id) {
                            vm.partsStatus.splice(index, 1);
                            partsStatusToDelete.push(partsStatus);
                        } else {
                            vm.partsStatus.splice(index, 1);
                            const i = partsStatusToAdd.findIndex(status => status.name === partsStatus.name);

                            partsStatusToAdd.splice(i, 1);
                        }
                    }
                });
        };       

        vm.validation = function (partStatus) {
            if (partStatus === undefined) {
                return false;
            } else if (partStatus && partStatus.name) {
            const duplicateExists = vm.partsStatus.some((part) => part.id !== partStatus.id && 
                                                        (part.name.trim().toUpperCase() === partStatus.name.trim().toUpperCase()));

                if (duplicateExists) {
                    vm.validationMsg = `Parts Status ${partStatus.name} already exists with the same name.`;
                    vm.isValid = false;
                } else {
                    vm.validationMsg = '';
                    vm.isValid = true;
                }
            } else {
                vm.validationMsg = 'Name is Required';
                vm.isValid = false;

                return false;
            }

            if (vm.isValid) {
                vm.trackPartsStatusUpdate(partStatus);
            }
        };

        vm.saveChanges  = function () { 
            vm.saving = true;
            const promises = [];

            if (partsStatusToUpdate.length > 0) {
                const partsStatusToUpdatePromise = dealerInspectionService.updatePartsStatus(dealerId, partsStatusToUpdate).then(() => {
                    partsStatusToUpdate = [];                        
                }).catch((err) => {
                    console.error('Error updating PartsStatus.', err);
                });

                promises.push(partsStatusToUpdatePromise);
            }

            if (partsStatusToAdd.length > 0) {
                const partsStatusToAddPromise = dealerInspectionService.addPartsStatus(dealerId, partsStatusToAdd).then(() => {
                    partsStatusToAdd = [];
                }).catch((err) => {
                    console.error('Error adding PartsStatus.', err);
                });

                promises.push(partsStatusToAddPromise);
            }
            
            if (partsStatusToDelete.length > 0) {
                const partsStatusToDeletePromise = dealerInspectionService.removePartsStatus(dealerId, partsStatusToDelete).then(() => {
                    partsStatusToDelete = [];                        
                }).catch((err) => {
                    console.error('Error deleting PartsStatus.', err);
                });

                promises.push(partsStatusToDeletePromise);
            }

            Promise.all(promises).then((responses) => {
                vm.saving = false;
                eventAlertService.createAlert('Part Statuses were updated successfully');
                
                return getPartsStatus(); // Call getPartsStatus() after successful update
            }).then(() => {
            }).catch((err) => {
                console.error('Error during save operation.', err);
            });
        };

        vm.trackPartsStatusUpdate = function (partsStatus) {
            if (partsStatus.id != null) {
                if (!partsStatusToUpdate.includes(partsStatus)) {
                    partsStatusToUpdate.push(partsStatus);
                }
            } else {
                if (!partsStatusToAdd.includes(partsStatus)) {
                    partsStatusToAdd.push(partsStatus);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    LocationTabInspectGeneralController.$inject = ["$scope", "eventAlertService", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "locationService"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectGeneralController', LocationTabInspectGeneralController);

    function LocationTabInspectGeneralController($scope, eventAlertService, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, locationService) {
        const vm = this;
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.dealer = resolvedLocation;     
        vm.isLoading = true;

        vm.saveChanges = function() {
            vm.saving = true;

            locationService.updateLocation(vm.dealer).then((response) => {
                eventAlertService.createAlert('Settings saved successfully.');
            }).finally(() => {
                vm.saving = false;
            });
        };
    }
})();
(function () {
    'use strict';

    LocationTabInspectLaborRatesController.$inject = ["SYSTEM_ENUMS", "MAX_MATRIX_ROWS", "MAX_MATRIX_COLUMNS", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "eventAlertService", "dealerInspectionService", "modalService", "permissions", "$scope", "$uibModal"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectLaborRatesController', LocationTabInspectLaborRatesController);

    function LocationTabInspectLaborRatesController(SYSTEM_ENUMS, MAX_MATRIX_ROWS, MAX_MATRIX_COLUMNS, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, eventAlertService, dealerInspectionService, modalService, permissions, $scope, $uibModal) {
        const vm = this;
        const dealerId = resolvedLocation.id;
        const MAX_ROWS = MAX_MATRIX_ROWS;
        const MAX_COLUMNS = MAX_MATRIX_COLUMNS;
        let initialFixedRates = [];
        let initialMatrixRates = [];
        let initialLaborRateSettings = {};
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.laborRateSettings = null;
        vm.currentMatrixRateIndex = null;
        vm.fixedRates = [];
        vm.matrixRates = [];
        vm.fixedRatesToDelete = [];
        vm.matrixRatesToDelete = [];
        vm.saving = false;
        vm.isLoading = true;
        vm.editingValue = [];
        vm.editingCell = null;
        vm.isRateTypeChanging = false;
        vm.SYSTEM_ENUMS = SYSTEM_ENUMS;
        vm.isAdminUser = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        vm.customerRateTypes = [
            {value: SYSTEM_ENUMS.rateTypes.fixed, label: 'Fixed Rate(s)'},
            {value: SYSTEM_ENUMS.rateTypes.matrix, label: 'Matrix'}
        ];
        vm.matrixRateTypes = [
            {value: SYSTEM_ENUMS.matrixRateTypes.rate, label: 'Rate'},
            {value: SYSTEM_ENUMS.matrixRateTypes.price, label: 'Price'}
        ];
        vm.selectedCustomerRateType = SYSTEM_ENUMS.rateTypes.matrix;

        function init() {
            return dealerInspectionService.getLaborRateSettings(dealerId)
                .then((response) => {
                    vm.laborRateSettings = response;
                    vm.laborRateSettings.matrixType = SYSTEM_ENUMS.matrixRateTypes.rate;
        
                    const customRate = response.customLaborRates.map((rate) => ({
                        id: rate.id,
                        name: rate.name,
                        rate: rate.rate,
                        isDefault: rate.isDefault,
                        laborRateSettingId: vm.laborRateSettings.id,
                        order: rate.order || 0
                    })).sort((a, b) => a.order - b.order);
        
                    vm.fixedRates = customRate;
        
                    const matrixRate = response.matrixLaborRates.map((rate) => {
                        const {rateMatrix, priceMatrix} = initializeMatrixFromRate(rate.matrix, true);
                
                        return {
                            id: rate.id,
                            name: rate.name,
                            rateMatrix: rateMatrix,
                            priceMatrix: priceMatrix,
                            originalMatrix: rateMatrix,
                            isDefault: rate.isDefault,
                            laborRateSettingId: vm.laborRateSettings.id,
                            matrixRateType: SYSTEM_ENUMS.matrixRateTypes.rate,
                            order: rate.order || 0
                        };
                    }).sort((a, b) => a.order - b.order);
        
                    vm.matrixRates = matrixRate;
                    
                    vm.selectedCustomerRateType = vm.laborRateSettings.useFixedRate ? SYSTEM_ENUMS.rateTypes.fixed : SYSTEM_ENUMS.rateTypes.matrix;

                    initialFixedRates = angular.copy(vm.fixedRates);
                    initialMatrixRates = angular.copy(vm.matrixRates);
                    initialLaborRateSettings = angular.copy(vm.laborRateSettings);
                })
                .catch((error) => {
                    console.error('Error fetching labor rate settings:', error);
                })
                .finally(() => {
                    vm.isLoading = false;
                    vm.isRateTypeChanging = false;
                });
        }

        function initializeMatrixFromRate(matrixRate, calculatePrice = true) {
            let rateMatrix = [];
            let priceMatrix = [];

            for (let i = 0; i < MAX_ROWS; i++) {
                let rateRow = [];
                let priceRow = [];

                for (let j = 0; j < MAX_COLUMNS; j++) {
                    if (matrixRate && matrixRate[i] && matrixRate[i][j] !== undefined) {
                        rateRow.push(matrixRate[i][j]);
                        
                        if (calculatePrice) {
                            let divisor = i + (j / 10);
                            
                            priceRow.push(divisor !== 0.0 ? parseFloat((matrixRate[i][j] / divisor)) : 0.00);
                        } else {
                            priceRow.push(0.00);
                        }
                    } else {
                        rateRow.push(0.00);
                        priceRow.push(0.00);
                    }
                }

                rateMatrix.push(rateRow);
                priceMatrix.push(priceRow);
            }

            return {rateMatrix, priceMatrix};
        }

        vm.onMatrixRateTypeChange = function (matrixRate) {
            const isToPrice = matrixRate.matrixRateType === SYSTEM_ENUMS.matrixRateTypes.price;
        
            const sourceMatrix = isToPrice ? matrixRate.rateMatrix : matrixRate.priceMatrix;
            const targetMatrix = sourceMatrix.map((row, rIndex) =>
                row.map((value, cIndex) => {
                    const divisor = rIndex + (cIndex / 10);
                    
                    return divisor ? parseFloat((value * (isToPrice ? divisor : 1 / divisor))) : 0;
                })
            );
        
            if (isToPrice) {
                matrixRate.priceMatrix = targetMatrix;
            } else {
                matrixRate.rateMatrix = targetMatrix;
            }
        };

        vm.addFixedRate = function() {
            const newRate = {
                name: '',
                rate: 0,
                isDefault: false,
                order: vm.fixedRates.length + 1
            };

            vm.fixedRates.push(newRate);
            vm.setLaborRateDefault();
        };

        vm.addMatrixRate = function() {
            const {rateMatrix, priceMatrix} = initializeMatrixFromRate();
        
            const newRate = {
                name: '',
                rateMatrix: rateMatrix,
                priceMatrix: priceMatrix,
                originalMatrix: rateMatrix,
                isDefault: false,
                matrixRateType: SYSTEM_ENUMS.matrixRateTypes.rate,
                order: vm.matrixRates.length + 1
            };
            
            vm.matrixRates.push(newRate);
            vm.setLaborRateDefault();
        };

        vm.deleteFixedRate = function(rate, index) {
            modalService.showYesNo(
                'Are you sure?',
                'Are you sure you want to delete this Fixed Rate?',
                'No',
                'Yes'
            ).then((deleteConfirmed) => {
                if (deleteConfirmed) {
                    if (rate.id) {
                        vm.fixedRatesToDelete.push(rate);
                    }

                    vm.fixedRates.splice(index, 1);
                    vm.setLaborRateDefault();
                }
            });
        };
        
        vm.deleteMatrixRate = function(rate, index) {
            modalService.showYesNo(
                'Are you sure?',
                'Are you sure you want to delete this Matrix Rate?',
                'No',
                'Yes'
            ).then((deleteConfirmed) => {
                if (deleteConfirmed) {
                    if (rate.id) {
                        vm.matrixRatesToDelete.push(rate);
                    }

                    vm.matrixRates.splice(index, 1);
                    vm.setLaborRateDefault();
                }
            });
        };

        vm.confirmRateTypeChange = () => {
            const newRateType = vm.selectedCustomerRateType;
            let previousRateType = null;

            if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.fixed) {
                previousRateType = SYSTEM_ENUMS.rateTypes.matrix;
            } else {
                previousRateType = SYSTEM_ENUMS.rateTypes.fixed;
            }

            vm.selectedCustomerRateType = previousRateType;
            vm.isRateTypeChanging = true;

            modalService.showYesNo(
                'Are you sure?',
                'Changing the rate type will clear any existing rates. Do you want to proceed?',
                'No',
                'Yes'
            ).then((confirmed) => {
                if (confirmed) {
                    const internalPayRate = vm.laborRateSettings.internalPayRate;
                    const warrantyPayRate = vm.laborRateSettings.warrantyPayRate;

                    init().then(() => {
                        vm.selectedCustomerRateType = newRateType;
                        vm.laborRateSettings.internalPayRate = internalPayRate;
                        vm.laborRateSettings.warrantyPayRate = warrantyPayRate;
                    });
                } else {
                    vm.selectedCustomerRateType = previousRateType;
                    vm.isRateTypeChanging = false;
                }
            });
        };

        vm.save = function() {
            vm.saving = true;
            let promises = [];
        
            vm.setLaborRateDefault();

            if (vm.fixedRatesToDelete.length > 0) {
                promises.push(
                    Promise.all(vm.fixedRatesToDelete.map(rate =>
                        dealerInspectionService.deleteCustomLaborRate(dealerId, rate.id)
                            .catch(error => console.error('Error deleting fixed rate:', error))
                    )).then(() => {
                        vm.fixedRatesToDelete = [];
                    })
                );
            }
            
            if (vm.matrixRatesToDelete.length > 0) {
                promises.push(
                    Promise.all(vm.matrixRatesToDelete.map(rate =>
                        dealerInspectionService.deleteMatrixLaborRate(dealerId, rate.id)
                            .catch(error => console.error('Error deleting matrix rate:', error))
                    )).then(() => {
                        vm.matrixRatesToDelete = [];
                    })
                );
            }
                    
            vm.laborRateSettings.useFixedRate = vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.fixed;
            vm.laborRateSettings.useMatrixRate = !vm.laborRateSettings.useFixedRate;

            promises.push(
                dealerInspectionService.updateLaborRateSettings(dealerId, vm.laborRateSettings.id, vm.laborRateSettings)
                    .catch(error => console.error('Error updating labor rate settings:', error))
            );

            if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.fixed) {
                vm.fixedRates.forEach(rate => {
                    promises.push(
                        rate.id
                            ? dealerInspectionService.updateCustomLaborRate(dealerId, rate.id, rate)
                                .catch(error => console.error('Error updating fixed rate:', error))
                            : dealerInspectionService.addCustomLaborRate(dealerId, rate)
                                .then(response => { rate.id = response; })
                                .catch(error => console.error('Error creating fixed rate:', error))
                    );
                });
            } 
            
            if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.matrix) {
                vm.matrixRates.forEach(rate => {
                    let tempRate = angular.copy(rate);
                    const originalMatrixRateType = rate.matrixRateType;
        
                    tempRate.matrix = tempRate.rateMatrix;
        
                    if (originalMatrixRateType !== SYSTEM_ENUMS.matrixRateTypes.rate) {
                        tempRate.matrixRateType = SYSTEM_ENUMS.matrixRateTypes.rate;
                        vm.onMatrixRateTypeChange(tempRate);
                        tempRate.matrix = tempRate.rateMatrix;
                    }
        
                    promises.push(
                        tempRate.id
                            ? dealerInspectionService.updateMatrixLaborRate(dealerId, tempRate.id, tempRate)
                                .then(() => {
                                    if (originalMatrixRateType !== SYSTEM_ENUMS.matrixRateTypes.rate) {
                                        tempRate.matrixRateType = originalMatrixRateType;
                                        angular.copy(tempRate, rate);
                                    }
                                })
                                .catch(error => console.error('Error updating matrix rate:', error))
                            : dealerInspectionService.addMatrixLaborRate(dealerId, tempRate)
                                .then(response => {
                                    rate.id = response;

                                    if (originalMatrixRateType !== SYSTEM_ENUMS.matrixRateTypes.rate) {
                                        tempRate.id = response;
                                        tempRate.matrixRateType = originalMatrixRateType;
                                        angular.copy(tempRate, rate);
                                    }
                                })
                                .catch(error => console.error('Error creating matrix rate:', error))
                    );
                });
            }
            
            Promise.all(promises)
                .then(() => {
                    eventAlertService.createAlert('Labor Rate Settings Updated Successfully!');
                    initialFixedRates = angular.copy(vm.fixedRates);
                    initialMatrixRates = angular.copy(vm.matrixRates);
                    initialLaborRateSettings = angular.copy(vm.laborRateSettings);
                })
                .catch(error => console.error('Error in one of the operations:', error))
                .finally(() => {
                    vm.saving = false;
                });
        };
        
        vm.selectMatrixRate = function(index) {
            if (vm.currentMatrixRateIndex === index) {
                vm.currentMatrixRateIndex = null;
            } else {
                vm.currentMatrixRateIndex = index;
            }
        };

        vm.onReorder = (e, ui) => {
            if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.fixed) {
                vm.fixedRates.forEach((fixedRate, index) => {
                    fixedRate.order = index + 1; 
                });
            }
        
            if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.matrix) {
                vm.matrixRates.forEach((matrixRate, index) => {
                    matrixRate.order = index + 1; 
                });
            }
        };

        vm.checkForChanges = function() {
            function normalizeRates(rates) {
                return {
                    internalPayRate: parseFloat(rates.internalPayRate).toFixed(2),
                    warrantyPayRate: parseFloat(rates.warrantyPayRate).toFixed(2),
                    customerPayRate: parseFloat(rates.customerPayRate).toFixed(2)
                };
            }

            return !angular.equals(initialFixedRates, vm.fixedRates) ||
                   !angular.equals(initialMatrixRates, vm.matrixRates) ||
                   !angular.equals(normalizeRates(initialLaborRateSettings), normalizeRates(vm.laborRateSettings));
        };

        vm.validation = {
            valDecimal: function (value) {
                // required validation will trigger in this case
                if (!value || (value && value.toString().trim().length === 0)) {
                    return {isValid: true};
                }

                let decRegEx = new RegExp(/^\d+(\.\d{1,16})?$/);
                let isValid = decRegEx.test(value);

                return {isValid: isValid};
            }
        };

        $scope.$on(SYSTEM_ENUMS.eventNames.locationTabCanChange, (e, cb) => {
            const hasChanges = vm.checkForChanges();
            
            cb(hasChanges);
        });

        vm.setLaborRateDefault = function(selectedRate) {
            if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.fixed) {
                if (selectedRate !== undefined) {
                    vm.fixedRates.forEach(rate => {
                        if (rate !== selectedRate) {
                            rate.isDefault = false;
                        }
                    });
                }

                const defaultRate = vm.fixedRates.find(rate => rate.isDefault);
                
                if (!defaultRate && vm.fixedRates.length > 0) {
                    vm.fixedRates[0].isDefault = true;
                }
            } else if (vm.selectedCustomerRateType === SYSTEM_ENUMS.rateTypes.matrix) {
                if (selectedRate !== undefined) {
                    vm.matrixRates.forEach(rate => {
                        if (rate !== selectedRate) {
                            rate.isDefault = false;
                        }
                    });
                }

                const defaultRate = vm.matrixRates.find(rate => rate.isDefault);
                
                if (!defaultRate && vm.matrixRates.length > 0) {
                    vm.matrixRates[0].isDefault = true;
                }
            }
        };

        vm.importMatrixRates = function() {
            const modalInstance = $uibModal.open({
                templateUrl: 'app/areas/location/views/modals/import-matrix-laborrates-modal.view.html',
                controller: 'ImportMatrixLaborRatesModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'top-modal'
            });

            modalInstance.result.then((matrixData) => {
                if (matrixData && matrixData.matrix) {
                    if (vm.selectedCustomerRateType !== SYSTEM_ENUMS.rateTypes.matrix) {
                        vm.selectedCustomerRateType = SYSTEM_ENUMS.rateTypes.matrix;
                    }

                    const isPrice = matrixData.type === SYSTEM_ENUMS.rateTypes.matrix;
                    const {rateMatrix, priceMatrix} = initializeMatrixFromRate(matrixData.matrix, isPrice);
                    let newRate = {
                        name: matrixData.name,
                        rateMatrix: rateMatrix,
                        priceMatrix: priceMatrix,
                        originalMatrix: rateMatrix,
                        isDefault: false,
                        matrixRateType: matrixData.type,
                        order: Math.max(0, ...vm.matrixRates.map(r => r.order || 0)) + 1
                    };

                    if (isPrice) {
                        vm.onMatrixRateTypeChange(newRate);
                    }

                    vm.matrixRates.push(newRate);
                    let newIndex = vm.matrixRates.length - 1;

                    vm.setLaborRateDefault(vm.matrixRates[newIndex]);
                    vm.currentMatrixRateIndex = newIndex;

                    eventAlertService.createAlert('Matrix Labor Rate imported successfully!');
                }
            });
        };
        
        init();
    }
})();

(function () {
    'use strict';

    LocationTabInspectFormBuilderController.$inject = ["$scope", "modalService", "eventAlertService", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "dealerInspectionService", "permissions", "resolvedDealersWithInspect"];
    angular
        .module('redcap.location')
        .controller('LocationTabInspectFormBuilderController', LocationTabInspectFormBuilderController);

    function LocationTabInspectFormBuilderController($scope, modalService, eventAlertService, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, dealerInspectionService, permissions, resolvedDealersWithInspect) {
        const vm = this;
        const allFormEntry = {
            dealerId: -999,
            id: -999,
            name: 'All forms'
        };
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.dealerId = resolvedLocation.id;     
        vm.isLoading = true;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.dealersWithInspect = resolvedDealersWithInspect.filter((dealer) => { return dealer.id !== resolvedLocation.id; });
        
        function init() {
            getForms();

            $scope.$on('$locationChangeStart', ($event, next, current) => { 
                vm.closeCurrentForm();
            });
        }

        vm.addNewInspectionForm = function() {
            vm.isAddingNewForm = true;
        };

        vm.saveChanges = function() {
            vm.isSaving = true;

            dealerInspectionService.updateInspectionForms(vm.dealerId, vm.inspectionForms).then((result) => {
                eventAlertService.createAlert('Forms saved successfully!');
            }).finally(() => {
                vm.isSaving = false;
            });
        };

        vm.deleteForm = function(formId) {
            //Check whether the form is default or not
            let isDefaultForm = vm.inspectionForms.find((form) => form.id === formId).isDefault;

            if (isDefaultForm) {
                modalService.showError('You cannot delete the default form. Please set another form as default before deleting this form.', '', true);

                return;
            }

            modalService.showYesNo('Confirm Delete', 'Are you sure you want to delete this form?', 'No', 'Yes', false).then((result) => {
                if (result) {
                    vm.isLoading = true;
                    
                    dealerInspectionService.deleteForm(vm.dealerId, formId).then(() => {
                        eventAlertService.createAlert('Form was successfully deleted!');
                        getForms();
                    }).catch(() => {
                        eventAlertService.createAlert('An error occurred deleting the form');
                        vm.isLoading = false;
                    });
                }
            });
        };

        vm.onFormsReordered = function(e, ui) {
            vm.inspectionForms.forEach((form, index) => {
                form.displayOrder = index + 1; 
            
                // The first form in the list will always be the default    
                form.isDefault = index === 0;
            });
        };        

        vm.sortableSettings = {
            stop: vm.onFormsReordered,
            handle: '> .reorder-container'
        };

        vm.loadForm = function(formId) {
            vm.currentFormId = formId;
        };

        vm.closeCurrentForm = function() {
            vm.currentFormId = null;
            vm.isAddingNewForm = false;

            getForms();
        };

        function getForms() {
            vm.isLoading = true;

            dealerInspectionService.getInspectionForms(vm.dealerId).then((inspectionForms) => {
                vm.inspectionForms = inspectionForms.filter((form) => !form.isAdHoc);
                vm.formCount = vm.inspectionForms.length;
            }).finally(() => {
                vm.isLoading = false;
            });
        }

        vm.updateDefaultForm = function(formId) {
            vm.inspectionForms.forEach((form) => {
                if (form.id === formId) {
                    form.isDefault = true;
                    form.isEnabled = true;
                } else {
                    form.isDefault = false;
                }
            });
        };

        vm.copyFromDealerChanged = function () {
            vm.loadingCopyableForms = true;
            dealerInspectionService.getInspectionFormsToCopy(vm.copyFromDealer).then((result) => {
                result.unshift(allFormEntry);
                vm.copyableForms = result;
            }).finally(() => {
                vm.loadingCopyableForms = false;
            });
        };

        vm.copySelectedForms = function () {
            modalService.showYesNo('Please Confirm', 'Are you sure you wish to copy the selected form(s) to this dealer?', 'No', 'Yes', true).then((confirmed) => {
                if (confirmed) {
                    vm.copyingForms = true;

                    if (vm.formToCopy === -999) {
                        dealerInspectionService.copyAllInspectForms(vm.dealerId, vm.copyFromDealer).then((result) => {
                            vm.formToCopy = null;

                            if (result) {
                                eventAlertService.createAlert('Forms copied successfully!');
                            }
                        }).finally(() => {
                            vm.copyingForms = false;
                            getForms();
                        });
                    } else {
                        dealerInspectionService.copyInspectForm(vm.dealerId, vm.copyFromDealer, vm.formToCopy).then((result) => {
                            vm.formToCopy = null;

                            if (result) {
                                eventAlertService.createAlert('Form copied successfully!');
                            }
                        }).finally(() => {
                            vm.copyingForms = false;
                            getForms();
                        });
                    }
                }
            });
        };

        init();
    }
})();

(function () {
    'use strict';

    LocationCheckinGeneralController.$inject = ["$transition$", "dealerHasCheckin", "resolvedLocation", "resolvedDealerTripTypes", "locationService", "$state", "resolvedMediaConfigItems", "eventAlertService"];
    angular
        .module('redcap.location')
        .controller('LocationCheckinGeneralController', LocationCheckinGeneralController);

    function LocationCheckinGeneralController($transition$, dealerHasCheckin, resolvedLocation, resolvedDealerTripTypes, locationService, $state, resolvedMediaConfigItems, eventAlertService) {

        let vm = this;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.locationId = $transition$.params().locationId;
        vm.loaded = true;
        vm.lastIndex = -1;
        vm.saving = false;

        vm.mediaconfigItems = resolvedMediaConfigItems.length === 0 ? [{id: 0, categoryDesc: ""}] : resolvedMediaConfigItems;

        vm.onRemove = function (lineItem) {
            if (vm.mediaconfigItems.length === 1)
                vm.mediaconfigItems = [{id: 0, categoryDesc: ""}];
            else
                vm.mediaconfigItems = vm.mediaconfigItems.filter(x => x.id !== lineItem.id);
        };

        vm.onAdd = function (lineItem) {
            lineItem.id = lineItem.id <= 0 ? --vm.lastIndex : lineItem.id;
            vm.mediaconfigItems = [...vm.mediaconfigItems, {id: 0, categoryDesc: ""}];
        };

        vm.saveMediaConfig = function (valid) {
            //if (!valid) { return $q.when(); }
            vm.isSaving = true;
            vm.mediaconfigItems.forEach(element => {
                element.detailDescs = _.map(element.detailDescs, (item) => { return item.text; });
            });

            locationService.saveUpdatePredifinedMediaConfigs(vm.locationId, vm.mediaconfigItems).then(result => {
                eventAlertService.createAlert('Predefined Walkaround Photos Successfully Updated.');
                vm.mediaconfigItems = result.length === 0 ? [{id: 0, categoryDesc: ""}] : result;
                vm.isSaving = false;
            });
        };

        vm.close = function () {
            $state.go('location-list');
        };

        vm.isEmptyForm = function () {
            let isEmpty = vm.mediaconfigItems.length === 1 && vm.mediaconfigItems[0].mediaType === undefined
                && (vm.mediaconfigItems[0].categoryDesc === undefined || vm.mediaconfigItems[0].categoryDesc === '')
                && (vm.mediaconfigItems[0].order === undefined || vm.mediaconfigItems[0].order === '')
                && (vm.mediaconfigItems[0].detailDescs === undefined);

            return isEmpty;
        };

    }
})();

(function () {
    'use strict';

    LocationAppointmentCapacityController.$inject = ["$transition$", "$scope", "$timeout", "$q", "$filter", "$location", "$state", "resolvedLocation", "APPOINTMENT_TRANSPORTATION_TYPE", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", "modalService", "permissions", "dealerHasCheckin", "SYSTEM_ENUMS", "appointmentUtilService", "constraintService", "locationService", "localStorageService", "resolvedLocationAppointmentConstraints", "resolvedLocationTransportationTypes", "resolvedLocationBufferConstraints", "resolvedTripTypeInstances", "resolvedDepartments", "resolvedLocationTransportationConstraints", "ValidationService", "tripTypeService", "eventAlertService"];
    angular
        .module('redcap.location')
        .controller('LocationAppointmentCapacityController', LocationAppointmentCapacityController);

    function LocationAppointmentCapacityController($transition$, $scope, $timeout, $q, $filter, $location, $state, resolvedLocation,
        APPOINTMENT_TRANSPORTATION_TYPE, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE, modalService, permissions, dealerHasCheckin,
        SYSTEM_ENUMS, appointmentUtilService, constraintService, locationService, localStorageService,
            resolvedLocationAppointmentConstraints, resolvedLocationTransportationTypes, resolvedLocationBufferConstraints, resolvedTripTypeInstances,
            resolvedDepartments, resolvedLocationTransportationConstraints, 
            ValidationService, tripTypeService, eventAlertService) {

        let vm = this;
        let params = localStorageService.get('lastManageCapacityParams');
        let revalidate = 'angularValidation.revalidate';
        let apptConstraintValid = 'appt-constraints-valid-';
        let constraintsValid = 'constraints-valid-';
        let referrer;
        let transitionParams = $transition$.params();
        let myValidation = new ValidationService({
            validateOnEmpty: true
        });
        let openedAppointmentItem = {
            departmentIds: []
        };
        let openedTransportationIds = [];
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.currentLocation = resolvedLocation;
        vm.loaded = true;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.isAdminUser = permissions.isAdminLevelUser();
        
        if (transitionParams.referrer) {
            localStorageService.set('lastManageCapacityReferrer', transitionParams.referrer);
            referrer = transitionParams.referrer;
        } else {
            referrer = localStorageService.get('lastManageCapacityReferrer');
        }

        vm.selectedLocation = null;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
        vm.appointmentConstraints = resolvedLocationAppointmentConstraints;
        vm.bufferConstraints = resolvedLocationBufferConstraints;
        vm.tripTypes = resolvedTripTypeInstances;
        vm.transportationTypes = resolvedLocationTransportationTypes;
        vm.dealerDepartments = resolvedDepartments;
        vm.constraints = resolvedLocationTransportationConstraints;
        vm.constraintDefinitionType = APPOINTMENT_CONSTRAINT_DEFINITION_TYPE;
        vm.tripTypeId = transitionParams.tripTypeId;
        vm.locationId = transitionParams.locationId;
        vm.loadingAppointmentConstraints = false;
        vm.loadingDepartments = false;
        vm.loadingTransportationTypes = false;
        vm.loadingConfigs = false;
        vm.loadingTransportationContstraints = false;
        vm.departmentTransportationTypes = [];

        let bufferedTransportationTypes = [
            APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner,
            APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage
        ];

        if (!vm.locationId) {
            vm.loadingLocations = true;
            locationService.getLocationsForDropDown(true, false, SYSTEM_ENUMS.permissionTypes.appointments, [SYSTEM_ENUMS.systemTripType.appointment]).then((result) => {
                vm.resolvedLocationList = result;
                vm.loadingLocations = false;
            });
        }

        vm.close = function () {
            let path = $location.path();

            if (path.indexOf('/locations') > -1) {
                $state.go('location-list');
            } else {
                $state.go(referrer, params, {reload: false});
            }
        };

        vm.isLoadingData = function () {
            return vm.loadingAppointmentConstraints ||
                vm.loadingDepartments  ||
                vm.loadingTransportationTypes  ||
                vm.loadingConfigs  ||
                vm.loadingTransportationContstraints;
        };

        vm.loadTransportationConstraints = function () {
            vm.loadingTransportationContstraints = true;
            constraintService.getConstraintsByType(vm.locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.transportation).then((result) => {
                vm.constraints = result;
                vm.loadingTransportationContstraints = false;
                populateTransportationList();
            });
        };

        vm.loadAppointmentConstraints = function () {
            vm.loadingAppointmentConstraints = true;
            constraintService.getConstraintsByType(vm.locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointment).then((result) => {
                vm.appointmentConstraints = result;
                vm.loadTransportationConstraints();
                vm.loadingAppointmentConstraints = false;
            });
        };

        vm.loadDepartments = function () {
            vm.loadingDepartments = true;
            locationService.getLocationDepartments(vm.locationId, true)
                .then((result) => {
                    vm.dealerDepartments = result;
                    vm.loadAppointmentConstraints();
                    vm.loadingDepartments = false;
                });
        };

        vm.loadTransportationTypes = function () {
            vm.loadingTransportationTypes = true;
            locationService.getLocationTransportationTypes(vm.locationId).then((result) => {
                vm.transportationTypes = result;
                vm.loadDepartments();
                vm.loadingTransportationTypes = false;
            });
        };

        vm.getPickupTripType = function () {
            vm.loadingConfigs = true;
            locationService.getLocationTripTypeInstances(vm.locationId).then((tripTypes) => {
                // get associated trip types to location
                if (tripTypes) {
                    vm.tripTypes = tripTypes;
                    let pickup = $filter('filter')(tripTypes, {systemTripTypeId: vm.systemTripTypes.pickup, status: 1}, true);

                    if (pickup && pickup.length > 0) {
                        vm.hasPickupInstance = true;
                    } else {
                        vm.hasPickupInstance = false;
                    }

                    refreshLocationTransportationTypesAndConstraints();
                    vm.loadingConfigs = false;
                }
            });
        };

        vm.loadAppointmentConfigs = function () {
            vm.loadingConfigs = true;
            locationService.getLocationTripTypeInstances(vm.locationId).then((tripTypes) => {
                // get associated trip types to location
                if (tripTypes) {
                    vm.tripTypes = tripTypes;
                    let appt = $filter('filter')(tripTypes, {systemTripTypeId: vm.systemTripTypes.appointment}, true);
                    let pickup = $filter('filter')(tripTypes, {systemTripTypeId: vm.systemTripTypes.pickup, status: 1}, true);
                    let apptTripType;

                    if (appt && appt.length > 0) {
                        apptTripType = appt[0];
                        tripTypeService.getTripTypeBookingTab(vm.locationId, apptTripType.id).then((result) => {
                            vm.currentTripType = result;
                            vm.specificConfigs = vm.currentTripType.tripTypeSpecificConfigs;
                            vm.loadTransportationTypes();
                            vm.loadingConfigs = false;
                        });
                    }
                    
                    if (pickup && pickup.length > 0) {
                        vm.hasPickupInstance = true;
                    } else {
                        vm.hasPickupInstance = false;
                    }

                    refreshLocationTransportationTypesAndConstraints();
                }
            });
        };

        if (vm.locationId) {
            vm.getPickupTripType();
        }

        vm.changeLocation = function () {
            if (vm.selectedLocation) {
                vm.locationId = vm.selectedLocation.id;
                vm.loadAppointmentConfigs();
            } else {
                vm.locationId = null;
            }

            vm.updatingLocation = false;
        };

        vm.selectedLocationChanged = function () {

            vm.updatingLocation = true;

            if (!vm.locationId) {
                vm.changeLocation();
            }
            

            $scope.inputForm.$invalid = !myValidation.checkFormValidity($scope.inputForm);
            $scope.inputForm.$valid = !$scope.inputForm.$invalid;

            if ($scope.inputForm.$valid) {
                $timeout(() => {
                    vm.autoSave(true);
                }, 25);
            } else {
                vm.selectedLocation = $filter('filter')(vm.resolvedLocationList, {id: vm.locationId}, true)[0];
            }
            
            
        };

        vm.addNewAppointmentConstraint = function (departmentId) {
            if (vm.saving) return;
            vm.appointmentConstraints.push({
                departmentId: departmentId || null,
                isDeleted: false,
                isNew: true,
                uid: appointmentUtilService.generateUID(departmentId)
            });
        };

        vm.addNewTransportationConstraint = function (transportationType, departmentId) {
            let isPickup = null;
            let hasLoaner = null;
            let dealerSysTransId = transportationType.dealerSystemTransportationTypeId;

            // The below 4 lines of code is how we're making "Pickup" actually be pickup with and w/out loaner
            // and "Loaner" be for pickup and drop off
            // because it's only setting the pickup flag for PICKUP NO LOANER
            // it's only setting the loaner flag for PICKUP WITH LOANER
            // this is a bit of a hack since it's keyed off of transportation ids,
            if (dealerSysTransId === APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner) {
                isPickup = transportationType.isPickup;
            } else if (dealerSysTransId === APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner) {
                hasLoaner = transportationType.hasLoaner;
            }

            transportationType.constraints.push({
                constraintDataParsed: {
                    TransportationTypeId: dealerSysTransId,
                    IsPickup: isPickup,
                    HasLoaner: hasLoaner,
                    UserLimitType: null
                },
                departmentId: departmentId || null,
                isDeleted: false,
                isNew: true,
                uid: appointmentUtilService.generateUID(transportationType.id)
            });
        };

        vm.addAppointmentConstraint = function (constraint, uid) {
            let index = vm.appointmentConstraints.findIndex(o => o.uid === uid);

            constraint.dealerId = vm.locationId;
            angular.extend(vm.appointmentConstraints[index], constraint);
            $scope.$broadcast(revalidate, apptConstraintValid + constraint.departmentId);
            // After we've revalidated any fields, use a $timeout to give the validation plugin time to validate all constraints
            // and recall checkFormValidity to update the UI error message fields
            $timeout(() => {
                vm.revalidateForm();
                vm.autoSave();
            }, 25);
        };

        vm.addTransportationConstraint = function (constraint, transportationType, uid) {
            let index = transportationType.constraints.findIndex(o => o.uid === uid);
            
            constraint.dealerId = vm.locationId;
            angular.extend(transportationType.constraints[index], constraint);
            $scope.$broadcast(revalidate, constraintsValid + transportationType.uid + '-' + constraint.departmentId);
            // After we've revalidated any fields, use a $timeout to give the validation plugin time to validate all constraints
            // and recall checkFormValidity to update the UI error message fields
            $timeout(() => {
                vm.revalidateForm();
                vm.autoSave();
            }, 25);
        };

        vm.removeAppointmentConstraint = function (constraint) {
            let index = vm.appointmentConstraints.findIndex(o => o.uid === constraint.uid);

            constraint.isDeleted = true;

            if (!vm.appointmentConstraints[index].id) {
                // We never saved this item, so we can completely remove it
                vm.appointmentConstraints.splice(index, 1);
            }

            // Ensure we always have at least one empty constraint for the department
            if (vm.appointmentConstraints.findIndex(o => !o.isDeleted && o.departmentId === constraint.departmentId) === -1) {
                vm.addNewAppointmentConstraint(constraint.departmentId);
            }

            $scope.$broadcast(revalidate, apptConstraintValid + constraint.departmentId);
            // After we've revalidated any fields, use a $timeout to give the validation plugin time to validate all constraints
            // and recall checkFormValidity to update the UI error message fields
            $timeout(() => {
                vm.revalidateForm();
            }, 25);
        };

        vm.removeTransportationConstraint = function (constraint, transportationType) {
            let index = transportationType.constraints.findIndex(o => o.uid === constraint.uid);

            constraint.isDeleted = true;

            if (!transportationType.constraints[index].id) {
                // We never saved this item, so we can completely remove it
                transportationType.constraints.splice(index, 1);
            }

            // Ensure we always have at least one empty constraint for the department
            if (transportationType.constraints.findIndex(o => !o.isDeleted && o.departmentId === constraint.departmentId) === -1) {
                vm.addNewTransportationConstraint(transportationType, constraint.departmentId);
            }

            $scope.$broadcast(revalidate, constraintsValid + transportationType.uid + '-' + constraint.departmentId);
            // After we've revalidated any fields, use a $timeout to give the validation plugin time to validate all constraints
            // and recall checkFormValidity to update the UI error message fields
            $timeout(() => {
                vm.revalidateForm();
            }, 25);
        };

        vm.appointmentConstraintChange = function (elementsToRevalidate, departmentId) {
            // We've gotten an input changed event, revalidate the form
            let i = 0;
            let arrLen = elementsToRevalidate.length;

            for (i = 0; i < arrLen; i++) {
                $scope.$broadcast(revalidate, elementsToRevalidate[i]);
            }

            $scope.$broadcast(revalidate, apptConstraintValid + departmentId);
            $timeout(() => {
                vm.revalidateForm();
            }, 25);
        };

        vm.constraintChange = function (elementsToRevalidate, transportationTypeUid, departmentId) {
            // We've gotten an input changed event, revalidate the form
            let i = 0;
            let arrLen = elementsToRevalidate.length;

            for (i = 0; i < arrLen; i++) {
                $scope.$broadcast(revalidate, elementsToRevalidate[i]);
            }

            $scope.$broadcast(revalidate, constraintsValid + transportationTypeUid + '-' + departmentId);
            $timeout(() => {
                vm.revalidateForm();
            }, 25);
        };

        vm.validation = {
            valConstraints: constraintService.validateLimitPerHourPerDayConstraints,
            // the ValidationService plugin cannot handle object literal notation in parameters of the inline custom validation function in the HTML
            filterPredicate: function (departmentId) {
                return {
                    departmentId: departmentId
                };
            }
        };

        vm.revalidateForm = function () {
            if (!vm.locationId) {
                return;
            }

            $timeout(() => {
                $scope.inputForm.$invalid = !myValidation.checkFormValidity($scope.inputForm);
                $scope.inputForm.$valid = !$scope.inputForm.$invalid;
            });
        };

        vm.autoSaveInProgress = false;
        vm.autoSaveTimeout = null;

        vm.autoSave = function (calledFromUpdateLocation, bookBtnClicked) {
            // Debouncing autosaves as they are triggered after several ng-changes
            // creating an unnecessary overhead while editing checkboxes
            let debounceInMilliseconds = bookBtnClicked ? 1 : 5000;

            if (vm.autoSaveTimeout && !vm.autoSaveInProgress) {
                // Cancel the previous autoSaveTimeout if it has not begun
                $timeout.cancel(vm.autoSaveTimeout);
                vm.autoSaveTimeout = null;
            }

            if (!vm.autoSaveTimeout) {
                vm.autoSaveTimeout = $timeout(() => {
                    vm.autoSaveInProgress = true;

                    // Give adequate time to process whether or not the form is valid, then autosave
                    return vm.updateBooking($scope.inputForm.$valid, true)
                        .then(() => {
                            // Clear state
                            vm.autoSaveInProgress = false;
                            vm.autoSaveTimeout = null;

                            if (calledFromUpdateLocation) {
                                vm.changeLocation();
                            }
                        }).catch(() => {
                            vm.autoSaveInProgress = false;
                            vm.autoSaveTimeout = null;
                        });
                }, debounceInMilliseconds);
            }
        };

        vm.updateBtnClicked = function (valid) {
            if (!valid) { return $q.when(); }

            vm.autoSave(false, true);
        };

        vm.bufferConstraintChanged = function(constraintDataParsed, transportationType = null) {
            if (vm.saving) return;
            let bufferHours = constraintDataParsed.BufferHours;
            let pattern = /^\d*\.?\d{0,2}$/;
        
            // Check if input matches the pattern, otherwise remove unwanted characters
            if (!pattern.test(bufferHours)) {
                let match = bufferHours.match(/\d*\.?\d{2,}?/g);

                constraintDataParsed.BufferHours = match ? match[0] : '';

                return;
            }

            let settingsData = {
                TransportationTypeId: transportationType?.dealerSystemTransportationTypeId,
                BufferHours: bufferHours ? bufferHours : 0,
                HasLoaner: transportationType?.hasLoaner,
            };

            // Check if constraint already exists
            let existingConstraint = vm.bufferConstraints.find(constraint => 
                constraint.constraintDataParsed.TransportationTypeId === settingsData.TransportationTypeId &&
                constraint.departmentId === vm.selectedDepartmentId
            );
        
            // If no exact match, check for TransportationTypeId equal to 0 ie. all appointments
            if (!existingConstraint) {
                existingConstraint = vm.bufferConstraints.find(constraint => 
                    constraint.constraintDataParsed.TransportationTypeId === 0 &&
                    constraint.departmentId === vm.selectedDepartmentId
                );
            }

            if (existingConstraint) {
                // Update the existing constraint
                existingConstraint.constraintData = JSON.stringify(settingsData);
                existingConstraint.constraintDataParsed = settingsData;
            } else {
                // Push the new constraint
                let today = new Date();

                vm.bufferConstraints.push({
                    id: 0,
                    startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
                    constraintData: JSON.stringify(settingsData),
                    constraintDataParsed: settingsData,
                    departmentId: vm.selectedDepartmentId || null,
                    dealerId: vm.locationId,
                    dealerConstraintDefinitionId: APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointmentBuffer,
                    isDeleted: false,
                    isNew: false,
                    uid: appointmentUtilService.generateUID(vm.selectedDepartmentId)
                });
            }

            vm.revalidateForm();
            vm.autoSave();
        };

        vm.hasBufferConstraint = function (transportationType) {
            return bufferedTransportationTypes.includes(transportationType.dealerSystemTransportationTypeId);
        };

        vm.updateBooking = function (valid) {
            let constraintsToSave = [];
            let exists;
            let deptApptConstraints = vm.appointmentConstraints.filter((constr) => constr.departmentId === vm.selectedDepartmentId);

            vm.saving = true;

            deptApptConstraints.forEach((constraint) => {
                if (constraint.isNew || typeof constraint.id === 'undefined' || !constraint.departmentId) {
                    return;
                }

                if (!constraint.isDeleted && vm.validation.valConstraints(vm.appointmentConstraints, vm.validation.filterPredicate(constraint.departmentId)) === false) {
                    vm.autoSaveInProgress = false;
                    vm.saving = false;

                    return;
                }

                constraint.advisorId = null;
                exists = constraintsToSave.findIndex(o => o.uid === constraint.uid);

                if (exists  === -1) {
                    constraintsToSave.push(constraint);
                }
            });

            let deptBufferConstraints = vm.bufferConstraints.filter((constr) => constr.departmentId === vm.selectedDepartmentId);

            deptBufferConstraints.forEach((constraint) => {
                if (constraint.isNew || typeof constraint.id === 'undefined' || !constraint.departmentId) {
                    return;
                }

                constraint.advisorId = null;
                exists = constraintsToSave.findIndex(o => o.uid === constraint.uid);

                if (exists  === -1) {
                    constraintsToSave.push(constraint);
                }
            });
            
            vm.transportationTypes.forEach((item) => {
                let deptConstraints = item.constraints.filter((constr) => constr.departmentId ===  vm.selectedDepartmentId);

                if (deptConstraints && item.constraints.length > 0 && item.dealerDepartmentId) {
                    item.constraints.forEach((constraint) => {
                        if (constraint.isNew || typeof constraint.id === 'undefined') {
                            return;
                        }
                    
                        constraint.advisorId = null;

                        if (vm.validation.valConstraints(item.constraints, vm.validation.filterPredicate(constraint.departmentId)) === false) {
                            vm.autoSaveInProgress = false;
                            vm.saving = false;

                            return;
                        }
                        
                        exists = constraintsToSave.findIndex(o => o.uid === constraint.uid);

                        if (exists === -1) {
                            constraintsToSave.push(constraint);
                        }
                    });
                }
            });

            if (vm.autoSaveInProgress === false) {
                return;
            }

            return locationService.updateLocationTransportationTypes(vm.locationId, vm.transportationTypes)
                .then(() => {
                    let savePromise = $q.when();

                    if (constraintsToSave.length > 0) {
                        savePromise = constraintService.saveConstraints(vm.locationId, constraintsToSave);
                    }

                    return savePromise.then(() => {
                        vm.saving = false;
                        // Refresh the transportation type list
                        eventAlertService.createAlert('Constraints data successfully updated.');

                        return refreshLocationTransportationTypesAndConstraints();
                    });
                });
                
        };

        vm.appointmentDepartmentClicked = function (dept) {
            if (openedAppointmentItem.departmentIds.includes(dept.id)) {
                let index = openedAppointmentItem.departmentIds.indexOf(dept.id);

                if (index > -1) {
                    openedAppointmentItem.departmentIds.splice(index, 1);
                }
            } else {
                openedAppointmentItem.departmentIds.push(dept.id);
            }
        };

        vm.isAppointmentItemOpen = function (dept) {
            return openedAppointmentItem.departmentIds.includes(dept.id);
        };

        vm.transportationDepartmentClicked = function (transType, dept) {
            let transportationId = transType.id;
            let clickedTransportation = openedTransportationIds.find(o => o.id === transportationId);

            if (clickedTransportation) {
                if (clickedTransportation.departmentIds.includes(dept.id)) {
                    let index = clickedTransportation.departmentIds.indexOf(dept.id);

                    if (index > -1) {
                        clickedTransportation.departmentIds.splice(index, 1);
                    }
                }  else {
                    clickedTransportation.departmentIds.push(dept.id);
                }
            } else {
                let departmentIds = [];

                departmentIds.push(dept.id);
                openedTransportationIds.push({
                    id: transportationId,
                    departmentIds: departmentIds
                });
            }
            
        };

        vm.departmentSelected = function () {
            openedTransportationIds = [];
            openedAppointmentItem = {
                departmentIds: []
            };

            vm.selectedDepartment = $filter('filter')(vm.dealerDepartments, {id: vm.selectedDepartmentId}, true)[0];

            $timeout(() => {
                // this page used to work different, and these functions were here already.. easier to just use them
                let bufferConstraint = $filter('filter')(vm.bufferConstraints, value => {
                    return (value.constraintDataParsed.TransportationTypeId === null || 
                            value.constraintDataParsed.TransportationTypeId === 0) &&
                            value.departmentId === vm.selectedDepartmentId;
                });

                if (bufferConstraint && bufferConstraint.length > 0) {
                    vm.allApptsBuffer = bufferConstraint[0];
                } else {
                    vm.allApptsBuffer = {
                        constraintDataParsed: {
                            BufferHours: ''
                        }
                    };
                }

                vm.departmentTransportationTypes = $filter('filter')(vm.transportationTypes, {dealerDepartmentId: vm.selectedDepartmentId}, true);

                vm.departmentTransportationTypes.forEach((transportationType) => {
                    if (vm.hasBufferConstraint(transportationType) && transportationType.constraints.buffer) {
                        transportationType.deptConstraintData = $filter('filter')(transportationType.constraints.buffer, {departmentId: vm.selectedDepartmentId}, true)[0].constraintDataParsed;
                    }
                });

                vm.appointmentDepartmentClicked(vm.selectedDepartment);
                vm.departmentTransportationTypes.forEach((transportationType) => {
                    vm.transportationDepartmentClicked(transportationType, vm.selectedDepartment);
                });
            }, 1);
        };

        vm.isTransportationItemOpen = function (transType, dept) {
            let transportationId = transType.id;
            let clickedTransportation = openedTransportationIds.find(o => o.id === transportationId);

            if (clickedTransportation) {
                return clickedTransportation.departmentIds.includes(dept.id);
            } else {
                return false;
            }
        };

        vm.isPickupLoaner = function (transType) {
            return transType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner;
        };

        function refreshLocationTransportationTypesAndConstraints() {
            let locationId = vm.locationId;
            let appointmentConstraintPromise; let transportationConstraintPromise; let bufferConstraintPromise;

                appointmentConstraintPromise = constraintService.getConstraintsByType(locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointment)
                    .then((response) => {
                        vm.appointmentConstraints = response;
                    }),
                transportationConstraintPromise = constraintService.getConstraintsByType(locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.transportation)
                    .then((response) => {
                        vm.constraints = response;
                    });
                bufferConstraintPromise = constraintService.getConstraintsByType(locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointmentBuffer)
                    .then((response) => {
                        vm.bufferConstraints = response;
                    });

            return $q.all([appointmentConstraintPromise, transportationConstraintPromise, bufferConstraintPromise]).then(() => {
                populateTransportationList();

                return;
            });
            
        }

        function populateTransportationList(openedTransportationIds, openedAppointmentItem) {
            vm.appointmentConstraints.forEach((constraint) => {
                constraint.isNew = false;
            });

            vm.bufferConstraints.forEach((constraint) => {
                constraint.isNew = false;
            });

            // Default each department to have a blank appointment constraint if empty, for UI purposes
            vm.dealerDepartments.forEach((dept) => {
                dept.appointmentConstraintsAreValid = false;
                dept.constraintsAreValid = false;

                if (openedAppointmentItem) {
                    if (openedAppointmentItem.departmentIds.includes(dept.id)) {
                        dept.groupClicked = true;
                    }
                }

                if ($filter('filter')(vm.appointmentConstraints, {departmentId: dept.id}, true).length === 0) {
                    vm.addNewAppointmentConstraint(dept.id);
                }
            });

            vm.transportationTypes.forEach((item) => {
                // View Model specific fields needed for the new UI design
                item.name = 'N/A';
                item.orderInUI = -1;
                item.hideConsumerToggle = false;
                item.hideDashboardToggle = false;
                item.hideCapacitySettings = false;

                switch (item.dealerSystemTransportationTypeId) {
                    case APPOINTMENT_TRANSPORTATION_TYPE.waiter:
                        item.name = 'Waiter';
                        item.orderInUI = 6;
                        item.isDisabled = false;
                        break;
                    case APPOINTMENT_TRANSPORTATION_TYPE.shuttle:
                        item.name = 'Shuttle On Demand';
                        item.orderInUI = 5;
                        item.isDisabled = false;
                        break;
                    case APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner:
                        // NOTE: the capacity engine ignores the transportation trip type id
                        // for this item and treats is as capacity for loaner for pickups and drop offs
                        item.isDisabled = false;
                        item.name = 'Loaner';
                        item.orderInUI = 4;
                        break;
                    case APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner:
                        // NOTE: the capacity engine ignores the transportation trip type id
                        // for this item and treats is as capacity for pickups with and w/out loaner
                        item.name = 'Service Valet Pick Up';
                        item.orderInUI = 2;

                        if (vm.hasPickupInstance === false) {
                            item.isDisabled = true;
                            item.showInConsumer = false;
                            item.showInDashboard = false;
                        }
 
                        break;
                    case APPOINTMENT_TRANSPORTATION_TYPE.rideshareCredits:
                        item.name = 'Loaner On Demand (Rideshare Credits)';
                        item.orderInUI = 6;
                        item.isDisabled = false;
                        break;
                    case APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage:
                        item.name = 'Mobile Service';
                        item.isDisabled = false;
                        item.orderInUI = 3;
                        break;
                    case APPOINTMENT_TRANSPORTATION_TYPE.dropOff:
                        // NOTE: we are cheating a bit here, and will use this to determine 
                        // if the entire drop off section should be displayed for the department
                        // if show In Dash is toggled off then SOD and Waiter will also get turned off
                        // ditto for consumer
                        item.isDisabled = false;
                        item.name = 'Customer Drop Off';
                        item.orderInUI = 1;
                        item.hideCapacitySettings = true;
                        break;
                }

                item.uid = appointmentUtilService.generateUID(item.id, item.id);
                item.locationDepartments = angular.copy(vm.dealerDepartments);

                if (openedTransportationIds) {
                    let openedTransportation = openedTransportationIds.find(o => o.id === item.id);

                    if (openedTransportation) {
                        item.locationDepartments.forEach((dept) => {
                            if (openedTransportation.departmentIds.includes(dept.id)) {
                                dept.groupClicked = true;
                            }
                        });
                    }
                }

                item.constraints = $filter('filter')(vm.constraints, (value) => {
                    return value.constraintDataParsed.TransportationTypeId === item.dealerSystemTransportationTypeId;
                });

                item.constraints.forEach((c) => {
                    c.isNew = false;
                });
                
                if (vm.hasBufferConstraint(item)) {
                    if (!item.constraints.buffer) {
                        item.constraints.buffer = [];
                    }
                    
                    let bufferConstraints = $filter('filter')(vm.bufferConstraints, value => value.constraintDataParsed.TransportationTypeId === item.dealerSystemTransportationTypeId);

                    if (bufferConstraints && bufferConstraints.length > 0) {
                        item.constraints.buffer.push(...bufferConstraints);
                    }
                }

                // Default each transportation type to have a blank constraint if empty, for UI purposes
                item.locationDepartments.forEach((dept) => {
                    dept.constraintsAreValid = false;

                    if ($filter('filter')(item.constraints, {departmentId: dept.id}, true).length === 0) {
                        vm.addNewTransportationConstraint(item, dept.id);
                    }

                    if (vm.hasBufferConstraint(item)) {
                        if ($filter('filter')(item.constraints.buffer, {departmentId: dept.id}, true).length === 0) {
                            item.constraints.buffer.push({
                                    constraintDataParsed: {
                                        BufferHours: ''
                                    },
                                    departmentId: dept.id
                                });
                        }
                    }
                });

            });
        }

        populateTransportationList();

        function checkDisableLoaner () {
            let dropOffs = $filter('filter')(vm.departmentTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.dropOff}, true);
            let pickups = $filter('filter')(vm.departmentTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner}, true);
            let loaners = $filter('filter')(vm.departmentTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner}, true);
            let disableLoanerConsumer = true;
            let disableLoanerDashboard = true;
             
            if (dropOffs && dropOffs.length > 0 && dropOffs[0].showInConsumer === true) {
                disableLoanerConsumer = false;
            }

            if (pickups && pickups.length > 0 && pickups[0].showInConsumer === true) {
                disableLoanerConsumer = false;
            }

            if (dropOffs && dropOffs.length > 0 && dropOffs[0].showInDashboard === true) {
                disableLoanerDashboard = false;
            }

            if (pickups && pickups.length > 0 && pickups[0].showInDashboard === true) {
                disableLoanerDashboard = false;
            }

            if (loaners && loaners.length > 0) {
                if (disableLoanerConsumer === true) {
                    loaners[0].showInConsumer = false;
                } 

                if (disableLoanerDashboard === true) {
                    loaners[0].showInDashboard = false;
                } 
            }
            
        }

        function disableDropOffTypes(disableConsumer, disableDashboard) {
            let shuttleTypes = $filter('filter')(vm.departmentTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.shuttle}, true);
            let waitTypes = $filter('filter')(vm.departmentTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.waiter}, true);
            let creditTypes = $filter('filter')(vm.departmentTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.rideshareCredits}, true);

            if (shuttleTypes && shuttleTypes.length > 0) {
                if (disableConsumer === true) {
                    shuttleTypes[0].showInConsumer = false;
                } else {
                    shuttleTypes[0].showInDashboard = false;
                }
            }

            if (waitTypes && waitTypes.length > 0) {
                if (disableConsumer === true) {
                    waitTypes[0].showInConsumer = false;
                } else if (disableDashboard === true) {
                    waitTypes[0].showInDashboard = false;
                }
            }

            if (creditTypes && creditTypes.length > 0 && disableConsumer === true) {
                creditTypes[0].showInConsumer = false;
            }


        }

        vm.isSelfServe = function () {
            return vm.resolvedLocationList;
        };

        vm.hasEnabledTransportationType = function (checkConsumer, checkDashboard) {
            // get the departmentTransportation types for this department
            let allTypes = vm.departmentTransportationTypes;
            let id = vm.selectedDepartment.id;
            let hasTransportationTypeEnabled = false;
            let pickup = $filter('filter')(allTypes, {dealerDepartmentId: id, dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner}, true);
            let dropoff = $filter('filter')(allTypes, {dealerDepartmentId: id, dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.dropOff}, true);
            let mobile = $filter('filter')(allTypes, {dealerDepartmentId: id, dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage}, true);
            
                if (pickup && pickup.length > 0) {
                    vm.selectedDepartment.hasPickup = true;

                    if (checkConsumer && pickup[0].showInConsumer === true) {
                        hasTransportationTypeEnabled = true;
                    }

                    if (checkDashboard && pickup[0].showInDashboard === true) {
                        hasTransportationTypeEnabled = true;
                    }
                }

                if (dropoff && dropoff.length > 0) {
                    vm.selectedDepartment.hasDropoff = true;

                    if (checkConsumer && dropoff[0].showInConsumer === true) {
                        hasTransportationTypeEnabled = true;
                    }

                    if (checkDashboard && dropoff[0].showInDashboard === true) {
                        hasTransportationTypeEnabled = true;
                    }
                }

                if (mobile && mobile.length > 0) {
                    vm.selectedDepartment.hasMobile = true;

                    if (checkConsumer && mobile[0].showInConsumer === true) {
                        hasTransportationTypeEnabled = true;
                    }

                    if (checkDashboard && mobile[0].showInDashboard === true) {
                        hasTransportationTypeEnabled = true;
                    }
                }

                return hasTransportationTypeEnabled;
        };

        vm.getErrorMessage = function() {
            let message = "You must have at least one of the following enabled for each dashboard and consumer: ";

            if (vm.selectedDepartment.hasDropoff) {
                message += "Customer Drop Off";
            }

            if (vm.selectedDepartment.hasPickup) {
                if (vm.selectedDepartment.hasDropoff) {
                    message += ", ";
                }

                message += "Service Valet Pick Up";
            }

            if (vm.selectedDepartment.hasMobile) {
                if (vm.selectedDepartment.hasDropoff || vm.selectedDepartment.hasPickup) {
                    message += ", ";
                }

                message += "Mobile Service";
            }

            message += ".";

            return message;
        };

        vm.dashboardHeaderSwitched = function (transportationType) {
            $timeout(() => {
                if (vm.hasEnabledTransportationType(false, true) === false) {
                    transportationType.showInDashboard = true;
                    modalService.showYesNo('Warning', vm.getErrorMessage(), null, 'OK');
                } else {
                    if (transportationType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.dropOff) {
                        disableDropOffTypes(false, true);
                    }

                    checkDisableLoaner();
                }
            }, 1);
        };

        vm.consumerHeaderSwitched = function (transportationType) {
            $timeout(() => {
                if (vm.hasEnabledTransportationType(true, false)  === false) {
                    transportationType.showInConsumer = true;
                    modalService.showYesNo('Warning', vm.getErrorMessage(), null, 'OK');
                } else {
                    if (transportationType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.dropOff) {
                        disableDropOffTypes(true, false);
                    }

                    checkDisableLoaner();
                }
            }, 1);
        };


        vm.filterTransportationTypes = function (value, index, array) {
            let dstId = value.dealerSystemTransportationTypeId;

            if (dstId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage) {
                return vm.tripTypes.some(t => t.systemTripTypeId === SYSTEM_ENUMS.systemTripType.mobileGarage);
            }

            return dstId === APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner
                || dstId === APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner
                || dstId === APPOINTMENT_TRANSPORTATION_TYPE.shuttle
                || dstId === APPOINTMENT_TRANSPORTATION_TYPE.waiter
                || dstId === APPOINTMENT_TRANSPORTATION_TYPE.dropOff
                || dstId === APPOINTMENT_TRANSPORTATION_TYPE.rideshareCredits;
        };
        
        
    }
})();

(function () {
    'use strict';
    paymentSettingsController.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.location')
        .component('paymentSettings', {
            templateUrl: 'app/areas/location/components/payments/settings.view.html',
            controller: paymentSettingsController,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'dmsEntry': '<'
            }
        });
    function paymentSettingsController(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
            vm.paymentProcessorsEnum = SYSTEM_ENUMS.paymentProcessorsEnum;
            vm.paymentProcessors = SYSTEM_ENUMS.paymentProcessors;
        }
    }
})();

(function () {
    'use strict';

    InspectionFormDetailController.$inject = ["$timeout", "dealerInspectionService", "inspectionService", "eventAlertService", "INSPECT_CONSTANTS", "rcUtilService", "modalService"];
    angular
        .module('redcap.location')
        .component('inspectionFormDetails', {
            templateUrl: 'app/areas/location/components/inspect/inspection-form-details.view.html',
            controller: InspectionFormDetailController,
            bindings: {
                dealerId: '<',
                formId: '<',          
                displayOrder: '<',      
                onClose: '&'                
            },
            controllerAs: 'vm'
        });

    function InspectionFormDetailController($timeout, dealerInspectionService, inspectionService, eventAlertService, INSPECT_CONSTANTS, rcUtilService, modalService) {
        this.$onInit = function() {
            let vm = this;

            vm.measurementInputTypeEnum = INSPECT_CONSTANTS.measurementInputType;
            vm.measurementInputTypes = mapEnum(INSPECT_CONSTANTS.measurementInputTypeText);
            vm.measurementUnitTypes = mapEnum(INSPECT_CONSTANTS.measurementUnitTypeText);   
            vm.severityTypes = mapEnum(INSPECT_CONSTANTS.severityTypeText);            
            vm.recommendationSearchSettings = inspectionService.getAutoCompleteSettings(true, vm, false, null, null, false);
            vm.observationSearchSettings = inspectionService.getAutoCompleteSettings(false, vm, false, null, null, false);

            function init() {
                if (!vm.formId) {
                    vm.form = {
                        name: '',
                        description: '',
                        isEnabled: false,
                        sections: [],
                        displayOrder: vm.displayOrder
                    };
                } else {
                    vm.isLoading = true;

                    dealerInspectionService.getInspectionFormDetail(vm.dealerId, vm.formId).then((inspectionForm) => {
                        vm.form = inspectionForm;

                        // We have to setup handlers for each obs/rec autocomplete in order to handle when an option is selected
                        vm.form.sections.forEach((section, sectionIdx) => { 
                            section.tasks.forEach((task, taskIdx) => {
                                handleAutoCompleteSearch(`#observation-search${sectionIdx}${taskIdx}`, 'observationId', 'observations');
                                handleAutoCompleteSearch(`#recommendation-search${sectionIdx}${taskIdx}`, 'recommendationId', 'recommendations');
                            });
                        });
                    }).finally(() => {
                        vm.isLoading = false;
                    });
                }                
            }

            vm.saveForm = function() {
                vm.isSaving = true;

                dealerInspectionService.saveInspectionForm(vm.dealerId, vm.form).then((savedForm) => {
                    // This will effectively set the id on the form and any saved section, task, measurement, etc.
                    //  Using lodash merge instead of object.assign because we need a deep merge that includes
                    //  properties set on arrays of objects (ie: tasks within a section).
                    
                    _.merge(vm.form, savedForm);
                    
                    eventAlertService.createAlert('Form saved successfully!');
                }).finally(() => {
                    vm.isSaving = false;
                });
            };

            vm.publishForm = function() {
                vm.isSaving = true;

                dealerInspectionService.publishInspectionForm(vm.dealerId, vm.form.id).then((result) => {
                    init();
                    eventAlertService.createAlert('Form published successfully!');
                }).finally(() => {
                    vm.isSaving = false;
                });
            };

            vm.close = function() {
                if (vm.onClose) {                    
                    vm.onClose();
                }
            };

            vm.addSection = function () {
                const newSection = {
                    tempId: rcUtilService.getRandomNumber(),
                    name: '',
                    tasks: [],
                    displayOrder: vm.form.sections.length + 1,
                    isEditing: true
                };

                vm.form.sections.push(newSection);

                vm.addTask(newSection, vm.form.sections.length - 1);
            };
            
            vm.addTask = function (section, sectionIdx) {
                section.tasks = section.tasks || [];

                const newTask = {
                    tempId: rcUtilService.getRandomNumber(),
                    name: '',
                    observations: [],
                    recommendations: [],
                    displayOrder: section.tasks.length + 1,
                    isEditing: true      
                };

                section.tasks.push(newTask);

                const taskIdx = section.tasks.length - 1;

                handleAutoCompleteSearch(`#observation-search${sectionIdx}${taskIdx}`, 'observationId', 'observations');
                handleAutoCompleteSearch(`#recommendation-search${sectionIdx}${taskIdx}`, 'recommendationId', 'recommendations');
            };

            vm.deleteSection = async function(section) {
                const deleteFn = () => { dealerInspectionService.deleteFormSection(vm.dealerId, section.id); };

                await removeItem('Section', section, deleteFn, vm.form.sections);  
            };

            vm.removeTaskFromSection = async function(task, section) {
                const deleteFn = () => { dealerInspectionService.deleteFormTask(vm.dealerId, task.id); };

                await removeItem('Task', task, deleteFn, section.tasks);             
            };

            vm.createMeasurementForTask = function (task) {
                task.measurement = {
                    tempId: rcUtilService.getRandomNumber(),
                    components: [],
                    levels: [],
                    inputType: null,
                    unitType: null
                };

                vm.addComponentToMeasurement(task);
            };

            vm.removeObservationFromTask = async function(task, taskObservation) {
                const deleteFn = () => { dealerInspectionService.deleteFormObservation(vm.dealerId, taskObservation.id); };

                await removeItem('Observation', taskObservation, deleteFn, task.observations);               
            };

            vm.removeRecommendationFromTask = async function(task, taskRecommendation) {
                const deleteFn = () => { dealerInspectionService.deleteFormRecommendation(vm.dealerId, taskRecommendation.id); };

                await removeItem('Recommendation', taskRecommendation, deleteFn, task.recommendations); 
            };

            vm.addComponentToMeasurement = function(task) {
                const component = {
                    tempId: rcUtilService.getRandomNumber(),
                    name: '',
                    displayOrder: task.measurement.components.length + 1
                };

                task.measurement.components.push(component);
            };

            vm.removeComponentFromMeasurement = async function(task, component) {
                const deleteFn = () => { dealerInspectionService.deleteFormMeasurementComponent(vm.dealerId, task.measurement.id, component.id); };

                await removeItem('Measurement Component', component, deleteFn, task.measurement.components);        
                
                if (task.measurement.components.length === 0) {
                    task.measurement = null;
                }
            };

            vm.addLevelToMeasurement = function(task) {
                const level = {
                    tempId: rcUtilService.getRandomNumber(),
                    value: '',
                    severity: null,
                    displayOrder: task.measurement.levels.length + 1
                };

                task.measurement.levels.push(level);
            };

            vm.removeLevelFromMeasurement = async function(task, level, bypassConfirmation) {
                const deleteFn = () => { dealerInspectionService.deleteFormMeasurementLevel(vm.dealerId, level.id); };

                await removeItem('Measurement Level', level, deleteFn, task.measurement.levels, bypassConfirmation);               
            };

            vm.showSectionEditFields = function(section) {
                section.isEditing = !section.isEditing;
            };

            vm.showTaskEditFields = function(task) {
                task.isEditing = !task.isEditing; 
            };
            
            vm.onItemsReordered = function(e, ui) {
                const itemArray = ui.item.sortable.sourceModel;
              
                itemArray.forEach((item, index) => {
                    item.displayOrder = index + 1;
                });
            };

            vm.sortableSettings = {
                stop: vm.onItemsReordered,
                handle: '> .reorder-container'
            };

            vm.onMeasurementInputTypeChanged = async function(task) {
                if (task.measurement.inputType === vm.measurementInputTypeEnum.manual && task.measurement.levels.length) {
                    const confirmed = await modalService.showYesNo('Are you sure?', 'If you change to MANUAL, the ranges in this section will be deleted. Are you sure you want to do this?', 'No', 'Yes');
                    
                    if (confirmed) {
                        task.measurement.levels.forEach((level) => {
                            vm.removeLevelFromMeasurement(task, level, true);
                        });
                    } else {
                        task.measurement.inputType = vm.measurementInputTypeEnum.range;
                    }
                }
            };

            async function removeItem (itemName, itemToRemove, fn, collectionToRemoveFrom, bypassConfirmation) {
                const isConfirmed = bypassConfirmation ? true : await confirmDelete(itemName);

                if (isConfirmed) {
                    if (itemToRemove.id) {
                        vm.isSaving = true;

                        await fn();

                        vm.isSaving = false;
                    }
    
                    _.remove(collectionToRemoveFrom, (i) => { 
                        return (itemToRemove.id && i.id === itemToRemove.id) ||   // Item is an existing item in the db
                               (itemToRemove.tempId && i.tempId === itemToRemove.tempId); // Item is a newly added item that hasn't been persisted yet
                    });
                }
            }

            async function confirmDelete (itemName) {
                return modalService.showYesNo('Confirm Delete', `Are you sure you want to delete this ${itemName}?`, 'No', 'Yes', false);
            }

            function handleAutoCompleteSearch(autocompleteElId, idField, collectionField) {
                // The templateSelection event on the select2 settings gets fired twice (which is a bug in select2), 
                //  so we explicitly handle this event here, which only gets fired once.  Due to issues with select2
                //  and the angular digest cycle, we have to wrap both of these events in timeouts to ensure the view is refreshed.
                $timeout(() => {
                    const $search = angular.element(autocompleteElId);
                    
                    $search.off('select2:select');

                    $search.on('select2:select', (selection) => {
                        $timeout(() => {
                            const selectedItem = selection.params.data;
                            const item = {
                                name: selectedItem.name,
                                tempId: rcUtilService.getRandomNumber()
                            };

                            item[idField] = selectedItem.id;

                            const selectionEl = angular.element(selection.target);
                            const sectionId = selectionEl.data('sectionId');
                            const taskId = selectionEl.data('taskId');
                            const section = vm.form.sections.find((s) => { return s.id === sectionId || s.tempId === sectionId; });
                            const task = section.tasks.find((t) => { return t.id === taskId || t.tempId === taskId; });                            

                            task[collectionField].push(item);
                            
                            // Clear the selection from the input field
                            $search.val('').trigger('change');
                        }, 0);                        
                    });
                }, 0);
            }

            function mapEnum(textEnum)  {
                return Object.keys(textEnum).map((key) => {
                    return {
                        id: key,
                        name: textEnum[key]
                    };
                });
            }

            init();
        };
    }
})();

(function () {
    'use strict';

    ConstraintController.$inject = ["constraintService", "appointmentRecurrenceOptionClass", "timeUtilService", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE"];
    angular
        .module('redcap.location')
        .component('constraint', {
            templateUrl: 'app/areas/location/components/constraint/constraint.component.view.html',
            controller: ConstraintController,
            bindings: {
                definitionType: '=',
                transportationType: '=',
                initValue: '=?',
                uid: '=?',
                onAdd: '&',
                onRemove: '&',
                onChange: '&'
            }
        });

    function ConstraintController(constraintService,
        appointmentRecurrenceOptionClass,
        timeUtilService,
        APPOINTMENT_CONSTRAINT_DEFINITION_TYPE) {
        this.$onInit = function() {
            let ctrl = this;

            ctrl.constraintDefinitionType = APPOINTMENT_CONSTRAINT_DEFINITION_TYPE;

            ctrl.isLimitPerHourPerDayConstraint = false;

            if (ctrl.definitionType === ctrl.constraintDefinitionType.opCode ||
                ctrl.definitionType === ctrl.constraintDefinitionType.transportation ||
                ctrl.definitionType === ctrl.constraintDefinitionType.appointment) {
                ctrl.isLimitPerHourPerDayConstraint = true;
            }

            ctrl.selectedRecurrenceOption = null;

            ctrl.datepickerOptions = {
                drops: "up",
                eventHandlers: {
                    'apply.daterangepicker': function(event, picker) {
                        ctrl.inputChange();
                    },
                    'hide.daterangepicker': function(event, picker) {
                        ctrl.inputChange();
                    },
                    'cancel.daterangepicker': function(event, picker) {
                        ctrl.inputChange();
                    }
                }
            };
            ctrl.dateRange = {};
            ctrl.hoursInDay = timeUtilService.hourIntervalsInDay;

            ctrl.availableEndHours = function() {
                return timeUtilService.filterAvailableHours.apply(ctrl, arguments);
            };

            ctrl.userLimitTypes = [
                {
                    label: 'DEALER',
                    value: 'dashboard'
                },
                {
                    label: 'CONSUMER',
                    value: 'consumer'
                },
                {
                    label: 'ALL USERS',
                    value: 'all'
                }
            ];
            ctrl.limitTypes = [
                {
                    label: 'PER HOUR',
                    value: 'hour'
                },
                {
                    label: 'COMBINED',
                    value: 'accumulative'
                }
            ];
            ctrl.recurrenceOptions = [];
            ctrl.allDay = false;
            ctrl.showRecurrenceOptions = false;
            ctrl.startTime = null;
            ctrl.endTime = null;
            ctrl.limitType = null;
            ctrl.limit = null;

            ctrl.repeatDayOfWeekValid = false;

            ctrl.enableAdd = false;

            ctrl.disableUserLimit = function(limitType) {
                if (!ctrl.transportationType) return false;

                if (limitType.value === 'dashboard') {
                    return ctrl.transportationType && ctrl.transportationType.showInDashboard === false;
                } else if (limitType.value === 'consumer') {
                    return ctrl.transportationType && ctrl.transportationType.showInConsumer === false;
                } else {
                    return ctrl.transportationType &&
                        ctrl.transportationType.showInConsumer === false &&
                        ctrl.transportationType.showInDashboard === false;
                }
            };

            ctrl.getActiveUserLimitTypes = function() {
                let allTypes = ctrl.userLimitTypes;
                let activeTypes = [];

                allTypes.forEach((type) => {
                    if (ctrl.disableUserLimit(type) === false) {
                        activeTypes.push(type);
                    }
                });

                return activeTypes;
            };

            ctrl.populateRecurrenceOptions = function(startDate, endDate) {
                ctrl.recurrenceOptions = constraintService.getRecurrenceOptions(startDate, endDate);
            };

            ctrl.isEmpty = function() {
                // Required for validations
                return !ctrl.allDay &&
                    !ctrl.startTime &&
                    !ctrl.endTime &&
                    !ctrl.limitType &&
                    !ctrl.limit &&
                    !ctrl.repeatMonday &&
                    !ctrl.repeatTuesday &&
                    !ctrl.repeatWednesday &&
                    !ctrl.repeatThursday &&
                    !ctrl.repeatFriday &&
                    !ctrl.repeatSaturday &&
                    !ctrl.repeatSunday;
            };

            // Holds logic to translate our models to a proper constraint model for validations
            ctrl.processModelUpdates = function() {
                let today = new Date();
                let startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                let endDate = null;
                let constraint;
                let recurrenceOption;

                if (ctrl.dateRange.startDate) {
                    startDate = ctrl.dateRange.startDate.startOf('day').toDate();
                }

                if (ctrl.dateRange.endDate) {
                    endDate = ctrl.dateRange.endDate.startOf('day').toDate();
                }

                if (!ctrl.selectedRecurrenceOption || !ctrl.showRecurrenceOptions) {
                    recurrenceOption = appointmentRecurrenceOptionClass.new(ctrl);
                    recurrenceOption.repeatDaily = true;
                } else {
                    recurrenceOption = ctrl.selectedRecurrenceOption;
                }

                constraint = constraintService.newConstraint(startDate,
                    ctrl.startTime,
                    endDate,
                    ctrl.endTime,
                    recurrenceOption,
                    ctrl.definitionType);
                constraint.uid = ctrl.uid;
                constraint.allDay = ctrl.allDay;

                if (ctrl.initValue) {
                    // Don't override the start date
                    if (ctrl.initValue.id) {
                        constraint.startDate = ctrl.initValue.startDate;
                        constraint.id = ctrl.initValue.id;
                    }

                    constraint.departmentId = ctrl.initValue.departmentId;
                    constraint.advisorId = ctrl.initValue.advisorId;
                    constraint.dealerRecurrenceRuleId = ctrl.initValue.dealerRecurrenceRuleId;
                }

                if (ctrl.isLimitPerHourPerDayConstraint) {
                    let settingsData = {
                        limit: ctrl.limit,
                        limitAccumulative: ctrl.limitType === 'accumulative',
                        userLimitType: ctrl.userLimitType
                    };

                    if (ctrl.definitionType === ctrl.constraintDefinitionType.opCode) {
                        settingsData.opCode = '';

                        if (ctrl.initValue && ctrl.initValue.constraintDataParsed) {
                            settingsData.opCode = ctrl.initValue.constraintDataParsed.OpCode ||
                                ctrl.initValue.constraintDataParsed.opCode;
                        }
                    } else if (ctrl.definitionType === ctrl.constraintDefinitionType.transportation) {
                        settingsData.transportationTypeId = ctrl.initValue.constraintDataParsed.TransportationTypeId ||
                            ctrl.initValue.constraintDataParsed.transportationTypeId;
                        settingsData.isPickup = ctrl.initValue.constraintDataParsed.IsPickup ||
                            ctrl.initValue.constraintDataParsed.isPickup;
                        settingsData.hasLoaner = ctrl.initValue.constraintDataParsed.HasLoaner ||
                            ctrl.initValue.constraintDataParsed.hasLoaner;
                    }
                    
                    constraint.constraintData = JSON.stringify(settingsData);
                    constraint.constraintDataParsed = settingsData;

                    // Update the values back to the initValue
                    if (ctrl.initValue) {
                        ctrl.initValue.startTime = ctrl.startTime;
                        ctrl.initValue.endTime = ctrl.endTime;
                        ctrl.initValue.limitType = ctrl.limitType;
                        ctrl.initValue.limit = ctrl.limit;

                        ctrl.initValue.repeatMonday = ctrl.repeatMonday || false;
                        ctrl.initValue.repeatTuesday = ctrl.repeatTuesday || false;
                        ctrl.initValue.repeatWednesday = ctrl.repeatWednesday || false;
                        ctrl.initValue.repeatThursday = ctrl.repeatThursday || false;
                        ctrl.initValue.repeatFriday = ctrl.repeatFriday || false;
                        ctrl.initValue.repeatSaturday = ctrl.repeatSaturday || false;
                        ctrl.initValue.repeatSunday = ctrl.repeatSunday || false;

                        ctrl.initValue.isNew = false;
                        constraint.isNew = ctrl.initValue.isNew;
                    }
                }

                return constraint;
            };

            ctrl.inputChange = function(preventDefault) {
                // Re-run validations
                ctrl.enableAdd = true;

                // Validate time is properly selected
                if (ctrl.allDay) {
                    ctrl.startTime = null;
                    ctrl.endTime = null;
                } else if (ctrl.startTime && ctrl.endTime) {
                    if (!timeUtilService.validateEndTimeGreaterThanStartTime(ctrl.startTime, ctrl.endTime) === true) {
                        ctrl.enableAdd = false;
                    }
                } else {
                    ctrl.enableAdd = false;
                }

                if (ctrl.isLimitPerHourPerDayConstraint) {
                    if (!ctrl.limitType || ctrl.limit < 0 || _.isNil(ctrl.limit)) {
                        ctrl.enableAdd = false;
                    }

                    if (!ctrl.allDay && !(ctrl.startTime && ctrl.endTime)) {
                        ctrl.enableAdd = false;
                    } else if (ctrl.allDay) {
                        ctrl.startTime = null;
                        ctrl.endTime = null;
                    }

                    if (ctrl.enableAdd && !preventDefault) {
                        // This view does not have an add button workflow - invoke the add method to perform the necessary model translations
                        ctrl.add();
                    }
                } else {
                    if (ctrl.dateRange.startDate && ctrl.dateRange.endDate) {
                        if (ctrl.dateRange.startDate.format('L') === ctrl.dateRange.endDate.format('L')) {
                            // We have a single date
                            ctrl.showRecurrenceOptions = true;
                        } else {
                            // We have a range of dates
                            ctrl.showRecurrenceOptions = false;
                        }

                        ctrl.populateRecurrenceOptions(ctrl.dateRange.startDate.toDate(),
                            ctrl.dateRange.endDate.toDate());

                        if (ctrl.showRecurrenceOptions) {
                            // Keep previous entry if still an option, otherwise default to first recurrence option
                            let existingIndex = ctrl.recurrenceOptions.findIndex(ctrl.recurrenceOptions, (option) => {
                                return ctrl.selectedRecurrenceOption &&
                                    option.text === ctrl.selectedRecurrenceOption.text;
                            });

                            if (existingIndex > -1) {
                                ctrl.selectedRecurrenceOption = ctrl.recurrenceOptions[existingIndex];
                            } else {
                                ctrl.selectedRecurrenceOption = ctrl.recurrenceOptions[0];
                            }
                        } else {
                            ctrl.selectedRecurrenceOption = null;
                        }
                    } else if (!ctrl.dateRange.startDate) {
                        ctrl.enableAdd = false;
                    }
                }

                if (ctrl.onChange && !preventDefault) {
                    let uid = ctrl.uid;
                    let elementsToRevalidate = [
                        'recurrence-user-limittype-' + uid,
                        'recurrence-starttime-' + uid,
                        'recurrence-endtime-' + uid,
                        'recurrence-limittype-' + uid,
                        'recurrence-limit-' + uid,
                        'recurrence-option-' + uid,
                        'recurrence-dow-valid-' + uid
                    ];

                    ctrl.onChange({elementsToRevalidate: elementsToRevalidate});
                }
            };

            ctrl.validation = {
                valConstraintStartEndTime: function(otherField) {
                    if (ctrl.isEmpty()) {
                        return true;
                    }

                    if (ctrl.allDay) {
                        return true;
                    }

                    return timeUtilService.validateEndTimeGreaterThanStartTime(ctrl.startTime,
                        ctrl.endTime,
                        otherField);
                },
                valUserLimitType: function() {
                    if (ctrl.isEmpty()) {
                        return true;
                    }

                    if (!ctrl.userLimitType) {
                        return false;
                    }

                    return true;
                },
                valLimitType: function() {
                    if (ctrl.isEmpty()) {
                        return true;
                    }

                    if (ctrl.isLimitPerHourPerDayConstraint && !ctrl.limitType) {
                        return false;
                    }

                    return true;
                },
                valLimit: function() {
                    if (ctrl.isEmpty()) {
                        return true;
                    }

                    if (ctrl.isLimitPerHourPerDayConstraint && (ctrl.limit < 0 || _.isNil(ctrl.limit))) {
                        return false;
                    }

                    return true;
                },
                valRepeatDay: function() {
                    if (ctrl.isEmpty()) {
                        return true;
                    }

                    if (!ctrl.repeatMonday &&
                        !ctrl.repeatTuesday &&
                        !ctrl.repeatWednesday &&
                        !ctrl.repeatThursday &&
                        !ctrl.repeatFriday &&
                        !ctrl.repeatSaturday &&
                        !ctrl.repeatSunday) {
                        return false;
                    }

                    return true;
                }
            };

            ctrl.add = function() {
                let constraint = ctrl.processModelUpdates();

                if (!ctrl.isLimitPerHourPerDayConstraint) {
                    // Clear the fields
                    ctrl.dateRange = {};
                    ctrl.selectedRecurrenceOption = null;
                    ctrl.recurrenceOptions = [];
                    ctrl.allDay = false;
                    ctrl.showRecurrenceOptions = false;
                    ctrl.startTime = null;
                    ctrl.endTime = null;
                    ctrl.limitType = null;
                    ctrl.limit = null;
                    ctrl.enableAdd = false;
                }

                if (ctrl.onAdd) {
                    ctrl.onAdd({constraint: constraint, uid: ctrl.uid});
                }
            };

            ctrl.remove = function() {
                if (ctrl.onRemove) {
                    ctrl.onRemove();
                }
            };

            if (ctrl.initValue && ctrl.initValue.dealerConstraintDefinitionId) {
                // Load in the constraint for edit
                ctrl.definitionType = ctrl.initValue.dealerConstraintDefinitionId;
                ctrl.startTime = ctrl.initValue.startTime;
                ctrl.endTime = ctrl.initValue.endTime;
                ctrl.allDay = ctrl.startTime === null && ctrl.endTime === null;
                let  settingsData = JSON.parse(ctrl.initValue.constraintData);

                ctrl.limit = _.isNil(settingsData.Limit) ? settingsData.limit : settingsData.Limit;
                ctrl.limitType = settingsData.LimitAccumulative || settingsData.limitAccumulative
                    ? 'accumulative'
                    : 'hour';
                ctrl.userLimitType = settingsData.UserLimitType || settingsData.userLimitType;
                ctrl.repeatMonday = ctrl.initValue.repeatMonday;
                ctrl.repeatTuesday = ctrl.initValue.repeatTuesday;
                ctrl.repeatWednesday = ctrl.initValue.repeatWednesday;
                ctrl.repeatThursday = ctrl.initValue.repeatThursday;
                ctrl.repeatFriday = ctrl.initValue.repeatFriday;
                ctrl.repeatSaturday = ctrl.initValue.repeatSaturday;
                ctrl.repeatSunday = ctrl.initValue.repeatSunday;

                // Fire off the input change for validation
                ctrl.inputChange(true);
            }
        };
    }
})();

(function () {
    'use strict';

    tekionSettings.$inject = ["SYSTEM_ENUMS"];
    angular
        .module('redcap.location')
        .component('tekionSettings', {
            templateUrl: 'app/areas/location/components/dms/tekion-settings.view.html',
            controller: tekionSettings,
            bindings: {
                dmsTransportationTypes: '<',
                dealerTransportationTypes: '<',
                ngModel: '<',
                dmsSystem: '<'
            },
            controllerAs: 'vm'
        });

    function tekionSettings(SYSTEM_ENUMS) {
        this.$onInit = function() {
            let vm = this;

            vm.tekionDmsSystem = SYSTEM_ENUMS.dmsSystemEnum.Tekion;
        };


    }
})();

(function () {
    'use strict';

    LoanerVehiclesSummaryController.$inject = ["$transition$", "loanerService", "locationService", "eventAlertService", "resolvedStatuses", "SYSTEM_ENUMS", "$scope", "$state"];
    angular
        .module('redcap.loaner')
        .controller('LoanerVehiclesSummaryController', LoanerVehiclesSummaryController);

    function LoanerVehiclesSummaryController($transition$, loanerService, locationService, eventAlertService, resolvedStatuses, SYSTEM_ENUMS, $scope, $state) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        vm.loading = false;
        vm.locationId = $transition$.params().locationId;
        vm.dateStatus = vm.today = moment(new Date());
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;

        vm.statusList = resolvedStatuses;

        function initSummary() {

            vm.loadingTab = true;

            loanerService.getVehicle($transition$.params().locationId, $transition$.params().vehicleId).then(result => {

                if (!result) {
                    $state.go('loaner-vehicles-list', {}, {reload: true});
                }

                vm.resolvedVehicle = result;
                vm.newStatus = vm.resolvedVehicle.status;

                if (vm.statusList.indexOf(vm.resolvedVehicle.status) === -1) {
                    vm.statusList.push(vm.resolvedVehicle.status);
                }

                if (vm.resolvedVehicle.activeContractId != null) {
                    vm.loadingContract = true;
                    loanerService.getContract($transition$.params().locationId, vm.resolvedVehicle.activeContractId).then(contract => {
                        vm.resolvedContract = contract;
                        vm.loadingContract = false;
                    });
                } else {
                    vm.loadingContract = false;
                    vm.resolvedContract = null;
                }

                locationService.getIntegrations($transition$.params().locationId).then((result) => {
                    vm.loanerProviderType = result.loaner.providerType;
                });

                vm.loadingTab = false;
            });

        }

        vm.update = function () {
            vm.loading = true;
            loanerService.updateStatusVehicle($transition$.params().locationId, $transition$.params().vehicleId, vm.newStatus, moment(vm.dateStatus).format('YYYY-MM-DD')).then(() => {
                vm.loading = false;
                eventAlertService.createAlert('Vehicle sucessfully updated.');
            });
        };

        vm.edit = function () {
            $state.go('loaner-vehicle-edit', {'vehicleId': $transition$.params().vehicleId, 'locationId': $transition$.params().locationId});
        };


        initSummary();

        vm.close = function () {
            $scope.$dismiss();
            $state.go('loaner-vehicles-list', {}, {reload: true});
        };
    }

})();
(function () {
    'use strict';

    LoanerVehiclesListController.$inject = ["$timeout", "loanerService", "locationService", "repairOrderService", "SYSTEM_ENUMS", "SAVED_SEARCHES_PLACEHOLDER", "searchMode", "systemService", "searchTemplateUtilService", "rcLocalStorageService", "rcUtilService", "$scope", "$filter", "$state"];
    angular
        .module('redcap.loaner')
        .controller('LoanerVehiclesListController', LoanerVehiclesListController);

    function LoanerVehiclesListController($timeout, loanerService, locationService, repairOrderService, SYSTEM_ENUMS, SAVED_SEARCHES_PLACEHOLDER, searchMode, systemService, searchTemplateUtilService, rcLocalStorageService, rcUtilService, $scope, $filter, $state) {
        let vm = this;
        let locationMakesAndModels = null;
        let searchCriteriaKey = "fleetsSearchCriteriaFilters";
        let templateKey = "selectedVehicleSearchTemplate";

        vm.showAdvancedSearch = false;
        searchTemplateUtilService.initSearchTemplateData(vm);
        vm.locations = null;
        vm.loadingMakes = false;
        vm.pageNumber = 0;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.searchMode = searchMode;

        if ($state.name !== 'loaner-vehicles-list') vm.searchMode = 'loaner-vehicles-list';

        vm.selectableViewModes = [
            {value: 'loaner-contracts-list', icon: 'library_books', text: 'Contracts', tooltip: 'Contracts List View', hideFramedIn: false},
            {value: 'loaner-vehicles-list', icon: 'drive_eta', text: 'Fleet', tooltip: 'Fleet List View', hideFramedIn: false}
        ];

        vm.listModeChanged = function() {
            vm.showAdvancedSearch = false;
            vm.setListMode(vm.searchModeIcon.value);
        };

        vm.setListMode = function (newMode) {
            loanerService.loanerListModeChanged(vm, newMode);
        };

        function setSearchModeDropdownIcon () {
            let ddIcon = $filter('filter')(vm.selectableViewModes, {value: vm.searchMode}, true);

            if (ddIcon && ddIcon.length > 0) {
                vm.searchModeIcon = ddIcon[0];
            } else {
                vm.searchModeIcon = null;
            }
        }

        vm.showColumns = {
            color: true,
            vehicleGroup: true,
            location: true,
            stockNumber: true
        };
        
        let initialFilters = { 
            location: null,
            search: null,
            status: [],
            make: null,
            model: null,
            group: null,
            makesFilter: [],
            modelsFilter: [],
            vehicleClasses: [],
            statusesFilter: [],
            loanerProviderType: null
        };

        let existingFilters = rcLocalStorageService.get(searchCriteriaKey) || {};
        
        vm.filters = Object.assign({}, initialFilters, existingFilters);

        vm.searchScopeText = function (statuses) {
            let text = statuses.map((status) => {
                return vm.filters.statusesFilter.find((filterStatus) => filterStatus.id === status.id).text;
            });

            return text.join(', ');
        };

        function populateGroupsFilter() {
            if (!vm.filters.location || !vm.filters.location.id) {
                vm.filters.vehicleClasses = [];

                return;
            }

            let savedGroup = vm.filters.group; // check if group is in new dealer

            loanerService.getVehicleClasses(vm.filters.location.id).then(result => {
                vm.filters.vehicleClasses = result ? result.filter(a => a.vehicleClass !== undefined).map(a => a.vehicleClass) : [];
            }).finally(() => {
                if (!vm.searchTemplateData.isTemplateDirty && vm.searchTemplateData.currentSearchTemplate && vm.searchTemplateData.currentSearchTemplate.template && vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleGroup) {
                    vm.filters.group = vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleGroup;
                }

                if (savedGroup) {
                    let matchedGroup = vm.filters.vehicleClasses.find(item => item.toLowerCase() === savedGroup.toLowerCase());

                    if (matchedGroup) vm.filters.group = matchedGroup;
                }
            });
        }

        function populateMakesFilter() {
            if (!vm.filters.location || !vm.filters.location.id) {
                vm.filters.makesFilter = [];
                vm.filters.modelsFilter = [];

                return;
            }

            let savedMake = vm.filters.make;   // check if make/model is in new dealer
            let savedModel = vm.filters.model;
            
            vm.loadingMakes = true;
            loanerService.getVehicles({dealerId: vm.filters.location.id, page: 0, pageSize: 200}).then((result) => { 
                mapMakesAndModels(result);
                vm.filters.statusesFilter = result ? [... new Set(result.map(a => a.status))].map((a, index) => ({id: index, text: a})) : [];
            }).finally(() => {
                vm.loadingMakes = false;
                vm.filters.makesFilter = Object.keys(locationMakesAndModels).sort().map(make => make);

                if (!vm.searchTemplateData.isTemplateDirty && vm.searchTemplateData.currentSearchTemplate && vm.searchTemplateData.currentSearchTemplate.template && !vm.isLoading) {
                    if (vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleMake) vm.filters.make = vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleMake;
                    if (vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleModel) vm.filters.model = vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleModel;
                    if (vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleStatus) vm.filters.status = vm.searchTemplateData.currentSearchTemplate.template.selectedVehicleStatus;
                }

                if (savedMake) {
                    let matchedMake = vm.filters.makesFilter.find(item => item.toLowerCase() === savedMake.toLowerCase());

                    if (matchedMake) vm.filters.make = matchedMake;
                    populateModelsFilter(savedModel);
                }
            });
        }

        function mapMakesAndModels(vehicles) {
            if (!vehicles || vehicles.length === 0) {
                locationMakesAndModels = null;

                return;
            }

            locationMakesAndModels = vehicles.reduce((acc, vehicle) => {

                if (!acc[vehicle.make]) {
                    acc[vehicle.make] = [];
                }

                if (!acc[vehicle.make].includes(vehicle.model)) {
                    acc[vehicle.make].push(vehicle.model);
                }

                return acc;
            }, {});
        }
 
        function populateModelsFilter(savedModel = null) {
            if (!vm.filters.make) {
                vm.filters.modelsFilter = [];

                return;
            }

            vm.filters.modelsFilter = locationMakesAndModels[vm.filters.make].sort().map(model => model);

            if (savedModel) {
                let matchedModel = vm.filters.modelsFilter.find(item => item.toLowerCase() === savedModel.toLowerCase());

                if (matchedModel) vm.filters.model = matchedModel;
            }
        }

        vm.selectedLocationChanged = function () {
            vm.resetLocationFilters();
            validateShownColumns();
            getLoanerProvider();
            populateGroupsFilter();
            populateMakesFilter();

            if (!vm.showAdvancedSearch) {
                vm.filterChanged();
            }
        };

        function validateShownColumns() {

            let propertiesToHide = [];
            let sysEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
            let location = vm.filters.location;

            if (location && (location.loanerManagementSystem === sysEnum.TSD ||
                location.loanerManagementSystem === sysEnum.TSDNew)) {
                propertiesToHide.push('color', 'vehicleGroup', 'stockNumber');
            } else if (location && location.loanerManagementSystem === sysEnum.ARS) {
                propertiesToHide.push('location', 'stockNumber');
            } else if (location && location.loanerManagementSystem === sysEnum.DealerWare) {
                propertiesToHide.push('vehicleGroup');
            }

            Object.keys(vm.showColumns).forEach(property => {
                if (propertiesToHide.includes(property)) {
                    vm.showColumns[property] = false;
                } else {
                    vm.showColumns[property] = true;
                }
            });
        }

        vm.makesFilterChanged = function () {
            populateModelsFilter();
            vm.filterChanged();
        };

        vm.filterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();

                if (!vm.showAdvancedSearch) {
                    vm.runQuery();
                }
            }, 1);
        };

        vm.searchStatusSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            idProp: 'text',
            displayProp: 'text',
            buttonClasses: 'ellipsis-overflow'
        };

        vm.searchStatusStrings = {
            buttonDefaultText: 'All statuses'
        };

        vm.searchSStatusEvents = {
            onSelectionChanged: function () {
                vm.filterChanged();
            }
        };

        vm.refreshVehicles = function () {
            if (vm.filters.location && vm.filters.location.id) {
                vm.isLoading = true;
                
                loanerService.getVehicles({
                    page: vm.pageNumber || 0,
                    pageSize: 20,
                    dealerId: vm.filters && vm.filters.location && vm.filters.location.id,
                    search: vm.filters && vm.filters.search,
                    group: vm.filters && vm.filters.group,
                    status: vm.filters && vm.filters.status.map(status => status.id),
                    make: vm.filters && vm.filters.make,
                    model: vm.filters && vm.filters.model
                }).then((result) => {
                    createFilterMessage();
                    vm.vehicles = vm.vehicles.concat(result);
                    vm.canShowMore = result && result.length === 20;
                    vm.pageNumber++;
                }).finally(() => {
                    saveFilterSettings();
                    vm.isLoading = false;
                });
            }
        };

        vm.getFuelPercentage = function(vehicle) {
            if (vehicle.fuelInLiters && vehicle.fuelCapacity) {
                return Math.round((vehicle.fuelInLiters / vehicle.fuelCapacity) * 100);
            } else if (vehicle.fuel) {
                return Math.round(vehicle.fuel * 100);
            } else {
                return 0;
            }
        };
        
        vm.getLocations = function() {
            repairOrderService.getDealersForDropdown(SYSTEM_ENUMS.permissionTypes.loaner, false).then((result) => {
                // filter out TSD Legacy locations, since they don't support fleet .. we also don't want None because ... those don't actually bring anything back but an error
                let filteredResult = result.filter(location => location.loanerManagementSystem !== SYSTEM_ENUMS.loanerManagementSystemsEnum.TSD && location.loanerManagementSystem !== SYSTEM_ENUMS.loanerManagementSystemsEnum.None);

                filteredResult.forEach((location) => {
                    location.displayText = rcUtilService.formatLocationForDropdown(location);
                });

                vm.locations = filteredResult;

                if (vm.locations.length === 1) {
                    vm.filters.location = vm.locations[0];
                } else if (vm.filters.location && vm.filters.location.id) {
                    vm.filters.location = $filter('filter')(vm.locations, {id: vm.filters.location.id})[0];
                }
                
                init();
            });
        };

        vm.getLocations();
        
        function getLoanerProvider () {
            if (vm.filters.location && vm.filters.location.id) {
                locationService.getIntegrations(vm.filters.location.id).then((result) => { // here
                    vm.filters.loanerProviderType = result.loaner.providerType;
                });
            }
        }
        
        vm.addVehicle = function () {
            $state.go('loaner-vehicle-add');
        };

        vm.toggleShowSearchOptions = function () {
            vm.searchTemplateBeforeAdvancedSearch = structuredClone(vm.searchTemplateData);
            vm.filtersBeforeAdvancedSearch  = structuredClone(vm.filters);
            
            if (vm.showAdvancedSearch) {
                vm.runQuery();
            }

            vm.showAdvancedSearch = !vm.showAdvancedSearch;
        };

        function updateDirtyFlag() {
            if (vm.searchTemplateData.currentSearchTemplate) {
                vm.searchTemplateData.isTemplateDirty = true;
            }
        }

        vm.runQuery = function () {
            if (vm.showAdvancedSearch) return;
            
            vm.vehicles = [];
            vm.pageNumber = 0;
            createFilterMessage();
            vm.refreshVehicles();
            saveFilterSettings();
        };

        vm.applyBtnClicked = function () {
            vm.searchTemplateBeforeAdvancedSearch = null;
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            rcLocalStorageService.set(templateKey, vm.searchTemplateData.currentSearchTemplate);
            vm.runQuery();
        };

        vm.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vm.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };

        vm.clearSearchCriteria = function () {
            vm.keywordFilter = null;
            vm.isGlobalTemplate = false;
            vm.resetFilters();
        };

        vm.resetLocationFilters = function () {
            locationMakesAndModels = null;
            vm.filters.status = [];
            vm.filters.group = null;
            vm.filters.makesFilter = [];
            vm.filters.modelsFilter = [];
            vm.filters.vehicleClasses = [];
            vm.filters.statusesFilter = [];
        };

        vm.resetFilters = function (linkClicked) {
            vm.templateName = null;
            vm.searchTemplateData.currentSearchTemplate = null;
            vm.searchTemplateData.savedSearchName = null;
            vm.filters.location = vm.locations.length === 1 ? vm.locations[0] : null;
            vm.filters.search = null;
            vm.filters.make = null;
            vm.filters.model = null;
            vm.resetLocationFilters();
            vm.filtersBeforeAdvancedSearch  = structuredClone(vm.filters);
            rcLocalStorageService.set(templateKey, null);

            if (linkClicked) {
                vm.showAdvancedSearch = false;
            }

            if (!vm.showAdvancedSearch) {
                vm.clearSearchField();
                saveFilterSettings();
                createFilterMessage();
            }
        };

        vm.clearSearchField = function() {
            vm.filters.search = null;
            vm.filterChanged();
        };

        function saveFilterSettings() {
            rcLocalStorageService.set(searchCriteriaKey, vm.filters);
        }

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vm.searchTemplateData.currentSearchTemplate.id = null;
            }

            searchTemplateUtilService.saveSearchTemplateClicked(vm, {
                selectedVehicleLocationId: vm.filters.location.id,
                selectedVehicleSearch: vm.filters.search, 
                selectedVehicleStatus: vm.filters.status, 
                selectedVehicleMake: vm.filters.make, 
                selectedVehicleModel: vm.filters.model, 
                selectedVehicleGroup: vm.filters.group, 
                templateName: vm.searchTemplateData.savedSearchName
            }, SYSTEM_ENUMS.searchTemplateTypes.fleet);
        }

        function finishLoadingTemplate() { 
            let template = vm.searchTemplateData.currentSearchTemplate.template;

            vm.filters.search = template.selectedVehicleSearch;
            vm.filters.status = template.selectedVehicleStatus;
            vm.filters.group = template.selectedVehicleGroup;
            vm.filters.make = template.selectedVehicleMake;
            vm.filters.model = template.selectedVehicleModel;

            if (!vm.showAdvancedSearch) {
                vm.runQuery();
            }
        }

        vm.loadSearchTemplate = function (item, model) {
            if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                let template = item.template;
                let templateDealer = $filter('filter')(vm.locations, {id: template.selectedVehicleLocationId}, true);

                vm.isLoading = true;
                vm.searchTemplateData.isTemplateDirty = false;
                vm.searchTemplateData.currentSearchTemplate = item;
                rcLocalStorageService.set(templateKey, vm.searchTemplateData.currentSearchTemplate);
                vm.searchTemplateData.savedSearchName = template.templateName;
                vm.templateName = template.templateName;
                
                if (templateDealer && templateDealer.length > 0) {
                    if (vm.filters.location !== templateDealer[0]) {
                        vm.filters.location = templateDealer[0];
                        populateGroupsFilter();
                        populateMakesFilter();
                        getLoanerProvider();
                    } else {
                        vm.filters.location = templateDealer[0];
                    }
                }

                finishLoadingTemplate();
                        
            } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                rcLocalStorageService.set(templateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);
                vm.resetFilters();
            } else {
                rcLocalStorageService.set(templateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);

                if (!vm.showAdvancedSearch) {
                    vm.runQuery();
                }
            }
        };

        function loadSearchTemplates () {
            systemService.getSearchTemplates(SYSTEM_ENUMS.searchTemplateTypes.fleet).then((templates) => {
                vm.searchTemplateData.searchTemplates = templates;
                loadLastTemplateAndFilters();
            });
        }

        function loadLastTemplateAndFilters () {
            vm.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate(templateKey);

            if (vm.searchTemplateData.currentSearchTemplate) {
                let searchItem = vm.searchTemplateData.searchTemplates.find((item) => { return item.template.templateName === vm.searchTemplateData.currentSearchTemplate.template.templateName; });

                if (searchItem) {
                    vm.loadSearchTemplate(searchItem);
                } else {
                    vm.searchTemplateData.currentSearchTemplate = null;
                    vm.runQuery();
                }
            } 
        }

        function createFilterMessage() {
            vm.filterCount = 0;
            vm.filterMessage = '';

            if (vm.filters.location && vm.filters.location.name) {
                vm.requiredFilterMessage = vm.filters.location.name;
                vm.filterCount++;
                rcUtilService.buildFilterMessage('Location', vm.filters.location.name, vm, false, true, 43);
            }
            
            if (vm.filters.search) {
                vm.filterCount++;
                rcUtilService.buildFilterMessage('Search Term', vm.filters.search, vm, false, true, 43);
            }

            if (vm.filters.status && vm.filters.status.length > 0) {
                vm.filterCount++;
                rcUtilService.buildFilterMessage('Status', vm.filters.status.map(x => x.id).join(", "), vm, false, true, 43);
            }
            
            if (vm.filters.make) {
                vm.filterCount++;
                rcUtilService.buildFilterMessage('Make', vm.filters.make, vm, false, true, 43);
            }
            
            if (vm.filters.model) {
                vm.filterCount++;
                rcUtilService.buildFilterMessage('Model', vm.filters.model, vm, false, true, 43);
            }

            if (vm.filters.group) {
                vm.filterCount++;
                rcUtilService.buildFilterMessage('Group', vm.filters.group, vm, false, true, 43);
            }
        }
        
        function init() {
            vm.vehicles = [];
            loadSearchTemplates();
            setSearchModeDropdownIcon();
            populateGroupsFilter();
            populateMakesFilter();
            getLoanerProvider();
            validateShownColumns();
            vm.runQuery();
        } 

        vm.close = function () {
            searchTemplateUtilService.advancedFilterModalClosed(vm);
            validateShownColumns();
        };
    }

})();

(function () {
    'use strict';

    LoanerVehiclesAddController.$inject = ["$transition$", "loanerService", "resolvedLocations", "resolvedLocation", "resolvedDealerConfigurations", "SYSTEM_ENUMS", "$scope", "authService"];
    angular
        .module('redcap.loaner')
        .controller('LoanerVehiclesAddController', LoanerVehiclesAddController);

    function LoanerVehiclesAddController($transition$, loanerService, resolvedLocations, resolvedLocation, resolvedDealerConfigurations, SYSTEM_ENUMS, $scope, authService) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        vm.resolvedLocations = resolvedLocations;
        vm.vehicleId = $transition$.params().vehicleId;
        vm.dealerConfigurations = resolvedDealerConfigurations;
        
        vm.accordion = {
            steps: {
                chooseLocation: 1,
                vehicleDetails: 2
            },
            selectedStep: 1
        };

        vm.clearSelectedLocation = function() {
            vm.location = null;
            vm.customer = null;
            vm.accordion.selectedStep = 1;
        };

        vm.locationSelected = function() {
            loanerService.loanerConfigurations(vm.location.id).then(
                (dealerConfigurations) => {
                    vm.dealerConfigurations = dealerConfigurations;
                    vm.accordion.selectedStep += 1;
                });
            
            vm.loadingVehicleGroups = true;
            loanerService.getVehicleClasses(vm.location.id).then(result => {
                vm.vehicleClasses = result ? result.map(a => a.vehicleClass) : [];
                vm.loadingVehicleGroups = false;
            });
        };

        if (resolvedLocations && resolvedLocations.length === 1) {
            vm.location = resolvedLocations[0];
            vm.locationSelected();
        }

        function initEdit() {
            vm.loadingTab = true;
            loanerService.getVehicle($transition$.params().locationId, $transition$.params().vehicleId).then(result => {
                vm.resolvedVehicle = result;
                vm.accordion.selectedStep += 1;
                vm.location = resolvedLocation;
                vm.loadingTab = false;
            });

            vm.loadingVehicleGroups = true;
            loanerService.getVehicleClasses($transition$.params().locationId).then(result => {
                vm.vehicleClasses = result ? result.map(a => a.vehicleClass) : [];
                vm.loadingVehicleGroups = false;
            });

        }

        if ($transition$.params().vehicleId) {
            initEdit();
        }

    }

})();
(function () {
    'use strict';

    LoanerReservationsEditController.$inject = ["$state", "$transition$", "rcUtilService", "loanerService", "resolvedLocation", "tripService", "messagesService", "SYSTEM_ENUMS", "eventAlertService", "$rootScope"];
    angular
        .module('redcap.loaner')
        .controller('LoanerReservationsEditController', LoanerReservationsEditController);

    function LoanerReservationsEditController($state, $transition$, rcUtilService, loanerService, resolvedLocation, tripService, messagesService, SYSTEM_ENUMS, eventAlertService, $rootScope) {
        let vm = this;

        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.$transition$ = $transition$;
        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.dealer = resolvedLocation;
        vm.locationId = $transition$.params()['locationId'];
        vm.reservationId = $transition$.params()['reservationId'];
        
        vm.loadingTab = true;        
        vm.selectedIndex = $transition$.params()['activeTab'];
        vm.activeTab = [];
        vm.activeTab[vm.selectedIndex] = true;
      
        vm.updatePath = function () {
            $state.go('loaner-reservation-edit', {activeTab: vm.selectedIndex}, {reload: false, inherit: true});
        };

        vm.clickTab = function(index) {
            vm.selectedIndex = index;
            vm.activeTab[index] = true;
            vm.updatePath();
        };

        vm.checkPhoneType = function() {
            if (vm.customer && vm.customer.phone && vm.customer.phone.length === 10) {
                messagesService.checkPhoneNumber(vm.customer.phone, vm.locationId)
                    .then((response) => {
                        vm.resolvedContract.customerPhoneType = response.type;
                    });
            } else {
                vm.resolvedContract.customerPhoneType = vm.phoneTypes.unknown;
            }
        };

        vm.enableMessaging = function (enable) {
            rcUtilService.showHideMobileMessagingPanel(enable);
        };

        function initSummary() {
            loanerService.getContract($transition$.params().locationId, $transition$.params().reservationId).then((result) => {
                if (result.contact.firstName && result.contact.lastName)
                    result.contact.fullName = result.contact.firstName + ' ' + result.contact.lastName;
                if (result.contact.firstName === 'undefined' || result.contact.firstName == null)
                    result.contact.fullName = result.contact.lastName;
                if (result.contact.lastName === 'undefined' || result.contact.lastName == null)
                    result.contact.fullName = result.contact.firstName;
               
                vm.resolvedContract = structuredClone(result.contract);

                vm.resolvedContract.duration = result.duration;
                vm.resolvedContract.invoices = result.invoices;
                vm.resolvedContract.externalCustomerId = result.externalCustomerId;
                vm.resolvedContract.externalContractId = result.externalContractId;
				vm.resolvedContract.rideProviderCredit = result.rideProviderCredit;

                vm.resolvedContract.hasSignature = result.hasSignature;
                vm.resolvedContract.appointmentId = result.appointmentId;
                vm.resolvedContract.appointmentDateTime = result.appointmentDateTime;
                vm.resolvedContract.appointmentDmsId = result.appointmentDmsId;
                vm.resolvedContract.paymentStatus = result.paymentStatus;
                vm.resolvedContract.pickupTripId = result.pickupTripId;
                vm.resolvedContract.returnTripId = result.returnTripId;
                vm.resolvedContract.pickupTripInProgress = result.pickupTripInProgress;
                vm.resolvedContract.pickupTripStatus = result.pickupTripStatus;
                vm.resolvedContract.pickupTripETASeconds = result.pickupTripETASeconds;
                vm.resolvedContract.pickupTripDateTime = result.pickupTripDateTime;
                vm.resolvedContract.returnTripDateTime = result.returnTripDateTime;
                vm.resolvedContract.returnTripETASeconds = result.returnTripETASeconds;
                vm.resolvedContract.returnTripInProgress = result.returnTripInProgress;
                vm.resolvedContract.returnTripStatus = result.returnTripStatus;
                vm.resolvedContract.pickupTripCompleted = result.pickupTripCompleted;
                vm.resolvedContract.returnTripCompleted = result.returnTripCompleted;
                vm.resolvedContract.cancelledBy = result.cancelledBy;
                vm.resolvedContract.serviceVehicle = result.serviceVehicle;
                
                vm.loanerPreferences = result.loanerPreferences;
                vm.additionalDrivers = result.additionalDrivers || [];
                vm.creditCard = result.creditCard;
                // Hide the vehicle tab for TSD loaner clients
                vm.hideVehicleTab = vm.resolvedContract && vm.resolvedContract.loanerClient === SYSTEM_ENUMS.loanerManagementSystemsEnum.TSD;
                vm.contact = result.contact;
                $rootScope.$broadcast('messagePaneContactUpdate', vm.contact);
                vm.customer = {
                    email: vm.resolvedContract.customer.email,
                    firstName: vm.resolvedContract.customer.firstName,
                    lastName: vm.resolvedContract.customer.lastName,
                    phone: vm.resolvedContract.customer.phoneNumber
                };

                vm.checkPhoneType();

                vm.driversLicense = result.license || {};

                vm.driversLicense.photoFront = vm.driversLicense.photoFront || {};
                vm.driversLicense.photoBack = vm.driversLicense.photoBack || {};

                vm.insurance = result.insurance || {};
                vm.insurance.photo = vm.insurance.photo || {};

                if (result.insurance) {
                    vm.insurance.expirationDate = new Date(new moment(result.insurance.expirationDate).format('MM/DD/YYYY'));
                }

                vm.resolvedContract.loanerVehicle = vm.resolvedContract.loanerVehicle ||
                {
                    photoFront: {},
                    photoBack: {}
                };

                vm.vehicle = vm.resolvedContract.loanerVehicle;
                initAsideHeaderData();
                vm.loadingTab = false;
             });
        }
        
        
        tripService.hasMessaging(vm.locationId).then((result) => {
            vm.hasMessaging = result || false;
        });

        vm.driversLicenseSectionInvalid = function () {
            if (vm.selectedIndex !== 1 || !vm.driverLicense) return false;

            return vm.driversLicense.dlExpired ||
                vm.driversLicense.invalidDOB ||
                Object.keys(vm.driversLicense.photoFront).length === 0 ||
                Object.keys(vm.driversLicense.photoBack).length === 0 ||
                !vm.driversLicense.photoFront.fileData ||
                !vm.driversLicense.photoBack.fileData;
        };

        vm.insuranceSectionInvalid = function () {
            if (vm.selectedIndex !== 1 || !vm.insurance) return false;

            return vm.insurance.insExpired || Object.keys(vm.insurance.photo).length === 0 || !vm.insurance.photo.fileData;
        };

        vm.save = function() {
            switch (vm.selectedIndex) {
                case 1:
                    vm.saving = true;
                    loanerService.editReservation(vm.locationId, vm.reservationId, {
                        id: vm.id,
                        loaner: vm.loaner,
                        customer: vm.customer,
                        insurance: vm.insurance,
                        driversLicense: vm.driversLicense,
                        creditCard: vm.creditCard,
                        additionalDrivers: vm.additionalDrivers
                    }).then((response) => {

                        vm.driversLicense.credentialsValid = response.credentialsValid;
                        vm.driversLicense.credentialsError = response.credentialsError;

                        vm.saving = false;
                        eventAlertService.createAlert('Data Successfully Updated.');
                    });
                    break;
                case 2:
                    break;
            }
        };

        $rootScope.$on('vehicle::selected', (e, data) => {
            vm.resolvedContract.loanerVehicle = data;
        });

        function initAsideHeaderData () {
            vm.headerData = {
                customer: {
                    firstName: vm.customer.firstName,
                    lastName: vm.customer.lastName,
                    mobilePhone: vm.customer.phone
                },
                contract: vm.resolvedContract
            };
        }

        initSummary();
        
    }

})();

(function () {
    'use strict';

    LoanerReservationsAddController.$inject = ["loanerService", "repairOrderService", "SYSTEM_ENUMS", "$scope"];
    angular
        .module('redcap.loaner')
        .controller('LoanerReservationsAddController', LoanerReservationsAddController);

    function LoanerReservationsAddController(loanerService, repairOrderService, SYSTEM_ENUMS, $scope) {
        let vm = this;
        let parent_vm = $scope.$parent.vm;

        vm.loaner = {};
        vm.customer = {
            firstName: parent_vm && parent_vm.customer && parent_vm.customer.firstName,
            lastName: parent_vm && parent_vm.customer && parent_vm.customer.lastName,
            phone: parent_vm && parent_vm.customer && parent_vm.customer.mobilePhone
        };
        vm.insurance = {
            photo: {}
        };
        vm.driversLicense = {
            firstName: parent_vm && parent_vm.customer && parent_vm.customer.firstName,
            lastName: parent_vm && parent_vm.customer && parent_vm.customer.lastName,
            photoFront: {},
            photoBack: {}
        };
        vm.creditCard = {};

        vm.save = function () {
            loanerService.saveReservation(parent_vm.location.id, {
                id: vm.id,
                loaner: vm.loaner,
                customer: vm.customer,
                insurance: vm.insurance,
                driversLicense: vm.driversLicense,
                creditCard: vm.creditCard
            }).then(() => {
            });
        };
    }

})();

(function () {
    'use strict';

    LoanerContractsNewController.$inject = ["loanerService", "resolvedLocations", "repairOrderService", "SYSTEM_ENUMS", "$q"];
    angular
        .module('redcap.loaner')
        .controller('LoanerContractsNewController', LoanerContractsNewController);

    function LoanerContractsNewController(loanerService, resolvedLocations, repairOrderService, SYSTEM_ENUMS, $q) {
        let vm = this;

        vm.resolvedLocations = resolvedLocations;
        let pageSize = 25;

        vm.accordion = {
            steps: {
                chooseLocation: 1,
                chooseCustomer: 2,
                pickupDateTime: 3,
                addData: 4
            },
            selectedStep: 1
        };

        vm.locationSelected = function() {
            vm.accordion.selectedStep += 1;
        };

        if (resolvedLocations && resolvedLocations.length === 1) {
            vm.location = resolvedLocations[0];
            vm.locationSelected();
        }

        vm.billToSelected = function() {
            vm.accordion.selectedStep += 1;
        };

        vm.timeSelected = function() {
            vm.accordion.selectedStep += 1;
        };

        vm.clearSelectedLocation = function() {
            vm.location = null;
            vm.customer = null;
            vm.accordion.selectedStep = 1;
        };

        vm.clearBillTo = function () {
            vm.customer = null;
            vm.accordion.selectedStep = 2;
        };
    }

})();

(function () {
    'use strict';

    LoanerContractsListController.$inject = ["loanerService", "loanerSettingsService", "repairOrderService", "locationService", "rcLocalStorageService", "modalService", "permissions", "searchMode", "SYSTEM_ENUMS", "SAVED_SEARCHES_PLACEHOLDER", "rcUtilService", "systemService", "searchTemplateUtilService", "$filter", "$q", "$state", "$timeout"];
    angular
        .module('redcap.loaner')
        .controller('LoanerContractsListController', LoanerContractsListController);

    function LoanerContractsListController(loanerService, loanerSettingsService, repairOrderService, locationService, rcLocalStorageService, modalService,
            permissions, searchMode, SYSTEM_ENUMS, SAVED_SEARCHES_PLACEHOLDER, rcUtilService, systemService, searchTemplateUtilService, $filter, $q, $state, $timeout) {
        let vm = this;
        let searchCriteriaKey = "contractsSearchCriteriaFilters";
        let templateKey = "selectedContractSearchTemplate";

        vm.pageNumber = 0;
        vm.contracts = [];
        vm.enableLoanerPrefs = false;
        vm.enableUpchargeFee = false;
        vm.enableLarPointsUpcharge = false;
        vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
        vm.locationHasPayments = false;
        vm.locations = null;
        vm.userHasPayments = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.payments);
        vm.loanerActionsEnum = SYSTEM_ENUMS.loanerActionsEnum;
        vm.showAdvancedSearch = false;
        searchTemplateUtilService.initSearchTemplateData(vm);
        vm.isLoading = false;
        vm.searchMode = searchMode;
        vm.filterCount = 0;
        vm.filterMessage = '';

        if ($state.name !== 'loaner-contracts-list') {
            vm.searchMode = 'loaner-contracts-list';
        }

        vm.selectableViewModes = [
            {value: 'loaner-contracts-list', icon: 'library_books', text: 'Contracts', tooltip: 'Contracts List View', hideFramedIn: false},
            {value: 'loaner-vehicles-list', icon: 'drive_eta', text: 'Fleet', tooltip: 'Fleet List View', hideFramedIn: false}
        ];

        vm.listModeChanged = function() {
            vm.showAdvancedSearch = false;
            vm.setListMode(vm.searchModeIcon.value);
        };

        vm.setListMode = function (newMode) {
            loanerService.loanerListModeChanged(vm, newMode);
        };

        function setSearchModeDropdownIcon () {
            let ddIcon = $filter('filter')(vm.selectableViewModes, {value: vm.searchMode}, true);

            if (ddIcon && ddIcon.length > 0) {
                vm.searchModeIcon = ddIcon[0];
            } else {
                vm.searchModeIcon = null;
            }
        }
        
        vm.hasPayments = function () {
            return vm.locationHasPayments && vm.userHasPayments && vm.dmsConfiguration && vm.dmsConfiguration.paymentConfiguration !== null;
        };

        vm.getInvoiceStatusText = function(status) {
            return loanerService.getInvoiceStatusText(status);
        };

        vm.getPaymentStatusText = function(status) {
            return loanerService.getPaymentStatusText(status);
        };

        vm.disableActionDropdown = function (contract) {
            return loanerService.disableActionDropdown(contract);
        };

        vm.dateRangePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { vm.customTimeFrameChanged(); }
            }
        };

        vm.searchScopeText = function (statuses) {
            let text = statuses.map((status) => {
                return vm.searchStatuses.find((searchStatus) => searchStatus.id === status.id).text;
            });

            return text.join(', ');
        };

        vm.removeLoaner = function (dealerId, contract) {
            return loanerService.removeLoanerFromTrip(dealerId, contract.tripId).then((result) => {
                if (result) {
                    contract.tripId = null;
                }
            });
        };

        vm.searchStatuses = [
            {id: 1, text: 'Reserved'},
            {id: 2, text: 'Available'},
            {id: 3, text: 'Unavailable'}
        ];

        vm.searchStatusSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            externalIdProp: '',
            displayProp: 'text',
            buttonClasses: 'ellipsis-overflow'
        };

        vm.searchStatusStrings = {
            buttonDefaultText: 'All statuses'
        };

        vm.searchSStatusEvents = {
            onSelectionChanged: function () {
                vm.refreshContracts(true);
            }
        };

        let initialFilters = { 
            status: null,
            location: null,
            timeframe: 'today',
            loanerMake: null,
            customerMake: null, 
            customTimeframe: {
                startDate: moment(),
                endDate: moment()
            },
            sortBy: null,
            sortDirection: null,
            loanerAppointmentType: null,
            customerMakesFilter: null,
            loanerMakesFilter: null
        };

        let existingFilters = rcLocalStorageService.get(searchCriteriaKey) || {};
        
        vm.filters = Object.assign({}, initialFilters, existingFilters);

        if (vm.filters.customTimeframe) {
            if (vm.filters.customTimeframe.startDate && !moment.isMoment(vm.filters.customTimeframe.startDate)) {
                vm.filters.customTimeframe.startDate = moment(vm.filters.customTimeframe.startDate);
            }

            if (vm.filters.customTimeframe.endDate && !moment.isMoment(vm.filters.customTimeframe.endDate)) {
                vm.filters.customTimeframe.endDate = moment(vm.filters.customTimeframe.endDate);
            }
        }

        if (!vm.filters.timeframe) {
            vm.filters.timeframe = 'today';
        }

        vm.getStartDate = function () {
            let timeframeAdjustments = {
                'last60': -60,
                'last30': -30,
                'last7': -7,
                'yesterday': -1,
                'today': 0,
                'tomorrow': 1,
                'todayTomorrow': 0,
                'next7': 0,
                'next30': 0
            };

            if (vm.filters.timeframe === 'custom') {
                if (!vm.filters || !vm.filters.customTimeframe || !vm.filters.customTimeframe.startDate) {
                    return null;
                }

                return new moment(vm.filters.customTimeframe.startDate).format('MM/DD/YYYY');
            }

            let daysToAdd = timeframeAdjustments[vm.filters.timeframe] || 0;

            return new moment(new Date()).add(daysToAdd, 'days').startOf('day').format('MM/DD/YYYY');
        };

        vm.showCalendar = function () {
            return vm.filters.timeframe === 'custom';
        };

        vm.clearCustomTimeFrame = function () {
            vm.filters.timeframe = 'today';
            vm.clearMakesFilters();
            vm.filterChanged();
        };

        vm.getEndDate = function () {
            let timeframeAdjustments = {
                'last60': 0,
                'last30': 0,
                'last7': 0,
                'yesterday': -1,
                'today': 0,
                'tomorrow': 1,
                'todayTomorrow': 1,
                'next7': 7,
                'next30': 30,
                'next60': 60
            };

            if (vm.filters.timeframe === 'custom') {
                if (!vm.filters || !vm.filters.customTimeframe || !vm.filters.customTimeframe.endDate) {

                    return null;
                }

                return new moment(vm.filters.customTimeframe.endDate).format('MM/DD/YYYY');
            }

            let daysToAdd = timeframeAdjustments[vm.filters.timeframe] || 0;
            let endDate = new moment(new Date()).add(daysToAdd, 'days');

            if (vm.filters.timeframe === 'yesterday') {
                return endDate.endOf('day').format('MM/DD/YYYY');
            } else {
                return endDate.startOf('day').format('MM/DD/YYYY');
            }
        };

        vm.refreshContracts = function (resetPageNum) {
            let q = $q.defer();

            if (vm.isLoading) {
                q.resolve();

                return q.promise;
            }

            vm.isLoading = true;

            if (resetPageNum) {
                vm.pageNumber = 0;
                vm.contracts = [];
            }

            if (!vm.filters || !vm.filters.location || !vm.filters.location.id) {
                vm.isLoading = false;
                q.resolve();

                return q.promise;
            }

            loanerService.getContractsList({
                page: vm.pageNumber || 0,
                pageSize: (vm.filters.location.loanerConfiguration === SYSTEM_ENUMS.loanerManagementSystemsEnum.DealerWare) ? 1000 : 20,
                dealerId: vm.filters && vm.filters.location && vm.filters.location.id,
                search: vm.filters && vm.filters.search || null,
                sort: vm.filters && !vm.filters.search && vm.filters.sort || null,
                sortDirection: vm.filters && !vm.filters.search && vm.filters.sortDirection || null,
                status: vm.filters && !vm.filters.search && vm.filters.status || null,
                startDate: vm.filters && !vm.filters.search && vm.getStartDate() || null,
                endDate: vm.filters && !vm.filters.search && vm.getEndDate() || null,
                customerMake: vm.filters && !vm.filters.search && vm.filters.customerMake || null,
                loanerMake: vm.filters && !vm.filters.search && vm.filters.loanerMake || null,
                loanerAppointmentType: vm.filters && !vm.filters.search && vm.filters.loanerAppointmentType || null
            }).then((response) => {
                let returnedContracts = response.results;

                vm.totalContractsCount = response.totalReturnedResults;
                vm.filters.customerMakesFilter = response.customerMakesList;
                vm.filters.loanerMakesFilter = response.loanerMakesList;
                vm.contracts = vm.contracts.concat(returnedContracts);
                vm.canShowMore = returnedContracts && returnedContracts.length === 20;
                vm.pageNumber++;

                createFilterMessage();
            }).finally(() => {
                saveFilterSettings();
                vm.isLoading = false;
                q.resolve();
            });

            return q.promise;
        };

        vm.actionClicked = function (contract) {
            loanerService.contractActionClicked(contract, vm.filters.location);
        };

        vm.isLoanerVehiclePreferredVehicle = function (contract) {
            return contract ? loanerService.isLoanerVehiclePreferredVehicle(contract) : false;
        };

        vm.loadLoanerPreferences = function (runQueryAfter) {
            if (vm.filters.location && vm.filters.location.id) {
                loanerSettingsService.getSettings(vm.filters.location.id).then((result) => {
                    vm.enableLoanerPrefs = result.enableLoanerPreferences;
                    vm.enableUpchargeFee = result.enableUpchargeFee;
                    vm.enableLarPointsUpcharge = result.enableLarPointsUpcharge;
                    vm.loanerPrefVehicles = result.vehicles;
                    vm.loanerActions = structuredClone(SYSTEM_ENUMS.loanerActions);

                    if (vm.enableLarPointsUpcharge === false) {
                        loanerService.removePointsFromActions(vm.loanerActions);
                    }
                   
                    if (vm.hasPayments() === false) {
                        loanerService.removeCreateInvoiceFromActions(vm.loanerActions);
                    }
                    
                    if (runQueryAfter) {
                        vm.runQuery();
                    }
                });
            } else if (runQueryAfter) {
                vm.runQuery();
            }
        };

        vm.loadLocationPermissions  = function (runQueryAfter) {
            if (vm.filters.location && vm.filters.location.id) {
                locationService.hasRole(vm.filters.location.id, SYSTEM_ENUMS.permissionTypes.payments).then((result) => {
                    vm.locationHasPayments = result;
                    locationService.getLocationDMS(vm.filters.location.id).then((dmsResult) => {
                        vm.dmsConfiguration = dmsResult;
                    });
                    vm.loadLoanerPreferences(runQueryAfter);
                }, (errorResponse) => {
                    vm.locationHasPayments = false;
                    vm.loadLoanerPreferences(runQueryAfter);
                });
            }
        };

        vm.selectedLocationChanged = function () {
            vm.clearMakesFilters();
            vm.loadLocationPermissions();

            if (!vm.showAdvancedSearch) {
                vm.filterChanged();
            } 
        };

        vm.getLocations = function() {
            repairOrderService.loanerDealersForDropDown().then((result) => {
                result.forEach((location) => {
                    location.displayText = rcUtilService.formatLocationForDropdown(location);
                });

                // Remove the 'redcap' loaner configuration which doesn't exist and is really 'none'
                // not sure why we're using loaner configuration and loaner management system in diff places
                let filteredResult = result.filter(location => location.loanerConfiguration !== 1);

                vm.locations = filteredResult;

                //if only one location, show it by default
                if (vm.locations.length === 1) {
                    vm.filters.location = vm.locations[0];
                } else if (vm.filters.location && vm.filters.location.id) {
                    vm.filters.location = $filter('filter')(vm.locations, {id: vm.filters.location.id})[0];
                }

                vm.loadLocationPermissions();
                init();
            });
        };


        vm.createTripModel = function (contract, tripType) {
            if (vm.filters.location.loanerConfiguration === SYSTEM_ENUMS.loanerManagementSystemsEnum.TSDNew) {
                // TSDNew doesn't have the customer email in the contracts list, so we need to get it from the contract
                let contractId = contract.externalContractId === 0 ? contract.contractNumber : contract.externalContractId;

                return loanerService.getContract(vm.filters.location.id, contractId).then((result) => {
                    return {
                        locationId: vm.filters.location.id,
                        trans: true,
                        loaner: contract.currentState === "started" ? '1' : '0',
                        first: contract.customerFirstName,
                        last: contract.customerLastName,
                        phone: contract.customerPhone,
                        email: result.contract.customer.email,
                        loanerReservationId: contract.externalContractId,
                        systemTripTypeId: tripType,
                        year: contract.customerVehicle ? contract.customerVehicle.year : null,
                        make: contract.customerVehicle ? contract.customerVehicle.make : null,
                        model: contract.customerVehicle ? contract.customerVehicle.model : null,
                        vin: contract.customerVehicle ? contract.customerVehicle.vin : null,
                        externalConfirmationToken: contract.contractNumber
                    };
                });
            } else {
                return Promise.resolve({
                    locationId: vm.filters.location.id,
                    trans: true,
                    loaner: contract.currentState === "started" ? '1' : '0',
                    first: contract.customerFirstName,
                    last: contract.customerLastName,
                    phone: contract.customerPhone,
                    email: contract.customerEmail,
                    loanerReservationId: contract.externalContractId,
                    systemTripTypeId: tripType,
                    year: contract.customerVehicle ? contract.customerVehicle.year : null,
                    make: contract.customerVehicle ? contract.customerVehicle.make : null,
                    model: contract.customerVehicle ? contract.customerVehicle.model : null,
                    vin: contract.customerVehicle ? contract.customerVehicle.vin : null,
                    externalConfirmationToken: contract.contractNumber
                });
            }
        };

        vm.getTripModel = function (contract) {
            return vm.createTripModel(contract, 1);
        };

        vm.validateStarted = function (contract) {
            if (contract.currentState !== "started") {

                let confirmMessage = 'The selected loaner agreement is either not available or has not been started, are you sure you want to continue booking this trip?';
                let confirm = modalService.showYesNo('Please Confirm', confirmMessage, 'No', 'Yes');
                
                confirm.then((confirmed) => {
                    if (confirmed) {
                        vm.addTrip(vm.getReturnTripModel(contract));
                    } 
                });

            } else {
                vm.addTrip(vm.getReturnTripModel(contract));
            }
        };

        vm.getReturnTripModel = function(contract) {
            return vm.createTripModel(contract, 2);      
        };

        vm.addTrip = function (promise) {
            promise.then((data) => {
                $state.go('trip-add', data);
            });
        };

        vm.getLocations();

        vm.sortChanged = function (col, dir) {
            vm.filters.sortBy = col;
            vm.filters.sortDirection = dir;

            return vm.refreshContracts(true, col, dir);
        };

        vm.timeframes = [
            {text: 'Last 60 days', value: 'last60'},
            {text: 'Last 30 days', value: 'last30'},
            {text: 'Last 7 Days', value: 'last7'},
            {text: 'Yesterday', value: 'yesterday'},
            {text: 'Today', value: 'today'},
            {text: 'Tomorrow', value: 'tomorrow'},
            {text: 'Today and Tomorrow', value: 'todayTomorrow'},
            {text: 'Next 7 Days', value: 'next7'},
            {text: 'Next 30 days', value: 'next30'},
            {text: 'Next 60 days', value: 'next60'},
            {text: 'Custom Date Range', value: 'custom'}
        ];

        vm.contractStatuses = [
            {text: 'Booked', value: 'booked'},
            {text: 'Started', value: 'started'},
            {text: 'Finished', value: 'finished'}
        ];

        vm.loanerAppointmentTypes = [
            {text: 'Pickup', value: 1},
            {text: 'Dropoff', value: 2}
        ];

        vm.filterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();

                if (!vm.showAdvancedSearch) {
                    vm.runQuery();
                }
            }, 1);
        };

        vm.timeframeChanged = function () {
            vm.clearMakesFilters();

            //if custom is selected, just return we need more dates
            if (vm.filters.timeframe === 'custom') {
                $timeout(() => {
                    $('#timeframe_range').data('daterangepicker').toggle();
                }, 1);
            }

            vm.filterChanged();
        };

        vm.customTimeFrameChanged = function () {
            vm.clearMakesFilters();

            if (vm.filters.customTimeframe && vm.filters.customTimeframe.startDate && vm.filters.customTimeframe.endDate) {
                vm.filterChanged();
            }
        };

        vm.clearSearchField = function() {
            vm.clearMakesFilters();
            vm.filters.search = null;
            vm.filterChanged();
        };

        vm.statusChanged = function () {
            vm.clearMakesFilters();
            vm.filterChanged();
        };

        vm.clearMakesFilters = function () {
            vm.filters.customerMakesFilter = null;
            vm.filters.loanerMakesFilter = null;
            vm.filters.customerMake = null;
            vm.filters.loanerMake = null;
        };

        vm.searchTimeout = null;

        vm.getEstDollars = function (contract) {
            let settings = loanerService.getLoanerPreferenceSettingForVehicle(vm.loanerPrefVehicles, contract);
               
            if (settings) {
                return loanerService.calculateEstChargeInDollars(contract.duration, settings.dailyCost);
            }
        };

        vm.getEstPoints = function (contract) {
            let settings = loanerService.getLoanerPreferenceSettingForVehicle(vm.loanerPrefVehicles, contract);
               
            if (settings) {
                return loanerService.calculateEstChargeInDollars(contract.duration, settings.dailyPoints);
            }
        };

        vm.filterLoanerActions = function (contract) {
            return function (action) {

                if (action.value !== SYSTEM_ENUMS.loanerActionsEnum.CreateInvoice) {
                    return true;
                }

                if (contract.externalCustomerId) {
                    return true;
                }

                return false;
            };
        };


        vm.toggleShowSearchOptions = function () {
            vm.searchTemplateBeforeAdvancedSearch = angular.copy(vm.searchTemplateData);
            vm.filtersBeforeAdvancedSearch  = angular.copy(vm.filters);
            vm.showAdvancedSearch = !vm.showAdvancedSearch;
        };

        function updateDirtyFlag() {
            if (vm.searchTemplateData.currentSearchTemplate) {
                vm.searchTemplateData.isTemplateDirty = true;
            }
        }

        vm.runQuery = function () {
            createFilterMessage();
            vm.refreshContracts(true);
            saveFilterSettings();
        };

        vm.applyBtnClicked = function () {
            let prevLocId = vm.filtersBeforeAdvancedSearch.location?.id;
            let newLocId = vm.filters.location?.id;

            vm.searchTemplateBeforeAdvancedSearch = null;
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            rcLocalStorageService.set(templateKey, vm.searchTemplateData.currentSearchTemplate);

            if (prevLocId !== newLocId) {
                vm.loadLocationPermissions(true);
            } else {
                vm.runQuery();
            }
        };

        vm.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vm.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };

        vm.clearSearchCriteria = function () {
            vm.keywordFilter = null;
            vm.isGlobalTemplate = false;
            vm.resetFilters();
        };

        vm.resetFilters = function (linkClicked) {
            vm.templateName = null;
            vm.searchTemplateData.currentSearchTemplate = null;
            vm.searchTemplateData.savedSearchName = null;
            vm.filters.location = vm.locations.length === 1 ? vm.locations[0] : null;
            vm.filters.status = null;
            vm.filters.timeframe = 'today';
            vm.filters.customTimeframe = {
                startDate: moment(),
                endDate: moment()
            },
            vm.filters.customerMake = null;
            vm.filters.loanerMake = null;
            vm.filters.loanerAppointmentType = null;
            vm.filtersBeforeAdvancedSearch  = angular.copy(vm.filters);
            rcLocalStorageService.set(templateKey, null);
            
            if (linkClicked) {
                vm.showAdvancedSearch = false;
            }

            if (!vm.showAdvancedSearch) {
                vm.clearSearchField();
                saveFilterSettings();
                createFilterMessage();
            }
        };

        function saveFilterSettings() {     
            rcLocalStorageService.set(searchCriteriaKey, vm.filters);
        }

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vm.searchTemplateData.currentSearchTemplate.id = null;
            }

            searchTemplateUtilService.saveSearchTemplateClicked(vm, {
                selectedContractLocationId: vm.filters.location.id,
                selectedContractSearch: vm.filters.search, 
                selectedContractStatus: vm.filters.status, 
                selectedContractTimeFrame: vm.filters.timeframe, 
                selectedContractCustomTimeFrame: vm.filters.customTimeframe,
                selectedContractCustomerMake: vm.filters.customerMake,
                selectedContractLoanerMake: vm.filters.loanerMake,
                templateName: vm.searchTemplateData.savedSearchName
            }, SYSTEM_ENUMS.searchTemplateTypes.contract);
        }

        function finishLoadingTemplate() { 
            let template = vm.searchTemplateData.currentSearchTemplate.template;

            vm.filters.search = template.selectedContractSearch;
            vm.filters.status = template.selectedContractStatus;
            vm.filters.timeframe = template.selectedContractTimeFrame;
            vm.filters.customTimeframe = template.selectedContractCustomTimeFrame;
            vm.filters.customerMake = template.selectedContractCustomerMake;
            vm.filters.loanerMake = template.selectedContractLoanerMake;

            if (!vm.showAdvancedSearch) {
                vm.runQuery();
            }
        }

        vm.loadSearchTemplate = function (item, model) {
            if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                let template = item.template;
                let templateDealer = $filter('filter')(vm.locations, {id: template.selectedContractLocationId}, true);

                vm.searchTemplateData.isTemplateDirty = false;
                vm.searchTemplateData.currentSearchTemplate = item;
                rcLocalStorageService.set(templateKey, vm.searchTemplateData.currentSearchTemplate);
                vm.searchTemplateData.savedSearchName = template.templateName;
                vm.templateName = template.templateName;
                
                if (templateDealer && templateDealer.length > 0) {
                    vm.filters.location = templateDealer[0];
                }

                finishLoadingTemplate();
                        
            } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                rcLocalStorageService.set(templateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);
                vm.resetFilters();
            } else {
                rcLocalStorageService.set(templateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);

                if (!vm.showAdvancedSearch) {
                    vm.refreshContracts(true);
                }
            }
        };

        function loadSearchTemplates () {
            systemService.getSearchTemplates(SYSTEM_ENUMS.searchTemplateTypes.contract).then((templates) => {
                vm.searchTemplateData.searchTemplates = templates;
                loadLastTemplateAndFilters();
            });
        }

        function loadLastTemplateAndFilters () {
            vm.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate(templateKey);
            
            if (vm.searchTemplateData.currentSearchTemplate) {
                let searchItem = vm.searchTemplateData.searchTemplates.find((item) => { return item.template.templateName === vm.searchTemplateData.currentSearchTemplate.template.templateName; });
                
                if (searchItem) {
                    vm.loadSearchTemplate(searchItem);
                } else {
                    vm.searchTemplateData.currentSearchTemplate = null;
                    vm.refreshContracts(true);
                }
            } 
        }

        function createFilterMessage() {
            vm.filterCount = 0;
            vm.filterMessage = '';
            
            if (vm.filters.location && vm.filters.location.name) {
                vm.requiredFilterMessage = vm.filters.location.name;
                rcUtilService.buildFilterMessage('Location', vm.filters.location.name, vm, false, true, 43);
            }
            
            if (vm.filters.search) {
                rcUtilService.buildFilterMessage('Search Term', vm.filters.search, vm, false, true, 43);
            }
                   
            if (vm.filters.status) {
                rcUtilService.buildFilterMessage('Status', vm.contractStatuses.find(t => t.value === vm.filters.status).text, vm, false, true, 43);
            }
            
            if (vm.filters.timeframe) {
                rcUtilService.buildFilterMessage('Time Frame', vm.timeframes.find(t => t.value === vm.filters.timeframe).text, vm, false, true, 43);
            }
            
            if (vm.filters.customerMake) {
                rcUtilService.buildFilterMessage('Customer Make', vm.filters.customerMake, vm, false, true, 43);
            }
            
            if (vm.filters.loanerMake) {
                rcUtilService.buildFilterMessage('Loaner Make', vm.filters.loanerMake, vm, false, true, 43);
            }

            if (vm.filters.loanerAppointmentType) {
                rcUtilService.buildFilterMessage('Loaner Appt Type', vm.loanerAppointmentTypes.find(t => t.value === vm.filters.loanerAppointmentType).text, vm, false, true, 43);
            }

        }
        
        function init() {
            loadSearchTemplates();
            createFilterMessage();
            setSearchModeDropdownIcon();
            vm.runQuery();
        }  

        vm.close = function () {
            searchTemplateUtilService.advancedFilterModalClosed(vm);
        };
    }

})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.loaner')
        .component('loanerVehicleInfo', {
            templateUrl: 'app/areas/loaner/components/vehicle-info/vehicle-info.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$scope", "SYSTEM_ENUMS", "loanerSettingsService", "modalService", "loanerService", "locationService", "timeUtilService", "permissions"];
    angular
        .module('redcap.loaner')
        .component('loanerSummary', {
            templateUrl: 'app/areas/loaner/components/loaner-summary/loaner-summary.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'loanerPreferences': '<'
            }
        });

    function controller($scope,
        SYSTEM_ENUMS,
        loanerSettingsService,
        modalService,
        loanerService,
        locationService,
        timeUtilService,
        permissions) {
        this.$onInit = function() {
            let vm = this;
            let parent = $scope.$parent.$parent.$parent.$parent;

            vm.resolvedContract = vm.ngModel;
            vm.enableLoanerPrefs = false;
            vm.enableUpchargeFee = false;
            vm.enableLarPointsUpcharge = false;
            vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
            vm.customer = vm.ngModel.customer;
            vm.toLocalTimeFormat = timeUtilService.toLocalTimeFormat;
            vm.isContractStarted = vm.ngModel.isContractStarted;

            vm.locationHasPayments = false;
            vm.userHasPayments = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.payments);

            vm.validCompletedCanceled =
                !!(vm.resolvedContract.isCancelled || vm.resolvedContract.isCompleted);

            vm.getInvoiceStatusText = function(status) {
                return loanerService.getInvoiceStatusText(status);
            };

            vm.getPaymentStatusText = function(status) {
                return loanerService.getPaymentStatusText(status);
            };

            vm.disableActionDropdown = function(contract) {
                return loanerService.disableActionDropdown(contract);
            };

            vm.hasPayments = function() {
                return vm.locationHasPayments &&
                    vm.userHasPayments &&
                    vm.dmsConfiguration &&
                    vm.dmsConfiguration.paymentConfiguration !== null;
            };

            vm.getSignatureStatus = function() {
                return vm.resolvedContract && vm.resolvedContract.hasSignature
                    ? 'Complete'
                    : 'Pending';
            };

            vm.getCreditCardStatus = function() {
                return vm.resolvedContract && vm.resolvedContract.creditCard
                    ? 'Complete'
                    : 'Pending';
            };
            
            vm.tripModel = {
                locationId: parent.vmPnl.locationId,
                trans: true,
                loaner: '1',
                first: vm.ngModel.customer.firstName,
                last: vm.ngModel.customer.lastName,
                phone: vm.ngModel.customer.phoneNumber,
                email: vm.ngModel.customer.email,
                loanerReservationId: vm.ngModel.id,
                year: vm.ngModel.serviceVehicle ? vm.ngModel.serviceVehicle.year : null,
                make: vm.ngModel.serviceVehicle ? vm.ngModel.serviceVehicle.make : null,
                model: vm.ngModel.serviceVehicle ? vm.ngModel.serviceVehicle.model : null,
                vin: vm.ngModel.serviceVehicle ? vm.ngModel.serviceVehicle.vin : null,
                externalConfirmationToken: vm.ngModel.externalConfirmationToken
            };

            vm.pickupTripModel = {};
            vm.returnTripModel = {};
            angular.extend(vm.pickupTripModel, vm.tripModel, {systemTripTypeId: 1});
            angular.extend(vm.returnTripModel, vm.tripModel, {systemTripTypeId: 2});

            function loadLoanerSettings() {
                loanerSettingsService.getSettings(parent.vmPnl.locationId).then((result) => {
                    vm.enableLoanerPrefs = result.enableLoanerPreferences;
                    vm.enableUpchargeFee = result.enableUpchargeFee;
                    vm.enableLarPointsUpcharge = result.enableLarPointsUpcharge;
                    vm.loanerPrefVehicles = result.vehicles;
                    vm.loanerActions = structuredClone(SYSTEM_ENUMS.loanerActions);

                    if (vm.enableLarPointsUpcharge === false) {
                        loanerService.removePointsFromActions(vm.loanerActions);
                    }

                    if (vm.hasPayments() === false) {
                        loanerService.removeCreateInvoiceFromActions(vm.loanerActions);
                    }
                });
            }


            vm.loadLocationPermissions = function() {
                if (parent.vmPnl.locationId) {
                    locationService.hasRole(parent.vmPnl.locationId, SYSTEM_ENUMS.permissionTypes.payments).then((result) => {
                            vm.locationHasPayments = result;
                            locationService.getLocationDMS(parent.vmPnl.locationId).then((dmsResult) => {
                                vm.dmsConfiguration = dmsResult;
                            });
                            loadLoanerSettings();
                        },
                        (errorResponse) => {
                            vm.locationHasPayments = false;
                            loadLoanerSettings();
                        });
                }
            };

            vm.loadLocationPermissions();

            vm.removeLoaner = function(tripId) {
                return loanerService.removeLoanerFromTrip(parent.vmPnl.locationId, tripId).then((result) => {
                    if (result) {
                        vm.resolvedContract.pickupTripId = null;
                        vm.resolvedContract.returnTripId = null;
                    }
                });
            };

            vm.getVehicleDetails = function() {
                if (vm.resolvedContract.car) {
                    return vm.resolvedContract.car.year +
                        ' ' +
                        vm.resolvedContract.car.make +
                        ' ' +
                        vm.resolvedContract.car.model;
                }

                return "Pending";
            };

            vm.resendLink = function() {
                modalService
                    .showYesNo('Send customer link?', 'Are you sure you want to send the customer form?', 'No', 'Yes')
                    .then((result) => {
                        if (!result) return;

                        loanerService.sendCustomerReminder(parent.vmPnl.locationId, parent.vmPnl.reservationId);

                    });
            };

            vm.calcETATime = function(timeInSeconds) {
                let t = new Date();

                t.setSeconds(t.getSeconds() + timeInSeconds);

                return t;
            };

            vm.actionClicked = function() {
                loanerService.contractActionClicked(vm.resolvedContract, parent.vmPnl.dealer);
            };

            vm.isLoanerVehiclePreferredVehicle = function() {
                return loanerService.isLoanerVehiclePreferredVehicle(vm.resolvedContract, vm.loanerPreferences);
            };

            vm.getContractTotalDays = function() {
                return loanerService.getContractTotalDays(vm.resolvedContract.duration);
            };

            vm.getDailyDollars = function() {
                let settings = loanerService.getLoanerPreferenceSettingForVehicle(vm.loanerPrefVehicles,
                    vm.resolvedContract,
                    vm.loanerPreferences);

                if (settings) {
                    return settings.dailyCost;
                }

                return 0;
            };

            vm.getDailyPoints = function() {
                let settings = loanerService.getLoanerPreferenceSettingForVehicle(vm.loanerPrefVehicles,
                    vm.resolvedContract,
                    vm.loanerPreferences);

                if (settings) {
                    return settings.dailyPoints;
                }

                return 0;
            };

            vm.getEstDollars = function() {
                return loanerService.calculateEstChargeInDollars(vm.resolvedContract.duration, vm.getDailyDollars());
            };

            vm.getEstPoints = function() {
                return loanerService.calculateEstChargeInDollars(vm.resolvedContract.duration, vm.getDailyPoints());
            };
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["modalService", "$sce", "SYSTEM_ENUMS"];
    angular
        .module('redcap.loaner')
        .component('loanerInsurance', {
            templateUrl: 'app/areas/loaner/components/insurance/insurance.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'loanerClient': '<',
                'isCancelled': '<',
                'isCompleted': '<',
                'isContractStarted': '<'
            }
        });

    function controller(modalService, $sce, SYSTEM_ENUMS) {
        this.$onInit = function() {
            var vm = this;

            vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
            vm.isValidToDisable = vm.isCancelled || vm.isCompleted || vm.isContractStarted ? true : false;

            vm.validateInsExpiration = function(dateToCheck) {
                var today = moment(new Date()).format('YYYYMMDD');
                dateToCheck = moment(new Date(dateToCheck)).format('YYYYMMDD');
                if (dateToCheck <= today) {
                    vm.ngModel.insExpired = true;
                } else {
                    vm.ngModel.insExpired = false;
                }
            };

            if (vm.ngModel && vm.ngModel.expiration) {
                vm.ngModel.expiration = moment(new Date(vm.ngModel.expiration)).format('MM/DD/YYYY');
                vm.validateInsExpiration(vm.ngModel.expiration);
            }

            vm.openImage = function() {
                if (vm.isValidToDisable) {
                    modalService.showImageViewer(vm.ngModel.photo.url, 'Insurance Card');
                } else {
                    modalService.showImageViewer(vm.ngModel.photo.url,
                        'Insurance Card',
                        1,
                        null,
                        function() {
                            vm.ngModel.photo = {};
                        });
                }
            };

            vm.updateDate = function(type) {
                if (type === 'ed') {
                    vm.ngModel.expiration = vm.currentEDDay.format('MM/DD/YYYY');
                } else {
                    vm.currentEDDay = vm.ngModel.expiration;
                }
                vm.validateInsExpiration(vm.ngModel.expiration);
            };
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce", "$scope", "loanerService", "$q", "modalService", "$timeout", "$rootScope", "rcUtilService"];
    angular
        .module('redcap.loaner')
        .component('loanerVehicle', {
            templateUrl: 'app/areas/loaner/components/loaner-vehicle/loaner-vehicle.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'locationId': '<',
                'dealerCountry': '<',
                'reservationId': '<'
            }
        });

    function controller(SYSTEM_ENUMS,
        $sce,
        $scope,
        loanerService,
        $q,
        modalService,
        $timeout,
        $rootScope,
        rcUtilService) {
        this.$onInit = function() {
            let vm = this;
            let parent_vm = $scope.$parent.vm;

            vm.measurementTypes = SYSTEM_ENUMS.measurementTypes;
            vm.vehicle = vm.ngModel;
            vm.cancelPromise = null;
            vm.defaultVehicle = angular.extend({}, vm.ngModel);

            vm.searchVehicle = function() {

            };

            let pageSize = 25;

            vm.cancelPromise = null;

            vm.searchOptions = {
                width: '100%',
                dropdownAutoWidth: true,
                placeholder: 'Search (Stock #, VIN, Lic Plate)',
                minimumInputLength: 3,
                maximumSelectionLength: 1,
                allowClear: true,
                ajax: {
                    type: 'GET',
                    dataType: 'json',
                    data: function(parameters) {
                        let query = {
                            search: parameters.term,
                            page: parameters.page,
                            locationId: vm.locationId,
                            reservationId: vm.reservationId,
                            pageSize: pageSize
                        };

                        return query;
                    },
                    transport: function(params, success, failure) {
                        let data = params.data;

                        if (vm.cancelPromise) {
                            vm.cancelPromise.resolve();
                        }

                        vm.cancelPromise = $q.defer();

                        return loanerService
                            .searchVehicles(data.search, data.locationId, data.reservationId, vm.cancelPromise.promise)
                            .then((results) => {
                                success(results);
                            }).catch((err) => {
                                failure(err);
                            });
                    },
                    delay: 250,
                    processResults: function(data) {
                        return {
                            results: data
                        };
                    }
                },
                templateSelection: function(item) {
                    return item.year + ' ' + item.make + ' ' + item.model + ' (' + item.vin + ')';
                },
                templateResult: function(item) {
                    if (item.loading) {
                        return "Searching...";
                    }

                    return item.year + ' ' + item.make + ' ' + item.model + ' (' + item.vin + ')';
                }
            };

            vm.setupVehicleSelect = function() {
                $timeout(() => {
                        let element = angular.element("#vehicleselect");

                        if (element.length) {
                            element.on('select2:select',
                                (e) => {
                                    vm.vehicle = e.params.data;
                                    $rootScope.$broadcast('vehicle::selected', vm.vehicle);
                                });
                        } else {
                            vm.setupVehicleSelect();
                        }
                    },
                    100,
                    1);
            };

            vm.openImage = function(image) {
                modalService.showImageViewer(image.url, 'Loaner Issue');
            };

            vm.loadIssues = function() {
                vm.loadingIssues = true;

                loanerService.getVehicleIssues(vm.locationId, vm.vehicle.id).then((result) => {
                    vm.vehicle.issues = result;
                }).finally(() => {
                    vm.loadingIssues = false;
                });
            };

            vm.setupVehicleSelect();

            $rootScope.$on('vehicle::selected',
                () => {
                    vm.loadIssues();
                });

            if (vm.vehicle && vm.vehicle.id) {
                vm.loadIssues();
            }

            if (vm.vehicle.fuelInLiters || vm.fuelCapacity) {
                let fuelLevel = 0;

                if (vm.vehicle.fuelInLiters === null || vm.fuelCapacity === undefined) {
                    fuelLevel = 0;
                } else {
                    fuelLevel = vm.vehicle.fuelInLiters / vm.fuelCapacity * 100;
                }
                
                vm.levelFuel = rcUtilService.setFuelLevel(fuelLevel);
            }
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce", "pdf417Service", "loanerService", "modalService", "rcUtilService"];
    angular
        .module('redcap.loaner')
        .component('loanerDriversLicense', {
            templateUrl: 'app/areas/loaner/components/drivers-license/drivers-license.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'useFullName': '<',
                'isCancelled': '<',
                'isCompleted': '<',
                'isContractStarted': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce, pdf417Service, loanerService, modalService, rcUtilService) {
        this.$onInit = function () {
            var vm = this;

            vm.usStates = SYSTEM_ENUMS.usStates;
            vm.isValidToDisable = vm.isCancelled || vm.isCompleted || vm.isContractStarted ? true : false;
            vm.scanError = null;

            vm.updateDate = function (type) {
                if (type === 'dob' || type === 'dobTyped') {
                    if (type === 'dob') {
                        vm.ngModel.dateOfBirth = vm.currentDOBDay.format('MM/DD/YYYY');
                    } else {
                        vm.currentDOBDay = vm.ngModel.dateOfBirth;
                    }
                    vm.validateDOB(vm.ngModel.dateOfBirth);
                } else {
                    if (type === 'dle') {
                        vm.ngModel.expiration = vm.currentDLEDay.format('MM/DD/YYYY');
                    } else {
                        vm.currentDLEDay = vm.ngModel.expiration;
                    }
                    vm.validateDLExpiration(vm.ngModel.expiration);
                }
            };

            vm.validateDOB = function (date) {
                var validDOB = loanerService.validateDOB(date);
                if (validDOB.isValid) {
                    vm.ngModel.invalidDOB = false;
                    vm.ngModel.invalidDOBMessage = null;
                } else {
                    vm.ngModel.invalidDOB = true;
                    vm.ngModel.invalidDOBMessage = validDOB.message;
                }
            };

            vm.validateDLExpiration = function (dateToCheck) {
                var today = moment(new Date()).format('YYYYMMDD');
                dateToCheck = moment(new Date(dateToCheck)).format('YYYYMMDD');
                vm.ngModel.dlExpired = (dateToCheck <= today);
            };

            if (vm.ngModel.dateOfBirth) {
                vm.ngModel.dateOfBirth = moment(new Date(vm.ngModel.dateOfBirth)).format('MM/DD/YYYY');
                vm.validateDOB(vm.ngModel.dateOfBirth);
            }

            if (vm.ngModel.expiration) {
                vm.ngModel.expiration = moment(new Date(vm.ngModel.expiration)).format('MM/DD/YYYY');
                vm.validateDLExpiration(vm.ngModel.expiration);
            }

            vm.readBarcode = function ($model, $file, $files, $event) {
                return pdf417Service.readBarcode($files).then(function (results) {
                    var result = (results && results.length && results[0]) || {};

                    if (result.address1) vm.ngModel.addressLine1 = result.address1;
                    if (result.address2) vm.ngModel.addressLine2 = result.address2;
                    if (result.city) vm.ngModel.addressCity = result.city;
                    if (result.state) vm.ngModel.state = result.state;
                    if (result.zip) vm.ngModel.addressZip = result.zip;

                    if (vm.useFullName) {
                        if (result.firstName || result.lastName) {
                            vm.ngModel.fullName = [result.firstName || '', result.lastName || ''].join(' ').trim();
                        }
                    } else {
                        if (result.firstName) vm.ngModel.firstName = result.firstName;
                        if (result.lastName) vm.ngModel.lastName = result.lastName;
                    }

                    if (result.licenseNumber) vm.ngModel.number = result.licenseNumber;

                    if (result.expiration) {
                        vm.ngModel.expiration = moment(new Date(result.expiration)).format('MM/DD/YYYY');
                        vm.currentDLEDay = vm.ngModel.expiration;
                        vm.validateDLExpiration(vm.ngModel.expiration);
                    }

                    if (result.dateOfBirth) {
                        vm.ngModel.dateOfBirth = moment(new Date(result.dateOfBirth)).format('MM/DD/YYYY');
                        vm.currentDOBDay = vm.ngModel.dateOfBirth;
                        vm.validateDOB(vm.ngModel.dateOfBirth);
                    }

                    vm.scanError = null;
                }).catch(function (err) {
                    rcUtilService.noBarCodeDetected(vm, err);
                });
            };


            vm.openImage = function (image, type) {
                var option = vm.ngModel;
                if (vm.isValidToDisable) {
                    modalService.showImageViewer(image.url, 'License');
                } else {
                    modalService.showImageViewer(
                        image.url,
                        'License',
                        1,
                        null,
                        function () {
                            if (type === 'front') {
                                option.photoFront = {};
                            } else {
                                option.photoBack = {};
                            }
                        }
                    );
                }
            };

            vm.needsControlMargin = function () {
                var photoFront = vm.ngModel.photoFront,
                    photoBack = vm.ngModel.photoBack;
                return !rcUtilService.isEmpty(photoFront.fileData) &&
                    !rcUtilService.isEmpty(photoFront.url) &&
                    !rcUtilService.isEmpty(photoBack.fileData) &&
                    !rcUtilService.isEmpty(photoBack.url);
            };
        };
    }
})();


(function () {
    'use strict';

    controller.$inject = ["modalService", "rcUtilService", "deviceDetector"];
    angular
        .module('redcap.loaner')
        .component('dragDropImage', {
            templateUrl: 'app/areas/loaner/components/drag-drop-image/drag-drop-image.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '=',
                'placeholder': '@',
                'onLoad': '&',
                'loadingText': '@',
                'errorText': '@',
                'useIcon': '<',
                'videoIcon': '<',
                'repeatContainer': '=',
                'dropReference': '=',
                'imageType': '@?',
                'ngRequired': '<',
                'allowVideo': '<',
                'nativeCameraOnly': '<',
                'isVersion2': '<',
                'useSmallButton': '<',
                'hideBtnText': '<',
                'isCancelled': '<',
                'isCompleted': '<',
                'mediaLimit': '@',
                'mediaType': '@',
                'isContractStarted': '<',
                'alwaysShowIcon': '<',
                'dealerId': '<',
                'onComplete': '&?',
                'key': '<'
            }
        });

    function controller(modalService, rcUtilService, deviceDetector) {
        this.$onInit = function () {
            let vm = this;
            let onLoadFunc = vm.onLoad && vm.onLoad();  
           
            vm.checkingForVideoCapture = false;
            vm.supportsVideoCapture = false;
            vm.buttonDisabled = true;
            vm.pattern = vm.allowVideo ? 'image/*,video/*,text/plain' : 'image/*,text/plain';
            vm.validationPattern = vm.allowVideo ? 'image/*,video/*' : 'image/*';
            vm.file = {};
            vm.ngModel = vm.ngModel || {};
            vm.file.$ngfBlobUrl = vm.ngModel.fileData || vm.ngModel.url;
            vm.ngModel.fileData = vm.ngModel.fileData || vm.ngModel.url;
            vm.ngModel.fileChanged = vm.ngModel.fileChanged || false;
            vm.file_backup = vm.file;
            vm.forCard = vm.imageType === 'insuranceFront' || vm.imageType === 'licenseFront' || vm.imageType === 'licenseBack';
            vm.options = {
                updateOn: 'change',
                allowInvalid: false,
                debounce: 0
            };

            // Determine if the camera is supported/should be used.
            if (!vm.nativeCameraOnly && (deviceDetector.isMobile() || window.serviceSuiteSettings.isTouchDevice)) {
                
                const hasMediaDevices = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
                const hasMediaRecorder = typeof MediaRecorder !== 'undefined';
 
                vm.supportsVideoCapture = hasMediaDevices && hasMediaRecorder;
            }
            
            vm.buttonDisabled = vm.isCancelled || vm.isCompleted || vm.isContractStarted;

            vm.launchCamera = function() {
                if (vm.buttonDisabled) return;

                modalService.showPhotoCapture(vm.photoCaptured, vm.mediaType, vm.mediaLimit);
            };

            vm.photoCaptured = function(blob) {
                let file = {
                    name: 'captured-photo.png',
                    type: blob.type,    
                    size: blob.size,
                    lastModified: new Date().getTime()
                };
                let fileObj = new File([blob], file.name, {type: file.type});

                vm.upload([fileObj], fileObj, [fileObj], [], [], null)
                    .then((uploadedFileData) => {
                        if (onLoadFunc) {
                            onLoadFunc(vm.ngModel, uploadedFileData, [uploadedFileData], null, vm.imageType, vm.dropReference, vm.repeatContainer, true, vm.dealerId, vm.key)
                                .then((image) => {
                                    if (vm.repeatContainer) {

                                        const exists = vm.repeatContainer.some(item => item.fileData === image.fileData);
                                           
                                        if (!exists) {
                                            vm.repeatContainer.push(structuredClone(image));
                                        }
                                    }

                                    if (vm.onComplete) vm.onComplete()(image);

                                    vm.ngModel = {};
                                })
                                .catch((error) => {
                                    console.error('Error in onLoadFunc after upload: ', error);
                                });
                        }
                    })
                    .catch((uploadError) => {
                        console.error('Error during upload: ', uploadError);
                    });
            };

            vm.upload = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
                return new Promise((resolve, reject) => {
                    if (!$file) {
                        vm.file = vm.file_backup;
                        reject('No file to upload');
                        
                        return;
                    }
            
                    vm.file_backup = $file;
                    let reader = new FileReader();
                    
                    reader.readAsDataURL($file);

                    reader.onload = () => {
                        vm.ngModel.errorMessage = null;
                        vm.ngModel.fileChanged = true;

                        if (onLoadFunc) {
                            vm.isLoading = true;
            
                            try {
                                vm.ngModel.fileData = reader.result;
                                let result = onLoadFunc(vm.ngModel, $file, $files, $event, vm.imageType, vm.dropReference, vm.repeatContainer, false, vm.dealerId, vm.key);
                                
                                if (result && result.catch) {
                                    result.catch((ex) => {
                                        vm.isLoading = false;
                                        vm.ngModel.errorMessage = vm.errorText;
                                        vm.ngModel.hasError = true;
                                        vm.ngModel.fileData = null;
                                        vm.ngModel.exception = ex;
                                        reject(ex);
                                    });
                                }
            
                                if (result && result.finally) {
                                    result.finally(() => {
                                        vm.isLoading = false;
                                    });
                                }
            
                                if (result.then && vm.isVersion2) {
                                    result.then((image) => {
                                        if (vm.repeatContainer) {
                                            const exists = vm.repeatContainer.some(item => item.fileData === image.fileData);
                                           
                                            if (!exists) {
                                                vm.repeatContainer.push(structuredClone(image));
                                            }
                                        }

                                        if (vm.onComplete) vm.onComplete()(image);
            
                                        vm.file.$ngfBlobUrl = null;
                                    });
                                } else {
                                    vm.isLoading = false;
                                    resolve(reader.result);
                                }
                            } catch (ex) {
                                vm.isLoading = false;
                                vm.ngModel.errorMessage = vm.errorText;
                                vm.ngModel.hasError = true;
                                vm.ngModel.exception = ex;
                                vm.file.$ngfBlobUrl = null;
                                reject(ex);
                            }
                        } else {
                            vm.ngModel.fileData = reader.result;
                        }
                    };
                });
            };
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.loaner')
        .component('loanerCreditCard', {
            templateUrl: 'app/areas/loaner/components/credit-card/credit-card.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'reservationId': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }

    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.loaner')
        .component('loanerCustomerInfo', {
            templateUrl: 'app/areas/loaner/components/customer-info/customer-info.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.loaner')
        .component('loanerContractDetails', {
            templateUrl: 'app/areas/loaner/components/contract-details/contract-details.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce) {
        this.$onInit = function() {
            var vm = this;
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS", "$sce", "$filter", "$timeout", "loanerService"];
    angular
        .module('redcap.loaner')
        .component('loanerAdditionalDrivers', {
            templateUrl: 'app/areas/loaner/components/additional-drivers/additional-drivers.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'isCancelled': '<',
                'isCompleted': '<',
                'isContractStarted': '<'
            }
        });

    function controller(SYSTEM_ENUMS, $sce, $filter, $timeout, loanerService) {
        this.$onInit = function() {
            var vm = this;

            vm.usStates = SYSTEM_ENUMS.usStates;
            vm.isValidToDisable = vm.isCancelled || vm.isCompleted || vm.isContractStarted ? true : false;

            vm.updateHasExpiredFlag = function() {
                var expiredDrivers = $filter('filter')(vm.ngModel, { dlExpired: true, shouldDelete: false }, true);
                if (expiredDrivers && expiredDrivers.length === 0) {
                    vm.ngModel.hasExpiredDrivers = false;
                }
            };

            vm.validateDLExp = function(item) {
                var today = moment(new Date()).format('YYYYMMDD');
                var dateToCheck = moment(new Date(item.licenseExpiration)).format('YYYYMMDD');
                if (dateToCheck <= today) {
                    item.dlExpired = true;
                    vm.ngModel.hasExpiredDrivers = true;
                } else {
                    item.dlExpired = false;
                    vm.updateHasExpiredFlag();
                }
            };

            vm.validateDOB = function(item) {
                var validDOB = loanerService.validateDOB(item.dateOfBirth);
                if (validDOB.isValid) {
                    item.invalidDOB = false;
                } else {
                    item.invalidDOB = true;
                }
            };

            vm.removeClicked = function(driver) {
                driver.shouldDelete = true;
                vm.updateHasExpiredFlag();
            };

            for (var i = 0; i < vm.ngModel.length; i++) {
                var item = vm.ngModel[i];
                item.readonly = true;
                if (item.dateOfBirth) {
                    item.dateOfBirth = new Date(item.dateOfBirth);
                }

                if (item.licenseExpiration) {
                    item.licenseExpiration = new Date(item.licenseExpiration);
                }

                vm.validateDLExp(item);
            }

        }
    }
})();

(function () {
    'use strict';

    VehicleOverviewModalController.$inject = ["$scope", "liberatedAsideService", "roService", "modalService", "rcUtilService", "appointmentUtilService", "signalRService", "resolvedRo", "resolvedDealerId", "INSPECT_CONSTANTS", "SYSTEM_ENUMS", "APPOINTMENT_PHOTOTYPE"];
    angular
        .module('redcap.inspect')
        .controller('VehicleOverviewModalController', VehicleOverviewModalController);

    function VehicleOverviewModalController($scope, liberatedAsideService, roService, modalService, rcUtilService, appointmentUtilService, signalRService, resolvedRo, resolvedDealerId, INSPECT_CONSTANTS, SYSTEM_ENUMS, APPOINTMENT_PHOTOTYPE) {
        let vm = this;

        vm.ro = resolvedRo;
        vm.dealerId = resolvedDealerId;
        vm.isLoading = true;
        vm.checkInCompleted = false;
        vm.vehicleOverview = null;
        vm.newNote = '';
        vm.uploadVehicleOverviewMedia = roService.uploadMedia;
        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
        vm.pictureTypes = APPOINTMENT_PHOTOTYPE;
        vm.vehicleOverviewMediaListener = signalRService.registerVehicleOverviewMediaListener(vm.ro.id);

        vm.close = function () {
            liberatedAsideService.closeLiberatedAside();
        };

        init();

        function init() {
            if (vm.ro && vm.ro.dealerAppointmentId) {
                vm.checkInCompleted = true;
            }

            roService.getVehicleOverview(vm.dealerId, vm.ro.id).then((overview) => {
                vm.vehicleOverview = overview;

                getMediaUploadLink();
            });

            listenForMediaUpdates();
        }

        function getMediaUploadLink() {
            roService.getMediaUploadLink(vm.dealerId, vm.ro.id).then((link) => {
                vm.mediaUploadUrl = link;
                vm.isLoading = false;
            });
        }

        vm.addNote = function() {
            roService.addShopNote(vm.dealerId, vm.ro.id, vm.newNote).then((savedNote) => {
                vm.vehicleOverview.notes.unshift(savedNote);
                vm.newNote = '';
            });
        };

        vm.deleteNote = function(noteId) {
            modalService.showYesNo(
                    'Please confirm',
                    'Are you sure you want to delete this Shop Note?',
                    'No',
                    'Yes'
            ).then((deleteConfirmed) => {
                if (deleteConfirmed) {
                    roService.deleteShopNote(vm.dealerId, vm.ro.id, noteId).then((response) => {
                        rcUtilService.removeFromArray(vm.vehicleOverview.notes, (n) => n.id === noteId);
                    });
                }
            });
        };

        vm.formatMessage = function(data) {
            return rcUtilService.formatNewLineHtml(data);
        };

        vm.getMediaType = function(fileExtension) {
            return appointmentUtilService.getMediaType(fileExtension);
        };
        
        vm.mediaUploaded = function(savedMedia) {
            savedMedia.appointmentPictureType = vm.pictureTypes.vehicleOverview;
            savedMedia.heading = 'Vehicle Overview';
            savedMedia.description = savedMedia.description || 'Inspection Media';

            roService.saveMedia(vm.dealerId, vm.ro.id, [savedMedia]);
        };

        vm.openMediaModal = function (url, description, mediaType, imageId) {
            description = description || 'Inspection Media';

            if (imageId) {
                modalService.showImageViewer(url, description, mediaType, null, () => {
                    roService.deleteMedia(vm.dealerId, vm.ro.id, [imageId]).then((response) => {
                        rcUtilService.removeFromArray(vm.vehicleOverview.media, (m) => m.id === imageId);
                    });
                });
            } else {
                modalService.showImageViewer(url, description, mediaType);
            }
        };

        function listenForMediaUpdates() {
            vm.vehicleOverviewMediaListener
                .on(signalRService.events.vehicleOverviewMedia.broadcastMediaUploaded, handleMediaUploaded)
                .on(signalRService.events.vehicleOverviewMedia.broadcastMediaDeleted, handleMediaDeleted)
                .start();
        }

        function handleMediaUploaded(mediaUpload) {
            if (mediaUpload?.media && mediaUpload.lineItemId === vm.ro.id) {
                vm.vehicleOverview.media = vm.vehicleOverview.media || [];
                
                if (!vm.vehicleOverview.media.some(media => media.azureImageId === mediaUpload.media.azureImageId)) {
                    vm.vehicleOverview.media.push(mediaUpload.media);
                }
            }
        }

        function handleMediaDeleted(mediaDelete) {
            if (mediaDelete?.lineItemId === vm.ro.id && vm.vehicleOverview.media) {
                vm.vehicleOverview.media = vm.vehicleOverview.media.filter(media => media.id !== mediaDelete.mediaId);
            }
        }

        $scope.$on('$destroy', () => {
            unregisterSignalR();
        });

        function unregisterSignalR() {
            if (vm.vehicleOverviewMediaListener) {
                vm.vehicleOverviewMediaListener.disconnect();
                vm.vehicleOverviewMediaListener = null;
            }
        }
    }
})();
(function () {
    'use strict';

    MediaViewerModalController.$inject = ["$uibModalInstance", "resolvedRo", "resolvedDealerId", "resolvedLineItem", "roService"];
    angular
        .module('redcap.inspect')
        .controller('MediaViewerModalController', MediaViewerModalController);

    function MediaViewerModalController($uibModalInstance, resolvedRo, resolvedDealerId, resolvedLineItem, roService) {
        let vm = this;

        vm.ro = resolvedRo;
        vm.lineItem = resolvedLineItem;
        vm.dealerId = resolvedDealerId;
        vm.loading = false;
        
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

        vm.save = function () {
            vm.saving = true;

            roService.updateLineItemMedia(vm.dealerId, vm.ro.id, vm.lineItem).then(() => {
                $uibModalInstance.close(vm.lineItem);
                vm.saving = false;
            });
        };
    }
})();

(function () {
    'use strict';

    InspectionSummaryModalController.$inject = ["$uibModalInstance", "resolvedRo", "resolvedFromConsumer", "resolvedConsumerKey"];
    angular
        .module('redcap.inspect')
        .controller('InspectionSummaryModalController', InspectionSummaryModalController);

    function InspectionSummaryModalController($uibModalInstance, resolvedRo, resolvedFromConsumer, resolvedConsumerKey) {
        let vm = this;

        vm.ro = resolvedRo;      
        vm.fromConsumer = resolvedFromConsumer;
        vm.consumerKey = resolvedConsumerKey; 

        vm.close = function () {
            $uibModalInstance.close(false);
        };
    }
})();

(function () {
    'use strict';

    ImportPartsQuoteModalController.$inject = ["$uibModalInstance", "resolvedRo", "resolvedDealerId", "roService"];
    angular
        .module('redcap.inspect')
        .controller('ImportPartsQuoteModalController', ImportPartsQuoteModalController);

    function ImportPartsQuoteModalController($uibModalInstance, resolvedRo, resolvedDealerId,  roService) {
        let vm = this;
        let partsToImport = [];        
        const dealerId = resolvedDealerId;
        const roId = resolvedRo.id;

        init();

        function init() {
            vm.isLoading = true;

            roService.getRoLineItems(dealerId, roId).then((roLineItemResult) => {
                vm.lineItems = roLineItemResult.map(li => li.serviceOperations).flat();

                vm.lineItems.forEach((li) => {
                    li.displayLabel = getLineItemLabel(li);
                });
            }).finally(() => {
                vm.isLoading = false;
            });

            vm.lineItemDropdownSettings = {
                showCheckAll: true,
                showUncheckAll: true,
                idProperty: 'id',
                displayProp: 'displayLabel',
                buttonClasses: 'ellipsis-overflow',
                smartButtonMaxItems: 4,
                smartButtonTextConverter: function(itemText, originalItem) { return originalItem.opCode || originalItem.opCodeName; } 
            };
        }

        vm.isFormValid = function () {
            return vm.partsQuote.some((part) => part.lineItems.length);
        };
        
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

        vm.getPartsQuote = function () {
            vm.partsQuote = [];
            
            if (vm.partsQuoteSearch !== '') {
                vm.isLoading = true;
                roService.getPartsQuote(dealerId, vm.partsQuoteSearch).then((response) => {
                    vm.partsQuote = (response && response.parts) || [];

                    vm.partsQuote.forEach((part) => {
                        part.lineItems = [];
                    });
                }).catch((error) => {
                    console.error('Error fetching parts quote:', error);                        
                }).finally(() => {
                    vm.isLoading = false;
                });
            }           
        };

        vm.saveChanges = function () {
            const partsWithLines = vm.partsQuote.filter((part) => part.lineItems.length);

            if (partsWithLines.length) {  
                vm.submittedWithNoLines = false;              
                vm.saving = true;

                partsToImport = [];

                const roPartsAssociateId = resolvedRo?.partsAssociate?.id ?? null; 

                partsWithLines.forEach((part) => {
                    const partToImport = {
                        description: part.partDescription,
                        manufacturer: part.manufacturer,
                        partNumber: part.partNumber,                
                        retailPrice: part.unitListPrice,                
                        quantity: part.soldQuantity,
                        overridePrice: part.unitSalePrice,
                        total: part.unitSalePrice ? part.unitSalePrice * part.soldQuantity : part.unitListPrice * part.soldQuantity,
                        serviceOperationIds: part.lineItems.map((li) => li.id),
                        dmsPartId: part.id,
                        partsAssociateId: part.partsAssociateId ?? roPartsAssociateId
                    };

                    partsToImport.push(partToImport);
                });

                roService.addPartsBulk(dealerId, roId, partsToImport).then((addedParts) => {
                    addedParts.forEach((addedPart) => {
                        const lineItem = vm.lineItems.find((li) => li.id === addedPart.serviceOperationId);

                        lineItem.parts.push(addedPart);  
                    });

                    calculatePartsCharge().then(() => {
                        $uibModalInstance.close(true);
                    });     
                }).catch((err) => {
                    console.error('Error saving parts quote:', err);
                    vm.error = 'An error occurred while saving parts quote. Please try again.';
                }).finally(() => {
                    vm.saving = false;
                });
            } else {
                vm.submittedWithNoLines = true;
            }
        };

      function calculatePartsCharge() {
            let selectedLineItems = vm.lineItems.filter(lineItem => partsToImport.some(part => part.serviceOperationIds.includes(lineItem.id)));
            let promises = [];

            selectedLineItems.forEach((lineItem) => {
                lineItem.partsCharge = (lineItem.parts || []).reduce((sum, part) => sum + (part.quantity * part.overridePrice), 0);

                let quotePromise = roService.updatePartsQuotePricing(dealerId, roId, lineItem.id, lineItem.partsCharge);

                promises.push(quotePromise);
            });

            return Promise.all(promises);
        }

        function getLineItemLabel (lineItem) {
            let description = lineItem.description || lineItem.correctionString || '';
            
            return lineItem.opCode ? (description ? lineItem.opCode + ' : ' + description : lineItem.opCode) : description;
        }
    }
})();

(function () {
    'use strict';

    EditLineItemModalController.$inject = ["$uibModalInstance", "$rootScope", "$scope", "$timeout", "modalService", "roService", "resolvedRo", "resolvedLineItem", "resolvedDealerId", "INSPECT_CONSTANTS", "permissions", "SYSTEM_VARIABLES", "signalRService", "resolvedDefaultTab"];
    angular
        .module('redcap.inspect')
        .controller('EditLineItemModalController', EditLineItemModalController);

    function EditLineItemModalController($uibModalInstance, $rootScope, $scope, $timeout, modalService, roService, resolvedRo, resolvedLineItem, resolvedDealerId, INSPECT_CONSTANTS, permissions, SYSTEM_VARIABLES, signalRService, resolvedDefaultTab) {
        let vm = this;
        
        vm.updatingParts = false;
        vm.lineItem = _.cloneDeep(resolvedLineItem);
        vm.ro = resolvedRo;
        vm.dealerId = resolvedDealerId;
        vm.isLoading = true;
        vm.activeTab = [];
        vm.showMediaViewer = false;
        vm.originalOpCode = vm.lineItem.opCode;
        vm.authorizationStatuses = INSPECT_CONSTANTS.lineItemStatus;
        vm.soleraLogoUrl = SYSTEM_VARIABLES.soleraLogoUrl;
        vm.isTechnician = permissions.isTechnician() && !permissions.isServiceAdvisor() && !permissions.isAdminLevelUser();
        vm.inspectionMediaListener = signalRService.registerInspectionMediaListener(vm.lineItem.id);

        function init() {        
            vm.setActiveTab(resolvedDefaultTab || 0);
            roService.getMediaUploadLink(vm.dealerId, vm.ro.id, vm.lineItem.id, vm.lineItem.inspectionTask?.inspectionTaskId, vm.lineItem.inspectionTask?.name).then((link) => {
                if (link) {
                    vm.mediaUploadUrl = link;
                }
            });

            listenForMediaUpdates();
        }

        function listenForMediaUpdates() {
            vm.inspectionMediaListener
                .on(signalRService.events.inspectionMedia.broadcastMediaUploaded, handleMediaUploaded)
                .on(signalRService.events.inspectionMedia.broadcastMediaDeleted, handleMediaDeleted)
                .start();
        }

        function handleMediaUploaded(mediaUpload) {
            if (mediaUpload?.media && mediaUpload.lineItemId === vm.lineItem.id) {
                vm.lineItem.mediaItems = vm.lineItem.mediaItems || [];
                
                if (!vm.lineItem.mediaItems.some(media => media.azureImageId === mediaUpload.media.azureImageId)) {
                    vm.lineItem.mediaItems.push(mediaUpload.media);
                }
            }
        }

        function handleMediaDeleted(mediaDelete) {
            if (mediaDelete?.lineItemId === vm.lineItem.id && vm.lineItem.mediaItems) {
                vm.lineItem.mediaItems = vm.lineItem.mediaItems.filter(media => media.id !== mediaDelete.mediaId);
            }
        }

        $scope.$on('$destroy', () => {
            unregisterSignalR();
        });

        function unregisterSignalR() {
            if (vm.inspectionMediaListener) {
                vm.inspectionMediaListener.disconnect();
                vm.inspectionMediaListener = null;
            }
        }
   
        function closeModal(saveClicked) {
            resolvedLineItem.parts = vm.lineItem.parts;
            resolvedLineItem.mediaItems = vm.lineItem.mediaItems;

            if (!$scope.inputForm.$pristine) {
                modalService.showYesNo('Unsaved Changes', 'Are you sure you want to close this screen with unsaved changes? Any media or parts added or removed will not be changed, but all other changes will be lost if you choose to exit without saving.', 'Cancel', 'OK', true).then((confirmed) => {
                    if (confirmed) {
                        $uibModalInstance.close(saveClicked);
                    }
                });
            } else {
                $uibModalInstance.close(saveClicked);
            }
        }

        function saveChanges () {
            saveEstimate().then((estimatedSaved) => {
                // TODO: Put this function in the line-item-recommendation component
                roService.updateLineItem(vm.dealerId, vm.ro.id, vm.lineItem.id, vm.lineItem).then((savedLineItem) => {
                    _.merge(resolvedLineItem, savedLineItem);
                    
                    $uibModalInstance.close(savedLineItem);
                }).finally(() => {
                    vm.saving = false;                    
                });
            });
        }

        vm.save = function() {            
            vm.saving = true;
            
            if (vm.lineItem.newNote) {
                vm.lineItem.note = {message: vm.lineItem.newNote, id: null};
                vm.lineItem.newNote = '';
            }

            if (vm.lineItem.authorizationStatus === vm.authorizationStatuses.approved) {
                modalService.showYesNo('Info', 'Note this is an already approved item. Please ensure you have authorization from your customer on the updated estimate.', null, 'OK').then((result) => {                
                    if (result) {
                        saveChanges();
                    } else {
                        vm.saving = false;
                        $uibModalInstance.close(false);
                    }
                });
            } else {
                saveChanges();
            }         
        };

        // TODO: This should probably be happening inside of the line-item-recommendation component
        vm.updateMedia = function() {
            vm.saving = true;

            roService.updateLineItemMedia(vm.dealerId, vm.ro.id, vm.lineItem).then(() => {
                updateLineItemMediaCollection();
            }).finally(() => {
                vm.saving = false;
                vm.showMediaViewer = false;
            });
        };

        function updateLineItemMediaCollection() {
            if (vm.lineItem.selectedMediaItems?.selected?.length > 0) {
                vm.lineItem.mediaItems = vm.lineItem.mediaItems.concat(vm.lineItem.selectedMediaItems.selected);
            }

            if (vm.lineItem.selectedMediaItems?.deselected?.length > 0) {
                const deselectedItems = vm.lineItem.selectedMediaItems.deselected.map((media) => { return media.id; });

                vm.lineItem.mediaItems = vm.lineItem.mediaItems.filter((media) => { return !deselectedItems.includes(media.id); });
            }
        }

        // TODO: put this function in the line-item-estimate component
        function saveEstimate() {
            if (vm.isTechnician) {
                return Promise.resolve(true);
            }
            
            const estimate = buildEstimateModel();
            
            return roService.updateLineItemPricing(vm.dealerId, vm.ro.id, vm.lineItem.id, estimate);
        }

        function buildEstimateModel() {
            if (vm.lineItem.selectedOpCode && vm.originalOpCode != vm.lineItem.selectedOpCode.opCode) {
                vm.lineItem.opCode = vm.lineItem.selectedOpCode.opCode;
                vm.lineItem.opCodeDescription = vm.lineItem.selectedOpCode.text;
                vm.lineItem.mappedOpCodeId = vm.lineItem.selectedOpCode.dealerAppointmentOpCodeId;
            } else if (!vm.opCodeNotFound && vm.originalOpCode && !vm.lineItem.selectedOpCode) {
                vm.lineItem.opCode = null;
                vm.lineItem.opCodeDescription = null;
                vm.lineItem.mappedOpCodeId = null;
            } else {
                vm.lineItem.opCodeDescription = vm.lineItem.description;
            }
            
            const isManualLaborRate = vm.lineItem.pricing.isManualLaborRate || false;
        
            return {
                id: vm.lineItem.id,
                opCode: vm.lineItem.opCode,
                opCodeDescription: vm.lineItem.opCodeDescription,
                cause: vm.lineItem.cause,
                correction: vm.lineItem.correction,
                payType: vm.lineItem.selectedPayType ? vm.lineItem.selectedPayType.payType : null,
                laborMatrixId: isManualLaborRate ? null : (vm.lineItem.selectedLaborMatrix ? vm.lineItem.selectedLaborMatrix.id : null),
                customLaborRateId: isManualLaborRate ? null : (vm.lineItem.selectedFixedRate ? vm.lineItem.selectedFixedRate.id : null),
                labor: {
                    laborHours: vm.lineItem.laborHours,
                    laborRate: vm.lineItem.laborRate || 0,
                    laborCost: vm.lineItem.noLaborCharge ? 0 : vm.lineItem.laborCharge,
                    isManualLaborRate: isManualLaborRate
                },
                parts: vm.lineItem.parts,
                noLaborCharge: vm.lineItem.noLaborCharge,
                noPartsCharge: vm.lineItem.noPartsCharge,
                useFlatPrice: vm.lineItem.useFlatPrice,
                flatRetailAmount: vm.lineItem.pricing.flatRetailAmount,
                shopSupplies: vm.lineItem.pricing.shopSupplies,
                fee: vm.lineItem.pricing.fee,
                taxes: vm.lineItem.pricing.tax,
                isTaxExempt: vm.lineItem.pricing.isTaxExempt,
                isWaivingShopSupplies: vm.lineItem.pricing.waiveShopSupplies,
                notes: vm.lineItem.notes || [],
                totalPartsCost: vm.lineItem.noPartsCharge ? 0 : vm.lineItem.partsCharge,
                total: vm.lineItem.pricing.flatRetailAmount
            };
        }

        vm.setActiveTab = function (tab) {
            vm.activeTab[tab] = true;
        };
        
        vm.close = function () {
            if (vm.showMediaViewer) {
                vm.showMediaViewer = false;
            } else {
                closeModal();
            }
        };

        vm.calculateTaxes = function() {
            const estimate = buildEstimateModel();
            
            roService.calculateTax(vm.dealerId, vm.ro.id, vm.lineItem.id, estimate).then((calculatedTax) => {
                vm.lineItem.pricing.tax = calculatedTax.tax;
                vm.lineItem.pricing.shopSupplies = calculatedTax.shopSupplies;
                vm.lineItem.pricing.fee = calculatedTax.fee;
                vm.lineItem.pricing.taxesAndFees = vm.lineItem.pricing.tax + vm.lineItem.pricing.shopSupplies + vm.lineItem.pricing.fee;
                vm.lineItem.pricing.taxesPendingUpdate = false;
            }).catch(() => {
                vm.lineItem.pricing.taxesPendingUpdate = true;
            });
        };

        $rootScope.$on('searchOpCodeInitialized', (event, data) => {
            $timeout(() => {
                vm.opCodeNotFound = vm.lineItem.opCode && !vm.lineItem.selectedOpCode;

                // needed so we can check if the form is pristine later 
                // when closed.. intitializing the opcode was setting it to false
                if ($scope.inputForm) {
                    $scope.inputForm.$setPristine();
                }
            }, 500);
        });

        init();
    }
})();

(function () {
    'use strict';

    CreateRoModalController.$inject = ["$uibModalInstance", "$rootScope", "$scope", "$timeout", "ValidationService", "vehicleService", "roService", "inspectionService", "resolvedDealer", "SYSTEM_ENUMS", "$filter", "customerService", "modalService", "locationService"];
    angular
        .module('redcap.inspect')
        .controller('CreateRoModalController', CreateRoModalController);

    function CreateRoModalController($uibModalInstance, $rootScope, $scope, $timeout, ValidationService, vehicleService, roService, inspectionService, resolvedDealer, SYSTEM_ENUMS, $filter, customerService, modalService, locationService) {
        let vm = this;
        let revalidate = 'angularValidation.revalidate';
        let myValidation = new ValidationService({
            validateOnEmpty: true
        });

        vm.dealerId = resolvedDealer.id;
        vm.redcapDealer = resolvedDealer;
        vm.availForms = null;
        vm.dealerUsers = null;
        vm.usStates = SYSTEM_ENUMS.usStates;
        vm.canadianProvinces = SYSTEM_ENUMS.canadianProvinces;
        vm.supportedCountries = SYSTEM_ENUMS.supportedCountries;
        vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
        vm.customerSearch = null;
        vm.serviceAdvisors = null;

        vm.dmsRequiresHangTag = roService.dmsRequiresHangTag(vm.redcapDealer.dmsSystem);

        // todo, add properties to this
        // or create something down in services to create a new ro
        // update ng models on the form to match
        vm.ro = {
            roNumber: null,
            serviceAdvisorEmployeeId: null,
            inspectionFormId: null,
            dmsCustomerId: null,
            lastName: null,
            firstName: null,
            mobilePhone: null,
            email: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            countryShortCode: null,
            vin: null,
            odometer: null,
            odometerType: vm.odometerTypes[0],
            hangTagNumber: null,
            year: null,
            make: null,
            model: null,
            subModel: null,
            engine: null,
            style: null,
            color: null,
            licensePlate: null
        };

        vm.validation = {
            phone: function (fieldValue) {
                if (!fieldValue || fieldValue && fieldValue.length === 0) return {isValid: false, message: ''};
                fieldValue = fieldValue.replace(/\D/g, '');

                return {isValid: fieldValue.length === 10, message: '.'};
            },
            zip: function (fieldValue) {
                if (!fieldValue || fieldValue && fieldValue.length === 0) return {isValid: true, message: 'Valid'};
                fieldValue = fieldValue.replace(/\D/g, '');

                return {isValid: fieldValue.length === 5, message: '.'};
            },
            vin: function (fieldValue) {
                if (!fieldValue || fieldValue && fieldValue.length === 0) return {isValid: true, message: 'Valid'};

                return {isValid: fieldValue.length === 17, message: '.'};
            },
            firstName: function (fieldValue) {
                if (!vm.redcapDealer || vm.redcapDealer.dmsSystem != SYSTEM_ENUMS.dmsSystemEnum.DealerTrack || !vm.redcapDealer.dmsEnabled) {
                    return {isValid: true, message: ''};
                }

                return {isValid: !!fieldValue && fieldValue.trim().length > 0, message: ''};
            }
        };

        vm.countryChanged = function () {
            $timeout(() => {
                if (vm.ro.countryShortCode === 'US' && vm.ro.state) {
                    if (vm.usStates.indexOf(vm.ro.state) === -1) {
                        vm.ro.state = null;
                    }
                } else if (vm.ro.countryShortCode === 'CA' && vm.ro.state) {
                    if (vm.canadianProvinces.indexOf(vm.ro.state) === -1) {
                        vm.ro.state = null;
                    }
                }

                $scope.$broadcast(revalidate, 'zip');
            }, 1);
        };
       
        vm.checkValidVin = function() {
            let vin = vm.ro.vin;

            vm.errorDecodingVin = false;

            if (vin && vin.trim().length === 17) {
                vm.decodingVin = true;
                vm.errorDecodingVin = false;
                vehicleService.decodeVin(vm.dealerId, vin).then((response) => {
                    if (response) {
                        vm.ro.year = response.year;
                        vm.ro.make = response.makeName;
                        vm.ro.makeCode = response.makeCode;
                        vm.ro.model = response.modelName;
                        vm.ro.modelCode = response.modelCode;
                        vm.ro.subModel = response.subModelName;
                        vm.ro.engine = response.engineDescription;
                    } else {
                        vm.errorDecodingVin = true;
                    }
                })
                .finally(() => {
                    vm.decodingVin = false;
                });


            }
        };

        vm.needsMakeModelCodes = function() {
            return vm.redcapDealer && vm.redcapDealer.dmsSystem == SYSTEM_ENUMS.dmsSystemEnum.CDK && vm.redcapDealer.dmsEnabled;
        };

        vm.cancel = function () {
            $uibModalInstance.close(null);
        };

        vm.save = function (isValid) {
            vm.errorSaving = false;
            let valid = null;

            if ($scope.inputForm) {
                valid = myValidation.checkFormValidity($scope.inputForm) && isValid;
            }

            if (!valid) return;

            vm.saving = true;

            if (vm.confirmedUpdateCustomer) {
                vm.ro.isUpdateContact = true;
            }

            roService.createRepairOrder(vm.dealerId, vm.ro).then((savedRoId) => {
                if (savedRoId) {
                    vm.ro.id = savedRoId;
                    vm.ro.dealerId = vm.dealerId;

                    $uibModalInstance.close(vm.ro);                    
                } else {
                    vm.errorSaving = true;
                }
            }).catch((err) => {
                console.log(err);
                vm.errorSaving = true;
            }).finally(() => {
                vm.saving = false;
            });
        };

        vm.searchRos = function (searchString) {
            if (!vm.dealerId || !searchString || searchString.length < 3) {
                return [];
            }

            vm.searchingRos = true;
            vm.selectedRepairOrder = null;

            return roService.searchRepairOrdersFromDms(vm.dealerId, searchString);
        };

        vm.createNewRo = function () {
            vm.availableRos.push({
                displayMessage: 'Create a New Record.',
                customer: {
                    lastName: '',
                    firstName: ''
                },
                isNew: true
            });
        };

        vm.forceAddRepairOrder = function () {
            vm.selectedRepairOrder = {
                displayMessage: '[NEW REPAIR ORDER]',
                customer: {
                    firstName: '',
                    lastName: ''
                },
                isNew: true
            };

            vm.ro = {};
            vm.setNewRepairOrderDefaults();
        };

        vm.clearSelectedRo = function () {
            vm.selectedRepairOrder = null;
            vm.customerSearch = null;
            vm.vehicleSearch = null;
            vm.ro = {};

            vm.ro.isNewVehicle = null;
            vm.hasVehicleSelections = false;
            vm.availableVehicles = [];
        };

        vm.formatRepairOrderSearchResult = function (repairOrder) {
            let out = '';

            if (repairOrder) {
                if (repairOrder.isFound === false) {
                    // Customer was not found, return the message that was placed in the lastName
                    return `<div class="margin-top-md">${repairOrder.displayMessage}</div>`;
                } else if (repairOrder.isNew) {
                    return '<span class="theme-link no-underline text-normal-case">Can\'t find it?  </span><span class="theme-link create-new">Create a New Record.</span>';
                }

                let name = repairOrder.customer.lastName;
                let custId = repairOrder.customer.dmsId;
                let roNumber = repairOrder.dmsId;

                if (repairOrder.customer.isBusiness) {
                    name = repairOrder.customer.lastName;
                } else if (repairOrder.customer.firstName) {
                    name = `${repairOrder.customer.firstName} ${repairOrder.customer.lastName}`;
                }

                out = `<b>#${roNumber}</b> ${name}`;

                if (repairOrder.vehicle) {
                    let vin = !repairOrder.vehicle.vin || repairOrder.vehicle.vin === '' ? 'NO VIN' : repairOrder.vehicle.vin;

                    out += `<br>${repairOrder.vehicle.year} ${repairOrder.vehicle.make} ${repairOrder.vehicle.model} (${vin})`;
                }
            }

            return out;
        };

        vm.formatSelectedRepairOrder = function (repairOrder) {
            if (repairOrder.isNew) return '';

            return `RO# ${repairOrder.dmsId}`;
        };

        vm.roNotFound = function (searchString) {
            vm.availableRos = [{
                displayMessage: `No results match ${searchString}`,
                customer: {
                    lastName: '',
                    firstName: ''
                },
                isFound: false
            }];
        };

        vm.setNewRepairOrderDefaults = function () {
            vm.selectedRepairOrder.displayMessage = '[NEW REPAIR ORDER]';
            vm.customerSearch = null;
            vm.vehicleSearch = null;
            vm.ro.isNewCustomer = null;
            vm.ro.isNewVehicle = null;
        };

        vm.searchCustomers = function(searchString) {
            let filteredSearch = searchString.replace(/[^a-zA-Z0-9]/g, '');
            
            return roService.searchCustomers(vm.dealerId, filteredSearch);
        };

        vm.roSelected = function () {
            if (vm.selectedRepairOrder) {

                vm.ro = {};

                if (vm.selectedRepairOrder.isNew) {
                    vm.setNewRepairOrderDefaults();
                }

                vm.ro.roNumber = vm.selectedRepairOrder.dmsId;

                if (vm.selectedRepairOrder.customer) {

                    vm.customerSearch = {
                        displayText: getCustomerName(vm.selectedRepairOrder.customer),
                    };

                    vm.ro.dmsCustomerId = vm.selectedRepairOrder.customer.dmsCustomerId;
                    vm.ro.lastName = vm.selectedRepairOrder.customer.lastName;
                    vm.ro.firstName = vm.selectedRepairOrder.customer.firstName;
                    vm.ro.mobilePhone = vm.selectedRepairOrder.customer.mobilePhone;
                    vm.ro.email = vm.selectedRepairOrder.customer.email;

                    if (vm.selectedRepairOrder.customer.address) {
                        vm.ro.address1 = vm.selectedRepairOrder.customer.address.streetAddress;
                        vm.ro.address2 = vm.selectedRepairOrder.customer.address.streetAddress2;
                        vm.ro.city = vm.selectedRepairOrder.customer.address.city;
                        vm.ro.state = vm.selectedRepairOrder.customer.address.state;
                        vm.ro.zip = vm.selectedRepairOrder.customer.address.postalCode;
                        vm.ro.countryShortCode = vm.selectedRepairOrder.customer.address.countryCode;
                    }
                    
                }

                if (vm.selectedRepairOrder.vehicle) {
                    vm.ro.vin = vm.selectedRepairOrder.vehicle.vin;
                    vm.ro.odometer = vm.selectedRepairOrder.vehicle.odometer;
                    vm.ro.odometerType = vm.selectedRepairOrder.vehicle.odometerType;
                    vm.ro.year = vm.selectedRepairOrder.vehicle.year;
                    vm.ro.make = vm.selectedRepairOrder.vehicle.make;
                    vm.ro.model = vm.selectedRepairOrder.vehicle.model;
                    vm.ro.makeCode = vm.selectedRepairOrder.vehicle.makeCode;
                    vm.ro.modelCode = vm.selectedRepairOrder.vehicle.modelCode;
                    vm.ro.subModel = vm.selectedRepairOrder.vehicle.subModel;
                    vm.ro.engine = vm.selectedRepairOrder.vehicle.engine;
                    vm.ro.style = vm.selectedRepairOrder.vehicle.style;
                    vm.ro.color = vm.selectedRepairOrder.vehicle.color;
                    vm.ro.licensePlate = vm.selectedRepairOrder.vehicle.licensePlate;
                    
                    vm.vehicleSearch = {
                        displayText: vm.vehicleFormat(vm.selectedRepairOrder.vehicle)
                    };
                }
            }
        };

        vm.searchCustomers = function(searchString) {
            return roService.searchCustomers(vm.dealerId, searchString);
        };

        vm.phoneUpdated = function () {
            if (vm.ro.mobilePhone && vm.ro.mobilePhone.length === 10) {
                customerService.checkDuplicateCustomer(vm.dealerId, vm.ro.email, vm.ro.mobilePhone)
                    .then((result) => {
                        const customers = result.customers;

                    if (customers && customers.length > 0) {
                    // show modal to have user select customer.
                        modalService.showDuplicateCustomerModal(customers).then((result) => {
                            if (result) {
                                customerService.getCustomersByDMSCustNo(vm.dealerId, result.custNo).then((customerResult) => {
                                    if (customerResult) {
                                        customerResult.customerCountryShortCode = customerResult.customerCountryShortCode === 'USA' ? 'US' : customerResult.customerCountryShortCode;
                                        
                                        if (customerResult.customerVehicles && customerResult.customerVehicles.length > 0) {
                                            customerResult.vehicle = customerResult.customerVehicles[0];
                                        }

                                        vm.confirmedUpdateCustomer = false;
                                        vm.customerSelected(customerResult);
                                    }   
                                });                        
                            } else {
                                vm.confirmedUpdateCustomer = true;
                            }
                        });
                    }
                });
                
                vm.confirmedUpdateCustomer = false;
            }   
        };

        vm.requiresVehicleSearch = function () {
            switch (vm.redcapDealer.dmsSystem) {
                case SYSTEM_ENUMS.dmsSystemEnum.CDK:
                case SYSTEM_ENUMS.dmsSystemEnum.DealerTrack:
                    return true;
                default:
                    return false;
            }
        };

        vm.setVehicleSelectionsFromSearch = function () {
            if (!vm.ro.dmsCustomerId) return;

            vm.searchingVehicles = true;
            roService.getCustomerVehicles(vm.dealerId, vm.ro.dmsCustomerId).then(results => {
                vm.customerSearch.customerVehicles = results || [];
                vm.hasVehicleSelections = results.length;
                vm.availableVehicles = results;

                if (results.length === 0) {
                    vm.vehicleSearch = {
                        displayText: '[NEW VEHICLE]',
                        isNew: true
                    };
                } else {
                    if (vm.selectedRepairOrder.vehicle) {
                        vm.vehicleSearch = {
                            displayText: vm.vehicleFormat(vm.selectedRepairOrder.vehicle)
                        };
                    }
                }

                vm.customerSearch.customerVehicles.push({
                    isNew: true
                });
            })
                .finally(() => {
                    vm.searchingVehicles = false;
                });
        };

        vm.setVehicleSelectionsFromCustomer = function () {
            let customerVehicles = (vm.customerSearch && vm.customerSearch.customerVehicles) || [];

            vm.hasVehicleSelections = !!customerVehicles.length;

            if (customerVehicles.length === 0) {
                vm.vehicleSearch = {
                    displayText: '[NEW VEHICLE]',
                    isNew: true
                };
            } else {
                if (vm.selectedRepairOrder.vehicle) {
                    vm.vehicleSearch = {
                        displayText: vm.vehicleFormat(vm.selectedRepairOrder.vehicle)
                    };
                }
            }

            customerVehicles.push({
                isNew: true
            });
            vm.availableVehicles = customerVehicles;
        };

        vm.setVehicleSelections = function () {
            if (vm.requiresVehicleSearch()) {
                vm.setVehicleSelectionsFromSearch();
            } else {
                vm.setVehicleSelectionsFromCustomer();
            }

        };

        vm.vehicleFormat = function (vehicle) {
            if (!vehicle) return '';
            if (vehicle.displayText) return vehicle.displayText;
            if (vehicle.isNew) return '';

            return `${vehicle.year} ${vehicle.make} ${vehicle.model} (${vehicle.vin})`;
        };

        vm.vehicleSearchCleared = function () {
            vm.clearVehicleFields();
        };

        vm.clearVehicleFields = function() {
            vm.ro.vin = '';
            vm.ro.odometer = '';
            vm.ro.odometerType = '';
            vm.ro.year = '';
            vm.ro.make = '';
            vm.ro.model = '';
            vm.ro.makeCode = '';
            vm.ro.modelCode = '';
            vm.ro.subModel = '';
            vm.ro.engine = '';
            vm.ro.style = '';
            vm.ro.color = '';
            vm.ro.licensePlate = '';
            vm.selectedRepairOrder.vehicle = null;
            vm.ro.isNewVehicle = null;
        };

        vm.clearVehicle = function () {
            vm.clearVehicleFields();

            vm.vehicleSearch = null;
            vm.hasVehicleSelections = false;
            vm.availableVehicles = [];
        };

        vm.vehicleSelected = function (vehicle) {
            if (vehicle.isNew) {
                vm.clearVehicleFields();
                vm.ro.isNewVehicle = true;

                return;
            }

            vm.ro.isNewVehicle = false;
            vm.ro.vin = vehicle.vin;
            vm.ro.odometer = vehicle.odometer;
            vm.ro.odometerType = vehicle.odometerType;
            vm.ro.year = vehicle.year;
            vm.ro.make = vehicle.make;
            vm.ro.model = vehicle.model;
            vm.ro.makeCode = vehicle.makeCode;
            vm.ro.modelCode = vehicle.modelCode;
            vm.ro.subModel = vehicle.subModel;
            vm.ro.engine = vehicle.engine;
            vm.ro.style = vehicle.style;
            vm.ro.color = vehicle.color;
            vm.ro.licensePlate = vehicle.license;
            vm.selectedRepairOrder.vehicle = vehicle;
        };

        vm.customerSelected = function (customer) {
            vm.ro.isNewCustomer = customer.isNew || false;
            vm.ro.firstName = customer.customerFirstName;
            vm.ro.lastName = customer.customerLastName;
            vm.ro.mobilePhone = customer.customerPhone;
            vm.ro.email = customer.customerEmail;
            vm.ro.address1 = customer.customerAddress1;
            vm.ro.address2 = customer.customerAddress2;
            vm.ro.city = customer.customerCity;
            vm.ro.state = customer.customerState;
            vm.ro.zip = customer.customerZip;
            vm.ro.countryShortCode = customer.customerCountryShortCode;
            vm.ro.dmsCustomerId = customer.customerId;


            if (customer.vehicle) {
                vm.ro.vin = customer.vehicle.vin;
                vm.ro.odometer = customer.vehicle.odometer;
                vm.ro.odometerType = customer.vehicle.odometerType;
                vm.ro.year = customer.vehicle.year;
                vm.ro.make = customer.vehicle.make;
                vm.ro.model = customer.vehicle.model;
                vm.ro.makeCode = customer.vehicle.makeCode;
                vm.ro.modelCode = customer.vehicle.modelCode;
                vm.ro.subModel = customer.vehicle.subModel;
                vm.ro.engine = customer.vehicle.engine;
                vm.ro.style = customer.vehicle.style;
                vm.ro.color = customer.vehicle.color;
                vm.ro.licensePlate = customer.vehicle.license;
                vm.selectedRepairOrder.vehicle = customer.vehicle;
                vm.ro.isNewVehicle = false;
            } else {
                vm.clearVehicle();
                vm.ro.isNewVehicle = true;
            }

            vm.setVehicleSelections();
        };

        vm.newCustomer = function () {
            vm.ro.isNewCustomer = true;
            vm.ro.isNewVehicle = true;

            vm.ro.firstName = '';
            vm.ro.lastName = '';
            vm.ro.mobilePhone = '';
            vm.ro.email = '';
            vm.ro.address1 = '';
            vm.ro.address2 = '';
            vm.ro.city = '';
            vm.ro.state = null;
            vm.ro.zip = '';
            vm.ro.countryShortCode = null;
            vm.ro.dmsCustomerId = null;
            vm.ro.vin = '';
            vm.ro.odometer = '';
            vm.ro.odometerType = null;
            vm.ro.year = '';
            vm.ro.make = '';
            vm.ro.model = '';
            vm.ro.makeCode = '';
            vm.ro.modelCode = '';
            vm.ro.subModel = '';
            vm.ro.engine = '';
            vm.ro.style = '';
            vm.ro.color = '';
            vm.ro.licensePlate = '';

            vm.setVehicleSelections();
        };

        function getCustomerName(customer) {
            let nameParts = [];
            
           if (customer.customerFirstName) {
                nameParts.push(customer.customerFirstName);
            }

            if (customer.customerLastName) {
                nameParts.push(customer.customerLastName);
            }


            return nameParts.join(' ');
        }

        vm.customerSelectedFormat = function (customer) {
            if (customer.displayText) return customer.displayText;

            return getCustomerName(customer);
        };


        vm.customerFormat = function (customer) {
            if (!customer) return '';

            let name = getCustomerName(customer);

            let custId = (customer.customerId == parseFloat(customer.customerId)) // check if custNo is a number
                ? `#${customer.customerId}`
                : '';

            let phone = customer.mobilePhone ? `${$filter('tel')(customer.mobilePhone)}` : '';

            let vehicle = '';

            if (!vm.requiresVehicleSearch()) {
                vehicle = 'No Vehicle';
            }

            if (customer.vehicle) {
                let vehicleParts = [];

                customer.vehicle.year && vehicleParts.push(customer.vehicle.year);
                customer.vehicle.make && vehicleParts.push(customer.vehicle.make);
                customer.vehicle.model && vehicleParts.push(customer.vehicle.model);
                customer.vehicle.vin && vehicleParts.push(`(${customer.vehicle.vin})`);
                vehicle = vehicleParts.join(' ');
            }

            let line1 = `<b>${name}</b> ${custId} ${phone}`;
            let line2 = `${vehicle}`;

            return `<div>${line1}</div>` +
                `<div>${line2}</div>`;
        };

        vm.processCustomerResults = function (customers) {
            let ret = [];

            customers.forEach((customer) => {
                if (!customer || !customer.customerVehicles || !customer.customerVehicles.length) {
                    ret.push(customer);

                    return;
                }

                customer.customerVehicles = customer.customerVehicles.filter(vehicle => vehicle.vin);
                customer.customerVehicles.forEach(vehicle => ret.push(_.extend({}, customer, {vehicle: vehicle})));
            });

            return ret;
        };

        vm.customerSearchCleared = function() {
            vm.ro.isNewCustomer = false;
            vm.ro.firstName = '';
            vm.ro.lastName = '';
            vm.ro.mobilePhone = '';
            vm.ro.email = '';
            vm.ro.address1 = '';
            vm.ro.address2 = '';
            vm.ro.city = '';
            vm.ro.state = null;
            vm.ro.zip = '';
            vm.ro.countryShortCode = null;
            vm.ro.dmsCustomerId = '';

            vm.clearVehicle();
            vm.customerSearch = null;
        };

        function init() {
            vm.loadingForms = true;

            inspectionService.getAvailableInspectionForms(vm.dealerId).then((forms) => {
                vm.availForms = forms;
            }).finally(() => {
                vm.loadingForms = false;
            });

            vm.loadingUsers = true;
            
            locationService.getServiceAdvisors(vm.dealerId, null, true, true, false, false, true).then((serviceAdvisors) => {
                vm.serviceAdvisors = serviceAdvisors;
            }).finally(() => {
                vm.loadingUsers = false;
            });

            vm.selectedRepairOrder = {
                displayMessage: '[NEW REPAIR ORDER]',
                customer: {
                    firstName: '',
                    lastName: ''
                },
                isNew: true
            };

            vm.ro = {};
            vm.setNewRepairOrderDefaults();
        }

        init();
    }
})();

(function () {
    'use strict';

    InspectCompareToDmsController.$inject = ["$uibModalInstance", "roService", "resolvedRo", "resolvedDealerId", "SYSTEM_ENUMS"];
    angular
        .module('redcap.inspect')
        .controller('InspectCompareToDmsController', InspectCompareToDmsController);

    function InspectCompareToDmsController($uibModalInstance, roService, resolvedRo, resolvedDealerId, SYSTEM_ENUMS) {
        const vm = this;
        const dealerId = resolvedDealerId;
        const ro = resolvedRo;

        vm.loading = true;
        vm.customerName = `${ro.customer.firstName} ${ro.customer.lastName}`;
        vm.dmsId = ro.dmsRepairOrderNumber;

        roService.compareToDms(dealerId, ro.id).then(result => {
            vm.recordsToAdd = result.toAdd;
            vm.recordsToDelete = result.toRemove;

            if (ro.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.AutoMate) {
                vm.recordsToUpdate = result.toUpdate;
            }
        }).catch((exception) => {
            if (exception && exception.status === 404) {
                vm.error = 'No matching DMS record found.';
            } else {
                vm.error = exception;
            }
        }).finally(() => {
            vm.loading = false;
        });

        vm.close = function () {
            $uibModalInstance.close(null);
        };

        vm.syncDmsLines = function () {
            vm.syncing = true;
            roService.pullFromDms(dealerId, ro.id).then(() => {
                $uibModalInstance.close(true);
            }).catch((ex) => {
                vm.error = ex;
            }).finally(() => {
                vm.syncing = false;
            });
        };
    }
})();

(function () {
    'use strict';

    ChangeInspectionFormModalController.$inject = ["$uibModalInstance", "resolvedRo", "resolvedDealerId", "inspectionService", "modalService"];
    angular
        .module('redcap.inspect')
        .controller('ChangeInspectionFormModalController', ChangeInspectionFormModalController);

    function ChangeInspectionFormModalController($uibModalInstance, resolvedRo, resolvedDealerId, inspectionService, modalService) {
        let vm = this;
        let originalFormId = null;

        vm.formSelection = null;
        vm.loading = true;
        vm.selectedForm = null;
        vm.ro = resolvedRo;
        vm.dealerId = resolvedDealerId;        
        
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

        vm.canSave = function () {
            return vm.selectedForm && vm.selectedForm.id !== vm.ro.inspectionForm?.id;
        };

        vm.save = function () {            
            vm.saving = true;

            inspectionService.changeInspectionForm(vm.dealerId, vm.ro.id, vm.selectedForm.id).then((result) => {
                vm.ro.inspectionForm = vm.selectedForm;
                
                $uibModalInstance.close(vm.selectedForm);
            }).finally(() => {
                vm.saving = false;
            });           
        };
       
        vm.onFormChange = function (newForm) {
            if (!newForm || newForm.id === originalFormId) {
                vm.selectedForm = newForm;

                return;
            }

            let confirm = modalService.showYesNo(
                'Confirm Form Change',
                'Changing the inspection form will clear all current inspection inputs. Any recommendations or services already added will remain in the RO.',
                'Cancel',
                'Continue',
                false
            );

            confirm.then((isConfirmed) => {
                if (isConfirmed) {
                    vm.selectedForm = newForm;
                } else {
                    vm.formSelection = vm.selectedForm;
                }
            });
        };
   
        function init() {
            inspectionService.getAvailableInspectionForms(vm.dealerId).then((forms) => {
                vm.availForms = forms;

                if (vm.ro.inspectionForm) {
                    vm.selectedForm = vm.availForms.find((form) => { return form.id === vm.ro.inspectionForm.id; });
                
                    originalFormId = vm.selectedForm?.id;
                }

                vm.formSelection = vm.selectedForm;
            }).finally(() => {
                vm.loading = false;
            });
        }

        init();
    }
})();

(function () {
    'use strict';

    AssignToModalController.$inject = ["$uibModalInstance", "resolvedRo", "resolvedDealerId", "roService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.inspect')
        .controller('AssignToModalController', AssignToModalController);

    function AssignToModalController($uibModalInstance, resolvedRo, resolvedDealerId, roService, SYSTEM_ENUMS) {
        let vm = this;

        vm.dmsSystemEnum = SYSTEM_ENUMS.dmsSystemEnum;
        vm.ro = resolvedRo;
        vm.dealerId = resolvedDealerId;

        vm.partsAssociateFilter = function (user) {
            return userHasRole(user, SYSTEM_ENUMS.roleNames.partsAssociate);
        };
       
        vm.technicianFilter = function(user) {
            if (vm.ro.dmsSystem === vm.dmsSystemEnum.AutoMate || vm.ro.dmsSystem === vm.dmsSystemEnum.DealerTrack) {
                return userHasRole(user, 'technician') && user.employeeNumber && user.identityUserId && user.employeeNumber !== user.identityUserId;
            }

            return userHasRole(user, SYSTEM_ENUMS.roleNames.technician);
        };

        vm.advisorFilter = function(user) {
            return userHasRole(user, SYSTEM_ENUMS.roleNames.serviceAdvisor);
        };

        vm.statusChanged = function() {
            if (vm.selectedStatus?.alwaysAssignedUserId) {
                vm.assignedTo =  vm.dealerUsers.find((usr) => { return usr.id === vm.selectedStatus?.alwaysAssignedUserId; });
            }
        };

        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

        vm.save = function () {
            let assignmentModel = {
                statusId: vm.selectedStatus.id,
                serviceAdvisorId: _.get(vm.selectedAdvisor, 'id'),
                technicianId: _.get(vm.selectedTechnician, 'id'),
                assignedToUserId: vm.selectedStatus.alwaysAssignedUserId || _.get(vm.assignedTo, 'id'),
                shopFlagId: _.get(vm.selectedShopFlag, 'id'),
                partsAssociateId: _.get(vm.selectedPartsAssociate, 'id')
            };
            
            vm.saving = true;
            roService.updateRoAssignments(vm.dealerId, vm.ro.id, assignmentModel).then((result) => {

            }).finally(() => {
                $uibModalInstance.close(true);
                vm.saving = false;                
            });
        };
        
        function init() {
            vm.loading = true;
            vm.loadingShopAssociates = true;

            roService.getDealerFilterOptions(vm.dealerId).then((options) => {
                vm.statuses = options.roStatuses;
                vm.shopFlags = options.shopFlags;
                vm.dealerUsers = options.dealerUsers;

                vm.selectedStatus = vm.statuses.find((s) => { return s.id === vm.ro.statusId; });
                
                // The shape of the RO object can be different based on whether it's coming from the route sheet, or the RO detail
                let currentStatusId = _.get(vm.ro, 'status.id') || _.get(vm.ro, 'statusId');

                vm.selectedStatus = vm.statuses.find((s) => { return s.id === currentStatusId; });
                vm.selectedShopFlag = vm.shopFlags.find((s) => { return s.id === vm.ro.shopFlagId; });

                roService.getRoAssignments(vm.dealerId, vm.ro.id).then((assignments) => {
                    vm.selectedAdvisor = vm.dealerUsers.find((usr) => { return usr.id === assignments.serviceAdvisorId; });
                    vm.selectedTechnician = vm.dealerUsers.find((usr) => { return usr.id === assignments.technicianId; });
                    vm.assignedTo =  vm.dealerUsers.find((usr) => { return usr.id === assignments.assignedToId; });
                    vm.selectedPartsAssociate = vm.dealerUsers.find((usr) => { return usr.id === assignments.partsAssociateId; });

                    checkValidRoles();
                    setOriginalValues();
                }).catch((err) => {
                    console.log('Error getting assignments', err);
                }).finally(() => {
                    vm.loading = false;
                });                  
            });
        }

        function checkValidRoles() {
            if (!userHasRole(vm.selectedAdvisor, SYSTEM_ENUMS.roleNames.serviceAdvisor)) {
                vm.selectedAdvisor = null;
            }

            if (!userHasRole(vm.selectedTechnician, SYSTEM_ENUMS.roleNames.technician)) {
                vm.selectedTechnician = null;
            }

            if (!userHasRole(vm.selectedPartsAssociate, SYSTEM_ENUMS.roleNames.partsAssociate)) {
                vm.selectedPartsAssociate = null;
            }
        }
        
        function setOriginalValues() {
            vm.originalValues = {
                selectedStatus: vm.selectedStatus,
                selectedShopFlag: vm.selectedShopFlag,
                assignedTo: vm.assignedTo,
                selectedAdvisor: vm.selectedAdvisor,
                selectedTechnician: vm.selectedTechnician,
                selectedPartsAssociate: vm.selectedPartsAssociate
            };
        }
        
        function userHasRole(user, roleName) {
            return user.roles.some((r) => {
                return r.toLowerCase() === roleName.toLowerCase();
            });
        }

        init();
    }
})();

(function () {
    'use strict';

    angular.module('redcap.consumer.trip', []);
})();
(function () {
    'use strict';

    consumerTripService.$inject = ["consumerApi", "MOMENTJS_FORMAT", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.trip')
        .factory('consumerTripService', consumerTripService);

    function consumerTripService(consumerApi, MOMENTJS_FORMAT, SYSTEM_ENUMS) {

        let TRIP_BASEPATH = 'public/trip/';
            let systemTripTypes = SYSTEM_ENUMS.systemTripType;

        return {
            getTrip: getTrip,
            getDriverInfo: getDriverInfo,
            getSurvey: getSurvey,
            getProxySession: getProxySession,
            getDealerConfig: getDealerConfig,
            canAlterTrip: canAlterTrip,
            saveSurveyQuestions: saveSurveyQuestions,
            utcToLocalJSDate: utcToLocalJSDate,
            createTripEditUrl: createTripEditUrl,
            createTripCancelUrl: createTripCancelUrl,
            createTripRescheduleUrl: createTripRescheduleUrl,
            allowEditCancel: allowEditCancel
        };

        function getTrip(tripId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(TRIP_BASEPATH + tripId + keyParam);
        }

        function getDriverInfo(tripId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(TRIP_BASEPATH + tripId + '/driver' + keyParam);
        }

        function getSurvey(tripId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(TRIP_BASEPATH + tripId + '/surveys' + keyParam);
        }

        function getProxySession(tripId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(TRIP_BASEPATH + tripId + '/proxysession' + keyParam);
        }

        function saveSurveyQuestions(tripId, surveyId, responses, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.post(TRIP_BASEPATH + tripId + '/surveys/' + surveyId + keyParam, responses);
        }

        function getDealerConfig(tripId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(TRIP_BASEPATH + tripId + '/config' + keyParam);
        }

        function canAlterTrip(tripId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(TRIP_BASEPATH + tripId + '/canalter' + keyParam);
        }

        function utcToLocalJSDate(momentUtcTime) {
            return moment.utc(momentUtcTime + 'Z', MOMENTJS_FORMAT).local().toDate();
        }
        
        function createTripEditUrl(trip, baseUrl) {
            let editUrl = baseUrl;

            if (trip.systemTripTypeId === systemTripTypes.pickup || trip.systemTripTypeId === systemTripTypes.dropoff || trip.systemTripTypeId === systemTripTypes.recalls) {
                editUrl += '/book/' + trip.dealer.id + '/' + trip.systemTripTypeId + '/1/' + trip.dealerServiceOrderId + '/' + trip.tripId + '#/edit';
            } else { 
                editUrl += '/book/' + trip.dealer.id + '/v' + trip.tripTypeId + '/1/' + trip.dealerServiceOrderId + '/' + trip.tripId + '#/edit';
            }

            return editUrl;
        }

        function createTripCancelUrl(trip, baseUrl) {
            let cancelUrl = baseUrl;

            if (trip.systemTripTypeId === systemTripTypes.pickup || trip.systemTripTypeId === systemTripTypes.dropoff) {
                return null;
            } else if (!trip.tripTypeId || ((trip.systemTripTypeId === systemTripTypes.pickup || trip.systemTripTypeId === systemTripTypes.dropoff) &&
                trip.dealerServiceOrderId) && trip.isBookedByInvite) {

                cancelUrl +=  '/book/' + trip.dealer.id + '/' + trip.systemTripTypeId + '/';

                if (trip.dealerServiceOrderId) {
                    cancelUrl += trip.dealerServiceOrderId + '/';
                }

                cancelUrl += '?cancelled=1';  
            } else if (trip.systemTripTypeId === systemTripTypes.recalls) {
                cancelUrl += '/find/' + trip.routingPageId;
            } else {
                cancelUrl += '/book/' + trip.dealer.id + '/v' + trip.tripTypeId;

                let params = buildParams(trip);

                cancelUrl += params ?  '?' + params + '&cancelled=1' : '?cancelled=1';
            }


            return cancelUrl;
        }

        function createTripRescheduleUrl(trip, baseUrl) {
            let rescheduleUrl = baseUrl;

            if (trip.systemTripTypeId === systemTripTypes.testdrives || trip.systemTripTypeId === systemTripTypes.deliverSoldVehicle) {
                if (trip.tripTypeId) {
                    rescheduleUrl += '/book/' + trip.dealer.id + '/v' + trip.tripTypeId;
                } else {
                    rescheduleUrl += '/book/' + trip.dealer.id  + '/' + trip.systemTripTypeId;
                }

                rescheduleUrl += '?' + buildParams(trip) + '#/book';
            } else if (trip.systemTripTypeId === systemTripTypes.recalls) {
                if (trip.tripTypeId) {
                    rescheduleUrl += '/book/' + trip.dealer.id + '/v' + trip.tripTypeId;
                } else {
                    rescheduleUrl += '/book/' + trip.dealer.id  + '/' + trip.systemTripTypeId;
                }

                rescheduleUrl += '#/book';

            } else {
                rescheduleUrl += '/book/' + trip.dealer.id + '/' + trip.systemTripTypeId + '/' + trip.dealerServiceOrderId + '#/book';
            }

            return rescheduleUrl;
        }

        function buildParams(trip) {
            let url = '';

            if (trip.systemTripTypeId === systemTripTypes.testdrives || trip.systemTripTypeId === systemTripTypes.deliverSoldVehicle) {
                url += 'year=';
                url += trip.vehicle.year;
                url += '&make=';
                url += trip.vehicle.make;
                url += '&model=';
                url += trip.vehicle.model;
            }

            if (trip.systemTripTypeId === systemTripTypes.deliverSoldVehicle) {
                let name = trip.customerName.split(' ');

                url += '&fname=';
                url += name[0];
                name.shift();
                url += '&lname=';
                let lastName = name.join(' ').trim();

                url += lastName;
                url += '&transmission=';
                url += trip.vehicle.isManual ? '0' : '1';
                
                if (trip.vehicle.vin) {
                    url += '&vin=';
                    url += trip.vehicle.vin;
                }

                if (trip.vehicle.stockNumber) {
                    url += '&stockNum=';
                    url += trip.vehicle.stockNumber;
                }

                if (trip.vehicle2 && trip.vehicle2.year !== null) {
                    url += '&hasTradeIn=1';
                    url += '&year2=';
                    url += trip.vehicle2.year;
                    url += '&make2=';
                    url += trip.vehicle2.make;
                    url += '&model2=';
                    url += trip.vehicle2.model;
                    url += '&transmission2=';
                    url += trip.vehicle2.isManual ? '0' : '1';
                }
            }

            return url;
        }

        function getKeyParam(key, firstParam) {
            return key ? (firstParam ? '?key=' : '&key=') + key : '';
        }

        function allowEditCancel(dealerBranding, trip) {
            // If provider trip, allow editing/cancelling
            if (trip.providerRideId) {
                return true;
            }

            // Deny editing/cancelling for specific system trip types
            if (trip.systemTripTypeId === systemTripTypes.dealerTrade ||
                trip.systemTripTypeId === systemTripTypes.inventoryTransport) {
                return false;
            }

            // Allow editing/cancelling based on dealer branding config
            return dealerBranding.allowCustomerToEditTrips !== "false" && dealerBranding.allowCustomerToEditTrips !== false;
        }
    }
})();

(function () {
    'use strict';

    consumerLocationService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi", "consumerApi"];
    angular
        .module('redcap.consumer.trip')
        .factory('consumerLocationService', consumerLocationService);

    function consumerLocationService($q, $log, $filter, $http, $rootScope, rcApi, consumerApi) {

        var LOCATION_BASEPATH = 'dealers/';
        var _currentLocation;

        return {
            getTwilioNumbers: getTwilioNumbers,
            getStaticMap: getStaticMap
        };

        function getTwilioNumbers(lat, lng) {
            return rcApi.get('twilio', { lat: lat, lng: lng });
        }

        function getStaticMap(lat, lng, width, height) {
            var d = $q.defer();

            var mapParams = {
                lat: lat,
                lng: lng,
                width: width,
                height: height,
                zoom: '13'
            };

            consumerApi.get('public/maps/staticmap', mapParams)
                .then(function (result) {
                    d.resolve(result);
                }, function (error) {
                    d.resolve(null);
                }
            );

            return d.promise;
        }
    }
})();

(function () {
    'use strict';

    consumerDealerService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "consumerApi", "consumerAuthService", "MOMENTJS_FORMAT", "toastr", "mapObjectFactory"];
    angular
        .module('redcap.consumer.trip')
        .factory('consumerDealerService', consumerDealerService);

    function consumerDealerService($q, $log, $filter, $http, $rootScope, consumerApi, consumerAuthService, MOMENTJS_FORMAT, toastr, mapObjectFactory) {

        var DEALER_BASEPATH = 'public/dealer/';

        return {
            getDealer: getDealer
        };

        function getDealer(dealerId, key) {
            return consumerApi.get(DEALER_BASEPATH + dealerId);
        }
    }
})();

(function () {
    'use strict';

    consumerBookingService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "consumerApi", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.trip')
        .factory('consumerBookingService', consumerBookingService);

    function consumerBookingService($q, $log, $filter, $http, $rootScope, consumerApi, SYSTEM_ENUMS) {

        var BOOKING_BASEPATH = 'public/book';
        var roSearchCanceler = null;

        return {
            bookTrip: bookTrip,
            cancelTrip: cancelTrip,
            bookProviderRide: bookProviderRide,
            getTripTypeInstance: getTripTypeInstance,
            getServiceOrder: getServiceOrder,
            getTripWorkflow: getTripWorkflow,
            getTripRoute: getTripRoute,
            getProviderRides: getProviderRides,
            getRules: getRules,
            validateBookingRules: validateBookingRules
        };

        function getRules(pickupLat, pickupLng, dropoffLat, dropoffLng, tripTypeInstanceId, dealerId, pickupState, dropoffState, rideProviderType) {
            var url = BOOKING_BASEPATH + '/' + 'rules?pickuplat=' + pickupLat + 
            '&pickuplng=' + pickupLng + 
            '&dropofflat=' + dropoffLat + 
            '&dropofflng=' + dropoffLng + 
            '&triptypeinstanceId=' + tripTypeInstanceId + 
            '&dealerId=' + dealerId + 
            '&pickupstate=' + pickupState + 
            '&dropoffstate=' + dropoffState;

            if (rideProviderType) {
                url += '&rideProviderType=' + rideProviderType;
            }
            
            return consumerApi.get(url, null, null, buildHeaders(false));
        }

        function getTripRoute(
            pickupLat,
            pickupLng,
            dropoffLat,
            dropoffLng,
            dealerTripTypeId) {
            return consumerApi.post(BOOKING_BASEPATH + '/triproute', {
                pickup: { lat: pickupLat, lng: pickupLng },
                dropoff: { lat: dropoffLat, lng: dropoffLng },
                dealerTripTypeId: dealerTripTypeId,
                rideType: 'lyft'
            }).then(function (route) {
                return route;
            });
        }

        function getProviderRides(pickup, dropoff, tripTypeInstanceId, dealerId, systemTripTypeId, isTest) {
            var isPartsOnDemand = systemTripTypeId === SYSTEM_ENUMS.systemTripType.partsOnDemand;

            // Ensure the all the parameters are valid
            pickup.streetAddress = pickup.streetAddress || pickup.address || pickup.name;
            dropoff.streetAddress = dropoff.streetAddress || dropoff.address || dropoff.name;

            return consumerApi.post(BOOKING_BASEPATH + '/providerrides', {
                pickup: buildStop(pickup.lat, pickup.lng, pickup.streetAddress, pickup.city, pickup.state, pickup.zip),
                dropoff: buildStop(dropoff.lat, dropoff.lng, dropoff.streetAddress, dropoff.city, dropoff.state, dropoff.zip),
                triptypeinstanceId: tripTypeInstanceId,
                dealerId: dealerId
            }, buildHeaders(isTest, true, isPartsOnDemand))
                .then(function (response) {
                    var formattedRides = [];
                    if(response.estimates && !response.error) {
                        _.each(response.estimates, function (estimate) {
                            formattedRides.push({
                                displayName: estimate.displayName,
                                eta: estimate.etaSeconds < 1200 ? estimate.etaSeconds : '> 20 mins',
                                etd: estimate.estimatedSecondsToDropoff ? estimate.estimatedSecondsToDropoff : 'ETA will be updated when driver is assigned.',
                                rideType: estimate.rideType,
                                rideTypeId: estimate.rideTypeId,
                                estimatedCost: estimate.adjustedEstimatedCostCents / 100,
                                baseCost: estimate.estimatedCostCents / 100,
                                estimatedDistance: estimate.estimatedDistanceMiles,
                                estimatedDuration: estimate.estimatedDurationSeconds,
                                costToken: estimate.costToken,
                                rideProviderType: response.rideProviderType,
                                hasEtd: !!estimate.estimatedSecondsToDropoff,
                                sandboxRunId: response.sandboxRunId
                            });
                        });
    
                        return formattedRides;    
                    }                    
                });
        }

        function getTripTypeInstance(tripTypeInstanceId) {
            return consumerApi.get(BOOKING_BASEPATH + '/triptypeinstance/' + tripTypeInstanceId);
        }

        function getTripWorkflow(tripWorkflowId) {
            return consumerApi.get(BOOKING_BASEPATH + '/tripworkflow/' + tripWorkflowId);
        }

        function getServiceOrder(dealerServiceOrderId, tripWorkflowId) {
            return consumerApi.get(BOOKING_BASEPATH + '/serviceorder/' + dealerServiceOrderId + '/' + tripWorkflowId);
        }

        function bookProviderRide(dealerId,
            pickupLat,
            pickupLng,
            pickupStreetAddress,
            pickupCity,
            pickupState,
            pickupZip,
            pickupCountry, 
            dropoffLat,
            dropoffLng,
            dropoffStreetAddress,
            dropoffCity,
            dropoffState,
            dropoffZip,
            dropoffCountry, 
            rideType,
            rideTypeId,
            serviceOrderId,
            serviceAdvisorId,
            inviteUserId,
            tripId,
            isTestTrip,
            sandboxRunId,
            pickupTime,
            estimatedDistanceMiles,
            estimatedDuration,
            roNum,
            customerPhone,
            customerEmail,
            customerFirstName,
            customerLastName,
            customerNotes,
            dealerTripTypeId,
            costToken,
            estimatedCost,
            presentedCost,
            maxCost,
            systemTripType,
            startsAtDealer,
            rideProviderType,
            primetimePercentage) {
            var pickup = buildStop(pickupLat, pickupLng, pickupStreetAddress, pickupCity, pickupState, pickupZip, pickupCountry, true, systemTripType, startsAtDealer),
                dropoff = buildStop(dropoffLat, dropoffLng, dropoffStreetAddress, dropoffCity, dropoffState, dropoffZip, dropoffCountry, false, systemTripType, startsAtDealer),
                isPartsOnDemand = systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand;

            return consumerApi.post(BOOKING_BASEPATH + '/rideprovider', {
                dealerId: dealerId,
                pickup: pickup,
                dropoff: dropoff,
                rideType: rideType,
                rideTypeId: rideTypeId,
                serviceOrderId: serviceOrderId,
                inviteUserId: inviteUserId,
                tripId: tripId,
                isTestTrip: isTestTrip,
                pickupTime: pickupTime,
                estimatedDistance: estimatedDistanceMiles * 1609.34, // Convert to meters for consistency
                estimatedDuration: estimatedDuration,
                roNum: roNum,
                phone: customerPhone,
                email: customerEmail,
                firstName: customerFirstName,
                lastName: customerLastName,
                customerNotes: customerNotes,
                dealerTripTypeId: dealerTripTypeId,
                serviceAdvisorId: serviceAdvisorId,
                costToken: costToken,
                estimatedCost: estimatedCost,
                presentedCost: presentedCost,
                maxCost: maxCost,
                startsAtDealer: startsAtDealer,
                primetimePercentage: primetimePercentage,
                sandboxRunId: sandboxRunId
            }, buildHeaders(isTestTrip, true, isPartsOnDemand, rideProviderType));
        }

        function bookTrip(serviceOrder, trip) {
            var dlInfo = serviceOrder.dlInfo,
                insInfo = serviceOrder.insInfo,
                loc = trip.customerLocation,
                dropoffLoc = trip.dropoffLocation || trip.customerLocation,
                homeLoc = trip.customerHomeLocation,
                vehInfo = serviceOrder.vehicleInfo,
                veh2Info = serviceOrder.vehicle2Info,
                custInfo = serviceOrder.customerInfo,
                customerDateTime = moment(trip.customerDate + " " + trip.customerTime, "MM/DD/YYYY hh:mm A").utc(),
                pickupTime = trip.pickupTimeUtc || moment.utc(customerDateTime),
                tripBindingModel = {
                    recallId: serviceOrder.recallId || null,
                    dealerServiceOrderId: serviceOrder.id || null,
                    tripType: trip.selectedSystemTripType.id,
                    customerDescriptionOfProblem: serviceOrder.customerDescriptionOfProblem,
                    customer: {
                        firstName: custInfo.firstName,
                        lastName: custInfo.lastName,
                        companyName: custInfo.companyName,
                        phoneNumber: custInfo.phoneNumber,
                        email: custInfo.email,
                        address: homeLoc && trip.selectedSystemTripType.supportsHomeAddress ? {
                            name: 'home address',
                            streetAddress: homeLoc.streetAddress,
                            city: homeLoc.city,
                            state: homeLoc.state,
                            zip: homeLoc.zip,
                            countryShortCode: homeLoc.countryShortCode,
                            lat: homeLoc.lat,
                            lng: homeLoc.lng
                        } : null
                    },
                    customerLocation: {
                        streetAddress: loc.streetAddress,
                        city: loc.city,
                        state: loc.state,
                        zip: loc.zip,
                        countryShortCode: loc.countryShortCode,
                        lat: loc.lat,
                        lng: loc.lng
                    },
                    dealerTripTypeId: trip.dealerTripTypeInstance.id,
                    hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                    vehicle: {
                        modelId: trip.vehicleModelId || 0,
                        year: vehInfo.year,
                        make: vehInfo.make,
                        model: vehInfo.model,
                        style: vehInfo.style ? vehInfo.style.name : null,
                        vin: vehInfo.vin,
                        stockNumber: vehInfo.stockNumber
                    },
                    pickupTime: pickupTime,
                    driversLicense: dlInfo.number ? serviceOrder.dlInfo : null,
                    insurance: insInfo.policyNumber ? serviceOrder.insInfo : null,
                    tripNote: trip.tripNote,
                    transmission: vehInfo.transmission ? vehInfo.transmission.value : 0,// 0 automatic, 1 manual
                    bookingSource: "Automotive - Dealer",
                    hoursNeeded: trip.hoursNeeded,
                    serviceAdvisorId: trip.serviceAdvisor.id,
                    driverId: trip.assignedDriver ? trip.assignedDriver.id : null,
                    sendNotifications: true,
                    updateDMSRecord: serviceOrder.createDMSAppointment,
                    isTestTrip: trip.testTrip,
                    tripId: trip.id || 0,
                    bypassValidation: (trip.errors && trip.errors.length) > 0 ? true : false,
                    roNumber: serviceOrder.roNumber || null,
                    loanerContractId: serviceOrder.selectedLoanerContract ? serviceOrder.selectedLoanerContract.externalContractId : null
                };

            if (veh2Info) {
                tripBindingModel.vehicle2 = {
                    year: veh2Info.year,
                    make: veh2Info.make,
                    model: veh2Info.model
                };
            }

            if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup || 
                trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.recalls) {
                tripBindingModel.appointmentDateTime = tripBindingModel.pickupTime;
            }

            if (dlInfo && dlInfo.number) {
                tripBindingModel.driversLicense.ExpirationDate = moment(dlInfo.expirationMonth + '/01/' + dlInfo.expirationYear, "MM/DD/YYYY");
            }

            if (insInfo && insInfo.policyNumber) {
                tripBindingModel.insurance.ExpirationDate = moment(insInfo.expirationMonth + '/01/' + insInfo.expirationYear, "MM/DD/YYYY");
            }

            if (trip.selectedSystemTripType.supportsStartAtCustomer && serviceOrder.hasLoaner === 'no') {
                tripBindingModel.oneWayStartsAtDealer = trip.startsAtDealer;
            }

            return consumerApi.post(BOOKING_BASEPATH + '?dealerId=' + trip.dealerLocation.id, tripBindingModel)
                .then(function (response) {
                    return response;
                });
        }

        function cancelTrip(tripId, cancelReason, editUrl, key, isTestTrip, systemTripType, rideProviderType) {
            var isPartsOnDemand = systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand;
            return consumerApi.post('public/trip/' + tripId +  '/cancel?key=' + key, { cancelReason: cancelReason, editUrl: editUrl }, buildHeaders(isTestTrip, true, isPartsOnDemand, rideProviderType));
        }
        
        function buildHeaders(isTest, requiresUserToken, requiresDelivery, rideProviderType) {
            var headers = { isTest: !!isTest };

            if (requiresUserToken) {
                headers.requiresUserToken = true;
            }

            if (requiresDelivery) {
                headers.requiresDeliveryClient = true;
            }

            if (rideProviderType) {
                headers.rideProviderType = rideProviderType;
            }

            return headers;
        }

        function buildStop(lat, lng, streetAddress, city, state, zip, country, isPickup, systemTripType, isLyftFromDealership) {
            var destinationType = null;
            if (systemTripType === SYSTEM_ENUMS.systemTripType.lyftShuttleService || systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand) {
                if (isLyftFromDealership) {
                    destinationType = isPickup ? SYSTEM_ENUMS.destinationType.dealer : SYSTEM_ENUMS.destinationType.customer;
                } else {
                    destinationType = isPickup ? SYSTEM_ENUMS.destinationType.customer : SYSTEM_ENUMS.destinationType.dealer;
                }
            } else {
                destinationType = isPickup ?  SYSTEM_ENUMS.destinationType.customer : SYSTEM_ENUMS.destinationType.other;
            }
            
            return {
                locationType: isPickup ? SYSTEM_ENUMS.stopType.pickup : SYSTEM_ENUMS.stopType.dropoff,
                destinationType: destinationType,
                lat: lat,
                lng: lng,
                streetAddress: streetAddress,
                city: city,
                state: state,
                zip: zip,
                countryShortCode: country          
            };
        }

        function validateBookingRules(serviceOrder, theTrip) {

            var loc = theTrip.customerLocation,
                customerDateTime = moment(theTrip.customerDate + ' ' + theTrip.customerTime, 'MM/DD/YYYY hh:mm A').utc(),
                pickupTime = theTrip.pickupTimeUtc || moment.utc(customerDateTime),
                dropOffLoc = theTrip.dropoffLocation,
                vehInfo = serviceOrder.vehicleInfo,
                model = {
                    existingTripId: theTrip.id,
                    tripType: theTrip.dealerTripTypeInstance.tripTypeId,
                    customerLocation: {
                        name: theTrip.customerLocationName ? theTrip.customerLocationName : null,
                        streetAddress: loc.streetAddress,
                        city: loc.city,
                        state: loc.state,
                        zip: loc.zip,
                        countryShortCode: loc.countryShortCode,
                        lat: loc.lat,
                        lng: loc.lng
                    },
                    dropoffLocation: dropOffLoc ? {
                        streetAddress: dropOffLoc.streetAddress,
                        city: dropOffLoc.city,
                        state: dropOffLoc.state,
                        zip: dropOffLoc.zip,
                        countryShortCode: dropOffLoc.countryShortCode,
                        lat: dropOffLoc.lat,
                        lng: dropOffLoc.lng
                    } : null,
                    dealerTripTypeId: theTrip.dealerTripTypeInstance.id,
                    hoursNeeded: null,
                    hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                    pickupTime: pickupTime,
                    workFlowId: theTrip.tripWorkFlowId
                };

            if (theTrip.dealerTripTypeInstance.vehicle) {
                model.vehicleModelId = theTrip.dealerTripTypeInstance.vehicle.id;
            }

            if (theTrip.selectedSystemTripType.supportsStartAtCustomer && serviceOrder.hasLoaner === 'no' || theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dealerTrade) {
                model.oneWayStartsAtDealer = theTrip.startsAtDealer;
            }

            if (vehInfo && vehInfo.year && vehInfo.make && vehInfo.model) {
                model.vehicleYear = vehInfo.year;
                model.vehicleMake = vehInfo.make;
                model.vehicleModel = vehInfo.model;
            }

            if (theTrip.selectedSystemTripType.supportsFavoriteLocations) {
                if (theTrip.dropoffFormattedLocation) {
                    model.dropoffLocation.name = theTrip.dropoffFormattedLocation.name;
                }

                if (theTrip.customerFormattedLocation) {
                    model.customerLocation.name = theTrip.customerFormattedLocation.name;
                }
            }

            return consumerApi.post(BOOKING_BASEPATH + '/validatebookingrules?dealerId=' + theTrip.dealerLocation.id, model)
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    ConsumerTripSurveyController.$inject = ["$scope", "$state", "SYSTEM_ENUMS", "ValidationService", "consumerTripService", "rcUtilService", "resolvedTrip", "resolvedSurvey", "resolvedKey", "resolvedDealerBranding", "resolvedDealerConfig", "CONSUMER_APPS_TYPE", "HERE_MAPS_CONFIG"];
    angular
        .module('redcap.consumer.trip')
        .controller('ConsumerTripSurveyController', ConsumerTripSurveyController);

    function ConsumerTripSurveyController($scope, $state, SYSTEM_ENUMS, ValidationService, consumerTripService, rcUtilService, resolvedTrip, resolvedSurvey, resolvedKey, resolvedDealerBranding, resolvedDealerConfig, CONSUMER_APPS_TYPE, HERE_MAPS_CONFIG) {
        var vm = this;
        var currentBounds;
        
        vm.trip = resolvedTrip;
        vm.dealerBranding = resolvedDealerBranding;
        vm.isProviderTrip = !!vm.trip.providerRideId;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.tripTypeNames = SYSTEM_ENUMS.consumerTripTypeNames;

        vm.headers = rcUtilService.populateConsumerHeaders(vm.tripTypeNames);

        vm.configValues = resolvedDealerConfig.configValues;
        
        if (vm.trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.lyft) {
            vm.providerName = 'lyft';
        } else {
            vm.providerName = 'uber';
            vm.configValues.externalTermsPageURL = null;
        }

        if (vm.trip.hasSurveyResponse) {
            goToSurveyComplete();
        }

        vm.mapOptions = {
            showSegmentOverlay: false,
            fillHeight: false,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: false,
            showControls: false,
            disableLiveTracking: true,
            hideLoadingScreen: true,
            lockMapMode: true,
            trip: vm.trip
        };

        vm.surveyQuestionType = SYSTEM_ENUMS.surveyQuestionType;
        vm.survey = resolvedSurvey;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
        vm.markers = [];

        var sortedStops = _.sortBy(vm.trip.stops, function(stop) { return stop.estimatedArrival; });
        
        vm.pickup = sortedStops[0].address;
        vm.dropoff = sortedStops[1].address;
        
        function goToSurveyComplete() {
            $state.go('track', { tripId: vm.trip.id, key: resolvedKey });
        }

        vm.submitSurvey = function (valid) {
            if (!vm.submittingSurvey && new ValidationService().checkFormValidity($scope.surveyForm) && valid) {
                vm.submittingSurvey = true;

                var responses = [];

                _.each(vm.survey.questions, function(question) {
                    question.responseText = question.responseValue;

                    if (question.options && question.options.length) {
                        var selectedResponse = _.find(question.options, { optionValue: question.responseValue});
                        
                        if (selectedResponse) {
                            question.responseText = selectedResponse.optionText;
                        }
                    }

                    responses.push({
                        tripId: vm.trip.id,
                        surveyQuestionId: question.id,
                        responseValue: question.responseValue,
                        responseText: question.responseText
                    });
                });

                consumerTripService.saveSurveyQuestions(vm.trip.id, vm.survey.id, responses, resolvedKey).then(function (success) {
                    vm.submittingSurvey = false;
    
                    if (success) {
                        goToSurveyComplete();
                    }
                });
            }
        };

        $scope.$on('$destroy', function (event, next, current) {

        });
    }
})();

(function () {
    'use strict';

    ConsumerTripSummaryController.$inject = ["$state", "$q", "$window", "rcUtilService", "consumerModalService", "resolvedTrip", "resolvedKey", "resolvedDealerBranding", "resolvedDealerConfig", "consumerTripService", "tripService", "consumerLocationService", "consumerBookingService", "consumerAppointmentService", "modalService", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "HERE_MAPS_CONFIG"];
    angular
        .module('redcap.consumer.trip')
        .controller('ConsumerTripSummaryController', ConsumerTripSummaryController);

    function ConsumerTripSummaryController($state, $q, $window, rcUtilService, consumerModalService, resolvedTrip, resolvedKey, resolvedDealerBranding, resolvedDealerConfig, consumerTripService, tripService, consumerLocationService, consumerBookingService, consumerAppointmentService, modalService, SYSTEM_ENUMS, CONSUMER_APPS_TYPE, HERE_MAPS_CONFIG) {
        let vm = this;

        vm.trip = resolvedTrip;
        vm.dealerBranding = resolvedDealerBranding;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
        vm.tripTypeNames = SYSTEM_ENUMS.consumerTripTypeNames;
        vm.tripStates = SYSTEM_ENUMS.driverTripStates;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.isInFrame = consumerAppointmentService.isInFrame();
        vm.cancellingTrip = false;
        vm.configValues = resolvedDealerConfig.configValues;
        vm.isProviderTrip = !!vm.trip.providerRideId;

        // Only show the customer location name if it isn't the standard 'Name's location'
        vm.trip.customerLocationName = vm.trip.customerLocationName !== vm.trip.customerName + '\'s location' ? vm.trip.customerLocationName : null;
        vm.trip.customerExpectedTime = tripService.utcToLocalJSDate(vm.trip.customerExpectedTimeUtc);

        vm.headers = rcUtilService.populateConsumerHeaders(vm.tripTypeNames);
        
        vm.mapOptions = {
            showSegmentOverlay: false,
            fillHeight: false,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: false,
            showControls: false,
            disableLiveTracking: true,
            hideLoadingScreen: true,
            lockMapMode: true,
            trip: vm.trip
        };

        consumerLocationService.getStaticMap(vm.trip.customerLatLng.lat, vm.trip.customerLatLng.lng, 300, 175)
            .then((mapUrl) => {
                vm.customerStaticMapUrl = mapUrl;
            });

        vm.injectModelYear = function (origValue) {
            if (origValue) {
                let new1 = rcUtilService.replaceAll(origValue, '[MODEL]', vm.trip.vehicle.model);
                    let new2 = rcUtilService.replaceAll(new1, '[YEAR]', vm.trip.vehicle.year);
                    let new3 = rcUtilService.replaceAll(new2, '[MAKE]', vm.trip.vehicle.make);
                    let new4 = rcUtilService.replaceAll(new3, '[DEALERPHONE]', vm.trip.dealer.phoneNumber);

                return new4;
            } else {
                return '';
            }
        };

        vm.goToSurvey = function () {
            $window.location = '/consumer/' + vm.trip.id + '/survey?key=' + resolvedKey;
        };

        vm.allowEditCancel = function () {
            return consumerTripService.allowEditCancel(vm.dealerBranding, vm.trip);
        };

        vm.editTrip = function() {
            consumerTripService.canAlterTrip(vm.trip.id, resolvedKey)
                .then((tripStatus) => {
                    if (tripStatus.canEdit) {
                        let editUrl = consumerTripService.createTripEditUrl(vm.trip, vm.configValues.oldConsumerBaseUrl);

                        $window.location = editUrl;
                    } else {
                        modalService.showYesNo(null,
                            'We\'re sorry.  This reservation is currently in progress and cannot be edited.<br/>Please call ' + vm.trip.dealer.phoneNumber + ' for further assistance.',
                                null, 'Ok');
                    }
                });
        };

        vm.reschedule = function() {
            let rescheduleUrl = consumerTripService.createTripRescheduleUrl(vm.trip, vm.configValues.oldConsumerBaseUrl);

            $window.location = rescheduleUrl;
        };

        vm.cancelTrip = function() {
            consumerTripService.canAlterTrip(vm.trip.id, resolvedKey)
                .then((tripStatus) => {
                    if (tripStatus.canCancel) {
                        let deferred = $q.defer();

                        consumerModalService.showCancelReason(vm.configValues.requireTripCancellationReason).then(
                            (reason) => {
                                if (vm.configValues.requireTripCancellationReason) {
                                    deferred.resolve(reason);
                                } else {
                                    deferred.resolve('Customer Canceled');
                                }
                            },
                            (result) => {
                                deferred.reject();
                            }
                        ).catch(() => {
                            deferred.reject();
                        });

                        deferred.promise.then((reason) => {
                            let editUrl = consumerTripService.createTripRescheduleUrl(vm.trip, vm.configValues.oldConsumerBaseUrl);

                            vm.cancellingTrip = true;
                            consumerBookingService.cancelTrip(vm.trip.id, reason, editUrl, resolvedKey, vm.trip.isTestTrip, vm.trip.rideProviderType)
                                .then(() => {
                                    let canceledUrl = consumerTripService.createTripCancelUrl(vm.trip, vm.configValues.oldConsumerBaseUrl);

                                    if (canceledUrl) {
                                        $window.location = canceledUrl;
                                    } else {
                                        $state.reload();
                                    }
                            });
                        });
                    } else {
                        modalService.showYesNo(null,
                            'We\'re sorry.  This reservation is currently in progress and cannot be edited.<br/>Please call ' + vm.trip.dealer.phoneNumber + ' for further assistance.',
                                null, 'Ok');
                    }
                });
        };
    }
})();

(function () {
    'use strict';

    ConsumerTrackTripController.$inject = ["$scope", "$state", "$window", "rcUtilService", "SYSTEM_ENUMS", "consumerBookingService", "resolvedTrip", "consumerModalService", "resolvedKey", "resolvedDealerBranding", "resolvedDealerConfig", "HERE_MAPS_CONFIG", "consumerTripService"];
    angular
        .module('redcap.consumer.trip')
        .controller('ConsumerTrackTripController', ConsumerTrackTripController);

    function ConsumerTrackTripController($scope, $state, $window, rcUtilService, SYSTEM_ENUMS, consumerBookingService, resolvedTrip, consumerModalService, resolvedKey, resolvedDealerBranding, resolvedDealerConfig, HERE_MAPS_CONFIG, consumerTripService) {
        let vm = this;
        
        vm.tripStatus = HERE_MAPS_CONFIG.tripStatus;
        vm.trip = resolvedTrip;
        vm.trip.urlKey = resolvedKey;
        vm.tripTypeNames = SYSTEM_ENUMS.consumerTripTypeNames;
        vm.dealerBranding = resolvedDealerBranding;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;

        vm.configValues = resolvedDealerConfig.configValues;
        vm.headers = rcUtilService.populateConsumerHeaders(vm.tripTypeNames);

        if (vm.trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.lyft) {
            vm.providerName = 'lyft';
        } else {
            vm.providerName = 'uber';
            vm.configValues.externalTermsPageURL = null;
        }
        
        vm.isProviderTrip = !!vm.trip.providerRideId;
        vm.headerDescription = vm.isProviderTrip ? 'Powered by' : vm.headers[vm.trip.systemTripTypeId];
        vm.tripCanceled = vm.trip.state === SYSTEM_ENUMS.driverTripStates.canceled;
        vm.tripComplete = vm.trip.state === SYSTEM_ENUMS.driverTripStates.complete;
        
        vm.stateDescription = vm.trip.stateName;

        setCompleteMsg();        

        vm.allowEditCancel = function () {
            return consumerTripService.allowEditCancel(vm.dealerBranding, vm.trip);
        };
        
        vm.mapOptions = {
            trip: vm.trip,
            fillHeight: true,
            footerElementId: 'track-footer',
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.followMode,
            continuouslyUpdateEstimate: !vm.tripCanceled && !vm.tripComplete,
            colorBasedOnStopType: true,
            showActualRoute: false,
            lockMapMode: true,
            useImagesInPin: true,
            onlyShowEstimateOnCompleted: true,
            hideLoadingScreen: true
        };

        let sortedStops = _.sortBy(vm.trip.stops, (stop) => { return stop.estimatedArrival; });
            let startsAtDealerWorkflowIds = 
                        [SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoanerDealerFirst, 
                        SYSTEM_ENUMS.tripWorkflowTypes.servicePickupWithLoaner];
            let startsAtDealer = startsAtDealerWorkflowIds.includes(vm.trip.workflowId);
            let pickup = startsAtDealer ? sortedStops[1] : sortedStops[0];
            let dropoff = startsAtDealer ? sortedStops[2] : sortedStops[1];
            let dealerName = vm.trip.dealer.name;

        vm.loadComplete = false;

        vm.pickup = pickup.address;
        vm.dropoff = dropoff.address;        

        if (pickup.stopType === SYSTEM_ENUMS.destinationType.dealer) {
            vm.pickup.dealerName = dealerName;
        } else if (dropoff.stopType === SYSTEM_ENUMS.destinationType.dealer) {
            vm.dropoff.dealerName = dealerName;
        }

        vm.searchingForDriver = function () {
            return !vm.tripCanceled && !vm.tripComplete && (!vm.trip.driver.name || (vm.isProviderTrip && !vm.trip.lyftVehicle));
        };

        vm.hasDriver = function() {
            return !!vm.trip.driver.name;
        };

        vm.goToSurvey = function () {
            $state.go('survey', {trip: vm.trip, tripId: vm.trip.id, key: resolvedKey});
        };

        vm.noDrivers = function () {
            // TODO: Determine a more declarative way to get this data.
            return vm.trip.cancellationReason === 'We were unable to find any drivers in your area.';
        };

        vm.cancelTrip = function () {
            vm.dialogShown = true;
            
            consumerModalService.showCancelReason(vm.configValues.requireTripCancellationReason).then(
                (reason) => {
                    vm.dialogShown = false;
                    let cancelReason = 'Customer Canceled';
                        let editUrl = consumerTripService.createTripRescheduleUrl(vm.trip, vm.configValues.oldConsumerBaseUrl);

                    // get the cancel reason the customer entered    
                    if (vm.configValues.requireTripCancellationReason) {
                        cancelReason = reason;
                    } 

                    vm.cancellingTrip = true;
                    consumerBookingService.cancelTrip(vm.trip.id, cancelReason, editUrl, resolvedKey, vm.trip.isTestTrip, vm.trip.systemTripTypeId, vm.trip.rideProviderType).then((success) => {
                        vm.cancellingTrip = false;

                        if (success) {
                            setCanceledFields(cancelReason);
                        }
                    });
                },
                (result) => {
                    vm.dialogShown = false;
                }
            ).catch(() => {
                vm.dialogShown = false;
            });
            
        };

        vm.callDriver = function() {
            if (vm.isProviderTrip) {
                $window.location = 'tel:' + vm.trip.driver.mobilePhone;
            } else {
                consumerTripService.getProxySession(vm.trip.id, resolvedKey)
                    .then((response) => {
                        $window.location =  'tel:' + response.virtualPhoneNumber; 
                    });
            }
        };

        vm.messageDriver = function() {
            if (vm.isProviderTrip) {
                let smsPhone = vm.trip.driver.sMSPhone != null ? vm.trip.driver.sMSPhone : vm.trip.driver.mobilePhone;

                $window.location = 'sms:' + smsPhone;
            } else {
                consumerTripService.getProxySession(vm.trip.id, resolvedKey)
                    .then((response) => {
                        $window.location =  'sms:' + response.virtualPhoneNumber; 
                    });
            }
        };

        $scope.$on('trackingUpdateReceived', (evt, driverTrackingInformation) => {
            let driverLocation = driverTrackingInformation.driverLatestLocation;

            if (driverLocation) {
                vm.eta = driverLocation.etaSeconds || 0;
            }

            updateTripStatus(driverTrackingInformation);
            updateDriverDetails(driverTrackingInformation);  
        });

        function updateDriverDetails(driverTrackingInformation) {
            if (driverTrackingInformation.driver && (driverTrackingInformation.lyftVehicle || driverTrackingInformation.isCanceled)) {
                if (driverTrackingInformation.isCanceled) {
                    setCanceledFields(driverTrackingInformation.cancellationReason);
                } else {
                    vm.trip.driver = driverTrackingInformation.driver;
                    vm.trip.lyftVehicle = driverTrackingInformation.lyftVehicle;

                    updateTripStatus(driverTrackingInformation);                    
                }
            }
        }

        function updateTripStatus(driverTrackingInformation) {
            // Ensure that we actually have data
            if (driverTrackingInformation) {
                if (driverTrackingInformation.isCanceled || driverTrackingInformation.isComplete) {
                    if (driverTrackingInformation.isCanceled) {
                        setCanceledFields();
                    } else {
                        vm.tripComplete = true;
                        vm.trip.state = SYSTEM_ENUMS.driverTripStates.complete;
                    }
                }

                vm.stateDescription = driverTrackingInformation.stateDescription;
            }
        }

        function setCompleteMsg() {
            if (vm.trip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.partsOnDemand) {
                vm.tripCompleteMsg = {
                    title: 'Your parts have arrived',
                    body: 'Thank you for using Parts OnDemand'
                };
            } else {
                vm.tripCompleteMsg = {
                    title: vm.isProviderTrip ? 'You have arrived' : 'Your ' + vm.headers[vm.trip.systemTripTypeId] + ' is complete!',
                    body: vm.isProviderTrip ? 'Thank you for using Shuttle!' : 'Thank you for using our service!'
                };
            }
        }

        function setCanceledFields(cancellationReason) {
            vm.tripCanceled = true;
            vm.trip.cancellationReason = cancellationReason;
            vm.trip.state = SYSTEM_ENUMS.driverTripStates.canceled;
        }
    }
})();

(function () {
    'use strict';

    ConsumerInviteExpiredContoller.$inject = ["$q", "$scope", "$state", "toastr", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "hereMapsService", "HereMapsCONSTS", "mapObjectFactory", "resolvedServiceOrder", "resolvedTripTypeInstance", "resolvedDealerBranding"];
    angular
        .module('redcap.consumer.trip')
        .controller('ConsumerInviteExpiredContoller', ConsumerInviteExpiredContoller);

    function ConsumerInviteExpiredContoller($q, $scope, $state, toastr, SYSTEM_ENUMS, HERE_MAPS_CONFIG, hereMapsService, HereMapsCONSTS, mapObjectFactory, resolvedServiceOrder, resolvedTripTypeInstance, resolvedDealerBranding) {
        if(resolvedServiceOrder.existingTripId) {
            $state.go('track', { tripId: resolvedServiceOrder.existingTripId, key: resolvedServiceOrder.tripUrlKey });
        }

        var vm = this,
            initialLocation = null;

        vm.dealerBranding = resolvedDealerBranding;
        vm.editingPickup = false;
        vm.alertMsg = {
            title: 'Invite expired or invalid',
            phoneNumber: resolvedServiceOrder.dealer.phone,
            description: 'If you still need a ride, please contact the dealership at:'
        };
        vm.pickup = null;
        vm.dropoff = null;
        vm.trip = {};
        vm.markers = [];
        vm.formInvalid = false;
        vm.canGetCurrentLocation = !!navigator.geolocation;
        vm.failedValidations = {};
        vm.dealerAddress = resolvedServiceOrder.dealer.address;

        var isRoadside = resolvedTripTypeInstance.systemTripTypeId === SYSTEM_ENUMS.systemTripType.lyftRoadSideAssistance,
            consumerToastrConfig = {
                toastClass: 'toast-consumer'
            };

        init();
        initMap();
       

        function init() {
            if (vm.pickup || vm.dropoff) {
                setInitialLocation(vm.pickup || vm.dropoff);
                return;
            }

            if (isRoadside && vm.canGetCurrentLocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    setInitialLocation({ lat: position.coords.latitude, lng: position.coords.longitude });
                }, function (err) {
                    setInitialLocation(vm.pickup || vm.dropoff || resolvedServiceOrder.dealer.address);
                }, { enableHighAccuracy: true });
            } else if (!isRoadside) {
                vm.pickup = resolvedServiceOrder.dealer.address;
                    vm.pickup.dealerName = resolvedServiceOrder.dealer.name;

                setInitialLocation(vm.pickup || vm.dropoff || resolvedServiceOrder.dealer.address);
            }
        }

        function initMap() {
            // These are required in order for the map to be interactive.
            vm.mapListeners = {
                drag: function () {

                },
                resize: function () {

                }
            };

            vm.mapOptions = {
                fillHeight: true,
                footerElementId: 'track-footer',
                defaultMapMode: HERE_MAPS_CONFIG.mapModes.followMode,
                colorBasedOnStopType: true,
                showActualRoute: false,
                lockMapMode: true,
                useImagesInPin: true,
                hideLoadingScreen: true
            };
            
            $scope.$on('resizeHereMap', function () {
                if (vm.hereMap)
                    vm.hereMap.refresh();
            });
        }

        vm.onMapReady = function (hereMap) {
            vm.hereMap = hereMap;
            
            var pinType;

            if (isRoadside) {
                pinType = vm.dropoff == initialLocation ? SYSTEM_ENUMS.destinationType.genericDropoff : SYSTEM_ENUMS.destinationType.genericPickup;
            } else {
                pinType = vm.dropoff ==  vm.dealerAddress ? SYSTEM_ENUMS.destinationType.genericDropoff : SYSTEM_ENUMS.destinationType.genericPickup;
            }

            var initialPin = mapObjectFactory.createHereMarker(initialLocation.lat, initialLocation.lng, pinType);
            vm.markers.push(initialPin);
            vm.hereMap.updateMarkers(vm.markers, true);
            vm.hereMap.setZoom(HereMapsCONSTS.DEFAULT_MAP_OPTIONS.zoom);
        };

        function setInitialLocation(position) {
            initialLocation = position;
        }

        vm.normalizeLyftErrorTitle = function(msg) {
            return msg.replace(/\_/g, ' ');
        };

        $scope.$on('$destroy', function (event, next, current) {

        });
    }
})();
(function () {
    'use strict';

    angular
        .module('redcap',
        [
            'afkl.lazyImage',
            'angular-ladda',
            'azureBlobUpload',
            'angularBetterPlaceholder',
            'daterangepicker',
            'ghiscoding.validation',
            'googlechart',
            'infinite-scroll',
            'LocalStorageModule',
            'localytics.directives',
            'logToServer',
            'moment-picker',
            'ngAnimate',
            'ngAside',
            'ngAutocomplete',
            'ngCookies',
            'ngFileUpload',
            'ngMap',
            'ngMask',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngTagsInput',
            'ngTouch',
            'ng.deviceDetector',
            'ngWebworker',
            'pascalprecht.translate',
            'signature',
            'toastr',
            'uiCropper',
            'uiSwitch',
            'ui.bootstrap',
            'ui.footable',
            'ui.router',
            'ui.select',
            'ui.select2',
            'ui.sortable',
            'ui.carousel',
            'angularjs-dropdown-multiselect',
            'heremaps',
            'rzSlider',
            'redcap.constants',
            'redcap.directives',
            'redcap.main',
            'redcap.providers',
            'redcap.auth',
            'redcap.enrollment',
            'redcap.location',
            'redcap.filters',
            'redcap.services',
            'redcap.location',
            'redcap.user',
            'redcap.trip',
            'redcap.appointment',
            'redcap.appointment.classes',
            'redcap.driver',
            'redcap.productmarketing',
            'redcap.profile',
            'redcap.reports',
            'redcap.support',
            'redcap.messages',
            'redcap.payments',
            'redcap.consumer',
            'redcap.consumer.components',
            'redcap.consumer.trip',
            'redcap.consumer.payments',
            'redcap.consumer.appointments',
            'redcap.consumer.ownercare',
            'redcap.loaner',
            'redcap.consumer.loaner',
            'redcap.inspect',
            'redcap.consumer.repairorderauthorizations',
            'redcap.consumer.inspect',  
        ]);

    angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);
})();

(function () {
    'use strict';

    ConsumerController.$inject = ["$log", "$rootScope"];
    angular
        .module('redcap')
        .controller('ConsumerController', ConsumerController);

    function ConsumerController($log, $rootScope) {
        var vm = this;
    }
})();

(function () {
    'use strict';

    ConsumerBookTripController.$inject = ["$q", "$scope", "$state", "$timeout", "toastr", "SYSTEM_ENUMS", "consumerBookingService", "hereMapsService", "HereMapsCONSTS", "mapObjectFactory", "resolvedTripWorkflow", "resolvedTripTypeInstance", "resolvedServiceOrder", "resolvedDealerBranding", "ValidationService", "rcUtilService"];
    angular
        .module('redcap.consumer.trip')
        .controller('ConsumerBookTripController', ConsumerBookTripController);

    function ConsumerBookTripController($q, $scope, $state, $timeout, toastr, SYSTEM_ENUMS, consumerBookingService, hereMapsService, HereMapsCONSTS, mapObjectFactory, resolvedTripWorkflow, resolvedTripTypeInstance, resolvedServiceOrder, resolvedDealerBranding, ValidationService, rcUtilService) {
        if (resolvedServiceOrder.existingTripId) {
            $state.go('track', {tripId: resolvedServiceOrder.existingTripId, key: resolvedServiceOrder.tripUrlKey});
        }

        let vm = this;
        let lastErrorMsg = null;
        let initialLocation = null;
        let processLocationsTimeoutId = null;

        vm.dealerBranding = resolvedDealerBranding;
        vm.alertMsg = null;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
        vm.systemTripType = resolvedTripTypeInstance.systemTripTypeId;
        vm.consumerBookingDisclaimer = resolvedTripTypeInstance.consumerBookingDisclaimer;
        vm.serviceOrder = resolvedServiceOrder;
        vm.editingPickup = false;
        vm.pickup = null;
        vm.dropoff = null;
        vm.missingOptIn = false;
        vm.trip = {};
        vm.markers = [];
        vm.formInvalid = false;
        vm.canGetCurrentLocation = !!navigator.geolocation;
        vm.failedValidations = {};
        vm.bookingRules = null;
        vm.smsOptIn = rcUtilService.isEmpty(vm.consumerBookingDisclaimer) && vm.systemTripType === vm.systemTripTypes.partsOnDemand;
        let isRoadside = vm.systemTripType === vm.systemTripTypes.lyftRoadSideAssistance;
        let consumerToastrConfig = {
            toastClass: 'toast-consumer'
        };

        vm.placesOptions = {
            country: 'us,can'
        };

        initMap();
        init();

        function init() {
            if (vm.pickup || vm.dropoff) {
                clearMap();
                setInitialLocation(vm.pickup || vm.dropoff);

                return;
            }

            if (isRoadside && vm.canGetCurrentLocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    setInitialLocation({lat: position.coords.latitude, lng: position.coords.longitude});
                }, (err) => {
                    setInitialLocation(vm.pickup || vm.dropoff || vm.serviceOrder.dealer.address);
                }, {enableHighAccuracy: true});
            } else if (!isRoadside) {
                if (resolvedTripWorkflow.oneWayStartAtDealer) {
                    vm.pickup = vm.serviceOrder.dealer.address;
                    vm.pickup.dealerName = vm.serviceOrder.dealer.name;
                } else {
                    vm.dropoff = vm.serviceOrder.dealer.address;
                    vm.dropoff.dealerName = vm.serviceOrder.dealer.name;
                }

                setInitialLocation(vm.pickup || vm.dropoff || vm.serviceOrder.dealer.address);
            }
        }

        function initMap() {
            vm.mapOptions = {
                draggable: true,
                resize: true,
                coords: {
                    latitude: vm.dealerBranding.lat || 26.114249,
                    longitude: vm.dealerBranding.lng || -80.1368509
                }
            };

            // These are required in order for the map to be interactive.
            vm.mapListeners = {
                drag: function () {

                },
                resize: function () {

                }
            };

            vm.onMapReady = function (hereMap) {
                vm.hereMap = hereMap;

                hereMap.setZoom(HereMapsCONSTS.DEFAULT_MAP_OPTIONS.zoom);

                let pinType;

                if (isRoadside) {
                    pinType = vm.dropoff == initialLocation ? SYSTEM_ENUMS.destinationType.genericDropoff : SYSTEM_ENUMS.destinationType.genericPickup;
                } else {
                    pinType = vm.dropoff == vm.serviceOrder.dealer.address ? SYSTEM_ENUMS.destinationType.genericDropoff : SYSTEM_ENUMS.destinationType.genericPickup;
                }

                let initialPin = mapObjectFactory.createHereMarker(initialLocation.lat, initialLocation.lng, pinType);

                vm.markers.push(initialPin);
                vm.hereMap.updateMarkers(vm.markers, true);
            };

            $scope.$on('resizeHereMap', () => {
                if (vm.hereMap)
                    vm.hereMap.refresh();
            });
        }

        function setInitialLocation(position) {
            initialLocation = position;
        }

        vm.useCurrentLocation = function (evt) {
            evt.stopPropagation();

            navigator.geolocation.getCurrentPosition((position) => {
                let latlng = {lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude)};

                hereMapsService.reverseGeocode(latlng.lat, latlng.lng).then((location) => {
                    if (location) {
                        vm.hereMap.setZoom(11);

                        let searchInput = angular.element('#customerLocation')[0];

                        searchInput.value = location.streetAddress || location.city + ', ' + location.state;

                        vm.trip.customerLocation = searchInput.value;
                        processLocations(location, false);
                    } else {
                        toastr.error('No results were found for your current location', consumerToastrConfig);
                    }
                });
            }, (err) => {
                toastr.error('An error occurred while trying to find your location.  Please ensure location is enabled on your device.', consumerToastrConfig);
            }, {enableHighAccuracy: true});
        };

        vm.showPlacesSearch = function (isPickup) {
            vm.editingPickup = isPickup;

            if (vm.canEditField(isPickup)) {
                vm.searchVisible = true;

                let focusElement = isPickup || resolvedTripWorkflow.oneWayStartAtDealer ? '#customerLocation' : '#dropoffLocation';
                let searchInput = angular.element(focusElement)[0];

                // Timeout necessary to give element time to load.
                $timeout(() => { searchInput.focus(); }, 500, false);
            }
        };

        vm.canEditField = function (isPickup) {
            return isRoadside ||
                (isPickup && !resolvedTripWorkflow.oneWayStartAtDealer ||
                    !isPickup && resolvedTripWorkflow.oneWayStartAtDealer);
        };

        vm.bookTrip = function (valid) {
            vm.bookingTrip = true;

            if (!vm.canBook()) {
                if (!vm.smsOptIn) {
                    vm.missingOptIn = true;
                    vm.bookingTrip = false;

                    return;
                }

                showErrorToast();

                return;
            }

            if (valid && new ValidationService().checkFormValidity($scope.tripBookForm)) {
                vm.formInvalid = false;

                consumerBookingService.bookProviderRide(resolvedTripTypeInstance.dealerId,
                    vm.pickup.lat,
                    vm.pickup.lng,
                    vm.pickup.streetAddress || vm.pickup.address || vm.pickup.name,
                    vm.pickup.city,
                    vm.pickup.state,
                    vm.pickup.zip,
                    vm.pickup.countryShortCode,
                    vm.dropoff.lat,
                    vm.dropoff.lng,
                    vm.dropoff.streetAddress || vm.dropoff.address || vm.dropoff.name,
                    vm.dropoff.city,
                    vm.dropoff.state,
                    vm.dropoff.zip,
                    vm.dropoff.countryShortCode,
                    SYSTEM_ENUMS.providerRideTypes[vm.selectedProviderRide.rideType],
                    vm.selectedProviderRide.rideTypeId,
                    vm.serviceOrder && vm.serviceOrder.dealerServiceOrderId != -1 ? vm.serviceOrder.dealerServiceOrderId : null,
                    vm.serviceOrder.serviceAdvisorId,
                    vm.serviceOrder.inviteUserId,
                    null,
                    vm.serviceOrder.isTestTrip,
                    vm.selectedProviderRide.sandboxRunId,
                    moment().add(vm.selectedProviderRide.eta, 'seconds'),
                    vm.selectedProviderRide.estimatedDistance,
                    vm.selectedProviderRide.estimatedDuration,
                    vm.serviceOrder.roNumber,
                    vm.serviceOrder.customerPhone,
                    vm.serviceOrder.customerEmail,
                    vm.serviceOrder.customerName1,
                    vm.serviceOrder.customerName2,
                    '',
                    resolvedTripTypeInstance.id,
                    vm.selectedProviderRide.costToken,
                    vm.selectedProviderRide.baseCost,
                    vm.selectedProviderRide.estimatedCost,
                    vm.selectedProviderRide.maxCost,
                    resolvedTripTypeInstance.systemTripTypeId,
                    resolvedTripWorkflow.oneWayStartAtDealer,
                    vm.selectedProviderRide.rideProviderType,
                    vm.selectedProviderRide.primetimePercentage).then((result) => {
                        if (result.isSuccessful) {
                            vm.tripBooked = true;
                            $state.go('track', {trip: result, tripId: result.id, key: result.urlKey});
                        } else {
                            if (result.error) {
                                vm.lyftAlertMsg = {
                                    phoneNumber: vm.serviceOrder.dealer.phone,
                                    error: result.error.error
                                };
                            }
                        }

                        vm.bookingTrip = false;
                    }).catch((err) => {
                        vm.bookingTrip = false;
                    });
            } else {
                vm.formInvalid = true;
                vm.bookingTrip = false;
            }
        };

        vm.getLyftErrorDescription = function (error) {
            let errorMessages = [];

            if (error.error_description) {
                errorMessages.push(error.error_description);
            }

            if (error.error_detail && error.error_detail.length) {
                for (let index in error.error_detail) {
                    let detail = error.error_detail[index];

                    errorMessages.push(detail.value);
                }
            }

            return errorMessages.join(', ');
        };

        vm.normalizeLyftErrorTitle = function (msg) {
            return msg.replace(/\_/g, ' ');
        };

        vm.clearInput = function (isCustomerLocation, isDropoff) {
            isDropoff = isDropoff || vm.isDropoffField();

            if (isCustomerLocation) {
                vm.trip.customerLocation = null;

                if (isDropoff) {
                    vm.dropoff = null;
                } else {
                    vm.pickup = null;
                }
            } else {
                vm.trip.dropoffLocation = null;
                vm.dropoff = null;
            }

            init();
        };

        vm.locationUpdated = function (formattedAddress) {
            processLocations(formattedAddress.location, vm.isDropoffField());
        };

        vm.dropoffLocationUpdated = function (formattedAddress) {
            processLocations(formattedAddress.location, true);
        };

        vm.isDropoffField = function () {
            return !vm.editingPickup && vm.systemTripType !== vm.systemTripTypes.lyftRoadSideAssistance;
        };

        vm.clearAlert = function () {
            vm.alertMsg = null;
        };

        vm.canBook = function () {
            return !vm.rulesFailed && !vm.tripBooked && !!vm.pickup && vm.smsOptIn && !!vm.dropoff && !vm.gettingEstimates;
        };

        function processLocations(location, isDropoff) {
            if (processLocationsTimeoutId) {
                clearTimeout(processLocationsTimeoutId); // Clear any previous timeout to prevent stacking
            }

            if (location && location.lat) {
                if (isRoadside) {
                    if (isDropoff) {
                        vm.dropoff = location;
                    } else {
                        vm.pickup = location;
                    }
                } else if (vm.systemTripType === vm.systemTripTypes.lyftShuttleService ||
                    vm.systemTripType === vm.systemTripTypes.partsOnDemand) {
                    if (resolvedTripWorkflow.oneWayStartAtDealer) {
                        vm.pickup = vm.serviceOrder.dealer.address;
                        vm.pickup.dealerName = vm.serviceOrder.dealer.name;
                        vm.dropoff = location;
                    } else {
                        vm.pickup = location;
                        vm.dropoff = vm.serviceOrder.dealer.address;
                        vm.dropoff.dealerName = vm.serviceOrder.dealer.name;
                    }
                }

                if (vm.dropoff && vm.pickup) {
                    vm.rulesFailed = true;
                    vm.gettingEstimates = true;

                    getProviderRide().then((providerRide) => {
                        checkRules().then((rules) => {
                            let outOfArea = !rules.isDropoffInServiceArea || !rules.isPickupInServiceArea;
                            let stateErrorOccurred = rules.hasMultiStateViolation;
                            let providerErrorOccurred = !providerRide;

                            vm.rulesFailed = outOfArea || stateErrorOccurred || providerErrorOccurred;

                            if (outOfArea) {
                                let locationText = vm.failedValidations.pickup ? 'Pickup' : 'Dropoff';

                                showErrorToast(locationText + ' outside of service area', 'Please enter a different location below or contact the dealership at: ', true);
                            } else if (providerErrorOccurred) {
                                showErrorToast('Unable to locate driver', 'Please enter a different location below or contact the dealership at: ', true);
                            } else if (stateErrorOccurred) {
                                showErrorToast('Unable to book out of State', ' Pickup and dropoff must be within the same state.  Please contact your parts supplier if you need assistance at:', true);
                            } else if (!vm.rulesFailed) {
                                vm.clearAlert();

                                // Set timer to call processLocations again after 30 seconds
                                processLocationsTimeoutId = setTimeout(() => {
                                    processLocations(location, isDropoff);
                                }, 30000);
                            }

                            vm.gettingEstimates = false;
                        });
                    });

                    getTripRoute();
                }
            } else {
                if (isDropoff) {
                    vm.dropoff = null;
                    vm.trip.dropoffLocation = null;
                } else {
                    vm.pickup = null;
                    vm.trip.customerLocation = null;
                }

                init();
            }
        }

        function checkRules() {
            vm.failedValidations = {};

            return consumerBookingService.getRules(vm.pickup.lat,
                vm.pickup.lng,
                vm.dropoff.lat,
                vm.dropoff.lng,
                resolvedTripTypeInstance.id,
                resolvedTripTypeInstance.dealerId,
                vm.pickup.state,
                vm.dropoff.state,
                vm.selectedProviderRide ? vm.selectedProviderRide.rideProviderType : null).then((rules) => {
                    vm.bookingRules = rules;

                    if (!rules.isPickupInServiceArea || !rules.isDropoffInServiceArea || rules.hasMultiStateViolation) {
                        vm.failedValidations.pickup = !rules.isPickupInServiceArea;
                        vm.failedValidations.dropoff = !rules.isDropoffInServiceArea || rules.hasMultiStateViolation;
                    }

                    return rules;
                });
        }

        function showErrorToast(title, description, showPhoneNumber) {
            vm.alertMsg = {
                title: title || lastErrorMsg.title,
                description: description || lastErrorMsg.description,
                phoneNumber: showPhoneNumber ? vm.serviceOrder.dealer.phone : lastErrorMsg.phoneNumber
            };

            lastErrorMsg = vm.alertMsg;
        }

        function getProviderRide() {
            vm.selectedProviderRide = null;

            return consumerBookingService.getProviderRides(vm.pickup, vm.dropoff,
                resolvedTripTypeInstance.id,
                resolvedTripTypeInstance.dealerId,
                vm.systemTripType,
                vm.serviceOrder.isTestTrip).then((providerRides) => {
                    vm.rulesFailed = false;
                    let baseProviderRide = _.first(_.orderBy(providerRides, ['estimatedCost'], ['asc']));

                    if (baseProviderRide) {
                        vm.selectedProviderRide = baseProviderRide;
                    }

                    return baseProviderRide;
                });
        }

        function getTripRoute() {
            if (!vm.pickup || !vm.dropoff) return;

            vm.searchVisible = false;

            clearMap();

            let pickupPin = mapObjectFactory.createHereMarker(vm.pickup.lat, vm.pickup.lng, SYSTEM_ENUMS.destinationType.genericPickup);
            let dropoffPin = mapObjectFactory.createHereMarker(vm.dropoff.lat, vm.dropoff.lng, SYSTEM_ENUMS.destinationType.genericDropoff);

            vm.markers.push(pickupPin);
            vm.markers.push(dropoffPin);

            let waypoints = [{lat: vm.pickup.lat, lng: vm.pickup.lng}, {lat: vm.dropoff.lat, lng: vm.dropoff.lng}];

            vm.hereMap.calculateRoute('car', {mode: 'balanced', waypoints: waypoints}).then((result) => {
                let sections = result.routes[0].sections;
                let lineStrings = [];

                sections.forEach((section) => {
                    // convert Flexible Polyline encoded string to geometry
                    lineStrings.push(H.geo.LineString.fromFlexiblePolyline(section.polyline));
                });

                let multiLineString = new H.geo.MultiLineString(lineStrings);
              
                // render route on the map
                vm.hereMap.addObject(new H.map.Polyline(multiLineString, {style: {lineWidth: 5}}));

                fitBounds();
            });
        }

        function clearMap() {
            vm.markers = [];
            vm.hereMap.updateMarkers(null);
            vm.hereMap.cleanRoutes();
        }

        function fitBounds() {
            vm.hereMap.updateMarkers(vm.markers, true);

            // HERE does not include the markers in the viewport,
            // so we have to zoom out one level to include them.  We
            // have a slight delay to ensure the method above has run
            // and properly updated the map bounds.
            $timeout(() => {
                let currentZoom = vm.hereMap.getZoom();

                // Unfortunately the HERE directive has a bug that ignores animation while zooming,
                //  so we have to get the actual instance of the map and use the SDK method instead.
                vm.hereMap.getPlatform().map.setZoom(currentZoom - 1, true);
            }, 500);
        }

        $scope.$on('$destroy', (event, next, current) => {
            if (processLocationsTimeoutId) {
                clearTimeout(processLocationsTimeoutId); // Ensure the timeout is cleared when the controller scope is destroyed
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('redcap.consumer', ['redcap.consumer.components']);
})();

(function () {
    'use strict';

    consumerModalService.$inject = ["$q", "$uibModal", "$aside"];
    angular
        .module('redcap.consumer')
        .factory('consumerModalService', consumerModalService);

    function consumerModalService($q, $uibModal, $aside) {

        return {
            showDealerDetails: showDealerDetails,
            showMessage: showMessage,
            showCancelReason: showCancelReason
        };

        function showDealerDetails(dealerDetails, appInfo) {
            var aside = $aside.open({
                templateUrl: 'app/areas/consumer/shared/views/dealer-details.view.html',
                controllerAs: 'vm',
                controller: 'ConsumerDealerDetailsController',
                placement: 'left',
                size: 'sm',
                backdrop: true,
                animation: false,
                windowClass: 'top-0 mobile-95-percent',
                resolve: {
                    resolvedDealer: function() {
                        return dealerDetails;
                    },
                    resolvedAppInfo: function() {
                        return appInfo;
                    }
                }
              }).result;

              // Return aside promise
              return aside;
        }

        function showCancelReason(requireCancelReason, title) {
            var aside = $aside.open({
                templateUrl: 'app/areas/consumer/shared/components/cancelReason/cancel-reason.view.html',
                controllerAs: 'vm',
                controller: 'ConsumerCancelReasonController',
                placement: 'left',
                size: 'sm',
                backdrop: true,
                animation: false,
                windowClass: 'top-0 mobile-95-percent',
                resolve: {
                    resolvedTitle: function() {
                        return title;
                    },
                    resolvedReasonRequired : function () {
                        return requireCancelReason;
                    }
                }
              }).result;

              // Return aside promise
              return aside;
        }

        function showMessage(title, message, isError, buttons) {
            var deferred = $q.defer();

            var modal = $uibModal.open({
                templateUrl: 'app/areas/consumer/appointments/views/partials/message.view.html',
                controllerAs: 'vm',
                controller: 'ConsumerAppointmentMessageModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedTitle: function () { return title; },
                    resolvedMessage: function () { return message; },
                    resolvedIsError: function () { return isError; },
                    resolvedButtons: function () { return buttons; }
                }
            });

            modal.result.then(function (result) {
                deferred.resolve(result);
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }
    }

})();

(function () {
    'use strict';

    consumerMessagesService.$inject = ["$q", "rcApi"];
    angular
        .module('redcap.consumer')
        .factory('consumerMessagesService', consumerMessagesService);

    function consumerMessagesService($q, rcApi) {

        return {
            checkPhoneNumber: checkPhoneNumber
        };

        function checkPhoneNumber(phoneNumber, dealerId) {
            return rcApi.get('contacts/phonenumbers/' + phoneNumber + '?dealerId=' + dealerId);
        }
    }
})();

(function () {
    'use strict';

    consumerService.$inject = ["consumerApi"];
    angular
        .module('redcap.consumer')
        .factory('consumerService', consumerService);

    function consumerService(consumerApi) {

        var CUSTOMER_BASEPATH = 'public/consumer/';
        var DEALER_BASEPATH = 'public/dealer/';

        return {
            getTerms: getTerms,
            getFAQs: getFAQs,
            getPrivacy: getPrivacy,
            getDealer: getDealer,
            getDealerBranding: getDealerBranding
        };

        function getTerms(dealerId, type, typeTypeId, tripTypeInstanceId) {
            return consumerApi.get(CUSTOMER_BASEPATH + dealerId + '/terms/' + (tripTypeInstanceId ? 'v' + tripTypeInstanceId : typeTypeId ? typeTypeId : ''), {
                appType: type
            });
        }

        function getFAQs(dealerId, type, typeTypeId, tripTypeInstanceId) {
            return consumerApi.get(CUSTOMER_BASEPATH + dealerId + '/faq/' + (tripTypeInstanceId ? 'v' + tripTypeInstanceId : typeTypeId ? typeTypeId : ''), {
                appType: type
            });
        }

        function getPrivacy(dealerId, type, typeTypeId, tripTypeInstanceId) {
            return consumerApi.get(CUSTOMER_BASEPATH + dealerId + '/privacy/' + (tripTypeInstanceId ? 'v' + tripTypeInstanceId : typeTypeId ? typeTypeId : ''), {
                appType: type
            });
        }

        function getDealer(dealerId) {
            return consumerApi.get(DEALER_BASEPATH + dealerId);
        }

        function getDealerBranding(dealerId, tripTypeInstanceId, isLoaner) {
            return consumerApi.get(DEALER_BASEPATH + dealerId + '/branding',
                {
                    tripTypeInstanceId: tripTypeInstanceId,
                    isLoaner: isLoaner ? true : false
                });
        }

    }
})();

(function () {
    'use strict';

    ConsumerDealerDetailsController.$inject = ["$uibModalInstance", "resolvedDealer", "resolvedAppInfo", "consumerLocationService"];
    angular
        .module('redcap.consumer')
        .controller('ConsumerDealerDetailsController', ConsumerDealerDetailsController);

    function ConsumerDealerDetailsController($uibModalInstance, resolvedDealer, resolvedAppInfo, consumerLocationService) {
        var vm = this;

        vm.dealer = resolvedDealer;
        vm.appInfo = resolvedAppInfo;
        vm.googleAddressLink = 'http://maps.google.com/?q=' + vm.dealer.address + ', ' + vm.dealer.city + ', ' + vm.dealer.state + ', ' + vm.dealer.zip;
        vm.dealerStaticMapUrl = null;
        vm.close = close;

        consumerLocationService.getStaticMap(vm.dealer.lat, vm.dealer.lng, 300, 300)
            .then(function(mapUrl) {
                vm.dealerStaticMapUrl = mapUrl;
            });

        function close() {
            $uibModalInstance.dismiss();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.consumer')
        .directive('consumerDealerCustomStyles', consumerDealerCustomStyles);

    function consumerDealerCustomStyles() {
        return {
            //templateUrl: "C:\Users\Home\Source\Repos\redcap\redcap.admindashboard\src\app\areas\consumer\appointments\directives\dealer-custom-consumer-styles.directive.html",
            template: "<link rel='shortcut icon' ng-href='vm.fav'><link rel='stylesheet' type='text/css' ng-repeat='sheet in vm.styleSheets' ng-href='sheet.url'><style ng-repeat='style in vm.styles'>{{ style.name + '{' }} {{ style.items }} {{ '}; '}} </style>",
            controller: ConsumerDealerCustomStylesController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                configs: '<'
            }
        };
    }

    function ConsumerDealerCustomStylesController() {
        this.$onInit = function() {
            var vm = this;

            vm.styles = [];
            vm.styleSheets = [];


            init();

            function init() {
                if (!vm.configs) return;


                // Add custom style config values
                addStyle(
                    'table.visual-date-time .btn-default.pill-btn.selected, .modal-footer .btn.btn-primary, .btn-primary, .custom-button-color',
                    [
                        { property: 'background-color', value: vm.configs.cssButtonBackgroundColor },
                        { property: 'border-color', value: vm.configs.cssButtonBackgroundColor },
                        { property: 'color', value: vm.configs.cssButtonColor }
                    ]);

                addStyle('.cfl-preference-selection',
                    [{ property: 'background-color', value: vm.configs.cssButtonBackgroundColor }]);
                addStyle('.theme-panel', [{ property: 'border-color', value: vm.configs.cssButtonBackgroundColor }]);
                addStyle('.theme-text', [{ property: 'color', value: vm.configs.cssLinkColor }]);
                addStyle('.theme-link', [{ property: 'color', value: vm.configs.cssLinkColor }]);
                addStyle('.theme-text', [{ property: 'color', value: vm.configs.cssLinkColor }]);

                addStyle('.owner-care .card .card-footer label input[type="radio"]:checked + span',
                    [
                        { property: 'color', value: vm.configs.cssLinkColor },
                        { property: 'border-color', value: vm.configs.cssLinkColor }
                    ]);

                addStyle('.owner-care .info-icon.active',
                    [
                        { property: 'color', value: vm.configs.cssButtonBackgroundColor },
                        { property: 'border-color', value: vm.configs.cssLinkColor }
                    ]);

                addStyle(
                    '.owner-care .media-window-full-width .media-thumbnail.active img, .owner-care .media-window-full-width .media-thumbnail.active video',
                    [
                        { property: 'border-color', value: vm.configs.cssLinkColor }
                    ]);

                addStyle('.appointment-homework .card .card-footer label input[type="radio"]:checked + span',
                    [
                        { property: 'color', value: vm.configs.cssLinkColor },
                        { property: 'border-color', value: vm.configs.cssLinkColor }
                    ]);

                addStyle('.appointment-homework .info-icon.active',
                    [
                        { property: 'color', value: vm.configs.cssButtonBackgroundColor },
                        { property: 'border-color', value: vm.configs.cssLinkColor }
                    ]);

                addStyle(
                    '.appointment-homework .media-window-full-width .media-thumbnail.active img, .appointment-homework .media-window-full-width .media-thumbnail.active video',
                    [
                        { property: 'border-color', value: vm.configs.cssLinkColor }
                    ]);

                addStyle('.sms-icon .circle-text',
                    [
                        { property: 'background-color', value: vm.configs.cssButtonBackgroundColor }
                    ]);

                addStyle('select:required, input:required',
                    [
                        { property: 'border-left-color', value: vm.configs.cssButtonBackgroundColor }
                    ]);

                if (vm.configs.cssRequiredColor && vm.configs.cssRequiredColor !== '') {
                    addStyle('.consumer select:required, .consumer input:required',
                        [
                            { property: 'border-left-color', value: vm.configs.cssRequiredColor }
                        ]);

                    addStyle('.consumer .ng-invalid.ng-dirty:not(:focus), .consumer .ng-invalid.ng-touched:not(:focus)',
                        [
                            { property: 'border-color', value: vm.configs.cssRequiredColor }
                        ]);

                    addStyle('.consumer .validation, .consumer .text-danger',
                        [
                            { property: 'color', value: vm.configs.cssRequiredColor }
                        ]);


                }

                // Add custom stylesheet config values
                addStyleSheet(vm.configs.cssOverride);

                // Favorite Icon
                if (vm.configs.favIcon && vm.configs.favIcon !== '' && vm.configs.favIcon !== 'None') {
                    vm.fav = vm.configs.favIcon;
                }
            }

            function addStyle(name, items) {
                if (!items) return;

                // Add only non-null, non-empty values to overrides
                var styleItems = [];
                items.forEach(function(item) {
                    if (item.value && item.value !== '') {
                        styleItems.push(item);
                    }
                });

                // Save flatten styles
                var flattenItems = function() {
                    if (!styleItems) return '';

                    var resultCss = '';
                    styleItems.forEach(function(item) {
                        resultCss += item.property + ' : ' + item.value + ' !important; ';
                    });

                    return resultCss;
                };

                // Add styles
                vm.styles.push({ name: name, items: flattenItems() });
            }

            function addStyleSheet(url) {
                if (url && url !== '') {
                    vm.styleSheets.push(url);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE"];
    angular.module('redcap.consumer.repairorderauthorizations')
        .config(routeConfig);

    function routeConfig($stateProvider, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE) {
        let repairOrderAuthorizationHomeworkBase = {
            parent: 'consumer',
            url: '/repairorder/authorizations/:dealerId',
            abstract: true,
            public: true,
            data: {
                onError: {
                    toState: 'consumerError'
                }
            },
            params: {
                dealerId: null
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                hasAccess: ["consumerAppointmentService", "$transition$", "$state", function (consumerAppointmentService, $transition$, $state) {
                    'ngInject';

                    return consumerAppointmentService.hasAccess($transition$.params()['dealerId']).then(
                        (result) => {
                            if (result === false) {
                                $state.go('consumerError');
                            }
                        },
                        (error) => {
                            $state.go('consumerError');
                        });
                }],
                resolvedDealerBranding: ["consumerAppointmentService", "$transition$", "$rootScope", function (consumerAppointmentService, $transition$, $rootScope) {
                    'ngInject';

                    return consumerAppointmentService.getAppointmentHomeworkBranding($transition$.params()['dealerId']).then(
                        (resolvedDealerBranding) => {
                            let adminConfig = resolvedDealerBranding.adminConfig;

                            adminConfig.clientClass = 'consumer-appointment-page'; // Add custom class to body
                            adminConfig.hideToastr = true; // Don't show toastr messages
                            $rootScope.config = adminConfig;

                            return resolvedDealerBranding;
                        },
                        (error) => { return {}; });
                }],
                resolvedKey: ["$transition$", function ($transition$) {
                    'ngInject';

                    return $transition$.params().key;
                }]
            }
        };
        
        let repairOrderAuthorizationHomeworkLandingPage = {
            parent: repairOrderAuthorizationHomeworkBase,
            url: '/landing/:repairOrderId?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/repairorders/authorizations/views/homework-landing.view.html',
            controller: 'ConsumerRepairOrderAuthorizationsHomeworkLandingController as vm', // TODO: rename all of these controllers
            resolve: {
                resolvedRepairOrder: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRepairOrder($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], $transition$.params().key);
                }],
                resolvedPendingAuthorizations: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getPendingAuthorizations($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], $transition$.params().key);
                }],
                resolvedDealerOpCodes: ["$transition$", "consumerAppointmentService", function($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getLocationOpCodes($transition$.params()['dealerId']);
                }],
                pageTitle: function () {
                    return 'Service Authorization for your vehicle';
                }
            }
        };
        let repairOrderAuthorizationHomeworkServicesPage = {
            parent: repairOrderAuthorizationHomeworkBase,
            url: '/services/:repairOrderId?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/repairorders/authorizations/views/homework-services.view.html',
            controller: 'ConsumerRepairOrderAuthorizationsHomeworkServicesController as vm',
            resolve: {
                resolvedRepairOrder: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRepairOrder($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], 
                    $transition$.params().key);
                }],                
                resolvedPendingAuthorizations: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getPendingAuthorizations($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], $transition$.params().key);
                }],
                resolvedApprovedTotals: ["consumerRepairOrderAuthorizationsService", "$transition$", function(consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getApprovedTotals($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], $transition$.params().key);
                }],
                resolvedTerms: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getActiveTerms($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], 
                    $transition$.params().key);
                }],
                resolvedLocationTransportationTypes: ["$transition$", "locationService", function ($transition$, locationService) {
                    'ngInject';

                    return locationService.getLocationTransportationTypes($transition$.params().dealerId);
                }],
                resolvedDealerOpCodes: ["$transition$", "consumerAppointmentService", function($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getLocationOpCodes($transition$.params().dealerId);
                }],
                pageTitle: function () {
                    return 'Service Authorization for your vehicle';
                }
            }
        };

        let repairOrderAuthorizationHomeworkConfirmInfoPage = {
            parent: repairOrderAuthorizationHomeworkBase,
            url: '/summary/:repairOrderId?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/repairorders/authorizations/views/homework-confirminfo.view.html',
            controller: 'ConsumerRepairOrderAuthorizationsHomeworkConfirmInfoController as vm',
            resolve: {
                resolvedRepairOrder: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRepairOrder($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], 
                    $transition$.params().key);
                }],
                resolvedServiceLines: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRoLineItems($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], $transition$.params().key);
                }],
                resolvedAuthHistory: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getAuthorizationHistory($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], $transition$.params().key);
                }],
                resolvedDealerIntegrations: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getDealerIntegrations($transition$.params()['dealerId']);
                }],
                resolvedLocationTransportationTypes: ["$transition$", "locationService", function ($transition$, locationService) {
                    'ngInject';

                    return locationService.getLocationTransportationTypes($transition$.params().dealerId);
                }],
                resolvedDealerOpCodes: ["$transition$", "consumerAppointmentService", function($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getLocationOpCodes($transition$.params().dealerId);
                }],
                pageTitle: function () {
                    return 'Confirm your service information';
                }
            }
        };

        let repairOrderAuthorizationHomeworkAuthorizationHistory = {
            parent: repairOrderAuthorizationHomeworkBase,
            url: '/history/:authorizationGroupId/:repairOrderId?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/repairorders/authorizations/views/homework-authorization-history.view.html',
            controller: 'ConsumerRepairOrderAuthorizationsHomeworkAuthorizationHistoryController as vm',
            params: {
                authorizationGroupId: null,
                repairOrderId: null,
                key: null
            },
            resolve: {
                resolvedRepairOrder: ["consumerRepairOrderAuthorizationsService", "$transition$", function (consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRepairOrder($transition$.params()['dealerId'], $transition$.params()['repairOrderId'], 
                    $transition$.params().key);
                }],
                resolvedAuthorizationGroup: ["consumerRepairOrderAuthorizationsService", "$transition$", function(consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getAuthorizationGroupDetail($transition$.params()['dealerId'],
                        $transition$.params()['repairOrderId'],
                        $transition$.params()['authorizationGroupId'],
                        $transition$.params().key);
                }],
                resolvedDealerOpCodes: ["$transition$", "consumerAppointmentService", function($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getLocationOpCodes($transition$.params()['dealerId']);
                }],
                pageTitle: function () {
                    return 'Authorization History';
                }
            }
        };


        $stateProvider
            .state('consumer-repairorder-authorizations-base', repairOrderAuthorizationHomeworkBase)
            .state('consumer-repairorder-authorizations-landing', repairOrderAuthorizationHomeworkLandingPage)
            .state('consumer-repairorder-authorizations-services', repairOrderAuthorizationHomeworkServicesPage)
            .state('consumer-repairorder-authorizations-confirminfo', repairOrderAuthorizationHomeworkConfirmInfoPage)
            .state('consumer-repairorder-authorizations-authhistory', repairOrderAuthorizationHomeworkAuthorizationHistory);
    }
})();

(function () {
    "use strict";
    periPaymentsService.$inject = ["consumerApi", "rcApi"];
    angular
        .module("redcap.consumer.payments")
        .factory("periPaymentsService", periPaymentsService);
    function periPaymentsService(consumerApi, rcApi) {
        var PAYMENT_BASEPATH = "payment/peri/";
        return {
            createTransaction: createTransaction,
            verifyPayment: verifyPayment,
            createTransactionForDashboard: createTransactionForDashboard,
            verifyDashboardPayment: verifyDashboardPayment,
            getTerminals: getTerminals
        };
        function createTransaction(dealerId, invoiceGuid, redirectUrl) {
            return consumerApi.post(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceGuid + '/createTransaction',
                {
                    redirectUrl: redirectUrl
                });
        }
        function createTransactionForDashboard(dealerId, invoiceId, redirectUrl) {
            return rcApi.post(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceId + '/createDashboardTransaction',
                {
                    redirectUrl: redirectUrl
                });
        }
        function verifyPayment(dealerId, invoiceGuid, transactionId) {
            return consumerApi.get(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceGuid + '/consumerPay/' + transactionId);
        }
        function verifyDashboardPayment(dealerId, invoiceId, transactionId) {
            return rcApi.get(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceId + '/pay/' + transactionId);
        }
        function getTerminals(dealerId) {
            return rcApi.get(PAYMENT_BASEPATH + dealerId + '/terminals');
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("redcap.consumer.payments")
        .factory("consumerPaymentTextService", consumerPaymentTextService);

    function consumerPaymentTextService() {
        
        return {
            makeTextUserFriendly: makeTextUserFriendly
        };

        function makeTextUserFriendly(text, invoice) {
            if (typeof(text) !== 'string') return text;
            return text.replace('[FIRST_NAME]', invoice.customerFirstName).replace('[DEALER_NAME]', invoice.dealerName);
        }
    }

})();

(function () {
    "use strict";

    consumerPaymentService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module("redcap.consumer.payments")
        .factory("consumerPaymentService", consumerPaymentService);

    function consumerPaymentService($q, $log, $filter, $http, $rootScope, rcApi) {

        var PAYMENT_BASEPATH = "payment/";

        return {
            getInvoiceByGuid: getInvoiceByGuid,
            getCardsOnFile: getCardsOnFile,
            getInitializationToken: getInitializationToken,
            sendPayment: sendPayment,
            processInvoice: processInvoice,
            getPaymentResult: getPaymentResult,
            getVerbiage: getVerbiage,
            getTripTypes: getTripTypes,
            getDealerHours: getDealerHours,
            setComeInTime: setComeInTime,
            updateDeliveryDetails: updateDeliveryDetails,
            validateTransaction: validateTransaction,
            updateDeliveryCostEstimate: updateDeliveryCostEstimate,
            updateDeliveryAddress: updateDeliveryAddress,
            bookLater: bookLater
        };

        function getInvoiceByGuid(invoiceGuid) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoicebyguid', {
                guid: invoiceGuid
            });
        }

        function getCardsOnFile(invoiceGuid, emailAddress) {
            return rcApi.post(PAYMENT_BASEPATH + 'cardsonfile', {
                emailAddress: emailAddress,
                invoiceGuid: invoiceGuid
            });
        }

        function getInitializationToken(invoiceGuid, emailAddress) {
            return rcApi.post(PAYMENT_BASEPATH + 'initialize', {
                emailAddress: emailAddress,
                invoiceGuid: invoiceGuid
            });
        }

        function processInvoice(invoiceGuid, bookingInfo, isPartsOnDemand, isTest) {
            return rcApi.post(PAYMENT_BASEPATH + 'pay/billToAccount', {
                invoiceGuid: invoiceGuid,
                bookingInfo: bookingInfo
            }, buildHeaders(isPartsOnDemand, isTest));
        }

        function getPaymentResult(invoiceGuid) {
            return rcApi.post(PAYMENT_BASEPATH + 'paymentresult', {
                invoiceGuid: invoiceGuid
            });
        }

        function getVerbiage(locationId) {
            return rcApi.get(PAYMENT_BASEPATH + 'verbiage', {
                locationId: locationId
            });
        }

        function getTripTypes(invoiceGuid) {
            return rcApi.get(PAYMENT_BASEPATH + 'triptypes', {
                invoiceGuid: invoiceGuid
            });
        }

        function getDealerHours(invoiceGuid) {
            return rcApi.get(PAYMENT_BASEPATH + 'dealerhours', {
                invoiceGuid: invoiceGuid
            });
        }

        function updateDeliveryCostEstimate(invoiceId, isPartsOnDemand, isTest) {
            return rcApi.put(PAYMENT_BASEPATH + 'invoice/delivery/costestimate?invoiceId=' + invoiceId, null, null, buildHeaders(isPartsOnDemand, isTest))
                .then(function (response) {
                    return response;
                });
        }

        function updateDeliveryAddress(invoiceId, address) {
            return rcApi.put(PAYMENT_BASEPATH + 'invoice/delivery/address?invoiceId=' + invoiceId, address)
                .then(function (response) {
                    return response;
                });
        }

        function sendPayment(invoiceGuid, tokenId, emailAddress, address, city, state, zip, saveCard, bookingInfo, isPartsOnDemand, isTest) {
            return rcApi.post(PAYMENT_BASEPATH + 'pay', {
                emailAddress: emailAddress,
                tokenId: tokenId || '',
                invoiceGuid: invoiceGuid,
                address: address || '',
                city: city || '',
                state: state || '',
                zip: zip || '',
                saveCard: saveCard || false,
                bookingInfo: bookingInfo
            }, buildHeaders(isPartsOnDemand, isTest));
        }

        function validateTransaction(invoiceGuid, paymentResult, bookingInfo, isPartsOnDemand, isTest) {
            return rcApi.post(PAYMENT_BASEPATH + 'validatetransaction', angular.extend({ invoiceGuid: invoiceGuid, bookingInfo: bookingInfo }, paymentResult), buildHeaders(isPartsOnDemand, isTest));
        }

        function buildHeaders(isPartsOnDemand, isTest) {
            var headers = { requiresUserToken: true };

            if (isPartsOnDemand) {
                headers.requiresDeliveryClient = true;
            }
            if (isTest) {
                headers.isTest = isTest;
            }

            return headers;
        }

        function setComeInTime(invoiceGuid, localDate, localTime) {
            return rcApi.post(PAYMENT_BASEPATH + 'comein', {
                invoiceGuid: invoiceGuid,
                dateTime: moment(localDate + ' ' + localTime).local().format()
            });
        }

        function updateDeliveryDetails(invoiceGuid, model) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/' + invoiceGuid + '/delivery/update', {
                model: model
            });
        }

        function bookLater(invoiceGuid, dealerTripTypeId, workflowId) {
            return rcApi.post(PAYMENT_BASEPATH + 'booklater',
                {
                    invoiceGuid: invoiceGuid,
                    dealerTripTypeId: dealerTripTypeId,
                    workflowId: workflowId
                });
        }
    }
})();

(function () {
    "use strict";

    consumerPaymentModalService.$inject = ["$q", "$uibModal"];
    angular
        .module("redcap.consumer.payments")
        .factory("consumerPaymentModalService", consumerPaymentModalService);

    function consumerPaymentModalService($q, $uibModal) {
        return {
            showSecure3d: showSecure3d
        };

        function showSecure3d(htmlToShow) {

            let modal = $uibModal.open({
                templateUrl: 'app/areas/consumer/payments/views/modals/secure3d.view.html',
                controllerAs: 'vm',
                controller: 'ConsumerSecure3dController',
                windowClass: 'top-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    htmlToShow: function () { return htmlToShow; }
                }
            });

            return modal.result;
        }

    }

})();

(function () {
    'use strict';

    paymentSuccessController.$inject = ["invoice", "deliveryStyleValues", "$state", "paymentResult", "consumerPaymentTextService", "offeredTripTypes", "verbiage", "SYSTEM_ENUMS", "deliveryChargeType"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentSuccessController', paymentSuccessController);

    function paymentSuccessController(invoice, deliveryStyleValues, $state, paymentResult, consumerPaymentTextService, offeredTripTypes, verbiage, SYSTEM_ENUMS, deliveryChargeType) {
        var vm = this;
        vm.dealerInfo = {
            dealerName: invoice.dealerName,
            styleValues: invoice.styleValues,
            dealerPhone: invoice.dealerPhone,
            dealerSmsNumber: invoice.dealerSmsNumber,
            dealerAddress: invoice.dealerAddress,
            dealerCity: invoice.dealerCity,
            dealerState: invoice.dealerState,
            dealerZip: invoice.dealerZip,
            dealerLat: invoice.dealerLat,
            dealerLng: invoice.dealerLng,
            locationId: invoice.locationId,
            desktopHeaderImageUrl: invoice.desktopHeaderImageUrl,
            headerImageUrl: invoice.headerImageUrl
        };
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.invoice = paymentResult.invoice;
        vm.paymentResult = paymentResult;
        vm.offeredTripTypes = offeredTripTypes;
        vm.nextPage = function () {
            vm.loading = true;
            $state.go('payment-review-charges', {
                emailAddress: vm.emailAddress
            });
        };
        vm.tax = _.reduce(vm.invoice.lineItems, function (memo, item) {
            return memo + parseFloat(item.tax || 0);
        }, 0);

        vm.fee = _.reduce(vm.invoice.lineItems, function (memo, item) {
            return memo + parseFloat(item.fee || 0);
        }, 0);
        
        vm.shopSupplies = _.reduce(vm.invoice.lineItems, function (memo, item) {
            return memo + parseFloat(item.shopSupplies || 0);
        }, 0);

        vm.systemTripType = SYSTEM_ENUMS.systemTripType;
        vm.pickupDateTime = vm.invoice.comeInDateTime;
        vm.isBillToAccount = vm.pickupDateTime ? paymentResult.cardNumber == null : deliveryChargeType === SYSTEM_ENUMS.invoiceChargeTypes.billToAccount;
        vm.title = consumerPaymentTextService.makeTextUserFriendly(verbiage.successTitle, invoice);
        vm.paragraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.successParagraph, invoice);

        vm.selectedBookType = _.find(offeredTripTypes, function (item) {
            return item.type == vm.invoice.selectedBookingType;
        });

        if (vm.paymentResult) {
            vm.tripId = vm.paymentResult.invoice.tripId;
            vm.tripKey = vm.paymentResult.invoice.tripUrlKey;
        }

        // Ensure that we have all that we need for the delivery option
        vm.isValidPODDelivery = vm.invoice.isPodCheckout && vm.tripId != null && vm.tripKey != null;
    }
})();

(function () {
    'use strict';

    paymentSuccessNoBookingController.$inject = ["invoice", "deliveryStyleValues", "paymentResult", "consumerPaymentTextService", "verbiage"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentSuccessNoBookingController', paymentSuccessNoBookingController);


    function paymentSuccessNoBookingController(invoice, deliveryStyleValues, paymentResult, consumerPaymentTextService, verbiage) {
        var vm = this;
        vm.invoice = invoice;
        vm.result = paymentResult;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.tax = _.reduce(vm.invoice.lineItems, function (memo, item) {
            return memo + parseFloat(item.tax || 0);
        }, 0);

        vm.fee = _.reduce(vm.invoice.lineItems, function (memo, item) {
            return memo + parseFloat(item.fee || 0);
        }, 0);
        
        vm.shopSupplies = _.reduce(vm.invoice.lineItems, function (memo, item) {
            return memo + parseFloat(item.shopSupplies || 0);
        }, 0);

        vm.title = consumerPaymentTextService.makeTextUserFriendly(verbiage.successTitle, invoice);
        vm.paragraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.successParagraph, invoice);
    }


})();

(function () {
    'use strict';

    paymentReviewChargesController.$inject = ["invoice", "deliveryStyleValues", "$transition$", "$state", "consumerPaymentTextService", "verbiage", "deliveryChargeType", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentReviewChargesController', paymentReviewChargesController);


    function paymentReviewChargesController(invoice, deliveryStyleValues, $transition$, $state, consumerPaymentTextService, verbiage, deliveryChargeType, SYSTEM_ENUMS) {
        var vm = this;
        vm.invoice = invoice;
        vm.deliveryStyleValues = deliveryStyleValues;

        // Don't include delivery charges or discounts
        vm.visibleLineItems = _.filter(invoice.lineItems, function (item) {
            return item.type !== SYSTEM_ENUMS.invoiceLineItemTypes.delivery.id && item.type !== SYSTEM_ENUMS.invoiceLineItemTypes.discount.id;
        });
        
        vm.tax = _.reduce(vm.visibleLineItems, function (memo, item) {
            return memo + parseFloat(item.tax || 0);
        }, 0);

        vm.fee = _.reduce(vm.visibleLineItems, function (memo, item) {
            return memo + parseFloat(item.fee || 0);
        }, 0);
        
        vm.shopSupplies = _.reduce(vm.visibleLineItems, function (memo, item) {
            return memo + parseFloat(item.shopSupplies || 0);
        }, 0);
        
        vm.title = consumerPaymentTextService.makeTextUserFriendly(verbiage.reviewTitle, invoice);
        vm.paragraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.reviewParagraph, invoice);

        vm.nextPage = function () {
            vm.loading = true;
            if (deliveryChargeType === SYSTEM_ENUMS.invoiceChargeTypes.billToAccount) {
                $state.go('payment-delivery-options', { paymentInfo: null }, { reload: true });
            } else {
                $state.go('payment-credit-card', $transition$.params());
            }
        };

        vm.back = function () {
            $state.go('payment-landing', $transition$.params());
        };
    }
})();

(function () {
    'use strict';

    paymentLandingController.$inject = ["invoice", "deliveryStyleValues", "dealerHours", "consumerPaymentTextService", "verbiage", "$state", "$transition$", "isPartsOnDemand", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentLandingController', paymentLandingController);


    function paymentLandingController(invoice, deliveryStyleValues, dealerHours, consumerPaymentTextService, verbiage, $state, $transition$, isPartsOnDemand, SYSTEM_ENUMS) {
        var vm = this;
        vm.invoice = invoice;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.isInvoiceCancelled = vm.invoice.status === SYSTEM_ENUMS.invoiceStatus.cancelled ? true : false;
      
        vm.emailAddress = $transition$.params()['emailAddress'];
        vm.title = vm.isInvoiceCancelled ? consumerPaymentTextService.makeTextUserFriendly(verbiage.cancelledTitle, invoice) : isPartsOnDemand ? 'Your parts are ready!' : consumerPaymentTextService.makeTextUserFriendly(verbiage.welcomeTitle, invoice);
        vm.paragraph = vm.isInvoiceCancelled ? consumerPaymentTextService.makeTextUserFriendly(verbiage.cancelledParagraph, invoice) : isPartsOnDemand ? 'Your parts are ready for delivery.  Please follow through the steps to pay your invoice and arrange delivery.  Please contact us if you have any questions or need to modify your order.' : consumerPaymentTextService.makeTextUserFriendly(verbiage.welcomeParagraph, invoice);
        vm.isDeliveryCurrentlyAvailable = false;
        vm.dealerHours = dealerHours;
        vm.isPartsOnDemand = isPartsOnDemand;

        var date = moment(new Date()),
            currentDateTime = moment(new Date());
        var deliveryLineItem = _.find(vm.invoice.lineItems, function (item) {
            return item.type === SYSTEM_ENUMS.invoiceLineItemTypes.delivery.id;
        });

        // Set up steps, check for POD delivry option
        vm.steps = [];

        // If POD show different steps
        if (isPartsOnDemand && deliveryLineItem != null) {
            if (deliveryLineItem.deliveryOptions.chargeType === SYSTEM_ENUMS.invoiceChargeTypes.billToAccount) {
                vm.steps = [
                    {text:'Review your parts invoice'}, 
                    {text:'Choose delivery options'}, 
                    {text:'Submit invoice and track delivery'}
                ];
            } else {
                vm.steps = [
                    {text:'Review your parts invoice'}, 
                    {text:'Enter payment information'}, 
                    {text:'Choose delivery options'}, 
                    {text:'Pay invoice and track delivery'}
                ];
            }
        } else {
            vm.steps = [
                {text:'Review your invoice'}, 
                {text:'Choose delivery option'}, 
                {text:'Pay the bill'}
            ];
        }

        function findDealerHoursForDay(momentDate) {
            return dealerHours.hours.find(function (item) {
                return momentDate.day() === item.dayOfWeekId;
            });
        }

        var hoursForToday = findDealerHoursForDay(currentDateTime);
        if (hoursForToday) {
            // If dealer's hours are past current time (they are closed), add an additional day
            if (moment(currentDateTime.format('MM/DD/YYYY')).add(hoursForToday.endTime, 'minutes') < currentDateTime) {
                date = date.add(1, 'days');
            } else {
                // The dealer is still open
                vm.isDeliveryCurrentlyAvailable = true;
            }
        }

        vm.formattedDealerHours = [];
        if (!vm.isDeliveryCurrentlyAvailable) {
            for (var dayId = 0; dayId <= 6; dayId++) {
                var dayOfWeek = dealerHours.hours.find(function (item) {
                    return dayId === item.dayOfWeekId;
                });

                // Make sure all times are valid
                if (dayOfWeek && dayOfWeek.startTime && dayOfWeek.endTime) {
                    vm.formattedDealerHours.push(
                        {
                            name: moment.weekdaysShort(dayId),
                            startTime: moment().startOf('day').add(dayOfWeek.startTime, 'minutes').format('hh:mm A'),
                            endTime: moment().startOf('day').add(dayOfWeek.endTime, 'minutes').format('hh:mm A')
                        });
                } else {
                    vm.formattedDealerHours.push(
                        {
                            name: moment.weekdaysShort(dayId),
                            isClosed: true
                        });
                }
            }
        }

        vm.nextPage = function () {
            vm.loading = true;
            $state.go('payment-review-charges', {
                paymentInfo: { emailAddress: vm.emailAddress },
                emailAddress: vm.emailAddress,
                verbiage: verbiage,
                invoice: invoice
            });
        };
    }
})();

(function () {
    'use strict';

    deliveryOptionsController.$inject = ["invoice", "deliveryStyleValues", "dealerHours", "toastr", "SYSTEM_ENUMS", "$transition$", "offeredTripTypes", "consumerPaymentService", "$state"];
    angular
        .module('redcap.consumer.payments')
        .controller('DeliveryOptionsController', deliveryOptionsController);


    function deliveryOptionsController(invoice, deliveryStyleValues, dealerHours, toastr, SYSTEM_ENUMS, $transition$, offeredTripTypes, consumerPaymentService, $state) {
        var vm = this;
        vm.isDeliveryCurrentlyAvailable = false;
        vm.invoice = invoice;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.dealerHours = dealerHours;
        vm.systemTripType = SYSTEM_ENUMS.systemTripType;
        vm.currentBookingInfo = $transition$.params() == null ? {} : $transition$.params().bookingInfo;
        vm.deliveryErrorMessage = null;

        vm.offeredTripTypes = offeredTripTypes.filter(function (t) {
            return t != vm.systemTripType.partsOnDemand;
        });

        //Check offeredTrips
        if (vm.offeredTripTypes == null || vm.offeredTripTypes.length == 0) {
            $state.go('payment-confirmation', { bookingInfo: {}, paymentInfo: $transition$.params().paymentInfo }, { reload: true });
        }

        vm.dates = [];
        var date = moment(new Date()),
            currentDateTime = moment(new Date());

        vm.delivery = {
            address: vm.currentBookingInfo != null && vm.currentBookingInfo.delivery != null ? vm.currentBookingInfo.delivery.address : {},
            addressDetails: vm.currentBookingInfo != null && vm.currentBookingInfo.delivery != null ? vm.currentBookingInfo.delivery.address : {},
            hereMapOptions: {
                watchEnter: true,
                country: 'us,can',
                startLat: invoice.dealerLat,
                startLng: invoice.dealerLng
            }
        };

        // Check to see that we have a delivery line item
        // MOVE THIS TO ROUTE?
        var deliveryLineItem = _.find(vm.invoice.lineItems, function (item) {
            return item.type == SYSTEM_ENUMS.invoiceLineItemTypes.delivery.id;
        });

        // Get the address based off the address.
        if (deliveryLineItem) {
            vm.delivery.address = deliveryLineItem.deliveryOptions.address;
        }

        function findDealerHoursForDay(momentDate) {
            return dealerHours.hours.find(function (item) {
                return momentDate.day() === item.dayOfWeekId;
            });
        }

        var hoursForToday = findDealerHoursForDay(currentDateTime);
        if (hoursForToday) {
            // If dealer's hours are past current time (they are closed), add an additional day
            if (moment(currentDateTime.format('MM/DD/YYYY')).add(hoursForToday.endTime, 'minutes') < currentDateTime) {
                date = date.add(1, 'days');
            } else {
                // The dealer is still open
                vm.isDeliveryCurrentlyAvailable = true;
            }
        }

        for (var i = 0; i < 7; i++) {
            if ((dealerHours.blackouts && dealerHours.blackouts.some(function (item) { return moment(item).format('MM/DD/YYYY') === date.format('MM/DD/YYYY'); })) ||
                (dealerHours.hours && dealerHours.hours.every(function (item) { return item.dayOfWeekId !== date.day(); }))) {
                i--;
                date = date.add(1, 'days');
                continue;
            }

            var dateObj = { value: date.format('MM/DD/YYYY'), text: date.format('MM/DD') };
            if (date.format('MM/DD/YYYY') === currentDateTime.format('MM/DD/YYYY')) {
                dateObj.text += ' Today';
            }

            vm.dates.push(dateObj);
            date = date.add(1, 'days');
        }

        vm.selectedDate = vm.dates[0];

        vm.selectedDateChanged = function () {
            var times = [],
                dayOfWeekFiltered = findDealerHoursForDay(moment(vm.selectedDate.value));
            var selectedTime = vm.selectedTime;
            vm.selectedTime = '';

            if (dayOfWeekFiltered) {
                var time = moment(vm.selectedDate.value).add(dayOfWeekFiltered.startTime, 'minutes');
                times.push(time.format('hh:mm A')); // add the start date.

                var duration = (dayOfWeekFiltered.endTime - dayOfWeekFiltered.startTime) / 30;
                for (var i = 0; i < duration; i++) {
                    time = time.add(30 - (time.minutes() % 30), 'minutes'); // next time to add
                    if (time > currentDateTime) {
                        var timeFormat = time.format('hh:mm A');
                        if (timeFormat === selectedTime) {
                            vm.selectedTime = timeFormat;
                        }
                        times.push(timeFormat);
                    }
                }
            }
            vm.times = times;
        };

        vm.selectedDateChanged();

        vm.deliveryAddressUpdated = function (formattedAddress) {
            if (formattedAddress && formattedAddress.location && formattedAddress.location.lat) {
                vm.delivery.address = formattedAddress.location;
            }
        };

        vm.consumerOptionSelected = function (option, isBookLater) {
            vm.loading = true;
            $state.go('payment-confirmation', { bookingInfo: { details: option, isBookLater: isBookLater }, paymentInfo: $transition$.params().paymentInfo }, { reload: true });
        };

        vm.pickUpSelected = function () {
            vm.loading = true;
            var formattedDateTime = new Date(vm.selectedDate.value + ' ' + vm.selectedTime);
            $state.go('payment-confirmation', { bookingInfo: { details: { systemTripTypeId: null }, pickup: { formattedDateTime: formattedDateTime, date: vm.selectedDate.value, time: vm.selectedTime } }, paymentInfo: $transition$.params().paymentInfo }, { reload: true });
        };

        vm.deliverySelected = function (option) {
            vm.loading = true;
            vm.deliveryErrorMessage = null;

            // Update delivery address
            consumerPaymentService.updateDeliveryAddress($transition$.params().invoiceGuid, vm.delivery.address, true).then(function () {
                $state.go('payment-confirmation', { bookingInfo: { details: option, delivery: { address: vm.delivery.address } }, paymentInfo: $transition$.params().paymentInfo }, { reload: true });
            }, function(err) {
                vm.deliveryErrorMessage = err.message;
            });
        };

        vm.back = function () {
            $state.go('payment-credit-card', $transition$.params());
        };
    }
})();

(function () {
    'use strict';

    paymentCreditCardController.$inject = ["invoice", "deliveryStyleValues", "cardsOnFile", "initializationToken", "$scope", "SYSTEM_ENUMS", "consumerPaymentService", "$transition$", "$state", "$timeout", "consumerPaymentTextService", "verbiage", "$sce", "toastr", "consumerPaymentModalService", "$window"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentCreditCardController', paymentCreditCardController);


    function paymentCreditCardController(invoice, deliveryStyleValues, cardsOnFile, initializationToken, $scope, SYSTEM_ENUMS, consumerPaymentService, $transition$, $state, $timeout, consumerPaymentTextService, verbiage, $sce, toastr, consumerPaymentModalService, $window) {
        var vm = this;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.data = {};
        vm.data.html = '';
        vm.data.invoice = vm.invoice = invoice;
        vm.data.nextPage = function () { };
        vm.data.cardsOnFile = cardsOnFile || [];
        vm.data.initializationToken = initializationToken;
        vm.data.usStates = SYSTEM_ENUMS.usStates;
        vm.paymentProcessorsEnum = SYSTEM_ENUMS.paymentProcessorsEnum;
        vm.data.newCardTitle = consumerPaymentTextService.makeTextUserFriendly(verbiage.newCardTitle, invoice);
        vm.data.newCardParagraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.newCardParagraph, invoice);
        vm.data.billingAddressTitle = consumerPaymentTextService.makeTextUserFriendly(verbiage.billingAddressTitle, invoice);
        vm.data.billingAddressParagraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.billingAddressParagraph, invoice);
        vm.data.paymentTitle = consumerPaymentTextService.makeTextUserFriendly(verbiage.paymentTitle, invoice);
        vm.data.paymentParagraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.paymentParagraph, invoice);
        vm.data.cardAdditionalSecurityTitle = consumerPaymentTextService.makeTextUserFriendly(verbiage.cardAdditionalSecurityTitle, invoice);
        vm.data.cardAdditionalSecurityParagraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.cardAdditionalSecurityParagraph, invoice);
        vm.params = $transition$.params();
    }
})();

(function () {
    'use strict';

    paymentConfirmationController.$inject = ["$scope", "deliveryStyleValues", "invoice", "consumerPaymentTextService", "consumerPaymentService", "verbiage", "$state", "$transition$", "$sce", "SYSTEM_ENUMS", "$interval", "isTest", "deliveryChargeType"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentConfirmationController', paymentConfirmationController);

    function paymentConfirmationController($scope, deliveryStyleValues, invoice, consumerPaymentTextService, consumerPaymentService, verbiage, $state, $transition$, $sce, SYSTEM_ENUMS, $interval, isTest, deliveryChargeType) {
        var vm = this;
        vm.invoice = invoice;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.data = {};
        vm.data.html = '';
        vm.params = $transition$.params();
        vm.delivery = null;
        vm.pickup = null;
        vm.bookingInfo = vm.params.bookingInfo;
        vm.title = consumerPaymentTextService.makeTextUserFriendly(verbiage.reviewAndSubmitTitle, invoice);
        vm.paragraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.reviewAndSubmitParagraph, invoice);
        vm.calculatedTotal = vm.invoice.total;
        vm.isBillToAccount = deliveryChargeType === SYSTEM_ENUMS.invoiceChargeTypes.billToAccount;
        vm.isPartsOnDemand = null;
        vm.initComplete = false;
        vm.hasError = false;
        vm.processingErrorMessage = null;
        vm.isTest = isTest;

        vm.init = function () {
            vm.tax = _.reduce(vm.invoice.lineItems, function (memo, item) {
                return memo + parseFloat(item.tax || 0);
            }, 0);

            vm.fee = _.reduce(vm.invoice.lineItems, function (memo, item) {
                return memo + parseFloat(item.fee || 0);
            }, 0);
            
            vm.shopSupplies = _.reduce(vm.invoice.lineItems, function (memo, item) {
                return memo + parseFloat(item.shopSupplies || 0);
            }, 0);

            // --- Delivery Setup ---
            if (vm.bookingInfo.details != null) {
                switch (vm.bookingInfo.details.systemTripTypeId) {
                    case SYSTEM_ENUMS.systemTripType.partsOnDemand:
                        if (vm.bookingInfo.delivery != null) {
                            vm.isPartsOnDemand = true;

                            vm.delivery = {
                                discount: vm.bookingInfo.delivery.discount,
                                address: vm.bookingInfo.delivery.address,
                                refreshTime: 30, // Time to refresh ride provider estimates
                                isUpdating: null
                            };

                            vm.countDownInterval = $interval(function () {
                                if (vm.delivery.isUpdating == null || vm.delivery.isUpdating == false) {
                                    if (vm.delivery.refreshCountdown == null || vm.delivery.refreshCountdown == 0) {
                                        vm.delivery.isUpdating = true;
                                        vm.delivery.refreshCountdown = vm.delivery.refreshTime;

                                        // Update ride provider estimate
                                        consumerPaymentService.updateDeliveryCostEstimate(vm.params.invoiceGuid, true, vm.isTest).then(function (result) {
                                            if (result != null) {
                                                vm.invoice = result;
                                                vm.calculatedTotal = vm.invoice.totalWithDelivery;
                                            } else {
                                                vm.hasError = true;
                                                vm.delivery.isUpdating = false;
                                                vm.initComplete = true;
                                                vm.cancelCountdown();
                                            }
                                            vm.delivery.isUpdating = false;
                                            vm.initComplete = true;
                                        }, function (reject) {
                                            vm.hasError = true;
                                            vm.calculatedTotal = vm.invoice.total;
                                            vm.delivery.isUpdating = false;
                                            vm.initComplete = true;
                                            vm.cancelCountdown();
                                        });
                                    } else if (vm.delivery.refreshCountdown <= 0) {
                                        vm.delivery.refreshCountdown = 0;
                                    } else {
                                        vm.delivery.refreshCountdown -= 1;
                                    }
                                }
                            }, 1000);
                        } else {
                            // Pickup
                            vm.pickup = vm.bookingInfo.pickup;
                            vm.initComplete = true;
                        }
                        break;
                    case null: // Pickup
                        vm.pickup = vm.bookingInfo.pickup;
                        vm.initComplete = true;
                        break;
                    default:
                        vm.initComplete = true;
                        break;
                }
            } else {
                vm.initComplete = true;
            }
        };

        vm.getEstimatedDiscount = function () {
            if (vm.delivery.options.paymentType) {
                switch (vm.delivery.options.paymentType) {
                    case 0: // Customer Pays
                        return 0;
                    case 1: // Dealer Pays
                        return -vm.getCurrentRideProviderEstimate();
                    case 2: // $ Discount
                        return -Number(vm.delivery.options.discountAmount);
                    case 3: // % Discount
                        return -vm.getCurrentRideProviderEstimate() * (Number(vm.delivery.options.discountAmount / 100) > 1 ? 1 : Number(vm.delivery.options.discountAmount) / 100);
                }
            }

            return 0;
        };

        vm.getTotal = function () {
            return vm.getCurrentRideProviderEstimate() + vm.getEstimatedDiscount() + vm.getPreviousTotal();
        };

        vm.getCurrentRideProviderEstimate = function () {
            if (vm.delivery.rideProviderDetails != null) {
                return vm.delivery.rideProviderDetails.estimatedCostCents / 100;
            }
            return 0;
        };

        vm.showSecure3d = function (html) {
            vm.data.html = $sce.trustAsHtml(html);
            window['handle3DSecure'] = vm.handle3DSecure;

            $scope.$on('destroy', function () {
                window['handle3DSecure'] = null;
            });
        };

        vm.handle3DSecure = function (result) {
            vm.data.html = '';
            vm.processingErrorMessage = null;
            var jsonResult = JSON.parse(result);
            jsonResult.AuthorizationNumber = jsonResult.AuthorizationNumber || jsonResult.AutorizationNumber;
            consumerPaymentService.validateTransaction(vm.params.invoiceGuid, jsonResult, vm.bookingInfo, vm.isPartsOnDemand, vm.isTest).then(function (result) {
                if (result && result.success) {
                    vm.data.html = '';
                    vm.invoice.status = SYSTEM_ENUMS.invoiceStatus.paid;
                    $state.go('payment-success', { result: result }, { reload: true });
                    vm.loading = false;
                }
                else if (result.message == null) {
                    vm.handleTransactionError({ message: 'Error: Unknown Error' });
                } else {
                    vm.handleTransactionError(result);
                }
            }, function (reject) {
                vm.handleTransactionError(reject);
            }).catch(function (err) {
                vm.handleTransactionError(err);
            });
        };

        vm.cancel3dSecure = function () {
            vm.data.html = '';
            vm.loading = false;
        };

        vm.handleTransactionError = function (result) {
            vm.loading = false;
            var errorMessage = result.data ? result.data.message : result.message;
            if (errorMessage === 'Invoice already paid' || errorMessage === 'Duplicated transaction') {
                $state.go('payment-success', null, { reload: true });
            } else {
                // Display error message
                vm.processingErrorMessage = errorMessage;
                // uncheck authorized
                vm.customerAuthorized = false;
                // restart countdown
                vm.init();
            }
        };

        vm.pay = function () {
            vm.processingErrorMessage = null;
            if (vm.isBillToAccount) {
                consumerPaymentService.processInvoice(vm.params.invoiceGuid, vm.bookingInfo, vm.isPartsOnDemand, vm.isTest).then(function (result) {
                    if (result && result.success) {
                        $state.go('payment-success', { result: result }, { reload: true });
                        vm.loading = false;
                    }
                    else {
                        vm.handleTransactionError(result);
                    }
                }, function (reject) {
                    vm.handleTransactionError(reject);
                });
            } else {
                consumerPaymentService.sendPayment(vm.params.invoiceGuid, vm.params.paymentInfo.selectedToken, vm.params.paymentInfo.emailAddress, vm.params.paymentInfo.billingAddress.street, vm.params.paymentInfo.billingAddress.city, vm.params.paymentInfo.billingAddress.state, vm.params.paymentInfo.billingAddress.zip, false, vm.bookingInfo, vm.isPartsOnDemand, vm.isTest).then(function (result) {
                    if (result && result.success) {
                        vm.invoice.status = SYSTEM_ENUMS.invoiceStatus.paid;
                        $state.go('payment-success', { result: result }, { reload: true });
                        vm.loading = false;
                    }
                    else {
                        if (result.resultCode === SYSTEM_ENUMS.cenposStatus.is3DSecureTransaction) {
                            vm.showSecure3d(result.htmlToDisplay);
                        }
                        else {
                            vm.handleTransactionError(result);
                        }
                    }
                }, function (reject) {
                    vm.handleTransactionError(reject);
                });
            }
        };

        vm.nextPage = function () {
            vm.loading = true;
            vm.cancelCountdown();
            vm.pay();
        };

        vm.back = function () {
            vm.cancelCountdown();
            if (vm.invoice.isPodCheckout) {
                $state.go('payment-delivery-options', $transition$.params(), { reload: true });
            } else {
                $state.go('payment-credit-card', $transition$.params(), { reload: true });
            }
        };

        vm.cancelCountdown = function () {
            if (vm.countDownInterval != null) {
                $interval.cancel(vm.countDownInterval);
                vm.countDownInterval = null;
            }
        };

        vm.$onDestroy = function () {
            vm.cancelCountdown();
        };

        // Init the delivery and other options
        vm.init();
    }
})();

(function () {
    'use strict';

    paymentBringItInController.$inject = ["invoice", "deliveryStyleValues", "dealerHours", "consumerPaymentService", "consumerPaymentTextService", "verbiage", "$state", "$transition$"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentBringItInController', paymentBringItInController);


    function paymentBringItInController(invoice, deliveryStyleValues, dealerHours, consumerPaymentService, consumerPaymentTextService, verbiage, $state, $transition$) {
        var vm = this;
        vm.invoice = invoice;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.dealerHours = dealerHours;
        vm.paragraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.bookingParagraph, invoice);

        var date = moment(new Date()),
            today = moment(new Date());

        vm.dates = [];

        function findDealerHoursForDay(momentDate) {
            return dealerHours.hours.find(function (item) {
                return momentDate.day() === item.dayOfWeekId;
            });
        }

        var hoursForToday = findDealerHoursForDay(today);
        if (hoursForToday) {
            if (moment(today.format('MM/DD/YYYY')).add(hoursForToday.endTime) < today) {
                date = date.add(1, 'days');
            }
        }
        for (var i = 0; i < 7; i++) {
            if ((dealerHours.blackouts && dealerHours.blackouts.some(function (item) { return moment(item).format('MM/DD/YYYY') === date.format('MM/DD/YYYY'); })) ||
                (dealerHours.hours && dealerHours.hours.every(function (item) { return item.dayOfWeekId !== date.day(); })))
            {
                i--;
                date = date.add(1, 'days');
                continue;
            }

            var dateObj = { value: date.format('MM/DD/YYYY'), text: date.format('MM/DD') };
            if (date.format('MM/DD/YYYY') === today.format('MM/DD/YYYY')) {
                dateObj.text += ' Today';
            }

            vm.dates.push(dateObj);
            date = date.add(1, 'days');
        }

        vm.selectedDate = vm.dates[0];

        vm.selectedDateChanged = function() {
            var times = [],
                dayOfWeekFiltered = findDealerHoursForDay(moment(vm.selectedDate.value));
            var selectedTime = vm.selectedTime;
            vm.selectedTime = '';

            if (dayOfWeekFiltered) {
                var time = moment(vm.selectedDate.value).add(dayOfWeekFiltered.startTime, 'minutes');
                times.push(time.format('hh:mm A')); // add the start date.

                var duration = (dayOfWeekFiltered.endTime - dayOfWeekFiltered.startTime) / 30;
                for (var i = 0; i < duration; i++) {
                    time = time.add(30 - (time.minutes() % 30), 'minutes'); // next time to add
                    if (time > today) {
                        var timeFormat = time.format('hh:mm A');
                        if (timeFormat === selectedTime) {
                            vm.selectedTime = timeFormat;
                        }
                        times.push(timeFormat);
                    }
                }
            }
            vm.times = times;
        };

        vm.selectedDateChanged();


        vm.nextPage = function () {
            vm.loading = true;
            consumerPaymentService.setComeInTime($transition$.params()['invoiceGuid'], vm.selectedDate.value, vm.selectedTime).then(function() {
                $state.go('payment-success', { invoice: null }, { reload: true });
            }).finally(function() {
                vm.loading = false;
            });

        };
    }
})();

(function () {
    'use strict';

    paymentBookTripController.$inject = ["invoice", "deliveryStyleValues", "consumerPaymentTextService", "verbiage", "offeredTripTypes", "$state", "$transition$", "consumerPaymentService"];
    angular
        .module('redcap.consumer.payments')
        .controller('PaymentBookTripController', paymentBookTripController);


    function paymentBookTripController(invoice, deliveryStyleValues, consumerPaymentTextService, verbiage, offeredTripTypes, $state, $transition$, consumerPaymentService) {
        var vm = this;
        vm.invoice = invoice;
        vm.deliveryStyleValues = deliveryStyleValues;
        vm.offeredTripTypes = offeredTripTypes;
        vm.title = consumerPaymentTextService.makeTextUserFriendly(verbiage.bookingTitle, invoice);
        vm.paragraph = consumerPaymentTextService.makeTextUserFriendly(verbiage.bookingParagraph, invoice);

        vm.bookLater = function (option) {
            consumerPaymentService.bookLater($transition$.params().invoiceGuid, option.dealerTripTypeId, option.workflowId).then(function(result) {
                if (result) {
                    $state.go('payment-success-no-booking', { invoice: null }, { reload: true });
                }
            });
        };
    }


})();

(function () {
    "use strict";

    consumerLoanerService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "consumerApi"];
    angular
        .module("redcap.consumer.loaner")
        .factory("consumerLoanerService", consumerLoanerService);

    function consumerLoanerService($q, $log, $filter, $http, $rootScope, consumerApi) {

        var BASEPATH = "consumer/loaner/";

        return {
            getVehicleChoices: getVehicleChoices,
            getUser: getUser,
            getClientToken: getClientToken,
            saveProfile: saveProfile,
            getVehicle: getVehicle,
            getVehicleIssues: getVehicleIssues,
            getContractPdfLink: getContractPdfLink,
            signContract: signContract,
            getTerms: getTerms,
            getIssueImages: getIssueImages,
            chooseLyftCredits: chooseLyftCredits,
            beforeContractSigned: beforeContractSigned
        };

        function getUser(userGuid, dealerId) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid);
        }

        function getVehicleChoices(dealerId, userGuid) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/vehiclechoices');
        }

        function getTerms(dealerId, userGuid) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/terms');
        }

        function getClientToken(userGuid, dealerId) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/token');
        }

        function saveProfile(userGuid, dealerId, data) {
            return consumerApi.post(BASEPATH + dealerId + '/' + userGuid + '', data);
        }

        function chooseLyftCredits(userGuid, dealerId) {
            return consumerApi.post(BASEPATH + dealerId + '/' + userGuid + '/lyftCredits');
        }

        function getVehicle(dealerId, userGuid) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/vehicle');
        }

        function getVehicleIssues(dealerId, userGuid) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/issues');
        }

        function getIssueImages(dealerId, userGuid, issueId) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/issueimages/' + issueId);
        }

        function getContractPdfLink(dealerId, userGuid) {
            return consumerApi.get(BASEPATH + dealerId + '/' + userGuid + '/contractpdf');
        }

        function beforeContractSigned(dealerId, userGuid) {
            return consumerApi.post(BASEPATH + dealerId + '/' + userGuid + '/beforeContractSigned', null);
        }

        function signContract(dealerId, userGuid, signatureImageData, agreedTerms) {
            return consumerApi.post(BASEPATH + dealerId + '/' + userGuid + '/sign',
                {
                    image: signatureImageData,
                    agreedTerms: agreedTerms
                });
        }
    }

})();

(function () {
    'use strict';

    LoanerConsumerSignatureController.$inject = ["$transition$", "resolvedIssues", "resolvedUser", "resolvedDealerBranding", "resolvedTerms", "resolvedVehicle", "resolvedContractLink", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerConsumerSignatureController', LoanerConsumerSignatureController);


    function LoanerConsumerSignatureController($transition$, resolvedIssues, resolvedUser, resolvedDealerBranding, resolvedTerms, resolvedVehicle, resolvedContractLink, SYSTEM_ENUMS) {
        var vm = this;
        vm.routeParams = $transition$.params();
        vm.issues = resolvedIssues || [];
        vm.terms = resolvedTerms || [];
        vm.dealerBranding = resolvedDealerBranding;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.resolvedUser = resolvedUser;
        vm.SYSTEM_ENUMS = SYSTEM_ENUMS;

        if (resolvedVehicle.fuelCapacity && resolvedVehicle.fuelCapacity > 0) {
            vm.fuel = (resolvedVehicle.fuelInLiters / resolvedVehicle.fuelCapacity) * 100;
        } else {
            vm.fuel = resolvedVehicle.fuel;
        }

        vm.fuel = vm.fuel || 0;
        vm.year = resolvedVehicle.year;
        vm.make = resolvedVehicle.make;
        vm.model = resolvedVehicle.model;
        vm.mileage = resolvedVehicle.mileage;
        vm.vin = resolvedVehicle.vin;
        vm.contractLink = resolvedContractLink;

        vm.maxWidth = 768 > window.innerWidth ? 768 : window.innerWidth;
    }
})();

(function () {
    'use strict';

    LoanerConsumerSignatureCompleteController.$inject = ["$transition$", "$state", "resolvedIssues", "resolvedDealerBranding", "resolvedVehicle", "resolvedContractLink", "resolvedUser", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerConsumerSignatureCompleteController', LoanerConsumerSignatureCompleteController);


    function LoanerConsumerSignatureCompleteController($transition$, $state, resolvedIssues, resolvedDealerBranding, resolvedVehicle, resolvedContractLink, resolvedUser, SYSTEM_ENUMS) {
        var vm = this;
        vm.routeParams = $transition$.params();
        vm.issues = $state.params.issues || resolvedIssues || [];
        vm.dealerBranding = resolvedDealerBranding;
        vm.terms = $state.params.terms;
        vm.imageUrl = $state.params.signatureImageUrl;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.sliderOptions = {
            hidePointerLabels: true,
            hideLimitLabels: true,
            enforceStep: false,
            step: 1,
            floor: 0,
            ceil: 100,
            disabled: true,
            showSelectionBar: true,
            ticksArray: [
                { value: 0, legend: 'E' },
                { value: 12.5, legend: '1/8' },
                { value: 25, legend: '1/4' },
                { value: 37.5, legend: '3/8' },
                { value: 50, legend: '1/2' },
                { value: 62.5, legend: '5/8' },
                { value: 75, legend: '3/4' },
                { value: 87.5, legend: '7/8' },
                { value: 100, legend: 'F' }
            ]
        };

        if (resolvedVehicle.fuelCapacity && resolvedVehicle.fuelCapacity > 0) {
            vm.fuel = (resolvedVehicle.fuelInLiters / resolvedVehicle.fuelCapacity) * 100;
        } else {
            vm.fuel = resolvedVehicle.fuel;
        }

        vm.fuel = vm.fuel || 0;
        vm.year = resolvedVehicle.year;
        vm.make = resolvedVehicle.make;
        vm.model = resolvedVehicle.model;
        vm.mileage = resolvedVehicle.mileage;
        vm.vin = resolvedVehicle.vin;
        vm.contractLink = resolvedContractLink;
        vm.contractSignedDate = resolvedUser.contractSignedDate;
        vm.SYSTEM_ENUMS = SYSTEM_ENUMS;
    }
})();

(function () {
    'use strict';

    LoanerConsumerProfileCompleteController.$inject = ["$transition$", "resolvedDealerBranding", "resolvedUser", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerConsumerProfileCompleteController', LoanerConsumerProfileCompleteController);


    function LoanerConsumerProfileCompleteController($transition$, resolvedDealerBranding, resolvedUser, SYSTEM_ENUMS) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;
        vm.resolvedUser = resolvedUser;
        vm.params = $transition$.params();
        
        if (vm.params.loanerPreferences) {
            vm.loanerPreferences = vm.params.loanerPreferences;
            vm.resolvedUser.loanerPreferences = vm.params.loanerPreferences;
        }

        vm.isLyftCredit = function () {
            if (!vm.resolvedUser.enableLoanerPreferences) return false;

            if (!vm.loanerPreferences) return false;

            return vm.loanerPreferences.transportationType === SYSTEM_ENUMS.cflTransportationTypes.lyftCredit;
        };

        vm.license = vm.params.license;
        vm.card = vm.params.card && vm.params.card.details ? vm.card : null;
        vm.cardProvided = vm.params.card;
        vm.insurance = vm.params.insurance;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.loanerClientType = vm.dealerBranding.configValues.loanerClientType;
      
    }
})();

(function () {
    'use strict';

    LoanerLandingController.$inject = ["user", "$state", "resolvedDealerBranding", "resolvedUser", "consumerLoanerService"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerLandingController', LoanerLandingController);


    function LoanerLandingController(user, $state, resolvedDealerBranding, resolvedUser, consumerLoanerService) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;
        vm.configValues = vm.dealerBranding.configValues;
        vm.resolvedUser = resolvedUser;
       
        function displayLoanerPreferences () {
            var user = vm.resolvedUser;
            return user.enableLoanerPreferences === true && (user.canChooseLoanerPreferences === true || user.enableLyftCreditAlternative === true);
        }

        vm.tasks = [
            {
                text: vm.configValues.loanerSelectPreferences,
                hide: vm.resolvedUser.profileComplete || !displayLoanerPreferences()
            },
            {
                text: vm.configValues.loanerLicenseBullet,
                hide: vm.resolvedUser.profileComplete
            },
            {
                text: vm.configValues.loanerInsuranceBullet,
                hide: vm.resolvedUser.profileComplete
            },
            {
                text: vm.configValues.loanerCreditCardBullet,
                hide: !vm.resolvedUser.isCreditCardRequired || vm.resolvedUser.profileComplete
            },
            {
                text: vm.configValues.loanerHasLoanerBullet,
                hide: !vm.resolvedUser.isStartContractLoanerTasksComplete || vm.resolvedUser.isContractStarted
            },
            {
                text: vm.configValues.loanerReviewAndSignBullet,
                hide: !vm.resolvedUser.isStartContractLoanerTasksComplete || vm.resolvedUser.isContractStarted
            },
            {
                text: vm.configValues.loanerViewConfirmationBullet,
                hide: vm.resolvedUser.isStartContractLoanerTasksComplete || !vm.resolvedUser.profileComplete && !vm.resolvedUser.isContractStarted
            }
        ];

        vm.tasks = vm.tasks.filter(function (item) {
            return !item.hide;
        });

        vm.nextPage = function () {
            vm.loading = true;
            var params = {},
                route = null,
                user = vm.resolvedUser;

            if (displayLoanerPreferences() && !user.profileComplete && !vm.resolvedUser.isStartContractLoanerTasksComplete && !vm.resolvedUser.isContractStarted) {
                route = 'loaner-cfl-transportation';
                params = {branding: vm.dealerBranding };
            } else if (!user.profileComplete) {
                route = 'loaner-driver-info';
                params = {fromState: 'loaner-landing'};
            } else {
                if (!user.isStartContractLoanerTasksComplete || user.isContractStarted === true) {
                    route = 'loaner-profile-complete';
                    params = { fromStart: true };
                } else {
                    route = 'loaner-signature';
                }
            }

            $state.go(route, params).finally(function () {
                vm.loading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    LoanerErrorController.$inject = ["$transition$", "resolvedDealerBranding"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerErrorController', LoanerErrorController);


    function LoanerErrorController($transition$, resolvedDealerBranding) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;

        vm.goBack = goBack;
        vm.error = $transition$.params().error || 'An error has occurred. If the error persists, please contact your dealership.';
        vm.title = $transition$.params().title || 'Oops...';
        vm.dealershipName = vm.dealerBranding.name;
        vm.dealershipPhone = vm.dealerBranding.mainPhoneNumber;
    }

    function goBack(){
        window.history.back();
    }
})();

(function () {
    'use strict';

    LoanerDriverInfoController.$inject = ["$state", "$transition$", "SYSTEM_ENUMS", "resolvedDealerBranding", "resolvedUser", "pdf417Service", "azureBlob", "$q", "rcUtilService"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerDriverInfoController', LoanerDriverInfoController);


    function LoanerDriverInfoController($state, $transition$, SYSTEM_ENUMS, resolvedDealerBranding, resolvedUser, pdf417Service, azureBlob, $q, rcUtilService) {
        var vm = this,
            params = $transition$.params(),
            currentYear = new Date().getFullYear();

        function buildExpiresYearList() {
            var i,
                years = [];

            for (i = currentYear; i < currentYear + 12; i++) {
                years.push(i.toString());
            }

            return years;
        }

        vm.underAge = false;
        vm.dlExpired = false;
        vm.insExpired = false;
        vm.calendarMonths = SYSTEM_ENUMS.calendarMonths;
        vm.expiresYears = buildExpiresYearList();
        vm.minDate = moment().format('MM/DD/YYYY');
        vm.maxDate = moment().add(180, 'days').format('MM/DD/YYYY');
        vm.minInsuranceExpYear = currentYear - 13;
        vm.maxInsuranceExpYear = currentYear + 13;
        vm.minBirthDateYear = 1900;
        vm.maxBirthDateYear = currentYear;
        vm.minAge = 21;
        vm.calendarMonths = SYSTEM_ENUMS.calendarMonths;
        vm.dobDays = null;
        vm.licenseExpDays = null;
        vm.insuranceExpDays = null;

        vm.usStates = SYSTEM_ENUMS.usStates;
        vm.dealerBranding = resolvedDealerBranding;
        vm.configValues = vm.dealerBranding.configValues;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.loanerClientType = vm.dealerBranding.configValues.loanerClientType;

        vm.resolvedUser = resolvedUser;
        vm.SYSTEM_ENUMS = SYSTEM_ENUMS;

        vm.params = $transition$.params();
        vm.credentialsValid = vm.params.credentialsValid;
        vm.credentialsError = vm.params.credentialsError;

        vm.scanError = null;

        vm.license = params.license || {
            photoFront: {},
            photoBack: {},
            number: null,
            expiration: null,
            dateOfBirth: null
        };

        vm.insurance = params.insurance || {
            photo: {},
            carrier: null,
            policy: null,
            expiration: null
        };

        function init() {
            if (vm.license.expiration) {
                var expire = vm.license.expiration;

                vm.setLicenseExpirationInputs(expire);
                vm.dlExpired = vm.validateNotExpired(vm.licenseExpDay, vm.licenseExpMonth, vm.licenseExpYear);
                vm.setLicenseExpiration();
            }

            if (vm.license.dateOfBirth) {
                var dob = vm.license.dateOfBirth;

                vm.setLicenseDOBInputs(dob);
                vm.setLicenseDOB();
            }

            if (vm.insurance.expiration) {
                var expireIns = vm.insurance.expiration;

                vm.setInsuranceExpirationInputs(expireIns);
                vm.setInsuranceExpiration();
            }
        }

        vm.vehicleKeyDown = function (e) {
            if (e.keyCode === 9) return;

            if (!(e.keyCode > 95 && e.keyCode < 106
                || e.keyCode > 47 && e.keyCode < 58
                || e.keyCode === 8)) {
                e.preventDefault();
            }
        };

        vm.isDOBYearInvalid = function () {
            if (!vm.dobYear) return true;

            var year = parseInt(vm.dobYear);
            if (year < vm.minBirthDateYear || year > vm.maxBirthDateYear) {
                return true;
            }

            return false;
        };

        vm.validation = {
            valLicenseExpYear: function () {
                if (!vm.licenseExpYear || vm.licenseExpYear === '') {
                    return { isValid: false, message: 'Required' };
                }

                var year = parseInt(vm.licenseExpYear);
                if (year < vm.minLicenseExpYear || year > vm.maxLicenseExpYear) {
                    return { isValid: false, message: '' };
                }
                else {
                    return true;
                }
            },
            valDOBYear: function () {
                if (!vm.dobYear || vm.dobYear === '') {
                    return { isValid: false, message: 'Required' };
                }

                var year = parseInt(vm.dobYear);
                if (year < vm.minBirthDateYear || year > vm.maxBirthDateYear) {
                    return { isValid: false, message: '' };
                }
                else {
                    return true;
                }
            },
            valInsuranceExpYear: function () {
                if (!vm.insuranceExpYear || vm.insuranceExpYear === '') {
                    return { isValid: false, message: 'Required' };
                }

                var year = parseInt(vm.insuranceExpYear);
                if (year < vm.minInsuranceExpYear || year > vm.maxInsuranceExpYear) {
                    return { isValid: false, message: '' };
                }
                else {
                    return true;
                }
            }
        };

        vm.getCalendarDays = function (year, month) {
            var days = new Date(year, month, 0).getDate(),
                dayArr = [];

            dayArr = _.range(1, days+1).map(function (num) { return ('0' + num).slice(-2); });

            return dayArr;
        };

        vm.setLicenseExpirationInputs = function (expireDate) {
            vm.licenseExpYear = expireDate.getFullYear() + "";
            vm.licenseExpMonth = ("0"+(expireDate.getMonth()+1)).slice(-2);
            vm.driversLicenseMonthYearUpdated();
            vm.licenseExpDay = ("0" + expireDate.getDate()).slice(-2);
        };

        vm.setLicenseExpiration = function () {
            if (vm.licenseExpYear && vm.licenseExpMonth && vm.licenseExpDay) {
                vm.license.expiration = new Date(vm.licenseExpYear + '-' + vm.licenseExpMonth + '-' + vm.licenseExpDay + 'T00:00:00');
            } else {
                vm.license.expiration = null;
            }
        };

        vm.setLicenseDOBInputs = function(dob) {
            vm.dobYear = dob.getFullYear() + "";
            vm.dobMonth = ("0"+(dob.getMonth()+1)).slice(-2);
            vm.updateDOBCalendarDays();
            vm.dobDay = ("0" + dob.getDate()).slice(-2);
        };

        vm.setLicenseDOB = function () {
            if (vm.dobYear && vm.dobMonth && vm.dobDay) {
                vm.license.dateOfBirth = new Date(vm.dobYear + '-' + vm.dobMonth + '-' + vm.dobDay + 'T00:00:00');

                var age = moment().diff(moment(vm.dobYear + '-' + vm.dobMonth + '-' + vm.dobDay), 'years');
                if (age < vm.minAge) {
                    vm.underAge = true;
                } else {
                    vm.underAge = false;
                }
            } else {
                vm.license.dateOfBirth = null;
                vm.underAge = false;
            }

        };

        vm.setInsuranceExpirationInputs = function(expireDate) {
            vm.insuranceExpYear = expireDate.getFullYear() + "";
            vm.insuranceExpMonth = ("0"+(expireDate.getMonth()+1)).slice(-2);
            vm.insuranceMonthYearUpdated();
            vm.insuranceExpDay = ("0" + expireDate.getDate()).slice(-2);
        };

        vm.setInsuranceExpiration = function () {
            if (vm.insuranceExpYear && vm.insuranceExpMonth && vm.insuranceExpDay) {
                vm.insurance.expiration = new Date(vm.insuranceExpYear + '-' + vm.insuranceExpMonth + '-' + vm.insuranceExpDay + 'T00:00:00');
            } else {
                vm.insurance.expiration = null;
            }
        };

        vm.updateDOBCalendarDays = function () {
            if (vm.isDOBYearInvalid(vm.dobYear)) {
                vm.dobDays = null;
                return;
            }

            vm.dobDays = vm.getCalendarDays(vm.dobYear, vm.dobMonth);

            vm.setLicenseDOB();
        };

        vm.validateNotExpired = function (day, month, year) {
            if (!day || !month || !year) {
                return false;
            }

            var dateToCheck = new Date(month + '/' + day + '/' + year);

            return dateToCheck < new Date();
        };

        vm.driversLicenseMonthYearUpdated = function () {
            if (!vm.licenseExpMonth || !vm.licenseExpYear) {
                vm.licenceExpDays = null;
            } else {
                vm.licenseExpDays = vm.getCalendarDays(vm.licenseExpYear, vm.licenseExpMonth);
            }

            vm.dlExpired = vm.validateNotExpired(vm.licenseExpDay, vm.licenseExpMonth, vm.licenseExpYear);

            vm.setLicenseExpiration();
        };

        vm.driversLicenseDayUpdated = function () {
            vm.dlExpired = vm.validateNotExpired(vm.licenseExpDay, vm.licenseExpMonth, vm.licenseExpYear);
            vm.setLicenseExpiration();
        };

        vm.insuranceMonthYearUpdated = function () {
            if (!vm.insuranceExpMonth || !vm.insuranceExpYear) {
                vm.insuranceExpDays = null;
            } else {
                vm.insuranceExpDays = vm.getCalendarDays(vm.insuranceExpYear, vm.insuranceExpMonth);
            }

            vm.insExpired = vm.validateNotExpired(vm.insuranceExpDay, vm.insuranceExpMonth, vm.insuranceExpYear);
            vm.setInsuranceExpiration();

        };

        vm.insuranceDayUpdated = function () {
            vm.insExpired = vm.validateNotExpired(vm.insuranceExpDay, vm.insuranceExpMonth, vm.insuranceExpYear);
            vm.setInsuranceExpiration();
        };

        vm.dobDayUpdated = function () {
            vm.setLicenseDOB();
        };

        vm.imageUploadMap = {
            'licenseFront': resolvedUser.driversLicenseFrontToken,
            'licenseBack': resolvedUser.driversLicenseBackToken,
            'insuranceFront': resolvedUser.insuranceToken
        };

        vm.upload = function ($model, file, $files, $event, $id) {
            var result = $q.defer();
            var map = vm.imageUploadMap[$id];
            var config = {
                baseUrl: map,
                file: file,
                complete: function () {
                    result.resolve('upload complete');
                },
                error: function(err) {
                    result.reject(err);
                },
                blockSize: 4000000000
            };
            azureBlob.upload(config);
            return result.promise;

        };

        vm.readAndUpload = function ($model, $file, $files, $event, $id) {
            var defer = $q.defer();

            vm.upload($model, $file, $files, $event, $id).then(function() {
                pdf417Service.readBarcode($files).then(function (results) {
                    var result = results && results.length && results[0] || {};
                    if (result.address1) {
                        vm.license.addressLine1 = result.address1;
                    }
                    if (result.address2) {
                        vm.license.addressLine2 = result.address2;
                    }

                    if (result.city) {
                        vm.license.addressCity = result.city;
                    }

                    if (result.state) {
                        vm.license.addressState = result.state;
                    }

                    if (result.zip) {
                        vm.license.addressZip = result.zip;
                    }

                    if (result.firstName) {
                        vm.license.firstName = result.firstName;
                    }
                    if (result.lastName) {
                        vm.license.lastName = result.lastName;
                    }

                    if (result.dateOfBirth) {
                        var dob = result.dateOfBirth;

                        vm.setLicenseDOBInputs(dob);
                        vm.setLicenseDOB();
                    }

                    if (result.licenseNumber) {
                        vm.license.number = result.licenseNumber;
                    }

                    if (result.expiration) {
                        var expire = result.expiration;

                        vm.setLicenseExpirationInputs(expire);
                        vm.dlExpired = vm.validateNotExpired(vm.licenseExpDay, vm.licenseExpMonth, vm.licenseExpYear);
                        vm.setLicenseExpiration();
                    }
                    vm.scanError = null;
                    defer.resolve('upload and scan complete');
                }).catch(function(err) {
                    rcUtilService.noBarCodeDetected(vm, err);
                });
            }).catch(function (err) {
                defer.reject(err);
            });
            return defer.promise;
        };

        vm.nextPage = function () {
            vm.credentialsValid = null;
            vm.loading = true;

            var nextState = vm.resolvedUser.isCreditCardRequired ? 'loaner-credit-card-info' : 'loaner-confirmation';
            $state.go(nextState, {license: vm.license, insurance: vm.insurance, transportationType: params.transportationType, vehiclePreferences: params.vehiclePreferences}).finally(function() {
                vm.loading = false;
            });
        };

        vm.back = function () {
            vm.loading = true;
            var fromPage = params.fromState || 'loaner-landing';
            $state.go(fromPage).finally(function () {
                vm.loading = false;
            });
        };

        init();
    }
})();

(function () {
    'use strict';

    LoanerConsumerCreditCardController.$inject = ["$transition$", "$scope", "resolvedDealerBranding", "resolvedUser", "resolvedToken", "$state", "SYSTEM_ENUMS", "$sce"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerConsumerCreditCardController', LoanerConsumerCreditCardController);


    function LoanerConsumerCreditCardController($transition$, $scope, resolvedDealerBranding, resolvedUser, resolvedToken, $state, SYSTEM_ENUMS, $sce) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;
        vm.resolvedUser = resolvedUser;

        vm.token = resolvedToken.token;
        vm.url = resolvedToken.url;
        vm.loanerClientType = resolvedToken.loanerClientType;
        vm.SYSTEM_ENUMS = SYSTEM_ENUMS;

        vm.params = $transition$.params();
        vm.dropinInstance = null;
        vm.loading = true;
        vm.paymentMethodValid = vm.params.paymentMethodValid;

        vm.submitCard = function () {
            vm.paymentMethodValid = null;
            if (vm.dropinInstance) {
                vm.dropinInstance.requestPaymentMethod().then(function (result) {
                    vm.dropinInstance.teardown().then(function (err) {
                        $state.go('loaner-confirmation', { card: result });
                    }).finally(function () {
                        vm.loading = false;
                    });
                });
            }
        };

        vm.nextPage = vm.submitCard;
        switch (vm.loanerClientType) {
            case SYSTEM_ENUMS.loanerManagementSystemsEnum.DealerWare:
                braintree.dropin.create({
                    authorization: vm.token,
                    container: '#creditcardform',
                    card: {
                        cardholderName: {
                            required: true
                        }
                    }
                }).then(function (instance) {
                    vm.dropinInstance = instance;
                    vm.loading = false;
                    $scope.$digest();
                });
                break;
            case SYSTEM_ENUMS.loanerManagementSystemsEnum.ARS:
                var css = 'body{font-family:"open sans","Helvetica Neue",Helvetica,Arial,sans-serif;line-height:1.42857;color:#626262;margin:0}' +
                    'label+br{display: none}' +
                    'label{width:30%;min-width:100px;font-size:13px;font-weight:bold;white-space:pre-wrap;}' +
                    'label,input,select{display:inline-block;margin-bottom:10px;}' +
                    'input{font-size:16px;padding:6px 12px;}' +
                    'select{font-size:16px;padding:6px 12px;}' +
                    '#ccnumfield{width:55%}' +
                    '#ccexpirymonth{margin-right:-4px}';

                vm.iframedURL = $sce.trustAsResourceUrl(vm.url + "&css=" + encodeURIComponent(css));
                break;
            case SYSTEM_ENUMS.loanerManagementSystemsEnum.TSDNew:

                vm.iframedURL = $sce.trustAsResourceUrl(vm.url);
                break;
        }

        vm.iFrameOnloadTsd = function () {
            try {
                window.addEventListener("message", vm.iFrameReceiveMessageTsd, false);
            }
            catch (e) {
                
             }
            try {
                window.attachEvent('onmessage', vm.iFrameReceiveMessageTsd);
            }
            catch (e) { }
        };

        vm.iFrameReceiveMessageTsd = function (event) {
            console.log("Event, data: " + event.data);
        };

        vm.iFrameOnload = function () {
            try {
                window.addEventListener("message", vm.iFrameReceiveMessage, false);
            }
            catch (e) {
                
             }
            try {
                window.attachEvent('onmessage', vm.iFrameReceiveMessage);
            }
            catch (e) { }
        };

        vm.iFrameReceiveMessage = function (event) {
            if (event.data == 'CCStatus=OK') {
                $state.go('loaner-confirmation', { card: {} });
            }
            else {
                vm.back();
            }
        };

        vm.nextTSD = function () {
            vm.loading = true;
            $state.go('loaner-confirmation', { card: {} }).finally(function () {
                vm.loading = false;
            });
        };

        vm.back = function () {
            vm.loading = true;
            $state.go('loaner-driver-info').finally(function () {
                vm.loading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    LoanerConsumerConfirmationController.$inject = ["$transition$", "$state", "resolvedDealerBranding", "resolvedUser", "consumerLoanerService", "timeUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerConsumerConfirmationController', LoanerConsumerConfirmationController);


    function LoanerConsumerConfirmationController($transition$, $state, resolvedDealerBranding, resolvedUser, consumerLoanerService, timeUtilService, SYSTEM_ENUMS) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;
        vm.resolvedUser = resolvedUser;
        vm.params = $transition$.params();
        vm.license = vm.params.license;
        vm.card = vm.params.card && vm.params.card.details ? vm.params.card : null; 
        vm.cardProvided = vm.params.card;
        vm.insurance = vm.params.insurance;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.loanerClientType = vm.dealerBranding.configValues.loanerClientType;
        vm.toLocalTimeFormat = timeUtilService.toLocalTimeFormat;
        vm.savingSuccessful = false;

        vm.loanerPreferences = {
            transportationType: vm.params.transportationType,
            usePoints: vm.params.usePoints,
            vehicles: vm.params.vehiclePreferences
        };

        vm.isLyftCredit = function () {
            if (!vm.resolvedUser.enableLoanerPreferences) return false;

            if (!vm.loanerPreferences) return false;

            return vm.loanerPreferences.transportationType === SYSTEM_ENUMS.cflTransportationTypes.lyftCredit;
        };

        vm.dropinInstance = null;
        vm.nextPage = function () {
            vm.error = null;
            vm.loading = true; 
            vm.savingProfile = true;
            var data = {
                transportation: {
                    transportationType: vm.loanerPreferences ? vm.loanerPreferences.transportationType : null,
                    vehiclePreferences: vm.loanerPreferences ? vm.loanerPreferences.vehicles : null,
                    usePoints: vm.loanerPreferences ? vm.loanerPreferences.usePoints : null
                },
                creditCard: vm.card,
                profile: {
                    license: vm.license,
                    insurance: vm.insurance
                }
            };

            if (data.profile && data.profile.license) {
                data.profile.license.photoFront = null;
                data.profile.license.photoBack = null;
            }

            if (vm.isLyftCredit() === false) {
                consumerLoanerService.saveProfile($transition$.params()['userGuid'], $transition$.params()['dealerId'], data).then(function (response) {

                    if (response.paymentMethodValid === false) {
                        $state.go('loaner-credit-card-info', { license: vm.license, insurance: vm.insurance, paymentMethodValid : false }).finally(function() {
                            vm.loading = false;
                        });
                    }
                    else if (response.credentialsValid === false) {
                        $state.go('loaner-driver-info', { license: null, insurance: vm.insurance, credentialsValid : false, credentialsError : response.credentialsError }).finally(function() {
                            vm.loading = false;
                        });
                    }
                    else {
                        vm.savingSuccessful = true;
                        if (resolvedUser.isStartContractLoanerTasksComplete) {
                            $state.go('loaner-signature');
                        } else {
                            $state.go('loaner-profile-complete', { loanerPreferences: vm.loanerPreferences });
                        }
                    }

                }).catch(function (err) {
                    vm.error = err.data && err.data.message || err.message;
                    vm.savingProfile = false;
                    vm.loading = false;
                });
            } else {
                 consumerLoanerService.chooseLyftCredits($transition$.params()['userGuid'], $transition$.params()['dealerId']).then(function (saveResult) {
                    vm.savingSuccessful = true;
                    $state.go('loaner-profile-complete', { loanerPreferences: vm.loanerPreferences });
                }).catch(function (err) {
                    vm.error = err.data && err.data.message || err.message;
                    vm.savingProfile = false;
                }).finally(function () {
                    vm.loading = false;
                });
            }

            

        };

        vm.back = function () {
            vm.loading = true;

            var prevState = vm.resolvedUser.isCreditCardRequired ? 'loaner-credit-card-info' : 'loaner-driver-info';

            if (vm.isLyftCredit() === true) {
                prevState = 'loaner-cfl-transportation';
            }

            $state.go(prevState, { license: vm.license, insurance: vm.insurance }).finally(function() {
                vm.loading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    LoanerCflVehicleSelectionController.$inject = ["$filter", "$state", "resolvedDealerBranding", "SYSTEM_ENUMS", "resolvedUser", "resolvedVehicleChoices"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerCflVehicleSelectionController', LoanerCflVehicleSelectionController);


    function LoanerCflVehicleSelectionController($filter, $state, resolvedDealerBranding, SYSTEM_ENUMS, resolvedUser, resolvedVehicleChoices) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;
        vm.configValues = vm.dealerBranding.configValues;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.loanerClientType = vm.dealerBranding.configValues.loanerClientType;
        vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
        vm.vehicleChoices = resolvedVehicleChoices;
        vm.resolvedUser = resolvedUser;
        vm.firstSelection = null;
        vm.secondSelection = null;
        vm.usePoints = false;
        
        vm.vehicleSelected = function (vehicle) {
            if (!vm.firstSelection) {
                vm.firstSelection = vehicle.modelCode;
            } else if (!vm.secondSelection && vehicle.modelCode !== vm.firstSelection) {
                vm.secondSelection = vehicle.modelCode;
            } else if (vm.firstSelection === vehicle.modelCode) {
                vm.firstSelection = vm.secondSelection;
                vm.secondSelection = null;
            } else if (vm.secondSelection === vehicle.modelCode) {
                vm.secondSelection = null;
            } else {
                vm.firstSelection = vehicle.modelCode;
                vm.secondSelection = null;
            }
        };


        vm.nextPage = function () {
            vm.loading = true;
            var firstVehicle = $filter('filter')(vm.vehicleChoices, { modelCode: vm.firstSelection }, true)[0],
                secondVehicle = $filter('filter')(vm.vehicleChoices, { modelCode: vm.secondSelection }, true)[0],
                vehiclePreferences = [];
            
            firstVehicle.order = 1;
            secondVehicle.order = 2;
            vehiclePreferences.push(firstVehicle);
            vehiclePreferences.push(secondVehicle);
            
            $state.go('loaner-driver-info', {vehiclePreferences: vehiclePreferences, transportationType: vm.cflTransportationTypes.chooseLoaner, usePoints: vm.usePoints, fromState: 'loaner-cfl-vehicleselection'}).finally(function() {
                vm.loading = false;
            });
        };

        vm.back = function () {
            vm.loading = true;
            $state.go('loaner-cfl-transportation').finally(function () {
                vm.loading = false;
            });
        };
        
    }
})();

(function () {
    'use strict';

    LoanerCflTransportationController.$inject = ["user", "$state", "$filter", "SYSTEM_ENUMS", "resolvedDealerBranding", "resolvedUser", "rcUtilService"];
    angular
        .module('redcap.consumer.loaner')
        .controller('LoanerCflTransportationController', LoanerCflTransportationController);


    function LoanerCflTransportationController(user, $state, $filter, SYSTEM_ENUMS, resolvedDealerBranding, resolvedUser, rcUtilService) {
        var vm = this;
        vm.dealerBranding = resolvedDealerBranding;
        vm.configValues = vm.dealerBranding.configValues;
        vm.loanerManagementSystemsEnum = SYSTEM_ENUMS.loanerManagementSystemsEnum;
        vm.loanerClientType = vm.dealerBranding.configValues.loanerClientType;
        vm.resolvedUser = resolvedUser;
        vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
        vm.selectedTransportationType = null;
        vm.disableLyftCreditMsg = null;
    

        if (vm.resolvedUser.lyftCreditsDisabled === true && 
            vm.configValues.cflDisabledLyftCreditText && 
            vm.resolvedUser.lyftCreditDisableHours) {
            vm.disableLyftCreditMsg = rcUtilService.replaceAll(vm.configValues.cflDisabledLyftCreditText, "[HOURS]", vm.resolvedUser.lyftCreditDisableHours);
        }
        
        
        function formatLyftText () {
            var amount =  $filter('currency')(vm.resolvedUser.lyftCreditAmount);
            vm.lyftCreditText = vm.configValues.cflLyftCreditText.replace("[CREDITAMOUNT]", amount);
        }

        if (vm.resolvedUser.enableLyftCreditAlternative) {
            formatLyftText();
        }

        vm.selectTransportationType = function (type) {
            vm.selectedTransportationType = type;
        };

        vm.nextPage = function () {
            vm.loading = true;
            var nextState = null,
                params = {transportationType: vm.selectedTransportationType, fromState: 'loaner-cfl-transportation'};

            switch (vm.selectedTransportationType) {
                case vm.cflTransportationTypes.chooseLoaner:
                    nextState = 'loaner-cfl-vehicleselection';
                    break;
                case vm.cflTransportationTypes.firstAvailable:
                    nextState = 'loaner-driver-info';
                    break;
                case vm.cflTransportationTypes.lyftCredit:
                    nextState = 'loaner-confirmation';
                    break;
               
            }
            
            $state.go(nextState, params).finally(function() {
                vm.loading = false;
            });
        };

        vm.back = function () {
            vm.loading = true;
            $state.go('loaner-landing').finally(function () {
                vm.loading = false;
            });
        };

    }
})();

(function () {
    "use strict";

    consumerOwnercareService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module("redcap.consumer.ownercare")
        .factory("consumerOwnercareService", consumerOwnercareService);

    function consumerOwnercareService($q, $log, $filter, $http, $rootScope, rcApi) {

        var BASEPATH = "ownercare/";
        
        return {
            getEvent: getEvent,
            getTaxesAndFees: getTaxesAndFees,
            saveEvent: saveEvent,
            getDealerBranding: getDealerBranding,
            getVerbiage: getVerbiage,
            formatVerbiage: formatVerbiage,
            getTerms: getTerms,
            getApprovedServices: getApprovedServices,
            setApprovalByRecommendationId: setApprovalByRecommendationId
        };

        function getEvent(eventGuid, dealerId) {
            return rcApi.get(BASEPATH + dealerId + '/' + eventGuid);
        }

        /* Expects recommendations to be in the form of:
         * [{
         *      externalId: 0,
         *      isApproved: true,
         *      total: 1.25
         * }]
        */
        function getTaxesAndFees(eventGuid, recommendations, dealerId) {
            return rcApi.post(BASEPATH + dealerId + '/' + "tax", {
                eventId: eventGuid,
                recommendations: recommendations
            });
        }

        /* Expects recommendations to be in the form of:
         * [{
         *      externalId: 0,
         *      isApproved: true,
         *      total: 1.25
         * }]
        */
        function saveEvent(eventGuid, recommendations, dealerId) {
            return rcApi.post(BASEPATH + dealerId, {
                eventId: eventGuid,
                recommendations: recommendations
            });
        }

        function getDealerBranding(dealerId) {
            return rcApi.get(BASEPATH + 'dealer/' + dealerId);
        }

        function getVerbiage(dealerId) {
            return rcApi.get(BASEPATH + 'verbiage/' + dealerId);
        }

        function formatVerbiage(text, event, dealerBranding) {
            text = text || '';
            var evt = event.postResponse ? event.postResponse : event;
            return text
                .replace('[customer_first_name]', evt.motoristName)
                .replace('[vehicle_year]', evt.vehicle && evt.vehicle.year)
                .replace('[vehicle_make]', evt.vehicle && evt.vehicle.make)
                .replace('[vehicle_model]', evt.vehicle && evt.vehicle.model)
                .replace('[dealer_phone]', $filter('tel')(dealerBranding.mainPhoneNumber))
                .replace('[dealer_phone_link]', '<a class="theme-link" href="tel:' + dealerBranding.mainPhoneNumber + '">' + $filter('tel')(dealerBranding.mainPhoneNumber) + '</a>')
                .replace('[sms_link]', '<a class="theme-link" href="sms:' + dealerBranding.smsNumber + '">text us</a>');
        }

        function getTerms(dealerId) {
            return rcApi.get(BASEPATH + 'terms/' + dealerId);
        }

        function getApprovedServices(event) {
            var items = [];
            var evt = event && event.postResponse ? event.postResponse : event;
            return items.concat(evt.failedRecommendations, evt.cautionRecommendations, evt.originalFailed, evt.originalCautioned)
                .map(function (item) {
                    return {
                        name: item.name,
                        isApproved: item.isApproved === true || item.isApproved === "1",
                        externalId: item.externalId,
                        total: item.price
                    };
                });
        }

        function setApprovalByRecommendationId(event, recommendationId, status) {
            var items = [];
            var evt = event && event.postResponse ? event.postResponse : event;
            items = items.concat(evt.failedRecommendations, evt.cautionRecommendations, evt.originalFailed, evt.originalCautioned);
            var itemToSetStatus = items.find(function(item) {
                return item.externalId === recommendationId;
            });
            if (itemToSetStatus) {
                itemToSetStatus.isApproved = status;
            }
        }

    }

})();

(function () {
    'use strict';

    ownerCareSummaryController.$inject = ["event", "$state", "resolvedDealerBranding", "SYSTEM_ENUMS", "consumerOwnercareService", "resolvedVerbiage"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareSummaryController', ownerCareSummaryController);


    function ownerCareSummaryController(event, $state, resolvedDealerBranding, SYSTEM_ENUMS, consumerOwnercareService, resolvedVerbiage) {
        var vm = this;
        vm.title = consumerOwnercareService.formatVerbiage(resolvedVerbiage.summaryTitle, event, resolvedDealerBranding);
        vm.paragraph = consumerOwnercareService.formatVerbiage(resolvedVerbiage.summaryParagraph, event, resolvedDealerBranding);
        vm.statuses = SYSTEM_ENUMS.ownerCareItemStatus;
        vm.event = event.postResponse || {};
        vm.loading = false;
        vm.dealerBranding = resolvedDealerBranding;
        vm.itemcount = vm.event.failedRecommendations.length + vm.event.cautionRecommendations.length + vm.event.originalFailed.length + vm.event.originalCautioned.length;
        vm.failedItems = [].concat(vm.event.originalFailed, vm.event.failedRecommendations);
        vm.cautionedItems = [].concat(vm.event.originalCautioned, vm.event.cautionRecommendations);

        vm.nextPage = function () {
            vm.loading = true;
            $state.go('ownercare-services');
        };
    }


})();

(function () {
    'use strict';

    ownerCareServicesController.$inject = ["event", "$state", "resolvedDealerBranding", "resolvedVerbiage", "consumerOwnercareService"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareServicesController', ownerCareServicesController);


    function ownerCareServicesController(event, $state, resolvedDealerBranding, resolvedVerbiage, consumerOwnercareService) {
        var vm = this;
        vm.title = consumerOwnercareService.formatVerbiage(resolvedVerbiage.servicesTitle, event, resolvedDealerBranding);
        
        vm.event = event.postResponse;
        vm.loading = false;
        vm.dealerBranding = resolvedDealerBranding;
        vm.itemcount = vm.event.failedRecommendations.length + vm.event.cautionRecommendations.length;
        vm.allItems = [].concat(vm.event.originalFailed,
            vm.event.failedRecommendations,
            vm.event.originalCautioned,
            vm.event.cautionRecommendations);

        vm.nextPage = function () {
            vm.loading = true;
            $state.go('ownercare-review', {
                event: event,
                approvedServices: consumerOwnercareService.getApprovedServices(vm.event)
            });
        };

        vm.approveAll = function() {
            vm.allItems.forEach(function(item) {
                item.isApproved = '1';
            });
        };

        vm.back = function () {
            $state.go('ownercare-summary');
        };
    }


})();

(function () {
    'use strict';

    ownerCareServiceDetailsController.$inject = ["event", "recommendation", "$state", "$transition$", "SYSTEM_ENUMS", "resolvedDealerBranding", "resolvedVerbiage", "consumerOwnercareService"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareServiceDetailsController', ownerCareServiceDetailsController);


    function ownerCareServiceDetailsController(event, recommendation, $state, $transition$, SYSTEM_ENUMS, resolvedDealerBranding, resolvedVerbiage, consumerOwnercareService) {
        var vm = this;
        vm.verbiage = resolvedVerbiage;
        vm.loading = false;
        vm.isDeclining = $transition$.params()['decline'] || false;
        vm.dealerBranding = resolvedDealerBranding;
        vm.recommendation = recommendation;
        vm.types = SYSTEM_ENUMS.ownerCareRecommendationTypes;
        vm.event = event;


        vm.back = function () {
            $state.go('ownercare-services');
        };

        function pushMediaItem(itemsArr, type) {
            if (!itemsArr || !itemsArr.length) return;
            for (var i = 0; i < itemsArr.length; i++) {
                vm.media.push(angular.extend({ 'type': type }, itemsArr[i]));
            }
        }

        vm.setTab = function (tab) {
            if (vm.selectedTab === tab) return;

            vm.selectedTab = tab;
            vm.media = [];
            switch (tab) {

            case vm.types.details:
                    var article = vm.recommendation.additionalInformationArticle || {};
                    if (article.goodImage) vm.media.push(angular.extend({ 'type': vm.types.image, 'description' : 'Good' }, article.goodImage));
                    if (article.badImage) vm.media.push(angular.extend({ 'type': vm.types.image, 'description': 'Poor'  }, article.badImage));
                    if (article.video) vm.media.push(angular.extend({ 'type': vm.types.video }, article.video));
                    break;
                case vm.types.image:
                    pushMediaItem(vm.recommendation.attachedPhoto, vm.types.image);
                    break;
                case vm.types.video:
                    pushMediaItem(vm.recommendation.attachedVideo, vm.types.video);
                    break;
                case vm.types.audio:
                    pushMediaItem(vm.recommendation.attachedAudio, vm.types.audio);
                    break;
            }
        };

        vm.decline = function () {
            consumerOwnercareService.setApprovalByRecommendationId(event, recommendation.externalId, '0');
            vm.back();
        };


        vm.setTab($transition$.params()['tabId']);

        var tabToSet;
        if (vm.isDeclining) {
            if (vm.recommendation.additionalInformationArticle) {
                tabToSet = vm.types.details;
            }
            else if (vm.recommendation.attachedVideo && vm.recommendation.attachedVideo.length) {
                tabToSet = vm.types.video;
            }
            else if (vm.recommendation.attachedPhoto && vm.recommendation.attachedPhoto.length) {
                tabToSet = vm.types.image;
            }
            else if (vm.recommendation.attachedAudio && vm.recommendation.attachedAudio.length) {
                tabToSet = vm.types.audio;
            }

            vm.setTab(tabToSet);
        }
    }


})();

(function () {
    'use strict';

    ownerCareReviewController.$inject = ["event", "taxesAndFees", "$state", "$transition$", "consumerOwnercareService", "resolvedDealerBranding", "resolvedVerbiage"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareReviewController', ownerCareReviewController);


    function ownerCareReviewController(event, taxesAndFees, $state, $transition$, consumerOwnercareService, resolvedDealerBranding, resolvedVerbiage) {
        var vm = this,
            i;
        vm.title = consumerOwnercareService.formatVerbiage(resolvedVerbiage.reviewTitle, event, resolvedDealerBranding);
        vm.paragraph = consumerOwnercareService.formatVerbiage(resolvedVerbiage.reviewParagraph, event, resolvedDealerBranding);

        vm.event = event.postResponse || {};
        vm.dealerBranding = resolvedDealerBranding;
        vm.taxesAndFees = taxesAndFees;
        vm.approvedServices = $transition$.params()['approvedServices'].filter(function(item) {
            return item.isApproved;
        });

        vm.feeTotal = 0;
        for (i = 0; i < taxesAndFees.postResponse.feesAndTaxes.length; i++) {
            vm.feeTotal += taxesAndFees.postResponse.feesAndTaxes[i].amount;
        }

        vm.servicesTotal = 0;

        for (i = 0; i < vm.approvedServices.length; i++) {
            vm.servicesTotal += vm.approvedServices[i].total;
        }

        vm.total = vm.servicesTotal + vm.feeTotal;

        vm.nextPage = function () {
            vm.loading = true;
            consumerOwnercareService.saveEvent($transition$.params()['eventGuid'], $transition$.params()['approvedServices'], $transition$.params()['dealerId']).then(function(response) {
                if (response && response.postResponse === true) {
                    $state.go('ownercare-done', {
                        approvedServices: $transition$.params()['approvedServices'],
                        taxesAndFees: taxesAndFees,
                        total: vm.total
                });
                }

            });
        };

        vm.back = function() {
            $state.go('ownercare-services');
        };
    }


})();

(function () {
    'use strict';

    ownerCareLandingController.$inject = ["event", "$state", "resolvedDealerBranding", "resolvedVerbiage", "consumerOwnercareService"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareLandingController', ownerCareLandingController);


    function ownerCareLandingController(event, $state, resolvedDealerBranding, resolvedVerbiage, consumerOwnercareService) {
        var vm = this;
        vm.title = consumerOwnercareService.formatVerbiage(resolvedVerbiage.welcomeTitle, event, resolvedDealerBranding);
        vm.paragraph = consumerOwnercareService.formatVerbiage(resolvedVerbiage.welcomeParagraph, event, resolvedDealerBranding);

        vm.event = event;
        vm.dealerBranding = resolvedDealerBranding;
        vm.nextPage = function () {
            vm.loading = true;
            $state.go('ownercare-summary');
        };
    }
})();

(function () {
    'use strict';

    ownerCareErrorController.$inject = ["$transition$"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareErrorController', ownerCareErrorController);


    function ownerCareErrorController($transition$) {
        var vm = this;
        vm.error = $transition$.params().error || 'An error has occurred.';
    }
})();

(function () {
    'use strict';

    ownerCareDoneController.$inject = ["event", "$transition$", "consumerOwnercareService", "resolvedDealerBranding", "resolvedVerbiage", "taxesAndFees"];
    angular
        .module('redcap.consumer.ownercare')
        .controller('OwnerCareDoneController', ownerCareDoneController);


    function ownerCareDoneController(event, $transition$, consumerOwnercareService, resolvedDealerBranding, resolvedVerbiage, taxesAndFees) {
        var vm = this,
            i;
        vm.title = consumerOwnercareService.formatVerbiage(resolvedVerbiage.successTitle, event, resolvedDealerBranding);
        vm.paragraph = consumerOwnercareService.formatVerbiage(resolvedVerbiage.successParagraph, event, resolvedDealerBranding);
        vm.footerParagraph = consumerOwnercareService.formatVerbiage(resolvedVerbiage.successFooterParagraph, event, resolvedDealerBranding);
        vm.event = event.postResponse || {};
        vm.dealerBranding = resolvedDealerBranding;
        vm.taxesAndFees = taxesAndFees;
        vm.approvedServices = $transition$.params()['approvedServices'].filter(function(item) {
            return item.isApproved;
        });

        vm.feeTotal = 0;
        for (i = 0; i < vm.taxesAndFees.postResponse.feesAndTaxes.length; i++) {
            vm.feeTotal += vm.taxesAndFees.postResponse.feesAndTaxes[i].amount;
        }

        vm.servicesTotal = 0;

        for (i = 0; i < vm.approvedServices.length; i++) {
            vm.servicesTotal += vm.approvedServices[i].total;
        }

        vm.total = vm.servicesTotal + vm.feeTotal;

    }


})();

(function () {
    'use strict';

    angular.module('redcap.consumer.inspect', []);
})();

(function () {
    'use strict';
    VehicleOverviewMediaUploadController.$inject = ["$state", "$stateParams", "rcUtilService", "resolvedRo", "consumerInspectService", "appointmentUtilService", "modalService", "SYSTEM_ENUMS", "APPOINTMENT_PHOTOTYPE"];
    angular
        .module('redcap.consumer.inspect')
        .controller('VehicleOverviewMediaUploadController', VehicleOverviewMediaUploadController);

    function VehicleOverviewMediaUploadController($state, $stateParams, rcUtilService, resolvedRo, consumerInspectService, appointmentUtilService, modalService, SYSTEM_ENUMS, APPOINTMENT_PHOTOTYPE) {
        let vm = this;

        vm.ro = resolvedRo;
        vm.dealerId = $stateParams.dealerId;
        vm.key = $stateParams.key;
        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
        vm.vehicleOverviewMedia = null;
        vm.pictureTypes = APPOINTMENT_PHOTOTYPE;
        vm.uploadVehicleOverviewMedia = consumerInspectService.uploadMedia;

        vm.getMediaType = function(fileExtension) {
            return appointmentUtilService.getMediaType(fileExtension);
        };

        vm.openMediaModal = function (url, description, mediaType, imageId) {
            description = description || 'Inspection Media';

            if (imageId) {
                modalService.showImageViewer(url, description, mediaType, null, () => {
                    consumerInspectService.deleteMedia(vm.dealerId, vm.ro.id, [imageId], vm.key).then((response) => {
                        rcUtilService.removeFromArray(vm.vehicleOverviewMedia, (m) => m.id === imageId);
                    });
                });
            } else {
                modalService.showImageViewer(url, description, mediaType);
            }
        };

        init();

        function init() {
            consumerInspectService.getMedia(vm.dealerId, vm.ro.id, vm.pictureTypes.vehicleOverview, vm.key).then((media) => {
                vm.vehicleOverviewMedia = media;
            });
        }

        vm.mediaUploaded = function(savedMedia) {
            savedMedia.appointmentPictureType = vm.pictureTypes.vehicleOverview;
            savedMedia.heading = 'Vehicle Overview';
            savedMedia.description = savedMedia.description || 'Inspection Media';

            consumerInspectService.saveMedia(vm.dealerId, vm.ro.id, [savedMedia], vm.key);
        };

         vm.close = function () {
            $state.go('consumer-inspection-media-upload-list', {
                dealerId: vm.dealerId,
                roId: vm.ro.id,
                key: vm.key
            });
        };
    }
})();

(function () {
    'use strict';

    InspectionMediaUploadController.$inject = ["$q", "$stateParams", "SYSTEM_ENUMS", "modalService", "resolvedRo", "resolvedLineItems", "consumerInspectService", "appointmentUtilService", "azureBlob", "authService", "$state"];
    angular
        .module('redcap.consumer.inspect')
        .controller('InspectionMediaUploadController', InspectionMediaUploadController);

    function InspectionMediaUploadController($q, $stateParams, SYSTEM_ENUMS, modalService, resolvedRo, resolvedLineItems, consumerInspectService, appointmentUtilService, azureBlob, authService, $state) {
        const vm = this;
        const allLineItems = resolvedLineItems.flatMap((li) => li.serviceOperations);
        const lineItemId = parseInt($stateParams.lineItemId);
        const taskId = parseInt($stateParams.taskId);
        const taskName = $stateParams.taskName;
        const dealerId = $stateParams.dealerId;
        const key = $stateParams.key;        
        
        vm.ro = resolvedRo;
        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;

        function init() {
            if (taskId) {
                vm.lineItems = allLineItems.filter((li) => li.inspectionTask?.inspectionTaskId === taskId);                
                vm.taskName = taskName;
            } else {
                vm.lineItems = [allLineItems.find((li) => li.id === lineItemId)];
                vm.taskName = 'NA';
            }
        }

        init();

        vm.openImageModal = (media, lineItem) => {
            const imageUrl = media.mediaUrl;
            const imageType = media.mediaType || media.fileExtension;
            const description = media.description || "Media Viewer";

            modalService.showImageViewer(imageUrl, description, imageType, null, () => vm.deleteMedia(media, lineItem));
        };

        vm.deleteMedia = (media, lineItem) => {
            if (!lineItem || !media) return;
            
            consumerInspectService.deleteRecMedia(dealerId, vm.ro.id, lineItem.id, [media.id], key)
                .then(() => {
                    const idx = lineItem.mediaItems.indexOf(media);
                    
                    if (idx > -1) {
                        lineItem.mediaItems.splice(idx, 1);
                    }
                });
        };

        // TODO: refactor this method into a shared service that can be reused elsewhere.  It's currently duplicated in a variety of ways throughout the app.
        vm.uploadMedia = function ($model, file, $files, $event, $id, reference, container, forceAdd) {
            const lineItem = vm.lineItems.find((li) => li.mediaItems === container);
            
            if (!lineItem) return;

            vm.addingImage = true;

            const currentUserId = (authService && typeof authService.getCurrentUser === 'function') ? (authService.getCurrentUser() || {}).userId : (key || 'unknown');
            let deferred = $q.defer();

            vm.imageType = appointmentUtilService.getImageTypes();
            consumerInspectService.getImageToken(dealerId, vm.ro.id, vm.imageType.recommendedMaintenance, key).then((result) => {
                const config = {
                    baseUrl: result.url,
                    file: file,
                    complete: function () {
                        $model.azureImageId = result.imageId;
                        $model.mediaUrl = result.url;
                        $model.fileExtension = file.type;
                        $model.createdByUserId = currentUserId;
                        const mediaObject = angular.copy($model);
                        
                        consumerInspectService.saveRecMedia(dealerId, vm.ro.id, lineItem.id, [mediaObject], key)
                            .then(() => consumerInspectService.getRecMedia(dealerId, vm.ro.id, lineItem.id, key))
                            .then((mediaResponse) => {
                                lineItem.mediaItems = mediaResponse;

                                if (deferred) deferred.resolve(mediaObject);

                                vm.addingImage = false;
                            });
                    },
                    error: function (err) {
                        if (deferred) deferred.reject(err);

                        vm.addingImage = false;
                    },
                    blockSize: 4000000
                };
                
                azureBlob.upload(config);
            }, (err) => {
                if (deferred) deferred.reject(err);
            });
            
            return deferred ? deferred.promise : undefined;
        };

        vm.close = function() {
            $state.go('consumer-inspection-media-upload-list', {
                dealerId: dealerId,
                roId: vm.ro.id,
                key: key
            });
        };
    }
})();
(function () {
    'use strict';

    InspectionMediaUploadListController.$inject = ["$state", "$stateParams", "resolvedLineItems", "resolvedRo", "INSPECT_CONSTANTS", "roService", "$rootScope", "resolvedConfig", "authService"];
    angular
        .module('redcap.consumer.inspect')
        .controller('InspectionMediaUploadListController', InspectionMediaUploadListController);

    function InspectionMediaUploadListController($state, $stateParams, resolvedLineItems, resolvedRo, INSPECT_CONSTANTS, roService, $rootScope, resolvedConfig, authService) {
        let vm = this;

        vm.dealerId = $stateParams.dealerId;
        vm.key = $stateParams.key;
        vm.ro = resolvedRo;
        vm.noTaskExpanded = false;

        function init() {
            const allLineItems = resolvedLineItems.flatMap((li) => li.serviceOperations); 

            vm.tasks = _.uniqBy(
                allLineItems
                    .filter((li) => li.inspectionTask !== null)
                    .map((op) => ({ 
                        ...op.inspectionTask, 
                        lineItemCount: allLineItems.filter(li => li.inspectionTask?.inspectionTaskId === op.inspectionTask.inspectionTaskId).length 
                    })), 
                'inspectionTaskId'
            );
            vm.adhocLineItems = allLineItems.filter((li) => !li.inspectionTask);
        }

        init();

        vm.goToInspect = function () {
            const configId = resolvedConfig.id || $rootScope.config.id;
            const inspectParams = {
                tabType: INSPECT_CONSTANTS.tabTypes.roDetail,
                dealerId: vm.dealerId,
                roId: vm.ro.id,
                customerName: roService.buildCustomerNameForTab(vm.ro.customer.firstName, vm.ro.customer.lastName),
                activeInspectTab: INSPECT_CONSTANTS.detailTabType.services,
                configId: configId
            };
            
            authService.isAuthenticated().then(() => {
                $state.go('inspect', inspectParams);
            }).catch(() => {
                $state.go('login', {
                    configId: configId || 1,
                    referrer: $state.href('inspect', inspectParams)
                });
            });
        };

        vm.openTask = function(task) {
            $state.go('consumer-inspection-media-upload-task', {
                dealerId: vm.dealerId,
                roId: vm.ro.id,
                taskId: task.inspectionTaskId,
                taskName: task.name,
                key: vm.key
            });
        };

        vm.toggleNoTask = function () {
            vm.noTaskExpanded = !vm.noTaskExpanded;
        };

        vm.openNoTaskLineItem = function(lineItem) {
            $state.go('consumer-inspection-media-upload-rec', {
                dealerId: vm.dealerId,
                roId: vm.ro.id,
                lineItemId: lineItem.id,
                key: vm.key
            });
        };

        vm.openVehicleOverview = function() {
            $state.go('consumer-vehicle-overview-media-upload', {
                dealerId: vm.dealerId,
                roId: vm.ro.id,
                key: vm.key
            });
        };
    }
})();
(function () {
    'use strict';

    consumerInspectService.$inject = ["consumerApi", "appointmentUtilService", "authService", "rcUtilService", "azureBlob"];
    angular
        .module('redcap.consumer.inspect')
        .factory('consumerInspectService', consumerInspectService);

    function consumerInspectService(consumerApi, appointmentUtilService, authService, rcUtilService, azureBlob) {
        const BASE_PATH = 'consumer/v2/';

        return {
            getLineItems: getLineItems,
            getImageToken: getImageToken,
            saveRecMedia: saveRecMedia,
            getRecMedia: getRecMedia,
            deleteRecMedia: deleteRecMedia,
            getMedia: getMedia,
            saveMedia: saveMedia,
            deleteMedia: deleteMedia,
            uploadMedia: uploadMedia
        };

        function getLineItems(dealerId, roId, key) {
            return consumerApi.get(`${BASE_PATH}dealer/${dealerId}/repairorder/${roId}/lineitems?key=${key}`);
        }

        function getImageToken(dealerId, roId, imageType, key) {
            return consumerApi.get(`${BASE_PATH}dealer/${dealerId}/repairorder/${roId}/imageToken/${imageType}?key=${key}`);
        }

        function saveRecMedia(dealerId, roId, lineItemId, media, key) {
            return consumerApi.post(`${BASE_PATH}dealer/${dealerId}/repairorder/${roId}/rec/${lineItemId}/media/?key=${key}`, media);
        }

        function getRecMedia(dealerId, roId, lineItemId, key) {
            return consumerApi.get(`${BASE_PATH}dealer/${dealerId}/repairorder/${roId}/rec/${lineItemId}/media?key=${key}`);
        }

        function deleteRecMedia(dealerId, roId, lineItemId, mediaId, key) {
            return consumerApi.remove(`${BASE_PATH}dealer/${dealerId}/repairorder/${roId}/rec/${lineItemId}/media/${mediaId}?key=${key}`);
        }

        function getMedia(dealerId, repairOrderId, pictureType, key) {
            const params = {
                pictureType: pictureType
            };

            return consumerApi.get(`${BASE_PATH}dealer/${dealerId}/repairorder/${repairOrderId}/media?key=${key}`, params);
        }
        
        function saveMedia(dealerId, repairOrderId, mediaItems, key) {
            return consumerApi.post(`${BASE_PATH}dealer/${dealerId}/repairorder/${repairOrderId}/media?key=${key}`, mediaItems);
        }

        function deleteMedia(dealerId, repairOrderId, mediaIds, key) {
            return consumerApi.remove(`${BASE_PATH}dealer/${dealerId}/repairorder/${repairOrderId}/media?key=${key}`, mediaIds);
        }

        function uploadMedia($model, file, $files, $event, $imageType, reference, container, forceAdd, dealerId, key) {
            const currentUserId = (authService && typeof authService.getCurrentUser === 'function') ? (authService.getCurrentUser() || {}).userId : (key || 'unknown');
            const imageTypes = appointmentUtilService.getImageTypes();

            let imageType = imageTypes[$imageType] || imageTypes.recommendedMaintenance;

            return new Promise((resolve, reject) => {
                
                getImageToken(dealerId, reference, imageType, key).then((result) => {
                    const config = {
                        baseUrl: result.url,
                        file: file,
                        complete: function () {

                            $model.azureImageId = result.imageId;
                            $model.url = result.url;
                            $model.mediaUrl = result.url;
                            $model.mediaType = appointmentUtilService.getMediaType(file.type);
                            $model.fileExtension = file.type;
                            $model.dateTaken = new Date();
                            $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);
                            $model.createdByUserId = currentUserId;
                            $model.reference = reference;
                            $model.imageType = imageType;

                            resolve(_.cloneDeep($model));
                        },
                        error: function (err) {
                            console.error('Image upload failed', err);
                            reject(err);
                        },
                        blockSize: 4000000 
                    };

                    azureBlob.upload(config);
                }).catch((err) => {
                    console.error('Failed to retrieve image token', err);
                    reject(err);
                }); 
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('redcap.consumer.appointments', []);
})();

(function () {
    'use strict';

    consumerAppointmentTextService.$inject = ["$filter"];
    angular
        .module('redcap.consumer.appointments')
        .factory('ConsumerAppointmentTextService', consumerAppointmentTextService);

    function consumerAppointmentTextService($filter) {

        return {
            makeTextUserFriendly: makeTextUserFriendly
        };

        function makeTextUserFriendly(text, dealerInfo) {
            if (typeof text !== 'string') return text;
            return text.replace('[DEALER_PHONE]', $filter('tel')(dealerInfo.mainPhoneNumber)).replace('[DEALER_NAME]', dealerInfo.name);
        }
    }

})();

(function () {
    'use strict';

    consumerAppointmentService.$inject = ["consumerApi", "consumerBookingService", "rideProviderService", "rcUtilService", "appointmentUtilService", "modalService", "appointmentClass", "SYSTEM_ENUMS", "APPOINTMENT_CUSTOMERTYPE", "APPOINTMENT_TRANSPORTATION_TYPE", "$q", "$filter", "$timeout", "$rootScope"];
    angular
        .module('redcap.consumer.appointments')
        .factory('consumerAppointmentService', consumerAppointmentService);

    function consumerAppointmentService(consumerApi, consumerBookingService, rideProviderService, rcUtilService, appointmentUtilService, modalService, appointmentClass, 
        SYSTEM_ENUMS, APPOINTMENT_CUSTOMERTYPE, APPOINTMENT_TRANSPORTATION_TYPE, $q, $filter, $timeout, $rootScope) {

        let CONSUMER_APPOINTMENT_BASEPATH = 'consumer/appointment/';
        let _currentTimeSlots = {};
        let THIRTY_SECONDS = 30000;

        return {
            getPreviouslyDeclinedServices: getPreviouslyDeclinedServices,
            hasAccess: hasAccess,
            getDealerBranding: getDealerBranding,
            getAppointmentHomeworkBranding: getAppointmentHomeworkBranding,
            getVehicleYears: getVehicleYears,
            getMakesInYear: getMakesInYear,
            getModelsForMakeInYear: getModelsForMakeInYear,
            getSubModelsForMakeInYear: getSubModelsForMakeInYear,
            getConsumerTripTypes: getConsumerTripTypes,
            getDefaultDropOff: getDefaultDropOff,
            getDefaultPickUp: getDefaultPickUp,
            getMobileTransportationType: getMobileTransportationType,
            getPickUpTripType: getPickUpTripType,
            getDepartments: getDepartments,
            getTripType: getTripType,
            getDepartmentServiceAdvisors: getDepartmentServiceAdvisors,
            getDepartmentHours: getDepartmentHours,
            getDepartmentClosedConstraints: getDepartmentClosedConstraints,
            getAvailability: getAvailability,
            isInFrame: isInFrame,
            validateVin: validateVin,
            getRecalls: getRecalls,
            getRecommendedMaintenance: getRecommendedMaintenance,
            sendVerificationCode: sendVerificationCode,
            checkVerificationCode: checkVerificationCode,
            getDefaultDepartment: getDefaultDepartment,
            createAppointment: createAppointment,
            cancelAppointment: cancelAppointment,
            getAppointment: getAppointment,
            isInServiceArea: isInServiceArea,
            validateTrip: validateTrip,
            postProcessAPIAppointment: postProcessAPIAppointment,
            isDealerConfigured: isDealerConfigured,
            displayLoanerSections: displayLoanerSections,
            getDMSRequiredFields: getDMSRequiredFields,
            getDealerIntegrations: getDealerIntegrations,
            getCustomerVehicles: getCustomerVehicles,
			getCustomer: getCustomer,
            getLocationOpCodes: getLocationOpCodes,
            filterDepartmentOpCodes: filterDepartmentOpCodes,
            filterDepartmentTransportationTypes: filterDepartmentTransportationTypes,
            getVehicleConditionImages: getVehicleConditionImages,
            postProcessAPIAuthorizationServices: postProcessAPIAuthorizationServices,
            getActiveTerms: getActiveTerms,
            getAuthorizations: getAuthorizations,
            createRide: createRide,
            createSignature: createSignature,
            setAppointmentStatus: setAppointmentStatus,
            sendBookLaterSms: sendBookLaterSms,
            createRideShareCredit: createRideShareCredit,
            getRideShareCredit: getRideShareCredit,
            getBookingMethod: getBookingMethod,
            isOriginalAppointmentPickupLoaner: isOriginalAppointmentPickupLoaner,
            minimizeHeaderMap: minimizeHeaderMap,
            loadTripRoute: loadTripRoute,
            displayTripLocations: displayTripLocations,
            postLoadAppointment: postLoadAppointment,
            pickupChanged: pickupChanged,
            pickupDateTimeChanged: pickupDateTimeChanged,
            updateDepartmentHours: updateDepartmentHours,
            processClosedConstraints: processClosedConstraints,
            isDateSelecteable: isDateSelecteable,
			getDisplayMapInMobile: getDisplayMapInMobile,
            getDisplayMapFramedIn: getDisplayMapFramedIn,
            showTheMap: showTheMap,
            requiresCapacityValidation: requiresCapacityValidation,
            validateCapacity: validateCapacity,
            isDepartmentRankingCompleted: isDepartmentRankingCompleted,
            getAndProcessPreviouslyDeclinedServices: getAndProcessPreviouslyDeclinedServices,
            filterDepartmentData: filterDepartmentData,
            loadRecallsRecMaintPrevDeclined: loadRecallsRecMaintPrevDeclined,
			genericCreateApptError: genericCreateApptError,
            setCurrentState: setCurrentState,
            findMismatchedLineItems: findMismatchedLineItems
        };

        function isInFrame() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }

        function getPreviouslyDeclinedServices(dealerId, customerId, vin) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/declined-service/' + customerId + '/' + vin);
        }

        function hasAccess(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/hasAccess');
        }

        function getDealerBranding(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/dealer');
        }

        function getAppointmentHomeworkBranding(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointmentHomeworkBranding');
        }

        function getVehicleYears(dealerId, dealerTripTypeId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/vehicleyears', {
                dealerTripTypeId: dealerTripTypeId
            });
        }

        function getMakesInYear(dealerId, year, dealerTripTypeId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/vehiclemakes',
                {
                    year: year,
                    dealerTripTypeId: dealerTripTypeId
                });
        }

        function getModelsForMakeInYear(dealerId, year, make, dealerTripTypeId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/vehiclemodels',
                {
                    year: year,
                    make: make,
                    dealerTripTypeId: dealerTripTypeId
                });
        }

        function getSubModelsForMakeInYear(dealerId, year, make, model) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/vehiclesubmodels',
                {
                    year: year,
                    make: make,
                    model: model
                });
        }

        function getDefaultDropOff(tripTypes) {
            // first check to see if the main drop off has 'showInConsumer' turned off, if this is the case, all drop offs
            // should be turned off for department we're looking at
            let dropOffOwnTransportation = $filter('filter')(tripTypes.dropOffTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.dropOff}, true);

            if (dropOffOwnTransportation && dropOffOwnTransportation.length > 0) {
                if (dropOffOwnTransportation[0].showInConsumer === false) return null;
            }

            let showInConsumerTransportationTypes = $filter('filter')(tripTypes.dropOffTransportationTypes, {showInConsumer: true}, true);

            if (showInConsumerTransportationTypes && showInConsumerTransportationTypes.length > 0) {
                let defTripType = $filter('filter')(showInConsumerTransportationTypes, {isDefault: true}, true);

                if (defTripType && defTripType.length > 0) return defTripType[0];

                return showInConsumerTransportationTypes[0];
            } else {
                return null;
            }
            
        }

        function getDefaultPickUp(tripTypes, configValues) {
            // first check to see if the main pick up has 'showInConsumer' turned off, if this is the case, all pick ups
            // should be turned off for department we're looking at
            if (tripTypes.pickUpTransportationTypes.length === 0) return null;

            let pickupWithLoaner = $filter('filter')(tripTypes.pickUpTransportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner}, true);

            if (pickupWithLoaner && pickupWithLoaner.length > 0) {
                if (pickupWithLoaner[0].showInConsumer === false) return null;
            }

            // otherwise default to other old logic to see which pickup trip type instance to use
            let tempLoanerDefault = configValues.hasLoanerDefault ? configValues.hasLoanerDefault.toLowerCase() : null;
            let hasLoaner = tempLoanerDefault === 'true';
            let hasLoanerPickup = $filter('filter')(tripTypes.pickUpTransportationTypes, {hasLoaner: hasLoaner}, true)[0];

            if (hasLoanerPickup.showInConsumer === true) {
                return hasLoanerPickup;
            } else {
                let hasNoLoanerPickup =  $filter('filter')(tripTypes.pickUpTransportationTypes, {hasLoaner: false}, true)[0];

                if (hasNoLoanerPickup.showInConsumer === true) {
                    return hasNoLoanerPickup;
                } else {
                    return null;
                }
            }
            
        }

        function getMobileTransportationType(tripTypes) {
            if (tripTypes.mobileGarageType && tripTypes.mobileGarageType.length > 0 && tripTypes.mobileGarageType[0].showInConsumer === true) {
                return tripTypes.mobileGarageType[0];
            }

            return null;
        }

        function getPickUpTripType(tripTypes, hasLoaner) {
            return $filter('filter')(tripTypes.pickUpTransportationTypes, {hasLoaner: hasLoaner}, true)[0];
        }

        function getConsumerTripTypes(transportationTypes) {
            return {
                dropOffTransportationTypes: $filter('filter')(transportationTypes, {isDropOff: true}, true),
                pickUpTransportationTypes: $filter('filter')(transportationTypes, {isPickup: true}, true),
                mobileGarageTypes: $filter('filter')(transportationTypes, {dealerSystemTransportationTypeId: APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage}, true)
            };
        }

        function getAvailability(dealerId, appointmentId, startDateUTC, endDateUTC, departmentId, advisor, transportationType, pickupLocation, apptOpCodes, cancellationToken) {
            // Ensure non-nulls for pickup location
            if (transportationType && !transportationType.isPickup && pickupLocation === null) {
                pickupLocation = {
                    streetAddress: 'test',
                    city: 'test',
                    state: 'az',
                    zipCode: '55555',
                    lat: 0,
                    lng: 0
                };
            }

            // Pulled from the dashboard call - make sure these stay in sync
            let d = $q.defer();
            let now = Date.now();
            let pickupLat = pickupLocation ? pickupLocation.lat : null;
            let pickupLng = pickupLocation ? pickupLocation.lng : null;
            let elapsed = now - _currentTimeSlots.timeStamp;
            let params = {
                startDateUTC: startDateUTC,
                endDateUTC: endDateUTC || null,
                appointmentId: appointmentId,
                advisorId: advisor ? advisor.id : null,
                departmentId: departmentId,
                transportationTypeId: transportationType ? transportationType.id : null,
                pickupLocation: pickupLocation ? pickupLocation : null,
                apptOpCodes: apptOpCodes,
                isMobileGarage: transportationType.isMobileGarage || false
            };

            if (pickupLocation) {
                params.pickupLocation = {
                    county: pickupLocation.county,
                    streetAddress: pickupLocation.streetAddress,
                    city: pickupLocation.city,
                    state: pickupLocation.state,
                    zip: pickupLocation.zipCode,
                    countryShortCode: pickupLocation.countryShortCode,
                    lat: pickupLocation.lat,
                    lng: pickupLocation.lng
                };
            }

            if (_currentTimeSlots &&
                _currentTimeSlots.selectedAdvisorId === params.advisorId &&
                _currentTimeSlots.dealerId === dealerId &&
                _currentTimeSlots.departmentId === departmentId &&
                _currentTimeSlots.transportationTypeId === params.transportationTypeId &&
                _currentTimeSlots.pickupLat === pickupLat &&
                _currentTimeSlots.pickupLng === pickupLng &&
                _currentTimeSlots.startDateUTC === startDateUTC &&
                _currentTimeSlots.endDateUTC === endDateUTC &&
                elapsed < THIRTY_SECONDS) {
                d.resolve(_currentTimeSlots.result);
            } else {
                consumerApi.post(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/availability/', params, d.promise)
                    .then((result) => {
                        if (result) {
                            _currentTimeSlots.result = result;
                            _currentTimeSlots.selectedAdvisorId = params.advisorId;
                            _currentTimeSlots.dealerId = dealerId;
                            _currentTimeSlots.departmentId = departmentId;
                            _currentTimeSlots.startDateUTC = params.startDateUTC;
                            _currentTimeSlots.transportationTypeId = params.transportationTypeId;
                            _currentTimeSlots.endDateUTC = params.endDateUTC;
                            _currentTimeSlots.timeStamp = Date.now();
                            d.resolve(_currentTimeSlots.result); // TT - CAROLE, WE NEED TO UPDATE THIS TO HANDLE MULTIPLE CALENDARS
                        }

                        d.resolve(_currentTimeSlots.result);
                    }, (error) => {
                        d.resolve(null);
                    }
                );

            }

            return d.promise;
        }

        function preProcessAppointment(dealerId, appointmentModel) {
            appointmentModel.dateCreated = new Date();
            appointmentModel.dealerId = dealerId;
            let appointmentToBook = appointmentClass.new(appointmentModel);
            let customerTypes = APPOINTMENT_CUSTOMERTYPE;

            appointmentToBook.lineItems = _.cloneDeep(appointmentModel.lineItems);

            // if we don't do this, posting fails with int32 conversion error
            if (appointmentToBook.id === null) {
                delete appointmentToBook.id;
            }

            if (appointmentToBook.customerType === customerTypes.individual) {
                appointmentToBook.customerCompany = null;
            } else {
                appointmentToBook.customerCompany = appointmentModel.customerLastName;
            }

            // remove any items that had a department line item mismatch
            appointmentToBook.lineItems = appointmentToBook.lineItems.filter((lineItem) => lineItem.departmentLineItemMismatch !== true);

            if (appointmentToBook.lineItems && appointmentToBook.lineItems.length > 0) {
                appointmentToBook.lineItems.forEach((lineItem) => {
                    if (lineItem.id === null) {
                        delete lineItem.id;
                    }

                    let isCurrDescNull = rcUtilService.isEmpty(lineItem.opCodeDescription);

                    if (isCurrDescNull && lineItem.dealerAppointmentServiceOpCode && !rcUtilService.isEmpty(lineItem.dealerAppointmentServiceOpCode.consumerDescription)) {
                        lineItem.opCodeDescription = lineItem.dealerAppointmentServiceOpCode.consumerDescription;
                    } else if (isCurrDescNull && lineItem.consumerDescription) {
                        lineItem.opCodeDescription = lineItem.consumerDescription;
                    }
                });
            }

            return appointmentToBook;
        }

        function getDefaultDepartment(dealerId, appointmentModel) {
            let appointmentToBook = preProcessAppointment(dealerId, appointmentModel);

            return consumerApi.post(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/checkdefaultdepartment', appointmentToBook);
        }

        function createAppointment(dealerId, appointmentModel, previouslyDeclinedServices) {
            let promise;
            let appointmentToBook = preProcessAppointment(dealerId, appointmentModel);

            appointmentToBook.errors = [];

            if (previouslyDeclinedServices) {
                appointmentUtilService.preProcesPreviouslyDeclinedServices(appointmentToBook, previouslyDeclinedServices);
            }

            if (appointmentModel.advisor) {
                appointmentToBook.dealerEmployeeId = appointmentModel.advisor.id;
                appointmentToBook.serviceAdvisorNumber = appointmentModel.advisor.employeeNumber;
            }

            // remove any that aren't false
            if (appointmentToBook.lineItems) {
                appointmentToBook.lineItems = appointmentToBook.lineItems.filter((lineItem) => lineItem.checked !== false);
            }
            
            // Create the first promise and chain remaining
            promise = consumerApi.post(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/', appointmentToBook)
                .then((result) => {
                    // Trip booking is handled in the backend - return the result
                    return result;
                }, (error) => {
                    // Parse out the booking errors
                    if (error && error.data && error.data.message && error.status === 400) {
                        return {
                            errors: [error.data.message]
                        };
                    } else {
                        return {
                            errors: ['Oops… we had a problem booking your appointment. Please contact the dealership.']
                        };
                    }
                }
            );

            return promise;
        }


        function getAppointment(dealerId, appointmentId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/' + appointmentId + keyParam);
        }

        function cancelAppointment(dealerId, appointment, reason, key) {
            let cancelReason = {
                reason: reason
            };

            let keyParam = getKeyParam(key, true);

            return consumerApi.put(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/' + appointment.id + '/cancel' + keyParam, cancelReason)
                .then((response) => {
                    return response;
                }, (error) => {
                    // Parse out the booking errors
                    if (error && error.data && error.data.message) {
                        return {
                            errors: [error.data.message]
                        };
                    } else {
                        return {
                            errors: ['An error occurred canceling the trip.']
                        };
                    }
                });
        }

        function validateVin(dealerId, vin) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/DecodeVin',
                {
                    vin: vin
                });
        }

        function getRecalls(dealerId, appt) {
            if (appt.vin) {
                return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/recall/vin/' + appt.vin);
            } else {
               return Promise.resolve([]);
            }
        }

        function getRecommendedMaintenance(dealerId, appt) {
            if (appt.vin) {
                return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/maintenance/vin/' + appt.vin + '/odometer/' + appt.mileage, {isMiles: appt.mileageType.type === 0});
            } else {
                let make = appt.selectedDMSMake ? appt.selectedDMSMake.make : appt.make;
                let model = appt.selectedDMSModel ? appt.selectedDMSModel.model : appt.model;

                return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/maintenance',
                    {
                        year: appt.year,
                        make: make,
                        model: model,
                        odometer: appt.mileage,
                        isMiles: appt.mileageType.type === 0
                    });
            }
        }

        function getServiceAdvisors(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/serviceadvisors');
        }

        function getDepartments(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/departments?excludeDepartmentsWithoutServiceAdvisors=true');
        }

        function getTripType(dealerId, systemTripTypeId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/tripType/',
            {
                systemTripTypeId: systemTripTypeId
            });
        }

        function getDepartmentServiceAdvisors(dealerId, departmentId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/departmentserviceadvisors/',
            {
                departmentId: departmentId
            });
        }

        function getDepartmentHours(dealerId, departmentId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/departmenthours/',
            {
                departmentId: departmentId
            });
        }

        function getDepartmentClosedConstraints(dealerId, departmentId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/departmentclosedconstraints/',
            {
                departmentId: departmentId
            });
        }

        function sendVerificationCode(dealerId, phoneNumberOrEmail, emailForPhoneNumbers) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/SendValidationCode',
                {
                    mobileNumberOrEmail: phoneNumberOrEmail,
                    emailForPhoneNumbers: emailForPhoneNumbers
                });
        }

        function checkVerificationCode(dealerId, phoneNumber, code) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/CheckValidationCode',
                {
                    mobileNumber: phoneNumber,
                    validationCode: code
                });
        }

        function getVehicleConditionImages (dealerId, appointmentId, key) {
            let keyParam = getKeyParam(key, true);
            
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/' + appointmentId + '/vehicle-condition');
        }

        function getCustomerVehicles(dealerId, customerId, resolvedKey) {
            let params = '?customerId=' + customerId;

            if (resolvedKey) {
                params += '&showNoVin=true';
            }

            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/GetCustomerVehicles' + params);
        }

        function isInServiceArea (dealerId, pickupLocation) {
            let location = pickupLocation.location;

            if (!location) {
                location = {lat: 0, lng: 0};
            }

            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/InServiceArea?pickupLat=' + location.lat + '&pickupLng=' + location.lng);
        }

        function validateTrip(dealerId, appointmentModel, dealerTripType) {
            let appointmentToBook = appointmentClass.new(appointmentModel);

            appointmentToBook.errors = [];
            let serviceOrder = {
                tripType: null,
                customer: null,
                pickupTime: appointmentModel.tripPickupTime,
                serviceAdvisorId: null,
                customerInfo: appointmentModel.tripCustomer,
                hasLoaner: dealerTripType.hasLoaner ? 'yes' : 'no',
                vehicleInfo: {
                    year: appointmentToBook.year,
                    make: appointmentToBook.make,
                    model: appointmentToBook.model,
                    vin: appointmentToBook.vin,
                    transmission: appointmentModel.isManual
                },
                dlInfo: {},
                insInfo: {}
            };

            let apptDateTime = moment(appointmentModel.apptDateTime);
            let dateString = apptDateTime.format('MM/DD/YYYY');
            let timeString = apptDateTime.format('hh:mm A');
            let systemTripType = SYSTEM_ENUMS.systemTripTypes.find((tripType) => tripType.value === SYSTEM_ENUMS.systemTripType.pickup);

            systemTripType = _.cloneDeep(systemTripType);
            systemTripType.id = systemTripType.value;
            let trip = {
                customerDate: dateString,
                customerTime: timeString,
                customerLocation: appointmentModel.tripPickupLocation,
                pickupTimeUtc: appointmentModel.tripPickupTime,
                selectedSystemTripType: systemTripType,
                dealerTripTypeInstance: {
                    id: 0,
                    tripTypeId: systemTripType.value
                },
                serviceAdvisor: {
                    id: null
                },
                startsAtDealer: dealerTripType.hasLoaner,
                dealerLocation: {
                    id: dealerId
                },
                tripNote: appointmentModel.tripNote
            };

            return consumerBookingService.validateBookingRules(serviceOrder, trip)
                .then((bookingRules) => {
                    return bookingRules;
                })
                .catch((error) => {
                    // Parse out the booking errors
                    let errors = [];

                    if (error && error.data && error.data.message) {
                        try {
                            let parsedError = JSON.parse(error.data.message).TripVerificationResponses;

                            if (parsedError && parsedError.length > 0) {
                                parsedError.forEach((err) => {
                                    errors.push(err.errorMessage);
                                });
                            }
                        } catch (parseError) {
                            if (error.data.exceptionMessage) {
                                errors.push(error.data.exceptionMessage);
                            } else {
                                errors.push(error.data.message);
                            }
                        }

                        return {
                            errors: errors || ['An error occurred booking the trip.']
                        };
                    } else {
                        return {
                            errors: ['An error occurred booking the trip.']
                        };
                    }
                });
        }


        function processItem (item, allOpCodes, appointment) {
            item.checked = true;
            let opCode =  null;
            let appointmentDepartmentId = appointment.departmentId;
            let departmentMismatch = false;
            let apptServiceOpCode = item.dealerAppointmentServiceOpCode;
            let deptGenericOpCodes = $filter('filter')(allOpCodes, {dealerDepartmentId: appointmentDepartmentId, isGeneric: true}, true);
            let deptRecMaintOpCodes = $filter('filter')(allOpCodes, {dealerDepartmentId: appointmentDepartmentId, isRecommendedMaintenance: true}, true);
            let deptRecallOpCodes = $filter('filter')(allOpCodes, {dealerDepartmentId: appointmentDepartmentId, isRecall: true}, true);
            let recMaintEnabledConsumer = appointmentUtilService.opCodesEnabledForDept(deptRecMaintOpCodes, appointmentDepartmentId, false);
            let recallsEnabledConsumer = appointmentUtilService.opCodesEnabledForDept(deptRecallOpCodes, appointmentDepartmentId, false);
            let recMaintEnabledDashboard = appointmentUtilService.opCodesEnabledForDept(deptRecMaintOpCodes, appointmentDepartmentId, true);
            let recallsEnabledDashboard = appointmentUtilService.opCodesEnabledForDept(deptRecallOpCodes, appointmentDepartmentId, true);
            let genericEnabled = appointmentUtilService.departmentGenericEnabled(deptGenericOpCodes, appointmentDepartmentId);
             
            item.departmentLineItemMismatch = false;
             
            if (apptServiceOpCode) {
                if (item.isAutomatic !== true && apptServiceOpCode && apptServiceOpCode.dealerDepartmentId !== appointmentDepartmentId) {
                    opCode = appointmentUtilService.getMatchingDepartmentOpCode(allOpCodes, apptServiceOpCode, appointmentDepartmentId);

                    if (opCode) {
                        item.dealerAppointmentServiceOpCode = apptServiceOpCode = opCode;
                        item.dealerAppointmentServiceOpCodeId = opCode.id;
                        item.departmentLineItemMismatch = false;
                    } else {
                        // set the flag so we can message the user there was an issue
                        // matching up line items
                        departmentMismatch = true;
                        item.departmentLineItemMismatch = true;
                        appointment.departmentLineItemMismatch = true;
                        item.isOther = false;
                        item.checked = false;
                        // if there was an opcode from another department, uncheck it
                        let otherDeptOpCodes = $filter('filter')(allOpCodes, {opCode: apptServiceOpCode.opCode, checked: true}, true);

                        if (otherDeptOpCodes && otherDeptOpCodes.length > 0) {
                            otherDeptOpCodes.forEach((opCode) => {
                                opCode.checked = false;
                            });
                        }

                    }

                    if (recMaintEnabledConsumer === false && recMaintEnabledDashboard === false && item.isRecommendedMaintenance) {
                        item.departmentLineItemMismatch = true;
                        appointment.departmentLineItemMismatch = true;
                        item.checked = false;
                    }

                    if (recallsEnabledConsumer === false && recallsEnabledDashboard === false && item.isRecall) {
                        item.departmentLineItemMismatch = true;
                        appointment.departmentLineItemMismatch = true;
                        item.checked = false;
                    }

                    if (genericEnabled === false && item.isGeneric) {
                        item.departmentLineItemMismatch = true;
                        appointment.departmentLineItemMismatch = true;
                        item.checked = false;
                    }
                    
                } else {
                    item.departmentLineItemMismatch = false;
                }
                
                item.isAutomatic = apptServiceOpCode.isAutomatic;
                item.isGeneric = apptServiceOpCode.isGeneric;
                item.isRecall = apptServiceOpCode.isRecall;
                item.isRecommendedMaintenance = apptServiceOpCode.isRecommendedMaintenance;
            }
            
            if (item.dealerAppointmentServiceOpCodeId && !opCode && departmentMismatch === false) {
                opCode = $filter('filter')(allOpCodes, {id: item.dealerAppointmentServiceOpCodeId}, true)[0];
            }
            
            if (departmentMismatch === false) {
                if (opCode) {
                    item.isOther = false;
                    item.consumerName = opCode.consumerName;
                    item.dashboardName = opCode.dashboardName;
                    item.consumerDescription = opCode.consumerDescription;
                    item.dashboardDescription = opCode.dashboardDescription;
                    item.isAutomatic = opCode.isAutomatic;
                    item.isGeneric = opCode.isGeneric;
                    item.isRecall = opCode.isRecall;
                    item.isRecommendedMaintenance = opCode.isRecommendedMaintenance;
                } else {
                    item.isOther = true;
                }
            } else {
                item.checked = false;
            }  
        }

        function postProcessAPIAppointment (appointment, dealerOpCodes, dealerDepartments, previouslyDeclinedServices) {
            let allOpCodes = dealerOpCodes.all;

            appointment.departmentLineItemMismatch = false;
 
            if (allOpCodes && allOpCodes.length > 0 && appointment.lineItems) {
                appointment.lineItems.forEach((item) => {
                    // Set up the view model variables
                    processItem(item, allOpCodes, appointment);
                });
            }

            if (dealerDepartments) {
                let selectedDepartment = $filter('filter')(dealerDepartments, {id: appointment.departmentId}, true)[0];

                if (selectedDepartment && selectedDepartment.showPreviouslyDeclinedServicesConsumer === false && previouslyDeclinedServices) {
                    previouslyDeclinedServices.forEach((item) => {
                        if (item.checked) {
                            item.checked = false;
                            item.departmentLineItemMismatch = true;
                            appointment.departmentLineItemMismatch = true;
                        }
                    });
                }
            }

            return appointment;
        }
        
        function postProcessAPIAuthorizationServices (authorizations, dealerOpCodes, appointment) {
            let allOpCodes = dealerOpCodes.all;
            
            if (allOpCodes && allOpCodes.length > 0) {
                authorizations.forEach((authorization) => {
                    // Set up the view model variables
                    processItem(authorization, allOpCodes, appointment);
                });
            }

            return authorizations;
        }

        function isDealerConfigured (dealerOpCodes, apptConsumerDepartmentId) {
            let genericLineItem = null;
            let genericConfigured = true;

            if (dealerOpCodes && dealerOpCodes.genericOpCodes && dealerOpCodes.genericOpCodes.length > 0) {
                genericLineItem = dealerOpCodes.genericOpCodes[0];
                
                if (genericLineItem && genericLineItem.isEnabled === true && 
                    genericLineItem.showInConsumer === true && 
                    genericLineItem.opCode === "") {
                    genericConfigured = false;
                }
            }


            return apptConsumerDepartmentId !== null && 
                   apptConsumerDepartmentId.length > 0 && 
                   genericConfigured === true;
        }

        function getCustomer (dealerId, email, phone) {
            return consumerApi.post(CONSUMER_APPOINTMENT_BASEPATH + 'dealer/' + dealerId + '/customers/search', {customerPhone: phone, customerEmail: email});
        }
        

        function getKeyParam(key, firstParam) {
            return key ? (firstParam ? '?key=' : '&key=') + key : '';
        }

        function displayLoanerSections(tripTypes, originalAppointmentHasLoaner) {
            if (originalAppointmentHasLoaner === true) return true;

            let loanerTripType = $filter('filter')(tripTypes.pickUpTransportationTypes, {hasLoaner: true}, true);
            let displayLoanerSections;

            if (loanerTripType && loanerTripType.length > 0) {
                displayLoanerSections = loanerTripType[0].showInConsumer;
            }

            return displayLoanerSections;
        }

        function getDMSRequiredFields(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/DmsRequiredFields');
        }

        function getDealerIntegrations(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/DealerIntegrations');
        }

        function getLocationOpCodes(dealerId) {
            return consumerApi.get(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/opcodes')
                .then((result) => {
                    // Generic / Non Generic split to reduce code repetition
                    return {
                        opCodes: $filter('filter')(result, {isGeneric: false, isRecall: false, isRecommendedMaintenance: false}, true),
                        genericOpCodes: $filter('filter')(result, {isGeneric: true}, true),
                        recallOpCodes: $filter('filter')(result, {isRecall: true}, true),
                        recommendedMaintenanceOpCodes: $filter('filter')(result, {isRecommendedMaintenance: true}, true),
                        automaticOpCodes: $filter('filter')(result, {isAutomatic: true}, true),
                        all: result
                    };
                });
        }

        function filterDepartmentOpCodes (dealerOpCodes, departmentId) {
            if (departmentId) {
                let allOpCodes = dealerOpCodes.all;
                let departmentOpCodes = {
                    opCodes: $filter('filter')(allOpCodes, {isGeneric: false, isRecall: false, isRecommendedMaintenance: false, dealerDepartmentId: departmentId}, true),
                    genericOpCodes: $filter('filter')(allOpCodes, {isGeneric: true, dealerDepartmentId: departmentId}, true),
                    recallOpCodes: $filter('filter')(allOpCodes, {isRecall: true, dealerDepartmentId: departmentId}, true),
                    recommendedMaintenanceOpCodes: $filter('filter')(allOpCodes, {isRecommendedMaintenance: true, dealerDepartmentId: departmentId}, true),
                    automaticOpCodes: $filter('filter')(allOpCodes, {isAutomatic: true}, true), // automatic op codes are not dept specific
                    allDeptOpCodes: $filter('filter')(allOpCodes, {dealerDepartmentId: departmentId}, true),
                    all: allOpCodes
                };

                    return departmentOpCodes;
                
            } else {
                return dealerOpCodes;
            }
        }

        function filterDepartmentTransportationTypes (allTransportationTypes, deptId) {
            let deptDropOffs = $filter('filter')(allTransportationTypes.dropOffTransportationTypes, {dealerDepartmentId: deptId}, true);
            let deptPickUps = $filter('filter')(allTransportationTypes.pickUpTransportationTypes, {dealerDepartmentId: deptId}, true);
            let deptMobileGarage = $filter('filter')(allTransportationTypes.mobileGarageTypes, {dealerDepartmentId: deptId}, true);

            return  {
                dropOffTransportationTypes: deptDropOffs,
                pickUpTransportationTypes: deptPickUps,
                mobileGarageType: deptMobileGarage
            };
        }

        function getAuthorizationBaseRoute(dealerId, appointmentId) {
            return 'dealer/' + dealerId + '/appointment/' + appointmentId + '/authorization/';
        }

        function getActiveTerms(dealerId, appointmentId, key) {
            let route = getAuthorizationBaseRoute(dealerId, appointmentId) + 'terms';
           
            route = route + "?key=" + key;

            return consumerApi.get(route);
        }

        function getAuthorizations (dealerId, appointmentId, key) {
            let route = getAuthorizationBaseRoute(dealerId, appointmentId);

            route = route + "?key=" + key;

            return consumerApi.get(route);
        }

        function createRide (
            dealerId,
            pickupLat,
            pickupLng,
            pickupStreetAddress,
            pickupCity,
            pickupState,
            pickupZip,
            pickupCountry,
            dropoffLat,
            dropoffLng,
            dropoffStreetAddress,
            dropoffCity,
            dropoffState,
            dropoffZip,
            dropoffCountry,
            rideType,
            serviceOrderId,
            serviceAdvisorId,
            tripId,
            isTestTrip,
            pickupTime,
            estimatedDistanceMiles,
            estimatedDuration,
            roNum,
            customerPhone,
            customerEmail,
            customerFirstName,
            customerLastName,
            customerNotes,
            dealerTripTypeId,
            costToken,
            estimatedCost,
            presentedCost,
            maxCost,
            systemTripType,
            startsAtDealer,
            monthlyChargesSnapshot,
            companyName,
            workFlowId,
            referenceNumber,
            overrideServiceAdvisorFirstName,
            overrideServiceAdvisorLastName,
            overrideServiceAdvisorMobile,
            rideProviderType,
            dropoffNote,
            lyftSandboxFlowType,
            apptId,
            key
        ) {
            let route = getAuthorizationBaseRoute(dealerId, apptId) + 'ride';

            route = route + "?key=" + key;

            let pickup = rideProviderService.buildStop(pickupLat, pickupLng, pickupStreetAddress, pickupCity, pickupState, pickupZip, pickupCountry, true, systemTripType, startsAtDealer, workFlowId);
            let dropoff = rideProviderService.buildStop(dropoffLat, dropoffLng, dropoffStreetAddress, dropoffCity, dropoffState, dropoffZip, dropoffCountry, false, systemTripType, startsAtDealer, workFlowId);

            return consumerApi.post(route, {
                systemTripType: systemTripType,
                pickup: pickup,
                dropoff: dropoff,
                rideType: rideType,
                serviceOrderId: serviceOrderId,
                tripId: tripId,
                isTestTrip: isTestTrip,
                pickupTime: pickupTime,
                estimatedDistance: estimatedDistanceMiles * 1609.34, // Convert to meters for consistency
                estimatedDuration: estimatedDuration,
                roNum: roNum,
                phone: customerPhone,
                email: customerEmail,
                firstName: customerFirstName,
                lastName: customerLastName,
                companyName: companyName,
                customerNotes: customerNotes,
                dealerTripTypeId: dealerTripTypeId,
                serviceAdvisorId: serviceAdvisorId,
                costToken: costToken,
                estimatedCost: estimatedCost,
                presentedCost: presentedCost,
                maxCost: maxCost,
                startsAtDealer: startsAtDealer,
                monthlyChargesSnapshot: monthlyChargesSnapshot,
                workFlowId: workFlowId,
                referenceNumber: referenceNumber,
                overrideServiceAdvisorFirstName: overrideServiceAdvisorFirstName,
                overrideServiceAdvisorLastName: overrideServiceAdvisorLastName,
                overrideServiceAdvisorMobile: overrideServiceAdvisorMobile,
                dropoffNote: dropoffNote,
                sandboxFlowType: lyftSandboxFlowType,
                apptId: apptId
            }, rideProviderService.buildHeaders(isTestTrip, true, false, systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand, rideProviderType));
           
        }

        function createRideShareCredit (dealerId, appointmentId, rideDetails, key) {
            let route = getAuthorizationBaseRoute(dealerId, appointmentId) + 'credit';

            route = route + "?key=" + key;

            return consumerApi.post(route, rideDetails);
        }

        function getRideShareCredit(dealerId, appointmentId, key) {
            let route = getAuthorizationBaseRoute(dealerId, appointmentId) + 'credit';

            route = route + "?key=" + key;

            return consumerApi.get(route);
        }

        function createSignature(dealerId, appointmentId, fullName, key) {
            let route = getAuthorizationBaseRoute(dealerId, appointmentId) + 'signature?fullName=' + fullName;

            route = route + "&key=" + key;

            return consumerApi.get(route);
        }

        function setAppointmentStatus(dealerId, appointmentId, statusId, key) {
            let keyParam = getKeyParam(key, true);

            return consumerApi.put(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/' + appointmentId + '/setAppointmentStatus' + keyParam, {statusId: statusId}).then((response) => {
                return response;
            });
        }

        function sendBookLaterSms(lyftShuttleTripTypeId, appt, smsNumber, key) {
            let dealerId = appt.dealerId;

            return getAdvisor(dealerId, appt.id, key).then((advisor) => {
                let bindingModel = {
                    type: 1,    // 1 = sms
                    serviceAdvisorId: advisor.id,
                    roNumber: appt.dealerServiceOrder ? appt.dealerServiceOrder.roNumber : null,
                    firstName: appt.customerFirstName,
                    lastName: appt.customerLastName,
                    phone: smsNumber,
                    startsAtDealer: true,
                    systemTripTypeId: SYSTEM_ENUMS.systemTripType.lyftShuttleService,
                    tripWorkFlowId: SYSTEM_ENUMS.tripWorkflowTypes.lyftFromDealership,
                    hasLoaner: false
                };

                
                return getTripTypeFormattedMessage(dealerId, lyftShuttleTripTypeId, appt.dealerServiceOrderId, bindingModel)
                    .then((formattedMessage) => {
                        bindingModel.subject = formattedMessage.subject;
                        bindingModel.body = formattedMessage.body;
                        bindingModel.apptDateTime = new Date(appt.apptDateTime);
            
                        if (appt.dealerServiceOrderId) {
                            return consumerApi.post('dealers/' + dealerId + '/tripTypes/' + lyftShuttleTripTypeId + '/notifications/formatted/' + appt.dealerServiceOrderId, bindingModel)
                            .then((response) => {
                                return response;
                            });
                        } else {
                            return consumerApi.post('dealers/' + dealerId + '/tripTypes/' + lyftShuttleTripTypeId + '/notifications/formatted', bindingModel)
                            .then((response) => {
                                return response;
                            });
                        }
                    }, (smsFailed) => {
                        alert("TODO: Unable to book shuttle ride. Please contact your service Adivsor");
                    });
                    
            });
        }

        function getBookingMethod(configs) {
            let bookingMethod = parseInt(configs.apptConsumerBookingExperienceMethod);

            return bookingMethod;
        }

        function getDisplayMapInMobile(configs) {
            let displayMap = configs.consumerMobileDisplayMap ? configs.consumerMobileDisplayMap.toLowerCase() : 'true';

            return displayMap === 'true';
        }

        function getDisplayMapFramedIn(configs) {
            let framedInHideMap = configs.framedInHideMap ? configs.framedInHideMap.toLowerCase() : 'true';

            return framedInHideMap !== 'true';
        }

        function showTheMap(isInFrame, showMapFramedIn) {
            if (isInFrame === false || showMapFramedIn) {
                return true; 
            }
            
            if (showMapFramedIn === false) {
                return false;
            }
            
            return true;
        }

        // private
        function getAdvisor(dealerId, appointmentId, key) {
            let route = getAuthorizationBaseRoute(dealerId, appointmentId) + 'advisor';

            route = route + "?key=" + key;

            return consumerApi.get(route);
        }

        function getTripTypeFormattedMessage(dealerId, dealerTripTypeId, serviceOrderId, bindingModel) {
            if (serviceOrderId) {
                return consumerApi.get('dealers/' + dealerId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted/' + serviceOrderId, bindingModel);
            } else {
                return consumerApi.get('dealers/' + dealerId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted', bindingModel);
            }
        }

        function isOriginalAppointmentPickupLoaner (appt, allTransportationTypes, loanerTransportationType) {
            if (appt.dealerTransportationTypeId) {
                let currentTripType  = $filter('filter')(allTransportationTypes, {id: appt.dealerTransportationTypeId}, true)[0];

                if (currentTripType.dealerSystemTransportationTypeId === loanerTransportationType) {
                    return true;
                } 
            }

            return false;

        }

        function minimizeHeaderMap() {
            $timeout(() => {
                $rootScope.$broadcast('minimizeHeaderMap');
            }, 500);
        }

        function loadTripRoute(minimizeMapAfter, appointment) {
            if (appointment.tripStops && appointment.tripStops.length > 1) {
                $timeout(() => {
                    $rootScope.$broadcast('drawTripRoute', appointment.tripStops);

                    if (minimizeMapAfter) {
                        minimizeHeaderMap();
                    }
                }, 50);
            }
        }

        function displayTripLocations (data) {
            if (data.locationList && data.locationList.length > 0) {
                data.locationList.forEach((location) => {
                    location.latLng = {lat: location.lat, lng: location.lng};
                });
            }

            $rootScope.$broadcast('drawTripRoute', data.locationList);
        }

        function postLoadAppointment (vm) {
            let appt = vm.appointment;
            let dealerOpCodes = vm.dealerOpCodes;
            let lineItems = appt.lineItems;
            let recallLineItem = dealerOpCodes.recallOpCodes[0];
            let recMaintLineItem = dealerOpCodes.recommendedMaintenanceOpCodes[0];
            let recalls = $filter('filter')(lineItems, {isRecall: true}, true);
            let recMaint = $filter('filter')(lineItems, {isRecommendedMaintenance: true}, true);
            let hasRecalls = recalls && recalls.length > 0;
            let hasRecMaint = recMaint && recMaint.length > 0;
            let showRecalls = recallLineItem ? recallLineItem.showInConsumer : false;
            let showRecallsInDashboard = recallLineItem ? recallLineItem.showInDashboard : false;
            let showRecMaint = recMaintLineItem ? recMaintLineItem.showInConsumer : false;
            let showRecMaintInDashboard = recMaintLineItem ? recMaintLineItem.showInDashboard : false;

            if (!showRecalls && !showRecallsInDashboard && recalls && recalls.length > 0) {
                hasRecalls = false;
                recalls.forEach((recall) => {
                    recall.isOther = true;
                    recall.showInConsumer = true;

                    if (recall.dealerAppointmentServiceOpCode) {
                        recall.dealerAppointmentServiceOpCode.isRecall = false;
                        recall.dealerAppointmentServiceOpCode.isOther = true;
                        recall.dealerAppointmentServiceOpCode.showInConsumer = true;
                    }
                });
            }

            if (!showRecMaint && !showRecMaintInDashboard && recMaint && recMaint.length > 0) {
                hasRecMaint = false;
                recMaint.forEach((maint) => {
                    maint.isRecommendedMaintenance = true;
                    maint.isOther = true;
                    maint.showInConsumer = true;

                    if (maint.dealerAppointmentServiceOpCode) {
                        maint.dealerAppointmentServiceOpCode.isRecommendedMaintenance = false;
                        maint.dealerAppointmentServiceOpCode.isOther = true;
                        maint.dealerAppointmentServiceOpCode.showInConsumer = true;
                    }
                });
            }

            if (hasRecalls || hasRecMaint) {
                appt.originalApptHasRecallsOrRecMaint = true;
            } else {
                appt.originalApptHasRecallsOrRecMaint = false;
            }

            vm.originalApptYear = vm.appointment.year;
            vm.originalApptMake = vm.appointment.make;
            vm.originalApptModel = vm.appointment.model;

            // we will need to check if these have chagned later
            vm.originalAppointmentDateTime = _.cloneDeep(appt.apptDateTime);
            vm.originalDealerEmployeeId = appt.dealerEmployeeId;
            vm.originalDepartmentId = appt.departmentId;
            vm.originalTransportationType = appt.dealerTransportationTypeId;
            vm.originalIsManual = appt.isManual;
            vm.originalPickupLocation = appt.tripPickupLocation;
        }

        function pickupChanged (tripType, pickupLocation, dealer, busyFlag) {
            if (!tripType.isDropOff && pickupLocation) {
                busyFlag = true;
                isInServiceArea(dealer.dealerId, pickupLocation).then(
                    (result) => {
                        pickupLocation.isInServiceArea = result;
                        $rootScope.$broadcast('updateAvailability', null);
                        busyFlag = false;

                        if (result) {
                            let tempAppointment = {
                                dealerTransportationTypeId: tripType.id,
                                tripPickupTime: moment(),
                                tripPickupLocation: pickupLocation.location
                            };
                            
                            validateTrip(dealer.dealerId, tempAppointment, tripType)
                                .then((result) => {
                                    if (result.errors && result.errors.length > 0) {
                                        $rootScope.$broadcast('updateTripLocationError', result.errors);
                                    } else {
                                        let displayedTripLocations = appointmentUtilService.getTripLocations(result);

                                        displayTripLocations({locationList: displayedTripLocations});
                                        $rootScope.$broadcast('updateTripLocations', displayedTripLocations);
                                    }

                                });
                        } else {
                            $rootScope.$broadcast('clearMap');
                        }
                    },
                    (error) => {
                        busyFlag = false;
                    }).finally(() => { });
            }
        }

        function pickupDateTimeChanged (appt, tripType, pickupLocation, dealer, newValue) {
            appt.dealerTransportationTypeId = tripType.id;
            appt.tripPickupTime = newValue;

            if (pickupLocation) {
                appt.tripPickupLocation = pickupLocation.location;
            }
            
            validateTrip(dealer.dealerId, appt, tripType)
                .then((result) => {
                    displayTripLocations({locationList: appointmentUtilService.getTripLocations(result)});
                });
        }
  
        function updateDepartmentHours (dealerId, deptId) {
            getDepartmentHours(dealerId, deptId)
                .then((result) => {
                    $rootScope.$broadcast('departmentHoursUpdated', result);
                });

            getDepartmentClosedConstraints(dealerId, deptId)
            .then((closedConstraints) => {
                $rootScope.$broadcast('departmentConstraintsUpdated', closedConstraints);
            });
        }

        function processClosedConstraints(closedConstraints) {
            let processedConstraints = null;
            let startDate = null;
            let momentToday = moment.utc(new Date());
            let todaysDate = momentToday.format('YYYY-MM-DD');

            if (closedConstraints && closedConstraints.length > 0) {
                closedConstraints.forEach((currConstraint) => {
                    if (currConstraint.isDeleted === false && (!currConstraint.startTime || currConstraint.allDay)) {
                        startDate = currConstraint.startDate.substr(0, 10);

                        let validConstraint = false;
                        let pastDate = false;

                        if (startDate < todaysDate && currConstraint.repeatAnnually) {
                            validConstraint = true;
                            pastDate = true;
                        } else if (startDate >= todaysDate) {
                            validConstraint = true;
                        }

                        if (validConstraint) {
                            // add a year to the date
                            // until it's in the future
                            if (pastDate) {
                                let stillPast = true;
                                let currMomentDate = null;

                                while (stillPast) {
                                    currMomentDate = moment.utc(startDate).add(1, 'years');
                                    startDate = currMomentDate.format('YYYY-MM-DD');

                                    if (startDate >= todaysDate) {
                                        stillPast = false;

                                        if (processedConstraints === null) {
                                            processedConstraints = [];
                                        }
        
                                        processedConstraints.push(startDate);
                                    }
                                }

                            } else {
                                if (processedConstraints === null) {
                                    processedConstraints = [];
                                }

                                processedConstraints.push(startDate);
                            }

                        
                        }
                    }
                });
            }

            return processedConstraints;
        }

        function isDateSelecteable (date, type, hours, closedConstraints) {
            let momentToday = moment.utc(new Date());
            let strToday = momentToday.format('YYYY-MM-DD');
            let monthToday = momentToday.format('MM');
            let yearToday = momentToday.format('YYYY');
            let dayOfWeek = date.format('dddd');
            let dateString = date.format('YYYY-MM-DD');
            let monthString = date.format('MM');
            let yearString = date.format('YYYY');

            if (type === 'year' && yearString < yearToday) return false;

            if (type === 'year' && yearString >= yearToday) return true;

            if (type === 'month' && yearString < yearToday) return false;

            if (type === 'month' && yearToday === yearString && monthString < monthToday) return false;

            if (type === 'month' && yearToday === yearString && monthString >= monthToday) return true;
            
            if (type === 'day' && dateString < strToday) return false;

            // disable any days of the week the dealer is closed
            if (hours) {
                if (hours.isClosedSaturday === true && dayOfWeek === 'Saturday') return false;
                if (hours.isClosedSunday === true && dayOfWeek === 'Sunday') return false;
                if (hours.isClosedMonday === true && dayOfWeek === 'Monday') return false;
                if (hours.isClosedTuesday === true && dayOfWeek === 'Tuesday') return false;
                if (hours.isClosedWednesday === true && dayOfWeek === 'Wednesday') return false;
                if (hours.isClosedThursday === true && dayOfWeek === 'Thursday') return false;
                if (hours.isClosedFriday === true && dayOfWeek === 'Friday') return false;
            }


            if (closedConstraints) {
                let strDate = date.format('YYYY-MM-DD');

                if (closedConstraints.includes(strDate)) return false;
            }
            
            return true;
        }

        function requiresCapacityValidation (vm, checkServices) {
            let appt = vm.appointment;

            if (vm.appointment.id && 
                vm.originalAppointmentDateTime === appt.apptDateTime &&
                vm.originalDealerEmployeeId === appt.dealerEmployeeId &&
                vm.originalDepartmentId === appt.departmentId &&
                vm.originalTransportationType === appt.dealerTransportationTypeId &&
                vm.originalPickupLocation === appt.tripPickupLocation) {
                    // only check this if there is a pickup location .. it gets set to false
                    // by default in consumer so for drop offs it won't match.
                    if (vm.originalPickupLocation && appt.tripPickupLocation) {
                        if (vm.originalIsManual !== appt.isManual) return true;
                    }

                    if (checkServices) {
                        if (vm.servicesModified === true) {
                            return true;
                        } else {
                            return false;
                        }
                    } 

                    return false;
                }

                return true;
        }

        function validateCapacity(dealerId, appointmentModel, previouslyDeclinedServices) {
            let promise;
            let appointmentToBook = preProcessAppointment(dealerId, appointmentModel);

            appointmentToBook.errors = [];

            if (previouslyDeclinedServices) {
                appointmentUtilService.preProcesPreviouslyDeclinedServices(appointmentToBook, previouslyDeclinedServices);
            }

            if (appointmentModel.advisor) {
                appointmentToBook.dealerEmployeeId = appointmentModel.advisor.id;
                appointmentToBook.serviceAdvisorNumber = appointmentModel.advisor.employeeNumber;
            }

            // Create the first promise and chain remaining
            promise = consumerApi.post(CONSUMER_APPOINTMENT_BASEPATH + dealerId + '/appointment/validateCapacity', appointmentToBook)
                .then((result) => {
                    // Trip booking is handled in the backend - return the result
                    return result;
                }, (error) => {
                    // Parse out the booking errors
                    if (error && error.data && error.data.message && error.status === 400) {
                        return {
                            errors: [error.data.message]
                        };
                    } else {
                        return {
                            errors: ['Oops… we had a problem booking your appointment. Please contact the dealership.']
                        };
                    }
                }
            );

            return promise;
        }

        function isDepartmentRankingCompleted(dealerDeparments) {
            let hasRanking = false;

            if (dealerDeparments && dealerDeparments.length > 0) {
                dealerDeparments.forEach((department) => {
                    if (department.rank) {
                        hasRanking = true;
                    }
                });
            }

            return hasRanking;
        }

        // the below functions are called both by booking and ghost garage
        // so if you modify them need to test booking/editing in both booking workflows

        function getAndProcessPreviouslyDeclinedServices(vm) {
            let appt = vm.appointment;
            let opCodes = vm.dealerOpCodes;

            if (appt.vin && appt.customerId && vm.department.showPreviouslyDeclinedServicesConsumer) {
                // check for previously declined services
                vm.gettingPreviouslyDeclinedServices = true;
                getPreviouslyDeclinedServices(vm.dealer.dealerId, appt.customerId, appt.vin)
                .then((response) => {
                    let nonRecalls = null;
                    
                    if (response) {
                        nonRecalls = $filter('filter')(response, {isRecall: false}, true);

                        appointmentUtilService.processPreviouslyDeclinedLineItems(nonRecalls, opCodes.all, opCodes.opCodes);
                    }

                    vm.previouslyDeclinedServices = nonRecalls;
                    vm.gettingPreviouslyDeclinedServices = false;
                    $rootScope.$broadcast('previouslyDeclinedServicesUpdated', vm.previouslyDeclinedServices);
                }).finally(() => { 
                    vm.gettingPreviouslyDeclinedServices = false;
                 });
            }
        }

        function filterDepartmentData(vm, consumerTripTypes, dealerOpCodes, currDeptId) {
            vm.dealerOpCodes = filterDepartmentOpCodes(dealerOpCodes, currDeptId);
            vm.genericConsumerServiceEnabled = false;
    
            if (vm.dealerOpCodes && vm.dealerOpCodes.genericOpCodes)  {
                vm.dealerGenericOpCodes = vm.dealerOpCodes.genericOpCodes;
                vm.firstGenericOpCode = vm.dealerGenericOpCodes[0];
                vm.genericConsumerServiceEnabled = vm.firstGenericOpCode ? vm.firstGenericOpCode.showInConsumer : false;
            }

            // Trip Types
            vm.tripTypes = filterDepartmentTransportationTypes(consumerTripTypes, currDeptId);
            vm.defaultPickupTripType = getDefaultPickUp(vm.tripTypes, vm.configValues);

            if (!vm.dealer.enableRideShareCredits) {
                vm.tripTypes.dropOffTransportationTypes = vm.tripTypes.dropOffTransportationTypes
                    .filter((type) => type.dealerSystemTransportationTypeId !== vm.apptTransporationTypes.rideshareCredits);
                vm.transportationTypes = vm.transportationTypes
                    .filter((type) => type.dealerSystemTransportationTypeId !== vm.apptTransporationTypes.rideshareCredits);
            }

            let tripTypeInfo = {
                allTripTypes: vm.tripTypes,
                selTripType: vm.tripType
            };

            $rootScope.$broadcast('departmentTripTypesUpdated', tripTypeInfo);
        }
        
        // used by regular and ghost garage when loading recalls, rec maint and prev declined services 
        function loadRecallsRecMaintPrevDeclined (vm) {
            let recallLineItem = vm.dealerOpCodes.recallOpCodes[0];
            let recMaintLineItem = vm.dealerOpCodes.recommendedMaintenanceOpCodes[0];
            let showRecalls = false; let showRecMaint = false;

            vm.recalls = null;
            vm.noRecallsFound = false;
            vm.noRecMaintFound = false;
            
            if (recallLineItem && 
                recallLineItem.recallOpCodeType) {

                showRecalls = true;
                vm.retrievingRecalls = true;

                this.getRecalls(vm.dealer.dealerId, vm.appointment).then((recalls) => {
                    vm.recalls = recalls;
                    $rootScope.$broadcast('recallsUpdated', vm.recalls);

                    if (!vm.appointment.mileage || recMaintLineItem.showInConsumer === false) {
                        getAndProcessPreviouslyDeclinedServices(vm);
                    }
                    
                    vm.retrievingRecalls = false;
                }, (errorResponse) => {
                    vm.recalls = null;
                    vm.noRecallsFound = true;
                    $rootScope.$broadcast('recallsUpdated', vm.recalls);

                    if (!vm.appointment.mileage || recMaintLineItem.showInConsumer === false) {
                        getAndProcessPreviouslyDeclinedServices(vm);
                    }

                    vm.retrievingRecalls = false;
                });
            }

            if (vm.appointment.mileage && 
                recMaintLineItem && 
                recMaintLineItem.showInConsumer === true) {
                showRecMaint = true;
                this.getRecommendedMaintenance(vm.dealer.dealerId, vm.appointment).then((response) => {
                    vm.recMaintData = response.maintenanceIntervals;
                    vm.recMaintDisclaimer = response.motorDisclaimer;
                    $rootScope.$broadcast('recMaintUpdated', vm.recMaintData);
                    vm.retrievingRecmaint = false;
                    getAndProcessPreviouslyDeclinedServices(vm);
                }, (errorResponse) => {
                    vm.recMaintData = null;
                    vm.noRecMaintFound = true;
                    $rootScope.$broadcast('recMaintUpdated', vm.recMaintData);
                    vm.retrievingRecmaint = false;
                    getAndProcessPreviouslyDeclinedServices(vm);
                });
            }

            if (!showRecalls && !showRecMaint) {
                getAndProcessPreviouslyDeclinedServices(vm);
            }
        }

        // used by regular and ghost garage when there is an error creating the appt
		function genericCreateApptError (vm) {
            modalService.showYesNo('Error', 'Error while creating appointment', null, 'OK');
            vm.loading = false;
        }

        // used by regular and ghost garage when clicking back/next to set the state of the UI 
        function setCurrentState (vm, stateToSet) {
            vm.currentState = vm.states.find((s) => s.id === stateToSet);
        }

        // pass in the department we are switching to, and determine if any of the line items on 
        // the appointment won't have a match in the new department, so we can display messaging to the user 
        // BEFORE they switch departments 
        function findMismatchedLineItems(vm, departmentSwitchgingTo) {
            let appointment = vm.appointment; 
            let allOpCodes = vm.dealerOpCodes.all;
            let mismatchedItems = [];
            let departmentSwitchingTo = $filter('filter')(vm.dealerDepartments, {id: departmentSwitchgingTo}, true)[0];
            let deptGenericOpCodes = $filter('filter')(allOpCodes, {dealerDepartmentId: departmentSwitchgingTo, isGeneric: true}, true);
            let deptRecMaintOpCodes = $filter('filter')(allOpCodes, {dealerDepartmentId: departmentSwitchgingTo, isRecommendedMaintenance: true}, true);
            let deptRecallOpCodes = $filter('filter')(allOpCodes, {dealerDepartmentId: departmentSwitchgingTo, isRecall: true}, true);
            let recMaintEnabled = appointmentUtilService.opCodesEnabledForDept(deptRecMaintOpCodes, departmentSwitchgingTo, false);
            let recallsEnabled = appointmentUtilService.opCodesEnabledForDept(deptRecallOpCodes, departmentSwitchgingTo, false);
            let genericEnabled = appointmentUtilService.departmentGenericEnabled(deptGenericOpCodes, departmentSwitchingTo);
            let previouslyDeclinedEnabled = departmentSwitchingTo.showPreviouslyDeclinedServicesConsumer;
            let previouslyDeclinedItems = vm.previouslyDeclinedServices;
        
            if (appointment.lineItems && appointment.lineItems.length > 0) {
                appointment.lineItems.forEach((item) => {
                    if (!item.dealerAppointmentServiceOpCode) {
                        item.dealerAppointmentServiceOpCode = $filter('filter')(allOpCodes, {id: item.dealerAppointmentServiceOpCodeId}, true)[0];
                    }

                    let apptServiceOpCode = item.dealerAppointmentServiceOpCode;
                    let opCode = null;

                    if (item.isAutomatic !== true && apptServiceOpCode && apptServiceOpCode.dealerDepartmentId !== departmentSwitchgingTo) {
                        opCode = appointmentUtilService.getMatchingDepartmentOpCode(allOpCodes, apptServiceOpCode, departmentSwitchgingTo);

                        if (!opCode || opCode.length === 0) {
                            mismatchedItems.push(item);
                        }
                    }

                    if (genericEnabled === false && item.isGeneric === true) {
                        mismatchedItems.push(item);
                    }

                    if (recMaintEnabled === false && item.isRecommendedMaintenance === true) {
                        mismatchedItems.push(item);
                    }

                    if (recallsEnabled === false && item.isRecall === true) {
                        mismatchedItems.push(item);
                    }
                });
            }
            

            if (previouslyDeclinedEnabled === false && previouslyDeclinedItems && previouslyDeclinedItems.length > 0) {
                previouslyDeclinedItems.forEach((item) => {
                    if (item.checked) {
                        mismatchedItems.push(item);
                    }
                });
            }

            return mismatchedItems;
        }
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentViewAppointmentDetailsController.$inject = ["APPOINTMENT_TRANSPORTATION_TYPE", "timeUtilService", "appointmentUtilService"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentViewAppointmentDetails', consumerAppointmentViewAppointmentDetails);

    function consumerAppointmentViewAppointmentDetails() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/view-appointment-details.view.html',
            controller: ConsumerAppointmentViewAppointmentDetailsController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                tripTypes: '<',
                dealer: '<',
                appointment: '<',
                tripType: '<',
                previouslydeclinedservices: '<',
                dealerIntegrations: '<',
                credit: '<'
            }
        };
    }

    function ConsumerAppointmentViewAppointmentDetailsController(APPOINTMENT_TRANSPORTATION_TYPE,
        timeUtilService,
        appointmentUtilService) {
        this.$onInit = function() {
            let vm = this;

            vm.tripPickupDisplayTime = null;
            vm.isPickup = vm.tripType.isPickup;
            vm.isDropoff = vm.tripType.isDropOff;
            vm.isMobile = vm.tripType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage;

            if (vm.appointment && vm.isPickup && vm.appointment.tripPickupTime) {
               vm.tripPickupDisplayTime = timeUtilService.toSpecificTimeFormat(vm.appointment.tripPickupTime, vm.dealer.timeZoneId, 'YYYY-MM-DDTHH:mm:ss');
            }

            if (vm.appointment && vm.appointment.tripPickupLocation) {
                let loc = vm.appointment.tripPickupLocation;

                vm.pickupLocation = {
                    name: loc.name,
                    streetAddress: loc.streetAddress,
                    city: loc.city,
                    state: loc.state,
                    zipCode: loc.zip,
                    countryShortCode: loc.countryShortCode,
                    lat: loc.lat,
                    lng: loc.lng
                };
            }

            vm.isHideRideShareCreditTransportationType = function() {
                if (!vm.credit) return false;

                if (vm.credit &&
                    vm.tripType &&
                    vm.tripType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.rideshareCredits)
                    return true;

                return false;
            };

            vm.getCreditDescription = function() {
                return appointmentUtilService.getCreditDescription(vm.tripTypes.dropOffTransportationTypes);
            };

            vm.getShuttleDescription = function() {
                return appointmentUtilService.getShuttleDescription(vm.tripTypes.dropOffTransportationTypes);
            };

            vm.getLineItemsTotal = function() {
                let total = 0;

                vm.appointment.lineItems.forEach((lineItem) => {
                    let price = parseFloat(lineItem.retailPrice);
  
                    if (!isNaN(price)) {  
                        total += price;  
                    }  
                });

                return parseFloat(total.toFixed(2));
            };

            vm.getTripTypeLabel = function() {
                let tripTypeId = vm.tripType.dealerSystemTransportationTypeId;

                if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.dropOff) {
                    return "Customer Will Drop Off";
                } else if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.waiter) {
                    return "Customer Will Wait";
                } else if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.shuttle) {
                    return vm.getShuttleDescription() + ' Requested';
                } else if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.dropOffLoaner) {
                    return "Loaner Requested";
                } else if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.rideshareCredits) {
                    return vm.getCreditDescription() + " Requested";
                } else if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.pickupNoLoaner) {
                    return "Pick Up Customer Vehicle";
                } else if (tripTypeId === APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner) {
                    return "Loaner Requested";
                }

            };
        };
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentLandingChooseDepartmentTransportationController.$inject = ["$rootScope", "$scope", "modalService", "consumerAppointmentService"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentLandingChooseDepartmentTransportation', consumerAppointmentLandingChooseDepartmentTransportation);

    function consumerAppointmentLandingChooseDepartmentTransportation() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/landing-choose-department-transportation.view.html',
            controller: ConsumerAppointmentLandingChooseDepartmentTransportationController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                transportationTypes: '<',
                department: '<',
                branding: '<',
                dealer: '<',
                buttonText: '<',
                appointment: '<',
                pickup: '<',
                isLanding: '<',
                dealerOpCodes: '<',
                dealerDepartments: '<',
                previouslyDeclinedServices: '<'
            }
        };
    }

    function ConsumerAppointmentLandingChooseDepartmentTransportationController($rootScope,
        $scope,
        modalService,
        consumerAppointmentService) {
        this.$onInit = function() {
            let vm = this;

            if (!vm.buttonText) {
                vm.buttonText = 'GET STARTED';
            }

            vm.tripType = null;
            vm.defaultDropoffTransportationType = null;
            vm.defaultPickupTransportationType = null;
            vm.defaultMobileGarageTransortationType = null;

            vm.firstChoiceTitle = vm.branding.landingFirstChoiceTitle;
            vm.secondChoiceTitle = vm.branding.landingSecondChoiceTitle;

            vm.showRadioButtons = function() {
                let cnt = 0;

                if (vm.defaultDropoffTransportationType) {
                    cnt++;
                }

                if (vm.defaultPickupTransportationType) {
                    cnt++;
                }

                if (vm.defaultMobileGarageTransortationType) {
                    cnt++;
                }

                if (cnt > 1) return true;

                if (cnt === 1) {
                    if (vm.defaultDropoffTransportationType) {
                        vm.tripType = vm.defaultDropoffTransportationType;
                    }

                    if (vm.defaultPickupTransportationType) {
                        vm.tripType = vm.defaultPickupTransportationType;
                    }

                    if (vm.defaultMobileGarageTransortationType) {
                        vm.tripType = vm.defaultMobileGarageTransortationType;
                    }
                }

                return false;
            };

            vm.disableGetStarted = function() {
                let type = vm.tripType;

                if (!type) return true;

                let typeNotSelected = !type.isDropOff && !vm.pickupLocation;
                let outOfServiceArea = !type.isDropOff && vm.pickupLocation && vm.pickupLocation.isInServiceArea === false;

                return typeNotSelected || vm.checkingServiceArea || outOfServiceArea;
            };

            vm.pickUpChanged = function() {
                vm.checkingServiceArea = true;
                consumerAppointmentService.isInServiceArea(vm.dealer.dealerId, vm.pickupLocation).then((result) => {
                    vm.checkingServiceArea = false;
                    vm.pickupLocation.isInServiceArea = result;

                    if (result) {
                        $rootScope.$broadcast('departmentPickupChanged', vm.pickupLocation);
                    } else {
                        $rootScope.$broadcast('clearMap', null);
                    }
                },
                (error) => {
                    vm.checkingServiceArea = false;
                }).finally(() => {});
            };

            vm.getStarted = function() {
                let selectedInfo = {
                    tripType: vm.tripType,
                    department: vm.department,
                    pickupLocation: vm.pickupLocation
                };

                let finishUp = function() {
                    $rootScope.$broadcast('departmentGetStartedClicked', selectedInfo);
                };

                if (vm.isLanding === true) {
                    finishUp();
                } else {
                    let mismatchedItems = consumerAppointmentService.findMismatchedLineItems(vm, vm.department.id);

                    if (mismatchedItems && mismatchedItems.length > 0) {
                        let modalBody =
                            'The previously entered service needs below may not be supported by the selected department and will be removed.  If you choose to switch departments, please select from the list of available services offered by that department.<br/><br/><ul>';

                        mismatchedItems.forEach((item) => {
                            modalBody += "<li>";

                            // determine the display text for each line item
                            // based on each line item type
                            if (item.isGeneric === true) {
                                modalBody += "Customer Entered Issue: " + item.note;
                            } else if (item.isRecommendedMaintenance === true) {
                                modalBody += item.opCodeDescription ||
                                    item.consumerName ||
                                    item.consumerDescription ||
                                    item.name;
                            } else if (item.isRecall) {
                                modalBody += "Recall: ";
                                modalBody += item.recallDisplayName ? item.recallDisplayName : item.note;
                            } else {
                                modalBody += item.consumerName ||
                                    item.consumerDescription ||
                                    item.name ||
                                    item.opCodeDescription;
                            }

                            modalBody += "</li>";
                        });

                        modalBody += "</ul>Are you sure you want to switch to the selected department?";
                        let confirm = modalService.showYesNo('Please Confirm', modalBody, 'No', 'Yes');

                        confirm.then((confirmed) => {
                            if (confirmed) {
                                finishUp();
                            }
                        });
                    } else {
                        finishUp();
                    }

                }
            };

            function initPanel() {
                let appt = vm.appointment;
                let currTransId = appt ? appt.dealerTransportationTypeId : null;

                vm.departmentTransportationTypes =
                    consumerAppointmentService.filterDepartmentTransportationTypes(vm.transportationTypes,
                        vm.department.id);
                vm.defaultDropoffTransportationType =
                    consumerAppointmentService.getDefaultDropOff(vm.departmentTransportationTypes);

                if (vm.departmentTransportationTypes.pickUpTransportationTypes.length > 0) {
                    vm.defaultPickupTransportationType =
                        consumerAppointmentService.getDefaultPickUp(vm.departmentTransportationTypes, vm.branding);
                }

                if (vm.departmentTransportationTypes.mobileGarageType.length > 0 &&
                    vm.departmentTransportationTypes.mobileGarageType[0].showInConsumer === true) {
                    vm.defaultMobileGarageTransortationType = vm.departmentTransportationTypes.mobileGarageType[0];
                }

                if (appt && appt.departmentId === vm.department.id) {
                    if (vm.defaultPickupTransportationType && currTransId === vm.defaultPickupTransportationType.id) {
                        vm.tripType = vm.defaultPickupTransportationType;
                        vm.pickupLocation = vm.pickup;
                    } else if (vm.defaultDropoffTransportationType &&
                        currTransId === vm.defaultDropoffTransportationType.id) {
                        vm.tripType = vm.defaultDropoffTransportationType;
                    } else if (vm.defaultMobileGarageTransortationType &&
                        currTransId === vm.defaultMobileGarageTransortationType.id) {
                        vm.tripType = vm.defaultMobileGarageTransortationType;
                        vm.pickupLocation = vm.pickup;
                    }
                }
            }

            initPanel();

            $scope.$on("pickUpChanged", (e, newValue) => {
                if (newValue && newValue.department.id === vm.department.id) {
                    if (vm.tripType && !vm.tripType.isDropOff) {
                        vm.pickupLocation = newValue.pickUp;
                        vm.pickUpChanged();
                    }

                }
            });
        };
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentEditVehicleOwnerInformationController.$inject = ["$rootScope", "$scope", "APPOINTMENT_CUSTOMERTYPE", "appointmentUtilService", "consumerMessagesService", "SYSTEM_ENUMS", "rcUtilService"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentEditVehicleOwnerInformation', consumerAppointmentEditVehicleOwnerInformation);

    function consumerAppointmentEditVehicleOwnerInformation() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/edit-vehicle-owner-information.view.html',
            controller: ConsumerAppointmentEditVehicleOwnerInformationController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealer: '<',
                appointment: '=',
                requiredfields: '=',
                vehicleFormSubmitted: '<',
                form: '=',
                ghostGarage: '<'
            }
        };
    }

    function ConsumerAppointmentEditVehicleOwnerInformationController($rootScope,
        $scope,
        APPOINTMENT_CUSTOMERTYPE,
        appointmentUtilService,
        consumerMessagesService,
        SYSTEM_ENUMS,
        rcUtilService) {
        this.$onInit = function() {
            let vm = this;

            vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
            vm.supportedCountries = SYSTEM_ENUMS.supportedCountries;
            vm.appointmentLanguages = SYSTEM_ENUMS.appointmentLanguages;
            vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
            vm.usStates = SYSTEM_ENUMS.usStates;
            vm.customerType = APPOINTMENT_CUSTOMERTYPE;
            vm.appointment.customerIsBusiness =
            vm.appointment.customerType === APPOINTMENT_CUSTOMERTYPE.business;
            vm.ghostGarage = parseInt(vm.ghostGarage);

            if (vm.appointment.customerState === "") {
                vm.appointment.customerState = null;
            }
            
            vm.disableCustomerFields = function() {
                return vm.appointment.customerId !== "";
            };

            vm.validation = {
                validEmail: function() {
                    return rcUtilService.isValidEmail(vm.appointment.customerEmail);
                },
                combinedCustomerNameLength: function() {
                    return appointmentUtilService.validateCombinedCustomerNameLength(vm.dealer.dmsSystem,
                        vm.appointment.customerFirstName,
                        vm.appointment.customerLastName,
                        vm.appointment.customerIsBusiness);
                }
            };

            function checkPhoneType(phoneNumber) {
                if (phoneNumber && phoneNumber.length === 10) {
                    vm.isPhoneNumberValidating = true;
                    consumerMessagesService.checkPhoneNumber(phoneNumber, vm.dealer.dealerId)
                        .then((response) => {
                            vm.customerPhoneType = response;
                            $rootScope.$broadcast('customerPhoneTypeChanged', vm.customerPhoneType);
                        })
                        .finally(() => {
                            vm.isPhoneNumberValidating = false;
                        });
                } else {
                    vm.customerPhoneType = {type: vm.phoneTypes.unknown};
                    vm.appointment.invalidPhone = true;
                }
            }

            vm.mobilePhoneUpdated = function(phoneNumber) {
                checkPhoneType(phoneNumber);
            };


            vm.displayAddressFields = function() {
                // false for first parameter from consumer pages always, because we don't have a show/hide address link
                return appointmentUtilService.displayAddressFields(false, true, vm.requiredfields);
            };

            vm.displayCountyCountry = function() {
                // false for first parameter from consumer pages always, because we don't have a show/hide address link
                return appointmentUtilService.displayCountyCountry(false, true, vm.requiredfields);
            };

            vm.displayLanguage = function() {
                // false for first parameter from consumer pages always, because we don't have a show/hide address link
                return appointmentUtilService.displayLanguage(false, true, vm.requiredfields);
            };

            vm.isBusinessUpdated = function() {
                vm.appointment.customerType = vm.appointment.customerIsBusiness
                    ? vm.customerType.business
                    : vm.customerType.individual;

                if (vm.appointment.customerType === vm.customerType.individual) {
                    vm.appointment.customerCompany = null;
                }
            };

            if (vm.appointment.customerPhone) {
                checkPhoneType(vm.appointment.customerPhone);
            }

            $scope.$watch('consumerVehicleOwner',
                (newValue) => {
                    vm.form = newValue;
                });
        };
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentEditVehicleInformationController.$inject = ["$rootScope", "$scope", "$filter", "$window", "$timeout", "appointmentUtilService", "OLDER_VEHICLES", "SYSTEM_ENUMS", "rcUtilService", "consumerAppointmentService"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentEditVehicleInformation', consumerAppointmentEditVehicleInformation);

    function consumerAppointmentEditVehicleInformation() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/edit-vehicle-information.view.html',
            controller: ConsumerAppointmentEditVehicleInformationController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealer: '<',
                appointment: '<?',
                vehicles: '<',
                vehicleformsubmitted: '<',
                initialvehicleselected: '<',
                form: '=',
                ghostGarage: '<'
            }
        };
    }

    function ConsumerAppointmentEditVehicleInformationController($rootScope,
        $scope,
        $filter,
        $window,
        $timeout,
        appointmentUtilService,
        OLDER_VEHICLES,
        SYSTEM_ENUMS,
        rcUtilService,
        consumerAppointmentService) {
        this.$onInit = function() {
            let vm = this;
            let initVehicleSelection = false;
            let currentYear = new Date().getFullYear();

            vm.maxVehicleYear = currentYear + 1;
            vm.ymmOlderVehicles = false;
            vm.dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;
            vm.transmission = 'automatic';
            vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
            vm.vehicleSelected = vm.initialvehicleselected;
            vm.ghostGarage = parseInt(vm.ghostGarage);
            vm.needsScheduleTransportationUpdate = false;
            vm.initialYMM = {
                year: null,
                make: '',
                model: '',
                vin: '',
                mileageType: _.find(vm.odometerTypes,
                    (r) => { return r.type === vm.dealer.country.measurementType; })
            };

            vm.appendOlderVehicles = function(years) {
                if (vm.dealer.configValues.appointmentVehiclesRestricted === true) {
                    return;
                }

                if (vm.dealer.dmsSystem !== vm.dmsEnum.CDK) {
                    if (!years) {
                        years = [];
                    }

                    years.push(OLDER_VEHICLES);
                }
            };

            vm.vehicleHasChanged = function() {
                let year = parseInt(vm.appointment.year);
                    let make = vm.appointment.make.toUpperCase();
                    let model = vm.appointment.model.toUpperCase();

                return year !== parseInt(vm.initialYMM.year) ||
                    make !== vm.initialYMM.make.toUpperCase() ||
                    model !== vm.initialYMM.model.toUpperCase();
            };

            vm.newVehicle = {
                make: null,
                mileage: null,
                model: null,
                vehicleId: null,
                vin: null,
                year: null,
                mileageType: _.find(vm.odometerTypes,
                    (r) => { return r.type === vm.dealer.country.measurementType; })
            };

            vm.getYears = getYears;
            vm.updateMakes = updateMakes;
            vm.updateModels = updateModels;
            vm.modelSelected = modelSelected;
            vm.onSelectVehicle = onSelectVehicle;

            if (vm.appointment.id && vm.appointment.year && vm.appointment.make) {
                initVehicleSelection = true;
                vm.initialYMM.year = vm.appointment.year;
                vm.initialYMM.make = vm.appointment.make;
                vm.initialYMM.model = vm.appointment.model;
                vm.initialYMM.vin = vm.appointment.vin;
                vm.initialYMM.mileageType = vm.appointment.mileageType;
            }

            if (vm.appointment.year === "") {
                vm.appointment.year = null;
            }

            if (vm.appointment.subModel === "") {
                vm.appointment.subModel = null;
            }

            vm.ensureVehicleYearInDropDown = function() {
                if (!vm.appointment.year || vm.appointment.year === "") return;

                let year = parseInt(vm.appointment.year);
                    let exists = _.some(vm.vehicleYears,
                        (yearToCompare) => {
                            return parseInt(yearToCompare) !== year;
                        });

                if (!exists && year !== "" & year !== null) {
                    if (!vm.vehicleYears) {
                        vm.vehicleYears = [];
                    }

                    vm.vehicleYears.push(year);
                }

            };

            vm.ensureVehicleMakeInDropDown = function() {
                let make = vm.appointment.make;
                let exists = _.some(vm.makes,
                    (makeToCompare) => {
                        return makeToCompare.makeCode.toLowerCase() === make.toLowerCase() ||
                            makeToCompare.make.toLowerCase() === make.toLowerCase();
                    });

                if (!exists) {
                    if (!vm.makes) {
                        vm.makes = [];
                    }

                    vm.makes.push({make: make, makeCode: make});
                }

            };

            vm.ensureVehicleModelInDropDown = function() {
                let model = vm.appointment.model;
                let exists = _.some(vm.models,
                    (modelToCompare) => {
                        return modelToCompare.modelCode.toLowerCase() === model.toLowerCase() ||
                            modelToCompare.model.toLowerCase() === model.toLowerCase();
                    });

                if (!exists) {
                    if (!vm.models) {
                        vm.models = [];
                    }

                    vm.models.push({model: model, modelCode: model});
                }

            };

            vm.validation = {
                valYear: function() {
                    return rcUtilService.isValidYear(vm.appointment.year, 1900, vm.maxVehicleYear);
                }
            };

            vm.vehicleKeyDown = function(e) {
                rcUtilService.vehicleKeyDown(e);
            };

            vm.switchYMMToDropDowns = function() {
                vm.ymmOlderVehicles = false;
                vm.appointment.year = null;
                vm.appointment.make = null;
                vm.appointment.model = null;

            };

            function getDealerTripTypeId() {
                return vm.dealer.configValues.appointmentTripTypeId;
            }

            function getYears() {
                if (vm.vehicleYears) return;
                vm.loadingYears = true;

                consumerAppointmentService.getVehicleYears(vm.dealer.dealerId, getDealerTripTypeId()).then(
                    (years) => {
                        vm.appendOlderVehicles(years);
                        vm.vehicleYears = years;
                        vm.ensureVehicleYearInDropDown();

                        if (initVehicleSelection && vm.vehicleYears) {
                            $timeout(() => {
                                    updateMakes();
                                },
                                1);
                        }
                    }).finally(() => {
                    vm.loadingYears = false;
                });
            }

            function switchYMMToTextInputs() {
                vm.ymmOlderVehicles = true;
                vm.appointment.year = null;
            }

            function updateMakes() {
                if (vm.appointment.year === OLDER_VEHICLES) {
                    switchYMMToTextInputs();

                    return;
                }

                vm.loadingMakes = true;
                consumerAppointmentService
                    .getMakesInYear(vm.dealer.dealerId, vm.appointment.year, getDealerTripTypeId()).then(
                        (makes) => {
                            vm.makes = makes;

                            if (initVehicleSelection && vm.makes) {
                                $timeout(() => {
                                        vm.ensureVehicleMakeInDropDown();
                                        let compareTo = vm.appointment.make.toLowerCase();
                                        let findMake = $filter('filter')(vm.makes,
                                            (item) => {
                                                return item.makeCode.toLowerCase() === compareTo ||
                                                    item.make.toLowerCase() === compareTo;
                                            },
                                            true);

                                        if (findMake && findMake.length > 0) {
                                            vm.selectedMake = findMake[0];
                                            vm.appointment.make = vm.selectedMake ? vm.selectedMake.makeCode : null;
                                        }

                                        updateModels();
                                    },
                                    1);
                            }
                        }).finally(() => {
                        // below will set focus to the make input after all of the 
                        // values have been populated
                        let makeElement = $window.document.getElementById('make');

                        if (makeElement) {
                            $timeout(() => {
                                    makeElement.focus();
                                },
                                0);
                        }

                        if (vm.appointment.year && vm.appointment.make && vm.appointment.model) {
                            $rootScope.$broadcast('vehicleUpdated');
                        }

                        vm.loadingMakes = false;
                    });
            }

            function updateModels() {
                vm.model = '';
                vm.appointment.make = vm.selectedMake ? vm.selectedMake.makeCode : null;
                vm.appointment.selectedDMSMake = vm.selectedMake;

                if (vm.appointment.make) {
                    vm.loadingModels = true;
                    consumerAppointmentService.getModelsForMakeInYear(vm.dealer.dealerId,
                        vm.appointment.year,
                        vm.selectedMake.make,
                        getDealerTripTypeId()).then((models) => {
                        vm.models = models;

                        if (initVehicleSelection) {
                            $timeout(() => {

                                    vm.ensureVehicleModelInDropDown();
                                    let compareTo = vm.appointment.model.toLowerCase();
                                        let findModel = $filter('filter')(vm.models,
                                            (item) => {
                                                return item.modelCode.toLowerCase() === compareTo ||
                                                    item.model.toLowerCase() === compareTo;
                                            },
                                            true);

                                    if (findModel && findModel.length > 0) {
                                        vm.selectedModel = findModel[0];
                                        vm.appointment.model = vm.selectedModel ? vm.selectedModel.modelCode : null;
                                    }

                                    vm.appointment.selectedDMSModel = vm.selectedModel;
                                    vm.loadingSubModels = true;
                                    consumerAppointmentService.getSubModelsForMakeInYear(vm.dealer.dealerId,
                                            vm.appointment.year,
                                            vm.selectedMake.make,
                                            vm.selectedModel.model).then((submodels) => {
                                            vm.subModels = submodels;
                                            vm.loadingSubModels = false;
                                            $timeout(() => {
                                                    let compareToSub = vm.appointment.subModel?.toLowerCase();
                                                        let findSubModel = $filter('filter')(vm.subModels,
                                                            (item) => {
                                                                return item.toLowerCase() === compareToSub;
                                                            },
                                                            true);

                                                    if (findSubModel && findSubModel.length > 0) {
                                                        vm.selectedSubModel = findSubModel[0];
                                                        vm.appointment.subModel = vm.selectedSubModel;
                                                    }
                                                },
                                                1);
                                        })
                                        .finally(() => {
                                            vm.loadingSubModels = false;
                                        });
                                },
                                1);
                        }

                        initVehicleSelection = false;
                    }).finally(() => {
                        // below will set focus to the model input after all of the 
                        // values have been populated
                        let modelElement = $window.document.getElementById('model');

                        if (modelElement) {
                            $timeout(() => {
                                    modelElement.focus();
                                },
                                0);
                        }

                        if (vm.appointment.year && vm.appointment.make && vm.appointment.model) {
                            $rootScope.$broadcast('vehicleUpdated');
                        }

                        vm.loadingModels = false;
                    });
                } else {
                    vm.models = null;
                }
            }

            function modelSelected() {
                vm.appointment.model = vm.selectedModel ? vm.selectedModel.modelCode : null;
                vm.appointment.selectedDMSModel = vm.selectedModel;

                if (vm.appointment.model) {
                    vm.loadingSubModels = true;

                    // If we have altered the YMM from the original and we have a VIN, we need to clear it out
                    if (vm.vehicleHasChanged()) {
                        vm.appointment.vin = null;
                    } else if (vm.initialYMM.vin) {
                        vm.appointment.vin = vm.initialYMM.vin;
                    }

                    consumerAppointmentService.getSubModelsForMakeInYear(vm.dealer.dealerId,
                            vm.appointment.year,
                            vm.appointment.selectedDMSMake.make,
                            vm.appointment.selectedDMSModel.model)
                        .then((result) => {
                            vm.subModels = result;
                            vm.loadingSubModels = false;
                        })
                        .finally(() => {
                            vm.loadingSubModels = false;

                            if (vm.appointment.year && vm.appointment.make && vm.appointment.model) {
                                $rootScope.$broadcast('vehicleUpdated');
                            }
                        });
                }
            }

            function onSelectVehicle(inputVehicle, initial = false) {
                if (!initial && !vm.needsScheduleTransportationUpdate) showUpdateWarning();
                let vehicle = vm.vehicleSelected;

                if (!vehicle.makeName) {
                    vehicle.makeName = vehicle.make;
                }

                if (!vehicle.modelName) {
                    vehicle.modelName = vehicle.model;
                }

                if (vm.appointment.id) {
                    vehicle.mileage = vm.appointment.mileage;
                }

                angular.extend(vm.appointment, vehicle);

                vm.appointment.selectedDMSMake = {
                    make: vehicle.make,
                    makeName: vehicle.makeName
                };

                vm.appointment.selectedDMSModel = {
                    modelName: vehicle.modelName,
                    model: vehicle.model
                };

                if (vm.appointment.mileage) {
                    vm.appointment.mileage = parseInt(vm.appointment.mileage);
                }

                if (!vm.appointment.id) {
                    vm.appointment.mileage = null;
                }

                if (!vm.appointment.year && !vm.appointment.make && !vm.appointment.model) {
                    vm.makes = [];
                    vm.models = [];
                } else {
                    $rootScope.$broadcast('vehicleUpdated');
                    $scope.$broadcast('angularValidation.revalidate', 'year');
                    $scope.$broadcast('angularValidation.revalidate', 'make');
                    $scope.$broadcast('angularValidation.revalidate', 'model');
                    $scope.$broadcast('angularValidation.revalidate', 'mileage');
                }
            }

            vm.customerNameRequired = function() {
                return appointmentUtilService.customerNameRequired(vm.dealer.dmsSystem);
            };

            function showUpdateWarning() {
                $rootScope.$broadcast('showUpdateWarning');
                vm.needsScheduleTransportationUpdate = true;
            }

            $scope.$watch('consumerVehicleInformation',
                (newValue) => {
                    vm.form = newValue;
                });

            $scope.$watch('vm.initialvehicleselected',
                (newValue) => {
                    if (newValue == null) {
                        return;
                    }
                    
                    if (newValue && newValue.vehicleId) {
                        vm.vehicleSelected = newValue;
                    } else if (newValue) {
                        vm.vehicleSelected = newValue;
                        vm.newVehicle.year = newValue.year;
                        vm.newVehicle.make = newValue.make;
                        vm.newVehicle.model = newValue.model;
                        vm.newVehicle.vin = newValue.vin;
                    } else if (vm.newVehicle) {
                        vm.vehicleSelected = vm.newVehicle;
                    }

                    if (vm.vehicleSelected) {
                        onSelectVehicle(null, true);
                    }
                });
        };
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentEditAppointmentDetailsController.$inject = ["$scope", "$rootScope", "$filter", "$timeout", "APPOINTMENT_TRANSPORTATION_TYPE_GROUP", "consumerAppointmentService", "appointmentUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentEditAppointmentDetails', consumerAppointmentEditAppointmentDetails);

    function consumerAppointmentEditAppointmentDetails() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/edit-appointment-details.view.html',
            controller: ConsumerAppointmentEditAppointmentDetailsController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealer: '<',
                tripTypes: '<',
                transmissions: '<',
                configValues: '=',
                appointment: '<',
                tripType: '=',
                pickupLocation: '<',
				lastserviceadvisor: '<',
                detailsformsubmitted: '<',
                defaulttopreviousadvisor: '<',
                originalappointmenthasloaner: '<',
                ghostGarage: '<',
                department: '<',
                departmentHours: '<',
                departmentConstraints: '<',
                form: '='
            }
        };
    }

    function ConsumerAppointmentEditAppointmentDetailsController($scope,
        $rootScope,
        $filter,
        $timeout,
        APPOINTMENT_TRANSPORTATION_TYPE_GROUP,
        consumerAppointmentService,
        appointmentUtilService,
        SYSTEM_ENUMS) {
        this.$onInit = function() {
            let vm = this;
            let today = moment(new Date());

            vm.canSelectAnyAdvisor = vm.dealer.dmsSystem !== SYSTEM_ENUMS.dmsSystemEnum.Tekion;

            function updateDepartmentData() {
                let tripTypes = vm.tripTypes;
                let configs = vm.configValues;

                vm.displayLoanerSections =
                    consumerAppointmentService.displayLoanerSections(tripTypes, vm.originalappointmenthasloaner);
                vm.dropOffTransportationTypes =
                    $filter('filter')(tripTypes.dropOffTransportationTypes, {showInConsumer: true}, true);
                vm.pickupTransportationTypes =
                    $filter('filter')(tripTypes.pickUpTransportationTypes, {showInConsumer: true}, true);
                vm.defaultPickupTripType = consumerAppointmentService.getDefaultPickUp(tripTypes, configs);

                vm.defaultDropOff = consumerAppointmentService.getDefaultDropOff(tripTypes);
                vm.defaultPickUp = consumerAppointmentService.getDefaultPickUp(tripTypes, configs);
                vm.defaultMobile = consumerAppointmentService.getMobileTransportationType(tripTypes);
            }

            vm.transTypeGroups = APPOINTMENT_TRANSPORTATION_TYPE_GROUP;
            vm.ghostGarage = parseInt(vm.ghostGarage);
            // GET THE DEFAULT DROP OFF TRIP TYPE
            vm.isApptPast = false;
            vm.daysToDisplay = 7;
            vm.needLoaner = null;
            vm.time = null;
            vm.minCalendarDate = null;

            vm.defaultPickUpLoaner = null;
            vm.defaultDropOffLoaner = null;

            // Time slots
            vm.availSlotErrors = null;
            vm.availTimeSlots = null;
            vm.availTimeSlotsVisualPicker = null;
            vm.selectedDay = null;
            vm.disabledDates = [];
            vm.minDate = moment().format('MM/DD/YYYY');
            vm.maxDate = moment().add(180, 'days').format('MM/DD/YYYY');

            vm.pickupTimeChanged = pickupTimeChanged;
            vm.transmissionChanged = transmissionChanged;
            vm.getDealerSlots = getDealerSlots;
            vm.transportationUpdated = transportationUpdated;
            vm.advisorUpdated = advisorUpdated;
            vm.defaultNoLoanerStartAtDealer = null;
            vm.defaultDropOff = null;
            vm.showRadioButtons = false;
            vm.needsScheduleTransportationUpdate = false;

            function setTransportation() {
                if (vm.tripType) {
                    if (vm.tripType.isPickup === true) {
                        vm.transportation = vm.transTypeGroups.pickup;
                    } else if (vm.tripType.isDropOff === true) {
                        vm.transportation = vm.transTypeGroups.dropoff;
                    } else {
                        vm.transportation = vm.transTypeGroups.mobile;
                    }
                }

            }


            function isApptInPast() {
                if (vm.availTimeSlots &&
                    moment.tz(vm.appointment.apptDateTime, vm.availTimeSlots.timeZoneId)
                    .isBefore(moment.tz(vm.availTimeSlots.timeZoneId))) {
                    vm.isApptPast = true;
                } else {
                    vm.isApptPast = false;
                }
            }

            function resetLoanerOptions() {
                if (vm.tripType.hasLoaner) {
                    vm.needLoaner = 'true';
                } else {
                    vm.needLoaner = 'false';
                }
            }

            function init(departmentUpdated) {
                // make sure we get the default advisor before getting availability
                let advisorsPromise = getServiceAdvisors();

                updateDepartmentData();

                let cnt = 0;

                let setTripType = function(departmentUpdated) {
                    if (vm.showRadioButtons === false) {
                        if (vm.defaultDropOff) vm.tripType = vm.defaultDropOff;
                        if (vm.defaultPickUp) vm.tripType = vm.defaultPickUp;
                        if (vm.defaultMobile) vm.tripType = vm.defaultMobile;
                    } else {
                        if (vm.tripType) {
                            if (vm.tripType.isDropOff) {
                                vm.tripType = vm.defaultDropOff;
                            } else if (vm.tripType.isPickup) {
                                vm.tripType = vm.defaultPickUp;
                            } else {
                                vm.tripType = vm.defaultMobile;
                            }
                        } else {
                            if (vm.defaultDropOff) {
                                vm.tripType = vm.defaultDropOff;
                            } else if (vm.defaultPickUp) {
                                vm.tripType = vm.defaultPickUp;
                            } else if (vm.defaultMobile) {
                                vm.tripType = vm.defaultMobile;
                            }
                        }
                    }

                    setTransportation();

                    if (departmentUpdated === true) {
                        advisorsPromise.then(() => {
                            getDealerSlots(true);
                        });
                    }

                };

                if (vm.defaultDropOff) cnt++;
                if (vm.defaultPickUp) cnt++;
                if (vm.defaultMobile) cnt++;

                vm.showRadioButtons = cnt > 1;

                vm.selectedTransmission = vm.appointment.isManual ? "1" : "0";

                if (vm.appointment.isManual === null) {
                    vm.appointment.isManual = false;
                }

                if (!vm.appointment.id) {
                    // if we don't have a timeout here, this trip type
                    // keeps getting nuked if we are overriding the default department id
                    if (departmentUpdated) {
                        $timeout(() => {
                                setTripType(departmentUpdated);
                                resetLoanerOptions();
                            },
                            1);
                    } else {
                        setTripType(departmentUpdated);
                    }
                }

                if (!vm.pickupLocation && vm.appointment.tripPickupLocation) {
                    let pickupLoc = vm.appointment.tripPickupLocation;

                    if (!pickupLoc.formattedAddress) {
                        pickupLoc.formattedAddress = pickupLoc.streetAddress +
                            ' ' +
                            pickupLoc.city +
                            ' ' +
                            pickupLoc.state +
                            ' ' +
                            pickupLoc.zip;
                    }

                    vm.pickupLocation = {
                        location: pickupLoc
                    };

                }

                if (vm.appointment.id) {
                    vm.currentMomentDay = moment(vm.appointment.apptDateTime);
                    vm.selectedDay = vm.currentMomentDay.format('MM/DD/YYYY');
                    vm.minCalendarDate = moment.utc(new Date());

                    if (vm.currentMomentDay.isBefore(vm.minCalendarDate)) {
                        vm.minCalendarDate = vm.currentMomentDay;
                    }

                    setTransportation();
                }

                if (departmentUpdated !== true) {
                    resetLoanerOptions();
                    advisorsPromise.then(() => {
                        getDealerSlots(true);
                    });
                }

            }

            /*
             * function to determine if date should be selectable based
             * on the hours and constraints passed in
             */
            vm.isDateSelectable = function(date, type) {
                let disabledDates = vm.disabledDates && vm.disabledDates.length > 1
                    ? vm.disabledDates
                    : vm.departmentConstraints;

                return consumerAppointmentService.isDateSelecteable(date, type, vm.departmentHours, disabledDates);
            };

            vm.dateChanged = function(newValue, oldValue) {
                let temp = newValue.format("MM/DD/YYYY");

                // don't call update avail if we aren't changing the date
                if (temp !== vm.selectedDay) {
                    vm.selectedDay = newValue.format("MM/DD/YYYY");
                    vm.currentMomentDay = moment.utc(new Date(vm.selectedDay));
                    vm.getDealerSlots();
                }
            };

            init();

            vm.timeSlotFilter = function(value, index, array) {
                if (!vm.tripType) return false;
                let usePickup = appointmentUtilService.isTripTypePickupOrMobile(vm.tripType);

                return !usePickup || !!value.pickupTime;
            };

            vm.distinctBy = function() {
                let usePickup = appointmentUtilService.isTripTypePickupOrMobile(vm.tripType);

                return usePickup ? 'pickupTime' : false;
            };

            function removeUnavailableTimes(timeSlots) {
                // First filter out the constrained; we do not allow overrides on consumer
                timeSlots = _.filter(timeSlots,
                    (o) => { return !o.unavailable || (o.blockTime === vm.appointment.apptDateTime && !vm.needsScheduleTransportationUpdate); });

                return timeSlots;
            }

            function fillTimeDropDown(initial, timeSelected) {
                let date = moment(vm.selectedDay, 'MM/DD/YYYY').format('YYYY-MM-DD');
                let selectedDate = _.find(vm.availTimeSlots.days, (x) => { return x.day.startsWith(date); });

                if (initial && vm.appointment.id !== null) {
                    // Can't find the date for the appointment, add it to the list any ways
                    if (!selectedDate) {
                        selectedDate = {timeSlotBlocks: []};
                    }

                    vm.times = removeUnavailableTimes(selectedDate.timeSlotBlocks);

                    let selectedDateTime = _.find(selectedDate.timeSlotBlocks,
                        (x) => { return x.blockTime.startsWith(vm.appointment.apptDateTime); });

                    // Current appointment's date/time isn't in the list, add it (if it is not in the past)
                    if (!selectedDateTime &&
                        !moment.tz(vm.appointment.apptDateTime, vm.availTimeSlots.timeZoneId)
                        .isBefore(moment.tz(vm.availTimeSlots.timeZoneId))) {
                        let obj = {
                            slots: 0,
                            blockTime: vm.appointment.apptDateTime
                        };

                        if (!vm.times) {
                            vm.times = [];
                        }

                        vm.times.unshift(obj);
                        // Select new time
                        selectedDateTime = _.find(vm.times,
                            (x) => { return x.blockTime.startsWith(vm.appointment.apptDateTime); });

                    }

                    isApptInPast();

                    // Set the time to the selected appointment date/time
                    if (selectedDateTime) {
                        vm.time = selectedDateTime;
                    }
                } else {

                    // Can't find the date for the appointment, add it to the list any ways
                    if (!selectedDate) {
                        selectedDate = {timeSlotBlocks: []};
                    }

                    vm.times = removeUnavailableTimes(selectedDate.timeSlotBlocks);

                    if (!timeSelected) {
                        if (vm.appointment.apptDateTime) {
                            timeSelected = _.find(selectedDate.timeSlotBlocks,
                                (x) => { return x.blockTime.startsWith(vm.appointment.apptDateTime); });

                            if (timeSelected) {
                                vm.time = timeSelected;
                            }
                        } else {
                            vm.time = vm.times && vm.times.length > 0 ? vm.times[0] : null;
                        }
                    } else {
                        vm.time = timeSelected;
                    }

                    // Time contains full date+time object
                    let updatedDateTime = vm.time ? vm.time.blockTime : null;

                    if (vm.time) {
                        vm.appointment.apptDateTime = updatedDateTime;
                        isApptInPast();
                    }

                    if (appointmentUtilService.isTripTypePickupOrMobile(vm.tripType) === true && vm.time) {
                        let firstAvailTimeSlot = appointmentUtilService.getFirstAvailableTimeSlot(vm.time.slots);

                        if (firstAvailTimeSlot) {
                            updatedDateTime = firstAvailTimeSlot.driverCustomerExpectedTimeUtc;
                            $rootScope.$broadcast('pickUpDateTimeChanged', updatedDateTime);
                        }
                    }
                }

                if (!vm.times || (vm.times && vm.times.length === 0)) {
                    vm.availSlotErrors = [
                        'No available appointment times were found on the selected day.  Please select a different date.'
                    ];
                    vm.time = null;
                    vm.dealerSlotsLoading = false;
                }

                $timeout(() => {
                        angular.element('#time').trigger('change');
                        // the ng-change's method still needs to be triggered
                        pickupTimeChanged();
                    },
                    1);
            }

            function pickupTimeChanged() {
                let selTimeBlock = vm.time;

                if (selTimeBlock && selTimeBlock.slots) {
                    // If we've selected "Any" we assign the appointment with the block's first available advisor
                    let timeSlotAdvisor;

                    if (vm.appointment.advisor) {
                        // assign the currently advisor if they're available at this time
                        // otherwise assign any
                        timeSlotAdvisor = _.find(selTimeBlock.slots, {advisorId: vm.appointment.advisor.id});

                        if (timeSlotAdvisor) {
                            vm.appointment.dealerEmployeeId = timeSlotAdvisor.advisorId;
                            vm.appointment.dealerEmployeeFirstName = vm.appointment.advisor.firstName;
                            vm.appointment.dealerEmployeeLastName = vm.appointment.advisor.lastName;
                            vm.appointment.dealerEmployeeOfficePhone = vm.appointment.advisor.officePhone;
                            vm.appointment.serviceAdvisorNumber = timeSlotAdvisor.advisorNumber;
                        } else {
                            timeSlotAdvisor = selTimeBlock.slots[0];
                        }
                    } else {
                        timeSlotAdvisor = selTimeBlock.slots[0];
                    }

                    let updatedDateTime = selTimeBlock.blockTime;

                    if (vm.time) {
                        vm.appointment.apptDateTime = updatedDateTime;
                        isApptInPast();
                    }

                    if (appointmentUtilService.isTripTypePickupOrMobile(vm.tripType) === true) {
                        updatedDateTime = timeSlotAdvisor.driverCustomerExpectedTimeUtc;
                        $rootScope.$broadcast('pickUpDateTimeChanged', updatedDateTime);
                    }

                    $rootScope.$broadcast('timeChanged');
                }
            }

            function transmissionChanged() {
                if (!vm.needsScheduleTransportationUpdate) showUpdateWarning();
                vm.appointment.isManual = vm.selectedTransmission === "1";
            }

            function advisorUpdated(id) {
                if (id) {
                    vm.appointment.advisor = $filter('filter')(vm.advisors, {id: id}, true)[0];
                } else {
                    vm.appointment.advisor = null;
                }
            }

            function transportationUpdated(broadcastPickupChanged, resetLoaner, newTripType) {
                if (!vm.needsScheduleTransportationUpdate) showUpdateWarning();

                // Update if option for loaner isn't available on selected transportation side
                let handleTransportationTypeChanged = function() {
                    if (resetLoaner) {
                        resetLoanerOptions();
                    }

                    $rootScope.$broadcast('transportationTypeChanged', vm.tripType);

                    // Update date/time
                    if (vm.tripType.isDropOff || broadcastPickupChanged !== true) {
                        getDealerSlots();
                    }

                    // Update map
                    if (broadcastPickupChanged) {
                        if (vm.tripType.isDropOff && !newTripType) {
                            $rootScope.$broadcast('pickUpChanged', null);
                        } else if (vm.pickupLocation) {
                            let placeChanged = {
                                pickUp: vm.pickupLocation,
                                department: vm.department
                            };

                            $rootScope.$broadcast('pickUpChanged', placeChanged);

                        }
                    }
                };

                vm.tripType = null;

                $timeout(() => {
                        if (vm.transportation === vm.transTypeGroups.pickup && vm.defaultPickUpLoaner === null) {
                            vm.tripType =
                                consumerAppointmentService.getPickUpTripType(vm.tripTypes, vm.needLoaner === 'true');
                            handleTransportationTypeChanged();
                        } else if (vm.transportation === vm.transTypeGroups.dropoff &&
                            vm.defaultDropOffLoaner === null &&
                            !newTripType) {
                            vm.tripType = vm.defaultDropOff;
                            handleTransportationTypeChanged();
                        } else if (vm.transportation === vm.transTypeGroups.mobile) {
                            vm.tripType = vm.defaultMobile;
                            handleTransportationTypeChanged();
                        } else {
                            vm.tripType = $filter('filter')(vm.tripTypes.dropOffTransportationTypes,
                                {id: newTripType.id},
                                true)[0];
                            handleTransportationTypeChanged();
                        }
                    },
                    100);

            }

            function getServiceAdvisors() {
                vm.loadingAdvisors = true;

                return consumerAppointmentService.getDepartmentServiceAdvisors(vm.dealer.dealerId, vm.appointment.departmentId)
                    .then(
                        (advisors) => {
                            vm.advisors = advisors;

                            if (vm.appointment.dealerEmployeeId) {
                                advisorUpdated(vm.appointment.dealerEmployeeId);
                            } else if (vm.lastserviceadvisor &&
                                (vm.defaulttopreviousadvisor === true || vm.defaulttopreviousadvisor === "true")) {
                                advisorUpdated(vm.lastserviceadvisor.id);
                            }

                    let ids = _.map (vm.advisors, (advisor) => {  
                        return advisor.id;  
                      });  
                      
                    if (ids.some(id => id !== vm.appointment.dealerEmployeeId)) {
                        vm.appointment.dealerEmployeeId = null;
                        vm.appointment.serviceAdvisorNumber = null;
                    }     
                        },
                        (error) => {
                            vm.advisors = [{}];
                        }
                    ).finally(() => {
                        vm.loadingAdvisors = false;
                    });
            }

            function getDealerSlots(initial) {
                if (!initial && !vm.needsScheduleTransportationUpdate) showUpdateWarning();

                if (vm.tripType.isDropOff === true) {
                    vm.pickupLocation = null;
                }

                if (appointmentUtilService.isTripTypePickupOrMobile(vm.tripType) === true &&
                    (!vm.pickupLocation || vm.pickupLocation.isInServiceArea === false)) {
                    vm.availTimeSlots = null;
                    vm.availTimeSlotsVisualPicker = null;
                    vm.selectedDay = null;
                    vm.time = null;

                    return;
                }

                let startDateUTC = null;
                let endDateUTC = null;
                let pickupLocation = null;


                if (!vm.selectedDay) {
                    vm.currentMomentDay = today;
                    vm.selectedDay = vm.currentMomentDay.format('MM/DD/YYYY');
                }

                vm.dealerSlotsLoading = true;
                $rootScope.$broadcast('hideButtons', true);
                startDateUTC = moment.utc(vm.selectedDay, 'MM/DD/YYYY');
                endDateUTC = moment.utc(vm.selectedDay, 'MM/DD/YYYY').add(vm.daysToDisplay, 'days');

                if (vm.pickupLocation) {
                    let loc = vm.pickupLocation.location;

                    pickupLocation = {
                        streetAddress: loc.streetAddress,
                        city: loc.city,
                        state: loc.state,
                        zipCode: loc.zip,
                        countryCode: loc.countryShortCode,
                        lat: loc.lat,
                        lng: loc.lng
                    };
                }

                let departmentId = parseInt(vm.configValues.apptConsumerDepartmentId);

                let advisorsPromise = Promise.resolve();

                if (vm.appointment.canUseDefaultDepartment && vm.appointment.defaultDealerDepartmentId) {
                    departmentId = vm.appointment.defaultDealerDepartmentId;
                    vm.appointment.departmentId = departmentId;
                    vm.appointment.advisor = null;
                    vm.appointment.canUseDefaultDepartment =
                        false; // reset this so it doesn't keep firing over and over.
                    advisorsPromise = getServiceAdvisors();
                    $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
                }

                vm.availTimeSlots = null;
                // we don't filter out unavail pills for the visual picker
                // so using a diff variable for that one
                vm.availTimeSlotsVisualPicker = null;

                advisorsPromise.then(() => {
                    return consumerAppointmentService.getAvailability(vm.dealer.dealerId,
                        vm.appointment.id,
                        startDateUTC,
                        endDateUTC,
                        vm.appointment.departmentId,
                        vm.appointment.advisor,
                        vm.tripType,
                        pickupLocation,
                        _.map(vm.appointment.lineItems, (item) => { return item.opCode; }))
                    .then((results) => {
                        if (!results) {
                            vm.availSlotErrors = [
                                'No available appointment times were found on the selected day.  Please select a different date.'
                            ];
                            vm.availTimeSlots = null;
                            vm.availTimeSlotsVisualPicker = null;
                            vm.time = null;
                            vm.currentMomentDay = moment(vm.selectedDay);
                            vm.selectedDay = vm.currentMomentDay.format('MM/DD/YYYY');
                        } else {
                            vm.availSlotErrors = null;
                            vm.availTimeSlots = results;
                            vm.availTimeSlotsVisualPicker = results;
                            vm.disabledDates = [];

                            if (results.days) {
                                _.forEach(results.days,
                                    (day) => {
                                        if (_.findIndex(day.timeSlotBlocks,
                                                (block) => {
                                                    return !block.unavailable;
                                                }) ===
                                            -1) {
                                            vm.disabledDates.push(moment(day.day).format("MM/DD/YYYY"));
                                        }
                                    });

                                if (vm.departmentConstraints && vm.departmentConstraints.length > 1) {
                                    let temp = vm.disabledDates.concat(vm.departmentConstraints);

                                    vm.disabledDates = temp;
                                }
                            }

                            // If editing an appointment, select the date as the appointment date
                            if (initial && vm.appointment.id) {
                                vm.currentMomentDay = moment(vm.appointment.apptDateTime);
                                vm.selectedDay = vm.currentMomentDay.format('MM/DD/YYYY');
                                vm.minCalendarDate = moment.utc(new Date());

                                if (vm.currentMomentDay.isBefore(vm.minCalendarDate)) {
                                    vm.minCalendarDate = vm.currentMomentDay;
                                }
                            } else if (!vm.appointment.id) {
                                // Set date to first date that has available slots
                                let firstAvailable = _.find(vm.availTimeSlots.days,
                                    (day) => {
                                        return day.timeSlotBlocks.length > 0;
                                    });

                                if (firstAvailable) {
                                    vm.currentMomentDay = moment(firstAvailable.day);
                                    vm.selectedDay = vm.currentMomentDay.format('MM/DD/YYYY');
                                }
                            }

                            fillTimeDropDown(initial);

                        }

                        $rootScope.$broadcast('hideButtons', false);

                    }).finally(() => {
                        $rootScope.$broadcast('hideButtons', false);
                        vm.dealerSlotsLoading = false;
                    });
                });
            }

            function showUpdateWarning() {
                $rootScope.$broadcast('showUpdateWarning');
                vm.needsScheduleTransportationUpdate = true;
            }

            $scope.$on('updateAvailability',
                (e, setInitial) => {
                    getDealerSlots(setInitial);
                });

            $scope.$on('updateApptSchedule',
                (e) => {
                    vm.needsScheduleTransportationUpdate = true;
                    getDealerSlots(false);
                });

            $scope.$on('newDaySelected',
                (e, timeSelected) => {
                    fillTimeDropDown(false, timeSelected);
                });

            $scope.$on('newTimeSelected',
                (e) => {
                    pickupTimeChanged();
                });

            $scope.$on('updateStartDate',
                (e, data) => {
                    vm.selectedDay = data;
                    vm.currentMomentDay = moment(new Date(data));
                    getDealerSlots(true);
                });

            $scope.$watch('consumerAppointmentDetails',
                (newValue) => {
                    vm.form = newValue;
                });

            $scope.$on('updateTripLocations',
                (e, newValue) => {
                    vm.displayedTripLocations = newValue;
                    vm.tripLocationError = null;
                });


            $scope.$on('updateTripLocationError',
                (e, newValue) => {
                    vm.tripLocationError = newValue;
                });

            $scope.$on('departmentTripTypesUpdated',
                (e, newValue) => {
                    if (newValue) {
                        vm.tripTypes = newValue.allTripTypes;
                        vm.tripType = newValue.selTripType;
                        init(true);
                    }
                });

        };
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentCustomerLoginController.$inject = ["$scope", "$rootScope", "consumerAppointmentService", "ValidationService"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentCustomerLogin', consumerAppointmentCustomerLogin);

    function consumerAppointmentCustomerLogin() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/customer-login.view.html',
            controller: ConsumerAppointmentCustomerLoginController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealer: '<',
                flow: '<',
                loading: '<?'
            }
        };
    }

    function ConsumerAppointmentCustomerLoginController($scope, $rootScope, consumerAppointmentService, ValidationService) {

        this.$onInit = function() {
            var vm = this;

            vm.states = {
                requestPhone: 1,
                selectPhoneNumber: 2,
                verifyAccount: 3,
                selectAppointments: 4,
                invalidAccount: 5,
                noAppointments: 6
            };

            vm.currentState = vm.states.requestPhone;

            vm.sendCode = sendCode;
            vm.verifyCode = verifyCode;
            vm.previouslyEnteredEmail = null;
            vm.sendCodeError = false;
            vm.continueAsGuest = continueAsGuest;
            vm.openAppointment = openAppointment;
            vm.cancel = cancel;

            function sendCode(phoneNumberOrEmail) {
                vm.sendCodeError = false;
                var myValidation = new ValidationService(),
                    valid;

                valid = myValidation.checkFormValidity($scope.loginCustomerForm);
                if (!valid) {
                    return;
                } // Check to see if valid

                vm.loading = true;
                return consumerAppointmentService
                    .sendVerificationCode(vm.dealer.dealerId, phoneNumberOrEmail, vm.previouslyEnteredEmail).then(
                        // Success
                        function(result) {
                            vm.sendCodeError = false;
                            if (result.isEmail) {
                                vm.previouslyEnteredEmail = phoneNumberOrEmail;
                                vm.phones = result.phones;
                                vm.currentState = vm.states.selectPhoneNumber;
                            } else {
                                vm.previouslyEnteredEmail = null;

                                // Get last 4 of phone texted
                                vm.last4Phone = result.last4Phone;
                                vm.loginPhone = phoneNumberOrEmail;

                                // Change state for user to verify code sent to device
                                vm.currentState = vm.states.verifyAccount;
                            }
                        },
                        // Reject
                        function(reject) {
                            vm.sendCodeError = true;
                        })
                    .finally(function(reject) {
                        vm.loading = false;
                    });
            }

            function verifyCode(phoneNumber, code) {
                vm.loading = true;
                vm.verifyCodeError = false;

                return consumerAppointmentService.checkVerificationCode(vm.dealer.dealerId, phoneNumber, code).then(
                        // Success
                        function(result) {
                            if (result) {
                                if (result.appointments && result.appointments.length > 0 && vm.flow === 'existing') {
                                    vm.appointments = result.appointments;
                                    vm.currentState = vm.states.selectAppointments;

                                    if (result.appointments.length === 1) {
                                        vm.selectedAppointment = vm.appointments[0].id;
                                    }
                                } else if (result.appointments &&
                                    result.appointments.length === 0 &&
                                    vm.flow === 'existing') {
                                    vm.customerData = result;
                                    vm.currentState = vm.states.noAppointments;
                                } else {
                                    // Notify listeners
                                    $rootScope.$broadcast('customerLoginEvent', { event: 'login', data: result });
                                }
                            } else {
                                vm.verifyCodeError = true;
                                vm.errorMessage = 'Unknown error, please try again';
                            }
                        },
                        function(reject) {
                            vm.verifyCodeError = true;
                            vm.errorMessage = reject.message;
                        })
                    .finally(function() {
                        vm.loading = false;
                    });
            }

            vm.validation = {
                validEmailOrPhone: function() {
                    var phoneRegEx = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/,
                        emailRegEx =
                            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        loginPhoneEmail = vm.loginPhoneEmail;

                    if (phoneRegEx.test(loginPhoneEmail) || emailRegEx.test(loginPhoneEmail)) {
                        return true;
                    } else {
                        return { isValid: false, message: 'A valid email or phone number must be specified' };
                    }

                }
            };

            vm.submitForm = function() {
                var currState = vm.currentState,
                    states = vm.states;
                if (currState === states.requestPhone) {
                    vm.sendCode(vm.loginPhoneEmail);
                } else if (currState === states.selectPhoneNumber) {
                    vm.sendCode(vm.selectedPhone);
                } else if (currState === states.verifyAccount) {
                    vm.verifyCode(vm.loginPhone, vm.code);
                } else if (currState === states.selectAppointments) {
                    var selectedApptKey = _.find(vm.appointments,
                        function(appt) { return appt.id === vm.selectedAppointment; }).key;
                    vm.openAppointment(vm.selectedAppointment, selectedApptKey);
                } else if (currState === states.invalidAccount) {
                    vm.sendCode(vm.loginPhone);
                } else if (currState === states.noAppointments) {
                    if (vm.customerData) {
                        $rootScope.$broadcast('customerLoginEvent', { event: 'login', data: vm.customerData });
                    }
                }
            };

            function continueAsGuest() {
                $rootScope.$broadcast('customerLoginEvent', { event: 'guest' });
            }

            function openAppointment(id, key) {
                $rootScope.$broadcast('customerLoginEvent', { event: 'openAppointment', data: { id: id, key: key } });
            }

            function cancel() {
                vm.customerData = null;
                $rootScope.$broadcast('customerLoginEvent', { event: 'cancel' });
            }
        };
    }
})();

(function () {
    'use strict';

    ConsumerAppointmentChooseServicesController.$inject = ["$scope", "$rootScope", "$filter", "$timeout", "consumerAppointmentService", "appointmentUtilService", "appointmentLineItemClass", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE"];
    angular
        .module('redcap.consumer.appointments')
        .directive(
            'consumerAppointmentChooseServices',
            consumerAppointmentChooseServices
        );

    function consumerAppointmentChooseServices() {
        return {
            restrict: 'A',
            templateUrl:
                'app/areas/consumer/appointments/views/partials/choose-services.view.html',
            controller: ConsumerAppointmentChooseServicesController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealerDepartments: '<',
                dealer: '<',
                form: '=',
                appointment: '<',
                dealeropcodes: '<',
                originallineitems: '<',
                recalls: '<',
                recmaintdata: '<',
                recmaintdisclaimer: '<',
                gettingservices: '<',
                disableserviceselection: '<',
                previouslydeclinedservices: '<',
                otherservicestitle: '<',
                previouslydeclinedtitle: '<',
                dealerIntegrations: '<',
                ghostGarage: '<',
                rankedDepartments: '<'
            }
        };
    }

    function ConsumerAppointmentChooseServicesController($scope, $rootScope, $filter, $timeout, consumerAppointmentService,
        appointmentUtilService, appointmentLineItemClass, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE) {
            this.$onInit = function() {
                let vm = this;

                vm.bookingMethod = consumerAppointmentService.getBookingMethod(vm.dealer.configValues);
                vm.multipleDepartments = vm.bookingMethod === CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.multipleDepartments;
                vm.expandLineItemMismatch = true;
                vm.fakeInput = 1;
                vm.uniqueCnt = 0;
                vm.initialized = false;
                vm.prevDeclinedServicesOpen = false;
                vm.genericConsumerServiceEnabled = true;
                vm.ghostGarage = parseInt(vm.ghostGarage);
                vm.servicesOpen = vm.ghostGarage === 0 ? false : !vm.genericConsumerServiceEnabled;
                vm.recallsOpen = false;
                vm.recMaintOpen = false;
                vm.hasAnyServices = vm.appointment.lineItems ? vm.appointment.lineItems.length > 0 : false;
                vm.appointmentRecallsAreValid = false;
                vm.containsServices = false;
                vm.selectedRecMaint = null;
                vm.serviceSelected = serviceSelected;
                vm.serviceToggle = serviceToggle;
                vm.serviceValidation = serviceValidation;
                vm.valRecalls = valRecalls;
                vm.hasSelectedServices = hasSelectedServices;
                vm.filteredOpCodes = null;
                vm.dealerGenericOpCodes = null;
                vm.dealerRecallOpCodes = null;
                vm.dealerOpCodesAll = null;
                vm.additionalServiceNotes = null;
                vm.unknownImportedOtherLineItems = [];
                vm.genericConsumerServicesNotes = [];
                vm.departmentMismatchCount = null;
                vm.needsScheduleTransportationUpdate = false;
                vm.displayConsumerPrices = vm.dealer.configValues.displayConsumerPrices === 'true';

                vm.getDepartmentMismatchCount = function() {
                    if (!vm.departmentMismatchCount) {
                        vm.mismatchedLineItems = $filter('filter')(vm.appointment.lineItems,
                            {departmentLineItemMismatch: true},
                            true);
                        vm.misMatchedDeclinedItems = $filter('filter')(vm.previouslydeclinedservices,
                            {departmentLineItemMismatch: true},
                            true);
                        let lineItemCount = vm.mismatchedLineItems ? vm.mismatchedLineItems.length : 0;
                        let declinedItemCount = vm.misMatchedDeclinedItems ? vm.misMatchedDeclinedItems.length : 0;

                        vm.departmentMismatchCount = lineItemCount + declinedItemCount;
                    }

                    return vm.departmentMismatchCount;
                };

                vm.showServicesCount = function() {
                    if (vm.ghostGarage === 0) return true;

                    return vm.genericConsumerServiceEnabled;
                };

                vm.servicesToggle = function() {
                    if (!vm.showServicesCount()) return;

                    vm.servicesOpen = !vm.servicesOpen;
                };

                vm.prevDeclinedServicesToggle = function() {
                    vm.prevDeclinedServicesOpen = !vm.prevDeclinedServicesOpen;
                };

                vm.recallsToggle = function() {
                    vm.recallsOpen = !vm.recallsOpen;
                };

                vm.recMaintToggle = function() {
                    vm.recMaintOpen = !vm.recMaintOpen;
                };

                vm.showRecalls = function() {
                    return vm.dealerRecallOpCodes?.length > 0 && vm.dealerRecallOpCodes[0].showInConsumer && vm.recalls?.length > 0;
                };

                vm.showRecMaint = function() {
                    return vm.dealerRecommendedMaintenanceOpCodes &&
                        vm.dealerRecommendedMaintenanceOpCodes.length > 0 &&
                        vm.dealerRecommendedMaintenanceOpCodes[0].showInConsumer &&
                        vm.recmaintdata &&
                        vm.recmaintdata.length > 0;
                };

                vm.showPreviouslyDeclinedServices = function() {
                    let currentDepartment =
                        $filter('filter')(vm.dealerDepartments, {id: vm.appointment.departmentId}, true)[0];

                    return currentDepartment.showPreviouslyDeclinedServicesConsumer &&
                        vm.previouslydeclinedservices &&
                        vm.previouslydeclinedservices.length > 0;
                };

                vm.showRecallsUnderCommonServices = function() {
                    let recallOpCodes = vm.dealeropcodes.recallOpCodes;
                    let checkedItems = null;
                    let originallyChecked = $filter('filter')(vm.appointment.lineItems,
                        {isRecall: true, originallyChecked: true},
                        true);

                    if (recallOpCodes && recallOpCodes[0] && recallOpCodes[0].showInConsumer === false && recallOpCodes[0].showInDashboard === true) {
                        checkedItems =
                            $filter('filter')(vm.appointment.lineItems, {isRecall: true, checked: true}, true);

                        if (checkedItems && checkedItems.length > 0) {
                            checkedItems.forEach((item) => {
                                item.originallyChecked = true;
                            });
                        }
                    }

                    return (checkedItems && checkedItems.length > 0) ||
                        (originallyChecked && originallyChecked.length > 0);
                };

                vm.showRecMaintUnderCommonServices = function() {
                    let recommendedMaintenanceOpCodes = vm.dealeropcodes.recommendedMaintenanceOpCodes;
                    let checkedItems = null;
                    let originallyChecked = null;

                    if (recommendedMaintenanceOpCodes && recommendedMaintenanceOpCodes[0] && recommendedMaintenanceOpCodes[0].showInConsumer === false &&
                        recommendedMaintenanceOpCodes[0].showInDashboard === true) {
                        checkedItems = $filter('filter')(vm.appointment.lineItems,
                                {isRecommendedMaintenance: true, checked: true},
                                true),
                        originallyChecked = $filter('filter')(vm.appointment.lineItems,
                            {isRecommendedMaintenance: true, originallyChecked: true},
                            true);

                        if (checkedItems && checkedItems.length > 0) {
                            checkedItems.forEach((item) => {
                                item.originallyChecked = true;
                            });
                        }
                    }

                    return checkedItems && checkedItems.length > 0;
                };

                vm.getServicesCount = function() {
                    let services = $filter('filter')(vm.filteredOpCodes, vm.filterConsumerAndExistingOpCodes, true);
                    let dashboardRecallRecMaint =
                        $filter('filter')(vm.appointment.lineItems, {originallyChecked: true}, true);
                    let servicesLength = 0;

                    if (services) servicesLength = services.length;

                    servicesLength += vm.unknownImportedOtherLineItems.length;

                    if (dashboardRecallRecMaint) {
                        servicesLength += dashboardRecallRecMaint.length;
                    }

                    return servicesLength;
                };

                vm.hasFilteredServices = function() {
                    let services = $filter('filter')(vm.filteredOpCodes, vm.filterConsumerAndExistingOpCodes, true);
                    let dashboardRecallRecMaint =
                        $filter('filter')(vm.appointment.lineItems, {originallyChecked: true}, true);

                    if (services && services.length > 0) return true;

                    if (dashboardRecallRecMaint && dashboardRecallRecMaint.legnth > 0) return true;

                    return false;
                };

                vm.getSelectedServicesCount = function() {
                    let services = $filter('filter')(vm.filteredOpCodes, {checked: true, isAutomatic: false}, true);
                    let dashboardRecallRecMaint = $filter('filter')(vm.appointment.lineItems,
                        {originallyChecked: true, checked: true},
                        true);
                    let unknownImportedSelected =
                        $filter('filter')(vm.unknownImportedOtherLineItems, {checked: true}, true);
                    let servicesLength = 0;

                    if (services) servicesLength = services.length;

                    if (unknownImportedSelected) {
                        servicesLength += unknownImportedSelected.length;
                    }

                    if (dashboardRecallRecMaint) {
                        servicesLength += dashboardRecallRecMaint.length;
                    }

                    return servicesLength;
                };

                vm.getSelectedServicesToDisplay = function(services) {
                    let selectedServices = $filter('filter')(services, {checked: true}, true);

                    return selectedServices.length;
                };

                vm.filterConsumerAndExistingOpCodes = function(lineItem) {
                    let existing = false;
                    let previouslyDeclinedItems = vm.previouslydeclinedservices;
                    let previouslyDeclined = false;

                    if (vm.originallineitems && vm.originallineitems.length > 0) {
                        existing = $filter('filter')(vm.originallineitems,
                            {
                                dealerAppointmentServiceOpCodeId: lineItem.id,
                                isAutomatic: false,
                                departmentLineItemMismatch: false
                            },
                            true);
                    }

                    // if it matches a previously declined service, filter it out.
                    if (vm.showPreviouslyDeclinedServices()) {
                        previouslyDeclined =
                            $filter('filter')(previouslyDeclinedItems, {opCode: lineItem.opCode}, true);

                        if (previouslyDeclined && previouslyDeclined.length > 0) {
                            return false;
                        }
                    }

                    if (lineItem.isOther) return false;

                    return lineItem.showInConsumer || (existing && existing.length > 0);
                };

                vm.getConsumerNeedsRows = function() {
                    return vm.allowedGenericLineItemCount === 1 ? 3 : 1;
                };

                vm.addGenericLineItem = function() {
                    if (vm.dealerGenericOpCodes.length === 0) return;

                    let opCodeSuffix = vm.genericConsumerServicesNotes.length > 0
                            ? vm.genericConsumerServicesNotes.length - 1
                            : "";
                    let dealerGenericLineItem = vm.dealerGenericOpCodes[0];

                    if (!dealerGenericLineItem) return;

                    let newLineItem = appointmentLineItemClass.new({
                        dealerId: dealerGenericLineItem.dealerId,
                        opCode: dealerGenericLineItem.opCode + opCodeSuffix,
                        genericName: dealerGenericLineItem.genericName,
                        note: "",
                        isAutomatic: dealerGenericLineItem.isAutomatic,
                        isEnabled: dealerGenericLineItem.isEnabled,
                        isGeneric: dealerGenericLineItem.isGeneric,
                        isRecall: false,
                        isRecommendedMaintenance: false,
                        id: null,
                        retailPrice: dealerGenericLineItem.retailPrice,
                        consumerName: dealerGenericLineItem.consumerName,
                        dashboardName: dealerGenericLineItem.dashboardName,
                        consumerDescription: dealerGenericLineItem.consumerDescription,
                        dashboardDescription: dealerGenericLineItem.dashboardDescription,
                        uniqueCnt: vm.uniqueCnt
                    });

                    vm.uniqueCnt = vm.uniqueCnt++;
                    vm.genericConsumerServicesNotes.push(newLineItem);
                };

                vm.removeGenericLineItem = function(index) {
                    vm.genericConsumerServicesNotes.splice(index, 1);
                };

                $rootScope.$on('declinedServiceToggled',
                    (event, data) => {
                        if (!vm.needsScheduleTransportationUpdate) showUpdateWarning();

                        // check to see if we need to uncheck any recmaint
                        if (vm.recmaintdata) {
                            let recMaint = $filter('filter')(vm.previouslydeclinedservices,
                                {checked: true, isRecommendedMaintenance: true},
                                true);

                            if (recMaint && recMaint.length > 0) {
                                let checkedRecMaint = $filter('filter')(vm.recmaintdata, {checked: true}, true);

                                if (checkedRecMaint && checkedRecMaint.length > 0) {
                                    checkedRecMaint[0].checked = false;
                                    vm.selectedRecMaint = null;
                                }
                            }
                        }

                    });


                initializeLineItems();

                function initializeLineItems() {
                    vm.unknownImportedOtherLineItems = [];

                    // Populate the dealer op codes
                    if (vm.dealeropcodes) {
                        vm.dealeropcodes =
                            consumerAppointmentService.filterDepartmentOpCodes(vm.dealeropcodes,
                                vm.appointment.departmentId);
                        vm.filteredOpCodes = vm.dealeropcodes.opCodes;

                        if (vm.displayConsumerPrices && vm.dealeropcodes.recallOpCodes && vm.dealeropcodes.recallOpCodes.length > 0) {
                            vm.recallPrefix = vm.dealeropcodes.recallOpCodes[0].pricePrefix;
                            vm.recallPrice = vm.dealeropcodes.recallOpCodes[0].retailPrice;
                        }

                        if (vm.displayConsumerPrices && vm.dealeropcodes.recommendedMaintenanceOpCodes && vm.dealeropcodes.recommendedMaintenanceOpCodes.length > 0) {
                            vm.recMaintPrefix = vm.dealeropcodes.recommendedMaintenanceOpCodes[0].pricePrefix;
                            vm.recMaintPrice = vm.dealeropcodes.recommendedMaintenanceOpCodes[0].retailPrice;
                        }

                        if (vm.filteredOpCodes && vm.filteredOpCodes.length > 0) {
                            vm.filteredOpCodes.forEach((opCode) => {
                                if (opCode.showDefaultConsumerNote) {
                                    opCode.note = opCode.defaultConsumerNote;
                                }
                            });
                        }   

                        vm.dealerGenericOpCodes = vm.dealeropcodes.genericOpCodes;
                        vm.dealerRecallOpCodes = vm.dealeropcodes.recallOpCodes;
                        vm.dealerRecommendedMaintenanceOpCodes = vm.dealeropcodes.recommendedMaintenanceOpCodes;
                        vm.dealerOpCodesAll = vm.dealeropcodes.all;
                        vm.containsServices = true;
                    }

                    if (!vm.firstGenericOpCode) {
                        vm.firstGenericOpCode = vm.dealerGenericOpCodes[0];
                        vm.allowedGenericLineItemCount =
                            vm.firstGenericOpCode ? vm.firstGenericOpCode.allowMultipleCount : false;
                        vm.genericConsumerServiceEnabled =
                            vm.firstGenericOpCode ? vm.firstGenericOpCode.showInConsumer : false;

                        if (vm.initialized === false) {
                            vm.servicesOpen = !vm.genericConsumerServiceEnabled;
                            vm.initialized = true;
                        }

                        if (!vm.allowedGenericLineItemCount) {
                            vm.allowedGenericLineItemCount = 1;
                        }
                    }

                    if (vm.appointment.lineItems && vm.appointment.lineItems.length > 0) {
                        vm.appointment.lineItems.forEach((lineItem) => {
                            if (lineItem.isGeneric === true) {
                                vm.genericConsumerServicesNotes.push(lineItem);
                            } else if (lineItem.dealerAppointmentServiceOpCodeId && lineItem.isOther === false) {
                                let dealerOpCode = $filter('filter')(vm.filteredOpCodes,
                                    {id: lineItem.dealerAppointmentServiceOpCodeId},
                                    true);

                                // if we couldn't match it up by id, try matching it by opcode
                                if (!dealerOpCode || dealerOpCode.length === 0) {
                                    dealerOpCode = $filter('filter')(vm.filteredOpCodes,
                                        {opCode: lineItem.opCode},
                                        true);
                                }

                                if (dealerOpCode && dealerOpCode[0]) {
                                    let currOpCode = dealerOpCode[0];

                                    currOpCode.checked = true;

                                    if (currOpCode.showDefaultConsumerNote) {
                                        currOpCode.note = lineItem.note;

                                        if (currOpCode.note && currOpCode.note.trim() === "") {
                                            currOpCode.note = currOpCode.defaultConsumerNote;
                                        }
                                    }
                                }
                            } else {
                                let otherLineItem = lineItem;

                                otherLineItem.checked = true;
                                vm.unknownImportedOtherLineItems.push(otherLineItem);
                            }
                        });
                    }

                    if (vm.genericConsumerServicesNotes.length === 0) {
                        vm.addGenericLineItem();
                    }

                }

                $scope.$on('recallsUpdated',
                    (e, newValue) => {
                        vm.recalls = newValue;

                        const recallLines = vm.appointment.lineItems.filter((line) => line.isRecall);

                        recallLines.forEach((recall, i) => {
                            const recallToCheck = vm.recalls.find((item) => {
                                return item.manufacturerNumber === recall.manufacturerNumber;
                            });

                            if (!vm.appointment.yearMakeModelMismatch && recallToCheck) {
                                recallToCheck.checked = true;
                            } else {
                                // The recall data has changed, this previous recall is no longer relevant
                                vm.appointment.lineItems.splice(i, 1);
                            }
                        });

                        serviceValidation();
                    });

                $scope.$on('previouslyDeclinedServicesUpdated',
                    (e, newValue) => {
                        vm.previouslydeclinedservices = newValue;

                        if (vm.recmaintdata) {
                            appointmentUtilService.removePreviouslyDeclinedRecMaint(vm.appointment,
                                vm.recmaintdata,
                                vm.previouslydeclinedservices);
                        }
                    });

                $scope.$on('recMaintUpdated',
                    (e, newValue) => {
                        vm.recmaintdata = newValue;
                        let recMaint = null;
                        let i;
                        let lineItems = vm.appointment.lineItems;
                        let length = lineItems.length;

                        if (vm.showPreviouslyDeclinedServices()) {
                            appointmentUtilService.removePreviouslyDeclinedRecMaint(vm.appointment,
                                vm.recmaintdata,
                                vm.previouslydeclinedservices);
                        }

                        for (i = length - 1; i >= 0; i--) {
                            recMaint = lineItems[i];

                            if (!recMaint.isRecommendedMaintenance) {
                                continue;
                            }

                            let recMaintToCheck = $filter('filter')(vm.recmaintdata,
                                (item) => {
                                    return appointmentUtilService.getRecommendedMaintenanceName(item,
                                            vm.appointment.mileageType) ===
                                        recMaint.overrideName;
                                },
                                true);

                            if (!vm.appointment.yearMakeModelMismatch &&
                                recMaintToCheck &&
                                recMaintToCheck.length > 0) {
                                recMaintToCheck[0].checked = true;
                                vm.selectedRecMaint = recMaintToCheck[0].interval;
                            } else {
                                // The rec maint data has changed, this previous recMaint is no longer relevant
                                vm.appointment.lineItems.splice(i, 1);
                            }
                        }
                    });

                function serviceToggle(service) {
                    if (vm.disableserviceselection) return;

                    if (service.originallyChecked && service.isRecall) {
                        vm.recallsChanged = true;
                    }

                    service.checked = !service.checked;
                    serviceSelected();
                }

                vm.noteUpdated = function(lineItem) {
                    serviceSelected();
                };

                vm.getRecMainTooltip = function(apps) {
                    return appointmentUtilService.getRecMainTooltip(apps);
                };

                vm.getRecMaintTitle = function(recMaint) {
                    return appointmentUtilService.getRecMaintTitle(recMaint, vm.appointment);
                };

                vm.getConsumerNeedPlaceHolderText = function(index) {
                    if (vm.allowedGenericLineItemCount === 1) {
                        return "PLEASE DESCRIBE DESIRED SERVICES OR ISSUES HERE";
                    } else if (index === 0) {
                        return "PLEASE DESCRIBE YOUR FIRST ISSUE OR SERVICE NEED HERE";
                    } else {
                        return "PLEASE DESCRIBE YOUR NEXT ISSUE OR SERVICE NEED HERE";
                    }
                };

                function serviceSelected() {
                    if (!vm.needsScheduleTransportationUpdate) showUpdateWarning();
                    // Validate services
                    serviceValidation();
                    // Call listeners
                    let checkedLineItems = $filter('filter')(vm.filteredOpCodes, {checked: true}, true);
                    let checkedImportedOtherLineItems =
                        $filter('filter')(vm.unknownImportedOtherLineItems, {checked: true}, true);
                    let dashboardRecRecMaint =
                        $filter('filter')(vm.appointment.lineItems, {originallyChecked: true}, true);


                    if (vm.genericConsumerServicesNotes && vm.genericConsumerServicesNotes.length > 0) {
                        vm.genericConsumerServicesNotes.forEach((item) => {
                            if (item.note && item.note.trim() !== "") {
                                checkedLineItems.push(item);
                            }
                        });
                    }

                    let selectedServices = {
                        checkedLineItems: checkedLineItems,
                        selectedRecMaint: vm.selectedRecMaint,
                        checkedImportedLineItems: checkedImportedOtherLineItems,
                        recallsChanged: vm.recallsChanged,
                        dashboardRecRecMaint: dashboardRecRecMaint
                    };

                    $rootScope.$broadcast('servicesUpdated', selectedServices);
                }

                // Custom validation to require at least custom user input or a selected service.
                function serviceValidation() {
                    $scope.consumerServices.$setValidity('hasAnyServices', hasSelectedServices());
                    $scope.consumerServices.$setValidity('appointmentRecallsAreValid', valRecalls());
                }

                $scope.$on('validateServices',
                    (e, newValue) => {
                        serviceValidation();
                    });

                function valRecalls() {
                    vm.validatingRecalls = true;

                    return appointmentUtilService.validateRecalls(vm.dealerRecallOpCodes,
                        vm.appointment.departmentId,
                        vm.recalls,
                        vm.getNoteMaxLength(),
                        vm.validatingRecalls);
                }

                function hasAdditionalServiceNotes() {

                    let hasNote = false;

                    if (vm.genericConsumerServicesNotes && vm.genericConsumerServicesNotes.length > 0) {
                        vm.genericConsumerServicesNotes.forEach((item) => {
                            if (item.note && item.note.trim() !== "") {
                                hasNote = true;
                            }
                        });
                    }

                    return hasNote;
                }

                function hasSelectedServices(index) {

                    if (index > 0) return true;

                    if (hasAdditionalServiceNotes() === true) return true;

                    if (vm.selectedRecMaint) return true;

                    let checkedRecallData = $filter('filter')(vm.recalls, {checked: true}, true);

                    if (checkedRecallData && checkedRecallData.length > 0) return true;

                    if (vm.showPreviouslyDeclinedServices()) {
                        let checkedDeclinedServices = vm.previouslydeclinedservices
                            ? $filter('filter')(vm.previouslydeclinedservices, {checked: true}, true)
                            : [];

                        if (checkedDeclinedServices && checkedDeclinedServices.length > 0) return true;
                    }

                    let dashboardRecallRecMaint = $filter('filter')(vm.appointment.lineItems,
                        {checked: true, originallyChecked: true},
                        true);

                    if (dashboardRecallRecMaint && dashboardRecallRecMaint.length > 0) return true;

                    let checkedOtherServices = $filter('filter')(vm.unknownImportedOtherLineItems,
                        {checked: true, isAutomatic: false},
                        true);

                    if (checkedOtherServices && checkedOtherServices.length > 0) return true;

                    let hasCheckedItem = vm.filteredOpCodes
                            ? $filter('filter')(vm.filteredOpCodes, {checked: true, isAutomatic: false}, true)
                            : [];
                    let retVal = !!(hasCheckedItem && hasCheckedItem.length > 0);

                    return retVal;
                }

                vm.getNoteMaxLength = function() {
                    return appointmentUtilService.getNoteMaxLength(vm.dealer.dmsSystem);
                };

                vm.recallLineItemToggled = function(recall) {
                    if (vm.disableserviceselection) return;
                    $timeout(() => {
                            recall.checked = !recall.checked;
                            vm.recallsChanged = true;
                            serviceSelected();
                        },
                        1);
                };

                vm.recMaintItemToggle = function(recMaint, event) {
                    // Properly handle change events, as well as deselecting events
                    if (vm.recmaintdata && vm.recmaintdata.length > 0) {
                        vm.recmaintdata.forEach((item) => {
                            // Deselect previous items
                            if (item.interval !== recMaint.interval) {
                                item.checked = false;
                            }
                        });
                    }

                    recMaint.checked = !recMaint.checked;

                    if (!recMaint.checked) {
                        vm.selectedRecMaint = null;
                    } else {
                        vm.selectedRecMaint = recMaint.interval;
                        
                        if (vm.showPreviouslyDeclinedServices()) {
                            let prevD = $filter('filter')(vm.previouslydeclinedservices,
                                {checked: true, isRecommendedMaintenance: true},
                                true);

                            if (prevD && prevD.length > 0) {
                                prevD[0].checked = false;
                            }
                        }
                    }

                    serviceSelected();
                };

                function showUpdateWarning() {
                    $rootScope.$broadcast('showUpdateWarning');
                    vm.needsScheduleTransportationUpdate = true;
                }

                vm.changeDepartment = function() {
                    $rootScope.$broadcast('gotoChangeDepartment');
                };

                $scope.$watch('consumerServices',
                    (newValue) => {
                        vm.form = newValue;
                    });

                $scope.$on('departmentUpdated',
                    (e, newValue) => {
                        vm.genericConsumerServicesNotes = [];
                        vm.firstGenericOpCode = null;
                        initializeLineItems();
                    });
            };
    }
})();

(function() {
    'use strict';

    ConsumerAppointmentChoosePickupController.$inject = ["$scope", "$rootScope", "APPOINTMENT_TRANSPORTATION_TYPE", "appointmentUtilService"];
    angular
        .module('redcap.consumer.appointments')
        .directive(
            'consumerAppointmentChoosePickup',
            consumerAppointmentChoosePickup
        );

    function consumerAppointmentChoosePickup() {
        return {
            restrict: 'A',
            templateUrl:
                'app/areas/consumer/appointments/views/partials/choose-pickup.view.html',
            controller: ConsumerAppointmentChoosePickupController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealer: '<',
                department: '<',
                place: '<',
                tripType: '<',
                cleanInput: '<'
            }
        };
    }

    function ConsumerAppointmentChoosePickupController($scope,
        $rootScope,
        APPOINTMENT_TRANSPORTATION_TYPE,
        appointmentUtilService) {
        this.$onInit = function() {
            var vm = this;
            vm.inputName = appointmentUtilService.getUniqueDOMID();


            function setPlaceholder() {
                vm.placeholder =
                    vm.tripType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage
                    ? 'ENTER YOUR ADDRESS'
                    : 'ENTER YOUR PICKUP ADDRESS';
            }

            vm.placesOptions = {
                watchEnter: true,
                country: 'us,can',
                startLat: parseFloat(vm.dealer.lat),
                startLng: parseFloat(vm.dealer.lng)
            };

            vm.placeUpdated = placeUpdated;

            init();

            function init() {
                updateLocation();
                setPlaceholder();
            }

            function placeUpdated(place) {
                var placeChanged = {
                    pickUp: place,
                    department: vm.department
                };

                $rootScope.$broadcast('pickUpChanged', placeChanged);
                $rootScope.$broadcast('departmentPickUpChanged', place);
            }

            function updateLocation() {
                if (vm.place) {
                    vm.location = vm.place.location.formattedAddress;
                } else {
                    vm.location = '';
                }
            }

            $scope.$on('transportationTypeChanged',
                function(e, newValue) {
                    vm.tripType = newValue;
                    setPlaceholder();
                });

            $scope.$on('pickUpChanged',
                function(e, newValue) {
                    if (newValue && newValue.department.id === vm.department.id) {
                        var pickup = newValue.pickUp;
                        if (!vm.place ||
                            vm.place === undefined ||
                            !pickup ||
                            vm.place && vm.place.location.lat !== pickup.location.lat ||
                            vm.place && vm.place.location.lng !== pickup.location.lng) {
                            vm.place = pickup;
                            updateLocation();
                        }
                    }
                });

            $scope.$watch('vm.place',
                function(newValue) {
                    updateLocation();
                });
        };
    }
})();

(function () {
    'use strict';

    consumerAppointmentMapController.$inject = ["$scope", "$window", "consumerAppointmentService", "mapObjectFactory", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "$timeout"];
    angular
        .module('redcap.consumer.appointments')
        .directive('consumerAppointmentMap', consumerAppointmentMap);

    function consumerAppointmentMap() {
        return {
            restrict: 'A',
            templateUrl: 'app/areas/consumer/appointments/views/partials/appointment-map.html',
            controller: consumerAppointmentMapController,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                dealer: '<',
                pickup: '<',
                maxheight: '<'
            }
        };
    }

    function consumerAppointmentMapController($scope,
        $window,
        consumerAppointmentService,
        mapObjectFactory,
        SYSTEM_ENUMS,
        HERE_MAPS_CONFIG,
        $timeout) {
        this.$onInit = function() {
            var vm = this,
                MAP_MIN_HEIGHT = 100,
                MAP_MAX_HEIGHT = 300;

            vm.markers = [];
            vm.mapName = 'MAP-' + Math.random();
            vm.currentRoute = null;
            vm.isInFrame = consumerAppointmentService.isInFrame() ? '1' : '0';

            vm.mapOptions = {
                draggable: false,
                showSegmentOverlay: false,
                defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
                useImagesInPin: true,
                showActualRoute: false,
                showControls: false,
                disableLiveTracking: true,
                forceHideRecenter: true
            };

            vm.mapListeners = {
                drag: function() {},
                zoom: function() {}
            };

            function updateMapWithMarkers() {
                // Dealer marker
                vm.markers = [];

                if (vm.dealer) {
                    var dealerPin = mapObjectFactory.createHereMarker(vm.dealer.lat,
                        vm.dealer.lng,
                        SYSTEM_ENUMS.destinationType.dealer);
                    vm.markers.push(dealerPin);
                }

                // Customer marker (pickup)
                if (vm.pickup) {
                    var pickup = vm.pickup.location,
                        customerPin = mapObjectFactory.createHereMarker(pickup.lat,
                            pickup.lng,
                            SYSTEM_ENUMS.destinationType.customer);
                    vm.markers.push(customerPin);
                }

                // necessary for the route to draw correctly.
                if (vm.hereMap) {
                    vm.hereMap.updateMarkers(vm.markers, true);
                }

                if (vm.markers.length === 1) {
                    fitBounds();
                } else {
                    if (vm.hereMap) {
                        vm.hereMap.fitAll();
                    }
                }

            }

            function fitBounds() {
                $timeout(function() {
                        if (!vm.hereMap) {
                            return fitBounds();
                        }

                        vm.hereMap.setZoom(14);

                    },
                    1);
            }

            $scope.$on('drawTripRoute',
                function(e, newRoute) {
                    vm.currentRoute = newRoute;
                    if (vm.hereMap) {
                        vm.hereMap.updateMap({ stops: newRoute });
                    }
                });

            $scope.$on('pickUpChanged',
                function(e, newValue) {
                    if (newValue) {
                        vm.pickup = newValue.pickUp;
                        updateMapWithMarkers();
                    } else {
                        vm.hereMap.clearMap();
                        updateMapWithMarkers();
                    }
                });

            $scope.$on('transportationTypeChanged',
                function(e, newValue) {
                    if (newValue.isDropOff) {
                        vm.pickup = null;
                        vm.hereMap.clearMap();
                        updateMapWithMarkers();
                    }
                });

            $scope.$on('clearMap',
                function(e, newValue) {
                    vm.hereMap.clearMap();
                    updateMapWithMarkers();
                });

            $scope.$on('minimizeHeaderMap',
                function(e, newValue) {
                    vm.resizeMap(true);
                });


            vm.onMapReady = function(hereMap) {
                vm.hereMap = hereMap;
                if (vm.currentRoute) {
                    vm.hereMap.updateMap({ stops: vm.currentRoute });
                } else {
                    updateMapWithMarkers();
                }
            };

            function debounce(fn, time) {
                var timeout;
                // every time this returned fn is called, it clears and re-sets the timeout
                return function() {
                    var context = this;
                    // set args so we can access it inside of inner function
                    var args = arguments;
                    var later = function() {
                        timeout = null;
                        fn.apply(context, args);
                    };
                    $timeout.cancel(timeout);
                    timeout = $timeout(later, time);
                };
            }

            vm.resizeMap = function(forceMinimize) {
                var currentMapHeight = angular.element('#appt-map-container').height(),
                    newMapHeight,
                    window = angular.element($window),
                    width = window.width();


                if (currentMapHeight > MAP_MIN_HEIGHT || forceMinimize) {
                    if (width < 992) {
                        newMapHeight = 100;
                    } else {
                        newMapHeight = MAP_MIN_HEIGHT;
                    }
                } else {
                    if (width < 992) {
                        newMapHeight = 200;
                    } else {
                        newMapHeight = MAP_MAX_HEIGHT;
                    }
                }

                if (newMapHeight === currentMapHeight) return;

                var resizerTop = newMapHeight + 15,
                    mapHeightProp = newMapHeight + 'px';

                $timeout(function() {
                        if (vm.isInFrame === '1') {
                            resizerTop = resizerTop - 50;
                        }
                        angular.element('.appointment-header-map').css('height', mapHeightProp);
                        angular.element('#public-map').css('height', mapHeightProp);
                        angular.element('#appt-map-container').css('height', mapHeightProp);
                        angular.element('#map').css('height', mapHeightProp);
                        angular.element('#resizer').css('top', resizerTop + 'px');
                        angular.element('.map-wrap').css('height', mapHeightProp);
                        angular.element('.map-container').css('height', mapHeightProp);
                        if (vm.hereMap) {
                            vm.hereMap.setMapSizes(mapHeightProp, null);
                            if (mapHeightProp === MAP_MIN_HEIGHT + 'px') {
                                vm.hereMap.setZoom(0);
                            } else {
                                vm.hereMap.setZoom(13);
                            }
                        }
                    },
                    1);

            };

            function onWindowResize() {
                var currentMapHeight = angular.element('#appt-map-container').height(),
                    newMapHeight,
                    window = angular.element($window),
                    width = window.width(),
                    resizerTop,
                    mapHeightProp;
                if (width < 992 && currentMapHeight > 200) {
                    newMapHeight = 200;
                    resizerTop = newMapHeight + 15;
                    mapHeightProp = newMapHeight + 'px';

                    if (vm.isInFrame === '1') {
                        resizerTop = resizerTop - 50;
                    }
                    angular.element('.appointment-header-map').css('height', mapHeightProp);
                    angular.element('#public-map').css('height', mapHeightProp);
                    angular.element('#appt-map-container').css('height', mapHeightProp);
                    angular.element('#map').css('height', mapHeightProp);
                    angular.element('#resizer').css('top', resizerTop + 'px');
                    if (vm.hereMap) {
                        vm.hereMap.setMapSizes(mapHeightProp, null);
                    }

                } else if (vm.isInFrame === '1') {

                    currentMapHeight = angular.element('#appt-map-container').height();
                    resizerTop = currentMapHeight + 15;
                    mapHeightProp = currentMapHeight + 'px';
                    resizerTop = resizerTop - 50;

                    angular.element('.appointment-header-map').css('height', mapHeightProp);
                    angular.element('#public-map').css('height', mapHeightProp);
                    angular.element('#appt-map-container').css('height', mapHeightProp);
                    angular.element('#map').css('height', mapHeightProp);
                    angular.element('#resizer').css('top', resizerTop + 'px');
                    if (vm.hereMap) {
                        vm.hereMap.setMapSizes(mapHeightProp, null);
                    }


                }

                $timeout(function() {
                        if (vm.markers.length === 1) {
                            fitBounds();
                        } else {
                            if (vm.hereMap) {
                                vm.hereMap.fitAll();
                            }
                        }
                    },
                    250);
            }

            angular.element($window).on('resize', debounce(onWindowResize, 450));
            $timeout(function() {
                    onWindowResize();
                },
                1);
        };
    }
})();

(function () {
    'use strict';

    consumerAppointmentMessageModalController.$inject = ["$uibModalInstance", "resolvedTitle", "resolvedMessage", "resolvedIsError", "resolvedButtons"];
    angular
        .module('redcap.consumer.appointments')
        .controller('ConsumerAppointmentMessageModalController', consumerAppointmentMessageModalController);

    function consumerAppointmentMessageModalController($uibModalInstance, resolvedTitle, resolvedMessage, resolvedIsError, resolvedButtons) {
        var vm = this;
        vm.title = resolvedTitle;
        vm.message = resolvedMessage;
        vm.isError = resolvedIsError;
        vm.buttons = resolvedButtons;

        // Public functions
        vm.resolve = resolve;
        vm.close = close;

        function close() {
            $uibModalInstance.close([]);
        }

        function resolve(result){
            $uibModalInstance.close(result);
        }
    }
})();

(function () {
    'use strict';

    consumerAppointmentLandingController.$inject = ["$scope", "$rootScope", "$state", "$window", "$transition$", "$filter", "appointmentUtilService", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE", "dealerOpCodes", "resolvedDealerDepartments", "resolvedDealerBranding", "resolvedConsumerTripTypes", "consumerAppointmentService", "consumerModalService"];
    angular
        .module('redcap.consumer.appointments')
        .controller('ConsumerAppointmentLandingController', consumerAppointmentLandingController);

    function consumerAppointmentLandingController($scope, $rootScope, $state, $window, $transition$, $filter, appointmentUtilService, 
        SYSTEM_ENUMS, CONSUMER_APPS_TYPE, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE, dealerOpCodes, resolvedDealerDepartments,
        resolvedDealerBranding, resolvedConsumerTripTypes, consumerAppointmentService, consumerModalService) {
    
        var vm = this,
            configValues = resolvedDealerBranding.configValues,
            bookingMethod = consumerAppointmentService.getBookingMethod(configValues);

        if (bookingMethod === CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.ghostGarage) {
            $state.go('consumer-appointment-ghostgarage-booking', $transition$.params());
            return;
        } 

        vm.branding = configValues;
        vm.loadingPage = true;
        vm.displayedTripLocations = null;
        vm.isInFrame = consumerAppointmentService.isInFrame();
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        // Dealer Settings
        vm.dealer = resolvedDealerBranding;
        vm.apptConsumerDepartmentId = configValues.apptConsumerDepartmentId;
        vm.title = configValues.landingTitle;
        vm.description = configValues.landingDescription;
        vm.firstChoiceTitle = configValues.landingFirstChoiceTitle;
        vm.secondChoiceTitle = configValues.landingSecondChoiceTitle;
        vm.thirdChoiceTitle = configValues.landingThirdChoiceTitle;
        vm.firstChoiceDescription = configValues.landingFirstChoiceDescription;
        vm.secondChoiceDescription = configValues.landingSecondChoiceDescription;
        vm.thirdChoiceDescription = configValues.landingThirdChoiceDescription;
        vm.dealerDepartments = resolvedDealerDepartments;
        
        vm.headerImageUrl = configValues.headerImageUrl;
        vm.dealerOpCodes = dealerOpCodes;
        
        vm.showMapInMobile = consumerAppointmentService.getDisplayMapInMobile(configValues);
        vm.showMapFramedIn = consumerAppointmentService.getDisplayMapFramedIn(configValues);

        // Trip Types
        vm.resolvedConsumerTripTypes = resolvedConsumerTripTypes;
        
        // Public functions
        vm.getStarted = getStarted;
        vm.showDealerDetails = showDealerDetails;

        vm.displayLoanerSections = consumerAppointmentService.displayLoanerSections(vm.resolvedConsumerTripTypes, false);
        
        vm.showTheMap = function () {
            return consumerAppointmentService.showTheMap(vm.isInFrame, vm.showMapFramedIn);
        };

        function init() {
            // Set initial step
            vm.step = 'selectServiceType';
            if (bookingMethod !== CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.standard) {
                if (consumerAppointmentService.isDepartmentRankingCompleted(resolvedDealerDepartments)) {
                    vm.hasDeparmentRanking = true;
                    vm.rankedDepartments = $filter('filter')(resolvedDealerDepartments, { rank: '' });
                } else {
                    vm.hasDeparmentRanking = false;
                }
            } else {
                vm.hasDepartmentRanking = false;
            }

            if (bookingMethod !== CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.standard || vm.hasDepartmentRanking === false) {
                var defaultDeptId = vm.apptConsumerDepartmentId ? parseInt(vm.apptConsumerDepartmentId) : null,
                    deptTransTypes = null;
                if (defaultDeptId) {
                    vm.defaultDepartment = $filter('filter')(resolvedDealerDepartments, { id: defaultDeptId }, true)[0];
                    vm.selectedDepartment = vm.defaultDepartment;
                    deptTransTypes = consumerAppointmentService.filterDepartmentTransportationTypes(resolvedConsumerTripTypes, defaultDeptId);

                    vm.defaultDropoffTripType = consumerAppointmentService.getDefaultDropOff(deptTransTypes);
                    vm.defaultPickupTripType = null;
                    
                    // make sure they have a pickup trip type instance enabled
                    if (resolvedConsumerTripTypes.pickUpTransportationTypes.length > 0 && configValues.defaultPickupTripTypeId !== null) {
                        vm.defaultPickupTripType = consumerAppointmentService.getDefaultPickUp(deptTransTypes, configValues);
                    }
                }
            }

            consumerAppointmentService.minimizeHeaderMap();
            vm.loadingPage = false;
        }

        init();

        function getStarted(type) {
            $rootScope.$broadcast('minimizeHeaderMap');

             // "I have an appointment"
            if (type === 'existing') {
                vm.flow = 'existing';
                vm.step = 'customerLogin';
                return;
            }

            // If selected "New" appointment
            if (type && type !== '') {
                // Update selected service
                vm.tripType = type;

                // Reset pickup address if not pickup type
                if (type.isDropOff && configValues.landingPageSecondChoiceURL && configValues.landingPageSecondChoiceURL.trim().length > 0) {
                    window.onbeforeunload = null;
                    $window.location = configValues.landingPageSecondChoiceURL;
                    return;
                }

                if (type.isDropOff) {
                    vm.pickupLocation = null;
                    $rootScope.$broadcast('departmentPickupChanged', null);
                }

                // If selected service type is valid
                if (vm.tripType) {
                    vm.flow = null;
                    vm.step = 'customerLogin';
                } // else do nothing.
            }
        }

        function showDealerDetails() {
            consumerModalService.showDealerDetails(vm.dealer);
        }

        vm.useStandardLandingPage = function () {
            return bookingMethod === CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.standard || vm.hasDeparmentRanking === false;
        };

        vm.dealerConfigured = function () {
            return consumerAppointmentService.isDealerConfigured(vm.dealerOpCodes, vm.apptConsumerDepartmentId);
        };

        vm.disableGetStarted = function () {
            var type = vm.tripType,
                typeNotSelected = !type.isDropOff && !vm.pickupLocation,
                outOfServiceArea = !type.isDropOff && vm.pickupLocation && vm.pickupLocation.isInServiceArea === false;
            if (type === 'existing') return false;
            return !type || typeNotSelected || vm.checkingServiceArea || outOfServiceArea;
        };

        vm.updateMap = function () {
            // just need to pass "now" to validate trip so that we can get a route to display on the map for now

            var tempAppointment = {
                dealerTransportationTypeId: vm.tripType.id,
                tripPickupTime: moment(),
                tripPickupLocation : vm.pickupLocation.location
            };
            
            consumerAppointmentService.validateTrip(vm.dealer.dealerId, tempAppointment, vm.tripType)
                .then(function (result) {
                    vm.displayedTripLocations = appointmentUtilService.getTripLocations(result);
                    consumerAppointmentService.displayTripLocations({ locationList: vm.displayedTripLocations});
                });
        };

        vm.clearMap = function () {
            $rootScope.$broadcast('clearMap');
        };

        vm.pickUpChanged = function () {
            vm.checkingServiceArea = true;
            consumerAppointmentService.isInServiceArea(vm.dealer.dealerId, vm.pickupLocation).then(
                function (result) {
                    vm.checkingServiceArea = false;
                    vm.pickupLocation.isInServiceArea = result;
                    if (result) {
                        vm.updateMap();
                    } else {
                        vm.clearMap();
                    }
                },
                function (error) {
                    vm.checkingServiceArea = false;
                }).finally(function () { });

        };

        $scope.$on('customerLoginEvent', function (e, loginEventData) {
            vm.loading = true;
            
            // Guest Login
            if (loginEventData && loginEventData.event === 'guest') {
                //Guest
                var guestAppointment = {
                    dealerTransportationTypeId: vm.tripType.id
                };
                
                $state.go('consumer-appointment-booking', angular.extend({ appointment: guestAppointment, tripType: vm.tripType, pickupLocation: vm.pickupLocation, displayedTripLocations: vm.displayedTripLocations, eventData: loginEventData.event, department: vm.selectedDepartment }));
            }
            // Customer Login
            else if (loginEventData && loginEventData.event === 'login') {
                // Login
                var customerAppointment = loginEventData.data.customer;
                customerAppointment.dealerTransportationTypeId = vm.tripType.id;

                $state.go('consumer-appointment-booking', angular.extend({ appointment: customerAppointment, tripType: vm.tripType, pickupLocation: vm.pickupLocation, eventData: loginEventData.event, department: vm.selectedDepartment }));
            }
            // Open Appointment
            else if (loginEventData && loginEventData.event === 'openAppointment') {
                // Go to confirmation screen
                $state.go('consumer-appointment-confirmation', angular.extend({ appointmentId: loginEventData.data.id, key: loginEventData.data.key }));
            }
            // Cancel / Else
            else {
                // Reset selections
                vm.pickupLocation = null;
                vm.loading = false;
                vm.step = 'selectServiceType';
            }
        });

        $scope.$on("departmentPickUpChanged", function (e, newValue) {
            if (vm.tripType && !vm.tripType.isDropOff) {
                vm.pickupLocation = newValue;
                vm.pickUpChanged();
            }
        });

        $scope.$on("clearMap", function (e, newValue) {
            vm.clearMap();
        });

        $scope.$on("departmentGetStartedClicked", function (e, newValue) {
            var selectedInfo = newValue;
            vm.tripType = selectedInfo.tripType;
            vm.selectedDepartment = selectedInfo.department;
            vm.pickupLocation = selectedInfo.pickupLocation;
            vm.getStarted(vm.tripType);
        });

        
    }
})();

(function () {
    'use strict';

    consumerAppointmentGhostGarageBookingController.$inject = ["$rootScope", "$scope", "$transition$", "$state", "$window", "$filter", "$q", "rcUtilService", "appointmentLineItemClass", "ValidationService", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "APPOINTMENTSTATUS_LABELS", "APPOINTMENT_CUSTOMERTYPE", "APPOINTMENT_TRANSPORTATION_TYPE", "resolvedDealerBranding", "resolvedAppointmentStatuses", "consumerAppointmentService", "modalService", "resolvedConsumerTripTypes", "resolvedRequiredDMSFields", "locationTransportationTypes", "appointmentClass", "dealerOpCodes", "appointmentUtilService", "resolvedKey", "resolvedDealerIntegrations", "consumerModalService", "resolvedDealerDepartments"];
    angular
        .module('redcap.consumer.appointments')
        .controller('ConsumerAppointmentGhostGarageBookingController', consumerAppointmentGhostGarageBookingController);

    function consumerAppointmentGhostGarageBookingController($rootScope, $scope, $transition$, $state, $window, $filter, $q, rcUtilService, appointmentLineItemClass, 
            ValidationService, SYSTEM_ENUMS, CONSUMER_APPS_TYPE, APPOINTMENTSTATUS_LABELS, APPOINTMENT_CUSTOMERTYPE, APPOINTMENT_TRANSPORTATION_TYPE, 
            resolvedDealerBranding, resolvedAppointmentStatuses, consumerAppointmentService, modalService, resolvedConsumerTripTypes, resolvedRequiredDMSFields,
            locationTransportationTypes, appointmentClass, dealerOpCodes, appointmentUtilService, resolvedKey, resolvedDealerIntegrations,
            consumerModalService, resolvedDealerDepartments) {
        
        let vm = this;
        let transitionParams = $transition$.params();

        vm.loading = true;
        // Dealer settings
        vm.dealerDepartments = resolvedDealerDepartments;
        vm.dealer = resolvedDealerBranding;
        vm.displayCapacityErrorMessaging = false;
        vm.departmentHours = null;
        vm.departmentConstraints = null;
        vm.requiredDMSFields = resolvedRequiredDMSFields;
        vm.displayedTripLocations = null;
        vm.hideButtons = false;
        vm.tripLocationError = null;
        vm.calendarTitle = 'WE PICK IT UP';
        vm.configValues = resolvedDealerBranding.configValues;
        vm.apptConsumerOtherServicesTitle = vm.configValues.apptConsumerOtherServicesTitle;
        vm.apptConsumerAlternateServicesTitle = vm.configValues.apptConsumerAlternateServicesTitle;
        vm.apptPreviouslyDeclinedtitle = vm.configValues.consumerMobileDeclinedServicesParagraph;
        vm.termsAndConditionsText = resolvedDealerBranding.termsPageText;
        vm.textOptInText = resolvedDealerBranding.configValues.desktopMarketingOptInCopyText;
        vm.headerImageUrl = vm.configValues.headerImageUrl;
        vm.apptConsumerDepartmentId = vm.configValues.apptConsumerDepartmentId;
        vm.defaultToPreviousAdvisor = vm.configValues.defaultToPreviousAdvisor;
        vm.apptTransporationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
        vm.appStatuses = APPOINTMENTSTATUS_LABELS;
        vm.apptStatuses = resolvedAppointmentStatuses;
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes; 
        vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;  
        vm.transmissions = SYSTEM_ENUMS.transmissions;  
        vm.dealerOpCodes = dealerOpCodes;
        vm.tripTypes = resolvedConsumerTripTypes;
        // this is needed for dignified .. remove if not needed
        vm.dealerIntegrations = resolvedDealerIntegrations;
        
        vm.myValidation = new ValidationService();
        vm.transportationTypes = locationTransportationTypes;
        vm.genericConsumerServiceEnabled = false;

        vm.showMapInMobile = consumerAppointmentService.getDisplayMapInMobile(resolvedDealerBranding.configValues);
        vm.showMapFramedIn = consumerAppointmentService.getDisplayMapFramedIn(resolvedDealerBranding.configValues);
        
        
        vm.showTheMap = function () {
            return consumerAppointmentService.showTheMap(vm.isInFrame, vm.showMapFramedIn);
        };

        vm.startOver = function () {
            $window.location.reload();
        };
        
        vm.newStatus = _.find(vm.apptStatuses, {description: vm.appStatuses.new}).code;
        
        vm.isInFrame = consumerAppointmentService.isInFrame();
        vm.confirmationFormSubmitted = false;
        vm.confirmation = false;

        // Appointment
        vm.appointmentId = transitionParams.appointmentId;
        vm.appointment = null;
        vm.originalAppointmentLineItems = [];
        vm.tripType = null;
        vm.defaultPickupTripType = null;

        if (!vm.appointmentId) {
            if (vm.tripTypes.pickUpTransportationTypes.length > 0 && vm.configValues.defaultPickupTripTypeId) {
                vm.tripType = consumerAppointmentService.getDefaultPickUp(vm.tripTypes, vm.configValues);
            } 
        }

        
        vm.dealerConfigured = function () {
            if (!vm.configValues.defaultPickupTripTypeId) return false;

            return consumerAppointmentService.isDealerConfigured(vm.dealerOpCodes, vm.apptConsumerDepartmentId);
        };
        
        vm.stateId = {
            booked: 0,
            services: 1,
            appointment: 2,
            vehicle: 3,
            confirmation: 4
        };

        vm.customerType = APPOINTMENT_CUSTOMERTYPE;

        // Page states
        vm.states = [
            {
                id: vm.stateId.services,
                previousState: vm.appointmentId || vm.appointment && vm.appointment.id ? vm.stateId.booked : null,
                nextState: vm.stateId.appointment,
                isValid: function () {
                    $rootScope.$broadcast('validateServices', null);
                    let validServices =  vm.myValidation.checkFormValidity(vm.vehicleServicesForm);

                    return validServices && rcUtilService.isFormValid(vm.vehicleServicesForm);
                    
                }
            },
            {
                id: vm.stateId.appointment,
                previousState: vm.stateId.services,
                nextState: vm.stateId.vehicle,
                isValid: function () {
                    vm.detailsFormSubmitted = true;
                    let lineItemCount = vm.appointment && vm.appointment.lineItems ? vm.appointment.lineItems.length : 0;

                    if (lineItemCount === 0) return false;

                    let validDetails = vm.myValidation.checkFormValidity(vm.appointmentForm);
                    let isManualValid = !(vm.tripType.isPickup && vm.appointment.isManual === null);
                    let isTripTypeValid = !!vm.tripType;
                    

                    return validDetails && rcUtilService.isFormValid(vm.appointmentForm) && isManualValid && isTripTypeValid;
                }
            },
            {
                id: vm.stateId.vehicle,
                previousState: vm.stateId.appointment,
                nextState: vm.stateId.confirmation, //'Services',
                isValid: function () {
                    vm.vehicleFormSubmitted = true;
                    let validOwner = vm.myValidation.checkFormValidity(vm.vehicleOwnerForm);
                    let validVehicleForm = vm.myValidation.checkFormValidity(vm.vehicleInformationForm);
                    let validVehicle = false;
                    let validMileage;

                    if (!vm.appointment.year || !vm.appointment.make || !vm.appointment.model) {
                        validVehicle = false;
                    } else if (vm.appointment.vehicleId) {
                        validVehicle = true;
                    } else {
                        validVehicle = vm.myValidation.checkFormValidity(vm.vehicleInformationForm);
                    }

                    validMileage = vm.appointment.mileage !== null && vm.appointment.mileage !== "";

                    return validOwner && validVehicleForm && validVehicle && validMileage;
                }
            },   
            {
                id: vm.stateId.confirmation,
                previousState: vm.stateId.vehicle,
                nextState: null,
                isValid: function () {
                    // Valid
                    if (vm.confirmation) return true;

                    // Invalid
                    return false;
                }
            }
        ];

        
        consumerAppointmentService.setCurrentState(vm, vm.stateId.services);

        // Public functions
        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.createAppointment = createAppointment;
        vm.showDealerDetails = showDealerDetails;
        vm.originalAppointmentHasLoaner = false;

        function isOriginalAppointmentPickupLoaner () {
            vm.originalAppointmentHasLoaner = consumerAppointmentService.isOriginalAppointmentPickupLoaner(vm.appointment, vm.transportationTypes, vm.apptTransporationTypes.pickupLoaner);
        }

        function postLoadAppointment () {
            consumerAppointmentService.postLoadAppointment(vm);
        }

        function loadAppointment(result) {
            vm.appointment = appointmentClass.new(result);
            vm.appointment = consumerAppointmentService.postProcessAPIAppointment(vm.appointment, vm.dealerOpCodes, vm.dealerDepartments, vm.previouslyDeclinedServices);
            vm.appointment.yearMakeModelMismatch = false;
            vm.originalAppointmentLineItems = _.cloneDeep(vm.appointment.lineItems);

            // we will need to check if these have chagned later
            vm.originalAppointmentDateTime = _.cloneDeep(vm.appointment.apptDateTime);
            vm.originalDealerEmployeeId = vm.appointment.dealerEmployeeId;
            vm.originalDepartmentId = vm.appointment.departmentId;
            
            vm.originalTransportationType = vm.appointment.dealerTransportationTypeId;
            vm.originalIsManual = vm.appointment.isManual;
            vm.originalPickupLocation = vm.appointment.tripPickupLocation;

            isOriginalAppointmentPickupLoaner();
        }
        
        function displayCapacityErrorMessaging () {
            vm.displayCapacityErrorMessaging = true;
        }

        function validateCapacity () {
            vm.validatingCapacity = true;
            consumerAppointmentService.validateCapacity(vm.dealer.dealerId, vm.appointment, vm.previouslyDeclinedServices).then(
                (result) => {
                    if (result.errors) {
                        displayCapacityErrorMessaging();
                        vm.validatingCapacity = false;

                        return;
                    }
 
                    vm.validatingCapacity = false;
                },
                (error) => {
                    displayCapacityErrorMessaging();
                    vm.validatingCapacity = false;

                    return;
                }).finally(() => { 
                    vm.validatingCapacity = false;
                });
        }

        function loadRecallsAndRecMaintAndPrevDeclined () {
            consumerAppointmentService.loadRecallsRecMaintPrevDeclined(vm);
        }

        function filterDepartmentData() {
            consumerAppointmentService.filterDepartmentData(vm, resolvedConsumerTripTypes, dealerOpCodes, vm.appointment.departmentId);
        }

        function init() {
            // Default appointment object
            let setStatus = function () {
                    if (!vm.appointment.appointmentStatus) {
                        vm.appointment.appointmentStatus = vm.newStatus;
                    }
                };

            let setTripType = function () {
                if (vm.appointment.dealerTransportationTypeId) {
                    vm.tripType = $filter('filter')(vm.transportationTypes, {id: vm.appointment.dealerTransportationTypeId}, true)[0];
                }
            };

            if (vm.appointment === null && transitionParams.appointment) {
                vm.appointment = appointmentClass.new(transitionParams.appointment);
                vm.appointment.yearMakeModelMismatch = false;

                if (transitionParams.appointment && transitionParams.appointment.customerType === vm.customerType.business) {
                    vm.appointment.customerIsBusiness = true;
                } else if (!vm.appointment.customerType) {
                    vm.appointment.customerType = vm.customerType.individual;
                }

                vm.appointment = consumerAppointmentService.postProcessAPIAppointment(vm.appointment, vm.dealerOpCodes, vm.dealerDepartments, vm.previouslyDeclinedServices);
                vm.originalAppointmentLineItems = _.cloneDeep(vm.appointment.lineItems);
                
                isOriginalAppointmentPickupLoaner();
                vm.appointment.originalApptHasRecallsOrRecMaint = false;
                postLoadAppointment();
                setTripType();
                setStatus();
                consumerAppointmentService.loadTripRoute(false, vm.appointment);
                loadRecallsAndRecMaintAndPrevDeclined();
                vm.loading = false;
            } else if (vm.appointment === null && vm.appointmentId) {
                consumerAppointmentService.getAppointment(vm.dealer.dealerId, vm.appointmentId, resolvedKey).then(
                (result) => {
                    // Success
                    loadAppointment(result);

                    if (!vm.appointment.departmentId) {
                        vm.appointment.departmentId = parseInt(vm.apptConsumerDepartmentId);
                        filterDepartmentData();
                        $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
                    }

                    postLoadAppointment();
                    setTripType();
                    setStatus();
                    consumerAppointmentService.loadTripRoute(true, vm.appointment);
                    loadRecallsAndRecMaintAndPrevDeclined();
                    vm.loading = false;
                },
                (error) => {
                    $state.go('404NotFound');
                }).finally(() => {
                    vm.loading = false;
                });
            } else if (vm.appointment === null) {
                vm.appointment = appointmentClass.new();

                if (!vm.appointment.customerType) {
                    vm.appointment.customerType = vm.customerType.individual;
                }
                
                vm.appointment.yearMakeModelMismatch = false;
                vm.appointment.originalApptHasRecallsOrRecMaint = false;
                setStatus();
                vm.loading = false;
            } else {
                vm.appointment.originalApptHasRecallsOrRecMaint = false;

                if (!vm.appointment.status) {
                    setStatus();
                }

                vm.loading = false;
            }

            if (vm.appointment && !vm.appointment.departmentId) {
                vm.appointment.departmentId = parseInt(vm.apptConsumerDepartmentId);
                filterDepartmentData();
                $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
            }

            if (vm.appointment && !vm.appointment.department) {
                vm.appointment.department = $filter('filter')(vm.dealerDepartments, {id: vm.appointment.departmentId}, true)[0];
            }
        }

        function previousStep() {
            let prevState = vm.currentState.previousState;

            if (prevState !== null) {
                if (prevState === vm.stateId.booked) {
                    $state.go('consumer-appointment-confirmation', angular.extend({appointmentId: vm.appointment.id}, transitionParams));
                } else {
                    consumerAppointmentService.setCurrentState(vm, prevState);
                    vm.currentState.submitted = false;
                }
            }
        }

        function nextStep() {
            let currentState = vm.currentState;

            if (!currentState.isValid()) {
                vm.currentState.submitted = true;

                return;
            }

            let checkPhoneAndFinish = function () {
                if (phoneType.type === vm.phoneTypes.landline) {
                    phoneWarning = modalService.showLandlineWarning;
                } else if (phoneType.type === vm.phoneTypes.voip) {
                    phoneWarning = modalService.showVoIPWarning;
                }

                phoneWarning().then(() => {
                    if (!vm.appointment.customerType) {
                        vm.appointment.customerType = vm.customerType.individual;
                    }
                });
            };

            if (currentState.id === vm.stateId.vehicle) {
                var phoneWarning = $q.when;  // Do not show any warning
                var phoneType = vm.customerPhoneType;

                if (!phoneType) {
                    return;
                } 
                
                if (!vm.appointment.id && !vm.appointment.customerId) {
                    consumerAppointmentService.getCustomer(vm.dealer.dealerId, vm.appointment.customerEmail, vm.appointment.customerPhone)
                    .then((customer) => {
                        if (customer) {
                            // exact match found in dms, use the customer number.
                            vm.appointment.customerId = customer.custNo;
                        }

                        checkPhoneAndFinish();
                    });
                } else {
                    checkPhoneAndFinish();
                }
                
            } else if (currentState.id === vm.stateId.services) {
                consumerAppointmentService.getDefaultDepartment(vm.dealer.dealerId, vm.appointment)
                    .then((response) => {
                        vm.appointment.canUseDefaultDepartment = response.canUseDefaultDepartment;
                        vm.appointment.defaultDealerDepartmentId = response.defaultDealerDepartmentId;

                        if (vm.appointment.canUseDefaultDepartment && vm.appointment.departmentId !== vm.appointment.defaultDealerDepartmentId) {
                            // We need to repopulate the time slots
                            $rootScope.$broadcast('updateAvailability', null);
                        }

                        if (consumerAppointmentService.requiresCapacityValidation(vm, true) === false) {
                            vm.appointment.bypassValidation = true;
                        } else {
                            // we need to fire off a capacity check before going to the next page
                            // and display error messaging if they've lost their slot
                            validateCapacity();
                        }
                    });

            }

            if (currentState.nextState) {
                $window.scrollTo(0, 0); // ensure that customer is on top of page
                consumerAppointmentService.setCurrentState(vm, vm.currentState.nextState);
                vm.currentState.submitted = false;
            }
        }

        function createAppointment() {
            vm.confirmationFormSubmitted = true;

            if (!vm.currentState.isValid()) {
                return;
            }

            vm.loading = true;
            
            // Convert to AP appointment type
            vm.appointment.dealerTransportationTypeId = vm.tripType.id;
            vm.appointment.departmentId = parseInt(vm.apptConsumerDepartmentId);
            filterDepartmentData();
            $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
            
            if (vm.pickupLocation) {
                vm.appointment.tripPickupLocation = vm.pickupLocation.location;
                appointmentUtilService.createTripCustomer(vm.appointment);
            }

            if (!vm.appointment.id) {
                vm.appointment.addingNew = true;
            } else {
                vm.appointment.addingNew = false;
            }

            consumerAppointmentService.createAppointment(vm.dealer.dealerId, vm.appointment, vm.previouslyDeclinedServices).then(
                (result) => {
                    if (result && !result.errors) {
                        gotoConfirm(result);
                    } else if (result && result.errors && result.errors.length > 0) {
                        vm.loading = false;
                        modalService.showError('Sorry, there was a problem booking your appointment:', result.errors);
                    } else {
                        consumerAppointmentService.genericCreateApptError(vm);
                    }
                },
                (error) => {
                    // Error
                    consumerAppointmentService.genericCreateApptError(vm);
                }).finally(() => { });
        }

        function gotoConfirm(result) {
            loadAppointment(result);
            $state.go('consumer-appointment-confirmation', {appointment: vm.appointment, appointmentId: vm.appointment.id, displayedTripLocations: vm.displayedTripLocations, dealerId: transitionParams.dealerId, tripType: vm.tripType, key: vm.appointment.urlKey});
        }

        function showDealerDetails() {
            consumerModalService.showDealerDetails(vm.dealer);
        }

        vm.updateYMM = function (origValue) {
             return appointmentUtilService.updateYMM(origValue, vm.appointment);
        };

        vm.isYMMSameAsOriginalApptYMM  = function (year, make, model) {
            return appointmentUtilService.isYMMSameAsOriginalApptYMM(year, make, model, vm.originalApptYear, vm.originalApptMake, vm.originalApptModel);
        };

        vm.gettingServices = function () {
            return vm.retrievingRecalls || vm.gettingPreviouslyDeclinedServices;
        };

        vm.showTermsWarning = function () {
            // ghis validation is not working correctly w/ the checkbox
            // if you check it and then uncheck it.. it's passing as if checked
            if (!vm.confirmation && vm.confirmationFormSubmitted) {
                return true;
            }

            return false;
        };

        vm.showTextOptInWarning = function () {
            // ghis validation is not working correctly w/ the checkbox
            // if you check it and then uncheck it.. it's passing as if checked
            if (!vm.appointment.mobileSmsOptedIn && vm.confirmationFormSubmitted) {
                return true;
            }

            return false;
        };

        vm.pickUpChanged = function () {
            consumerAppointmentService.pickupChanged(vm.tripType, vm.pickupLocation, vm.dealer, vm.checkingIsInServiceArea);
        };

        $scope.$on('updateTripLocations', (e, newValue) => {
            vm.displayedTripLocations = newValue;
            vm.tripLocationError = null;
        });

        $scope.$on('updateTripLocationError', (e, newValue) => {
            vm.tripLocationError = newValue;
        });

        $scope.$on('transportationTypeChanged', (e, newValue) => {
            vm.tripType = newValue;
        });

        $scope.$on('pickUpChanged', (e, newValue) => {
            if (newValue) {
                vm.pickupLocation = newValue.pickUp;
            } else {
                vm.pickupLocation = null;
            }

            vm.pickUpChanged();
        });

        $scope.$on('customerPhoneTypeChanged', (e, newValue) => {
            vm.customerPhoneType = newValue;
            vm.appointment.invalidPhone = !vm.customerPhoneType;
        });

        $scope.$on('pickUpDateTimeChanged', (e, newValue) => {
            consumerAppointmentService.pickupDateTimeChanged(vm.appointment, vm.tripType, vm.pickupLocation, vm.dealer, newValue);
        });

        $scope.$on('timeChanged', (e, newValue) => {
            vm.displayCapacityErrorMessaging = false;
        });

        $scope.$on('vehicleUpdated', (e, newValue) => {
            let appt = vm.appointment;

            vm.appointment.yearMakeModelMismatch = !vm.isYMMSameAsOriginalApptYMM(appt.year, appt.make, appt.model);
        });

        $scope.$on('hideButtons', (e, newValue) => {
            if (newValue === true && vm.currentState === vm.states.appointment) {
                vm.hideButtons = newValue;
            }
        });

        vm.getRecMainTooltip = function (apps) {
            return appointmentUtilService.getRecMainTooltip(apps);
        };

        $scope.$on('servicesUpdated', (e, newValue) => {
            vm.servicesModified = true;
            appointmentUtilService.processServicesUpdated(newValue, vm.appointment, vm.originalAppointmentLineItems, vm.dealer, vm.dealerOpCodes, vm.recalls, vm.recMaintData);
        });

        $scope.$on('departmentUpdated', (e, newValue) => {
            if (vm.lastDepartmentId !== newValue) {
                vm.lastDepartmentId = newValue;
                filterDepartmentData();
                consumerAppointmentService.updateDepartmentHours(vm.dealer.dealerId, newValue);
            }
        });

        $scope.$on('departmentHoursUpdated', (e, newValue) => {
            vm.departmentHours = newValue;
        });

        $scope.$on('departmentConstraintsUpdated', (e, newValue) => {
            vm.departmentConstraints = newValue;
            vm.processedClosedConstraints = consumerAppointmentService.processClosedConstraints(vm.departmentConstraints);
           
        });

        init();

    }
})();

(function () {
    'use strict';

    consumerAppointmentConfirmationController.$inject = ["$state", "$transition$", "$timeout", "$rootScope", "$filter", "resolvedRideShareCredit", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "APPOINTMENTSTATUS_LABELS", "resolvedConsumerTripTypes", "resolvedDealerBranding", "resolvedAppointmentStatuses", "consumerAppointmentService", "appointmentUtilService", "dealerOpCodes", "appointmentClass", "resolvedKey", "locationTransportationTypes", "consumerModalService", "resolvedDealerIntegrations", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE"];
    angular
        .module('redcap.consumer.appointments')
        .controller('ConsumerAppointmentConfirmationController', consumerAppointmentConfirmationController);

    function consumerAppointmentConfirmationController($state, $transition$, $timeout, $rootScope, $filter, resolvedRideShareCredit,
                SYSTEM_ENUMS, CONSUMER_APPS_TYPE, APPOINTMENTSTATUS_LABELS, resolvedConsumerTripTypes, resolvedDealerBranding, 
                resolvedAppointmentStatuses, consumerAppointmentService, appointmentUtilService, dealerOpCodes, appointmentClass, resolvedKey, 
                locationTransportationTypes, consumerModalService, resolvedDealerIntegrations, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE) {
        let vm = this;

        vm.credit = resolvedRideShareCredit;
        vm.dealerIntegrations = resolvedDealerIntegrations;
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.appStatuses = APPOINTMENTSTATUS_LABELS;
        vm.loading = true;
        vm.transportationTypes = locationTransportationTypes;
        vm.dealerOpCodes = null;
        vm.dealerGenericOpCodes = null;
        vm.dealerOpCodes = dealerOpCodes;

        vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;

        vm.apptStatuses = resolvedAppointmentStatuses;
        vm.canceledStatus = _.find(vm.apptStatuses, {description: vm.appStatuses.canceled}).code;
        vm.tripTypes = resolvedConsumerTripTypes;
        vm.isInFrame = consumerAppointmentService.isInFrame();
        vm.dealer = resolvedDealerBranding;
        vm.headerImageUrl = resolvedDealerBranding.configValues.headerImageUrl;

        vm.configValues = resolvedDealerBranding.configValues;
        vm.apptConsumerDepartmentId = vm.configValues.apptConsumerDepartmentId;
        vm.appointment = $transition$.params().appointment;
        vm.confirmationCode = $transition$.params().appointmentId;
        vm.tripType = $transition$.params().tripType || null;

        // Public functions
        vm.editAppointment = editAppointment;
        vm.cancelAppointment = cancelAppointment;
        vm.showDealerDetails = showDealerDetails;

        vm.showMapInMobile = consumerAppointmentService.getDisplayMapInMobile(resolvedDealerBranding.configValues);
        vm.showMapFramedIn = consumerAppointmentService.getDisplayMapFramedIn(resolvedDealerBranding.configValues);
       
        let bookingMethod = consumerAppointmentService.getBookingMethod(resolvedDealerBranding.configValues);

        vm.maxHeight = 300;
        init();

        vm.showTheMap = function () {
            return consumerAppointmentService.showTheMap(vm.isInFrame, vm.showMapFramedIn);
        };
        
        function setTripType() {
            if (vm.appointment.dealerTransportationTypeId) {
                vm.tripType = $filter('filter')(vm.transportationTypes, {id: vm.appointment.dealerTransportationTypeId}, true)[0];
            } else {
                vm.tripType = vm.transportationTypes[0];
            }
        }

        function init() {
            // Load appointment here
            vm.errorLoadingAppointment = false;
            consumerAppointmentService.getAppointment(vm.dealer.dealerId, vm.confirmationCode, resolvedKey).then(
                (result) => {

                    // Success
                    let appointment = appointmentClass.new(result);

                    vm.appointment = consumerAppointmentService.postProcessAPIAppointment(appointment, vm.dealerOpCodes);

                    setTripType();

                    if (vm.appointment.tripStops && vm.appointment.tripStops.length > 1) {
                        $rootScope.$broadcast('drawTripRoute', vm.appointment.tripStops);
                        
                    }

                    if (vm.appointment.year && vm.appointment.make) {
                        consumerAppointmentService.getModelsForMakeInYear(vm.dealer.dealerId, vm.appointment.year, vm.appointment.make).then((models) => {
                            if (models) {
                                let dmsModel = $filter('filter')(models, {modelCode: vm.appointment.model}, true);

                                if (dmsModel && dmsModel.length > 0) {
                                    vm.appointment.selectedDMSModel = dmsModel[0];
                                }

                            } 
                        });
                    }

                    // w/out this, we sometimes are getting the chrome leave site message for no reason
                    $timeout(() => {
                        window.onbeforeunload = null;
                    }, 1);
                },
                (error) => {
                    // Error
                    if (error.status === 401)
                        $state.go('404NotFound');
                        
                    vm.errorLoadingAppointment = true;
                }).finally(() => {
                    
                    if (bookingMethod === CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.ghostGarage) {
                        let formEl = angular.element('.form-horizontal');

                        formEl.addClass('ghost-garage-booking');
                        vm.maxHeight = 195;
                    } else {
                        
                        $timeout(() => {
                            $rootScope.$broadcast('minimizeHeaderMap');
                        }, 1);
                    }
                    
                    vm.loading = false;
                });

            
        }

        function editAppointment() {
            vm.loadingEdit = true;

            consumerAppointmentService.getAppointment(vm.dealer.dealerId, vm.appointment.id, resolvedKey)
                .then((result) => {
                    vm.appointment.canEdit = result.canEdit;

                    if (result.canEdit) {
                        let appt = vm.appointment;

                        $state.go('consumer-appointment-booking', angular.extend({appointment: appt, appointmentId: appt.id, tripType: appt.tripType, key: resolvedKey}));
                    } else {
                        consumerModalService.showMessage('Error', 'This appointment cannot be edited at this time. Please contact the dealership if you have any questions.', true);
                        vm.loadingEdit = false;
                    }
                });
        }

        function cancelAppointment() {
            // Show cancel aside
            consumerAppointmentService.getAppointment(vm.dealer.dealerId, vm.appointment.id, resolvedKey)
                .then((result) => {
                    vm.appointment.canCancel = result.canCancel;

                    if (result.canCancel) {
                        consumerModalService.showCancelReason(true, "Cancel Appointment").then(
                            (reason) => {
                                // Cancel
                                vm.loading = true;
            
                                consumerAppointmentService.cancelAppointment(vm.dealer.dealerId, vm.appointment, reason, resolvedKey).then(
                                    (result) => {
                                        if (result && !result.errors) {
                                            vm.appointment.appointmentStatus = vm.canceledStatus; // Set status to cancelled
                                        } else if (result && result.errors && result.errors.length > 0) {
                                            // Translate the list of errors to html
                                            let errorMsg = '';

                                            for (let i = 0; i < result.errors.length; i++) {
                                                errorMsg += result.errors[i] + ',';
                                            }

                                            errorMsg = errorMsg.substr(0, errorMsg.length - 1);
                                            consumerModalService.showMessage('Error', 'Sorry, there was a problem canceling your appointment: ' + errorMsg, true);
                                        } else {
                                            consumerModalService.showMessage('Error', 'Sorry, there was a problem canceling your appointment.', true);
                                        }
                                    }).finally(() => {
                                        vm.loading = false;
                                    });
                            },
                            (result) => {
                                // Cancel - Do nothing
                            }
                        );
                    } else {
                        consumerModalService.showMessage('Error', 'This appointment cannot be canceled at this time. Please contact the dealership if you have any questions.', true);
                    }
                });
        }

        function showDealerDetails() {
            consumerModalService.showDealerDetails(vm.dealer);
        }
    }
})();

(function () {
    'use strict';

    consumerAppointmentBookingController.$inject = ["$rootScope", "$scope", "$transition$", "$state", "$window", "$filter", "$q", "$timeout", "rcUtilService", "appointmentLineItemClass", "ValidationService", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE", "SYSTEM_ENUMS", "CONSUMER_APPS_TYPE", "APPOINTMENTSTATUS_LABELS", "APPOINTMENT_CUSTOMERTYPE", "APPOINTMENT_TRANSPORTATION_TYPE", "resolvedDealerBranding", "resolvedAppointmentStatuses", "consumerAppointmentService", "modalService", "resolvedConsumerTripTypes", "resolvedRequiredDMSFields", "locationTransportationTypes", "appointmentClass", "dealerOpCodes", "appointmentUtilService", "resolvedKey", "resolvedDealerIntegrations", "consumerModalService", "resolvedDealerDepartments"];
    angular
        .module('redcap.consumer.appointments')
        .controller('ConsumerAppointmentBookingController', consumerAppointmentBookingController);

    function consumerAppointmentBookingController($rootScope, $scope, $transition$, $state, $window, $filter, $q, $timeout, rcUtilService, appointmentLineItemClass, 
            ValidationService, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE, SYSTEM_ENUMS, CONSUMER_APPS_TYPE, APPOINTMENTSTATUS_LABELS, APPOINTMENT_CUSTOMERTYPE, APPOINTMENT_TRANSPORTATION_TYPE, 
            resolvedDealerBranding, resolvedAppointmentStatuses, consumerAppointmentService, modalService, resolvedConsumerTripTypes, resolvedRequiredDMSFields,
            locationTransportationTypes, appointmentClass, dealerOpCodes, appointmentUtilService, resolvedKey, resolvedDealerIntegrations,
            consumerModalService, resolvedDealerDepartments) {

        let vm = this;
        let configValues = resolvedDealerBranding.configValues;
        let bookingMethod = consumerAppointmentService.getBookingMethod(configValues);
        let transitionParams = $transition$.params();
     
        vm.dealerDepartments = resolvedDealerDepartments;
        vm.chooseDeptButtonText = 'NEXT';
        vm.branding = configValues;
        vm.displayCapacityErrorMessaging = false;
        vm.showMapInMobile = consumerAppointmentService.getDisplayMapInMobile(configValues);
        vm.showMapFramedIn = consumerAppointmentService.getDisplayMapFramedIn(configValues);
        vm.resolvedConsumerTripTypes = resolvedConsumerTripTypes;
        vm.needsScheduleTransportationUpdate = false;
        
        if (bookingMethod === CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE.ghostGarage) {
            $state.go('consumer-appointment-ghostgarage-booking', transitionParams);

            return;
        }

        vm.loading = true;

        if (consumerAppointmentService.isDepartmentRankingCompleted(resolvedDealerDepartments)) {
            vm.rankedDepartments = $filter('filter')(resolvedDealerDepartments, {rank: ''});
        } else {
            vm.rankedDepartments = null;
        }

        vm.appointmentId = transitionParams.appointmentId;
       
        vm.department = transitionParams.department;

        vm.vehicleSelected = null;
        vm.departmentConstraints = null;
        vm.departmentHours = null;
        vm.tripLocationError = null;
        
        vm.dealerIntegrations = resolvedDealerIntegrations;
        
        vm.displayedTripLocations = null;
        vm.myValidation = new ValidationService();
        vm.configValues = resolvedDealerBranding.configValues;
        vm.apptTransporationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
        vm.transportationTypes = locationTransportationTypes;
        vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
        vm.apptConsumerDepartmentId = vm.configValues.apptConsumerDepartmentId;
        vm.defaultToPreviousAdvisor = vm.configValues.defaultToPreviousAdvisor;
        vm.apptConsumerOtherServicesTitle = vm.configValues.apptConsumerOtherServicesTitle;
        vm.apptConsumerAlternateServicesTitle = vm.configValues.apptConsumerAlternateServicesTitle;
        vm.apptPreviouslyDeclinedtitle = vm.configValues.consumerMobileDeclinedServicesParagraph;
        vm.isInFrame = consumerAppointmentService.isInFrame();
        vm.sysEnums = SYSTEM_ENUMS;
        vm.appTypes = CONSUMER_APPS_TYPE;
        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;      
        // Dealer settings
        vm.dealer = resolvedDealerBranding;
        vm.requiredDMSFields = resolvedRequiredDMSFields;

        vm.appStatuses = APPOINTMENTSTATUS_LABELS;
        vm.apptStatuses = resolvedAppointmentStatuses;
        vm.newStatus = _.find(vm.apptStatuses, {description: vm.appStatuses.new}).code;
        vm.disableServiceSelection = false;
        

        function filterDepartmentData() {
            consumerAppointmentService.filterDepartmentData(vm, resolvedConsumerTripTypes, dealerOpCodes, vm.appointment.departmentId);
        }

        vm.termsAndConditionsText = resolvedDealerBranding.termsPageText;
        vm.textOptInText = resolvedDealerBranding.configValues.desktopMarketingOptInCopyText;

        vm.headerImageUrl = vm.configValues.headerImageUrl;
        vm.confirmationFormSubmitted = false;
        vm.confirmation = false;
        vm.transmissions = SYSTEM_ENUMS.transmissions;

        // Appointment
        vm.appointment = null;
        vm.originalAppointmentLineItems = [];
        vm.tripType = transitionParams.tripType;
        vm.pickupLocation = transitionParams.pickupLocation;
        vm.loginEvent = transitionParams.eventData;
        vm.customerVehicles = null;
        vm.lastServiceAdvisor = null;

        if (transitionParams.appointment && transitionParams.appointment.vehicles) {
            vm.customerVehicles = transitionParams.appointment.vehicles;
        }

        if (transitionParams.appointment && transitionParams.appointment.lastServiceAdvisor && !vm.appointmentId) {
            vm.lastServiceAdvisor = transitionParams.appointment.lastServiceAdvisor;
        }

        vm.dealerConfigured = function () {
            return consumerAppointmentService.isDealerConfigured(vm.dealerOpCodes, vm.apptConsumerDepartmentId);
        };

        vm.startOver = function () {
            $window.location.reload();
        };
        
        vm.stateId = {
            landing: 0,
            booked: 1,
            vehicle: 2,
            services: 3,
            appointment: 4,
            confirmation: 5,
            changeDepartment: 6
        };

        vm.customerType = APPOINTMENT_CUSTOMERTYPE;

        // Page states
        vm.states = [
            {
                id: vm.stateId.vehicle,
                previousState: vm.appointmentId || (vm.appointment && vm.appointment.id) ? vm.stateId.booked : vm.stateId.landing,
                nextState: vm.stateId.services, //'Services',
                isValid: function () {
                    vm.vehicleFormSubmitted = true;

                    let validOwner = (!vm.vehicleOwnerForm || vm.vehicleOwnerForm.$validationSummary === undefined) ? true : vm.myValidation.checkFormValidity(vm.vehicleOwnerForm);
                    let appt = vm.appointment;
                    let validVehicle = false;
                    let validMileage;
                    let validState = true;

                    if (vm.requiredDMSFields.customerState && !appt.customerState) {
                        validState = false;
                    }

                    if (!appt.year || !appt.make || !appt.model) {
                        validVehicle = false;
                    } else if (appt.vehicleId) {
                        validVehicle = true;
                    } else {
                        validVehicle = (!vm.vehicleInformationForm || vm.vehicleInformationForm.$validationSummary === undefined) ? true : vm.myValidation.checkFormValidity(vm.vehicleInformationForm);
                    }

                    validMileage = appt.mileage !== null && appt.mileage !== "";

                    return validOwner && validVehicle && validMileage && validState;
                }
            },
            {
                id: vm.stateId.services,
                previousState: vm.stateId.vehicle,
                nextState: vm.stateId.appointment,
                isValid: function () {
                    $rootScope.$broadcast('validateServices', null);
                    let validServices =  vm.myValidation.checkFormValidity(vm.vehicleServicesForm);

                    return validServices && rcUtilService.isFormValid(vm.vehicleServicesForm);
                }
            },
            {
                id: vm.stateId.appointment,
                previousState: vm.stateId.services,
                nextState: vm.stateId.confirmation,
                isValid: function () {
                    vm.detailsFormSubmitted = true;
                    let lineItemCount = vm.appointment && vm.appointment.lineItems ? vm.appointment.lineItems.length : 0;

                    if (lineItemCount === 0) return false;
                    
                    let validDetails = vm.myValidation.checkFormValidity(vm.appointmentForm);
                    let hasServices = vm.appointment && vm.appointment.lineItems.length > 0;
                    let isManualValid = !(vm.tripType.isPickup && vm.appointment.isManual === null);
                    let isTripTypeValid = !!vm.tripType;

                    return validDetails && rcUtilService.isFormValid(vm.appointmentForm) && isManualValid && isTripTypeValid && hasServices;
                }
            },
            {
                id: vm.stateId.confirmation,
                previousState: vm.stateId.appointment,
                nextState: null,
                isValid: function () {
                    // Valid
                    if (vm.showTextOptInWarning() && !vm.appointment.mobileSmsOptedIn) return false;
                    
                    if (vm.confirmation) return true;

                    // Invalid
                    return false;
                }
            },
            {
                id: vm.stateId.changeDepartment,
                previousState: vm.stateId.services,
                nextState: vm.stateId.services,
                isValid: function () {
                    // Valid
                    if (vm.confirmation) return true;

                    // Invalid
                    return false;
                }
            }
        ];

        consumerAppointmentService.setCurrentState(vm, vm.stateId.vehicle);

        vm.showTheMap = function () {
            return consumerAppointmentService.showTheMap(vm.isInFrame, vm.showMapFramedIn);
        };
        
        vm.getCustomerVehicles = function () {
            let appt = vm.appointment;

            consumerAppointmentService.getCustomerVehicles(vm.dealer.dealerId, appt.customerId, resolvedKey).then((result) => {
                vm.customerVehicles = result;
                let vehicle = null;

                if (appt.vehicleId) {
                    vehicle = $filter('filter')(vm.customerVehicles, {vehicleId: appt.vehicleId}, true);

                    if (vehicle && vehicle.length > 0) {
                        vm.vehicleSelected = vehicle[0];

                        return;
                    }
                }

                if (appt.vin) {
                    vehicle = $filter('filter')(vm.customerVehicles, {vin: appt.vin}, true);

                    if (vehicle && vehicle.length > 0) {
                        vm.vehicleSelected = vehicle[0];

                        return;
                    }
                }

                if (appt.year || appt.make || appt.model) {
                    let appointmentYear = appt.year ? appt.year.toString() : null;
                    let appointmentMake = appt.make ? appt.make.toUpperCase() : null;
                    let appointmentModel = appt.model ? appt.model.toUpperCase() : null;

                    vehicle = $filter('filter')(vm.customerVehicles, (customerVehicle) => {
                        let customerVehicleYear = customerVehicle.year ? customerVehicle.year.toString() : null;
                        let customerVehicleMake = customerVehicle.make ? customerVehicle.make.toUpperCase() : null;
                        let customerVehicleModel = customerVehicle.model ? customerVehicle.model.toUpperCase() : null;

                        return customerVehicleYear === appointmentYear && customerVehicleMake === appointmentMake && customerVehicleModel === appointmentModel;
                    });

                    if (vehicle && vehicle.length > 0) {
                        vm.vehicleSelected = vehicle[0];
                    } else {
                        vm.vehicleSelected = {
                            make: appt.make,
                            model: appt.model,
                            year: appt.year,
                            vin: appt.vin
                        };
                    }
                }
            });
        };

        
        // Public functions
        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.createAppointment = createAppointment;
        vm.showDealerDetails = showDealerDetails;
        vm.originalAppointmentHasLoaner = false;

        
        function isOriginalAppointmentPickupLoaner () {
            vm.originalAppointmentHasLoaner = consumerAppointmentService.isOriginalAppointmentPickupLoaner(vm.appointment, vm.transportationTypes, vm.apptTransporationTypes.pickupLoaner);
        }

        function postLoadAppointment () {
            if (vm.appointment.customerId) {
                vm.getCustomerVehicles();
            }

            consumerAppointmentService.postLoadAppointment(vm);
        }

        function loadAppointment(result) {
            vm.appointment = appointmentClass.new(result);

            if (vm.dealerOpCodes) {
                vm.appointment = consumerAppointmentService.postProcessAPIAppointment(vm.appointment, vm.dealerOpCodes, vm.dealerDepartments, vm.previouslyDeclinedServices);
                vm.originalAppointmentLineItems = _.cloneDeep(vm.appointment.lineItems);
            }

            vm.appointment.yearMakeModelMismatch = false;
            isOriginalAppointmentPickupLoaner();
        }
        

        function init() {
            // Default appointment object
            let setStatus = function () {
                    if (!vm.appointment.appointmentStatus) {
                        vm.appointment.appointmentStatus = vm.newStatus;
                    }
                };

            let setTripType = function () {
                if (vm.appointment.dealerTransportationTypeId) {
                    vm.tripType = $filter('filter')(vm.transportationTypes, {id: vm.appointment.dealerTransportationTypeId}, true)[0];
                }
            };

            vm.displayedTripLocations = {
                locationList: transitionParams.displayedTripLocations
            };

            if (vm.appointment === null && transitionParams.appointment) {
                vm.appointment = appointmentClass.new(transitionParams.appointment);
                
                if (transitionParams.appointment && transitionParams.appointment.customerType === vm.customerType.business) {
                    vm.appointment.customerIsBusiness = true;
                    vm.appointment.customerType = vm.customerType.business;
                } else if (!vm.appointment.customerType) {
                    vm.appointment.customerType = vm.customerType.individual;
                }

                if (vm.appointment.departmentId) {
                    vm.department = $filter('filter')(resolvedDealerDepartments, {id: vm.appointment.departmentId}, true)[0];
                    filterDepartmentData();
                    $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
                } else if (vm.department) {
                    vm.appointment.departmentId = vm.department.id;
                    filterDepartmentData();
                    $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
                }

                vm.appointment.yearMakeModelMismatch = false;
                vm.appointment = consumerAppointmentService.postProcessAPIAppointment(vm.appointment, vm.dealerOpCodes, vm.dealerDepartments, vm.previouslyDeclinedServices);
                vm.originalAppointmentLineItems = _.cloneDeep(vm.appointment.lineItems);
                
                isOriginalAppointmentPickupLoaner();
                vm.appointment.originalApptHasRecallsOrRecMaint = false;
                postLoadAppointment();
                setTripType();
                setStatus();
                consumerAppointmentService.minimizeHeaderMap();

                if (vm.displayedTripLocations && vm.displayedTripLocations.locationList && vm.displayedTripLocations.locationList.length > 0) {
                    $timeout(() => {
                        consumerAppointmentService.displayTripLocations(vm.displayedTripLocations);
                    }, 1000);
                }

                vm.loading = false;
            } else if (vm.appointment === null && vm.appointmentId) {
                consumerAppointmentService.getAppointment(vm.dealer.dealerId, vm.appointmentId, resolvedKey).then(
                (result) => {
                    // Success
                    loadAppointment(result);

                    if (!vm.appointment.departmentId) {
                        if (vm.department) {
                            vm.appointment.departmentId = vm.department.id;
                        } else {
                            vm.appointment.departmentId = parseInt(vm.apptConsumerDepartmentId);
                            vm.department = $filter('filter')(resolvedDealerDepartments, {id: vm.appointment.departmentId}, true)[0];
                        }

                        $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
                    } else {
                        vm.department = $filter('filter')(resolvedDealerDepartments, {id: vm.appointment.departmentId}, true)[0];
                    }
                    
                    filterDepartmentData();
                    vm.appointment = consumerAppointmentService.postProcessAPIAppointment(vm.appointment, vm.dealerOpCodes, vm.dealerDepartments, vm.previouslyDeclinedServices);
                    vm.originalAppointmentLineItems = _.cloneDeep(vm.appointment.lineItems);
                    
                    postLoadAppointment();
                    setTripType();
                    setStatus();
                    consumerAppointmentService.loadTripRoute(true, vm.appointment);
                    consumerAppointmentService.minimizeHeaderMap();

                    if (vm.displayedTripLocations && vm.displayedTripLocations.locationList && vm.displayedTripLocations.locationList.length > 0) {
                        $timeout(() => {
                            consumerAppointmentService.displayTripLocations(vm.displayedTripLocations);
                        }, 1000);
                    }

                    vm.loading = false;
                },
                (error) => {
                    $state.go('404NotFound');
                }).finally(() => {
                    vm.loading = false;
                });
            } else if (vm.appointment === null) {
                vm.appointment = appointmentClass.new();

                if (!vm.appointment.customerType) {
                    vm.appointment.customerType = vm.customerType.individual;
                }

                if (vm.department) {
                    vm.appointment.departmentId = vm.department.id;
                    filterDepartmentData();
                }

                vm.appointment.yearMakeModelMismatch = false;
                vm.appointment.originalApptHasRecallsOrRecMaint = false;
                setStatus();
                consumerAppointmentService.minimizeHeaderMap();
                vm.loading = false;
            } else {
                vm.appointment.originalApptHasRecallsOrRecMaint = false;

                if (!vm.appointment.status) {
                    setStatus();
                }

                consumerAppointmentService.minimizeHeaderMap();
                vm.loading = false;
            }

            if (vm.appointment && !vm.appointment.departmentId) {
                if (vm.department) {
                    vm.appointment.departmentId = vm.department.id;
                } else {
                    vm.appointment.departmentId = parseInt(vm.apptConsumerDepartmentId);
                }

                filterDepartmentData();
                $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
            }

            
        }

        function getPreviouslyDeclinedServices () {
            consumerAppointmentService.getAndProcessPreviouslyDeclinedServices(vm);
        }

        function previousStep() {
            let prevState = vm.currentState.previousState;

            if (prevState !== null) {
                if (prevState === vm.stateId.landing) {
                    let confirm = modalService.showYesNo('Please Confirm', 'Are you sure you want to log out and start over?', 'No', 'Yes');

                    confirm.then((confirmed) => {
                        if (confirmed) {
                            $state.go('consumer-appointment-landing', angular.extend({}, $transition$));
                        } 
                    });
                } else if (prevState === vm.stateId.booked) {
                    $state.go('consumer-appointment-confirmation', angular.extend({appointmentId: vm.appointment.id, displayedTripLocations: vm.displayedTripLocations}, $transition$.params()));
                } else {
                    consumerAppointmentService.setCurrentState(vm, prevState);
                    vm.currentState.submitted = false;

                    if (prevState === vm.stateId.appointment) {
                        $rootScope.$broadcast('updateAvailability', true);
                    } else if (prevState === vm.stateId.services) {
                        vm.disableServiceSelection = false;
                    }
                }
            }
        }

        function displayCapacityErrorMessaging () {
            vm.displayCapacityErrorMessaging = true;
        }

        function validateCapacity () {
            vm.validatingCapacity = true;
            consumerAppointmentService.validateCapacity(vm.dealer.dealerId, vm.appointment, vm.previouslyDeclinedServices).then(
                (result) => {
                    if (result.errors) {
                        displayCapacityErrorMessaging();
                        vm.validatingCapacity = false;

                        return;
                    }
 
                    vm.validatingCapacity = false;
                },
                (error) => {
                    displayCapacityErrorMessaging();
                    vm.validatingCapacity = false;

                    return;
                }).finally(() => { 
                    vm.validatingCapacity = false;
                });
        }

        function loadRecallsAndRecMaintAndPrevDeclined () {
            consumerAppointmentService.loadRecallsRecMaintPrevDeclined(vm);
        }

        // if new department was selected, attemp to match up the transportation selection 
        // from the old department to the new department
        function swapTransportationSelection (oldDeptId, newDeptId) {
            let currentTransportationType = null;
            let currentSystemTransportationTypeId = null;
              
            if (vm.appointment.dealerTransportationTypeId) {
                currentTransportationType = $filter('filter')(vm.transportationTypes, {id: vm.appointment.dealerTransportationTypeId}, true);

                if (currentTransportationType && currentTransportationType.length > 0) {
                    currentSystemTransportationTypeId = currentTransportationType[0].dealerSystemTransportationTypeId;
                }
            }
			
			// have to do this in case we're switching departments
            if (currentSystemTransportationTypeId) {
                let tripType = $filter('filter')(vm.transportationTypes, {dealerSystemTransportationTypeId: currentSystemTransportationTypeId, dealerDepartmentId: newDeptId, showInConsumer: true}, true);

                if (tripType && tripType.length > 0) {
                    vm.tripType = tripType[0];
                    vm.appointment.dealerTransportationTypeId = vm.tripType.id;
                } else {
                    vm.tripType = null;
                    vm.appointment.dealerTransportationTypeId = null;
                }
            }

        }

        function nextStep() {
            vm.busy = true;

            let currentState = vm.currentState;

            let goToNextPage = function () {
                    if (currentState.nextState) {
                        $window.scrollTo(0, 0); // ensure that customer is on top of page
                        consumerAppointmentService.setCurrentState(vm, vm.currentState.nextState);
                        vm.busy = false;
                        vm.currentState.submitted = false;
                    }
                };

            if (!currentState.isValid()) {
                vm.currentState.submitted = true;
                vm.busy = false;

                return;
            }

            let checkPhoneAndFinish = function () {
                if (phoneType.type === vm.phoneTypes.landline) {
                    phoneWarning = modalService.showLandlineWarning;
                } else if (phoneType.type === vm.phoneTypes.voip) {
                    phoneWarning = modalService.showVoIPWarning;
                }

                phoneWarning().then(() => {
                    if (!vm.appointment.customerType) {
                        vm.appointment.customerType = vm.customerType.individual;
                    }

                    if (vm.appointment.selectedDMSMake && vm.appointment.selectedDMSModel) {
                        loadRecallsAndRecMaintAndPrevDeclined();
                    } else {
                        getPreviouslyDeclinedServices();
                    }

                    goToNextPage();
                });
            };

            if (currentState.id === vm.stateId.vehicle) {
                var phoneWarning = $q.when;  // Do not show any warning
                    var phoneType = vm.customerPhoneType;

                if (!phoneType) {
                    vm.busy = false;

                    return;
                } 
                
                if (!vm.tripType.isDropOff && vm.pickupLocation) {
                    vm.appointment.tripPickupLocation = vm.pickupLocation.location;
                } else if (vm.tripType.isDropOff) {
                    vm.appointment.tripPickupLocation = null;
                }

                if (!vm.appointment.id && !vm.appointment.customerId) {
                    consumerAppointmentService.getCustomer(vm.dealer.dealerId, vm.appointment.customerEmail, vm.appointment.customerPhone)
                    .then((customer) => {
                        if (customer) {
                            // exact match found in dms, use the customer number.
                            vm.appointment.customerId = customer.custNo;
                        }

                        checkPhoneAndFinish();
                    });
                } else {
                    checkPhoneAndFinish();
                }
                
            } else if (currentState.id === vm.stateId.services) {
                vm.disableServiceSelection = true;
                consumerAppointmentService.getDefaultDepartment(vm.dealer.dealerId, vm.appointment)
                    .then((response) => {
                        vm.appointment.canUseDefaultDepartment = response.canUseDefaultDepartment;
                        vm.appointment.defaultDealerDepartmentId = response.defaultDealerDepartmentId;
                        let defaultDepartment = $filter('filter')(resolvedDealerDepartments, {id: response.defaultDealerDepartmentId}, true)[0];

                        if (vm.appointment.canUseDefaultDepartment && vm.appointment.departmentId !== vm.appointment.defaultDealerDepartmentId && !defaultDepartment.isDisabled) {
                            // We need to repopulate the time slots
                            let confirm = modalService.showYesNo('Warning', "We're sorry, based on your service selections, this appointment can only be booked in our <b>" + defaultDepartment.name + "</b> Department.  Note some transportation options might not be available.<br/><br/>Click OK to continue or CANCEL to add or change your services.", 'Cancel', 'OK');

                            confirm.then((confirmed) => {
                                if (confirmed) {
                                    swapTransportationSelection(vm.appointment.departmentId, response.defaultDealerDepartmentId);
                                    goToNextPage();
                                    vm.appointment.departmentId = response.defaultDealerDepartmentId;
                                    $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);

                                    if (consumerAppointmentService.requiresCapacityValidation(vm, true) === false) {
                                        vm.appointment.bypassValidation = true;
                                    } else {
                                        // we need to fire off a capacity check before going to the next page
                                        // and display error messaging if they've lost their slot
                                        validateCapacity();
                                    }

                                    $rootScope.$broadcast('updateAvailability', false);
                                } else {
                                    vm.busy = false;
                                }
                            });
                        } else {

                            if (consumerAppointmentService.requiresCapacityValidation(vm, true) === false) {
                                vm.appointment.bypassValidation = true;
                            } else {
                                // we need to fire off a capacity check before going to the next page
                                // and display error messaging if they've lost their slot
                                validateCapacity();
                            }

                            goToNextPage();
                            $rootScope.$broadcast('updateAvailability', false);
                        }
                    });
            } else {
                goToNextPage();
            }
            
        }

        function createAppointment() {
            vm.confirmationFormSubmitted = true;

            if (!vm.currentState.isValid()) {
                return;
            }

            vm.loading = true;

            // Convert to AP appointment type
            vm.appointment.dealerTransportationTypeId = vm.tripType.id;
            $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);

            if (!vm.appointment.departmentId && vm.department) {
                vm.appointment.departmentId = vm.department.id;
                $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
            }
        
            if (vm.pickupLocation) {
                vm.appointment.tripPickupLocation = vm.pickupLocation.location;
                appointmentUtilService.createTripCustomer(vm.appointment);
            } else if (vm.tripType.isDropOff) {
                vm.appointment.tripPickupLocation = null;
            }

            if (!vm.appointment.id) {
                vm.appointment.addingNew = true;
            } else {
                vm.appointment.addingNew = false;
            }

            consumerAppointmentService.createAppointment(vm.dealer.dealerId, vm.appointment, vm.previouslyDeclinedServices).then(
                (result) => {
                    if (result && !result.errors) {
                        gotoConfirm(result);
                    } else if (result && result.errors && result.errors.length > 0) {
                        vm.loading = false;
                        modalService.showError('Sorry, there was a problem booking your appointment:', result.errors);
                    } else {
                        consumerAppointmentService.genericCreateApptError(vm);
                    }
                },
                (error) => {
                    // Error
                    consumerAppointmentService.genericCreateApptError(vm);
                }).finally(() => { });
        }

        vm.cancelChangeDepartment = function () {
            consumerAppointmentService.setCurrentState(vm, vm.stateId.services);
        };

        vm.gotoChangeDepartment = function () {
            consumerAppointmentService.setCurrentState(vm, vm.stateId.changeDepartment);
        };

        function gotoConfirm(result) {
            loadAppointment(result);
            $state.go('consumer-appointment-confirmation', {appointment: vm.appointment, appointmentId: vm.appointment.id, dealerId: transitionParams.dealerId, tripType: vm.tripType, key: vm.appointment.urlKey});
        }

        function showDealerDetails() {
            consumerModalService.showDealerDetails(vm.dealer);
        }

        vm.updateYMM = function (origValue) {
            return appointmentUtilService.updateYMM(origValue, vm.appointment);
        };

        vm.isYMMSameAsOriginalApptYMM  = function (year, make, model) {
            return appointmentUtilService.isYMMSameAsOriginalApptYMM(year, make, model, vm.originalApptYear, vm.originalApptMake, vm.originalApptModel);
        };

        vm.gettingServices = function () {
            return vm.retrievingRecalls || vm.gettingPreviouslyDeclinedServices;
        };

        vm.showTermsWarning = function () {
            // ghis validation is not working correctly w/ the checkbox
            // if you check it and then uncheck it.. it's passing as if checked
            if (!vm.confirmation && vm.confirmationFormSubmitted) {
                return true;
            }

            return false;
        };

        vm.showTextOptInWarning = function () {
            // ghis validation is not working correctly w/ the checkbox
            // if you check it and then uncheck it.. it's passing as if checked
            if (!vm.appointment.mobileSmsOptedIn && vm.confirmationFormSubmitted) {
                return true;
            }

            return false;
        };

        vm.pickUpChanged = function () {
            vm.showUpdateWarning();
            consumerAppointmentService.pickupChanged(vm.tripType, vm.pickupLocation, vm.dealer, vm.checkingIsInServiceArea);
        };

        vm.showUpdateWarning = function (ignoreUpdateWarning = false) {
            if (ignoreUpdateWarning) return;

            if (!vm.needsScheduleTransportationUpdate) {
                modalService.showYesNo('Warning', 'Changing certain appointment details may result in your date or time no longer being available.<br/>If you have questions, please contact us.<br/><br/>Are you sure you want to continue with these changes?', 'YES', 'NO');
                vm.needsScheduleTransportationUpdate = true;
            }

            $rootScope.$broadcast('updateApptSchedule');
        };

        $scope.$on('showUpdateWarning', (e, newValue) => {
            let isApptEdit = vm.appointmentId || (vm.appointment && vm.appointment.id);

            vm.showUpdateWarning(!isApptEdit);
        });

        $scope.$on('updateTripLocations', (e, newValue) => {
            vm.displayedTripLocations = newValue;
            vm.tripLocationError = null;
        });

        $scope.$on('updateTripLocationError', (e, newValue) => {
            vm.tripLocationError = newValue;
        });
        
        $scope.$on('transportationTypeChanged', (e, newValue) => {
            vm.tripType = newValue;
        });

        $scope.$on('pickUpChanged', (e, newValue) => {
            if (newValue) {
                vm.pickupLocation = newValue.pickUp;
            } else {
                vm.pickupLocation = null;
            }

            vm.pickUpChanged();
        });

        $scope.$on('customerPhoneTypeChanged', (e, newValue) => {
            vm.customerPhoneType = newValue;
            vm.appointment.invalidPhone = !vm.customerPhoneType;
        });

        $scope.$on('pickUpDateTimeChanged', (e, newValue) => {
            consumerAppointmentService.pickupDateTimeChanged(vm.appointment, vm.tripType, vm.pickupLocation, vm.dealer, newValue);
        });

        $scope.$on('timeChanged', (e, newValue) => {
            vm.displayCapacityErrorMessaging = false;
        });

        $scope.$on('vehicleUpdated', (e, newValue) => {
            let appt = vm.appointment;

            vm.appointment.yearMakeModelMismatch = !vm.isYMMSameAsOriginalApptYMM(appt.year, appt.make, appt.model);
        });

        $scope.$on('gotoChangeDepartment', (e, newValue) => {
            vm.gotoChangeDepartment();
        });

        vm.getRecMainTooltip = function (apps) {
            return appointmentUtilService.getRecMainTooltip(apps);
        };

        $scope.$on('departmentUpdated', (e, newValue) => {
            if (vm.lastDepartmentId !== newValue) {
                vm.lastDepartmentId = newValue;
                consumerAppointmentService.updateDepartmentHours(vm.dealer.dealerId, newValue, vm.departmentHours, vm.loadingDepartmentHours);
                filterDepartmentData();
            }
        });

        $scope.$on('departmentHoursUpdated', (e, newValue) => {
            vm.departmentHours = newValue;
        });

        $scope.$on('departmentConstraintsUpdated', (e, newValue) => {
            vm.departmentConstraints = newValue;
            vm.processedClosedConstraints = consumerAppointmentService.processClosedConstraints(vm.departmentConstraints);
        });

        $scope.$on('servicesUpdated', (e, newValue) => {
            vm.servicesModified = true;
            appointmentUtilService.processServicesUpdated(newValue, vm.appointment, vm.originalAppointmentLineItems, vm.dealer, vm.dealerOpCodes, vm.recalls, vm.recMaintData);
        });

        $scope.$on('departmentGetStartedClicked', (e, newValue) => {
            if (newValue) {
                let refilterDepartmentData = false;

                if (newValue.department.id !== vm.appointment.departmentId) {
                    refilterDepartmentData = true;
                    vm.appointment.advisor = null;
                    vm.appointment.dealerEmployeeFirstName = null;
                    vm.appointment.dealerEmployeeLastName = null;
                    vm.appointment.dealerEmployeeId = null;
                    vm.appointment.dealerEmployeeOfficePhone = null;
                    vm.appointment.serviceAdvisorNumber = null;
                }

                vm.tripType = newValue.tripType;
                vm.appointment.dealerTransportationTypeId = newValue.tripType.id;
                vm.appointment.departmentId = newValue.department.id;
                
                // need to call this to set or clear department mismatch flags
                vm.appointment = consumerAppointmentService.postProcessAPIAppointment(vm.appointment, vm.dealerOpCodes, vm.dealerDepartments, vm.previouslyDeclinedServices);
                

                vm.pickupLocation = newValue.pickupLocation;
                consumerAppointmentService.setCurrentState(vm, vm.stateId.services);

                if (refilterDepartmentData === true) {
                    $rootScope.$broadcast('departmentUpdated', vm.appointment.departmentId);
                    consumerAppointmentService.loadRecallsRecMaintPrevDeclined(vm);
                }
            }
        });


        init();

    }
})();


(function () {
    'use strict';

    CheckInVerifyVehicleController.$inject = ["$q", "azureBlob", "rcUtilService", "vehicleService", "appointmentUtilService", "locationService", "SYSTEM_ENUMS", "APPOINTMENT_PHOTOTYPE", "APPOINTMENT_APPOINTMENTSTATUS", "modalService", "appointmentService", "$log", "$scope"];
    angular
        .module('redcap.appointment')
        .component('checkinVerifyVehicle', {
            templateUrl: 'app/areas/checkin/components/verify-vehicle/checkin-verify-vehicle.view.html',
            controller: CheckInVerifyVehicleController,
            controllerAs: 'vm',
            bindings: {
                appointment: '=',
                serviceAdvisors: '=',
                isLoading: '=',
                registerStepFn: '&',
                hasCheckinDataChanged: '&'
            }
        });

    function CheckInVerifyVehicleController($q, azureBlob, rcUtilService, vehicleService, appointmentUtilService, locationService, SYSTEM_ENUMS, APPOINTMENT_PHOTOTYPE, APPOINTMENT_APPOINTMENTSTATUS, modalService, appointmentService, $log, $scope) {
        this.$onInit = function() {
            let vm = this;
            let lastRecordedMileage = 0;
            let isLastRecordedMileageSet = false;
            let isOdometerValid = true;

            vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.selectedAdvisor = null;        
            vm.imageToUpload = {};
            vm.newIssueDescription = '';
            vm.vehicleConditions = [];
            vm.validation = {
                validVin: function (vin) {
                    return rcUtilService.isValidVin(vin);
                },
                validatePredefinedImages: function() {
                    const hasIncompleteImages = vm.predefinedImages?.some(category => category.isRequired && category.images.some(imageItem => !imageItem.imageId));

                    return !hasIncompleteImages;
                },
                validOdometer: function () {
                    return isOdometerValid;
                }
            };

            vm.openVinScan = function () {
                modalService.showVinScanModal().then((scannedVin) => {
                    vm.appointment.vin = scannedVin;
                });
            };

            // TODO: refactor all of the image upload code into one component at a later time. This code is duplicated 95% of the places
            //  it's used.
            vm.upload = function ($model, file, $files, $event, $id, reference, container, forceAdd, forPredefinedImage) {
                const deferred = $q.defer();

                // TODO: WTF is "forceAdd"
                const isExistingImage = $model.imageId && $model.url;
                const imageTokenPromise = isExistingImage ?
                                             appointmentService.getImageToken(vm.appointment.dealerId, APPOINTMENT_PHOTOTYPE.vehicleCondition, $model.imageId) :
                                             appointmentService.getImageToken(vm.appointment.dealerId, APPOINTMENT_PHOTOTYPE.vehicleCondition);

                imageTokenPromise.then((imageData) => {
                    const config = {
                        baseUrl: $model.url || imageData.url,
                        file: file,
                        complete: function() {
                            $model.imageType = APPOINTMENT_PHOTOTYPE.vehicleCondition;
                            $model.fileExtension = file.type;
                            $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);

                            function processImage() {
                                if (isExistingImage) {
                                    return editImage(vm.vehicleConditions, reference.index, $model);
                                } else {
                                    $model.imageId = imageData.imageId;
                                    $model.url = imageData.url;
                                    $model.dateTaken = new Date();  
                                    $model.id = reference?.id;
                                    
                                    vm.imageToUpload = {};     

                                    if (forPredefinedImage) {
                                        // If this is for predefinedImage
                                        return appointmentService.saveConditionsPredefinedImages(vm.appointment.dealerId, vm.appointment.id, $model).then((conditions) => {
                                            const imageToUpdate = vm.predefinedImages.flatMap((condition) => condition.images).find((image) => image.id === $model.id);

                                            if (imageToUpdate) {
                                                imageToUpdate.url = $model.url;
                                                imageToUpdate.imageId = $model.imageId;
                                                imageToUpdate.imageType = $model.imageType;
                                                imageToUpdate.dateTaken = $model.dateTaken;
                                                imageToUpdate.fileExtension = $model.fileExtension;
                                            }                                           

                                            return conditions;
                                        });
                                    } else {
                                        return Promise.resolve(true);
                                    }
                                }
                            }

                            processImage().then(() => {
                                saveVehicleConditions();
                                
                                deferred.resolve(_.cloneDeep($model));
                            }).catch((error) => {
                                deferred.reject(error);
                            }).finally(() => {
                                vm.isLoading = false;
                            });                                                        
                        },
                        error: function(err) {
                            deferred.reject(err);
                            vm.isLoading = false;
                        },
                        blockSize: 4000000000
                    };

                    azureBlob.upload(config);
                });

                return deferred.promise;
            };

            vm.uploadPredefinedImage = function ($model, file, $files, $event, $id, reference, container, forceAdd) {
                return vm.upload($model, file, $files, $event, $id, reference, container, forceAdd, true);
            };

            vm.getMediaType = function (fileExtension) {
                return appointmentUtilService.getMediaType(fileExtension);
            };

            vm.addDescription = function () {
                let newIndex = 0;

                if (vm.vehicleConditions.length > 0) {
                    newIndex = Math.max(...vm.vehicleConditions.map((o) => { return o.index; })) + 1;
                }

                vm.vehicleConditions.push({index: newIndex, description: vm.newIssueDescription, images: []});
                vm.newIssueDescription = '';

                saveVehicleConditions();
            };

            vm.removeVehicleCondition = function (index) {
                const confirm = modalService.showYesNo('Please Confirm', 'Are you sure you want to delete this Vehicle Condition?', 'No', 'Yes');

                confirm.then((confirmed) => {
                    if (confirmed) {
                        vm.vehicleConditions.splice(index, 1);
                        saveVehicleConditions();
                    }
                });
            };
        
            vm.openImageModal = function (url, description, mediaType, imageId) {
                if (imageId) {
                    modalService.showImageViewer(url, description, mediaType, null, () => {
                        vm.isLoading = true;

                        appointmentService.deleteConditionsImage(vm.appointment.dealerId, vm.appointment.id, imageId).then((response) => {
                            vm.predefinedImages = response;
                            vm.validation.validatePredefinedImages();
                        }).catch((error) => {
                            console.log(error);
                        }).finally(() => {
                            vm.isLoading = false;
                        });
                    });
                } else {
                    modalService.showImageViewer(url, description, mediaType);
                }
            };

            vm.checkValidVin = function() {
                let vin = vm.appointment.vin;
               
                if (vin && vin.trim().length === 17) {
                    isOwnedByOtherCustomer();

                    vehicleService.decodeVin(vm.appointment.dealerId, vin).then((response) => {
                        if (response && response.baseVehicleID) {
                            vm.appointment.year = response.year;
                            // Note: it's possible this may cause issues with CDK Implementation
                            // if so, we may need to modify this to look up the vehicles with the vehicle service
                            // for this dealer if the DMS is CDK and attempt to match the make/model to what they have
                            vm.appointment.makeName = response.makeName;
                            vm.appointment.make = response.makeName;
                            vm.appointment.modelName = response.modelName;
                            vm.appointment.model = response.modelName;
                            lastRecordedMileage = parseInt(response.lastRecordedMileage, 10) || 0;
                            isLastRecordedMileageSet = true;
                        }
                    }).catch((error) => {
                        console.error('Error decoding VIN:', error);
                    });
                }
            };

            function isOwnedByOtherCustomer () {
                if (vm.appointment.customerId && vm.appointment.customerId !== -998) {
                    vehicleService.isOwnedByOtherCustomer(vm.appointment.dealerId, vm.appointment.vin, vm.appointment.customerId).then((response) => {
                        if (response === true) {
                            modalService.showYesNo('Warning', 'This VIN is associated with another customer.  If you continue, the VIN will be associated with this customer.', null, 'OK');
                        }
                    });
                }                
            }

            function saveVehicleConditions() {
                vm.isLoading = true;

                appointmentService.saveVehicleConditionImage(vm.appointment.dealerId, vm.appointment.id, vm.vehicleConditions).then((savedConditions) => {
                    vm.vehicleConditions.forEach((condition) => {
                        if (!condition.id) {
                            condition.id = savedConditions.find((c) => c.description === condition.description)?.id;
                        }
                    });
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    vm.isLoading = false;
                });
            }

            function editImage (allConditions, vehicleConditionId, image) {
                return appointmentService.editVehicleConditionImage(vm.appointment.dealerId, vm.appointment.id, allConditions, vehicleConditionId, image);
            }

            function processStep() {
                if (vm.hasCheckinDataChanged()) {
                    vm.appointment.disableNotifications = true;
                    vm.appointment.disableSendLoanerHomework = true;                   

                    return appointmentService.createOrUpdateAppointment(vm.appointment.dealerId, vm.appointment).then((result) => {
                        let modal = null;
        
                        if (result?.dmsSyncError) {
                            modal = modalService.showDetailedErrorDlg(result.dmsSyncError, true);
                        } else if (result?.errors?.length > 0) {
                            modal = modalService.showError('Sorry, there was a problem saving your appointment:', result.errors);
                        }

                        if (modal) {
                            return modal.then(() => { return Promise.resolve(); });
                        } else {
                            return result;
                        }                
                    });
                } else {
                    return Promise.resolve();
                }
            }

            function init() {
                vm.isLoading = true;

                const conditionPromise = appointmentService.getVehicleConditionImages(vm.appointment.dealerId, vm.appointment.id).then((issues) => {
                    vm.vehicleConditions = appointmentUtilService.processVehicleConditions(issues, true);
                });

                const predefinedImagePromise = locationService.getPredifinedMediaConfigs(vm.appointment.dealerId, vm.appointment.id).then((images) => {
                    vm.predefinedImages = images;
                });

                Promise.all([conditionPromise, predefinedImagePromise]).catch((err) => { 
                    console.log('Error loading conditions and images', err);
                }).finally(() => {
                    vm.isLoading = false;
                });

                vm.registerStepFn()(processStep);
            }

            init();

            function validateOdometer(odometer) {
                if (odometer < lastRecordedMileage) {
                    isOdometerValid = false;
                    vm.odometerError = `Must be greater than last value of ${lastRecordedMileage}.`;
                } else {
                    isOdometerValid = true;
                    vm.odometerError = null;
                }
            }

            vm.checkValidOdometer = function (odometer) {
                if (!odometer) return;
                
                isOdometerValid = false;

                if (isLastRecordedMileageSet) {
                    validateOdometer(odometer);                    
                } else {
                    vehicleService.decodeVin(vm.appointment.dealerId, vm.appointment.vin).then((response) => {
                        if (response) {
                            lastRecordedMileage = parseInt(response.lastRecordedMileage, 10) || 0;
                            isLastRecordedMileageSet = true;
                        }

                        validateOdometer(odometer);
                        
                        $scope.$broadcast('angularValidation.revalidate', 'odometer');
                    }).catch((error) => {
                        isOdometerValid = true;
                        $log.error('Error decoding VIN for mileage check:', error);
                    });
                }
            };
        };
    }
})();


(function () {
    'use strict';

    CheckInServiceCardController.$inject = ["$q", "locationService", "azureBlob", "appointmentService", "appointmentUtilService", "rcUtilService", "APPOINTMENT_PAYTYPES", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .component('checkinServiceCard', {
            templateUrl: 'app/areas/checkin/components/service-card/checkin-service-card.view.html',
            controller: CheckInServiceCardController,
            controllerAs: 'vm',
            bindings: {
                services: '=',
                service: '=',
                serviceGroup: '<',
                department: '<',
                appointment: '=',
                dispatchCodes: '<',
                requireDispatchCode: '<',
                dealerServiceTypes: '<',
                checkinSettings: '<'
            }
        });

    function CheckInServiceCardController($q, locationService, azureBlob, appointmentService, appointmentUtilService, rcUtilService, APPOINTMENT_PAYTYPES, SYSTEM_ENUMS) {
        this.$onInit = function() {
            let vm = this;
            const opCodeResultsPageSize = 25;

            vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
            vm.serviceGroupTypes = SYSTEM_ENUMS.serviceGroupTypes;
            vm.payTypes = APPOINTMENT_PAYTYPES;
            vm.imageTypes = appointmentUtilService.getImageTypes();
            vm.lineItemSeverities = SYSTEM_ENUMS.lineItemSeverity;
            vm.service.domId = rcUtilService.getRandomNumber();
            vm.maxNoteLength = appointmentUtilService.getNoteMaxLength(vm.appointment.dealerDMSSystem);
            vm.validation = {
                valDecimal: function(value, exactDecimalPlaces) {
                    return appointmentUtilService.validateDecimal(value, vm.service, exactDecimalPlaces);
                },
                // TODO: come back to this... really don't like having to pass in all exsting services... see if there's a way to do this 
                //  using the data that's on the appointment already... or in the parent (add services) component
                valOpCode: function() {
                    return appointmentUtilService.validateDashboardOpCode(vm.services, vm.opCodes, vm.service.opCode, vm.service, vm.appointment.dealerDMSSystem);
                }
            };

            vm.serviceSelected = function() {
                if (vm.service.serviceGroupType === vm.serviceGroupTypes.manuallyAdded) {
                    const emptyManualItems = vm.services.filter((service) => service.serviceGroupType === vm.serviceGroupTypes.manuallyAdded && !service.opCode);

                    if (vm.service.isSelected && emptyManualItems.filter((service) => !service.isSelected).length === 0) {
                        vm.services.push({name: 'New Item', serviceGroupType: vm.serviceGroupTypes.manuallyAdded});
                    }
                } else if (vm.service.serviceGroupType === vm.serviceGroupTypes.recommendedMaintenance) {
                    const maintenanceServices = vm.services.filter((service) => service.serviceGroupType === vm.serviceGroupTypes.recommendedMaintenance);
                    const shouldDeselect = vm.service.isSelected && vm.serviceGroup.selectedService.domId === vm.service.domId;

                    maintenanceServices.forEach((service) => {
                        service.isSelected = false;
                    });

                    if (shouldDeselect) {
                        vm.service.isSelected = false;
                        vm.serviceGroup.selectedService = null;
                    } else {
                        vm.service.isSelected = true;
                    }
                }

                const countShift = vm.service.isSelected || vm.serviceGroup.selectedService ? 1 : -1;

                vm.checkinSettings.selectedServicesCount = vm.checkinSettings.selectedServicesCount + countShift;
            };

            vm.opCodeSearchQuery = {
                type: 'GET',
                dataType: 'json',
                data: function(parameters) {
                    let query = {
                        search: parameters.term,
                        dealerId: vm.appointment.dealerId,
                        page: parameters.page,
                        pageSize: opCodeResultsPageSize
                    };

                    return query;
                },
                transport: function(params, success, failure) {
                    let data = params.data;

                    return locationService.searchLocationOpCodes(vm.appointment.dealerId, vm.appointment.departmentId, data.search, data.page, data.pageSize, true).then(success, failure);
                },
                delay: 800,
                processResults: function(data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === opCodeResultsPageSize
                        }
                    };
                }
            };

            vm.formatOpCodeForSelection = function(item) {
                return appointmentUtilService.formatOpCodeSearchForSelection(item);
            };

            vm.formatOpCodeForDropdown = function(item) {
                return appointmentUtilService.formatOpCodeForDropDown(item);
            };

            vm.opCodeSelected = function(selectedOpCode) {
                appointmentUtilService.processDashboardOpCodeSearchSelected(vm.service, selectedOpCode, vm.appointment.dealerDMSSystem, vm.department?.defaultDispatchCode, true);              
            };
            
            vm.upload = function  ($model, file, $files, $event, $imageType, reference, forceAdd) {
                let deferred = $q.defer();
                let imageType = vm.imageTypes[$imageType];

                appointmentService.getImageToken(vm.appointment.dealerId, imageType).then((result) => {
                    let config = {
                        baseUrl: result.url,
                        file: file,
                        complete: function () {
                            $model.imageId = result.imageId;
                            $model.url = result.url;
                            $model.fileExtension = file.type;
                            $model.dateTaken = new Date();
                            $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);

                            const clonedImageData = _.cloneDeep($model);

                            if (!vm.service.images)
                                vm.service.images = [];

                            vm.service.images.push(clonedImageData);

                            deferred.resolve('Upload successful');
                        },
                        error: function(err) {
                            deferred.reject(err);
                        },
                        blockSize: 4000000000
                    };

                    azureBlob.upload(config);
                }).catch((err) => {
                    console.error('Error getting image token.', err);
                });

                return deferred.promise; 
            };    
        };
    }
})();


(function () {
    'use strict';

    CheckInVerifyCustomerController.$inject = ["appointmentUtilService", "modalService", "appointmentService", "locationService", "APPOINTMENT_APPOINTMENTSTATUS"];
    angular
        .module('redcap.appointment')
        .component('checkinVerifyCustomer', {
            templateUrl: 'app/areas/checkin/components/verify-customer/checkin-verify-customer.view.html',
            controller: CheckInVerifyCustomerController,
            controllerAs: 'vm',
            bindings: {
                appointment: '=',
                serviceAdvisors: '=',
                appointmentStatuses: '<',
                dealerDepartments: '<',
                customerPhoneChanged: '&',
                registerStepFn: '&',
                hasCheckinDataChanged: '&'
            }
        });

    function CheckInVerifyCustomerController(appointmentUtilService, modalService, appointmentService, locationService, APPOINTMENT_APPOINTMENTSTATUS) {
        this.$onInit = function() {
            let vm = this;

            vm.lastContactPhoneNumber = vm.appointment.customerPhone;
            vm.selectedAdvisor = null;

            vm.activeDepartmentFilter = function(dept) {
                return dept.isDisabled === false || (vm.appointment.departmentId === dept.id);
            };

            vm.advisorChanged = function () {
                if (vm.selectedAdvisor && vm.selectedAdvisor.id) {
                    vm.appointment.dealerEmployeeId = vm.selectedAdvisor.id;
                    vm.appointment.serviceAdvisorNumber = vm.selectedAdvisor.employeeNumber;
                } else {
                    vm.appointment.dealerEmployeeId = null;
                }
            };
    
            vm.validation = {
                isValidDepartment: function () {
                    return appointmentUtilService.validateDepartment(vm.dealerDepartments, vm.appointment.departmentId);
                }
            };
            
            vm.getAdvisorAvailTime = function(advisor) {
                return appointmentService.getAdvisorAvailTime(vm.appointment, advisor);
            };
    
            vm.mobilePhoneUpdated = function (phoneNumber, loadingFromRecord) {
                if (vm.lastContactPhoneNumber !== phoneNumber) {
                    vm.lastContactPhoneNumber = phoneNumber;
    
                    if (phoneNumber) {
                        vm.customerPhoneChanged();
                    }
                }
            };
    
            vm.departmentChanged = function() {
                if (vm.appointment.departmentId) {
                    locationService.getLocationDepartmentAvailAdvisor(vm.appointment.dealerId, vm.appointment.departmentId, true).then((response) => {
                        vm.serviceAdvisors = response?.advisors || [];
                    });
                } else {
                    vm.serviceAdvisors = [];
                }
            };

            function setAdvisor () {
                if (vm.appointment.dealerEmployeeId) {
                    let advisor = vm.serviceAdvisors.find((a) => a.id === vm.appointment.dealerEmployeeId);
        
                    if (advisor) {
                        vm.selectedAdvisor = advisor;
                        vm.advisorChanged();
                    }
                } else if (vm.serviceAdvisors.length === 1) {
                    vm.selectedAdvisor = vm.serviceAdvisors[0];
                    vm.advisorChanged();
                }
            }

            function processStep() {
                if (vm.hasCheckinDataChanged()) {
                    vm.appointment.appointmentStatus = APPOINTMENT_APPOINTMENTSTATUS.checkingIn;
                    vm.appointment.disableNotifications = true;
                    vm.appointment.disableSendLoanerHomework = true;                   

                    return appointmentService.createOrUpdateAppointment(vm.appointment.dealerId, vm.appointment).then((result) => {
                        let modal = null;
        
                        if (result?.dmsSyncError) {
                            modal = modalService.showDetailedErrorDlg(result.dmsSyncError, true);
                        } else if (result?.errors?.length > 0) {
                            modal = modalService.showError('Sorry, there was a problem saving your appointment:', result.errors);
                        }
        
                        if (modal) {
                            return modal.then(() => { return Promise.resolve(); });
                        } else {
                            return result;
                        }                
                    });
                } else if (vm.appointment.appointmentStatus !== APPOINTMENT_APPOINTMENTSTATUS.checkingIn) {
                    return appointmentService.setAppointmentStatus(vm.appointment.dealerId, vm.appointment.id, APPOINTMENT_APPOINTMENTSTATUS.checkingIn).then(() => {
                        vm.appointment.appointmentStatus = APPOINTMENT_APPOINTMENTSTATUS.checkingIn;
                        
                        return true;
                    });
                } else {
                    return Promise.resolve();
                }
            }
            
            function init() {
                setAdvisor();

                vm.registerStepFn()(processStep);
            }

            init();
        };
    }
})();


(function () {
    'use strict';

    CheckInTransportationOptionsController.$inject = ["rideProviderService", "locationService", "promiseTimeService", "roService", "appointmentService", "permissions", "APPOINTMENT_TRANSPORTATION_TYPE", "APPOINTMENT_APPOINTMENTSTATUS", "SYSTEM_ENUMS", "modalService", "rcUtilService"];
    angular
        .module('redcap.appointment')
        .component('checkinTransportationOptions', {
            templateUrl: 'app/areas/checkin/components/transportation-options/checkin-transportation-options.view.html',
            controller: CheckInTransportationOptionsController,
            controllerAs: 'vm',
            bindings: {
                appointment: '=',
                isLoading: '=',
                departments: '<',
                registerStepFn: '&'
            }
        });

    function CheckInTransportationOptionsController(rideProviderService, locationService, promiseTimeService, roService, appointmentService, permissions, APPOINTMENT_TRANSPORTATION_TYPE, APPOINTMENT_APPOINTMENTSTATUS, SYSTEM_ENUMS, modalService, rcUtilService) {
        this.$onInit = function() {
            let vm = this;
            let shuttleTripTypeInstance = null;
            let tripTypeInstances = [];
            
            vm.transportationTypeEnum = APPOINTMENT_TRANSPORTATION_TYPE;
            vm.shuttleScheduleTypes = {
                now: 1,
                later: 2                  
            };

            vm.tripBooking = {
                supports: {
                    inspect: false,
                    shuttleOnDemand: false,
                    waiter: false,
                    dropoff: false,
                    loaner: false,
                    rideShareCredits: false,
                    testTrips: permissions.isSysAdmin() || permissions.isDeveloper() || permissions.isRedCapAdmin()
                },   
                scheduleOptions: [
                    {
                        type: vm.shuttleScheduleTypes.now,
                        detail: 'Book Shuttle now'
                    },
                    {
                        type: vm.shuttleScheduleTypes.later,
                        detail: 'Send text to book Shuttle later'
                    }
                ],            
                hereAutoCompleteOptions: {
                    watchEnter: true,
                    country: 'us,can',
                    startLat: vm.appointment.dealerLat,
                    startLng: vm.appointment.dealerLng
                },    
                location: null,
                providerRides: [],
                isTest: false,
                bookingError: null,
                rideshareCredit: {
                    // default to today
                    timeframe: {
                        startDate: moment(),
                        endDate: moment()
                    }
                },
                datePickerOptions: {
                    minDate: moment(), 
                    maxDate: moment().add(90, 'days')
                },
                updateTransportation: function() {
                    this.selectedTransportationType = this.dealerTransportationTypes.find((tt) => tt.dealerSystemTransportationTypeId === this.selectedTransportationEnum);
                    vm.appointment.dealerTransportationTypeId = this.selectedTransportationType.id;
                    
                    if (this.selectedTransportationEnum === vm.transportationTypeEnum.shuttle) {
                         this.offerRideshareCredit = false;
                    }
                },
                locationUpdated: function(formattedAddress) {
                    if (formattedAddress?.location?.lat) {                        
                        this.location = formattedAddress.location;

                        this.getProviderRides();
                    } else {
                        this.location = null;                        
                    }
                },
                providerRideSelected: function() {
                    this.providerRides.forEach((ride) => {
                        ride.selected = false;
                    });
                    
                    this.selectedProviderRide.selected = true;
                    this.selectedProviderRide.isTestTrip = this.isTest;
                },
                getProviderRides: function() {
                    const pickupStop = rideProviderService.buildStop(vm.appointment.dealerLat, vm.appointment.dealerLng, vm.appointment.dealerAddress?.streetAddress, vm.appointment.dealerAddress?.city, vm.appointment.dealerAddress?.state, vm.appointment.dealerAddress.zip, vm.appointment.dealerAddress?.countryShortCode, true, shuttleTripTypeInstance.systemTripTypeId, false);
                    const dropoffStop = rideProviderService.buildStop(this.location.lat, this.location.lng, this.location.streetAddress, this.location.city, this.location.state, this.location.zip, this.location.country, false, shuttleTripTypeInstance.systemTripTypeId, false);

                    vm.loadingShuttleEstimates = true;
                    this.bookingError = null;

                    rideProviderService.getEstimates(vm.appointment.dealerId, shuttleTripTypeInstance.id, pickupStop, dropoffStop, false, this.isTest).then((estimateResponse) => {
                        this.providerRides = [];

                        if (estimateResponse.error) {
                            this.bookingError = `Error retrieving ETA and Pricing: ${estimateResponse.error}`;
                        } else {
                            estimateResponse.estimates.forEach((estimate) => {
                                this.providerRides.push({
                                    ...estimate,
                                    eta: estimate.etaSeconds < 1200 ? estimate.etaSeconds : '> 20 mins',
                                    etd: estimate.estimatedSecondsToDropoff ? estimate.estimatedSecondsToDropoff : 'ETA will be updated when driver is assigned.',
                                    estimatedCost: estimate.adjustedEstimatedCostCents / 100,
                                    baseCost: estimate.estimatedCostCents / 100,
                                    estimatedDistance: estimate.estimatedDistanceMiles,
                                    estimatedDuration: estimate.estimatedDurationSeconds,
                                    hasEtd: !!estimate.estimatedSecondsToDropoff
                                });
                            });                           

                            if (!this.providerRides.length) {
                                this.bookingError = 'We\'re sorry, there are currently no drivers available in your area. Please try again later.';
                            } else if (this.selectedProviderRide) {
                                // If this is getting executed as part of the ride provider refresh interval, auto-select the 
                                //  previously selected ride if one was selected.
                                this.selectedProviderRide = this.providerRides.find((ride) => ride.displayName === this.selectedProviderRide.displayName);
                                
                                if (this.selectedProviderRide) {
                                    this.selectedProviderRide.selected = true;
                                }
                            } else if (this.providerRides.length === 1) {
                                this.selectedProviderRide = this.providerRides[0];
                                this.providerRideSelected();
                            }
                        }
                    }).catch((err) => {
                        const errorMsg = err.data?.exceptionMessage || err.data?.errorMessage;

                        this.bookingError = `The Ride Provider returned an error when trying to get estimates${errorMsg ? ': ' + errorMsg : ''}`;
                    }).finally(() => { vm.loadingShuttleEstimates = false; });
                }
            };

            vm.appointmentBooking = {
                departmentHours: null,
                rules: null,
                dealerDepartment: vm.departments.find((department) => department.id === vm.appointment.departmentId),
                dmsRequiresHangTag: roService.dmsRequiresHangTag(vm.appointment.dealerDMSSystem),
                keyTag: vm.appointment.keyTag,
                setPromiseDateTime: function() {
                    const dateTime = moment(this.promiseDate.format('YYYY-MM-DD') + ' ' + this.promiseTime, 'YYYY-MM-DD hh:mm A');

                    vm.appointment.promiseDateTime = dateTime.format('YYYY-MM-DDTHH:mm:ss');
                },
                promiseDateChanged: function(newValue, oldValue) {
                    this.promiseTimeHours = promiseTimeService.generateHoursFromDate(newValue, vm.appointment.apptDateTime, this.departmentHours, this.dealerDepartment);                    
                    this.setPromiseDateTime();
                },
                isDateSelectable: function(date) {
                    return promiseTimeService.isPromiseDateSelectable(vm.appointment.apptDateTime, date, this.departmentHours);
                },
                validation: {
                    keyTag: function () {        
                        if (!this.keyTag) {
                            return {isValid: true};
                        }
        
                        // DealerTrack allows only 5 alphanumeric characters
                        if (vm.appointment.dealerDMSSystem === SYSTEM_ENUMS.dmsSystemEnum.DealerTrack && !/^[A-Za-z0-9]{1,5}$/.test(this.keyTag)) {
                            return {isValid: false, message: 'Must be 5 characters or fewer'};
                        // AutoMate allows only 10 numeric characters
                        } else if (vm.appointment.dealerDMSSystem === SYSTEM_ENUMS.dmsSystemEnum.AutoMate && !/^[0-9]{1,10}$/.test(this.keyTag)) {
                            return {isValid: false, message: 'Must be 10 digits or fewer'};
                        } else if (!/^[A-Za-z0-9]{1,25}$/.test(this.keyTag)) {
                            return {isValid: false, message: 'Must be 25 characters or fewer'};
                        }
        
                        return {isValid: true};
                    }
                }
            };

            vm.authorizationOptions = {
                flowType: {
                    sendToCustomer: 1,
                    thisDevice: 2
                },
                selectedFlowType: 1,
                authorizeServicesPhone: vm.appointment.customerPhone
            };
            
            function init() {
                vm.isLoading = true;

                vm.registerStepFn()(processStep);

                const transportationTypePromise = locationService.getLocationTransportationTypes(vm.appointment.dealerId).then((dealerTransportationTypes) => {
                    vm.tripBooking.dealerTransportationTypes = dealerTransportationTypes;
                    vm.tripBooking.selectedTransportationType = vm.tripBooking.dealerTransportationTypes.find((tt) => tt.id === vm.appointment.dealerTransportationTypeId);
                    
                    if (!vm.tripBooking.selectedTransportationType) {
                        vm.tripBooking.selectedTransportationType = vm.tripBooking.dealerTransportationTypes.find((tt) => { return tt.isDefault; }) || vm.tripBooking.dealerTransportationTypes[0];
                    }

                    if (vm.tripBooking.selectedTransportationType) {
                        vm.tripBooking.selectedTransportationEnum = vm.tripBooking.selectedTransportationType.dealerSystemTransportationTypeId;

                        if (vm.tripBooking.selectedTransportationType.isPickup) {
                            vm.tripBooking.selectedTransportationType.description = 'Service Pickup';
                        } else if (vm.tripBooking.selectedTransportationType.isMobileGarage) {
                            vm.tripBooking.selectedTransportationType.description = 'Mobile Service';
                        } else {
                            vm.tripBooking.selectedTransportationType.description = 'Customer Dropoff';
                        }
                    } else {
                        vm.tripBooking.selectedTransportationEnum = vm.transportationTypeEnum.dropOff; // Default to dropoff
                    }                
                });

                const tripTypeInstancesPromise = locationService.getLocationTripTypeInstances(vm.appointment.dealerId).then((response) => {
                    tripTypeInstances = response;                   
                    shuttleTripTypeInstance = tripTypeInstances.find((tt) => { return tt.systemTripTypeId === SYSTEM_ENUMS.systemTripType.lyftShuttleService && tt.status && tt.isDefault; });
                });

                const bookingRulesPromise = appointmentService.getBookingConfig(vm.appointment.dealerId).then((bookingRules) => {
                    vm.appointmentBooking.rules = bookingRules;
                });

                const departmentHoursPromise = promiseTimeService.getDepartmentHours(vm.appointment.dealerId, vm.appointment.departmentId).then((hours) => {
                    vm.appointmentBooking.departmentHours = hours;
                });

                const dealerPermissionPromise = locationService.hasRole(vm.appointment.dealerId, SYSTEM_ENUMS.permissionTypes.inspect).then((dealerHasInspect) => {
                    vm.tripBooking.supports.inspect = dealerHasInspect && permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.inspect);
                });

                const promises = [transportationTypePromise, tripTypeInstancesPromise, bookingRulesPromise, departmentHoursPromise, dealerPermissionPromise];

                Promise.all(promises).then(() => {
                    vm.tripBooking.supports.shuttleOnDemand = hasTripTypeInstance(SYSTEM_ENUMS.systemTripType.lyftShuttleService) &&
                                            hasTransportationType(APPOINTMENT_TRANSPORTATION_TYPE.shuttle);

                    vm.tripBooking.supports.rideShareCredits = hasTripTypeInstance(SYSTEM_ENUMS.systemTripType.lyftCredit) &&
                                             hasTransportationType(APPOINTMENT_TRANSPORTATION_TYPE.rideshareCredits);
                                             
                    vm.tripBooking.supports.dropoff = hasTransportationType(APPOINTMENT_TRANSPORTATION_TYPE.dropOff);
                    vm.tripBooking.supports.waiter = hasTransportationType(APPOINTMENT_TRANSPORTATION_TYPE.waiter);
                    vm.tripBooking.supports.loaner = hasTransportationType(APPOINTMENT_TRANSPORTATION_TYPE.pickupLoaner);

                    // Set promise date info
                    if (vm.appointment.promiseDateTime) {
                        const promiseDate = moment(vm.appointment.promiseDateTime);
                        const promiseTime = promiseDate.format('hh:mm A');
                        
                        vm.appointmentBooking.promiseTimeHours = promiseTimeService.generateHoursFromDate(promiseDate, vm.appointment.apptDateTime, vm.appointmentBooking.departmentHours, vm.appointmentBooking.dealerDepartment);
    
                        promiseTimeService.setHours(vm.appointmentBooking.promiseTimeHours, promiseTime);
    
                        vm.appointmentBooking.promiseDate = promiseDate;
                        vm.appointmentBooking.promiseTime = promiseTime;
                    } else {
                        const initialPromiseTime = promiseTimeService.getPromiseTime(vm.appointment.apptDateTime, vm.appointmentBooking.rules.promiseTimeDuration, 'days', vm.appointmentBooking.departmentHours, vm.appointmentBooking.dealerDepartment);

                        vm.appointmentBooking.promiseTimeHours = initialPromiseTime.hours;
                        vm.appointmentBooking.promiseDate = initialPromiseTime.promiseDate;
                        vm.appointmentBooking.promiseTime = initialPromiseTime.promiseTime;
                    }
                }).finally(() => {
                    vm.isLoading = false;
                });
            }

            init();
            
            function hasTripTypeInstance(systemTripTypeId) {
                return tripTypeInstances.some((tt) => tt.systemTripTypeId === systemTripTypeId && tt.status);
            }

            function hasTransportationType(transportationTypeId) {
                const transportationType = vm.tripBooking.dealerTransportationTypes.find((tt) => tt.dealerSystemTransportationTypeId === transportationTypeId && tt.dealerDepartmentId == vm.appointment.departmentId);

                return transportationType?.showInConsumer || transportationType?.showInDashboard;
            }

            function getCreditDetails() {
                let creditDetails = null;                
    
                if (vm.tripBooking.offerRideshareCredit) {
                    const phone = vm.authorizationOptions.selectedFlowType === vm.authorizationOptions.flowType.sendToCustomer ? 
                              vm.authorizationOptions.authorizeServicesPhone :
                              vm.appointment.customerPhone;

                    creditDetails = {
                        creditType: SYSTEM_ENUMS.rideProviderCreditTypes.appointment,
                        benefitType: SYSTEM_ENUMS.rideProviderBenefitTypes.credits,
                        creditAmount: vm.tripBooking.rideshareCredit.creditAmount * 100,  // Api expects amount in cents
                        startTime: moment(vm.tripBooking.rideshareCredit.timeframe.startDate.startOf('day').milliseconds(0)).utc(),
                        endTime: moment(vm.tripBooking.rideshareCredit.timeframe.endDate.endOf('day').milliseconds(0)).utc(),
                        firstName: vm.appointment.customerFirstName,
                        lastName: vm.appointment.customerLastName,
                        geoRestrictionType: vm.tripBooking.rideshareCredit.geoRestrictionType,
                        customerId: vm.appointment.customerId,
                        isTest: false,
                        phoneNumber: phone
                    };
                }
    
                return creditDetails;
            }

            function getShuttleDetails() {
                // Field mappings needed for posting the ride
                let shuttleDetails = null;

                if (vm.tripBooking.selectedTransportationEnum === vm.transportationTypeEnum.shuttle && vm.tripBooking.selectedShuttleType === vm.shuttleScheduleTypes.now) {
                    shuttleDetails = {};
                    _.merge(shuttleDetails, vm.tripBooking.selectedProviderRide, {                                    
                        dropoff: vm.tripBooking.location,
                        rideName: vm.tripBooking.selectedProviderRide.displayName,
                        isTestTrip: vm.tripBooking.isTest,
                        estimatedCost: vm.tripBooking.selectedProviderRide.baseCost,
                        presentedCost: vm.tripBooking.selectedProviderRide.estimatedCost,
                        dealerTripTypeId: shuttleTripTypeInstance.id,
                        rideProviderType: shuttleTripTypeInstance.rideProviderType
                    });
                }                

                return shuttleDetails;
            }

            function processStep () {
                vm.appointment.disableNotifications = true;
                vm.appointment.disableSendLoanerHomework = true;

                const shuttleBookingPhone = vm.tripBooking.selectedShuttleType === vm.shuttleScheduleTypes.later ? vm.tripBooking.customerPhone : null;
                const creditDetails = getCreditDetails();
                const shuttleDetails = getShuttleDetails();
                const sendAuthorizationsToCustomer = vm.authorizationOptions.selectedFlowType === vm.authorizationOptions.flowType.sendToCustomer;

                vm.appointmentBooking.setPromiseDateTime();
                vm.appointment.keyTag = vm.appointmentBooking.keyTag;
                vm.appointment.disableDMSPush = false;

                return appointmentService.completeCheckin(vm.appointment.dealerId, vm.appointment.id, shuttleDetails, creditDetails, shuttleBookingPhone, vm.authorizationOptions.authorizeServicesPhone, vm.appointment.promiseDateTime, vm.appointmentBooking.keyTag, sendAuthorizationsToCustomer).then((response) => {
                    vm.appointment.repairOrderId = response.roId;
                    vm.appointment.disableNotifications = true;
                    vm.appointment.disableSendLoanerHomework = false;
                    vm.appointment.pendingRideDetails = response.pendingRideDetails;

                    if (response.dmsSyncError) {
                        modalService.showDetailedCheckInErrorDlg(response.dmsSyncError, true);
                    } 

                    vm.appointment.appointmentStatus = APPOINTMENT_APPOINTMENTSTATUS.checkedIn;

                    return {checkinComplete: sendAuthorizationsToCustomer};
                }).catch((error) => {
                    vm.appointment.disableSendLoanerHomework = false;
                    vm.appointment.disableNotifications = false;

                    if (rcUtilService.isInvalidTwilioPhoneNumberError(error)) {
                        modalService.showError("You’ve entered an invalid phone number, please enter a new phone number", null, true);
                    }

                    return Promise.reject(error);
                });                                
            }
        };
    }
})();


(function () {
    'use strict';

    CheckInAddServicesController.$inject = ["vehicleService", "locationService", "modalService", "appointmentService", "appointmentUtilService", "rcUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .component('checkinAddServices', {
            templateUrl: 'app/areas/checkin/components/add-services/checkin-add-services.view.html',
            controller: CheckInAddServicesController,
            controllerAs: 'vm',
            bindings: {
                appointment: '=',
                isLoading: '=',
                dealerDepartments: '<',
                registerStepFn: '&',
                checkinSettings: '<'
            }
        });

    function CheckInAddServicesController(vehicleService, locationService, modalService, appointmentService, appointmentUtilService, rcUtilService, SYSTEM_ENUMS) {
        this.$onInit = function() {
            let vm = this;
            let locationOpCodes = {};
            let previouslyDeclinedServices = null;
            let recommendedMaintenanceGroup = null;

            // TODO: At some point we should find a way to standardize allll line item properties from the backend to the frontend.  Right now it's a bit
            //  like spaghetti trying to figure out which property matches with which.
            const serviceMatcher = (li, service) => { 
                if (service.isRecall) {
                    return li.manufacturerNumber === service.manufacturerNumber;
                } else if (service.isRecommendedMaintenance) {
                    return li.opCodeDescription === service.name || li.note === service.name;
                } else if (service.dealerAppointmentServiceOpCode) {
                    return li.dealerAppointmentServiceOpCode && li.dealerAppointmentServiceOpCode?.id === service.dealerAppointmentServiceOpCode;
                } else {
                    return li.opCode === service.opCode;
                }
            };

            const objectMerger = (destinationObjValue, objToMergeValue, key) => {
                // Don't overwrite these values in the destination object
                if (key === 'id' || key === 'dashboardDescription' || key === 'description' || key === 'dashboardName') {
                    // If destinationObjValue is undefined, we use null instead.  If undefined is returned, the default mergeWith functionality would be used, meaning it would use the value coming from the src, which we don't want.
                    return destinationObjValue || null;
                }
            };

            vm.selectedDepartment = vm.dealerDepartments.find((d) => d.id === vm.appointment.departmentId);            
            vm.serviceGroupTypes = SYSTEM_ENUMS.serviceGroupTypes;
            vm.checkinSettings.selectedServicesCount = 0;
            vm.services = [];
            vm.dealerServiceTypes = [];
            vm.dispatchOpCodes = [];
            vm.serviceGroups = [
                {
                    name: 'Previously Deferred Services',
                    serviceGroupType: vm.serviceGroupTypes.previouslyDeclined,
                    isExpanded: true,
                    showWarning: true,
                    showDeptDefaultWarning: false
                },
                {
                    name: 'Recalls',
                    serviceGroupType: vm.serviceGroupTypes.recall,
                    isExpanded: true,
                    showWarning: true,
                    showDeptDefaultWarning: false,
                    showIfEmpty: true
                },
                {
                    name: 'Recommended Maintenance',
                    serviceGroupType: vm.serviceGroupTypes.recommendedMaintenance,
                    limitToOneSelection: true,
                    selectedService: null,
                    isExpanded: true,
                    showDeptDefaultWarning: false
                },
                {
                    name: 'Common Services',
                    serviceGroupType: vm.serviceGroupTypes.common,
                    isExpanded: true,
                    showDeptDefaultWarning: true
                },
                {
                    name: 'Custom Services',
                    serviceGroupType: vm.serviceGroupTypes.manuallyAdded,
                    isExpanded: true
                }
            ];

            vm.validateServices = function() {
                return vm.checkinSettings.selectedServicesCount > 0;
            };

            function init() {
                vm.isLoading = true;                

                vm.registerStepFn()(processStep);

                locationService.getLocationOpCodes(vm.appointment.dealerId).then((opCodeResponse) => {
                    locationOpCodes = opCodeResponse;

                    let opCodes = locationOpCodes.opCodes.filter((svc) => !svc.isAutomatic && svc.dealerDepartmentId == vm.appointment.departmentId && svc.showInDashboard);
                   
                    opCodes.forEach((opCode) => {
                        opCode.serviceGroupType = vm.serviceGroupTypes.common;
                    });

                    const promises = [];

                    let recallOpCodes = appointmentUtilService.getDeptOpCodes(locationOpCodes.recallOpCodes, vm.appointment.departmentId);
                    let recallsEnabled = appointmentUtilService.opCodesEnabledForDept(locationOpCodes.recallOpCodes, vm.appointment.departmentId, true);
                    let recallsConfigured = !!(recallsEnabled && recallOpCodes[0].recallOpCodeType);
                    
                    if (recallsEnabled && recallsConfigured) {
                        const recallPromise = vehicleService.getRecalls(vm.appointment.dealerId, vm.appointment.vin).then((recalls) => {
                            const recallOpCode = recallOpCodes[0]; // There should only be one recall opcode per department, so we can safely get the first item in this array.

                            if (recalls) {
                                recalls.forEach((recall) => {
                                    recall = _.mergeWith(recall, recallOpCode, objectMerger);

                                    recall.dealerAppointmentServiceOpCodeId = recallOpCode.id;
                                    recall.serviceGroupType = vm.serviceGroupTypes.recall;
                                    recall.name = recall.displayName + (recall.manufacturerNumber ? ` (${recall.manufacturerNumber})` : '');
                                    recall.isRecall = true;
                                    recall.note = recall.description;
                                    recall.recallDisplayName = recall.displayName;
                                });
                            }

                            return recalls;
                        }).catch((err) => { 
                            console.log('error getting recalls', err);
        
                            return []; 
                        });

                        promises.push(recallPromise);
                    }
                    
                    const recommendedMaintenanceOpCodes = appointmentUtilService.getDeptOpCodes(locationOpCodes.recommendedMaintenanceOpCodes, vm.appointment.departmentId);
                    const recommendedMaintenanceEnabled = appointmentUtilService.opCodesEnabledForDept(locationOpCodes.recommendedMaintenanceOpCodes, vm.appointment.departmentId, true);

                    if (recommendedMaintenanceEnabled) {
                        const recommendedMaintenancePromise = vehicleService.getRecommendedMaintenance(vm.appointment.dealerId,  vm.appointment.vin, vm.appointment.year, vm.appointment.make, vm.appointment.model, vm.appointment.mileage, null, vm.selectedDepartment?.defaultDispatchCode).then((response) => {
                            const recommendedMaintenanceOpCode = recommendedMaintenanceOpCodes[0]; // There should only be one recall opcode per department, so we can safely get the first item in this array.
                            
                            if (response && response.maintenanceIntervals && response.maintenanceIntervals.length > 0) {
                                response.maintenanceIntervals.forEach((recommendedMaintenance) => {
                                    recommendedMaintenance = _.mergeWith(recommendedMaintenance, recommendedMaintenanceOpCode, objectMerger);

                                    recommendedMaintenance.dealerAppointmentServiceOpCodeId = recommendedMaintenanceOpCode.id;
                                    recommendedMaintenance.serviceGroupType = vm.serviceGroupTypes.recommendedMaintenance;
                                    recommendedMaintenance.name = appointmentUtilService.getRecommendedMaintenanceName(recommendedMaintenance, vm.appointment.mileageType);
                                    recommendedMaintenance.note = recommendedMaintenance.name;
                                    recommendedMaintenance.isRecommendedMaintenance = true;
                                    recommendedMaintenance.details = appointmentUtilService.getRecMainTooltip(recommendedMaintenance.applications);
                                });
                            }

                            vm.recMaintDisclaimer = response.motorDisclaimer;

                            return response.maintenanceIntervals;
                        });
                        
                        promises.push(recommendedMaintenancePromise);
                    }

                    if (vm.selectedDepartment.showPreviouslyDeclinedServicesDashboard) {
                        const previouslyDeclinedPromise = appointmentService.getPreviouslyDeclinedServices(vm.appointment.dealerId, vm.appointment.customerId, vm.appointment.vin).then((declinedServices) => {
                            declinedServices = declinedServices.filter((svc) => !svc.isRecall && !svc.isRecommendedMaintenance);

                            declinedServices.forEach((svc) => {
                                svc.serviceGroupType = vm.serviceGroupTypes.previouslyDeclined;
                            });

                            // so we can use it to filter common services later.
                            previouslyDeclinedServices = declinedServices;

                            return previouslyDeclinedServices;
                        });

                        promises.push(previouslyDeclinedPromise);
                    }   

                    Promise.all(promises).then((results) => {
                        if (previouslyDeclinedServices?.length > 0) {
                            appointmentUtilService.processPreviouslyDeclinedLineItems(previouslyDeclinedServices, locationOpCodes.all, locationOpCodes.opCodes, true);
                        
                            let commonServicesWithoutPreviouslyDeclined = opCodes.filter(commonService => {
                                return !previouslyDeclinedServices.some(declinedService => declinedService.opCode === commonService.opCode);
                            });

                            opCodes = commonServicesWithoutPreviouslyDeclined;
                        } 

                        vm.services = vm.services.concat(opCodes);

                        results.forEach((promiseData) => {
                            vm.services = vm.services.concat(promiseData);
                        });

                        recommendedMaintenanceGroup = vm.serviceGroups.find((group) => group.serviceGroupType === vm.serviceGroupTypes.recommendedMaintenance);

                        vm.services.forEach((service) => {
                            let existingService = vm.appointment.lineItems.find((li) => serviceMatcher(li, service));

                            if (existingService) {
                                service.laborHours = existingService.laborHours;
                                service.payType = existingService.payType;
                                service.serviceType = existingService.serviceType;
                                service.retailPrice = existingService.retailPrice;
                                service.dispatchCode = existingService.dispatchCode;
                                service.images = existingService.images;
                                service.note = existingService.note;
                                service.isSelected = true;

                                if (existingService.isRecommendedMaintenance) {                       
                                    recommendedMaintenanceGroup.selectedService = service;
                                }
                            }
                        });

                        const manuallyAddedServices = vm.appointment.lineItems.filter((li) => !li.dealerAppointmentServiceOpCodeId);
                        
                        manuallyAddedServices.forEach((service) => { service.isSelected = true; service.serviceGroupType = vm.serviceGroupTypes.manuallyAdded; });
                        
                        // Remove any services that are in the manually added collection so we don't get duplicate selected services.
                        vm.services = vm.services.filter((service) => !manuallyAddedServices.some((manuallyAdded) => manuallyAdded.opCode === service.opCode));
                        
                        vm.services = vm.services.concat(manuallyAddedServices);

                        const emptyServiceForManualEntry = {
                            name: 'New Item',
                            serviceGroupType: vm.serviceGroupTypes.manuallyAdded
                        };

                        vm.services.push(emptyServiceForManualEntry);

                        vm.checkinSettings.selectedServicesCount = vm.services.reduce((totalSelected, service) => { return totalSelected + (service.isSelected ? 1 : 0); }, 0);
                    }).finally(() => {
                        vm.isLoading = false;
                    });
                });

                // Get Dealer Service Types and DispatchOpCodes based on dms
                locationService.getLocationDMS(vm.appointment.dealerId).then((dmsData) => {
                    if (dmsData?.dmsDealerId) {
                        vm.requireDispatchCode = dmsData.requireDispatchCode;
                        vm.canViewServiceHistory = appointmentUtilService.displayServiceHistory(vm.appointment, dmsData.dmsSystem);

                        if (dmsData.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.DealerTrack) {
                            locationService.lookupServiceTypes(vm.appointment.dealerId, dmsData).then((response) => {
                                vm.dealerServiceTypes = response;
                            });
                        }
                        
                        if (dmsData.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.CDK) {
                            locationService.lookupDispatchCodes(vm.appointment.dealerId, dmsData).then((codes) => {
                                vm.dispatchOpCodes = codes;
                            });
                        }
                    } 
                });
            }

            init();
            
            function processStep () {                
                // Since Recalls are handled differently, editing them is complex.  To simplify that process we simply remove them from the appointment here
                // and use the "addedServices" variable below to add them back.
                rcUtilService.removeFromArray(vm.appointment.lineItems, (li) => li.isRecall);

                const selectedServices = vm.services.filter((service) => { return service.isSelected; });
                const addedServices = selectedServices.filter((service) => !vm.appointment.lineItems.some((li) => serviceMatcher(li, service))).map((service) => _.cloneDeep(service));
                const editedServices = selectedServices.filter((service) => vm.appointment.lineItems.some((li) => serviceMatcher(li, service)));
                const previouslyDeclinedServices = vm.services.filter((service) => { return service.serviceGroupType === vm.serviceGroupTypes.previouslyDeclined;});

                addedServices.forEach((svc) => { svc.isUpsell = true; svc.isAdded = true; });

                // Remove any services that were unselected
                vm.appointment.lineItems = vm.appointment.lineItems.filter((li) => !vm.services.some((service) => !service.isSelected && serviceMatcher(li, service)));
                vm.appointment.lineItems = vm.appointment.lineItems.concat(addedServices);
                
                vm.appointment.disableNotifications = true;
                vm.appointment.disableSendLoanerHomework = true;      

                editedServices.forEach((service) => {
                    let serviceToEdit = vm.appointment.lineItems.find((li) => serviceMatcher(li, service));

                    if (serviceToEdit) {
                        serviceToEdit = _.mergeWith(serviceToEdit, service, objectMerger);
                    }
                }); 

                if (previouslyDeclinedServices?.length > 0) {
                    vm.appointment.previouslyDeclinedItems = previouslyDeclinedServices.map((service) => { return {id: service.id, deleted: service.isSelected, decline: service.isDeclined}; });
                }

                // Map the common service (ie: dealer op code) id to the dealerAppointmentServiceOpCodeId.
                vm.appointment.lineItems.forEach((li) => {
                    if (li.isAdded && li.serviceGroupType !== vm.serviceGroupTypes.manuallyAdded && !li.dealerAppointmentServiceOpCodeId) {
                        li.dealerAppointmentServiceOpCodeId = li.id;
                        li.id = null; // The service id 
                    } 
                }); 

                // TODO: Consider writing new method that only updates line items (instead of the entire appointment)
                const keyTag = vm.appointment.keyTag;

                return appointmentService.createOrUpdateAppointment(vm.appointment.dealerId, vm.appointment).then((savedAppointment) => {    
                    if (savedAppointment?.errors?.length > 0) {
                        return modalService.showError('Sorry, there was a problem saving your appointment:', savedAppointment.errors);
                    } else {
                        if (savedAppointment?.dmsSyncError) {
                            modalService.showDetailedErrorDlg(savedAppointment.dmsSyncError, true);
                        }

                        vm.appointment = savedAppointment;
                        vm.appointment.keyTag = keyTag;

                        return savedAppointment;
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    MessagesNotesTabController.$inject = ["$scope", "trip", "SYSTEM_ENUMS", "permissions"];
    angular
        .module('redcap')
        .controller('MessagesNotesTabController', MessagesNotesTabController);

    function MessagesNotesTabController($scope, trip, SYSTEM_ENUMS, permissions) {
        var vm = this;        
        vm.trip = trip;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.hasMessaging = permissions.isSysAdmin() || permissions.isRedCapAdmin();
    }
})();

(function () {
    'use strict';

    MessagesMonitorTabController.$inject = ["trip", "SYSTEM_ENUMS"];
    angular
        .module('redcap')
        .controller('MessagesMonitorTabController', MessagesMonitorTabController);


    function MessagesMonitorTabController(trip, SYSTEM_ENUMS) {
        var vm = this;
        vm.trip = trip;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        
    }


})();

(function () {
    'use strict';

    MessagesInternalTabController.$inject = ["trip", "appointment", "contact", "hasMessaging", "messagesService", "SYSTEM_ENUMS", "$rootScope"];
    angular
        .module('redcap')
        .controller('MessagesInternalTabController', MessagesInternalTabController);

    function MessagesInternalTabController(trip, appointment, contact, hasMessaging, messagesService, SYSTEM_ENUMS, $rootScope) {
        let vm = this;
        
        vm.trip = trip;
        vm.appointment = appointment;
        vm.contact = contact;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.hasMessaging = hasMessaging;
        
        // backup way to update contact if we cant pass on route
        $rootScope.$on('messagePaneContactUpdate', (event, data) => {
            vm.contact = data;
        });

        $rootScope.$on('messagePaneHasMessagingUpdate', (event, data) => {
            vm.hasMessaging = data;
        });

        vm.loadContact = function () {
            if ((!vm.trip || !vm.trip.customerPhone && !vm.trip.customerName) && !vm.appointment) return;

            let dealerId = null;
            let phoneNumber = null;
            let customerName = null;
            let firstName = null;
            let lastName = null;
            let customerEmail = null;
            let customerPhone = null;

            if (vm.trip) {
                let trip = vm.trip;

                phoneNumber = trip.customerPhone;
                customerName = trip.customerName.split(' ');
                firstName = customerName[0];
                lastName = customerName[1];
                dealerId = trip.dealer.id;
                customerEmail = trip.customerEmail;
                customerPhone = trip.customerPhone;
            } else {
                let appt = vm.appointment;

                dealerId = appt.dealerId;
                phoneNumber = appt.customerPhone;
                firstName = appt.customerFirstName;
                lastName = appt.customerLastName;
                customerEmail = appt.customerEmail;
            }
                
            if (phoneNumber && phoneNumber.length >= 10) {
                messagesService.getContacts({dealer: dealerId, query: phoneNumber.replace(/\D/g, ''), allowDisabledDealers: true})
                .then((contacts) => {
                    if (contacts.length) {
                        vm.contact = contacts[0];
                    } else {
                        vm.contact = {
                            id: 0,
                            dealerId: dealerId,
                            firstName: firstName,
                            lastName: lastName,
                            email: customerEmail,
                            mobilePhone: customerPhone
                        };
                    }
                });
            }
        };

        if (!vm.contact) {
            vm.loadContact();
        }
    }
})();

(function () {
    'use strict';

    MessagesDriverTabController.$inject = ["trip", "SYSTEM_ENUMS"];
    angular
        .module('redcap')
        .controller('MessagesDriverTabController', MessagesDriverTabController);


    function MessagesDriverTabController(trip, SYSTEM_ENUMS) {
        var vm = this;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.trip = trip;
    }


})();

(function () {
    'use strict';

    MessagesDealerInfoTabController.$inject = ["$scope", "trip", "SYSTEM_ENUMS", "permissions", "locationService", "$rootScope"];
    angular
        .module('redcap')
        .controller('MessagesDealerInfoTabController', MessagesDealerInfoTabController);

    function MessagesDealerInfoTabController($scope, trip, SYSTEM_ENUMS, permissions, locationService, $rootScope) {
        let vm = this;
        
        vm.trip = trip;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.atRiskError = null;
        vm.canAddNotes = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        
        $scope.$on('messagePaneDealerIdUpdate', (event, data) => {
            vm.trip = vm.trip || {};
            vm.trip.dealer = data;
        });

        vm.toggleAtRiskDealer = function() {
            vm.atRiskError = null;
            vm.trip.dealer.isAtRisk = !vm.trip.dealer.isAtRisk;
            locationService.setIsAtRisk(vm.trip.dealer.id, vm.trip.dealer.isAtRisk).then((result) => {
                if (!result) {
                    vm.atRiskError = 'There was an error setting at-risk value. Please refresh and try again';
                } else {
                    $rootScope.$broadcast('TripService.changed', vm.theTrip);
                }
            });
        };
    }
})();

(function () {
    'use strict';

    MessagesCustomerTabController.$inject = ["trip", "appointment", "contact", "hasMessaging", "messagesService", "SYSTEM_ENUMS", "$rootScope"];
    angular
        .module('redcap')
        .controller('MessagesCustomerTabController', MessagesCustomerTabController);


    function MessagesCustomerTabController(trip, appointment, contact, hasMessaging, messagesService, SYSTEM_ENUMS, $rootScope) {
        let vm = this;

        vm.trip = trip;
        vm.appointment = appointment;
        vm.contact = contact;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.hasMessaging = hasMessaging;

        // backup way to update contact if we cant pass on route
        $rootScope.$on('messagePaneContactUpdate', (event, data) => {
            vm.contact = data;
        });

        $rootScope.$on('messagePaneHasMessagingUpdate', (event, data) => {
            vm.hasMessaging = data;
        });

        vm.loadContact = function () {
            if ((!vm.trip || !vm.trip.customerPhone && !vm.trip.customerName) && !vm.appointment) return;

            let dealerId = null;
            let phoneNumber = null;
            let customerName = null;
            let firstName = null;
            let lastName = null;
            let customerEmail = null;
            let customerPhone = null;

            if (vm.trip) {
                let trip = vm.trip;

                phoneNumber = trip.customerPhone;
                customerName = trip.customerName.split(' ');
                firstName = customerName[0];
                lastName = customerName[1];
                dealerId = trip.dealer.id;
                customerEmail = trip.customerEmail;
                customerPhone = trip.customerPhone;
            } else {
                let appt = vm.appointment;

                dealerId = appt.dealerId;
                phoneNumber = appt.customerPhone;
                firstName = appt.customerFirstName;
                lastName = appt.customerLastName;
                customerEmail = appt.customerEmail;
            }
                
            if (phoneNumber && phoneNumber.length >= 10) {
                messagesService.getContacts({dealer: dealerId, query: phoneNumber.replace(/\D/g, ''), allowDisabledDealers: true})
                .then((contacts) => {
                    if (contacts.length) {
                        vm.contact = contacts[0];
                    } else {
                        vm.contact = {
                            id: 0,
                            dealerId: dealerId,
                            firstName: firstName,
                            lastName: lastName,
                            email: customerEmail,
                            mobilePhone: customerPhone
                        };
                    }
                });
            }
        };

       if (!vm.contact) {
            vm.loadContact();
        }
    }


})();

(function () {
    'use strict';

    MainController.$inject = ["$log", "$state", "$scope", "$rootScope", "$aside", "$transition$", "$transitions", "$uibModalStack", "$timeout", "$window", "ValidationService", "resolvedOverrides", "userService", "localStorageService", "authService", "authAzureService", "resolvedConfig", "systemService", "liberatedAsideService", "permissions", "signalRService", "toastr", "messagesService", "modalService", "resolvedSupportConfigs", "SYSTEM_ENUMS", "MESSAGES_ENUM"];
    angular
        .module('redcap.main', [])
        .controller('MainController', MainController);

    function MainController($log, $state, $scope, $rootScope, $aside, $transition$, $transitions, $uibModalStack, $timeout, $window, ValidationService, resolvedOverrides, userService, localStorageService, authService, authAzureService,
            resolvedConfig, systemService, liberatedAsideService, permissions, signalRService, toastr, messagesService, modalService, resolvedSupportConfigs, SYSTEM_ENUMS, MESSAGES_ENUM) {
        let vm = this;
        let systemListener = signalRService.registerSystemListener();
        let user = authService.getCurrentUser();
        let aside = undefined;
        
        // setting this here so it gets set on every page
        let myValidation = new ValidationService();
        
        $transitions.onStart({}, () => {
            // always close the menu when we transition
            vm.mobileNavCollapsed = true;
        });
        
        myValidation.setGlobalOptions({displayOnlyLastErrorMsg: true});
       
        vm.parentMenus = {
            adminSettings: 1,
            myAccount: 2
        };

        vm.products = updateOverrides();

        $rootScope.config = resolvedConfig;

        vm.currentParentMenu = null;
        vm.customerNotificationCount = null;
        vm.internalNotificationCount = null;
        vm.fullname = user.fullName;
        vm.email = user.username;
        vm.profileImageUrl = user.profileImageUrl;
        vm.currentYear = new Date().getFullYear();
        vm.isDeveloper = permissions.isDeveloper();
        vm.isAsideOpen = false;
        vm.displayName = $state.current.data.displayName;
        vm.isGoMobileEnabled = false;
        vm.permissionTypes = SYSTEM_ENUMS.permissionTypes;
        vm.supportTrainingConfigs = resolvedSupportConfigs;
        vm.menuWasClicked = false;
        vm.isAdmin = permissions.isDealerAdmin() || permissions.isSysAdmin() || permissions.isRedCapAdmin();
        vm.isSystemAdmin = permissions.isSysAdmin();
        vm.isSysAdminOrRedCapAdmin = permissions.isSysAdminOrRedCapAdmin();

        $timeout(() => {
            vm.mobileNavCollapsed = true;
        }, 1);
        
        vm.myPopoverTemplateUrl = "myPopoverTemplate.html";

        $log.debug('currentUser: ' + JSON.stringify(user));

        vm.isGoMobileEnabled = localStorageService.get('isGoMobileEnabled') || false;
        messagesService.isGoMobileEnabled().then((response) => {
            vm.isGoMobileEnabled = response;
            localStorageService.set('isGoMobileEnabled', vm.isGoMobileEnabled);
        });

        updateOutOfOffice();

        updateNotificationCount();

        $rootScope.$on('impersonationsChanged', () => {
            updateNotificationCount();
        });

        $rootScope.$on('setSelectedMarketingArea', (ev, marketingArea) => {
            vm.marketingArea = marketingArea;
        });

        vm.cleanMarketingArea = function () {
            if (!vm.marketingArea) return null;

            return vm.marketingArea.replace(/\s/g, ''); 
        };

        systemListener.on(signalRService.events.system.broadcastNewMessage,
            (updateModel) => {
                if (user.userId !== updateModel.toasterMessage.createdById) {
                    let createdDate = moment.utc(updateModel.toasterMessage.createdDate).local();
                        let title = '<b class="text-uppercase">' + updateModel.toasterMessage.createdBy + '</b> <span>' + createdDate.format('M/D/YY') + ' at ' + createdDate.format('h:mmA') + '</span>';

                    toastr.info(
                        updateModel.toasterMessage.content,
                        title, {
                            positionClass: 'toast-top-right',
                            iconClass: 'system-notification theme-bg',
                            toastClass: 'system-notification-toast',
                            onTap: function (toast) {
                                if (updateModel.type === MESSAGES_ENUM.contactMessageTypes.driver) {
                                    $state.go('trip-detail', {tripId: updateModel.toasterMessage.tripId});
                                } else if (updateModel.type === MESSAGES_ENUM.contactMessageTypes.customer) {
                                    $state.go('contact-detail-customer', {contactId: updateModel.toasterMessage.contactId});
                                } else {
                                    $state.go('contact-detail-internal', {contactId: updateModel.toasterMessage.contactId});
                                }
                            }
                        });

                    $rootScope.$broadcast('unread-count.refresh');
                }
            })
            .on(signalRService.events.system.broadcastFailedMessage, (updateModel) => {
                let createdDate = moment.utc(updateModel.toasterMessage.createdDate).local();
                let title = '<b class="text-uppercase">FAILED MESSAGE</b> <span>' + createdDate.format('M/D/YY') + ' at ' + createdDate.format('h:mmA') + '</span>';

                toastr.info(
                    updateModel.toasterMessage.content,
                    title, {
                        positionClass: 'toast-top-right',
                        iconClass: 'system-notification theme-bg',
                        toastClass: 'system-notification-toast',
                        onTap: function (toast) {
                            if (updateModel.type === MESSAGES_ENUM.contactMessageTypes.customer) {
                                $state.go('contact-detail-customer', {contactId: updateModel.toasterMessage.contactId});
                            } else {
                                $state.go('contact-detail-internal', {contactId: updateModel.toasterMessage.contactId});
                            }
                        }
                    });
            })
            .start(); // initiate the connection letting the server know what events this client is listening for

        vm.menuClicked = function () {
            vm.menuWasClicked = true;
            vm.mobileNavCollapsed = !vm.mobileNavCollapsed;
            vm.closeModal();
        };

        vm.showMessagingIcons = function () {
            return permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.messaging);
        };

        vm.hasInspect = function() {
            return permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.inspect);
        };

        vm.showManageDepartmentAdvisors = function () {
            if (!permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.appointments)) return false;
            
            return permissions.isDealerAdmin() || permissions.isSysAdmin() || permissions.isRedCapAdmin();
        };

        vm.showSettingsSubMenu = function () {
            return permissions.isDealerAdmin() || permissions.isSysAdmin() || permissions.isRedCapAdmin(); 
        };

        vm.canAccessManageMySchedule = function () {
            return permissions.getEnableManageMySchedule() && permissions.isServiceAdvisor();
        };

        function stripSelfServicePrefix (stringToCorrect) {
            stringToCorrect = stringToCorrect.replace("location-appointmentcapacity-", "");
            stringToCorrect = stringToCorrect.replace("location-departments-", "");
            stringToCorrect = stringToCorrect.replace("location-advisors-", "");
            stringToCorrect = stringToCorrect.replace("location-opcodes-", "");
            stringToCorrect = stringToCorrect.replace("location-departments-", "");
            stringToCorrect = stringToCorrect.replace("myschedule-", "");

            return stringToCorrect;
        }

        vm.closeModal = function () {
            liberatedAsideService.closeLiberatedAside();
            modalService.closeTopModal();
        };

        vm.relocateAutopointMenuItems = function () {
            return permissions.isSysAdmin() || permissions.isDeveloper() || permissions.isRedCapAdmin();
        };

        function openAside(statePrefix, storageServiceParam) {
            let top = $uibModalStack.getTop();
                
            if (top) {
                $uibModalStack.dismiss(top.key);
            }

            $timeout(() => {
                let referrer = $state.current.name;
                let params = $state.params;
                let noReferrerList = ['venue-mappings', 'myschedule', 'uber-serviceability', 'systemsurvey-management'];
                
                referrer = stripSelfServicePrefix(referrer);

                if (referrer === 'appointment-messages' || 
                    referrer === 'appointment-scripts' ||
                    referrer === 'appointment-faq') {
                        referrer = 'appointment-add';
                }

                localStorageService.set(storageServiceParam, params);

                if (!noReferrerList.includes(statePrefix) && referrer.indexOf("-list") > -1) {
                    $state.go(statePrefix + referrer, {referrer: referrer});
                } else {
                    $state.go(statePrefix, {referrer: referrer});
                }
            }, 50);
            
        }

        vm.mySchedule = function () {
            vm.toggleMobileMenu();
            openAside('myschedule', 'lastManageAdvisorsParams');
        };

        vm.venueMapping = function () {
            vm.toggleMobileMenu();
            openAside('venue-mappings', 'lastVenueMappingsParams');
        };

        vm.uberServiceability = function () {
            vm.toggleMobileMenu();
            openAside('uber-serviceability');
        };

        vm.systemSurveyManagement = function () {
            vm.toggleMobileMenu();
            
            openAside('systemsurvey-management');
        };

        vm.getParent = function (model) {
            if (!model) return null;
            
            let parent = null;
            let upper = model.toUpperCase();
           
            switch (upper) {
                case 'PAYMENTS':
                    parent = 'payments-list';
                    break;
                case 'LOANERS':
                    parent = 'loaner-contracts-list';
                    break;
                case 'TRANSPORTATION':
                    parent = 'trip-list';
                    break;
                case 'MESSAGES':
                    parent = 'contact-list';
                    break;
                case 'APPOINTMENTS':
                    parent = 'appointment-list';
                    break;
                case 'USERS':
                    parent = 'user-list';
                    break;
                case 'DRIVERS':
                    parent = 'driver-list';
                    break;
                case 'LOCATIONS':
                    parent = 'location-list';
                    break;
                case 'REPORTS':
                    parent = 'reports-list';
                    break;
                case 'INSPECT':
                    parent = 'inspect';
                    break;
                case 'CHECK IN':
                    parent = 'appointment-list';
                    break;                
            }

            return parent;
        };

        vm.getActiveProductIcon = function () {
            const products = vm.products;
            let productIcon = null;
            let activeProduct = vm.getActiveProduct();

            switch (activeProduct) {
                case products.Product_Payment.overrideVal: 
                    vm.currentParentMenu = null;
                    productIcon = 'credit_card';
                    break;
                case products.Product_Transportation.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'drive_eta';
                    break;
                case products.Product_Loaner.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'library_books';
                    break;
                case products.Product_Report.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'assessment';
                    break;
                case products.Product_Inspect.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'assignment';
                    break;
                case products.Product_Appointment.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'insert_invitation';
                    break;
                case products.Product_Authorizations.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'input';
                    break;
                case products.Product_CheckIn.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'assignment_turned_in';
                    break;
                case products.Product_Messaging.overrideVal:
                    vm.currentParentMenu = null;
                    productIcon =  'mail';
                    break;
                case 'LOCATIONS':
                    vm.currentParentMenu = vm.parentMenus.adminSettings;
                    productIcon =  'settings';
                    break;
                case 'USERS':
                    vm.currentParentMenu = vm.parentMenus.adminSettings;
                    productIcon =  'settings';
                    break;
                case 'DRIVERS':
                    vm.currentParentMenu = vm.parentMenus.adminSettings;
                    productIcon =  'settings';
                    break;
                case 'MY ACCOUNT':
                    vm.currentParentMenu = vm.parentMenus.myAccount;
                    productIcon =  'account_circle';
                    break;
                case 'HELP':
                    vm.currentParentMenu = null;
                    productIcon =  'help';
                    break;
            }

            return productIcon;
        };

        vm.getNewMenuProductDisplayName = function () {
            let product = vm.getActiveProduct();

            if (product === 'DRIVERS' ||  product === 'USERS' ||  product === 'LOCATIONS') {
                return 'SETTINGS';
            }

            return product;
        };

        vm.isLocationList = function () {
            let path = vm.currentRoute = $state.name;
            
            return path.indexOf('location-list') > -1 && path.indexOf('venue-mapping') === -1;
        };

        vm.isVenueMapping = function () {
            let path = vm.currentRoute = $state.name;

            return path.indexOf('venue-mapping') > -1;
        };

        vm.isManageMySchedule = function () {
            let path = vm.currentRoute = $state.name;

            return path.indexOf('myschedule') > -1;
        };

        vm.getActiveProduct = function () {
            let path = vm.currentRoute = $state.name;
            let activeModule = null;

            path = stripSelfServicePrefix(path);

            if (path.indexOf('venue-mapping') > -1) {
                activeModule = 'LOCATIONS';
            } else {
                       
                switch (path) {
                    case 'payment-edit':
                    case 'payment-create':
                    case 'payments-list':
                    case 'payments-send-link':
                        activeModule = vm.products.Product_Payment.overrideVal;
                        break;
                    case 'lyft-credit-edit':
                    case 'trip-tab-trip':
                    case 'trip-tab-summary':
                    case 'trip-tab-tasks':
                    case 'trip-tab-vehicles':
                    case 'trip-add':
                    case 'edit-trip':
                    case 'trip-detail-tabs':
                    case 'trip-detail':
                    case 'trip-list':
                        activeModule = vm.products.Product_Transportation.overrideVal;
                        break;
                    case 'loaner-contracts-list':
                    case 'loaner-vehicles-list':
                    case 'loaner-contracts-add':
                    case 'loaner-reservation-add':
                    case 'loaner-reservation-edit':
                        activeModule = vm.products.Product_Loaner.overrideVal;
                        break;
                    case 'report-list':
                        activeModule = vm.products.Product_Report.overrideVal;
                        break;
                    case 'inspect':
                        activeModule = vm.products.Product_Inspect.overrideVal;
                        break;
                    case 'appointment-details':
                    case 'appointment-checkin':
                    case 'appointment-messages':
                    case 'appointment-list':
                        activeModule = vm.products.Product_Appointment.overrideVal;
                        break;
                    case 'appointment-details-auth-list':
                    case 'appointment-checkin-auth-list':
                    case 'appointment-messages-auth-list':
                    case 'auth-list':
                        activeModule = vm.products.Product_Authorizations.overrideVal;
                        break;
                    case 'appointment-details-checkin-list':
                    case 'appointment-checkin-checkin-list':
                    case 'appointment-messages-checkin-list':
                    case 'checkin-list':
                        activeModule = vm.products.Product_CheckIn.overrideVal;
                        break;
                    case 'contact-add':
                    case 'contact-detail-customer':
                    case 'contact-list':
                        activeModule = vm.products.Product_Messaging.overrideVal;
                        break;
                    case 'location-list':
                    case 'tab-booking':
                    case 'tab-drivers':
                    case 'tab-users':
                    case 'tab-api':
                    case 'tab-integrations':
                    case 'tab-capacity':
                    case 'tab-departments':
                    case 'tab-hours':
                    case 'tab-logos':
                    case 'tab-tasks':
                    case 'tab-survey':
                    case 'tab-notifications':
                    case 'tab-ui':
                    case 'tab-hours-other':
                        activeModule = 'LOCATIONS';
                        break;
                    case 'user-list':
                        activeModule = 'USERS';
                        break;
                    case 'driver-list':
                        activeModule = 'DRIVERS';
                        break;
                    case 'profile':
                    case 'changepassword':
                        activeModule = 'MY ACCOUNT';
                        break;
                    case 'tutorial-list':
                        activeModule = 'HELP';
                        break;
                    default:
                        location.statusText = 'unknown';
                        location.statusLabel = 'label-default';
            }
        }

            return activeModule;
        };

        vm.displaySettingsMenu = function () {
            return vm.isAdmin || 
                permissions.isDevloper || 
                permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.users) || 
                permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.drivers) || 
                permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.locations);
        };

        vm.goto = function (path, toggleMenu) {
            $state.go(path, {configId: resolvedConfig.id});

            if (toggleMenu) {
                vm.mobileNavCollapsed = true;
            }
        };

        vm.gotoTutorial = function (configId) {
            $state.go('tutorial-list', {configId: resolvedConfig.id, productId: configId});
            vm.mobileNavCollapsed = true;
        };

        vm.gotoLyftRefunds = function () {
            vm.toggleMobileMenu();
            modalService.processLyftRefunds();
        };

        vm.toggleMobileMenu = function () {
            if ($('#mobile-tablet-wrapper').is(':visible')) {
                vm.mobileNavCollapsed = !vm.mobileNavCollapsed;
            }
        };

        vm.myProfile = function () {
            vm.toggleMobileMenu();
            vm.closeModal();
            $state.go('profile', {configId: resolvedConfig.id});
        };

        vm.changePassword = function () {
            vm.toggleMobileMenu();
            vm.closeModal();
            $state.go('changepassword', {configId: resolvedConfig.id});
        };

        vm.adminSettings = function () {
            vm.toggleMobileMenu();
            vm.closeModal();

            if (vm.isAdmin || permissions.hasPermission(SYSTEM_ENUMS.locations)) {
                $state.go('location-list', {configId: resolvedConfig.id});
            } else if (vm.isAdmin || permissions.hasPermission(SYSTEM_ENUMS.drivers)) {
                $state.go('driver-list', {configId: resolvedConfig.id});
            } else if (vm.isAdmin || permissions.hasPermission(SYSTEM_ENUMS.users)) {
                $state.go('user-list', {configId: resolvedConfig.id});
            }
        };


        vm.logout = function () {
            vm.toggleMobileMenu();
            vm.closeModal();
            $log.debug('vm.logout');
            authAzureService.signOut();
            authService.logout();

            if (systemListener) {
                systemListener.disconnect();
            }

            $state.go('login', {configId: resolvedConfig.id});
        };

        vm.privacyPolicy = function () {
            vm.toggleMobileMenu();
            vm.closeModal();

            let privacyTab = $state.href('privacypolicy', {configId: resolvedConfig.id});
            
            $window.open(privacyTab, 'new');

        };

        vm.navBarClicked = function () {
            $scope.$broadcast('navbar-clicked');
        };

        vm.isTransportationState = function () {
            let isMarketingTransportation = $state.includes('marketing') && $transition$.targetState().params()['marketingArea'] === 'Transportation';

            return $state.includes('trip-list') || $state.includes('lyftcredits') || isMarketingTransportation;
        };

        vm.isLoanerState = function () {
            let isMarketingLoaner = $state.includes('marketing') && $transition$.targetState().params()['marketingArea'] === 'Loaner';

            return $state.includes('loaner') || $state.includes('loaner-vehicles') || $state.includes('loaner-contracts') || $state.includes('loaner-reservation') || isMarketingLoaner;
        };

        vm.getState = function () {
            return $state;
        };

        vm.experiencesTransportationClicked = function () {
            vm.closeModal();
            vm.mobileNavCollapsed = !vm.mobileNavCollapsed;
            $state.go('trip-list');
        };

        vm.toggleGoMobile = function () {
            messagesService.setGoMobile(!vm.isGoMobileEnabled).then((response) => {
                vm.isGoMobileEnabled = response;
                localStorageService.set('isGoMobileEnabled', vm.isGoMobileEnabled);
            });
        };

        vm.openOutOfOffice = function () {
            this.size = 'lg';

            let options = {
                templateUrl: 'app/areas/messages/views/out-of-office.view.html',
                container: 'body',
                placement: 'bottom',
                animation: false,
                backdrop: 'static', // prevents modal from being closed by clicking background
                show: false,
                html: true,
                keyboard: false,
                size: this.size,
                controller: 'OutOfOfficeController as vm',
                windowClass: 'has-fixed-footer aside-centered aside-sm',
                resolve: {
                    resolvedOutOfOffice: function () { return vm.outOfOffice; }
                }
            };

            aside = $aside.open(options);
            vm.isAsideOpen = true;
        };

        vm.openSubMenu = function (subMenuToOpen) {
            if (subMenuToOpen === vm.parentMenus.myAccount) {
                vm.myProfile();
            } else if (subMenuToOpen === vm.parentMenus.adminSettings) {
                vm.adminSettings();
            }
        };

        vm.openHelp = function () {
            if (vm.supportTrainingConfigs && vm.supportTrainingConfigs.length > 0) {
                vm.gotoTutorial(vm.supportTrainingConfigs[0].id);
            }
        };

        $scope.$on('outofoffice-closed', () => {
            aside.dismiss();
            vm.isAsideOpen = false;
            updateOutOfOffice();
        });

        $rootScope.$on('unread-count.refresh', () => {
            updateNotificationCount();
        });

        function updateOutOfOffice() {
            userService.getOutOfOffice().then((response) => {
                vm.outOfOffice = response;
                vm.isOutOfOffice = !!response;
            });
        }

        function updateNotificationCount() {
            // debugger;       // uncomment if you want to debug how many times the main nav updates the contact count
            return systemService.getUnreadNotificationCount()
                .then((unreadCount) => {
                    vm.notificationCount = formatUnreadCount(unreadCount);
                    $rootScope.$broadcast('unread-count.updated');
                });
        }

        function updateOverrides() {
            let overrideType = {
                trip: 1,
                product: 2
            };

            if (resolvedOverrides && resolvedOverrides.length) {
                SYSTEM_ENUMS.useTripNameOverrides = true;
                
                _.each(resolvedOverrides, (override) => {
                    if (override.type === overrideType.trip) {
                        // find the system_enum trip type
                        let tripType = _.find(SYSTEM_ENUMS.systemTripTypes, {value: override.systemTripTypeId});

                        if (tripType) {
                            tripType.overrideName = override.overrideProductName;
                            tripType.overrideHelpText = override.overrideHelpText && override.overrideHelpText.length > 0 ? override.overrideHelpText : null;
                            tripType.badgeText = override.overrideProductBadge;
                        }
                    } else if (override.type === overrideType.product) {
                        // update supportConfig names
                        let supportConfig = _.find(resolvedSupportConfigs, {productName: SYSTEM_ENUMS.products[override.overrideProductName].originalVal});

                        if (supportConfig) {
                            supportConfig.productName = override.overrideProductValue;
                        }

                        // now we can update the enum
                        SYSTEM_ENUMS.products[override.overrideProductName].overrideVal = override.overrideProductValue;
                    }
                });
            }

            return SYSTEM_ENUMS.products;
        }

        function formatUnreadCount(unreadCount) {
            return unreadCount > 99 ? '99+' : unreadCount;
        }

        $scope.$on('user-profile-picture-updated', () => {
            let url = new URL(vm.profileImageUrl);
            let searchParams = url.searchParams;

            searchParams.set('cachebuster', new Date().getTime());
            url.search = searchParams.toString();
            vm.profileImageUrl = url.toString();
        });
        
    }
})();
(function () {
    'use strict';

    angular.module('redcap.user', []);
})();
(function () {
    'use strict';

    UserTabSettingsController.$inject = ["userService", "resolvedUser", "eventAlertService", "modalService", "locationService", "permissions"];
    angular
        .module('redcap.user')
        .controller('UserTabSettingsController', UserTabSettingsController);

    function UserTabSettingsController(userService, resolvedUser, eventAlertService, modalService, locationService, permissions) {
        let vm = this;

        vm.currentUser = resolvedUser;   
        vm.currentUser.migrateToSolidDate = vm.currentUser.migrateToSolidDate ? moment(vm.currentUser.migrateToSolidDate) : null; 
        vm.showMFAToggle = permissions.isSysAdmin();

        vm.updateUser = function () {
            let tmp = vm.currentUser.profilePicture;
 
            vm.currentUser.profilePicture = null;

            userService.updateUser(vm.currentUser).then((response) => {
                if (vm.newDefaultUserTripTypes) {   
                    vm.updateDefaultUser();
                }

                eventAlertService.createAlert('User Updated.');
                vm.currentUser.profilePicture = tmp;
            });
        };
        
        
        vm.selectDefaultTripTypeUser = function () {
                if (vm.currentUser.isDisabled) {
                    locationService.getTripTypesWithDefaultUser(vm.currentUser.id).then((response) => {
                        vm.triptypes = response;
        
                        if (vm.triptypes && vm.triptypes.length > 0) {
                            modalService.selectDefaultTripTypeUser(vm.triptypes).then((modalResponse) => { 
                                if (modalResponse == null) {
                                    vm.currentUser.isDisabled = false;
                                    vm.newDefaultUserTripTypes = null;
                                } else {
                                    vm.newDefaultUserTripTypes = modalResponse;
                                }
                            });
                        }
                        
                    });                 
                }
        };

        vm.updateDefaultUser = function() {
            _.forEach(vm.newDefaultUserTripTypes, (tripType) => {
                _.forEach(tripType.tripTypeIds, (tripTypeId) => {
                    let data = {
                        tripTypeId: tripTypeId,
                        employeeId: tripType.userSelected
                    };

                    locationService.updateDefaultUser(data).then(() => {})
                        .catch((err) => {
                            console.log('Error while update the default user.', err); 
                        });
                });
            });
        };

    }
})();

(function () {
    'use strict';

    UserTabSecurityController.$inject = ["$location", "$sce", "$rootScope", "SYSTEM_ENUMS", "userRolesService", "userService", "NON_EDITABLE_USERROLES_CSV", "resolvedUser", "resolvedRoles", "eventAlertService", "permissions"];
    angular
        .module('redcap.user')
        .controller('UserTabSecurityController', UserTabSecurityController);

    function UserTabSecurityController($location, $sce, $rootScope, SYSTEM_ENUMS, userRolesService, userService, NON_EDITABLE_USERROLES_CSV, resolvedUser, resolvedRoles, eventAlertService, permissions) {
        let vm = this;
        let dealerAdminRole = _.filter(resolvedRoles, (r) => { return r.name === SYSTEM_ENUMS.roleNames.dealerAdmin; })[0];
        let systemAdminRole = _.filter(resolvedRoles, (r) => { return r.name === SYSTEM_ENUMS.roleNames.systemAdmin; })[0];
        let rcAdminRole = _.filter(resolvedRoles, (r) => { return r.name === SYSTEM_ENUMS.roleNames.redCapAdmin; })[0];
        let defunctRoles = SYSTEM_ENUMS.hiddenRoles;

        vm.nonEditableRoles = NON_EDITABLE_USERROLES_CSV.split(",");
        vm.alwaysHiddenSystemRoles = [SYSTEM_ENUMS.roleNames.driverUser];
        vm.dealerAdminAllowedSystemRoles = [SYSTEM_ENUMS.roleNames.serviceAdvisor, SYSTEM_ENUMS.roleNames.dealerAdmin, SYSTEM_ENUMS.roleNames.dealerUser];

        if (permissions.isAppointmentAdmin()) {
            vm.dealerAdminAllowedSystemRoles.push(SYSTEM_ENUMS.roleNames.appointmentAdmin);
        }

        vm.dealerAdminDisallowedFeatureRoles = [SYSTEM_ENUMS.permissionTypes.marketing, SYSTEM_ENUMS.permissionTypes.cpo, SYSTEM_ENUMS.permissionTypes.welcomePoint];
       
        vm.currentUser = resolvedUser;
        vm.password = '';
        vm.passwordConfirm = '';
        vm.sendingPasswordResetEmail = false;
        vm.requiresPasswordChange = true;
        vm.rolesEnums = SYSTEM_ENUMS.roleNames;

        vm.hasMFAPermissions = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        
        function updateHiddenRoles (roles) {
            _.forEach(roles, (role) => {
                if (defunctRoles.includes(role.name.toLowerCase())) {
                    role.isHidden = true;
                } else {
                    role.isHidden = false;
                }

            });
        }

        updateHiddenRoles(resolvedRoles);
        
        vm.featureRoles = _.filter(resolvedRoles, {isForFeature: true});
        vm.systemRoles = _.filter(resolvedRoles, {isForFeature: false});
        vm.childRoles = _.filter(resolvedRoles, (r) => { return r.parentRole !== null;});  
        vm.showInternalRoles === false;
        vm.popoverIsOpen = false;
        vm.absUrl = $location.absUrl();
      
        $rootScope.$on('$locationChangeStart', (event, newUrl, oldUrl) => {
            vm.popoverIsOpen = false;
        });

        vm.updatePassword = function () {
            vm.sendingPasswordResetEmail = true;

            if (vm.currentUser.lastSolidLoginDate) {
                userService.emailResetPasswordSolid(vm.currentUser.userName).then((result) => {
                    eventAlertService.createAlert('An email has been sent with instructions on how to proceed.');
                }).catch((err) => {
                    eventAlertService.createAlert('An error occurred please try again.');
                }).finally(() => {
                    vm.sendingPasswordResetEmail = false;
                });
            } else {
                userService.emailTempPassword(vm.currentUser.userName).then((result) => {
                    eventAlertService.createAlert('An email has been sent with instructions on how to proceed.');
                }).catch((err) => {
                    eventAlertService.createAlert('An error occurred please try again.');
                }).finally(() => {
                    vm.sendingPasswordResetEmail = false;
                });
            }
        };

        vm.resetMFA = function () {
            vm.sendingPasswordResetEmail = true;
            
            userService.resetMFAbyUsername(vm.currentUser.userName).then((result) => {
                eventAlertService.createAlert('MFA settings have been reset for the user.');
            }).catch((err) => {
                eventAlertService.createAlert('An error occurred please try again.');
            }).finally(() => {
                vm.sendingPasswordResetEmail = false;
            });
        };

        vm.updateUser = function () {
            let tmp = vm.currentUser.profilePicture;
            let allRoles = vm.featureRoles.concat(vm.systemRoles, vm.childRoles);

            vm.currentUser.profilePicture = null;
            vm.currentUser.roles = _.filter(allRoles, {assigned: true})
                                    .map((r) => {
                                        return r.name;
                                    });        
            userService.updateUser(vm.currentUser).then((response) => {
                eventAlertService.createAlert('User Updated.',  2000, () => {
                    eventAlertService.createAlert('Please advise the user to log out and log in to ensure changes take effect.', 100000, null, 'text-danger');
                });
                vm.currentUser.profilePicture = tmp;
                userRolesService.getUserRoles(resolvedUser.id).then((roles) => {
                    updateHiddenRoles(roles);
                    
                    _.forEach(roles, (role) => {
                        role.displayText = (role.displayName ? role.displayName : role.name);
                    });
                    vm.featureRoles = _.filter(roles, {isForFeature: true});
                    vm.systemRoles = _.filter(roles, {isForFeature: false});
                    vm.childRoles = _.filter(roles, (r) => { return r.parentRole !== null;});  
                });
            });
        };

        vm.passwordRemoteValidation = function() {
            return userService.checkPassword(vm.password);
        };

        vm.isRoleDisabled = function (role) {
            if (role.name === SYSTEM_ENUMS.roleNames.developerUser) {
               return !permissions.isDeveloper();
            }

            if (role.name === SYSTEM_ENUMS.roleNames.systemAdmin) {
                return !permissions.isSysAdmin();
            } else if (role.name === SYSTEM_ENUMS.roleNames.redCapAdmin) {
                return !(permissions.isDeveloper() || permissions.isSysAdmin());
            } else if (role.name === SYSTEM_ENUMS.roleNames.dealerAdmin) {
                return !(permissions.isDeveloper() || permissions.isSysAdmin() || permissions.isRedCapAdmin());
            } else { 
                return _.findIndex(vm.nonEditableRoles, (r) => { return role.name === r; }) > -1;
            }
        };

        vm.switchClicked = function(role) {
            role.assigned = !role.assigned;
        };

        // This function is used to verify if the current user is only a ProgramAdmin with Reports role
        vm.verifyIfIsOnlyProgramAdminWithReports = function () {
            vm.programAdmin = null;
            vm.systemAdmin = null;
            vm.redCapAdmin = null;
            vm.isSystemAndRedCapAdmin = null;
            let allRoles = vm.featureRoles.concat(vm.systemRoles, vm.childRoles);

            vm.currentUser.roles = _.filter(allRoles, {assigned: true})
                                    .map((r) => {
                                        return r.name;
                                    });
            vm.userRoles = _.filter(allRoles, {isForFeature: false, assigned: true})
                                    .map((r) => {
                                        return r.name;
                                    });            
            
            let hasSystemAdmin = vm.currentUser.roles.includes(SYSTEM_ENUMS.roleNames.systemAdmin);
            let hasRedCapAdmin = vm.currentUser.roles.includes(SYSTEM_ENUMS.roleNames.redCapAdmin);
            let hasProgramAdmin = vm.currentUser.roles.includes(SYSTEM_ENUMS.roleNames.programAdmin);
            let hasReports = vm.currentUser.roles.includes(SYSTEM_ENUMS.permissionTypes.reports);
                                    

            // Check if the user is both a SystemAdmin and RedCapAdmin
            if (hasSystemAdmin && hasRedCapAdmin) {
                vm.isSystemAndRedCapAdmin = true;               
            } else if (!hasSystemAdmin && !hasRedCapAdmin) {
                // Check if the user is neither a SystemAdmin nor a RedCapAdmin
                // Check if the user has only one role (ProgramAdmin) and no other roles
                if (vm.userRoles.length === 1 && (hasProgramAdmin)) {
                    vm.isSystemAndRedCapAdmin = false;

                    return true;
                } else if (!(vm.currentUser.roles.length === 2 && (hasProgramAdmin && hasReports))) {
                    // Check if the user has more than one role or has additional roles along with ProgramAdmin
                    vm.programAdmin = false;

                    return false;
                } else {
                    vm.isSystemAndRedCapAdmin = false;
                }                   
            } else if (vm.currentUser.roles.length === 2 && (hasProgramAdmin && hasReports)) {
                // Check if the user has both ProgramAdmin and Reports roles
                vm.programAdmin = true;

                return true;
            } else if (hasSystemAdmin) {
                // Check if the user is a SystemAdmin
                vm.systemAdmin = true;               
            } else if (hasRedCapAdmin) {
                 // Check if the user is a RedCapAdmin
                vm.redCapAdmin = true;               
            } else {
                return false;
            }
        }; 

        vm.assignAllRoles = function(name, isAssigned) {
            if (name === SYSTEM_ENUMS.roleNames.systemAdmin && isAssigned) {
                    _.forEach(vm.systemRoles, (systemRole) => {
                        if ((systemRole.name !== SYSTEM_ENUMS.roleNames.systemAdmin) && systemRole.isInternal === false && systemRole.name !== SYSTEM_ENUMS.roleNames.driverUser) {
                            systemRole.assigned = true;
                        }
                    });
                    vm.assignFeatureRoles();
            } else if (name === SYSTEM_ENUMS.roleNames.redCapAdmin && isAssigned) {
                    _.forEach(vm.systemRoles, (systemRole) => {
                        if ((systemRole.name !== SYSTEM_ENUMS.roleNames.redCapAdmin && systemRole.name !== SYSTEM_ENUMS.roleNames.systemAdmin) && systemRole.isInternal === false && systemRole.name !== SYSTEM_ENUMS.roleNames.driverUser) {
                            systemRole.assigned = true;
                        }
                    });
                    vm.assignFeatureRoles();
            }
        };

        vm.assignFeatureRoles = function () {
            _.forEach(vm.featureRoles, (featureRole) => {
                featureRole.assigned = true;
            });
        };

        vm.checkRoleCondition = function (role) {
            return role.tooltip !== null && role.tooltip !== '' && (role.name !== SYSTEM_ENUMS.roleNames.dealerAdmin || (role.name === SYSTEM_ENUMS.roleNames.dealerAdmin && vm.isRoleDisabled(role) !== true));
        };

        vm.onlyProgramAdmin = function () {
            if (vm.userRoles.length === 1 && (vm.userRoles.includes(SYSTEM_ENUMS.roleNames.programAdmin))) {
                _.forEach(vm.featureRoles, (featureRole) => {
                    if (featureRole.name === SYSTEM_ENUMS.permissionTypes.reports) {
                        featureRole.assigned = true;
                    } else {
                        featureRole.assigned = false;
                    }
                });

                return true;
            } else {
                return false;
            }

        };

        vm.updateChildRoles = function(role) {  
            role.assigned = !role.assigned;

            _.forEach(vm.childRoles, (childRole) => {
                if (childRole.parentRole.name === role.name && role.assigned) {
                    childRole.assigned = false;
                }
            });

            vm.assignAllRoles(role.name, role.assigned);
        }; 

        vm.roleClicked = function(role) {
            vm.updateChildRoles(role); 
            role.assigned = !role.assigned;
        };
        
        vm.filterChildRolesToDisplay = function(role) {  
            return function(childRole) {  
                return childRole.parentRole.name === role.name;  
            };
        };

        vm.filterSystemRolesToDisplay = function (role) {
            if (role.parentRole !== null) return false;
            
            if (_.findIndex(vm.alwaysHiddenSystemRoles, (r) => { return role.name === r; }) > -1) {
                return false;
            }

            if (permissions.isDeveloper() || permissions.isSysAdmin() || permissions.isRedCapAdmin()) {
                if (vm.showAllRoles === true) return true;

                return role.isInternal === false;
            }
            
            if (permissions.isDealerAdmin()) {
                return _.findIndex(vm.dealerAdminAllowedSystemRoles, (r) => { return role.name === r; }) > -1;
            }
        };

        vm.filterFeatureRolesToDisplay = function (role) {
            if (role.parentRole !== null) return false;
            if (permissions.isDeveloper() || permissions.isSysAdmin() || permissions.isRedCapAdmin()) return true;
            
            let permissionToCheck = role.name;

            if (permissionToCheck.indexOf(' ') > -1) {
                permissionToCheck = permissionToCheck.split(' ')[0];
            }

            if (permissions.isDealerAdmin()) {
                return _.findIndex(vm.dealerAdminDisallowedFeatureRoles, (r) => { 
                    return role.name === r; 
                    }) === -1 && permissions.hasDealerPermission(permissionToCheck);
            }
        };

        vm.stopPropagation = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        };

        function init () {
            _.forEach(resolvedRoles,  (role) => {
                role.displayText = (role.displayName ? role.displayName : role.name);
            });

            if (permissions.isDeveloper() || permissions.isSysAdmin() || permissions.isRedCapAdmin()) {
                let showAll = $location.search()['showAllRoles'];

                if (showAll === '1') {
                    vm.showAllRoles = true;
                }
            }

            if (systemAdminRole) {
                vm.assignAllRoles(systemAdminRole.name, systemAdminRole.assigned);
            }
             
            if (rcAdminRole) {
                vm.assignAllRoles(rcAdminRole.name, rcAdminRole.assigned);
            }
        }

        init();
    }
})();

'use strict';

(function () {

    UserTabLocationsController.$inject = ["$filter", "userService", "employeeService", "modalService", "permissions", "locationService", "webworkerService", "resolvedUser", "eventAlertService", "$transition$", "$timeout"];
    angular
        .module('redcap.user')
        .controller('UserTabLocationsController', UserTabLocationsController);

    function UserTabLocationsController($filter, userService, employeeService, modalService, permissions, locationService,
        webworkerService, resolvedUser, eventAlertService, $transition$, $timeout) {
        const DEFAULT_PAGE_SIZE = 50;
        let vm = this;
        let displayLimit = 50;
        let nonIntegratedUser = {
            dealerId: -1,
            employeeHtml: 'Create Non Integrated User: -1',
            employeeHtmlTruncated: 'Create Non Integrated User',
            enableAutomation: false,
            firstName: 'Non Integrated',
            fullName: 'Create Non Integrated User',
            lastName: 'User',
            id: -1,
            employeeNumber: '',
            identityUserId: null
        };

        vm.currentUser = resolvedUser;
        vm.selectedLocations = [];
        vm.removedLocations = [];
        vm.alreadyAssignedLocIds = new Set(); // IDs that existed when the page loaded
        vm.initialMappingSnapshot = {}; // Snapshot of initial employeeId + enableAutomation per location
        vm.currentLocation = null;
        vm.isLoadingMore = false;
        vm.isInitialLoading = true;
        vm.currentPage = 0;
        vm.hasMorePages = true;
        vm.pageSize = DEFAULT_PAGE_SIZE;
        vm.locationDisplayLimit = 0;
        vm.selectedProgram = -1;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.supportedLocations = [];
        vm.locations = [];
        vm.allowedLocations = [];
        vm.adminPrograms = [{'name': 'Add all dealers in...', 'id': -1}];
        vm.locationsLoaded = false;

        function computeHasMorePages(response, itemCount) {
            return response.hasNextPage === true || (response.hasMorePages !== false && itemCount === vm.pageSize);
        }

        function createSelectedLocation(item) {
            let location = {
                ...item,
                dealerEmployee: null,
                currentPage: 1,
                hasMoreEmployees: true,
                employees: [],
                displayedEmployees: [],
                employeesProcessed: false
            };

            if (location.dmsSystem !== 0) {
                location.dealerEmployee = nonIntegratedUser;
            }

            return location;
        }

        function createMappedLocation(location) {
            return {
                ...location,
                employees: location.employees || [],
                displayedEmployees: [],
                employeesProcessed: false
            };
        }

        function resetAndReloadLocations(clearSelectedLocations) {
            vm.currentLocation = null;
            vm.currentPage = 0;
            vm.removedLocations = [];

            if (clearSelectedLocations) {
                vm.selectedLocations = [];
            }

            loadInitialData();
        }

        function resetLocationSelectorState() {
            vm.currentLocation = null;
            vm.locationDisplayLimit = 0;
        }

        function isLocAlreadyAssigned(locationId) {
            return vm.alreadyAssignedLocIds.has(locationId);
        }

        function loadInitialData() {
            vm.isInitialLoading = true;

            userService.getEmployeeMapping($transition$.params().userId, vm.currentPage, vm.pageSize).then((response) => {
                    let initialLocations = [];

                    if (response && response.results) {
                        initialLocations = response.results;
                        vm.hasMorePages = computeHasMorePages(response, initialLocations.length);
                    } else if (Array.isArray(response)) {
                        initialLocations = response;
                        vm.hasMorePages = initialLocations.length === vm.pageSize;
                    }

                    vm.selectedLocations = initialLocations.map(createMappedLocation);

                    // Snapshot the IDs that exist on the server — newly added locations won't be in here
                    vm.alreadyAssignedLocIds = new Set(initialLocations.map(loc => loc.id));

                    // Snapshot the initial mapping state for change detection
                    vm.initialMappingSnapshot = {};
                    initialLocations.forEach(loc => {
                        vm.initialMappingSnapshot[loc.id] = {
                            employeeId: loc.dealerEmployee ? loc.dealerEmployee.id : null,
                            enableAutomation: loc.dealerEmployee ? (loc.dealerEmployee.enableAutomation || false) : false
                        };
                    });

                    vm.currentPage++;
                }).catch(() => {
                    eventAlertService.createAlert('Error loading locations. Please try again.', 'danger');
                }).finally(() => {
                    vm.isInitialLoading = false;
                });
        }

        loadInitialData();

        locationService.getLocations().then((locationList) => {
            vm.locations = locationList;
            vm.allowedLocations = locationList;
            vm.supportedLocations = locationList;
            vm.locationsLoaded = true;

            // Process admin programs
            let programsMap = {};

            locationList.forEach((location) => {
                location.locationHtml = location.name;

                switch (location.status) {
                    case 1:
                        location.statusText = 'Active';
                        break;
                    case 2: 
                        location.statusText = 'QA';
                        break;
                    case 3: 
                        location.statusText = 'Install';
                        break;
                    default:
                        location.statusText = 'Disabled';
                        break;
                }

                let key = location.adminConfigId + '-' + location.adminProgramName;

                if (!programsMap[key]) {
                    programsMap[key] = {'name': location.adminProgramName, 'id': location.adminConfigId};
                    vm.adminPrograms.push(programsMap[key]);
                }
            });
        });
        
        vm.loadMoreLocations = function () {
            if (vm.isLoadingMore || !vm.hasMorePages) {
                return;
            }

            vm.isLoadingMore = true;

            userService.getEmployeeMapping($transition$.params().userId, vm.currentPage, vm.pageSize).then((response) => {
                    let newLocations = [];

                    if (response?.results) {
                        newLocations = response.results;
                        vm.hasMorePages = computeHasMorePages(response, newLocations.length);
                    } else if (Array.isArray(response)) {
                        newLocations = response;
                        vm.hasMorePages = newLocations.length === vm.pageSize;
                    }

                    if (newLocations.length > 0) {
                        let processedLocations = newLocations.map(createMappedLocation);

                        $timeout(() => {
                            vm.selectedLocations = vm.selectedLocations.concat(processedLocations);

                            // Also snapshot these paginated locations for change detection
                            newLocations.forEach(loc => {
                                vm.alreadyAssignedLocIds.add(loc.id);
                                vm.initialMappingSnapshot[loc.id] = {
                                    employeeId: loc.dealerEmployee ? loc.dealerEmployee.id : null,
                                    enableAutomation: loc.dealerEmployee ? (loc.dealerEmployee.enableAutomation || false) : false
                                };
                            });

                            vm.currentPage++;
                        });
                    } else {
                        vm.hasMorePages = false;
                    }
                }).catch(() => {
                    vm.hasMorePages = false;
                }).finally(() => {
                    $timeout(() => {
                        vm.isLoadingMore = false;
                    });
                });
        };

        vm.locationsFilter = function (locationName) {
            if (locationName.length >= 1) {
                webworkerService.filter(vm.locations, locationName, false, 'locationHtml').then((result) => {
                    vm.locationDisplayLimit = result.length;
                    finish(result);
                });
            } else {
                vm.locationDisplayLimit = displayLimit;
                finish(vm.locations);
            }

            function finish(locations) {
                let selectedIds = vm.selectedLocations.map(loc => loc.id);

                vm.supportedLocations = locations.filter(loc => !selectedIds.includes(loc.id));
            }
        };

        vm.resetFields = function () {
            resetAndReloadLocations(false);
        };

        function toMappingDto(loc) {
            return {
                DealerId: loc.id,
                EmployeeId: loc.dealerEmployee ? loc.dealerEmployee.id : null,
                EmployeeNumber: loc.dealerEmployee ? loc.dealerEmployee.employeeNumber : null,
                EnableAutomation: loc.dealerEmployee ? loc.dealerEmployee.enableAutomation : null
            };
        }

        vm.updateUser = function (isConfirmed, selectedServiceAdvisors) {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            // --- Build delta: only send added, removed, and edited locations ---
            let addedMappings = vm.selectedLocations.filter(loc => !isLocAlreadyAssigned(loc.id)).map(toMappingDto);

            let removedMappings = vm.removedLocations.filter(loc => isLocAlreadyAssigned(loc.id)).map(toMappingDto);    

            let editedMappings = vm.selectedLocations.filter(loc => {
                    if (!isLocAlreadyAssigned(loc.id)) return false;

                    let initial = vm.initialMappingSnapshot[loc.id];

                    if (!initial) return false;

                    let currentEmpId = loc.dealerEmployee ? loc.dealerEmployee.id : null;
                    let currentEnableAutomation = loc.dealerEmployee ? loc.dealerEmployee.enableAutomation : false;

                    return currentEmpId !== initial.employeeId || currentEnableAutomation !== initial.enableAutomation;
                }).map(toMappingDto);

            // Skip API call if nothing changed
            if (!addedMappings.length && !removedMappings.length && !editedMappings.length) {
                vm.isSaving = false;
                eventAlertService.createAlert('No changes to save.', 'info');

                return;
            }

            let postData = {
                IsForcedUpdateConfirmed: !!isConfirmed,
                addedMappings: addedMappings,
                removedMappings: removedMappings,
                editedMappings: editedMappings,
                replacementAdvisorMappings: []
            };

            if (selectedServiceAdvisors && vm.removedLocations.length > 0) {
                vm.removedLocations.forEach((removedLoc) => {
                    let advisorMappings = selectedServiceAdvisors[removedLoc.id];

                    if (advisorMappings && advisorMappings.length > 0) {
                        advisorMappings.forEach((mapping) => {
                            postData.replacementAdvisorMappings.push({
                                DealerId: mapping.locationId,
                                DepartmentId: mapping.departmentId,
                                EmployeeId: mapping.advisor.id,
                                EmployeeNumber: mapping.advisor.employeeNumber,
                                EnableAutomation: mapping.advisor.enableAutomation || false
                            });
                        });
                    }
                });
            }

            userService.updateEmployeeMapping(vm.currentUser.id, postData).then((response) => {
                // Backend returns enriched conflict object or true on success.
                if (response?.affectedDealerIds?.length > 0) {
                    let affectedDealerIds = response.affectedDealerIds;
                    let affectedLocationsDetails = response.affectedLocations;
                    let reassignmentRulesByLocationId = {};

                    affectedLocationsDetails.forEach((details) => {
                        reassignmentRulesByLocationId[details.dealerId] = {
                            departmentIds: details.departmentIds,
                            requiresLocationLevelSelection: details.requiresLocationLevelSelection
                        };
                    });

                    // Filter removed locations to only those the backend confirmed have related ROs/appointments
                    let locationsNeedingAdvisor = vm.removedLocations.filter(loc => affectedDealerIds.includes(loc.id));

                    if (locationsNeedingAdvisor.length > 0 && !selectedServiceAdvisors) {
                        modalService.selectServiceAdvisor(
                            locationsNeedingAdvisor,
                            'Select New Service Advisor',
                            'This user may be associated with Service Orders or Appointments. Please choose a new service advisor for each location below to reassign any items this user is currently associated with:',
                            vm.currentUser,
                            reassignmentRulesByLocationId
                        ).then((advisors) => {
                            vm.updateUser(true, advisors);
                        }).catch(() => {
                            resetAndReloadLocations(true);
                        });
                    } else {
                        vm.updateUser(true, selectedServiceAdvisors);
                    }
                } else {
                    // Reload fresh data from server to confirm the update was saved
                    resetAndReloadLocations(true);
                    eventAlertService.createAlert('User Locations Successfully Updated.');
                }
            }).catch(() => {
                eventAlertService.createAlert('Unable to update user locations. Please try again.', 'danger');
            }).finally(() => {
                vm.isSaving = false;
            });
        };

        vm.locationSelected = function (item) {
            let found = vm.selectedLocations.find(l => l.id === item.id);

            if (!found) {
                let loc = createSelectedLocation(item);

                vm.removedLocations = vm.removedLocations.filter((location) => location.id !== item.id);

                vm.selectedLocations.push(loc);
                vm.supportedLocations = vm.supportedLocations.filter((location) => location.id !== item.id);
                resetLocationSelectorState();
            }
        };

        vm.loadEmployees = function (loc, searchText, isPagedLoad) {
            if (!loc.employeesProcessed && loc.employees && loc.employees.length > 0) {
                loc.employees = createEmployeeHtml(loc.employees);
                loc.employeesProcessed = true;
            }

            if (!searchText) {
                searchText = '';
            }

            if (!isPagedLoad) {
                loc.currentPage = 1;
                loc.hasMoreEmployees = true;
                loc.employees = [];
                loc.pageSize = DEFAULT_PAGE_SIZE; 
            }

            employeeService.getEmployeesByLocationPaged(loc.id, true, loc.currentPage, searchText).then((response) => {
                loc.pageSize = response.pageSize || DEFAULT_PAGE_SIZE;

                let newEmployees = createEmployeeHtml(response.employees);

                if (isPagedLoad) {
                    let existingIds = loc.employees.map((e) => e.id);
                    let uniqueNewEmployees = newEmployees.filter((e) => existingIds.indexOf(e.id) === -1);

                    loc.employees = loc.employees.concat(uniqueNewEmployees);
                } else {
                    loc.employees = newEmployees;
                }

                loc.displayedEmployees = loc.employees;
                loc.currentPage++;

                if (response.employees.length < loc.pageSize) {
                    loc.hasMoreEmployees = false;
                }
            });
        };

        vm.removeLocation = function (id) {
            if (vm.isOnlyDealerAdmin === true) {
                let filteredResults = vm.selectedLocations.filter((e) => {
                    return vm.filterOnlyLocationsWithPermission(e);
                });

                if (filteredResults.length === 1) {
                    modalService.showYesNo('Error', 'The user must have at least one assigned location.', null, 'OK');

                    return;
                }
            }

            let locationToRemove = vm.selectedLocations.find((item) => item.id === id);

            if (locationToRemove) {
                // Only track as removed if it was committed to the server (not newly added this session)
                if (isLocAlreadyAssigned(locationToRemove.id) && !vm.removedLocations.some((location) => location.id === locationToRemove.id)) {
                    vm.removedLocations.push(locationToRemove);
                }

                vm.selectedLocations = vm.selectedLocations.filter((item) => item.id !== id);
            }
        };

        vm.addMultipleLocations = function (adminConfigId) {
            if (adminConfigId === -1) {
                return;
            }

            if (!vm.locationsLoaded || vm.locations.length === 0) {
                eventAlertService.createAlert('Please wait for locations to load...', 'warning');
                vm.selectedProgram = -1;

                return;
            }

            let selectedIds = new Set(vm.selectedLocations.map(loc => loc.id));
            let locationsToAdd = vm.locations.filter(location =>
                location.adminConfigId === adminConfigId &&
                !selectedIds.has(location.id) &&
                !isLocAlreadyAssigned(location.id)
            );

            if (locationsToAdd.length === 0) {
                eventAlertService.createAlert(`No new locations to add for this ${vm.selectedProgram} program.`, 'info');
                vm.selectedProgram = -1;

                return;
            }

            locationsToAdd.forEach((location) => {
                vm.selectedLocations.push(createSelectedLocation(location));
            });
           
            let addedIds = locationsToAdd.map(loc => loc.id);

            vm.supportedLocations = vm.supportedLocations.filter(loc => !addedIds.includes(loc.id));
            resetLocationSelectorState();
        };

        vm.uiSelectEmployeesNgBindHtml = function (employee, truncate) {
            return createNgBindHtml(employee, truncate);
        };

        vm.addToBulkSurveyList = function (dealerId) {
            let confirm = modalService.showYesNo('Survey Bulk CC', 'Are you sure you want to add this user to all Survey bulk lists for this dealer?', 'Cancel', 'Yes');

            confirm.then((isConfirmed) => {
                if (isConfirmed) {
                    userService.addUserBulkCC(vm.currentUser.id, dealerId, true, false);
                }
            });
        };

        vm.addToBulkNotificationList = function (dealerId) {
            let confirm = modalService.showYesNo('Notification Bulk CC', 'Are you sure you want to add this user to all Notifications bulk lists for this dealer?', 'Cancel', 'Yes');

            confirm.then((isConfirmed) => {
                if (isConfirmed) {
                    userService.addUserBulkCC(vm.currentUser.id, dealerId, false, true);
                }
            });
        };

        vm.filterOnlyLocationsWithPermission = function (loc) {
            if (!vm.isOnlyDealerAdmin) return true;

            let location = $filter('filter')(vm.allowedLocations, {id: loc.id}, true);

            return location && location.length > 0;
        };

        function createEmployeeHtml (employees) {
            let uniqueEmployees = [];
            let seenEmployeeIds = new Set();

            employees.forEach((employee) => {
                if (employee.id != null && seenEmployeeIds.has(employee.id)) {
                    return;
                }

                if (employee.id != null) {
                    seenEmployeeIds.add(employee.id);
                }

                employee.employeeHtml = createNgBindHtml(employee);
                employee.employeeHtmlTruncated = truncateEmployeeName(employee.employeeHtml);
                uniqueEmployees.push(employee);
            });

            // add a non-integrated user that will create a new user for the dealer employee
            if (!seenEmployeeIds.has(nonIntegratedUser.id)) {
                uniqueEmployees.splice(0, 0, nonIntegratedUser);
            }

            return uniqueEmployees;
        }

        function createNgBindHtml (employee, truncate) {
            let nameEmployeeNumber = '';

            if (employee) {
                let separator = (employee.fullName == null || employee.employeeNumber == null) ? '' : ' : ';

                nameEmployeeNumber =  employee.fullName + separator + employee.employeeNumber;
            }

            if (truncate) {
                return truncateEmployeeName(nameEmployeeNumber);
            }

            return nameEmployeeNumber;
        }

        function truncateEmployeeName(nameEmployeeNumber) {
            let truncate = nameEmployeeNumber.substring(0, 25);

            if (nameEmployeeNumber.length > 25) {
                return truncate + '...';
            }

            return truncate;
        }
    }
})();
(function () {
    'use strict';

    UserTabGeneralController.$inject = ["userService", "USER_TITLES", "$transition$", "resolvedUser", "eventAlertService", "appointmentUtilService"];
    angular
        .module('redcap.user')
        .controller('UserTabGeneralController', UserTabGeneralController);

    function UserTabGeneralController(userService, USER_TITLES, $transition$, resolvedUser, eventAlertService, appointmentUtilService) {
        let vm = this;

        vm.currentUser = resolvedUser;
        vm.titles = USER_TITLES;

        vm.validation = {
            phoneNumberRequired: function (number) {
                return appointmentUtilService.validatePhoneNumber(number);
            }
        };

        if ($transition$.params().userAdded &&  $transition$.params().userAdded === 'true') {
            vm.userAdded = true;
        }

        vm.profilePic = {
            profileImageUpload: null,
            profileImage: null
        };

        vm.clickFileInput = function() {
            angular.element(document.querySelector('#fileInput')).click();
        };

        vm.updateUser = function () {
            if (vm.profilePic.profileImage) {
                vm.currentUser.profilePicture = vm.profilePic.profileImage;
            } else {
                vm.currentUser.profilePicture = null;
            }
            
            userService.updateUser(vm.currentUser).then((response) => {
                eventAlertService.createAlert('User updated!');
            });
        };
    }
})();

(function () {
    'use strict';

    UserListController.$inject = ["$scope", "$timeout", "rcLocalStorageService", "userService", "resolvedLocationList", "rcUtilService", "resolvedRoles"];
    angular
        .module('redcap.user')
        .controller('UserListController', UserListController);

    function UserListController($scope, $timeout, rcLocalStorageService, userService, resolvedLocationList, rcUtilService, resolvedRoles) {
        let vm = this;
        let displayLimit = 30;
        let page = 0;
        let multiSelectConfig = {
            '.chosen-select': {},
            '.chosen-select-deselect': {allow_single_deselect: true},
            '.chosen-select-no-single': {disable_search_threshold: 10},
            '.chosen-select-no-results': {no_results_text: 'Oops, nothing found!'},
            '.chosen-select-width': {width: "95%"}
        };

        let initialFilters = { 
            searchInput: [],
            filterByLocations: [],
            activeStatus: 'true',
            filterByUserRole: null
        };
        let initialSort = {
            sortDirection: "asc",
            sortBy: null
        };

        let savedFilterKey = "userListSavedFilterKey";
        let savedSortKey = "userListSavedSortKey";
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};
        let existingSort = rcLocalStorageService.get(savedSortKey) || {};

        for (let selector in multiSelectConfig) {
            $(selector).chosen(multiSelectConfig[selector]);
        }

        vm.showAdvancedSearch  = false;
        vm.systemRoles = resolvedRoles || [];

        let parentRoles = resolvedRoles.filter(role => !role.parentRole);

        parentRoles.sort((a, b) => a.name.localeCompare(b.name));
        let childRoles = resolvedRoles.filter(role => role.parentRole);

        childRoles.sort((a, b) => a.name.localeCompare(b.name));

        let sortedRoles = [];

        parentRoles.forEach(parentRole => {
            sortedRoles.push(parentRole);
            let roleChildRoles = childRoles.filter(role => role.parentRole.name === parentRole.name);

            sortedRoles.push(...roleChildRoles);
        });
        
        vm.systemRoles = sortedRoles;

        _.forEach(resolvedLocationList, (location) => {
            location.displayText = rcUtilService.formatLocationForDropdown(location);
        });

        _.forEach(resolvedRoles, (role) => {
            role.displayText = (role.displayName ? role.displayName : role.name);

            if (role.parentRole) {
                role.displayText = ' - ' + role.displayText;
            }
        });

        vm.locations = resolvedLocationList;
        vm.roleUsers = resolvedRoles;
        vm.filteredUsers = [];
        vm.loading = false;
        vm.canShowMore = true;
        vm.sorting = {
            user: 0,
            name: 1
        };

        function refreshSearch() {
            if (vm.isLoading)
                return $timeout(refreshSearch, 100);

            page = 0;
            vm.filteredUsers = [];
            vm.canShowMore = true;
            vm.searchUsers();
        }

        vm.sortClicked = function (type) {
            if (vm.sort.sortBy !== type || vm.sort.sortDirection !== 'asc') {
                vm.sort.sortDirection = "asc";
            } else {
                vm.sort.sortDirection = "desc";
            }

            vm.sort.sortBy = type;

            refreshSearch();
        };
       

        vm.searchUsers = function () {
            if (vm.isLoading)
                return;

            vm.isLoading = true;
            
            let filter = {
                query: _.map(vm.filters.searchInput, (item) => { return item.text; }),
                dealerIds: vm.locations.length > 1 ?  vm.filters.filterByLocations : [],
                activeOnly: vm.filters.activeStatus === 'all' ? null : vm.filters.activeStatus === 'true',
                page: page,
                pageSize: displayLimit,
                sortType: vm.sort.sortBy,
                sortAsc: vm.sort.sortDirection === 'asc',
                roleUserId: vm.systemRoles.length > 1 ?  (vm.filters.filterByUserRole != '' ? vm.filters.filterByUserRole : null) : null
            };
            
            userService.getUsers(filter).then((result) => {
                if (result.length === 0 || result.length < displayLimit) {
                    vm.canShowMore = false;
                }

                if (result.length > 0) {
                    vm.filteredUsers = vm.filteredUsers.concat(result);
                }

                vm.isLoading = false;
                page++;
                vm.filterMessage = createFilterMessage();
            }, (error) => {
                vm.isLoading = false;
            });

        };

        function createFilterMessage() {
            let message = '';

            vm.filterCount = 0;

            if (vm.filters.searchInput && vm.filters.searchInput.length > 0) {
                message += '<i><b>Keyword</b>: ';
                message += vm.filters.searchInput.map((input) => { return input['text']; });
                message += '</i>&nbsp;&nbsp;';
            }

            if (vm.filters.filterByLocations && vm.filters.filterByLocations.length > 0) {
                let tempLocs = [];

                vm.filterCount ++;
                _.forEach(vm.filters.filterByLocations, (locationId) => {
                    tempLocs.push(_.find(vm.locations, (location) => { return location.id === locationId; }));
                });
                message += '<i><b>Location</b>: ';
                message += tempLocs.map((location) => { return location['name']; });
                message += '</i>&nbsp;&nbsp;';
            }

            if (vm.filters.filterByUserRole != null) {
                let roleSelected = _.find(vm.systemRoles, {id: vm.filters.filterByUserRole});
                let roleName = roleSelected ? roleSelected.displayText : "";

                vm.filterCount ++;
                message += '<i><b>User Role</b>: ';
                message += roleName;
                message += '</i>&nbsp;&nbsp;';
               
            }

            if (vm.filters.activeStatus !== 'all') {
                vm.filterCount ++;
                message += '<i><b> Status: </b>' + (vm.filters.activeStatus === 'true' ? 'Active' : 'Inactive') + '</i>';
            }


            if (message.length > 0)
                message = 'Showing results for ' + message;

            return message;
        }

        vm.filtersChanged = function () {
            rcLocalStorageService.set(savedFilterKey, vm.filters);
            refreshSearch();
        };

        vm.toggleShowSearchOptions = function () {
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

            if (vm.showAdvancedSearch) {
                vm.searchUsers();
            }

            vm.showAdvancedSearch  = !vm.showAdvancedSearch;
        };

        vm.applyBtnClicked = function () {
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            vm.searchUsers();
        };

        // this will unregister itself when the scope is destroyed, nothing to manually clean up
        $scope.$on('UserService.changed', (event, data) => {
            refreshSearch();
        });

        vm.close = function () {
            // set the filters back because they didn't apply them.
            vm.filters = vm.filtersBeforeAdvancedSearch;
            vm.showAdvancedSearch = false;
        };


        function init() {
            vm.filters = _.extend({}, initialFilters, existingFilters);
            vm.sort = _.extend({}, initialSort, existingSort);
        }

        init();
    }
})();

(function () {
    'use strict';

    UserEditController.$inject = ["$state", "$scope", "resolvedUser"];
    angular
        .module('redcap.user')
        .controller('UserEditController', UserEditController);

    function UserEditController($state, $scope, resolvedUser) {
        var vm = this;
        vm.tabs = '';

        vm.currentUser = resolvedUser;
        vm.titleUser = _.trim(_.toString(vm.currentUser.fullName)) !== '' ? vm.currentUser.fullName : vm.currentUser.userName + ' (Login)';

        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });

        vm.initTabContainers = function () {

            vm.tabs = [{
                title: 'General',
                route: 'user-tab-general',
                active: false
            },
            {
                title: 'Security',
                route: 'user-tab-security',
                active: false
            },
            {
                title: 'Locations',
                route: 'user-tab-locations',
                active: false
            },
            {
                title: 'Settings',
                route: 'user-tab-settings',
                active: false
            }];

            vm.tabs.forEach(function (tab) {
                tab.active = $state.name === tab.route;
            });
        };

        vm.initTabContainers();



    }
})();

(function () {
    'use strict';

    UserAddController.$inject = ["$log", "$scope", "$state", "$timeout", "toastr", "locationService", "modalService", "appointmentUtilService", "webworkerService", "userService", "fileReaderService", "resolvedLocationList", "SYSTEM_ENUMS", "USER_TITLES", "permissions"];
    angular
        .module('redcap.user')
        .controller('UserAddController', UserAddController);

    function UserAddController($log, $scope, $state, $timeout, toastr, locationService, modalService, appointmentUtilService, 
        webworkerService, userService, fileReaderService, resolvedLocationList, SYSTEM_ENUMS, USER_TITLES, permissions) {
        let vm = this;
        let pageSize = 25;
        let displayLimit = 25;

        vm.systemEnums = SYSTEM_ENUMS;
        vm.titles = USER_TITLES;
        vm.showUserImport = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.userAddMode = '1';
        vm.isLoadingData = false;
        vm.forceDisplayLocationSelection = false;
        // gray out form fields until user name confirmed as available
        vm.fieldsDisabled = true;
        vm.locationDisplayLimit = displayLimit;

        _.forEach(resolvedLocationList, (location) => {
            location.locationHtml = locationService.getLocationHTML(location, true);
        });

        vm.locations = resolvedLocationList;

        vm.validation = {
            phoneNumberRequired: function (number) {
                return appointmentUtilService.validatePhoneNumber(number);
            }
        };

        vm.locationsFilter = function (locationName) {
            if (locationName.length >= 1) {
                webworkerService.filter(resolvedLocationList, locationName, false, 'locationHtml')
                    .then ((result) => {
                        vm.locations = result;
                        vm.locationDisplayLimit = result.length;
                    });
            } else {
                vm.locationDisplayLimit = displayLimit;
            }
        };

        vm.locationSelected = function (item, model) {
            vm.homeDealerId = item.id;
        };

        vm.createUser = function () {
            // PREPARE DATA
            $log.debug('vm', vm);

            if (vm.isOnlyDealerAdmin === true) {
                vm.enableEmailCC = true;
            }

            let newUser = {
                userName: vm.userName,
                password: vm.password,
                firstName: vm.firstName,
                lastName: vm.lastName,
                mobilePhone: vm.mobilePhone,
                officePhone: vm.officePhone,
                email: vm.emailAddress,
                enableEmailCC: vm.enableEmailCC,
                sendWelcomeEmail: vm.isOnlyDealerAdmin === true ? true : vm.sendWelcomeEmail,
                homeDealerId: vm.sendWelcomeEmail || vm.isOnlyDealerAdmin === true ? vm.homeDealerId : null,
                allSurveysCC: vm.allSurveysCC,
                allNotificationsCC: vm.allNotificationsCC
            };

            userService.addUser(newUser).then((response) => {
                toastr.success('New User Successfully Added. Redirecting in 2 seconds...');
                // close panel
                $scope.$dismiss();

                vm.resetFields();

                $timeout(() => {
                    $state.go('user-tab-general', {userId: response, userAdded: true});
                }, 2000);
            }, (errorResponse) => {
                let errorMessage = 'An error occurred';

                if (errorResponse.data && errorResponse.data.exceptionMessage)
                    errorMessage = errorResponse.data.exceptionMessage;
                toastr.error(errorMessage);
            });
        };

        vm.resetFields = function () {
            vm.fieldsDisabled = true;
            vm.userName = '';
            vm.password = '';
            vm.passwordConfirm = '';
            vm.firstName = '';
            vm.lastName = '';
            vm.mobilePhone = '';
            vm.officePhone = '';
            vm.emailAddress = '';
            vm.homeDealerId = null;
            vm.enableEmailCC = false;
            vm.ccAllSurveys = false;
            vm.ccAllNotifications = false;
        };

        vm.employeeTitleCheck = function (value) {
            return {isValid: vm.titles.indexOf(value) >= 0, message: 'Field is required.'};
        };

        vm.userNameRemoteValidationCheck = function () {
            if (vm.isOnlyDealerAdmin) {
                // for dealer admins we're defaulting this
                vm.emailAddress = vm.userName;
            }

            return userService.checkIfUserExists(vm.userName).then((response) => {
                vm.fieldsDisabled = !response.isValid;

                return response;
            });
        };

        vm.passwordRemoteValidationCheck = function () {
            return userService.checkPassword(vm.password);
        };

        // required listener for form
        $scope.$on('form.locator', (event, formCtrl) => {
            vm.childScopeForm = formCtrl;
        });

        vm.resetFields();

        // determine if we need to display the home location drop down 
        // or just set to the only dealer for Dealer Admins.
        if (vm.isOnlyDealerAdmin === true && vm.locations.length > 1) {
            vm.forceDisplayLocationSelection = true;
        } else if (vm.isOnlyDealerAdmin === true && vm.locations.length === 1) {
            vm.homeDealerId = vm.locations[0].id;
        }

        vm.userSearchQuery = {
            type: 'GET',
            dataType: 'json',
            data: function (parameters) {
                let query = {
                    query: [parameters.term],
                    dealerIds: vm.filterByLocations,
                    page: !parameters.page ? 0 : parameters.page,
                    pageSize: pageSize
                };

                return query;
            },
            transport: function (params, success, failure) {
                let data = params.data;

                return userService.getUsers(data).then(success, failure);
            },
            delay: 250,
            processResults: function (data) {
                return {
                    results: data,
                    pagination: {
                        more: data.length === pageSize
                    }
                };
            }
        };

        vm.formatForUserSelection = function (user) {
            if (user && user.fullName && user.userName) {
                return user.fullName + ' : ' + user.userName;
            }
        };

        vm.formatForUserDropdown = function (user) {
            if (user && user.fullName && user.userName) {
                return user.fullName + ' : ' + user.userName;
            }
        };

        vm.chooseImportFile = function(file) {
            let reader = new FileReader();
            
            vm.bulkImport = {};
            vm.readingFile = true;
            reader.readAsDataURL(file);

            reader.onload = function() {
                vm.readingFile = false;

                vm.bulkImport = {
                    file: file,
                    base64FileData: reader.result,
                    fileName: file.name
                };
            };
        };

        vm.importUsers = function() {
            let confirm = modalService.showYesNo('Please Confirm', 'You are about to import all records in the import file into the system, are you sure you want to proceed?', 'No', 'Yes');
            
            confirm.then((confirmed) => {
                if (confirmed) {
                    vm.importCompleted = false;
                    vm.isLoadingData = true;
                    let importUserId = vm.importUser ? vm.importUser.id : null;

                    userService.bulkImportUsers(vm.bulkImport.base64FileData, importUserId).then((uploadResults) => {
                        let csvFile = uploadResults;
                        let filename = 'user_upload_completed.csv';

                        fileReaderService.saveToDisk(csvFile, filename);
                        vm.importCompleted = true;
                    }).catch((err) => {
                        console.error(err);
                    }).finally(() => {
                        vm.isLoadingData = false;
                        vm.bulkImport = {};
                    });
                }
            });
        };
    }
})();

/*!
 * html2pdf.js v0.10.2
 * Copyright (c) 2024 Erik Koopmans
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("html2pdf", [], factory);
	else if(typeof exports === 'object')
		exports["html2pdf"] = factory();
	else
		root["html2pdf"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/array/from.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/array/from.js ***!
  \**************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/array/from */ "./node_modules/core-js-pure/stable/array/from.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/array/is-array.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/array/is-array.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/array/is-array */ "./node_modules/core-js-pure/stable/array/is-array.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/date/now.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/date/now.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/date/now */ "./node_modules/core-js-pure/stable/date/now.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/bind.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/bind.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/bind */ "./node_modules/core-js-pure/stable/instance/bind.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/concat.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/concat.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/concat */ "./node_modules/core-js-pure/stable/instance/concat.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/every.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/every.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/every */ "./node_modules/core-js-pure/stable/instance/every.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/fill.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/fill.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/fill */ "./node_modules/core-js-pure/stable/instance/fill.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/filter.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/filter.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/filter */ "./node_modules/core-js-pure/stable/instance/filter.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/for-each.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/for-each.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/for-each */ "./node_modules/core-js-pure/stable/instance/for-each.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/includes.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/includes.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/includes */ "./node_modules/core-js-pure/stable/instance/includes.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/index-of.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/index-of.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/index-of */ "./node_modules/core-js-pure/stable/instance/index-of.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/map.js":
/*!****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/map.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/map */ "./node_modules/core-js-pure/stable/instance/map.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reduce.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reduce.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/reduce */ "./node_modules/core-js-pure/stable/instance/reduce.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reverse.js":
/*!********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reverse.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/reverse */ "./node_modules/core-js-pure/stable/instance/reverse.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/slice.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/slice.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/slice */ "./node_modules/core-js-pure/stable/instance/slice.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/some.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/some.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/some */ "./node_modules/core-js-pure/stable/instance/some.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/starts-with.js":
/*!************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/starts-with.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/starts-with */ "./node_modules/core-js-pure/stable/instance/starts-with.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/trim.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/trim.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/trim */ "./node_modules/core-js-pure/stable/instance/trim.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/values.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/values.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/instance/values */ "./node_modules/core-js-pure/stable/instance/values.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/map.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/map.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/map */ "./node_modules/core-js-pure/stable/map/index.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-properties.js":
/*!****************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-properties.js ***!
  \****************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/object/define-properties */ "./node_modules/core-js-pure/stable/object/define-properties.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-property.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-property.js ***!
  \**************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/object/define-property */ "./node_modules/core-js-pure/stable/object/define-property.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor.js":
/*!**************************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor.js ***!
  \**************************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/object/get-own-property-descriptor */ "./node_modules/core-js-pure/stable/object/get-own-property-descriptor.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js":
/*!***************************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js ***!
  \***************************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/object/get-own-property-descriptors */ "./node_modules/core-js-pure/stable/object/get-own-property-descriptors.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols.js":
/*!***********************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols.js ***!
  \***********************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/object/get-own-property-symbols */ "./node_modules/core-js-pure/stable/object/get-own-property-symbols.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/keys.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/object/keys.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/object/keys */ "./node_modules/core-js-pure/stable/object/keys.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/parse-float.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/parse-float.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/parse-float */ "./node_modules/core-js-pure/stable/parse-float.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/parse-int.js":
/*!*************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/parse-int.js ***!
  \*************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/parse-int */ "./node_modules/core-js-pure/stable/parse-int.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/promise.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/promise.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/promise */ "./node_modules/core-js-pure/stable/promise/index.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/apply.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/apply.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/reflect/apply */ "./node_modules/core-js-pure/stable/reflect/apply.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/reflect/construct */ "./node_modules/core-js-pure/stable/reflect/construct.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/delete-property.js":
/*!***************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/delete-property.js ***!
  \***************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/reflect/delete-property */ "./node_modules/core-js-pure/stable/reflect/delete-property.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/get-prototype-of.js":
/*!****************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/get-prototype-of.js ***!
  \****************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/reflect/get-prototype-of */ "./node_modules/core-js-pure/stable/reflect/get-prototype-of.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js-stable/symbol.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js-stable/symbol.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/stable/symbol */ "./node_modules/core-js-pure/stable/symbol/index.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/array/from.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/array/from.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/array/from */ "./node_modules/core-js-pure/features/array/from.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/array/is-array */ "./node_modules/core-js-pure/features/array/is-array.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js":
/*!****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/get-iterator-method */ "./node_modules/core-js-pure/features/get-iterator-method.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/get-iterator.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/get-iterator.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/get-iterator */ "./node_modules/core-js-pure/features/get-iterator.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/instance/slice.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/instance/slice.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/instance/slice */ "./node_modules/core-js-pure/features/instance/slice.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/object/create.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/object/create.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/object/create */ "./node_modules/core-js-pure/features/object/create.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/object/define-property.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/object/define-property.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/object/define-property */ "./node_modules/core-js-pure/features/object/define-property.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-descriptor.js":
/*!*******************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-descriptor.js ***!
  \*******************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/object/get-own-property-descriptor */ "./node_modules/core-js-pure/features/object/get-own-property-descriptor.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js":
/*!********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/object/get-prototype-of */ "./node_modules/core-js-pure/features/object/get-prototype-of.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js":
/*!********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/object/set-prototype-of */ "./node_modules/core-js-pure/features/object/set-prototype-of.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/promise.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/promise.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/promise */ "./node_modules/core-js-pure/features/promise/index.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/reflect/get.js":
/*!********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/reflect/get.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/reflect/get */ "./node_modules/core-js-pure/features/reflect/get.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/symbol.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/symbol.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/symbol */ "./node_modules/core-js-pure/features/symbol/index.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! core-js-pure/features/symbol/iterator */ "./node_modules/core-js-pure/features/symbol/iterator.js");

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayLikeToArray.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayLikeToArray.js ***!
  \*****************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithHoles.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithHoles.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/array/is-array */ "./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js");

function _arrayWithHoles(arr) {
  if (_babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__(arr)) return arr;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithoutHoles.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithoutHoles.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithoutHoles; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/array/is-array */ "./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js");
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayLikeToArray.js");


function _arrayWithoutHoles(arr) {
  if (_babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__(arr)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_1__.default)(arr);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/asyncToGenerator.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/asyncToGenerator.js ***!
  \*****************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/promise */ "./node_modules/@babel/runtime-corejs3/core-js/promise.js");


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    _babel_runtime_corejs3_core_js_promise__WEBPACK_IMPORTED_MODULE_0__.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new _babel_runtime_corejs3_core_js_promise__WEBPACK_IMPORTED_MODULE_0__(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/classCallCheck.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/classCallCheck.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/createClass.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/createClass.js ***!
  \************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/define-property */ "./node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    _babel_runtime_corejs3_core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/define-property */ "./node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _babel_runtime_corejs3_core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/get.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/get.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _get; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_reflect_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/reflect/get */ "./node_modules/@babel/runtime-corejs3/core-js/reflect/get.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/get-own-property-descriptor */ "./node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-descriptor.js");
/* harmony import */ var _superPropBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./superPropBase.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/superPropBase.js");



function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && _babel_runtime_corejs3_core_js_reflect_get__WEBPACK_IMPORTED_MODULE_0__) {
    _get = _babel_runtime_corejs3_core_js_reflect_get__WEBPACK_IMPORTED_MODULE_0__;
  } else {
    _get = function _get(target, property, receiver) {
      var base = (0,_superPropBase_js__WEBPACK_IMPORTED_MODULE_2__.default)(target, property);
      if (!base) return;

      var desc = _babel_runtime_corejs3_core_js_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_object_set_prototype_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/set-prototype-of */ "./node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/get-prototype-of */ "./node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js");


function _getPrototypeOf(o) {
  _getPrototypeOf = _babel_runtime_corejs3_core_js_object_set_prototype_of__WEBPACK_IMPORTED_MODULE_0__ ? _babel_runtime_corejs3_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_1__ : function _getPrototypeOf(o) {
    return o.__proto__ || _babel_runtime_corejs3_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_1__(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/inherits.js":
/*!*********************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/inherits.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_object_create__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/create */ "./node_modules/@babel/runtime-corejs3/core-js/object/create.js");
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./setPrototypeOf.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/setPrototypeOf.js");


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = _babel_runtime_corejs3_core_js_object_create__WEBPACK_IMPORTED_MODULE_0__(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__.default)(subClass, superClass);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArray.js":
/*!****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArray.js ***!
  \****************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/symbol */ "./node_modules/@babel/runtime-corejs3/core-js/symbol.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/get-iterator-method */ "./node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_array_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/array/from */ "./node_modules/@babel/runtime-corejs3/core-js/array/from.js");



function _iterableToArray(iter) {
  if (typeof _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ !== "undefined" && _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_1__(iter) != null || iter["@@iterator"] != null) return _babel_runtime_corejs3_core_js_array_from__WEBPACK_IMPORTED_MODULE_2__(iter);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArrayLimit.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArrayLimit.js ***!
  \*********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArrayLimit; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/symbol */ "./node_modules/@babel/runtime-corejs3/core-js/symbol.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/get-iterator-method */ "./node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js");


function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ !== "undefined" && _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_1__(arr) || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableRest.js":
/*!****************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableRest.js ***!
  \****************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableSpread.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableSpread.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableSpread; }
/* harmony export */ });
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/typeof */ "./node_modules/@babel/runtime-corejs3/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_babel_runtime_corejs3_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__.default)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__.default)(self);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_object_set_prototype_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/object/set-prototype-of */ "./node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js");

function _setPrototypeOf(o, p) {
  _setPrototypeOf = _babel_runtime_corejs3_core_js_object_set_prototype_of__WEBPACK_IMPORTED_MODULE_0__ || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/slicedToArray.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/slicedToArray.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithHoles.js");
/* harmony import */ var _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArrayLimit.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableRest.js");




function _slicedToArray(arr, i) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__.default)(arr) || (0,_iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__.default)(arr, i) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__.default)(arr, i) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__.default)();
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/superPropBase.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/superPropBase.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _superPropBase; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getPrototypeOf.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/getPrototypeOf.js");

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__.default)(object);
    if (object === null) break;
  }

  return object;
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/toConsumableArray.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/toConsumableArray.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _toConsumableArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithoutHoles.js");
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArray.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/nonIterableSpread.js");




function _toConsumableArray(arr) {
  return (0,_arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__.default)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__.default)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__.default)(arr) || (0,_nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__.default)();
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/typeof.js":
/*!*******************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/typeof.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/symbol */ "./node_modules/@babel/runtime-corejs3/core-js/symbol.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/symbol/iterator */ "./node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js");


function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ === "function" && typeof _babel_runtime_corejs3_core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_1__ === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ === "function" && obj.constructor === _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__ && obj !== _babel_runtime_corejs3_core_js_symbol__WEBPACK_IMPORTED_MODULE_0__.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/helpers/esm/unsupportedIterableToArray.js":
/*!***************************************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/helpers/esm/unsupportedIterableToArray.js ***!
  \***************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_slice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/instance/slice */ "./node_modules/@babel/runtime-corejs3/core-js/instance/slice.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/array/from */ "./node_modules/@babel/runtime-corejs3/core-js/array/from.js");
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime-corejs3/helpers/esm/arrayLikeToArray.js");



function _unsupportedIterableToArray(o, minLen) {
  var _context;

  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_2__.default)(o, minLen);

  var n = _babel_runtime_corejs3_core_js_instance_slice__WEBPACK_IMPORTED_MODULE_0__(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _babel_runtime_corejs3_core_js_array_from__WEBPACK_IMPORTED_MODULE_1__(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_2__.default)(o, minLen);
}

/***/ }),

/***/ "./node_modules/@babel/runtime-corejs3/regenerator/index.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime-corejs3/regenerator/index.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./src/plugin/hyperlinks.js":
/*!**********************************!*\
  !*** ./src/plugin/hyperlinks.js ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each.js */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.string.link.js */ "./node_modules/core-js/modules/es.string.link.js");
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _worker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../worker.js */ "./src/worker.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils.js */ "./src/utils.js");



 // Add hyperlink functionality to the PDF creation.
// Main link array, and refs to original functions.

var linkInfo = [];
var orig = {
  toContainer: _worker_js__WEBPACK_IMPORTED_MODULE_2__.default.prototype.toContainer,
  toPdf: _worker_js__WEBPACK_IMPORTED_MODULE_2__.default.prototype.toPdf
};

_worker_js__WEBPACK_IMPORTED_MODULE_2__.default.prototype.toContainer = function toContainer() {
  return orig.toContainer.call(this).then(function toContainer_hyperlink() {
    // Retrieve hyperlink info if the option is enabled.
    if (this.opt.enableLinks) {
      // Find all anchor tags and get the container's bounds for reference.
      var container = this.prop.container;
      var links = container.querySelectorAll('a');
      var containerRect = (0,_utils_js__WEBPACK_IMPORTED_MODULE_3__.unitConvert)(container.getBoundingClientRect(), this.prop.pageSize.k);
      linkInfo = []; // Loop through each anchor tag.

      Array.prototype.forEach.call(links, function (link) {
        // Treat each client rect as a separate link (for text-wrapping).
        var clientRects = link.getClientRects();

        for (var i = 0; i < clientRects.length; i++) {
          var clientRect = (0,_utils_js__WEBPACK_IMPORTED_MODULE_3__.unitConvert)(clientRects[i], this.prop.pageSize.k);
          clientRect.left -= containerRect.left;
          clientRect.top -= containerRect.top;
          var page = Math.floor(clientRect.top / this.prop.pageSize.inner.height) + 1;
          var top = this.opt.margin[0] + clientRect.top % this.prop.pageSize.inner.height;
          var left = this.opt.margin[1] + clientRect.left;
          linkInfo.push({
            page: page,
            top: top,
            left: left,
            clientRect: clientRect,
            link: link
          });
        }
      }, this);
    }
  });
};

_worker_js__WEBPACK_IMPORTED_MODULE_2__.default.prototype.toPdf = function toPdf() {
  return orig.toPdf.call(this).then(function toPdf_hyperlink() {
    // Add hyperlinks if the option is enabled.
    if (this.opt.enableLinks) {
      // Attach each anchor tag based on info from toContainer().
      linkInfo.forEach(function (l) {
        this.prop.pdf.setPage(l.page);
        this.prop.pdf.link(l.left, l.top, l.clientRect.width, l.clientRect.height, {
          url: l.link.href
        });
      }, this); // Reset the active page of the PDF to the final page.

      var nPages = this.prop.pdf.internal.getNumberOfPages();
      this.prop.pdf.setPage(nPages);
    }
  });
};

/***/ }),

/***/ "./src/plugin/jspdf-plugin.js":
/*!************************************!*\
  !*** ./src/plugin/jspdf-plugin.js ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.symbol.js */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.description.js */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator.js */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! jspdf */ "./node_modules/jspdf/dist/jspdf.es.min.js");








function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Import dependencies.
 // Get dimensions of a PDF page, as determined by jsPDF.

jspdf__WEBPACK_IMPORTED_MODULE_7__.jsPDF.getPageSize = function (orientation, unit, format) {
  // Decode options object
  if (_typeof(orientation) === 'object') {
    var options = orientation;
    orientation = options.orientation;
    unit = options.unit || unit;
    format = options.format || format;
  } // Default options


  unit = unit || 'mm';
  format = format || 'a4';
  orientation = ('' + (orientation || 'P')).toLowerCase();
  var format_as_string = ('' + format).toLowerCase(); // Size in pt of various paper formats

  var pageFormats = {
    'a0': [2383.94, 3370.39],
    'a1': [1683.78, 2383.94],
    'a2': [1190.55, 1683.78],
    'a3': [841.89, 1190.55],
    'a4': [595.28, 841.89],
    'a5': [419.53, 595.28],
    'a6': [297.64, 419.53],
    'a7': [209.76, 297.64],
    'a8': [147.40, 209.76],
    'a9': [104.88, 147.40],
    'a10': [73.70, 104.88],
    'b0': [2834.65, 4008.19],
    'b1': [2004.09, 2834.65],
    'b2': [1417.32, 2004.09],
    'b3': [1000.63, 1417.32],
    'b4': [708.66, 1000.63],
    'b5': [498.90, 708.66],
    'b6': [354.33, 498.90],
    'b7': [249.45, 354.33],
    'b8': [175.75, 249.45],
    'b9': [124.72, 175.75],
    'b10': [87.87, 124.72],
    'c0': [2599.37, 3676.54],
    'c1': [1836.85, 2599.37],
    'c2': [1298.27, 1836.85],
    'c3': [918.43, 1298.27],
    'c4': [649.13, 918.43],
    'c5': [459.21, 649.13],
    'c6': [323.15, 459.21],
    'c7': [229.61, 323.15],
    'c8': [161.57, 229.61],
    'c9': [113.39, 161.57],
    'c10': [79.37, 113.39],
    'dl': [311.81, 623.62],
    'letter': [612, 792],
    'government-letter': [576, 756],
    'legal': [612, 1008],
    'junior-legal': [576, 360],
    'ledger': [1224, 792],
    'tabloid': [792, 1224],
    'credit-card': [153, 243]
  }; // Unit conversion

  switch (unit) {
    case 'pt':
      var k = 1;
      break;

    case 'mm':
      var k = 72 / 25.4;
      break;

    case 'cm':
      var k = 72 / 2.54;
      break;

    case 'in':
      var k = 72;
      break;

    case 'px':
      var k = 72 / 96;
      break;

    case 'pc':
      var k = 12;
      break;

    case 'em':
      var k = 12;
      break;

    case 'ex':
      var k = 6;
      break;

    default:
      throw 'Invalid unit: ' + unit;
  } // Dimensions are stored as user units and converted to points on output


  if (pageFormats.hasOwnProperty(format_as_string)) {
    var pageHeight = pageFormats[format_as_string][1] / k;
    var pageWidth = pageFormats[format_as_string][0] / k;
  } else {
    try {
      var pageHeight = format[1];
      var pageWidth = format[0];
    } catch (err) {
      throw new Error('Invalid format: ' + format);
    }
  } // Handle page orientation


  if (orientation === 'p' || orientation === 'portrait') {
    orientation = 'p';

    if (pageWidth > pageHeight) {
      var tmp = pageWidth;
      pageWidth = pageHeight;
      pageHeight = tmp;
    }
  } else if (orientation === 'l' || orientation === 'landscape') {
    orientation = 'l';

    if (pageHeight > pageWidth) {
      var tmp = pageWidth;
      pageWidth = pageHeight;
      pageHeight = tmp;
    }
  } else {
    throw 'Invalid orientation: ' + orientation;
  } // Return information (k is the unit conversion ratio from pts)


  var info = {
    'width': pageWidth,
    'height': pageHeight,
    'unit': unit,
    'k': k
  };
  return info;
};

/* harmony default export */ __webpack_exports__["default"] = (jspdf__WEBPACK_IMPORTED_MODULE_7__.jsPDF);

/***/ }),

/***/ "./src/plugin/pagebreaks.js":
/*!**********************************!*\
  !*** ./src/plugin/pagebreaks.js ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.array.concat.js */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.slice.js */ "./node_modules/core-js/modules/es.array.slice.js");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.array.join.js */ "./node_modules/core-js/modules/es.array.join.js");
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each.js */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.keys.js */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _worker_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../worker.js */ "./src/worker.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils.js */ "./src/utils.js");







/* Pagebreak plugin:

    Adds page-break functionality to the html2pdf library. Page-breaks can be
    enabled by CSS styles, set on individual elements using selectors, or
    avoided from breaking inside all elements.

    Options on the `opt.pagebreak` object:

    mode:   String or array of strings: 'avoid-all', 'css', and/or 'legacy'
            Default: ['css', 'legacy']

    before: String or array of CSS selectors for which to add page-breaks
            before each element. Can be a specific element with an ID
            ('#myID'), all elements of a type (e.g. 'img'), all of a class
            ('.myClass'), or even '*' to match every element.

    after:  Like 'before', but adds a page-break immediately after the element.

    avoid:  Like 'before', but avoids page-breaks on these elements. You can
            enable this feature on every element using the 'avoid-all' mode.
*/
// Refs to original functions.

var orig = {
  toContainer: _worker_js__WEBPACK_IMPORTED_MODULE_5__.default.prototype.toContainer
}; // Add pagebreak default options to the Worker template.

_worker_js__WEBPACK_IMPORTED_MODULE_5__.default.template.opt.pagebreak = {
  mode: ['css', 'legacy'],
  before: [],
  after: [],
  avoid: []
};

_worker_js__WEBPACK_IMPORTED_MODULE_5__.default.prototype.toContainer = function toContainer() {
  return orig.toContainer.call(this).then(function toContainer_pagebreak() {
    // Setup root element and inner page height.
    var root = this.prop.container;
    var pxPageHeight = this.prop.pageSize.inner.px.height; // Check all requested modes.

    var modeSrc = [].concat(this.opt.pagebreak.mode);
    var mode = {
      avoidAll: modeSrc.indexOf('avoid-all') !== -1,
      css: modeSrc.indexOf('css') !== -1,
      legacy: modeSrc.indexOf('legacy') !== -1
    }; // Get arrays of all explicitly requested elements.

    var select = {};
    var self = this;
    ['before', 'after', 'avoid'].forEach(function (key) {
      var all = mode.avoidAll && key === 'avoid';
      select[key] = all ? [] : [].concat(self.opt.pagebreak[key] || []);

      if (select[key].length > 0) {
        select[key] = Array.prototype.slice.call(root.querySelectorAll(select[key].join(', ')));
      }
    }); // Get all legacy page-break elements.

    var legacyEls = root.querySelectorAll('.html2pdf__page-break');
    legacyEls = Array.prototype.slice.call(legacyEls); // Loop through all elements.

    var els = root.querySelectorAll('*');
    Array.prototype.forEach.call(els, function pagebreak_loop(el) {
      // Setup pagebreak rules based on legacy and avoidAll modes.
      var rules = {
        before: false,
        after: mode.legacy && legacyEls.indexOf(el) !== -1,
        avoid: mode.avoidAll
      }; // Add rules for css mode.

      if (mode.css) {
        // TODO: Check if this is valid with iFrames.
        var style = window.getComputedStyle(el); // TODO: Handle 'left' and 'right' correctly.
        // TODO: Add support for 'avoid' on breakBefore/After.

        var breakOpt = ['always', 'page', 'left', 'right'];
        var avoidOpt = ['avoid', 'avoid-page'];
        rules = {
          before: rules.before || breakOpt.indexOf(style.breakBefore || style.pageBreakBefore) !== -1,
          after: rules.after || breakOpt.indexOf(style.breakAfter || style.pageBreakAfter) !== -1,
          avoid: rules.avoid || avoidOpt.indexOf(style.breakInside || style.pageBreakInside) !== -1
        };
      } // Add rules for explicit requests.


      Object.keys(rules).forEach(function (key) {
        rules[key] = rules[key] || select[key].indexOf(el) !== -1;
      }); // Get element position on the screen.
      // TODO: Subtract the top of the container from clientRect.top/bottom?

      var clientRect = el.getBoundingClientRect(); // Avoid: Check if a break happens mid-element.

      if (rules.avoid && !rules.before) {
        var startPage = Math.floor(clientRect.top / pxPageHeight);
        var endPage = Math.floor(clientRect.bottom / pxPageHeight);
        var nPages = Math.abs(clientRect.bottom - clientRect.top) / pxPageHeight; // Turn on rules.before if the el is broken and is at most one page long.

        if (endPage !== startPage && nPages <= 1) {
          rules.before = true;
        }
      } // Before: Create a padding div to push the element to the next page.


      if (rules.before) {
        var pad = (0,_utils_js__WEBPACK_IMPORTED_MODULE_6__.createElement)('div', {
          style: {
            display: 'block',
            height: pxPageHeight - clientRect.top % pxPageHeight + 'px'
          }
        });
        el.parentNode.insertBefore(pad, el);
      } // After: Create a padding div to fill the remaining page.


      if (rules.after) {
        var pad = (0,_utils_js__WEBPACK_IMPORTED_MODULE_6__.createElement)('div', {
          style: {
            display: 'block',
            height: pxPageHeight - clientRect.bottom % pxPageHeight + 'px'
          }
        });
        el.parentNode.insertBefore(pad, el.nextSibling);
      }
    });
  });
};

/***/ }),

/***/ "./src/utils.js":
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "objType": function() { return /* binding */ objType; },
/* harmony export */   "createElement": function() { return /* binding */ createElement; },
/* harmony export */   "cloneNode": function() { return /* binding */ cloneNode; },
/* harmony export */   "unitConvert": function() { return /* binding */ unitConvert; },
/* harmony export */   "toPx": function() { return /* binding */ toPx; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.number.constructor.js */ "./node_modules/core-js/modules/es.number.constructor.js");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.symbol.js */ "./node_modules/core-js/modules/es.symbol.js");
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.symbol.description.js */ "./node_modules/core-js/modules/es.symbol.description.js");
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.symbol.iterator.js */ "./node_modules/core-js/modules/es.symbol.iterator.js");
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "./node_modules/core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "./node_modules/core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "./node_modules/core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);









function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Determine the type of a variable/object.
var objType = function objType(obj) {
  var type = _typeof(obj);

  if (type === 'undefined') return 'undefined';else if (type === 'string' || obj instanceof String) return 'string';else if (type === 'number' || obj instanceof Number) return 'number';else if (type === 'function' || obj instanceof Function) return 'function';else if (!!obj && obj.constructor === Array) return 'array';else if (obj && obj.nodeType === 1) return 'element';else if (type === 'object') return 'object';else return 'unknown';
}; // Create an HTML element with optional className, innerHTML, and style.

var createElement = function createElement(tagName, opt) {
  var el = document.createElement(tagName);
  if (opt.className) el.className = opt.className;

  if (opt.innerHTML) {
    el.innerHTML = opt.innerHTML;
    var scripts = el.getElementsByTagName('script');

    for (var i = scripts.length; i-- > 0; null) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
  }

  for (var key in opt.style) {
    el.style[key] = opt.style[key];
  }

  return el;
}; // Deep-clone a node and preserve contents/properties.

var cloneNode = function cloneNode(node, javascriptEnabled) {
  // Recursively clone the node.
  var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);

  for (var child = node.firstChild; child; child = child.nextSibling) {
    if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') {
      clone.appendChild(cloneNode(child, javascriptEnabled));
    }
  }

  if (node.nodeType === 1) {
    // Preserve contents/properties of special nodes.
    if (node.nodeName === 'CANVAS') {
      clone.width = node.width;
      clone.height = node.height;
      clone.getContext('2d').drawImage(node, 0, 0);
    } else if (node.nodeName === 'TEXTAREA' || node.nodeName === 'SELECT') {
      clone.value = node.value;
    } // Preserve the node's scroll position when it loads.


    clone.addEventListener('load', function () {
      clone.scrollTop = node.scrollTop;
      clone.scrollLeft = node.scrollLeft;
    }, true);
  } // Return the cloned node.


  return clone;
}; // Convert units from px using the conversion value 'k' from jsPDF.

var unitConvert = function unitConvert(obj, k) {
  if (objType(obj) === 'number') {
    return obj * 72 / 96 / k;
  } else {
    var newObj = {};

    for (var key in obj) {
      newObj[key] = obj[key] * 72 / 96 / k;
    }

    return newObj;
  }
}; // Convert units to px using the conversion value 'k' from jsPDF.

var toPx = function toPx(val, k) {
  return Math.floor(val * k / 72 * 96);
};

/***/ }),

/***/ "./src/worker.js":
/*!***********************!*\
  !*** ./src/worker.js ***!
  \***********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es.object.assign.js */ "./node_modules/core-js/modules/es.object.assign.js");
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es.array.map.js */ "./node_modules/core-js/modules/es.array.map.js");
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es.object.keys.js */ "./node_modules/core-js/modules/es.object.keys.js");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es.array.concat.js */ "./node_modules/core-js/modules/es.array.concat.js");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "./node_modules/core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es.regexp.to-string.js */ "./node_modules/core-js/modules/es.regexp.to-string.js");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es.function.name.js */ "./node_modules/core-js/modules/es.function.name.js");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/web.dom-collections.for-each.js */ "./node_modules/core-js/modules/web.dom-collections.for-each.js");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! jspdf */ "./node_modules/jspdf/dist/jspdf.es.min.js");
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! html2canvas */ "./node_modules/html2canvas/dist/html2canvas.js");
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(html2canvas__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils.js */ "./src/utils.js");
/* harmony import */ var es6_promise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! es6-promise */ "./node_modules/es6-promise/dist/es6-promise.js");
/* harmony import */ var es6_promise__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(es6_promise__WEBPACK_IMPORTED_MODULE_11__);












var Promise = (es6_promise__WEBPACK_IMPORTED_MODULE_11___default().Promise);
/* ----- CONSTRUCTOR ----- */

var Worker = function Worker(opt) {
  // Create the root parent for the proto chain, and the starting Worker.
  var root = Object.assign(Worker.convert(Promise.resolve()), JSON.parse(JSON.stringify(Worker.template)));
  var self = Worker.convert(Promise.resolve(), root); // Set progress, optional settings, and return.

  self = self.setProgress(1, Worker, 1, [Worker]);
  self = self.set(opt);
  return self;
}; // Boilerplate for subclassing Promise.


Worker.prototype = Object.create(Promise.prototype);
Worker.prototype.constructor = Worker; // Converts/casts promises into Workers.

Worker.convert = function convert(promise, inherit) {
  // Uses prototypal inheritance to receive changes made to ancestors' properties.
  promise.__proto__ = inherit || Worker.prototype;
  return promise;
};

Worker.template = {
  prop: {
    src: null,
    container: null,
    overlay: null,
    canvas: null,
    img: null,
    pdf: null,
    pageSize: null
  },
  progress: {
    val: 0,
    state: null,
    n: 0,
    stack: []
  },
  opt: {
    filename: 'file.pdf',
    margin: [0, 0, 0, 0],
    image: {
      type: 'jpeg',
      quality: 0.95
    },
    enableLinks: true,
    html2canvas: {},
    jsPDF: {}
  }
};
/* ----- FROM / TO ----- */

Worker.prototype.from = function from(src, type) {
  function getType(src) {
    switch ((0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.objType)(src)) {
      case 'string':
        return 'string';

      case 'element':
        return src.nodeName.toLowerCase && src.nodeName.toLowerCase() === 'canvas' ? 'canvas' : 'element';

      default:
        return 'unknown';
    }
  }

  return this.then(function from_main() {
    type = type || getType(src);

    switch (type) {
      case 'string':
        return this.set({
          src: (0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.createElement)('div', {
            innerHTML: src
          })
        });

      case 'element':
        return this.set({
          src: src
        });

      case 'canvas':
        return this.set({
          canvas: src
        });

      case 'img':
        return this.set({
          img: src
        });

      default:
        return this.error('Unknown source type.');
    }
  });
};

Worker.prototype.to = function to(target) {
  // Route the 'to' request to the appropriate method.
  switch (target) {
    case 'container':
      return this.toContainer();

    case 'canvas':
      return this.toCanvas();

    case 'img':
      return this.toImg();

    case 'pdf':
      return this.toPdf();

    default:
      return this.error('Invalid target.');
  }
};

Worker.prototype.toContainer = function toContainer() {
  // Set up function prerequisites.
  var prereqs = [function checkSrc() {
    return this.prop.src || this.error('Cannot duplicate - no source HTML.');
  }, function checkPageSize() {
    return this.prop.pageSize || this.setPageSize();
  }];
  return this.thenList(prereqs).then(function toContainer_main() {
    // Define the CSS styles for the container and its overlay parent.
    var overlayCSS = {
      position: 'fixed',
      overflow: 'hidden',
      zIndex: 1000,
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      backgroundColor: 'rgba(0,0,0,0.8)'
    };
    var containerCSS = {
      position: 'absolute',
      width: this.prop.pageSize.inner.width + this.prop.pageSize.unit,
      left: 0,
      right: 0,
      top: 0,
      height: 'auto',
      margin: 'auto',
      backgroundColor: 'white'
    }; // Set the overlay to hidden (could be changed in the future to provide a print preview).

    overlayCSS.opacity = 0; // Create and attach the elements.

    var source = (0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.cloneNode)(this.prop.src, this.opt.html2canvas.javascriptEnabled);
    this.prop.overlay = (0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.createElement)('div', {
      className: 'html2pdf__overlay',
      style: overlayCSS
    });
    this.prop.container = (0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.createElement)('div', {
      className: 'html2pdf__container',
      style: containerCSS
    });
    this.prop.container.appendChild(source);
    this.prop.overlay.appendChild(this.prop.container);
    document.body.appendChild(this.prop.overlay);
  });
};

Worker.prototype.toCanvas = function toCanvas() {
  // Set up function prerequisites.
  var prereqs = [function checkContainer() {
    return document.body.contains(this.prop.container) || this.toContainer();
  }]; // Fulfill prereqs then create the canvas.

  return this.thenList(prereqs).then(function toCanvas_main() {
    // Handle old-fashioned 'onrendered' argument.
    var options = Object.assign({}, this.opt.html2canvas);
    delete options.onrendered;
    return html2canvas__WEBPACK_IMPORTED_MODULE_9__(this.prop.container, options);
  }).then(function toCanvas_post(canvas) {
    // Handle old-fashioned 'onrendered' argument.
    var onRendered = this.opt.html2canvas.onrendered || function () {};

    onRendered(canvas);
    this.prop.canvas = canvas;
    document.body.removeChild(this.prop.overlay);
  });
};

Worker.prototype.toImg = function toImg() {
  // Set up function prerequisites.
  var prereqs = [function checkCanvas() {
    return this.prop.canvas || this.toCanvas();
  }]; // Fulfill prereqs then create the image.

  return this.thenList(prereqs).then(function toImg_main() {
    var imgData = this.prop.canvas.toDataURL('image/' + this.opt.image.type, this.opt.image.quality);
    this.prop.img = document.createElement('img');
    this.prop.img.src = imgData;
  });
};

Worker.prototype.toPdf = function toPdf() {
  // Set up function prerequisites.
  var prereqs = [function checkCanvas() {
    return this.prop.canvas || this.toCanvas();
  }, function checkPageSize() {
    return this.prop.pageSize || this.setPageSize();
  }]; // Fulfill prereqs then create the image.

  return this.thenList(prereqs).then(function toPdf_main() {
    // Create local copies of frequently used properties.
    var canvas = this.prop.canvas;
    var opt = this.opt; // Calculate the number of pages.

    var pxFullHeight = canvas.height;
    var pxPageHeight = Math.floor(canvas.width * this.prop.pageSize.inner.ratio);
    var nPages = Math.ceil(pxFullHeight / pxPageHeight); // Define pageHeight separately so it can be trimmed on the final page.

    var pageHeight = this.prop.pageSize.inner.height; // Create a one-page canvas to split up the full image.

    var pageCanvas = document.createElement('canvas');
    var pageCtx = pageCanvas.getContext('2d');
    pageCanvas.width = canvas.width;
    pageCanvas.height = pxPageHeight; // Initialize the PDF.

    this.prop.pdf = this.prop.pdf || new jspdf__WEBPACK_IMPORTED_MODULE_8__.jsPDF(opt.jsPDF);

    for (var page = 0; page < nPages; page++) {
      // Trim the final page to reduce file size.
      if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
        pageCanvas.height = pxFullHeight % pxPageHeight;
        pageHeight = pageCanvas.height * this.prop.pageSize.inner.width / pageCanvas.width;
      } // Display the page.


      var w = pageCanvas.width;
      var h = pageCanvas.height;
      pageCtx.fillStyle = 'white';
      pageCtx.fillRect(0, 0, w, h);
      pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h); // Add the page to the PDF.

      if (page) this.prop.pdf.addPage();
      var imgData = pageCanvas.toDataURL('image/' + opt.image.type, opt.image.quality);
      this.prop.pdf.addImage(imgData, opt.image.type, opt.margin[1], opt.margin[0], this.prop.pageSize.inner.width, pageHeight);
    }
  });
};
/* ----- OUTPUT / SAVE ----- */


Worker.prototype.output = function output(type, options, src) {
  // Redirect requests to the correct function (outputPdf / outputImg).
  src = src || 'pdf';

  if (src.toLowerCase() === 'img' || src.toLowerCase() === 'image') {
    return this.outputImg(type, options);
  } else {
    return this.outputPdf(type, options);
  }
};

Worker.prototype.outputPdf = function outputPdf(type, options) {
  // Set up function prerequisites.
  var prereqs = [function checkPdf() {
    return this.prop.pdf || this.toPdf();
  }]; // Fulfill prereqs then perform the appropriate output.

  return this.thenList(prereqs).then(function outputPdf_main() {
    /* Currently implemented output types:
     *    https://rawgit.com/MrRio/jsPDF/master/docs/jspdf.js.html#line992
     *  save(options), arraybuffer, blob, bloburi/bloburl,
     *  datauristring/dataurlstring, dataurlnewwindow, datauri/dataurl
     */

    if (this.opt.jsPDF && this.opt.jsPDF.autoPrint) {
        return this.prop.pdf.autoPrint().output(type, options);
    } else {
        return this.prop.pdf.output(type, options);
    }    
  });
};

Worker.prototype.outputImg = function outputImg(type, options) {
  // Set up function prerequisites.
  var prereqs = [function checkImg() {
    return this.prop.img || this.toImg();
  }]; // Fulfill prereqs then perform the appropriate output.

  return this.thenList(prereqs).then(function outputImg_main() {
    switch (type) {
      case undefined:
      case 'img':
        return this.prop.img;

      case 'datauristring':
      case 'dataurlstring':
        return this.prop.img.src;

      case 'datauri':
      case 'dataurl':
        return document.location.href = this.prop.img.src;

      default:
        throw 'Image output type "' + type + '" is not supported.';
    }
  });
};

Worker.prototype.save = function save(filename) {
  // Set up function prerequisites.
  var prereqs = [function checkPdf() {
    return this.prop.pdf || this.toPdf();
  }]; // Fulfill prereqs, update the filename (if provided), and save the PDF.

  return this.thenList(prereqs).set(filename ? {
    filename: filename
  } : null).then(function save_main() {
    this.prop.pdf.save(this.opt.filename);
  });
};
/* ----- SET / GET ----- */


Worker.prototype.set = function set(opt) {
  // TODO: Implement ordered pairs?
  // Silently ignore invalid or empty input.
  if ((0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.objType)(opt) !== 'object') {
    return this;
  } // Build an array of setter functions to queue.


  var fns = Object.keys(opt || {}).map(function (key) {
    switch (key) {
      case 'margin':
        return this.setMargin.bind(this, opt.margin);

      case 'jsPDF':
        return function set_jsPDF() {
          this.opt.jsPDF = opt.jsPDF;
          return this.setPageSize();
        };

      case 'pageSize':
        return this.setPageSize.bind(this, opt.pageSize);

      default:
        if (key in Worker.template.prop) {
          // Set pre-defined properties in prop.
          return function set_prop() {
            this.prop[key] = opt[key];
          };
        } else {
          // Set any other properties in opt.
          return function set_opt() {
            this.opt[key] = opt[key];
          };
        }

    }
  }, this); // Set properties within the promise chain.

  return this.then(function set_main() {
    return this.thenList(fns);
  });
};

Worker.prototype.get = function get(key, cbk) {
  return this.then(function get_main() {
    // Fetch the requested property, either as a predefined prop or in opt.
    var val = key in Worker.template.prop ? this.prop[key] : this.opt[key];
    return cbk ? cbk(val) : val;
  });
};

Worker.prototype.setMargin = function setMargin(margin) {
  return this.then(function setMargin_main() {
    // Parse the margin property: [top, left, bottom, right].
    switch ((0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.objType)(margin)) {
      case 'number':
        margin = [margin, margin, margin, margin];

      case 'array':
        if (margin.length === 2) {
          margin = [margin[0], margin[1], margin[0], margin[1]];
        }

        if (margin.length === 4) {
          break;
        }

      default:
        return this.error('Invalid margin array.');
    } // Set the margin property, then update pageSize.


    this.opt.margin = margin;
  }).then(this.setPageSize);
};

Worker.prototype.setPageSize = function setPageSize(pageSize) {
  return this.then(function setPageSize_main() {
    // Retrieve page-size based on jsPDF settings, if not explicitly provided.
    pageSize = pageSize || jspdf__WEBPACK_IMPORTED_MODULE_8__.jsPDF.getPageSize(this.opt.jsPDF); // Add 'inner' field if not present.

    if (!pageSize.hasOwnProperty('inner')) {
      pageSize.inner = {
        width: pageSize.width - this.opt.margin[1] - this.opt.margin[3],
        height: pageSize.height - this.opt.margin[0] - this.opt.margin[2]
      };
      pageSize.inner.px = {
        width: (0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.toPx)(pageSize.inner.width, pageSize.k),
        height: (0,_utils_js__WEBPACK_IMPORTED_MODULE_10__.toPx)(pageSize.inner.height, pageSize.k)
      };
      pageSize.inner.ratio = pageSize.inner.height / pageSize.inner.width;
    } // Attach pageSize to this.


    this.prop.pageSize = pageSize;
  });
};

Worker.prototype.setProgress = function setProgress(val, state, n, stack) {
  // Immediately update all progress values.
  if (val != null) this.progress.val = val;
  if (state != null) this.progress.state = state;
  if (n != null) this.progress.n = n;
  if (stack != null) this.progress.stack = stack;
  this.progress.ratio = this.progress.val / this.progress.state; // Return this for command chaining.

  return this;
};

Worker.prototype.updateProgress = function updateProgress(val, state, n, stack) {
  // Immediately update all progress values, using setProgress.
  return this.setProgress(val ? this.progress.val + val : null, state ? state : null, n ? this.progress.n + n : null, stack ? this.progress.stack.concat(stack) : null);
};
/* ----- PROMISE MAPPING ----- */


Worker.prototype.then = function then(onFulfilled, onRejected) {
  // Wrap `this` for encapsulation.
  var self = this;
  return this.thenCore(onFulfilled, onRejected, function then_main(onFulfilled, onRejected) {
    // Update progress while queuing, calling, and resolving `then`.
    self.updateProgress(null, null, 1, [onFulfilled]);
    return Promise.prototype.then.call(this, function then_pre(val) {
      self.updateProgress(null, onFulfilled);
      return val;
    }).then(onFulfilled, onRejected).then(function then_post(val) {
      self.updateProgress(1);
      return val;
    });
  });
};

Worker.prototype.thenCore = function thenCore(onFulfilled, onRejected, thenBase) {
  // Handle optional thenBase parameter.
  thenBase = thenBase || Promise.prototype.then; // Wrap `this` for encapsulation and bind it to the promise handlers.

  var self = this;

  if (onFulfilled) {
    onFulfilled = onFulfilled.bind(self);
  }

  if (onRejected) {
    onRejected = onRejected.bind(self);
  } // Cast self into a Promise to avoid polyfills recursively defining `then`.


  var isNative = Promise.toString().indexOf('[native code]') !== -1 && Promise.name === 'Promise';
  var selfPromise = isNative ? self : Worker.convert(Object.assign({}, self), Promise.prototype); // Return the promise, after casting it into a Worker and preserving props.

  var returnVal = thenBase.call(selfPromise, onFulfilled, onRejected);
  return Worker.convert(returnVal, self.__proto__);
};

Worker.prototype.thenExternal = function thenExternal(onFulfilled, onRejected) {
  // Call `then` and return a standard promise (exits the Worker chain).
  return Promise.prototype.then.call(this, onFulfilled, onRejected);
};

Worker.prototype.thenList = function thenList(fns) {
  // Queue a series of promise 'factories' into the promise chain.
  var self = this;
  fns.forEach(function thenList_forEach(fn) {
    self = self.thenCore(fn);
  });
  return self;
};

Worker.prototype['catch'] = function (onRejected) {
  // Bind `this` to the promise handler, call `catch`, and return a Worker.
  if (onRejected) {
    onRejected = onRejected.bind(this);
  }

  var returnVal = Promise.prototype['catch'].call(this, onRejected);
  return Worker.convert(returnVal, this);
};

Worker.prototype.catchExternal = function catchExternal(onRejected) {
  // Call `catch` and return a standard promise (exits the Worker chain).
  return Promise.prototype['catch'].call(this, onRejected);
};

Worker.prototype.error = function error(msg) {
  // Throw the error in the Promise chain.
  return this.then(function error_main() {
    throw new Error(msg);
  });
};
/* ----- ALIASES ----- */


Worker.prototype.using = Worker.prototype.set;
Worker.prototype.saveAs = Worker.prototype.save;
Worker.prototype.export = Worker.prototype.output;
Worker.prototype.run = Worker.prototype.then;
/* ----- FINISHING ----- */
// Expose the Worker class.

/* harmony default export */ __webpack_exports__["default"] = (Worker);

/***/ }),

/***/ "./node_modules/canvg/lib/index.es.js":
/*!********************************************!*\
  !*** ./node_modules/canvg/lib/index.es.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AElement": function() { return /* binding */ AElement; },
/* harmony export */   "AnimateColorElement": function() { return /* binding */ AnimateColorElement; },
/* harmony export */   "AnimateElement": function() { return /* binding */ AnimateElement; },
/* harmony export */   "AnimateTransformElement": function() { return /* binding */ AnimateTransformElement; },
/* harmony export */   "BoundingBox": function() { return /* binding */ BoundingBox; },
/* harmony export */   "CB1": function() { return /* binding */ CB1; },
/* harmony export */   "CB2": function() { return /* binding */ CB2; },
/* harmony export */   "CB3": function() { return /* binding */ CB3; },
/* harmony export */   "CB4": function() { return /* binding */ CB4; },
/* harmony export */   "Canvg": function() { return /* binding */ Canvg; },
/* harmony export */   "CircleElement": function() { return /* binding */ CircleElement; },
/* harmony export */   "ClipPathElement": function() { return /* binding */ ClipPathElement; },
/* harmony export */   "DefsElement": function() { return /* binding */ DefsElement; },
/* harmony export */   "DescElement": function() { return /* binding */ DescElement; },
/* harmony export */   "Document": function() { return /* binding */ Document; },
/* harmony export */   "Element": function() { return /* binding */ Element; },
/* harmony export */   "EllipseElement": function() { return /* binding */ EllipseElement; },
/* harmony export */   "FeColorMatrixElement": function() { return /* binding */ FeColorMatrixElement; },
/* harmony export */   "FeCompositeElement": function() { return /* binding */ FeCompositeElement; },
/* harmony export */   "FeDropShadowElement": function() { return /* binding */ FeDropShadowElement; },
/* harmony export */   "FeGaussianBlurElement": function() { return /* binding */ FeGaussianBlurElement; },
/* harmony export */   "FeMorphologyElement": function() { return /* binding */ FeMorphologyElement; },
/* harmony export */   "FilterElement": function() { return /* binding */ FilterElement; },
/* harmony export */   "Font": function() { return /* binding */ Font; },
/* harmony export */   "FontElement": function() { return /* binding */ FontElement; },
/* harmony export */   "FontFaceElement": function() { return /* binding */ FontFaceElement; },
/* harmony export */   "GElement": function() { return /* binding */ GElement; },
/* harmony export */   "GlyphElement": function() { return /* binding */ GlyphElement; },
/* harmony export */   "GradientElement": function() { return /* binding */ GradientElement; },
/* harmony export */   "ImageElement": function() { return /* binding */ ImageElement; },
/* harmony export */   "LineElement": function() { return /* binding */ LineElement; },
/* harmony export */   "LinearGradientElement": function() { return /* binding */ LinearGradientElement; },
/* harmony export */   "MarkerElement": function() { return /* binding */ MarkerElement; },
/* harmony export */   "MaskElement": function() { return /* binding */ MaskElement; },
/* harmony export */   "Matrix": function() { return /* binding */ Matrix; },
/* harmony export */   "MissingGlyphElement": function() { return /* binding */ MissingGlyphElement; },
/* harmony export */   "Mouse": function() { return /* binding */ Mouse; },
/* harmony export */   "PSEUDO_ZERO": function() { return /* binding */ PSEUDO_ZERO; },
/* harmony export */   "Parser": function() { return /* binding */ Parser; },
/* harmony export */   "PathElement": function() { return /* binding */ PathElement; },
/* harmony export */   "PathParser": function() { return /* binding */ PathParser; },
/* harmony export */   "PatternElement": function() { return /* binding */ PatternElement; },
/* harmony export */   "Point": function() { return /* binding */ Point; },
/* harmony export */   "PolygonElement": function() { return /* binding */ PolygonElement; },
/* harmony export */   "PolylineElement": function() { return /* binding */ PolylineElement; },
/* harmony export */   "Property": function() { return /* binding */ Property; },
/* harmony export */   "QB1": function() { return /* binding */ QB1; },
/* harmony export */   "QB2": function() { return /* binding */ QB2; },
/* harmony export */   "QB3": function() { return /* binding */ QB3; },
/* harmony export */   "RadialGradientElement": function() { return /* binding */ RadialGradientElement; },
/* harmony export */   "RectElement": function() { return /* binding */ RectElement; },
/* harmony export */   "RenderedElement": function() { return /* binding */ RenderedElement; },
/* harmony export */   "Rotate": function() { return /* binding */ Rotate; },
/* harmony export */   "SVGElement": function() { return /* binding */ SVGElement; },
/* harmony export */   "SVGFontLoader": function() { return /* binding */ SVGFontLoader; },
/* harmony export */   "Scale": function() { return /* binding */ Scale; },
/* harmony export */   "Screen": function() { return /* binding */ Screen; },
/* harmony export */   "Skew": function() { return /* binding */ Skew; },
/* harmony export */   "SkewX": function() { return /* binding */ SkewX; },
/* harmony export */   "SkewY": function() { return /* binding */ SkewY; },
/* harmony export */   "StopElement": function() { return /* binding */ StopElement; },
/* harmony export */   "StyleElement": function() { return /* binding */ StyleElement; },
/* harmony export */   "SymbolElement": function() { return /* binding */ SymbolElement; },
/* harmony export */   "TRefElement": function() { return /* binding */ TRefElement; },
/* harmony export */   "TSpanElement": function() { return /* binding */ TSpanElement; },
/* harmony export */   "TextElement": function() { return /* binding */ TextElement; },
/* harmony export */   "TextPathElement": function() { return /* binding */ TextPathElement; },
/* harmony export */   "TitleElement": function() { return /* binding */ TitleElement; },
/* harmony export */   "Transform": function() { return /* binding */ Transform; },
/* harmony export */   "Translate": function() { return /* binding */ Translate; },
/* harmony export */   "UnknownElement": function() { return /* binding */ UnknownElement; },
/* harmony export */   "UseElement": function() { return /* binding */ UseElement; },
/* harmony export */   "ViewPort": function() { return /* binding */ ViewPort; },
/* harmony export */   "compressSpaces": function() { return /* binding */ compressSpaces; },
/* harmony export */   "getSelectorSpecificity": function() { return /* binding */ getSelectorSpecificity; },
/* harmony export */   "normalizeAttributeName": function() { return /* binding */ normalizeAttributeName; },
/* harmony export */   "normalizeColor": function() { return /* binding */ normalizeColor; },
/* harmony export */   "parseExternalUrl": function() { return /* binding */ parseExternalUrl; },
/* harmony export */   "presets": function() { return /* binding */ index; },
/* harmony export */   "toNumbers": function() { return /* binding */ toNumbers; },
/* harmony export */   "trimLeft": function() { return /* binding */ trimLeft; },
/* harmony export */   "trimRight": function() { return /* binding */ trimRight; },
/* harmony export */   "vectorMagnitude": function() { return /* binding */ vectorMagnitude; },
/* harmony export */   "vectorsAngle": function() { return /* binding */ vectorsAngle; },
/* harmony export */   "vectorsRatio": function() { return /* binding */ vectorsRatio; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_starts_with__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/starts-with */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/starts-with.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_starts_with__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_starts_with__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/parse-float */ "./node_modules/@babel/runtime-corejs3/core-js-stable/parse-float.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/map */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/map.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/slicedToArray */ "./node_modules/@babel/runtime-corejs3/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_define_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/object/define-property */ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-property.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_define_property__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_define_property__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_define_properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/object/define-properties */ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-properties.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_define_properties__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_define_properties__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors */ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/for-each */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/for-each.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor */ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_filter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/filter */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/filter.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_filter__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_filter__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols */ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/object/keys */ "./node_modules/@babel/runtime-corejs3/core-js-stable/object/keys.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @babel/runtime-corejs3/regenerator */ "./node_modules/@babel/runtime-corejs3/regenerator/index.js");
/* harmony import */ var _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/asyncToGenerator */ "./node_modules/@babel/runtime-corejs3/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/defineProperty */ "./node_modules/@babel/runtime-corejs3/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/classCallCheck */ "./node_modules/@babel/runtime-corejs3/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/createClass */ "./node_modules/@babel/runtime-corejs3/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/concat */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/concat.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/reduce */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reduce.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_date_now__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/date/now */ "./node_modules/@babel/runtime-corejs3/core-js-stable/date/now.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_date_now__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_date_now__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/every */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/every.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_promise__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/promise */ "./node_modules/@babel/runtime-corejs3/core-js-stable/promise.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_promise__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_promise__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/bind */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/bind.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var raf__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! raf */ "./node_modules/raf/index.js");
/* harmony import */ var raf__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(raf__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/trim */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/trim.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var rgbcolor__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! rgbcolor */ "./node_modules/rgbcolor/index.js");
/* harmony import */ var rgbcolor__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(rgbcolor__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/reflect/construct */ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/inherits */ "./node_modules/@babel/runtime-corejs3/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/getPrototypeOf */ "./node_modules/@babel/runtime-corejs3/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_corejs3_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/toConsumableArray */ "./node_modules/@babel/runtime-corejs3/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_some__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/some */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/some.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_some__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_some__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/includes */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/includes.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/array/from */ "./node_modules/@babel/runtime-corejs3/core-js-stable/array/from.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_reverse__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/reverse */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/reverse.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_reverse__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_reverse__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/index-of */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/index-of.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/get */ "./node_modules/@babel/runtime-corejs3/helpers/esm/get.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_fill__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/fill */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/fill.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_fill__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_fill__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var svg_pathdata__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! svg-pathdata */ "./node_modules/svg-pathdata/lib/SVGPathData.module.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_delete_property__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/reflect/delete-property */ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/delete-property.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_delete_property__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_reflect_delete_property__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _babel_runtime_corejs3_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! @babel/runtime-corejs3/helpers/assertThisInitialized */ "./node_modules/@babel/runtime-corejs3/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/values */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/values.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_parse_int__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/parse-int */ "./node_modules/@babel/runtime-corejs3/core-js-stable/parse-int.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_parse_int__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_parse_int__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _babel_runtime_corejs3_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/get-iterator */ "./node_modules/@babel/runtime-corejs3/core-js/get-iterator.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_array_is_array__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/array/is-array */ "./node_modules/@babel/runtime-corejs3/core-js-stable/array/is-array.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_array_is_array__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_array_is_array__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js/get-iterator-method */ "./node_modules/@babel/runtime-corejs3/core-js/get-iterator-method.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_symbol__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/symbol */ "./node_modules/@babel/runtime-corejs3/core-js-stable/symbol.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_symbol__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_symbol__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_slice__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/instance/slice */ "./node_modules/@babel/runtime-corejs3/core-js-stable/instance/slice.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_instance_slice__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_slice__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_map__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/map */ "./node_modules/@babel/runtime-corejs3/core-js-stable/map.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_map__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_map__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_apply__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/reflect/apply */ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/apply.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_apply__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_reflect_apply__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_get_prototype_of__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! @babel/runtime-corejs3/core-js-stable/reflect/get-prototype-of */ "./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/get-prototype-of.js");
/* harmony import */ var _babel_runtime_corejs3_core_js_stable_reflect_get_prototype_of__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_stable_reflect_get_prototype_of__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var stackblur_canvas__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! stackblur-canvas */ "./node_modules/stackblur-canvas/dist/stackblur-es.js");





















































/**
 * HTML-safe compress white-spaces.
 * @param str - String to compress.
 */
function compressSpaces(str) {
  return str.replace(/(?!\u3000)\s+/gm, ' ');
}
/**
 * HTML-safe left trim.
 * @param str - String to trim.
 */

function trimLeft(str) {
  return str.replace(/^[\n \t]+/, '');
}
/**
 * HTML-safe right trim.
 * @param str - String to trim.
 */

function trimRight(str) {
  return str.replace(/[\n \t]+$/, '');
}
/**
 * String to numbers array.
 * @param str - Numbers string.
 */

function toNumbers(str) {
  var matches = (str || '').match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(matches).call(matches, (_babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default()));
} // Microsoft Edge fix

var allUppercase = /^[A-Z-]+$/;
/**
 * Normalize attribute name.
 * @param name - Attribute name.
 */

function normalizeAttributeName(name) {
  if (allUppercase.test(name)) {
    return name.toLowerCase();
  }

  return name;
}
/**
 * Parse external URL.
 * @param url - CSS url string.
 */

function parseExternalUrl(url) {
  //                                   single quotes [2]
  //                                   v           double quotes [3]
  //                                   v           v        no quotes [4]
  //                                   v           v        v
  var urlMatch = url.match(/url\(('([^']+)'|"([^"]+)"|([^'"\)]+))\)/) || [];
  return urlMatch[2] || urlMatch[3] || urlMatch[4];
}
/**
 * Transform floats to integers in rgb colors.
 * @param color - Color to normalize.
 */

function normalizeColor(color) {
  if (!_babel_runtime_corejs3_core_js_stable_instance_starts_with__WEBPACK_IMPORTED_MODULE_0___default()(color).call(color, 'rgb')) {
    return color;
  }

  var rgbParts = 3;
  var normalizedColor = color.replace(/\d+(\.\d+)?/g, function (num, isFloat) {
    return rgbParts-- && isFloat ? String(Math.round(_babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default()(num))) : num;
  });
  return normalizedColor;
}

// slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
var attributeRegex = /(\[[^\]]+\])/g;
var idRegex = /(#[^\s\+>~\.\[:]+)/g;
var classRegex = /(\.[^\s\+>~\.\[:]+)/g;
var pseudoElementRegex = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi;
var pseudoClassWithBracketsRegex = /(:[\w-]+\([^\)]*\))/gi;
var pseudoClassRegex = /(:[^\s\+>~\.\[:]+)/g;
var elementRegex = /([^\s\+>~\.\[:]+)/g;

function findSelectorMatch(selector, regex) {
  var matches = selector.match(regex);

  if (!matches) {
    return [selector, 0];
  }

  return [selector.replace(regex, ' '), matches.length];
}
/**
 * Measure selector specificity.
 * @param selector - Selector to measure.
 */


function getSelectorSpecificity(selector) {
  var specificity = [0, 0, 0];
  var currentSelector = selector.replace(/:not\(([^\)]*)\)/g, '     $1 ').replace(/{[\s\S]*/gm, ' ');
  var delta = 0;

  var _findSelectorMatch = findSelectorMatch(currentSelector, attributeRegex);

  var _findSelectorMatch2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch, 2);

  currentSelector = _findSelectorMatch2[0];
  delta = _findSelectorMatch2[1];
  specificity[1] += delta;

  var _findSelectorMatch3 = findSelectorMatch(currentSelector, idRegex);

  var _findSelectorMatch4 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch3, 2);

  currentSelector = _findSelectorMatch4[0];
  delta = _findSelectorMatch4[1];
  specificity[0] += delta;

  var _findSelectorMatch5 = findSelectorMatch(currentSelector, classRegex);

  var _findSelectorMatch6 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch5, 2);

  currentSelector = _findSelectorMatch6[0];
  delta = _findSelectorMatch6[1];
  specificity[1] += delta;

  var _findSelectorMatch7 = findSelectorMatch(currentSelector, pseudoElementRegex);

  var _findSelectorMatch8 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch7, 2);

  currentSelector = _findSelectorMatch8[0];
  delta = _findSelectorMatch8[1];
  specificity[2] += delta;

  var _findSelectorMatch9 = findSelectorMatch(currentSelector, pseudoClassWithBracketsRegex);

  var _findSelectorMatch10 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch9, 2);

  currentSelector = _findSelectorMatch10[0];
  delta = _findSelectorMatch10[1];
  specificity[1] += delta;

  var _findSelectorMatch11 = findSelectorMatch(currentSelector, pseudoClassRegex);

  var _findSelectorMatch12 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch11, 2);

  currentSelector = _findSelectorMatch12[0];
  delta = _findSelectorMatch12[1];
  specificity[1] += delta;
  currentSelector = currentSelector.replace(/[\*\s\+>~]/g, ' ').replace(/[#\.]/g, ' ');

  var _findSelectorMatch13 = findSelectorMatch(currentSelector, elementRegex);

  var _findSelectorMatch14 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_findSelectorMatch13, 2);

  currentSelector = _findSelectorMatch14[0];
  delta = _findSelectorMatch14[1];
  // lgtm [js/useless-assignment-to-local]
  specificity[2] += delta;
  return specificity.join('');
}

var PSEUDO_ZERO = .00000001;
/**
 * Vector magnitude.
 */

function vectorMagnitude(v) {
  return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
}
/**
 * Ratio between two vectors.
 */

function vectorsRatio(u, v) {
  return (u[0] * v[0] + u[1] * v[1]) / (vectorMagnitude(u) * vectorMagnitude(v));
}
/**
 * Angle between two vectors.
 */

function vectorsAngle(u, v) {
  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vectorsRatio(u, v));
}
function CB1(t) {
  return t * t * t;
}
function CB2(t) {
  return 3 * t * t * (1 - t);
}
function CB3(t) {
  return 3 * t * (1 - t) * (1 - t);
}
function CB4(t) {
  return (1 - t) * (1 - t) * (1 - t);
}
function QB1(t) {
  return t * t;
}
function QB2(t) {
  return 2 * t * (1 - t);
}
function QB3(t) {
  return (1 - t) * (1 - t);
}

var Property = /*#__PURE__*/function () {
  function Property(document, name, value) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Property);

    this.document = document;
    this.name = name;
    this.value = value;
    this.isNormalizedColor = false;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Property, [{
    key: "split",
    value: function split() {
      var _context, _context2;

      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
      var document = this.document,
          name = this.name;
      return _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(_context = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_context2 = compressSpaces(this.getString())).call(_context2).split(separator)).call(_context, function (value) {
        return new Property(document, name, value);
      });
    }
  }, {
    key: "hasValue",
    value: function hasValue(zeroIsValue) {
      var value = this.value;
      return value !== null && value !== '' && (zeroIsValue || value !== 0) && typeof value !== 'undefined';
    }
  }, {
    key: "isString",
    value: function isString(regexp) {
      var value = this.value;
      var result = typeof value === 'string';

      if (!result || !regexp) {
        return result;
      }

      return regexp.test(value);
    }
  }, {
    key: "isUrlDefinition",
    value: function isUrlDefinition() {
      return this.isString(/^url\(/);
    }
  }, {
    key: "isPixels",
    value: function isPixels() {
      if (!this.hasValue()) {
        return false;
      }

      var asString = this.getString();

      switch (true) {
        case /px$/.test(asString):
        case /^[0-9]+$/.test(asString):
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.value = value;
      return this;
    }
  }, {
    key: "getValue",
    value: function getValue(def) {
      if (typeof def === 'undefined' || this.hasValue()) {
        return this.value;
      }

      return def;
    }
  }, {
    key: "getNumber",
    value: function getNumber(def) {
      if (!this.hasValue()) {
        if (typeof def === 'undefined') {
          return 0;
        }

        return _babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default()(def);
      }

      var value = this.value;

      var n = _babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default()(value);

      if (this.isString(/%$/)) {
        n = n / 100.0;
      }

      return n;
    }
  }, {
    key: "getString",
    value: function getString(def) {
      if (typeof def === 'undefined' || this.hasValue()) {
        return typeof this.value === 'undefined' ? '' : String(this.value);
      }

      return String(def);
    }
  }, {
    key: "getColor",
    value: function getColor(def) {
      var color = this.getString(def);

      if (this.isNormalizedColor) {
        return color;
      }

      this.isNormalizedColor = true;
      color = normalizeColor(color);
      this.value = color;
      return color;
    }
  }, {
    key: "getDpi",
    value: function getDpi() {
      return 96.0; // TODO: compute?
    }
  }, {
    key: "getRem",
    value: function getRem() {
      return this.document.rootEmSize;
    }
  }, {
    key: "getEm",
    value: function getEm() {
      return this.document.emSize;
    }
  }, {
    key: "getUnits",
    value: function getUnits() {
      return this.getString().replace(/[0-9\.\-]/g, '');
    }
  }, {
    key: "getPixels",
    value: function getPixels(axisOrIsFontSize) {
      var processPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.hasValue()) {
        return 0;
      }

      var _ref = typeof axisOrIsFontSize === 'boolean' ? [undefined, axisOrIsFontSize] : [axisOrIsFontSize],
          _ref2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_ref, 2),
          axis = _ref2[0],
          isFontSize = _ref2[1];

      var viewPort = this.document.screen.viewPort;

      switch (true) {
        case this.isString(/vmin$/):
          return this.getNumber() / 100.0 * Math.min(viewPort.computeSize('x'), viewPort.computeSize('y'));

        case this.isString(/vmax$/):
          return this.getNumber() / 100.0 * Math.max(viewPort.computeSize('x'), viewPort.computeSize('y'));

        case this.isString(/vw$/):
          return this.getNumber() / 100.0 * viewPort.computeSize('x');

        case this.isString(/vh$/):
          return this.getNumber() / 100.0 * viewPort.computeSize('y');

        case this.isString(/rem$/):
          return this.getNumber() * this.getRem();

        case this.isString(/em$/):
          return this.getNumber() * this.getEm();

        case this.isString(/ex$/):
          return this.getNumber() * this.getEm() / 2.0;

        case this.isString(/px$/):
          return this.getNumber();

        case this.isString(/pt$/):
          return this.getNumber() * this.getDpi() * (1.0 / 72.0);

        case this.isString(/pc$/):
          return this.getNumber() * 15;

        case this.isString(/cm$/):
          return this.getNumber() * this.getDpi() / 2.54;

        case this.isString(/mm$/):
          return this.getNumber() * this.getDpi() / 25.4;

        case this.isString(/in$/):
          return this.getNumber() * this.getDpi();

        case this.isString(/%$/) && isFontSize:
          return this.getNumber() * this.getEm();

        case this.isString(/%$/):
          return this.getNumber() * viewPort.computeSize(axis);

        default:
          {
            var n = this.getNumber();

            if (processPercent && n < 1.0) {
              return n * viewPort.computeSize(axis);
            }

            return n;
          }
      }
    }
  }, {
    key: "getMilliseconds",
    value: function getMilliseconds() {
      if (!this.hasValue()) {
        return 0;
      }

      if (this.isString(/ms$/)) {
        return this.getNumber();
      }

      return this.getNumber() * 1000;
    }
  }, {
    key: "getRadians",
    value: function getRadians() {
      if (!this.hasValue()) {
        return 0;
      }

      switch (true) {
        case this.isString(/deg$/):
          return this.getNumber() * (Math.PI / 180.0);

        case this.isString(/grad$/):
          return this.getNumber() * (Math.PI / 200.0);

        case this.isString(/rad$/):
          return this.getNumber();

        default:
          return this.getNumber() * (Math.PI / 180.0);
      }
    }
  }, {
    key: "getDefinition",
    value: function getDefinition() {
      var asString = this.getString();
      var name = asString.match(/#([^\)'"]+)/);

      if (name) {
        name = name[1];
      }

      if (!name) {
        name = asString;
      }

      return this.document.definitions[name];
    }
  }, {
    key: "getFillStyleDefinition",
    value: function getFillStyleDefinition(element, opacity) {
      var def = this.getDefinition();

      if (!def) {
        return null;
      } // gradient


      if (typeof def.createGradient === 'function') {
        return def.createGradient(this.document.ctx, element, opacity);
      } // pattern


      if (typeof def.createPattern === 'function') {
        if (def.getHrefAttribute().hasValue()) {
          var patternTransform = def.getAttribute('patternTransform');
          def = def.getHrefAttribute().getDefinition();

          if (patternTransform.hasValue()) {
            def.getAttribute('patternTransform', true).setValue(patternTransform.value);
          }
        }

        return def.createPattern(this.document.ctx, element, opacity);
      }

      return null;
    }
  }, {
    key: "getTextBaseline",
    value: function getTextBaseline() {
      if (!this.hasValue()) {
        return null;
      }

      return Property.textBaselineMapping[this.getString()];
    }
  }, {
    key: "addOpacity",
    value: function addOpacity(opacity) {
      var value = this.getColor();
      var len = value.length;
      var commas = 0; // Simulate old RGBColor version, which can't parse rgba.

      for (var i = 0; i < len; i++) {
        if (value[i] === ',') {
          commas++;
        }

        if (commas === 3) {
          break;
        }
      }

      if (opacity.hasValue() && this.isString() && commas !== 3) {
        var color = new (rgbcolor__WEBPACK_IMPORTED_MODULE_25___default())(value);

        if (color.ok) {
          color.alpha = opacity.getNumber();
          value = color.toRGBA();
        }
      }

      return new Property(this.document, this.name, value);
    }
  }], [{
    key: "empty",
    value: function empty(document) {
      return new Property(document, 'EMPTY', '');
    }
  }]);

  return Property;
}();
Property.textBaselineMapping = {
  'baseline': 'alphabetic',
  'before-edge': 'top',
  'text-before-edge': 'top',
  'middle': 'middle',
  'central': 'middle',
  'after-edge': 'bottom',
  'text-after-edge': 'bottom',
  'ideographic': 'ideographic',
  'alphabetic': 'alphabetic',
  'hanging': 'hanging',
  'mathematical': 'alphabetic'
};

var ViewPort = /*#__PURE__*/function () {
  function ViewPort() {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, ViewPort);

    this.viewPorts = [];
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(ViewPort, [{
    key: "clear",
    value: function clear() {
      this.viewPorts = [];
    }
  }, {
    key: "setCurrent",
    value: function setCurrent(width, height) {
      this.viewPorts.push({
        width: width,
        height: height
      });
    }
  }, {
    key: "removeCurrent",
    value: function removeCurrent() {
      this.viewPorts.pop();
    }
  }, {
    key: "getCurrent",
    value: function getCurrent() {
      var viewPorts = this.viewPorts;
      return viewPorts[viewPorts.length - 1];
    }
  }, {
    key: "computeSize",
    value: function computeSize(d) {
      if (typeof d === 'number') {
        return d;
      }

      if (d === 'x') {
        return this.width;
      }

      if (d === 'y') {
        return this.height;
      }

      return Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
    }
  }, {
    key: "width",
    get: function get() {
      return this.getCurrent().width;
    }
  }, {
    key: "height",
    get: function get() {
      return this.getCurrent().height;
    }
  }]);

  return ViewPort;
}();

var Point = /*#__PURE__*/function () {
  function Point(x, y) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Point);

    this.x = x;
    this.y = y;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Point, [{
    key: "angleTo",
    value: function angleTo(point) {
      return Math.atan2(point.y - this.y, point.x - this.x);
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(transform) {
      var x = this.x,
          y = this.y;
      var xp = x * transform[0] + y * transform[2] + transform[4];
      var yp = x * transform[1] + y * transform[3] + transform[5];
      this.x = xp;
      this.y = yp;
    }
  }], [{
    key: "parse",
    value: function parse(point) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _toNumbers = toNumbers(point),
          _toNumbers2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_toNumbers, 2),
          _toNumbers2$ = _toNumbers2[0],
          x = _toNumbers2$ === void 0 ? defaultValue : _toNumbers2$,
          _toNumbers2$2 = _toNumbers2[1],
          y = _toNumbers2$2 === void 0 ? defaultValue : _toNumbers2$2;

      return new Point(x, y);
    }
  }, {
    key: "parseScale",
    value: function parseScale(scale) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var _toNumbers3 = toNumbers(scale),
          _toNumbers4 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_toNumbers3, 2),
          _toNumbers4$ = _toNumbers4[0],
          x = _toNumbers4$ === void 0 ? defaultValue : _toNumbers4$,
          _toNumbers4$2 = _toNumbers4[1],
          y = _toNumbers4$2 === void 0 ? x : _toNumbers4$2;

      return new Point(x, y);
    }
  }, {
    key: "parsePath",
    value: function parsePath(path) {
      var points = toNumbers(path);
      var len = points.length;
      var pathPoints = [];

      for (var i = 0; i < len; i += 2) {
        pathPoints.push(new Point(points[i], points[i + 1]));
      }

      return pathPoints;
    }
  }]);

  return Point;
}();

var Mouse = /*#__PURE__*/function () {
  function Mouse(screen) {
    var _context, _context2;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Mouse);

    this.screen = screen;
    this.working = false;
    this.events = [];
    this.eventElements = [];
    this.onClick = _babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22___default()(_context = this.onClick).call(_context, this);
    this.onMouseMove = _babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22___default()(_context2 = this.onMouseMove).call(_context2, this);
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Mouse, [{
    key: "isWorking",
    value: function isWorking() {
      return this.working;
    }
  }, {
    key: "start",
    value: function start() {
      if (this.working) {
        return;
      }

      var screen = this.screen,
          onClick = this.onClick,
          onMouseMove = this.onMouseMove;
      var canvas = screen.ctx.canvas;
      canvas.onclick = onClick;
      canvas.onmousemove = onMouseMove;
      this.working = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.working) {
        return;
      }

      var canvas = this.screen.ctx.canvas;
      this.working = false;
      canvas.onclick = null;
      canvas.onmousemove = null;
    }
  }, {
    key: "hasEvents",
    value: function hasEvents() {
      return this.working && this.events.length > 0;
    }
  }, {
    key: "runEvents",
    value: function runEvents() {
      if (!this.working) {
        return;
      }

      var document = this.screen,
          events = this.events,
          eventElements = this.eventElements;
      var style = document.ctx.canvas.style;

      if (style) {
        style.cursor = '';
      }

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(events).call(events, function (_ref, i) {
        var run = _ref.run;
        var element = eventElements[i];

        while (element) {
          run(element);
          element = element.parent;
        }
      }); // done running, clear


      this.events = [];
      this.eventElements = [];
    }
  }, {
    key: "checkPath",
    value: function checkPath(element, ctx) {
      if (!this.working || !ctx) {
        return;
      }

      var events = this.events,
          eventElements = this.eventElements;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(events).call(events, function (_ref2, i) {
        var x = _ref2.x,
            y = _ref2.y;

        if (!eventElements[i] && ctx.isPointInPath && ctx.isPointInPath(x, y)) {
          eventElements[i] = element;
        }
      });
    }
  }, {
    key: "checkBoundingBox",
    value: function checkBoundingBox(element, boundingBox) {
      if (!this.working || !boundingBox) {
        return;
      }

      var events = this.events,
          eventElements = this.eventElements;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(events).call(events, function (_ref3, i) {
        var x = _ref3.x,
            y = _ref3.y;

        if (!eventElements[i] && boundingBox.isPointInBox(x, y)) {
          eventElements[i] = element;
        }
      });
    }
  }, {
    key: "mapXY",
    value: function mapXY(x, y) {
      var _this$screen = this.screen,
          window = _this$screen.window,
          ctx = _this$screen.ctx;
      var point = new Point(x, y);
      var element = ctx.canvas;

      while (element) {
        point.x -= element.offsetLeft;
        point.y -= element.offsetTop;
        element = element.offsetParent;
      }

      if (window.scrollX) {
        point.x += window.scrollX;
      }

      if (window.scrollY) {
        point.y += window.scrollY;
      }

      return point;
    }
  }, {
    key: "onClick",
    value: function onClick(evt) {
      var _this$mapXY = this.mapXY((evt || event).clientX, (evt || event).clientY),
          x = _this$mapXY.x,
          y = _this$mapXY.y;

      this.events.push({
        type: 'onclick',
        x: x,
        y: y,
        run: function run(event) {
          if (event.onClick) {
            event.onClick();
          }
        }
      });
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(evt) {
      var _this$mapXY2 = this.mapXY((evt || event).clientX, (evt || event).clientY),
          x = _this$mapXY2.x,
          y = _this$mapXY2.y;

      this.events.push({
        type: 'onmousemove',
        x: x,
        y: y,
        run: function run(event) {
          if (event.onMouseMove) {
            event.onMouseMove();
          }
        }
      });
    }
  }]);

  return Mouse;
}();

var defaultWindow = typeof window !== 'undefined' ? window : null;
var defaultFetch = typeof fetch !== 'undefined' ? _babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22___default()(fetch).call(fetch, void 0) // `fetch` depends on context: `someObject.fetch(...)` will throw error.
: null;

var Screen = /*#__PURE__*/function () {
  function Screen(ctx) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$fetch = _ref.fetch,
        fetch = _ref$fetch === void 0 ? defaultFetch : _ref$fetch,
        _ref$window = _ref.window,
        window = _ref$window === void 0 ? defaultWindow : _ref$window;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Screen);

    this.ctx = ctx;
    this.FRAMERATE = 30;
    this.MAX_VIRTUAL_PIXELS = 30000;
    this.CLIENT_WIDTH = 800;
    this.CLIENT_HEIGHT = 600;
    this.viewPort = new ViewPort();
    this.mouse = new Mouse(this);
    this.animations = [];
    this.waits = [];
    this.frameDuration = 0;
    this.isReadyLock = false;
    this.isFirstRender = true;
    this.intervalId = null;
    this.window = window;
    this.fetch = fetch;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Screen, [{
    key: "wait",
    value: function wait(checker) {
      this.waits.push(checker);
    }
  }, {
    key: "ready",
    value: function ready() {
      if (!this.readyPromise) {
        return _babel_runtime_corejs3_core_js_stable_promise__WEBPACK_IMPORTED_MODULE_21___default().resolve();
      }

      return this.readyPromise;
    }
  }, {
    key: "isReady",
    value: function isReady() {
      var _context;

      if (this.isReadyLock) {
        return true;
      }

      var isReadyLock = _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20___default()(_context = this.waits).call(_context, function (_) {
        return _();
      });

      if (isReadyLock) {
        this.waits = [];

        if (this.resolveReady) {
          this.resolveReady();
        }
      }

      this.isReadyLock = isReadyLock;
      return isReadyLock;
    }
  }, {
    key: "setDefaults",
    value: function setDefaults(ctx) {
      // initial values and defaults
      ctx.strokeStyle = 'rgba(0,0,0,0)';
      ctx.lineCap = 'butt';
      ctx.lineJoin = 'miter';
      ctx.miterLimit = 4;
    }
  }, {
    key: "setViewBox",
    value: function setViewBox(_ref2) {
      var document = _ref2.document,
          ctx = _ref2.ctx,
          aspectRatio = _ref2.aspectRatio,
          width = _ref2.width,
          desiredWidth = _ref2.desiredWidth,
          height = _ref2.height,
          desiredHeight = _ref2.desiredHeight,
          _ref2$minX = _ref2.minX,
          minX = _ref2$minX === void 0 ? 0 : _ref2$minX,
          _ref2$minY = _ref2.minY,
          minY = _ref2$minY === void 0 ? 0 : _ref2$minY,
          refX = _ref2.refX,
          refY = _ref2.refY,
          _ref2$clip = _ref2.clip,
          clip = _ref2$clip === void 0 ? false : _ref2$clip,
          _ref2$clipX = _ref2.clipX,
          clipX = _ref2$clipX === void 0 ? 0 : _ref2$clipX,
          _ref2$clipY = _ref2.clipY,
          clipY = _ref2$clipY === void 0 ? 0 : _ref2$clipY;
      // aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
      var cleanAspectRatio = compressSpaces(aspectRatio).replace(/^defer\s/, ''); // ignore defer

      var _cleanAspectRatio$spl = cleanAspectRatio.split(' '),
          _cleanAspectRatio$spl2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_cleanAspectRatio$spl, 2),
          aspectRatioAlign = _cleanAspectRatio$spl2[0],
          aspectRatioMeetOrSlice = _cleanAspectRatio$spl2[1];

      var align = aspectRatioAlign || 'xMidYMid';
      var meetOrSlice = aspectRatioMeetOrSlice || 'meet'; // calculate scale

      var scaleX = width / desiredWidth;
      var scaleY = height / desiredHeight;
      var scaleMin = Math.min(scaleX, scaleY);
      var scaleMax = Math.max(scaleX, scaleY);
      var finalDesiredWidth = desiredWidth;
      var finalDesiredHeight = desiredHeight;

      if (meetOrSlice === 'meet') {
        finalDesiredWidth *= scaleMin;
        finalDesiredHeight *= scaleMin;
      }

      if (meetOrSlice === 'slice') {
        finalDesiredWidth *= scaleMax;
        finalDesiredHeight *= scaleMax;
      }

      var refXProp = new Property(document, 'refX', refX);
      var refYProp = new Property(document, 'refY', refY);
      var hasRefs = refXProp.hasValue() && refYProp.hasValue();

      if (hasRefs) {
        ctx.translate(-scaleMin * refXProp.getPixels('x'), -scaleMin * refYProp.getPixels('y'));
      }

      if (clip) {
        var scaledClipX = scaleMin * clipX;
        var scaledClipY = scaleMin * clipY;
        ctx.beginPath();
        ctx.moveTo(scaledClipX, scaledClipY);
        ctx.lineTo(width, scaledClipY);
        ctx.lineTo(width, height);
        ctx.lineTo(scaledClipX, height);
        ctx.closePath();
        ctx.clip();
      }

      if (!hasRefs) {
        var isMeetMinY = meetOrSlice === 'meet' && scaleMin === scaleY;
        var isSliceMaxY = meetOrSlice === 'slice' && scaleMax === scaleY;
        var isMeetMinX = meetOrSlice === 'meet' && scaleMin === scaleX;
        var isSliceMaxX = meetOrSlice === 'slice' && scaleMax === scaleX;

        if (/^xMid/.test(align) && (isMeetMinY || isSliceMaxY)) {
          ctx.translate(width / 2.0 - finalDesiredWidth / 2.0, 0);
        }

        if (/YMid$/.test(align) && (isMeetMinX || isSliceMaxX)) {
          ctx.translate(0, height / 2.0 - finalDesiredHeight / 2.0);
        }

        if (/^xMax/.test(align) && (isMeetMinY || isSliceMaxY)) {
          ctx.translate(width - finalDesiredWidth, 0);
        }

        if (/YMax$/.test(align) && (isMeetMinX || isSliceMaxX)) {
          ctx.translate(0, height - finalDesiredHeight);
        }
      } // scale


      switch (true) {
        case align === 'none':
          ctx.scale(scaleX, scaleY);
          break;

        case meetOrSlice === 'meet':
          ctx.scale(scaleMin, scaleMin);
          break;

        case meetOrSlice === 'slice':
          ctx.scale(scaleMax, scaleMax);
          break;
      } // translate


      ctx.translate(-minX, -minY);
    }
  }, {
    key: "start",
    value: function start(element) {
      var _this = this;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$enableRedraw = _ref3.enableRedraw,
          enableRedraw = _ref3$enableRedraw === void 0 ? false : _ref3$enableRedraw,
          _ref3$ignoreMouse = _ref3.ignoreMouse,
          ignoreMouse = _ref3$ignoreMouse === void 0 ? false : _ref3$ignoreMouse,
          _ref3$ignoreAnimation = _ref3.ignoreAnimation,
          ignoreAnimation = _ref3$ignoreAnimation === void 0 ? false : _ref3$ignoreAnimation,
          _ref3$ignoreDimension = _ref3.ignoreDimensions,
          ignoreDimensions = _ref3$ignoreDimension === void 0 ? false : _ref3$ignoreDimension,
          _ref3$ignoreClear = _ref3.ignoreClear,
          ignoreClear = _ref3$ignoreClear === void 0 ? false : _ref3$ignoreClear,
          forceRedraw = _ref3.forceRedraw,
          scaleWidth = _ref3.scaleWidth,
          scaleHeight = _ref3.scaleHeight,
          offsetX = _ref3.offsetX,
          offsetY = _ref3.offsetY;

      var FRAMERATE = this.FRAMERATE,
          mouse = this.mouse;
      var frameDuration = 1000 / FRAMERATE;
      this.frameDuration = frameDuration;
      this.readyPromise = new (_babel_runtime_corejs3_core_js_stable_promise__WEBPACK_IMPORTED_MODULE_21___default())(function (resolve) {
        _this.resolveReady = resolve;
      });

      if (this.isReady()) {
        this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
      }

      if (!enableRedraw) {
        return;
      }

      var now = _babel_runtime_corejs3_core_js_stable_date_now__WEBPACK_IMPORTED_MODULE_19___default()();

      var then = now;
      var delta = 0;

      var tick = function tick() {
        now = _babel_runtime_corejs3_core_js_stable_date_now__WEBPACK_IMPORTED_MODULE_19___default()();
        delta = now - then;

        if (delta >= frameDuration) {
          then = now - delta % frameDuration;

          if (_this.shouldUpdate(ignoreAnimation, forceRedraw)) {
            _this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);

            mouse.runEvents();
          }
        }

        _this.intervalId = raf__WEBPACK_IMPORTED_MODULE_23___default()(tick);
      };

      if (!ignoreMouse) {
        mouse.start();
      }

      this.intervalId = raf__WEBPACK_IMPORTED_MODULE_23___default()(tick);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.intervalId) {
        raf__WEBPACK_IMPORTED_MODULE_23___default().cancel(this.intervalId);
        this.intervalId = null;
      }

      this.mouse.stop();
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(ignoreAnimation, forceRedraw) {
      // need update from animations?
      if (!ignoreAnimation) {
        var _context2;

        var frameDuration = this.frameDuration;

        var shouldUpdate = _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18___default()(_context2 = this.animations).call(_context2, function (shouldUpdate, animation) {
          return animation.update(frameDuration) || shouldUpdate;
        }, false);

        if (shouldUpdate) {
          return true;
        }
      } // need update from redraw?


      if (typeof forceRedraw === 'function' && forceRedraw()) {
        return true;
      }

      if (!this.isReadyLock && this.isReady()) {
        return true;
      } // need update from mouse events?


      if (this.mouse.hasEvents()) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY) {
      var CLIENT_WIDTH = this.CLIENT_WIDTH,
          CLIENT_HEIGHT = this.CLIENT_HEIGHT,
          viewPort = this.viewPort,
          ctx = this.ctx,
          isFirstRender = this.isFirstRender;
      var canvas = ctx.canvas;
      viewPort.clear();

      if (canvas.width && canvas.height) {
        viewPort.setCurrent(canvas.width, canvas.height);
      } else {
        viewPort.setCurrent(CLIENT_WIDTH, CLIENT_HEIGHT);
      }

      var widthStyle = element.getStyle('width');
      var heightStyle = element.getStyle('height');

      if (!ignoreDimensions && (isFirstRender || typeof scaleWidth !== 'number' && typeof scaleHeight !== 'number')) {
        // set canvas size
        if (widthStyle.hasValue()) {
          canvas.width = widthStyle.getPixels('x');

          if (canvas.style) {
            canvas.style.width = "".concat(canvas.width, "px");
          }
        }

        if (heightStyle.hasValue()) {
          canvas.height = heightStyle.getPixels('y');

          if (canvas.style) {
            canvas.style.height = "".concat(canvas.height, "px");
          }
        }
      }

      var cWidth = canvas.clientWidth || canvas.width;
      var cHeight = canvas.clientHeight || canvas.height;

      if (ignoreDimensions && widthStyle.hasValue() && heightStyle.hasValue()) {
        cWidth = widthStyle.getPixels('x');
        cHeight = heightStyle.getPixels('y');
      }

      viewPort.setCurrent(cWidth, cHeight);

      if (typeof offsetX === 'number') {
        element.getAttribute('x', true).setValue(offsetX);
      }

      if (typeof offsetY === 'number') {
        element.getAttribute('y', true).setValue(offsetY);
      }

      if (typeof scaleWidth === 'number' || typeof scaleHeight === 'number') {
        var _context3, _context4;

        var viewBox = toNumbers(element.getAttribute('viewBox').getString());
        var xRatio = 0;
        var yRatio = 0;

        if (typeof scaleWidth === 'number') {
          var _widthStyle = element.getStyle('width');

          if (_widthStyle.hasValue()) {
            xRatio = _widthStyle.getPixels('x') / scaleWidth;
          } else if (!isNaN(viewBox[2])) {
            xRatio = viewBox[2] / scaleWidth;
          }
        }

        if (typeof scaleHeight === 'number') {
          var _heightStyle = element.getStyle('height');

          if (_heightStyle.hasValue()) {
            yRatio = _heightStyle.getPixels('y') / scaleHeight;
          } else if (!isNaN(viewBox[3])) {
            yRatio = viewBox[3] / scaleHeight;
          }
        }

        if (!xRatio) {
          xRatio = yRatio;
        }

        if (!yRatio) {
          yRatio = xRatio;
        }

        element.getAttribute('width', true).setValue(scaleWidth);
        element.getAttribute('height', true).setValue(scaleHeight);
        var transformStyle = element.getStyle('transform', true, true);
        transformStyle.setValue(_babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context3 = _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context4 = "".concat(transformStyle.getString(), " scale(")).call(_context4, 1.0 / xRatio, ", ")).call(_context3, 1.0 / yRatio, ")"));
      } // clear and render


      if (!ignoreClear) {
        ctx.clearRect(0, 0, cWidth, cHeight);
      }

      element.render(ctx);

      if (isFirstRender) {
        this.isFirstRender = false;
      }
    }
  }]);

  return Screen;
}();
Screen.defaultWindow = defaultWindow;
Screen.defaultFetch = defaultFetch;

var defaultFetch$1 = Screen.defaultFetch;
var DefaultDOMParser = typeof DOMParser !== 'undefined' ? DOMParser : null;

var Parser = /*#__PURE__*/function () {
  function Parser() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$fetch = _ref.fetch,
        fetch = _ref$fetch === void 0 ? defaultFetch$1 : _ref$fetch,
        _ref$DOMParser = _ref.DOMParser,
        DOMParser = _ref$DOMParser === void 0 ? DefaultDOMParser : _ref$DOMParser;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Parser);

    this.fetch = fetch;
    this.DOMParser = DOMParser;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Parser, [{
    key: "parse",
    value: function () {
      var _parse = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee(resource) {
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!/^</.test(resource)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.parseFromString(resource));

              case 2:
                return _context.abrupt("return", this.load(resource));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function parse(_x) {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
  }, {
    key: "parseFromString",
    value: function parseFromString(xml) {
      var parser = new this.DOMParser();

      try {
        return this.checkDocument(parser.parseFromString(xml, 'image/svg+xml'));
      } catch (err) {
        return this.checkDocument(parser.parseFromString(xml, 'text/xml'));
      }
    }
  }, {
    key: "checkDocument",
    value: function checkDocument(document) {
      var parserError = document.getElementsByTagName('parsererror')[0];

      if (parserError) {
        throw new Error(parserError.textContent);
      }

      return document;
    }
  }, {
    key: "load",
    value: function () {
      var _load = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee2(url) {
        var response, xml;
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetch(url);

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return response.text();

              case 5:
                xml = _context2.sent;
                return _context2.abrupt("return", this.parseFromString(xml));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load(_x2) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }]);

  return Parser;
}();

var Translate = /*#__PURE__*/function () {
  function Translate(_, point) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Translate);

    this.type = 'translate';
    this.point = null;
    this.point = Point.parse(point);
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Translate, [{
    key: "apply",
    value: function apply(ctx) {
      var _this$point = this.point,
          x = _this$point.x,
          y = _this$point.y;
      ctx.translate(x || 0.0, y || 0.0);
    }
  }, {
    key: "unapply",
    value: function unapply(ctx) {
      var _this$point2 = this.point,
          x = _this$point2.x,
          y = _this$point2.y;
      ctx.translate(-1.0 * x || 0.0, -1.0 * y || 0.0);
    }
  }, {
    key: "applyToPoint",
    value: function applyToPoint(point) {
      var _this$point3 = this.point,
          x = _this$point3.x,
          y = _this$point3.y;
      point.applyTransform([1, 0, 0, 1, x || 0.0, y || 0.0]);
    }
  }]);

  return Translate;
}();

var Rotate = /*#__PURE__*/function () {
  function Rotate(document, rotate, transformOrigin) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Rotate);

    this.type = 'rotate';
    this.angle = null;
    this.originX = null;
    this.originY = null;
    this.cx = 0;
    this.cy = 0;
    var numbers = toNumbers(rotate);
    this.angle = new Property(document, 'angle', numbers[0]);
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
    this.cx = numbers[1] || 0;
    this.cy = numbers[2] || 0;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Rotate, [{
    key: "apply",
    value: function apply(ctx) {
      var cx = this.cx,
          cy = this.cy,
          originX = this.originX,
          originY = this.originY,
          angle = this.angle;
      var x = cx + originX.getPixels('x');
      var y = cy + originY.getPixels('y');
      ctx.translate(x, y);
      ctx.rotate(angle.getRadians());
      ctx.translate(-x, -y);
    }
  }, {
    key: "unapply",
    value: function unapply(ctx) {
      var cx = this.cx,
          cy = this.cy,
          angle = this.angle;
      ctx.translate(cx, cy);
      ctx.rotate(-1.0 * angle.getRadians());
      ctx.translate(-cx, -cy);
    }
  }, {
    key: "applyToPoint",
    value: function applyToPoint(point) {
      var cx = this.cx,
          cy = this.cy,
          angle = this.angle;
      var rad = angle.getRadians();
      point.applyTransform([1, 0, 0, 1, cx || 0.0, cy || 0.0 // this.p.y
      ]);
      point.applyTransform([Math.cos(rad), Math.sin(rad), -Math.sin(rad), Math.cos(rad), 0, 0]);
      point.applyTransform([1, 0, 0, 1, -cx || 0.0, -cy || 0.0 // -this.p.y
      ]);
    }
  }]);

  return Rotate;
}();

var Scale = /*#__PURE__*/function () {
  function Scale(_, scale) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Scale);

    this.type = 'scale';
    this.scale = null;
    var scaleSize = Point.parseScale(scale); // Workaround for node-canvas

    if (scaleSize.x === 0 || scaleSize.y === 0) {
      scaleSize.x = PSEUDO_ZERO;
      scaleSize.y = PSEUDO_ZERO;
    }

    this.scale = scaleSize;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Scale, [{
    key: "apply",
    value: function apply(ctx) {
      var _this$scale = this.scale,
          x = _this$scale.x,
          y = _this$scale.y;
      ctx.scale(x, y || x);
    }
  }, {
    key: "unapply",
    value: function unapply(ctx) {
      var _this$scale2 = this.scale,
          x = _this$scale2.x,
          y = _this$scale2.y;
      ctx.scale(1.0 / x, 1.0 / y || x);
    }
  }, {
    key: "applyToPoint",
    value: function applyToPoint(point) {
      var _this$scale3 = this.scale,
          x = _this$scale3.x,
          y = _this$scale3.y;
      point.applyTransform([x || 0.0, 0, 0, y || 0.0, 0, 0]);
    }
  }]);

  return Scale;
}();

var Matrix = /*#__PURE__*/function () {
  function Matrix(_, matrix) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Matrix);

    this.type = 'matrix';
    this.matrix = [];
    this.matrix = toNumbers(matrix);
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Matrix, [{
    key: "apply",
    value: function apply(ctx) {
      var matrix = this.matrix;
      ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
    }
  }, {
    key: "unapply",
    value: function unapply(ctx) {
      var matrix = this.matrix;
      var a = matrix[0];
      var b = matrix[2];
      var c = matrix[4];
      var d = matrix[1];
      var e = matrix[3];
      var f = matrix[5];
      var g = 0.0;
      var h = 0.0;
      var i = 1.0;
      var det = 1 / (a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g));
      ctx.transform(det * (e * i - f * h), det * (f * g - d * i), det * (c * h - b * i), det * (a * i - c * g), det * (b * f - c * e), det * (c * d - a * f));
    }
  }, {
    key: "applyToPoint",
    value: function applyToPoint(point) {
      point.applyTransform(this.matrix);
    }
  }]);

  return Matrix;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var Skew = /*#__PURE__*/function (_Matrix) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(Skew, _Matrix);

  var _super = _createSuper(Skew);

  function Skew(document, skew) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Skew);

    _this = _super.call(this, document, skew);
    _this.type = 'skew';
    _this.angle = null;
    _this.angle = new Property(document, 'angle', skew);
    return _this;
  }

  return Skew;
}(Matrix);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var SkewX = /*#__PURE__*/function (_Skew) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(SkewX, _Skew);

  var _super = _createSuper$1(SkewX);

  function SkewX(document, skew) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, SkewX);

    _this = _super.call(this, document, skew);
    _this.type = 'skewX';
    _this.matrix = [1, 0, Math.tan(_this.angle.getRadians()), 1, 0, 0];
    return _this;
  }

  return SkewX;
}(Skew);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var SkewY = /*#__PURE__*/function (_Skew) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(SkewY, _Skew);

  var _super = _createSuper$2(SkewY);

  function SkewY(document, skew) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, SkewY);

    _this = _super.call(this, document, skew);
    _this.type = 'skewY';
    _this.matrix = [1, Math.tan(_this.angle.getRadians()), 0, 1, 0, 0];
    return _this;
  }

  return SkewY;
}(Skew);

function parseTransforms(transform) {
  var _context;

  return _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_context = compressSpaces(transform)).call(_context).replace(/\)([a-zA-Z])/g, ') $1').replace(/\)(\s?,\s?)/g, ') ').split(/\s(?=[a-z])/);
}

function parseTransform(transform) {
  var _transform$split = transform.split('('),
      _transform$split2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_transform$split, 2),
      type = _transform$split2[0],
      value = _transform$split2[1];

  return [_babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(type).call(type), _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(value).call(value).replace(')', '')];
}

var Transform = /*#__PURE__*/function () {
  function Transform(document, transform, transformOrigin) {
    var _this = this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Transform);

    this.document = document;
    this.transforms = [];
    var data = parseTransforms(transform);

    _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(data).call(data, function (transform) {
      if (transform === 'none') {
        return;
      }

      var _parseTransform = parseTransform(transform),
          _parseTransform2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_parseTransform, 2),
          type = _parseTransform2[0],
          value = _parseTransform2[1];

      var TransformType = Transform.transformTypes[type];

      if (typeof TransformType !== 'undefined') {
        _this.transforms.push(new TransformType(_this.document, value, transformOrigin));
      }
    });
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Transform, [{
    key: "apply",
    value: function apply(ctx) {
      var transforms = this.transforms;
      var len = transforms.length;

      for (var i = 0; i < len; i++) {
        transforms[i].apply(ctx);
      }
    }
  }, {
    key: "unapply",
    value: function unapply(ctx) {
      var transforms = this.transforms;
      var len = transforms.length;

      for (var i = len - 1; i >= 0; i--) {
        transforms[i].unapply(ctx);
      }
    } // TODO: applyToPoint unused ... remove?

  }, {
    key: "applyToPoint",
    value: function applyToPoint(point) {
      var transforms = this.transforms;
      var len = transforms.length;

      for (var i = 0; i < len; i++) {
        transforms[i].applyToPoint(point);
      }
    }
  }], [{
    key: "fromElement",
    value: function fromElement(document, element) {
      var transformStyle = element.getStyle('transform', false, true);

      var _element$getStyle$spl = element.getStyle('transform-origin', false, true).split(),
          _element$getStyle$spl2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_element$getStyle$spl, 2),
          transformOriginXProperty = _element$getStyle$spl2[0],
          _element$getStyle$spl3 = _element$getStyle$spl2[1],
          transformOriginYProperty = _element$getStyle$spl3 === void 0 ? transformOriginXProperty : _element$getStyle$spl3;

      var transformOrigin = [transformOriginXProperty, transformOriginYProperty];

      if (transformStyle.hasValue()) {
        return new Transform(document, transformStyle.getString(), transformOrigin);
      }

      return null;
    }
  }]);

  return Transform;
}();
Transform.transformTypes = {
  translate: Translate,
  rotate: Rotate,
  scale: Scale,
  matrix: Matrix,
  skewX: SkewX,
  skewY: SkewY
};

var Element = /*#__PURE__*/function () {
  function Element(document, node) {
    var _context,
        _this = this,
        _context4;

    var captureTextNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Element);

    this.document = document;
    this.node = node;
    this.captureTextNodes = captureTextNodes;
    this.attributes = {};
    this.styles = {};
    this.stylesSpecificity = {};
    this.animationFrozen = false;
    this.animationFrozenValue = '';
    this.parent = null;
    this.children = [];

    if (!node || node.nodeType !== 1) {
      // ELEMENT_NODE
      return;
    } // add attributes


    _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(node.attributes)).call(_context, function (attribute) {
      var nodeName = normalizeAttributeName(attribute.nodeName);
      _this.attributes[nodeName] = new Property(document, nodeName, attribute.value);
    });

    this.addStylesFromStyleDefinition(); // add inline styles

    if (this.getAttribute('style').hasValue()) {
      var _context2;

      var styles = _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(_context2 = this.getAttribute('style').getString().split(';')).call(_context2, function (_) {
        return _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_).call(_);
      });

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(styles).call(styles, function (style) {
        var _context3;

        if (!style) {
          return;
        }

        var _style$split$map = _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(_context3 = style.split(':')).call(_context3, function (_) {
          return _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_).call(_);
        }),
            _style$split$map2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_style$split$map, 2),
            name = _style$split$map2[0],
            value = _style$split$map2[1];

        _this.styles[name] = new Property(document, name, value);
      });
    }

    var definitions = document.definitions;
    var id = this.getAttribute('id'); // add id

    if (id.hasValue()) {
      if (!definitions[id.getValue()]) {
        definitions[id.getValue()] = this;
      }
    }

    _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context4 = _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(node.childNodes)).call(_context4, function (childNode) {
      if (childNode.nodeType === 1) {
        _this.addChild(childNode); // ELEMENT_NODE

      } else if (captureTextNodes && (childNode.nodeType === 3 || childNode.nodeType === 4)) {
        var textNode = document.createTextNode(childNode);

        if (textNode.getText().length > 0) {
          _this.addChild(textNode); // TEXT_NODE

        }
      }
    });
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Element, [{
    key: "getAttribute",
    value: function getAttribute(name) {
      var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var attr = this.attributes[name];

      if (!attr && createIfNotExists) {
        var _attr = new Property(this.document, name, '');

        this.attributes[name] = _attr;
        return _attr;
      }

      return attr || Property.empty(this.document);
    }
  }, {
    key: "getHrefAttribute",
    value: function getHrefAttribute() {
      for (var key in this.attributes) {
        if (key === 'href' || /:href$/.test(key)) {
          return this.attributes[key];
        }
      }

      return Property.empty(this.document);
    }
  }, {
    key: "getStyle",
    value: function getStyle(name) {
      var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var skipAncestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var style = this.styles[name];

      if (style) {
        return style;
      }

      var attr = this.getAttribute(name);

      if (attr && attr.hasValue()) {
        this.styles[name] = attr; // move up to me to cache

        return attr;
      }

      if (!skipAncestors) {
        var parent = this.parent;

        if (parent) {
          var parentStyle = parent.getStyle(name);

          if (parentStyle && parentStyle.hasValue()) {
            return parentStyle;
          }
        }
      }

      if (createIfNotExists) {
        var _style = new Property(this.document, name, '');

        this.styles[name] = _style;
        return _style;
      }

      return style || Property.empty(this.document);
    }
  }, {
    key: "render",
    value: function render(ctx) {
      // don't render display=none
      // don't render visibility=hidden
      if (this.getStyle('display').getString() === 'none' || this.getStyle('visibility').getString() === 'hidden') {
        return;
      }

      ctx.save();

      if (this.getStyle('mask').hasValue()) {
        // mask
        var mask = this.getStyle('mask').getDefinition();

        if (mask) {
          this.applyEffects(ctx);
          mask.apply(ctx, this);
        }
      } else if (this.getStyle('filter').getValue('none') !== 'none') {
        // filter
        var filter = this.getStyle('filter').getDefinition();

        if (filter) {
          this.applyEffects(ctx);
          filter.apply(ctx, this);
        }
      } else {
        this.setContext(ctx);
        this.renderChildren(ctx);
        this.clearContext(ctx);
      }

      ctx.restore();
    }
  }, {
    key: "setContext",
    value: function setContext(_) {}
  }, {
    key: "applyEffects",
    value: function applyEffects(ctx) {
      // transform
      var transform = Transform.fromElement(this.document, this);

      if (transform) {
        transform.apply(ctx);
      } // clip


      var clipPathStyleProp = this.getStyle('clip-path', false, true);

      if (clipPathStyleProp.hasValue()) {
        var clip = clipPathStyleProp.getDefinition();

        if (clip) {
          clip.apply(ctx);
        }
      }
    }
  }, {
    key: "clearContext",
    value: function clearContext(_) {}
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      var _context5;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context5 = this.children).call(_context5, function (child) {
        child.render(ctx);
      });
    }
  }, {
    key: "addChild",
    value: function addChild(childNode) {
      var _context6;

      var child = childNode instanceof Element ? childNode : this.document.createElement(childNode);
      child.parent = this;

      if (!_babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32___default()(_context6 = Element.ignoreChildTypes).call(_context6, child.type)) {
        this.children.push(child);
      }
    }
  }, {
    key: "matchesSelector",
    value: function matchesSelector(selector) {
      var _context7;

      var node = this.node;

      if (typeof node.matches === 'function') {
        return node.matches(selector);
      }

      var styleClasses = node.getAttribute('class');

      if (!styleClasses || styleClasses === '') {
        return false;
      }

      return _babel_runtime_corejs3_core_js_stable_instance_some__WEBPACK_IMPORTED_MODULE_31___default()(_context7 = styleClasses.split(' ')).call(_context7, function (styleClass) {
        if (".".concat(styleClass) === selector) {
          return true;
        }
      });
    }
  }, {
    key: "addStylesFromStyleDefinition",
    value: function addStylesFromStyleDefinition() {
      var _this$document = this.document,
          styles = _this$document.styles,
          stylesSpecificity = _this$document.stylesSpecificity;

      for (var selector in styles) {
        if (selector[0] !== '@' && this.matchesSelector(selector)) {
          var style = styles[selector];
          var specificity = stylesSpecificity[selector];

          if (style) {
            for (var name in style) {
              var existingSpecificity = this.stylesSpecificity[name];

              if (typeof existingSpecificity === 'undefined') {
                existingSpecificity = '000';
              }

              if (specificity >= existingSpecificity) {
                this.styles[name] = style[name];
                this.stylesSpecificity[name] = specificity;
              }
            }
          }
        }
      }
    }
  }, {
    key: "removeStyles",
    value: function removeStyles(element, ignoreStyles) {
      var toRestore = _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18___default()(ignoreStyles).call(ignoreStyles, function (toRestore, name) {
        var _context8;

        var styleProp = element.getStyle(name);

        if (!styleProp.hasValue()) {
          return toRestore;
        }

        var value = styleProp.getString();
        styleProp.setValue('');
        return _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context8 = []).call(_context8, (0,_babel_runtime_corejs3_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_30__.default)(toRestore), [[name, value]]);
      }, []);

      return toRestore;
    }
  }, {
    key: "restoreStyles",
    value: function restoreStyles(element, styles) {
      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(styles).call(styles, function (_ref) {
        var _ref2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        element.getStyle(name, true).setValue(value);
      });
    }
  }]);

  return Element;
}();
Element.ignoreChildTypes = ['title'];

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var UnknownElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(UnknownElement, _Element);

  var _super = _createSuper$3(UnknownElement);

  function UnknownElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, UnknownElement);

    _this = _super.call(this, document, node, captureTextNodes);

    return _this;
  }

  return UnknownElement;
}(Element);

function wrapFontFamily(fontFamily) {
  var trimmed = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(fontFamily).call(fontFamily);

  return /^('|")/.test(trimmed) ? trimmed : "\"".concat(trimmed, "\"");
}

function prepareFontFamily(fontFamily) {
  var _context;

  return typeof process === 'undefined' ? fontFamily : _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(_context = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(fontFamily).call(fontFamily).split(',')).call(_context, wrapFontFamily).join(',');
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-style
 */


function prepareFontStyle(fontStyle) {
  if (!fontStyle) {
    return '';
  }

  var targetFontStyle = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(fontStyle).call(fontStyle).toLowerCase();

  switch (targetFontStyle) {
    case 'normal':
    case 'italic':
    case 'oblique':
    case 'inherit':
    case 'initial':
    case 'unset':
      return targetFontStyle;

    default:
      if (/^oblique\s+(-|)\d+deg$/.test(targetFontStyle)) {
        return targetFontStyle;
      }

      return '';
  }
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
 */


function prepareFontWeight(fontWeight) {
  if (!fontWeight) {
    return '';
  }

  var targetFontWeight = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(fontWeight).call(fontWeight).toLowerCase();

  switch (targetFontWeight) {
    case 'normal':
    case 'bold':
    case 'lighter':
    case 'bolder':
    case 'inherit':
    case 'initial':
    case 'unset':
      return targetFontWeight;

    default:
      if (/^[\d.]+$/.test(targetFontWeight)) {
        return targetFontWeight;
      }

      return '';
  }
}

var Font = /*#__PURE__*/function () {
  function Font(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Font);

    var inheritFont = inherit ? typeof inherit === 'string' ? Font.parse(inherit) : inherit : {};
    this.fontFamily = fontFamily || inheritFont.fontFamily;
    this.fontSize = fontSize || inheritFont.fontSize;
    this.fontStyle = fontStyle || inheritFont.fontStyle;
    this.fontWeight = fontWeight || inheritFont.fontWeight;
    this.fontVariant = fontVariant || inheritFont.fontVariant;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Font, [{
    key: "toString",
    value: function toString() {
      var _context2;

      return _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_context2 = [prepareFontStyle(this.fontStyle), this.fontVariant, prepareFontWeight(this.fontWeight), this.fontSize, // Wrap fontFamily only on nodejs and only for canvas.ctx
      prepareFontFamily(this.fontFamily)].join(' ')).call(_context2);
    }
  }], [{
    key: "parse",
    value: function parse() {
      var _context3;

      var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var inherit = arguments.length > 1 ? arguments[1] : undefined;
      var fontStyle = '';
      var fontVariant = '';
      var fontWeight = '';
      var fontSize = '';
      var fontFamily = '';

      var parts = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_context3 = compressSpaces(font)).call(_context3).split(' ');

      var set = {
        fontSize: false,
        fontStyle: false,
        fontWeight: false,
        fontVariant: false
      };

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(parts).call(parts, function (part) {
        var _context4, _context5, _context6;

        switch (true) {
          case !set.fontStyle && _babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32___default()(_context4 = Font.styles).call(_context4, part):
            if (part !== 'inherit') {
              fontStyle = part;
            }

            set.fontStyle = true;
            break;

          case !set.fontVariant && _babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32___default()(_context5 = Font.variants).call(_context5, part):
            if (part !== 'inherit') {
              fontVariant = part;
            }

            set.fontStyle = true;
            set.fontVariant = true;
            break;

          case !set.fontWeight && _babel_runtime_corejs3_core_js_stable_instance_includes__WEBPACK_IMPORTED_MODULE_32___default()(_context6 = Font.weights).call(_context6, part):
            if (part !== 'inherit') {
              fontWeight = part;
            }

            set.fontStyle = true;
            set.fontVariant = true;
            set.fontWeight = true;
            break;

          case !set.fontSize:
            if (part !== 'inherit') {
              var _part$split = part.split('/');

              var _part$split2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_part$split, 1);

              fontSize = _part$split2[0];
            }

            set.fontStyle = true;
            set.fontVariant = true;
            set.fontWeight = true;
            set.fontSize = true;
            break;

          default:
            if (part !== 'inherit') {
              fontFamily += part;
            }

        }
      });

      return new Font(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit);
    }
  }]);

  return Font;
}();
Font.styles = 'normal|italic|oblique|inherit';
Font.variants = 'normal|small-caps|inherit';
Font.weights = 'normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';

var BoundingBox = /*#__PURE__*/function () {
  function BoundingBox() {
    var x1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NaN;
    var y1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.NaN;
    var x2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.NaN;
    var y2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Number.NaN;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, BoundingBox);

    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
    this.addPoint(x1, y1);
    this.addPoint(x2, y2);
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(BoundingBox, [{
    key: "addPoint",
    value: function addPoint(x, y) {
      if (typeof x !== 'undefined') {
        if (isNaN(this.x1) || isNaN(this.x2)) {
          this.x1 = x;
          this.x2 = x;
        }

        if (x < this.x1) {
          this.x1 = x;
        }

        if (x > this.x2) {
          this.x2 = x;
        }
      }

      if (typeof y !== 'undefined') {
        if (isNaN(this.y1) || isNaN(this.y2)) {
          this.y1 = y;
          this.y2 = y;
        }

        if (y < this.y1) {
          this.y1 = y;
        }

        if (y > this.y2) {
          this.y2 = y;
        }
      }
    }
  }, {
    key: "addX",
    value: function addX(x) {
      this.addPoint(x, null);
    }
  }, {
    key: "addY",
    value: function addY(y) {
      this.addPoint(null, y);
    }
  }, {
    key: "addBoundingBox",
    value: function addBoundingBox(boundingBox) {
      if (!boundingBox) {
        return;
      }

      var x1 = boundingBox.x1,
          y1 = boundingBox.y1,
          x2 = boundingBox.x2,
          y2 = boundingBox.y2;
      this.addPoint(x1, y1);
      this.addPoint(x2, y2);
    }
  }, {
    key: "sumCubic",
    value: function sumCubic(t, p0, p1, p2, p3) {
      return Math.pow(1 - t, 3) * p0 + 3 * Math.pow(1 - t, 2) * t * p1 + 3 * (1 - t) * Math.pow(t, 2) * p2 + Math.pow(t, 3) * p3;
    }
  }, {
    key: "bezierCurveAdd",
    value: function bezierCurveAdd(forX, p0, p1, p2, p3) {
      var b = 6 * p0 - 12 * p1 + 6 * p2;
      var a = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
      var c = 3 * p1 - 3 * p0;

      if (a === 0) {
        if (b === 0) {
          return;
        }

        var t = -c / b;

        if (0 < t && t < 1) {
          if (forX) {
            this.addX(this.sumCubic(t, p0, p1, p2, p3));
          } else {
            this.addY(this.sumCubic(t, p0, p1, p2, p3));
          }
        }

        return;
      }

      var b2ac = Math.pow(b, 2) - 4 * c * a;

      if (b2ac < 0) {
        return;
      }

      var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);

      if (0 < t1 && t1 < 1) {
        if (forX) {
          this.addX(this.sumCubic(t1, p0, p1, p2, p3));
        } else {
          this.addY(this.sumCubic(t1, p0, p1, p2, p3));
        }
      }

      var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);

      if (0 < t2 && t2 < 1) {
        if (forX) {
          this.addX(this.sumCubic(t2, p0, p1, p2, p3));
        } else {
          this.addY(this.sumCubic(t2, p0, p1, p2, p3));
        }
      }
    } // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html

  }, {
    key: "addBezierCurve",
    value: function addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
      this.addPoint(p0x, p0y);
      this.addPoint(p3x, p3y);
      this.bezierCurveAdd(true, p0x, p1x, p2x, p3x);
      this.bezierCurveAdd(false, p0y, p1y, p2y, p3y);
    }
  }, {
    key: "addQuadraticCurve",
    value: function addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
      var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)

      var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)

      var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)

      var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)

      this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
    }
  }, {
    key: "isPointInBox",
    value: function isPointInBox(x, y) {
      var x1 = this.x1,
          y1 = this.y1,
          x2 = this.x2,
          y2 = this.y2;
      return x1 <= x && x <= x2 && y1 <= y && y <= y2;
    }
  }, {
    key: "x",
    get: function get() {
      return this.x1;
    }
  }, {
    key: "y",
    get: function get() {
      return this.y1;
    }
  }, {
    key: "width",
    get: function get() {
      return this.x2 - this.x1;
    }
  }, {
    key: "height",
    get: function get() {
      return this.y2 - this.y1;
    }
  }]);

  return BoundingBox;
}();

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var RenderedElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(RenderedElement, _Element);

  var _super = _createSuper$4(RenderedElement);

  function RenderedElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, RenderedElement);

    _this = _super.apply(this, arguments);
    _this.modifiedEmSizeStack = false;
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(RenderedElement, [{
    key: "calculateOpacity",
    value: function calculateOpacity() {
      var opacity = 1.0; // tslint:disable-next-line: no-this-assignment

      var element = this;

      while (element) {
        var opacityStyle = element.getStyle('opacity', false, true); // no ancestors on style call

        if (opacityStyle.hasValue(true)) {
          opacity *= opacityStyle.getNumber();
        }

        element = element.parent;
      }

      return opacity;
    }
  }, {
    key: "setContext",
    value: function setContext(ctx) {
      var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!fromMeasure) {
        // causes stack overflow when measuring text with gradients
        // fill
        var fillStyleProp = this.getStyle('fill');
        var fillOpacityStyleProp = this.getStyle('fill-opacity');
        var strokeStyleProp = this.getStyle('stroke');
        var strokeOpacityProp = this.getStyle('stroke-opacity');

        if (fillStyleProp.isUrlDefinition()) {
          var fillStyle = fillStyleProp.getFillStyleDefinition(this, fillOpacityStyleProp);

          if (fillStyle) {
            ctx.fillStyle = fillStyle;
          }
        } else if (fillStyleProp.hasValue()) {
          if (fillStyleProp.getString() === 'currentColor') {
            fillStyleProp.setValue(this.getStyle('color').getColor());
          }

          var _fillStyle = fillStyleProp.getColor();

          if (_fillStyle !== 'inherit') {
            ctx.fillStyle = _fillStyle === 'none' ? 'rgba(0,0,0,0)' : _fillStyle;
          }
        }

        if (fillOpacityStyleProp.hasValue()) {
          var _fillStyle2 = new Property(this.document, 'fill', ctx.fillStyle).addOpacity(fillOpacityStyleProp).getColor();

          ctx.fillStyle = _fillStyle2;
        } // stroke


        if (strokeStyleProp.isUrlDefinition()) {
          var strokeStyle = strokeStyleProp.getFillStyleDefinition(this, strokeOpacityProp);

          if (strokeStyle) {
            ctx.strokeStyle = strokeStyle;
          }
        } else if (strokeStyleProp.hasValue()) {
          if (strokeStyleProp.getString() === 'currentColor') {
            strokeStyleProp.setValue(this.getStyle('color').getColor());
          }

          var _strokeStyle = strokeStyleProp.getString();

          if (_strokeStyle !== 'inherit') {
            ctx.strokeStyle = _strokeStyle === 'none' ? 'rgba(0,0,0,0)' : _strokeStyle;
          }
        }

        if (strokeOpacityProp.hasValue()) {
          var _strokeStyle2 = new Property(this.document, 'stroke', ctx.strokeStyle).addOpacity(strokeOpacityProp).getString();

          ctx.strokeStyle = _strokeStyle2;
        }

        var strokeWidthStyleProp = this.getStyle('stroke-width');

        if (strokeWidthStyleProp.hasValue()) {
          var newLineWidth = strokeWidthStyleProp.getPixels();
          ctx.lineWidth = !newLineWidth ? PSEUDO_ZERO // browsers don't respect 0 (or node-canvas? :-)
          : newLineWidth;
        }

        var strokeLinecapStyleProp = this.getStyle('stroke-linecap');
        var strokeLinejoinStyleProp = this.getStyle('stroke-linejoin');
        var strokeMiterlimitProp = this.getStyle('stroke-miterlimit');
        var pointOrderStyleProp = this.getStyle('paint-order');
        var strokeDasharrayStyleProp = this.getStyle('stroke-dasharray');
        var strokeDashoffsetProp = this.getStyle('stroke-dashoffset');

        if (strokeLinecapStyleProp.hasValue()) {
          ctx.lineCap = strokeLinecapStyleProp.getString();
        }

        if (strokeLinejoinStyleProp.hasValue()) {
          ctx.lineJoin = strokeLinejoinStyleProp.getString();
        }

        if (strokeMiterlimitProp.hasValue()) {
          ctx.miterLimit = strokeMiterlimitProp.getNumber();
        }

        if (pointOrderStyleProp.hasValue()) {
          // ?
          ctx.paintOrder = pointOrderStyleProp.getValue();
        }

        if (strokeDasharrayStyleProp.hasValue() && strokeDasharrayStyleProp.getString() !== 'none') {
          var gaps = toNumbers(strokeDasharrayStyleProp.getString());

          if (typeof ctx.setLineDash !== 'undefined') {
            ctx.setLineDash(gaps);
          } else if (typeof ctx.webkitLineDash !== 'undefined') {
            ctx.webkitLineDash = gaps;
          } else if (typeof ctx.mozDash !== 'undefined' && !(gaps.length === 1 && gaps[0] === 0)) {
            ctx.mozDash = gaps;
          }

          var offset = strokeDashoffsetProp.getPixels();

          if (typeof ctx.lineDashOffset !== 'undefined') {
            ctx.lineDashOffset = offset;
          } else if (typeof ctx.webkitLineDashOffset !== 'undefined') {
            ctx.webkitLineDashOffset = offset;
          } else if (typeof ctx.mozDashOffset !== 'undefined') {
            ctx.mozDashOffset = offset;
          }
        }
      } // font


      this.modifiedEmSizeStack = false;

      if (typeof ctx.font !== 'undefined') {
        var fontStyleProp = this.getStyle('font');
        var fontStyleStyleProp = this.getStyle('font-style');
        var fontVariantStyleProp = this.getStyle('font-variant');
        var fontWeightStyleProp = this.getStyle('font-weight');
        var fontSizeStyleProp = this.getStyle('font-size');
        var fontFamilyStyleProp = this.getStyle('font-family');
        var font = new Font(fontStyleStyleProp.getString(), fontVariantStyleProp.getString(), fontWeightStyleProp.getString(), fontSizeStyleProp.hasValue() ? "".concat(fontSizeStyleProp.getPixels(true), "px") : '', fontFamilyStyleProp.getString(), Font.parse(fontStyleProp.getString(), ctx.font));
        fontStyleStyleProp.setValue(font.fontStyle);
        fontVariantStyleProp.setValue(font.fontVariant);
        fontWeightStyleProp.setValue(font.fontWeight);
        fontSizeStyleProp.setValue(font.fontSize);
        fontFamilyStyleProp.setValue(font.fontFamily);
        ctx.font = font.toString();

        if (fontSizeStyleProp.isPixels()) {
          this.document.emSize = fontSizeStyleProp.getPixels();
          this.modifiedEmSizeStack = true;
        }
      }

      if (!fromMeasure) {
        // effects
        this.applyEffects(ctx); // opacity

        ctx.globalAlpha = this.calculateOpacity();
      }
    }
  }, {
    key: "clearContext",
    value: function clearContext(ctx) {
      (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(RenderedElement.prototype), "clearContext", this).call(this, ctx);

      if (this.modifiedEmSizeStack) {
        this.document.popEmSize();
      }
    }
  }]);

  return RenderedElement;
}(Element);

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(TextElement, _RenderedElement);

  var _super = _createSuper$5(TextElement);

  function TextElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, TextElement);

    _this = _super.call(this, document, node, (this instanceof TextElement ? this.constructor : void 0) === TextElement ? true : captureTextNodes);
    _this.type = 'text';
    _this.x = 0;
    _this.y = 0;
    _this.measureCache = -1;
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(TextElement, [{
    key: "setContext",
    value: function setContext(ctx) {
      var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(TextElement.prototype), "setContext", this).call(this, ctx, fromMeasure);

      var textBaseline = this.getStyle('dominant-baseline').getTextBaseline() || this.getStyle('alignment-baseline').getTextBaseline();

      if (textBaseline) {
        ctx.textBaseline = textBaseline;
      }
    }
  }, {
    key: "initializeCoordinates",
    value: function initializeCoordinates(ctx) {
      this.x = this.getAttribute('x').getPixels('x');
      this.y = this.getAttribute('y').getPixels('y');
      var dxAttr = this.getAttribute('dx');
      var dyAttr = this.getAttribute('dy');

      if (dxAttr.hasValue()) {
        this.x += dxAttr.getPixels('x');
      }

      if (dyAttr.hasValue()) {
        this.y += dyAttr.getPixels('y');
      }

      this.x += this.getAnchorDelta(ctx, this, 0);
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(ctx) {
      var _context,
          _this2 = this;

      if (this.type !== 'text') {
        return this.getTElementBoundingBox(ctx);
      }

      this.initializeCoordinates(ctx);
      var boundingBox = null;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = this.children).call(_context, function (_, i) {
        var childBoundingBox = _this2.getChildBoundingBox(ctx, _this2, _this2, i);

        if (!boundingBox) {
          boundingBox = childBoundingBox;
        } else {
          boundingBox.addBoundingBox(childBoundingBox);
        }
      });

      return boundingBox;
    }
  }, {
    key: "getFontSize",
    value: function getFontSize() {
      var document = this.document,
          parent = this.parent;
      var inheritFontSize = Font.parse(document.ctx.font).fontSize;
      var fontSize = parent.getStyle('font-size').getNumber(inheritFontSize);
      return fontSize;
    }
  }, {
    key: "getTElementBoundingBox",
    value: function getTElementBoundingBox(ctx) {
      var fontSize = this.getFontSize();
      return new BoundingBox(this.x, this.y - fontSize, this.x + this.measureText(ctx), this.y);
    }
  }, {
    key: "getGlyph",
    value: function getGlyph(font, text, i) {
      var char = text[i];
      var glyph = null;

      if (font.isArabic) {
        var len = text.length;
        var prevChar = text[i - 1];
        var nextChar = text[i + 1];
        var arabicForm = 'isolated';

        if ((i === 0 || prevChar === ' ') && i < len - 2 && nextChar !== ' ') {
          arabicForm = 'terminal';
        }

        if (i > 0 && prevChar !== ' ' && i < len - 2 && nextChar !== ' ') {
          arabicForm = 'medial';
        }

        if (i > 0 && prevChar !== ' ' && (i === len - 1 || nextChar === ' ')) {
          arabicForm = 'initial';
        }

        if (typeof font.glyphs[char] !== 'undefined') {
          glyph = font.glyphs[char][arabicForm];

          if (!glyph && font.glyphs[char].type === 'glyph') {
            glyph = font.glyphs[char];
          }
        }
      } else {
        glyph = font.glyphs[char];
      }

      if (!glyph) {
        glyph = font.missingGlyph;
      }

      return glyph;
    }
  }, {
    key: "getText",
    value: function getText() {
      return '';
    }
  }, {
    key: "getTextFromNode",
    value: function getTextFromNode(node) {
      var textNode = node || this.node;

      var childNodes = _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(textNode.parentNode.childNodes);

      var index = _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_35___default()(childNodes).call(childNodes, textNode);

      var lastIndex = childNodes.length - 1;
      var text = compressSpaces(textNode.value || textNode.text || textNode.textContent || '');

      if (index === 0) {
        text = trimLeft(text);
      }

      if (index === lastIndex) {
        text = trimRight(text);
      }

      return text;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      var _context2,
          _this3 = this;

      if (this.type !== 'text') {
        this.renderTElementChildren(ctx);
        return;
      }

      this.initializeCoordinates(ctx);

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context2 = this.children).call(_context2, function (_, i) {
        _this3.renderChild(ctx, _this3, _this3, i);
      });

      var mouse = this.document.screen.mouse; // Do not calc bounding box if mouse is not working.

      if (mouse.isWorking()) {
        mouse.checkBoundingBox(this, this.getBoundingBox(ctx));
      }
    }
  }, {
    key: "renderTElementChildren",
    value: function renderTElementChildren(ctx) {
      var document = this.document,
          parent = this.parent;
      var renderText = this.getText();
      var customFont = parent.getStyle('font-family').getDefinition();

      if (customFont) {
        var _context3;

        var unitsPerEm = customFont.fontFace.unitsPerEm;
        var ctxFont = Font.parse(document.ctx.font);
        var fontSize = parent.getStyle('font-size').getNumber(ctxFont.fontSize);
        var fontStyle = parent.getStyle('font-style').getString(ctxFont.fontStyle);
        var scale = fontSize / unitsPerEm;
        var text = customFont.isRTL ? _babel_runtime_corejs3_core_js_stable_instance_reverse__WEBPACK_IMPORTED_MODULE_34___default()(_context3 = renderText.split('')).call(_context3).join('') : renderText;
        var dx = toNumbers(parent.getAttribute('dx').getString());
        var len = text.length;

        for (var i = 0; i < len; i++) {
          var glyph = this.getGlyph(customFont, text, i);
          ctx.translate(this.x, this.y);
          ctx.scale(scale, -scale);
          var lw = ctx.lineWidth;
          ctx.lineWidth = ctx.lineWidth * unitsPerEm / fontSize;

          if (fontStyle === 'italic') {
            ctx.transform(1, 0, .4, 1, 0, 0);
          }

          glyph.render(ctx);

          if (fontStyle === 'italic') {
            ctx.transform(1, 0, -.4, 1, 0, 0);
          }

          ctx.lineWidth = lw;
          ctx.scale(1 / scale, -1 / scale);
          ctx.translate(-this.x, -this.y);
          this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / unitsPerEm;

          if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) {
            this.x += dx[i];
          }
        }

        return;
      }

      var x = this.x,
          y = this.y;

      if (ctx.paintOrder === 'stroke') {
        if (ctx.strokeStyle) {
          ctx.strokeText(renderText, x, y);
        }

        if (ctx.fillStyle) {
          ctx.fillText(renderText, x, y);
        }
      } else {
        if (ctx.fillStyle) {
          ctx.fillText(renderText, x, y);
        }

        if (ctx.strokeStyle) {
          ctx.strokeText(renderText, x, y);
        }
      }
    }
  }, {
    key: "getAnchorDelta",
    value: function getAnchorDelta(ctx, parent, startI) {
      var textAnchor = this.getStyle('text-anchor').getString('start');

      if (textAnchor !== 'start') {
        var children = parent.children;
        var len = children.length;
        var child = null;
        var width = 0;

        for (var i = startI; i < len; i++) {
          child = children[i];

          if (i > startI && child.getAttribute('x').hasValue() || child.getAttribute('text-anchor').hasValue()) {
            break; // new group
          }

          width += child.measureTextRecursive(ctx);
        }

        return -1 * (textAnchor === 'end' ? width : width / 2.0);
      }

      return 0;
    }
  }, {
    key: "adjustChildCoordinates",
    value: function adjustChildCoordinates(ctx, textParent, parent, i) {
      var child = parent.children[i];

      if (typeof child.measureText !== 'function') {
        return child;
      }

      ctx.save();
      child.setContext(ctx, true);
      var xAttr = child.getAttribute('x');
      var yAttr = child.getAttribute('y');
      var dxAttr = child.getAttribute('dx');
      var dyAttr = child.getAttribute('dy');
      var textAnchor = child.getAttribute('text-anchor').getString('start');

      if (i === 0 && child.type !== 'textNode') {
        if (!xAttr.hasValue()) {
          xAttr.setValue(textParent.getAttribute('x').getValue('0'));
        }

        if (!yAttr.hasValue()) {
          yAttr.setValue(textParent.getAttribute('y').getValue('0'));
        }

        if (!dxAttr.hasValue()) {
          dxAttr.setValue(textParent.getAttribute('dx').getValue('0'));
        }

        if (!dyAttr.hasValue()) {
          dyAttr.setValue(textParent.getAttribute('dy').getValue('0'));
        }
      }

      if (xAttr.hasValue()) {
        child.x = xAttr.getPixels('x') + textParent.getAnchorDelta(ctx, parent, i);

        if (textAnchor !== 'start') {
          var width = child.measureTextRecursive(ctx);
          child.x += -1 * (textAnchor === 'end' ? width : width / 2.0);
        }

        if (dxAttr.hasValue()) {
          child.x += dxAttr.getPixels('x');
        }
      } else {
        if (textAnchor !== 'start') {
          var _width = child.measureTextRecursive(ctx);

          textParent.x += -1 * (textAnchor === 'end' ? _width : _width / 2.0);
        }

        if (dxAttr.hasValue()) {
          textParent.x += dxAttr.getPixels('x');
        }

        child.x = textParent.x;
      }

      textParent.x = child.x + child.measureText(ctx);

      if (yAttr.hasValue()) {
        child.y = yAttr.getPixels('y');

        if (dyAttr.hasValue()) {
          child.y += dyAttr.getPixels('y');
        }
      } else {
        if (dyAttr.hasValue()) {
          textParent.y += dyAttr.getPixels('y');
        }

        child.y = textParent.y;
      }

      textParent.y = child.y;
      child.clearContext(ctx);
      ctx.restore();
      return child;
    }
  }, {
    key: "getChildBoundingBox",
    value: function getChildBoundingBox(ctx, textParent, parent, i) {
      var _context4;

      var child = this.adjustChildCoordinates(ctx, textParent, parent, i); // not a text node?

      if (typeof child.getBoundingBox !== 'function') {
        return null;
      }

      var boundingBox = child.getBoundingBox(ctx);

      if (!boundingBox) {
        return null;
      }

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context4 = child.children).call(_context4, function (_, i) {
        var childBoundingBox = textParent.getChildBoundingBox(ctx, textParent, child, i);
        boundingBox.addBoundingBox(childBoundingBox);
      });

      return boundingBox;
    }
  }, {
    key: "renderChild",
    value: function renderChild(ctx, textParent, parent, i) {
      var _context5;

      var child = this.adjustChildCoordinates(ctx, textParent, parent, i);
      child.render(ctx);

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context5 = child.children).call(_context5, function (_, i) {
        textParent.renderChild(ctx, textParent, child, i);
      });
    }
  }, {
    key: "measureTextRecursive",
    value: function measureTextRecursive(ctx) {
      var _context6;

      var width = _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18___default()(_context6 = this.children).call(_context6, function (width, child) {
        return width + child.measureTextRecursive(ctx);
      }, this.measureText(ctx));

      return width;
    }
  }, {
    key: "measureText",
    value: function measureText(ctx) {
      var measureCache = this.measureCache;

      if (~measureCache) {
        return measureCache;
      }

      var renderText = this.getText();
      var measure = this.measureTargetText(ctx, renderText);
      this.measureCache = measure;
      return measure;
    }
  }, {
    key: "measureTargetText",
    value: function measureTargetText(ctx, targetText) {
      if (!targetText.length) {
        return 0;
      }

      var parent = this.parent;
      var customFont = parent.getStyle('font-family').getDefinition();

      if (customFont) {
        var _context7;

        var fontSize = this.getFontSize();
        var text = customFont.isRTL ? _babel_runtime_corejs3_core_js_stable_instance_reverse__WEBPACK_IMPORTED_MODULE_34___default()(_context7 = targetText.split('')).call(_context7).join('') : targetText;
        var dx = toNumbers(parent.getAttribute('dx').getString());
        var len = text.length;
        var _measure = 0;

        for (var i = 0; i < len; i++) {
          var glyph = this.getGlyph(customFont, text, i);
          _measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;

          if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) {
            _measure += dx[i];
          }
        }

        return _measure;
      }

      if (!ctx.measureText) {
        return targetText.length * 10;
      }

      ctx.save();
      this.setContext(ctx, true);

      var _ctx$measureText = ctx.measureText(targetText),
          measure = _ctx$measureText.width;

      this.clearContext(ctx);
      ctx.restore();
      return measure;
    }
  }]);

  return TextElement;
}(RenderedElement);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var TSpanElement = /*#__PURE__*/function (_TextElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(TSpanElement, _TextElement);

  var _super = _createSuper$6(TSpanElement);

  function TSpanElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, TSpanElement);

    _this = _super.call(this, document, node, (this instanceof TSpanElement ? this.constructor : void 0) === TSpanElement ? true : captureTextNodes);
    _this.type = 'tspan'; // if this node has children, then they own the text

    _this.text = _this.children.length > 0 ? '' : _this.getTextFromNode();
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(TSpanElement, [{
    key: "getText",
    value: function getText() {
      return this.text;
    }
  }]);

  return TSpanElement;
}(TextElement);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextNode = /*#__PURE__*/function (_TSpanElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(TextNode, _TSpanElement);

  var _super = _createSuper$7(TextNode);

  function TextNode() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, TextNode);

    _this = _super.apply(this, arguments);
    _this.type = 'textNode';
    return _this;
  }

  return TextNode;
}(TSpanElement);

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var PathParser = /*#__PURE__*/function (_SVGPathData) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(PathParser, _SVGPathData);

  var _super = _createSuper$8(PathParser);

  function PathParser(path) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, PathParser);

    _this = _super.call(this, path // Fix spaces after signs.
    .replace(/[+-.]\s+/g, '-') // Remove invalid part.
    .replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ''));
    _this.control = null;
    _this.start = null;
    _this.current = null;
    _this.command = null;
    _this.commands = _this.commands;
    _this.i = -1;
    _this.previousCommand = null;
    _this.points = [];
    _this.angles = [];
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(PathParser, [{
    key: "reset",
    value: function reset() {
      this.i = -1;
      this.command = null;
      this.previousCommand = null;
      this.start = new Point(0, 0);
      this.control = new Point(0, 0);
      this.current = new Point(0, 0);
      this.points = [];
      this.angles = [];
    }
  }, {
    key: "isEnd",
    value: function isEnd() {
      var i = this.i,
          commands = this.commands;
      return i >= commands.length - 1;
    }
  }, {
    key: "next",
    value: function next() {
      var command = this.commands[++this.i];
      this.previousCommand = this.command;
      this.command = command;
      return command;
    }
  }, {
    key: "getPoint",
    value: function getPoint() {
      var xProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'x';
      var yProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'y';
      var point = new Point(this.command[xProp], this.command[yProp]);
      return this.makeAbsolute(point);
    }
  }, {
    key: "getAsControlPoint",
    value: function getAsControlPoint(xProp, yProp) {
      var point = this.getPoint(xProp, yProp);
      this.control = point;
      return point;
    }
  }, {
    key: "getAsCurrentPoint",
    value: function getAsCurrentPoint(xProp, yProp) {
      var point = this.getPoint(xProp, yProp);
      this.current = point;
      return point;
    }
  }, {
    key: "getReflectedControlPoint",
    value: function getReflectedControlPoint() {
      var previousCommand = this.previousCommand.type;

      if (previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_38__.SVGPathData.CURVE_TO && previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_38__.SVGPathData.SMOOTH_CURVE_TO && previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_38__.SVGPathData.QUAD_TO && previousCommand !== svg_pathdata__WEBPACK_IMPORTED_MODULE_38__.SVGPathData.SMOOTH_QUAD_TO) {
        return this.current;
      } // reflect point


      var _this$current = this.current,
          cx = _this$current.x,
          cy = _this$current.y,
          _this$control = this.control,
          ox = _this$control.x,
          oy = _this$control.y;
      var point = new Point(2 * cx - ox, 2 * cy - oy);
      return point;
    }
  }, {
    key: "makeAbsolute",
    value: function makeAbsolute(point) {
      if (this.command.relative) {
        var _this$current2 = this.current,
            x = _this$current2.x,
            y = _this$current2.y;
        point.x += x;
        point.y += y;
      }

      return point;
    }
  }, {
    key: "addMarker",
    value: function addMarker(point, from, priorTo) {
      var points = this.points,
          angles = this.angles; // if the last angle isn't filled in because we didn't have this point yet ...

      if (priorTo && angles.length > 0 && !angles[angles.length - 1]) {
        angles[angles.length - 1] = points[points.length - 1].angleTo(priorTo);
      }

      this.addMarkerAngle(point, from ? from.angleTo(point) : null);
    }
  }, {
    key: "addMarkerAngle",
    value: function addMarkerAngle(point, angle) {
      this.points.push(point);
      this.angles.push(angle);
    }
  }, {
    key: "getMarkerPoints",
    value: function getMarkerPoints() {
      return this.points;
    }
  }, {
    key: "getMarkerAngles",
    value: function getMarkerAngles() {
      var angles = this.angles;
      var len = angles.length;

      for (var i = 0; i < len; i++) {
        if (!angles[i]) {
          for (var j = i + 1; j < len; j++) {
            if (angles[j]) {
              angles[i] = angles[j];
              break;
            }
          }
        }
      }

      return angles;
    }
  }]);

  return PathParser;
}(svg_pathdata__WEBPACK_IMPORTED_MODULE_38__.SVGPathData);

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var PathElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(PathElement, _RenderedElement);

  var _super = _createSuper$9(PathElement);

  function PathElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, PathElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'path';
    _this.pathParser = null;
    _this.pathParser = new PathParser(_this.getAttribute('d').getString());
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(PathElement, [{
    key: "path",
    value: function path(ctx) {
      var pathParser = this.pathParser;
      var boundingBox = new BoundingBox();
      pathParser.reset();

      if (ctx) {
        ctx.beginPath();
      }

      while (!pathParser.isEnd()) {
        switch (pathParser.next().type) {
          case PathParser.MOVE_TO:
            this.pathM(ctx, boundingBox);
            break;

          case PathParser.LINE_TO:
            this.pathL(ctx, boundingBox);
            break;

          case PathParser.HORIZ_LINE_TO:
            this.pathH(ctx, boundingBox);
            break;

          case PathParser.VERT_LINE_TO:
            this.pathV(ctx, boundingBox);
            break;

          case PathParser.CURVE_TO:
            this.pathC(ctx, boundingBox);
            break;

          case PathParser.SMOOTH_CURVE_TO:
            this.pathS(ctx, boundingBox);
            break;

          case PathParser.QUAD_TO:
            this.pathQ(ctx, boundingBox);
            break;

          case PathParser.SMOOTH_QUAD_TO:
            this.pathT(ctx, boundingBox);
            break;

          case PathParser.ARC:
            this.pathA(ctx, boundingBox);
            break;

          case PathParser.CLOSE_PATH:
            this.pathZ(ctx, boundingBox);
            break;
        }
      }

      return boundingBox;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(_) {
      return this.path();
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      var pathParser = this.pathParser;
      var points = pathParser.getMarkerPoints();
      var angles = pathParser.getMarkerAngles();

      var markers = _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(points).call(points, function (point, i) {
        return [point, angles[i]];
      });

      return markers;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      this.path(ctx);
      this.document.screen.mouse.checkPath(this, ctx);
      var fillRuleStyleProp = this.getStyle('fill-rule');

      if (ctx.fillStyle !== '') {
        if (fillRuleStyleProp.getString('inherit') !== 'inherit') {
          _babel_runtime_corejs3_core_js_stable_instance_fill__WEBPACK_IMPORTED_MODULE_37___default()(ctx).call(ctx, fillRuleStyleProp.getString());
        } else {
          _babel_runtime_corejs3_core_js_stable_instance_fill__WEBPACK_IMPORTED_MODULE_37___default()(ctx).call(ctx);
        }
      }

      if (ctx.strokeStyle !== '') {
        ctx.stroke();
      }

      var markers = this.getMarkers();

      if (markers) {
        var markersLastIndex = markers.length - 1;
        var markerStartStyleProp = this.getStyle('marker-start');
        var markerMidStyleProp = this.getStyle('marker-mid');
        var markerEndStyleProp = this.getStyle('marker-end');

        if (markerStartStyleProp.isUrlDefinition()) {
          var marker = markerStartStyleProp.getDefinition();

          var _markers$ = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(markers[0], 2),
              point = _markers$[0],
              angle = _markers$[1];

          marker.render(ctx, point, angle);
        }

        if (markerMidStyleProp.isUrlDefinition()) {
          var _marker = markerMidStyleProp.getDefinition();

          for (var i = 1; i < markersLastIndex; i++) {
            var _markers$i = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(markers[i], 2),
                _point = _markers$i[0],
                _angle = _markers$i[1];

            _marker.render(ctx, _point, _angle);
          }
        }

        if (markerEndStyleProp.isUrlDefinition()) {
          var _marker2 = markerEndStyleProp.getDefinition();

          var _markers$markersLastI = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(markers[markersLastIndex], 2),
              _point2 = _markers$markersLastI[0],
              _angle2 = _markers$markersLastI[1];

          _marker2.render(ctx, _point2, _angle2);
        }
      }
    }
  }, {
    key: "pathM",
    value: function pathM(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathM = PathElement.pathM(pathParser),
          point = _PathElement$pathM.point;

      var x = point.x,
          y = point.y;
      pathParser.addMarker(point);
      boundingBox.addPoint(x, y);

      if (ctx) {
        ctx.moveTo(x, y);
      }
    }
  }, {
    key: "pathL",
    value: function pathL(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathL = PathElement.pathL(pathParser),
          current = _PathElement$pathL.current,
          point = _PathElement$pathL.point;

      var x = point.x,
          y = point.y;
      pathParser.addMarker(point, current);
      boundingBox.addPoint(x, y);

      if (ctx) {
        ctx.lineTo(x, y);
      }
    }
  }, {
    key: "pathH",
    value: function pathH(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathH = PathElement.pathH(pathParser),
          current = _PathElement$pathH.current,
          point = _PathElement$pathH.point;

      var x = point.x,
          y = point.y;
      pathParser.addMarker(point, current);
      boundingBox.addPoint(x, y);

      if (ctx) {
        ctx.lineTo(x, y);
      }
    }
  }, {
    key: "pathV",
    value: function pathV(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathV = PathElement.pathV(pathParser),
          current = _PathElement$pathV.current,
          point = _PathElement$pathV.point;

      var x = point.x,
          y = point.y;
      pathParser.addMarker(point, current);
      boundingBox.addPoint(x, y);

      if (ctx) {
        ctx.lineTo(x, y);
      }
    }
  }, {
    key: "pathC",
    value: function pathC(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathC = PathElement.pathC(pathParser),
          current = _PathElement$pathC.current,
          point = _PathElement$pathC.point,
          controlPoint = _PathElement$pathC.controlPoint,
          currentPoint = _PathElement$pathC.currentPoint;

      pathParser.addMarker(currentPoint, controlPoint, point);
      boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

      if (ctx) {
        ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
      }
    }
  }, {
    key: "pathS",
    value: function pathS(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathS = PathElement.pathS(pathParser),
          current = _PathElement$pathS.current,
          point = _PathElement$pathS.point,
          controlPoint = _PathElement$pathS.controlPoint,
          currentPoint = _PathElement$pathS.currentPoint;

      pathParser.addMarker(currentPoint, controlPoint, point);
      boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

      if (ctx) {
        ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
      }
    }
  }, {
    key: "pathQ",
    value: function pathQ(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathQ = PathElement.pathQ(pathParser),
          current = _PathElement$pathQ.current,
          controlPoint = _PathElement$pathQ.controlPoint,
          currentPoint = _PathElement$pathQ.currentPoint;

      pathParser.addMarker(currentPoint, controlPoint, controlPoint);
      boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

      if (ctx) {
        ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
      }
    }
  }, {
    key: "pathT",
    value: function pathT(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathT = PathElement.pathT(pathParser),
          current = _PathElement$pathT.current,
          controlPoint = _PathElement$pathT.controlPoint,
          currentPoint = _PathElement$pathT.currentPoint;

      pathParser.addMarker(currentPoint, controlPoint, controlPoint);
      boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

      if (ctx) {
        ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
      }
    }
  }, {
    key: "pathA",
    value: function pathA(ctx, boundingBox) {
      var pathParser = this.pathParser;

      var _PathElement$pathA = PathElement.pathA(pathParser),
          currentPoint = _PathElement$pathA.currentPoint,
          rX = _PathElement$pathA.rX,
          rY = _PathElement$pathA.rY,
          sweepFlag = _PathElement$pathA.sweepFlag,
          xAxisRotation = _PathElement$pathA.xAxisRotation,
          centp = _PathElement$pathA.centp,
          a1 = _PathElement$pathA.a1,
          ad = _PathElement$pathA.ad; // for markers


      var dir = 1 - sweepFlag ? 1.0 : -1.0;
      var ah = a1 + dir * (ad / 2.0);
      var halfWay = new Point(centp.x + rX * Math.cos(ah), centp.y + rY * Math.sin(ah));
      pathParser.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
      pathParser.addMarkerAngle(currentPoint, ah - dir * Math.PI);
      boundingBox.addPoint(currentPoint.x, currentPoint.y); // TODO: this is too naive, make it better

      if (ctx && !isNaN(a1) && !isNaN(ad)) {
        var r = rX > rY ? rX : rY;
        var sx = rX > rY ? 1 : rX / rY;
        var sy = rX > rY ? rY / rX : 1;
        ctx.translate(centp.x, centp.y);
        ctx.rotate(xAxisRotation);
        ctx.scale(sx, sy);
        ctx.arc(0, 0, r, a1, a1 + ad, Boolean(1 - sweepFlag));
        ctx.scale(1 / sx, 1 / sy);
        ctx.rotate(-xAxisRotation);
        ctx.translate(-centp.x, -centp.y);
      }
    }
  }, {
    key: "pathZ",
    value: function pathZ(ctx, boundingBox) {
      PathElement.pathZ(this.pathParser);

      if (ctx) {
        // only close path if it is not a straight line
        if (boundingBox.x1 !== boundingBox.x2 && boundingBox.y1 !== boundingBox.y2) {
          ctx.closePath();
        }
      }
    }
  }], [{
    key: "pathM",
    value: function pathM(pathParser) {
      var point = pathParser.getAsCurrentPoint();
      pathParser.start = pathParser.current;
      return {
        point: point
      };
    }
  }, {
    key: "pathL",
    value: function pathL(pathParser) {
      var current = pathParser.current;
      var point = pathParser.getAsCurrentPoint();
      return {
        current: current,
        point: point
      };
    }
  }, {
    key: "pathH",
    value: function pathH(pathParser) {
      var current = pathParser.current,
          command = pathParser.command;
      var point = new Point((command.relative ? current.x : 0) + command.x, current.y);
      pathParser.current = point;
      return {
        current: current,
        point: point
      };
    }
  }, {
    key: "pathV",
    value: function pathV(pathParser) {
      var current = pathParser.current,
          command = pathParser.command;
      var point = new Point(current.x, (command.relative ? current.y : 0) + command.y);
      pathParser.current = point;
      return {
        current: current,
        point: point
      };
    }
  }, {
    key: "pathC",
    value: function pathC(pathParser) {
      var current = pathParser.current;
      var point = pathParser.getPoint('x1', 'y1');
      var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
      var currentPoint = pathParser.getAsCurrentPoint();
      return {
        current: current,
        point: point,
        controlPoint: controlPoint,
        currentPoint: currentPoint
      };
    }
  }, {
    key: "pathS",
    value: function pathS(pathParser) {
      var current = pathParser.current;
      var point = pathParser.getReflectedControlPoint();
      var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
      var currentPoint = pathParser.getAsCurrentPoint();
      return {
        current: current,
        point: point,
        controlPoint: controlPoint,
        currentPoint: currentPoint
      };
    }
  }, {
    key: "pathQ",
    value: function pathQ(pathParser) {
      var current = pathParser.current;
      var controlPoint = pathParser.getAsControlPoint('x1', 'y1');
      var currentPoint = pathParser.getAsCurrentPoint();
      return {
        current: current,
        controlPoint: controlPoint,
        currentPoint: currentPoint
      };
    }
  }, {
    key: "pathT",
    value: function pathT(pathParser) {
      var current = pathParser.current;
      var controlPoint = pathParser.getReflectedControlPoint();
      pathParser.control = controlPoint;
      var currentPoint = pathParser.getAsCurrentPoint();
      return {
        current: current,
        controlPoint: controlPoint,
        currentPoint: currentPoint
      };
    }
  }, {
    key: "pathA",
    value: function pathA(pathParser) {
      var current = pathParser.current,
          command = pathParser.command;
      var rX = command.rX,
          rY = command.rY,
          xRot = command.xRot,
          lArcFlag = command.lArcFlag,
          sweepFlag = command.sweepFlag;
      var xAxisRotation = xRot * (Math.PI / 180.0);
      var currentPoint = pathParser.getAsCurrentPoint(); // Conversion from endpoint to center parameterization
      // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
      // x1', y1'

      var currp = new Point(Math.cos(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.sin(xAxisRotation) * (current.y - currentPoint.y) / 2.0, -Math.sin(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * (current.y - currentPoint.y) / 2.0); // adjust radii

      var l = Math.pow(currp.x, 2) / Math.pow(rX, 2) + Math.pow(currp.y, 2) / Math.pow(rY, 2);

      if (l > 1) {
        rX *= Math.sqrt(l);
        rY *= Math.sqrt(l);
      } // cx', cy'


      var s = (lArcFlag === sweepFlag ? -1 : 1) * Math.sqrt((Math.pow(rX, 2) * Math.pow(rY, 2) - Math.pow(rX, 2) * Math.pow(currp.y, 2) - Math.pow(rY, 2) * Math.pow(currp.x, 2)) / (Math.pow(rX, 2) * Math.pow(currp.y, 2) + Math.pow(rY, 2) * Math.pow(currp.x, 2)));

      if (isNaN(s)) {
        s = 0;
      }

      var cpp = new Point(s * rX * currp.y / rY, s * -rY * currp.x / rX); // cx, cy

      var centp = new Point((current.x + currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y, (current.y + currentPoint.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y); // initial angle

      var a1 = vectorsAngle([1, 0], [(currp.x - cpp.x) / rX, (currp.y - cpp.y) / rY]); // θ1
      // angle delta

      var u = [(currp.x - cpp.x) / rX, (currp.y - cpp.y) / rY];
      var v = [(-currp.x - cpp.x) / rX, (-currp.y - cpp.y) / rY];
      var ad = vectorsAngle(u, v); // Δθ

      if (vectorsRatio(u, v) <= -1) {
        ad = Math.PI;
      }

      if (vectorsRatio(u, v) >= 1) {
        ad = 0;
      }

      return {
        currentPoint: currentPoint,
        rX: rX,
        rY: rY,
        sweepFlag: sweepFlag,
        xAxisRotation: xAxisRotation,
        centp: centp,
        a1: a1,
        ad: ad
      };
    }
  }, {
    key: "pathZ",
    value: function pathZ(pathParser) {
      pathParser.current = pathParser.start;
    }
  }]);

  return PathElement;
}(RenderedElement);

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var SVGElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(SVGElement, _RenderedElement);

  var _super = _createSuper$a(SVGElement);

  function SVGElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, SVGElement);

    _this = _super.apply(this, arguments);
    _this.type = 'svg';
    _this.root = false;
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(SVGElement, [{
    key: "setContext",
    value: function setContext(ctx) {
      var document = this.document;
      var screen = document.screen,
          window = document.window;
      var canvas = ctx.canvas;
      screen.setDefaults(ctx);

      if (canvas.style && typeof ctx.font !== 'undefined' && window && typeof window.getComputedStyle !== 'undefined') {
        ctx.font = window.getComputedStyle(canvas).getPropertyValue('font');
        var fontSizeProp = new Property(document, 'fontSize', Font.parse(ctx.font).fontSize);

        if (fontSizeProp.hasValue()) {
          document.rootEmSize = fontSizeProp.getPixels('y');
          document.emSize = document.rootEmSize;
        }
      } // create new view port


      if (!this.getAttribute('x').hasValue()) {
        this.getAttribute('x', true).setValue(0);
      }

      if (!this.getAttribute('y').hasValue()) {
        this.getAttribute('y', true).setValue(0);
      }

      var _screen$viewPort = screen.viewPort,
          width = _screen$viewPort.width,
          height = _screen$viewPort.height;

      if (!this.getStyle('width').hasValue()) {
        this.getStyle('width', true).setValue('100%');
      }

      if (!this.getStyle('height').hasValue()) {
        this.getStyle('height', true).setValue('100%');
      }

      if (!this.getStyle('color').hasValue()) {
        this.getStyle('color', true).setValue('black');
      }

      var refXAttr = this.getAttribute('refX');
      var refYAttr = this.getAttribute('refY');
      var viewBoxAttr = this.getAttribute('viewBox');
      var viewBox = viewBoxAttr.hasValue() ? toNumbers(viewBoxAttr.getString()) : null;
      var clip = !this.root && this.getStyle('overflow').getValue('hidden') !== 'visible';
      var minX = 0;
      var minY = 0;
      var clipX = 0;
      var clipY = 0;

      if (viewBox) {
        minX = viewBox[0];
        minY = viewBox[1];
      }

      if (!this.root) {
        width = this.getStyle('width').getPixels('x');
        height = this.getStyle('height').getPixels('y');

        if (this.type === 'marker') {
          clipX = minX;
          clipY = minY;
          minX = 0;
          minY = 0;
        }
      }

      screen.viewPort.setCurrent(width, height);

      if (this.node // is not temporary SVGElement
      && this.getStyle('transform', false, true).hasValue() && !this.getStyle('transform-origin', false, true).hasValue()) {
        this.getStyle('transform-origin', true, true).setValue('50% 50%');
      }

      (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(SVGElement.prototype), "setContext", this).call(this, ctx);

      ctx.translate(this.getAttribute('x').getPixels('x'), this.getAttribute('y').getPixels('y'));

      if (viewBox) {
        width = viewBox[2];
        height = viewBox[3];
      }

      document.setViewBox({
        ctx: ctx,
        aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
        width: screen.viewPort.width,
        desiredWidth: width,
        height: screen.viewPort.height,
        desiredHeight: height,
        minX: minX,
        minY: minY,
        refX: refXAttr.getValue(),
        refY: refYAttr.getValue(),
        clip: clip,
        clipX: clipX,
        clipY: clipY
      });

      if (viewBox) {
        screen.viewPort.removeCurrent();
        screen.viewPort.setCurrent(width, height);
      }
    }
  }, {
    key: "clearContext",
    value: function clearContext(ctx) {
      (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(SVGElement.prototype), "clearContext", this).call(this, ctx);

      this.document.screen.viewPort.removeCurrent();
    }
    /**
     * Resize SVG to fit in given size.
     * @param width
     * @param height
     * @param preserveAspectRatio
     */

  }, {
    key: "resize",
    value: function resize(width) {
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
      var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var widthAttr = this.getAttribute('width', true);
      var heightAttr = this.getAttribute('height', true);
      var viewBoxAttr = this.getAttribute('viewBox');
      var styleAttr = this.getAttribute('style');
      var originWidth = widthAttr.getNumber(0);
      var originHeight = heightAttr.getNumber(0);

      if (preserveAspectRatio) {
        if (typeof preserveAspectRatio === 'string') {
          this.getAttribute('preserveAspectRatio', true).setValue(preserveAspectRatio);
        } else {
          var preserveAspectRatioAttr = this.getAttribute('preserveAspectRatio');

          if (preserveAspectRatioAttr.hasValue()) {
            preserveAspectRatioAttr.setValue(preserveAspectRatioAttr.getString().replace(/^\s*(\S.*\S)\s*$/, '$1'));
          }
        }
      }

      widthAttr.setValue(width);
      heightAttr.setValue(height);

      if (!viewBoxAttr.hasValue()) {
        var _context;

        viewBoxAttr.setValue(_babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context = "0 0 ".concat(originWidth || width, " ")).call(_context, originHeight || height));
      }

      if (styleAttr.hasValue()) {
        var widthStyle = this.getStyle('width');
        var heightStyle = this.getStyle('height');

        if (widthStyle.hasValue()) {
          widthStyle.setValue("".concat(width, "px"));
        }

        if (heightStyle.hasValue()) {
          heightStyle.setValue("".concat(height, "px"));
        }
      }
    }
  }]);

  return SVGElement;
}(RenderedElement);

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var RectElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(RectElement, _PathElement);

  var _super = _createSuper$b(RectElement);

  function RectElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, RectElement);

    _this = _super.apply(this, arguments);
    _this.type = 'rect';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(RectElement, [{
    key: "path",
    value: function path(ctx) {
      var x = this.getAttribute('x').getPixels('x');
      var y = this.getAttribute('y').getPixels('y');
      var width = this.getStyle('width', false, true).getPixels('x');
      var height = this.getStyle('height', false, true).getPixels('y');
      var rxAttr = this.getAttribute('rx');
      var ryAttr = this.getAttribute('ry');
      var rx = rxAttr.getPixels('x');
      var ry = ryAttr.getPixels('y');

      if (rxAttr.hasValue() && !ryAttr.hasValue()) {
        ry = rx;
      }

      if (ryAttr.hasValue() && !rxAttr.hasValue()) {
        rx = ry;
      }

      rx = Math.min(rx, width / 2.0);
      ry = Math.min(ry, height / 2.0);

      if (ctx) {
        var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
        ctx.beginPath(); // always start the path so we don't fill prior paths

        if (height > 0 && width > 0) {
          ctx.moveTo(x + rx, y);
          ctx.lineTo(x + width - rx, y);
          ctx.bezierCurveTo(x + width - rx + KAPPA * rx, y, x + width, y + ry - KAPPA * ry, x + width, y + ry);
          ctx.lineTo(x + width, y + height - ry);
          ctx.bezierCurveTo(x + width, y + height - ry + KAPPA * ry, x + width - rx + KAPPA * rx, y + height, x + width - rx, y + height);
          ctx.lineTo(x + rx, y + height);
          ctx.bezierCurveTo(x + rx - KAPPA * rx, y + height, x, y + height - ry + KAPPA * ry, x, y + height - ry);
          ctx.lineTo(x, y + ry);
          ctx.bezierCurveTo(x, y + ry - KAPPA * ry, x + rx - KAPPA * rx, y, x + rx, y);
          ctx.closePath();
        }
      }

      return new BoundingBox(x, y, x + width, y + height);
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      return null;
    }
  }]);

  return RectElement;
}(PathElement);

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var CircleElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(CircleElement, _PathElement);

  var _super = _createSuper$c(CircleElement);

  function CircleElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, CircleElement);

    _this = _super.apply(this, arguments);
    _this.type = 'circle';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(CircleElement, [{
    key: "path",
    value: function path(ctx) {
      var cx = this.getAttribute('cx').getPixels('x');
      var cy = this.getAttribute('cy').getPixels('y');
      var r = this.getAttribute('r').getPixels();

      if (ctx && r > 0) {
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2, false);
        ctx.closePath();
      }

      return new BoundingBox(cx - r, cy - r, cx + r, cy + r);
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      return null;
    }
  }]);

  return CircleElement;
}(PathElement);

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var EllipseElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(EllipseElement, _PathElement);

  var _super = _createSuper$d(EllipseElement);

  function EllipseElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, EllipseElement);

    _this = _super.apply(this, arguments);
    _this.type = 'ellipse';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(EllipseElement, [{
    key: "path",
    value: function path(ctx) {
      var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
      var rx = this.getAttribute('rx').getPixels('x');
      var ry = this.getAttribute('ry').getPixels('y');
      var cx = this.getAttribute('cx').getPixels('x');
      var cy = this.getAttribute('cy').getPixels('y');

      if (ctx && rx > 0 && ry > 0) {
        ctx.beginPath();
        ctx.moveTo(cx + rx, cy);
        ctx.bezierCurveTo(cx + rx, cy + KAPPA * ry, cx + KAPPA * rx, cy + ry, cx, cy + ry);
        ctx.bezierCurveTo(cx - KAPPA * rx, cy + ry, cx - rx, cy + KAPPA * ry, cx - rx, cy);
        ctx.bezierCurveTo(cx - rx, cy - KAPPA * ry, cx - KAPPA * rx, cy - ry, cx, cy - ry);
        ctx.bezierCurveTo(cx + KAPPA * rx, cy - ry, cx + rx, cy - KAPPA * ry, cx + rx, cy);
        ctx.closePath();
      }

      return new BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      return null;
    }
  }]);

  return EllipseElement;
}(PathElement);

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var LineElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(LineElement, _PathElement);

  var _super = _createSuper$e(LineElement);

  function LineElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, LineElement);

    _this = _super.apply(this, arguments);
    _this.type = 'line';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(LineElement, [{
    key: "getPoints",
    value: function getPoints() {
      return [new Point(this.getAttribute('x1').getPixels('x'), this.getAttribute('y1').getPixels('y')), new Point(this.getAttribute('x2').getPixels('x'), this.getAttribute('y2').getPixels('y'))];
    }
  }, {
    key: "path",
    value: function path(ctx) {
      var _this$getPoints = this.getPoints(),
          _this$getPoints2 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_this$getPoints, 2),
          _this$getPoints2$ = _this$getPoints2[0],
          x0 = _this$getPoints2$.x,
          y0 = _this$getPoints2$.y,
          _this$getPoints2$2 = _this$getPoints2[1],
          x1 = _this$getPoints2$2.x,
          y1 = _this$getPoints2$2.y;

      if (ctx) {
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y1);
      }

      return new BoundingBox(x0, y0, x1, y1);
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      var _this$getPoints3 = this.getPoints(),
          _this$getPoints4 = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(_this$getPoints3, 2),
          p0 = _this$getPoints4[0],
          p1 = _this$getPoints4[1];

      var a = p0.angleTo(p1);
      return [[p0, a], [p1, a]];
    }
  }]);

  return LineElement;
}(PathElement);

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var PolylineElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(PolylineElement, _PathElement);

  var _super = _createSuper$f(PolylineElement);

  function PolylineElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, PolylineElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'polyline';
    _this.points = [];
    _this.points = Point.parsePath(_this.getAttribute('points').getString());
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(PolylineElement, [{
    key: "path",
    value: function path(ctx) {
      var points = this.points;

      var _points = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(points, 1),
          _points$ = _points[0],
          x0 = _points$.x,
          y0 = _points$.y;

      var boundingBox = new BoundingBox(x0, y0);

      if (ctx) {
        ctx.beginPath();
        ctx.moveTo(x0, y0);
      }

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(points).call(points, function (_ref) {
        var x = _ref.x,
            y = _ref.y;
        boundingBox.addPoint(x, y);

        if (ctx) {
          ctx.lineTo(x, y);
        }
      });

      return boundingBox;
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      var points = this.points;
      var lastIndex = points.length - 1;
      var markers = [];

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(points).call(points, function (point, i) {
        if (i === lastIndex) {
          return;
        }

        markers.push([point, point.angleTo(points[i + 1])]);
      });

      if (markers.length > 0) {
        markers.push([points[points.length - 1], markers[markers.length - 1][1]]);
      }

      return markers;
    }
  }]);

  return PolylineElement;
}(PathElement);

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var PolygonElement = /*#__PURE__*/function (_PolylineElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(PolygonElement, _PolylineElement);

  var _super = _createSuper$g(PolygonElement);

  function PolygonElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, PolygonElement);

    _this = _super.apply(this, arguments);
    _this.type = 'polygon';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(PolygonElement, [{
    key: "path",
    value: function path(ctx) {
      var boundingBox = (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(PolygonElement.prototype), "path", this).call(this, ctx);

      var _this$points = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(this.points, 1),
          _this$points$ = _this$points[0],
          x = _this$points$.x,
          y = _this$points$.y;

      if (ctx) {
        ctx.lineTo(x, y);
        ctx.closePath();
      }

      return boundingBox;
    }
  }]);

  return PolygonElement;
}(PolylineElement);

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var PatternElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(PatternElement, _Element);

  var _super = _createSuper$h(PatternElement);

  function PatternElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, PatternElement);

    _this = _super.apply(this, arguments);
    _this.type = 'pattern';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(PatternElement, [{
    key: "createPattern",
    value: function createPattern(ctx, _, parentOpacityProp) {
      var width = this.getStyle('width').getPixels('x', true);
      var height = this.getStyle('height').getPixels('y', true); // render me using a temporary svg element

      var patternSvg = new SVGElement(this.document, null);
      patternSvg.attributes.viewBox = new Property(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
      patternSvg.attributes.width = new Property(this.document, 'width', "".concat(width, "px"));
      patternSvg.attributes.height = new Property(this.document, 'height', "".concat(height, "px"));
      patternSvg.attributes.transform = new Property(this.document, 'transform', this.getAttribute('patternTransform').getValue());
      patternSvg.children = this.children;
      var patternCanvas = this.document.createCanvas(width, height);
      var patternCtx = patternCanvas.getContext('2d');
      var xAttr = this.getAttribute('x');
      var yAttr = this.getAttribute('y');

      if (xAttr.hasValue() && yAttr.hasValue()) {
        patternCtx.translate(xAttr.getPixels('x', true), yAttr.getPixels('y', true));
      }

      if (parentOpacityProp.hasValue()) {
        this.styles['fill-opacity'] = parentOpacityProp;
      } else {
        _babel_runtime_corejs3_core_js_stable_reflect_delete_property__WEBPACK_IMPORTED_MODULE_39___default()(this.styles, 'fill-opacity');
      } // render 3x3 grid so when we transform there's no white space on edges


      for (var x = -1; x <= 1; x++) {
        for (var y = -1; y <= 1; y++) {
          patternCtx.save();
          patternSvg.attributes.x = new Property(this.document, 'x', x * patternCanvas.width);
          patternSvg.attributes.y = new Property(this.document, 'y', y * patternCanvas.height);
          patternSvg.render(patternCtx);
          patternCtx.restore();
        }
      }

      var pattern = ctx.createPattern(patternCanvas, 'repeat');
      return pattern;
    }
  }]);

  return PatternElement;
}(Element);

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var MarkerElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(MarkerElement, _Element);

  var _super = _createSuper$i(MarkerElement);

  function MarkerElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, MarkerElement);

    _this = _super.apply(this, arguments);
    _this.type = 'marker';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(MarkerElement, [{
    key: "render",
    value: function render(ctx, point, angle) {
      if (!point) {
        return;
      }

      var x = point.x,
          y = point.y;
      var orient = this.getAttribute('orient').getValue('auto');
      var markerUnits = this.getAttribute('markerUnits').getValue('strokeWidth');
      ctx.translate(x, y);

      if (orient === 'auto') {
        ctx.rotate(angle);
      }

      if (markerUnits === 'strokeWidth') {
        ctx.scale(ctx.lineWidth, ctx.lineWidth);
      }

      ctx.save(); // render me using a temporary svg element

      var markerSvg = new SVGElement(this.document, null);
      markerSvg.type = this.type;
      markerSvg.attributes.viewBox = new Property(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
      markerSvg.attributes.refX = new Property(this.document, 'refX', this.getAttribute('refX').getValue());
      markerSvg.attributes.refY = new Property(this.document, 'refY', this.getAttribute('refY').getValue());
      markerSvg.attributes.width = new Property(this.document, 'width', this.getAttribute('markerWidth').getValue());
      markerSvg.attributes.height = new Property(this.document, 'height', this.getAttribute('markerHeight').getValue());
      markerSvg.attributes.overflow = new Property(this.document, 'overflow', this.getAttribute('overflow').getValue());
      markerSvg.attributes.fill = new Property(this.document, 'fill', this.getAttribute('fill').getColor('black'));
      markerSvg.attributes.stroke = new Property(this.document, 'stroke', this.getAttribute('stroke').getValue('none'));
      markerSvg.children = this.children;
      markerSvg.render(ctx);
      ctx.restore();

      if (markerUnits === 'strokeWidth') {
        ctx.scale(1 / ctx.lineWidth, 1 / ctx.lineWidth);
      }

      if (orient === 'auto') {
        ctx.rotate(-angle);
      }

      ctx.translate(-x, -y);
    }
  }]);

  return MarkerElement;
}(Element);

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var DefsElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(DefsElement, _Element);

  var _super = _createSuper$j(DefsElement);

  function DefsElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, DefsElement);

    _this = _super.apply(this, arguments);
    _this.type = 'defs';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(DefsElement, [{
    key: "render",
    value: function render() {// NOOP
    }
  }]);

  return DefsElement;
}(Element);

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var GElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(GElement, _RenderedElement);

  var _super = _createSuper$k(GElement);

  function GElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, GElement);

    _this = _super.apply(this, arguments);
    _this.type = 'g';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(GElement, [{
    key: "getBoundingBox",
    value: function getBoundingBox(ctx) {
      var _context;

      var boundingBox = new BoundingBox();

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = this.children).call(_context, function (child) {
        boundingBox.addBoundingBox(child.getBoundingBox(ctx));
      });

      return boundingBox;
    }
  }]);

  return GElement;
}(RenderedElement);

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var GradientElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(GradientElement, _Element);

  var _super = _createSuper$l(GradientElement);

  function GradientElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, GradientElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.attributesToInherit = ['gradientUnits'];
    _this.stops = [];

    var _assertThisInitialize = (0,_babel_runtime_corejs3_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_40__.default)(_this),
        stops = _assertThisInitialize.stops,
        children = _assertThisInitialize.children;

    _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(children).call(children, function (child) {
      if (child.type === 'stop') {
        stops.push(child);
      }
    });

    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(GradientElement, [{
    key: "getGradientUnits",
    value: function getGradientUnits() {
      return this.getAttribute('gradientUnits').getString('objectBoundingBox');
    }
  }, {
    key: "createGradient",
    value: function createGradient(ctx, element, parentOpacityProp) {
      var _this2 = this;

      // tslint:disable-next-line: no-this-assignment
      var stopsContainer = this;

      if (this.getHrefAttribute().hasValue()) {
        stopsContainer = this.getHrefAttribute().getDefinition();
        this.inheritStopContainer(stopsContainer);
      }

      var _stopsContainer = stopsContainer,
          stops = _stopsContainer.stops;
      var gradient = this.getGradient(ctx, element);

      if (!gradient) {
        return this.addParentOpacity(parentOpacityProp, stops[stops.length - 1].color);
      }

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(stops).call(stops, function (stop) {
        gradient.addColorStop(stop.offset, _this2.addParentOpacity(parentOpacityProp, stop.color));
      });

      if (this.getAttribute('gradientTransform').hasValue()) {
        // render as transformed pattern on temporary canvas
        var document = this.document;
        var _document$screen = document.screen,
            MAX_VIRTUAL_PIXELS = _document$screen.MAX_VIRTUAL_PIXELS,
            viewPort = _document$screen.viewPort;

        var _viewPort$viewPorts = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(viewPort.viewPorts, 1),
            rootView = _viewPort$viewPorts[0];

        var rect = new RectElement(document, null);
        rect.attributes.x = new Property(document, 'x', -MAX_VIRTUAL_PIXELS / 3.0);
        rect.attributes.y = new Property(document, 'y', -MAX_VIRTUAL_PIXELS / 3.0);
        rect.attributes.width = new Property(document, 'width', MAX_VIRTUAL_PIXELS);
        rect.attributes.height = new Property(document, 'height', MAX_VIRTUAL_PIXELS);
        var group = new GElement(document, null);
        group.attributes.transform = new Property(document, 'transform', this.getAttribute('gradientTransform').getValue());
        group.children = [rect];
        var patternSvg = new SVGElement(document, null);
        patternSvg.attributes.x = new Property(document, 'x', 0);
        patternSvg.attributes.y = new Property(document, 'y', 0);
        patternSvg.attributes.width = new Property(document, 'width', rootView.width);
        patternSvg.attributes.height = new Property(document, 'height', rootView.height);
        patternSvg.children = [group];
        var patternCanvas = document.createCanvas(rootView.width, rootView.height);
        var patternCtx = patternCanvas.getContext('2d');
        patternCtx.fillStyle = gradient;
        patternSvg.render(patternCtx);
        return patternCtx.createPattern(patternCanvas, 'no-repeat');
      }

      return gradient;
    }
  }, {
    key: "inheritStopContainer",
    value: function inheritStopContainer(stopsContainer) {
      var _context,
          _this3 = this;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = this.attributesToInherit).call(_context, function (attributeToInherit) {
        if (!_this3.getAttribute(attributeToInherit).hasValue() && stopsContainer.getAttribute(attributeToInherit).hasValue()) {
          _this3.getAttribute(attributeToInherit, true).setValue(stopsContainer.getAttribute(attributeToInherit).getValue());
        }
      });
    }
  }, {
    key: "addParentOpacity",
    value: function addParentOpacity(parentOpacityProp, color) {
      if (parentOpacityProp.hasValue()) {
        var colorProp = new Property(this.document, 'color', color);
        return colorProp.addOpacity(parentOpacityProp).getColor();
      }

      return color;
    }
  }]);

  return GradientElement;
}(Element);

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var LinearGradientElement = /*#__PURE__*/function (_GradientElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(LinearGradientElement, _GradientElement);

  var _super = _createSuper$m(LinearGradientElement);

  function LinearGradientElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, LinearGradientElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'linearGradient';

    _this.attributesToInherit.push('x1', 'y1', 'x2', 'y2');

    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(LinearGradientElement, [{
    key: "getGradient",
    value: function getGradient(ctx, element) {
      var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
      var boundingBox = isBoundingBoxUnits ? element.getBoundingBox(ctx) : null;

      if (isBoundingBoxUnits && !boundingBox) {
        return null;
      }

      if (!this.getAttribute('x1').hasValue() && !this.getAttribute('y1').hasValue() && !this.getAttribute('x2').hasValue() && !this.getAttribute('y2').hasValue()) {
        this.getAttribute('x1', true).setValue(0);
        this.getAttribute('y1', true).setValue(0);
        this.getAttribute('x2', true).setValue(1);
        this.getAttribute('y2', true).setValue(0);
      }

      var x1 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x1').getNumber() : this.getAttribute('x1').getPixels('x');
      var y1 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y1').getNumber() : this.getAttribute('y1').getPixels('y');
      var x2 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x2').getNumber() : this.getAttribute('x2').getPixels('x');
      var y2 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y2').getNumber() : this.getAttribute('y2').getPixels('y');

      if (x1 === x2 && y1 === y2) {
        return null;
      }

      return ctx.createLinearGradient(x1, y1, x2, y2);
    }
  }]);

  return LinearGradientElement;
}(GradientElement);

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var RadialGradientElement = /*#__PURE__*/function (_GradientElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(RadialGradientElement, _GradientElement);

  var _super = _createSuper$n(RadialGradientElement);

  function RadialGradientElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, RadialGradientElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'radialGradient';

    _this.attributesToInherit.push('cx', 'cy', 'r', 'fx', 'fy', 'fr');

    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(RadialGradientElement, [{
    key: "getGradient",
    value: function getGradient(ctx, element) {
      var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
      var boundingBox = element.getBoundingBox(ctx);

      if (isBoundingBoxUnits && !boundingBox) {
        return null;
      }

      if (!this.getAttribute('cx').hasValue()) {
        this.getAttribute('cx', true).setValue('50%');
      }

      if (!this.getAttribute('cy').hasValue()) {
        this.getAttribute('cy', true).setValue('50%');
      }

      if (!this.getAttribute('r').hasValue()) {
        this.getAttribute('r', true).setValue('50%');
      }

      var cx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('cx').getNumber() : this.getAttribute('cx').getPixels('x');
      var cy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('cy').getNumber() : this.getAttribute('cy').getPixels('y');
      var fx = cx;
      var fy = cy;

      if (this.getAttribute('fx').hasValue()) {
        fx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('fx').getNumber() : this.getAttribute('fx').getPixels('x');
      }

      if (this.getAttribute('fy').hasValue()) {
        fy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('fy').getNumber() : this.getAttribute('fy').getPixels('y');
      }

      var r = isBoundingBoxUnits ? (boundingBox.width + boundingBox.height) / 2.0 * this.getAttribute('r').getNumber() : this.getAttribute('r').getPixels();
      var fr = this.getAttribute('fr').getPixels();
      return ctx.createRadialGradient(fx, fy, fr, cx, cy, r);
    }
  }]);

  return RadialGradientElement;
}(GradientElement);

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var StopElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(StopElement, _Element);

  var _super = _createSuper$o(StopElement);

  function StopElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, StopElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'stop';
    var offset = Math.max(0, Math.min(1, _this.getAttribute('offset').getNumber()));

    var stopOpacity = _this.getStyle('stop-opacity');

    var stopColor = _this.getStyle('stop-color', true);

    if (stopColor.getString() === '') {
      stopColor.setValue('#000');
    }

    if (stopOpacity.hasValue()) {
      stopColor = stopColor.addOpacity(stopOpacity);
    }

    _this.offset = offset;
    _this.color = stopColor.getColor();
    return _this;
  }

  return StopElement;
}(Element);

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var AnimateElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(AnimateElement, _Element);

  var _super = _createSuper$p(AnimateElement);

  function AnimateElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, AnimateElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'animate';
    _this.duration = 0;
    _this.initialValue = null;
    _this.initialUnits = '';
    _this.removed = false;
    _this.frozen = false;
    document.screen.animations.push((0,_babel_runtime_corejs3_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_40__.default)(_this));
    _this.begin = _this.getAttribute('begin').getMilliseconds();
    _this.maxDuration = _this.begin + _this.getAttribute('dur').getMilliseconds();
    _this.from = _this.getAttribute('from');
    _this.to = _this.getAttribute('to');
    _this.values = _this.getAttribute('values');

    if (_babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41___default()(_this).hasValue()) {
      _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41___default()(_this).setValue(_babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41___default()(_this).getString().split(';'));
    }

    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(AnimateElement, [{
    key: "getProperty",
    value: function getProperty() {
      var attributeType = this.getAttribute('attributeType').getString();
      var attributeName = this.getAttribute('attributeName').getString();

      if (attributeType === 'CSS') {
        return this.parent.getStyle(attributeName, true);
      }

      return this.parent.getAttribute(attributeName, true);
    }
  }, {
    key: "calcValue",
    value: function calcValue() {
      var _context;

      var initialUnits = this.initialUnits;

      var _this$getProgress = this.getProgress(),
          progress = _this$getProgress.progress,
          from = _this$getProgress.from,
          to = _this$getProgress.to; // tween value linearly


      var newValue = from.getNumber() + (to.getNumber() - from.getNumber()) * progress;

      if (initialUnits === '%') {
        newValue *= 100.0; // numValue() returns 0-1 whereas properties are 0-100
      }

      return _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context = "".concat(newValue)).call(_context, initialUnits);
    }
  }, {
    key: "update",
    value: function update(delta) {
      var parent = this.parent;
      var prop = this.getProperty(); // set initial value

      if (!this.initialValue) {
        this.initialValue = prop.getString();
        this.initialUnits = prop.getUnits();
      } // if we're past the end time


      if (this.duration > this.maxDuration) {
        var fill = this.getAttribute('fill').getString('remove'); // loop for indefinitely repeating animations

        if (this.getAttribute('repeatCount').getString() === 'indefinite' || this.getAttribute('repeatDur').getString() === 'indefinite') {
          this.duration = 0;
        } else if (fill === 'freeze' && !this.frozen) {
          this.frozen = true;
          parent.animationFrozen = true;
          parent.animationFrozenValue = prop.getString();
        } else if (fill === 'remove' && !this.removed) {
          this.removed = true;
          prop.setValue(parent.animationFrozen ? parent.animationFrozenValue : this.initialValue);
          return true;
        }

        return false;
      }

      this.duration += delta; // if we're past the begin time

      var updated = false;

      if (this.begin < this.duration) {
        var newValue = this.calcValue(); // tween

        var typeAttr = this.getAttribute('type');

        if (typeAttr.hasValue()) {
          var _context2;

          // for transform, etc.
          var type = typeAttr.getString();
          newValue = _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context2 = "".concat(type, "(")).call(_context2, newValue, ")");
        }

        prop.setValue(newValue);
        updated = true;
      }

      return updated;
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      var document = this.document,
          values = _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_41___default()(this);

      var result = {
        progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
      };

      if (values.hasValue()) {
        var p = result.progress * (values.getValue().length - 1);
        var lb = Math.floor(p);
        var ub = Math.ceil(p);
        result.from = new Property(document, 'from', _babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default()(values.getValue()[lb]));
        result.to = new Property(document, 'to', _babel_runtime_corejs3_core_js_stable_parse_float__WEBPACK_IMPORTED_MODULE_1___default()(values.getValue()[ub]));
        result.progress = (p - lb) / (ub - lb);
      } else {
        result.from = this.from;
        result.to = this.to;
      }

      return result;
    }
  }]);

  return AnimateElement;
}(Element);

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var AnimateColorElement = /*#__PURE__*/function (_AnimateElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(AnimateColorElement, _AnimateElement);

  var _super = _createSuper$q(AnimateColorElement);

  function AnimateColorElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, AnimateColorElement);

    _this = _super.apply(this, arguments);
    _this.type = 'animateColor';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(AnimateColorElement, [{
    key: "calcValue",
    value: function calcValue() {
      var _this$getProgress = this.getProgress(),
          progress = _this$getProgress.progress,
          from = _this$getProgress.from,
          to = _this$getProgress.to;

      var colorFrom = new (rgbcolor__WEBPACK_IMPORTED_MODULE_25___default())(from.getColor());
      var colorTo = new (rgbcolor__WEBPACK_IMPORTED_MODULE_25___default())(to.getColor());

      if (colorFrom.ok && colorTo.ok) {
        var _context, _context2;

        // tween color linearly
        var r = colorFrom.r + (colorTo.r - colorFrom.r) * progress;
        var g = colorFrom.g + (colorTo.g - colorFrom.g) * progress;
        var b = colorFrom.b + (colorTo.b - colorFrom.b) * progress; // ? alpha

        return _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context = _babel_runtime_corejs3_core_js_stable_instance_concat__WEBPACK_IMPORTED_MODULE_17___default()(_context2 = "rgb(".concat(_babel_runtime_corejs3_core_js_stable_parse_int__WEBPACK_IMPORTED_MODULE_42___default()(r, 10), ", ")).call(_context2, _babel_runtime_corejs3_core_js_stable_parse_int__WEBPACK_IMPORTED_MODULE_42___default()(g, 10), ", ")).call(_context, _babel_runtime_corejs3_core_js_stable_parse_int__WEBPACK_IMPORTED_MODULE_42___default()(b, 10), ")");
      }

      return this.getAttribute('from').getColor();
    }
  }]);

  return AnimateColorElement;
}(AnimateElement);

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var AnimateTransformElement = /*#__PURE__*/function (_AnimateElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(AnimateTransformElement, _AnimateElement);

  var _super = _createSuper$r(AnimateTransformElement);

  function AnimateTransformElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, AnimateTransformElement);

    _this = _super.apply(this, arguments);
    _this.type = 'animateTransform';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(AnimateTransformElement, [{
    key: "calcValue",
    value: function calcValue() {
      var _this$getProgress = this.getProgress(),
          progress = _this$getProgress.progress,
          from = _this$getProgress.from,
          to = _this$getProgress.to; // tween value linearly


      var transformFrom = toNumbers(from.getString());
      var transformTo = toNumbers(to.getString());

      var newValue = _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(transformFrom).call(transformFrom, function (from, i) {
        var to = transformTo[i];
        return from + (to - from) * progress;
      }).join(' ');

      return newValue;
    }
  }]);

  return AnimateTransformElement;
}(AnimateElement);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof (_babel_runtime_corejs3_core_js_stable_symbol__WEBPACK_IMPORTED_MODULE_46___default()) === "undefined" || _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_45___default()(o) == null) { if (_babel_runtime_corejs3_core_js_stable_array_is_array__WEBPACK_IMPORTED_MODULE_44___default()(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _babel_runtime_corejs3_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_43___default()(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _babel_runtime_corejs3_core_js_stable_instance_slice__WEBPACK_IMPORTED_MODULE_47___default()(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FontElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FontElement, _Element);

  var _super = _createSuper$s(FontElement);

  function FontElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FontElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'font';
    _this.glyphs = {};
    _this.horizAdvX = _this.getAttribute('horiz-adv-x').getNumber();
    var definitions = document.definitions;

    var _assertThisInitialize = (0,_babel_runtime_corejs3_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_40__.default)(_this),
        children = _assertThisInitialize.children;

    var _iterator = _createForOfIteratorHelper(children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;

        switch (child.type) {
          case 'font-face':
            {
              _this.fontFace = child;
              var fontFamilyStyle = child.getStyle('font-family');

              if (fontFamilyStyle.hasValue()) {
                definitions[fontFamilyStyle.getString()] = (0,_babel_runtime_corejs3_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_40__.default)(_this);
              }

              break;
            }

          case 'missing-glyph':
            _this.missingGlyph = child;
            break;

          case 'glyph':
            {
              var glyph = child;

              if (glyph.arabicForm) {
                _this.isRTL = true;
                _this.isArabic = true;

                if (typeof _this.glyphs[glyph.unicode] === 'undefined') {
                  _this.glyphs[glyph.unicode] = {};
                }

                _this.glyphs[glyph.unicode][glyph.arabicForm] = glyph;
              } else {
                _this.glyphs[glyph.unicode] = glyph;
              }

              break;
            }

          default:
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FontElement, [{
    key: "render",
    value: function render() {// NO RENDER
    }
  }]);

  return FontElement;
}(Element);

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FontFaceElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FontFaceElement, _Element);

  var _super = _createSuper$t(FontFaceElement);

  function FontFaceElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FontFaceElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'font-face';
    _this.ascent = _this.getAttribute('ascent').getNumber();
    _this.descent = _this.getAttribute('descent').getNumber();
    _this.unitsPerEm = _this.getAttribute('units-per-em').getNumber();
    return _this;
  }

  return FontFaceElement;
}(Element);

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var MissingGlyphElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(MissingGlyphElement, _PathElement);

  var _super = _createSuper$u(MissingGlyphElement);

  function MissingGlyphElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, MissingGlyphElement);

    _this = _super.apply(this, arguments);
    _this.type = 'missing-glyph';
    _this.horizAdvX = 0;
    return _this;
  }

  return MissingGlyphElement;
}(PathElement);

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var GlyphElement = /*#__PURE__*/function (_PathElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(GlyphElement, _PathElement);

  var _super = _createSuper$v(GlyphElement);

  function GlyphElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, GlyphElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'glyph';
    _this.horizAdvX = _this.getAttribute('horiz-adv-x').getNumber();
    _this.unicode = _this.getAttribute('unicode').getString();
    _this.arabicForm = _this.getAttribute('arabic-form').getString();
    return _this;
  }

  return GlyphElement;
}(PathElement);

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var TRefElement = /*#__PURE__*/function (_TextElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(TRefElement, _TextElement);

  var _super = _createSuper$w(TRefElement);

  function TRefElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, TRefElement);

    _this = _super.apply(this, arguments);
    _this.type = 'tref';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(TRefElement, [{
    key: "getText",
    value: function getText() {
      var element = this.getHrefAttribute().getDefinition();

      if (element) {
        var firstChild = element.children[0];

        if (firstChild) {
          return firstChild.getText();
        }
      }

      return '';
    }
  }]);

  return TRefElement;
}(TextElement);

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var AElement = /*#__PURE__*/function (_TextElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(AElement, _TextElement);

  var _super = _createSuper$x(AElement);

  function AElement(document, node, captureTextNodes) {
    var _context;

    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, AElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'a';
    var childNodes = node.childNodes;
    var firstChild = childNodes[0];

    var hasText = childNodes.length > 0 && _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20___default()(_context = _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(childNodes)).call(_context, function (node) {
      return node.nodeType === 3;
    });

    _this.hasText = hasText;
    _this.text = hasText ? _this.getTextFromNode(firstChild) : '';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(AElement, [{
    key: "getText",
    value: function getText() {
      return this.text;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      if (this.hasText) {
        // render as text element
        (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(AElement.prototype), "renderChildren", this).call(this, ctx);

        var document = this.document,
            x = this.x,
            y = this.y;
        var mouse = document.screen.mouse;
        var fontSize = new Property(document, 'fontSize', Font.parse(document.ctx.font).fontSize); // Do not calc bounding box if mouse is not working.

        if (mouse.isWorking()) {
          mouse.checkBoundingBox(this, new BoundingBox(x, y - fontSize.getPixels('y'), x + this.measureText(ctx), y));
        }
      } else if (this.children.length > 0) {
        // render as temporary group
        var g = new GElement(this.document, null);
        g.children = this.children;
        g.parent = this;
        g.render(ctx);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var window = this.document.window;

      if (window) {
        window.open(this.getHrefAttribute().getString());
      }
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove() {
      var ctx = this.document.ctx;
      ctx.canvas.style.cursor = 'pointer';
    }
  }]);

  return AElement;
}(TextElement);

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof (_babel_runtime_corejs3_core_js_stable_symbol__WEBPACK_IMPORTED_MODULE_46___default()) === "undefined" || _babel_runtime_corejs3_core_js_get_iterator_method__WEBPACK_IMPORTED_MODULE_45___default()(o) == null) { if (_babel_runtime_corejs3_core_js_stable_array_is_array__WEBPACK_IMPORTED_MODULE_44___default()(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _babel_runtime_corejs3_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_43___default()(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = _babel_runtime_corejs3_core_js_stable_instance_slice__WEBPACK_IMPORTED_MODULE_47___default()(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_11___default()(object); if ((_babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default())) { var symbols = _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default()(object); if (enumerableOnly) symbols = _babel_runtime_corejs3_core_js_stable_instance_filter__WEBPACK_IMPORTED_MODULE_9___default()(symbols).call(symbols, function (sym) { return _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0,_babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__.default)(target, key, source[key]); }); } else if ((_babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default())) { _babel_runtime_corejs3_core_js_stable_object_define_properties__WEBPACK_IMPORTED_MODULE_5___default()(target, _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default()(source)); } else { var _context4; _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _babel_runtime_corejs3_core_js_stable_object_define_property__WEBPACK_IMPORTED_MODULE_4___default()(target, key, _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default()(source, key)); }); } } return target; }

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextPathElement = /*#__PURE__*/function (_TextElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(TextPathElement, _TextElement);

  var _super = _createSuper$y(TextPathElement);

  function TextPathElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, TextPathElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'textPath';
    _this.textWidth = 0;
    _this.textHeight = 0;
    _this.pathLength = -1;
    _this.glyphInfo = null;
    _this.letterSpacingCache = [];
    _this.measuresCache = new (_babel_runtime_corejs3_core_js_stable_map__WEBPACK_IMPORTED_MODULE_48___default())([['', 0]]);

    var pathElement = _this.getHrefAttribute().getDefinition();

    _this.text = _this.getTextFromNode();
    _this.dataArray = _this.parsePathData(pathElement);
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(TextPathElement, [{
    key: "getText",
    value: function getText() {
      return this.text;
    }
  }, {
    key: "path",
    value: function path(ctx) {
      var dataArray = this.dataArray;

      if (ctx) {
        ctx.beginPath();
      }

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(dataArray).call(dataArray, function (_ref) {
        var type = _ref.type,
            points = _ref.points;

        switch (type) {
          case PathParser.LINE_TO:
            if (ctx) {
              ctx.lineTo(points[0], points[1]);
            }

            break;

          case PathParser.MOVE_TO:
            if (ctx) {
              ctx.moveTo(points[0], points[1]);
            }

            break;

          case PathParser.CURVE_TO:
            if (ctx) {
              ctx.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
            }

            break;

          case PathParser.QUAD_TO:
            if (ctx) {
              ctx.quadraticCurveTo(points[0], points[1], points[2], points[3]);
            }

            break;

          case PathParser.ARC:
            {
              var _points = (0,_babel_runtime_corejs3_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__.default)(points, 8),
                  cx = _points[0],
                  cy = _points[1],
                  rx = _points[2],
                  ry = _points[3],
                  theta = _points[4],
                  dTheta = _points[5],
                  psi = _points[6],
                  fs = _points[7];

              var r = rx > ry ? rx : ry;
              var scaleX = rx > ry ? 1 : rx / ry;
              var scaleY = rx > ry ? ry / rx : 1;

              if (ctx) {
                ctx.translate(cx, cy);
                ctx.rotate(psi);
                ctx.scale(scaleX, scaleY);
                ctx.arc(0, 0, r, theta, theta + dTheta, Boolean(1 - fs));
                ctx.scale(1 / scaleX, 1 / scaleY);
                ctx.rotate(-psi);
                ctx.translate(-cx, -cy);
              }

              break;
            }

          case PathParser.CLOSE_PATH:
            if (ctx) {
              ctx.closePath();
            }

            break;
        }
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      this.setTextData(ctx);
      ctx.save();
      var textDecoration = this.parent.getStyle('text-decoration').getString();
      var fontSize = this.getFontSize();
      var glyphInfo = this.glyphInfo;
      var fill = ctx.fillStyle;

      if (textDecoration === 'underline') {
        ctx.beginPath();
      }

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(glyphInfo).call(glyphInfo, function (glyph, i) {
        var p0 = glyph.p0,
            p1 = glyph.p1,
            rotation = glyph.rotation,
            partialText = glyph.text;
        ctx.save();
        ctx.translate(p0.x, p0.y);
        ctx.rotate(rotation);

        if (ctx.fillStyle) {
          ctx.fillText(partialText, 0, 0);
        }

        if (ctx.strokeStyle) {
          ctx.strokeText(partialText, 0, 0);
        }

        ctx.restore();

        if (textDecoration === 'underline') {
          if (i === 0) {
            ctx.moveTo(p0.x, p0.y + fontSize / 8);
          }

          ctx.lineTo(p1.x, p1.y + fontSize / 5);
        } //// To assist with debugging visually, uncomment following
        //
        // ctx.beginPath();
        // if (i % 2)
        // 	ctx.strokeStyle = 'red';
        // else
        // 	ctx.strokeStyle = 'green';
        // ctx.moveTo(p0.x, p0.y);
        // ctx.lineTo(p1.x, p1.y);
        // ctx.stroke();
        // ctx.closePath();

      });

      if (textDecoration === 'underline') {
        ctx.lineWidth = fontSize / 20;
        ctx.strokeStyle = fill;
        ctx.stroke();
        ctx.closePath();
      }

      ctx.restore();
    }
  }, {
    key: "getLetterSpacingAt",
    value: function getLetterSpacingAt() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.letterSpacingCache[idx] || 0;
    }
  }, {
    key: "findSegmentToFitChar",
    value: function findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, inputOffset, dy, c, charI) {
      var offset = inputOffset;
      var glyphWidth = this.measureText(ctx, c);

      if (c === ' ' && anchor === 'justify' && textFullWidth < fullPathWidth) {
        glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
      }

      if (charI > -1) {
        offset += this.getLetterSpacingAt(charI);
      }

      var splineStep = this.textHeight / 20;
      var p0 = this.getEquidistantPointOnPath(offset, splineStep, 0);
      var p1 = this.getEquidistantPointOnPath(offset + glyphWidth, splineStep, 0);
      var segment = {
        p0: p0,
        p1: p1
      };
      var rotation = p0 && p1 ? Math.atan2(p1.y - p0.y, p1.x - p0.x) : 0;

      if (dy) {
        var dyX = Math.cos(Math.PI / 2 + rotation) * dy;
        var dyY = Math.cos(-rotation) * dy;
        segment.p0 = _objectSpread(_objectSpread({}, p0), {}, {
          x: p0.x + dyX,
          y: p0.y + dyY
        });
        segment.p1 = _objectSpread(_objectSpread({}, p1), {}, {
          x: p1.x + dyX,
          y: p1.y + dyY
        });
      }

      offset += glyphWidth;
      return {
        offset: offset,
        segment: segment,
        rotation: rotation
      };
    }
  }, {
    key: "measureText",
    value: function measureText(ctx, text) {
      var measuresCache = this.measuresCache;
      var targetText = text || this.getText();

      if (measuresCache.has(targetText)) {
        return measuresCache.get(targetText);
      }

      var measure = this.measureTargetText(ctx, targetText);
      measuresCache.set(targetText, measure);
      return measure;
    } // This method supposes what all custom fonts already loaded.
    // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
    // You need to call this method manually to update glyphs cache.

  }, {
    key: "setTextData",
    value: function setTextData(ctx) {
      var _context,
          _this2 = this;

      if (this.glyphInfo) {
        return;
      }

      var renderText = this.getText();
      var chars = renderText.split('');
      var spacesNumber = renderText.split(' ').length - 1;

      var dx = _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(_context = this.parent.getAttribute('dx').split()).call(_context, function (_) {
        return _.getPixels('x');
      });

      var dy = this.parent.getAttribute('dy').getPixels('y');
      var anchor = this.parent.getStyle('text-anchor').getString('start');
      var thisSpacing = this.getStyle('letter-spacing');
      var parentSpacing = this.parent.getStyle('letter-spacing');
      var letterSpacing = 0;

      if (!thisSpacing.hasValue() || thisSpacing.getValue() === 'inherit') {
        letterSpacing = parentSpacing.getPixels();
      } else if (thisSpacing.hasValue()) {
        if (thisSpacing.getValue() !== 'initial' && thisSpacing.getValue() !== 'unset') {
          letterSpacing = thisSpacing.getPixels();
        }
      } // fill letter-spacing cache


      var letterSpacingCache = [];
      var textLen = renderText.length;
      this.letterSpacingCache = letterSpacingCache;

      for (var i = 0; i < textLen; i++) {
        letterSpacingCache.push(typeof dx[i] !== 'undefined' ? dx[i] : letterSpacing);
      }

      var dxSum = _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18___default()(letterSpacingCache).call(letterSpacingCache, function (acc, cur, i) {
        return i === 0 ? 0 : acc + cur || 0;
      }, 0);

      var textWidth = this.measureText(ctx);
      var textFullWidth = Math.max(textWidth + dxSum, 0);
      this.textWidth = textWidth;
      this.textHeight = this.getFontSize();
      this.glyphInfo = [];
      var fullPathWidth = this.getPathLength();
      var startOffset = this.getStyle('startOffset').getNumber(0) * fullPathWidth;
      var offset = 0;

      if (anchor === 'middle' || anchor === 'center') {
        offset = -textFullWidth / 2;
      }

      if (anchor === 'end' || anchor === 'right') {
        offset = -textFullWidth;
      }

      offset += startOffset;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(chars).call(chars, function (char, i) {
        // Find such segment what distance between p0 and p1 is approx. width of glyph
        var _this2$findSegmentToF = _this2.findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, offset, dy, char, i),
            nextOffset = _this2$findSegmentToF.offset,
            segment = _this2$findSegmentToF.segment,
            rotation = _this2$findSegmentToF.rotation;

        offset = nextOffset;

        if (!segment.p0 || !segment.p1) {
          return;
        } // const width = this.getLineLength(
        // 	segment.p0.x,
        // 	segment.p0.y,
        // 	segment.p1.x,
        // 	segment.p1.y
        // );
        // Note: Since glyphs are rendered one at a time, any kerning pair data built into the font will not be used.
        // Can foresee having a rough pair table built in that the developer can override as needed.
        // Or use "dx" attribute of the <text> node as a naive replacement
        // const kern = 0;
        // placeholder for future implementation
        // const midpoint = this.getPointOnLine(
        // 	kern + width / 2.0,
        // 	segment.p0.x, segment.p0.y, segment.p1.x, segment.p1.y
        // );


        _this2.glyphInfo.push({
          // transposeX: midpoint.x,
          // transposeY: midpoint.y,
          text: chars[i],
          p0: segment.p0,
          p1: segment.p1,
          rotation: rotation
        });
      });
    }
  }, {
    key: "parsePathData",
    value: function parsePathData(path) {
      this.pathLength = -1; // reset path length

      if (!path) {
        return [];
      }

      var pathCommands = [];
      var pathParser = path.pathParser;
      pathParser.reset(); // convert l, H, h, V, and v to L

      while (!pathParser.isEnd()) {
        var current = pathParser.current;
        var startX = current ? current.x : 0;
        var startY = current ? current.y : 0;
        var command = pathParser.next();
        var nextCommandType = command.type;
        var points = [];

        switch (command.type) {
          case PathParser.MOVE_TO:
            this.pathM(pathParser, points);
            break;

          case PathParser.LINE_TO:
            nextCommandType = this.pathL(pathParser, points);
            break;

          case PathParser.HORIZ_LINE_TO:
            nextCommandType = this.pathH(pathParser, points);
            break;

          case PathParser.VERT_LINE_TO:
            nextCommandType = this.pathV(pathParser, points);
            break;

          case PathParser.CURVE_TO:
            this.pathC(pathParser, points);
            break;

          case PathParser.SMOOTH_CURVE_TO:
            nextCommandType = this.pathS(pathParser, points);
            break;

          case PathParser.QUAD_TO:
            this.pathQ(pathParser, points);
            break;

          case PathParser.SMOOTH_QUAD_TO:
            nextCommandType = this.pathT(pathParser, points);
            break;

          case PathParser.ARC:
            points = this.pathA(pathParser);
            break;

          case PathParser.CLOSE_PATH:
            PathElement.pathZ(pathParser);
            break;
        }

        if (command.type !== PathParser.CLOSE_PATH) {
          pathCommands.push({
            type: nextCommandType,
            points: points,
            start: {
              x: startX,
              y: startY
            },
            pathLength: this.calcLength(startX, startY, nextCommandType, points)
          });
        } else {
          pathCommands.push({
            type: PathParser.CLOSE_PATH,
            points: [],
            pathLength: 0
          });
        }
      }

      return pathCommands;
    }
  }, {
    key: "pathM",
    value: function pathM(pathParser, points) {
      var _PathElement$pathM$po = PathElement.pathM(pathParser).point,
          x = _PathElement$pathM$po.x,
          y = _PathElement$pathM$po.y;
      points.push(x, y);
    }
  }, {
    key: "pathL",
    value: function pathL(pathParser, points) {
      var _PathElement$pathL$po = PathElement.pathL(pathParser).point,
          x = _PathElement$pathL$po.x,
          y = _PathElement$pathL$po.y;
      points.push(x, y);
      return PathParser.LINE_TO;
    }
  }, {
    key: "pathH",
    value: function pathH(pathParser, points) {
      var _PathElement$pathH$po = PathElement.pathH(pathParser).point,
          x = _PathElement$pathH$po.x,
          y = _PathElement$pathH$po.y;
      points.push(x, y);
      return PathParser.LINE_TO;
    }
  }, {
    key: "pathV",
    value: function pathV(pathParser, points) {
      var _PathElement$pathV$po = PathElement.pathV(pathParser).point,
          x = _PathElement$pathV$po.x,
          y = _PathElement$pathV$po.y;
      points.push(x, y);
      return PathParser.LINE_TO;
    }
  }, {
    key: "pathC",
    value: function pathC(pathParser, points) {
      var _PathElement$pathC = PathElement.pathC(pathParser),
          point = _PathElement$pathC.point,
          controlPoint = _PathElement$pathC.controlPoint,
          currentPoint = _PathElement$pathC.currentPoint;

      points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }, {
    key: "pathS",
    value: function pathS(pathParser, points) {
      var _PathElement$pathS = PathElement.pathS(pathParser),
          point = _PathElement$pathS.point,
          controlPoint = _PathElement$pathS.controlPoint,
          currentPoint = _PathElement$pathS.currentPoint;

      points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
      return PathParser.CURVE_TO;
    }
  }, {
    key: "pathQ",
    value: function pathQ(pathParser, points) {
      var _PathElement$pathQ = PathElement.pathQ(pathParser),
          controlPoint = _PathElement$pathQ.controlPoint,
          currentPoint = _PathElement$pathQ.currentPoint;

      points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }, {
    key: "pathT",
    value: function pathT(pathParser, points) {
      var _PathElement$pathT = PathElement.pathT(pathParser),
          controlPoint = _PathElement$pathT.controlPoint,
          currentPoint = _PathElement$pathT.currentPoint;

      points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
      return PathParser.QUAD_TO;
    }
  }, {
    key: "pathA",
    value: function pathA(pathParser) {
      var _PathElement$pathA = PathElement.pathA(pathParser),
          rX = _PathElement$pathA.rX,
          rY = _PathElement$pathA.rY,
          sweepFlag = _PathElement$pathA.sweepFlag,
          xAxisRotation = _PathElement$pathA.xAxisRotation,
          centp = _PathElement$pathA.centp,
          a1 = _PathElement$pathA.a1,
          ad = _PathElement$pathA.ad;

      if (sweepFlag === 0 && ad > 0) {
        ad = ad - 2 * Math.PI;
      }

      if (sweepFlag === 1 && ad < 0) {
        ad = ad + 2 * Math.PI;
      }

      return [centp.x, centp.y, rX, rY, a1, ad, xAxisRotation, sweepFlag];
    }
  }, {
    key: "calcLength",
    value: function calcLength(x, y, commandType, points) {
      var len = 0;
      var p1 = null;
      var p2 = null;
      var t = 0;

      switch (commandType) {
        case PathParser.LINE_TO:
          return this.getLineLength(x, y, points[0], points[1]);

        case PathParser.CURVE_TO:
          // Approximates by breaking curve into 100 line segments
          len = 0.0;
          p1 = this.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);

          for (t = 0.01; t <= 1; t += 0.01) {
            p2 = this.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
            len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
            p1 = p2;
          }

          return len;

        case PathParser.QUAD_TO:
          // Approximates by breaking curve into 100 line segments
          len = 0.0;
          p1 = this.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);

          for (t = 0.01; t <= 1; t += 0.01) {
            p2 = this.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
            len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
            p1 = p2;
          }

          return len;

        case PathParser.ARC:
          // Approximates by breaking curve into line segments
          len = 0.0;
          var start = points[4]; // 4 = theta

          var dTheta = points[5]; // 5 = dTheta

          var end = points[4] + dTheta;
          var inc = Math.PI / 180.0; // 1 degree resolution

          if (Math.abs(start - end) < inc) {
            inc = Math.abs(start - end);
          } // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi


          p1 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);

          if (dTheta < 0) {
            // clockwise
            for (t = start - inc; t > end; t -= inc) {
              p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
              len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
              p1 = p2;
            }
          } else {
            // counter-clockwise
            for (t = start + inc; t < end; t += inc) {
              p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
              len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
              p1 = p2;
            }
          }

          p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
          len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
          return len;
      }

      return 0;
    }
  }, {
    key: "getPointOnLine",
    value: function getPointOnLine(dist, P1x, P1y, P2x, P2y) {
      var fromX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : P1x;
      var fromY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : P1y;
      var m = (P2y - P1y) / (P2x - P1x + PSEUDO_ZERO);
      var run = Math.sqrt(dist * dist / (1 + m * m));

      if (P2x < P1x) {
        run *= -1;
      }

      var rise = m * run;
      var pt = null;

      if (P2x === P1x) {
        // vertical line
        pt = {
          x: fromX,
          y: fromY + rise
        };
      } else if ((fromY - P1y) / (fromX - P1x + PSEUDO_ZERO) === m) {
        pt = {
          x: fromX + run,
          y: fromY + rise
        };
      } else {
        var ix = 0;
        var iy = 0;
        var len = this.getLineLength(P1x, P1y, P2x, P2y);

        if (len < PSEUDO_ZERO) {
          return null;
        }

        var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
        u = u / (len * len);
        ix = P1x + u * (P2x - P1x);
        iy = P1y + u * (P2y - P1y);
        var pRise = this.getLineLength(fromX, fromY, ix, iy);
        var pRun = Math.sqrt(dist * dist - pRise * pRise);
        run = Math.sqrt(pRun * pRun / (1 + m * m));

        if (P2x < P1x) {
          run *= -1;
        }

        rise = m * run;
        pt = {
          x: ix + run,
          y: iy + rise
        };
      }

      return pt;
    }
  }, {
    key: "getPointOnPath",
    value: function getPointOnPath(distance) {
      var fullLen = this.getPathLength();
      var cumulativePathLength = 0;
      var p = null;

      if (distance < -0.00005 || distance - 0.00005 > fullLen) {
        return null;
      }

      var dataArray = this.dataArray;

      var _iterator = _createForOfIteratorHelper$1(dataArray),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var command = _step.value;

          if (command && (command.pathLength < 0.00005 || cumulativePathLength + command.pathLength + 0.00005 < distance)) {
            cumulativePathLength += command.pathLength;
            continue;
          }

          var delta = distance - cumulativePathLength;
          var currentT = 0;

          switch (command.type) {
            case PathParser.LINE_TO:
              p = this.getPointOnLine(delta, command.start.x, command.start.y, command.points[0], command.points[1], command.start.x, command.start.y);
              break;

            case PathParser.ARC:
              var start = command.points[4]; // 4 = theta

              var dTheta = command.points[5]; // 5 = dTheta

              var end = command.points[4] + dTheta;
              currentT = start + delta / command.pathLength * dTheta;

              if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
                break;
              }

              p = this.getPointOnEllipticalArc(command.points[0], command.points[1], command.points[2], command.points[3], currentT, command.points[6]);
              break;

            case PathParser.CURVE_TO:
              currentT = delta / command.pathLength;

              if (currentT > 1) {
                currentT = 1;
              }

              p = this.getPointOnCubicBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3], command.points[4], command.points[5]);
              break;

            case PathParser.QUAD_TO:
              currentT = delta / command.pathLength;

              if (currentT > 1) {
                currentT = 1;
              }

              p = this.getPointOnQuadraticBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3]);
              break;

            default:
          }

          if (p) {
            return p;
          }

          break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
  }, {
    key: "getLineLength",
    value: function getLineLength(x1, y1, x2, y2) {
      return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
  }, {
    key: "getPathLength",
    value: function getPathLength() {
      if (this.pathLength === -1) {
        var _context2;

        this.pathLength = _babel_runtime_corejs3_core_js_stable_instance_reduce__WEBPACK_IMPORTED_MODULE_18___default()(_context2 = this.dataArray).call(_context2, function (length, command) {
          return command.pathLength > 0 ? length + command.pathLength : length;
        }, 0);
      }

      return this.pathLength;
    }
  }, {
    key: "getPointOnCubicBezier",
    value: function getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
      var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
      var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "getPointOnQuadraticBezier",
    value: function getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
      var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
      var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "getPointOnEllipticalArc",
    value: function getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
      var cosPsi = Math.cos(psi);
      var sinPsi = Math.sin(psi);
      var pt = {
        x: rx * Math.cos(theta),
        y: ry * Math.sin(theta)
      };
      return {
        x: cx + (pt.x * cosPsi - pt.y * sinPsi),
        y: cy + (pt.x * sinPsi + pt.y * cosPsi)
      };
    } // TODO need some optimisations. possibly build cache only for curved segments?

  }, {
    key: "buildEquidistantCache",
    value: function buildEquidistantCache(inputStep, inputPrecision) {
      var fullLen = this.getPathLength();
      var precision = inputPrecision || 0.25; // accuracy vs performance

      var step = inputStep || fullLen / 100;

      if (!this.equidistantCache || this.equidistantCache.step !== step || this.equidistantCache.precision !== precision) {
        // Prepare cache
        this.equidistantCache = {
          step: step,
          precision: precision,
          points: []
        }; // Calculate points

        var s = 0;

        for (var l = 0; l <= fullLen; l += precision) {
          var p0 = this.getPointOnPath(l);
          var p1 = this.getPointOnPath(l + precision);

          if (!p0 || !p1) {
            continue;
          }

          s += this.getLineLength(p0.x, p0.y, p1.x, p1.y);

          if (s >= step) {
            this.equidistantCache.points.push({
              x: p0.x,
              y: p0.y,
              distance: l
            });
            s -= step;
          }
        }
      }
    }
  }, {
    key: "getEquidistantPointOnPath",
    value: function getEquidistantPointOnPath(targetDistance, step, precision) {
      this.buildEquidistantCache(step, precision);

      if (targetDistance < 0 || targetDistance - this.getPathLength() > 0.00005) {
        return null;
      }

      var idx = Math.round(targetDistance / this.getPathLength() * (this.equidistantCache.points.length - 1));
      return this.equidistantCache.points[idx] || null;
    }
  }]);

  return TextPathElement;
}(TextElement);

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var ImageElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(ImageElement, _RenderedElement);

  var _super = _createSuper$z(ImageElement);

  function ImageElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, ImageElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'image';
    _this.loaded = false;

    var href = _this.getHrefAttribute().getString();

    if (!href) {
      return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(_this);
    }

    var isSvg = /\.svg$/.test(href);
    document.images.push((0,_babel_runtime_corejs3_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_40__.default)(_this));

    if (!isSvg) {
      _this.loadImage(href);
    } else {
      _this.loadSvg(href);
    }

    _this.isSvg = isSvg;
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(ImageElement, [{
    key: "loadImage",
    value: function () {
      var _loadImage = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee(href) {
        var image;
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.document.createImage(href);

              case 3:
                image = _context.sent;
                this.image = image;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                // tslint:disable-next-line: no-console
                console.error("Error while loading image \"".concat(href, "\":"), _context.t0);

              case 10:
                this.loaded = true;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function loadImage(_x) {
        return _loadImage.apply(this, arguments);
      }

      return loadImage;
    }()
  }, {
    key: "loadSvg",
    value: function () {
      var _loadSvg = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee2(href) {
        var response, svg;
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.document.fetch(href);

              case 3:
                response = _context2.sent;
                _context2.next = 6;
                return response.text();

              case 6:
                svg = _context2.sent;
                this.image = svg;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                // tslint:disable-next-line: no-console
                console.error("Error while loading image \"".concat(href, "\":"), _context2.t0);

              case 13:
                this.loaded = true;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function loadSvg(_x2) {
        return _loadSvg.apply(this, arguments);
      }

      return loadSvg;
    }()
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      var document = this.document,
          image = this.image,
          loaded = this.loaded;
      var x = this.getAttribute('x').getPixels('x');
      var y = this.getAttribute('y').getPixels('y');
      var width = this.getStyle('width').getPixels('x');
      var height = this.getStyle('height').getPixels('y');

      if (!loaded || !image || !width || !height) {
        return;
      }

      ctx.save();

      if (this.isSvg) {
        document.canvg.forkString(ctx, this.image, {
          ignoreMouse: true,
          ignoreAnimation: true,
          ignoreDimensions: true,
          ignoreClear: true,
          offsetX: x,
          offsetY: y,
          scaleWidth: width,
          scaleHeight: height
        }).render();
      } else {
        var _image = this.image;
        ctx.translate(x, y);
        document.setViewBox({
          ctx: ctx,
          aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
          width: width,
          desiredWidth: _image.width,
          height: height,
          desiredHeight: _image.height
        });

        if (this.loaded) {
          if (typeof _image.complete === 'undefined' || _image.complete) {
            ctx.drawImage(_image, 0, 0);
          }
        }
      }

      ctx.restore();
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var x = this.getAttribute('x').getPixels('x');
      var y = this.getAttribute('y').getPixels('y');
      var width = this.getStyle('width').getPixels('x');
      var height = this.getStyle('height').getPixels('y');
      return new BoundingBox(x, y, x + width, y + height);
    }
  }]);

  return ImageElement;
}(RenderedElement);

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var SymbolElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(SymbolElement, _RenderedElement);

  var _super = _createSuper$A(SymbolElement);

  function SymbolElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, SymbolElement);

    _this = _super.apply(this, arguments);
    _this.type = 'symbol';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(SymbolElement, [{
    key: "render",
    value: function render(_) {// NO RENDER
    }
  }]);

  return SymbolElement;
}(RenderedElement);

var SVGFontLoader = /*#__PURE__*/function () {
  function SVGFontLoader(document) {
    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, SVGFontLoader);

    this.document = document;
    this.loaded = false;
    document.fonts.push(this);
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(SVGFontLoader, [{
    key: "load",
    value: function () {
      var _load = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee(fontFamily, url) {
        var _context, document, svgDocument, fonts;

        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                document = this.document;
                _context2.next = 4;
                return document.canvg.parser.load(url);

              case 4:
                svgDocument = _context2.sent;
                fonts = svgDocument.getElementsByTagName('font');

                _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(fonts)).call(_context, function (fontNode) {
                  var font = document.createElement(fontNode);
                  document.definitions[fontFamily] = font;
                });

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                // tslint:disable-next-line: no-console
                console.error("Error while loading font \"".concat(url, "\":"), _context2.t0);

              case 12:
                this.loaded = true;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }]);

  return SVGFontLoader;
}();

function _createSuper$B(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$B(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var StyleElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(StyleElement, _Element);

  var _super = _createSuper$B(StyleElement);

  function StyleElement(document, node, captureTextNodes) {
    var _context;

    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, StyleElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'style';
    var css = compressSpaces(_babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_2___default()(_context = _babel_runtime_corejs3_core_js_stable_array_from__WEBPACK_IMPORTED_MODULE_33___default()(node.childNodes)).call(_context, function (_) {
      return _.data;
    }).join('').replace(/(\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, '') // remove comments
    .replace(/@import.*;/g, '') // remove imports
    );
    var cssDefs = css.split('}');

    _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(cssDefs).call(cssDefs, function (_) {
      var def = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_).call(_);

      if (!def) {
        return;
      }

      var cssParts = def.split('{');
      var cssClasses = cssParts[0].split(',');
      var cssProps = cssParts[1].split(';');

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(cssClasses).call(cssClasses, function (_) {
        var cssClass = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_).call(_);

        if (!cssClass) {
          return;
        }

        var props = document.styles[cssClass] || {};

        _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(cssProps).call(cssProps, function (cssProp) {
          var _context2, _context3;

          var prop = _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_35___default()(cssProp).call(cssProp, ':');

          var name = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_context2 = cssProp.substr(0, prop)).call(_context2);

          var value = _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_24___default()(_context3 = cssProp.substr(prop + 1, cssProp.length - prop)).call(_context3);

          if (name && value) {
            props[name] = new Property(document, name, value);
          }
        });

        document.styles[cssClass] = props;
        document.stylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);

        if (cssClass === '@font-face') {
          //  && !nodeEnv
          var fontFamily = props['font-family'].getString().replace(/"|'/g, '');
          var srcs = props.src.getString().split(',');

          _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(srcs).call(srcs, function (src) {
            if (_babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_35___default()(src).call(src, 'format("svg")') > 0) {
              var url = parseExternalUrl(src);

              if (url) {
                new SVGFontLoader(document).load(fontFamily, url);
              }
            }
          });
        }
      });
    });

    return _this;
  }

  return StyleElement;
}(Element);
StyleElement.parseExternalUrl = parseExternalUrl;

function _createSuper$C(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$C(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var UseElement = /*#__PURE__*/function (_RenderedElement) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(UseElement, _RenderedElement);

  var _super = _createSuper$C(UseElement);

  function UseElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, UseElement);

    _this = _super.apply(this, arguments);
    _this.type = 'use';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(UseElement, [{
    key: "setContext",
    value: function setContext(ctx) {
      (0,_babel_runtime_corejs3_helpers_get__WEBPACK_IMPORTED_MODULE_36__.default)((0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(UseElement.prototype), "setContext", this).call(this, ctx);

      var xAttr = this.getAttribute('x');
      var yAttr = this.getAttribute('y');

      if (xAttr.hasValue()) {
        ctx.translate(xAttr.getPixels('x'), 0);
      }

      if (yAttr.hasValue()) {
        ctx.translate(0, yAttr.getPixels('y'));
      }
    }
  }, {
    key: "path",
    value: function path(ctx) {
      var element = this.element;

      if (element) {
        element.path(ctx);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(ctx) {
      var document = this.document,
          element = this.element;

      if (element) {
        var tempSvg = element;

        if (element.type === 'symbol') {
          // render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
          tempSvg = new SVGElement(document, null);
          tempSvg.attributes.viewBox = new Property(document, 'viewBox', element.getAttribute('viewBox').getString());
          tempSvg.attributes.preserveAspectRatio = new Property(document, 'preserveAspectRatio', element.getAttribute('preserveAspectRatio').getString());
          tempSvg.attributes.overflow = new Property(document, 'overflow', element.getAttribute('overflow').getString());
          tempSvg.children = element.children; // element is still the parent of the children

          element.styles.opacity = new Property(document, 'opacity', this.calculateOpacity());
        }

        if (tempSvg.type === 'svg') {
          var widthStyle = this.getStyle('width', false, true);
          var heightStyle = this.getStyle('height', false, true); // if symbol or svg, inherit width/height from me

          if (widthStyle.hasValue()) {
            tempSvg.attributes.width = new Property(document, 'width', widthStyle.getString());
          }

          if (heightStyle.hasValue()) {
            tempSvg.attributes.height = new Property(document, 'height', heightStyle.getString());
          }
        }

        var oldParent = tempSvg.parent;
        tempSvg.parent = this;
        tempSvg.render(ctx);
        tempSvg.parent = oldParent;
      }
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(ctx) {
      var element = this.element;

      if (element) {
        return element.getBoundingBox(ctx);
      }

      return null;
    }
  }, {
    key: "elementTransform",
    value: function elementTransform() {
      var document = this.document,
          element = this.element;
      return Transform.fromElement(document, element);
    }
  }, {
    key: "element",
    get: function get() {
      if (!this._element) {
        this._element = this.getHrefAttribute().getDefinition();
      }

      return this._element;
    }
  }]);

  return UseElement;
}(RenderedElement);

function _createSuper$D(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$D(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

function imGet(img, x, y, width, _, rgba) {
  return img[y * width * 4 + x * 4 + rgba];
}

function imSet(img, x, y, width, _, rgba, val) {
  img[y * width * 4 + x * 4 + rgba] = val;
}

function m(matrix, i, v) {
  var mi = matrix[i];
  return mi * v;
}

function c(a, m1, m2, m3) {
  return m1 + Math.cos(a) * m2 + Math.sin(a) * m3;
}

var FeColorMatrixElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FeColorMatrixElement, _Element);

  var _super = _createSuper$D(FeColorMatrixElement);

  function FeColorMatrixElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FeColorMatrixElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'feColorMatrix';
    var matrix = toNumbers(_this.getAttribute('values').getString());

    switch (_this.getAttribute('type').getString('matrix')) {
      // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
      case 'saturate':
        {
          var s = matrix[0];
          matrix = [0.213 + 0.787 * s, 0.715 - 0.715 * s, 0.072 - 0.072 * s, 0, 0, 0.213 - 0.213 * s, 0.715 + 0.285 * s, 0.072 - 0.072 * s, 0, 0, 0.213 - 0.213 * s, 0.715 - 0.715 * s, 0.072 + 0.928 * s, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
          break;
        }

      case 'hueRotate':
        {
          var a = matrix[0] * Math.PI / 180.0;
          matrix = [c(a, 0.213, 0.787, -0.213), c(a, 0.715, -0.715, -0.715), c(a, 0.072, -0.072, 0.928), 0, 0, c(a, 0.213, -0.213, 0.143), c(a, 0.715, 0.285, 0.140), c(a, 0.072, -0.072, -0.283), 0, 0, c(a, 0.213, -0.213, -0.787), c(a, 0.715, -0.715, 0.715), c(a, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
          break;
        }

      case 'luminanceToAlpha':
        matrix = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }

    _this.matrix = matrix;
    _this.includeOpacity = _this.getAttribute('includeOpacity').hasValue();
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FeColorMatrixElement, [{
    key: "apply",
    value: function apply(ctx, _, __, width, height) {
      // assuming x==0 && y==0 for now
      var includeOpacity = this.includeOpacity,
          matrix = this.matrix;
      var srcData = ctx.getImageData(0, 0, width, height);

      for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
          var r = imGet(srcData.data, x, y, width, height, 0);
          var g = imGet(srcData.data, x, y, width, height, 1);
          var b = imGet(srcData.data, x, y, width, height, 2);
          var a = imGet(srcData.data, x, y, width, height, 3);
          var nr = m(matrix, 0, r) + m(matrix, 1, g) + m(matrix, 2, b) + m(matrix, 3, a) + m(matrix, 4, 1);
          var ng = m(matrix, 5, r) + m(matrix, 6, g) + m(matrix, 7, b) + m(matrix, 8, a) + m(matrix, 9, 1);
          var nb = m(matrix, 10, r) + m(matrix, 11, g) + m(matrix, 12, b) + m(matrix, 13, a) + m(matrix, 14, 1);
          var na = m(matrix, 15, r) + m(matrix, 16, g) + m(matrix, 17, b) + m(matrix, 18, a) + m(matrix, 19, 1);

          if (includeOpacity) {
            nr = ng = nb = 0;
            na *= a / 255;
          }

          imSet(srcData.data, x, y, width, height, 0, nr);
          imSet(srcData.data, x, y, width, height, 1, ng);
          imSet(srcData.data, x, y, width, height, 2, nb);
          imSet(srcData.data, x, y, width, height, 3, na);
        }
      }

      ctx.clearRect(0, 0, width, height);
      ctx.putImageData(srcData, 0, 0);
    }
  }]);

  return FeColorMatrixElement;
}(Element);

function _createSuper$E(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$E(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var MaskElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(MaskElement, _Element);

  var _super = _createSuper$E(MaskElement);

  function MaskElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, MaskElement);

    _this = _super.apply(this, arguments);
    _this.type = 'mask';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(MaskElement, [{
    key: "apply",
    value: function apply(ctx, element) {
      var document = this.document; // render as temp svg

      var x = this.getAttribute('x').getPixels('x');
      var y = this.getAttribute('y').getPixels('y');
      var width = this.getStyle('width').getPixels('x');
      var height = this.getStyle('height').getPixels('y');

      if (!width && !height) {
        var _context;

        var boundingBox = new BoundingBox();

        _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = this.children).call(_context, function (child) {
          boundingBox.addBoundingBox(child.getBoundingBox(ctx));
        });

        x = Math.floor(boundingBox.x1);
        y = Math.floor(boundingBox.y1);
        width = Math.floor(boundingBox.width);
        height = Math.floor(boundingBox.height);
      }

      var ignoredStyles = this.removeStyles(element, MaskElement.ignoreStyles);
      var maskCanvas = document.createCanvas(x + width, y + height);
      var maskCtx = maskCanvas.getContext('2d');
      document.screen.setDefaults(maskCtx);
      this.renderChildren(maskCtx); // convert mask to alpha with a fake node
      // TODO: refactor out apply from feColorMatrix

      new FeColorMatrixElement(document, {
        nodeType: 1,
        childNodes: [],
        attributes: [{
          nodeName: 'type',
          value: 'luminanceToAlpha'
        }, {
          nodeName: 'includeOpacity',
          value: 'true'
        }]
      }).apply(maskCtx, 0, 0, x + width, y + height);
      var tmpCanvas = document.createCanvas(x + width, y + height);
      var tmpCtx = tmpCanvas.getContext('2d');
      document.screen.setDefaults(tmpCtx);
      element.render(tmpCtx);
      tmpCtx.globalCompositeOperation = 'destination-in';
      tmpCtx.fillStyle = maskCtx.createPattern(maskCanvas, 'no-repeat');
      tmpCtx.fillRect(0, 0, x + width, y + height);
      ctx.fillStyle = tmpCtx.createPattern(tmpCanvas, 'no-repeat');
      ctx.fillRect(0, 0, x + width, y + height); // reassign mask

      this.restoreStyles(element, ignoredStyles);
    }
  }, {
    key: "render",
    value: function render(_) {// NO RENDER
    }
  }]);

  return MaskElement;
}(Element);
MaskElement.ignoreStyles = ['mask', 'transform', 'clip-path'];

function _createSuper$F(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$F(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var noop = function noop() {};

var ClipPathElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(ClipPathElement, _Element);

  var _super = _createSuper$F(ClipPathElement);

  function ClipPathElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, ClipPathElement);

    _this = _super.apply(this, arguments);
    _this.type = 'clipPath';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(ClipPathElement, [{
    key: "apply",
    value: function apply(ctx) {
      var _context;

      var document = this.document;

      var contextProto = _babel_runtime_corejs3_core_js_stable_reflect_get_prototype_of__WEBPACK_IMPORTED_MODULE_50___default()(ctx);

      var beginPath = ctx.beginPath,
          closePath = ctx.closePath;

      if (contextProto) {
        contextProto.beginPath = noop;
        contextProto.closePath = noop;
      }

      _babel_runtime_corejs3_core_js_stable_reflect_apply__WEBPACK_IMPORTED_MODULE_49___default()(beginPath, ctx, []);

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context = this.children).call(_context, function (child) {
        if (typeof child.path === 'undefined') {
          return;
        }

        var transform = typeof child.elementTransform !== 'undefined' ? child.elementTransform() : null; // handle <use />

        if (!transform) {
          transform = Transform.fromElement(document, child);
        }

        if (transform) {
          transform.apply(ctx);
        }

        child.path(ctx);

        if (contextProto) {
          contextProto.closePath = closePath;
        }

        if (transform) {
          transform.unapply(ctx);
        }
      });

      _babel_runtime_corejs3_core_js_stable_reflect_apply__WEBPACK_IMPORTED_MODULE_49___default()(closePath, ctx, []);

      ctx.clip();

      if (contextProto) {
        contextProto.beginPath = beginPath;
        contextProto.closePath = closePath;
      }
    }
  }, {
    key: "render",
    value: function render(_) {// NO RENDER
    }
  }]);

  return ClipPathElement;
}(Element);

function _createSuper$G(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$G(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FilterElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FilterElement, _Element);

  var _super = _createSuper$G(FilterElement);

  function FilterElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FilterElement);

    _this = _super.apply(this, arguments);
    _this.type = 'filter';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FilterElement, [{
    key: "apply",
    value: function apply(ctx, element) {
      // render as temp svg
      var document = this.document,
          children = this.children;
      var boundingBox = element.getBoundingBox(ctx);

      if (!boundingBox) {
        return;
      }

      var px = 0;
      var py = 0;

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(children).call(children, function (child) {
        var efd = child.extraFilterDistance || 0;
        px = Math.max(px, efd);
        py = Math.max(py, efd);
      });

      var width = Math.floor(boundingBox.width);
      var height = Math.floor(boundingBox.height);
      var tmpCanvasWidth = width + 2 * px;
      var tmpCanvasHeight = height + 2 * py;

      if (tmpCanvasWidth < 1 || tmpCanvasHeight < 1) {
        return;
      }

      var x = Math.floor(boundingBox.x);
      var y = Math.floor(boundingBox.y);
      var ignoredStyles = this.removeStyles(element, FilterElement.ignoreStyles);
      var tmpCanvas = document.createCanvas(tmpCanvasWidth, tmpCanvasHeight);
      var tmpCtx = tmpCanvas.getContext('2d');
      document.screen.setDefaults(tmpCtx);
      tmpCtx.translate(-x + px, -y + py);
      element.render(tmpCtx); // apply filters

      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(children).call(children, function (child) {
        if (typeof child.apply === 'function') {
          child.apply(tmpCtx, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
        }
      }); // render on me


      ctx.drawImage(tmpCanvas, 0, 0, tmpCanvasWidth, tmpCanvasHeight, x - px, y - py, tmpCanvasWidth, tmpCanvasHeight);
      this.restoreStyles(element, ignoredStyles);
    }
  }, {
    key: "render",
    value: function render(_) {// NO RENDER
    }
  }]);

  return FilterElement;
}(Element);
FilterElement.ignoreStyles = ['filter', 'transform', 'clip-path'];

function _createSuper$H(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$H(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$H() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FeDropShadowElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FeDropShadowElement, _Element);

  var _super = _createSuper$H(FeDropShadowElement);

  function FeDropShadowElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FeDropShadowElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'feDropShadow';

    _this.addStylesFromStyleDefinition();

    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FeDropShadowElement, [{
    key: "apply",
    value: function apply(_, __, ___, ____, _____) {// TODO: implement
    }
  }]);

  return FeDropShadowElement;
}(Element);

function _createSuper$I(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$I(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$I() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FeMorphologyElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FeMorphologyElement, _Element);

  var _super = _createSuper$I(FeMorphologyElement);

  function FeMorphologyElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FeMorphologyElement);

    _this = _super.apply(this, arguments);
    _this.type = 'feMorphology';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FeMorphologyElement, [{
    key: "apply",
    value: function apply(_, __, ___, ____, _____) {// TODO: implement
    }
  }]);

  return FeMorphologyElement;
}(Element);

function _createSuper$J(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$J(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$J() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FeCompositeElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FeCompositeElement, _Element);

  var _super = _createSuper$J(FeCompositeElement);

  function FeCompositeElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FeCompositeElement);

    _this = _super.apply(this, arguments);
    _this.type = 'feComposite';
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FeCompositeElement, [{
    key: "apply",
    value: function apply(_, __, ___, ____, _____) {// TODO: implement
    }
  }]);

  return FeCompositeElement;
}(Element);

function _createSuper$K(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$K(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$K() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var FeGaussianBlurElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(FeGaussianBlurElement, _Element);

  var _super = _createSuper$K(FeGaussianBlurElement);

  function FeGaussianBlurElement(document, node, captureTextNodes) {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, FeGaussianBlurElement);

    _this = _super.call(this, document, node, captureTextNodes);
    _this.type = 'feGaussianBlur';
    _this.blurRadius = Math.floor(_this.getAttribute('stdDeviation').getNumber());
    _this.extraFilterDistance = _this.blurRadius;
    return _this;
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(FeGaussianBlurElement, [{
    key: "apply",
    value: function apply(ctx, x, y, width, height) {
      var document = this.document,
          blurRadius = this.blurRadius;
      var body = document.window ? document.window.document.body : null;
      var canvas = ctx.canvas; // StackBlur requires canvas be on document

      canvas.id = document.getUniqueId();

      if (body) {
        canvas.style.display = 'none';
        body.appendChild(canvas);
      }

      (0,stackblur_canvas__WEBPACK_IMPORTED_MODULE_51__.canvasRGBA)(canvas, x, y, width, height, blurRadius);

      if (body) {
        body.removeChild(canvas);
      }
    }
  }]);

  return FeGaussianBlurElement;
}(Element);

function _createSuper$L(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$L(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$L() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var TitleElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(TitleElement, _Element);

  var _super = _createSuper$L(TitleElement);

  function TitleElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, TitleElement);

    _this = _super.apply(this, arguments);
    _this.type = 'title';
    return _this;
  }

  return TitleElement;
}(Element);

function _createSuper$M(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$M(); return function _createSuperInternal() { var Super = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_corejs3_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_29__.default)(this).constructor; result = _babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_corejs3_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_28__.default)(this, result); }; }

function _isNativeReflectConstruct$M() { if (typeof Reflect === "undefined" || !(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default())) return false; if ((_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default().sham)) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_babel_runtime_corejs3_core_js_stable_reflect_construct__WEBPACK_IMPORTED_MODULE_26___default()(Date, [], function () {})); return true; } catch (e) { return false; } }

var DescElement = /*#__PURE__*/function (_Element) {
  (0,_babel_runtime_corejs3_helpers_inherits__WEBPACK_IMPORTED_MODULE_27__.default)(DescElement, _Element);

  var _super = _createSuper$M(DescElement);

  function DescElement() {
    var _this;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, DescElement);

    _this = _super.apply(this, arguments);
    _this.type = 'desc';
    return _this;
  }

  return DescElement;
}(Element);

var elementTypes = {
  'svg': SVGElement,
  'rect': RectElement,
  'circle': CircleElement,
  'ellipse': EllipseElement,
  'line': LineElement,
  'polyline': PolylineElement,
  'polygon': PolygonElement,
  'path': PathElement,
  'pattern': PatternElement,
  'marker': MarkerElement,
  'defs': DefsElement,
  'linearGradient': LinearGradientElement,
  'radialGradient': RadialGradientElement,
  'stop': StopElement,
  'animate': AnimateElement,
  'animateColor': AnimateColorElement,
  'animateTransform': AnimateTransformElement,
  'font': FontElement,
  'font-face': FontFaceElement,
  'missing-glyph': MissingGlyphElement,
  'glyph': GlyphElement,
  'text': TextElement,
  'tspan': TSpanElement,
  'tref': TRefElement,
  'a': AElement,
  'textPath': TextPathElement,
  'image': ImageElement,
  'g': GElement,
  'symbol': SymbolElement,
  'style': StyleElement,
  'use': UseElement,
  'mask': MaskElement,
  'clipPath': ClipPathElement,
  'filter': FilterElement,
  'feDropShadow': FeDropShadowElement,
  'feMorphology': FeMorphologyElement,
  'feComposite': FeCompositeElement,
  'feColorMatrix': FeColorMatrixElement,
  'feGaussianBlur': FeGaussianBlurElement,
  'title': TitleElement,
  'desc': DescElement
};

function ownKeys$1(object, enumerableOnly) { var keys = _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_11___default()(object); if ((_babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default())) { var symbols = _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default()(object); if (enumerableOnly) symbols = _babel_runtime_corejs3_core_js_stable_instance_filter__WEBPACK_IMPORTED_MODULE_9___default()(symbols).call(symbols, function (sym) { return _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context5 = ownKeys$1(Object(source), true)).call(_context5, function (key) { (0,_babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__.default)(target, key, source[key]); }); } else if ((_babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default())) { _babel_runtime_corejs3_core_js_stable_object_define_properties__WEBPACK_IMPORTED_MODULE_5___default()(target, _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default()(source)); } else { var _context6; _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context6 = ownKeys$1(Object(source))).call(_context6, function (key) { _babel_runtime_corejs3_core_js_stable_object_define_property__WEBPACK_IMPORTED_MODULE_4___default()(target, key, _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default()(source, key)); }); } } return target; }

function createCanvas(width, height) {
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
}

function createImage(_x) {
  return _createImage.apply(this, arguments);
}

function _createImage() {
  _createImage = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee(src) {
    var anonymousCrossOrigin,
        image,
        _args = arguments;
    return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            anonymousCrossOrigin = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            image = document.createElement('img');

            if (anonymousCrossOrigin) {
              image.crossOrigin = 'Anonymous';
            }

            return _context7.abrupt("return", new (_babel_runtime_corejs3_core_js_stable_promise__WEBPACK_IMPORTED_MODULE_21___default())(function (resolve, reject) {
              image.onload = function () {
                resolve(image);
              };

              image.onerror = function () {
                reject();
              };

              image.src = src;
            }));

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee);
  }));
  return _createImage.apply(this, arguments);
}

var Document = /*#__PURE__*/function () {
  function Document(canvg) {
    var _context, _context2;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$rootEmSize = _ref.rootEmSize,
        rootEmSize = _ref$rootEmSize === void 0 ? 12 : _ref$rootEmSize,
        _ref$emSize = _ref.emSize,
        emSize = _ref$emSize === void 0 ? 12 : _ref$emSize,
        _ref$createCanvas = _ref.createCanvas,
        createCanvas = _ref$createCanvas === void 0 ? Document.createCanvas : _ref$createCanvas,
        _ref$createImage = _ref.createImage,
        createImage = _ref$createImage === void 0 ? Document.createImage : _ref$createImage,
        anonymousCrossOrigin = _ref.anonymousCrossOrigin;

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Document);

    this.canvg = canvg;
    this.definitions = {};
    this.styles = {};
    this.stylesSpecificity = {};
    this.images = [];
    this.fonts = [];
    this.emSizeStack = [];
    this.uniqueId = 0;
    this.screen = canvg.screen;
    this.rootEmSize = rootEmSize;
    this.emSize = emSize;
    this.createCanvas = createCanvas;
    this.createImage = this.bindCreateImage(createImage, anonymousCrossOrigin);
    this.screen.wait(_babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22___default()(_context = this.isImagesLoaded).call(_context, this));
    this.screen.wait(_babel_runtime_corejs3_core_js_stable_instance_bind__WEBPACK_IMPORTED_MODULE_22___default()(_context2 = this.isFontsLoaded).call(_context2, this));
  }

  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Document, [{
    key: "bindCreateImage",
    value: function bindCreateImage(createImage, anonymousCrossOrigin) {
      if (typeof anonymousCrossOrigin === 'boolean') {
        return function (source, forceAnonymousCrossOrigin) {
          return createImage(source, typeof forceAnonymousCrossOrigin === 'boolean' ? forceAnonymousCrossOrigin : anonymousCrossOrigin);
        };
      }

      return createImage;
    }
  }, {
    key: "popEmSize",
    value: function popEmSize() {
      var emSizeStack = this.emSizeStack;
      emSizeStack.pop();
    }
  }, {
    key: "getUniqueId",
    value: function getUniqueId() {
      return "canvg".concat(++this.uniqueId);
    }
  }, {
    key: "isImagesLoaded",
    value: function isImagesLoaded() {
      var _context3;

      return _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20___default()(_context3 = this.images).call(_context3, function (_) {
        return _.loaded;
      });
    }
  }, {
    key: "isFontsLoaded",
    value: function isFontsLoaded() {
      var _context4;

      return _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_20___default()(_context4 = this.fonts).call(_context4, function (_) {
        return _.loaded;
      });
    }
  }, {
    key: "createDocumentElement",
    value: function createDocumentElement(document) {
      var documentElement = this.createElement(document.documentElement);
      documentElement.root = true;
      documentElement.addStylesFromStyleDefinition();
      this.documentElement = documentElement;
      return documentElement;
    }
  }, {
    key: "createElement",
    value: function createElement(node) {
      var elementType = node.nodeName.replace(/^[^:]+:/, '');
      var ElementType = Document.elementTypes[elementType];

      if (typeof ElementType !== 'undefined') {
        return new ElementType(this, node);
      }

      return new UnknownElement(this, node);
    }
  }, {
    key: "createTextNode",
    value: function createTextNode(node) {
      return new TextNode(this, node);
    }
  }, {
    key: "setViewBox",
    value: function setViewBox(config) {
      this.screen.setViewBox(_objectSpread$1({
        document: this
      }, config));
    }
  }, {
    key: "window",
    get: function get() {
      return this.screen.window;
    }
  }, {
    key: "fetch",
    get: function get() {
      return this.screen.fetch;
    }
  }, {
    key: "ctx",
    get: function get() {
      return this.screen.ctx;
    }
  }, {
    key: "emSize",
    get: function get() {
      var emSizeStack = this.emSizeStack;
      return emSizeStack[emSizeStack.length - 1];
    },
    set: function set(value) {
      var emSizeStack = this.emSizeStack;
      emSizeStack.push(value);
    }
  }]);

  return Document;
}();
Document.createCanvas = createCanvas;
Document.createImage = createImage;
Document.elementTypes = elementTypes;

function ownKeys$2(object, enumerableOnly) { var keys = _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_11___default()(object); if ((_babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default())) { var symbols = _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_10___default()(object); if (enumerableOnly) symbols = _babel_runtime_corejs3_core_js_stable_instance_filter__WEBPACK_IMPORTED_MODULE_9___default()(symbols).call(symbols, function (sym) { return _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context3 = ownKeys$2(Object(source), true)).call(_context3, function (key) { (0,_babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__.default)(target, key, source[key]); }); } else if ((_babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default())) { _babel_runtime_corejs3_core_js_stable_object_define_properties__WEBPACK_IMPORTED_MODULE_5___default()(target, _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default()(source)); } else { var _context4; _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_7___default()(_context4 = ownKeys$2(Object(source))).call(_context4, function (key) { _babel_runtime_corejs3_core_js_stable_object_define_property__WEBPACK_IMPORTED_MODULE_4___default()(target, key, _babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default()(source, key)); }); } } return target; }
/**
 * SVG renderer on canvas.
 */

var Canvg = /*#__PURE__*/function () {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  function Canvg(ctx, svg) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    (0,_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__.default)(this, Canvg);

    this.parser = new Parser(options);
    this.screen = new Screen(ctx, options);
    this.options = options;
    var document = new Document(this, options);
    var documentElement = document.createDocumentElement(svg);
    this.document = document;
    this.documentElement = documentElement;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   */


  (0,_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__.default)(Canvg, [{
    key: "fork",

    /**
     * Create new Canvg instance with inherited options.
     * @param ctx - Rendering context.
     * @param svg - SVG source string or URL.
     * @param options - Rendering options.
     */
    value: function fork(ctx, svg) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return Canvg.from(ctx, svg, _objectSpread$2(_objectSpread$2({}, this.options), options));
    }
    /**
     * Create new Canvg instance with inherited options.
     * @param ctx - Rendering context.
     * @param svg - SVG source string.
     * @param options - Rendering options.
     */

  }, {
    key: "forkString",
    value: function forkString(ctx, svg) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return Canvg.fromString(ctx, svg, _objectSpread$2(_objectSpread$2({}, this.options), options));
    }
    /**
     * Document is ready promise.
     */

  }, {
    key: "ready",
    value: function ready() {
      return this.screen.ready();
    }
    /**
     * Document is ready value.
     */

  }, {
    key: "isReady",
    value: function isReady() {
      return this.screen.isReady();
    }
    /**
     * Render only first frame, ignoring animations and mouse.
     * @param options - Rendering options.
     */

  }, {
    key: "render",
    value: function () {
      var _render = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee() {
        var options,
            _args = arguments;
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                this.start(_objectSpread$2({
                  enableRedraw: true,
                  ignoreAnimation: true,
                  ignoreMouse: true
                }, options));
                _context.next = 4;
                return this.ready();

              case 4:
                this.stop();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render() {
        return _render.apply(this, arguments);
      }

      return render;
    }()
    /**
     * Start rendering.
     * @param options - Render options.
     */

  }, {
    key: "start",
    value: function start() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var documentElement = this.documentElement,
          screen = this.screen,
          baseOptions = this.options;
      screen.start(documentElement, _objectSpread$2(_objectSpread$2({
        enableRedraw: true
      }, baseOptions), options));
    }
    /**
     * Stop rendering.
     */

  }, {
    key: "stop",
    value: function stop() {
      this.screen.stop();
    }
    /**
     * Resize SVG to fit in given size.
     * @param width
     * @param height
     * @param preserveAspectRatio
     */

  }, {
    key: "resize",
    value: function resize(width) {
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
      var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.documentElement.resize(width, height, preserveAspectRatio);
    }
  }], [{
    key: "from",
    value: function () {
      var _from = (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee2(ctx, svg) {
        var options,
            parser,
            svgDocument,
            _args2 = arguments;
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                parser = new Parser(options);
                _context2.next = 4;
                return parser.parse(svg);

              case 4:
                svgDocument = _context2.sent;
                return _context2.abrupt("return", new Canvg(ctx, svgDocument, options));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function from(_x, _x2) {
        return _from.apply(this, arguments);
      }

      return from;
    }()
    /**
     * Create Canvg instance from SVG source string.
     * @param ctx - Rendering context.
     * @param svg - SVG source string.
     * @param options - Rendering options.
     */

  }, {
    key: "fromString",
    value: function fromString(ctx, svg) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var parser = new Parser(options);
      var svgDocument = parser.parseFromString(svg);
      return new Canvg(ctx, svgDocument, options);
    }
  }]);

  return Canvg;
}();

/**
 * Options preset for `OffscreenCanvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 */
function offscreen() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      DOMParserFallback = _ref.DOMParser;

  var preset = {
    window: null,
    ignoreAnimation: true,
    ignoreMouse: true,
    DOMParser: DOMParserFallback,
    createCanvas: function createCanvas(width, height) {
      return new OffscreenCanvas(width, height);
    },
    createImage: function createImage(url) {
      return (0,_babel_runtime_corejs3_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__.default)( /*#__PURE__*/_babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().mark(function _callee() {
        var response, blob, img;
        return _babel_runtime_corejs3_regenerator__WEBPACK_IMPORTED_MODULE_12___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(url);

              case 2:
                response = _context.sent;
                _context.next = 5;
                return response.blob();

              case 5:
                blob = _context.sent;
                _context.next = 8;
                return createImageBitmap(blob);

              case 8:
                img = _context.sent;
                return _context.abrupt("return", img);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };

  if (typeof DOMParser !== 'undefined' || typeof DOMParserFallback === 'undefined') {
    _babel_runtime_corejs3_core_js_stable_reflect_delete_property__WEBPACK_IMPORTED_MODULE_39___default()(preset, 'DOMParser');
  }

  return preset;
}

/**
 * Options preset for `node-canvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @param config.canvas - `node-canvas` exports.
 * @param config.fetch - WHATWG-compatible `fetch` function.
 */
function node(_ref) {
  var DOMParser = _ref.DOMParser,
      canvas = _ref.canvas,
      fetch = _ref.fetch;
  return {
    window: null,
    ignoreAnimation: true,
    ignoreMouse: true,
    DOMParser: DOMParser,
    fetch: fetch,
    createCanvas: canvas.createCanvas,
    createImage: canvas.loadImage
  };
}

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	offscreen: offscreen,
	node: node
});

/* harmony default export */ __webpack_exports__["default"] = (Canvg);




/***/ }),

/***/ "./node_modules/core-js-pure/es/array/from.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/from.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.string.iterator */ "./node_modules/core-js-pure/modules/es.string.iterator.js");
__webpack_require__(/*! ../../modules/es.array.from */ "./node_modules/core-js-pure/modules/es.array.from.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Array.from;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/is-array.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/is-array.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.array.is-array */ "./node_modules/core-js-pure/modules/es.array.is-array.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Array.isArray;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/concat.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/concat.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.concat */ "./node_modules/core-js-pure/modules/es.array.concat.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').concat;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/every.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/every.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.every */ "./node_modules/core-js-pure/modules/es.array.every.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').every;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/fill.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/fill.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.fill */ "./node_modules/core-js-pure/modules/es.array.fill.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').fill;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/filter.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/filter.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.filter */ "./node_modules/core-js-pure/modules/es.array.filter.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').filter;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/for-each.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/for-each.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.for-each */ "./node_modules/core-js-pure/modules/es.array.for-each.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').forEach;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/includes.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/includes.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.includes */ "./node_modules/core-js-pure/modules/es.array.includes.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').includes;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/index-of.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/index-of.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.index-of */ "./node_modules/core-js-pure/modules/es.array.index-of.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').indexOf;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/map.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/map.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.map */ "./node_modules/core-js-pure/modules/es.array.map.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').map;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/reduce.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/reduce.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.reduce */ "./node_modules/core-js-pure/modules/es.array.reduce.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').reduce;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/reverse.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/reverse.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.reverse */ "./node_modules/core-js-pure/modules/es.array.reverse.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').reverse;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/slice.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/slice.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.slice */ "./node_modules/core-js-pure/modules/es.array.slice.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').slice;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/some.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/some.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.some */ "./node_modules/core-js-pure/modules/es.array.some.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').some;


/***/ }),

/***/ "./node_modules/core-js-pure/es/array/virtual/values.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/es/array/virtual/values.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.array.iterator */ "./node_modules/core-js-pure/modules/es.array.iterator.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Array').values;


/***/ }),

/***/ "./node_modules/core-js-pure/es/date/now.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js-pure/es/date/now.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.date.now */ "./node_modules/core-js-pure/modules/es.date.now.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Date.now;


/***/ }),

/***/ "./node_modules/core-js-pure/es/function/virtual/bind.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/es/function/virtual/bind.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.function.bind */ "./node_modules/core-js-pure/modules/es.function.bind.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('Function').bind;


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/bind.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/bind.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(/*! ../function/virtual/bind */ "./node_modules/core-js-pure/es/function/virtual/bind.js");

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/concat.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/concat.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var concat = __webpack_require__(/*! ../array/virtual/concat */ "./node_modules/core-js-pure/es/array/virtual/concat.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.concat) ? concat : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/every.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/every.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var every = __webpack_require__(/*! ../array/virtual/every */ "./node_modules/core-js-pure/es/array/virtual/every.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.every;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.every) ? every : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/fill.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/fill.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fill = __webpack_require__(/*! ../array/virtual/fill */ "./node_modules/core-js-pure/es/array/virtual/fill.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.fill;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.fill) ? fill : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/filter.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/filter.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var filter = __webpack_require__(/*! ../array/virtual/filter */ "./node_modules/core-js-pure/es/array/virtual/filter.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.filter) ? filter : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/includes.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/includes.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayIncludes = __webpack_require__(/*! ../array/virtual/includes */ "./node_modules/core-js-pure/es/array/virtual/includes.js");
var stringIncludes = __webpack_require__(/*! ../string/virtual/includes */ "./node_modules/core-js-pure/es/string/virtual/includes.js");

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.includes)) return arrayIncludes;
  if (typeof it === 'string' || it === StringPrototype || (it instanceof String && own === StringPrototype.includes)) {
    return stringIncludes;
  } return own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/index-of.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/index-of.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var indexOf = __webpack_require__(/*! ../array/virtual/index-of */ "./node_modules/core-js-pure/es/array/virtual/index-of.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.indexOf) ? indexOf : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/map.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/map.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = __webpack_require__(/*! ../array/virtual/map */ "./node_modules/core-js-pure/es/array/virtual/map.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.map) ? map : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/reduce.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/reduce.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reduce = __webpack_require__(/*! ../array/virtual/reduce */ "./node_modules/core-js-pure/es/array/virtual/reduce.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reduce) ? reduce : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/reverse.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/reverse.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reverse = __webpack_require__(/*! ../array/virtual/reverse */ "./node_modules/core-js-pure/es/array/virtual/reverse.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reverse;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.reverse) ? reverse : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/slice.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/slice.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var slice = __webpack_require__(/*! ../array/virtual/slice */ "./node_modules/core-js-pure/es/array/virtual/slice.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.slice) ? slice : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/some.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/some.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var some = __webpack_require__(/*! ../array/virtual/some */ "./node_modules/core-js-pure/es/array/virtual/some.js");

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.some;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.some) ? some : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/starts-with.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/starts-with.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startsWith = __webpack_require__(/*! ../string/virtual/starts-with */ "./node_modules/core-js-pure/es/string/virtual/starts-with.js");

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.startsWith;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.startsWith) ? startsWith : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/instance/trim.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/instance/trim.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trim = __webpack_require__(/*! ../string/virtual/trim */ "./node_modules/core-js-pure/es/string/virtual/trim.js");

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.trim) ? trim : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/map/index.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js-pure/es/map/index.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.map */ "./node_modules/core-js-pure/modules/es.map.js");
__webpack_require__(/*! ../../modules/es.object.to-string */ "./node_modules/core-js-pure/modules/es.object.to-string.js");
__webpack_require__(/*! ../../modules/es.string.iterator */ "./node_modules/core-js-pure/modules/es.string.iterator.js");
__webpack_require__(/*! ../../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Map;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/create.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/create.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.create */ "./node_modules/core-js-pure/modules/es.object.create.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/define-properties.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/define-properties.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.define-properties */ "./node_modules/core-js-pure/modules/es.object.define-properties.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

var Object = path.Object;

var defineProperties = module.exports = function defineProperties(T, D) {
  return Object.defineProperties(T, D);
};

if (Object.defineProperties.sham) defineProperties.sham = true;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/define-property.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/define-property.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.define-property */ "./node_modules/core-js-pure/modules/es.object.define-property.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/get-own-property-descriptor.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/get-own-property-descriptor.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.get-own-property-descriptor */ "./node_modules/core-js-pure/modules/es.object.get-own-property-descriptor.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/get-own-property-descriptors.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/get-own-property-descriptors.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.get-own-property-descriptors */ "./node_modules/core-js-pure/modules/es.object.get-own-property-descriptors.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Object.getOwnPropertyDescriptors;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/get-own-property-symbols.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/get-own-property-symbols.js ***!
  \*************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.symbol */ "./node_modules/core-js-pure/modules/es.symbol.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/get-prototype-of.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/get-prototype-of.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.get-prototype-of */ "./node_modules/core-js-pure/modules/es.object.get-prototype-of.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Object.getPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/keys.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/keys.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.keys */ "./node_modules/core-js-pure/modules/es.object.keys.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Object.keys;


/***/ }),

/***/ "./node_modules/core-js-pure/es/object/set-prototype-of.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/object/set-prototype-of.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.object.set-prototype-of */ "./node_modules/core-js-pure/modules/es.object.set-prototype-of.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Object.setPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js-pure/es/parse-float.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/es/parse-float.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../modules/es.parse-float */ "./node_modules/core-js-pure/modules/es.parse-float.js");
var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.parseFloat;


/***/ }),

/***/ "./node_modules/core-js-pure/es/parse-int.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js-pure/es/parse-int.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../modules/es.parse-int */ "./node_modules/core-js-pure/modules/es.parse-int.js");
var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.parseInt;


/***/ }),

/***/ "./node_modules/core-js-pure/es/promise/index.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/promise/index.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.aggregate-error */ "./node_modules/core-js-pure/modules/es.aggregate-error.js");
__webpack_require__(/*! ../../modules/es.object.to-string */ "./node_modules/core-js-pure/modules/es.object.to-string.js");
__webpack_require__(/*! ../../modules/es.promise */ "./node_modules/core-js-pure/modules/es.promise.js");
__webpack_require__(/*! ../../modules/es.promise.all-settled */ "./node_modules/core-js-pure/modules/es.promise.all-settled.js");
__webpack_require__(/*! ../../modules/es.promise.any */ "./node_modules/core-js-pure/modules/es.promise.any.js");
__webpack_require__(/*! ../../modules/es.promise.finally */ "./node_modules/core-js-pure/modules/es.promise.finally.js");
__webpack_require__(/*! ../../modules/es.string.iterator */ "./node_modules/core-js-pure/modules/es.string.iterator.js");
__webpack_require__(/*! ../../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Promise;


/***/ }),

/***/ "./node_modules/core-js-pure/es/reflect/apply.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/es/reflect/apply.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.reflect.apply */ "./node_modules/core-js-pure/modules/es.reflect.apply.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Reflect.apply;


/***/ }),

/***/ "./node_modules/core-js-pure/es/reflect/construct.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/es/reflect/construct.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.reflect.construct */ "./node_modules/core-js-pure/modules/es.reflect.construct.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Reflect.construct;


/***/ }),

/***/ "./node_modules/core-js-pure/es/reflect/delete-property.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/reflect/delete-property.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.reflect.delete-property */ "./node_modules/core-js-pure/modules/es.reflect.delete-property.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Reflect.deleteProperty;


/***/ }),

/***/ "./node_modules/core-js-pure/es/reflect/get-prototype-of.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/es/reflect/get-prototype-of.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.reflect.get-prototype-of */ "./node_modules/core-js-pure/modules/es.reflect.get-prototype-of.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Reflect.getPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js-pure/es/reflect/get.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/es/reflect/get.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.reflect.get */ "./node_modules/core-js-pure/modules/es.reflect.get.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Reflect.get;


/***/ }),

/***/ "./node_modules/core-js-pure/es/string/virtual/includes.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/es/string/virtual/includes.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.string.includes */ "./node_modules/core-js-pure/modules/es.string.includes.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('String').includes;


/***/ }),

/***/ "./node_modules/core-js-pure/es/string/virtual/starts-with.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/es/string/virtual/starts-with.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.string.starts-with */ "./node_modules/core-js-pure/modules/es.string.starts-with.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('String').startsWith;


/***/ }),

/***/ "./node_modules/core-js-pure/es/string/virtual/trim.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/es/string/virtual/trim.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../../modules/es.string.trim */ "./node_modules/core-js-pure/modules/es.string.trim.js");
var entryVirtual = __webpack_require__(/*! ../../../internals/entry-virtual */ "./node_modules/core-js-pure/internals/entry-virtual.js");

module.exports = entryVirtual('String').trim;


/***/ }),

/***/ "./node_modules/core-js-pure/es/symbol/index.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js-pure/es/symbol/index.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.array.concat */ "./node_modules/core-js-pure/modules/es.array.concat.js");
__webpack_require__(/*! ../../modules/es.object.to-string */ "./node_modules/core-js-pure/modules/es.object.to-string.js");
__webpack_require__(/*! ../../modules/es.symbol */ "./node_modules/core-js-pure/modules/es.symbol.js");
__webpack_require__(/*! ../../modules/es.symbol.async-iterator */ "./node_modules/core-js-pure/modules/es.symbol.async-iterator.js");
__webpack_require__(/*! ../../modules/es.symbol.description */ "./node_modules/core-js-pure/modules/es.symbol.description.js");
__webpack_require__(/*! ../../modules/es.symbol.has-instance */ "./node_modules/core-js-pure/modules/es.symbol.has-instance.js");
__webpack_require__(/*! ../../modules/es.symbol.is-concat-spreadable */ "./node_modules/core-js-pure/modules/es.symbol.is-concat-spreadable.js");
__webpack_require__(/*! ../../modules/es.symbol.iterator */ "./node_modules/core-js-pure/modules/es.symbol.iterator.js");
__webpack_require__(/*! ../../modules/es.symbol.match */ "./node_modules/core-js-pure/modules/es.symbol.match.js");
__webpack_require__(/*! ../../modules/es.symbol.match-all */ "./node_modules/core-js-pure/modules/es.symbol.match-all.js");
__webpack_require__(/*! ../../modules/es.symbol.replace */ "./node_modules/core-js-pure/modules/es.symbol.replace.js");
__webpack_require__(/*! ../../modules/es.symbol.search */ "./node_modules/core-js-pure/modules/es.symbol.search.js");
__webpack_require__(/*! ../../modules/es.symbol.species */ "./node_modules/core-js-pure/modules/es.symbol.species.js");
__webpack_require__(/*! ../../modules/es.symbol.split */ "./node_modules/core-js-pure/modules/es.symbol.split.js");
__webpack_require__(/*! ../../modules/es.symbol.to-primitive */ "./node_modules/core-js-pure/modules/es.symbol.to-primitive.js");
__webpack_require__(/*! ../../modules/es.symbol.to-string-tag */ "./node_modules/core-js-pure/modules/es.symbol.to-string-tag.js");
__webpack_require__(/*! ../../modules/es.symbol.unscopables */ "./node_modules/core-js-pure/modules/es.symbol.unscopables.js");
__webpack_require__(/*! ../../modules/es.json.to-string-tag */ "./node_modules/core-js-pure/modules/es.json.to-string-tag.js");
__webpack_require__(/*! ../../modules/es.math.to-string-tag */ "./node_modules/core-js-pure/modules/es.math.to-string-tag.js");
__webpack_require__(/*! ../../modules/es.reflect.to-string-tag */ "./node_modules/core-js-pure/modules/es.reflect.to-string-tag.js");
var path = __webpack_require__(/*! ../../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = path.Symbol;


/***/ }),

/***/ "./node_modules/core-js-pure/es/symbol/iterator.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/es/symbol/iterator.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es.symbol.iterator */ "./node_modules/core-js-pure/modules/es.symbol.iterator.js");
__webpack_require__(/*! ../../modules/es.string.iterator */ "./node_modules/core-js-pure/modules/es.string.iterator.js");
__webpack_require__(/*! ../../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
var WrappedWellKnownSymbolModule = __webpack_require__(/*! ../../internals/well-known-symbol-wrapped */ "./node_modules/core-js-pure/internals/well-known-symbol-wrapped.js");

module.exports = WrappedWellKnownSymbolModule.f('iterator');


/***/ }),

/***/ "./node_modules/core-js-pure/features/array/from.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/features/array/from.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/array/from */ "./node_modules/core-js-pure/es/array/from.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/array/is-array.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/features/array/is-array.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/array/is-array */ "./node_modules/core-js-pure/es/array/is-array.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/get-iterator-method.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/features/get-iterator-method.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
__webpack_require__(/*! ../modules/es.string.iterator */ "./node_modules/core-js-pure/modules/es.string.iterator.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js-pure/internals/get-iterator-method.js");

module.exports = getIteratorMethod;


/***/ }),

/***/ "./node_modules/core-js-pure/features/get-iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/features/get-iterator.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
__webpack_require__(/*! ../modules/es.string.iterator */ "./node_modules/core-js-pure/modules/es.string.iterator.js");
var getIterator = __webpack_require__(/*! ../internals/get-iterator */ "./node_modules/core-js-pure/internals/get-iterator.js");

module.exports = getIterator;


/***/ }),

/***/ "./node_modules/core-js-pure/features/instance/slice.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/features/instance/slice.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/slice */ "./node_modules/core-js-pure/es/instance/slice.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/object/create.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/features/object/create.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/create */ "./node_modules/core-js-pure/es/object/create.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/object/define-property.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js-pure/features/object/define-property.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/define-property */ "./node_modules/core-js-pure/es/object/define-property.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/object/get-own-property-descriptor.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/core-js-pure/features/object/get-own-property-descriptor.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/get-own-property-descriptor */ "./node_modules/core-js-pure/es/object/get-own-property-descriptor.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/object/get-prototype-of.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/features/object/get-prototype-of.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/get-prototype-of */ "./node_modules/core-js-pure/es/object/get-prototype-of.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/object/set-prototype-of.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/features/object/set-prototype-of.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/set-prototype-of */ "./node_modules/core-js-pure/es/object/set-prototype-of.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/promise/index.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/features/promise/index.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/promise */ "./node_modules/core-js-pure/es/promise/index.js");
__webpack_require__(/*! ../../modules/esnext.aggregate-error */ "./node_modules/core-js-pure/modules/esnext.aggregate-error.js");
// TODO: Remove from `core-js@4`
__webpack_require__(/*! ../../modules/esnext.promise.all-settled */ "./node_modules/core-js-pure/modules/esnext.promise.all-settled.js");
__webpack_require__(/*! ../../modules/esnext.promise.try */ "./node_modules/core-js-pure/modules/esnext.promise.try.js");
__webpack_require__(/*! ../../modules/esnext.promise.any */ "./node_modules/core-js-pure/modules/esnext.promise.any.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/reflect/get.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/features/reflect/get.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/reflect/get */ "./node_modules/core-js-pure/es/reflect/get.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/symbol/index.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/features/symbol/index.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/symbol */ "./node_modules/core-js-pure/es/symbol/index.js");
__webpack_require__(/*! ../../modules/esnext.symbol.async-dispose */ "./node_modules/core-js-pure/modules/esnext.symbol.async-dispose.js");
__webpack_require__(/*! ../../modules/esnext.symbol.dispose */ "./node_modules/core-js-pure/modules/esnext.symbol.dispose.js");
__webpack_require__(/*! ../../modules/esnext.symbol.matcher */ "./node_modules/core-js-pure/modules/esnext.symbol.matcher.js");
__webpack_require__(/*! ../../modules/esnext.symbol.metadata */ "./node_modules/core-js-pure/modules/esnext.symbol.metadata.js");
__webpack_require__(/*! ../../modules/esnext.symbol.observable */ "./node_modules/core-js-pure/modules/esnext.symbol.observable.js");
// TODO: Remove from `core-js@4`
__webpack_require__(/*! ../../modules/esnext.symbol.pattern-match */ "./node_modules/core-js-pure/modules/esnext.symbol.pattern-match.js");
// TODO: Remove from `core-js@4`
__webpack_require__(/*! ../../modules/esnext.symbol.replace-all */ "./node_modules/core-js-pure/modules/esnext.symbol.replace-all.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/features/symbol/iterator.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/features/symbol/iterator.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/symbol/iterator */ "./node_modules/core-js-pure/es/symbol/iterator.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/a-function.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/a-function.js ***!
  \***********************************************************/
/***/ (function(module) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/a-possible-prototype.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/a-possible-prototype.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/add-to-unscopables.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/add-to-unscopables.js ***!
  \*******************************************************************/
/***/ (function(module) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js-pure/internals/an-instance.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/an-instance.js ***!
  \************************************************************/
/***/ (function(module) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/an-object.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/an-object.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-fill.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-fill.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js-pure/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-for-each.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-for-each.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").forEach;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js-pure/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-from.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-from.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js-pure/internals/function-bind-context.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var callWithSafeIterationClosing = __webpack_require__(/*! ../internals/call-with-safe-iteration-closing */ "./node_modules/core-js-pure/internals/call-with-safe-iteration-closing.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js-pure/internals/is-array-iterator-method.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js-pure/internals/create-property.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js-pure/internals/get-iterator-method.js");

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-includes.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-includes.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js-pure/internals/to-absolute-index.js");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-iteration.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-iteration.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js-pure/internals/function-bind-context.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js-pure/internals/indexed-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js-pure/internals/array-species-create.js");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-method-has-species-support.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-method-has-species-support.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js-pure/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-method-is-strict.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-method-is-strict.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-reduce.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-reduce.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js-pure/internals/indexed-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/array-species-create.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-species-create.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js-pure/internals/is-array.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/call-with-safe-iteration-closing.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/call-with-safe-iteration-closing.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js-pure/internals/iterator-close.js");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/check-correctness-of-iteration.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/check-correctness-of-iteration.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/classof-raw.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/classof-raw.js ***!
  \************************************************************/
/***/ (function(module) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/classof.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/classof.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js-pure/internals/to-string-tag-support.js");
var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js-pure/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/collection-strong.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/collection-strong.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js").f;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js-pure/internals/object-create.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js-pure/internals/redefine-all.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js-pure/internals/function-bind-context.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js-pure/internals/an-instance.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js-pure/internals/iterate.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js-pure/internals/define-iterator.js");
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js-pure/internals/set-species.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var fastKey = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js-pure/internals/internal-metadata.js").fastKey;
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js-pure/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/collection.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/collection.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ./export */ "./node_modules/core-js-pure/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var InternalMetadataModule = __webpack_require__(/*! ../internals/internal-metadata */ "./node_modules/core-js-pure/internals/internal-metadata.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js-pure/internals/iterate.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js-pure/internals/an-instance.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js-pure/internals/set-to-string-tag.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js").f;
var forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").forEach;
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js-pure/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;

  if (!DESCRIPTORS || typeof NativeConstructor != 'function'
    || !(IS_WEAK || NativePrototype.forEach && !fails(function () { new NativeConstructor().entries().next(); }))
  ) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (iterable != undefined) iterate(iterable, target[ADDER], { that: target, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
        createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });

    IS_WEAK || defineProperty(Constructor.prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).collection.size;
      }
    });
  }

  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: true }, exported);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/correct-is-regexp-logic.js":
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/correct-is-regexp-logic.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/correct-prototype-getter.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/correct-prototype-getter.js ***!
  \*************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "./node_modules/core-js-pure/internals/create-iterator-constructor.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/create-iterator-constructor.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js-pure/internals/iterators-core.js").IteratorPrototype;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js-pure/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js-pure/internals/create-property-descriptor.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js-pure/internals/set-to-string-tag.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js-pure/internals/iterators.js");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/create-non-enumerable-property.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js-pure/internals/create-property-descriptor.js");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/create-property-descriptor.js":
/*!***************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/create-property-descriptor.js ***!
  \***************************************************************************/
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/create-property.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/create-property.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js-pure/internals/to-primitive.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js-pure/internals/create-property-descriptor.js");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/define-iterator.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/define-iterator.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js-pure/internals/create-iterator-constructor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js-pure/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js-pure/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js-pure/internals/set-to-string-tag.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js-pure/internals/redefine.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js-pure/internals/iterators.js");
var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js-pure/internals/iterators-core.js");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/define-well-known-symbol.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/define-well-known-symbol.js ***!
  \*************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js-pure/internals/path.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js-pure/internals/well-known-symbol-wrapped.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/descriptors.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/descriptors.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "./node_modules/core-js-pure/internals/document-create-element.js":
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/document-create-element.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/dom-iterables.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/dom-iterables.js ***!
  \**************************************************************/
/***/ (function(module) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/engine-is-browser.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/engine-is-browser.js ***!
  \******************************************************************/
/***/ (function(module) {

module.exports = typeof window == 'object';


/***/ }),

/***/ "./node_modules/core-js-pure/internals/engine-is-ios.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/engine-is-ios.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js-pure/internals/engine-user-agent.js");

module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "./node_modules/core-js-pure/internals/engine-is-node.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/engine-is-node.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js-pure/internals/classof-raw.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "./node_modules/core-js-pure/internals/engine-is-webos-webkit.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/engine-is-webos-webkit.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js-pure/internals/engine-user-agent.js");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "./node_modules/core-js-pure/internals/engine-user-agent.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/engine-user-agent.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "./node_modules/core-js-pure/internals/engine-v8-version.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/engine-v8-version.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js-pure/internals/engine-user-agent.js");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/entry-virtual.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/entry-virtual.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js-pure/internals/path.js");

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/enum-bug-keys.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/enum-bug-keys.js ***!
  \**************************************************************/
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "./node_modules/core-js-pure/internals/export.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/export.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js").f;
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js-pure/internals/is-forced.js");
var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js-pure/internals/path.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js-pure/internals/function-bind-context.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/fails.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/fails.js ***!
  \******************************************************/
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/freezing.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/freezing.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "./node_modules/core-js-pure/internals/function-bind-context.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/function-bind-context.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/function-bind.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/function-bind.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/get-built-in.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/get-built-in.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js-pure/internals/path.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/get-iterator-method.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/get-iterator-method.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js-pure/internals/classof.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js-pure/internals/iterators.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/get-iterator.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/get-iterator.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js-pure/internals/get-iterator-method.js");

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/global.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/global.js ***!
  \*******************************************************/
/***/ (function(module) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ "./node_modules/core-js-pure/internals/has.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/has.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/hidden-keys.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/hidden-keys.js ***!
  \************************************************************/
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/host-report-errors.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/host-report-errors.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/html.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/html.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "./node_modules/core-js-pure/internals/ie8-dom-define.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/ie8-dom-define.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js-pure/internals/document-create-element.js");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js-pure/internals/indexed-object.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/indexed-object.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js-pure/internals/classof-raw.js");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/inspect-source.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/inspect-source.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js-pure/internals/shared-store.js");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/internal-metadata.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/internal-metadata.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js-pure/internals/hidden-keys.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js").f;
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js-pure/internals/uid.js");
var FREEZING = __webpack_require__(/*! ../internals/freezing */ "./node_modules/core-js-pure/internals/freezing.js");

var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/internal-state.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/internal-state.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js-pure/internals/native-weak-map.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var objectHas = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var shared = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js-pure/internals/shared-store.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js-pure/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js-pure/internals/hidden-keys.js");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/is-array-iterator-method.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-array-iterator-method.js ***!
  \*************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js-pure/internals/iterators.js");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/is-array.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-array.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js-pure/internals/classof-raw.js");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/is-forced.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-forced.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/is-object.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-object.js ***!
  \**********************************************************/
/***/ (function(module) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/is-pure.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-pure.js ***!
  \********************************************************/
/***/ (function(module) {

module.exports = true;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/is-regexp.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-regexp.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js-pure/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/iterate.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterate.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var isArrayIteratorMethod = __webpack_require__(/*! ../internals/is-array-iterator-method */ "./node_modules/core-js-pure/internals/is-array-iterator-method.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js-pure/internals/function-bind-context.js");
var getIteratorMethod = __webpack_require__(/*! ../internals/get-iterator-method */ "./node_modules/core-js-pure/internals/get-iterator-method.js");
var iteratorClose = __webpack_require__(/*! ../internals/iterator-close */ "./node_modules/core-js-pure/internals/iterator-close.js");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/iterator-close.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterator-close.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/iterators-core.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterators-core.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js-pure/internals/object-get-prototype-of.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/iterators.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterators.js ***!
  \**********************************************************/
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/microtask.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/microtask.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js").f;
var macrotask = __webpack_require__(/*! ../internals/task */ "./node_modules/core-js-pure/internals/task.js").set;
var IS_IOS = __webpack_require__(/*! ../internals/engine-is-ios */ "./node_modules/core-js-pure/internals/engine-is-ios.js");
var IS_WEBOS_WEBKIT = __webpack_require__(/*! ../internals/engine-is-webos-webkit */ "./node_modules/core-js-pure/internals/engine-is-webos-webkit.js");
var IS_NODE = __webpack_require__(/*! ../internals/engine-is-node */ "./node_modules/core-js-pure/internals/engine-is-node.js");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/native-promise-constructor.js":
/*!***************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/native-promise-constructor.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");

module.exports = global.Promise;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/native-symbol.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/native-symbol.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js-pure/internals/engine-v8-version.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "./node_modules/core-js-pure/internals/native-weak-map.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/native-weak-map.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js-pure/internals/inspect-source.js");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "./node_modules/core-js-pure/internals/new-promise-capability.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/new-promise-capability.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/not-a-regexp.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/not-a-regexp.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isRegExp = __webpack_require__(/*! ../internals/is-regexp */ "./node_modules/core-js-pure/internals/is-regexp.js");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/number-parse-float.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/number-parse-float.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js-pure/internals/string-trim.js").trim;
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js-pure/internals/whitespaces.js");

var $parseFloat = global.parseFloat;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/number-parse-int.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/number-parse-int.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js-pure/internals/string-trim.js").trim;
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js-pure/internals/whitespaces.js");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-create.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-create.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js-pure/internals/object-define-properties.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js-pure/internals/enum-bug-keys.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js-pure/internals/hidden-keys.js");
var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js-pure/internals/html.js");
var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js-pure/internals/document-create-element.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js-pure/internals/shared-key.js");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-define-properties.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-define-properties.js ***!
  \*************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js-pure/internals/object-keys.js");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-define-property.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-define-property.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js-pure/internals/ie8-dom-define.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js-pure/internals/to-primitive.js");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js":
/*!***********************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js ***!
  \***********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js-pure/internals/object-property-is-enumerable.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js-pure/internals/create-property-descriptor.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js-pure/internals/to-primitive.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js-pure/internals/ie8-dom-define.js");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-get-own-property-names-external.js":
/*!***************************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-own-property-names-external.js ***!
  \***************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var $getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js-pure/internals/object-get-own-property-names.js").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-get-own-property-names.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-own-property-names.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js-pure/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js-pure/internals/enum-bug-keys.js");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-get-own-property-symbols.js":
/*!********************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-own-property-symbols.js ***!
  \********************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-get-prototype-of.js":
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-prototype-of.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js-pure/internals/shared-key.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js-pure/internals/correct-prototype-getter.js");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-keys-internal.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-keys-internal.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js-pure/internals/array-includes.js").indexOf;
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js-pure/internals/hidden-keys.js");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-keys.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-keys.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js-pure/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js-pure/internals/enum-bug-keys.js");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-property-is-enumerable.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-property-is-enumerable.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-set-prototype-of.js":
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-set-prototype-of.js ***!
  \************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var aPossiblePrototype = __webpack_require__(/*! ../internals/a-possible-prototype */ "./node_modules/core-js-pure/internals/a-possible-prototype.js");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "./node_modules/core-js-pure/internals/object-to-string.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-to-string.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js-pure/internals/to-string-tag-support.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js-pure/internals/classof.js");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/own-keys.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/own-keys.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js-pure/internals/object-get-own-property-names.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js-pure/internals/object-get-own-property-symbols.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/path.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/path.js ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/perform.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/perform.js ***!
  \********************************************************/
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/promise-resolve.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/promise-resolve.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var newPromiseCapability = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js-pure/internals/new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/redefine-all.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/redefine-all.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js-pure/internals/redefine.js");

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine(target, key, src[key], options);
  } return target;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/redefine.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/redefine.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/require-object-coercible.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/require-object-coercible.js ***!
  \*************************************************************************/
/***/ (function(module) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/set-global.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/set-global.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/set-species.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/set-species.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/set-to-string-tag.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/set-to-string-tag.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js-pure/internals/to-string-tag-support.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js").f;
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var toString = __webpack_require__(/*! ../internals/object-to-string */ "./node_modules/core-js-pure/internals/object-to-string.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/shared-key.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/shared-key.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js-pure/internals/shared.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js-pure/internals/uid.js");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/shared-store.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/shared-store.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js-pure/internals/set-global.js");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/shared.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/shared.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");
var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js-pure/internals/shared-store.js");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js-pure/internals/species-constructor.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/species-constructor.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/string-multibyte.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/string-multibyte.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js-pure/internals/to-integer.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js-pure/internals/require-object-coercible.js");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/string-trim-forced.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/string-trim-forced.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js-pure/internals/whitespaces.js");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/string-trim.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/string-trim.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js-pure/internals/require-object-coercible.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js-pure/internals/whitespaces.js");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/task.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/task.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js-pure/internals/function-bind-context.js");
var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js-pure/internals/html.js");
var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js-pure/internals/document-create-element.js");
var IS_IOS = __webpack_require__(/*! ../internals/engine-is-ios */ "./node_modules/core-js-pure/internals/engine-is-ios.js");
var IS_NODE = __webpack_require__(/*! ../internals/engine-is-node */ "./node_modules/core-js-pure/internals/engine-is-node.js");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-absolute-index.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-absolute-index.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js-pure/internals/to-integer.js");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-indexed-object.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-indexed-object.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js-pure/internals/indexed-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js-pure/internals/require-object-coercible.js");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-integer.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-integer.js ***!
  \***********************************************************/
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-length.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-length.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js-pure/internals/to-integer.js");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-object.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-object.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js-pure/internals/require-object-coercible.js");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-primitive.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-primitive.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/to-string-tag-support.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-string-tag-support.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "./node_modules/core-js-pure/internals/uid.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/uid.js ***!
  \****************************************************/
/***/ (function(module) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/use-symbol-as-uid.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/use-symbol-as-uid.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js-pure/internals/native-symbol.js");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "./node_modules/core-js-pure/internals/well-known-symbol-wrapped.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/well-known-symbol-wrapped.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "./node_modules/core-js-pure/internals/well-known-symbol.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/well-known-symbol.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js-pure/internals/shared.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js-pure/internals/uid.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js-pure/internals/native-symbol.js");
var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js-pure/internals/use-symbol-as-uid.js");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "./node_modules/core-js-pure/internals/whitespaces.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/whitespaces.js ***!
  \************************************************************/
/***/ (function(module) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.aggregate-error.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.aggregate-error.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js-pure/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js-pure/internals/object-set-prototype-of.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js-pure/internals/object-create.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js-pure/internals/create-property-descriptor.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js-pure/internals/iterate.js");

var $AggregateError = function AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  if (setPrototypeOf) {
    // eslint-disable-next-line unicorn/error-message -- expected
    that = setPrototypeOf(new Error(undefined), getPrototypeOf(that));
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', String(message));
  var errorsArray = [];
  iterate(errors, errorsArray.push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

$AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ''),
  name: createPropertyDescriptor(5, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true }, {
  AggregateError: $AggregateError
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.concat.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.concat.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js-pure/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js-pure/internals/create-property.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js-pure/internals/array-species-create.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js-pure/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js-pure/internals/engine-v8-version.js");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.every.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.every.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $every = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").every;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js-pure/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.fill.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.fill.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var fill = __webpack_require__(/*! ../internals/array-fill */ "./node_modules/core-js-pure/internals/array-fill.js");
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js-pure/internals/add-to-unscopables.js");

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.filter.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.filter.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $filter = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js-pure/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.for-each.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.for-each.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var forEach = __webpack_require__(/*! ../internals/array-for-each */ "./node_modules/core-js-pure/internals/array-for-each.js");

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.from.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.from.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var from = __webpack_require__(/*! ../internals/array-from */ "./node_modules/core-js-pure/internals/array-from.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js-pure/internals/check-correctness-of-iteration.js");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.includes.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.includes.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $includes = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js-pure/internals/array-includes.js").includes;
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js-pure/internals/add-to-unscopables.js");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.index-of.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.index-of.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js-pure/internals/array-includes.js").indexOf;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js-pure/internals/array-method-is-strict.js");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.is-array.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.is-array.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js-pure/internals/is-array.js");

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.iterator.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.iterator.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js-pure/internals/add-to-unscopables.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js-pure/internals/iterators.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js-pure/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js-pure/internals/define-iterator.js");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.map.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.map.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $map = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").map;
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js-pure/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.reduce.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.reduce.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $reduce = __webpack_require__(/*! ../internals/array-reduce */ "./node_modules/core-js-pure/internals/array-reduce.js").left;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js-pure/internals/array-method-is-strict.js");
var CHROME_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js-pure/internals/engine-v8-version.js");
var IS_NODE = __webpack_require__(/*! ../internals/engine-is-node */ "./node_modules/core-js-pure/internals/engine-is-node.js");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.reverse.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.reverse.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js-pure/internals/is-array.js");

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.slice.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.slice.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js-pure/internals/is-array.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js-pure/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js-pure/internals/create-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js-pure/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.array.some.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.some.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $some = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").some;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js-pure/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.date.now.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.date.now.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.function.bind.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.function.bind.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var bind = __webpack_require__(/*! ../internals/function-bind */ "./node_modules/core-js-pure/internals/function-bind.js");

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.json.to-string-tag.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.json.to-string-tag.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js-pure/internals/set-to-string-tag.js");

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.map.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.map.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(/*! ../internals/collection */ "./node_modules/core-js-pure/internals/collection.js");
var collectionStrong = __webpack_require__(/*! ../internals/collection-strong */ "./node_modules/core-js-pure/internals/collection-strong.js");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.math.to-string-tag.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.math.to-string-tag.js ***!
  \********************************************************************/
/***/ (function() {

// empty


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.create.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.create.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js-pure/internals/object-create.js");

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.define-properties.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.define-properties.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js-pure/internals/object-define-properties.js");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.define-property.js":
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.define-property.js ***!
  \************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var objectDefinePropertyModile = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js");

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.get-own-property-descriptor.js":
/*!************************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.get-own-property-descriptor.js ***!
  \************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var nativeGetOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js").f;
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.get-own-property-descriptors.js":
/*!*************************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.get-own-property-descriptors.js ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js-pure/internals/own-keys.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js-pure/internals/create-property.js");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.get-prototype-of.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.get-prototype-of.js ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var nativeGetPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js-pure/internals/object-get-prototype-of.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js-pure/internals/correct-prototype-getter.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.keys.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.keys.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var nativeKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js-pure/internals/object-keys.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.set-prototype-of.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.set-prototype-of.js ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js-pure/internals/object-set-prototype-of.js");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.object.to-string.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.to-string.js ***!
  \******************************************************************/
/***/ (function() {

// empty


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.parse-float.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.parse-float.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var parseFloatImplementation = __webpack_require__(/*! ../internals/number-parse-float */ "./node_modules/core-js-pure/internals/number-parse-float.js");

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.parse-int.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.parse-int.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var parseIntImplementation = __webpack_require__(/*! ../internals/number-parse-int */ "./node_modules/core-js-pure/internals/number-parse-int.js");

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.promise.all-settled.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.promise.all-settled.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js-pure/internals/new-promise-capability.js");
var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js-pure/internals/perform.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js-pure/internals/iterate.js");

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.promise.any.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.promise.any.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js-pure/internals/new-promise-capability.js");
var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js-pure/internals/perform.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js-pure/internals/iterate.js");

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.promise.finally.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.promise.finally.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");
var NativePromise = __webpack_require__(/*! ../internals/native-promise-constructor */ "./node_modules/core-js-pure/internals/native-promise-constructor.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js-pure/internals/species-constructor.js");
var promiseResolve = __webpack_require__(/*! ../internals/promise-resolve */ "./node_modules/core-js-pure/internals/promise-resolve.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js-pure/internals/redefine.js");

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && typeof NativePromise == 'function') {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromise.prototype['finally'] !== method) {
    redefine(NativePromise.prototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.promise.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.promise.js ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var NativePromise = __webpack_require__(/*! ../internals/native-promise-constructor */ "./node_modules/core-js-pure/internals/native-promise-constructor.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js-pure/internals/redefine.js");
var redefineAll = __webpack_require__(/*! ../internals/redefine-all */ "./node_modules/core-js-pure/internals/redefine-all.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js-pure/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js-pure/internals/set-to-string-tag.js");
var setSpecies = __webpack_require__(/*! ../internals/set-species */ "./node_modules/core-js-pure/internals/set-species.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var anInstance = __webpack_require__(/*! ../internals/an-instance */ "./node_modules/core-js-pure/internals/an-instance.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js-pure/internals/inspect-source.js");
var iterate = __webpack_require__(/*! ../internals/iterate */ "./node_modules/core-js-pure/internals/iterate.js");
var checkCorrectnessOfIteration = __webpack_require__(/*! ../internals/check-correctness-of-iteration */ "./node_modules/core-js-pure/internals/check-correctness-of-iteration.js");
var speciesConstructor = __webpack_require__(/*! ../internals/species-constructor */ "./node_modules/core-js-pure/internals/species-constructor.js");
var task = __webpack_require__(/*! ../internals/task */ "./node_modules/core-js-pure/internals/task.js").set;
var microtask = __webpack_require__(/*! ../internals/microtask */ "./node_modules/core-js-pure/internals/microtask.js");
var promiseResolve = __webpack_require__(/*! ../internals/promise-resolve */ "./node_modules/core-js-pure/internals/promise-resolve.js");
var hostReportErrors = __webpack_require__(/*! ../internals/host-report-errors */ "./node_modules/core-js-pure/internals/host-report-errors.js");
var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js-pure/internals/new-promise-capability.js");
var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js-pure/internals/perform.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js-pure/internals/internal-state.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js-pure/internals/is-forced.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var IS_BROWSER = __webpack_require__(/*! ../internals/engine-is-browser */ "./node_modules/core-js-pure/internals/engine-is-browser.js");
var IS_NODE = __webpack_require__(/*! ../internals/engine-is-node */ "./node_modules/core-js-pure/internals/engine-is-node.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js-pure/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructorPrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.reflect.apply.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.reflect.apply.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

var nativeApply = getBuiltIn('Reflect', 'apply');
var functionApply = Function.apply;

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  nativeApply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    aFunction(target);
    anObject(argumentsList);
    return nativeApply
      ? nativeApply(target, thisArgument, argumentsList)
      : functionApply.call(target, thisArgument, argumentsList);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.reflect.construct.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.reflect.construct.js ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js-pure/internals/a-function.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js-pure/internals/object-create.js");
var bind = __webpack_require__(/*! ../internals/function-bind */ "./node_modules/core-js-pure/internals/function-bind.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.reflect.delete-property.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.reflect.delete-property.js ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js").f;

// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$({ target: 'Reflect', stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.reflect.get-prototype-of.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.reflect.get-prototype-of.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var objectGetPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js-pure/internals/object-get-prototype-of.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js-pure/internals/correct-prototype-getter.js");

// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.reflect.get.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.reflect.get.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js-pure/internals/object-get-prototype-of.js");

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  if (descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey)) return has(descriptor, 'value')
    ? descriptor.value
    : descriptor.get === undefined
      ? undefined
      : descriptor.get.call(receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.reflect.to-string-tag.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.reflect.to-string-tag.js ***!
  \***********************************************************************/
/***/ (function() {

// empty


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.string.includes.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.string.includes.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js-pure/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js-pure/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js-pure/internals/correct-is-regexp-logic.js");

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.string.iterator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.string.iterator.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js-pure/internals/string-multibyte.js").charAt;
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js-pure/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js-pure/internals/define-iterator.js");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.string.starts-with.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.string.starts-with.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js").f;
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js-pure/internals/to-length.js");
var notARegExp = __webpack_require__(/*! ../internals/not-a-regexp */ "./node_modules/core-js-pure/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js-pure/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__(/*! ../internals/correct-is-regexp-logic */ "./node_modules/core-js-pure/internals/correct-is-regexp-logic.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $startsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.string.trim.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.string.trim.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var $trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js-pure/internals/string-trim.js").trim;
var forcedStringTrimMethod = __webpack_require__(/*! ../internals/string-trim-forced */ "./node_modules/core-js-pure/internals/string-trim-forced.js");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.async-iterator.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.async-iterator.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.description.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.description.js ***!
  \********************************************************************/
/***/ (function() {

// empty


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.has-instance.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.has-instance.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.is-concat-spreadable.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.is-concat-spreadable.js ***!
  \*****************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.iterator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.iterator.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js-pure/internals/get-built-in.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js-pure/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js-pure/internals/descriptors.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js-pure/internals/native-symbol.js");
var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js-pure/internals/use-symbol-as-uid.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js-pure/internals/fails.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js-pure/internals/has.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js-pure/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js-pure/internals/is-object.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js-pure/internals/an-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js-pure/internals/to-object.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js-pure/internals/to-indexed-object.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js-pure/internals/to-primitive.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js-pure/internals/create-property-descriptor.js");
var nativeObjectCreate = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js-pure/internals/object-create.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js-pure/internals/object-keys.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js-pure/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternal = __webpack_require__(/*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js-pure/internals/object-get-own-property-names-external.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js-pure/internals/object-get-own-property-symbols.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js-pure/internals/object-define-property.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js-pure/internals/object-property-is-enumerable.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js-pure/internals/redefine.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js-pure/internals/shared.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js-pure/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js-pure/internals/hidden-keys.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js-pure/internals/uid.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");
var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js-pure/internals/well-known-symbol-wrapped.js");
var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js-pure/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js-pure/internals/internal-state.js");
var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js-pure/internals/array-iteration.js").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.match-all.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.match-all.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.match.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.match.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.replace.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.replace.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.search.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.search.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.species.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.species.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.split.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.split.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.to-primitive.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.to-primitive.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.to-string-tag.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.to-string-tag.js ***!
  \**********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/es.symbol.unscopables.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.symbol.unscopables.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.aggregate-error.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.aggregate-error.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(/*! ./es.aggregate-error */ "./node_modules/core-js-pure/modules/es.aggregate-error.js");


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.promise.all-settled.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.promise.all-settled.js ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(/*! ./es.promise.all-settled.js */ "./node_modules/core-js-pure/modules/es.promise.all-settled.js");


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.promise.any.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.promise.any.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(/*! ./es.promise.any */ "./node_modules/core-js-pure/modules/es.promise.any.js");


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.promise.try.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.promise.try.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js-pure/internals/export.js");
var newPromiseCapabilityModule = __webpack_require__(/*! ../internals/new-promise-capability */ "./node_modules/core-js-pure/internals/new-promise-capability.js");
var perform = __webpack_require__(/*! ../internals/perform */ "./node_modules/core-js-pure/internals/perform.js");

// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$({ target: 'Promise', stat: true }, {
  'try': function (callbackfn) {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(callbackfn);
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.async-dispose.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.async-dispose.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.dispose.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.dispose.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.matcher.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.matcher.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('matcher');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.metadata.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.metadata.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.observable.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.observable.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.pattern-match.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.pattern-match.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/esnext.symbol.replace-all.js":
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/esnext.symbol.replace-all.js ***!
  \************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js-pure/internals/define-well-known-symbol.js");

defineWellKnownSymbol('replaceAll');


/***/ }),

/***/ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js":
/*!***************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/web.dom-collections.iterator.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ./es.array.iterator */ "./node_modules/core-js-pure/modules/es.array.iterator.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js-pure/internals/dom-iterables.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js-pure/internals/global.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js-pure/internals/classof.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js-pure/internals/create-non-enumerable-property.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js-pure/internals/iterators.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js-pure/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),

/***/ "./node_modules/core-js-pure/stable/array/from.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/array/from.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/array/from */ "./node_modules/core-js-pure/es/array/from.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/array/is-array.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/array/is-array.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/array/is-array */ "./node_modules/core-js-pure/es/array/is-array.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/array/virtual/for-each.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/array/virtual/for-each.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../../es/array/virtual/for-each */ "./node_modules/core-js-pure/es/array/virtual/for-each.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/array/virtual/values.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/array/virtual/values.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../../es/array/virtual/values */ "./node_modules/core-js-pure/es/array/virtual/values.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/date/now.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js-pure/stable/date/now.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/date/now */ "./node_modules/core-js-pure/es/date/now.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/bind.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/bind.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/bind */ "./node_modules/core-js-pure/es/instance/bind.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/concat.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/concat.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/concat */ "./node_modules/core-js-pure/es/instance/concat.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/every.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/every.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/every */ "./node_modules/core-js-pure/es/instance/every.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/fill.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/fill.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/fill */ "./node_modules/core-js-pure/es/instance/fill.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/filter.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/filter.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/filter */ "./node_modules/core-js-pure/es/instance/filter.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/for-each.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/for-each.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
var forEach = __webpack_require__(/*! ../array/virtual/for-each */ "./node_modules/core-js-pure/stable/array/virtual/for-each.js");
var classof = __webpack_require__(/*! ../../internals/classof */ "./node_modules/core-js-pure/internals/classof.js");
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.forEach)
    // eslint-disable-next-line no-prototype-builtins -- safe
    || DOMIterables.hasOwnProperty(classof(it)) ? forEach : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/includes.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/includes.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/includes */ "./node_modules/core-js-pure/es/instance/includes.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/index-of.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/index-of.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/index-of */ "./node_modules/core-js-pure/es/instance/index-of.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/map.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/map.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/map */ "./node_modules/core-js-pure/es/instance/map.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/reduce.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/reduce.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/reduce */ "./node_modules/core-js-pure/es/instance/reduce.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/reverse.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/reverse.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/reverse */ "./node_modules/core-js-pure/es/instance/reverse.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/slice.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/slice.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/slice */ "./node_modules/core-js-pure/es/instance/slice.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/some.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/some.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/some */ "./node_modules/core-js-pure/es/instance/some.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/starts-with.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/starts-with.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/starts-with */ "./node_modules/core-js-pure/es/instance/starts-with.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/trim.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/trim.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/instance/trim */ "./node_modules/core-js-pure/es/instance/trim.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/instance/values.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/instance/values.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/web.dom-collections.iterator */ "./node_modules/core-js-pure/modules/web.dom-collections.iterator.js");
var values = __webpack_require__(/*! ../array/virtual/values */ "./node_modules/core-js-pure/stable/array/virtual/values.js");
var classof = __webpack_require__(/*! ../../internals/classof */ "./node_modules/core-js-pure/internals/classof.js");
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.values;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.values)
    // eslint-disable-next-line no-prototype-builtins -- safe
    || DOMIterables.hasOwnProperty(classof(it)) ? values : own;
};


/***/ }),

/***/ "./node_modules/core-js-pure/stable/map/index.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/stable/map/index.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/map */ "./node_modules/core-js-pure/es/map/index.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/object/define-properties.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/object/define-properties.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/define-properties */ "./node_modules/core-js-pure/es/object/define-properties.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/object/define-property.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/object/define-property.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/define-property */ "./node_modules/core-js-pure/es/object/define-property.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/object/get-own-property-descriptor.js":
/*!********************************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/object/get-own-property-descriptor.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/get-own-property-descriptor */ "./node_modules/core-js-pure/es/object/get-own-property-descriptor.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/object/get-own-property-descriptors.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/object/get-own-property-descriptors.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/get-own-property-descriptors */ "./node_modules/core-js-pure/es/object/get-own-property-descriptors.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/object/get-own-property-symbols.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/object/get-own-property-symbols.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/get-own-property-symbols */ "./node_modules/core-js-pure/es/object/get-own-property-symbols.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/object/keys.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/object/keys.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/object/keys */ "./node_modules/core-js-pure/es/object/keys.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/parse-float.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/parse-float.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../es/parse-float */ "./node_modules/core-js-pure/es/parse-float.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/parse-int.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/stable/parse-int.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../es/parse-int */ "./node_modules/core-js-pure/es/parse-int.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/promise/index.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/promise/index.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/promise */ "./node_modules/core-js-pure/es/promise/index.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/reflect/apply.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/reflect/apply.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/reflect/apply */ "./node_modules/core-js-pure/es/reflect/apply.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/reflect/construct.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/reflect/construct.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/reflect/construct */ "./node_modules/core-js-pure/es/reflect/construct.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/reflect/delete-property.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/reflect/delete-property.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/reflect/delete-property */ "./node_modules/core-js-pure/es/reflect/delete-property.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/reflect/get-prototype-of.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js-pure/stable/reflect/get-prototype-of.js ***!
  \**********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/reflect/get-prototype-of */ "./node_modules/core-js-pure/es/reflect/get-prototype-of.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js-pure/stable/symbol/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/stable/symbol/index.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(/*! ../../es/symbol */ "./node_modules/core-js-pure/es/symbol/index.js");

module.exports = parent;


/***/ }),

/***/ "./node_modules/core-js/internals/a-function.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/a-function.js ***!
  \******************************************************/
/***/ (function(module) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/a-possible-prototype.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/a-possible-prototype.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/add-to-unscopables.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/add-to-unscopables.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "./node_modules/core-js/internals/an-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/an-object.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-for-each.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-for-each.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "./node_modules/core-js/internals/array-includes.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/array-includes.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-iteration.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/array-iteration.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(/*! ../internals/function-bind-context */ "./node_modules/core-js/internals/function-bind-context.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-method-has-species-support.js":
/*!****************************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-has-species-support.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-method-is-strict.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/array-method-is-strict.js ***!
  \******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-species-constructor.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-constructor.js ***!
  \*********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "./node_modules/core-js/internals/array-species-create.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/array-species-create.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(/*! ../internals/array-species-constructor */ "./node_modules/core-js/internals/array-species-constructor.js");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "./node_modules/core-js/internals/classof-raw.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/classof-raw.js ***!
  \*******************************************************/
/***/ (function(module) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/internals/classof.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/classof.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
var classofRaw = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/copy-constructor-properties.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var ownKeys = __webpack_require__(/*! ../internals/own-keys */ "./node_modules/core-js/internals/own-keys.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/correct-prototype-getter.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "./node_modules/core-js/internals/create-html.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/create-html.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + toString(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-iterator-constructor.js":
/*!***********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
  \***********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js").IteratorPrototype;
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-non-enumerable-property.js":
/*!**************************************************************************!*\
  !*** ./node_modules/core-js/internals/create-non-enumerable-property.js ***!
  \**************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-property-descriptor.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
  \**********************************************************************/
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/internals/create-property.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/create-property.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/define-iterator.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/define-iterator.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var createIteratorConstructor = __webpack_require__(/*! ../internals/create-iterator-constructor */ "./node_modules/core-js/internals/create-iterator-constructor.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var IteratorsCore = __webpack_require__(/*! ../internals/iterators-core */ "./node_modules/core-js/internals/iterators-core.js");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/internals/define-well-known-symbol.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/define-well-known-symbol.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(/*! ../internals/path */ "./node_modules/core-js/internals/path.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/descriptors.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/descriptors.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "./node_modules/core-js/internals/document-create-element.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/document-create-element.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/internals/dom-iterables.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/dom-iterables.js ***!
  \*********************************************************/
/***/ (function(module) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "./node_modules/core-js/internals/engine-user-agent.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/engine-user-agent.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "./node_modules/core-js/internals/engine-v8-version.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/engine-v8-version.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var userAgent = __webpack_require__(/*! ../internals/engine-user-agent */ "./node_modules/core-js/internals/engine-user-agent.js");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "./node_modules/core-js/internals/enum-bug-keys.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
  \*********************************************************/
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "./node_modules/core-js/internals/export.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/export.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/fails.js":
/*!*************************************************!*\
  !*** ./node_modules/core-js/internals/fails.js ***!
  \*************************************************/
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/function-bind-context.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/function-bind-context.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aFunction = __webpack_require__(/*! ../internals/a-function */ "./node_modules/core-js/internals/a-function.js");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/internals/get-built-in.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/get-built-in.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "./node_modules/core-js/internals/global.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/global.js ***!
  \**************************************************/
/***/ (function(module) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ "./node_modules/core-js/internals/has.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/internals/has.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "./node_modules/core-js/internals/hidden-keys.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/hidden-keys.js ***!
  \*******************************************************/
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/internals/html.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/html.js ***!
  \************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "./node_modules/core-js/internals/ie8-dom-define.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var createElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/internals/indexed-object.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/indexed-object.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "./node_modules/core-js/internals/inherit-if-required.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/internals/inherit-if-required.js ***!
  \***************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var setPrototypeOf = __webpack_require__(/*! ../internals/object-set-prototype-of */ "./node_modules/core-js/internals/object-set-prototype-of.js");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "./node_modules/core-js/internals/inspect-source.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/inspect-source.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "./node_modules/core-js/internals/internal-state.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/internal-state.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(/*! ../internals/native-weak-map */ "./node_modules/core-js/internals/native-weak-map.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var objectHas = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var shared = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-array.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/is-array.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-forced.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-forced.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "./node_modules/core-js/internals/is-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-object.js ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/internals/is-pure.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/internals/is-pure.js ***!
  \***************************************************/
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ "./node_modules/core-js/internals/is-symbol.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/is-symbol.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js");

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return typeof $Symbol == 'function' && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterators-core.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/internals/iterators-core.js ***!
  \**********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var getPrototypeOf = __webpack_require__(/*! ../internals/object-get-prototype-of */ "./node_modules/core-js/internals/object-get-prototype-of.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "./node_modules/core-js/internals/iterators.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/iterators.js ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/internals/native-symbol.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/native-symbol.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "./node_modules/core-js/internals/native-weak-map.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/native-weak-map.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "./node_modules/core-js/internals/object-assign.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-assign.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/internals/object-create.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/internals/object-create.js ***!
  \*********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var defineProperties = __webpack_require__(/*! ../internals/object-define-properties */ "./node_modules/core-js/internals/object-define-properties.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var html = __webpack_require__(/*! ../internals/html */ "./node_modules/core-js/internals/html.js");
var documentCreateElement = __webpack_require__(/*! ../internals/document-create-element */ "./node_modules/core-js/internals/document-create-element.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  if (iframe.style) {
    iframe.style.display = 'none';
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
  }
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = document.domain && activeXDocument ?
    NullProtoObjectViaActiveX(activeXDocument) : // old IE
    NullProtoObjectViaIFrame() ||
    NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-define-properties.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-properties.js ***!
  \********************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-define-property.js":
/*!******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-define-property.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
/*!******************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var IE8_DOM_DEFINE = __webpack_require__(/*! ../internals/ie8-dom-define */ "./node_modules/core-js/internals/ie8-dom-define.js");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-names-external.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names-external.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var $getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-names.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-own-property-symbols.js":
/*!***************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/internals/object-get-prototype-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(/*! ../internals/correct-prototype-getter */ "./node_modules/core-js/internals/correct-prototype-getter.js");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-keys-internal.js":
/*!****************************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
  \****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var indexOf = __webpack_require__(/*! ../internals/array-includes */ "./node_modules/core-js/internals/array-includes.js").indexOf;
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-keys.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/object-keys.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(/*! ../internals/object-keys-internal */ "./node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__(/*! ../internals/enum-bug-keys */ "./node_modules/core-js/internals/enum-bug-keys.js");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/internals/object-property-is-enumerable.js":
/*!*************************************************************************!*\
  !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/internals/object-set-prototype-of.js":
/*!*******************************************************************!*\
  !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
  \*******************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var aPossiblePrototype = __webpack_require__(/*! ../internals/a-possible-prototype */ "./node_modules/core-js/internals/a-possible-prototype.js");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "./node_modules/core-js/internals/object-to-string.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/object-to-string.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
var classof = __webpack_require__(/*! ../internals/classof */ "./node_modules/core-js/internals/classof.js");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "./node_modules/core-js/internals/ordinary-to-primitive.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/ordinary-to-primitive.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/internals/own-keys.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/own-keys.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "./node_modules/core-js/internals/path.js":
/*!************************************************!*\
  !*** ./node_modules/core-js/internals/path.js ***!
  \************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

module.exports = global;


/***/ }),

/***/ "./node_modules/core-js/internals/redefine.js":
/*!****************************************************!*\
  !*** ./node_modules/core-js/internals/redefine.js ***!
  \****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");
var inspectSource = __webpack_require__(/*! ../internals/inspect-source */ "./node_modules/core-js/internals/inspect-source.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "./node_modules/core-js/internals/regexp-flags.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/regexp-flags.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/internals/require-object-coercible.js":
/*!********************************************************************!*\
  !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
  \********************************************************************/
/***/ (function(module) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-global.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/set-global.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "./node_modules/core-js/internals/set-to-string-tag.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "./node_modules/core-js/internals/shared-key.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/shared-key.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/internals/shared-store.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/shared-store.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var setGlobal = __webpack_require__(/*! ../internals/set-global */ "./node_modules/core-js/internals/set-global.js");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "./node_modules/core-js/internals/shared.js":
/*!**************************************************!*\
  !*** ./node_modules/core-js/internals/shared.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var store = __webpack_require__(/*! ../internals/shared-store */ "./node_modules/core-js/internals/shared-store.js");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.16.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/internals/string-html-forced.js":
/*!**************************************************************!*\
  !*** ./node_modules/core-js/internals/string-html-forced.js ***!
  \**************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-multibyte.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/internals/string-multibyte.js ***!
  \************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");
var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "./node_modules/core-js/internals/string-trim.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/string-trim.js ***!
  \*******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");
var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
var whitespaces = __webpack_require__(/*! ../internals/whitespaces */ "./node_modules/core-js/internals/whitespaces.js");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-absolute-index.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-indexed-object.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-integer.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/internals/to-integer.js ***!
  \******************************************************/
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-length.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-length.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ../internals/to-integer */ "./node_modules/core-js/internals/to-integer.js");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-object.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-object.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(/*! ../internals/require-object-coercible */ "./node_modules/core-js/internals/require-object-coercible.js");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-primitive.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/internals/to-primitive.js ***!
  \********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
var ordinaryToPrimitive = __webpack_require__(/*! ../internals/ordinary-to-primitive */ "./node_modules/core-js/internals/ordinary-to-primitive.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = input[TO_PRIMITIVE];
  var result;
  if (exoticToPrim !== undefined) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-property-key.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/internals/to-property-key.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ "./node_modules/core-js/internals/to-string-tag-support.js":
/*!*****************************************************************!*\
  !*** ./node_modules/core-js/internals/to-string-tag-support.js ***!
  \*****************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "./node_modules/core-js/internals/to-string.js":
/*!*****************************************************!*\
  !*** ./node_modules/core-js/internals/to-string.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");

module.exports = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "./node_modules/core-js/internals/uid.js":
/*!***********************************************!*\
  !*** ./node_modules/core-js/internals/uid.js ***!
  \***********************************************/
/***/ (function(module) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "./node_modules/core-js/internals/use-symbol-as-uid.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/use-symbol-as-uid.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "./node_modules/core-js/internals/well-known-symbol-wrapped.js":
/*!*********************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol-wrapped.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "./node_modules/core-js/internals/well-known-symbol.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
  \*************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");
var USE_SYMBOL_AS_UID = __webpack_require__(/*! ../internals/use-symbol-as-uid */ "./node_modules/core-js/internals/use-symbol-as-uid.js");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "./node_modules/core-js/internals/whitespaces.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/internals/whitespaces.js ***!
  \*******************************************************/
/***/ (function(module) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.concat.js":
/*!*********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.concat.js ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var arraySpeciesCreate = __webpack_require__(/*! ../internals/array-species-create */ "./node_modules/core-js/internals/array-species-create.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__(/*! ../internals/engine-v8-version */ "./node_modules/core-js/internals/engine-v8-version.js");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.iterator.js":
/*!***********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.iterator.js ***!
  \***********************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var addToUnscopables = __webpack_require__(/*! ../internals/add-to-unscopables */ "./node_modules/core-js/internals/add-to-unscopables.js");
var Iterators = __webpack_require__(/*! ../internals/iterators */ "./node_modules/core-js/internals/iterators.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.join.js":
/*!*******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.join.js ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var IndexedObject = __webpack_require__(/*! ../internals/indexed-object */ "./node_modules/core-js/internals/indexed-object.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var arrayMethodIsStrict = __webpack_require__(/*! ../internals/array-method-is-strict */ "./node_modules/core-js/internals/array-method-is-strict.js");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.map.js":
/*!******************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.map.js ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var $map = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").map;
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.array.slice.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.array.slice.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var toAbsoluteIndex = __webpack_require__(/*! ../internals/to-absolute-index */ "./node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__(/*! ../internals/to-length */ "./node_modules/core-js/internals/to-length.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var createProperty = __webpack_require__(/*! ../internals/create-property */ "./node_modules/core-js/internals/create-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var arrayMethodHasSpeciesSupport = __webpack_require__(/*! ../internals/array-method-has-species-support */ "./node_modules/core-js/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.function.name.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.function.name.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.number.constructor.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.number.constructor.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var isForced = __webpack_require__(/*! ../internals/is-forced */ "./node_modules/core-js/internals/is-forced.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var classof = __webpack_require__(/*! ../internals/classof-raw */ "./node_modules/core-js/internals/classof-raw.js");
var inheritIfRequired = __webpack_require__(/*! ../internals/inherit-if-required */ "./node_modules/core-js/internals/inherit-if-required.js");
var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
var toPrimitive = __webpack_require__(/*! ../internals/to-primitive */ "./node_modules/core-js/internals/to-primitive.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var create = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var getOwnPropertyNames = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js").f;
var getOwnPropertyDescriptor = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js").f;
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var trim = __webpack_require__(/*! ../internals/string-trim */ "./node_modules/core-js/internals/string-trim.js").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a number');
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.assign.js":
/*!**********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.assign.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var assign = __webpack_require__(/*! ../internals/object-assign */ "./node_modules/core-js/internals/object-assign.js");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.keys.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.keys.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var nativeKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.object.to-string.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.object.to-string.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(/*! ../internals/to-string-tag-support */ "./node_modules/core-js/internals/to-string-tag-support.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var toString = __webpack_require__(/*! ../internals/object-to-string */ "./node_modules/core-js/internals/object-to-string.js");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.regexp.to-string.js":
/*!*************************************************************!*\
  !*** ./node_modules/core-js/modules/es.regexp.to-string.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var $toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var flags = __webpack_require__(/*! ../internals/regexp-flags */ "./node_modules/core-js/internals/regexp-flags.js");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(/*! ../internals/string-multibyte */ "./node_modules/core-js/internals/string-multibyte.js").charAt;
var toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__(/*! ../internals/define-iterator */ "./node_modules/core-js/internals/define-iterator.js");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.string.link.js":
/*!********************************************************!*\
  !*** ./node_modules/core-js/modules/es.string.link.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var createHTML = __webpack_require__(/*! ../internals/create-html */ "./node_modules/core-js/internals/create-html.js");
var forcedStringHTMLMethod = __webpack_require__(/*! ../internals/string-html-forced */ "./node_modules/core-js/internals/string-html-forced.js");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.description.js":
/*!***************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.description.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var defineProperty = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js").f;
var copyConstructorProperties = __webpack_require__(/*! ../internals/copy-constructor-properties */ "./node_modules/core-js/internals/copy-constructor-properties.js");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.iterator.js":
/*!************************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.iterator.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js/internals/define-well-known-symbol.js");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "./node_modules/core-js/modules/es.symbol.js":
/*!***************************************************!*\
  !*** ./node_modules/core-js/modules/es.symbol.js ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(/*! ../internals/export */ "./node_modules/core-js/internals/export.js");
var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var getBuiltIn = __webpack_require__(/*! ../internals/get-built-in */ "./node_modules/core-js/internals/get-built-in.js");
var IS_PURE = __webpack_require__(/*! ../internals/is-pure */ "./node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__(/*! ../internals/descriptors */ "./node_modules/core-js/internals/descriptors.js");
var NATIVE_SYMBOL = __webpack_require__(/*! ../internals/native-symbol */ "./node_modules/core-js/internals/native-symbol.js");
var fails = __webpack_require__(/*! ../internals/fails */ "./node_modules/core-js/internals/fails.js");
var has = __webpack_require__(/*! ../internals/has */ "./node_modules/core-js/internals/has.js");
var isArray = __webpack_require__(/*! ../internals/is-array */ "./node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__(/*! ../internals/is-object */ "./node_modules/core-js/internals/is-object.js");
var isSymbol = __webpack_require__(/*! ../internals/is-symbol */ "./node_modules/core-js/internals/is-symbol.js");
var anObject = __webpack_require__(/*! ../internals/an-object */ "./node_modules/core-js/internals/an-object.js");
var toObject = __webpack_require__(/*! ../internals/to-object */ "./node_modules/core-js/internals/to-object.js");
var toIndexedObject = __webpack_require__(/*! ../internals/to-indexed-object */ "./node_modules/core-js/internals/to-indexed-object.js");
var toPropertyKey = __webpack_require__(/*! ../internals/to-property-key */ "./node_modules/core-js/internals/to-property-key.js");
var $toString = __webpack_require__(/*! ../internals/to-string */ "./node_modules/core-js/internals/to-string.js");
var createPropertyDescriptor = __webpack_require__(/*! ../internals/create-property-descriptor */ "./node_modules/core-js/internals/create-property-descriptor.js");
var nativeObjectCreate = __webpack_require__(/*! ../internals/object-create */ "./node_modules/core-js/internals/object-create.js");
var objectKeys = __webpack_require__(/*! ../internals/object-keys */ "./node_modules/core-js/internals/object-keys.js");
var getOwnPropertyNamesModule = __webpack_require__(/*! ../internals/object-get-own-property-names */ "./node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternal = __webpack_require__(/*! ../internals/object-get-own-property-names-external */ "./node_modules/core-js/internals/object-get-own-property-names-external.js");
var getOwnPropertySymbolsModule = __webpack_require__(/*! ../internals/object-get-own-property-symbols */ "./node_modules/core-js/internals/object-get-own-property-symbols.js");
var getOwnPropertyDescriptorModule = __webpack_require__(/*! ../internals/object-get-own-property-descriptor */ "./node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__(/*! ../internals/object-define-property */ "./node_modules/core-js/internals/object-define-property.js");
var propertyIsEnumerableModule = __webpack_require__(/*! ../internals/object-property-is-enumerable */ "./node_modules/core-js/internals/object-property-is-enumerable.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var redefine = __webpack_require__(/*! ../internals/redefine */ "./node_modules/core-js/internals/redefine.js");
var shared = __webpack_require__(/*! ../internals/shared */ "./node_modules/core-js/internals/shared.js");
var sharedKey = __webpack_require__(/*! ../internals/shared-key */ "./node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__(/*! ../internals/hidden-keys */ "./node_modules/core-js/internals/hidden-keys.js");
var uid = __webpack_require__(/*! ../internals/uid */ "./node_modules/core-js/internals/uid.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");
var wrappedWellKnownSymbolModule = __webpack_require__(/*! ../internals/well-known-symbol-wrapped */ "./node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineWellKnownSymbol = __webpack_require__(/*! ../internals/define-well-known-symbol */ "./node_modules/core-js/internals/define-well-known-symbol.js");
var setToStringTag = __webpack_require__(/*! ../internals/set-to-string-tag */ "./node_modules/core-js/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__(/*! ../internals/internal-state */ "./node_modules/core-js/internals/internal-state.js");
var $forEach = __webpack_require__(/*! ../internals/array-iteration */ "./node_modules/core-js/internals/array-iteration.js").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom-collections.for-each.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.for-each.js ***!
  \**********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
var forEach = __webpack_require__(/*! ../internals/array-for-each */ "./node_modules/core-js/internals/array-for-each.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom-collections.iterator.js":
/*!**********************************************************************!*\
  !*** ./node_modules/core-js/modules/web.dom-collections.iterator.js ***!
  \**********************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(/*! ../internals/global */ "./node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__(/*! ../internals/dom-iterables */ "./node_modules/core-js/internals/dom-iterables.js");
var ArrayIteratorMethods = __webpack_require__(/*! ../modules/es.array.iterator */ "./node_modules/core-js/modules/es.array.iterator.js");
var createNonEnumerableProperty = __webpack_require__(/*! ../internals/create-non-enumerable-property */ "./node_modules/core-js/internals/create-non-enumerable-property.js");
var wellKnownSymbol = __webpack_require__(/*! ../internals/well-known-symbol */ "./node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "./node_modules/dompurify/dist/purify.js":
/*!***********************************************!*\
  !*** ./node_modules/dompurify/dist/purify.js ***!
  \***********************************************/
/***/ (function(module) {

/*! @license DOMPurify 2.3.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.0/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, function () { 'use strict';

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);

  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);

  var regExpTest = unapply(RegExp.prototype.test);

  var typeErrorCreate = unconstruct(TypeError);

  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }

  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array) {
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = stringToLowerCase(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);

    var property = void 0;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);

  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'feimage', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);

  var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);

  var text = freeze(['#text']);

  var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);

  var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

  var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html$$1) {
          return html$$1;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.3.0';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;

      return DOMPurify;
    }

    var originalDocument = window.document;

    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        Text = window.Text,
        Comment = window.Comment,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;


    var ElementPrototype = Element.prototype;

    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML('') : '';

    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;


    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;

    var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
        ERB_EXPR$$1 = ERB_EXPR,
        DATA_ATTR$$1 = DATA_ATTR,
        ARIA_ATTR$$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify.
     *
     * This defaults to `true` starting DOMPurify 2.2.0. Note that setting it to `false`
     * might cause XSS from attacks hidden in closed shadowroots in case the browser
     * supports Declarative Shadow: DOM https://web.dev/declarative-shadow-dom/
     */
    var RETURN_DOM_IMPORT = true;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false; // Default true
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html);
          addToSet(ALLOWED_ATTR, html$1);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl);
          addToSet(ALLOWED_ATTR, mathMl$1);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);

    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);

    var ALL_MATHML_TAGS = addToSet({}, mathMl);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: HTML_NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erronously deleted from
        // HTML namespace.
        var commonSvgAndHTMLElements = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG or MathML). Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc = void 0;
      var leadingWhitespace = void 0;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, 'text/html');
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      if (elm instanceof Text || elm instanceof Comment) {
        return false;
      }

      if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function') {
        return true;
      }

      return false;
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content = void 0;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = stringToLowerCase(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
        content = stringReplace(content, ERB_EXPR$$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        return false;

        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr = void 0;
      var value = void 0;
      var lcName = void 0;
      var l = void 0;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;

        value = stringTrim(attr.value);
        lcName = stringToLowerCase(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
          value = stringReplace(value, ERB_EXPR$$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = currentNode.nodeName.toLowerCase();
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode = void 0;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty, cfg) {
      var body = void 0;
      var importedNode = void 0;
      var currentNode = void 0;
      var oldNode = void 0;
      var returnNode = void 0;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) ; else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : emptyHTML;
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (RETURN_DOM_IMPORT) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = stringToLowerCase(tag);
      var lcName = stringToLowerCase(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));



/***/ }),

/***/ "./node_modules/es6-promise/dist/es6-promise.js":
/*!******************************************************!*\
  !*** ./node_modules/es6-promise/dist/es6-promise.js ***!
  \******************************************************/
/***/ (function(module) {

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	0;
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));






/***/ }),

/***/ "./node_modules/fflate/esm/browser.js":
/*!********************************************!*\
  !*** ./node_modules/fflate/esm/browser.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Deflate": function() { return /* binding */ Deflate; },
/* harmony export */   "AsyncDeflate": function() { return /* binding */ AsyncDeflate; },
/* harmony export */   "deflate": function() { return /* binding */ deflate; },
/* harmony export */   "deflateSync": function() { return /* binding */ deflateSync; },
/* harmony export */   "Inflate": function() { return /* binding */ Inflate; },
/* harmony export */   "AsyncInflate": function() { return /* binding */ AsyncInflate; },
/* harmony export */   "inflate": function() { return /* binding */ inflate; },
/* harmony export */   "inflateSync": function() { return /* binding */ inflateSync; },
/* harmony export */   "Gzip": function() { return /* binding */ Gzip; },
/* harmony export */   "AsyncGzip": function() { return /* binding */ AsyncGzip; },
/* harmony export */   "gzip": function() { return /* binding */ gzip; },
/* harmony export */   "gzipSync": function() { return /* binding */ gzipSync; },
/* harmony export */   "Gunzip": function() { return /* binding */ Gunzip; },
/* harmony export */   "AsyncGunzip": function() { return /* binding */ AsyncGunzip; },
/* harmony export */   "gunzip": function() { return /* binding */ gunzip; },
/* harmony export */   "gunzipSync": function() { return /* binding */ gunzipSync; },
/* harmony export */   "Zlib": function() { return /* binding */ Zlib; },
/* harmony export */   "AsyncZlib": function() { return /* binding */ AsyncZlib; },
/* harmony export */   "zlib": function() { return /* binding */ zlib; },
/* harmony export */   "zlibSync": function() { return /* binding */ zlibSync; },
/* harmony export */   "Unzlib": function() { return /* binding */ Unzlib; },
/* harmony export */   "AsyncUnzlib": function() { return /* binding */ AsyncUnzlib; },
/* harmony export */   "unzlib": function() { return /* binding */ unzlib; },
/* harmony export */   "unzlibSync": function() { return /* binding */ unzlibSync; },
/* harmony export */   "compress": function() { return /* binding */ gzip; },
/* harmony export */   "AsyncCompress": function() { return /* binding */ AsyncGzip; },
/* harmony export */   "compressSync": function() { return /* binding */ gzipSync; },
/* harmony export */   "Compress": function() { return /* binding */ Gzip; },
/* harmony export */   "Decompress": function() { return /* binding */ Decompress; },
/* harmony export */   "AsyncDecompress": function() { return /* binding */ AsyncDecompress; },
/* harmony export */   "decompress": function() { return /* binding */ decompress; },
/* harmony export */   "decompressSync": function() { return /* binding */ decompressSync; },
/* harmony export */   "strToU8": function() { return /* binding */ strToU8; },
/* harmony export */   "strFromU8": function() { return /* binding */ strFromU8; },
/* harmony export */   "zip": function() { return /* binding */ zip; },
/* harmony export */   "zipSync": function() { return /* binding */ zipSync; },
/* harmony export */   "unzip": function() { return /* binding */ unzip; },
/* harmony export */   "unzipSync": function() { return /* binding */ unzipSync; }
/* harmony export */ });
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Much of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// Many optimizations have been made, so the bundle size is ultimately smaller but performance is similar.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};
var wk = (function (c, id, msg, transfer, cb) {
    var u = ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([c], { type: 'text/javascript' })));
    var w = new Worker(u);
    w.onerror = function (e) { return cb(e.error, null); };
    w.onmessage = function (e) { return cb(null, e.data); };
    w.postMessage(msg, transfer);
    return w;
});

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = ((i & 0xAAAA) >>> 1) | ((i & 0x5555) << 1);
    x = ((x & 0xCCCC) >>> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >>> 4) | ((x & 0x0F0F) << 4);
    rev[i] = (((x & 0xFF00) >>> 8) | ((x & 0x00FF) << 8)) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i)
        ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i)
            co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i)
    flt[i] = 8;
for (var i = 144; i < 256; ++i)
    flt[i] = 9;
for (var i = 256; i < 280; ++i)
    flt[i] = 7;
for (var i = 280; i < 288; ++i)
    flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
    fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8)) >>> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >>> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p / 8) >> 0) + (p & 7 && 1); };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var inflt = function (dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st)
        st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts)
                    break;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                throw 'invalid block type';
            if (pos > tbts)
                throw 'unexpected EOF';
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while (noSt || pos + mxa < tbts) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts)
                throw 'unexpected EOF';
            if (!c)
                throw 'invalid length/literal';
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d)
                    throw 'invalid distance';
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & ((1 << b) - 1), pos += b;
                }
                if (pos > tbts)
                    throw 'unexpected EOF';
                if (noBuf)
                    cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return [new u8(0), 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        lcfreq[lclt[i] & 31]++;
    for (var i = 0; i < lcdt.length; ++i)
        lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >>> 5) & 127), p += clct[i] >>> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = (syms[i] >>> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (syms[i] >>> 23) & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (syms[i] >>> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e < s) {
                // write full block
                pos = wfblk(w, pos, dat.subarray(i, e));
            }
            else {
                // write final block
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for (; i < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = (imod - pimod) & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = (i - dif + j + 32768) & 32767;
                                    var pti = prev[ti];
                                    var cd = (ti - pti + 32768) & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += (imod - pimod + 32768) & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst)
            pos = wfblk(w, pos, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ (function () {
    var t = new u32(256);
    for (var i = 0; i < 256; ++i) {
        var c = i, k = 9;
        while (--k)
            c = ((c & 1) && 0xEDB88320) ^ (c >>> 1);
        t[i] = c;
    }
    return t;
})();
// CRC32
var crc = function () {
    var c = 0xFFFFFFFF;
    return {
        p: function (d) {
            // closures have awful performance
            var cr = c;
            for (var i = 0; i < d.length; ++i)
                cr = crct[(cr & 255) ^ d[i]] ^ (cr >>> 8);
            c = cr;
        },
        d: function () { return c ^ 0xFFFFFFFF; }
    };
};
// Alder32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 5552, l);
                for (; i < e; ++i)
                    n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function () { return ((a >>> 8) << 16 | (b & 255) << 8 | (b >>> 8)) + ((a & 255) << 23) * 2; }
    };
};
;
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : (12 + opt.mem), pre, post, !st);
};
// Walmart object spread
var mrg = function (a, b) {
    var o = {};
    for (var k in a)
        o[k] = a[k];
    for (var k in b)
        o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function (fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for (var i = 0; i < dt.length; ++i) {
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                }
                else {
                    fnStr += st_1;
                    for (var t in v.prototype)
                        fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            }
            else
                fnStr += st_1;
        }
        else
            td[k] = v;
    }
    return [fnStr, td];
};
var ch = [];
// clone bufs
var cbfs = function (v) {
    var tl = [];
    for (var k in v) {
        if (v[k] instanceof u8 || v[k] instanceof u16 || v[k] instanceof u32)
            tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    }
    return tl;
};
// use a worker to execute code
var wrkr = function (fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for (var i = 0; i < m; ++i)
            _a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function () { return [u8, u16, u32, fleb, fdeb, clim, fl, fd, flrm, fdrm, rev, hMap, max, bits, bits16, shft, slc, inflt, inflateSync, pbf, gu8]; };
var bDflt = function () { return [u8, u16, u32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf]; };
// gzip extra
var gze = function () { return [gzh, gzhl, wbytes, crc, crct]; };
// gunzip extra
var guze = function () { return [gzs, gzl]; };
// zlib extra
var zle = function () { return [zlh, wbytes, adler]; };
// unzlib extra
var zule = function () { return [zlv]; };
// post buf
var pbf = function (msg) { return postMessage(msg, [msg.buffer]); };
// get u8
var gu8 = function (o) { return o && o.size && new u8(o.size); };
// async helper
var cbify = function (dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function (err, dat) {
        w.terminate();
        cb(err, dat);
    });
    if (!opts.consume)
        dat = new u8(dat);
    w.postMessage([dat, opts], [dat.buffer]);
    return function () { w.terminate(); };
};
// auto stream
var astrm = function (strm) {
    strm.ondata = function (dat, final) { return postMessage([dat, final], [dat.buffer]); };
    return function (ev) { return strm.push(ev.data[0], ev.data[1]); };
};
// async stream attach
var astrmify = function (fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function (err, dat) {
        if (err)
            w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1])
                w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function (d, f) {
        if (t)
            throw 'stream finished';
        if (!strm.ondata)
            throw 'no stream handler';
        w.postMessage([d, t = f], [d.buffer]);
    };
    strm.terminate = function () { w.terminate(); };
};
// read 2 bytes
var b2 = function (d, b) { return d[b] | (d[b + 1] << 8); };
// read 4 bytes
var b4 = function (d, b) { return (d[b] | (d[b + 1] << 8) | (d[b + 2] << 16)) + (d[b + 3] << 23) * 2; };
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function (c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0)
        wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for (var i = 0; i <= fn.length; ++i)
            c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function (d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8)
        throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4)
        st += d[10] | (d[11] << 8) + 2;
    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++])
        ;
    return st + (flg & 2);
};
// gzip length
var gzl = function (d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16) + (2 * (d[l - 1] << 23));
};
// gzip header length
var gzhl = function (o) { return 10 + ((o.filename && (o.filename.length + 1)) || 0); };
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (fl ? (32 - 2 * fl) : 1);
};
// zlib valid
var zlv = function (d) {
    if ((d[0] & 15) != 8 || (d[0] >>> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        throw 'invalid zlib data';
    if (d[1] & 32)
        throw 'invalid zlib data: preset dictionaries not supported';
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function')
        cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */
var Deflate = /*#__PURE__*/ (function () {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function (c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Deflate.prototype.push = function (chunk, final) {
        if (this.d)
            throw 'stream finished';
        if (!this.ondata)
            throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}());

/**
 * Asynchronous streaming DEFLATE compression
 */
var AsyncDeflate = /*#__PURE__*/ (function () {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function () { return [astrm, Deflate]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}());

function deflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bDflt,
    ], function (ev) { return pbf(deflateSync(ev.data[0], ev.data[1])); }, 0, cb);
}
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */
function deflateSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    return dopt(data, opts, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */
var Inflate = /*#__PURE__*/ (function () {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */
    function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function (c) {
        if (this.d)
            throw 'stream finished';
        if (!this.ondata)
            throw 'no stream handler';
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function (final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, (this.s.p / 8) >> 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */
    Inflate.prototype.push = function (chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}());

/**
 * Asynchronous streaming DEFLATE decompression
 */
var AsyncInflate = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function () { return [astrm, Inflate]; }
        ], this, 0, function () {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}());

function inflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bInflt
    ], function (ev) { return pbf(inflateSync(ev.data[0], gu8(ev.data[1]))); }, 1, cb);
}
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */
var Gzip = /*#__PURE__*/ (function () {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gzip.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function (c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v)
            gzh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}());

/**
 * Asynchronous streaming GZIP compression
 */
var AsyncGzip = /*#__PURE__*/ (function () {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function () { return [astrm, Deflate, Gzip]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}());

function gzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bDflt,
        gze,
        function () { return [gzipSync]; }
    ], function (ev) { return pbf(gzipSync(ev.data[0], ev.data[1])); }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */
function gzipSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */
var Gunzip = /*#__PURE__*/ (function () {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */
    function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gunzip.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = gzs(this.p);
            if (s >= this.p.length && !final)
                return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8)
                throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}());

/**
 * Asynchronous streaming GZIP decompression
 */
var AsyncGunzip = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function () { return [astrm, Inflate, Gunzip]; }
        ], this, 0, function () {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}());

function gunzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bInflt,
        guze,
        function () { return [gunzipSync]; }
    ], function (ev) { return pbf(gunzipSync(ev.data[0])); }, 3, cb);
}
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */
var Zlib = /*#__PURE__*/ (function () {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Zlib.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function (c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v)
            zlh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}());

/**
 * Asynchronous streaming Zlib compression
 */
var AsyncZlib = /*#__PURE__*/ (function () {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function () { return [astrm, Deflate, Zlib]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}());

function zlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bDflt,
        zle,
        function () { return [zlibSync]; }
    ], function (ev) { return pbf(zlibSync(ev.data[0], ev.data[1])); }, 4, cb);
}
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */
var Unzlib = /*#__PURE__*/ (function () {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */
    function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzlib.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final)
                return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4)
                throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}());

/**
 * Asynchronous streaming Zlib decompression
 */
var AsyncUnzlib = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function () { return [astrm, Inflate, Unzlib]; }
        ], this, 0, function () {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}());

function unzlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bInflt,
        zule,
        function () { return [unzlibSync]; }
    ], function (ev) { return pbf(unzlibSync(ev.data[0], gu8(ev.data[1]))); }, 5, cb);
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
// Default algorithm for compression (used because having a known output size allows faster decompression)

// Default algorithm for compression (used because having a known output size allows faster decompression)

/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var Decompress = /*#__PURE__*/ (function () {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */
    function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Decompress.prototype.push = function (chunk, final) {
        if (!this.ondata)
            throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            }
            else
                this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function () { _this_1.ondata.apply(_this_1, arguments); };
                this.s = (this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8)
                    ? new this.G(cb)
                    : ((this.p[0] & 15) != 8 || (this.p[0] >> 4) > 7 || ((this.p[0] << 8 | this.p[1]) % 31))
                        ? new this.I(cb)
                        : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        }
        else
            this.s.push(chunk, final);
    };
    return Decompress;
}());

/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var AsyncDecompress = /*#__PURE__*/ (function () {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */
    function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncDecompress.prototype.push = function (chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}());

function decompress(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzip(data, opts, cb)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflate(data, opts, cb)
            : unzlib(data, opts, cb);
}
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function decompressSync(data, out) {
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzipSync(data, out)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflateSync(data, out)
            : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function (d, p, t, o) {
    for (var k in d) {
        var val = d[k], n = p + k;
        if (val instanceof u8)
            t[n] = [val, o];
        else if (Array.isArray(val))
            t[n] = [val[0], mrg(o, val[1])];
        else
            fltn(val, n + '/', t, o);
    }
};
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
    var l = str.length;
    if (!latin1 && typeof TextEncoder != 'undefined')
        return new TextEncoder().encode(str);
    var ar = new u8(str.length + (str.length >>> 1));
    var ai = 0;
    var w = function (v) { ar[ai++] = v; };
    for (var i = 0; i < l; ++i) {
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + ((l - i) << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1)
            w(c);
        else if (c < 2048)
            w(192 | (c >>> 6)), w(128 | (c & 63));
        else if (c > 55295 && c < 57344)
            c = 65536 + (c & 1023 << 10) | (str.charCodeAt(++i) & 1023),
                w(240 | (c >>> 18)), w(128 | ((c >>> 12) & 63)), w(128 | ((c >>> 6) & 63)), w(128 | (c & 63));
        else
            w(224 | (c >>> 12)), w(128 | ((c >>> 6) & 63)), w(128 | (c & 63));
    }
    return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
    var r = '';
    if (!latin1 && typeof TextDecoder != 'undefined')
        return new TextDecoder().decode(dat);
    for (var i = 0; i < dat.length;) {
        var c = dat[i++];
        if (c < 128 || latin1)
            r += String.fromCharCode(c);
        else if (c < 224)
            r += String.fromCharCode((c & 31) << 6 | (dat[i++] & 63));
        else if (c < 240)
            r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | (dat[i++] & 63));
        else
            c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | (dat[i++] & 63)) - 65536,
                r += String.fromCharCode(55296 | (c >> 10), 56320 | (c & 1023));
    }
    return r;
}
;
// skip local zip header
var slzh = function (d, b) { return b + 30 + b2(d, b + 26) + b2(d, b + 28); };
// read zip header
var zh = function (d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = z ? z64e(d, es) : [b4(d, b + 20), b4(d, b + 24), b4(d, b + 42)], sc = _a[0], su = _a[1], off = _a[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
};
// read zip64 extra field
var z64e = function (d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2))
        ;
    return [b4(d, b + 12), b4(d, b + 4), b4(d, b + 20)];
};
// write zip header
var wzh = function (d, b, c, cmp, su, fn, u, o, ce, t) {
    var fl = fn.length, l = cmp.length;
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null)
        d[b] = 20, b += 2;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = (t == 8 && (o.level == 1 ? 6 : o.level < 6 ? 4 : o.level == 9 ? 2 : 0)), d[b++] = u && 8;
    d[b] = t, b += 2;
    var dt = new Date(o.mtime || Date.now()), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119)
        throw 'date not in range 1980-2099';
    wbytes(d, b, ((y << 24) * 2) | ((dt.getMonth() + 1) << 21) | (dt.getDate() << 16) | (dt.getHours() << 11) | (dt.getMinutes() << 5) | (dt.getSeconds() >>> 1));
    b += 4;
    wbytes(d, b, c);
    wbytes(d, b + 4, l);
    wbytes(d, b + 8, su);
    wbytes(d, b + 12, fl), b += 16; // skip extra field, comment
    if (ce != null)
        wbytes(d, b += 10, ce), b += 4;
    d.set(fn, b);
    b += fl;
    if (ce == null)
        d.set(cmp, b);
};
// write zip footer (end of central directory)
var wzf = function (o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
function zip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var cbf = function () {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for (var i = 0; i < slft; ++i) {
            var f = files[i];
            try {
                wzh(out, tot, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
                wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, tot, f.t), o += 46 + f.n.length, tot += 30 + f.n.length + f.d.length;
            }
            catch (e) {
                return cb(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft)
        cbf();
    var _loop_1 = function (i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), m = file.length;
        c.p(file);
        var n = strToU8(fn), s = n.length;
        var t = p.level == 0 ? 0 : 8;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cb(e, null);
            }
            else {
                var l = d.length;
                files[i] = {
                    t: t,
                    d: d,
                    m: m,
                    c: c.d(),
                    u: fn.length != l,
                    n: n,
                    p: p
                };
                o += 30 + s + l;
                tot += 76 + 2 * s + l;
                if (!--lft)
                    cbf();
            }
        };
        if (n.length > 65535)
            cbl('filename too long', null);
        if (!t)
            cbl(null, file);
        else if (m < 160000) {
            try {
                cbl(null, deflateSync(file, p));
            }
            catch (e) {
                cbl(e, null);
            }
        }
        else
            term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for (var i = 0; i < slft; ++i) {
        _loop_1(i);
    }
    return tAll;
}
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */
function zipSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for (var fn in r) {
        var _a = r[fn], file = _a[0], p = _a[1];
        var t = p.level == 0 ? 0 : 8;
        var n = strToU8(fn), s = n.length;
        if (n.length > 65535)
            throw 'filename too long';
        var d = t ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push({
            t: t,
            d: d,
            m: file.length,
            c: c.d(),
            u: fn.length != s,
            n: n,
            o: o,
            p: p
        });
        o += 30 + s + l;
        tot += 76 + 2 * s + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for (var i = 0; i < files.length; ++i) {
        var f = files[i];
        wzh(out, f.o, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
        wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, f.o, f.t), o += 46 + f.n.length;
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Asynchronously decompresses a ZIP archive
 * @param data The raw compressed ZIP file
 * @param cb The callback to call with the decompressed files
 * @returns A function that can be used to immediately terminate the unzipping
 */
function unzip(data, cb) {
    if (typeof cb != 'function')
        throw 'no callback';
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) {
            cb('invalid zip file', null);
            return;
        }
    }
    ;
    var lft = b2(data, e + 8);
    if (!lft)
        cb(null, {});
    var c = lft;
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50)
            throw 'invalid zip file';
        c = lft = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    var _loop_2 = function (i) {
        var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cb(e, null);
            }
            else {
                files[fn] = d;
                if (!--lft)
                    cb(null, files);
            }
        };
        if (!c_1)
            cbl(null, slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) {
                try {
                    cbl(null, inflateSync(infl, new u8(su)));
                }
                catch (e) {
                    cbl(e, null);
                }
            }
            else
                term.push(inflate(infl, { size: su }, cbl));
        }
        else
            cbl('unknown compression type ' + c_1, null);
    };
    for (var i = 0; i < c; ++i) {
        _loop_2(i);
    }
    return tAll;
}
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @returns The decompressed files
 */
function unzipSync(data) {
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558)
            throw 'invalid zip file';
    }
    ;
    var c = b2(data, e + 8);
    if (!c)
        return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50)
            throw 'invalid zip file';
        c = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    for (var i = 0; i < c; ++i) {
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!c_2)
            files[fn] = slc(data, b, b + sc);
        else if (c_2 == 8)
            files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
        else
            throw 'unknown compression type ' + c_2;
    }
    return files;
}


/***/ }),

/***/ "./node_modules/html2canvas/dist/html2canvas.js":
/*!******************************************************!*\
  !*** ./node_modules/html2canvas/dist/html2canvas.js ***!
  \******************************************************/
/***/ (function(module) {

/*!
 * html2canvas 1.0.0 <https://html2canvas.hertzen.com>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    0;
}(this, function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var Bounds = /** @class */ (function () {
        function Bounds(x, y, w, h) {
            this.left = x;
            this.top = y;
            this.width = w;
            this.height = h;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (clientRect) {
            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
        };
        return Bounds;
    }());
    var parseBounds = function (node) {
        return Bounds.fromClientRect(node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 1.1.1 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup[base64.charCodeAt(i)];
            encoded2 = lookup[base64.charCodeAt(i + 1)];
            encoded3 = lookup[base64.charCodeAt(i + 2)];
            encoded4 = lookup[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    var base64 = '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';

    /* @flow */
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR = 2; //  Cause a line break (after), except between CR and LF
    var LF = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var UnicodeTrie = createTrieFromBase64(base64);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR, LF, NL];
    var SPACE = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indicies = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indicies.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indicies.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indicies.push(indicies[index - 1]);
                    return types.push(prev);
                }
                indicies.push(index);
                return types.push(AL);
            }
            indicies.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indicies, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED;
        }
        // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
        if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI && next === RI) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED) { }
                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var TokenType;
    (function (TokenType) {
        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
    })(TokenType || (TokenType = {}));
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE$1 = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE$1;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: TokenType.LEFT_PARENTHESIS_TOKEN
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: TokenType.RIGHT_PARENTHESIS_TOKEN
    };
    var COMMA_TOKEN = { type: TokenType.COMMA_TOKEN };
    var SUFFIX_MATCH_TOKEN = { type: TokenType.SUFFIX_MATCH_TOKEN };
    var PREFIX_MATCH_TOKEN = { type: TokenType.PREFIX_MATCH_TOKEN };
    var COLUMN_TOKEN = { type: TokenType.COLUMN_TOKEN };
    var DASH_MATCH_TOKEN = { type: TokenType.DASH_MATCH_TOKEN };
    var INCLUDE_MATCH_TOKEN = { type: TokenType.INCLUDE_MATCH_TOKEN };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
    };
    var SUBSTRING_MATCH_TOKEN = { type: TokenType.SUBSTRING_MATCH_TOKEN };
    var BAD_URL_TOKEN = { type: TokenType.BAD_URL_TOKEN };
    var BAD_STRING_TOKEN = { type: TokenType.BAD_STRING_TOKEN };
    var CDO_TOKEN = { type: TokenType.CDO_TOKEN };
    var CDC_TOKEN = { type: TokenType.CDC_TOKEN };
    var COLON_TOKEN = { type: TokenType.COLON_TOKEN };
    var SEMICOLON_TOKEN = { type: TokenType.SEMICOLON_TOKEN };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
    };
    var WHITESPACE_TOKEN = { type: TokenType.WHITESPACE_TOKEN };
    var EOF_TOKEN = { type: TokenType.EOF_TOKEN };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: TokenType.HASH_TOKEN, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: TokenType.AT_KEYWORD_TOKEN, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: TokenType.DELIM_TOKEN, value: fromCodePoint(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: end };
            }
            else {
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: TokenType.FUNCTION_TOKEN, value: value };
            }
            return { type: TokenType.IDENT_TOKEN, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: TokenType.URL_TOKEN, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === TokenType.STRING_TOKEN) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 60000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: TokenType.STRING_TOKEN, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: TokenType.DIMENSION_TOKEN, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: TokenType.PERCENTAGE_TOKEN, number: number, flags: flags };
            }
            return { type: TokenType.NUMBER_TOKEN, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === TokenType.WHITESPACE_TOKEN) {
                token = this.consumeToken();
            }
            if (token.type === TokenType.EOF_TOKEN) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === TokenType.WHITESPACE_TOKEN);
            if (token.type === TokenType.EOF_TOKEN) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === TokenType.EOF_TOKEN) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
                case TokenType.LEFT_PARENTHESIS_TOKEN:
                    return this.consumeSimpleBlock(token.type);
                case TokenType.FUNCTION_TOKEN:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: TokenType.FUNCTION
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === TokenType.DIMENSION_TOKEN; };
    var isNumberToken = function (token) { return token.type === TokenType.NUMBER_TOKEN; };
    var isIdentToken = function (token) { return token.type === TokenType.IDENT_TOKEN; };
    var isStringToken = function (token) { return token.type === TokenType.STRING_TOKEN; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== TokenType.WHITESPACE_TOKEN; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === TokenType.COMMA_TOKEN) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== TokenType.WHITESPACE_TOKEN) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) {
            return true;
        }
        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) {
            return true;
        }
        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
    };

    var isLength = function (token) {
        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
    };

    var isLengthPercentage = function (token) {
        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: TokenType.NUMBER_TOKEN,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (value) {
            if (value.type === TokenType.DIMENSION_TOKEN) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === TokenType.DIMENSION_TOKEN) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color = {
        name: 'color',
        parse: function (value) {
            if (value.type === TokenType.FUNCTION) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(value.values);
            }
            if (value.type === TokenType.HASH_TOKEN) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === TokenType.IDENT_TOKEN) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === TokenType.NUMBER_TOKEN) {
            return token.number;
        }
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var PropertyDescriptorParsingType;
    (function (PropertyDescriptorParsingType) {
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));

    var BACKGROUND_CLIP;
    (function (BACKGROUND_CLIP) {
        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return BACKGROUND_CLIP.PADDING_BOX;
                        case 'content-box':
                            return BACKGROUND_CLIP.CONTENT_BOX;
                    }
                }
                return BACKGROUND_CLIP.BORDER_BOX;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var parseColorStop = function (args) {
        var color$1 = color.parse(args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color$1, stop: stop } : { color: color$1, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [[0, 0], [0, height], [width, 0], [width, height]];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case CSSRadialExtent.CLOSEST_SIDE:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.CLOSEST_CORNER:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case CSSRadialExtent.FARTHEST_SIDE:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.FARTHEST_CORNER:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: CSSImageType.LINEAR_GRADIENT };
    };

    var prefixLinearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        }
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        Logger.create = function (options) {
            Logger.instances[options.id] = new Logger(options);
        };
        Logger.destroy = function (id) {
            delete Logger.instances[id];
        };
        Logger.getInstance = function (id) {
            var instance = Logger.instances[id];
            if (typeof instance === 'undefined') {
                throw new Error("No logger instance found with id " + id);
            }
            return instance;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.create = function (name, options) {
            return (CacheStorage._caches[name] = new Cache(name, options));
        };
        CacheStorage.destroy = function (name) {
            delete CacheStorage._caches[name];
        };
        CacheStorage.open = function (name) {
            var cache = CacheStorage._caches[name];
            if (typeof cache !== 'undefined') {
                return cache;
            }
            throw new Error("Cache with key \"" + name + "\" not found");
        };
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage.getInstance = function () {
            var current = CacheStorage._current;
            if (current === null) {
                throw new Error("No cache instance attached");
            }
            return current;
        };
        CacheStorage.attachInstance = function (cache) {
            CacheStorage._current = cache;
        };
        CacheStorage.detachInstance = function () {
            CacheStorage._current = null;
        };
        CacheStorage._caches = {};
        CacheStorage._origin = 'about:blank';
        CacheStorage._current = null;
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(id, options) {
            this.id = id;
            this._options = options;
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                this._cache[src] = this.loadImage(src);
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !useProxy && !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                xhr.open('GET', proxy + "?url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var webkitGradient = function (tokens) {
        var angle = deg(180);
        var stops = [];
        var type = CSSImageType.LINEAR_GRADIENT;
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = CSSImageType.LINEAR_GRADIENT;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = CSSImageType.RADIAL_GRADIENT;
                    return;
                }
            }
            if (firstToken.type === TokenType.FUNCTION) {
                if (firstToken.name === 'from') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color$1 });
                }
                else if (firstToken.name === 'to') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color$1 });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color$1 = color.parse(values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: TokenType.PERCENTAGE_TOKEN, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color$1
                            });
                        }
                    }
                }
            }
        });
        return type === CSSImageType.LINEAR_GRADIENT
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var prefixRadialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var CSSImageType;
    (function (CSSImageType) {
        CSSImageType[CSSImageType["URL"] = 0] = "URL";
        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
    })(CSSImageType || (CSSImageType = {}));
    var isLinearGradient = function (background) {
        return background.type === CSSImageType.LINEAR_GRADIENT;
    };
    var isRadialGradient = function (background) {
        return background.type === CSSImageType.RADIAL_GRADIENT;
    };
    var CSSRadialShape;
    (function (CSSRadialShape) {
        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
    })(CSSRadialShape || (CSSRadialShape = {}));
    var CSSRadialExtent;
    (function (CSSRadialExtent) {
        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
    })(CSSRadialExtent || (CSSRadialExtent = {}));
    var image = {
        name: 'image',
        parse: function (value) {
            if (value.type === TokenType.URL_TOKEN) {
                var image_1 = { url: value.value, type: CSSImageType.URL };
                CacheStorage.getInstance().addImage(value.value);
                return image_1;
            }
            if (value.type === TokenType.FUNCTION) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(value.values);
            }
            throw new Error("Unsupported image type");
        }
    };
    function isSupportedImage(value) {
        return value.type !== TokenType.FUNCTION || SUPPORTED_IMAGE_FUNCTIONS[value.name];
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens.filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); }).map(image.parse);
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var BACKGROUND_REPEAT;
    (function (BACKGROUND_REPEAT) {
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return BACKGROUND_REPEAT.NO_REPEAT;
            case 'repeat-x':
            case 'repeat no-repeat':
                return BACKGROUND_REPEAT.REPEAT_X;
            case 'repeat-y':
            case 'no-repeat repeat':
                return BACKGROUND_REPEAT.REPEAT_Y;
            case 'repeat':
            default:
                return BACKGROUND_REPEAT.REPEAT;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) { return parseLengthPercentageTuple(tokens.filter(isLengthPercentage)); }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var BORDER_STYLE;
    (function (BORDER_STYLE) {
        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
        BORDER_STYLE[BORDER_STYLE["DASHED"] = 2] = "DASHED";
        BORDER_STYLE[BORDER_STYLE["DOTTED"] = 3] = "DOTTED";
        BORDER_STYLE[BORDER_STYLE["DOUBLE"] = 4] = "DOUBLE";
    })(BORDER_STYLE || (BORDER_STYLE = {}));
    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (style) {
            switch (style) {
                case 'none':
                    return BORDER_STYLE.NONE;
                case 'dashed':
                    return BORDER_STYLE.DASHED;
                case 'dotted':
                    return BORDER_STYLE.DOTTED;
                case 'double':
                    return BORDER_STYLE.DOUBLE;
            }
            return BORDER_STYLE.SOLID;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color$1 = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var FLOAT;
    (function (FLOAT) {
        FLOAT[FLOAT["NONE"] = 0] = "NONE";
        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
    })(FLOAT || (FLOAT = {}));
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (float) {
            switch (float) {
                case 'left':
                    return FLOAT.LEFT;
                case 'right':
                    return FLOAT.RIGHT;
                case 'inline-start':
                    return FLOAT.INLINE_START;
                case 'inline-end':
                    return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'normal') {
                return 0;
            }
            if (token.type === TokenType.NUMBER_TOKEN) {
                return token.number;
            }
            if (token.type === TokenType.DIMENSION_TOKEN) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === TokenType.NUMBER_TOKEN) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            return image.parse(token);
        }
    };

    var LIST_STYLE_POSITION;
    (function (LIST_STYLE_POSITION) {
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'inside':
                    return LIST_STYLE_POSITION.INSIDE;
                case 'outside':
                default:
                    return LIST_STYLE_POSITION.OUTSIDE;
            }
        }
    };

    var LIST_STYLE_TYPE;
    (function (LIST_STYLE_TYPE) {
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (type) {
            switch (type) {
                case 'disc':
                    return LIST_STYLE_TYPE.DISC;
                case 'circle':
                    return LIST_STYLE_TYPE.CIRCLE;
                case 'square':
                    return LIST_STYLE_TYPE.SQUARE;
                case 'decimal':
                    return LIST_STYLE_TYPE.DECIMAL;
                case 'cjk-decimal':
                    return LIST_STYLE_TYPE.CJK_DECIMAL;
                case 'decimal-leading-zero':
                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
                case 'lower-roman':
                    return LIST_STYLE_TYPE.LOWER_ROMAN;
                case 'upper-roman':
                    return LIST_STYLE_TYPE.UPPER_ROMAN;
                case 'lower-greek':
                    return LIST_STYLE_TYPE.LOWER_GREEK;
                case 'lower-alpha':
                    return LIST_STYLE_TYPE.LOWER_ALPHA;
                case 'upper-alpha':
                    return LIST_STYLE_TYPE.UPPER_ALPHA;
                case 'arabic-indic':
                    return LIST_STYLE_TYPE.ARABIC_INDIC;
                case 'armenian':
                    return LIST_STYLE_TYPE.ARMENIAN;
                case 'bengali':
                    return LIST_STYLE_TYPE.BENGALI;
                case 'cambodian':
                    return LIST_STYLE_TYPE.CAMBODIAN;
                case 'cjk-earthly-branch':
                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
                case 'cjk-heavenly-stem':
                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
                case 'cjk-ideographic':
                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
                case 'devanagari':
                    return LIST_STYLE_TYPE.DEVANAGARI;
                case 'ethiopic-numeric':
                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
                case 'georgian':
                    return LIST_STYLE_TYPE.GEORGIAN;
                case 'gujarati':
                    return LIST_STYLE_TYPE.GUJARATI;
                case 'gurmukhi':
                    return LIST_STYLE_TYPE.GURMUKHI;
                case 'hebrew':
                    return LIST_STYLE_TYPE.HEBREW;
                case 'hiragana':
                    return LIST_STYLE_TYPE.HIRAGANA;
                case 'hiragana-iroha':
                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
                case 'japanese-formal':
                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
                case 'japanese-informal':
                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
                case 'kannada':
                    return LIST_STYLE_TYPE.KANNADA;
                case 'katakana':
                    return LIST_STYLE_TYPE.KATAKANA;
                case 'katakana-iroha':
                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
                case 'khmer':
                    return LIST_STYLE_TYPE.KHMER;
                case 'korean-hangul-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
                case 'korean-hanja-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
                case 'korean-hanja-informal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
                case 'lao':
                    return LIST_STYLE_TYPE.LAO;
                case 'lower-armenian':
                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
                case 'malayalam':
                    return LIST_STYLE_TYPE.MALAYALAM;
                case 'mongolian':
                    return LIST_STYLE_TYPE.MONGOLIAN;
                case 'myanmar':
                    return LIST_STYLE_TYPE.MYANMAR;
                case 'oriya':
                    return LIST_STYLE_TYPE.ORIYA;
                case 'persian':
                    return LIST_STYLE_TYPE.PERSIAN;
                case 'simp-chinese-formal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
                case 'simp-chinese-informal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
                case 'tamil':
                    return LIST_STYLE_TYPE.TAMIL;
                case 'telugu':
                    return LIST_STYLE_TYPE.TELUGU;
                case 'thai':
                    return LIST_STYLE_TYPE.THAI;
                case 'tibetan':
                    return LIST_STYLE_TYPE.TIBETAN;
                case 'trad-chinese-formal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
                case 'trad-chinese-informal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
                case 'upper-armenian':
                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
                case 'disclosure-open':
                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
                case 'disclosure-closed':
                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
                case 'none':
                default:
                    return LIST_STYLE_TYPE.NONE;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var OVERFLOW;
    (function (OVERFLOW) {
        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
    })(OVERFLOW || (OVERFLOW = {}));
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return OVERFLOW.HIDDEN;
                    case 'scroll':
                        return OVERFLOW.SCROLL;
                    case 'auto':
                        return OVERFLOW.AUTO;
                    case 'visible':
                    default:
                        return OVERFLOW.VISIBLE;
                }
            });
        }
    };

    var OVERFLOW_WRAP;
    (function (OVERFLOW_WRAP) {
        OVERFLOW_WRAP["NORMAL"] = "normal";
        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'break-word':
                    return OVERFLOW_WRAP.BREAK_WORD;
                case 'normal':
                default:
                    return OVERFLOW_WRAP.NORMAL;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var TEXT_ALIGN;
    (function (TEXT_ALIGN) {
        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textAlign) {
            switch (textAlign) {
                case 'right':
                    return TEXT_ALIGN.RIGHT;
                case 'center':
                case 'justify':
                    return TEXT_ALIGN.CENTER;
                case 'left':
                default:
                    return TEXT_ALIGN.LEFT;
            }
        }
    };

    var POSITION;
    (function (POSITION) {
        POSITION[POSITION["STATIC"] = 0] = "STATIC";
        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
        POSITION[POSITION["FIXED"] = 3] = "FIXED";
        POSITION[POSITION["STICKY"] = 4] = "STICKY";
    })(POSITION || (POSITION = {}));
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'relative':
                    return POSITION.RELATIVE;
                case 'absolute':
                    return POSITION.ABSOLUTE;
                case 'fixed':
                    return POSITION.FIXED;
                case 'sticky':
                    return POSITION.STICKY;
            }
            return POSITION.STATIC;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var TEXT_TRANSFORM;
    (function (TEXT_TRANSFORM) {
        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return TEXT_TRANSFORM.UPPERCASE;
                case 'lowercase':
                    return TEXT_TRANSFORM.LOWERCASE;
                case 'capitalize':
                    return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
        }
    };

    var transform = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            if (token.type === TokenType.FUNCTION) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1], _a = values[2], _b = values[3], a2 = values[4], b2 = values[5], _c = values[6], _d = values[7], _e = values[8], _f = values[9], _g = values[10], _h = values[11], a4 = values[12], b4 = values[13], _j = values[14], _k = values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var VISIBILITY;
    (function (VISIBILITY) {
        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
    })(VISIBILITY || (VISIBILITY = {}));
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (visibility) {
            switch (visibility) {
                case 'hidden':
                    return VISIBILITY.HIDDEN;
                case 'collapse':
                    return VISIBILITY.COLLAPSE;
                case 'visible':
                default:
                    return VISIBILITY.VISIBLE;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case TokenType.IDENT_TOKEN:
                    case TokenType.STRING_TOKEN:
                        accumulator.push(token.value);
                        break;
                    case TokenType.NUMBER_TOKEN:
                        accumulator.push(token.number.toString());
                        break;
                    case TokenType.COMMA_TOKEN:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var FONT_STYLE;
    (function (FONT_STYLE) {
        FONT_STYLE["NORMAL"] = "normal";
        FONT_STYLE["ITALIC"] = "italic";
        FONT_STYLE["OBLIQUE"] = "oblique";
    })(FONT_STYLE || (FONT_STYLE = {}));
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'oblique':
                    return FONT_STYLE.OBLIQUE;
                case 'italic':
                    return FONT_STYLE.ITALIC;
                case 'normal':
                default:
                    return FONT_STYLE.NORMAL;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === TokenType.IDENT_TOKEN) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(declaration) {
            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(boxShadow, declaration.boxShadow);
            this.color = parse(color$1, declaration.color);
            this.display = parse(display, declaration.display);
            this.float = parse(float, declaration.cssFloat);
            this.fontFamily = parse(fontFamily, declaration.fontFamily);
            this.fontSize = parse(fontSize, declaration.fontSize);
            this.fontStyle = parse(fontStyle, declaration.fontStyle);
            this.fontVariant = parse(fontVariant, declaration.fontVariant);
            this.fontWeight = parse(fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(lineBreak, declaration.lineBreak);
            this.lineHeight = parse(lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(listStyleType, declaration.listStyleType);
            this.marginTop = parse(marginTop, declaration.marginTop);
            this.marginRight = parse(marginRight, declaration.marginRight);
            this.marginBottom = parse(marginBottom, declaration.marginBottom);
            this.marginLeft = parse(marginLeft, declaration.marginLeft);
            this.opacity = parse(opacity, declaration.opacity);
            var overflowTuple = parse(overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(paddingTop, declaration.paddingTop);
            this.paddingRight = parse(paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
            this.position = parse(position, declaration.position);
            this.textAlign = parse(textAlign, declaration.textAlign);
            this.textDecorationColor = parse(textDecorationColor, declaration.textDecorationColor || declaration.color);
            this.textDecorationLine = parse(textDecorationLine, declaration.textDecorationLine);
            this.textShadow = parse(textShadow, declaration.textShadow);
            this.textTransform = parse(textTransform, declaration.textTransform);
            this.transform = parse(transform, declaration.transform);
            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
            this.visibility = parse(visibility, declaration.visibility);
            this.wordBreak = parse(wordBreak, declaration.wordBreak);
            this.zIndex = parse(zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== POSITION.STATIC;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== FLOAT.NONE;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(declaration) {
            this.content = parse(content, declaration.content);
            this.quotes = parse(quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(declaration) {
            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case PropertyDescriptorParsingType.IDENT_VALUE:
                var token = parser.parseComponentValue();
                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
            case PropertyDescriptorParsingType.VALUE:
                return descriptor.parse(parser.parseComponentValue());
            case PropertyDescriptorParsingType.LIST:
                return descriptor.parse(parser.parseComponentValues());
            case PropertyDescriptorParsingType.TOKEN_VALUE:
                return parser.parseComponentValue();
            case PropertyDescriptorParsingType.TYPE_VALUE:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(parser.parseComponentValue());
                    case 'color':
                        return color.parse(parser.parseComponentValue());
                    case 'image':
                        return image.parse(parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                }
        }
        throw new Error("Attempting to parse unsupported css format type " + descriptor.format);
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(element) {
            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
            this.textNodes = [];
            this.elements = [];
            if (this.styles.transform !== null && isHTMLElementNode(element)) {
                // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(element);
            this.flags = 0;
        }
        return ElementContainer;
    }());

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return new Bounds(0, 0, 0, 0);
    };
    var getRangeBounds = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return Bounds.fromClientRect(range.getBoundingClientRect());
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function (i) { return fromCodePoint(i); }) : breakWords(value, styles);
    };
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                words.push(bk.value.slice());
            }
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(node, styles) {
            this.text = transform$1(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform$1 = function (text, transform) {
        switch (transform) {
            case TEXT_TRANSFORM.LOWERCASE:
                return text.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
                return text.replace(CAPITALIZE, capitalize);
            case TEXT_TRANSFORM.UPPERCASE:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(img) {
            var _this = _super.call(this, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            CacheStorage.getInstance().addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(canvas) {
            var _this = _super.call(this, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(img) {
            var _this = _super.call(this, img) || this;
            var s = new XMLSerializer();
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            CacheStorage.getInstance().addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: TokenType.DIMENSION_TOKEN,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: TokenType.PERCENTAGE_TOKEN,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(input) {
            var _this = _super.call(this, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle =
                    BORDER_STYLE.SOLID;
                _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(element) {
            var _this = _super.call(this, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var parseColor = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(iframe) {
            var _this = _super.call(this, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.documentElement)
                            .backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                var container = createContainer(childNode);
                if (container.styles.isVisible()) {
                    if (createsRealStackingContext(childNode, container, root)) {
                        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                    }
                    else if (createsStackingContext(container.styles)) {
                        container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                    }
                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                        container.flags |= 8 /* IS_LIST_OWNER */;
                    }
                    parent.elements.push(container);
                    if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                        parseNodeTree(childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function (element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(element);
        }
        return new ElementContainer(element);
    };
    var parseTree = function (element) {
        var container = createContainer(element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case LIST_STYLE_TYPE.DISC:
                return '•' + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
                return '◦' + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
                return '◾' + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case LIST_STYLE_TYPE.KANNADA:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(element, options) {
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    documentClone.documentElement.style.top = -windowSize.top + 'px';
                                    documentClone.documentElement.style.left = -windowSize.left + 'px';
                                    documentClone.documentElement.style.position = 'absolute';
                                }
                            }
                            onclone = this.options.onclone;
                            if (typeof this.clonedReferenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            /*
            if (isIFrameElement(node)) {
                return this.createIFrameClone(node);
            }
    */
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            // @ts-ignore
            if (isImageElement(clone) && clone.loading === 'lazy') {
                // @ts-ignore
                clone.loading = 'eager';
            }
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                Logger.getInstance(this.options.id).error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) { }
            return clonedCanvas;
        };
        /*
        createIFrameClone(iframe: HTMLIFrameElement) {
            const tempIframe = <HTMLIFrameElement>iframe.cloneNode(false);
            const iframeKey = generateIframeKey();
            tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

            const {width, height} = parseBounds(iframe);

            this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(iframe, this.options)
                .then(documentElement => {
                    return this.renderer(
                        documentElement,
                        {
                            allowTaint: this.options.allowTaint,
                            backgroundColor: '#ffffff',
                            canvas: null,
                            imageTimeout: this.options.imageTimeout,
                            logging: this.options.logging,
                            proxy: this.options.proxy,
                            removeContainer: this.options.removeContainer,
                            scale: this.options.scale,
                            foreignObjectRendering: this.options.foreignObjectRendering,
                            useCORS: this.options.useCORS,
                            target: new CanvasRenderer(),
                            width,
                            height,
                            x: 0,
                            y: 0,
                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                        },
                    );
                })
                .then(
                    (canvas: HTMLCanvasElement) =>
                        new Promise((resolve, reject) => {
                            const iframeCanvas = document.createElement('img');
                            iframeCanvas.onload = () => resolve(canvas);
                            iframeCanvas.onerror = (event) => {
                                // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>'s point of view
                                // and instead of `onload` cause `onerror` and unhandled rejection warnings
                                // https://github.com/niklasvh/html2canvas/issues/1502
                                iframeCanvas.src == 'data:,' ? resolve(canvas) : reject(event);
                            };
                            iframeCanvas.src = canvas.toDataURL();
                            if (tempIframe.parentNode && iframe.ownerDocument && iframe.ownerDocument.defaultView) {
                                tempIframe.parentNode.replaceChild(
                                    copyCSSStyles(
                                        iframe.ownerDocument.defaultView.getComputedStyle(iframe),
                                        iframeCanvas
                                    ),
                                    tempIframe
                                );
                            }
                        })
                );
            return tempIframe;
        }
    */
        DocumentCloner.prototype.cloneNode = function (node) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                for (var child = node.firstChild; child; child = child.nextSibling) {
                    if (!isElementNode(child) ||
                        (!isScriptElement(child) &&
                            !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                            (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                            clone.appendChild(this.cloneNode(child));
                        }
                    }
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) {
                    copyCSSStyles(style, clone);
                }
                //this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(style));
            var declaration = new CSSParsedPseudoDeclaration(style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === TokenType.STRING_TOKEN) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === TokenType.URL_TOKEN) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === TokenType.FUNCTION) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                }
                else if (token.type === TokenType.IDENT_TOKEN) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = function () {
                cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            // Safari shows pseudoelements if content is set
            if (property !== 'content') {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var PathType;
    (function (PathType) {
        PathType[PathType["VECTOR"] = 0] = "VECTOR";
        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
    })(PathType || (PathType = {}));
    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = PathType.VECTOR;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === PathType.BEZIER_CURVE; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.type = 1 /* CLIP */;
            this.target = target;
            this.path = path;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
            this.opacity = opacity;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(element, parentStack) {
            this.container = element;
            this.effects = parentStack.slice(0);
            this.curves = new BoundCurves(element);
            if (element.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(element.styles.opacity));
            }
            if (element.styles.transform !== null) {
                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
                var matrix = element.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getParentEffects = function () {
            var effects = this.effects.slice(0);
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (!equalPath(borderBox, paddingBox)) {
                    effects.push(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
            }
            return effects;
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent.getParentEffects());
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, []);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) {
            return element.bounds;
        }
        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case BACKGROUND_REPEAT.REPEAT_X:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case BACKGROUND_REPEAT.REPEAT_Y:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case BACKGROUND_REPEAT.NO_REPEAT:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function () {
        function CanvasRenderer(options) {
            this._activeEffects = [];
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + "px";
                this.canvas.style.height = options.height + "px";
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            this.ctx.textBaseline = 'bottom';
            this._activeEffects = [];
            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        CanvasRenderer.prototype.applyEffects = function (effects, target) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.filter(function (effect) { return contains(effect.target, target); }).forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
            }
            else {
                var letters = toCodePoints(text.text).map(function (i) { return fromCodePoint(i); });
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + text.bounds.height);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = styles.fontFamily.join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize;
                var _this = this;
                return __generator(this, function (_b) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    text.textBounds.forEach(function (text) {
                        _this.ctx.fillStyle = asString(styles.color);
                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing);
                        var textShadows = styles.textShadow;
                        if (textShadows.length && text.text.trim().length) {
                            textShadows
                                .slice(0)
                                .reverse()
                                .forEach(function (textShadow) {
                                _this.ctx.shadowColor = asString(textShadow.color);
                                _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                _this.ctx.shadowBlur = textShadow.blur.number;
                                _this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                            });
                            _this.ctx.shadowColor = '';
                            _this.ctx.shadowOffsetX = 0;
                            _this.ctx.shadowOffsetY = 0;
                            _this.ctx.shadowBlur = 0;
                        }
                        if (styles.textDecorationLine.length) {
                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                            styles.textDecorationLine.forEach(function (textDecorationLine) {
                                switch (textDecorationLine) {
                                    case 1 /* UNDERLINE */:
                                        // Draws a line at the baseline of the font
                                        // TODO As some browsers display the line as more than 1px if the font-size is big,
                                        // need to take that into account both in position and size
                                        var baseline = _this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                        break;
                                    case 2 /* OVERLINE */:
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                        break;
                                    case 3 /* LINE_THROUGH */:
                                        // TODO try and find exact position for line-through
                                        var middle = _this.fontMetrics.getMetrics(fontFamily, fontSize).middle;
                                        _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                        break;
                                }
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, e_1, image, e_2, iframeRenderer, canvas, size, bounds, x, textBounds, img, image, url, e_3, bounds;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.applyEffects(paint.effects, 4 /* CONTENT */);
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _b.label = 5;
                        case 5:
                            _b.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.options.cache.match(container.src)];
                        case 6:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            e_1 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _b.label = 9;
                        case 9:
                            _b.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.options.cache.match(container.svg)];
                        case 10:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            e_2 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer({
                                id: this.options.id,
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                scrollX: 0,
                                scrollY: 0,
                                width: container.width,
                                height: container.height,
                                cache: this.options.cache,
                                windowWidth: container.width,
                                windowHeight: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _b.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _b.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case TEXT_ALIGN.CENTER:
                                        x += bounds.width / 2;
                                        break;
                                    case TEXT_ALIGN.RIGHT:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === CSSImageType.URL)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _b.label = 15;
                        case 15:
                            _b.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.options.cache.match(url)];
                        case 16:
                            image = _b.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            e_3 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _b.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0: 
                        // https://www.w3.org/TR/css-position-3/#painting-order
                        // 1. the background and borders of the element forming the stacking context.
                        return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            if (image.width === width && image.height === height) {
                return image;
            }
            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, e_4, _a, path, x, y, width, height, pattern, _b, path, x, y, width, height, _c, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _d, path, left, top_1, width, height, position, x, y, _e, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            if (!(backgroundImage.type === CSSImageType.URL)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _f.label = 1;
                                        case 1:
                                            _f.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.options.cache.match(url)];
                                        case 2:
                                            image = _f.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_4 = _f.sent();
                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _a = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _a[0], x = _a[1], y = _a[2], width = _a[3], height = _a[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _b = calculateBackgroundRendering(container, index, [null, null, null]), path = _b[0], x = _b[1], y = _b[2], width = _b[3], height = _b[4];
                                                _c = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _c[0], x0 = _c[1], x1 = _c[2], y0 = _c[3], y1 = _c[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], left = _d[1], top_1 = _d[2], width = _d[3], height = _d[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _e = calculateRadius(backgroundImage, x, y, width, height), rx = _e[0], ry = _e[1];
                                                if (rx > 0 && rx > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _f.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */);
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === BORDER_STYLE.DASHED)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, BORDER_STYLE.DASHED)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === BORDER_STYLE.DOTTED)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, BORDER_STYLE.DOTTED)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === BORDER_STYLE.DOUBLE)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === BORDER_STYLE.DASHED) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === BORDER_STYLE.DOTTED) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === BORDER_STYLE.DOTTED) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === BORDER_STYLE.DOTTED) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === BORDER_STYLE.DOTTED) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === BORDER_STYLE.DASHED) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }());
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case BACKGROUND_CLIP.BORDER_BOX:
                return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
                return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case TEXT_ALIGN.CENTER:
                return 'center';
            case TEXT_ALIGN.RIGHT:
                return 'right';
            case TEXT_ALIGN.LEFT:
            default:
                return 'left';
        }
    };

    var ForeignObjectRenderer = /** @class */ (function () {
        function ForeignObjectRenderer(options) {
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + "px";
            this.canvas.style.height = options.height + "px";
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG$1(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }());
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var _this = undefined;
    var parseColor$1 = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(_this, void 0, void 0, function () {
        var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    instanceName = (Math.round(Math.random() * 1000) + Date.now()).toString(16);
                    _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    defaultResourceOptions = {
                        allowTaint: false,
                        imageTimeout: 15000,
                        proxy: undefined,
                        useCORS: false
                    };
                    resourceOptions = __assign({}, defaultResourceOptions, opts);
                    defaultOptions = {
                        backgroundColor: '#ffffff',
                        cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
                        logging: true,
                        removeContainer: true,
                        foreignObjectRendering: false,
                        scale: defaultView.devicePixelRatio || 1,
                        windowWidth: defaultView.innerWidth,
                        windowHeight: defaultView.innerHeight,
                        scrollX: defaultView.pageXOffset,
                        scrollY: defaultView.pageYOffset,
                        x: left,
                        y: top,
                        width: Math.ceil(width),
                        height: Math.ceil(height),
                        id: instanceName
                    };
                    options = __assign({}, defaultOptions, resourceOptions, opts);
                    windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
                    Logger.create({ id: instanceName, enabled: options.logging });
                    Logger.getInstance(instanceName).debug("Starting document clone");
                    documentCloner = new DocumentCloner(element, {
                        id: instanceName,
                        onclone: options.onclone,
                        ignoreElements: options.ignoreElements,
                        inlineImages: options.foreignObjectRendering,
                        copyStyles: options.foreignObjectRendering
                    });
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _b.sent();
                    documentBackgroundColor = ownerDocument.documentElement
                        ? parseColor$1(getComputedStyle(ownerDocument.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bodyBackgroundColor = ownerDocument.body
                        ? parseColor$1(getComputedStyle(ownerDocument.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bgColor = opts.backgroundColor;
                    defaultBackgroundColor = typeof bgColor === 'string' ? parseColor$1(bgColor) : bgColor === null ? COLORS.TRANSPARENT : 0xffffffff;
                    backgroundColor = element === ownerDocument.documentElement
                        ? isTransparent(documentBackgroundColor)
                            ? isTransparent(bodyBackgroundColor)
                                ? defaultBackgroundColor
                                : bodyBackgroundColor
                            : documentBackgroundColor
                        : defaultBackgroundColor;
                    renderOptions = {
                        id: instanceName,
                        cache: options.cache,
                        canvas: options.canvas,
                        backgroundColor: backgroundColor,
                        scale: options.scale,
                        x: options.x,
                        y: options.y,
                        scrollX: options.scrollX,
                        scrollY: options.scrollY,
                        width: options.width,
                        height: options.height,
                        windowWidth: options.windowWidth,
                        windowHeight: options.windowHeight
                    };
                    if (!options.foreignObjectRendering) return [3 /*break*/, 3];
                    Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
                    CacheStorage.attachInstance(options.cache);
                    Logger.getInstance(instanceName).debug("Starting DOM parsing");
                    root = parseTree(clonedElement);
                    CacheStorage.detachInstance();
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    Logger.getInstance(instanceName).debug("Starting renderer");
                    renderer = new CanvasRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _b.sent();
                    _b.label = 5;
                case 5:
                    if (options.removeContainer === true) {
                        if (!DocumentCloner.destroy(container)) {
                            Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    Logger.getInstance(instanceName).debug("Finished rendering");
                    Logger.destroy(instanceName);
                    CacheStorage.destroy(instanceName);
                    return [2 /*return*/, canvas];
            }
        });
    }); };

    return html2canvas;

}));



/***/ }),

/***/ "./node_modules/jspdf/dist/jspdf.es.min.js":
/*!*************************************************!*\
  !*** ./node_modules/jspdf/dist/jspdf.es.min.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AcroForm": function() { return /* binding */ Lt; },
/* harmony export */   "AcroFormAppearance": function() { return /* binding */ wt; },
/* harmony export */   "AcroFormButton": function() { return /* binding */ dt; },
/* harmony export */   "AcroFormCheckBox": function() { return /* binding */ vt; },
/* harmony export */   "AcroFormChoiceField": function() { return /* binding */ ct; },
/* harmony export */   "AcroFormComboBox": function() { return /* binding */ ht; },
/* harmony export */   "AcroFormEditBox": function() { return /* binding */ ft; },
/* harmony export */   "AcroFormListBox": function() { return /* binding */ lt; },
/* harmony export */   "AcroFormPasswordField": function() { return /* binding */ yt; },
/* harmony export */   "AcroFormPushButton": function() { return /* binding */ pt; },
/* harmony export */   "AcroFormRadioButton": function() { return /* binding */ gt; },
/* harmony export */   "AcroFormTextField": function() { return /* binding */ bt; },
/* harmony export */   "GState": function() { return /* binding */ I; },
/* harmony export */   "ShadingPattern": function() { return /* binding */ C; },
/* harmony export */   "TilingPattern": function() { return /* binding */ j; },
/* harmony export */   "jsPDF": function() { return /* binding */ O; }
/* harmony export */ });
/* harmony import */ var fflate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! fflate */ "./node_modules/fflate/esm/browser.js");
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.3.1 Built on 2021-03-08T15:44:11.674Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2020 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2020 yWorks GmbH, http://www.yworks.com
 *               2015-2020 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, willow-systems.com
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */

var r=function(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this}();function n(){r.console&&"function"==typeof r.console.log&&r.console.log.apply(r.console,arguments)}var i={log:n,warn:function(t){r.console&&("function"==typeof r.console.warn?r.console.warn.apply(r.console,arguments):n.call(null,arguments))},error:function(t){r.console&&("function"==typeof r.console.error?r.console.error.apply(r.console,arguments):n(t))}};
/**
 * @license
 * FileSaver.js
 * A saveAs() FileSaver implementation.
 *
 * By Eli Grey, http://eligrey.com
 *
 * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
 * source  : http://purl.eligrey.com/github/FileSaver.js
 */function a(t,e,r){var n=new XMLHttpRequest;n.open("GET",t),n.responseType="blob",n.onload=function(){l(n.response,e,r)},n.onerror=function(){i.error("could not download file")},n.send()}function o(t){var e=new XMLHttpRequest;e.open("HEAD",t,!1);try{e.send()}catch(t){}return e.status>=200&&e.status<=299}function s(t){try{t.dispatchEvent(new MouseEvent("click"))}catch(r){var e=document.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(e)}}var u,c,l=r.saveAs||("object"!=typeof window||window!==r?function(){}:"undefined"!=typeof HTMLAnchorElement&&"download"in HTMLAnchorElement.prototype?function(t,e,n){var i=r.URL||r.webkitURL,u=document.createElement("a");e=e||t.name||"download",u.download=e,u.rel="noopener","string"==typeof t?(u.href=t,u.origin!==location.origin?o(u.href)?a(t,e,n):s(u,u.target="_blank"):s(u)):(u.href=i.createObjectURL(t),setTimeout((function(){i.revokeObjectURL(u.href)}),4e4),setTimeout((function(){s(u)}),0))}:"msSaveOrOpenBlob"in navigator?function(t,e,r){if(e=e||t.name||"download","string"==typeof t)if(o(t))a(t,e,r);else{var n=document.createElement("a");n.href=t,n.target="_blank",setTimeout((function(){s(n)}))}else navigator.msSaveOrOpenBlob(function(t,e){return void 0===e?e={autoBom:!1}:"object"!=typeof e&&(i.warn("Deprecated: Expected third argument to be a object"),e={autoBom:!e}),e.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t}(t,r),e)}:function(t,e,n,i){if((i=i||open("","_blank"))&&(i.document.title=i.document.body.innerText="downloading..."),"string"==typeof t)return a(t,e,n);var o="application/octet-stream"===t.type,s=/constructor/i.test(r.HTMLElement)||r.safari,u=/CriOS\/[\d]+/.test(navigator.userAgent);if((u||o&&s)&&"object"==typeof FileReader){var c=new FileReader;c.onloadend=function(){var t=c.result;t=u?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),i?i.location.href=t:location=t,i=null},c.readAsDataURL(t)}else{var l=r.URL||r.webkitURL,h=l.createObjectURL(t);i?i.location=h:location.href=h,i=null,setTimeout((function(){l.revokeObjectURL(h)}),4e4)}});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */function h(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6));t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var r=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],n=0;n<r.length;n++){var i=r[n].re,a=r[n].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r,this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g,this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),r=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==r.length&&(r="0"+r),"#"+t+e+r}}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function f(t,e){var r=t[0],n=t[1],i=t[2],a=t[3];r=p(r,n,i,a,e[0],7,-680876936),a=p(a,r,n,i,e[1],12,-389564586),i=p(i,a,r,n,e[2],17,606105819),n=p(n,i,a,r,e[3],22,-1044525330),r=p(r,n,i,a,e[4],7,-176418897),a=p(a,r,n,i,e[5],12,1200080426),i=p(i,a,r,n,e[6],17,-1473231341),n=p(n,i,a,r,e[7],22,-45705983),r=p(r,n,i,a,e[8],7,1770035416),a=p(a,r,n,i,e[9],12,-1958414417),i=p(i,a,r,n,e[10],17,-42063),n=p(n,i,a,r,e[11],22,-1990404162),r=p(r,n,i,a,e[12],7,1804603682),a=p(a,r,n,i,e[13],12,-40341101),i=p(i,a,r,n,e[14],17,-1502002290),r=g(r,n=p(n,i,a,r,e[15],22,1236535329),i,a,e[1],5,-165796510),a=g(a,r,n,i,e[6],9,-1069501632),i=g(i,a,r,n,e[11],14,643717713),n=g(n,i,a,r,e[0],20,-373897302),r=g(r,n,i,a,e[5],5,-701558691),a=g(a,r,n,i,e[10],9,38016083),i=g(i,a,r,n,e[15],14,-660478335),n=g(n,i,a,r,e[4],20,-405537848),r=g(r,n,i,a,e[9],5,568446438),a=g(a,r,n,i,e[14],9,-1019803690),i=g(i,a,r,n,e[3],14,-187363961),n=g(n,i,a,r,e[8],20,1163531501),r=g(r,n,i,a,e[13],5,-1444681467),a=g(a,r,n,i,e[2],9,-51403784),i=g(i,a,r,n,e[7],14,1735328473),r=m(r,n=g(n,i,a,r,e[12],20,-1926607734),i,a,e[5],4,-378558),a=m(a,r,n,i,e[8],11,-2022574463),i=m(i,a,r,n,e[11],16,1839030562),n=m(n,i,a,r,e[14],23,-35309556),r=m(r,n,i,a,e[1],4,-1530992060),a=m(a,r,n,i,e[4],11,1272893353),i=m(i,a,r,n,e[7],16,-155497632),n=m(n,i,a,r,e[10],23,-1094730640),r=m(r,n,i,a,e[13],4,681279174),a=m(a,r,n,i,e[0],11,-358537222),i=m(i,a,r,n,e[3],16,-722521979),n=m(n,i,a,r,e[6],23,76029189),r=m(r,n,i,a,e[9],4,-640364487),a=m(a,r,n,i,e[12],11,-421815835),i=m(i,a,r,n,e[15],16,530742520),r=v(r,n=m(n,i,a,r,e[2],23,-995338651),i,a,e[0],6,-198630844),a=v(a,r,n,i,e[7],10,1126891415),i=v(i,a,r,n,e[14],15,-1416354905),n=v(n,i,a,r,e[5],21,-57434055),r=v(r,n,i,a,e[12],6,1700485571),a=v(a,r,n,i,e[3],10,-1894986606),i=v(i,a,r,n,e[10],15,-1051523),n=v(n,i,a,r,e[1],21,-2054922799),r=v(r,n,i,a,e[8],6,1873313359),a=v(a,r,n,i,e[15],10,-30611744),i=v(i,a,r,n,e[6],15,-1560198380),n=v(n,i,a,r,e[13],21,1309151649),r=v(r,n,i,a,e[4],6,-145523070),a=v(a,r,n,i,e[11],10,-1120210379),i=v(i,a,r,n,e[2],15,718787259),n=v(n,i,a,r,e[9],21,-343485551),t[0]=x(r,t[0]),t[1]=x(n,t[1]),t[2]=x(i,t[2]),t[3]=x(a,t[3])}function d(t,e,r,n,i,a){return e=x(x(e,t),x(n,a)),x(e<<i|e>>>32-i,r)}function p(t,e,r,n,i,a,o){return d(e&r|~e&n,t,e,i,a,o)}function g(t,e,r,n,i,a,o){return d(e&n|r&~n,t,e,i,a,o)}function m(t,e,r,n,i,a,o){return d(e^r^n,t,e,i,a,o)}function v(t,e,r,n,i,a,o){return d(r^(e|~n),t,e,i,a,o)}function b(t){var e,r=t.length,n=[1732584193,-271733879,-1732584194,271733878];for(e=64;e<=t.length;e+=64)f(n,y(t.substring(e-64,e)));t=t.substring(e-64);var i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<t.length;e++)i[e>>2]|=t.charCodeAt(e)<<(e%4<<3);if(i[e>>2]|=128<<(e%4<<3),e>55)for(f(n,i),e=0;e<16;e++)i[e]=0;return i[14]=8*r,f(n,i),n}function y(t){var e,r=[];for(e=0;e<64;e+=4)r[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return r}u=r.atob.bind(r),c=r.btoa.bind(r);var w="0123456789abcdef".split("");function N(t){for(var e="",r=0;r<4;r++)e+=w[t>>8*r+4&15]+w[t>>8*r&15];return e}function L(t){return String.fromCharCode((255&t)>>0,(65280&t)>>8,(16711680&t)>>16,(4278190080&t)>>24)}function A(t){return b(t).map(L).join("")}function x(t,e){return t+e&4294967295}if("5d41402abc4b2a76b9719d911017c592"!=function(t){for(var e=0;e<t.length;e++)t[e]=N(t[e]);return t.join("")}(b("hello"))){function x(t,e){var r=(65535&t)+(65535&e);return(t>>16)+(e>>16)+(r>>16)<<16|65535&r}}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */function S(t,e){var r,n,i,a;if(t!==r){for(var o=(i=t,a=1+(256/t.length>>0),new Array(a+1).join(i)),s=[],u=0;u<256;u++)s[u]=u;var c=0;for(u=0;u<256;u++){var l=s[u];c=(c+l+o.charCodeAt(u))%256,s[u]=s[c],s[c]=l}r=t,n=s}else s=n;var h=e.length,f=0,d=0,p="";for(u=0;u<h;u++)d=(d+(l=s[f=(f+1)%256]))%256,s[f]=s[d],s[d]=l,o=s[(s[f]+s[d])%256],p+=String.fromCharCode(e.charCodeAt(u)^o);return p}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */var _={print:4,modify:8,copy:16,"annot-forms":32};function P(t,e,r,n){this.v=1,this.r=2;let i=192;t.forEach((function(t){if(void 0!==_.perm)throw new Error("Invalid permission: "+t);i+=_[t]})),this.padding="(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";let a=(e+this.padding).substr(0,32),o=(r+this.padding).substr(0,32);this.O=this.processOwnerPassword(a,o),this.P=-(1+(255^i)),this.encryptionKey=A(a+this.O+this.lsbFirstWord(this.P)+this.hexToBytes(n)).substr(0,5),this.U=S(this.encryptionKey,this.padding)}function k(t){if("object"!=typeof t)throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var e={};this.subscribe=function(t,r,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof r||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");e.hasOwnProperty(t)||(e[t]={});var i=Math.random().toString(35);return e[t][i]=[r,!!n],i},this.unsubscribe=function(t){for(var r in e)if(e[r][t])return delete e[r][t],0===Object.keys(e[r]).length&&delete e[r],!0;return!1},this.publish=function(n){if(e.hasOwnProperty(n)){var a=Array.prototype.slice.call(arguments,1),o=[];for(var s in e[n]){var u=e[n][s];try{u[0].apply(t,a)}catch(t){r.console&&i.error("jsPDF PubSub Error",t.message,t)}u[1]&&o.push(s)}o.length&&o.forEach(this.unsubscribe)}},this.getTopics=function(){return e}}function I(t){if(!(this instanceof I))return new I(t);var e="opacity,stroke-opacity".split(",");for(var r in t)t.hasOwnProperty(r)&&e.indexOf(r)>=0&&(this[r]=t[r]);this.id="",this.objectNumber=-1}function F(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1}function C(t,e,r,n,i){if(!(this instanceof C))return new C(t,e,r,n,i);this.type="axial"===t?2:3,this.coords=e,this.colors=r,F.call(this,n,i)}function j(t,e,r,n,i){if(!(this instanceof j))return new j(t,e,r,n,i);this.boundingBox=t,this.xStep=e,this.yStep=r,this.stream="",this.cloneIndex=0,F.call(this,n,i)}function O(t){var e,n="string"==typeof arguments[0]?arguments[0]:"p",a=arguments[1],o=arguments[2],s=arguments[3],u=[],f=1,d=16,p="S",g=null;"object"==typeof(t=t||{})&&(n=t.orientation,a=t.unit||a,o=t.format||o,s=t.compress||t.compressPdf||s,null!==(g=t.encryption||null)&&(g.userPassword=g.userPassword||"",g.ownerPassword=g.ownerPassword||"",g.userPermissions=g.userPermissions||[]),f="number"==typeof t.userUnit?Math.abs(t.userUnit):1,void 0!==t.precision&&(e=t.precision),void 0!==t.floatPrecision&&(d=t.floatPrecision),p=t.defaultPathOperation||"S"),u=t.filters||(!0===s?["FlateEncode"]:u),a=a||"mm",n=(""+(n||"P")).toLowerCase();var m=t.putOnlyUsedFonts||!1,v={},b={internal:{},__private__:{}};b.__private__.PubSub=k;var y="1.3",w=b.__private__.getPdfVersion=function(){return y};b.__private__.setPdfVersion=function(t){y=t};var N={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};b.__private__.getPageFormats=function(){return N};var L=b.__private__.getPageFormat=function(t){return N[t]};o=o||"a4";var A={COMPAT:"compat",ADVANCED:"advanced"},x=A.COMPAT;function S(){this.saveGraphicsState(),ct(new Ht(xt,0,0,-xt,0,Er()*xt).toString()+" cm"),this.setFontSize(this.getFontSize()/xt),p="n",x=A.ADVANCED}function _(){this.restoreGraphicsState(),p="S",x=A.COMPAT}var F=function(t,e){if("bold"==t&&"normal"==e||"bold"==t&&400==e||"normal"==t&&"italic"==e||"bold"==t&&"italic"==e)throw new Error("Invalid Combination of fontweight and fontstyle");return e&&t!==e&&(t=400==e?"italic"==t?"italic":"normal":700==e&&"italic"!==t?"bold":t+""+e),t};b.advancedAPI=function(t){var e=x===A.COMPAT;return e&&S.call(this),"function"!=typeof t||(t(this),e&&_.call(this)),this},b.compatAPI=function(t){var e=x===A.ADVANCED;return e&&_.call(this),"function"!=typeof t||(t(this),e&&S.call(this)),this},b.isAdvancedAPI=function(){return x===A.ADVANCED};var B,M=function(t){if(x!==A.ADVANCED)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")},E=b.roundToPrecision=b.__private__.roundToPrecision=function(t,r){var n=e||r;if(isNaN(t)||isNaN(n))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(n).replace(/0+$/,"")};B=b.hpf=b.__private__.hpf="number"==typeof d?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return E(t,d)}:"smart"===d?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return E(t,t>-1&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return E(t,16)};var q=b.f2=b.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return E(t,2)},R=b.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return E(t,3)},T=b.scale=b.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return x===A.COMPAT?t*xt:x===A.ADVANCED?t:void 0},D=function(t){return x===A.COMPAT?Er()-t:x===A.ADVANCED?t:void 0},U=function(t){return T(D(t))};b.__private__.setPrecision=b.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(e=parseInt(t,10))};var z,H="00000000000000000000000000000000",V=b.__private__.getFileId=function(){return H},W=b.__private__.setFileId=function(t){return H=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():H.split("").map((function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))})).join(""),null!==g&&(We=new P(g.userPermissions,g.userPassword,g.ownerPassword,H)),H};b.setFileId=function(t){return W(t),this},b.getFileId=function(){return V()};var G=b.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),r=e<0?"+":"-",n=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[r,Z(n),"'",Z(i),"'"].join("");return["D:",t.getFullYear(),Z(t.getMonth()+1),Z(t.getDate()),Z(t.getHours()),Z(t.getMinutes()),Z(t.getSeconds()),a].join("")},Y=b.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),r=parseInt(t.substr(6,2),10)-1,n=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,r,n,i,a,o,0)},J=b.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=G(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return z=e},X=b.__private__.getCreationDate=function(t){var e=z;return"jsDate"===t&&(e=Y(z)),e};b.setCreationDate=function(t){return J(t),this},b.getCreationDate=function(t){return X(t)};var K,Z=b.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},$=b.__private__.padd2Hex=function(t){return("00"+(t=t.toString())).substr(t.length)},Q=0,tt=[],et=[],rt=0,nt=[],it=[],at=!1,ot=et,st=function(){Q=0,rt=0,et=[],tt=[],nt=[],Zt=Jt(),$t=Jt()};b.__private__.setCustomOutputDestination=function(t){at=!0,ot=t};var ut=function(t){at||(ot=t)};b.__private__.resetCustomOutputDestination=function(){at=!1,ot=et};var ct=b.__private__.out=function(t){return t=t.toString(),rt+=t.length+1,ot.push(t),ot},lt=b.__private__.write=function(t){return ct(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},ht=b.__private__.getArrayBuffer=function(t){for(var e=t.length,r=new ArrayBuffer(e),n=new Uint8Array(r);e--;)n[e]=t.charCodeAt(e);return r},ft=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];b.__private__.getStandardFonts=function(){return ft};var dt=t.fontSize||16;b.__private__.setFontSize=b.setFontSize=function(t){return dt=x===A.ADVANCED?t/xt:t,this};var pt,gt=b.__private__.getFontSize=b.getFontSize=function(){return x===A.COMPAT?dt:dt*xt},mt=t.R2L||!1;b.__private__.setR2L=b.setR2L=function(t){return mt=t,this},b.__private__.getR2L=b.getR2L=function(){return mt};var vt,bt=b.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*%$/.test(t))pt=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');pt=t}else pt=parseInt(t,10)};b.__private__.getZoomMode=function(){return pt};var yt,wt=b.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');vt=t};b.__private__.getPageMode=function(){return vt};var Nt=b.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');yt=t};b.__private__.getLayoutMode=function(){return yt},b.__private__.setDisplayMode=b.setDisplayMode=function(t,e,r){return bt(t),Nt(e),wt(r),this};var Lt={title:"",subject:"",author:"",keywords:"",creator:""};b.__private__.getDocumentProperty=function(t){if(-1===Object.keys(Lt).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return Lt[t]},b.__private__.getDocumentProperties=function(){return Lt},b.__private__.setDocumentProperties=b.setProperties=b.setDocumentProperties=function(t){for(var e in Lt)Lt.hasOwnProperty(e)&&t[e]&&(Lt[e]=t[e]);return this},b.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(Lt).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return Lt[t]=e};var At,xt,St,_t,Pt,kt={},It={},Ft=[],Ct={},jt={},Ot={},Bt={},Mt=null,Et=0,qt=[],Rt=new k(b),Tt=t.hotfixes||[],Dt={},Ut={},zt=[],Ht=function(t,e,r,n,i,a){if(!(this instanceof Ht))return new Ht(t,e,r,n,i,a);isNaN(t)&&(t=1),isNaN(e)&&(e=0),isNaN(r)&&(r=0),isNaN(n)&&(n=1),isNaN(i)&&(i=0),isNaN(a)&&(a=0),this._matrix=[t,e,r,n,i,a]};Object.defineProperty(Ht.prototype,"sx",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Ht.prototype,"shy",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Ht.prototype,"shx",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Ht.prototype,"sy",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Ht.prototype,"tx",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Ht.prototype,"ty",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Ht.prototype,"a",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Ht.prototype,"b",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Ht.prototype,"c",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Ht.prototype,"d",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Ht.prototype,"e",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Ht.prototype,"f",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Ht.prototype,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(Ht.prototype,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(Ht.prototype,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(Ht.prototype,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),Ht.prototype.join=function(t){return[this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(B).join(t)},Ht.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,r=t.sx*this.shy+t.shy*this.sy,n=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Ht(e,r,n,i,a,o)},Ht.prototype.decompose=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*r+(e/=o)*n;r-=t*s,n-=e*s;var u=Math.sqrt(r*r+n*n);return s/=u,t*(n/=u)<e*(r/=u)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Ht(o,0,0,u,0,0),translate:new Ht(1,0,0,1,i,a),rotate:new Ht(t,e,-e,t,0,0),skew:new Ht(1,0,s,1,0,0)}},Ht.prototype.toString=function(t){return this.join(" ")},Ht.prototype.inversed=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=1/(t*n-e*r),s=n*o,u=-e*o,c=-r*o,l=t*o;return new Ht(s,u,c,l,-s*i-c*a,-u*i-l*a)},Ht.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,r=t.x*this.shy+t.y*this.sy+this.ty;return new kr(e,r)},Ht.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),r=this.applyToPoint(new kr(t.x+t.w,t.y+t.h));return new Ir(e.x,e.y,r.x-e.x,r.y-e.y)},Ht.prototype.clone=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty;return new Ht(t,e,r,n,i,a)},b.Matrix=Ht;var Vt=b.matrixMult=function(t,e){return e.multiply(t)},Wt=new Ht(1,0,0,1,0,0);b.unitMatrix=b.identityMatrix=Wt;var Gt=function(t,e){if(!jt[t]){var r=(e instanceof C?"Sh":"P")+(Object.keys(Ct).length+1).toString(10);e.id=r,jt[t]=r,Ct[r]=e,Rt.publish("addPattern",e)}};b.ShadingPattern=C,b.TilingPattern=j,b.addShadingPattern=function(t,e){return M("addShadingPattern()"),Gt(t,e),this},b.beginTilingPattern=function(t){M("beginTilingPattern()"),Cr(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix)},b.endTilingPattern=function(t,e){M("endTilingPattern()"),e.stream=it[K].join("\n"),Gt(t,e),Rt.publish("endTilingPattern",e),zt.pop().restore()};var Yt=b.__private__.newObject=function(){var t=Jt();return Xt(t,!0),t},Jt=b.__private__.newObjectDeferred=function(){return Q++,tt[Q]=function(){return rt},Q},Xt=function(t,e){return e="boolean"==typeof e&&e,tt[t]=rt,e&&ct(t+" 0 obj"),t},Kt=b.__private__.newAdditionalObject=function(){var t={objId:Jt(),content:""};return nt.push(t),t},Zt=Jt(),$t=Jt(),Qt=b.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"]}}else{var r=parseFloat(e[0]);e=[r,r,r,"r"]}for(var n="#",i=0;i<3;i++)n+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return n},te=b.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var r=t.ch1,n=t.ch2,i=t.ch3,a=t.ch4,o="draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof r&&"#"!==r.charAt(0)){var s=new h(r);if(s.ok)r=s.toHex();else if(!/^\d*\.?\d*$/.test(r))throw new Error('Invalid color "'+r+'" passed to jsPDF.encodeColorString.')}if("string"==typeof r&&/^#[0-9A-Fa-f]{3}$/.test(r)&&(r="#"+r[1]+r[1]+r[2]+r[2]+r[3]+r[3]),"string"==typeof r&&/^#[0-9A-Fa-f]{6}$/.test(r)){var u=parseInt(r.substr(1),16);r=u>>16&255,n=u>>8&255,i=255&u}if(void 0===n||void 0===a&&r===n&&n===i)if("string"==typeof r)e=r+" "+o[0];else switch(t.precision){case 2:e=q(r/255)+" "+o[0];break;case 3:default:e=R(r/255)+" "+o[0]}else if(void 0===a||"object"==typeof a){if(a&&!isNaN(a.a)&&0===a.a)return e=["1.","1.","1.",o[1]].join(" ");if("string"==typeof r)e=[r,n,i,o[1]].join(" ");else switch(t.precision){case 2:e=[q(r/255),q(n/255),q(i/255),o[1]].join(" ");break;default:case 3:e=[R(r/255),R(n/255),R(i/255),o[1]].join(" ")}}else if("string"==typeof r)e=[r,n,i,a,o[2]].join(" ");else switch(t.precision){case 2:e=[q(r),q(n),q(i),q(a),o[2]].join(" ");break;case 3:default:e=[R(r),R(n),R(i),R(a),o[2]].join(" ")}return e},ee=b.__private__.getFilters=function(){return u},re=b.__private__.putStream=function(t){var e=(t=t||{}).data||"",r=t.filters||ee(),n=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o=t.objectId,s=function(t){return t};if(null!==g&&void 0===o)throw new Error("ObjectId must be passed to putStream for file encryption");null!==g&&(s=We.encryptor(o,0));var u={};!0===r&&(r=["FlateEncode"]);var c=t.additionalKeyValues||[],l=(u=void 0!==O.API.processDataByFilters?O.API.processDataByFilters(e,r):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(n)?n.join(" "):n.toString());if(0!==u.data.length&&(c.push({key:"Length",value:u.data.length}),!0===i&&c.push({key:"Length1",value:a})),0!=l.length)if(l.split("/").length-1==1)c.push({key:"Filter",value:l});else{c.push({key:"Filter",value:"["+l+"]"});for(var h=0;h<c.length;h+=1)if("DecodeParms"===c[h].key){for(var f=[],d=0;d<u.reverseChain.split("/").length-1;d+=1)f.push("null");f.push(c[h].value),c[h].value="["+f.join(" ")+"]"}}ct("<<");for(var p=0;p<c.length;p++)ct("/"+c[p].key+" "+c[p].value);ct(">>"),0!==u.data.length&&(ct("stream"),ct(s(u.data)),ct("endstream"))},ne=b.__private__.putPage=function(t){var e=t.number,r=t.data,n=t.objId,i=t.contentsObjId;Xt(n,!0),ct("<</Type /Page"),ct("/Parent "+t.rootDictionaryObjId+" 0 R"),ct("/Resources "+t.resourceDictionaryObjId+" 0 R"),ct("/MediaBox ["+parseFloat(B(t.mediaBox.bottomLeftX))+" "+parseFloat(B(t.mediaBox.bottomLeftY))+" "+B(t.mediaBox.topRightX)+" "+B(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&ct("/CropBox ["+B(t.cropBox.bottomLeftX)+" "+B(t.cropBox.bottomLeftY)+" "+B(t.cropBox.topRightX)+" "+B(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&ct("/BleedBox ["+B(t.bleedBox.bottomLeftX)+" "+B(t.bleedBox.bottomLeftY)+" "+B(t.bleedBox.topRightX)+" "+B(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&ct("/TrimBox ["+B(t.trimBox.bottomLeftX)+" "+B(t.trimBox.bottomLeftY)+" "+B(t.trimBox.topRightX)+" "+B(t.trimBox.topRightY)+"]"),null!==t.artBox&&ct("/ArtBox ["+B(t.artBox.bottomLeftX)+" "+B(t.artBox.bottomLeftY)+" "+B(t.artBox.topRightX)+" "+B(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&ct("/UserUnit "+t.userUnit),Rt.publish("putPage",{objId:n,pageContext:qt[e],pageNumber:e,page:r}),ct("/Contents "+i+" 0 R"),ct(">>"),ct("endobj");var a=r.join("\n");return x===A.ADVANCED&&(a+="\nQ"),Xt(i,!0),re({data:a,filters:ee(),objectId:i}),ct("endobj"),n},ie=b.__private__.putPages=function(){var t,e,r=[];for(t=1;t<=Et;t++)qt[t].objId=Jt(),qt[t].contentsObjId=Jt();for(t=1;t<=Et;t++)r.push(ne({number:t,data:it[t],objId:qt[t].objId,contentsObjId:qt[t].contentsObjId,mediaBox:qt[t].mediaBox,cropBox:qt[t].cropBox,bleedBox:qt[t].bleedBox,trimBox:qt[t].trimBox,artBox:qt[t].artBox,userUnit:qt[t].userUnit,rootDictionaryObjId:Zt,resourceDictionaryObjId:$t}));Xt(Zt,!0),ct("<</Type /Pages");var n="/Kids [";for(e=0;e<Et;e++)n+=r[e]+" 0 R ";ct(n+"]"),ct("/Count "+Et),ct(">>"),ct("endobj"),Rt.publish("postPutPages")},ae=function(t){var e=function(t,e){return-1!==t.indexOf(" ")?"("+Ie(t,e)+")":Ie(t,e)};Rt.publish("putFont",{font:t,out:ct,newObject:Yt,putStream:re,pdfEscapeWithNeededParanthesis:e}),!0!==t.isAlreadyPutted&&(t.objectNumber=Yt(),ct("<<"),ct("/Type /Font"),ct("/BaseFont /"+e(t.postScriptName)),ct("/Subtype /Type1"),"string"==typeof t.encoding&&ct("/Encoding /"+t.encoding),ct("/FirstChar 32"),ct("/LastChar 255"),ct(">>"),ct("endobj"))},oe=function(){for(var t in kt)kt.hasOwnProperty(t)&&(!1===m||!0===m&&v.hasOwnProperty(t))&&ae(kt[t])},se=function(t){t.objectNumber=Yt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[B(t.x),B(t.y),B(t.x+t.width),B(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var r=t.pages[1].join("\n");re({data:r,additionalKeyValues:e,objectId:t.objectNumber}),ct("endobj")},ue=function(){for(var t in Dt)Dt.hasOwnProperty(t)&&se(Dt[t])},ce=function(t,e){var r,n=[],i=1/(e-1);for(r=0;r<1;r+=i)n.push(r);if(n.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a)}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o)}for(var s="",u=0,c=0;c<n.length;c++){for(r=n[c];r>t[u+1].offset;)u++;var l=t[u].offset,h=(r-l)/(t[u+1].offset-l),f=t[u].color,d=t[u+1].color;s+=$(Math.round((1-h)*f[0]+h*d[0]).toString(16))+$(Math.round((1-h)*f[1]+h*d[1]).toString(16))+$(Math.round((1-h)*f[2]+h*d[2]).toString(16))}return s.trim()},le=function(t,e){e||(e=21);var r=Yt(),n=ce(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),re({data:n,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"],objectId:r}),ct("endobj"),t.objectNumber=Yt(),ct("<< /ShadingType "+t.type),ct("/ColorSpace /DeviceRGB");var a="/Coords ["+B(parseFloat(t.coords[0]))+" "+B(parseFloat(t.coords[1]))+" ";2===t.type?a+=B(parseFloat(t.coords[2]))+" "+B(parseFloat(t.coords[3])):a+=B(parseFloat(t.coords[2]))+" "+B(parseFloat(t.coords[3]))+" "+B(parseFloat(t.coords[4]))+" "+B(parseFloat(t.coords[5])),ct(a+="]"),t.matrix&&ct("/Matrix ["+t.matrix.toString()+"]"),ct("/Function "+r+" 0 R"),ct("/Extend [true true]"),ct(">>"),ct("endobj")},he=function(t,e){var r=Jt(),n=Yt();e.push({resourcesOid:r,objectOid:n}),t.objectNumber=n;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(B).join(" ")+"]"}),i.push({key:"XStep",value:B(t.xStep)}),i.push({key:"YStep",value:B(t.yStep)}),i.push({key:"Resources",value:r+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),re({data:t.stream,additionalKeyValues:i,objectId:t.objectNumber}),ct("endobj")},fe=function(t){var e;for(e in Ct)Ct.hasOwnProperty(e)&&(Ct[e]instanceof C?le(Ct[e]):Ct[e]instanceof j&&he(Ct[e],t))},de=function(t){for(var e in t.objectNumber=Yt(),ct("<<"),t)switch(e){case"opacity":ct("/ca "+q(t[e]));break;case"stroke-opacity":ct("/CA "+q(t[e]))}ct(">>"),ct("endobj")},pe=function(){var t;for(t in Ot)Ot.hasOwnProperty(t)&&de(Ot[t])},ge=function(){for(var t in ct("/XObject <<"),Dt)Dt.hasOwnProperty(t)&&Dt[t].objectNumber>=0&&ct("/"+t+" "+Dt[t].objectNumber+" 0 R");Rt.publish("putXobjectDict"),ct(">>")},me=function(){We.oid=Yt(),ct("<<"),ct("/Filter /Standard"),ct("/V "+We.v),ct("/R "+We.r),ct("/U <"+We.toHexString(We.U)+">"),ct("/O <"+We.toHexString(We.O)+">"),ct("/P "+We.P),ct(">>"),ct("endobj")},ve=function(){for(var t in ct("/Font <<"),kt)kt.hasOwnProperty(t)&&(!1===m||!0===m&&v.hasOwnProperty(t))&&ct("/"+t+" "+kt[t].objectNumber+" 0 R");ct(">>")},be=function(){if(Object.keys(Ct).length>0){for(var t in ct("/Shading <<"),Ct)Ct.hasOwnProperty(t)&&Ct[t]instanceof C&&Ct[t].objectNumber>=0&&ct("/"+t+" "+Ct[t].objectNumber+" 0 R");Rt.publish("putShadingPatternDict"),ct(">>")}},ye=function(t){if(Object.keys(Ct).length>0){for(var e in ct("/Pattern <<"),Ct)Ct.hasOwnProperty(e)&&Ct[e]instanceof b.TilingPattern&&Ct[e].objectNumber>=0&&Ct[e].objectNumber<t&&ct("/"+e+" "+Ct[e].objectNumber+" 0 R");Rt.publish("putTilingPatternDict"),ct(">>")}},we=function(){if(Object.keys(Ot).length>0){var t;for(t in ct("/ExtGState <<"),Ot)Ot.hasOwnProperty(t)&&Ot[t].objectNumber>=0&&ct("/"+t+" "+Ot[t].objectNumber+" 0 R");Rt.publish("putGStateDict"),ct(">>")}},Ne=function(t){Xt(t.resourcesOid,!0),ct("<<"),ct("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ve(),be(),ye(t.objectOid),we(),ge(),ct(">>"),ct("endobj")},Le=function(){var t=[];oe(),pe(),ue(),fe(t),Rt.publish("putResources"),t.forEach(Ne),Ne({resourcesOid:$t,objectOid:Number.MAX_SAFE_INTEGER}),Rt.publish("postPutResources")},Ae=function(){Rt.publish("putAdditionalObjects");for(var t=0;t<nt.length;t++){var e=nt[t];Xt(e.objId,!0),ct(e.content),ct("endobj")}Rt.publish("postPutAdditionalObjects")},xe=function(t){It[t.fontName]=It[t.fontName]||{},It[t.fontName][t.fontStyle]=t.id},Se=function(t,e,r,n,i){var a={id:"F"+(Object.keys(kt).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:r,encoding:n,isStandardFont:i||!1,metadata:{}};return Rt.publish("addFont",{font:a,instance:this}),kt[a.id]=a,xe(a),a.id},_e=function(t){for(var e=0,r=ft.length;e<r;e++){var n=Se.call(this,t[e][0],t[e][1],t[e][2],ft[e][3],!0);!1===m&&(v[n]=!0);var i=t[e][0].split("-");xe({id:n,fontName:i[0],fontStyle:i[1]||""})}Rt.publish("addFonts",{fonts:kt,dictionary:It})},Pe=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!r.console)throw new Error(n);r.console.error(n,t),r.alert&&alert(n)}},t.foo.bar=t,t.foo},ke=function(t,e){var r,n,i,a,o,s,u,c,l;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&kt[At].metadata&&kt[At].metadata[i]&&kt[At].metadata[i].encoding&&(a=kt[At].metadata[i].encoding,!o&&kt[At].encoding&&(o=kt[At].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(u=!1,s=[],r=0,n=t.length;r<n;r++)(c=o[t.charCodeAt(r)])?s.push(String.fromCharCode(c)):s.push(t[r]),s[r].charCodeAt(0)>>8&&(u=!0);t=s.join("")}for(r=t.length;void 0===u&&0!==r;)t.charCodeAt(r-1)>>8&&(u=!0),r--;if(!u)return t;for(s=e.noBOM?[]:[254,255],r=0,n=t.length;r<n;r++){if((l=(c=t.charCodeAt(r))>>8)>>8)throw new Error("Character at position "+r+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(l),s.push(c-(l<<8))}return String.fromCharCode.apply(void 0,s)},Ie=b.__private__.pdfEscape=b.pdfEscape=function(t,e){return ke(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},Fe=b.__private__.beginPage=function(t){it[++Et]=[],qt[Et]={objId:0,contentsObjId:0,userUnit:Number(f),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},Oe(Et),ut(it[K])},Ce=function(t,e){var r,a,s;switch(n=e||n,"string"==typeof t&&(r=L(t.toLowerCase()),Array.isArray(r)&&(a=r[0],s=r[1])),Array.isArray(t)&&(a=t[0]*xt,s=t[1]*xt),isNaN(a)&&(a=o[0],s=o[1]),(a>14400||s>14400)&&(i.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),a=Math.min(14400,a),s=Math.min(14400,s)),o=[a,s],n.substr(0,1)){case"l":s>a&&(o=[s,a]);break;case"p":a>s&&(o=[s,a])}Fe(o),hr(lr),ct(yr),0!==Sr&&ct(Sr+" J"),0!==_r&&ct(_r+" j"),Rt.publish("addPage",{pageNumber:Et})},je=function(t){t>0&&t<=Et&&(it.splice(t,1),qt.splice(t,1),Et--,K>Et&&(K=Et),this.setPage(K))},Oe=function(t){t>0&&t<=Et&&(K=t)},Be=b.__private__.getNumberOfPages=b.getNumberOfPages=function(){return it.length-1},Me=function(t,e,r){var n,a=void 0;return r=r||{},t=void 0!==t?t:kt[At].fontName,e=void 0!==e?e:kt[At].fontStyle,n=t.toLowerCase(),void 0!==It[n]&&void 0!==It[n][e]?a=It[n][e]:void 0!==It[t]&&void 0!==It[t][e]?a=It[t][e]:!1===r.disableWarning&&i.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),a||r.noFallback||null==(a=It.times[e])&&(a=It.times.normal),a},Ee=b.__private__.putInfo=function(){var t=Yt(),e=function(t){return t};for(var r in null!==g&&(e=We.encryptor(t,0)),ct("<<"),ct("/Producer ("+Ie(e("jsPDF "+O.version))+")"),Lt)Lt.hasOwnProperty(r)&&Lt[r]&&ct("/"+r.substr(0,1).toUpperCase()+r.substr(1)+" ("+Ie(e(Lt[r]))+")");ct("/CreationDate ("+Ie(e(z))+")"),ct(">>"),ct("endobj")},qe=b.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Zt;switch(Yt(),ct("<<"),ct("/Type /Catalog"),ct("/Pages "+e+" 0 R"),pt||(pt="fullwidth"),pt){case"fullwidth":ct("/OpenAction [3 0 R /FitH null]");break;case"fullheight":ct("/OpenAction [3 0 R /FitV null]");break;case"fullpage":ct("/OpenAction [3 0 R /Fit]");break;case"original":ct("/OpenAction [3 0 R /XYZ null null 1]");break;default:var r=""+pt;"%"===r.substr(r.length-1)&&(pt=parseInt(pt)/100),"number"==typeof pt&&ct("/OpenAction [3 0 R /XYZ null null "+q(pt)+"]")}switch(yt||(yt="continuous"),yt){case"continuous":ct("/PageLayout /OneColumn");break;case"single":ct("/PageLayout /SinglePage");break;case"two":case"twoleft":ct("/PageLayout /TwoColumnLeft");break;case"tworight":ct("/PageLayout /TwoColumnRight")}vt&&ct("/PageMode /"+vt),Rt.publish("putCatalog"),ct(">>"),ct("endobj")},Re=b.__private__.putTrailer=function(){ct("trailer"),ct("<<"),ct("/Size "+(Q+1)),ct("/Root "+Q+" 0 R"),ct("/Info "+(Q-1)+" 0 R"),null!==g&&ct("/Encrypt "+We.oid+" 0 R"),ct("/ID [ <"+H+"> <"+H+"> ]"),ct(">>")},Te=b.__private__.putHeader=function(){ct("%PDF-"+y),ct("%ºß¬à")},De=b.__private__.putXRef=function(){var t="0000000000";ct("xref"),ct("0 "+(Q+1)),ct("0000000000 65535 f ");for(var e=1;e<=Q;e++){"function"==typeof tt[e]?ct((t+tt[e]()).slice(-10)+" 00000 n "):void 0!==tt[e]?ct((t+tt[e]).slice(-10)+" 00000 n "):ct("0000000000 00000 n ")}},Ue=b.__private__.buildDocument=function(){st(),ut(et),Rt.publish("buildDocument"),Te(),ie(),Ae(),Le(),null!==g&&me(),Ee(),qe();var t=rt;return De(),Re(),ct("startxref"),ct(""+t),ct("%%EOF"),ut(it[K]),et.join("\n")},ze=b.__private__.getBlob=function(t){return new Blob([ht(t)],{type:"application/pdf"})},He=b.output=b.__private__.output=Pe((function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return Ue();case"save":b.save(e.filename);break;case"arraybuffer":return ht(Ue());case"blob":return ze(Ue());case"bloburi":case"bloburl":if(void 0!==r.URL&&"function"==typeof r.URL.createObjectURL)return r.URL&&r.URL.createObjectURL(ze(Ue()))||void 0;i.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var n="",a=Ue();try{n=c(a)}catch(t){n=c(unescape(encodeURIComponent(a)))}return"data:application/pdf;filename="+e.filename+";base64,"+n;case"pdfobjectnewwindow":if("[object Window]"===Object.prototype.toString.call(r)){var o='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+(e.pdfObjectUrl||"https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js")+'"><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",s=r.open();return null!==s&&s.document.write(o),s}throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");case"pdfjsnewwindow":if("[object Window]"===Object.prototype.toString.call(r)){var u='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+"?file=&downloadName="+e.filename+'" width="500px" height="400px" /></body></html>',l=r.open();if(null!==l){l.document.write(u);var h=this;l.document.documentElement.querySelector("#pdfViewer").onload=function(){l.document.title=e.filename,l.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(h.output("bloburl"))}}return l}throw new Error("The option pdfjsnewwindow just works in a browser-environment.");case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(r))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var f='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',d=r.open();if(null!==d&&(d.document.write(f),d.document.title=e.filename),d||"undefined"==typeof safari)return d;break;case"datauri":case"dataurl":return r.document.location.href=this.output("datauristring",e);default:return null}})),Ve=function(t){return!0===Array.isArray(Tt)&&Tt.indexOf(t)>-1};switch(a){case"pt":xt=1;break;case"mm":xt=72/25.4;break;case"cm":xt=72/2.54;break;case"in":xt=72;break;case"px":xt=1==Ve("px_scaling")?.75:96/72;break;case"pc":case"em":xt=12;break;case"ex":xt=6;break;default:throw new Error("Invalid unit: "+a)}var We=null;J(),W();var Ge=function(t){return null!==g?We.encryptor(t,0):function(t){return t}},Ye=b.__private__.getPageInfo=b.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:qt[t].objId,pageNumber:t,pageContext:qt[t]}},Je=b.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in qt)if(qt[e].objId===t)break;return Ye(e)},Xe=b.__private__.getCurrentPageInfo=b.getCurrentPageInfo=function(){return{objId:qt[K].objId,pageNumber:K,pageContext:qt[K]}};b.addPage=function(){return Ce.apply(this,arguments),this},b.setPage=function(){return Oe.apply(this,arguments),ut.call(this,it[K]),this},b.insertPage=function(t){return this.addPage(),this.movePage(K,t),this},b.movePage=function(t,e){var r,n;if(t>e){r=it[t],n=qt[t];for(var i=t;i>e;i--)it[i]=it[i-1],qt[i]=qt[i-1];it[e]=r,qt[e]=n,this.setPage(e)}else if(t<e){r=it[t],n=qt[t];for(var a=t;a<e;a++)it[a]=it[a+1],qt[a]=qt[a+1];it[e]=r,qt[e]=n,this.setPage(e)}return this},b.deletePage=function(){return je.apply(this,arguments),this},b.__private__.text=b.text=function(t,e,r,n,i){var a,o,s,u,c,l,h,f,d=(n=n||{}).scope||this;if("number"==typeof t&&"number"==typeof e&&("string"==typeof r||Array.isArray(r))){var p=r;r=e,e=t,t=p}if(arguments[3]instanceof Ht==!1?(s=arguments[4],u=arguments[5],"object"==typeof(h=arguments[3])&&null!==h||("string"==typeof s&&(u=s,s=null),"string"==typeof h&&(u=h,h=null),"number"==typeof h&&(s=h,h=null),n={flags:h,angle:s,align:u})):(M("The transform parameter of text() with a Matrix value"),f=i),isNaN(e)||isNaN(r)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return d;var g="",m=!1,b="number"==typeof n.lineHeightFactor?n.lineHeightFactor:cr,y=d.internal.scaleFactor;function w(t){return t=t.split("\t").join(Array(n.TabLen||9).join(" ")),Ie(t,h)}function N(t){for(var e,r=t.concat(),n=[],i=r.length;i--;)"string"==typeof(e=r.shift())?n.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?n.push(e[0]):n.push([e[0],e[1],e[2]]);return n}function L(t,e){var r;if("string"==typeof t)r=e(t)[0];else if(Array.isArray(t)){for(var n,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(n=a.shift())?o.push(e(n)[0]):Array.isArray(n)&&"string"==typeof n[0]&&(i=e(n[0],n[1],n[2]),o.push([i[0],i[1],i[2]]));r=o}return r}var S=!1,_=!0;if("string"==typeof t)S=!0;else if(Array.isArray(t)){var P=t.concat();o=[];for(var k,I=P.length;I--;)("string"!=typeof(k=P.shift())||Array.isArray(k)&&"string"!=typeof k[0])&&(_=!1);S=_}if(!1===S)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var F=dt/d.internal.scaleFactor,C=F*(cr-1);switch(n.baseline){case"bottom":r-=C;break;case"top":r+=F-C;break;case"hanging":r+=F-2*C;break;case"middle":r+=F/2-C}if((l=n.maxWidth||0)>0&&("string"==typeof t?t=d.splitTextToSize(t,l):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(d.splitTextToSize(e,l))}),[]))),a={text:t,x:e,y:r,options:n,mutex:{pdfEscape:Ie,activeFontKey:At,fonts:kt,activeFontSize:dt}},Rt.publish("preProcessText",a),t=a.text,s=(n=a.options).angle,f instanceof Ht==!1&&s&&"number"==typeof s){s*=Math.PI/180,0===n.rotationDirection&&(s=-s),x===A.ADVANCED&&(s=-s);var j=Math.cos(s),O=Math.sin(s);f=new Ht(j,O,-O,j,0,0)}else s&&s instanceof Ht&&(f=s);x!==A.ADVANCED||f||(f=Wt),void 0!==(c=n.charSpace||Ar)&&(g+=B(T(c))+" Tc\n",this.setCharSpace(this.getCharSpace()||0));n.lang;var E=-1,q=void 0!==n.renderingMode?n.renderingMode:n.stroke,R=d.internal.getCurrentPageInfo().pageContext;switch(q){case 0:case!1:case"fill":E=0;break;case 1:case!0:case"stroke":E=1;break;case 2:case"fillThenStroke":E=2;break;case 3:case"invisible":E=3;break;case 4:case"fillAndAddForClipping":E=4;break;case 5:case"strokeAndAddPathForClipping":E=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":E=6;break;case 7:case"addToPathForClipping":E=7}var D=void 0!==R.usedRenderingMode?R.usedRenderingMode:-1;-1!==E?g+=E+" Tr\n":-1!==D&&(g+="0 Tr\n"),-1!==E&&(R.usedRenderingMode=E),u=n.align||"left";var U,z=dt*b,H=d.internal.pageSize.getWidth(),V=kt[At];c=n.charSpace||Ar,l=n.maxWidth||0,h=Object.assign({autoencode:!0,noBOM:!0},n.flags);var W=[];if("[object Array]"===Object.prototype.toString.call(t)){var G;o=N(t),"left"!==u&&(U=o.map((function(t){return d.getStringUnitWidth(t,{font:V,charSpace:c,fontSize:dt,doKerning:!1})*dt/y})));var Y,J=0;if("right"===u){e-=U[0],t=[],I=o.length;for(var X=0;X<I;X++)0===X?(Y=gr(e),G=mr(r)):(Y=T(J-U[X]),G=-z),t.push([o[X],Y,G]),J=U[X]}else if("center"===u){e-=U[0]/2,t=[],I=o.length;for(var K=0;K<I;K++)0===K?(Y=gr(e),G=mr(r)):(Y=T((J-U[K])/2),G=-z),t.push([o[K],Y,G]),J=U[K]}else if("left"===u){t=[],I=o.length;for(var Z=0;Z<I;Z++)t.push(o[Z])}else{if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[],I=o.length,l=0!==l?l:H;for(var $=0;$<I;$++)G=0===$?mr(r):-z,Y=0===$?gr(e):0,$<I-1&&W.push(B(T((l-U[$])/(o[$].split(" ").length-1)))),t.push([o[$],Y,G])}}var Q="boolean"==typeof n.R2L?n.R2L:mt;!0===Q&&(t=L(t,(function(t,e,r){return[t.split("").reverse().join(""),e,r]}))),a={text:t,x:e,y:r,options:n,mutex:{pdfEscape:Ie,activeFontKey:At,fonts:kt,activeFontSize:dt}},Rt.publish("postProcessText",a),t=a.text,m=a.mutex.isHex||!1;var tt=kt[At].encoding;"WinAnsiEncoding"!==tt&&"StandardEncoding"!==tt||(t=L(t,(function(t,e,r){return[w(t),e,r]}))),o=N(t),t=[];for(var et,rt,nt,it=0,at=1,ot=Array.isArray(o[0])?at:it,st="",ut=function(t,e,r){var i="";return r instanceof Ht?(r="number"==typeof n.angle?Vt(r,new Ht(1,0,0,1,t,e)):Vt(new Ht(1,0,0,1,t,e),r),x===A.ADVANCED&&(r=Vt(new Ht(1,0,0,-1,0,0),r)),i=r.join(" ")+" Tm\n"):i=B(t)+" "+B(e)+" Td\n",i},lt=0;lt<o.length;lt++){switch(st="",ot){case at:nt=(m?"<":"(")+o[lt][0]+(m?">":")"),et=parseFloat(o[lt][1]),rt=parseFloat(o[lt][2]);break;case it:nt=(m?"<":"(")+o[lt]+(m?">":")"),et=gr(e),rt=mr(r)}void 0!==W&&void 0!==W[lt]&&(st=W[lt]+" Tw\n"),0===lt?t.push(st+ut(et,rt,f)+nt):ot===it?t.push(st+nt):ot===at&&t.push(st+ut(et,rt,f)+nt)}t=ot===it?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var ht="BT\n/";return ht+=At+" "+dt+" Tf\n",ht+=B(dt*b)+" TL\n",ht+=Nr+"\n",ht+=g,ht+=t,ct(ht+="ET"),v[At]=!0,d};var Ke=b.__private__.clip=b.clip=function(t){return ct("evenodd"===t?"W*":"W"),this};b.clipEvenOdd=function(){return Ke("evenodd")},b.__private__.discardPath=b.discardPath=function(){return ct("n"),this};var Ze=b.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};b.__private__.setDefaultPathOperation=b.setDefaultPathOperation=function(t){return Ze(t)&&(p=t),this};var $e=b.__private__.getStyle=b.getStyle=function(t){var e=p;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t}return e},Qe=b.close=function(){return ct("h"),this};b.stroke=function(){return ct("S"),this},b.fill=function(t){return tr("f",t),this},b.fillEvenOdd=function(t){return tr("f*",t),this},b.fillStroke=function(t){return tr("B",t),this},b.fillStrokeEvenOdd=function(t){return tr("B*",t),this};var tr=function(t,e){"object"==typeof e?nr(e,t):ct(t)},er=function(t){null===t||x===A.ADVANCED&&void 0===t||(t=$e(t),ct(t))};function rr(t,e,r,n,i){var a=new j(e||this.boundingBox,r||this.xStep,n||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Gt(o,a),a}var nr=function(t,e){var r=jt[t.key],n=Ct[r];if(n instanceof C)ct("q"),ct(ir(e)),n.gState&&b.setGState(n.gState),ct(t.matrix.toString()+" cm"),ct("/"+r+" sh"),ct("Q");else if(n instanceof j){var i=new Ht(1,0,0,-1,0,Er());t.matrix&&(i=i.multiply(t.matrix||Wt),r=rr.call(n,t.key,t.boundingBox,t.xStep,t.yStep,i).id),ct("q"),ct("/Pattern cs"),ct("/"+r+" scn"),n.gState&&b.setGState(n.gState),ct(e),ct("Q")}},ir=function(t){switch(t){case"f":case"F":return"W n";case"f*":return"W* n";case"B":return"W S";case"B*":return"W* S";case"S":return"W S";case"n":return"W n"}},ar=b.moveTo=function(t,e){return ct(B(T(t))+" "+B(U(e))+" m"),this},or=b.lineTo=function(t,e){return ct(B(T(t))+" "+B(U(e))+" l"),this},sr=b.curveTo=function(t,e,r,n,i,a){return ct([B(T(t)),B(U(e)),B(T(r)),B(U(n)),B(T(i)),B(U(a)),"c"].join(" ")),this};b.__private__.line=b.line=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Ze(i))throw new Error("Invalid arguments passed to jsPDF.line");return x===A.COMPAT?this.lines([[r-t,n-e]],t,e,[1,1],i||"S"):this.lines([[r-t,n-e]],t,e,[1,1]).stroke()},b.__private__.lines=b.lines=function(t,e,r,n,i,a){var o,s,u,c,l,h,f,d,p,g,m,v;if("number"==typeof t&&(v=r,r=e,e=t,t=v),n=n||[1,1],a=a||!1,isNaN(e)||isNaN(r)||!Array.isArray(t)||!Array.isArray(n)||!Ze(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(ar(e,r),o=n[0],s=n[1],c=t.length,g=e,m=r,u=0;u<c;u++)2===(l=t[u]).length?(g=l[0]*o+g,m=l[1]*s+m,or(g,m)):(h=l[0]*o+g,f=l[1]*s+m,d=l[2]*o+g,p=l[3]*s+m,g=l[4]*o+g,m=l[5]*s+m,sr(h,f,d,p,g,m));return a&&Qe(),er(i),this},b.path=function(t){for(var e=0;e<t.length;e++){var r=t[e],n=r.c;switch(r.op){case"m":ar(n[0],n[1]);break;case"l":or(n[0],n[1]);break;case"c":sr.apply(this,n);break;case"h":Qe()}}return this},b.__private__.rect=b.rect=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Ze(i))throw new Error("Invalid arguments passed to jsPDF.rect");return x===A.COMPAT&&(n=-n),ct([B(T(t)),B(U(e)),B(T(r)),B(T(n)),"re"].join(" ")),er(i),this},b.__private__.triangle=b.triangle=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Ze(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[r-t,n-e],[i-r,a-n],[t-i,e-a]],t,e,[1,1],o,!0),this},b.__private__.roundedRect=b.roundedRect=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Ze(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*r),a=Math.min(a,.5*n),this.lines([[r-2*i,0],[i*s,0,i,a-a*s,i,a],[0,n-2*a],[0,a*s,-i*s,a,-i,a],[2*i-r,0],[-i*s,0,-i,-a*s,-i,-a],[0,2*a-n],[0,-a*s,i*s,-a,i,-a]],t+i,e,[1,1],o,!0),this},b.__private__.ellipse=b.ellipse=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Ze(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var a=4/3*(Math.SQRT2-1)*r,o=4/3*(Math.SQRT2-1)*n;return ar(t+r,e),sr(t+r,e-o,t+a,e-n,t,e-n),sr(t-a,e-n,t-r,e-o,t-r,e),sr(t-r,e+o,t-a,e+n,t,e+n),sr(t+a,e+n,t+r,e+o,t+r,e),er(i),this},b.__private__.circle=b.circle=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||!Ze(n))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,r,r,n)},b.setFont=function(t,e,r){return r&&(e=F(e,r)),At=Me(t,e,{disableWarning:!1}),this};var ur=b.__private__.getFont=b.getFont=function(){return kt[Me.apply(b,arguments)]};b.__private__.getFontList=b.getFontList=function(){var t,e,r={};for(t in It)if(It.hasOwnProperty(t))for(e in r[t]=[],It[t])It[t].hasOwnProperty(e)&&r[t].push(e);return r},b.addFont=function(t,e,r,n,i){var a=["StandardEncoding","MacRomanEncoding","Identity-H","WinAnsiEncoding"];return arguments[3]&&-1!==a.indexOf(arguments[3])?i=arguments[3]:arguments[3]&&-1==a.indexOf(arguments[3])&&(r=F(r,n)),i=i||"Identity-H",Se.call(this,t,e,r,i)};var cr,lr=t.lineWidth||.200025,hr=b.__private__.setLineWidth=b.setLineWidth=function(t){return ct(B(T(t))+" w"),this};b.__private__.setLineDash=O.API.setLineDash=O.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map((function(t){return B(T(t))})).join(" "),e=B(T(e)),ct("["+t+"] "+e+" d"),this};var fr=b.__private__.getLineHeight=b.getLineHeight=function(){return dt*cr};b.__private__.getLineHeight=b.getLineHeight=function(){return dt*cr};var dr=b.__private__.setLineHeightFactor=b.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(cr=t),this},pr=b.__private__.getLineHeightFactor=b.getLineHeightFactor=function(){return cr};dr(t.lineHeight);var gr=b.__private__.getHorizontalCoordinate=function(t){return T(t)},mr=b.__private__.getVerticalCoordinate=function(t){return x===A.ADVANCED?t:qt[K].mediaBox.topRightY-qt[K].mediaBox.bottomLeftY-T(t)},vr=b.__private__.getHorizontalCoordinateString=b.getHorizontalCoordinateString=function(t){return B(gr(t))},br=b.__private__.getVerticalCoordinateString=b.getVerticalCoordinateString=function(t){return B(mr(t))},yr=t.strokeColor||"0 G";b.__private__.getStrokeColor=b.getDrawColor=function(){return Qt(yr)},b.__private__.setStrokeColor=b.setDrawColor=function(t,e,r,n){return yr=te({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"draw",precision:2}),ct(yr),this};var wr=t.fillColor||"0 g";b.__private__.getFillColor=b.getFillColor=function(){return Qt(wr)},b.__private__.setFillColor=b.setFillColor=function(t,e,r,n){return wr=te({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"fill",precision:2}),ct(wr),this};var Nr=t.textColor||"0 g",Lr=b.__private__.getTextColor=b.getTextColor=function(){return Qt(Nr)};b.__private__.setTextColor=b.setTextColor=function(t,e,r,n){return Nr=te({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"text",precision:3}),this};var Ar=t.charSpace,xr=b.__private__.getCharSpace=b.getCharSpace=function(){return parseFloat(Ar||0)};b.__private__.setCharSpace=b.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Ar=t,this};var Sr=0;b.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},b.__private__.setLineCap=b.setLineCap=function(t){var e=b.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return Sr=e,ct(e+" J"),this};var _r=0;b.__private__.setLineJoin=b.setLineJoin=function(t){var e=b.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return _r=e,ct(e+" j"),this},b.__private__.setLineMiterLimit=b.__private__.setMiterLimit=b.setLineMiterLimit=b.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return ct(B(T(t))+" M"),this},b.GState=I,b.setGState=function(t){(t="string"==typeof t?Ot[Bt[t]]:Pr(null,t)).equals(Mt)||(ct("/"+t.id+" gs"),Mt=t)};var Pr=function(t,e){if(!t||!Bt[t]){var r=!1;for(var n in Ot)if(Ot.hasOwnProperty(n)&&Ot[n].equals(e)){r=!0;break}if(r)e=Ot[n];else{var i="GS"+(Object.keys(Ot).length+1).toString(10);Ot[i]=e,e.id=i}return t&&(Bt[t]=e.id),Rt.publish("addGState",e),e}};b.addGState=function(t,e){return Pr(t,e),this},b.saveGraphicsState=function(){return ct("q"),Ft.push({key:At,size:dt,color:Nr}),this},b.restoreGraphicsState=function(){ct("Q");var t=Ft.pop();return At=t.key,dt=t.size,Nr=t.color,Mt=null,this},b.setCurrentTransformationMatrix=function(t){return ct(t.toString()+" cm"),this},b.comment=function(t){return ct("#"+t),this};var kr=function(t,e){var r=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var n=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},Ir=function(t,e,r,n){kr.call(this,t,e),this.type="rect";var i=r||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var a=n||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t))}}),this},Fr=function(){this.page=Et,this.currentPage=K,this.pages=it.slice(0),this.pagesContext=qt.slice(0),this.x=St,this.y=_t,this.matrix=Pt,this.width=Br(K),this.height=Er(K),this.outputDestination=ot,this.id="",this.objectNumber=-1};Fr.prototype.restore=function(){Et=this.page,K=this.currentPage,qt=this.pagesContext,it=this.pages,St=this.x,_t=this.y,Pt=this.matrix,Mr(K,this.width),qr(K,this.height),ot=this.outputDestination};var Cr=function(t,e,r,n,i){zt.push(new Fr),Et=K=0,it=[],St=t,_t=e,Pt=i,Fe([r,n])},jr=function(t){if(!Ut[t]){var e=new Fr,r="Xo"+(Object.keys(Dt).length+1).toString(10);e.id=r,Ut[t]=r,Dt[r]=e,Rt.publish("addFormObject",e),zt.pop().restore()}};for(var Or in b.beginFormObject=function(t,e,r,n,i){return Cr(t,e,r,n,i),this},b.endFormObject=function(t){return jr(t),this},b.doFormObject=function(t,e){var r=Dt[Ut[t]];return ct("q"),ct(e.toString()+" cm"),ct("/"+r.id+" Do"),ct("Q"),this},b.getFormObject=function(t){var e=Dt[Ut[t]];return{x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},b.save=function(t,e){return t=t||"generated.pdf",(e=e||{}).returnPromise=e.returnPromise||!1,!1===e.returnPromise?(l(ze(Ue()),t),"function"==typeof l.unload&&r.setTimeout&&setTimeout(l.unload,911),this):new Promise((function(e,n){try{var i=l(ze(Ue()),t);"function"==typeof l.unload&&r.setTimeout&&setTimeout(l.unload,911),e(i)}catch(t){n(t.message)}}))},O.API)O.API.hasOwnProperty(Or)&&("events"===Or&&O.API.events.length?function(t,e){var r,n,i;for(i=e.length-1;-1!==i;i--)r=e[i][0],n=e[i][1],t.subscribe.apply(t,[r].concat("function"==typeof n?[n]:n))}(Rt,O.API.events):b[Or]=O.API[Or]);var Br=b.getPageWidth=function(t){return(qt[t=t||K].mediaBox.topRightX-qt[t].mediaBox.bottomLeftX)/xt},Mr=b.setPageWidth=function(t,e){qt[t].mediaBox.topRightX=e*xt+qt[t].mediaBox.bottomLeftX},Er=b.getPageHeight=function(t){return(qt[t=t||K].mediaBox.topRightY-qt[t].mediaBox.bottomLeftY)/xt},qr=b.setPageHeight=function(t,e){qt[t].mediaBox.topRightY=e*xt+qt[t].mediaBox.bottomLeftY};return b.internal={pdfEscape:Ie,getStyle:$e,getFont:ur,getFontSize:gt,getCharSpace:xr,getTextColor:Lr,getLineHeight:fr,getLineHeightFactor:pr,write:lt,getHorizontalCoordinate:gr,getVerticalCoordinate:mr,getCoordinateString:vr,getVerticalCoordinateString:br,collections:{},newObject:Yt,newAdditionalObject:Kt,newObjectDeferred:Jt,newObjectDeferredBegin:Xt,getFilters:ee,putStream:re,events:Rt,scaleFactor:xt,pageSize:{getWidth:function(){return Br(K)},setWidth:function(t){Mr(K,t)},getHeight:function(){return Er(K)},setHeight:function(t){qr(K,t)}},encryptionOptions:g,encryption:We,getEncryptor:Ge,output:He,getNumberOfPages:Be,pages:it,out:ct,f2:q,f3:R,getPageInfo:Ye,getPageInfoByObjId:Je,getCurrentPageInfo:Xe,getPDFVersion:w,Point:kr,Rectangle:Ir,Matrix:Ht,hasHotfix:Ve},Object.defineProperty(b.internal.pageSize,"width",{get:function(){return Br(K)},set:function(t){Mr(K,t)},enumerable:!0,configurable:!0}),Object.defineProperty(b.internal.pageSize,"height",{get:function(){return Er(K)},set:function(t){qr(K,t)},enumerable:!0,configurable:!0}),_e.call(b,ft),At="F1",Ce(o,n),Rt.publish("initialized"),b}P.prototype.lsbFirstWord=function(t){return String.fromCharCode(t>>0&255,t>>8&255,t>>16&255,t>>24&255)},P.prototype.toHexString=function(t){return t.split("").map((function(t){return("0"+(255&t.charCodeAt(0)).toString(16)).slice(-2)})).join("")},P.prototype.hexToBytes=function(t){for(var e=[],r=0;r<t.length;r+=2)e.push(String.fromCharCode(parseInt(t.substr(r,2),16)));return e.join("")},P.prototype.processOwnerPassword=function(t,e){return S(A(e).substr(0,5),t)},P.prototype.encryptor=function(t,e){let r=A(this.encryptionKey+String.fromCharCode(255&t,t>>8&255,t>>16&255,255&e,e>>8&255)).substr(0,10);return function(t){return S(r,t)}},I.prototype.equals=function(t){var e,r="id,objectNumber,equals";if(!t||typeof t!=typeof this)return!1;var n=0;for(e in this)if(!(r.indexOf(e)>=0)){if(this.hasOwnProperty(e)&&!t.hasOwnProperty(e))return!1;if(this[e]!==t[e])return!1;n++}for(e in t)t.hasOwnProperty(e)&&r.indexOf(e)<0&&n--;return 0===n},O.API={events:[]},O.version="2.3.1";var B=O.API,M=1,E=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},q=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},R=function(t){return t.toFixed(2)},T=function(t){return t.toFixed(5)};B.__acroform__={};var D=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},U=function(t){return t*M},z=function(t){var e=new ot,r=wt.internal.getHeight(t)||0,n=wt.internal.getWidth(t)||0;return e.BBox=[0,0,Number(R(n)),Number(R(r))],e},H=B.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},V=B.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},W=B.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},G=B.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return W(t,e-1)},Y=B.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return H(t,e-1)},J=B.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return V(t,e-1)},X=B.__acroform__.calculateCoordinates=function(t,e){var r=e.internal.getHorizontalCoordinate,n=e.internal.getVerticalCoordinate,i=t[0],a=t[1],o=t[2],s=t[3],u={};return u.lowerLeft_X=r(i)||0,u.lowerLeft_Y=n(a+s)||0,u.upperRight_X=r(i+o)||0,u.upperRight_Y=n(a)||0,[Number(R(u.lowerLeft_X)),Number(R(u.lowerLeft_Y)),Number(R(u.upperRight_X)),Number(R(u.upperRight_Y))]},K=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],r=t._V||t.DV,n=Z(t,r),i=t.scope.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(t.scope.__private__.encodeColorString(t.color)),e.push("/"+i+" "+R(n.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(n.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=z(t);return a.scope=t.scope,a.stream=e.join("\n"),a}},Z=function(t,e){var r=0===t.fontSize?t.maxFontSize:t.fontSize,n={text:"",fontSize:""},i=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),a=r,o=wt.internal.getHeight(t)||0;o=o<0?-o:o;var s=wt.internal.getWidth(t)||0;s=s<0?-s:s;var u=function(e,r,n){if(e+1<i.length){var a=r+" "+i[e+1];return $(a,t,n).width<=s-4}return!1};a++;t:for(;a>0;){e="",a--;var c,l,h=$("3",t,a).height,f=t.multiline?o-a:(o-h)/2,d=f+=2,p=0,g=0;if(a<=0){e="(...) Tj\n",e+="% Width of Text: "+$(e,t,a=12).width+", FieldWidth:"+s+"\n";break}var m="",v=0;for(var b in i)if(i.hasOwnProperty(b)){m=" "==(m+=i[b]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var y=parseInt(b),w=u(y,m,a),N=b>=i.length-1;if(w&&!N){m+=" ";continue}if(w||N){if(N)g=y;else if(t.multiline&&(h+2)*(v+2)+2>o)continue t}else{if(!t.multiline)continue t;if((h+2)*(v+2)+2>o)continue t;g=y}for(var L="",A=p;A<=g;A++)L+=i[A]+" ";switch(L=" "==L.substr(L.length-1)?L.substr(0,L.length-1):L,l=$(L,t,a).width,t.textAlign){case"right":c=s-l-2;break;case"center":c=(s-l)/2;break;case"left":default:c=2}e+=R(c)+" "+R(d)+" Td\n",e+="("+E(L)+") Tj\n",e+=-R(c)+" 0 Td\n",d=-(a+2),l=0,p=g+1,v++,m=""}else;break}return n.text=e,n.fontSize=a,n},$=function(t,e,r){var n=e.scope.internal.getFont(e.fontName,e.fontStyle),i=e.scope.getStringUnitWidth(t,{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r);return{height:e.scope.getStringUnitWidth("3",{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r)*1.5,width:i}},Q={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},tt=function(t,e){var r={type:"reference",object:t};void 0===e.internal.getPageInfo(t.page).pageContext.annotations.find((function(t){return t.type===r.type&&t.object===r.object}))&&e.internal.getPageInfo(t.page).pageContext.annotations.push(r)},et=function(t,e){for(var r in t)if(t.hasOwnProperty(r)){var n=r,i=t[r];e.internal.newObjectDeferredBegin(i.objId,!0),"object"==typeof i&&"function"==typeof i.putStream&&i.putStream(),delete t[n]}},rt=function(t,e){if(e.scope=t,void 0!==t.internal&&(void 0===t.internal.acroformPlugin||!1===t.internal.acroformPlugin.isInitialized)){if(ut.FieldNum=0,t.internal.acroformPlugin=JSON.parse(JSON.stringify(Q)),t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");M=t.internal.scaleFactor,t.internal.acroformPlugin.acroFormDictionaryRoot=new st,t.internal.acroformPlugin.acroFormDictionaryRoot.scope=t,t.internal.acroformPlugin.acroFormDictionaryRoot._eventID=t.internal.events.subscribe("postPutResources",(function(){!function(t){t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID,t.internal.acroformPlugin.printedOut=!0}(t)})),t.internal.events.subscribe("buildDocument",(function(){!function(t){t.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var e=t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];n.objId=void 0,n.hasAnnotation&&tt(n,t)}}(t)})),t.internal.events.subscribe("putCatalog",(function(){!function(t){if(void 0===t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");t.internal.write("/AcroForm "+t.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")}(t)})),t.internal.events.subscribe("postPutPages",(function(e){!function(t,e){var r=!t;for(var n in t||(e.internal.newObjectDeferredBegin(e.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),e.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),t=t||e.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(t.hasOwnProperty(n)){var i=t[n],a=[],o=i.Rect;if(i.Rect&&(i.Rect=X(i.Rect,e)),e.internal.newObjectDeferredBegin(i.objId,!0),i.DA=wt.createDefaultAppearanceStream(i),"object"==typeof i&&"function"==typeof i.getKeyValueListForStream&&(a=i.getKeyValueListForStream()),i.Rect=o,i.hasAppearanceStream&&!i.appearanceStreamContent){var s=K(i);a.push({key:"AP",value:"<</N "+s+">>"}),e.internal.acroformPlugin.xForms.push(s)}if(i.appearanceStreamContent){var u="";for(var c in i.appearanceStreamContent)if(i.appearanceStreamContent.hasOwnProperty(c)){var l=i.appearanceStreamContent[c];if(u+="/"+c+" ",u+="<<",Object.keys(l).length>=1||Array.isArray(l)){for(var n in l)if(l.hasOwnProperty(n)){var h=l[n];"function"==typeof h&&(h=h.call(e,i)),u+="/"+n+" "+h+" ",e.internal.acroformPlugin.xForms.indexOf(h)>=0||e.internal.acroformPlugin.xForms.push(h)}}else"function"==typeof(h=l)&&(h=h.call(e,i)),u+="/"+n+" "+h,e.internal.acroformPlugin.xForms.indexOf(h)>=0||e.internal.acroformPlugin.xForms.push(h);u+=">>"}a.push({key:"AP",value:"<<\n"+u+">>"})}e.internal.putStream({additionalKeyValues:a,objectId:i.objId}),e.internal.out("endobj")}r&&et(e.internal.acroformPlugin.xForms,e)}(e,t)})),t.internal.acroformPlugin.isInitialized=!0}},nt=B.__acroform__.arrayToPdfArray=function(t,e,r){var n=function(t){return t};if(Array.isArray(t)){for(var i="[",a=0;a<t.length;a++)switch(0!==a&&(i+=" "),typeof t[a]){case"boolean":case"number":case"object":i+=t[a].toString();break;case"string":"/"!==t[a].substr(0,1)?(void 0!==e&&r&&(n=r.internal.getEncryptor(e)),i+="("+E(n(t[a].toString()))+")"):i+=t[a].toString()}return i+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var it=function(t,e,r){var n=function(t){return t};return void 0!==e&&r&&(n=r.internal.getEncryptor(e)),(t=t||"").toString(),t="("+E(n(t))+")"},at=function(){this._objId=void 0,this._scope=void 0,Object.defineProperty(this,"objId",{get:function(){if(void 0===this._objId){if(void 0===this.scope)return;this._objId=this.scope.internal.newObjectDeferred()}return this._objId},set:function(t){this._objId=t}}),Object.defineProperty(this,"scope",{value:this._scope,writable:!0})};at.prototype.toString=function(){return this.objId+" 0 R"},at.prototype.putStream=function(){var t=this.getKeyValueListForStream();this.scope.internal.putStream({data:this.stream,additionalKeyValues:t,objectId:this.objId}),this.scope.internal.out("endobj")},at.prototype.getKeyValueListForStream=function(){var t=[],e=Object.getOwnPropertyNames(this).filter((function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"scope"!=t&&"objId"!=t&&"_"!=t.substring(0,1)}));for(var r in e)if(!1===Object.getOwnPropertyDescriptor(this,e[r]).configurable){var n=e[r],i=this[n];i&&(Array.isArray(i)?t.push({key:n,value:nt(i,this.objId,this.scope)}):i instanceof at?(i.scope=this.scope,t.push({key:n,value:i.objId+" 0 R"})):"function"!=typeof i&&t.push({key:n,value:i}))}return t};var ot=function(){at.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writable:!0});var t,e=[];Object.defineProperty(this,"BBox",{configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(e){t=e.trim()},get:function(){return t||null}})};D(ot,at);var st=function(){at.call(this);var t,e=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return e.length>0?e:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return e}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(t){var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+E(e(t))+")"}},set:function(e){t=e}})};D(st,at);var ut=function(){at.call(this);var t=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return t},set:function(e){if(isNaN(e))throw new Error('Invalid value "'+e+'" for attribute F supplied.');t=e}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(t,3))},set:function(e){!0===Boolean(e)?this.F=Y(t,3):this.F=J(t,3)}});var e=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');e=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:r[0]},set:function(t){r[0]=t}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:r[1]},set:function(t){r[1]=t}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:r[2]},set:function(t){r[2]=t}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:r[3]},set:function(t){r[3]=t}});var n="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return n},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":n=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var i=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!i||i.length<1){if(this instanceof mt)return;i="FieldObject"+ut.FieldNum++}var t=function(t){return t};return this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),"("+E(t(i))+")"},set:function(t){i=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return i},set:function(t){i=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var o="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t}});var s=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var u=void 0;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return void 0===u?50/M:u},set:function(t){u=t}});var c="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t}});var l="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!l||this instanceof mt||this instanceof bt))return it(l,this.objId,this.scope)},set:function(t){t=t.toString(),l=t}});var h=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(h)return this instanceof dt==!1?it(h,this.objId,this.scope):h},set:function(t){t=t.toString(),h=this instanceof dt==!1?"("===t.substr(0,1)?q(t.substr(1,t.length-2)):q(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof dt==!0?q(h.substr(1,h.length-1)):h},set:function(t){t=t.toString(),h=this instanceof dt==!0?"/"+t:t}});var f=null;Object.defineProperty(this,"_V",{enumerable:!1,configurable:!1,get:function(){if(f)return f},set:function(t){this.V=t}}),Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof dt==!1?it(f,this.objId,this.scope):f},set:function(t){t=t.toString(),f=this instanceof dt==!1?"("===t.substr(0,1)?q(t.substr(1,t.length-2)):q(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof dt==!0?q(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof dt==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,p=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return p},set:function(t){t=Boolean(t),p=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,1):this.Ff=J(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,2):this.Ff=J(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,3):this.Ff=J(this.Ff,3)}});var g=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==g)return g},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');g=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(g){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:g=2;break;case"center":case 1:g=1;break;case"left":case 0:default:g=0}}})};D(ut,at);var ct=function(){ut.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var t=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){t=e}});var e=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return nt(e,this.objId,this.scope)},set:function(t){var r,n;n=[],"string"==typeof(r=t)&&(n=function(t,e,r){r||(r=1);for(var n,i=[];n=e.exec(t);)i.push(n[r]);return i}(r,/\((.*?)\)/g)),e=n}}),this.getOptions=function(){return e},this.setOptions=function(t){e=t,this.sort&&e.sort()},this.addOption=function(t){t=(t=t||"").toString(),e.push(t),this.sort&&e.sort()},this.removeOption=function(t,r){for(r=r||!1,t=(t=t||"").toString();-1!==e.indexOf(t)&&(e.splice(e.indexOf(t),1),!1!==r););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,18):this.Ff=J(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=Y(this.Ff,19):this.Ff=J(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=Y(this.Ff,20),e.sort()):this.Ff=J(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,22):this.Ff=J(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,23):this.Ff=J(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,27):this.Ff=J(this.Ff,27)}}),this.hasAppearanceStream=!1};D(ct,ut);var lt=function(){ct.call(this),this.fontName="helvetica",this.combo=!1};D(lt,ct);var ht=function(){lt.call(this),this.combo=!0};D(ht,lt);var ft=function(){ht.call(this),this.edit=!0};D(ft,ht);var dt=function(){ut.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,15):this.Ff=J(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,16):this.Ff=J(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,17):this.Ff=J(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,26):this.Ff=J(this.Ff,26)}});var t,e={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};if(this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),0!==Object.keys(e).length){var r,n=[];for(r in n.push("<<"),e)n.push("/"+r+" ("+E(t(e[r]))+")");return n.push(">>"),n.join("\n")}},set:function(t){"object"==typeof t&&(e=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return e.CA||""},set:function(t){"string"==typeof t&&(e.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return t.substr(1,t.length-1)},set:function(e){t="/"+e}})};D(dt,ut);var pt=function(){dt.call(this),this.pushButton=!0};D(pt,dt);var gt=function(){dt.call(this),this.radio=!0,this.pushButton=!1;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=void 0!==e?e:[]}})};D(gt,dt);var mt=function(){var t,e;ut.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return e},set:function(t){e=t}});var r,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};this.scope&&(t=this.scope.internal.getEncryptor(this.objId));var e,r=[];for(e in r.push("<<"),n)r.push("/"+e+" ("+E(t(n[e]))+")");return r.push(">>"),r.join("\n")},set:function(t){"object"==typeof t&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=wt.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName)};D(mt,ut),gt.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t)||!("getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var r=this.Kids[e];r.appearanceStreamContent=t.createAppearanceStream(r.optionName),r.caption=t.getCA()}},gt.prototype.createOption=function(t){var e=new mt;return e.Parent=this,e.optionName=t,this.Kids.push(e),Nt.call(this.scope,e),e};var vt=function(){dt.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=wt.CheckBox.createAppearanceStream()};D(vt,dt);var bt=function(){ut.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,13):this.Ff=J(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,21):this.Ff=J(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,23):this.Ff=J(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,24):this.Ff=J(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,25):this.Ff=J(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,26):this.Ff=J(this.Ff,26)}});var t=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){Number.isInteger(e)&&(t=e)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};D(bt,ut);var yt=function(){bt.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(G(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=Y(this.Ff,14):this.Ff=J(this.Ff,14)}}),this.password=!0};D(yt,bt);var wt={CheckBox:{createAppearanceStream:function(){return{N:{On:wt.CheckBox.YesNormal},D:{On:wt.CheckBox.YesPushDown,Off:wt.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=z(t);e.scope=t.scope;var r=[],n=t.scope.internal.getFont(t.fontName,t.fontStyle).id,i=t.scope.__private__.encodeColorString(t.color),a=Z(t,t.caption);return r.push("0.749023 g"),r.push("0 0 "+R(wt.internal.getWidth(t))+" "+R(wt.internal.getHeight(t))+" re"),r.push("f"),r.push("BMC"),r.push("q"),r.push("0 0 1 rg"),r.push("/"+n+" "+R(a.fontSize)+" Tf "+i),r.push("BT"),r.push(a.text),r.push("ET"),r.push("Q"),r.push("EMC"),e.stream=r.join("\n"),e},YesNormal:function(t){var e=z(t);e.scope=t.scope;var r=t.scope.internal.getFont(t.fontName,t.fontStyle).id,n=t.scope.__private__.encodeColorString(t.color),i=[],a=wt.internal.getHeight(t),o=wt.internal.getWidth(t),s=Z(t,t.caption);return i.push("1 g"),i.push("0 0 "+R(o)+" "+R(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+R(o-1)+" "+R(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+r+" "+R(s.fontSize)+" Tf "+n),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=z(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+R(wt.internal.getWidth(t))+" "+R(wt.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:wt.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=wt.RadioButton.Circle.YesNormal,e.D[t]=wt.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=z(t);e.scope=t.scope;var r=[],n=wt.internal.getWidth(t)<=wt.internal.getHeight(t)?wt.internal.getWidth(t)/4:wt.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=wt.internal.Bezier_C,a=Number((n*i).toFixed(5));return r.push("q"),r.push("1 0 0 1 "+T(wt.internal.getWidth(t)/2)+" "+T(wt.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+a+" "+a+" "+n+" 0 "+n+" c"),r.push("-"+a+" "+n+" -"+n+" "+a+" -"+n+" 0 c"),r.push("-"+n+" -"+a+" -"+a+" -"+n+" 0 -"+n+" c"),r.push(a+" -"+n+" "+n+" -"+a+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=z(t);e.scope=t.scope;var r=[],n=wt.internal.getWidth(t)<=wt.internal.getHeight(t)?wt.internal.getWidth(t)/4:wt.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*wt.internal.Bezier_C).toFixed(5)),o=Number((n*wt.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+T(wt.internal.getWidth(t)/2)+" "+T(wt.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),r.push("0 g"),r.push("q"),r.push("1 0 0 1 "+T(wt.internal.getWidth(t)/2)+" "+T(wt.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+o+" "+o+" "+n+" 0 "+n+" c"),r.push("-"+o+" "+n+" -"+n+" "+o+" -"+n+" 0 c"),r.push("-"+n+" -"+o+" -"+o+" -"+n+" 0 -"+n+" c"),r.push(o+" -"+n+" "+n+" -"+o+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=z(t);e.scope=t.scope;var r=[],n=wt.internal.getWidth(t)<=wt.internal.getHeight(t)?wt.internal.getWidth(t)/4:wt.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*wt.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+T(wt.internal.getWidth(t)/2)+" "+T(wt.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:wt.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=wt.RadioButton.Cross.YesNormal,e.D[t]=wt.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=z(t);e.scope=t.scope;var r=[],n=wt.internal.calculateCross(t);return r.push("q"),r.push("1 1 "+R(wt.internal.getWidth(t)-2)+" "+R(wt.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(R(n.x1.x)+" "+R(n.x1.y)+" m"),r.push(R(n.x2.x)+" "+R(n.x2.y)+" l"),r.push(R(n.x4.x)+" "+R(n.x4.y)+" m"),r.push(R(n.x3.x)+" "+R(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=z(t);e.scope=t.scope;var r=wt.internal.calculateCross(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+R(wt.internal.getWidth(t))+" "+R(wt.internal.getHeight(t))+" re"),n.push("f"),n.push("q"),n.push("1 1 "+R(wt.internal.getWidth(t)-2)+" "+R(wt.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(R(r.x1.x)+" "+R(r.x1.y)+" m"),n.push(R(r.x2.x)+" "+R(r.x2.y)+" l"),n.push(R(r.x4.x)+" "+R(r.x4.y)+" m"),n.push(R(r.x3.x)+" "+R(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=z(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+R(wt.internal.getWidth(t))+" "+R(wt.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=t.scope.internal.getFont(t.fontName,t.fontStyle).id,r=t.scope.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+r}};wt.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=wt.internal.getWidth(t),r=wt.internal.getHeight(t),n=Math.min(e,r);return{x1:{x:(e-n)/2,y:(r-n)/2+n},x2:{x:(e-n)/2+n,y:(r-n)/2},x3:{x:(e-n)/2,y:(r-n)/2},x4:{x:(e-n)/2+n,y:(r-n)/2+n}}}},wt.internal.getWidth=function(t){var e=0;return"object"==typeof t&&(e=U(t.Rect[2])),e},wt.internal.getHeight=function(t){var e=0;return"object"==typeof t&&(e=U(t.Rect[3])),e};var Nt=B.addField=function(t){if(rt(this,t),!(t instanceof ut))throw new Error("Invalid argument passed to jsPDF.addField.");var e;return(e=t).scope.internal.acroformPlugin.printedOut&&(e.scope.internal.acroformPlugin.printedOut=!1,e.scope.internal.acroformPlugin.acroFormDictionaryRoot=null),e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),t.page=t.scope.internal.getCurrentPageInfo().pageNumber,this};B.AcroFormChoiceField=ct,B.AcroFormListBox=lt,B.AcroFormComboBox=ht,B.AcroFormEditBox=ft,B.AcroFormButton=dt,B.AcroFormPushButton=pt,B.AcroFormRadioButton=gt,B.AcroFormCheckBox=vt,B.AcroFormTextField=bt,B.AcroFormPasswordField=yt,B.AcroFormAppearance=wt,B.AcroForm={ChoiceField:ct,ListBox:lt,ComboBox:ht,EditBox:ft,Button:dt,PushButton:pt,RadioButton:gt,CheckBox:vt,TextField:bt,PasswordField:yt,Appearance:wt},O.AcroForm={ChoiceField:ct,ListBox:lt,ComboBox:ht,EditBox:ft,Button:dt,PushButton:pt,RadioButton:gt,CheckBox:vt,TextField:bt,PasswordField:yt,Appearance:wt};var Lt=O.AcroForm;
/** @license
 * jsPDF addImage plugin
 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
 *               2013 Chris Dowling, https://github.com/gingerchris
 *               2013 Trinh Ho, https://github.com/ineedfat
 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
 *               2013 Norah Smith, https://github.com/burnburnrocket
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */function At(t){return t.reduce((function(t,e,r){return t[e]=r,t}),{})}!function(t){t.__addimage__={};var e="UNKNOWN",r={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},n=t.__addimage__.getImageFileTypeByImageData=function(t,n){var i,a;n=n||e;var o,s,u,c=e;if(x(t))for(u in r)for(o=r[u],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t[a]){s=!1;break}if(!0===s){c=u;break}}else for(u in r)for(o=r[u],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t.charCodeAt(a)){s=!1;break}if(!0===s){c=u;break}}return c===e&&n!==e&&(c=n),c},i=function(t){for(var e=this.internal.write,r=this.internal.putStream,n=(0,this.internal.getFilters)();-1!==n.indexOf("FlateEncode");)n.splice(n.indexOf("FlateEncode"),1);t.objectId=this.internal.newObject();var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:t.width}),a.push({key:"Height",value:t.height}),t.colorSpace===b.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(t.palette.length/3-1)+" "+("sMask"in t&&void 0!==t.sMask?t.objectId+2:t.objectId+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+t.colorSpace}),t.colorSpace===b.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:t.bitsPerComponent}),"decodeParameters"in t&&void 0!==t.decodeParameters&&a.push({key:"DecodeParms",value:"<<"+t.decodeParameters+">>"}),"transparency"in t&&Array.isArray(t.transparency)){for(var o="",s=0,u=t.transparency.length;s<u;s++)o+=t.transparency[s]+" "+t.transparency[s]+" ";a.push({key:"Mask",value:"["+o+"]"})}void 0!==t.sMask&&a.push({key:"SMask",value:t.objectId+1+" 0 R"});var c=void 0!==t.filter?["/"+t.filter]:void 0;if(r({data:t.data,additionalKeyValues:a,alreadyAppliedFilters:c,objectId:t.objectId}),e("endobj"),"sMask"in t&&void 0!==t.sMask){var l="/Predictor "+t.predictor+" /Colors 1 /BitsPerComponent "+t.bitsPerComponent+" /Columns "+t.width,h={width:t.width,height:t.height,colorSpace:"DeviceGray",bitsPerComponent:t.bitsPerComponent,decodeParameters:l,data:t.sMask};"filter"in t&&(h.filter=t.filter),i.call(this,h)}if(t.colorSpace===b.INDEXED){var f=this.internal.newObject();r({data:_(new Uint8Array(t.palette)),objectId:f}),e("endobj")}},a=function(){var t=this.internal.collections.addImage_images;for(var e in t)i.call(this,t[e])},o=function(){var t,e=this.internal.collections.addImage_images,r=this.internal.write;for(var n in e)r("/I"+(t=e[n]).index,t.objectId,"0","R")},s=function(){this.internal.collections.addImage_images||(this.internal.collections.addImage_images={},this.internal.events.subscribe("putResources",a),this.internal.events.subscribe("putXobjectDict",o))},l=function(){var t=this.internal.collections.addImage_images;return s.call(this),t},h=function(){return Object.keys(this.internal.collections.addImage_images).length},f=function(e){return"function"==typeof t["process"+e.toUpperCase()]},d=function(t){return"object"==typeof t&&1===t.nodeType},p=function(e,r){if("IMG"===e.nodeName&&e.hasAttribute("src")){var n=""+e.getAttribute("src");if(0===n.indexOf("data:image/"))return u(unescape(n).split("base64,").pop());var i=t.loadFile(n,!0);if(void 0!==i)return i}if("CANVAS"===e.nodeName){var a;switch(r){case"PNG":a="image/png";break;case"WEBP":a="image/webp";break;case"JPEG":case"JPG":default:a="image/jpeg"}return u(e.toDataURL(a,1).split("base64,").pop())}},g=function(t){var e=this.internal.collections.addImage_images;if(e)for(var r in e)if(t===e[r].alias)return e[r]},m=function(t,e,r){return t||e||(t=-96,e=-96),t<0&&(t=-1*r.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*r.height*72/e/this.internal.scaleFactor),0===t&&(t=e*r.width/r.height),0===e&&(e=t*r.height/r.width),[t,e]},v=function(t,e,r,n,i,a){var o=m.call(this,r,n,i),s=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString,c=l.call(this);if(r=o[0],n=o[1],c[i.index]=i,a){a*=Math.PI/180;var h=Math.cos(a),f=Math.sin(a),d=function(t){return t.toFixed(4)},p=[d(h),d(f),d(-1*f),d(h),0,0,"cm"]}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),u(e+n),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([s(r),"0","0",s(n),"0","0","cm"].join(" "))):this.internal.write([s(r),"0","0",s(n),s(t),u(e+n),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q")},b=t.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};t.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=t.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=t.__addimage__.sHashCode=function(t){var e,r,n=0;if("string"==typeof t)for(r=t.length,e=0;e<r;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;else if(x(t))for(r=t.byteLength/2,e=0;e<r;e++)n=(n<<5)-n+t[e],n|=0;return n},N=t.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},L=t.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),r=null;if(2===e.length){var n=/^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);Array.isArray(n)&&(r={mimeType:n[1],charset:n[2],data:e[1]})}return r},A=t.__addimage__.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};t.__addimage__.isArrayBuffer=function(t){return A()&&t instanceof ArrayBuffer};var x=t.__addimage__.isArrayBufferView=function(t){return A()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},S=t.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r},_=t.__addimage__.arrayBufferToBinaryString=function(t){try{return u(c(String.fromCharCode.apply(null,t)))}catch(e){if("undefined"!=typeof Uint8Array&&void 0!==Uint8Array.prototype.reduce)return new Uint8Array(t).reduce((function(t,e){return t.push(String.fromCharCode(e)),t}),[]).join("")}};t.addImage=function(){var t,r,n,i,a,o,u,c,l;if("number"==typeof arguments[1]?(r=e,n=arguments[1],i=arguments[2],a=arguments[3],o=arguments[4],u=arguments[5],c=arguments[6],l=arguments[7]):(r=arguments[1],n=arguments[2],i=arguments[3],a=arguments[4],o=arguments[5],u=arguments[6],c=arguments[7],l=arguments[8]),"object"==typeof(t=arguments[0])&&!d(t)&&"imageData"in t){var h=t;t=h.imageData,r=h.format||r||e,n=h.x||n||0,i=h.y||i||0,a=h.w||h.width||a,o=h.h||h.height||o,u=h.alias||u,c=h.compression||c,l=h.rotation||h.angle||l}var f=this.internal.getFilters();if(void 0===c&&-1!==f.indexOf("FlateEncode")&&(c="SLOW"),isNaN(n)||isNaN(i))throw new Error("Invalid coordinates passed to jsPDF.addImage");s.call(this);var p=P.call(this,t,r,u,c);return v.call(this,n,i,a,o,p,l),this};var P=function(r,i,a,o){var s,u,c;if("string"==typeof r&&n(r)===e){r=unescape(r);var l=k(r,!1);(""!==l||void 0!==(l=t.loadFile(r,!0)))&&(r=l)}if(d(r)&&(r=p(r,i)),i=n(r,i),!f(i))throw new Error("addImage does not support files of type '"+i+"', please ensure that a plugin for '"+i+"' support is added.");if((null==(c=a)||0===c.length)&&(a=function(t){return"string"==typeof t||x(t)?w(t):null}(r)),(s=g.call(this,a))||(A()&&(r instanceof Uint8Array||(u=r,r=S(r))),s=this["process"+i.toUpperCase()](r,h.call(this),a,function(e){return e&&"string"==typeof e&&(e=e.toUpperCase()),e in t.image_compression?e:y.NONE}(o),u)),!s)throw new Error("An unknown error occurred whilst processing the image.");return s},k=t.__addimage__.convertBase64ToBinaryString=function(t,e){var r;e="boolean"!=typeof e||e;var n,i="";if("string"==typeof t){n=null!==(r=L(t))?r.data:t;try{i=u(n)}catch(t){if(e)throw N(n)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};t.getImageProperties=function(r){var i,a,o="";if(d(r)&&(r=p(r)),"string"==typeof r&&n(r)===e&&(""===(o=k(r,!1))&&(o=t.loadFile(r)||""),r=o),a=n(r),!f(a))throw new Error("addImage does not support files of type '"+a+"', please ensure that a plugin for '"+a+"' support is added.");if(!A()||r instanceof Uint8Array||(r=S(r)),!(i=this["process"+a.toUpperCase()](r)))throw new Error("An unknown error occurred whilst processing the image");return i.fileType=a,i}}(O.API),
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){if(void 0!==t&&""!=t)return!0};O.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var r,n,i,a=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,s=this.internal.getPageInfoByObjId(t.objId),u=t.pageContext.annotations,c=!1,l=0;l<u.length&&!c;l++)switch((r=u[l]).type){case"link":(e(r.options.url)||e(r.options.pageNumber))&&(c=!0);break;case"reference":case"text":case"freetext":c=!0}if(0!=c){this.internal.write("/Annots [");for(var h=0;h<u.length;h++){r=u[h];var f=this.internal.pdfEscape,d=this.internal.getEncryptor(t.objId);switch(r.type){case"reference":this.internal.write(" "+r.object.objId+" 0 R ");break;case"text":var p=this.internal.newAdditionalObject(),g=this.internal.newAdditionalObject(),m=this.internal.getEncryptor(p.objId),v=r.title||"Note";i="<</Type /Annot /Subtype /Text "+(n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y)+"] ")+"/Contents ("+f(m(r.contents))+")",i+=" /Popup "+g.objId+" 0 R",i+=" /P "+s.objId+" 0 R",i+=" /T ("+f(m(v))+") >>",p.content=i;var b=p.objId+" 0 R";i="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+a(r.bounds.x+30)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w+30)+" "+o(r.bounds.y)+"] ")+" /Parent "+b,r.open&&(i+=" /Open true"),i+=" >>",g.content=i,this.internal.write(p.objId,"0 R",g.objId,"0 R");break;case"freetext":n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y+r.bounds.h)+"] ";var y=r.color||"#000000";i="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+f(d(r.contents))+")",i+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+y+")",i+=" /Border [0 0 0]",i+=" >>",this.internal.write(i);break;case"link":if(r.options.name){var w=this.annotations._nameMap[r.options.name];r.options.pageNumber=w.page,r.options.top=w.y}else r.options.top||(r.options.top=0);if(n="/Rect ["+r.finalBounds.x+" "+r.finalBounds.y+" "+r.finalBounds.w+" "+r.finalBounds.h+"] ",i="",r.options.url)i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+f(d(r.options.url))+") >>";else if(r.options.pageNumber){switch(i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(r.options.pageNumber).objId+" 0 R",r.options.magFactor=r.options.magFactor||"XYZ",r.options.magFactor){case"Fit":i+=" /Fit]";break;case"FitH":i+=" /FitH "+r.options.top+"]";break;case"FitV":r.options.left=r.options.left||0,i+=" /FitV "+r.options.left+"]";break;case"XYZ":default:var N=o(r.options.top);r.options.left=r.options.left||0,void 0===r.options.zoom&&(r.options.zoom=0),i+=" /XYZ "+r.options.left+" "+N+" "+r.options.zoom+"]"}}""!=i&&(i+=" >>",this.internal.write(i))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,r,n,i){var a=this.internal.getCurrentPageInfo(),o=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;a.pageContext.annotations.push({finalBounds:{x:o(t),y:s(e),w:o(t+r),h:s(e+n)},options:i,type:"link"})},t.textWithLink=function(t,e,r,n){var i=this.getTextWidth(t),a=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,r,n),r+=.2*a,"center"===n.align&&(e-=i/2),"right"===n.align&&(e-=i),this.link(e,r-a,i,a,n),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor}}(O.API),
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},r={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},n={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},i=[1570,1571,1573,1575];t.__arabicParser__={};var a=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==e[t.charCodeAt(0)]},o=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},s=t.__arabicParser__.isArabicEndLetter=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length<=2},u=t.__arabicParser__.isArabicAlfLetter=function(t){return o(t)&&i.indexOf(t.charCodeAt(0))>=0};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=1};var c=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=2};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=3};var l=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return o(t)&&a(t)&&4==e[t.charCodeAt(0)].length},h=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=r,i="",a=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(a++,"number"==typeof(n=n[t.charCodeAt(e)])&&(i+=String.fromCharCode(n),n=r,a=0),e===t.length-1&&(n=r,i+=t.charAt(e-(a-1)),e-=a-1,a=0)):(n=r,i+=t.charAt(e-a),e-=a,a=0);return i};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==n[t.charCodeAt(0)]};var f=t.__arabicParser__.getCorrectForm=function(t,e,r){return o(t)?!1===a(t)?-1:!c(t)||!o(e)&&!o(r)||!o(r)&&s(e)||s(t)&&!o(e)||s(t)&&u(e)||s(t)&&s(e)?0:l(t)&&o(e)&&!s(e)&&o(r)&&c(r)?3:s(t)||!o(r)?1:2:-1},d=function(t){var r=0,n=0,i=0,a="",s="",u="",c=(t=t||"").split("\\s+"),l=[];for(r=0;r<c.length;r+=1){for(l.push(""),n=0;n<c[r].length;n+=1)a=c[r][n],s=c[r][n-1],u=c[r][n+1],o(a)?(i=f(a,s,u),l[r]+=-1!==i?String.fromCharCode(e[a.charCodeAt(0)][i]):a):l[r]+=a;l[r]=h(l[r])}return l.join(" ")},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,r=[];if(Array.isArray(e)){var n=0;for(r=[],n=0;n<e.length;n+=1)Array.isArray(e[n])?r.push([d(e[n][0]),e[n][1],e[n][2]]):r.push([d(e[n])]);t=r}else t=d(e);return"string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p])}(O.API),O.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){this.internal.out("/OpenAction "+e+" 0 R")}))}return this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){var t=void 0;Object.defineProperty(this,"pdf",{get:function(){return t},set:function(e){t=e}});var e=150;Object.defineProperty(this,"width",{get:function(){return e},set:function(t){e=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=e+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var n=[];Object.defineProperty(this,"childNodes",{get:function(){return n},set:function(t){n=t}});var i={};Object.defineProperty(this,"style",{get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"parentNode",{})};e.prototype.getContext=function(t,e){var r;if("2d"!==(t=t||"2d"))return null;for(r in e)this.pdf.context2d.hasOwnProperty(r)&&(this.pdf.context2d[r]=e[r]);return this.pdf.context2d._canvas=this,this.pdf.context2d},e.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},t.events.push(["initialized",function(){this.canvas=new e,this.canvas.pdf=this}])}(O.API),
/**
 * @license
 * ====================================================================
 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Hall, james@parall.ax
 *               2014 Diego Casorran, https://github.com/diegocr
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){var e={left:0,top:0,bottom:0,right:0},r=!1,n=function(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},e),this.internal.__cell__.margins.width=this.getPageWidth(),i.call(this))},i=function(){this.internal.__cell__.lastCell=new a,this.internal.__cell__.pages=1},a=function(){var t=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return t},set:function(e){t=e}});var e=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return e},set:function(t){e=t}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t}});var n=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return n},set:function(t){n=t}});var i=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return i},set:function(t){i=t}});var a=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return a},set:function(t){a=t}});var o=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return o},set:function(t){o=t}}),this};a.prototype.clone=function(){return new a(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},a.prototype.toArray=function(){return[this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},t.setHeaderFunction=function(t){return n.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},t.getTextDimensions=function(t,e){n.call(this);var r=(e=e||{}).fontSize||this.getFontSize(),i=e.font||this.getFont(),a=e.scaleFactor||this.internal.scaleFactor,o=0,s=0,u=0,c=this;if(!Array.isArray(t)&&"string"!=typeof t){if("number"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");t=String(t)}const l=e.maxWidth;l>0?"string"==typeof t?t=this.splitTextToSize(t,l):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(c.splitTextToSize(e,l))}),[])):t=Array.isArray(t)?t:[t];for(var h=0;h<t.length;h++)o<(u=this.getStringUnitWidth(t[h],{font:i})*r)&&(o=u);return 0!==o&&(s=t.length),{w:o/=a,h:Math.max((s*r*this.getLineHeightFactor()-r*(this.getLineHeightFactor()-1))/a,0)}},t.cellAddPage=function(){n.call(this),this.addPage();var t=this.internal.__cell__.margins||e;return this.internal.__cell__.lastCell=new a(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this};var o=t.cell=function(){var t;t=arguments[0]instanceof a?arguments[0]:new a(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),n.call(this);var i=this.internal.__cell__.lastCell,o=this.internal.__cell__.padding,s=this.internal.__cell__.margins||e,u=this.internal.__cell__.tableHeaderRow,c=this.internal.__cell__.printHeaders;return void 0!==i.lineNumber&&(i.lineNumber===t.lineNumber?(t.x=(i.x||0)+(i.width||0),t.y=i.y||0):i.y+i.height+t.height+s.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=s.top,c&&u&&(this.printHeaderRow(t.lineNumber,!0),t.y+=u[0].height)):t.y=i.y+i.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===r?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-o,t.y+o,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+o,{align:"center",baseline:"top",maxWidth:t.width-o-o}):this.text(t.text,t.x+o,t.y+o,{align:"left",baseline:"top",maxWidth:t.width-o-o})),this.internal.__cell__.lastCell=t,this};t.table=function(t,r,u,c,l){if(n.call(this),!u)throw new Error("No data for PDF table.");var h,f,d,p,g=[],m=[],v=[],b={},y={},w=[],N=[],L=(l=l||{}).autoSize||!1,A=!1!==l.printHeaders,x=l.css&&void 0!==l.css["font-size"]?16*l.css["font-size"]:l.fontSize||12,S=l.margins||Object.assign({width:this.getPageWidth()},e),_="number"==typeof l.padding?l.padding:3,P=l.headerBackgroundColor||"#c8c8c8";if(i.call(this),this.internal.__cell__.printHeaders=A,this.internal.__cell__.margins=S,this.internal.__cell__.table_font_size=x,this.internal.__cell__.padding=_,this.internal.__cell__.headerBackgroundColor=P,this.setFontSize(x),null==c)m=g=Object.keys(u[0]),v=g.map((function(){return"left"}));else if(Array.isArray(c)&&"object"==typeof c[0])for(g=c.map((function(t){return t.name})),m=c.map((function(t){return t.prompt||t.name||""})),v=c.map((function(t){return t.align||"left"})),h=0;h<c.length;h+=1)y[c[h].name]=c[h].width*(19.049976/25.4);else Array.isArray(c)&&"string"==typeof c[0]&&(m=g=c,v=g.map((function(){return"left"})));if(L||Array.isArray(c)&&"string"==typeof c[0])for(h=0;h<g.length;h+=1){for(b[p=g[h]]=u.map((function(t){return t[p]})),this.setFont(void 0,"bold"),w.push(this.getTextDimensions(m[h],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),f=b[p],this.setFont(void 0,"normal"),d=0;d<f.length;d+=1)w.push(this.getTextDimensions(f[d],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);y[p]=Math.max.apply(null,w)+_+_,w=[]}if(A){var k={};for(h=0;h<g.length;h+=1)k[g[h]]={},k[g[h]].text=m[h],k[g[h]].align=v[h];var I=s.call(this,k,y);N=g.map((function(e){return new a(t,r,y[e],I,k[e].text,void 0,k[e].align)})),this.setTableHeaderRow(N),this.printHeaderRow(1,!1)}var F=c.reduce((function(t,e){return t[e.name]=e.align,t}),{});for(h=0;h<u.length;h+=1){var C=s.call(this,u[h],y);for(d=0;d<g.length;d+=1)o.call(this,new a(t,r,y[g[d]],C,u[h][g[d]],h+2,F[g[d]]))}return this.internal.__cell__.table_x=t,this.internal.__cell__.table_y=r,this};var s=function(t,e){var r=this.internal.__cell__.padding,n=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map((function(n){var i=t[n];return this.splitTextToSize(i.hasOwnProperty("text")?i.text:i,e[n]-r-r)}),this).map((function(t){return this.getLineHeightFactor()*t.length*n/i+r+r}),this).reduce((function(t,e){return Math.max(t,e)}),0)};t.setTableHeaderRow=function(t){n.call(this),this.internal.__cell__.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(n.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var i;if(r=!0,"function"==typeof this.internal.__cell__.headerFunction){var s=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new a(s[0],s[1],s[2],s[3],void 0,-1)}this.setFont(void 0,"bold");for(var u=[],c=0;c<this.internal.__cell__.tableHeaderRow.length;c+=1)i=this.internal.__cell__.tableHeaderRow[c].clone(),e&&(i.y=this.internal.__cell__.margins.top||0,u.push(i)),i.lineNumber=t,this.setFillColor(this.internal.__cell__.headerBackgroundColor),o.call(this,i);u.length>0&&this.setTableHeaderRow(u),this.setFont(void 0,"normal"),r=!1}}(O.API);var xt={italic:["italic","oblique","normal"],oblique:["oblique","italic","normal"],normal:["normal","oblique","italic"]},St=["ultra-condensed","extra-condensed","condensed","semi-condensed","normal","semi-expanded","expanded","extra-expanded","ultra-expanded"],_t=At(St),Pt=[100,200,300,400,500,600,700,800,900],kt=At(Pt);function It(t){var e=t.family.replace(/"|'/g,"").toLowerCase(),r=function(t){return xt[t=t||"normal"]?t:"normal"}(t.style),n=function(t){if(!t)return 400;if("number"==typeof t)return t>=100&&t<=900&&t%100==0?t:400;if(/^\d00$/.test(t))return parseInt(t);switch(t){case"bold":return 700;case"normal":default:return 400}}(t.weight),i=function(t){return"number"==typeof _t[t=t||"normal"]?t:"normal"}(t.stretch);return{family:e,style:r,weight:n,stretch:i,src:t.src||[],ref:t.ref||{name:e,style:[i,r,n].join(" ")}}}function Ft(t,e,r,n){var i;for(i=r;i>=0&&i<e.length;i+=n)if(t[e[i]])return t[e[i]];for(i=r;i>=0&&i<e.length;i-=n)if(t[e[i]])return t[e[i]]}var Ct={"sans-serif":"helvetica",fixed:"courier",monospace:"courier",terminal:"courier",cursive:"times",fantasy:"times",serif:"times"},jt={caption:"times",icon:"times",menu:"times","message-box":"times","small-caption":"times","status-bar":"times"};function Ot(t){return[t.stretch,t.style,t.weight,t.family].join(" ")}function Bt(t,e,r){for(var n=(r=r||{}).defaultFontFamily||"times",i=Object.assign({},Ct,r.genericFontFamilies||{}),a=null,o=null,s=0;s<e.length;++s)if(i[(a=It(e[s])).family]&&(a.family=i[a.family]),t.hasOwnProperty(a.family)){o=t[a.family];break}if(!(o=o||t[n]))throw new Error("Could not find a font-family for the rule '"+Ot(a)+"' and default family '"+n+"'.");if(o=function(t,e){if(e[t])return e[t];var r=_t[t],n=r<=_t.normal?-1:1,i=Ft(e,St,r,n);if(!i)throw new Error("Could not find a matching font-stretch value for "+t);return i}(a.stretch,o),o=function(t,e){if(e[t])return e[t];for(var r=xt[t],n=0;n<r.length;++n)if(e[r[n]])return e[r[n]];throw new Error("Could not find a matching font-style for "+t)}(a.style,o),!(o=function(t,e){if(e[t])return e[t];if(400===t&&e[500])return e[500];if(500===t&&e[400])return e[400];var r=kt[t],n=Ft(e,Pt,r,t<400?-1:1);if(!n)throw new Error("Could not find a matching font-weight for value "+t);return n}(a.weight,o)))throw new Error("Failed to resolve a font for the rule '"+Ot(a)+"'.");return o}function Mt(t){return t.trimLeft()}function Et(t,e){for(var r=0;r<t.length;){if(t.charAt(r)===e)return[t.substring(0,r),t.substring(r+1)];r+=1}return null}function qt(t){var e=t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);return null===e?null:[e[0],t.substring(e[0].length)]}var Rt,Tt,Dt,Ut=["times"];!function(t){var e,r,n,a,o,s,u,c,l,f=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new c,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new s,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new s,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new d(this),e=this.internal.f2,r=this.internal.getCoordinateString,n=this.internal.getVerticalCoordinateString,a=this.internal.getHorizontalCoordinate,o=this.internal.getVerticalCoordinate,s=this.internal.Point,u=this.internal.Rectangle,c=this.internal.Matrix,l=new f}]);var d=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var r=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return r},set:function(t){r=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t}});var u=[];Object.defineProperty(this,"pageBreaks",{get:function(){return u},set:function(t){u=t}}),Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof f&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var c=[];Object.defineProperty(this,"ctxStack",{get:function(){return c},set:function(t){c=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=p(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=p(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}});var h=null;function d(t,e){if(null===h){var r=function(t){var e=[];return Object.keys(t).forEach((function(r){t[r].forEach((function(t){var n=null;switch(t){case"bold":n={family:r,weight:"bold"};break;case"italic":n={family:r,style:"italic"};break;case"bolditalic":n={family:r,weight:"bold",style:"italic"};break;case"":case"normal":n={family:r}}null!==n&&(n.ref={name:r,style:t},e.push(n))}))})),e}(t.getFontList());h=function(t){for(var e={},r=0;r<t.length;++r){var n=It(t[r]),i=n.family,a=n.stretch,o=n.style,s=n.weight;e[i]=e[i]||{},e[i][a]=e[i][a]||{},e[i][a][o]=e[i][a][o]||{},e[i][a][o][s]=n}return e}(r.concat(e))}return h}var g=null;Object.defineProperty(this,"fontFaces",{get:function(){return g},set:function(t){h=null,g=t}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var r=e[1],n=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor),this.pdf.setFontSize(i);var s=function(t){var e,r,n=[],i=t.trim();if(""===i)return Ut;if(i in jt)return[jt[i]];for(;""!==i;){switch(r=null,e=(i=Mt(i)).charAt(0)){case'"':case"'":r=Et(i.substring(1),e);break;default:r=qt(i)}if(null===r)return Ut;if(n.push(r[0]),""!==(i=Mt(r[1]))&&","!==i.charAt(0))return Ut;i=i.replace(/^,/,"")}return n}(a);if(this.fontFaces){var u=Bt(d(this.pdf,this.fontFaces),s.map((function(t){return{family:t,stretch:"normal",weight:n,style:r}})));this.pdf.setFont(u.ref.name,u.ref.style)}else{var c="";("bold"===n||parseInt(n,10)>=700||"bold"===r)&&(c="bold"),"italic"===r&&(c+="italic"),0===c.length&&(c="normal");for(var l="",h={arial:"Helvetica",Arial:"Helvetica",verdana:"Helvetica",Verdana:"Helvetica",helvetica:"Helvetica",Helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",cursive:"Times",fantasy:"Times",serif:"Times"},f=0;f<s.length;f++){if(void 0!==this.pdf.internal.getFont(s[f],c,{noFallback:!0,disableWarning:!0})){l=s[f];break}if("bolditalic"===c&&void 0!==this.pdf.internal.getFont(s[f],"bold",{noFallback:!0,disableWarning:!0}))l=s[f],c="bold";else if(void 0!==this.pdf.internal.getFont(s[f],"normal",{noFallback:!0,disableWarning:!0})){l=s[f],c="normal";break}}if(""===l)for(var p=0;p<s.length;p++)if(h[s[p]]){l=h[s[p]];break}l=""===l?"Times":l,this.pdf.setFont(l,c)}}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};d.prototype.fill=function(){N.call(this,"fill",!1)},d.prototype.stroke=function(){N.call(this,"stroke",!1)},d.prototype.beginPath=function(){this.path=[{type:"begin"}]},d.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var r=this.ctx.transform.applyToPoint(new s(t,e));this.path.push({type:"mt",x:r.x,y:r.y}),this.ctx.lastPoint=new s(t,e)},d.prototype.closePath=function(){var t=new s(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"==typeof this.path[e+1]&&"number"==typeof this.path[e+1].x){t=new s(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"==typeof this.path[e+2]&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new s(t.x,t.y)},d.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var r=this.ctx.transform.applyToPoint(new s(t,e));this.path.push({type:"lt",x:r.x,y:r.y}),this.ctx.lastPoint=new s(r.x,r.y)},d.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),N.call(this,null,!0)},d.prototype.quadraticCurveTo=function(t,e,r,n){if(isNaN(r)||isNaN(n)||isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var a=this.ctx.transform.applyToPoint(new s(r,n)),o=this.ctx.transform.applyToPoint(new s(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:a.x,y:a.y}),this.ctx.lastPoint=new s(a.x,a.y)},d.prototype.bezierCurveTo=function(t,e,r,n,a,o){if(isNaN(a)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var u=this.ctx.transform.applyToPoint(new s(a,o)),c=this.ctx.transform.applyToPoint(new s(t,e)),l=this.ctx.transform.applyToPoint(new s(r,n));this.path.push({type:"bct",x1:c.x,y1:c.y,x2:l.x,y2:l.y,x:u.x,y:u.y}),this.ctx.lastPoint=new s(u.x,u.y)},d.prototype.arc=function(t,e,r,n,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(a))throw i.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var u=this.ctx.transform.applyToPoint(new s(t,e));t=u.x,e=u.y;var c=this.ctx.transform.applyToPoint(new s(0,r)),l=this.ctx.transform.applyToPoint(new s(0,0));r=Math.sqrt(Math.pow(c.x-l.x,2)+Math.pow(c.y-l.y,2))}Math.abs(a-n)>=2*Math.PI&&(n=0,a=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:r,startAngle:n,endAngle:a,counterclockwise:o})},d.prototype.arcTo=function(t,e,r,n,i){throw new Error("arcTo not implemented.")},d.prototype.rect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+r,e),this.lineTo(t+r,e+n),this.lineTo(t,e+n),this.lineTo(t,e),this.lineTo(t+r,e),this.lineTo(t,e)},d.prototype.fillRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!g.call(this)){var a={};"butt"!==this.lineCap&&(a.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(a.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,r,n),this.fill(),a.hasOwnProperty("lineCap")&&(this.lineCap=a.lineCap),a.hasOwnProperty("lineJoin")&&(this.lineJoin=a.lineJoin)}},d.prototype.strokeRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");m.call(this)||(this.beginPath(),this.rect(t,e,r,n),this.stroke())},d.prototype.clearRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,r,n))},d.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var n=new f(this.ctx);this.ctxStack.push(this.ctx),this.ctx=n}},d.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},d.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var p=function(t){var e,r,n,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))e=0,r=0,n=0,i=0;else{var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=parseFloat(a[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new h(t);t=o.ok?o.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,r=t.substring(2,3),r+=r,n=t.substring(3,4),n+=n):(e=t.substring(1,3),r=t.substring(3,5),n=t.substring(5,7)),e=parseInt(e,16),r=parseInt(r,16),n=parseInt(n,16)}}return{r:e,g:r,b:n,a:i,style:t}},g=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},m=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};d.prototype.fillText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw i.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(n=isNaN(n)?void 0:n,!g.call(this)){r=A.call(this,r);var a=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;k.call(this,{text:t,x:e,y:r,scale:o,angle:a,align:this.textAlign,maxWidth:n})}},d.prototype.strokeText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw i.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!m.call(this)){n=isNaN(n)?void 0:n,r=A.call(this,r);var a=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;k.call(this,{text:t,x:e,y:r,scale:o,renderingMode:"stroke",angle:a,align:this.textAlign,maxWidth:n})}},d.prototype.measureText=function(t){if("string"!=typeof t)throw i.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,r=this.pdf.internal.scaleFactor,n=e.internal.getFontSize(),a=e.getStringUnitWidth(t)*n/e.internal.scaleFactor,o=function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this};return new o({width:a*=Math.round(96*r/72*1e4)/1e4})},d.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var r=new c(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(r)},d.prototype.rotate=function(t){if(isNaN(t))throw i.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new c(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},d.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var r=new c(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(r)},d.prototype.transform=function(t,e,r,n,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(a)||isNaN(o))throw i.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var s=new c(t,e,r,n,a,o);this.ctx.transform=this.ctx.transform.multiply(s)},d.prototype.setTransform=function(t,e,r,n,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,r=isNaN(r)?0:r,n=isNaN(n)?1:n,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new c(t,e,r,n,i,a)},d.prototype.drawImage=function(t,e,r,n,i,a,o,s,l){var h=this.pdf.getImageProperties(t),f=1,d=1,p=1,g=1;void 0!==n&&void 0!==s&&(p=s/n,g=l/i,f=h.width/n*s/n,d=h.height/i*l/i),void 0===a&&(a=e,o=r,e=0,r=0),void 0!==n&&void 0===s&&(s=n,l=i),void 0===n&&void 0===s&&(s=h.width,l=h.height);for(var m,b=this.ctx.transform.decompose(),N=B(b.rotate.shx),A=new c,x=(A=(A=(A=A.multiply(b.translate)).multiply(b.skew)).multiply(b.scale)).applyToRectangle(new u(a-e*p,o-r*g,n*f,i*d)),S=v.call(this,x),_=[],P=0;P<S.length;P+=1)-1===_.indexOf(S[P])&&_.push(S[P]);if(w(_),this.autoPaging)for(var k=_[0],I=_[_.length-1],F=k;F<I+1;F++){if(this.pdf.setPage(F),0!==this.ctx.clip_path.length){var C=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=y(m,this.posX,-1*this.pdf.internal.pageSize.height*(F-1)+this.posY),L.call(this,"fill",!0),this.path=C}var j=JSON.parse(JSON.stringify(x));j=y([j],this.posX,-1*this.pdf.internal.pageSize.height*(F-1)+this.posY)[0],this.pdf.addImage(t,"JPEG",j.x,j.y,j.w,j.h,null,null,N)}else this.pdf.addImage(t,"JPEG",x.x,x.y,x.w,x.h,null,null,N)};var v=function(t,e,r){var n=[];switch(e=e||this.pdf.internal.pageSize.width,r=r||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":n.push(Math.floor((t.y+this.posY)/r)+1);break;case"arc":n.push(Math.floor((t.y+this.posY-t.radius)/r)+1),n.push(Math.floor((t.y+this.posY+t.radius)/r)+1);break;case"qct":var i=M(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);n.push(Math.floor(i.y/r)+1),n.push(Math.floor((i.y+i.h)/r)+1);break;case"bct":var a=E(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);n.push(Math.floor(a.y/r)+1),n.push(Math.floor((a.y+a.h)/r)+1);break;case"rect":n.push(Math.floor((t.y+this.posY)/r)+1),n.push(Math.floor((t.y+t.h+this.posY)/r)+1)}for(var o=0;o<n.length;o+=1)for(;this.pdf.internal.getNumberOfPages()<n[o];)b.call(this);return n},b=function(){var t=this.fillStyle,e=this.strokeStyle,r=this.font,n=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=r,this.lineCap=n,this.lineWidth=i,this.lineJoin=a},y=function(t,e,r){for(var n=0;n<t.length;n++)switch(t[n].type){case"bct":t[n].x2+=e,t[n].y2+=r;case"qct":t[n].x1+=e,t[n].y1+=r;case"mt":case"lt":case"arc":default:t[n].x+=e,t[n].y+=r}return t},w=function(t){return t.sort((function(t,e){return t-e}))},N=function(t,e){for(var r,n,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,u=s*this.ctx.transform.scaleX,c=this.lineJoin,l=JSON.parse(JSON.stringify(this.path)),h=JSON.parse(JSON.stringify(this.path)),f=[],d=0;d<h.length;d++)if(void 0!==h[d].x)for(var p=v.call(this,h[d]),g=0;g<p.length;g+=1)-1===f.indexOf(p[g])&&f.push(p[g]);for(var m=0;m<f.length;m++)for(;this.pdf.internal.getNumberOfPages()<f[m];)b.call(this);if(w(f),this.autoPaging)for(var N=f[0],A=f[f.length-1],x=N;x<A+1;x++){if(this.pdf.setPage(x),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=u,this.lineJoin=c,0!==this.ctx.clip_path.length){var S=this.path;r=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=y(r,this.posX,-1*this.pdf.internal.pageSize.height*(x-1)+this.posY),L.call(this,t,!0),this.path=S}n=JSON.parse(JSON.stringify(l)),this.path=y(n,this.posX,-1*this.pdf.internal.pageSize.height*(x-1)+this.posY),!1!==e&&0!==x||L.call(this,t,e),this.lineWidth=s}else this.lineWidth=u,L.call(this,t,e),this.lineWidth=s;this.path=l},L=function(t,e){if(("stroke"!==t||e||!m.call(this))&&("stroke"===t||e||!g.call(this))){for(var r,n,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var u=i.length;if(!isNaN(a[o-1].x)&&(r=[s.x-a[o-1].x,s.y-a[o-1].y],u>0))for(;u>=0;u--)if(!0!==i[u-1].close&&!0!==i[u-1].begin){i[u-1].deltas.push(r),i[u-1].abs.push(s);break}break;case"bct":r=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(r);break;case"qct":var c=a[o-1].x+2/3*(s.x1-a[o-1].x),l=a[o-1].y+2/3*(s.y1-a[o-1].y),h=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;r=[c-a[o-1].x,l-a[o-1].y,h-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(r);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s)}}n=e?null:"stroke"===t?"stroke":"fill";for(var v=0;v<i.length;v++){if(i[v].arc){for(var b=i[v].abs,y=0;y<b.length;y++){var w=b[y];"arc"===w.type?x.call(this,w.x,w.y,w.radius,w.startAngle,w.endAngle,w.counterclockwise,void 0,e):I.call(this,w.x,w.y)}S.call(this,n),this.pdf.internal.out("h")}if(!i[v].arc&&!0!==i[v].close&&!0!==i[v].begin){var N=i[v].start.x,L=i[v].start.y;F.call(this,i[v].deltas,N,L)}}n&&S.call(this,n),e&&_.call(this)}},A=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,r=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-r;case"top":return t+e-r;case"hanging":return t+e-2*r;case"middle":return t+e/2-r;case"ideographic":return t;case"alphabetic":default:return t}};d.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},d.prototype.createPattern=function(){return this.createLinearGradient()},d.prototype.createRadialGradient=function(){return this.createLinearGradient()};var x=function(t,e,r,n,i,a,o,s){for(var u=j.call(this,r,n,i,a),c=0;c<u.length;c++){var l=u[c];0===c&&P.call(this,l.x1+t,l.y1+e),C.call(this,t,e,l.x2,l.y2,l.x3,l.y3,l.x4,l.y4)}s?_.call(this):S.call(this,o)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip(),this.pdf.discardPath()},P=function(t,e){this.pdf.internal.out(r(t)+" "+n(e)+" m")},k=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var r=this.ctx.transform.applyToPoint(new s(t.x,t.y)),n=this.ctx.transform.decompose(),i=new c;i=(i=(i=i.multiply(n.translate)).multiply(n.skew)).multiply(n.scale);for(var a,o,l,h=this.pdf.getTextDimensions(t.text),f=this.ctx.transform.applyToRectangle(new u(t.x,t.y,h.w,h.h)),d=i.applyToRectangle(new u(t.x,t.y-h.h,h.w,h.h)),p=v.call(this,d),g=[],m=0;m<p.length;m+=1)-1===g.indexOf(p[m])&&g.push(p[m]);if(w(g),!0===this.autoPaging)for(var b=g[0],N=g[g.length-1],A=b;A<N+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var x=this.path;a=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=y(a,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),L.call(this,"fill",!0),this.path=x}var S=JSON.parse(JSON.stringify(f));S=y([S],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],t.scale>=.01&&(o=this.pdf.internal.getFontSize(),this.pdf.setFontSize(o*t.scale),l=this.lineWidth,this.lineWidth=l*t.scale),this.pdf.text(t.text,S.x,S.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(o),this.lineWidth=l)}else t.scale>=.01&&(o=this.pdf.internal.getFontSize(),this.pdf.setFontSize(o*t.scale),l=this.lineWidth,this.lineWidth=l*t.scale),this.pdf.text(t.text,r.x+this.posX,r.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(o),this.lineWidth=l)},I=function(t,e,i,a){i=i||0,a=a||0,this.pdf.internal.out(r(t+i)+" "+n(e+a)+" l")},F=function(t,e,r){return this.pdf.lines(t,e,r,null,null)},C=function(t,r,n,i,s,u,c,l){this.pdf.internal.out([e(a(n+t)),e(o(i+r)),e(a(s+t)),e(o(u+r)),e(a(c+t)),e(o(l+r)),"c"].join(" "))},j=function(t,e,r,n){for(var i=2*Math.PI,a=Math.PI/2;e>r;)e-=i;var o=Math.abs(r-e);o<i&&n&&(o=i-o);for(var s=[],u=n?-1:1,c=e;o>1e-5;){var l=c+u*Math.min(o,a);s.push(O.call(this,t,c,l)),o-=Math.abs(l-c),c=l}return s},O=function(t,e,r){var n=(r-e)/2,i=t*Math.cos(n),a=t*Math.sin(n),o=i,s=-a,u=o*o+s*s,c=u+o*i+s*a,l=4/3*(Math.sqrt(2*u*c)-c)/(o*a-s*i),h=o-l*s,f=s+l*o,d=h,p=-f,g=n+e,m=Math.cos(g),v=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*m-f*v,y2:h*v+f*m,x3:d*m-p*v,y3:d*v+p*m,x4:t*Math.cos(r),y4:t*Math.sin(r)}},B=function(t){return 180*t/Math.PI},M=function(t,e,r,n,i,a){var o=t+.5*(r-t),s=e+.5*(n-e),c=i+.5*(r-i),l=a+.5*(n-a),h=Math.min(t,i,o,c),f=Math.max(t,i,o,c),d=Math.min(e,a,s,l),p=Math.max(e,a,s,l);return new u(h,d,f-h,p-d)},E=function(t,e,r,n,i,a,o,s){var c,l,h,f,d,p,g,m,v,b,y,w,N,L,A=r-t,x=n-e,S=i-r,_=a-n,P=o-i,k=s-a;for(l=0;l<41;l++)v=(g=(h=t+(c=l/40)*A)+c*((d=r+c*S)-h))+c*(d+c*(i+c*P-d)-g),b=(m=(f=e+c*x)+c*((p=n+c*_)-f))+c*(p+c*(a+c*k-p)-m),0==l?(y=v,w=b,N=v,L=b):(y=Math.min(y,v),w=Math.min(w,b),N=Math.max(N,v),L=Math.max(L,b));return new u(Math.round(y),Math.round(w),Math.round(N-y),Math.round(L-w))}}(O.API),
/**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(e){var r=function(t){var e,r,n,i,a,o,s,u,c,l;for(/[^\x00-\xFF]/.test(t),r=[],n=0,i=(t+=e="\0\0\0\0".slice(t.length%4||4)).length;i>n;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(l=a%85))/85)-(c=a%85))/85)-(u=a%85))/85)-(s=a%85))/85)%85,r.push(o+33,s+33,u+33,c+33,l+33)):r.push(122);return function(t,e){for(var r=e;r>0;r--)t.pop()}(r,e.length),String.fromCharCode.apply(String,r)+"~>"},n=function(t){var e,r,n,i,a,o=String,s="length",u=255,c="charCodeAt",l="slice",h="replace";for(t[l](-2),t=t[l](0,-2)[h](/\s/g,"")[h]("z","!!!!!"),n=[],i=0,a=(t+=e="uuuuu"[l](t[s]%5||5))[s];a>i;i+=5)r=52200625*(t[c](i)-33)+614125*(t[c](i+1)-33)+7225*(t[c](i+2)-33)+85*(t[c](i+3)-33)+(t[c](i+4)-33),n.push(u&r>>24,u&r>>16,u&r>>8,u&r);return function(t,e){for(var r=e;r>0;r--)t.pop()}(n,e[s]),o.fromCharCode.apply(o,n)},i=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var r="",n=0;n<t.length;n+=2)r+=String.fromCharCode("0x"+(t[n]+t[n+1]));return r},a=function(e){for(var r=new Uint8Array(e.length),n=e.length;n--;)r[n]=e.charCodeAt(n);return e=(r=(0,fflate__WEBPACK_IMPORTED_MODULE_0__.zlibSync)(r)).reduce((function(t,e){return t+String.fromCharCode(e)}),"")};e.processDataByFilters=function(t,e){var o=0,s=t||"",u=[];for("string"==typeof(e=e||[])&&(e=[e]),o=0;o<e.length;o+=1)switch(e[o]){case"ASCII85Decode":case"/ASCII85Decode":s=n(s),u.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":s=r(s),u.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":s=i(s),u.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":s=s.split("").map((function(t){return("0"+t.charCodeAt().toString(16)).slice(-2)})).join("")+">",u.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":s=a(s),u.push("/FlateDecode");break;default:throw new Error('The filter: "'+e[o]+'" is not implemented')}return{data:s,reverseChain:u.reverse().join(" ")}}}(O.API),
/**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.loadFile=function(t,e,r){return function(t,e,r){e=!1!==e,r="function"==typeof r?r:function(){};var n=void 0;try{n=function(t,e,r){var n=new XMLHttpRequest,i=0,a=function(t){var e=t.length,r=[],n=String.fromCharCode;for(i=0;i<e;i+=1)r.push(n(255&t.charCodeAt(i)));return r.join("")};if(n.open("GET",t,!e),n.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(n.onload=function(){200===n.status?r(a(this.responseText)):r(void 0)}),n.send(null),e&&200===n.status)return a(n.responseText)}(t,e,r)}catch(t){}return n}(t,e,r)},t.loadImageFile=t.loadFile}(O.API),
/**
 * @license
 * Copyright (c) 2018 Erik Koopmans
 * Released under the MIT License.
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){function e(){return(r.html2canvas?Promise.resolve(r.html2canvas):Promise.resolve(/*! import() */).then(__webpack_require__.t.bind(__webpack_require__, /*! html2canvas */ "./node_modules/html2canvas/dist/html2canvas.js", 23))).catch((function(t){return Promise.reject(new Error("Could not load html2canvas: "+t))})).then((function(t){return t.default?t.default:t}))}function n(){return(r.DOMPurify?Promise.resolve(r.DOMPurify):Promise.resolve(/*! import() */).then(__webpack_require__.t.bind(__webpack_require__, /*! dompurify */ "./node_modules/dompurify/dist/purify.js", 23))).catch((function(t){return Promise.reject(new Error("Could not load dompurify: "+t))})).then((function(t){return t.default?t.default:t}))}var i=function(t){var e=typeof t;return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},a=function(t,e){var r=document.createElement(t);for(var n in e.className&&(r.className=e.className),e.innerHTML&&e.dompurify&&(r.innerHTML=e.dompurify.sanitize(e.innerHTML)),e.style)r.style[n]=e.style[n];return r},o=function(t,e){for(var r=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),n=t.firstChild;n;n=n.nextSibling)!0!==e&&1===n.nodeType&&"SCRIPT"===n.nodeName||r.appendChild(o(n,e));return 1===t.nodeType&&("CANVAS"===t.nodeName?(r.width=t.width,r.height=t.height,r.getContext("2d").drawImage(t,0,0)):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(r.value=t.value),r.addEventListener("load",(function(){r.scrollTop=t.scrollTop,r.scrollLeft=t.scrollLeft}),!0)),r},s=function t(e){var r=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),n=t.convert(Promise.resolve(),r);return n=(n=n.setProgress(1,t,1,[t])).set(e)};(s.prototype=Object.create(Promise.prototype)).constructor=s,s.convert=function(t,e){return t.__proto__=e||s.prototype,t},s.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{},backgroundColor:"transparent"}},s.prototype.from=function(t,e){return this.then((function(){switch(e=e||function(t){switch(i(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase()?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.then(n).then((function(e){return this.set({src:a("div",{innerHTML:t,dompurify:e})})}));case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}}))},s.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},s.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then((function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:this.opt.backgroundColor},e=o(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=a("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=a("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(a("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"}))},s.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(e).then((function(t){var e=Object.assign({},this.opt.html2canvas);return delete e.onrendered,t(this.prop.container,e)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},s.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(e).then((function(t){var e=this.opt.jsPDF,r=this.opt.fontFaces,n=Object.assign({async:!0,allowTaint:!0,scale:1,scrollX:this.opt.scrollX||0,scrollY:this.opt.scrollY||0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete n.onrendered,e.context2d.autoPaging=!0,e.context2d.posX=this.opt.x,e.context2d.posY=this.opt.y,e.context2d.fontFaces=r,r)for(var i=0;i<r.length;++i){var a=r[i],o=a.src.find((function(t){return"truetype"===t.format}));o&&e.addFont(o.url,a.ref.name,a.ref.style)}return n.windowHeight=n.windowHeight||0,n.windowHeight=0==n.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):n.windowHeight,t(this.prop.container,n)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},s.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then((function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t}))},s.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then((function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF}))},s.prototype.output=function(t,e,r){return"img"===(r=r||"pdf").toLowerCase()||"image"===r.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},s.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){return this.prop.pdf.output(t,e)}))},s.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then((function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}}))},s.prototype.save=function(t){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then((function(){this.prop.pdf.save(this.opt.filename)}))},s.prototype.doCallback=function(){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){this.prop.callback(this.prop.pdf)}))},s.prototype.set=function(t){if("object"!==i(t))return this;var e=Object.keys(t||{}).map((function(e){if(e in s.template.prop)return function(){this.prop[e]=t[e]};switch(e){case"margin":return this.setMargin.bind(this,t.margin);case"jsPDF":return function(){return this.opt.jsPDF=t.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,t.pageSize);default:return function(){this.opt[e]=t[e]}}}),this);return this.then((function(){return this.thenList(e)}))},s.prototype.get=function(t,e){return this.then((function(){var r=t in s.template.prop?this.prop[t]:this.opt[t];return e?e(r):r}))},s.prototype.setMargin=function(t){return this.then((function(){switch(i(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t})).then(this.setPageSize)},s.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then((function(){(t=t||O.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t}))},s.prototype.setProgress=function(t,e,r,n){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=r&&(this.progress.n=r),null!=n&&(this.progress.stack=n),this.progress.ratio=this.progress.val/this.progress.state,this},s.prototype.updateProgress=function(t,e,r,n){return this.setProgress(t?this.progress.val+t:null,e||null,r?this.progress.n+r:null,n?this.progress.stack.concat(n):null)},s.prototype.then=function(t,e){var r=this;return this.thenCore(t,e,(function(t,e){return r.updateProgress(null,null,1,[t]),Promise.prototype.then.call(this,(function(e){return r.updateProgress(null,t),e})).then(t,e).then((function(t){return r.updateProgress(1),t}))}))},s.prototype.thenCore=function(t,e,r){r=r||Promise.prototype.then;t&&(t=t.bind(this)),e&&(e=e.bind(this));var n=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?this:s.convert(Object.assign({},this),Promise.prototype),i=r.call(n,t,e);return s.convert(i,this.__proto__)},s.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},s.prototype.thenList=function(t){var e=this;return t.forEach((function(t){e=e.thenCore(t)})),e},s.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return s.convert(e,this)},s.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},s.prototype.error=function(t){return this.then((function(){throw new Error(t)}))},s.prototype.using=s.prototype.set,s.prototype.saveAs=s.prototype.save,s.prototype.export=s.prototype.output,s.prototype.run=s.prototype.then,O.getPageSize=function(t,e,r){if("object"==typeof t){var n=t;t=n.orientation,e=n.unit||e,r=n.format||r}e=e||"mm",r=r||"a4",t=(""+(t||"P")).toLowerCase();var i,a=(""+r).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":i=1;break;case"mm":i=72/25.4;break;case"cm":i=72/2.54;break;case"in":i=72;break;case"px":i=.75;break;case"pc":case"em":i=12;break;case"ex":i=6;break;default:throw"Invalid unit: "+e}var s,u=0,c=0;if(o.hasOwnProperty(a))u=o[a][1]/i,c=o[a][0]/i;else try{u=r[1],c=r[0]}catch(t){throw new Error("Invalid format: "+r)}if("p"===t||"portrait"===t)t="p",c>u&&(s=c,c=u,u=s);else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",u>c&&(s=c,c=u,u=s)}return{width:c,height:u,unit:e,k:i,orientation:t}},t.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.fontFaces=e.fontFaces?e.fontFaces.map(It):null;var r=new s(e);return e.worker?r:r.from(t).doCallback()}}(O.API),O.API.addJS=function(t){return Dt=t,this.internal.events.subscribe("postPutResources",(function(){Rt=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(Rt+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),Tt=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+Dt+")"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){void 0!==Rt&&void 0!==Tt&&this.internal.out("/Names <</JavaScript "+Rt+" 0 R>>")})),this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e;t.events.push(["postPutResources",function(){var t=this,r=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),i=0;i<n.length;i++){var a=n[i],o=r.exec(a);if(null!=o){var s=o[1];t.internal.newObjectDeferredBegin(s,!1)}t.internal.write(a)}if(this.outline.createNamedDestinations){var u=this.internal.pages.length,c=[];for(i=0;i<u;i++){var l=t.internal.newObject();c.push(l);var h=t.internal.getPageInfo(i+1);t.internal.write("<< /D["+h.objId+" 0 R /XYZ null null null]>> endobj")}var f=t.internal.newObject();t.internal.write("<< /Names [ ");for(i=0;i<c.length;i++)t.internal.write("(page_"+(i+1)+")"+c[i]+" 0 R");t.internal.write(" ] >>","endobj"),e=t.internal.newObject(),t.internal.write("<< /Dests "+f+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){this.outline.root.children.length>0&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+e+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,r){var n={title:e,options:r,children:[]};return null==t&&(t=this.root),t.children.push(n),n},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var r=0;r<e.children.length;r++)this.genIds_r(e.children[r])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(var r=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<e.children.length;n++){var i=e.children[n];this.objStart(i),this.line("/Title "+this.makeString(i.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),i.children.length>0&&(this.line("/First "+this.makeRef(i.children[0])),this.line("/Last "+this.makeRef(i.children[i.children.length-1])));var a=this.count=this.count_r({count:0},i);if(a>0&&this.line("/Count "+a),i.options&&i.options.pageNumber){var o=t.internal.getPageInfo(i.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+r(0)+" 0]")}this.objEnd()}for(var s=0;s<e.children.length;s++)this.renderItems(e.children[s])},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var r=0;r<e.children.length;r++)t.count++,this.count_r(t,e.children[r]);return t.count}}])}(O.API),
/**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=[192,193,194,195,196,197,198,199];t.processJPEG=function(t,r,n,i,a,o){var s,u=this.decode.DCT_DECODE,c=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=a||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(s=function(t){for(var r,n=256*t.charCodeAt(4)+t.charCodeAt(5),i=t.length,a={width:0,height:0,numcomponents:1},o=4;o<i;o+=2){if(o+=n,-1!==e.indexOf(t.charCodeAt(o+1))){r=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),a={width:256*t.charCodeAt(o+7)+t.charCodeAt(o+8),height:r,numcomponents:t.charCodeAt(o+9)};break}n=256*t.charCodeAt(o+2)+t.charCodeAt(o+3)}return a}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;case 3:o=this.color_spaces.DEVICE_RGB}c={data:t,width:s.width,height:s.height,colorSpace:o,bitsPerComponent:8,filter:u,index:r,alias:n}}return c}}(O.API);var zt,Ht,Vt,Wt,Gt,Yt=function(){var t,n,i;function a(t){var e,r,n,i,a,o,s,u,c,l,h,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),c=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===c&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:f>e;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(n=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>n)throw new Error("More transparent colors than palette size");if((l=n-this.transparency.indexed.length)>0)for(d=0;0<=l?d<l:d>l;0<=l?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(h=this.read(e)).indexOf(0),u=String.fromCharCode.apply(String,h.slice(0,s)),this.text[u]=String.fromCharCode.apply(String,h.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}a.prototype.read=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)r.push(this.data[this.pos++]);return r},a.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.decodePixels=function(t){var r=this.pixelBitlength/8,n=new Uint8Array(this.width*this.height*r),i=0,a=this;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);function o(e,o,s,u){var c,l,h,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F=Math.ceil((a.width-e)/s),C=Math.ceil((a.height-o)/u),j=a.width==F&&a.height==C;for(L=r*F,w=j?n:new Uint8Array(L*C),p=t.length,N=0,l=0;N<C&&i<p;){switch(t[i++]){case 0:for(f=S=0;S<L;f=S+=1)w[l++]=t[i++];break;case 1:for(f=_=0;_<L;f=_+=1)c=t[i++],d=f<r?0:w[l-r],w[l++]=(c+d)%256;break;case 2:for(f=P=0;P<L;f=P+=1)c=t[i++],h=(f-f%r)/r,A=N&&w[(N-1)*L+h*r+f%r],w[l++]=(A+c)%256;break;case 3:for(f=k=0;k<L;f=k+=1)c=t[i++],h=(f-f%r)/r,d=f<r?0:w[l-r],A=N&&w[(N-1)*L+h*r+f%r],w[l++]=(c+Math.floor((d+A)/2))%256;break;case 4:for(f=I=0;I<L;f=I+=1)c=t[i++],h=(f-f%r)/r,d=f<r?0:w[l-r],0===N?A=x=0:(A=w[(N-1)*L+h*r+f%r],x=h&&w[(N-1)*L+(h-1)*r+f%r]),g=d+A-x,m=Math.abs(g-d),b=Math.abs(g-A),y=Math.abs(g-x),v=m<=b&&m<=y?d:b<=y?A:x,w[l++]=(c+v)%256;break;default:throw new Error("Invalid filter algorithm: "+t[i-1])}if(!j){var O=((o+N*u)*a.width+e)*r,B=N*L;for(f=0;f<F;f+=1){for(var M=0;M<r;M+=1)n[O++]=w[B++];O+=(s-1)*r}}N++}}return t=(0,fflate__WEBPACK_IMPORTED_MODULE_0__.unzlibSync)(t),1==a.interlaceMethod?(o(0,0,8,8),o(4,0,8,8),o(0,4,4,8),o(2,0,4,4),o(0,2,2,4),o(1,0,2,2),o(0,1,1,2)):o(0,0,1,1),n},a.prototype.decodePalette=function(){var t,e,r,n,i,a,o,s,u;for(r=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+r.length),n=0,t=0,e=o=0,s=r.length;o<s;e=o+=3)i[n++]=r[e],i[n++]=r[e+1],i[n++]=r[e+2],i[n++]=null!=(u=a[t++])?u:255;return i},a.prototype.copyToImageData=function(t,e){var r,n,i,a,o,s,u,c,l,h,f;if(n=this.colors,l=null,r=this.hasAlphaChannel,this.palette.length&&(l=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),n=4,r=!0),c=(i=t.data||t).length,o=l||e,a=s=0,1===n)for(;a<c;)u=l?4*e[a/4]:s,h=o[u++],i[a++]=h,i[a++]=h,i[a++]=h,i[a++]=r?o[u++]:255,s=u;else for(;a<c;)u=l?4*e[a/4]:s,i[a++]=o[u++],i[a++]=o[u++],i[a++]=o[u++],i[a++]=r?o[u++]:255,s=u},a.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};var o=function(){if("[object Window]"===Object.prototype.toString.call(r)){try{n=r.document.createElement("canvas"),i=n.getContext("2d")}catch(t){return!1}return!0}return!1};return o(),t=function(t){var e;if(!0===o())return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e;throw new Error("This method requires a Browser with Canvas-capability.")},a.prototype.decodeFrames=function(e){var r,n,i,a,o,s,u,c;if(this.animation){for(c=[],n=o=0,s=(u=this.animation.frames).length;o<s;n=++o)r=u[n],i=e.createImageData(r.width,r.height),a=this.decodePixels(new Uint8Array(r.data)),this.copyToImageData(i,a),r.imageData=i,c.push(r.image=t(i));return c}},a.prototype.renderFrame=function(t,e){var r,n,i;return r=(n=this.animation.frames)[e],i=n[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===r.blendOp&&t.clearRect(r.xOffset,r.yOffset,r.width,r.height),t.drawImage(r.image,r.xOffset,r.yOffset)},a.prototype.animate=function(t){var e,r,n,i,a,o,s=this;return r=0,o=this.animation,i=o.numFrames,n=o.frames,a=o.numPlays,(e=function(){var o,u;if(o=r++%i,u=n[o],s.renderFrame(t,o),i>1&&r/i<a)return s.animation._timeout=setTimeout(e,u.delay)})()},a.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},a.prototype.render=function(t){var e,r;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(r=e.createImageData(this.width,this.height),this.copyToImageData(r,this.decodePixels()),e.putImageData(r,0,0))},a}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Jt(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,n=t[e++]|t[e++]<<8,i=t[e++],a=i>>7,o=1<<(7&i)+1;t[e++];t[e++];var s=null,u=null;a&&(s=e,u=o,e+=3*o);var c=!0,l=[],h=0,f=null,d=0,p=null;for(this.width=r,this.height=n;c&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,p=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var g=t[e++];h=t[e++]|t[e++]<<8,f=t[e++],0==(1&g)&&(f=null),d=g>>2&7,e++;break;case 254:for(;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var m=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,b=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,w=t[e++],N=w>>6&1,L=1<<(7&w)+1,A=s,x=u,S=!1;if(w>>7){S=!0;A=e,x=L,e+=3*L}var _=e;for(e++;;){var P;if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}l.push({x:m,y:v,width:b,height:y,has_local_palette:S,palette_offset:A,palette_size:x,data_offset:_,data_length:e-_,transparent_index:f,interlaced:!!N,delay:h,disposal:d});break;case 59:c=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return l.length},this.loopCount=function(){return p},this.frameInfo=function(t){if(t<0||t>=l.length)throw new Error("Frame index out of range.");return l[t]},this.decodeAndBlitFrameBGRA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);Xt(t,i.data_offset,o,a);var s=i.palette_offset,u=i.transparent_index;null===u&&(u=256);var c=i.width,l=r-c,h=c,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*l;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===h&&(h=c,(p+=g)>=d&&(g=4*l+4*r*(m-1),p=f+(c+l)*(m<<1),m>>=1)),y===u)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=L,n[p++]=N,n[p++]=w,n[p++]=255}--h}},this.decodeAndBlitFrameRGBA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);Xt(t,i.data_offset,o,a);var s=i.palette_offset,u=i.transparent_index;null===u&&(u=256);var c=i.width,l=r-c,h=c,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*l;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===h&&(h=c,(p+=g)>=d&&(g=4*l+4*r*(m-1),p=f+(c+l)*(m<<1),m>>=1)),y===u)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=w,n[p++]=N,n[p++]=L,n[p++]=255}--h}}}function Xt(t,e,r,n){for(var a=t[e++],o=1<<a,s=o+1,u=s+1,c=a+1,l=(1<<c)-1,h=0,f=0,d=0,p=t[e++],g=new Int32Array(4096),m=null;;){for(;h<16&&0!==p;)f|=t[e++]<<h,h+=8,1===p?p=t[e++]:--p;if(h<c)break;var v=f&l;if(f>>=c,h-=c,v!==o){if(v===s)break;for(var b=v<u?v:m,y=0,w=b;w>o;)w=g[w]>>8,++y;var N=w;if(d+y+(b!==v?1:0)>n)return void i.log("Warning, gif stream longer than expected.");r[d++]=N;var L=d+=y;for(b!==v&&(r[d++]=N),w=b;y--;)w=g[w],r[--L]=255&w,w>>=8;null!==m&&u<4096&&(g[u++]=m<<8|N,u>=l+1&&c<12&&(++c,l=l<<1|1)),m=v}else u=s+1,l=(1<<(c=a+1))-1,m=null}return d!==n&&i.log("Warning, gif stream shorter than expected."),r}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/function Kt(t){var e,r,n,i,a,o=Math.floor,s=new Array(64),u=new Array(64),c=new Array(64),l=new Array(64),h=new Array(65535),f=new Array(65535),d=new Array(64),p=new Array(64),g=[],m=0,v=7,b=new Array(64),y=new Array(64),w=new Array(64),N=new Array(256),L=new Array(2048),A=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],x=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],_=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],P=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],k=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],I=[0,1,2,3,4,5,6,7,8,9,10,11],F=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],C=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function j(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2}return i}function O(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(m|=1<<v),r--,--v<0&&(255==m?(B(255),B(0)):B(m),v=7,m=0)}function B(t){g.push(t)}function M(t){B(t>>8&255),B(255&t)}function E(t,e,r,n,i){for(var a,o=i[0],s=i[240],u=function(t,e){var r,n,i,a,o,s,u,c,l,h,f=0;for(l=0;l<8;++l){r=t[f],n=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],u=t[f+6];var p=r+(c=t[f+7]),g=r-c,m=n+u,v=n-u,b=i+s,y=i-s,w=a+o,N=a-o,L=p+w,A=p-w,x=m+b,S=m-b;t[f]=L+x,t[f+4]=L-x;var _=.707106781*(S+A);t[f+2]=A+_,t[f+6]=A-_;var P=.382683433*((L=N+y)-(S=v+g)),k=.5411961*L+P,I=1.306562965*S+P,F=.707106781*(x=y+v),C=g+F,j=g-F;t[f+5]=j+k,t[f+3]=j-k,t[f+1]=C+I,t[f+7]=C-I,f+=8}for(f=0,l=0;l<8;++l){r=t[f],n=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],u=t[f+48];var O=r+(c=t[f+56]),B=r-c,M=n+u,E=n-u,q=i+s,R=i-s,T=a+o,D=a-o,U=O+T,z=O-T,H=M+q,V=M-q;t[f]=U+H,t[f+32]=U-H;var W=.707106781*(V+z);t[f+16]=z+W,t[f+48]=z-W;var G=.382683433*((U=D+R)-(V=E+B)),Y=.5411961*U+G,J=1.306562965*V+G,X=.707106781*(H=R+E),K=B+X,Z=B-X;t[f+40]=Z+Y,t[f+24]=Z-Y,t[f+8]=K+J,t[f+56]=K-J,f++}for(l=0;l<64;++l)h=t[l]*e[l],d[l]=h>0?h+.5|0:h-.5|0;return d}(t,e),c=0;c<64;++c)p[A[c]]=u[c];var l=p[0]-r;r=p[0],0==l?O(n[0]):(O(n[f[a=32767+l]]),O(h[a]));for(var g=63;g>0&&0==p[g];)g--;if(0==g)return O(o),r;for(var m,v=1;v<=g;){for(var b=v;0==p[v]&&v<=g;)++v;var y=v-b;if(y>=16){m=y>>4;for(var w=1;w<=m;++w)O(s);y&=15}a=32767+p[v],O(i[(y<<4)+f[a]]),O(h[a]),v++}return 63!=g&&O(o),r}function q(t){(t=Math.min(Math.max(t,1),100),a!=t)&&(!function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=o((e[r]*t+50)/100);n=Math.min(Math.max(n,1),255),s[A[r]]=n}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var h=o((i[a]*t+50)/100);h=Math.min(Math.max(h,1),255),u[A[a]]=h}for(var f=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var g=0;g<8;g++)c[d]=1/(s[A[d]]*f[p]*f[g]*8),l[d]=1/(u[A[d]]*f[p]*f[g]*8),d++}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),a=t)}this.encode=function(t,a){a&&q(a),g=new Array,m=0,v=7,M(65496),M(65504),M(16),B(74),B(70),B(73),B(70),B(0),B(1),B(1),B(0),M(1),M(1),B(0),B(0),function(){M(65499),M(132),B(0);for(var t=0;t<64;t++)B(s[t]);B(1);for(var e=0;e<64;e++)B(u[e])}(),function(t,e){M(65472),M(17),B(8),M(e),M(t),B(3),B(1),B(17),B(0),B(2),B(17),B(1),B(3),B(17),B(1)}(t.width,t.height),function(){M(65476),M(418),B(0);for(var t=0;t<16;t++)B(x[t+1]);for(var e=0;e<=11;e++)B(S[e]);B(16);for(var r=0;r<16;r++)B(_[r+1]);for(var n=0;n<=161;n++)B(P[n]);B(1);for(var i=0;i<16;i++)B(k[i+1]);for(var a=0;a<=11;a++)B(I[a]);B(17);for(var o=0;o<16;o++)B(F[o+1]);for(var s=0;s<=161;s++)B(C[s])}(),M(65498),M(12),B(3),B(1),B(0),B(2),B(17),B(3),B(17),B(0),B(63),B(0);var o=0,h=0,f=0;m=0,v=7,this.encode.displayName="_encode_";for(var d,p,N,A,j,R,T,D,U,z=t.data,H=t.width,V=t.height,W=4*H,G=0;G<V;){for(d=0;d<W;){for(j=W*G+d,T=-1,D=0,U=0;U<64;U++)R=j+(D=U>>3)*W+(T=4*(7&U)),G+D>=V&&(R-=W*(G+1+D-V)),d+T>=W&&(R-=d+T-W+4),p=z[R++],N=z[R++],A=z[R++],b[U]=(L[p]+L[N+256>>0]+L[A+512>>0]>>16)-128,y[U]=(L[p+768>>0]+L[N+1024>>0]+L[A+1280>>0]>>16)-128,w[U]=(L[p+1280>>0]+L[N+1536>>0]+L[A+1792>>0]>>16)-128;o=E(b,c,o,e,n),h=E(y,l,h,r,i),f=E(w,l,f,r,i),d+=32}G+=8}if(v>=0){var Y=[];Y[1]=v+1,Y[0]=(1<<v+1)-1,O(Y)}return M(65497),new Uint8Array(g)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)N[e]=t(e)}(),e=j(x,S),r=j(k,I),n=j(_,P),i=j(F,C),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)f[32767+n]=r,h[32767+n]=[],h[32767+n][1]=r,h[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)f[32767+i]=r,h[32767+i]=[],h[32767+i][1]=r,h[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)L[t]=19595*t,L[t+256>>0]=38470*t,L[t+512>>0]=7471*t+32768,L[t+768>>0]=-11059*t,L[t+1024>>0]=-21709*t,L[t+1280>>0]=32768*t+8421375,L[t+1536>>0]=-27439*t,L[t+1792>>0]=-5329*t}(),q(t)}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */function Zt(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}function $t(t){function e(t){if(!t)throw Error("assert :P")}function r(t,e,r){for(var n=0;4>n;n++)if(t[e+n]!=r.charCodeAt(n))return!0;return!1}function n(t,e,r,n,i){for(var a=0;a<i;a++)t[e+a]=r[n+a]}function i(t,e,r,n){for(var i=0;i<n;i++)t[e+i]=r}function a(t){return new Int32Array(t)}function o(t,e){for(var r=[],n=0;n<t;n++)r.push(new e);return r}function s(t,e){var r=[];return function t(r,n,i){for(var a=i[n],o=0;o<a&&(r.push(i.length>n+1?[]:new e),!(i.length<n+1));o++)t(r[o],n+1,i)}(r,0,t),r}function u(t,e){for(var r="",n=0;n<4;n++)r+=String.fromCharCode(t[e++]);return r}function c(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function l(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new($t=function(){var t=this;function u(t,e){for(var r=1<<e-1>>>0;t&r;)r>>>=1;return r?(t&r-1)+r:t}function c(t,r,n,i,a){e(!(i%n));do{t[r+(i-=n)]=a}while(0<i)}function l(t,r,n,i,o){if(e(2328>=o),512>=o)var s=a(512);else if(null==(s=a(o)))return 0;return function(t,r,n,i,o,s){var l,f,d=r,p=1<<n,g=a(16),m=a(16);for(e(0!=o),e(null!=i),e(null!=t),e(0<n),f=0;f<o;++f){if(15<i[f])return 0;++g[i[f]]}if(g[0]==o)return 0;for(m[1]=0,l=1;15>l;++l){if(g[l]>1<<l)return 0;m[l+1]=m[l]+g[l]}for(f=0;f<o;++f)l=i[f],0<i[f]&&(s[m[l]++]=f);if(1==m[15])return(i=new h).g=0,i.value=s[0],c(t,d,1,p,i),p;var v,b=-1,y=p-1,w=0,N=1,L=1,A=1<<n;for(f=0,l=1,o=2;l<=n;++l,o<<=1){if(N+=L<<=1,0>(L-=g[l]))return 0;for(;0<g[l];--g[l])(i=new h).g=l,i.value=s[f++],c(t,d+w,o,A,i),w=u(w,l)}for(l=n+1,o=2;15>=l;++l,o<<=1){if(N+=L<<=1,0>(L-=g[l]))return 0;for(;0<g[l];--g[l]){if(i=new h,(w&y)!=b){for(d+=A,v=1<<(b=l)-n;15>b&&!(0>=(v-=g[b]));)++b,v<<=1;p+=A=1<<(v=b-n),t[r+(b=w&y)].g=v+n,t[r+b].value=d-r-b}i.g=l-n,i.value=s[f++],c(t,d+(w>>n),o,A,i),w=u(w,l)}}return N!=2*m[15]-1?0:p}(t,r,n,i,o,s)}function h(){this.value=this.g=0}function f(){this.value=this.g=0}function d(){this.G=o(5,h),this.H=a(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=o(Rr,f)}function p(t,r,n,i){e(null!=t),e(null!=r),e(2147483648>i),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=r,t.pa=n,t.Jd=r,t.Yc=n+i,t.Zc=4<=i?n+i-4+1:n,_(t)}function g(t,e){for(var r=0;0<e--;)r|=k(t,128)<<e;return r}function m(t,e){var r=g(t,e);return P(t)?-r:r}function v(t,r,n,i){var a,o=0;for(e(null!=t),e(null!=r),e(4294967288>i),t.Sb=i,t.Ra=0,t.u=0,t.h=0,4<i&&(i=4),a=0;a<i;++a)o+=r[n+a]<<8*a;t.Ra=o,t.bb=i,t.oa=r,t.pa=n}function b(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<Ur-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0)}function y(t,r){if(e(0<=r),!t.h&&r<=Dr){var n=L(t)&Tr[r];return t.u+=r,b(t),n}return t.h=1,t.u=0}function w(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0}function N(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0}function L(t){return t.Ra>>>(t.u&Ur-1)>>>0}function A(t){return e(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>Ur}function x(t,e){t.u=e,t.h=A(t)}function S(t){t.u>=zr&&(e(t.u>=zr),b(t))}function _(t){e(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(e(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1))}function P(t){return g(t,1)}function k(t,e){var r=t.Ca;0>t.b&&_(t);var n=t.b,i=r*e>>>8,a=(t.I>>>n>i)+0;for(a?(r-=i,t.I-=i+1<<n>>>0):r=i+1,n=r,i=0;256<=n;)i+=8,n>>=8;return n=7^i+Hr[n],t.b-=n,t.Ca=(r<<n)-1,a}function I(t,e,r){t[e+0]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255}function F(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return F(t,e)|t[e+2]<<16}function j(t,e){return F(t,e)|F(t,e+2)<<16}function O(t,r){var n=1<<r;return e(null!=t),e(0<r),t.X=a(n),null==t.X?0:(t.Mb=32-r,t.Xa=r,1)}function B(t,r){e(null!=t),e(null!=r),e(t.Xa==r.Xa),n(r.X,0,t.X,0,1<<r.Xa)}function M(){this.X=[],this.Xa=this.Mb=0}function E(t,r,n,i){e(null!=n),e(null!=i);var a=n[0],o=i[0];return 0==a&&(a=(t*o+r/2)/r),0==o&&(o=(r*a+t/2)/t),0>=a||0>=o?0:(n[0]=a,i[0]=o,1)}function q(t,e){return t+(1<<e)-1>>>e}function R(t,e){return((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function T(e,r){t[r]=function(r,n,i,a,o,s,u){var c;for(c=0;c<o;++c){var l=t[e](s[u+c-1],i,a+c);s[u+c]=R(r[n+c],l)}}}function D(){this.ud=this.hd=this.jd=0}function U(t,e){return((4278124286&(t^e))>>>1)+(t&e)>>>0}function z(t){return 0<=t&&256>t?t:0>t?0:255<t?255:void 0}function H(t,e){return z(t+(t-e+.5>>1))}function V(t,e,r){return Math.abs(e-r)-Math.abs(t-r)}function W(t,e,r,n,i,a,o){for(n=a[o-1],r=0;r<i;++r)a[o+r]=n=R(t[e+r],n)}function G(t,e,r,n,i){var a;for(a=0;a<r;++a){var o=t[e+a],s=o>>8&255,u=16711935&(u=(u=16711935&o)+((s<<16)+s));n[i+a]=(4278255360&o)+u>>>0}}function Y(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255}function J(t,e,r,n,i,a){var o;for(o=0;o<n;++o){var s=e[r+o],u=s>>>8,c=s,l=255&(l=(l=s>>>16)+((t.jd<<24>>24)*(u<<24>>24)>>>5));c=255&(c=(c=c+((t.hd<<24>>24)*(u<<24>>24)>>>5))+((t.ud<<24>>24)*(l<<24>>24)>>>5));i[a+o]=(4278255360&s)+(l<<16)+c}}function X(e,r,n,i,a){t[r]=function(t,e,r,n,o,s,u,c,l){for(n=u;n<c;++n)for(u=0;u<l;++u)o[s++]=a(r[i(t[e++])])},t[e]=function(e,r,o,s,u,c,l){var h=8>>e.b,f=e.Ea,d=e.K[0],p=e.w;if(8>h)for(e=(1<<e.b)-1,p=(1<<h)-1;r<o;++r){var g,m=0;for(g=0;g<f;++g)g&e||(m=i(s[u++])),c[l++]=a(d[m&p]),m>>=h}else t["VP8LMapColor"+n](s,u,d,p,c,l,r,o,f)}}function K(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255}}function Z(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255,n[i++]=a>>24&255}}function $(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;n[i++]=a,n[i++]=o}}function Q(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;n[i++]=a,n[i++]=o}}function tt(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>0&255,n[i++]=a>>8&255,n[i++]=a>>16&255}}function et(t,e,r,i,a,o){if(0==o)for(r=e+r;e<r;)I(i,((o=t[e++])[0]>>24|o[1]>>8&65280|o[2]<<8&16711680|o[3]<<24)>>>0),a+=32;else n(i,a,t,e,r)}function rt(e,r){t[r][0]=t[e+"0"],t[r][1]=t[e+"1"],t[r][2]=t[e+"2"],t[r][3]=t[e+"3"],t[r][4]=t[e+"4"],t[r][5]=t[e+"5"],t[r][6]=t[e+"6"],t[r][7]=t[e+"7"],t[r][8]=t[e+"8"],t[r][9]=t[e+"9"],t[r][10]=t[e+"10"],t[r][11]=t[e+"11"],t[r][12]=t[e+"12"],t[r][13]=t[e+"13"],t[r][14]=t[e+"0"],t[r][15]=t[e+"0"]}function nt(t){return t==Hn||t==Vn||t==Wn||t==Gn}function it(){this.eb=[],this.size=this.A=this.fb=0}function at(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0}function ot(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new it,this.f.kb=new at,this.sd=null}function st(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0]}function ut(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0}function ct(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function lt(t,e){var r=t.T,i=e.ba.f.RGBA,a=i.eb,o=i.fb+t.ka*i.A,s=vi[e.ba.S],u=t.y,c=t.O,l=t.f,h=t.N,f=t.ea,d=t.W,p=e.cc,g=e.dc,m=e.Mc,v=e.Nc,b=t.ka,y=t.ka+t.T,w=t.U,N=w+1>>1;for(0==b?s(u,c,null,null,l,h,f,d,l,h,f,d,a,o,null,null,w):(s(e.ec,e.fc,u,c,p,g,m,v,l,h,f,d,a,o-i.A,a,o,w),++r);b+2<y;b+=2)p=l,g=h,m=f,v=d,h+=t.Rc,d+=t.Rc,o+=2*i.A,s(u,(c+=2*t.fa)-t.fa,u,c,p,g,m,v,l,h,f,d,a,o-i.A,a,o,w);return c+=t.fa,t.j+y<t.o?(n(e.ec,e.fc,u,c,w),n(e.cc,e.dc,l,h,N),n(e.Mc,e.Nc,f,d,N),r--):1&y||s(u,c,null,null,l,h,f,d,l,h,f,d,a,o+i.A,null,null,w),r}function ht(t,r,n){var i=t.F,a=[t.J];if(null!=i){var o=t.U,s=r.ba.S,u=s==Dn||s==Wn;r=r.ba.f.RGBA;var c=[0],l=t.ka;c[0]=t.T,t.Kb&&(0==l?--c[0]:(--l,a[0]-=t.width),t.j+t.ka+t.T==t.o&&(c[0]=t.o-t.j-l));var h=r.eb;l=r.fb+l*r.A;t=Sn(i,a[0],t.width,o,c,h,l+(u?0:3),r.A),e(n==c),t&&nt(s)&&An(h,l,u,o,c,r.A)}return 0}function ft(t){var e=t.ma,r=e.ba.S,n=11>r,i=r==qn||r==Tn||r==Dn||r==Un||12==r||nt(r);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Mr(e.Oa,t,i?11:12))return 0;if(i&&nt(r)&&br(),t.da)alert("todo:use_scaling");else{if(n){if(e.Ib=ct,t.Kb){if(r=t.U+1>>1,e.memory=a(t.U+2*r),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+r,e.Ib=lt,br()}}else alert("todo:EmitYUV");i&&(e.Jb=ht,n&&mr())}if(n&&!Ci){for(t=0;256>t;++t)ji[t]=89858*(t-128)+_i>>Si,Mi[t]=-22014*(t-128)+_i,Bi[t]=-45773*(t-128),Oi[t]=113618*(t-128)+_i>>Si;for(t=Pi;t<ki;++t)e=76283*(t-16)+_i>>Si,Ei[t-Pi]=Wt(e,255),qi[t-Pi]=Wt(e+8>>4,15);Ci=1}return 1}function dt(t){var r=t.ma,n=t.U,i=t.T;return e(!(1&t.ka)),0>=n||0>=i?0:(n=r.Ib(t,r),null!=r.Jb&&r.Jb(t,r,n),r.Dc+=n,1)}function pt(t){t.ma.memory=null}function gt(t,e,r,n){return 47!=y(t,8)?0:(e[0]=y(t,14)+1,r[0]=y(t,14)+1,n[0]=y(t,1),0!=y(t,3)?0:!t.h)}function mt(t,e){if(4>t)return t+1;var r=t-2>>1;return(2+(1&t)<<r)+y(e,r)+1}function vt(t,e){return 120<e?e-120:1<=(r=((r=$n[e-1])>>4)*t+(8-(15&r)))?r:1;var r}function bt(t,e,r){var n=L(r),i=t[e+=255&n].g-8;return 0<i&&(x(r,r.u+8),n=L(r),e+=t[e].value,e+=n&(1<<i)-1),x(r,r.u+t[e].g),t[e].value}function yt(t,r,n){return n.g+=t.g,n.value+=t.value<<r>>>0,e(8>=n.g),t.g}function wt(t,r,n){var i=t.xc;return e((r=0==i?0:t.vc[t.md*(n>>i)+(r>>i)])<t.Wb),t.Ya[r]}function Nt(t,r,i,a){var o=t.ab,s=t.c*r,u=t.C;r=u+r;var c=i,l=a;for(a=t.Ta,i=t.Ua;0<o--;){var h=t.gc[o],f=u,d=r,p=c,g=l,m=(l=a,c=i,h.Ea);switch(e(f<d),e(d<=h.nc),h.hc){case 2:Gr(p,g,(d-f)*m,l,c);break;case 0:var v=f,b=d,y=l,w=c,N=(_=h).Ea;0==v&&(Vr(p,g,null,null,1,y,w),W(p,g+1,0,0,N-1,y,w+1),g+=N,w+=N,++v);for(var L=1<<_.b,A=L-1,x=q(N,_.b),S=_.K,_=_.w+(v>>_.b)*x;v<b;){var P=S,k=_,I=1;for(Wr(p,g,y,w-N,1,y,w);I<N;){var F=(I&~A)+L;F>N&&(F=N),(0,Zr[P[k++]>>8&15])(p,g+ +I,y,w+I-N,F-I,y,w+I),I=F}g+=N,w+=N,++v&A||(_+=x)}d!=h.nc&&n(l,c-m,l,c+(d-f-1)*m,m);break;case 1:for(m=p,b=g,N=(p=h.Ea)-(w=p&~(y=(g=1<<h.b)-1)),v=q(p,h.b),L=h.K,h=h.w+(f>>h.b)*v;f<d;){for(A=L,x=h,S=new D,_=b+w,P=b+p;b<_;)Y(A[x++],S),$r(S,m,b,g,l,c),b+=g,c+=g;b<P&&(Y(A[x++],S),$r(S,m,b,N,l,c),b+=N,c+=N),++f&y||(h+=v)}break;case 3:if(p==l&&g==c&&0<h.b){for(b=l,p=m=c+(d-f)*m-(w=(d-f)*q(h.Ea,h.b)),g=l,y=c,v=[],w=(N=w)-1;0<=w;--w)v[w]=g[y+w];for(w=N-1;0<=w;--w)b[p+w]=v[w];Yr(h,f,d,l,m,l,c)}else Yr(h,f,d,p,g,l,c)}c=a,l=i}l!=i&&n(a,i,c,l,s)}function Lt(t,r){var n=t.V,i=t.Ba+t.c*t.C,a=r-t.C;if(e(r<=t.l.o),e(16>=a),0<a){var o=t.l,s=t.Ta,u=t.Ua,c=o.width;if(Nt(t,a,n,i),a=u=[u],e((n=t.C)<(i=r)),e(o.v<o.va),i>o.o&&(i=o.o),n<o.j){var l=o.j-n;n=o.j;a[0]+=l*c}if(n>=i?n=0:(a[0]+=4*o.v,o.ka=n-o.j,o.U=o.va-o.v,o.T=i-n,n=1),n){if(u=u[0],11>(n=t.ca).S){var h=n.f.RGBA,f=(i=n.S,a=o.U,o=o.T,l=h.eb,h.A),d=o;for(h=h.fb+t.Ma*h.A;0<d--;){var p=s,g=u,m=a,v=l,b=h;switch(i){case En:Qr(p,g,m,v,b);break;case qn:tn(p,g,m,v,b);break;case Hn:tn(p,g,m,v,b),An(v,b,0,m,1,0);break;case Rn:nn(p,g,m,v,b);break;case Tn:et(p,g,m,v,b,1);break;case Vn:et(p,g,m,v,b,1),An(v,b,0,m,1,0);break;case Dn:et(p,g,m,v,b,0);break;case Wn:et(p,g,m,v,b,0),An(v,b,1,m,1,0);break;case Un:en(p,g,m,v,b);break;case Gn:en(p,g,m,v,b),xn(v,b,m,1,0);break;case zn:rn(p,g,m,v,b);break;default:e(0)}u+=c,h+=f}t.Ma+=o}else alert("todo:EmitRescaledRowsYUVA");e(t.Ma<=n.height)}}t.C=r,e(t.C<=t.i)}function At(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var r=t.Ya[e].G,n=t.Ya[e].H;if(0<r[1][n[1]+0].g||0<r[2][n[2]+0].g||0<r[3][n[3]+0].g)return 0}return 1}function xt(t,r,n,i,a,o){if(0!=t.Z){var s=t.qd,u=t.rd;for(e(null!=mi[t.Z]);r<n;++r)mi[t.Z](s,u,i,a,i,a,o),s=i,u=a,a+=o;t.qd=s,t.rd=u}}function St(t,r){var n=t.l.ma,i=0==n.Z||1==n.Z?t.l.j:t.C;i=t.C<i?i:t.C;if(e(r<=t.l.o),r>i){var a=t.l.width,o=n.ca,s=n.tb+a*i,u=t.V,c=t.Ba+t.c*i,l=t.gc;e(1==t.ab),e(3==l[0].hc),Xr(l[0],i,r,u,c,o,s),xt(n,i,r,o,s,a)}t.C=t.Ma=r}function _t(t,r,n,i,a,o,s){var u=t.$/i,c=t.$%i,l=t.m,h=t.s,f=n+t.$,d=f;a=n+i*a;var p=n+i*o,g=280+h.ua,m=t.Pb?u:16777216,v=0<h.ua?h.Wa:null,b=h.wc,y=f<p?wt(h,c,u):null;e(t.C<o),e(p<=a);var w=!1;t:for(;;){for(;w||f<p;){var N=0;if(u>=m){var _=f-n;e((m=t).Pb),m.wd=m.m,m.xd=_,0<m.s.ua&&B(m.s.Wa,m.s.vb),m=u+ti}if(c&b||(y=wt(h,c,u)),e(null!=y),y.Qb&&(r[f]=y.qb,w=!0),!w)if(S(l),y.jc){N=l,_=r;var P=f,k=y.pd[L(N)&Rr-1];e(y.jc),256>k.g?(x(N,N.u+k.g),_[P]=k.value,N=0):(x(N,N.u+k.g-256),e(256<=k.value),N=k.value),0==N&&(w=!0)}else N=bt(y.G[0],y.H[0],l);if(l.h)break;if(w||256>N){if(!w)if(y.nd)r[f]=(y.qb|N<<8)>>>0;else{if(S(l),w=bt(y.G[1],y.H[1],l),S(l),_=bt(y.G[2],y.H[2],l),P=bt(y.G[3],y.H[3],l),l.h)break;r[f]=(P<<24|w<<16|N<<8|_)>>>0}if(w=!1,++f,++c>=i&&(c=0,++u,null!=s&&u<=o&&!(u%16)&&s(t,u),null!=v))for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else if(280>N){if(N=mt(N-256,l),_=bt(y.G[4],y.H[4],l),S(l),_=vt(i,_=mt(_,l)),l.h)break;if(f-n<_||a-f<N)break t;for(P=0;P<N;++P)r[f+P]=r[f+P-_];for(f+=N,c+=N;c>=i;)c-=i,++u,null!=s&&u<=o&&!(u%16)&&s(t,u);if(e(f<=a),c&b&&(y=wt(h,c,u)),null!=v)for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else{if(!(N<g))break t;for(w=N-280,e(null!=v);d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;N=f,e(!(w>>>(_=v).Xa)),r[N]=_.X[w],w=!0}w||e(l.h==A(l))}if(t.Pb&&l.h&&f<a)e(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&B(t.s.vb,t.s.Wa);else{if(l.h)break t;null!=s&&s(t,u>o?o:u),t.a=0,t.$=f-n}return 1}return t.a=3,0}function Pt(t){e(null!=t),t.vc=null,t.yc=null,t.Ya=null;var r=t.Wa;null!=r&&(r.X=null),t.vb=null,e(null!=t)}function kt(){var e=new or;return null==e?null:(e.a=0,e.xb=gi,rt("Predictor","VP8LPredictors"),rt("Predictor","VP8LPredictors_C"),rt("PredictorAdd","VP8LPredictorsAdd"),rt("PredictorAdd","VP8LPredictorsAdd_C"),Gr=G,$r=J,Qr=K,tn=Z,en=$,rn=Q,nn=tt,t.VP8LMapColor32b=Jr,t.VP8LMapColor8b=Kr,e)}function It(t,r,n,s,u){var c=1,f=[t],p=[r],g=s.m,m=s.s,v=null,b=0;t:for(;;){if(n)for(;c&&y(g,1);){var w=f,N=p,A=s,_=1,P=A.m,k=A.gc[A.ab],I=y(P,2);if(A.Oc&1<<I)c=0;else{switch(A.Oc|=1<<I,k.hc=I,k.Ea=w[0],k.nc=N[0],k.K=[null],++A.ab,e(4>=A.ab),I){case 0:case 1:k.b=y(P,3)+2,_=It(q(k.Ea,k.b),q(k.nc,k.b),0,A,k.K),k.K=k.K[0];break;case 3:var F,C=y(P,8)+1,j=16<C?0:4<C?1:2<C?2:3;if(w[0]=q(k.Ea,j),k.b=j,F=_=It(C,1,0,A,k.K)){var B,M=C,E=k,T=1<<(8>>E.b),D=a(T);if(null==D)F=0;else{var U=E.K[0],z=E.w;for(D[0]=E.K[0][0],B=1;B<1*M;++B)D[B]=R(U[z+B],D[B-1]);for(;B<4*T;++B)D[B]=0;E.K[0]=null,E.K[0]=D,F=1}}_=F;break;case 2:break;default:e(0)}c=_}}if(f=f[0],p=p[0],c&&y(g,1)&&!(c=1<=(b=y(g,4))&&11>=b)){s.a=3;break t}var H;if(H=c)e:{var V,W,G,Y=s,J=f,X=p,K=b,Z=n,$=Y.m,Q=Y.s,tt=[null],et=1,rt=0,nt=Qn[K];r:for(;;){if(Z&&y($,1)){var it=y($,3)+2,at=q(J,it),ot=q(X,it),st=at*ot;if(!It(at,ot,0,Y,tt))break r;for(tt=tt[0],Q.xc=it,V=0;V<st;++V){var ut=tt[V]>>8&65535;tt[V]=ut,ut>=et&&(et=ut+1)}}if($.h)break r;for(W=0;5>W;++W){var ct=Xn[W];!W&&0<K&&(ct+=1<<K),rt<ct&&(rt=ct)}var lt=o(et*nt,h),ht=et,ft=o(ht,d);if(null==ft)var dt=null;else e(65536>=ht),dt=ft;var pt=a(rt);if(null==dt||null==pt||null==lt){Y.a=1;break r}var gt=lt;for(V=G=0;V<et;++V){var mt=dt[V],vt=mt.G,bt=mt.H,wt=0,Nt=1,Lt=0;for(W=0;5>W;++W){ct=Xn[W],vt[W]=gt,bt[W]=G,!W&&0<K&&(ct+=1<<K);n:{var At,xt=ct,St=Y,kt=pt,Ft=gt,Ct=G,jt=0,Ot=St.m,Bt=y(Ot,1);if(i(kt,0,0,xt),Bt){var Mt=y(Ot,1)+1,Et=y(Ot,1),qt=y(Ot,0==Et?1:8);kt[qt]=1,2==Mt&&(kt[qt=y(Ot,8)]=1);var Rt=1}else{var Tt=a(19),Dt=y(Ot,4)+4;if(19<Dt){St.a=3;var Ut=0;break n}for(At=0;At<Dt;++At)Tt[Zn[At]]=y(Ot,3);var zt=void 0,Ht=void 0,Vt=St,Wt=Tt,Gt=xt,Yt=kt,Jt=0,Xt=Vt.m,Kt=8,Zt=o(128,h);i:for(;l(Zt,0,7,Wt,19);){if(y(Xt,1)){var $t=2+2*y(Xt,3);if((zt=2+y(Xt,$t))>Gt)break i}else zt=Gt;for(Ht=0;Ht<Gt&&zt--;){S(Xt);var Qt=Zt[0+(127&L(Xt))];x(Xt,Xt.u+Qt.g);var te=Qt.value;if(16>te)Yt[Ht++]=te,0!=te&&(Kt=te);else{var ee=16==te,re=te-16,ne=Jn[re],ie=y(Xt,Yn[re])+ne;if(Ht+ie>Gt)break i;for(var ae=ee?Kt:0;0<ie--;)Yt[Ht++]=ae}}Jt=1;break i}Jt||(Vt.a=3),Rt=Jt}(Rt=Rt&&!Ot.h)&&(jt=l(Ft,Ct,8,kt,xt)),Rt&&0!=jt?Ut=jt:(St.a=3,Ut=0)}if(0==Ut)break r;if(Nt&&1==Kn[W]&&(Nt=0==gt[G].g),wt+=gt[G].g,G+=Ut,3>=W){var oe,se=pt[0];for(oe=1;oe<ct;++oe)pt[oe]>se&&(se=pt[oe]);Lt+=se}}if(mt.nd=Nt,mt.Qb=0,Nt&&(mt.qb=(vt[3][bt[3]+0].value<<24|vt[1][bt[1]+0].value<<16|vt[2][bt[2]+0].value)>>>0,0==wt&&256>vt[0][bt[0]+0].value&&(mt.Qb=1,mt.qb+=vt[0][bt[0]+0].value<<8)),mt.jc=!mt.Qb&&6>Lt,mt.jc){var ue,ce=mt;for(ue=0;ue<Rr;++ue){var le=ue,he=ce.pd[le],fe=ce.G[0][ce.H[0]+le];256<=fe.value?(he.g=fe.g+256,he.value=fe.value):(he.g=0,he.value=0,le>>=yt(fe,8,he),le>>=yt(ce.G[1][ce.H[1]+le],16,he),le>>=yt(ce.G[2][ce.H[2]+le],0,he),yt(ce.G[3][ce.H[3]+le],24,he))}}}Q.vc=tt,Q.Wb=et,Q.Ya=dt,Q.yc=lt,H=1;break e}H=0}if(!(c=H)){s.a=3;break t}if(0<b){if(m.ua=1<<b,!O(m.Wa,b)){s.a=1,c=0;break t}}else m.ua=0;var de=s,pe=f,ge=p,me=de.s,ve=me.xc;if(de.c=pe,de.i=ge,me.md=q(pe,ve),me.wc=0==ve?-1:(1<<ve)-1,n){s.xb=pi;break t}if(null==(v=a(f*p))){s.a=1,c=0;break t}c=(c=_t(s,v,0,f,p,p,null))&&!g.h;break t}return c?(null!=u?u[0]=v:(e(null==v),e(n)),s.$=0,n||Pt(m)):Pt(m),c}function Ft(t,r){var n=t.c*t.i,i=n+r+16*r;return e(t.c<=r),t.V=a(i),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+r,1)}function Ct(t,r){var n=t.C,i=r-n,a=t.V,o=t.Ba+t.c*n;for(e(r<=t.l.o);0<i;){var s=16<i?16:i,u=t.l.ma,c=t.l.width,l=c*s,h=u.ca,f=u.tb+c*n,d=t.Ta,p=t.Ua;Nt(t,s,a,o),_n(d,p,h,f,l),xt(u,n,n+s,h,f,c),i-=s,a+=s*t.c,n+=s}e(n==r),t.C=t.Ma=r}function jt(){this.ub=this.yd=this.td=this.Rb=0}function Ot(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0}function Bt(){this.Fb=this.Bb=this.Cb=0,this.Zb=a(4),this.Lb=a(4)}function Mt(){this.Yb=function(){var t=[];return function t(e,r,n){for(var i=n[r],a=0;a<i&&(e.push(n.length>r+1?[]:0),!(n.length<r+1));a++)t(e[a],r+1,n)}(t,0,[3,11]),t}()}function Et(){this.jb=a(3),this.Wc=s([4,8],Mt),this.Xc=s([4,17],Mt)}function qt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new a(4),this.od=new a(4)}function Rt(){this.ld=this.La=this.dd=this.tc=0}function Tt(){this.Na=this.la=0}function Dt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0}function Ut(){this.ad=a(384),this.Za=0,this.Ob=a(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0}function zt(){this.uc=this.M=this.Nb=0,this.wa=Array(new Rt),this.Y=0,this.ya=Array(new Ut),this.aa=0,this.l=new Gt}function Ht(){this.y=a(16),this.f=a(8),this.ea=a(8)}function Vt(){this.cb=this.a=0,this.sc="",this.m=new w,this.Od=new jt,this.Kc=new Ot,this.ed=new qt,this.Qa=new Bt,this.Ic=this.$c=this.Aa=0,this.D=new zt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=o(8,w),this.ia=0,this.pb=o(4,Dt),this.Pa=new Et,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Ht),this.Hd=0,this.rb=Array(new Tt),this.sb=0,this.wa=Array(new Rt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new Ut),this.L=this.aa=0,this.gd=s([4,2],Rt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0}function Wt(t,e){return 0>t?0:t>e?e:t}function Gt(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0}function Yt(){var t=new Vt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,ni||(ni=Zt)),t}function Jt(t,e,r){return 0==t.a&&(t.a=e,t.sc=r,t.cb=0),0}function Xt(t,e,r){return 3<=r&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Kt(t,r){if(null==t)return 0;if(t.a=0,t.sc="OK",null==r)return Jt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=r.data,a=r.w,o=r.ha;if(4>o)return Jt(t,7,"Truncated header.");var s=n[a+0]|n[a+1]<<8|n[a+2]<<16,u=t.Od;if(u.Rb=!(1&s),u.td=s>>1&7,u.yd=s>>4&1,u.ub=s>>5,3<u.td)return Jt(t,3,"Incorrect keyframe parameters.");if(!u.yd)return Jt(t,4,"Frame not displayable.");a+=3,o-=3;var c=t.Kc;if(u.Rb){if(7>o)return Jt(t,7,"cannot parse picture header");if(!Xt(n,a,o))return Jt(t,3,"Bad code word");c.c=16383&(n[a+4]<<8|n[a+3]),c.Td=n[a+4]>>6,c.i=16383&(n[a+6]<<8|n[a+5]),c.Ud=n[a+6]>>6,a+=7,o-=7,t.za=c.c+15>>4,t.Ub=c.i+15>>4,r.width=c.c,r.height=c.i,r.Da=0,r.j=0,r.v=0,r.va=r.width,r.o=r.height,r.da=0,r.ib=r.width,r.hb=r.height,r.U=r.width,r.T=r.height,i((s=t.Pa).jb,0,255,s.jb.length),e(null!=(s=t.Qa)),s.Cb=0,s.Bb=0,s.Fb=1,i(s.Zb,0,0,s.Zb.length),i(s.Lb,0,0,s.Lb)}if(u.ub>o)return Jt(t,7,"bad partition length");p(s=t.m,n,a,u.ub),a+=u.ub,o-=u.ub,u.Rb&&(c.Ld=P(s),c.Kd=P(s)),c=t.Qa;var l,h=t.Pa;if(e(null!=s),e(null!=c),c.Cb=P(s),c.Cb){if(c.Bb=P(s),P(s)){for(c.Fb=P(s),l=0;4>l;++l)c.Zb[l]=P(s)?m(s,7):0;for(l=0;4>l;++l)c.Lb[l]=P(s)?m(s,6):0}if(c.Bb)for(l=0;3>l;++l)h.jb[l]=P(s)?g(s,8):255}else c.Bb=0;if(s.Ka)return Jt(t,3,"cannot parse segment header");if((c=t.ed).zd=P(s),c.Tb=g(s,6),c.wb=g(s,3),c.Pc=P(s),c.Pc&&P(s)){for(h=0;4>h;++h)P(s)&&(c.vd[h]=m(s,6));for(h=0;4>h;++h)P(s)&&(c.od[h]=m(s,6))}if(t.L=0==c.Tb?0:c.zd?1:2,s.Ka)return Jt(t,3,"cannot parse filter header");var f=o;if(o=l=a,a=l+f,c=f,t.Xb=(1<<g(t.m,2))-1,f<3*(h=t.Xb))n=7;else{for(l+=3*h,c-=3*h,f=0;f<h;++f){var d=n[o+0]|n[o+1]<<8|n[o+2]<<16;d>c&&(d=c),p(t.Jc[+f],n,l,d),l+=d,c-=d,o+=3}p(t.Jc[+h],n,l,c),n=l<a?0:5}if(0!=n)return Jt(t,n,"cannot parse partitions");for(n=g(l=t.m,7),o=P(l)?m(l,4):0,a=P(l)?m(l,4):0,c=P(l)?m(l,4):0,h=P(l)?m(l,4):0,l=P(l)?m(l,4):0,f=t.Qa,d=0;4>d;++d){if(f.Cb){var v=f.Zb[d];f.Fb||(v+=n)}else{if(0<d){t.pb[d]=t.pb[0];continue}v=n}var b=t.pb[d];b.Sc[0]=ei[Wt(v+o,127)],b.Sc[1]=ri[Wt(v+0,127)],b.Eb[0]=2*ei[Wt(v+a,127)],b.Eb[1]=101581*ri[Wt(v+c,127)]>>16,8>b.Eb[1]&&(b.Eb[1]=8),b.Qc[0]=ei[Wt(v+h,117)],b.Qc[1]=ri[Wt(v+l,127)],b.lc=v+l}if(!u.Rb)return Jt(t,4,"Not a key frame.");for(P(s),u=t.Pa,n=0;4>n;++n){for(o=0;8>o;++o)for(a=0;3>a;++a)for(c=0;11>c;++c)h=k(s,ci[n][o][a][c])?g(s,8):si[n][o][a][c],u.Wc[n][o].Yb[a][c]=h;for(o=0;17>o;++o)u.Xc[n][o]=u.Wc[n][li[o]]}return t.kc=P(s),t.kc&&(t.Bd=g(s,8)),t.cb=1}function Zt(t,e,r,n,i,a,o){var s=e[i].Yb[r];for(r=0;16>i;++i){if(!k(t,s[r+0]))return i;for(;!k(t,s[r+1]);)if(s=e[++i].Yb[0],r=0,16==i)return 16;var u=e[i+1].Yb;if(k(t,s[r+2])){var c=t,l=0;if(k(c,(f=s)[(h=r)+3]))if(k(c,f[h+6])){for(s=0,h=2*(l=k(c,f[h+8]))+(f=k(c,f[h+9+l])),l=0,f=ii[h];f[s];++s)l+=l+k(c,f[s]);l+=3+(8<<h)}else k(c,f[h+7])?(l=7+2*k(c,165),l+=k(c,145)):l=5+k(c,159);else l=k(c,f[h+4])?3+k(c,f[h+5]):2;s=u[2]}else l=1,s=u[1];u=o+ai[i],0>(c=t).b&&_(c);var h,f=c.b,d=(h=c.Ca>>1)-(c.I>>f)>>31;--c.b,c.Ca+=d,c.Ca|=1,c.I-=(h+1&d)<<f,a[u]=((l^d)-d)*n[(0<i)+0]}return 16}function $t(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,i(t.zc,0,0,t.zc.length),t.ja=0}function Qt(t,r){if(null==t)return 0;if(null==r)return Jt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Kt(t,r))return 0;if(e(t.cb),null==r.ac||r.ac(r)){r.ob&&(t.L=0);var s=Ti[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=r.v-s>>4,t.zb=r.j-s>>4,0>t.yb&&(t.yb=0),0>t.zb&&(t.zb=0)),t.Va=r.o+15+s>>4,t.Hb=r.va+15+s>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var u=t.ed;for(s=0;4>s;++s){var c;if(t.Qa.Cb){var l=t.Qa.Lb[s];t.Qa.Fb||(l+=u.Tb)}else l=u.Tb;for(c=0;1>=c;++c){var h=t.gd[s][c],f=l;if(u.Pc&&(f+=u.vd[0],c&&(f+=u.od[0])),0<(f=0>f?0:63<f?63:f)){var d=f;0<u.wb&&((d=4<u.wb?d>>2:d>>1)>9-u.wb&&(d=9-u.wb)),1>d&&(d=1),h.dd=d,h.tc=2*f+d,h.ld=40<=f?2:15<=f?1:0}else h.tc=0;h.La=c}}}s=0}else Jt(t,6,"Frame setup failed"),s=t.a;if(s=0==s){if(s){t.$c=0,0<t.Aa||(t.Ic=Ui);t:{s=t.Ic;u=4*(d=t.za);var p=32*d,g=d+1,m=0<t.L?d*(0<t.Aa?2:1):0,v=(2==t.Aa?2:1)*d;if((h=u+832+(c=3*(16*s+Ti[t.L])/2*p)+(l=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=h)s=0;else{if(h>t.Vb){if(t.Vb=0,t.Ec=a(h),t.Fc=0,null==t.Ec){s=Jt(t,1,"no memory during frame initialization.");break t}t.Vb=h}h=t.Ec,f=t.Fc,t.Ac=h,t.Bc=f,f+=u,t.Gd=o(p,Ht),t.Hd=0,t.rb=o(g+1,Tt),t.sb=1,t.wa=m?o(m,Rt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=d),e(!0),t.oc=h,t.pc=f,f+=832,t.ya=o(v,Ut),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=d),t.R=16*d,t.B=8*d,d=(p=Ti[t.L])*t.R,p=p/2*t.B,t.sa=h,t.ta=f+d,t.qa=t.sa,t.ra=t.ta+16*s*t.R+p,t.Ha=t.qa,t.Ia=t.ra+8*s*t.B+p,t.$c=0,f+=c,t.mb=l?h:null,t.nb=l?f:null,e(f+l<=t.Fc+t.Vb),$t(t),i(t.Ac,t.Bc,0,u),s=1}}if(s){if(r.ka=0,r.y=t.sa,r.O=t.ta,r.f=t.qa,r.N=t.ra,r.ea=t.Ha,r.Vd=t.Ia,r.fa=t.R,r.Rc=t.B,r.F=null,r.J=0,!Cn){for(s=-255;255>=s;++s)Pn[255+s]=0>s?-s:s;for(s=-1020;1020>=s;++s)kn[1020+s]=-128>s?-128:127<s?127:s;for(s=-112;112>=s;++s)In[112+s]=-16>s?-16:15<s?15:s;for(s=-255;510>=s;++s)Fn[255+s]=0>s?0:255<s?255:s;Cn=1}an=ce,on=ae,un=oe,cn=se,ln=ue,sn=ie,hn=Je,fn=Xe,dn=$e,pn=Qe,gn=Ke,mn=Ze,vn=tr,bn=er,yn=ze,wn=He,Nn=Ve,Ln=We,fi[0]=xe,fi[1]=he,fi[2]=Le,fi[3]=Ae,fi[4]=Se,fi[5]=Pe,fi[6]=_e,fi[7]=ke,fi[8]=Fe,fi[9]=Ie,hi[0]=ve,hi[1]=de,hi[2]=pe,hi[3]=ge,hi[4]=be,hi[5]=ye,hi[6]=we,di[0]=Be,di[1]=fe,di[2]=Ce,di[3]=je,di[4]=Ee,di[5]=Me,di[6]=qe,s=1}else s=0}s&&(s=function(t,r){for(t.M=0;t.M<t.Va;++t.M){var o,s=t.Jc[t.M&t.Xb],u=t.m,c=t;for(o=0;o<c.za;++o){var l=u,h=c,f=h.Ac,d=h.Bc+4*o,p=h.zc,g=h.ya[h.aa+o];if(h.Qa.Bb?g.$b=k(l,h.Pa.jb[0])?2+k(l,h.Pa.jb[2]):k(l,h.Pa.jb[1]):g.$b=0,h.kc&&(g.Ad=k(l,h.Bd)),g.Za=!k(l,145)+0,g.Za){var m=g.Ob,v=0;for(h=0;4>h;++h){var b,y=p[0+h];for(b=0;4>b;++b){y=ui[f[d+b]][y];for(var w=oi[k(l,y[0])];0<w;)w=oi[2*w+k(l,y[w])];y=-w,f[d+b]=y}n(m,v,f,d,4),v+=4,p[0+h]=y}}else y=k(l,156)?k(l,128)?1:3:k(l,163)?2:0,g.Ob[0]=y,i(f,d,y,4),i(p,0,y,4);g.Dd=k(l,142)?k(l,114)?k(l,183)?1:3:2:0}if(c.m.Ka)return Jt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(c=s,l=(u=t).rb[u.sb-1],f=u.rb[u.sb+u.ja],o=u.ya[u.aa+u.ja],d=u.kc?o.Ad:0)l.la=f.la=0,o.Za||(l.Na=f.Na=0),o.Hc=0,o.Gc=0,o.ia=0;else{var N,L;l=f,f=c,d=u.Pa.Xc,p=u.ya[u.aa+u.ja],g=u.pb[p.$b];if(h=p.ad,m=0,v=u.rb[u.sb-1],y=b=0,i(h,m,0,384),p.Za)var A=0,x=d[3];else{w=a(16);var S=l.Na+v.Na;if(S=ni(f,d[1],S,g.Eb,0,w,0),l.Na=v.Na=(0<S)+0,1<S)an(w,0,h,m);else{var _=w[0]+3>>3;for(w=0;256>w;w+=16)h[m+w]=_}A=1,x=d[0]}var P=15&l.la,I=15&v.la;for(w=0;4>w;++w){var F=1&I;for(_=L=0;4>_;++_)P=P>>1|(F=(S=ni(f,x,S=F+(1&P),g.Sc,A,h,m))>A)<<7,L=L<<2|(3<S?3:1<S?2:0!=h[m+0]),m+=16;P>>=4,I=I>>1|F<<7,b=(b<<8|L)>>>0}for(x=P,A=I>>4,N=0;4>N;N+=2){for(L=0,P=l.la>>4+N,I=v.la>>4+N,w=0;2>w;++w){for(F=1&I,_=0;2>_;++_)S=F+(1&P),P=P>>1|(F=0<(S=ni(f,d[2],S,g.Qc,0,h,m)))<<3,L=L<<2|(3<S?3:1<S?2:0!=h[m+0]),m+=16;P>>=2,I=I>>1|F<<5}y|=L<<4*N,x|=P<<4<<N,A|=(240&I)<<N}l.la=x,v.la=A,p.Hc=b,p.Gc=y,p.ia=43690&y?0:g.ia,d=!(b|y)}if(0<u.L&&(u.wa[u.Y+u.ja]=u.gd[o.$b][o.Za],u.wa[u.Y+u.ja].La|=!d),c.Ka)return Jt(t,7,"Premature end-of-file encountered.")}if($t(t),u=r,c=1,o=(s=t).D,l=0<s.L&&s.M>=s.zb&&s.M<=s.Va,0==s.Aa)t:{if(o.M=s.M,o.uc=l,Or(s,o),c=1,o=(L=s.D).Nb,l=(y=Ti[s.L])*s.R,f=y/2*s.B,w=16*o*s.R,_=8*o*s.B,d=s.sa,p=s.ta-l+w,g=s.qa,h=s.ra-f+_,m=s.Ha,v=s.Ia-f+_,I=0==(P=L.M),b=P>=s.Va-1,2==s.Aa&&Or(s,L),L.uc)for(F=(S=s).D.M,e(S.D.uc),L=S.yb;L<S.Hb;++L){A=L,x=F;var C=(j=(U=S).D).Nb;N=U.R;var j=j.wa[j.Y+A],O=U.sa,B=U.ta+16*C*N+16*A,M=j.dd,E=j.tc;if(0!=E)if(e(3<=E),1==U.L)0<A&&wn(O,B,N,E+4),j.La&&Ln(O,B,N,E),0<x&&yn(O,B,N,E+4),j.La&&Nn(O,B,N,E);else{var q=U.B,R=U.qa,T=U.ra+8*C*q+8*A,D=U.Ha,U=U.Ia+8*C*q+8*A;C=j.ld;0<A&&(fn(O,B,N,E+4,M,C),pn(R,T,D,U,q,E+4,M,C)),j.La&&(mn(O,B,N,E,M,C),bn(R,T,D,U,q,E,M,C)),0<x&&(hn(O,B,N,E+4,M,C),dn(R,T,D,U,q,E+4,M,C)),j.La&&(gn(O,B,N,E,M,C),vn(R,T,D,U,q,E,M,C))}}if(s.ia&&alert("todo:DitherRow"),null!=u.put){if(L=16*P,P=16*(P+1),I?(u.y=s.sa,u.O=s.ta+w,u.f=s.qa,u.N=s.ra+_,u.ea=s.Ha,u.W=s.Ia+_):(L-=y,u.y=d,u.O=p,u.f=g,u.N=h,u.ea=m,u.W=v),b||(P-=y),P>u.o&&(P=u.o),u.F=null,u.J=null,null!=s.Fa&&0<s.Fa.length&&L<P&&(u.J=hr(s,u,L,P-L),u.F=s.mb,null==u.F&&0==u.F.length)){c=Jt(s,3,"Could not decode alpha data.");break t}L<u.j&&(y=u.j-L,L=u.j,e(!(1&y)),u.O+=s.R*y,u.N+=s.B*(y>>1),u.W+=s.B*(y>>1),null!=u.F&&(u.J+=u.width*y)),L<P&&(u.O+=u.v,u.N+=u.v>>1,u.W+=u.v>>1,null!=u.F&&(u.J+=u.v),u.ka=L-u.j,u.U=u.va-u.v,u.T=P-L,c=u.put(u))}o+1!=s.Ic||b||(n(s.sa,s.ta-l,d,p+16*s.R,l),n(s.qa,s.ra-f,g,h+8*s.B,f),n(s.Ha,s.Ia-f,m,v+8*s.B,f))}if(!c)return Jt(t,6,"Output aborted.")}return 1}(t,r)),null!=r.bc&&r.bc(r),s&=1}return s?(t.cb=0,s):0}function te(t,e,r,n,i){i=t[e+r+32*n]+(i>>3),t[e+r+32*n]=-256&i?0>i?0:255:i}function ee(t,e,r,n,i,a){te(t,e,0,r,n+i),te(t,e,1,r,n+a),te(t,e,2,r,n-a),te(t,e,3,r,n-i)}function re(t){return(20091*t>>16)+t}function ne(t,e,r,n){var i,o=0,s=a(16);for(i=0;4>i;++i){var u=t[e+0]+t[e+8],c=t[e+0]-t[e+8],l=(35468*t[e+4]>>16)-re(t[e+12]),h=re(t[e+4])+(35468*t[e+12]>>16);s[o+0]=u+h,s[o+1]=c+l,s[o+2]=c-l,s[o+3]=u-h,o+=4,e++}for(i=o=0;4>i;++i)u=(t=s[o+0]+4)+s[o+8],c=t-s[o+8],l=(35468*s[o+4]>>16)-re(s[o+12]),te(r,n,0,0,u+(h=re(s[o+4])+(35468*s[o+12]>>16))),te(r,n,1,0,c+l),te(r,n,2,0,c-l),te(r,n,3,0,u-h),o++,n+=32}function ie(t,e,r,n){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=re(t[e+4]),s=35468*t[e+1]>>16;ee(r,n,0,i+o,t=re(t[e+1]),s),ee(r,n,1,i+a,t,s),ee(r,n,2,i-a,t,s),ee(r,n,3,i-o,t,s)}function ae(t,e,r,n,i){ne(t,e,r,n),i&&ne(t,e+16,r,n+4)}function oe(t,e,r,n){on(t,e+0,r,n,1),on(t,e+32,r,n+128,1)}function se(t,e,r,n){var i;for(t=t[e+0]+4,i=0;4>i;++i)for(e=0;4>e;++e)te(r,n,e,i,t)}function ue(t,e,r,n){t[e+0]&&cn(t,e+0,r,n),t[e+16]&&cn(t,e+16,r,n+4),t[e+32]&&cn(t,e+32,r,n+128),t[e+48]&&cn(t,e+48,r,n+128+4)}function ce(t,e,r,n){var i,o=a(16);for(i=0;4>i;++i){var s=t[e+0+i]+t[e+12+i],u=t[e+4+i]+t[e+8+i],c=t[e+4+i]-t[e+8+i],l=t[e+0+i]-t[e+12+i];o[0+i]=s+u,o[8+i]=s-u,o[4+i]=l+c,o[12+i]=l-c}for(i=0;4>i;++i)s=(t=o[0+4*i]+3)+o[3+4*i],u=o[1+4*i]+o[2+4*i],c=o[1+4*i]-o[2+4*i],l=t-o[3+4*i],r[n+0]=s+u>>3,r[n+16]=l+c>>3,r[n+32]=s-u>>3,r[n+48]=l-c>>3,n+=64}function le(t,e,r){var n,i=e-32,a=Bn,o=255-t[i-1];for(n=0;n<r;++n){var s,u=a,c=o+t[e-1];for(s=0;s<r;++s)t[e+s]=u[c+t[i+s]];e+=32}}function he(t,e){le(t,e,4)}function fe(t,e){le(t,e,8)}function de(t,e){le(t,e,16)}function pe(t,e){var r;for(r=0;16>r;++r)n(t,e+32*r,t,e-32,16)}function ge(t,e){var r;for(r=16;0<r;--r)i(t,e,t[e-1],16),e+=32}function me(t,e,r){var n;for(n=0;16>n;++n)i(e,r+32*n,t,16)}function ve(t,e){var r,n=16;for(r=0;16>r;++r)n+=t[e-1+32*r]+t[e+r-32];me(n>>5,t,e)}function be(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e-1+32*r];me(n>>4,t,e)}function ye(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e+r-32];me(n>>4,t,e)}function we(t,e){me(128,t,e)}function Ne(t,e,r){return t+2*e+r+2>>2}function Le(t,e){var r,i=e-32;i=new Uint8Array([Ne(t[i-1],t[i+0],t[i+1]),Ne(t[i+0],t[i+1],t[i+2]),Ne(t[i+1],t[i+2],t[i+3]),Ne(t[i+2],t[i+3],t[i+4])]);for(r=0;4>r;++r)n(t,e+32*r,i,0,i.length)}function Ae(t,e){var r=t[e-1],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];I(t,e+0,16843009*Ne(t[e-1-32],r,n)),I(t,e+32,16843009*Ne(r,n,i)),I(t,e+64,16843009*Ne(n,i,a)),I(t,e+96,16843009*Ne(i,a,a))}function xe(t,e){var r,n=4;for(r=0;4>r;++r)n+=t[e+r-32]+t[e-1+32*r];for(n>>=3,r=0;4>r;++r)i(t,e+32*r,n,4)}function Se(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],u=t[e+2-32],c=t[e+3-32];t[e+0+96]=Ne(n,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=Ne(r,n,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=Ne(a,r,n),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=Ne(o,a,r),t[e+3+64]=t[e+2+32]=t[e+1+0]=Ne(s,o,a),t[e+3+32]=t[e+2+0]=Ne(u,s,o),t[e+3+0]=Ne(c,u,s)}function _e(t,e){var r=t[e+1-32],n=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],u=t[e+7-32];t[e+0+0]=Ne(t[e+0-32],r,n),t[e+1+0]=t[e+0+32]=Ne(r,n,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=Ne(n,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=Ne(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=Ne(a,o,s),t[e+3+64]=t[e+2+96]=Ne(o,s,u),t[e+3+96]=Ne(s,u,u)}function Pe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],u=t[e+2-32],c=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+u+1>>1,t[e+3+0]=u+c+1>>1,t[e+0+96]=Ne(i,n,r),t[e+0+64]=Ne(n,r,a),t[e+0+32]=t[e+1+96]=Ne(r,a,o),t[e+1+32]=t[e+2+96]=Ne(a,o,s),t[e+2+32]=t[e+3+96]=Ne(o,s,u),t[e+3+32]=Ne(s,u,c)}function ke(t,e){var r=t[e+0-32],n=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],u=t[e+6-32],c=t[e+7-32];t[e+0+0]=r+n+1>>1,t[e+1+0]=t[e+0+64]=n+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=Ne(r,n,i),t[e+1+32]=t[e+0+96]=Ne(n,i,a),t[e+2+32]=t[e+1+96]=Ne(i,a,o),t[e+3+32]=t[e+2+96]=Ne(a,o,s),t[e+3+64]=Ne(o,s,u),t[e+3+96]=Ne(s,u,c)}function Ie(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=r+n+1>>1,t[e+2+0]=t[e+0+32]=n+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=Ne(r,n,i),t[e+3+0]=t[e+1+32]=Ne(n,i,a),t[e+3+32]=t[e+1+64]=Ne(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a}function Fe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],u=t[e+1-32],c=t[e+2-32];t[e+0+0]=t[e+2+32]=r+o+1>>1,t[e+0+32]=t[e+2+64]=n+r+1>>1,t[e+0+64]=t[e+2+96]=i+n+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=Ne(s,u,c),t[e+2+0]=Ne(o,s,u),t[e+1+0]=t[e+3+32]=Ne(r,o,s),t[e+1+32]=t[e+3+64]=Ne(n,r,o),t[e+1+64]=t[e+3+96]=Ne(i,n,r),t[e+1+96]=Ne(a,i,n)}function Ce(t,e){var r;for(r=0;8>r;++r)n(t,e+32*r,t,e-32,8)}function je(t,e){var r;for(r=0;8>r;++r)i(t,e,t[e-1],8),e+=32}function Oe(t,e,r){var n;for(n=0;8>n;++n)i(e,r+32*n,t,8)}function Be(t,e){var r,n=8;for(r=0;8>r;++r)n+=t[e+r-32]+t[e-1+32*r];Oe(n>>4,t,e)}function Me(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e+r-32];Oe(n>>3,t,e)}function Ee(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e-1+32*r];Oe(n>>3,t,e)}function qe(t,e){Oe(128,t,e)}function Re(t,e,r){var n=t[e-r],i=t[e+0],a=3*(i-n)+jn[1020+t[e-2*r]-t[e+r]],o=On[112+(a+4>>3)];t[e-r]=Bn[255+n+On[112+(a+3>>3)]],t[e+0]=Bn[255+i-o]}function Te(t,e,r,n){var i=t[e+0],a=t[e+r];return Mn[255+t[e-2*r]-t[e-r]]>n||Mn[255+a-i]>n}function De(t,e,r,n){return 4*Mn[255+t[e-r]-t[e+0]]+Mn[255+t[e-2*r]-t[e+r]]<=n}function Ue(t,e,r,n,i){var a=t[e-3*r],o=t[e-2*r],s=t[e-r],u=t[e+0],c=t[e+r],l=t[e+2*r],h=t[e+3*r];return 4*Mn[255+s-u]+Mn[255+o-c]>n?0:Mn[255+t[e-4*r]-a]<=i&&Mn[255+a-o]<=i&&Mn[255+o-s]<=i&&Mn[255+h-l]<=i&&Mn[255+l-c]<=i&&Mn[255+c-u]<=i}function ze(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)De(t,e+n,r,i)&&Re(t,e+n,r)}function He(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)De(t,e+n*r,1,i)&&Re(t,e+n*r,1)}function Ve(t,e,r,n){var i;for(i=3;0<i;--i)ze(t,e+=4*r,r,n)}function We(t,e,r,n){var i;for(i=3;0<i;--i)He(t,e+=4,r,n)}function Ge(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Te(t,e,r,s))Re(t,e,r);else{var u=t,c=e,l=r,h=u[c-2*l],f=u[c-l],d=u[c+0],p=u[c+l],g=u[c+2*l],m=27*(b=jn[1020+3*(d-f)+jn[1020+h-p]])+63>>7,v=18*b+63>>7,b=9*b+63>>7;u[c-3*l]=Bn[255+u[c-3*l]+b],u[c-2*l]=Bn[255+h+v],u[c-l]=Bn[255+f+m],u[c+0]=Bn[255+d-m],u[c+l]=Bn[255+p-v],u[c+2*l]=Bn[255+g-b]}e+=n}}function Ye(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Te(t,e,r,s))Re(t,e,r);else{var u=t,c=e,l=r,h=u[c-l],f=u[c+0],d=u[c+l],p=On[112+((g=3*(f-h))+4>>3)],g=On[112+(g+3>>3)],m=p+1>>1;u[c-2*l]=Bn[255+u[c-2*l]+m],u[c-l]=Bn[255+h+g],u[c+0]=Bn[255+f-p],u[c+l]=Bn[255+d-m]}e+=n}}function Je(t,e,r,n,i,a){Ge(t,e,r,1,16,n,i,a)}function Xe(t,e,r,n,i,a){Ge(t,e,1,r,16,n,i,a)}function Ke(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4*r,r,1,16,n,i,a)}function Ze(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4,1,r,16,n,i,a)}function $e(t,e,r,n,i,a,o,s){Ge(t,e,i,1,8,a,o,s),Ge(r,n,i,1,8,a,o,s)}function Qe(t,e,r,n,i,a,o,s){Ge(t,e,1,i,8,a,o,s),Ge(r,n,1,i,8,a,o,s)}function tr(t,e,r,n,i,a,o,s){Ye(t,e+4*i,i,1,8,a,o,s),Ye(r,n+4*i,i,1,8,a,o,s)}function er(t,e,r,n,i,a,o,s){Ye(t,e+4,1,i,8,a,o,s),Ye(r,n+4,1,i,8,a,o,s)}function rr(){this.ba=new ot,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new ut,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc"}function nr(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0}function ir(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0}function ar(){this.ua=0,this.Wa=new M,this.vb=new M,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new d,this.yc=new h}function or(){this.xb=this.a=0,this.l=new Gt,this.ca=new ot,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new N,this.Pb=0,this.wd=new N,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new ar,this.ab=0,this.gc=o(4,ir),this.Oc=0}function sr(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new Gt,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0}function ur(t,e,r,n,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+r[n+e]&255,t=i[a+e]}function cr(t,e,r,n,i,a,o){var s;if(null==t)ur(null,null,r,n,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+r[n+s]&255}function lr(t,e,r,n,i,a,o){if(null==t)ur(null,null,r,n,i,a,o);else{var s,u=t[e+0],c=u,l=u;for(s=0;s<o;++s)c=l+(u=t[e+s])-c,l=r[n+s]+(-256&c?0>c?0:255:c)&255,c=u,i[a+s]=l}}function hr(t,r,i,o){var s=r.width,u=r.o;if(e(null!=t&&null!=r),0>i||0>=o||i+o>u)return null;if(!t.Cc){if(null==t.ga){var c;if(t.ga=new sr,(c=null==t.ga)||(c=r.width*r.o,e(0==t.Gb.length),t.Gb=a(c),t.Uc=0,null==t.Gb?c=0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,c=1),c=!c),!c){c=t.ga;var l=t.Fa,h=t.P,f=t.qc,d=t.mb,p=t.nb,g=h+1,m=f-1,b=c.l;if(e(null!=l&&null!=d&&null!=r),mi[0]=null,mi[1]=ur,mi[2]=cr,mi[3]=lr,c.ca=d,c.tb=p,c.c=r.width,c.i=r.height,e(0<c.c&&0<c.i),1>=f)r=0;else if(c.$a=l[h+0]>>0&3,c.Z=l[h+0]>>2&3,c.Lc=l[h+0]>>4&3,h=l[h+0]>>6&3,0>c.$a||1<c.$a||4<=c.Z||1<c.Lc||h)r=0;else if(b.put=dt,b.ac=ft,b.bc=pt,b.ma=c,b.width=r.width,b.height=r.height,b.Da=r.Da,b.v=r.v,b.va=r.va,b.j=r.j,b.o=r.o,c.$a)t:{e(1==c.$a),r=kt();e:for(;;){if(null==r){r=0;break t}if(e(null!=c),c.mc=r,r.c=c.c,r.i=c.i,r.l=c.l,r.l.ma=c,r.l.width=c.c,r.l.height=c.i,r.a=0,v(r.m,l,g,m),!It(c.c,c.i,1,r,null))break e;if(1==r.ab&&3==r.gc[0].hc&&At(r.s)?(c.ic=1,l=r.c*r.i,r.Ta=null,r.Ua=0,r.V=a(l),r.Ba=0,null==r.V?(r.a=1,r=0):r=1):(c.ic=0,r=Ft(r,c.c)),!r)break e;r=1;break t}c.mc=null,r=0}else r=m>=c.c*c.i;c=!r}if(c)return null;1!=t.ga.Lc?t.Ga=0:o=u-i}e(null!=t.ga),e(i+o<=u);t:{if(r=(l=t.ga).c,u=l.l.o,0==l.$a){if(g=t.rc,m=t.Vc,b=t.Fa,h=t.P+1+i*r,f=t.mb,d=t.nb+i*r,e(h<=t.P+t.qc),0!=l.Z)for(e(null!=mi[l.Z]),c=0;c<o;++c)mi[l.Z](g,m,b,h,f,d,r),g=f,m=d,d+=r,h+=r;else for(c=0;c<o;++c)n(f,d,b,h,r),g=f,m=d,d+=r,h+=r;t.rc=g,t.Vc=m}else{if(e(null!=l.mc),r=i+o,e(null!=(c=l.mc)),e(r<=c.i),c.C>=r)r=1;else if(l.ic||mr(),l.ic){l=c.V,g=c.Ba,m=c.c;var y=c.i,w=(b=1,h=c.$/m,f=c.$%m,d=c.m,p=c.s,c.$),N=m*y,L=m*r,x=p.wc,_=w<L?wt(p,f,h):null;e(w<=N),e(r<=y),e(At(p));e:for(;;){for(;!d.h&&w<L;){if(f&x||(_=wt(p,f,h)),e(null!=_),S(d),256>(y=bt(_.G[0],_.H[0],d)))l[g+w]=y,++w,++f>=m&&(f=0,++h<=r&&!(h%16)&&St(c,h));else{if(!(280>y)){b=0;break e}y=mt(y-256,d);var P,k=bt(_.G[4],_.H[4],d);if(S(d),!(w>=(k=vt(m,k=mt(k,d)))&&N-w>=y)){b=0;break e}for(P=0;P<y;++P)l[g+w+P]=l[g+w+P-k];for(w+=y,f+=y;f>=m;)f-=m,++h<=r&&!(h%16)&&St(c,h);w<L&&f&x&&(_=wt(p,f,h))}e(d.h==A(d))}St(c,h>r?r:h);break e}!b||d.h&&w<N?(b=0,c.a=d.h?5:3):c.$=w,r=b}else r=_t(c,c.V,c.Ba,c.c,c.i,r,Ct);if(!r){o=0;break t}}i+o>=u&&(t.Cc=1),o=1}if(!o)return null;if(t.Cc&&(null!=(o=t.ga)&&(o.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+i*s}function fr(t,e,r,n,i,a){for(;0<i--;){var o,s=t,u=e+(r?1:0),c=t,l=e+(r?0:3);for(o=0;o<n;++o){var h=c[l+4*o];255!=h&&(h*=32897,s[u+4*o+0]=s[u+4*o+0]*h>>23,s[u+4*o+1]=s[u+4*o+1]*h>>23,s[u+4*o+2]=s[u+4*o+2]*h>>23)}e+=a}}function dr(t,e,r,n,i){for(;0<n--;){var a;for(a=0;a<r;++a){var o=t[e+2*a+0],s=15&(c=t[e+2*a+1]),u=4369*s,c=(240&c|c>>4)*u>>16;t[e+2*a+0]=(240&o|o>>4)*u>>16&240|(15&o|o<<4)*u>>16>>4&15,t[e+2*a+1]=240&c|s}e+=i}}function pr(t,e,r,n,i,a,o,s){var u,c,l=255;for(c=0;c<i;++c){for(u=0;u<n;++u){var h=t[e+u];a[o+4*u]=h,l&=h}e+=r,o+=s}return 255!=l}function gr(t,e,r,n,i){var a;for(a=0;a<i;++a)r[n+a]=t[e+a]>>8}function mr(){An=fr,xn=dr,Sn=pr,_n=gr}function vr(r,n,i){t[r]=function(t,r,a,o,s,u,c,l,h,f,d,p,g,m,v,b,y){var w,N=y-1>>1,L=s[u+0]|c[l+0]<<16,A=h[f+0]|d[p+0]<<16;e(null!=t);var x=3*L+A+131074>>2;for(n(t[r+0],255&x,x>>16,g,m),null!=a&&(x=3*A+L+131074>>2,n(a[o+0],255&x,x>>16,v,b)),w=1;w<=N;++w){var S=s[u+w]|c[l+w]<<16,_=h[f+w]|d[p+w]<<16,P=L+S+A+_+524296,k=P+2*(S+A)>>3;x=k+L>>1,L=(P=P+2*(L+_)>>3)+S>>1,n(t[r+2*w-1],255&x,x>>16,g,m+(2*w-1)*i),n(t[r+2*w-0],255&L,L>>16,g,m+(2*w-0)*i),null!=a&&(x=P+A>>1,L=k+_>>1,n(a[o+2*w-1],255&x,x>>16,v,b+(2*w-1)*i),n(a[o+2*w+0],255&L,L>>16,v,b+(2*w+0)*i)),L=S,A=_}1&y||(x=3*L+A+131074>>2,n(t[r+y-1],255&x,x>>16,g,m+(y-1)*i),null!=a&&(x=3*A+L+131074>>2,n(a[o+y-1],255&x,x>>16,v,b+(y-1)*i)))}}function br(){vi[En]=bi,vi[qn]=wi,vi[Rn]=yi,vi[Tn]=Ni,vi[Dn]=Li,vi[Un]=Ai,vi[zn]=xi,vi[Hn]=wi,vi[Vn]=Ni,vi[Wn]=Li,vi[Gn]=Ai}function yr(t){return t&~Fi?0>t?0:255:t>>Ii}function wr(t,e){return yr((19077*t>>8)+(26149*e>>8)-14234)}function Nr(t,e,r){return yr((19077*t>>8)-(6419*e>>8)-(13320*r>>8)+8708)}function Lr(t,e){return yr((19077*t>>8)+(33050*e>>8)-17685)}function Ar(t,e,r,n,i){n[i+0]=wr(t,r),n[i+1]=Nr(t,e,r),n[i+2]=Lr(t,e)}function xr(t,e,r,n,i){n[i+0]=Lr(t,e),n[i+1]=Nr(t,e,r),n[i+2]=wr(t,r)}function Sr(t,e,r,n,i){var a=Nr(t,e,r);e=a<<3&224|Lr(t,e)>>3,n[i+0]=248&wr(t,r)|a>>5,n[i+1]=e}function _r(t,e,r,n,i){var a=240&Lr(t,e)|15;n[i+0]=240&wr(t,r)|Nr(t,e,r)>>4,n[i+1]=a}function Pr(t,e,r,n,i){n[i+0]=255,Ar(t,e,r,n,i+1)}function kr(t,e,r,n,i){xr(t,e,r,n,i),n[i+3]=255}function Ir(t,e,r,n,i){Ar(t,e,r,n,i),n[i+3]=255}function Wt(t,e){return 0>t?0:t>e?e:t}function Fr(e,r,n){t[e]=function(t,e,i,a,o,s,u,c,l){for(var h=c+(-2&l)*n;c!=h;)r(t[e+0],i[a+0],o[s+0],u,c),r(t[e+1],i[a+0],o[s+0],u,c+n),e+=2,++a,++s,c+=2*n;1&l&&r(t[e+0],i[a+0],o[s+0],u,c)}}function Cr(t,e,r){return 0==r?0==t?0==e?6:5:0==e?4:0:r}function jr(t,e,r,n,i){switch(t>>>30){case 3:on(e,r,n,i,0);break;case 2:sn(e,r,n,i);break;case 1:cn(e,r,n,i)}}function Or(t,e){var r,a,o=e.M,s=e.Nb,u=t.oc,c=t.pc+40,l=t.oc,h=t.pc+584,f=t.oc,d=t.pc+600;for(r=0;16>r;++r)u[c+32*r-1]=129;for(r=0;8>r;++r)l[h+32*r-1]=129,f[d+32*r-1]=129;for(0<o?u[c-1-32]=l[h-1-32]=f[d-1-32]=129:(i(u,c-32-1,127,21),i(l,h-32-1,127,9),i(f,d-32-1,127,9)),a=0;a<t.za;++a){var p=e.ya[e.aa+a];if(0<a){for(r=-1;16>r;++r)n(u,c+32*r-4,u,c+32*r+12,4);for(r=-1;8>r;++r)n(l,h+32*r-4,l,h+32*r+4,4),n(f,d+32*r-4,f,d+32*r+4,4)}var g=t.Gd,m=t.Hd+a,v=p.ad,b=p.Hc;if(0<o&&(n(u,c-32,g[m].y,0,16),n(l,h-32,g[m].f,0,8),n(f,d-32,g[m].ea,0,8)),p.Za){var y=u,w=c-32+16;for(0<o&&(a>=t.za-1?i(y,w,g[m].y[15],4):n(y,w,g[m+1].y,0,4)),r=0;4>r;r++)y[w+128+r]=y[w+256+r]=y[w+384+r]=y[w+0+r];for(r=0;16>r;++r,b<<=2)y=u,w=c+Ri[r],fi[p.Ob[r]](y,w),jr(b,v,16*+r,y,w)}else if(y=Cr(a,o,p.Ob[0]),hi[y](u,c),0!=b)for(r=0;16>r;++r,b<<=2)jr(b,v,16*+r,u,c+Ri[r]);for(r=p.Gc,y=Cr(a,o,p.Dd),di[y](l,h),di[y](f,d),b=v,y=l,w=h,255&(p=r>>0)&&(170&p?un(b,256,y,w):ln(b,256,y,w)),p=f,b=d,255&(r>>=8)&&(170&r?un(v,320,p,b):ln(v,320,p,b)),o<t.Ub-1&&(n(g[m].y,0,u,c+480,16),n(g[m].f,0,l,h+224,8),n(g[m].ea,0,f,d+224,8)),r=8*s*t.B,g=t.sa,m=t.ta+16*a+16*s*t.R,v=t.qa,p=t.ra+8*a+r,b=t.Ha,y=t.Ia+8*a+r,r=0;16>r;++r)n(g,m+r*t.R,u,c+32*r,16);for(r=0;8>r;++r)n(v,p+r*t.B,l,h+32*r,8),n(b,y+r*t.B,f,d+32*r,8)}}function Br(t,n,i,a,o,s,u,c,l){var h=[0],f=[0],d=0,p=null!=l?l.kd:0,g=null!=l?l:new nr;if(null==t||12>i)return 7;g.data=t,g.w=n,g.ha=i,n=[n],i=[i],g.gb=[g.gb];t:{var m=n,b=i,y=g.gb;if(e(null!=t),e(null!=b),e(null!=y),y[0]=0,12<=b[0]&&!r(t,m[0],"RIFF")){if(r(t,m[0]+8,"WEBP")){y=3;break t}var w=j(t,m[0]+4);if(12>w||4294967286<w){y=3;break t}if(p&&w>b[0]-8){y=7;break t}y[0]=w,m[0]+=12,b[0]-=12}y=0}if(0!=y)return y;for(w=0<g.gb[0],i=i[0];;){t:{var L=t;b=n,y=i;var A=h,x=f,S=m=[0];if((k=d=[d])[0]=0,8>y[0])y=7;else{if(!r(L,b[0],"VP8X")){if(10!=j(L,b[0]+4)){y=3;break t}if(18>y[0]){y=7;break t}var _=j(L,b[0]+8),P=1+C(L,b[0]+12);if(2147483648<=P*(L=1+C(L,b[0]+15))){y=3;break t}null!=S&&(S[0]=_),null!=A&&(A[0]=P),null!=x&&(x[0]=L),b[0]+=18,y[0]-=18,k[0]=1}y=0}}if(d=d[0],m=m[0],0!=y)return y;if(b=!!(2&m),!w&&d)return 3;if(null!=s&&(s[0]=!!(16&m)),null!=u&&(u[0]=b),null!=c&&(c[0]=0),u=h[0],m=f[0],d&&b&&null==l){y=0;break}if(4>i){y=7;break}if(w&&d||!w&&!d&&!r(t,n[0],"ALPH")){i=[i],g.na=[g.na],g.P=[g.P],g.Sa=[g.Sa];t:{_=t,y=n,w=i;var k=g.gb;A=g.na,x=g.P,S=g.Sa;P=22,e(null!=_),e(null!=w),L=y[0];var I=w[0];for(e(null!=A),e(null!=S),A[0]=null,x[0]=null,S[0]=0;;){if(y[0]=L,w[0]=I,8>I){y=7;break t}var F=j(_,L+4);if(4294967286<F){y=3;break t}var O=8+F+1&-2;if(P+=O,0<k&&P>k){y=3;break t}if(!r(_,L,"VP8 ")||!r(_,L,"VP8L")){y=0;break t}if(I[0]<O){y=7;break t}r(_,L,"ALPH")||(A[0]=_,x[0]=L+8,S[0]=F),L+=O,I-=O}}if(i=i[0],g.na=g.na[0],g.P=g.P[0],g.Sa=g.Sa[0],0!=y)break}i=[i],g.Ja=[g.Ja],g.xa=[g.xa];t:if(k=t,y=n,w=i,A=g.gb[0],x=g.Ja,S=g.xa,_=y[0],L=!r(k,_,"VP8 "),P=!r(k,_,"VP8L"),e(null!=k),e(null!=w),e(null!=x),e(null!=S),8>w[0])y=7;else{if(L||P){if(k=j(k,_+4),12<=A&&k>A-12){y=3;break t}if(p&&k>w[0]-8){y=7;break t}x[0]=k,y[0]+=8,w[0]-=8,S[0]=P}else S[0]=5<=w[0]&&47==k[_+0]&&!(k[_+4]>>5),x[0]=w[0];y=0}if(i=i[0],g.Ja=g.Ja[0],g.xa=g.xa[0],n=n[0],0!=y)break;if(4294967286<g.Ja)return 3;if(null==c||b||(c[0]=g.xa?2:1),u=[u],m=[m],g.xa){if(5>i){y=7;break}c=u,p=m,b=s,null==t||5>i?t=0:5<=i&&47==t[n+0]&&!(t[n+4]>>5)?(w=[0],k=[0],A=[0],v(x=new N,t,n,i),gt(x,w,k,A)?(null!=c&&(c[0]=w[0]),null!=p&&(p[0]=k[0]),null!=b&&(b[0]=A[0]),t=1):t=0):t=0}else{if(10>i){y=7;break}c=m,null==t||10>i||!Xt(t,n+3,i-3)?t=0:(p=t[n+0]|t[n+1]<<8|t[n+2]<<16,b=16383&(t[n+7]<<8|t[n+6]),t=16383&(t[n+9]<<8|t[n+8]),1&p||3<(p>>1&7)||!(p>>4&1)||p>>5>=g.Ja||!b||!t?t=0:(u&&(u[0]=b),c&&(c[0]=t),t=1))}if(!t)return 3;if(u=u[0],m=m[0],d&&(h[0]!=u||f[0]!=m))return 3;null!=l&&(l[0]=g,l.offset=n-l.w,e(4294967286>n-l.w),e(l.offset==l.ha-i));break}return 0==y||7==y&&d&&null==l?(null!=s&&(s[0]|=null!=g.na&&0<g.na.length),null!=a&&(a[0]=u),null!=o&&(o[0]=m),0):y}function Mr(t,e,r){var n=e.width,i=e.height,a=0,o=0,s=n,u=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,u=t.bd,a=t.v,o=t.j,11>r||(a&=-2,o&=-2),0>a||0>o||0>=s||0>=u||a+s>n||o+u>i))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+u,e.U=s,e.T=u,e.da=null!=t&&0<t.da,e.da){if(!E(s,u,r=[t.ib],a=[t.hb]))return 0;e.ib=r[0],e.hb=a[0]}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*n/4&&e.hb<3*i/4,e.Kb=0),1}function Er(t){if(null==t)return 2;if(11>t.S){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function qr(t,e,r,n){if(null==n||0>=t||0>=e)return 2;if(null!=r){if(r.Da){var i=r.cd,o=r.bd,s=-2&r.v,u=-2&r.j;if(0>s||0>u||0>=i||0>=o||s+i>t||u+o>e)return 2;t=i,e=o}if(r.da){if(!E(t,e,i=[r.ib],o=[r.hb]))return 2;t=i[0],e=o[0]}}n.width=t,n.height=e;t:{var c=n.width,l=n.height;if(t=n.S,0>=c||0>=l||!(t>=En&&13>t))t=2;else{if(0>=n.Rd&&null==n.sd){s=o=i=e=0;var h=(u=c*zi[t])*l;if(11>t||(o=(l+1)/2*(e=(c+1)/2),12==t&&(s=(i=c)*l)),null==(l=a(h+2*o+s))){t=1;break t}n.sd=l,11>t?((c=n.f.RGBA).eb=l,c.fb=0,c.A=u,c.size=h):((c=n.f.kb).y=l,c.O=0,c.fa=u,c.Fd=h,c.f=l,c.N=0+h,c.Ab=e,c.Cd=o,c.ea=l,c.W=0+h+o,c.Db=e,c.Ed=o,12==t&&(c.F=l,c.J=0+h+2*o),c.Tc=s,c.lb=i)}if(e=1,i=n.S,o=n.width,s=n.height,i>=En&&13>i)if(11>i)t=n.f.RGBA,e&=(u=Math.abs(t.A))*(s-1)+o<=t.size,e&=u>=o*zi[i],e&=null!=t.eb;else{t=n.f.kb,u=(o+1)/2,h=(s+1)/2,c=Math.abs(t.fa);l=Math.abs(t.Ab);var f=Math.abs(t.Db),d=Math.abs(t.lb),p=d*(s-1)+o;e&=c*(s-1)+o<=t.Fd,e&=l*(h-1)+u<=t.Cd,e=(e&=f*(h-1)+u<=t.Ed)&c>=o&l>=u&f>=u,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=d>=o,e&=p<=t.Tc,e&=null!=t.F)}else e=0;t=e?0:2}}return 0!=t||null!=r&&r.fd&&(t=Er(n)),t}var Rr=64,Tr=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],Dr=24,Ur=32,zr=8,Hr=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];T("Predictor0","PredictorAdd0"),t.Predictor0=function(){return 4278190080},t.Predictor1=function(t){return t},t.Predictor2=function(t,e,r){return e[r+0]},t.Predictor3=function(t,e,r){return e[r+1]},t.Predictor4=function(t,e,r){return e[r-1]},t.Predictor5=function(t,e,r){return U(U(t,e[r+1]),e[r+0])},t.Predictor6=function(t,e,r){return U(t,e[r-1])},t.Predictor7=function(t,e,r){return U(t,e[r+0])},t.Predictor8=function(t,e,r){return U(e[r-1],e[r+0])},t.Predictor9=function(t,e,r){return U(e[r+0],e[r+1])},t.Predictor10=function(t,e,r){return U(U(t,e[r-1]),U(e[r+0],e[r+1]))},t.Predictor11=function(t,e,r){var n=e[r+0];return 0>=V(n>>24&255,t>>24&255,(e=e[r-1])>>24&255)+V(n>>16&255,t>>16&255,e>>16&255)+V(n>>8&255,t>>8&255,e>>8&255)+V(255&n,255&t,255&e)?n:t},t.Predictor12=function(t,e,r){var n=e[r+0];return(z((t>>24&255)+(n>>24&255)-((e=e[r-1])>>24&255))<<24|z((t>>16&255)+(n>>16&255)-(e>>16&255))<<16|z((t>>8&255)+(n>>8&255)-(e>>8&255))<<8|z((255&t)+(255&n)-(255&e)))>>>0},t.Predictor13=function(t,e,r){var n=e[r-1];return(H((t=U(t,e[r+0]))>>24&255,n>>24&255)<<24|H(t>>16&255,n>>16&255)<<16|H(t>>8&255,n>>8&255)<<8|H(t>>0&255,n>>0&255))>>>0};var Vr=t.PredictorAdd0;t.PredictorAdd1=W,T("Predictor2","PredictorAdd2"),T("Predictor3","PredictorAdd3"),T("Predictor4","PredictorAdd4"),T("Predictor5","PredictorAdd5"),T("Predictor6","PredictorAdd6"),T("Predictor7","PredictorAdd7"),T("Predictor8","PredictorAdd8"),T("Predictor9","PredictorAdd9"),T("Predictor10","PredictorAdd10"),T("Predictor11","PredictorAdd11"),T("Predictor12","PredictorAdd12"),T("Predictor13","PredictorAdd13");var Wr=t.PredictorAdd2;X("ColorIndexInverseTransform","MapARGB","32b",(function(t){return t>>8&255}),(function(t){return t})),X("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",(function(t){return t}),(function(t){return t>>8&255}));var Gr,Yr=t.ColorIndexInverseTransform,Jr=t.MapARGB,Xr=t.VP8LColorIndexInverseTransformAlpha,Kr=t.MapAlpha,Zr=t.VP8LPredictorsAdd=[];Zr.length=16,(t.VP8LPredictors=[]).length=16,(t.VP8LPredictorsAdd_C=[]).length=16,(t.VP8LPredictors_C=[]).length=16;var $r,Qr,tn,en,rn,nn,an,on,sn,un,cn,ln,hn,fn,dn,pn,gn,mn,vn,bn,yn,wn,Nn,Ln,An,xn,Sn,_n,Pn=a(511),kn=a(2041),In=a(225),Fn=a(767),Cn=0,jn=kn,On=In,Bn=Fn,Mn=Pn,En=0,qn=1,Rn=2,Tn=3,Dn=4,Un=5,zn=6,Hn=7,Vn=8,Wn=9,Gn=10,Yn=[2,3,7],Jn=[3,3,11],Xn=[280,256,256,256,40],Kn=[0,1,1,1,0],Zn=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],$n=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Qn=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],ti=8,ei=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],ri=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],ni=null,ii=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],ai=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],oi=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],si=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ui=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ci=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],li=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],hi=[],fi=[],di=[],pi=1,gi=2,mi=[],vi=[];vr("UpsampleRgbLinePair",Ar,3),vr("UpsampleBgrLinePair",xr,3),vr("UpsampleRgbaLinePair",Ir,4),vr("UpsampleBgraLinePair",kr,4),vr("UpsampleArgbLinePair",Pr,4),vr("UpsampleRgba4444LinePair",_r,2),vr("UpsampleRgb565LinePair",Sr,2);var bi=t.UpsampleRgbLinePair,yi=t.UpsampleBgrLinePair,wi=t.UpsampleRgbaLinePair,Ni=t.UpsampleBgraLinePair,Li=t.UpsampleArgbLinePair,Ai=t.UpsampleRgba4444LinePair,xi=t.UpsampleRgb565LinePair,Si=16,_i=1<<Si-1,Pi=-227,ki=482,Ii=6,Fi=(256<<Ii)-1,Ci=0,ji=a(256),Oi=a(256),Bi=a(256),Mi=a(256),Ei=a(ki-Pi),qi=a(ki-Pi);Fr("YuvToRgbRow",Ar,3),Fr("YuvToBgrRow",xr,3),Fr("YuvToRgbaRow",Ir,4),Fr("YuvToBgraRow",kr,4),Fr("YuvToArgbRow",Pr,4),Fr("YuvToRgba4444Row",_r,2),Fr("YuvToRgb565Row",Sr,2);var Ri=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],Ti=[0,2,8],Di=[8,7,6,4,4,2,2,2,1,1,1,1],Ui=1;this.WebPDecodeRGBA=function(t,r,n,i,a){var o=qn,s=new rr,u=new ot;s.ba=u,u.S=o,u.width=[u.width],u.height=[u.height];var c=u.width,l=u.height,h=new st;if(null==h||null==t)var f=2;else e(null!=h),f=Br(t,r,n,h.width,h.height,h.Pd,h.Qd,h.format,null);if(0!=f?c=0:(null!=c&&(c[0]=h.width[0]),null!=l&&(l[0]=h.height[0]),c=1),c){u.width=u.width[0],u.height=u.height[0],null!=i&&(i[0]=u.width),null!=a&&(a[0]=u.height);t:{if(i=new Gt,(a=new nr).data=t,a.w=r,a.ha=n,a.kd=1,r=[0],e(null!=a),(0==(t=Br(a.data,a.w,a.ha,null,null,null,r,null,a))||7==t)&&r[0]&&(t=4),0==(r=t)){if(e(null!=s),i.data=a.data,i.w=a.w+a.offset,i.ha=a.ha-a.offset,i.put=dt,i.ac=ft,i.bc=pt,i.ma=s,a.xa){if(null==(t=kt())){s=1;break t}if(function(t,r){var n=[0],i=[0],a=[0];e:for(;;){if(null==t)return 0;if(null==r)return t.a=2,0;if(t.l=r,t.a=0,v(t.m,r.data,r.w,r.ha),!gt(t.m,n,i,a)){t.a=3;break e}if(t.xb=gi,r.width=n[0],r.height=i[0],!It(n[0],i[0],1,t,null))break e;return 1}return e(0!=t.a),0}(t,i)){if(i=0==(r=qr(i.width,i.height,s.Oa,s.ba))){e:{i=t;r:for(;;){if(null==i){i=0;break e}if(e(null!=i.s.yc),e(null!=i.s.Ya),e(0<i.s.Wb),e(null!=(n=i.l)),e(null!=(a=n.ma)),0!=i.xb){if(i.ca=a.ba,i.tb=a.tb,e(null!=i.ca),!Mr(a.Oa,n,Tn)){i.a=2;break r}if(!Ft(i,n.width))break r;if(n.da)break r;if((n.da||nt(i.ca.S))&&mr(),11>i.ca.S||(alert("todo:WebPInitConvertARGBToYUV"),null!=i.ca.f.kb.F&&mr()),i.Pb&&0<i.s.ua&&null==i.s.vb.X&&!O(i.s.vb,i.s.Wa.Xa)){i.a=1;break r}i.xb=0}if(!_t(i,i.V,i.Ba,i.c,i.i,n.o,Lt))break r;a.Dc=i.Ma,i=1;break e}e(0!=i.a),i=0}i=!i}i&&(r=t.a)}else r=t.a}else{if(null==(t=new Yt)){s=1;break t}if(t.Fa=a.na,t.P=a.P,t.qc=a.Sa,Kt(t,i)){if(0==(r=qr(i.width,i.height,s.Oa,s.ba))){if(t.Aa=0,n=s.Oa,e(null!=(a=t)),null!=n){if(0<(c=0>(c=n.Md)?0:100<c?255:255*c/100)){for(l=h=0;4>l;++l)12>(f=a.pb[l]).lc&&(f.ia=c*Di[0>f.lc?0:f.lc]>>3),h|=f.ia;h&&(alert("todo:VP8InitRandom"),a.ia=1)}a.Ga=n.Id,100<a.Ga?a.Ga=100:0>a.Ga&&(a.Ga=0)}Qt(t,i)||(r=t.a)}}else r=t.a}0==r&&null!=s.Oa&&s.Oa.fd&&(r=Er(s.ba))}s=r}o=0!=s?null:11>o?u.f.RGBA.eb:u.f.kb.y}else o=null;return o};var zi=[3,4,3,4,4,2,2,4,4,4,2,1,1]});var h=[0],f=[0],d=[],p=new $t,g=t,m=function(t,e){var r={},n=0,i=!1,a=0,o=0;if(r.frames=[],!
/** @license
   * Copyright (c) 2017 Dominik Homberger

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

https://webpjs.appspot.com
WebPRiffParser dominikhlbg@gmail.com
*/
function(t,e,r,n){for(var i=0;i<n;i++)if(t[e+i]!=r.charCodeAt(i))return!0;return!1}(t,e,"RIFF",4)){var s,h;l(t,e+=4);for(e+=8;e<t.length;){var f=u(t,e),d=l(t,e+=4);e+=4;var p=d+(1&d);switch(f){case"VP8 ":case"VP8L":void 0===r.frames[n]&&(r.frames[n]={});(v=r.frames[n]).src_off=i?o:e-8,v.src_size=a+d+8,n++,i&&(i=!1,a=0,o=0);break;case"VP8X":(v=r.header={}).feature_flags=t[e];var g=e+4;v.canvas_width=1+c(t,g);g+=3;v.canvas_height=1+c(t,g);g+=3;break;case"ALPH":i=!0,a=p+8,o=e-8;break;case"ANIM":(v=r.header).bgcolor=l(t,e);g=e+4;v.loop_count=(s=t)[(h=g)+0]<<0|s[h+1]<<8;g+=2;break;case"ANMF":var m,v;(v=r.frames[n]={}).offset_x=2*c(t,e),e+=3,v.offset_y=2*c(t,e),e+=3,v.width=1+c(t,e),e+=3,v.height=1+c(t,e),e+=3,v.duration=c(t,e),e+=3,m=t[e++],v.dispose=1&m,v.blend=m>>1&1}"ANMF"!=f&&(e+=p)}return r}}(g,0);m.response=g,m.rgbaoutput=!0,m.dataurl=!1;var v=m.header?m.header:null,b=m.frames?m.frames:null;if(v){v.loop_counter=v.loop_count,h=[v.canvas_height],f=[v.canvas_width];for(var y=0;y<b.length&&0!=b[y].blend;y++);}var w=b[0],N=p.WebPDecodeRGBA(g,w.src_off,w.src_size,f,h);w.rgba=N,w.imgwidth=f[0],w.imgheight=h[0];for(var L=0;L<f[0]*h[0]*4;L++)d[L]=N[L];return this.width=f,this.height=h,this.data=d,this}!function(e){var r=function(){return"function"==typeof fflate__WEBPACK_IMPORTED_MODULE_0__.zlibSync},n=function(r,n,a,l){var h=4,f=s;switch(l){case e.image_compression.FAST:h=1,f=o;break;case e.image_compression.MEDIUM:h=6,f=u;break;case e.image_compression.SLOW:h=9,f=c}r=i(r,n,a,f);var d=(0,fflate__WEBPACK_IMPORTED_MODULE_0__.zlibSync)(r,{level:h});return e.__addimage__.arrayBufferToBinaryString(d)},i=function(t,e,r,n){for(var i,a,o,s=t.length/e,u=new Uint8Array(t.length+s),c=h(),l=0;l<s;l+=1){if(o=l*e,i=t.subarray(o,o+e),n)u.set(n(i,r,a),o+l);else{for(var d,p=c.length,g=[];d<p;d+=1)g[d]=c[d](i,r,a);var m=f(g.concat());u.set(g[m],o+l)}a=i}return u},a=function(t){var e=Array.apply([],t);return e.unshift(0),e},o=function(t,e){var r,n=[],i=t.length;n[0]=1;for(var a=0;a<i;a+=1)r=t[a-e]||0,n[a+1]=t[a]-r+256&255;return n},s=function(t,e,r){var n,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)n=r&&r[o]||0,i[o+1]=t[o]-n+256&255;return i},u=function(t,e,r){var n,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)n=t[s-e]||0,i=r&&r[s]||0,a[s+1]=t[s]+256-(n+i>>>1)&255;return a},c=function(t,e,r){var n,i,a,o,s=[],u=t.length;s[0]=4;for(var c=0;c<u;c+=1)n=t[c-e]||0,i=r&&r[c]||0,a=r&&r[c-e]||0,o=l(n,i,a),s[c+1]=t[c]-o+256&255;return s},l=function(t,e,r){if(t===e&&e===r)return t;var n=Math.abs(e-r),i=Math.abs(t-r),a=Math.abs(t+e-r-r);return n<=i&&n<=a?t:i<=a?e:r},h=function(){return[a,o,s,u,c]},f=function(t){var e=t.map((function(t){return t.reduce((function(t,e){return t+Math.abs(e)}),0)}));return e.indexOf(Math.min.apply(null,e))};e.processPNG=function(t,i,a,o){var s,u,c,l,h,f,d,p,g,m,v,b,y,w,N,L=this.decode.FLATE_DECODE,A="";if(this.__addimage__.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.__addimage__.isArrayBufferView(t)){if(t=(c=new Yt(t)).imgData,u=c.bits,s=c.colorSpace,h=c.colors,-1!==[4,6].indexOf(c.colorType)){if(8===c.bits){g=(p=32==c.pixelBitlength?new Uint32Array(c.decodePixels().buffer):16==c.pixelBitlength?new Uint16Array(c.decodePixels().buffer):new Uint8Array(c.decodePixels().buffer)).length,v=new Uint8Array(g*c.colors),m=new Uint8Array(g);var x,S=c.pixelBitlength-c.bits;for(w=0,N=0;w<g;w++){for(y=p[w],x=0;x<S;)v[N++]=y>>>x&255,x+=c.bits;m[w]=y>>>x&255}}if(16===c.bits){g=(p=new Uint32Array(c.decodePixels().buffer)).length,v=new Uint8Array(g*(32/c.pixelBitlength)*c.colors),m=new Uint8Array(g*(32/c.pixelBitlength)),b=c.colors>1,w=0,N=0;for(var _=0;w<g;)y=p[w++],v[N++]=y>>>0&255,b&&(v[N++]=y>>>16&255,y=p[w++],v[N++]=y>>>0&255),m[_++]=y>>>16&255;u=8}o!==e.image_compression.NONE&&r()?(t=n(v,c.width*c.colors,c.colors,o),d=n(m,c.width,1,o)):(t=v,d=m,L=void 0)}if(3===c.colorType&&(s=this.color_spaces.INDEXED,f=c.palette,c.transparency.indexed)){var P=c.transparency.indexed,k=0;for(w=0,g=P.length;w<g;++w)k+=P[w];if((k/=255)===g-1&&-1!==P.indexOf(0))l=[P.indexOf(0)];else if(k!==g){for(p=c.decodePixels(),m=new Uint8Array(p.length),w=0,g=p.length;w<g;w++)m[w]=P[p[w]];d=n(m,c.width,1)}}var I=function(t){var r;switch(t){case e.image_compression.FAST:r=11;break;case e.image_compression.MEDIUM:r=13;break;case e.image_compression.SLOW:r=14;break;default:r=12}return r}(o);return L===this.decode.FLATE_DECODE&&(A="/Predictor "+I+" "),A+="/Colors "+h+" /BitsPerComponent "+u+" /Columns "+c.width,(this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t))&&(t=this.__addimage__.arrayBufferToBinaryString(t)),(d&&this.__addimage__.isArrayBuffer(d)||this.__addimage__.isArrayBufferView(d))&&(d=this.__addimage__.arrayBufferToBinaryString(d)),{alias:a,data:t,index:i,filter:L,decodeParameters:A,transparency:l,palette:f,sMask:d,predictor:I,width:c.width,height:c.height,bitsPerComponent:u,colorSpace:s}}}}(O.API),function(t){t.processGIF89A=function(e,r,n,i){var a=new Jt(e),o=a.width,s=a.height,u=[];a.decodeAndBlitFrameRGBA(0,u);var c={data:u,width:o,height:s},l=new Kt(100).encode(c,100);return t.processJPEG.call(this,l,r,n,i)},t.processGIF87A=t.processGIF89A}(O.API),Zt.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.datav.getUint8(this.pos++,!0),n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:n,blue:r,quad:a}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Zt.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){i.log("bit decode error:"+t)}},Zt.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),r=e%4;for(t=this.height-1;t>=0;t--){for(var n=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var u=this.palette[a>>7-s&1];this.data[o+4*s]=u.blue,this.data[o+4*s+1]=u.green,this.data[o+4*s+2]=u.red,this.data[o+4*s+3]=255}0!==r&&(this.pos+=4-r)}},Zt.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+2*i*4,s=a>>4,u=15&a,c=this.palette[s];if(this.data[o]=c.blue,this.data[o+1]=c.green,this.data[o+2]=c.red,this.data[o+3]=255,2*i+1>=this.width)break;c=this.palette[u],this.data[o+4]=c.blue,this.data[o+4+1]=c.green,this.data[o+4+2]=c.red,this.data[o+4+3]=255}0!==e&&(this.pos+=4-e)}},Zt.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;e>=0;e--){for(var r=this.bottom_up?e:this.height-1-e,n=0;n<this.width;n++){var i=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+4*n;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[a+1]=o.green,this.data[a+2]=o.blue,this.data[a+3]=255}else this.data[a]=255,this.data[a+1]=255,this.data[a+2]=255,this.data[a+3]=255}0!==t&&(this.pos+=4-t)}},Zt.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,u=(a>>10&e)/e*255|0,c=a>>15?255:0,l=n*this.width*4+4*i;this.data[l]=u,this.data[l+1]=s,this.data[l+2]=o,this.data[l+3]=c}this.pos+=t}},Zt.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),r=parseInt("111111",2),n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,u=(o>>5&r)/r*255|0,c=(o>>11)/e*255|0,l=i*this.width*4+4*a;this.data[l]=c,this.data[l+1]=u,this.data[l+2]=s,this.data[l+3]=255}this.pos+=t}},Zt.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*r;this.data[o]=a,this.data[o+1]=i,this.data[o+2]=n,this.data[o+3]=255}this.pos+=this.width%4}},Zt.prototype.bit32=function(){for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*r;this.data[s]=a,this.data[s+1]=i,this.data[s+2]=n,this.data[s+3]=o}},Zt.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processBMP=function(e,r,n,i){var a=new Zt(e,!1),o=a.width,s=a.height,u={data:a.getData(),width:o,height:s},c=new Kt(100).encode(u,100);return t.processJPEG.call(this,c,r,n,i)}}(O.API),$t.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processWEBP=function(e,r,n,i){var a=new $t(e,!1),o=a.width,s=a.height,u={data:a.getData(),width:o,height:s},c=new Kt(100).encode(u,100);return t.processJPEG.call(this,c,r,n,i)}}(O.API),O.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")})),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
 * MIT license.
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 *               2014 Diego Casorran, https://github.com/diegocr
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
zt=O.API,Ht=zt.getCharWidthsArray=function(t,e){var r,n,i=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),o=e.charSpace||this.internal.getCharSpace(),s=e.widths?e.widths:i.metadata.Unicode.widths,u=s.fof?s.fof:1,c=e.kerning?e.kerning:i.metadata.Unicode.kerning,l=c.fof?c.fof:1,h=!1!==e.doKerning,f=0,d=t.length,p=0,g=s[0]||u,m=[];for(r=0;r<d;r++)n=t.charCodeAt(r),"function"==typeof i.metadata.widthOfString?m.push((i.metadata.widthOfGlyph(i.metadata.characterToGlyph(n))+o*(1e3/a)||0)/1e3):(f=h&&"object"==typeof c[n]&&!isNaN(parseInt(c[n][p],10))?c[n][p]/l:0,m.push((s[n]||g)/u+f)),p=n;return m},Vt=zt.getStringUnitWidth=function(t,e){var r=(e=e||{}).fontSize||this.internal.getFontSize(),n=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return zt.processArabic&&(t=zt.processArabic(t)),"function"==typeof n.metadata.widthOfString?n.metadata.widthOfString(t,r,i)/r:Ht.apply(this,arguments).reduce((function(t,e){return t+e}),0)},Wt=function(t,e,r,n){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<r;)s+=e[a],a++;i.push(t.slice(0,a));var u=a;for(s=0;a!==o;)s+e[a]>n&&(i.push(t.slice(u,a)),s=0,u=a),s+=e[a],a++;return u!==a&&i.push(t.slice(u,a)),i},Gt=function(t,e,r){r||(r={});var n,i,a,o,s,u,c,l=[],h=[l],f=r.textIndent||0,d=0,p=0,g=t.split(" "),m=Ht.apply(this,[" ",r])[0];if(u=-1===r.lineIndent?g[0].length+2:r.lineIndent||0){var v=Array(u).join(" "),b=[];g.map((function(t){(t=t.split(/\s*\n/)).length>1?b=b.concat(t.map((function(t,e){return(e&&t.length?"\n":"")+t}))):b.push(t[0])})),g=b,u=Vt.apply(this,[v,r])}for(a=0,o=g.length;a<o;a++){var y=0;if(n=g[a],u&&"\n"==n[0]&&(n=n.substr(1),y=1),f+d+(p=(i=Ht.apply(this,[n,r])).reduce((function(t,e){return t+e}),0))>e||y){if(p>e){for(s=Wt.apply(this,[n,i,e-(f+d),e]),l.push(s.shift()),l=[s.pop()];s.length;)h.push([s.shift()]);p=i.slice(n.length-(l[0]?l[0].length:0)).reduce((function(t,e){return t+e}),0)}else l=[n];h.push(l),f=p+u,d=m}else l.push(n),f+=d+p,d=m}return c=u?function(t,e){return(e?v:"")+t.join(" ")}:function(t){return t.join(" ")},h.map(c)},zt.splitTextToSize=function(t,e,r){var n,i=(r=r||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle);return e.metadata.Unicode?{widths:e.metadata.Unicode.widths||{0:1},kerning:e.metadata.Unicode.kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,r);n=Array.isArray(t)?t:String(t).split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=r.textIndent?1*r.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=r.lineIndent;var s,u,c=[];for(s=0,u=n.length;s<u;s++)c=c.concat(Gt.apply(this,[n[s],o,a]));return c},
/** @license
 jsPDF standard_fonts_metrics plugin
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 * MIT license.
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 * 
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){t.__fontmetrics__=t.__fontmetrics__||{};for(var e="klmnopqrstuvwxyz",r={},n={},i=0;i<e.length;i++)r[e[i]]="0123456789abcdef"[i],n["0123456789abcdef"[i]]=e[i];var a=function(t){return"0x"+parseInt(t,10).toString(16)},o=t.__fontmetrics__.compress=function(t){var e,r,i,s,u=["{"];for(var c in t){if(e=t[c],isNaN(parseInt(c,10))?r="'"+c+"'":(c=parseInt(c,10),r=(r=a(c).slice(2)).slice(0,-1)+n[r.slice(-1)]),"number"==typeof e)e<0?(i=a(e).slice(3),s="-"):(i=a(e).slice(2),s=""),i=s+i.slice(0,-1)+n[i.slice(-1)];else{if("object"!=typeof e)throw new Error("Don't know what to do with value type "+typeof e+".");i=o(e)}u.push(r+i)}return u.push("}"),u.join("")},s=t.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,n,i,a,o={},s=1,u=o,c=[],l="",h="",f=t.length-1,d=1;d<f;d+=1)"'"==(a=t[d])?e?(i=e.join(""),e=void 0):e=[]:e?e.push(a):"{"==a?(c.push([u,i]),u={},i=void 0):"}"==a?((n=c.pop())[0][n[1]]=u,i=void 0,u=n[0]):"-"==a?s=-1:void 0===i?r.hasOwnProperty(a)?(l+=r[a],i=parseInt(l,16)*s,s=1,l=""):l+=a:r.hasOwnProperty(a)?(h+=r[a],u[i]=parseInt(h,16)*s,s=1,i=void 0,h=""):h+=a;return o},u={codePages:["WinAnsiEncoding"],WinAnsiEncoding:s("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},c={Unicode:{Courier:u,"Courier-Bold":u,"Courier-BoldOblique":u,"Courier-Oblique":u,Helvetica:u,"Helvetica-Bold":u,"Helvetica-BoldOblique":u,"Helvetica-Oblique":u,"Times-Roman":u,"Times-Bold":u,"Times-BoldItalic":u,"Times-Italic":u}},l={Unicode:{"Courier-Oblique":s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":s("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":s("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":s("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:s("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:s("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":s("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:s("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":s("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":s("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":s("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e=t.font,r=l.Unicode[e.postScriptName];r&&(e.metadata.Unicode={},e.metadata.Unicode.widths=r.widths,e.metadata.Unicode.kerning=r.kerning);var n=c.Unicode[e.postScriptName];n&&(e.metadata.Unicode.encoding=n,e.encoding=n.codePages[0])}])}(O.API),
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r};t.API.events.push(["addFont",function(r){var n=void 0,i=r.font,a=r.instance;if(!i.isStandardFont){if(void 0===a)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");if("string"!=typeof(n=!1===a.existsFileInVFS(i.postScriptName)?a.loadFile(i.postScriptName):a.getFileFromVFS(i.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");!function(r,n){n=/^\x00\x01\x00\x00/.test(n)?e(n):e(u(n)),r.metadata=t.API.TTFFont.open(n),r.metadata.Unicode=r.metadata.Unicode||{encoding:{},kerning:{},widths:[]},r.metadata.glyIdsUsed=[0]}(i,n)}}])}(O),
/** @license
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){function e(){return(r.canvg?Promise.resolve(r.canvg):Promise.resolve(/*! import() */).then(__webpack_require__.bind(__webpack_require__, /*! canvg */ "./node_modules/canvg/lib/index.es.js"))).catch((function(t){return Promise.reject(new Error("Could not load canvg: "+t))})).then((function(t){return t.default?t.default:t}))}O.API.addSvgAsImage=function(t,r,n,a,o,s,u,c){if(isNaN(r)||isNaN(n))throw i.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(a)||isNaN(o))throw i.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=a,l.height=o;var h=l.getContext("2d");h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height);var f={ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0},d=this;return e().then((function(e){return e.fromString(h,t,f)}),(function(){return Promise.reject(new Error("Could not load canvg."))})).then((function(t){return t.render(f)})).then((function(){d.addImage(l.toDataURL("image/jpeg",1),r,n,a,o,u,c)}))}}(),O.API.putTotalPages=function(t){var e,r=0;parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),r=this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),r=this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var n=1;n<=this.internal.getNumberOfPages();n++)for(var i=0;i<this.internal.pages[n].length;i++)this.internal.pages[n][i]=this.internal.pages[n][i].replace(e,r);return this},O.API.viewerPreferences=function(t,e){var r;t=t||{},e=e||!1;var n,i,a,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},s=Object.keys(o),u=[],c=0,l=0,h=0;function f(t,e){var r,n=!1;for(r=0;r<t.length;r+=1)t[r]===e&&(n=!0);return n}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),r=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var d=s.length;for(h=0;h<d;h+=1)r[s[h]].value=r[s[h]].defaultValue,r[s[h]].explicitSet=!1}if("object"==typeof t)for(i in t)if(a=t[i],f(s,i)&&void 0!==a){if("boolean"===r[i].type&&"boolean"==typeof a)r[i].value=a;else if("name"===r[i].type&&f(r[i].valueSet,a))r[i].value=a;else if("integer"===r[i].type&&Number.isInteger(a))r[i].value=a;else if("array"===r[i].type){for(c=0;c<a.length;c+=1)if(n=!0,1===a[c].length&&"number"==typeof a[c][0])u.push(String(a[c]-1));else if(a[c].length>1){for(l=0;l<a[c].length;l+=1)"number"!=typeof a[c][l]&&(n=!1);!0===n&&u.push([a[c][0]-1,a[c][1]-1].join(" "))}r[i].value="["+u.join(" ")+"]"}else r[i].value=r[i].defaultValue;r[i].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){var t,e=[];for(t in r)!0===r[t].explicitSet&&("name"===r[t].type?e.push("/"+t+" /"+r[t].value):e.push("/"+t+" "+r[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")})),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=r,this},
/** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){var e=function(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),r=unescape(encodeURIComponent(t)),n=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=r.length+n.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+r+n+i+a),this.internal.write("endstream"),this.internal.write("endobj")},r=function(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R")};t.addMetadata=function(t,n){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:n||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",r),this.internal.events.subscribe("postPutResources",e)),this}}(O.API),function(t){var e=t.API,r=e.pdfEscape16=function(t,e){for(var r,n=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(r=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(r),e.metadata.toUnicode[r]=t.charCodeAt(o),-1==n.indexOf(r)&&(n.push(r),n.push([parseInt(e.metadata.widthOfGlyph(r),10)])),"0"==r)return a.join("");r=r.toString(16),a.push(i[4-r.length],r)}return a.join("")},n=function(t){var e,r,n,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",n=[],o=0,s=(r=Object.keys(t).sort((function(t,e){return t-e}))).length;o<s;o++)e=r[o],n.length>=100&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar",n=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),n.push("<"+e+"><"+i+">"));return n.length&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream,s=e.pdfEscapeWithNeededParanthesis;if(r.metadata instanceof t.API.TTFFont&&"Identity-H"===r.encoding){for(var u=r.metadata.Unicode.widths,c=r.metadata.subset.encode(r.metadata.glyIdsUsed,1),l="",h=0;h<c.length;h++)l+=String.fromCharCode(c[h]);var f=a();o({data:l,addLength1:!0,objectId:f}),i("endobj");var d=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:d}),i("endobj");var p=a();i("<<"),i("/Type /FontDescriptor"),i("/FontName /"+s(r.fontName)),i("/FontFile2 "+f+" 0 R"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/Flags "+r.metadata.flags),i("/StemV "+r.metadata.stemV),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i(">>"),i("endobj");var g=a();i("<<"),i("/Type /Font"),i("/BaseFont /"+s(r.fontName)),i("/FontDescriptor "+p+" 0 R"),i("/W "+t.API.PDFObject.convert(u)),i("/CIDToGIDMap /Identity"),i("/DW 1000"),i("/Subtype /CIDFontType2"),i("/CIDSystemInfo"),i("<<"),i("/Supplement 0"),i("/Registry (Adobe)"),i("/Ordering ("+r.encoding+")"),i(">>"),i(">>"),i("endobj"),r.objectNumber=a(),i("<<"),i("/Type /Font"),i("/Subtype /Type0"),i("/ToUnicode "+d+" 0 R"),i("/BaseFont /"+s(r.fontName)),i("/Encoding /"+r.encoding),i("/DescendantFonts ["+g+" 0 R]"),i(">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream,s=e.pdfEscapeWithNeededParanthesis;if(r.metadata instanceof t.API.TTFFont&&"WinAnsiEncoding"===r.encoding){for(var u=r.metadata.rawData,c="",l=0;l<u.length;l++)c+=String.fromCharCode(u[l]);var h=a();o({data:c,addLength1:!0,objectId:h}),i("endobj");var f=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:f}),i("endobj");var d=a();i("<<"),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i("/StemV "+r.metadata.stemV),i("/Type /FontDescriptor"),i("/FontFile2 "+h+" 0 R"),i("/Flags 96"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/FontName /"+s(r.fontName)),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i(">>"),i("endobj"),r.objectNumber=a();for(var p=0;p<r.metadata.hmtx.widths.length;p++)r.metadata.hmtx.widths[p]=parseInt(r.metadata.hmtx.widths[p]*(1e3/r.metadata.head.unitsPerEm));i("<</Subtype/TrueType/Type/Font/ToUnicode "+f+" 0 R/BaseFont/"+s(r.fontName)+"/FontDescriptor "+d+" 0 R/Encoding/"+r.encoding+" /FirstChar 29 /LastChar 255 /Widths "+t.API.PDFObject.convert(r.metadata.hmtx.widths)+">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);var i=function(t){var e,n=t.text||"",i=t.x,a=t.y,o=t.options||{},s=t.mutex||{},u=s.pdfEscape,c=s.activeFontKey,l=s.fonts,h=c,f="",d=0,p="",g=l[h].encoding;if("Identity-H"!==l[h].encoding)return{text:n,x:i,y:a,options:o,mutex:s};for(p=n,h=c,Array.isArray(n)&&(p=n[0]),d=0;d<p.length;d+=1)l[h].metadata.hasOwnProperty("cmap")&&(e=l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),e||p[d].charCodeAt(0)<256&&l[h].metadata.hasOwnProperty("Unicode")?f+=p[d]:f+="";var m="";return parseInt(h.slice(1))<14||"WinAnsiEncoding"===g?m=u(f,h).split("").map((function(t){return t.charCodeAt(0).toString(16)})).join(""):"Identity-H"===g&&(m=r(f,l[h])),s.isHex=!0,{text:m,x:i,y:a,options:o,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",r=[],n={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var a=0;for(a=0;a<e.length;a+=1)Array.isArray(e[a])&&3===e[a].length?r.push([i(Object.assign({},n,{text:e[a][0]})).text,e[a][1],e[a][2]]):r.push(i(Object.assign({},n,{text:e[a]})).text);t.text=r}else t.text=i(Object.assign({},n,{text:e})).text}])}(O),
/**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0};t.existsFileInVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]},t.addFileToVFS=function(t,r){return e.call(this),this.internal.vFS[t]=r,this},t.getFileFromVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null}}(O.API),
/**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var r,n,i,a,o,s,u,c=e,l=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],h=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],f={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},d={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},p=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],g=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),m=!1,v=0;this.__bidiEngine__={};var b=function(t){var e=t.charCodeAt(),r=e>>8,n=d[r];return void 0!==n?c[256*n+(255&e)]:252===r||253===r?"AL":g.test(r)?"L":8===r?"R":"N"},y=function(t){for(var e,r=0;r<t.length;r++){if("L"===(e=b(t.charAt(r))))return!1;if("R"===e)return!0}return!1},w=function(t,e,o,s){var u,c,l,h,f=e[s];switch(f){case"L":case"R":m=!1;break;case"N":case"AN":break;case"EN":m&&(f="AN");break;case"AL":m=!0,f="R";break;case"WS":f="N";break;case"CS":s<1||s+1>=e.length||"EN"!==(u=o[s-1])&&"AN"!==u||"EN"!==(c=e[s+1])&&"AN"!==c?f="N":m&&(c="AN"),f=c===u?c:"N";break;case"ES":f="EN"===(u=s>0?o[s-1]:"B")&&s+1<e.length&&"EN"===e[s+1]?"EN":"N";break;case"ET":if(s>0&&"EN"===o[s-1]){f="EN";break}if(m){f="N";break}for(l=s+1,h=e.length;l<h&&"ET"===e[l];)l++;f=l<h&&"EN"===e[l]?"EN":"N";break;case"NSM":if(i&&!a){for(h=e.length,l=s+1;l<h&&"NSM"===e[l];)l++;if(l<h){var d=t[s],p=d>=1425&&d<=2303||64286===d;if(u=e[l],p&&("R"===u||"AL"===u)){f="R";break}}}f=s<1||"B"===(u=e[s-1])?"N":o[s-1];break;case"B":m=!1,r=!0,f=v;break;case"S":n=!0,f="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":m=!1;break;case"BN":f="N"}return f},N=function(t,e,r){var n=t.split("");return r&&L(n,r,{hiLevel:v}),n.reverse(),e&&e.reverse(),n.join("")},L=function(t,e,i){var a,o,s,u,c,d=-1,p=t.length,g=0,y=[],N=v?h:l,L=[];for(m=!1,r=!1,n=!1,o=0;o<p;o++)L[o]=b(t[o]);for(s=0;s<p;s++){if(c=g,y[s]=w(t,L,y,s),a=240&(g=N[c][f[y[s]]]),g&=15,e[s]=u=N[g][5],a>0)if(16===a){for(o=d;o<s;o++)e[o]=1;d=-1}else d=-1;if(N[g][6])-1===d&&(d=s);else if(d>-1){for(o=d;o<s;o++)e[o]=u;d=-1}"B"===L[s]&&(e[s]=0),i.hiLevel|=u}n&&function(t,e,r){for(var n=0;n<r;n++)if("S"===t[n]){e[n]=v;for(var i=n-1;i>=0&&"WS"===t[i];i--)e[i]=v}}(L,e,p)},A=function(t,e,n,i,a){if(!(a.hiLevel<t)){if(1===t&&1===v&&!r)return e.reverse(),void(n&&n.reverse());for(var o,s,u,c,l=e.length,h=0;h<l;){if(i[h]>=t){for(u=h+1;u<l&&i[u]>=t;)u++;for(c=h,s=u-1;c<s;c++,s--)o=e[c],e[c]=e[s],e[s]=o,n&&(o=n[c],n[c]=n[s],n[s]=o);h=u}h++}}},x=function(t,e,r){var n=t.split(""),i={hiLevel:v};return r||(r=[]),L(n,r,i),function(t,e,r){if(0!==r.hiLevel&&u)for(var n,i=0;i<t.length;i++)1===e[i]&&(n=p.indexOf(t[i]))>=0&&(t[i]=p[n+1])}(n,r,i),A(2,n,e,r,i),A(1,n,e,r,i),n.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,r){if(function(t,e){if(e)for(var r=0;r<t.length;r++)e[r]=r;void 0===a&&(a=y(t)),void 0===s&&(s=y(t))}(t,e),i||!o||s)if(i&&o&&a^s)v=a?1:0,t=N(t,e,r);else if(!i&&o&&s)v=a?1:0,t=x(t,e,r),t=N(t,e);else if(!i||a||o||s){if(i&&!o&&a^s)t=N(t,e),a?(v=0,t=x(t,e,r)):(v=1,t=x(t,e,r),t=N(t,e));else if(i&&a&&!o&&s)v=1,t=x(t,e,r),t=N(t,e);else if(!i&&!o&&a^s){var n=u;a?(v=1,t=x(t,e,r),v=0,u=!1,t=x(t,e,r),u=n):(v=0,t=x(t,e,r),t=N(t,e),v=1,u=!1,t=x(t,e,r),u=n,t=N(t,e))}}else v=0,t=x(t,e,r);else v=a?1:0,t=x(t,e,r);return t},this.__bidiEngine__.setOptions=function(t){t&&(i=t.isInputVisual,o=t.isOutputVisual,a=t.isInputRtl,s=t.isOutputRtl,u=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],r=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),i=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,r.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var a=0;for(i=[],a=0;a<e.length;a+=1)"[object Array]"===Object.prototype.toString.call(e[a])?i.push([r.doBidiReorder(e[a][0]),e[a][1],e[a][2]]):i.push([r.doBidiReorder(e[a])]);t.text=i}else t.text=r.doBidiReorder(e);r.setOptions({isInputVisual:!0})}])}(O),O.API.TTFFont=function(){function t(t){var e;if(this.rawData=t,e=this.contents=new te(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new ye(this),this.registerTTF()}return t.open=function(e){return new t(e)},t.prototype.parse=function(){return this.directory=new ee(this.contents),this.head=new ie(this),this.name=new he(this),this.cmap=new oe(this),this.toUnicode={},this.hhea=new se(this),this.maxp=new fe(this),this.hmtx=new de(this),this.post=new ce(this),this.os2=new ue(this),this.loca=new be(this),this.glyf=new ge(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},t.prototype.registerTTF=function(){var t,e,r,n,i;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var e,r,n,i;for(i=[],e=0,r=(n=this.bbox).length;e<r;e++)t=n[e],i.push(Math.round(t*this.scaleFactor));return i}.call(this),this.stemV=0,this.post.exists?(r=255&(n=this.post.italic_angle),0!=(32768&(e=n>>16))&&(e=-(1+(65535^e))),this.italicAngle=+(e+"."+r)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(i=this.familyClass)||2===i||3===i||4===i||5===i||7===i,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},t.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},t.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},t.prototype.widthOfString=function(t,e,r){var n,i,a,o;for(a=0,i=0,o=(t=""+t).length;0<=o?i<o:i>o;i=0<=o?++i:--i)n=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(n))+r*(1e3/e)||0;return a*(e/1e3)},t.prototype.lineHeight=function(t,e){var r;return null==e&&(e=!1),r=e?this.lineGap:0,(this.ascender+r-this.decender)/1e3*t},t}();var Qt,te=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return(t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return(t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;e=0<=t?++e:--e)r[e]=String.fromCharCode(this.readByte());return r.join("")},t.prototype.writeString=function(t){var e,r,n;for(n=[],e=0,r=t.length;0<=r?e<r:e>r;e=0<=r?++e:--e)n.push(this.writeByte(t.charCodeAt(e)));return n},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,r,n,i,a,o,s;return t=this.readByte(),e=this.readByte(),r=this.readByte(),n=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^r)+4294967296*(255^n)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*r+4294967296*n+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,r;return e=Math.floor(t/4294967296),r=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(r>>24&255),this.writeByte(r>>16&255),this.writeByte(r>>8&255),this.writeByte(255&r)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,r;for(e=[],r=0;0<=t?r<t:r>t;r=0<=t?++r:--r)e.push(this.readByte());return e},t.prototype.write=function(t){var e,r,n,i;for(i=[],r=0,n=t.length;r<n;r++)e=t[r],i.push(this.writeByte(e));return i},t}(),ee=function(){var t;function e(t){var e,r,n;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},r=0,n=this.tableCount;0<=n?r<n:r>n;r=0<=n?++r:--r)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return e.prototype.encode=function(e){var r,n,i,a,o,s,u,c,l,h,f,d,p;for(p in f=Object.keys(e).length,s=Math.log(2),l=16*Math.floor(Math.log(f)/s),a=Math.floor(l/s),c=16*f-l,(n=new te).writeInt(this.scalarType),n.writeShort(f),n.writeShort(l),n.writeShort(a),n.writeShort(c),i=16*f,u=n.pos+i,o=null,d=[],e)for(h=e[p],n.writeString(p),n.writeInt(t(h)),n.writeInt(u),n.writeInt(h.length),d=d.concat(h),"head"===p&&(o=u),u+=h.length;u%4;)d.push(0),u++;return n.write(d),r=2981146554-t(n.data),n.pos=o+8,n.writeUInt32(r),n.data},t=function(t){var e,r,n,i;for(t=pe.call(t);t.length%4;)t.push(0);for(n=new te(t),r=0,e=0,i=t.length;e<i;e=e+=4)r+=n.readUInt32();return 4294967295&r},e}(),re={}.hasOwnProperty,ne=function(t,e){for(var r in e)re.call(e,r)&&(t[r]=e[r]);function n(){this.constructor=t}return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t};Qt=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var ie=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new te).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),ae=function(){function t(t,e){var r,n,i,a,o,s,u,c,l,h,f,d,p,g,m,v,b;switch(this.platformID=t.readUInt16(),this.encodingID=t.readShort(),this.offset=e+t.readInt(),l=t.pos,t.pos=this.offset,this.format=t.readUInt16(),this.length=t.readUInt16(),this.language=t.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=t.readByte();break;case 4:for(f=t.readUInt16(),h=f/2,t.pos+=6,i=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),t.pos+=2,p=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),u=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),c=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),n=(this.length-t.pos+this.offset)/2,o=function(){var e,r;for(r=[],s=e=0;0<=n?e<n:e>n;s=0<=n?++e:--e)r.push(t.readUInt16());return r}(),s=m=0,b=i.length;m<b;s=++m)for(g=i[s],r=v=d=p[s];d<=g?v<=g:v>=g;r=d<=g?++v:--v)0===c[s]?a=r+u[s]:0!==(a=o[c[s]/2+(r-d)-(h-s)]||0)&&(a+=u[s]),this.codeMap[r]=65535&a}t.pos=l}return t.encode=function(t,e){var r,n,i,a,o,s,u,c,l,h,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F,C,j,O,B,M,E,q,R,T,D,U,z,H,V,W,G,Y;switch(I=new te,a=Object.keys(t).sort((function(t,e){return t-e})),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),v={0:0},i={},F=0,B=a.length;F<B;F++)null==v[V=t[n=a[F]]]&&(v[V]=++p),i[n]={old:t[n],new:v[t[n]]},g[n]=v[t[n]];return I.writeUInt16(1),I.writeUInt16(0),I.writeUInt32(12),I.writeUInt16(0),I.writeUInt16(262),I.writeUInt16(0),I.write(g),{charMap:i,subtable:I.data,maxGlyphID:p+1};case"unicode":for(P=[],l=[],b=0,v={},r={},m=u=null,C=0,M=a.length;C<M;C++)null==v[w=t[n=a[C]]]&&(v[w]=++b),r[n]={old:w,new:v[w]},o=v[w]-n,null!=m&&o===u||(m&&l.push(m),P.push(n),u=o),m=n;for(m&&l.push(m),l.push(65535),P.push(65535),S=2*(x=P.length),A=2*Math.pow(Math.log(x)/Math.LN2,2),h=Math.log(A/2)/Math.LN2,L=2*x-A,s=[],N=[],f=[],d=j=0,E=P.length;j<E;d=++j){if(_=P[d],c=l[d],65535===_){s.push(0),N.push(0);break}if(_-(k=r[_].new)>=32768)for(s.push(0),N.push(2*(f.length+x-d)),n=O=_;_<=c?O<=c:O>=c;n=_<=c?++O:--O)f.push(r[n].new);else s.push(k-_),N.push(0)}for(I.writeUInt16(3),I.writeUInt16(1),I.writeUInt32(12),I.writeUInt16(4),I.writeUInt16(16+8*x+2*f.length),I.writeUInt16(0),I.writeUInt16(S),I.writeUInt16(A),I.writeUInt16(h),I.writeUInt16(L),z=0,q=l.length;z<q;z++)n=l[z],I.writeUInt16(n);for(I.writeUInt16(0),H=0,R=P.length;H<R;H++)n=P[H],I.writeUInt16(n);for(W=0,T=s.length;W<T;W++)o=s[W],I.writeUInt16(o);for(G=0,D=N.length;G<D;G++)y=N[G],I.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],I.writeUInt16(p);return{charMap:r,subtable:I.data,maxGlyphID:b+1}}},t}(),oe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,r,n;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:r>n;r=0<=n?++r:--r)e=new ae(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var r,n;return null==e&&(e="macroman"),r=ae.encode(t,e),(n=new te).writeUInt16(0),n.writeUInt16(1),r.table=n.data.concat(r.subtable),r},e}(),se=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),ue=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="OS/2",e.prototype.parse=function(t){if(t.pos=this.offset,this.version=t.readUInt16(),this.averageCharWidth=t.readShort(),this.weightClass=t.readUInt16(),this.widthClass=t.readUInt16(),this.type=t.readShort(),this.ySubscriptXSize=t.readShort(),this.ySubscriptYSize=t.readShort(),this.ySubscriptXOffset=t.readShort(),this.ySubscriptYOffset=t.readShort(),this.ySuperscriptXSize=t.readShort(),this.ySuperscriptYSize=t.readShort(),this.ySuperscriptXOffset=t.readShort(),this.ySuperscriptYOffset=t.readShort(),this.yStrikeoutSize=t.readShort(),this.yStrikeoutPosition=t.readShort(),this.familyClass=t.readShort(),this.panose=function(){var e,r;for(r=[],e=0;e<10;++e)r.push(t.readByte());return r}(),this.charRange=function(){var e,r;for(r=[],e=0;e<4;++e)r.push(t.readInt());return r}(),this.vendorID=t.readString(4),this.selection=t.readShort(),this.firstCharIndex=t.readShort(),this.lastCharIndex=t.readShort(),this.version>0&&(this.ascent=t.readShort(),this.descent=t.readShort(),this.lineGap=t.readShort(),this.winAscent=t.readShort(),this.winDescent=t.readShort(),this.codePageRange=function(){var e,r;for(r=[],e=0;e<2;e=++e)r.push(t.readInt());return r}(),this.version>1))return this.xHeight=t.readShort(),this.capHeight=t.readShort(),this.defaultChar=t.readShort(),this.breakChar=t.readShort(),this.maxContext=t.readShort()},e}(),ce=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="post",e.prototype.parse=function(t){var e,r,n;switch(t.pos=this.offset,this.format=t.readInt(),this.italicAngle=t.readInt(),this.underlinePosition=t.readShort(),this.underlineThickness=t.readShort(),this.isFixedPitch=t.readInt(),this.minMemType42=t.readInt(),this.maxMemType42=t.readInt(),this.minMemType1=t.readInt(),this.maxMemType1=t.readInt(),this.format){case 65536:break;case 131072:var i;for(r=t.readUInt16(),this.glyphNameIndex=[],i=0;0<=r?i<r:i>r;i=0<=r?++i:--i)this.glyphNameIndex.push(t.readUInt16());for(this.names=[],n=[];t.pos<this.offset+this.length;)e=t.readByte(),n.push(this.names.push(t.readString(e)));return n;case 151552:return r=t.readUInt16(),this.offsets=t.read(r);case 196608:break;case 262144:return this.map=function(){var e,r,n;for(n=[],i=e=0,r=this.file.maxp.numGlyphs;0<=r?e<r:e>r;i=0<=r?++e:--e)n.push(t.readUInt32());return n}.call(this)}},e}(),le=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},he=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="name",e.prototype.parse=function(t){var e,r,n,i,a,o,s,u,c,l,h;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),r=[],i=0;0<=e?i<e:i>e;i=0<=e?++i:--i)r.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=c=0,l=r.length;c<l;i=++c)n=r[i],t.pos=n.offset,u=t.readString(n.length),a=new le(u,n),null==s[h=n.nameID]&&(s[h]=[]),s[n.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),fe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),de=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="hmtx",e.prototype.parse=function(t){var e,r,n,i,a,o,s;for(t.pos=this.offset,this.metrics=[],e=0,o=this.file.hhea.numberOfMetrics;0<=o?e<o:e>o;e=0<=o?++e:--e)this.metrics.push({advance:t.readUInt16(),lsb:t.readInt16()});for(n=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var r,i;for(i=[],e=r=0;0<=n?r<n:r>n;e=0<=n?++r:--r)i.push(t.readInt16());return i}(),this.widths=function(){var t,e,r,n;for(n=[],t=0,e=(r=this.metrics).length;t<e;t++)i=r[t],n.push(i.advance);return n}.call(this),r=this.widths[this.widths.length-1],s=[],e=a=0;0<=n?a<n:a>n;e=0<=n?++a:--a)s.push(this.widths.push(r));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),pe=[].slice,ge=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="glyf",e.prototype.parse=function(){return this.cache={}},e.prototype.glyphFor=function(t){var e,r,n,i,a,o,s,u,c,l;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,r=i.indexOf(t),0===(n=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+r,a=(o=new te(e.read(n))).readShort(),u=o.readShort(),l=o.readShort(),s=o.readShort(),c=o.readShort(),this.cache[t]=-1===a?new ve(o,u,l,s,c):new me(o,a,u,l,s,c),this.cache[t]))},e.prototype.encode=function(t,e,r){var n,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)n=t[e[o]],i.push(a.length),n&&(a=a.concat(n.encode(r)));return i.push(a.length),{table:a,offsets:i}},e}(),me=function(){function t(t,e,r,n,i,a){this.raw=t,this.numberOfContours=e,this.xMin=r,this.yMin=n,this.xMax=i,this.yMax=a,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),ve=function(){function t(t,e,r,n,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=r,this.xMax=n,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readUInt16()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(){var t,e,r;for(e=new te(pe.call(this.raw.data)),t=0,r=this.glyphIDs.length;t<r;++t)e.pos=this.glyphOffsets[t];return e.data},t}(),be=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return ne(e,Qt),e.prototype.tag="loca",e.prototype.parse=function(t){var e,r;return t.pos=this.offset,e=this.file.head.indexToLocFormat,this.offsets=0===e?function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=2)n.push(2*t.readUInt16());return n}.call(this):function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=4)n.push(t.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var r=new Uint32Array(this.offsets.length),n=0,i=0,a=0;a<r.length;++a)if(r[a]=n,i<e.length&&e[i]==a){++i,r[a]=n;var o=this.offsets[a],s=this.offsets[a+1]-o;s>0&&(n+=s)}for(var u=new Array(4*r.length),c=0;c<r.length;++c)u[4*c+3]=255&r[c],u[4*c+2]=(65280&r[c])>>8,u[4*c+1]=(16711680&r[c])>>16,u[4*c]=(4278190080&r[c])>>24;return u},e}(),ye=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,r,n,i;for(e in n=this.font.cmap.tables[0].codeMap,t={},i=this.subset)r=i[e],t[e]=n[r];return t},t.prototype.glyphsFor=function(t){var e,r,n,i,a,o,s;for(n={},a=0,o=t.length;a<o;a++)n[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],n)(null!=(r=n[i])?r.compound:void 0)&&e.push.apply(e,r.glyphIDs);if(e.length>0)for(i in s=this.glyphsFor(e))r=s[i],n[i]=r;return n},t.prototype.encode=function(t,e){var r,n,i,a,o,s,u,c,l,h,f,d,p,g,m;for(n in r=oe.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=r.charMap)f[(s=m[n]).old]=s.new;for(d in h=r.maxGlyphID,a)d in f||(f[d]=h++);return c=function(t){var e,r;for(e in r={},t)r[t[e]]=e;return r}(f),l=Object.keys(c).sort((function(t,e){return t-e})),p=function(){var t,e,r;for(r=[],t=0,e=l.length;t<e;t++)o=l[t],r.push(c[o]);return r}(),i=this.font.glyf.encode(a,p,f),u=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:u,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();O.API.PDFObject=function(){var t;function e(){}return t=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},e.convert=function(r){var n,i,a,o;if(Array.isArray(r))return"["+function(){var t,i,a;for(a=[],t=0,i=r.length;t<i;t++)n=r[t],a.push(e.convert(n));return a}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+t(r.getUTCFullYear(),4)+t(r.getUTCMonth(),2)+t(r.getUTCDate(),2)+t(r.getUTCHours(),2)+t(r.getUTCMinutes(),2)+t(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(i in a=["<<"],r)o=r[i],a.push("/"+i+" "+e.convert(o));return a.push(">>"),a.join("\n")}return""+r},e}();/* harmony default export */ __webpack_exports__["default"] = (O);



/***/ }),

/***/ "./node_modules/performance-now/lib/performance-now.js":
/*!*************************************************************!*\
  !*** ./node_modules/performance-now/lib/performance-now.js ***!
  \*************************************************************/
/***/ (function(module) {

// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);




/***/ }),

/***/ "./node_modules/raf/index.js":
/*!***********************************!*\
  !*** ./node_modules/raf/index.js ***!
  \***********************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var now = __webpack_require__(/*! performance-now */ "./node_modules/performance-now/lib/performance-now.js")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/rgbcolor/index.js":
/*!****************************************!*\
  !*** ./node_modules/rgbcolor/index.js ***!
  \****************************************/
/***/ (function(module) {

/*
	Based on rgbcolor.js by Stoyan Stefanov <sstoo@gmail.com>
	http://www.phpied.com/rgb-color-parser-in-javascript/
*/

module.exports = function(color_string) {
    this.ok = false;
    this.alpha = 1.0;

    // strip any leading #
    if (color_string.charAt(0) == '#') { // remove # if any
        color_string = color_string.substr(1,6);
    }

    color_string = color_string.replace(/ /g,'');
    color_string = color_string.toLowerCase();

    // before getting into regexps, try simple matches
    // and overwrite the input
    var simple_colors = {
        aliceblue: 'f0f8ff',
        antiquewhite: 'faebd7',
        aqua: '00ffff',
        aquamarine: '7fffd4',
        azure: 'f0ffff',
        beige: 'f5f5dc',
        bisque: 'ffe4c4',
        black: '000000',
        blanchedalmond: 'ffebcd',
        blue: '0000ff',
        blueviolet: '8a2be2',
        brown: 'a52a2a',
        burlywood: 'deb887',
        cadetblue: '5f9ea0',
        chartreuse: '7fff00',
        chocolate: 'd2691e',
        coral: 'ff7f50',
        cornflowerblue: '6495ed',
        cornsilk: 'fff8dc',
        crimson: 'dc143c',
        cyan: '00ffff',
        darkblue: '00008b',
        darkcyan: '008b8b',
        darkgoldenrod: 'b8860b',
        darkgray: 'a9a9a9',
        darkgreen: '006400',
        darkkhaki: 'bdb76b',
        darkmagenta: '8b008b',
        darkolivegreen: '556b2f',
        darkorange: 'ff8c00',
        darkorchid: '9932cc',
        darkred: '8b0000',
        darksalmon: 'e9967a',
        darkseagreen: '8fbc8f',
        darkslateblue: '483d8b',
        darkslategray: '2f4f4f',
        darkturquoise: '00ced1',
        darkviolet: '9400d3',
        deeppink: 'ff1493',
        deepskyblue: '00bfff',
        dimgray: '696969',
        dodgerblue: '1e90ff',
        feldspar: 'd19275',
        firebrick: 'b22222',
        floralwhite: 'fffaf0',
        forestgreen: '228b22',
        fuchsia: 'ff00ff',
        gainsboro: 'dcdcdc',
        ghostwhite: 'f8f8ff',
        gold: 'ffd700',
        goldenrod: 'daa520',
        gray: '808080',
        green: '008000',
        greenyellow: 'adff2f',
        honeydew: 'f0fff0',
        hotpink: 'ff69b4',
        indianred : 'cd5c5c',
        indigo : '4b0082',
        ivory: 'fffff0',
        khaki: 'f0e68c',
        lavender: 'e6e6fa',
        lavenderblush: 'fff0f5',
        lawngreen: '7cfc00',
        lemonchiffon: 'fffacd',
        lightblue: 'add8e6',
        lightcoral: 'f08080',
        lightcyan: 'e0ffff',
        lightgoldenrodyellow: 'fafad2',
        lightgrey: 'd3d3d3',
        lightgreen: '90ee90',
        lightpink: 'ffb6c1',
        lightsalmon: 'ffa07a',
        lightseagreen: '20b2aa',
        lightskyblue: '87cefa',
        lightslateblue: '8470ff',
        lightslategray: '778899',
        lightsteelblue: 'b0c4de',
        lightyellow: 'ffffe0',
        lime: '00ff00',
        limegreen: '32cd32',
        linen: 'faf0e6',
        magenta: 'ff00ff',
        maroon: '800000',
        mediumaquamarine: '66cdaa',
        mediumblue: '0000cd',
        mediumorchid: 'ba55d3',
        mediumpurple: '9370d8',
        mediumseagreen: '3cb371',
        mediumslateblue: '7b68ee',
        mediumspringgreen: '00fa9a',
        mediumturquoise: '48d1cc',
        mediumvioletred: 'c71585',
        midnightblue: '191970',
        mintcream: 'f5fffa',
        mistyrose: 'ffe4e1',
        moccasin: 'ffe4b5',
        navajowhite: 'ffdead',
        navy: '000080',
        oldlace: 'fdf5e6',
        olive: '808000',
        olivedrab: '6b8e23',
        orange: 'ffa500',
        orangered: 'ff4500',
        orchid: 'da70d6',
        palegoldenrod: 'eee8aa',
        palegreen: '98fb98',
        paleturquoise: 'afeeee',
        palevioletred: 'd87093',
        papayawhip: 'ffefd5',
        peachpuff: 'ffdab9',
        peru: 'cd853f',
        pink: 'ffc0cb',
        plum: 'dda0dd',
        powderblue: 'b0e0e6',
        purple: '800080',
        rebeccapurple: '663399',
        red: 'ff0000',
        rosybrown: 'bc8f8f',
        royalblue: '4169e1',
        saddlebrown: '8b4513',
        salmon: 'fa8072',
        sandybrown: 'f4a460',
        seagreen: '2e8b57',
        seashell: 'fff5ee',
        sienna: 'a0522d',
        silver: 'c0c0c0',
        skyblue: '87ceeb',
        slateblue: '6a5acd',
        slategray: '708090',
        snow: 'fffafa',
        springgreen: '00ff7f',
        steelblue: '4682b4',
        tan: 'd2b48c',
        teal: '008080',
        thistle: 'd8bfd8',
        tomato: 'ff6347',
        turquoise: '40e0d0',
        violet: 'ee82ee',
        violetred: 'd02090',
        wheat: 'f5deb3',
        white: 'ffffff',
        whitesmoke: 'f5f5f5',
        yellow: 'ffff00',
        yellowgreen: '9acd32'
    };
    color_string = simple_colors[color_string] || color_string;
    // emd of simple type-in colors

    // array of color definition objects
    var color_defs = [
        {
            re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
            example: ['rgba(123, 234, 45, 0.8)', 'rgba(255,234,245,1.0)'],
            process: function (bits){
                return [
                    parseInt(bits[1]),
                    parseInt(bits[2]),
                    parseInt(bits[3]),
                    parseFloat(bits[4])
                ];
            }
        },
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: ['rgb(123, 234, 45)', 'rgb(255,234,245)'],
            process: function (bits){
                return [
                    parseInt(bits[1]),
                    parseInt(bits[2]),
                    parseInt(bits[3])
                ];
            }
        },
        {
            re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            example: ['#00ff00', '336699'],
            process: function (bits){
                return [
                    parseInt(bits[1], 16),
                    parseInt(bits[2], 16),
                    parseInt(bits[3], 16)
                ];
            }
        },
        {
            re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            example: ['#fb0', 'f0f'],
            process: function (bits){
                return [
                    parseInt(bits[1] + bits[1], 16),
                    parseInt(bits[2] + bits[2], 16),
                    parseInt(bits[3] + bits[3], 16)
                ];
            }
        }
    ];

    // search through the definitions to find a match
    for (var i = 0; i < color_defs.length; i++) {
        var re = color_defs[i].re;
        var processor = color_defs[i].process;
        var bits = re.exec(color_string);
        if (bits) {
            var channels = processor(bits);
            this.r = channels[0];
            this.g = channels[1];
            this.b = channels[2];
            if (channels.length > 3) {
                this.alpha = channels[3];
            }
            this.ok = true;
        }

    }

    // validate/cleanup values
    this.r = (this.r < 0 || isNaN(this.r)) ? 0 : ((this.r > 255) ? 255 : this.r);
    this.g = (this.g < 0 || isNaN(this.g)) ? 0 : ((this.g > 255) ? 255 : this.g);
    this.b = (this.b < 0 || isNaN(this.b)) ? 0 : ((this.b > 255) ? 255 : this.b);
    this.alpha = (this.alpha < 0) ? 0 : ((this.alpha > 1.0 || isNaN(this.alpha)) ? 1.0 : this.alpha);

    // some getters
    this.toRGB = function () {
        return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
    }
    this.toRGBA = function () {
        return 'rgba(' + this.r + ', ' + this.g + ', ' + this.b + ', ' + this.alpha + ')';
    }
    this.toHex = function () {
        var r = this.r.toString(16);
        var g = this.g.toString(16);
        var b = this.b.toString(16);
        if (r.length == 1) r = '0' + r;
        if (g.length == 1) g = '0' + g;
        if (b.length == 1) b = '0' + b;
        return '#' + r + g + b;
    }

    // help
    this.getHelpXML = function () {

        var examples = new Array();
        // add regexps
        for (var i = 0; i < color_defs.length; i++) {
            var example = color_defs[i].example;
            for (var j = 0; j < example.length; j++) {
                examples[examples.length] = example[j];
            }
        }
        // add type-in colors
        for (var sc in simple_colors) {
            examples[examples.length] = sc;
        }

        var xml = document.createElement('ul');
        xml.setAttribute('id', 'rgbcolor-examples');
        for (var i = 0; i < examples.length; i++) {
            try {
                var list_item = document.createElement('li');
                var list_color = new RGBColor(examples[i]);
                var example_div = document.createElement('div');
                example_div.style.cssText =
                        'margin: 3px; '
                        + 'border: 1px solid black; '
                        + 'background:' + list_color.toHex() + '; '
                        + 'color:' + list_color.toHex()
                ;
                example_div.appendChild(document.createTextNode('test'));
                var list_item_value = document.createTextNode(
                    ' ' + examples[i] + ' -> ' + list_color.toRGB() + ' -> ' + list_color.toHex()
                );
                list_item.appendChild(example_div);
                list_item.appendChild(list_item_value);
                xml.appendChild(list_item);

            } catch(e){}
        }
        return xml;

    }

}


/***/ }),

/***/ "./node_modules/stackblur-canvas/dist/stackblur-es.js":
/*!************************************************************!*\
  !*** ./node_modules/stackblur-canvas/dist/stackblur-es.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlurStack": function() { return /* binding */ BlurStack; },
/* harmony export */   "canvasRGB": function() { return /* binding */ processCanvasRGB; },
/* harmony export */   "canvasRGBA": function() { return /* binding */ processCanvasRGBA; },
/* harmony export */   "image": function() { return /* binding */ processImage; },
/* harmony export */   "imageDataRGB": function() { return /* binding */ processImageDataRGB; },
/* harmony export */   "imageDataRGBA": function() { return /* binding */ processImageDataRGBA; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/* eslint-disable no-bitwise -- used for calculations */

/* eslint-disable unicorn/prefer-query-selector -- aiming at
  backward-compatibility */

/**
* StackBlur - a fast almost Gaussian Blur For Canvas
*
* In case you find this class useful - especially in commercial projects -
* I am not totally unhappy for a small donation to my PayPal account
* mario@quasimondo.de
*
* Or support me on flattr:
* {@link https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript}.
*
* @module StackBlur
* @author Mario Klingemann
* Contact: mario@quasimondo.com
* Website: {@link http://www.quasimondo.com/StackBlurForCanvas/StackBlurDemo.html}
* Twitter: @quasimondo
*
* @copyright (c) 2010 Mario Klingemann
*
* Permission is hereby granted, free of charge, to any person
* obtaining a copy of this software and associated documentation
* files (the "Software"), to deal in the Software without
* restriction, including without limitation the rights to use,
* copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the
* Software is furnished to do so, subject to the following
* conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
* OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
* HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
* FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
* OTHER DEALINGS IN THE SOFTWARE.
*/
var mulTable = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];
var shgTable = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
/**
 * @param {string|HTMLImageElement} img
 * @param {string|HTMLCanvasElement} canvas
 * @param {Float} radius
 * @param {boolean} blurAlphaChannel
 * @param {boolean} useOffset
 * @param {boolean} skipStyles
 * @returns {undefined}
 */

function processImage(img, canvas, radius, blurAlphaChannel, useOffset, skipStyles) {
  if (typeof img === 'string') {
    img = document.getElementById(img);
  }

  if (!img || !('naturalWidth' in img)) {
    return;
  }

  var dimensionType = useOffset ? 'offset' : 'natural';
  var w = img[dimensionType + 'Width'];
  var h = img[dimensionType + 'Height'];

  if (typeof canvas === 'string') {
    canvas = document.getElementById(canvas);
  }

  if (!canvas || !('getContext' in canvas)) {
    return;
  }

  if (!skipStyles) {
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
  }

  canvas.width = w;
  canvas.height = h;
  var context = canvas.getContext('2d');
  context.clearRect(0, 0, w, h);
  context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, w, h);

  if (isNaN(radius) || radius < 1) {
    return;
  }

  if (blurAlphaChannel) {
    processCanvasRGBA(canvas, 0, 0, w, h, radius);
  } else {
    processCanvasRGB(canvas, 0, 0, w, h, radius);
  }
}
/**
 * @param {string|HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @throws {Error|TypeError}
 * @returns {ImageData} See {@link https://html.spec.whatwg.org/multipage/canvas.html#imagedata}
 */


function getImageDataFromCanvas(canvas, topX, topY, width, height) {
  if (typeof canvas === 'string') {
    canvas = document.getElementById(canvas);
  }

  if (!canvas || _typeof(canvas) !== 'object' || !('getContext' in canvas)) {
    throw new TypeError('Expecting canvas with `getContext` method ' + 'in processCanvasRGB(A) calls!');
  }

  var context = canvas.getContext('2d');

  try {
    return context.getImageData(topX, topY, width, height);
  } catch (e) {
    throw new Error('unable to access image data: ' + e);
  }
}
/**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */


function processCanvasRGBA(canvas, topX, topY, width, height, radius) {
  if (isNaN(radius) || radius < 1) {
    return;
  }

  radius |= 0;
  var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
  imageData = processImageDataRGBA(imageData, topX, topY, width, height, radius);
  canvas.getContext('2d').putImageData(imageData, topX, topY);
}
/**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */


function processImageDataRGBA(imageData, topX, topY, width, height, radius) {
  var pixels = imageData.data;
  var div = 2 * radius + 1; // const w4 = width << 2;

  var widthMinus1 = width - 1;
  var heightMinus1 = height - 1;
  var radiusPlus1 = radius + 1;
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
  var stackStart = new BlurStack();
  var stack = stackStart;
  var stackEnd;

  for (var i = 1; i < div; i++) {
    stack = stack.next = new BlurStack();

    if (i === radiusPlus1) {
      stackEnd = stack;
    }
  }

  stack.next = stackStart;
  var stackIn = null,
      stackOut = null,
      yw = 0,
      yi = 0;
  var mulSum = mulTable[radius];
  var shgSum = shgTable[radius];

  for (var y = 0; y < height; y++) {
    stack = stackStart;
    var pr = pixels[yi],
        pg = pixels[yi + 1],
        pb = pixels[yi + 2],
        pa = pixels[yi + 3];

    for (var _i = 0; _i < radiusPlus1; _i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack.a = pa;
      stack = stack.next;
    }

    var rInSum = 0,
        gInSum = 0,
        bInSum = 0,
        aInSum = 0,
        rOutSum = radiusPlus1 * pr,
        gOutSum = radiusPlus1 * pg,
        bOutSum = radiusPlus1 * pb,
        aOutSum = radiusPlus1 * pa,
        rSum = sumFactor * pr,
        gSum = sumFactor * pg,
        bSum = sumFactor * pb,
        aSum = sumFactor * pa;

    for (var _i2 = 1; _i2 < radiusPlus1; _i2++) {
      var p = yi + ((widthMinus1 < _i2 ? widthMinus1 : _i2) << 2);
      var r = pixels[p],
          g = pixels[p + 1],
          b = pixels[p + 2],
          a = pixels[p + 3];
      var rbs = radiusPlus1 - _i2;
      rSum += (stack.r = r) * rbs;
      gSum += (stack.g = g) * rbs;
      bSum += (stack.b = b) * rbs;
      aSum += (stack.a = a) * rbs;
      rInSum += r;
      gInSum += g;
      bInSum += b;
      aInSum += a;
      stack = stack.next;
    }

    stackIn = stackStart;
    stackOut = stackEnd;

    for (var x = 0; x < width; x++) {
      var paInitial = aSum * mulSum >> shgSum;
      pixels[yi + 3] = paInitial;

      if (paInitial !== 0) {
        var _a2 = 255 / paInitial;

        pixels[yi] = (rSum * mulSum >> shgSum) * _a2;
        pixels[yi + 1] = (gSum * mulSum >> shgSum) * _a2;
        pixels[yi + 2] = (bSum * mulSum >> shgSum) * _a2;
      } else {
        pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
      }

      rSum -= rOutSum;
      gSum -= gOutSum;
      bSum -= bOutSum;
      aSum -= aOutSum;
      rOutSum -= stackIn.r;
      gOutSum -= stackIn.g;
      bOutSum -= stackIn.b;
      aOutSum -= stackIn.a;

      var _p = x + radius + 1;

      _p = yw + (_p < widthMinus1 ? _p : widthMinus1) << 2;
      rInSum += stackIn.r = pixels[_p];
      gInSum += stackIn.g = pixels[_p + 1];
      bInSum += stackIn.b = pixels[_p + 2];
      aInSum += stackIn.a = pixels[_p + 3];
      rSum += rInSum;
      gSum += gInSum;
      bSum += bInSum;
      aSum += aInSum;
      stackIn = stackIn.next;
      var _stackOut = stackOut,
          _r = _stackOut.r,
          _g = _stackOut.g,
          _b = _stackOut.b,
          _a = _stackOut.a;
      rOutSum += _r;
      gOutSum += _g;
      bOutSum += _b;
      aOutSum += _a;
      rInSum -= _r;
      gInSum -= _g;
      bInSum -= _b;
      aInSum -= _a;
      stackOut = stackOut.next;
      yi += 4;
    }

    yw += width;
  }

  for (var _x = 0; _x < width; _x++) {
    yi = _x << 2;

    var _pr = pixels[yi],
        _pg = pixels[yi + 1],
        _pb = pixels[yi + 2],
        _pa = pixels[yi + 3],
        _rOutSum = radiusPlus1 * _pr,
        _gOutSum = radiusPlus1 * _pg,
        _bOutSum = radiusPlus1 * _pb,
        _aOutSum = radiusPlus1 * _pa,
        _rSum = sumFactor * _pr,
        _gSum = sumFactor * _pg,
        _bSum = sumFactor * _pb,
        _aSum = sumFactor * _pa;

    stack = stackStart;

    for (var _i3 = 0; _i3 < radiusPlus1; _i3++) {
      stack.r = _pr;
      stack.g = _pg;
      stack.b = _pb;
      stack.a = _pa;
      stack = stack.next;
    }

    var yp = width;
    var _gInSum = 0,
        _bInSum = 0,
        _aInSum = 0,
        _rInSum = 0;

    for (var _i4 = 1; _i4 <= radius; _i4++) {
      yi = yp + _x << 2;

      var _rbs = radiusPlus1 - _i4;

      _rSum += (stack.r = _pr = pixels[yi]) * _rbs;
      _gSum += (stack.g = _pg = pixels[yi + 1]) * _rbs;
      _bSum += (stack.b = _pb = pixels[yi + 2]) * _rbs;
      _aSum += (stack.a = _pa = pixels[yi + 3]) * _rbs;
      _rInSum += _pr;
      _gInSum += _pg;
      _bInSum += _pb;
      _aInSum += _pa;
      stack = stack.next;

      if (_i4 < heightMinus1) {
        yp += width;
      }
    }

    yi = _x;
    stackIn = stackStart;
    stackOut = stackEnd;

    for (var _y = 0; _y < height; _y++) {
      var _p2 = yi << 2;

      pixels[_p2 + 3] = _pa = _aSum * mulSum >> shgSum;

      if (_pa > 0) {
        _pa = 255 / _pa;
        pixels[_p2] = (_rSum * mulSum >> shgSum) * _pa;
        pixels[_p2 + 1] = (_gSum * mulSum >> shgSum) * _pa;
        pixels[_p2 + 2] = (_bSum * mulSum >> shgSum) * _pa;
      } else {
        pixels[_p2] = pixels[_p2 + 1] = pixels[_p2 + 2] = 0;
      }

      _rSum -= _rOutSum;
      _gSum -= _gOutSum;
      _bSum -= _bOutSum;
      _aSum -= _aOutSum;
      _rOutSum -= stackIn.r;
      _gOutSum -= stackIn.g;
      _bOutSum -= stackIn.b;
      _aOutSum -= stackIn.a;
      _p2 = _x + ((_p2 = _y + radiusPlus1) < heightMinus1 ? _p2 : heightMinus1) * width << 2;
      _rSum += _rInSum += stackIn.r = pixels[_p2];
      _gSum += _gInSum += stackIn.g = pixels[_p2 + 1];
      _bSum += _bInSum += stackIn.b = pixels[_p2 + 2];
      _aSum += _aInSum += stackIn.a = pixels[_p2 + 3];
      stackIn = stackIn.next;
      _rOutSum += _pr = stackOut.r;
      _gOutSum += _pg = stackOut.g;
      _bOutSum += _pb = stackOut.b;
      _aOutSum += _pa = stackOut.a;
      _rInSum -= _pr;
      _gInSum -= _pg;
      _bInSum -= _pb;
      _aInSum -= _pa;
      stackOut = stackOut.next;
      yi += width;
    }
  }

  return imageData;
}
/**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */


function processCanvasRGB(canvas, topX, topY, width, height, radius) {
  if (isNaN(radius) || radius < 1) {
    return;
  }

  radius |= 0;
  var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
  imageData = processImageDataRGB(imageData, topX, topY, width, height, radius);
  canvas.getContext('2d').putImageData(imageData, topX, topY);
}
/**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */


function processImageDataRGB(imageData, topX, topY, width, height, radius) {
  var pixels = imageData.data;
  var div = 2 * radius + 1; // const w4 = width << 2;

  var widthMinus1 = width - 1;
  var heightMinus1 = height - 1;
  var radiusPlus1 = radius + 1;
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
  var stackStart = new BlurStack();
  var stack = stackStart;
  var stackEnd;

  for (var i = 1; i < div; i++) {
    stack = stack.next = new BlurStack();

    if (i === radiusPlus1) {
      stackEnd = stack;
    }
  }

  stack.next = stackStart;
  var stackIn = null;
  var stackOut = null;
  var mulSum = mulTable[radius];
  var shgSum = shgTable[radius];
  var p, rbs;
  var yw = 0,
      yi = 0;

  for (var y = 0; y < height; y++) {
    var pr = pixels[yi],
        pg = pixels[yi + 1],
        pb = pixels[yi + 2],
        rOutSum = radiusPlus1 * pr,
        gOutSum = radiusPlus1 * pg,
        bOutSum = radiusPlus1 * pb,
        rSum = sumFactor * pr,
        gSum = sumFactor * pg,
        bSum = sumFactor * pb;
    stack = stackStart;

    for (var _i5 = 0; _i5 < radiusPlus1; _i5++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack = stack.next;
    }

    var rInSum = 0,
        gInSum = 0,
        bInSum = 0;

    for (var _i6 = 1; _i6 < radiusPlus1; _i6++) {
      p = yi + ((widthMinus1 < _i6 ? widthMinus1 : _i6) << 2);
      rSum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - _i6);
      gSum += (stack.g = pg = pixels[p + 1]) * rbs;
      bSum += (stack.b = pb = pixels[p + 2]) * rbs;
      rInSum += pr;
      gInSum += pg;
      bInSum += pb;
      stack = stack.next;
    }

    stackIn = stackStart;
    stackOut = stackEnd;

    for (var x = 0; x < width; x++) {
      pixels[yi] = rSum * mulSum >> shgSum;
      pixels[yi + 1] = gSum * mulSum >> shgSum;
      pixels[yi + 2] = bSum * mulSum >> shgSum;
      rSum -= rOutSum;
      gSum -= gOutSum;
      bSum -= bOutSum;
      rOutSum -= stackIn.r;
      gOutSum -= stackIn.g;
      bOutSum -= stackIn.b;
      p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
      rInSum += stackIn.r = pixels[p];
      gInSum += stackIn.g = pixels[p + 1];
      bInSum += stackIn.b = pixels[p + 2];
      rSum += rInSum;
      gSum += gInSum;
      bSum += bInSum;
      stackIn = stackIn.next;
      rOutSum += pr = stackOut.r;
      gOutSum += pg = stackOut.g;
      bOutSum += pb = stackOut.b;
      rInSum -= pr;
      gInSum -= pg;
      bInSum -= pb;
      stackOut = stackOut.next;
      yi += 4;
    }

    yw += width;
  }

  for (var _x2 = 0; _x2 < width; _x2++) {
    yi = _x2 << 2;

    var _pr2 = pixels[yi],
        _pg2 = pixels[yi + 1],
        _pb2 = pixels[yi + 2],
        _rOutSum2 = radiusPlus1 * _pr2,
        _gOutSum2 = radiusPlus1 * _pg2,
        _bOutSum2 = radiusPlus1 * _pb2,
        _rSum2 = sumFactor * _pr2,
        _gSum2 = sumFactor * _pg2,
        _bSum2 = sumFactor * _pb2;

    stack = stackStart;

    for (var _i7 = 0; _i7 < radiusPlus1; _i7++) {
      stack.r = _pr2;
      stack.g = _pg2;
      stack.b = _pb2;
      stack = stack.next;
    }

    var _rInSum2 = 0,
        _gInSum2 = 0,
        _bInSum2 = 0;

    for (var _i8 = 1, yp = width; _i8 <= radius; _i8++) {
      yi = yp + _x2 << 2;
      _rSum2 += (stack.r = _pr2 = pixels[yi]) * (rbs = radiusPlus1 - _i8);
      _gSum2 += (stack.g = _pg2 = pixels[yi + 1]) * rbs;
      _bSum2 += (stack.b = _pb2 = pixels[yi + 2]) * rbs;
      _rInSum2 += _pr2;
      _gInSum2 += _pg2;
      _bInSum2 += _pb2;
      stack = stack.next;

      if (_i8 < heightMinus1) {
        yp += width;
      }
    }

    yi = _x2;
    stackIn = stackStart;
    stackOut = stackEnd;

    for (var _y2 = 0; _y2 < height; _y2++) {
      p = yi << 2;
      pixels[p] = _rSum2 * mulSum >> shgSum;
      pixels[p + 1] = _gSum2 * mulSum >> shgSum;
      pixels[p + 2] = _bSum2 * mulSum >> shgSum;
      _rSum2 -= _rOutSum2;
      _gSum2 -= _gOutSum2;
      _bSum2 -= _bOutSum2;
      _rOutSum2 -= stackIn.r;
      _gOutSum2 -= stackIn.g;
      _bOutSum2 -= stackIn.b;
      p = _x2 + ((p = _y2 + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
      _rSum2 += _rInSum2 += stackIn.r = pixels[p];
      _gSum2 += _gInSum2 += stackIn.g = pixels[p + 1];
      _bSum2 += _bInSum2 += stackIn.b = pixels[p + 2];
      stackIn = stackIn.next;
      _rOutSum2 += _pr2 = stackOut.r;
      _gOutSum2 += _pg2 = stackOut.g;
      _bOutSum2 += _pb2 = stackOut.b;
      _rInSum2 -= _pr2;
      _gInSum2 -= _pg2;
      _bInSum2 -= _pb2;
      stackOut = stackOut.next;
      yi += width;
    }
  }

  return imageData;
}
/**
 *
 */


var BlurStack =
/**
 * Set properties.
 */
function BlurStack() {
  _classCallCheck(this, BlurStack);

  this.r = 0;
  this.g = 0;
  this.b = 0;
  this.a = 0;
  this.next = null;
};




/***/ }),

/***/ "./node_modules/svg-pathdata/lib/SVGPathData.module.js":
/*!*************************************************************!*\
  !*** ./node_modules/svg-pathdata/lib/SVGPathData.module.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "COMMAND_ARG_COUNTS": function() { return /* binding */ N; },
/* harmony export */   "SVGPathData": function() { return /* binding */ f; },
/* harmony export */   "SVGPathDataParser": function() { return /* binding */ _; },
/* harmony export */   "SVGPathDataTransformer": function() { return /* binding */ u; },
/* harmony export */   "encodeSVGPath": function() { return /* binding */ e; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var t=function(r,e){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,r){t.__proto__=r}||function(t,r){for(var e in r)r.hasOwnProperty(e)&&(t[e]=r[e])})(r,e)};function r(r,e){function i(){this.constructor=r}t(r,e),r.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i)}function e(t){var r="";Array.isArray(t)||(t=[t]);for(var e=0;e<t.length;e++){var i=t[e];if(i.type===f.CLOSE_PATH)r+="z";else if(i.type===f.HORIZ_LINE_TO)r+=(i.relative?"h":"H")+i.x;else if(i.type===f.VERT_LINE_TO)r+=(i.relative?"v":"V")+i.y;else if(i.type===f.MOVE_TO)r+=(i.relative?"m":"M")+i.x+" "+i.y;else if(i.type===f.LINE_TO)r+=(i.relative?"l":"L")+i.x+" "+i.y;else if(i.type===f.CURVE_TO)r+=(i.relative?"c":"C")+i.x1+" "+i.y1+" "+i.x2+" "+i.y2+" "+i.x+" "+i.y;else if(i.type===f.SMOOTH_CURVE_TO)r+=(i.relative?"s":"S")+i.x2+" "+i.y2+" "+i.x+" "+i.y;else if(i.type===f.QUAD_TO)r+=(i.relative?"q":"Q")+i.x1+" "+i.y1+" "+i.x+" "+i.y;else if(i.type===f.SMOOTH_QUAD_TO)r+=(i.relative?"t":"T")+i.x+" "+i.y;else{if(i.type!==f.ARC)throw new Error('Unexpected command type "'+i.type+'" at index '+e+".");r+=(i.relative?"a":"A")+i.rX+" "+i.rY+" "+i.xRot+" "+ +i.lArcFlag+" "+ +i.sweepFlag+" "+i.x+" "+i.y}}return r}function i(t,r){var e=t[0],i=t[1];return[e*Math.cos(r)-i*Math.sin(r),e*Math.sin(r)+i*Math.cos(r)]}function a(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];for(var e=0;e<t.length;e++)if("number"!=typeof t[e])throw new Error("assertNumbers arguments["+e+"] is not a number. "+typeof t[e]+" == typeof "+t[e]);return!0}var n=Math.PI;function o(t,r,e){t.lArcFlag=0===t.lArcFlag?0:1,t.sweepFlag=0===t.sweepFlag?0:1;var a=t.rX,o=t.rY,s=t.x,u=t.y;a=Math.abs(t.rX),o=Math.abs(t.rY);var h=i([(r-s)/2,(e-u)/2],-t.xRot/180*n),c=h[0],y=h[1],p=Math.pow(c,2)/Math.pow(a,2)+Math.pow(y,2)/Math.pow(o,2);1<p&&(a*=Math.sqrt(p),o*=Math.sqrt(p)),t.rX=a,t.rY=o;var m=Math.pow(a,2)*Math.pow(y,2)+Math.pow(o,2)*Math.pow(c,2),O=(t.lArcFlag!==t.sweepFlag?1:-1)*Math.sqrt(Math.max(0,(Math.pow(a,2)*Math.pow(o,2)-m)/m)),T=a*y/o*O,v=-o*c/a*O,l=i([T,v],t.xRot/180*n);t.cX=l[0]+(r+s)/2,t.cY=l[1]+(e+u)/2,t.phi1=Math.atan2((y-v)/o,(c-T)/a),t.phi2=Math.atan2((-y-v)/o,(-c-T)/a),0===t.sweepFlag&&t.phi2>t.phi1&&(t.phi2-=2*n),1===t.sweepFlag&&t.phi2<t.phi1&&(t.phi2+=2*n),t.phi1*=180/n,t.phi2*=180/n}function s(t,r,e){a(t,r,e);var i=t*t+r*r-e*e;if(0>i)return[];if(0===i)return[[t*e/(t*t+r*r),r*e/(t*t+r*r)]];var n=Math.sqrt(i);return[[(t*e+r*n)/(t*t+r*r),(r*e-t*n)/(t*t+r*r)],[(t*e-r*n)/(t*t+r*r),(r*e+t*n)/(t*t+r*r)]]}var u,h=Math.PI/180;function c(t,r,e){return(1-e)*t+e*r}function y(t,r,e,i){return t+Math.cos(i/180*n)*r+Math.sin(i/180*n)*e}function p(t,r,e,i){var a=r-t,n=e-r,o=3*a+3*(i-e)-6*n,s=6*(n-a),u=3*a;return Math.abs(o)<1e-6?[-u/s]:function(t,r,e){void 0===e&&(e=1e-6);var i=t*t/4-r;if(i<-e)return[];if(i<=e)return[-t/2];var a=Math.sqrt(i);return[-t/2-a,-t/2+a]}(s/o,u/o,1e-6)}function m(t,r,e,i,a){var n=1-a;return t*(n*n*n)+r*(3*n*n*a)+e*(3*n*a*a)+i*(a*a*a)}!function(t){function r(){return u((function(t,r,e){return t.relative&&(void 0!==t.x1&&(t.x1+=r),void 0!==t.y1&&(t.y1+=e),void 0!==t.x2&&(t.x2+=r),void 0!==t.y2&&(t.y2+=e),void 0!==t.x&&(t.x+=r),void 0!==t.y&&(t.y+=e),t.relative=!1),t}))}function e(){var t=NaN,r=NaN,e=NaN,i=NaN;return u((function(a,n,o){return a.type&f.SMOOTH_CURVE_TO&&(a.type=f.CURVE_TO,t=isNaN(t)?n:t,r=isNaN(r)?o:r,a.x1=a.relative?n-t:2*n-t,a.y1=a.relative?o-r:2*o-r),a.type&f.CURVE_TO?(t=a.relative?n+a.x2:a.x2,r=a.relative?o+a.y2:a.y2):(t=NaN,r=NaN),a.type&f.SMOOTH_QUAD_TO&&(a.type=f.QUAD_TO,e=isNaN(e)?n:e,i=isNaN(i)?o:i,a.x1=a.relative?n-e:2*n-e,a.y1=a.relative?o-i:2*o-i),a.type&f.QUAD_TO?(e=a.relative?n+a.x1:a.x1,i=a.relative?o+a.y1:a.y1):(e=NaN,i=NaN),a}))}function n(){var t=NaN,r=NaN;return u((function(e,i,a){if(e.type&f.SMOOTH_QUAD_TO&&(e.type=f.QUAD_TO,t=isNaN(t)?i:t,r=isNaN(r)?a:r,e.x1=e.relative?i-t:2*i-t,e.y1=e.relative?a-r:2*a-r),e.type&f.QUAD_TO){t=e.relative?i+e.x1:e.x1,r=e.relative?a+e.y1:e.y1;var n=e.x1,o=e.y1;e.type=f.CURVE_TO,e.x1=((e.relative?0:i)+2*n)/3,e.y1=((e.relative?0:a)+2*o)/3,e.x2=(e.x+2*n)/3,e.y2=(e.y+2*o)/3}else t=NaN,r=NaN;return e}))}function u(t){var r=0,e=0,i=NaN,a=NaN;return function(n){if(isNaN(i)&&!(n.type&f.MOVE_TO))throw new Error("path must start with moveto");var o=t(n,r,e,i,a);return n.type&f.CLOSE_PATH&&(r=i,e=a),void 0!==n.x&&(r=n.relative?r+n.x:n.x),void 0!==n.y&&(e=n.relative?e+n.y:n.y),n.type&f.MOVE_TO&&(i=r,a=e),o}}function O(t,r,e,i,n,o){return a(t,r,e,i,n,o),u((function(a,s,u,h){var c=a.x1,y=a.x2,p=a.relative&&!isNaN(h),m=void 0!==a.x?a.x:p?0:s,O=void 0!==a.y?a.y:p?0:u;function T(t){return t*t}a.type&f.HORIZ_LINE_TO&&0!==r&&(a.type=f.LINE_TO,a.y=a.relative?0:u),a.type&f.VERT_LINE_TO&&0!==e&&(a.type=f.LINE_TO,a.x=a.relative?0:s),void 0!==a.x&&(a.x=a.x*t+O*e+(p?0:n)),void 0!==a.y&&(a.y=m*r+a.y*i+(p?0:o)),void 0!==a.x1&&(a.x1=a.x1*t+a.y1*e+(p?0:n)),void 0!==a.y1&&(a.y1=c*r+a.y1*i+(p?0:o)),void 0!==a.x2&&(a.x2=a.x2*t+a.y2*e+(p?0:n)),void 0!==a.y2&&(a.y2=y*r+a.y2*i+(p?0:o));var v=t*i-r*e;if(void 0!==a.xRot&&(1!==t||0!==r||0!==e||1!==i))if(0===v)delete a.rX,delete a.rY,delete a.xRot,delete a.lArcFlag,delete a.sweepFlag,a.type=f.LINE_TO;else{var l=a.xRot*Math.PI/180,_=Math.sin(l),N=Math.cos(l),x=1/T(a.rX),d=1/T(a.rY),A=T(N)*x+T(_)*d,E=2*_*N*(x-d),C=T(_)*x+T(N)*d,M=A*i*i-E*r*i+C*r*r,R=E*(t*i+r*e)-2*(A*e*i+C*t*r),g=A*e*e-E*t*e+C*t*t,I=(Math.atan2(R,M-g)+Math.PI)%Math.PI/2,S=Math.sin(I),L=Math.cos(I);a.rX=Math.abs(v)/Math.sqrt(M*T(L)+R*S*L+g*T(S)),a.rY=Math.abs(v)/Math.sqrt(M*T(S)-R*S*L+g*T(L)),a.xRot=180*I/Math.PI}return void 0!==a.sweepFlag&&0>v&&(a.sweepFlag=+!a.sweepFlag),a}))}function T(){return function(t){var r={};for(var e in t)r[e]=t[e];return r}}t.ROUND=function(t){function r(r){return Math.round(r*t)/t}return void 0===t&&(t=1e13),a(t),function(t){return void 0!==t.x1&&(t.x1=r(t.x1)),void 0!==t.y1&&(t.y1=r(t.y1)),void 0!==t.x2&&(t.x2=r(t.x2)),void 0!==t.y2&&(t.y2=r(t.y2)),void 0!==t.x&&(t.x=r(t.x)),void 0!==t.y&&(t.y=r(t.y)),void 0!==t.rX&&(t.rX=r(t.rX)),void 0!==t.rY&&(t.rY=r(t.rY)),t}},t.TO_ABS=r,t.TO_REL=function(){return u((function(t,r,e){return t.relative||(void 0!==t.x1&&(t.x1-=r),void 0!==t.y1&&(t.y1-=e),void 0!==t.x2&&(t.x2-=r),void 0!==t.y2&&(t.y2-=e),void 0!==t.x&&(t.x-=r),void 0!==t.y&&(t.y-=e),t.relative=!0),t}))},t.NORMALIZE_HVZ=function(t,r,e){return void 0===t&&(t=!0),void 0===r&&(r=!0),void 0===e&&(e=!0),u((function(i,a,n,o,s){if(isNaN(o)&&!(i.type&f.MOVE_TO))throw new Error("path must start with moveto");return r&&i.type&f.HORIZ_LINE_TO&&(i.type=f.LINE_TO,i.y=i.relative?0:n),e&&i.type&f.VERT_LINE_TO&&(i.type=f.LINE_TO,i.x=i.relative?0:a),t&&i.type&f.CLOSE_PATH&&(i.type=f.LINE_TO,i.x=i.relative?o-a:o,i.y=i.relative?s-n:s),i.type&f.ARC&&(0===i.rX||0===i.rY)&&(i.type=f.LINE_TO,delete i.rX,delete i.rY,delete i.xRot,delete i.lArcFlag,delete i.sweepFlag),i}))},t.NORMALIZE_ST=e,t.QT_TO_C=n,t.INFO=u,t.SANITIZE=function(t){void 0===t&&(t=0),a(t);var r=NaN,e=NaN,i=NaN,n=NaN;return u((function(a,o,s,u,h){var c=Math.abs,y=!1,p=0,m=0;if(a.type&f.SMOOTH_CURVE_TO&&(p=isNaN(r)?0:o-r,m=isNaN(e)?0:s-e),a.type&(f.CURVE_TO|f.SMOOTH_CURVE_TO)?(r=a.relative?o+a.x2:a.x2,e=a.relative?s+a.y2:a.y2):(r=NaN,e=NaN),a.type&f.SMOOTH_QUAD_TO?(i=isNaN(i)?o:2*o-i,n=isNaN(n)?s:2*s-n):a.type&f.QUAD_TO?(i=a.relative?o+a.x1:a.x1,n=a.relative?s+a.y1:a.y2):(i=NaN,n=NaN),a.type&f.LINE_COMMANDS||a.type&f.ARC&&(0===a.rX||0===a.rY||!a.lArcFlag)||a.type&f.CURVE_TO||a.type&f.SMOOTH_CURVE_TO||a.type&f.QUAD_TO||a.type&f.SMOOTH_QUAD_TO){var O=void 0===a.x?0:a.relative?a.x:a.x-o,T=void 0===a.y?0:a.relative?a.y:a.y-s;p=isNaN(i)?void 0===a.x1?p:a.relative?a.x:a.x1-o:i-o,m=isNaN(n)?void 0===a.y1?m:a.relative?a.y:a.y1-s:n-s;var v=void 0===a.x2?0:a.relative?a.x:a.x2-o,l=void 0===a.y2?0:a.relative?a.y:a.y2-s;c(O)<=t&&c(T)<=t&&c(p)<=t&&c(m)<=t&&c(v)<=t&&c(l)<=t&&(y=!0)}return a.type&f.CLOSE_PATH&&c(o-u)<=t&&c(s-h)<=t&&(y=!0),y?[]:a}))},t.MATRIX=O,t.ROTATE=function(t,r,e){void 0===r&&(r=0),void 0===e&&(e=0),a(t,r,e);var i=Math.sin(t),n=Math.cos(t);return O(n,i,-i,n,r-r*n+e*i,e-r*i-e*n)},t.TRANSLATE=function(t,r){return void 0===r&&(r=0),a(t,r),O(1,0,0,1,t,r)},t.SCALE=function(t,r){return void 0===r&&(r=t),a(t,r),O(t,0,0,r,0,0)},t.SKEW_X=function(t){return a(t),O(1,0,Math.atan(t),1,0,0)},t.SKEW_Y=function(t){return a(t),O(1,Math.atan(t),0,1,0,0)},t.X_AXIS_SYMMETRY=function(t){return void 0===t&&(t=0),a(t),O(-1,0,0,1,t,0)},t.Y_AXIS_SYMMETRY=function(t){return void 0===t&&(t=0),a(t),O(1,0,0,-1,0,t)},t.A_TO_C=function(){return u((function(t,r,e){return f.ARC===t.type?function(t,r,e){var a,n,s,u;t.cX||o(t,r,e);for(var y=Math.min(t.phi1,t.phi2),p=Math.max(t.phi1,t.phi2)-y,m=Math.ceil(p/90),O=new Array(m),T=r,v=e,l=0;l<m;l++){var _=c(t.phi1,t.phi2,l/m),N=c(t.phi1,t.phi2,(l+1)/m),x=N-_,d=4/3*Math.tan(x*h/4),A=[Math.cos(_*h)-d*Math.sin(_*h),Math.sin(_*h)+d*Math.cos(_*h)],E=A[0],C=A[1],M=[Math.cos(N*h),Math.sin(N*h)],R=M[0],g=M[1],I=[R+d*Math.sin(N*h),g-d*Math.cos(N*h)],S=I[0],L=I[1];O[l]={relative:t.relative,type:f.CURVE_TO};var H=function(r,e){var a=i([r*t.rX,e*t.rY],t.xRot),n=a[0],o=a[1];return[t.cX+n,t.cY+o]};a=H(E,C),O[l].x1=a[0],O[l].y1=a[1],n=H(S,L),O[l].x2=n[0],O[l].y2=n[1],s=H(R,g),O[l].x=s[0],O[l].y=s[1],t.relative&&(O[l].x1-=T,O[l].y1-=v,O[l].x2-=T,O[l].y2-=v,O[l].x-=T,O[l].y-=v),T=(u=[O[l].x,O[l].y])[0],v=u[1]}return O}(t,t.relative?0:r,t.relative?0:e):t}))},t.ANNOTATE_ARCS=function(){return u((function(t,r,e){return t.relative&&(r=0,e=0),f.ARC===t.type&&o(t,r,e),t}))},t.CLONE=T,t.CALCULATE_BOUNDS=function(){var t=function(t){var r={};for(var e in t)r[e]=t[e];return r},i=r(),a=n(),h=e(),c=u((function(r,e,n){var u=h(a(i(t(r))));function O(t){t>c.maxX&&(c.maxX=t),t<c.minX&&(c.minX=t)}function T(t){t>c.maxY&&(c.maxY=t),t<c.minY&&(c.minY=t)}if(u.type&f.DRAWING_COMMANDS&&(O(e),T(n)),u.type&f.HORIZ_LINE_TO&&O(u.x),u.type&f.VERT_LINE_TO&&T(u.y),u.type&f.LINE_TO&&(O(u.x),T(u.y)),u.type&f.CURVE_TO){O(u.x),T(u.y);for(var v=0,l=p(e,u.x1,u.x2,u.x);v<l.length;v++){0<(w=l[v])&&1>w&&O(m(e,u.x1,u.x2,u.x,w))}for(var _=0,N=p(n,u.y1,u.y2,u.y);_<N.length;_++){0<(w=N[_])&&1>w&&T(m(n,u.y1,u.y2,u.y,w))}}if(u.type&f.ARC){O(u.x),T(u.y),o(u,e,n);for(var x=u.xRot/180*Math.PI,d=Math.cos(x)*u.rX,A=Math.sin(x)*u.rX,E=-Math.sin(x)*u.rY,C=Math.cos(x)*u.rY,M=u.phi1<u.phi2?[u.phi1,u.phi2]:-180>u.phi2?[u.phi2+360,u.phi1+360]:[u.phi2,u.phi1],R=M[0],g=M[1],I=function(t){var r=t[0],e=t[1],i=180*Math.atan2(e,r)/Math.PI;return i<R?i+360:i},S=0,L=s(E,-d,0).map(I);S<L.length;S++){(w=L[S])>R&&w<g&&O(y(u.cX,d,E,w))}for(var H=0,U=s(C,-A,0).map(I);H<U.length;H++){var w;(w=U[H])>R&&w<g&&T(y(u.cY,A,C,w))}}return r}));return c.minX=1/0,c.maxX=-1/0,c.minY=1/0,c.maxY=-1/0,c}}(u||(u={}));var O,T=function(){function t(){}return t.prototype.round=function(t){return this.transform(u.ROUND(t))},t.prototype.toAbs=function(){return this.transform(u.TO_ABS())},t.prototype.toRel=function(){return this.transform(u.TO_REL())},t.prototype.normalizeHVZ=function(t,r,e){return this.transform(u.NORMALIZE_HVZ(t,r,e))},t.prototype.normalizeST=function(){return this.transform(u.NORMALIZE_ST())},t.prototype.qtToC=function(){return this.transform(u.QT_TO_C())},t.prototype.aToC=function(){return this.transform(u.A_TO_C())},t.prototype.sanitize=function(t){return this.transform(u.SANITIZE(t))},t.prototype.translate=function(t,r){return this.transform(u.TRANSLATE(t,r))},t.prototype.scale=function(t,r){return this.transform(u.SCALE(t,r))},t.prototype.rotate=function(t,r,e){return this.transform(u.ROTATE(t,r,e))},t.prototype.matrix=function(t,r,e,i,a,n){return this.transform(u.MATRIX(t,r,e,i,a,n))},t.prototype.skewX=function(t){return this.transform(u.SKEW_X(t))},t.prototype.skewY=function(t){return this.transform(u.SKEW_Y(t))},t.prototype.xSymmetry=function(t){return this.transform(u.X_AXIS_SYMMETRY(t))},t.prototype.ySymmetry=function(t){return this.transform(u.Y_AXIS_SYMMETRY(t))},t.prototype.annotateArcs=function(){return this.transform(u.ANNOTATE_ARCS())},t}(),v=function(t){return" "===t||"\t"===t||"\r"===t||"\n"===t},l=function(t){return"0".charCodeAt(0)<=t.charCodeAt(0)&&t.charCodeAt(0)<="9".charCodeAt(0)},_=function(t){function e(){var r=t.call(this)||this;return r.curNumber="",r.curCommandType=-1,r.curCommandRelative=!1,r.canParseCommandOrComma=!0,r.curNumberHasExp=!1,r.curNumberHasExpDigits=!1,r.curNumberHasDecimal=!1,r.curArgs=[],r}return r(e,t),e.prototype.finish=function(t){if(void 0===t&&(t=[]),this.parse(" ",t),0!==this.curArgs.length||!this.canParseCommandOrComma)throw new SyntaxError("Unterminated command at the path end.");return t},e.prototype.parse=function(t,r){var e=this;void 0===r&&(r=[]);for(var i=function(t){r.push(t),e.curArgs.length=0,e.canParseCommandOrComma=!0},a=0;a<t.length;a++){var n=t[a],o=!(this.curCommandType!==f.ARC||3!==this.curArgs.length&&4!==this.curArgs.length||1!==this.curNumber.length||"0"!==this.curNumber&&"1"!==this.curNumber),s=l(n)&&("0"===this.curNumber&&"0"===n||o);if(!l(n)||s)if("e"!==n&&"E"!==n)if("-"!==n&&"+"!==n||!this.curNumberHasExp||this.curNumberHasExpDigits)if("."!==n||this.curNumberHasExp||this.curNumberHasDecimal||o){if(this.curNumber&&-1!==this.curCommandType){var u=Number(this.curNumber);if(isNaN(u))throw new SyntaxError("Invalid number ending at "+a);if(this.curCommandType===f.ARC)if(0===this.curArgs.length||1===this.curArgs.length){if(0>u)throw new SyntaxError('Expected positive number, got "'+u+'" at index "'+a+'"')}else if((3===this.curArgs.length||4===this.curArgs.length)&&"0"!==this.curNumber&&"1"!==this.curNumber)throw new SyntaxError('Expected a flag, got "'+this.curNumber+'" at index "'+a+'"');this.curArgs.push(u),this.curArgs.length===N[this.curCommandType]&&(f.HORIZ_LINE_TO===this.curCommandType?i({type:f.HORIZ_LINE_TO,relative:this.curCommandRelative,x:u}):f.VERT_LINE_TO===this.curCommandType?i({type:f.VERT_LINE_TO,relative:this.curCommandRelative,y:u}):this.curCommandType===f.MOVE_TO||this.curCommandType===f.LINE_TO||this.curCommandType===f.SMOOTH_QUAD_TO?(i({type:this.curCommandType,relative:this.curCommandRelative,x:this.curArgs[0],y:this.curArgs[1]}),f.MOVE_TO===this.curCommandType&&(this.curCommandType=f.LINE_TO)):this.curCommandType===f.CURVE_TO?i({type:f.CURVE_TO,relative:this.curCommandRelative,x1:this.curArgs[0],y1:this.curArgs[1],x2:this.curArgs[2],y2:this.curArgs[3],x:this.curArgs[4],y:this.curArgs[5]}):this.curCommandType===f.SMOOTH_CURVE_TO?i({type:f.SMOOTH_CURVE_TO,relative:this.curCommandRelative,x2:this.curArgs[0],y2:this.curArgs[1],x:this.curArgs[2],y:this.curArgs[3]}):this.curCommandType===f.QUAD_TO?i({type:f.QUAD_TO,relative:this.curCommandRelative,x1:this.curArgs[0],y1:this.curArgs[1],x:this.curArgs[2],y:this.curArgs[3]}):this.curCommandType===f.ARC&&i({type:f.ARC,relative:this.curCommandRelative,rX:this.curArgs[0],rY:this.curArgs[1],xRot:this.curArgs[2],lArcFlag:this.curArgs[3],sweepFlag:this.curArgs[4],x:this.curArgs[5],y:this.curArgs[6]})),this.curNumber="",this.curNumberHasExpDigits=!1,this.curNumberHasExp=!1,this.curNumberHasDecimal=!1,this.canParseCommandOrComma=!0}if(!v(n))if(","===n&&this.canParseCommandOrComma)this.canParseCommandOrComma=!1;else if("+"!==n&&"-"!==n&&"."!==n)if(s)this.curNumber=n,this.curNumberHasDecimal=!1;else{if(0!==this.curArgs.length)throw new SyntaxError("Unterminated command at index "+a+".");if(!this.canParseCommandOrComma)throw new SyntaxError('Unexpected character "'+n+'" at index '+a+". Command cannot follow comma");if(this.canParseCommandOrComma=!1,"z"!==n&&"Z"!==n)if("h"===n||"H"===n)this.curCommandType=f.HORIZ_LINE_TO,this.curCommandRelative="h"===n;else if("v"===n||"V"===n)this.curCommandType=f.VERT_LINE_TO,this.curCommandRelative="v"===n;else if("m"===n||"M"===n)this.curCommandType=f.MOVE_TO,this.curCommandRelative="m"===n;else if("l"===n||"L"===n)this.curCommandType=f.LINE_TO,this.curCommandRelative="l"===n;else if("c"===n||"C"===n)this.curCommandType=f.CURVE_TO,this.curCommandRelative="c"===n;else if("s"===n||"S"===n)this.curCommandType=f.SMOOTH_CURVE_TO,this.curCommandRelative="s"===n;else if("q"===n||"Q"===n)this.curCommandType=f.QUAD_TO,this.curCommandRelative="q"===n;else if("t"===n||"T"===n)this.curCommandType=f.SMOOTH_QUAD_TO,this.curCommandRelative="t"===n;else{if("a"!==n&&"A"!==n)throw new SyntaxError('Unexpected character "'+n+'" at index '+a+".");this.curCommandType=f.ARC,this.curCommandRelative="a"===n}else r.push({type:f.CLOSE_PATH}),this.canParseCommandOrComma=!0,this.curCommandType=-1}else this.curNumber=n,this.curNumberHasDecimal="."===n}else this.curNumber+=n,this.curNumberHasDecimal=!0;else this.curNumber+=n;else this.curNumber+=n,this.curNumberHasExp=!0;else this.curNumber+=n,this.curNumberHasExpDigits=this.curNumberHasExp}return r},e.prototype.transform=function(t){return Object.create(this,{parse:{value:function(r,e){void 0===e&&(e=[]);for(var i=0,a=Object.getPrototypeOf(this).parse.call(this,r);i<a.length;i++){var n=a[i],o=t(n);Array.isArray(o)?e.push.apply(e,o):e.push(o)}return e}}})},e}(T),f=function(t){function i(r){var e=t.call(this)||this;return e.commands="string"==typeof r?i.parse(r):r,e}return r(i,t),i.prototype.encode=function(){return i.encode(this.commands)},i.prototype.getBounds=function(){var t=u.CALCULATE_BOUNDS();return this.transform(t),t},i.prototype.transform=function(t){for(var r=[],e=0,i=this.commands;e<i.length;e++){var a=t(i[e]);Array.isArray(a)?r.push.apply(r,a):r.push(a)}return this.commands=r,this},i.encode=function(t){return e(t)},i.parse=function(t){var r=new _,e=[];return r.parse(t,e),r.finish(e),e},i.CLOSE_PATH=1,i.MOVE_TO=2,i.HORIZ_LINE_TO=4,i.VERT_LINE_TO=8,i.LINE_TO=16,i.CURVE_TO=32,i.SMOOTH_CURVE_TO=64,i.QUAD_TO=128,i.SMOOTH_QUAD_TO=256,i.ARC=512,i.LINE_COMMANDS=i.LINE_TO|i.HORIZ_LINE_TO|i.VERT_LINE_TO,i.DRAWING_COMMANDS=i.HORIZ_LINE_TO|i.VERT_LINE_TO|i.LINE_TO|i.CURVE_TO|i.SMOOTH_CURVE_TO|i.QUAD_TO|i.SMOOTH_QUAD_TO|i.ARC,i}(T),N=((O={})[f.MOVE_TO]=2,O[f.LINE_TO]=2,O[f.HORIZ_LINE_TO]=1,O[f.VERT_LINE_TO]=1,O[f.CLOSE_PATH]=0,O[f.QUAD_TO]=4,O[f.SMOOTH_QUAD_TO]=2,O[f.CURVE_TO]=6,O[f.SMOOTH_CURVE_TO]=4,O[f.ARC]=7,O);



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	!function() {
/******/ 		var getProto = Object.getPrototypeOf ? function(obj) { return Object.getPrototypeOf(obj); } : function(obj) { return obj.__proto__; };
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach(function(key) { def[key] = function() { return value[key]; }; });
/******/ 			}
/******/ 			def['default'] = function() { return value; };
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _worker_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./worker.js */ "./src/worker.js");
/* harmony import */ var _plugin_jspdf_plugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./plugin/jspdf-plugin.js */ "./src/plugin/jspdf-plugin.js");
/* harmony import */ var _plugin_pagebreaks_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./plugin/pagebreaks.js */ "./src/plugin/pagebreaks.js");
/* harmony import */ var _plugin_hyperlinks_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./plugin/hyperlinks.js */ "./src/plugin/hyperlinks.js");




/**
 * Generate a PDF from an HTML element or string using html2canvas and jsPDF.
 *
 * @param {Element|string} source The source element or HTML string.
 * @param {Object=} opt An object of optional settings: 'margin', 'filename',
 *    'image' ('type' and 'quality'), and 'html2canvas' / 'jspdf', which are
 *    sent as settings to their corresponding functions.
 */

var html2pdf = function html2pdf(src, opt) {
  // Create a new worker with the given options.
  var worker = new html2pdf.Worker(opt);

  if (src) {
    // If src is specified, perform the traditional 'simple' operation.
    return worker.from(src).save();
  } else {
    // Otherwise, return the worker for new Promise-based operation.
    return worker;
  }
};

html2pdf.Worker = _worker_js__WEBPACK_IMPORTED_MODULE_0__.default; // Expose the html2pdf function.

/* harmony default export */ __webpack_exports__["default"] = (html2pdf);
}();
__webpack_exports__ = __webpack_exports__.default;
/******/ 	return __webpack_exports__;
/******/ })()
;
});
(function () {
    'use strict';

    userRolesService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module('redcap.user')
        .factory('userRolesService', userRolesService);

    function userRolesService($q, $log, $filter, $http, $rootScope, rcApi) {

        var USERROLE_BASEPATH = 'userRoles/';
        
        return {
            getUserRoles: getUserRoles,
            getRolesForUserFilter: getRolesForUserFilter
        };

        function getUserRoles(userId) {
            return rcApi.get(USERROLE_BASEPATH + userId);
        }

        function getRolesForUserFilter(){
            return rcApi.get(USERROLE_BASEPATH + 'getRolesForUserFilter');
        }
    }
})();

(function () {
    'use strict';

    userService.$inject = ["$q", "$rootScope", "rcApi", "localStorageService"];
    angular
        .module('redcap.user')
        .factory('userService', userService);

    function userService($q, $rootScope, rcApi, localStorageService) {

        let USER_BASEPATH = 'users/';
        let _currentUser = null;

        return {
            clearCache: clearCache,
            getUsers: getUsers,
            getUser: getUser,
            getEmployeeMapping: getEmployeeMapping,
            updateEmployeeMapping: updateEmployeeMapping,
            checkIfUserExists: checkIfUserExists,
            checkPassword: checkPassword,
            addUser: addUser,
            sendWelcomeEmails: sendWelcomeEmails,
            updateUser: updateUser,
            updatePassword: updatePassword,
            changePassword: changePassword,
            emailTempPassword: emailTempPassword,
            resetMFAbyUsername: resetMFAbyUsername,
            emailResetPasswordSolid: emailResetPasswordSolid,
            textTempPassword: textTempPassword,
            getUnseenTutorials: getUnseenTutorials,
            setSeenTutorial: setSeenTutorial,
            getTutorialBySupportConfigId: getTutorialBySupportConfigId,
            getTutorial: getTutorial,
            getOutOfOffice: getOutOfOffice,
            setOutOfOffice: setOutOfOffice,
            removeOutOfOffice: removeOutOfOffice,
            forgotUserName: forgotUserName,
            addUserBulkCC: addUserBulkCC,
            bulkImportUsers: bulkImportUsers,

            // onboarding
            getOnboardingUser: getOnboardingUser,
            confirmOnboarding: confirmOnboarding,
            moveUsersBetweenDealers: moveUsersBetweenDealers
        };

        function clearCache() {
            _currentUser = null;
        }

        function getUsers(filter) {
            if (filter)
                return rcApi.post(USER_BASEPATH + 'search', filter);

            return rcApi.post(USER_BASEPATH);
        }

        function getUser(userId) {

            if (_currentUser && _currentUser.id.toString() === userId) {
                return _currentUser;
            }

            return rcApi.get(USER_BASEPATH + userId).then((response) => {
                _currentUser = response;

                return _currentUser;
            });
        }

        function getUserByName(userName) {
            return rcApi.get(USER_BASEPATH + userName).then((response) => {
                    _currentUser = response;

                return _currentUser;
            });
        }

        function getEmployeeMapping(userId, pageNo, pageSize) {
            return rcApi.get(USER_BASEPATH + userId + '/getEmployeeMapping', {page: pageNo != null ? pageNo : 0, pageSize: pageSize || 50});
        }

        function updateEmployeeMapping(userId, mappings) {
            return rcApi.post(USER_BASEPATH + userId + '/updateEmployeeMapping', mappings);
        }

        function checkIfUserExists(userName) {
            return rcApi.get(USER_BASEPATH + 'userExists/' + encodeURIComponent(userName));
        }

        function checkPassword(password) {
            if (password && password.length > 0) {
                return rcApi.post(USER_BASEPATH + 'hasValidPassword', {value: password});
            } else {
                return false;
            }
        }

        function addUser(newUser) {
            return rcApi.post(USER_BASEPATH, newUser).then((response) => {
                if (angular.isNumber(response)) { //return a newly created user when successful
                    $rootScope.$broadcast('UserService.changed', newUser);
                    clearCache();
                }

                return response;
            });
        }

        function getUnseenTutorials() {
            return rcApi.get('slideshows/unseen');
        }

        function getTutorial(tutorialId) {
            return rcApi.get('slideshows/' + tutorialId);
        }

        function setSeenTutorial(tutorialId) {
            return rcApi.post('slideshows/' + tutorialId + '/seen');
        }

        function getTutorialBySupportConfigId(configId) {
            return rcApi.get('slideshows/tutorialsBySupportTrainingConfigId?supportTrainingConfigId=' + configId);
        }

        function sendWelcomeEmails(userList) {
            let deferred = $q.defer();
            let promises = [];

            userList.forEach((userId) => {
                let promise = rcApi.get(USER_BASEPATH + userId + '/sendEmail').then((result) => {
                    deferred.resolve(result);
                });

                promises.push(promise);
            });

            $q.all(promises).then((statuses) => {
                let finalStatus = true;

                statuses.forEach((status) => {
                    finalStatus &= status;
                });
                deferred.resolve(finalStatus);
            });

            return deferred.promise;
        }

        function updateUser(updatedUser) {
            return rcApi.put(USER_BASEPATH + updatedUser.id, updatedUser).then((response) => {
                if (response === true) {
                    clearCache(); // This will force the api to get the user again when getUser is called, because _currentUser will be null
                    $rootScope.$broadcast('UserService.changed', updatedUser);
                }

                return response;
            });
        }

        function updatePassword(userId, newPassword, requiresPasswordChange) {
            return rcApi.post(USER_BASEPATH + 'updatePassword', {userId: userId, newPassword: newPassword, requiresPasswordChange: requiresPasswordChange});
        }

        function changePassword(userId, currentPassword, newPassword) {
            return rcApi.post(USER_BASEPATH + 'changePassword', {userId: userId, currentPassword: currentPassword, newPassword: newPassword});
        }

        function emailTempPassword(userName) {
            return rcApi.post(USER_BASEPATH + 'SendTempPassword', {userName: userName, isEmail: true});
        }

        function resetMFAbyUsername(userName) {
            return rcApi.post(USER_BASEPATH + 'ResetMFAbyUsername', {userName: userName});
        }

        function emailResetPasswordSolid(userName) {
            return rcApi.post(USER_BASEPATH + 'SendResetPasswordSolidEmail', {userName: userName});
        }

        function textTempPassword(userName) {
            return rcApi.post(USER_BASEPATH + 'SendTempPassword', {userName: userName, isEmail: false});
        }

        function getOutOfOffice() {
            return rcApi.get(USER_BASEPATH + 'outofoffice');
        }

        function setOutOfOffice(message) {
            return rcApi.post(USER_BASEPATH + 'outofoffice', {value: message});
        }

        function removeOutOfOffice() {
            return rcApi.remove(USER_BASEPATH + 'outofoffice');
        }

        function forgotUserName(mobilePhone) {
            return rcApi.post(USER_BASEPATH + 'ForgotUserName', {phoneNumber: mobilePhone});
        }

        function getOnboardingUser(id) {
            return rcApi.get(USER_BASEPATH + 'newUser/' + id);
        }

        function confirmOnboarding(model) {
            return rcApi.put(USER_BASEPATH + 'newUser/' + model.id, model);
        }

        function addUserBulkCC(userId, dealerId, addToBulkCCSurvey, addToBulkCCNotifications) {
            return rcApi.post(USER_BASEPATH + 'addUserBulkCC', {userId: userId, dealerId: dealerId, addToBulkCCSurvey: addToBulkCCSurvey, addToBulkCCNotifications: addToBulkCCNotifications});
        }

        function bulkImportUsers(base64FileData, userIdToCopyFrom) {
            return rcApi.post(USER_BASEPATH + 'bulkimport', {base64FileData: base64FileData, userIdToCopyFrom: userIdToCopyFrom});   
        }

        function getCurrentProgramId() {
            let authData = localStorageService.get('authorizationData');

            return $q.resolve(authData && authData.adminConfigId ? authData.adminConfigId : null);
        }

        function moveUsersBetweenDealers(ids, targetDealerId, sourceDealerId) {
            return rcApi.post(USER_BASEPATH + 'moveUsers', {ids: ids, targetDealerId: targetDealerId,  sourceDealerId: sourceDealerId});
        }
    }

})();

(function () {
    'use strict';

    employeeService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module('redcap.user')
        .factory('employeeService', employeeService);

    function employeeService($q, $log, $filter, $http, $rootScope, rcApi) {

        let LOCATION_BASEPATH = 'dealers/';
        let EMPLOYEES_SUFFIXPATH = '/employees';
        let EMPLOYEES_GETCONFIGURED = '/getConfigured';
        let EMPLOYEES_GETCONFIGURED_CCLIST = '/getConfiguredCCList';
        let EMPLOYEES_PAGED_SUFFIXPATH = '/employees/paged';
        
        return {
            getEmployeesByLocation: getEmployeesByLocation,
            getConfiguredEmployeesByLocation: getConfiguredEmployeesByLocation,
            getConfiguredCCListEmployeesByLocation: getConfiguredCCListEmployeesByLocation,
            getEmployeesByLocationPaged: getEmployeesByLocationPaged
        };

        function getEmployeesByLocation(locationId, unusedOnly) {
            let unusedQueryParam = unusedOnly ? "?showUnusedOnly=true" : "";

            return rcApi.get(LOCATION_BASEPATH + 
                locationId + 
                EMPLOYEES_SUFFIXPATH + 
                unusedQueryParam);
        }

        function getEmployeesByLocationPaged(locationId, unusedOnly, page = 1, searchTerm = "") {
            let url = `${LOCATION_BASEPATH}${locationId}${EMPLOYEES_PAGED_SUFFIXPATH}`;
            let params = [];

            if (unusedOnly) params.push("showUnusedOnly=true");
            if (page) params.push(`page=${page}`);
            if (searchTerm && searchTerm.length > 0) params.push(`searchTerm=${encodeURIComponent(searchTerm)}`);
            if (params.length > 0) url += `?${params.join("&")}`;
            
            return rcApi.get(url);
        }

        function getConfiguredEmployeesByLocation(locationId, assignedEmployeeIds) {
            let url = LOCATION_BASEPATH + 
                locationId + 
                EMPLOYEES_SUFFIXPATH +
                EMPLOYEES_GETCONFIGURED;

            if (assignedEmployeeIds?.length) {
                url += "?assignedEmployeeIds=" + assignedEmployeeIds.join(",");
            }

            return rcApi.get(url);
        }

        function getConfiguredCCListEmployeesByLocation(locationId) {
            return rcApi.get(LOCATION_BASEPATH + 
                locationId + 
                EMPLOYEES_SUFFIXPATH +
                EMPLOYEES_GETCONFIGURED_CCLIST);
        }
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$scope", "HERE_MAPS_CONFIG", "enrollmentService", "mapObjectFactory"];
    angular
        .module('redcap.directives')
        .component('venueMapping', {
            templateUrl: 'app/shared/components/venue-mapping/venue-mapping.component.html',
            controller: controller,
            controllerAs: 'ctrl',
            bindings: {
                'settings': '=',
                'copyFromVenues':'=',
                'venue': '=',
                'onSave': '&',
                'onCancel': '&'
            }
        });

    function controller($scope, HERE_MAPS_CONFIG, enrollmentService, mapObjectFactory) {

        this.$onInit = function() {
            var ctrl = this,
                venueMarker,
                dealerOrigLatLng = {
                    lat: ctrl.venue.lat,
                    lng: ctrl.venue.lng
                },
                circleExists = false,
                pinRadius = 150,
                perimeterStyle = HERE_MAPS_CONFIG.perimeterStyle,
                circlePreviousStateGood = null,
                updatedVenue = {};

            ctrl.markers = [];
            ctrl.isProcessing = false;
            ctrl.showMapCover = true;
            ctrl.canSave = false;

            ctrl.mapOptions = {
                defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
                showControls: true,
                draggable: true,
                resize: true,
                coords: {
                    latitude: ctrl.venue.lat,
                    longitude: ctrl.venue.lng
                }
            };

            ctrl.placesOptions = {
                watchEnter: true,
                country: 'us',
                startLat: dealerOrigLatLng.lat,
                startLng: dealerOrigLatLng.lng
            };

            // These are required in order for the map to be interactive.
            ctrl.mapListeners = {
                drag: function() {

                },
                resize: function() {

                }
            };

            ctrl.onMapReady = function(hereMap) {
                ctrl.hereMap = hereMap;
                ctrl.hereMap && ctrl.hereMap.setMapStyle(HERE_MAPS_CONFIG.satelliteViewSettings);
                ctrl.hereMap.setZoom(19);

                $scope.$on('resizeHereMap',
                    function() {
                        if (ctrl.hereMap)
                            ctrl.hereMap.refresh();
                    });

                if (ctrl.venue) {
                    updatePlace(ctrl.venue);
                }
            };

            ctrl.save = function() {
                if (!ctrl.onSave)
                    return;

                if (ctrl.isProcessing) return;

                ctrl.isProcessing = true;

                var coordinate = ctrl.hereMap.getMarkers()[0].getGeometry();
                updatedVenue.lat = coordinate.lat;
                updatedVenue.lng = coordinate.lng;

                ctrl.onSave()(updatedVenue);
            };

            ctrl.cancel = function() {
                ctrl.onCancel()();
            };

            ctrl.placeUpdated = function(formattedAddress) {
                if (formattedAddress) {
                    dealerOrigLatLng.lat = formattedAddress.location.lat;
                    dealerOrigLatLng.lng = formattedAddress.location.lng;

                    updatedVenue.streetAddress = formattedAddress.location.streetAddress;
                    updatedVenue.city = formattedAddress.location.city;
                    updatedVenue.state = formattedAddress.location.state;
                    updatedVenue.zip = formattedAddress.location.zip;
                    updatedVenue.lat = formattedAddress.location.lat;
                    updatedVenue.lng = formattedAddress.location.lng;
                    updatedVenue.streetNumber = formattedAddress.location.streetNumber;
                    updatedVenue.address = formattedAddress.location.address;
                    updatedVenue.countryCode = formattedAddress.location.countryCode || 'USA';

                    var pinOptions = {
                        hidePopup: true,
                        draggable: false,
                        useImagesInPin: true
                    };

                    ctrl.markers = [];
                    venueMarker = mapObjectFactory.createDealerMarkerHere(updatedVenue, pinOptions);
                    ctrl.markers.push(venueMarker);
                    ctrl.hereMap.updateMarkers(ctrl.markers, true);

                    ctrl.hereMap.getMap().addEventListener('drag',
                        function() {
                            var coordinate = ctrl.hereMap.getCenter();

                            var distance = enrollmentService.getDistanceFromLatLonInKm(dealerOrigLatLng.lat,
                                dealerOrigLatLng.lng,
                                coordinate.lat,
                                coordinate.lng);
                            var circleStateGood = distance < pinRadius / 1000;

                            if (circleStateGood !== circlePreviousStateGood) {
                                ctrl.hereMap.removeCircle();

                                if (circleStateGood) {
                                    ctrl.hereMap.addCircle(dealerOrigLatLng.lat,
                                        dealerOrigLatLng.lng,
                                        pinRadius,
                                        perimeterStyle.circleStyleGood);
                                } else {
                                    ctrl.hereMap.addCircle(dealerOrigLatLng.lat,
                                        dealerOrigLatLng.lng,
                                        pinRadius,
                                        perimeterStyle.circleStyleBad);
                                }

                                circlePreviousStateGood = circleStateGood;
                            }

                            ctrl.outOfBounds = !circleStateGood;
                            ctrl.canSave = circleStateGood;
                            updatedVenue.lat = coordinate.lat;
                            updatedVenue.lng = coordinate.lng;

                            ctrl.hereMap.getMarkers()[0].setGeometry({ lat: updatedVenue.lat, lng: updatedVenue.lng });
                        });

                    ctrl.hereMap.getMap().addEventListener('dragend',
                        function() {
                            var coordinate = ctrl.hereMap.getCenter();

                            var distance = enrollmentService.getDistanceFromLatLonInKm(dealerOrigLatLng.lat,
                                dealerOrigLatLng.lng,
                                coordinate.lat,
                                coordinate.lng);
                            ctrl.showDistanceWarning = distance > pinRadius / 1000;
                            ctrl.showDistanceOk = !ctrl.showDistanceWarning;

                            ctrl.isProcessing = false;
                            ctrl.canSave = !ctrl.showDistanceWarning;
                        });

                    if (circleExists)
                        ctrl.hereMap.removeCircle();

                    ctrl.hereMap.addCircle(dealerOrigLatLng.lat,
                        dealerOrigLatLng.lng,
                        pinRadius,
                        perimeterStyle.circleStyle);
                    circleExists = true;
                    circlePreviousStateGood = null;
                    ctrl.hereMap.setZoom(19);

                    ctrl.showMapCover = false;
                }
            };

            ctrl.copyFromVenueChanged = function() {
                ctrl.copyFromVenue = _.find(ctrl.copyFromVenues,
                    function(t) {
                        return t.id === ctrl.copyFromVenueId;
                    });

                if (ctrl.copyFromVenue) {
                    updatePlace(ctrl.copyFromVenue);
                }
            };

            function updatePlace(venue) {
                var address = {
                    location: {
                        streetNumber: venue.streetNumber,
                        address: venue.address,
                        city: venue.city,
                        state: venue.state,
                        zip: venue.zip,
                        lat: venue.lat,
                        lng: venue.lng,
                        countryCode: venue.countryCode || 'USA'
                    }
                };

                ctrl.newLocation = {
                    address: `${venue.address} ${venue.city}, ${venue.state} ${venue.zip}`
                };

                ctrl.placeUpdated(address);
            }
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$rootScope", "consumerAppointmentService"];
    angular
        .module('redcap')
        .component('visualDate', {
            templateUrl: 'app/shared/components/visualDateTime/visual-date.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'minDate': '<', // date format 'YYYY-MM-DD'
                'startDate': '=',
                'daysDisplayed': '<',
                'businessHours': '<', // if we have business hours to check for if they are closed certain days
                'closedConstraints': '<' // additional business contstraints to look for random days off in
            }
        });

    function controller($rootScope, consumerAppointmentService) {

        this.$onInit = function() {
            var vm = this,
                daysToAdd = vm.daysDisplayed - 1,
                momentToday = moment.utc(new Date()),
                todaysDate = momentToday.format('YYYY-MM-DD');

            vm.processedClosedConstraints = null;

            if (!vm.minDate) {
                vm.minCalendarDate = todaysDate;
            } else {
                vm.minCalendarDate = moment.utc(new Date(vm.minDate)).format('YYYY-MM-DD');
            }

            vm.monthDisplay = null;
            vm.yearDisplay = null;


            /*
             * setMonthDisplay takes startDateMonth and endDateMonth
             * and determines if we need to display one month in the
             * header or two months 'JAN' or 'JAN/FEB' if start and end
             * spans two months.
             */
            function setMonthDisplay(startDateMonth, endDateMonth) {
                if (startDateMonth === endDateMonth) {
                    vm.monthDisplay = startDateMonth;
                } else {
                    vm.monthDisplay = startDateMonth + "/" + endDateMonth;
                }
            }

            /*
             * setMonthDisplay takes startDateYear and endDateYear
             * and determines if we need to display one year in the
             * header or two years '2022' or '2022/2033' if start and end
             * spans two years.
             */
            function setYearDisplay(startDateYear, endDateYear) {
                if (startDateYear === endDateYear) {
                    vm.yearDisplay = startDateYear;
                } else {
                    vm.yearDisplay = startDateYear + "/" + endDateYear;
                }
            }

            /*
             * go through the closed constraints and find the next valid date
             * for every closed constraint
             */


            function init(startDate) {
                var startDateMonth = startDate.format('MMMM'),
                    endDate = startDate.add(daysToAdd, 'days'),
                    endDateMonth = endDate.format('MMMM'),
                    startDateYear = startDate.format('YYYY'),
                    endDateYear = endDate.format('YYYY');

                setMonthDisplay(startDateMonth, endDateMonth);
                setYearDisplay(startDateYear, endDateYear);
                vm.currentMomentDate = moment(new Date(vm.startDate));
                vm.calendarDate = vm.currentMomentDate.format('YYYY-MM-DD');

            }

            /*
             * adjustDate move the displayed days forward or backward X days
             * days might be a negative number.  Check to see if the startDate
             * is before the minDate allowed and if so, just set it to the minDate
             * called when the forward and back arrows are clicked
             */
            function adjustDate(days) {
                var startDate = moment.utc(new Date(vm.startDate));
                startDate = startDate.add(days, 'days');

                // if going back 'x' days puts them before current date
                // just set it to today's date
                if (startDate.isSameOrBefore(vm.minCalendarDate)) {
                    startDate = moment.utc(new Date(vm.minCalendarDate));
                }

                vm.startDate = startDate.format("MM/DD/YYYY");
                $rootScope.$broadcast('updateStartDate', vm.startDate);
                init(startDate);
            }

            vm.disableBackArrrow = function() {
                return vm.currentMomentDate.isSameOrBefore(vm.minCalendarDate);
            };

            /*
             * dateChanged updates the startDate displayed and the day selected on the
             * calendar and re-initializes the data displayed
             */
            vm.dateChanged = function(newValue, oldValue) {
                var temp = newValue.format("MM/DD/YYYY");

                // don't call update avail if we aren't changing the date
                if (temp !== vm.startDate) {
                    vm.startDate = newValue.format("MM/DD/YYYY");
                    $rootScope.$broadcast('updateStartDate', vm.startDate);
                    var startDate = moment.utc(new Date(vm.startDate));
                    init(startDate);
                }
            };

            vm.backArrowClicked = function() {
                adjustDate(vm.daysDisplayed * -1);
            };

            vm.forwardArrowClicked = function() {
                adjustDate(vm.daysDisplayed);
            };

            /*
             * function to determine if date should be selectable based
             * on the hours and constraints passed in
             */
            vm.isDateSelectable = function(date, type) {
                return consumerAppointmentService.isDateSelecteable(date, type, vm.businessHours, vm.closedConstraints);
            };

            init(moment.utc(new Date(vm.startDate)));

        };
    }


})();


(function () {
    'use strict';

    controller.$inject = ["$rootScope", "$timeout", "$filter", "appointmentUtilService", "promiseTimeService"];
    angular
        .module('redcap')
        .component('visualDateTime', {
            templateUrl: 'app/shared/components/visualDateTime/visual-date-time.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'timeSlots': '<',
                'transportationType': '<',
                'selectedDay': '=',
                'selectedTime': '=',
                'daysDisplayed': '<'
            }
        });

    function controller($rootScope, $timeout, $filter, appointmentUtilService, promiseTimeService) {

        this.$onInit = function() {
            let vm = this;
            let datePlaceHolder =
                '2022/01/11 '; // we need a random date to put in front of times when we're comparing times.

            vm.unavailableMGTimeslotsDict = {};

            /*
             * function setTimeDropdownDirection use the position of the event click
             * and the approx size of the drop down menu to determine if the dropdown needs to
             * be opened going in the up or down direction, and applies the appropriate classes
             */
            function setTimeDropdownDirection($event) {

                let spaceFromBottom = $(window).height() - $event.clientY;
                let spaceFromTop = $event.clientY;
                let slotCount = vm.selectedTimeGroup.slots.length; // add one for the label
                let ulHeight = slotCount * 32 + 45; // about 32px for each item and some padding

                if (!vm.angularTimeSlotEl) {
                    vm.angularTimeSlotEl = angular.element('#visual-time-slots');
                }

                if (ulHeight > spaceFromBottom && ulHeight < spaceFromTop) {
                    vm.angularTimeSlotEl.addClass("dropup");
                    vm.angularTimeSlotEl.removeClass("ddown");
                } else {
                    vm.angularTimeSlotEl.removeClass("dropup");
                    vm.angularTimeSlotEl.addClass("ddown");
                }
            }

            /*
             * getButtonLabel determines the label for each of the pill buttons
             */
            vm.getButtonLabel = function(slot) {
                return slot.selected && vm.selectedTime
                    ? vm.transportationType.isPickup
                    ? vm.selectedTime.pickupTime
                    : vm.selectedTime.blockTime
                    : slot.label;
            };

            /*
             * after the angular upgrade sems to be a problem using the data filter, so using moment instead
             */
            vm.getDropdownLabel = function (item) {
                let time = vm.transportationType.isPickup === true ? item.pickupTime : item.blockTime;

                return moment(time, 'YYYY-MM-DD HH:mm A').format("h:mm A");
            };

            /*
             * setSelectedTime is called after a time is clicked in the drop down and updates the
             * time slot array to remove the selected flag on the previous item and update it on the new one
             * also broadcasts the appropriate events
             */
            vm.setSelectedTime = function(selDay, selGroup, selSlot) {
                let newDay = moment(new Date(selDay.day)).format("MM/DD/YYYY");
                let dayChanged = false;
                let timeChanged = false;

                if (vm.selectedDay !== newDay) {
                    vm.selectedDay = newDay;
                    dayChanged = true;
                }

                if (!vm.selectedTime ||
                    vm.selectedTime.blockTime !== selSlot.blockTime ||
                    vm.selectedTime.pickupTime !== selSlot.pickupTime) {
                    vm.selectedTime = selSlot;
                    timeChanged = true;
                }

                // update the correct bubble to be selected
                if (dayChanged || timeChanged) {
                    let days = vm.timeSlots.days;

                    _.forEach(days,
                        (currDay) => {
                            _.forEach(currDay.displayTimeSlots,
                                (currGroup) => {
                                    currGroup.selected = false;
                                });
                        });

                    selGroup.selected = true;

                    // fire off the events to update the drop downs to 
                    // have the correct time for mobile and update the route
                    if (dayChanged) {
                        $timeout(() => {
                                $rootScope.$broadcast('newDaySelected', selSlot);
                                $rootScope.$broadcast('newTimeSelected');
                            },
                            1);
                    } else if (timeChanged) {
                        $timeout(() => {
                                $rootScope.$broadcast('newTimeSelected');
                            },
                            1);
                    }

                }

            };

            vm.isTimeSelected = function(item) {
                if (!vm.selectedTime) return false;

                return vm.transportationType.isPickup
                    ? item.pickupTime === vm.selectedTime.pickupTime
                    : item.blockTime === vm.selectedTime.blockTime;
            };

            vm.timeBubbleClicked = function(timeGroup, $event) {
                vm.selectedTimeGroup = timeGroup;
                setTimeDropdownDirection($event);
            };

            function roundNextHour(fromTime) {
                let m = moment(new Date(datePlaceHolder + fromTime));
                let roundUp = m.minute() || m.second() || m.millisecond()
                    ? m.add(1, 'hour').startOf('hour')
                    : m.startOf('hour');

                return roundUp.format("hh:mm A");
            }

            function addHour(fromTime) {
                let m = moment(datePlaceHolder + fromTime, 'YYYY/MM/DD HH:mm A');

                return m.add(1, 'hour');
            }

            function roundPrevHour(fromTime) {
                let m = moment(new Date(datePlaceHolder + fromTime));
                let roundDown = m.startOf('hour');

                return roundDown.format("hh:mm A");
            }

            /*
             * getStartEndTimes determines the earliest and latest times
             * across all of the days passed in to display so that we can
             * display the same time slots for every single day
             * So if one day starts at 9am, but another starts at 6am,
             * we start every day at 6am.  Also we will end every day at the latest
             * time.
             */
            function getStartEndTimes() {
                let days = vm.timeSlots.days;
                let earliestTime = null;
                let latestTime = null;
                let timeSlotBlocks = null;
                let firstBlockTime = null;
                let lastBlockTime = null;
                let currBlock;
                let foundHours = false;
                let blockCnt;

                _.forEach(days,
                    (day) => {
                        timeSlotBlocks = day.timeSlotBlocks;

                        if (timeSlotBlocks.length > 0) {

                            // find the earliest time for this day
                            for (blockCnt = 0; blockCnt < timeSlotBlocks.length; blockCnt++) {
                                currBlock = timeSlotBlocks[blockCnt];

                                if (currBlock.unavailable === false ||
                                    (vm.selectedTime && currBlock.blockTime === vm.selectedTime.blockTime)) {
                                    foundHours = true;

                                    firstBlockTime = vm.transportationType.isPickup ? currBlock.pickupTime : currBlock.blockTime;

                                    if (!earliestTime) {
                                        earliestTime = moment(new Date(firstBlockTime)).format('hh:mm A');
                                    } else {
                                        let timeOnly = moment(new Date(firstBlockTime)).format('hh:mm A');
                                        let tempFirst = moment(timeOnly, 'hh:mm A');
                                        let tempEarliest = moment(earliestTime, 'hh:mm A');

                                        if (tempFirst.isBefore(tempEarliest)) {
                                            earliestTime = timeOnly;
                                        }
                                    }

                                    blockCnt = timeSlotBlocks.length;
                                }
                            }

                            // find the latest time for this day
                            if (foundHours) {
                                for (blockCnt = timeSlotBlocks.length - 1; blockCnt >= 0; blockCnt--) {
                                    currBlock = timeSlotBlocks[blockCnt];

                                    if (currBlock.unavailable === false) {
                                        lastBlockTime =
                                        vm.transportationType.isPickup ? currBlock.pickupTime : currBlock.blockTime;

                                        if (!latestTime) {
                                            latestTime = moment(new Date(lastBlockTime)).format('hh:mm A');
                                        } else {
                                            let timeOnlyLast = moment(new Date(lastBlockTime)).format('hh:mm A');
                                            let tempLast = moment(timeOnlyLast, 'hh:mm A');
                                            let tempLatest = moment(latestTime, 'hh:mm A');

                                            if (tempLast.isAfter(tempLatest)) {
                                                latestTime = timeOnlyLast;
                                            }
                                        }

                                        blockCnt = -1;
                                    }
                                }
                            }
                        }
                    });

                    if (!foundHours) {
                        _.forEach(days, (day) => {
                            if (!day.hoursOfOperation) return;
                            
                            let startTime = moment(day.hoursOfOperation.startTime, 'HH:mm:ss');
                            let endTime = moment(day.hoursOfOperation.endTime, 'HH:mm:ss');

                            if (!earliestTime || startTime.isBefore(earliestTime)) {
                                earliestTime = startTime;
                            }

                            if (!latestTime || endTime.isAfter(latestTime)) {
                                latestTime = endTime;
                            }
                        });
                        
                        if (!earliestTime || !latestTime) {
                            vm.closedEveryDay = true;
                            vm.earliestTime = null;
                            vm.latestTime = null;

                            return;
                        }

                        earliestTime = earliestTime.format('hh:mm A');
                        latestTime = latestTime.format('hh:mm A');
                    }

                vm.closedEveryDay = !foundHours;
                vm.earliestTime = earliestTime;
                vm.latestTime = latestTime;
                vm.secondTimeSlot = roundNextHour(vm.earliestTime);
                vm.lastTimeSlot = roundPrevHour(vm.latestTime);
            }

            /*
             * generateDisplayTimeSlot takes a day and a time and creates a new array in the format we need
             * for the visual date time picker
             */
            function generateDisplayTimeSlot(day, timeSlotToFill) {
                let hourToMatch = timeSlotToFill ? parseInt(timeSlotToFill.split(":")[0]) : null;
                let label = moment(new Date(datePlaceHolder + timeSlotToFill)).format('h:mm A');
                let timeSlots = [];
                let selectedTime = vm.selectedTime;
                let containsSelectedTime = false;


                _.forEach(day.timeSlotBlocks,
                    (block) => {
                        let dateToCheck = null;

                        if (vm.transportationType.isPickup) {
                            dateToCheck = new Date(block.pickupTime);
                        } else {
                            dateToCheck = new Date(block.blockTime);
                        }

                        if (dateToCheck.getHours() === hourToMatch) {
                            // does it match the selected time?
                            if (selectedTime &&
                                selectedTime.blockTime === block.blockTime &&
                                selectedTime.pickupTime === block.pickupTime) {
                                containsSelectedTime = true;
                            }

                            let result = null;

                            if (vm.transportationType.isPickup) {
                                result = $filter('filter')(timeSlots, {pickupTime: block.pickupTime}, true);
                            } else {
                                result = $filter('filter')(timeSlots, {blockTime: block.blockTime}, true);
                            }

                            if (!result || result.length === 0) {
                                timeSlots.push(block);
                            }

                        }
                    });
  
                if (timeSlots.length > 0) {
                    timeSlots.forEach(slot => {
                        if (slot?.appointmentDataList?.length > 0) {
                            let {firstHour, lastHour} = promiseTimeService.getFirstAndLastHoursFromApptDataList(slot.appointmentDataList);
                            let firstDateTime = new Date(firstHour);
                            let lastDateTime = new Date(lastHour);
                            let date = firstDateTime.toLocaleDateString();

                            if (!vm.unavailableMGTimeslotsDict[date]) {
                                vm.unavailableMGTimeslotsDict[date] = [];
                            }

                            vm.unavailableMGTimeslotsDict[date].push({firstDateTime, lastDateTime});
                        }
                    });
                }

                setMGTimeSlotUnavailable(timeSlots);

                // are all of the slots in here disabled?
                let hasAvailSlots = timeSlots.length > 0 &&
                    _.find(timeSlots, {unavailable: false});

                return {
                    label: label,
                    slots: timeSlots,
                    disabled: timeSlots.length === 0 || !hasAvailSlots,
                    selected: containsSelectedTime
                };
            }

            function setMGTimeSlotUnavailable(timeSlots) {
                if (!timeSlots || !Array.isArray(timeSlots)) return;

                timeSlots.forEach(slot => {
                    let startDateTime = null;
    
                    if (slot.appointmentDataList.length > 0) {
                        let {firstHour} = promiseTimeService.getFirstAndLastHoursFromApptDataList(slot.appointmentDataList);

                        startDateTime = new Date(firstHour);
                    } else {
                        startDateTime = new Date(slot.blockTime);
                    }
        
                    if (vm.unavailableMGTimeslotsDict[startDateTime.toLocaleDateString()]) {
                        let dayTimeFrames = vm.unavailableMGTimeslotsDict[startDateTime.toLocaleDateString()];
        
                        dayTimeFrames.forEach(timeFrame => {
                            if (startDateTime >= timeFrame.firstDateTime && startDateTime <= timeFrame.lastDateTime) {
                                slot.unavailable = true;
                            }
                        });
                    }
                });

            }

            /*
             * generateTimeArray takes the time slots from the avail engine
             * and reformats them to what we need to display in this calendar control
             */
            function generateTimeArray() {
                let days = vm.timeSlots.days;
                let earliestTime = vm.earliestTime;
                let latestTime = vm.latestTime;
                let dayCnt = 0;

                while (dayCnt < vm.daysDisplayed) {
                    let day = days[dayCnt];
                    let timeToFillMoment = moment(datePlaceHolder + roundPrevHour(earliestTime), "YYYY/MM/DD HH:mm A");
                    let momentLatest = moment(datePlaceHolder + latestTime, "YYYY/MM/DD HH:mm A");

                    day.displayTimeSlots = [];

                    while (timeToFillMoment.isSameOrBefore(momentLatest)) {
                        day.displayTimeSlots.push(generateDisplayTimeSlot(day, timeToFillMoment.format('H:mm')));
                        timeToFillMoment = addHour(timeToFillMoment.format('HH:mm A'));
                    }

                    dayCnt ++;
                }

            }

            function init() {
                getStartEndTimes();
                generateTimeArray();
            }

            init();

        };
    }


})();


(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS"];
    angular
        .module('redcap')
        .component('uiSelectSearch', {
            templateUrl: 'app/shared/components/ui-select/ui-select-search.component.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '=',
                'newItemDisplayText': '@',
                'selectedItemDisplayText': '&?',
                'formatSelection': '&',
                'searchFunction': '&?',
                'searchPreventionFunction': '&?',
                'itemSelected': '&?',
                'addNewSelected': '&?',
                'processResults': '&?',
                'searchPlaceholder': '@',
                'searchCleared': '&?',
                'availableItems': '<?',
                'searchDisabled': '<?',
                'refreshDelay': '<',
                'disabled': '<?',
                'showSpinner': '<?'
}
        });

    function controller(SYSTEM_ENUMS) {

        this.$onInit = function () {
            let vm = this;

            vm.refreshDelay = vm.refreshDelay || 1950;

            vm.search = function (searchString) {

                let canSearch = !vm.searchPreventionFunction || !vm.searchPreventionFunction(searchString);

                if (!canSearch || !searchString || searchString.length < 3) {
                    return [];
                }

                vm.isSearching = true;
                vm.ngModel = null;

                return vm.searchFunction({searchString: searchString}).then((results) => {
                    if (results && results.length > 0) {
                        if (!vm.processResults) {
                            vm.availableItems = results;
                        } else {
                            vm.availableItems = vm.processResults({results: results});
                        }

                    } else {
                        vm.itemNotFound(searchString);
                    }
                }).catch((errorResponse) => {
                    vm.itemNotFound(searchString);
                }).finally(() => {
                    vm.isSearching = false;
                    vm.createNew();
                });
            };

            vm.createNew = function () {
                vm.availableItems.push({
                    displayMessage: 'Create a New Record.',
                    isNew: true
                });
            };

            vm.forceAddNew = function ($select) {
                vm.ngModel = {
                    displayMessage: vm.newItemDisplayText,
                    isNew: true
                };

                vm.addNewSelected && vm.addNewSelected(vm.ngModel, $select);
                $select.close();
            };

            vm.typeAheadFormat = function (item) {
                if (item) {
                    if (item.isFound === false) {
                        return `<div class="margin-top-md">${item.displayMessage}</div>`;
                    } else if (item.isNew) {
                        return '<span class="theme-link no-underline text-normal-case">Can\'t find it?  </span><span class="theme-link create-new">Create a New Record.</span>';
                    }
                }

                if (!vm.formatSelection) {
                    return item;
                }

                return vm.formatSelection({item: item});
            };

            vm.itemNotFound = function (searchString) {
                vm.availableItems = [{
                    displayMessage: `No results match ${searchString}`,
                    isFound: false
                }];
            };

            vm.itemIsSelected = function () {
                if (vm.ngModel) {
                    if (vm.ngModel.isNew) {
                        vm.ngModel.displayMessage = vm.newItemDisplayText;
                    }

                    vm.itemSelected({item: vm.ngModel});
                }
            };

            vm.clearSelectedItem = function() {
                vm.ngModel = null;
                vm.searchCleared && vm.searchCleared();
            };

            vm.getDisplayMessage = function (selectedItem) {
                if (selectedItem) {
                    let text = vm.selectedItemDisplayText && vm.selectedItemDisplayText({item: selectedItem}) || '';

                    return text + (selectedItem.displayMessage || '');
                }

                return '';
            };
        };

    }


})();

(function () {
    'use strict';

    TypeaheadTaggedInputController.$inject = ["$element", "$timeout", "TAGGED_INPUT_MAX_SUGGESTIONS"];
    angular
        .module('redcap.appointment')
        .component('typeaheadTaggedInput', {
            bindings: {
                // Two-way bindings
                selectedItems: '=',
                searchQuery: '=',
                isFocused: '=?',
                isSearching: '=?',
                isDisabled: '=',
                // One-way bindings
                placeholder: '@',
                minLength: '@',
                maxTags: '@',
                displayProperty: '@',
                autocompleteDisplayProperty: '@',
                keyProperty: '@',
                loadOnFocus: '@',
                loadOnEmpty: '@',
                maxResultsToShow: '@',
                debounceDelay: '@',
                suggestions: '<',
                noResultsCount: '<',
                noResultsMessage: '@',
                noResultsSubMessage: '@',
                minLengthActionText: '@?',
                onMinLengthAction: '&?',
                onRegister: '&?',
                // Callbacks
                onSearch: '&',
                onSelected: '&',
                onRemoved: '&',
                shouldIgnoreSuggestion: '&?',
                onEmptyFocus: '&?',
                // Optional features
                showDropdownArrow: '@'
            },
            templateUrl: 'app/shared/components/typeAheadTaggedInput/typeahead-tagged-input.view.html',
            controller: TypeaheadTaggedInputController
        });

    function TypeaheadTaggedInputController($element, $timeout, TAGGED_INPUT_MAX_SUGGESTIONS) {
        let $ctrl = this;
        let _tagsInputEvents = null;

        // if focus leaves with no selection, clear typed query text.
        function clearQueryWhenNothingSelected() {
            const hasSelection = Array.isArray($ctrl.selectedItems) && $ctrl.selectedItems.length > 0;

            if (!hasSelection) {
                $ctrl.searchQuery = '';
            }
        }

        $ctrl.$onInit = function () {
            // Set defaults
            $ctrl.keyProperty = $ctrl.keyProperty || 'id';
            $ctrl.displayProperty = $ctrl.displayProperty || 'name';
            $ctrl.autocompleteDisplayProperty = $ctrl.autocompleteDisplayProperty || $ctrl.displayProperty;
            $ctrl.maxTags = $ctrl.maxTags || 1;
            $ctrl.minLength = $ctrl.minLength || 3;
            const parsedMinLength = Number.parseInt($ctrl.minLength, 10);

            $ctrl.effectiveMinLength = Number.isNaN(parsedMinLength) ? 3 : parsedMinLength;
            $ctrl.maxResultsToShow = $ctrl.maxResultsToShow || TAGGED_INPUT_MAX_SUGGESTIONS;
            $ctrl.debounceDelay = $ctrl.debounceDelay || 750;

            // Normalize state so consumers can pass minimal bindings consistently.
            $ctrl.selectedItems = Array.isArray($ctrl.selectedItems) ? $ctrl.selectedItems : [];
            $ctrl.searchQuery = typeof $ctrl.searchQuery === 'string' ? $ctrl.searchQuery : '';
            $ctrl.isFocused = $ctrl.isFocused === true;
            $ctrl.isSearching = $ctrl.isSearching === true;
            $ctrl.suggestions = Array.isArray($ctrl.suggestions) ? $ctrl.suggestions : [];
            $ctrl.hasSearched = false;
            $ctrl.noResultsCount = Number.isFinite($ctrl.noResultsCount) ? $ctrl.noResultsCount : 0;
            $ctrl.lastMinLengthActionAt = 0;
            $ctrl.searchRequestId = 0;

            if (typeof $ctrl.onRegister === 'function') {
                $ctrl.onRegister({ctrl: $ctrl});
            }
        };

        $ctrl.$postLink = function () {
            $timeout(() => {
                const tagsInputScope = angular.element($element[0].querySelector('input.input')).scope();

                _tagsInputEvents = tagsInputScope?.events;
            });
        };

        $ctrl.onFocus = function () {
            $ctrl.isFocused = true;

            const hasSelection = Array.isArray($ctrl.selectedItems) && $ctrl.selectedItems.length > 0;
            const currentText = $element[0].querySelector('input.input')?.value || '';

            if (!hasSelection && currentText.length === 0) {
                $ctrl.searchQuery = '';
                if (typeof $ctrl.onEmptyFocus === 'function') $ctrl.onEmptyFocus();
            }
        };

        $ctrl.search = function (query) {
            const safeQuery = typeof query === 'string' ? query : '';
            const liveInputQuery = $element[0].querySelector('input.input')?.value || '';

            if (liveInputQuery.length < $ctrl.effectiveMinLength) {
                $ctrl.searchRequestId++;
                $ctrl.searchQuery = liveInputQuery;
                $ctrl.isSearching = false;

                return [];
            }

            // ngTagsInput can emit delayed/debounced queries after the user has already typed/backspaced.
            // Ignore stale callback payloads and only search using the current live input text.
            if (safeQuery !== liveInputQuery) {
                $ctrl.searchRequestId++;
                $ctrl.searchQuery = liveInputQuery;
                if (liveInputQuery.length < $ctrl.effectiveMinLength) $ctrl.isSearching = false;

                return [];
            }

            const requestId = ++$ctrl.searchRequestId;

            $ctrl.hasSearched = true;
            $ctrl.searchQuery = safeQuery;

            return Promise.resolve($ctrl.onSearch({$query: safeQuery})).then((results) => {
                const currentQuery = $ctrl.searchQuery || '';

                if (requestId !== $ctrl.searchRequestId || currentQuery !== safeQuery) {
                    return [];
                }

                return results;
            });
        };

        $ctrl.reset = function (clearSuggestions) {
            $ctrl.searchRequestId++;
            $ctrl.selectedItems = [];
            $ctrl.searchQuery = '';
            $ctrl.isSearching = false;
            $ctrl.isFocused = false;
            $ctrl.hasSearched = false;
            if (clearSuggestions) $ctrl.suggestions = [];
        };

        $ctrl.openFromArrow = function () {
            if ($ctrl.selectedItems?.length > 0) return;
            $timeout(() => {
                $element[0].querySelector('input.input')?.focus();
            }, 0);
        };

        $ctrl.triggerSearch = function (query) {
            $timeout(() => {
                const inputEl = $element[0].querySelector('input.input');

                if (inputEl) {
                    inputEl.focus();
                    inputEl.value = query;
                }

                $ctrl.searchQuery = query;

                if (_tagsInputEvents) {
                    _tagsInputEvents.trigger('input-change', query);
                }
            }, 0);
        };

        $ctrl.onBlur = function () {
            $ctrl.isFocused = false;

            // let tag selection handlers run before we decide whether to clear.
            $timeout(clearQueryWhenNothingSelected, 0, false);
        };

        $ctrl.triggerMinLengthAction = function ($event) {
            $event?.preventDefault?.();
            $event?.stopPropagation?.();

            const now = Date.now();

            if (now - $ctrl.lastMinLengthActionAt < 300) return;
            $ctrl.lastMinLengthActionAt = now;

            if (typeof $ctrl.onMinLengthAction === 'function') {
                $ctrl.onMinLengthAction();
            }
        };

        $ctrl.onTagRemoved = function () {
            // Clear state and DOM input value
            $ctrl.searchRequestId++;
            $ctrl.selectedItems = [];
            $ctrl.searchQuery = '';
            $ctrl.isSearching = false;
            $ctrl.isFocused = false;
            $ctrl.hasSearched = false;
            const inputEl = $element[0].querySelector('input.input');

            if (inputEl) {
                inputEl.value = '';
            }

            // Call parent callback
            if (typeof $ctrl.onRemoved === 'function') {
                $ctrl.onRemoved();
            }
        };

        $ctrl.showNoResults = function () {
            const selectedCount = Array.isArray($ctrl.selectedItems) ? $ctrl.selectedItems.length : 0;
            const query = $ctrl.searchQuery || '';
            const minLength = $ctrl.effectiveMinLength;

            if (!$ctrl.isFocused || selectedCount !== 0 || $ctrl.isSearching || !$ctrl.hasSearched || query.length < minLength || !Array.isArray($ctrl.suggestions) || !$ctrl.noResultsMessage) {
                return false;
            }

            const hasRealSuggestions = $ctrl.suggestions.some((suggestion) => {
                if (typeof $ctrl.shouldIgnoreSuggestion !== 'function') {
                    return true;
                }

                return !$ctrl.shouldIgnoreSuggestion({suggestion: suggestion});
            });

            return $ctrl.noResultsCount === 0 && !hasRealSuggestions;
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["SYSTEM_ENUMS"];
    angular
        .module('redcap.loaner')
        .component('loanerPreferenceSummary', {
            templateUrl: 'app/shared/components/loaner/loaner-preference-summary.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function controller(SYSTEM_ENUMS) {

        this.$onInit = function() {
            var vm = this;
            vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
            vm.loanerPreferences = vm.ngModel;

            vm.transportationType = vm.loanerPreferences.transportationType;
            vm.vehicles = vm.loanerPreferences.vehicles || vm.loanerPreferences.vehiclePreferences;
        };

    }

    
})();

/**
 * ng-webworker - ng-webworker creates dynamic webworkers so angular apps can be multi-threaded.
 * @link https://github.com/mattslocum/ng-webworker
 * @license MIT
 */

(function() {
    //NOTE: transferable doesn't work for the worker_wrapper.
    function complete(mVal) {
        // _transferable_ is added to the worker
        postMessage(["complete", mVal]);
    }
    function notify(mVal) {
        // _transferable_ is added to the worker
        postMessage(["notice", mVal]);
    }

    self.onmessage = function(oEvent) {
        var aFuncParts = /function\s*(\w+)(.*)/.exec(oEvent.data.fn),
            aParts = oEvent.data.args || [],
            result;
        aParts.push(oEvent.data.fn);
        if (aFuncParts && aFuncParts.length) {
            eval("self['" + aFuncParts[1] + "'] = " + oEvent.data.fn);

            postMessage([
                'return',
                self[aFuncParts[1]].apply(null, oEvent.data.args)
            ]);
        }
    };

})();
/**
 * ng-webworker - ng-webworker creates dynamic webworkers so angular apps can be multi-threaded.
 * @link https://github.com/mattslocum/ng-webworker
 * @license MIT
 */
!function (name, context, definition) {
    // CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = definition();
    // AMD
    else if (typeof define === 'function' && define.amd) define(definition);
    // <script>
    else context[name] = definition();
}('ngWebworker', globalThis, function () {
    'use strict';

    var oWebworkerModule = angular.module('ngWebworker', []),
        CONST_FUNCTION = "function",
        CONST_RETURN = "return",
        CONST_COMPLETE = "complete",
        CONST_NOTICE = "notice";


    oWebworkerModule.provider('Webworker', function() {
        var WebworkerConfig = {
            async: false,
            helperPath: "worker_wrapper.js",
            useHelper: false, // gets set back to true for IE
            transferOwnership: true // if you pass in a ByteArray. Warning: Experimental
        };

        this.setConfig = function(oConfig) {
            angular.extend(WebworkerConfig, oConfig);
        };
        this.setHelperPath = function(strPath) {
            WebworkerConfig.helperPath = strPath;
        };
        this.setUseHelper = function(bUse) {
            WebworkerConfig.useHelper = !!bUse;
        };
        this.setTransferOwnership = function(bTransfer) {
            WebworkerConfig.transferOwnership = !!bTransfer;
        };


        function Webworker($q) {
            var min_safe = {};

            // only use these min_safe functions inside the webworker
            min_safe._transferable_ = function(messageData) {
                var messageDataTransfers = [];

                if (Object.prototype.toString.apply(messageData) != '[object Array]') {
                    messageData = [messageData];
                }

                messageData.forEach(function (data) {
                    if (data instanceof ArrayBuffer) {
                        messageDataTransfers.push(data);
                    }
                });

                return messageDataTransfers;
            };
            min_safe.complete = function(mVal) {
                // _transferable_ is added to the worker
                postMessage(["complete", mVal], self._transferable_(mVal));
            };
            min_safe.notify = function(mVal) {
                postMessage(["notice", mVal]);
            };


            this.create = function(worker, config) {
                var win = window,
                    URL = win.URL || win.webkitURL,
                    aFuncParts,
                    strWorker,
                    blob,
                    retWorker;

                config = config || {};

                config = angular.extend(
                    angular.copy(WebworkerConfig),
                    config
                );


                // stupid IE thinks Blob Webworkers violate same-origin
                // stupid Edge thinks it's not IE
                if (navigator.userAgent.indexOf('MSIE') !== -1 ||
                    navigator.userAgent.indexOf('Edge') !== -1 ||
                    navigator.appVersion.indexOf('Trident/') > 0) {
                    config.useHelper = true;
                }

                if (Worker && URL && URL.createObjectURL && (Blob || win.BlobBuilder || win.WebKitBlobBuilder || win.MozBlobBuilder)) {
                    if (typeof worker === CONST_FUNCTION) {
                        config.external = false;
                        if (!config.useHelper) {
                            aFuncParts = /function\s*(\w*)(.*)/.exec(worker.toString());
                            aFuncParts[1] = aFuncParts[1] || "__user_func__"; // give unnamed functions a name.

                            // reconstruct function signature
                            strWorker = "function " + aFuncParts[1] + aFuncParts[2];
                            strWorker +=  worker.toString().substring(aFuncParts[0].length);

                            strWorker += ";onmessage=function(e){" +
                                ";var result = " + aFuncParts[1] + ".apply(null,e.data);" +
                                // lets just try to make it transferable
                                "postMessage(['"+ CONST_RETURN +"', result], !_async_ ? self._transferable_(result) : [])" +
                            "};";

                            // add async and transferable function to worker
                            strWorker += "var _async_ = "+ config.async +";self._transferable_=" + min_safe._transferable_.toString() + ";";

                            if (win.Blob) {
                                blob = new Blob([
                                    "self.complete=" + min_safe.complete.toString() + ";",
                                    "self.notify=" + min_safe.notify.toString() + ";",
                                    strWorker
                                ], {type: 'application/javascript'});
                            } else if (win.BlobBuilder || win.WebKitBlobBuilder || win.MozBlobBuilder || win.MSBlobBuilder) { // Backwards-compatibility
                                // WARNING: This isn't tested well because I can can't find any
                                //          other browser other than PhantomJS to test with
                                win.BlobBuilder = win.BlobBuilder || win.WebKitBlobBuilder || win.MozBlobBuilder || win.MSBlobBuilder;
                                blob = new BlobBuilder();
                                blob.append("self.complete=" + min_safe.complete.toString() + ";");
                                blob.append("self.notify=" + min_safe.notify.toString() + ";");
                                blob.append(strWorker);
                                blob = blob.getBlob();
                            }
                        }

                        try {
                            if (config.useHelper) {
                                aFuncParts = /function\s*(\w*)(.*)/.exec(worker.toString());
                                aFuncParts[1] = aFuncParts[1] || "a"; // give unnamed functions a name.

                                // reconstruct function signature
                                strWorker = "function " + aFuncParts[1] + aFuncParts[2];
                                strWorker +=  worker.toString().substring(aFuncParts[0].length);

                                // add async and transferable function to worker
                                //strWorker += ";var _async_ = "+ config.async +";" + transferable.toString();
                                retWorker = new WebworkerGenerator(strWorker, config);
                            } else {
                                retWorker = new WebworkerGenerator(URL.createObjectURL(blob), config);
                            }
                        } catch(e) {}

                    } else {
                        // assume it is a string, and hope for the best
                        config.external = true;
                        retWorker = new WebworkerGenerator(worker, config);

                    // } else {
                    // we can't do webworkers.
                    // FUTURE: Lets shim it. Maybe a timeout?
                    }
                }

                return retWorker;
            };

            function WebworkerGenerator(worker, config) {
                var noop = function() {};

                if (config.external || !config.useHelper) {
                    this.oWorker = new Worker(worker);
                } else {
                    this.oWorker = new Worker(WebworkerConfig.helperPath);
                    this.strWorkerFunc = worker;
                }

                // setup default events so they will always be there
                this.config = angular.extend({
                    onMessage: noop,
                    onError: noop,
                    onReturn: noop,
                    onComplete: noop,
                    onNotice: noop
                }, config);

                // support webworker lowercase style
                if (config.onmessage) {
                    this.config.onMessage = config.onmessage;
                    this.config.onError = config.onerror;
                }
            }

            //TODO: save copy of promise/worker pair so we can terminate
            WebworkerGenerator.prototype.run = function() {
                var oDeferred = $q.defer(),
                    self = this,
                    messageData;

                this.oWorker.onmessage = function(oEvent) {
                    var strType,
                        oData = oEvent.data;

                    if (self.config.external && !self.config.async) {
                        oDeferred.resolve(oData);
                    } else {
                        strType = oEvent.data.shift();
                        oData = oEvent.data[0];

                        self.config.onMessage(oEvent);

                        // don't notify if we are complete or return
                        if (strType != CONST_COMPLETE && strType != CONST_RETURN) {
                            oDeferred.notify(oData);
                        }

                        if (strType == CONST_RETURN) {
                            if (!self.config.async) {
                                oDeferred.resolve(oData);
                            }
                            self.config.onReturn(oData);
                        } else if (strType == CONST_COMPLETE) {
                            oDeferred.resolve(oData);
                            self.config.onComplete(oData);
                        } else if (strType == CONST_NOTICE) {
                            self.config.onNotice(oData);
                        }
                    }
                };

                this.oWorker.onerror = function(oError) {
                    oDeferred.reject(oError);
                };

                if (self.config.external || !self.config.useHelper) {
                    //FUTURE: Use Array.slice(arguments) when available for V8 optimization
                    messageData = Array.prototype.slice.call(arguments);
                } else {
                    //FUTURE: Use Array.slice(arguments) when available for V8 optimization
                    messageData = {
                        fn: self.strWorkerFunc,
                        args: Array.prototype.slice.call(arguments)
                    };
                }

                this.oWorker.postMessage(messageData, transferable(messageData, this));

                if (!self.config.external && !self.config.useHelper) {
                    oDeferred.promise.finally(function () {
                        // Every time run happens on a dynamic web worker it
                        // creates a new web worker to prevent a thread leak,
                        // a worker will only last once
                        self.terminate();
                    });
                }

                return oDeferred.promise;
            };

            WebworkerGenerator.prototype.stop = function() {
                this.oWorker.onerror(new Error('stopped'));
                this.terminate();
            };

            WebworkerGenerator.prototype.terminate = function() {
                this.oWorker.terminate();
            };

            function transferable(messageData, worker) {
                // FUTURE: CanvasProxy and MessagePort when browsers support it.
                var messageDataTransfers = [];

                // the worker_wrapper helper doesn't support transfers right now
                if (worker.config.transferOwnership && !worker.config.useHelper) {
                    angular.forEach(messageData, function(data) {
                        if (data instanceof ArrayBuffer) {
                            messageDataTransfers.push(data);
                        }
                    });
                }

                return messageDataTransfers;
            }
        }

        this.$get = ['$q', function($q) {
            return new Webworker($q);
        }];
    });


    return oWebworkerModule;
});

(function () {
    'use strict';

    angular
        .module('redcap')
        .component('rcListStandardizedFooter', {
            bindings: {
                'locationRequired': '<',
                'selectedLocation': '<',
                'recordCount': '<',
                'canShowMore': '<',
                'isLoading': '<'
            },
            templateUrl: 'app/shared/components/list-standardized-footer/list-standardized-footer.view.html',
            controller: rcListStandardizedFooter,
            controllerAs: 'vm'
        });

    function rcListStandardizedFooter() {

        this.$onInit = function() {
            let vm = this;
            
        };
    }
})();

(function () {
    'use strict';

    ListSelectSavedSearchController.$inject = ["appointmentUtilService"];
    angular
    .module('redcap')
    .component('rcListSelectSavedSearch', {
        bindings: {
            'currentSearchTemplate': '=',
            'searchTemplates': '=',
            'onSelectEvent': '&'
        },
        templateUrl: 'app/shared/components/list-select-saved-search/list-select-saved-search.view.html',
        controller: ListSelectSavedSearchController,
        controllerAs: 'vm'
    });

    function ListSelectSavedSearchController(appointmentUtilService) {
        this.$onInit = function() {
            let vm = this;

            vm.myUniqueId = appointmentUtilService.getUniqueDOMID();
            
            vm.itemSelected = function (item) {
                vm.onSelectEvent({item: item});
            };
        };
    }
})();

(function () {
    'use strict';

    rcListTemplateSaveSearchDeleteBtns.$inject = ["searchTemplateUtilService"];
    angular
        .module('redcap')
        .component('rcListTemplateSaveSearchDeleteBtns', {
            bindings: {
                'listController': '<',
                'currentSearchTemplate': '<',
                'isProcessingTemplate': '<',
                'canManageGlobalTemplates': '<',
                'templateMessage': '<',
                'saveBtnClicked': '&',
                'saveAsBtnClicked': '&'
            },
            templateUrl: 'app/shared/components/list-template-save-search-delete-btns/list-template-save-search-delete-btns.view.html',
            controller: rcListTemplateSaveSearchDeleteBtns,
            controllerAs: 'vm'
        });

    function rcListTemplateSaveSearchDeleteBtns(searchTemplateUtilService) {

        this.$onInit = function() {
            let vm = this;

            vm.displaySaveBtn = function () {
                return searchTemplateUtilService.displaySaveBtn(vm.listController);
            };
            
            vm.displaySaveAsBtn = function () {
                return searchTemplateUtilService.displaySaveAsBtn(vm.listController);
            };
            
            vm.disableSaveBtn = function () {
                return !searchTemplateUtilService.enableSaveBtns(vm.listController) || (vm.listController.searchTemplateData.isTemplateDirty === false && vm.listController.searchTemplateData.currentSearchTemplate !== null);
            };
            
            vm.disableSaveAsBtn = function () {
                return !searchTemplateUtilService.enableSaveBtns(vm.listController);
            };
            
            vm.deleteSearchTemplate = function () {
                searchTemplateUtilService.deleteSearchTemplateClicked(vm.listController);
            };

        };
    }
})();

(function () {
    'use strict';

    ListModeSelectorController.$inject = ["$rootScope"];
    angular
        .module('redcap')
        .component('rcListModeSelector', {
            bindings: {
                'ngModel': '=',
                'availableModes': '=',
                'onSelectEvent': '&',
                'cssClass': '@'
            },
            templateUrl: 'app/shared/components/list-mode-selector/list-mode-selector.view.html',
            controller: ListModeSelectorController,
            controllerAs: 'vm'
        });

    function ListModeSelectorController($rootScope) {

        this.$onInit = function() {
            let vm = this;

            vm.tripListModeChanged = function() {
                if (vm.onSelectEvent) {
                    vm.onSelectEvent();
                }
            };
        };
    }
})();

(function () {
    'use strict';

    rcListAdvancedFilterToggle.$inject = ["$rootScope", "$timeout"];
    angular
        .module('redcap')
        .component('rcListAdvancedFilterToggle', {
            bindings: {
                'ngDisabled': '<',
                'ngDisabledMessage': '<',
                'filterCount': '<',
                'recordCount': '<',
                'filterMessage': '<',
                'alignRight': '=',
                'toggleAdvancedSearch': '&',
                'resetFilters': '&',
                'searchTrayDisplayed': '<'
            },
            templateUrl: 'app/shared/components/list-advanced-filter-toggle/list-advanced-filter-toggle.view.html',
            controller: rcListAdvancedFilterToggle,
            controllerAs: 'vm'
        });

    function rcListAdvancedFilterToggle($rootScope, $timeout) {

        this.$onInit = function() {
            let vm = this;
            let closePopoverTimeout;

            vm.isPopoverOpen = false;

            vm.onMouseEnter = function() {
                // Clear the timeout to prevent the popover from closing
                if (closePopoverTimeout) {
                    $timeout.cancel(closePopoverTimeout);
                }

                vm.isPopoverOpen = true;
            };
        
            vm.onMouseLeave = function() {
                // Set a delay to hide the popover
                closePopoverTimeout = $timeout(() => {
                    vm.isPopoverOpen = false;
                }, 750);
            };
        };
    }
})();

(function () {
    'use strict';

    rcListMobileFilters.$inject = ["$rootScope"];
    angular
        .module('redcap')
        .component('rcListMobileFilters', {
            bindings: {
                'requiredFilterCount': '<',
                'requiredFilterMessage': '<',
                'filterCount': '<',
                'recordCount': '<',
                'filterMessage': '<'
            },
            templateUrl: 'app/shared/components/list-mobile-filters/list-mobile-filters.view.html',
            controller: rcListMobileFilters,
            controllerAs: 'vm'
        });

    function rcListMobileFilters($rootScope) {
        let vm = this;

        this.$onInit = function() {
        
            vm.getAdjustedFilterCount = function() {
                if (vm.requiredFilterCount) 
                    return vm.filterCount - parseInt(vm.requiredFilterCount);
                else 
                    return vm.filterCount;
            };

            
        };
    }
})();

(function () {
    'use strict';

    angular.module('redcap.services', []);
})();

(function () {
    'use strict';

    angular
        .module('redcap.services')
        .factory('mapStyleFactory', mapStyleFactory);

        function mapStyleFactory() {
            return {
                createMapStyle: createMapStyle
            };

            function createMapStyle(style) {
                return mapStyle[style];
            }
        }

        var mapStyle = {
            nightMode: [
                            {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                            {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                            {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                            {
                                featureType: 'administrative.locality',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#d59563'}]
                            },
                            {
                                featureType: 'poi',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#d59563'}]
                            },
                            {
                                featureType: 'poi.park',
                                elementType: 'geometry',
                                stylers: [{color: '#263c3f'}]
                            },
                            {
                                featureType: 'poi.park',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#6b9a76'}]
                            },
                            {
                                featureType: 'road',
                                elementType: 'geometry',
                                stylers: [{color: '#38414e'}]
                            },
                            {
                                featureType: 'road',
                                elementType: 'geometry.stroke',
                                stylers: [{color: '#212a37'}]
                            },
                            {
                                featureType: 'road',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#9ca5b3'}]
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'geometry',
                                stylers: [{color: '#746855'}]
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'geometry.stroke',
                                stylers: [{color: '#1f2835'}]
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#f3d19c'}]
                            },
                            {
                                featureType: 'transit',
                                elementType: 'geometry',
                                stylers: [{color: '#2f3948'}]
                            },
                            {
                                featureType: 'transit.station',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#d59563'}]
                            },
                            {
                                featureType: 'water',
                                elementType: 'geometry',
                                stylers: [{color: '#17263c'}]
                            },
                            {
                                featureType: 'water',
                                elementType: 'labels.text.fill',
                                stylers: [{color: '#515c6d'}]
                            },
                            {
                                featureType: 'water',
                                elementType: 'labels.text.stroke',
                                stylers: [{color: '#17263c'}]
                            }
                        ],
            midnight: [
                            {
                                "featureType": "all",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 13
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#144b53"
                                    },
                                    {
                                        "lightness": 14
                                    },
                                    {
                                        "weight": 1.4
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "color": "#08304b"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#0c4152"
                                    },
                                    {
                                        "lightness": 5
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#0b434f"
                                    },
                                    {
                                        "lightness": 25
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#0b3d51"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "color": "#146474"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "color": "#021019"
                                    }
                                ]
                            }
                        ],
            light: [
                            {
                                "featureType": "administrative.locality",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "hue": "#2c2e33"
                                    },
                                    {
                                        "saturation": 7
                                    },
                                    {
                                        "lightness": 19
                                    },
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "hue": "#ffffff"
                                    },
                                    {
                                        "saturation": -100
                                    },
                                    {
                                        "lightness": 100
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "hue": "#ffffff"
                                    },
                                    {
                                        "saturation": -100
                                    },
                                    {
                                        "lightness": 100
                                    },
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "hue": "#bbc0c4"
                                    },
                                    {
                                        "saturation": -93
                                    },
                                    {
                                        "lightness": 31
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "hue": "#bbc0c4"
                                    },
                                    {
                                        "saturation": -93
                                    },
                                    {
                                        "lightness": 31
                                    },
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "hue": "#bbc0c4"
                                    },
                                    {
                                        "saturation": -93
                                    },
                                    {
                                        "lightness": -2
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "hue": "#e9ebed"
                                    },
                                    {
                                        "saturation": -90
                                    },
                                    {
                                        "lightness": -8
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "hue": "#e9ebed"
                                    },
                                    {
                                        "saturation": 10
                                    },
                                    {
                                        "lightness": 69
                                    },
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "hue": "#e9ebed"
                                    },
                                    {
                                        "saturation": -78
                                    },
                                    {
                                        "lightness": 67
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            }
                        ]
        };
})();
(function () {
    'use strict';

     mapResize.$inject = ["$interval", "$window"];
    angular
        .module('redcap.directives')
        .directive('mapResize', mapResize);
     
     function mapResize($interval, $window){
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var missingGoogleListener = function(){};
                var currentHeightWidth = getElementHeightWidth();
                var intervalCheck = null;

                function onResize(){
                    var newHeightWidth = getElementHeightWidth();
                    if (!_.isNaN(newHeightWidth) && newHeightWidth !== currentHeightWidth) {
                        currentHeightWidth = newHeightWidth;
                        
                        scope.$broadcast('resizeHereMap');
                    }
                }

                function cleanUp() {
                    if (angular.isDefined(intervalCheck)) { 
                        $interval.cancel(intervalCheck);
                    }
                    angular.element($window).off('resize', onResize);
                }

                function getElementHeightWidth() {
                    return element.height() + element.width();
                }

                intervalCheck = $interval(onResize, 500, false);
                angular.element($window).on('resize', onResize);
                scope.$on('$destroy', cleanUp);
            }         
        };
     }        
})();
(function () {
    'use strict';

        mapObjectFactory.$inject = ["SYSTEM_ENUMS", "HERE_MAPS_CONFIG"];
    angular
        .module('redcap.services')
        .factory('mapObjectFactory', mapObjectFactory);

        function mapObjectFactory(SYSTEM_ENUMS, HERE_MAPS_CONFIG) {
            let pathOptions = {
                color: {
                    default: '#3367D6',
                    estimate: '#afafaf',
                    healthy: '#8d8',
                    warning: 'yellow',
                    danger: 'red',
                    zendrive: '#f19609'
                },
                strokeOpacity: {
                    estimate: 0.5,
                    actual: 0.8
                },
                strokeWeight: {
                    estimate: 8,
                    actual: 4
                },
                strokeColor: {
                    estimate: 'rgba(0, 43, 255,' + .5 + ')',
                    actual: 'rgba(0, 43, 255,' + .9 + ')'
                }
            };
            let customerIcon = {
                url: '/assets/images/Customer Pin.png',
                scaledSize: [24, 24],
                origin: [0, 0],
                anchor: [12, 12]    // center of size 24x24
            };
            let dealerIcon = {
                url: '/assets/images/Dealer Pin.png',
                scaledSize: [24, 24],
                origin: [0, 0],
                anchor: [12, 12]    // center of size 24x24
            };
            let genericPickupIcon = {
                url: '/assets/images/pickup-pin.png',
                scaledSize: [34, 58],
                anchor: [17, 58]
            };
            let genericDropoffIcon = {
                url: '/assets/images/dropoff-pin.png',
                scaledSize: [34, 58],
                anchor: [17, 58]
            };
            let enrollGoodIcon = {
                url: '/assets/images/Driver pin Directional.png',
                scaledSize: [34, 58],
                anchor: [17, 53]
            };
            let enrollBadIcon = {
                url: '/assets/images/enroll-marker-red.png',
                scaledSize: [34, 58],
                anchor: [17, 53]
            };  
            let driverIcon = {
                url: '/assets/images/Driver pin.png',
                scaledSize: [20, 20],   // scaledSize: [27, 39], * for when we have a directional pin
                origin: [0, 0],
                anchor: [10, 10],        // anchor: [13, 10]     // top center of 27x39 (uses the center of the circle as the base) when using directional pin
                hereSettings: {
                    size: {h: 20, w: 20},
                    anchor: {x: 10, y: 10}
                }
            };
            let svgDriverIcon = {
                //This is for the driver icon settings when plotting on here maps
                url: null, 
                scaledSize: [50, 50],
                anchor: [25, 25],
                hereSettings: {
                    size: {h: 50, w: 50},
                    anchor: {x: 25, y: 25}
                }
            };           
            let icons = {
                driverIcon: driverIcon,
                svgDriverIcon: svgDriverIcon,
                genericDropoffIcon: genericDropoffIcon,
                genericPickupIcon: genericPickupIcon,
                dealerIcon: dealerIcon,
                customerIcon: customerIcon
            };

            // TODO: Once HERE Maps has fully replaced Google Maps, return to this and remove any unused methods
            return {
                getStatusColor: getStatusColor,
                getPinType: getPinType,
                //createMarker: createMarker,
                createCustomHereMarker: createCustomHereMarker,
                createHereMarker: createHereMarker,
                buildRoute: buildRoute,
                getMapPin: getMapPin,
                icons: icons,
                rotateDriverIcon: rotateDriverIcon,
                createMarkerHere: createMarkerHere,
                pathOptions: pathOptions,
                buildPopupContent: buildPopupContent
            };

            function getStatusColor(status) {
                return status === 1 ? pathOptions.color.healthy : status === 2 ? pathOptions.color.warning : pathOptions.color.danger;
            }

            // TODO: REMOVE ONCE ALL GOOGLE MAP REFERENCES ARE REMOVED AND HERE DIRECTIVE IS USED EVERYWHERE
            function getPinType(stopType) {
                switch (stopType) {
                    case SYSTEM_ENUMS.destinationType.customer:
                        return SYSTEM_ENUMS.mapPinType.customer;
                    case SYSTEM_ENUMS.destinationType.dealer:
                        return SYSTEM_ENUMS.mapPinType.dealership;
                    case SYSTEM_ENUMS.destinationType.driverLocation:
                        return SYSTEM_ENUMS.mapPinType.driver;
                    default:
                        return SYSTEM_ENUMS.mapPinType.stop;
                }
            }

            // TODO: REMOVE ONCE ALL MARKER CREATION GOES THROUGH createMarkerHere
            function createHereMarker(lat, lng, pinType, infoWindow, options) {
                options = options || {};
                let elementId = 'map-marker-' + pinType;
                let marker =  {
                    pos: {
                        lat: lat,
                        lng: lng
                    },
                    draggable: !!options.draggable,
                    type: 'dom',
                    markup: getMapPin(pinType, options.text, elementId, options.destinationType, options.useImagesInPin),
                    events: options.events,
                    data: {
                        elementId: elementId,
                        objectType: options.objectType || SYSTEM_ENUMS.hereObjectType.marker
                    }
                };

                if (infoWindow) {
                    marker.data.popup = infoWindow.markup;
                }

                return marker;
            }

            function buildPopupContent(address) {
                let popupContent = '<div class="here-infowindow"><div><b>';
                let hasName = address.name && address.name.length > 0;

                if (hasName) {
                    popupContent += address.name;
                    popupContent += '</b></div><div>';
                }
 
                popupContent += address.streetAddress;

                if (!hasName) {
                    popupContent + '</b>';
                }

                popupContent += "</div><div>";
                popupContent += address.city + ', ' + address.state + ' ' + address.zip; 
                popupContent += '</div></div>';

                return popupContent;
            }
            
            function createMarkerHere(stopInfo, pinText, options) {
                options = options || {};
                options.text = pinText;
                
                let elementId = 'map-marker-' + stopInfo.stopType;
                let showInfoWindows = !!options.showInfoWindows;
                let marker =  {
                        pos: {
                            lat: stopInfo.latLng.lat,
                            lng: stopInfo.latLng.lng
                        },
                        createInfoWindow: showInfoWindows,
                        draggable: !!options.draggable,
                        type: 'dom',
                        markup: getHerePin(stopInfo, elementId, options),
                        events: options.events,
                        data: {
                            elementId: elementId,
                            objectType: options.objectType || SYSTEM_ENUMS.hereObjectType.marker
                        }
                    };

                if (showInfoWindows) {
                    marker.data.popup = buildPopupContent(stopInfo.address);
                }
                
                return marker;
            }

            function createCustomHereMarker(data, markerType, options) {
                let markerTypes = HERE_MAPS_CONFIG.markerTypes;
                let iconUrl = markerType === markerTypes.dealer ? dealerIcon.url : customerIcon.url;
                let markup = '<div><div class="here-pin image-content"><img width="24" src="' + iconUrl.url + '" /></div></div>';

                options = options || {};
                
                let marker =  {
                    pos: {
                        lat: data.lat,
                        lng: data.lng
                    },
                    createInfoWindow: true,
                    draggable: false,
                    type: 'dom',
                    markup: markup,
                    data: {
                        elementId: 'map-dealer-marker-' + data.id
                    },
                    options: options
                };

                if (!options.hidePopup) {
                    marker.data.popup = buildPopupContent({
                            name: data.name,
                            streetAddress: data.address,
                            city: data.city,
                            state: data.state,
                            zip: data.zip
                        });
                }                
                
                return marker;
            }

            function getHerePin(stopInfo, elementId, options) {
                let pickupDropoffClass = '';
                let pinContent = options.text;

                if (!pinContent && options.useImagesInPin) {
                    if (stopInfo.stopType === SYSTEM_ENUMS.destinationType.dealer) {
                        pinContent = '<img width="24" src="' + dealerIcon.url + '" />';
                        pickupDropoffClass = 'image-content';
                    } else {
                        pinContent = '<img width="24" src="' + customerIcon.url + '" />';
                        pickupDropoffClass = 'image-content';
                    }
                } else if (options.colorBasedOnStopType) {
                    if (stopInfo.locationType === SYSTEM_ENUMS.stopType.pickup)
                        pickupDropoffClass = 'pickup';
                    else
                        pickupDropoffClass = 'dropoff';                    
                } else {
                    if (stopInfo.stopType === SYSTEM_ENUMS.destinationType.dealer)
                        pickupDropoffClass = 'dealer';
                    else
                        pickupDropoffClass = 'customer';
                }
                
                return '<div id="' + elementId + '"><div class="here-pin ' + pickupDropoffClass + '">' + (pinContent || '') + '</div></div>';
            }

            function buildRoute(pathPoints, isEstimatedPath, polylines) {
                if (polylines) {
                    pathPoints = polylines.flatMap((polyline) => {
                        if (polyline) return decodePath(polyline);
                        else return [];
                    });
                }

                let hereRoute = pathPoints.map((point) => {
                    if (point.lat) {
                        return point.lat + ',' + point.lng;
                    } else {
                        return point.join(',');
                    }                
                });

                let routeData = {
                    route: {
                        shape: hereRoute
                    },
                    style: {
                        opacity: isEstimatedPath ? pathOptions.strokeOpacity.estimate : pathOptions.strokeOpacity.actual,
                        lineWidth: isEstimatedPath ? pathOptions.strokeWeight.estimate : pathOptions.strokeWeight.actual,
                        color: isEstimatedPath ? pathOptions.strokeColor.estimate : pathOptions.strokeColor.actual
                    }
                };
                
                return routeData;
            }

            // taken from https://github.com/mapbox/polyline
            function decodePath(encodedPath, precision) {
                let index = 0;
                let lat = 0;
                let lng = 0;
                let coordinates = [];
                let shift = 0;
                let result = 0;
                let byte = null;
                let latitude_change;
                let longitude_change;
                let factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);

                // Coordinates have variable length when encoded, so just keep
                // track of whether we've hit the end of the string. In each
                // loop iteration, a single coordinate is decoded.
                while (index < encodedPath.length) {

                    // Reset shift, result, and byte
                    byte = null;
                    shift = 1;
                    result = 0;

                    do {
                        byte = encodedPath.charCodeAt(index++) - 63;
                        result += (byte & 0x1f) * shift;
                        shift *= 32;
                    } while (byte >= 0x20);

                    latitude_change = (result & 1) ? ((-result - 1) / 2) : (result / 2);

                    shift = 1;
                    result = 0;

                    do {
                        byte = encodedPath.charCodeAt(index++) - 63;
                        result += (byte & 0x1f) * shift;
                        shift *= 32;
                    } while (byte >= 0x20);

                    longitude_change = (result & 1) ? ((-result - 1) / 2) : (result / 2);

                    lat += latitude_change;
                    lng += longitude_change;

                    coordinates.push([lat / factor, lng / factor]);
                }

                return coordinates;
            }

            // TODO: REMOVE ONCE ALL MARKER CREATION GOES THROUGH getHerePin
            function getMapPin(pinType, pinContent, elementId, destinationType, useImagesInPin) {
                let pickupDropoffClass = '';

                if (!pinContent && useImagesInPin) {
                    if (pinType === SYSTEM_ENUMS.destinationType.enrollPodGood) {
                        let wrapperDivGood = '<div style="position: relative; top:' + (enrollGoodIcon.anchor[1] * -1) + 'px">';

                        return '<div id="' + elementId + '">' + wrapperDivGood + '<img width="34" src="' + enrollGoodIcon.url + '" /></div></div>';
                    } else if (pinType === SYSTEM_ENUMS.destinationType.enrollPodBad) {
                        let wrapperDivBad = '<div style="position: relative; top:' + (enrollBadIcon.anchor[1] * -1) + 'px">';

                        return '<div id="' + elementId + '">' + wrapperDivBad + '<img width="34" src="' + enrollBadIcon.url + '" /></div>';
                    } else if (pinType === SYSTEM_ENUMS.destinationType.dealer) {
                        pinContent = '<img width="24" src="' + dealerIcon.url + '" />';
                        pickupDropoffClass = 'image-content';
                    } else {
                        pinContent = '<img width="24" src="' + customerIcon.url + '" />';
                        pickupDropoffClass = 'image-content';
                    }
                } else {
                    if (pinType === SYSTEM_ENUMS.destinationType.genericPickup)
                        pickupDropoffClass = 'pickup';
                    else
                        pickupDropoffClass = 'dropoff';                    
                }

                if (destinationType)
                    pickupDropoffClass += destinationType === SYSTEM_ENUMS.destinationType.dealer ? ' dealer' : ' customer';
                
                return '<div id="' + elementId + '"><div class="here-pin ' + pickupDropoffClass + '">' + (pinContent || '') + '</div></div>';
            }

            function rotateDriverIcon(heading, vehicleColor, beaconColor) {
                let rot = Math.round(heading / 10) * 10;

                beaconColor = beaconColor || '#000000';
                vehicleColor = vehicleColor || '#FFFFFF';

                let driverIconSvg = '<svg style="transform:rotate(' + rot + 'deg); xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="100" height="100" version="1.1" id="svg3729" sodipodi:docname="57600-red-car-top-view-vector1.svg" inkscape:version="0.92.4 (5da689c313, 2019-01-14)"><metadata id="metadata3735"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title /></cc:Work></rdf:RDF></metadata><defs id="defs3733" /><sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10" gridtolerance="10" guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2" inkscape:window-width="1920" inkscape:window-height="1017" id="namedview3731" showgrid="false" inkscape:zoom="3.5333333" inkscape:cx="-47.062671" inkscape:cy="7.8892284" inkscape:window-x="-8" inkscape:window-y="-8" inkscape:window-maximized="1" inkscape:current-layer="svg3729" /><g id="g3727" transform="matrix(0,-0.16495359,0.16486647,0,10.660723,102.6432)"><g externalResourcesRequired="false" id="layer1" display="inline" style="display:inline"><g externalResourcesRequired="false" id="g3890"><path d="m 367.68838,93.998283 c -0.94442,0.0056 -2.95556,0.19088 -4.04962,0.586906 l -2.1911,0.939056 5.41907,22.498225 -78.13645,0.17608 c -1.5252,0.003 -3.05981,-0.009 -4.59735,-0.0195 -3.07513,-0.0215 -6.17584,-0.0654 -9.29266,-0.13694 -4.56546,-0.10474 -9.18323,-0.25851 -13.81183,-0.44997 -0.24783,-0.0103 -0.49542,-0.0286 -0.74341,-0.0391 -9.34823,-0.39452 -18.78561,-0.93385 -28.19088,-1.52596 -12.725,-0.80303 -25.36709,-1.69494 -37.64013,-2.4259 -9.0951,-0.5417 -17.98735,-0.98888 -26.52803,-1.25208 -5.86544,-0.18076 -11.55905,-0.2858 -17.05932,-0.25432 -2.70184,0.0155 -5.36379,0.0584 -7.96233,0.13695 -2.59854,0.0786 -5.24627,0.22242 -7.9232,0.41084 -1.33847,0.0942 -2.67804,0.19422 -4.03006,0.31302 -4.04979,0.35584 -8.16666,0.82725 -12.2663,1.36945 -0.006,6.1e-4 -0.0132,-6.1e-4 -0.0195,0 -2.73735,0.3622 -5.45808,0.76723 -8.17752,1.19338 -2.71943,0.42617 -5.42987,0.8751 -8.09927,1.3499 -2.662989,0.47365 -5.30279,0.97998 -7.884073,1.48684 -0.0063,0.001 -0.01327,-0.001 -0.01954,0 -1.293617,0.25409 -2.547798,0.50345 -3.814865,0.76297 -3.794662,0.77732 -7.470955,1.57515 -10.955536,2.36721 -0.0063,0.001 -0.01321,-10e-4 -0.01954,0 -2.32663,0.52894 -4.56208,1.04872 -6.710251,1.5651 -4.296997,1.03194 -8.210678,2.02498 -11.601128,2.91498 -5.085663,1.33503 -9.003937,2.45856 -11.32724,3.13019 -1.548592,0.44809 -2.386742,0.70428 -2.386742,0.70428 l -8.568787,2.34765 c -0.56493,0.1557 -1.113171,0.43376 -1.64333,0.82168 -0.180122,0.13178 -0.352043,0.27289 -0.528214,0.43039 -0.688377,0.61328 -1.346607,1.42152 -1.975918,2.40633 -0.0029,0.004 0.0029,0.0152 0,0.0195 -0.31324,0.49127 -0.640091,1.02698 -0.939041,1.60422 -0.0026,0.005 0.0026,0.0145 0,0.0195 -0.298981,0.57826 -0.595448,1.19835 -0.88036,1.85853 -0.0023,0.006 0.0023,0.0139 0,0.0195 -2.2957,5.32724 -4.144371,13.22901 -5.595139,22.67429 -9.42e-4,0.006 9.38e-4,0.0133 0,0.0195 -0.02251,0.14659 -0.03637,0.30264 -0.05869,0.44996 -0.315907,2.08565 -0.621048,4.25594 -0.899918,6.47559 -0.01908,0.15191 -0.03979,0.2975 -0.05869,0.44996 -0.314003,2.53116 -0.592682,5.13504 -0.860802,7.8059 -6.29e-4,0.006 6.29e-4,0.0132 0,0.0195 -0.133678,1.33248 -0.268639,2.68872 -0.39127,4.04969 -5.68e-4,0.006 5.8e-4,0.0131 0,0.0195 -0.122581,1.3612 -0.240372,2.72279 -0.352131,4.10836 -5.19e-4,0.006 5.11e-4,0.0131 0,0.0195 -0.223969,2.7781 -0.424568,5.6004 -0.606468,8.45149 -4.12e-4,0.006 4.08e-4,0.0131 0,0.0195 -0.54628,8.56676 -0.91375,17.39678 -1.11512,26.01969 -1.53e-4,0.006 1.49e-4,0.0129 0,0.0195 -0.134239,5.75292 -0.195702,11.40223 -0.195702,16.84452 0,0.60579 0.01725,1.22883 0.01957,1.83897 -0.0023,0.61015 -0.01957,1.2332 -0.01957,1.83899 0,5.44229 0.06145,11.0916 0.195641,16.84433 1.6e-4,0.007 -1.49e-4,0.013 0,0.0195 0.201359,8.62289 0.56884,17.45291 1.11512,26.01965 4.08e-4,0.006 -4.08e-4,0.0132 0,0.0195 0.1819,2.85111 0.3825,5.67337 0.606461,8.45148 5.19e-4,0.006 -5.19e-4,0.0133 0,0.0195 0.111759,1.38559 0.229561,2.74716 0.352139,4.1084 5.8e-4,0.006 -5.68e-4,0.0132 0,0.0195 0.122631,1.36099 0.25758,2.7172 0.391281,4.04968 6.1e-4,0.006 -6.29e-4,0.0132 0,0.0195 0.268101,2.67086 0.546791,5.27475 0.860779,7.8059 0.01891,0.15244 0.03961,0.29804 0.0587,0.44995 0.278862,2.21964 0.584011,4.38996 0.89991,6.47556 0.02232,0.14734 0.03619,0.30341 0.05869,0.44998 9.42e-4,0.006 -9.38e-4,0.0135 0,0.0195 1.450783,9.44528 3.299461,17.34705 5.595161,22.67429 0.0023,0.006 -0.0023,0.0141 0,0.0195 0.284901,0.66019 0.581371,1.28027 0.880341,1.85852 0.0026,0.005 -0.0026,0.0145 0,0.0195 0.298958,0.57724 0.625801,1.11295 0.939049,1.60422 0.0029,0.004 -0.0029,0.0151 0,0.0195 0.629311,0.9848 1.287521,1.79306 1.97591,2.40634 0.17617,0.1575 0.348091,0.29862 0.528221,0.43039 0.530159,0.38791 1.078388,0.66599 1.64333,0.82169 l 8.568787,2.34762 c 0,0 0.83815,0.2562 2.386742,0.70429 2.323303,0.67163 6.24157,1.79516 11.327232,3.13019 3.39045,0.89001 7.304131,1.88305 11.601128,2.91501 2.148178,0.51635 4.383621,1.03613 6.710258,1.56509 0.0064,10e-4 0.01321,-0.001 0.01953,0 3.484581,0.79205 7.160873,1.58987 10.955528,2.36719 1.267075,0.25952 2.521255,0.50888 3.814873,0.763 0.0063,0.001 0.01327,-10e-4 0.01954,0 2.581284,0.50683 5.221085,1.01318 7.884074,1.48681 2.66941,0.47483 5.37984,0.92374 8.09928,1.34992 2.71942,0.42615 5.44015,0.83118 8.17752,1.19336 0.006,6.1e-4 0.0132,-6.1e-4 0.0195,0 4.09964,0.5422 8.21649,1.01361 12.26628,1.36947 1.35202,0.11878 2.69159,0.21881 4.03006,0.31302 2.67694,0.18842 5.32466,0.33228 7.9232,0.41083 2.59856,0.0786 5.26047,0.12146 7.96233,0.13693 5.50028,0.0315 11.19388,-0.0735 17.05931,-0.2543 8.54068,-0.26321 17.43295,-0.71039 26.52806,-1.25208 12.27301,-0.73098 24.91507,-1.62286 37.64006,-2.4259 9.40531,-0.5921 18.84271,-1.13144 28.19095,-1.52597 0.24796,-0.0105 0.49554,-0.0288 0.74341,-0.0391 4.6286,-0.19147 9.24637,-0.34525 13.8118,-0.44995 3.11685,-0.0715 6.21753,-0.11548 9.29266,-0.13697 1.53754,-0.0108 3.07217,-0.0229 4.59738,-0.0195 l 78.13642,0.17609 -5.41904,22.4982 2.19107,0.93905 c 1.09409,0.39603 3.10519,0.5813 4.04965,0.58692 0.53122,0.003 1.09873,-0.0464 1.68247,-0.1565 0.19449,-0.0366 0.39035,-0.0883 0.58691,-0.13696 0.19067,-0.0473 0.39603,-0.0981 0.58691,-0.15649 0.39341,-0.12088 0.79102,-0.26392 1.17383,-0.43042 1.14035,-0.49677 2.21256,-1.20917 2.9932,-2.07373 0.006,-0.007 0.0136,-0.0129 0.0195,-0.0195 0.39114,-0.43689 0.69632,-0.90854 0.91949,-1.42817 l 7.61017,-19.60278 68.82422,0.15653 c 0.46756,0.23407 0.92407,0.46646 1.38901,0.68472 1.86508,0.87616 3.70047,1.62585 5.53644,2.26938 0.91543,0.32089 1.82663,0.61068 2.73886,0.88037 3.19278,0.94372 6.37802,1.59735 9.60565,2.03461 1.84445,0.24996 3.70984,0.43441 5.59518,0.56735 0.9426,0.0664 1.89936,0.11276 2.85627,0.15652 1.91381,0.0876 3.84295,0.13324 5.82989,0.1565 3.97376,0.0464 8.12555,0 12.52057,0 6.51709,0 12.72247,-0.33258 18.64398,-0.97818 2.36865,-0.25827 4.6897,-0.56186 6.9646,-0.9195 4.54981,-0.71527 8.90747,-1.63952 13.08795,-2.73892 1.04511,-0.27484 2.08826,-0.56262 3.1106,-0.86078 3.06696,-0.89447 6.01794,-1.89401 8.88184,-2.99326 0.95452,-0.36639 1.90435,-0.72653 2.83667,-1.11511 1.86456,-0.77722 3.68237,-1.60077 5.45819,-2.46502 0.88794,-0.43213 1.77514,-0.87687 2.64099,-1.33033 1.73187,-0.90698 3.42242,-1.8656 5.06701,-2.85632 0.82227,-0.49533 1.62525,-1.01007 2.42579,-1.52594 4.00311,-2.57935 7.73974,-5.39987 11.2099,-8.47107 2.77252,-2.45376 5.38494,-5.05829 7.82537,-7.80591 0.003,-0.004 -0.003,-0.0159 0,-0.0195 0.60755,-0.6842 1.21259,-1.37201 1.79987,-2.07373 0.003,-0.004 -0.003,-0.0157 0,-0.0195 0.5871,-0.70175 1.17425,-1.41345 1.74121,-2.13244 0.003,-0.004 -0.003,-0.0156 0,-0.0195 1.7063,-2.16494 3.32623,-4.39407 4.85175,-6.71032 0.003,-0.004 -0.003,-0.015 0,-0.0195 0.50634,-0.76914 1.01971,-1.54282 1.50634,-2.32807 0.003,-0.005 -0.003,-0.0149 0,-0.0195 1.46528,-2.3652 2.85901,-4.79071 4.14747,-7.29724 0.003,-0.005 -0.003,-0.0145 0,-0.0195 0.42761,-0.83209 0.84375,-1.67657 1.25207,-2.52371 0.003,-0.005 -0.003,-0.0143 0,-0.0195 0.4082,-0.8472 0.82385,-1.7009 1.21295,-2.56284 0.003,-0.006 -0.002,-0.0142 0,-0.0195 0.78034,-1.72937 1.52631,-3.47555 2.23023,-5.2626 0.003,-0.006 -0.002,-0.014 0,-0.0195 0.35077,-0.89078 0.68536,-1.79514 1.01733,-2.6998 0.002,-0.006 -0.002,-0.0139 0,-0.0195 0.33179,-0.90476 0.66504,-1.82053 0.97815,-2.7389 0.31305,-0.91848 0.62506,-1.84622 0.9195,-2.77804 0.002,-0.006 -0.002,-0.0138 0,-0.0195 0.29437,-0.93192 0.58496,-1.8722 0.86084,-2.81717 0.002,-0.006 -0.002,-0.0136 0,-0.0195 0.27569,-0.94507 0.54467,-1.89841 0.80206,-2.85633 0.002,-0.006 -0.002,-0.0136 0,-0.0195 0.77514,-2.88611 1.48273,-5.82586 2.09332,-8.82321 v -0.0195 c 0.20258,-0.99503 0.38263,-2.00607 0.56739,-3.01282 v -0.0195 c 1.29882,-7.08572 2.16735,-14.43765 2.60192,-22.04823 3.1e-4,-0.006 -4.2e-4,-0.0132 0,-0.0195 0.0613,-1.08174 0.11188,-2.17589 0.1565,-3.26714 2.4e-4,-0.006 -2.5e-4,-0.0132 0,-0.0195 0.0892,-2.18923 0.15442,-4.38678 0.17602,-6.61252 0,-0.006 -6e-5,-0.0132 0,-0.0195 0.0107,-1.1162 0.006,-2.23996 0,-3.36495 0,-0.39804 -0.0137,-0.79596 -0.0194,-1.19339 0.006,-0.39743 0.0194,-0.79535 0.0194,-1.19339 0.006,-1.12498 0.0107,-2.24875 0,-3.36494 -6e-5,-0.006 0,-0.0131 0,-0.0195 -0.0213,-2.22575 -0.0868,-4.42331 -0.17602,-6.61252 -2.5e-4,-0.006 2.4e-4,-0.0131 0,-0.0195 -0.0444,-1.09123 -0.0952,-2.18539 -0.1565,-3.26713 -4.2e-4,-0.006 3.1e-4,-0.0131 0,-0.0195 -0.43457,-7.61058 -1.3031,-14.96254 -2.60192,-22.04826 v -0.0195 c -0.18476,-1.00673 -0.36481,-2.01776 -0.56739,-3.0128 v -0.0195 c -0.61059,-2.99732 -1.31817,-5.93709 -2.09332,-8.8232 -0.002,-0.006 0.002,-0.0133 0,-0.0195 -0.25739,-0.9579 -0.52637,-1.91124 -0.80206,-2.85629 -0.002,-0.006 0.002,-0.0133 0,-0.0195 -0.27588,-0.94498 -0.56647,-1.88526 -0.86084,-2.81717 -0.002,-0.006 0.002,-0.0139 0,-0.0195 -0.29444,-0.93183 -0.60645,-1.85958 -0.9195,-2.77803 -0.31311,-0.91837 -0.64636,-1.83414 -0.97815,-2.73891 -0.002,-0.006 0.002,-0.014 0,-0.0195 -0.33197,-0.90465 -0.66656,-1.80904 -1.01733,-2.6998 -0.002,-0.006 0.003,-0.0139 0,-0.0195 -0.70392,-1.78706 -1.44989,-3.5332 -2.23023,-5.2626 -0.002,-0.005 0.003,-0.014 0,-0.0196 -0.38904,-0.86192 -0.80475,-1.71563 -1.21295,-2.56283 -0.003,-0.005 0.003,-0.0146 0,-0.0195 -0.40832,-0.84711 -0.82446,-1.69161 -1.25207,-2.5237 -0.003,-0.005 0.003,-0.0146 0,-0.0196 -1.28846,-2.5065 -2.68219,-4.93202 -4.14747,-7.29724 -0.003,-0.004 0.003,-0.0146 0,-0.0195 -0.48663,-0.78525 -1,-1.55893 -1.50634,-2.32806 -0.003,-0.004 0.003,-0.0151 0,-0.0195 -1.52552,-2.31628 -3.14539,-4.54538 -4.85175,-6.71034 -0.003,-0.004 0.003,-0.0159 0,-0.0195 -0.56696,-0.71898 -1.15411,-1.43071 -1.74121,-2.13245 -0.003,-0.004 0.003,-0.0158 0,-0.0195 -0.58722,-0.70175 -1.19232,-1.38957 -1.79987,-2.07376 -0.003,-0.004 0.003,-0.0158 0,-0.0195 -2.44043,-2.74762 -5.05285,-5.35213 -7.82537,-7.80588 -3.47016,-3.07121 -7.20679,-5.89174 -11.2099,-8.4711 -0.8006,-0.51587 -1.60358,-1.03059 -2.42579,-1.52595 -1.64453,-0.99072 -3.33508,-1.94934 -5.06701,-2.8563 -0.86585,-0.45347 -1.75305,-0.8982 -2.64099,-1.33033 -1.77588,-0.86426 -3.59369,-1.68782 -5.45819,-2.46501 -0.93232,-0.38861 -1.88215,-0.74873 -2.83667,-1.11513 -2.8639,-1.09924 -5.81488,-2.09878 -8.88184,-2.99324 -1.02234,-0.29815 -2.06549,-0.58596 -3.1106,-0.8608 -4.18048,-1.09939 -8.53814,-2.02366 -13.08795,-2.73891 -2.2749,-0.35765 -4.59595,-0.66123 -6.9646,-0.9195 -5.92139,-0.64644 -12.12677,-0.97898 -18.64386,-0.97898 -4.39508,0 -8.54687,-0.0464 -12.5206,0 -1.98694,0.0233 -3.91607,0.0689 -5.82989,0.1565 -0.95688,0.0438 -1.91364,0.0901 -2.85626,0.15651 -1.88532,0.13294 -3.75071,0.31738 -5.59516,0.56735 -3.22763,0.43728 -6.41287,1.0909 -9.60565,2.03463 -0.91226,0.26967 -1.82343,0.55946 -2.73886,0.88035 -1.83597,0.64354 -3.67142,1.39324 -5.53644,2.2694 -0.46497,0.21824 -0.92142,0.45064 -1.38904,0.68473 l -68.82422,0.15649 -7.6102,-19.602776 c -0.22314,-0.519615 -0.52832,-0.991234 -0.91949,-1.428154 -0.006,-0.0066 -0.0133,-0.0129 -0.0195,-0.01953 -0.78061,-0.864594 -1.85285,-1.576965 -2.9932,-2.073738 -0.38278,-0.166481 -0.78036,-0.30954 -1.17382,-0.430412 -0.19089,-0.05839 -0.39618,-0.109177 -0.58689,-0.156509 -0.19659,-0.04863 -0.39242,-0.100319 -0.58697,-0.13694 -0.58368,-0.110115 -1.15119,-0.159637 -1.68247,-0.156509 l 3e-5,-2.44e-4 z" id="path3855" stroke-miterlimit="4" inkscape:connector-curvature="0" style="fill:#000000;fill-opacity:0.99607801;stroke:#191919;stroke-width:14;stroke-miterlimit:4" /><path d="m 367.68838,93.998283 c -0.94442,0.0056 -2.95556,0.191635 -4.04962,0.586906 l -2.1911,0.939056 5.41907,22.439535 -78.13645,0.17607 c -48.80767,0.10356 -104.24931,-7.20172 -145.82594,-5.94735 -41.57664,1.25437 -95.234884,17.52904 -95.234884,17.52904 l -8.568787,2.3672 c -12.05196,3.31566 -16.100719,60.95542 -16.100719,104.41127 0,0.6968 0.01668,1.41053 0.01957,2.11287 -0.0029,0.70235 -0.01957,1.41608 -0.01957,2.11287 0,43.45589 4.048759,101.0956 16.100719,104.41127 l 8.568787,2.36722 c 0,0 53.658244,16.27466 95.234884,17.52902 41.57663,1.25437 97.01827,-6.0509 145.82594,-5.94736 l 78.13645,0.17609 -5.41907,22.43951 2.1911,0.93906 c 1.09406,0.39529 3.10517,0.5813 4.04962,0.58691 0.53125,0.003 1.09876,-0.0466 1.6825,-0.15652 0.19452,-0.0366 0.39035,-0.0884 0.58691,-0.13693 0.19065,-0.0472 0.396,-0.0982 0.58689,-0.15653 0.39343,-0.1206 0.79101,-0.26422 1.17383,-0.43039 1.14035,-0.49582 2.21258,-1.19119 2.99319,-2.05417 0.006,-0.007 0.0136,-0.013 0.0195,-0.0195 0.39118,-0.43609 0.69635,-0.90951 0.9195,-1.42816 l 7.6102,-19.56366 68.82418,0.15653 c 14.96253,7.47638 28.49173,6.71032 46.07193,6.71032 83.41877,0 117.461,-54.20623 117.06775,-126.06823 0,-0.48845 -0.0118,-0.98014 -0.0194,-1.46727 0.008,-0.48716 0.0194,-0.97884 0.0194,-1.46729 0.39325,-71.86198 -33.64898,-126.06824 -117.06769,-126.06824 -17.58023,0 -31.10946,-0.76603 -46.07196,6.71035 l -68.82421,0.15651 -7.6102,-19.563671 c -0.22315,-0.518623 -0.52832,-0.99205 -0.9195,-1.428154 -0.006,-0.0065 -0.0133,-0.01289 -0.0195,-0.01952 -0.78061,-0.862984 -1.85284,-1.55835 -2.99319,-2.054184 -0.38279,-0.166176 -0.78037,-0.309769 -1.17383,-0.430405 -0.19086,-0.0583 -0.39618,-0.109306 -0.58689,-0.156517 -0.19656,-0.04858 -0.39239,-0.100365 -0.58691,-0.13694 -0.58371,-0.109924 -1.15121,-0.159637 -1.68249,-0.156509 v -9.9e-5 1.5e-5 z" id="path2853" inkscape:connector-curvature="0" style="fill:' + vehicleColor + '" /><!--Body Color--><path d="m 236.10486,320.33777 c -20.88716,0 -40.88457,1.12689 -59.3555,3.16934 16.06424,30.49658 61.34228,18.94721 128.68838,19.73972 31.1055,0.36605 56.05735,1.17651 76.08225,1.48684 -29.52371,-14.60806 -83.59265,-24.3959 -145.41513,-24.3959 z" id="path3643" inkscape:connector-curvature="0" style="opacity:0.9;fill:#262626;fill-opacity:0.99607801" /><!--Right Window--><path d="m 236.10486,320.33777 c -2.00736,0 -3.99604,0.0185 -5.98642,0.0392 0.51225,10.12366 4.0242,18.94171 9.13614,24.31763 2.9245,-0.0473 5.94427,-0.12305 9.03833,-0.21521 -5.36249,-5.12869 -9.13556,-13.91556 -9.84043,-24.14157 -0.78335,-0.003 -1.56177,0 -2.34762,0 z" id="path3658" inkscape:connector-curvature="0" style="opacity:0.5;fill:#000000;fill-opacity:0.99607801" /><!-- Right Window separator--><path d="m 604.64111,302.97375 -3.18884,0.37171 c -13.48779,1.57303 -23.59418,16.26355 -24.59119,34.13858 l -0.2348,4.46051 3.28662,-3.03235 c 9.94721,-9.19052 17.71887,-20.35086 23.41748,-33.02347 z" id="path3707" stroke-miterlimit="4" inkscape:connector-curvature="0" style="fill:#212121;fill-rule:nonzero;stroke:#191919;stroke-width:5;stroke-miterlimit:4" /><!-- Right headlight --><path d="m 236.10486,318.78116 c -20.94342,0 -41.00049,1.12024 -59.53157,3.16934 l -2.28893,0.2543 1.07598,2.03464 c 4.17634,7.92841 10.36818,13.21777 18.19401,16.55087 7.82587,3.33307 17.26119,4.76575 28.23007,5.28217 21.93775,1.03284 50.0543,-1.64725 83.63376,-1.25208 31.08817,0.36585 56.03525,1.17615 76.08225,1.48685 l 0.70428,-2.97366 C 352.2493,328.5119 298.0925,318.78116 236.10486,318.78116 Z m 0,3.13022 c 57.07547,0 107.5202,8.43811 137.78537,21.10919 -18.75107,-0.36462 -40.82508,-1.00543 -68.43292,-1.33035 -33.76664,-0.39734 -61.96256,2.2864 -83.51638,1.27163 -10.77693,-0.50738 -19.88722,-1.94409 -27.17364,-5.04742 -6.54409,-2.78714 -11.57248,-6.98303 -15.33776,-13.08807 17.72152,-1.8675 36.77012,-2.91498 56.67533,-2.91498 z" id="path4025" inkscape:connector-curvature="0" style="opacity:0.9;fill:#191919;fill-rule:nonzero;stroke-width:5" /><!-- Right Window Outline --><path d="m 148.55818,165.1709 -48.673872,7.80591 c -16.997169,2.72583 -30.642738,30.53355 -31.927559,65.63607 1.284821,35.10251 14.930389,62.91025 31.927559,65.63611 l 48.673872,7.80588 c 8.32369,0 15.02472,-6.70108 15.02472,-15.02487 V 180.1958 c 0,-8.32382 -6.70103,-15.0249 -15.02473,-15.0249 z" id="rect2864" stroke-miterlimit="4" inkscape:connector-curvature="0" style="opacity:0.9;fill:#262626;fill-opacity:0.99607801;stroke:#191919;stroke-width:5;stroke-miterlimit:4" /><!-- Rear Window --><path d="m 418.67071,143.74869 c -1.85879,0 -3.68939,0.20794 -5.49734,0.60647 -0.006,-0.006 -0.013,-0.0132 -0.0195,-0.0195 l -39.96814,7.70807 c -11.09824,4.13478 -20.03296,8.9348 -20.03296,20.0332 v 133.07201 c 0,11.09841 8.93472,15.89843 20.03296,20.0332 l 39.96814,7.70807 c 0.007,-0.006 0.013,-0.0132 0.0195,-0.0195 1.80792,0.39856 3.63849,0.6065 5.49734,0.6065 28.41925,0 51.45871,-35.91113 51.53013,-94.86421 -0.0714,-58.95308 -23.11087,-94.8642 -51.53013,-94.8642 z" id="path3703" stroke-miterlimit="4" inkscape:connector-curvature="0" style="opacity:0.9;fill:#262626;fill-opacity:0.99607801;stroke:#191919;stroke-width:5;stroke-miterlimit:4;stroke-dashoffset:0" /><!-- Front window --><path d="m 236.10486,156.88786 c -20.88716,0 -40.88457,-1.12686 -59.3555,-3.16931 16.06424,-30.49657 61.34228,-18.94722 128.68838,-19.73973 31.1055,-0.36606 56.05735,-1.1765 76.08225,-1.48685 -29.52371,14.60807 -83.59265,24.39589 -145.41513,24.39589 z" id="path4157" inkscape:connector-curvature="0" style="opacity:0.9;fill:#262626;fill-opacity:0.99607801" /><!-- Left Window --><path d="m 236.10486,156.88786 c -2.00736,0 -3.99604,-0.0185 -5.98642,-0.0391 0.51225,-10.12367 4.0242,-18.94171 9.13614,-24.31763 2.9245,0.0473 5.94427,0.12303 9.03833,0.2152 -5.36249,5.12869 -9.13556,13.91557 -9.84043,24.14155 -0.78335,0.003 -1.56177,0 -2.34762,0 z" id="path4159" inkscape:connector-curvature="0" style="opacity:0.5;fill:#000000;fill-opacity:0.99607801" /><!-- Left Headlight --><path d="m 604.64111,174.25191 -3.18884,-0.37171 c -13.48779,-1.57304 -23.59418,-16.26355 -24.59119,-34.13859 l -0.2348,-4.46051 3.28662,3.03236 c 9.94721,9.19051 17.71887,20.35085 23.41748,33.02347 z" id="path4161" stroke-miterlimit="4" inkscape:connector-curvature="0" style="fill:#212121;fill-rule:nonzero;stroke:#191919;stroke-width:5;stroke-miterlimit:4" /><!-- Left window separator --><path d="m 236.10486,158.44447 c -20.94342,0 -41.00049,-1.12021 -59.53157,-3.16931 l -2.28893,-0.25432 1.07598,-2.03463 c 4.17634,-7.9284 10.36818,-13.21778 18.19401,-16.55086 7.82587,-3.33309 17.26119,-4.76576 28.23007,-5.28218 21.93775,-1.03283 50.0543,1.64724 83.63376,1.25207 31.08817,-0.36583 56.03525,-1.17615 76.08225,-1.48685 l 0.70428,2.97368 c -29.95541,14.82166 -84.11221,24.5524 -146.09985,24.5524 z m 0,-3.13017 c 57.07547,0 107.5202,-8.43814 137.78537,-21.10919 -18.75107,0.36459 -40.82508,1.00541 -68.43292,1.33032 -33.76664,0.39734 -61.96256,-2.28639 -83.51638,-1.27164 -10.77693,0.50739 -19.88722,1.94409 -27.17364,5.04743 -6.54409,2.78717 -11.57248,6.98303 -15.33776,13.08809 17.72152,1.86749 36.77012,2.91499 56.67533,2.91499 z" id="path4183" inkscape:connector-curvature="0" style="opacity:0.9;fill:#191919;fill-rule:nonzero;stroke-width:5" /><!-- Left window outline --></g></g></g><ellipse id="path3794" cx="50.079483" cy="32.120518" rx="12.777778" ry="5.6358986" style="fill:' + beaconColor + ';stroke-width:3.10342956" /></svg>';
                
                return driverIconSvg;
            }
        }
    }
)();

(function () {
    'use strict';

    InspectionSummaryController.$inject = ["SYSTEM_ENUMS", "INSPECT_CONSTANTS", "liberatedAsideService", "inspectionService", "rcUtilService", "roService", "locationService", "consumerRepairOrderAuthorizationsService", "consumerAppointmentService", "appointmentUtilService", "modalService"];
    angular
        .module('redcap.directives')
        .component('inspectionSummary', {
            templateUrl: 'app/shared/components/inspect/inspection-summary.view.html',
            controller: InspectionSummaryController,
            controllerAs: 'vm',
            bindings: {
                'ro': '<',
                'fromConsumer': '<',
                'consumerKey': '<'
            }
        });

    function InspectionSummaryController(SYSTEM_ENUMS, INSPECT_CONSTANTS, liberatedAsideService, inspectionService, rcUtilService, roService, locationService, consumerRepairOrderAuthorizationsService, consumerAppointmentService, appointmentUtilService, modalService) {
        this.$onInit = function() {
            const vm = this;
           
            vm.roItemizationEnabled = false;
            vm.lineItemSourceType = SYSTEM_ENUMS.lineItemSource;
            vm.measurementUnitTypes = INSPECT_CONSTANTS.measurementUnitType;
            vm.showPrintOption = !vm.fromConsumer;
            vm.passFailSummary = [
                {
                    passFailType: INSPECT_CONSTANTS.roTaskAnswerType.fail,
                    severity: INSPECT_CONSTANTS.severity.addressImmediately,
                    description: 'Address Immediately',
                    items: []
                },
                {
                    passFailType: INSPECT_CONSTANTS.roTaskAnswerType.caution,
                    severity: INSPECT_CONSTANTS.severity.addressSoon,
                    description: 'Address Soon',
                    items: []
                },
                {
                    passFailType: INSPECT_CONSTANTS.roTaskAnswerType.pass,
                    severity: INSPECT_CONSTANTS.severity.none,
                    items: []
                }
            ];
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;

            vm.printSummary = function() {
                rcUtilService.printToPDF('print-to-pdf', 'repeating-footer', 'Inspection-Summary-' + vm.ro.customer.name);
            };

            vm.close = function() {
                liberatedAsideService.closeLiberatedAside();
            };

            vm.getMediaType = function(fileExtension) {
                return appointmentUtilService.getMediaType(fileExtension);
            };

            vm.openMediaModal = function (url, description, mediaType) {
                modalService.showImageViewer(url, description, mediaType);
            };

            function init() {
                vm.isLoading = true;

                // TODO: use the actual inspection date once we have this data in our data model.
                vm.inspectionDate = _.get(vm.ro, 'authorizationHistory[0].createdDate');
                const lineItemRequest = vm.fromConsumer ? consumerRepairOrderAuthorizationsService.getRoLineItems(vm.ro.dealerId, vm.ro.id, vm.consumerKey) 
                                                        : roService.getRoLineItems(vm.ro.dealerId, vm.ro.id);
                
                const dealerOpCodes = vm.fromConsumer ? consumerAppointmentService.getLocationOpCodes(vm.ro.dealerId) : locationService.getLocationOpCodes(vm.ro.dealerId);
                const serviceLinesPromise = Promise.all([lineItemRequest, dealerOpCodes]).then(([serviceLines, dealerOpCodes]) => {
                    // TODO: Remove the need for this call... line item objects should be standardized and used directly from the API
                    const mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(dealerOpCodes, vm.ro);

                    vm.allLineItems = consumerRepairOrderAuthorizationsService.getServicesFromAuthorizations(serviceLines, mappedOpCodes, vm.ro, vm.consumerKey);
                    vm.inspectionRecommendations = vm.allLineItems.filter((li) => { return li.source !== vm.lineItemSourceType.originalCustomerRequest; });
                    vm.originalCustomerRequests = vm.allLineItems.filter((li) => { return li.source === vm.lineItemSourceType.originalCustomerRequest; });
                    vm.roItemizationEnabled = vm.allLineItems.some((item) => {
                        return item.itemizedPricingEnabled === true;
                    });
                    
                    if (vm.ro.inspectionForm?.isAdHoc) {
                        vm.inspectionRecommendations.forEach((li) => {
                            const summaryItem = vm.passFailSummary.find((item) => item.severity === li.severity);
    
                            summaryItem.items.push(li);
                        });
                    }                    
                });

                let inspectionFormPromise = null;

                if (!vm.ro.inspectionForm?.isAdHoc) {
                    const inspectionFormRequest = vm.fromConsumer ? 
                                                    consumerRepairOrderAuthorizationsService.getInspectionSections(vm.ro.dealerId, vm.ro.id, vm.consumerKey)
                                                    : inspectionService.getInspectionSections(vm.ro.dealerId, vm.ro.id);

                    inspectionFormPromise = inspectionFormRequest.then((sections) => {
                        vm.inspectionSections = sections;
                        const allTasks = vm.inspectionSections.flatMap((section) => section.tasks);

                        
                        vm.tasksWithMeasurements = allTasks.filter((task) => {
                            return task.inputOptions?.length > 0 && task.measurementChoices?.length > 0;
                        }).map((task) => {
                            task.measurementButtonWidth = Math.round(100 / task.measurementChoices.length) + '%';

                            return task;
                        });

                        vm.tasksWithInputsOnly = allTasks.filter((task) => {
                            return task.inputOptions?.length > 0 && task.measurementChoices?.length <= 0;
                        });

                        allTasks.forEach((task) => {                        
                            task.taskResponse = task.taskResponse || INSPECT_CONSTANTS.roTaskAnswerType.na;
                            
                            // AG said not to display NA for now
                            if (task.taskResponse !== INSPECT_CONSTANTS.roTaskAnswerType.na) {
                                const summaryItem = vm.passFailSummary.find((item) => item.passFailType === task.taskResponse);

                                summaryItem.items.push(task);
                            }
                        });
                    });
                }

                let termsPromise = null;

                // we aren't allowing printing on the consumer page, so we don't need to worry about the terms.
                if (!vm.fromConsumer) {
                    termsPromise = roService.getActiveTerms(vm.ro.dealerId, vm.ro.id).then((termsResults)  => { vm.terms = termsResults; });
                }

                const vehicleOverviewPromise = roService.getVehicleOverview(vm.ro.dealerId, vm.ro.id).then((overview) => {
                    vm.vehicleOverview = overview;
                });

                const promises = [serviceLinesPromise, inspectionFormPromise, termsPromise, vehicleOverviewPromise];
                
                Promise.all(promises).then(() => {
                    vm.roTotals = inspectionService.initROTotals();
                    inspectionService.calculateROTotals(vm.ro, vm.allLineItems, vm.roTotals);

                    vm.isLoading = false;
                });
            }
            
            init();
        };
    }
})();

(function ($, w, undefined) {
    if (w.footable === undefined || w.footable === null)
        throw new Error('Please check and make sure footable.js is included in the page and is loaded prior to this script.');

    var defaults = {
        sort: true,
        sorters: {
            alpha: function (a, b) {
              if (typeof a === 'string') { a = a.toLowerCase(); }
              if (typeof b === 'string') { b = b.toLowerCase(); }
              if (a === b) return 0;
              if (a < b) return -1;
              return 1;
            },
            numeric: function (a, b) {
              return a - b;
            }
        },
        classes: {
            sort: {
                sortable: 'footable-sortable',
                sorted: 'footable-sorted',
                descending: 'footable-sorted-desc',
                indicator: 'footable-sort-indicator'
            }
        },
        events: {
            sort: {
                sorting: 'footable_sorting',
                sorted: 'footable_sorted'
            }
        }
    };

    function Sort() {
        var p = this;
        p.name = 'Footable Sortable';
        p.init = function (ft) {
            p.footable = ft;
            if (ft.options.sort === true) {
                $(ft.table)
                    .unbind('.sorting')
                    .bind({
                        'footable_initialized.sorting': function (e) {
                            var $table = $(ft.table),
                                $tbody = $table.find('> tbody'),
                                cls = ft.options.classes.sort,
                                column, $th;

                            if ($table.data('sort') === false) return;

                            $table.find('> thead > tr:last-child > th, > thead > tr:last-child > td').each(function (ec) {
                                var $th = $(this), column = ft.columns[$th.index()];
                                if (column.sort.ignore !== true && !$th.hasClass(cls.sortable)) {
                                    $th.addClass(cls.sortable);
                                    $('<span />').addClass(cls.indicator).appendTo($th);
                                }
                            });

                            $table.find('> thead > tr:last-child > th.' + cls.sortable + ', > thead > tr:last-child > td.' + cls.sortable).unbind('click.footable').bind('click.footable', function (ec) {
                                ec.preventDefault();
                                $th = $(this);
                                var ascending = !$th.hasClass(cls.sorted);
                                p.doSort($th.index(), ascending);
                                return false;
                            });

                            var didSomeSorting = false;
                            for (var c in ft.columns) {
                                column = ft.columns[c];
                                if (column.sort.initial) {
                                    var ascending = column.sort.initial !== 'descending';
                                    p.doSort(column.index, ascending);
                                    break;
                                }
                            }
                            if (didSomeSorting) {
                                ft.bindToggleSelectors();
                            }
                        },
                        'footable_redrawn.sorting': function(e) {
                            var $table = $(ft.table),
                                cls = ft.options.classes.sort;
                            if ($table.data('sorted') >= 0) {
                                $table.find('> thead > tr:last-child > th').each(function(i){
                                    var $th = $(this);
                                    if ($th.hasClass(cls.sorted) || $th.hasClass(cls.descending)) {
                                        p.doSort(i);
                                        return;
                                    }
                                });
                            }
                        },
                        'footable_column_data.sorting': function (e) {
                            var $th = $(e.column.th);
                            e.column.data.sort = e.column.data.sort || {};
                            e.column.data.sort.initial = $th.data('sort-initial') || false;
                            e.column.data.sort.ignore = $th.data('sort-ignore') || false;
                            e.column.data.sort.selector = $th.data('sort-selector') || null;

                            var match = $th.data('sort-match') || 0;
                            if (match >= e.column.data.matches.length) match = 0;
                            e.column.data.sort.match = e.column.data.matches[match];
                        }
                    })
                //save the sort object onto the table so we can access it later
                .data('footable-sort', p);
            }
        };

        p.doSort = function(columnIndex, ascending) {
            var ft = p.footable;
            if ($(ft.table).data('sort') === false) return;

            var $table = $(ft.table),
                $tbody = $table.find('> tbody'),
                column = ft.columns[columnIndex],
                $th = $table.find('> thead > tr:last-child > th:eq(' + columnIndex + ')'),
                cls = ft.options.classes.sort,
                evt = ft.options.events.sort;

            ascending = ascending === undefined ? $th.hasClass(cls.sorted) :
                ascending === 'toggle' ? !$th.hasClass(cls.sorted) : ascending;

            if (column.sort.ignore === true) return true;

            //raise a pre-sorting event so that we can cancel the sorting if needed
            var event = ft.raise(evt.sorting, { column: column, direction: ascending ? 'ASC' : 'DESC' });
            if (event && event.result === false) return;

            $table.data('sorted', column.index);

            $table.find('> thead > tr:last-child > th, > thead > tr:last-child > td').not($th).removeClass(cls.sorted + ' ' + cls.descending);

            if (ascending === undefined) {
                ascending = $th.hasClass(cls.sorted);
            }

            if (ascending) {
                $th.removeClass(cls.descending).addClass(cls.sorted);
            } else {
                $th.removeClass(cls.sorted).addClass(cls.descending);
            }

            p.sort(ft, $tbody, column, ascending);

            ft.bindToggleSelectors();
            ft.raise(evt.sorted, { column: column, direction: ascending ? 'ASC' : 'DESC' });
        };

        p.rows = function (ft, tbody, column) {
            var rows = [];
            tbody.find('> tr').each(function () {
                var $row = $(this), $next = null;
                if ($row.hasClass(ft.options.classes.detail)) return true;
                if ($row.next().hasClass(ft.options.classes.detail)) {
                    $next = $row.next().get(0);
                }
                var row = { 'row': $row, 'detail': $next };
                if (column !== undefined) {
                    row.value = ft.parse(this.cells[column.sort.match], column);
                }
                rows.push(row);
                return true;
            }).detach();
            return rows;
        };

        p.sort = function (ft, tbody, column, ascending) {
            var rows = p.rows(ft, tbody, column);
            var sorter = ft.options.sorters[column.type] || ft.options.sorters.alpha;
            rows.sort(function (a, b) {
                if (ascending) {
                    return sorter(a.value, b.value);
                } else {
                    return sorter(b.value, a.value);
                }
            });
            for (var j = 0; j < rows.length; j++) {
                tbody.append(rows[j].row);
                if (rows[j].detail !== null) {
                    tbody.append(rows[j].detail);
                }
            }
        };
    }

    w.footable.plugins.register(Sort, defaults);

})(jQuery, window);

(function ($, w, undefined) {
    if (w.footable === undefined || w.footable === null)
        throw new Error('Please check and make sure footable.js is included in the page and is loaded prior to this script.');

    var defaults = {
        filter: {
            enabled: true,
            input: '.footable-filter',
            timeout: 300,
            minimum: 2,
            disableEnter: false,
            filterFunction: function(index) {
                var $t = $(this),
                    $table = $t.parents('table:first'),
                    filter = $table.data('current-filter').toUpperCase(),
                    text = $t.find('td').text();
                if (!$table.data('filter-text-only')) {
                    $t.find('td[data-value]').each(function () {
                        text += $(this).data('value');
                    });
                }
                return text.toUpperCase().indexOf(filter) >= 0;
            }
        }
    };

    function Filter() {
        var p = this;
        p.name = 'Footable Filter';
        p.init = function (ft) {
            p.footable = ft;
            if (ft.options.filter.enabled === true) {
                if ($(ft.table).data('filter') === false) return;
                ft.timers.register('filter');
                $(ft.table)
                    .unbind('.filtering')
                    .bind({
                        'footable_initialized.filtering': function (e) {
                            var $table = $(ft.table);
                            var data = {
                                'input': $table.data('filter') || ft.options.filter.input,
                                'timeout': $table.data('filter-timeout') || ft.options.filter.timeout,
                                'minimum': $table.data('filter-minimum') || ft.options.filter.minimum,
                                'disableEnter': $table.data('filter-disable-enter') || ft.options.filter.disableEnter
                            };
                            if (data.disableEnter) {
                                $(data.input).keypress(function (event) {
                                    if (window.event)
                                        return window.event.keyCode !== 13;
                                    else
                                        return event.which !== 13;
                                });
                            }
                            $table.bind('footable_clear_filter', function () {
                                $(data.input).val('');
                                p.clearFilter();
                            });
                            $table.bind('footable_filter', function (event, args) {
                                p.filter(args.filter);
                            });
                            $(data.input).keyup(function (eve) {
                                ft.timers.filter.stop();
                                if (eve.which === 27) {
                                    $(data.input).val('');
                                }
                                ft.timers.filter.start(function () {
                                    var val = $(data.input).val() || '';
                                    p.filter(val);
                                }, data.timeout);
                            });
                        },
                        'footable_redrawn.filtering': function (e) {
                            var $table = $(ft.table),
                                filter = $table.data('filter-string');
                            if (filter) {
                                p.filter(filter);
                            }
                        }
                })
                //save the filter object onto the table so we can access it later
                .data('footable-filter', p);
            }
        };

        p.filter = function (filterString) {
            var ft = p.footable,
                $table = $(ft.table),
                minimum = $table.data('filter-minimum') || ft.options.filter.minimum,
                clear = !filterString;

            //raise a pre-filter event so that we can cancel the filtering if needed
            var event = ft.raise('footable_filtering', { filter: filterString, clear: clear });
            if (event && event.result === false) return;
            if (event.filter && event.filter.length < minimum) {
              return; //if we do not have the minimum chars then do nothing
            }

          if (event.clear) {
                p.clearFilter();
            } else {
                var filters = event.filter.split(' ');

                $table.find('> tbody > tr').hide().addClass('footable-filtered');
                var rows = $table.find('> tbody > tr:not(.footable-row-detail)');
                $.each(filters, function (i, f) {
                    if (f && f.length > 0) {
                        $table.data('current-filter', f);
                        rows = rows.filter(ft.options.filter.filterFunction);
                    }
                });
                rows.each(function () {
                    p.showRow(this, ft);
                    $(this).removeClass('footable-filtered');
                });
                $table.data('filter-string', event.filter);
                ft.raise('footable_filtered', { filter: event.filter, clear: false });
            }
        };

        p.clearFilter = function () {
            var ft = p.footable,
                $table = $(ft.table);

            $table.find('> tbody > tr:not(.footable-row-detail)').removeClass('footable-filtered').each(function () {
                p.showRow(this, ft);
            });
            $table.removeData('filter-string');
            ft.raise('footable_filtered', { clear: true });
        };

        p.showRow = function (row, ft) {
            var $row = $(row), $next = $row.next(), $table = $(ft.table);
            if ($row.is(':visible')) return; //already visible - do nothing
            if ($table.hasClass('breakpoint') && $row.hasClass('footable-detail-show') && $next.hasClass('footable-row-detail')) {
                $row.add($next).show();
                ft.createOrUpdateDetailRow(row);
            }
            else $row.show();
        };
    }

    w.footable.plugins.register(Filter, defaults);

})(jQuery, window);

(function () {
    'use strict';

    angular
        .module('redcap')
        .component('calendarPostItNote', {
            templateUrl: 'app/shared/components/calendarPostItNote/calendar-post-it-note.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'caltitle': '<', // date format 'YYYY-MM-DD'
                'date': '<',
                'tripId': '<'
            }
        });

    function controller() {

        this.$onInit = function() {};
    }

    
})();


(function () {
    'use strict';

    controller.$inject = ["$rootScope", "$scope", "$timeout", "locationService", "appointmentUtilService", "SYSTEM_ENUMS", "APPOINTMENT_PAYTYPES"];
    angular
        .module('redcap.appointment')
        .component('lineitemEditProperties', {
            templateUrl: 'app/shared/components/authorizations/lineitem-edit-properties.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '=',
                'appointment': '<',
                'existingServices': '<',
                'opCodes': '<',
                'isCheckin': '<',
                'isRecMaint': '<',
                'removePadding': '<',
                'dmsSystem': '<',
                'dispatchCodes': '<',
                'serviceTypes': '<',
                'showNote': '<',
                'requireDispatchCode': '<',
                'isValidatingRecalls': '=',
                'opcodeselectedevent': '@' 
            }
        });

    function controller($rootScope,
        $scope,
        $timeout,
        locationService,
        appointmentUtilService,
        SYSTEM_ENUMS,
        APPOINTMENT_PAYTYPES) {

        this.$onInit = function() {
            let vm = this;
            let pageSize = 25;

            if (vm.appointment.dealerId !== 0) {
                vm.dealerId = vm.appointment.dealerId;
            } else if (vm.appointment.location) {
                vm.dealerId = vm.appointment.location.id;
            }

            vm.myUniqueId = appointmentUtilService.getUniqueDOMID();
            vm.ngModel.uniqueDOMId = vm.myUniqueId;
            vm.decimalRegex = `^[0-9]+(\.[0-9]{1,2})?$`;
            vm.paymentTypes = APPOINTMENT_PAYTYPES;
            vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
            vm.lineItemSeverities = SYSTEM_ENUMS.lineItemSeverity;
            vm.allowAnyInput = vm.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.None ||
                                vm.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.ReynoldsPOWER ||
                                vm.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.ReynoldsERA;

            if (!vm.ngModel.payType) {
                vm.ngModel.payType = "";
            } else {
                vm.ngModel.payType = vm.ngModel.payType.trim();
            }

            vm.getNoteMaxLength = function() {
                return appointmentUtilService.getNoteMaxLength(vm.dmsSystem);
            };

            vm.opCodeSearchSelected = function(lineItem, selectedItem) {
                let selectedDepartment = vm.appointment.department || {defaultDispatchCode: null};
                let defaultDispatchCode = selectedDepartment.defaultDispatchCode;

                appointmentUtilService.processDashboardOpCodeSearchSelected(lineItem, selectedItem, vm.dmsSystem, defaultDispatchCode, false);

                if (selectedItem && selectedItem.length > 0) {
                    let data = selectedItem[0];

                    if (data.customValue === true) {
                        locationService.searchLocationOpCodes(
                            vm.dealerId,
                            vm.appointment.departmentId,
                            data.text, 
                            1, 1, true, true
                        ).then((results) => {
                            if (results && results.length > 0) {
                                let description = results[0].dashboardDescription || results[0].text;

                                if (description && description !== data.text) {
                                    lineItem.opCodeDescription = description;
                                }
                            }
                        });
                    }
                }
                
                $timeout(() => {
                    $scope.$apply();

                    if (vm.opcodeselectedevent) {
                        let data = {
                            lineItem: lineItem,
                            selectedItem: selectedItem
                        };
    
                        $rootScope.$broadcast(vm.opcodeselectedevent, data);
                    }
                }, 1);
                
            };

            vm.opCodeSearchQuery = {
                type: 'GET',
                dataType: 'json',
                data: function(parameters) {
                    let query = {
                        search: parameters.term,
                        dealerId: vm.dealerId,
                        page: parameters.page,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function(params, success, failure) {
                    let data = params.data;

                    return locationService.searchLocationOpCodes(vm.dealerId,
                        vm.appointment.departmentId,
                        data.search,
                        data.page,
                        data.pageSize,
                        true).then(success, failure);
                },
                delay: 250,
                processResults: function(data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            };

            vm.validation = {
                valDecimal: function(value, lineItem, exactDecimalPlaces) {
                    return appointmentUtilService.validateDecimal(value, lineItem, exactDecimalPlaces);
                },
                valOpCode: function() {
                    return appointmentUtilService.validateDashboardOpCode(vm.existingServices,
                        vm.opCodes,
                        vm.ngModel.opCode || vm.ngModel.selectedOpCode,
                        vm.ngModel,
                        vm.dmsSystem);
                }
            };

            vm.formatForSelection = function(item) {
                return appointmentUtilService.formatOpCodeSearchForSelection(item);
            };

            vm.formatForDropdown = function(item) {
                return appointmentUtilService.formatOpCodeForDropDown(item);
            };

            vm.getCSSClass = function(isSmallField) {
                let dmsProviders = vm.dmsProviderTypes;
                let dmsSystem = vm.dmsSystem;
                let isCheckin = vm.isCheckin;
                let cssClass = 'responsive-lineItem ';

                if (dmsSystem !== dmsProviders.DealerTrack && dmsSystem !== dmsProviders.CDK && isCheckin === false) {
                    cssClass += 'col-sm-4';
                } else if ((dmsSystem === dmsProviders.DealerTrack || dmsSystem === dmsProviders.CDK) &&
                    isCheckin === true) {
                    if (isSmallField) {
                        cssClass += 'col-sm-1';
                    } else {
                        cssClass += 'col-sm-2';
                    }
                } else {
                    cssClass += 'col-sm-3';
                }

                return cssClass;
            };
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["appointmentUtilService", "INSPECT_CONSTANTS", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .component('authorizePendingLineitem', {
            templateUrl: 'app/shared/components/authorizations/authorize-pending-lineitem.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '=',
                'isDashboard': '=',
                'readOnly': '=',
                'checkinSummary': "=",
                'inspectionSummary': '=',
                'limitWidth': "=",
                'itemizeTax': '&?'
            }
        });

    function controller(appointmentUtilService, INSPECT_CONSTANTS, SYSTEM_ENUMS) {

        this.$onInit = function() {
            let vm = this;

            vm.expandedImagesAndNotes = !vm.checkinSummary;
            vm.lineItem = vm.ngModel;
            vm.lineItem.uniqueDOMId = vm.lineItem.uniqueDOMId || appointmentUtilService.getUniqueDOMID();
            vm.severity = INSPECT_CONSTANTS;
            vm.lineItemSourceTypes = SYSTEM_ENUMS.lineItemSource;
            vm.authorizationStatus = INSPECT_CONSTANTS.lineItemStatus;

            vm.isApproved = {
                approved: true,
                declined: false
            };

            if (vm.lineItem.isRecommendedMaintenance || vm.lineItem.isGeneric || vm.lineItem.isRecall || vm.lineItem.isPreviouslyDeferred) {
                vm.computedDescription = vm.lineItem.description;
            } else {
                vm.computedDescription = vm.lineItem.consumerDescription ||  vm.lineItem.dashboardDescription || vm.lineItem.description;
            }

             vm.computedName =  (vm.lineItem.name?.length && vm.lineItem.name) || vm.lineItem.dealerAppointmentServiceOpCode?.name || vm.lineItem.formattedCorrection || (vm.lineItem.getName && vm.lineItem.getName(!vm.isDashboard)) ||
                                (!vm.isDashboard ? vm.lineItem.consumerName : null);

            if (vm.computedName === vm.computedDescription) {
                vm.computedDescription = null;
            } else if (vm.computedName && vm.computedDescription) {
                vm.computedName += ': ';
            }

            // For items coming directly from the check-in process as DealerAppointmentDetail records (ie: the RO hasn't been created yet in our system),
            //  the data model looks slightly different (ie: the note property contains the complaint).  Until we complete PROD-14742, 
            //  we need to account for these line items.
            if (!vm.lineItem.formattedComplaint && vm.lineItem.note) {
                vm.lineItem.formattedComplaint = vm.lineItem.note;
            }

            vm.showSeverityIcon = function () {
                let severity = vm.lineItem.severity;
            
                return (severity && severity !== 0);
            };

            vm.approvedClicked = function () {
                vm.lineItem.declined = false;
                vm.lineItem.approved = true;

                vm.itemizeTax?.();
            };

            vm.declinedClicked = function() {
                vm.lineItem.approved = false;
                vm.lineItem.declined = true;
                
                vm.itemizeTax?.();
            };

            function getSourceDescription() {
                if (vm.lineItem.sourceType === vm.lineItemSourceTypes.originalCustomerRequest || vm.lineItem.sourceType === vm.lineItemSourceTypes.checkIn) {
                    return 'Original Customer Request';
                } else {
                    return `Added by ${vm.lineItem.addedBy?.firstName} ${vm.lineItem.addedBy?.lastName} `;
                }
            }

            function init() {
                vm.enumSeverity = appointmentUtilService.getSystemSeverity(vm.lineItem.severity);      
                vm.sourceDescription = getSourceDescription();                
            }

            init();
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$uibModalStack", "$transitions", "$aside", "roService", "locationService", "INSPECT_CONSTANTS"];
    angular
        .module('redcap.inspect')
        .component('authorizationHistoryList', {
            templateUrl: 'app/shared/components/authorizations/authorization-history-list.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'dealerId': '<',
                'repairOrder': '<',
                'dashboardHistoryMode': '<?'
            }
        });

    function controller($uibModalStack, $transitions, $aside, roService, locationService, INSPECT_CONSTANTS) {
        this.$onInit = function() {
            let vm = this;
            let authGroupModal = null;

            vm.authorizationStatuses = INSPECT_CONSTANTS.lineItemStatus;            
            vm.loadingAuthHistory = true;

            function init() {
                roService.getAuthorizationHistory(vm.dealerId, vm.repairOrder.id).then((authHistory) => {
                    if (vm.dashboardHistoryMode) {
                        vm.authorizationHistory = processAuthorizationHistory(authHistory, INSPECT_CONSTANTS);
                    } else {
                        vm.authorizationHistory = authHistory.filter(item => !roService.isOpenOrPendingAuthGroup(item, INSPECT_CONSTANTS));
                    }
                }).finally(() => {
                    vm.loadingAuthHistory = false; 
                });
            }

            init();
            
            vm.gotoAuthHistory = function (index, authorizationGroup) {
                const currentlyActiveModal = $uibModalStack.getTop();
                let $existingModalEl = null;
                
                if (currentlyActiveModal?.value?.modalDomEl) {
                    $existingModalEl = angular.element(currentlyActiveModal.value.modalDomEl);

                    $existingModalEl.addClass('hidden');    
                }

                let options = {
                    templateUrl: 'app/shared/components/authorizations/partials/authorization-group-modal.html',
                    container: 'body',
                    placement: 'bottom',
                    backdrop: 'static',
                    show: false,
                    html: true,
                    keyboard: false,
                    windowClass: 'aside-centered z-index-top',
                    size: '60-percent',
                    controllerAs: 'vm',
                    controller: ['$uibModalInstance', 'resolvedRo', 'resolvedAuthGroupDetail', 'resolvedDealerOpCodes', 'consumerRepairOrderAuthorizationsService', 'INSPECT_CONSTANTS', 'dashboardHistoryMode', function($uibModalInstance, resolvedRo, resolvedAuthGroupDetail, resolvedDealerOpCodes, consumerRepairOrderAuthorizationsService, INSPECT_CONSTANTS, dashboardHistoryMode) {
                        let vm = this;

                        vm.repairOrder = resolvedRo;
                        vm.authorizationGroup = resolvedAuthGroupDetail;
                        vm.authorizationStatuses = INSPECT_CONSTANTS.lineItemStatus;
                        vm.dashboardHistoryMode = !!dashboardHistoryMode;

                        // TODO: Once again, we need to return this data properly from the server everywhere we need it, instead of having to use
                        //  the buildServiceOpViewModel method. 
                        const mappedOpCodes = consumerRepairOrderAuthorizationsService.getMappedOpCodes(resolvedDealerOpCodes, vm.repairOrder);

                        vm.authorizationGroup.authorizations.forEach((auth) => {
                            auth.serviceOperation = {...consumerRepairOrderAuthorizationsService.buildServiceOpViewModel(auth.serviceOperation, mappedOpCodes.find(moc => moc.opCode === auth.serviceOperation.opCode)), hideBreakdown: true};
                        });

                        vm.close = function() {
                            $uibModalInstance.dismiss();
                        };
                    }],
                    resolve: {
                        resolvedRo: function() { return vm.repairOrder; },
                        resolvedAuthGroupDetail: function () { return roService.getAuthorizationGroup(vm.dealerId, vm.repairOrder.id, authorizationGroup.id); },
                        resolvedDealerOpCodes: function() { return locationService.getLocationOpCodes(vm.repairOrder.dealerId); },
                        dashboardHistoryMode: function() { return !!vm.dashboardHistoryMode; }
                    }
                };

                authGroupModal = $aside.open(options);      
                authGroupModal.result.then(() => {}).catch(() => {}).finally(() => { if ($existingModalEl) $existingModalEl.removeClass('hidden'); });   
            };

            $transitions.onBefore({}, (trans) => { 
                if (authGroupModal) {
                    authGroupModal.dismiss();
                }
            });

            function processAuthorizationHistory(authHistory, INSPECT_CONSTANTS) {
                return authHistory.map(authorizationGroup => {
                    const createdDate = moment(authorizationGroup.createdDate).format('M/D/YY [at] h:mma');
                    const allOpenOrPending = roService.isOpenOrPendingAuthGroup(authorizationGroup, INSPECT_CONSTANTS);

                    if (allOpenOrPending) {
                        authorizationGroup.displayText = `SENT ${createdDate} (${authorizationGroup.authorizations.length} services)`;
                    } else {
                        authorizationGroup.approvedCount = 0;
                        authorizationGroup.deferredCount = 0;

                        authorizationGroup.authorizations.forEach(auth => {
                            if (auth.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.approved) {
                                authorizationGroup.approvedCount++;
                            }

                            if (auth.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.deferred) {
                                authorizationGroup.deferredCount++;
                            }
                        });
                        
                        authorizationGroup.displayText = `COMPLETED ${createdDate} (${authorizationGroup.approvedCount} approved, ${authorizationGroup.deferredCount} deferred)`;
                    }
                    
                    return authorizationGroup;
                });
            }
        };
    }    
})();

(function () {
    'use strict';

    controller.$inject = ["vehicleService", "rcUtilService"];
    angular
        .module('redcap.appointment')
        .component('vehicleRoHistory', {
            templateUrl: 'app/shared/components/appointments/vehicle-ro-history.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'dealerId': '<',
                'vin': '<',
                'year': '<',
                'make': '<',
                'model': '<'
            }
        });

    function controller(vehicleService, rcUtilService) {

        this.$onInit = function() {
            let vm = this;
            let maximumAutoloadCount = 5;

            vm.loading = true;
            vm.getOdometerAbbreviation = rcUtilService.getOdometerAbbreviation;

            vehicleService.getVehicleRoHistory(vm.dealerId, vm.vin).then((histories) => {
                vm.roHistories = histories;
                vm.loading = false;
            });

            vm.getDetails = function(roNumber, isManualClick) {
                let historyItem = _.find(vm.roHistories, {roNumber: roNumber});

                if (vm.roHistories.length > maximumAutoloadCount &&
                    (!historyItem.opCodes || historyItem.opCodes.length === 0)) {
                    vehicleService.getVehicleRoDetails(vm.dealerId, vm.vin, roNumber)
                        .then((result) => {
                            if ((!result || result.length === 0) && isManualClick) {
                                historyItem.opCodes = [];
                                historyItem.opCodes.push({opCodeDescription: 'No RO Details found.'});
                            } else {
                                historyItem.opCodes = result;
                            }
                        });
                } 
            };
        };
    }

})();

(function () {
    'use strict';

    controller.$inject = ["appointmentService", "locationService", "modalService", "appointmentUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .component('vehicleDetailsIssues', {
            templateUrl: 'app/shared/components/appointments/vehicle-details-issues.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'appointment': '<',
                'loadConditions': '<'
            }
        });

    function controller(appointmentService, locationService, modalService, appointmentUtilService, SYSTEM_ENUMS) {
        this.$onInit = function() {
            let vm = this;

            vm.loadingImages = true;
            vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
            vm.loadPredifinedMediaConfigs = 1;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;

            function getVehicleConditions() {
                appointmentService.getVehicleConditionImages(vm.appointment.dealerId, vm.appointment.id)
                    .then((issues) => {
                        vm.vehicleConditions = appointmentUtilService.processVehicleConditions(issues);
                        vm.imagesToDisplay = appointmentUtilService.convertVehicleConditionToImages(vm.vehicleConditions);
                        vm.textToDisplay = vm.vehicleConditions.filter(x => x.images.length == 1);
                        vm.loadingImages = false;
                    });
            }

            function getPredifinedMediaItems() {
                locationService.getPredifinedMediaConfigs(vm.appointment.dealerId, vm.appointment.id)
                    .then((result) => {
                        vm.totalPredifinedImages = 0;
                        vm.predifinedImages = result.map(item => {
                            const filteredImages = item.images.filter(image => image.imageId !== null);

                            return {
                                ...item,
                                images: filteredImages
                            };
                        }).filter(item => item.images.length > 0);
                        vm.predifinedImages.forEach(item => {
                            vm.totalPredifinedImages = vm.totalPredifinedImages + item.images.length;
                        });
                    });
            }

            vm.getMediaType = function(fileExtension) {
                return appointmentUtilService.getMediaType(fileExtension);
            };

            if (vm.loadConditions !== 1) {
                vm.vehicleConditions = vm.ngModel;
                vm.imagesToDisplay = appointmentUtilService.convertVehicleConditionToImages(vm.vehicleConditions);
                vm.textToDisplay = vm.vehicleConditions.filter(x => x.images.length == 0);
                vm.loadingImages = false;
            }

            vm.showConditions = false;
            vm.showPredifinedMediaItems = false;

            vm.isCheckingIn = function() {
                return appointmentUtilService.isCheckingIn(vm.appointment);
            };

            vm.isCheckedIn = function() {
                return appointmentUtilService.isCheckedIn(vm.appointment);
            };

            if (vm.loadConditions === 1) {
                getVehicleConditions();
            }

            if (vm.loadPredifinedMediaConfigs === 1) {
                getPredifinedMediaItems();
            }
            
            vm.openImageModal = function(url, description, mediaType) {
                modalService.showImageViewer(url, description, mediaType);
            };
        };
    }

})();

(function () {
    'use strict';

    controller.$inject = ["$rootScope", "$filter", "appointmentUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.appointment')
        .component('previouslyDeclinedServiceItem', {
            templateUrl: 'app/shared/components/appointments/previously-declined-service-item.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '=',
                'recmaintdata': '=',
                'isDashboard': '=',
                'appointment': '=',
                'paymentTypes': '=',
                'dmsSystem': '=',
                'deptOpCodes': '=',
                'isCheckin': '=',
                'serviceTypes': '<',
                'disableserviceselection': '<'
            }
        });

    function controller($rootScope, $filter, appointmentUtilService, SYSTEM_ENUMS) {

        this.$onInit = function() {
            let vm = this;

            vm.prevDeclined = vm.ngModel;
            vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
            vm.isDisabled = !!vm.servicesDisabled;

            if (!vm.prevDeclined.retailPrice) {
                vm.prevDeclined.retailPrice = 0;
            }

            if (!vm.prevDeclined.laborHours) {
                vm.prevDeclined.laborHours = 0;
            }

            function init() {
                vm.enumSeverity = appointmentUtilService.getSystemSeverity(vm.prevDeclined.severity);

                let deptOpCode = vm.deptOpCodes
                        ? $filter('filter')(vm.deptOpCodes, {opCode: vm.ngModel.opCode}, true)
                        : null;
                    let isDashboard = vm.isDashboard;

                if (!deptOpCode || deptOpCode && deptOpCode.length === 0) {
                    if (isDashboard === true) {
                        // in dashboard we put a line item mismatch on it
                        vm.prevDeclined.departmentPrevDeclinedMismatch = true;
                    } else {
                        // we disable the line item in consumer
                        vm.isDisabled = true;
                    }
                } else {
                    vm.prevDeclined.departmentPrevDeclinedMismatch = false;
                }
            }

            init();

            vm.deletedDeclined = {
                deleted: 'deleted',
                declined: 'declined'
            };

            vm.getName = function() {
                let dealerOpCode = vm.prevDeclined.dealerOpCode;

                if (vm.prevDeclined.isRecommendedMaintenance) {
                    return vm.prevDeclined.opCodeDescription;
                } else if (dealerOpCode) {
                    if (vm.isDashboard) {
                        return dealerOpCode.dashboardName || dealerOpCode.name;
                    } else {
                        return dealerOpCode.consumerName || dealerOpCode.name;
                    }
                } else {
                    return vm.prevDeclined.opCode;
                }
            };

            vm.getDescription = function() {
                let description = "";
                    let dealerOpCode = vm.prevDeclined.dealerOpCode;

                if (vm.prevDeclined.isRecommendedMaintenance) {
                    _.forEach(vm.recmaintdata,
                        (recMaint) => {
                            let title = appointmentUtilService.getRecMaintTitle(recMaint, vm.appointment).trim();

                            if (title === vm.prevDeclined.opCodeDescription) {
                                description = appointmentUtilService.getRecMainTooltip(recMaint.applications);
                            }
                        });

                    return description;
                } else {
                    if (vm.isDashboard && dealerOpCode) {
                        return dealerOpCode.dashboardDescription || dealerOpCode.description;
                    } else if (dealerOpCode) {
                        return dealerOpCode.consumerDescription || dealerOpCode.description;
                    } else {
                        return vm.prevDeclined.note || vm.prevDeclined.opCode;
                    }
                }
            };

            vm.validation = {
                valDecimal: function(value, lineItem, exactDecimalPlaces) {
                    return appointmentUtilService.validateDecimal(value, null, exactDecimalPlaces);
                }
            };

            vm.getNoteMaxLength = function() {
                return appointmentUtilService.getNoteMaxLength(vm.dmsSystem);
            };

            vm.deleteClicked = function() {
                if (vm.isDisabled) return;
                vm.prevDeclined.isDeleted = true;
                vm.prevDeclined.isDeclined = false;
                vm.prevDeclined.checked = false;
            };

            vm.prevDeclinedLineItemToggled = function() {
                vm.prevDeclined.checked = !vm.prevDeclined.checked;

                if (vm.prevDeclined.checked) {
                    vm.prevDeclined.isDeleted = false;
                    vm.prevDeclined.isDeclined = false;
                    vm.prevDeclined.deletedDeclined = null;
                }

                $rootScope.$broadcast('declinedServiceToggled');
            };


            $rootScope.$on('deptOpCodesUpdated',
                (event, data) => {
                    vm.deptOpCodes = data;
                    init();
                });

        };
    }

})();

(function () {
    'use strict';

    controller.$inject = ["$scope", "appointmentUtilService", "SYSTEM_ENUMS", "modalService", "roService", "consumerRepairOrderAuthorizationsService"];
    angular
        .module('redcap.appointment')
        .component('lineitemImageDisplay', {
            templateUrl: 'app/shared/components/appointments/lineitem-image-display.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                ngModel: '<',
                commonServices: '<',
                authorizedServices: '<',
                hideDate: '<'
            }
        });

    function controller($scope, appointmentUtilService, SYSTEM_ENUMS, modalService, roService, consumerRepairOrderAuthorizationsService) {

        this.$onInit = function() {
            let vm = this;

            vm.lineItem = vm.ngModel;
            vm.images = [];
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;

            // TODO: Replace the images collection with the media item collection at the server level, so we only ever have to look at one of these 
            //  collections regardless of what screen we're on.
            $scope.$watch('vm.lineItem.images', (newValue, oldValue, scope) => {
                updateImageContainer();
            }, true);

            $scope.$watch('vm.lineItem.mediaItems', (newValue, oldValue, scope) => {
                updateImageContainer();
            }, true);

            function updateImageContainer() {
                if (!vm.commonServices && !vm.lineItem.images) {
                    vm.lineItem.images = [];
                }

                if (vm.lineItem.images && vm.lineItem.images.length > 0) {
                    vm.images = vm.commonServices ? vm.getCommonServiceImages(vm.lineItem) : vm.lineItem.images;
                } else {                    
                    vm.images = vm.commonServices ? vm.getCommonServiceImages(vm.lineItem) : vm.lineItem.mediaItems ? vm.lineItem.mediaItems : [];
                }
            }
            
            vm.getMediaType = function(file) {
                if (file) {
                    if (file.fileExtension) {
                        return appointmentUtilService.getMediaType(file.fileExtension);
                    } else if (file.mediaType != null) {
                        if (file.mediaType === 1) {
                            return SYSTEM_ENUMS.mediaTypes.photo;
                        } else {
                            return SYSTEM_ENUMS.mediaTypes.video;
                        }
                    }
                }
            };

            vm.openImage = function(file, mediaType) {
                let url = file.mediaUrl || file.url;

                if (vm.lineItem.isNew) {
                    let index = vm.lineItem.mediaItems.findIndex(img => img === file);

                    modalService.showImageViewer(url, 'Service Image', mediaType, null, () => {
                        vm.lineItem.mediaItems.splice(index, 1);
                    });                    
                } else {
                    modalService.showImageViewer(url, 'Service Image', mediaType);
                }            

                if (file.id && vm.lineItem.repairOrderId) {
                    if (vm.lineItem.consumerKey)  {
                        consumerRepairOrderAuthorizationsService.addMediaImpression(vm.lineItem.dealerId, vm.lineItem.repairOrderId, file.id, vm.lineItem.consumerKey).catch(() => {
                            // Handle any exceptions in case they occur. 
                        });
                    } else {
                        roService.addMediaImpression(vm.lineItem.dealerId, vm.lineItem.repairOrderId, file.id).catch(() => {
                            // Handle any exceptions in case they occur. 
                        });
                    }
                }                
            };

            vm.getCommonServiceImages = function(lineItem) {
                let existingIndex = _.findIndex(vm.authorizedServices,
                    (l) => {
                        return l.opCode === lineItem.opCode && l.dealerAppointmentServiceOpCodeId === lineItem.id;
                    }
                );

                if (existingIndex > -1) {
                    return vm.authorizedServices[existingIndex].images;
                } else {
                    return [];
                }
            };

            if (vm.images && vm.images.length > 0) {
                updateImageContainer();
            }
        };
    }
})();

(function () {
    'use strict';

    controller.$inject = ["$timeout"];
    angular
        .module('redcap.appointment')
        .component('dignifi', {
            templateUrl: 'app/shared/components/appointments/dignifi.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'dealerId': '<'
            }
        });

    function controller($timeout) {

        this.$onInit = function() {
            var vm = this;
            vm.openDigniFi = function() {
                DigniFiPrequalWidget.open();
            };
        };
    }
    
})();

(function () {
    'use strict';

    controller.$inject = ["$scope", "$timeout"];
    angular
        .module('redcap.appointment')
        .component('departmentLandingpageSettings', {
            templateUrl: 'app/shared/components/appointments/department-landingpage-settings.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'index': '<'
            }
        });

    function controller($scope, $timeout) {

        this.$onInit = function() {
            var vm = this;

            function revalidateForm() {

                $scope.$broadcast('angularValidation.revalidate', 'rank_' + vm.ngModel.id);

            }

            $timeout(function() {
                    revalidateForm();
                },
                1);

        };
    }


})();

(function () {
    'use strict';

    controller.$inject = ["appointmentUtilService", "INSPECT_CONSTANTS", "consumerRepairOrderAuthorizationsService"];
    angular
        .module('redcap.appointment')
        .component('approvedServicesConfirmation', {
            templateUrl: 'app/shared/components/appointments/approved-services-confirmation.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'isDashboard': '='
            }
        });

    function controller(appointmentUtilService, INSPECT_CONSTANTS, consumerRepairOrderAuthorizationsService) {

        this.$onInit = function() {
            let vm = this;
            
            vm.services = vm.ngModel;
            vm.services = vm.services.filter((item) => {
                return item.approved == true || item.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.approved;
            }).map((item) => {
                // We want to return the authorization snapshot associated with this service to ensure we're showing the customer
                //  the data from when they authorized the service (in case the service has been changed/edited since the approval occurred)
                if (item.authorization) {
                    // TODO: Remove our dependency on this wretched "getServicesFromAuthorizations"/buildServiceOpViewModel method... use the view model coming directly from the server instead
                    return consumerRepairOrderAuthorizationsService.buildServiceOpViewModel(item.authorization.serviceOperation);
                } else {
                    return item;
                }
            });

            vm.getTotalEstimate = function() {
                return vm.services.reduce((total, service) => total + (parseFloat(service.retailPrice) || 0), 0);
            };
        };
    }

    
})();

(function () {
    'use strict';

    rcAsideHeader.$inject = ["rcUtilService", "appointmentUtilService", "SYSTEM_ENUMS"];
    angular
        .module('redcap')
        .component('asideHeader', {
            templateUrl: 'app/shared/components/asideHeader/aside-header.component.view.html',
            controller: rcAsideHeader,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<',
                'printClicked': '&',
                'constructedTitle': '<',
                'showPrintOption': '<'
            }
        });
      

    function rcAsideHeader(rcUtilService, appointmentUtilService, SYSTEM_ENUMS) {
        let vm = this;

        this.$onInit = function() {
            vm.shortSystemTripType = SYSTEM_ENUMS.systemTripType;
            vm.tripWorkflowTypes = SYSTEM_ENUMS.tripWorkflowTypes;
            vm.useTripNameOverrides = SYSTEM_ENUMS.useTripNameOverrides;
            vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
            vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;

            vm.enableMessaging = function(showPanel) {
                rcUtilService.showHideMobileMessagingPanel(showPanel);
            };

            vm.apptIdIsValid = function(apptId) {
                return rcUtilService.isValidID(apptId);
            };

            vm.removePipedData = function(apptId) {
                return appointmentUtilService.removePipedData(apptId);
            };

        };
    }

    
})();


(function () {
    'use strict';

    redCapMapController.$inject = ["$scope", "$element", "$timeout", "mapObjectFactory", "HereMapsCONSTS", "tripService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.directives')
        .directive('redcapMap', redCapMap);

    function redCapMap() {
        return {
            restrict: 'A',            
            templateUrl: 'app/shared/directives/redcap-map/redcap-map.html',
            controller: redCapMapController,
            controllerAs: 'vm',
            scope: {
                onMapLoaded: "&mapLoaded"
            },
            bindToController: {
                options: '<'
            }
        };
    }

    function redCapMapController($scope, $element, $timeout, mapObjectFactory, HereMapsCONSTS, tripService, SYSTEM_ENUMS) {
        this.$onInit = function() {
            var vm = this;
            var markers = [];
            var mapLoadedActions = [];
            var parentElement = angular.element($element[0].parentElement);
            vm.options = vm.options || {};

            init();

            function init() {
                var width = vm.options.width || parentElement.outerWidth();
                var height = vm.options.height || parentElement.outerHeight();

                var mapOptions = {
                    draggable: true,
                    resize: true,
                    coords: {
                        latitude: vm.options.lat || 26.114249,
                        longitude: vm.options.lng || -80.1368509
                    }
                };

                mapOptions.width = width === 0 ? 500 : width;
                mapOptions.height = height === 0 ? 300 : height;

                vm.mapOptions = mapOptions;

                var defaultListeners = {
                    drag: function() {

                    },
                    resize: function() {

                    }
                };

                vm.mapListeners = defaultListeners;

                if (vm.options.eventListeners) {
                    angular.extend(vm.mapListeners, vm.options.eventListeners);
                }

                vm.onMapReady = function(hereMap) {
                    vm.hereMap = hereMap;

                    hereMap.setZoom(HereMapsCONSTS.DEFAULT_MAP_OPTIONS.zoom);

                    var mapLoaded = $scope.onMapLoaded();
                    mapLoaded && mapLoaded(redcapMap());

                    _.forEach(mapLoadedActions,
                        function(action) {
                            action.fn.apply(null, action.args);
                        });
                };

                $scope.$on('resizeHereMap',
                    function() {
                        if (vm.hereMap) {
                            // Ensure the ui has had a chance to refresh before updating map position
                            $timeout(function() {
                                vm.hereMap.refresh();
                            });
                        }
                    });

                $scope.$on('updateMapObjects',
                    function(event, locations, paths) {
                        if (!vm.hereMap) {
                            mapLoadedActions.push({
                                fn: updateMapObjects,
                                args: Array.prototype.slice.call(arguments).slice(1)
                            });
                            return;
                        }

                        updateMapObjects(locations, paths);
                    });

                $scope.$on('updateRoute',
                    function(event, tripRoutes) {
                        if (!vm.hereMap) {
                            mapLoadedActions.push({
                                fn: updateRoute,
                                args: Array.prototype.slice.call(arguments).slice(1)
                            });
                            return;
                        }

                        updateRoute(tripRoutes);
                    });
            }

            function updateMapObjects(locations, paths) {
                clearAllMap();
                locations = locations || [];
                paths = paths || [];

                _.forEach(locations,
                    function(location) {
                        location.options = location.options || {};

                        var pinType = mapObjectFactory.getPinType(location.stopType),
                            title = markerTitle(pinType, location.name, location.name),
                            address = markerTitle(pinType, location.address, location.address),
                            infoWindow = null;

                        if (!location.options.hidePopup) {
                            infoWindow = {
                                display: 'onClick',
                                markup: '<div ng-non-bindable="">' +
                                    '<div class="header"><b>' +
                                    title +
                                    '</b></div>' +
                                    '<div class="text-uppercase">' +
                                    address.streetAddress +
                                    '</div>' +
                                    '<div class="text-uppercase">' +
                                    address.city +
                                    ', ' +
                                    address.state +
                                    ' ' +
                                    address.zip +
                                    '</div>' +
                                    '</div>'
                            };
                        }

                        var marker = mapObjectFactory.createHereMarker(parseFloat(location.lat),
                            parseFloat(location.lng),
                            location.stopType,
                            infoWindow,
                            location.options);

                        pushMarker(marker);
                    });

                var routePoints = [];

                _.forEach(paths,
                    function(path) {
                        var routeData = mapObjectFactory.buildRoute(path.route, true);
                        routePoints.push(routeData.route.shape);
                        vm.hereMap.addRouteToMap(routeData);
                    });

                vm.hereMap.updateMarkers(markers);

                fitBounds(routePoints, markers);
            }

            function updateRoute(tripRoutes) {
                clearAllMap();
                vm.selectedTrip = null;
                if (_.isNil(tripRoutes)) return;

                vm.selectedTrip = tripRoutes.updatedTrip;

                // These times are provided as UTC, so we convert them to local time here.
                _.forEach(vm.selectedTrip.stops,
                    function(stop) {
                        stop.estimatedArrival = tripService.utcToLocalJSDate(stop.estimatedArrival);
                        if (vm.selectedTrip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.inventoryTransport) {
                            stop.stopType = 0;
                        }
                    });

                tripRoutes.estimate.stops.forEach(function(stop) {
                    var pinType = mapObjectFactory.getPinType(stop.type),
                        title = markerTitle(pinType,
                            tripRoutes.estimate.customer ? tripRoutes.estimate.customer.address.name : '',
                            tripRoutes.estimate.dealer ? tripRoutes.estimate.dealer.address.name : ''),
                        address = markerTitle(pinType,
                            tripRoutes.estimate.customer ? tripRoutes.estimate.customer.address : '',
                            tripRoutes.estimate.dealer ? tripRoutes.estimate.dealer.address : ''),
                        infoWindow = {
                            display: 'onClick',
                            markup: '<div ng-non-bindable="">' +
                                '<div class="header"><b>' +
                                title +
                                '</b></div>' +
                                '<div class="text-uppercase">' +
                                address.streetAddress +
                                '</div>' +
                                '<div class="text-uppercase">' +
                                address.city +
                                ', ' +
                                address.state +
                                ' ' +
                                address.zip +
                                '</div>' +
                                '</div>'
                        };

                    if (vm.selectedTrip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.inventoryTransport) {
                        stop.type = 0;
                    }

                    var marker = mapObjectFactory.createHereMarker(stop.lat, stop.lng, stop.type, infoWindow);
                    pushMarker(marker);
                });

                if (tripRoutes.estimate.driverLocation || !_.isNil(tripRoutes.estimate.driverLocationAtStop)) {
                    var createInfoWindow = function(actualTrip, tripDetails) {
                        tripDetails = tripDetails || actualTrip;

                        if (!actualTrip || !actualTrip.driver) return null;
                        var timeETA = '<div>Route Complete</div>';

                        if (tripDetails.scheduledArrivalTime) {
                            var colorSched = tripDetails.scheduledArrivalTime > new Date() ? 'green' : 'red';
                            timeETA = '<div>ETA: <span style="color: ' +
                                colorSched +
                                '"> ' +
                                moment(tripDetails.scheduledArrivalTime).fromNow() +
                                '</span></div>';
                        }

                        if (tripDetails.driverActualArrivalTime && tripDetails.driverScheduledDepartureTime) {
                            var color = new Date() < tripDetails.driverScheduledDepartureTime ? 'green' : 'red',
                                duration = '';
                            if (tripDetails.driverStopDuration > 0)
                                duration = ' / ' + tripDetails.driverStopDuration + ' Min';
                            timeETA = '<div>Time: <span style="color: ' +
                                color +
                                '"> ' +
                                moment(tripDetails.driverActualArrivalTime).fromNow().replace(' ago', '') +
                                '</span>' +
                                duration +
                                '</div>';
                        }

                        if (tripDetails.isLyftTrip &&
                        (_.isNil(tripDetails.scheduledArrivalTime) ||
                            _.isNil(tripDetails.driverScheduledDepartureTime)))
                            timeETA = '<div></div>';

                        return {
                            display: 'onClick',
                            markup: '<div>\
                                <div>\
                                    <div class="infowindow-header">' +
                                actualTrip.driver.name +
                                '</div>\
                                    <div>' +
                                tripDetails.driverState +
                                '</div>' +
                                timeETA +
                                '<div class="grey">' +
                                'Last Update: ' +
                                moment(tripDetails.driverLastUpdated).fromNow() +
                                '</span></div>\
                                </div>'
                        };
                    };

                    var estimate = tripRoutes.estimate,
                        loc,
                        infoWindow,
                        marker;
                    if (!_.isNil(estimate.driverLocationAtStop)) {
                        loc = _.find(estimate.stops, { 'type': estimate.driverLocationAtStop });
                        infoWindow = createInfoWindow(estimate);
                        _.remove(markers,
                            function(marker) { return marker.lat === loc.lat && marker.lng === loc.lng; });

                        marker = mapObjectFactory.createHereMarker(loc.lat,
                            loc.lng,
                            estimate.driverLocationAtStop,
                            infoWindow);
                        pushMarker(marker);
                    } else {
                        loc = tripRoutes.estimate.driverLocation,
                            infoWindow = createInfoWindow(tripRoutes.actual || estimate, estimate);

                        marker = mapObjectFactory.createHereMarker(loc.latLng.lat,
                            loc.latLng.lng,
                            SYSTEM_ENUMS.destinationType.driverLocation,
                            infoWindow);
                        pushMarker(marker);

                        if (loc.stopType === undefined || loc.stopType === null)
                            setMarkerToDestinationIcon(estimate.destinationStopType);
                    }
                }

                var actualPath = tripRoutes.actual || null;
                var
                    estimatedPath =
                        null; // TODO: currently this directive is only being used by venue mapping, so no routes will be drawn.  We'll delete this directive once venue mapping is moved as

                var routePoints = [];

                if (estimatedPath && estimatedPath.route) {
                    addRouteToMap(estimatedPath.route, true, routePoints);
                }

                if (actualPath && actualPath.route) {
                    addRouteToMap(actualPath.route, false, routePoints);
                }

                if (tripRoutes.zen) {
                    var paths = [];
                    _.forEach(tripRoutes.zen.route,
                        function(history) {
                            paths = paths.concat(history.path);
                        });
                    tripRoutes.zen.route = paths;

                    addRouteToMap(tripRoutes.zen.route, false, routePoints);
                }

                vm.hereMap.updateMarkers(markers);

                fitBounds(routePoints, markers);
            }

            function addRouteToMap(routeToAdd, clearRoutes, routeBounds) {
                var routeData = mapObjectFactory.buildRoute(routeToAdd, clearRoutes);

                var routeShape = _.get(routeData, 'route.shape', undefined);
                if (routeShape && routeShape.length > 1) {
                    routeBounds.push(routeShape);
                    vm.hereMap.addRouteToMap(routeData);
                }
            }

            function fitBounds(routePoints, markers) {
                var allPoints = [].concat.apply([], routePoints);

                var bounds = allPoints.map(function(point) {
                    var coords = point.split(',');
                    return { lat: coords[0], lng: coords[1] };
                });

                markers.forEach(function(marker) {
                    bounds.push(marker.pos);
                });

                var viewBounds = vm.hereMap.getBoundsRectFromMultiplePoints(bounds);
                vm.hereMap.setViewBounds(viewBounds);

                zoomOutIfMarkersOnEdge();

                // If there is only one marker, the zoom level will be too tight, so we 
                //  zoom out slightly in this case.
                if (markers && markers.length === 1) {
                    $timeout(function() {
                        var currentZoom = vm.hereMap.getZoom();
                        vm.hereMap.setZoom(currentZoom - 3);
                    });
                }
            }

            function zoomOutIfMarkersOnEdge() {
                $timeout(function() {
                    var distanceThreshold = 40;
                    var markers = redcapMap().getMarkers();
                    var mapRect = vm.hereMap.getViewPort().element.getBoundingClientRect();

                    _.forEach(markers,
                        function(marker) {
                            var markerData = marker.getData();
                            var markerEl = angular.element('#' + markerData.elementId);
                            var markerOffset = markerEl && markerEl.offset();

                            if (mapRect && markerOffset) {
                                var topDiff = Math.abs(mapRect.top - markerOffset.top);
                                var bottomDiff = Math.abs(mapRect.bottom - markerOffset.top);
                                var leftDiff = Math.abs(mapRect.left - markerOffset.left);
                                var rightDiff = Math.abs(mapRect.right - markerOffset.left);

                                if (topDiff <= distanceThreshold ||
                                    leftDiff <= distanceThreshold ||
                                    bottomDiff <= distanceThreshold ||
                                    rightDiff <= distanceThreshold) {
                                    var currentZoom = vm.hereMap.getZoom();
                                    vm.hereMap.setZoom(currentZoom - 1);
                                    return false;
                                }
                            }
                        });
                });
            }

            function clearAllMap() {
                markers = [];

                if (vm.hereMap) {
                    vm.hereMap.updateMarkers(null);
                    vm.hereMap.cleanRoutes();
                }
            }

            function markerTitle(pinType, customerName, dealerName) {
                switch (pinType) {
                case SYSTEM_ENUMS.mapPinType.dealership:
                    return dealerName;
                case SYSTEM_ENUMS.mapPinType.customer:
                    return customerName;
                default:
                    return 'Stop';
                }
            }

            function pushMarker(marker) {
                var exists = _.some(markers,
                    function(m) {
                        return m.pos.lat === marker.pos.lat &&
                            m.pos.lng === marker.pos.lng &&
                            m.markup === marker.markup;
                    });

                if (!exists) {
                    markers.push(marker);
                }
            }

            function setMarkerToDestinationIcon(stopType) {
                var marker = _.find(markers, { stopType: stopType });
                if (marker) {
                    marker.markup = mapObjectFactory.getMapPin(stopType, true);
                }
            }

            function redcapMap() {
                return {
                    getCenter: function() {
                        return vm.hereMap.getCenter();
                    },
                    setCenter: function(coords) {
                        vm.hereMap.setCenter(coords);
                    },
                    getMarkers: function() {
                        return vm.hereMap.getMarkers();
                    }
                };
            }
        };
    }
})();

(function () {
    'use strict';

    driverTrackingController.$inject = ["$scope", "$element", "$timeout", "$q", "signalRService", "tripService", "mapObjectFactory", "HereMapsMarkerService", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "hereMapsService", "permissions", "rcUtilService", "modalService", "appointmentUtilService"];
    angular
        .module('redcap.directives')
        .directive('driverTracking', driverTrackingDirective);

    function driverTrackingDirective() {
        return {
            restrict: 'A',
            templateUrl: 'app/shared/directives/redcap-map/redcap-map.html',
            controller: driverTrackingController,
            controllerAs: 'vm',
            scope: {
                onMapLoaded: "&mapLoaded",
                onUiReady: "&uiReady",
            },
            bindToController: {
                options: '<',
                dealer: '<',

            }
        };
    }

    function driverTrackingController($scope, $element, $timeout, $q, signalRService, tripService, mapObjectFactory, HereMapsMarkerService, SYSTEM_ENUMS, HERE_MAPS_CONFIG, hereMapsService, permissions, rcUtilService, modalService, appointmentUtilService) {
        this.$onInit = function () {

            let vm = this;
            let _markers = [];
            let _hereMap = null;
            let _driverLocation = null;
            let _previousDriverLocation = null;
            let _estimatedRouteLine = null;
            let _resetView = true;
            let _map = null;
            let _eta = null;
            let _pickup = null;
            let _dropoff = null;
            let _tripUpdateListener = null;
            let _parentElement = angular.element($element[0].parentElement);
            let _previousDestinationType = null;
            let _defaultMapMode = vm.options.defaultMapMode || HERE_MAPS_CONFIG.mapModes.overview;
            let _previousTripId;
            let _sortedStops;
            let _hasStop;
            let _skipDriverLocationOnInit = vm.options.hideLoadingScreen;
            let _dealer = vm.dealer;
            let _currentTripPoints = null;
            let _driverMarker = null;
            let _clusterLayer = null;
            let _lastDriverRotation = null;
            let _clonedDriverContent = null;
            let _estimatedRoute = null;
            let _previousBeaconColor = null;
            let _pendingStyleSyncHandler = null;
            const SATELLITE_STYLE_ZOOM_THRESHOLD = 17;

            setMapMode(_defaultMapMode);
            vm.isSysAdmin = permissions.isSysAdmin() || permissions.isRedCapAdmin();
            vm.selectedTrip = vm.options.trip;
            vm.isLoading = !vm.options.hideLoadingScreen && vm.selectedTrip ? vm.selectedTrip.isDriverActive : false;
            vm.loadingInTransition = vm.isLoading;
            vm.mapModes = HERE_MAPS_CONFIG.mapModes;
            vm.lockMapMode = vm.options.lockMapMode;

            initMap();

            vm.recenter = function () {
                setMapMode(_defaultMapMode);
                setViewBounds();
            };

            vm.onMapReady = function (hereMap) {
                _hereMap = hereMap;
                _map = _hereMap.getPlatform().map;

                if (vm.selectedTrip) {
                    updateMap(vm.selectedTrip);
                }

                let mapLoaded = $scope.onMapLoaded();

                mapLoaded && mapLoaded(mapActions());
            };

            vm.onUiReady = function () {
                let uiReady = $scope.onUiReady();

                uiReady && uiReady();
            };

            vm.toggleFollowMode = function () {
                if (vm.mapMode === HERE_MAPS_CONFIG.mapModes.followMode) {
                    setMapMode(HERE_MAPS_CONFIG.mapModes.overview);
                } else {
                    setMapMode(HERE_MAPS_CONFIG.mapModes.followMode);
                }

                setViewBounds();
            };

            vm.assignDriver = function (tripId, driver) {
                if (driver.currentlyAssigned) return;

                let type = vm.selectedTrip.systemTripTypeId !== SYSTEM_ENUMS.systemTripType.mobileGarage ? 'driver' : 'mobile tech';
                let confirmMessage = 'Are you sure you want to assign this trip to this' + type + '?';

                if ((vm.selectedTrip.vehicle && vm.selectedTrip.vehicle.isManual) ||
                    (vm.selectedTrip.vehicle2 && vm.selectedTrip.vehicle2.isManual)) {
                    confirmMessage = 'Note, driver must be able to operate a manual transmission. ' + confirmMessage;
                }

                modalService.showYesNo('Are you sure?', confirmMessage, 'No', 'Yes', true, false).then(
                    (response) => {
                        if (response === true) {
                            vm.assigningDriver = true;
                            tripService.assignDriver(tripId, driver.username).then((result) => {
                                updateNearbyAssignedDriver(driver);
                            }).finally(() => {
                                vm.assigningDriver = false;
                            });
                        }
                    });
            };

            vm.messageDriver = function (driver) {
                if (!vm.isSysAdmin || !driver.isDnsDriver) return;

                modalService.sendDriverMessage(driver);
            };

            vm.filterNearbyDrivers = function () {
                if (vm.dnsDriversOnly) {
                    vm.filteredNearbyDrivers = _.filter(vm.nearbyDrivers,
                        (d) => {
                            return d.isDnsDriver == true;
                        });

                    vm.addNearbyMarkers();
                } else {
                    vm.filteredNearbyDrivers = vm.nearbyDrivers;

                    if (!vm.isSysAdmin) {
                        vm.filteredNearbyDrivers = _.filter(vm.filteredNearbyDrivers,
                            (d) => {
                                return !d.isDnsDriver;
                            });
                    }

                    vm.addNearbyMarkers();
                }
            };

            function addTappableMarkersToMap(markersToAdd, markerType, listId) {
                clearTappableMarkers();

                _.forEach(markersToAdd, (marker) => {
                    let tappableMarker = createTappableMarker(marker, markerType, listId);

                    if (tappableMarker) {
                        vm.tappableMarkers.push(tappableMarker);
                        _hereMap.addObject(tappableMarker);
                    }
                });
            }

            function clearTappableMarkers() {
                _.forEach(vm.tappableMarkers, (tappableMarker) => {
                    _hereMap.removeObject(tappableMarker);
                });

                vm.tappableMarkers = [];
            }

            vm.listItemHover = function (driverId, hovered) {
                let driverMarker = angular.element('#driver-' + driverId);

                if (hovered) {
                    driverMarker.addClass('highlighted');
                } else {
                    driverMarker.removeClass('highlighted');
                }
            };


            vm.addNearbyMarkers = function () {
                vm.clearNearbyMarkers();
                let timeNow = moment.utc();

                _.forEach(vm.filteredNearbyDrivers,
                    (driver) => {
                        if (driver.lastKnownLocation &&
                            timeNow.diff(moment.utc(driver.lastKnownLocation.timestamp), 'seconds') <
                            vm.locationThresholdSeconds) {
                            let driverMarker = createNearbyDriverIcon(driver);

                            if (driverMarker) {
                                vm.nearbyMarkers.push(driverMarker);
                                _hereMap.addObject(driverMarker);
                            }
                        }
                    });
            };

            vm.clearNearbyMarkers = function () {
                _.forEach(vm.nearbyMarkers,
                    (marker) => {
                        _hereMap.removeObject(marker);
                    });

                vm.nearbyMarkers = [];
            };

            vm.listItemHover = function (driverId, hovered) {
                let driverMarker = angular.element('#driver-' + driverId);

                if (hovered) {
                    driverMarker.addClass('highlighted');
                } else {
                    driverMarker.removeClass('highlighted');
                }
            };

            $scope.$on('resizeHereMap',
                () => {
                    if (_hereMap) {
                        $timeout(() => {
                            _hereMap.refresh();
                        });
                    }
                });

            $scope.$on('updateTrip',
                (event, updateModel) => {
                    vm.canChangeDriver = updateModel.trip.canChangeDriver;
                });


            function updateMap(trip) {
                _currentTripPoints = null;
                clearAllMap();
                vm.selectedTrip = trip;

                if (!vm.options.disableLiveTracking) {
                    if (!_tripUpdateListener && !vm.selectedTrip.isComplete && !vm.selectedTrip.isCanceled) {
                        initSignalRHub();
                    } else if (_tripUpdateListener && _previousTripId !== vm.selectedTrip.id) {
                        alterGroupItems(vm.selectedTrip ? vm.selectedTrip.id : null);
                    }
                }

                vm.tripState = {
                    friendlyName: vm.selectedTrip.stateName,
                    lastUpdated: moment().format('h:mm:ss A')
                };

                vm.isLoading = !vm.options.hideLoadingScreen && (vm.selectedTrip.isDriverActive || vm.selectedTrip.isComplete);
                vm.loadingInTransition = vm.isLoading;

                setTripStops();

                drawMapObjects().then((result) => {
                    _previousDriverLocation = _driverLocation;
                });
            }

            function initMap() {
                let width = vm.options.width || _parentElement.outerWidth();
                let height = vm.options.height || _parentElement.outerHeight();
                let defaultLat = _dealer ? _dealer.lat : 39.8283;
                let defaultLng = _dealer ? _dealer.lng : -98.5795;

                setTripStops();
                let mapOptions = {
                    draggable: vm.options.draggable !== false,
                    coords: {
                        latitude: _pickup ? _pickup.latLng.lat : defaultLat,
                        longitude: _pickup ? _pickup.latLng.lng : defaultLng
                    }
                };

                mapOptions.width = width === 0 ? 500 : width;
                mapOptions.height = height === 0 ? 300 : height;
                clearTappableMarkers();

                vm.mapOptions = mapOptions;

                vm.mapListeners = {
                    dragend: function (evt) {
                        setMapMode(HERE_MAPS_CONFIG.mapModes.userControlled);
                    },
                    tap: function (evt) {
                        setMapMode(HERE_MAPS_CONFIG.mapModes.userControlled);
                    },
                    wheel: function (evt) {
                        setMapMode(HERE_MAPS_CONFIG.mapModes.userControlled);
                    },
                    dbltap: function (evt) {
                        setMapMode(HERE_MAPS_CONFIG.mapModes.userControlled);
                    },
                    mapviewchangeend: function () {
                        if (!_hereMap) return;

                        queueMapStyleUpdate();
                    }
                };
            }

            function clearAllMap() {
                if (_hereMap) {
                    _hereMap.updateMarkers(null);
                    _markers = null;
                    _hereMap.cleanRoutes();

                    vm.clearNearbyMarkers();

                    clearDriverOnMap();

                    if (_estimatedRoute) {
                        _hereMap.removeObject(_estimatedRoute);
                        _estimatedRoute = null;
                    }

                    _previousTripId = vm.selectedTrip ? vm.selectedTrip.id : null;

                    vm.selectedTrip = null;
                    _estimatedRouteLine = null;
                    _pickup = null;
                    _dropoff = null;
                    _driverLocation = null;
                    _previousDriverLocation = null;
                    _resetView = true;
                    _driverMarker = null;
                    _previousBeaconColor = null;

                    setMapMode(_defaultMapMode);
                }
            }

            function setMapStyle(mapStyle) {
                _hereMap && _hereMap.setMapStyle(mapStyle);
            }

            function updateMapStyleForZoomLevel(zoomLevel) {
                if (zoomLevel > SATELLITE_STYLE_ZOOM_THRESHOLD) {
                    setMapStyle(HERE_MAPS_CONFIG.satelliteViewSettings);
                } else {
                    setMapStyle(HERE_MAPS_CONFIG.normalViewSettings);
                }
            }

            function queueMapStyleUpdate() {
                const viewModel = _hereMap.getMap().getViewModel();

                if (_pendingStyleSyncHandler) {
                    viewModel.removeEventListener('sync', _pendingStyleSyncHandler);
                }

                const syncHandler = () => {
                    viewModel.removeEventListener('sync', syncHandler);
                    _pendingStyleSyncHandler = null;

                    const zoomLevel = viewModel.getLookAtData().zoom;

                    updateMapStyleForZoomLevel(zoomLevel);
                };

                _pendingStyleSyncHandler = syncHandler;
                viewModel.addEventListener('sync', syncHandler);
            }

            function setMapMode(mapMode) {
                vm.mapMode = mapMode;
                _resetView = true;
            }

            function createNearbyDriverIcon(driver) {
                if (!driver.lastKnownLocation ||
                    !driver.lastKnownLocation.latitude ||
                    !driver.lastKnownLocation.longitude)
                    return null;

                let domIconElement = document.createElement('div');
                let iconContent = '';
                let driverMarker = null;

                let driverNames = driver.name.split(' ');
                let initials = driverNames[0][0] + (driverNames.length > 1 ? driverNames[1][0] : '');

                iconContent =
                    '<div id="driver-' +
                    driver.id +
                    '" class="nearby-driver-marker"><div class="centered-content text-uppercase font-bold">' +
                    initials +
                    '</div></div>';

                // add content to the element
                domIconElement.innerHTML = iconContent;

                // create dom marker to add to the map
                driverMarker = new H.map.DomMarker(
                    {lat: driver.lastKnownLocation.latitude, lng: driver.lastKnownLocation.longitude},
                    {
                        icon: new H.map.DomIcon(domIconElement,
                            {
                                anchor: new H.math.Point(25, 25)
                            }),
                        data: {
                            driverId: driver.id
                        }
                    });

                driverMarker.addEventListener('tap',
                    (driverMarker) => {
                        let listEl = angular.element('#nearby-driver-list');
                        let driverItemEl =
                            angular.element('#driver-' + driverMarker.target.getData().driverId + '-list-item');

                        listEl.animate({scrollTop: driverItemEl.prop('offsetTop')}, "slow");
                    });

                return driverMarker;
            }

            function createTappableMarker(data, markerType, listId) {

                let domIconElement = document.createElement('div');
                let iconContent = '';
                let mapMarker = null;
                let iconUrl = null;

                if (markerType === HERE_MAPS_CONFIG.markerTypes.driver) {
                    iconUrl = mapObjectFactory.icons.driverIcon.url;
                } else if (markerType === HERE_MAPS_CONFIG.markerTypes.customer) {
                    iconUrl = mapObjectFactory.icons.customerIcon.url;
                }

                iconContent = '<div id="marker-' + data.listItemId + '" class="tappable-marker"><div><img width="24" src="' + iconUrl + '" /></div></div>';
                domIconElement.style.margin = '-12px 0 0 -12px';
                // add content to the element
                domIconElement.innerHTML = iconContent;

                // create dom marker to add to the map
                mapMarker = new H.map.DomMarker({lat: data.lat, lng: data.lng}, {
                    icon: new H.map.DomIcon(domIconElement, {
                        anchor: new H.math.Point(25, 25)
                    }),
                    data: data
                });

                mapMarker.addEventListener('tap', (mapMarker) => {
                    let listEl = angular.element('#' + listId);
                    let listItemElem = angular.element('#tappable-item-' + data.listItemId);

                    listEl.animate({scrollTop: listItemElem.prop('offsetTop')}, "slow");
                });

                mapMarker.addEventListener('pointerenter', (mapMarker) => {
                    let listItemElem = angular.element('#tappable-item-' + data.listItemId);

                    listItemElem.addClass('highlighted');
                }, true);

                mapMarker.addEventListener('pointerleave', (mapMarker) => {
                    let listItemElem = angular.element('#tappable-item-' + data.listItemId);

                    listItemElem.removeClass('highlighted');
                }, true);

                return mapMarker;
            }

            function getDriverIcon(rotation, beaconColor) {
                let domIconElement = document.createElement('div');
                let iconContent = '';
                let driverMarker = null;
                let driverPositionToUse = _previousDriverLocation || _driverLocation;

                // set the anchor using margin css property depending on the content's (svg element below) size
                // to make sure that the icon's center represents the marker's geo positon

                if (hasValidVehicle(vm.selectedTrip)) {
                    iconContent = mapObjectFactory.rotateDriverIcon(0, vm.selectedTrip.lyftVehicle.color, beaconColor);
                    domIconElement.style.margin = '-50px 0 0 -50px';
                } else {
                    let iconUrl = mapObjectFactory.icons.driverIcon.url;

                    iconContent = '<div><div><img width="24" src="' + iconUrl + '" /></div></div>';
                    domIconElement.style.margin = '-12px 0 0 -12px';
                }

                // add content to the element
                domIconElement.innerHTML = iconContent;

                // create dom marker to add to the map
                driverMarker = new H.map.DomMarker(
                    {lat: driverPositionToUse.latLng.lat, lng: driverPositionToUse.latLng.lng},
                    {
                        icon: new H.map.DomIcon(domIconElement,
                            {
                                anchor: new H.math.Point(25, 25),
                                onAttach: function (clonedElement, domIcon, domMarker) {
                                    _clonedDriverContent = clonedElement.getElementsByTagName('svg')[0];

                                    // set last used value for rotation when dom icon is attached (back in map's viewport)
                                    if (_clonedDriverContent) {
                                        _clonedDriverContent.style.transform = 'rotate(' + rotation + 'deg) scale(.5)';
                                    }
                                }
                            })
                    });

                return driverMarker;
            }

            function updateDriverIcon(rotation) {
                if (_clonedDriverContent) {
                    _clonedDriverContent.style.transform = 'rotate(' + rotation + 'deg)  scale(.5)';
                }
            }

            function drawMarkers() {
                let needsUpdate = true;

                if (_eta && _driverLocation) {
                    switch (_driverLocation.workflowNav.stateId) {
                        case SYSTEM_ENUMS.driverTripStates.accepted:
                        case SYSTEM_ENUMS.driverTripStates.enrouteToPickup:
                            needsUpdate = setMarkerText(_pickup, _dropoff);
                            break;

                        case SYSTEM_ENUMS.driverTripStates.returningViaChase:
                            if (_driverLocation.workflowNav.oneWayStartsAtDealer) {
                                needsUpdate = setMarkerText(_dropoff, _pickup);
                            } else {
                                needsUpdate = setMarkerText(_pickup, _dropoff);
                            }

                            break;

                        case SYSTEM_ENUMS.driverTripStates.enrouteToStop:
                            needsUpdate = setMarkerText(_dropoff, _pickup);
                            break;

                        case SYSTEM_ENUMS.driverTripStates.enrouteToDropoff:
                            if (_hasStop) {
                                needsUpdate = setMarkerText(_pickup, _dropoff);
                            } else {
                                needsUpdate = setMarkerText(_dropoff, _pickup);
                            }

                            break;
                        default:
                            _pickup.text = null;
                            _dropoff.text = null;
                    }
                } else {
                    if (_pickup) _pickup.text = null;
                    if (_dropoff) _dropoff.text = null;
                }

                if (needsUpdate) {
                    _markers = getMarkersOfType(SYSTEM_ENUMS.hereObjectType.driver);

                    if (_pickup) {
                        _markers.push(mapObjectFactory.createMarkerHere(_pickup, _pickup.text, vm.options));
                    }

                    if (_dropoff) {
                        _markers.push(mapObjectFactory.createMarkerHere(_dropoff, _dropoff.text, vm.options));
                    }

                    _hereMap.updateMarkers(_markers);
                }
            }

            function setMarkerText(markerToChange, markerToReset) {
                let eta = new moment().add(_eta, 'seconds');
                let oldDropoffText = markerToChange.text;

                markerToChange.text = eta.format("h:mm A");
                markerToReset.text = null;

                return oldDropoffText !== markerToChange.text;
            }

            function drawRoutes() {
                if (_markers.length <= 1) return Promise.resolve(true);

                if (vm.selectedTrip.isDriverActive && (_driverLocation || !_skipDriverLocationOnInit)) {
                    if (!_driverLocation) {
                        return tripService.getDriverLocation(vm.selectedTrip.id, vm.selectedTrip.driver.id).then((driverLocation) => {
                            _driverLocation = driverLocation;
                            updateDriverOnMap({tripId: vm.selectedTrip.id}, _driverLocation);

                            return drawActiveRoutes();
                        });
                    } else {
                        return drawActiveRoutes();
                    }
                } else if (vm.selectedTrip.isDriverActive && vm.selectedTrip.driverLatestLocation) {
                    _driverLocation = vm.selectedTrip.driverLatestLocation;
                    vm.selectedTrip.driverLatestLocation = null;

                    updateDriverOnMap({tripId: vm.selectedTrip.id}, _driverLocation);

                    return drawActiveRoutes();
                } else if (!_estimatedRouteLine) {
                    let drawingRoutes = [];

                    // only draw first estimated polyline
                    let stopWithEstimatedPolyline =
                        _.find(_sortedStops, (stop) => { return stop.encodedPolyline; });

                    if (stopWithEstimatedPolyline) {
                        drawingRoutes.push(drawEstimatedRoute(null, null, [stopWithEstimatedPolyline.encodedPolyline]));
                    }

                    if (!vm.options.onlyShowEstimateOnCompleted) {
                        // don't draw the actual route from the driver to the stop
                        let stopsToDraw = _sortedStops.slice(1);
                        let actualPolylines = stopsToDraw
                            .filter((stop) => { return !_.isNil(stop.actualEncodedPolyline); })
                            .map((stop) => { return stop.actualEncodedPolyline; });

                        drawingRoutes.push(drawActualRoute(null, null, actualPolylines, _driverLocation));
                    }

                    return $q.all(drawingRoutes);
                }
            }

            function drawActiveRoutes() {
                let nextStop = getNextStopLocation();

                if (_previousDestinationType !== nextStop.stopType) {
                    // clear actual and estimated routes, and show the estimate to the next destination, and only draw the actual from the
                    //  previous destination to the driver.
                    _hereMap.cleanRoutes();
                    _previousDestinationType = nextStop.stopType;
                    _estimatedRouteLine = null;
                }

                let driverPositionToUse = _previousDriverLocation || _driverLocation;
                let driverPosition = angular.extend({heading: driverPositionToUse.heading}, driverPositionToUse.latLng);
                let drawingRoutes = [];

                if (!_estimatedRouteLine || vm.options.continuouslyUpdateEstimate) {
                    drawingRoutes.push(drawEstimatedRoute([driverPosition, nextStop.latLng],
                        vm.options.continuouslyUpdateEstimate));
                }

                if (vm.options.showActualRoute) {
                    drawingRoutes.push(drawActualRoute(driverPositionToUse.workflowNav.stateId || vm.selectedTrip.state,
                        false,
                        null,
                        {latLng: driverPosition}));
                }

                return $q.all(drawingRoutes);
            }

            function drawEstimatedRoute(waypoints, clearPrevious, estimatedPolylines) {
                if (estimatedPolylines) {
                    if (estimatedPolylines.length) {
                        _estimatedRouteLine = mapObjectFactory.buildRoute(null, true, estimatedPolylines);
                        _hereMap.addRouteToMap(_estimatedRouteLine);
                    }

                    return Promise.resolve(true);
                } else if (!_estimatedRoute) {
                    let paramsForRoute = {
                        waypoints: waypoints
                    };

                    return _hereMap.calculateRoute('car', paramsForRoute).then((result) => {
                        let sections = result && result.routes && result.routes.length > 0 ? result.routes[0].sections : null;
                        let lineStrings = [];

                        if (!sections) {
                            console.log('*** Warning: no route associated with trip. Route line will not be drawn on map. ***');

                            return;
                        }

                        sections.forEach((section) => {
                            // convert Flexible Polyline encoded string to geometry
                            lineStrings.push(H.geo.LineString.fromFlexiblePolyline(section.polyline));
                        });


                        let multiLineString = new H.geo.MultiLineString(lineStrings);
                        let bounds = multiLineString.getBoundingBox();

                        if (_estimatedRoute) {
                            _hereMap.removeObject(_estimatedRoute);
                        }

                        _estimatedRoute = new H.map.Polyline(multiLineString,
                            {
                                style:
                                {
                                    opacity: mapObjectFactory.pathOptions.strokeOpacity.estimate,
                                    lineWidth: mapObjectFactory.pathOptions.strokeWeight.estimate,
                                    color: mapObjectFactory.pathOptions.strokeColor.estimate
                                }
                            });

                        // render route on the map
                        _hereMap.addObject(_estimatedRoute);

                        return true;
                    });
                }
            }

            function drawActualRoute(tripState, getSnappedRoute, actualPolylines, driverPosition) {
                if (actualPolylines) {
                    if (actualPolylines.length) {
                        let actualPath = mapObjectFactory.buildRoute(null, false, actualPolylines);

                        _hereMap.addRouteToMap(actualPath);
                    }

                    return Promise.resolve(true);
                } else {
                    let tripIdForHistory = vm.selectedTrip.id;

                    //if we don't have the trip points, go get them.
                    if (!_currentTripPoints || _currentTripPoints.length === 0 || getSnappedRoute) {
                        return tripService.getDriverHistory(tripIdForHistory, tripState, getSnappedRoute).then((driverHistory) => {
                            // It's possible that we get results for a trip *after* a new trip was selected in the UI, so we make sure we
                            //  only draw routes for the currently selected trip.
                            if (tripIdForHistory === vm.selectedTrip.id) {
                                _.forEach(driverHistory, (drivingSegment) => {
                                    _currentTripPoints = [];

                                    _.forEach(drivingSegment.points, (point) => {
                                        _currentTripPoints.push([point.latLng.lat, point.latLng.lng]);
                                    });

                                    if (_currentTripPoints.length > 1) {
                                        drawActualPath();
                                    }
                                });

                                return true;
                            } else {
                                return false;
                            }
                        });
                    } else {
                        if (driverPosition &&
                            driverPosition.latLng &&
                            driverPosition.latLng.lat &&
                            driverPosition.latLng.lng) {
                            _currentTripPoints.push([driverPosition.latLng.lat, driverPosition.latLng.lng]);
                            drawActualPath();

                            return Promise.resolve(true);
                        }
                    }
                }
            }

            function drawActualPath() {
                let actualPath = mapObjectFactory.buildRoute(_currentTripPoints, false);

                _hereMap.removeRoutesFromMap(SYSTEM_ENUMS.routeTypes.actual);
                _hereMap.addRouteToMap(actualPath, false, {routeType: SYSTEM_ENUMS.routeTypes.actual});
            }

            function setViewBounds() {
                if (vm.mapMode === HERE_MAPS_CONFIG.mapModes.followMode && vm.selectedTrip.isDriverActive && _driverLocation) {
                    centerOnDriver(_driverLocation, _previousDriverLocation);
                } else if (vm.mapMode === HERE_MAPS_CONFIG.mapModes.overview && vm.isSysAdmin && !vm.selectedTrip) {
                    _hereMap.setCenter({lat: 39.8283, lng: -98.5795});
                    _hereMap.setZoom(4);
                } else if (vm.mapMode !== HERE_MAPS_CONFIG.mapModes.userControlled && _resetView) {
                    _hereMap.fitAll();
                    _resetView = false;
                }
            }

            function updateDriverOnMap(driverLocationInformation, currentDriverLocation) {
                // There are times when Uber sends us no driver location.  In those cases, we don't want to attempt to display 0,0 on the map.
                if (currentDriverLocation && currentDriverLocation.latLng && currentDriverLocation.latLng.lat == 0 && currentDriverLocation.latLng.lng == 0)
                    return;

                if (!_driverMarker && (_previousDriverLocation || currentDriverLocation)) {
                    _driverMarker = _hereMap.getDriverMarker();

                    if (!_driverMarker) {
                        addDriverToMap(driverLocationInformation.beaconColor);
                    }
                }

                if (_previousBeaconColor != driverLocationInformation.beaconColor && _driverMarker) {
                    clearDriverOnMap();
                    addDriverToMap(driverLocationInformation.beaconColor);
                }

                if (_previousDriverLocation && _driverLocation && _driverMarker) {
                    let startCoord = _previousDriverLocation.latLng || _driverMarker.getGeometry(); // TODO: consider always using _driverMarker.getGeometry() if it has a value.
                    let endCoord = _driverLocation.latLng;
                    let durationMs = 2000;

                    rcUtilService.ease(startCoord, endCoord, durationMs, (coord) => {
                        if (_lastDriverRotation !== currentDriverLocation.heading) {
                            _lastDriverRotation = currentDriverLocation.heading;
                            updateDriverIcon(currentDriverLocation.heading);
                        }

                        if (_driverMarker) {
                            _driverMarker.setGeometry({lat: coord.lat, lng: coord.lng});
                        }
                    }, null);
                }
            }

            function addDriverToMap(beaconColor) {
                _driverMarker = getDriverIcon(0, beaconColor);
                _lastDriverRotation = 0;
                _hereMap.addObject(_driverMarker);
                _previousBeaconColor = beaconColor;
            }

            function clearDriverOnMap() {
                if (_driverMarker) {
                    _hereMap.removeObject(_driverMarker);
                    _driverMarker = null;
                }

                _markers = getMarkersOfType(SYSTEM_ENUMS.hereObjectType.marker);
                _hereMap.updateMarkers(_markers);
            }

            function drawMapObjects() {
                drawMarkers();

                return drawRoutes().then((results) => {
                    let allRoutesLoaded = _.every(results, (routeComplete) => {
                        return routeComplete === true;
                    });

                    if (!allRoutesLoaded) return false;

                    vm.isLoading = false;

                    $timeout(() => {
                        vm.loadingInTransition = false;
                    }, 600);

                    setViewBounds();

                }).catch((err) => {
                    console.log('Problem drawing routes', err);
                });
            }

            function centerOnDriver(currentLocation, previousLocation) {
                let nextStop = getNextStopLocation().latLng;
                let previousLoc = previousLocation || {};
                let rect = _hereMap.getBoundsRectFromMultiplePoints([previousLoc.latLng, currentLocation.latLng, nextStop]);
                let viewBounds = _hereMap.getMap().getViewModel().getLookAtData().bounds.getBoundingBox();
                let containsPoint = viewBounds.containsPoint(nextStop);

                if (!containsPoint || _resetView) {
                    if (_hereMap.getZoom() < 14) {
                        _hereMap.getMap().getViewModel().setLookAtData(
                            {
                                position: currentLocation.latLng,
                                zoom: 14
                            },
                            true
                        );
                    } else {
                        _hereMap.setCenter(currentLocation.latLng, true);
                    }

                    _resetView = false;
                } else {
                    _hereMap.setViewBounds(rect, true);
                }
            }

            function getNextStopLocation() {
                let currentStopType = _driverLocation.workflowNav.stopType;

                switch (currentStopType) {
                    case SYSTEM_ENUMS.stopType.pickup:
                        return _pickup;
                    case SYSTEM_ENUMS.stopType.stop:
                        return _dropoff;
                    case SYSTEM_ENUMS.stopType.dropoff:
                        if (_hasStop) return _pickup;
                        else return _dropoff;
                }
            }

            function setTripStops() {
                if (vm.selectedTrip) {
                    // These times are provided as UTC, so we convert them to local time here.
                    _.forEach(vm.selectedTrip.stops,
                        (stop) => {
                            let utcDate = tripService.utcToLocalJSDate(stop.estimatedArrival);

                            if (utcDate instanceof Date && !isNaN(utcDate)) stop.estimatedArrival = utcDate;

                            if (vm.selectedTrip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.inventoryTransport) {
                                stop.stopType = 0;
                            }
                        });

                    _hasStop = _.some(vm.selectedTrip.stops, (stop) => { return stop.locationType === SYSTEM_ENUMS.stopType.stop; });
                    _sortedStops = _.sortBy(vm.selectedTrip.stops, (stop) => { return stop.estimatedArrival; });
                    _pickup = _sortedStops[0];

                    if (_sortedStops.length > 1)
                        _dropoff = _sortedStops[1];
                }
            }

            function updateNearbyAssignedDriver(assignedDriver) {
                _.forEach(vm.nearbyDrivers, (d) => {
                    d.currentlyAssigned = false;
                });

                if (assignedDriver) {
                    let nearbyDriver = _.find(vm.nearbyDrivers, (d) => {
                        return d.username === assignedDriver.userName || d.username === assignedDriver.username;
                    });

                    if (nearbyDriver)
                        nearbyDriver.currentlyAssigned = true;
                }
            }

            function initSignalRHub() {
                if (vm.selectedTrip) {
                    _tripUpdateListener = signalRService.registerDriverTrackingListener(vm.selectedTrip.id);

                    _tripUpdateListener.on(signalRService.events.driverTracking.driverLocationOnlyChanged, (updatedDriverLocation) => {
                        if (_hereMap) {
                            if (_driverLocation) {
                                _driverLocation.latLng = updatedDriverLocation.latLng;
                                _driverLocation.heading = updatedDriverLocation.heading;

                                updateDriverOnMap({beaconColor: null}, _driverLocation);
                                setViewBounds();

                                drawMapObjects().then((response) => {
                                    // Cloning so that the previous location latLng doesn't get updated with the new latLng above
                                    //  when it's set on the _driverLocation object.
                                    _previousDriverLocation = _.cloneDeep(_driverLocation);
                                });
                            }
                        }
                    });

                    _tripUpdateListener.on(signalRService.events.driverTracking.driverPositionChanged, (driverTrackingInformation) => {
                        // It's possible that we could receive an update for a previous trip after the selected trip was changed, so
                        //  we ensure we don't process old trips in that case.
                        if (vm.selectedTrip && driverTrackingInformation.tripId === vm.selectedTrip.id) {
                            $scope.$emit('trackingUpdateReceived', driverTrackingInformation);

                            vm.tripState = {
                                friendlyName: driverTrackingInformation.workflowNav.friendlyState,
                                lastUpdated: moment().format('h:mm:ss A')
                            };

                            if (!driverTrackingInformation.isCanceled) {
                                if (getDriverId(driverTrackingInformation) !== getDriverId(vm.selectedTrip)) {
                                    vm.selectedTrip.driver = driverTrackingInformation.driver;
                                }

                                if (hasValidVehicle(driverTrackingInformation)) {
                                    vm.selectedTrip.lyftVehicle = driverTrackingInformation.lyftVehicle;
                                }
                            }

                            let currentDriverLocation = driverTrackingInformation.driverLatestLocation;

                            if (currentDriverLocation) {
                                _eta = currentDriverLocation.etaSeconds || 0;
                                vm.selectedTrip.isDriverActive = driverTrackingInformation.isDriverActive;

                                if (!vm.selectedTrip.isDriverActive) {
                                    _driverLocation = null;
                                    _estimatedRouteLine = null;
                                    _sortedStops = driverTrackingInformation.tripStops || _sortedStops;
                                    vm.options.continuouslyUpdateEstimate = false;
                                    vm.selectedTrip.isComplete = driverTrackingInformation.isComplete;
                                    vm.selectedTrip.isCanceled = driverTrackingInformation.isCanceled;

                                    _hereMap.cleanRoutes();
                                    setMapMode(HERE_MAPS_CONFIG.mapModes.overview);
                                } else {
                                    _driverLocation = currentDriverLocation;
                                    _driverLocation.workflowNav = driverTrackingInformation.workflowNav;
                                }

                                if (!_previousDriverLocation && _driverLocation && !_hereMap.getMap().getViewModel().getLookAtData().bounds.getBoundingBox().containsPoint(_driverLocation.latLng)) {
                                    // If the trip didn't have a driver location, but it gets one that wasn't previously in view, we tell the map to fit the driver into view
                                    _resetView = true;
                                }

                                if (_hereMap) {
                                    if (_driverLocation) {
                                        updateDriverOnMap(driverTrackingInformation, currentDriverLocation);
                                        setViewBounds();
                                    } else {
                                        clearDriverOnMap();
                                    }

                                    drawMapObjects().then((response) => {
                                        _previousDriverLocation = _driverLocation;
                                    });
                                }
                            }
                        }
                    }).start();
                }
            }

            function closeCurrentSignalRConnection() {
                if (_tripUpdateListener) _tripUpdateListener.disconnect();
                _previousTripId = null;
                _tripUpdateListener = null;
            }

            function alterGroupItems(newTripId) {
                if (_tripUpdateListener) {
                    _tripUpdateListener.alterGroupItems(_previousTripId, newTripId);
                }
            }

            function hasValidVehicle(tripInfo) {
                return !_.isNil(_.get(tripInfo, 'lyftVehicle.make'));
            }

            function getDriverId(locationInfo) {
                return _.get(locationInfo, 'driver.id');
            }

            $scope.$on('$destroy',
                () => {
                    closeCurrentSignalRConnection();
                });

            function getMarkersOfType(markerType) {
                // var markers = _hereMap.getMarkers() || [];
                // var driver = _hereMap.getDriverMarker();
                // if (driver) markers.push(driver);

                return _.filter(_markers,
                    (marker) => {
                        if (marker.getData || marker.data) {
                            let data = marker.data || marker.getData();

                            return !data || data.objectType === markerType;
                        }

                        return true;
                    });
            }

            function mapActions() {
                return {
                    refresh: function () {
                        _hereMap.refresh();
                    },
                    updateMap: function (trip) {
                        updateMap(trip);
                    },
                    clearMap: function () {
                        clearAllMap();
                    },
                    setCenter: function (coords, opt_animate) {
                        _hereMap.setCenter(coords, opt_animate);
                    },
                    setMapSizes: function (width, height) {
                        _hereMap.setMapSizes(width, height);
                    },
                    getMarkers: function () {
                        return _hereMap.getMarkers();
                    },
                    updateMarkers: function (places) {
                        _hereMap.updateMarkers(places, true);
                    },
                    addCircle: function (lat, lng, areaInMeters, style) {
                        _hereMap.addCircle(lat, lng, areaInMeters, style);
                    },
                    removeCircle: function () {
                        _hereMap.removeCircle();
                    },
                    setStyle: function (style) {
                        _hereMap.setMapStyle(style);
                    },
                    getMap: function () {
                        return _hereMap.getMap();
                    },
                    setLoading: function (trip) {
                        vm.isLoading = trip.isDriverActive || trip.isComplete;
                        vm.loadingInTransition = vm.isLoading;
                    },
                    setZoom: function (zoom) {
                        _hereMap.setZoom(zoom);
                    },
                    alterGroupItems: function () {
                        alterGroupItems(null);
                    },
                    stopDriverUpdates: function () {
                        closeCurrentSignalRConnection();
                    },
                    fitAll: function () {
                        _hereMap.fitAll();
                    },
                    addLayer: function (layer) {
                        _hereMap.getMap().addLayer(layer);
                    },
                    removeLayer: function (layer) {
                        _hereMap.getMap().removeLayer(layer);
                    },
                    showNearbyDriversButton: function () {
                        let callback = function () {
                            vm.canChangeDriver = vm.selectedTrip.canChangeDriver;

                            if (!vm.showNearbyDriversList) {
                                tripService.getNearbyDrivers(vm.selectedTrip.id).then((result) => {
                                    vm.nearbyDrivers = result.nearbyDrivers;
                                    vm.showNearbyDriversList = true;
                                    vm.hasDnsDrivers = _.some(vm.nearbyDrivers,
                                        (driver) => { return driver.isDnsDriver; });
                                    vm.locationThresholdSeconds = result.locationThresholdSeconds;
                                    vm.filterNearbyDrivers();
                                    $timeout(() => {
                                        updateHeight(true);
                                    },
                                        100);
                                });
                            } else {
                                vm.showNearbyDriversList = false;

                                vm.clearNearbyMarkers();
                                $timeout(() => {
                                    updateHeight(false);
                                },
                                    100);
                            }

                            function updateHeight(isExpanding) {
                                if (!vm.expandedWidth)
                                    vm.expandedWidth = _parentElement.outerWidth();

                                let heightDiff = isExpanding ? 200 : -200;
                                let mapWidth = isExpanding ? '70%' : vm.expandedWidth + 'px';
                                let newHeight = _parentElement.outerHeight() + heightDiff;
                                let mapWrap = _parentElement.find('.map-wrap');


                                _parentElement.css('height', newHeight + 'px');
                                mapWrap.css('height', newHeight + 'px');

                                if (isExpanding) {
                                    mapWrap.addClass('expanded');
                                } else {
                                    mapWrap.removeClass('expanded');
                                }

                                // Ensure we give the UI a chance to refresh before setting map width
                                $timeout(() => {
                                    _hereMap.setMapSizes(newHeight, mapWidth);
                                },
                                    100);

                            }
                        };


                        $timeout(() => {
                            let mapContainerWidth = angular.element('#trip-map-summary').width();
                            let mapWrap = _parentElement.find('.map-wrap');

                            mapWrap.css('width', mapContainerWidth + 'px');

                            let newMapHeight = mapWrap.outerHeight();
                            let newMapWidth = mapWrap.outerWidth();

                            $timeout(() => {
                                _hereMap.setMapSizes(newMapHeight, newMapWidth);
                            },
                                100);
                        },
                            750);

                        _hereMap.showNearbyDriversButton(callback);
                    },
                    updateAssignedDriver: function (driver) {
                        updateNearbyAssignedDriver(driver);
                    },
                    removeClusters: function () {
                        _hereMap.getMap().removeLayer(_clusterLayer);
                        _clusterLayer = null;
                    },
                    addClusters: function (dataPoints) {
                        // Create a layer that includes the data provider and its data points: 
                        if (_clusterLayer) {
                            this.removeClusters();
                        }

                        let clusteredDataProvider = new H.clustering.Provider(dataPoints,
                            {
                                theme: HereMapsMarkerService.getClusterTheme(_hereMap),
                                clusteringOptions: {
                                    eps: 32,
                                    minWeight: 3
                                }
                            });

                        _clusterLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);

                        _hereMap.getMap().addLayer(_clusterLayer);

                        return _clusterLayer;
                    },
                    addTappableMarkers: function (dataPoints, markerType, listId) {
                        addTappableMarkersToMap(dataPoints, markerType, listId);
                    },
                    removeTappableMarkers: function () {
                        clearTappableMarkers();
                    }
                };
            }
        };
    }
})();

/* global angular */
angular.module('afkl.lazyImage', []);
/* global angular */
angular.module('afkl.lazyImage')
    .service('afklSrcSetService', ['$window', function($window) {
        'use strict';

        /**
         * For other applications wanting the srccset/best image approach it is possible to use this module only
         * Loosely based on https://raw.github.com/borismus/srcset-polyfill/master/js/srcset-info.js
         */
        var INT_REGEXP = /^[0-9]+$/;

        // SRCSET IMG OBJECT
        function ImageInfo(options) {
            this.src = options.src;
            this.w = options.w || Infinity;
            this.h = options.h || Infinity;
            this.x = options.x || 1;
        }

        /**
         * Parse srcset rules
         * @param  {string} descString Containing all srcset rules
         * @return {object}            Srcset rules
         */
        var _parseDescriptors = function (descString) {

            var descriptors = descString.split(/\s/);
            var out = {};

            for (var i = 0, l = descriptors.length; i < l; i++) {

                var desc = descriptors[i];

                if (desc.length > 0) {

                    var lastChar = desc.slice(-1);
                    var value = desc.substring(0, desc.length - 1);
                    var intVal = parseInt(value, 10);
                    var floatVal = parseFloat(value);

                    if (value.match(INT_REGEXP) && lastChar === 'w') {
                        out[lastChar] = intVal;
                    } else if (value.match(INT_REGEXP) && lastChar === 'h') {
                        out[lastChar] = intVal;
                    } else if (!isNaN(floatVal) && lastChar === 'x') {
                        out[lastChar] = floatVal;
                    }

                }
            }

            return out;

        };

        /**
         * Returns best candidate under given circumstances
         * @param  {object} images     Candidate image
         * @param  {function} criteriaFn Rule
         * @return {object}            Returns best candidate under given criteria
         */
        var _getBestCandidateIf = function (images, criteriaFn) {

            var bestCandidate = images[0];

            for (var i = 0, l = images.length; i < l; i++) {
                var candidate = images[i];
                if (criteriaFn(candidate, bestCandidate)) {
                    bestCandidate = candidate;
                }
            }

            return bestCandidate;

        };

        /**
         * Remove candidate under given circumstances
         * @param  {object} images     Candidate image
         * @param  {function} criteriaFn Rule
         * @return {object}            Removes images from global image collection (candidates)
         */
        var _removeCandidatesIf = function (images, criteriaFn) {

            for (var i = images.length - 1; i >= 0; i--) {
                var candidate = images[i];
                if (criteriaFn(candidate)) {
                    images.splice(i, 1); // remove it
                }
            }

            return images;

        };

        /**
        * Direct implementation of "processing the image candidates":
        * http://www.whatwg.org/specs/web-apps/current-work/multipage/embedded-content-1.html#processing-the-image-candidates
        *
        * @param  {array} imageCandidates (required)
        * @param  {object} view (optional)
        * @returns {ImageInfo} The best image of the possible candidates.
        */
        var getBestImage = function (imageCandidates, view) {

            if (!imageCandidates) { return; }
            if (!view) {
                view = {
                    'w' : $window.innerWidth || document.documentElement.clientWidth,
                    'h' : $window.innerHeight || document.documentElement.clientHeight,
                    'x' : $window.devicePixelRatio || 1
                };
            }

            var images = imageCandidates.slice(0);

            /* LARGEST */
            // Width
            var largestWidth = _getBestCandidateIf(images, function (a, b) { return a.w > b.w; });
            // Less than client width.
            _removeCandidatesIf(images, (function () { return function (a) { return a.w < view.w; }; })(this));
            // If none are left, keep the one with largest width.
            if (images.length === 0) { images = [largestWidth]; }


            // Height
            var largestHeight = _getBestCandidateIf(images, function (a, b) { return a.h > b.h; });
            // Less than client height.
            _removeCandidatesIf(images, (function () { return function (a) { return a.h < view.h; }; })(this));
            // If none are left, keep one with largest height.
            if (images.length === 0) { images = [largestHeight]; }

            // Pixel density.
            var largestPxDensity = _getBestCandidateIf(images, function (a, b) { return a.x > b.x; });
            // Remove all candidates with pxdensity less than client pxdensity.
            _removeCandidatesIf(images, (function () { return function (a) { return a.x < view.x; }; })(this));
            // If none are left, keep one with largest pixel density.
            if (images.length === 0) { images = [largestPxDensity]; }


            /* SMALLEST */
            // Width
            var smallestWidth = _getBestCandidateIf(images, function (a, b) { return a.w < b.w; });
            // Remove all candidates with width greater than it.
            _removeCandidatesIf(images, function (a) { return a.w > smallestWidth.w; });

            // Height
            var smallestHeight = _getBestCandidateIf(images, function (a, b) { return a.h < b.h; });
            // Remove all candidates with height greater than it.
            _removeCandidatesIf(images, function (a) { return a.h > smallestHeight.h; });

            // Pixel density
            var smallestPxDensity = _getBestCandidateIf(images, function (a, b) { return a.x < b.x; });
            // Remove all candidates with pixel density less than smallest px density.
            _removeCandidatesIf(images, function (a) { return a.x > smallestPxDensity.x; });

            return images[0];

        };



        // options {src: null/string, srcset: string}
        // options.src    normal url or null
        // options.srcset 997-s.jpg 480w, 997-m.jpg 768w, 997-xl.jpg 1x
        var getSrcset = function (options) {

            var imageCandidates = [];

            var srcValue = options.src;
            var srcsetValue = options.srcset;

            if (!srcsetValue) { return; }

            /* PUSH CANDIDATE [{src: _, x: _, w: _, h:_}, ...] */
            var _addCandidate = function (img) {

                for (var j = 0, ln = imageCandidates.length; j < ln; j++) {
                    var existingCandidate = imageCandidates[j];

                    // DUPLICATE
                    if (existingCandidate.x === img.x &&
                        existingCandidate.w === img.w &&
                        existingCandidate.h === img.h) { return; }
                }

                imageCandidates.push(img);

            };


            var _parse = function () {

                var input = srcsetValue,
                position = 0,
                rawCandidates = [],
                url,
                descriptors;

                while (input !== '') {

                    while (input.charAt(0) === ' ') {
                        input = input.slice(1);
                    }

                    position = input.indexOf(' ');

                    if (position !== -1) {

                        url = input.slice(0, position);

                        // if (url === '') { break; }

                        input = input.slice(position + 1);

                        position = input.indexOf(',');

                        if (position === -1) {
                            descriptors = input;
                            input = '';
                        } else {
                            descriptors =  input.slice(0, position);
                            input = input.slice(position + 1);
                        }

                        rawCandidates.push({
                            url: url,
                            descriptors: descriptors
                        });

                    } else {

                        rawCandidates.push({
                            url: input,
                            descriptors: ''
                        });
                        input = '';
                    }

                }

                // FROM RAW CANDIDATES PUSH IMAGES TO COMPLETE SET
                for (var i = 0, l = rawCandidates.length; i < l; i++) {

                    var candidate = rawCandidates[i],
                    desc = _parseDescriptors(candidate.descriptors);

                    _addCandidate(new ImageInfo({
                        src: candidate.url,
                        x: desc.x,
                        w: desc.w,
                        h: desc.h
                    }));

                }

                if (srcValue) {
                    _addCandidate(new ImageInfo({src: srcValue}));
                }

            };

            _parse();


            // Return best available image for current view based on our list of candidates
            var bestImage = getBestImage(imageCandidates);

            /**
             * Object returning best match at moment, and total collection of candidates (so 'image' API can be used by consumer)
             * @type {Object}
             */
            var object = {
                'best': bestImage,              // IMAGE INFORMATION WHICH FITS BEST WHEN API IS REQUESTED
                'candidates': imageCandidates   // ALL IMAGE CANDIDATES BY GIVEN SRCSET ATTRIBUTES
            };

            // empty collection
            imageCandidates = null;

            // pass best match and candidates
            return object;

        };

        // throttle function to be used in directive
        function throttle(callback, delay) {
            var last, deferTimer;
            return function() {
                var now = +new Date();
                if (last && now < last + delay) {
                    clearTimeout(deferTimer);
                    deferTimer = setTimeout(function () {
                        console.info('SHOULD BE CALLING IN TIMEOUT');
                        last = now;
                        callback();
                    }, delay + last - now);
                } else {
                    console.info('in this one now');
                    last = now;
                    callback();
                }
            };
        }

        /**
         * PUBLIC API
         */
        return {
            get: getSrcset,        // RETURNS BEST IMAGE AND IMAGE CANDIDATES
            image: getBestImage,   // RETURNS BEST IMAGE WITH GIVEN CANDIDATES
            throttle: throttle     // RETURNS A THROTTLER FUNCTION
        };
    }]);
// This file was pulled from https://github.com/afklm/ng-lazy-image vesion 0.3.4
// The intention is to create a PR against that plugin once this is working with ajax loaded images

/* global angular */
angular.module('afkl.lazyImage')
    .directive('afklImageContainer', function () {
        'use strict';

        return {
            restrict: 'A',
            // We have to use controller instead of link here so that it will always run earlier than nested afklLazyImage directives
            controller: ['$scope', '$element', function ($scope, $element) {
                $element.data('afklImageContainer', $element);
            }]
        };
    })
    .directive('afklLazyImage', ['$rootScope', '$window', '$timeout', 'afklSrcSetService', '$parse', function ($rootScope, $window, $timeout, srcSetService, $parse) {
        'use strict';

        // Use srcSetService to find out our best available image
        var bestImage = function (images) {
            var image = srcSetService.get({ srcset: images });
            var sourceUrl;
            if (image) {
                sourceUrl = image.best.src;
            }
            return sourceUrl;
        };

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                var _concatImgAttrs = function (imgAttrs) {

                    var result = [];
                    var CLASSNAME = 'afkl-lazy-image';
                    var setClass = false;

                    if (!!options.imgAttrs) {
                        result = Array.prototype.map.call(imgAttrs, function (item) {
                            for (var key in item) {
                                if (item.hasOwnProperty(key)) {
                                    var value = item[key];
                                    if (key === 'class') {
                                        setClass = true;
                                        value = value + ' ' + CLASSNAME;
                                    }
                                    return String.prototype.concat.call(key, '="', value, '"');
                                }
                            }
                        });
                    }

                    if (!setClass) {
                        result.push('class="' + CLASSNAME + '"');
                    }

                    return result.join(' ');
                };

                // CONFIGURATION VARS
                var $container = element.inheritedData('afklImageContainer');
                if (!$container) {
                    $container = angular.element(attrs.afklLazyImageContainer || $window);
                }

                var loaded = false;
                var timeout;

                var images = attrs.afklLazyImage; // srcset attributes
                var options = attrs.afklLazyImageOptions ? $parse(attrs.afklLazyImageOptions)(scope) : {}; // options (background, offset)

                var img = null; // Angular element to image which will be placed
                var currentImage = null; // current image url
                var bgImage = null;
                var offset = options.offset ? options.offset : 50; // default offset
                var imgAttrs = _concatImgAttrs(options.imgAttrs); // all image attributes like class, title, onerror

                var LOADING = 'afkl-lazy-image-loading';

                attrs.afklLazyImageLoaded = false;

                var _containerScrollTop = function () {
                    // See if we can use jQuery, with extra check
                    if ($container.scrollTop) {
                        var scrollTopPosition = $container.scrollTop();
                        if (scrollTopPosition) {
                            return scrollTopPosition;
                        }
                    }

                    var c = $container[0];
                    if (c.pageYOffset !== undefined) {
                        return c.pageYOffset;
                    }
                    else if (c.scrollTop !== undefined) {
                        return c.scrollTop;
                    }

                    return document.documentElement.scrollTop || 0;
                };

                var _containerInnerHeight = function () {
                    if ($container.innerHeight) {
                        return $container.innerHeight();
                    }

                    var c = $container[0];
                    if (c.innerHeight !== undefined) {
                        return c.innerHeight;
                    } else if (c.clientHeight !== undefined) {
                        return c.clientHeight;
                    }

                    return document.documentElement.clientHeight || 0;
                };

                // Begin with offset and update on resize
                var _elementOffset = function () {
                    if (element.offset) {
                        return element.offset().top;
                    }
                    var box = element[0].getBoundingClientRect();
                    return box.top + _containerScrollTop() - document.documentElement.clientTop;
                };


                var _elementOffsetContainer = function () {
                    if (element.offset) {
                        return element.offset().top - $container.offset().top;
                    }
                    return element[0].getBoundingClientRect().top - $container[0].getBoundingClientRect().top;
                };

                // Update url of our image
                var _setImage = function () {
                    if (options.background) {
                        element[0].style.backgroundImage = 'url("' + currentImage + '")';
                    } else if (!!img) {
                        img[0].src = currentImage;
                    }
                };

                // Append image to DOM
                var _placeImage = function () {

                    loaded = true;
                    // What is my best image available
                    var imgUrl = bestImage(images);
                    //console.info('LOADING IMAGE!!!!!1')
                    if (imgUrl) {
                        // we have to make an image if background is false (default)
                        if (!options.background) {
                            if (!img) {
                                element.addClass(LOADING);
                                img = angular.element('<img ' + imgAttrs + ' />');
                                img.one('load', _loaded);
                                img.one('error', _error);
                                // remove loading class when image is acually loaded
                                element.append(img);
                            }
                        } else if (!bgImage) {
                            element.addClass(LOADING);

                            bgImage = new Image();
                            bgImage.addEventListener('load', _loaded);
                            bgImage.addEventListener('error', _error);
                            bgImage.src = imgUrl;
                        }

                        // set correct src/url
                        _checkIfNewImage();
                    }

                    // Element is added to dom, no need to listen to scroll anymore
                    $container.off('scroll', _onViewChange);

                };

                // Check on resize if actually a new image is best fit, if so then apply it
                var _checkIfNewImage = function () {
                    if (loaded) {
                        var newImage = bestImage(images);

                        if (newImage !== currentImage) {
                            // update current url
                            currentImage = newImage;

                            // TODO: loading state...

                            // update image url
                            _setImage();
                        }
                    }
                };

                // First update our begin offset
                _checkIfNewImage();

                var _loaded = function () {
                    attrs.$set('afklLazyImageLoaded', 'done');

                    element.removeClass(LOADING);

                    if (options.background) {
                        bgImage = null;
                    }
                };

                var _error = function () {
                    attrs.$set('afklLazyImageLoaded', 'fail');

                    if (options.background) {
                        bgImage = null;
                    }
                };

                // Check if the container is in view for the first time. Utilized by the scroll and resize events.
                var _onViewChange = function () {
                    // only do stuff when not set already
                    if (!loaded) {

                        // Config vars
                        var remaining, shouldLoad, windowBottom;

                        var height = _containerInnerHeight();
                        var scroll = _containerScrollTop();

                        var elOffset = $container[0] === $window ? _elementOffset() : _elementOffsetContainer();
                        windowBottom = $container[0] === $window ? height + scroll : height;

                        remaining = elOffset - windowBottom;
                        // Is our top of our image container in bottom of our viewport?
                        shouldLoad = remaining <= offset;

                        // Append image first time when it comes into our view, after that only resizing can have influence
                        if (shouldLoad) {
                            _placeImage();
                        }
                    }
                };

                var _onViewChangeThrottled = function () {
                    srcSetService.throttle(_onViewChange, 300);
                };

                // EVENT: RESIZE THROTTLED
                var _onResize = function () {
                    $timeout.cancel(timeout);
                    timeout = $timeout(function () {
                        _checkIfNewImage();
                        _onViewChange();
                    }, 300);
                };

                // Remove events for total destroy
                var _eventsOff = function () {

                    $timeout.cancel(timeout);

                    angular.element($window).off('resize', _onResize);
                    angular.element($window).off('scroll', _onViewChangeThrottled);

                    if ($container[0] !== $window) {
                        $container.off('resize', _onResize);
                        $container.off('scroll', _onViewChangeThrottled);
                    }

                    // remove image being placed
                    if (img) {
                        img.remove();
                    }

                    img = timeout = currentImage = undefined;
                };

                // set events for scrolling and resizing on window
                // even if container is not window it is important
                // to cover two cases:
                //  - when container size is bigger than window's size
                //  - when container's side is out of initial window border
                angular.element($window).on('resize', _onResize);
                angular.element($window).on('scroll', _onViewChangeThrottled); // TODO: This isn't getting called.

                // if container is not window, set events for container as well
                if ($container[0] !== $window) {
                    $container.on('resize', _onResize);
                    $container.on('scroll', _onViewChangeThrottled);
                }

                // events for image change
                attrs.$observe('afklLazyImage', function () {
                    images = attrs.afklLazyImage;
                    if (loaded) {
                        _placeImage();
                    }
                });

                // Image should be directly placed
                if (options.nolazy) {
                    _placeImage();
                }


                scope.$on('afkl.lazyImage.destroyed', _onResize);

                // Remove all events when destroy takes place
                scope.$on('$destroy', function () {
                    // tell our other kids, i got removed
                    $rootScope.$broadcast('afkl.lazyImage.destroyed');
                    // remove our events and image
                    return _eventsOff();
                });

                return _onViewChange();
            }
        };
    }]);
angular.module('heremaps').directive('heremaps', [
    '$timeout',
    '$window',
    '$rootScope',
    '$filter',
    'HereMapsConfig',
    'HereMapsAPIService',
    'HereMapsUtilsService',
    'HereMapsMarkerService',
    'HereMapsRoutesService',
    'HereMapsCONSTS',
    'HereMapsEventsFactory',
    'HereMapsUiFactory',
    'SYSTEM_ENUMS', function(
    $timeout,
    $window,
    $rootScope,
    $filter,
    HereMapsConfig,
    HereMapsAPIService,
    HereMapsUtilsService,
    HereMapsMarkerService,
    HereMapsRoutesService,
    HereMapsCONSTS,
    HereMapsEventsFactory,
    HereMapsUiFactory,
    SYSTEM_ENUMS) {

    HereMapsDirectiveCtrl.$inject = ["$scope", "$element", "$attrs", "HERE_MAPS_CONFIG"];
    return {
        restrict: 'EA',
        template: "<div id=\"here_map\" ng-style=\"{'width': mapWidth, 'height': mapHeight}\"></div>",
        replace: true,
        scope: {
            opts: '&options',
            places: '&',
            onMapReady: "&mapReady",
            onUiReady: "&uiReady",
            events: '&'
        },
        controller: HereMapsDirectiveCtrl
    };

    function HereMapsDirectiveCtrl($scope, $element, $attrs, HERE_MAPS_CONFIG) {
        var CONTROL_NAMES = HereMapsCONSTS.CONTROLS.NAMES,
            places = $scope.places(),
            opts = $scope.opts(),
            circle = null,
            listeners = $scope.events(),
            _currentMapStyle = null,
            _initialLoad = true;

        var options = angular.extend({}, HereMapsCONSTS.DEFAULT_MAP_OPTIONS, opts),
            position = HereMapsUtilsService.isValidCoords(options.coords) ?
                options.coords : HereMapsCONSTS.DEFAULT_MAP_OPTIONS.coords;

        var heremaps = { id: HereMapsUtilsService.generateId() },
            mapReady = $scope.onMapReady(),
            uiReady = $scope.onUiReady(),
            _onResizeMap = null,
            _hereMapsUi;

        const engineType = H.Map.EngineType['HARP'];        

        $timeout(function () {
            return _setMapSize();
        }).then(function () {
            HereMapsAPIService.loadApi().then(_apiReady);
        });

        options.resize && addOnResizeListener();

        $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', _onResizeMap);
        });

        function addOnResizeListener() {
            _onResizeMap = HereMapsUtilsService.throttle(_resizeHandler, HereMapsCONSTS.UPDATE_MAP_RESIZE_TIMEOUT);
            $window.addEventListener('resize', _onResizeMap);
        }

        function _apiReady() {
            _setupMapPlatform();
            _setupMap();
        }

        function _setupMapPlatform() {
            if (!HereMapsConfig.apiKey)
                throw new Error('apiKey was not provided. Please specify it in the HereMapsConfig');

            heremaps.platform = new H.service.Platform(HereMapsConfig);
            heremaps.layers = heremaps.platform.createDefaultLayers({ engineType });
        }

        function _getLocation(enableHighAccuracy, maximumAge) {
            var _enableHighAccuracy = !!enableHighAccuracy,
                _maximumAge = maximumAge || 0;

            return HereMapsAPIService.getPosition({
                enableHighAccuracy: _enableHighAccuracy,
                maximumAge: _maximumAge
            });
        }

        function _locationFailure() {
            console.error('Can not get a geo position');
        }

        function _setupMap() {
            _initMap(function () {
                HereMapsAPIService.loadModules($attrs.$attr, {
                    "controls": _uiModuleReady,
                    "events": _eventsModuleReady
                });
            });
        }

        async function _initMap(cb) {
            // Obtain the default map types from the platform object:
            const defaultLayers = heremaps.platform.createDefaultLayers({ engineType });

            var map = heremaps.map = new H.Map($element[0], defaultLayers.raster.normal.map, {
                engineType,
                zoom: HereMapsUtilsService.isValidCoords(position) ? options.zoom : options.maxZoom,
                center: new H.geo.Point(position.latitude, position.longitude),
                padding: {top: 50, left: 50, bottom: 50, right: 50}
            });

            HereMapsMarkerService.addMarkersToMap(map, places, true);

            mapReady && mapReady(MapProxy());

            cb && cb();
        }

        function _uiModuleReady() {
            if($attrs.controls) {
                _hereMapsUi = HereMapsUiFactory.start({
                    platform: heremaps,
                    alignment: $attrs.controls
                });

                if (uiReady) {
                    uiReady(_hereMapsUi);
                }
            }
        }

        function _eventsModuleReady() {
            HereMapsEventsFactory.start({
                platform: heremaps,
                listeners: listeners,
                options: options,
                injector: _moduleInjector
            });
        }

        function _moduleInjector() {
            return function (id) {
                return heremaps[id];
            };
        }

        function _resizeHandler(height, width) {
            _setMapSize.apply(null, arguments);

            heremaps.map.getViewPort().resize();
        }

        function _setMapSize(height, width) {
            var mapHeight = height || $element[0].parentNode.offsetHeight || options.height,
                mapWidth = width || $element[0].parentNode.offsetWidth || options.width;

            $scope.mapHeight = mapHeight + 'px';
            $scope.mapWidth = mapWidth + 'px';

            HereMapsUtilsService.runScopeDigestIfNeed($scope);
        }

        function _setCustomMapStyles(map, config) {
            if (_currentMapStyle !== config) {
                const defaultLayers = heremaps.platform.createDefaultLayers({ engineType });
                if (config == HERE_MAPS_CONFIG.satelliteViewSettings)
                {
                    map.setBaseLayer(defaultLayers.hybrid.liteday.raster);
                }
                else
                {                    
                    map.setBaseLayer(defaultLayers.raster.normal.map);
                }

                _currentMapStyle = config;
            }
        }

        function MapProxy() {
            return {
                refresh: function () {
                    var port = heremaps.map.getViewPort();

                    this.setMapSizes(port.height, port.width);
                },
                setMapSizes: function (height, width) {
                    _resizeHandler.apply(null, arguments);
                },
                setMapStyle: function(style) {
                    _setCustomMapStyles(heremaps.map, style);
                },
                getPlatform: function () {
                    return heremaps;
                },
                addCircle: function (centerLat, centerLng, radius, style) {
                    circle = new H.map.Circle(
                        {
                            lat: centerLat,
                            lng: centerLng
                        },
                        radius,       // radius in meters
                        {
                            style: style
                        }
                    );
                    
                    var circleData = circle.getData() || {};
                    circleData.objectType = SYSTEM_ENUMS.hereObjectType.circle;
                    circle.setData(circleData);
                    heremaps.map.addObject(circle);
                },
                removeCircle: function () {
                    heremaps.map.removeObject(circle);
                },
                calculateRoute: function (driveType, direction) {
                    return HereMapsRoutesService.calculateRoute(heremaps, {
                        driveType: driveType,
                        direction: direction
                    });
                },
                addRouteToMap: function (routeData, clean, metaData) {
                    HereMapsRoutesService.addRouteToMap(heremaps.map, routeData, clean, metaData);
                },
                addObject: function (object) {
                    return heremaps.map.addObject(object);
                },
                removeObject: function (object) {
                    return heremaps.map.removeObject(object);
                },
                removeObjects: function (object) {
                    return heremaps.map.removeObjects(object);
                },
                getObjects: function (object) {
                    return heremaps.map.getObjects(object);
                },
                removeRoutesFromMap: function(routeType) {
                    var mapObjects = this.getPlatform().map.getObjects(),
                        routesToRemove = _.filter(mapObjects, function(mapObject) {
                        if (mapObject.getData) {
                            var data = mapObject.getData();
                            return data && data.routeType === routeType;
                        }
                    });

                    if (routesToRemove)
                        HereMapsRoutesService.removeRoutesFromMap(heremaps.map, routesToRemove);
                },
                setZoom: function (zoom, step) {
                    HereMapsUtilsService.zoom(heremaps.map, zoom || 10, step);
                },
                getZoom: function () {
                    return heremaps.map.getZoom();
                },
                getCenter: function () {
                    return heremaps.map.getCenter();
                },
                getViewBounds: function () {
                    var vm = heremaps.map.getViewModel();
                    return vm.getLookAtData();
                },
                getViewPort: function () {
                    return heremaps.map.getViewPort();
                },
                setViewBounds: function (boundingRect, opt_animate) {
                    HereMapsMarkerService.setViewBounds(heremaps.map, boundingRect, opt_animate);
                },
                getBoundsRectFromMultiplePoints: function (topLeft, bottomRight) {
                    return HereMapsUtilsService.getBoundsRectFromMultiplePoints.apply(null, arguments);
                },
                getBoundsRectFromPoints: function (topLeft, bottomRight) {
                    return HereMapsUtilsService.getBoundsRectFromPoints.apply(null, arguments);
                },
                setCenter: function (coords, opt_animate) {
                    if (!coords) {
                        return console.error('coords are not specified!');
                    }

                    heremaps.map.setCenter(coords, opt_animate);
                },
                cleanRoutes: function () {
                    HereMapsRoutesService.cleanRoutes(heremaps.map);
                },
                
                /**
                 * @param {Boolean} enableHighAccuracy enable high accuracy
                 * @param {Number} maximumAge - the maximum age in milliseconds of a possible cached position that is acceptable to return. If set to 0, it means that the device cannot use a cached position and must attempt to retrieve the real current position
                 * @return {Promise} promise containing the user location if found
                 */
                getUserLocation: function (enableHighAccuracy, maximumAge) {
                    return _getLocation.apply(null, arguments).then(function (position) {
                        var coords = position.coords;

                        return {
                            lat: coords.latitude,
                            lng: coords.longitude
                        };
                    });
                },
                geocodeAddress: function (address) {
                    return HereMapsAPIService.geocodeAddress(heremaps.platform, {
                        searchtext: address && address.searchtext,
                        country: address && address.country,
                        city: address && address.city,
                        street: address && address.street,
                        housenumber: address && address.housenumber
                    });
                },
                updateMarkers: function (places, refreshViewbounds) {
                    HereMapsMarkerService.updateMarkers(heremaps.map, places, refreshViewbounds, heremaps);
                },
                getMapFactory: function (){
                    return HereMapsUtilsService.getMapFactory();
                },
                getMap: function() {
                    return heremaps.map;
                },
                fitAll: function() {
                    var mapContainer = heremaps.map,
                        markerBounds = mapContainer.markersGroup ? mapContainer.markersGroup.getBoundingBox() : null,
                        routeBounds = mapContainer.routesGroup ? mapContainer.routesGroup.getBoundingBox() : null,
                        mapObjects = this.getPlatform().map.getObjects(),
                        circles = _.filter(mapObjects, function(mapObject) {
                        if (mapObject.getData) {
                            var data = mapObject.getData();
                            return data && data.objectType === SYSTEM_ENUMS.hereObjectType.circle;
                        }
                    });

                    var fullBounds = [];

                    if (markerBounds) {
                        fullBounds.push(markerBounds.getTopLeft());
                        fullBounds.push(markerBounds.getBottomRight());
                    }

                    if (routeBounds) {
                        fullBounds.push(routeBounds.getTopLeft());
                        fullBounds.push(routeBounds.getBottomRight());
                    }

                    if (circles.length) {
                        var circleBounds = circles[0].getBoundingBox();
                        fullBounds.push(circleBounds.getTopLeft());
                        fullBounds.push(circleBounds.getBottomRight());
                    }

                    if (fullBounds.length) {
                        var allObjectRect = HereMapsUtilsService.getBoundsRectFromMultiplePoints(fullBounds),
                            hereActions = this,
                            timeoutWait = _initialLoad ? 500 : 0;

                        // There is a race condition when the map is initially loading that will prevent the bounds from being
                        //  drawn correctly without a timeout.  The renderEngine does have an event called 'render', but even then
                        //  it seems to fire earlier than we need it to. So a timeout is added here to ensure the route is drawn
                        //  correctly when the map is initially loading.
                        $timeout(function() {
                            hereActions.setViewBounds(allObjectRect, true);
                            _initialLoad = false;
                        }, timeoutWait);

                        var markers = this.getMarkers();

                        // If there is only one marker, the zoom level will be too tight, so we
                        //  zoom out slightly in this case.
                        if (markers && markers.length === 1) {
                            $timeout(function() {
                                var currentZoom = hereActions.getZoom();
                                hereActions.setZoom(currentZoom - 3);
                            }, 500);
                        } else {
                            this.zoomOutIfMarkersOnEdge(markers);
                        }
                    }
                },
                getMarkers: function() {
                    var mapObjects = heremaps.map.getObjects(true),
                        markers = _.filter(mapObjects, function(mapObject) {
                        if (mapObject.getData) {
                            var data = mapObject.getData() || mapObject.data;

                            return data && data.objectType === SYSTEM_ENUMS.hereObjectType.marker;
                        }
                    });

                    return markers;
                },
                getDriverMarker: function() {
                    var mapObjects = heremaps.map.getObjects(true);

                    return _.find(mapObjects, function(mapObject) {
                        if (mapObject.getData) {
                            var data = mapObject.getData() || mapObject.data;

                            return data && data.objectType === SYSTEM_ENUMS.hereObjectType.driver;
                        }
                    });
                },
                zoomOutIfMarkersOnEdge: function(mapMarkers) {
                    var hereActions = this;
                    $timeout(function() {
                        var distanceThreshold = 60,
                            markers = mapMarkers || this.getMarkers(),
                            mapRect = hereActions.getViewPort().element.getBoundingClientRect(),
                            zoomToSet = hereActions.getZoom(),
                            zoomWasSet = false;
                            
                            

                        _.forEach(markers, function(marker) {
                            var markerData = marker.getData(),
                                markerEl = angular.element('#' + markerData.elementId),
                                markerOffset = markerEl && markerEl.offset();

                            if (mapRect && markerOffset) {
                                var topDiff = Math.abs(mapRect.top - markerOffset.top),
                                    bottomDiff = Math.abs(mapRect.bottom - markerOffset.top),
                                    leftDiff = Math.abs(mapRect.left - markerOffset.left),
                                    rightDiff = Math.abs(mapRect.right - markerOffset.left);

                                if (topDiff <= distanceThreshold || leftDiff <= distanceThreshold || bottomDiff <= distanceThreshold || rightDiff <= distanceThreshold) {
                                    
                                    zoomWasSet = true;
                                    zoomToSet = zoomToSet - 0.4;
                                    if (zoomToSet > 0) {
                                        hereActions.setZoom(zoomToSet);
                                    }
                                    return false;
                                }
                            }
                            
                        });

                        if (!zoomWasSet) {
                            hereActions.setZoom(zoomToSet);
                        }
                    }, 750);
                },
                showNearbyDriversButton: function(callback) {
                    _hereMapsUi.showNearbyDriversButton(callback);
                }
            };
        }
    }
}]);

(function () {
    'use strict';

    tripService.$inject = ["$q", "rcApi", "MOMENTJS_FORMAT", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .factory('tripService', tripService);

    function tripService($q, rcApi, MOMENTJS_FORMAT, SYSTEM_ENUMS) {

        let TRIP_BASEPATH = 'trips/';
        let  _availableTripTypes = null;
        let    logisticTypes = {
                oneWay: 1,
                roundTrip: 2
            };

        return {
            tripWorkFlowHasLoaner: tripWorkFlowHasLoaner,
            getSystemTripTypes: getSystemTripTypes,
            getAvailableTripTypes: getAvailableTripTypes,
            getTrips: getTrips,
            getTrip: getTrip,
            getTripChildren: getTripChildren,
            updateIsTestTrip: updateIsTestTrip,
            getCancellationReasons: getCancellationReasons,
            getDriverLocation: getDriverLocation,
            getDriverHistory: getDriverHistory,
            getZendriveHistory: getZendriveHistory,
            getSurveys: getSurveys,
            getActiveDrivers: getActiveDrivers,
            getMobileTechnicians: getMobileTechnicians,
            getDriverPhoto: getDriverPhoto,
            assignDriver: assignDriver,
            unassignDriver: unassignDriver,
            getPhotos: getPhotos,
            getDriverTaskResponses: getDriverTaskResponses,
            getWorkflow: getWorkflow,
            submitHelpTicket: submitHelpTicket,
            getTripNotes: getTripNotes,
            getTripNoteTypes: getTripNoteTypes,
            addTripNote: addTripNote,
            deleteTripNote: deleteTripNote,
            getUsers: getUsers,
            getDriverDetails: getDriverDetails,
            removeFavoriteDriver: removeFavoriteDriver,
            addFavoriteDriver: addFavoriteDriver,
            removeExcludedDriver: removeExcludedDriver,
            addExcludedDriver: addExcludedDriver,
            getStatusText: getStatusText,
            utcToLocalJSDate: utcToLocalJSDate,
            getTripMessages: getTripMessages,
            sendTripMessage: sendTripMessage,
            getTripWorkFlows: getTripWorkFlows,
            updateCanAccessEarly: updateCanAccessEarly,
            getInvoices: getInvoices,
            hasMessaging: hasMessaging,
            addBillingTime: addBillingTime,
            calculateBillingTime: calculateBillingTime,
            saveCharge: saveCharge,
            deleteCharge: deleteCharge,
            completeTrip: completeTrip,
            getTripVehicles: getTripVehicles,
            getTripPhotoSasDownloadUrl: getTripPhotoSasDownloadUrl,
            formatDriverDropDown: formatDriverDropDown,
            saveDriverIncentive: saveDriverIncentive,
            getTripLog: getTripLog,
            getNearbyDrivers: getNearbyDrivers,
            removeItemFromDispatchModes: removeItemFromDispatchModes,
            detachLoanerReservation: detachLoanerReservation
        };

        function tripWorkFlowHasLoaner(record) {
            return record.workFlowLogisticTypeId === logisticTypes.roundTrip && record.hasLoaner;
        }

        function getSystemTripTypes() {
          
            return rcApi.get(TRIP_BASEPATH + 'systemtriptypes', null, null, null, null, true);
        }

        function getAvailableTripTypes() {
            if (_availableTripTypes) {
                return new Promise((resolve, reject) => {
                    resolve(_availableTripTypes);
                });
            } else {
                return rcApi.get(TRIP_BASEPATH + 'availabletriptypes').then((tripTypes) => {
                    _availableTripTypes = tripTypes;

                    return tripTypes;
                });
            }
        }

        function getTrips(searchFilter) {
            return rcApi.post(TRIP_BASEPATH + 'search', searchFilter || {});
        }

        function getTripPhotoSasDownloadUrl(tripId, imagepath, mediaType) {
            return rcApi.get(TRIP_BASEPATH + 'tripPhotoUrl', {
                tripId: tripId,
                imagePath: imagepath,
                mediaType: mediaType
            });
        }

        function hasMessaging(dealerId) {
            return rcApi.post(TRIP_BASEPATH + 'hasmessaging?dealerId=' + dealerId);
        }

        function detachLoanerReservation(tripId, dealerId) {
            return rcApi.post(TRIP_BASEPATH + tripId + '/detachLoanerReservation?dealerId=' + dealerId);
        }

        function getTrip(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId);
        }

        function getTripChildren(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/children');
        }

        function getCancellationReasons(dealerId, dealerTripTypeId) {
            return rcApi.get(TRIP_BASEPATH + 'cancellationReasons?dealerId=' + dealerId + '&dealerTripTypeId=' + dealerTripTypeId);
        }

        function getDriverLocation(tripId, username) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/' + username + '/location');
        }

        function getDriverHistory(tripId, tripState, snapToRoads) {
            let url = TRIP_BASEPATH + tripId + '/history?snapToRoads=' + !!snapToRoads;

            if (tripState) {
                url += '&tripState=' + tripState;
            }

            return rcApi.get(url);
        }

        function getZendriveHistory(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/zenDrive');
        }

        function getActiveDrivers(dealerId, fromTimeUtc, toTimeUtc, driverId, tripId, systemTripTypeId) {
            let driverIdParameter = driverId ? '&driverId=' + driverId : '';
            let tripIdParameter = tripId ? '&currentTripId=' + tripId : '';
            let tripTypeIdParameter = systemTripTypeId ? '&systemTripTypeId=' + systemTripTypeId : '';

            return rcApi.get(TRIP_BASEPATH + 'activeDrivers?dealerId=' + dealerId + '&fromTime=' + fromTimeUtc + '&toTime=' + toTimeUtc + driverIdParameter + tripIdParameter + tripTypeIdParameter);
        }

        function getMobileTechnicians(dealerId) {
            return rcApi.get(TRIP_BASEPATH + 'mobileTechnicians?dealerId=' + dealerId);
        }

        function getDriverPhoto(driverId) {
            return rcApi.get(TRIP_BASEPATH + 'driverPhoto', {driverId: driverId});
        }

        function updateIsTestTrip(tripId, isTestTrip) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/updateIsTestTrip?isTestTrip=' + isTestTrip);
        }

        function assignDriver(tripId, driverUsername) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/assignDriver?driverId=' + driverUsername);
        }

        function unassignDriver(tripId, driverUsername) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/unassignDriver?driverId=' + driverUsername);
        }

        function updateCanAccessEarly(tripId, canAccessEarly) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/updateCanAccessEarly?canAccessEarly=' + canAccessEarly);
        }

        function getDriverTaskResponses(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/tasks');
        }

        function getPhotos(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/photos');
        }

        function getSurveys(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/surveys');
        }

        function getWorkflow(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/workflow');
        }

        function submitHelpTicket(tripId, issueType, issueDescription) {
            let model = {
                Type: issueType,
                Issue: issueDescription
            };

            return rcApi.post(TRIP_BASEPATH + tripId + '/helpTicket', model);
        }

        function getTripNotes(tripId, previousNoteTime) {
            let previousTimeParam = previousNoteTime ? '?previousNoteTime=' + previousNoteTime : '';

            return rcApi.get(TRIP_BASEPATH + tripId + '/notes' + previousTimeParam)
                .then((result) => {
                    return result;
                })
                .catch((error) => {
                    return null;
                });
        }

        function getTripNoteTypes() {
           
            return rcApi.get(TRIP_BASEPATH + 'notetypes', null, null, null, null, true);
        }

        function addTripNote(tripId, note, noteType) {
            let model = {
                note: note,
                noteTypeId: noteType
            };

            return rcApi.post(TRIP_BASEPATH + tripId + '/notes', model);
        }

        function deleteTripNote(tripId, noteId) {
            return rcApi.remove(TRIP_BASEPATH + tripId + '/notes/' + noteId);
        }

        function getDriverDetails(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/driver');
        }

        function addFavoriteDriver(tripId, driverId) {
            return rcApi.post(TRIP_BASEPATH + tripId + '/driver/favorite', {value: driverId});
        }

        function removeFavoriteDriver(tripId, driverId) {
            return rcApi.remove(TRIP_BASEPATH + tripId + '/driver/favorite', {value: driverId});
        }

        function addExcludedDriver(tripId, driverId) {
            return rcApi.post(TRIP_BASEPATH + tripId + '/driver/exclude', {value: driverId});
        }

        function removeExcludedDriver(tripId, driverId) {
            return rcApi.remove(TRIP_BASEPATH + tripId + '/driver/exclude', {value: driverId});
        }

        function getUsers(term, cancelPromise) {
            return rcApi.get(TRIP_BASEPATH + 'users?searchTerm=' + term, null, cancelPromise);
        }

        function getStatusText(status, verbose) {
            let levelText = '';

            switch (status) {
                case SYSTEM_ENUMS.healthStatus.ok:
                case SYSTEM_ENUMS.healthStatus.warning:
                    levelText = 'Ok';
                    break;
                case SYSTEM_ENUMS.healthStatus.danger:
                    levelText = verbose ? 'Driver expected late' : 'Critical';
                    break;
                case SYSTEM_ENUMS.healthStatus.noDriverAccepted:
                    levelText = verbose ? 'No driver selected' : 'Critical';
                    break;
                case SYSTEM_ENUMS.healthStatus.driverNoLocation:
                    levelText = verbose ? 'Driver status unavailable' : 'Critical';
                    break;
                case SYSTEM_ENUMS.healthStatus.similarTrip:
                    levelText = verbose ? 'Similar trip booked' : 'Trip Exception Detected';
                    break;
                case SYSTEM_ENUMS.healthStatus.differentDropoff:
                    levelText = verbose ? 'Dropoff was different than booked' : 'Trip Exception Detected';
                    break;
                case SYSTEM_ENUMS.healthStatus.costDeviation:
                    levelText = verbose ? 'Cost greater than expected' : 'Trip Exception Detected';
                    break;
                case SYSTEM_ENUMS.healthStatus.driverDidntWait:
                    levelText = verbose ? 'Driver did not wait' : 'Trip Exception Detected';
                    break;
                default:
                    levelText = verbose ? 'Status Unknown' : '';
                    break;
            }

            return levelText;
        }

        function utcToLocalJSDate(momentUtcTime) {
            return moment.utc(momentUtcTime + 'Z', MOMENTJS_FORMAT).local().toDate();
        }

        function getTripMessages(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/messages');
        }

        function getTripVehicles(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/vehicles');
        }

        function sendTripMessage(tripId, message, recipientType) {
            let model = {
                message: message,
                recipientType: recipientType
            };

            return rcApi.post(TRIP_BASEPATH + tripId + '/messages/', model);
        }

        function getTripWorkFlows() {
           
            return rcApi.get(TRIP_BASEPATH + 'tripworkflows', null, null, null, null, true);
        }

        function getInvoices(tripIds) {
            let tripIdParams = '';

            _.forEach(tripIds, (tripId) => {
                tripIdParams += 'tripIds=' + tripId + '&';
            });

            return rcApi.get(TRIP_BASEPATH + 'invoices?' + tripIdParams.slice(0, -1));
        }

        function calculateBillingTime(tripId, startTime, endTime) {
            let billingTime = {
                startTime: startTime,
                endTime: endTime
            };

            return rcApi.post(TRIP_BASEPATH + tripId + '/calculatecharge', billingTime);
        }

        function addBillingTime(tripId, startTime, endTime, note) {
            let billingTime = {
                startTime: startTime,
                endTime: endTime,
                note: note
            };

            return rcApi.post(TRIP_BASEPATH + tripId + '/billingtimes', billingTime);
        }

        function saveCharge(tripId, charge) {
            return rcApi.post(TRIP_BASEPATH + tripId + '/charges', charge);
        }

        function deleteCharge(tripId, chargeId, comment) {
            return rcApi.remove(TRIP_BASEPATH + tripId + '/charges', {chargeId: chargeId, comment: comment});
        }

        function getTripLog(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/log');
        }

        function getNearbyDrivers(tripId) {
            return rcApi.get(TRIP_BASEPATH + tripId + '/nearbydrivers');
        }

        function completeTrip(tripId, startTime, endTime, note) {
            let billingTime = {
                startTime: startTime,
                endTime: endTime,
                note: note
            };

            return rcApi.post(TRIP_BASEPATH + tripId + '/complete', billingTime);
        }

        function formatDriverDropDown(driver, tripDriver) {
            if (driver.id == -999) {
                return driver.name;
            }

            let formattedResult = '';

            // If driver isn't internal, add additional details
            if (driver.company && driver.company.driverCompanyType !== SYSTEM_ENUMS.driverCompanyType.internal) {
                // Company name DNS/CIT/etc...
                formattedResult = driver.company.companyNameShort;

                if (driver.isDedicated) {  // isDedicated = true
                    formattedResult += ' DED';
                } else if (driver.isPreferred) { // isDedicated = false, isPreferred = true
                    formattedResult += ' FAV';
                } else {
                    formattedResult += ' NET'; // isDedicated = false, isPreferred = false
                }

                formattedResult = '(' + formattedResult + ')';
            }

            if (driver.isAvailable == false && tripDriver != driver) {
                formattedResult += '-Unavailable';
            }

            formattedResult = formattedResult.length > 0 ? driver.name + ' ' + formattedResult : driver.name;

            if (driver.isDnsVetted) {
                formattedResult += ' (VETTED)';
            }

            return formattedResult;
        }

        function saveDriverIncentive (tripId, incentive, redispatch) {
            return rcApi.post(TRIP_BASEPATH + tripId + '/driverincentive', {incentiveAmount: incentive.amount, reDispatch: redispatch, incentiveType: incentive.incentiveType});
        }

        function removeItemFromDispatchModes(modes, modeToRemove) {
            let i;
            let length = modes.length;

            for (i = 0; i < length; i++) {
                if (modes[i].value === modeToRemove) {
                    modes.splice(i, 1);
                    break;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    rideProviderService.$inject = ["rcApi", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .factory('rideProviderService', rideProviderService);

    function rideProviderService(rcApi, SYSTEM_ENUMS) {
            let TRIP_BASEPATH = 'rideprovider/book/';
            let RIDE_BASEPATH = 'rideprovider/ride/';
            let rideCostTokenTime = null;
            let tripWorkflowTypes = SYSTEM_ENUMS.tripWorkflowTypes;

        return {
            setSandboxState: setSandboxState,
            requestRide: requestRide,
            cancelRide: cancelRide,
            getTripRoute: getTripRoute,
            costTokenExpired: costTokenExpired,
            getRideTypes: getRideTypes,
            getCredit: getCredit,
            sendCredit: sendCredit,
            sendCreditBatch: sendCreditBatch,
            cancelCredit: cancelCredit,
            searchCredits: searchCredits,
            updateCredit: updateCredit,
            applyRefunds: applyRefunds,
            getEstimates: getEstimates,
            uploadBatch: uploadBatch,
            getCampaign: getCampaign,
            updateCampaign: updateCampaign,
            revokeCampaign: revokeCampaign,
            addCampaignParticipant: addCampaignParticipant,
            getCampaignErrors: getCampaignErrors,
            buildStop: buildStop,
            buildHeaders: buildHeaders,
            callDriver: callDriver
        };

        function setSandboxState(rideId, step, isPartsOnDemand, rideProviderType) {
            return rcApi.get(RIDE_BASEPATH + rideId + '/status?desiredStatus=' + step, null, null, buildHeaders(true, false, false, isPartsOnDemand, rideProviderType));
        }

        function costTokenExpired() {
            return rideCostTokenTime && moment().diff(rideCostTokenTime, 'seconds') > 60;
        }

        function getRideTypes() {
            return rcApi.get(RIDE_BASEPATH + 'ridetypes');
        }

        function getEstimates(dealerId, tripTypeInstanceId, pickup, dropoff, requiresDeliveryClient, isTest) {
            // Ensure the all the parameters are valid
            pickup.streetAddress = pickup.streetAddress || pickup.address || pickup.name;
            dropoff.streetAddress = dropoff.streetAddress || dropoff.address || dropoff.name;

            return rcApi.post(TRIP_BASEPATH + dealerId + '/estimates',
            {
                pickup: pickup,
                dropoff: dropoff,
                triptypeinstanceId: tripTypeInstanceId
            }, buildHeaders(isTest, true, false, requiresDeliveryClient))
            .then((response) => {
                let hasCostToken = _.some(response.estimates, (rideEstimate) => {
                    return rideEstimate.costToken != null;
                });

                rideCostTokenTime = hasCostToken ? moment() : null;

                return response;
            });
        }

        function requestRide(dealerId,
            pickupLat,
            pickupLng,
            pickupStreetAddress,
            pickupCity,
            pickupState,
            pickupZip,
            pickupCountry,
            dropoffLat,
            dropoffLng,
            dropoffStreetAddress,
            dropoffCity,
            dropoffState,
            dropoffZip,
            dropoffCountry,
            rideType,
            rideTypeId,
            serviceOrderId,
            serviceAdvisorId,
            tripId,
            isTestTrip,
            pickupTime,
            estimatedDistanceMiles,
            estimatedDuration,
            roNum,
            customerPhone,
            customerEmail,
            customerFirstName,
            customerLastName,
            customerNotes,
            dealerTripTypeId,
            costToken,
            estimatedCost,
            presentedCost,
            maxCost,
            systemTripType,
            startsAtDealer,
            monthlyChargesSnapshot,
            companyName,
            workFlowId,
            referenceNumber,
            overrideServiceAdvisorFirstName,
            overrideServiceAdvisorLastName,
            overrideServiceAdvisorMobile,
            rideProviderType,
            dropoffNote,
            lyftSandboxFlowType,
            apptId,
            primetimePercentage,
            sandboxRunId,
            packageSize) {
                let pickup = buildStop(pickupLat, pickupLng, pickupStreetAddress, pickupCity, pickupState, pickupZip, pickupCountry, true, systemTripType, startsAtDealer, workFlowId);
                let dropoff = buildStop(dropoffLat, dropoffLng, dropoffStreetAddress, dropoffCity, dropoffState, dropoffZip, dropoffCountry, false, systemTripType, startsAtDealer, workFlowId);

            return rcApi.post(TRIP_BASEPATH + dealerId, {
                systemTripType: systemTripType,
                pickup: pickup,
                dropoff: dropoff,
                rideType: rideType,
                rideTypeId: rideTypeId,
                serviceOrderId: serviceOrderId,
                tripId: tripId,
                isTestTrip: isTestTrip,
                pickupTime: pickupTime,
                estimatedDistance: estimatedDistanceMiles * 1609.34, // Convert to meters for consistency
                estimatedDuration: estimatedDuration,
                roNum: roNum,
                phone: customerPhone,
                email: customerEmail,
                firstName: customerFirstName,
                lastName: customerLastName,
                companyName: companyName,
                customerNotes: customerNotes,
                dealerTripTypeId: dealerTripTypeId,
                serviceAdvisorId: serviceAdvisorId,
                costToken: costToken,
                estimatedCost: estimatedCost,
                presentedCost: presentedCost,
                maxCost: maxCost,
                startsAtDealer: startsAtDealer,
                monthlyChargesSnapshot: monthlyChargesSnapshot,
                workFlowId: workFlowId,
                referenceNumber: referenceNumber,
                overrideServiceAdvisorFirstName: overrideServiceAdvisorFirstName,
                overrideServiceAdvisorLastName: overrideServiceAdvisorLastName,
                overrideServiceAdvisorMobile: overrideServiceAdvisorMobile,
                dropoffNote: dropoffNote,
                sandboxFlowType: lyftSandboxFlowType,
                apptId: apptId,
                primetimePercentage: primetimePercentage,
                sandboxRunId: sandboxRunId,
                packageSize: packageSize
            }, buildHeaders(isTestTrip, true, false, systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand, rideProviderType), true);
        }

        function cancelRide(rideId, cancelReason, notifyCustomer, isTestTrip, systemTripType, rideProviderType) {
            notifyCustomer = notifyCustomer || false;

            return rcApi.get(RIDE_BASEPATH + rideId + '/cancel?cancelReason=' + cancelReason + '&notifycustomer=' + notifyCustomer, null, null, buildHeaders(isTestTrip, true, false, systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand, rideProviderType), true);
        }

        function sendCredit(dealerId, firstName, lastName, phoneNumber, benefitType, startTime, endTime, creditAmount, creditType, referenceNote, liabilityPerRide, flatFarePerRide, discountRatio, numRides, geoRestrictionType, geoRestrictions, timeRestrictions, customerId, campaignId, isTest, createNewRO, newRoNumber) {
            return rcApi.post(TRIP_BASEPATH + dealerId + '/credits', {
                phoneNumber: phoneNumber,
                firstName: firstName,
                lastName: lastName,
                benefitType: benefitType,
                startTime: moment(startTime).utc(),
                endTime: moment(endTime).utc(),
                creditType: creditType,
                referenceNote: referenceNote,
                liabilityPerRide: liabilityPerRide ? liabilityPerRide * 100 : null,
                flatFarePerRide: liabilityPerRide ? flatFarePerRide * 100 : null,
                discountRatio: discountRatio,
                numRides: numRides,
                geoRestrictionType: geoRestrictionType,
                geoRestrictions: geoRestrictions,
                timeRestrictions: timeRestrictions,
                customerId: customerId,
                campaignId: campaignId,
                creditAmount: creditAmount * 100,
                createNewRO: createNewRO,
                newRoNumber: newRoNumber,
                isTest: isTest // Api expects amount in cents
            }, buildHeaders(isTest, false, true, false, SYSTEM_ENUMS.rideProviderType.lyft, benefitType));
        }

        function sendCreditBatch(dealerId, benefitType, startTime, endTime, creditAmount, creditType, referenceNote, liabilityPerRide, flatFarePerRide, discountRatio, numRides, geoRestrictionType, geoRestrictions, timeRestrictions, customerId, campaignId, riders, isTest) {
            return rcApi.post(TRIP_BASEPATH + dealerId + '/credits/batch', {
                benefitType: benefitType,
                startTime: moment(startTime).utc(),
                endTime: moment(endTime).utc(),
                creditType: creditType,
                referenceNote: referenceNote,
                liabilityPerRide: liabilityPerRide * 100,
                flatFarePerRide: flatFarePerRide * 100,
                discountRatio: discountRatio,
                numRides: numRides,
                geoRestrictionType: geoRestrictionType,
                geoRestrictions: geoRestrictions,
                timeRestrictions: timeRestrictions,
                customerId: customerId,
                campaignId: campaignId,
                riders: riders,
                creditAmount: creditAmount * 100, // Api expects amount in cents,
                isTest: isTest
            }, buildHeaders(isTest, false, true, false, SYSTEM_ENUMS.rideProviderType.lyft));
        }

        function updateCredit(credit, isTest) {
            return rcApi.put(RIDE_BASEPATH + 'credits/' + credit.id, credit, null, buildHeaders(isTest, false, true, false, SYSTEM_ENUMS.rideProviderType.lyft));
        }

        function getCredit(creditId, isTest) {
            return rcApi.get(RIDE_BASEPATH + 'credits/' + creditId, null, null, buildHeaders(isTest, false, true, false, SYSTEM_ENUMS.rideProviderType.lyft));
        }

        function searchCredits(filters) {
            return rcApi.post(RIDE_BASEPATH + 'credits/search', filters, buildHeaders(false, false, true, false, SYSTEM_ENUMS.rideProviderType.lyft));
        }

        function cancelCredit(creditId, isTest) {
            return rcApi.remove(RIDE_BASEPATH + 'credits/' + creditId, null, buildHeaders(isTest, false, true, false, SYSTEM_ENUMS.rideProviderType.lyft));
        }

        function getTripRoute(dealerId,
            pickupLat,
            pickupLng,
            pickupStreetAddress,
            pickupCity,
            pickupState,
            pickupZip,
            pickupCountry,
            dropoffLat,
            dropoffLng,
            dropoffStreetAddress,
            dropoffCity,
            dropoffState,
            dropoffZip,
            dropoffCountry,
            pickupTime,
            dealerTripTypeId,
            systemTripType,
            startsAtDealer,
            tripWorkFlowId) {

                let pickup = buildStop(pickupLat, pickupLng, pickupStreetAddress, pickupCity, pickupState, pickupZip, pickupCountry, true, systemTripType, startsAtDealer, tripWorkFlowId);
                let dropoff = buildStop(dropoffLat, dropoffLng, dropoffStreetAddress, dropoffCity, dropoffState, dropoffZip, dropoffCountry, false, systemTripType, startsAtDealer, tripWorkFlowId);

            return rcApi.post(TRIP_BASEPATH + dealerId + '/' + 'triproute', {
                pickup: pickup,
                dropoff: dropoff,
                pickupTime: pickupTime,
                dealerTripTypeId: dealerTripTypeId
            }).then((route) => {
                return {
                    pickup: pickup,
                    dropoff: dropoff,
                    route: route
                };
            });
        }

        function applyRefunds(refundsCsv) {
            return rcApi.post(RIDE_BASEPATH + 'refunds', {refundsCsv: refundsCsv});
        }

        function uploadBatch(dealerId, file) {
            return rcApi.post(TRIP_BASEPATH + dealerId + '/validate', file);
        }

        function addCampaignParticipant(campaignId, participant) {
            return rcApi.post(RIDE_BASEPATH + `campaigns/${campaignId}/participants/add`, participant);
        }

        function getCampaign(id) {
            return rcApi.get(RIDE_BASEPATH + `campaigns/${id}`);
        }

        function updateCampaign(id, campaign) {
            return rcApi.put(RIDE_BASEPATH + `campaigns/${id}`, campaign);
        }

        function revokeCampaign(id) {
            return rcApi.remove(RIDE_BASEPATH + `campaigns/${id}`);
        }

        function getCampaignErrors(id) {
            return rcApi.get(RIDE_BASEPATH + `campaigns/${id}/errors`);
        }

        function buildStop(lat, lng, streetAddress, city, state, zip, countryShortCode, isPickup, systemTripType, isLyftFromDealership, workFlowId) {
            let destinationType = null;

            if (systemTripType === SYSTEM_ENUMS.systemTripType.lyftShuttleService || systemTripType === SYSTEM_ENUMS.systemTripType.partsOnDemand && workFlowId !== tripWorkflowTypes.partsOnDemandToFromAny) {
                if (isLyftFromDealership) {
                    destinationType = isPickup ? SYSTEM_ENUMS.destinationType.dealer : SYSTEM_ENUMS.destinationType.customer;
                } else {
                    destinationType = isPickup ? SYSTEM_ENUMS.destinationType.customer : SYSTEM_ENUMS.destinationType.dealer;
                }
            } else {
                destinationType = isPickup ? SYSTEM_ENUMS.destinationType.customer : SYSTEM_ENUMS.destinationType.other;
            }

            return {
                locationType: isPickup ? SYSTEM_ENUMS.stopType.pickup : SYSTEM_ENUMS.stopType.dropoff,
                destinationType: destinationType,
                lat: lat,
                lng: lng,
                streetAddress: streetAddress,
                city: city,
                state: state,
                zip: zip,
                countryShortCode: countryShortCode
            };
        }

        function buildHeaders(isTest, requiresUserToken, requiresProgramPrivilege, isPartsOnDemand, rideProviderType) {
            let headers = {isTest: !!isTest};

            if (requiresUserToken) {
                headers.requiresUserToken = true;
            }

            if (requiresProgramPrivilege) {
                headers.requiresProgramPrivilege = true;
            }

            if (isPartsOnDemand) {
                headers.requiresDeliveryClient = true;
            }

            if (rideProviderType) {
                headers.rideProviderType = rideProviderType;
            }

            return headers;
        }

        function callDriver(rideId, phoneNumber, rideProviderType) {
            return rcApi.post(RIDE_BASEPATH + 'call', {
                rideId: rideId,
                phoneNumber: phoneNumber
            }, buildHeaders(false, false, false, false, rideProviderType));
        }
    }
})();
(function () {
    'use strict';

    tripLoanerService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .factory('tripLoanerService', tripLoanerService);

    function tripLoanerService($q, $log, $filter, $http, $rootScope, rcApi, SYSTEM_ENUMS) {

        var BOOKING_BASEPATH = 'loaner/';

        return {
            getLoanerDetails: getLoanerDetails
        };

        
        function getLoanerDetails(dealerId, loanerGuid) {
            return rcApi.get(BOOKING_BASEPATH + dealerId + '/' + loanerGuid + '/details');
        }
    }
})();

(function () {
    'use strict';

    chargeService.$inject = ["rcApi"];
    angular
        .module('redcap.trip')
        .factory('chargeService', chargeService);

    function chargeService(rcApi) {
        var CHARGE_BASEPATH = 'charge/';

        return {
            getConfigTypes: getConfigTypes
        };

        function getConfigTypes() {
            return rcApi.get(CHARGE_BASEPATH + 'configtypes');
        }
    }
})();

(function () {
    'use strict';

    bookingService.$inject = ["$q", "rcApi", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .factory('bookingService', bookingService);

    function bookingService($q, rcApi, SYSTEM_ENUMS) {

        var BOOKING_BASEPATH = 'booking/',
            roSearchCanceler = null;

        return {
            getRules: getRules,
            getRulesSpecific: getRulesSpecific,
            getLocationTripTypes: getLocationTripTypes,
            getLocationTripType: getLocationTripType,
            validateEarliestTime: validateEarliestTime,
            validateBookingRules: validateBookingRules,
            inServiceArea: inServiceArea,
            getServiceOrder: getServiceOrder,
            getServiceOrderLight: getServiceOrderLight,
            getUnavailableHours : getUnavailableHours,
            getDMSVehicleModels: getDMSVehicleModels,
            getVehicleTrimExclusions: getVehicleTrimExclusions,
            getVehicleModelTrims: getVehicleModelTrims,
            removeAccountDriver: removeAccountDriver,
            bookTrip: bookTrip,
            cancelTrip: cancelTrip,
            roSearch: roSearch,
            roSearchLight: roSearchLight,
            roTrips: roTrips,
            checkIfRONumberExists: checkIfRONumberExists,
            roExists: roExists,
            getAvailableDays: getAvailableDays,
            getAvailableTimes: getAvailableTimes,
            formatForDropdown: formatForDropdown,
            formatForItemSelected: formatForItemSelected,
            formatForMomentDate: formatForMomentDate,
            getMonthlyChargeInfo: getMonthlyChargeInfo 
        };

        function getRules(trip) {
            var dealerId = trip.dealerLocation ? trip.dealerLocation.id : trip.dealerId,
                dealerTripTypeId = trip.dealerTripTypeInstance ? trip.dealerTripTypeInstance.id : trip.tripTypeId,
                systemTripTypeId = trip.selectedSystemTripType ? trip.selectedSystemTripType.id : trip.systemTripTypeId,
                modelId = trip.dealerTripTypeInstance && trip.dealerTripTypeInstance.vehicle ? trip.dealerTripTypeInstance.vehicle.id : trip.modelId;
            return getRulesSpecific(dealerId, systemTripTypeId, dealerTripTypeId, modelId);
        }

        function getRulesSpecific(dealerId, systemTripTypeId, dealerTripTypeId, modelId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'rules', {tripTypeId: systemTripTypeId, tripTypeInstanceId: dealerTripTypeId, modelId: modelId});
        }

        function getLocationTripTypes(dealerId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'triptypesbymarketinggroup');
        }

        function getLocationTripType(dealerId, systemTripTypeId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'triptype?systemTripTypeId=' + systemTripTypeId );
        }

        function getServiceOrder(dealerId, dealerServiceOrderId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'ro/' + dealerServiceOrderId);
        }

        function getServiceOrderLight(dealerId, dealerServiceOrderId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'ro/light/' + dealerServiceOrderId);
        }

        function validateEarliestTime(serviceOrder, theTrip) {
            var loc = theTrip.customerLocation,
                vehInfo = serviceOrder.vehicleInfo,
                dropOffLoc = theTrip.dropoffLocation,
                selSystemTripType = theTrip.selectedSystemTripType,
                selSystemTripTypeId = selSystemTripType.id,
                systemTripTypes = SYSTEM_ENUMS.systemTripType,
                model = {
                    tripType: theTrip.dealerTripTypeInstance.tripTypeId,
                    customerLocation: {
                        name: theTrip.customerLocationName ? theTrip.customerLocationName : null,
                        streetAddress: loc.streetAddress,
                        city: loc.city,
                        state: loc.state,
                        zip: loc.zip,
                        countryShortCode: loc.countryShortCode,
                        lat: loc.lat,
                        lng: loc.lng
                    },
                    dropoffLocation: dropOffLoc ? {
                        streetAddress: dropOffLoc.streetAddress,
                        city: dropOffLoc.city,
                        state: dropOffLoc.state,
                        zip: dropOffLoc.zip,
                        countryShortCode: dropOffLoc.countryShortCode,
                        lat: dropOffLoc.lat,
                        lng: dropOffLoc.lng
                    }: null,
                    dealerTripTypeId: theTrip.dealerTripTypeInstance.id,
                    hoursNeeded: selSystemTripTypeId === systemTripTypes.mobileGarage ? theTrip.hoursNeeded : null,
                    hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                    workFlowId: theTrip.tripWorkFlowId,
                    lengthOfLoan: theTrip.lengthOfLoan,
                    loanerVehicleClass: theTrip.loanerVehicleClass
                };

            if (vehInfo && vehInfo.year && vehInfo.make && vehInfo.model) {
                model.vehicleYear = vehInfo.year;
                model.vehicleMake = vehInfo.make;
                model.vehicleModel = vehInfo.model;
            }

            if (selSystemTripType.supportsStartAtCustomer && serviceOrder.hasLoaner === 'no' || selSystemTripTypeId === systemTripTypes.dealerTrade) {
                model.oneWayStartsAtDealer = theTrip.startsAtDealer;
            }

            if (selSystemTripType.supportsFavoriteLocations) {
                if (theTrip.dropoffFormattedLocation) {
                    model.dropoffLocation.name = theTrip.dropoffFormattedLocation.name;
                }

                if (theTrip.customerFormattedLocation) {
                    model.customerLocation.name = theTrip.customerFormattedLocation.name;
                }
            }

            return rcApi.post(theTrip.dealerLocation.id + '/' + BOOKING_BASEPATH + 'validateearliesttime', model)
            .then(function (response) {
                return response;
            });
        }

        function validateBookingRules(serviceOrder, theTrip) {

           var loc = theTrip.customerLocation,
                customerDateTime = moment(formatForMomentDate(theTrip.customerDate) + ' ' + theTrip.customerTime, 'YYYY-MM-DD hh:mm A').utc(),
                pickupTime = theTrip.pickupTimeUtc || moment.utc(customerDateTime),
                dropOffLoc = theTrip.dropoffLocation,
                vehInfo = serviceOrder.vehicleInfo,
                selSystemTripType = theTrip.selectedSystemTripType,
                selSystemTripTypeId = selSystemTripType.id,
                systemTripTypes = SYSTEM_ENUMS.systemTripType,
                model = {
                    existingTripId: theTrip.id,
                    dealerAppointmentId: serviceOrder.dealerAppointmentId,
                    tripType: theTrip.dealerTripTypeInstance.tripTypeId,
                    customerLocation: {
                        name: theTrip.customerLocationName ? theTrip.customerLocationName : null,
                        streetAddress: loc.streetAddress,
                        city: loc.city,
                        state: loc.state,
                        zip: loc.zip,
                        countryShortCode: loc.countryShortCode,
                        lat: loc.lat,
                        lng: loc.lng
                    },
                    dropoffLocation: dropOffLoc ? {
                        streetAddress: dropOffLoc.streetAddress,
                        city: dropOffLoc.city,
                        state: dropOffLoc.state,
                        zip: dropOffLoc.zip,
                        countryShortCode: loc.countryShortCode,
                        lat: dropOffLoc.lat,
                        lng: dropOffLoc.lng
                    }: null,
                    dealerTripTypeId: theTrip.dealerTripTypeInstance.id,
                    hoursNeeded: selSystemTripTypeId === systemTripTypes.mobileGarage ? theTrip.hoursNeeded : null,
                    hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                    pickupTime: pickupTime,
                    workFlowId: theTrip.tripWorkFlowId
                };

            if (theTrip.dealerTripTypeInstance.vehicle) {
                model.vehicleModelId = theTrip.dealerTripTypeInstance.vehicle.id;
            }

            if (selSystemTripType.supportsStartAtCustomer && serviceOrder.hasLoaner === 'no' || selSystemTripTypeId === systemTripTypes.dealerTrade) {
                model.oneWayStartsAtDealer = theTrip.startsAtDealer;
            }

            if (vehInfo && vehInfo.year && vehInfo.make && vehInfo.model) {
                model.vehicleYear = vehInfo.year;
                model.vehicleMake = vehInfo.make;
                model.vehicleModel = vehInfo.model;
            }

            if (selSystemTripType.supportsFavoriteLocations) {
                if (theTrip.dropoffFormattedLocation) {
                    model.dropoffLocation.name = theTrip.dropoffFormattedLocation.name;
                }

                if (theTrip.customerFormattedLocation) {
                    model.customerLocation.name = theTrip.customerFormattedLocation.name;
                }
            }

            return rcApi.post(theTrip.dealerLocation.id + '/' + BOOKING_BASEPATH + 'validatebookingrules', model);
        }

        function inServiceArea(pickupLat, pickupLng, dropoffLat, dropoffLng, tripTypeInstanceId, dealerId, pickupState, dropoffState, rideProviderType) {
            var url = dealerId + '/' + BOOKING_BASEPATH + 'inservicearea?pickuplat=' + pickupLat + 
            '&pickuplng=' + pickupLng + 
            '&dropofflat=' + dropoffLat + 
            '&dropofflng=' + dropoffLng + 
            '&triptypeinstanceId=' + tripTypeInstanceId + 
            '&dealerId=' + dealerId +
            '&pickupstate=' + pickupState +
            '&dropoffState=' + dropoffState;

            if (rideProviderType) {
                url += '&rideProviderType=' + rideProviderType;
            }

            return rcApi.get(url, null, null);
        }

        function getUnavailableHours (dealerId, tripTypeInstanceId, date, location, serviceOrderId, silentDispatchTripId, tripWorkFlowId, vehicleYear, vehicleMake, vehicleModel) {

            return rcApi.post(dealerId + '/' + BOOKING_BASEPATH + 'unavailablehours ', {
                        dealerServiceOrderId: serviceOrderId,
                        dealerTripTypeId: tripTypeInstanceId,
                        workFlowId: tripWorkFlowId,
                        date: moment.utc(date),
                        location: location,
                        silentDispatchTripId: silentDispatchTripId,
                        vehicleYear: vehicleYear,
                        vehicleMake: vehicleMake,
                        vehicleModel: vehicleModel
                    }).then(function (response) {
                            return response;
                        });
        }

        function getDMSVehicleModels(dealerId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'dmsvehiclemodels');
        }

        function getVehicleTrimExclusions(dealerId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'vehiclemodeltrimexclusions');
        }

        function getVehicleModelTrims(dealerId, modelId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'vehicleModelTrims?vehicleModelId=' + modelId);
        }

        function cancelTrip(dealerId, tripId, cancelReason, sendNotifications, pushToDms) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'cancelTrip',
                {
                    tripId: tripId,
                    cancelReason: cancelReason,
                    sendNotifications: sendNotifications,
                    pushToDms: pushToDms
                });
        }

        function roSearch(searchTerm, dealerId, tripType) {
            var tripTypeQuery = '';

            if (tripType) {
                tripTypeQuery = '&tripType=' + tripType;
            }

            if (!roSearchCanceler) {
                roSearchCanceler = $q.defer();
            } else {
                roSearchCanceler.resolve();
                roSearchCanceler = $q.defer();
            }

            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'rosearch?searchTerm=' + searchTerm + tripTypeQuery, null, roSearchCanceler.promise)
                        .catch(function(err) {
                            if (err.status === -1) {
                                return { requestCanceled: true };
                            } else {
                                return err;
                            }
                        });
        }

        function roSearchLight(searchTerm, dealerId, tripType, isPhone) {
            var tripTypeQuery = '';
            if (tripType) {
                tripTypeQuery = '&tripType=' + tripType;
            }

            if (isPhone) {
                tripTypeQuery += '&isPhone=true';
            } 

            if (!roSearchCanceler) {
                roSearchCanceler = $q.defer();
            } else {
                roSearchCanceler.resolve();
                roSearchCanceler = $q.defer();
            }

            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'rosearchlight?searchTerm=' + searchTerm + tripTypeQuery, null, roSearchCanceler.promise)
                .catch(function (err) {
                    if (err.status === -1) {
                        return { requestCanceled: true };
                    } else {
                        return err;
                    }
                });
        }

        function roTrips(dealerId, dealerServiceOrderId) {

            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'rotrips',
                {
                    dealerServiceOrderId: dealerServiceOrderId
                })
                .catch(function (err) {
                    if (err.status === -1) {
                        return { requestCanceled: true };
                    } else {
                        return err;
                    }
                });
        }


        function checkIfRONumberExists(trip, serviceOrder, isSearchingForRO) {
            var deferred = $q.defer();

            if (!trip.isNewServiceOrder) {
                deferred.resolve({ isValid: true });
            } else {
                if (serviceOrder.roNumber.length >= 3 && !isSearchingForRO) {
                    rcApi.get(trip.dealerLocation.id + '/' + BOOKING_BASEPATH + 'roNumberExists?roNumber=' + serviceOrder.roNumber).then(function (response) {
                        deferred.resolve(response);
                    });
                } else {
                    deferred.reject({ isValid: false });
                }

            }

            return deferred.promise;

        }

        function roExists(dealerId, roNumber) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'roNumberExists?roNumber=' + roNumber );
        }

        function removeAccountDriver(dealerId, driverId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'removeaccountdriver?driverId=' + driverId);
        }

        function bookTrip(serviceOrder, trip) {
            var dlInfo = serviceOrder.dlInfo,
                insInfo = serviceOrder.insInfo,
                loc = trip.customerLocation,
                dropoffLoc = trip.dropoffLocation || trip.customerLocation,
                homeLoc = trip.customerHomeLocation,
                vehInfo = serviceOrder.vehicleInfo,
                veh2Info = serviceOrder.vehicle2Info,
                custInfo = serviceOrder.customerInfo,
                customerDateTime = moment(trip.customerDate + ' ' + trip.customerTime, 'MM/DD/YYYY hh:mm A').utc(),
                pickupTime = trip.pickupTimeUtc || moment.utc(customerDateTime),
                tripBindingModel = {
                    recallId: serviceOrder.recallId || null,
                    dealerServiceOrderId: serviceOrder.id || null,
                    tripType: trip.selectedSystemTripType.id,
                    customerDescriptionOfProblem: serviceOrder.customerDescriptionOfProblem,
                    customer: {
                        firstName: custInfo.firstName,
                        lastName: custInfo.lastName,
                        companyName: custInfo.companyName,
                        phoneNumber: custInfo.phoneNumber,
                        email: custInfo.email,
                        address: homeLoc && trip.selectedSystemTripType.supportsHomeAddress ? {
                            name: 'home address',
                            streetAddress: homeLoc.streetAddress,
                            city: homeLoc.city,
                            state: homeLoc.state,
                            zip: homeLoc.zip,
                            countryShortCode: homeLoc.countryShortCode,
                            lat: homeLoc.lat,
                            lng: homeLoc.lng
                        } : null
                    },
                    customerLocation: {
                        name: trip.customerLocationName ? trip.customerLocationName : null,
                        streetAddress: loc.streetAddress,
                        city: loc.city,
                        state: loc.state,
                        zip: loc.zip,
                        countryShortCode: loc.countryShortCode,
                        lat: loc.lat,
                        lng: loc.lng
                    },
                    dealerTripTypeId: trip.dealerTripTypeInstance.id,
                    hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                    vehicle: {
                        modelId: trip.vehicleModelId || 0,
                        year: vehInfo.year,
                        make: vehInfo.make,
                        model: vehInfo.model,
                        style: vehInfo.style ? vehInfo.style.name : vehInfo.genericStyle ?  vehInfo.genericStyle : null,
                        vin: vehInfo.vin,
                        stockNumber: vehInfo.stockNumber,
                        isVehicleNew: vehInfo.isVehicleNew ? vehInfo.isVehicleNew.value : null
                    },
                    pickupTime: pickupTime,
                    driversLicense: dlInfo.number ? serviceOrder.dlInfo : null,
                    insurance: insInfo.policyNumber ? serviceOrder.insInfo : null,
                    tripNote: trip.tripNote,
                    transmission: vehInfo.transmission ? vehInfo.transmission.value : 0,// 0 automatic, 1 manual
                    bookingSource: 'Automotive - Dealer',
                    hoursNeeded: trip.hoursNeeded,
                    serviceAdvisorId: trip.serviceAdvisor.id,
                    driverId: trip.assignedDriver ? trip.assignedDriver.id : null,
                    sendNotifications: true,
                    updateDMSRecord: serviceOrder.createDMSAppointment,
                    isTestTrip: trip.testTrip,
                    canAccessEarly: trip.canAccessEarly,
                    tripId: trip.id || 0,
                    bypassValidation: (trip.errors && trip.errors.length) > 0 ? true : false,
                    roNumber: serviceOrder.roNumber || null,
                    workFlowId: trip.tripWorkFlowId,
                    loanerContractId: serviceOrder.selectedLoanerContract ? serviceOrder.selectedLoanerContract.externalContractId : null,
                    loanerContractNumber: serviceOrder.selectedLoanerContract ? serviceOrder.selectedLoanerContract.contractNumber : null
                };

            if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                tripBindingModel.lengthOfLoan = trip.lengthOfLoan;
            }

            if (veh2Info !== null && typeof veh2Info !== 'undefined') {
                tripBindingModel.vehicle2 = {
                        year: veh2Info.year,
                        make: veh2Info.make,
                        model: veh2Info.model,
                        stockNumber: veh2Info.stockNumber || null
                };
                tripBindingModel.vehicle2Transmission = veh2Info.transmission ? veh2Info.transmission.value : 0;
            }

            if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup || trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.recalls) {
                tripBindingModel.appointmentDateTime = tripBindingModel.pickupTime;
            }

            if (trip.dropoffLocation !== null && typeof(trip.dropoffLocation !== null) !== 'undefined') {
                tripBindingModel.dropoffLocation =  {
                    streetAddress: dropoffLoc.streetAddress,
                    city: dropoffLoc.city,
                    state: dropoffLoc.state,
                    zip: dropoffLoc.zip,
                    countryShortCode: dropoffLoc.countryShortCode,
                    lat: dropoffLoc.lat,
                    lng: dropoffLoc.lng
                };

                tripBindingModel.hoursNeed = trip.hoursNeeded || null;
            }

            if (dlInfo && dlInfo.number) {
                tripBindingModel.driversLicense.ExpirationDate = moment(dlInfo.expirationMonth + '/01/' + dlInfo.expirationYear, 'MM/DD/YYYY');
            }

            if (insInfo && insInfo.policyNumber) {
                tripBindingModel.insurance.ExpirationDate = moment(insInfo.expirationMonth + '/01/' + insInfo.expirationYear, 'MM/DD/YYYY');
            }

            if (trip.selectedSystemTripType.supportsStartAtCustomer && serviceOrder.hasLoaner === 'no' || trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dealerTrade) {
                tripBindingModel.oneWayStartsAtDealer = trip.startsAtDealer;
            }

            if (trip.selectedSystemTripType.supportsFavoriteLocations) {
                if (trip.dropoffFormattedLocation) {
                    tripBindingModel.dropoffLocation.name = trip.dropoffFormattedLocation.name;
                }

                if (trip.customerFormattedLocation && trip.customerFormattedLocation.name) {
                    tripBindingModel.customerLocation.name = trip.customerFormattedLocation.name;
                }
            }

            return rcApi.post(trip.dealerLocation.id + '/' + BOOKING_BASEPATH, tripBindingModel, null, true);
        }

        function getAvailableDays(trip, serviceOrder, startDate, dealerDays) {
            var dealerId = trip.dealerLocation ? trip.dealerLocation.id : trip.dealerId,
                vehInfo = serviceOrder.vehicleInfo,
                tripTypeInstanceId = trip.dealerTripTypeInstance ? trip.dealerTripTypeInstance.id : null;
            return rcApi.post(dealerId + '/' + BOOKING_BASEPATH + 'availableDays ', {
                existingTripId: trip.id,
                tripType: trip.selectedSystemTripType.id,
                tripTypeInstanceId: tripTypeInstanceId,
                customerLocation: trip.customerLocation,
                dropOffLocation: trip.dropoffLocation || trip.customerLocation,
                startTime: moment(moment(startDate).startOf('day')).utc(),
                daysToCheck: dealerDays,
                hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                hoursNeeded: null,
                workFlowId: trip.tripWorkFlowId,
                vehicleMake: vehInfo ? vehInfo.make : null,
                vehicleModel: vehInfo ? vehInfo.model : null,
                vehicleYear: vehInfo ? vehInfo.year : null
            }).then(function (response) {
                return response;
            });
        }

        function getAvailableTimes(trip, serviceOrder, selectedDate) {
            var dealerId = trip.dealerLocation ? trip.dealerLocation.id : trip.dealerId,
                vehInfo = serviceOrder.vehicleInfo,
                tripTypeInstanceId = trip.dealerTripTypeInstance ? trip.dealerTripTypeInstance.id : null;

            return rcApi.post(dealerId + '/' + BOOKING_BASEPATH + 'availableTimes ', {
                existingTripId: trip.id,
                tripType: trip.selectedSystemTripType.id,
                tripTypeInstanceId: tripTypeInstanceId,
                customerLocation: trip.customerLocation,
                dropOffLocation: trip.dropoffLocation || trip.customerLocation,
                startTime: moment(formatForMomentDate(selectedDate)).startOf('day').utc(),
                daysToCheck: 1, // Default to just single day's worth of times
                hasLoaner: serviceOrder.hasLoaner ? serviceOrder.hasLoaner === 'yes' ? true : false : false,
                hoursNeeded: null,
                workFlowId: trip.tripWorkFlowId,
                vehicleMake: vehInfo ? vehInfo.make : null,
                vehicleModel: vehInfo ? vehInfo.model : null,
                vehicleYear: vehInfo ? vehInfo.year : null,
                lengthOfLoan: trip.lengthOfLoan,
                loanerVehicleClass: trip.loanerVehicleClass
            }).then(function (response) {
                return response;
            });
        }
        
        function getMonthlyChargeInfo(dealerId, dealerTripTypeId) {
            return rcApi.get(dealerId + '/' + BOOKING_BASEPATH + 'monthlychargeinfo?dealerTripTypeId=' + dealerTripTypeId);
        }

        function formatForDropdown(repairOrder, isAppt) {
            var companyName = repairOrder.companyName ? `${repairOrder.companyName}` : '',
                customerName = (repairOrder.customerName1 || repairOrder.customerName12) ? ((repairOrder.customerName1 || '')  + ' ' + (repairOrder.customerName2 || '')) : '';

            if (companyName && customerName) {
                customerName = `(${customerName})`;
            }

            if (isAppt) {
                var apptId = repairOrder.apptId && repairOrder.apptId.length > 0 ? '#' + repairOrder.apptId  + ' ' : '';

                return apptId + '(' + moment(repairOrder.appointmentDateTime).format('MM/DD/YYYY') + ') - ' +
                    companyName +
                    customerName + ', ' +
                    (repairOrder.year ? (repairOrder.year + ' ') : '') +
                    (repairOrder.make ? (repairOrder.make + ' ') : '') +
                    (repairOrder.model ? repairOrder.model : '');
            } else {
                return '#' + repairOrder.roNumber + ' ' +
                    '(' + moment(repairOrder.updatedDate).format('MM/DD/YYYY') + ') - ' +
                    companyName +
                    customerName + ', ' +
                    (repairOrder.year ? (repairOrder.year + ' ') : '') +
                    (repairOrder.make ? (repairOrder.make + ' ') : '') +
                    (repairOrder.model ? (repairOrder.model + ' ') : '') +
                    '(' + repairOrder.statusCodeDesc + ')';
            }
        }

        function formatForItemSelected(repairOrder, isAppt) {
            if (isAppt) {
                if (repairOrder) {
                    var display = repairOrder.customerName2 + ' - ',
                        dateTime = repairOrder.appointmentDateTime;
                        
                    if (dateTime) {
                        display += moment(dateTime).format('MMM D, ');
                        display += moment(dateTime).format('hh:mma');
                    }
                } else {
                    display = 'CREATE NEW';
                }
                
                return display;
            } else {
                return 'RO #' + repairOrder.roNumber;
            }
        }

        // Formats a date string for use with moment.js.
        // This function is used to prevent deprecation warnings from moment.js when a date string is not in a recognized RFC2822 or ISO format.
        function formatForMomentDate(date) {
            if (moment(date, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm:ssZ"], true).isValid()) {
                return date.split('T')[0];
            } else {
                return moment(date, "MM/DD/YYYY").format("YYYY-MM-DD");
            }
        }
    }
})();


(function () {
    "use strict";

    billingModalService.$inject = ["$q", "$uibModal", "tripService", "modalService", "SYSTEM_ENUMS"];
    angular
        .module("redcap.trip")
        .factory("billingModalService", billingModalService);

    function billingModalService($q, $uibModal, tripService, modalService, SYSTEM_ENUMS) {
        return {
            setCharge: setCharge,
            setBillingTime: setBillingTime,
            convertToTimezoneUtc: convertToTimezoneUtc
        };

        function setCharge(trip, chargeToEdit) {
            let deferred = $q.defer();

            let modal = $uibModal.open({
                templateUrl: 'app/areas/trip/views/modals/set-charge.view.html',
                controllerAs: 'vm',
                controller: 'SetTripChargeModalController',
                backdrop: 'static',
                windowClass: 'top-modal',
                keyboard: false,
                resolve: {
                    resolvedTrip: function () { return trip; },
                    chargeToEdit: chargeToEdit
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function setBillingTime(trip, chargeToEdit) {
            let deferred = $q.defer();

            let modal = $uibModal.open({
                templateUrl: 'app/areas/trip/views/modals/set-billing-time.view.html',
                controllerAs: 'vm',
                controller: 'SetBillingTimeModalController',
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'modal-width-px-800 top-modal',
                resolve: {
                    resolvedTrip: function () { return trip; },
                    chargeToEdit: function() { return chargeToEdit; }         
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }
        
        function convertToTimezoneUtc(timeToConvert, dealerTimezone) {
            let dateFormat = 'MM-DD-YYYY HH:mm:ss';

            // Extract the date and time components, then append the proper timezone
            let dateInTimezone = moment(timeToConvert).format(dateFormat) + moment().tz(dealerTimezone).format('Z');
            
            // Convert the dealer-specific time to UTC
            let timezoneInUtc = moment(dateInTimezone).utc().format(dateFormat);

            return timezoneInUtc;
        }
    }
})();



(function () {
    'use strict';

    TripTabVehiclesController.$inject = ["$q", "$log", "$scope", "$timeout", "SYSTEM_ENUMS", "resolvedVehicles", "modalService", "tripService", "signalRService"];
    angular
        .module('redcap.trip')
        .controller('TripTabVehiclesController', TripTabVehiclesController);

    function TripTabVehiclesController($q, $log, $scope, $timeout, SYSTEM_ENUMS, resolvedVehicles, modalService, tripService, signalRService) {
        var vm = this;

        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
        vm.workflowGroupedVehicles = resolvedVehicles;

        vm.openMedia = function (media) {
            var createNewDlg =  modalService.showImageViewer(media.path, null, media.type);
            createNewDlg.then(function (results) {});
        };

        $scope.$on('updateTrip', function(event, updateModel) {
            if (updateModel.type === signalRService.events.trips.updateType.stateChange
                || updateModel.type === signalRService.events.trips.updateType.modelChange) {
                    tripService.getTripVehicles(updateModel.trip.id)
                            .then(function (results) {
                                vm.workflowGroupedVehicles = results;
                            });
            }
        });
    }
})();
(function () {
    'use strict';

    TripTabTasksController.$inject = ["$scope", "toastr", "SYSTEM_ENUMS", "resolvedTaskResponses", "tripService", "signalRService"];
    angular
        .module('redcap.trip')
        .controller('TripTabTasksController', TripTabTasksController);

    function TripTabTasksController($scope, toastr, SYSTEM_ENUMS, resolvedTaskResponses, tripService, signalRService) {
        let vm = this;
        const atDealerShipLowerCase = "at dealership";

        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
        vm.workflowGroupedTasks = [];
        vm.workflowTaskTypes = SYSTEM_ENUMS.workflowTaskTypes;

        // todo, we should really have some sort of task type
        // on the task so we don't have to do this
        function isAtDealershipTask (state) {
            return state.toLowerCase() === atDealerShipLowerCase;
        }

        $scope.$on('updateTrip', (event, updateModel) => {
            if (updateModel.type === signalRService.events.trips.updateType.stateChange || updateModel.type === signalRService.events.trips.updateType.modelChange) {
                tripService.getDriverTaskResponses(updateModel.trip.id).then((result) => {
                    init(result);
                });
            }
        });


        vm.countMedia = function(segment) {
            let count = 0;

            if (!segment || !segment.tasks || !segment.tasks.length) return 0;

            for (let taskIndex = 0; taskIndex < segment.tasks.length; taskIndex++) {
                let task = segment.tasks[taskIndex];

                count += task.media && task.media.length || 0;
                count += task.vehicleIssues && task.vehicleIssues.length || 0;
            }

            return count;
        };

        vm.displayToastError = function (errorResponse) {
            let errorMessage = 'An error occurred';

            if (errorResponse.data && errorResponse.data.exceptionMessage) {
                errorMessage = errorResponse.data.exceptionMessage;
            }

            toastr.error(errorMessage);
        };

        vm.calculateDuration = function(segment) {
            if (!segment.startedDateTime || !segment.finishedDateTime) return null;

            let started = new Date(segment.startedDateTime);
                let ended = new Date(segment.finishedDateTime);

            return (ended - started) / 1000;
        };

        function init(resolvedTaskResponses) {
            vm.workflowGroupedTasks = [];

            // we only want to display those with photos
            for (let idx = 0; idx < resolvedTaskResponses.length - 1; idx++) {
                let segment = resolvedTaskResponses[idx];

                if (segment.tasks && segment.tasks.length > 0) {
                    segment.mediaCount = vm.countMedia(segment);

                    //hiding skipped tasks for the mobile Service by PROD-13157
                    if (segment.tripWorkflowId === SYSTEM_ENUMS.tripWorkflowTypes.mobileGarage) {
                        if (!segment.wasSkipped && !isAtDealershipTask(segment.friendlyState)) {
                            vm.workflowGroupedTasks.push(segment);
                        }
                    } else {
                        vm.workflowGroupedTasks.push(segment);
                    }
                }
            }
        }

        init(resolvedTaskResponses);
    }
})();

(function () {
    'use strict';

    TripTabSummaryController.$inject = ["$scope", "$state", "$filter", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "LoanerErrors", "resolvedTrip", "resolvedBookingRules", "tripService", "rideProviderService", "permissions", "modalService", "toastr", "signalRService"];
    angular
        .module('redcap.trip')
        .controller('TripTabSummaryController', TripTabSummaryController);

    function TripTabSummaryController($scope, $state, $filter, SYSTEM_ENUMS, HERE_MAPS_CONFIG, LoanerErrors, resolvedTrip, resolvedBookingRules, tripService,
        rideProviderService, permissions, modalService, toastr, signalRService) {
        let vm = this;
        let _map = null;

        vm.showProviderRideSandboxOptions = false;
        vm.shortSystemTripType = SYSTEM_ENUMS.systemTripType;
        vm.tripStates = SYSTEM_ENUMS.driverTripStates;
        vm.healthStatus = SYSTEM_ENUMS.healthStatus;        

        vm.mapOptions = {
            showSegmentOverlay: false,
            fillHeight: false,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: true,
            showInfoWindows: true,
            showControls: true,
            trip: resolvedTrip
        };

        function init(resolvedTrip) {
            vm.trip = resolvedTrip;

            if (!_.isEmpty(vm.trip.driverPayIncentive)) {
                if (vm.trip.driverPayIncentive.incentiveType == 1)
                    vm.trip.driverPayIncentive.amount = parseFloat(vm.trip.driverPayIncentive.amount).toFixed(2);
    
                vm.trip.driverPayIncentive.incentiveType = vm.trip.driverPayIncentive.incentiveType.toString();

                vm.previousIncentiveAmount = vm.trip.driverPayIncentive.amount;
            } else {
                vm.trip.driverPayIncentive = {};
            }

            vm.changeDriver = false;
            vm.bookingRules = resolvedBookingRules;
            vm.locToDisplay = null;
            vm.selectedSystemTripType = $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: vm.trip.systemTripTypeId})[0];
            vm.locToDisplay = $filter('filter')(vm.trip.stops, {stopType: 1})[0];
            vm.canSeeIncentive = !vm.selectedSystemTripType.supportsLyftAPI && 
                                 vm.selectedSystemTripType.value != SYSTEM_ENUMS.systemTripType.mobileGarage &&
                                 (permissions.isSysAdmin() || permissions.isRedCapAdmin());
            vm.incentiveDisabled = vm.trip.state > vm.tripStates.accepted;
            vm.supportsSandboxAdvance = vm.selectedSystemTripType.supportsLyftAPI &&
                                        (vm.trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.lyft &&
                                            vm.selectedSystemTripType.value === SYSTEM_ENUMS.systemTripType.partsOnDemand) ||
                                        (vm.trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.uber &&
                                            vm.selectedSystemTripType.value !== SYSTEM_ENUMS.systemTripType.partsOnDemand);

            if (vm.trip.loanerError === LoanerErrors.reservationNotFound) {
                let detachReservationModal = modalService.showYesNo('Loaner Reservation Not Found',
                    'We can’t access this reservation from your current LMS. The reservation may have been created under a different system or is no longer available. You can remove it from this trip to rebook with a new reservation.',
                    'Remove Reservation',
                    'Close');

                detachReservationModal.then((confirmed) => {
                    if (confirmed === false) {
                        let confirmDetachReservation = modalService.showYesNo('Confirm Loaner Removal',
                        'This will remove the loaner reservation from this trip and require that you manually create a new reservation under your current LMS. This action will not cancel the trip or affect the existing customer record. Are you sure you want to remove the loaner reservation from this trip?',
                        'Yes',
                        'Cancel');
                        
                        confirmDetachReservation.then((response) => {
                            if (response === false) {
                                tripService.detachLoanerReservation(vm.trip.id, vm.trip.dealer.id);
                            }
                        });
                    } 
                });
            }
        }

        init(resolvedTrip);

        vm.isTestTripChanged = function () {
            tripService.updateIsTestTrip(vm.trip.id, vm.trip.isTestTrip).then((response) => {
            });
        };

        vm.isTripCancelled = function () {
            if (vm.trip.cancelled.date || vm.trip.cancelled.firstName || vm.trip.cancelled.id || vm.trip.cancelled.lastName || vm.trip.cancelled.userName)
                return true;
            else
                return false;
        };

        vm.canAccessEarlyChanged = function () {
            vm.updatingCanAccessEarly = true;
            vm.tripUpdated = false;

            tripService.updateCanAccessEarly(vm.trip.id, vm.trip.canAccessEarly).then((response) => {
                vm.updatingCanAccessEarly = false;
                vm.tripUpdated = true;
            });
        };

        vm.showPhoneCapture = function () {
            modalService.showPhoneCapture().then((phone) => {
                if (phone) { 
                    rideProviderService.callDriver(vm.trip.tripId, phone, vm.trip.rideProviderType).then((response) => {
                    });
                }
            });
        };

        vm.showProviderRideSandboxOptionsDiv = function () {
            vm.showProviderRideSandboxOptions = !vm.showProviderRideSandboxOptions;
        };

        vm.mapLoaded = function (mapActions) {
            _map = mapActions;
        };

        vm.uiReady = function() {
            if (_map && 
                !vm.selectedSystemTripType.supportsLyftAPI &&
                 (
                    (permissions.isSysAdmin() || permissions.isRedCapAdmin()) || 
                    (vm.bookingRules.hasInternalDrivers && permissions.isDealerAdmin())
                 )) {
                _map.showNearbyDriversButton();
            }
        };

        vm.advanceProviderRide = function (step) {
            rideProviderService.setSandboxState(resolvedTrip.providerRideId, step, resolvedTrip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.partsOnDemand, resolvedTrip.rideProviderType)
                .then((result) => {
                    if (result.error) {
                        let message = {data: {exceptionMessage: result.error.error_description}};

                        vm.displayToastError(message);
                    } else {
                        let modal = modalService.showYesNo('Trip Advanced', 'Would you like to refresh the page to get the latest information?', 'No', 'Yes', false);

                        modal.then((refreshNow) => {
                            if (refreshNow) {
                                window.location.reload(true);
                            }
                        });
                    }
                }, (errorMessage) => {
                    vm.displayToastError(errorMessage);
                });
        };

        vm.getStatusText = function (status, verbose) {
            if (vm.trip.health.status > vm.healthStatus.driverNoLocation) {
                return vm.trip.health.reason;
            } else {
                return tripService.getStatusText(status, verbose);
            }
        };

        vm.enableDispatchControls = function () {
            return !vm.selectedSystemTripType.supportsLyftAPI && ((vm.bookingRules && vm.bookingRules.enableDispatchControls === true) || permissions.isSysAdmin() || permissions.isRedCapAdmin());
        };

        vm.changeDriverClick = function () {
            if (vm.changeDriver) { return; }

            vm.changeDriver = true;

            if (!vm.activeDrivers) {
                vm.retrievingDrivers = true;
                let trip = vm.trip;
                let startTime = moment(trip.expectedStartTime).format('MM/DD/YYYY hh:mm A');
                let endTime = moment(trip.expectedEndTime).format('MM/DD/YYYY hh:mm A'); // lower case am/pm seems to have a sporadic issue.
                let driverId = trip.driver && trip.driver.id || null;

                tripService.getActiveDrivers(trip.dealer.id, startTime.toLowerCase(), endTime.toLowerCase(), driverId, trip.id, vm.trip.systemTripTypeId).then((response) => {
                    if (response.errorMessage) {
                        vm.errors = response.errorMessage;
                    } else if (response) {
                        // insert in the --- line
                        for (let idx = response.length - 1; idx >= 0; idx--) {
                            if (response[idx].isPreferred) {
                                response.splice(idx + 1, 0, {id: -999, name: '------------------------------------------------', isAvailable: true});
                                break;
                            }
                        }

                        vm.activeDrivers = response;
                    }

                    vm.retrievingDrivers = false;
                }, (errorResponse) => {
                    vm.displayToastError(errorResponse);
                    vm.retrievingDrivers = false;
                });
            }
        };

        vm.canEditDriver = function () {
            if (!vm.enableDispatchControls() ||  !vm.trip ||  !vm.trip.canChangeDriver) { return false; }

            return true;
        };

        vm.displayToastError = function (errorResponse) {
            let errorMessage = 'An error occurred';

            if (errorResponse.data && errorResponse.data.exceptionMessage) {
                errorMessage = errorResponse.data.exceptionMessage;
            }

            toastr.error(errorMessage);
        };

        vm.saveNewDriver = function (newDriver, previousDriver) {
            vm.savingDriver = true;
            let assignOrUnassign = !newDriver || (!vm.trip.driver || !vm.trip.driver.id) ? tripService.unassignDriver : tripService.assignDriver;
                let driver = !newDriver || (!vm.trip.driver || !vm.trip.driver.id) ? previousDriver : newDriver;

            // If the driver is null, signalr might not have updated the trip with the current driver's information
            if (!driver) {
                vm.displayToastError('There was an error assigning the driver, please try again');
            }

            assignOrUnassign(vm.trip.id, driver.id).then((response) => {
                // We update the driver's photo with the response
                if (response && vm.trip.driver) {
                    vm.trip.driver.driverPhoto = response;
                }

                vm.changeDriver = false;
                vm.savingDriver = false;
                vm.originalDriver = newDriver;
            }, (errorResponse) => {
                vm.displayToastError(errorResponse);
                vm.savingDriver = false;
            });
        };

        vm.displayDriverUnavailableWarning = function (previousDriver) {
            let confirm = modalService.showYesNo('Please Confirm', 'The driver you selected is already booked for another trip at this time. Are you sure you want to continue changing the driver for this trip?', 'No', 'Yes');

            confirm.then((confirmed) => {
                if (!confirmed) {
                    vm.trip.driver = previousDriver;
                } else {
                    vm.saveNewDriver(vm.trip.driver, previousDriver);
                }
            });
        };

        vm.displayAreYourSureWarning = function (previousDriver) {
            let type = vm.selectedSystemTripType.value !== SYSTEM_ENUMS.systemTripType.mobileGarage ? 'driver' : 'mobile tech';
                let confirmMessage = 'Are you sure you want to assign this trip to this ' + type + '?';
            
            if ((vm.trip.vehicle && vm.trip.vehicle.isManual) || (vm.trip.vehicle2 && vm.trip.vehicle2.isManual)) {
                confirmMessage = 'Note, driver must be able to operate a manual transmission. ' + confirmMessage;
            }

            let confirm = modalService.showYesNo('Please Confirm', confirmMessage, 'No', 'Yes');

            confirm.then((confirmed) => {
                if (!confirmed) {
                    vm.trip.driver = previousDriver;
                } else {
                    if (vm.trip.driver) {
                        let newDriver = vm.trip.driver || previousDriver;

                        vm.saveNewDriver(newDriver, previousDriver);
                    } else {
                        vm.saveNewDriver(null, previousDriver);
                    }
                }
            });
        };

        vm.driverSelectionModified = function (updatedDriver, originalDriver) {
            vm.saveSuccessful = false;
            let driverId = updatedDriver ? updatedDriver.id : null;
                let tempDriver = $filter('filter')(vm.activeDrivers, {id: driverId})[0];

            if (tempDriver) {
                if (tempDriver.isAvailable === false) {
                    vm.displayDriverUnavailableWarning(originalDriver);
                } else {
                    vm.displayAreYourSureWarning(originalDriver);
                }
            } else {
                vm.displayAreYourSureWarning(originalDriver);
            }
        };

        vm.gotoTab = function (tabIndexToLoad, tabRoute) {
            if (tabRoute) {
                tabIndexToLoad = _.findIndex($scope.$parent.vm.tabs, {route: tabRoute});

                $scope.$parent.vm.tabs[tabIndexToLoad].active = true;
                $state.go($scope.$parent.vm.tabs[tabIndexToLoad].route);
            } else {
                $scope.$parent.vm.tabs[tabIndexToLoad].active = true;
                $state.go($scope.$parent.vm.tabs[tabIndexToLoad].route);
            }
        };

        vm.notSame = function() {
            return vm.previousIncentiveAmount !== vm.trip.driverPayIncentive.amount;
        };

        vm.saveDriverIncentive = function() {
            let isAssigned = vm.trip.driver && vm.trip.driver.id;

            confirmIncentive(isAssigned).then((continueProcessing) => {
                if (!continueProcessing) return;

                vm.savingDriverIncentive = true;
                if (_.isNumber(vm.trip.driverPayIncentive.amount)) 
                    vm.trip.driverPayIncentive.amount = parseFloat(vm.trip.driverPayIncentive.amount).toFixed(2);

                tripService.saveDriverIncentive(vm.trip.id, vm.trip.driverPayIncentive, vm.shouldReDispatch).then((result) => {
                    vm.settingDriverIncentive = false;
                    vm.previousIncentiveAmount = vm.trip.driverPayIncentive.amount;
                }).finally(() => {
                    vm.savingDriverIncentive = false;
                });
            });
        };

        vm.cancelSetIncentive = function () {
            vm.trip.driverPayIncentive.amount = vm.previousIncentiveAmount;
            vm.settingDriverIncentive = false;
        };

        function confirmIncentive(isAssigned) {
            if (!isAssigned) {
                return modalService.showYesNo('Trip will Re-Dispatch', 'The trip will be re-dispatched and drivers will be notified, are you sure you want to proceed?', 'No', 'Yes', true).then((confirmed) => {
                    if (!confirmed) return false;

                    vm.shouldReDispatch = true;

                    return true;
                });                
            } else {
                return modalService.showYesNo('Keep Assigned Driver?', 'Would you like to keep the assigned driver and send an updated notification letting them know an incentive has been added, or would you like to unassign from the current driver and re-dispatch to all drivers with the new incentive?', 'Re-Dispatch', 'Keep Current Driver', true, true).then((keepCurrentDriver) => {
                    if (keepCurrentDriver === null)
                        return false;
                    
                    vm.shouldReDispatch = !keepCurrentDriver;

                    return true;
                });                
            }
        }

        vm.formatDriverDropDown = function (driver, tripDriver) { return tripService.formatDriverDropDown(driver, tripDriver); };

        $scope.$on('updateTrip', (event, updateModel) => {
            vm.trip = updateModel.trip;

            if (!vm.trip.driver.driverPhoto) {
                tripService.getDriverPhoto(vm.trip.driver.id).then((response) => {
                    if (response && vm.trip.driver) {
                        vm.trip.driver.driverPhoto = response;
                    }
                });
            }

            if (updateModel.type === signalRService.events.trips.updateType.driverChange) {
                _map.updateAssignedDriver(updateModel.trip.driver);
            }
        });

        vm.showDriverContactLink = function () {
            return vm.trip.driver.id && (vm.trip.isComplete || vm.trip.isInProgress) && 
                    (vm.trip.systemTripTypeId === vm.shortSystemTripType.lyftRoadSideAssistance || 
                    vm.trip.systemTripTypeId === vm.shortSystemTripType.lyftShuttleService || 
                    vm.trip.systemTripTypeId === vm.shortSystemTripType.lyftDriverReturn);
        };
    }
})();

(function () {
    'use strict';

    TripTabRatingsController.$inject = ["$scope", "toastr", "resolvedSurveys", "resolvedTrip", "resolvedDriver", "tripService", "signalRService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('TripTabRatingsController', TripTabRatingsController);

    function TripTabRatingsController($scope, toastr, resolvedSurveys, resolvedTrip, resolvedDriver, tripService, signalRService, SYSTEM_ENUMS) {
        var vm = this;
        vm.resolvedSurveys = resolvedSurveys;
        vm.resolvedDriver = resolvedDriver;
        vm.resolvedTrip = resolvedTrip;
        vm.dispatchSystemTypes = SYSTEM_ENUMS.dispatchSystemTypes;

        $scope.$on('updateTrip', function (event, updateModel) {
            if (updateModel.type === signalRService.events.trips.updateType.stateChange) {
                tripService.getSurveys(resolvedTrip.id)
                    .then(function (resolvedSurveys) {
                        vm.resolvedSurveys = resolvedSurveys;
                        if (resolvedTrip.driver && resolvedTrip.driver.id) {
                            tripService.getDriverDetails(vm.resolvedTrip.id, vm.resolvedDriver.id)
                                .then(function (resolvedDriver) {
                                    vm.resolvedDriver = resolvedDriver;
                                }, function(errorResponse) {
                                    vm.updatingDriver = false;
                                    console.log('Driver may no longer be associated with dealer.  Setting ratings has been disabled');
                                });
                        } else {
                            return null;
                        }
                    });

                vm.resolvedTrip = updateModel.trip;
                vm.resolvedDriver = updateModel.trip.driver !== null ? updateModel.trip.driver : null;
            }
        });

        vm.refreshDriverDetails = function () {
            vm.updatingDriver = true;
            tripService.getDriverDetails(vm.resolvedTrip.id, vm.resolvedDriver.id).then(function(response) {
                vm.resolvedDriver = response;
                vm.updatingDriver = false;
            }, function(errorResponse) {
                vm.updatingDriver = false;
                toastr.error('An error has occurred.');
            });
        };

        vm.removeBlacklisted = function (addToFavoriteList) {
            vm.updatingDriver = true;
            tripService.removeExcludedDriver(vm.resolvedTrip.id, vm.resolvedDriver.id).then(function(response) {
                vm.updatingDriver = false;
                if (addToFavoriteList) {
                    vm.addFavoriteDriver();
                } else {
                    vm.refreshDriverDetails();
                }
            }, function(errorResponse) {
                vm.updatingDriver = false;
                toastr.error('An error has occurred.');
            });
        };

        vm.addFavoriteDriver = function () {
            vm.updatingDriver = true;
            tripService.addFavoriteDriver(vm.resolvedTrip.id, vm.resolvedDriver.id).then(function(response) {
                vm.refreshDriverDetails();
                vm.updatingDriver = false;
            }, function(errorResponse) {
                vm.updatingDriver = false;
                toastr.error('An error has occurred.');
            });
        };

        vm.favoriteDriver = function () {
            if (vm.resolvedDriver.isRestricted) {
                vm.removeBlacklisted(true);
            } else {
                vm.addFavoriteDriver();
            }
        };

        vm.removeFavorited = function (addToExcludedList, removeFromExcludedList) {
            vm.updatingDriver = true;
            tripService.removeFavoriteDriver(vm.resolvedTrip.id, vm.resolvedDriver.id).then(function(response) {
                vm.updatingDriver = false;

                if (addToExcludedList) {
                    vm.addBlacklistDriver();
                } else if (removeFromExcludedList) {
                    vm.removeBlacklisted(false);
                } else {
                    vm.refreshDriverDetails();
                }
            }, function(errorResponse) {
                vm.updatingDriver = false;
                toastr.error('An error has occurred.');
            });
        };

        vm.addBlacklistDriver = function () {
            vm.updatingDriver = true;
            tripService.addExcludedDriver(vm.resolvedTrip.id, vm.resolvedDriver.id).then(function(response) {
                vm.updatingDriver = false;
                vm.refreshDriverDetails();
            }, function(errorResponse) {
                vm.updatingDriver = false;
                toastr.error('An error has occurred.');
            });
        };

        vm.blacklistDriver = function () {
            if (vm.resolvedDriver.isAllowed) {
                vm.removeFavorited(true);
            } else {
                vm.addBlacklistDriver();
            }
        };

        vm.standardizeDriver = function () {
            if (vm.resolvedDriver.isAllowed) {
                vm.removeFavorited(false, true);
            } else {
                if (vm.resolvedDriver.isRestricted) {
                    vm.removeBlacklisted(false);
                } else {
                    vm.refreshDriverDetails();
                }
            }
        };
    }
})();

(function () {
    'use strict';

    TripTabLogController.$inject = ["$scope", "tripService", "resolvedTrip", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('TripTabLogController', TripTabLogController);

    function TripTabLogController($scope, tripService, resolvedTrip, SYSTEM_ENUMS) {
        let vm = this;

        vm.showAudits = true;
        vm.currentTripType = resolvedTrip.systemTripTypeId;
        vm.excludeMobileGarageStates = [17]; // This is the Skipped Workflow Step state for Mobile Service
        vm.excludeMobileGarageAuditDetails = ["From: At Customer, To: Driving to Dealership"]; // This is the audit detail for the workflow step that is skipped in Mobile Service

        tripService.getTripLog(resolvedTrip.id).then((result) => {
            vm.tripAudits = result.tripAudits;
            vm.tripDispatches = result.tripDispatches;

            vm.showAudits = true;

            if (vm.currentTripType === SYSTEM_ENUMS.systemTripType.mobileGarage) {
            _.remove(vm.tripAudits, (action) => {  
                return vm.excludeMobileGarageStates.includes(action.auditAction) || vm.excludeMobileGarageAuditDetails.includes(action.detail);
            });  
            }
        });

        vm.setSelectedButton = function(showAudit) {
            vm.showAudits = showAudit;
        };      
    }
})();

(function () {
    'use strict';

    TripTabHelpController.$inject = ["$scope", "toastr", "tripService", "resolvedTrip", "ValidationService", "modalService"];
    angular
        .module('redcap.trip')
        .controller('TripTabHelpController', TripTabHelpController);

    function TripTabHelpController($scope, toastr, tripService, resolvedTrip, ValidationService, modalService) {
        let vm = this;

        vm.sentSuccessfully = false;
        vm.trip = resolvedTrip;
        vm.submitTicket = true;
        vm.helpTicket = {
            type: null,
            description: null
        };
        
        vm.issueTypes = [
                        "GETTING AN ERROR MESSAGE",
                        "COMPLAINT ABOUT DRIVER",
                        "DAMAGE CLAIM",
                        "QUESTION ABOUT HOW TO USE THE SYSTEM",
                        "QUESTION ABOUT THE SERVICE SUITE SERVICE",
                        "HAVE MY SERVICE SUITE ACCOUNT REPRESENTATIVE CONTACT ME",
                        "REQUEST VEHICLE PICTURES",
                        "RECOVER LOST ITEM",
                        "MISSING PARTS OR FAILED PARTS DELIVERY"
                        ];

        vm.getIssueDescription = function () {
            if (vm.helpTicket.type === "MISSING PARTS OR FAILED PARTS DELIVERY") {
                return "Kindly provide all relevant details regarding the delivery and the missing parts. Please also have the parts invoice available.";
            } else if (vm.isLostItemTicket()) {
                return "Provide the most accurate description of the lost item, along with the customer's name, email address, and phone number.";
            } else {
                return "ISSUE DESCRIPTION";
            }
        };

        vm.isLostItemTicket = function () {
            return vm.helpTicket.type === "RECOVER LOST ITEM";
        };

        vm.showContactDriverHelp = function () {    
            modalService.showContactDriverHelp();
        };

        vm.submitTicket = function (isValid) {
            if (new ValidationService().checkFormValidity($scope.submitHelpTicket)) {
                vm.submittingHelpTicket = true;
                tripService.submitHelpTicket(vm.trip.id, vm.helpTicket.type, vm.helpTicket.description).then((response) => {
                    vm.submittingHelpTicket = false;
                    vm.sentSuccessfully = true;
                }, (errorResponse) => {
                    toastr.error("An error has occurred submitting your help ticket.");
                    vm.submittingHelpTicket = false;
                });
            }
        };
        
    }
})();
(function () {
    'use strict';

    TripTabAuditController.$inject = ["$scope", "tripService", "resolvedTrip", "resolvedTripChildren", "resolvedWorkflow", "signalRService", "billingModalService", "permissions", "SYSTEM_ENUMS", "resolvedParams", "rcUtilService", "modalService"];
    angular
        .module('redcap.trip')
        .controller('TripTabAuditController', TripTabAuditController);

    function TripTabAuditController($scope, tripService, resolvedTrip, resolvedTripChildren, resolvedWorkflow, signalRService, billingModalService, permissions, SYSTEM_ENUMS, resolvedParams, rcUtilService, modalService) {
        let vm = this;

        vm.resolvedParams = resolvedParams;

        vm.localCreatedDate = null;
        vm.localUpdateDate = null;
        vm.localCanceledDate = null;

        vm.workflow = resolvedWorkflow;
        vm.tripChildren = resolvedTripChildren;

        vm.expandAll = vm.resolvedParams.expandAll;
        vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;

        if (vm.expandAll) {
            vm.showTimeDetails = true;
            vm.chargesVisible = true;
        } else {
            vm.showTimeDetails = vm.resolvedParams.expandTimeDetails;
            vm.chargesVisible = vm.resolvedParams.expandBillingDetails;
        }

        vm.billingPending = resolvedTrip.chargeSummary === null || resolvedTrip.chargeSummary.calculatedCharge === null;
        vm.nonEditableChargeTypes = [8, 12]; // Driver return and Incentive
        vm.dispatchSystemTypes = SYSTEM_ENUMS.dispatchSystemTypes;
        vm.currentTripType = resolvedTrip.systemTripTypeId;
        vm.excludeMobileGarageStates = [7, 8]; // Driving to dealership and At Dealership

        $scope.$on('updateTrip', (updateModel) => {
            if (updateModel.type === signalRService.events.trips.updateType.stateChange
             || updateModel.type === signalRService.events.trips.updateType.modelChange) {
                tripService.getWorkflow(resolvedTrip.id)
                           .then((updatedWorkflow) => {
                                vm.workflow = updatedWorkflow;
                                init(updateModel.trip);
                            }
                );
             }
        });

    
        function init(trip) {
            vm.trip = trip;
        
            if (vm.trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.lyft) {
                vm.providerName = 'Lyft';
            } else if (vm.trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.uber) {
                vm.providerName = 'Uber';
            }

            let jsdate = typeof trip.created.date.getMonth === 'function' ? tripService.utcToLocalJSDate(moment.utc(trip.created.date)) : tripService.utcToLocalJSDate(trip.created.date);

            vm.localCreatedDate = jsdate;

            let jsupdatedate = typeof trip.updated.date.getMonth === 'function' ? tripService.utcToLocalJSDate(moment.utc(trip.updated.date)) : tripService.utcToLocalJSDate(trip.updated.date);

            vm.localUpdateDate = jsupdatedate;

            if (vm.trip.cancelled.date) {
                let jscanceldate = typeof trip.cancelled.date.getMonth === 'function' ? tripService.utcToLocalJSDate(moment.utc(trip.cancelled.date)) : tripService.utcToLocalJSDate(trip.cancelled.date);

                vm.localCanceledDate = jscanceldate;
            }

            vm.showBilling = permissions.isRedCapAdmin() || permissions.isSysAdmin() || (permissions.hasRole(SYSTEM_ENUMS.roleNames.dealerUser) && vm.trip.isLyftTrip);
            vm.showMoreBilling = permissions.isRedCapAdmin() || permissions.isSysAdmin();

            // The billingStart/End Dates are provided in UTC, so we display that time relative to the timezone of the dealer
            if (vm.showBilling && vm.billingPending) {
                vm.billingTime = {};
                let startMoment = moment.utc(resolvedTrip.chargeSummary.estimatedStartTime).tz(trip.dealerTimeZone);

                vm.billingTime.startDate = new Date(startMoment.format('MM/DD/YYYY HH:mm'));
            }

            vm.plannedTotalSeconds = vm.workflow.plannedTotalMinutes ? vm.workflow.plannedTotalMinutes * 60 : 0;
            vm.actualTotalSeconds = vm.workflow.actualTotalMinutes ? vm.workflow.actualTotalMinutes * 60 : 0;

            //If the trip is a mobile Service trip, remove the segments that are in state "Driving to dealership" and "At Dealership"
            if (vm.isMobileGarage()) {
                _.remove(vm.workflow.segments, (seg) => {  
                    return vm.excludeMobileGarageStates.includes(seg.state);
                });  
            }

            if (vm.trip.proofOfDelivery) {
                vm.trip.proofOfDeliveryImage = 'data:image/png;base64,' + vm.trip.proofOfDelivery;
            }
        }

        vm.editTripTime = function(calculatedCharge) {
            billingModalService.setBillingTime(resolvedTrip, calculatedCharge).then((associatedCharge) => {
               calculatedCharge.customerCharge.amount = associatedCharge.customerCharge.amount;
               calculatedCharge.driverPay.amount = associatedCharge.driverPay.amount;
               vm.trip.chargeSummary.billingHistoryItems.push(associatedCharge.historyItem);
            });
        };

        vm.editCharge = function(charge) {
            billingModalService.setCharge(resolvedTrip, charge).then((associatedCharge) => {
                if (associatedCharge.deleted) {
                    vm.trip.chargeSummary.manualCharges = _.remove(vm.trip.chargeSummary.manualCharges, function(chargeToRemove) { 
                        (chargeToRemove.customerCharge && this.customerCharge.id === associatedCharge.existingChargeId) || chargeToRemove.driverPay.id === associatedCharge.existingChargeId; 
                    });
                } else {
                    let item = associatedCharge.customerCharge || associatedCharge.driverPay;

                    // Ensure the charge is set if the associated charge has a value
                    if (!charge.customerCharge)
                        charge.customerCharge = { };

                    if (!charge.driverPay)
                        charge.driverPay = { };

                    charge.customerCharge.amount = associatedCharge.customerCharge ? associatedCharge.customerCharge.amount : 0;
                    charge.driverPay.amount = associatedCharge.driverPay ? associatedCharge.driverPay.amount : 0;
                    charge.customerCharge.chargeTypeDescription = item.chargeTypeDescription;
                    charge.driverPay.chargeTypeDescription = item.chargeTypeDescription;
                }

                vm.trip.chargeSummary.billingHistoryItems.push(associatedCharge.historyItem);
            });
        };

        vm.addCharge = function() {
            billingModalService.setCharge(resolvedTrip).then((associatedCharge) => {
                if (associatedCharge) {
                    vm.trip.chargeSummary.manualCharges.push(associatedCharge);
                    vm.trip.chargeSummary.billingHistoryItems.push(associatedCharge.historyItem);
                }
            });
        };

        vm.canEditCharge = function(charge) {
            return !_.some(vm.nonEditableChargeTypes, (chargeType) => {
                return (charge.customerCharge && charge.customerCharge.chargeType === chargeType) || 
                       (charge.driverPay && charge.driverPay.chargeType === chargeType);
            });
        };

        vm.calculateTotal = function(forCustomerCharge) {
            let calculatedCharge = vm.trip.chargeSummary.calculatedCharge;

            if (forCustomerCharge) {
                vm.trip.chargeSummary.totalChargeAmount = _.sumBy(vm.trip.chargeSummary.manualCharges, (manualCharge) => {
                    return manualCharge.customerCharge ? manualCharge.customerCharge.amount : 0;
                });

                vm.trip.chargeSummary.totalChargeAmount += (calculatedCharge ? calculatedCharge.customerCharge.amount : 0);

                return vm.trip.chargeSummary.totalChargeAmount;
            } else if (calculatedCharge.driverPay) {
                vm.trip.chargeSummary.totalDriverPayAmount = _.sumBy(vm.trip.chargeSummary.manualCharges, (manualCharge) => {
                    return manualCharge.driverPay ? manualCharge.driverPay.amount : 0;
                });

                vm.trip.chargeSummary.totalDriverPayAmount += (calculatedCharge ? calculatedCharge.driverPay.amount : 0);

                return  vm.trip.chargeSummary.totalDriverPayAmount;
            }
        };

        vm.calculateBillingTime = function() {

            if (!vm.billingTime.startDate || !vm.billingTime.endDate) return;

            if (vm.billingTime.startDate > vm.billingTime.endDate) {
                vm.validationMsg = 'Start Date must be before End Date';

                return;
            }

            vm.validationMsg = null;

            vm.processingBilling = true;
            tripService.calculateBillingTime(vm.trip.id, vm.billingTime.startDate, vm.billingTime.endDate).then((updatedBilling) => {
                vm.billingTime.customerChargeAmount = updatedBilling.totalChargeAmount;
                vm.billingTime.driverPayAmount = updatedBilling.totalPayAmount;

                vm.billingTime.totalDuration = moment(vm.billingTime.endDate).diff(vm.billingTime.startDate, 'seconds');

                vm.processingBilling = false;
            }, (err) => {
                vm.processingBilling = false;
                console.error('There was an issue calculating billing times', err);
            });
        };

        vm.completeTrip = function() {
            vm.processingBilling = true;

            // Here, the date and time are correct, but the offset is wrong, because the browser forces it to "local time,"
            //  so we want to force the offset to be in the dealer timezone (without adjusting the actual date and time),
            //  then convert that to UTC.
            let utcStart = billingModalService.convertToTimezoneUtc(vm.billingTime.startDate, resolvedTrip.dealerTimeZone);
                let utcEnd =  billingModalService.convertToTimezoneUtc(vm.billingTime.endDate, resolvedTrip.dealerTimeZone);

            tripService.completeTrip(resolvedTrip.id, utcStart, utcEnd, vm.billingTime.comment).then((response) => {
                vm.trip.chargeSummary.billingHistoryItems.push(response.historyItem);
                vm.trip.chargeSummary.calculatedCharge = response.calculatedCharge;
                vm.processingBilling = false;
                vm.billingPending = false;
                vm.chargesVisible = true;
            });
        };

        vm.showTimeDetailDiv = function () {
            vm.showTimeDetails = true;
        };

        vm.hideTimeDetailDiv = function () {
            vm.showTimeDetails = false;
        };

        vm.getRODisplayText = function (data) {
            let displayText = rcUtilService.getRODisplayText(data.roNumber);

            if (displayText) {
                return ' <span class="black">RO</span> #' + displayText;
            } else {
                return null;
            }
            
        };

        vm.isMobileGarage = function () {
            return vm.currentTripType === SYSTEM_ENUMS.systemTripType.mobileGarage;
        };

        vm.openImageModal = function (url) {
            modalService.showImageViewer(url, "Proof Of Delivery", vm.mediaTypes.image, null, null, true);
        };

        init(resolvedTrip);
    }
})();

(function () {
    'use strict';

    TripMainController.$inject = ["$scope", "$rootScope", "$timeout", "$filter", "authService", "permissions", "tripService", "modalService", "localStorageService", "resolvedSystemTripTypes", "resolvedAllowedTripTypes", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('TripMainController', TripMainController);

    function TripMainController($scope, $rootScope, $timeout, $filter, authService, permissions, tripService, modalService, localStorageService, resolvedSystemTripTypes, resolvedAllowedTripTypes, SYSTEM_ENUMS) {
        let vm = this;
            let transportationModeEnum = SYSTEM_ENUMS.transportationViewModeEnum;

        vm.isSysAdmin = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        vm.availTripModes = SYSTEM_ENUMS.transportationViewModes;
        vm.resolvedSystemTripTypes = resolvedSystemTripTypes;
        vm.resolvedAllowedTripTypes = resolvedAllowedTripTypes;
        vm.shortSystemTripType = SYSTEM_ENUMS.systemTripType;
        vm.transportationViewMode = null;
        vm.selectedViewModeIcon = null;
        vm.previouslySelectedIcon = null;

        vm.isFramedIn = function () { return authService.isFramedIn(); };
        
        vm.canManageCredits = _.some(vm.resolvedAllowedTripTypes, (tripType) => {
            return tripType === vm.shortSystemTripType.lyftCredit;
        });

        vm.getExperienceMode = function() {
            let lastToggleState = localStorageService.get('experiences-mode');
                let viewMode;

            // Map mode from possible previous values (before the "enum" was created)
            switch (lastToggleState) {
                case 'trip-list-nomap':
                    viewMode = transportationModeEnum.trip_list_no_map;
                break;

                case 'trip-list':
                    viewMode = transportationModeEnum.trip_list_with_map;
                break;

                case 'manage-credits':
                    viewMode = transportationModeEnum.credits_list;
                break;

                default:
                    if (lastToggleState) {
                        viewMode = lastToggleState;
                    } else {
                        viewMode = transportationModeEnum.trip_list_with_map;
                    }
            }

            return viewMode;
        };

        vm.setViewMode = function () {
            vm.transportationViewMode = vm.getExperienceMode();
            vm.selectedViewModeIcon = $filter('filter')(vm.availTripModes, {value: vm.transportationViewMode}, true)[0];
            vm.previouslySelectedIcon = vm.selectedViewModeIcon;
        };

        function setTripListState() {
            vm.setViewMode();

            if (vm.transportationViewMode !== transportationModeEnum.credits_list) {
                vm.tripList = true;
            } else {
                vm.tripList = false;
            }
        }

        $scope.$on('tripListModeUpdated', (event, data) => {
            setTripListState();
        });

        vm.handleListModeUpdated = function () {
            let selectedMode = vm.selectedViewModeIcon;
            
            if (selectedMode.value === transportationModeEnum.credits_list &&
                vm.canManageCredits === false) {
                    modalService.showHelpModal(null, "LO", 'LOANER ON DEMAND (RIDESHARE CREDITS)', 'Need to keep your customer\'s car a little longer?  No loaners available?  Give your customer flexibility by issuing Rideshare Credits right from the dash.  Contact Client Success or your account manager and start sharing Credits today.', true);
                    vm.selectedViewModeIcon = vm.previouslySelectedIcon;
            } else {
                localStorageService.set('experiences-mode', selectedMode.value);
                $timeout(() => {
                    if (vm.transportationViewMode === transportationModeEnum.credits_list) {
                        $rootScope.$broadcast('tripListModeUpdated');
                    } else {
                        $rootScope.$broadcast(selectedMode.broadcastEvent);
                    }
                }, 1);
                vm.previouslySelectedIcon = vm.selectedViewModeIcon;
            }
        };

        $rootScope.$on('tripListModeChanged', (event, data) => {
            vm.handleListModeUpdated();
        });

        function init() {

            // what items need to be removed if not an admin
            if (vm.isSysAdmin === false) {
                tripService.removeItemFromDispatchModes(vm.availTripModes, transportationModeEnum.dispatch_list);
            }
    
            // what items need to be hidden when framed in
            if (vm.isFramedIn()) {
                let hideList = $filter('filter')(vm.availTripModes, {hideFramedIn: true}, true);

                if (hideList && hideList.length > 0) {
                    _.forEach(hideList, (modeToHide) => {
                        tripService.removeItemFromDispatchModes(vm.availTripModes, modeToHide.value);
                    });
                }
            }

            setTripListState();
    
        }
        

        init();
    }
})();

(function () {
    'use strict';

    TripListController.$inject = ["$q", "$compile", "$scope", "$timeout", "$filter", "$state", "$transitions", "$location", "$anchorScroll", "$interval", "$rootScope", "SAVED_SEARCHES_PLACEHOLDER", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "searchTemplateUtilService", "permissions", "rcLocalStorageService", "locationService", "mapObjectFactory", "webworkerService", "tripService", "rcUtilService", "systemService"];
    angular
        .module('redcap.trip')
        .controller('TripListController', TripListController);

    function TripListController($q, $compile, $scope, $timeout, $filter, $state, $transitions, $location, $anchorScroll, $interval, $rootScope, SAVED_SEARCHES_PLACEHOLDER, SYSTEM_ENUMS, HERE_MAPS_CONFIG,
            searchTemplateUtilService, permissions, rcLocalStorageService, locationService, mapObjectFactory, webworkerService, tripService, rcUtilService, systemService) {

        let vmList = this;

        vmList.sortByType = {
            customerArrival: 1,
            lastStop: 2,
            bookedBy: 3,
            status: 4,
            alerts: 5,
            firstStop: 6,
            tripType: 12,
            driver: 13,
            customerName: 15
        };

        let singleLocationElemId = "#location-filter-single";
        let singleLocationElemDlgId = "#location-filter-single-dlg";                    
        let highlightedTripElem = undefined;
        let displayLimit = 30;
        let ignoreListReload = false;
        let _map = null;
        let _selectedTripId = null;
        let _select2DataId = 68; // This seems arbitrary, but is from a previous commit and in order to prevent breaking something I'm keeping it as-is for now.
        let _autoRefreshInterval;
        let _autoRefreshCountDown;
        let AUTOREFRESH_DURATION = 15000;
        let searchTemplateType = SYSTEM_ENUMS.searchTemplateTypes.trip;
        let clusteringLayer = null;
        let defaultDateRange = {
            startDate: moment(new Date()),
            endDate: moment(new Date())
        };

        let initialFilters = { 
            timeframeFilter: 0,
            locationFilter: [],
            programFilter: [],
            tripStatusFilter: [],
            userFilter: [],
            tripTypeFilter: [],
            loanerFilter: null,
            driverFilter: '',
            driverFilterUnassigned: false,
            customerFilter: '',
            forceTimeFilter: false,
            dnsOnlyFilter: false,
            driverProgramFilter: [],
            includeTestTripsFilter: true,
            keywordFilter: null,
            customTimeframe: defaultDateRange,
            selectedSingleLocationId: null,
            singleLocation: null
        };

        let initialSort = {
            sortDirection: 'asc',
            sortBy: vmList.sortByType.customerArrival
        };

       
        let savedFilterKey = "tripsListSavedFilterKey";
        let savedTemplateKey = "tripsListSavedTemplateKey";
        let savedSortKey = "tripListSavedSortKey";
        let savedDispatchSortKey = "tripDispatchListSavedSortKey";
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};
        let existingSort = rcLocalStorageService.get(savedSortKey);
        let existingDispatchSort = rcLocalStorageService.get(savedDispatchSortKey);
        
            
        vmList.dealerListInitialized = false;
        vmList.hasMultipleDealers = true;
        vmList.checkboxFilters = {
            tripStatusCheckboxFilter: [],
            programCheckboxFilter: [],
            driverProgramCheckboxFilter: [],
            tripTypeCheckboxFilter: [],
            locationCheckboxFilter: []
        };
        
        vmList.showAdvancedSearch  = false;
        vmList.parent_vm = $scope.$parent.vm;
        vmList.tripWorkflowTypes = SYSTEM_ENUMS.tripWorkflowTypes;
        vmList.useTripNameOverrides = SYSTEM_ENUMS.useTripNameOverrides;
        vmList.creditsIconBusy = false;
        vmList.resolvedSystemTripTypes = vmList.parent_vm.resolvedSystemTripTypes;
        vmList.resolvedAllowedTripTypes = vmList.parent_vm.resolvedAllowedTripTypes;
        vmList.healthStatus = SYSTEM_ENUMS.healthStatus;
        vmList.selectedInvoices = [];
        vmList.viewModes = SYSTEM_ENUMS.transportationViewModeEnum;
        vmList.mapOptions = {
            showSegmentOverlay: true,
            fillHeight: true,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: true,
            showControls: true,
            showInfoWindows: true
        };

        vmList.activeLocationsForMap = null;
        vmList.loadingLocations = false;
        vmList.sortFilterTrip = false;

        // These values are stored in a shared enum on the server, so the values start at 7.
        vmList.dispatchSortTypes = {
            tripId: 7,
            pickupTime: 8,
            customerEta: 9,
            dateCreated: 10,
            status: 4,
            account: 11,
            tripType: 12,
            driver: 13,
            driverCell: 14,
            customerName: 15,
            pickupAddress: 16,
            pickupCity: 17,
            state: 18,
            estPay: 19,
            estCharge: 20
        };

        vmList.checkboxFilterSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            idProp: 'value',
            displayProp: 'text',
            buttonClasses: 'ellipsis-overflow'
        };

        vmList.programFilterSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            idProp: 'id',
            displayProp: 'name',
            buttonClasses: 'ellipsis-overflow'
        };

        vmList.tripStatusFilterStrings = {
            buttonDefaultText: 'Status'
        };

        vmList.programFilterStrings = {
            buttonDefaultText: 'All programs'
        };

        vmList.driverProgramFilterStrings = {
            buttonDefaultText: 'All DNS Programs'
        };

        vmList.tripTypeFilterStrings = {
            buttonDefaultText: 'All trip types'
        };

        vmList.getDispatchSortDir = function () { 
            return vmList.dispatchSortAsc ? 'asc' : 'desc';
        };

        locationService.getDriverPrograms().then((programs) => {
            vmList.driverPrograms = programs;
        });

        vmList.searchBtnClicked = function () {
            vmList.runQuery();
        };
        
        function setTripListState() {
            vmList.displayMap = vmList.parent_vm.transportationViewMode === vmList.viewModes.trip_list_with_map;

            if (vmList.displayMap === true && !vmList.activeLocationsForMap) {
                locationService.getActiveDealersMinimalData(false, SYSTEM_ENUMS.permissionTypes.transportation).then((result) => {
                    vmList.activeLocationsForMap = result;

                    if (_map) {
                        addDealerClusterLayer();
                    } else {
                        $timeout(() => {
                            addDealerClusterLayer();
                        }, 750);
                    }
                });
            } else {
                clusteringLayer = null;
            }
        }

        $scope.$on('tripListMapModeUpdated', (event, data) => {
            let changeMode = function () {
                vmList.parent_vm.setViewMode();
                setTripListState();

                $timeout(() => {
                    updateList(vmList.ignoreFilters, vmList.showAll);
                }, 1);
            };
            
            if (vmList.showAdvancedSearch === true) {
                // must do this so the map and table 
                // draw correctly
                vmList.showAdvancedSearch = false;
                $timeout(() => {
                    changeMode();
                }, 1);
            } else {
                changeMode();
            }
        });

        setTripListState();

        vmList.tripListModeChanged = function () {
            vmList.showAdvancedSearch = false;
            vmList.parent_vm.handleListModeUpdated();
        };

        vmList.resolvedLocationList = null;
        vmList.isSysAdmin = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        vmList.canManageGlobalTemplates = permissions.isDeveloper() || permissions.isSysAdmin();
        searchTemplateUtilService.initSearchTemplateData(vmList);
        vmList.selectedQueryCount = -1;
        vmList.isGlobalTemplate = false;
        vmList.shortSystemTripType = SYSTEM_ENUMS.systemTripType;
        
        vmList.timeframes = [
            {value: 10, text: 'Last 60 days'},
            {value: 5, text: 'Last 30 days'},
            {value: 4, text: 'Last 7 days'},
            {value: 8, text: 'Yesterday'},
            {value: 0, text: 'Today'},
            {value: 6, text: 'Tomorrow'},
            {value: 7, text: 'Today and Tomorrow'},
            {value: 1, text: 'Next 7 days'},
            {value: 2, text: 'Next 30 days'},
            {value: 9, text: 'Next 60 days'},
            {value: 3, text: 'Custom...'}
        ];

        vmList.tripStatuses = [
            {value: 0, text: 'Pending'},
            {value: 1, text: 'In Progress'},
            {value: 2, text: 'Completed'},
            {value: 3, text: 'Unhealthy'},
            {value: 4, text: 'Canceled'}
        ];

        vmList.defaultTripStatuses = [0, 1, 3]; // all but completed and canceled

        vmList.displayLimit = displayLimit;
        vmList.alertCount = 0;
        vmList.isLoading = false;
        vmList.showingAlerts = false;
       
        function addDealerClusterLayer() {
            if (!vmList.activeLocationsForMap) return;

            if (!vmList.dealerDataPoints) {
                let dataPoints = [];

                _.forEach(vmList.activeLocationsForMap, (loc) => {
                    dataPoints.push(new H.clustering.DataPoint(loc.lat, loc.lng, null, loc));
                });

                vmList.dealerDataPoints = dataPoints;
            }
            
            if (!clusteringLayer) {
                clusteringLayer = _map.addClusters(vmList.dealerDataPoints);
                _map.setCenter({lat: 39.8283, lng: -98.5795});
                _map.setZoom(4);
            }

            $timeout(() => {
                _map.refresh();
            }, 1);
        }

        function showDealers() {
            if (vmList.parent_vm.transportationViewMode === vmList.viewModes.trip_list_no_map) {
                return;
            }

            if (_map) {
                _map.clearMap();

                if (!vmList.dealerDataPoints) {
                    if (vmList.isSysAdmin) {
                        addDealerClusterLayer();
                    } else {
                        if (vmList.isLocationListEmpty() === false) {
                            let points = vmList.resolvedLocationList.map((dealer) => {
                                return mapObjectFactory.createCustomHereMarker(dealer, HERE_MAPS_CONFIG.markerTypes.dealer);
                            });

                            $timeout(() => {
                                _map.updateMarkers(points);
                            }, 1);
                        }
                    }
                } else {
                    if (vmList.isSysAdmin) {
                        // this is called when switching back and
                        // forth between map modes... need the timeout so the
                        // map code can initialize first.
                        $timeout(() => {
                            addDealerClusterLayer();
                        }, 1);
                    }
                }
            }
        }

        function hideDealers() {
            if (clusteringLayer) {
               _map.removeClusters();
               clusteringLayer = null;
            }
        }

        function runQueryIfLocationsChanged () {
            if (_.isEqual(vmList.previousLocationFilter, vmList.filters.locationFilter) === false) {
                vmList.listFilterChanged();
            }
        }

        vmList.mapLoaded = function (mapActions) {
            _map = mapActions;
            _map.setZoom(4);

            if (!_selectedTripId) {
                showDealers();
            }
        };
        
        function formatTrip(trip) {
            if (vmList.searchFilter.forDispatch) {
                trip.customerExpectedTime = tripService.utcToLocalJSDate(trip.customerExpectedTimeUtc);
                trip.expectedStartTime = tripService.utcToLocalJSDate(trip.expectedStartTime);
                trip.dateCreated = tripService.utcToLocalJSDate(trip.dateCreated);
            } else {
                trip.apptTime = tripService.utcToLocalJSDate(trip.apptDate);
                trip.customerExpectedTime = tripService.utcToLocalJSDate(trip.customerExpectedTimeUtc);
                let tmp = $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: trip.systemTripTypeId})[0];

                if (trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.lyft || trip.rideProviderType === SYSTEM_ENUMS.rideProviderType.uber) {
                    trip.icon = null;
                    trip.badgeText = tmp.badgeText;
                } else if (tmp) {
                    trip.icon = tmp.icon;
                    trip.badgeText = tmp.badgeText;
                }

                trip.typeName = SYSTEM_ENUMS.useTripNameOverrides && tmp.overrideName ? tmp.overrideName : trip.typeName;
                trip.health.color = trip.health.status <= vmList.healthStatus.ok ? '' : mapObjectFactory.getStatusColor(trip.health.status);

                return trip;
            }
        }

        function saveFilterSettings() {
            rcLocalStorageService.set(savedFilterKey, vmList.filters);
            rcLocalStorageService.set(savedTemplateKey, vmList.templateName);
        }

        function deselectLocation () {
            vmList.filters.singleLocation = null;
            vmList.filters.selectedSingleLocationId = null;
            vmList.filters.locationFilter = [];
            vmList.listFilterChanged();
        }

        function setupDeselectLocation () {
            $(singleLocationElemId).on('select2:unselect', (e) => {
                deselectLocation();
            });

            $(singleLocationElemDlgId).on('select2:unselect', (e) => {
                deselectLocation();
            });

            $(singleLocationElemId).on('select2:clear', (e) => {
                deselectLocation();
            });

            $(singleLocationElemDlgId).on('select2:clear', (e) => {
                deselectLocation();
            });
        }

        function updateDirtyFlag() {
            if (vmList.searchTemplateData.currentSearchTemplate) {
                vmList.searchTemplateData.isTemplateDirty = true;
            }
        }


        vmList.getBookedByToolTip = function (data) {
            return data.created && data.created.firstName ? 'BOOKED BY ' + data.created.firstName + ' ' + data.created.lastName
                : data.bookingSource + ' BOOKED';
        };

        vmList.getStatusText = function (status, verbose) { return tripService.getStatusText(status, verbose); };

        vmList.tripWorkFlowHasLoaner = function (record) {
            return tripService.tripWorkFlowHasLoaner(record);
        };

        vmList.displayMore = function () {
            if (!vmList.isLoadingMore && !vmList.isLoading && vmList.canLoadMore) {
                vmList.isLoadingMore = true;
                vmList.searchFilter.page += 1;
                getTrips().finally(() => {
                    vmList.isLoadingMore = false;
                });
            }
        };

        vmList.timeframeChanged = function () {
            if (vmList.filters.timeframeFilter === 3) {
                $timeout(() => {
                    $('#timeframe_range').data('daterangepicker').toggle();
                }, 1);
            }

            vmList.listFilterChanged();
        };

        vmList.statusFilterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();
                vmList.filters.tripStatusFilter = vmList.checkboxFilters.tripStatusCheckboxFilter && vmList.checkboxFilters.tripStatusCheckboxFilter.length > 0 ? vmList.checkboxFilters.tripStatusCheckboxFilter.map(x => x.id).join(",").split(',').map(Number) : [];
            }, 1);
        };

        vmList.programFilterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();
                vmList.filters.programFilter = vmList.checkboxFilters.programCheckboxFilter && vmList.checkboxFilters.programCheckboxFilter.length > 0 ? vmList.checkboxFilters.programCheckboxFilter.map(x => x.id).join(",").split(',') : [];
            }, 1);
        };

        vmList.driverProgramFilterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();
                vmList.filters.driverProgramFilter = vmList.checkboxFilters.driverProgramCheckboxFilter && vmList.checkboxFilters.driverProgramCheckboxFilter.length > 0 ? vmList.checkboxFilters.driverProgramCheckboxFilter.map(x => x.id).join(",").split(',').map(Number) : [];
            }, 1);
        };

        vmList.tripTypeFilterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();
                vmList.filters.tripTypeFilter = vmList.checkboxFilters.tripTypeCheckboxFilter && vmList.checkboxFilters.tripTypeCheckboxFilter.length > 0 ? vmList.checkboxFilters.tripTypeCheckboxFilter.map(x => x.id).join(",").split(',').map(Number) : [];
            }, 1);
        };

        vmList.showFakeLocationInput = function () {
           
            if (vmList.filters.singleLocation && vmList.filters.locationFilter.length === 1) {
                return false;
            }

            if (vmList.isLocationListEmpty() === true || (vmList.filters.locationFilter && vmList.filters.locationFilter.length > 1)) {
                return true;
            }

            return false;
        };

        vmList.addLocationToFilter = function (locId) {
            vmList.previousLocationFilter = _.cloneDeep(vmList.filters.locationFilter);
            let locToAdd = parseInt(locId);
         
            if (!_.includes(vmList.filters.locationFilter, locToAdd)) {
               vmList.filters.locationFilter.push(locToAdd);
            }

            if (vmList.filters.locationFilter.length === 1) {
                vmList.filters.singleLocation = $filter('filter')(vmList.resolvedLocationList, {id: parseInt(vmList.filters.locationFilter[0])}, true)[0];
                setupDeselectLocation();
            }

            vmList.listFilterChanged();
        };

        // fired from the location selection box allowing for multiple location selections in advanced filters
        vmList.multipleLocationSelected = function () {
            if (vmList.filters.locationFilter && vmList.filters.locationFilter.length === 1) {
                let singleLoc = $filter('filter')(vmList.resolvedLocationList, {id: parseInt(vmList.filters.locationFilter[0])}, true)[0];
                let locationFilterDlg = $(singleLocationElemDlgId);
                
                vmList.filters.singleLocation = singleLoc;
                vmList.filters.selectedSingleLocationId = singleLoc.id;
                $timeout(() => {
                    setupDeselectLocation();
                    vmList.triggeredSelect2Select = true;
                    locationFilterDlg.select2("trigger", "select", {
                        data: singleLoc
                    });
                    
                }, 250);
            } else if (vmList.filters.locationFilter && vmList.filters.locationFilter.length === 0) {
                vmList.clearAllLocations();
            }

            getNoLocationLoadedText();
        };
            
        vmList.statusFilterEvents = {
            onSelectionChanged: function () {
                vmList.statusFilterChanged();
            }
        };

        vmList.programFilterEvents = {
            onSelectionChanged: function () {
                vmList.programFilterChanged();
            }
        };

        vmList.driverProgramFilterEvents = {
            onSelectionChanged: function () {
                vmList.driverProgramFilterChanged();
            }
        };

        vmList.tripTypeFilterEvents = {
            onSelectionChanged: function () {
                vmList.tripTypeFilterChanged();
            }
        };

        vmList.getMapDetails = function (trip, element) {
            if (!vmList.displayMap) return;

            if (!trip) {
                return;
            }

            if (_selectedTripId === trip.id) return;

            _selectedTripId = trip.id;
            hideDealers();

            highlightedTripElem = element;
            if (_map) _map.setLoading(trip);
            tripService.getTrip(trip.id).then((latestTrip) => {
                let tripIdx = _.findIndex(vmList.filteredTrips, {id: latestTrip.id});

                if (tripIdx !== -1) {
                    vmList.filteredTrips[tripIdx] = formatTrip(latestTrip);
                }

                _map.setZoom(4);
                _map.updateMap(latestTrip);
            });
        };

        vmList.goToTripDetails = function ($evt, tripId) {
            // Prevent the parent "click" from happening (which would load the trip on the map on the trip list) by stopping propagation
            $evt.stopPropagation();
            $state.go('trip-tab-trip', {tripId: tripId, locationList: vmList.activeLocationsForMap});

            // Stop updating the map on the trip list while the trip detail aside is open.
            _map.stopDriverUpdates();
            _selectedTripId = tripId;
        };

        $transitions.onSuccess({}, (trans) => {
            let toState = trans.$to().name;
            let fromState = trans.$from().name;

            if (_map) {
                if (toState === 'trip-list') {
                    let lastSelectedTripId = _selectedTripId;

                    _selectedTripId = null;

                    if (vmList.displayMap && lastSelectedTripId) {
                        let tripEl = angular.element('#' + lastSelectedTripId);

                        if (tripEl) {
                            // The event handler will run outside of the current apply cycle without a timeout.  
                            //  The timeout ensures the click happens right away.
                            $timeout(() => { tripEl.triggerHandler('click'); }, 1);
                        }
                    }                   
                } else if (fromState === 'trip-list') {
                    _map.alterGroupItems();
                }
            }

            if (vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list) {
                if (vmList.autoRefresh && toState === 'trip-list')
                    setRefreshInterval();
                else
                    clearRefreshInterval();
            }
        });

        vmList.isDispatchList = function () {
            return vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list;
        };

        vmList.isHighlightedRow = function (element) {
            if (!highlightedTripElem) return false;

            return element.$id === highlightedTripElem.$id;
        };

        vmList.sortBy = function (sortType) {
            vmList.sortFilterTrip = true;

            if (vmList.sortData.sortBy === sortType) {
                vmList.sortData.sortDirection = vmList.sortData.sortDirection === 'asc' ? 'desc' : 'asc';
            }

            vmList.sortData.sortBy = sortType;

            vmList.saveSort();

            switch (sortType) {
                case vmList.sortByType.alerts:
                    vmList.showingAlerts = !vmList.showingAlerts;
                    break;
            }

            updateList(vmList.ignoreFilters, vmList.showAll);
        };

        vmList.setDispatchSort = function (type) {
            if (vmList.dispatchSortType !== type || vmList.dispatchSortAsc === false)
                vmList.dispatchSortAsc = true;
            else
                vmList.dispatchSortAsc = false;

            vmList.dispatchSortType = type;
            vmList.saveSort();
            updateList(vmList.ignoreFilters, vmList.showAll);
        };

        vmList.isLocationListEmpty = function () {
            return vmList.dealerListInitialized === false || vmList.resolvedLocationList === null || 
                    (vmList.resolvedLocationList && vmList.resolvedLocationList.length === 0);
        };

        function selectLocationForTemplate (locationToSelect, advancedSearch) {
            let currentLocationSelection = _.cloneDeep(vmList.filters.locationFilter);

            $timeout(() => {
                if (locationToSelect) {
                    setupDeselectLocation();
                    vmList.filters.selectedSingleLocation = locationToSelect;
                    vmList.filters.selectedSingleLocationId = locationToSelect.id;
                    vmList.addLocationToFilter(locationToSelect.id);
                    triggerSelect2LoctionSelection();
                } else if (currentLocationSelection && currentLocationSelection.length > 0) {
                    vmList.filters.locationFilter = currentLocationSelection;
                }

                $timeout(() => {
                    vmList.dealerListInitialized = true; 
                    vmList.loadingLocations = false;

                    if (advancedSearch) {
                        triggerSelect2LoctionSelection();
                    }
                }, 1);
            }, 250);
        }

        vmList.getDealerLocations = function (advancedSearch, locationIdToSelect) {
            let locationToSelect = null;

            if (vmList.dealerListInitialized === false && vmList.loadingLocations !== true) { 
                vmList.loadingLocations = true;     
                locationService.getLocationsForTripListDropDown(true, false, SYSTEM_ENUMS.permissionTypes.transportation).then((result) => {
                    locationService.addTooltipInfoToLocations(vmList, result);
                    vmList.resolvedLocationList = result;

                    setupDeselectLocation();

                    if (locationIdToSelect) {
                        locationToSelect = vmList.filters.singleLocation = $filter('filter')(vmList.resolvedLocationList, {id: parseInt(vmList.filters.locationFilter[0])}, true)[0];
                    } else if (vmList.resolvedLocationList.length > 0 && 
                        vmList.hasMultipleDealers === false &&
                        result && result.length > 0) {
                        // if they only have one dealer, just select it 
                        locationToSelect = result[0];
                    } 
                    
                    selectLocationForTemplate(locationToSelect, advancedSearch);
                });
            } else if (locationIdToSelect) {
                locationToSelect = vmList.filters.singleLocation = $filter('filter')(vmList.resolvedLocationList, {id: parseInt(vmList.filters.locationFilter[0])}, true)[0];
                selectLocationForTemplate(locationToSelect, advancedSearch);
            } else if (advancedSearch) {
                triggerSelect2LoctionSelection();
            }
        };

        vmList.locationSearchQuery = {
            type: 'GET',
            dataType: 'json',
            data: function (parameters) {
                let query = {
                    search: parameters.term,
                    page: parameters.page,
                    pageSize: 5000
                };

                return query;
            },
            transport: function (params, success, failure) {
                let data = params.data;

                if (data.search && data.search.length > 0) {
                    return webworkerService.filter(vmList.resolvedLocationList, data.search, false, 'name').then(success, failure);
                } else {
                    return vmList.resolvedLocationList;
                }
            },
            delay: 250,
            processResults: function (data) {
                return {
                    results: data,
                    pagination: {
                        more: data.length === 5000
                    }
                };
            }
        };

        vmList.formatLocationForSelection = function (item) {
            return item.name;
        };

        vmList.formatLocationForDropdown = function (item) {
            if (item.html) {
                let option = $(item.html);

                $compile(option.contents())($scope);

                return option;
            } else {
                return item.name;
            }
        };

        vmList.clearLocationFilter = function () {
            vmList.previousLocationFilter = _.cloneDeep(vmList.filters.locationFilter);
            vmList.filters.locationFilter = [];
            getNoLocationLoadedText();
            runQueryIfLocationsChanged();
        };

        vmList.clearAllLocations = function () {
            rcLocalStorageService.set(savedTemplateKey, null);
            searchTemplateUtilService.clearSearchTemplate(vmList);
            vmList.clearLocationFilter();
            $timeout(() => {
                let locationFilter = $(singleLocationElemId);
                let locationFilterDlg = $(singleLocationElemDlgId);
                let chosenFilter = $("#locationListFilter");
                let chosenFilterMobile = $("#locationListFilterMobile");

                $timeout(() => {
                    chosenFilter.val('').trigger('chosen:updated');
                    chosenFilterMobile.val('').trigger('chosen:updated');
                    locationFilter.val(null).trigger('change');
                    locationFilterDlg.val(null).trigger('change');
                }, 1);
            }, 1);
        };

        vmList.clearUserFilter = function () {
            $timeout(() => {
                let $search = angular.element('#userFilter');

                $search.val('').trigger('change');
            });
        };

        vmList.selectSingleLocation = function (item) {
            if (item.length === 0 || !item[0].name || item[0].name.length === 0) return;

            vmList.previousLocationFilter = _.cloneDeep(vmList.filters.locationFilter);

            if (vmList.triggeredSelect2Select === true) {
                // this is the case where it was triggered from the multi select
                vmList.triggeredSelect2Select = false;
                runQueryIfLocationsChanged();

                return;
            }

            if (item && item.length > 0) {
                vmList.addLocationToFilter(item[0].id);
            } 
        };

        vmList.toggleShowSearchOptions = function () {
            vmList.searchTemplateBeforeAdvancedSearch = _.cloneDeep(vmList.searchTemplateData);
            vmList.filtersBeforeAdvancedSearch  = _.cloneDeep(vmList.filters);
            vmList.checkboxFiltersBeforeAdvancedSearch = _.cloneDeep(vmList.checkboxFilters);

            let searching = false;

            if (vmList.showAdvancedSearch) {
                searching = true;
                vmList.runQuery();
            }

            vmList.showAdvancedSearch = !vmList.showAdvancedSearch;

            if (vmList.showAdvancedSearch) {

                vmList.getDealerLocations(true);

                if (vmList.autoRefresh) {
                    vmList.previousAutoRefresh = vmList.autoRefresh;
                    clearRefreshInterval();
                }
            }
        };

        vmList.setDefaultStatusFilters = function () {
            vmList.filters.tripStatusFilter = vmList.defaultTripStatuses;
            setCheckboxesFromFilters();
        };

        vmList.loadSearchTemplate = function (item, model) {
            let loadTheTemplate = function () {
                if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                    let template = _.cloneDeep(item.template);
                    
                    vmList.searchTemplateData.isTemplateDirty = false;
                    vmList.searchTemplateData.currentSearchTemplate = item;
                    vmList.searchTemplateData.savedSearchName = template.templateName;
                    vmList.filters.locationFilter = template.locationFilter;

                    if (vmList.filters.locationFilter && vmList.filters.locationFilter.length === 1) {
                        vmList.filters.selectedSingleLocationId = vmList.filters.locationFilter[0];
                    }

                    vmList.getDealerLocations(false, vmList.filters.selectedSingleLocationId);
                    vmList.filters.programFilter = template.programFilter;
                    vmList.filters.tripTypeFilter = template.tripTypeFilter;
                    vmList.filters.tripStatusFilter = template.tripStatusFilter;

                    if (!vmList.filters.tripStatusFilter || vmList.filters.tripStatusFilter.length === 0) {
                        vmList.setDefaultStatusFilters();
                    }

                    vmList.filters.timeframeFilter = template.timeframeFilter;
                    vmList.filters.userFilter = template.userFilter;
                    vmList.filters.loanerFilter = template.loanerFilter;
                    vmList.filters.customTimeframe = template.customTimeframe || defaultDateRange;
                   
                    if (vmList.filters.customTimeframe && vmList.filters.customTimeframe.endDate) {
                        if (!moment.isMoment(vmList.filters.customTimeframe.endDate)) {
                            vmList.filters.customTimeframe.endDate = moment(vmList.filters.customTimeframe.endDate);
                        }
                    }

                    if (vmList.filters.customTimeframe && vmList.filters.customTimeframe.startDate) {
                        if (!moment.isMoment(vmList.filters.customTimeframe.startDate)) {
                            vmList.filters.customTimeframe.startDate = moment(vmList.filters.customTimeframe.startDate);
                        }
                    }

                    vmList.filters.keywordFilter = template.keywordFilter;
                    vmList.templateName = template.templateName;
                    vmList.isGlobalTemplate = item.isGlobal;
                    vmList.filters.customerFilter = template.customerFilter || '';
                    vmList.filters.driverFilter = template.driverFilter || '';
                    vmList.filters.driverFilterUnassigned = template.driverFilterUnassigned || false;
                    vmList.filters.dnsOnlyFilter = template.dnsOnlyFilter || false;
                    vmList.filters.driverProgramFilter = template.driverProgramFilter;
                    vmList.filters.includeTestTripsFilter = template.includeTestTripsFilter || true;
                    saveFilterSettings();
                    setCheckboxesFromFilters();
                    getNoLocationLoadedText();
                    updateList();
                } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                    rcLocalStorageService.set(savedTemplateKey, null);
                    searchTemplateUtilService.clearSearchTemplate(vmList);
                    resetFilters();
                    updateList();
                } else {
                    rcLocalStorageService.set(savedTemplateKey, null);
                    searchTemplateUtilService.clearSearchTemplate(vmList);
                }
            };

            if (vmList.filters.locationFilter.length > 0 || vmList.filters.singleLocation) {
                vmList.filters.locationFilter = [];
                vmList.filters.singleLocation = null;
                vmList.filters.selectedSingleLocationId = null;
                $timeout(() => {
                    let locationFilter = $(singleLocationElemId);
                    let locationFilterDlg = $(singleLocationElemDlgId);

                    $timeout(() => {
                        locationFilter.val(null).trigger('change');
                        locationFilterDlg.val(null).trigger('change');
                        loadTheTemplate();
                    }, 1);
                }, 1);
            } else {
                loadTheTemplate();
            }

            
        };

        vmList.showCalendar = function () {
            return vmList.filters.timeframeFilter === 3;
        };

        vmList.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vmList.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };

        function triggerSelect2LoctionSelection () {
            let locationFilter = $(singleLocationElemId);
            let locationFilterDlg = $(singleLocationElemDlgId);
            
            if (vmList.filters.singleLocation) {
                $timeout(() => {
                    
                        locationFilter.select2("trigger", "select", {
                            data: vmList.filters.singleLocation
                        });

                        locationFilterDlg.select2("trigger", "select", {
                            data: vmList.filters.singleLocation
                        });
                

                }, 1);
            } else {
                vmList.clearAllLocations();
            }
        }

        vmList.applyBtnClicked = function () {
            if (vmList.filters.locationFilter && vmList.filters.locationFilter.length === 1) {
                setupDeselectLocation();
                vmList.triggeredSelect2Select = true;
                triggerSelect2LoctionSelection();
            }

            vmList.searchTemplateBeforeAdvancedSearch = null;
            vmList.filtersBeforeAdvancedSearch = null;
            vmList.checkboxFiltersBeforeAdvancedSearch = null;
            vmList.showAdvancedSearch = false;
            updateList();
        };

        vmList.clearFilters = function () {
            searchTemplateUtilService.clearSearchTemplate(vmList);
            resetFilters();
            updateList(false, true);
        };

        vmList.listFilterChanged = function () {
            updateDirtyFlag();

            if (!vmList.showAdvancedSearch) {
                vmList.runQuery();
            } 
        };

        vmList.dateRangePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { 
                    vmList.listFilterChanged(); 
                }
            }
        };

        vmList.keywordFilterUpdated = function () {
            if (vmList.filters.keywordFilter !== vmList.prevSearchValue) {
                vmList.prevSearchValue = vmList.filters.keywordFilter;
                vmList.listFilterChanged();
            }
        };

        vmList.clearKeywordField = function () {
            vmList.filters.keywordFilter = null;

            if (vmList.filters.keywordFilter !== vmList.prevSearchValue) {
                vmList.prevSearchValue = vmList.filters.keywordFilter;
                vmList.listFilterChanged();
            }
        };

        vmList.clearCustomerField = function () {
            vmList.filters.customerFilter = null;
            vmList.listFilterChanged();
        };

        vmList.clearDriverField = function () {
            vmList.filters.driverFilter = '';
            vmList.listFilterChanged();
        };

        vmList.clearCustomTimeFrame = function () {
            vmList.filters.timeframeFilter = 0;
            vmList.listFilterChanged();
        };

        vmList.runQuery = function () {
            saveFilterSettings();

            if (vmList.shouldSaveTemplate) {
                saveSearchTemplate().then(() => {
                    loadLastTemplateAndFilters();
                }).catch(() => { });
            } else {
                updateList();
            }
        };

        vmList.clearSearchCriteria = function () {
            resetFilters(true);
            vmList.filters.keywordFilter = null;
            vmList.searchTemplateData.currentSearchTemplate = null;
            vmList.templateName = '';
            vmList.isGlobalTemplate = false;
            updateList(true);
        };

        vmList.toggleInvoice = function (trip) {
            if (!trip.invoiceChecked) {
                vmList.selectedInvoices.push(trip.id);
            } else {
                _.remove(vmList.selectedInvoices, (id) => { return id === trip.id; });
            }

            trip.invoiceChecked = !trip.invoiceChecked;
        };

        vmList.downloadInvoices = function () {
            if (!vmList.selectedInvoices.length) return;

            vmList.downloadingInvoices = true;
            tripService.getInvoices(vmList.selectedInvoices).then((result) => {
                SaveToDisk(result);

                _.forEach(vmList.selectedInvoices, (tripId) => {
                    let trip = _.find(vmList.filteredTrips, {id: tripId});

                    trip.invoiceChecked = false;
                });

                vmList.selectedInvoices = [];
            }).finally(() => {
                vmList.downloadingInvoices = false;
            });
        };

        vmList.getRODisplayText = function (data) {
            let displayText = rcUtilService.getRODisplayText(data.roNumber);
            
            if (displayText && data.systemTripTypeId === 2) {
                return '(RO #' + displayText + ') ' + data.roStatus;
            } else if (displayText) {
                return '(RO #' + displayText + ') ';
            }
        };

        function SaveToDisk(fileURL) {
            let save = document.createElement('a');

            save.href = fileURL;
            save.target = '_blank';

            let evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });

            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }

        vmList.close = function () {
            vmList.checkboxFilters = vmList.checkboxFiltersBeforeAdvancedSearch;
            searchTemplateUtilService.advancedFilterModalClosed(vmList);
        };

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vmList.searchTemplateData.currentSearchTemplate.id = null;
            }

            searchTemplateUtilService.saveSearchTemplateClicked(vmList,
            {
                locationFilter: vmList.filters.locationFilter,
                programFilter: vmList.filters.programFilter,
                tripTypeFilter: vmList.filters.tripTypeFilter,
                tripStatusFilter: vmList.filters.tripStatusFilter,
                timeframeFilter: vmList.filters.timeframeFilter,
                userFilter: vmList.filters.userFilter,
                loanerFilter: vmList.filters.loanerFilter,
                customerFilter: vmList.filters.customerFilter,
                driverFilter: vmList.filters.driverFilter,
                driverFilterUnassigned: vmList.filters.driverFilterUnassigned,
                customTimeframe: vmList.filters.customTimeframe,
                templateName: vmList.searchTemplateData.savedSearchName,
                dnsOnlyFilter: vmList.filters.dnsOnlyFilter,
                driverProgramFilter: vmList.filters.driverProgramFilter,
                includeTestTripsFilter: vmList.filters.includeTestTripsFilter,
                keywordFilter: vmList.filters.keywordFilter
            }, searchTemplateType);
        }

        function getTrips() {
            vmList.searchFilter.forDispatch = vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list;

            return  tripService.getTrips(vmList.searchFilter).then((response) => {
                if (response) {
                    let filteredTrips = response.results;

                    vmList.totalTripCount = response.totalReturnedResults;

                    _.each(filteredTrips, (trip) => {
                        formatTrip(trip);
                    });

                    if (!vmList.searchFilter.forDispatch) {
                        vmList.alertCount = _.filter(filteredTrips, (trip) => {
                            return trip.health.status > vmList.healthStatus.ok && !trip.isComplete;
                        }).length;
                    }

                    vmList.canLoadMore = filteredTrips && filteredTrips.length === vmList.searchFilter.pageSize;
                    vmList.allTrips = vmList.filteredTrips.concat(filteredTrips);
                    vmList.filteredTrips = _.uniqBy(vmList.allTrips, 'id');
                    vmList.selectedQueryCount = vmList.filteredTrips ? vmList.filteredTrips.length : -1;
                } else {
                    console.log('ERROR IN GETTING TRIPS - NULL RESPONSE');
                    vmList.searchErrorOccurred = true;
                }
            }, (err) => {
                console.log('ERROR IN GETTING TRIPS', err);
                vmList.searchErrorOccurred = true;
            });
        }

        
        vmList.saveSort = function() {
            rcLocalStorageService.set(savedSortKey, vmList.sortData);

            if (vmList.dispatchSortType) {
                let dispatchSort = {
                    sortType: vmList.dispatchSortType,
                    sortAsc: vmList.dispatchSortAsc 
                };

                rcLocalStorageService.set(savedDispatchSortKey, dispatchSort);
            }
        };


        function updateList(ignoreFilters, showAll) {
            _selectedTripId = null;
            vmList.filteredTrips = vmList.allTrips = [];

            vmList.filters.forceTimeFilter = vmList.filters.keywordFilter !== null && vmList.filters.keywordFilter !== '' && vmList.isSysAdmin && !showAll;

            createFilterMessage(ignoreFilters);
            clearRefreshInterval();
            vmList.displayLimit = displayLimit;
            vmList.searchErrorOccurred = null;
            vmList.ignoreFilters = ignoreFilters;
            vmList.showAll = showAll;
            vmList.searchFilter = vmList.searchFilter || {};

            // Select2 makes it difficult to set an initial value for dropdowns driven by autocomplete ajax.
            //  As such, we're having to maniuplate the html in order to add an initial value with the method below.
            populateSelect2Values('userFilter', setSelectedUsers);

            let sortField = vmList.displayMap ? vmList.sortData.sortBy : (vmList.sortFilterTrip ? vmList.sortData.sortBy : vmList.sortByType.customerArrival); 
            let sortOrder = vmList.sortData.sortDirection === 'desc' ? 1 : 0;

            if (vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list) {
                sortField = vmList.dispatchSortType;
                sortOrder = vmList.dispatchSortAsc ? 0 : 1;
            }

            let filter = {
                timeframe: vmList.filters.timeframeFilter,
                locations: vmList.filters.locationFilter,
                programs: vmList.filters.programFilter,
                status: vmList.filters.tripStatusFilter,
                users: vmList.filters.userFilter,
                tripTypes: vmList.filters.tripTypeFilter,
                includeLoaner: vmList.filters.loanerFilter,
                driverName: vmList.filters.driverFilter,
                driverFilterUnassigned: vmList.filters.driverFilterUnassigned,
                customerName: vmList.filters.customerFilter,
                forceTimeFilter: vmList.filters.forceTimeFilter,
                dnsOnly: vmList.filters.dnsOnlyFilter,
                driverPrograms: vmList.filters.driverProgramFilter,
                includeTestTrips: vmList.filters.includeTestTripsFilter,
                page: 0,
                pageSize: 25,
                sortOrder: sortOrder,
                sortField: sortField,
                alertsOnly: !!vmList.showingAlerts
            };

            if (vmList.filters.customTimeframe && vmList.filters.customTimeframe !== undefined && vmList.filters.customTimeframe.startDate && vmList.filters.customTimeframe.endDate) {
                filter.fromDate = vmList.filters.customTimeframe.startDate;
                filter.toDate = vmList.filters.customTimeframe.endDate;
            }

            if (vmList.filters.keywordFilter && vmList.filters.keywordFilter.length > 0) {
                filter.searchValues = [vmList.filters.keywordFilter];
            }
           
            // We are defaulting the a high number to avoid infinite scrolling issues on the dispatch list
            if (vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list) {
                filter.pageSize = 250;
            }

            let timeZone = moment.tz.guess();

            filter.timeZone = timeZone;

            vmList.searchFilter = filter;
            vmList.isLoading = true;

            showDealers();

            return getTrips().finally(() => {
                vmList.isLoading = false;
                
                if (vmList.autoRefresh === undefined)
                    vmList.autoRefresh = rcLocalStorageService.get('auto-refresh', vmList.autoRefresh) || false;

                if (vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list && vmList.autoRefresh)
                    setRefreshInterval();

                return true;
            });
        }

        function populateSelect2Values(selectId, callback) {
            let li_count = 0;
            let renderEle = angular.element('#' + selectId + ' + .select2-container .select2-selection__rendered');

            renderEle.each((ele) => {
                li_count++;
            });

            if (li_count <= 1) {
                callback(renderEle);
            }
        }

        function setSelectedUsers(htmlEl) {
            vmList.filters.userFilter.forEach((val) => {
                tripService.getUsers(val).then((result) => {
                    if (result && result.length) {
                        let displayText = result[0].fullName + ' (' + result[0].userName + ')';

                        setSelectedHtml(htmlEl, displayText, result[0]);
                    }
                });
            });
        }

        function setSelectedHtml(parentEl, displayText, data) {
            _select2DataId++;

            let li = $(document.createElement('li'));
            let span = $('<span class="select2-selection__choice__remove" role="presentation">×</span>');

            li.attr('class', 'select2-selection__choice');
            li.attr('data-select2-id', _select2DataId);
            li.append(span);
            li.append(document.createTextNode(displayText));

            _select2DataId++;
            let clearSpan = $('<span class="select2-selection__clear" title="Remove all items" data-select2-id="' + _select2DataId + '">×</span>');

            clearSpan.data('data', {data: data});

            parentEl.empty()
                .append(clearSpan)
                .append(li)
                .trigger('change')
                .trigger({
                    type: 'select2:select',
                    params: {
                        data: data
                    }
                }, data);
        }

        function createFilterMessage(ignoreFilters) {
            
            vmList.selectedQueryCount = -1;
            vmList.filterCount = 0;
            vmList.filterMessage = '';
         
            let customTimeFrame = vmList.filters.customTimeframe;

            if (ignoreFilters && vmList.filters.keywordFilter && vmList.filters.keywordFilter.length > 0) {
                rcUtilService.buildFilterMessage('Keyword', vmList.filters.keywordFilter.map((input) => { return input; }), vmList, true);

                if (vmList.filters.forceTimeFilter) {
                    rcUtilService.buildFilterMessage('Date Range', 'LAST 30 DAYS FORWARD', vmList);
                }
            }

            if (!ignoreFilters) {
                if (vmList.filters.locationFilter && vmList.filters.locationFilter.length > 0) {
                    if (vmList.resolvedLocationList) {
                        let vals = rcUtilService.getItemByProperty(vmList.filters.locationFilter, vmList.resolvedLocationList, 'id').map((location) => { return location ?  location.name : ''; });

                        rcUtilService.buildFilterMessage('Location', vals, vmList);
                    } else {
                        let msg = vmList.filters.locationFilter.length > 1 ? ' LOCATIONS' : ' LOCATION';

                        rcUtilService.buildFilterMessage('Location', vmList.filters.locationFilter.length + msg, vmList);
                    }
                }

                if (vmList.isSysAdmin && vmList.filters.programFilter && vmList.filters.programFilter.length > 0) {
                    let programVals = rcUtilService.getItemByProperty(vmList.filters.programFilter, vmList.resolvedProgramList, 'id').map((program) => { return program.name; });

                    rcUtilService.buildFilterMessage('Program', programVals, vmList);
                }

                if (vmList.filters.userFilter && vmList.filters.userFilter.length > 0) {
                    let msg = vmList.filters.userFilter.length > 1 ? ' USERS' : ' USER';
 
                    // at least show that we're filtering on a user
                    rcUtilService.buildFilterMessage('User', vmList.filters.userFilter.length + msg, vmList);
                    /*loadUsersDropdown().then(function() {
                        var users = getItem(vmList.userFilter, vmList.resolvedUserList, 'id').map(function (user) { return user.fullName + '  (' + user.userName + ')'; });
                        buildItemMessage('User', users);
                        deferred.resolve(true);
                    });*/
                }

                if (!vmList.filters.tripTypeFilter && !vmList.filters.tripStatusFilter) {
                    resetFilters();
                }

                if (vmList.filters.tripTypeFilter.length > 0) {
                    let tripTypes = rcUtilService.getItemByProperty(vmList.filters.tripTypeFilter, vmList.tripTypes, 'value').map((type) => { return type.text; });

                    rcUtilService.buildFilterMessage('Trip Type', tripTypes, vmList);
                }

                if (vmList.filters.tripStatusFilter.length > 0) {
                    let selectedStatuses = rcUtilService.getItemByProperty(vmList.filters.tripStatusFilter, vmList.tripStatuses, 'value').map((type) => { return type.text; });

                    rcUtilService.buildFilterMessage('Trip Status', selectedStatuses, vmList);
                }

                if (vmList.filters.driverFilter.length > 0 && !vmList.filters.driverFilterUnassigned) {
                    rcUtilService.buildFilterMessage('Driver Name', vmList.filters.driverFilter, vmList);
                }

                if (vmList.filters.driverFilterUnassigned) {
                    rcUtilService.buildFilterMessage('Unassigned', 'Yes (only unassigned)', vmList);
                }

                if (vmList.filters.customerFilter.length > 0) {
                    rcUtilService.buildFilterMessage('Customer Name', vmList.filters.customerFilter, vmList);
                }

                if (vmList.filters.timeframeFilter !== 3) {
                    let timeframe = _.find(vmList.timeframes, (tf) => { return tf.value === vmList.filters.timeframeFilter; });

                    if (timeframe) {
                        rcUtilService.buildFilterMessage('Date Range', timeframe.text, vmList);
                    }
                }

                if (vmList.filters.dnsOnlyFilter) {
                    rcUtilService.buildFilterMessage('DNS Only', 'Yes', vmList);
                }
                
                if (vmList.filters.driverProgramFilter && vmList.filters.driverProgramFilter.length > 0) {
                    let driverPrograms = [];

                    _.forEach(vmList.filters.driverProgramFilter, (programId) => {
                        let program = _.find(vmList.driverPrograms, (program) => { return program.id === programId; });

                        driverPrograms.push(program.name);
                    }); 
                    rcUtilService.buildFilterMessage('DNS Program', driverPrograms, vmList);                   
                }
                
                if (vmList.isSysAdmin) {
                    if (vmList.filters.includeTestTripsFilter) {
                        rcUtilService.buildFilterMessage('Include Test Trips', 'Yes', vmList);
                    } else {
                        rcUtilService.buildFilterMessage('Include Test Trips', 'No', vmList);
                    }
                }

                if (vmList.filters.loanerFilter) {
                    rcUtilService.buildFilterMessage('Has Loaner', vmList.filters.loanerFilter, vmList);
                }

                if (vmList.filters.timeframeFilter === 3 && 
                    customTimeFrame && 
                    customTimeFrame !== undefined && 
                    customTimeFrame.startDate && 
                    customTimeFrame.endDate) {
                    rcUtilService.buildFilterMessage('Date', new Date(customTimeFrame.startDate).toLocaleDateString() + ' - ' + new Date(customTimeFrame.endDate).toLocaleDateString(), vmList);
                }
            }
            
        }

        vmList.cancelPromise = null;
        vmList.userListSearchOptions = {
            width: '100%',
            placeholder: 'User',
            minimumInputLength: 3,
            maximumSelectionLength: 1,
            allowClear: true,
            language: {
                errorLoading: function () {
                    return "Searching...";
                }
            },
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vmList.cancelPromise) {
                        vmList.cancelPromise.resolve();
                    }

                    vmList.cancelPromise = $q.defer();

                    return tripService.getUsers(data.search, vmList.cancelPromise.promise).then((results) => {
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 500,
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                return item.fullName + ' (' + item.userName + ')';
            },
            templateResult: function (item) {
                if (item.loading) {
                    return "Searching...";
                }

                return item.fullName + ' (' + item.userName + ')';
            }
        };

        function getNoLocationLoadedText() {
            if (vmList.isLocationListEmpty() === true && 
                !vmList.filters.locationFilter) {
                    vmList.noLocationsText = null;
            } else if (vmList.isLocationListEmpty() === true && 
                vmList.filters.locationFilter.length === 0) {
                vmList.noLocationsText = null;
            } else {
                if (vmList.filters.locationFilter.length > 1) {
                    vmList.noLocationsText = vmList.filters.locationFilter.length + ' CHECKED';
                } else {
                    vmList.noLocationsText = null;
                }
            }
        }

        function setCheckboxesFromFilters () {
            if (vmList.filters.tripStatusFilter && vmList.filters.tripStatusFilter.length > 0) {
                vmList.checkboxFilters.tripStatusCheckboxFilter = [];
                _.forEach(vmList.filters.tripStatusFilter, (filter) => {
                    vmList.checkboxFilters.tripStatusCheckboxFilter.push({id: filter});
                });
            }

            if (vmList.filters.programFilter && vmList.filters.programFilter.length > 0) {
                vmList.checkboxFilters.programCheckboxFilter = [];
                _.forEach(vmList.filters.programFilter, (filter) => {
                    vmList.checkboxFilters.programCheckboxFilter.push({id: filter});
                });
            }

            if (vmList.filters.driverProgramFilter && vmList.filters.driverProgramFilter.length > 0) {
                vmList.checkboxFilters.driverProgramCheckboxFilter = [];
                _.forEach(vmList.filters.driverProgramFilter, (filter) => {
                    vmList.checkboxFilters.driverProgramCheckboxFilter.push({id: filter});
                });
            }

            if (vmList.filters.tripTypeFilter && vmList.filters.tripTypeFilter.length > 0) {
                vmList.checkboxFilters.tripTypeCheckboxFilter = [];
                _.forEach(vmList.filters.tripTypeFilter, (filter) => {
                    vmList.checkboxFilters.tripTypeCheckboxFilter.push({id: filter});
                });
            }

            if (vmList.isLocationListEmpty() === false && 
                vmList.resolvedLocationList.length > 0 &&
                vmList.filters.locationFilter && 
                vmList.filters.locationFilter.length > 0
                ) {
                    
                vmList.checkboxFilters.locationCheckboxFilter = [];
                _.forEach(vmList.filters.locationFilter, (filter) => {
                    vmList.checkboxFilters.locationCheckboxFilter.push({id: filter});
                });
            }
            
        }

        function loadLastTemplateAndFilters() {
            vmList.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate(savedTemplateKey);
        
            if (!vmList.filters.tripStatusFilter || vmList.filters.tripStatusFilter.length === 0) {
                vmList.setDefaultStatusFilters();
            }

            getNoLocationLoadedText();
            setCheckboxesFromFilters();

            if (vmList.filters.singleLocation && vmList.filters.locationFilter && vmList.filters.locationFilter.length === 1) {
                let selLoc = vmList.filters.singleLocation;

                if (vmList.dealerListInitialized === false) {
                    // put it in the list so it will show up in the box.
                    vmList.resolvedLocationList = [];
                    vmList.resolvedLocationList.push(selLoc);
                }

                // is the below messy?  yes, but blame select 2
                // it was the only way I could get the data to load
                // correctly from the cookies and set in the select2 component on load w/out
                // getting cleared out
                $timeout(() => {
                    if (vmList.filters.singleLocation) {
                        vmList.selectedSingleLocationId = vmList.filters.singleLocation.id;
                        vmList.triggeredSelect2Select = true;
                        $timeout(() => {
                            setupDeselectLocation();
                            let locationFilter = $(singleLocationElemId);
                            let locationFilterDlg = $(singleLocationElemDlgId);

                            locationFilter.select2("trigger", "select", {
                                data: vmList.filters.singleLocation
                            });

                            locationFilterDlg.select2("trigger", "select", {
                                data: vmList.filters.singleLocation
                            });
                        }, 250);
                    }
                }, 500);
            } 
            
            if (vmList.searchTemplateData.currentSearchTemplate) {
                let searchItem = _.find(vmList.searchTemplateData.searchTemplates, (item) => { return item.template.templateName === vmList.searchTemplateData.currentSearchTemplate; });

                if (searchItem) {
                    vmList.loadSearchTemplate(searchItem);
                } else {
                    vmList.searchTemplateData.currentSearchTemplate = null;

                    if (!ignoreListReload) {
                        updateList();
                    }
                }
            } else {
                if (!ignoreListReload) {
                    updateList();
                }
            }
        }

        init();

        function init() {
            vmList.sortData = _.extend({}, initialSort, existingSort);
            vmList.filters = _.extend({}, initialFilters, existingFilters);
            
            vmList.searchTemplateData.currentSearchTemplate = rcLocalStorageService.get(savedTemplateKey) || null;

            if (existingDispatchSort) {
                vmList.dispatchSortType = existingDispatchSort.sortType;
                vmList.dispatchSortAsc = existingDispatchSort.sortAsc;
            }
            
            // remove personal driver
            vmList.tripTypes = _.reject(SYSTEM_ENUMS.systemTripTypes, (el) => { return el.value === 10 || el.value === 11; });

            // this is so we have the system trip type display names
            // but only the ones we want to display in this app ( there are some in db we don't want to display);
            for (let idx = vmList.tripTypes.length - 1; idx >= 0; idx--) {
                let resSysTripType = $filter('filter')(vmList.resolvedSystemTripTypes, {id: vmList.tripTypes[idx].value});

                vmList.tripTypes[idx].text = SYSTEM_ENUMS.useTripNameOverrides && vmList.tripTypes[idx].overrideName ? vmList.tripTypes[idx].overrideName : resSysTripType[0].name;
            }

            if (vmList.isSysAdmin) {
                locationService.getAdminConfigs().then((result) => {
                    if (result) {
                        let keys = _.keys(result);
                        let programs = [];

                        _.forEach(keys, (key) => {
                            programs.push({
                                id: key,
                                name: result[key]
                            });
                        });
                        vmList.resolvedProgramList = programs;
                    }
                });
            } else {
                // check to see if this user only has one dealer so we can pre-populte the
                // location drop down 
                locationService.getLocationsCountForTripListDropDown(true, false, SYSTEM_ENUMS.permissionTypes.transportation).then((locationCount) => {
                    if (locationCount) {
                        vmList.hasMultipleDealers = locationCount > 1;

                        if (vmList.hasMultipleDealers === false) {
                            vmList.getDealerLocations();
                        }
                    }
                });

            }

            if (vmList.searchTemplateData.searchTemplates.length === 0) {
                systemService.getSearchTemplates(searchTemplateType).then((templates) => {
                    vmList.searchTemplateData.searchTemplates = templates;
                    loadLastTemplateAndFilters();
                });
            } else {
                loadLastTemplateAndFilters();
            }
    
        }

        function resetFilters() {
            vmList.isLoading = true;
            vmList.filters.locationFilter = [];
            vmList.filters.tripTypeFilter = [];
            vmList.filters.singleLocation = null;
            vmList.filters.selectedSingleLocationId = null;
            vmList.filters.userFilter = [];
            vmList.filters.customTimeframe = defaultDateRange;
            vmList.filters.loanerFilter = null;
            vmList.filters.timeframeFilter = 0;
            vmList.filters.customerFilter = '';
            vmList.filters.driverFilter = '';
            vmList.filters.dnsOnlyFilter = false;
            vmList.filters.driverProgramFilter = [];
            vmList.filters.includeTestTripsFilter = true;
            vmList.filters.programFilter = [];
            vmList.filters.tripStatusFilter = [];
            vmList.filters.driverFilterUnassigned = false;
            vmList.filters.keywordFilter = null;
            vmList.templateName = '';
            vmList.checkboxFilters.tripTypeCheckboxFilter = [];
            vmList.checkboxFilters.programCheckboxFilter = [];
            vmList.checkboxFilters.tripStatusCheckboxFilter = [];  
            vmList.checkboxFilters.driverProgramCheckboxFilter = [];
            vmList.setDefaultStatusFilters();
            vmList.clearAllLocations();
            vmList.clearUserFilter();
            vmList.filtersBeforeAdvancedSearch  = _.cloneDeep(vmList.filters);
            vmList.checkboxFiltersBeforeAdvancedSearch = _.cloneDeep(vmList.checkboxFilters);
            // Save filter settings
            saveFilterSettings();
            getNoLocationLoadedText();
        }

        $scope.$on('TripService.changed', (event, data) => {
            updateList();
            //TODO: refreshing the entire list is a stop gap - we can look into using "data" to refresh an individual item at some point later on
        });
        
        $scope.$on('Trip.asideClosed', () => {
            let listLoc = rcLocalStorageService.get('trip-list.anchor') || null;

            if (listLoc) {
                $timeout(() => {
                    $location.hash(listLoc);
                    $anchorScroll();
                    window.scrollBy(0, -170);

                    // removes the hash from the url
                    $location.hash('');
                    $location.replace();

                    // highlights the row
                    highlightedTripElem = angular.element(document.querySelector('#' + listLoc));
                }, 1);
            }
          }
        );

        $scope.$on('$destroy', (event, next, current) => {
            rcLocalStorageService.remove('trip-list.anchor');
        });

        vmList.openTrip = function (tripId, $event) {
            let angElem = $event.currentTarget;

            angElem = $(angElem).closest('tr')[0];
            rcLocalStorageService.set('trip-list.anchor', angElem.id);
            ignoreListReload = true;

            let stateParams = {tripId: tripId, locationList: vmList.activeLocationsForMap};

            if (vmList.parent_vm.transportationViewMode === vmList.viewModes.dispatch_list) {
                stateParams.activeMessageTab = SYSTEM_ENUMS.messagingPanelModes.dealerInfo;
            }

            $state.go('trip-tab-trip', stateParams);
        };

        vmList.resizeMap = function (maximize) {
            let listLeftSide = angular.element('#trip-content');
            let mapRightSide = angular.element('#map-size-reference');
            let tripsContainer = angular.element('#trips');
            let width = null;

            $timeout(() => {
                if (maximize) {
                    listLeftSide.addClass('hidden');
                    mapRightSide.removeClass('flex-percent-50').addClass('flex-percent-100');
                } else {
                    listLeftSide.removeClass('hidden');
                    mapRightSide.addClass('flex-percent-50').removeClass('flex-percent-100');
                }

                if (_map) {
                    if (maximize) {
                        width = tripsContainer.width();
                    } else {
                        width = mapRightSide.width();
                    }

                    _map.setMapSizes(null, width);
                }
            }, 250);
        };

        vmList.toggleAutoRefresh = function()  {
            if (!vmList.autoRefresh) {
                clearRefreshInterval();
            } else {
                setRefreshInterval();
            }

            rcLocalStorageService.set('auto-refresh', vmList.autoRefresh);
        };

        $scope.$on('$destroy', () => {
            clearRefreshInterval();
        });
        
        function setRefreshInterval() {            
            if (!_autoRefreshInterval) {
                let countdown = (AUTOREFRESH_DURATION / 1000);

                _autoRefreshInterval = $interval(() => {
                    updateList(vmList.ignoreFilters, vmList.showAll).then(() => {
                        vmList.refreshCountdown = countdown;
                    });
                    
                }, AUTOREFRESH_DURATION);

                vmList.refreshCountdown = countdown;
                _autoRefreshCountDown = $interval(() => { vmList.refreshCountdown--; }, 1000, 0);
            }
        } 

        function clearRefreshInterval() {
            if (angular.isDefined(_autoRefreshInterval)) {
                $interval.cancel(_autoRefreshInterval);
                _autoRefreshInterval = undefined;
            }

            if (angular.isDefined(_autoRefreshCountDown)) {
                $interval.cancel(_autoRefreshCountDown);
                _autoRefreshCountDown = undefined;
            }
        }

        vmList.addNew = function() {
            $state.go('trip-add', {locationList: vmList.activeLocationsForMap});
        };


        vmList.resizeFromDebounce = function () {
            vmList.resizeMap(false);
        }; 

        let debouncedRedraw = _.debounce(vmList.resizeFromDebounce, 150);

        $(window).on("resize", debouncedRedraw);
      
        $scope.$on("$destroy", () => {
            // clean up here
            $(window).off("resize");
        });
    }
})();

(function () {
    'use strict';

    TripDetailController.$inject = ["$scope", "$state", "$rootScope", "$filter", "$stateParams", "SYSTEM_ENUMS", "authService", "resolvedTrip", "resolvedParams", "resolvedBookingRules", "rcUtilService", "hasMessaging", "resolvedLocationList", "tripService", "bookingService", "signalRService", "modalService", "rideProviderService", "messagesService", "appointmentService", "appointmentUtilService", "permissions", "loanerService"];
    angular
        .module('redcap.trip')
        .controller('TripDetailController', TripDetailController);

    function TripDetailController($scope, $state, $rootScope, $filter, $stateParams, SYSTEM_ENUMS, authService, resolvedTrip, resolvedParams, resolvedBookingRules, rcUtilService,
        hasMessaging, resolvedLocationList, tripService, bookingService, signalRService, modalService, rideProviderService, messagesService, appointmentService, appointmentUtilService, permissions, loanerService) {
        let vm = this;
        let tripListener = signalRService.registerTripsListener(resolvedTrip.id);

        vm.isTestTrip = resolvedTrip.isTestTrip;
        vm.messagePanelMobileClass = 'trip-messaging-enabled';
        vm.hasLoanerPermission = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.loaner);
        vm.showOemId = permissions.isSysAdmin() || permissions.isRedCapAdmin();

        vm.cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
        vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
        vm.tripStates = SYSTEM_ENUMS.driverTripStates;
        vm.healthStatus = SYSTEM_ENUMS.healthStatus;
        vm.hasMessaging = hasMessaging;
        vm.tripWorkflowTypes = SYSTEM_ENUMS.tripWorkflowTypes;

        vm.useTripNameOverrides = SYSTEM_ENUMS.useTripNameOverrides;

        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.shortSystemTripType = SYSTEM_ENUMS.systemTripType;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.tabs = '';
        vm.cancellingTrip = false;
        vm.queryStringParms = resolvedParams || {};
        vm.activeMessageTab = vm.queryStringParms.activeMessageTab ? parseInt(vm.queryStringParms.activeMessageTab) : null;

        vm.isFramedIn = function () { return authService.isFramedIn(); };
       
        init(resolvedTrip);
      
        function setMessagingTabsFlag() {
            if (vm.queryStringParms.rmt && vm.queryStringParms.rmt === "1") return true;

            return false;
        }

        function initAsideHeaderData () {
            vm.headerData = {
                customer: {
                    lastName: vm.trip.customerName,
                    mobilePhone: vm.trip.customerPhone,
                    emailAddress: vm.trip.customerEmail
                },
                vehicle: {
                    year: vm.trip.vehicle.year,
                    make: vm.trip.vehicle.make,
                    model: vm.trip.vehicle.model,
                    stockNumber: vm.trip.vehicle.stockNumber,
                    vin: vm.trip.vehicle.vin,
                    isVehicleNew: vm.trip.vehicle.isVehicleNew
                },
                dealer: {
                    showOemId: vm.showOemId,
                    name: vm.trip.dealer.name,
                    oemDealerId: vm.trip.dealer.oemDealerId,
                    dmsSystem: vm.trip.dealer.dmsSystem
                },
                serviceAdvisor: {
                    fullName: vm.trip.dealer.serviceAdvisorName
                },
                hasLoanerPermission: vm.hasLoanerPermission,
                trip: vm.trip,
                isTestTrip: vm.isTestTrip
            };
        }

        vm.apptIdIsValid = function (apptId) {
            return rcUtilService.isValidID(apptId);
        };
        
        vm.removePipedData = function (apptId) {
            return appointmentUtilService.removePipedData(apptId);
        };

        vm.tripWorkFlowHasLoaner = function () {
            return tripService.tripWorkFlowHasLoaner(resolvedTrip);
        };

        vm.removeMessagingTabs = setMessagingTabsFlag();

        vm.enableMessaging = function (enable) {
            rcUtilService.showHideMobileMessagingPanel(enable);
        };

        vm.getStatusText = function (status, verbose) {
            return tripService.getStatusText(status, verbose);
        };

        vm.getVehicleToolTip = function (vehicle) {
            let toolTip = "";

            if (!vehicle) return;

            if (vehicle.styleName) {
                toolTip += vehicle.styleName + " ";
            }

            toolTip += vehicle.isManual ? 'Manual ' : 'Automatic ';

            if (vehicle.stockNumber) {
                toolTip += vehicle.stockNumber + " ";
            }

            if (vehicle.vin) {
                toolTip += vehicle.vin;
            }

            return toolTip;
        };

        vm.initTabContainers = function () {
            vm.tabs = [{
                title: "Summary",
                route: 'trip-tab-trip',
                active: false
            },
            {
                title: "Ratings",
                route: 'trip-tab-ratings',
                active: false
            },
            {
                title: "Audit",
                route: 'trip-tab-audit',
                active: false
            },
            {
                title: "Help",
                route: 'trip-tab-help',
                active: false
            }];

            if (!vm.trip.providerRideId) {
                vm.tabs.splice(1, 0,
                    {
                        title: "Tasks",
                        route: 'trip-tab-tasks',
                        active: false
                    });

            }

            // Only show the log tab if the user is an admin and the trip isn't with Lyft/Uber
            if ((permissions.isSysAdmin() || permissions.isRedCapAdmin()) && !vm.trip.providerRideId) {
                vm.tabs.push({
                    title: "Log",
                    route: 'trip-tab-log',
                    active: false
                });
            }

            vm.tabs.forEach((tab) => {
                tab.active = $state.name === tab.route;
            });
        };

        vm.initTabContainers();

        vm.tabSelected = function (route) {
            $state.go(route, {tripId: vm.trip.id, configId: $stateParams.configId});
        };

        vm.isTripSummary = function () { 
            return vm.tabs[0].active;
        };

        vm.showCancelDlg = function (reasons) {
            let cancelResult = modalService.showTripCancel(reasons, vm.trip, vm.rules);

            cancelResult.then((results) => {
                if (results) {
                    let cancellationReason = results.cancellationReason === 'Other' ? results.otherDescription : !results.otherDescription || results.otherDescription.length === 0 ? results.cancellationReason : results.cancellationReason + ' - ' + results.otherDescription;

                    vm.cancellingTrip = true;

                    if (vm.trip.providerRideId) {
                        rideProviderService.cancelRide(vm.trip.providerRideId, cancellationReason, results.notifyCustomer, vm.trip.isTestTrip, vm.trip.systemTripTypeId, vm.trip.rideProviderType).then((result) => {
                            vm.cancellingTrip = false;
                            $rootScope.$broadcast('TripService.changed', vm.theTrip);
                            result !== false && $state.go('trip-list');
                        }, (err) => {
                            vm.cancellingTrip = false;
                            modalService.showYesNo('Unable to cancel trip', err.data.exceptionMessage, null, 'OK', true);
                        });
                    } else {
                        bookingService.cancelTrip(vm.trip.dealer.id, vm.trip.tripId, cancellationReason, results.notifyCustomer, results.pushToDms).then((result) => {
                            $rootScope.$broadcast('TripService.changed', vm.theTrip);
                            $state.go('trip-list');
                        }, (errorResponse) => {
                            vm.cancellingTrip = false;
                        });
                    }
                } else {
                    vm.cancellingTrip = false;
                }
            });
        };

        vm.cancelTripClicked = function () {
            if (vm.trip.dealerAppointmentId && vm.trip.dealerAppointmentTripWorkFlowId) {
                appointmentService.getAppointment(vm.trip.dealer.id, vm.trip.dealerAppointmentId).then((appointment) => {
                    if (!appointment.canCancel && !appointment.canEdit) {
                        startCanelTrip();
                    } else {
                        redirectToAppointment();
                    }
                });
            } else {
                startCanelTrip();
            }
        };

        vm.rebookClicked = function () {
            let data =  {
                locationId: vm.trip.dealer.id,
                systemTripTypeId: vm.trip.systemTripTypeId,
                parentTripId: vm.trip.id,
            };

            $state.go('trip-add', data);
        };

        vm.bookReturnClicked = function () {
            let data =  {
                locationId: vm.trip.dealer.id,
                systemTripTypeId: vm.shortSystemTripType.dropoff,
                parentTripId: vm.trip.id,
                isReturnTrip: true
            };

            $state.go('trip-add', data);

        };

        function startCanelTrip() {
            if (vm.rules.requireTripCancellationReason === true) {
                tripService.getCancellationReasons(vm.trip.dealer.id, vm.trip.dealerTripTypeId).then((reasons) => {
                    let arrReasons = reasons ? reasons.split(',') : null;

                    vm.showCancelDlg(arrReasons);
                });
            } else {
                vm.showCancelDlg(null);
            }
        }

        vm.editTripClicked = function () {
            if (vm.trip.dealerAppointmentId && vm.trip.dealerAppointmentTripWorkFlowId) {
                redirectToAppointment();
            } else {
                vm.cancelingTrip = true;
                $state.go('edit-trip', { 
                    tripId: vm.trip.id, 
                    locationList: resolvedLocationList 
                });
            }
        };

        listenForTripUpdates();

        function init(trip) {
            if (trip) vm.trip = trip;

            vm.dmsSystem = vm.trip.dealer.dmsSystem;
            vm.trip.health.updated = tripService.utcToLocalJSDate(vm.trip.health.updated);
            vm.trip.apptDate = tripService.utcToLocalJSDate(vm.trip.apptDate);
            vm.trip.customerExpectedTime = tripService.utcToLocalJSDate(vm.trip.customerExpectedTimeUtc);
            vm.rules = resolvedBookingRules;
            vm.selectedSystemTripType = $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: vm.trip.systemTripTypeId})[0];
            vm.trip.workflowName = SYSTEM_ENUMS.useTripNameOverrides && vm.selectedSystemTripType.overrideName ? vm.selectedSystemTripType.overrideName : vm.trip.workflowName;
            vm.trip.typeName = SYSTEM_ENUMS.useTripNameOverrides && vm.selectedSystemTripType.overrideName ? vm.selectedSystemTripType.overrideName : vm.trip.typeName;
            initAsideHeaderData();
        }

        function listenForTripUpdates() {
            tripListener.on(signalRService.events.trips.broadcastTripUpdated, (updateModel) => {
                switch (updateModel.updateType) {
                    case signalRService.events.trips.updateType.healthChange:
                        // update the tripHealth
                        vm.trip.status = updateModel.trip.status;
                        vm.trip.health = updateModel.trip.health;
                        vm.trip.hasWarning = updateModel.trip.hasWarning;
                        init();
                        break;
                    case signalRService.events.trips.updateType.driverChange:
                        vm.trip.driver = updateModel.trip.driver;
                        if (vm.trip.driver.id == null)
                            vm.trip.lyftVehicle = null;
                        init();
                        break;
                    case signalRService.events.trips.updateType.stateChange:
                        vm.trip.state = updateModel.trip.state;
                        vm.trip.currentStep = updateModel.trip.currentStep;
                        vm.trip.isComplete = updateModel.trip.isComplete;
                        vm.trip.showDriver = updateModel.trip.showDriver;
                        vm.trip.stateName = updateModel.trip.stateName;
                        vm.trip.isDriving = updateModel.trip.isDriving;
                        vm.trip.canCancel = updateModel.trip.canCancel;
                        vm.trip.canEdit = updateModel.trip.canEdit;
                        vm.trip.canChangeDriver = updateModel.trip.canChangeDriver;
                        break;
                    case signalRService.events.trips.updateType.modelChange:
                        vm.trip = $.extend(vm.trip, updateModel.trip);
                        break;
                }

                $scope.$broadcast('updateTrip', {type: updateModel.updateType, trip: vm.trip});
            }).on(signalRService.events.drivers.broadcastDriverLocation, (driverLocation) => {
                // update Driver location
            }).start(); // initiate the connection letting the server know what events this client is listening for
        }

        function redirectToAppointment() {
            vm.routingToAppt = true;

            return modalService.showYesNo('Go to Appointment',
                'This trip was booked with an appointment and must be edited or canceled on the appointment screen.  Click OK to continue or Cancel to return to the Trip Summary',
                'Cancel', 'OK', true)
                .then((shouldRedirect) => {
                    if (shouldRedirect) {
                        $state.go('appointment-details', {locationId: vm.trip.dealer.id, appointmentId: vm.trip.dealerAppointmentId, fromCachedMenu: false}).catch((fail) => {
                            vm.routingToAppt = false;
                        });
                    } else {
                        vm.routingToAppt = false;
                    }
                })
                .catch(() => {
                    vm.routingToAppt = false;
                });
        }


        vm.loadContact = function () {
            if (!vm.trip) return;

            let phoneNumber = vm.trip.customerPhone;
            let customerName = vm.trip.customerName.split(' ');

            if (phoneNumber && phoneNumber.length >= 10) {
                messagesService.getContacts({dealer: vm.trip.dealer.id, query: phoneNumber.replace(/\D/g, ''), allowDisabledDealers: true})
                    .then((contacts) => {
                        if (contacts.length) {
                            vm.contact = contacts[0];
                        } else {
                            vm.contact = {
                                id: 0,
                                dealerId: vm.trip.dealer.id,
                                firstName: customerName[0],
                                lastName: customerName[1],
                                email: vm.trip.customerEmail,
                                mobilePhone: vm.trip.customerPhone
                            };
                        }
                    });
            }
        };

        if (vm.trip.providerRideId) {
            vm.loadContact();
        }

        // detach when controller removed.
        $scope.$on('$destroy', (event, next, current) => {
            tripListener.disconnect();
            vm.enableMessaging(false);
        });
    }
})();

(function () {
    'use strict';

    TripAddController.$inject = ["$scope", "$state", "$rootScope", "$timeout", "$filter", "$q", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "toastr", "locationService", "tripService", "tripTypeService", "bookingService", "resolvedLocationList", "permissions", "resolvedLocation", "resolvedUser", "resolvedSystemTripType", "resolvedTripType", "resolvedConfig", "resolvedServiceOrder", "resolvedFavoriteLocations", "resolvedTripWorkFlows", "resolvedParams", "resolvedTrip", "resolvedBookingRules", "ValidationService", "modalService", "rideProviderService", "messagesModalService", "messagesService", "authService", "$uibModal", "rcUtilService", "userRolesService", "resolvedParentTrip", "resolvedRO"];
    angular
        .module('redcap.trip')
        .controller('TripAddController', TripAddController);

    function TripAddController($scope, $state, $rootScope, $timeout, $filter, $q, SYSTEM_ENUMS, HERE_MAPS_CONFIG, toastr, locationService, tripService, tripTypeService,
        bookingService, resolvedLocationList, permissions, resolvedLocation, resolvedUser, resolvedSystemTripType, resolvedTripType, resolvedConfig,
        resolvedServiceOrder, resolvedFavoriteLocations, resolvedTripWorkFlows, resolvedParams, resolvedTrip, resolvedBookingRules, ValidationService,
        modalService, rideProviderService, messagesModalService, messagesService, authService, $uibModal, rcUtilService, userRolesService, resolvedParentTrip, resolvedRO) {
        
        let vm = this;

        vm.lastMotorGetMakesYear = null;
        vm.lastMotorGetModelMake = {
            make: null,
            makeCode: null
        };
        vm.healthStatus = SYSTEM_ENUMS.healthStatus;
        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.rideProviderTypes = SYSTEM_ENUMS.rideProviderType;
        vm.lyftSandboxFlowTypes = SYSTEM_ENUMS.lyftSandboxFlowTypes;
        vm.mapOptions = {
            showSegmentOverlay: false,
            fillHeight: false,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: false,
            showControls: false,
            disableLiveTracking: true
        };
        vm.packageSize = SYSTEM_ENUMS.uberPackageSize;
        vm.messagePanelMobileClass = 'trip-messaging-enabled';
        let _map = null;

        vm.mapLoaded = function(mapActions) {
            _map = mapActions;

            if (resolvedTrip) {
                vm.getMapDetails(resolvedTrip);
            } else if (vm.theTrip.dealerLocation) {
                vm.setMapLocation(vm.theTrip.dealerLocation);
            }
        };

        vm.isFramedIn = function () { return authService.isFramedIn(); };

        vm.validation = {
            validEmail: function (email) {
                return rcUtilService.isValidEmail(email);
            },
            validVin: function (vin) {
                return rcUtilService.isValidVin(vin);
            }
        };

        vm.showLyftSandBoxDropdown = function () {
            return vm.theTrip.selectedSystemTripType && vm.theTrip.selectedSystemTripType.rideProviderType != vm.rideProviderTypes.uber && vm.canSetTestTrip && vm.theTrip.selectedSystemTripType.lyft && vm.theTrip.selectedSystemTripType.lyft.supportsSandboxOptions && !vm.resolvedTrip && vm.serviceOrder && !vm.invitationSent && vm.serviceOrder.action > 0 && vm.displayBookItPanel();
        };

        vm.showTestTripCheckbox = function () {
            return vm.canSetTestTrip && vm.displayBookItPanel() && vm.theTrip.showTripSettingsForm == true;
        };

        $scope.$on('bookingConfigChanged', (evt, config) => {
            $scope.$broadcast('bookingConfigChangedListener', config);
        });

        $scope.$watch('vm.theTrip.testTrip', (newValue, oldValue) => {
            // Don't send unless changed with valid value   
            if (oldValue !== undefined) {
                $scope.$broadcast('testTripFlagChangedListener', newValue);
            }
        });

        vm.validateEditTripOriginalDate = null;
        vm.validateEditTripOriginalTime = null;
        vm.validateEditTripOriginalDriver = null;
        vm.newUsedOptions = [
            {value: 0, text: 'USED'},
            {value: 1, text: 'NEW'}
        ];

        vm.isTripType = function (tripType) {
            return vm.theTrip.selectedSystemTripType.id === tripType;
        };

        vm.baseProductGroups = [
            {
                marketingGroupId: 4,
                supportsDMSSearch: true,
                displayName: null,
                systemTripTypeIds: [
                    13
                ],
                badgeText: 'SO',
                helpText:
                    "Book a Shuttle OnDemand when customers need a ride from or to your dealership.  Shuttle OnDemand makes it easy to provide transportation without the assets and loaner utilization. Customers do not need ride provider account or the ride provider app.<br/><br/>",
                icon: null,
                placeholderText: 'SELECT TYPE OF TRIP'
            },
            {
                marketingGroupId: 1,
                supportsDMSSearch: false,
                systemTripTypeIds: [
                    1
                ],
                displayName: null,
                icon: null,
                badgeText: null,
                helpText:
                    "Book a Concierge Pick Up with or without a loaner for customers who don't want to visit the store for their service appointment. Concierge Pick Up improves customer spend, reduces loaner cycle times and delivers a premium customer experience.<br/><br/>"
            },
            {
                marketingGroupId: 1,
                supportsDMSSearch: false,
                systemTripTypeIds: [
                    2
                ],
                displayName: null,
                icon: null,
                badgeText: null,
                helpText:
                    "Book a Concierge Return with or without a loaner for customers who don't want to visit the store to pick up their vehicle after service. Concierge Return improves customer spend, reduces loaner cycle times and delivers a premium customer experience.<br/><br/>"
            },
            {
                marketingGroupId: 1,
                displayName: 'Mobile Service',
                systemTripTypeIds: [
                    22
                ],
                badgeText: 'MS',
                helpText: "Book a Mobile Service for customers who don't want to visit the store for their service appointment. Mobile Service allows customers to have their vehicle serviced at their home by a Mobile Tech.<br/><br/>",
                icon: null
            },
            {
                marketingGroupId: 4,
                supportsDMSSearch: false,
                systemTripTypeIds: [
                    12
                ],
                displayName: null,
                icon: null,
                badgeText: 'RO',
                helpText: "Book a Roadside OnDemand when customers are stranded with a disabled vehicle. It's fast and convenient for customers in a difficult position. Customers do not need a ride provider account or the ride provider app.<br/><br/>"
            },
            {
                marketingGroupId: 4,
                supportsDMSSearch: false,
                displayName: null,
                systemTripTypeIds: [
                    18
                ],
                badgeText: 'PO',
                helpText: "Book a Parts OnDemand when you need a Hot Shot parts delivery from or to your location.  Parts OnDemand makes it easy to deliver and receive parts while the parts truck isn't available or fast enough for your customers.  It's a great way to build your wholesale parts business without the need for additional trucks or routes.<br/><br/>",
                icon: null,
                placeholderText: 'SELECT TYPE OF TRIP'
            },
            {
                marketingGroupId: 4,
                supportsDMSSearch: false,
                displayName: null,
                systemTripTypeIds: [
                    20
                ],
                helpText: "Send a customer rideshare credit with the amount and timespan of your choosing.<br/><br/>",
                icon: null,
                badgeText: 'LO'
            },
            {
                marketingGroupId: 2,
                supportsDMSSearch: false,
                systemTripTypeIds: [
                    8
                ],
                displayName: null,
                icon: null,
                badgeText: 'TD',
                helpText:
                    "Book a Test Drive Delivery for customers who want to try a vehicle in their everyday environment like their home or office.<br/><br/>"
            },
            {
                marketingGroupId: 2,
                supportsDMSSearch: false,
                displayName: null,
                systemTripTypeIds: [
                    15
                ],
                badgeText: 'CD',
                helpText:
                    "Book a Concierge Delivery, with or without a trade in to pick up, for customers who need their newly purchased vehicle delivered to their home or office. It's a great way to say 'thank you' for the sale.<br/><br/",
                icon: null,
                placeholderText: 'SELECT TYPE OF TRIP'
            },
            {
                marketingGroupId: 2,
                displayName: null,
                isFake: false,
                systemTripTypeIds: [
                    17
                ],
                badgeText: 'DT',
                helpText: "Book a Dealer Trade when you need to move vehicles from one dealer to another. You can pick up a vehicle you purchased, deliver a vehicle you sold, or pick up and drop off at the same time.<br/><br/>",
                icon: null
            },
            {
                marketingGroupId: 2,
                displayName: null,
                systemTripTypeIds: [
                    16
                ],
                badgeText: 'IT',
                helpText: "Book an Inventory Transport to move your inventoy from lot to lot.<br/><br/>",
                icon: null
            }
        ];

        vm.baseExperiencesPanelGroups = [
            {
                marketingGroupId: 4,
                description: 'ONDEMAND EXPERIENCES',
                productGroups: _.filter(vm.baseProductGroups, {marketingGroupId: 4})
            },
            {
                marketingGroupId: 1,
                description: 'SERVICE EXPERIENCES',
                productGroups: _.filter(vm.baseProductGroups, {marketingGroupId: 1})
            },
            {
                marketingGroupId: 2,
                description: 'SALES EXPERIENCES',
                productGroups: _.filter(vm.baseProductGroups, {marketingGroupId: 2})
            },
            {
                marketingGroupId: 3,
                description: 'MORE EXPERIENCES',
                productGroups: _.filter(vm.baseProductGroups, {marketingGroupId: 3})
            }
        ];

        vm.resolvedFavoriteLocations = resolvedFavoriteLocations;
        vm.productGroupsConfigured = false;
        vm.canSetTestTrip = permissions.isSysAdmin() || permissions.isDeveloper() || permissions.isRedCapAdmin();
        vm.hasLoanerPermission = false;
        vm.resolvedTripWorkFlows = resolvedTripWorkFlows;
        vm.productGroupsConfigured = false;
        vm.selectedSearchServiceOrder = null;
        vm.serviceOrder = null;
        vm.newInvitation = null;
        vm.theTrip = null;
        vm.tripMarkers = [];
        vm.lyftInviteExpirationHours = 0;
        vm.resolvedTrip = resolvedTrip;
        vm.resolvedLocationList = resolvedLocationList;
        vm.resolvedServiceOrder = resolvedServiceOrder;
        vm.resolvedLocation = resolvedLocation;
        vm.currentUser = resolvedUser;
        vm.resolvedSystemTripType = resolvedSystemTripType;
        vm.resolvedTripType = resolvedTripType;
        vm.enumSystemTripTypes = SYSTEM_ENUMS.systemTripTypes;
        vm.shortSystemTripType = SYSTEM_ENUMS.systemTripType;
        vm.enumProductGroups = SYSTEM_ENUMS.tripTypeSelectionGroups;
        vm.bookingRules = resolvedBookingRules;
        vm.dmsVehicleYearMakeModels = null;
        vm.requiresYearDropDown = false;
        vm.testDriveTempDTT = null;
        vm.queryStringParameters = resolvedParams || {};
        vm.resolvedParentTrip = resolvedParentTrip;
        vm.customerPhoneDetail = {};
        vm.overridesPhoneDetail = {};
        vm.resolvedRO = resolvedRO;

        vm.tripWizard = {
            activeLocationList: vm.resolvedLocationList,
            recall: null,
            vehicle: null
        };

        vm.action = {
            book: 1,
            sms: 2,
            email: 3
        };

        vm.accordion = {
            steps: {
                chooseLocation: 1,
                chooseTripType: 2,
                tripSettings: 3,
                lyftCreditSettings: 4
            },
            selectedStep: vm.tripWizard.activeLocationList.length > 1 ? 1 : 2
        };

        vm.enableMessaging = function (enable) {
            rcUtilService.showHideMobileMessagingPanel(enable);
        };

        function addressNameContainsCustomerName(addressName, customerInfo) {
            let customerName = customerInfo.firstName + " " + customerInfo.lastName;

            return addressName.indexOf(customerName) > -1;
        }

        function getFormattedDealerServiceHours(dealerHours, daysToGet) {
            daysToGet = daysToGet || "186";
            let blackouts = dealerHours.blackouts;
            let today = new Date();
            let year = today.getFullYear();
            let month = today.getMonth();
            let day = today.getDate();
            let dayOfWeek;
            let ddDays = [];
            let blackoutDates = [];
            let blackoutDate;
            let i;

            let isDateInArray = function (array, value) {
                    return _.some(array, (item) => { return item.getTime() == value.getTime(); });
                };

            let isClosedDayOfWeek = function (dayOfWeek, dealerHours) {
                    let isClosed = _.some(dealerHours, (item) => {
                        return item.dayOfWeekId === dayOfWeek && item.startTime === item.endTime;
                    });

                    if (isClosed) {
                        return true;
                    }

                    let hasHours = _.some(dealerHours, (item) => {
                        return item.dayOfWeekId === dayOfWeek && item.startTime !== item.endTime;
                    });

                    if (hasHours) {
                        return false;
                    }

                    // the day isn't in there at all
                    return true;
            };

            if (blackouts) {
                for (i = blackouts.length - 1; i >= 0; i--) {
                    blackoutDate = moment(blackouts[i])._d;
                    blackoutDates.push(blackoutDate);
                }
            }

            for (i = 0; i < daysToGet; i++) {
                let jsDate = new Date(year, month, day + i);

                if (!isDateInArray(blackoutDates, jsDate)) {
                    dayOfWeek = jsDate.getDay();

                    if (!isClosedDayOfWeek(dayOfWeek, dealerHours.hours)) {
                        ddDays.push(jsDate);
                    }
                }
            }

            return ddDays;

        }

        vm.isLoading = function () {
            return vm.loadingNewServiceOrder || vm.loadingBookingRules || vm.procesingBookingRulesData || vm.loadingDMSVehicleModels || vm.resolvedTrip && !vm.theTrip.customerDate;
        };

        vm.displayProductGroupHelpModal = function (pg) {
            let buttonText = null;
            let that = this;

            if (!pg.isFake && !pg.isDisabled && !pg.needsConfiguration) {
                buttonText = "BOOK IT";
            }

            let createNewDlg = modalService.showHelpModal(pg.icon, pg.badgeText, pg.displayName, pg.helpText, true, buttonText);

            createNewDlg.then((selection) => {
                if (selection) {
                    that.productGroupSelected(pg);
                }
            });
        };

        function getTransportationSupportUrl () {
            // 9 is tranportation.  We currently don't have this in an enum, so just putting the ID here.
            return $state.href("software-help", {configId: resolvedConfig.id, productId: 9});
        }

        vm.displayProductGroupConfigurationModal = function (pg) {
            let supportUrl = getTransportationSupportUrl();

            modalService.showHelpModal(pg.icon, pg.badgeText, pg.displayName, 'Your account is currently not configured correctly for this trip type. Please contact <a href="' + supportUrl + '">customer support</a> so the issue may be resolved.', true);
        };

        vm.displayProductGroupUpgradeModal = function (pg) {
            let supportUrl = getTransportationSupportUrl();

            modalService.showHelpModal(pg.icon, pg.badgeText, pg.displayName, 'You must upgrade your account in order to get access to this trip type.  Contact <a href="' + supportUrl + '">customer support</a> for more information.', true);
        };

        vm.displayNonIntegratedROSearch = function () {
            let sysTripTypes = SYSTEM_ENUMS.systemTripType;

            if (vm.isTripType(sysTripTypes.dropoff) || 
                vm.isTripType(sysTripTypes.mobileGarage) || 
                vm.isTripType(sysTripTypes.lyftShuttleService) && vm.bookingRules && vm.bookingRules.isXTimeEnabled === false) {
                return true;
            }

            return false;
        };
        
        vm.displayROSearch = function() {
            return vm.displayIntegratedSearch() && vm.theTrip.dealerLocation.dmsEnabled === true || vm.displayNonIntegratedROSearch();
        };

        vm.displayAllLoanerFields = function () {
            return vm.theTrip && vm.theTrip.selectedTripOption && vm.theTrip.selectedTripOption.hasLoaner === 'yes' && vm.isTripType(SYSTEM_ENUMS.systemTripType.pickup);
        };
          
        vm.displayIntegratedSearch = function () {
            let trip = vm.theTrip;

            if (vm.loadingNewServiceOrder || !trip.selectedSystemTripType && !trip.selectedProductGroup) {
                return false;
            }

            if (trip.selectedSystemTripType) {
                if (trip.selectedSystemTripType.supportsDMSSearch === true) {
                    return true;
                }
            } else if (vm.productGroupSelectedRONewServiceOrder !== true && trip.selectedProductGroup.supportsDMSSearch === true) {
                return true;
            }

            return false;
        };

        vm.displayTerms = function() {
            let tripType = vm.theTrip.selectedSystemTripType;

            if (tripType) {
                return true;
            }

            return false;
        };

        vm.displayCustomerInfoFields = function () {
            let selTripType = vm.theTrip?.selectedSystemTripType;

            return selTripType?.value !== vm.shortSystemTripType.inventoryTransport;
        };

        vm.systemTripTypeSelectedIsPickupOrDropOffMG = function () {
            let sysTripTypes = SYSTEM_ENUMS.systemTripType;

            return vm.isTripType(sysTripTypes.dropoff) || vm.isTripType(sysTripTypes.pickup) || vm.isTripType(sysTripTypes.mobileGarage);
        };

        vm.displayThisIsABusiness = function () {
            let trip = vm.theTrip;
            let selTripType = trip.selectedSystemTripType;

            return selTripType && selTripType.id !== vm.shortSystemTripType.dealerTrade && selTripType.supportsLyftAPI !== true && trip.showTripSettingsForm === true && vm.loadingNewServiceOrder !== true && vm.loadingBookingRules !== true && vm.displayCustomerInfoFields();
        };

        vm.displayPrimaryVehicleInputFields = function () {
            if (!vm.theTrip.selectedSystemTripType || !vm.theTrip.dealerTripTypeInstance) return false;

            return vm.theTrip.selectedSystemTripType.supportsVehicleAssignment === true && !vm.tripWizard.vehicle && !vm.theTrip.dealerTripTypeInstance.vehicle && !vm.serviceOrder.recallId;
        };

        vm.displayStockNumber = function () {
            if (!vm.theTrip.selectedSystemTripType) return false;

            return vm.isTripType(vm.shortSystemTripType.deliverSoldVehicle) || vm.isTripType(vm.shortSystemTripType.inventoryTransport);
        };

        vm.displayDriverDropDown = function () {
            if (!vm.theTrip.selectedSystemTripType) return false;

            return vm.theTrip.selectedSystemTripType.supportsDriverAssignment === true && vm.theTrip.selectedSystemTripType.forceDisableDispatching !== true;
        };

        vm.displayPickupLocationFavoriteLocations = function () {
            if (!vm.theTrip.selectedSystemTripType) return false;

            let theTrip = vm.theTrip;
            let selTripType = theTrip.selectedSystemTripType;

            return selTripType.supportsFavoriteLocations && (selTripType.value === vm.shortSystemTripType.inventoryTransport || theTrip.selectedTripOption && theTrip.selectedTripOption.startsAtDealer === true);
        };

        vm.displayDropOffLocationFavoriteLocations = function () {
            if (!vm.theTrip.selectedSystemTripType) return false;

            let theTrip = vm.theTrip;
            let selTripType = theTrip.selectedSystemTripType;

            return selTripType.supportsFavoriteLocations && (selTripType.value === vm.shortSystemTripType.inventoryTransport || theTrip.selectedTripOption && theTrip.selectedTripOption.startsAtDealer === false);
        };

        vm.getBadgeText = function (systemTripTypeId) {
            if (!systemTripTypeId) return null;

            return $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: systemTripTypeId}, true)[0].badgeText;
        };

        vm.getBadgeIcon = function (systemTripTypeId) {
            if (!systemTripTypeId) return null;

            return $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: systemTripTypeId}, true)[0].icon;
        };

        vm.clearErrors = function () {
            vm.theTrip.apiErrors = null;
            vm.theTrip.errors = null;
            vm.confirmedErrors = [];
        };

        vm.getLocationHours = function () {
            locationService.getLocationHours(vm.theTrip.dealerLocation.id).then((response) => {
                if (response.hours.length === 0) {
                    vm.theTrip.apiErrors = "Your dealership does not have any configured hours.  Please contact your dealer administrator and ask them to configure your dealer hours.";
                    vm.theTrip.preventBooking = true;
                }
            }, (errorResponse) => {
                vm.displayToastError(errorResponse);
            });
        };

        vm.getServiceAdvisor = function (identityUserId) {
            return _.find(vm.serviceAdvisors, (advisor) => {
                return advisor.identityUserId == identityUserId;
            });
        };

        vm.enableDispatchControls = function () {
            if (permissions.isSysAdmin() || permissions.isRedCapAdmin() || vm.bookingRules && vm.bookingRules.enableDispatchControls === true) {
                return true;
            }

            return false;
        };

        vm.getServiceAdvisors = function () {
            let assignedServiceAdvisorId = null;
            
            if (vm.resolvedTrip && vm.resolvedTrip.dealer.serviceAdvisorId) {
                assignedServiceAdvisorId = vm.resolvedTrip.dealer.serviceAdvisorId;
            } else if (vm.resolvedServiceOrder && vm.resolvedServiceOrder.serviceAdvisorIdentityUserId) {
                assignedServiceAdvisorId = vm.resolvedServiceOrder.serviceAdvisorIdentityUserId;
            }

            locationService.getServiceAdvisors(vm.theTrip.dealerLocation.id, assignedServiceAdvisorId, false, null, true, true).then((response) => {
                vm.serviceAdvisors = response;
                
                vm.currentServiceAdvisor = vm.currentUser.id;

                if (vm.resolvedTrip && vm.resolvedTrip.dealer && vm.resolvedTrip.dealer.serviceAdvisorId) {
                    vm.theTrip.serviceAdvisor = vm.getServiceAdvisor(vm.resolvedTrip.dealer.serviceAdvisorId);
                } else if (vm.resolvedServiceOrder) {
                    vm.theTrip.serviceAdvisor = vm.getServiceAdvisor(vm.resolvedServiceOrder.serviceAdvisorIdentityUserId);
                } else {
                    vm.theTrip.serviceAdvisor = vm.getServiceAdvisor(vm.currentUser.id);
                }

                vm.getLocationHours();
            }, (errorResponse) => {
                vm.displayToastError(errorResponse);
            });
        };

        vm.createNewInvitation = function () {
            vm.newInvitation = {
                formattedInformationMessage: null,
                serviceOrder: null
            };
        };

        vm.displayToastError = function (errorResponse) {
            let errorMessage = 'An error occurred';

            if (errorResponse.data && errorResponse.data.exceptionMessage)
                errorMessage = errorResponse.data.exceptionMessage;
            toastr.error(errorMessage);
        };

        vm.createNewServiceOrder = function (data) {
            let qsp = vm.queryStringParameters;
            let serviceOrder = {
                    apptDate: null,
                    apptTime: null,
                    roNumber: data && data.roNumber ? data.roNumber : null,
                    hasLoaner: vm.queryStringParameters.hasLoaner !== null ? vm.queryStringParameters.hasLoaner == 0 ? 'no' : 'yes' : null,
                    recallId: null,
                    action: vm.action.book,
                    isCustomerPay: vm.bookingRules.isCustomerPay,
                    createDMSAppointment: false,
                    customerInfo: {
                        isBusiness: false,
                        companyName: null,
                        firstName: qsp.firstName || null,
                        lastName: qsp.lastName || null,
                        phoneNumber: qsp.phoneNumber || null,
                        email: qsp.emailAddress || null
                    },
                    dlInfo: {
                        number: null,
                        issuingState: null,
                        expirationMonth: null,
                        expirationYear: null
                    },
                    insInfo: {
                        carrier: null,
                        policyNumber: null,
                        expirationMonth: null,
                        expirationYear: null
                    },
                    vehicleInfo: {
                        vin: qsp.vehicleVIN || null,
                        year: qsp.vehicleYear || null,
                        make: qsp.vehicleMake || null,
                        model: qsp.vehicleModel || null,
                        transmission: qsp.vehicleTransmission || SYSTEM_ENUMS.transmissions[0]
                    },
                    dmsMake: null,
                    dmsModel: null
                };

            if (vm.isTripType(SYSTEM_ENUMS.systemTripType.deliverSoldVehicle) ||
                vm.isTripType(SYSTEM_ENUMS.systemTripType.dealerTrade)) {
                serviceOrder.vehicle2Info = {
                    vin: null,
                    year: null,
                    make: null,
                    model: null,
                    transmission: SYSTEM_ENUMS.transmissions[0]
                };
            }

            vm.serviceOrder = serviceOrder;
            vm.theTrip.isNewServiceOrder = true;
            vm.theTrip.showTripSettingsForm = true;
            vm.theTrip.lengthOfLoan = null;

            if (vm.isTripType(SYSTEM_ENUMS.systemTripType.pickup)) {
                vm.theTrip.lengthOfLoan = vm.bookingRules.promiseTimeDuration;
            }

            vm.loadingNewServiceOrder = false;

            if (vm.serviceOrder.customerInfo.phoneNumber)
                $timeout(() => {
                    vm.checkPhoneType(vm.serviceOrder.customerInfo.phoneNumber).then((result) => {
                        vm.customerPhoneDetail = result;
                        $scope.$broadcast('angularValidation.revalidate', 'phone_number');
                    });
                }, 100);

            if (vm.serviceOrder.hasLoaner === 'yes') {
                $timeout(() => { vm.setLoanerOption(vm.serviceOrder, vm.theTrip); }, 1);
            }

            vm.setMapLocation(vm.theTrip.dealerLocation);
            $rootScope.$broadcast('disableROSearch');
        };

        vm.setupTripOptions = function () {
            $timeout(() => {
                let element = angular.element("#loaner-requirements");

                if (element.length) {
                    $rootScope.$broadcast('tripOptionSelected');
                } else {
                    vm.setupTripOptions();
                }
            }, 100, 1);
        };

        vm.showCanStartEarlyCheckbox = function () {
            let trip = vm.theTrip;

            return !trip.selectedSystemTripType.supportsLyftAPI && 
            (!vm.bookingRules.defaultCanAccessEarly || (vm.resolvedTrip && !vm.resolvedTrip.canAccessEarly)) && vm.displayBookItPanel() && trip.showTripSettingsForm == true;
        };

        vm.formatDriverDropDown = function (driver, tripDriver) { return tripService.formatDriverDropDown(driver, tripDriver); };

        vm.setLoanerOption = function (serviceOrder, trip) {
            if (trip.selectedSystemTripType && trip.selectedSystemTripType.supportsLoanerVehicle) {
                let tripOptions = vm.theTrip.tripOptions;

                if (trip.tripWorkFlowId) {
                    vm.theTrip.selectedTripOption = $filter('filter')(tripOptions, {tripWorkFlowId: trip.tripWorkFlowId}, true)[0];
                } else if (trip.selectedSystemTripType.supportsLyftAPI) {
                    vm.theTrip.selectedTripOption = $filter('filter')(tripOptions, {startsAtDealer: trip.startsAtDealer}, true)[0];
                } else {
                    vm.theTrip.selectedTripOption = $filter('filter')(tripOptions, {startsAtDealer: trip.startsAtDealer, hasLoaner: serviceOrder.hasLoaner}, true)[0];
                }
            }

            if ((vm.bookingRules.disableStartAtCustomer === true && serviceOrder.hasLoaner) || (vm.bookingRules.disableStartAtCustomer === true && trip.startsAtDealer && !serviceOrder.hasLoaner)) {
                vm.removeStartAtCustomerOption();
            }

            vm.setupTripOptions();
        };

        vm.populateServiceOrder = function (serviceOrder, creatingFromServiceOrder) {
            let momentDLDate = serviceOrder.driversLicenseExpDate ? moment(serviceOrder.driversLicenseExpDate) : null;
            let momentInsDate = serviceOrder.insuranceExpDate ? moment(serviceOrder.insuranceExpDate) : null;
            let newServiceOrder = {
                    id: serviceOrder.dealerServiceOrderId,
                    hasLoaner: serviceOrder.hasLoaner ? 'yes' : 'no',
                    roNumber: serviceOrder.roNumber,
                    recallId: serviceOrder.recallId || null,
                    action: vm.action.book,
                    isCustomerPay: serviceOrder.enableCustomerPay,
                    createDMSAppointment: false,
                    contact: serviceOrder.contact,
                    customerInfo: {
                        isBusiness: !!serviceOrder.customerCompany,
                        companyName: serviceOrder.customerCompany || null,
                        firstName: serviceOrder.customerName1 || null,
                        lastName: serviceOrder.customerName2 || serviceOrder.customerCompany || null,
                        phoneNumber: serviceOrder.customerPhone && serviceOrder.customerPhone !== "0" ? serviceOrder.customerPhone : null,
                        email: serviceOrder.customerEmail || null
                    },
                    dlInfo: {
                        number: serviceOrder.driversLicenseNumber,
                        issuingState: serviceOrder.driversLicenseState,
                        expirationMonth: momentDLDate ? momentDLDate.format("MM") : null,
                        expirationYear: momentDLDate ? momentDLDate.format("YYYY") : null
                    },
                    insInfo: {
                        carrier: serviceOrder.insuranceCarrier,
                        policyNumber: serviceOrder.insurancePolicyNumber,
                        expirationMonth: momentInsDate ? momentInsDate.format("MM") : null,
                        expirationYear: momentInsDate ? momentInsDate.format("YYYY") : null
                    },
                    vehicleInfo: {
                        vin: serviceOrder.vin || null,
                        style: serviceOrder.vehicleStyleName || null,
                        year: serviceOrder.year ? parseInt(serviceOrder.year) : null,
                        make: serviceOrder.make || null,
                        model: serviceOrder.model || null,
                        stockNumber: serviceOrder.stockNumber || null,
                        transmission: serviceOrder.isManual ? SYSTEM_ENUMS.transmissions[1] : SYSTEM_ENUMS.transmissions[0]
                    },
                    customerDescriptionOfProblem: serviceOrder.customerDescriptionOfProblem || null,
                    dmsMake: serviceOrder.make || null,
                    dmsModel: serviceOrder.model || null,
                    xTimeYear: serviceOrder.year || null,
                    motorYear: serviceOrder.year || null
                };

            if (serviceOrder.appointmentDateTime) {
                newServiceOrder.appointmentDateTime = serviceOrder.appointmentDateTime;
            }

            if (serviceOrder.vehicle2Make) {
                newServiceOrder.vehicle2Info = {
                    year: serviceOrder.vehicle2Year ? parseInt(serviceOrder.vehicle2Year) : null,
                    make: serviceOrder.vehicle2Make || null,
                    model: serviceOrder.vehicle2Model || null,
                    stockNumber: serviceOrder.vehicle2StockNumber || null,
                    transmission: serviceOrder.vehicle2IsManual ? SYSTEM_ENUMS.transmissions[1] : SYSTEM_ENUMS.transmissions[0]
                };
            }

            if (serviceOrder.isVehicleNew !== null) {
                newServiceOrder.vehicleInfo.isVehicleNew = $filter('filter')(vm.newUsedOptions, {value: serviceOrder.isVehicleNew === false ? 0 : 1})[0];
            }

            if (serviceOrder.customerStreetAddress && serviceOrder.customerStreetAddress !== "") {
                vm.setCustomerHomeAddressFromServiceOrder(serviceOrder);
            }

            newServiceOrder.vehicleInfo.genericStyle = serviceOrder.vehicleStyleName;

            if (creatingFromServiceOrder && newServiceOrder.hasLoaner == 'no' && !vm.resolvedTrip && !vm.isTripType(SYSTEM_ENUMS.systemTripType.mobileGarage)) {
                vm.theTrip.startsAtDealer = vm.bookingRules.disableStartAtCustomer || vm.bookingRules.defaultNoLoanerStartAtDealer;
            }

            if (creatingFromServiceOrder && !vm.theTrip.selectedSystemTripType.supportsLyftAPI) {
                vm.setLoanerOption(newServiceOrder, vm.theTrip);
            }

            return newServiceOrder;
        };

        vm.setMakeModelDropDown = function (make, model) {
            vm.serviceOrder.dmsMake = $filter('filter')(vm.serviceOrder.xTimeYear.makes, {makeCode: make}, true)[0];

            if (vm.serviceOrder.dmsMake) {
                vm.serviceOrder.dmsModel = $filter('filter')(vm.serviceOrder.dmsMake.models, {modelCode: model}, true)[0];
            }
        };

        vm.createTripFromServiceOrder = function (serviceOrder) {
            vm.serviceOrder = vm.populateServiceOrder(serviceOrder, true);

            if (serviceOrder.serviceAdvisorIdentityUserId) {
                vm.theTrip.serviceAdvisor = vm.getServiceAdvisor(serviceOrder.serviceAdvisorIdentityUserId);
            }

            vm.updateState();
            vm.theTrip.isNewServiceOrder = false;
            vm.theTrip.showTripSettingsForm = true;

            let vehicleMake;
            let vehicleModel;

            if (vm.serviceOrder && !vm.requiresYearDropDown && vm.dmsVehicleYearMakeModels) {
                vehicleMake = vm.serviceOrder.vehicleInfo.make,
                vehicleModel = vm.serviceOrder.vehicleInfo.model;
                vm.serviceOrder.xTimeYear = vm.dmsVehicleYearMakeModels[0];
                vm.setMakeModelDropDown(vehicleMake, vehicleModel);
            } else if (vm.bookingRules.requiresMotorDataDropdown) {
                vehicleMake = vm.serviceOrder.vehicleInfo.make,
                vehicleModel = vm.serviceOrder.vehicleInfo.model;
                vm.motorYearUpdated (vehicleMake, vehicleModel);
            }
        };

        vm.setAdditionalFieldFromParent = function (trip) {
            if (trip.stops) {

                let custLoc = null;

                if (vm.theTrip.selectedSystemTripType.supportsFavoriteLocations) {
                    custLoc = trip.stops[0];
                } else {
                    custLoc = $filter('filter')(trip.stops, {stopType: 1})[0];
                }

                if (custLoc) {
                    let adr = custLoc.address;

                    vm.theTrip.customerFormattedLocation = adr.name + ' ' + adr.streetAddress + ', ' + adr.city + ' ' + adr.state + ' ' + adr.zip;

                    vm.theTrip.customerLocation = {
                        streetAddress: adr.streetAddress,
                        city: adr.city,
                        state: adr.state,
                        zip: adr.zip,
                        countryShortCode: adr.countryShortCode,
                        lat: custLoc.latLng.lat,
                        lng: custLoc.latLng.lng
                    };

                    if (vm.resolvedFavoriteLocations && vm.displayPickupLocationFavoriteLocations()) {
                        vm.theTrip.customerFormattedLocation = {
                            city: adr.city,
                            streetAddress: adr.streetAddress,
                            lat: custLoc.latLng.lat,
                            lng: custLoc.latLng.lng,
                            state: adr.state,
                            zip: adr.zip,
                            countryShortCode: adr.countryShortCode,
                            name: adr.name
                        };
                    }

                    // required for this validation to work correctly when programatically populating this field
                    $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'customer_location'); }, 1);
                    $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'gplaces'); }, 1);
                    // trigger other wizard processes
                    $timeout(() => { $scope.$broadcast('customerLocationLoadedFromRecord'); }, 1);
                }
            }

            vm.theTrip.tripNote = resolvedParentTrip.tripNote;

        };

        vm.setCustomerTimeAndLocFromTrip = function (trip) {
            vm.theTrip.customerDate = trip.customerExpectedTime;
            vm.theTrip.customerTime = moment(trip.customerExpectedTime).format("hh:mm A");
            vm.validateEditTripOriginalTime = vm.theTrip.customerTime;

            if (trip.stops) {

                let custLoc = null;

                if (vm.theTrip.selectedSystemTripType.supportsFavoriteLocations) {
                    custLoc = trip.stops[0];
                } else {
                    custLoc = $filter('filter')(trip.stops, {stopType: 1})[0];
                }

                if (custLoc) {
                    let adr = custLoc.address;

                    if (adr.name && adr.name !== adr.streetAddress && !addressNameContainsCustomerName(adr.name, vm.theTrip.serviceOrder.customerInfo)) {
                        vm.theTrip.customerLocationName = adr.name;
                        vm.theTrip.customerFormattedLocation = adr.name + ' ' + adr.streetAddress + ', ' + adr.city + ' ' + adr.state + ' ' + adr.zip;
                    } else {
                        vm.theTrip.customerFormattedLocation = adr.streetAddress + ' ' + adr.city + ', ' + adr.state + ' ' + adr.zip;
                    }

                    vm.theTrip.customerLocation = {
                        streetAddress: adr.streetAddress,
                        city: adr.city,
                        state: adr.state,
                        zip: adr.zip,
                        countryShortCode: adr.countryShortCode,
                        lat: custLoc.latLng.lat,
                        lng: custLoc.latLng.lng
                    };

                    if (vm.resolvedFavoriteLocations && vm.displayPickupLocationFavoriteLocations()) {
                        vm.theTrip.customerFormattedLocation = {
                            city: adr.city,
                            streetAddress: adr.streetAddress,
                            lat: custLoc.latLng.lat,
                            lng: custLoc.latLng.lng,
                            state: adr.state,
                            zip: adr.zip,
                            countryShortCode: adr.countryShortCode,
                            name: adr.name
                        };
                    }

                    // required for this validation to work correctly when programatically populating this field
                    $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'customer_location'); }, 1);
                    $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'gplaces'); }, 1);
                    // trigger other wizard processes
                    $timeout(() => { $scope.$broadcast('customerLocationLoadedFromRecord'); }, 1);
                }
            }


        };

        vm.setCustomerHomeAddressFromServiceOrder = function (serviceOrder) {
            if (serviceOrder.customerStreetAddress) {
                let idx = serviceOrder.customerCityStateZip.indexOf(',');
                let stateZip = serviceOrder.customerCityStateZip.substring(idx + 1, serviceOrder.customerCityStateZip.length).split(" ");

                vm.theTrip.customerHomeFormattedLocation = serviceOrder.customerStreetAddress + " " + serviceOrder.customerCityStateZip;
                vm.theTrip.customerHomeLocation = {
                    streetAddress: serviceOrder.customerStreetAddress,
                    city: serviceOrder.customerCityStateZip.substring(0, idx),
                    state: stateZip[0],
                    zip: stateZip[1],
                    countryShortCode: serviceOrder.countryShortCode
                };

                // required for this validation to work correctly when programatically populating this field
                $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'home_address'); }, 1);
                $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'gplaces'); }, 1);
            }

        };

        vm.setDropoffLocFromTrip = function (trip) {
            if (trip.stops && trip.stops.length > 1) {
                let loc = trip.stops[1].address;

                vm.theTrip.dropoffFormattedLocation = loc.streetAddress + " " + loc.city + ", " + loc.state + " " + loc.zip;
                vm.theTrip.dropoffLocation = {
                    streetAddress: loc.streetAddress,
                    city: loc.city,
                    state: loc.state,
                    zip: loc.zip,
                    countryShortCode: loc.countryShortCode,
                    lat: trip.stops[1].latLng.lat,
                    lng: trip.stops[1].latLng.lng
                };

                if (vm.resolvedFavoriteLocations && vm.displayDropOffLocationFavoriteLocations()) {
                    vm.theTrip.dropoffFormattedLocation = {
                        city: loc.city,
                        streetAddress: loc.streetAddress,
                        lat: trip.stops[1].latLng.lat,
                        lng: trip.stops[1].latLng.lng,
                        state: loc.state,
                        zip: loc.zip,
                        countryShortCode: loc.countryShortCode,
                        name: loc.name
                    };
                }

                // required for this validation to work correctly when programatically populating this field
                $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'dropoff_location'); }, 1);
                $timeout(() => { $scope.$broadcast('angularValidation.revalidate', 'gplaces'); }, 1);
            }
        };

        vm.loadTripFromRecord = function (serviceOrder, trip) {
            vm.theTrip.externalContractId = trip.externalReservationId;
            vm.theTrip.loanerConfirmationNumber = trip.loanerConfirmationNumber;
            vm.theTrip.lengthOfLoan = trip.lengthOfLoan;
            vm.theTrip.tripNote = trip.tripNote;
            vm.theTrip.startsAtDealer = !!trip.oneWayStartsAtDealer;
            vm.theTrip.tripWorkFlowId = trip.workFlowId;
            vm.serviceOrder = vm.populateServiceOrder(serviceOrder, true);
            vm.theTrip.serviceOrder = vm.serviceOrder;
            vm.setCustomerTimeAndLocFromTrip(trip);
            vm.theTrip.assignedDriver = vm.validateEditTripOriginalDriver = trip.driver;
            vm.theTrip.testTrip = trip.isTestTrip;
            vm.theTrip.isRoundTrip = trip.isRoundTrip ? "1" : "0";
            vm.theTrip.id = trip.id;
            vm.theTrip.smsOptIn = true;
            vm.theTrip.canAccessEarly = trip.canAccessEarly;

            if (trip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.inventoryTransport || trip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.dealerTrade) {
                vm.setDropoffLocFromTrip(trip);
            }

            if (vm.theTrip.isRoundTrip == "1" || vm.isTripType(SYSTEM_ENUMS.systemTripType.mobileGarage)) {
                
                let hours = trip.estimatedDuration / 3600;

                if (hours < 1 && !vm.isTripType(SYSTEM_ENUMS.systemTripType.mobileGarage)) {
                    hours = 2;
                }

                vm.theTrip.hoursNeeded = hours.toString();
            }

            if (trip && trip.tripPaths.length > 0) {
                vm.getMapDetails(trip);
            }

            vm.theTrip.showTripSettingsForm = true;

            $timeout(() => { vm.setLoanerOption(vm.serviceOrder, vm.theTrip); }, 1);
        };

        vm.createtheTrip = function () {
            let selectedTripOpt = null;

            if (vm.queryStringParameters.tripWorkflowType && !isNaN(vm.queryStringParameters.tripWorkflowType))
                selectedTripOpt = parseInt(vm.queryStringParameters.tripWorkflowType);

            let prepopulatedAddress = null;

            if (vm.queryStringParameters.streetAddress) {
                let qs = vm.queryStringParameters;

                prepopulatedAddress = qs.streetAddress;

                if (qs.city) {
                    prepopulatedAddress = prepopulatedAddress + ' ' + qs.city;
                }

                if (qs.state) {
                    prepopulatedAddress = prepopulatedAddress + ', ' + qs.state;
                }

                if (qs.zip) {
                    prepopulatedAddress = prepopulatedAddress + ' ' + qs.zip;
                }
            }

            vm.theTrip = {
                id: null,
                serviceAdvisor: null,
                assignedDriver: null,
                startsAtDealer: false,
                selectedSystemTripType: null,
                preventBooking: false,
                errors: null,
                isRoundTrip: null,
                showTripSettingsForm: false,
                serviceOrder: null,
                dealerLocation: vm.tripWizard.activeLocationList.length > 1 ? null : vm.tripWizard.activeLocationList[0],
                customerLocation: null,
                customerFormattedLocation: prepopulatedAddress,
                dropoffLocation: null,
                dropoffFormattedLocation: null,
                customerHomeLocation: null,
                customerHomeFormattedLocation: null,
                hoursNeeded: '0',
                dealerTripTypeInstance: null,
                earliestPickupTime: null,
                customerDate: null,
                customerTime: null,
                vehicleModelId: null,
                smsOptIn: false,
                tripOptId: selectedTripOpt,
                referenceNumber: vm.queryStringParameters.reference || null,
                rideProviderType: vm.resolvedSystemTripType != null ? vm.resolvedSystemTripType.rideProviderType : null
            };
        };
        
        vm.getBookTooltip = function () {
            if (vm.theTrip.showTripSettingsForm == true && vm.loanerCriteriaSelected() == true && !vm.theTrip.smsOptIn) {
                return 'Agreeing to receive texts is required.';
            } else {
                return '';
            }
        };

        // Initialize the trip
        vm.createtheTrip();


        vm.loanerCriteriaSelected = function () {
            if (!vm.theTrip || !vm.serviceOrder) return false;

            if (vm.theTrip.selectedSystemTripType && !vm.theTrip.selectedSystemTripType.supportsLoanerVehicle) return true;

            if (vm.serviceOrder.hasLoaner == null || (vm.serviceOrder.hasLoaner === "no" && vm.theTrip.selectedSystemTripType.supportsStartAtCustomer && vm.theTrip.startsAtDealer == null)) return false;

            return vm.theTrip.selectedTripOption !== null && vm.theTrip.selectedTripOption !== undefined;
        };

        vm.displayBookItPanel = function () {
            if (!vm.experiencesPanelGroups || !vm.theTrip || !vm.serviceOrder || vm.isLoading() == true) return false;

            if (vm.resolvedTrip && !vm.theTrip.customerDate) return false; // still loading

            return vm.serviceOrder && (vm.serviceOrder.id || vm.theTrip.isNewServiceOrder) && vm.serviceOrder.action === vm.action.book;
        };

        vm.displayEmailSMSPanel = function () {
            if (!vm.experiencesPanelGroups || !vm.theTrip || !vm.serviceOrder) return false;

            return vm.serviceOrder && (vm.serviceOrder.id || vm.theTrip.isNewServiceOrder) && vm.serviceOrder.action !== vm.action.book;
        };

        vm.getFormattedInvitationMessage = function () {
            if (vm.gettingFormattedMessage) {
                return;
            }

            $scope.$broadcast('angularValidation.revalidate', 'first_name');
            $scope.$broadcast('angularValidation.revalidate', 'last_name');
            $scope.$broadcast('angularValidation.revalidate', 'service_advisor');
            $scope.$broadcast('angularValidation.revalidate', 'phone_number');
            $scope.$broadcast('angularValidation.revalidate', 'email');
            $scope.$broadcast('angularValidation.revalidate', 'appt_time');
            $scope.$broadcast('angularValidation.revalidate', 'appt_date');

            if (vm.serviceOrder) {
                let custInfo = vm.serviceOrder.customerInfo;

                if (custInfo.firstName && custInfo.lastName && (vm.serviceOrder.action === vm.action.email && custInfo.email || vm.serviceOrder.action === vm.action.sms && custInfo.phoneNumber && vm.theTrip.serviceAdvisor)) {
                    vm.gettingFormattedMessage = true;
                    vm.theTrip.invitationMessage = "Retrieving formatted message...";

                    tripTypeService.getTripTypeFormattedMessage(vm.theTrip, vm.serviceOrder, parseInt(vm.serviceOrder.action) - 1).then((response) => {
                        vm.gettingFormattedMessage = false;

                        if (response) {
                            if (response.body)
                                vm.theTrip.invitationMessage = response.body;
                            if (response.subject)
                                vm.theTrip.invitationSubject = response.subject;
                            if (response.lyftInviteExpirationHours)
                                vm.lyftInviteExpirationHours = response.lyftInviteExpirationHours;
                        }
                    }, (errorResponse) => {
                        vm.gettingFormattedMessage = false;
                        vm.displayToastError(errorResponse);
                    });
                }
            }
        };

        vm.serviceOrderActionUpdated = function () {
            vm.serviceOrder.action = parseInt(vm.serviceOrder.action);
            vm.invitationSent = false;

            if (vm.theTrip) {
                vm.theTrip.invitationMessage = null;
                vm.theTrip.invitationSubject = null;
            }

            if (vm.serviceOrder.action !== vm.action.book) {
                vm.updateDateOptions(new Date(), "#appt_date");
                vm.getFormattedInvitationMessage();
            }

            // If trip type is a lyft and we just selected SMS
            if (vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.serviceOrder.action === vm.action.sms.toString()) {
                let spendingCap = vm.bookingRules.monthlySpendingCap || 0;

                if (spendingCap > 0) {
                    bookingService.getMonthlyChargeInfo(vm.theTrip.dealerLocation.id, vm.theTrip.dealerTripTypeInstance.id).then((capInfo) => {
                        // This is a self-defined code as the other error codes come from the TripVerificationResult enum on the server.  We may want to consider handling this on the server in the future.
                        let spendingErrorCode = 666;
                        let cumulativeCharges = capInfo.totalActualCharges + capInfo.totalPendingCharges;

                        vm.theTrip.monthlyChargesSnapshot = cumulativeCharges;

                        _.remove(vm.confirmedErrors, (err) => {
                            return err.code === spendingErrorCode || err === spendingErrorCode;
                        });

                        _.remove(vm.theTrip.errors, (err) => {
                            return err.code === spendingErrorCode;
                        });

                        if (cumulativeCharges > spendingCap) {
                            let capError = {message: 'This trip will cause the monthly spending limit to be exceeded.  Current spend: $' + cumulativeCharges.toFixed(2) + ' of $' + spendingCap, code: spendingErrorCode, allowOverride: true};

                            if (!vm.theTrip.errors)
                                vm.theTrip.errors = [];

                            vm.theTrip.errors.push(capError);
                        }
                    });
                }
            }
        };

        vm.removeStartAtCustomerOption = function () {
            _.remove(vm.theTrip.tripOptions, (e) => {
                return e.logisticType === 1 && e.oneWayStartsAtDealer === false;
            });
        };

        vm.removeToFromAnyLocationOption = function () {
            vm.theTrip.tripOptions = vm.theTrip.tripOptions.filter((e) => {
                return e.tripWorkFlowId !== SYSTEM_ENUMS.tripWorkflowTypes.partsOnDemandToFromAny;
            });
        };
        
        vm.loadContact = function () {
            if (!vm.theTrip) return;

            let phoneNumber = vm.customerPhoneDetail.phoneNumber;

            if (phoneNumber && phoneNumber.length >= 10) {
                messagesService.getContacts({dealer: vm.theTrip.dealerLocation.id, query: phoneNumber.replace(/\D/g, ''), allowDisabledDealers: true})
                    .then((contacts) => {
                        if (contacts.length) {
                            vm.contact = contacts[0];
                        } else {
                            vm.contact = {
                                id: 0,
                                dealerId: vm.theTrip.dealerLocation.id,
                                firstName: vm.serviceOrder.customerInfo.firstName,
                                lastName: vm.serviceOrder.customerInfo.lastName,
                                email: vm.serviceOrder.customerInfo.email,
                                mobilePhone: phoneNumber
                            };
                        }

                        $rootScope.$broadcast('messagePaneContactUpdate', vm.contact);
                    });
            } else {
                $rootScope.$broadcast('messagePaneContactUpdate', null);
            }
        };

        vm.procesBookingRulesData = function (loadFromRecord) {
            if (!vm.bookingRules || !vm.serviceOrder) {
                vm.procesingBookingRulesData = false;

                return;
            }

            // enforce default test mode for new trips
            if (vm.bookingRules.enableTestMode === true && !vm.theTrip.id) {
                vm.theTrip.testTrip = true;
            } else if (!vm.theTrip.id) {
                vm.theTrip.testTrip = false;
            } // else - don't change the value

            if (vm.bookingRules.requiresMakeModelDropdown) {
                vm.getDMSVehicleModels();
            }

            if (vm.bookingRules.requiresMotorDataDropdown) {
                vm.getMotorDataVehicleYears();
            }

            if (!vm.theTrip.id) {
                vm.theTrip.canAccessEarly = vm.bookingRules.defaultCanAccessEarly;
            }

            if (vm.bookingRules.disableStartAtCustomer === true && !vm.theTrip.id) {
                vm.removeStartAtCustomerOption();
            }

            if (vm.bookingRules.enableToFromAnyLocation === false && !vm.theTrip.id) {
                vm.removeToFromAnyLocationOption();
            }

            vm.procesingBookingRulesData = false;

        };

        // new motor data calls
        vm.getMotorDataVehicleYears = function () {
            vm.updatingYears = true;
            locationService.getVehicleYears(vm.theTrip.dealerLocation.id)
            .then((years) => {
                vm.motorVehicleYears = years;
                
                if (vm.serviceOrder && vm.serviceOrder.vehicleInfo && vm.serviceOrder.vehicleInfo.year) {
                    let vehicleYear = vm.serviceOrder.vehicleInfo.year;
                    let vehicleMake = vm.serviceOrder.vehicleInfo.make;
                    let vehicleModel = vm.serviceOrder.vehicleInfo.model;

                    vm.serviceOrder.motorYear = vehicleYear;

                    if (vm.serviceOrder.motorYear) {
                        vm.motorYearUpdated(vehicleMake, vehicleModel);
                    }
                    
                    
                }

                vm.updatingYears = false;
            });
        };

        vm.motorYearUpdated = function (makeToSelect, modelToSelect) {

            if (vm.lastMotorGetMakesYear !== vm.serviceOrder.motorYear || !vm.motorVehicleMakes) {
                vm.updateVehicleMakes = true;
                vm.lastMotorGetMakesYear = vm.serviceOrder.motorYear;
                locationService.getVehicleMakesInYear(vm.theTrip.dealerLocation.id, vm.serviceOrder.motorYear)
                .then((result) => {
                    vm.motorVehicleMakes = result;
                    vm.serviceOrder.dmsMake = null;
                    vm.serviceOrder.dmsModel = null;
                   
                    vm.lastMotorGetModelMake.makeCode = null;
                    vm.lastMotorGetModelMake.modelCode = null;

                    if (makeToSelect) {
                        vm.selectMotorMakeInDropDown(makeToSelect);
                    }

                    vm.motorMakeUpdated(modelToSelect);
                    vm.updateVehicleMakes = false;
                })
                .finally(() => {
                    vm.updateVehicleMakes = false;
                });
            } else {
                if (makeToSelect) {
                    //vm.ensureVehicleMakeInDropDown(makeToSelect);
                    vm.selectMotorMakeInDropDown(makeToSelect);
                }

                vm.motorMakeUpdated(modelToSelect);
            }
        };

        vm.disableMotorMake = function () {
            return !vm.serviceOrder.motorYear ||
                vm.updateVehicleMakes ||
                vm.updatingYears;
        };

        vm.motorMakeUpdated = function (modelToSelect) {
            let make = vm.serviceOrder.dmsMake;

            vm.serviceOrder.vehicleInfo.make = make ? make.makeCode : null;

            if (make && vm.lastMotorGetModelMake.makeCode !== make.makeCode) {
                vm.updateVehicleModels = true;
                vm.lastMotorGetModelMake = make;
                vm.deferred = $q.defer();
                locationService.getVehicleModels(vm.theTrip.dealerLocation.id, vm.serviceOrder.motorYear, make.make)
                .then((result) => {
                    vm.motorVehicleModels = result;
                    vm.serviceOrder.dmsModel = null;

                    if (modelToSelect) {
                        //vm.ensureVehicleModelInDropDown(modelToSelect);
                        setTimeout(() => {
                            vm.selectMotorModelInDropDown(modelToSelect);
                        }, 1);
                    }

                    vm.deferred.resolve(true);

                    vm.updateVehicleModels = false;

                })
                .finally(() => {
                    vm.updateVehicleModels = false;
                });
            }
        };

        vm.selectMotorMakeInDropDown = function(makeToSelect) {
            let compareTo = makeToSelect.toLowerCase();
            let findMake = $filter('filter')(vm.motorVehicleMakes, (item) => {
                return item.makeCode.toLowerCase() === compareTo || item.make.toLowerCase() === compareTo;
            }, true);

            if (findMake && findMake.length > 0) {
                vm.serviceOrder.dmsMake = findMake[0];
                vm.serviceOrder.vehicleInfo.make = vm.serviceOrder.dmsMake ? vm.serviceOrder.dmsMake.makeCode : null;
            } 
            
        };

        vm.selectMotorModelInDropDown = function(modelToSelect) {
            let compareTo = modelToSelect.toLowerCase();
            let findModel = $filter('filter')(vm.motorVehicleModels, (item) => {
                if (item.modelCode) {
                    return item.modelCode.toLowerCase() === compareTo || item.model.toLowerCase() === compareTo;
                } else {
                    return false;
                }
            }, true);

            if (findModel && findModel.length > 0) {
                vm.serviceOrder.dmsModel = findModel[0];
                vm.serviceOrder.vehicleInfo.model = vm.serviceOrder.dmsModel ? vm.serviceOrder.dmsModel.modelCode : null;
            }

            
        };

        vm.disableMotorModel = function () {
            return !vm.serviceOrder.dmsMake ||
                vm.updatingYears ||
                vm.updateVehicleModels ||
                vm.updateVehicleMakes;
        };

        vm.getDMSVehicleModels = function () {
            if (vm.dmsVehicleYearMakeModels) {
                return;
            }

            vm.loadingDMSVehicleModels = true;
            bookingService.getDMSVehicleModels(vm.theTrip.dealerLocation.id).then((response) => {
                if (response && response.length > 0) {
                    vm.dmsVehicleYearMakeModels = response;

                    if ($filter('filter')(vm.dmsVehicleYearMakeModels, {year: null}).length === 0) {
                        vm.requiresYearDropDown = true;
                    } else {
                        vm.requiresYearDropDown = false;
                        vm.serviceOrder.xTimeYear = vm.dmsVehicleYearMakeModels[0];
                    }
                }

                if (vm.serviceOrder && vm.serviceOrder.vehicleInfo.make) {
                    let vehicleYear = vm.serviceOrder.vehicleInfo.year;
                    let vehicleMake = vm.serviceOrder.vehicleInfo.make;
                    let vehicleModel = vm.serviceOrder.vehicleInfo.model;

                    if (vm.requiresYearDropDown) {
                        vm.serviceOrder.xTimeYear = $filter('filter')(vm.dmsVehicleYearMakeModels, {year: vehicleYear})[0];

                        if (vm.serviceOrder.xTimeYear) {
                            vm.setMakeModelDropDown(vehicleMake, vehicleModel);
                        }
                    } else if (vm.dmsVehicleYearMakeModels) {
                        vm.serviceOrder.xTimeYear = vm.dmsVehicleYearMakeModels[0];
                        vm.setMakeModelDropDown(vehicleMake, vehicleModel);
                    }
                }

                vm.loadingDMSVehicleModels = false;
            }, (errorResponse) => {
                vm.displayToastError(errorResponse);
            });
        };

        vm.resetDateOptions = function () {
            vm.theTrip.availableBookingDays = null;
            vm.theTrip.availableBookingHours = null;
        };

        vm.updateDateOptions = function (initDateValue, dateElem) {
            let momentToday = moment().format("MM/DD/YYYY");

            switch (vm.serviceOrder.action) {
                case vm.action.book.toString(): // I'll book it
                    if (!vm.theTrip.customerLocation || vm.theTrip.customerLocation === "") return;  // Invalid, just return

                    // Default to 186 days
                    bookingService.getAvailableDays(vm.theTrip, vm.serviceOrder, momentToday, 186).then(
                        (days) => {
                            // If days returns nothing, display error
                            if (!days || days.length === 0) {
                                vm.displayToastError("Unable to find any dates that match requirements.");

                                return;
                            }

                            // Update UI
                            updateDaysUI(days, initDateValue, dateElem, momentToday);
                        },
                        (reject) => {
                            vm.displayToastError("Error: ", reject);
                        }
                    );
                    break;

                default: {// Invites (SMS/Email)
                    let days = getFormattedDealerServiceHours(vm.bookingRules.dealerHours);

                    updateDaysUI(days, initDateValue, dateElem, momentToday);
                }
            }
        };

        function updateDaysUI(days, initDateValue, dateElem, momentToday) {
            let formElem = dateElem || "#customer_date";
            let bookingDays = [];
            let currDay;
            let momentDay;

            momentToday = moment(momentToday, 'MM/DD/YYYY');

            if (formElem === "#customer_date") {
                vm.theTrip.availableBookingDays = null;
                vm.theTrip.availableBookingHours = null;
            } else {
                vm.serviceOrder.availableApptDays = null;
                vm.serviceOrder.availableApptHours = null;
            }

            for (let idx = 0; idx < days.length; idx++) {
                currDay = days[idx];
                momentDay = moment(currDay);

                // starting with today, fill up the drop down for 30 days and initialize it to the customer date value
                if (
                    momentDay.isSame(momentToday, "day") ||
                    momentDay.isAfter(momentToday, "day")
                ) {
                    let formattedDate = momentDay.format("M/DD/YYYY");
                    let jsDate = new Date(formattedDate);

                    // Make sure we're not including the same date twice
                    if (!_.includes(bookingDays, jsDate)) {
                        bookingDays.push(jsDate);

                        if (
                            initDateValue &&
                            moment(initDateValue).isSame(
                                momentDay,
                                "day"
                            )
                        ) {
                            vm.initDateValue = momentDay.format(
                                "MM/DD/YYYY"
                            );

                            if (vm.theTrip.customerDate != vm.initDateValue) {
                                if (formElem === "#customer_date") {
                                    vm.theTrip.customerDate = vm.initDateValue;

                                    if (
                                        vm.resolvedTrip &&
                                        !vm.validateEditTripOriginalDate
                                    ) {
                                        vm.validateEditTripOriginalDate = vm.theTrip.customerDate;
                                    }
                                } else {
                                    vm.serviceOrder.apptDate = vm.initDateValue;
                                }
                            }
                        }
                    }
                }
            }

            if (formElem === "#customer_date") {
                vm.theTrip.availableBookingDays = bookingDays;
            } else {
                vm.serviceOrder.availableApptDays = bookingDays;
            }

            if (initDateValue) {
                if (!vm.initDateValue && vm.resolvedTrip) {
                    // we are editing a trip from the past, need to add the date to the drop down
                    let jDate = new Date(initDateValue);

                    bookingDays.unshift(jDate);

                    if (formElem === "#customer_date") {
                        vm.theTrip.availableBookingDays = bookingDays;
                    } else {
                        vm.serviceOrder.availableApptDays = bookingDays;
                    }

                    $timeout(() => {
                        let date =
                                formElem === "#customer_date"
                                    ? vm.theTrip.availableBookingDays[0]
                                    : vm.serviceOrder
                                          .availableApptDays[0];
                        let month = ("0" + (date.getMonth() + 1)).slice(
                                -2
                            );
                        let day = ("0" + date.getDate()).slice(-2);
                        let frm = month +
                                "/" +
                                day +
                                "/" +
                                date.getFullYear();

                        vm.initDateValue = frm;

                        if (formElem === "#customer_date") {
                            vm.theTrip.customerDate = frm;
                        } else {
                            vm.serviceOrder.apptDate = frm;
                        }

                        $(formElem).val(vm.initDateValue).trigger('change');

                    }, 500);
                } else {
                    // there is some funkiness going on with the selects in our project and displaying a date
                    // if I don't do this ... it won't initialize correctly sometimes.  I have spent several
                    // hours testing and working through this.
                    $timeout(() => {
                        if (
                            !$(formElem).val() ||
                            $(formElem)
                                .val()
                                .indexOf("null") > -1
                        ) {
                            $(formElem).val(vm.initDateValue).trigger('change');
                        }
                    }, 500);
                }
            }
        }

        vm.hasUnresolvedErrors = function () {
            if (!vm.theTrip.errors) {
                return false;
            }

            let tripErrors = vm.theTrip.errors;
            let confirmedErrors = vm.confirmedErrors;

            return !(tripErrors.length === (confirmedErrors === undefined ? 0 : confirmedErrors.length));
        };

        vm.populateVehicleDataFromDropDowns = function () {
            if ((vm.bookingRules.isXTimeEnabled === true || vm.requiresYearDropDown) && vm.serviceOrder.xTimeYear && vm.serviceOrder.xTimeYear.year) {
                vm.serviceOrder.vehicleInfo.year = vm.serviceOrder.xTimeYear.year;
            }

            if (vm.bookingRules.requiresMotorDataDropdown) {
                vm.serviceOrder.vehicleInfo.year = vm.serviceOrder.motorYear;
            }

            if (vm.bookingRules.requiresMakeModelDropdown === true ||
                vm.bookingRules.requiresMotorDataDropdown === true) {
                if (vm.serviceOrder.dmsMake) {
                    vm.serviceOrder.vehicleInfo.make = vm.serviceOrder.dmsMake.makeCode;
                } else {
                    vm.serviceOrder.vehicleInfo.make = null;
                }

                if (vm.serviceOrder.dmsModel) {
                    vm.serviceOrder.vehicleInfo.model = vm.serviceOrder.dmsModel.modelCode;
                } else {
                    vm.serviceOrder.vehicleInfo.model = null;
                }
            }

        };

        vm.submitBookTrip = function (valid) {
            let finishBooking = function () {

                if (vm.serviceOrder.vehicle2Info && vm.serviceOrder.vehicle2Info.year === null) {
                    vm.serviceOrder.vehicle2Info = null;
                }
                
                if (vm.serviceOrder.selectedLoanerContract) {
                    vm.serviceOrder.selectedLoanerContract.externalContractId = (vm.theTrip.dealerLocation.loanerManagementSystem === SYSTEM_ENUMS.loanerManagementSystemsEnum.TSDNew
                        && vm.serviceOrder.selectedLoanerContract?.contractNumber?.startsWith('A')) ? 0 : vm.serviceOrder.selectedLoanerContract.externalContractId;
                }

                bookingService.bookTrip(vm.serviceOrder, vm.theTrip).then((response) => {
                    let alert = $q.when();

                    if (response.hasLoanerManagementBookingError) {
                        let errorMessage = 'Error: The Trip has been successfully booked, but there was an error creating the loaner reservation.  Please contact the Client Success Team if this problem persists.';
                        
                        if (response.loanerManagementBookingError) {
                            errorMessage += ' Response from loaner provider: ' + response.loanerManagementBookingError;
                        }

                        alert = modalService.showError(errorMessage);
                    }

                    alert.then(() => {
                        vm.theTrip.apiErrors = null;
                        $state.go('trip-tab-trip', {tripId: response.tripId}, {reload: true});
                        $rootScope.$broadcast('TripService.changed', vm.theTrip);
                        vm.bookingTrip = false;
                    });

                }, (errorResponse) => {
                    vm.bookingTrip = false;

                    if (errorResponse.message && errorResponse.message.exceptionMessage) {
                        vm.theTrip.apiErrors = errorResponse.message.exceptionMessage;
                    } else if (errorResponse.data.message) {
                        try {
                            let jsonResult = JSON.parse(errorResponse.data.message);

                            vm.theTrip.apiErrors = "";
                            _.forEach(jsonResult.TripVerificationResponses, (result) => {
                                if (result.errorMessage) {
                                    vm.theTrip.apiErrors += result.errorMessage;
                                }
                            });
                        } catch (e) {
                            vm.theTrip.apiErrors = errorResponse.data.message;
                        }
                    } else {
                        vm.theTrip.apiErrors = errorResponse.data.exceptionMessage;
                    }
                });
            };

            if (!vm.displayCustomerInfoFields()) {
                // get the customer fields from the 'user' set
                let user = vm.theTrip.serviceAdvisor;

                vm.serviceOrder.customerInfo.firstName = user.firstName;
                vm.serviceOrder.customerInfo.lastName = user.lastName;
                vm.serviceOrder.customerInfo.phoneNumber = user.mobilePhone;
                vm.serviceOrder.customerInfo.email = user.email;
            }

            if (vm.bookingRules.isGeneric) {
                if (!vm.serviceOrder.vehicleInfo.style || !vm.serviceOrder.vehicleInfo.style.name) {
                    vm.serviceOrder.vehicleInfo.style = {
                        name: null
                    };
                }

                vm.serviceOrder.vehicleInfo.style.name = vm.serviceOrder.vehicleInfo.genericStyle;
            }

            vm.populateVehicleDataFromDropDowns();

            if (new ValidationService().checkFormValidity($scope.tripSettingsForm)) {
                vm.bookingTrip = true;

                setTripWorkflow();

                if (vm.serviceOrder.contact && vm.serviceOrder.customerInfo.phoneNumber !== vm.serviceOrder.contact.mobilePhone) {
                    let filters = {
                        dealer: vm.theTrip.dealerLocation.id,
                        query: vm.serviceOrder.customerInfo.phoneNumber
                    };

                    messagesService.getContacts(filters)
                        .then((contacts) => {
                            if (contacts.length && contacts[0].id !== vm.serviceOrder.contact.id) {
                                messagesModalService.showDuplicatePhoneConfirm()
                                    .then(() => {
                                        // update the contact details
                                        vm.serviceOrder.contact.mobilePhone = vm.serviceOrder.customerInfo.phoneNumber;
                                        messagesService.updateContact(vm.serviceOrder.contact.id, vm.serviceOrder.contact)
                                            .then((updatedContact) => {
                                                vm.serviceOrder.contact = updatedContact;
                                                finishBooking();
                                            });
                                    }).then((declined) => {
                                        vm.bookingTrip = false;
                                    });
                            } else
                                finishBooking();
                        }
                    );
                } else
                    finishBooking();
            }
        };

        vm.submitSendInvitation = function (valid) {
            if (vm.sendingFormattedMessage || !new ValidationService().checkFormValidity($scope.tripSettingsForm)) {
                return;
            }

            let action = parseInt(vm.serviceOrder.action);

            vm.invitationSent = false;

            if (vm.serviceOrder) {
                let custInfo = vm.serviceOrder.customerInfo;

                if (custInfo.firstName && custInfo.lastName && (action === vm.action.email && custInfo.email || action === vm.action.sms && custInfo.phoneNumber)) {
                    vm.sendingFormattedMessage = true;

                    tripTypeService.sendTripTypeFormattedMessage(vm.theTrip, vm.serviceOrder, action - 1).then((response) => {
                        vm.sendingFormattedMessage = false;

                        if (response == true) {
                            vm.invitationSent = true;
                            let confirm = modalService.showYesNo('Sent Successfully', 'The invitation was sent successfully.', null, 'Ok');
                            
                            confirm.then((confirmed) => {
                                $state.go('trip-list');
                            });
                        } else {
                            modalService.showYesNo('Error', 'There was an error sending your invitation and we have been made aware of the problem.  If the issue persists, please contact your account manager.', null, 'Ok');
                        }

                    }, (errorResponse) => {
                        vm.sendingFormattedMessage = false;
                        vm.displayToastError(errorResponse);
                    });
                }
            }
        };

        vm.handleLyftError = function (result) {
            if (!result) return;
            let errorMessagesToDisplay = [];
            let error = result.error;

            if (error) {
                if (error.errorDetail) {
                    for (let key in error.errorDetail) {
                        if (Object.prototype.hasOwnProperty.call(error.errorDetail, key)) {
                            let value = error.errorDetail[key];

                            if (typeof key !== 'string') continue;

                            switch (key.toLowerCase()) {
                                case 'passenger.phone_number':
                                    if (vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.partsOnDemand && vm.theTrip.startsAtDealer) {

                                        if (authService.isFramedIn()) {
                                            if (resolvedConfig.programName === 'OE Connect')
                                                modalService.showYesNo('Error', 'An active mobile phone number is needed to complete this delivery. Please update your OEC profile.', null, 'OK');
                                        } else {
                                            // In this case the "passenger" phone number corresponds to the service advisor
                                            $scope.tripSettingsForm.service_advisor.$setValidity('serviceAdvisor.phone_number', false);
                                            $scope.tripSettingsForm.service_advisor.$error['serviceAdvisor.phone_number'] = 'The phone number for the selected user is invalid.  Please update the number or select a different user';
                                        }
                                    } else {
                                        $scope.tripSettingsForm.phone_number.$setValidity('passenger.phone_number', false);
                                        $scope.tripSettingsForm.phone_number.$error['passenger.phone_number'] = value;
                                        errorMessagesToDisplay.push(value);
                                    }

                                    break;
                                default:
                                    errorMessagesToDisplay.push(value);
                                    break;
                            }
                        }
                    }
                }

                if (error.error && error.error.toLowerCase() === 'user_already_in_ride') {
                    $uibModal.open({
                        templateUrl: 'app/areas/trip/views/modals/lyft-duplicate-trip-modal.view.html',
                        controllerAs: 'vm',
                        controller: 'DuplicateLyftTripModalController',
                        backdrop: 'static',
                        windowClass: 'top-modal',
                        keyboard: false,
                        resolve: {
                            resolvedLyftResult: function() { return result; }
                        }
                    });
                } else if (error.errorDescription) {
                    errorMessagesToDisplay.push(error.errorDescription);
                }
            }

            if (errorMessagesToDisplay.length)
                modalService.showYesNo('Oops ... we couldn\'t book the trip.', errorMessagesToDisplay.join(', '), null, 'OK');
        };
        
        vm.uberPackageSizeSelected = null;

        vm.packageSizeSelectedChange = function () {
            vm.uberPackageSizeSelected = vm.packageSizeSelected ? vm.packageSizeSelected.value : null;
        };

        vm.openPackageSizeModal = function () {
            $uibModal.open({
                templateUrl: 'packageSizeModal.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.close = $uibModalInstance.close;
                }],
                backdrop: 'static',
                keyboard: false,
                windowClass: 'top-modal'
            });
        };

        vm.submitProviderTrip = function () {
            
            if (!vm.theTrip.selectedProviderRide) {
                vm.showRideProviderMessage = true;
                vm.rideProviderMessage = 'Please select a ride before booking.';

                return;
            }

            if (rideProviderService.costTokenExpired()) {
                modalService.showYesNo('Price Expired', 'The price for the selected ride has expired.  We will update the prices now.', null, 'Ok');
                $scope.$broadcast('getProviderRides');

                return;
            }

            vm.bookingTrip = true;

            let pickupLocation = {};
            let dropoffLocation = {};
            let selectedProviderRide = vm.theTrip.selectedProviderRide;
            let customerInfo = vm.serviceOrder.customerInfo;

            if (vm.theTrip.startsAtDealer) {
                pickupLocation = vm.theTrip.dealerLocation;
                dropoffLocation = vm.theTrip.customerLocation;
            } else if (vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.lyftShuttleService ||
                vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.partsOnDemand &&
                !(vm.theTrip.selectedTripOption && vm.theTrip.selectedTripOption.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.partsOnDemandToFromAny)) {
                pickupLocation = vm.theTrip.customerLocation;
                dropoffLocation = vm.theTrip.dealerLocation;
            } else {
                pickupLocation = vm.theTrip.customerLocation;
                dropoffLocation = vm.theTrip.dropoffLocation;
            }

            if (vm.theTrip.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.partsOnDemandToDealer) {
                vm.serviceOrder.customerInfo.companyName = customerInfo.firstName;
            }

            if (!vm.theTrip.tripWorkFlowId) {
                vm.theTrip.tripWorkFlowId = vm.theTrip.selectedSystemTripType.tripWorkFlowId;
            }

            let sandboxFlowType = vm.theTrip.lyftSandboxFlowType ? vm.theTrip.lyftSandboxFlowType.value : null;

            rideProviderService.requestRide(vm.theTrip.dealerLocation.id,
                pickupLocation.lat,
                pickupLocation.lng,
                pickupLocation.streetAddress || pickupLocation.address || pickupLocation.name,
                pickupLocation.city,
                pickupLocation.state,
                pickupLocation.zip,
                pickupLocation.countryShortCode,
                dropoffLocation.lat,
                dropoffLocation.lng,
                dropoffLocation.streetAddress || dropoffLocation.address || dropoffLocation.name,
                dropoffLocation.city,
                dropoffLocation.state,
                dropoffLocation.zip,
                dropoffLocation.countryShortCode,
                selectedProviderRide.rideType,
                selectedProviderRide.rideTypeId,
                vm.serviceOrder && vm.serviceOrder.id !== -1 ? vm.serviceOrder.id : null,
                vm.theTrip.serviceAdvisor.id,
                vm.theTrip.id,
                vm.theTrip.testTrip,
                moment().add(selectedProviderRide.eta, 'seconds'),
                selectedProviderRide.estimatedDistance,
                selectedProviderRide.estimatedDuration,
                vm.serviceOrder.roNumber,
                customerInfo.phoneNumber,
                customerInfo.email,
                customerInfo.firstName,
                customerInfo.lastName,
                vm.theTrip.tripNote,
                vm.theTrip.dealerTripTypeInstance.id,
                selectedProviderRide.costToken,
                selectedProviderRide.baseCost,
                selectedProviderRide.estimatedCost,
                selectedProviderRide.maxCost,
                vm.theTrip.selectedSystemTripType.id,
                vm.theTrip.startsAtDealer,
                vm.theTrip.monthlyChargesSnapshot,
                customerInfo.companyName,
                vm.theTrip.tripWorkFlowId,
                vm.theTrip.referenceNumber,
                vm.serviceOrder.overrideServiceAdvisorFirstName,
                vm.serviceOrder.overrideServiceAdvisorLastName,
                vm.serviceOrder.overrideServiceAdvisorMobile,
                selectedProviderRide.rideProviderType,
                vm.theTrip.dropoffNote,
                sandboxFlowType,
                null,
                selectedProviderRide.primetimePercentage,
                selectedProviderRide.sandboxRunId,
                vm.uberPackageSizeSelected).then((result) => {
                    if (result && result.isSuccessful) {
                        vm.theTrip.apiErrors = null;

                        if (authService.isFramedIn()) { // if there is a parent frame, send the RedCap TripId to it
                            window.parent.postMessage(result.tripId, '*');
                        }

                        $state.go('trip-tab-trip', {tripId: result.tripId}, {reload: true});
                    } else {
                        vm.handleLyftError(result);
                        vm.bookingTrip = false;
                    }
                }, (err) => {
                    // Safely access error data, defaulting to an empty object if not available
                    const result = err?.data || {};

                    // Assign the error message from the exception
                    result.error = result.exceptionMessage ?? result.message ?? "Unknown error";

                    // Handle the Lyft-specific error
                    if (result.error) {
                        modalService.showYesNo('Oops ... we couldn\'t book the trip', result.error, null, 'OK');
                    }

                    // Mark the trip booking process as complete
                    vm.bookingTrip = false;
                });
        };

        vm.disableSMSSend = function() {
            return vm.serviceOrder.action === vm.action.sms && (vm.customerPhoneDetail.isOptedOut || vm.customerPhoneDetail.type === vm.phoneTypes.landline);
        };

        vm.submitWizardForm = function (valid) {
            vm.formSubmitted = true;

            if (!valid || vm.hasUnresolvedErrors()) {
                new ValidationService().checkFormValidity($scope.tripSettingsForm);

                if (vm.hasUnresolvedErrors()) {
                    console.log('Trip has unresolved errors, do not continue.');
                }

                return;
            }

            let phoneWarning = $q.when; // Do not show any warning

            if (vm.serviceOrder && (vm.serviceOrder.action === vm.action.book || vm.serviceOrder.action === vm.action.sms)) {
                if (vm.customerPhoneDetail.isOptedOut) {
                    phoneWarning = modalService.showOptedOutWarning.bind(null, vm.customerPhoneDetail);
                } else {
                    if (vm.customerPhoneDetail.type === vm.phoneTypes.landline) {
                        phoneWarning = modalService.showLandlineWarning;
                    } else if (vm.customerPhoneDetail.type === vm.phoneTypes.voip) {
                        phoneWarning = modalService.showVoIPWarning;
                    }
                }
            }

            phoneWarning().then(() => {
                if (vm.theTrip.selectedSystemTripType.supportsLyftAPI && new ValidationService().checkFormValidity($scope.tripSettingsForm)) {
                    if (vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftCredit) {
                        $rootScope.$broadcast('sendLyftCredit');
                    } else if (vm.serviceOrder.action === vm.action.book) {
                        vm.submitProviderTrip();
                    } else {
                        vm.submitSendInvitation(valid);
                    }
                } else {
                    if (vm.serviceOrder.customerInfo.isBusiness === true) {
                        vm.serviceOrder.customerInfo.companyName = vm.serviceOrder.customerInfo.lastName;
                    } else {
                        vm.serviceOrder.customerInfo.companyName = null;
                    }

                    if (vm.serviceOrder.action === vm.action.book) {
                        vm.submitBookTrip(valid);
                    } else {
                        vm.submitSendInvitation(valid);
                    }
                }
            });
        };

        vm.updateState = function () {
            let trip = vm.theTrip;
            let serviceOrder = vm.serviceOrder;

            if (!vm.resolvedTrip) {
                if (trip.dealerTripTypeInstance && serviceOrder && serviceOrder.id) {
                    $state.go('trip-add', {
                        locationId: trip.dealerLocation.id,
                        systemTripTypeId: trip.selectedSystemTripType.id,
                        tripTypeInstanceId: trip.dealerTripTypeInstance.id,
                        serviceOrderId: serviceOrder.id
                    },
                        {
                            notify: false
                        });
                } else if (trip.dealerTripTypeInstance) {
                    $state.go('trip-add', {
                        locationId: trip.dealerLocation.id,
                        systemTripTypeId: trip.selectedSystemTripType.id,
                        tripTypeInstanceId: trip.dealerTripTypeInstance.id,
                        serviceOrderId: null
                    },
                        {
                            notify: false
                        });
                } else if (trip.selectedSystemTripType) {
                    $state.go('trip-add', {
                        locationId: trip.dealerLocation.id,
                        systemTripTypeId: trip.selectedSystemTripType.id,
                        tripTypeInstanceId: null,
                        serviceOrderId: null
                    },
                        {
                            notify: false
                        });
                } else if (trip.dealerLocation) {
                    $state.go('trip-add', {
                        locationId: trip.dealerLocation.id,
                        systemTripTypeId: null,
                        tripTypeInstanceId: null,
                        serviceOrderId: null
                    }, {
                            notify: false
                        });
                } else {
                    $state.go('trip-add', {
                        locationId: null,
                        systemTripTypeId: null,
                        tripTypeInstanceId: null,
                        serviceOrderId: null
                    }, {
                            notify: false
                        });
                }
            }
        };

        if (vm.tripWizard.activeLocationList.length === 1 || vm.resolvedLocation) {
            $timeout(() => {
                vm.theTrip.dealerLocation = vm.resolvedLocation || vm.tripWizard.activeLocationList[0];
                $rootScope.$broadcast('oneLocation', vm.theTrip.dealerLocation);
            });
        }

        vm.getMapDetails = function (trip) {
            tripService.getTrip(trip.id).then((latestTrip) => {
                if (latestTrip.tripPaths.length > 0) {
                    vm.loadRoute(latestTrip);
                } else {
                    vm.loadRoute(null);
                }
            });
        };

        $scope.$on('updateTrip', (event, updateModel) => {
            vm.trip = updateModel.trip;
        });

        vm.displayTripLocations = function (data) {
            _.forEach(data.locationList, (location) => {
                location.latLng = {lat: location.lat, lng: location.lng};
            });

            if (!_map) return;
            
            _map.updateMap({stops: data.locationList});
        };

        vm.setMapLocation = function (location, stopType) {
            // this prevents the map from showing the dealer location over the resolved routes
            if (!_map || (resolvedTrip && resolvedTrip.id)) return;

            location.stopType = stopType || SYSTEM_ENUMS.destinationType.dealer;
            location.latLng = {lat: location.lat, lng: location.lng};

            _map.updateMap({stops: [location]});
        };

        vm.loadRoute = function (trip) {
            if (!_map) return;

            _map.updateMap(trip);
        };

        vm.overridesPhoneChanged = function(phoneNumber) {
            $scope.tripSettingsForm.overrides_phone_number.$setValidity('passenger.phone_number', true);
            vm.checkPhoneType(phoneNumber).then((result) => {
                vm.customerPhoneDetail = result;
            });
        };

		vm.serviceAdvisorChanged = function() {
            $scope.tripSettingsForm.service_advisor.$setValidity('serviceAdvisor.phone_number', true);
        };

        vm.phoneChanged = function(phoneNumber) {
            $scope.tripSettingsForm.phone_number.$setValidity('passenger.phone_number', true);
            vm.checkPhoneType(phoneNumber).then((result) => {
                vm.customerPhoneDetail = result;
                vm.loadContact();
            });
        };

        vm.checkPhoneType = function (phoneNumber) {
            let deferred = $q.defer();

            if (phoneNumber && phoneNumber.length === 10) {
                vm.isPhoneNumberValidating = true;
                messagesService.checkPhoneNumber(phoneNumber, vm.theTrip.dealerLocation.id)
                    .then((response) => {
                        deferred.resolve(response);
                    })
                    .finally(() => {
                        vm.isPhoneNumberValidating = false;
                    });
            } else {
                deferred.resolve({});
            }

            return deferred.promise;
        };

        vm.doesFooterHaveCheckboxes = function () {
            if (vm.theTrip.showTripSettingsForm === false || vm.loanerCriteriaSelected() === false) return false;

            if ((vm.theTrip.selectedSystemTripType && vm.theTrip.selectedSystemTripType.supportsDMSApptPush && vm.bookingRules.dmsPushType === 2) ||
                (vm.theTrip.selectedSystemTripType && !vm.theTrip.selectedSystemTripType.supportsLyftAPI && (!vm.bookingRules.defaultCanAccessEarly || (vm.resolvedTrip && !vm.resolvedTrip.canAccessEarly)) && vm.displayBookItPanel() && vm.theTrip.showTripSettingsForm === true) ||
                (vm.canSetTestTrip && vm.displayBookItPanel() && vm.theTrip.showTripSettingsForm === true)
            )  return true;

            return false;
        };

        function setTripWorkflow() {
            if (vm.theTrip.tripWorkflowId) return;

            let tripWorkflowId = null;
            
            switch (vm.theTrip.selectedSystemTripType.value) {
                case SYSTEM_ENUMS.systemTripType.pickup:
                case SYSTEM_ENUMS.systemTripType.dropoff:
                case SYSTEM_ENUMS.systemTripType.testdrives:
                case SYSTEM_ENUMS.systemTripType.lyftRoadSideAssistance:
                case SYSTEM_ENUMS.systemTripType.lyftShuttleService:
                case SYSTEM_ENUMS.systemTripType.deliverSoldVehicle:
                case SYSTEM_ENUMS.systemTripType.inventoryTransport:
                case SYSTEM_ENUMS.systemTripType.dealerTrade:
                case SYSTEM_ENUMS.systemTripType.partsOnDemand:
                case SYSTEM_ENUMS.systemTripType.lyftDriverReturn:
                case SYSTEM_ENUMS.systemTripType.lyftCredit:
                case SYSTEM_ENUMS.systemTripType.appointment:
                    tripWorkflowId = null; // TODO: Implement other triptype->workflow mappings in the future.  This dramatically simplifies the logic in the booking service on the server
                break;
                case SYSTEM_ENUMS.systemTripType.mobileGarage:
                    tripWorkflowId = SYSTEM_ENUMS.tripWorkflowTypes.mobileGarage;
                break;
                default:
                    tripWorkflowId = null;
                break;
            }

            if (tripWorkflowId) {
                vm.theTrip.tripWorkFlowId = tripWorkflowId;
            }
        }
    }
})();

(function () {
    'use strict';

    TripAddSettingsController.$inject = ["$q", "$rootScope", "$scope", "rcUtilService", "$compile", "$filter", "$timeout", "$interval", "modalService", "locationService", "bookingService", "tripService", "rideProviderService", "loanerService", "hereMapsService", "SYSTEM_ENUMS", "$uibModal", "permissions", "appointmentUtilService"];
    angular
        .module('redcap.trip')
        .controller('TripAddSettingsController', TripAddSettingsController);

    function TripAddSettingsController($q, $rootScope, $scope, rcUtilService, $compile, $filter, $timeout, $interval, modalService, locationService, bookingService, tripService, rideProviderService, loanerService, hereMapsService, SYSTEM_ENUMS, $uibModal, permissions, appointmentUtilService) {
        let Levenshtein = window.Levenshtein;
        let vmSettingsPnl = this;
        let parent_vm = $scope.$parent.vm;
        let currentPickupLocation;
        let currentDropoffLocation;
        let validateTripTimer;
        let VALIDATETRIP_DURATION = 60000;
        let estimatePoll;
        let estimatePollCountDown;
        let ESTIMATEPOLL_DURATION = 60000;
        let yearMakeModelTimeout = null;
        let currentYear = new Date().getFullYear();

        vmSettingsPnl.isAdminLevelUser = permissions.isAdminLevelUser();
        vmSettingsPnl.rideProviderTypes = SYSTEM_ENUMS.rideProviderType;
        vmSettingsPnl.maxVehicleYear = currentYear + 1;
        vmSettingsPnl.tripTypes = SYSTEM_ENUMS.systemTripType;
        vmSettingsPnl.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vmSettingsPnl.routeData = null;
        vmSettingsPnl.lyftPollCountDownTimer = 59;
        vmSettingsPnl.mobileMapVisible = false;

        vmSettingsPnl.isFramedIn = function () { return vmSettingsPnl.parent_vm.isFramedIn(); };

        vmSettingsPnl.selectedTripType = parent_vm.theTrip.selectedSystemTripType;
        parent_vm.userHasOverrideRuleRole = permissions.isOverrideTripRule() || permissions.isAdminLevelUser();
        vmSettingsPnl.dealerLocation = parent_vm.theTrip.dealerLocation;
       
        $scope.$on('bookingConfigChangedListener', (evt, result) => {
            if (!parent_vm.theTrip.lengthOfLoan) {
                vmSettingsPnl.promiseTimeDuration = result.promiseTimeDuration;
                parent_vm.theTrip.lengthOfLoan = result.promiseTimeDuration;
            }
        });

        // AllowCustomerToEditTrips
        // force validation for POD prepopulated address
        vmSettingsPnl.locationError2 = null;

        if (parent_vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.partsOnDemand &&
            parent_vm.theTrip.customerFormattedLocation &&
            !parent_vm.theTrip.customerLocation) {
            vmSettingsPnl.locationError2 = 'Please verify the location for parts.';
        }

        vmSettingsPnl.loanerTripTypes = [
            SYSTEM_ENUMS.systemTripType.pickup,
            SYSTEM_ENUMS.systemTripType.dropoff
        ];

        if (parent_vm.theTrip.dealerLocation.loanerManagementSystem === SYSTEM_ENUMS.loanerManagementSystemsEnum.TSD) {
            //Hide contract field for TSD
            vmSettingsPnl.loanerTripTypes = [SYSTEM_ENUMS.systemTripType.pickup];
        }

        vmSettingsPnl.showTerms = function (evt, termsToShow) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }

            modalService.showCustomTerms(termsToShow);
        };

        function buildExpiresYearList() {
            let i;
            let years = [];

            for (i = currentYear; i < currentYear + 12; i++) {
                years.push(i.toString());
            }

            return years;
        }

        function revalidate(elementName) {
            $scope.$broadcast('angularValidation.revalidate', elementName);
        }

        function clearROSearch() {
            $timeout(() => {
                $('#roselect').val(null).trigger('change');
            }, 1);
        }

        function resetROSearch() {
            $timeout(() => {
                clearROSearch();
                vmSettingsPnl.enableROSearch(true);
            }, 1);
        }

        function getDayOfWeekServiceHours(dayOfWeek, dealerHours) {
            let hoursData = [];
            let hoursForDay = _.find(dealerHours, (hours) => {
                return hours.dayOfWeekId === dayOfWeek;
            });

            if (hoursForDay) {
                for (let totalMinutes = hoursForDay.startTime; totalMinutes <= hoursForDay.endTime; totalMinutes += 15) { // count minutes up until midnight next day
                    let hours = Math.floor(totalMinutes / 60);
                    let minutes = totalMinutes % 60;
                    let ampm = hours >= 12 ? 'PM' : 'AM';
                    let ampmHours = hours > 12 ? hours - 12 : hours < 1 ? 12 : hours;

                    hoursData.push((ampmHours < 10 ? '0' + ampmHours : ampmHours) + ':' + (minutes === 0 ? '00' : minutes) + ' ' + ampm);
                }
            }

            return hoursData;
        }

        function filterHoursByExcludedTimes(selectedDate, earliestPickupTime, dealerHours, excludedTimes, theTrip) {
            let allowedTimes = [];
            let excluded = false;
            let timeZoneId = excludedTimes.timeZoneDetail.timeZoneId;
            let inputDate = moment(selectedDate).tz(timeZoneId);
            let todaysDate = moment.tz(timeZoneId);
            let isTodayOrPastDate = false;
            let jsDate1 = moment.tz(timeZoneId);
            let jsDate2 = moment.tz(timeZoneId);
            let jsDateEarliest = new Date(earliestPickupTime);
            let customerTime = theTrip.customerTime;
            let initializing = parent_vm.resolvedTrip && vmSettingsPnl.initializeTimeDropdown;

            // call setHours to take the time out of the comparison
            if (inputDate.toDate().setHours(0, 0, 0, 0) <= todaysDate.toDate().setHours(0, 0, 0, 0)) {
                isTodayOrPastDate = true;
            }

            for (let hourIndex = 0; hourIndex < dealerHours.length; hourIndex++) {
                let dealerHour = dealerHours[hourIndex];

                excluded = _.some(excludedTimes.unavailableTimes, (excludedTime) => {
                    return dealerHour === moment(excludedTime.dateTime).format('hh:mm A');
                });

                if (!excluded || initializing && dealerHour === customerTime) {
                    let isPast = false;

                    if (isTodayOrPastDate && dealerHour !== earliestPickupTime) {
                        let hour;
                        let tempHour = parseInt(dealerHour.slice(0, 2));
                        let min = parseInt(dealerHour.slice(3, 5));
                        let ampm = dealerHour[6];

                        if (ampm === 'A') {
                            hour = tempHour === 12 ? 0 : tempHour;

                        } else {
                            hour = tempHour !== 12 ? tempHour + 12 : tempHour;
                        }

                        jsDate2 = jsDate2.set({
                            'hour': hour,
                            'minute': min,
                            'second': 0
                        });

                        if (jsDate2 < jsDate1 || jsDate2 < jsDateEarliest) {
                            isPast = true;
                        }
                    }

                    if (!isPast) {
                        allowedTimes.push(dealerHour);
                    }
                }
            }

            return allowedTimes;
        }

        function clearTimers() {
            vmSettingsPnl.lyftPollCountDownTimer = 60;

            // clean up the estimate Poll interval
            if (angular.isDefined(estimatePoll)) {
                $interval.cancel(estimatePoll);
                estimatePoll = undefined;
            }

            // clean up the countdown timer for Lyft
            if (angular.isDefined(estimatePollCountDown)) {
                $interval.cancel(estimatePollCountDown);
                estimatePoll = undefined;
            }

            vmSettingsPnl.clearCustomerTripTimer();
        }

        vmSettingsPnl.displayCustomTerms = function (terms, evt) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }

            let termsToShow = terms || parent_vm.bookingRules.termsOfUseCopy;

            modalService.showCustomTerms(termsToShow);
        };

        vmSettingsPnl.displayMap = function () {
            let trip = parent_vm.theTrip;

            return trip.showTripSettingsForm === true ||
                (trip.showTripSettingsForm === false && parent_vm.displayIntegratedSearch());
        };

        vmSettingsPnl.buildFavoriteLocationsDisplay = function () {
            vmSettingsPnl.displayFavoriteLocations = _.cloneDeep(parent_vm.favoriteLocations);

            let theDealership = _.cloneDeep(parent_vm.theTrip.dealerLocation);

            theDealership.isMyDealership = true;
            theDealership.id = 999;
            theDealership.displayName = 'My Dealership';
            vmSettingsPnl.displayFavoriteLocations.unshift(theDealership);

            if (parent_vm.bookingRules.allowDealerLocationManagement === true) {
                let manageLocations = {};

                manageLocations.id = -1;
                manageLocations.displayName = 'Manage Locations';
                vmSettingsPnl.displayFavoriteLocations.push(manageLocations);
            }

            if (parent_vm.theTrip.customerFormattedLocation && parent_vm.displayPickupLocationFavoriteLocations()) {
                let custLoc = $filter('filter')(vmSettingsPnl.displayFavoriteLocations, {address: parent_vm.theTrip.customerFormattedLocation.streetAddress, city: parent_vm.theTrip.customerFormattedLocation.city})[0];

                if (custLoc) {
                    parent_vm.theTrip.customerFormattedLocation.id = custLoc.id;
                }
            }

            if (parent_vm.theTrip.dropoffFormattedLocation && parent_vm.displayDropOffLocationFavoriteLocations()) {
                let doLoc = $filter('filter')(vmSettingsPnl.displayFavoriteLocations, {address: parent_vm.theTrip.dropoffFormattedLocation.streetAddress, city: parent_vm.theTrip.dropoffFormattedLocation.city})[0];

                if (doLoc) {
                    parent_vm.theTrip.dropoffFormattedLocation.id = doLoc.id;
                }
            }
        };

        vmSettingsPnl.options = {
            watchEnter: true,
            country: 'us,can',
            startLat: parent_vm.theTrip.dealerLocation.lat,
            startLng: parent_vm.theTrip.dealerLocation.lng
        };

        vmSettingsPnl.invalidSearchTerm = '';
        vmSettingsPnl.transmissions = SYSTEM_ENUMS.transmissions;
        vmSettingsPnl.usStates = SYSTEM_ENUMS.usStates;
        vmSettingsPnl.calendarMonths = SYSTEM_ENUMS.calendarMonths;
        vmSettingsPnl.calendarYears = buildExpiresYearList();
        vmSettingsPnl.placeHolderText = {
            roAppt: 'Search or enter RO #',
            customerLocation: '',
            dropOffLocation: '',
            customerDate: '',
            customerTime: ''
        };

        vmSettingsPnl.transmissionChanged = function () {
            if (!vmSettingsPnl.loading) {
                vmSettingsPnl.resetDriver();
            }
        };

        vmSettingsPnl.revalidateInput = function (inputName) {
            $timeout(() => { revalidate(inputName); }, 1);
        };

        vmSettingsPnl.validation = {
            valTransmissions: function () {
                let ret = parent_vm.serviceOrder.vehicleInfo.transmission !== null;

                return {isValid: ret, message: 'Required'};
            },
            valYear: function () {
                return rcUtilService.isValidYear(parent_vm.serviceOrder.vehicleInfo.year, 1950, vmSettingsPnl.maxVehicleYear);
            },
            valYear2: function () {
                return rcUtilService.isValidYear(parent_vm.serviceOrder.vehicle2Info.year, 1950, vmSettingsPnl.maxVehicleYear);
            },
            valEstHours: function (hours) {
                
                let temp = parseInt(hours);

                if (temp < 0) {
                    return {isValid: false, message: 'Must Be Greater Than Zero'};
                }

                return {isValid: true, message: ''};
            },
            dlDate: function () {
                if (parent_vm.bookingRules.disableDriversLicense === true) {
                    return true;
                }

                let dlInfo = parent_vm.serviceOrder.dlInfo;

                if (!dlInfo.expirationMonth || !dlInfo.expirationYear) {
                    return {isValid: false, message: 'Month and Year Required'};
                }

                let driversLicenseExpirationDate = new Date(dlInfo.expirationMonth + '/01/' + dlInfo.expirationYear);

                return {isValid: driversLicenseExpirationDate > new Date(), message: 'License Expired'};
            },
            insDate: function () {
                if (parent_vm.bookingRules.disableInsurance === true) {
                    return true;
                }

                let insInfo = parent_vm.serviceOrder.insInfo;

                if (!insInfo.expirationMonth || !insInfo.expirationYear) {
                    return {isValid: false, message: 'Month and Year Required'};
                }

                let insurancePolicyExpirationDate = new Date(insInfo.expirationMonth + '/01/' + insInfo.expirationYear);

                return {isValid: insurancePolicyExpirationDate > new Date(), message: 'Insurance Expired'};
            },
            phone: function (fieldValue) {
                if (fieldValue === undefined || !fieldValue)
                    return {isValid: false, message: 'Required.'};

                fieldValue = fieldValue.replace(/\D/g, '');

                return {isValid: fieldValue.length === 10, message: 'Required.'};
            },
            phoneNumberRequired: function(number) {
                if (number) {
                    number = number.replace(/\D/g, '');
                }

                return appointmentUtilService.validatePhoneNumber(number);
            }
        };

        vmSettingsPnl.dropOffLocChanged = function () {
            if (parent_vm.theTrip.customerLocation !== null && parent_vm.theTrip.dropoffLocation !== null) {
                if (vmSettingsPnl.isPartsOnDemandToFromAny()) {
                    vmSettingsPnl.revalidateInput('customer_location');
                }
            }
        };

        vmSettingsPnl.customerLocChanged = function () {
            if (parent_vm.theTrip.customerLocation !== null && parent_vm.theTrip.dropoffLocation !== null) {
                if (vmSettingsPnl.isPartsOnDemandToFromAny()) {
                    vmSettingsPnl.revalidateInput('dropoff_location');
                }
            }
        };

        vmSettingsPnl.loading = false;
        vmSettingsPnl.roApptSearch = null;

        vmSettingsPnl.isOpen = function () {
            return parent_vm.accordion.selectedStep === parent_vm.accordion.steps.tripSettings;
        };

        vmSettingsPnl.displayNewRecordHeader = function () {
            let trip = parent_vm.theTrip;

            if (!trip || !trip.selectedSystemTripType) { return false; }

            return trip.isNewServiceOrder && trip.selectedSystemTripType.supportsDMSSearch === true;
        };

        vmSettingsPnl.displayLoanerSelection = function () {
            let trip = parent_vm.theTrip;

            if (!trip || !trip.selectedSystemTripType || trip.selectedSystemTripType.requiresGroupSelection && !parent_vm.tripWizard.vehicle || trip && trip.isNewServiceOrder && !parent_vm.loanerCriteriaSelected()) { return false; }

            if (trip && trip.selectedSystemTripType && trip.selectedSystemTripType.supportsLoanerVehicle && parent_vm.serviceOrder && parent_vm.serviceOrder.hasLoaner !== null) { return true; }
        };

        vmSettingsPnl.displayFirstVehicleStockNumber = function () {
            let selTripType = parent_vm.theTrip.selectedSystemTripType;

            return selTripType.value === parent_vm.shortSystemTripType.dealerTrade || selTripType.value === parent_vm.shortSystemTripType.deliverSoldVehicle || selTripType.value === parent_vm.shortSystemTripType.inventoryTransport || parent_vm.bookingRules.isGeneric;
        };

        vmSettingsPnl.displaySecondVehicleStockNumber = function () {
            let selTripType = parent_vm.theTrip.selectedSystemTripType;

            return selTripType.value === parent_vm.shortSystemTripType.inventoryTransport || selTripType.value === parent_vm.shortSystemTripType.dealerTrade;
        };

        vmSettingsPnl.updateLyftPlaceHolderText = function () {
            vmSettingsPnl.placeHolderText.customerLocation = !parent_vm.theTrip.startsAtDealer ? 'PICK UP LOCATION' : 'DROP OFF LOCATION';
        };

        vmSettingsPnl.tripOptionSelected = function (initializing) {
            let selectedOption = parent_vm.theTrip.selectedTripOption;
            let placeHolders = selectedOption ? selectedOption.placeHolders : null;

            if (selectedOption) {

                parent_vm.serviceOrder.hasLoaner = selectedOption.hasLoaner;
                parent_vm.theTrip.startsAtDealer = selectedOption.startsAtDealer;
                parent_vm.theTrip.tripWorkFlowId = selectedOption.tripWorkFlowId;

                if (!initializing) {
                    vmSettingsPnl.resetDriver();
                }

                if (placeHolders) {
                    vmSettingsPnl.placeHolderText.customerLocation = placeHolders.customerLocation;
                    vmSettingsPnl.placeHolderText.dropOffLocation = placeHolders.dropOffLocation;
                }

                if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.lyftShuttleService) {
                    vmSettingsPnl.updateLyftPlaceHolderText();
                }

                parent_vm.hasLoanerPermission = parent_vm.bookingRules.products.some((item) => {
                    return item === SYSTEM_ENUMS.products.loaner;
                });

                if (parent_vm.hasLoanerPermission === true && parent_vm.theTrip.selectedTripOption.hasLoaner === 'yes' && vmSettingsPnl.loanerTripTypes.includes(parent_vm.theTrip.selectedSystemTripType.id)) {
                    vmSettingsPnl.setupLoanerContractSelect();
                }

                if (parent_vm.theTrip.selectedSystemTripType.supportsLyftAPI) {
                    vmSettingsPnl.lyftRides = null;
                    parent_vm.theTrip.selectedProviderRide = null;
                    vmSettingsPnl.updateLyftRideValues();

                    if (currentPickupLocation && currentDropoffLocation) {
                        getTripRoute(currentPickupLocation, currentDropoffLocation);
                    } else if (vmSettingsPnl.isPartsOnDemandToFromAny()) {
                        if (currentPickupLocation) {
                            parent_vm.setMapLocation(currentPickupLocation, SYSTEM_ENUMS.destinationType.customer);
                        } else if (currentDropoffLocation) {
                            parent_vm.setMapLocation(currentDropoffLocation, SYSTEM_ENUMS.destinationType.customer);
                        } else {
                            parent_vm.setMapLocation(parent_vm.theTrip.dealerLocation);
                        }
                    } else {
                        parent_vm.setMapLocation(parent_vm.theTrip.dealerLocation);
                    }

                    if (placeHolders && placeHolders.firstName) {
                        vmSettingsPnl.firstNamePlaceHolder = placeHolders.firstName;
                    } else {
                        vmSettingsPnl.firstNamePlaceHolder = 'FIRST NAME';
                    }

                    // For Parts on Demand TO your location (workflowId = 22), we aren't showing
                    // "Last Name" to make it clearer to the user that the input should be a "Business",
                    // but lastName is a required field, so we set it to a random number so it has a value.
                    if (parent_vm.theTrip.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.partsOnDemandToDealer) {
                        vmSettingsPnl.hideLastName = true;
                        parent_vm.serviceOrder.customerInfo.lastName = moment().valueOf();
                    } else {
                        vmSettingsPnl.hideLastName = false;

                        if (parent_vm.serviceOrder.customerInfo.lastName && angular.isNumber(parent_vm.serviceOrder.customerInfo.lastName)) {
                            parent_vm.serviceOrder.customerInfo.lastName = null;
                        }
                    }

                } else if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dealerTrade) {
                    parent_vm.setMapLocation(parent_vm.theTrip.dealerLocation);

                    if (!parent_vm.resolvedTrip) {
                        parent_vm.theTrip.customerLocation = null;
                        parent_vm.theTrip.customerFormattedLocation = null;
                        parent_vm.theTrip.customerDate = null;
                        parent_vm.theTrip.customerTime = null;
                        parent_vm.theTrip.earliestPickupTime = null;
                        parent_vm.theTrip.dropoffLocation = null;
                        parent_vm.theTrip.dropoffFormattedLocation = null;
                    }

                } else if (!initializing) {
                    vmSettingsPnl.validateCustomerTrip();
                }

            } else {
                parent_vm.serviceOrder.hasLoaner = null;
            }

            if (parent_vm.theTrip.selectedTripOption &&
                parent_vm.theTrip.selectedTripOption.hideSmsInvite &&
                parent_vm.serviceOrder.action !== parent_vm.action.book) {
                parent_vm.serviceOrder.action = parent_vm.action.book;
            }

            if (parent_vm.resolvedParentTrip)
                parent_vm.setAdditionalFieldFromParent(parent_vm.resolvedParentTrip);
        };

        vmSettingsPnl.displaySelectedVehicle = function () {
            let trip = parent_vm.theTrip;

            if (!trip || !trip.selectedSystemTripType) return false;

            if (!parent_vm.bookingRules || parent_vm.bookingRules && parent_vm.bookingRules.isGeneric === true) return false;

            return !trip.selectedSystemTripType.requiresGroupSelection && trip.selectedSystemTripType.requiresVehicleSelection === true && trip.dealerTripTypeInstance;
        };

        vmSettingsPnl.displaySelectedRecall = function () {
            let trip = parent_vm.theTrip;

            if (!trip || !trip.selectedSystemTripType) return false;

            return trip.selectedSystemTripType.requiresGroupSelection && trip.selectedSystemTripType.requiresVehicleSelection === true && parent_vm.tripWizard.vehicle;
        };

        vmSettingsPnl.disableDateField = function () {
            if (!parent_vm.theTrip) return true;

            if (!vmSettingsPnl.canGetEarliestPickupTime()) {
                return true;
            }

            return !parent_vm.bookingRules || parent_vm.theTrip.customerLocation === null;
        };

        vmSettingsPnl.disableTimeField = function () {
            let trip = parent_vm.theTrip;

            // Time field requires both location and date to be set
            return !trip || !parent_vm.bookingRules || trip.customerLocation === null || !trip.customerDate;
        };

        vmSettingsPnl.disableDriversField = function () {
            return vmSettingsPnl.retrievingDrivers || !parent_vm.theTrip || !parent_vm.theTrip.activeDrivers;
        };

        vmSettingsPnl.clearNewServiceOrder = function () {
            // must do this or we get a digest error
            clearROSearch();

            if (parent_vm.theTrip) {
                vmSettingsPnl.clearTripSettings();
            }

            vmSettingsPnl.roApptSearch = null;
            parent_vm.serviceOrder = null;
            parent_vm.theTrip.isNewServiceOrder = false;
            parent_vm.theTrip.showTripSettingsForm = false;

            if (parent_vm.theTrip.selectedProductGroup && parent_vm.theTrip.selectedProductGroup.systemTripTypes.length > 1) {
                parent_vm.selectedSearchServiceOrder = null;
                parent_vm.productGroupSelectedRONewServiceOrder = null;
                parent_vm.theTrip.selectedSystemTripType = null;
                parent_vm.bookingRules = null;
            }
        };

        vmSettingsPnl.clearLoanerSettings = function () {
            parent_vm.serviceOrder.hasLoaner = null;
        };

        vmSettingsPnl.clearModelSelectedDealerTripTypeInstance = function () {
            $rootScope.$broadcast('clearModeleSelected');
        };

        vmSettingsPnl.dealerTripTypeInstanceModelSelected = function () {
            $rootScope.$broadcast('dealerTripTypeInstanceModeleSelected');
        };

        vmSettingsPnl.recallModelSelected = function () {
            $rootScope.$broadcast('recallModelSelected');
        };

        vmSettingsPnl.updateSelect2PlaceHolder = function () {
            $timeout(() => {
                let element = vmSettingsPnl.getROSelectComponent();

                if (element.length) {
                    // Because there is a bug in the select2 component and it is terrible
                    vmSettingsPnl.repairOrderSearchOptions.placeholder = vmSettingsPnl.placeHolderText.roAppt;
                    $('roselect').attr('data-placeholder', vmSettingsPnl.placeHolderText.roAppt);
                    $('#roselect').select2(vmSettingsPnl.repairOrderSearchOptions);
                } else {
                    vmSettingsPnl.updateSelect2PlaceHolder();
                }
            }, 100, 1);
        };

        vmSettingsPnl.setPlaceholderText = function () {
            if (parent_vm.theTrip.selectedSystemTripType) {
                let placeHolders = parent_vm.theTrip.selectedSystemTripType.placeHolders;
                let pTxt = vmSettingsPnl.placeHolderText;
                let pickupType = SYSTEM_ENUMS.systemTripType.pickup;

                pTxt.roAppt = parent_vm.theTrip.selectedSystemTripType.id === pickupType ? 'Search or enter appt #' : 'Search or enter RO #';
                pTxt.searchLabel = parent_vm.theTrip.selectedSystemTripType.id === pickupType ? 'APPOINTMENTS' : 'REPAIR ORDERS';
                pTxt.customerDate = placeHolders.customerDate;
                pTxt.customerTime = placeHolders.customerTime;
                pTxt.customerLocation = placeHolders.customerLocation;

                if (placeHolders.dropOffLocation) {
                    pTxt.dropOffLocation = placeHolders.dropOffLocation;
                }

            } else {
                vmSettingsPnl.placeHolderText.roAppt = 'Search or enter RO #';
                vmSettingsPnl.placeHolderText.searchLabel = 'REPAIR ORDERS';
            }

            vmSettingsPnl.updateSelect2PlaceHolder();
        };

        vmSettingsPnl.clearTripSettings = function (isClearingPrevSteps) {
            vmSettingsPnl.enableROSearch(true);
            parent_vm.serviceOrder = null;
            parent_vm.tripWizard.recall = null;
            parent_vm.tripWizard.vehicle = null;
            parent_vm.invitationSent = false;
            vmSettingsPnl.searchResults = null;
            vmSettingsPnl.roApptSearch = null;
            vmSettingsPnl.lyftRides = null;
            parent_vm.resolvedServiceOrder = null;
            parent_vm.resolvedTrip = null;
            parent_vm.customerPhoneDetail = null;
            $rootScope.$broadcast('messagePaneContactUpdate', null);
            clearTimers();

            if (parent_vm.theTrip) {
                parent_vm.clearErrors();
                parent_vm.theTrip.tripWorkFlowId = null;
                parent_vm.theTrip.selectedTripOption = null;
                parent_vm.theTrip.invitationMessage = null;
                parent_vm.theTrip.invitationSubject = null;
                parent_vm.theTrip.isRoundTrip = null;
                parent_vm.theTrip.activeDrivers = null;
                parent_vm.theTrip.validateBookingRulesResponse = null;
                parent_vm.theTrip.vehicleModelId = null;
                parent_vm.theTrip.preventBooking = false;
                parent_vm.theTrip.hoursNeeded = '0';
                parent_vm.theTrip.showTripSettingsForm = false;
                parent_vm.theTrip.isNewServiceOrder = false;
                parent_vm.theTrip.customerLocation = null;
                parent_vm.theTrip.customerFormattedLocation = null;
                parent_vm.theTrip.customerDate = null;
                parent_vm.theTrip.customerTime = null;
                parent_vm.theTrip.earliestPickupTime = null;
                parent_vm.theTrip.dropoffLocation = null;
                parent_vm.theTrip.dropoffFormattedLocation = null;
                parent_vm.theTrip.customerHomeLocation = null;
                parent_vm.theTrip.customerHomeFormattedLocation = null;
            }

            if (!isClearingPrevSteps) {
                parent_vm.updateState();
                parent_vm.accordion.selectedStep = parent_vm.accordion.steps.tripSettings;
            }
        };

        /*
         * fired on invalid search term event so that we can display
         * error of not enough characters
         */
        vmSettingsPnl.invalidSearch = function (tag) {
            if (tag !== null) {
                vmSettingsPnl.invalidSearchTerm = tag;
            }
        };

        vmSettingsPnl.searchROAppt = function (tag) {
            vmSettingsPnl.invalidSearchTerm = '';
            vmSettingsPnl.searchResults = null;
            let roSearchTerms = '';

            if (vmSettingsPnl.roApptSearch) {
                for (let searchTermCounterIndex = 0; searchTermCounterIndex < vmSettingsPnl.roApptSearch.length; searchTermCounterIndex++) {
                    roSearchTerms += vmSettingsPnl.roApptSearch[searchTermCounterIndex].text;

                    if (searchTermCounterIndex !== vmSettingsPnl.roApptSearch.length - 1) {
                        roSearchTerms += ' ';
                    }
                }
            } else if (tag) {
                roSearchTerms = tag.text;
            }


            if (roSearchTerms && !vmSettingsPnl.searching) {
                vmSettingsPnl.searching = true;

                let tripTypeId = parent_vm.theTrip.selectedSystemTripType ? parent_vm.theTrip.selectedSystemTripType.overrideROSearchTripTypeId ? parent_vm.theTrip.selectedSystemTripType.overrideROSearchTripTypeId : parent_vm.theTrip.selectedSystemTripType.id : null;

                bookingService.roSearchLight(roSearchTerms, parent_vm.theTrip.dealerLocation.id, tripTypeId).then((serviceOrders) => {
                    if (serviceOrders && !serviceOrders.requestCanceled) {
                        vmSettingsPnl.searching = false;
                        vmSettingsPnl.searchResults = serviceOrders;
                    }
                }, (errorResponse) => {
                    vmSettingsPnl.searching = false;
                    parent_vm.displayToastError(errorResponse);
                });
            }
        };

        vmSettingsPnl.getFavoriteLocations = function () {
            locationService.getVenues(parent_vm.theTrip.dealerLocation.id).then((response) => {
                parent_vm.favoriteLocations = response;
                vmSettingsPnl.buildFavoriteLocationsDisplay();
            }, (errorResponse) => {
                parent_vm.displayToastError(errorResponse);
            });
        };

        vmSettingsPnl.createTripFromSearchResult = function (serviceOrderId) {
            bookingService.getServiceOrderLight(parent_vm.theTrip.dealerLocation.id, serviceOrderId).then((result) => {
                let theTrip = parent_vm.theTrip;
              
                parent_vm.loadingBookingRules = true;
                bookingService.getRules(theTrip).then((response) => {
                    parent_vm.bookingRules = response;
                    parent_vm.loadingBookingRules = false;
                    parent_vm.createTripFromServiceOrder(result);
                    parent_vm.procesBookingRulesData();
                    vmSettingsPnl.revalidateInput('vehicle_transmission');
                    vmSettingsPnl.searchResults = null;

                    parent_vm.setMapLocation(theTrip.dealerLocation);
                },
                    (errorResponse) => {
                        parent_vm.displayToastError(errorResponse);
                        parent_vm.loadingBookingRules = false;
                    });
            });
        };


        let getSelectedTripType = function () {
            let selTripType = parent_vm.theTrip.selectedSystemTripType;
            let type = selTripType.id === SYSTEM_ENUMS.systemTripType.dropoff || selTripType.overrideROSearchTripTypeId === SYSTEM_ENUMS.systemTripType.dropoff ? 'RO' : 'Appointment';

            return type;
        };

        /*
         * Displays active trip exists warning
         */
        vmSettingsPnl.activeTripExistsWarning = function (result) {
            let confirm = $uibModal.open({
                templateUrl: 'app/areas/trip/views/modals/duplicate-active-trip-modal.view.html',
                controllerAs: 'vm',
                controller: 'DuplicateActiveTripModalController',
                backdrop: 'static',
                windowClass: 'top-modal',
                keyboard: false,
                resolve: {
                    activeTripIds: function () { return result.activeTripIds; }
                }
            }).result;

            confirm.then((confirmed) => {
                if (confirmed) {
                    vmSettingsPnl.createTripFromSearchResult(result.dealerServiceOrderId);
                } else {
                    resetROSearch();
                }
            });
        };


        /*
         * Displays trip exists warning
         */
        vmSettingsPnl.tripExistsWarning = function (roNumber) {
            let type = getSelectedTripType();
            let confirm = modalService.showYesNo('Please Confirm', 'A trip is already booked on the selected ' + type + ', are you sure you would like to book another trip on this item?', 'No', 'Yes');

            confirm.then((confirmed) => {
                if (confirmed) {
                    vmSettingsPnl.createTripFromSearchResult(roNumber);
                } else {
                    resetROSearch();
                }
            });
        };

        vmSettingsPnl.searchResultClicked = function (result) {
            if (!result) return; // create new record

            if (result.appointmentDateTime) {
                const appointmentMoment = moment(result.appointmentDateTime);

                if (appointmentMoment.isValid()) {
                    parent_vm.theTrip.customerDate = appointmentMoment.format('MM/DD/YYYY');
                    parent_vm.theTrip.customerTime = appointmentMoment.format('hh:mm A');
                }
            }

            bookingService.roTrips(parent_vm.theTrip.dealerLocation.id, result.dealerServiceOrderId).then((tripData) => {
                let activeTripIds = tripData && tripData.filter((trip) => {
                    if (trip.isActive) return true;

                    return false;
                }).map((item) => { return item.id; });

                let hasExistingTrip = tripData && tripData.length;

                if (parent_vm.theTrip.selectedSystemTripType) {
                    if (activeTripIds && activeTripIds.length && !parent_vm.resolvedServiceOrder) {
                        vmSettingsPnl.activeTripExistsWarning({
                            activeTripIds: activeTripIds,
                            dealerServiceOrderId: result.dealerServiceOrderId
                        });
                    } else if (hasExistingTrip && !parent_vm.resolvedServiceOrder) {
                        vmSettingsPnl.tripExistsWarning(result.dealerServiceOrderId);
                    } else {
                        vmSettingsPnl.createTripFromSearchResult(result.dealerServiceOrderId);
                    }
                } else {
                    bookingService.getServiceOrderLight(parent_vm.theTrip.dealerLocation.id, result.dealerServiceOrderId).then((result) => {
                        parent_vm.selectedSearchServiceOrder = result;
                    });
                }
            });
        };

        vmSettingsPnl.getRONumberFromSearchTags = function () {
            let searchTerms = vmSettingsPnl.roApptSearch;
            let length = searchTerms ? searchTerms.length : 0;
            let idx;
            let roNumber = '';

            for (idx = 0; idx < length; idx++) {
                if (roNumber !== '') {
                    roNumber += ' ';
                }

                roNumber += searchTerms[idx].text;
            }

            return roNumber;
        };

        /*
         * Displays new customer warning error message when create new is clicked.
         */
        vmSettingsPnl.createNewRecord = function (roNumber) {
            let trip = parent_vm.theTrip;
            let createNewDlg;

            let createRO = function () {
                if (trip.selectedSystemTripType) {
                    parent_vm.loadingNewServiceOrder = true;
                    let data = {};
                    let display = roNumber;

                    if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dropoff || trip.selectedSystemTripType.overrideROSearchTripTypeId === SYSTEM_ENUMS.systemTripType.dropoff) {
                        data.roNumber = roNumber;
                    }

                    // force it into the select2 display
                    $timeout(() => {
                        $('#roselect').val(null).trigger('change');
                        let option = new Option(display, -999, true, true);

                        $('#roselect').append(option).trigger('change');
                        $rootScope.$broadcast('createNewServiceOrder', data);
                    }, 1);
                } else {
                    parent_vm.productGroupSelectedRONewServiceOrder = true;
                }
            };

            if (trip.dealerLocation.dmsEnabled) {
                createNewDlg = modalService.showNewServiceOrderWarning(roNumber),
                    createNewDlg.then((results) => {
                        if (results) {
                            createRO();
                        } else {
                            resetROSearch();
                        }
                    });
            } else {
                createRO();
            }
        };

        vmSettingsPnl.productGroupTripTypeSelected = function (systemTripType) {
            let serviceOrder = parent_vm.selectedSearchServiceOrder;
            let isNew = parent_vm.productGroupSelectedRONewServiceOrder;

            $rootScope.$broadcast('clearProductGroupSelectedSystemTripType');

            if (systemTripType) {
                $timeout(() => {
                    parent_vm.selectedSearchServiceOrder = serviceOrder;
                    parent_vm.productGroupSelectedRONewServiceOrder = isNew;
                    $rootScope.$broadcast('setSelectedSystemTripType', systemTripType);
                }, 1);
            }
        };

        vmSettingsPnl.updateErrorCheckbox = function (error) {
            // Ensure that we actually have a list defined
            if (!parent_vm.confirmedErrors) {
                parent_vm.confirmedErrors = [];
            }

            if (error.isChecked) {
                parent_vm.confirmedErrors.push(error.code);
            } else {
                parent_vm.confirmedErrors.splice(parent_vm.confirmedErrors.indexOf(error.code));
            }

            if (parent_vm.confirmedErrors.length === parent_vm.theTrip.errors.length &&
                (!parent_vm.theTrip.availableBookingHours || parent_vm.theTrip.availableBookingHours.length === 0)
            ) {
                vmSettingsPnl.updateTimeOptions(parent_vm.theTrip.customerDate, parent_vm.theTrip.customerTime, false);
                
            }
        };

        function isNullOrMinValueDate(seletedDate) {
            if (!seletedDate) {  
                return true;  
            }  
            
            let dateToCheck = new Date(seletedDate);
  
            if (dateToCheck.getFullYear() < 999) {
                return true;
            } else {
                return false;
            }
        }

        vmSettingsPnl.updateTimeOptions = function (selectedDate, selectedTime, validateTrip, timeEl) {
            if (isNullOrMinValueDate (selectedDate)) return;

            // Ensure that parent_vm.serviceOrder.action is defined
            if (parent_vm.serviceOrder.action === null) {
                parent_vm.serviceOrder.action = parent_vm.action.book; // Default: "I'll book it"
            }

            switch (parent_vm.serviceOrder.action.toString()) {
                case parent_vm.action.book.toString(): // I'll book it
                    bookingService.getAvailableTimes(
                        parent_vm.theTrip,
                        parent_vm.serviceOrder,
                        selectedDate
                    ).then(
                        (times) => {
                            // If times returns nothing, display error (for new trip)
                            if ((!times || times.length === 0) && (!parent_vm.theTrip || parent_vm.theTrip.id === 0)) {
                                parent_vm.displayToastError('Unable to find any times that match requirements.');

                                return;
                            }

                            let bookingTimes = [];
                            let internalNetworkDealerAdmin = parent_vm.resolvedLocation && parent_vm.resolvedLocation.isClosedNetwork && permissions.isDealerAdmin();
                            let dnsOnly = parent_vm.resolvedLocation && !parent_vm.resolvedLocation.isClosedNetwork;
                            let isSystemAdmin = permissions.isSysAdmin() || permissions.isRedCapAdmin() || permissions.isDeveloper();
                            let idx; 
                            let currDayTime; 
                            let momentDayTime; 
                            let momentSelectedDate; 
                            let formattedTime;

                            if (internalNetworkDealerAdmin || isSystemAdmin || dnsOnly || parent_vm.userHasOverrideRuleRole) {
                                let dealerHours = parent_vm.bookingRules.dealerHours;
                                let jsSelectedDate = new Date(selectedDate);

                                bookingTimes = getDayOfWeekServiceHours(jsSelectedDate.getDay(), dealerHours.hours);

                                let availableTimes = [];

                                for (idx = 0; idx < times.length; idx++) {
                                    currDayTime = times[idx],
                                    momentDayTime = moment(currDayTime),
                                    momentSelectedDate = moment(bookingService.formatForMomentDate(selectedDate));

                                    // Only add the current day's times
                                    if (momentDayTime.isSame(momentSelectedDate, 'day')) {
                                        formattedTime = momentDayTime.format('hh:mm A');
                                        availableTimes.push(formattedTime);
                                    }
                                }

                                // Ensure that current selected time is in list, if not add it to the beginning
                                if (!_.includes(bookingTimes, selectedTime)) {
                                    availableTimes.unshift(selectedTime);
                                }

                                // Set times that come back as available
                                parent_vm.theTrip.availableTimes = availableTimes;
                            } else {
                                for (idx = 0; idx < times.length; idx++) {
                                    currDayTime = times[idx],
                                        momentDayTime = moment(currDayTime),
                                        momentSelectedDate = moment(selectedDate).format('MM/DD/YYYY');

                                    // Only add the current day's times
                                    if (momentDayTime.isSame(momentSelectedDate, 'day')) {
                                        formattedTime = momentDayTime.format('hh:mm A');
                                        bookingTimes.push(formattedTime);
                                    }
                                }

                                // Ensure that current selected time is in list, if not add it to the beginning
                                if (!_.includes(bookingTimes, selectedTime)) {
                                    bookingTimes.unshift(selectedTime);
                                }
                            }

                            // Update the UI
                            updateTimesUI(timeEl, bookingTimes, selectedTime, validateTrip);

                        }), function (errorResponse) {
                            parent_vm.displayToastError(errorResponse);
                        };

                    break;
                default: // SMS/Email
                    var dealerHours = parent_vm.bookingRules.dealerHours;
                        var jsSelectedDate = new Date(selectedDate);
                        var dealerServiceHoursForDate = getDayOfWeekServiceHours(jsSelectedDate.getDay(), dealerHours.hours);
                        var theTrip = parent_vm.theTrip;
                        var vehInfo = parent_vm.serviceOrder.vehicleInfo;

                    bookingService.getUnavailableHours(
                        theTrip.dealerLocation.id,
                        theTrip.dealerTripTypeInstance.id,
                        jsSelectedDate,
                        theTrip.customerLocation,
                        theTrip.isNewServiceOrder ? -1 : parent_vm.serviceOrder.id,
                        -1,
                        theTrip.tripWorkFlowId,
                        vehInfo.year ? vehInfo.year : null,
                        vehInfo.make ? vehInfo.make : null,
                        vehInfo.model ? vehInfo.model : null
                    ).then(
                        (response) => {
                            let hours = filterHoursByExcludedTimes(selectedDate, selectedTime, dealerServiceHoursForDate, response, theTrip);

                            // Update the UI
                            updateTimesUI(timeEl, hours, selectedTime, validateTrip);
                        });
            }
        };

        function updateTimesUI(timeEl, bookingTimes, selectedTime, validateTrip) {
            if (!timeEl) {
                parent_vm.theTrip.availableBookingHours = bookingTimes;
            } else {
                parent_vm.serviceOrder.availableApptHours = bookingTimes;
            }

            vmSettingsPnl.updatingTimes = false;

            if (vmSettingsPnl.initializeTimeDropdown) {
                if (parent_vm.theTrip && !parent_vm.theTrip.customerTime && bookingTimes && bookingTimes.length && vmSettingsPnl.selectFirstItemOnValidTimesLoad) {
                    selectedTime = bookingTimes[0];
                    vmSettingsPnl.selectFirstItemOnValidTimesLoad = false;
                }

                $timeout(() => {
                    let customerTimeElement = timeEl ? $(timeEl) : $('#customer_time');

                    if (!customerTimeElement.val() || customerTimeElement.val().indexOf('null') > -1) {
                        if (timeEl === '#appt_time') {
                            parent_vm.serviceOrder.apptTime = selectedTime;
                        } else {
                            parent_vm.theTrip.customerTime = selectedTime;
                        }

                        customerTimeElement.val(selectedTime).trigger('change');

                        vmSettingsPnl.initializeTimeDropdown = false;
                    }

                    if (validateTrip) {
                        vmSettingsPnl.validateCustomerTrip();
                    }
                }, 500);
            } else {
                if (!bookingTimes || !bookingTimes.length) {
                    parent_vm.theTrip.customerTime = '';
                    vmSettingsPnl.initializeTimeDropdown = true;
                    vmSettingsPnl.selectFirstItemOnValidTimesLoad = true;
                }

                if (validateTrip) {
                    vmSettingsPnl.validateCustomerTrip();
                }
            }
        }

        // call api earliest avail pickup time
        vmSettingsPnl.getEarliestAvailableTime = function (initializingFromDB) {
            if (parent_vm.theTrip.selectedSystemTripType.supportsLyftAPI) return;

            vmSettingsPnl.gettingEarliestPickupTime = true;
            vmSettingsPnl.initializeTimeDropdown = true;
            parent_vm.clearErrors();

            parent_vm.theTrip.validatingTrip = true;
           
            bookingService.validateEarliestTime(parent_vm.serviceOrder, parent_vm.theTrip).then((response) => {
                let outOfArea = null;

                if (response.errorMessages) {
                    outOfArea = $filter('filter')(response.errorMessages, {code: 110})[0];
                }

                vmSettingsPnl.gettingEarliestPickupTime = false;

                if (outOfArea !== null && typeof outOfArea !== 'undefined' && parent_vm.bookingRules.enableBypassBookingRules === false &&  vmSettingsPnl.isAdminLevelUser === false) {
                    if (response.errorMessages) {
                        parent_vm.theTrip.errors = response.errorMessages;
                    }

                    parent_vm.theTrip.earliestPickupTime = null;
                    parent_vm.theTrip.availableBookingDays = null;
                    parent_vm.theTrip.availableBookingHours = null;
                } else {
                    parent_vm.theTrip.earliestPickupTime = response.earliestPickupTime;
                    let initialDate = null;
                    let initialTime = null;

                    // update the date drop down box
                    if ((parent_vm.resolvedTrip && initializingFromDB) || (initializingFromDB && vmSettingsPnl.hasExistingAppointment())) {
                        // we are doing an initial update from a trip we are editing OR preserving existing appointment date.
                        parent_vm.updateDateOptions(parent_vm.theTrip.customerDate);
                        initialDate = parent_vm.theTrip.customerDate;
                        initialTime = parent_vm.theTrip.customerTime;
                    } else {
                        parent_vm.updateDateOptions(parent_vm.theTrip.earliestPickupTime);
                        initialDate = parent_vm.theTrip.earliestPickupTime;
                        initialTime = moment(parent_vm.theTrip.earliestPickupTime).format('hh:mm A');
                    }

                    vmSettingsPnl.initializeTimeDropdown = true;
                    $timeout(() => {
                        vmSettingsPnl.updateTimeOptions(initialDate, initialTime);
                    }, 1);
                }

                if (!initializingFromDB) {
                    vmSettingsPnl.validateCustomerTrip();
                } else {
                    vmSettingsPnl.getActiveDrivers(true);
                }

                parent_vm.theTrip.validatingTrip = false;
            }, (errorResponse) => {
                parent_vm.theTrip.validatingTrip = false;

                if (errorResponse.data && errorResponse.data.exceptionMessage) {
                    parent_vm.theTrip.apiErrors = errorResponse.data.exceptionMessage;
                } else {
                    parent_vm.displayToastError('An error has occurred.');
                }
            });
        };

        vmSettingsPnl.displayDriverUnavailableWarning = function (previousDriver) {
            let confirm = modalService.showYesNo('Please Confirm', 'The driver you selected is already booked for another trip at this time. Are you sure you want to continue with this driver?', 'No', 'Yes');

            confirm.then((confirmed) => {
                if (!confirmed) {
                    parent_vm.theTrip.assignedDriver = previousDriver;
                }
            });
        };

        vmSettingsPnl.driverSelectionModified = function (updatedDriver, originalDriver) {
            if (updatedDriver) {
                let manualTransmissionType = 1;

                if ((parent_vm.serviceOrder.vehicle2Info && parent_vm.serviceOrder.vehicle2Info.transmission.value === manualTransmissionType) ||
                    (parent_vm.serviceOrder.vehicleInfo && parent_vm.serviceOrder.vehicleInfo.transmission.value === manualTransmissionType)) {
                    modalService.showYesNo('Manual Transmission', 'Please confirm the selected Driver is able to drive a vehicle with a manual transmission.', 'Cancel', 'Confirm').then((confirmed) => {
                        if (confirmed) {
                            processDriverSelection(updatedDriver.id, originalDriver);
                        } else {
                            parent_vm.theTrip.assignedDriver = originalDriver;
                        }
                    });
                } else {
                    processDriverSelection(updatedDriver.id, originalDriver);
                }
            }
        };

        function processDriverSelection(updatedDriverId, originalDriver) {
            let tempDriver = $filter('filter')(parent_vm.theTrip.activeDrivers, {id: updatedDriverId})[0];

            if (tempDriver) {
                if (tempDriver.isAvailable === false) {
                    vmSettingsPnl.displayDriverUnavailableWarning(originalDriver);
                }
            }
        }

        vmSettingsPnl.getActiveDrivers = function (loadFromTrip) {
            let rulesResponse = parent_vm.theTrip.validateBookingRulesResponse;
            let resolvedTrip = parent_vm.resolvedTrip;

            if (!loadFromTrip) {
                if (!parent_vm.theTrip || !rulesResponse || !rulesResponse.tripStops) {
                    return;
                }
            } else {
                if (!resolvedTrip) {
                    return;
                }
            }

            vmSettingsPnl.retrievingDrivers = true;

            let startTime = loadFromTrip ? moment(resolvedTrip.expectedStartTime).format('MM/DD/YYYY hh:mm A') : moment(rulesResponse.startTime).utc().format('MM/DD/YYYY hh:mm A');
            let endTime = loadFromTrip ? moment(resolvedTrip.expectedEndTime).format('MM/DD/YYYY hh:mm A') : moment(rulesResponse.endTime).utc().format('MM/DD/YYYY hh:mm A'); // lower case am/pm seems to have a sporadic issue.
            let assignedDriverId = parent_vm.theTrip.assignedDriver && parent_vm.theTrip.assignedDriver.id || null;
            let currentTripId = resolvedTrip ? resolvedTrip.id : null;


            tripService.getActiveDrivers(parent_vm.theTrip.dealerLocation.id, startTime.toLowerCase(), endTime.toLowerCase(), assignedDriverId, currentTripId, parent_vm.theTrip.selectedSystemTripType.id).then((response) => {
                if (response.errorMessage) {
                    parent_vm.theTrip.errors = response.errorMessage;
                } else if (response) {
                    // insert in the --- line
                    for (let idx = response.length - 1; idx >= 0; idx--) {
                        if (response[idx].isPreferred) {
                            response.splice(idx + 1, 0, {id: -999, name: '------------------------------------------------', isAvailable: true});
                            break;
                        }
                    }

                    $timeout(() => {
                        parent_vm.theTrip.assignedDriver = $filter('filter')(parent_vm.theTrip.activeDrivers, {id: assignedDriverId})[0];
                    }, 250);

                    parent_vm.theTrip.activeDrivers = response;

                }

                vmSettingsPnl.retrievingDrivers = false;


            }, (errorResponse) => {
                parent_vm.displayToastError(errorResponse);
                vmSettingsPnl.retrievingDrivers = false;
            });
        };

        vmSettingsPnl.hourKeyDown = function(e) {
            rcUtilService.numberWithDecimal(e);
        };

        vmSettingsPnl.clearCustomerTripTimer = function () {
            if (angular.isDefined(validateTripTimer)) {
                $interval.cancel(validateTripTimer);
                validateTripTimer = undefined;
            }
        };

        vmSettingsPnl.timeExpiredCustomerTrip = function () {
            modalService.showYesNo('Oops!', 'Date, time and driver availability must be refreshed.  Please click OK and re-enter the required information to continue booking this trip.', null, 'OK')
                .then((result) => {
                    if (!parent_vm.resolvedTrip) {
                        parent_vm.theTrip.customerDate = null;
                        parent_vm.theTrip.customerTime = null;
                        parent_vm.theTrip.assignedDriver = null;
                        vmSettingsPnl.getEarliestAvailableTime();
                    } else {
                        parent_vm.theTrip.customerDate = parent_vm.validateEditTripOriginalDate;
                        parent_vm.theTrip.customerTime = parent_vm.validateEditTripOriginalTime;
                        parent_vm.theTrip.assignedDriver = parent_vm.validateEditTripOriginalDriver;

                    }
                });
        };


        vmSettingsPnl.validateCustomerTrip = function () {
            vmSettingsPnl.clearCustomerTripTimer();

            let trip = parent_vm.theTrip;

            if (trip.customerLocation === null || !trip.selectedSystemTripType.supportsLyftAPI && (trip.customerDate === null || !trip.customerTime))
                return;

            parent_vm.theTrip.validateBookingRulesResponse = null;
            parent_vm.theTrip.validatingTrip = true;
            parent_vm.clearErrors();
            bookingService.validateBookingRules(parent_vm.serviceOrder, parent_vm.theTrip).then((bookingRules) => {
                if (bookingRules.errorMessages) {
                    parent_vm.theTrip.errors = bookingRules.errorMessages;
                }

                if (!bookingRules.errorMessages || parent_vm.bookingRules.enableBypassBookingRules === true) {
                    parent_vm.theTrip.validatingTrip = false;
                    parent_vm.theTrip.validateBookingRulesResponse = bookingRules;
                    vmSettingsPnl.getActiveDrivers();

                    if (bookingRules.tripStops) {
                        let dispLocations = [];

                        _.forEach(bookingRules.tripStops, (stop, idx) => {
                            let loc = stop.location;

                            loc.address = {streetAddress: loc.addr1, city: loc.city, state: loc.state, zip: loc.zip, countryShortCode: loc.countryShortCode, name: loc.name};
                            loc.stopType = parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.inventoryTransport ? 0 : stop.locationDescription;
                            loc.estimatedArrival = stop.estimatedArrival;

                            if (bookingRules.encodedRoutes[idx])
                                loc.encodedPolyline = bookingRules.encodedRoutes[idx];

                            dispLocations.push(loc);
                        });

                        parent_vm.displayTripLocations({locationList: dispLocations});
                    }
                }

                if (!validateTripTimer) {
                    validateTripTimer = $interval(() => {
                        vmSettingsPnl.clearCustomerTripTimer();
                        vmSettingsPnl.timeExpiredCustomerTrip();
                    }, VALIDATETRIP_DURATION);
                }

                parent_vm.theTrip.validatingTrip = false;
            }, (errorResponse) => {
                parent_vm.displayToastError(errorResponse);
                parent_vm.theTrip.validatingTrip = false;
            });
        };

        vmSettingsPnl.hasExistingAppointment = function () {
            return !!(parent_vm.theTrip.customerDate && parent_vm.theTrip.customerTime);
        };

        vmSettingsPnl.canGetEarliestPickupTime = function () {
            let trip = parent_vm.theTrip;
            let serviceOrder = parent_vm.serviceOrder;

            if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.mobileGarage && (!trip.hoursNeeded || trip.hoursNeeded === "")) {
                return false;
            }

            if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup && parent_vm.bookingRules.isXTimeEnabled === true) {
                return trip.customerLocation !== null && serviceOrder.dmsMake !== null && serviceOrder.dmsModel !== null && serviceOrder.xTimeYear !== null;
            } else if (trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.inventoryTransport || trip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dealerTrade) {
                return trip.customerLocation !== null && trip.dropoffLocation !== null;
            } else {
                return !trip.selectedSystemTripType.supportsLyftAPI && (trip.selectedSystemTripType.id !== SYSTEM_ENUMS.systemTripType.personalDriver && trip.customerLocation ||
                    trip.customerLocation && trip.hoursNeeded && trip.hoursNeeded !== '0' && parent_vm.theTrip.isRoundTrip === '1' ||
                    trip.customerLocation && trip.dropoffLocation && parent_vm.theTrip.isRoundTrip !== '1');
            }
        };

        
        vmSettingsPnl.favoriteCustomerLocationSelected = function (location) {
            if (location.id === -1) {
                vmSettingsPnl.manageLocations(true);
            } else if (parent_vm.theTrip.dropoffLocation && location && location.id === parent_vm.theTrip.dropoffLocation.id) {
                modalService.showYesNo('Info', 'Pickup and Dropoff locations cannot be the same.', null, 'OK');
                parent_vm.theTrip.customerFormattedLocation = null;
            } else {
                parent_vm.theTrip.customerLocation = {
                    city: location.city,
                    streetAddress: location.address,
                    lat: location.lat,
                    lng: location.lng,
                    state: location.state,
                    zip: location.zip,
                    countryShortCode: location.countryShortCode,
                    id: location.id
                };

                if (vmSettingsPnl.canGetEarliestPickupTime()) {
                    vmSettingsPnl.getEarliestAvailableTime();
                }
            }
        };

        vmSettingsPnl.favoriteDropoffLocationSelected = function (location) {
            if (location.id === -1) {
                vmSettingsPnl.manageLocations(false);
            } else if (parent_vm.theTrip.customerLocation && location && location.id === parent_vm.theTrip.customerLocation.id) {
                modalService.showYesNo('Info', 'Pickup and Dropoff locations cannot be the same.', null, 'OK');
                parent_vm.theTrip.dropoffFormattedLocation = null;
            } else {
                parent_vm.theTrip.dropoffLocation = {
                    city: location.city,
                    streetAddress: location.address,
                    lat: location.lat,
                    lng: location.lng,
                    state: location.state,
                    zip: location.zip,
                    countryShortCode: location.countryShortCode,
                    id: location.id
                };

                if (vmSettingsPnl.canGetEarliestPickupTime()) {
                    vmSettingsPnl.getEarliestAvailableTime();
                }
            }
        };

        vmSettingsPnl.providerRideSelected = function (providerRide) {
            _.each(vmSettingsPnl.lyftRides, (ride) => {
                ride.selected = false;
            });

            const rideDisplayName = providerRide.displayName ? providerRide.displayName.toUpperCase() : '';
            const isWAV = rideDisplayName == SYSTEM_ENUMS.UberRideTypes.uberWAV.toUpperCase();
            const isAssist = rideDisplayName == SYSTEM_ENUMS.UberRideTypes.uberAssist.toUpperCase();

            parent_vm.rideAlertMessage = isWAV ? 'Please ensure your customer needs a wheelchair accessible vehicle as availability is limited.' 
                                            : isAssist ? 'Please ensure your customer needs additional assistance as availability is limited.' : null;
            
            parent_vm.theTrip.selectedProviderRide = providerRide;
            providerRide.selected = true;

            parent_vm.rideProvider = providerRide.rideProviderName;

            updateSegments(providerRide.estimatedDuration, providerRide.estimatedDistance);

            let spendingCap = parent_vm.bookingRules.monthlySpendingCap || 0;

            if (spendingCap > 0) {
                bookingService.getMonthlyChargeInfo(parent_vm.theTrip.dealerLocation.id, parent_vm.theTrip.dealerTripTypeInstance.id).then((capInfo) => {
                    // This is a self-defined code as the other error codes come from the TripVerificationResult enum on the server.  We may want to consider handling this on the server in the future.
                    let spendingErrorCode = 666;
                    let cumulativeCharges = capInfo.totalActualCharges + capInfo.totalPendingCharges;
                    let effectiveTotal = providerRide.estimatedCost + cumulativeCharges;

                    parent_vm.theTrip.monthlyChargesSnapshot = cumulativeCharges;

                    _.remove(parent_vm.confirmedErrors, (err) => {
                        return err.code === spendingErrorCode || err === spendingErrorCode;
                    });

                    _.remove(parent_vm.theTrip.errors, (err) => {
                        return err.code === spendingErrorCode;
                    });

                    if (effectiveTotal > spendingCap) {
                        let capError = {message: 'This trip will cause the monthly spending limit to be exceeded.  Current spend: $' + cumulativeCharges.toFixed(2) + ' of $' + spendingCap, code: spendingErrorCode, allowOverride: true};

                        if (!parent_vm.theTrip.errors)
                            parent_vm.theTrip.errors = [];

                        parent_vm.theTrip.errors.push(capError);
                    }
                });
            }
        };

        vmSettingsPnl.updateLyftRideValues = function () {
            // Clear any previous ride provider errors
            parent_vm.showRideProviderMessage = false;
            parent_vm.rideProviderMessage = null;

            let currentTrip = parent_vm.theTrip;
            let selectedSystemTripTypeId = currentTrip.selectedSystemTripType.id;

            if (!currentTrip.customerLocation) {
                return Promise.resolve(null);
            }

            if (currentTrip.startsAtDealer) {
                currentPickupLocation = currentTrip.dealerLocation;
                currentDropoffLocation = currentTrip.customerLocation;

                return getProviderRides();
            } else if (selectedSystemTripTypeId === SYSTEM_ENUMS.systemTripType.lyftShuttleService ||
                (selectedSystemTripTypeId === SYSTEM_ENUMS.systemTripType.partsOnDemand && !vmSettingsPnl.isPartsOnDemandToFromAny())) {
                currentPickupLocation = currentTrip.customerLocation;
                currentDropoffLocation = currentTrip.dealerLocation;

                return getProviderRides();
            } else {
                currentPickupLocation = currentTrip.customerLocation;
                currentDropoffLocation = currentTrip.dropoffLocation;

                if (currentTrip.dropoffLocation && currentTrip.customerLocation) {
                    return getProviderRides();
                } else {
                    return Promise.resolve(true);
                }
            }
        };

        vmSettingsPnl.customerLocationUpdated = function (formattedAddress) {
            if (formattedAddress && formattedAddress.location && formattedAddress.location.lat) {
                vmSettingsPnl.resetDriver();

                parent_vm.theTrip.customerLocationName = formattedAddress.name;
                parent_vm.theTrip.customerLocation = formattedAddress.location;

                if (parent_vm.theTrip.selectedSystemTripType.supportsLyftAPI) {
                    vmSettingsPnl.lyftRides = null;
                    parent_vm.theTrip.selectedProviderRide = null;

                    vmSettingsPnl.updateLyftRideValues().then((estimateResponse) => {
                        if (currentPickupLocation && currentDropoffLocation) {
                            bookingService.inServiceArea(currentPickupLocation.lat,
                                currentPickupLocation.lng,
                                currentDropoffLocation.lat,
                                currentDropoffLocation.lng,
                                parent_vm.theTrip.dealerTripTypeInstance.id,
                                parent_vm.theTrip.dealerLocation.id).then((rules) => {
                                    parent_vm.clearErrors();

                                    if (rules.errors) {
                                        parent_vm.theTrip.errors = rules.errors;
                                    }

                                    if (parent_vm.theTrip.errors === null && vmSettingsPnl.lyftRides.length === 1) {
                                        // Auto-select the lyft ride if there is only one item in the list.
                                        vmSettingsPnl.providerRideSelected(vmSettingsPnl.lyftRides[0]);
                                    }

                                    getTripRoute(currentPickupLocation, currentDropoffLocation);
                                });
                        } else if (vmSettingsPnl.isPartsOnDemandToFromAny()) {
                            let loc = currentPickupLocation ? currentPickupLocation : currentDropoffLocation;

                            parent_vm.setMapLocation(loc, SYSTEM_ENUMS.destinationType.customer);
                        }

                        vmSettingsPnl.locationError2 = null;
                    });
                } else {
                    if (vmSettingsPnl.canGetEarliestPickupTime()) {
                        vmSettingsPnl.getEarliestAvailableTime(vmSettingsPnl.hasExistingAppointment());
                    } else if (vmSettingsPnl.hasExistingAppointment()) {
                        $timeout(() => {
                            vmSettingsPnl.validateCustomerTrip();
                        }, 100);
                    }
                }
            } else {
                parent_vm.theTrip.customerLocation = null;
                parent_vm.theTrip.customerDate = null;
                parent_vm.theTrip.customerTime = null;
                vmSettingsPnl.initializeTimeDropdown = true;
            }
        };

        vmSettingsPnl.hoursUpdated = function () {
            if (vmSettingsPnl.canGetEarliestPickupTime()) {
                vmSettingsPnl.getEarliestAvailableTime();
            }
        };

        vmSettingsPnl.dropoffLocationUpdated = function (formattedAddress) {
            if (formattedAddress) {
                vmSettingsPnl.resetDriver();

                parent_vm.theTrip.dropoffLocation = formattedAddress.location;
                currentDropoffLocation = formattedAddress.location;

                if (vmSettingsPnl.canGetEarliestPickupTime()) {
                    vmSettingsPnl.getEarliestAvailableTime();
                }

                if ((parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.lyftRoadSideAssistance || vmSettingsPnl.isPartsOnDemandToFromAny()) &&
                    parent_vm.theTrip.dropoffLocation && parent_vm.theTrip.customerLocation) {
                    vmSettingsPnl.lyftRides = null;
                    parent_vm.theTrip.selectedProviderRide = null;

                    getProviderRides().then((estimateResponse) => {
                        checkServiceArea(estimateResponse);
                    });
                } else if (vmSettingsPnl.isPartsOnDemandToFromAny()) {
                    let loc = currentPickupLocation ? currentPickupLocation : currentDropoffLocation;

                    parent_vm.setMapLocation(loc, SYSTEM_ENUMS.destinationType.customer);
                }
            } else {
                parent_vm.theTrip.dropoffLocation = null;
                parent_vm.theTrip.customerDate = null;
                parent_vm.theTrip.customerTime = null;
                vmSettingsPnl.initializeTimeDropdown = true;
            }
        };

        vmSettingsPnl.getRideProviderDetails = function (provider) {
            switch (provider.rideProviderType) {
                case vmSettingsPnl.rideProviderTypes.uber:
                case vmSettingsPnl.rideProviderTypes.uberDirect:
                    return {
                        name: 'Uber',
                        logo: '/assets/images/uber.png',
                        logoAlt: 'Uber Logo',
                        class: 'uber'
                    };
                case vmSettingsPnl.rideProviderTypes.lyft:
                default:
                    return {
                        name: 'Lyft',
                        logo: '/assets/images/lyft.png',
                        logoAlt: 'Lyft Logo',
                        class: 'lyft'
                    };
            }
        };


        vmSettingsPnl.displayServiceAdvisorOverrideFields = function () {
            return vmSettingsPnl.isPartsOnDemandToFromAny();
        };

        vmSettingsPnl.customerHomeAddressLocationUpdated = function (formattedAddress) {
            if (formattedAddress) {
                vmSettingsPnl.resetDriver();
                parent_vm.theTrip.customerHomeLocation = formattedAddress.location;
            } else {
                parent_vm.theTrip.customerHomeLocation = null;
            }
        };

        vmSettingsPnl.customerHoursNeededChanged = function () {
            if (vmSettingsPnl.canGetEarliestPickupTime()) {
                vmSettingsPnl.getEarliestAvailableTime();
            }
        };

        vmSettingsPnl.customerDateChanged = function () {
            let validateTrip = parent_vm.theTrip.customerTime !== null;

            vmSettingsPnl.resetDriver();
            vmSettingsPnl.updateTimeOptions(parent_vm.theTrip.customerDate, parent_vm.theTrip.customerTime, validateTrip);
        };

        vmSettingsPnl.vehicleSelectionChanged = function () {
            if (yearMakeModelTimeout) {
                // if there is already a timeout in process cancel it
                $timeout.cancel(yearMakeModelTimeout);
            }

            yearMakeModelTimeout = $timeout(() => {
                if (parent_vm.bookingRules.isXTimeEnabled) {
                    parent_vm.theTrip.customerDate = null;
                    parent_vm.theTrip.customerTime = null;
                    parent_vm.theTrip.apiErrors = null;
                    parent_vm.theTrip.errors = null;
                }

                parent_vm.populateVehicleDataFromDropDowns();

                if (vmSettingsPnl.canGetEarliestPickupTime()) {
                    vmSettingsPnl.getEarliestAvailableTime();
                    yearMakeModelTimeout = null;
                }
            }, 500);
        };

        vmSettingsPnl.apptDateChanged = function () {
            vmSettingsPnl.resetDriver();
            vmSettingsPnl.updateTimeOptions(parent_vm.serviceOrder.apptDate, parent_vm.serviceOrder.apptTime, false, '#appt_time');
        };

        vmSettingsPnl.customerTimeChanged = function () {
            vmSettingsPnl.resetDriver();
            vmSettingsPnl.validateCustomerTrip();
        };

        vmSettingsPnl.availableTimeText = function (time) {
            if (parent_vm.theTrip.availableTimes && !parent_vm.theTrip.availableTimes.includes(time)) {
                return time + ' (Unavailable)';
            }

            return time;
        };

        vmSettingsPnl.resetDriver = function () {

            if ((parent_vm.resolvedTrip && !parent_vm.theTrip.activeDrivers) || vmSettingsPnl.loading) {
                return;
            }

            if (parent_vm.theTrip) {
                parent_vm.theTrip.assignedDriver = null;
            }
        };

        vmSettingsPnl.retryGetProviderRides = function () {
            getProviderRides();
        };

        vmSettingsPnl.vehicleKeyDown = function (e) {
            rcUtilService.vehicleKeyDown(e);
        };

        vmSettingsPnl.getDriverPlaceHolder = function () {
            if (vmSettingsPnl.isMobileGarage()) {
                return "MOBILE TECH";
            }

            return "DRIVER";
        };

        vmSettingsPnl.updateFavoriteLocations = function (locationsToDelete, newLocations) {
            vmSettingsPnl.updatingFavoriteLocations = true;
            locationService.updateVenues(parent_vm.theTrip.dealerLocation.id, newLocations, locationsToDelete).then((response) => {
                vmSettingsPnl.updatingFavoriteLocations = false;
                vmSettingsPnl.getFavoriteLocations();
            }, (errorResponse) => {
                vmSettingsPnl.updatingFavoriteLocations = false;
                parent_vm.displayToastError(errorResponse);
            });
        };

        vmSettingsPnl.resetDropDownAfterManageLocation = function (calledFromCustomerLocation) {
            if (calledFromCustomerLocation) {
                parent_vm.theTrip.customerFormattedLocation = null;
            } else {
                parent_vm.theTrip.dropoffFormattedLocation = null;
            }
        };

        vmSettingsPnl.manageLocations = function (calledFromCustomerLocation, locationsToDelete, newLocations) {
            let dealerId = parent_vm.theTrip.dealerLocation.id;
            let manageLocationsResult = modalService.showManageLocations(dealerId, parent_vm.favoriteLocations, vmSettingsPnl.options, locationsToDelete, newLocations, false, parent_vm.theTrip.dealerLocation);

            manageLocationsResult.then((results) => {
                if (!results.cancelled && (results.locationsToDelete.length > 0 || results.newLocations.length > 0)) {
                    vmSettingsPnl.updateFavoriteLocations(results.locationsToDelete, results.newLocations);
                }

                vmSettingsPnl.resetDropDownAfterManageLocation(calledFromCustomerLocation);
            });
        };

        function checkServiceArea(estimateResponse) {
            bookingService.inServiceArea(currentPickupLocation.lat,
                currentPickupLocation.lng,
                currentDropoffLocation.lat,
                currentDropoffLocation.lng,
                parent_vm.theTrip.dealerTripTypeInstance.id,
                parent_vm.theTrip.dealerLocation.id,
                currentPickupLocation.state,
                currentDropoffLocation.state,
                estimateResponse ? estimateResponse.rideProviderType : null).then((rules) => {
                    parent_vm.clearErrors();

                    if (rules.errors) {
                        parent_vm.theTrip.errors = rules.errors;
                    }

                    getTripRoute(currentPickupLocation, currentDropoffLocation);
                });
        }

        $scope.$on('clearTripSettings', (event, data) => {
            vmSettingsPnl.clearTripSettings(data);
        });

        $scope.$on('tripOptionSelected', (event, data) => {
            if (parent_vm.theTrip.selectedSystemTripType.supportsLyftAPI) {
                vmSettingsPnl.updateLyftPlaceHolderText();
            }

            let initFromDB = !!parent_vm.resolvedServiceOrder;

            vmSettingsPnl.tripOptionSelected(initFromDB);
        });

        $scope.$on('getProviderRides', (event) => {
            getProviderRides();
        });

        $scope.$on('systemTripTypeSelected', (event, data) => {
            vmSettingsPnl.setPlaceholderText();
        });

        $scope.$on('tripTypeIntanceSelected', (event, data) => {
            if (parent_vm.theTrip.selectedSystemTripType.supportsFavoriteLocations && !parent_vm.resolvedFavoriteLocations) {
                vmSettingsPnl.getFavoriteLocations();
            } else if (parent_vm.theTrip.selectedSystemTripType.supportsFavoriteLocations) {
                parent_vm.favoriteLocations = parent_vm.resolvedFavoriteLocations;
                vmSettingsPnl.buildFavoriteLocationsDisplay();
            }
        });

        $scope.$on('productGroupSelected', (event, data) => {
            vmSettingsPnl.setPlaceholderText();
        });

        $scope.$on('customerLocationLoadedFromRecord', (event, data) => {
            vmSettingsPnl.getEarliestAvailableTime(true);
        });

        function getProviderRides() {
            if (!parent_vm.theTrip.customerLocation) {
                return;
            }

            clearTimers();
            vmSettingsPnl.lyftRides = null;

            function processProviderRides(estimates, rideProviderType, rideProviderName, sandboxRunId) {
                vmSettingsPnl.lyftRides = [];
                let etaVerbiage = parent_vm.theTrip.selectedSystemTripType.id !== vmSettingsPnl.tripTypes.partsOnDemand ? 'ETA will be updated when driver is assigned.' : 'ETA will be updated once the delivery is booked and a driver is assigned.';

                _.each(estimates, (estimate) => {
                    vmSettingsPnl.lyftRides.push({
                        displayName: estimate.displayName,
                        eta: estimate.etaSeconds < 1200 ? estimate.etaSeconds : '> 20 mins',
                        etd: estimate.estimatedSecondsToDropoff ? estimate.estimatedSecondsToDropoff : etaVerbiage,
                        rideType: estimate.rideType,
                        rideTypeId: estimate.rideTypeId,
                        estimatedCost: estimate.adjustedEstimatedCostCents / 100,
                        baseCost: estimate.estimatedCostCents / 100,
                        estimatedDistance: estimate.estimatedDistanceMiles,
                        estimatedDuration: estimate.estimatedDurationSeconds,
                        costToken: estimate.costToken,
                        selected: estimate.selected,
                        rideProviderType: rideProviderType,
                        rideProviderName: rideProviderName,
                        hasEtd: !!estimate.estimatedSecondsToDropoff,
                        primetimePercentage: estimate.primetimePercentage,
                        sandboxRunId: sandboxRunId
                    });
                });

                if (parent_vm.theTrip.selectedProviderRide) {
                    let selectedRideIndex = _.findIndex(vmSettingsPnl.lyftRides, (ride) => {
                        return ride.displayName === parent_vm.theTrip.selectedProviderRide.displayName;
                    });

                    if (selectedRideIndex !== -1) {
                        vmSettingsPnl.lyftRides[selectedRideIndex].selected = true;
                        parent_vm.theTrip.selectedProviderRide = vmSettingsPnl.lyftRides[selectedRideIndex];
                    } else {
                        parent_vm.theTrip.selectedProviderRide = null;
                    }
                }

                if (vmSettingsPnl.lyftRides.length === 0) {
                    parent_vm.rideProviderMessage = 'We\'re sorry, there are currently no drivers available in your area. Please try again later.';
                    parent_vm.showRideProviderMessage = true;
                } else {
                    parent_vm.showRideProviderMessage = false;
                }

                // Auto-select the lyft ride if there is only one item in the list.
                if (vmSettingsPnl.lyftRides.length === 1) {
                    vmSettingsPnl.providerRideSelected(vmSettingsPnl.lyftRides[0]);
                }
            }

            let requiresDeliveryClient = parent_vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.partsOnDemand;
            let deferred = $q.defer();

            vmSettingsPnl.processingEstimates = true;

            rideProviderService.getEstimates(parent_vm.theTrip.dealerLocation.id,
                parent_vm.theTrip.dealerTripTypeInstance.id,
                currentPickupLocation,
                currentDropoffLocation,
                requiresDeliveryClient,
                parent_vm.theTrip.testTrip)
                .then((estimateResponse) => {
                    vmSettingsPnl.lyftRides = [];

                    if (!estimatePoll) {
                        estimatePollCountDown = $interval(() => { vmSettingsPnl.lyftPollCountDownTimer--; }, 1000, 0);
                        estimatePoll = $interval(() => {
                            getProviderRides();
                        }, ESTIMATEPOLL_DURATION);
                    }

                    if (estimateResponse.error) {
                        let errorMessagesToDisplay = [];
                        let error = estimateResponse.error;

                        if (error && error.errorDescription) {
                            errorMessagesToDisplay.push(error.errorDescription);
                        }

                        parent_vm.rideProviderMessage = 'ERROR RETRIEVING ETA AND PRICING: ' + errorMessagesToDisplay.join(', ');
                        parent_vm.showRideProviderMessage = true;

                        return deferred.resolve(null);
                    }

                    vmSettingsPnl.rideProviderType = estimateResponse.rideProviderType;
                    processProviderRides(estimateResponse.estimates, estimateResponse.rideProviderType, estimateResponse.rideProviderName, estimateResponse.sandboxRunId);

                    return deferred.resolve(estimateResponse);
                }).catch((err) => {
                    let errorMessageToDisplay = 'An error has occurred';
                    
                    if (err && err.data) {
                        if (err.data.exceptionMessage) {
                          errorMessageToDisplay = err.data.exceptionMessage;
                        } else if (err.data.message) {
                          errorMessageToDisplay = err.data.message;
                        }
                      }

                    parent_vm.rideProviderMessage = 'ERROR RETRIEVING ETA AND PRICING: ' + errorMessageToDisplay;
                    parent_vm.showRideProviderMessage = true;

                    return deferred.resolve(null);
                }).finally(() => {
                    vmSettingsPnl.processingEstimates = false;
                });

            return deferred.promise;
        }

        function updateSegments(estimatedDuration, estimatedDistance) {
            if (parent_vm.theTrip.selectedProviderRide && vmSettingsPnl.routeData) {
                let pickupArrival = new Date();
                let dropoffArrival = new Date(pickupArrival);

                pickupArrival.setSeconds(pickupArrival.getSeconds() + parent_vm.theTrip.selectedProviderRide.eta);
                dropoffArrival.setSeconds(dropoffArrival.getSeconds() + parent_vm.theTrip.selectedProviderRide.eta + estimatedDuration);

                vmSettingsPnl.routeData.pickup.estimatedArrival = pickupArrival;
                vmSettingsPnl.routeData.dropoff.estimatedArrival = dropoffArrival;
            }
        }

        function getTripRoute(pickupLocation, dropoffLocation, estimatedDistance, estimatedDuration) {
            if (!pickupLocation || !dropoffLocation) return;

            rideProviderService.getTripRoute(parent_vm.theTrip.dealerLocation.id,
                pickupLocation.lat,
                pickupLocation.lng,
                pickupLocation.streetAddress || pickupLocation.address || pickupLocation.name,
                pickupLocation.city,
                pickupLocation.state,
                pickupLocation.zip,
                pickupLocation.countryShortCode,
                dropoffLocation.lat,
                dropoffLocation.lng,
                dropoffLocation.streetAddress || dropoffLocation.address || dropoffLocation.name,
                dropoffLocation.city,
                dropoffLocation.state,
                dropoffLocation.zip,
                dropoffLocation.countryShortCode,
                moment().add(180, 'seconds'), // TODO: Arbitrary amount of time so the map can be shown as soon as customer location is chosen
                parent_vm.theTrip.dealerTripTypeInstance.id,
                parent_vm.theTrip.selectedSystemTripType.id,
                parent_vm.theTrip.startsAtDealer,
                parent_vm.theTrip.tripWorkFlowId).then((routeData) => {
                    // add properties that the displayTripLocations location list expects
                    routeData.pickup.stopType = routeData.pickup.destinationType;
                    routeData.dropoff.stopType = routeData.dropoff.destinationType;
                    routeData.pickup.address = routeData.pickup;
                    routeData.dropoff.address = routeData.dropoff;

                    vmSettingsPnl.routeData = routeData;

                    updateSegments(estimatedDuration);

                    vmSettingsPnl.routeData.pickup.encodedPolyline = routeData.route;

                    parent_vm.displayTripLocations({locationList: [vmSettingsPnl.routeData.pickup, vmSettingsPnl.routeData.dropoff]});
                });
        }

        vmSettingsPnl.toggleMobileMap = function () {
            vmSettingsPnl.mobileMapVisible = !vmSettingsPnl.mobileMapVisible;

            if (vmSettingsPnl.mobileMapVisible) {
                let locationsToShow = [];

                if (vmSettingsPnl.routeData) {
                    locationsToShow.push(vmSettingsPnl.routeData.pickup);
                    locationsToShow.push(vmSettingsPnl.routeData.dropoff);
                } else if (currentDropoffLocation || currentPickupLocation) {
                    if (currentPickupLocation)
                        locationsToShow.push(currentPickupLocation);

                    if (currentDropoffLocation)
                        locationsToShow.push(currentDropoffLocation);
                } else {
                    locationsToShow.push(parent_vm.theTrip.dealerLocation);

                    if (parent_vm.theTrip.customerLocation)
                        locationsToShow.push(parent_vm.theTrip.customerLocation);
                }

                $timeout(() => {
                    parent_vm.displayTripLocations({locationList: locationsToShow});
                }, 500);
            }
        };

        vmSettingsPnl.getROSelectComponent = function () {
            return angular.element('#roselect');
        };

        vmSettingsPnl.getLoanerContractSelectComponent = function () {
            return angular.element('#loaner-contract-select');
        };

        let loanerContractPageSize = 20;

        vmSettingsPnl.loanerContractSearchOptions = {
            width: '100%',
            placeholder: 'Search loaner contract',
            minimumInputLength: 0,
            maximumSelectionLength: 1,
            allowClear: true,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        dealerId: parent_vm.theTrip.dealerLocation.id,
                        page: parameters.page || 0,
                        pageSize: loanerContractPageSize || 20
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;
                    let status = 'started';

                    if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                        status = 'booked';
                    }

                    if (parent_vm.cancelPromise) {
                        parent_vm.cancelPromise.resolve([]);
                    }

                    parent_vm.cancelPromise = $q.defer();

                    loanerService.getContracts({
                        dealerId: data.dealerId,
                        search: data.search || undefined,
                        page: data.page,
                        pageSize: loanerContractPageSize,
                        status: status,
                        isActive: true
                    }, parent_vm.cancelPromise.promise)
                        .then(success, failure)
                        .finally(() => {
                            parent_vm.cancelPromise = null;
                        });
                },
                delay: 250,
                processResults: function (data, params) {
                    let page = params.page || 1;
                    let more = data.length === loanerContractPageSize;
                    let results = [];

                    if (page === 1) {
                        data.unshift({id: -999, externalContractId: null});
                    }

                    for (let i = 0; i < data.length; i++) {
                        if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                            if (data[i].tripId && parent_vm.theTrip.id !== data[i].tripId) {
                                data[i].disabled = true;
                            } else {
                                if (data[i].externalContractId) {
                                    data[i].id = data[i].externalContractId;
                                }

                                results.push(data[i]);
                            }
                        } else if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dropoff) {
                            if (data[i].returnTripId && parent_vm.theTrip.id !== data[i].returnTripId) {
                                data[i].disabled = true;
                            } else {
                                if (data[i].externalContractId) {
                                    data[i].id = data[i].externalContractId;
                                }

                                results.push(data[i]);
                            }
                        }
                    }

                    return {
                        results: results,
                        pagination: {
                            more: more
                        }
                    };
                }
            },
            templateSelection: function (item) {
                if (item.text) return item.text;

                if (item.externalContractId === null) {
                    if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                        return '[NEW LOANER CONTRACT]';
                    }

                    return '[NO CONTRACT]';
                }

                return ['#' + item.contractNumber, item.customerName, item.vehicleYear, item.vehicleMake, item.vehicleModel].join(' ');
            },
            templateResult: function (item) {
                if (item.loading) {
                    return 'Searching...';
                }

                if (item.externalContractId === null) {
                    if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                        return '[NEW LOANER CONTRACT]';
                    }

                    return '[NO CONTRACT]';
                }

                return ['#' + item.contractNumber, item.customerName, item.vehicleYear, item.vehicleMake, item.vehicleModel, item.disabled ? "(Trip booked)" : null].join(' ');
            }
        };

        vmSettingsPnl.enableLoanerContractSearch = function (enable) {
            $timeout(() => {
                let element = vmSettingsPnl.getLoanerContractSelectComponent();

                if (element.length) {
                    element.prop('disabled', !enable);
                } else {
                    vmSettingsPnl.enableLoanerContractSearch(enable);
                }
            }, 100, 1);
        };

        vmSettingsPnl.setupLoanerContractSelect = function () {
            $timeout(() => {
                let element = vmSettingsPnl.getLoanerContractSelectComponent();

                if (element.length) {
                    element.on('select2:select', (e) => {
                        let data = e.params.data;

                        parent_vm.serviceOrder.selectedLoanerContract = data;
                        vmSettingsPnl.enableLoanerContractSearch(false);
                    })
                        .on('select2:unselect', (e) => {
                            parent_vm.serviceOrder.selectedLoanerContract = null;
                            vmSettingsPnl.enableLoanerContractSearch(true);
                        });
                }

                //go ahead and select the loaner reservation if its provided.
                if (parent_vm.theTrip.externalContractId) {
                    vmSettingsPnl.addDefaultContractItem(element, '#' + (parent_vm.theTrip.loanerConfirmationNumber != null ?
                        parent_vm.theTrip.loanerConfirmationNumber :
                        parent_vm.theTrip.externalContractId), parent_vm.theTrip.externalContractId);
                } else if (parent_vm.queryStringParameters && parent_vm.queryStringParameters.loanerReservationId) {
                    let text = ['#' + parent_vm.queryStringParameters.loanerReservationId, parent_vm.queryStringParameters.firstName, parent_vm.queryStringParameters.lastName, parent_vm.queryStringParameters.vehicleYear, parent_vm.queryStringParameters.vehicleMake, parent_vm.queryStringParameters.vehicleModel].join(' ');

                    vmSettingsPnl.addDefaultContractItem(element, text, parent_vm.queryStringParameters.loanerReservationId, parent_vm.queryStringParameters.externalConfirmationToken);
                } else if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                    vmSettingsPnl.addDefaultContractItem(element, '[New contract]', null);
                } else if (parent_vm.theTrip.id > 0 && parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dropoff) {
                    vmSettingsPnl.addDefaultContractItem(element, '[No contract]', null);
                }

                // Ensure that we have the loaner contract id set
                if (parent_vm.queryStringParameters.loanerReservationId) {
                    parent_vm.theTrip.loanerContractId = parent_vm.queryStringParameters.loanerReservationId;
                }
            }, 100, 1);
        };

        vmSettingsPnl.addDefaultContractItem = function (element, text, id, contractNumber = null) {
            let newOption = new Option(text, id, true, true);

            $(element).find('option').remove().end().append(newOption).trigger('change');
            vmSettingsPnl.enableLoanerContractSearch(false);
            parent_vm.serviceOrder.selectedLoanerContract = {
                id: id,
                externalContractId: id,
                contractNumber: contractNumber
            };
        };

        vmSettingsPnl.clearSelectedLoanerContract = function () {
            let element = vmSettingsPnl.getLoanerContractSelectComponent();

            element.trigger('select2:unselect');
            $timeout(() => {
                element.val(null).trigger('change');
            }, 1);
        };


        vmSettingsPnl.repairOrderSearchOptions = {
            width: '100%',
            placeholder: vmSettingsPnl.placeHolderText.roAppt,
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        locationId: parent_vm.theTrip.dealerLocation.id,
                        tripTypeId: parent_vm.theTrip.selectedSystemTripType ? parent_vm.theTrip.selectedSystemTripType.overrideROSearchTripTypeId ? parent_vm.theTrip.selectedSystemTripType.overrideROSearchTripTypeId : parent_vm.theTrip.selectedSystemTripType.id : null
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;
                   
                    if (vmSettingsPnl.cancelPromise) {
                        vmSettingsPnl.cancelPromise.resolve();
                    }

                    vmSettingsPnl.cancelPromise = $q.defer();

                    return bookingService.roSearchLight(data.search, data.locationId, data.tripTypeId).then((results) => {
                        if (results && !results.requestCanceled) {
                            // because select2 is DUMB DUMB DUMB
                            let mappedResults = $.map(results, (obj) => {
                                obj.id = obj.id || obj.dealerServiceOrderId;

                                return obj;
                            });

                            mappedResults.push({
                                id: -999,
                                text: '<span></span>',
                                searchTerm: data.search
                            });

                            success(mappedResults);
                        } else if (results && results.requestCanceled) {
                            success([{
                                id: -999,
                                text: '<span></span>',
                                searchTerm: data.search
                            }]);
                        }
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 1000,
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            },
            templateSelection: function (item) {
                let appendCreateNew = true;
                
                if (item.text) {
                    let text = '';

                    if (parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup) {
                        let serviceOrder = parent_vm.serviceOrder;
                        let dateTime = serviceOrder ? serviceOrder.appointmentDateTime : null;

                        if (serviceOrder) {
                            text = serviceOrder.customerInfo.lastName + ' - ';

                            if (dateTime) {
                                text += moment(dateTime).format('MMM D, ');
                                text += moment(dateTime).format('hh:mma');
                            }

                            appendCreateNew = false;
                        }
                    } else if (item.roNumber) {
                        text = "#" + item.roNumber;
                    } else if (parent_vm.resolvedRO) {
                        text = "RO #" + item.text;
                        appendCreateNew = false;
                    } else if (item.searchTerm) {
                        text = item.searchTerm;
                    } else {
                        text = item.text;
                    }

                    if (appendCreateNew === true) {
                        text = 'Create New ' + text;
                    }

                    return $("<div title ='" + text + "'>" + text + "</div>");
                }

                return bookingService.formatForItemSelected(item, parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup);
            },
            templateResult: function (item) {
                if (item.loading) {
                    return 'Searching...';
                }

                let isAppt = parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup;

                if (item.text && item.id !== -998) {
                    let option = $("<span class='theme-link no-underline text-normal-case'>Can't find it?  </span>");
                    let newRecord = $("<span class='create-new'>Create a New Record.</span>");

                    option.append(newRecord);

                    return option;
                } else if (item.text && item.id === -998) {
                    let optionA = $(item.text);

                    return optionA;
                }

                return bookingService.formatForDropdown(item, isAppt);
            }
        };

        vmSettingsPnl.enableROSearch = function (enable) {
            $timeout(() => {
                let element = vmSettingsPnl.getROSelectComponent();

                if (element.length) {
                    $('#roselect').prop('disabled', !enable);
                } else {
                    vmSettingsPnl.enableROSearch(enable);
                }
            }, 100, 1);
        };

        function createNewRecordClicked(item) {
            let isAppt = parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup;

            if (!isAppt) {
                bookingService.roExists(parent_vm.theTrip.dealerLocation.id, item.searchTerm).then((response) => {
                    if (response.isValid) {
                        vmSettingsPnl.createNewRecord(item.searchTerm);
                    } else {
                        modalService.showYesNo('Validation Error', 'This RO# is in use and must be selected from search results.  If you want to create a New Record, please enter a numeric value that is not in use.', null, 'OK');
                        clearROSearch();
                    }
                });
            } else {
                vmSettingsPnl.createNewRecord(item.searchTerm);
            }
        }

        vmSettingsPnl.setupRoSelect = function () {
            $timeout(() => {
                let element = vmSettingsPnl.getROSelectComponent();

                if (element.length) {
                    element.on('select2:select',
                        (e) => {
                            let data = e.params.data;

                            if (data && data.id === -999) {
                                e.preventDefault();
                                $('#roselect').empty();
                                createNewRecordClicked(data);
                            } else {
                                vmSettingsPnl.searchResultClicked(data);
                                vmSettingsPnl.enableROSearch(false);
                            }
                        })
                        .on('select2:unselect', (e) => {
                            vmSettingsPnl.enableROSearch(true);
                        });

                    // add selected option to select2 if needed
                    if (parent_vm.resolvedServiceOrder) {
                        parent_vm.resolvedServiceOrder.id = parent_vm.resolvedServiceOrder.dealerServiceOrderId;

                        let roSelect = $('#roselect');
                        let serviceOrder = parent_vm.resolvedServiceOrder;
                        let display = parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup ? serviceOrder.apptId : serviceOrder.roNumber;
                        let option = new Option(display, serviceOrder.id, true, true);

                        roSelect.append(option).trigger('change');

                        roSelect.trigger({
                            type: 'select2:select',
                            params: {
                                data: serviceOrder
                            }
                        });
                    } else if (parent_vm.resolvedRO && parent_vm.theTrip.dealerLocation.dmsEnabled && parent_vm.theTrip.selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.dropoff) {
                        let roSelect = $('#roselect');
                        let serviceOrder = parent_vm.resolvedRO;
                        let display = serviceOrder.roNumber;
                        let option = new Option(display, serviceOrder, true, true);

                        roSelect.append(option).trigger('change');

                        roSelect.trigger({
                            type: 'select2:select',
                            params: {
                                data: serviceOrder
                            }
                        });
                    }
                } else {
                    vmSettingsPnl.setupRoSelect();
                }
            }, 100, 1);
        };

        vmSettingsPnl.setupRoSelect();

        vmSettingsPnl.clearSelectedRO = function () {
            modalService.showYesNo('Confirm Clear', 'This will reset your form.  Are you sure you want to clear the selection?', 'No', 'Yes', true)
                .then((confirmed) => {
                    if (confirmed) {
                        vmSettingsPnl.clearNewServiceOrder();
                        vmSettingsPnl.enableROSearch(true);
                    }
                });

        };

        vmSettingsPnl.isPartsOnDemandToFromAny = function () {
            let trip = parent_vm.theTrip;

            if (trip.selectedTripOption &&
                trip.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.partsOnDemandToFromAny) {
                return true;
            }

            return false;
        };
        
        vmSettingsPnl.isTransportOrDelivery = function () {
            let selectedTripTypeId = parent_vm.theTrip.selectedSystemTripType.id;
            let tripTypes = parent_vm.shortSystemTripType;

            if (selectedTripTypeId === tripTypes.inventoryTransport || 
                selectedTripTypeId === tripTypes.deliverSoldVehicle) {
                    return true;
            }

            return false;
        };

        vmSettingsPnl.isPickupDropoff = function () {
            let selectedTripTypeId = parent_vm.theTrip.selectedSystemTripType.id;
            let tripTypes = parent_vm.shortSystemTripType;
            
            if (selectedTripTypeId === tripTypes.pickup ||
                selectedTripTypeId === tripTypes.dropoff) {
                    return true;
            }

            return false;
        };

        vmSettingsPnl.isMobileGarage = function () {
            let selectedTripTypeId = parent_vm.theTrip.selectedSystemTripType.id;
            let tripTypes = parent_vm.shortSystemTripType;
            
            if (selectedTripTypeId === tripTypes.mobileGarage) {
                    return true;
            }

            return false;
        };

        vmSettingsPnl.customerCanEditTrips = function () {
            return parent_vm.bookingRules ? parent_vm.bookingRules.allowCustomerToEditTrips : true;
        };

        function init() {
            if (parent_vm.theTrip.selectedSystemTripType && parent_vm.theTrip.selectedSystemTripType.supportsLyftAPI) {
                vmSettingsPnl.updateLyftPlaceHolderText();
            }

            if (parent_vm.resolvedTrip) vmSettingsPnl.validateCustomerTrip();

            vmSettingsPnl.setPlaceholderText();

            let dealerLoc = parent_vm.theTrip.dealerLocation;

            vmSettingsPnl.options.startLat = parseFloat(dealerLoc.lat);
            vmSettingsPnl.options.startLng = parseFloat(dealerLoc.lng);

            if (parent_vm.theTrip.customerFormattedLocation) {
                hereMapsService.getPlacePredictions(parent_vm.theTrip.customerFormattedLocation, dealerLoc.lat, dealerLoc.lng).then((results) => {
                    if (results.length) {
                        let selectResult = results[0];

                        hereMapsService.getPlaceDetails(selectResult.id).then((placeDetails) => {
                            let qsp = parent_vm.queryStringParameters;

                            if (qsp.streetAddress && qsp.zip) {
                                // check if the address is close to what was sent in.
                                let stDistance = Levenshtein.get(qsp.streetAddress, placeDetails.streetAddress);
                                let zipDistance = Levenshtein.get(qsp.zip, placeDetails.zip);

                                // if the street and zip are close and the state is a match, use this address.
                                if (stDistance < 5 && qsp.state.toUpperCase() === placeDetails.state.toUpperCase() && zipDistance < 3) {
                                    let formattedAddress = {location: placeDetails};

                                    vmSettingsPnl.customerLocationUpdated(formattedAddress);
                                }
                            }

                            // if there is no match, don't use address. The UI will display that user needs to verify the address.
                        });
                    }
                });
            }

            showLoanerContract();
        }

        init();

        $scope.$on('testTripFlagChangedListener', (event, data) => {
            // Update the estimates if the test trip flag changes
            if (parent_vm.theTrip.selectedSystemTripType.supportsLyftAPI) {
                getProviderRides();
            }
        });

        $scope.$on('disableROSearch', (event, data) => {
            vmSettingsPnl.enableROSearch(false);
        });

        $scope.$on('enableROSearch', (event, data) => {
            vmSettingsPnl.enableROSearch(true);
        });

        $scope.$on('$destroy', (event, next, current) => {
            clearTimers();
        });

        function showLoanerContract() {
            let hasConfiguration = false; 
            let hasProduct = false;

            hasConfiguration = vmSettingsPnl.dealerLocation.loanerManagementSystem !== null;
            hasProduct = vmSettingsPnl.loanerTripTypes.includes(vmSettingsPnl.selectedTripType.id);
            vmSettingsPnl.displayContractLoaner = !!((hasConfiguration && hasProduct));
        }
    }
})();

(function () {
    'use strict';

    TripAddChooseTripTypeController.$inject = ["$rootScope", "$scope", "$filter", "$timeout", "$state", "modalService", "toastr", "bookingService", "appointmentService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('TripAddChooseTripTypeController', TripAddChooseTripTypeController);

    function TripAddChooseTripTypeController($rootScope, $scope, $filter, $timeout, $state, modalService, toastr, bookingService, appointmentService, SYSTEM_ENUMS) {
        let vmTypePnl = this;
        let parent_vm = $scope.$parent.vm;
        let theTrip = parent_vm.theTrip;
        let steps = parent_vm.accordion.steps;
        let enumSystemTripTypes = parent_vm.enumSystemTripTypes;

        vmTypePnl.systemEnums = SYSTEM_ENUMS;
        vmTypePnl.selectedSystemTripType = null;
        vmTypePnl.selectedDealerTripType = null;
        vmTypePnl.loading = false;
        vmTypePnl.availTripTypes = null;
        vmTypePnl.availRecalls = null;
        vmTypePnl.availTestDrives = null;
        vmTypePnl.hasAppointments = false;

        function populateSelectedTripTypeOptions() {
            let allWorkFlows = parent_vm.resolvedTripWorkFlows;

            _.forEach(parent_vm.theTrip.selectedSystemTripType.tripOptions, (option) => {
                let filteredWorkFlows = $filter('filter')(allWorkFlows, {id: option.tripWorkFlowId}, true);

                if (filteredWorkFlows) {
                    let workFlow = filteredWorkFlows[0];

                    for (let k in workFlow) { option[k] = workFlow[k]; }

                    option.hasLoaner = option.logisticType === 1 ? 'no' : 'yes';
                }
            });

            if (parent_vm.theTrip.tripOptId !== null) {
                parent_vm.theTrip.dealerTripTypeInstance = parent_vm.theTrip.dealerTripTypeInstance || {};
                parent_vm.theTrip.dealerTripTypeInstance.id = parent_vm.resolvedTripType.id;
                createNewServiceOrder().then(() => {
                    $timeout(() => { 
                        $rootScope.$broadcast('tripOptionSelected');
                    }, 100, 1);
                });
                parent_vm.theTrip.selectedSystemTripType.tripOptions = $filter('filter')(parent_vm.theTrip.selectedSystemTripType.tripOptions, {id: parent_vm.theTrip.tripOptId});
                parent_vm.theTrip.selectedTripOption = parent_vm.theTrip.selectedSystemTripType.tripOptions[0];
            }

            // so that we can remove start at customer if we need to basedon dealer config.
            parent_vm.theTrip.tripOptions = _.cloneDeep(parent_vm.theTrip.selectedSystemTripType.tripOptions);
        }

        function copyEnumValuesToSelectedTripType() {
            let currEnum = $filter('filter')(enumSystemTripTypes, {value: parent_vm.theTrip.selectedSystemTripType.id})[0];

            for (let k in currEnum) { parent_vm.theTrip.selectedSystemTripType[k] = currEnum[k]; }

            populateSelectedTripTypeOptions();
        }

        function createNewServiceOrder(data) {
            parent_vm.loadingBookingRules = true;

            return bookingService.getRules(parent_vm.theTrip).then((response) => {
                parent_vm.bookingRules = response;
                parent_vm.procesingBookingRulesData = true;
                parent_vm.loadingBookingRules = false;
                parent_vm.createNewServiceOrder(data);
                parent_vm.procesBookingRulesData();
                parent_vm.theTrip.isNewServiceOrder = true;
            }, (errorResponse) => {
                parent_vm.displayToastError(errorResponse);
                parent_vm.loadingBookingRules = false;
            });
        }


        function dealerTripTypeInstanceSelected(createServiceOrder, populateVehicleData, loadingFromRecord) {
            let finishUp = function () {
                parent_vm.procesingBookingRulesData = true;
                parent_vm.loadingBookingRules = false;

                if (createServiceOrder && !parent_vm.resolvedServiceOrder && !parent_vm.serviceOrder) {
                    // prod 1885 ... if it's a drop off and not x time integrated show ro search, don't create new record
                    // even if they are not integrated
                    if (parent_vm.displayNonIntegratedROSearch()) {
                        parent_vm.theTrip.isNewServiceOrder = false;
                    } else {
                        parent_vm.theTrip.isNewServiceOrder = true;
                        parent_vm.createNewServiceOrder();

                        if (parent_vm.resolvedParentTrip) {
                            parent_vm.setAdditionalFieldFromParent(parent_vm.resolvedParentTrip);
                        }
                    }
                } else if (parent_vm.selectedSearchServiceOrder) {
                    parent_vm.createTripFromServiceOrder(parent_vm.selectedSearchServiceOrder);
                }

                parent_vm.procesBookingRulesData(loadingFromRecord);

                $timeout(() => {
                    // need timeout or the proper elements haven't loaded that this is broadcasting to
                    $rootScope.$broadcast('tripTypeIntanceSelected');
                });

                if (populateVehicleData) {
                    let dtt = parent_vm.theTrip.dealerTripTypeInstance;

                    if (parent_vm.theTrip.selectedSystemTripType.supportsVehicleTrim) {
                        getTrimStyleExclusions();
                    }

                    populateServiceOrderVehicle(dtt.vehicle);
                    parent_vm.theTrip.showTripSettingsForm = true;
                } else if (!parent_vm.displayNonIntegratedROSearch()) {
                    parent_vm.theTrip.showTripSettingsForm = true;
                }
            };

            if (!parent_vm.bookingRules && !parent_vm.loadingBookingRules) {
                parent_vm.loadingBookingRules = true;
                bookingService.getRules(parent_vm.theTrip).then((response) => {
                    parent_vm.loadingBookingRules = false;
                    parent_vm.bookingRules = response;
                    finishUp();
                }, (errorResponse) => {
                    parent_vm.displayToastError(errorResponse);
                    parent_vm.loadingBookingRules = false;
                });
            } else if (parent_vm.loadingBookingRules) {
                $timeout(() => {
                    // give it a chance to finish loading
                    dealerTripTypeInstanceSelected(createServiceOrder, populateVehicleData, loadingFromRecord);
                }, 750);
            } else {
                finishUp();
            }
        }

        function populateServiceOrderVehicle (vehicle) {
            if (parent_vm.serviceOrder && vehicle && !parent_vm.bookingRules.isGeneric) {
                parent_vm.serviceOrder.vehicleInfo.make = vehicle.make;
                parent_vm.serviceOrder.vehicleInfo.model = vehicle.model;
                parent_vm.serviceOrder.vehicleInfo.year = vehicle.year;
            }
        }

        /*
         * Used for test drives, to load trim styles avail for a model
         */
        function getSelectedModelTrimStyles() {
            vmTypePnl.loadingModelTrims = true;
            bookingService.getVehicleModelTrims(parent_vm.theTrip.dealerLocation.id, parent_vm.theTrip.dealerTripTypeInstance.vehicle.id).then((response) => {
                let trims = response;
                let exclusions = parent_vm.trimStyleExclusions;
                let availableVehicleTrims = [];
                let currTrim; 
                let shouldExclude;

                vmTypePnl.loadingModelTrims = false;

                if (trims && trims.length > 0) {
                    for (let trimIndex = 0; trimIndex < trims.length; trimIndex++) {
                        currTrim = trims[trimIndex];
                        shouldExclude = false;

                        for (let exclusionIndex = 0; exclusionIndex < exclusions.length; exclusionIndex++) {
                            if (currTrim.id === exclusions[exclusionIndex].trimId) {
                                shouldExclude = true;
                            }
                        }

                        if (parent_vm.serviceOrder && parent_vm.serviceOrder.vehicleInfo.style) {
                            if (parent_vm.serviceOrder.vehicleInfo.style === currTrim.name) {
                                parent_vm.serviceOrder.vehicleInfo.style = currTrim;
                            }
                        }

                        if (!shouldExclude) {
                            availableVehicleTrims.push(currTrim);
                        }
                    }
                }

                parent_vm.theTrip.availableVehicleTrims = availableVehicleTrims;

            }, (errorResponse) => {
                vmTypePnl.loadingModelTrims = false;
                parent_vm.displayToastError(errorResponse);
            });
        }

        function filterActiveTripTypes (tripTypes) {
            return $filter('filter')(tripTypes, (tripType) => {
                let activeTripTypeEnum = _.find(enumSystemTripTypes, (tripTypeEnum) => {
                    return tripTypeEnum.value === tripType.id;
                });

                if (activeTripTypeEnum) {
                    tripType.badgeText = activeTripTypeEnum.badgeText;
                    tripType.icon = activeTripTypeEnum.icon;

                    return true;
                }

                return false;
            });
        }

        function getLocationTripTypeInstances () {
            vmTypePnl.loading = true;
            parent_vm.productGroupsConfigured = false;
            parent_vm.experiencesPanelGroups = _.cloneDeep(parent_vm.baseExperiencesPanelGroups);

            appointmentService.getAccessAndBookingConfig(theTrip.dealerLocation.id).then((response) => {
                vmTypePnl.hasAppointments = response.hasAccess;
                vmTypePnl.allowBookingStandAloneTrips = response.allowBookingStandAloneTrips;
                parent_vm.promiseTimeDuration = response.promiseTimeDuration;

                $scope.$emit('bookingConfigChanged', response);
                bookingService.getLocationTripTypes(theTrip.dealerLocation.id).then((marketingGroups) => {

                    if (marketingGroups) {
                        _.each(marketingGroups, (marketingGroup) => {
                            marketingGroup.tripTypes = filterActiveTripTypes(marketingGroup.tripTypes);
                        });
    
                        // now we are going to massage these into the vm.experiencesPanelGroups for display
                        // TODO: IF THIS IS FORMALIZED WE MAY PUT IT IN THE DB/API INSTEAD OF IN CONSTANTS,
                        // BUT CURRENTLY THIS GROUPING IS ONLY FOR THE NEW DASH
                        _.each(parent_vm.experiencesPanelGroups, (currPanelGroup) => {
                            _.each(currPanelGroup.productGroups, (currProductGroup) => {
                                let tripTypeIds = currProductGroup.systemTripTypeIds;

                                currProductGroup.systemTripTypes = currProductGroup.systemTripTypes || [];
    
                                _.each(tripTypeIds, (tripTypeId) => {
                                    let marketingGroup = _.find(marketingGroups, (marketingGroup) => {
                                      return currPanelGroup.marketingGroupId === marketingGroup.id;
                                    });
    
                                    if (marketingGroup) {
                                        let currTripType = _.find(marketingGroup.tripTypes, (tt) => {
                                            return tt.id === tripTypeId;
                                        });
    
                                        if (currTripType) {
                                            currProductGroup.systemTripTypes.push(currTripType);
    
                                            if (tripTypeIds.length === 1 && !currProductGroup.displayName) {
                                                let enumtype = _.find(parent_vm.enumSystemTripTypes, (ttEnum) => {
                                                    return ttEnum.value === currTripType.id;
                                                });

                                                currProductGroup.displayName = vmTypePnl.systemEnums.useTripNameOverrides && enumtype.overrideName ? enumtype.overrideName : currTripType.name.replace("LYFT ", ""); // LYFT is visible in the icon, we don't want to have it repeated.
                                                currProductGroup.helpText = vmTypePnl.systemEnums.useTripNameOverrides && enumtype.overrideHelpText ? enumtype.overrideHelpText : currProductGroup.helpText;
                                                currProductGroup.badgeText = enumtype.badgeText;
                                                currProductGroup.icon = enumtype.icon;
                                            }
    
                                            currProductGroup.isDisabled = currTripType.isDisabled;
                                            currProductGroup.needsConfiguration = currTripType.needsConfiguration;
                                            currProductGroup.lyftSpending = null;
    
                                            // Only calculate lyft spending for active trips
                                            if (!currTripType.isDisabled) {
                                                // If multiple dealer trip types, sum up totals
                                                _.each(currTripType.dealerTripTypes, (dtts) => {
                                                    // If lyftSpending is null, just assign the object directly
                                                    if (dtts.lyftSpending && currProductGroup.lyftSpending == null) {
                                                        currProductGroup.lyftSpending = dtts.lyftSpending;
                                                    } else if (dtts.lyftSpending) {
                                                        // Current dealerTripType lyft spending values to existing lyft spending object
                                                        currProductGroup.lyftSpending.totalActualCharges += dtts.lyftSpending.totalActualCharges;
                                                        currProductGroup.lyftSpending.totalPendingCharges += dtts.lyftSpending.totalPendingCharges;
                                                        currProductGroup.lyftSpending.monthlySpendingCap += dtts.lyftSpending.monthlySpendingCap;
                                                    }
                                                });
    
                                                if (currProductGroup.lyftSpending) {
                                                    currProductGroup.lyftSpending.showLyftSpending = currProductGroup.lyftSpending.monthlySpendingCap > 0;
                                                    currProductGroup.lyftSpending.isOverSpendingCap = (currProductGroup.lyftSpending.totalPendingCharges + currProductGroup.lyftSpending.totalActualCharges) > currProductGroup.lyftSpending.monthlySpendingCap;
                                                }
                                            }
    
                                            if (parent_vm.resolvedSystemTripType && parent_vm.resolvedSystemTripType.id === currTripType.id) {
                                                currProductGroup.selected = true;
                                                parent_vm.theTrip.selectedProductGroup = currProductGroup;
                                            }
                                        }
                                    }
                                });
                            });
    
                            _.remove(currPanelGroup.productGroups, (group) => {
                                return group.systemTripTypes.length === 0 && !group.isFake;
                            });
    
                            parent_vm.productGroupsConfigured = true;
    
                        });
                    } else {
                        toastr.error("Error loading trip types for this location.");
                    }
    
                    vmTypePnl.loading = false;
                }, (errorResponse) => {
                    parent_vm.displayToastError(errorResponse);
                });
            });
            
        }

        function loadDataFromResolvedObjects (selSystemTripType) {
            let createSvcOrderFromResolvedObjects = function () {
                if (parent_vm.resolvedServiceOrder) {
                    if (!parent_vm.resolvedTrip) {
                        parent_vm.createTripFromServiceOrder(parent_vm.resolvedServiceOrder);
                    } else {
                        parent_vm.loadTripFromRecord(parent_vm.resolvedServiceOrder, parent_vm.resolvedTrip);
                    }
                }
            };

            if (selSystemTripType.requiresGroupSelection) {
                createSvcOrderFromResolvedObjects();
                vmTypePnl.recallModelSelected(parent_vm.resolvedServiceOrder != null);
            } else if (selSystemTripType.requiresVehicleSelection) {
                vmTypePnl.dealerTripTypeInstanceModelSelected(true);
                createSvcOrderFromResolvedObjects();
            } else {
                if (parent_vm.bookingRules) {
                    parent_vm.procesingBookingRulesData = true;
                    createSvcOrderFromResolvedObjects();
                    parent_vm.procesBookingRulesData(true);
                } else {
                    parent_vm.loadingBookingRules = true;
                    bookingService.getRules(parent_vm.theTrip).then((response) => {
                        parent_vm.bookingRules = response;
                        parent_vm.loadingBookingRules = false;
                        parent_vm.procesingBookingRulesData = true;
                        createSvcOrderFromResolvedObjects();
                        parent_vm.procesBookingRulesData(true);
                    }, (errorResponse) => {
                        parent_vm.displayToastError(errorResponse);
                        parent_vm.loadingBookingRules = false;
                    });
                }
            }
        }

        /*
         * Determines if any trim styles are excluded for the selected location
         */
        function getTrimStyleExclusions () {
            vmTypePnl.loadingTrimStyleExclusions = true;
            bookingService.getVehicleTrimExclusions(parent_vm.theTrip.dealerLocation.id).then((response) => {
                parent_vm.trimStyleExclusions = response;
                getSelectedModelTrimStyles();
                vmTypePnl.loadingTrimStyleExclusions = false;
            }, (errorResponse) => {
                vmTypePnl.loadingTrimStyleExclusions = false;
                parent_vm.displayToastError(errorResponse);
            });
        }

        vmTypePnl.isOpen = function () {
            return parent_vm.accordion.selectedStep === steps.chooseTripType;
        };

        vmTypePnl.getSelectedPanelGroup = function (group) {
            return $filter('filter')(group.productGroups, {selected: true}).length;
        };

        vmTypePnl.displaySelectedTripType = function () {
            if (!parent_vm.theTrip) return false;

            return parent_vm.theTrip.selectedProductGroup;
        };

        /*
         * Vehicle selection cleared for test drives
         */
        vmTypePnl.clearModelSelectedDealerTripTypeInstance = function () {
            parent_vm.theTrip.dealerTripTypeInstance = null;
            parent_vm.testDriveTempDTT = null;
            parent_vm.theTrip.vehicleModelId = null;
            $rootScope.$broadcast('clearTripSettings');
        };

        /*
         * Vehicle selected for test drives.
         */
        vmTypePnl.dealerTripTypeInstanceModelSelected = function (loadingFromRecord) {
            let id = parseInt(parent_vm.testDriveTempDTT);
            let dtts = parent_vm.theTrip.selectedSystemTripType.dealerTripTypes;
            let dtt = null;

            if (!loadingFromRecord) {
                parent_vm.bookingRules = null;
            }

            dtt =  $filter('filter')(dtts, {id: parseInt(id)}, true)[0];
            parent_vm.theTrip.dealerTripTypeInstance = dtt;

            if (dtt && dtt.vehicle) {
                parent_vm.theTrip.vehicleModelId = dtt.vehicle.id;
                let populateServiceOrder = !parent_vm.serviceOrder && !parent_vm.resolvedServiceOrder;

                dealerTripTypeInstanceSelected(populateServiceOrder, true, loadingFromRecord);
            }

            parent_vm.updateState();
        };

        /*
         * Recall vehicle selected
         */
        vmTypePnl.recallModelSelected = function (loadingFromDB) {
            if (parent_vm.theTrip.dealerTripTypeInstance && !loadingFromDB) {
                let tripWiz = parent_vm.tripWizard;

                if (tripWiz.recall && tripWiz.vehicle) {
                    if (!parent_vm.serviceOrder) {
                        parent_vm.theTrip.isNewServiceOrder = true;
                        parent_vm.createNewServiceOrder();
                    }

                    parent_vm.serviceOrder.recallId = tripWiz.recall.id;
                    populateServiceOrderVehicle(tripWiz.vehicle);
                }
            } else {
                parent_vm.serviceOrder.recallId = parent_vm.resolvedServiceOrder.recallId;
                parent_vm.tripWizard.recall = $filter('filter')(parent_vm.theTrip.dealerTripTypeInstance.recalls, {id: parent_vm.resolvedServiceOrder.recallId})[0];
                parent_vm.tripWizard.vehicle = $filter('filter')(parent_vm.tripWizard.recall.models, {make: parent_vm.resolvedServiceOrder.make, model: parent_vm.resolvedServiceOrder.model})[0];
                populateServiceOrderVehicle(parent_vm.theTrip.dealerTripTypeInstance.vehicle);
            }
        };

        function redirectToAppointment() {
            parent_vm.routingToAppt = true;

            return modalService.showYesNo('Go to Appointment',
                'Picking up a customer’s vehicle for service is now booked using the appointment scheduler.  Click OK to begin booking a new service appointment.',
                'Cancel', 'OK', true)
                .then((shouldRedirect) => {
                    if (shouldRedirect) {
                        $state.go('appointment-add', {locationId: parent_vm.theTrip.dealerLocation.id, appointmentId: null, fromCachedMenu: false}).catch((fail) => {
                            parent_vm.routingToAppt = false;
                        });
                    } else {
                        parent_vm.routingToAppt = false;
                    }
                })
                .catch(() => {
                    parent_vm.routingToAppt = false;
                });
        }

        vmTypePnl.productGroupSelected = function (productGroup) {
            if (parent_vm.selectedProductGroup) {
                vmTypePnl.clearProductGroup();
            }

            productGroup.selected = true;
            parent_vm.theTrip.selectedProductGroup = productGroup;
            
            if (productGroup.systemTripTypes.length === 1) {
                let selectedSystemTripType = productGroup.systemTripTypes[0];

                // PROD-6255, if they have appointments, we need to redirect them if they selected service valet pickup
                if (selectedSystemTripType.id === SYSTEM_ENUMS.systemTripType.pickup && vmTypePnl.hasAppointments && vmTypePnl.allowBookingStandAloneTrips === false) {
                    productGroup.selected = false;
                    parent_vm.theTrip.selectedProductGroup = null;
                    redirectToAppointment();

                    return;
                } else {
                    vmTypePnl.systemTripTypeSelected(selectedSystemTripType);
                }
            } else {
                parent_vm.accordion.selectedStep = steps.tripSettings;
            }

            $rootScope.$broadcast('productGroupSelected');
        };

        parent_vm.productGroupSelected = vmTypePnl.productGroupSelected;

        vmTypePnl.systemTripTypeSelected = function (selSystemTripType) {
            // Clear any previous ride provider errors
            parent_vm.showRideProviderMessage = false;
            parent_vm.rideProviderMessage = null;
            
            parent_vm.theTrip.selectedSystemTripType = vmTypePnl.selectedSystemTripType = selSystemTripType;
            copyEnumValuesToSelectedTripType();
            let dtts = selSystemTripType.dealerTripTypes;

            if (parent_vm.resolvedTripType) {
                // trip type passed in route and possibly other items
                // determine which are populated and process them
                parent_vm.testDriveTempDTT = parent_vm.resolvedTripType.id;
                vmTypePnl.selectedDealerTripType = parent_vm.resolvedTripType;
                parent_vm.theTrip.dealerTripTypeInstance = vmTypePnl.selectedDealerTripType;
                loadDataFromResolvedObjects(selSystemTripType);

            } else if (parent_vm.resolvedTrip && dtts.length === 1) {
                vmTypePnl.selectedDealerTripType = dtts[0];
                parent_vm.theTrip.dealerTripTypeInstance = vmTypePnl.selectedDealerTripType;
                loadDataFromResolvedObjects(selSystemTripType);
            } else if (dtts.length === 1) {
                // there is only one trip type instance matching this sys trip type, so use it
                vmTypePnl.selectedDealerTripType = dtts[0];
                parent_vm.testDriveTempDTT = vmTypePnl.selectedDealerTripType.id;
                parent_vm.theTrip.dealerTripTypeInstance = vmTypePnl.selectedDealerTripType;

                if (selSystemTripType.requiresVehicleSelection) {
                    vmTypePnl.dealerTripTypeInstanceModelSelected();
                }
            // group selection indicates recalls currently will most likely be future test drives
            // vehicle selection is current test drives
            } else if (!selSystemTripType.requiresGroupSelection && !selSystemTripType.requiresVehicleSelection) {
                // get the default trip type instance for this system trip type
                vmTypePnl.selectedDealerTripType = $filter('filter')(dtts, {isDefault: true})[0];
                parent_vm.theTrip.dealerTripTypeInstance = vmTypePnl.selectedDealerTripType;
                loadDataFromResolvedObjects(selSystemTripType);
            }

            if (parent_vm.productGroupSelectedRONewServiceOrder) {
                parent_vm.theTrip.isNewServiceOrder = true;
            }

            $rootScope.$broadcast('systemTripTypeSelected');

            if ((selSystemTripType.supportsDMSSearch === false || parent_vm.theTrip.dealerLocation.dmsEnabled === false) &&
                (selSystemTripType.requiresVehicleSelection === false || selSystemTripType.id === SYSTEM_ENUMS.systemTripType.recalls)) {
                    if (!parent_vm.resolvedServiceOrder && !parent_vm.selectedSearchServiceOrder) {
                        parent_vm.theTrip.isNewServiceOrder = true;
                    }

                    dealerTripTypeInstanceSelected(parent_vm.theTrip.isNewServiceOrder, false, !!parent_vm.resolvedTripType);
            }

            if (parent_vm.theTrip.dealerTripTypeInstance && parent_vm.theTrip.dealerTripTypeInstance.defaultVenue && parent_vm.theTrip.dealerLocation) {
                parent_vm.theTrip.dealerLocation.lat = parent_vm.theTrip.dealerTripTypeInstance.defaultVenue.lat;
                parent_vm.theTrip.dealerLocation.lng = parent_vm.theTrip.dealerTripTypeInstance.defaultVenue.lng;
            }

            parent_vm.updateState();
            parent_vm.accordion.selectedStep = selSystemTripType.id === SYSTEM_ENUMS.systemTripType.lyftCredit ? steps.lyftCreditSettings : steps.tripSettings;

            //show modal if pickup trip exists
            if (selSystemTripType.id === SYSTEM_ENUMS.systemTripType.dropoff && parent_vm.resolvedParentTrip) {
                parent_vm.resolvedRO = parent_vm.resolvedRO ? [...parent_vm.resolvedRO].sort((a, b) => new Date(b.updatedDate) - new Date(a.updatedDate))[0] : null;
                 modalService.showReturnTripDetails(parent_vm.theTrip.dealerLocation.dmsEnabled ? parent_vm.resolvedRO : null,
                    parent_vm.resolvedParentTrip.loanerConfirmationNumber, parent_vm.resolvedParentTrip.customerName,  parent_vm.resolvedParentTrip.expectedStartTime);
                }

        };

        vmTypePnl.clearProductGroupSelectedSystemTripType = function () {
            parent_vm.bookingRules = null;
            parent_vm.favoriteLocations = null;
            parent_vm.resolvedTripType = null;
            parent_vm.dmsVehicleYearMakeModels = null;
            parent_vm.requiresYearDropDown = false;
            parent_vm.theTrip.vehicleModelId = null;
            parent_vm.theTrip.availableBookingDays = null;
            parent_vm.theTrip.availableBookingHours = null;
            parent_vm.theTrip.selectedSystemTripType = null;
            parent_vm.theTrip.dealerTripTypeInstance = null;
            vmTypePnl.selectedSystemTripType = null;
            vmTypePnl.selectedDealerTripType = null;
            parent_vm.selectedSearchServiceOrder = null;
            parent_vm.productGroupSelectedRONewServiceOrder = false;
            parent_vm.theTrip.referenceNumber = null;

            $rootScope.$broadcast('clearTripSettings', true);
            vmTypePnl.clearModelSelectedDealerTripTypeInstance();
        };

        vmTypePnl.clearTripType = function (isClearingPrevSteps) {
            vmTypePnl.clearProductGroupSelectedSystemTripType();

            if (!isClearingPrevSteps) {
                parent_vm.updateState();
                parent_vm.accordion.selectedStep = steps.chooseTripType;
            }
        };


        vmTypePnl.clearProductGroup = function (isClearingPreviousSteps) {
            vmTypePnl.clearTripType(isClearingPreviousSteps);
            _.each(parent_vm.experiencesPanelGroups, (panelGroup) => {
                _.each(panelGroup.productGroups, (productGroup) => {
                    productGroup.selected = false;
                });
            });

            parent_vm.theTrip.selectedProductGroup = null;
        };

        // this will unregister itself when the scope is destroyed, nothing to manually clean up
        $scope.$on('locationChosen', (event, data) => {
            getLocationTripTypeInstances();
        });

        $scope.$on('clearSelectedTripType', (event, data) => {
            vmTypePnl.clearTripType();
        });

        $scope.$on('clearProductGroupSelectedSystemTripType', (event, data) => {
            vmTypePnl.clearProductGroupSelectedSystemTripType();
        });

        $scope.$on('dealerTripTypeInstanceModeleSelected', (event, data) => {
            vmTypePnl.dealerTripTypeInstanceModelSelected();
        });

        $scope.$on('recallModelSelected', (event, data) => {
            vmTypePnl.recallModelSelected();
        });

        $scope.$on('clearModeleSelected', (event, data) => {
            vmTypePnl.clearModelSelectedDealerTripTypeInstance();
        });

        $scope.$on('createNewServiceOrder', (event, data) => {
            createNewServiceOrder(data);
        });

        $scope.$on('setSelectedSystemTripType', (event, data) => {
            // todo: figure out why data isn't being passed properly.
            vmTypePnl.systemTripTypeSelected(data);
        });
    }
})();

(function () {
    'use strict';

    TripAddChooseLocationController.$inject = ["$rootScope", "$scope", "$filter", "$timeout", "tripService", "locationService"];
    angular
        .module('redcap.trip')
        .controller('TripAddChooseLocationController', TripAddChooseLocationController);

    function TripAddChooseLocationController($rootScope, $scope, $filter, $timeout, tripService, locationService) {
        let vmPnl = this;
        let parent_vm = $scope.$parent.vm;
        let theTrip = parent_vm.theTrip;
        let steps = parent_vm.accordion.steps;
        
    
        vmPnl.locationListLogos = null;
            
        vmPnl.getLocationListLogo = function (adminProgramId) {
            if (vmPnl.locationListLogos && vmPnl.locationListLogos.length > 0) {
                let adminLoc = $filter('filter')(vmPnl.locationListLogos, {id: adminProgramId});

                if (adminLoc && adminLoc[0]) {
                    return adminLoc[0].locationListLogo;
                }
            }

            return null;
        };

        vmPnl.isBelowSearchThreshold = function () {
            if (vmPnl.availableLocations.length <= vmPnl.locationSearchThreshold) {
                vmPnl.zipFilteredLocationList = vmPnl.availableLocations;

                if (vmPnl.availableLocations.length > 1 && !vmPnl.locationListLogos) {
                    // if they only have one location we don't need to display a logo,
                    // also we only need to query for the information once.
                    locationService.getAdminConfigLocationListLogos().then((response) => {
                        vmPnl.locationListLogos = response;
                    });
                }
            }
        };
        
        vmPnl.noLocationsForZipFound = false;
        vmPnl.locationSearchThreshold = 5;
        vmPnl.availableLocations = $scope.$parent.vm.tripWizard.activeLocationList;
        vmPnl.selectedLocation = null;
        vmPnl.loading = false;
        vmPnl.chooseLocation = null;
        vmPnl.zip = '';
        vmPnl.filterByZip = null;
        vmPnl.zipMarkers = null;
        parent_vm.zipMarkers = null;
        vmPnl.zipFilteredLocationList = null;
        vmPnl.isBelowSearchThreshold();
        vmPnl.parent_vm = parent_vm;
        vmPnl.steps = steps;

        
        vmPnl.clearZipCodeSearch = function () {
            vmPnl.noLocationsForZipFound = false;
            vmPnl.zip = '';
            vmPnl.filterByZip = '';
            vmPnl.zipFilteredLocationList = null;
            vmPnl.zipMarkers = null;
            parent_vm.zipMarkers = null;
            vmPnl.isBelowSearchThreshold();
        };

        vmPnl.onZipCodeKeyPress = function (event) {
            if (event.which === 13) { //if enter then hit the search button 
                vmPnl.searchLocationByZipCode();
            }

            if (event.which === 8) { //if backspace clear search results
                vmPnl.clearZipCodeSearch();
            }
        };

        vmPnl.onZipCodeBlur = function (event) {
            vmPnl.searchLocationByZipCode();
        };

        vmPnl.searchLocationByZipCode = function () {
            let currZipCodeSearchTermLength = vmPnl.zip.length;
            
            if (currZipCodeSearchTermLength === 0) return; 
            vmPnl.filterByZip = vmPnl.zip;
            vmPnl.zipFilteredLocationList = $filter('filter')(vmPnl.availableLocations, {zip: vmPnl.filterByZip});
            vmPnl.zipMarkers = [];
            let filteredListLength = vmPnl.zipFilteredLocationList.length;

            if (filteredListLength === 0) {
                vmPnl.noLocationsForZipFound = true;
            }

            for (let idx = filteredListLength - 1; idx >= 0; idx--) {
                let currLocation = vmPnl.zipFilteredLocationList[idx];
                let marker = {
                    title: currLocation.name,
                    location: {
                        lat: parseFloat(currLocation.lat),
                        lng: parseFloat(currLocation.lng)
                    }
                };

                vmPnl.zipMarkers.push(marker);
                parent_vm.zipMarkers = vmPnl.zipMarkers;
            }

            
        };

        vmPnl.locationSelected = function (locationFromList, emitSystemTripTypeSelected) {
            if (locationFromList) {
                theTrip.dealerLocation = locationFromList;
            }

            if (vmPnl.selectedLocation) {
                theTrip.dealerLocation = vmPnl.selectedLocation;
            }

            if (theTrip.dealerLocation) {
                $rootScope.$broadcast('messagePaneDealerIdUpdate', theTrip.dealerLocation);

                tripService.hasMessaging(theTrip.dealerLocation.id).then((response) => {
                    $rootScope.$broadcast('messagePaneHasMessagingUpdate', response);
                    parent_vm.hasMessaging = response;
                });
                parent_vm.updateState();
                parent_vm.accordion.selectedStep = steps.chooseTripType;
                vmPnl.clearZipCodeSearch();

                // populate workflows so systemtriptypes can be configured properly downstream.
                tripService.getTripWorkFlows().then((workFlows) => {
                    parent_vm.resolvedTripWorkFlows = workFlows;
                }, (errorResponse) => {
                    parent_vm.displayToastError(errorResponse);
                });  

                $rootScope.$broadcast('locationChosen', theTrip.dealerLocation);
                parent_vm.getServiceAdvisors();
            }

            if (emitSystemTripTypeSelected && parent_vm.resolvedSystemTripType) {
               $rootScope.$broadcast('setSelectedSystemTripType', parent_vm.resolvedSystemTripType);
            }
        };

        vmPnl.clearSelectedLocation = function () {
            $rootScope.$broadcast('clearProductGroupSelectedSystemTripType');
            $rootScope.$broadcast('clearTripSettings', true);
            $rootScope.$broadcast('clearSelectedTripType');
            
            parent_vm.bookingRules = null;
            parent_vm.favoriteLocations = null;
            parent_vm.resolvedTripType = null;
            parent_vm.dmsVehicleYearMakeModels = null;
            parent_vm.requiresYearDropDown = false;
            parent_vm.theTrip.vehicleModelId = null;
            parent_vm.theTrip.availableBookingDays = null;
            parent_vm.theTrip.availableBookingHours = null;
            parent_vm.theTrip.selectedSystemTripType = null;
            parent_vm.theTrip.dealerTripTypeInstance = null;
            parent_vm.theTrip.vehicleModelId = null;
            parent_vm.testDriveTempDTT = null;
            parent_vm.customerLocOptions = {};
            parent_vm.theTrip.dealerLocation = null;
            vmPnl.selectedLocation = null;
            parent_vm.updateState(); 
            parent_vm.dmsVehicleYearMakeModels = null;
            parent_vm.requiresYearDropDown = false;
            parent_vm.accordion.selectedStep = steps.chooseLocation;
            vmPnl.isBelowSearchThreshold();
            $timeout(() => {
                $("#locationFilter").trigger("change");
            }, 1);
            
        };


        $scope.$on('oneLocation', (event, data) => {
            vmPnl.locationSelected(data, true);
        });
    }
})();

(function () {
    'use strict';

    LyftCreditListController.$inject = ["$scope", "$timeout", "$compile", "$rootScope", "systemService", "searchTemplateUtilService", "webworkerService", "rcUtilService", "SAVED_SEARCHES_PLACEHOLDER", "SYSTEM_ENUMS", "toastr", "permissions", "locationService", "rideProviderService", "rcLocalStorageService"];
    angular
        .module('redcap.trip')
        .controller('LyftCreditListController', LyftCreditListController);

    function LyftCreditListController($scope, $timeout, $compile,  $rootScope, systemService, searchTemplateUtilService, webworkerService, rcUtilService, SAVED_SEARCHES_PLACEHOLDER, SYSTEM_ENUMS, toastr, permissions, locationService, rideProviderService, rcLocalStorageService) {

        let vmList = this;
        let displayLimit = 30;
        let searchTemplateType = SYSTEM_ENUMS.searchTemplateTypes.lyftCredit;

        vmList.loadingLocations = false;
        vmList.hasMultipleDealers = true;
        vmList.resolvedLocationList = null;
        vmList.dealerListInitialized = false;
        vmList.noLocationsText = 'ALL LOCATIONS';
        vmList.showAdvancedSearch  = false;
        vmList.parent_vm = $scope.$parent.vm;
        vmList.isSysAdmin = permissions.isSysAdmin() || permissions.isRedCapAdmin() || permissions.isDeveloper();
        vmList.tripTypeEnum = SYSTEM_ENUMS.systemTripType;
        vmList.isLoading = false;
        searchTemplateUtilService.initSearchTemplateData(vmList);
        vmList.displayLimit = displayLimit;
        vmList.isLoading = false;
       
        let initialFilters = { 
            customerFilter: null,
            customerIdFilter: null,
            locationFilter: null,
            creditStatusFilter: null,
            creditTypeFilter: null,
            timeframeFilter: 0,
            campaignIdFilter: null,
            showExpired: false,
            showBulkUpload: false,
            currentFilterLocation: null,
            customTimeframe: {startDate: null, endDate: null}
        };

        let savedFilterKey = "vouchersListSavedFilterKey";
        let savedTemplateKey = "vouchersListSavedTemplateKey";
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};
        
        vmList.timeframes = [
            {value: 0, text: 'Issued Today'},
            {value: 1, text: 'Issued This Week'},
            {value: 4, text: 'Issued Last Week'},
            {value: 5, text: 'Issued Last 30 Days'},
            {value: 3, text: 'Custom...'}
        ];

        vmList.actions = {
            extend: '1',
            adjust: '2',
            cancel: '3'
        };

        vmList.creditStatuses = [
            {value: 'invited', text: 'Invited'},
            {value: 'active', text: 'Active'},
            {value: 'completed', text: 'Completed'},
            {value: 'cancelled', text: 'Cancelled'}
        ];

        vmList.creditTypes = [
            {value: 1, text: 'Repair Order'},
            {value: 2, text: 'Roadside Assistance'},
            {value: 3, text: 'New Vehicle Sale'},
            {value: 4, text: 'Special Event'},
            {value: 5, text: 'Bulk Upload'},
            {value: 6, text: 'Appointment'},
            {value: 7, text: 'Loaner Contract'}
        ];

        vmList.providerType = function(provider) {
            return provider === SYSTEM_ENUMS.rideProviderType.lyft ? 'Lyft' : 'Uber';
        };

        vmList.clearClientIdField = function () {
            vmList.filters.customerIdFilter = null;
            vmList.listFilterChanged();
        };

        vmList.clearCampaignIdField = function () {
            vmList.filters.campaignIdFilter = null;
            vmList.listFilterChanged();
        };

        vmList.displayMore = function () {
            $timeout(() => { vmList.displayLimit += displayLimit / 5; }, 10);
        };

        vmList.clearFilters = function () {
            vmList.resetFilters();
            saveFilters();
            updateList();
        };

        vmList.searchBtnClicked = function () {
            saveFilters();
            updateList();
        };

        vmList.listFilterChanged = function (fromDatePicker) {
            if (vmList.filters.timeframeFilter === 3 && fromDatePicker) {
                if (vmList.showAdvancedSearch) {
                    $timeout(() => {
                        $('#timeframe_range-2').data('daterangepicker').toggle();
                    }, 1);
                } else {
                    $timeout(() => {
                        $('#timeframe_range').data('daterangepicker').toggle();
                    }, 1);
                }
            }

            saveFilters();
            updateDirtyFlag();

            if (!vmList.showAdvancedSearch) {
                updateList();
            }
           
        };

        vmList.tripListModeChanged = function () {
            vmList.showAdvancedSearch = false;
            vmList.parent_vm.handleListModeUpdated();
        };

        vmList.showCalendar = function () {
            return vmList.filters.timeframeFilter === 3;
        };

        vmList.clearCustomTimeFrame = function () {
            vmList.filters.timeframeFilter = 0;
            vmList.listFilterChanged();
        };

        vmList.dateRangePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { 
                    vmList.listFilterChanged(); 
                }
            }
        };

        vmList.refreshCredit = function(credit, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            vmList.isRefreshing = true;
            credit.isRefreshing = true;
            rideProviderService.getCredit(credit.id, credit.isTest).then((updatedCredit) => {
                vmList.isRefreshing = false;

                formatCredit(updatedCredit);
                
                let creditToUpdate = _.find(vmList.filteredCredits, {id: credit.id});

                creditToUpdate = angular.copy(updatedCredit, creditToUpdate);
                credit.isRefreshing = false;
            }, (err) => {
                vmList.isRefreshing = false;
                credit.isRefreshing = false;
                toastr.error('An error occurred while refreshing the credit: ' + err);
            });
        };

        vmList.resetFilters = function () {
            vmList.isLoading = true;
            vmList.filters.locationFilter = null;
            vmList.filters.currentFilterLocation = null;
            vmList.filters.selectedSingleLocation = null;
            vmList.filters.selectedSingleLocationId = null;
            vmList.filters.customerFilter = null;
            vmList.filters.creditStatusFilter = null;
            vmList.filters.creditTypeFilter = null;
            vmList.filters.dateRangeFilter = null;
            vmList.filters.timeframeFilter = null;
            vmList.filters.campaignIdFilter = null;
            vmList.filters.customerIdFilter = null;
            vmList.filters.showExpired = false;
            vmList.templateName = null;
            vmList.searchTemplateData.currentSearchTemplate = null;
            vmList.searchTemplateData.savedSearchName = null;
            vmList.filters.customTimeframe = [];
            vmList.filtersBeforeAdvancedSearch  = _.cloneDeep(vmList.filters);
            
            $timeout(() => {
                // clear the select2
                $('#location-filter-single').val(null).trigger('change');
            }, 1);
            
            updateList();
        };

        vmList.handleConfirmKeypress = function(event) {
            if (event.which === 13) {
                vmList.listFilterChanged();
            }
        };

        vmList.customerFilterUpdated = function () {
            if (vmList.filters.customerFilter !== vmList.prevCustomerSearchValue) {
                vmList.prevCustomerSearchValue = vmList.filters.customerFilter;
                vmList.listFilterChanged();
            }
        };

        vmList.clearCustomerField = function () {
            vmList.filters.customerFilter = null;

            if (vmList.filters.customerFilter !== vmList.prevCustomerSearchValue) {
                vmList.prevCustomerSearchValue = vmList.filters.customerFilter;
                vmList.listFilterChanged();
            }
        };

        vmList.toggleShowSearchOptions = function () {
            vmList.searchTemplateBeforeAdvancedSearch = _.cloneDeep(vmList.searchTemplateData);
            vmList.filtersBeforeAdvancedSearch  = _.cloneDeep(vmList.filters);

            if (vmList.showAdvancedSearch) {
                vmList.selectedSingleLocationId = null;
                $timeout(() => {
                    vmList.filters.currentFilterLocation = vmList.selectedSingleLocation;
                    vmList.selectedSingleLocationId = vmList.selectedSingleLocation.id;
                }, 250);
                
                updateList();
            }

            vmList.showAdvancedSearch  = !vmList.showAdvancedSearch;

        };

        vmList.isLocationListEmpty = function () {
            return vmList.resolvedLocationList == null || 
                    (vmList.resolvedLocationList.length === 1 && vmList.resolvedLocationList[0] === "");
        };

        vmList.isLocationListEmpty = function () {
            return vmList.dealerListInitialized === false || 
                   vmList.resolvedLocationList === null || 
                    (vmList.resolvedLocationList && vmList.resolvedLocationList.length === 0);
        };

        vmList.getDealerLocations = function(dealerToSelect) {
            if (vmList.dealerListInitialized === false && vmList.loadingLocations === false) {
                vmList.loadingLocations = true;   
                locationService.getLocationsForDropDown(true, false, null, [SYSTEM_ENUMS.systemTripType.lyftCredit]).then((result) => {
                    locationService.addTooltipInfoToLocations(vmList, result);
                    vmList.resolvedLocationList = result;

                    if (dealerToSelect) {
                        let dealerFromList = _.find(vmList.resolvedLocationList, (dealer) => { return dealer.id === parseInt(dealerToSelect.id); });

                        vmList.selectedSingleLocation = dealerFromList;
                        vmList.selectSingleLocation([dealerFromList]);
                    }

                    vmList.dealerListInitialized = true;
                    vmList.loadingLocations = false;   
                });
            }
        };

        vmList.locationSearchQuery = {
            type: 'GET',
            dataType: 'json',
            data: function (parameters) {
                let query = {
                    search: parameters.term,
                    page: parameters.page,
                    pageSize: 5000
                };

                return query;
            },
            transport: function (params, success, failure) {
                let data = params.data;

                if (data.search && data.search.length > 0) {
                    return webworkerService.filter(vmList.resolvedLocationList, data.search, false, 'name').then(success, failure);
                } else {
                    return vmList.resolvedLocationList;
                }
            },
            delay: 250,
            processResults: function (data) {
                return {
                    results: data,
                    pagination: {
                        more: data.length === 5000
                    }
                };
            }
        };

        vmList.formatLocationForSelection = function (item) {
            return item.name;
        };

        vmList.formatLocationForDropdown = function (item) {
            console.log(item);

            if (item.html) {
                let option = $(item.html);

                $compile(option.contents())($scope);

                return option;
            } else {
                return item.name;
            }
        };

        vmList.selectSingleLocation = function (item) {
            if (item && item.length > 0) {
                vmList.filters.currentFilterLocation = item[0];
                vmList.filters.locationFilter = item[0].id + "";
            } else {
                vmList.filters.currentFilterLocation = null;
                vmList.filters.locationFilter = null;
            }

            vmList.listFilterChanged();
        };

        vmList.loadSearchTemplate = function (item, model) {
            if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                rcLocalStorageService.set(savedTemplateKey, vmList.searchTemplateData.currentSearchTemplate);
                let template = item.template;

                vmList.searchTemplateData.isTemplateDirty = false;
                vmList.searchTemplateData.currentSearchTemplate = item;
                vmList.searchTemplateData.savedSearchName = template.templateName;
                vmList.filters.locationFilter = template.locationFilter;
                vmList.filters.customerFilter = template.customerFilter;
                vmList.filters.creditStatusFilter = template.creditStatusFilter;
                vmList.filters.creditTypeFilter = template.creditTypeFilter;
                vmList.filters.timeframeFilter = template.timeframeFilter;
                vmList.filters.campaignIdFilter = template.campaignIdFilter;
                vmList.filters.customerIdFilter = template.customerIdFilter;
                vmList.filters.currentFilterLocation = template.currentFilterLocation;
                vmList.filters.showExpired = template.showExpired;
                vmList.templateName = template.templateName;
                vmList.isGlobalTemplate = item.isGlobal;
                vmList.filters.customTimeframe = template.customTimeframe ? template.customTimeframe : {startDate: null, endDate: null};

                if (vmList.filters.customTimeframe && vmList.filters.customTimeframe.endDate) {
                    if (!moment.isMoment(vmList.filters.customTimeframe.endDate)) {
                        vmList.filters.customTimeframe.endDate = moment(vmList.filters.customTimeframe.endDate);
                    }
                }

                if (vmList.filters.customTimeframe && vmList.filters.customTimeframe.startDate) {
                    if (!moment.isMoment(vmList.filters.customTimeframe.startDate)) {
                        vmList.filters.customTimeframe.startDate = moment(vmList.filters.customTimeframe.startDate);
                    }
                }

                if (template.currentFilterLocation) {
                    if (!vmList.resolvedLocationList) {
                        vmList.getDealerLocations(template.currentFilterLocation);
                    } else {
                        let dealerFromList = _.find(vmList.resolvedLocationList, (dealer) => { return dealer.id === parseInt(template.currentFilterLocation.id); });

                        vmList.selectedSingleLocation = dealerFromList;
                        vmList.selectSingleLocation([dealerFromList]);
                    }   
                }

            } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                rcLocalStorageService.set(savedTemplateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vmList);
                vmList.resetFilters();
            } else {
                rcLocalStorageService.set(savedTemplateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vmList);
            }

            updateList();
    
        };

        vmList.clearSearchCriteria = function () {
            vmList.resetFilters(true);
            vmList.keywordFilter = null;
            vmList.isGlobalTemplate = false;
            updateList();
        };

        vmList.applyBtnClicked = function () {
            vmList.searchTemplateBeforeAdvancedSearch = null;
            vmList.filtersBeforeAdvancedSearch = null;
            vmList.showAdvancedSearch = false;
            updateList();
        };

        vmList.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vmList.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };

        vmList.close = function () {
            searchTemplateUtilService.advancedFilterModalClosed(vmList);
        };

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vmList.searchTemplateData.currentSearchTemplate.id = null;
            }

            searchTemplateUtilService.saveSearchTemplateClicked(vmList,
                {
                    locationFilter: vmList.filters.locationFilter,
                    creditStatusFilter: vmList.filters.creditStatusFilter,
                    timeframeFilter: vmList.filters.timeframeFilter,
                    campaignIdFilter: vmList.filters.campaignIdFilter,
                    customerIdFilter: vmList.filters.customerIdFilter,
                    customerFilter: vmList.filters.customerFilter,
                    showExpired: vmList.filters.showExpired,
                    templateName: vmList.searchTemplateData.savedSearchName,
                    currentFilterLocation: vmList.filters.currentFilterLocation,
                    isGlobalTemplate: vmList.isGlobalTemplate,
                    customTimeframe: vmList.filters.customTimeframe
                }, searchTemplateType);
            
        }

        function saveFilters() {
            rcLocalStorageService.set(savedFilterKey, vmList.filters);
            rcLocalStorageService.set(savedTemplateKey, vmList.searchTemplateData.currentSearchTemplate);
        }

        function updateDirtyFlag() {
            if (vmList.searchTemplateData.currentSearchTemplate) {
                vmList.searchTemplateData.isTemplateDirty = true;
            }
        }

        function createFilterMessage() {
            
            vmList.filterCount = 0;
            vmList.filterMessage = '';
            let customTimeFrame = vmList.filters.customTimeframe;

            if (vmList.filters.customerFilter && vmList.filters.customerFilter.length > 0) {
                rcUtilService.buildFilterMessage('Customer Name', vmList.filters.customerFilter, vmList);
            }

            if (vmList.filters.timeframeFilter !== null) {
                let timeframe = _.find(vmList.timeframes, (tf) => { return tf.value === vmList.filters.timeframeFilter; });

                if (timeframe) {
                    rcUtilService.buildFilterMessage('Date Range', timeframe.text, vmList);
                }
            }

            if (vmList.filters.locationFilter && vmList.filters.locationFilter.length > 0) {
                let name = vmList.filters.currentFilterLocation ? vmList.filters.currentFilterLocation.name : '1 Dealer';

                rcUtilService.buildFilterMessage('Location', name, vmList);
            }

            if (vmList.filters.creditStatusFilter) {
                let selStatus = _.find(vmList.creditStatuses, (status) => { return status.value === vmList.filters.creditStatusFilter; });

                rcUtilService.buildFilterMessage('Status', selStatus.text, vmList);
            }

            if (vmList.filters.creditTypeFilter) {
                let selType = _.find(vmList.creditTypes, (type) => { return type.value === vmList.filters.creditTypeFilter; });

                rcUtilService.buildFilterMessage('Type', selType.text, vmList);
            }

            if (vmList.filters.campaignIdFilter && vmList.filters.campaignIdFilter.length > 0) {
                rcUtilService.buildFilterMessage('Campaign Id', vmList.filters.campaignIdFilter, vmList);
            }

            if (vmList.filters.customerIdFilter && vmList.filters.customerIdFilter.length > 0) {
                rcUtilService.buildFilterMessage('Customer Id', vmList.filters.customerIdFilter, vmList);
            }

            if (vmList.filters.showExpired) {
                rcUtilService.buildFilterMessage('EXPIRED', 'SHOW EXPIRED', vmList);
            }

            if (vmList.filters.timeframeFilter === 3 && 
                customTimeFrame && 
                customTimeFrame !== undefined && 
                customTimeFrame.startDate && 
                customTimeFrame.endDate) {
                rcUtilService.buildFilterMessage('Date', new Date(customTimeFrame.startDate).toLocaleDateString() + ' - ' + new Date(customTimeFrame.endDate).toLocaleDateString(), vmList);
            }
        }

        function updateList() {
            createFilterMessage();

            vmList.displayLimit = displayLimit;
            vmList.isLoading = true;
            vmList.searchErrorOccurred = null;

            let filter = {
                customerName: vmList.filters.customerFilter,
                timeframe: vmList.filters.timeframeFilter,
                dealerId: vmList.filters.locationFilter,
                status: vmList.filters.creditStatusFilter,
                creditType: vmList.filters.creditTypeFilter,
                campaignId: vmList.filters.campaignIdFilter,
                customerId: vmList.filters.customerIdFilter,
                showExpired: vmList.filters.showExpired,
                fromDate: vmList.filters.customTimeframe.startDate,
                toDate: vmList.filters.customTimeframe.endDate
            };

            if (vmList.filters.customTimeframe && vmList.filters.customTimeframe !== undefined && vmList.filters.customTimeframe.startDate && vmList.filters.customTimeframe.endDate) {
                filter.fromDate = vmList.filters.customTimeframe.startDate;
                filter.toDate = vmList.filters.customTimeframe.endDate;
            } else {
                filter.fromDate = null;
                filter.toDate = null;
            }

            vmList.filteredCredits = null;

            rideProviderService.searchCredits(filter).then((filteredCredits) => {
                vmList.allCredits = filteredCredits;
                vmList.filteredCredits = filteredCredits;

                _.each(vmList.filteredCredits, (credit) => {
                    formatCredit(credit);
                });

                vmList.isLoading = false;
                vmList.canLoadMore = filteredCredits && filteredCredits.length === vmList.filteredCredits.pageSize;

            }, (err) => {
                vmList.searchErrorOccurred = true;
                vmList.isLoading = false;
            });
        }

        function loadLastTemplateAndFilters() {
            vmList.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate(savedTemplateKey);
            
            if (vmList.searchTemplateData.currentSearchTemplate) {
                
                let searchItem = _.find(vmList.searchTemplateData.searchTemplates, (item) => { return item.template.templateName === vmList.searchTemplateData.currentSearchTemplate; });

                if (searchItem) {
                    vmList.loadSearchTemplate(searchItem);
                } else {
                    vmList.searchTemplateData.currentSearchTemplate = null;
                    updateList();
                }
            }  else {
                updateList();
            }
        }
        
        function init() {
            vmList.filters = _.extend({}, initialFilters, existingFilters);
            vmList.searchTemplateData.currentSearchTemplate = rcLocalStorageService.get(savedTemplateKey) || null;

            locationService.getLocationsCountForTripListDropDown(true, false, SYSTEM_ENUMS.permissionTypes.transportation).then((locationCount) => {
                if (locationCount) {
                    vmList.hasMultipleDealers = locationCount > 1;

                    if (vmList.hasMultipleDealers === false) {
                        vmList.getDealerLocations();
                    }
                }
            });

            if (vmList.searchTemplateData.searchTemplates.length === 0) {
                systemService.getSearchTemplates(searchTemplateType).then((templates) => {
                    vmList.searchTemplateData.searchTemplates = templates;
                    loadLastTemplateAndFilters();
                });
            } else {
                loadLastTemplateAndFilters();
            }
        }

        function formatCredit(credit) {
            setDaysLeft(credit);

            credit.creditAmount = credit.creditAmount / 100;
            credit.creditBalance = credit.creditBalance / 100;
            credit.creditType = _.find(vmList.creditTypes, {value: credit.creditType}).text;
        }

        function setDaysLeft(credit) {
            let startTime = moment(credit.startTime);
            let endTime = moment(credit.endTime);
            let now = moment().utc();
            let timeLeft = endTime.diff(now, 'seconds');            

            credit.daysValid = endTime.diff(startTime, 'days');
            credit.timeLeft = timeLeft < 0 ? 'Expired' : timeLeft;
        }

        $scope.$on('LyftCreditService.changed', (event, data) => {
            updateList();
        });

        init();
    }
})();


(function () {
    'use strict';

    LyftCreditEditController.$inject = ["modalService", "$scope", "$rootScope", "$state", "timeUtilService", "rideProviderService", "resolvedCredit", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('LyftCreditEditController', LyftCreditEditController);

    function LyftCreditEditController(modalService, $scope, $rootScope, $state, timeUtilService, rideProviderService, resolvedCredit, SYSTEM_ENUMS) {
        var vm = this;
    
        vm.credit = resolvedCredit;
        vm.credit.referenceNote = vm.credit.referenceNote || '';
        vm.benefitTypes = SYSTEM_ENUMS.rideProviderBenefitTypes;
        vm.benefitStatusTypes = SYSTEM_ENUMS.rideProviderBenefitStatusTypes;

        vm.originalRemainingAmount = vm.credit.benefit.remainingAmount;
        vm.originalRemainingNumRides = vm.credit.benefit.remainingNumRides;
        vm.originalReferenceNote = vm.credit.referenceNote;
        
        vm.endTime = moment.utc(vm.credit.endTime).local().format('MMM DD, YYYY');
        vm.originalEndTime = moment(vm.endTime);
        
        vm.dateCreated = moment.utc(vm.credit.dateCreated).local().format('MMM DD, YYYY');

        vm.minDate = moment(vm.originalEndTime);
        vm.maxDate = moment.utc(vm.credit.endTime).local().add(90, 'days');

        var now = moment().utc(),
            timeLeft = moment(vm.credit.endTime).diff(now, 'seconds');
            
        vm.cancelled = vm.credit.status === 'cancelled';
        vm.expired = timeLeft <= 0 && !vm.cancelled ? true : false;

        function daysInTimeframe(endTime) {
            return  moment(endTime).endOf('day').diff(moment(vm.credit.startTime).startOf('day'), 'day');
        }

        vm.isEditable = !(vm.expired || vm.credit.preventEditOrDelete || vm.cancelled);

        vm.daysOfWeek = timeUtilService.shortDays; 

        function updateCredit () {
            vm.updatingCredit = true;
            
            var creditDataToUpdate = {
                id: vm.credit.id,
                benefitType: vm.credit.benefitType,
                discountAmount: (vm.credit.benefit.discountAmount + (vm.credit.benefit.remainingAmount - vm.originalRemainingAmount)) * 100,
                referenceNote: vm.credit.referenceNote,
                startTime: vm.credit.startTime.startOf('day'),
                endTime: vm.credit.endTime.endOf('day'),
                numRides: vm.credit.benefit.numRides + (vm.credit.benefit.remainingNumRides - vm.originalRemainingNumRides)
            };

            rideProviderService.updateCredit(creditDataToUpdate).then(function(response) {
                vm.updatingCredit = false;
                if (response && !response.error) {
                    $rootScope.$broadcast('LyftCreditService.changed', vm.credit);
                    $state.go('trip-list');
                } else {
                    vm.error = 'An error occurred while updating the credit: ';
                }
            });
        }

        vm.validateDate = function () {
            var days = daysInTimeframe(vm.endTime);
            return { isValid: days <= 90 && days >= 0, message: '' };
        };

        vm.validateLaterDate = function() {
            var endTime = moment(vm.endTime);
            return { isValid: endTime.endOf('day').isSameOrAfter(vm.originalEndTime.endOf('day')), message: '' };
        };

        vm.isBenefitChanged = function() {
            return vm.credit.benefit.remainingAmount > vm.originalRemainingAmount
                || moment(vm.endTime).isAfter(vm.originalEndTime)
                || vm.credit.referenceNote !== vm.originalReferenceNote;
        };

        vm.cancelCredit = function () {
            vm.error = null;
            modalService.showYesNo('Confirm Revoke', 'Are you sure you want to revoke this credit?', 'No', 'Yes', true).then(function (confirmed) {
                vm.cancelling = true;
           
                if (confirmed) {
                    rideProviderService.cancelCredit(vm.credit.id, vm.credit.isTest).then(function (response) {
                        vm.cancelling = false;
                        if (response && !response.error) {
                            $rootScope.$broadcast('LyftCreditService.changed', vm.credit);
                            $state.go('trip-list');
                        } else {
                            vm.error = 'An error occurred while deleting the credit: ' + response.error.error;
                        }

                    }, function (err) {
                        vm.error = 'An error occurred while deleting the credit.  Please try again.';
                    });
                } else {
                    vm.cancelling = false;
                }
            });
        };


        vm.updateCredit = function () {
            vm.credit.startTime = moment(vm.credit.startTime);
            vm.credit.endTime = moment(vm.endTime);
            updateCredit();
        };
         
        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });
    }
})();

(function () {
    'use strict';

        LyftCreditAddController.$inject = ["$scope", "$rootScope", "$state", "toastr", "permissions", "rideProviderService", "repairOrderService", "modalService", "SYSTEM_ENUMS", "$timeout", "timeUtilService", "localStorageService", "rcUtilService"];
    angular
        .module('redcap.trip')
        .controller('LyftCreditAddController', LyftCreditAddController);

    function LyftCreditAddController($scope, $rootScope, $state, toastr, permissions, rideProviderService, repairOrderService, 
        modalService, SYSTEM_ENUMS, $timeout, timeUtilService, localStorageService, rcUtilService) {
        let vmSettingsPnl = this;
            let parent_vm = $scope.$parent.vm;
            let roSearchPageSize = 20;
            let roSearchResults = [];
            let today = moment();
            let location = parent_vm.theTrip.dealerLocation;
            let dmsSystem = location.dmsSystem;

        vmSettingsPnl.simpleView = localStorageService.get('lyftCreditSimpleView');
        vmSettingsPnl.createNewRO = false;
        vmSettingsPnl.newRoNumber = null;

        if (vmSettingsPnl.simpleView === null) {
            vmSettingsPnl.simpleView = true;
        }
        
        vmSettingsPnl.advancedOptionsVisible = false;
        vmSettingsPnl.hoursData = timeUtilService.createHoursDropdown(30);
        
        vmSettingsPnl.minDate = new Date();
        vmSettingsPnl.maxDate = new Date(vmSettingsPnl.minDate);
        vmSettingsPnl.maxDate.setDate(vmSettingsPnl.maxDate.getDate() + 90);

        vmSettingsPnl.datePickerOptions = {minDate: vmSettingsPnl.minDate, maxDate: vmSettingsPnl.maxDate};
        vmSettingsPnl.creditTypes = SYSTEM_ENUMS.rideProviderCreditTypes;
        vmSettingsPnl.benefitTypes = SYSTEM_ENUMS.rideProviderBenefitTypes;
        vmSettingsPnl.geoRestrictionTypes = SYSTEM_ENUMS.rideProviderGeoRestrictionTypes;
        vmSettingsPnl.rideProviderTypes = SYSTEM_ENUMS.rideProviderType;
        vmSettingsPnl.rideProviderType = parent_vm.theTrip.rideProviderType;

        vmSettingsPnl.geoRestrictionTypeOptions = [
            {text: 'ON TRIPS THAT START AND END AT ANY LOCATION', value: vmSettingsPnl.geoRestrictionTypes.none},
            {text: 'ON TRIPS THAT AT LEAST START OR END AT ONE OF THE LOCATIONS LISTED BELOW', value: vmSettingsPnl.geoRestrictionTypes.pickupOrDropoff},
            {text: 'ON TRIPS THAT BOTH START AND END AT LOCATIONS LISTED BELOW', value: vmSettingsPnl.geoRestrictionTypes.pickupAndDropoff}
        ];

        vmSettingsPnl.simpleTimeOptions = [
            {text: '1 DAY', value: '1'},
            {text: '2 DAYS', value: '2'},
            {text: '3 DAYS', value: '3'},
            {text: '4 DAYS', value: '4'},
            {text: '5 DAYS', value: '5'},
            {text: 'CUSTOM DATE RANGE', value: 'custom'}
        ];

        vmSettingsPnl.isValidatingBatch = false;

        vmSettingsPnl.lyftCredit = { 
            type: vmSettingsPnl.benefitTypes.credits,
            geoRestrictionType: vmSettingsPnl.geoRestrictionTypeOptions[0].value,
            timeframe: {startDate: null, endDate: null},
            simpleTimeFrame: null
        };

        vmSettingsPnl.geoRestrictions = [{displayName: '', radiusInMeters: null}];

        vmSettingsPnl.validation = {
            phone: function (fieldValue) {
                return rcUtilService.isValidPhone(fieldValue);
            },
            timeRestriction: function(restriction) {
                if (restriction.checked && restriction.startTime !== null && restriction.endTime !== null) {
                    if (restriction.startTime >= restriction.endTime) {
                        return false;
                    }
                }

                return true;
            },
            geoRestriction: function(geoRestrictionType) {
                if (geoRestrictionType) {
                    let geoRestrictions = _.filter(vmSettingsPnl.geoRestrictions, (geoRestriction) => {
                        return _.trim(geoRestriction.displayName) || geoRestriction.radiusInMeters;
                    });

                    if (geoRestrictionType === vmSettingsPnl.geoRestrictionTypes.pickupOrDropoff && !geoRestrictions.length) {
                        return {isValid: false, message: 'Must have at least one geo location'};
                    }

                    if (geoRestrictionType === vmSettingsPnl.geoRestrictionTypes.pickupAndDropoff && geoRestrictions.length < 2) {
                        return {isValid: false, message: 'Must have at least two geo locations'};
                    }
                }

                return {isValid: true, message: 'message'};
            }
        };

        vmSettingsPnl.isEmptyGeoRestriction = function(geoRestriction) {
            return !geoRestriction.lat && !geoRestriction.lng && !geoRestriction.radiusInMeters;
        };

        vmSettingsPnl.placesOptions = {
            watchEnter: true,
            country: 'us,can'
        };

        vmSettingsPnl.creditTypeOptions = [
            {
                id: vmSettingsPnl.creditTypes.repairOrder,
                name: 'Repair order'
            },
            {
                id: vmSettingsPnl.creditTypes.roadsideAssistance,
                name: 'Roadside assistance'
            },
            {
                id: vmSettingsPnl.creditTypes.newVehicleSale,
                name: 'New vehicle sale'
            },
            {
                id: vmSettingsPnl.creditTypes.specialEvent,
                name: 'Special event'
            },
            {
                id: vmSettingsPnl.creditTypes.appointment,
                name: 'Appointment'
            }
        ];

        if (parent_vm.theTrip.dealerLocation.enableLyftBenefitBulkUpload) {
            vmSettingsPnl.creditTypeOptions.push({
                id: vmSettingsPnl.creditTypes.bulkUpload,
                name: 'BULK UPLOAD'
            });
        }

        vmSettingsPnl.timeRestrictionOptions = [
            {dayOfWeek: 1, text: 'MON', checked: false, startTime: null, endTime: null},
            {dayOfWeek: 2, text: 'TUE', checked: false, startTime: null, endTime: null},
            {dayOfWeek: 3, text: 'WED', checked: false, startTime: null, endTime: null},
            {dayOfWeek: 4, text: 'THU', checked: false, startTime: null, endTime: null},
            {dayOfWeek: 5, text: 'FRI', checked: false, startTime: null, endTime: null},
            {dayOfWeek: 6, text: 'SAT', checked: false, startTime: null, endTime: null},
            {dayOfWeek: 0, text: 'SUN', checked: false, startTime: null, endTime: null}
        ];

        vmSettingsPnl.canSetTestTrip = permissions.isRedCapAdmin() || permissions.isSysAdmin() || permissions.isDeveloper();

        if (vmSettingsPnl.canSetTestTrip) {
            vmSettingsPnl.lyftCredit.isTest = true;
        }

        vmSettingsPnl.showDatePicker = function () {
            // Preventing users from entering bad data by making field read only
            // and placing a button there to show/hide the field
            $timeout(() => {
                $('#lyft-credit-date-picker').data('daterangepicker').show();
            }, 1);
        };

        vmSettingsPnl.repairOrderSearchOptions = {
            width: '100%',
            placeholder: 'Repair order search',
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            tags: dmsSystem === 0,
            createTag: function (params) {
                return {
                    roNumber: params.term,
                    id: -1,
                    text: params.term,
                    createNew: true
                };
            },
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        locationId: parent_vm.theTrip.dealerLocation.id,
                        advisorId: null,
                        pageSize: roSearchPageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    return repairOrderService.getOpenRepairOrders(data.search, data.locationId, data.advisorId, data.page, roSearchPageSize).then((results) => {
                        roSearchResults = results;
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 750,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === roSearchPageSize
                        }
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) { return item.text; }

                if (item.createNew) {
                    vmSettingsPnl.createNewRO = true;
                    vmSettingsPnl.newRoNumber = item.roNumber;

                    return 'CREATE NEW - #' + item.roNumber;
                } else {
                    vmSettingsPnl.createNewRO = false;
                    vmSettingsPnl.newRoNumber = null;
                }

                return '#' + item.roNumber + ' ' + item.customerFirstName + ' ' + item.customerLastName + ' $' + (item.roTotal || 0).toFixed(2);
            },
            templateResult: function (item) {
                if (item.loading) {
                    return 'Searching...';
                }

                if (item.createNew) {
                    let option = $("<span class='theme-link no-underline text-normal-case'>Can't find it?  </span>");
                        let newRecord = $("<span class='create-new'>Create a New Record.</span>");

                    option.append(newRecord);

                    return option;
                }

                return '#' + item.roNumber + ' ' + item.customerFirstName + ' ' + item.customerLastName + ' $' + (item.roTotal || 0).toFixed(2);
            }
        };

        vmSettingsPnl.validateBatch = function(file) {
            vmSettingsPnl.lyftCredit.batch = {
                file: file,
                isValid: false,
                isUploaded: false
            };

            let reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = function() {
                let base64FileData = reader.result;

                vmSettingsPnl.isValidatingBatch = true;

                rideProviderService.uploadBatch(parent_vm.theTrip.dealerLocation.id,
                {
                    fileName: file.name,
                    base64FileData: base64FileData
                }).then((result) => {
                    angular.extend(vmSettingsPnl.lyftCredit.batch, result);
                    vmSettingsPnl.lyftCredit.batch.isUploaded = true;
                }).catch((err) => { 
                    console.error(err);
                }).finally(() => {
                    vmSettingsPnl.isValidatingBatch = false;
                });
            };
        };

        vmSettingsPnl.addGeoRestriction = function() {
            let newRestriction = {
                displayName: '',
                radiusInMeters: null
            };

            vmSettingsPnl.geoRestrictions.push(newRestriction);
        };

        vmSettingsPnl.removeGeoRestriction = function(geoRestriction) {
            let index = vmSettingsPnl.geoRestrictions.indexOf(geoRestriction);

            vmSettingsPnl.geoRestrictions.splice(index, 1);
        };

        vmSettingsPnl.getValidGeoRestrictions = function() {
            return _.filter(vmSettingsPnl.geoRestrictions, (geoRestriction) => {
                return geoRestriction.lat && geoRestriction.lng && geoRestriction.radiusInMeters;
            });
        };

        vmSettingsPnl.getNonEmptyGeoRestrictions = function() {
            return _.filter(vmSettingsPnl.geoRestrictions, (geoRestriction) => {
                let hasLatLng = geoRestriction.lat && geoRestriction.lng;

                return hasLatLng || geoRestriction.radiusInMeters;
            });
        };

        $scope.$on('sendLyftCredit', sendCredit);

        $scope.$watch('vmSettingsPnl.lyftCredit.repairOrder', (newVal) => {
            let creditType = vmSettingsPnl.lyftCredit.creditType;

            if (creditType && creditType.id === vmSettingsPnl.creditTypes.repairOrder && roSearchResults && newVal) {
                let ro = _.find(roSearchResults, {id: parseInt(newVal[0])});

                if (ro) {
                    vmSettingsPnl.lyftCredit.firstName = ro.customerFirstName;
                    vmSettingsPnl.lyftCredit.lastName = ro.customerLastName;
                    vmSettingsPnl.lyftCredit.phoneNumber = ro.customerPhone;
                    vmSettingsPnl.phoneChanged(ro.customerPhone);
                }
            }
        });

        vmSettingsPnl.phoneChanged = function(phoneNumber) { 
            parent_vm.checkPhoneType(phoneNumber).then((result) => {
                parent_vm.customerPhoneDetail = result;
                parent_vm.loadContact();
            });
        };

        vmSettingsPnl.addressSelected = function(geoRestriction, address) {
            let loc = address.location;

            geoRestriction.displayName = loc.formattedAddress;
            geoRestriction.lat = loc.lat;
            geoRestriction.lng = loc.lng;
        };

        vmSettingsPnl.startTimeChanged = function(timeRestriction) {
            $timeout(() => { revalidate('time_end_' + timeRestriction.dayOfWeek); }, 1);
        };

        vmSettingsPnl.toggleSimpleView = function () {
            vmSettingsPnl.simpleView = !vmSettingsPnl.simpleView;
            localStorageService.set('lyftCreditSimpleView', vmSettingsPnl.simpleView);
        };

        vmSettingsPnl.simpleTimeFrameChanged = function () {

            if (vmSettingsPnl.lyftCredit.simpleTimeframe !== 'custom') {
                vmSettingsPnl.lyftCredit.timeframe.startDate = today;
                let daysToInc = parseInt(vmSettingsPnl.lyftCredit.simpleTimeframe);

                vmSettingsPnl.lyftCredit.timeframe.endDate = today.clone().add(daysToInc, 'days');
            }

        };

        vmSettingsPnl.creditTypeChanged = function () {
            if (vmSettingsPnl.lyftCredit.creditType === undefined || vmSettingsPnl.lyftCredit.creditType.id === undefined) {
                return;
            } else if (vmSettingsPnl.lyftCredit.creditType.id !== vmSettingsPnl.creditTypes.repairOrder) {
                vmSettingsPnl.createNewRO = false;
                vmSettingsPnl.newRoNumber = null;
            }
        };

        function revalidate(elementName) {
            $scope.$broadcast('angularValidation.revalidate', elementName);
        }

        function sendCredit() {
            vmSettingsPnl.submitAttempted = true;

            let geoRestrictions = vmSettingsPnl.getValidGeoRestrictions();
                let geoRestrictionLength = geoRestrictions.length;

            if (vmSettingsPnl.lyftCredit.geoRestrictionType === vmSettingsPnl.geoRestrictionTypes.pickupOrDropoff && 
                geoRestrictionLength === 0) {
                return;
            }
            
            if (vmSettingsPnl.lyftCredit.geoRestrictionType === vmSettingsPnl.geoRestrictionTypes.pickupAndDropoff && 
                geoRestrictionLength < 2) {
                return;
            }

            parent_vm.sendingCredit = true;
            
            let lyftCredit = vmSettingsPnl.lyftCredit;
                let referenceNote = lyftCredit.creditType.id === vmSettingsPnl.creditTypes.repairOrder ? 
                                lyftCredit.repairOrder[0] : lyftCredit.referenceNote;
                let timeRestrictions = _.filter(vmSettingsPnl.timeRestrictionOptions, {checked: true});
                

            if (lyftCredit.creditType.id !== vmSettingsPnl.creditTypes.bulkUpload) {
                rideProviderService.sendCredit(parent_vm.theTrip.dealerLocation.id,
                                        lyftCredit.firstName,
                                        lyftCredit.lastName,
                                        lyftCredit.phoneNumber,
                                        lyftCredit.type,
                                        lyftCredit.timeframe.startDate.startOf('day').milliseconds(0),
                                        lyftCredit.timeframe.endDate.endOf('day').milliseconds(0),
                                        lyftCredit.creditAmount,
                                        lyftCredit.creditType.id,
                                        referenceNote,
                                        lyftCredit.liabilityPerRide,
                                        lyftCredit.flatFarePerRide,
                                        lyftCredit.discountRatio,
                                        lyftCredit.numRides,
                                        lyftCredit.geoRestrictionType,
                                        geoRestrictions,
                                        timeRestrictions,
                                        lyftCredit.customerId,
                                        lyftCredit.campaignId,
                                        lyftCredit.isTest,
                                        vmSettingsPnl.createNewRO,
                                        vmSettingsPnl.newRoNumber).then((result) => {
                                            parent_vm.sendingCredit = false;    
                                                toastr.success('Credit was successfully sent');
                                                $rootScope.$broadcast('LyftCreditService.changed', vmSettingsPnl.lyftCredit);
                                                $state.go('trip-list');
                                        }, (error) => {
                                                toastr.error('An error occurred while sending the credit, please try again.');
                                                parent_vm.sendingCredit = false;
                                        });
                } else { 
                    modalService.showYesNo('Are you sure?', `You are about to generate ${lyftCredit.batch.count} Lyft Benefits.  Are you sure you want to do this?`, 'Cancel', 'Confirm')
                        .then((result) => {
                            if (result) {
                                rideProviderService.sendCreditBatch(parent_vm.theTrip.dealerLocation.id,
                                    lyftCredit.type,
                                    lyftCredit.timeframe.startDate.startOf('day'),
                                    lyftCredit.timeframe.endDate.endOf('day'),
                                    lyftCredit.creditAmount,
                                    lyftCredit.creditType.id,
                                    referenceNote,
                                    lyftCredit.liabilityPerRide,
                                    lyftCredit.flatFarePerRide,
                                    lyftCredit.discountRatio,
                                    lyftCredit.numRides,
                                    lyftCredit.geoRestrictionType,
                                    geoRestrictions,
                                    timeRestrictions,
                                    lyftCredit.customerId,
                                    lyftCredit.campaignId,
                                    lyftCredit.creditType.id === vmSettingsPnl.creditTypes.bulkUpload ? lyftCredit.batch.riders : [],
                                    lyftCredit.isTest).then((result) => {
                                        parent_vm.sendingCredit = false;
                                        
                                        modalService.showYesNo('Benefits Submitted', `${lyftCredit.batch.count} Lyft Benefits have been submitted and will process in the background.  You can view the status on the campaign summary.`, null, 'OK')
                                            .then((response) => {
                                                $rootScope.$broadcast('LyftCreditService.changed', vmSettingsPnl.lyftCredit);
                                                $state.go('lyft-campaign-edit', {id: result.id});
                                            });

                                    }, (error) => {
                                            toastr.error('An error occurred while sending the credit, please try again.');
                                            parent_vm.sendingCredit = false;
                                    });
                            }
                        });
                }
            }
        }
})();

(function () {
    'use strict';

    LyftCampaignEditController.$inject = ["$scope", "$rootScope", "$state", "timeUtilService", "resolvedCampaign", "rideProviderService", "fileReaderService", "modalService", "signalRService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.trip')
        .controller('LyftCampaignEditController', LyftCampaignEditController);

    function LyftCampaignEditController($scope, $rootScope, $state, timeUtilService, resolvedCampaign, rideProviderService, fileReaderService, modalService, signalRService, SYSTEM_ENUMS) {
        var vm = this;

        vm.addParticipantType = 'single';

        vm.benefitTypes = SYSTEM_ENUMS.rideProviderBenefitTypes;
        vm.batchStatuses = SYSTEM_ENUMS.rideProviderBenefitBatchStatuses;

        vm.campaignBatchListener = null;

        initialize(resolvedCampaign);

        vm.campaignBatchListener =  signalRService.registerCampaignBatchListener(vm.campaign.id);
        listenForCampaignBatchUpdates();

        vm.participants = [{ firstName: '', lastName: '', phoneNumber: '' }];

        vm.daysOfWeek = timeUtilService.shortDays;    

        function initialize(campaign) {
            vm.campaign = campaign;

            vm.endTime = moment.utc(vm.campaign.endTime).local().format('MMM DD, YYYY');
            vm.originalEndTime = moment(vm.endTime);
    
            vm.originalDiscountAmount = vm.campaign.benefit.discountAmount;
            vm.originalNumRides = vm.campaign.benefit.numRides;
            vm.originalReferenceNote = vm.campaign.referenceNote;

            var now = moment().utc(),
                timeLeft = moment(vm.campaign.endTime).diff(now, 'seconds');
            vm.expired = timeLeft <= 0 ? true : false;

            vm.isEditable = !vm.expired && !vm.campaign.isTest && vm.campaign.batchStatus !== vm.batchStatuses.processing && !vm.campaign.isRevoked;
        }

        vm.validateDate = function () {
            var days = daysInTimeframe(vm.endTime);
            return { isValid: days <= 90 && days >= 0, message: '' };
        };

        vm.validateLaterDate = function() {
            var endTime = moment(vm.endTime);
            return { isValid: endTime.endOf('day').isSameOrAfter(vm.originalEndTime.endOf('day')), message: '' };
        };

        vm.validatePhone = function(fieldValue) {
            fieldValue = fieldValue ? fieldValue.replace(/\D/g,'') : '';
            return { isValid: fieldValue.length === 10, message: 'Phone is required.' };
        };

        function daysInTimeframe(endTime) {
            return  moment(endTime).diff(moment(vm.campaign.startTime), 'day');
        }

        vm.validateBatch = function(file) {
            
            vm.isValidatingBatch = true;
            
            vm.campaign.batch = {
                file: file,
                isValid: false,
                isUploaded: false
            };

            var reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function() {
                var base64FileData = reader.result;

                rideProviderService.uploadBatch(vm.campaign.benefit.dealerId,
                {
                    fileName: file.name,
                    base64FileData: base64FileData
                }).then(function(result) {
                    angular.extend(vm.campaign.batch, result);
                    vm.campaign.batch.isUploaded = true;
                }).catch(function(err) {
                    console.error(err);
                }).finally(function() {
                    vm.isValidatingBatch = false;
                });
            };
        };

        vm.getErrorLog = function() {
            rideProviderService.getCampaignErrors(vm.campaign.id)
                .then(function(result) {
                    var csvFile = result;
                    var filename = `${vm.campaign.customerId}-${vm.campaign.campaignId}_Errors.csv`;
                    fileReaderService.saveToDisk(csvFile, filename);
                });
        };

        vm.addParticipant = function() {
            var participant = {
                firstName: '',
                lastName: '',
                phoneNumber: ''
            };

            vm.participants.push(participant);
        };

        vm.removeParticipant = function(participant) {
            var index = vm.participants.indexOf(participant);

            vm.participants.splice(index, 1);
        };

        vm.isEmptyParticipant = function(participant) {
            return !participant.firstName && !participant.lastName && !participant.phoneNumber;
        };

        vm.hasParticipants = function() {
            var participants = vm.addParticipantType === 'single' ? vm.participants  : vm.campaign.batch ? vm.campaign.batch.riders : [];
            participants = participants || [];
            return participants.length > 0;
        };

        vm.canSubmit = function() {
            var isFileUpload = vm.addParticipantType === 'multiple',
                hasValidUpload = vm.campaign.batch && vm.campaign.batch.isUploaded && vm.campaign.batch.isValid;

            return $scope.LyftCampaignEditForm.$valid && ((vm.addParticipantType === 'single' && $scope.LyftCampaignAddParticipantForm.$valid) || (isFileUpload && hasValidUpload)) && 
                ($scope.LyftCampaignEditForm.$dirty || (vm.addParticipantType === 'single' && $scope.LyftCampaignAddParticipantForm.$dirty) || (isFileUpload && hasValidUpload));
        };

        vm.updateCampaign = function() {
            if (vm.canSubmit()) {
                if ($scope.LyftCampaignEditForm.$dirty) {
                    modalService.showBenefitBatchUpdateConfirm()
                        .then(function(result) {
                            submitCampaign(result);
                        });
                } else {
                    // No changes have been made to the benefit so mainly just
                    // adding particpants to the campaign
                    submitCampaign({ skipModified: false });
                }
            }
        };

        function submitCampaign(options) {
            var participants = vm.addParticipantType === 'single' ? vm.participants : vm.campaign.batch ? vm.campaign.batch.riders : [];

            rideProviderService.updateCampaign(vm.campaign.id, {
                numRides: vm.campaign.benefit.numRides,
                discountAmount: vm.campaign.benefit.discountAmount ? vm.campaign.benefit.discountAmount * 100 : null,
                startTime: moment(vm.campaign.startTime).startOf('day'),
                endTime: moment(vm.endTime).endOf('day'),
                referenceNote: vm.referenceNote,
                skipModified: options.skipModified,
                participants: _.filter(participants, function(participant) {
                    return !vm.isEmptyParticipant(participant);
                })
            }).then(function(response) {
                if (response && !response.error) {
                    vm.participants = [{ firstName: '', lastName: '', phoneNumber: ''}];
                    vm.campaign.batchStatus = vm.batchStatuses.processing;

                    initialize(vm.campaign);

                    modalService.showYesNo('', 'Changes to this campaign have been submitted and will process in the background.  You can view the status on the campaign summary.', null, 'OK')
                        .then(function(result) {
                            if (result) {
                                $rootScope.$broadcast('LyftCreditService.changed', vm.campaign);
                            }
                        });
                }
            });
        }

        vm.revokeCampaign = function() {
            modalService.showYesNo('Are you sure?', 'Are you sure you would like the revoke the benefits in this campaign?', 'No', 'Yes')
                .then(function(result) {
                    if (result) {
                        rideProviderService.revokeCampaign(this.campaign.id)
                            .then(function() {
                                $rootScope.$broadcast('LyftCreditService.changed', vm.campaign);
                                $state.go('trip-list');
                            });
                    }
                });
        };

        function listenForCampaignBatchUpdates() {
            vm.campaignBatchListener.on(signalRService.events.campaignBatch.broadcastCampaignBatchUpdate, function (message) {
                rideProviderService.getCampaign(message.campaignId)
                    .then(function(result) {
                        initialize(result);
                        $rootScope.$broadcast('LyftCreditService.changed', vm.campaign);
                    });
            }).start();
        }

        function unregisterSignalR() {
            if (vm.campaignBatchListener) {
                vm.campaignBatchListener.disconnect();
                vm.campaignBatchListener = null;
            }
        }


        $scope.$on('$destroy', function () {
            unregisterSignalR();
        });

        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });
    }
})();

(function () {
    'use strict';

    angular.module('redcap.profile', []);
})();
(function () {
    'use strict';

    profileService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi", "authService"];
    angular
        .module('redcap.profile')
        .factory('profileService', profileService);

    function profileService($q, $log, $filter, $http, $rootScope, rcApi, authService) {

        var USER_BASEPATH = 'users/';
        var _currentUser = null;

        return {
            clearCache: clearCache,
            getUser: getUser,
            updateUser: updateUser,
            changePassword: changePassword,
            checkPassword: checkPassword
        };

        function clearCache() {
            _currentUser = null;
        }

        function getUser() {

            var userName = authService.getCurrentUser().username;

            if (_currentUser && _currentUser.userName === userName) {
                return _currentUser;
            }

            return rcApi.post(USER_BASEPATH + "byname", { userName: userName })
                .then(function (response) {
                    _currentUser = response;
                    return _currentUser;
                });
        }

        function updateUser(updatedUser) {
            return rcApi.put(USER_BASEPATH + updatedUser.id, updatedUser)
                .then(function (response) {
                    if (response === true) {
                        clearCache(); // This will force the api to get the user again when getUser is called, because _currentUser will be null
                        $rootScope.$broadcast('ProfileService.changed', updatedUser);
                    }
                    return response;
                });
        }

        function changePassword(userId, currentPassword, newPassword) {
            return rcApi.post(USER_BASEPATH + 'changePassword', { userId: userId, currentPassword: currentPassword, newPassword: newPassword });
        }

        function checkPassword(password) {
            if (password && password.length > 0) {
                return rcApi.post(USER_BASEPATH + 'hasValidPassword', { value: password });
            } else {
                return false;
            }
        }

    }

})();

(function () {
    'use strict';

    ProfileController.$inject = ["profileService", "resolvedUser", "eventAlertService", "DASHBOARD_VERSION", "$rootScope"];
    angular
        .module('redcap.profile')
        .controller('ProfileController', ProfileController);

    function ProfileController(profileService, resolvedUser, eventAlertService, DASHBOARD_VERSION, $rootScope) {
        var vm = this;

        // Current dashboard version
        vm.dashVersion = DASHBOARD_VERSION;

        vm.currentUser = resolvedUser;
        vm.profilePic = {
            profileImageUpload: null,
            profileImage: null
        };

        vm.updateUser = function () {
            if (vm.profilePic.profileImageUpload) {
                vm.currentUser.profilePicture = vm.profilePic.profileImageUpload;
            } else {
                vm.currentUser.profilePicture = null;
            }


            profileService.updateUser(vm.currentUser).then(function (response) {
                eventAlertService.createAlert('Profile Successfully Updated.');
                
                if (vm.currentUser.profilePicture) {
                    $rootScope.$broadcast('user-profile-picture-updated');
                }
            });
        };
    }
})();

(function () {
    'use strict';

   ChangePasswordController.$inject = ["$log", "$rootScope", "$scope", "$filter", "SYSTEM_ENUMS", "$timeout", "$state", "userService", "resolvedUser", "configId", "isForced", "toastr"];
    angular
        .module('redcap.profile')
        .controller('ChangePasswordController', ChangePasswordController);

    function ChangePasswordController($log, $rootScope, $scope, $filter, SYSTEM_ENUMS, $timeout, $state, userService, resolvedUser, configId, isForced, toastr) {
        let vm = this;

        vm.currentUser = resolvedUser;
        vm.currentPassword = "";
        vm.newPassword = "";
        vm.confirmPassword = "";
        vm.incorrectPwdSupplied = false;
        vm.solidMigrationStatus = SYSTEM_ENUMS.solidMigrationStatus;
        vm.isSolidUser = resolvedUser.solidUserId != null && resolvedUser.lastSolidLoginDate != null;  

        vm.passwordRemoteValidation = function (password) {
            return userService.checkPassword(password);
        };

        vm.changePassword = function () {
            vm.incorrectPwdSupplied = false;
            userService.changePassword(vm.currentUser.id, vm.currentPassword, vm.newPassword).then((response) => {
                $scope.$broadcast('event-alert', {message: 'User Password Successfully Changed.'});

                if (isForced) 
                    $scope.$broadcast('event-alert', {message: 'Redirecting to login...'});
                else
                    $scope.$broadcast('event-alert', {message: 'Password changed. Please log back in using the new password. '});

                $timeout(() => {
                    $state.go('login', {configId: configId});
                }, 2000);
            }, (errorMessage) => {
                if (errorMessage.data && errorMessage.data && errorMessage.data.exceptionMessage && errorMessage.data.exceptionMessage.toLowerCase().indexOf("incorrect password") > -1) {
                    vm.incorrectPwdSupplied = true;
                } else {
                    vm.incorrectPwdSupplied = false;
                    toastr.error(errorMessage);
                }
            });
        };

        vm.updatePassword = function () {
            vm.sendingPasswordResetEmail = true;

            userService.emailResetPasswordSolid(vm.currentUser.userName).then((result) => {
                $scope.$broadcast('event-alert', {message: 'User Password Successfully Changed.'});
            }).catch((err) => {
                $scope.$broadcast('event-alert', {message: 'An error occurred please try again.'});
            }).finally(() => {
                vm.sendingPasswordResetEmail = false;
            });
        };
   }
})();

(function () {
    'use strict';

    angular.module('redcap.support', []);
})();
(function () {
    'use strict';

supportService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi", "authService"];
    angular
        .module('redcap.support')
        .factory('supportService', supportService);

    function supportService($q, $log, $filter, $http, $rootScope, rcApi, authService) {

        var SUPPORT_BASEPATH = 'support/',
            _currentUser = null;

        return {
            clearCache: clearCache,
            submitDriverHelpTicket: submitDriverHelpTicket,
            submitSoftwareHelpTicket: submitSoftwareHelpTicket,
            getSupportTrainingConfigs: getSupportTrainingConfigs,
            getSupportTrainingConfig: getSupportTrainingConfig,
            marketingInquiry: marketingInquiry,
            updateHoursOfOperation: updateHoursOfOperation
        };

        function clearCache() {
            _currentUser = null;
        }

        function submitDriverHelpTicket(issueType, issueDescription) {            
            var model = {
                Type: issueType,
                Issue: issueDescription
            };        
            return rcApi.post(SUPPORT_BASEPATH + 'driverHelpTicket', model);
        }


        function submitSoftwareHelpTicket(issueType, issueDescription) {            
            var model = {
                Type: issueType,
                Issue: issueDescription
            };        
            return rcApi.post(SUPPORT_BASEPATH + 'softwareHelpTicket', model);
        }

        function marketingInquiry(ticket) {
            return rcApi.post(SUPPORT_BASEPATH + 'marketingInquiry', ticket);
        }
      
        function getSupportTrainingConfigs() {
            return rcApi.get(SUPPORT_BASEPATH + 'supportTrainingConfigs');
        }

        function getSupportTrainingConfig(configId) {
            return rcApi.get(SUPPORT_BASEPATH + 'supportTrainingConfig?configId=' + configId);
        }

        function updateHoursOfOperation(hoursOfOperation) {
            return rcApi.post(SUPPORT_BASEPATH + 'UpdateSupportTrainingConfigHours?hoursOfOperation=' + encodeURIComponent(hoursOfOperation));
        }
}

})();

(function () {
    'use strict';

   TutorialListController.$inject = ["$state", "$transition$", "$filter", "modalService", "resolvedSupportTrainingConfigs", "resolvedSupportTrainingConfig", "resolvedTutorials", "permissions", "$aside", "supportService"];
    angular
        .module('redcap.support')
        .controller('TutorialListController', TutorialListController);

    function TutorialListController($state, $transition$, $filter, modalService, resolvedSupportTrainingConfigs, resolvedSupportTrainingConfig, resolvedTutorials, permissions, $aside, supportService) {
        let vm = this;

        vm.tutorialTypes = {
            0: 'Video',
            1: 'PDF',
            2: 'Power Point',
            3: 'Image(s)',
            9: 'Other'
        };

        vm.busy = false;
        vm.selectedProduct = $transition$.params().product;
        vm.allSupportTutorialConfigs = resolvedSupportTrainingConfigs;
        vm.resolvedTutorials = resolvedTutorials;
        vm.config = resolvedSupportTrainingConfig;
        vm.isSystemAdmin = permissions.isSysAdmin();
        vm.selectedDropDownConfig = $filter('filter')(vm.allSupportTutorialConfigs, {id: vm.config.id}, true)[0];

        _.forEach(vm.allSupportTutorialConfigs, (config) => {
            if (!config.requiredPermission || config.requiredPermission && permissions.hasPermission(config.requiredPermission.name)) {
                config.hasAccess = true;
            } else {
                config.hasAccess = false;
            }
        });

        vm.accessibleProducts = $filter('filter')(vm.allSupportTutorialConfigs, {hasAccess: true});

        vm.selectedConfigChanged = function () {
            $state.go('tutorial-list', {productId: vm.selectedDropDownConfig.id}, {reload: true});
        };

        vm.getTypeLabel = function (type) {
            return vm.tutorialTypes[type];
        };

        vm.getMinutesSeconds = function (milliseconds) {
            let minutes = Math.floor(milliseconds / 60000);
            let seconds = (milliseconds % 60000 / 1000).toFixed(0);
            
            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        };


        vm.showTutorial = function (tutorial) {
            if (tutorial.trainingType === 0 || tutorial.trainingType === 3) {
                modalService.showTutorial(tutorial, true);
            } else {
                window.open(tutorial.thumbnailPath,
                 "_trainingMaterial",
                 "toolbar=0, menubar=0, titlebar=0, status=0, location=0, scrollbars=1, resizable=yes");
            }
        };

        vm.openHoursOfOperation = function () {
            let options = {
                templateUrl: 'app/areas/support/views/modals/hours-of-operation.view.html',
                container: 'body',
                placement: 'bottom',
                animation: false,
                backdrop: 'static',
                show: false,
                html: true,
                keyboard: false,
                size: 'lg',
                controller: 'HoursOfOperationController as vm',
                windowClass: 'has-fixed-footer aside-centered aside-sm',
                resolve: {
                    resolvedHoursOfOperation: function () { return vm.config.hoursOfOperation; }
                }
            };

            let aside = $aside.open(options);
            aside.result.then(() => {
                supportService.getSupportTrainingConfig(vm.config.id).then(function (updatedConfig) {
                    vm.config = updatedConfig;
                });
            });
        };
   }
})();

(function () {
    'use strict';

   SoftwareHelpController.$inject = ["$log", "$rootScope", "$scope", "$filter", "$timeout", "$state", "supportService", "resolvedTicketType", "resolvedPreviousPage", "toastr", "ValidationService"];
    angular
        .module('redcap.support')
        .controller('SoftwareHelpController', SoftwareHelpController);

    function SoftwareHelpController($log, $rootScope, $scope, $filter, $timeout, $state, supportService, resolvedTicketType, resolvedPreviousPage, toastr, ValidationService) {
        let vm = this;

        vm.sentSuccessfully = false;
        vm.submitTicket = true;
        vm.previousPage = resolvedPreviousPage || "";
        vm.helpTicket = {
            type: resolvedTicketType || null,
            description: null
        };

        vm.issueTypes = [
                        "GETTING AN ERROR MESSAGE",
                        "QUESTION ABOUT HOW TO USE THE SYSTEM",
                        "HAVE MY SERVICE SUITE ACCOUNT REPRESENTATIVE CONTACT ME",
                        "REQUEST VEHICLE PICTURES",
                        "BILLING SUPPORT",
                        "ADD USER",
                        "ADD DRIVER"
                        ];

        vm.submitTicket = function (isValid) {
            if (new ValidationService().checkFormValidity($scope.submitHelpTicket)) {
                vm.submittingHelpTicket = true;
                supportService.submitSoftwareHelpTicket(vm.helpTicket.type, vm.helpTicket.description).then((response) => {
                    vm.submittingHelpTicket = false;
                    vm.sentSuccessfully = true;
                }, (errorResponse) => {
                    toastr.error("An error has occurred submitting your help ticket.");
                    vm.submittingHelpTicket = false;
                });
            }
        };

        vm.getDescription = function () {
            let type = vm.helpTicket.type;

            if (type !== "ADD USER" && type !== "ADD DRIVER") {
                return "ISSUE DESCRIPTION";
            } else if (type !== "ADD DRIVER") {
                return "PROVIDE: FIRST AND LAST NAME, EMAIL ADDRESS, MOBILE AND OFFICE NUMBER, BUSINESS TITLE, DEALERSHIP NAME";
            } else {
                return "PROVIDE: FIRST AND LAST NAME, EMAIL ADDRESS, AND CELL PHONE NUMBER";
            }
        };
     
   }
})();

(function () {
    'use strict';

    HoursOfOperationController.$inject = ["resolvedHoursOfOperation", "supportService", "$uibModalInstance"];
    angular
        .module('redcap.support')
        .controller('HoursOfOperationController', HoursOfOperationController);

    function HoursOfOperationController(resolvedHoursOfOperation, supportService, $uibModalInstance) {
        let vm = this;

        vm.hoursOfOperation = resolvedHoursOfOperation || '';

        vm.saveHoursOfOperation = (valid) => {
            if (valid) {
                supportService.updateHoursOfOperation(vm.hoursOfOperation).then(function () {
                    vm.closeHoursOfOperation();
                });
            }
        };

        vm.closeHoursOfOperation = function () {
            $uibModalInstance.close();
        };
    }
})();
(function () {
    'use strict';

   DriverHelpController.$inject = ["$log", "$rootScope", "$scope", "$filter", "$timeout", "$state", "supportService", "toastr", "ValidationService"];
    angular
        .module('redcap.support')
        .controller('DriverHelpController', DriverHelpController);

    function DriverHelpController($log, $rootScope, $scope, $filter, $timeout,$state, supportService, toastr, ValidationService) {
        var vm = this;
        vm.sentSuccessfully = false;
        vm.submitTicket = true;
        vm.helpTicket = {
            type: null,
            description: null
        };
        
        vm.issueTypes = [
                        "COMPLAINT ABOUT DRIVER",
                        "DAMAGE CLAIM",
                        "QUESTION ABOUT DRIVER NETWORK SERVICES"
                        ];

        vm.submitTicket = function (isValid) {
            if(new ValidationService().checkFormValidity($scope.submitHelpTicket)) {
                vm.submittingHelpTicket = true;
                supportService.submitDriverHelpTicket(vm.helpTicket.type, vm.helpTicket.description).then(function(response) {
                    vm.submittingHelpTicket = false;
                    vm.sentSuccessfully = true;
                }, function(errorResponse) {
                    toastr.error("An error has occurred submitting your help ticket.");
                    vm.submittingHelpTicket = false;
                });
            }
        };
     
   }
})();
(function () {
    'use strict';

    angular.module('redcap.reports', []);
})();
(function () {
    "use strict";

    reportService.$inject = ["SYSTEM_ENUMS", "rcApi"];
    angular
        .module("redcap.reports")
        .factory("reportService", reportService);

    function reportService(SYSTEM_ENUMS, rcApi) {

        var REPORTS_BASEPATH = "reports/",
            currentTokens = {};

        return {
            getToken: getToken,
            getList: getList,
            getReport: getReport,
            addReport: addReport,
            editReport: editReport,
            deleteReport: deleteReport,
            getUnaddedReports: getUnaddedReports,
            getPermissions: getPermissions,
            getPrograms: getPrograms,
            getReportPermissionLevels: getReportPermissionLevels
        };

        function getList() {
            return rcApi.get(REPORTS_BASEPATH + 'list');
        }

        function getToken(reportId) {
            return rcApi.get(REPORTS_BASEPATH + 'token/' + reportId)
                .then(function (response) {
                    currentTokens[reportId] = response;
                    return currentTokens[reportId];
                });
        }

        function getPrograms() {
            return rcApi.get(REPORTS_BASEPATH + 'programs');
        }

        function addReport(reportId, reportName, role, sortOrder, hideFilters, reportType, url, multipointReportId, permissions, programs) {
            return rcApi.post(REPORTS_BASEPATH,
                {
                    id: reportId,
                    name: reportName,
                    role: role,
                    sortOrder: sortOrder,
                    hideFilters: hideFilters || false,
                    reportType: reportType,
                    url: url,
                    multipointReportId: multipointReportId,
                    permissions: permissions || [],
                    programs: programs || []
                });
        }

        function getReport(reportId) {
            return rcApi.get(REPORTS_BASEPATH + reportId);
        }

        function editReport(reportId, reportName, role, sortOrder, hideFilters, isActive, url, multipointReportId, permissions, programs) {
            return rcApi.post(REPORTS_BASEPATH + reportId,
                {
                    name: reportName,
                    role: role,
                    sortOrder: sortOrder,
                    hideFilters: hideFilters,
                    isActive: isActive,
                    url: url,
                    multipointReportId: multipointReportId,
                    permissions: permissions || [],
                    programs: programs || []
                });
        }

        function deleteReport(reportId) {
            return rcApi.post(REPORTS_BASEPATH + reportId + "/delete");
        }

        function getUnaddedReports() {
            return rcApi.get(REPORTS_BASEPATH + 'getNewReports');
        }

        function getPermissions() {
            return rcApi.get(REPORTS_BASEPATH + 'permissions');
        }

        function getReportPermissionLevels () {
            return [
                {
                    text: "System Admin",
                    value: SYSTEM_ENUMS.reportRoles.systemAdmin
                }, {
                    text: "Program Admin",
                    value: SYSTEM_ENUMS.reportRoles.programAdmin
                }, {
                    text: "Everyone",
                    value: SYSTEM_ENUMS.reportRoles.everyone
                }
            ];
        }
    }

})();

(function () {
    'use strict';

    ReportListController.$inject = ["$filter", "reportList", "appointmentLocationList", "reportService", "$rootScope", "$scope", "$interval", "SYSTEM_ENUMS", "appointmentService", "AUTOPOINT_PRODUCT_TYPE", "localStorageService"];
    angular
        .module('redcap.reports')
        .controller('ReportListController', ReportListController);

    function ReportListController($filter, reportList, appointmentLocationList, reportService, $rootScope, $scope, $interval, SYSTEM_ENUMS, appointmentService, AUTOPOINT_PRODUCT_TYPE, localStorageService) {
        var vm = this, 
            intervalCheck = null,
            hasReports = reportList && reportList.length,
            lastSelectedReport = localStorageService.get('lastSelectedReport') || null,
            lastSelectedDealer = localStorageService.get('lastSelectedDealer') || null,
            validSSODealers =  _.filter(appointmentLocationList, function(d) { return d.multiPointDealerId !== null; });

        vm.apptDealer = null;
        vm.reports = reportList;

        vm.appointmentLocationList = validSSODealers;
        vm.selectedReport = hasReports && (lastSelectedReport || vm.reports[0].id);

        vm.reportMapping = {};
        vm.sysEnums = SYSTEM_ENUMS;

        _.each(reportList, function(item) {
          vm.reportMapping[item.id] = item;
        });

      var reportContainer = $('#report-container');

        vm.getLastUpdatedDate = function() {
            var item = vm.report;
            if (item) {
                return moment.utc(item.lastUpdated).local().format("M/DD/YYYY h:mm a");
            }
        };

        vm.reportSelected = function () {
            if (!vm.selectedReport) return;
            localStorageService.set('lastSelectedReport', vm.selectedReport);
           
            vm.reportObject = vm.reportMapping[vm.selectedReport];
            if (!vm.reportObject) return;
            reportContainer.empty();
            vm.showPowerBIButtons = false;
            if (vm.reportObject.reportType === SYSTEM_ENUMS.reportTypes.powerBI) {
                vm.apptDealer = null;
                localStorageService.set('lastSelectedDealer', null);
                vm.showPowerBIButtons = true;
                reportService.getToken(vm.selectedReport).then(function(report) {
                    vm.report = report;
                    var models = window['powerbi-client'].models,
                        // We give All permissions to demonstrate switching between View and Edit mode and saving report.
                        permissions = models.Permissions.All,
                        config = {
                            type: 'report',
                            tokenType: models.TokenType.Embed,
                            accessToken: vm.report.token,
                            embedUrl: vm.report.embedUrl,
                            id: vm.report.reportId,
                            permissions: permissions,
                            settings: {
                                filterPaneEnabled: !report.hideFilters,
                                navContentPaneEnabled: true,
                                background: models.BackgroundType.Transparent
                            }
                        };

                    powerbi.reset(reportContainer[0]);
                    powerbi.embed(reportContainer[0], config);
                    setIframeHeight();
                });
            } 
            else if (vm.reportObject.reportType === SYSTEM_ENUMS.reportTypes.fabricServiceSuite) {
                vm.apptDealer = null;
                localStorageService.set('lastSelectedDealer', null);
                vm.showPowerBIButtons = true;
                reportService.getToken(vm.selectedReport).then(function(report) {
                    vm.report = report;
                    var models = window['fabricServiceSuite-client'].models,
                        // We give All permissions to demonstrate switching between View and Edit mode and saving report.
                        permissions = models.Permissions.All,
                        config = {
                            type: 'report',
                            tokenType: models.TokenType.Embed,
                            accessToken: vm.report.token,
                            embedUrl: vm.report.embedUrl,
                            id: vm.report.reportId,
                            permissions: permissions,
                            settings: {
                                filterPaneEnabled: !report.hideFilters,
                                navContentPaneEnabled: true,
                                background: models.BackgroundType.Transparent
                            }
                        };

                    powerbi.reset(reportContainer[0]);
                    powerbi.embed(reportContainer[0], config);
                    setIframeHeight();
                });
            }
            else if (vm.reportObject.reportType === SYSTEM_ENUMS.reportTypes.externalLink) {
                vm.apptDealer = null;
                localStorageService.set('lastSelectedDealer', null);
                var iFrame = document.createElement('iframe');
                iFrame.setAttribute('src', vm.reportObject.url);
                reportContainer[0].appendChild(iFrame);
            } else if (vm.reportObject.reportType === SYSTEM_ENUMS.reportTypes.autopointSSO && vm.apptDealer && vm.apptDealer.id) {
                vm.appointmentLocationSelected();
            }
        };

        vm.appointmentLocationSelected = function () {
            localStorageService.set('lastSelectedDealer', vm.apptDealer.id);
            appointmentService.getSsoUrl(vm.apptDealer.id, AUTOPOINT_PRODUCT_TYPE.checkinandinspectreport).then(function (result) {
                if (result) {
                    result += "&reportId=" + vm.reportObject.multipointReportId;
                    console.log(result);
                    // first clear out anything in the element
                    reportContainer[0].replaceChildren();
                    var iFrame = document.createElement('iframe');
                    iFrame.setAttribute('src', result);
                    reportContainer[0].appendChild(iFrame);
                } else {
                    vm.errorLoadingURL = true;
                }
            },
            function (error) {
                vm.errorLoadingURL = false;
            });
        };

        vm.fullScreen = function() {
            powerbi.get(reportContainer[0]).fullscreen();
        };

        vm.printReport = function () {
            powerbi.get(reportContainer[0]).print();
        };

        var setIframeHeight = function() {
            var container = angular.element('#report-wrapper'),
                containerHeight = container.height();
            reportContainer.height(containerHeight);
        };

        intervalCheck = $interval(setIframeHeight, 500, false);
        $scope.$on('destroy', function () {
            if (angular.isDefined(intervalCheck)) {
                 $interval.cancel(intervalCheck);
            }
        });

        if (hasReports) {
            vm.reportSelected();
        }

        if (!$rootScope.$$listenerCount['reload-reports']) {
            $rootScope.$on('reload-reports', function (evt, shouldResetToFirstItem) {
                reportService.getList().then(function(items) {
                    vm.reports = items;
                    if (shouldResetToFirstItem && vm.reports && vm.reports.length) {
                        vm.selectedReport = vm.reports[0].id;
                        vm.reportSelected();
                    }
                });
            });
        }
        
        if (vm.selectedReport && lastSelectedDealer) {
            vm.apptDealer = $filter('filter')(vm.appointmentLocationList, { id: lastSelectedDealer }, true)[0];
            vm.appointmentLocationSelected();
        }

    }
})();

(function () {
    'use strict';

    ReportEditController.$inject = ["resolvedReport", "reportService", "modalService", "ValidationService", "$scope", "$state", "SYSTEM_ENUMS", "resolvedPermissions", "resolvedPrograms"];
    angular
        .module('redcap.reports')
        .controller('ReportEditController', ReportEditController);

    function ReportEditController(resolvedReport, reportService, modalService, ValidationService, $scope, $state, SYSTEM_ENUMS, resolvedPermissions, resolvedPrograms) {
        var vm = this;

        vm.report = resolvedReport;
        vm.reportTypes = SYSTEM_ENUMS.reportTypes;
        vm.report.lastUpdated = moment.utc(vm.report.lastUpdated).local().format('MM-DD-YYYY HH:mm:ss');
        vm.numberOfReports = new Array(resolvedReport.reportsCount);
        vm.rolePermissions = resolvedPermissions;
        vm.programs = resolvedPrograms;
        vm.reportRoles = SYSTEM_ENUMS.reportRoles;
        var selectedPermissions = vm.report.permissions;
        vm.report.rolePermissions = resolvedPermissions.filter(function (item) {
            return selectedPermissions.some(function(permission) {
                return permission === item.id;
            });
        });

        vm.save = function () {
            if (new ValidationService().checkFormValidity($scope.reportForm)) {
                var permissions = vm.report.rolePermissions.map(function (item) {
                        return item.id;
                    }),
                    programs = [];
                if (vm.report && vm.report.programs) {
                    programs = vm.report.programs.map(function (item) {
                        return item.id;
                    });
                }
               
                reportService.editReport(vm.report.id,
                        vm.report.name,
                        vm.report.role,
                        vm.report.sortOrder,
                        vm.report.hideFilters,
                        vm.report.isActive,
                        vm.report.url,
                        vm.report.multipointReportId,
                        permissions,
                        programs)
                    .then(function() {
                        $scope.$emit('reload-reports');
                        $state.go('report-list');
                    });
            }
        };

        vm.permissionLevels = reportService.getReportPermissionLevels();

        vm.sortOrders = [];

        for (var i = 1; i <= resolvedReport.reportsCount; i++) {
            vm.sortOrders.push({
                text: i,
                value: i
            });
        }

        vm.promptDelete = function() {
            modalService.showYesNo("Are you sure?", "Are you sure you want to remove this report?", "No", "Yes", false)
                .then(function(result) {
                    if (result) {
                        reportService.deleteReport(vm.report.id).then(function() {
                            $scope.$emit('reload-reports', true);
                            $state.go('report-list');
                        });
                    }
                });
        };
    }
})();

(function () {
    'use strict';

    ReportAddController.$inject = ["resolvedReports", "reportService", "$scope", "ValidationService", "$state", "SYSTEM_ENUMS", "resolvedPermissions", "resolvedPrograms"];
    angular
        .module('redcap.reports')
        .controller('ReportAddController', ReportAddController);

    function ReportAddController(resolvedReports, reportService, $scope, ValidationService, $state, SYSTEM_ENUMS, resolvedPermissions, resolvedPrograms) {
        var vm = this;
        vm.reports = resolvedReports.reports;
        vm.numberOfReports = new Array(resolvedReports.reportsCount + 1);
        vm.rolePermissions = resolvedPermissions;
        vm.programs = resolvedPrograms;

        vm.addReport = function () {
            vm.reportRolePermissions = vm.reportRolePermissions || [];
            var permissions = vm.reportRolePermissions.map(function(item) {
                    return item.id;
                }),
                programs = [];

            if (vm.report && vm.report.programs) {
                programs = vm.report.programs.map(function(item) {
                    return item.id;
                });
            }

            if (new ValidationService().checkFormValidity($scope.reportForm)) {
                reportService.addReport(vm.pbiReport, vm.displayName, vm.role, vm.sortOrder, vm.hideFilters, vm.reportType, vm.url, vm.multipointReportId, permissions, programs).then(function() {
                    $scope.$emit('reload-reports');
                    $state.go('report-list');
                }); 
            }
        };
        vm.reportRoles = SYSTEM_ENUMS.reportRoles;
        vm.reportTypeEnum = SYSTEM_ENUMS.reportTypes;

        vm.reportTypes = [
            {
                id: SYSTEM_ENUMS.reportTypes.powerBI,
                text: 'Power BI'
            }, 
            {
                id: SYSTEM_ENUMS.reportTypes.externalLink,
                text: 'External Link'
            }, 
            {
                id: SYSTEM_ENUMS.reportTypes.autopointSSO,
                text: 'MP2 Report'
            },
            {
                id: SYSTEM_ENUMS.reportTypes.fabricServiceSuite,
                text: 'Fabric Service Suite'
            }
        ];

        vm.permissionLevels = reportService.getReportPermissionLevels();

        vm.reportType = SYSTEM_ENUMS.reportTypes.powerBI;

    }
})();

(function () {
    'use strict';

    vehicleService.$inject = ["$q", "rcApi"];
    angular
        .module('redcap.appointment')
        .factory('vehicleService', vehicleService);

    function vehicleService($q, rcApi) {

        let _currentRecommendedMaintenance = {
            vin: null,
            year: null,
            make: null,
            model: null,
            odometer: null,
            isMiles: null,
            results: null
        };

        return {
            decodeVin: decodeVin,
            getRecommendedMaintenance: getRecommendedMaintenance,
            getRecalls: getRecalls,
            getVehicles: getVehicles,
            getVehicle: getVehicle,
            getYears: getYears,
            getMakes: getMakes,
            getMakesInYear: getMakesInYear,
            getModels: getModels,
            getSubModels: getSubModels,
            isOwnedByOtherCustomer: isOwnedByOtherCustomer,
            getVehicleRoHistory: getVehicleRoHistory,
            getVehicleRoDetails: getVehicleRoDetails,
            getColors: getColors
        };

        function getBasePath(locationId) {
            return 'dealer/' + locationId + '/vehicle/';
        }

        function getVehicles(locationId) {
            return rcApi.get(getBasePath(locationId));
        }

        function getColors(locationId) {
            return rcApi.get(getBasePath(locationId) + 'color');
        }

        function getYears(locationId) {
            return rcApi.get(getBasePath(locationId) + 'year');
        }

        function getMakes(locationId) {
            return rcApi.get(getBasePath(locationId) + 'make');
        }

        function getMakesInYear(locationId, year) {
            return rcApi.get(getBasePath(locationId) + 'year/' + year);
        }

        function getModels(locationId, year, make) {
            return rcApi.get(getBasePath(locationId) + 'make',
                {
                    year: year,
                    make: make
                });
        }

        function getSubModels(locationId, year, make, model) {
            return rcApi.get(getBasePath(locationId) + 'submodel',
                {
                    year: year,
                    make: make,
                    model: model,
                });
        }

        function getVehicle(locationId, vin) {
            return rcApi.get(getBasePath(locationId) + 'vin/' + vin, null, null, null, true).catch(() => null);
        }

        function getRecommendedMaintenance(locationId, vin, year, make, model, odometer, isMiles, defaultDispatchCode) {
            let d = $q.defer();

            if (_currentRecommendedMaintenance && _currentRecommendedMaintenance.result !== null 
                && _currentRecommendedMaintenance.vin === vin && _currentRecommendedMaintenance.year === year 
                && _currentRecommendedMaintenance.model === model && _currentRecommendedMaintenance.vin === vin 
                && _currentRecommendedMaintenance.odometer === odometer && _currentRecommendedMaintenance.isMiles === isMiles) {
                d.resolve(_.cloneDeep(_currentRecommendedMaintenance.results));
            } else {
                if (vin) {
                    rcApi.get(getBasePath(locationId) +  'maintenance/vin/' + vin + '/odometer/' + odometer, {isMiles: isMiles}, null, null, true)
                        .then((result) => {
                            if (result && result.maintenanceIntervals) {
                                result.maintenanceIntervals.forEach(recMaint => {
                                    recMaint.retailPrice = 0;
                                    recMaint.laborHours = 0;
                                    recMaint.payType = 'C';
                                    recMaint.dispatchCode = defaultDispatchCode;
                                });

                                _currentRecommendedMaintenance.vin = vin;
                                _currentRecommendedMaintenance.year = year;
                                _currentRecommendedMaintenance.make = make;
                                _currentRecommendedMaintenance.model = model;
                                _currentRecommendedMaintenance.odometer = odometer;
                                _currentRecommendedMaintenance.isMiles = isMiles;
                                _currentRecommendedMaintenance.results = result;
                            }

                            d.resolve(_.cloneDeep(_currentRecommendedMaintenance.results));
                        }, (error) => {
                            d.reject(null);
                        }
                    );
                } else {
                    rcApi.get(getBasePath(locationId) + 'maintenance', {
                        year: year,
                        make: make,
                        model: model,
                        odometer: odometer,
                        isMiles: isMiles
                    }, null, null, true)
                        .then((result) => {
                            if (result && result.maintenanceIntervals) {
                                result.maintenanceIntervals.forEach(recMaint => {
                                    recMaint.retailPrice = 0;
                                    recMaint.laborHours = 0;
                                    recMaint.payType = 'C';
                                    recMaint.dispatchCode = defaultDispatchCode;
                                });
                                
                                _currentRecommendedMaintenance.vin = vin;
                                _currentRecommendedMaintenance.year = year;
                                _currentRecommendedMaintenance.make = make;
                                _currentRecommendedMaintenance.model = model;
                                _currentRecommendedMaintenance.odometer = odometer;
                                _currentRecommendedMaintenance.isMiles = isMiles;
                                _currentRecommendedMaintenance.results = result;
                            }

                            d.resolve(_.cloneDeep(_currentRecommendedMaintenance.results));
                        }, (error) => {
                            d.reject(null);
                        }
                    );
                }
            }

            return d.promise;
        }

        function getRecalls (locationId, vin) {
            if (vin) {
                return rcApi.get(getBasePath(locationId) +  'recall/vin/' + vin, null, null, null, true, true);
            } else {
                return Promise.resolve([]);
            }    
        }

        function decodeVin(locationId, vin) {
            return rcApi.get(getBasePath(locationId) + 'vin/' + vin, null, null, null, true);
        }
       
        function isOwnedByOtherCustomer(locationId, vin, dmsCustomerNumber) {
            let strPath = getBasePath(locationId) + 'ownedbyothercustomer?vin=' + vin;

            if (dmsCustomerNumber !== "") {
                strPath += '&dmsCustomerNumber=' + dmsCustomerNumber;
            }

            return rcApi.get(strPath);
        }

        function getVehicleRoHistory(locationId, vin) {
            return rcApi.get(getBasePath(locationId) + 'ro-history/' + vin);
        }

        function getVehicleRoDetails(locationId, vin, roNumber) {
            return rcApi.get(getBasePath(locationId) + 'ro-history/' + vin + '/detail/' + roNumber);
        }
    }
})();

(function () {
    'use strict';

    settingsService.$inject = ["rcApi"];
    angular
        .module('redcap.appointment')
        .factory('settingsService', settingsService);

    function settingsService(rcApi) {
        
        return {
            getAppointmentStatuses: getAppointmentStatuses,
            getMobileGarageMarketingContent: getMobileGarageMarketingContent
        };

        function getAppointmentStatuses() {
           return rcApi.get('appointment/settings/appointment-statuses', null, null, null, null, true);
        }

        function getMobileGarageMarketingContent() {
           return rcApi.get('appointment/settings/getMobileGarageMarketing', null, null, null, null, true);
        }
    }
})();

(function () {
    'use strict';

    customerService.$inject = ["rcApi"];
    angular
        .module('redcap.appointment')
        .factory('customerService', customerService);

    function customerService(rcApi) {

        var CUSTOMER_BASEPATH = 'dealer/';
      
        return {
            searchCustomersFromDms: searchCustomersFromDms,
            getCustomersByDMSCustNo: getCustomersByDMSCustNo,
            checkDuplicateCustomer: checkDuplicateCustomer
        };

        function searchCustomersFromDms(dealerId, searchText) {
            return rcApi.get(CUSTOMER_BASEPATH + dealerId + '/customers/search?searchText=' + searchText);
        }

        function getCustomersByDMSCustNo(dealerId, custNo) {
            return rcApi.get(CUSTOMER_BASEPATH + dealerId + '/customer/'+ custNo + '?includeVehicles=true');
        }

        function checkDuplicateCustomer(dealerId, email, phone) {
            return rcApi.post(CUSTOMER_BASEPATH + dealerId + '/appointment/customers/search', { customerEmail: email, customerPhone: phone });
        }
    }
})();


(function () {
    'use strict';

    authorizationService.$inject = ["rcApi", "SYSTEM_ENUMS", "bookingService"];
    angular
        .module('redcap.appointment')
        .factory('authorizationService', authorizationService);

    function authorizationService(rcApi, SYSTEM_ENUMS, bookingService) {
        let LOCATION_BASEPATH = 'dealers/';

        return {
            sendBookLaterSms: sendBookLaterSms,
            getAppointmentRideShareCredit: getAppointmentRideShareCredit
        };

        function getBaseRoute(dealerId, appointmentId) {
            return 'dealer/' + dealerId + '/appointment/' + appointmentId + '/authorization/';
        }

        function sendBookLaterSms(appt, smsNumber) {
            let dealerId = appt.dealerId;

            return getAdvisor(dealerId, appt.id).then((advisor) => {
                let bindingModel = {
                    type: 1,    // 1 = sms
                    serviceAdvisorId: advisor.id,
                    roNumber: appt.dealerServiceOrder ? appt.dealerServiceOrder.roNumber : null,
                    firstName: appt.customerFirstName,
                    lastName: appt.customerLastName,
                    phone: smsNumber,
                    startsAtDealer: true,
                    systemTripTypeId: SYSTEM_ENUMS.systemTripType.lyftShuttleService,
                    tripWorkFlowId: SYSTEM_ENUMS.tripWorkflowTypes.lyftFromDealership,
                    hasLoaner: false
                };

                return bookingService.getLocationTripType(dealerId, SYSTEM_ENUMS.systemTripType.lyftShuttleService)
                    .then((tripType) => {
                        let dealerTripTypeId = tripType.dealerTripTypes[0].id;

                        return getTripTypeFormattedMessage(dealerId, dealerTripTypeId, appt.dealerServiceOrderId, bindingModel)
                            .then((formattedMessage) => {
                                bindingModel.subject = formattedMessage.subject;
                                bindingModel.body = formattedMessage.body;
                                bindingModel.apptDateTime = new Date(appt.apptDateTime);
                    
                                if (appt.dealerServiceOrderId) {
                                    return rcApi.post(LOCATION_BASEPATH + dealerId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted/' + appt.dealerServiceOrderId, bindingModel)
                                    .then((response) => {
                                        return response;
                                    });
                                } else {
                                    return rcApi.post(LOCATION_BASEPATH + dealerId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted', bindingModel)
                                    .then((response) => {
                                        return response;
                                    });
                                }
                            }, (smsFailed) => {
                                alert("TODO: Unable to book shuttle ride. Please contact your service Adivsor");
                            });
                    });
            });
        }

        // private
        function getAdvisor(dealerId, appointmentId) {
            let route = getBaseRoute(dealerId, appointmentId) + 'advisor';

            return rcApi.get(route);
        }

        function getTripTypeFormattedMessage(dealerId, dealerTripTypeId, serviceOrderId, bindingModel) {
            if (serviceOrderId) {
                return rcApi.get(LOCATION_BASEPATH + dealerId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted/' + serviceOrderId, bindingModel);
            } else {
                return rcApi.get(LOCATION_BASEPATH + dealerId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted', bindingModel);
            }
        }

        function getAppointmentRideShareCredit(dealerId, appointmentId) {
            let route = getBaseRoute(dealerId, appointmentId) + 'credit';

            return rcApi.get(route);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.appointment')
        .factory('appointmentService', appointmentService);

    appointmentService.$inject = ['$q', '$rootScope', '$filter', 'rcApi', 'bookingService', 'appointmentClass', 'appointmentUtilService',
        'SYSTEM_ENUMS', 'APPOINTMENT_SEARCHTYPE', 'APPOINTMENTSTATUS_LABELS', 'APPOINTMENT_CUSTOMERTYPE', 'APPOINTMENT_TRANSPORTATION_TYPE_GROUP'];

    function appointmentService($q, $rootScope, $filter, rcApi, bookingService, appointmentClass, appointmentUtilService, 
        SYSTEM_ENUMS, APPOINTMENT_SEARCHTYPE, APPOINTMENTSTATUS_LABELS, APPOINTMENT_CUSTOMERTYPE, APPOINTMENT_TRANSPORTATION_TYPE_GROUP) {

        let SCRIPTFAQ_BASEPATH = 'content/';

        return {
            getSsoUrl: getSsoUrl,
            getRules: getRules,
            getLocationDMS: getLocationDMS,
            getAvailability: getAvailability,
            typeAheadSearchAppointments: typeAheadSearchAppointments,
            searchAppointments: searchAppointments,
            searchAppointmentsSpecial: searchAppointmentsSpecial,
            getFAQContent: getFAQContent,
            getScriptContent: getScriptContent,
            getDefaultDepartment: getDefaultDepartment,
            createOrUpdateAppointment: createOrUpdateAppointment,
            getAppointment: getAppointment,
            getServiceAdvisors: getServiceAdvisors,
            hasAccess: hasAccess,
            getAccessAndBookingConfig: getAccessAndBookingConfig,
            getBookingConfig: getBookingConfig,
            updateBookingConfigs: updateBookingConfigs,
            getCancellationReasons: getCancellationReasons,
            cancelAppointment: cancelAppointment,
            checkInAppointment: checkInAppointment,
            setAppointmentStatus: setAppointmentStatus,
            getImageToken: getImageToken,
            arriveAppointment: arriveAppointment,
            isInServiceArea: isInServiceArea,
            validateTrip: validateTrip,
            getAppointmentStatusLabel: getAppointmentStatusLabel,
            getAppointmentDepartment: getAppointmentDepartment,
            preprocessLineItems: preprocessLineItems,
            getStatus: getStatus,
            isDraftAppointment: isDraftAppointment,
            getVehicleConditionImages: getVehicleConditionImages,
            saveVehicleConditionImage: saveVehicleConditionImage,
            saveConditionsPredefinedImages: saveConditionsPredefinedImages,
            editVehicleConditionImage: editVehicleConditionImage,
            getDMSRequiredFields: getDMSRequiredFields,
            getTripType: getTripType,
            getPreviouslyDeclinedServices: getPreviouslyDeclinedServices,
            deleteDraftAppointment: deleteDraftAppointment,
            getStatusHistory: getStatusHistory,
            validateCapacity: validateCapacity,
            getLineItemTooltip: getLineItemTooltip,
            showAppointmentStatus: showAppointmentStatus,
            getDepartmentHours: getDepartmentHours,
            deleteConditionsImage: deleteConditionsImage,
            getAdvisorAvailTime: getAdvisorAvailTime,
            completeCheckin: completeCheckin
        };

        function getSsoUrl (dealerId, productType) {
            return rcApi.get('appointment/' + dealerId + '/appsettings/ssourl?productType=' + productType);
        }

        function getRules (dealerId, systemTripTypeId, dealerTripTypeId) {
            return bookingService.getRulesSpecific(dealerId, systemTripTypeId, dealerTripTypeId);
        }

        function getLocationDMS(dealerId) {
            return rcApi.get('appointment/' + dealerId + '/appsettings/dms');
        }

        function getAvailability (dealerId, appointmentId, startDateUTC, endDateUTC, departmentId, advisor, transportationType, pickupLocation, apptOpCodes, loanerNumberOfDays, mobileTech, mobileGarageBufferTime) {
            const advisorId = advisor?.id ?? null;
            const params = {
                startDateUTC,
                endDateUTC: endDateUTC || null,
                appointmentId,
                advisorId,
                departmentId,
                transportationTypeId: transportationType?.id ?? null,
                pickupLocation: pickupLocation ?? null,
                apptOpCodes,
                loanerNumberOfDays,
                isMobileGarage: transportationType.isMobileGarage || false,
                mobileTechId: mobileTech?.id ?? null,
                mobileGarageBufferTime: mobileGarageBufferTime || 0
            };

            if (pickupLocation) {
                params.pickupLocation = {
                    county: pickupLocation.county,
                    streetAddress: pickupLocation.streetAddress,
                    city: pickupLocation.city,
                    state: pickupLocation.state,
                    zip: pickupLocation.zip,
                    countryShortCode: pickupLocation.countryShortCode,
                    lat: pickupLocation.lat,
                    lng: pickupLocation.lng
                };
            }

            return rcApi.post('dealer/' + dealerId + '/appointment/availability/', params)
                .catch(() => null);
        }

        function getServiceAdvisors (dealerId) {
            return rcApi.get('appointment/settings/' + dealerId + '/serviceAdvisors', null, null, null, null, true)
                .catch(() => null);
        }

        function getTripType (dealerId, systemTripTypeId) {
            return rcApi.get('appointment/settings/' + dealerId + '/tripType?systemTripTypeId=' + systemTripTypeId).catch((error) => {
                return null;
            });
        }

        function searchAppointments(location, departmentId, advisors, startDate, searchTerm, statusFilterMixed, transportationTypesFilter, includeServicesBreakdown = false) {
            const statusFilter = typeof statusFilterMixed === 'number' ? [statusFilterMixed]
                : (statusFilterMixed !== null && typeof statusFilterMixed === 'object') ? statusFilterMixed
                : null;

            const searchParams = {
                scheduleStartDate: startDate,
                scheduleEndDate: startDate,
                departmentId,
                advisorIds: advisors,
                dealerTransportationTypeIds: transportationTypesFilter || [],
                appointmentStatuses: statusFilter,
                includeServicesBreakdown,
                includePickupLocationDataInResponse: includeServicesBreakdown
            };

            return rcApi.post('dealer/' + location.id + '/appointment/schedule', searchParams, null, true)
                .catch(e => e);
        }
        
        function searchAppointmentsSpecial(location, departmentId, advisors, startDate, endDate, searchTerm, statusFilterMixed, transportationTypesFilter, sortBy, sortOrder, timeFrame, timeZone, page, pageSize) {
            page = page || 1;
            pageSize = pageSize || 25;
            sortOrder = sortOrder === 'asc' ? 'Ascending' : 'Descending';

            const statusFilter = typeof statusFilterMixed === 'number' ? [statusFilterMixed]
                : (statusFilterMixed !== null && typeof statusFilterMixed === 'object') ? statusFilterMixed
                : null;

            const searchParams = {
                scheduleStartDate: startDate,
                scheduleEndDate: endDate,
                departmentId,
                advisorIds: advisors,
                dealerTransportationTypeIds: transportationTypesFilter || [],
                appointmentStatuses: statusFilter,
                sortOrder,
                sortBy,
                timeFrame,
                timeZone,
                page,
                pageSize
            };

            return rcApi.post(getAppointmentSearchUrl(location), searchParams, null, true);
        }

        function typeAheadSearchAppointments(location, startDate, endDate, searchTerm, timeFrame, timeZone) {
            const searchType = searchTerm.replace(/\D/g, '').length === 10
                ? APPOINTMENT_SEARCHTYPE.customerPhone
                : null;

            const searchParams = {
                searchTerm,
                scheduleStartDate: moment(startDate),
                scheduleEndDate: moment(endDate),
                timeFrame,
                timeZone,
                sortBy: 'Appointment',
                sortOrder: 'Descending',
                ...(searchType && {searchType})
            };

            return rcApi.post(getAppointmentSearchUrl(location), searchParams)
                .catch(e => e);
        }

        function getFAQContent(step, dealerId) {
            return rcApi.get(SCRIPTFAQ_BASEPATH + 'faq/Appointments/' + step + (dealerId !== 0 ? '/' + dealerId : ''), null, null, null, null, true)
                .catch(() => null);
        }

        function getScriptContent(step, dealerId) {
            return rcApi.get(SCRIPTFAQ_BASEPATH + 'script/Appointments/' + step + (dealerId !== 0 ? '/' + dealerId : ''), null, null, null, null, true)
                .catch(() => null);
        }

        function clearNewApptVehIds(appt) {
            if (appt.customerId === "-998" || appt.customerId === -998) {
                appt.customerId = null;
            }

            if (appt.vehicleId === "-998" || appt.vehicleId === -998) {
                appt.vehicleId = null;
            }
        }

        function preProcessAppointment(dealerId, appointmentModel) {
            appointmentModel.dateCreated = new Date();
            appointmentModel.dealerId = dealerId;
            const appointmentToBook = appointmentClass.new(appointmentModel);

            // if we don't do this, posting fails with int32 conversion error
            if (appointmentToBook.id === null) {
                delete appointmentToBook.id;
            }

            clearNewApptVehIds(appointmentToBook);

            if (Array.isArray(appointmentToBook.lineItems)) {
                appointmentToBook.lineItems.forEach((lineItem) => {
                    if (lineItem.id === null) {
                        delete lineItem.id;
                    }
                });
            }

            if (appointmentModel.previouslyDeclinedItems) {
                appointmentToBook.previouslyDeclinedItems = appointmentModel.previouslyDeclinedItems;
            }

            appointmentToBook.disableSendLoanerHomework = appointmentModel.disableSendLoanerHomework;

            return appointmentToBook;
        }

        function getDefaultDepartment(dealerId, appointmentModel) {
            const appointmentToBook = preProcessAppointment(dealerId, appointmentModel);
            
            appointmentToBook.lineItems = Array.isArray(appointmentToBook.lineItems)
                ? appointmentToBook.lineItems.filter(item => item.checked)
                : [];

            return rcApi.post('dealer/' + dealerId + '/appointment/checkdefaultdepartment', appointmentToBook);
        }

        function validateCapacity (dealerId, appointmentModel, previouslyDeclinedServices) {
            let appointmentToBook = preProcessAppointment(dealerId, appointmentModel);
            let customerTypes = APPOINTMENT_CUSTOMERTYPE;

            if (previouslyDeclinedServices) {
                appointmentUtilService.preProcesPreviouslyDeclinedServices(appointmentToBook, previouslyDeclinedServices);
            }

            appointmentToBook.errors = [];

            if (appointmentModel.advisor) {
                appointmentToBook.dealerEmployeeId = appointmentModel.advisor.id;
                appointmentToBook.serviceAdvisorNumber = appointmentModel.advisor.employeeNumber;
            }

            appointmentToBook.customerCompany = appointmentModel.customerType === customerTypes.individual ? null : appointmentModel.customerLastName;

            return rcApi.post('dealer/' + dealerId + '/appointment/validateCapacity', appointmentToBook, null, true)
                .then(result => result, (error) => {
                    if (error?.data?.message && error.status === 400) {
                        return {isDetailed: false, errors: [error.data.message]};
                    } else if (error?.data?.message && error.status === 500) {
                        return {errors: [error], isDetailed: true};
                    }

                    return {errors: null};
                });
        }

        function createOrUpdateAppointment (dealerId, appointmentModel, broadcastListUpdate) {
            appointmentModel.dealerId = dealerId;
            const appointmentToBook = _.cloneDeep(appointmentModel);

            clearNewApptVehIds(appointmentToBook);

            if (appointmentModel.langauge) {
                appointmentToBook.languageType = appointmentModel.language?.value;
            }

            appointmentToBook.errors = [];
            appointmentToBook.customerCompany = appointmentToBook.customerType === APPOINTMENT_CUSTOMERTYPE.individual ? null : appointmentToBook.customerLastName;

            return rcApi.post('dealer/' + dealerId + '/appointment/', appointmentToBook, null, true)
                .then((result) => {
                    if (broadcastListUpdate) {
                        $rootScope.$broadcast('AppointmentList.changed', result);
                    }

                    return result;
                }, (error) => {
                    if (error?.data?.message && error.status === 400) {
                        return {isDetailed: false, errors: [error.data.message]};
                    } else if (error?.data?.message && error.status === 500) {
                        return {errors: [error], isDetailed: true};
                    } else if (error?.status === 409) {
                        return {errors: [error], isDetailed: true};
                    }

                    return {isDetailed: false, errors: ['An error occurred when attempting to update the appointment.']};
                }
            );
        }

        function getAppointment (dealerId, appointmentId) {
            return rcApi.get('dealer/' + dealerId + '/appointment/' + appointmentId);
        }

        function hasAccess (dealerId) {
            return rcApi.get('appointment/' + dealerId + '/appsettings/hasAccess/').catch(() => false);
        }

        function getAccessAndBookingConfig(dealerId) {
            return rcApi.get('appointment/' + dealerId + '/appsettings/getAccessAndBookingConfig/').catch(() => false);
        }

        function getBookingConfig(dealerId) {
            return rcApi.get('appointment/' + dealerId + '/appsettings/getBookingConfig/').catch(() => false);
        }

        function updateBookingConfigs (dealerId, configs) {
            return rcApi.post('appointment/' + dealerId + '/appsettings/updateBookingConfigs', configs).catch(() => false);
        }

        function getCancellationReasons (dealerId, dealerTripTypeId) {
            return rcApi.get('dealer/' + dealerId + '/appointment/cancelreasons/' + dealerTripTypeId).catch(() => false);
        }

        function cancelAppointment (dealerId, appt, cancellationReason, notifyCustomer) {
            return rcApi.remove('dealer/' + dealerId + '/appointment/' + appt.id, {reason: cancellationReason, notifyCustomer}).then((response) => {
                $rootScope.$broadcast('AppointmentList.changed', response);

                return response;
            }, (error) => {
                return {
                    errors: error?.data?.message ? [error.data.message] : ['An error occurred canceling the trip.']
                };
            });
        }

        function checkInAppointment(dealerId, id) {
            return rcApi.put('dealer/' + dealerId + '/appointment/checkin/' + id).then((response) => {
                $rootScope.$broadcast('AppointmentList.changed', response);

                return response;
            });
        }

        function completeCheckin(dealerId, appointmentId, shuttleDetails, creditDetails, shuttleBookingPhone, authorizeServicesPhone, promiseDateTime, keyTag, sendToCustomer) {
            const model = {
                pendingRideDetail: shuttleDetails,
                pendingCreditDetail: creditDetails,
                pendingBookLaterPhone: shuttleBookingPhone, 
                promiseDateTime: promiseDateTime,
                keyTag: keyTag,
                smsNumber: authorizeServicesPhone,
                sendToCustomer: sendToCustomer 
            };

            return rcApi.post(`dealer/${dealerId}/appointment/${appointmentId}/checkin/complete`, model);
        }

        function setAppointmentStatus(dealerId, appointmentId, statusId, notifyCustomer) {
            return rcApi.put('dealer/' + dealerId + '/appointment/setAppointmentStatus/', {appointmentId, statusId, notifyCustomer: !!notifyCustomer})
                .then((response) => {
                    $rootScope.$broadcast('AppointmentList.changed', response);

                    return response;
                });
        }

        function getImageToken(dealerId, imageType, imageId) {
            const url = `dealer/${dealerId}/appointment/image-token/${imageType}${imageId ? '/' + imageId : ''}`;

            return rcApi.get(url);
        }

        function arriveAppointment(dealerId, id) {
            return rcApi.put('dealer/' + dealerId + '/appointment/arrive/' + id).then((response) => {
                $rootScope.$broadcast('AppointmentList.changed', response);

                return response;
            });
        }

        function isInServiceArea (dealerId, pickupLocation) {
            return rcApi.get('dealer/' + dealerId + '/appointment/inServiceArea?pickupLat=' + pickupLocation.lat + '&pickupLng=' + pickupLocation.lng);
        }

        function validateTrip(dealerId, appointmentModel, dealerTripType) {
            let appointmentToBook = appointmentClass.new(appointmentModel);
            
            appointmentToBook.errors = [];
            let serviceOrder = {
                tripType: null,
                customer: null,
                dealerAppointmentId: appointmentModel.id,
                pickupTime: appointmentModel.tripPickupTime,
                serviceAdvisorId: null,
                customerInfo: appointmentModel.tripCustomer,
                hasLoaner: appointmentModel.transportationType?.hasLoaner ? 'yes' : 'no',
                vehicleInfo: {
                    year: appointmentToBook.year,
                    make: appointmentToBook.make,
                    model: appointmentToBook.model,
                    vin: appointmentToBook.vin,
                    transmission: appointmentModel.isManual
                },
                dlInfo: {},
                insInfo: {}
            };
            const apptDateTime = moment(appointmentModel.apptDateTime);
            const dateString = apptDateTime.format('MM/DD/YYYY');
            const timeString = apptDateTime.format('hh:mm A');
            const systemTripType = structuredClone(SYSTEM_ENUMS.systemTripTypes?.find(t => t.value === SYSTEM_ENUMS.systemTripType?.pickup));

            systemTripType.id = systemTripType.value;
            const clonedDealerTripType = structuredClone(dealerTripType);

            clonedDealerTripType.tripTypeId = systemTripType.value;

            const trip = {
                customerDate: dateString,
                customerTime: timeString,
                customerLocation: appointmentModel.tripPickupLocation,
                pickupTimeUtc: appointmentModel.tripPickupTime,
                selectedSystemTripType: systemTripType,
                dealerTripTypeInstance: clonedDealerTripType,
                serviceAdvisor: {id: null},
                startsAtDealer: appointmentModel.transportationType?.hasLoaner,
                dealerLocation: {id: dealerId},
                tripNote: appointmentModel.tripNote
            };

            return bookingService.validateBookingRules(serviceOrder, trip)
                .then(bookingRules => bookingRules)
                .catch((error) => {
                    const errors = [];

                    if (error?.data?.message) {
                        try {
                            const parsedError = JSON.parse(error.data.message)?.TripVerificationResponses;

                            if (Array.isArray(parsedError)) {
                                parsedError.forEach(err => {
                                    if (err?.errorMessage) errors.push(err.errorMessage);
                                });
                            }
                        } catch (parseError) {
                            errors.push(error.data.message);
                        }

                        return {errors: errors.length > 0 ? errors : ['An error occurred booking the trip.']};
                    }

                    return {errors: ['An error occurred booking the trip.']};
                });
        }

        function showAppointmentStatus(pickupDropoff, status) {
            let transTypeGroups = APPOINTMENT_TRANSPORTATION_TYPE_GROUP;
            let statusLabels = APPOINTMENTSTATUS_LABELS;
             
            if (pickupDropoff === transTypeGroups.mobile) {
                return status !== statusLabels.arrived.toUpperCase()
                    && status !== statusLabels.checkedIn.toUpperCase()
                    && status !== statusLabels.checkingIn.toUpperCase();
            }

            return true;
            
        }

        function getAppointmentStatusLabel (appt, statuses) {
            let appStatus = appt.appointmentStatus;
            let matchingStatus;
            let label = '';

            matchingStatus = $filter('filter')(statuses, {code: appStatus}, true);

            if (matchingStatus && matchingStatus.length > 0) {
                label += matchingStatus[0].description;
            }

            return label;

        }

        function getAppointmentDepartment (appt, departments) {
            let dept =  $filter('filter')(departments, {id: appt.departmentId}, true);

            if (dept && dept.length > 0) return dept[0];

            return null;
        }

        function preprocessLineItems(appt, allOpCodes, lineItems, changingDepartment, allRecMaintOpCodes, allRecallOpCodes) {
            let recMaintEnabledDashboard = appointmentUtilService.opCodesEnabledForDept(allRecMaintOpCodes, appt.departmentId, true);
            let recallsEnabledDashboard = appointmentUtilService.opCodesEnabledForDept(allRecallOpCodes, appt.departmentId, true);
            let recMaintEnabledConsumer = appointmentUtilService.opCodesEnabledForDept(allRecMaintOpCodes, appt.departmentId, false);
            let recallsEnabledConsumer = appointmentUtilService.opCodesEnabledForDept(allRecallOpCodes, appt.departmentId, false);
 
            appt.departmentLineItemMismatch = false;
            appt.departmentRecallForceUnchecked = false;
            appt.departmentRecMaintForceUnchecked = false;

            if (Array.isArray(lineItems)) {
                lineItems.forEach((item) => {
                    // Set up the view model variables
                    if (!item.dealerAppointmentServiceOpCode) {
                        let match = $filter('filter')(allOpCodes, {id: item.dealerAppointmentServiceOpCodeId}, true);

                        if (match && match.length > 0) {
                            item.dealerAppointmentServiceOpCode = match[0];
                        }
                    }

                    // need  to check and see if we have a department line item mismatch
                    // and try to match up the appropriate line item in the correct department if we do
                    let itemServiceOpCode = item.dealerAppointmentServiceOpCode;

                    if (item.isAutomatic !== true && 
                        itemServiceOpCode && itemServiceOpCode.dealerDepartmentId !== appt.departmentId && allOpCodes) {
                        let newDeptOpCode = appointmentUtilService.getMatchingDepartmentOpCode(allOpCodes, itemServiceOpCode, appt.departmentId);

                        if (newDeptOpCode) {
                            item.dealerAppointmentServiceOpCode = itemServiceOpCode = newDeptOpCode;
                            item.dealerAppointmentServiceOpCodeId = newDeptOpCode.id;
                            item.departmentLineItemMismatch = false;
                        } else {
                            // set the flag so we can message the user there was an issue
                            // matching up line items
                            item.departmentLineItemMismatch = true;
                            appt.departmentLineItemMismatch = true;
                        }
                    } else {
                        item.departmentLineItemMismatch = false;
                    }
                    

                    if (changingDepartment === false) {
                        item.checked = true;
                    } else {
                        let apptServiceOpCode = item.dealerAppointmentServiceOpCode;

                        if (apptServiceOpCode && apptServiceOpCode.isRecommendedMaintenance && recMaintEnabledDashboard === false && recMaintEnabledConsumer === false) {
                            item.checked = false;
                            item.departmentRecMaintForceUnchecked = true;
                            appt.departmentRecMaintForceUnchecked = true;
                        } else if (apptServiceOpCode && apptServiceOpCode.isRecall && recallsEnabledDashboard === false && recallsEnabledConsumer === false) {
                            item.checked = false;
                            item.departmentRecallForceUnchecked = true;
                            appt.departmentRecallForceUnchecked = true;
                        } else {
                            item.departmentRecallForceUnchecked = false;
                            item.departmentRecMaintForceUnchecked = false;
                        }
                    }

                    if (item.dealerAppointmentServiceOpCode) {
                        let dealerApptServiceOpCode = item.dealerAppointmentServiceOpCode;

                        item.isAutomatic = dealerApptServiceOpCode.isAutomatic;
                        item.isGeneric = dealerApptServiceOpCode.isGeneric;
                        item.isRecall = dealerApptServiceOpCode.isRecall;
                        item.isRecommendedMaintenance = dealerApptServiceOpCode.isRecommendedMaintenance;
                        item.isOther = false;
                    } else if (!item.dealerAppointmentServiceOpCodeId) {
                        item.isOther = true;
                    }
                });
            }
            
            if (appt.departmentRecallForceUnchecked === true || 
                appt.departmentRecMaintForceUnchecked === true) {
                let length = lineItems.length; 
                let i;

                for (i = length - 1; i >= 0; i--) {
                    if (lineItems[i].departmentRecallForceUnchecked === true ||
                        lineItems[i].departmentRecMaintForceUnchecked === true) {
                        lineItems.splice(i, 1);
                    }
                }
            }

            if (appt.departmentRecallForceUnchecked === true) {
                $rootScope.$broadcast('resetRecallData');
            }

            if (appt.departmentRecMaintForceUnchecked === true) {
                $rootScope.$broadcast('resetRecommendedMaintenanceData');
            }
        }

        function getStatus (statuses, status) {
            return $filter('filter')(statuses, {description: status}, true)[0].code;
        }

        function isDraftAppointment (statuses, appointment) {
            return appointment.appointmentStatus === getStatus(statuses, APPOINTMENTSTATUS_LABELS.draft);
        }

        function getVehicleConditionImages (dealerId, appointmentId) {
            return rcApi.get('dealer/' + dealerId + '/appointment/checkin/' + appointmentId + '/vehicle-condition');
        }

        function saveVehicleConditionImage (dealerId, appointmentId, vehicleConditions) {
            // remove fileData so it's not transported
            vehicleConditions?.forEach(condition => {
                condition.images?.forEach(image => {
                    image.fileData = null;
                });
            });

            return rcApi.post('dealer/' + dealerId + '/appointment/checkin/' + appointmentId + '/vehicle-condition', vehicleConditions);
        }
        
        function saveConditionsPredefinedImages(dealerId, appointmentId, predifinedImagesConditions) {
            if (predifinedImagesConditions && predifinedImagesConditions.fileData) {
                predifinedImagesConditions.fileData = null;
            }

            return rcApi.post('dealer/' + dealerId + '/appointment/checkin/' + appointmentId + '/vehicle-condition/predifinedImages', predifinedImagesConditions);
        }

        function deleteConditionsImage(dealerId, appointmentId, imageId) {
            return rcApi.post('dealer/' + dealerId + '/appointment/checkin/' + appointmentId + '/vehicle-condition/deleteConditionsImage/' + imageId);
        }

        function getPreviouslyDeclinedServices(dealerId, customerId, vin) {
            return rcApi.get('dealer/' + dealerId + '/appointment/declined-service/' + customerId + '/' + vin);
        }

        function editVehicleConditionImage (dealerId, appointmentId, vehicleConditions, vehicleConditionId, imageData) {
            // remove fileData so it's not transported
            vehicleConditions?.forEach(condition => {
                condition.images?.forEach(image => {
                    image.fileData = null;
                });
            });
            
            return rcApi.put('dealer/' + dealerId + '/appointment/checkin/' + appointmentId + '/vehicle-condition/' + vehicleConditionId, imageData);
        }

        function getDMSRequiredFields(dealerId) {
            return rcApi.get('dealer/' + dealerId + '/appointment/DmsRequiredFields');
        }

        function deleteDraftAppointment (dealerId, appointmentId) {
            return rcApi.post('dealer/' + dealerId + '/appointment/deletedraft/' + appointmentId);
        }

        function getStatusHistory (dealerId, appointmentId, statuses) {
            return rcApi.get('dealer/' + dealerId + '/appointment/' + appointmentId + '/history?statuses=' + statuses);
        }

        function getLineItemTooltip (dealerId, appointmentId) {
            return rcApi.get('dealer/' + dealerId + '/appointment/' + appointmentId + '/getLineItemTooltip');
        }

        function getDepartmentHours (dealerId, departmentId) {
            return rcApi.get('dealer/' + dealerId + '/appointment/department/' + departmentId + '/hours');
        }

        function getAdvisorAvailTime (appt, advisor) {
            if (advisor.id === appt.dealerEmployeeId) {
                return ' (Currenty Assigned)';
            } else {
                const utcNow = moment.utc();
                const firstAvailUtc = moment.utc(new Date(advisor.firstAvailableTime));

                if (utcNow.isBefore(firstAvailUtc)) {
                    return ' (Available at ' + moment(firstAvailUtc).format('hh:mm A') + ')';
                } else { 
                    return ' (Available)';
                }
            }
        }

        function getAppointmentSearchUrl(location) {
            if (location?.id) return `dealer/${location.id}/appointment/search`;

            return 'dealer/appointment/search';
        }
    }
})();
    
(function () {
    'use strict';

    AppointmentController.$inject = ["$rootScope", "$scope", "$transition$", "$state", "$timeout", "$filter", "messagesService", "rcUtilService", "APPOINTMENTSTATUS_LABELS", "APPOINTMENT_CUSTOMERTYPE", "APPOINTMENT_PAYTYPES", "ValidationService", "APPOINTMENT_TRANSPORTATION_TYPE", "appointmentService", "appointmentUtilService", "toastr", "resolvedLocationList", "resolvedAppointmentStatuses", "resolvedDmsRequiredFields", "SYSTEM_ENUMS", "appointmentClass", "locationService", "tripService", "modalService", "localStorageService", "FIELD_IS_REQUIRED"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentController', AppointmentController);

    function AppointmentController($rootScope, $scope, $transition$, $state, $timeout, $filter, messagesService, rcUtilService, APPOINTMENTSTATUS_LABELS, APPOINTMENT_CUSTOMERTYPE, APPOINTMENT_PAYTYPES, ValidationService,
            APPOINTMENT_TRANSPORTATION_TYPE, appointmentService, appointmentUtilService, toastr, 
            resolvedLocationList, resolvedAppointmentStatuses, resolvedDmsRequiredFields, SYSTEM_ENUMS, appointmentClass, locationService, tripService, modalService, localStorageService, FIELD_IS_REQUIRED) {
        
        let vm = this;
        let _params = $transition$.params();
        let _resolvedLocationId = _params.locationId;
        let _resolvedApptId = _params.appointmentId;
        let _editClicked = _params.editClicked;
        let _initialStep;
        let _validationService = new ValidationService({
            validateOnEmpty: true
        });
        let _activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
        let _suffix = appointmentUtilService.getProductSuffix(_activeProduct);
        let _originalAppointmentHasRecalls = false;
        let _originalAppointmentHasRecMaint = false;
       
        vm.fieldIsReqTxt = FIELD_IS_REQUIRED;
        vm.originalApptHasRecallsOrRecMaint = false;
        vm.resolvedCustomerId = _params.customerId;
        vm.fakeInput = "validationHelper";
        vm.dmsRequiredFields = resolvedDmsRequiredFields;
        vm.recallsChecked = false;
        vm.recMaintChecked = false;
        vm.prevDeclinedServicesChecked = false;
        vm.originalApptFirstName = null;
        vm.originalApptLastName = null;
        vm.originalApptMobile = null;
        vm.originalApptEmail = null;
        vm.originalApptYear = null;
        vm.originalApptMake = null;
        vm.originalApptModel = null;
        vm.decodedVin = false;
        vm.addingCustomerVehicle = false;
        vm.appointmentStatuses = resolvedAppointmentStatuses;
        vm.odometerTypes = SYSTEM_ENUMS.odometerTypes;
        vm.contactError = null;
        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.paymentTypes = APPOINTMENT_PAYTYPES;
        vm.loadSummaryMap = false;
        vm.locationList = resolvedLocationList;
        vm.editingExistingAppointment = false;
        vm.dealerOpCodes = [];
        vm.servicesModified = false;
        vm.needsScheduleTransportationUpdate = false;
        vm.originalAppointmentLineItems = [];
        vm.customerType = APPOINTMENT_CUSTOMERTYPE;
        vm.forceNewCustomerOnLoad = false;
        vm.preselectedVin = null;
        vm.accordion = {
            steps: {
                chooseLocation: 1,
                customerVehicle: 2,
                scheduleTransportation: 3,
                summary: 4
            },
            selectedStep: vm.locationList.length > 1 ? 1 : 2
        };
        vm.lastDuplicateCustomerChecked = {
            email: null,
            phone: null
        };

        vm.loadingCustomerDetails = false;

        vm.enableMessaging = function (enable) {
            rcUtilService.showHideMobileMessagingPanel(enable);
        };

        function getAppointmentStatusId (description) {
            let status = $filter('filter')(vm.appointmentStatuses, {description: description}, true)[0];

            return status.code;
        }

        function selectTransportationType() {
            let transId = vm.appointment.dealerTransportationTypeId;
            
            vm.appointment.transportationType = appointmentUtilService.getDefaultTranportationType(transId, vm.dealerTransportationTypes);
            vm.appointment.pickupDropoff = appointmentUtilService.getPickupDropOffOption(vm.appointment);
        }

        vm.isFormInvalid = function () {
            
            if (vm.accordion.selectedStep === vm.accordion.steps.customerVehicle && vm.tooManyRecalls === true) {
                return true;
            } else if (vm.accordion.selectedStep === vm.accordion.steps.customerVehicle && 
                _activeProduct === 'appointment-list' && 
                vm.appointment.noLineItemsSelected) {
                return true;
            } else if (vm.accordion.selectedStep === vm.accordion.steps.scheduleTransportation && !vm.appointment.selectedTimeSlot) {
                return true;
            }

            let valid = true;

            if ($scope.bookApptForm) {
                valid = _validationService.checkFormValidity($scope.bookApptForm) && $scope.bookApptForm.$valid;
            }

            return !valid;
        };

        vm.filterOpCodesForDisplay = function (opCode) {
            let showPreviouslyDeclinedServices = vm.previouslyDeclinedServicesEnabled();

            return appointmentUtilService.filterOpCodesForDisplay(vm.appointment.departmentId, showPreviouslyDeclinedServices, opCode, vm.originalAppointmentLineItems, vm.previouslyDeclinedServices, vm.appointment.lineItems);
        };

        vm.getSelectedServicesCounts = function () {
            vm.commonServicesCount = 0;
            vm.recMaintServiceCount = $filter('filter')(vm.appointment.lineItems, {isRecommendedMaintenance: true}, true).length;
            vm.recallsServiceCount = vm.recalls ? $filter('filter')(vm.recalls, {checked: true}, true).length : 0;
            vm.prevDeclinedServiceCount = vm.previouslyDeclinedServices ? $filter('filter')(vm.previouslyDeclinedServices, {checked: true}, true).length : 0;

            _.forEach(vm.dealerOpCodes, (lineItem) => {
                if (lineItem.checked && vm.filterOpCodesForDisplay(lineItem)) {
                    vm.commonServicesCount++;
                }
            });

            vm.appointment.noLineItemsSelected = vm.getSelectedLineItemCount() === 0;
        };

        vm.opCodesLoaded = function () {
            if (vm.originalAppointmentLineItems.length === 0 && vm.appointment.apptId) {
                vm.dealerOpCodes = _.cloneDeep(vm.cleanDealerOpCodes);
                vm.dealerGenericOpCodes = _.cloneDeep(vm.cleanDealerGenericOpCodes);
                vm.dealerRecallOpCodes = _.cloneDeep(vm.cleanDealerRecallOpCodes);
                vm.dealerRecommendedMaintenanceOpCodes = _.cloneDeep(vm.cleanDealerRecommendedMaintenanceOpCodes);
                vm.dealerOpCodesAll = _.cloneDeep(vm.cleanDealerOpCodesAll);
                if (vm.appointmentLoadNotFinished === false)
                    vm.addOtherLineItem();
            } else {
                vm.resetAppointmentLineItems();
            }

            if (vm.appointmentLoadNotFinished === true) {
                finishLoadAppointmentAfterOpcodes();
                vm.addOtherLineItem();
                vm.appointmentLoadNotFinished = false;
            } else {
                appointmentUtilService.processDashboardViewLineItems(vm.appointment.lineItems, vm.appointment.departmentId, vm.dealerOpCodesAll, vm.dealerOpCodes, vm.dealerRecommendedMaintenanceOpCodes, vm.dealerRecallOpCodes);
            }

            vm.getSelectedServicesCounts();
        };

        vm.recallsLoaded = function () {
            appointmentUtilService.processDashboardViewLineItems(vm.appointment.lineItems, vm.appointment.departmentId, vm.dealerOpCodesAll, vm.dealerOpCodes, vm.dealerRecommendedMaintenanceOpCodes, vm.dealerRecallOpCodes);
        };

        // when we switch from a department with recalls to one where recalls are not enabled
        // this is called
        $rootScope.$on('resetRecallData', () => {
            vm.recalls.forEach((item) => {
                item.checked = false;
            });
        });

        // when we switch from a department with recmaint to one where recmaint are not enabled
        // this is called
        $rootScope.$on('resetRecommendedMaintenanceData', () => {
            vm.recMaintData.forEach((item) => {
                item.checked = false;
            }); 

            vm.selectedRecMaint = null;
        });

        vm.recallsEnabled = function () {
            return _originalAppointmentHasRecalls || appointmentUtilService.opCodesEnabledForDept(vm.dealerRecallOpCodes, vm.appointment.departmentId, true);
        };

        vm.recMaintEnabled = function () {
            return _originalAppointmentHasRecMaint || appointmentUtilService.opCodesEnabledForDept(vm.dealerRecommendedMaintenanceOpCodes, vm.appointment.departmentId, true);
        };

        vm.previouslyDeclinedServicesEnabled = function () {
            if (!vm.selectedDepartment) return false;

            return vm.selectedDepartment.showPreviouslyDeclinedServicesDashboard;
        };

        // called if we switch to a department w/
        // prev declined services disabled
        function resetPreviouslyDeclinedServices () {
            let appt = vm.appointment;
            let selectedDeclinedServices = null;
            let previouslyDeclinedServices = vm.previouslyDeclinedServices;
 
            appt.departmentPrevDeclinedForceUnchecked = false;
            
            if (previouslyDeclinedServices) {
                selectedDeclinedServices =  previouslyDeclinedServices ? $filter('filter')(previouslyDeclinedServices, {checked: true}, true) : [];

                if (selectedDeclinedServices.length > 0) {
                    appt.departmentPrevDeclinedForceUnchecked = true;
                    _.forEach(selectedDeclinedServices, (service) => {
                        service.checked = false;
                    });
                }
            }

            vm.getSelectedServicesCounts();
        }

        vm.hasMismatchedPreviouslyDeclinedItems = function () {
            return _.some(vm.previouslyDeclinedServices, (svc) => {
                return svc.departmentPrevDeclinedMismatch && svc.checked;
              });
        };

        vm.departmentChanged = function (loadFromEdit) {
            let appt = vm.appointment;
            let deptId = appt.departmentId;

            if (deptId) {
                vm.selectedDepartment = _.find(vm.dealerDepartments, (d) => { return d.id === deptId; });
                vm.dealerDeptOpCodes = appointmentUtilService.getDeptOpCodes(vm.dealerOpCodes, deptId);
                $rootScope.$broadcast('deptOpCodesUpdated', vm.dealerDeptOpCodes);
                $scope.$broadcast('defaultDepartmentLoaded', deptId);
                // go through the functions that load when an appointment is loaded
                // because these contain the locic for department mismatching and figuring out checked items
                appointmentService.preprocessLineItems(appt, vm.dealerOpCodesAll, appt.lineItems, true, vm.dealerRecommendedMaintenanceOpCodes, vm.dealerRecallOpCodes);
                appointmentUtilService.processDashboardViewLineItems(vm.appointment.lineItems, deptId, vm.dealerOpCodesAll, vm.dealerOpCodes, vm.dealerRecommendedMaintenanceOpCodes, vm.dealerRecallOpCodes);

                if (vm.previouslyDeclinedServicesEnabled() === false) {
                    resetPreviouslyDeclinedServices();
                } else {
                    vm.appointment.departmentPrevDeclinedForceUnchecked = false;
                }

                if (vm.appointment.transportationType?.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage) {
                    vm.getMobileTechs();
                }

                return locationService.getLocationDepartmentAvailAdvisor(appt.location.id, deptId, true).
                    then((result) => {
                        vm.serviceAdvisors = result.advisors;
                        appointmentUtilService.setLastBookedDepartment(appt.location.id, deptId);

                        if (loadFromEdit) {
                            $rootScope.$broadcast('serviceAdvisorsLoaded');
                        }
                    });
            } else {
                vm.serviceAdvisors = null;

                return Promise.resolve();
            }
        };

        vm.getMobileTechs = function () {
            vm.retrievingDrivers = true;
            let appt = vm.appointment;
            let startTime = moment(appt.expectedStartTime).format('MM/DD/YYYY hh:mm A');
            let endTime = moment(appt.expectedEndTime).format('MM/DD/YYYY hh:mm A'); // lower case am/pm seems to have a sporadic issue.
            let driverId = appt.tripDriver ? appt.tripDriver.id : null;
            let tripType = appointmentUtilService.transportationTripTypeMap(appt.transportationType.dealerSystemTransportationTypeId);

            tripService.getActiveDrivers(appt.dealerId,
                startTime.toLowerCase(),
                endTime.toLowerCase(),
                driverId,
                vm.appointment.tripId,
                tripType).then((response) => {
                    if (response.errorMessage) {
                        vm.errors = response.errorMessage;
                    } else if (response) {
                        vm.mobileTechs = response;
                    }

                    vm.retrievingDrivers = false;
                },
                (errorResponse) => {
                    displayToastError(errorResponse);
                    vm.retrievingDrivers = false;
            });
        };

        vm.formatDriverDropDown = function (driver) { return tripService.formatDriverDropDown(driver, driver); };

        vm.loadContactForMessagingPanel = function (initializing) {
            let phoneNumber = vm.appointment.customerPhone;

            function setContact(contacts) {
                const fallback = {
                    id: 0,
                    dealerId: vm.appointment.location?.id || vm.appointment.dealerId,
                    firstName: vm.appointment.customerFirstName,
                    lastName: vm.appointment.customerLastName,
                    email: vm.appointment.customerEmail,
                    mobilePhone: phoneNumber || null
                };

                vm.contact = (contacts && contacts.length) ? contacts[0] : fallback;
                $rootScope.$broadcast('messagePaneContactUpdate', vm.contact);
            }

            if (!phoneNumber || phoneNumber.length !== 10) {
                setContact([]);

                if (initializing) {
                    vm.loadingAppointment = false;
                    $rootScope.$broadcast('appointmentLoaded');
                }

                return;
            }

            messagesService.getContacts({dealer: vm.appointment.location.id, query: phoneNumber.replace(/\D/g, ''), allowDisabledDealers: true}).then((contacts) => {
                setContact(contacts);
            }).finally(() => {
                if (initializing) {
                    vm.loadingAppointment = false;
                    $rootScope.$broadcast('appointmentLoaded');
                }
            });
        };

        function loadModelForDropdownAddress () {
            let customer = vm.appointment;

            if (customer.address1 && customer.city && customer.state && customer.zipCode) {
                vm.appointment.customerFormattedLocation = customer.address1 + ", " + customer.city + " " + customer.state + " " + customer.zipCode;
            }
        }

        vm.activeDepartmentFilter = function(dept) {
            return dept.isDisabled === false || (vm.editingExistingAppointment === true && vm.originalDepartmentId === dept.id);
        };

        vm.requiresCapacityValidation = function (checkServices) {
            let appt = vm.appointment;

            if (vm.editingExistingAppointment === true && 
                vm.originalAppointmentDateTime === appt.apptDateTime &&
                vm.originalDealerEmployeeId === appt.dealerEmployeeId &&
                vm.originalDepartmentId === appt.departmentId &&
                vm.originalTransportationType === appt.dealerTransportationTypeId &&
                vm.originalIsManual === appt.isManual &&
                vm.originalPickupLocation === appt.tripPickupLocation) {
                    if (checkServices) {
                        if (vm.servicesModified === true) {
                            return true;
                        } else {
                            return false;
                        }
                    } 

                    return false;
                }

                return true;
        };

        vm.updateCustomerVehicleModelAfterLoad = function () {
            if (vm.appointment.customerType !== vm.customerType.business) {
                vm.appointment.customerType = vm.customerType.individual;
            }

            vm.appointment.customerIsBusiness = vm.appointment.customerType === vm.customerType.business;

            loadModelForDropdownAddress();

        };

        vm.getAppointmentDepartment = function () {
            return appointmentService.getAppointmentDepartment(vm.appointment, vm.dealerDepartments);
        };

        vm.getStatus = function (status) {
            return appointmentService.getStatus(vm.appointmentStatuses, status);
        };

        vm.addOtherLineItem = function() {
            if (vm.appointment.location) {
                appointmentUtilService.addDashboardOtherLineItem(vm.appointment.lineItems, vm.appointment.location.id);
            }
        };

        vm.resetAppointmentLineItems = function () {
            vm.dealerOpCodes = _.cloneDeep(vm.cleanDealerOpCodes);
            vm.dealerGenericOpCodes = _.cloneDeep(vm.cleanDealerGenericOpCodes);
            vm.dealerRecallOpCodes = _.cloneDeep(vm.cleanDealerRecallOpCodes);
            vm.dealerRecommendedMaintenanceOpCodes = _.cloneDeep(vm.cleanDealerRecommendedMaintenanceOpCodes);
            vm.dealerOpCodesAll = _.cloneDeep(vm.cleanDealerOpCodesAll);
            vm.appointment.lineItems = _.cloneDeep(vm.originalAppointmentLineItems);
            vm.addOtherLineItem();
        };

        vm.resetAppointment = function () {
            let tmpLocation = vm.appointment.location;
            let tmpDepartment = vm.appointment.departmentId;
            let tmpDMSSystem = vm.appointment.dealerDMSSystem;

            vm.appointment = appointmentClass.new();
            vm.appointment.location = tmpLocation;
            vm.appointment.departmentId = tmpDepartment;
            vm.appointment.dealerDMSSystem = tmpDMSSystem;
            vm.resetAppointmentLineItems();
            vm.addingCustomerVehicle = false;
            vm.customer = false;
            vm.currentVehicle = null;
            vm.contact = null;
        };

        vm.clearCustomer = function () {
            vm.addingCustomerVehicle = false;
            vm.customer = false;
            vm.appointment.customerId = null;
            vm.appointment.customerFirstName = null;
            vm.appointment.customerLastName = null;
            vm.appointment.customerCompany = null;
            vm.appointment.customerEmail = null;
            vm.appointment.customerPhone = null;
            vm.lastDuplicateCustomerChecked = {
                email: null,
                phone: null
            };
        };

        vm.clearVehicle = function () {
            vm.currentVehicle = null;
            vm.appointment.vin = null;
            vm.appointment.year = null;
            vm.appointment.make = null;
            vm.appointment.model = null;
        };

        function displayToastError(errorResponse) {
            let errorMessage = 'An error occurred';

            if (errorResponse.data && errorResponse.data.exceptionMessage) {
                errorMessage = errorResponse.data.exceptionMessage;
            }

            toastr.error(errorMessage);
        }

        vm.updateState = function () {
            let appt = vm.appointment;

            if (!vm.resolvedAppointment) {
               if (appt.appointmentId) {
                    $state.go('appointment-add' + _suffix, {
                        locationId: appt.location.id,
                        customerId: appt.customerId,
                        appointmentId: appt.appointmentId
                    },
                    {
                        notify: false
                    });
                } else if (appt.customer) {
                    $state.go('appointment-add' + _suffix, {
                        locationId: appt.location.id,
                        customerId: appt.customerId,
                        appointmentId: null
                    },
                    {
                        notify: false
                    });
                } else if (appt.location) {
                    $state.go('appointment-add' + _suffix, {
                        locationId: appt.location.id,
                        customerId: null,
                        appointmentId: null
                    }, {
                        notify: false
                    });

                } else {
                    $state.go('appointment-add' + _suffix, {
                        locationId: null,
                        customerId: null,
                        appointmentId: null
                    }, {
                        notify: false
                    });
                }
            }
        };

        function finishLoadAppointmentAfterOpcodes () {
            let appt = vm.appointment; 
            let recalls = $filter('filter')(appt.lineItems, {isRecall: true}, true);
            let recMaint = $filter('filter')(appt.lineItems, {isRecommendedMaintenance: true}, true);

            _originalAppointmentHasRecalls = recalls && recalls.length > 0;
            _originalAppointmentHasRecMaint = recMaint && recMaint.length > 0;

            appointmentService.preprocessLineItems(appt, vm.dealerOpCodesAll, appt.lineItems, false, vm.dealerRecommendedMaintenanceOpCodes, vm.dealerRecallOpCodes);
            vm.originalAppointmentLineItems = _.cloneDeep(appt.lineItems);
            vm.originalApptYear = appt.year ? parseInt(appt.year) : null;
            vm.originalApptMake = appt.make;
            vm.originalApptModel = appt.model;
            
        
            if (_originalAppointmentHasRecalls || _originalAppointmentHasRecMaint) {
                vm.originalApptHasRecallsOrRecMaint = true;
            }

            vm.originalDriver = appt.tripDriver ? appt.tripDriver.id : null;
            appointmentUtilService.processDashboardViewLineItems(vm.appointment.lineItems, vm.appointment.departmentId, vm.dealerOpCodesAll, vm.dealerOpCodes, vm.dealerRecommendedMaintenanceOpCodes, vm.dealerRecallOpCodes);
            
            $timeout(() => {
                vm.servicesModified = false;
            }, 1);
            vm.updateCustomerVehicleModelAfterLoad();
            selectTransportationType();
        }
        
        vm.loadAppointment = function (appt) {
            vm.appointment = appointmentClass.new(appt);

            if (appt.dealerId) {
                vm.appointment.location = $filter('filter')(vm.locationList, {id: appt.dealerId}, true)[0];
            } else {
                vm.appointment.location = vm.resolvedLocation;
            }

            if (vm.appointment.make) {
                vm.appointment.make = vm.appointment.make.trim();
            }

            if (vm.appointment.model) {
                vm.appointment.model = vm.appointment.model.trim();
            }

            if (vm.appointment.promiseDateTime) {
                let promiseDateTime = moment(vm.appointment.promiseDateTime);

                vm.appointment.promiseDate = promiseDateTime;
                vm.appointment.promiseTime = promiseDateTime.format('hh:mm A');
            }

            if (vm.appointment.tripDriver && !vm.appointment.tripDriver.id) {
                vm.appointment.tripDriver = null;
            }
            
            if (vm.dealerOpCodesAll) {
                finishLoadAppointmentAfterOpcodes();
            } else {
                vm.appointmentLoadNotFinished = true;
            }
            
        };

        vm.getSelectedLineItemCount = function () {
            let checkedLineItems = appointmentUtilService.getDashboardCheckedLineItems(vm.appointment.lineItems, vm.dealerOpCodes);
            let selectedRecMaint = vm.recMaintData ? $filter('filter')(vm.recMaintData, {checked: true}, true) : [];
            let selectedDeclinedServices =  vm.previouslyDeclinedServices ? $filter('filter')(vm.previouslyDeclinedServices, {checked: true}, true) : [];
            let selectedRecalls = vm.recalls ? $filter('filter')(vm.recalls, {checked: true}, true) : [];
            let cnt = checkedLineItems.length;

            if (selectedRecMaint) {
                cnt += selectedRecMaint.length;
            }

            if (selectedDeclinedServices) {
                cnt += selectedDeclinedServices.length;
            }

            if (selectedRecalls) {
                cnt += selectedRecalls.length;
            }

            return cnt;
        };

        vm.getRecMainTooltip = function (apps) {
            return appointmentUtilService.getRecMainTooltip(apps);
        };

        vm.getRecMaintTitle = function (recMaint) {
            return appointmentUtilService.getRecMaintTitle(recMaint, vm.appointment);
        };

        vm.gotoTab = function (tabIndexToLoad) {
            vm.tabs[tabIndexToLoad].active = true;
            $state.go(vm.tabs[tabIndexToLoad].route);
        };

        vm.showNextBtn = function () {
            if (vm.resolvedAppointmentId && !vm.editingExistingAppointment) return false;

            switch (vm.accordion.selectedStep) {
                case 1 :
                    return false;
                case 2 :
                    if (vm.appointment && !vm.customer && !vm.addingCustomer) {
                        return false;
                    }

                    return true;
                case 3 :
                    return true;
                case 4 :
                    return true;
                default:
                    return true;
            }
        };

        vm.showBackBtn = function () {
            switch (vm.accordion.selectedStep) {
                case 1 :
                    return false;
                case 2 :
                    if (vm.appointment && !vm.customer) return false;
                    if (vm.editingExistingAppointment) return false;

                    return true;
                case 3 :
                    return true;
                case 4 :
                    if (vm.resolvedAppointmentId && !vm.editingExistingAppointment) return false;

                    return true;
                default:
                    return true;
            }
        };

        vm.getNextBtnText = function () {
            switch (vm.accordion.selectedStep) {
                case 1 :
                    return '';
                case 2 :
                    return 'NEXT';
                case 3 :
                    return 'NEXT';
                case 4 :
                    return 'BOOK';
            }
        };

        vm.backClicked = function () {
            $rootScope.$broadcast('apptBackClicked');
        };

        vm.nextClicked = function () {
            $rootScope.$broadcast('apptNextClicked');
        };

        vm.isDraftAppointment = function () {
            return appointmentService.isDraftAppointment(vm.appointmentStatuses, vm.appointment);
        };

        function hasSomeCustomerData () {
            let appt = vm.appointment;

            if (appt.customerFirstName ||
                appt.customerLastName ||
                appt.customerEmail || 
                appt.customerPhone ||
                appt.customerAddress1 ||
                appt.customerCity ||
                appt.customerState ||
                appt.customerZip ||
                appt.customerCounty ||
                appt.year ||
                appt.make || 
                appt.model) return true;

                return false;
        }

        vm.closeClicked = function () {
            if (vm.appointment.id && _editClicked === "1") {
                $state.go('appointment-details' + _suffix, { 
                    locationId: vm.appointment.location.id,
                    appointmentId: vm.appointment.id
                });
            } else {
                let customerSelected = !!(vm.appointment.customerId && vm.appointment.appointmentStatus === 0 && hasSomeCustomerData());
                
                if (customerSelected || vm.isDraftAppointment()) {
                    let confirm = modalService.showYesNo('Save Draft?', 'Do you want to save a draft for later?', 'No', 'Yes');

                    confirm.then((confirmed) => {
                        if (confirmed) {
                            vm.appointment.disableNotifications = true;
                            vm.closeBusy = true;
                            vm.appointment.appointmentStatus = vm.getStatus(APPOINTMENTSTATUS_LABELS.draft);
                            appointmentService.createOrUpdateAppointment(vm.appointment.location.id, vm.appointment, true)
                            .then((result) => {
                                 if (result && !result.errors) {
                                    $state.go(_activeProduct);
                                } else {
                                    console.log(result.errors);
                                    vm.closeBusy = false;
                                }
                            });
                            
                        } else {
                            if (vm.appointment.id) {
                                vm.closeBusy = true;
                                appointmentService.deleteDraftAppointment(vm.appointment.location.id, vm.appointment.id).then((result) => {
                                    $state.go(_activeProduct);
                                }).finally(() => {
                                    vm.closeBusy = false;
                                });
                            } else {
                                // it was never saved, just exit
                                $state.go(_activeProduct);
                            }
                        }
                    });
                } else {
                    $state.go(_activeProduct);
                }
            }
        };

        // right hand side tabs
        function initTabContainers() {
            vm.tabs = [
            {
                title: 'MESSAGE',
                route: 'appointment-messages' + _suffix,
                active: false
            },
            {
                title: 'SCRIPT',
                route: 'appointment-scripts' + _suffix,
                active: false
            },
            {
                title: 'FAQ',
                route: 'appointment-faq' + _suffix,
                active: false
            }];

            $timeout(() => {
                vm.gotoTab(0);
            }, 1000);
        }

        function initialize() {
            if (_resolvedLocationId) {
                vm.resolvedLocation = $filter('filter')(resolvedLocationList, {id: parseInt(_resolvedLocationId)}, true)[0];
            }
        
            // because deep linking doesn't work w/ the asides
            // and accordions load the appt here
            if (!_resolvedApptId) {
                vm.appointment = appointmentClass.new();
                _initialStep = vm.accordion.steps.chooseLocation;

                if (vm.resolvedLocation) {
                    vm.appointment.location = vm.resolvedLocation;
                }

                if (_params.vin) {
                    vm.appointment.vin = _params.vin;
                }

                if (_params.autoNewCustomer) {
                    vm.forceNewCustomerOnLoad = true;
                    vm.preselectedVin = _params.vin || null;
                    $timeout(() => {
                        vm.selectedCustomer = appointmentUtilService.createNewCustomerEntry();
                        angular.extend(vm.appointment, vm.selectedCustomer);
                        vm.customer = true;
                        _initialStep = vm.accordion.steps.customerVehicle;
                        vm.accordion.selectedStep = _initialStep;
                        $rootScope.$broadcast('stepChanged');
                        vm.gotoTab && vm.gotoTab(0);
                    }, 0);
                }
            } else {
                vm.loadingAppointment = true;
                vm.resolvedAppointmentId = _resolvedApptId;
            
                appointmentService.getAppointment(_resolvedLocationId, _resolvedApptId).then((result) => {
                    if (!result.canEdit && _editClicked === "1") {
                        modalService.showError('Appointment has progressed to a stage where it is no longer editable.', '', true)
                            .then(() => {}).then((error) => {}).finally(() => {
                                $state.go('appointment-details' + _suffix, { 
                                    locationId: vm.appointment.location.id,
                                    appointmentId: vm.appointment.id
                                });
                            });
                    }

                    vm.loadAppointment(result);
                    vm.customer = true;
                    vm.currentVehicle = null;
                    _initialStep = vm.accordion.steps.summary;
                    
                    if (_editClicked === "1") {
                        let appt = vm.appointment;
                        
                        vm.editingExistingAppointment = true;
                        vm.accordion.selectedStep = vm.accordion.steps.customerVehicle;
                        // need to note the original department, advisor, trip type, etc so we can check
                        // later if it was edited
                        vm.originalAppointmentDateTime = _.cloneDeep(appt.apptDateTime);
                        vm.originalDealerEmployeeId = appt.dealerEmployeeId;
                        vm.originalDepartmentId = appt.departmentId;
                        vm.originalTransportationType = appt.dealerTransportationTypeId;
                        vm.originalIsManual = appt.isManual;
                        vm.originalPickupLocation = appt.tripPickupLocation;
                    } else {
                        vm.accordion.selectedStep = _initialStep;
                    }

                    vm.loadSummaryMap = true;

                    // is the motorist phone number a valid mobile phone?
                    if (vm.appointment.customerPhone && vm.appointment.customerPhone.length === 10) {
                        vm.contactError = null;
                        messagesService.checkPhoneNumber(vm.appointment.customerPhone, vm.appointment.location.id)
                            .then((response) => {
                                if (response.type === vm.phoneTypes.landline || response.type === vm.phoneTypes.voip) {
                                    vm.contactError = "Number is a ";
                                    vm.contactError += response.type === vm.phoneTypes.voip ? "VoIP" : "landline";
                                    vm.loadingAppointment = false;
                                    $rootScope.$broadcast('appointmentLoaded');
                                } else {
                                    vm.loadContactForMessagingPanel(true);
                                }
                            });
                    } else {
                        vm.loadingAppointment = false;
                    }

                }, (errorResponse) => {
                    displayToastError(errorResponse);
                    vm.loadingAppointment = false;
                });
            }
            
            vm.currentRoute = $state.name;
            initTabContainers();
            vm.appointmentCanceledStatusId = getAppointmentStatusId('Canceled');

            if (_initialStep !== vm.accordion.steps.summary && !_resolvedLocationId) {
                vm.accordion.selectedStep = _initialStep;
                $rootScope.$broadcast('stepChanged');
            }
        }

        initialize();

        $scope.$on('departmentIdSet', () => {
            $scope.$broadcast('defaultDepartmentLoaded', vm.appointment.departmentId);
        });

        vm.showUpdateWarning = function (parentPanel, ignoreUpdateWarning = false) {
            if (ignoreUpdateWarning || 
                vm.loadingAppointment === true ||
                vm.editingExistingAppointment === false || 
                parentPanel.initialYMMLoad === true ||
                parentPanel.initialLoad === true || 
                parentPanel.updatingYears === true) return;

            if (!vm.needsScheduleTransportationUpdate) {
                modalService.showYesNo('Warning', 'Changing certain appointment details may result in your date or time no longer being available.<br/>If you have questions, please contact us.<br/><br/>Are you sure you want to continue with these changes?', 'YES', 'NO');
                vm.needsScheduleTransportationUpdate = true;
            }
        };
    }

})();

(function () {
    'use strict';

    AppointmentListController.$inject = ["$q", "$rootScope", "$scope", "$filter", "$state", "$timeout", "$transition$", "permissions", "SYSTEM_ENUMS", "APPOINTMENT_APPOINTMENTSTATUS", "APPOINTMENT_CUSTOMERTYPE", "APPOINTMENT_TRANSPORTATION_TYPE_GROUP", "HERE_MAPS_CONFIG", "SAVED_SEARCHES_PLACEHOLDER", "APPOINTMENT_TRANSPORTATION_TYPE", "appointmentUtilService", "appointmentService", "locationService", "tripService", "customerService", "resolvedAppointmentStatuses", "rcLocalStorageService", "rcUtilService", "resolvedLocation", "resolvedLocationTransportationTypes", "hasAccess", "resolvedDepartments", "searchTemplateUtilService", "systemService", "modalService", "vehicleService", "resolvedMobileGarageMarketingContent", "typeaheadSelectionService"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentListController', AppointmentListController);


    function AppointmentListController($q, $rootScope, $scope, $filter, $state, $timeout, $transition$, permissions, SYSTEM_ENUMS, APPOINTMENT_APPOINTMENTSTATUS, APPOINTMENT_CUSTOMERTYPE, APPOINTMENT_TRANSPORTATION_TYPE_GROUP,
        HERE_MAPS_CONFIG, SAVED_SEARCHES_PLACEHOLDER, APPOINTMENT_TRANSPORTATION_TYPE, appointmentUtilService, appointmentService, locationService, tripService, customerService, 
        resolvedAppointmentStatuses, rcLocalStorageService, rcUtilService, resolvedLocation, resolvedLocationTransportationTypes, hasAccess, resolvedDepartments, searchTemplateUtilService, systemService, modalService, vehicleService, resolvedMobileGarageMarketingContent, typeaheadSelectionService) {
        let vm = this;
        let _searchToday = moment(new Date()).format('DD/MM/YYYY');
        let _date = new Date();
        let _configId = parseInt($transition$.params().configId);
        let _transitionMode = parseInt($transition$.params().mode);
        let _defaultDisplayMode = _transitionMode || 1;
        let _allDepartmentsOption = {id: -1, name: 'All'};
        let _map = null;
        let _resolvedDealerId = resolvedLocation?.id;
        let _resolvedDepartments = resolvedDepartments;
        let _apptStatusEnum = APPOINTMENT_APPOINTMENTSTATUS;
        let _customerType = APPOINTMENT_CUSTOMERTYPE;
        let _hasCheckin = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.checkIn);
        let _listPath = $state.name;
        let _hasActionableAppt = false;
        let _listPageSize = 50;
        let _typeAheadSearchRequestId = 0;
        
        let _unassignedTech = {
            id: null,
            name: 'Unassigned',
            userName: null,
            isAvailable: true,
            isDedicated: false,
            isPreferred: false,
            isDnsVetted: false
        };

        let _timeFrameEnum = {
            today: 0,
            next7Days: 1,
            next30Days: 2,
            tomorrow: 6,
            last7Days: 4,
            last30Days: 5,
            custom: 3,
            allFutureDates: 11,
            next60Days: 9,
            last60Days: 10
        };

        let _initialFilters = { 
            showServicesColumn: false,
            selectedStatusFilter: null,
            selectedAdvisorsFilter: [],
            searchDate: moment(new Date()),
            pickupDropoff: null,
            selectedTypeFilter: null,
            searchMode: _defaultDisplayMode,
            filterByTimeFrame: _timeFrameEnum.today,
            filterByCustomTimeframe: {startDate: moment(), endDate: moment()},
            selectedDepartment: null,
            selectedLocation: null,
            currentTimeZone: null,
            locationDepartments: null,
            serviceAdvisors: null,
            pickUpTransportationTypes: null,
            dropOffTransportationTypes: null,
        };
      
        vm.dataInitialized = false;
        vm.maxServicesToShow = 4;
        vm.transportationTypes = resolvedLocationTransportationTypes;
        vm.disabledFilterMsg = 'Please select a Location and Department<br/> to use advanced filters.';
        vm.hasAccess = hasAccess;
        vm.classicSortColumns = ['Customer', 'Contact', 'Appointment', 'Status', 'Type', 'Booked'];
        vm.mobileMarketingContent =  resolvedMobileGarageMarketingContent;
        vm.loadingLocation = false;
        vm.noResultsText = "<strong><br /><br />No Results Found</strong>";
        vm.errorText = "<strong><br /><br />An Error Has Occurred</strong>";
        vm.closedText = "<strong><br /><br />Closed </strong>";
        vm.selectLocText = "<strong><br /><br />Please Select A Location</strong>";
        vm.selectDeptText = "<strong><br /><br />Please Select A Department</strong>";
        vm.locNotConfigured = "<strong><br /><br />The selected location has not been configured for appointments.  Please contact your account administrator.</strong>";
        vm.showMobileGarageMarketingContent = false;
        vm.showAdvancedSearch = false;
        searchTemplateUtilService.initSearchTemplateData(vm);
        vm.mobileGarageDepartments = [];
        vm.mobileTechnicians = null;
        vm.showVinError = false;
        vm.currentTooltipBlock = null;
        vm.appointmentCount = null;
        vm.apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
     
        vm.mapOptions = {
            showSegmentOverlay: true,
            fillHeight: true,
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            useImagesInPin: true,
            showActualRoute: true,
            showControls: true,
            showInfoWindows: true,
            forceHideRecenter: true
        };

        vm.selectableViewModes = [
            {value: 1, icon: 'today', text: 'Daily', tooltip: 'Calendar List View', hideFramedIn: false},
            {value: 5, icon: 'list', text: 'List', tooltip: 'Sortable List View', hideFramedIn: false},
            {value: 6, icon: 'local_shipping', text: 'Mobile', tooltip: 'Mobile Service List View', hideFramedIn: false}
        ];

        function getCurrentSuffix () {
            vm.suffix = appointmentUtilService.getProductSuffix(_listPath);
            vm.activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
        }

        function showMobileGarageMarketingContent () {
            vm.showMobileGarageMarketingContent = true;
        }

        getCurrentSuffix();

        let savedFilterKey = "tripsListSavedFilterKey" + vm.suffix;
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};

        vm.statuses = resolvedAppointmentStatuses.filter(o => o.code !== APPOINTMENT_APPOINTMENTSTATUS.draft);
        vm.searchError = false;
        vm.isClosed = false;
        vm.authHistoryStatuses = SYSTEM_ENUMS.appointmentAuthorizationStatus;
        vm.authHistoryStatusEnum = SYSTEM_ENUMS.appointmentAuthorizationStatusEnum;
        vm.transTypeGroups = APPOINTMENT_TRANSPORTATION_TYPE_GROUP;

        vm.cachedCancellationReasons = {
            locationId: null,
            tripTypeId: null,
            reasons: null
        };

        vm.actions = {
            cancel: '1',
            checkIn: '2',
            arrive: '3',
            noShow: '4'
        };

        vm.searchModes = {
            classic: 1,
            byCustomer: 2,
            byTime: 3,
            authorizations: 4,
            sortable: 5,
            mobileGarage: 6
        };

        vm.searchResults = [];
        vm.currentPage = 1;
        vm.pageSize = _listPageSize;
        vm.canLoadMore = false;
        vm.isLoadingMore = false;
        vm.lastListSearch = null;
        vm.selectedTypeAheadAppt = [];
        vm.typeAheadApptMap = {};
        vm.typeAheadSearchQuery = '';

        vm.timeframes = [
            {value: _timeFrameEnum.last60Days,   text: 'Last 60 days'},
            {value: _timeFrameEnum.last30Days, text: 'Last 30 days'},
            {value: _timeFrameEnum.last7Days,  text: 'Last 7 days'},
            {value: _timeFrameEnum.today,      text: 'Today'},
            {value: _timeFrameEnum.tomorrow,   text: 'Tomorrow'},
            {value: _timeFrameEnum.next7Days,  text: 'Next 7 days'},
            {value: _timeFrameEnum.next30Days, text: 'Next 30 days'},
            {value: _timeFrameEnum.next60Days,   text: 'Next 60 days'},
            {value: _timeFrameEnum.allFutureDates, text: 'All future dates'},
            {value: _timeFrameEnum.custom,     text: 'Custom'}
        ];

        vm.dateRangePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { vm.customTimeFrameChanged(); }
            }
        };

        // initialize the filters
        if (existingFilters) {
            vm.filters = _.extend({}, _initialFilters, existingFilters);
        } else {
            vm.filters = _initialFilters;
            vm.filters.filterByTimeFrame = _timeFrameEnum.today;
        }
       
        setSearchModeDropdownIcon();
       
        if (vm.filters.filterByTimeFrame === _timeFrameEnum.custom && vm.filters.filterByCustomTimeframe) {
            if (vm.filters.filterByCustomTimeframe.startDate && !moment.isMoment(vm.filters.filterByCustomTimeframe.startDate)) {
                vm.filters.filterByCustomTimeframe.startDate = moment(vm.filters.filterByCustomTimeframe.startDate);
            }

            if (vm.filters.filterByCustomTimeframe.endDate && !moment.isMoment(vm.filters.filterByCustomTimeframe.endDate)) {
                vm.filters.filterByCustomTimeframe.endDate = moment(vm.filters.filterByCustomTimeframe.endDate);
            }
        }

        
        vm.advisorFilterEvents = {
            onSelectionChanged: function () {
                vm.appointmentFilterChanged();
            }
        };

        vm.advisorFilterSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            idProp: 'id',
            displayProp: 'label',
            buttonClasses: 'ellipsis-overflow'
        };

        vm.advisorDropdownLabels = {
            buttonDefaultText: 'All advisors'
        };

        if (vm.filters.searchDate) {
            _date = vm.filters.searchDate;
        }

        vm.calendarDate = moment(_date).format('YYYY-MM-DD');

        vm.isListInMode = function (mode) {
            return _listPath.indexOf(mode) !== -1;
        };

        function isMobileView() {
            return window.innerWidth <= 780;
        }

        function searchForActionableAppointments(appointments) {
            if (!appointments) return;

            appointments.forEach((appt) => {
                if (appt.canCancel === true || appt.canCheckIn === true || appt.canArrive === true) {
                    _hasActionableAppt = true;
                }
            });
        }

        function getApptEndTime (appt) {
            // promiseDateTime for Mobile Garage is being saved as the apptDateTime + estimatedLaborDuration
            appt.estimatedEndDateTime = new Date(moment.tz(appt.promiseDateTime, appt.dealerTimezonId).format("YYYY-MM-DDTHH:mm:ss"));
        }

        vm.showActionColumn = function () {
            return _hasActionableAppt;
        };

        vm.hasDropDown = function (appts) {
            let today = moment(new Date());

            if (!appts) return false;
            
            return appts.some((appt) =>
                (!moment(vm.filters.searchDate).isBefore(today, 'day') && appt.canCancel === true)
                || appt.canCheckIn
                || appt.canArrive
            );
        };

        vm.isSearchToday = function () {
            let checkDate = moment(vm.filters.searchDate).format('DD/MM/YYYY');

            return _searchToday === checkDate;
        };

        vm.todayClicked = function () {
            vm.filters.searchDate = moment(new Date());
			vm.calendarDate = moment(vm.filters.searchDate).format('YYYY-MM-DD');
            vm.appointmentFilterChanged();
        };

        vm.showCancelOption = function (appt) {
            return appt.canCancel === true;
        };

        vm.showNoShowOption = function (appt) {
            return appt.canCancel === true;
        };

        vm.showCheckInOption = function (appt) {
            return !(vm.dealerHasCheckin && !_hasCheckin) && appt.canCheckIn === true;
        };

        vm.showArriveOption = function (appt) {
            return !(vm.dealerHasCheckin && !_hasCheckin) && appt.canArrive === true;
        };

        vm.showCancelDlg = function (appt, reasons) {
            let cancelResult = modalService.showAppointmentCancel(reasons, appt);

            cancelResult.then((results) => {
                if (results) {
                    let cancellationReason = results.cancellationReason === 'Other' ? results.otherDescription : !results.otherDescription || results.otherDescription.length === 0  ? results.cancellationReason : results.cancellationReason + ' - ' + results.otherDescription;

                    vm.cancellingAppt = true;

                    appointmentService.cancelAppointment(vm.filters.selectedLocation.id, appt, cancellationReason, results.notifyCustomer).then((result) => {
                        vm.cancellingAppt = false;

                        if (result && result.errors && result.errors.length > 0) {
                            modalService.showError('Sorry, there was a problem canceling your appointment:', result.errors);
                        }
                    }, (errorResponse) => {
                        vm.cancellingAppt = false;
                    });

                } else {
                    vm.cancellingAppt = false;
                }
            });
        };

        function cancelAppt(appt) {
            let selectedLocationId = vm.filters.selectedLocation.id;

            let performCancel = function () {
                let isPickup = vm.filters.pickUpTransportationTypes.filter((transportationType) => transportationType.id === appt.dealerTransportationTypeId);
                let availReasons = vm.cachedCancellationReasons.reasons;
                let reasons = null;

                if (isPickup && isPickup.length > 0) {
                    reasons = availReasons.tripCancelReasons;
                } else {
                    reasons = availReasons.apptCancelReasons;
                }

                vm.showCancelDlg(appt, reasons);
            };

            modalService.showYesNo('Confirm Cancel', 'Are you sure you want to cancel this appointment?', 'No', 'Yes', true).then((confirmed) => {
                if (confirmed) {
                    if (vm.cachedCancellationReasons.locationId !== selectedLocationId) {
                        locationService.getLocationTripTypeInstances(selectedLocationId).then((tripTypes) => {
                            vm.cachedCancellationReasons.tripTypeId = tripTypes.find((tripType) => tripType.systemTripTypeId === 1 && tripType.isDefault === true).id;
                            appointmentService.getCancellationReasons(selectedLocationId, vm.cachedCancellationReasons.tripTypeId).then((reasons) => {
                                vm.cachedCancellationReasons.locationId = selectedLocationId;
                                vm.cachedCancellationReasons.reasons = reasons;
                                performCancel();
                            });
                        });
                    } else {
                        performCancel();
                    }
                }

                appt.selectedAction = null;
            });
        }

        vm.addAppointment = function () {
            $state.go('appointment-add' + vm.suffix);
        };

        vm.gotoCheckIn = function (appt) {
            $state.go('appointment-checkin' + vm.suffix, {
                locationId: appt.dealerId,
                customerId: appt.customerId,
                appointmentId: appt.id,
                configId: _configId
            });
        };

        function arriveAppt(appt) {
            if (vm.dealerHasCheckin && _hasCheckin) {
                const modalResult = modalService.arriveAppointment(appt, vm.filters.locationDepartments);

                modalResult.then((formData) => {
                    if (formData && formData.cancelled !== true) {
                        $rootScope.$broadcast('AppointmentList.changed', formData);
                    }

                    appt.selectedAction = null;
                });

            } else if (!vm.dealerHasCheckin) {
                vm.updatingAppt = true;
                appointmentService.arriveAppointment(vm.filters.selectedLocation.id, appt.id).then((result) => {
                    vm.updatingAppt = false;
                    appt.selectedAction = null;
                }, (errorResponse) => {
                    vm.updatingAppt = false;
                    appt.selectedAction = null;
                });
            }
        }

        function checkInAppt(appt) {
            if (vm.dealerHasCheckin && _hasCheckin) {
                vm.gotoCheckIn(appt);
            } else if (!vm.dealerHasCheckin) {
                vm.updatingAppt = true;
                appointmentService.checkInAppointment(vm.filters.selectedLocation.id, appt.id).then((result) => {
                    vm.updatingAppt = false;
                }, (errorResponse) => {
                    vm.updatingAppt = false;
                });
            }
        }

        function noShowAppt(appt) {
            appt.selectedAction = null;
            let modalResult = modalService.showAppointmentNoShow(appt);

            modalResult.then((results) => {
                if (results) {
                    vm.updatingAppt = true;
                    appointmentService.setAppointmentStatus(vm.filters.selectedLocation.id, appt.id, APPOINTMENT_APPOINTMENTSTATUS.noShow, results.notifyCustomer).then((result) => {
                        vm.updatingAppt = false;
                    }, (errorResponse) => {
                        vm.updatingAppt = false;
                    });
                } else {
                    vm.updatingAppt = false;
                }
            });
        }

        vm.actionSelected = function (appt) {
            switch (appt.selectedAction) {
                case vm.actions.cancel:
                    cancelAppt(appt);
                    break;
                case vm.actions.checkIn:
                    checkInAppt(appt);
                    break;
                case vm.actions.arrive:
                    arriveAppt(appt);
                    break;
                case vm.actions.noShow:
                    noShowAppt(appt);
                    break;
            }
        };

        vm.prevDayClicked = function () {
            if (!vm.searchingAppointments) {
                vm.filters.searchDate = moment(vm.filters.searchDate.subtract(1, "days").toDate());
                vm.calendarDate = moment(vm.filters.searchDate).format('YYYY-MM-DD');
            }
        };

        vm.nextDayClicked = function () {
            if (!vm.searchingAppointments) {
                vm.filters.searchDate = moment(vm.filters.searchDate.add(1, "days").toDate());
                vm.calendarDate = moment(vm.filters.searchDate).format('YYYY-MM-DD');
            }
        };

        vm.dateChanged = function (newValue, oldValue) {
            if (vm.filters.searchDate._i !== newValue._i) {
                vm.filters.searchDate = newValue;
				vm.calendarDate = moment(vm.filters.searchDate).format('YYYY-MM-DD');
                vm.appointmentFilterChanged();
            }
        };

        vm.isLocationConfigured = function () {
            return vm.loadingLocation === true || (vm.filters.locationDepartments && vm.filters.locationDepartments.length > 0);
        };

        function setDepatmentTripTypes() {
            if (vm.filters.selectedDepartment) {
                let deptIds = vm.filters.selectedDepartment == -1 ? vm.filters.locationDepartments.map(item => item.id) : [vm.filters.selectedDepartment];
               
                vm.filters.dropOffTransportationTypes = vm.transportationTypes.filter((item) => {
                                                                    return item.isDropOff === true && deptIds.includes(item.dealerDepartmentId);
                                                                });
                vm.filters.pickUpTransportationTypes = vm.transportationTypes.filter((item) => {
                                                                    return item.isPickup === true && deptIds.includes(item.dealerDepartmentId);
                                                                });
                vm.mobileTransportationTypes = vm.transportationTypes.filter((item) => {
                                                                    return item.isMobileGarage === true && deptIds.includes(item.dealerDepartmentId);
                                                                });
            } else {
                vm.filters.dropOffTransportationTypes = null;
                vm.filters.pickUpTransportationTypes = null;
                vm.mobileTransportationTypes = null;
            }
        }

        vm.setSelectedDepartment = function (departmentId, loadingTemplate) {
            let depts = vm.filters.locationDepartments.filter((department) => department.id === departmentId);
            
            vm.filters.selectedDepartment = _allDepartmentsOption.id;

            // verify this department belongs to this delaer
            if (depts && depts.length > 0) {
                vm.filters.selectedDepartment = departmentId;
            }
            
            setDepatmentTripTypes();
            saveFilterSettings();
            loadDepartmentAdvisors(loadingTemplate);

            if (!loadingTemplate && !vm.showAdvancedSearch) {
                vm.appointmentFilterChanged();
            } 
        };

        vm.loadMobileTechs = function () {
            if (vm.mobileTechnicians) return;
            tripService.getMobileTechnicians(vm.filters.selectedLocation.id).then((response) => {
                response.unshift(_unassignedTech);
                vm.mobileTechnicians = response;
            }, (errorResponse) => {
                console.log('Error loading mobile technicians.');
            });
        };

        function postLocationDepartmentLoad (locationDepartmentsResults, loadingTemplate, templateDepartmentId) {
            let searchModes = vm.searchModes;

            if ((vm.isCheckInView() || vm.filters.searchMode === vm.searchModes.sortable) && (!vm.isAdminUser && !vm.filters.selectedLocation)) {
                locationDepartmentsResults.unshift(_allDepartmentsOption);
            }
            
            vm.mobileGarageDepartments = [];
            vm.filters.locationDepartments = locationDepartmentsResults;
                
            if (vm.filters.searchMode === searchModes.mobileGarage && vm.mobileGarageDepartments.length === 0) {
                vm.filterMobileGarageDepartments();
                vm.loadMobileTechs();
            }

            if (loadingTemplate) {
                vm.setSelectedDepartment(templateDepartmentId, true);
            } else if (vm.filters.locationDepartments.length === 1 && vm.filters.searchMode === searchModes.classic) {
                vm.setSelectedDepartment(vm.filters.locationDepartments[0].id);
            } else {
                let savedDepartmentId = vm.filters.selectedDepartment;
                let deptList = vm.filters.searchMode == searchModes.mobileGarage ? vm.mobileGarageDepartments : vm.filters.locationDepartments;
                let firstDept = deptList.find(d => d.id > 0);

                if (vm.filters.searchMode === searchModes.classic || vm.filters.searchMode === searchModes.mobileGarage) {
                    let selectedDepartment = savedDepartmentId > 0 ? deptList.find(d => d.id === savedDepartmentId) : null;
                   
                    if (selectedDepartment) {
                        vm.setSelectedDepartment(savedDepartmentId);
                    } else if (firstDept) {
                        vm.setSelectedDepartment(firstDept.id);
                    }
                } else if (savedDepartmentId && (savedDepartmentId > 0 || savedDepartmentId === -1)) {
                    let selectedDepartment = savedDepartmentId > 0 ? vm.filters.locationDepartments.find(d => d.id === savedDepartmentId) : null;
                   
                    vm.setSelectedDepartment(selectedDepartment ? savedDepartmentId : (firstDept ? firstDept.id : vm.filters.locationDepartments[0].id));
                } else {
                    if (firstDept) {
                        vm.setSelectedDepartment(firstDept.id);
                    } else if (vm.filters.locationDepartments && vm.filters.locationDepartments.length > 0) {
                        vm.setSelectedDepartment(vm.filters.locationDepartments[0].id);
                    }
                }
            }

            if (!vm.showAdvancedSearch) {
                vm.currentAppointmentSlots = null;
            }

            if (vm.isCheckInView() && vm.filters.searchMode !== searchModes.byCustomer && vm.filters.searchMode !== searchModes.byTime) {
                vm.filters.searchMode = searchModes.byCustomer;                
            }

            rcLocalStorageService.set('selectedAppointmentDisplayMode' + vm.suffix, vm.filters.searchMode);
            vm.loadingLocation = false;
            setSearchModeDropdownIcon();
            loadSearchTemplates();
        }

        function addApptAdvisorToList(listAddingTo, apptToAddFrom) {
            listAddingTo.push({
                departmentIds: null,
                employeeNumber: apptToAddFrom.serviceAdvisorNumber,
                firstName: apptToAddFrom.dealerEmployeeFirstName,
                id: apptToAddFrom.dealerEmployeeId,
                lastName: apptToAddFrom.dealerEmployeeLastName,
                label: (apptToAddFrom.dealerEmployeeFirstName || '') + ' ' + (apptToAddFrom.dealerEmployeeLastName || '')
            });
        }

        vm.filterMobileGarageDepartments = function () {
            vm.mobileGarageDepartments = [];
            vm.filters.locationDepartments.forEach((dept) => {
                let mobileTransType = vm.transportationTypes.filter((transportationType) => transportationType.dealerSystemTransportationTypeId === vm.apptTransportationTypes.mobileGarage && transportationType.dealerDepartmentId === dept.id && transportationType.showInDashboard === true);

                if (mobileTransType && mobileTransType.length > 0) {
                    vm.mobileGarageDepartments.push(dept);
                }
            });
        };

        function loadDepartmentAdvisors(loadingTemplate) {
            if (vm.filters.selectedLocation?.id && vm.filters.selectedDepartment) {
                vm.loadingAdvisors = true;
                locationService.getLocationDepartmentAvailAdvisor(vm.filters.selectedLocation.id, vm.filters.selectedDepartment, false).
                    then((result) => {
                        vm.filters.selectedAdvisorsFilter = [];
                        vm.filters.serviceAdvisors = result.advisors.map((sa) => {
                            return {
                                id: sa.id,
                                label: (sa.firstName || '') + ' ' + (sa.lastName || '')
                            };
                        });

                        if (loadingTemplate) {
                            finishLoadingTemplateAfterDepartmentsLoaded();
                        } else if (!vm.showAdvancedSearch) {
                            createFilterMessage();
                        }

                        vm.loadingAdvisors = false;
                    });
            } else {
                vm.filters.serviceAdvisors = null;
            }
        }

        vm.getLocationPermissions = function () {
            if (vm.filters.selectedLocation) {
                appointmentService.getAccessAndBookingConfig(vm.filters.selectedLocation.id).then((response) => {
                    vm.dealerHasCheckin = response.hasCheckIn;
                });
            } else {
                vm.dealerHasCheckin = false;
            }
        };

        vm.showCheckInSkipped = function (data) {
            return data.appointmentStatus === _apptStatusEnum.repairOrderCreated && data.isCheckinSkipped === true;
        };
        
        vm.getApptStatusTopLabel = function (data) {
            let label = appointmentService.getAppointmentStatusLabel(data, vm.statuses);
            let parts = label.split('(');

            return parts[0];
        };

        vm.getApptStatusBottomLabel = function (data) {
            let label = appointmentService.getAppointmentStatusLabel(data, vm.statuses);
            let parts = label.split('(');
            let bottom = null;

            if (parts.length > 1) {
                bottom = parts[1].split(')')[0];
            }

            return bottom;
        };

        vm.getLinesCountText = function (data) {
            let text = "(<span class='theme-link'>" + data.opCodes.length +  " line";

            if (data.opCodes.length > 1) {
                text += "s";
            }

            text += "</span>)";

            return text;
        };

        vm.getServicesToolTip = function (appt) {
            if (appt.tooltip) {
                return appt.tooltip;
            } else {
                $timeout(() => {
                    if (appt.isHovered && !appt.gettingTooltip && !appt.tooltip) {
                        appt.gettingTooltip = true;
                        appointmentService.getLineItemTooltip(appt.dealerId, appt.id).then((result) => {
                            appt.tooltip = {
                                lineItems: result
                            };
                            appt.gettingTooltip = false;
                        }, (errorResponse) => {
                            appt.gettingTooltip = false;
                        });
                    }
                }, 250);

                return "Loading Services ...";
            }
        };

        vm.isCanceled = function (data) {
            return data.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.canceled;
        };

        vm.getMobileTripType = function (data) {
            let dropOffs = vm.filters.dropOffTransportationTypes;
            let pickUps = vm.filters.pickUpTransportationTypes;
            let transportationType;
            let strLabel = "";
            let transType = data.dealerTransportationTypeId;

            transportationType = dropOffs.filter((transportationTypeItem) => transportationTypeItem.id === transType);

            if (transportationType && transportationType.length > 0) {
                strLabel += "DROP OFF";
            } else {
                transportationType = pickUps.filter((transportationTypeItem) => transportationTypeItem.id === transType);

                if (transportationType && transportationType.length > 0) {
                    strLabel += "PICK UP";
                }
            }

            return strLabel;
        };

        vm.getTransportationTypeLabel = function (data) {
            let dropOffs = vm.transportationTypes.filter((transportationType) => transportationType.isDropOff === true);
            let pickUps = vm.transportationTypes.filter((transportationType) => transportationType.isPickup === true);
            let mobile = vm.mobileTransportationTypes || vm.transportationTypes;
            let transportationType;
            let strLabel = "";
            let transType = data.dealerTransportationTypeId;

            transportationType = dropOffs.filter((transportationTypeItem) => transportationTypeItem.id === transType);

            if (transportationType && transportationType.length > 0) {
                strLabel += "<span>CUSTOMER DROP OFF</span><Br/>";
                strLabel += "<span>" + transportationType[0].dashboardDescription + "</span>";
            } else {
                transportationType = pickUps.filter((transportationTypeItem) => transportationTypeItem.id === transType);

                if (transportationType && transportationType.length > 0) {
                    strLabel += "<span>PICK UP (" + moment(data.pickUpTripArrivalTime).format("LT") + ")</span><Br/>";
                    strLabel += "<span>" + transportationType[0].dashboardDescription + "</span>";
                } else  {
                    transportationType = mobile.filter((transportationTypeItem) => transportationTypeItem.id === transType);

                    if (transportationType && transportationType.length > 0) {
                        strLabel += "<span>MOBILE SERVICE</span><Br/>";
                    }
                }
            }

            return strLabel;
        };

        vm.setApptHover = function (appt, hovered) {
            appt.isHovered = hovered;

            let markerItem = angular.element('#marker-' + appt.id);

            if (hovered) {
                if (!appt.tooltip || appt.gettingTooltip) {
                    vm.currentTooltipBlock = appt;
                    vm.getServicesToolTip(appt);
                } else {
                    vm.currentTooltipBlock = appt;
                }

                markerItem.addClass('highlighted');
            } else {
                markerItem.removeClass('highlighted');
            }
        };

        function performClassicCalendarSearch (selectedLocation, selectedDepartment, advisors, date, searchTerm, selectedStatus, selectedTypes) {
            appointmentService.searchAppointments(selectedLocation, selectedDepartment, advisors, date, searchTerm, selectedStatus, selectedTypes, vm.filters.showServicesColumn).then((response) => {
                vm.searchError = false;
                _hasActionableAppt = false;
                vm.appointmentCount = 0;

                if (response && response.timeSlotBlocks) {
                    vm.currentAppointmentSlots = response.timeSlotBlocks;
                    vm.isClosed = !response.hoursOfOperation.isOpen;
                    response.timeSlotBlocks.forEach((slot) => {
                        slot.appointments.forEach((appt) => {
                            vm.appointmentCount++;
                            const opCodeCount = vm.filters.showServicesColumn && !vm.showCheckInSkipped(appt)
                                ? (appt.servicesBreakdowns?.length || 0)
                                : 0;

                            let cssClass = 'min-height-px-50';

                            if (vm.filters.showServicesColumn) {
                                switch (opCodeCount) {
                                    case 0:
                                        cssClass = 'min-height-px-50';
                                        break;
                                    case 1:
                                        cssClass = 'min-height-px-50';
                                        break;
                                    case 2:
                                        cssClass = 'min-height-px-80';
                                        break;
                                    case 3:
                                        cssClass = 'min-height-px-110';
                                        break;
                                    case 4: 
                                        cssClass = 'min-height-px-140';
                                        break;
                                    default:
                                        cssClass = 'min-height-px-170';
                                        break;
                                }
                            }

                            appt.cssClass = cssClass;
                            
                            if (vm.filters.serviceAdvisors && appt.dealerEmployeeId && !vm.filters.serviceAdvisors.some(advisor => advisor.id === appt.dealerEmployeeId)) {
                                addApptAdvisorToList(vm.filters.serviceAdvisors, appt);
                            }

                        });

                        searchForActionableAppointments(slot.appointments);
                    });
                }

                vm.searchingAppointments = false;

                if (response && response.status === 500) {
                    vm.searchError = true;
                    vm.currentAppointmentSlots = [];
                }
            }, () => {
                vm.searchError = true;
                vm.searchingAppointments = false;
                vm.currentAppointmentSlots = [];
            });
        }

        vm.isAdvisorUnmapped = function (appt) {
            return appointmentUtilService.isAdvisorUnmapped(appt);
        };

        vm.frontEndSort = function (appt) {
            if (!isMobileView()) {
                return;
            }

            let mode = vm.filters.searchMode;

            if (mode === vm.searchModes.byCustomer) {
                if (appt.customerType === _customerType.business) {
                    return appt.customerLastName;
                } else {
                    return appt.customerFirstName;
                }
            } else if (mode === vm.searchModes.byTime) {
                return appt.apptDateTime;
            }
        };

        function performAppointmentSearch(selectedLocation, selectedDepartment, advisors, startDate, endDate, searchTerm, selectedStatus, selectedTypes, sortAlpha, sortDate, timeFrame, timeZone) {
            vm.currentAppointmentSlots = null;
            vm.currentPage = 1;
            
            let deptId = selectedDepartment ? selectedDepartment : null;
          
            appointmentService.searchAppointmentsSpecial(
                selectedLocation,
                deptId,
                advisors,
                startDate,
                endDate,
                searchTerm,
                selectedStatus,
                selectedTypes,
                vm.sort.sortBy,
                vm.sort.sortDirection,
                timeFrame,
                timeZone,
                vm.currentPage,
                vm.pageSize
            ).then((response) => {
                    let results = response;

                    vm.searchError = false;
                    _hasActionableAppt = false;
                    vm.searchResults = results;
                    vm.appointmentCount = vm.searchResults.length;
                    vm.canLoadMore = results && results.length === vm.pageSize;
                   
                    searchForActionableAppointments(vm.searchResults);

                    if (response && response.status === 500) {
                        vm.searchError = true;
                        vm.currentAppointmentSlots = [];
                        vm.searchResults = [];
                        vm.canLoadMore = false;
                    }

                    vm.searchingAppointments = false;
                    
                }, () => {
                    vm.searchError = true;
                    vm.currentAppointmentSlots = [];
                    vm.searchResults = [];
                    vm.canLoadMore = false;
                }).finally(() => {
                    vm.searchingAppointments = false;
                });
        }

        vm.pagedSearch = function () {
            if (!vm.lastListSearch || vm.searchingAppointments || vm.isLoadingMore || !vm.canLoadMore) {
                return;
            }

            vm.isLoadingMore = true;

            let nextPage = vm.currentPage + 1;
          
            appointmentService.searchAppointmentsSpecial(
                vm.lastListSearch.selectedLocation,
                vm.lastListSearch.selectedDepartment,
                vm.lastListSearch.advisors,
                vm.lastListSearch.startDate,
                vm.lastListSearch.endDate,
                vm.lastListSearch.searchTerm,
                vm.lastListSearch.selectedStatus,
                vm.lastListSearch.selectedTypes,
                vm.sort.sortBy,
                vm.sort.sortDirection,
                vm.lastListSearch.timeFrame,
                vm.lastListSearch.timeZone,
                nextPage,
                vm.pageSize
            ).then((response) => {
                let results = response;

                if (!results.length) {
                    vm.canLoadMore = false;

                    return;
                }

                vm.currentPage = nextPage;
                vm.searchResults = vm.searchResults.concat(results);
                vm.appointmentCount = vm.searchResults.length;
                vm.canLoadMore = results.length === vm.pageSize;
                searchForActionableAppointments(results);
                vm.searchError = false;
            }, () => {
                vm.canLoadMore = false;
            }).finally(() => {
                vm.isLoadingMore = false;
            });
        };

        vm.mapLoaded = function (mapActions) {
            _map = mapActions;
        };

        function addCustomerToMarkerCollection(appt) {
            if (appt.customerStop) {
                let newEntry = _.cloneDeep(appt.customerStop);

                newEntry.listItemId = appt.id;
                vm.tappableMarkers.push(newEntry);
            }
        }

        function performMobileGarageSearch(selectedLocation, selectedDepartment, advisors, date, searchTerm, selectedStatus, selectedTypes) {
            vm.tappableMarkers = [];
           
            appointmentService.searchAppointments(selectedLocation, selectedDepartment, advisors, date, searchTerm, selectedStatus, selectedTypes, true).then((response) => {
                vm.searchError = false;
                _hasActionableAppt = false;
                vm.searchingAppointments = false;
                vm.appointmentCount = 0;

                // keep this list separate from the filter in case there are
                // advisors w/out appointments, we don't want to show them in the list
                if (response && response.timeSlotBlocks) {
                    vm.appointmentInterval = response.appointmentIntervalInMinutes;
                    vm.currentAppointmentSlots = response.timeSlotBlocks;
                    vm.isClosed = !response.hoursOfOperation.isOpen;
                    response.timeSlotBlocks.forEach((slot) => {
                        slot.appointments.forEach((appt) => {
                            vm.appointmentCount++;
                            
                            getApptEndTime(appt);

                            getMGApptCardHeight(appt);

                            addCustomerToMarkerCollection(appt);
                            
                            if (vm.filters.serviceAdvisors && appt.dealerEmployeeId && !vm.filters.serviceAdvisors.find(advisor => advisor.id === appt.dealerEmployeeId)) {
                                addApptAdvisorToList(vm.filters.serviceAdvisors, appt);
                            }
                                
                        });
                    });

                    if (vm.tappableMarkers && vm.tappableMarkers.length > 0) _map.setCenter({lat: vm.tappableMarkers[0].lat, lng: vm.tappableMarkers[0].lng});
                    _map.addTappableMarkers(vm.tappableMarkers, HERE_MAPS_CONFIG.markerTypes.customer, "appointment-mobile-garage-table");
                }

                $timeout(() => {
                    setMGUpdateScrollableArea();
                }, 750);

                if (response && response.status === 500) {
                    vm.searchError = true;
                    vm.currentAppointmentSlots = [];
                }
            }, (errorResponse) => {
                console.log('Error searching appointments: ', errorResponse);
                vm.searchError = true;
                vm.searchingAppointments = false;
                vm.currentAppointmentSlots = [];
            });
        }

        vm.openVinScan = function () {
            modalService.showVinScanModal().then((scannedVin) => {
                vm.searchApptsByVin(scannedVin);
            });
        };

        function searchAppointments() {
            if (vm.showAdvancedSearch) return;

            let selectedLocation = vm.filters.selectedLocation;
            let selectedDepartment = vm.filters.selectedDepartment;
            let selectedStatus = vm.filters.selectedStatusFilter;
            let selectedTypes = null;
            let searchTerm = vm.searchInput;
            let advisors = vm.filters.selectedAdvisorsFilter ? vm.filters.selectedAdvisorsFilter.map((sa) => { return sa.id; }) : null;
            let pickupDropOffTypes = null;
            let timeFrameDate = setDates();
            let startDate = timeFrameDate.startDate;
            let endDate = timeFrameDate.endDate;
            let transTypeGroups = vm.transTypeGroups;

            if (vm.filters.searchMode === vm.searchModes.mobileGarage) {
                pickupDropOffTypes = vm.mobileTransportationTypes;
            } else if (!vm.filters.selectedTypeFilter && vm.filters.pickupDropoff === transTypeGroups.pickup) {
                pickupDropOffTypes = vm.filters.pickUpTransportationTypes;
            } else if (!vm.filters.selectedTypeFilter && vm.filters.pickupDropoff === transTypeGroups.dropoff) {
                pickupDropOffTypes = vm.filters.dropOffTransportationTypes;
            } else if (!vm.filters.selectedTypeFilter && vm.filters.pickupDropoff === transTypeGroups.mobile) {
                pickupDropOffTypes = vm.mobileTransportationTypes;
            } else if (vm.filters.selectedTypeFilter) {
                selectedTypes = [vm.filters.selectedTypeFilter];
            }

            if (pickupDropOffTypes) {
                selectedTypes = [];
                pickupDropOffTypes.forEach((type) => {
                    selectedTypes.push(type.id);
                });
            }
            
            createFilterMessage();
            vm.searchingAppointments = true;
            vm.filters.currentTimeZone = moment.tz.guess();

            if (selectedLocation || (!vm.isAdminUser && vm.filters.searchMode !== vm.searchModes.classic && vm.filters.searchMode !== vm.searchModes.mobileGarage)) {
                let date = moment(new Date());

                if (vm.filters.searchMode === vm.searchModes.classic || vm.filters.searchMode === vm.searchModes.mobileGarage) {
                    date = moment(vm.filters.searchDate?._i);
                }

                if (selectedStatus === null) {
                    // default to all status excluding Draft in the drop down
                    selectedStatus = [];

                    vm.statuses.forEach((status) => {
                        if (status.description !== 'Draft' && status.description !== 'Canceled') {
                            selectedStatus.push(status.code);
                        }
                    });
                }

                if (!selectedDepartment) {
                    vm.searchingAppointments = false;
                    vm.currentAppointmentSlots = null;

                    return;
                }

                saveFilterSettings();
                
                if (vm.filters.searchMode === vm.searchModes.classic) {
                    vm.lastListSearch = null;
                    vm.canLoadMore = false;
                    performClassicCalendarSearch(selectedLocation, selectedDepartment, advisors, date, searchTerm, selectedStatus, selectedTypes);
                } else if (vm.filters.searchMode === vm.searchModes.mobileGarage) {
                    vm.lastListSearch = null;
                    vm.canLoadMore = false;
                    performMobileGarageSearch(selectedLocation, selectedDepartment, advisors, date, searchTerm, selectedStatus, selectedTypes);
                } else {
                    // list
                    vm.lastListSearch = {
                        selectedLocation: selectedLocation,
                        selectedDepartment: selectedDepartment,
                        advisors: advisors,
                        startDate: startDate,
                        endDate: endDate,
                        searchTerm: searchTerm,
                        selectedStatus: selectedStatus,
                        selectedTypes: selectedTypes,
                        timeFrame: vm.filters.filterByTimeFrame,
                        timeZone: vm.filters.currentTimeZone
                    };
                    performAppointmentSearch(selectedLocation, selectedDepartment, advisors, startDate, endDate, searchTerm, selectedStatus, selectedTypes, null, null, vm.filters.filterByTimeFrame, vm.filters.currentTimeZone);
                }

            } else {
                vm.searchingAppointments = false;
                vm.currentAppointmentSlots = [];
            }
        }

        vm.isAuthPending = function (auth) {
            return auth.status === vm.authHistoryStatusEnum.pending;
        };

        vm.isAuthReady = function (auth) {
            return auth.status === vm.authHistoryStatusEnum.ready;
        };

        vm.getDepartmentName = function (departmentId) {
            if (departmentId) {
                let dept = vm.filters.locationDepartments.filter((department) => department.id === departmentId);

                if (dept && dept.length > 0) return dept[0].name;
            }
        };

        function clearAppointmentTypeAheadSelection () {
            vm.selectedTypeAheadAppt = [];
            vm.typeAheadSearchQuery = '';
        }

        let apptTypeAheadCtrl = null;

        vm.registerApptTypeAhead = function (ctrl) {
            apptTypeAheadCtrl = ctrl;
        };

        vm.typeAheadApptSelected = function (tag) {
            if (tag) {
                const appt = typeaheadSelectionService.resolveSelection(tag, vm.typeAheadApptMap, vm.typeAheadAppts);

                if (appt?.appointmentId !== -999) vm.viewAppointment(appt);
            }

            clearAppointmentTypeAheadSelection();
        };

        vm.typeAheadApptRemoved = function () {
            clearAppointmentTypeAheadSelection();
        };

        vm.typeAheadCustomerNotFound = function (searchTerm) {
            vm.typeAheadAppts = [];

            if (vm.filters.searchMode === vm.searchModes.mobileGarage || vm.filters.searchMode === vm.searchModes.classic) {
                vm.typeAheadAppts.push({
                    name: `No results match ${searchTerm}. <b>Switch to List view</b> to search additional dates.`,
                    id: -999,
                    appointmentId: -999
                });
            } else {
                vm.typeAheadAppts.push({
                    name: `<span class='theme-link'>Can't find it?</span> <b>Try adjusting your TimeFrame Filter.</b>`,
                    id: -999,
                    appointmentId: -999
                });
            }
        };

        vm.searchCustomerByVin = function (searchTerm) {
            if (!vm.filters.selectedLocation || !searchTerm || !rcUtilService.isValidVin(searchTerm)?.isValid) {
                return [];
            }

            customerService.searchCustomersFromDms(vm.filters.selectedLocation.id, searchTerm).then((customerResults) => {
                if (customerResults && customerResults.length > 0) {
                    let customer = customerResults[0];

                    if (customer.customerVehicles && customer.customerVehicles.length > 0) {
                        vm.showVinError = false;
                        let vehicle = customer.customerVehicles[0];
                        let confirm = modalService.showYesNo('', `No appointment was found for this VIN.<br />Click CANCEL to search manually, or NEXT to check <em>${customer.customerFirstName} ${customer.customerLastName}'s ${vehicle.year} ${vehicle.make} ${vehicle.model} (${vehicle.vin.slice(-8)})</em> as a walk in.`, 'Cancel', 'Next');

                        confirm.then((confirmed) => {
                            if (confirmed) {
                                $state.go('appointment-add' + vm.suffix, {
                                    locationId: vm.filters.selectedLocation.id,
                                    customerId: customer.customerId,
                                    appointmentId: null
                                },
                                {
                                    notify: false
                                });
                            }
                        }).catch(() => console.log('VIN modal cancelled'));
                    }
                } else {
                    vehicleService.decodeVin(vm.filters.selectedLocation.id, searchTerm).then((decoded) => {
                        const ymm = decoded && decoded.year && decoded.makeName && decoded.modelName
                            ? `${decoded.year} ${decoded.makeName} ${decoded.modelName}`
                            : '';
                        let confirm = modalService.showVinNotFound(searchTerm, vm.filters.selectedLocation, ymm, $state && $state.name ? $state.name : null);

                        confirm.then((confirmed) => {
                            if (confirmed) {
                                $state.go('appointment-add' + vm.suffix, {
                                    locationId: vm.filters.selectedLocation.id,
                                    appointmentId: null,
                                    vin: searchTerm,
                                    autoNewCustomer: 1
                                },
                                {
                                    notify: false
                                });
                            }
                        }).catch(() => console.log('VIN Search cancelled'));
                    });
                }
            }, (errorResponse) => {
                vm.showVinError = true;
            });
        };

        let _vinScanSearchTerm = null;

        vm.searchApptsByVin = function(searchTerm) {
            if (!vm.filters.selectedLocation || !searchTerm || !rcUtilService.isValidVin(searchTerm)?.isValid) {
                return [];
            }

            vm.searchingTypeAheadAppts = true;
            clearAppointmentTypeAheadSelection();
            vm.typeAheadAppts = [];
            vm.typeAheadApptMap = {};
            vm.typeAheadSearchQuery = searchTerm;

            const timeFrameDate = setDates();

            appointmentService.typeAheadSearchAppointments(vm.filters.selectedLocation, timeFrameDate.startDate, timeFrameDate.endDate, searchTerm, vm.filters.filterByTimeFrame, vm.filters.currentTimeZone).then((result) => {
                if (result?.length > 0) {
                    vm.showVinError = false;
                    const typeAheadData = appointmentUtilService.buildAppointmentTypeAheadData(result);

                    vm.typeAheadAppts = typeAheadData.suggestions;
                    vm.typeAheadApptMap = typeAheadData.map;

                    if (vm.typeAheadAppts.length === 1) {
                        vm.viewAppointment(vm.typeAheadAppts[0]);
                        clearAppointmentTypeAheadSelection();
                    } else {
                        _vinScanSearchTerm = searchTerm;
                        apptTypeAheadCtrl?.triggerSearch(searchTerm);
                    }
                } else {
                    vm.searchCustomerByVin(searchTerm);
                }

                vm.searchingTypeAheadAppts = false;
            }, (errorResponse) => {
                vm.searchCustomerByVin(searchTerm);
                vm.searchingTypeAheadAppts = false;
            });
        };

        vm.refreshTypeAheadAppts = function(searchTerm) {
            vm.typeAheadSearchQuery = searchTerm;

            if (_vinScanSearchTerm === searchTerm) {
                // Avoid duplicate api call since the vin search already populates the type ahead
                _vinScanSearchTerm = null;
                vm.searchingTypeAheadAppts = false;

                return vm.typeAheadAppts;
            }

            if ((!vm.filters.selectedLocation && vm.isAdminUser) || !searchTerm || searchTerm.length < 3) {
                _typeAheadSearchRequestId++;
                vm.searchingTypeAheadAppts = false;
                vm.typeAheadAppts = [];
                vm.typeAheadApptMap = {};

                return [];
            }

            const requestId = ++_typeAheadSearchRequestId;

            vm.searchingTypeAheadAppts = true;
            vm.typeAheadApptMap = {};
            saveFilterSettings();

            const timeFrameDate = setDates();

            return appointmentService.typeAheadSearchAppointments(vm.filters.selectedLocation, timeFrameDate.startDate, timeFrameDate.endDate, searchTerm, vm.filters.filterByTimeFrame, vm.filters.currentTimeZone).then((result) => {
                if (requestId !== _typeAheadSearchRequestId) {
                    if ((vm.typeAheadSearchQuery || '').length < 3) vm.searchingTypeAheadAppts = false;

                    return vm.typeAheadAppts;
                }

                vm.searchingTypeAheadAppts = false;

                if (result?.length > 0) {
                    const typeAheadData = appointmentUtilService.buildAppointmentTypeAheadData(result);

                    vm.typeAheadAppts = typeAheadData.suggestions;
                    vm.typeAheadApptMap = typeAheadData.map;

                    if (vm.filters.searchMode === vm.searchModes.mobileGarage || vm.filters.searchMode === vm.searchModes.classic) {
                        vm.typeAheadAppts.push({
                            name: "<span class='theme-link'>Can't find it?</span>  <b>Switch to List view</b> to search additional dates.",
                            id: -999,
                            appointmentId: -999
                        });
                    } else {
                        vm.typeAheadAppts.push({
                            name: "<span class='theme-link'>Can't find it?</span> <b>Try adjusting your TimeFrame Filter.</b>",
                            id: -999,
                            appointmentId: -999
                        });
                    }

                    return vm.typeAheadAppts;
                }

                vm.typeAheadCustomerNotFound(searchTerm);

                return vm.typeAheadAppts;
            }).catch(() => {
                if (requestId !== _typeAheadSearchRequestId) {
                    if ((vm.typeAheadSearchQuery || '').length < 3) vm.searchingTypeAheadAppts = false;

                    return vm.typeAheadAppts;
                }

                vm.searchingTypeAheadAppts = false;

                return [];
            });
        };

        function openDetails(id, dealerId) {
            let locationId = vm.filters.selectedLocation?.id || dealerId;
            
            $state.go('appointment-details' + vm.suffix, {locationId: locationId, appointmentId: id, configId: _configId});
        }

        vm.viewAppointment = function (appt) {
            let id = appt.id || appt.appointmentId;

            if (vm.isCheckInView() && appt.appointmentStatus === _apptStatusEnum.repairOrderCreated) {
                let confirm = modalService.showYesNo('', 'This appointment has been converted to an RO and can no longer be checked in. Please use Inspect to obtain authorizations from the customer. ', 'Cancel', 'OK');

                confirm.then((confirmed) => {
                    if (confirmed) {
                       openDetails(id, appt.dealerId);
                    }
                });
            } else {
                openDetails(id, appt.dealerId);
            }
            
        };

        function updateLocationPermissions () {
            if (!vm.hasAccess && vm.allLocations.length === 1) return;

            if (!vm.hasAccess && vm.allLocations.length > 1) {
                vm.hasAccess = true;
                vm.filters.selectedLocation = null;

                return;
            }

            vm.getLocationPermissions();
        }

        function afterLocationChanged (loadingTemplate, templateDepartmentId) {
            if (!vm.isAdminUser && !vm.filters.selectedLocation) {
                let departments = [];

                departments.unshift(_allDepartmentsOption);
                vm.filters.locationDepartments = departments;
                vm.setSelectedDepartment(vm.filters.locationDepartments[0].id);

                return $q.resolve();
            }

            if (!vm.filters.selectedLocation) {
                return $q.resolve();
            }

            rcLocalStorageService.set('selectedAppointmentDealer', vm.filters.selectedLocation);
            
            if (vm.filters.selectedLocation.id === _resolvedDealerId) {
                updateLocationPermissions();

                return locationService.getLocationTransportationTypes(vm.filters.selectedLocation.id).then((transportationTypeResults) => {
                    vm.transportationTypes = transportationTypeResults;
                }).finally(() => {
                    postLocationDepartmentLoad(_resolvedDepartments, loadingTemplate, templateDepartmentId);
                    saveFilterSettings();
                });
            } else {
                let selLoc = vm.filters.selectedLocation;
                
                vm.loadingLocation = true;

                return appointmentService.hasAccess(vm.filters.selectedLocation.id).then((hasAccessResults) => {
                    vm.hasAccess = hasAccessResults;

                    updateLocationPermissions();

                    let transportationTypesPromise = locationService.getLocationTransportationTypes(selLoc.id);
                    let departmentsPromise = locationService.getLocationDepartments(selLoc.id);

                    return $q.all([transportationTypesPromise, departmentsPromise]).then(([transportationTypeResults, locationDepartmentsResults]) => {
                        vm.transportationTypes = transportationTypeResults;
                        postLocationDepartmentLoad(locationDepartmentsResults, loadingTemplate, templateDepartmentId);
                        saveFilterSettings();
                    });
                }).catch((failedResponse) => {
                    vm.loadingLocation = false;

                    return $q.reject(failedResponse);
                });
            }
        }

        vm.selectedLocationChanged = function () {
            vm.filters.selectedAdvisorsFilter = null;
            vm.filters.pickupDropoff = null;
            vm.mobileTechnicians = null;
            vm.filters.selectedDepartment = null; 
            vm.filters.selectedTypeFilter = null;
            vm.mobileGarageDepartments = [];
            afterLocationChanged(false, null);
            saveFilterSettings();
        };

        vm.selectedDepartmentChanged = function () {
            vm.filters.selectedAdvisorsFilter = null;
            vm.filters.pickupDropoff = null;
            vm.filters.selectedTypeFilter = null;
            setDepatmentTripTypes();
            loadDepartmentAdvisors(false);
            saveFilterSettings();
            vm.appointmentFilterChanged();
        };

        vm.customTimeFrameChanged = function () {
            if (vm.filters.filterByCustomTimeframe && vm.filters.filterByCustomTimeframe.startDate && vm.filters.filterByCustomTimeframe.endDate) {
                saveFilterSettings();
            }

            if (!vm.showAdvancedSearch) {
                vm.appointmentFilterChanged();
            }
        };

        vm.timeFrameChanged = function () {
            saveFilterSettings();

            if (vm.filters.filterByTimeFrame === _timeFrameEnum.custom) {
                $timeout(() => {
                    $('#timeframe_range').data('daterangepicker').toggle();
                }, 1);

                return;
            } else if (!vm.showAdvancedSearch) {
                vm.appointmentFilterChanged();
            }
        };

        vm.setSearchMode = function (newMode) {
            if (newMode === vm.searchModes.byCustomer) {
                vm.sortAlphaReverse = !vm.sortAlphaReverse;
                vm.sort.sortBy = 'Customer';
                vm.sort.sortDirection = !vm.sortAlphaReverse ? 'asc' : 'desc';
                vm.saveSort();
            } else if (newMode === vm.searchModes.byTime) {
                vm.sortTimeReverse = !vm.sortTimeReverse;
                vm.sort.sortBy = 'Appointment';
                vm.sort.sortDirection = !vm.sortTimeReverse ? 'asc' : 'desc';
                vm.saveSort();
            }

            if (newMode !== vm.filters.searchMode) {
                vm.searchingAppointments = true;
                vm.filters.searchMode = newMode;
                saveFilterSettings();

                $state.go(vm.activeProduct, {
                    mode: newMode, configId: _configId
                });
                
            }
        };

        vm.populateStatusFilter = function () {
            if (vm.filters.searchMode === vm.searchModes.mobileGarage) {
                vm.statuses = resolvedAppointmentStatuses.filter(o => {
                    return o.code === APPOINTMENT_APPOINTMENTSTATUS.new
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.checkingIn
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.checkedIn
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.arrived
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.imported
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.repairOrderCreated
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.inProgress
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.completed
                        || o.code === APPOINTMENT_APPOINTMENTSTATUS.canceled;
                });
            } else {
                vm.statuses = resolvedAppointmentStatuses.filter(o => o.code !== APPOINTMENT_APPOINTMENTSTATUS.draft);
            }
        };

        vm.searchModeChanged = function() {
            vm.showAdvancedSearch = false;
            vm.setSearchMode(vm.searchModeIcon.value);
        };

        vm.getSortDirection = function () {
            if (!isMobileView()) {
                return;
            }

            let mode = vm.filters.searchMode;

            if (mode === vm.searchModes.byCustomer) {
                return vm.sortAlphaReverse;
            } else if (mode === vm.searchModes.byTime) {
                return vm.sortTimeReverse;
            }
        };

        vm.localAppointmentFilter = function (appointment) {
            // OpCodes
            let showAppointment = false;

            if (appointment && vm.filterByOpCodes && vm.filterByOpCodes.length > 0 && appointment.opCodes && appointment.opCodes.length > 0) {
                let opcodeListLower = vm.filterByOpCodes.toLowerCase().split(' ');

                appointment.opCodes.forEach((appOpcode) => {
                    let lowerAppCode = appOpcode.toLowerCase();

                    opcodeListLower.forEach((opcode) => {
                        if (lowerAppCode.includes(opcode)) {
                            showAppointment = true;

                            return;
                        }
                    });
                });
            } else {
                showAppointment = true;
            }

            return showAppointment;
        };

        $scope.mobileGarageAppointmentFilter = function(techColumn) {
            let currentDriver = vm.mobileTechnicians[techColumn];
            let filterByOpCodes = vm.filterByOpCodes;
                

            return function(appointment) {
                let showAppointment = false;
                let apptOpCodes = appointment ? appointment.opCodes : null;

                if (appointment.driverId !== currentDriver.id) return false;

                if (appointment && filterByOpCodes && filterByOpCodes.length > 0 && apptOpCodes && apptOpCodes.length > 0) {
                    let opcodeListLower = filterByOpCodes.toLowerCase().split(' ');

                    appointment.opCodes.forEach((appOpcode) => {
                        let lowerAppCode = appOpcode.toLowerCase();

                        opcodeListLower.forEach((opcode) => {
                            if (lowerAppCode.includes(opcode)) {
                                showAppointment = true;

                                return;
                            }
                        });
                    });
                } else {
                    showAppointment = true;
                }

                return showAppointment;
            };
        };

        vm.isAppointmentView = function () {
            return vm.isListInMode('appointment-list');
        };

        vm.isCheckInView = function () {
            return vm.isListInMode('checkin-list');
        };

        vm.saveSort = function() {
            rcLocalStorageService.set('sort' + vm.suffix, vm.sort);
        };

        vm.mobileSortChanged = function () {
            let el = angular.element(document.getElementsByClassName("header_" + vm.selectedMobileSort));

            if (el) {
                el.triggerHandler('click');
            }
        };

        vm.sortChanged = function (sortBy, sortOrder, fromMobile) {
            vm.selectedMobileSort = sortBy;
            
            let d = $q.defer();

            vm.sort.sortBy = sortBy;
            vm.sort.sortDirection = sortOrder;
            vm.searchingAppointments = true;
            vm.saveSort();
            vm.appointmentFilterChanged();
            
            d.resolve(null);

            return d.promise;
        };

        vm.toggleShowSearchOptions = function () {
            vm.searchTemplateBeforeAdvancedSearch = _.cloneDeep(vm.searchTemplateData);
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);
            vm.showAdvancedSearch = !vm.showAdvancedSearch;

            if (vm.filters.searchMode === vm.searchModes.mobileGarage) {
                $timeout(() => {
                    setMGUpdateScrollableArea();
                }, 750);
            }
        };

        vm.showCalendar = function () {
            return vm.filters.filterByTimeFrame === _timeFrameEnum.custom;
        };

        vm.clearCustomTimeFrame = function () {
            vm.filters.filterByTimeFrame = _timeFrameEnum.today;
            vm.appointmentFilterChanged();
        };

        vm.appointmentFilterChanged = function () {
            updateDirtyFlag();

            if (!vm.showAdvancedSearch && vm.dataInitialized === true) {
                searchAppointments();
            } 
        };
        
        vm.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vm.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };
        
        vm.resetFilters = function (linkClicked) {
            vm.templateName = null;
            vm.searchTemplateData.currentSearchTemplate = null;
            vm.searchTemplateData.savedSearchName = null;
            vm.filters.selectedStatusFilter = null;
            vm.filters.selectedAdvisorsFilter = [];
            vm.filters.pickupDropoff = null;
            vm.filters.selectedTypeFilter = null;
            vm.filters.filterByTimeFrame = _timeFrameEnum.today;
            vm.filters.filterByCustomTimeframe = {
                startDate: moment(),
                endDate: moment()
            };
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);
            rcLocalStorageService.set('selectedAppointmentSearchTemplate' + vm.suffix, null);
            saveFilterSettings();

            if (linkClicked) {
                vm.showAdvancedSearch = false;
            }

            vm.appointmentFilterChanged();
        };
        
        vm.clearSearchCriteria = function () {
            vm.keywordFilter = null;
            vm.isGlobalTemplate = false;
            vm.resetFilters();
        };
        
        function adjustOldTimeFilters () {
            if (vm.filters.filterByTimeFrame === 'last7') {
                vm.filters.filterByTimeFrame = 'Last 7 days';
            } else if (vm.filters.filterByTimeFrame === 'last30') {
                vm.filters.filterByTimeFrame = 'Last 30 days';
            } else if (vm.filters.filterByTimeFrame === 'last60') {
                vm.filters.filterByTimeFrame = 'Last 60 days';
            } else if (vm.filters.filterByTimeFrame === 'next7') {
                vm.filters.filterByTimeFrame = 'Next 7 days';
            } else if (vm.filters.filterByTimeFrame === 'next30') {
                vm.filters.filterByTimeFrame = 'Next 30 days';      
            } else if (vm.filters.filterByTimeFrame === 'next60') {
                vm.filters.filterByTimeFrame = 'Next 60 days';
            } 

            let matchedTimeframe = vm.timeframes.find((timeframe) => timeframe.text === vm.filters.filterByTimeFrame);

            if (matchedTimeframe) {
                vm.filters.filterByTimeFrame = matchedTimeframe.value;
            } else {
                vm.filters.filterByTimeFrame = _timeFrameEnum.today;
            }
        }
        
        function finishLoadingTemplateAfterDepartmentsLoaded () {
            let template = vm.searchTemplateData.currentSearchTemplate.template;
            
            vm.filters.selectedAdvisorsFilter = template.selectedAppointmentAdvisors;
            vm.filters.selectedStatusFilter = template.selectedAppointmentStatus;
            vm.filters.pickupDropoff = template.selectedAppointmentPickupDropoff;
            vm.filters.selectedTypeFilter = template.selectedAppointmentType;
            vm.filterByOpCodes = template.selectedAppointmentOpCode;
            vm.appointmentFilterChanged();
        }

        vm.loadSearchTemplate = function (item, model) {
            if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                let template = _.cloneDeep(item.template);
                let currentLocationId = vm.filters.selectedLocation ? vm.filters.selectedLocation.id : null;
                let templateDealer = vm.allLocations.filter((location) => location.id === template.selectedAppointmentDealerId);
                
                vm.searchingAppointments = true;
                vm.searchTemplateData.isTemplateDirty = false;
                vm.searchTemplateData.currentSearchTemplate = item;
                vm.filters.filterByTimeFrame = template.selectedFilterByTimeFrame;
                
                if (typeof vm.filters.filterByTimeFrame === 'string') {
                    let trimmedFilterByTimeFrame = vm.filters.filterByTimeFrame.trim();

                    if (!trimmedFilterByTimeFrame.length) {
                        vm.filters.filterByTimeFrame = _timeFrameEnum.today;
                    } else if (/^-?\d+$/.test(trimmedFilterByTimeFrame)) {
                        let parsedFilterByTimeFrame = parseInt(trimmedFilterByTimeFrame, 10);
                        let matchedTimeframe = vm.timeframes.find((timeframe) => timeframe.value === parsedFilterByTimeFrame);

                        vm.filters.filterByTimeFrame = matchedTimeframe ? parsedFilterByTimeFrame : _timeFrameEnum.today;
                    } else if (trimmedFilterByTimeFrame) {
                        vm.filters.filterByTimeFrame = trimmedFilterByTimeFrame;
                        adjustOldTimeFilters();
                    } else {
                        vm.filters.filterByTimeFrame = _timeFrameEnum.today;
                    }
                } else if (Number.isInteger(vm.filters.filterByTimeFrame)) {
                    let matchedTimeframe = vm.timeframes.find((timeframe) => timeframe.value === vm.filters.filterByTimeFrame);

                    if (!matchedTimeframe) {
                        vm.filters.filterByTimeFrame = _timeFrameEnum.today;
                    }
                } else if (vm.filters.filterByTimeFrame !== null) {
                    vm.filters.filterByTimeFrame = _timeFrameEnum.today;
                }
                
                vm.filters.filterByCustomTimeframe = template.selectedFilerByCustomTimeFrame || {
                    startDate: moment(),
                    endDate: moment()
                };

                if (vm.filters.filterByCustomTimeframe.startDate && !moment.isMoment(vm.filters.filterByCustomTimeframe.startDate)) {
                    vm.filters.filterByCustomTimeframe.startDate = moment(vm.filters.filterByCustomTimeframe.startDate);
                }

                if (vm.filters.filterByCustomTimeframe.endDate && !moment.isMoment(vm.filters.filterByCustomTimeframe.endDate)) {
                    vm.filters.filterByCustomTimeframe.endDate = moment(vm.filters.filterByCustomTimeframe.endDate);
                }
                
                rcLocalStorageService.set('selectedAppointmentSearchTemplate' + vm.suffix, vm.searchTemplateData.currentSearchTemplate);
                vm.searchTemplateData.savedSearchName = template.templateName;
                vm.templateName = template.templateName;
                
                if (templateDealer && templateDealer.length > 0) {
                    vm.filters.selectedLocation = templateDealer[0];

                    // we have to load all of the data for the location before we can set the 
                    // other template data
                    if (vm.filters.selectedLocation.id !== currentLocationId) {
                        afterLocationChanged(true, template.selectedAppointmentDepartment).catch(() => {
                            vm.searchingAppointments = false;
                        });
                    } else {
                        finishLoadingTemplateAfterDepartmentsLoaded();
                    }
                }
                
            } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                rcLocalStorageService.set('selectedAppointmentSearchTemplate' + vm.suffix, null);
                searchTemplateUtilService.clearSearchTemplate(vm);
                vm.resetFilters();
            } else {
                rcLocalStorageService.set('selectedAppointmentSearchTemplate' + vm.suffix, null);
                searchTemplateUtilService.clearSearchTemplate(vm);
                vm.appointmentFilterChanged();
            }
        };

        $scope.$on('AppointmentList.changed', (event, data) => {
            vm.appointmentFilterChanged();
        });

        vm.searchBtnClicked = function () {
            vm.appointmentFilterChanged();
        };

        vm.applyBtnClicked = function () {
            if (vm.filters.pickupDropoff === '' || vm.filters.pickupDropoff === APPOINTMENT_TRANSPORTATION_TYPE_GROUP.mobile) {
                vm.filters.selectedTypeFilter = null;
            }
            
            vm.searchTemplateBeforeAdvancedSearch = null;
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            rcLocalStorageService.set('selectedAppointmentSearchTemplate' + vm.suffix, vm.searchTemplateData.currentSearchTemplate);
            createFilterMessage();
            vm.appointmentFilterChanged();
        };
        
        function saveFilterSettings() {
            let suffix = vm.suffix;

            if (!vm.showTimeFrameFilter) {
                vm.filters.filterByTimeFrame = null;
                vm.filters.filterByCustomTimeframe = null;
            } else {
                if (!vm.filters.filterByCustomTimeframe || !vm.filters.filterByCustomTimeframe.startDate || !vm.filters.filterByCustomTimeframe.endDate) {
                    vm.filters.filterByCustomTimeframe = null;
                }
            }

            rcLocalStorageService.set(savedFilterKey, vm.filters);
            rcLocalStorageService.set('sort' + suffix, vm.sort);
        }

        function loadLastTemplateAndFilters () {
            let suffix = vm.suffix;

            vm.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate('selectedAppointmentSearchTemplate' + suffix);
            
            if (vm.searchTemplateData.currentSearchTemplate) {
                let searchItem = vm.searchTemplateData.searchTemplates.find(item => { 
                    return item.template.templateName === vm.searchTemplateData.currentSearchTemplate.template.templateName; 
                });

                if (searchItem) {
                    vm.loadSearchTemplate(searchItem);
                } else {
                    vm.searchTemplateData.currentSearchTemplate = null;
                    vm.appointmentFilterChanged();
                }
            } 
        }

        function getSearchTemplateType () {
            let allTypes = SYSTEM_ENUMS.searchTemplateTypes;
            let allSearchModes = vm.searchModes;

            if (vm.isAppointmentView() === true) {
                if (vm.filters.searchMode === allSearchModes.classic) {
                    return allTypes.appointmentCalendar;
                } else {
                    return allTypes.appointmentSortable;
                }
            } else if (vm.isCheckInView() === true) {
                return allTypes.appointmentCheckin;
            } 
        }

        function loadSearchTemplates () {
            systemService.getSearchTemplates(getSearchTemplateType()).then((templates) => {
                vm.searchTemplateData.searchTemplates = templates;

                loadLastTemplateAndFilters();
            });
        }

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vm.searchTemplateData.currentSearchTemplate.id = null;
            }

            searchTemplateUtilService.saveSearchTemplateClicked(vm, {
                selectedAppointmentDepartment: vm.filters.selectedDepartment,
                selectedAppointmentDealerId: vm.filters.selectedLocation.id,
                selectedAppointmentAdvisors: vm.filters.selectedAdvisorsFilter,
                selectedAppointmentStatus: vm.filters.selectedStatusFilter,
                selectedAppointmentPickupDropoff: vm.filters.pickupDropoff,
                selectedAppointmentType: vm.filters.selectedTypeFilter,
                selectedAppointmentOpCode: vm.filterByOpCodes,
                selectedFilterByTimeFrame: vm.filters.filterByTimeFrame,
                selectedFilerByCustomTimeFrame: vm.filters.filterByCustomTimeframe,
                templateName: vm.searchTemplateData.savedSearchName
            }, getSearchTemplateType());
        }

        function updateDirtyFlag() {
            if (vm.searchTemplateData.currentSearchTemplate) {
                vm.searchTemplateData.isTemplateDirty = true;
            }
        }

        vm.activeDepartmentsFilter = function(dept) {
            return !(dept.isDisabled === true && dept.hasFutureAppointments === false);
        };

        function createFilterMessage() {
            
            vm.filterCount = 0;
            vm.filterMessage = '';
            vm.requiredFilterMessage = "";

            if (vm.filters.selectedLocation) {
                vm.requiredFilterMessage += vm.filters.selectedLocation.name;
                rcUtilService.buildFilterMessage('Location', vm.filters.selectedLocation.name, vm);
            }

            if (vm.selectedTypeAheadAppt && vm.selectedTypeAheadAppt.length > 0) {
                rcUtilService.buildFilterMessage('Search Term', vm.selectedTypeAheadAppt, vm);
            }

            if (vm.filters.selectedDepartment) {
                let deptName = vm.getDepartmentName(vm.filters.selectedDepartment);

                if (deptName) {
                    vm.requiredFilterMessage += ", ";
                    vm.requiredFilterMessage += deptName;

                    rcUtilService.buildFilterMessage('Department', deptName, vm);
                }
            }

            if (vm.filters.selectedAdvisorsFilter && vm.filters.serviceAdvisors) {
                let advisors = '';
                let label = 'Advisor';
                let cnt = 0;

                vm.filters.selectedAdvisorsFilter.forEach((filter) => {
                    let item = vm.filters.serviceAdvisors.find(advisor => advisor.id === filter.id);

                    if (item) {
                        if (cnt > 0) { 
                            advisors += ", ";
                        }

                        advisors += item.label;
                        cnt ++;
                    }
                });

                if (cnt > 1)
                    label += 's';

                if (advisors.length > 0) {
                    rcUtilService.buildFilterMessage('Advisor', advisors, vm);
                }
            }

            if (vm.filters.pickupDropoff && vm.filters.pickupDropoff !== "") {
                let display = '';

                if (vm.filters.pickupDropoff === APPOINTMENT_TRANSPORTATION_TYPE_GROUP.dropoff) {
                    display = 'Customer Drop Off';
                } else if (vm.filters.pickupDropoff === APPOINTMENT_TRANSPORTATION_TYPE_GROUP.pickup) {
                    display = 'Dealership Pick Up';
                } else if (vm.filters.pickupDropoff === APPOINTMENT_TRANSPORTATION_TYPE_GROUP.mobile) {
                    display = 'Mobile Service';
                }

                rcUtilService.buildFilterMessage('Appointment Type', display, vm);
            }

            if (vm.filters.selectedTypeFilter) {
                let selectedType = vm.transportationTypes.filter((transportationType) => transportationType.id === vm.filters.selectedTypeFilter);

                if (selectedType) {
                    rcUtilService.buildFilterMessage('Transportation Type', selectedType[0].dashboardDescription, vm);
                }
            }

            if (vm.filters.selectedStatusFilter) {
                let selectedStatus = null;
                
                selectedStatus = vm.statuses.find((status) => status.code === vm.filters.selectedStatusFilter);
                rcUtilService.buildFilterMessage('Status', selectedStatus.description, vm);
            }

            if (vm.filterByOpCodes) {
                rcUtilService.buildFilterMessage('Op Code', vm.filterByOpCodes, vm);
            }

            if (vm.filters.filterByTimeFrame !== null) {
                if (vm.filters.filterByTimeFrame !== _timeFrameEnum.custom) {
                    let selectedFrame = vm.timeframes.find((timeframe) => timeframe.value === vm.filters.filterByTimeFrame);

                    if (selectedFrame) {
                        rcUtilService.buildFilterMessage('Time Frame', selectedFrame.text, vm);
                    }
                } else {
                    rcUtilService.buildFilterMessage('Time Frame', 'Custom date range', vm);
                }
            }
        }

        function setSearchModeDropdownIcon () {
            let ddIcon = vm.selectableViewModes.filter((searchMode) => searchMode.value === vm.filters.searchMode);

            if (ddIcon && ddIcon.length > 0) {
                vm.searchModeIcon = ddIcon[0];
            } else {
                vm.searchModeIcon = null;
            }
        }

        function setMGUpdateScrollableArea () {
            let leftWidth = angular.element("#mobile-garage-wrapper").width() / 2; // take off left padding

            if (_map) {
                $timeout(() => {
                    _map.setMapSizes(null, leftWidth);
                }, 1);
            }

        }

        function init() {
            vm.sort = rcLocalStorageService.get('sort' + vm.suffix) || {
                sortBy: 'Customer',
                sortDirection: 'asc'
            };
            
            vm.sortAlphaReverse = vm.sort.sortDirection !== 'asc';
            vm.sortTimeReverse = vm.sort.sortDirection !== 'asc';
            vm.populateStatusFilter();
            
            setSearchModeDropdownIcon();
       
            if (vm.filters.filterByCustomTimeframe) {
                if (vm.filters.filterByCustomTimeframe.startDate && !moment.isMoment(vm.filters.filterByCustomTimeframe.startDate)) {
                    vm.filters.filterByCustomTimeframe.startDate = moment(vm.filters.filterByCustomTimeframe.startDate);
                }

                if (vm.filters.filterByCustomTimeframe.endDate && !moment.isMoment(vm.filters.filterByCustomTimeframe.endDate)) {
                    vm.filters.filterByCustomTimeframe.endDate = moment(vm.filters.filterByCustomTimeframe.endDate);
                }
            }
            
            let requiredSystemTripTypes = [SYSTEM_ENUMS.systemTripType.appointment];
            let permission = SYSTEM_ENUMS.permissionTypes.appointments;

            vm.isLocationRequiredForClassicAndMobile = false;
            vm.isAdminUser = permissions.isAdminLevelUser();
            vm.filters.filterByTimeFrame = _timeFrameEnum.today;
            vm.showTimeFrameFilter =  ((vm.filters.searchMode === vm.searchModes.sortable && vm.isAppointmentView()) || vm.isCheckInView());
           
            if (vm.isAppointmentView()) {
                if (vm.filters.searchMode === vm.searchModes.mobileGarage) {
                    requiredSystemTripTypes = [SYSTEM_ENUMS.systemTripType.appointment, SYSTEM_ENUMS.systemTripType.mobileGarage];
                }
            } else if (vm.isCheckInView()) {
                permission = SYSTEM_ENUMS.permissionTypes.checkIn;
            }
            
            locationService.hasMobileGarageDealer(true, false, permission, requiredSystemTripTypes).then((hasMobileGarageDealer) => {
                if (hasMobileGarageDealer !== true && (!vm.mobileMarketingContent || vm.mobileMarketingContent === "") && vm.selectableViewModes.length === 3) {
                    // remove the mobile icon from the icon drop down
                    vm.selectableViewModes.splice(-1);
                }
            });

            locationService.getLocationsForDropDown(true, false, permission, requiredSystemTripTypes).then((locationResult) => {
                vm.allLocations = locationResult;
                let loc = !vm.allLocations || vm.allLocations.length === 0 ? null : vm.allLocations[0];
                let lastDealer = vm.filters.selectedLocation;
                let test = lastDealer ? vm.allLocations.filter((location) => location.id === (lastDealer.id || lastDealer)) : null;

                lastDealer = (test && test.length > 0) ? test[0] : null;
                
                if (vm.isAdminUser || (vm.isAppointmentView() && (vm.filters.searchMode === vm.searchModes.classic || vm.filters.searchMode === vm.searchModes.mobileGarage))) {
                    vm.filters.selectedLocation = lastDealer || loc;
                }

                if (vm.filters.searchMode === vm.searchModes.mobileGarage && !vm.filters.selectedLocation) {
                    showMobileGarageMarketingContent();
                    $timeout(() => {
                        vm.dataInitialized = true;
                        vm.appointmentFilterChanged();
                    }, 1000);
                } else {
                    afterLocationChanged(false, null).catch(() => {
                        vm.searchingAppointments = false;
                    }).finally(() => {
                        // small timeout to prevent multiple search calls firing while loading 
                        // various data.
                        $timeout(() => {
                            vm.dataInitialized = true;
                            vm.appointmentFilterChanged();
                        }, 500);
                    });
                }

                if (vm.filters.searchMode === vm.searchModes.mobileGarage) {
                    $timeout(() => {
                        setMGUpdateScrollableArea();
                    }, 1);
                }
            });
        }

        function getMGApptCardHeight (appt) {
            if (appt.cardHeight) return appt.cardHeight;

            let apptInterval = vm.appointmentInterval;
            let cardEndTime = moment.tz(appt.promiseDateTime, appt.dealerTimezonId);
            let apptTime = moment.tz(appt.pickUpTripArrivalTime, appt.dealerTimezonId);
            
            if (vm.currentAppointmentSlots && vm.currentAppointmentSlots.length > 0) {
                let closingTime = moment.tz(_.last(vm.currentAppointmentSlots).blockTime, appt.dealerTimezonId);

                cardEndTime = moment.min(cardEndTime, closingTime);
            }

            let deltaMinutes = cardEndTime.diff(apptTime, 'minutes');
            let intervals = Math.ceil(deltaMinutes / apptInterval);
            let height;

            height = intervals * 51;
            if (height < 50) height = 50;

            appt.cardHeight = height + 'px';
        }

        vm.getMGApptCardLeft = function (appt, index, driver) {
            let left = 0;
            let apptToCheckStartTime = appt.pickUpTripArrivalTime;
            let jsApptToCheckStartDate = new Date(apptToCheckStartTime); 
            let spread = 15; // how many pixels to move the appts over when overlapping

            // is there another appointment at the same time?
            // then move it over 
            left += (index * spread);

            // does it overlap another appointment that starts at a different time?
            // aka starts before a previous appointment ends?

            vm.currentAppointmentSlots.forEach((slot) => {
                slot.appointments.forEach((currAppt) => {
                    if (currAppt.driverId === driver.id && 
                        currAppt.pickUpTripArrivalTime !== apptToCheckStartTime) {
                        // is the end time of this appointment, after the start time of the appointment we are drawing?
                        if (new Date(currAppt.pickUpTripArrivalTime) < jsApptToCheckStartDate && 
                            currAppt.estimatedEndDateTime > jsApptToCheckStartDate) {
                            left += spread;
                        }
                    }
                        
                });
            });
           
            return left + 'px';
        };

        let debouncedRedraw = _.debounce(setMGUpdateScrollableArea, 150);

        $(window).on("resize", debouncedRedraw);
      
        $scope.$on("$destroy", () => {
            // clean up here
            $(window).off("resize");
            $(window).off("scroll");
        });

        init();

        vm.close = function () {
            searchTemplateUtilService.advancedFilterModalClosed(vm);
        };

        function setDates() {
            let startDate = null;
            let endDate = null;
          
            if (vm.filters.searchMode === vm.searchModes.classic || vm.filters.searchMode === vm.searchModes.mobileGarage) {
                startDate = moment(vm.calendarDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                endDate = moment(vm.calendarDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss');    
            } else if (vm.filters.filterByTimeFrame === _timeFrameEnum.custom) {
                startDate = moment(vm.filters.filterByCustomTimeframe.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                endDate = moment(vm.filters.filterByCustomTimeframe.endDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
            }

            return {startDate: moment(startDate), endDate: moment(endDate)}; 
        }
    }
})();

(function () {
    'use strict';

    AppointmentDetailTabsController.$inject = ["$filter", "$state", "rcUtilService", "SYSTEM_ENUMS", "resolvedAppointmentRideShareCredit", "resolvedLocationOpCodes", "resolvedAppointment", "resolvedLocationTransportationTypes", "resolvedLocationTripTypeInstances", "resolvedAppointmentStatuses", "resolvedDepartments", "resolvedDealerHasCheckin", "resolvedDealerHasInspect", "appointmentService", "appointmentUtilService", "roService", "appointmentClass", "permissions", "modalService", "hasMessaging", "APPOINTMENTSTATUS_LABELS", "INSPECT_CONSTANTS", "APPOINTMENT_APPOINTMENTSTATUS"];
    angular
        .module('redcap.appointment')
        .controller('AppointmentDetailTabsController', AppointmentDetailTabsController);

        function AppointmentDetailTabsController($filter, $state, rcUtilService, SYSTEM_ENUMS, resolvedAppointmentRideShareCredit, resolvedLocationOpCodes,
            resolvedAppointment, resolvedLocationTransportationTypes, resolvedLocationTripTypeInstances, resolvedAppointmentStatuses, resolvedDepartments, resolvedDealerHasCheckin, resolvedDealerHasInspect,
            appointmentService, appointmentUtilService, roService, appointmentClass, permissions, modalService, hasMessaging, APPOINTMENTSTATUS_LABELS, INSPECT_CONSTANTS, APPOINTMENT_APPOINTMENTSTATUS) {

        let vm = this;
        let _today = moment(new Date());
        let _WEEK_OLD = _today.clone().subtract(7, 'days').startOf('day');
        let _dealerHasCheckin = resolvedDealerHasCheckin;
        let _dealerHasInspect = resolvedDealerHasInspect;
        let _dealerOpCodes = resolvedLocationOpCodes.opCodes;
        let _cleanDealerOpCodesAll = resolvedLocationOpCodes.all;
        let _cleanDealerRecallOpCodes = resolvedLocationOpCodes.recallOpCodes;
        let _cleanDealerRecommendedMaintenanceOpCodes = resolvedLocationOpCodes.recommendedMaintenanceOpCodes;
        let _userHasInspect = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.inspect);
        let _userHasCheckIn = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.checkIn);
        let _activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
        let _suffix = appointmentUtilService.getProductSuffix(_activeProduct);
        let _appointmentStatusEnum = APPOINTMENT_APPOINTMENTSTATUS;
        let _locationDepartments = resolvedDepartments;
       
        vm.dmsCancelReason = 'canceled in the dms';
        vm.customerData = null;
        vm.rideShareCredit = resolvedAppointmentRideShareCredit;
        vm.appointment = appointmentClass.new(resolvedAppointment);
        vm.tripTypeInstances = resolvedLocationTripTypeInstances;
        vm.locationTransportationTypes = resolvedLocationTransportationTypes;
        vm.appointmentStatuses = resolvedAppointmentStatuses;
        vm.hasMessaging = hasMessaging;
        vm.tabTypes = INSPECT_CONSTANTS.tabTypes;
        vm.detailTabTypes = INSPECT_CONSTANTS.detailTabType;
        vm.viewModes = {
            summary: 1,
            arrived: 2,
            checkedIn: 3,
            authorizations: 4
        };

        appointmentService.preprocessLineItems(vm.appointment, vm.dealerOpCodesAll, vm.appointment.lineItems, false, _cleanDealerRecommendedMaintenanceOpCodes, _cleanDealerRecallOpCodes);
        appointmentUtilService.processDashboardViewLineItems(vm.appointment.lineItems, vm.appointment.departmentId, _cleanDealerOpCodesAll, _dealerOpCodes, _cleanDealerRecommendedMaintenanceOpCodes, _cleanDealerRecallOpCodes);
        
        let _pickUpTransportationTypes = $filter('filter')(vm.locationTransportationTypes, {isPickup: true}, true);

        vm.locationDepartment = appointmentService.getAppointmentDepartment(vm.appointment, _locationDepartments);

        // If we are arrived or checked in (where we show the checkin summary), make sure we have a repair order object
        if (!vm.repairOrder && vm.appointment.repairOrderId) {
            roService.getRo(vm.appointment.dealerId, vm.appointment.repairOrderId).then((ro) => {
                vm.repairOrder = ro;
            });
        }

        vm.getCustomerName = function () {
            return roService.buildCustomerNameForTab(vm.appointment.customerFirstName, vm.appointment.customerLastName);
        };
        
        vm.getViewMode = function () {
            let apptStatus = vm.appointment.appointmentStatus;
            let viewModes = vm.viewModes;
           
            if (_activeProduct === 'appointment-list') {
                return viewModes.summary;
            } else if (_activeProduct === 'checkin-list') {
                if (apptStatus === _appointmentStatusEnum.new ||
                    apptStatus === _appointmentStatusEnum.walkIn ||
                    apptStatus === _appointmentStatusEnum.draft ||
                    apptStatus === _appointmentStatusEnum.imported ||
                    apptStatus === _appointmentStatusEnum.noShow ||
                    apptStatus === _appointmentStatusEnum.canceled) {
                        return  viewModes.summary;
                    } else if (apptStatus === _appointmentStatusEnum.arrived) {
                        return viewModes.arrived;
                    } else {
                        return viewModes.checkedIn;
                    }
            } else if (_activeProduct === 'auth-list') {
                return viewModes.authorizations;
            }
        };

        vm.enableMessaging = function (enable) {
            rcUtilService.showHideMobileMessagingPanel(enable);
        };

        vm.returnToParentList = function () {
            $state.go(_activeProduct);
        };

        vm.printSummary = function() {
            rcUtilService.printToPDF('print-to-pdf', 'repeating-footer', 'Appointment-Summary-' + vm.appointment.customerLastName);
        };

        function showCancelDlg(appt, reasons) {
            let cancelResult = modalService.showAppointmentCancel(reasons, appt);

            cancelResult.then((results) => {
                if (results) {
                    let cancellationReason = results.cancellationReason === 'Other' ? results.otherDescription : !results.otherDescription || results.otherDescription.length === 0  ? results.cancellationReason : results.cancellationReason + ' - ' + results.otherDescription;

                    vm.cancellingAppt = true;

                    appointmentService.cancelAppointment(appt.dealerId, appt, cancellationReason, results.notifyCustomer).then((result) => {
                        vm.cancellingAppt = false;

                        if (result && !result.errors) {
                            vm.returnToParentList();
                        } else if (result && result.errors && result.errors.length > 0) {
                            modalService.showError('Sorry, there was a problem canceling your appointment:', result.errors);
                        } else {
                            modalService.showYesNo('Error', 'Sorry, there was a problem canceling your appointment.', null, 'OK');
                        }

                    }, (errorResponse) => {
                        vm.cancellingAppt = false;
                    });

                } else {
                    vm.cancellingAppt = false;
                }
            });
        }

        vm.cancelClicked = function () {
            let appt = vm.appointment;
            let dealerId = appt.dealerId;

            let finishUp = function (configReasons) {
                let isPickup = $filter('filter')(_pickUpTransportationTypes, {id: appt.dealerTransportationTypeId}, true);
                let reasons = null;

                if (isPickup && isPickup.length > 0) {
                    reasons = configReasons.tripCancelReasons;
                } else {
                    reasons = configReasons.apptCancelReasons;
                }

                showCancelDlg(appt, reasons);
            };


            modalService.showYesNo('Confirm Cancel', 'Are you sure you want to cancel this appointment?', 'No', 'Yes', true).then((confirmed) => {
                if (confirmed) {
                    appointmentService.getAppointment(dealerId, appt.id).then((result) => {
                        if (!result.canCancel) {
                            modalService.showError('Appointment has progressed to a stage where it can no longer be canceled.', '', true)
                                .then(() => {}).then((error) => {}).finally(() => {
                                    $state.go('appointment-details' + _suffix, { 
                                        locationId: dealerId,
                                        appointmentId: appt.id
                                    });
                                });
                        } else {
                            let tripTypeId = $filter('filter')(vm.tripTypeInstances, {systemTripTypeId: 1, isDefault: true}, true)[0].id;

                            appointmentService.getCancellationReasons(dealerId, tripTypeId).then((reasons) => {
                                finishUp(reasons);
                            });
                        }
                    });
                }
            });
        };
        
        vm.showCancelBtn = function () {
            let appt = vm.appointment;
 
            if (appt && appt.appointmentStatus === _appointmentStatusEnum.repairOrderCreated) return false;
            
            if (moment(appt.apptDateTime).isBefore(_today, 'day')) {
                if ((permissions.isSysAdmin() || permissions.isRedCapAdmin()) 
                    && appt.canCancel) {
                        return true;
                    }

                return false;
            }

            if (!appt.canCancel) return false;

            if ((appt && appt.isComplete) || 
                (appt && appt.isCanceled) || 
                (appt && appt.isArchived)) {
                    return false;
                }

            return true;
        };

        function gotoCheckIn(appt) {
            // PROD-8961 For now keep the Arrived/Check In buttons on the appointment summary� 
            // when the user clicks one, take them to the Check in Tab
            $state.go('appointment-checkin' + '-checkin-list', { 
                locationId: appt.dealerId,
                customerId: appt.customerId,
                appointmentId: appt.id,
                appointment: appt,
                transportationTypes: vm.locationTransportationTypes,
                tripTypeInstances: vm.tripTypeInstances,
                departments: _locationDepartments,
                hasMessaging: vm.hasMessaging
            });
        }

        vm.checkInClicked = function () {
            let appt = vm.appointment;
            let dealerId = appt.dealerId; 
            
            if (_userHasCheckIn === false || _dealerHasCheckin === false) {
                // just update the status, don't go through the check in process.
                vm.updatingAppt = true;
          
                appointmentService.checkInAppointment(dealerId, appt.id).then((result) => {
                    if (result) {
                        vm.appointment.appointmentStatus = appointmentService.getStatus(vm.appointmentStatuses, APPOINTMENTSTATUS_LABELS.checkedIn);
                        vm.appointment.canCheckIn = false;
                        vm.updatingAppt = false;
                    }
                }, (errorResponse) => {
                    vm.updatingAppt = false;
                });
            } else {
                gotoCheckIn(appt);
            }
        };

        vm.arrivedClicked = function () {
            let appt = vm.appointment;
            let dealerId = appt.dealerId; 
            
            appointmentService.setAppointmentStatus(dealerId, appt.id, APPOINTMENT_APPOINTMENTSTATUS.arrived).then((result) => {
                vm.appointment.status = APPOINTMENT_APPOINTMENTSTATUS.arrived;
                vm.appointment.statusLastChanged = result;
                vm.appointment.appointmentStatus = appointmentService.getStatus(vm.appointmentStatuses, APPOINTMENTSTATUS_LABELS.arrived);

                if (_userHasCheckIn === true && _dealerHasCheckin === true) {
                    gotoCheckIn(appt);
                } else {
                    vm.appointment.canArrive = false;
                }
                
                vm.updatingAppt = false;
                
            }, () => {
                vm.updatingAppt = false;
            });
        };

        vm.showInspectBtn = function () {
            return _userHasInspect &&
                   _dealerHasInspect && // <- this ensures dealer supports Inspect module
                   (vm.getViewMode() === vm.viewModes.checkedIn || (vm.getViewMode() === vm.viewModes.summary && vm.appointment.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.repairOrderCreated));
        };

        vm.showArrivedBtn = function () {
            if (_dealerHasCheckin === true && _userHasCheckIn === false) return false;

            if (_dealerHasCheckin === false && _userHasCheckIn === false) return false;

            if (_dealerHasCheckin === true) return false; // always going to show check in going foward;
            
            if (vm.appointment.canArrive === true) return true;

            return false;
        };
        
        vm.showCheckInBtn = function () {
            if (_dealerHasCheckin === true && _userHasCheckIn === false) return false;

            if (_dealerHasCheckin === false && _userHasCheckIn === false) return false;
            
            if (_dealerHasCheckin === false) {
                if (vm.appointment.canCheckIn === true && 
                    vm.appointment.canArrive === false) return true;
            } else {
                if (vm.appointment.canCheckIn === true) return true;
            }
            
            return false;
        };

        function isDraftAppointment() {
            return appointmentService.isDraftAppointment(vm.appointmentStatuses, vm.appointment);
        }
        
        vm.showEditBtn = function () {
            if (vm.appointment.apptDateTime && isDraftAppointment() === false) {
                if (moment(vm.appointment.apptDateTime).isBefore(_WEEK_OLD, 'day')) return false;
            }
            
            if (vm.appointment.canEdit) return true;

            return false;
        };

        vm.editClicked = function () {
            let appt = vm.appointment;

            $state.go('appointment-add' + _suffix, { 
                locationId: appt.dealerId,
                customerId: appt.customerId,
                appointmentId: appt.id,
                editClicked: 1
            });
        };

        function initCustomerData () {
            vm.customerData = {
                customer: {
                    firstName: vm.appointment.customerFirstName,
                    lastName: vm.appointment.customerLastName,
                    mobilePhone: vm.appointment.customerPhone
                },
                vehicle: {
                    year: vm.appointment.year,
                    make: appointmentUtilService.getDisplayMake(vm.appointment),
                    model: appointmentUtilService.getDisplayModel(vm.appointment),
                    vin: vm.appointment.vin
                }
            };
        }

        initCustomerData();
    }

})();
(function () {
    'use strict';

    angular.module('redcap.productmarketing', []);
})();
(function () {
    'use strict';

    ProductMarketingEmbeddedController.$inject = ["$sce", "$rootScope", "$stateParams", "$timeout", "resolvedMarketingURL", "resolvedMarketingConfig"];
    angular
        .module('redcap.productmarketing')
        .controller('ProductMarketingEmbeddedController', ProductMarketingEmbeddedController);

    function ProductMarketingEmbeddedController($sce, $rootScope, $stateParams, $timeout, resolvedMarketingURL, resolvedMarketingConfig) {
        var vm = this;
        vm.productName = _.startCase($stateParams.marketingArea);
        vm.marketingURL = $sce.trustAsResourceUrl(resolvedMarketingURL);
        vm.marketingConfig = resolvedMarketingConfig;
        $timeout(function () {
            $rootScope.$broadcast('setSelectedMarketingArea', _.startCase($stateParams.marketingArea));
        },1);

    }
})();
(function () {
    'use strict';

    InquireController.$inject = ["$scope", "supportService", "resolvedUser", "permissions", "ValidationService", "marketingConfig", "SYSTEM_ENUMS"];
    angular
        .module('redcap.productmarketing')
        .controller('InquireController', InquireController);

    function InquireController($scope, supportService, resolvedUser, permissions, ValidationService, marketingConfig, SYSTEM_ENUMS) {
        let vm = this;
        let currentUser = resolvedUser;
        let permissionConfigs = permissions.getPermissionsMarketingConfigs();
        
        vm.marketingConfig = marketingConfig;
        vm.permissions = permissions;
        vm.usStates = SYSTEM_ENUMS.usStateNames;

        vm.ticket = {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            phone: currentUser.mobilePhone,
            email: currentUser.email,
            company: null,
            title: null,
            comments: null,
            state: null,
            products: []
        };

        vm.titles = [
            "SERVICE ADVISOR",
            "SERVICE MANAGER",
            "SERVICE DIRECTOR",
            "GENERAL MANAGER",
            "BDC MANAGER",
            "OTHER"
        ];

        vm.productDropDownOptions = [];

        _.forEach(permissionConfigs, (permission) => {
            if (permission.marketingFormattedContent && permission.marketingFormattedContent.length > 0) {
                vm.productDropDownOptions.push({value: permission.id, text: permission.name});

                if (permission.id === vm.marketingConfig.id) {
                    vm.ticket.products.push(permission);
                }
            }
        });

        vm.productDropDownText = function(options) {
            let texts = _.map(options, (option) => {
                    return _.find(vm.productDropDownOptions, {'value': option.id}).text;
                });

            return _.join(texts, ', ');
        };

        vm.productDropDownSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            idProp: 'value',
            displayProp: 'text',
            buttonClasses: 'ellipsis-overflow'
        };

        vm.productDropDownStrings = {
            buttonDefaultText: 'Select product(s)'
        };

        vm.validation = {
            phone: function (fieldValue) {
                fieldValue = fieldValue.replace(/\D/g, '');

                return {isValid: fieldValue.length === 10, message: 'Field is required.'};
            },
            productSelected: function (fieldValue) {
                return {isValid: fieldValue.length > 0, message: 'Field is required.'};
            }
        };

        vm.submitInquiry = function () {
            let myValidation = new ValidationService();
            let ticket = vm.ticket;
            let selectedProductIds = ticket.products;
            let interestestedInProducts = "INTERESTED IN: ";

            if (!myValidation.checkFormValidity($scope.submitInquiry)) {
                vm.submitted = true;

                return false;
            }

            _.forEach(selectedProductIds, (product, i) => {
                let  text = _.find(vm.productDropDownOptions, {'value': product.id}).text;

                interestestedInProducts += text;
                    
                if (i < selectedProductIds.length - 1) {
                    interestestedInProducts += ", ";
                }
            });

            ticket.description = ticket.comments + " " + interestestedInProducts;
        
            vm.submittingInquiry = true;
            supportService.marketingInquiry(ticket).then((response) => {
                vm.submittingInquiry = false;
                vm.sentSuccessfully = response;
            }, (errorResponse) => {
                vm.submittingInquiry = false;
            });
            
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('redcap.appointment')
        .component('appointmentServiceCenterTitle', {
            templateUrl: 'app/areas/appointment/components/appointment-service-center-title.component.view.html',
            controller: controller,
            controllerAs: 'vm',
            bindings: {
                'ngModel': '<'
            }
        });

    function controller() {
        this.$onInit = function() {
            var vm = this;
            vm.appointment = vm.ngModel;
        };
    }
})();

(function () {
    "use strict";
    periPaymentsService.$inject = ["consumerApi", "rcApi"];
    angular
        .module("redcap.payments")
        .factory("periPaymentsService", periPaymentsService);
    function periPaymentsService(consumerApi, rcApi) {
        var PAYMENT_BASEPATH = "payment/peri/";
        return {
            createTransaction: createTransaction,
            verifyPayment: verifyPayment,
            verifyDashboardPayment: verifyDashboardPayment,
            getTerminals: getTerminals
        };
        function createTransaction(dealerId, invoiceGuid, redirectUrl) {
            return consumerApi.post(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceGuid + '/createTransaction',
                {
                    redirectUrl: redirectUrl
                });
        }
        function verifyPayment(dealerId, invoiceGuid, transactionId) {
            return consumerApi.get(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceGuid + '/consumerPay/' + transactionId);
        }
        function verifyDashboardPayment(dealerId, invoiceId, transactionId) {
            return rcApi.get(PAYMENT_BASEPATH + dealerId + '/invoices/' + invoiceId + '/pay/' + transactionId);
        }
        function getTerminals(dealerId) {
            return rcApi.get(PAYMENT_BASEPATH + dealerId + '/terminals');
        }
    }
})();

(function () {
    "use strict";

    paymentService.$inject = ["SYSTEM_ENUMS", "rcApi"];
    angular
        .module("redcap.payments")
        .factory("paymentService", paymentService);

    function paymentService(SYSTEM_ENUMS, rcApi) {
        let PAYMENT_BASEPATH = "payment/";

        return {
            getInitializedToken: getInitializedToken,
            getCardsOnFile: getCardsOnFile,
            deleteCard: deleteCard,
            submitPayment: submitPayment,
            getInvoices: getInvoices,
            getInvoice: getInvoice,
            createInvoice: createInvoice,
            editLineItems: editLineItems,
            processPayment: processPayment,
            getPaymentConfig: getPaymentConfig,
            sendMessage: sendMessage,
            archiveInvoice: archiveInvoice,
            unarchiveInvoice: unarchiveInvoice,
            getTerminals: getTerminals,
            collectPayment: collectPayment,
            getDefaultMessage: getDefaultMessage,
            filterPaymentLineItemTypes: filterPaymentLineItemTypes,
            getInvoicesWithTotalCount: getInvoicesWithTotalCount,
            refundPayment: refundPayment,
            getPaymentDetails: getPaymentDetails,
            cancelInvoice: cancelInvoice
        };

        function getInitializedToken(repairOrderId) {
            return rcApi.post(PAYMENT_BASEPATH + 'initialize', {
                repairOrderId: repairOrderId
            }).then((response) => {
                return response;
            });
        }

        function submitPayment(amount, address, city, state, zip, tokenId, repairOrderId) {
            return rcApi.post(PAYMENT_BASEPATH + 'pay', {
                amount: amount,
                address: address,
                city: city,
                state: state,
                zip: zip,
                tokenId: tokenId,
                repairOrderId: repairOrderId
            }).then((response) => {
                return response;
            });
        }

        function collectPayment(invoiceId, terminalId, isManualEntry) {
            return rcApi.post(PAYMENT_BASEPATH + 'collect', {
                invoiceId: invoiceId,
                terminalId: terminalId,
                isManualEntry: isManualEntry || false
            });
        }

        function getCardsOnFile(repairOrderId) {
            return rcApi.get(PAYMENT_BASEPATH + 'cardsonfile/' + repairOrderId);
        }

        function refundPayment(invoiceId) {
            return rcApi.post(PAYMENT_BASEPATH + 'refund/' + invoiceId);
        }

        function getPaymentDetails(invoiceId) {
            return rcApi.get(PAYMENT_BASEPATH + 'paymentdetails/' + invoiceId);
        }

        function deleteCard(repairOrderId, cardId) {
            return rcApi.remove(PAYMENT_BASEPATH + 'cardsonfile/', {
                repairOrderId: repairOrderId,
                cardId: cardId
            }).then((response) => {
                return response;
            });
        }

        function getInvoicesWithTotalCount(searchString, dealerId, createdBy, invoiceStatus, showArchived, page, pageSize, sortDirection, sortType) {
            return rcApi.get(PAYMENT_BASEPATH + 'invoicesWithTotalCount/', {
                search: searchString || null,
                locationId: dealerId || null,
                createdBy: createdBy || null,
                invoiceStatus: invoiceStatus || null,
                showArchived: showArchived || null,
                page: page || 0,
                pageSize: pageSize || 25,
                sortDir: sortDirection || "asc",
                sortType: sortType || "Customer"
            }).then((response) => {
                return response;
            });
        }

        function getInvoices(searchString, dealerId, createdBy, invoiceStatus, showArchived, page, pageSize, sortDirection, sortType) {
            return rcApi.get(PAYMENT_BASEPATH + 'invoices/', {
                search: searchString || null,
                locationId: dealerId || null,
                createdBy: createdBy || null,
                invoiceStatus: invoiceStatus || null,
                showArchived: showArchived || null,
                page: page || 0,
                pageSize: pageSize || 25,
                sortDir: sortDirection || "asc",
                sortType: sortType || "Customer"
            }).then((response) => {
                return response;
            });
        }

        function getInvoice(invoiceId) {
            return rcApi.get(PAYMENT_BASEPATH + 'invoice/' + invoiceId).then((response) => {
                return response;
            });
        }

        function editLineItems(invoice) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/edit', {
                invoiceId: invoice.id,
                lineItems: invoice.lineItems.map((item) => {
                    return {
                        type: item.type,
                        repairOrderId: (item.repairOrder && item.repairOrder.repairOrderId && item.repairOrder.repairOrderId[0]) || null,
                        externalCustomerId: item.externalCustomerId || item.loanerUpcharge && item.loanerUpcharge.externalCustomerId || null,
                        externalContractId: item.externalContractId || item.loanerUpcharge && item.loanerUpcharge.externalContractId || null,
                        externalReservationId: item.externalReservationId || item.loanerUpcharge && item.loanerUpcharge.externalReservationId || null,
                        description: item.description,
                        amount: item.amount,
                        createNew: item.createNew,
                        repairOrderNumber: item.roNumber
                    };
                })
            });
        }

        function createInvoice(invoice) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice', invoice);
        }

        function processPayment(payment) {
            return rcApi.post(PAYMENT_BASEPATH + 'process', payment);
        }

        function getPaymentConfig(locationId) {
            return rcApi.get(PAYMENT_BASEPATH + 'configuration', {locationId: locationId});
        }

        function getTerminals(locationId) {
            return rcApi.get(PAYMENT_BASEPATH + 'terminals', {locationId: locationId});
        }

        function getDefaultMessage(invoiceId, dealerSystemTripTypeId) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/message', {invoiceId: invoiceId, dealerSystemTripTypeId: dealerSystemTripTypeId || null});
        }

        function sendMessage(invoiceId, message, allowedTripTypes, deliveryOptions) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/send', {
                invoiceId: invoiceId,
                message: message,
                allowedTripTypes: allowedTripTypes || [],
                deliveryOptions: deliveryOptions
            });
        }

        function archiveInvoice(invoiceId) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/archive', {invoiceId: invoiceId});
        }

        function unarchiveInvoice(invoiceId) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/unarchive', {invoiceId: invoiceId});
        }

        function cancelInvoice(invoiceId) {
            return rcApi.post(PAYMENT_BASEPATH + 'invoice/cancel', {invoiceId: invoiceId});
        }

        function filterPaymentLineItemTypes (loanerChargesEnabled) {
            let lineItemOptions = Object.values(SYSTEM_ENUMS.invoiceLineItemTypes).filter((item) => {
                let types = SYSTEM_ENUMS.invoiceLineItemTypes;

                if (loanerChargesEnabled === false) {
                    return item.id !== types.delivery.id && 
                        item.id !== types.discount.id && 
                        item.id !== types.loanerUpcharge.id;
                } else {
                    return item.id !== types.delivery.id && 
                        item.id !== types.discount.id;
                }
            });

            return lineItemOptions;
        }
    }

})();


(function () {
    "use strict";

    paymentModalService.$inject = ["$q", "$uibModal", "paymentService", "periPaymentsService", "modalService", "SYSTEM_ENUMS", "$rootScope"];
    angular
        .module("redcap.payments")
        .factory("paymentModalService", paymentModalService);

    function paymentModalService($q, $uibModal, paymentService, periPaymentsService, modalService, SYSTEM_ENUMS, $rootScope) {
        return {
            payNow: payNow, // NEEDS
            archive: archive,
            unarchive: unarchive,
            getLink: getLink,
            refund: refund, // NEEDS
            cancel: cancel
        };

        function showPeriModal(invoice, deferred) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/payments/views/modals/peri-pay-now-modal.view.html',
                controllerAs: 'vm',
                controller: 'periPayNowModalController',
                windowClass: 'top-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedInvoice: function () { return invoice; },
                    resolvedPaymentConfig: function () {
                        return paymentService.getPaymentConfig(invoice.dealerId);
                    },
                    resolvedTerminals: function () {
                        return periPaymentsService.getTerminals(invoice.dealerId);
                    }
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });
        }

        function showCenPosModal(invoice, deferred) {

            let modal = $uibModal.open({
                templateUrl: 'app/areas/payments/views/modals/cenpos-pay-now-modal.view.html',
                controllerAs: 'vm',
                controller: 'CenPosPayNowModalController',
                windowClass: 'top-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedInvoice: function () { return invoice; },
                    resolvedPaymentConfig: function () {
                        return paymentService.getPaymentConfig(invoice.dealerId);
                    }
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });
        }

        function showCardConnectModal(invoice, deferred) {

            let modal = $uibModal.open({
                templateUrl: 'app/areas/payments/views/modals/cardconnect-pay-now-modal.view.html',
                controllerAs: 'vm',
                controller: 'CardConnectPayNowModalController',
                windowClass: 'top-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedInvoice: function () { return invoice; },
                    resolvedPaymentConfig: function () {
                        return paymentService.getPaymentConfig(invoice.dealerId);
                    },
                    resolvedTerminals: function() {
                        return paymentService.getTerminals(invoice.dealerId);
                    }
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });
        }

        function payNow(invoice) {
            let deferred = $q.defer();

            switch (invoice.paymentProcessor) {
                case SYSTEM_ENUMS.paymentProcessorsEnum.cenPos:
                    showCenPosModal(invoice, deferred);
                    break;
                case SYSTEM_ENUMS.paymentProcessorsEnum.cardConnect:
                    showCardConnectModal(invoice, deferred);
                    break;
                case SYSTEM_ENUMS.paymentProcessorsEnum.peri:
                    showPeriModal(invoice, deferred);
                    break;
            }

            return deferred.promise;
        }

        function archive(invoiceId) {
            let deferred = $q.defer();

            let modal = $uibModal.open({
                    templateUrl: 'app/shared/modal/yesno.html',
                    controllerAs: 'vm',
                    windowClass: 'top-modal',
                    controller: ["$uibModalInstance", function ($uibModalInstance) {
                        let vm = this;

                        vm.title = 'Are you sure?';
                        vm.body = 'Are you sure you want to archive this record?';
                        vm.noText = 'No';
                        vm.yesText = 'Yes';
                        vm.hideClose = false;

                        vm.close = function (choice) {
                            if (choice) {
                                paymentService.archiveInvoice(invoiceId).then(() => {
                                    $uibModalInstance.close(true);
                                });
                            } else {
                                $uibModalInstance.close(false);
                            }
                        };
                    }],
                    backdrop: 'static',
                    keyboard: false
                }
            );

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function unarchive(invoiceId) {
            let deferred = $q.defer();

            let modal = $uibModal.open({
                    templateUrl: 'app/shared/modal/yesno.html',
                    controllerAs: 'vm',
                    windowClass: 'top-modal',
                    controller: ["$uibModalInstance", function ($uibModalInstance) {
                        let vm = this;

                        vm.title = 'Are you sure?';
                        vm.body = 'Are you sure you want to unarchive this record?';
                        vm.noText = 'No';
                        vm.yesText = 'Yes';
                        vm.hideClose = false;

                        vm.close = function (choice) {
                            if (choice) {
                                paymentService.unarchiveInvoice(invoiceId).then(() => {
                                    $uibModalInstance.close(true);
                                });
                            } else {
                                $uibModalInstance.close(false);
                            }
                        };
                    }],
                    backdrop: 'static',
                    keyboard: false
                }
            );

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function getLink(invoice) {
             let deferred = $q.defer();

             let modal = $uibModal.open({
                 templateUrl: 'app/areas/payments/views/modals/get-link-modal.view.html',
                 controllerAs: 'vm',
                 controller: 'PaymentGetLinkModalController',
                 backdrop: 'static',
                 windowClass: 'top-modal',
                 keyboard: false,
                 resolve: {
                     resolvedInvoice: function () { return invoice; }
                 }
             });

             modal.result.then((result) => {
                 deferred.resolve(result);
             }, () => {
                 deferred.reject();
             });

             return deferred.promise;
         }

        function refund(invoice) {
            let deferred = $q.defer();

            switch (invoice.paymentProcessor) {
                case SYSTEM_ENUMS.paymentProcessorsEnum.cenPos:
                case SYSTEM_ENUMS.paymentProcessorsEnum.cardConnect:
                return otherRefund(invoice, deferred);
            case SYSTEM_ENUMS.paymentProcessorsEnum.peri:
                periRefund(invoice, deferred);
                break;
            }

            return deferred.promise;
        }

        function periRefund(invoice, deferred) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/payments/views/modals/peri-refund-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: 'PeriPaymentRefundModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedInvoice: function () { return invoice; },
                    resolvedPaymentConfig: function () {
                        return paymentService.getPaymentConfig(invoice.dealerId);
                    }
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function otherRefund(invoice, deferred) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/payments/views/modals/refund-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: 'PaymentRefundModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedInvoice: function () { return invoice; },
                    resolvedPaymentConfig: function () {
                        return paymentService.getPaymentConfig(invoice.dealerId);
                    }
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function cancel(invoiceId) {
            let deferred = $q.defer();

            let modal = $uibModal.open({
                    templateUrl: 'app/shared/modal/yesno.html',
                    controllerAs: 'vm',
                    windowClass: 'top-modal',
                    controller: ["$uibModalInstance", function ($uibModalInstance) {
                        let vm = this;

                        vm.title = 'Cancel Invoice';
                        vm.body = 'Are you sure you want to cancel this invoice?';
                        vm.noText = 'No';
                        vm.yesText = 'Yes';
                        vm.hideClose = false;

                        vm.close = function (choice) {
                            if (choice) {
                                paymentService.cancelInvoice(invoiceId).then((response) => {
                                    $uibModalInstance.close(true);
                                    modalService.showYesNo('Confirmation', 'Invoice has been cancelled.', null, 'OK').then((response) => {
                                        if (response) {
                                            $rootScope.$broadcast('refresh:invoices');
                                        }
                                    });
                                });
                            } else {
                                $uibModalInstance.close(false);
                            }
                        };
                    }],
                    backdrop: 'static',
                    keyboard: false
                }
            );

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }
    }

})();

(function () {
    'use strict';
    periPaymentController.$inject = ["$sce", "$state", "periPaymentsService"];
    angular
        .module('redcap.payments')
        .component('periDashboardPayment', {
            templateUrl: 'app/areas/payments/views/partials/peri-payment.view.html',
            controller: periPaymentController,
            controllerAs: 'vm',
            bindings: {
                'params': '<',
                'transactionData': '=',
            }
        });

    function periPaymentController($sce, $state, periPaymentsService) {
       

        this.$onInit = function () {
            let vm = this;

            vm.PAYMENT_VIEW_STATES = {
                INITIAL_LOADING: 0,
                IN_PROGRESS: 1
            };
            vm.currentState = vm.PAYMENT_VIEW_STATES.INITIAL_LOADING;

            let host = `${location.protocol}//${location.host}`;
            let path = $state.href('payment-peri-dashboard-processed');
            let redirectUrl = `${host}${path}`;

            periPaymentsService.createTransaction(vm.params.dealerId, vm.params.invoiceGuid, redirectUrl).then(
                (response) => {
                    vm.transactionData = response;
                    vm.url = $sce.trustAsResourceUrl(response.url);

                });

            vm.iFrameOnload = () => {
                vm.currentState = vm.PAYMENT_VIEW_STATES.IN_PROGRESS;
            };
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('redcap.payments')
        .controller('periDashboardVerifyController', periDashboardVerifyController);

    function periDashboardVerifyController() {
        window.parent.angular.element('#smsIFrame').scope().$emit('peri-validate-dashboard-transaction');
    }
})();

(function () {
    'use strict';

    paymentSendLinkController.$inject = ["$scope", "$rootScope", "$state", "$transition$", "resolvedInvoice", "authService", "paymentService", "rideProviderService", "SYSTEM_ENUMS", "toastr", "modalService"];
    angular
        .module('redcap.payments')
        .controller('PaymentSendLinkController', paymentSendLinkController);

    function paymentSendLinkController($scope, $rootScope, $state, $transition$, resolvedInvoice, authService, paymentService, rideProviderService, SYSTEM_ENUMS, toastr, modalService) {
        let vm = this;
        let currentUser = authService.getCurrentUser();
        let fromPaymentList = $transition$.params().fromPaymentList || false;
        let partsOnDemandTypeId = SYSTEM_ENUMS.systemTripType.partsOnDemand;

        vm.message = null;
        vm.invoice = resolvedInvoice;
        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.allowedBookingTypes = _.map(resolvedInvoice.allowedBookingTypes || [], (item) => {
            return {
                dealerSystemTripTypeId: item.dealerSystemTripTypeId,
                dealerTripTypeId: item.dealerTripTypeId,
                invoiceLineItemAllowedDealerSystemTripTypeId: item.invoiceLineItemAllowedDealerSystemTripTypeId,
                dashboardDescription: item.dashboardDescription,
                allowed: item.allowed || false  //if null (unset), uncheck by default
            };
        });

        // Delivery Options / Settings
        
        vm.delivery = {
            types: {
                chargeTypes: [
                    {value: 0, text: 'Credit Card'},
                    {value: 1, text: 'Bill To Account'}
                ],
                paymentTypes: [
                    {value: 0, text: 'Customer Pays'},
                    {value: 1, text: 'Dealer Pays'},
                    {value: 2, text: '$ Discount'},
                    {value: 3, text: '% Discount'}
                ]
            },
            config: {
                hereMapOptions: {
                    watchEnter: true,
                    country: 'us,can',
                    startLat: resolvedInvoice.dealerAddress.lat,
                    startLng: resolvedInvoice.dealerAddress.lng
                }
            },
            dealerAddress: resolvedInvoice.dealerAddress,
            options: {
                discountAmount: 0,
                chargeType: null,
                paymentType: null,
                rideProviderDetails: null,
                address: null
            }
        };

        function checkLineItems() {
            // No need to check if empty
            if (resolvedInvoice.lineItems == null || resolvedInvoice.lineItems.length === 0) { return; }

            // Returns first delivery line item / there should only be one
            let deliveryLineItem = resolvedInvoice.lineItems.find((item) => {
                return item.type === SYSTEM_ENUMS.invoiceLineItemTypes.delivery.id;
            });

            // No delivery line item found, return
            if (deliveryLineItem == null || deliveryLineItem.childLineItems == null) { return; }

            // Returns first discount line item (with the parent id of the delivery item) / there should only be one
            let discountLineItem = deliveryLineItem.childLineItems.find((item) => {
                return item.type !== SYSTEM_ENUMS.invoiceLineItemTypes.delivery.id && item.parentLineItemId === deliveryLineItem.id;
            });

            // Update delivery options
            vm.delivery.options = {
                discountAmount: discountLineItem ? discountLineItem.amount.toFixed(2) : 0.00,
                chargeType: deliveryLineItem && deliveryLineItem.deliveryOptions ? deliveryLineItem.deliveryOptions.chargeType : null,
                paymentType: discountLineItem && discountLineItem.discountOptions ? discountLineItem.discountOptions.paymentType : null,
                address: deliveryLineItem && deliveryLineItem.deliveryOptions ? deliveryLineItem.deliveryOptions.address : null,
                addressDetails: deliveryLineItem && deliveryLineItem.deliveryOptions ? deliveryLineItem.deliveryOptions.address : null,
                addressString: deliveryLineItem && deliveryLineItem.deliveryOptions && deliveryLineItem.deliveryOptions.address ? deliveryLineItem.deliveryOptions.address.formattedAddress : null
            };

            // Recalulate if address is populated
            if (deliveryLineItem.deliveryOptions && deliveryLineItem.deliveryOptions.address) {
                // Set the booking type to be Parts
                vm.selectedBookingType = _.find(vm.allowedBookingTypes, (bookingType) => { return bookingType.dealerSystemTripTypeId == partsOnDemandTypeId; });
                vm.updateRideProviderEstimates();
            }
        }

        function updateMessage(isPartsDeliverySelected) {
            paymentService.getDefaultMessage(resolvedInvoice.id, isPartsDeliverySelected ? partsOnDemandTypeId : null).then((message) => {
                vm.message = message;
            }, () => {
                // Default message (incase of error)
                vm.message = 'Hi ' + resolvedInvoice.customerFirstName + '. This is ' +
                currentUser.fullName + ' at ' + resolvedInvoice.dealerName +
                '. Your vehicle is ready! Please click the link below to view and pay your invoice and arrange the return of your vehicle. Thank you. ' +
                resolvedInvoice.consumerUrl;
            });
        }

        vm.bookingTypeChanged = function (bookingType) {
            vm.selectedBookingType = bookingType;

            // Parts Delivery
            if (bookingType.dealerSystemTripTypeId === partsOnDemandTypeId) {
                vm.allowedBookingTypes.filter((item) => {
                    return item.dealerSystemTripTypeId !== partsOnDemandTypeId;
                }).forEach((item) => {
                    // If selected, uncheck all other types
                    if (bookingType.allowed) {
                        item.allowed = false;
                    }

                    // Enable / disable others based on if "Parts Delivery" is selected
                    item.disabled = bookingType.allowed;
                });

            } // else continue as normal

            updateMessage(bookingType.dealerSystemTripTypeId === partsOnDemandTypeId && bookingType.allowed);
        };

        vm.isPartsDeliverySelected = function () {
            return vm.allowedBookingTypes
                .filter((item) => {
                    return item.allowed === true && item.dealerSystemTripTypeId === partsOnDemandTypeId;
                }).length !== 0;
        };

        vm.deliveryAddressUpdated = function (formattedAddress) {
            if (formattedAddress && formattedAddress.location && formattedAddress.location.lat) {
                vm.delivery.options.address = formattedAddress.location;
                vm.updateRideProviderEstimates();
            }
        };

        vm.deliveryAddressUpdatedBlur = function(addressString) {
            if (addressString == null || addressString.length == 0) {
                vm.delivery.options.address = null;
                vm.delivery.options.rideProviderDetails = null;
                vm.updateDeliverySummary();
            }
        };

        vm.isValid = function () {
            if (!vm.smsAgreement) return false;
            
            if (vm.isPartsDeliverySelected()) {
                // Charge type is complete
                if (vm.delivery.options.chargeType == null) { return false; }

                // Delivery payment is complete
                if (vm.delivery.options.paymentType == null) { return false; }

                // Delivery amount is complete if needed (dealer pays or $ or % discount)
                if ((vm.delivery.options.paymentType == 1 || vm.delivery.options.paymentType == 2 || vm.delivery.options.paymentType == 3) && (vm.delivery.options.discountAmount == null || Number(vm.delivery.options.discountAmount) <= 0)) { return false; }
                
                if (!vm.customerAgreedToTermsUber) { return false; }
            }

            return true;
        };

        vm.updateRideProviderEstimates = function () {
            vm.getRideProviderEstimates().then((response) => {
                let estimates = response.estimates;

                // Ensure we have estimates, and choose first one
                if (estimates !== null && estimates.length > 0) {
                    vm.delivery.options.rideProviderDetails = estimates[0];
                } else {
                    vm.delivery.options.rideProviderDetails = null;
                    let errorMsg = response.error ? response.error.errorMessage : 'Failed to find ride provider estimate.';

                    toastr.error(errorMsg);
                }

                /// Update pricing
                vm.updateDeliverySummary();
            });
        };

        vm.getRideProviderEstimates = function () {
            return rideProviderService.getEstimates(vm.invoice.dealerId, vm.selectedBookingType.dealerTripTypeId, vm.delivery.dealerAddress, vm.delivery.options.address, true);
        };

        vm.getCurrentRideProviderEstimate = function () {
            if (vm.delivery.options.rideProviderDetails != null) {
                return vm.delivery.options.rideProviderDetails.estimatedCostCents / 100;
            }

            return 0;
        };

        vm.getEstimatedDiscount = function () {
            if (vm.delivery.options.paymentType) {
                let estimate = vm.getCurrentRideProviderEstimate();

                switch (vm.delivery.options.paymentType) {
                    case 0: // Customer Pays
                        return 0;
                    case 1: // Dealer Pays
                        // If the estimate is more than the max amount, return the max amount.
                        // Else return the estimate (cause it is less than the max amount)
                        if (estimate > Number(vm.delivery.options.discountAmount)) {
                            return -Number(vm.delivery.options.discountAmount);
                        }

                        return -estimate;
                    case 2: // $ Discount
                        // If the estimate is more than the max amount, return the max amount.
                        // Else return the estimate (cause it is less than the max amount)
                        if (estimate > Number(vm.delivery.options.discountAmount)) {
                            return -Number(vm.delivery.options.discountAmount);
                        }

                        return -estimate;
                    case 3: // % Discount
                        return -vm.getCurrentRideProviderEstimate() * (Number(vm.delivery.options.discountAmount / 100) > 1 ? 1 : Number(vm.delivery.options.discountAmount) / 100);
                }
            }

            return 0;
        };

        vm.getPreviousTotal = function () {
            return vm.invoice.total; // Total without delivery charges
        };

        vm.getTotal = function () {
            return vm.getCurrentRideProviderEstimate() + vm.getEstimatedDiscount() + vm.getPreviousTotal();
        };

        vm.updateDeliverySummary = function () {
            // Add "Estimated", if needed
            let isEstimated = vm.delivery.options.paymentType == 3;
            let rideDeliveryCharge = vm.getCurrentRideProviderEstimate();
            let creditAmount = vm.getEstimatedDiscount();

            vm.chargeItems = [];
            vm.chargeItems.push({description: 'Previous Invoice Total', amount: vm.getPreviousTotal()});  // Previous Total
            vm.chargeItems.push({description: 'Estimated Parts On Demand delivery charge', amount: rideDeliveryCharge == 0 ? 'PENDING' : rideDeliveryCharge}); // Estimate Delivery Charge
            vm.chargeItems.push({description: 'Credit' + (isEstimated ? ' (Estimated)' : ''), amount: (creditAmount == 0 && rideDeliveryCharge == 0) ? 'PENDING' : creditAmount});  // Discount
            vm.chargeItems.push({description: 'Total Updated Invoice', amount: vm.getTotal(), isTotal: true});  // Total
        };

        // See if existing delivery / discounts, and populate delivery object
        checkLineItems();

        // Generate the initial message
        updateMessage();

        // Update disabled
        vm.allowedBookingTypes.forEach((item) => {
            if (vm.isPartsDeliverySelected() && item.dealerSystemTripTypeId != partsOnDemandTypeId) {
                item.disabled = true;
            }
        });

        vm.showTerms = function(evt, termsToShow) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }
            
            modalService.showCustomTerms(termsToShow);
        };

        // Update the buttons on the parent aside
        $rootScope.$broadcast('update:payment-aside-buttons',
            [{
                text: 'Cancel',
                style: 'btn-default',
                broadcastName: 'payment-edit-cancel'
            },
            {
                text: 'Send',
                style: 'btn-primary',
                isValid: vm.isValid,
                includeLadda: true,
                broadcastName: 'payment-edit-send'
            }
            ]);

        $scope.$on('payment-edit-cancel', (event) => {
            if (fromPaymentList) {
                $state.go('payments-list');
            } else {
                $state.go('payment-edit');
            }
        });

        $scope.$on('payment-edit-send', (event) => {
            if (!vm.message) {
                vm.submitted = true;

                return;
            }

            vm.sending = true;
            let allowedTripTypes = vm.allowedBookingTypes
                .filter((item) => {
                    return item.allowed === true;
                })
                .map((item) => {
                    return item.invoiceLineItemAllowedDealerSystemTripTypeId;
                });

            // Delivery options
            let delivery = null;

            if (vm.isPartsDeliverySelected()) {
                delivery = {
                    estimatedCostCents: vm.delivery.options.rideProviderDetails != null ? vm.delivery.options.rideProviderDetails.estimatedCostCents : 0,
                    address: vm.delivery.options.address,
                    discountAmount: vm.delivery.options.discountAmount,
                    chargeType: vm.delivery.options.chargeType,
                    paymentType: vm.delivery.options.paymentType,
                    rideProviderDetails: {
                        rideType: vm.delivery.options.rideProviderDetails != null ? vm.delivery.options.rideProviderDetails.rideType : null
                    }
                };
            }

            paymentService.sendMessage(resolvedInvoice.id, vm.message, allowedTripTypes, delivery).then(() => {
                vm.sending = false;
                $state.go('payment-edit', {}, {reload: true});
            }, (err) => {
                vm.sending = false;
            });
        });
    }
})();

(function () {
    'use strict';

    paymentsController.$inject = ["paymentService", "repairOrderService", "resolvedInvoice", "resolvedPayments", "modalService", "ValidationService", "$log", "$rootScope", "$scope", "$filter", "$timeout", "toastr"];
    angular
        .module('redcap.payments')
        .controller('PaymentsListController', paymentsController);

    function paymentsController(paymentService, repairOrderService, resolvedInvoice, resolvedPayments, modalService, ValidationService, $log, $rootScope, $scope, $filter, $timeout, toastr) {
        var vm = this;
        var resolvedRepairOrder = {};
        vm.resolvedRepairOrder = resolvedRepairOrder;
        vm.resolvedPayments = resolvedPayments;
    }
})();

(function () {
    'use strict';

    paymentsListController.$inject = ["paymentService", "paymentModalService", "locationService", "repairOrderService", "searchTemplateUtilService", "rcUtilService", "SAVED_SEARCHES_PLACEHOLDER", "SYSTEM_ENUMS", "systemService", "rcLocalStorageService", "$scope", "$state", "$filter", "$timeout", "$q"];
    angular
        .module('redcap.payments')
        .controller('PaymentsListController', paymentsListController);


    function paymentsListController(paymentService, paymentModalService, locationService, repairOrderService, searchTemplateUtilService, rcUtilService, SAVED_SEARCHES_PLACEHOLDER, SYSTEM_ENUMS, systemService, rcLocalStorageService, $scope, $state, $filter, $timeout, $q) {
        let vm = this;
        
        vm.page = 0;
        vm.pageSize = 25;
        vm.isLoading = false;
        vm.activeStatusAction = 0;
        vm.showAdvancedSearch  = false;
        searchTemplateUtilService.initSearchTemplateData(vm);
        vm.followingStatusCheckboxFilter = [];

        vm.actionsEnum = {
            send: 1,
            pay: 2,
            archive: 3,
            link: 4,
            unarchive: 5,
            refund: 6,
            cancel: 7
        };

        vm.invoiceStatusEnum = {
            all: undefined,
            draft: 1,
            unpaid: 2,
            paid: 3,
            authorized: 5,
            failedDelivery: 6,
            refunded: 7,
            cancelled: 8
        };

        vm.invoiceActiveStatuses = [
            {text: 'Active', value: 0},
            {text: 'Archived', value: 1}
        ];

        vm.createdByOptions = [
            {text: 'Me', value: 0},
            {text: 'Everyone', value: 1}
        ];

        vm.invoiceStatuses = [
            {text: 'All', value: vm.invoiceStatusEnum.all},
            {text: 'Draft', value: vm.invoiceStatusEnum.draft},
            {text: 'Unpaid (Sent)', value: vm.invoiceStatusEnum.unpaid},
            {text: 'Paid', value: vm.invoiceStatusEnum.paid},
            {text: 'Authorized', value: vm.invoiceStatusEnum.authorized},
            {text: 'Failed Delivery', value: vm.invoiceStatusEnum.failedDelivery},
            {text: 'Refunded', value: vm.invoiceStatusEnum.refunded},
            {text: 'Cancelled', value: vm.invoiceStatusEnum.cancelled}
        ];

        vm.refundActions = [
            {text: 'Action', value: undefined, disable: true},
            {text: 'Send/remind', value: vm.actionsEnum.send},
            {text: 'Archive', value: vm.actionsEnum.archive},
            {text: 'Get link', value: vm.actionsEnum.link}
        ];

        vm.paidActions = [
            {text: 'Action', value: undefined, disable: true},
            {text: 'Send/remind', value: vm.actionsEnum.send},
            {text: 'Refund', value: vm.actionsEnum.refund},
            {text: 'Archive', value: vm.actionsEnum.archive},
            {text: 'Get link', value: vm.actionsEnum.link}
        ];

        vm.otherStatusActions = [
            {text: 'Action', value: undefined, disable: true},
            {text: 'Send/remind', value: vm.actionsEnum.send},
            {text: 'Pay now', value: vm.actionsEnum.pay},
            {text: 'Archive', value: vm.actionsEnum.archive},
            {text: 'Get link', value: vm.actionsEnum.link}
        ];

        vm.unpaidActions = [
            {text: 'Action', value: undefined, disable: true},
            {text: 'Send/remind', value: vm.actionsEnum.send},
            {text: 'Pay now', value: vm.actionsEnum.pay},
            {text: 'Archive', value: vm.actionsEnum.archive},
            {text: 'Get link', value: vm.actionsEnum.link},
            {text: 'Cancel', value: vm.actionsEnum.cancel}
        ];

        vm.archivedActions = [
            {text: 'Action', value: undefined, disable: true},
            {text: 'Send/remind', value: vm.actionsEnum.send},
            {text: 'Pay now', value: vm.actionsEnum.pay},
            {text: 'Unarchive', value: vm.actionsEnum.unarchive},
            {text: 'Get link', value: vm.actionsEnum.link}
        ];

        vm.cancelledActions = [
            {text: 'Action', value: undefined, disable: true},
            {text: 'Archive', value: vm.actionsEnum.archive},
            {text: 'Get link', value: vm.actionsEnum.link}
        ];

        let initialFilters = { 
            searchText: null,
            selectedLocation: null,
            createdBy: vm.createdByOptions[0].value,
            selectedInvoiceStatus: vm.invoiceStatuses[0].value,
            selectedStatus: vm.invoiceActiveStatuses[0].value
        };

        let initialSort = {
            sortDirection: "asc",
            sortBy: "Customer"
        };
        
        let savedFilterKey = "paymentsListSavedFilterKey";
        let savedSortKey = "paymentsListSavedSortKey";
        let savedTemplateKey = "paymentsListSavedTemplateKey";
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};
        let existingSort = rcLocalStorageService.get(savedSortKey) || {};

        function updateDirtyFlag() {
            if (vm.searchTemplateData.currentSearchTemplate) {
                vm.searchTemplateData.isTemplateDirty = true;
            }
        }

        vm.toggleShowSearchOptions = function () {
            vm.advancedFilterSelectedLocation = vm.filters.selectedLocation;
            vm.searchTemplateBeforeAdvancedSearch = _.cloneDeep(vm.searchTemplateData);
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

            if (vm.showAdvancedSearch) {
                vm.runQuery();
            }

            vm.showAdvancedSearch  = !vm.showAdvancedSearch;

        };

        vm.runQuery = function () {
            vm.activeStatusAction = vm.filters.selectedStatus;
            createFilterMessage();
            vm.executeSearch();
            saveFilterSettings();
        };

        vm.applyBtnClicked = function () {
            vm.searchTemplateBeforeAdvancedSearch = null;
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            vm.filters.selectedLocation = vm.advancedFilterSelectedLocation;
            vm.runQuery();
        };

        vm.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vm.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };

        vm.resetFilters = function (linkClicked) {
            vm.templateName = null;
            vm.searchTemplateData.currentSearchTemplate = null;
            vm.searchTemplateData.savedSearchName = null;
            
            vm.filters.searchText = null;

            if (vm.availableLocations.length > 1) {
                vm.filters.selectedLocation = null;
            }

            vm.filters.createdBy = vm.createdByOptions[0].value;
            vm.filters.selectedInvoiceStatus = vm.invoiceStatuses[0].value;
            vm.filters.selectedStatus = vm.invoiceActiveStatuses[0].value;
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

            if (linkClicked) {
                vm.showAdvancedSearch = false;
            }

            if (!vm.showAdvancedSearch) {
                vm.runQuery();
            }
        };

        vm.clearSearchCriteria = function () {
            vm.keywordFilter = null;
            vm.isGlobalTemplate = false;
            vm.resetFilters();
        };
        

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vm.searchTemplateData.currentSearchTemplate.id = null;
            }
           
            searchTemplateUtilService.saveSearchTemplateClicked(vm, {
                selectedPaymentSearchText: vm.filters.searchText,
                selectedPaymentLocation: vm.advancedFilterSelectedLocation,
                selectedPaymentCreator: vm.filters.createdBy, 
                selectedPaymentInvoiceStatus: vm.filters.selectedInvoiceStatus, 
                selectedPaymentSelectedStatus: vm.filters.selectedStatus, 
                templateName: vm.searchTemplateData.savedSearchName
            }, SYSTEM_ENUMS.searchTemplateTypes.payment);
        }

        function finishLoadingTemplate() { 
            let template = vm.searchTemplateData.currentSearchTemplate.template;
          
            vm.filters.selectedLocation = template.selectedPaymentLocation;
            vm.filters.searchText = template.selectedPaymentSearchText;
            vm.filters.createdBy = template.selectedPaymentCreator;
            vm.filters.selectedInvoiceStatus = template.selectedPaymentInvoiceStatus;
            vm.filters.selectedStatus = template.selectedPaymentSelectedStatus;

            if (!vm.showAdvancedSearch) {
                vm.runQuery();
            }
        }
        
        vm.loadSearchTemplate = function (item, model) {
            if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                let template = item.template;
                let selectedLocationId = (template.selectedPaymentLocation && template.selectedPaymentLocation.id) || null;
                let templateDealer = $filter('filter')(vm.availableLocations, {id: selectedLocationId}, true);

                vm.filters.selectedLocation = null;
                vm.isLoading = true;
                vm.searchTemplateData.isTemplateDirty = false;
                vm.searchTemplateData.currentSearchTemplate = item;
                rcLocalStorageService.set(savedTemplateKey, vm.searchTemplateData.currentSearchTemplate);
                vm.searchTemplateData.savedSearchName = template.templateName;
                vm.templateName = template.templateName;
                
                if (templateDealer && templateDealer.length > 0) {
                    $timeout(() => {
                        vm.filters.selectedLocation = $filter('filter')(vm.availableLocations, {id: selectedLocationId}, true)[0];
                    }, 1);
                    
                }

                finishLoadingTemplate();
                        
            } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                rcLocalStorageService.set(savedTemplateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);
                vm.resetFilters();
            } else {
                rcLocalStorageService.set(savedTemplateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);

                if (!vm.showAdvancedSearch) {
                    vm.runQuery();
                }
            }
        };

        function loadSearchTemplates() {
            systemService.getSearchTemplates(SYSTEM_ENUMS.searchTemplateTypes.payment).then((templates) => {
                vm.searchTemplateData.searchTemplates = templates;
                loadLastTemplateAndFilters();
            });
        }

        function saveFilterSettings() {     
            rcLocalStorageService.set(savedFilterKey, vm.filters);
            rcLocalStorageService.set(savedSortKey, vm.sort);
            rcLocalStorageService.set(savedTemplateKey, vm.searchTemplateData.currentSearchTemplate);
        }

        function loadLastTemplateAndFilters () {
            vm.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate(savedTemplateKey);

            if (vm.searchTemplateData.currentSearchTemplate) {
                let searchItem = _.find(vm.searchTemplateData.searchTemplates, (item) => { return item.template.templateName === vm.searchTemplateData.currentSearchTemplate.template.templateName; });

                if (searchItem) {
                    vm.loadSearchTemplate(searchItem);
                } else {
                    vm.searchTemplateData.currentSearchTemplate = null;
                    vm.runQuery();
                }
            } 
        }

        vm.filterEvents = {
            onSelectionChanged: function () {
                vm.filterChanged();
            }
        };
        
        vm.filterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();

                if (!vm.showAdvancedSearch) {
                    vm.runQuery();
                }
            }, 1);
        };

        function createFilterMessage() {
            vm.filterCount = 0;
            vm.filterMessage = '';

            if (vm.filters.selectedLocation) {
                rcUtilService.buildFilterMessage('Location', vm.filters.selectedLocation.name, vm, false, true, 43);
            }

            if (vm.createdByOptions.some(option => option.value === vm.filters.createdBy)) {
                rcUtilService.buildFilterMessage('Created By', vm.createdByOptions.find(option => option.value === vm.filters.createdBy).text, vm, false, true, 43);
            }

            if (vm.filters.searchText) {
                rcUtilService.buildFilterMessage('Search Term', vm.filters.searchText, vm, false, true, 43);
            }

            if (Object.values(vm.invoiceStatusEnum).includes(vm.filters.selectedInvoiceStatus)) {
                rcUtilService.buildFilterMessage('Status',  vm.invoiceStatuses.find(option => option.value === vm.filters.selectedInvoiceStatus).text, vm);
            }

            if (vm.invoiceActiveStatuses.some(status => status.value === vm.filters.selectedStatus)) {
                rcUtilService.buildFilterMessage('Active Status', vm.invoiceActiveStatuses.find(option => option.value === vm.filters.selectedStatus).text, vm);
            }
        }

        vm.selectedrow = [];

        vm.locationSelected = function () {
            vm.filterChanged();
        };

        this.executeSearch = function() {
            vm.isLoading = true;
            vm.invoices = [];
            vm.page = 0;
            vm.getInvoices((results) => {
                return results;
            });
        };

        this.displayMore = function() {
            if (!vm.isLoading && vm.canShowMore) {
                vm.isLoading = true;
                vm.page = vm.page + 1;
                vm.getInvoices((results) => {
                    return vm.invoices.concat(results);
                });
            }
        };

        vm.getInvoices = function (resultsHandler) {
            let selectedLocationId = (vm.filters.selectedLocation && vm.filters.selectedLocation.id) || null;
            let createdBy = vm.filters.createdBy;
        
            saveFilterSettings();
            
            paymentService.getInvoicesWithTotalCount(vm.filters.searchText, selectedLocationId, createdBy, vm.filters.selectedInvoiceStatus, vm.filters.selectedStatus, vm.page, vm.pageSize, vm.sort.sortDirection, vm.sort.sortBy).then((results) => {
                vm.totalCount = results.totalReturnedResults;
                let resultsInvoices = results.resultsInvoices || [];

                vm.invoices = resultsHandler(resultsInvoices);
                vm.canShowMore = vm.invoices.length < vm.totalCount;

                vm.isLoading = false;
            });
        };

        vm.loadModal = function(item) {
            if (item.hasPayments) {
                $state.go('payment-payments-list', {id: item.id});
            } else {
                if (item.canProcessPayment) {
                    $state.go('payment-invoice-send', {id: item.id});
                } else {
                    $state.go('payments-not-configured', {id: item.id});
                }
            }
        };

        vm.getPaidActions = function(invoice) {
            if (invoice.paymentProcessor === SYSTEM_ENUMS.paymentProcessorsEnum.peri) {
                return vm.paidActions;
            } else {
                return vm.paidActions.filter(action => action.value !== vm.actionsEnum.refund);
            }
        };

        vm.actionSelected = function (invoiceId, rowId) {
            switch (vm.selectedrow[rowId]) {
                case vm.actionsEnum.send:
                    $state.go('payment-send-link', {invoiceId: invoiceId, fromPaymentList: true});
                break;
                case vm.actionsEnum.pay:
                    paymentService.getInvoice(invoiceId).then((invoice) => {
                        paymentModalService.payNow(invoice);
                    });
                break;
                case vm.actionsEnum.archive:
                    paymentModalService.archive(invoiceId).then((result) => {
                        if (result) {
                            vm.invoices.splice(rowId, 1);
                        }
                    });
                    break;
                case vm.actionsEnum.link:
                    paymentService.getInvoice(invoiceId).then((invoice) => {
                        paymentModalService.getLink(invoice);
                    });
                    break;
                case vm.actionsEnum.unarchive:
                    paymentModalService.unarchive(invoiceId).then((result) => {
                        if (result) {
                            vm.invoices.splice(rowId, 1);
                        }
                    });
                    break;
                case vm.actionsEnum.refund:
                    paymentService.getInvoice(invoiceId).then((invoice)  => {
                        paymentModalService.refund(invoice);
                    });
                    break;
                case vm.actionsEnum.cancel:
                    paymentModalService.cancel(invoiceId);
                    break;
            }

            vm.selectedrow[rowId] = undefined;

            return false;
        };

        vm.getLineItemTypes = function (items) {
            return items.map((val) => {
                 return val.lineItemType;
            }).filter((val, index, self) => {
                return self.indexOf(val) === index;
            }).join(', ');
        };


        $scope.$on('refresh:invoices', () => {
            vm.runQuery();
        });

        vm.saveSort = function() {
            rcLocalStorageService.set(savedSortKey, vm.sort);
        };

        vm.sortChanged = function (sortBy, sortOrder, fromMobile) {
            let d = $q.defer();

            vm.sort.sortBy = sortBy;
            vm.sort.sortDirection = sortOrder;
            vm.searchingPayment = true;
            vm.saveSort();
            vm.runQuery();
            
            d.resolve(null);

            return d.promise;
        };
        
        
        vm.filters = _.extend({}, initialFilters, existingFilters);

        function init() {
            vm.filters = _.extend({}, initialFilters, existingFilters);
            vm.sort = _.extend({}, initialSort, existingSort);
            vm.searchTemplateData.currentSearchTemplate = rcLocalStorageService.get(savedTemplateKey) || null;
            let selectedLocationId = (vm.filters.selectedLocation && vm.filters.selectedLocation.id) || null;

            paymentService.getInvoices(vm.filters.searchText, selectedLocationId, vm.filters.createdBy, vm.filters.selectedInvoiceStatus, vm.filters.selectedStatus, null, null, vm.sort.sortDirection, vm.sort.sortBy).then((paymentResults) => {
                vm.invoices = paymentResults;
                repairOrderService.getDealersForDropdown(SYSTEM_ENUMS.permissionTypes.payments).then((locationResults) => {
                    vm.availableLocations = locationResults;

                    if (selectedLocationId) {
                        vm.filters.selectedLocation = $filter('filter')(vm.availableLocations, {id: selectedLocationId})[0];
                    } else if (vm.availableLocations.length === 1) {
                        vm.filters.selectedLocation = vm.availableLocations[0];
                    }

                    vm.canShowMore = vm.invoices.length === vm.pageSize;
                    loadSearchTemplates();
                });
                
            });
        }

        init();

        vm.close = function () {
            searchTemplateUtilService.advancedFilterModalClosed(vm);
        };
    
    }

})();

(function () {
    'use strict';

    paymentInvoiceSendController.$inject = ["paymentService", "repairOrderService", "resolvedInvoice", "modalService", "SYSTEM_ENUMS", "ValidationService", "$q", "$log", "$rootScope", "$scope", "$state", "$filter", "$timeout", "toastr"];
    angular
        .module('redcap.payments')
        .controller('PaymentInvoiceSendController', paymentInvoiceSendController);

    var sendTypes = {
        sms: 'sms',
        manual: 'manual'
    };

    function paymentInvoiceSendController(paymentService, repairOrderService, resolvedInvoice, modalService, SYSTEM_ENUMS, ValidationService, $q, $log, $rootScope, $scope, $state, $filter, $timeout, toastr) {
        var vm = this;
        vm.loadingData = false;
        var resolvedRepairOrder = {};
        vm.sendTypes = sendTypes;
        vm.resolvedRepairOrder = resolvedRepairOrder;
        vm.sendType = sendTypes.sms;
        vm.usStates = SYSTEM_ENUMS.usStates;
        var amount = (resolvedRepairOrder.customerTotal || 0) - (resolvedRepairOrder.paidAmount || 0);
        vm.amount = (amount > 0 ? amount : 0).toFixed(2);
        vm.smsNumber = resolvedRepairOrder.customerPhone;

        vm.deleteCard = function (tokenId) {
            modalService.showYesNo("Are You Sure?", "Are you sure you want to delete this card?", "No", "Yes").then(function (result) {
                if (result) {

                    vm.loadingData = true;
                    vm.cardToken = null;
                    paymentService.deleteCard(resolvedRepairOrder.id, tokenId).then(function (response) {
                        vm.loadCardsOnFile().then(function () {
                            vm.loadingData = false;
                        });
                    });
                }
            });
        };

        function successCallback(result) {
            vm.cardsOnFile.splice(vm.cardsOnFile.length -1, 0, {
                text: result.CardType +
                    ' ****' + result.ProtectedCardNumber.substr(result.ProtectedCardNumber.length - 4) +
                    ' ' + result.CardExpirationDate.substr(0, 2) + '/' + result.CardExpirationDate.substr(2, 2),
                value: result.RecurringSaleTokenId
            });

            vm.cardToken = result.RecurringSaleTokenId;
        }

        function cancelCallback(result) {
            console.log('error:' + JSON.stringify(result));
        }

        vm.loadPaymentWindow = function() {
            vm.paymentContainer = $("#payment-provider");
            vm.showCC = true;
            vm.paymentContainer.createWebpay({
                url: 'https://www.cenpos.net/simplewebpay/cards',
                height: 400,
                sessionToken: false,
                params: "isCvv=true" +
                    "&verifyingpost=" +
                    vm.resolvedInitializationToken.data,
                success: successCallback,
                cancel: cancelCallback
            });
        };

        vm.cardChanged = function() {
            if (vm.cardToken === '0') {
                vm.loadPaymentWindow();
            }
        };

        vm.addCard = function() {
            vm.paymentContainer.submitAction();
        };

        vm.submitPayment = function() {
            vm.submittingPayment = true;
            paymentService.submitPayment(vm.amount,
                vm.billingAddress,
                vm.billingCity,
                vm.billingState,
                vm.billingZip,
                vm.cardToken,
                resolvedRepairOrder.id).then(function(result) {
                $state.go('repair-order-payments-list', { id: resolvedRepairOrder.id });
                vm.submittingPayment = false;
            }).catch(function(err) {
                vm.submittingPayment = false;
            });
        };

        vm.sendSmsInvoice = function () {
            repairOrderService.sendSmsInvoice(resolvedRepairOrder.id, vm.smsText, vm.smsNumber, vm.amount).then(
                function() { });
        };

        vm.submitForm = function() {
            if (new ValidationService().checkFormValidity($scope.paymentForm)) {
                switch (vm.sendType) {
                case sendTypes.sms:
                    vm.sendSmsInvoice();
                    break;
                case sendTypes.manual:
                    vm.submitPayment();
                    break;
                }
            }
            return false;
        };

        vm.manuallySelected = function() {
            vm.loadingData = true;
            $q.all([
                vm.loadInitializationToken(),
                vm.loadCardsOnFile()
            ]).then(function(data) {
                vm.loadingData = false;
            });
        };

        $scope.$watch('vm.sendType', function () {
            if (vm.sendType === sendTypes.manual) {
                vm.manuallySelected();
            }
        });


        vm.loadInitializationToken = function() {
            return paymentService.getInitializedToken(resolvedRepairOrder.id).then(
                function(resolvedInitializationToken) {
                    return vm.resolvedInitializationToken = resolvedInitializationToken;
                });
        };

        vm.loadCardsOnFile = function() {
            return paymentService.getCardsOnFile(resolvedRepairOrder.id).then(function(resolvedCardsOnFile) {
                vm.cardsOnFile = _.map(resolvedCardsOnFile,
                    function(item) {
                        return {
                            text: item.cardType +
                                ' ****' +
                                item.cardNumber +
                                ' ' +
                                item.cardExpirationDate.substr(0, 2) +
                                '/' +
                                item.cardExpirationDate.substr(2, 2),
                            value: item.tokenId
                        };
                    });

                var count = vm.cardsOnFile.length;

                vm.cardsOnFile.push({
                    text: 'USE ANOTHER CARD',
                    value: '0'
                });

                if (count === 0) vm.cardToken = 0;
                if (count === 1) vm.cardToken = vm.cardsOnFile[0].tokenId;


                return vm.cardsOnFile;
            });
        };
    }
})();

(function () {
    'use strict';

    paymentEditController.$inject = ["$scope", "$rootScope", "resolvedInvoice", "SYSTEM_ENUMS", "paymentModalService", "paymentService", "$state"];
    angular
        .module('redcap.payments')
        .controller('PaymentEditController', paymentEditController);

    function paymentEditController($scope, $rootScope, resolvedInvoice, SYSTEM_ENUMS, paymentModalService, paymentService, $state) {
        let vm = this;

        vm.resolvedInvoice = resolvedInvoice;
        vm.invoiceStatus = SYSTEM_ENUMS.invoiceStatus;
        vm.canRefund = vm.resolvedInvoice.paymentProcessor === SYSTEM_ENUMS.paymentProcessorsEnum.peri;

        // Reset the buttons on the parent aside
        $rootScope.$broadcast('update:payment-aside-buttons', null);

        vm.fixAmounts = function () {
            vm.tax = 0;
            vm.fee = 0;
            vm.shopSupplies = 0;
            vm.resolvedInvoice.lineItems &&
                _.each(vm.resolvedInvoice.lineItems,
                    (item) => {
                        if (item.tax) {
                            vm.tax += parseFloat(item.tax);
                        }

                        if (item.fee) {
                            vm.fee += parseFloat(item.fee);
                        }

                        if (item.shopSupplies) {
                            vm.shopSupplies += parseFloat(item.shopSupplies);
                        }

                        item.amount = parseFloat(item.amount || 0).toFixed(2);
                    });
        };

        vm.fixAmounts();

        vm.sendLink = function () {
            $state.go('payment-send-link', {invoiceId: vm.resolvedInvoice.id});
        };

        vm.payNow = function () {
            return paymentModalService.payNow(vm.resolvedInvoice).then(() => {
                vm.refreshInvoice();
            });
        };

        vm.archive = function () {
            return paymentModalService.archive(vm.resolvedInvoice.id).then(() => {
                vm.refreshInvoice();
            });
        };

        vm.unarchive = function () {
            return paymentModalService.unarchive(vm.resolvedInvoice.id).then(() => {
                vm.refreshInvoice();
            });
        };

        vm.bookTrip = function () {
            $state.go('trip-add', {locationId: vm.resolvedInvoice.dealerId});
        };

        vm.editItems = function () {
            $state.go('payment-edit-items');
        };

        vm.copy = function () {
            angular.element('#link').select();
            document.execCommand('copy');
        };

        vm.refreshInvoice = function () {
            vm.refreshing = true;
            paymentService.getInvoice(vm.resolvedInvoice.id).then((refreshedInvoice) => {
                vm.resolvedInvoice = refreshedInvoice;
                vm.fixAmounts();
            }).finally(() => {
                vm.refreshing = false;
            });
        };

        vm.selectedActionChanged = function () {
            switch (+vm.selectedAction) {
                case 1:
                    vm.showLink = true;
                    break;
                case 2:
                    vm.archive();
                    break;
                case 3:
                    paymentModalService.refund(vm.resolvedInvoice);
                    break;
                case 4:
                    paymentModalService.cancel(vm.resolvedInvoice.id);
                    break;
            }

            vm.selectedAction = '';
        };

        $scope.$on('Payment.refreshInvoice', (event, data) => {
            vm.refreshInvoice();
        });
    }
})();

(function () {
    'use strict';

    paymentEditItemsController.$inject = ["$state", "$rootScope", "$scope", "resolvedInvoice", "SYSTEM_ENUMS", "repairOrderService", "paymentService", "$timeout", "$q", "loanerService", "permissions", "loanerSettingsService", "locationService"];
    angular
        .module('redcap.payments')
        .controller('PaymentEditItemsController', paymentEditItemsController);

    function paymentEditItemsController($state, $rootScope, $scope, resolvedInvoice, SYSTEM_ENUMS, repairOrderService, paymentService, $timeout, $q, loanerService, permissions,
        loanerSettingsService, locationService) {
        let vm = this;
        let pageSize = 25;

        vm.resolvedInvoice = resolvedInvoice;
        vm.lineItemTypes = SYSTEM_ENUMS.invoiceLineItemTypes;
        vm.locationHasLoanerManagement = false;
        vm.userHasLoanerManagement = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.loaner);

        function setLineItemTypes () {
            // Don't include discounts / delivery line item types
            vm.lineItemOptions = paymentService.filterPaymentLineItemTypes(vm.loanerUpchargesEnabled);
        }
        
        function loadLoanerSettings () {
            loanerSettingsService.getSettings(vm.resolvedInvoice.dealerId).then((result) => {
                if (result.enableLoanerPreferences === true && result.enableUpchargeFee === true) {
                    vm.loanerUpchargesEnabled = true;
                } else {
                    vm.loanerUpchargesEnabled = false;
                }

                setLineItemTypes();
            });
        }

        vm.loadLocationPermissions  = function () {
            if (vm.resolvedInvoice.dealerId) {
                locationService.hasRole(vm.resolvedInvoice.dealerId, SYSTEM_ENUMS.permissionTypes.loanerManagement).then((result) => {
                    vm.locationHasLoanerManagement = result;
                    
                    if (vm.locationHasLoanerManagement === true && vm.userHasLoanerManagement === true) {
                        loadLoanerSettings();
                    } else {
                        vm.loanerUpchargesEnabled = false;
                        setLineItemTypes();
                    }
                }, (errorResponse) => {
                    vm.locationHasLoanerManagement = false;
                    vm.loanerUpchargesEnabled = false;
                    setLineItemTypes();
                });
            }
        };

        vm.loadLocationPermissions();

        vm.getOptsWithInitialSelection = function (initValue) {
            if (!initValue) return vm.repairOrderSearchOptions;
            initValue.repairOrderId = [String(initValue.id)];
            initValue.selected = true;

            return angular.extend({data: [initValue]}, vm.repairOrderSearchOptions);
        };

        vm.getLoanerUpchargeOptsWithInitialSelection = function (initValue) {
            if (!initValue) return vm.loanerUpchargeSearchOptions;
            initValue.Id = [String(initValue.id)];
            initValue.selected = true;

            return angular.extend({data: [initValue]}, vm.loanerUpchargeSearchOptions);
        };

        vm.cancelPromise = null;
        vm.repairOrderSearchOptions = {
            width: '100%',
            placeholder: 'Repair order search',
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            tags: true,
            createTag: function (params) {
                return {
                    roNumber: params.term,
                    id: -1,
                    text: params.term,
                    createNew: true
                };
            },
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        locationId: vm.resolvedInvoice.dealerId,
                        advisorId: null,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return repairOrderService.getOpenRepairOrders(data.search, data.locationId, data.advisorId, data.page, pageSize, vm.cancelPromise.promise, true).then((results) => {
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 750,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                if (item.createNew) {
                    return 'CREATE NEW - #' + item.roNumber;
                }

                return repairOrderService.formatForDropdown(item);
            },
            templateResult: function (item, a, b, c, d) {

                if (item.loading) {
                    return "Searching...";
                }

                if (item.createNew) {
                    let option = $("<span class='theme-link no-underline text-normal-case'>Can't find it?  </span>");
                        let newRecord = $("<span class='create-new'>Create a New Record.</span>");

                    option.append(newRecord);

                    return option;
                }

                return repairOrderService.formatForDropdown(item);
            }
        };

        vm.loanerUpchargeSearchOptions = {
            width: '100%',
            placeholder: 'Loaner contract search',
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            tags: false,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        dealerId: vm.resolvedInvoice.dealerId,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return loanerService.getContractsListForDropdown(data, vm.cancelPromise.promise).then((results) => {
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                if (item.noContract) {
                    return '[NO CONTRACT]';
                }

                return loanerService.formatContractForDropdown(item);
            },
            templateResult: function (item, a, b, c, d) {

                if (item.loading) {
                    return "Searching...";
                }

                if (item.noContract) {
                    let newRecord = $("<span class='create-new'>[NO CONTRACT]</span>");

                    return newRecord;
                }

                return loanerService.formatContractForDropdown(item);
            }
        };

        vm.setupNewLineItemListener = function () {
            $timeout(() => {
                let element = angular.element("#editItemsForm");

                if (element.length) {
                    element.on('select2:select',
                        (e) => {
                            let index = angular.element(e.target).data('index');
                                let ele = angular.element('#amount' + index);
                                let item = vm.resolvedInvoice.lineItems[index];

                            let amount = 0;

                            switch (item.type) {
                                case SYSTEM_ENUMS.invoiceLineItemTypes.repairOrder.id:
                                    amount = e.params.data.roTotal;
                                    break;
                                case SYSTEM_ENUMS.invoiceLineItemTypes.loanerUpcharge.id:
                                    if (e.params.data.duration && e.params.data.dailyRate) {
                                        let days = e.params.data.duration.days;

                                        if (e.params.data.duration.hours > 0) {
                                            days++;
                                        }

                                        amount = days * e.params.data.dailyRate || 0.00;
                                    }

                                    break;
                            }

                            item.roNumber = e.params.data.roNumber || null;
                            item.createNew = e.params.data.createNew || false;
                            item.externalCustomerId = e.params.data.externalCustomerId;
                            item.externalContractId = e.params.data.externalContractId;
                            item.externalReservationId = e.params.data.externalContractId;
                            ele.val((amount || 0).toFixed(2));
                            ele.change();

                            $timeout(() => {
                                $scope.$apply();
                            });
                        });
                } else {
                    vm.setupNewLineItemListener();
                }
            }, 100, 1);
        };

        vm.setupNewLineItemListener();

        vm.isValid = function() {
            return $scope.isValid;
        };

        // Update the buttons on the parent aside
        $rootScope.$broadcast('update:payment-aside-buttons',
            [{
                text: 'Cancel',
                style: 'btn-default',
                broadcastName: 'payment-edit-cancel'
            },
            {
                text: 'Save',
                isValid: vm.isValid,
                style: 'btn-primary',
                includeLadda: true,
                broadcastName: 'payment-edit-save'
            }
            ]);

        $scope.$on('payment-edit-cancel', (event) => {
            $state.go('payment-edit');
        });

        $scope.$watch('editItemsForm.$valid', (newVal) => {
            $scope.isValid = newVal;
        });

        $scope.$on('payment-edit-save', (event) => {
            return paymentService.editLineItems(vm.resolvedInvoice).then((result) => {
                $rootScope.$broadcast('Payment.refreshInvoice');
                $state.go('payment-edit', {}, {reload: true});
            });
        });

        $scope.lineItemFilter = function (item) {
            return item.type !== vm.lineItemTypes.delivery.id && item.type !== vm.lineItemTypes.discount.id;
        };
    }
})();

(function () {
    'use strict';

    paymentCreateController.$inject = ["resolvedLocations", "repairOrderService", "paymentService", "SYSTEM_ENUMS", "$state", "$q", "$timeout", "loanerService"];
    angular
        .module('redcap.payments')
        .controller('PaymentCreateController', paymentCreateController);

    function paymentCreateController(resolvedLocations, repairOrderService, paymentService, SYSTEM_ENUMS, $state, $q, $timeout, loanerService) {
        let vm = this;

        vm.params = $state.transition && $state.transition.params() || { };
        vm.locations = resolvedLocations;
        
        let newInvoice = {
            location: null,
            customer: vm.params.customer || null,
            items: vm.params.lineItems || []
        };

        let pageSize = 25;

        vm.invoice = newInvoice;
        vm.locationSearchThreshold = 5;

        //if we passed a location in, lets use it if we can
        if (vm.params.location && vm.params.location.id) {
            let matchedLocations = resolvedLocations.filter((item) => {
                return item.id === vm.params.location.id;
            });

            if (matchedLocations && matchedLocations.length) {
                vm.invoice.location = {
                    name: matchedLocations[0].name,
                    id: matchedLocations[0].id
                };
            }
        }

        if (vm.locations.length <= vm.locationSearchThreshold)
            vm.thresholdLocations = vm.locations;

        if (!vm.invoice.location && resolvedLocations.length === 1) {
            vm.invoice.location = {
                id: resolvedLocations[0].id,
                name: resolvedLocations[0].name
            };
        }

        vm.accordion = {
            steps: {
                chooseLocation: 1,
                chooseCustomer: 2,
                addItems: 3
            },
            selectedStep: 1
        };

        function nextStep() {
            vm.accordion.selectedStep++;
        }

        vm.locationSelected = function() {
            if (vm.invoice.location) {
                nextStep();
            }
        };

        vm.selectLocation = function (location) {
            vm.invoice.location = location;
            vm.locationSelected();
        };

        vm.billToSelected = function(repairOrder, contact, firstName, lastName, mobilePhone) {
            vm.invoice.items = [];

            if (repairOrder) {
                vm.invoice.items.push({
                    type: SYSTEM_ENUMS.invoiceLineItemTypes.repairOrder,
                    value: repairOrder || {},
                    amount: (repairOrder.roTotal || 0).toFixed(2),
                    repairOrderId: [String(repairOrder.id)]
                });
            } else {
                vm.invoice.items.push({amount: '0.00'});
            }

            vm.invoice.customer = {
                id: contact && contact.id || null,
                firstName: firstName,
                lastName: lastName,
                mobilePhone: mobilePhone
            };

            vm.accordion.selectedStep++;
        };

        vm.clearSelectedLocation = function() {
            vm.invoice.location = null;
            vm.accordion.selectedStep = vm.accordion.steps.chooseLocation;
        };

        vm.clearBillTo = function (vmPnl) {
            vm.invoice.customer = null;
            vmPnl.selectedContact = null;
            vmPnl.selectedRepairOrder = null;
            vm.invoice.items = [];
            vm.isCreatingNew = false;
            vmPnl.contactId = null;
            vmPnl.repairOrderId = null;
            vmPnl.firstName = null;
            vmPnl.lastName = null;
            vmPnl.mobilePhone = null;
            $timeout(() => {
                vm.resetSelect(angular.element("#phoneselect"));
                vm.resetSelect(angular.element("#roselect"));
            });
            vm.accordion.selectedStep = vm.accordion.steps.chooseCustomer;
        };

        vm.resetSelect = function(select) {
            select.prop('disabled', false);
            select.trigger('change');
        };

        vm.cancelPromise = null;
        vm.repairOrderSearchOptions = {
            width: '100%',
            placeholder: 'Repair order #',
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            tags: true,
            createTag: function (params) {
                return {
                    roNumber: params.term,
                    id: -1,
                    text: params.term,
                    createNew: true
                };
            },
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        locationId: vm.invoice.location.id,
                        advisorId: null,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return repairOrderService.getOpenRepairOrders(data.search, data.locationId, data.advisorId, data.page, pageSize, vm.cancelPromise.promise, true).then((results) => {
                        success(results);

                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 750,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            },
            templateSelection: function (item) {
                vm.isCreatingNew = false;
                if (!item.id) return item.text;

                if (item.createNew) {
                    return 'CREATE NEW - #' + item.roNumber;
                }

                return repairOrderService.formatForDropdown(item);
            },
            templateResult: function (item) {
                if (item.loading) {
                    return "Searching...";
                }

                if (item.createNew) {
                    let option = $("<span class='theme-link no-underline text-normal-case'>Can't find it?  </span>");
                        let newRecord = $("<span class='create-new'>Create a New Record.</span>");

                    option.append(newRecord);

                    return option;
                }

                return repairOrderService.formatForDropdown(item);
            }
        };

        vm.loanerUpchargeSearchOptions = {
            width: '100%',
            placeholder: 'Loaner contract search',
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            tags: false,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        dealerId: vm.invoice.location.id,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return loanerService.getContractsListForDropdown(data, vm.cancelPromise.promise).then((results) => {
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                if (item.noContract) {
                    return '[NO CONTRACT]';
                }

                return loanerService.formatContractForDropdown(item);
            },
            templateResult: function (item, a, b, c, d) {

                if (item.loading) {
                    return "Searching...";
                }

                if (item.noContract) {
                    let newRecord = $("<span class='create-new'>[NO CONTRACT]</span>");

                    return newRecord;
                }

                return loanerService.formatContractForDropdown(item);
            }
        };

        vm.createNewInvoice = function (invoice) {
            return paymentService.createInvoice({
                contact: {
                    id: invoice.customer.id,
                    firstName: invoice.customer.firstName,
                    lastName: invoice.customer.lastName,
                    phone: invoice.customer.mobilePhone
                },
                dealerId: invoice.location.id,
                lineItems: invoice.items.map((item) => {
                    return {
                        type: item.type.id,
                        description: item.description,
                        amount: parseFloat(item.amount).toFixed(2),
                        repairOrderId: Array.isArray(item.repairOrderId)
                            ? (item.repairOrderId && item.repairOrderId.length && item.repairOrderId[0])
                            : item.repairOrderId,
                        repairOrderNumber: item.value && item.value.roNumber || null,
                        createNew: item.value && item.value.createNew || false,
                        externalCustomerId: item.value && item.value.externalCustomerId,
                        externalContractId: item.value && item.value.externalContractId,
                        externalReservationId: item.value && item.value.externalContractId
                    };
                })
            }).then((invoiceId) => {
                $state.go('payment-edit', {invoiceId: invoiceId});
            });
        };

        if (vm.invoice.location) {
            vm.locationSelected();

            if (vm.invoice.customer) {
                vm.billToSelected(null, null, vm.invoice.customer.firstName, vm.invoice.customer.lastName, vm.invoice.customer.mobilePhone);
            }

            if (vm.params.lineItems && vm.params.lineItems.length) {
                vm.invoice.items = vm.params.lineItems;
            }
        }
    }


})();

(function () {
    'use strict';

    paymentChooseLocationController.$inject = ["$scope"];
    angular
        .module('redcap.payments')
        .controller('PaymentChooseLocationController', paymentChooseLocationController);

    function paymentChooseLocationController($scope) {
        var vm = this;
        var parent_vm = $scope.$parent.vm;
        parent_vm.child = this;
        vm.resolvedLocations = parent_vm.locations;
        vm.accordion = parent_vm.accordion;
    }
})();

(function () {
    'use strict';

    paymentChooseCustomerController.$inject = ["messagesService", "bookingService", "modalService", "$scope", "$timeout", "$filter", "$q"];
    angular
        .module('redcap.payments')
        .controller('PaymentChooseCustomerController', paymentChooseCustomerController);

    function paymentChooseCustomerController(messagesService, bookingService, modalService, $scope, $timeout, $filter, $q) {
        let vm = this;
            let parent_vm = $scope.$parent.vm;
            let pageSize = 25;

        parent_vm.child = this;
        vm.repairOrderPage = 0;
        vm.selectedContact = false;
        vm.selectedRepairOrder = false;
        vm.accordion = parent_vm.accordion;

        vm.cancelPromise = null;
        vm.phoneSearchOptions = {
            width: '100%',
            placeholder: 'Mobile phone',
            minimumInputLength: 3,
            maximumSelectionLength: 1,
            allowClear: true,
            language: {
                errorLoading: function() {
                    return "Searching...";
                }
            },
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        page: parameters.page,
                        locationId: parent_vm.invoice.location.id,
                        advisorId: null,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return messagesService.search(data.search, data.locationId, vm.cancelPromise.promise).then((results) => {
                        success(results);
                    }).catch((err) => {
                        failure(err);
                    });
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                return $filter('tel')(item.mobilePhone) + ' ' + item.firstName + ' ' + item.lastName;
            },
            templateResult: function (item) {
                if (item.loading) {
                    return "Searching...";
                }

                return $filter('tel')(item.mobilePhone) + ' ' + item.firstName + ' ' + item.lastName;
            }
        };

        vm.setCustomerData = function (params) {
            if (!parent_vm.isCreatingNew) {
                angular.element("#phoneselect").prop('disabled', true);
            }

            vm.selectedRepairOrder = params.data;
            vm.firstName = params.data.customerFirstName;
            vm.lastName = params.data.customerLastName;
            vm.mobilePhone = params.data.customerPhone;

            //$scope.$apply();
            if (vm.mobilePhone && vm.firstName && vm.lastName) {
                vm.submitForm();
            }
        };

        vm.setupRoSelect = function() {
            $timeout(() => {
                    let element = angular.element("#roselect");

                    if (element.length) {
                        element.on('select2:select',
                            (e) => {
                                if (e.params.data.createNew) {
                                    //check if the id is valid.
                                    //if not, throw alert and clear select2 values
                                    bookingService.roExists(parent_vm.invoice.location.id, e.params.data.roNumber).then((result) => {
                                        $timeout(() => {
                                            if (!result || !result.isValid) {
                                                element.val(null).trigger('change');
                                                modalService.showYesNo('Validation Error', 'This RO# is in use and must be selected from search results. If you want to create a New Record, please enter a numeric value that is not in use.', null, 'OK');
                                            } else {
                                                parent_vm.isCreatingNew = true;
                                                vm.setCustomerData(e.params);
                                            }
                                        });
                                    });
                                } else {
                                    vm.setCustomerData(e.params);
                                }
                            }).on('select2:unselect', (e) => {
                                parent_vm.isCreatingNew = false;
                                angular.element("#phoneselect").prop('disabled', false);
                                vm.selectedRepairOrder = null;
                            });
                    } else {
                        vm.setupRoSelect();
                    }
                },
                100,
                1);
        };

        vm.setupPhoneSelect = function() {
            $timeout(() => {
                    let element = angular.element("#phoneselect");

                    if (element.length) {
                        element.on('select2:select',
                            (e) => {
                                if (!parent_vm.isCreatingNew) {
                                    angular.element("#roselect").prop('disabled', true);
                                }

                                vm.selectedContact = e.params.data;
                                vm.firstName = e.params.data.firstName;
                                vm.lastName = e.params.data.lastName;
                                vm.mobilePhone = e.params.data.mobilePhone;
                                $scope.$apply();

                                if (vm.mobilePhone && vm.firstName && vm.lastName) {
                                    vm.submitForm();
                                }
                            }).on('select2:unselect',
                            (e) => {
                                angular.element("#roselect").prop('disabled', false);
                                vm.selectedContact = null;
                            });
                    } else {
                        vm.setupPhoneSelect();
                    }
                },
                100,
                1);
        };

        vm.submitForm = function() {
            parent_vm.billToSelected(vm.selectedRepairOrder,
                vm.selectedContact,
                vm.firstName,
                vm.lastName,
                vm.mobilePhone);
        };

        vm.setupRoSelect();
        vm.setupPhoneSelect();
    }
})();

(function () {
    'use strict';

    paymentCenposLoaderController.$inject = ["$scope", "SYSTEM_ENUMS", "paymentService", "$sce", "$timeout"];
    angular
        .module('redcap.payments')
        .controller('PaymentCenposLoaderController', paymentCenposLoaderController);

    function paymentCenposLoaderController($scope, SYSTEM_ENUMS, paymentService, $sce, $timeout) {
        var vm = this;
        vm.cenposSettings = $scope.$parent.vm.cenposSettings;
        vm.formUrl = $sce.trustAsResourceUrl(vm.cenposSettings.url);

        function formInitializer() {
            if (!$scope.submitForm || !$scope.submitForm.$valid) {
                return $timeout(formInitializer, 50);
            }
            angular.element('#submitForm', vm.cenposSettings.document).submit();

        }

        $scope.onInit = $timeout(formInitializer, 50);
        
    }
})();

(function () {
    'use strict';

    paymentAsideController.$inject = ["resolvedInvoice", "rcUtilService", "messagesService", "$timeout", "$rootScope", "$state", "$scope", "SYSTEM_ENUMS"];
    angular
        .module('redcap.payments')
        .controller('PaymentAsideController', paymentAsideController);


    function paymentAsideController(resolvedInvoice, rcUtilService, messagesService, $timeout, $rootScope, $state, $scope, SYSTEM_ENUMS) {
        let vm = this;

        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.resolvedInvoice = resolvedInvoice;
        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.confirmBusy = false;

        vm.enableMessaging = function (enable) {
            rcUtilService.showHideMobileMessagingPanel(enable);
        };

        vm.buttonClicked = function (eventName, causeBusy) {
            vm.confirmBusy = causeBusy;
            $rootScope.$broadcast(eventName);
        };

        if (resolvedInvoice.contactId) {
            messagesService.getContact(resolvedInvoice.contactId)
                .then((contact) => {
                    vm.contact = contact;
                });
        } else {
            vm.contact = {
                id: 0,
                firstName: resolvedInvoice.contactFirstName,
                lastName: resolvedInvoice.contactLastName,
                mobilePhone: resolvedInvoice.customerPhone,
                email: resolvedInvoice.customerEmail,
                phoneNumberType: resolvedInvoice.customerPhoneType
            };
        }

        if (vm.contact) {
            $timeout(() => {
                $rootScope.$broadcast('messagePaneContactUpdate', vm.contact);
            }, 2000);
        }

        vm.currentRoute = $state.name;

        $scope.$on('$destroy', () => {
            vm.confirmBusy = false;
            $rootScope.$broadcast('refresh:invoices');
            vm.enableMessaging(false);
        });

        $scope.$on('update:payment-aside-buttons', (event, buttons) => {
            vm.paymentButtons = buttons;
        });

        function initHeaderData () {
            vm.headerData = {
                invoice: resolvedInvoice,
                dealer: {
                    name: resolvedInvoice.dealerName
                },
                serviceAdvisor: {
                    firstName: vm.resolvedInvoice.serviceAdvisorFirstName,
                    lastName: vm.resolvedInvoice.serviceAdvisorLastName
                },
                customer: {
                    firstName: resolvedInvoice.customerFirstName,
                    lastName: resolvedInvoice.customerLastName,
                    mobilePhone: resolvedInvoice.customerPhone,
                    emailAddress: resolvedInvoice.customerEmail
                }
            };
        }

        initHeaderData ();
    }
})();

(function () {
    'use strict';

    paymentAddItemsController.$inject = ["$scope", "SYSTEM_ENUMS", "$timeout", "permissions", "locationService", "loanerSettingsService", "paymentService"];
    angular
        .module('redcap.payments')
        .controller('PaymentAddItemsController', paymentAddItemsController);

    function paymentAddItemsController($scope, SYSTEM_ENUMS, $timeout, permissions, locationService, loanerSettingsService, paymentService) {
        let vm = this;
        let parent_vm = vm.parent_vm = $scope.$parent.vm;

        parent_vm.child = this;
        vm.lineItemTypes = SYSTEM_ENUMS.invoiceLineItemTypes;
        vm.invoice = parent_vm.invoice;
        vm.locationHasLoanerManagement = false;
        vm.userHasLoanerManagement = permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.loaner);
        

        function setLineItemTypes () {
            // Don't include discounts / delivery line item types
            vm.lineItemOptions = paymentService.filterPaymentLineItemTypes(vm.loanerUpchargesEnabled);
        }
        
        function loadLoanerSettings () {
            loanerSettingsService.getSettings(parent_vm.invoice.location.id).then((result) => {
                if (result.enableLoanerPreferences === true && result.enableUpchargeFee === true) {
                    vm.loanerUpchargesEnabled = true;
                } else {
                    vm.loanerUpchargesEnabled = false;
                }

                setLineItemTypes();
            });
        }

        vm.loadLocationPermissions  = function () {
            if (parent_vm.invoice.location.id) {
                locationService.hasRole(parent_vm.invoice.location.id, SYSTEM_ENUMS.permissionTypes.loanerManagement).then((result) => {
                    vm.locationHasLoanerManagement = result;
                    
                    if (vm.locationHasLoanerManagement === true && vm.userHasLoanerManagement === true) {
                        loadLoanerSettings();
                    } else {
                        vm.loanerUpchargesEnabled = false;
                        setLineItemTypes();
                    }
                }, (errorResponse) => {
                    vm.locationHasLoanerManagement = false;
                    vm.loanerUpchargesEnabled = false;
                    setLineItemTypes();
                });
            }
        };

        vm.loadLocationPermissions();

        vm.setSelect2Tag = function () {
            $timeout(() => {
                let element = angular.element("#repairOrder0");

                if (!element.length || !element[0].options.length) return vm.setSelect2Tag();
                let option = angular.element(element[0].options[0]);

                option.attr('data-select2-tag', 'true');
            });
        };

        vm.getOptsWithInitialSelection = function (initValue) {
            if (!initValue) return angular.extend({}, parent_vm.repairOrderSearchOptions);
            let result = angular.extend({data: [initValue]}, parent_vm.repairOrderSearchOptions);

            if (initValue.createNew) {
                vm.setSelect2Tag();
            }

            return result;
        };

        vm.getLoanerUpchargeOptsWithInitialSelection = function (initValue) {
            if (!initValue) return parent_vm.loanerUpchargeSearchOptions;
            initValue.id = [String(initValue.id || initValue.externalContractId)];
            initValue.selected = true;

            return angular.extend({data: [initValue]}, parent_vm.loanerUpchargeSearchOptions);
        };

        vm.submitForm = function () {
            vm.submitting = true;
            parent_vm.createNewInvoice(vm.invoice).finally(() => {
                vm.submitting = false;
            });
        };

        vm.getTotal = function () {
            if (!vm.invoice.items) return 0;

            return _.sumBy(vm.invoice.items, (item) => {
                return parseFloat(item.amount || item.roTotal) || 0;
            });
        };

        vm.setupNewLineItemListener = function () {
            $timeout(() => {
                let element = angular.element("#editItemsForm");

                if (element.length) {
                    element.on('select2:select',
                        (e) => {
                            let index = angular.element(e.target).data('index');
                            let ele = angular.element('#amount' + index);
                            let item = vm.invoice.items[index];
                            let amount = 0;

                            switch (item.type) {
                                case SYSTEM_ENUMS.invoiceLineItemTypes.repairOrder:
                                    amount = e.params.data.roTotal;
                                    break;
                                case SYSTEM_ENUMS.invoiceLineItemTypes.loanerUpcharge:
                                    if (e.params.data.duration && e.params.data.dailyRate) {
                                        let days = e.params.data.duration.days;

                                        if (e.params.data.duration.hours > 0) {
                                            days++;
                                        }

                                        amount = days * e.params.data.dailyRate || 0.00;
                                    }

                                    break;
                            }

                            item.value = item.value || {};
                            item.value.roNumber = e.params.data.roNumber || '';
                            item.value.createNew = e.params.data.createNew || 'false';
                            item.value.externalCustomerId = e.params.data.externalCustomerId;
                            item.value.externalContractId = e.params.data.externalContractId;
                            item.value.externalReservationId = e.params.data.externalContractId;
                            ele.val((amount || 0).toFixed(2));
                            $timeout(() => {
                                $scope.$apply();
                            });
                        });
                } else {
                    vm.setupNewLineItemListener();
                }
            }, 100, 1);
        };

        vm.setupNewLineItemListener();
    }
})();

(function () {
    'use strict';

    angular.module('redcap.messages', []);
})();

(function () {
    'use strict';

    messagesService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi", "MESSAGES_ENUM", "appointmentUtilService"];
    angular
        .module('redcap.messages')
        .factory('messagesService', messagesService);

    function messagesService($q, $log, $filter, $http, $rootScope, rcApi, MESSAGES_ENUM, appointmentUtilService) {

        return {
            getContacts: getContacts,
            getContact: getContact,
            getMessages: getMessages,
            addContact: addContact,
            updateContact: updateContact,
            sendMessage: sendMessage,
            acknowledge: acknowledge,
            unacknowledge: unacknowledge,
            read: read,
            unread: unread,
            follow: follow,
            unfollow: unfollow,
            escalate: escalate,
            getDealerUsers: getDealerUsers,
            getImpersonations: getImpersonations,
            updateImpersonations: updateImpersonations,
            getMessageTemplates: getMessageTemplates,
            populateTemplate: populateTemplate,
            search: search,
            flag: flag,
            unflag: unflag,
            isGoMobileEnabled: isGoMobileEnabled,
            setGoMobile: setGoMobile,
            checkPhoneNumber: checkPhoneNumber,
            checkPhoneNumberType: checkPhoneNumberType,
            sendMobileLink: sendMobileLink,
            refreshMessageList: refreshMessageList
        };

        function getContacts(filters, cancelPromise) {
            return rcApi.post('contacts/search', filters, null, null, cancelPromise);
        }

        function getContact(contactId) {
            return rcApi.get('contacts/' + contactId, null, null, null, true);
        }

        function getDealerUsers(search, dealerId) {
            if (dealerId)
                return rcApi.get('contacts/dealerusers/' + dealerId, {search: search});

            return rcApi.get('contacts/dealerusers', {search: search});
        }

        function follow(contactId, params) {
            return rcApi.post('contacts/' + contactId + '/follow', params);
        }

        function unfollow(contactId, params) {
            return rcApi.post('contacts/' + contactId + '/unfollow', params);
        }

        function read(contactId, type) {
            type = type || MESSAGES_ENUM.contactMessageTypes.customer;

            return rcApi.post('contacts/' + contactId + '/messages/read?type=' + type);
        }

        function unread(contactId) {
            return rcApi.remove('contacts/' + contactId + '/messages/read');
        }

        function addContact(params) {
            return rcApi.post('contacts', params);
        }

        function updateContact(contactId, params) {
            return rcApi.put('contacts/' + contactId, params);
        }

        function getMessages(contactId, params) {
            return rcApi.get('contacts/' + contactId + '/messages', params);
        }

        function sendMessage(contactId, params) {
            return rcApi.post('contacts/' + contactId + '/messages', params);
        }

        function acknowledge(contactId) {
            return rcApi.post('contacts/' + contactId + '/acknowledge');
        }

        function unacknowledge(contactId) {
            return rcApi.remove('contacts/' + contactId + '/acknowledge');
        }

        function getImpersonations() {
            return rcApi.get('contacts/impersonations');
        }

        function updateImpersonations(params) {
            return rcApi.post('contacts/impersonations', params);
        }

        function search(params, dealerId, cancelPromise) {
            return rcApi.get('contacts/search',
                {
                    query: params,
                    dealerId: dealerId || null
                }, cancelPromise
            );
        }

        function escalate(contactId) {
            return rcApi.post('contacts/' + contactId + '/escalate');
        }

        function getMessageTemplates() {
            return rcApi.get('contacts/messagetemplates');
        }

        function populateTemplate(templateId, params) {
            return rcApi.post('contacts/populate/' + templateId, params);
        }

        function flag(contactId) {
            return rcApi.post('contacts/' + contactId + '/flag');
        }

        function unflag(contactId) {
            return rcApi.remove('contacts/' + contactId + '/flag');
        }

        function isGoMobileEnabled() {
            return rcApi.get('contacts/mobile');
        }

        function setGoMobile(isEnabled) {
            return rcApi.post('contacts/mobile', {isEnabled: isEnabled});
        }

        function checkPhoneNumber(phoneNumber, dealerId) {
            return rcApi.get('contacts/phonenumbers/' + phoneNumber + '?dealerId=' + dealerId);
        }

        function checkPhoneNumberType(phoneNumber) {
            return rcApi.get('contacts/phonenumbers/' + phoneNumber + '/type', null, null, null, null, true);
        }

        function sendMobileLink(contactId, type) {
            return rcApi.post('contacts/' + contactId + '/sendmobilelink', {type: type});
        }

        function refreshMessageList(vm) {
            if (!vm) return;
            if (!vm.messages) return;

            addDateBubbles(vm.messages);

            vm.earliestMessage = _.minBy(vm.messages.filter((message) => !message.isDateBubble),
                (message) => {
                    return moment(message.dateCreated);
                });
        }

        function addDateBubbles(messages) {
            if (!messages.dateBubbles) messages.dateBubbles = [];
            let dates = getUniqueDates(messages);

            dates.forEach(date => {
                messages.push({id: appointmentUtilService.getUniqueDOMID(), isDateBubble: true, dateCreated: date});
                messages.dateBubbles.push(date);
            });
            
        }
        
        function getUniqueDates(messages) {
            return _.uniqBy(messages, message => moment(message.dateCreated).format('YYYY-MM-DD'))
                        .map(message => moment(message.dateCreated).startOf('day').format())
                        .filter(date => !messages.dateBubbles.some(bubble => bubble === date));
        }
    }
})();

(function() {
    'use strict';

    MessagesModalService.$inject = ["$uibModal", "$q"];
    angular
        .module('redcap.messages')
        .factory("messagesModalService", MessagesModalService);

    function MessagesModalService($uibModal, $q) {

        return {
            showDuplicatePhoneConfirm: showDuplicatePhoneConfirm
        };

        function showDuplicatePhoneConfirm() {
            let deferred = $q.defer();

            let modal = $uibModal.open({
                    templateUrl: 'app/shared/modal/messages/duplicate-phone.html',
                    windowClass: 'top-modal',
                    backdrop: 'static',
                    keyboard: false
                });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('redcap.messages')
        .filter('message', MessageFilter);

    var newLineRegExp = /(\r\n|\r|\n)/g;
    var linkRegExp = /((http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?)/g;

    function MessageFilter() {
        return function(message) {
            if(!message) return '';

            var formatted = message.replace(newLineRegExp, '<br>')
                                   .replace(linkRegExp, '<a href="$1" class="theme-link" target="_blank">$1</a>');

            return formatted;
        };
    }

})();

(function () {
    'use strict';

    WatchUserSelectionController.$inject = ["$scope", "resolvedImpersonations", "messagesService"];
    angular
        .module('redcap.messages')
        .controller('WatchUserSelectionController', WatchUserSelectionController);

    function WatchUserSelectionController($scope, resolvedImpersonations, messagesService) {
        var vm = this;
        
        vm.selectedUsers = resolvedImpersonations.users;
        vm.matchingUsers = [];

        vm.searchUsers = searchUsers;
        vm.handleSelect = handleSelect;
        vm.update = update;

        function searchUsers($select) {
            if ($select.search) {
                messagesService.getDealerUsers($select.search)
                    .then(function (dealerUsers) {
                        var selectedUserIds = _.pick(vm.selectedUsers, 'userId');

                        vm.matchingUsers = _.filter(dealerUsers, function (user) {
                            return !_.includes(selectedUserIds, user.userId);
                        });
                    });
            }
        }

        function handleSelect() {
            $scope.$broadcast('select');
        }

        function update() {
            var params = {};

            params.userIds = _.map(vm.selectedUsers, function (user) {
                return user.userId;
            });

            messagesService.updateImpersonations(params)
                .then(function (result) {
                    vm.$close(result);
                });
        }
    }
})();

(function () {
    'use strict';

    OutOfOfficeController.$inject = ["$rootScope", "$scope", "resolvedOutOfOffice", "userService", "ValidationService"];
    angular
        .module('redcap.messages')
        .controller('OutOfOfficeController', OutOfOfficeController);

    function OutOfOfficeController($rootScope, $scope, resolvedOutOfOffice, userService, ValidationService) {
        var vm = this;

        vm.outOfOffice = resolvedOutOfOffice || {};
        vm.outOfOffice.enabled = resolvedOutOfOffice ? true : false;
        vm.outOfOffice.message = vm.outOfOffice.message || '';

        vm.validation = {
            isFormValid: function () {
                return vm.outOfOffice.enabled ? vm.outOfOffice.message.length > 0 : true;
            }
        };

        vm.saveOutOfOffice = function (valid) {
            if (new ValidationService().checkFormValidity($scope.outOfOfficeForm) && valid) {
                if (vm.outOfOffice.enabled) {
                    userService.setOutOfOffice(vm.outOfOffice.message)
                            .then(function () {
                                    closeOutOfOffice();
                            });
                } else {
                    userService.removeOutOfOffice()
                            .then(function () {
                                    closeOutOfOffice();
                            });
                }
            }
        };

        vm.closeOutOfOffice = function () {
            closeOutOfOffice();
        };

        function closeOutOfOffice() {
            $rootScope.$broadcast('outofoffice-closed');
        }
    }
})();

(function() {
    ContactTabMessagesController.$inject = ["$scope", "$rootScope", "$state", "$timeout", "contact", "modalService", "messageType", "messagesService", "resolvedMessageTemplates", "authService", "signalRService", "toastr", "SYSTEM_ENUMS", "MESSAGES_ENUM", "hasMessaging", "permissions"];
    angular
        .module('redcap.messages')
        .controller('ContactTabMessagesController', ContactTabMessagesController);

    function ContactTabMessagesController($scope, $rootScope, $state, $timeout, contact, modalService, messageType, messagesService, resolvedMessageTemplates, authService, signalRService, toastr, SYSTEM_ENUMS, MESSAGES_ENUM, hasMessaging, permissions) {
        let vm = this;

        vm.parent = $scope.$parent.vm;
        vm.contact = contact;
        vm.currentUser = authService.getCurrentUser();
        vm.hasMessaging = hasMessaging;
        vm.isTechnician = permissions.isTechnician() && !(permissions.isAdminLevelUser() || permissions.isServiceAdvisor());

        vm.messageTypes = MESSAGES_ENUM.contactMessageTypes;

        vm.pageSize = 20;
        vm.isLoading = false;
        vm.canShowMore = true;

        vm.messageType = messageType;
        vm.getMessages = getMessages;
        vm.earliestMessage = null;
        vm.messages = [];

        vm.attachFile = attachFile;
        vm.removeAttachment = removeAttachment;
        vm.messageAttachments = [];

        vm.messageTemplates = [{"id": null, "name": "CHOOSE TEMPLATE"}].concat(resolvedMessageTemplates);

       
        vm.selectMessageTemplate = selectMessageTemplate;
        vm.selectedMessageTemplate = null;
        vm.isTemplatePopulating = false;
        vm.isMessageSending = false;
        vm.sendMessage = sendMessage;
        vm.isSendDisabled = isSendDisabled;

        vm.selectedDealerUser = null;
        vm.dealerUserSearchResults = [];
        vm.searchDealerUsers = searchDealerUsers;
        vm.selectDealerUser = selectDealerUser;
        vm.removeFollower = removeFollower;
        vm.followerHovering = {};

        vm.acknowledgementTypes = MESSAGES_ENUM.acknowledgementTypes;
        vm.acknowledge = acknowledge;
        vm.unacknowledge = unacknowledge;
        vm.updatePreferences = updatePreferences;

        vm.sendMobileLink = sendMobileLink;

        vm.isInitialLoad = true;

        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.closeAside = closeAside;
        vm.contactMessagesListener;

        vm.panelMode = vm.messageType === vm.messageTypes.customer ? SYSTEM_ENUMS.messagingPanelModes.dealerCustomer
            : SYSTEM_ENUMS.messagingPanelModes.internal;

        vm.isTabActive = function(tab) {
            return $state.name === tab;
        };

        vm.closeMobileTools = function () {
            vm.parent.showMobileActionFollowers = false;
        };

        initialize();

        function initialize() {
            vm.contactMessagesListener = $scope.$parent.vm.contactMessagesListener;
            listenForContactMessagesUpdates();

            getMessages(contact.id).then(() => {
                scrollDown();
            });

            read();
        }

        function getMessages(contactId) {
            let params = {
                pageSize: vm.pageSize,
                type: messageType
            };

            if (vm.earliestMessage) {
                params.before = vm.earliestMessage.dateCreated;
            }

            vm.isLoading = true;

            return messagesService.getMessages(contactId, params)
                .then((messages) => {
                    vm.canShowMore = messages.length === vm.pageSize;

                    _.each(messages, (message) => {
                        addMessage(message);
                    });

                    messagesService.refreshMessageList(vm);

                })
                .finally(() => {
                    vm.isLoading = false;
                    vm.isInitialLoad = false;
                });
        }

        function sendMessage() {
            if (!vm.contact.mobilePhone && vm.messageType == vm.messageTypes.customer) {
                showPhoneNumberWarning();

                return;
            }

            if ((vm.newMessage || vm.messageAttachments.length) && !vm.isMessageSending && vm.contact.phoneNumberType !== vm.phoneTypes.landline) {
                vm.isMessageSending = true;
                let contact = vm.contact.id === 0 ? vm.selectedContact : vm.contact;

                let params = {
                    body: vm.newMessage,
                    media: vm.messageAttachments,
                    type: messageType
                };

                messagesService.sendMessage(contact.id, params)
                    .then((response) => {
                        addMessage(response.message);
                        angular.extend(vm.contact, response.contact);
                        vm.newMessage = '';
                        vm.messageAttachments = [];
                        vm.isMessageSending = false;
                        scrollDown();
                    })
                    .catch(() => {
                        vm.isMessageSending = false;
                    });
            }
        }

        function attachFile(panelMode) {
            angular.element('#attach-file' + panelMode).trigger('click');
        }

        function removeAttachment(attachment) {
            _.remove(vm.messageAttachments, attachment);
        }

        function selectMessageTemplate() {
            if (!vm.contact.firstName || !vm.contact.lastName) {
                toastr.error("Please enter the customer's First and Last Name before selecting a template.");
                vm.selectedMessageTemplate = null;

                return;
            }

            if (vm.messageTemplates[0].id === null) {
                vm.messageTemplates.shift();
            }

            vm.isTemplatePopulating = true;
            messagesService.populateTemplate(vm.selectedMessageTemplate.id, {contactId: vm.contact.id, dealerId: vm.contact.dealerId}).then((response) => {
                vm.newMessage = response.message;
            }).finally(() => {
                vm.isTemplatePopulating = false;
            });
        }

        function addMessage(message) {
            if (message.type !== messageType) return;

            let duplicate = _.find(vm.messages, (msg) => {
                return message.id === msg.id;
            });

            if (!duplicate) {
                processMessage(message);

                // parse to local time
                message.dateCreated = moment.utc(message.dateCreated).local().format();
                vm.messages.push(message);
            }

            messagesService.refreshMessageList(vm);
        }

        function processMessage(message) {
            if (message.createdById == vm.currentUser.userId) {
                message.createdBy = 'You';
                message.isFromCustomer = false;
            }
        }

        function closeAside() {
            $state.go('contact-list');
        }

        function searchDealerUsers($select) {
            if ($select.search) {
                messagesService.getDealerUsers($select.search, contact.dealerId).then((result) => {
                    vm.dealerUserSearchResults = result;
                });
            }
        }

        function read() {
            return messagesService.read(vm.contact.id, messageType)
                .then(() => {
                    if (messageType === vm.messageTypes.internal) {
                        vm.contact.hasUnreadInternal = false;
                    } else {
                        vm.contact.hasUnread = false;
                    }

                    $rootScope.$broadcast('unread-count.refresh');
                });
        }

        function removeFollower(follower) {
            messagesService.unfollow(vm.contact.id, {userId: follower.userId, type: messageType})
                .then((updatedContact) => {
                    vm.contact = updatedContact;
                });
        }

        function selectDealerUser() {
            messagesService.follow(vm.contact.id, {userId: vm.selectedDealerUser.userId, type: messageType})
                .then((updatedContact) => {
                    vm.contact = updatedContact;
                    vm.selectedDealerUser = null;
                })
                .catch(() => {
                    vm.selectedDealerUser = null;
                });
        }

        function acknowledge(contact) {
            messagesService.acknowledge(contact.id)
                .then((updatedContact) => {
                    vm.contact = updatedContact;
                });
        }

        function unacknowledge(contact) {
            messagesService.unacknowledge(contact.id)
                .then((updatedContact) => {
                    vm.contact = updatedContact;
                });
        }

        function isSendDisabled() {
            if (vm.isTechnician && vm.messageType === vm.messageTypes.customer) {
                return true;
            }
            
            return vm.isMessageSending || (vm.messageType === vm.messageTypes.customer && vm.contact.phoneNumberType === vm.phoneTypes.landline)
            || (vm.messageType === vm.messageTypes.customer && !vm.contact.mobilePhone)
            || (vm.messageType === vm.messageTypes.customer && vm.contact.isOptedOut);
        }

        function sendMobileLink(contact) {
            messagesService.sendMobileLink(contact.id, vm.messageType)
                .then((response) => {
                    toastr.info(response.message,
                        '<b class="text-uppercase">Link has been sent</b>', {
                        positionClass: 'toast-top-right',
                        iconClass: 'system-notification theme-bg',
                        toastClass: 'system-notification-toast'
                    });
                });
        }

        function updatePreferences() {
            messagesService.updateContact(vm.contact.id, vm.contact)
                .then((updatedContact) => {
                    vm.contact = updatedContact;
                });
        }

        function showPhoneNumberWarning() {
            modalService.showYesNo("This contact does not have a mobile phone number", "Please update the contact with a valid mobile phone number.", null, "OK");
        }

        function scrollDown() {
            return $timeout(() => {
                let container = angular.element('.message-list-container-' + vm.messageType)[0];

                container.scrollTop = container.scrollHeight;
            });
        }

        function listenForContactMessagesUpdates() {
            vm.contactMessagesListener.on(signalRService.events.contactMessages.broadcastMessageReceived, (message) => {
                addMessage(message);
                scrollDown();
                read();
            }).start();
        }
    }
})();

(function () {
    'use strict';

    ContactListController.$inject = ["$rootScope", "$scope", "$filter", "$uibModal", "$q", "$location", "$state", "$timeout", "$anchorScroll", "authService", "resolvedLocations", "resolvedImpersonations", "messagesService", "rcLocalStorageService", "rcUtilService", "signalRService", "SYSTEM_ENUMS", "MESSAGES_ENUM", "searchTemplateUtilService", "systemService", "SAVED_SEARCHES_PLACEHOLDER", "permissions"];
    angular
        .module('redcap.messages')
        .controller('ContactListController', ContactListController);

    function ContactListController($rootScope, $scope, $filter, $uibModal, $q, $location, $state, $timeout, $anchorScroll, authService, resolvedLocations, resolvedImpersonations, messagesService, rcLocalStorageService, 
        rcUtilService, signalRService, SYSTEM_ENUMS, MESSAGES_ENUM, searchTemplateUtilService, systemService, SAVED_SEARCHES_PLACEHOLDER, permissions) {
        let vm = this;
        let contactsToUpdate = [];
        let pageSize = 20;
        let page = 0;
        let searchCriteriaKey = "contactsSearchCriteriaFilters";
        let templateKey = "selectedMessageSearchTemplate";
        
        vm.showAdvancedSearch  = false;
        vm.searchTemplateType = SYSTEM_ENUMS.searchTemplateTypes.message;
        searchTemplateUtilService.initSearchTemplateData(vm);
        vm.followingStatusCheckboxFilter = [];
        vm.isAdmin = permissions.isSysAdmin() || permissions.isDeveloper() || permissions.isRedCapAdmin();
        vm.selectedId = false;

        vm.toggleShowSearchOptions = function () {
            vm.searchTemplateBeforeAdvancedSearch = _.cloneDeep(vm.searchTemplateData);
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

            if (vm.showAdvancedSearch) {
                runQuery();
            }

            vm.showAdvancedSearch  = !vm.showAdvancedSearch ;
        };

        function updateDirtyFlag() {
            if (vm.searchTemplateData.currentSearchTemplate) {
                vm.searchTemplateData.isTemplateDirty = true;
            }
        }

        function runQuery () {
            createFilterMessage();
            vm.refreshContacts();
            saveFilterSettings();
        }

        vm.applyBtnClicked = function () {
            vm.templateBeforeAdvancedSearch = null;
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            runQuery();
        };

        vm.saveBtnClicked = function () {
            saveSearchTemplate(false);
        };

        vm.saveAsBtnClicked = function () {
            saveSearchTemplate(true);
        };

        vm.clearSearchCriteria = function () {
            vm.keywordFilter = null;
            vm.isGlobalTemplate = false;
            vm.resetFilters();
        };

        vm.resetFilters = function (linkClicked) {
            vm.templateName = null;
            vm.searchTemplateData.currentSearchTemplate = null;
            vm.searchTemplateData.savedSearchName = null;
            vm.filters.location = vm.locations.length === 1 ? vm.locations[0] : null;
            vm.filters.scopes = [
                {id: 1},
                {id: 2}
            ];
            vm.filters.status = vm.contactStatuses[0];
            vm.filters.timeframe = {value: 3, text: 'Last 7 Days'};
            vm.clearSearchField();
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);
            
            if (linkClicked) {
                vm.showAdvancedSearch = false;
            }
            
            if (!vm.showAdvancedSearch) {
                vm.refreshContacts();
                saveFilterSettings();
                createFilterMessage();
            }
        };

        function saveSearchTemplate(saveAs) {
            if (saveAs) {
                vm.searchTemplateData.currentSearchTemplate.id = null;
            }

            searchTemplateUtilService.saveSearchTemplateClicked(vm, {
                selectedMessageLocationId: vm.filters.location.id,
                selectedMessageScopes: vm.filters.scopes, 
                selectedMessageStatus: vm.filters.status, 
                selectedMessageTimeFrame: vm.filters.timeframe, 
                templateName: vm.searchTemplateData.savedSearchName
            }, vm.searchTemplateType);
        }

        function finishLoadingTemplate() { 
            let template = vm.searchTemplateData.currentSearchTemplate.template;

            vm.filters.scopes = template.selectedMessageScopes;
            vm.filters.status = template.selectedMessageStatus;
            vm.filters.timeframe = template.selectedMessageTimeFrame;

            if (!vm.showAdvancedSearch) {
                runQuery();
            }
        }
        
        vm.loadSearchTemplate = function (item, model) {
            if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                let template = item.template;
                let templateDealer = $filter('filter')(vm.locations, {id: template.selectedMessageLocationId}, true);

                vm.isLoading = true;
                vm.searchTemplateData.isTemplateDirty = false;
                vm.searchTemplateData.currentSearchTemplate = item;
                rcLocalStorageService.set(templateKey, vm.searchTemplateData.currentSearchTemplate);
                vm.searchTemplateData.savedSearchName = template.templateName;
                vm.templateName = template.templateName;
                
                if (templateDealer && templateDealer.length > 0) {
                    vm.filters.location = templateDealer[0];
                }

                finishLoadingTemplate();
                        
            } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                rcLocalStorageService.set(templateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);
                vm.resetFilters();
            } else {
                rcLocalStorageService.set(templateKey, null);
                searchTemplateUtilService.clearSearchTemplate(vm);

                if (!vm.showAdvancedSearch) {
                    vm.refreshContacts();
                }
            }
        };

        function loadSearchTemplates () {
            systemService.getSearchTemplates(vm.searchTemplateType).then((templates) => {
                vm.searchTemplateData.searchTemplates = templates;
                loadLastTemplateAndFilters();
            });
        }

        function saveFilterSettings() {     
            rcLocalStorageService.set(searchCriteriaKey, vm.filters);
            rcLocalStorageService.set(templateKey, vm.searchTemplateData.currentSearchTemplate);
        }

        function loadLastTemplateAndFilters () {
            vm.searchTemplateData.currentSearchTemplate = systemService.getLastSearchTemplate(templateKey);

            if (vm.searchTemplateData.currentSearchTemplate) {
                let searchItem = systemService.findLastSearchTemplateInCollection(vm.searchTemplateData.currentSearchTemplate, vm.searchTemplateData.searchTemplates);
                
                if (searchItem) {
                    vm.loadSearchTemplate(searchItem);
                } else {
                    vm.searchTemplateData.currentSearchTemplate = null;
                    vm.refreshContacts();
                }
            } 
        }

        vm.filterEvents = {
            onSelectionChanged: function () {
                vm.filterChanged();
            }
        };
        
        vm.filterChanged = function () {
            $timeout(() => {
                updateDirtyFlag();

                if (!vm.showAdvancedSearch) {
                    createFilterMessage();
                    vm.refreshContacts();
                }
            }, 1);
        };

        function createFilterMessage() {
            vm.filterCount = 0;
            vm.filterMessage = '';

            if (vm.filters.location) {
                if (vm.isAdmin) {
                    vm.requiredFilterMessage = vm.filters.location.name;
                }

                rcUtilService.buildFilterMessage('Location', vm.filters.location.name, vm, false, true, 43);
            }
            
            if (vm.filters.search) {
                rcUtilService.buildFilterMessage('Search Term', vm.filters.search, vm, false, true, 43);
            }
                   
            if (vm.filters.status) {
                rcUtilService.buildFilterMessage('Status', vm.filters.status.text, vm, false, true, 43);
            }
            
            if (vm.filters.timeframe) {
                rcUtilService.buildFilterMessage('Time Frame', vm.filters.timeframe.text, vm);
            }

            if (vm.filters.scopes && vm.filters.scopes.length > 0) {
                vm.activeFilters = angular.copy(vm.filters);
                let followingStatusFilter = vm.activeFilters.scopes && vm.activeFilters.scopes.length > 0 ? vm.activeFilters.scopes.map(x => x.id).join(",").split(',').map(Number) : [];
                let selectedStatuses = rcUtilService.getItemByProperty(followingStatusFilter, vm.searchScopes, 'value').map((type) => { return type.text; });

                rcUtilService.buildFilterMessage('Following Status', selectedStatuses, vm, false, true, 43);
            }
        }

        vm.searchScopes = [
            {value: 1, text: 'I\'m the Primary'},
            {value: 2, text: 'I\'m following'},
            {value: 3, text: 'I\'m not following'},
            {value: 4, text: 'Unassigned'}
        ];

        vm.clearSearchField = function() {
            vm.filters.search = '';

            if (vm.isCustomSearching) {
                vm.refreshContacts();
            }
        };

        $scope.$on('Contact.asideClosed', () => {
            let listLoc = rcLocalStorageService.get('listLoc') || null;

            if (listLoc) {
                $timeout(() => { 
                    $location.hash(listLoc); 
                    $anchorScroll();
                    
                    // removes the hash from the url
                    $location.hash('');
                    $location.replace();

                    // highlights the row
                    vm.selectedId = listLoc;
                }, 1);
                $rootScope.$broadcast('unread-count.refresh');
            }
          }
        );

        vm.openContact = function (contactId, $event) {
            let angElem = $event.currentTarget;

            rcLocalStorageService.set('listLoc', angElem.id);
            $state.go('contact-detail-customer', {contactId: contactId});
        };

        vm.removeSelectedId = function() {
            vm.selectedId = null;
            rcLocalStorageService.remove('listLoc');
        };

        vm.searchScopeText = function(scopes) {
            let scopeTexts = _.map(scopes, (scope) => {
                return _.find(vm.searchScopes, {'value': scope.id}).text;
            });

            return _.join(scopeTexts, ', ');
        };

        vm.searchScopeSettings = {
            showCheckAll: false,
            showUncheckAll: false,
            idProp: 'value',
            displayProp: 'text',
            buttonClasses: 'ellipsis-overflow'
        };

        vm.searchScopeStrings = {
            buttonDefaultText: 'All Contacts'
        };

        vm.searchScopeEvents = {
            onSelectionChanged: function() {
                vm.refreshContacts();
            }
        };

        vm.contactStatuses = [
            {value: 0, text: 'All Statuses'},
            {value: 1, text: 'Unread'},
            {value: 2, text: 'Escalated'},
            {value: 3, text: 'Unanswered'}
        ];

        vm.contactTimeframes = [
            {value: 0, text: 'All History'},
            {value: 1, text: 'Today'},
            {value: 2, text: 'Yesterday'},
            {value: 3, text: 'Last 7 Days'},
            {value: 4, text: 'Last 30 Days'}
        ];

        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.locations = resolvedLocations;
        vm.followers = [];
        vm.canShowMore = true;
        vm.contactsListener = signalRService.registerContactsListener();
        listenForContactUpdates();

        let initialFilters = {
            location: vm.locations.length === 1 ? vm.locations[0] : null,
            status: vm.contactStatuses[0],
            timeframe: vm.contactTimeframes[3],
            sortDirection: null,
            sortBy: null,
            search: '',
            scopes: [{id: 1}, {id: 2}]
        };

        let clearedFilters = {
            location: null,
            status: vm.contactStatuses[0],
            timeframe: vm.contactTimeframes[3],
            sortDirection: null,
            sortBy: null,
            search: '',
            scopes: [{id: 1}, {id: 2}]
        };

        $scope.$on('Contact.updated', (event, contact) => {
            getUpdates([contact.id]);
        });

        let existingFilters = rcLocalStorageService.get(searchCriteriaKey) || {};
        
        vm.filters = _.extend({}, initialFilters, existingFilters);
        ensureFilterAvailability(vm.filters);
        vm.activeFilters = null;

        vm.sortChanged = function (sortBy, sortOrder) {
            let d = $q.defer();

            vm.filters.sortBy = sortBy;
            vm.filters.sortDirection = sortOrder;
            vm.refreshContacts();
            
            d.resolve(null);

            return d.promise;
        };

        vm.getFilterCount = function () {
            let cnt = 0;

            if (!vm.activeFilters) {
                return cnt;
            }

            if (vm.activeFilters.search) {
                cnt++;
            } else {
                if (vm.activeFilters.location && vm.activeFilters.location.name) {
                    cnt++;
                }

                if (vm.activeFilters.status && vm.activeFilters.status.value) {
                    cnt++;
                }

                if (vm.activeFilters.timeframe && vm.activeFilters.timeframe.value) {
                    cnt++;
                }

                if (vm.activeFilters.scopes && vm.activeFilters.scopes.length) {
                    cnt++;
                }
            }

            return cnt;
        };

        vm.currentUser = authService.getCurrentUser();
        vm.acknowledgementTypes = MESSAGES_ENUM.acknowledgementTypes;
        vm.contacts = [];
        vm.impersonations = resolvedImpersonations;
        vm.isLoading = false;
        vm.showAll = showAll;
        vm.isFiltered = isFiltered;
        vm.watchSelection = watchSelection;
        vm.selectedAction = '';
        vm.onActionSelected = onActionSelected;

        vm.actions = {
            follow: 0,
            unfollow: 1,
            markAsRead: 2,
            markAsUnread: 3,
            escalate: 4,
            markAsAcknowledged: 5,
            markAsUnacknowledged: 6,
            flag: 7,
            unflag: 8
        };

        vm.cancelSearch = null;
        vm.search = search;
        vm.getUpdates = getUpdates;
        vm.refreshContacts = refreshContacts;

        search();

        function search() {
            vm.lastSearch = vm.filters.search;
            let filters = mapFilters(vm.filters);

            filters.page = page;
            vm.showServiceAdvisorWarning = false;
            
            let hasMyCustomersFilter = !filters || !filters.scopes || !filters.scopes.length || filters.scopes.some((item) => {
                return item === 1;
            });

            if (!hasMyCustomersFilter) {
                vm.showServiceAdvisorWarning = true;
            }

            let earliest = getEarliest();

            filters.paging = earliest ? {before: earliest.lastMessageDate, isFlagged: earliest.isFlagged} : undefined; 
            filters.pageSize = pageSize;

            if (vm.cancelSearch) {
                vm.cancelSearch.resolve();
                vm.cancelSearch = null;
            }

            vm.cancelSearch = $q.defer();
            vm.isLoading = true;

            return messagesService.getContacts(filters, vm.cancelSearch.promise).then((results) => {
                vm.contacts = filters.paging ? _.concat(vm.contacts, results) : results;
                page++;
                vm.canShowMore = pageSize === results.length;
                vm.activeFilters = angular.copy(vm.filters);
                createFilterMessage();
                rcLocalStorageService.set(searchCriteriaKey, vm.filters);
                vm.isLoading = false;
            }).catch((err) => {
                if (err.status !== -1) {
                    createFilterMessage();
                    vm.isLoading = false;
                }
            });
        }

        function getEarliest()  {
            let ordered = _.orderBy(vm.contacts, ['isFlagged', 'lastMessageDate'], ['desc', 'desc']);
            let last = _.last(ordered);

            return last;
        }

        function getUpdates(contacts) {
            if (contacts && contacts.length) {
                vm.isUpdating = true;

                let filters = mapFilters(vm.filters);

                filters.ids = contacts;

                return messagesService.getContacts(filters).then((results) => {
                    _.remove(vm.contacts, (contact) => {
                        return contacts.indexOf(contact.id) > -1;
                    });

                    _.each(results, (result) => {
                        let index = _.findIndex(vm.contacts, {id: result.id});

                        if (index >= 0) {
                            vm.contacts[index] = result;
                        } else {
                            vm.contacts.push(result);
                        }
                    });

                    contactsToUpdate = [];
                    vm.isUpdating = false;
                }).catch(() => {
                    vm.isUpdating = false;
                });
            }
        }

        function refreshContacts() {
            vm.contacts = [];
            page = 0;
            search();
        }

        function showAll() {
            vm.filters = angular.copy(clearedFilters);

            refreshContacts();
            $rootScope.$broadcast('unread-count.refresh');
        }

        function isFiltered() {
            return !angular.equals(vm.activeFilters, initialFilters);
        }

        function watchSelection() {
            vm.modalInstance = $uibModal.open({
                templateUrl: 'app/areas/messages/views/watch-selector.view.html',
                controllerAs: 'vm',
                controller: 'WatchUserSelectionController',
                bindToController: true,
                backdrop: 'true',
                keyboard: false,
                resolve: {
                    resolvedImpersonations: function () {
                        return angular.copy(vm.impersonations);
                    }
                }
            });

            vm.modalInstance.result.then((results) => {
                vm.impersonations = results;
                vm.refreshContacts();

                $scope.$emit('impersonationsChanged');
            });
        }

        $scope.$on('navbar-clicked', () => {
            if (vm.modalInstance) {
                vm.modalInstance.dismiss();
            }
        });

        function onActionSelected(contact) {
            let actionType = parseInt(vm.selectedAction, 10);
            let action = null;
            let contactId = contact.id;
            let userId = vm.currentUser.userId;
            let customerMessages = MESSAGES_ENUM.contactMessageTypes.customer;

            switch (actionType) {
                case vm.actions.follow:
                    action = messagesService.follow.bind(null, contactId, {userId: userId, type: customerMessages});
                    break;
                case vm.actions.unfollow:
                    action = messagesService.unfollow.bind(null, contactId, {userId: userId, type: customerMessages});
                    break;
                case vm.actions.markAsRead:
                    action = messagesService.read.bind(null, contactId);
                    break;
                case vm.actions.markAsUnread:
                    action = messagesService.unread.bind(null, contactId);
                    break;
                case vm.actions.escalate:
                    action = messagesService.escalate.bind(null, contactId);
                    break;
                case vm.actions.markAsAcknowledged:
                    action = messagesService.acknowledge.bind(null, contactId);
                    break;
                case vm.actions.markAsUnacknowledged:
                    action = messagesService.unacknowledge.bind(null, contactId);
                    break;
                case vm.actions.flag:
                    action = messagesService.flag.bind(null, contactId);
                    break;
                case vm.actions.unflag:
                    action = messagesService.unflag.bind(null, contactId);
                    break;
            }

            if (action) {
                action().then(() => {
                    getUpdates([contact.id]).then(() => {
                        $rootScope.$broadcast('unread-count.refresh');
                    });
                });
            }

            vm.selectedAction = '';
        }

        function listenForContactUpdates() {
            vm.contactsListener.on(signalRService.events.contacts.broadcastContactUpdate, (message) => {
                contactsToUpdate.push(message.contactId);

                getUpdates(contactsToUpdate);
            }).start();
        }


        $scope.$on('$destroy', () => {
            unregisterSignalR();
            rcLocalStorageService.remove('listLoc');
        });

        function unregisterSignalR() {
            if (vm.contactsListener) {
                vm.contactsListener.disconnect();
                vm.contactsListener = null;
            }
        }

        function ensureFilterAvailability(filters) {
            filters.location = filters.location && vm.locations.length > 1 ? _.find(resolvedLocations, {id: filters.location.id}) : undefined;
            filters.status =  filters.status ? _.find(vm.contactStatuses, {value: filters.status.value}) : undefined;
            filters.timeframe = filters.timeframe ? _.find(vm.contactTimeframes, {value: filters.timeframe.value}) : undefined;
            filters.sortDirection = filters.sortDirection ? filters.sortDirection : undefined;
            filters.sortBy = filters.sortBy ? filters.sortBy : undefined;
            filters.scopes = filters.scopes && filters.scopes.length ? _.intersectionWith(filters.scopes, vm.searchScopes, (scope1, scope2) => {
                return scope1.id === scope2.value;
            }) : [];
        }

        function mapFilters(selectedFilters) {
            let filters;

            if (selectedFilters.search) {
                vm.isCustomSearching = true;

                filters = {
                    dealer: selectedFilters.location ? selectedFilters.location.id : null,
                    query: selectedFilters.search
                };
            } else {
                vm.isCustomSearching = false;
                filters = {
                    dealer: selectedFilters.location ? selectedFilters.location.id : null,
                    status: selectedFilters.status.value,
                    timeframe: selectedFilters.timeframe.value,
                    sortDirection: selectedFilters.sortDirection,
                    sortBy: selectedFilters.sortBy,
                    scopes: selectedFilters.scopes.length ? _.map(selectedFilters.scopes, (scope) => { return scope.id; })
                        : _.map(vm.searchScopes, (scope) => { return scope.value; })
                };     
            }

            return filters;
        }

        function init() {
            loadSearchTemplates();
        }

        init();

        vm.close = function () {
            searchTemplateUtilService.advancedFilterModalClosed(vm);
        };
    }
})();

(function () {
    'use strict';

    ContactDetailController.$inject = ["$scope", "$state", "resolvedContact", "resolvedServiceAdvisors", "messagesService", "signalRService", "authService", "messagesModalService", "MESSAGES_ENUM", "SYSTEM_ENUMS"];
    angular
        .module('redcap.messages')
        .controller('ContactDetailController', ContactDetailController);

    function ContactDetailController($scope, $state, resolvedContact, resolvedServiceAdvisors, messagesService, signalRService, authService, messagesModalService, MESSAGES_ENUM, SYSTEM_ENUMS) {
        let vm = this;
        
        vm.showMobileActionFollowers = false;
        vm.currentUser = authService.getCurrentUser();
        vm.contact = resolvedContact;
        vm.isEditingContact = false;
        vm.editContact = editContact;
        vm.cancelEditContact = cancelEditContact;
        vm.updateContact = updateContact;
        vm.editingContact = null;
        vm.selectedContact = null;
        vm.searchContacts = searchContacts;
        vm.contactSearchResults = [];
        vm.phoneDetail = {};
        vm.serviceAdvisors = resolvedServiceAdvisors;
        vm.toggleMobileActionFollowers = toggleMobileActionFollowers;

        vm.contactMessagesListener = null;

        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.checkPhoneType = checkPhoneType;
        vm.isPhoneNumberValidating = false;

        initialize();


        vm.isTabActive = function(tab) {
            return $state.name === tab;
        };

        function initialize() {
            initTabContainers();

            vm.contactMessagesListener = signalRService.registerContactMessagesListener(vm.contact.id);
            listenForContactMessagesUpdates();
        }

        function initTabContainers() {
            vm.tabs = [{
                title: 'Customer',
                route: 'contact-detail-customer'
            },
            {
                title: 'Internal',
                route: 'contact-detail-internal'
            }];
        }

        function searchContacts($select) {
            if ($select.search) {
                messagesService.getContacts({query: $select.search}).then((result) => {
                    vm.contactSearchResults = result;
                });
            }
        }

        function editContact() {
            vm.editingContact = angular.copy(vm.contact);
            vm.phoneDetail = {
                type: vm.editingContact.phoneNumberType,
                isOptedOut: vm.editingContact.isOptedOut,
                dealerPhone: vm.editingContact.dealerPhone
            };
            vm.isEditingContact = true;
        }

        function cancelEditContact() {
            vm.editingContact = null;
            vm.isEditingContact = false;
        }

        function updateContact() {
            vm.isContactUpdating = true;

            const saveContact = () =>
                messagesService.updateContact(vm.contact.id, vm.editingContact).then((updatedContact) => {
                    angular.copy(updatedContact, vm.contact);
                    vm.isEditingContact = false;
                });

            let filters = {
                dealer: vm.editingContact.dealerId,
                query: vm.editingContact.mobilePhone
            };

            messagesService.getContacts(filters).then((contacts) => {
                if (contacts.length && contacts[0].id !== vm.contact.id) {
                    return messagesModalService.showDuplicatePhoneConfirm().then(saveContact);
                }
                
                return saveContact();
            }).finally(() => {
                vm.isContactUpdating = false;
            });
        }

        function unregisterSignalR() {
            if (vm.contactMessagesListener) {
                vm.contactMessagesListener.disconnect();
                vm.contactMessagesListener = null;
            }
        }

        function toggleMobileActionFollowers() {
            vm.showMobileActionFollowers = !vm.showMobileActionFollowers;
        }

        function checkPhoneType(phoneNumber) {
            if (phoneNumber && phoneNumber.length === 10) {
                vm.isPhoneNumberValidating = true;
                messagesService.checkPhoneNumber(phoneNumber, vm.editingContact.dealerId).then((response) => {
                    vm.phoneDetail = response;
                }).finally(() => {
                    vm.isPhoneNumberValidating = false;
                });
            } else {
                vm.phoneDetail = {};
            }
        }

        function listenForContactMessagesUpdates() {
            vm.contactMessagesListener.on(signalRService.events.contactMessages.broadcastMessageReceived, (message) => {
                if (vm.isTabActive('current_detail_customer') && message.type === MESSAGES_ENUM.contactMessageTypes.internal) {
                    vm.contact.hasUnreadInternal = true;
                } else if (vm.isTabActive('customer_detail_internal') && message.type === MESSAGES_ENUM.contactMessageTypes.customer) {
                    vm.contact.hasUnread = true;
                }
            }).start();
        }

        $scope.$on('$destroy', () => {
            unregisterSignalR();
        });
    }
})();

(function () {
    'use strict';

    ContactAddController.$inject = ["$state", "resolvedLocations", "messagesService", "repairOrderService", "$filter", "$timeout", "messagesModalService", "SYSTEM_ENUMS", "$q"];
    angular
        .module('redcap.messages')
        .controller('ContactAddController', ContactAddController);

    function ContactAddController($state, resolvedLocations, messagesService, repairOrderService, $filter, $timeout, messagesModalService, SYSTEM_ENUMS, $q) {
        let vm = this;

        vm.locations = resolvedLocations;
        vm.locationSearchThreshold = 5;
        vm.selectedLocation = resolvedLocations.length === 1 ? _.first(resolvedLocations) : null;
        if (resolvedLocations.length <= vm.locationSearchThreshold)
            vm.thresholdLocations = resolvedLocations;

        vm.selectedContact = null;

        vm.clearSelectedLocation = clearSelectedLocation;

        vm.selectContact = selectContact;
        vm.clearSelectedContact = clearSelectedContact;

        vm.selectedRepairOrder = null;
        vm.matchingRepairOrders = [];

        vm.phoneNumberFilter = '';
        vm.matchingContacts = [];

        vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
        vm.checkPhoneType = checkPhoneType;
        vm.isPhoneNumberValidating = false;
        vm.phoneDetail = {};

        vm.id = 0;
        vm.firstName = '';
        vm.lastName = '';
        vm.mobilePhone = '';

        vm.steps = {
            location: 0,
            contact: 1
        };

        vm.currentStep = vm.selectedLocation ? vm.steps.contact : vm.steps.location;
        vm.onSelectLocation = onSelectLocation;

        vm.filterLocations = function (search) {
            vm.locations = _.filter(resolvedLocations, (location) => {
                return location.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
            });
        };

        let pageSize = 10;

        vm.repairOrderId = null;
        vm.contactId = null;
        vm.cancelPromise = null;
        vm.repairOrderSearchOptions = {
            width: '100%',
            placeholder: 'Repair order search',
            minimumInputLength: 2,
            maximumSelectionLength: 1,
            allowClear: true,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        dealerId: vm.selectedLocation.id,
                        page: parameters.page,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    if (vm.cancelPromise) {
                        vm.cancelPromise.resolve();
                    }

                    vm.cancelPromise = $q.defer();

                    return repairOrderService.getOpenRepairOrders(data.search, data.dealerId, null, data.page, pageSize, vm.cancelPromise.promise).then(success, failure);
                },
                delay: 750,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                return repairOrderService.formatForDropdown(item);
            },
            templateResult: function (item) {
                if (item.loading) {
                    return 'Searching...';
                }

                return repairOrderService.formatForDropdown(item);
            }
        };

        vm.phoneSearchOptions = {
            width: '100%',
            placeholder: 'Mobile phone number search',
            minimumInputLength: 3,
            maximumSelectionLength: 1,
            allowClear: true,
            ajax: {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        query: parameters.term,
                        page: parameters.page,
                        dealer: vm.selectedLocation.id,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    return messagesService.getContacts(data).then(success, failure);
                },
                delay: 250,
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            },
            templateSelection: function (item) {
                if (!item.id) return item.text;

                return $filter('tel')(item.mobilePhone) + ' ' + item.firstName + ' ' + item.lastName;
            },
            templateResult: function (item) {
                if (item.loading) {
                    return "Searching...";
                }

                return $filter('tel')(item.mobilePhone) + ' ' + item.firstName + ' ' + item.lastName;
            }
        };

        function onSelectLocation() {
            if (vm.selectedLocation) {
                vm.currentStep = vm.steps.contact;
            }
        }

        function clearSelectedLocation() {
            clearSelectedContact();
            vm.selectedLocation = null;
            vm.currentStep = vm.steps.location;
        }

        vm.selectLocation = function (location) {
            vm.selectedLocation = location;
            onSelectLocation();
        };

        vm.setupRoSelect = function () {
            $timeout(() => {
                let element = angular.element("#rosearch");

                if (element.length) {
                    element.on('select2:select',
                        (e) => {
                            let selectedContact = {
                                id: e.params.data.contactId,
                                dealerId: vm.selectedLocation.id,
                                firstName: e.params.data.customerFirstName,
                                lastName: e.params.data.customerLastName,
                                mobilePhone: e.params.data.customerPhone
                            };

                            if (selectedContact.id) {
                                goToContact(selectedContact.id);
                            } else {
                                createContact(selectedContact)
                                    .then((newContact) => {
                                        goToContact(newContact.id);
                                    });
                            }

                            e.preventDefault();
                        })
                        .on('select2:unselect',
                            (e) => {
                                vm.selectedRepairOrder = null;
                            });
                } else {
                    vm.setupRoSelect();
                }
            },
                100,
                1);
        };

        vm.setupRoSelect();

        vm.setupPhoneSelect = function () {
            $timeout(() => {
                let element = angular.element("#phonesearch");

                if (element.length) {
                    element.on('select2:selecting', (e) => {
                        let selectedContact = e.params.args.data;

                        goToContact(selectedContact.id);

                        // Prevent the selection because it causes the
                        // select box to grow and look weird before it takes
                        // the user to the detail page.
                        e.preventDefault();
                    });
                } else {
                    vm.setupPhoneSelect();
                }
            },
                100,
                1);
        };

        vm.setupPhoneSelect();

        function clearSelectedContact() {
            vm.currentStep = vm.steps.contact;
            $timeout(() => {
                angular.element('#rosearch').val(null).trigger('change');
                angular.element('#phonesearch').val(null).trigger('change');
                angular.element('#locationFilter').trigger('change');
            }, 1);
            vm.selectedContact = null;
        }

        function selectContact() {
            vm.selectedContact = {
                dealerId: vm.selectedLocation.id,
                firstName: vm.firstName,
                lastName: vm.lastName,
                mobilePhone: vm.mobilePhone
            };

            let filters = {
                dealer: vm.selectedLocation.id,
                query: vm.mobilePhone
            };

            messagesService.getContacts(filters)
                .then((contacts) => {
                    if (contacts.length) {
                        messagesModalService.showDuplicatePhoneConfirm()
                            .then(() => {
                                return createContact(vm.selectedContact)
                                    .then((newContact) => {
                                        goToContact(newContact.id);

                                    });
                            });
                    } else {
                        return createContact(vm.selectedContact)
                            .then((newContact) => {
                                goToContact(newContact.id);
                            });
                    }
                });
        }

        function createContact(contact) {
            return messagesService.addContact(contact);
        }

        function goToContact(contactId) {
            $state.go('contact-detail-customer', {contactId: contactId});
        }

        function checkPhoneType(phoneNumber) {
            if (phoneNumber && phoneNumber.length === 10) {
                vm.isPhoneNumberValidating = true;
                messagesService.checkPhoneNumber(phoneNumber, vm.selectedLocation.id)
                    .then((response) => {
                        vm.phoneDetail = response;
                    })
                    .finally(() => {
                        vm.isPhoneNumberValidating = false;
                    });
            } else {
                vm.phoneDetail = {};
            }
        }

    }
})();

(function () {
    'use strict';

    MessagingPanelController.$inject = ["messagesService", "tripService", "$scope", "$filter", "$timeout", "signalRService", "authService", "modalService", "locationService", "SYSTEM_ENUMS", "MESSAGES_ENUM", "permissions"];
    angular
        .module('redcap.messages')
        .component('rcMessagingPanel', {
            bindings: {
                contact: '<',
                trip: '<',
                panelMode: '<?',
                hasMessaging: '<?',
                onContactUpdate: '&',
                messageTemplates: '<?'
            },
            templateUrl: 'app/areas/messages/views/messaging-panel.view.html',
            controller: MessagingPanelController
        });

    function MessagingPanelController(messagesService,
        tripService,
        $scope,
        $filter,
        $timeout,
        signalRService,
        authService,
        modalService,
        locationService,
        SYSTEM_ENUMS,
        MESSAGES_ENUM,
        permissions) {

        let vm = this;
        let pageSize = 10;
        let disableCustomerMessaging = !permissions.allowCustomerMessaging();

        vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
        vm.participantTypes = SYSTEM_ENUMS.tripCommunicationParticipantTypes;
        vm.messageTypes = MESSAGES_ENUM.contactMessageTypes;
        vm.earliestMessage = null;

        this.$onInit = function() {
            
            if (vm.trip && vm.trip.id) {
                vm.tripCommunicationsListener = signalRService.registerTripCommunicationsListener(vm.trip.id);
                listenForTripCommunicationsUpdates();
            }

            vm.currentUser = authService.getCurrentUser();
            vm.messages = [];
            vm.displayMore = displayMore;
            vm.canShowMore = true;
            vm.isLoading = false;
            vm.sendMessage = sendMessage;
            vm.isMessageSending = false;
            vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
            vm.isPhoneNumberChanged = false;

            const messageTemplates = vm.messageTemplates;

            vm.messageTemplates = [{"id": null, "name": "CHOOSE TEMPLATE"}];

            if (messageTemplates && messageTemplates.length) {
                vm.messageTemplates = vm.messageTemplates.concat(messageTemplates);
            } else {
                messagesService.getMessageTemplates().then((templates) => {
                    vm.messageTemplates = vm.messageTemplates.concat(templates);
                });
            }

            vm.selectedMessageTemplate = null;
            vm.selectMessageTemplate = selectMessageTemplate;
            vm.isTemplatePopulating = false;

            vm.isInitialLoad = true;
            vm.contactMessagesListener = null;

            vm.attachFile = attachFile;
            vm.removeAttachment = removeAttachment;
            vm.messageAttachments = [];

            vm.selectedTripNoteType = null;
            
            vm.isTechnician = permissions.isTechnician() && !(permissions.isAdminLevelUser() || permissions.isServiceAdvisor());
            vm.isSendDisabled = vm.isTechnician && vm.panelMode === vm.messagingPanelModes.dealerCustomer;

            if (vm.panelMode === vm.messagingPanelModes.tripNotes) {
                getTripNoteTypes();
            }

            // only the internal tab is showing up, need to make sure we initialize messages on it
            if (disableCustomerMessaging && vm.panelMode === vm.messagingPanelModes.internal && vm.contact) {
                initializeContactMessages();
            }

            vm.disableMessaging = function() {
                if (vm.panelMode === vm.messagingPanelModes.driverCustomer || 
                    !permissions.hasUserPermission("Messaging")) return true;

                if (vm.panelMode !== vm.messagingPanelModes.dealerCustomer &&
                    vm.panelMode !== vm.messagingPanelModes.tripNotes) return false;

                return !vm.hasMessaging;
            };
        };

        $scope.$on('messagesTabChanged', (event, data) => { 
            if (vm.panelMode === vm.messagingPanelModes.internal && data === vm.messagingPanelModes.internal && vm.contact && vm.isInitialLoad) {
                initializeContactMessages();
            }
        });

        vm.$onChanges = function (changes) {
            if (vm.panelMode === vm.messagingPanelModes.dealerCustomer && vm.contact) {
                initializeContactMessages(changes);
            } else if (vm.trip && (vm.trip.id || vm.trip.dealer.id)) {
                if (vm.panelMode === vm.messagingPanelModes.tripNotes && vm.trip.id) {
                    getTripNotes(vm.trip.id).then(() => {
                            scrollDown();
                        });
                } else if (vm.panelMode === vm.messagingPanelModes.dealerInfo && vm.trip.dealer && vm.trip.dealer.id) {
                    getDealerNotes().then(() => {
                            scrollDown();
                        });
                } else if (vm.panelMode !== vm.messagingPanelModes.dealerCustomer && vm.panelMode !== vm.messagingPanelModes.internal && vm.trip.id) {
                    getTripMessages(vm.trip.id).then(() => {
                            scrollDown();
                        });
                }
            } else {
                vm.isInitialLoad = false;
            }
        };

            vm.$onDestroy = function() {
                unregisterSignalR();
            };

        function initializeContactMessages(changes) {            
            if (changes?.contact?.currentValue && changes?.contact?.previousValue) {
                if (vm.contact && vm.contact.id && (changes?.contact?.previousValue.id === undefined || changes?.contact?.currentValue.id == changes?.contact?.previousValue.id)) {
                    getContactMessages(vm.contact.id).then(() => {
                            scrollDown();
                            vm.isPhoneNumberChanged = false;
                        });

                    unregisterSignalR();
                    vm.contactMessagesListener = signalRService.registerContactMessagesListener(vm.contact.id);
                    listenForContactMessagesUpdates();

                    messagesService.read(vm.contact.id);
                } else if (vm.contact && vm.contact.id && changes?.contact?.currentValue.id != changes?.contact?.previousValue.id) {
                    vm.messages = [];
                    vm.isInitialLoad = true;
                    vm.isPhoneNumberChanged = false;
                    vm.earliestMessage = null;

                    getContactMessages(vm.contact.id).then(() => {
                        scrollDown();
                    });

                    unregisterSignalR();
                    vm.contactMessagesListener = signalRService.registerContactMessagesListener(vm.contact.id);
                    listenForContactMessagesUpdates();

                    messagesService.read(vm.contact.id);
                } else if (vm.contact && vm.contact.id === 0) {
                    vm.messages = [];
                    vm.earliestMessage = null;
                    vm.isInitialLoad = false;
                    vm.isPhoneNumberChanged = true;
                    unregisterSignalR();
                } else {
                    vm.isInitialLoad = false;
                }
            } else {
                // No changes parameter (called from other places) - handle normally
                if (vm.contact && vm.contact.id) {
                    getContactMessages(vm.contact.id).then(() => {
                            scrollDown();
                            vm.isPhoneNumberChanged = false;
                        });

                    unregisterSignalR();
                    vm.contactMessagesListener = signalRService.registerContactMessagesListener(vm.contact.id);
                    listenForContactMessagesUpdates();

                    messagesService.read(vm.contact.id);
                } else if (vm.contact && vm.contact.id === 0) {
                    vm.messages = [];
                    vm.earliestMessage = null;
                    vm.isInitialLoad = false;
                    vm.isPhoneNumberChanged = true;
                } else {
                    vm.isInitialLoad = false;
                }
            }
        }

        function displayMore() {
            if (vm.panelMode === vm.messagingPanelModes.dealerCustomer || vm.panelMode === vm.messagingPanelModes.internal) {
                if (vm.isPhoneNumberChanged !== true && vm.contact && vm.contact.id) {
                    getContactMessages(vm.contact.id);
                }
            } else if (vm.trip && vm.trip.id) {
                if (vm.panelMode === vm.messagingPanelModes.tripNotes) {
                    getTripNotes(vm.trip.id);
                } else { 
                    getTripMessages(vm.trip.id);
                }
            }
        }

        function getContactMessages(contactId) {
            let params = {};

            params.pageSize = pageSize;
            params.type = vm.panelMode === vm.messagingPanelModes.internal
                ? vm.messageTypes.internal
                : vm.messageTypes.customer;

            if (vm.earliestMessage) {
                params.before = vm.earliestMessage.dateCreated;
            }

            vm.isLoading = true;

            return messagesService.getMessages(contactId, params).then((messages) => {
                    const safeMessages = Array.isArray(messages) ? messages : [];

                    vm.canShowMore = safeMessages.length === pageSize;

                    safeMessages.forEach((message) => {
                        addMessage(message);
                    });

                    messagesService.refreshMessageList(vm);

                    vm.isLoading = false;
                    vm.isInitialLoad = false;
                })
                .catch((err) => {
                    vm.isLoading = false;
                    vm.isInitialLoad = false;
                });
        }

        function messageMap(message) {
            let senderName = message.createdBy;
                let participantTypes = SYSTEM_ENUMS.tripCommunicationParticipantTypes;

            if (!senderName) {
                senderName = message.senderType === participantTypes.driver
                    ? vm.trip.driver.name
                    : vm.trip.customerName;
            }

            return angular.extend({},
                message,
                {
                    createdBy: senderName,
                    dateCreatedLocal: moment.utc(message.dateCreated).local().format('MM/DD/YYYY hh:mm A')
                });
        }

        function filterDriverCustomerMessages() {
            let participantTypes = SYSTEM_ENUMS.tripCommunicationParticipantTypes;
                let messages = $filter('filter')(vm.tripMessages,
                    (m) => {
                        return m.senderType === participantTypes.driver &&
                            m.recipientType === participantTypes.customer ||
                            m.senderType === participantTypes.customer &&
                            m.recipientType === participantTypes.driver;
                    });

            vm.tripMessages = messages;
        }

        function filterDealerDriverMessages() {
            let participantTypes = SYSTEM_ENUMS.tripCommunicationParticipantTypes;
                let messages = $filter('filter')(vm.tripMessages,
                    (m) => {
                        return m.senderType === participantTypes.dealer &&
                            m.recipientType === participantTypes.driver ||
                            m.senderType === participantTypes.driver && m.recipientType === participantTypes.dealer;
                    });

            vm.tripMessages = messages;
        }

        function getTripMessages() {
            let params = {};

            params.pageSize = pageSize;

            if (vm.earliestMessage) {
                params.before = vm.earliestMessage.dateCreated;
            }

            vm.isLoading = true;

            return tripService.getTripMessages(vm.trip.id).then((messages) => {
                    const safeMessages = Array.isArray(messages) ? messages : [];

                    vm.tripMessages = safeMessages.map(messageMap);

                    if (vm.panelMode === vm.messagingPanelModes.driverCustomer) {
                        filterDriverCustomerMessages();
                    } else if (vm.panelMode === vm.messagingPanelModes.dealerDriver) {
                        filterDealerDriverMessages();
                    }

                    vm.canShowMore = vm.tripMessages.length === pageSize;

                    vm.tripMessages.forEach((message) => {
                        addMessage(message);
                    });

                    messagesService.refreshMessageList(vm);

                    vm.isLoading = false;
                    vm.isInitialLoad = false;

                    $timeout(() => {
                        scrollDown();
                    }, 50);

                })
                .catch((err) => {
                    vm.isLoading = false;
                    vm.isInitialLoad = false;
                });
        }

        function getTripNotes() {
            let params = {};

            params.pageSize = pageSize;

            if (vm.earliestMessage) {
                params.before = vm.earliestMessage.dateCreated;
            }

            vm.isLoading = true;

            return tripService.getTripNotes(vm.trip.id).then((notes) => {
                    const safeNotes = Array.isArray(notes) ? notes : [];

                    vm.tripNotes = safeNotes.map(messageMap);

                    vm.canShowMore = vm.tripNotes.length === pageSize;

                    vm.tripNotes.forEach((message) => {
                        addMessage(message);
                    });

                    messagesService.refreshMessageList(vm);

                    vm.isLoading = false;
                    vm.isInitialLoad = false;

                    $timeout(() => {
                        scrollDown();
                    }, 50);
                })
                .catch((err) => {
                    vm.isLoading = false;
                    vm.isInitialLoad = false;
                });
        }

        function getDealerNotes() {
            let params = {};

            params.pageSize = pageSize;

            if (vm.earliestMessage) {
                params.before = vm.earliestMessage.dateCreated;
            }

            vm.isLoading = true;

            return locationService.getDealerNotes(vm.trip.dealer.id).then((notes) => {
                const safeNotes = Array.isArray(notes) ? notes : [];

                vm.dealerNotes = safeNotes.map(messageMap);

                vm.canShowMore = vm.dealerNotes.length === pageSize;

                vm.dealerNotes.forEach((message) => {
                    addMessage(message);
                });

                messagesService.refreshMessageList(vm);

                vm.isLoading = false;
                vm.isInitialLoad = false;

                $timeout(() => {
                        scrollDown();
                }, 50);

            }).catch((err) => {
                vm.isLoading = false;
                vm.isInitialLoad = false;
            });
        }

        function sendDealerCustomerMessage() {
            if (!vm.contact.mobilePhone && vm.panelMode !== vm.messagingPanelModes.internal) {
                showPhoneNumberWarning();

                return;
            }

            if ((vm.message || vm.messageAttachments.length) && !vm.isMessageSending) {
                let messageType = vm.panelMode === vm.messagingPanelModes.internal
                    ? vm.messageTypes.internal
                    : vm.messageTypes.customer;

                if (vm.contact.id === 0) {
                    let contact = vm.contact;

                    vm.isMessageSending = true;
                        messagesService.addContact({
                            dealerId: contact.dealerId,
                            firstName: contact.firstName,
                            lastName: contact.lastName,
                            mobilePhone: contact.mobilePhone,
                            dmsCustomerId: contact.dmsCustomerId,
                            message: {
                                body: vm.message,
                                media: vm.messageAttachments,
                                type: messageType
                            }
                        }).then((newContact) => {
                            vm.contact = newContact;
                            vm.isInitialLoad = true;
                            vm.message = '';
                            vm.messageAttachments = [];
                            vm.isMessageSending = false;
                            getContactMessages(vm.contact.id).then(() => {
                                scrollDown();
                            });
                        }).catch(() => {
                            vm.isMessageSending = false;
                        });
                } else {
                    vm.isMessageSending = true;
                    messagesService.sendMessage(vm.contact.id,  {body: vm.message, media: vm.messageAttachments, type: messageType}).then((response) => {
                        addMessage(response.message);
                        messagesService.refreshMessageList(vm);
                        vm.contact = response.contact;
                        vm.message = '';
                        vm.isMessageSending = false;
                        vm.messageAttachments = [];
                        scrollDown();
                    }).catch(() => {
                        vm.isMessageSending = false;
                    });
                }
            }
        }

        function sendDealerDriverMessage() {
            if (vm.message && vm.message.length > 0) {
                vm.isMessageSending = true;
                tripService.sendTripMessage(vm.trip.id, vm.message, vm.participantTypes.driver).then((response) => {
                    vm.isMessageSending = false;
                    vm.message = null;
                    vm.messageAttachments = [];
                    getTripMessages(vm.trip.id).then(() => {
                        scrollDown();
                    });
                }).catch(() => {
                    vm.isMessageSending = false;
                });
            }
        }

        function addTripNote() {
            if (vm.message && vm.message.length > 0 && vm.selectedTripNoteType) {
                vm.isMessageSending = true;
                tripService.addTripNote(vm.trip.id, vm.message, vm.selectedTripNoteType).then((response) => {
                    vm.isMessageSending = false;
                    vm.message = null;
                    vm.selectedTripNoteType = null;

                    vm.createMessageForm.$setPristine();
                    vm.createMessageForm.$setUntouched();

                    getTripNotes(vm.trip.id).then(() => {
                        scrollDown();
                    });
                }).catch(() => {
                    vm.isMessageSending = false;
                });
            }
        }

        function addDealerNote() {
            if (vm.message && vm.message.length > 0) {
                vm.isMessageSending = true;

                locationService.addDealerNote(vm.trip.dealer.id, vm.message).then((response) => {
                    vm.isMessageSending = false;
                    vm.message = null;
                    vm.selectedTripNoteType = null;

                    vm.createMessageForm.$setPristine();
                    vm.createMessageForm.$setUntouched();

                    getDealerNotes().then(() => {
                        scrollDown();
                    });
                }).catch(() => {
                    vm.isMessageSending = false;
                }); 
            }
        }

        function sendMessage() {
            
            if (vm.panelMode === vm.messagingPanelModes.dealerCustomer ||
                vm.panelMode === vm.messagingPanelModes.internal) {
                sendDealerCustomerMessage();
            } else if (vm.panelMode === vm.messagingPanelModes.tripNotes) {
                addTripNote();
            } else if (vm.panelMode === vm.messagingPanelModes.dealerInfo) {
                addDealerNote();
            } else if (vm.panelMode === vm.messagingPanelModes.dealerDriver) {
                sendDealerDriverMessage();
            }
        }

        function attachFile(panelMode) {
            angular.element('#attach-file' + panelMode).trigger('click');
        }

        function removeAttachment(attachment) {
            if (!Array.isArray(vm.messageAttachments)) {
                vm.messageAttachments = [];

                return;
            }

            vm.messageAttachments = vm.messageAttachments.filter((item) => item !== attachment);
        }

        function listenForContactMessagesUpdates() {
          
            vm.contactMessagesListener.on(signalRService.events.contactMessages.broadcastMessageReceived,
                (message) => {
                    addMessage(message);
                    messagesService.refreshMessageList(vm);
                    scrollDown();
                    messagesService.read(vm.contact.id);
                }).start();
        }

        function showPhoneNumberWarning() {
            modalService.showYesNo("This contact does not have a mobile phone number",
                "Please update the contact with a valid mobile phone number.",
                null,
                "OK");
        }

        function unregisterSignalR() {
            if (vm.contactMessagesListener) {
                vm.contactMessagesListener.disconnect();
                vm.contactMessagesListener = null;
            }
        }

        function scrollDown() {
            return $timeout(() => {
                let containers = angular.element('.message-list-container');

                Array.from(containers || []).forEach((container) => {
                    container.scrollTop = container.scrollHeight;
                });
            });
        }

        function addMessage(message) {
            let duplicate = (Array.isArray(vm.messages) ? vm.messages : []).find((msg) => {
                return message.id === msg.id;
            });

            if (!duplicate) {
                if (message.createdById === vm.currentUser.userId) {
                    message.createdBy = 'You';
                }
                
                // parse to local time
                message.dateCreated = moment.utc(message.dateCreated).local().format();
                vm.messages.push(message);
            }
        }

        function selectMessageTemplate() {
            vm.isTemplatePopulating = true;

            let params = {
                contactId: vm.contact.id,
                dealerId: vm.contact.dealerId,
                overrides: !vm.contact.id
                    ? {
                        contact: {
                            firstName: vm.contact.firstName,
                            lastName: vm.contact.lastName
                        }
                    }
                    : undefined
            };

            if (vm.messageTemplates[0].id === null) {
                vm.messageTemplates.shift();
            }

            messagesService.populateTemplate(vm.selectedMessageTemplate.id, params).then((response) => {
                vm.message = response.message;
            }).finally(() => {
                vm.isTemplatePopulating = false;
            });
        }

        function listenForTripCommunicationsUpdates() {
           
            vm.tripCommunicationsListener.on(signalRService.events.tripCommunications.broadcastMessageReceived,
                (message) => {
                    if (vm.trip.id ===
                        message.tripId) { // only push this message if it is related to this trip. otherwise ignore
                        vm.tripMessages.push(messageMap(message));

                        if (vm.panelMode === vm.messagingPanelModes.driverCustomer) {
                            filterDriverCustomerMessages();
                        } else if (vm.panelMode === vm.messagingPanelModes.dealerDriver) {
                            filterDealerDriverMessages();
                        }

                        vm.messages = [];
                        vm.tripMessages.forEach((message) => {
                            addMessage(message);
                        });
                        messagesService.refreshMessageList(vm);
                        scrollDown();
                    }
                }).start();
        }

        function getTripNoteTypes() {
            tripService.getTripNoteTypes().then((result) => {
                vm.tripNoteTypes = result;
            });
        }

        function cleanUp() {
            if (vm.tripCommunicationsListener) {
                vm.tripCommunicationsListener.disconnect();
                vm.tripCommunicationsListener = null;
            }
        }

        $scope.$on('$destroy', cleanUp);
    }
    
})();

(function () {
    'use strict';

    MessageListController.$inject = ["SYSTEM_ENUMS", "tripService", "modalService", "locationService"];
    angular
        .module('redcap.messages')
        .component('rcMessageList', {
            bindings: {
                messages: '<',
                lastReadDate: '<',
                panelMode: '<?'
            },
            templateUrl: 'app/areas/messages/views/message-list.view.html',
            controller: MessageListController
        });

    function MessageListController(SYSTEM_ENUMS, tripService, modalService, locationService) {
        this.$onInit = function() {
            let vm = this;

            vm.isImage = isImage;
            vm.isVideo = isVideo;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
            vm.participantTypes = SYSTEM_ENUMS.tripCommunicationParticipantTypes;

            vm.addToClass = function(message) {
                if (message.notificationStatus == 14) return true;

                if ((vm.panelMode === vm.messagingPanelModes.dealerCustomer ||
                        vm.panelMode === vm.messagingPanelModes.internal) &&
                    message.isFromCustomer) return true;

                if (vm.panelMode === vm.messagingPanelModes.dealerDriver &&
                    message.senderType === vm.participantTypes.driver) return true;

                if (vm.panelMode === vm.messagingPanelModes.driverCustomer &&
                    message.senderType === vm.participantTypes.customer) return true;

                return false;
            };

            vm.$onInit = function() {
                if (vm.lastReadDate) {
                    let latestMessage = _.maxBy(vm.messages,
                        (message) => {
                            return moment(message.dateCreated);
                        });

                    if (latestMessage) {
                        let lastReadMoment = moment.utc(vm.lastReadDate);
                        let latestMessageMoment = moment.utc(latestMessage.dateCreated);

                        if (lastReadMoment.isBefore(latestMessageMoment)) {
                            let separator = {isSeparator: true, dateCreated: vm.lastReadDate};

                            vm.messages.push(separator);
                        }
                    }
                }
            };

            vm.getDateBubbleText = function(date) {
                let dateMoment = moment(date);

                if (dateMoment.isBefore(moment().startOf('day').add(-1, 'weeks'))) return dateMoment.format('MM/DD/YY');
                if (dateMoment.isSame(moment().startOf('day'))) return 'Today';
                if (dateMoment.isSame(moment().startOf('day').add(-1, 'days'))) return 'Yesterday';

                switch (dateMoment.day()) {
                    case 0:
                        return 'Sunday';
                    case 1:
                        return 'Monday';
                    case 2:
                        return 'Tuesday';
                    case 3:
                        return 'Wednesday';
                    case 4:
                        return 'Thursday';
                    case 5:
                        return 'Friday';
                    case 6:
                        return 'Saturday';
                }
            };

            vm.openImageModal = function (url, description, mediaType) {
                modalService.showImageViewer(url, description, mediaType);
            };

            vm.deleteNote = function(tripId, noteId) {
                if (vm.deletingNoteId) return;

                let modal = modalService.showYesNo('Confirm Delete',
                    'Are you sure you want to delete this note?',
                    'No',
                    'Yes',
                    true);

                modal.then((confirmed) => {
                    if (confirmed) {
                        vm.deletingNoteId = noteId;

                        tripService.deleteTripNote(tripId, noteId).then(() => {
                            _.remove(vm.messages, {id: noteId});
                        }).catch((err) => {
                            console.log('An error occurred while deleting note. Please try again');
                        }).finally(() => {
                            vm.deletingNoteId = null;
                        });
                    }
                });
            };

            vm.deleteDealerNote = function(noteId) {
                if (vm.deletingDealerNoteId) return;

                let modal = modalService.showYesNo('Confirm Delete',
                    'Are you sure you want to delete this note?',
                    'No',
                    'Yes',
                    true);

                modal.then((confirmed) => {
                    if (confirmed) {
                        vm.deletingDealerNoteId = noteId;

                        locationService.deleteDealerNote(noteId).then(() => {
                            _.remove(vm.messages, {id: noteId});
                        }).catch((err) => {
                            console.log('An error occurred while deleting note. Please try again');
                        }).finally(() => {
                            vm.deletingDealerNoteId = null;
                        });
                    }
                });
            };

            function isImage(media) {
                return /image/.test(media.contentType);
            }

            function isVideo(media) {
                return /video/.test(media.contentType);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('messageEditor', MessageEditorDirective);

    function MessageEditorDirective() {
        return {
            restrict: 'A',
            scope: {
                onEnter: '&'
            },
            link: function (scope, element) {
                element.on('keypress', function ($event) {
                    if ($event.which === 13) {
                        if (!$event.shiftKey) {
                            scope.onEnter();
                            $event.preventDefault();
                        }
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    MessageAttachmentSelectorDirective.$inject = ["fileReaderService", "toastr"];
    angular
        .module('redcap.directives')
        .directive('messageAttachmentSelector', MessageAttachmentSelectorDirective);

    var maxFilesAttached = 10;

    function MessageAttachmentSelectorDirective(fileReaderService, toastr) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var updateModel = function () {
                    var file = element[0].files[0];

                    if (file) {
                        var otherAttachments = ngModelController.$modelValue;

                        if (otherAttachments.length === maxFilesAttached) {
                            toastr.error('More than ' + maxFilesAttached + ' files cannot be attached to a message.');
                            return;
                        }

                        fileReaderService.readAsDataUrl(file, scope)
                            .then(function (dataUrl) {
                                ngModelController.$modelValue.push({
                                    fileName: file.name,
                                    type: file.type,
                                    content: dataUrl,
                                    size: file.size
                                });
                            });

                        element.val('');
                    }
                };

                element.bind('change', updateModel);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.messages')
        .component('rcContactName', {
            bindings: {
                contact: '<'
            },
            templateUrl: 'app/areas/messages/views/contact-name.view.html'
        });

})();

(function () {
    'use strict';

    tripTypeService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module('redcap.location')
        .factory('tripTypeService', tripTypeService);

    function tripTypeService($q, $log, $filter, $http, $rootScope, rcApi) {

        let LOCATION_BASEPATH = 'dealers/';
        let inviteTypes = {
            email: 1,
            sms: 2
        };

        return {
            getTripTypeBookItConfigurations: getTripTypeBookItConfigurations,
            getTripTypeBookingTab: getTripTypeBookingTab,
            getTripTypeSurveyTab: getTripTypeSurveyTab,
            getTripTypeNotificationsTab: getTripTypeNotificationsTab,
            getTripTypeQuestionResponses: getTripTypeQuestionResponses,
            getTripProfiles: getTripProfiles,
            getServiceAreaTypes: getServiceAreaTypes,
            getLocationTripTypeWorkFlows: getLocationTripTypeWorkFlows,
            getLocationTripWorkFlowTasks: getLocationTripWorkFlowTasks,
            getSurveys: getSurveys,
            getSurveyQuestions: getSurveyQuestions,
            getDealersUsingSurvey: getDealersUsingSurvey,
            setSurveyActiveStatus: setSurveyActiveStatus,
            getVehicleMakesModels: getVehicleMakesModels,
            updateTripType: updateTripType,
            updateNotificationTemplate: updateNotificationTemplate,
            resetNotificationTemplate: resetNotificationTemplate,
            updateTripTypeQuestionResponses: updateTripTypeQuestionResponses,
            updateLocationTripWorkFlowTasks: updateLocationTripWorkFlowTasks,
            getLocationTripTypeNotifications: getLocationTripTypeNotifications,
            getInviteNotificationTemplates: getInviteNotificationTemplates,
            getTripWorkflowNotificationTemplateGroups: getTripWorkflowNotificationTemplateGroups,
            getTripTypeFormattedMessage: getTripTypeFormattedMessage,
            sendTripTypeFormattedMessage: sendTripTypeFormattedMessage,
            getTripTypeInternal: getTripTypeInternal,
            getDealersWithTripType: getDealersWithTripType,
            copyWorkflowTasks: copyWorkflowTasks,
            getIncentives: getIncentives,
            saveIncentives: saveIncentives
        };

        function getTripTypeBookItConfigurations(locationId, dealerTripTypeId, configKeys) {
            return getTripTypeInternal(locationId, dealerTripTypeId, configKeys, []);
        }

        function getTripTypeBookingTab(locationId, dealerTripTypeId) {

            let commonConfigKeys = ['ServiceAreaData', 'ServiceAreaType', 'EnableCustomerPay', 'DefaultTravelTimeToCustomerMinutes',
                'DealerLocationMinutes', 'DealerLocationMinutesStart', 'DealerLocationMinutesEnd', 'CustomerLocationMinutes', 'RoundTripChargeProfileId',
                'OneWayChargeProfileId', 'RoundTripDriverPayProfileId', 'OneWayDriverPayProfileId', 'VehicleModelId', 'TripCutoffMinutes',
                'ConcurrentTrips', 'SurveyRecipientList', 'EnableBypassBookingRules', 'InviteExpirationMinutes', 'LyftInviteExpirationHours', 'DispatchNumber', 'ChargeConfigId',
                'DefaultCanAccessEarly', 'DefaultVenueId', 'ChargePercentThreshold', 'MonthlySpendingCap', 'DriverPayConfigId', 'DriverPayRatePerMinute',
                'DriverPayMinimum', 'CancelFee', 'CustomerChargeRatePerMinute', 'UseActualTimesForBilling', 'CustomerChargeMinimum', 'DriverTimeBasedMinimumThreshold', 'CustomerTimeBasedMinimumThreshold', 'ServiceFeePercent',
                'SkipWorkflowToDealer'];

            let specificConfigKeys = ['AppointmentBookingConfig', 'MinutesBeforeAppointmentTimeToDenyBooking',
                'SuppressDriversLicenseFields', 'EnableDriversLicenseVerification', 'SuppressInsuranceFields',
                'SuppressCreditCardFields', 'DefaultServiceAdvisorId', 'SuppressVehicleVIN', 'AllowCustomerToEditTrips', 'DisallowedRideProviderRides',
                'DefaultNoLoanerStartAtDealer', 'AllowDealerLocationManagement', 'IsGeneric', 'SuppressChooseLoanerOptions', 'HasLoanerDefault',
                'EnableConsumerLandingPage', 'LandingPageSecondChoiceURL', 'DisableStartAtCustomer', 'ApptSchedulingIncrements', 'ApptConsumerDepartmentId',
                'AllowBookingStandAloneTrips', 'ApptConsumerOtherServicesTitle', 'ApptConsumerAlternateServicesTitle', 'ApptConsumerBookingExperienceMethod', 'LandingPageMobileTitle', 'LandingPageMobileDescription',
                'EnableManageMySchedule', 'DefaultToPreviousAdvisor', 'EnableLyftBenefitBulkUpload', 'ConsumerMobileDisplayMap', 'FramedInHideMap', 'ApptConsumerAltBookingServicesParagraph', 'ApptConsumerAltBookingServicesTitle',
                'ShowDriverRidePriceSurge', 'AutomaticallyMarkAppointmentsAsNoShow', 'AppointmentsNoShowAfterDays', 'PreventLateAtNightForEarlyBooking', 'EnableToFromAnyLocation', 'DisplayConsumerPrices',
                'SodTripOpCode', 'WriteSodTripCostToRo'];

            return getTripTypeInternal(locationId, dealerTripTypeId, commonConfigKeys, specificConfigKeys);
        }

        function getTripTypeSurveyTab(locationId, dealerTripTypeId) {

            let commonConfigKeys = ['SurveyId', 'DriverSurveyId', 'BulkSurveyCCRecipientList'];
            let specificConfigKeys = [];

            return getTripTypeInternal(locationId, dealerTripTypeId, commonConfigKeys, specificConfigKeys);
        }

        function getTripTypeNotificationsTab(locationId, dealerTripTypeId) {

            let commonConfigKeys = ['EmailCCList', 'OneWayNotificationProfileId', 'RoundTripNotificationProfileId', 'BulkNotificationCCRecipientList', 'SurveyRecipientList',
                'InviteExpirationMinutes', 'LyftInviteExpirationHours', 'EnableWebhooks', 'WebhookUrl', 'WebhookUsername', 'WebhookPassword', 'SendCustomerSMSViaWebhooks'];
            let specificConfigKeys = ['EnableToFromAnyLocation'];

            return getTripTypeInternal(locationId, dealerTripTypeId, commonConfigKeys, specificConfigKeys);
        }

        function getTripTypeQuestionResponses(locationId, dealerTripTypeId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/tripTypeQuestions/' + dealerTripTypeId);
        }

        function getTripProfiles() {
            return rcApi.get('tripProfiles');
        }

        function getServiceAreaTypes() {
            return rcApi.get(LOCATION_BASEPATH + '/serviceAreaTypes');
        }

        function getLocationTripTypeWorkFlows(locationId, dealerTripTypeId) {
            return  rcApi.get(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/tripWorkflows');
        }

        function getLocationTripWorkFlowTasks(locationId, workFlowId) {
            return  rcApi.get(LOCATION_BASEPATH + locationId + '/tripWorkFlowTasks/' + workFlowId);
        }

        function updateLocationTripWorkFlowTasks(locationId, updatedTasks) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/tripWorkFlowTasks', updatedTasks).then((response) => {
                    return response;
                });
        }

        function getSurveys(includeInactive) {
            return rcApi.get('surveys?includeInactive=' + !!includeInactive);
        }

        function getSurveyQuestions(surveyId) {
            return rcApi.get('surveys/' + surveyId);
        }

        function getDealersUsingSurvey(surveyId) {
            return rcApi.get('surveys/' + surveyId + '/dealers');
        }

        function setSurveyActiveStatus(surveyId, isActive) {
            return rcApi.put('surveys/' + surveyId + '/activate/' + isActive);
        }

        function getVehicleMakesModels(locationId) {
            return rcApi.get('dealer/' + locationId + '/vehicles');
        }

        function getLocationTripTypeNotifications(locationId, dealerTripTypeId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/notifications');
        }

        function getInviteNotificationTemplates(locationId, tripTypeId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/notificationTemplates/invites/' + tripTypeId);
        }

        function getTripWorkflowNotificationTemplateGroups(locationId, workFlowId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/notificationTemplates/tripWorkflows/' + workFlowId);
        }

        function getTripTypeFormattedMessage(trip, serviceOrder, type) {
            let serviceOrderId = serviceOrder ? serviceOrder.id : null;
            let locationId = trip.dealerLocation.id;
            let dealerTripTypeId = trip.dealerTripTypeInstance.id;
            let bindingModel = {
                type: type,
                serviceAdvisorId: trip.serviceAdvisor ? trip.serviceAdvisor.id : null,
                firstName: serviceOrder.customerInfo.firstName,
                lastName: serviceOrder.customerInfo.lastName,
                startsAtDealer: trip.selectedTripOption && trip.selectedTripOption.startsAtDealer,
                systemTripTypeId: trip.selectedSystemTripType.id,
                tripWorkFlowId: trip.tripWorkFlowId || trip.selectedSystemTripType.tripWorkFlowId,
                loanerContractId: serviceOrder.selectedLoanerContract ? serviceOrder.selectedLoanerContract.externalContractId : null,
            };

            if (serviceOrder.hasLoaner && serviceOrder.hasLoaner === 'yes') {
                bindingModel.hasLoaner = true;
            }

            if (serviceOrderId) {
                return rcApi.get(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted/' + serviceOrderId, bindingModel);
            } else {
                return rcApi.get(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted', bindingModel);
            }
        }

        function sendTripTypeFormattedMessage(trip, serviceOrder, type) {
            let serviceOrderId = serviceOrder ? serviceOrder.id : null;
            let custInfo = serviceOrder.customerInfo;
            let locationId = trip.dealerLocation.id;
            let dealerTripTypeId = trip.dealerTripTypeInstance.id;
            let bindingModel = {
                type: type,
                subject: trip.invitationSubject,
                body: trip.invitationMessage,
                roNumber: serviceOrder ? serviceOrder.roNumber : null,
                serviceAdvisorId: trip.serviceAdvisor.id,
                firstName: custInfo.firstName,
                lastName: custInfo.lastName,
                email: type === inviteTypes.email ? null : custInfo.email,
                phone: type === inviteTypes.sms ? null : custInfo.phoneNumber,
                tripWorkFlowId: trip.tripWorkFlowId || trip.selectedSystemTripType.tripWorkFlowId,
                loanerContractId: serviceOrder.selectedLoanerContract ? serviceOrder.selectedLoanerContract.externalContractId : null,
            };

            if (trip.selectedTripOption) {
                bindingModel.startsAtDealer = trip.selectedTripOption.startsAtDealer;
            }

            if (serviceOrder.hasLoaner && serviceOrder.hasLoaner === 'yes') {
                bindingModel.hasLoaner = true;
            }

            if (serviceOrder.apptDate) {
                if (serviceOrder.apptTime) {
                    bindingModel.apptDateTime = new Date(serviceOrder.apptDate + ' ' + serviceOrder.apptTime);
                    bindingModel.apptDateTime = bindingModel.apptDateTime.toString();
                    bindingModel.apptDateTime = bindingModel.apptDateTime.split(' ').slice(0, 5).join(' ');
                } else {
                    bindingModel.apptDateTime = new Date(serviceOrder.apptDate);
                }
            }

            if (serviceOrderId) {
                return rcApi.post(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted/' + serviceOrderId, bindingModel).then((response) => {
                    return response;
                });
            } else {
                return rcApi.post(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/notifications/formatted', bindingModel).then((response) => {
                    return response;
                });
            }
        }

        function updateTripType(tripType) {
            let updatedTripType = {
                status: tripType.status,
                tripTypeCommonConfigs: [],
                tripTypeSpecificConfigs: []
            };

            for (let key in tripType.tripTypeCommonConfigs) {
                if (tripType.tripTypeCommonConfigs[key].value === 'null') tripType.tripTypeCommonConfigs[key].value = null;
                updatedTripType.tripTypeCommonConfigs.push({configKey: key, configValue: tripType.tripTypeCommonConfigs[key].value});
            }

            for (let key2 in tripType.tripTypeSpecificConfigs) {
                if (tripType.tripTypeSpecificConfigs[key2].value === 'null') tripType.tripTypeSpecificConfigs[key2].value = null;
                updatedTripType.tripTypeSpecificConfigs.push({configKey: key2, configValue: tripType.tripTypeSpecificConfigs[key2].value});
            }

            return rcApi.put(LOCATION_BASEPATH + tripType.dealerId + '/tripTypes/' + tripType.id, updatedTripType);
        }

        function updateNotificationTemplate(locationId, template) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/notificationTemplates/', template);
        }

        function resetNotificationTemplate(locationId, template) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/notificationTemplates/reset', template);
        }

        function updateTripTypeQuestionResponses(locationId, updatedResponses) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/tripTypeQuestions', updatedResponses).then((response) => {
                    return response;
                });
        }

        function getTripTypeInternal(locationId, dealerTripTypeId, commonConfigKeys, specificConfigKeys) {
            // Purpose: common function to hit the API and retrieve a trip type with all configs
            // Note: when commonConfigKeys or specificConfigKeys are null or an empty array, ALL configs of that type are returned
            
            return rcApi.post(LOCATION_BASEPATH + locationId + '/tripTypes/' + dealerTripTypeId + '/filter', {
                "tripTypeCommonConfigs": commonConfigKeys,
                "tripTypeSpecificConfigs": specificConfigKeys
            }).then((response) => {
                // transform trip type common and specific config arrays into objects
                let commonConfigs = getTripConfigsAsObjectInternal(commonConfigKeys, response.tripTypeCommonConfigs);
                let specificConfigs = getTripConfigsAsObjectInternal(specificConfigKeys, response.tripTypeSpecificConfigs);

                // replace the common and specific config arrays with the transformed objects
                response.tripTypeCommonConfigs = commonConfigs;
                response.tripTypeSpecificConfigs = specificConfigs;

                return response;
            });
        }

        function getTripConfigsAsObjectInternal(configKeys, configArray) {
            // Purpose: transforms a configArray from the TripType API into a object with properties

            let tripConfigs = {};
            let doNotParseConfigs = ["LandingPageSecondChoiceURL"];


            if (configKeys && configKeys.constructor === Array && configKeys.length > 0) {
                // caller passed-in a configKeys array, loop through it and filter on just those configs by key
                for (let i = 0; i < configKeys.length; i++) {
                    let config = $filter('filter')(configArray, {configKey: configKeys[i]}, true);

                    if (config.length === 1) {
                        let doNotParse = jQuery.inArray(config[0].configKey, doNotParseConfigs) > -1;

                        tripConfigs[configKeys[i]] = {
                            value: doNotParse ? config[0].configValue : getJsPrimitiveFromStringValue(config[0].configValue),
                            defaultValue: doNotParse ? config[0].configValue :  getJsPrimitiveFromStringValue(config[0].defaultValue)
                        };
                    }
                }
            } else {
                // caller did not pass a configKeys array, loop through and return all configs
                for (let idx = 0; idx < configArray.length; idx++) {
                    let configKey = configArray[idx].configKey;
                    let dontParse = jQuery.inArray(configKey, doNotParseConfigs) > -1;

                    tripConfigs[configKey] = {
                        value: dontParse ? configArray[idx].configValue :  getJsPrimitiveFromStringValue(configArray[idx].configValue),
                        defaultValue: dontParse ? configArray[idx].configValue :  getJsPrimitiveFromStringValue(configArray[idx].defaultValue)
                    };
                }
            }

            return tripConfigs;
        }

        function getDealersWithTripType(tripTypeId) {
            return rcApi.get(LOCATION_BASEPATH + 'triptypes/' + tripTypeId);
        }

        function copyWorkflowTasks(sourceDealerId, destDealerId, tripWorkflowId, copyAllWorkflows) {
            return rcApi.post(LOCATION_BASEPATH + destDealerId + '/tripworkflowtasks/copy',
                {sourceDealerId: sourceDealerId, tripWorkflowId: tripWorkflowId, copyAllWorkflows: copyAllWorkflows});
        }

        function getJsPrimitiveFromStringValue(value) {
            return value && (value.search(/false|true/i) > -1 ? JSON.parse(value.toLowerCase()) : value);
        }

        function getIncentives(locationId, tripTypeId) {
            return  rcApi.get(LOCATION_BASEPATH + locationId + '/triptypes/' + tripTypeId + '/incentives').then((incentives) => {
                incentives.forEach((incentive) => {
                    let daysOfWeek = [
                        {day: 'M', index: 1, checked: false},
                        {day: 'T', index: 2, checked: false},
                        {day: 'W', index: 3, checked: false},
                        {day: 'T', index: 4, checked: false},
                        {day: 'F', index: 5, checked: false},
                        {day: 'S', index: 6, checked: false},
                        {day: 'S', index: 0, checked: false}
                    ];

                    let selectedDays = incentive.daysOfWeek.split(',');
                    
                    selectedDays.forEach((selectedDay) => {
                        let dow = _.find(daysOfWeek, (dow) => { return dow.index === parseInt(selectedDay); });
                        
                        dow.checked = true;
                    });

                    incentive.daysOfWeek = daysOfWeek;
                });

                return incentives;
            });
        }
        
        function saveIncentives(locationId, tripTypeId, incentives) {
            return  rcApi.post(LOCATION_BASEPATH + locationId + '/triptypes/' + tripTypeId + '/incentives', incentives);
        }
    }
})();

(function () {
    'use strict';

    productSettingsService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module('redcap.location')
        .factory('productSettingsService', productSettingsService);

    function productSettingsService($q, $log, $filter, $http, $rootScope, rcApi) {

        var BASEPATH = 'productsettings/';

        return {
            getSettings: getSettings,
            getAutomationSettings: getAutomationSettings,
            saveSettings: saveSettings,
            saveAutomationSettings: saveAutomationSettings
        };
        
        function getSettings(dealerId, productId) {
            return rcApi.get(BASEPATH + dealerId + '/' + productId);
        }

        function saveSettings(dealerId, productId, data) {
            return rcApi.post(BASEPATH + dealerId + '/' + productId, data);
        }

        function getAutomationSettings(dealerId, productId) {
            return rcApi.get(BASEPATH + dealerId + '/' + productId + '/automation');
        }

        function saveAutomationSettings(dealerId, productId, data) {
            return rcApi.post(BASEPATH + dealerId + '/' + productId + '/automation', data);
        }
    }
})();

(function () {
    'use strict';

    locationService.$inject = ["$filter", "$rootScope", "rcApi", "SYSTEM_ENUMS"];
    angular
        .module('redcap.location')
        .factory('locationService', locationService);

    function locationService($filter, $rootScope, rcApi, SYSTEM_ENUMS) {

        let LOCATION_BASEPATH = 'dealers/';
             let _currentLocation;
             let _shortLocationDetails;

        return {
            clearCache: clearCache,
            getLocations: getLocations,
            getPagedLocations: getPagedLocations,
            getLocationsForDropDown: getLocationsForDropDown,
            getActiveDealersMinimalData: getActiveDealersMinimalData,
            getLocationsForTripListDropDown: getLocationsForTripListDropDown,
            getLocationsCountForTripListDropDown: getLocationsCountForTripListDropDown,
            hasDuplicateName: hasDuplicateName,
            hasDuplicateAddress: hasDuplicateAddress,
            getLocation: getLocation,
            getLocationDetails: getLocationDetails,
            getLocationDMS: getLocationDMS,
            getLocationHours: getLocationHours,
            getLocationLogos: getLocationLogos,
            getLocationTripTypeInstances: getLocationTripTypeInstances,
            getLocationTransportationTypes: getLocationTransportationTypes,
            getSystemOpCodes: getSystemOpCodes,
            getLocationOpCodes: getLocationOpCodes,
            searchLocationOpCodes: searchLocationOpCodes,
            getLocationDmsDepartments: getLocationDmsDepartments,
            getLocationDepartments: getLocationDepartments,
            getLocationDepartment: getLocationDepartment,
            getLocationDepartmentAvailAdvisor: getLocationDepartmentAvailAdvisor,
            getLocationDepartmentDealerHours: getLocationDepartmentDealerHours,
            getLocationDepartmentAssignedAdvisors: getLocationDepartmentAssignedAdvisors,
            getLocationAdvisorHours: getLocationAdvisorHours,
            updateLocationDepartment: updateLocationDepartment,
            updateLocationDepartments: updateLocationDepartments,
            updateLocationDepartmentAdvisorHours: updateLocationDepartmentAdvisorHours,
            getIntegrations: getIntegrations,
            updateIntegrations: updateIntegrations,
            getTwilioNumbers: getTwilioNumbers,
            get800Number: get800Number,
            get800Numbers: get800Numbers,
            getAdminPrograms: getAdminPrograms,
            getPartnerPrograms: getPartnerPrograms,
            getTaskTypes: getTaskTypes,
            getVehicleTypes: getVehicleTypes,
            getEmployees: getEmployees,
            getDrivers: getDrivers,
            getTimezones: getTimezones,
            getTimezoneNames: getTimezoneNames,
            getAdminConfigs: getAdminConfigs,
            getTimezone: getTimezone,
            getTimezoneName: getTimezoneName,
            addLocation: addLocation,
            updateLocation: updateLocation,
            updateLocationHours: updateLocationHours,
            updateLocationDMS: updateLocationDMS,
            updateLocationTransportationTypes: updateLocationTransportationTypes,
            updateLocationOpCodes: updateLocationOpCodes,
            deleteLocationOpCode: deleteLocationOpCode,
            getCapacities: getCapacities,
            getCapacityGroups: getCapacityGroups,
            updateCapacities: updateCapacities,
            updateCapacityGroups: updateCapacityGroups,
            lookupServiceTypes: lookupServiceTypes,
            lookupDispatchCodes: lookupDispatchCodes,
            lookupLaborTypes: lookupLaborTypes,
            lookupDeliveryOptions: lookupDeliveryOptions,
            importOpCodes: importOpCodes,
            getServiceAdvisors: getServiceAdvisors,
            getCurrentUserServiceAdvisorRecord: getCurrentUserServiceAdvisorRecord,
            getProductPackages: getProductPackages,
            getVenues: getVenues,
            updateVenues: updateVenues,
            saveVenue: saveVenue,
            getStatusText: getStatusText,
            getLocationHTML: getLocationHTML,
            getDmsLogs: getDmsLogs,
            getAutoMatePubSubSubscriptions: getAutoMatePubSubSubscriptions,
            deleteAutoMatePubSubSubscription: deleteAutoMatePubSubSubscription,
            hasTransportationType: hasTransportationType,
            setPreferredDrivers: setPreferredDrivers,
            setBlockedDrivers: setBlockedDrivers,
            getDriverCompanies: getDriverCompanies,
            getDriverPrograms: getDriverPrograms,
            updateDriverCompanies: updateDriverCompanies,
            updateDriverPrograms: updateDriverPrograms,
            getDealersInServiceArea: getDealersInServiceArea,
			isTestModeEnabled: isTestModeEnabled,
            bulkImportDealers: bulkImportDealers,
            getVenueMappings: getVenueMappings,
            getUberServiceability: getUberServiceability,
            getEmployeePermissions: getEmployeePermissions,
            saveEmployeePermissions: saveEmployeePermissions,
            getAdminConfigLocationListLogos: getAdminConfigLocationListLogos,
            hasRole: hasRole,
            getDealerNotes: getDealerNotes,
            addDealerNote: addDealerNote,
            deleteDealerNote: deleteDealerNote,
            setIsAtRisk: setIsAtRisk,
            getVehicleYears: getVehicleYears,
            getVehicleMakesInYear: getVehicleMakesInYear,
            getVehicleModels: getVehicleModels,
            updateDepartmentSettings: updateDepartmentSettings,
            getPredifinedMediaConfigs: getPredifinedMediaConfigs,
            saveUpdatePredifinedMediaConfigs: saveUpdatePredifinedMediaConfigs,
            addTooltipInfoToLocations: addTooltipInfoToLocations,
            hasDuplicateSMSPhone: hasDuplicateSMSPhone,
            changeTripTypeRideProvider: changeTripTypeRideProvider,
            getRideProviderTripTypeInstances: getRideProviderTripTypeInstances,
            createUberOrganizations: createUberOrganizations,
			hasMobileGarageDealer: hasMobileGarageDealer,
            getTripTypesWithDefaultUser: getTripTypesWithDefaultUser,
            updateDefaultUser: updateDefaultUser,
            getDataObfuscationPause: getDataObfuscationPause,
            setDataObfuscationPause: setDataObfuscationPause,
            copyTripTypeInstances: copyTripTypeInstances 
        };

        function clearCache() {
            _currentLocation = null;
        }      

        function getLocations(filter) {
            if (filter)
                return rcApi.post(LOCATION_BASEPATH + 'search', filter);

            return rcApi.get(LOCATION_BASEPATH);
        }

        function getPagedLocations(filter) {
            if (filter)
                return rcApi.post(LOCATION_BASEPATH + 'pagedsearch', filter);

            return rcApi.get(LOCATION_BASEPATH);
        }

        function getLocationsForDropDown(activeOnly, onlyApIntegrated, requiredPermission, requiredSystemTripTypeIds, isForManagement) {
            let url = LOCATION_BASEPATH + 'dealersDropDown?onlyActive=' + (activeOnly || false).toString() +
                        '&onlyApIntegrated=' + (onlyApIntegrated || false).toString();

            if (requiredPermission) {
                url += '&requiredPermission=' + requiredPermission;
            }

            if (requiredSystemTripTypeIds && requiredSystemTripTypeIds.length > 0) {
                url += '&requiredSystemTripTypeInstanceIds=' + requiredSystemTripTypeIds.join(',');
            } else {
                '&requiredSystemTripTypeInstanceIds=null';
            }

            if (isForManagement) {
                url += '&isForManagement=true';
            }

            return rcApi.get(url);
        }

        function getActiveDealersMinimalData(onlyApIntegrated, requiredPermission, requiredSystemTripTypeId, isForManagement) {
            let url = LOCATION_BASEPATH + 'getActiveDealersMinimalData?onlyApIntegrated=' + (onlyApIntegrated || false).toString();

            if (requiredPermission) {
                url += '&requiredPermission=' + requiredPermission;
            }

            if (requiredSystemTripTypeId) {
                url += '&requiredSystemTripTypeInstanceId=' + requiredSystemTripTypeId;
            }

            if (isForManagement) {
                url += '&isForManagement=true';
            }

            return rcApi.get(url);
        }

        function getLocationsForTripListDropDown(activeOnly, onlyApIntegrated, requiredPermission, requiredSystemTripTypeId, isForManagement) {
            let url = LOCATION_BASEPATH + 'GetLocationsForTripListDropDown?onlyActive=' + (activeOnly || false).toString() +
                        '&onlyApIntegrated=' + (onlyApIntegrated || false).toString();

            if (requiredPermission) {
                url += '&requiredPermission=' + requiredPermission;
            }

            if (requiredSystemTripTypeId) {
                url += '&requiredSystemTripTypeInstanceId=' + requiredSystemTripTypeId;
            }

            if (isForManagement) {
                url += '&isForManagement=true';
            }

            return rcApi.get(url);
        }

        function getLocationsCountForTripListDropDown(activeOnly, onlyApIntegrated, requiredPermission, requiredSystemTripTypeId, isForManagement) {
            let url = LOCATION_BASEPATH + 'GetLocationsCountForTripListDropDown?onlyActive=' + (activeOnly || false).toString() +
                        '&onlyApIntegrated=' + (onlyApIntegrated || false).toString();

            if (requiredPermission) {
                url += '&requiredPermission=' + requiredPermission;
            }

            if (requiredSystemTripTypeId) {
                url += '&requiredSystemTripTypeInstanceId=' + requiredSystemTripTypeId;
            }

            if (isForManagement) {
                url += '&isForManagement=true';
            }

            return rcApi.get(url);
        }

        function hasDuplicateName(dealerName, dealerId) {
            let model = {};

            if (dealerName)     model.dealerName = dealerName;
            if (dealerId)       model.dealerId = dealerId;

            return rcApi.get(LOCATION_BASEPATH + 'hasNameDuplicate', model);
        }

        function hasDuplicateAddress(location, dealerId) {
            let model = {};

            if (location.streetAddress) model.address = location.streetAddress;
            if (location.city)          model.city = location.city;
            if (location.state)         model.state = location.state;
            if (location.zip)           model.zip = location.zip;
            if (dealerId)               model.dealerId = dealerId;

            return rcApi.get(LOCATION_BASEPATH + 'hasAddressDuplicate', model);
        }

        function hasDuplicateSMSPhone(smsPhone, dealerId) {
            let model = {};

            if (smsPhone)       model.smsPhone = smsPhone;
            if (dealerId)       model.dealerId = dealerId;

            return rcApi.get(LOCATION_BASEPATH + 'hasSMSPhoneDuplicate', model);
        }

        //This gets only geo-location specific details and phone numbers.
        function getLocationDetails(locationId) {
            if (_shortLocationDetails && _shortLocationDetails.id.toString() === locationId) {
                return _shortLocationDetails;
            }

            return rcApi.get(LOCATION_BASEPATH + locationId + "/getLocationDetails").then((response) => {
                _shortLocationDetails = response;

                return _shortLocationDetails;
            });
        }

        function getLocation(locationId) {

            if (_currentLocation && _currentLocation.id.toString() === locationId) {
                return _currentLocation;
            }

            return rcApi.get(LOCATION_BASEPATH + locationId).then((response) => {
                _currentLocation = response;

                return _currentLocation;
            });
        }

        function getLocationDMS(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms');
        }

        function getIntegrations(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/integrations');
        }

        function getLocationHours(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/hours');
        }

        function getLocationLogos(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/logos');
        }

        function getLocationTripTypeInstances(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/tripTypes');
        }

        function getLocationTransportationTypes(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/transportationtypes');
        }

        function getSystemOpCodes() {
            return rcApi.get(LOCATION_BASEPATH + '/opcodes/system').then((result) => {
                // Generic / Non Generic split to reduce code repetition
                return {
                    opCodes: $filter('filter')(result, {isGeneric: false, isRecall: false, isRecommendedMaintenance: false, isAutomatic: false}, true),
                    genericOpCodes: $filter('filter')(result, {isGeneric: true}, true),
                    recallOpCodes: $filter('filter')(result, {isRecall: true}, true),
                    recommendedMaintenanceOpCodes: $filter('filter')(result, {isRecommendedMaintenance: true}, true),
                    automaticOpCodes: $filter('filter')(result, {isAutomatic: true}, true),
                    all: result
                };
            });
        }

        function getLocationOpCodes(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/opcodes').then((result) => {
                // Generic / Non Generic split to reduce code repetition
                if (result) {
                    result.forEach((o) => {
                        if (o.retailPrice && o.retailPrice != 0) {
                            o.retailPrice = o.retailPrice.toFixed(2);
                        }
                    });
                }

                return {
                    opCodes: $filter('filter')(result, {isGeneric: false, isRecall: false, isRecommendedMaintenance: false}, true),
                    genericOpCodes: $filter('filter')(result, {isGeneric: true}, true),
                    recallOpCodes: $filter('filter')(result, {isRecall: true}, true),
                    recommendedMaintenanceOpCodes: $filter('filter')(result, {isRecommendedMaintenance: true}, true),
                    automaticOpCodes: $filter('filter')(result, {isAutomatic: true}, true),
                    all: result
                };
            });
        }

        function searchLocationOpCodes(locationId, deptId, searchTerm, page, pageSize, includeDealerMappedInResultSet, exactOpCodeMatch) {
            let route = '/opcodes/';
            
            if (includeDealerMappedInResultSet === true) {
                route = route + 'all/';
            }

            const requestParams = {
                searchTerm: searchTerm,
                page: page || 1,
                pageSize: pageSize || 25,
                exactOpCodeMatch: exactOpCodeMatch
            };

            if (deptId) {
                requestParams.dealerDeptId = deptId;
            }

            return rcApi.get(LOCATION_BASEPATH + locationId + route, requestParams).then((opCodes) => {
                if (opCodes) {
                    opCodes.forEach((o) => {
                        o.dealerAppointmentOpCodeId = o.id;
                        o.id = o.opCode; // TODO: look into rewriting this, not sure why James did it originally, but it feels wrong.
                        o.text = o.dashboardDescription;
                    });

                    return opCodes;
                }
            });
        }

        function updateLocationTransportationTypes(locationId, locationTransportationTypes) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/transportationtypes', {dealerTransportationTypes: locationTransportationTypes});
        }

        function updateLocationOpCodes(locationId, locationOpCodes) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/opcodes', {dealerAppointmentServiceOpCodes: locationOpCodes});
        }

        function deleteLocationOpCode(locationId, opCodeId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/deleteopcode/' + opCodeId);
        }

        function getLocationDmsDepartments(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/department/dms/serviceshops');
        }

        function getLocationDepartments(locationId, excludeDepartmentsWithoutServiceAdvisors, includeDepartmentsWithFutureAppts) {
            let qryString = '';

            if (excludeDepartmentsWithoutServiceAdvisors === true) {
                qryString = '?excludeDepartmentsWithoutServiceAdvisors=true';
            } else if (includeDepartmentsWithFutureAppts === true) {
                qryString = '?includeDepartmentsWithFutureAppts=true';
            }

            return rcApi.get(LOCATION_BASEPATH + locationId + '/departments' + qryString);
        }

        function getLocationDepartment(locationId, departmentId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/department/' + departmentId);
        }

        function getLocationDepartmentAvailAdvisor(locationId, departmentId, ignoreAvailability) {
            // Default availability to true
            let queryParams = {};
            
            if (ignoreAvailability === undefined || !ignoreAvailability) {
                queryParams.includeAvailability = true;
            } else {
                queryParams.includeAvailability = false;
            }

            queryParams.includeAvailability = ignoreAvailability;
           
            return rcApi.get(LOCATION_BASEPATH + locationId + '/department/' + departmentId + '/advisor', queryParams);
        }

        function getLocationDepartmentDealerHours(locationId, departmentId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/department/dealerhours' + (!departmentId ? '' : '/' + departmentId));
        }

        function getLocationDepartmentAssignedAdvisors(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/department/advisors/assigned');
        }

        function getLocationAdvisorHours(locationId, advisorId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/advisorhours/' + advisorId);
        }

        function updateLocationDepartments(locationId, departments) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/updatedepartments', {dealerDepartments: departments});
        }

        function updateLocationDepartment(locationId, department) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/department', department);
        }

        function updateDepartmentSettings(department) {
            return rcApi.put(LOCATION_BASEPATH + 'department/settings', department);
        }

        function updateLocationDepartmentAdvisorHours(locationId, advisor) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/advisorhours', advisor);
        }

        function getTwilioNumbers(lat, lng) {
            return rcApi.get('twilio', {lat: lat, lng: lng});
        }

        function get800Number() {
            return rcApi.get('twilio');
        }

        function get800Numbers() {
            return rcApi.get('twilio/multiple');
        }

        function getAdminPrograms() {
            return rcApi.get('adminConfig');
        }

        function getPartnerPrograms() {
            return rcApi.get(LOCATION_BASEPATH + 'partnerPrograms');
        }

        function getTaskTypes() {
            return rcApi.get(LOCATION_BASEPATH + 'taskTypes');
        }

        function getVehicleTypes() {
            return rcApi.get(LOCATION_BASEPATH + 'vehicleTypes');
        }

        function getEmployees(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/users');
        }

        function getDrivers(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/drivers');
        }

        function getTimezones() {
            return rcApi.get(LOCATION_BASEPATH + 'timezone');
        }

        function getTimezoneNames() {
            return rcApi.get(LOCATION_BASEPATH + 'timezones');
        }

        function getTimezone(lat, lng) {
            return rcApi.post(LOCATION_BASEPATH + 'timezone', {lat: lat, lng: lng});
        }

        function getTimezoneName(ianaId) {
            return rcApi.post(LOCATION_BASEPATH + 'timezoneName', {value: ianaId});
        }

        function getAdminConfigs() {
            return rcApi.get(LOCATION_BASEPATH + 'program');
        }

        function getServiceAdvisors(locationId, currentServiceAdvisor, filterServiceAdvisor, filterDmsEmployee, filterProgramAdmins, excludeProgramAdmin) {
            let queryParams = []; let strParm = '';
            
            if (currentServiceAdvisor) {
                queryParams.push('currentServiceAdvisorIdentityId=' + currentServiceAdvisor);
            }

            if (filterServiceAdvisor === true) {
                queryParams.push('serviceAdvisorsOnly=true');
            }

            if (filterDmsEmployee === true) {
                queryParams.push('onlyDmsEmployees=true');
            }

            if (filterProgramAdmins === true) {
                queryParams.push('excludeProgramAdmins=true');
            }

            for (let i = 0; i < queryParams.length; i++) {
                if (i > 0) {
                    strParm += '&';
                } else {
                    strParm += '?';
                }

                strParm += queryParams[i];
            }

            return rcApi.get(LOCATION_BASEPATH + locationId + '/serviceAdvisors' + strParm);
        }

        function getCurrentUserServiceAdvisorRecord(locationId, currentServiceAdvisor, filterServiceAdvisor, filterDmsEmployee, filterProgramAdmins) {
            let queryParams = []; let strParm = '';
            
            if (currentServiceAdvisor) {
                queryParams.push('currentServiceAdvisorIdentityId=' + currentServiceAdvisor);
            }

            if (filterServiceAdvisor === true) {
                queryParams.push('serviceAdvisorsOnly=true');
            }

            if (filterDmsEmployee === true) {
                queryParams.push('onlyDmsEmployees=true');
            }

            if (filterProgramAdmins === true) {
                queryParams.push('excludeProgramAdmins=true');
            }

            for (let i = 0; i < queryParams.length; i++) {
                if (i > 0) {
                    strParm += '&';
                } else {
                    strParm += '?';
                }

                strParm += queryParams[i];
            }

            return rcApi.get(LOCATION_BASEPATH + locationId + '/getCurrentUserServiceAdvisorInfo' + strParm);
        }

        function addLocation(newLocation) {
            return rcApi.post(LOCATION_BASEPATH, newLocation).then((response) => {
                if (angular.isNumber(response)) { //return is a newly created dealer id when successful
                    $rootScope.$broadcast('LocationService.changed', newLocation);
                }

                return response;
            });
        }

        function updateLocation(updatedLocation) {
            return rcApi.put(LOCATION_BASEPATH + updatedLocation.id, updatedLocation).then((response) => {
                if (response === true) {
                    _currentLocation = null;  // This will force the api to get the location again when getLocation is called, because _currentLocation will be null
                    $rootScope.$broadcast('LocationService.changed', updatedLocation);
                }

                return response;
            });
        }

        function getCapacities(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/capacities');
        }

        function getCapacityGroups(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/capacities/groups');
        }

        function updateCapacityGroups(locationId, groups) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/capacities/groups', groups);
        }

        function updateCapacities(locationId, tripCapacities) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/capacities', tripCapacities);
        }

        function updateLocationHours(locationId, updatedHours, blackoutDates, tripCapacities) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/hours', {
                hours: updatedHours,
                blackouts: blackoutDates,
                tripCapacities: tripCapacities
            });
        }

        function updateLocationDMS(locationId, updatedDMS) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/dms', updatedDMS);
        }

        function updateIntegrations(locationId, updatedIntegrations) {
            updatedIntegrations.dealer = null;

            return rcApi.put(LOCATION_BASEPATH + locationId + '/integrations', updatedIntegrations);
        }

        function lookupDispatchCodes(locationId, dmsEntry) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms/GetDispatchCodes', dmsEntry);
        }

        function lookupLaborTypes(locationId, dmsEntry) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms/GetLaborTypes', dmsEntry);
        }

        function lookupDeliveryOptions(locationId, dmsEntry) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms/GetDeliveryOptions', dmsEntry);
        }

        function lookupServiceTypes(locationId, dmsValues) {
            const urlParams = {
                dmsDealerId: dmsValues.dmsDealerId,
                dmsEnterpriseId: dmsValues.dmsEnterpriseId, 
                dmsSystem: dmsValues.dmsSystem
            };

            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms/servicetypes', urlParams);
        }

        function importOpCodes(locationId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/dms/importopcodes');
        }

        function getProductPackages() {
            return rcApi.get(LOCATION_BASEPATH + 'productPackages');
        }

        function getVenues(dealerId, venuesOnly) {
            venuesOnly = venuesOnly || false;

            return rcApi.get(LOCATION_BASEPATH + dealerId + '/venues?venuesOnly=' + venuesOnly);
        }

        function updateVenues(dealerId, newLocations, removeLocations) {
            return rcApi.post(LOCATION_BASEPATH + dealerId + '/venues', {
                newFavoriteLocations: newLocations,
                deleteFavoriteLocations: removeLocations
            }).then((response) => {
                return response;
            });
        }

        function saveVenue(dealerTripTypeId, venue) {
            return rcApi.post(LOCATION_BASEPATH + dealerTripTypeId + '/venuemappings', venue);
        }

        function getStatusText (statusId) {
            let status = $filter('filter')(SYSTEM_ENUMS.dealerStatuses, {value: statusId})[0];

            return status.text;
        }

        function getLocationHTML (location, showOemDealerId) {
            if (showOemDealerId && location.oemDealerId && location.oemDealerId !== '') {
                return location.name + ' ('  + location.oemDealerId + ')' + ' (' + location.city + ', ' + location.state +  ') - (' + getStatusText(location.status) + ')';
            } else {
                return location.name + ' (' + location.city + ', ' + location.state + ') - (' + getStatusText(location.status) + ')';
            }
        }

        function getDmsLogs(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms/logs');
        }

        function getAutoMatePubSubSubscriptions(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/dms/automate/pubsub');
        }

        function deleteAutoMatePubSubSubscription(locationId, operation, type) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/dms/automate/pubsub/' + encodeURIComponent(operation) + '/' + encodeURIComponent(type));
        }

        function hasTransportationType (transportationTypes, systemTripTypeId) {
            let type = $filter('filter')(transportationTypes, {systemTripTypeId: systemTripTypeId, status: 1}, true);

            if (type && type.length > 0) return true;

            return false;
        }
        
        function setPreferredDrivers(driverIds, locationId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/preferreddrivers', driverIds);
        }
        
        function setBlockedDrivers(driverIds, locationId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/blockeddrivers', driverIds);
        }

        function getDriverCompanies() {
            return rcApi.get(LOCATION_BASEPATH + '/drivercompanies');
        }

        function getDriverPrograms() {
            return rcApi.get(LOCATION_BASEPATH + '/driverprograms');
        }

        function updateDriverCompanies(dealerId, companyIds) {
            return rcApi.put(LOCATION_BASEPATH + '/' + dealerId + '/drivercompanies', companyIds);
        }

        function updateDriverPrograms(dealerId, programIds) {
            return rcApi.put(LOCATION_BASEPATH + '/' + dealerId + '/driverprograms', programIds);
        }

        function getDealersInServiceArea(radiusInMeters, homeBaseLat, homeBaseLng, driverId) {
            return  rcApi.get(LOCATION_BASEPATH + 'locationsinrange', {driverId: driverId, radiusInMeters: radiusInMeters, driverBaseLocationLat: homeBaseLat, driverBaseLocationLng: homeBaseLng});
        }
        
		function isTestModeEnabled(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/isTestModeEnabled');
        }

        function bulkImportDealers(base64FileData, dealerIdToCopyFrom) {
            return rcApi.post(LOCATION_BASEPATH + 'bulkimport', {base64FileData: base64FileData, dealerIdToCopyFrom: dealerIdToCopyFrom});   
        }
        
        function getVenueMappings(dealerId) {
            let dealerParam = dealerId ? ('?dealerId=' + dealerId) : '';

            return rcApi.get(LOCATION_BASEPATH + 'venuemappings' + dealerParam);   
        }

        function getUberServiceability(address) {
            return rcApi.post(LOCATION_BASEPATH + 'serviceability', address);   
        }

        function getEmployeePermissions(locationId, showOnlyDealerProducts) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/userpermissions', {showOnlyDealerProducts: showOnlyDealerProducts});
        }

        function saveEmployeePermissions(locationId, users) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/userpermissions', users);
        }

        function getAdminConfigLocationListLogos () {
            return rcApi.get('adminConfig/getAdminProgramLocationListLogos');
        }

		function hasRole(dealerId, roleName) {
            return rcApi.get(LOCATION_BASEPATH  + dealerId + '/hasRole?roleName=' + roleName);   
        }

        function getDealerNotes(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/notes');
        }

        function addDealerNote(locationId, note) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/notes', {value: note});
        }

        function deleteDealerNote(noteId) {
            return rcApi.remove(LOCATION_BASEPATH + '/notes/' + noteId);
        }
        
        function setIsAtRisk(locationId, isAtRisk) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/atrisk', {value: isAtRisk});
        }

        function getVehicleYears(locationId) {
            return rcApi.get('dealer/' + locationId + '/vehicles/' + 'year');
        }

        function getVehicleMakesInYear(locationId, year) {
            return rcApi.get('dealer/' + locationId + '/vehicles/' + 'year/' + year);
        }

        function getVehicleModels(locationId, year, make) {
            return rcApi.get('dealer/' + locationId + '/vehicles/' + 'make/' + encodeURIComponent(make) + '?year=' + year);
        }
        
        function getPredifinedMediaConfigs(locationId, appointmentId) {
            let apiUrl = LOCATION_BASEPATH + locationId + '/PredifinedMediaConfigs';

            apiUrl = appointmentId == null ? apiUrl : apiUrl + "/" + appointmentId;

            return rcApi.get(apiUrl);
        }

        function saveUpdatePredifinedMediaConfigs(locationId, mediaConfigItems) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/SaveUpdatePredifinedMediaConfigs', mediaConfigItems);
        }

        function getRideProviderTripTypeInstances(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/rideProviderTripTypeInstances');
        }

        function changeTripTypeRideProvider(locationId, systemTripTypeId, rideProviderType) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/changeTripTypeRideProvider', {systemTripTypeId: systemTripTypeId, rideProviderType: rideProviderType});
        }

        function createUberOrganizations(dealerIds) {
            return rcApi.post(LOCATION_BASEPATH + '/createUberOrganizations', {dealerIds: dealerIds});
        }

        function addTooltipInfoToLocations(vm, locations) {
            locations.forEach((location) => {
                let locHTML = vm.isSysAdmin ? '<div title="RC: ' + location.id + '">' + location.name + '</div>' : '<div>' + location.name + '</div>';

                location.html = locHTML;

                switch (location.status) {
                    case 1:
                        location.statusText = 'Active';
                        break;
                    case 2:
                        location.statusText = 'QA';
                        break;
                    case 3:
                        location.statusText = 'Install';
                        break;
                    default:
                        location.statusText = 'Disabled';
                        break;
                }
            });
        }

        function hasMobileGarageDealer() {
            let url = LOCATION_BASEPATH + 'hasMobileGarageDealer';

            return rcApi.get(url);
        }
        
        function getTripTypesWithDefaultUser(identityUserId) {
            return rcApi.get(LOCATION_BASEPATH + 'defaultUserInTripTypes/' + identityUserId);
        }

        function updateDefaultUser(tripTypes) {
            return rcApi.put(LOCATION_BASEPATH + 'defaultUserInTripTypes', tripTypes);
        }

        function getDataObfuscationPause(dealerId) {
            return rcApi.get(LOCATION_BASEPATH + dealerId + '/data-obfuscation/pause');
        }

        function setDataObfuscationPause(dealerId, isPaused) {
            return rcApi.post(LOCATION_BASEPATH + dealerId + '/data-obfuscation/pause', {isPaused: isPaused});
        }

        function copyTripTypeInstances(copyData) {
            return rcApi.post(LOCATION_BASEPATH + 'copyTripTypeInstances', copyData);
        }
    }
})();

(function () {
    'use strict';

    loanerSettingsService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module('redcap.location')
        .factory('loanerSettingsService', loanerSettingsService);

    function loanerSettingsService($q, $log, $filter, $http, $rootScope, rcApi) {

        var BASEPATH = 'loanersettings/';

        return {
            getMakes: getMakes,
            getModels: getModels,
            getSettings: getSettings,
            getNotificationSettings: getNotificationSettings,
            saveSettings: saveSettings,
            saveNotificationSettings: saveNotificationSettings
        };
        
        function getSettings(dealerId) {
            return rcApi.get(BASEPATH + dealerId);
        }

        function saveSettings(dealerId, data) {
            return rcApi.post(BASEPATH + dealerId , data);
        }

        function getNotificationSettings(dealerId) {
            return rcApi.get(BASEPATH + dealerId + '/notifications');
        }

        function saveNotificationSettings(dealerId, data) {
            return rcApi.post(BASEPATH + dealerId + '/notifications', data);
        }

        function getMakes(dealerId) {
            return rcApi.get(BASEPATH + dealerId + '/makes');
        }

        function getModels(dealerId, makeId) {
            return rcApi.get(BASEPATH + dealerId + '/models/' + makeId);
        }
    }
})();

(function () {
    'use strict';

    dealerInspectionService.$inject = ["rcApi"];
    angular
        .module('redcap.location')
        .factory('dealerInspectionService', dealerInspectionService);

    function dealerInspectionService(rcApi) {
        const LOCATION_BASEPATH = 'dealers/';

        return {
            getRoStatuses: getRoStatuses,
            createRoStatus: createRoStatus,
            updateInspectRoStatus: updateInspectRoStatus,
            deleteRoStatus: deleteRoStatus,
            getShopFlags: getShopFlags,
            addShopFlags: addShopFlags,
            updateShopFlags: updateShopFlags,
            removeShopFlag: removeShopFlag,
            getPartsStatus: getPartsStatus,
            addPartsStatus: addPartsStatus,
            updatePartsStatus: updatePartsStatus,
            removePartsStatus: removePartsStatus,
            getInspectionForms: getInspectionForms,
            getInspectionFormDetail: getInspectionFormDetail,
            getDealersWithCopyableInspectionForms: getDealersWithCopyableInspectionForms,
            getInspectionFormsToCopy: getInspectionFormsToCopy,
            updateInspectionForms: updateInspectionForms,
            saveInspectionForm: saveInspectionForm,
            publishInspectionForm: publishInspectionForm,
            deleteForm: deleteForm,
            deleteFormSection: deleteFormSection,
            deleteFormTask: deleteFormTask,
            deleteFormObservation: deleteFormObservation,
            deleteFormRecommendation: deleteFormRecommendation,
            deleteFormMeasurementComponent: deleteFormMeasurementComponent,
            deleteFormMeasurementLevel: deleteFormMeasurementLevel,
            copyAllInspectForms: copyAllInspectForms,
            copyInspectForm: copyInspectForm,
            getLaborRateSettings: getLaborRateSettings,
            updateLaborRateSettings: updateLaborRateSettings,
            addCustomLaborRate: addCustomLaborRate,
            updateCustomLaborRate: updateCustomLaborRate,
            deleteCustomLaborRate: deleteCustomLaborRate,
            addMatrixLaborRate: addMatrixLaborRate,
            updateMatrixLaborRate: updateMatrixLaborRate,
            deleteMatrixLaborRate: deleteMatrixLaborRate,
            getShopSupplies: getShopSupplies,
            updateShopSupplies: updateShopSupplies,
            getShopTaxes: getShopTaxes,
            addNewTaxes: addNewTaxes,
            updateTaxes: updateTaxes,
            deleteTaxes: deleteTaxes,
        };

        function getRoStatuses(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/roStatuses');
        }

        function createRoStatus(locationId, status) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/roStatuses', status);
        }

        function updateInspectRoStatus(locationId, statusId, status) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/roStatuses/' + statusId, status);
        }

        function deleteRoStatus(locationId, statusId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/roStatuses/' + statusId);
        }

        function getShopFlags(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/shopFlags');                       
        }

        function addShopFlags(locationId, shopFlags) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/shopFlags', shopFlags);
        }

        function updateShopFlags(locationId, shopFlags) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/shopflags', shopFlags);
        }

        function removeShopFlag(locationId, shopFlags) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/shopflags', shopFlags);
        }

        function getPartsStatus(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/partsStatus');                       
        }

        function addPartsStatus(locationId, partsStatus) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/partsStatus', partsStatus);
        }

        function updatePartsStatus(locationId, partsStatus) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/partsStatus', partsStatus);
        }

        function removePartsStatus(locationId, partsStatus) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/partsStatus', partsStatus);
        }

        function getInspectionForms(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/inspectionforms');
        }

        function getInspectionFormDetail(locationId, formId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + `/inspectionforms/${formId}`);
        }

        function updateInspectionForms(locationId, inspectionForms) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/inspectionFormList', inspectionForms);
        }

        function saveInspectionForm(locationId, inspectionForm) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/inspectionforms', inspectionForm);
        }

        function publishInspectionForm(locationId, inspectionFormId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/inspectionforms/publish/' + inspectionFormId);
        }

        function deleteForm(locationId, formId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/' + formId);
        }
        
        function deleteFormSection(locationId, formSectionId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/section/' + formSectionId);
        }

        function deleteFormTask(locationId, formTaskId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/task/' + formTaskId);
        }

        function deleteFormObservation(locationId, formTaskObservationId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/task/observation/' + formTaskObservationId);
        }

        function deleteFormRecommendation(locationId, formTaskRecommendationId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/task/recommendation/' + formTaskRecommendationId);
        }

        function deleteFormMeasurementComponent(locationId, taskMeasurementId, formMeasurementComponentId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/task/measurement/' + taskMeasurementId + '/component/' + formMeasurementComponentId);
        }

        function deleteFormMeasurementLevel(locationId, formMeasurementLevelId) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/inspectionforms/task/level/' + formMeasurementLevelId);
        }

        function getLaborRateSettings(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/laborRateSettings');
        }

        function updateLaborRateSettings(locationId, id, matrixRate) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/laborRateSettings/' + id, matrixRate);
        }

        function addCustomLaborRate(locationId, customRate) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/customLaborRates', customRate);
        }
        
        function updateCustomLaborRate(locationId, id, customRate) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/customLaborRates/' + id, customRate);
        }

        function deleteCustomLaborRate(locationId, id) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/customLaborRates/' + id);
        }
        
        function addMatrixLaborRate(locationId, matrixRate) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/matrixLaborRates', matrixRate);
        }
        
        function updateMatrixLaborRate(locationId, id, matrixRate) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/matrixLaborRates/' + id, matrixRate);
        }
        
        function deleteMatrixLaborRate(locationId, id) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/matrixLaborRates/' + id);
        }

        function getShopSupplies(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/shopSupplies');
        }

        function updateShopSupplies(locationId, shopSupplies) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/shopSupplies', shopSupplies);
        }

        function getShopTaxes(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/shopTaxes');
        }

        function addNewTaxes(locationId, tax) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/shopTaxes', tax);
        }

        function updateTaxes(locationId, tax) {
            return rcApi.put(LOCATION_BASEPATH + locationId + '/shopTaxes', tax);
        }

        function deleteTaxes(locationId, tax) {
            return rcApi.remove(LOCATION_BASEPATH + locationId + '/shopTaxes', tax);
        }

        function getDealersWithCopyableInspectionForms() {
            return rcApi.get(LOCATION_BASEPATH + 'dealersWithInspectionForms');
        }

        function getInspectionFormsToCopy(locationId) {
            return rcApi.get(LOCATION_BASEPATH + locationId + '/inspectionFormsToCopyFrom');
        }

        function copyAllInspectForms(locationId, copyFromDealerId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/copyAllInspectionForms/' + copyFromDealerId);
        }

        function copyInspectForm(locationId, copyFromDealerId, copyFormId) {
            return rcApi.post(LOCATION_BASEPATH + locationId + '/copyInspectionForm/' + copyFromDealerId + '/' + copyFormId);
        }
    }
})();

(function () {
    'use strict';

    dealerConfigService.$inject = ["rcApi"];
    angular
        .module('redcap.location')
        .factory('dealerConfigService', dealerConfigService);

    function dealerConfigService(rcApi) {
        const CONFIG_KEYS_BASE_PATH = 'dealers/';

        return {
            getConfigKeys: getConfigKeys,
            getConfigValue: getConfigValue,
            saveConfigValue: saveConfigValue
        };

        function getConfigKeys(dealerId, dealerTripTypeId) {
            return rcApi.get(`${CONFIG_KEYS_BASE_PATH}${dealerId}/tripTypes/${dealerTripTypeId}/configkeys`).then((response) => {
                    if (!response || typeof response !== 'object') {
                        return [];
                    }

                    const configKeys = (response.tripTypeSpecificConfigs || [])
                        .map(config => config.configKey)
                        .filter(key => !!key);

                    return Array.from(new Set(configKeys));
                });
        }

        function getConfigValue(dealerId, dealerTripTypeId, configKey) {
            let filterPath = `${CONFIG_KEYS_BASE_PATH}${dealerId}/tripTypes/${dealerTripTypeId}/filter`;
            
            return rcApi.post(filterPath, {
                tripTypeCommonConfigs: [],
                tripTypeSpecificConfigs: [configKey]
            }).then((response) => {
                if (!response) return '';

                let specificMatch = (response.tripTypeSpecificConfigs || []).find(c => c.configKey === configKey);
                
                if (specificMatch) return specificMatch.configValue;

                return '';
            });
        }

        function saveConfigValue(payload) {
            let url = `${CONFIG_KEYS_BASE_PATH}${payload.dealerId}/tripTypes/${payload.dealerTripTypeId}`;
                        
            return rcApi.put(url, {
                tripTypeCommonConfigs: [],
                tripTypeSpecificConfigs: [{configKey: payload.configKey, configValue: payload.configValue}],
                status: payload.status || 1
            });
        }
    }
})();

(function () {
    'use strict';

    constraintService.$inject = ["rcApi", "timeUtilService", "appointmentUtilService", "appointmentRecurrenceOptionClass", "$filter"];
    angular
        .module('redcap.appointment')
        .factory('constraintService', constraintService);

    function constraintService(rcApi, timeUtilService, appointmentUtilService, appointmentRecurrenceOptionClass, $filter) {

        var CONSTRAINT_BASEPATH = 'dealer/';

        return {
            getConstraintsByType: getConstraintsByType,
            saveConstraints: saveConstraints,
            getRecurrenceOptions: getRecurrenceOptions,
            validateLimitPerHourPerDayConstraints: validateLimitPerHourPerDayConstraints,
            newConstraint: newConstraint,
            constraintToString: constraintToString
        };

        function saveConstraints(locationId, constraints) {
            return rcApi.put(CONSTRAINT_BASEPATH + locationId + '/constraints', constraints);
        }

        function getConstraintsByType(dealerId, departmentId, advisorId, constraintDefinitionType) {
            var route = CONSTRAINT_BASEPATH + dealerId + '/constraints/bytype/' + constraintDefinitionType;
            if (departmentId) {
                route += '/department/' + departmentId;
            }
            if (advisorId) {
                route += '/advisor/' + advisorId;
            }
            return rcApi.get(route).then(function (results) {
                _.forEach(results, function (item) {
                    if (item.constraintData) {
                        item.constraintDataParsed = JSON.parse(item.constraintData);
                    }
                    item.uid = appointmentUtilService.generateUID(null, item.id);
                });
                return results;
            });
        }

        function getRecurrenceText(recurrenceOption, startDate) {
            if (recurrenceOption.repeatAnnually && recurrenceOption.repeatOnTheDate) {
                return 'on the date';
            }
            let dayName = timeUtilService.days[startDate.getDay()];
            let monthName = timeUtilService.months[startDate.getMonth()];
            let day = startDate.getDay();

            // Loop up one week at a time to determine if we're at the last iteration for the day for the month
            let number = 0;
            let remainder = 0;
            let suffix = '';

            remainder = startDate.getDate() % 7;
            number = Math.floor(startDate.getDate() / 7);
            if (remainder > 0) {
                number += 1;
            }
            switch (number) {
                case 1:
                    suffix = 'st';
                    break;
                case 2:
                    suffix = 'nd';
                    break;
                case 3:
                    suffix = 'rd';
                    break;
                case 4:
                case 5:
                    suffix = 'th';
                    break;
            }

            // If we add 7 days to the dateBusinessClosed and it is not a valid date, then we know it is the last day of the month
            let nextWeekDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 7);
            if (nextWeekDay.getMonth() === startDate.getMonth()) {
                return 'on the ' + number + suffix + ' ' + dayName + ' of ' + monthName;
            } else if (recurrenceOption.recurrenceNthDayOfWeek > 0) {
                return 'on the ' + number + suffix + ' ' + dayName + ' of ' + monthName;
            } else if (recurrenceOption.recurrenceNthDayOfWeek === -1) {
                return 'on the last ' + dayName + ' of ' + monthName;
            }
        }

        function getRecurrenceOptions(startDate, endDate) {
            var recurrenceOptions = [];
            if (startDate) {
                let day = startDate.getDay();
                let isDateRange = startDate.getTime() !== endDate.getTime();
                let recurrenceOption = appointmentRecurrenceOptionClass.new();
                recurrenceOption.text = 'Not Recurring';
                recurrenceOption.repeatAnnually = false;
                recurrenceOption.repeatOnTheDate = false;
                if (isDateRange) {
                    recurrenceOption.repeatDaily = true;
                } else {
                    recurrenceOption.repeatDaily = false;
                    recurrenceOption.recurrenceDay = startDate.getDate();
                    recurrenceOption.recurrenceMonth = startDate.getMonth() + 1;
                }
                recurrenceOptions.push(recurrenceOption);
                recurrenceOption = appointmentRecurrenceOptionClass.new();
                recurrenceOption.repeatAnnually = true;
                recurrenceOption.repeatOnTheDate = true;
                recurrenceOption.recurrenceDay = startDate.getDate();
                recurrenceOption.recurrenceMonth = startDate.getMonth() + 1;
                recurrenceOption.text = getRecurrenceText(recurrenceOption, startDate);
                recurrenceOptions.push(recurrenceOption);
                let month = startDate.getMonth();
                // Loop up one week at a time to determine if we're at the last iteration for the day for the month
                let number = 0;
                let remainder = 0;

                remainder = startDate.getDate() % 7;
                number = Math.floor(startDate.getDate() / 7);
                if (remainder > 0) {
                    number += 1;
                }

                let nextWeekDay = new Date();
                // If we add 7 days to the dateBusinessClosed and it is not a valid date, then we know it is the last day of the month
                nextWeekDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 7);
                if (nextWeekDay.getMonth() === startDate.getMonth()) {
                    recurrenceOption = appointmentRecurrenceOptionClass.new();
                    recurrenceOption.repeatAnnually = true;
                    recurrenceOption.recurrenceDayOfWeek = day;
                    recurrenceOption.recurrenceNthDayOfWeek = number;
                    recurrenceOption.recurrenceMonth = month + 1;
                    recurrenceOption.text = getRecurrenceText(recurrenceOption, startDate);
                    recurrenceOptions.push(recurrenceOption);
                } else {
                    recurrenceOption = appointmentRecurrenceOptionClass.new();
                    recurrenceOption.repeatAnnually = true;
                    recurrenceOption.recurrenceDayOfWeek = day;
                    recurrenceOption.recurrenceNthDayOfWeek = number;
                    recurrenceOption.recurrenceMonth = month + 1;
                    recurrenceOption.text = getRecurrenceText(recurrenceOption, startDate);
                    recurrenceOptions.push(recurrenceOption);
                    recurrenceOption = appointmentRecurrenceOptionClass.new();
                    recurrenceOption.repeatAnnually = true;
                    recurrenceOption.recurrenceDayOfWeek = day;
                    recurrenceOption.recurrenceNthDayOfWeek = -1;
                    recurrenceOption.recurrenceMonth = month + 1;
                    recurrenceOption.text = getRecurrenceText(recurrenceOption, startDate);
                    recurrenceOptions.push(recurrenceOption);
                }
            }
            return recurrenceOptions;
        }

        // Shared validation logic
        function validateLimitPerHourPerDayConstraints(constraints, filterPredicate) {
            var perHourTimes = {}, 
                perDayTimes = {}, 
                i, currDay;

            // Set up the arrays for time overlap validation
            for (i = 0; i < timeUtilService.days.length; i++) {
                currDay = timeUtilService.days[i];
                perHourTimes[currDay] = [];
                perDayTimes[currDay] = [];
            }

            if (filterPredicate && typeof filterPredicate === 'object') {
                constraints = $filter('filter')(constraints, filterPredicate, true);
            }

            _.each(constraints, function (constraint) {
                if (constraint.isDeleted === true) {
                    return;
                }
                
                var isPerHourFrequency = false,
                    isPerHourAccumalative = false,
                    constraintDataParsed = constraint.constraintDataParsed;

                // Create a running tab of the repeat days to ensure no overlap
                if (constraintDataParsed && 
                    (constraintDataParsed.LimitAccumulative === false || constraintDataParsed.limitAccumulative === false)) {
                    isPerHourFrequency = true;
                }

                if (constraintDataParsed && 
                    (constraintDataParsed.LimitAccumulative === true || constraintDataParsed.limitAccumulative === true)) {
                    isPerHourAccumalative = true;
                }
                
                var time = { 
                    startTime: constraint.startTime, 
                    endTime: constraint.endTime, 
                    userLimitType: !isPerHourFrequency && !isPerHourAccumalative ? null : constraintDataParsed.userLimitType || constraintDataParsed.UserLimitType 
                };

                for (i = 0; i < timeUtilService.days.length; i++) {
                    currDay = timeUtilService.days[i];
                    if (constraint['repeat' + currDay] === true) {
                        if (isPerHourFrequency) {
                            perHourTimes[currDay].push(time);
                        } else {
                            perDayTimes[currDay].push(time);
                        }
                    }
                }
            });

            // Validate any time overlaps
            var timesAreValid = true;
            for (i = 0; i < timeUtilService.days.length; i++) {
                currDay = timeUtilService.days[i];
                if (!timeUtilService.validateTimesDoNotOverlap(perHourTimes[currDay]) || 
                    !timeUtilService.validateTimesDoNotOverlap(perDayTimes[currDay])) {
                    timesAreValid = false;
                    break;
                }
            }
            return timesAreValid;
        }

        function newConstraint(startDate, startTime, endDate, endTime, recurrenceOption, constraintDefinitionType) {
            var isDateRange = (startDate && !endDate) || (startDate.getTime() !== endDate.getTime());
            if (isDateRange && !recurrenceOption) {
                recurrenceOption = appointmentRecurrenceOptionClass.new();
                recurrenceOption.repeatDaily = true;
            } else if (!isDateRange && (recurrenceOption.repeatAnnually || recurrenceOption.repeatOnTheDate)) {
                endDate = null;
            }
            return {
                id: 0,
                allDay: false,
                dealerId: null,
                departmentId: null,
                advisorId: null,
                constraintData: null,
                repeatAnnually: recurrenceOption.repeatAnnually,
                repeatDaily: recurrenceOption.repeatDaily,
                repeatOnTheDate: recurrenceOption.repeatOnTheDate,
                repeatMonday: recurrenceOption.repeatMonday,
                repeatTuesday: recurrenceOption.repeatTuesday,
                repeatWednesday: recurrenceOption.repeatWednesday,
                repeatThursday: recurrenceOption.repeatThursday,
                repeatFriday: recurrenceOption.repeatFriday,
                repeatSaturday: recurrenceOption.repeatSaturday,
                repeatSunday: recurrenceOption.repeatSunday,
                recurrenceDay: recurrenceOption.recurrenceDay,
                recurrenceNthDayOfWeek: recurrenceOption.recurrenceNthDayOfWeek,
                recurrenceDayOfWeek: recurrenceOption.recurrenceDayOfWeek,
                recurrenceMonth: recurrenceOption.recurrenceMonth,
                startDate: startDate,
                startTime: startTime,
                endDate: endDate,
                endTime: endTime,
                dealerRecurrenceRuleId: null,
                dealerConstraintDefinitionId: constraintDefinitionType,
                isDeleted: false
            };
        }

        function constraintToString(constraint) {
            var format = 'EEE, MMM dd, yyyy',
                friendly = $filter('date')(constraint.startDate, format),
                startDate = constraint.startDate;

            if (constraint.endDate && constraint.startDate !== constraint.endDate) {
                friendly += ' to ' + $filter('date')(constraint.endDate, format);
            } else if (!constraint.repeatDaily) {
                if (typeof startDate === 'string') {
                    startDate = new Date(startDate);
                }
                friendly += ' ' + getRecurrenceText(constraint, startDate);
            }

            if (!constraint.startTime) {
                friendly += ' ALL DAY';
            } else {
                friendly += ' ' + timeUtilService.toTimeFormat(constraint.startTime);
            }

            if (constraint.endTime) {
                friendly += ' to ' + timeUtilService.toTimeFormat(constraint.endTime);
            }

            return friendly;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.location')
        .factory('consolidatedTasksMappingService', consolidatedTasksMappingService);

    function consolidatedTasksMappingService() {

        var textBlocks = {
            1: 'Scan the loaner VIN, document the mileage and fuel level, photograph the vehicle exterior, and document any issues.',
            2: 'Document the loaner mileage and fuel level, photograph the vehicle exterior, document any issues, and verify the customer’s driver’s license.',
            3: 'Scan the customer vehicle VIN, document the mileage and fuel level, photograph the vehicle exterior, and document any issues.',
            4: 'Document the customer vehicle mileage and fuel level, photograph the vehicle exterior, and document any issues.',
            5: 'Document the loaner mileage and fuel level, photograph the vehicle exterior, and document any issues.'
        };

        var mapping = {
            1: { //Pickup no Loaner (Customer First)
                4: [
                    {
                        text: textBlocks[3],
                        type: 'customer',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                6: [
                    {
                        text: textBlocks[4],
                        type: 'customer',
                        task: true,
                        vin: false,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ]
            },
            2: { //Pickup with Loaner
                12: [
                    {
                        text: textBlocks[1],
                        type: 'loaner',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                14: [
                    {
                        text: textBlocks[2],
                        type: 'loaner',
                        task: true,
                        vin: false,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: true
                    },
                    {
                        text: textBlocks[3],
                        type: 'customer',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                16: [
                    {
                        text: textBlocks[4],
                        type: 'customer',
                        task: true,
                        vin: false,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ]

            },
            3: { //Dropoff no Loaner
                26: [
                    {
                        text: textBlocks[3],
                        type: 'customer',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                28: [
                    {
                        text: textBlocks[4],
                        type: 'customer',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ]
            },
            4: { //Dropoff with Loaner
                36: [
                    {
                        text: textBlocks[3],
                        type: 'customer',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                38: [
                    {
                        text: textBlocks[1],
                        type: 'loaner',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }, {
                        text: textBlocks[4],
                        type: 'customer',
                        task: true,
                        vin: false,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                40: [
                    {
                        text: textBlocks[5],
                        type: 'loaner',
                        task: true,
                        vin: false,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ]
            },
            10: { //Pickup no Loaner (Dealer First)
                113: [
                    {
                        text: textBlocks[3],
                        type: 'customer',
                        task: true,
                        vin: true,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ],
                115: [
                    {
                        text: textBlocks[4],
                        type: 'customer',
                        task: true,
                        vin: false,
                        mileage: true,
                        fuel: true,
                        extPhotos: true,
                        issues: true,
                        dlverify: false
                    }
                ]
            }
        };

        function getMappingByWorkflow(workflowId) {
            return mapping[workflowId];
        }

        
        return {
            getMapping: mapping,
            getMappingByWorkflow: getMappingByWorkflow
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('selectionTaskValidation', selectionTaskValidation);

    function selectionTaskValidation() {
        function validate(value) {
            if (!value || !value.length) return false;

            var count = value.filter(function(item) {
                return !item.disabled;
            }).length;
            return count > 1;
        }
        
        return {
            require: 'ngModel',
            link: function (scope, elem, attr, ngModel) {
                scope.$parent.$watchCollection('task.items', function(newVal, oldVal) {
                    ngModel.$setValidity('count', validate(newVal));
                });
            }
        };
    }

})();

(function () {
    'use strict';

    VenueMappingsController.$inject = ["$transition$", "$state", "$location", "permissions", "SYSTEM_ENUMS", "locationService", "localStorageService"];
    angular
        .module('redcap.location')
        .controller('VenueMappingsController', VenueMappingsController);

    function VenueMappingsController($transition$, $state, $location, permissions, SYSTEM_ENUMS, locationService, localStorageService ) {
        var vm = this,
            referrer,
            params,
            configId,
            supportedTripTypes = [SYSTEM_ENUMS.systemTripType.lyftShuttleService,SYSTEM_ENUMS.systemTripType.partsOnDemand ];

        vm.isAdmin = permissions.isSysAdmin() || permissions.isDeveloper() || permissions.isRedCapAdmin();

        vm.selectedDealerChanged = function() {
            getVenueMappings();
        };

        vm.setVenueForTripType = function(dealerTripTypeId, dealerLocation) {           
            vm.currentTripType = _.find(dealerLocation.tripTypes, function(tt) {
                return tt.dealerTripTypeId === dealerTripTypeId;
            });

            // If the selected trip type already has a venue, initialize the map component with that location, otherwise
            //  use the dealers primary location
            vm.currentDealer = vm.currentTripType && vm.currentTripType.venue ? vm.currentTripType.venue : dealerLocation;
            vm.currentDealer.dealerName = dealerLocation.dealerName;
            vm.currentDealer.dealerId = dealerLocation.dealerId;

            vm.existingVenues = dealerLocation.tripTypes.filter(function(tt) {
                return !!tt.venue;
            }).map(function(tt) {
                var result = _.cloneDeep(tt.venue);
                result.id = tt.id,
                result.name = tt.tripTypeName;
                
                return result;
            });
        };

        vm.saveVenue = function(venue) {
            venue.countryShortCode = venue.countryShortCode || 'USA';
            return locationService.saveVenue(vm.currentTripType.dealerTripTypeId, venue).then(function(result) {
                // Update the venue in the main dealerVenues collection so it's retained within the view.
                var selectedDealer = _.find(vm.dealerVenues, function(d) {
                    return d.dealerId === vm.currentDealer.dealerId;
                });

                var selectedTripType = _.find(selectedDealer.tripTypes, function(tt) {
                    return tt.dealerTripTypeId === vm.currentTripType.dealerTripTypeId;
                });

                selectedTripType.venue = selectedTripType.venue || {};
                _.extend(selectedTripType.venue, venue);
                vm.currentDealer = null;
                vm.currentTripType = null;
            });
        };

        vm.cancelVenueSetting = function() {
            vm.currentDealer = null;
            vm.currentTripType = null;
        };

        init();

        function getVenueMappings() {
            locationService.getVenueMappings(vm.selectedDealerId).then(function(mappings) {
                vm.dealerVenues = _.filter(mappings, function(mapping) {
                    mapping.tripTypes = _.filter(mapping.tripTypes, function(tt) {
                        return supportedTripTypes.includes(tt.id);
                    });

                    return mapping.tripTypes.length > 0;
                });
            });
        }

        function init() {
            if (vm.isAdmin) {
                vm.loadingDealers = true;
                locationService.getLocations({ hasTripTypes: supportedTripTypes, pageSize: 99999 }).then(function(dealers) {
                    vm.dealers = dealers;
                    vm.loadingDealers = false;
                });
            } else {
                getVenueMappings();
            }

            initReferrer();
        }

        function initReferrer() {
            params = localStorageService.get('lastVenueMappingsParams');
            if ($transition$.params().referrer) {
                localStorageService.set('lastVenueMappingsReferrer', $transition$.params().referrer);
                referrer = $transition$.params().referrer;
            } else {
                referrer = localStorageService.get('lastVenueMappingsReferrer');
            }
    
            if ($transition$.params().configId) {
                configId = $transition$.params().configId;
            }    
        }

        vm.close = function () {
            var path = $location.path();
            if (path.indexOf('/locations') > -1) {
                $state.go('location-list', { configId: configId });
            } else {
                $state.go(referrer, params, {reload: false});
            }
        };        
    }
})();

(function () {
    'use strict';

    UberServiceabilityController.$inject = ["$transition$", "$uibModalInstance", "$state", "$location", "locationService", "localStorageService"];
    angular
        .module('redcap.location')
        .controller('UberServiceabilityController', UberServiceabilityController);

    function UberServiceabilityController($transition$, $uibModalInstance, $state, $location, locationService, localStorageService) {
        let vm = this;
        let configId = null;
        let referrer = null;
        let params = null;

        initReferrer();

        function initReferrer() {
            params = localStorageService.get('lastUberServiceParams');

            if ($transition$.params().referrer) {
                localStorageService.set('lastUberServiceReferrer', $transition$.params().referrer);
                referrer = $transition$.params().referrer;
            } else {
                referrer = localStorageService.get('lastUberServiceReferrer');
            }
    
            if ($transition$.params().configId) {
                configId = $transition$.params().configId;
            }    
        }

        vm.placeUpdated = function (address) {
            if (address && address.location.formattedAddress) {
                locationService.getUberServiceability({address: address.location.formattedAddress}).then((results) => {
                    vm.results = results;
                    vm.error = null;
                }).catch((error) => {
                    vm.results = null;
                    vm.error = 'Error fetching Uber serviceability: ' + error.message;
                });
            }
        };

        vm.close = function () {
            let path = $location.path();

            if (path.indexOf('/locations') > -1) {
                $state.go('location-list', {configId: configId});
            } else {
                $state.go(referrer, params, {reload: false});
            }
        };
    }
})();

(function () {
    'use strict';

    LocationTabUsersController.$inject = ["dealerHasCheckin", "resolvedDealerTripTypes", "resolvedLocation", "$state", "userService", "resolvedDealerEmployees", "eventAlertService", "modalService", "rcUtilService", "permissions", "locationService"];
    angular
        .module('redcap.location')
        .controller('LocationTabUsersController', LocationTabUsersController);

    function LocationTabUsersController(dealerHasCheckin, resolvedDealerTripTypes, resolvedLocation, $state, userService, resolvedDealerEmployees, eventAlertService, modalService, rcUtilService, permissions, locationService) {

        let vm = this;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;

        vm.dealerEmployees = resolvedDealerEmployees;
        vm.isAdmin = permissions.isSysAdminOrRedCapAdmin();

        vm.submitDisabled = function () {
            return _.filter(vm.dealerEmployees, 'sendWelcomeEmail').length < 1;
        };

        vm.sendWelcomeEmails = function () {
            let userIdList = _.filter(vm.dealerEmployees, 'sendWelcomeEmail').map((user) => { return user.id; });

            userService.sendWelcomeEmails(userIdList)
                .then((result) => {
                    eventAlertService.createAlert('Enrollment emails successfully sent.');
                });
        };
        
        vm.moveActiveUsers = () => {
            const getActiveAccounts = () => vm.dealerEmployees.filter((employee) => employee.isActive === true);
            const moveAccounts = (accountIds, newLocationId, currentLocationId) => userService.moveUsersBetweenDealers(accountIds, newLocationId, currentLocationId);
            
            rcUtilService.moveAccountsBetweenDealers(modalService, getActiveAccounts, moveAccounts, vm.currentLocation.id, $state, 'tab-users', 'User', locationService);
        };
    }    
})();

(function() {
    'use strict';

    LocationTabUserPermissionsController.$inject = ["SYSTEM_ENUMS", "dealerHasCheckin", "resolvedDealerTripTypes", "resolvedLocation", "permissions", "eventAlertService", "dealerId", "locationService"];
    angular
        .module('redcap.location')
        .controller('LocationTabUserPermissionsController', LocationTabUserPermissionsController);

    function LocationTabUserPermissionsController(SYSTEM_ENUMS, dealerHasCheckin, resolvedDealerTripTypes, resolvedLocation, permissions, eventAlertService, dealerId, locationService) {

        let vm = this;
		let defunctRoles = SYSTEM_ENUMS.hiddenRoles;

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;

        vm.submitDisabled = function() {
            return vm.isLoading;
        };
        
        
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.showOnlyDealerProducts = vm.isOnlyDealerAdmin; // if they're just a dealer admin, only show dealer products
        
        vm.getPermissions = function() {
            vm.isLoading = true;
            locationService.getEmployeePermissions(dealerId, vm.showOnlyDealerProducts)
                .then((result) => {
                    vm.dealerEmployees = result.users;
                    vm.features = result.features;

                    _.forEach(vm.features, (role) => {
                        if (defunctRoles.includes(role.name.toLowerCase())) {
                            role.isHidden = true;
                        } else {
                            role.isHidden = false;
                        }
            
                    });
                })
                .finally(() => {
                    vm.isLoading = false;
                });
        };

        vm.saveChanges = function() {
            vm.isSaving = true;
            locationService.saveEmployeePermissions(dealerId, {users: vm.dealerEmployees})
                .then((result) => {
                    
                })
                .finally(() => {
                    eventAlertService.createAlert('Changes successfully saved.');
                    vm.isSaving = false;
                });
        };

        vm.getPermissions();
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.location')
        .controller('LocationTabUIController', LocationTabUIController);

    function LocationTabUIController() {
        var vm = this;
    }
})();

(function () {

    'use strict';

    LocationTabTasksController.$inject = ["$scope", "$log", "$transition$", "tripTypeService", "resolvedLocation", "resolvedDealerTripTypes", "dealerHasCheckin", "resolvedWorkFlows", "resolvedTaskTypes", "resolvedVehicleTypes", "resolvedLocationsWithTripType", "eventAlertService", "modalService", "ValidationService", "SYSTEM_ENUMS", "consolidatedTasksMappingService", "rcUtilService"];
    angular
        .module('redcap.location')
        .controller('LocationTabTasksController', LocationTabTasksController);

    function LocationTabTasksController($scope, $log, $transition$, tripTypeService, resolvedLocation, resolvedDealerTripTypes, dealerHasCheckin, resolvedWorkFlows, resolvedTaskTypes, resolvedVehicleTypes, resolvedLocationsWithTripType, eventAlertService, 
            modalService, ValidationService, SYSTEM_ENUMS, consolidatedTasksMappingService, rcUtilService) {
        let vm = this;
        let locationId = $transition$.params().locationId;
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.needsConsolidatedTasks = false;
        vm.validationCnt = 0;
        vm.location = resolvedLocation;
        vm.taskTypes = resolvedTaskTypes;
        vm.vehicleTypes = resolvedVehicleTypes;
        vm.workflowTaskTypes = SYSTEM_ENUMS.workflowTaskTypes;
        vm.locationsWithTripType = _.filter(resolvedLocationsWithTripType, (location) => {
            return location.id !== _.toInteger(locationId);  // filter out current location
        });
        vm.copyAllWorkflows = false;

        vm.getWorkFlowNavs = function (workflowId) {
            vm.currentWorkFlowId = workflowId;
            vm.needsConsolidatedTasks = false;
            tripTypeService.getLocationTripWorkFlowTasks(locationId, workflowId).then((result) => {
                // set the initial 'switched off' ui flag
                for (let idx = result.length - 1; idx >= 0; idx--) {
                    let currTasks = result[idx].tasks;

                    for (let idx2 = currTasks.length - 1; idx2 >= 0; idx2--) {
                        currTasks[idx2].switchedOn = currTasks[idx2].message;
                    }
                }

                vm.resolvedWorkFlowTasks = result;
                vm.needsConsolidatedTasks = consolidatedTasksMappingService.getMappingByWorkflow(vm.currentWorkFlowId);
            });
        };

        vm.setWorkFlow = function (workFlowId) {
            vm.validationCnt++;
            vm.resolvedWorkFlowTasks = null;
            vm.getWorkFlowNavs(workFlowId);
        };

        vm.getSwitchId = function (task) {
            return 'switch-' + task.questionId;
        };

        vm.addNewTask = function(workFlowId) {
            let workFlowTaskCount = this.resolvedWorkFlowTasks.length;
            let newTask = {
                defaultMessage: "",
                heading: "",
                message: "",
                id: 0,
                sortOrder: workFlowTaskCount,
                taskType: 1,
                switchedOn: true
            };

            for (let i = 0; i < this.resolvedWorkFlowTasks.length; ++i) {
                let workflow = this.resolvedWorkFlowTasks[i];
                
                if (workflow.id === workFlowId) {
                    workflow.tasks.push(newTask);
                    workflow.tripTypeId = $transition$.params().tripTypeId;
                }
            }
        };

        vm.updateTasks = function () {
            let myValidation = new ValidationService();

            if (!myValidation.checkFormValidity($scope.inputForm)) {
                return false;
            }

            let navs = vm.resolvedWorkFlowTasks;

            for (let idx = navs.length - 1; idx >= 0; idx--) {
                let currTasks = navs[idx].tasks;

                navs[idx].tripTypeId = $transition$.params().tripTypeId;

                for (let idx2 = currTasks.length - 1; idx2 >= 0; idx2--) {
                    let task = currTasks[idx2];
                    
                    if (!task.switchedOn) {
                        task.message = '';
                    } else if (task.switchedOn && !task.message) {
                        task.message = null;
                    } else if (task.switchedOn && (!task.message || task.message == '')) {
                        task.message = ' ';
                    }
                    
                }
            }

            vm.tasksUpdating = true;
            tripTypeService.updateLocationTripWorkFlowTasks(locationId, navs).then((response) => {
                let eventAlertMessage;

                vm.tasksUpdating = false;

                if (response) {
                    if (typeof response.isValid !== 'undefined' && !response.isValid) {
                        eventAlertMessage = response.message;
                        $log.error('location tasks:' + eventAlertMessage);
                    } else {
                        $log.info('success: location Trip Type Work Flow Tasks updated');
                        eventAlertMessage = 'Trip Work Flow Tasks Successfully Updated.';
                    }
                }

                eventAlertService.createAlert(eventAlertMessage);

                // refresh the view to make sure that we grab the latest version of tasks that now have IDs associated with them
                this.setWorkFlow(vm.currentWorkFlowId);
            });

            $log.info('submit: responses', navs);
        };

        vm.useDefaultMessage = function(task) {
            let confirmed = confirm("Are you sure you want to use the default text of: \r" + task.defaultMessage);

            if (confirmed) {
                task.message = task.defaultMessage;
            }
        };

        vm.onTaskTypeChanged = function(task) {
            if (task.taskType === vm.workflowTaskTypes.customerVehicleTasksMulti) {
                task.includesVinScan = true;
            }

            if (vm.isVehicleTask(task)) {
                let type = _.find(vm.taskTypes, (taskType) => {
                    return taskType.value === task.taskType;
                });

                task.heading = type.text;
            }
        };

        vm.isVehicleTask = function(task) {
            return task.taskType === vm.workflowTaskTypes.customerVehicleTasks
                || task.taskType === vm.workflowTaskTypes.loanerVehicleTasks
                || task.taskType === vm.workflowTaskTypes.otherVehicleTasks;
        };

        vm.copyTasks = function () {
            let confirmMessage = vm.copyAllWorkflows ? 'This action will replace all tasks for all trip type instances that match the selected location.  This cannot be undone.<br /><br />Are you sure?'
                : 'This action will replace all tasks below with tasks from the selected location.  This cannot be undone.<br /><br />Are you sure?';

            if (vm.selectedLocation) {
                modalService.showYesNo('Please Confirm', confirmMessage, 'No', 'Yes', true).then((confirmed) => {
                    if (confirmed) {
                        vm.tasksUpdating = true;
                        tripTypeService.copyWorkflowTasks(vm.selectedLocation, locationId, vm.currentWorkFlowId, vm.copyAllWorkflows).then((result) => {
                            vm.tasksUpdating = false;
                            modalService.showCopyDriverTasksResults(result);
                            vm.getWorkFlowNavs(vm.currentWorkFlowId);
                        }).catch((err) => {
                            vm.tasksUpdating = false;
                            modalService.showError('An error occurred that prevented tasks from being copied: ', err);
                        });
                    }
                });
            }
        };

        vm.resolvedWorkFlows = resolvedWorkFlows;

        if (vm.resolvedWorkFlows && vm.resolvedWorkFlows.length > 0) {
            // by default we select the first one so get the tasks associated with it
            vm.getWorkFlowNavs(vm.resolvedWorkFlows[0].id);
        }
        
        vm.getWorkflowDisplayName = rcUtilService.getWorkflowDisplayName;

        vm.insertConsolidatedTask = function(workflowTasks, insertIndex, taskToInsert) {
            let taskTypeId = taskToInsert.type === 'customer'
                ? SYSTEM_ENUMS.workflowTaskTypes.customerVehicleTasks
                : SYSTEM_ENUMS.workflowTaskTypes.loanerVehicleTasks;

            let heading = taskToInsert.type === 'customer'
                ? 'Customer Vehicle Tasks'
                : 'Loaner Vehicle Tasks';

            for (let i = insertIndex; i < workflowTasks.length; i++) {
                workflowTasks[i].sortOrder = i + 1;
            }

            let newTask = {
                defaultMessage: taskToInsert.text,
                heading: heading,
                message: taskToInsert.text,
                id: 0,
                sortOrder: insertIndex,
                taskType: taskTypeId,
                switchedOn: false,
                includesVinScan: taskToInsert.vin,
                includesMileage: taskToInsert.mileage,
                includesFuelLevel: taskToInsert.fuel,
                includesVehicleExterior: taskToInsert.extPhotos,
                includesDamageIssues: taskToInsert.issues,
                includesDriversLicense: taskToInsert.dlverify
            };

            workflowTasks.splice(insertIndex + 1, 0, newTask);
        };

        vm.addConsolidatedTasks = function() {
            let mapping = consolidatedTasksMappingService.getMappingByWorkflow(vm.currentWorkFlowId);

            if (!mapping) return;

            let workflowSteps = vm.resolvedWorkFlowTasks || [];

            for (let i = 0; i < workflowSteps.length; i++) {
                let workflowStep = workflowSteps[i];
                let mappedStep = mapping[workflowStep.id];

                if (!mappedStep) continue;

                let tasks = workflowStep.tasks || [];

                if (tasks.length === 0) continue;

                let taskInsertIndex = -1;
                let hasLoanerTask = false;
                let hasCustomerTask = false;

                for (let j = 0; j < tasks.length; j++) {
                    if (hasLoanerTask && hasCustomerTask) break;
                    let task = tasks[j];

                    switch (task.taskType) {
                    case SYSTEM_ENUMS.workflowTaskTypes.loanerVehicleTasks:
                        hasLoanerTask = true;
                        break;
                    case SYSTEM_ENUMS.workflowTaskTypes.customerVehicleTasks:
                        hasCustomerTask = true;
                        break;
                    case SYSTEM_ENUMS.workflowTaskTypes.photo:
                        taskInsertIndex = j;
                        break;
                    }
                }


                if (taskInsertIndex === -1) taskInsertIndex = tasks.length + 1;

                //this will insert records based on the ordering specified in the mapping
                for (let k = 0; k < mappedStep.length; k++) {
                    if (mappedStep[k].type === 'loaner') {
                        if (!hasLoanerTask) {
                            vm.insertConsolidatedTask(tasks, taskInsertIndex, mappedStep[k]);
                            taskInsertIndex++;
                            hasLoanerTask = true;
                        }
                    }

                    if (mappedStep[k].type === 'customer') {
                        if (!hasCustomerTask) {
                            vm.insertConsolidatedTask(tasks, taskInsertIndex, mappedStep[k]);
                            taskInsertIndex++;
                            hasCustomerTask = true;
                        }
                    }
                }
            }
        };
    }
})();

(function () {

    'use strict';

    LocationTabSurveyController.$inject = ["$log", "dealerHasCheckin", "resolvedLocation", "resolvedDealerTripTypes", "tripTypeService", "resolvedSurveys", "resolvedTripType", "eventAlertService", "resolvedEmployees"];
    angular
        .module('redcap.location')
        .controller('LocationTabSurveyController', LocationTabSurveyController);

    function LocationTabSurveyController($log, dealerHasCheckin, resolvedLocation, resolvedDealerTripTypes, tripTypeService, resolvedSurveys, resolvedTripType, eventAlertService, resolvedEmployees) {
        let vm = this;
        let idx = 0;
        let currSurvey = null;
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.customerSurveys = [{id: 0, name: 'None'}];
        vm.driverSurveys = [{id: 0, name: 'None'}];

        for (idx = resolvedSurveys.length - 1; idx >= 0; idx--) {
            currSurvey = resolvedSurveys[idx];
            currSurvey.type === 0 ? vm.customerSurveys.push(currSurvey) : vm.driverSurveys.push(currSurvey);
        }

        vm.selectedSurveyQuestions = [];
        vm.selectedDriverSurveyQuestions = [];

        vm.currentTripType = resolvedTripType;
        vm.commonConfigs = vm.currentTripType.tripTypeCommonConfigs;
        vm.resolvedEmployees = resolvedEmployees;

        if (vm.commonConfigs.BulkSurveyCCRecipientList && vm.commonConfigs.BulkSurveyCCRecipientList.value) {
            let filteredResults = _.filter(vm.resolvedEmployees, (e) => {
                return _.includes(vm.commonConfigs.BulkSurveyCCRecipientList.value.split(','), e.id.toString());
            });

            if (filteredResults) {
                vm.BulkEmailSurveyListMap = filteredResults.map((value) => { return value.id; });
            }
        }

        function validId(id) {
            if (id === undefined || id.value === null || id.value === '0') {
                return false;
            }

            return true;
        }


        vm.getSurveyQuestions = function () {
            if (!validId(vm.commonConfigs.SurveyId)) {
                vm.selectedSurveyQuestions = [];

                return;
            }

            tripTypeService.getSurveyQuestions(vm.commonConfigs.SurveyId.value)
                .then((result) => {
                    $log.debug('result', result);

                    if (result.length < 1) {
                        vm.selectedSurveyQuestions = [];
                        vm.selectedSurveyQuestions.push({questionTypeId: -1, question: 'There are no questions for this survey.'});
                    } else {
                        vm.selectedSurveyQuestions = result;
                    }
                });

        };

        vm.getDriverSurveyQuestions = function () {
            if (!validId(vm.commonConfigs.DriverSurveyId)) {
                vm.selectedDriverSurveyQuestions = [];
                
                return;
            }

            tripTypeService.getSurveyQuestions(vm.commonConfigs.DriverSurveyId.value)
                .then((result) => {
                    $log.debug('result', result);

                    if (result.length < 1) {
                        vm.selectedDriverSurveyQuestions = [];
                        vm.selectedDriverSurveyQuestions.push({questionTypeId: -1, question: 'There are no questions for this survey.'});
                    } else {
                        vm.selectedDriverSurveyQuestions = result;
                    }
                });

        };

        vm.updateSurveyId = function () {
            if (vm.BulkEmailSurveyListMap) {
                vm.commonConfigs.BulkSurveyCCRecipientList.value = vm.BulkEmailSurveyListMap.join();
            } else {
                // No one selected, "Clean" list
                vm.commonConfigs.BulkSurveyCCRecipientList.value = '';
            }

            tripTypeService.updateTripType(vm.currentTripType)
                .then((response) => {
                    if (response === true) {
                        eventAlertService.createAlert('Survey Type successfully updated.');
                    }
                }
                );
        };

        // select from inital trip config survey id
        vm.getSurveyQuestions();
        vm.getDriverSurveyQuestions();

        vm.validation = {
            acceptableSurveys: _.map(vm.surveys, 'id').join()
        };
    }

})();

(function () {
    'use strict';

    LocationTabNotificationsController.$inject = ["$scope", "$transition$", "tripTypeService", "resolvedTripType", "resolvedTripProfiles", "resolvedNotifications", "resolvedInviteNotificationTemplates", "resolvedWorkFlows", "resolvedEmployees", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "eventAlertService", "modalService", "permissions", "SYSTEM_ENUMS", "rcUtilService"];
    let app = angular.module('redcap.location');

    app.controller('LocationTabNotificationsController', LocationTabNotificationsController);

    app.filter('propsFilter', () => {
        return function (items, props) {
            let out = [];

            if (angular.isArray(items)) {
                items.forEach((item) => {
                    let itemMatches = false;
                    let keys = Object.keys(props);

                    for (let i = 0; i < keys.length; i++) {
                        let prop = keys[i];
                        let text = props[prop].toLowerCase();

                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    });

    function LocationTabNotificationsController($scope, $transition$, tripTypeService, resolvedTripType, resolvedTripProfiles, resolvedNotifications,
        resolvedInviteNotificationTemplates, resolvedWorkFlows, resolvedEmployees, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, eventAlertService, modalService, permissions, SYSTEM_ENUMS, rcUtilService) {
        
        let vm = this;
        let maxInviteHours = 36;
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        

        vm.currentTripType = resolvedTripType;
        vm.commonConfigs = vm.currentTripType.tripTypeCommonConfigs;
        vm.specificConfigs = resolvedTripType.tripTypeSpecificConfigs;
        vm.tripProfiles = resolvedTripProfiles;
        vm.resolvedNotifications = resolvedNotifications;
        vm.resolvedInviteNotificationTemplates = resolvedInviteNotificationTemplates;
        vm.resolvedWorkFlows = resolvedWorkFlows;
        vm.resolvedEmployees = resolvedEmployees;
        vm.resolvedLocation = resolvedLocation;
        vm.isDeveloper = permissions.isDeveloper();
        vm.showWebhooks = resolvedTripType.systemTripTypeId !== SYSTEM_ENUMS.systemTripType.appointment;
        vm.inviteHours = [];
        vm.uberEnabled = false;
        const uberProviders = [SYSTEM_ENUMS.rideProviderType.uberDirect, SYSTEM_ENUMS.rideProviderType.uber];
        const systemTripTypesToCheck = [SYSTEM_ENUMS.systemTripType.lyftRoadSideAssistance, SYSTEM_ENUMS.systemTripType.lyftShuttleService];

        vm.webhookTypeChanged = function () {
            if (vm.webhookAuthenticationType === 'None') {
                vm.currentTripType.tripTypeCommonConfigs.OAuthUrl ? vm.currentTripType.tripTypeCommonConfigs.OAuthUrl.value = '' : vm.currentTripType.tripTypeCommonConfigs.OAuthUrl = {value: ''};
                vm.currentTripType.tripTypeCommonConfigs.WebhookUsername ? vm.currentTripType.tripTypeCommonConfigs.WebhookUsername.value = '' : vm.currentTripType.tripTypeCommonConfigs.WebhookUsername = {value: ''};
                vm.currentTripType.tripTypeCommonConfigs.WebhookPassword ? vm.currentTripType.tripTypeCommonConfigs.WebhookPassword.value = '' : vm.currentTripType.tripTypeCommonConfigs.WebhookPassword = {value: ''};
                vm.currentTripType.tripTypeCommonConfigs.WebhookScope ? vm.currentTripType.tripTypeCommonConfigs.WebhookScope.value = '' : vm.currentTripType.tripTypeCommonConfigs.WebhookScope = {value: ''};
            } else if (vm.webhookAuthenticationType === 'Basic') {
                vm.currentTripType.tripTypeCommonConfigs.OAuthUrl ? vm.currentTripType.tripTypeCommonConfigs.OAuthUrl.value = '' : vm.currentTripType.tripTypeCommonConfigs.OAuthUrl = {value: ''};
                vm.currentTripType.tripTypeCommonConfigs.WebhookScope ? vm.currentTripType.tripTypeCommonConfigs.WebhookScope.value = '' : vm.currentTripType.tripTypeCommonConfigs.WebhookScope = {value: ''};
            }
        };

        vm.updateNotificationTemplate = function (template) {
            tripTypeService.updateNotificationTemplate($transition$.params().locationId, template).then((response) => {
                if (response === true) {
                    $scope.savedTemplateCnt++;

                    if ($scope.savedTemplateCnt === $scope.dirtyTemplateCnt) {
                        $scope.savedTemplateCnt = 0;
                        $scope.dirtyTemplateCnt = 0;
                        eventAlertService.createAlert('Notification data successfully updated.');
                        vm.getTripWorkflowNotificationTemplateGroups(vm.currentWorkFlowId);
                    }
                } else {
                    eventAlertService.createAlert('There was an error saving your notifications updates.');
                }
            });
        };

        vm.saveAllChanges = function () {
            $scope.dirtyTemplateCnt = 0;
            $scope.savedTemplateCnt = 0;
            _.forEach(vm.resolvedInviteNotificationTemplates, (template) => {
                if (template.isDirty) {
                    $scope.dirtyTemplateCnt++;
                    vm.updateNotificationTemplate(template);
                }
            });

            _.forEach(vm.resolvedTripWorkflowNotificationTemplateGroups, (templateGroup) => {
                _.forEach(templateGroup.notificationTemplateViewModels, (template) => {
                    if (template.isDirty) {
                        $scope.dirtyTemplateCnt++;
                        vm.updateNotificationTemplate(template);
                    }
                });
            });

            // Webhooks
            if (vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.isDirty ||
                vm.currentTripType.tripTypeCommonConfigs.WebhookUrl.isDirty ||
                vm.currentTripType.tripTypeCommonConfigs.WebhookUsername.isDirty ||
                vm.currentTripType.tripTypeCommonConfigs.WebhookPassword.isDirty ||
                vm.currentTripType.tripTypeCommonConfigs.SendCustomerSMSViaWebhooks.isDirty) {
                tripTypeService.updateTripType(vm.currentTripType).then((response) => {
                    if (response === true) {
                        eventAlertService.createAlert('Webhook successfully updated.');
                    } else {
                        eventAlertService.createAlert('There was an error saving webhook updates.');
                    }
                });
            }

            // Update the bulk cc list for notifications
            if (vm.BulkEmailNotificationListMap) {
                vm.commonConfigs.BulkNotificationCCRecipientList.value = vm.BulkEmailNotificationListMap.join();
            } else {
                // No one selected, "Clean" list
                vm.commonConfigs.BulkNotificationCCRecipientList.value = '';
            }

            tripTypeService.updateTripType(vm.currentTripType)
                .then((response) => {
                    if (response === true) {
                        eventAlertService.createAlert('Notifications CC list successfully updated.');
                    }
                });
        };

        vm.updateClicked = function () {
            if (vm.resolvedLocation.isCopyable) {
                let confirm = modalService.showYesNo('Warning!', 'This is a Program Level Dealer. Changes to notifications on this dealer will apply to all dealers in the same program. Are you sure you want to do this?', 'No', 'Yes');

                confirm.then((isConfirmed) => {
                    if (isConfirmed) {
                        vm.saveAllChanges();
                    }
                });
            } else {
                vm.saveAllChanges();
            }
        };


        vm.resetTemplateToDefault = function (template) {
            modalService.showYesNo('Are you sure?', 'Are you sure you want to reset this template to the default value?', 'No', 'Yes')
                .then((shouldReset) => {
                    if (shouldReset) {
                        tripTypeService.resetNotificationTemplate($transition$.params().locationId, template).then((response) => {
                            if (response === true) {
                                eventAlertService.createAlert('Notification template successfully reset.');
                                vm.getTripWorkflowNotificationTemplateGroups(vm.currentWorkFlowId);
                            }
                        });
                    }
                });
        };

        vm.getTripWorkflowNotificationTemplateGroups = function (workFlowId) {
            vm.loadingTripWorkflowTemplates = true;
            vm.currentWorkFlowId = workFlowId;
            vm.resolvedTripWorkflowNotificationTemplateGroups = null;
            tripTypeService.getTripWorkflowNotificationTemplateGroups($transition$.params().locationId, workFlowId)
                .then((result) => {
                    vm.resolvedTripWorkflowNotificationTemplateGroups = result;
                })
                .finally(() => {
                    vm.loadingTripWorkflowTemplates = false;
                });
        };

        vm.setWorkFlow = function (workFlowId) {
            vm.getTripWorkflowNotificationTemplateGroups(workFlowId);
        };


        vm.validation = {
            acceptableTripProfiles: _.map(vm.tripProfiles, 'sdProfileId').join(),
            acceptableMinutes: _.map(vm.inviteHours, (hours) => { return hours * 60; }).join()
        };

        vm.hasNotifications = function () {
            if ((!vm.resolvedInviteNotificationTemplates || vm.resolvedInviteNotificationTemplates.length === 0) && (!vm.resolvedTripWorkflowNotificationTemplateGroups || vm.resolvedTripWorkflowNotificationTemplateGroups.every(group => group.notificationTemplateViewModels.length === 0))) {
                return false;                
            }

            return true;
        };
        
        vm.getWorkflowDisplayName = rcUtilService.getWorkflowDisplayName;

        function init () {
            if (uberProviders.includes(vm.currentTripType.rideProvider) && systemTripTypesToCheck.includes(vm.currentTripType.systemTripTypeId)) {
                vm.uberEnabled = true;
            }
    
            $scope.dealer = {};
            $scope.dealer.selectedEmployees = [];
    
            for (let hours = 0; hours < maxInviteHours; hours++) {
                vm.inviteHours[hours] = hours;
            }
    
            if (vm.commonConfigs.BulkNotificationCCRecipientList && vm.commonConfigs.BulkNotificationCCRecipientList.value) {
                let filteredResults = _.filter(vm.resolvedEmployees, (e) => {
                    return _.includes(vm.commonConfigs.BulkNotificationCCRecipientList.value.split(','), e.id.toString());
                });
    
                if (filteredResults) {
                    vm.BulkEmailNotificationListMap = filteredResults.map((value) => { return value.id; });
                }
            }
    
            // Webhooks
            if (vm.currentTripType.tripTypeCommonConfigs.OAuthUrl && vm.currentTripType.tripTypeCommonConfigs.OAuthUrl.value) {
                vm.webhookAuthenticationType = 'OAuth';
            } else if (vm.currentTripType.tripTypeCommonConfigs.WebhookUsername && vm.currentTripType.tripTypeCommonConfigs.WebhookUsername.value &&
                vm.currentTripType.tripTypeCommonConfigs.WebhookPassword && vm.currentTripType.tripTypeCommonConfigs.WebhookPassword.value) {
                vm.webhookAuthenticationType = 'Basic';
            } else {
                vm.webhookAuthenticationType = 'None';
            }

            if (vm.specificConfigs && vm.specificConfigs.EnableToFromAnyLocation && !vm.specificConfigs.EnableToFromAnyLocation.value) {
                vm.resolvedWorkFlows = vm.resolvedWorkFlows.filter((e) => {
                    return e.id !== SYSTEM_ENUMS.tripWorkflowTypes.partsOnDemandToFromAny;
                });
            }
            
            if (vm.resolvedWorkFlows && vm.resolvedWorkFlows.length > 0) {
                vm.getTripWorkflowNotificationTemplateGroups(vm.resolvedWorkFlows[0].id);
            } 
    
            if (vm.resolvedLocation.isCopyable) {
                modalService.showYesNo('Warning!', 'This is a Program Level Dealer. Changes to notifications on this dealer will apply to all dealers in the same program.', null, 'Ok');
            }
        }

        init();

    }
})();

 (function () {

     'use strict';

     LocationTabNotesController.$inject = ["$log", "$transition$", "resolvedTripType", "tripTypeService", "resolvedResponses", "eventAlertService"];
     angular
         .module('redcap.location')
         .controller('LocationTabNotesController', LocationTabNotesController);

     function LocationTabNotesController($log, $transition$, resolvedTripType, tripTypeService, resolvedResponses, eventAlertService) {
         let vm = this;
         let locationId = $transition$.params().locationId;

         vm.currentTripType = resolvedTripType;

         vm.updateResponses = function (responses) {
             // validation text length
             responses.forEach((response) => {
                 if (response.response.length < 1)
                     response.response = ' ';
             });

             tripTypeService.updateTripTypeQuestionResponses(locationId, responses).then((response) => {
                 $log.info('success: location Trip Type Question Responses updated');
                 eventAlertService.createAlert('Trip Notes Successfully Updated.');
             });
             $log.info('submit: responses', responses);
         };

         if (locationId) {
             // execute data load for hours tab
             vm.responses = resolvedResponses;
         }
     }
  })();


(function () {
    'use strict';

    LocationTabLogosController.$inject = ["resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "locationLogos"];
    angular
        .module('redcap.location')
        .controller('LocationTabLogosController', LocationTabLogosController);

    function LocationTabLogosController(resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes, locationLogos) {
        let vm = this;
        
        vm.locationLogos = locationLogos;
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
    }
})();

(function () {
    'use strict';

    LocationTabLineItemsController.$inject = ["$transition$", "$q", "$timeout", "$scope", "$filter", "$location", "$state", "permissions", "localStorageService", "resolvedLocation", "dealerHasCheckin", "resolvedDealerTripTypes", "ValidationService", "rcUtilService", "appointmentUtilService", "modalService", "eventAlertService", "SYSTEM_ENUMS", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", "APPOINTMENT_PAYTYPES", "APPOINTMENT_RECALL_OPCODE_TYPE", "APPOINTMENT_SERVICE_SYSTEM_OPCODE_TYPE", "ctrlOptions", "resolvedTripType", "resolvedSystemOpCodes", "resolvedLocationOpCodes", "resolvedLocationOpCodeConstraints", "resolvedDepartments", "resolvedDMSData", "locationService", "constraintService", "appointmentServiceOpCodeClass", "resolvedDepartmentsWithAdvisors"];
    let app = angular.module('redcap.location');

    app.controller('LocationTabLineItemsController', LocationTabLineItemsController);

    function LocationTabLineItemsController($transition$, $q, $timeout, $scope, $filter, $location, $state, permissions, localStorageService, resolvedLocation, dealerHasCheckin, resolvedDealerTripTypes,
            ValidationService, rcUtilService, appointmentUtilService, modalService, eventAlertService, SYSTEM_ENUMS, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE, APPOINTMENT_PAYTYPES, APPOINTMENT_RECALL_OPCODE_TYPE, APPOINTMENT_SERVICE_SYSTEM_OPCODE_TYPE, ctrlOptions, resolvedTripType, 
            resolvedSystemOpCodes, resolvedLocationOpCodes, resolvedLocationOpCodeConstraints, resolvedDepartments, resolvedDMSData, locationService, constraintService, appointmentServiceOpCodeClass, resolvedDepartmentsWithAdvisors) {
        
        let vm = this;
        let _myValidation = new ValidationService({
                validateOnEmpty: true
            });
        let _pageSize = 25;
        let _referrer;
        let _params = localStorageService.get('lastManageOpCodesParams');
        let _revalidate = 'angularValidation.revalidate';
        
        if ($transition$.params().referrer) {
            localStorageService.set('lastManageOpCodesReferrer', $transition$.params().referrer);
            _referrer = $transition$.params().referrer;
        } else {
            _referrer = localStorageService.get('lastManageOpCodesReferrer');
        }

        vm.headerClicked = function ($event, formDisabled) {
            if (formDisabled) {
                $event.stopPropagation(); $event.preventDefault();
            }
        };

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.lineItemCounts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        vm.displayGenericOpCodes = true;
        vm.displayAutomaticOpCodes = true;
        vm.displayOtherOpCodes = true;
        vm.sortType = null;
        vm.sortAsc = null;
        vm.constraintDefinitionType = APPOINTMENT_CONSTRAINT_DEFINITION_TYPE;
        vm.constraints = resolvedLocationOpCodeConstraints;
        vm.systemTripType = SYSTEM_ENUMS.systemTripType;
        vm.configuredLocationOpCodes = resolvedLocationOpCodes;
        vm.locationDepartments = resolvedDepartments;
        vm.departmentsWithAdvisors = resolvedDepartmentsWithAdvisors;
        
        vm.recallOpCodeType = APPOINTMENT_RECALL_OPCODE_TYPE;
        vm.locationId = $transition$.params().locationId;
        vm.resolvedLocationList = null;
        vm.mergedOpCodeList = [];
        vm.deptConstraintsAreValid = false;
        vm.dispatchCodes = [];
        vm.loadingDispatchCodes = false;
        vm.select2Ready = true;
        vm.requireDispatchCode = resolvedDMSData.requireDispatchCode;
        vm.systemOpcodeType = APPOINTMENT_SERVICE_SYSTEM_OPCODE_TYPE;

        if (resolvedDMSData && resolvedDMSData.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.CDK) {
            vm.loadingDispatchCodes = true;
            locationService.lookupDispatchCodes(vm.locationId, resolvedDMSData).then((result) => {
                vm.dispatchCodes = result;
                vm.loadingDispatchCodes = false;
            });
        }

        if (!vm.locationId) {
            vm.loadingLocations = true;
            locationService.getLocationsForDropDown(true, false, SYSTEM_ENUMS.permissionTypes.appointments, [SYSTEM_ENUMS.systemTripType.appointment]).then((result) => {
                vm.resolvedLocationList = result;
                vm.loadingLocations = false;
            });
        } else {
            vm.selectedLocation = {
                id: vm.locationId
            };
        }

        vm.ctrlOptions = ctrlOptions;

        vm.sorting = {
            name: 'name',
            opCode: 'opCode',
            payType: 'payType',
            retailPrice: 'retailPrice',
            laborHours: 'laborHours',
            dispatchCode: 'dispatchCode',
            serviceType: 'serviceType',
            dashSortOrder: 'dashSortOrder',
            consumerSortOrder: 'consumerSortOrder'
        };

        vm.selectedLocationChanged = function () {
            if (!vm.selectedLocation) {
                return;
            }

            vm.locationId = vm.selectedLocation.id;
            vm.dmsSystem = vm.selectedLocation.dmsSystem;
            vm.initializingLocation = true;

            locationService.getLocationDepartments(vm.locationId, true).then((response) => {
                vm.departmentsWithAdvisors = response;
            });

            refreshLocationOpCodesAndConstraints(false);
            loadOptionalDropDowns();
        };

        // Utilizing jQuery to handle the tab through complexity
        $('body').on('focusout', '.line-item-mapping .panel-body .last-input', (event) => {
            // Some instances in the Generic Op Code panel cause focusout to be triggered twice, prevent that here
            event.stopImmediatePropagation();
            let parentPanel = $(this).parents('.panel-default');
            let remainingPanels = parentPanel.nextAll('.panel-default');

            if (remainingPanels.length === 0) {
                // This is the last panel in the group, check what panel we are on and select the next one
                if (parentPanel.hasClass('group-1')) {
                    remainingPanels = $('.group-2');
                } else if (parentPanel.hasClass('group-2')) {
                    remainingPanels = $('.group-3');
                }
            }

            // Only click if panel is not opened
            if (!remainingPanels.first().hasClass('panel-open')) {
                remainingPanels.first().find('a[data-toggle=collapse]').click();
            }

            $timeout(() => {
                vm.autoSave(vm.selectedDepartment?.id);
            }, 25);
        });

        vm.hasInvalidLineItems = function (overrideDepartment) {
            let deptToCheck = overrideDepartment || vm.departmentFilter;
            let invalidItems = vm.mergedOpCodeList.some((lineItem) => {
                    return !lineItem.isValid && (lineItem.dealerDepartmentId === deptToCheck || lineItem.isAutomatic);
            });
 
            return invalidItems;
        };

        vm.hasInvalidAutomaticLineItems = function () {
            let invalidItems = vm.mergedOpCodeList.some((lineItem) => {
                    return lineItem.isAutomatic &&
                            lineItem.isEnabled &&
                            lineItem.isDeleted === false &&
                            !vm.isLineItemValid(lineItem);
            });
 
            return invalidItems;
        };
        
        vm.isLineItemValid = function (lineItem) {
            let dmsSystem = vm.dmsSystem;
            let dmsEnum = vm.dmsEnum;
            let opCode = lineItem.opCode;

            lineItem.isValid = true;

            if (!lineItem.isEnabled) return true;

            if (lineItem.isAutomatic && lineItem.isEnabled && !opCode) {
                lineItem.isValid = false;

                return false;
            }

            if (!lineItem.showInConsumer && !lineItem.showInDashboard) return true;
            
            if (!lineItem.name || !opCode || lineItem.name === "" || opCode === "") {
                lineItem.isValid = false;

                return false;
            }

            if (dmsSystem === dmsEnum.CDK) {
                if (vm.requireDispatchCode === true && !lineItem.dispatchCode) {
                    lineItem.isValid = false;

                    return false;
                }
            } else if (dmsSystem === dmsEnum.DealerTrack) {
                if (!lineItem.serviceType) {
                    lineItem.isValid = false;

                    return false;
                }
            } 

            if (dmsSystem === dmsEnum.ReynoldsERA || dmsSystem === dmsEnum.ReynoldsPOWER) {
                let cleanMergedOpCodeList = $filter('filter')(vm.mergedOpCodeList, {isEnabled: true}, true);

                if ($filter('filter')(cleanMergedOpCodeList, {opCode: opCode, dealerDepartmentId: lineItem.dealerDepartmentId}, true).length > 1) {
                    lineItem.isValid = false;

                    return false;
                }
            }

            return true;
        };

        function refreshLocationOpCodesAndConstraints(retainSelectedDepartment) {
            let openedOpCodes = [];
            let previouslySelectedDepartment = _.cloneDeep(vm.departmentFilter);
            let opCodePromise = locationService.getLocationOpCodes(vm.locationId)
                .then((response) => {
                    vm.configuredLocationOpCodes = response;
                });
            let constraintPromise = constraintService.getConstraintsByType(vm.locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.opCode)
                .then((response) => {
                    vm.constraints = response;
                });
            let loadDepartmentsPromise = locationService.getLocationDepartments(vm.locationId)
                .then((response) => {
                    vm.locationDepartments = response;

                    if (retainSelectedDepartment) {
                        vm.departmentFilter = previouslySelectedDepartment;
                    } else {
                        vm.departmentFilter = vm.locationDepartments[0].id;
                    }
                });

            
            return $q.all([loadDepartmentsPromise, opCodePromise, constraintPromise]).then(() => {
                // Before overwriting the UI accordion specific view model properties copy their state
                vm.mergedOpCodeList.forEach((item) => {
                    if (item.isEnabled) {
                        if (!vm.isLineItemValid(item)) {
                            item.isOpen = true;
                        }
                    }

                    if (item.isOpen) {
                        let departmentIds = [];

                        item.locationDepartments.forEach((dept) => {
                            if (dept.groupClicked) {
                                departmentIds.push(dept.id);
                            }
                        });
                        openedOpCodes.push({
                            id: item.id,
                            opCode: item.opCode,
                            departmentIds: departmentIds
                        });
                    }
                });
                vm.select2Ready = false;
                populateOpCodeList(openedOpCodes);
                initDepartment(retainSelectedDepartment);
                $scope.$watch('vm.mergedOpCodeList', (newVal, oldVal) => {
                    if (!newVal) return;

                    vm.select2Ready = false;  

                    $scope.$$postDigest(() => {  
                        vm.select2Ready = true;  
                    });  
                });

                return;
            });
        }

        function loadOptionalDropDowns() {
            if (vm.dmsSystem === vm.dmsEnum.DealerTrack && !vm.serviceTypes) {
                vm.gettingServiceTypes = true;
                let promise = $q.when();

                if (!resolvedDMSData) {
                    promise = locationService.getLocationDMS(vm.locationId).then((response) => {
                        resolvedDMSData = response;
                    });
                }

                promise.then(() => {
                    locationService.lookupServiceTypes(vm.locationId, resolvedDMSData).then((response) => {
                        vm.serviceTypes = response;
                    }).finally(() => {
                        vm.gettingServiceTypes = false;
                    });
                });
            }
        }

        function populateOpCodeList(openedOpCodes) {
            vm.mergedOpCodeList = [];

            // Load up the list for the UI, if we have dealer op codes, use those, otherwise use the default
            // Populate Generic, Maintenance, Recall at the top, then the remaining system op codes
            if (vm.configuredLocationOpCodes && vm.configuredLocationOpCodes.genericOpCodes.length > 0) {
                vm.configuredLocationOpCodes.genericOpCodes.forEach((item) => {
                    vm.mergedOpCodeList.push(item);
                });
            } else {
                let genericItem = appointmentServiceOpCodeClass.new(vm.systemOpCodes.genericOpCodes[0]);

                genericItem = transposeNewLineItemProperties(genericItem);
                vm.mergedOpCodeList.push(genericItem);
            }

            if (vm.configuredLocationOpCodes.recommendedMaintenanceOpCodes.length > 0) {
                vm.configuredLocationOpCodes.recommendedMaintenanceOpCodes.forEach((item) => {
                    vm.mergedOpCodeList.push(item);
                });
            } else {
                let maintItem = appointmentServiceOpCodeClass.new(vm.systemOpCodes.recommendedMaintenanceOpCodes[0]);

                maintItem = transposeNewLineItemProperties(maintItem);
                vm.mergedOpCodeList.push(maintItem);
            }

            if (vm.configuredLocationOpCodes.recallOpCodes.length > 0) {
                vm.configuredLocationOpCodes.recallOpCodes.forEach((item) => {
                    vm.mergedOpCodeList.push(item);
                });
            } else {
                let recallItem = appointmentServiceOpCodeClass.new(vm.systemOpCodes.recallOpCodes[0]);

                recallItem = transposeNewLineItemProperties(recallItem);
                vm.mergedOpCodeList.push(recallItem);
            }

            if (vm.configuredLocationOpCodes.automaticOpCodes.length > 0) {
                let configuredAutomaticOpCodes = vm.configuredLocationOpCodes.automaticOpCodes;

                configuredAutomaticOpCodes.forEach((item) => {
                    vm.mergedOpCodeList.push(item);
                });

                vm.systemOpCodes.automaticOpCodes.forEach((item) => {
                    if ($filter('filter')(configuredAutomaticOpCodes, {dealerSystemAppointmentServiceId: item.id}, true).length === 0) {
                        let automaticItem = appointmentServiceOpCodeClass.new(item);

                        automaticItem = transposeNewLineItemProperties(automaticItem);
                        automaticItem.isEnabled = false;
                        vm.mergedOpCodeList.push(automaticItem);
                    }
                });

            } else {
                vm.systemOpCodes.automaticOpCodes.forEach((item) => {
                    let automaticItem = appointmentServiceOpCodeClass.new(item);

                    automaticItem = transposeNewLineItemProperties(automaticItem);
                    automaticItem.isEnabled = false;
                    vm.mergedOpCodeList.push(automaticItem);
                });
            }

            if (vm.sortType) {
                let ordered = null;
                let ascDesc = vm.sortAsc ? 'asc' : 'desc';
                    
                if (vm.configuredLocationOpCodes.opCodes.length > 0) {
                    ordered = _.orderBy(vm.configuredLocationOpCodes.opCodes, [vm.sortType], [ascDesc]);
                    ordered.forEach((item) => {
                        if (!item.isAutomatic) {
                            vm.mergedOpCodeList.push(item);
                        }
                    });
                } else {
                    ordered = _.orderBy(vm.systemOpCodes.opCodes, [vm.sortType], [ascDesc]);
                    ordered.forEach((item) => {
                        item = appointmentServiceOpCodeClass.new(item);
                        item = transposeNewLineItemProperties(item);

                        if (!item.isAutomatic) {
                            vm.mergedOpCodeList.push(item);
                        }
                    });
                }
            } else {
                if (vm.configuredLocationOpCodes.opCodes.length > 0) {
                    vm.configuredLocationOpCodes.opCodes.forEach((item) => {
                        if (!item.isAutomatic) {
                            vm.mergedOpCodeList.push(item);
                        }
                    });
                } else {
                    vm.systemOpCodes.opCodes.forEach((item) => {
                        item = appointmentServiceOpCodeClass.new(item);
                        item = transposeNewLineItemProperties(item);

                        if (!item.isAutomatic) {
                            vm.mergedOpCodeList.push(item);
                        }
                    });
                }
            }

            vm.mergedOpCodeList.forEach((item) => {
                item.uid = appointmentUtilService.generateUID(item.opCode, item.id);
                item.locationDepartments = _.cloneDeep(vm.locationDepartments);
                item.selectedOpCode = item.opCode ? {
                    id: item.opCode,
                    opCode: item.opCode,
                    text: item.opCode
                } : null;
                
                if (item.isEnabled) {
                    if (!vm.isLineItemValid(item)) {
                        item.isOpen = true;
                    }
                }

                if (openedOpCodes) {
                    let openedOpCode = openedOpCodes.find((o) => { 
                        if (o.id) {
                            return o.id === item.id;
                        }

                        return o.opCode === item.opCode;
                    });
                    
                    if (openedOpCode) {
                        item.isOpen = true;
                        item.locationDepartments.forEach((dept) => {
                            if (openedOpCode.departmentIds.includes(dept.id)) {
                                dept.groupClicked = true;
                            }
                        });
                    }
                }

                item.constraints = $filter('filter')(vm.constraints, (value) => {
                    return value.constraintDataParsed.OpCode === item.opCode;
                });

                item.constraints.forEach((c) => {
                    c.isNew = false;
                });

                vm.deptConstraintsAreValid = false;

                // Default each op code to have a blank constraint if empty, for UI purposes
                item.locationDepartments.forEach((dept) => {
                    if ($filter('filter')(item.constraints, {departmentId: dept.id}, true).length === 0) {
                        vm.addNewOpCodeConstraint(item, dept.id);
                    }
                });
            });

            vm.initializingLocation = false;
        }

        vm.sort = function (type) {
            if (vm.sortType !== type || vm.sortAsc === false) {
                vm.sortAsc = true;
            } else {
                vm.sortAsc = false;
            }

            vm.sortType = type;
            populateOpCodeList();
        };

        vm.formatForSelection = function (item) {
            return item.opCode;
        };

        vm.formatForDropdown = function (item) {
            return item.opCode + ': ' + item.dashboardDescription;
        };

        vm.toggleMultipleItems = function (item) {
            $timeout(() => {
                if (item.allowMultipleCount > 1) {
                    item.allowMultipleCount = 1;
                } else {
                    item.allowMultipleCount = 2;
                }
            }, 1);
        };

        vm.opCodeSearchQuery = {
            type: 'GET',
            dataType: 'json',
            data: function (parameters) {
                let query = {
                    search: parameters.term,
                    dealerId: vm.locationId,
                    page: parameters.page,
                    pageSize: _pageSize
                };

                return query;
            },
            transport: function (params, success, failure) {
                let data = params.data;

                return locationService.searchLocationOpCodes(vm.locationId, null, data.search, data.page, data.pageSize).then(success, failure);
            },
            delay: 800,
            processResults: function (data) {
                // avoid automatic opcodes showing in other search results
                let filteredData = data.filter(item => {
                    return !vm.mergedOpCodeList.some(mergedItem => mergedItem.opCode === item.opCode && mergedItem.isAutomatic && mergedItem.isEnabled && mergedItem.dealerSystemAppointmentServiceId === vm.systemOpcodeType.customAutomaticOpCode);
                });

                return {
                    results: filteredData,
                    pagination: {
                        more: data.length === _pageSize
                    }
                };
            }
        };

        vm.systemOpCodes = resolvedSystemOpCodes;
        vm.serviceTypes = null;
        vm.currentTripType = resolvedTripType;
        vm.displayConsumerPrices = vm.currentTripType.tripTypeSpecificConfigs.DisplayConsumerPrices.value;
        vm.dmsSystem = resolvedDMSData ? resolvedDMSData.dmsSystem : null;
        vm.dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;
        vm.paymentTypes = APPOINTMENT_PAYTYPES;
        vm.decimalRegex = '^[0-9]+(\.[0-9]{1,2})?$';
        vm.showInConsumerFilter = null;
        vm.showInDashboardFilter = null;
        vm.convertedTextFilter = "";

        function openLineItem (lineItem) {
            $timeout(() => {
                lineItem.isOpen = true;
            }, 1);
        }

        function closeLineItem (lineItem) {
            $timeout(() => {
                lineItem.isOpen = false;
            }, 1);
        }

        vm.showInFilters = [
            {value: 1, text: 'UNASSIGNED'},
            {value: 2, text: 'DASH ONLY'},
            {value: 3, text: 'CONSUMER ONLY'},
            {value: 4, text: 'CONSUMER AND DASH'}
        ];

        vm.showInFilterChanged = function () {
            if (vm.showInFilter === null) {
                vm.showInConsumerFilter = null;
                vm.showInDashboardFilter = null;
            } else if (vm.showInFilter === 1) {
                vm.showInConsumerFilter = false;
                vm.showInDashboardFilter = false;
            } else if (vm.showInFilter === 2) {
                vm.showInConsumerFilter = false;
                vm.showInDashboardFilter = true;
            }  else if (vm.showInFilter === 3) {
                vm.showInConsumerFilter = true;
                vm.showInDashboardFilter = false;
            }  else if (vm.showInFilter === 4) {
                vm.showInConsumerFilter = true;
                vm.showInDashboardFilter = true;
            }
        };

        vm.textFilterChanged = function () {
            vm.convertedTextFilter = vm.textFilter.toLowerCase();
        };

        vm.filterGenericItems = function (item) {
            if (item.isDeleted === false && item.dealerDepartmentId === vm.departmentFilter && (item.isRecall || item.isRecommendedMaintenance || item.isGeneric)) return true;
        };

        vm.filterDisplayedItems = function (item) {
            if (item.isDeleted === false && (item.isRecall || item.isRecommendedMaintenance || item.isGeneric || item.isAutomatic)) return false;

            let baseCondition = item.dealerDepartmentId === vm.departmentFilter && 
                                item.isDeleted === false && 
                                item.isEnabled === true;

            if (vm.showInConsumerFilter === null && vm.showInDashboardFilter === null) {
                if (vm.convertedTextFilter === "") {
                    return baseCondition;
                } else {
                    return baseCondition && 
                        ((item.opCode && item.opCode.toLowerCase().indexOf(vm.convertedTextFilter) > -1) || 
                        (item.name && item.name.toLowerCase().indexOf(vm.convertedTextFilter) > -1));
                }                
            } else {
                if (vm.convertedTextFilter === "") {
                    return baseCondition && item.showInDashboard === vm.showInDashboardFilter;
                } else {
                    return baseCondition &&
                        item.showInConsumer === vm.showInConsumerFilter && 
                        item.showInDashboard === vm.showInDashboardFilter && 
                        ((item.opCode && item.opCode.toLowerCase().indexOf(vm.convertedTextFilter) > -1) || 
                        (item.name && item.name.toLowerCase().indexOf(vm.convertedTextFilter) > -1));
                }
            }
        };

        vm.showServiceTypeError = function () {
           return vm.dmsSystem === vm.dmsEnum.DealerTrack && (!vm.serviceTypes || vm.serviceTypes.length === 0) && vm.gettingServiceTypes === false;
        };

        function initDepartment(retainSelectedDepartment) {
            if (vm.locationDepartments && vm.locationDepartments.length) {
                if (retainSelectedDepartment !== true) {
                    vm.departmentFilter = vm.locationDepartments[0].id;
                }

                vm.departmentChanged();
            }
        }

        vm.getDepartmentName = function (deptId) {
            let dept = vm.locationDepartments.find((d) => { return d.id === deptId; });

            return dept.name;
        };

        vm.departmentChanged = function (form) {
            if (form && form.$dirty) {
                let deptToCheck = vm.selectedDepartment?.id;
                let invalidLineItems = vm.hasInvalidLineItems(deptToCheck);
                
                if (invalidLineItems) {
                    modalService.showYesNo(
                        'Please Confirm',
                        'You have made changes that are incomplete and will not save. Do you still want to change departments?',
                        'No',
                        'Yes'
                    ).then((confirmed) => {
                        if (!confirmed) {
                            vm.departmentFilter = deptToCheck;
                            vm.selectedDepartment = vm.locationDepartments.find((department) => department.id === deptToCheck);
                        } else {
                            vm.selectedDepartment = vm.locationDepartments.find((department) => department.id === vm.departmentFilter);
                        }
                    });
                } else {
                    vm.autoSave(deptToCheck, vm.departmentFilter);
                }
            } else {
                vm.selectedDepartment = vm.locationDepartments.find((department) => department.id === vm.departmentFilter);
            }
        };

        initDepartment();
        loadOptionalDropDowns();

        let transposeNewLineItemProperties = function (lineItem) {
            lineItem.isDeleted = false;
            lineItem.isEnabled = true;
            lineItem.dealerSystemAppointmentServiceId = lineItem.id;
            lineItem.id = 0;
            lineItem.dealerId = vm.locationId;

            return lineItem;
        };

        vm.getNoteMaxLength = function () {
            return appointmentUtilService.getNoteMaxLength(vm.dmsSystem);
        };

        vm.addNewOpCodeConstraint = function (lineItem, departmentId) {
            lineItem.constraints.push({
                constraintDataParsed: {
                    OpCode: lineItem.opCode
                },
                departmentId: departmentId || null,
                isDeleted: false,
                isNew: true,
                uid: appointmentUtilService.generateUID(lineItem.opCode)
            });
        };

        vm.isLastOpCodeConstraintBlank = function (lineItem) {
            let constraints = $filter('filter')(lineItem.constraints, (value) => {
                return value.departmentId === vm.departmentFilter;
            });

            return constraints[constraints.length - 1].isNew ? constraints[constraints.length - 1].isNew : false;
        };

        if (vm.locationId) {
            populateOpCodeList();
        }

        vm.revalidatePricePrefix = function () {
            // Validate all line items' price prefix fields regardless of which one is active in the DOM 
            _.forEach(vm.mergedOpCodeList, (lineItem) => {
                $scope.$broadcast(_revalidate, 'pricePrefix-' + lineItem.uid);
            });
        };

        vm.revalidateForm = function () {
            if (!vm.locationId) {
                return;
            }

            $timeout(() => {
                $scope.locationLineItemForm.$invalid = !_myValidation.checkFormValidity($scope.locationLineItemForm);
                $scope.locationLineItemForm.$valid = !$scope.locationLineItemForm.$invalid;
            });
        };

        vm.revalidateForm();

        // Validate the form on any data change
        $scope.$watch('vm.mergedOpCodeList', () =>  {
            vm.revalidateForm();
        }, true);

        vm.recallOpCodeTypeChanged = function (uid) {
            let index = vm.mergedOpCodeList.findIndex((o) => { return o.uid === uid; });
            
            if (vm.mergedOpCodeList[index].recallOpCodeType !== vm.recallOpCodeType.prefix) {
                vm.mergedOpCodeList[index].recallPrefix = null;
            }

            $timeout(() => {
                // Revalidate our prefix field
                $scope.$broadcast(_revalidate, 'prefix-' + uid);
            }, 1);
        };
        
        vm.getOpCodeMaxLength = function () {
            return appointmentUtilService.getOpCodeMaxLength(vm.dmsSystem);
        };

        vm.validation = {
            valRequiredIfEnabled: function (field, lineItem) {
                // If we're validating an automatic line that isn't enabled, we can shortcut validation
                // if we're not requiring dispatch code for this dealer ... we're all good
                if (lineItem.isAutomatic && !lineItem.isEnabled) {
                    return true;
                } else if (!lineItem.isAutomatic && !lineItem.showInDashboard && !lineItem.showInConsumer) {
                    return true;
                } else if (vm.requireDispatchCode === false) {
                    return true;
                }

                if ((typeof field === 'string' && field.trim().length === 0) || typeof field === 'undefined' || field === null) {
                    openLineItem(lineItem);

                    return false;
                } else {
                    return true;
                }
            },
            valOpCode: function (lineItem) {
                let opCode = lineItem.opCode;

                // Due to the limitations of the validation suite and the select2 control, we need to reference the ng-model.
                if (lineItem.selectedOpCode && lineItem.selectedOpCode.length === 1) {
                    opCode = lineItem.selectedOpCode[0];
                }

                let dmsSystem = vm.dmsSystem;
                let dmsEnum = vm.dmsEnum;
                let maxLength = vm.getOpCodeMaxLength();
                let isAutomaticOrEnabled = lineItem.isAutomatic && lineItem.isEnabled;


                // If we're validating a line that isn't enabled, we're fine to have a NULL op code
                if (!opCode && (lineItem.showInConsumer || lineItem.showInDashboard || isAutomaticOrEnabled)) {
                    openLineItem(lineItem);

                    return false;
                }

                // If we're validating an automatic line that isn't enabled, we can shortcut validation
                if (lineItem.isAutomatic && !lineItem.isEnabled) {
                    return true;
                } else if (!lineItem.isAutomatic && !lineItem.showInDashboard && !lineItem.showInConsumer) {
                    return true;
                }

                // Validate this op code has not been used yet
				if (dmsSystem === dmsEnum.ReynoldsERA || dmsSystem === dmsEnum.ReynoldsPOWER) {
                    let matchedOpCode = vm.mergedOpCodeList.find((o) => { 
                        return o.dealerDepartmentId === lineItem.dealerDepartmentId && 
                                o.opCode &&  
                                o.opCode.toLowerCase() === opCode.toLowerCase() &&
                                o.id !== lineItem.id;
                            });

                    if (matchedOpCode) {
                        openLineItem(lineItem);

                        return {isValid: false, message: ' must be unique'};
                    }
                }

                if (opCode.length > maxLength) {
                    openLineItem(lineItem);

                    return {isValid: false, message: ' cannot be greater than ' + maxLength +  ' characters.'};
                }

                if (dmsSystem === dmsEnum.CDK) {
                    if (opCode.indexOf(' ') > -1) {
                        openLineItem(lineItem);

                        return {isValid: false, message: ' cannot contain spaces.'};
                    }

                    if (opCode.indexOf('|') > -1) {
                        openLineItem(lineItem);

                        return {isValid: false, message: ' cannot contain \'|\'.'};
                    }

                    if (opCode.indexOf('*') > -1) {
                        openLineItem(lineItem);

                        return {isValid: false, message: ' cannot contain \'*\'.'};
                    }

                    if (_.startsWith(opCode, 'DNX') || _.startsWith(opCode, 'DGP') || _.startsWith(opCode, 'DTG')) {
                        openLineItem(lineItem);

                        return {isValid: false, message: ' cannot start with DTG, DNS, or DNX'};
                    }

                    return true;
                } else {
                    return true;
                }
            },
            valPrefix: function (lineItem) {
                // If we're validating a line that isn't enabled, we're fine to have a NULL op code
                if (!lineItem.opCode && !lineItem.showInConsumer && !lineItem.showInDashboard) {

                    return true;
                }

                if (lineItem.recallOpCodeType === vm.recallOpCodeType.prefix && (!lineItem.recallPrefix || lineItem.recallPrefix.trim().length === 0)) {
                    openLineItem(lineItem);

                    return {isValid: false, message: ' is required.'};
                }

                return true;
            },
            valPricePrefix: function (lineItem) {
                if (lineItem.pricePrefix && lineItem.pricePrefix.length > 12) {
                    openLineItem(lineItem);

                    return {isValid: false, message: ' exceeds 12 characters.'};
                } else if (!vm.displayConsumerPrices || !lineItem.opCode && !lineItem.showInConsumer) {

                    return true;
                } else if (!lineItem.pricePrefix || lineItem.pricePrefix.trim().length === 0) {
                    openLineItem(lineItem);

                    return {isValid: false, message: ' is required.'};
                }

                return true;
            },
            valDecimal: function (value, lineItem, exactDecimalPlaces) {

                return appointmentUtilService.validateDecimal(value, lineItem, exactDecimalPlaces);
                
            },
            valConstraints: constraintService.validateLimitPerHourPerDayConstraints,
            // the ValidationService plugin cannot handle object literal notation in parameters of the inline custom validation function in the HTML
            filterPredicate: function (departmentId) {
                return {
                    departmentId: departmentId
                };
            }
        };

        vm.addOpCodeConstraint = function (constraint, lineItem, uid) {
            let index = lineItem.constraints.findIndex((o) => {
                return o.uid === uid;
            });

            constraint.dealerId = vm.locationId;
            angular.extend(lineItem.constraints[index], constraint);
            $scope.$broadcast(_revalidate, 'constraints-valid-' + lineItem.uid + '-' + constraint.departmentId);
            // After we've revalidated any fields, use a $timeout to give the validation plugin time to validate all constraints
            // and recall checkFormValidity to update the UI error message fields
            $timeout(() => {
                vm.revalidateForm();
                vm.autoSave(vm.selectedDepartment?.id);
            }, 25);
        };

        vm.removeOpCodeConstraint = function (constraint, lineItem) {
            let index = lineItem.constraints.findIndex((o) => {
                return o.uid === constraint.uid;
            });

            constraint.isDeleted = true;

            if (!lineItem.constraints[index].id) {
                // We never saved this item, so we can completely remove it
                lineItem.constraints.splice(index, 1);
            }

            // Ensure we always have at least one empty constraint for the department
            if (lineItem.constraints.findIndex((o) => {return !o.isDeleted && o.departmentId === constraint.departmentId; }) === -1) {
                vm.addNewOpCodeConstraint(lineItem, constraint.departmentId);
            }

            $scope.$broadcast(_revalidate, 'constraints-valid-' + lineItem.uid + '-' + constraint.departmentId);
            // After we've revalidated any fields, use a $timeout to give the validation plugin time to validate all constraints
            // and recall checkFormValidity to update the UI error message fields
            $timeout(() => {
                vm.revalidateForm();
            }, 25);
        };

        vm.constraintChange = function (elementsToRevalidate, lineItemUid, departmentId) {
            // We've gotten an input changed event, revalidate the form
            for (let i = 0; i < elementsToRevalidate.length; i++) {
                $scope.$broadcast(_revalidate, elementsToRevalidate[i]);
            }

            $scope.$broadcast(_revalidate, 'constraints-valid-' + lineItemUid + '-' + departmentId);
            $timeout(() => {
                vm.revalidateForm();
            }, 25);
        };

        vm.headerSwitched = function (open, lineItem) {
            $scope.$broadcast(_revalidate, 'opcode-' + lineItem.uid);
            $scope.$broadcast(_revalidate, 'retailprice-' + lineItem.uid);
            $scope.$broadcast(_revalidate, 'laborhours-' + lineItem.uid);
            $scope.$broadcast(_revalidate, 'dispatchcode-' + lineItem.uid);
            $scope.$broadcast(_revalidate, 'dmsServiceTypes-' + lineItem.uid);

            if (lineItem.showInConsumer) {
                $scope.$broadcast(_revalidate, 'pricePrefix-' + lineItem.uid);
            }

            vm.revalidateForm();

            let formIsInvalid = $scope.locationLineItemForm.$invalid || vm.hasInvalidAutomaticLineItems();
            
            if (open && (!formIsInvalid || !lineItem.isValid)) {
                openLineItem(lineItem);
            } else if (lineItem.isAutomatic && !open) {
                closeLineItem(lineItem);
            }
           
        };

        vm.addNewLine = function (isAutomaticOpCode = false) {
            let lineItem = transposeNewLineItemProperties(appointmentServiceOpCodeClass.new());
            let defaultDispatchCode = vm.selectedDepartment.defaultDispatchCode;

            // Open the most recently added line
            lineItem.isOpen = true;
            lineItem.uid = appointmentUtilService.generateUID(lineItem.opCode, lineItem.id);
            lineItem.locationDepartments = _.cloneDeep(vm.locationDepartments);
            if (!isAutomaticOpCode) lineItem.dealerDepartmentId = vm.departmentFilter;

            if (isAutomaticOpCode) {
                lineItem.dealerSystemAppointmentServiceId = vm.systemOpcodeType.customAutomaticOpCode;
                let defaultAutomaticOpCode = vm.mergedOpCodeList.find(item =>
                    item.dealerSystemAppointmentServiceId === vm.systemOpcodeType.customAutomaticOpCode
                );

                lineItem.name = defaultAutomaticOpCode?.name ?? 'On Every Appointment';
                lineItem.description = defaultAutomaticOpCode?.description ?? 'Automatic Op Code';
                lineItem.dashboardDescription = defaultAutomaticOpCode?.description ?? 'Automatic Op Code';
            }

            lineItem.isAutomatic = isAutomaticOpCode;


            if (defaultDispatchCode) {
                lineItem.dispatchCode = defaultDispatchCode;
            }

            lineItem.constraints = $filter('filter')(vm.constraints, (value) => {
                return value.constraintDataParsed.OpCode === lineItem.opCode;
            });
            
            vm.deptConstraintsAreValid = false;
            
            lineItem.locationDepartments.forEach((dept) => {
                if ($filter('filter')(lineItem.constraints, {departmentId: dept.id}, true).length === 0) {
                    vm.addNewOpCodeConstraint(lineItem, dept.id);
                }
            });

            vm.isLineItemValid(lineItem);
            vm.mergedOpCodeList.push(lineItem);
        };

        vm.deleteLine = function (lineItem) {
            let index = vm.mergedOpCodeList.findIndex((o) => {
                return o.uid === lineItem.uid;
            });
            let confirm = modalService.showYesNo('Please Confirm', 'Are you sure you want to delete this mapping?', 'No', 'Yes');

            confirm.then((confirmed) => {
                if (confirmed) {
                    vm.mergedOpCodeList[index].isDeleted = true;

                    if (vm.mergedOpCodeList[index].id === 0) {
                        // We never saved this item, so we can completely remove it
                        vm.mergedOpCodeList.splice(index, 1);
                    } else {
                        locationService.deleteLocationOpCode(vm.locationId, vm.mergedOpCodeList[index].id).then(() => {
                            eventAlertService.createAlert('Line Item successfully deleted.');
                        });
                    }
                }
            });
        };

        vm.opCodeSearchSelected = function (lineItem, selectedItem) {
            if (selectedItem && selectedItem.length === 1) {
                let data = selectedItem[0];

                lineItem.laborHours = data.laborHours;
                lineItem.opCode = data.opCode;
                lineItem.payType = data.payType;
                lineItem.retailPrice = data.retailPrice;
                lineItem.serviceType = data.serviceType;
                lineItem.partsPrice = data.partsPrice;
                lineItem.laborPrice = data.laborPrice;
            } else {
                // Item was cleared, clear out previously autofilled data
                lineItem.laborHours = 0;
                lineItem.opCode = '';
                lineItem.payType = null;
                lineItem.retailPrice = null;
                lineItem.laborPrice = null;
                lineItem.partsPrice = null;
                lineItem.serviceType = null;
            }
            
            $scope.$broadcast(_revalidate, 'opcode-' + lineItem.uid);
        };

        vm.close = function () {
            let path = $location.path();

            if (path.indexOf('/locations')  > -1) {
                $state.go('location-list');
            } else {
                $state.go(_referrer, _params, {reload: false});
            }
        };

        vm.autoSaveInProgress = false;
        vm.autoSaveTimeout = null;

        vm.autoSave = function (departmentIdToSave, switchToDepartment) {
            // Debouncing autosaves as they are triggered after several ng-changes
            // creating an unnecessary overhead while editing checkboxes
            let debounceInMilliseconds = 5000;
            let effectiveDepartmentId = departmentIdToSave || vm.departmentFilter;

            if (vm.autoSaveTimeout && !vm.autoSaveInProgress) {
                // Cancel the previous autoSaveTimeout if it has not begun
                $timeout.cancel(vm.autoSaveTimeout);
                vm.autoSaveTimeout = null;
            }
            
            if (!vm.autoSaveTimeout) {
                vm.autoSaveTimeout = $timeout(() => {
                    vm.autoSaveInProgress = true;

                    // Give adequate time to process whether or not the form is valid, then autosave
                    return vm.updateLineItems($scope.locationLineItemForm.$valid && !vm.hasInvalidLineItems(), effectiveDepartmentId)
                        .then(() => {
                            if (switchToDepartment) {
                                vm.selectedDepartment = vm.locationDepartments.find((department) => department.id === vm.departmentFilter);
                            }

                            // Clear state
                            vm.autoSaveInProgress = false;
                            vm.autoSaveTimeout = null;
                        }).catch(() => {
                            vm.autoSaveInProgress = false;
                            vm.autoSaveTimeout = null;
                        });
                }, debounceInMilliseconds);
            }
        };

        function isEmptyLineItem (lineItem) {
            return lineItem.id === 0 && rcUtilService.isEmpty(lineItem.name) && rcUtilService.isEmpty(lineItem.opCode)
                && !lineItem.showInDashboard && !lineItem.showInConsumer && rcUtilService.isEmpty(lineItem.dashboardName) && rcUtilService.isEmpty(lineItem.consumerName) && rcUtilService.isEmpty(lineItem.dashboardDescription) && rcUtilService.isEmpty(lineItem.consumerDescription);
        }

        vm.updateLineItems = function (valid, departmentIdToSave, options) {
            let savePromise = $q.when();

            if (!valid) return savePromise;

            const isManual = options?.source === 'manual';

            if (isManual) {
                vm.manualSaveInProgress = true;
            }

            let effectiveDepartmentId = departmentIdToSave || vm.departmentFilter;
            let lineItemsToSave = [];
            let constraintsToSave = [];

            vm.mergedOpCodeList.forEach((lineItem) => {
                // We need to operate on a copy to avoid nulling out values in the UI
                if (!lineItem || (lineItem.isAutomatic !== true && lineItem.dealerDepartmentId !== effectiveDepartmentId)) {
                    return;
                }

                let item = _.clone(lineItem);
                let hasDashboardName = item.dashboardName && item.dashboardName.trim().length === 0;
                let hasConsumerName = item.consumerName && item.consumerName.trim().length === 0;
                let hasDashboardDescription = item.dashboardDescription && item.dashboardDescription.trim().length === 0;
                let hasConsumerDescription = item.consumerDescription && item.consumerDescription.trim().length === 0;

                if (hasDashboardName || item.dashboardName === item.name) {
                    item.dashboardName = null;
                }

                if (hasConsumerName || item.consumerName === item.name) {
                    item.consumerName = null;
                }

                if (!item.isAutomatic && (hasDashboardDescription || item.dashboardDescription === item.description)) {
                    item.dashboardDescription = null;
                }

                if (!item.isAutomatic && (hasConsumerDescription || item.consumerDescription === item.description)) {
                    item.consumerDescription = null;
                }

                if (!item.dealerSystemAppointmentServiceId) {
                    item.overrideName = item.name;
                }

                if (item.isAutomatic) {
                    item.consumerDescription = item.dashboardDescription;
                }

                if (!isEmptyLineItem(item)) {
                    lineItemsToSave.push(item);

                    if (item.constraints && item.constraints.length > 0) {
                        item.constraints.forEach((constraint) => {
                            if (constraint.isNew || typeof constraint.id === 'undefined') {
                                return;
                            }

                            if (constraint.departmentId !== effectiveDepartmentId) {
                                return;
                            }

                            constraint.advisorId = null;
                            constraintsToSave.push(constraint);
                        });
                    }
                }
            });

            return locationService.updateLocationOpCodes(vm.locationId, lineItemsToSave).then(() => {
                eventAlertService.createAlert('Line Item Data Successfully Updated.');

                if (constraintsToSave.length > 0) {
                    savePromise = constraintService.saveConstraints(vm.locationId, constraintsToSave);
                }

                return savePromise.then(() => {
                    // Refresh the op code list
                    let deptToUpdate = vm.locationDepartments.find((department) => department.id === effectiveDepartmentId) || vm.selectedDepartmen;
                    
                    return locationService.updateDepartmentSettings(deptToUpdate).then(() => {
                        return refreshLocationOpCodesAndConstraints(true);
                    });
                });
            }).finally(() => {
                if (isManual) {
                    vm.manualSaveInProgress = false;
                }
            });
        };

    }
})();

(function () {
    'use strict';

    LocationTabIntegrationsController.$inject = ["$transition$", "$scope", "$filter", "modalService", "SYSTEM_ENUMS", "locationService", "eventAlertService", "resolvedDMSData", "resolvedIntegrationData", "resolvedTripTypInstances", "resolvedLocation", "resolvedHasCheckIn", "resolvedRideProviderTripTypeInstanceDetails"];
    angular
        .module('redcap.location')
        .controller('LocationTabIntegrationsController', LocationTabIntegrationsController);

    let tabs = {
        DMS: 1,
        XTime: 2,
        Payments: 3,
        AutoPoint: 4,
        LoanerManagement: 5,
        DigniFi: 6
    };

    function LocationTabIntegrationsController($transition$,
        $scope,
        $filter,
        modalService,
        SYSTEM_ENUMS,
        locationService,
        eventAlertService,
        resolvedDMSData,
        resolvedIntegrationData,
        resolvedTripTypInstances,
        resolvedLocation,
        resolvedHasCheckIn,
        resolvedRideProviderTripTypeInstanceDetails) {

        let vm = this;
        let locationId = $transition$.params().locationId;

        vm.hasCheckIn = resolvedHasCheckIn;
        vm.currentLocation = resolvedLocation;
        vm.fakeInput = 1; // do not remove.  solving issue with ghis validation bug
        vm.locationId = locationId;
        vm.dmsImportRecords = [];
        vm.dmsEntry = resolvedDMSData;
        vm.dmsEntry.paymentProcessor = vm.dmsEntry.paymentProcessor || SYSTEM_ENUMS.paymentProcessorsEnum.none;
        vm.dmsEntry.paymentConfiguration = vm.dmsEntry.paymentConfiguration || {};
        vm.dmsEntry.paymentConfiguration.terminals = vm.dmsEntry.paymentConfiguration.terminals || [];

        vm.integrationData = resolvedIntegrationData || {};
        vm.integrationData.loaner = vm.integrationData.loaner || {};
        vm.integrationData.autoPoint = vm.integrationData.autoPoint || {};
        vm.integrationData.digniFi = vm.integrationData.digniFi || {};
        vm.rolesEnums = SYSTEM_ENUMS;
        vm.dmsSystemTypes = SYSTEM_ENUMS.dmsSystem;
        vm.dmsSystemEnum = SYSTEM_ENUMS.dmsSystemEnum;
        vm.paymentProcessorsEnum = SYSTEM_ENUMS.paymentProcessorsEnum;
        vm.paymentProcessors = SYSTEM_ENUMS.paymentProcessors;
        vm.dmsPushTypes = SYSTEM_ENUMS.dmsPushTypes;
        vm.dmsPushTypesEnum = SYSTEM_ENUMS.dmsPushTypesEnum;
        vm.rideProviderTypes = SYSTEM_ENUMS.rideProviderType;
        vm.rideProviderTripTypeInstanceDetails = resolvedRideProviderTripTypeInstanceDetails;
        vm.disableConvertRideProvider = resolvedLocation.isCopyable; // Only allow conversion if dealership isn't program level
        vm.dmsEnvironmentTypes = SYSTEM_ENUMS.dmsEnvironmentTypes;

        if (vm.dmsEntry && vm.dmsEntry.dmsPushType !== SYSTEM_ENUMS.dmsPushTypesEnum.ConsumerApiAndDash) {
            vm.dmsPushTypes = vm.dmsPushTypes.filter(item => item.value !== SYSTEM_ENUMS.dmsPushTypesEnum.ConsumerApiAndDash);
        }

        vm.productPackageLevels = SYSTEM_ENUMS.dmsPackageLevels;
        
        vm.serviceTypes = [vm.dmsEntry.dmsServiceType];
        vm.tabs = tabs;
        vm.tab = tabs.DMS;

        vm.roDeliveryOptions = [];
        vm.apptDeliveryOptions = [];
        vm.mobileGarageDeliveryOptions = [];

        if (vm.dmsEntry.hasLoanerDataElementAppt === 6) {
            vm.apptDeliveryOptions = [vm.dmsEntry.hasLoanerDataPatternAppt];
        }

        if (vm.dmsEntry.hasLoanerDataElementRO === 6) {
            vm.roDeliveryOptions = [vm.dmsEntry.hasLoanerDataPatternRO];
        }

        if (vm.dmsEntry.mobileGarageDeliveryFlag) {
            vm.mobileGarageDeliveryOptions = [vm.dmsEntry.mobileGarageDeliveryFlag];
        }

        vm.motiveDataSources = SYSTEM_ENUMS.motiveDataSource;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
        vm.tripTypeIntances = resolvedTripTypInstances;
        vm.hasAppointments = locationService.hasTransportationType(vm.tripTypeIntances, vm.systemTripTypes.appointment);
        vm.hasMobileGarage = locationService.hasTransportationType(vm.tripTypeIntances, vm.systemTripTypes.mobileGarage);
      
        if (resolvedDMSData.dmsDispatchCode) {
            vm.dispatchCodes = [resolvedDMSData.dmsDispatchCode];
        } else {
            vm.dispatchCodes = [];
        }

        if (resolvedDMSData.dmsLaborType) {
            //just show the labor type code when we load the page initially
            vm.laborTypes = [{value: resolvedDMSData.dmsLaborType, text: ''}];
        } else {
            vm.laborTypes = [];
        }

        vm.booleanOptions = [
            {value: true, text: 'Yes'},
            {value: false, text: 'No'}
        ];

        vm.dmsIntervals = [
            {value: 900, text: 'Every 15 Minutes'},
            {value: 1200, text: 'Every 20 Minutes'},
            {value: 1800, text: 'Every 30 Minutes'}
        ];

        vm.dispatchMakeCodes = $filter('alphaNumRange')('A', 'Z');

        // APPT & RO IDENTIFICATION MASSAGE
        vm.identificationTypesAppt = [
            {value: 1, text: 'Transportation Type'},
            {value: 2, text: 'Op Code'},
            {value: 3, text: 'Service Tag'},
            {value: 4, text: 'Force Value'}, 
            {value: 5, text: 'Comments'},
            {value: 6, text: 'Delivery Flag'}
        ];

        vm.identificationTypesRO = [
            {value: 1, text: 'Transportation Type'},
            {value: 2, text: 'Op Code'},
            {value: 3, text: 'Service Tag'},
            {value: 4, text: 'Force Value'},
            {value: 6, text: 'Delivery Flag'}
        ];

        vm.validation = {
            acceptableDmsIntervals: _.map(vm.dmsIntervals, 'value').join()
        };

        vm.apptMapChanged = function () {
            if (vm.dmsEntry.hasLoanerDataElementAppt === 4) {
                vm.dmsEntry.hasLoanerDataPatternAppt = 'true';
            } else {
                vm.dmsEntry.hasLoanerDataPatternAppt = null;
            }
        };

        vm.roMapChanged = function () {
            if (vm.dmsEntry.hasLoanerDataElementRO === 4) {
                vm.dmsEntry.hasLoanerDataPatternRO = 'true';
            } else {
                vm.dmsEntry.hasLoanerDataPatternRO = null;
            }
        };

        vm.resetDMS = function () {
            if (vm.dmsEntry.dmsSystem === 0) {
                vm.dmsEntry.dmsDealerId = null;
                vm.dmsEntry.dmsImportIntervalInSeconds = 900;
                vm.dmsEntry.hasLoanerDataElementAppt = null;
                vm.dmsEntry.hasLoanerDataElementRO = null;
                vm.dmsEntry.hasLoanerDataPatternAppt = null;
                vm.dmsEntry.hasLoanerDataPatternRO = null;
                vm.dmsEntry.initializeData = false;
                vm.dmsEntry.dmsPushType = 0;
                vm.dmsEntry.dmsEnterpriseId = null;
            } else if (vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.Tekion) {
                vm.dmsEntry.dmsPushType = 0;
            }
        };

        vm.updateDMS = function () {
            // default this value to 900 if it's less than that to avoid issues in the importer
            // some DMS's aren't showing this drop down and need it defaulted 
            if (!vm.dmsEntry.dmsImportIntervalInSeconds || vm.dmsEntry.dmsImportIntervalInSeconds < 900) {
                vm.dmsEntry.dmsImportIntervalInSeconds = 900;
            }

            if (vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.None && !vm.dmsEntry.isXTimeEnabled) {
                vm.dmsEntry.dmsPushType = vm.dmsPushTypesEnum.None;
            }

            locationService.updateLocationDMS(locationId, vm.dmsEntry).then((response) => {
                locationService.updateIntegrations(locationId, vm.integrationData).then((response2) => {
                    eventAlertService.createAlert('Location Integrations Successfully Updated.');

                    if (vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.AutoMate && vm.dmsEntry.isPubSubEnabled) {
                        vm.loadAutoMateSubscriptions();
                    }
                });
            });
        };

        vm.lookupServiceTypes = function () {
          locationService.lookupServiceTypes(locationId, vm.dmsEntry).then((response) => {
            vm.serviceTypes = response;
            eventAlertService.createAlert('Pulled service codes successfully.');
          });
        };

        vm.lookupDispatchCodes = function() {
            locationService.lookupDispatchCodes(locationId, vm.dmsEntry).then((response) => {
                vm.dispatchCodes = response;
                eventAlertService.createAlert('Pulled dispatch codes successfully.');
            });
        };

        vm.lookupLaborTypes = function () {
            locationService.lookupLaborTypes(locationId, vm.dmsEntry).then((response) => {
                vm.laborTypes = response;
                eventAlertService.createAlert('Pulled labor types successfully.');
            });
        };

        vm.loadDmsTab = function() {
            vm.tab = vm.tabs.DMS;
            vm.dmsImportRecordsLoading = true;
            vm.dmsImportRecords = [];
            locationService.getDmsLogs(locationId).then((result) => {
                vm.dmsImportRecords = result || [];
            }).finally(() => {
                vm.dmsImportRecordsLoading = false;
            });
        };

        vm.loanerDataPatternApptChanged = function() {
            vm.dmsEntry.hasLoanerDataPatternAppt = null;
        };

        vm.loanerDataPatternROChanged = function() {
            vm.dmsEntry.hasLoanerDataPatternRO = null;
        };

        let deliveryOptionsPromise = null;

        function getDeliveryOptions() {
            if (!deliveryOptionsPromise) {
                deliveryOptionsPromise = locationService.lookupDeliveryOptions(locationId, vm.dmsEntry);
            }

            return deliveryOptionsPromise;
        }

        vm.lookupMobileGarageDeliveryOptions = function () {
            getDeliveryOptions().then((response) => {
                vm.mobileGarageDeliveryOptions = response;
                eventAlertService.createAlert('Pulled delivery options successfully.');
            });
        };

        vm.lookupApptDeliveryOptions = function () {
            getDeliveryOptions().then((response) => {
                vm.apptDeliveryOptions = response;
                eventAlertService.createAlert('Pulled delivery options successfully.');
            });
        };

        vm.lookupRoDeliveryOptions = function() {
            getDeliveryOptions().then((response) => {
                vm.roDeliveryOptions = response;
                eventAlertService.createAlert('Pulled delivery options successfully.');
            });
        };

        vm.changeTripTypeRideProvider = function(tripTypeInstance, rideProviderType) {
            vm.changingRideProvider = true;

            locationService.changeTripTypeRideProvider(locationId, tripTypeInstance.systemTripTypeId, rideProviderType).then((response) => {
                vm.getRideProviderTripTypeInstanceDetails();                
                eventAlertService.createAlert('Changed trip type successfully.');
            }).finally(() => { 
                vm.changingRideProvider = false; 
            });
        };

        vm.createUberOrganization = function(dealerId) {
            locationService.createUberOrganizations(dealerId).then((response) => {
                eventAlertService.createAlert('Created Uber OrgId successfully. (Please Refresh Page)');
            });
        };

        vm.createUberOrganizations = function(dealerIds) {
            locationService.createUberOrganizations(dealerIds).then((response) => {
                eventAlertService.createAlert('Created Uber organizations successfully.');
            });
        };

        vm.getRideProviderTripTypeInstanceDetails = function() {
            locationService.getRideProviderTripTypeInstances(locationId).then((response) => {
                vm.rideProviderTripTypeInstanceDetails = response;
            });
        };
        
        vm.importOpCodes = function() {
            vm.importingOpCodes = true;
            locationService.importOpCodes(locationId).then((response) => {
                    eventAlertService.createAlert('OpCodes imported successfully from DMS.');
            })
            .catch((error) => {
                eventAlertService.createAlert('Failed to import OpCodes. Please check DMS configuration.', 'danger');
            })
            .finally(() => {
                vm.importingOpCodes = false;
            });
        };

        // AutoMate Pub/Sub
        vm.autoMatePubSubSubscriptions = [];
        vm.autoMatePubSubLoading = false;
        vm.autoMatePubSubExpanded = false;

        vm.loadAutoMateSubscriptions = function() {
            if (vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.AutoMate) return;
            vm.autoMatePubSubLoading = true;
            locationService.getAutoMatePubSubSubscriptions(locationId).then((response) => {
                vm.autoMatePubSubSubscriptions = response || [];

                if (vm.autoMatePubSubSubscriptions.length > 0) {
                    vm.autoMatePubSubExpanded = true;
                }
            }).catch(() => {
                vm.autoMatePubSubSubscriptions = [];
            }).finally(() => {
                vm.autoMatePubSubLoading = false;
            });
        };

        vm.deleteAutoMateSubscription = function(operation, type) {
            modalService.showYesNo('Confirm Delete', `Are you sure you want to delete the ${operation} ${type} subscription?`, 'No', 'Yes').then((confirmed) => {
                if (!confirmed) return;
                locationService.deleteAutoMatePubSubSubscription(locationId, operation, type).then(() => {
                    eventAlertService.createAlert('Subscription deleted.');
                    vm.loadAutoMateSubscriptions();
                }).catch(() => {
                    eventAlertService.createAlert('Failed to delete subscription.', 'danger');
                });
            });
        };

        if (vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.AutoMate && vm.dmsEntry.isPubSubEnabled) {
            vm.loadAutoMateSubscriptions();
        }

        vm.loadDmsTab();
    }
})();

(function () {

    'use strict';

    LocationTabIncentivesController.$inject = ["$scope", "$timeout", "$transition$", "tripTypeService", "eventAlertService", "timeUtilService", "resolvedLocation", "resolvedDealerTripTypes", "dealerHasCheckin", "ValidationService", "resolvedIncentives"];
    angular
        .module('redcap.location')
        .controller('LocationTabIncentivesController', LocationTabIncentivesController);

    function LocationTabIncentivesController($scope, $timeout, $transition$, tripTypeService, eventAlertService, timeUtilService, resolvedLocation, resolvedDealerTripTypes, dealerHasCheckin, ValidationService, resolvedIncentives) {
        let vm = this;
       
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.scheduledIncentives = resolvedIncentives || [];         
        vm.hoursInDay = timeUtilService.hourIntervalsInDay;
        vm.location = resolvedLocation;       

        vm.incentiveTypes = [
            {value: 1, label: 'FLAT RATE'},
            {value: 2, label: 'PERCENT'}
        ];

        vm.availableEndHours = function () {
            return timeUtilService.filterAvailableHours.apply(vm, arguments);
        };

        vm.saveIncentives = function() {
            let savedIncentives = [];

            _.forEach(vm.scheduledIncentives, (incentive) => {
                let newIncentive = _.cloneDeep(incentive);

                newIncentive.daysOfWeek = getSelectedDays(incentive).join(',');

                savedIncentives.push(newIncentive);
            });

            tripTypeService.saveIncentives(vm.location.id, $transition$.params().tripTypeId, savedIncentives).then((result) => {
                eventAlertService.createAlert('Scheduled Incentives successfully saved.');
            });
        };

        vm.validateDays = function(incentive) {            
            if (!incentive) return true;
            
            return hasDaysChecked(incentive);
        };

        vm.validateTimes = function(incentive) {
            if (!incentive.startTime || !incentive.endTime) 
                return {isValid: true};

            let momentTimes = {
                startTime2: moment(incentive.startTime, 'HHmmss'),
                endTime2: moment(incentive.endTime, 'HHmmss')
            };

            if (momentTimes.startTime2.isAfter(momentTimes.endTime2)) {
                return {isValid: false, message: 'From Time must be before End Time'};
            }                

            let incentiveDays = getSelectedDays(incentive);

            // Check all days, and if there are any times that intersect, invalidate the field
            let hasOverlap = _.some(vm.scheduledIncentives, (otherIncentive) => {
                if (otherIncentive.id !== incentive.id) {
                    momentTimes.startTime1 =  moment(otherIncentive.startTime, 'HHmmss');
                    momentTimes.endTime1 = moment(otherIncentive.endTime, 'HHmmss');
                    let otherIncentiveDays = getSelectedDays(otherIncentive);
                    let hasSharedDays = _.intersection(incentiveDays, otherIncentiveDays).length > 0;

                    let overlap = hasSharedDays &&
                                momentTimes.startTime1.isSameOrBefore(momentTimes.endTime2) &&
                                momentTimes.endTime1.isSameOrAfter(momentTimes.startTime2);
    
                    return overlap;
                }
               
                return false;
            });

            return {isValid: !hasOverlap, message: 'These times overlap with another incentive'};
        };

        vm.startTimeChanged = function(incentiveId) {
            revalidateField('incentive-endtime-' + incentiveId);

            revalidateOtherIncentives(incentiveId);
        };

        vm.endTimeChanged = function(incentiveId) {
           revalidateField('incentive-starttime-' + incentiveId);

           revalidateOtherIncentives(incentiveId);
        };

        vm.addIncentive = function(skipValidity) {
            if (!skipValidity && !(new ValidationService().checkFormValidity($scope.incentiveForm))) {
                return;
            }

            let daysOfWeek = [
                {day: 'M', index: 1, checked: false},
                {day: 'T', index: 2, checked: false},
                {day: 'W', index: 3, checked: false},
                {day: 'T', index: 4, checked: false},
                {day: 'F', index: 5, checked: false},
                {day: 'S', index: 6, checked: false},
                {day: 'S', index: 0, checked: false}
            ];

            vm.incentive = {
                daysOfWeek: daysOfWeek,
                fromTime: null,
                toTime: null,
                amount: null,
                id: Math.ceil(Math.random() * 999999) // temporary random number so the incentive can be removed
            };

            vm.scheduledIncentives.push(vm.incentive);
        };

        vm.dowChanged = function (dow, incentive) {
            // Prevent an existing incentive from having all days removed
            if (!dow.checked && !hasDaysChecked(incentive)) {
                dow.checked = true;
            }

            revalidateOtherIncentives();
        };
        
        vm.removeIncentive = function(id) {
            _.remove(vm.scheduledIncentives, (incentive) => {
                return incentive.id === id;
            });
        };

        if (vm.scheduledIncentives.length === 0)
            vm.addIncentive(true);

        function hasDaysChecked(incentive) {
            return _.some(incentive.daysOfWeek, (dow) => { return dow.checked; });
        }

        function revalidateField(fieldName) {
            $timeout(() => {
                $scope.$broadcast('angularValidation.revalidate', fieldName);
            });
        }

        function revalidateOtherIncentives(incentiveId) {
            _.forEach(vm.scheduledIncentives, (incentive) => {
                if (incentive.id !== incentiveId) {
                    revalidateField('incentive-starttime-' + incentive.id);
                    revalidateField('incentive-endtime-' + incentive.id);
                }                
            });
        }

        function getSelectedDays(incentive) {
            return _.map(_.filter(incentive.daysOfWeek, (filteredDow) => { return filteredDow.checked; }), (dow) => {
                return dow.index;
            });
        }
    }
})();

(function () {
    'use strict';

    LocationTabHoursController.$inject = ["$scope", "$transition$", "$filter", "$timeout", "SYSTEM_ENUMS", "modalService", "locationService", "locationHours", "eventAlertService", "timeUtilService", "dealerHasCheckin", "resolvedDealerTripTypes", "resolvedLocation"];
    angular
        .module('redcap.location')
        .controller('LocationTabHoursController', LocationTabHoursController);

    function LocationTabHoursController($scope, $transition$, $filter, $timeout, SYSTEM_ENUMS, modalService, locationService, locationHours, eventAlertService, timeUtilService, dealerHasCheckin, resolvedDealerTripTypes, resolvedLocation) {
        let vm = this;
        let today = new Date();
        let locationId = $transition$.params().locationId;
        
        today.setUTCHours(0, 0, 0, 0);

        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.dayNames = SYSTEM_ENUMS.dayNames;
        vm.locationEntry = '';
        vm.locationHours = [];
        vm.blackouts = futureBlackoutDates(locationHours.blackouts);
        vm.blackoutEnteredValid = null;

        vm.today = moment();

        if (locationId) {
            getDbLocationHours();
            vm.hoursData = timeUtilService.createHoursDropdown(30);
        }

        //watch vm.locationHours to check if at least one day is open
        $scope.$watch('vm.locationHours', (newVal) => {
            let valid = false;

            if (newVal && newVal.length > 0) {
                let foundOpenDay = $filter('filter')(newVal, {closed: false}, false);

                if (foundOpenDay.length) { valid = true; }
            }

            vm.inputForm.allDaysClosedValidator.$setValidity('', valid);
        }, true);

        vm.revalidate = function (controlToValidate) {
            if (controlToValidate) {
                $timeout(() =>  {
                    $timeout(() => { $scope.$broadcast('angularValidation.revalidate', controlToValidate); }, 1);
                }, 250);
            }
        };

        $scope.validateTimes = function (fieldValue, startTime, endTime, isClosed, revalidateControl) {
            if (!isClosed) {
                if (!fieldValue) {
                    return {isValid: false, message: 'Start time and end time is required.'};
                }

                if (startTime > endTime) {
                    return {isValid: false, message: 'Open hours must be before closing hours'};
                }

                if (startTime === endTime) {
                    return {isValid: false, message: 'Open and close time can not be the same time.'};
                }
            }

            return {isValid: true};
        };

        vm.validateDate = function (dateToValidate) {
            let date = new Date(dateToValidate);
            let formattedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
            let isValid = jQuery.inArray(formattedDate, vm.blackouts) === -1;

            vm.blackoutEnteredValid = isValid;

            return {isValid: isValid, message: 'Duplicate black out date.'};
        };

        vm.validateTime00clock = function (startTime, endTime, isClosed) {
            
            if (!isClosed) {
                if (startTime === 0 && endTime === 0) {
                    vm.inputForm.$invalid = true;

                    return true;
                }
            }

            return false;

        };

        vm.sortByDate = function (date1, date2) {
            date1 = new Date(date1);
            date2 = new Date(date2);

            return date1 < date2;
        };

        vm.closedChanged = function (day) {
            if (!day.closed && (!day.startTime || !day.endTime)) {
                day.startTime = vm.hoursData[0].minutesFromMidnight;
                day.endTime = vm.hoursData[0].minutesFromMidnight;
            }
        };

        function futureBlackoutDates(blackouts) {
            return blackouts.filter((b) => {
                let date = new Date(b);

                return date >= today;
            });
        }

        function getDbLocationHours() {
            let days = [];

            for (let dayOfWeek = 0; dayOfWeek < vm.dayNames.length; dayOfWeek++) {
                let dayTemp = {
                    title: vm.dayNames[dayOfWeek],
                    dayOfWeekId: dayOfWeek,
                    startTime: null,
                    endTime: null,
                    closed: true
                };

                locationHours.hours.forEach((dbDay) => {
                    if (dbDay.dayOfWeekId === dayTemp.dayOfWeekId) {    // database data found
                        dayTemp.startTime = dbDay.startTime;
                        dayTemp.endTime = dbDay.endTime;
                        dayTemp.closed = dbDay.startTime === dbDay.endTime;

                        return;
                    }
                });
                days.push(dayTemp);

            }

            vm.locationHours = days;
        }

        vm.updateHours = function () {
            let daytimesArray = [];

            vm.locationHours.forEach((day) => {
                // only push days that are open
                if (!day.closed) {
                    daytimesArray.push({
                        dayOfWeekId: day.dayOfWeekId,
                        startTime: day.startTime,
                        endTime: day.endTime,
                        serviceTripCapacity: day.serviceTripCapacity,
                        salesTripCapacity: day.salesTripCapacity
                    });
                }
            });


            locationService.updateLocationHours(locationId, daytimesArray, vm.blackouts).then((response) => {
                eventAlertService.createAlert('Location Hours Successfully Updated.');
            });
        };

        vm.addBlackout = function (dateToAdd) {
            let date = moment(dateToAdd).format('YYYY-MM-DDTHH:mm:ss');

            if (jQuery.inArray(date, vm.blackouts) === -1) {
                vm.blackouts.push(date);

                if ($scope.vm.inputForm.$valid) {
                    vm.updateHours();
                }
            }
        };

        vm.deleteBlackout = function (index) {
            let confirm = modalService.showYesNo('Please Confirm', 'Are you sure you want to delete the selected blackout date?', 'No', 'Yes');
            
            confirm.then((confirmed) => {
                if (confirmed) {
                    vm.blackouts.splice(index, 1);

                    if ($scope.vm.inputForm.$valid) {
                        vm.updateHours();
                    }
                }
            });
        };
    }
})();

(function () {
    'use strict';

    LocationTabGeneralController.$inject = ["$log", "$scope", "$rootScope", "$timeout", "$uibModal", "$aside", "permissions", "locationService", "modalService", "SYSTEM_ENUMS", "resolvedLocation", "resolvedLocationUsers", "resolvedAdminPrograms", "resolvedTimezones", "eventAlertService", "resolvedProductPackages", "resolvedDealerTripTypes", "dealerHasCheckin"];
    angular
        .module('redcap.location')
        .controller('LocationTabGeneralController', LocationTabGeneralController);

    function LocationTabGeneralController($log, $scope, $rootScope, $timeout, $uibModal, $aside, permissions, locationService, modalService, SYSTEM_ENUMS, resolvedLocation, 
        resolvedLocationUsers, resolvedAdminPrograms, resolvedTimezones, eventAlertService, resolvedProductPackages, resolvedDealerTripTypes, dealerHasCheckin) {
        let vm = this;
        let dealerCurrentTwilio = angular.copy(resolvedLocation.twilioNumber);
        let revalidate = 'angularValidation.revalidate';
        let defunctRoles = SYSTEM_ENUMS.hiddenRoles;

        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.isLoading = true;
        vm.show800Numbers = false;
        vm.currentLocation = resolvedLocation;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.isDeveloper = permissions.isDeveloper();
        vm.dealerId = this.currentLocation.id;
        vm.currentLocation.hasPayments = vm.currentLocation.hasPayments && vm.currentLocation.paymentsConfigured;
        vm.locationEmployees = _.filter(resolvedLocationUsers, user => user.identityUserId);
        vm.brandingTypes = SYSTEM_ENUMS.brandingTypes;
        vm.locationTypes = SYSTEM_ENUMS.locationTypes;
        vm.timeZones = resolvedTimezones;
        vm.systemEnums = SYSTEM_ENUMS;
        vm.statuses = SYSTEM_ENUMS.dealerStatuses;
        vm.adminPrograms = resolvedAdminPrograms;
        vm.productPackages = resolvedProductPackages;
        vm.autocomplete = resolvedLocation.location.streetAddress + ", " + resolvedLocation.location.city + " " + resolvedLocation.location.state + " ";
        vm.hasCheckIn = dealerHasCheckin;
        vm.isSystemAdmin = permissions.isSysAdmin();
        vm.canPauseObfuscation = vm.isSystemAdmin;
        vm.isDataObfuscationPaused = false;
        vm.pauseToggleBusy = false;
        vm.showMFAToggle = vm.isSystemAdmin;
       
        _.forEach(vm.currentLocation.assignedRoles, (role) => {
            if (defunctRoles.includes(role.name.toLowerCase())) {
                role.isHidden = true;
            } else {
                role.isHidden = false;
            }

            if (role.name.toLowerCase() === SYSTEM_ENUMS.permissionTypes.payments.toLowerCase()  && !vm.currentLocation.paymentsConfigured) {
                role.isDisabled = true;
            } else {
                role.isDisabled = false;
            }
        });

        vm.switchClicked = function(role) {
            if (role.isDisabled) {
                $timeout(() => {
                    role.assigned = false;
                }, 1);
            } else {
                role.assigned = !role.assigned;
                role.showWhenDisabled = role.name.toLowerCase() !== SYSTEM_ENUMS.permissionTypes.authorizations.toLowerCase();  
            }
        };

        vm.placesOptions = {
            startLat: vm.currentLocation.location.lat,
            startLng: vm.currentLocation.location.lng  
        };

        if (vm.currentLocation.goLiveDate) {
            vm.currentLocation.goLiveDate = moment(vm.currentLocation.goLiveDate).format('MM/DD/YYYY');
        }

        vm.currentLocation.migrateUsersToSolidDate = vm.currentLocation.migrateUsersToSolidDate ? moment(vm.currentLocation.migrateUsersToSolidDate) : null;
        
        // pre-validate address and name
        $timeout(() => { 
            $scope.$broadcast(revalidate, 'locationName'); 
            $scope.$broadcast(revalidate, 'gplaces');
            vm.isLoading = false;
        }, 1);
       
        
        vm.updateLocation = function () {
            if (!vm.currentLocation.brandingType) {
                vm.currentLocation.brandingType = vm.systemEnums.dealerBranding.autoDealer;
            }

            if (dealerCurrentTwilio !== vm.currentLocation.twilioNumber) {
                modalService.showYesNo('Changing SMS Number', 
                                       'Are you sure you want to change the dealer\'s number?', 
                                       'Cancel', 
                                       'Yes', 
                                       false)
                            .then((response) => {
                                if (response === true) {
                                    locationService.updateLocation(vm.currentLocation).then((response) => {
                                        eventAlertService.createAlert('Location Data Successfully Updated.');
                                    });
                                }
                            });
            } else {
                locationService.updateLocation(vm.currentLocation).then((response) => {
                    eventAlertService.createAlert('Location Data Successfully Updated.');
                    $rootScope.$broadcast('locationUpdated');
                });
            }
        };

        vm.updateTimezone = function () {
            locationService.getTimezoneName(vm.currentLocation.timeZoneId).then((response) => {
                vm.currentLocation.timezoneName = response;
            });
        };

        vm.validation = {
            acceptableTimeZones: _.map(vm.timeZones).join(),
            acceptableStatuses: _.map(vm.statuses, 'value').join(),
            acceptableAdminPrograms: _.map(vm.adminPrograms, 'id').join(),
            phone: function (fieldValue) {
                fieldValue = fieldValue.replace(/\D/g, '');

                return {isValid: fieldValue.length === 10, message: 'A valid phone number is required.'};
            },
            url: function (url) {
                if (url.indexOf('?') >= 0)
                    return {isValid: false, message: 'Please remove everything after "?"'};

                let regexp = /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;

                return {isValid: regexp.test(url), message: 'Must be a valid url.'};
            },
            tollFree: function (numberStr) {
                let regexp = /^(\+?1)?(8(00|33|44|55|66|77|88)[2-9]\d{6})$/;

                return regexp.text(numberStr);
            }
        };

        vm.placeUpdated = function (formattedAddress) {
            vm.currentLocation.location = formattedAddress.location;

            $log.debug('vm.currentLocation', vm.currentLocation);

            if (vm.currentLocation.location && vm.currentLocation.location.lat && vm.currentLocation.location.lng) {
                locationService.hasDuplicateAddress(vm.currentLocation.location)
                    .then((result) => {
                        vm.hasDuplicateAddress = !result.isValid;
                    });

                locationService.getTimezone(vm.currentLocation.location.lat, vm.currentLocation.location.lng)
                    .then((timezoneDetail) => {
                        vm.currentLocation.timeZoneId = timezoneDetail.timeZoneId;
                        vm.currentLocation.timezoneName = timezoneDetail.timeZoneFullName;
                    });
            }
        };  

        vm.updateSMSPhone = function() {
                locationService.hasDuplicateSMSPhone(vm.currentLocation.twilioNumber, vm.dealerId)
                .then((result) => {
                vm.hasDuplicateSMSPhone = !result.isValid;
                });
            
        };

        vm.updateSMSPhone();

        vm.canOpenDealerConfig = function () {
            return vm.isSystemAdmin && !!vm.currentLocation.id;
        };

        vm.openDealerConfig = function () {
            locationService.getLocationTripTypeInstances(vm.currentLocation.id).then((tripTypes) => {
                let modalInstance = $uibModal.open({
                    templateUrl: 'app/areas/location/views/dealer-config-modal.view.html',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'lg',
                    controller: 'DealerConfigModalController as vm',
                    windowClass: 'top-modal',
                    resolve: {
                        resolvedDealerId: function () { return vm.currentLocation.id; },
                        resolvedTripTypes: function () { return tripTypes; }
                    }
                });

                modalInstance.result.then((dealerConfigData) => {
                    if (dealerConfigData) {
                        eventAlertService.createAlert('Dealer config updated successfully!');
                    }
                });
            }).catch(() => {
                eventAlertService.error('Unable to load trip types for dealer config.');
            });
        };
        
        vm.loadDataObfuscationPause = function () {
            if (!vm.canPauseObfuscation) {
                return;
            }

            locationService.getDataObfuscationPause(vm.dealerId)
                .then((response) => {
                    vm.isDataObfuscationPaused = response.isPaused;
                });
        };

        vm.toggleDataObfuscationPause = function () {
            if (!vm.canPauseObfuscation || vm.pauseToggleBusy) {
                return;
            }

            vm.pauseToggleBusy = true;
            const nextState = vm.isDataObfuscationPaused;

            locationService.setDataObfuscationPause(vm.dealerId, nextState)
                .then(() => {
                    const message = nextState ? 'Data deletion/obfuscation paused for this dealer.' : 'Data deletion/obfuscation resumed for this dealer.';

                    eventAlertService.createAlert(message);
                })
                .catch(() => {
                    vm.isDataObfuscationPaused = !nextState;
                })
                .finally(() => {
                    vm.pauseToggleBusy = false;
                });
        };

        vm.loadDataObfuscationPause();

        vm.nameUpdated = function () {
            if (vm.currentLocation.name) {
                locationService.hasDuplicateName(vm.currentLocation.name)
                    .then((result) => {
                        vm.hasDuplicateName = !result.isValid;
                    });
            }
        };

        vm.updateSms = function () {
            modalService.showYesNo('Changing SMS Number', 
                                   'You are about to change the dealer\'s messaging number.  Customers will not be able to message the dealer using the old number.  Are you sure you want to do this?', 
                                   'Cancel', 
                                   'Yes', 
                                   false)
                        .then((response) => {
                            if (response === true) {
                                locationService.get800Numbers()
                                    .then((newNums) => {
                                        if (!_.includes(newNums, vm.currentLocation.twilioNumber)) {
                                            newNums.push(vm.currentLocation.twilioNumber);
                                        }

                                        vm.twilioNumbers = newNums;
                                        vm.show800Numbers = true;
                                    }); 
                            }
                        });
        };

        vm.openCopyTripTypesModal = function () {
            modalService.closeTopModal();

            let modal = $uibModal.open({
                templateUrl: 'app/areas/location/views/modals/copy-trip-types-modal.view.html',
                controller: 'CopyTripTypesModalController',
                controllerAs: 'vm',
                size: '60-percent',
                windowClass: 'aside-centered top-modal min-height-px-400',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    currentLocation: function() {
                        return vm.currentLocation;
                    },
                    currentLocationTripTypes: function() {
                        return vm.dealerTripTypes;
                    }
                }
            });

            return modal.result;
        };
    }
})();

(function () {
    'use strict';

    LocationTabDriversController.$inject = ["$transition$", "$filter", "$state", "permissions", "locationService", "resolvedLocation", "resolvedDealerDrivers", "resolvedDriverCompanies", "resolvedDriverPrograms", "eventAlertService", "modalService", "SYSTEM_ENUMS", "dealerHasCheckin", "resolvedDealerTripTypes", "driverService", "rcUtilService"];
    angular
        .module('redcap.location')
        .controller('LocationTabDriversController', LocationTabDriversController);

    function LocationTabDriversController($transition$, $filter, $state, permissions, locationService, resolvedLocation, resolvedDealerDrivers, resolvedDriverCompanies, 
        resolvedDriverPrograms, eventAlertService, modalService, SYSTEM_ENUMS, dealerHasCheckin, resolvedDealerTripTypes, driverService, rcUtilService) {

        let vm = this;
        let existingCompanyIds = resolvedLocation.driverCompanyIds;
        let dnsCompany; 
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.isAdmin = permissions.isSysAdminOrRedCapAdmin();
        
        function filterDrivers () {
            if (vm.isOnlyDealerAdmin) {
                vm.dealerDrivers = $filter('filter')(vm.allDealerDrivers, {companyName: 'Internal'}, true);
            } else {
                vm.dealerDrivers = vm.allDealerDrivers;
            }
        }

        vm.driverCompanies = resolvedDriverCompanies;
        dnsCompany = _.find(vm.driverCompanies, (c) => {
            return c.type === SYSTEM_ENUMS.driverCompanyType.dns;
        });

        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.allDealerDrivers = resolvedDealerDrivers;
        filterDrivers();
        vm.dealerId = $transition$.params().locationId;
        vm.enableSubmit = false;
        vm.driverPrograms = resolvedDriverPrograms;
        vm.currentLocation = resolvedLocation;
        vm.hasDNS = _.some(vm.currentLocation.driverCompanyIds, (c) => { return c === dnsCompany.id; });
       
        vm.preferredToggleChanged = function(driver) {
            if (driver.isPreferred)
                driver.isBlocked = false;   
        };

        vm.blockedToggleChanged = function(driver) {
            if (driver.isBlocked)
                driver.isPreferred = false;   
        };

        vm.showSpecialColumns = function () {
            return vm.hasDNS && !vm.isOnlyDealerAdmin;
        };

        vm.isDNSDriver = function (driver) {
            return driver.companyName === dnsCompany.name;
        };

        vm.getSwitchTitle = function (driver, switchName) {
            return driver.isDedicated ? 'Not applicable to dedicated drivers.' : 'Enable/Disable ' + switchName;
        };

        vm.saveChanges = function() {
            let hadDnsBefore = _.some(existingCompanyIds, (c) => { return c === dnsCompany.id; });
            let hasDnsNow = _.some(vm.currentLocation.driverCompanyIds, (c) => { return c === dnsCompany.id; });
            let dnsModalMessage = null;
            
            if (hadDnsBefore && !hasDnsNow) {
                dnsModalMessage = 'Removing DNS from this field will immediately remove this location from drivers with overlapping service areas and prevent this location from offering trips to DNS drivers.  This will not affect trips that are already assigned to DNS drivers.  Are you sure you want to do this?';
            } else if (!hadDnsBefore && hasDnsNow) {
                dnsModalMessage = 'Adding DNS to this field will immediately add this location to drivers with overlapping service areas and allow this location to offer trips to DNS drivers.  Are you sure you want to do this?';
            }

            if (dnsModalMessage) {
                modalService.showYesNo('Confirm Change to DNS', 
                dnsModalMessage,
                'No', 
                'Yes', 
                false)
                .then((response) => {
                    if (response === true) {
                        updateDealerCompanies();
                    }
                });
            } else {
                updateDealerCompanies();
            }
            
            updateDriverPrograms();

            let preferredDriverIds = _.filter(vm.allDealerDrivers, 'isPreferred').map((driver) => { return driver.driverId; }); 

            locationService.setPreferredDrivers(preferredDriverIds, vm.dealerId)
                .then((result) => {
                    eventAlertService.createAlert('Preferred drivers updated');
                });

            let  blockedDriverIds = _.filter(vm.allDealerDrivers, 'isBlocked').map((driver) => { return driver.driverId; });    

            locationService.setBlockedDrivers(blockedDriverIds, vm.dealerId)
                .then((result) => {
                    eventAlertService.createAlert('Blocked drivers updated');
                });
        };

        function updateDealerCompanies() {
            vm.hasDNS = _.some(vm.currentLocation.driverCompanyIds, (c) => { return c === dnsCompany.id; });
            locationService.updateDriverCompanies(vm.dealerId, vm.currentLocation.driverCompanyIds)
            .then((result) => {
                eventAlertService.createAlert('Companies updated');
                existingCompanyIds = _.clone(vm.currentLocation.driverCompanyIds);
                locationService.getDrivers(vm.dealerId).then((dealerDrivers) => {
                    vm.allDealerDrivers = dealerDrivers;
                    filterDrivers();
                });
            });
        }

        function updateDriverPrograms() {
            locationService.updateDriverPrograms(vm.dealerId, vm.currentLocation.driverProgramIds)
            .then((result) => {
                eventAlertService.createAlert('Programs updated');
            });
        }

        vm.moveActiveDrivers = () => {
            const getActiveAccounts = () => vm.dealerDrivers;
            const moveAccounts = (accountIds, newLocationId, currentLocationId) => driverService.moveDriversBetweenDealers(accountIds, newLocationId, currentLocationId);
            
            rcUtilService.moveAccountsBetweenDealers(modalService, getActiveAccounts, moveAccounts, vm.currentLocation.id, $state, 'tab-drivers', 'Driver', locationService);
        };
    }    
})();

(function () {
    'use strict';

    LocationTabDepartmentsController.$inject = ["$transition$", "$scope", "$q", "$timeout", "$state", "$location", "$filter", "SYSTEM_ENUMS", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", "resolvedDMSData", "resolvedServiceAdvisors", "resolvedTripType", "resolvedLocationDepartments", "modalService", "tripTypeService", "locationService", "ValidationService", "eventAlertService", "constraintService", "timeUtilService", "appointmentUtilService", "localStorageService", "dealerHasCheckin", "resolvedDealerTripTypes", "resolvedLocation"];
    angular
        .module('redcap.location')
        .controller('LocationTabDepartmentsController', LocationTabDepartmentsController);

    function LocationTabDepartmentsController($transition$, $scope, $q, $timeout, $state, $location, $filter, 
            SYSTEM_ENUMS, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE, resolvedDMSData,
            resolvedServiceAdvisors, resolvedTripType, resolvedLocationDepartments,
            modalService, tripTypeService, locationService, ValidationService, eventAlertService, constraintService, timeUtilService, appointmentUtilService, localStorageService, dealerHasCheckin, resolvedDealerTripTypes, resolvedLocation) {
        
        let vm = this;
        let myValidation = new ValidationService();
        let referrer;
        let params = localStorageService.get('lastManageDeptParams');
       
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;

        if ($transition$.params().referrer) {
            localStorageService.set('lastManageDeptReferrer', $transition$.params().referrer);
            referrer = $transition$.params().referrer;
        } else {
            referrer = localStorageService.get('lastManageDeptReferrer');
        }

        vm.myUniqueId = appointmentUtilService.getUniqueDOMID();
        vm.dmsData = resolvedDMSData;
        vm.dmsProviderTypes = SYSTEM_ENUMS.dmsSystemEnum;
        vm.showDisabledDepartments = false;
        vm.preloadedDepartments = resolvedLocationDepartments;
        vm.constraintDefinitionType = APPOINTMENT_CONSTRAINT_DEFINITION_TYPE;
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;
        vm.currentTripType = resolvedTripType;
        vm.specificConfigs = null;

        if (vm.currentTripType) {
            vm.specificConfigs = vm.currentTripType.tripTypeSpecificConfigs;
        }

        vm.locationId = $transition$.params().locationId;
        vm.departmentDealerHours;
        vm.departmentId = $transition$.params().advDeptId;
        vm.allAdvisorsForDealer = resolvedServiceAdvisors;
        vm.availableAdvisors = [];
        vm.assignedAdvisors = [];
        vm.dmsServiceShops = [];
        vm.loadingDmsServiceShops = false;
        vm.hasDmsDepartments = false;

        // Model to hold UI selected advisors
        vm.advisorsToMove = [];
        vm.departments = [];
        vm.departments.unshift({
            id: null,
            name: 'New Department...',
            isDisabled: false
        });

        vm.currentDepartment = {};
        vm.businessClosedConstraints = [];

        vm.close = function () {
            let path = $location.path();

            if (path.indexOf('/locations') > -1) {
                $state.go('location-list');
            } else {
                $state.go(referrer, params, {reload: false});
            }
        };

        vm.loadDmsServiceShops = function (locationId, departmentId) {
            if (vm.dmsData.dmsSystem !== vm.dmsProviderTypes.Tekion) {
                vm.dmsServiceShops = [];
                vm.hasDmsDepartments = false;
                vm.loadingDmsServiceShops = false;
                vm.dmsServiceShops = null;

                return;
            }

            if (vm.loadingDmsServiceShops) return;

            vm.dmsServiceShops = [];
            vm.loadingDmsServiceShops = true;

            locationService.getLocationDmsDepartments(locationId).then((result) => {
                if (result && result.length) {
                    vm.dmsServiceShops = result;
                    vm.hasDmsDepartments = true;

                    if (vm.currentDepartment) {
                        let deptMatch = result.find((shop) => shop.dealerDepartmentId === departmentId);

                        if (deptMatch) {
                            vm.currentDepartment.dmsServiceShopId = deptMatch.dmsServiceShopId;
                        }
                    }
                } else {
                    vm.hasDmsDepartments = false;
                }
            }).finally(() => {
                vm.loadingDmsServiceShops = false;
            });
        };
        
        vm.loadDepartment = function () {
            if (vm.selectedDepartment) {
                if (vm.selectedDepartment.id === null) {
                    // New Department, clear out the fields
                    vm.departmentId = null;
                    vm.currentDepartment = {
                        schedule: vm.daysOfWeek.map(day => ({day, isClosed: false, startTime: null, endTime: null}))
                    };
                    vm.businessClosedConstraints = [];
                    setUpAvailableAndAssignedAdvisorLists();
                } else {
                    vm.loadingDepartment = true;
                    locationService.getLocationDepartment(vm.locationId, vm.selectedDepartment.id).
                        then((result) => {
                            vm.departmentId = result.id;
                            vm.currentDepartment = result;
                            
                            if (!vm.currentDepartment.schedule || vm.currentDepartment.schedule.length === 0) {
                                vm.currentDepartment.schedule = vm.daysOfWeek.map(day => ({
                                    day,
                                    isClosed: vm.currentDepartment['isClosed' + day] || false,
                                    startTime: vm.currentDepartment['startTime' + day] || null,
                                    endTime: vm.currentDepartment['endTime' + day] || null
                                }));
                            }

                            setUpAvailableAndAssignedAdvisorLists(result.advisors);
                            constraintService.getConstraintsByType(vm.locationId, result.id, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.businessClosed).then((result) => {
                                vm.businessClosedConstraints = result;
                                vm.loadingDepartment = false;
                            });
                        });
                }

                vm.loadDmsServiceShops(vm.locationId, vm.selectedDepartment.id);
            }
        };

        function postProcessDepartments () {

            let newDepartment = vm.departments.find((o) => { return o.name === 'New Department...'; });

            if (!newDepartment) {
                vm.departments.unshift({
                    id: null,
                    name: 'New Department...',
                    isDisabled: false
                });
            }

            if (vm.departmentId > 0) {
                vm.selectedDepartment = vm.departments.find((o) => { return o.id === parseInt(vm.departmentId); });
            } 

            if (vm.specificConfigs) {
                vm.loadDefaultDepartment();
            }

            if (vm.departmentId) {
                vm.loadDepartment();
            }
        }

        vm.loadDepartments = function (forceRefresh) {
            if (forceRefresh) {
                vm.preloadedDepartments = null;
            }

            if (vm.preloadedDepartments) {
                vm.departments = vm.preloadedDepartments;
                postProcessDepartments();
            } else {
                locationService.getLocationDepartments(vm.locationId).then((result) => {
                    vm.departments = result;
                    postProcessDepartments();
                });
            }
        };

        vm.loadServiceAdvisors = function () {
            vm.loadingServiceAdvisors = true;
            locationService.getServiceAdvisors(vm.locationId, null, true, true).then((result) => {
                vm.allAdvisorsForDealer = result;
                setUpAvailableAndAssignedAdvisorLists();
                vm.loadDepartments();
                vm.loadingServiceAdvisors = false;
            });
        };

        vm.loadDefaultDepartment = function () {
            if (vm.specificConfigs.ApptConsumerDepartmentId && 
                vm.specificConfigs.ApptConsumerDepartmentId.value) {
                vm.defaultDepartment = $filter('filter')(vm.departments, {id: parseInt(vm.specificConfigs.ApptConsumerDepartmentId.value)}, true)[0];
            }
        };

        vm.setDefaultDepartment = function (departmentId) {
            vm.specificConfigs.ApptConsumerDepartmentId.value = departmentId;
            tripTypeService.updateTripType(vm.currentTripType).then((response) => {
            });
            
        };

        function setUpAvailableAndAssignedAdvisorLists(advisorsToAssign) {
            let originalList = _.clone(vm.allAdvisorsForDealer);

            vm.availableAdvisors = originalList;
            vm.assignedAdvisors = [];

            vm.availableAdvisors.forEach(advisor => {
                advisor.inMultipleDepts = isInMultipleDepartments(advisor.departmentIds, false);
            });

            if (!advisorsToAssign) {
                advisorsToAssign = [];
            }
            
            filterAvailableAndAssignedAdvisorLists(advisorsToAssign);
        }

        function filterAvailableAndAssignedAdvisorLists(advisorsToAssign) {
            // Move the selected items from one list to the other
            let index;

            advisorsToAssign.forEach((advisor) => {
                index = vm.availableAdvisors.findIndex((o) => { return o.id === advisor.id; });

                if (index > -1) {
                    // Move advisor to the department list
                    vm.assignedAdvisors.push(vm.availableAdvisors.splice(index, 1)[0]);

                    vm.assignedAdvisors.forEach(advisor => {
                        advisor.inMultipleDepts = isInMultipleDepartments(advisor.departmentIds, true);
                    });
                    
                    return; // continue
                }

                index = vm.assignedAdvisors.findIndex((o) => { return o.id === advisor.id; });
                
                if (index > -1) {
                    // Move advisor to the available advisor list
                    vm.availableAdvisors.push(vm.assignedAdvisors.splice(index, 1)[0]);

                    vm.availableAdvisors.forEach(advisor => {
                        advisor.inMultipleDepts = isInMultipleDepartments(advisor.departmentIds, false);
                    });
                    
                    return; // continue
                }
            });
        }

        if (vm.locationId) {
            if (vm.allAdvisorsForDealer) {
                vm.loadDepartments();
            } else {
                vm.loadServiceAdvisors();
            }
        }

        vm.departmentChanged = function () {
            vm.loadDepartment();
        };

        vm.selectAdvisor = function () {
            filterAvailableAndAssignedAdvisorLists(vm.advisorsToMove);
        };

        vm.shortDaysOfWeek = timeUtilService.shortDays;
        vm.daysOfWeek = timeUtilService.days;
        vm.appointmentDurations = [];
        vm.hoursInDay = timeUtilService.hourIntervalsInDay;

        for (let increment = 5; increment <= 90; increment += 5) {
            let hour = Math.floor(increment / 60);
            let minute = hour > 0 ? increment % 60 : increment;

            vm.appointmentDurations.push({
                label: increment,
                value: (hour < 10 ? '0' + hour.toString() : hour.toString()) + ':' + (minute < 10 ? '0' + minute.toString() : minute.toString()) + ':00'
            });
        }

        vm.closedChanged = function (daySchedule) {
            if (daySchedule.isClosed === true) {
                daySchedule.startTime = null;
                daySchedule.endTime = null;
            }

            vm.revalidateForm();
        };

        vm.getDepartmentDealerHours = function () {
            if (!vm.departmentDealerHours || vm.departmentDealerHours.dealerId !== vm.locationId) {
                return locationService.getLocationDepartmentDealerHours(vm.locationId).then((result) => {
                    vm.departmentDealerHours = result;
                    vm.departmentDealerHours.dealerId = vm.locationId;

                    return result;
                });
            } else {
                // We've already retrieved the list, no need to call again
                let deferred = $q.defer();

                deferred.resolve(vm.departmentDealerHours);

                return deferred.promise;
            }
        };

        $scope.$watchGroup(['vm.currentDepartment', 'vm.currentDepartment.useDealerHours'], (newValues, oldValues) => {
            if (vm.currentDepartment.useDealerHours) {
                vm.getDepartmentDealerHours().then((result) => {
                    if (result.schedule && result.schedule.length > 0) {
                        vm.currentDepartment.schedule = result.schedule.map(s => ({...s}));
                    } else {
                        vm.currentDepartment.schedule = vm.daysOfWeek.map(day => ({
                            day,
                            isClosed: result['isClosed' + day] || false,
                            startTime: result['startTime' + day] || null,
                            endTime: result['endTime' + day] || null
                        }));
                    }

                    vm.revalidateForm();
                });
            } else {
                vm.revalidateForm();
            }
        });

        vm.revalidateForm = function () {
            $timeout(() => {
                if ($scope.inputForm.$validationSummary) {
                    myValidation.checkFormValidity($scope.inputForm);
                }
            });
        };


        vm.revalidateOpenTime = function (day) {
            $timeout(() => {
                $scope.$broadcast('angularValidation.revalidate', vm.myUniqueId + '-starttime-' + day);
            }, 500);
        };

        
        vm.revalidateCloseTime = function (day) {
            $timeout(() => {
                $scope.$broadcast('angularValidation.revalidate', vm.myUniqueId + '-endtime-' + day);
            }, 500);
        };

        vm.validation = {
            valStartEndTime: function (daySchedule, otherField) {
                
                if (daySchedule.isClosed) {
                    return true;
                }

                return timeUtilService.validateEndTimeGreaterThanStartTime(daySchedule.startTime, daySchedule.endTime, otherField);
            },
            valDepartmentName: function () {
                let errorMessage = {isValid: false, message: 'Department name already exists.'};
                let successMessage = {isValid: true, message: ' '};

                if (!vm.currentDepartment.name || vm.currentDepartment.name === "") {
                    return successMessage;
                }
                
                let foundDepartments = $filter('filter')(vm.departments, {name: vm.currentDepartment.name}, true);

                if (foundDepartments && foundDepartments.length > 1) {
                    return errorMessage;
                } else if (foundDepartments && foundDepartments.length === 1) {
                    if (foundDepartments[0].id === vm.currentDepartment.id) {
                        return successMessage;
                    } else {
                        return errorMessage;
                    }
                } else {
                    return successMessage;
                }
            }
        };

        vm.isDefaultDepartmentWithoutAdvisors = function () {
            if (!vm.defaultDepartment) return false;

            if (vm.currentDepartment.id === vm.defaultDepartment.id && vm.assignedAdvisors.length === 0) return true;

            return false;
        };

        vm.constraintToString = constraintService.constraintToString;

        vm.updateDepartment = function () {
            vm.currentDepartment.dealerId = vm.locationId;
            let refreshList = !vm.currentDepartment.id;
            let isFirstDepartment = vm.departments.length === 1;

            vm.currentDepartment.advisors = [];
            vm.assignedAdvisors.forEach((adv) => {
                vm.currentDepartment.advisors.push(adv);
            });

            if (vm.currentDepartment.isDisabled) {
                vm.showDisabledDepartments = true;
                vm.currentDepartment.showInConsumer = false;
            }

            vm.currentDepartment.schedule.forEach(daySchedule => {
                vm.currentDepartment['isClosed' + daySchedule.day] = daySchedule.isClosed;
                vm.currentDepartment['startTime' + daySchedule.day] = daySchedule.startTime;
                vm.currentDepartment['endTime' + daySchedule.day] = daySchedule.endTime;
            });
 
            locationService.updateLocationDepartment(vm.locationId, vm.currentDepartment).then((result) => {
                vm.departmentId = result.id;
                vm.currentDepartment = result;
                
                // Update isDisabled flag in the departments list
                let idx = vm.departments.findIndex(dept => dept.id === vm.departmentId);

                if (idx !== -1) {
                    vm.departments[idx] = result;
                }
                
                if (isFirstDepartment) {
                    vm.setDefaultDepartment(result.id);
                }

                vm.loadDepartments(refreshList);
                vm.loadServiceAdvisors();
                
                vm.selectedDepartment.name = result.name;

                if (vm.businessClosedConstraints.length > 0) {
                    vm.businessClosedConstraints.forEach((o) => {
                        o.departmentId = result.id;
                    });
                    constraintService.saveConstraints(vm.locationId, vm.businessClosedConstraints).then(() => {
                        vm.loadDepartment();
                        eventAlertService.createAlert('Department Successfully Updated.');
                    });
                } else {
                    eventAlertService.createAlert('Department Successfully Updated.');
                }
            });
        };

        vm.addBusinessClosedConstraint = function (constraint) {
            constraint.dealerId = vm.locationId;
            constraint.departmentId = vm.currentDepartment.id;

            if (!constraint.uid) {
                constraint.uid = appointmentUtilService.generateUID(constraint.id, constraint.id);
            }

            vm.businessClosedConstraints.push(constraint);
            
            if ($scope.inputForm.$valid) {
                vm.updateDepartment();
            }
        };

        vm.deleteBusinessClosedConstraint = function (item) {
            let confirm = modalService.showYesNo('Please Confirm', 'Are you sure you want to delete the selected day?', 'No', 'Yes');
            
            confirm.then((confirmed) => {
                if (confirmed) {
                    let index = vm.businessClosedConstraints.indexOf(item);
                    
                    vm.businessClosedConstraints[index].isDeleted = true;
                    
                    if (!(vm.businessClosedConstraints[index].id > 0)) {
                        // We never saved this item, so we can completely remove it
                        vm.businessClosedConstraints.splice(index, 1);
                        
                    } else {
                        if ($scope.inputForm.$valid) {
                            vm.updateDepartment();
                        }
                    }
                }
            });
        };

        function isInMultipleDepartments (departments, isAssigned) {
            if (!departments) return false;
            if (isAssigned) return departments.length > 1 || departments.some(department => department !== vm.departmentId);
            if (!isAssigned) return departments.length > 2 || departments.length > 1 && !departments.some(department => department === vm.departmentId);
        }
    }
})();

(function () {
    'use strict';

    locationTabCapacityController.$inject = ["$transition$", "locationService", "webworkerService", "locationCapacities", "permissions", "eventAlertService", "resolvedLocationList", "resolvedDealerCapacityGroups", "modalService", "dealerHasCheckin", "resolvedDealerTripTypes", "resolvedLocation"];
    angular
        .module('redcap.location')
        .controller('LocationTabCapacityController', locationTabCapacityController);

    function locationTabCapacityController($transition$, locationService, webworkerService, locationCapacities, 
            permissions, eventAlertService, resolvedLocationList, resolvedDealerCapacityGroups, modalService, dealerHasCheckin, resolvedDealerTripTypes, resolvedLocation) {
                
        let vm = this;
        let displayLimit = 25;
        let locationId = $transition$.params().locationId;
       
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.tripTypeGroupings = [{name: 'Service', id: 0}, {name: 'Sales', id: 1}, {name: 'Mobile Service', id: 2}];
        vm.tripCapacities = locationCapacities;
        vm.locations = resolvedLocationList;
        vm.dealerCapacityGroups = [];

        // Populate groups
        if (resolvedDealerCapacityGroups && resolvedDealerCapacityGroups.length > 0) {
            resolvedDealerCapacityGroups.forEach((capacityGroup) => {
                vm.dealerCapacityGroups.push(capacityGroup);
            });
        }

        vm.locationsFilter = function (locationName) {
            if (locationName.length >= 1) {
                webworkerService.filter(resolvedLocationList, locationName, false, 'name').then((result) => {
                    vm.locations = result;
                    vm.locationDisplayLimit = result.length;
                });
            } else {
                vm.locationDisplayLimit = displayLimit;
            }
        };

        vm.locationSelected = function (item, tripTypeGroupId) {
            if (!vm.dealerCapacityGroups) {
                vm.dealerCapacityGroups = [];
            }

            // Only add to list if not already there
            if (!vm.dealerCapacityGroups.some((g) => { return g.dealerId === item.id && g.tripTypeGroup === tripTypeGroupId; })) {
                vm.dealerCapacityGroups.push({dealerId: item.id, name: item.name, tripTypeGroup: tripTypeGroupId});
            }

            vm.selectedLocation[tripTypeGroupId] = null;
        };

        vm.removeLocation = function (itemToRemove) {
            modalService.showYesNo('Confirm Remove', 'Are you sure you want to remove this location? If yes, be sure to manually update the location’s capacity settings.', 'No', 'Yes', true).then((confirmed) => {
                if (confirmed) {
                    // Remove item
                    _.remove(vm.dealerCapacityGroups, (item) => { return item.dealerId === itemToRemove.dealerId && item.tripTypeGroup === itemToRemove.tripTypeGroup; });
                }
            });
        };

        vm.validateNumber = function (valueToValidate) {
            if (!valueToValidate) return {isValid: true};
            if (String(valueToValidate).replace(/[^0-9]*/, '') === String(valueToValidate)) return {isValid: true};

            return {isValid: false, message: 'Invalid Number'};
        };

        vm.updateCapacities = function () {
            let capacitiesArray = [];

            vm.tripCapacities.forEach((tripCapacityGroup) => {
                tripCapacityGroup.capacities.forEach((tripTypeCapacity) => {
                        capacitiesArray.push(tripTypeCapacity);
                    });
                }
            );

            locationService.updateCapacities(locationId, capacitiesArray).then((response) => {
                let capacityGroupsArray = [];

                vm.dealerCapacityGroups.forEach((group) => { capacityGroupsArray.push({dealerId: group.dealerId, tripTypeGroup: group.tripTypeGroup}); });

                locationService.updateCapacityGroups(locationId, capacityGroupsArray).then((response) => {
                    eventAlertService.createAlert('Capacity And Groups Settings Successfully Updated.');
                });
            });
        };
    }
})();

(function () {
    'use strict';

    LocationTabBookingController.$inject = ["$scope", "$transition$", "$filter", "$timeout", "$q", "rcUtilService", "tripTypeService", "modalService", "locationService", "appointmentService", "SYSTEM_ENUMS", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE", "resolvedTripType", "resolvedLocationTransportationTypes", "resolvedAssociatedConfigs", "resolvedServiceAreaTypes", "tripProfileLookups", "vehicleMakesModels", "eventAlertService", "resolvedEmployees", "ValidationService", "constraintService", "rideProviderService", "chargeService", "resolvedVenues", "resolvedDepartments", "userRolesService", "dealerHasCheckin", "resolvedLocation", "resolvedDealerTripTypes"];
    angular
        .module('redcap.location')
        .controller('LocationTabBookingController', LocationTabBookingController);

    function LocationTabBookingController($scope, $transition$, $filter, $timeout, $q, rcUtilService, tripTypeService, modalService, locationService,
        appointmentService, SYSTEM_ENUMS, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE, resolvedTripType, resolvedLocationTransportationTypes, resolvedAssociatedConfigs,
        resolvedServiceAreaTypes, tripProfileLookups, vehicleMakesModels, eventAlertService, resolvedEmployees,
        ValidationService, constraintService, rideProviderService, chargeService, resolvedVenues, resolvedDepartments, userRolesService, dealerHasCheckin, resolvedLocation, resolvedDealerTripTypes) {

        let vm = this;
        let myValidation = new ValidationService({
                validateOnEmpty: true
            });
        let lyftMaxHours = 168;
        let maxInviteHours = 36;
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.consumer_appt_booking_exp = CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE;
        vm.associatedConfigs = resolvedAssociatedConfigs;
        vm.transportationTypes = resolvedLocationTransportationTypes;
        vm.tripTypeId = $transition$.params().tripTypeId;
        vm.locationId = $transition$.params().locationId;
        vm.bookingWindows = SYSTEM_ENUMS.bookingWindows;
        vm.resolvedAllEmployees = resolvedEmployees;
        vm.systemTripType = SYSTEM_ENUMS.systemTripType;
        vm.currentTripType = resolvedTripType;
        vm.commonConfigs = vm.currentTripType.tripTypeCommonConfigs;
      
        function setDefaultServiceAdvisorId() {
            if (vm.specificConfigs.DefaultServiceAdvisorId) {
                vm.specificConfigs.DefaultServiceAdvisorId.value = parseInt(vm.specificConfigs.DefaultServiceAdvisorId.value) || null;

                if (!_.some(vm.resolvedEmployees, (employee) => {
                    return parseInt(vm.specificConfigs.DefaultServiceAdvisorId.value) === parseInt(employee.id);
                })) {
                    vm.specificConfigs.DefaultServiceAdvisorId.value = null;
                }
            }
        }

        function init() {
            const deferred = $q.defer();

            vm.resolvedEmployees = [];
            const promises = [];

            _.each(vm.resolvedAllEmployees, (x, idx) => {
                const promise = userRolesService.getUserRoles(x.identityUserId).then((roles) => {
                    const hasProgramAdminRole = _.find(roles, (role) => { return role.name === SYSTEM_ENUMS.roleNames.programAdmin; }).assigned;
                    const hasSystemAdminRole = _.find(roles, (role) => { return role.name === SYSTEM_ENUMS.roleNames.systemAdmin; }).assigned;
                    const hasRedCapAdminRole = _.find(roles, (role) => { return role.name === SYSTEM_ENUMS.roleNames.redCapAdmin; }).assigned;
                    const hasProgramAdminFullAccess = (hasSystemAdminRole || hasRedCapAdminRole) && hasProgramAdminRole;
                    const isValid = (hasProgramAdminFullAccess || !hasProgramAdminRole);

                    if (isValid) {
                        vm.resolvedEmployees.push(x);
                    }
                });

                promises.push(promise);
            });
          

            $q.all(promises).then(() => {
                vm.resolvedEmployees = _.orderBy(vm.resolvedEmployees, [user => user.firstName.toLowerCase(), user => user.lastName.toLowerCase()], ['asc', 'asc']);
                setDefaultServiceAdvisorId();
                deferred.resolve();
            });

            return deferred.promise;
        }

        if (vm.currentTripType.tripTypeSpecificConfigs.ApptSchedulingIncrements) {
            vm.currentTripType.tripTypeSpecificConfigs.ApptSchedulingIncrements.value = parseInt(vm.currentTripType.tripTypeSpecificConfigs.ApptSchedulingIncrements.value);
        }

        vm.specificConfigs = vm.currentTripType.tripTypeSpecificConfigs;

        vm.sodTripOpCode = null;

        if (vm.specificConfigs.SodTripOpCode && vm.specificConfigs.SodTripOpCode.value) {
            vm.sodTripOpCode = {
                id: vm.specificConfigs.SodTripOpCode.value,
                opCode: vm.specificConfigs.SodTripOpCode.value,
                text: vm.specificConfigs.SodTripOpCode.value
            };
        }

        vm.dealerVenues = resolvedVenues;
        vm.dealerDepartments = resolvedDepartments;

        vm.orderedDepartments = _.orderBy(vm.dealerDepartments, ['rank'], ['asc']);

        vm.noLoanerStopValues = {
            START_AT_DEALER: 0,
            START_AT_CUSTOMER: 1,
            DISABLE_START_AT_CUSTOMER: 2
        };

        vm.noLoanerFirstStopOptions = [
            {value: vm.noLoanerStopValues.START_AT_DEALER, text: 'Start at Dealer Default'},
            {value: vm.noLoanerStopValues.START_AT_CUSTOMER, text: 'Start at Customer Default'},
            {value: vm.noLoanerStopValues.DISABLE_START_AT_CUSTOMER, text: 'Disable Start at Customer'}
        ];

        vm.constSystemTripType = $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: vm.currentTripType.systemTripTypeId}, true)[0];

        if (vm.constSystemTripType.value !== vm.systemTripType.appointment) {
            chargeService.getConfigTypes().then((configTypes) => {
                // create objects that work well with dropdowns (text/value)
                vm.chargeConfigTypes = Object.keys(configTypes).map((k) => { return {value: configTypes[k].id, text: configTypes[k].name}; });
            });
        }

        vm.loadingSelectedDepartment = true;

        // timeout required for race condition w/ the select drop down options populating
        setTimeout(() => {
            if (vm.specificConfigs.DefaultNoLoanerStartAtDealer || vm.specificConfigs.DisableStartAtCustomer) {
                if (vm.specificConfigs.DisableStartAtCustomer && vm.specificConfigs.DisableStartAtCustomer.value === true) {
                    vm.selectedFirstOption = vm.noLoanerStopValues.DISABLE_START_AT_CUSTOMER;
                } else if (vm.specificConfigs.DefaultNoLoanerStartAtDealer.value === true) {
                    vm.selectedFirstOption = vm.noLoanerStopValues.START_AT_DEALER;
                } else {
                    vm.selectedFirstOption = vm.noLoanerStopValues.START_AT_CUSTOMER;
                }
            }
            
            if (vm.specificConfigs.ApptConsumerDepartmentId && vm.specificConfigs.ApptConsumerDepartmentId.value) {
                vm.selectedDepartment = $filter('filter')(vm.dealerDepartments, {id: parseInt(vm.specificConfigs.ApptConsumerDepartmentId.value)}, true)[0];
            }

            vm.loadingSelectedDepartment = false;
        }, 1);


        formatConfigValues();

        function formatConfigValues() {
            if (vm.specificConfigs.LandingPageSecondChoiceURL && vm.specificConfigs.LandingPageSecondChoiceURL.value === 'None') {
                vm.specificConfigs.LandingPageSecondChoiceURL.value = '';
            }

            $timeout(() => {
                $scope.$broadcast('angularValidation.revalidate', 'LandingPageSecondChoiceURL');
            }, 1);
    
            if (vm.commonConfigs.ChargePercentThreshold) {
                vm.commonConfigs.ChargePercentThreshold.value = parseInt(vm.commonConfigs.ChargePercentThreshold.value);
            }
    
            if (vm.commonConfigs.MonthlySpendingCap) {
                vm.commonConfigs.MonthlySpendingCap.value = parseFloat(vm.commonConfigs.MonthlySpendingCap.value);
            }
    
            formatBillingSettings(true);
        }

        init().then(() => {
            if (vm.commonConfigs.SurveyRecipientList && vm.commonConfigs.SurveyRecipientList.value) {
                let filteredResults = _.filter(vm.resolvedEmployees, (e) => {
                    return _.includes(vm.commonConfigs.SurveyRecipientList.value.split(','), e.id.toString());
                });

                if (filteredResults) {
                    vm.EmailSurveyListMap = filteredResults.map((value) => { return value.id; });
                }
            }
        });

        vm.lyftHours = [];
        vm.inviteHours = [];

        vm.currentTripType.active = vm.currentTripType.status === 1;
        vm.fieldsDisabled = !vm.currentTripType.status;

        vm.tripProfileLookups = tripProfileLookups;
        vm.vehicleMakesModels = vehicleMakesModels;

        // OpCode search support (similar to lineitems controller)
        let _pageSize = 25;

        vm.bookingOpCode = {};

        vm.formatForSelection = function (item) {
            return item.opCode;
        };

        vm.formatForDropdown = function (item) {
            return item.opCode + ': ' + item.dashboardDescription;
        };

        vm.opCodeSearchQuery = {
            type: 'GET',
            dataType: 'json',
            data: function (parameters) {
                let query = {
                    search: parameters.term,
                    dealerId: vm.locationId,
                    page: parameters.page - 1,
                    pageSize: _pageSize
                };

                return query;
            },
            transport: function (params, success, failure) {
                let data = params.data;

                return locationService.searchLocationOpCodes(vm.locationId, null, data.search, data.page, data.pageSize).then(success, failure);
            },
            delay: 250,
            processResults: function (data) {
                return {
                    results: data,
                    pagination: {
                        more: data.length === _pageSize
                    }
                };
            }
        };

        vm.opCodeSearchSelected = function (selectedItem) {
            if (!vm.specificConfigs.SodTripOpCode) {
                vm.specificConfigs.SodTripOpCode = {value: '', defaultValue: ''};
            }

            if (selectedItem?.length === 1) {
                vm.specificConfigs.SodTripOpCode.value = selectedItem[0]?.opCode;
            } else {
                vm.specificConfigs.SodTripOpCode.value = null;
            }
        };

        let maxTime = lyftMaxHours > maxInviteHours ? lyftMaxHours : maxInviteHours;
        let counter = 0;

        for (counter = 0; counter <= maxTime; counter++) {
            if (counter <= lyftMaxHours) {
                vm.lyftHours[counter] = counter;
            }

            if (counter <= maxInviteHours) {
                vm.inviteHours[counter] = counter;
            }
        }

        vm.showConvertedHours = function (hoursToConvert) {
            if (hoursToConvert === undefined || hoursToConvert.value === 0)
                return 'No Expiration';

            let days = parseInt(hoursToConvert.value / 24);
            let hours = hoursToConvert.value % 24;
                
            if (days > 0) {
                return days + ' day' + (days === 1 ? ' ' : 's ') + hours + ' hour' + (hours === 1 ? '' : 's');
            } else {
                return hours + ' hour' + (hours === 1 ? '' : 's');
            }
        };

        vm.showConvertedMinutes = function (minutesToConvert) {
            if (minutesToConvert === undefined || minutesToConvert.value === 0)
                return 'No Expiration';
           
            let hoursToConvert = {
                value: minutesToConvert.value / 60
            };

            return vm.showConvertedHours(hoursToConvert);
        };

        vm.displayDriverTimeWithCustomer = function () {
            return vm.commonConfigs.CustomerLocationMinutes !== undefined &&
                   vm.currentTripType.systemTripTypeId !== 16 && vm.constSystemTripType.value !== vm.systemTripType.mobileGarage;
        };

        vm.displayServiceArea = function (inputForm) {
            // If we have a lyft config, use that option for displaying
            if (vm.constSystemTripType.lyft !== undefined) {
                return vm.constSystemTripType.lyft.supportsServiceArea;
            } else {
                return vm.commonConfigs.ServiceAreaData !== undefined &&
                       vm.constSystemTripType.value !== vm.systemTripType.dealerTrade &&
                       vm.constSystemTripType.value !== vm.systemTripType.inventoryTransport;
            }
        };

        vm.displayInsurance = function () {
            // If we have a lyft config, use that option for displaying
            if (vm.constSystemTripType.lyft !== undefined) {
                return vm.constSystemTripType.lyft.supportsInsurance;
            } else {
                return vm.specificConfigs.SuppressInsuranceFields !== undefined &&
                       vm.constSystemTripType.value !== vm.systemTripType.dealerTrade &&
                       vm.constSystemTripType.value !== vm.systemTripType.inventoryTransport;
            }
        };

        vm.displayDriversLicense = function () {
            // If we have a lyft config, use that option for displaying
            if (vm.constSystemTripType.lyft !== undefined) {
                return vm.constSystemTripType.lyft.supportsDriversLicense;
            } else {
                return vm.specificConfigs.SuppressDriversLicenseFields !== undefined &&
                       vm.constSystemTripType.value !== vm.systemTripType.dealerTrade &&
                       vm.constSystemTripType.value !== vm.systemTripType.inventoryTransport;
            }
        };

        vm.manageVenues = function() {
            let location = $scope.$parent.vm.currentLocation.location;
            let locId = vm.locationId;
            let placesOptions = {
                    watchEnter: true,
                    country: 'us,can',
                    startLat: location.lat,
                    startLng: location.lng
                };
            let modal = modalService.showManageLocations(locId, vm.dealerVenues, placesOptions, null, null, true, location);

            modal.then((results) => {
                if (!results.cancelled && (results.locationsToDelete.length > 0 || results.newLocations.length > 0)) {
                    locationService.updateVenues(locId, results.newLocations, results.locationsToDelete).then((response) => {
                        locationService.getVenues(locId, true).then((venues) => {
                            vm.dealerVenues = venues;
                            eventAlertService.createAlert('Venue list was successfully updated');
                        });
                    }, (errorResponse) => {
                        eventAlertService.createAlert('An error occurred while trying to update the Venues list');
                        console.log('Error saving venues', errorResponse);
                    });
                }
            });
        };

        vm.departmentSelected = function () {
            if (vm.selectedDepartment) {
                vm.specificConfigs.ApptConsumerDepartmentId.value = vm.selectedDepartment.id;
            } else {
                vm.specificConfigs.ApptConsumerDepartmentId.value = null;
            }
        };

        vm.suppressConfigsSwitch = {
            // suppress configs actually display in switches the opposite of value
            driversLicenseFields: vm.specificConfigs.SuppressDriversLicenseFields ? !vm.specificConfigs.SuppressDriversLicenseFields.value : null,
            insuranceFields: vm.specificConfigs.SuppressInsuranceFields ? !vm.specificConfigs.SuppressInsuranceFields.value : null,
            creditCardFields: vm.specificConfigs.SuppressCreditCardFields ? !vm.specificConfigs.SuppressCreditCardFields.value : null,
            vehicleVIN: vm.specificConfigs.SuppressVehicleVIN ? !vm.specificConfigs.SuppressVehicleVIN.value : null,
            chooseLoanerOptions: vm.specificConfigs.SuppressChooseLoanerOptions ? !vm.specificConfigs.SuppressChooseLoanerOptions.value : null
        };

        // create objects that work well with dropdowns (text/value)
        vm.serviceAreaTypes = Object.keys(resolvedServiceAreaTypes).map((k) => { return {value: parseInt(k), text: resolvedServiceAreaTypes[k]}; });
        

        // Lyft Configs
        if (vm.constSystemTripType.lyft !== undefined) {
            if (vm.constSystemTripType.lyft.supportsRideTypes) {
                rideProviderService.getRideTypes().then((rideTypes) => {
                    vm.providerRideTypes = rideTypes;
                    vm.lyftRideSettings = [];
                    let disallowedTypes = [];

                    if (vm.specificConfigs.DisallowedRideProviderRides && vm.specificConfigs.DisallowedRideProviderRides.value) {
                        disallowedTypes = vm.specificConfigs.DisallowedRideProviderRides.value.split(',');
                    }

                    _.each(vm.providerRideTypes, (rideType) => {
                        vm.lyftRideSettings.push({
                            value: !_.some(disallowedTypes, (t) => { return t == rideType.value; }),
                            id: rideType.value,
                            name: rideType.name
                        });
                    });
                });
            }
        }

        vm.validation = {
            acceptableBookingWindows: _.map(vm.bookingWindows, 'value').join(),
            acceptableChargeProfiles: _.map(vm.tripProfileLookups, 'sdProfileId').join(),
            acceptableMinutes: _.map(vm.inviteHours, (hours) => { return hours * 60; }).join(),
            phone: function (fieldValue) {
                return rcUtilService.isValidPhone(fieldValue);
            },
            url: function (url) {
                if (url === "") {
                    return {isValid: true, message: ''};
                } 

                let regexp = /^(https:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;

                return {isValid: regexp.test(url), message: 'Must be a valid url beginning with https.'};
            },
            valConstraints: constraintService.validateLimitPerHourPerDayConstraints,
            // the ValidationService plugin cannot handle object literal notation in parameters of the inline custom validation function in the HTML
            filterPredicate: function (departmentId) {
                return {
                    departmentId: departmentId
                };
            }
        };

        vm.revalidateForm = function () {
            if (!vm.locationId) {
                return;
            }

            $timeout(() => {
                $scope.inputForm.$invalid = !myValidation.checkFormValidity($scope.inputForm);
                $scope.inputForm.$valid = !$scope.inputForm.$invalid;
            });
        };

        vm.isEmpty = function (value) {
            return rcUtilService.isEmpty(value);
        };

        vm.updateBooking = function (valid) {
            if (!valid) { return $q.when(); }
            
            return vm.updateTripType().then(() => {
                if (vm.constSystemTripType.value === vm.systemTripType.appointment) {
                    return locationService.updateLocationTransportationTypes(vm.locationId, vm.transportationTypes)
                        .then(() => {
                                appointmentService.updateBookingConfigs(vm.locationId, vm.associatedConfigs).then(() => {
                                if (vm.dealerDepartments) {
                                    locationService.updateLocationDepartments(vm.locationId, vm.dealerDepartments).then((deptResult) => {
                                        eventAlertService.createAlert('Booking data successfully updated.');

                                        return $q.when(true);
                                    });
                                } else {
                                    eventAlertService.createAlert('Booking data successfully updated.');

                                    return $q.when(true);
                                }
                            });
                        });
                }

                return $q.when(true);
            }).then((response) => {
                if (response === true) {
                    eventAlertService.createAlert('Booking data successfully updated.');
                }
            });
        };

        vm.updateTripType = function () {
            let clearUrlAfterSave = false;

            if (vm.constSystemTripType.lyft?.supportsRideTypes) {
                let disallowedRideTypes = [];

                _.each(vm.lyftRideSettings, (rideSetting) => {
                    if (rideSetting.value === false) {
                        disallowedRideTypes.push(rideSetting.id);
                    }
                });

                vm.specificConfigs.DisallowedRideProviderRides = {value: disallowedRideTypes.join(','), defaultValue: ''};
            }

            if (vm.specificConfigs.SuppressDriversLicenseFields) {
                vm.specificConfigs.SuppressDriversLicenseFields.value = !vm.suppressConfigsSwitch.driversLicenseFields;
            }

            if (vm.specificConfigs.SuppressInsuranceFields) {
                vm.specificConfigs.SuppressInsuranceFields.value = !vm.suppressConfigsSwitch.insuranceFields;
            }

            if (vm.specificConfigs.SuppressCreditCardField) {
                vm.specificConfigs.SuppressCreditCardFields.value = !vm.suppressConfigsSwitch.creditCardFields;
            }

            if (vm.specificConfigs.SuppressVehicleVIN) {
                vm.specificConfigs.SuppressVehicleVIN.value = !vm.suppressConfigsSwitch.vehicleVIN;
            }

            if (vm.specificConfigs.SuppressChooseLoanerOptions) {
                vm.specificConfigs.SuppressChooseLoanerOptions.value = !vm.suppressConfigsSwitch.chooseLoanerOptions;
            }

            // make sure this is set to the default if it's not enabled and we didn't show the input box
            if (vm.specificConfigs.LandingPageSecondChoiceURL && vm.specificConfigs.LandingPageSecondChoiceURL.value === '' && vm.specificConfigs.EnableConsumerLandingPage.value === false) {
                vm.specificConfigs.LandingPageSecondChoiceURL.value = 'None';
                clearUrlAfterSave = true;
            }

            if (vm.EmailSurveyListMap) {
                vm.commonConfigs.SurveyRecipientList.value = vm.EmailSurveyListMap.join();
            }

            if (vm.selectedFirstOption !== undefined) {
                if (vm.selectedFirstOption === vm.noLoanerStopValues.DISABLE_START_AT_CUSTOMER) {
                    vm.specificConfigs.DisableStartAtCustomer == null ? vm.specificConfigs.DisableStartAtCustomer = {value: true} : vm.specificConfigs.DisableStartAtCustomer.value = true;
                } else {
                    vm.specificConfigs.DisableStartAtCustomer == null ? vm.specificConfigs.DisableStartAtCustomer = {value: false} : vm.specificConfigs.DisableStartAtCustomer.value = false;

                    if (vm.selectedFirstOption === vm.noLoanerStopValues.START_AT_DEALER) {
                        vm.specificConfigs.DefaultNoLoanerStartAtDealer.value = true;
                    } else {
                        vm.specificConfigs.DefaultNoLoanerStartAtDealer.value = false;
                    }
                }
            }

            formatBillingSettings();
        
            if (vm.constSystemTripType.value === vm.systemTripType.appointment) {
                delete vm.specificConfigs.DefaultServiceAdvisorId;
            }

            return tripTypeService.updateTripType(vm.currentTripType).then((response) => {
                if (clearUrlAfterSave) {
                    vm.specificConfigs.LandingPageSecondChoiceURL.value = '';
                }
            });
        };

        vm.isMobileGarage = function () {
            if (vm.currentTripType.systemTripTypeId === SYSTEM_ENUMS.systemTripType.mobileGarage)  {

                return true;
            }

            return false;
        };

        function formatBillingSettings(isOnInit) { 
            let zero = 0;    

            if (vm.commonConfigs.ServiceFeePercent) {
                let serviceFeePercent = parseFloat(vm.commonConfigs.ServiceFeePercent.value);

                vm.commonConfigs.ServiceFeePercent.value = _.isFinite(serviceFeePercent) ? serviceFeePercent.toFixed(2) : zero.toFixed(2);
            }

            if (vm.commonConfigs.DriverPayRatePerMinute) {
                let driverPayRate = parseFloat(vm.commonConfigs.DriverPayRatePerMinute.value);

                vm.commonConfigs.DriverPayRatePerMinute.value = _.isNumber(driverPayRate) ? driverPayRate : zero.toFixed(2);

                if (isOnInit) {
                    // When initializing, we convert the value to a "per hour" amount for more readability
                    vm.DriverPayRatePerHour = (vm.commonConfigs.DriverPayRatePerMinute.value * 60).toFixed(2);                    
                } else {
                    // When saving, we convert back to a high-precision "per minute" amount
                    vm.commonConfigs.DriverPayRatePerMinute.value = (vm.DriverPayRatePerHour / 60).toFixed(6);
                }                
            }
    
            if (vm.commonConfigs.DriverPayMinimum) {
                let driverMinimum = parseFloat(vm.commonConfigs.DriverPayMinimum.value);

                vm.commonConfigs.DriverPayMinimum.value = _.isNumber(driverMinimum) ? driverMinimum.toFixed(2) : zero.toFixed(2);
            }
    
            if (vm.commonConfigs.CancelFee) {
                let cancelFee = parseFloat(vm.commonConfigs.CancelFee.value);

                vm.commonConfigs.CancelFee.value = _.isNumber(cancelFee) && !_.isNaN(cancelFee) ? cancelFee.toFixed(2) : zero.toFixed(2);
            } else {
                vm.commonConfigs.CancelFee.value = zero.toFixed(2);
            }     
            
         
            if (vm.commonConfigs.CustomerChargeRatePerMinute) {
                let chargeRate = parseFloat(vm.commonConfigs.CustomerChargeRatePerMinute.value);

                vm.commonConfigs.CustomerChargeRatePerMinute.value = _.isNumber(chargeRate) ? chargeRate : 0;

                if (isOnInit) {
                    // When initializing, we convert the value to a "per hour" amount for more readability
                    vm.CustomerChargeRatePerHour = (vm.commonConfigs.CustomerChargeRatePerMinute.value * 60).toFixed(2);
                } else {
                    // When saving, we convert back to a high-precision "per minute" amount
                    vm.commonConfigs.CustomerChargeRatePerMinute.value = (vm.CustomerChargeRatePerHour / 60).toFixed(6);                    
                }
            }
    
            if (vm.commonConfigs.CustomerChargeMinimum) {
                let chargeMinimum = parseFloat(vm.commonConfigs.CustomerChargeMinimum.value);

                vm.commonConfigs.CustomerChargeMinimum.value = _.isFinite(chargeMinimum) ? chargeMinimum.toFixed(2) : 0;
            }
        }

        $scope.$watch('vm.currentTripType.active', (newVal) => {
            vm.fieldsDisabled = !newVal;
            vm.currentTripType.status = newVal ? 1 : 0;
        });
    }
})();

(function () {
    'use strict';

    LocationTabAPIController.$inject = ["locationService", "webworkerService", "resolvedLocation", "resolvedPartnerPrograms", "eventAlertService", "dealerHasCheckin", "resolvedDealerTripTypes"];
    angular
        .module('redcap.location')
        .controller('LocationTabAPIController', LocationTabAPIController);

    function LocationTabAPIController(locationService, webworkerService, resolvedLocation, resolvedPartnerPrograms, eventAlertService, dealerHasCheckin, resolvedDealerTripTypes) {
        let vm = this;
        let displayLimit = 50;
        
        vm.hasCheckIn = dealerHasCheckin;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.currentProgram = null;
        vm.programDisplayLimit = displayLimit;
        vm.programs = _.cloneDeep(resolvedPartnerPrograms);
        vm.selectedPrograms = createProgramNames();

        vm.programsFilter = function (programName) {
            if (programName.length >= 1) {
                webworkerService.filter(resolvedPartnerPrograms, programName, false, 'text')
                    .then ((result) => {
                        vm.programs = result;
                    });
            } else {
                vm.programs = _.cloneDeep(resolvedPartnerPrograms);
            }   
            
        };

        vm.resetFields = function () {
            vm.currentLocation = null;
            vm.selectedPrograms = createProgramNames();
        };

        vm.programSelected = function (item, model) {
            vm.selectedPrograms.push(item);
            _.remove(vm.programs, (program) => { return program.value === item.value; });
            vm.currentProgram = null;
        };

        vm.removeProgram = function (programId) {
            _.remove(vm.selectedPrograms, (program) => {
                return program.value === programId;
            });

            let program = _.find(resolvedPartnerPrograms, {value: programId});

            vm.programs.push(program);
        };

        vm.updateLocation = function () {
            vm.currentLocation.partnerProgramIds = _.map(vm.selectedPrograms, 'value');

            locationService.updateLocation(vm.currentLocation).then((response) => {
                eventAlertService.createAlert('Location Data Successfully Updated.');
            });
        };

        function createProgramNames() {
            let programs = [];

            _.forEach(resolvedLocation.partnerProgramIds, (prg) => {
                let program = _.find(resolvedPartnerPrograms, {value: prg});

                programs.push(program);
                _.remove(vm.programs, (p) => { return p.value === program.value; });
            });

            return programs;
        }
    }
})();
(function () {
    'use strict';

    LocationTabAdvisorsController.$inject = ["$transition$", "$scope", "$q", "$timeout", "$state", "$location", "SYSTEM_ENUMS", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", "resolvedServiceAdvisors", "currentState", "permissions", "profileService", "ctrlOptions", "appointmentUtilService", "locationService", "ValidationService", "modalService", "eventAlertService", "constraintService", "timeUtilService", "localStorageService", "resolvedDMSData", "resolvedHasCheckIn", "resolvedDealerTripTypes", "resolvedLocation"];
    angular
        .module('redcap.location')
        .controller('LocationTabAdvisorsController', LocationTabAdvisorsController);

    function LocationTabAdvisorsController($transition$, $scope, $q, $timeout, $state, $location, 
            SYSTEM_ENUMS, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE, resolvedServiceAdvisors, currentState, permissions,
            profileService, ctrlOptions, appointmentUtilService, locationService, ValidationService, 
            modalService, eventAlertService, constraintService, timeUtilService, localStorageService, resolvedDMSData, resolvedHasCheckIn, resolvedDealerTripTypes, resolvedLocation) {

        let vm = this;
        let myValidation = new ValidationService();
        let referrer;
        let params = localStorageService.get('lastManageAdvisorsParams');
        let parent_vm = $scope.$parent.vm;
        let configId;

        vm.myUniqueId = appointmentUtilService.getUniqueDOMID();
        vm.dmsEntry = resolvedDMSData;
        vm.dmsSystemEnum = SYSTEM_ENUMS.dmsSystemEnum;
        vm.hasCheckIn = resolvedHasCheckIn;
        vm.dealerTripTypes = resolvedDealerTripTypes;
        vm.currentLocation = resolvedLocation;
        vm.shortDaysOfWeek = timeUtilService.shortDays;

        if ($transition$.params().referrer) {
            localStorageService.set('lastManageAdvisorsReferrer', $transition$.params().referrer);
            referrer = $transition$.params().referrer;
        } else {
            referrer = localStorageService.get('lastManageAdvisorsReferrer');
        }

        vm.constraintDefinitionType = APPOINTMENT_CONSTRAINT_DEFINITION_TYPE;

        if ($transition$.params().configId) {
            configId = $transition$.params().configId;
        }

        vm.hasDeptAccess = permissions.hasRole(SYSTEM_ENUMS.roleNames.departmentAdmin) || permissions.isAdminLevelUser();
        vm.locationId = $transition$.params().locationId;
        vm.resolvedLocationList = null;
        vm.ctrlOptions = ctrlOptions;

        vm.isManageMySchedule = vm.ctrlOptions.individualScheduleView;
       
        if (!vm.locationId) {
            vm.loadingLocations = true;
            locationService.getLocationsForDropDown(true, false, SYSTEM_ENUMS.permissionTypes.appointments, [SYSTEM_ENUMS.systemTripType.appointment], vm.isManageMySchedule).then((result) => {
                vm.resolvedLocationList = result;
                vm.loadingLocations = false;
            });
        } else {
            vm.selectedLocation = {
                id: vm.locationId
            };
        }

        if (vm.ctrlOptions.individualScheduleView) {
            // Populate the schedule page based on the profileService logged in identityuserid
            // this function does not always return a promise...
            $q.when(profileService.getUser()).then((response) => {
                vm.currentIdentityUserId = response.id;
            });
        }

        vm.departmentDealerHours;

        vm.advisors = resolvedServiceAdvisors;
        vm.daysOfWeek = timeUtilService.days;
        vm.hoursInDay = timeUtilService.hourIntervalsInDay;

        vm.selectedLocation = vm.selectedLocation || null;
        vm.selectedAdvisor = null;
        vm.currentAdvisor = null;
        vm.currentIdentityUserId = null;
        vm.isMappedAdvisor = true;

        vm.advisorOffConstraints = [];

        vm.selectedLocationChanged = function () {
            vm.selectedAdvisor = null;
            vm.getDepartmentAdvisorHoursError = false;

            if (!vm.selectedLocation) {
                vm.locationId = null;

                return;
            }

            vm.locationId = vm.selectedLocation.id;

            if (vm.ctrlOptions.adminView) {
                return locationService.getLocationDepartmentAssignedAdvisors(vm.locationId).then((response) => {
                    vm.advisors = response;
                });
            } else {
                const dmsPromise = locationService.getLocationDMS(vm.locationId).then((response) => {
                    vm.dmsEntry = response;
                });

                const deptPromise = locationService.getLocationDepartments(vm.locationId, false).then((response) => {
                    vm.allDepartments = response;
                });

                const advisorPromise = locationService.getCurrentUserServiceAdvisorRecord(vm.locationId, vm.currentIdentityUserId, true, true).then((response) => {
                    if (response && response.length) {
                        vm.selectedAdvisor = response[0];

                        if (vm.selectedAdvisor.departmentIds.length === 0) {
                            vm.getDepartmentAdvisorHoursError = true;
                        }
                    } else {
                        vm.getDepartmentAdvisorHoursError = true;
                        vm.selectedAdvisor = null;
                    }
                });

                const promises = [dmsPromise, deptPromise, advisorPromise];

                Promise.all(promises).then(() => {  
                    vm.selectedAdvisorChanged();
                });
            }
        };

        vm.gotoDept = function (deptId) {
            if (!vm.hasDeptAccess) return;

            if (parent_vm) {
                parent_vm.tabs[1].active = true;

                if (deptId)
                    $state.go('tab-departments', {advDeptId: deptId});
                else
                    $state.go('tab-departments');
            } else {
                $state.go('location-departments-' + currentState, {
                    advLocId: vm.locationId,
                    advDeptId: deptId
                });
            }
        };

        vm.selectedAdvisorChanged = function () {
            if (!vm.selectedAdvisor) {
                vm.currentAdvisor = null;

                return;
            } 
            
            if (vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.None) {
                vm.isMappedAdvisor = vm.selectedAdvisor.employeeNumber !== null && vm.selectedAdvisor.employeeNumber !== vm.selectedAdvisor.identityUserId;
            }          

            function getHours() {
                if (vm.selectedAdvisor.departmentIds && vm.selectedAdvisor.departmentIds.length > 0) {
                    vm.selectedAdvisor.departments = vm.departments.filter((r) => { return vm.selectedAdvisor.departmentIds.includes(r.id); });

                    if (vm.selectedAdvisor.departments && vm.selectedAdvisor.departments.length > 0) {
                        locationService.getLocationAdvisorHours(vm.locationId, vm.selectedAdvisor.id).then((response) => {
                            vm.currentAdvisor = response;
                            
                            if (vm.currentAdvisor.useDepartmentHours && vm.selectedAdvisor.departments.length === 1) {
                                vm.currentAdvisor.departmentId = vm.selectedAdvisor.departments[0].id;
                            }
                            
                            constraintService.getConstraintsByType(vm.locationId, vm.currentAdvisor.departmentId, vm.currentAdvisor.advisorId, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.advisorOff).then((response) => {
                                vm.advisorOffConstraints = response;
                            });

                            if ((vm.currentAdvisor && vm.currentAdvisor.departmentId > 0)) {
                                vm.currentAdvisor.useDepartmentHours = true;
                                vm.getDepartmentDealerHours().then((result) => {
                                    vm.currentAdvisor.schedule = buildScheduleFromDeptHours(result);
                                    vm.revalidateForm();
                                });
                            }
                        });
                    }
                }
            }

            // Apply scope changes
            if (vm.allDepartments) {
                addCustomToAdvisorHoursDropdown();
                getHours();
            } else {
                locationService.getLocationDepartments(vm.locationId, false).then((response) => {
                    vm.allDepartments = response;
                    addCustomToAdvisorHoursDropdown();
                    getHours();
                });
            }
        };

        function addCustomToAdvisorHoursDropdown() {
            // Add "Custom" to the dropdown of departments, so that users can create custom hours instead of hours for a specific department
            if (vm.allDepartments && vm.allDepartments.length > 0) {
                vm.departments = vm.allDepartments.filter((r) => { return vm.selectedAdvisor.departmentIds.includes(r.id); });
                let customDepartment = {
                    id: -99,
                    name: 'Custom'
                };

                vm.departments.push(customDepartment);
            }
        }

        vm.selectedDepartmentChanged = function () {
            if (!vm.currentAdvisor) return;
            
            const hasAnyHours = vm.currentAdvisor.schedule &&
                vm.currentAdvisor.schedule.some((s) => s.startTime || s.endTime);

            if (!hasAnyHours && !vm.currentAdvisor.departmentId) {
                vm.currentAdvisor.departmentId = vm.selectedAdvisor.departmentIds[0];
            }

            if ((vm.currentAdvisor && vm.currentAdvisor.departmentId > 0)) {
                vm.currentAdvisor.useDepartmentHours = true;
                vm.getDepartmentDealerHours().then((result) => {
                    vm.currentAdvisor.schedule = buildScheduleFromDeptHours(result);
                    vm.revalidateForm();
                });
            } else if (vm.currentAdvisor) { // Custom hours
                if (!vm.currentAdvisor.departmentId) {
                    const allEmpty = !vm.currentAdvisor.schedule ||
                        vm.currentAdvisor.schedule.every((s) => !s.isOff && !s.startTime && !s.endTime);

                    if (allEmpty) {
                        vm.currentAdvisor.departmentId = null;
                    }
                }

                vm.currentAdvisor.useDepartmentHours = false;
            }
        };

        vm.getDepartmentDealerHours = function () {
            if (!vm.departmentDealerHours || vm.departmentDealerHours.departmentId !== vm.currentAdvisor.departmentId) {
                return locationService.getLocationDepartmentDealerHours(vm.locationId, vm.currentAdvisor.departmentId).then((result) => {
                    vm.departmentDealerHours = result;
                    vm.departmentDealerHours.departmentId = vm.currentAdvisor.departmentId;
                    
                    return result;
                });
            } else {
                // We've already retrieved the list, no need to call again
                let deferred = $q.defer();
                
                deferred.resolve(vm.departmentDealerHours);
                
                return deferred.promise;
            }
        };

        vm.runStartEndTimeValidation = function(dayOfWeek) {
            let day = vm.daysOfWeek[dayOfWeek] || dayOfWeek;

            $timeout(() => {
                $scope.$broadcast('angularValidation.revalidate', vm.myUniqueId + '-starttime-' + day);
                $scope.$broadcast('angularValidation.revalidate', vm.myUniqueId + '-endtime-' + day);
            });
        };

        vm.closedChanged = function (daySchedule) {
            if (daySchedule.isOff === true) {
                daySchedule.startTime = null;
                daySchedule.endTime = null;
            }

            vm.runStartEndTimeValidation(daySchedule.dayOfWeek);
            vm.revalidateForm();
        };

        vm.revalidateForm = function () {
            $timeout(() => {
                if ($scope.inputForm && $scope.inputForm.$validationSummary) {
                    $scope.inputForm.$valid = myValidation.checkFormValidity($scope.inputForm);
                    $scope.inputForm.$invalid = !$scope.inputForm.$valid;
                }
            });
        };

        vm.validation = {
            valStartEndTime: function (daySchedule, otherField) {
                if (!vm.currentAdvisor) return true;

                if (daySchedule.isOff) {
                    return true;
                }

                return timeUtilService.validateEndTimeGreaterThanStartTime(daySchedule.startTime, daySchedule.endTime, otherField);
            }
        };

        vm.constraintToString = constraintService.constraintToString;

        vm.updateAdvisor = function () {

            // check if all schedule hours are valid, caused by bug in angular-validation
            // click vm.gotoDept(department.id), return to advisors tab, angular-validation doesn't check for null start/end times anymore
            if ($scope.inputForm.$valid) {
                (vm.currentAdvisor.schedule || []).forEach((daySchedule) => {
                    let validation = vm.validation.valStartEndTime(daySchedule, null);

                    if (!validation) {
                        $scope.inputForm.$valid = false;
                        $scope.inputForm.$invalid = true;

                        return;
                    }
                });
                if ($scope.inputForm.$invalid) return;
            }

            locationService.updateLocationDepartmentAdvisorHours(vm.locationId, vm.currentAdvisor).then((result) => {
                vm.currentAdvisor = result;

                if (vm.advisorOffConstraints.length > 0) {
                    constraintService.saveConstraints(vm.locationId, vm.advisorOffConstraints).then((result) => {
                        constraintService.getConstraintsByType(vm.locationId, vm.currentAdvisor.departmentId, vm.currentAdvisor.advisorId, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.advisorOff).then((response) => {
                            vm.advisorOffConstraints = response;
                            eventAlertService.createAlert('Advisor Schedule Updated.');
                        });
                    });
                } else {
                    eventAlertService.createAlert('Advisor Schedule Updated.');
                }
            });
        };

        vm.addAdvisorOffConstraint = function (constraint) {
            constraint.dealerId = vm.locationId;
            constraint.departmentId = vm.currentAdvisor.departmentId;
            constraint.advisorId = vm.currentAdvisor.advisorId;

            if (!constraint.uid) {
                constraint.uid = appointmentUtilService.generateUID(constraint.id, constraint.id);
            }

            vm.advisorOffConstraints.push(constraint);

            if ($scope.inputForm.$valid) {
                vm.updateAdvisor();
            }
        };

        vm.deleteAdvisorOffConstraint = function (item) {
            let confirm = modalService.showYesNo('Please Confirm', 'Are you sure you want to delete the selected day?', 'No', 'Yes');
            
            confirm.then((confirmed) => {
                if (confirmed) {
                    let index = vm.advisorOffConstraints.indexOf(item);
                    
                    vm.advisorOffConstraints[index].isDeleted = true;
                    
                    if (!(vm.advisorOffConstraints[index].id > 0)) {
                        // We never saved this item, so we can completely remove it
                        vm.advisorOffConstraints.splice(index, 1);
                        
                    } else {
                        if ($scope.inputForm.$valid) {
                            vm.updateAdvisor();
                        }
                    }
                }
            });
        };

        function buildScheduleFromDeptHours(deptHours) {

            return vm.daysOfWeek.map((day, index) => ({
                dayOfWeek: index,
                day,
                isOff: deptHours['isClosed' + day] || false,
                startTime: deptHours['startTime' + day] || null,
                endTime: deptHours['endTime' + day] || null
            }));
        }

        vm.close = function () {
            let path = $location.path();

            if (path.indexOf('/locations') > -1) {
                $state.go('location-list', {configId: configId});
            } else {
                $state.go(referrer, params, {reload: false});
            }
        };
        
    }
})();


(function () {
    'use strict';

    SystemSurveyManagementController.$inject = ["$state", "$log", "$transition$", "$location", "tripTypeService", "resolvedSurveys", "modalService", "rcLocalStorageService"];
    angular
        .module('redcap.location')
        .controller('SystemSurveyManagementController', SystemSurveyManagementController);

    function SystemSurveyManagementController($state, $log, $transition$, $location, tripTypeService, resolvedSurveys, modalService, rcLocalStorageService) {
        let vm = this;
        let referrer = null;
        let params = null;
        let configId = null;

        vm.surveys = resolvedSurveys || [];
        vm.selectedSurveyObj = null;
        vm.surveyQuestions = [];
        vm.dealerAssociations = [];
        vm.isLoading = false;
        vm.canDeactivate = false;
        vm.isDeactivated = false;      

        initReferrer();

        function initReferrer() {
            params = rcLocalStorageService.get('lastSurveyParams');

            if ($transition$.params().referrer) {
                rcLocalStorageService.set('lastSurveyParams', $transition$.params().referrer);
                referrer = $transition$.params().referrer;
            } else {
                referrer = rcLocalStorageService.get('lastSurveyParams');
            }

            if ($transition$.params().configId) {
                configId = $transition$.params().configId;
            }
        }

        function isDeactivated() {
            return !vm.selectedSurveyObj?.isActive;
        }

        vm.onSurveyChange = function () {
            if (!vm.selectedSurveyObj?.id) {
                vm.surveyQuestions = [];
                vm.dealerAssociations = [];
                vm.canDeactivate = false;
                vm.isDeactivated = false;
                vm.selectedSurveyObj = null;

                return;
            }

            vm.isLoading = true;

            const questionsPromise = tripTypeService.getSurveyQuestions(vm.selectedSurveyObj.id).then(result => {
                vm.surveyQuestions = Array.isArray(result) ? result : [];
            }).catch(error => {
                $log.error('Error loading survey questions:', error);
                vm.surveyQuestions = [];
            });

            const dealersPromise = tripTypeService.getDealersUsingSurvey(vm.selectedSurveyObj.id).then(dealers => {
                vm.dealerAssociations = dealers || [];
                vm.canDeactivate = vm.dealerAssociations.length === 0;

                if (vm.canDeactivate && vm.selectedSurveyObj) {
                    vm.isDeactivated = isDeactivated();
                }
            }).catch(error => {
                $log.error('Error loading dealers using survey:', error);
                vm.dealerAssociations = [];
                vm.canDeactivate = false;
            });

            Promise.all([questionsPromise, dealersPromise]).finally(() => {
                vm.isLoading = false;
            });
        };

        vm.toggleSurveyActive = function (deactivateRequest) {
            if (deactivateRequest === !vm.selectedSurveyObj.isActive) {
                return;
            }

            const title = deactivateRequest ? 'Confirm Deactivation' : 'Confirm Reactivation';
            const body = deactivateRequest ? 'Are you sure you want to deactivate this survey?' : 'Are you sure you want to activate this survey?';
            const confirmedMessage = deactivateRequest ? 'Deactivate' : 'Reactivate';

            modalService.showYesNo(title, body, 'Cancel', confirmedMessage, true).then(confirmed => {
                if (!confirmed) {
                    vm.isDeactivated = isDeactivated();

                    return;
                }

                vm.isLoading = true;
                let updateActiveStatus = !deactivateRequest;

                return tripTypeService.setSurveyActiveStatus(vm.selectedSurveyObj.id, updateActiveStatus).then(() => {
                    vm.selectedSurveyObj.isActive = updateActiveStatus;
                    let survey = vm.surveys.find(s => String(s.id) === String(vm.selectedSurveyObj.id));

                    if (survey) {
                        survey.isActive = updateActiveStatus;
                    }

                    vm.isDeactivated = isDeactivated();
                }).catch(error => {
                    vm.isDeactivated = isDeactivated();
                    let errorMessage = deactivateRequest ? 'Failed to deactivate survey. Please try again.' : 'Failed to reactivate survey. Please try again.';
                    let message = (error && (error.message || error.data)) || 'Unknown error';

                    modalService.showError(errorMessage, message);
                }).finally(() => {
                    vm.isLoading = false;
                });
            });
        };

        vm.close = function () {
            let path = $location.path();

            if (path.indexOf('/locations') > -1) {
                $state.go('location-list', {configId: configId});
            } else {
                $state.go(referrer, params, {reload: false});
            }
        };
    }
}());

(function () {
    'use strict';

    LocationListController.$inject = ["$scope", "$timeout", "rcLocalStorageService", "permissions", "locationService", "resolvedTimezones", "resolvedAdminConfigs", "SYSTEM_ENUMS"];
    angular
        .module('redcap.location')
        .controller('LocationListController', LocationListController);

    function LocationListController($scope, $timeout, rcLocalStorageService, permissions, locationService, resolvedTimezones, resolvedAdminConfigs, SYSTEM_ENUMS) {
        let vm = this;
        let displayLimit = 30;
        let page = 0;

        vm.showAdvancedSearch  = false;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.sortType = null;
        vm.sortAsc = null;
            
        vm.filteredLocations = [];
        vm.canShowMore = true;
        vm.adminPrograms = ['All programs'].concat(_.map(resolvedAdminConfigs, (config) => { return config.programName; }));
        vm.timezones = ['All timezones'].concat(resolvedTimezones);
        vm.countries = ['All countries'].concat(_.map(SYSTEM_ENUMS.supportedCountries, (countries) => { return countries.text; }));
        vm.statuses = ['All statuses', 'Active', 'QA', 'Install', 'Disabled'];

        let initialFilters = { 
            searchInput: [],
            selectedProgram: 'All programs',
            selectedStatus: 'All statuses',
            selectedTimezone: 'All timezones',
            selectedCountry: 'All countries'
        };

        let initialSort = {
            sortDirection: "asc",
            sortBy: null
        };

        let savedFilterKey = "locationListSavedFilterKey";
        let savedSortKey = "locationListSavedSortKey";
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};
        let existingSort = rcLocalStorageService.get(savedSortKey) || {};

        function init() {
            vm.filters = _.extend({}, initialFilters, existingFilters);
            vm.sort = _.extend({}, initialSort, existingSort);
        }

        init();

        vm.sorting = {
            status: 0,
            program: 1,
            name: 2,
            location: 3,
            oem: 4,
            dms: 5,
            timezone: 6,
            id: 10
        };

        vm.locationTokenChanged = function () {
            vm.filterChanged();
        };

        vm.filterChanged = function() {
            rcLocalStorageService.set(savedFilterKey, vm.filters);
            refreshSearch();
        };

        vm.toggleShowSearchOptions = function () {
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

            if (vm.showAdvancedSearch) {
                vm.runQuery();
            }

            vm.showAdvancedSearch  = !vm.showAdvancedSearch;
        };

        vm.applyBtnClicked = function () {
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            vm.runQuery();
        };

        $scope.$on('LocationService.changed', (event, data) => {
            refreshSearch();
        });

        vm.sortClicked = function (type) {
            if (vm.sort.sortBy !== type || vm.sort.sortDirection !== 'asc') {
                vm.sort.sortDirection = "asc";
            } else {
                vm.sort.sortDirection = "desc";
            }

            vm.sort.sortBy = type;
            refreshSearch();
        };

        function refreshSearch() {
            if (vm.isLoading)
                $timeout(refreshSearch, 100);

            page = 0;
            vm.filteredLocations = [];
            vm.canShowMore = true;
            vm.searchLocations();
        }

        vm.searchLocations = function() {
            if (vm.isLoading || !vm.filters)
                return;

            vm.isLoading = true;
            let filter = {
                query: vm.isOnlyDealerAdmin ? [] : _.map(vm.filters.searchInput, (item) => { return item.text; }),
                adminProgramName: vm.isOnlyDealerAdmin ? 'All programs' : vm.filters.selectedProgram,
                statusName: vm.isOnlyDealerAdmin ? 'All statuses' : vm.filters.selectedStatus,
                timezoneName: vm.isOnlyDealerAdmin ? 'All timezones' : vm.filters.selectedTimezone,
                countryName: vm.isOnlyDealerAdmin ? 'All countries' : vm.filters.selectedCountry,
                pageSize: displayLimit,
                page: page,
                sortType: vm.sort.sortBy,
                sortAsc: vm.sort.sortDirection === 'asc'
            };

            locationService.getPagedLocations(filter).then((locations) => {
                let filteredLocations = locations.results;

                setupLocations(filteredLocations);
                vm.filterMessage = createFilterMessage();
                vm.totalDealersCount = locations.totalReturnedResults;
                page++;
                vm.isLoading = false;
            }, (error) => {
                vm.isLoading = false;
            });
        };

        function createFilterMessage() {
            let message = '';

            vm.filterCount = 0;

            if (vm.filters.searchInput && vm.filters.searchInput.length > 0) {
                vm.filterCount++;
                message += '<i><b>Keyword</b>: ';
                message += vm.filters.searchInput.map((input) => { return input['text']; });
                message += '</i>&nbsp;&nbsp;';
            }

            if (vm.filters.selectedProgram.toUpperCase() !== 'ALL PROGRAMS') {
                vm.filterCount++;
                message += '<i><b>Program</b>: ' + vm.filters.selectedProgram + '</i>&nbsp;&nbsp;';
            }

            if (vm.filters.selectedStatus.toUpperCase() !== 'ALL STATUSES') {
                vm.filterCount++;
                message += '<i><b>Status</b>: ' + vm.filters.selectedStatus + '</i>&nbsp;&nbsp;';
            }

            if (vm.filters.selectedTimezone.toUpperCase() !== 'ALL TIMEZONES') {
                vm.filterCount++;
                message += '<i><b>Timezone</b>: ' + vm.filters.selectedTimezone + '</i>';
            }

            if (vm.filters.selectedCountry.toUpperCase() !== 'ALL COUNTRIES') {
                vm.filterCount++;
                message += '<i><b>Country</b>: ' + vm.filters.selectedCountry + '</i>';
            }

            if (message.length > 0) {
                message = 'Showing results for ' + message;
            }

            return message;
        }

        function setupLocations(locationList) {
            locationList.forEach((location) => {
                switch (location.status) {
                    case 1 :
                        location.statusText = 'Active';
                        location.statusLabel = 'label-success';
                        break;
                    case 2 :
                        location.statusText = 'QA';
                        location.statusLabel = 'label-info';
                        break;
                    case 3 :
                        location.statusText = 'Install';
                        location.statusLabel = 'label-warning';
                        break;
                    case 4 :
                        location.statusText = 'Disabled';
                        location.statusLabel = 'label-default';
                        break;
                    default:
                        location.statusText = 'unknown';
                        location.statusLabel = 'label-default';
                }
            });

            if (locationList.length === 0)
                vm.canShowMore = false;
            else
                vm.filteredLocations = vm.filteredLocations.concat(locationList);
            
        }

        vm.close = function () {
            // set the filters back because they didn't apply them.
            vm.filters = vm.filtersBeforeAdvancedSearch;
            vm.showAdvancedSearch = false;
        };

        
    }
})();

(function () {
    'use strict';

    LocationEditController.$inject = ["$transition$", "$state", "$rootScope", "$scope", "$filter", "permissions", "resolvedLocation", "resolvedDealerTripTypes", "SYSTEM_ENUMS", "modalService"];
    angular
        .module('redcap.location')
        .controller('LocationEditController', LocationEditController);

    function LocationEditController($transition$, $state, $rootScope, $scope, $filter, permissions, resolvedLocation, resolvedDealerTripTypes, SYSTEM_ENUMS, modalService) {
        let vm = this;
        let selectedTripType;
        let transitionParams = $transition$.params();
        let apptTabs = ["tab-departments", "tab-advisors", "tab-appointmentcapacity", "tab-lineitems"];
        
        vm.subMenuVisible = false;
        vm.subMenuWasClicked = false;
        vm.tabsData = '';
        vm.systemTripTypes = SYSTEM_ENUMS.systemTripType;

        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.tripTypes = '';
        vm.appointmentTripType = null;
        vm.tabs = '';
        vm.currentLocation = resolvedLocation;
        vm.locationId = _.toInteger(transitionParams.locationId);
        vm.tripTypeId = _.toInteger(transitionParams.tripTypeId);
        vm.productPermissionId = _.toInteger(transitionParams.productPermissionId);
        vm.productType = SYSTEM_ENUMS.productPermission;
        vm.tripTypes = resolvedDealerTripTypes; 
        
        vm.isAppointmentAdmin = permissions.isAppointmentAdmin();
        vm.isAdminLevelUser = permissions.isAdminLevelUser();
        vm.isDepartmentAdmin = permissions.hasRole(SYSTEM_ENUMS.roleNames.departmentAdmin);

        // required listener for form
        $scope.$on('form.locator', (event, formCtrl) => {
            vm.childScopeForm = formCtrl;
        });

        vm.initTripTypes = function () {
            vm.initTabContainers(vm.currentTripTypeName(), vm.tripTypeId, vm.productPermissionId);
        };

        vm.initTabContainers = function (tripTypeName, tripTypeId, productTypeId) {
            vm.tripTypeName = tripTypeName;
            vm.tripTypeId = _.toInteger(tripTypeId);
            selectedTripType = _.find(vm.tripTypes, {id: vm.tripTypeId});        
            
            const onGenericDealerSettings = vm.tripTypeId === 0 && !productTypeId;
            const appointmentsSelected = selectedTripType && selectedTripType.systemTripTypeId === SYSTEM_ENUMS.systemTripType.appointment;
            
            // When the page is refreshed the product for appoinmtents won't be in the url, so we have to use the trip type to 
            //  determine if appoinments is selected.  
            if (appointmentsSelected)
                productTypeId = vm.productType.appointments;

            switch (productTypeId) {
                case vm.productType.checkIn:
                    initCheckInTabs();
                    break;

                case vm.productType.messaging:
                    initMessagingTabs();
                    break;

                case vm.productType.appointments:
                    initAppointmentTabs();
                    break;

                case vm.productType.inspect:
                    initInspectTabs();
                    break;

                case vm.productType.loaner:
                    initLoanerTabs();
                    break;

                default:
                    if (onGenericDealerSettings) {
                        initDealerSettingTabs();
                    } else {
                        initTripTypeTabs();
                    }

                    break;
            }

            const currState = $state.name;
            
            vm.tabs.forEach((tab) => {
                tab.active = currState === tab.route;
            });
        };

        vm.tabChanged = function($event, tab) {   
            vm.subMenuClick(true);

            $event.preventDefault();
            $event.stopPropagation();

            const currentState = $state.name;            
            const currentTab = vm.tabs.find(t => t.route === currentState);
            const tabCanDetectChanges = $scope.$$listenerCount[SYSTEM_ENUMS.eventNames.locationTabCanChange] >= 1;

            if (tabCanDetectChanges) {
                $scope.$broadcast(SYSTEM_ENUMS.eventNames.locationTabCanChange, (hasChanges) => {
                    if (hasChanges) {
                        modalService.showYesNo('Unsaved Changes', 'Your changes are not saved. Are you sure you want to leave this page?', 'No', 'Yes').then((leaveConfirmed) => {
                            if (leaveConfirmed) {
                                handleTabChange(currentTab, tab);
                            } else {
                                if (currentTab) {
                                    currentTab.active = true;
                                }
        
                                tab = currentTab;
                            }
                        });
                    } else {
                       handleTabChange(currentTab, tab);
                    }
                });
            } else {
                handleTabChange(currentTab, tab);
            }
        };

        function handleTabChange(currentTab, newTab) {
            const apptTripType = _.find(vm.tripTypes, {systemTripTypeId: SYSTEM_ENUMS.systemTripType.appointment});

            if (currentTab) {
                currentTab.active = false;
            }

            newTab.active = true;

            if (apptTripType && apptTripType.id != null && apptTabs.includes(newTab.route)) {
               
                $state.go(newTab.route, angular.extend({}, transitionParams, {tripTypeId: apptTripType.id}));
            } else {
                $state.go(newTab.route);
            }
        }

        vm.subMenuHover = function (mouseEnter) {
            if (vm.subMenuWasClicked === true) return;

            let menuEl = angular.element("#location-sub-menu");

            if (!mouseEnter) {
                menuEl.removeClass('visible');
                vm.subMenuVisible = false;
            } else {
                menuEl.addClass('visible');
                vm.subMenuVisible = true;
            }
        };

        $rootScope.$on('subMenuMouseLeave', (event, data) => {
            vm.subMenuHover(false);
        });

        vm.subMenuClick = function (forceClose) {
            let menuEl = angular.element("#location-sub-menu");

            if (forceClose || vm.subMenuWasClicked === true) {
                vm.subMenuWasClicked = false;
                menuEl.removeClass('visible');
                vm.subMenuVisible = false;
            } else {
                vm.subMenuWasClicked = true;
                menuEl.addClass('visible');
                vm.subMenuVisible = true;
            }
        };

        vm.tripTypeSwitch = function (tripTypeName, tripTypeId, productPermissionId) {
            vm.subMenuClick(true);

            vm.initTabContainers(tripTypeName, tripTypeId, productPermissionId);

            vm.tabs.forEach((tab) => {
                tab.active = false;
            });

            // always switch back to first tab in rowset if trip type is switched
            vm.tabs[0].active = true;
         
            $state.go(vm.tabs[0].route, angular.extend({}, transitionParams, {tripTypeId: tripTypeId, productPermissionId: productPermissionId}));
        };

        $rootScope.$on('tripTypeSwitched', (event, data) => {
            vm.tripTypeSwitch(data.tripTypeName, data.tripTypeId, data.productPermissionId);
        });

        vm.currentTripTypeName = function () {
            switch (vm.productPermissionId) {
                case vm.productType.messaging:
                    return "Messaging";
                case vm.productType.loaner:
                    return "Loaner Management";
                case vm.productType.checkIn:
                    return "Check In";
                case vm.productType.inspect:
                    return "Inspect";
            }

            if (vm.tripTypeId === 0) { return "General Settings"; }

            let tripType = _.find(vm.tripTypes, {id: vm.tripTypeId});
            let name = tripType ? tripType.name : '';

            // for consistency
            if (tripType.systemTripTypeId === vm.systemTripTypes.appointment) {
                name += "s";
            }

            return name;
        };

        vm.initTripTypes();

        function tripTypeForLyft() {
            if (selectedTripType && selectedTripType.systemTripTypeId) {
                let enumType = $filter('filter')(SYSTEM_ENUMS.systemTripTypes, {value: selectedTripType.systemTripTypeId}, true)[0];

                if (enumType && enumType.supportsLyftAPI) {
                    return true;
                }
            }

            return false;
        }

        function initCheckInTabs() {
            vm.tabs = [
                {
                    title: "General",
                    route: 'location-checkin-general',
                    active: true
                }
            ]; 
        }

        function initMessagingTabs() {
            vm.tabs = [
                {
                    title: "Settings",
                    route: 'location-product-settings',
                    active: true
                }
            ]; 

            if (!vm.isOnlyDealerAdmin) {
                vm.tabs.push({
                    title: "Automation",
                    route: 'location-product-automation',
                    active: false
                });
            }
        }

        function initInspectTabs() {
            vm.tabs = [
                {
                    title: "General",
                    route: 'location-config-inspect-general',
                    active: true
                },
                {
                    title: "Status",
                    route: 'location-config-inspect-status',
                    active: false
                },
                {
                    title: "Shop Flags",
                    route: 'location-config-inspect-shopflags',
                    active: false
                },
                {
                    title: "Parts Availability Status",
                    route: 'location-config-inspect-partsavailability',
                    active: false
                },
                // {
                //     title: "Notifications",
                //     route: 'location-config-inspect-notifications',
                //     active: false
                // },
                {
                    title: "Form Builder",
                    route: 'location-config-inspect-formbuilder',
                    active: false
                },
                {
                    title: "Labor Rates",
                    route: 'location-config-inspect-laborrates',
                    active: false
                },
                // {
                //     title: "Parts",
                //     route: 'location-config-inspect-parts',
                //     active: false
                // },
                {
                    title: "Shop Supplies",
                    route: 'location-config-inspect-shopsupplies',
                    active: false
                },                
                {
                    title: "Taxes",
                    route: 'location-config-inspect-taxes',
                    active: false
                }
            ]; 
        }

        function initTripTypeTabs() {
            vm.tabs = [{
                title: "Booking",
                route: 'tab-booking',
                active: false
            },
            {
                title: "Tasks",
                route: 'tab-tasks',
                active: false
            },
            {
                title: "Survey",
                route: 'tab-survey',
                active: false
            },
            {
                title: "Notifications",
                route: 'tab-notifications',
                active: false
            }];

            if (tripTypeForLyft()) {
                _.remove(vm.tabs, (tab) => {
                    return tab.route === 'tab-tasks';
                });
            } else {
                vm.tabs.push({
                    title: "Incentives",
                    route: 'tab-incentives',
                    active: false
                });                
            }
        }

        function initLoanerTabs() {
            if (!vm.isOnlyDealerAdmin) {
                vm.tabs = [];

                vm.tabs.push({
                    title: "Preferences",
                    route: "location-loaner-settings-preferences",
                    active: false
                });

                vm.tabs.push({
                    title: "Notifications",
                    route: "location-loaner-settings-notifications",
                    active: false
                });
            } else {
                vm.tabs = [
                    {
                        title: "Settings",
                        route: 'location-product-settings',
                        active: true
                    }
                ]; 
            }
        }

        function initAppointmentTabs() {
            vm.isInspect = false;
            vm.tabs = [];

            if (vm.isOnlyDealerAdmin === false || vm.isAppointmentAdmin === true) {
                vm.tabs.push({
                    title: "General",
                    route: "tab-booking",
                    active: false
                });
            }

            if (vm.isAdminLevelUser && vm.isAppointmentAdmin) {
                vm.tabs.push({
                    title: "Departments",
                    route: "tab-departments",
                    active: false
                });  

                vm.tabs.push({
                    title: "Advisors",
                    route: "tab-advisors",
                    active: false
                });

                vm.tabs.push({
                    title: "Capacity",
                    route: "tab-appointmentcapacity",
                    active: false
                });
                
                vm.tabs.push({
                    title: "Line Item Mappings",
                    route: "tab-lineitems",
                    active: false
                });                   
            } else if (vm.isAppointmentAdmin && !vm.isAdminLevelUser) {
                if (permissions.hasRole(SYSTEM_ENUMS.roleNames.departmentAdmin)) {
                    vm.tabs.push({
                        title: "Departments",
                        route: "tab-departments",
                        active: false
                    });                        
                }

                if (permissions.hasRole(SYSTEM_ENUMS.roleNames.serviceAdvisorAdmin)) {
                    vm.tabs.push({
                        title: "Advisors",
                        route: "tab-advisors",
                        active: false
                    });
                }

                if (permissions.hasRole(SYSTEM_ENUMS.roleNames.capacitiesAdmin)) {
                    vm.tabs.push({
                        title: "Capacity",
                        route: "tab-appointmentcapacity",
                        active: false
                    });
                }

                if (permissions.hasRole(SYSTEM_ENUMS.roleNames.opCodeAdmin)) {
                    vm.tabs.push({
                        title: "Line Item Mappings",
                        route: "tab-lineitems",
                        active: false
                    });
                }
            } else if (!vm.isAppointmentAdmin && vm.isAdminLevelUser) {
                vm.tabs.push({
                    title: "Departments",
                    route: "tab-departments",
                    active: false
                });  

                vm.tabs.push({
                    title: "Advisors",
                    route: "tab-advisors",
                    active: false
                });

                vm.tabs.push({
                    title: "Capacity",
                    route: "tab-appointmentcapacity",
                    active: false
                });

                vm.tabs.push({
                    title: "Line Item Mappings",
                    route: "tab-lineitems",
                    active: false
                });
            } 

            vm.tabs.push({
                title: "Notifications",
                route: 'tab-notifications',
                active: false
            });
       
            if (!vm.isAdminLevelUser) {
                _.remove(vm.tabs, (tab) => {
                    return tab.route === 'tab-notifications';
                });
            }
        }
        
        function initDealerSettingTabs() {
            vm.tabs = [{
                title: "Location",
                route: 'tab-general',
                active: false
            },
            {
                title: "Logos",
                route: 'tab-logos',
                active: false
            },
            {
                title: "Hours",
                route: 'tab-hours',
                active: false
            },
            {
                title: 'Capacity',
                route: 'tab-capacity',
                active: false
            },
            {
                title: "Integrations",
                route: 'tab-integrations',
                active: false
            },
            {
                title: "API",
                route: 'tab-api',
                active: false
            },
            {
                title: "Users",
                route: 'tab-users',
                active: false
            },
            {
                title: "User Permissions",
                route: 'tab-user-permissions',
                active: false
            },
            {
                title: "Drivers",
                route: 'tab-drivers',
                active: false
            }];

            if (vm.isOnlyDealerAdmin) {
                _.remove(vm.tabs, (tab) => {
                    return tab.route === 'tab-logos' ||
                        tab.route === 'tab-integrations' ||
                        tab.route === 'tab-api';  
                });
            }
        }

    }
})();
(function () {
    'use strict';

    LocationAddController.$inject = ["$filter", "$log", "$scope", "$state", "$timeout", "toastr", "permissions", "locationService", "fileReaderService", "modalService", "SYSTEM_ENUMS", "ValidationService", "resolvedAdminPrograms", "resolvedProductPackages", "resolvedLocations", "resolvedDriverCompanies", "resolvedDriverPrograms"];
    angular
        .module('redcap.location')
        .controller('LocationAddController', LocationAddController);

  function LocationAddController($filter, $log, $scope, $state, $timeout, toastr, permissions, locationService, fileReaderService, modalService, SYSTEM_ENUMS, ValidationService, resolvedAdminPrograms, resolvedProductPackages, resolvedLocations, resolvedDriverCompanies, resolvedDriverPrograms) {
        let vm = this;

        vm.placesObj = {
            location: {}
        };

        vm.gplaces = '';
        vm.smsNumberQueried = false;
        vm.systemEnums = SYSTEM_ENUMS;
        vm.dealerIdToCopy = null;
        vm.adminPrograms = resolvedAdminPrograms;
        vm.productPackages = resolvedProductPackages;
        vm.locationList = resolvedLocations; 
        vm.driverCompanies = resolvedDriverCompanies;
        vm.driverPrograms = resolvedDriverPrograms;
        vm.locationList.unshift({id: 0, name: 'None'});
        vm.adminConfigId = null;
        vm.dealerAddMode = '1';
        vm.showDealerImport = permissions.isSysAdmin() || permissions.isRedCapAdmin();  
        // gray out form fields until location entered
        vm.fieldsDisabled = true;

        let copyableDealers = $filter('filter')(vm.locationList, {isCopyable: true});
    
        vm.validation = {
            acceptableLocationTypes: vm.systemEnums.locationTypes.map(lt => lt.value).join(),
            acceptableStatuses: vm.systemEnums.dealerStatuses.map(ds => ds.value).join(),
            acceptableAdminPrograms: vm.adminPrograms.map(ap => ap.id).join(),
            acceptableCopyFromDealers: copyableDealers.map(cd => cd.id).join(),
            checkCopyFrom: function () {
                if (vm.dealerIdToCopy !== null) {
                    vm.locationList.some((location) => {
                        if (location.id === vm.dealerIdToCopy) {
                            return vm.adminConfigId = location.adminConfigId;
                        }
                    });
                }
            },
            phone: function (fieldValue) {
                if (!fieldValue) return {isValid: false, message: 'A valid phone number is required.'};
                fieldValue = fieldValue.replace(/\D/g, '');
                
                return {isValid: fieldValue.length === 10, message: 'A valid phone number is required.'};
            },
            url: function (url) {
                if (url.indexOf('?') >= 0)
                    return {isValid: false, message: 'Please remove everything after "?"'};

                let regexp = /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;

                return {isValid: regexp.test(url), message: 'Must be a valid url.'};
            }
        };

        vm.createLocation = function () {
            // Possibly move this to a directive
            if (new ValidationService().checkFormValidity($scope.locationAddForm)) {
                // triptype toggle buttons
                let tripTypes = [];

                if (vm.servicepickup) tripTypes.push(SYSTEM_ENUMS.systemTripType.pickup);
                if (vm.servicedropoff) tripTypes.push(SYSTEM_ENUMS.systemTripType.dropoff);
                if (vm.testdrives) tripTypes.push(SYSTEM_ENUMS.systemTripType.testdrives);
                if (vm.recalls) tripTypes.push(SYSTEM_ENUMS.systemTripType.recalls);
                if (vm.lyftRoadSideAssistance) tripTypes.push(SYSTEM_ENUMS.systemTripType.lyftRoadSideAssistance);
                if (vm.lyftShuttleService) tripTypes.push(SYSTEM_ENUMS.systemTripType.lyftShuttleService);
                if (vm.deliverSoldVehicle) tripTypes.push(SYSTEM_ENUMS.systemTripType.deliverSoldVehicle);
                if (vm.inventoryTransport) tripTypes.push(SYSTEM_ENUMS.systemTripType.inventoryTransport);
             
                $log.debug('tripTypes', tripTypes);

                if (tripTypes.length === 0 && vm.dealerIdToCopy === null) {
                    $log.debug(vm.dealerIdToCopy);
                    toastr.error('Please select at least one product.');

                    return;
                }

                // PREPARE DATA
                $log.debug('vm', vm);

                let newLocation = vm.placesObj;
                
                newLocation.dealerIdToCopy = vm.dealerIdToCopy;
                newLocation.tripTypeIds = tripTypes;
                newLocation.adminConfigId = vm.adminConfigId;
                newLocation.brandingType = vm.systemEnums.dealerBranding.autoDealer;
                                
                locationService.addLocation(newLocation).then((response) => {
                    toastr.success('New Location Successfully Added.');
                    // close panel
                    $scope.$dismiss();

                    vm.resetFields();

                    $state.go('tab-general', {locationId: response, tripTypeId: 0});
                });
            }
        };

        vm.resetFields = function () {
            vm.placesObj = {
                location: {}
            };
            vm.gplaces = '';
            vm.dealerIdToCopy = null;
            vm.servicepickup = false;
            vm.servicedropoff = false;
            vm.testdrives = false;
            vm.recalls = false; 
            vm.lyftRoadSideAssistance = false; 
            vm.lyftShuttleService = false;  
            vm.lyftFromDealership = false;  
            vm.deliverSoldVehicle = false;
            vm.inventoryTransport = false;        
            vm.fieldsDisabled = true;

            $timeout(() => {
                $("#copy_from_dealer").trigger("change");
            }, 1);
            
            $scope.locationAddForm.$setPristine();
        };
        
        vm.placeUpdated = function(formattedAddress) {
            if (formattedAddress) {
                vm.placesObj.location = formattedAddress.location;
                vm.placesObj.location.countryShortCode = formattedAddress.location.countryShortCode === 'USA' ? 'US' : formattedAddress.location.countryShortCode;

                vm.showWarning = false;
                vm.fieldsDisabled = false;

                locationService.hasDuplicateAddress(vm.placesObj.location).then((result) => {
                    vm.hasDuplicateAddress = !result.isValid;
                });

                locationService.getTimezone(vm.placesObj.location.lat, vm.placesObj.location.lng).then((result) => {
                    vm.placesObj.timeZone = result.timeZoneFullName;
                    vm.placesObj.timeZoneId = result.timeZoneId;
                });

                locationService.get800Number().then((twilioNumber) => {
                    vm.placesObj.twilioNumber = twilioNumber;
                    vm.smsNumberQueried = true;
                });
            }
        };

        vm.nameUpdated = function () {
            locationService.hasDuplicateName(vm.placesObj.name).then((result) => {
                vm.hasDuplicateName = !result.isValid;
            });
        };

        if (vm.showDealerImport) {
            let dealerFilter = {   
                onlyCopyable: true,         
                pageSize: 99999999 // Get all dealers
            };

            locationService.getLocations(dealerFilter).then((result) => {           
                vm.copyFromDealerList = result;
            });
        }        

        vm.chooseImportFile = function(file) {
            vm.bulkImport = {};
            let reader = new FileReader();

            vm.readingFile = true;
            reader.readAsDataURL(file);

            reader.onload = function() {
                vm.readingFile = false;

                vm.bulkImport = {
                    file: file,
                    base64FileData: reader.result,
                    fileName: file.name
                };                
            };
        };

        vm.importDealers = function() {
            let confirm = modalService.showYesNo('Please Confirm', 'You are about to import all records in the import file into the system, are you sure you want to proceed?', 'No', 'Yes');
            
            confirm.then((confirmed) => {
                if (confirmed) {
                    vm.importCompleted = false;
                    vm.isLoadingData = true;
                    let copyFromDealerId = vm.copyFromDealer ? vm.copyFromDealer.id : null;

                    locationService.bulkImportDealers(vm.bulkImport.base64FileData, copyFromDealerId).then((uploadResults) => {                  
                        let csvFile = uploadResults;
                        let filename = 'dealer_upload_completed.csv';
                        
                        fileReaderService.saveToDisk(csvFile, filename);

                        vm.importCompleted = true;
                    }).catch((err) => { 
                        console.error(err);
                    }).finally(() => {
                        vm.isLoadingData = false;
                        vm.bulkImport = {};
                    });
                }
            });           
        };

        vm.validateSMSPhone = function() {
            locationService.hasDuplicateSMSPhone(vm.placesObj.twilioNumber).then((result) => {
                vm.hasDuplicateSMSPhone = !result.isValid;
            });
        };
        
        vm.validateSMSPhone();
        
        $scope.$watch('vm.places.twilioNumber', (newVal) => {
            if (newVal) {
                vm.placesObj.twilioNumber = newVal;
                vm.smsNumberQueried = true;
            }
        });

        $scope.$on('form.locator', (event, formCtrl) => {
            vm.childScopeForm = formCtrl;
        });
    }
})();

(function () {
    'use strict';

    DealerConfigModalController.$inject = ["$uibModalInstance", "dealerConfigService", "eventAlertService", "resolvedDealerId", "resolvedTripTypes", "$scope"];
    angular
        .module('redcap.location')
        .controller('DealerConfigModalController', DealerConfigModalController);

    function DealerConfigModalController($uibModalInstance, dealerConfigService, eventAlertService, resolvedDealerId, resolvedTripTypes, $scope) {
        let vm = this;

        const steps = {
            select: 'select',
            edit: 'edit'
        };

        const labels = {
            next: 'Next',
            create: 'Create',
            update: 'Update'
        };

        vm.steps = steps;
        vm.dealerId = resolvedDealerId;
        vm.title = 'Dealer Config Admin';
        vm.availableTripTypes = createTripTypeOptions(resolvedTripTypes);
        vm.selectedTripType = vm.availableTripTypes[0] || null;
        vm.form = {
            configKey: '',
            configValue: ''
        };
        vm.availableConfigKeys = [];
        vm.filteredConfigKeys = [];
        vm.step = steps.select;
        vm.primaryLabel = labels.next;
        vm.isLoading = false;
        vm.isLoadingKeys = false;
        vm.addUpdateAnotherConfigKey = false;
        vm.errors = {};

        $scope.$on('form.locator', (_, formCtrl) => {
            vm.childScopeForm = formCtrl;
        });

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.tripTypeChanged = function () {
            vm.form.configKey = '';
            vm.form.configValue = '';
            vm.normalizedConfigKey = '';
            vm.step = steps.select;
            vm.primaryLabel = labels.next;
            vm.errors = {};
            loadConfigKeys();
        };

        vm.addConfigKey = function ($select) {
            let searchText = $select?.search || '';
            let normalizedKey = normalizeConfigKey(searchText);

            if (!normalizedKey) {
                return;
            }

            let configKeyExists = (vm.availableConfigKeys || []).some((availableConfigKey) => availableConfigKey.toLowerCase() === normalizedKey.toLowerCase());

            if (!configKeyExists) {
                vm.availableConfigKeys.push(normalizedKey);
                vm.availableConfigKeys.sort(compareConfigKeys);
            }

            vm.form.configKey = normalizedKey;
            vm.normalizedConfigKey = normalizedKey;
            vm.step = steps.edit;
            vm.primaryLabel = labels.create;
            vm.form.configValue = '';
        };

        vm.onConfigKeySelected = function ($item, $model) {
            vm.form.configKey = normalizeConfigKey($item || $model || vm.form.configKey);
            vm.normalizedConfigKey = vm.form.configKey;
        };

        vm.filterConfigKeys = function (searchTerm) {
            if (!searchTerm || searchTerm.length === 0) {
                vm.filteredConfigKeys = vm.availableConfigKeys;

                return;
            }

            const lowerSearch = searchTerm.toLowerCase();

            vm.filteredConfigKeys = vm.availableConfigKeys.filter((key) => {
                return key.toLowerCase().includes(lowerSearch);
            });
        };

        vm.handlePrimaryAction = function () {
            vm.errors = {};
            vm.form.configKey = normalizeConfigKey(vm.form.configKey);

            if (!vm.form.configKey) {
                return;
            }

            if (vm.step === steps.select) {
                fetchConfigValue();
            } else {
                saveConfigValue();
            }
        };

        vm.disablePrimaryAction = function () {
            if (vm.isLoading) {
                return true;
            }

            if (vm.step === steps.select) {
                return !vm.form.configKey;
            }

            return false;
        };

        function compareConfigKeys(configKey, keyToCompare) {
            return configKey.toLowerCase().localeCompare(keyToCompare.toLowerCase());
        }

        function loadConfigKeys() {
            vm.isLoadingKeys = true;

            if (!vm.dealerId) {
                vm.availableConfigKeys = [];
                vm.isLoadingKeys = false;

                return;
            }

            if (!vm.selectedTripType?.dealerTripTypeId) {
                vm.availableConfigKeys = [];
                vm.isLoadingKeys = false;

                return;
            }

            dealerConfigService.getConfigKeys(vm.dealerId, vm.selectedTripType.dealerTripTypeId).then((availableKeys) => {
                vm.availableConfigKeys = availableKeys || [];
                vm.availableConfigKeys.sort(compareConfigKeys);
                vm.filteredConfigKeys = vm.availableConfigKeys;
            }).catch(() => {
                vm.availableConfigKeys = [];
                vm.errors.loadKeys = 'Unable to load config keys.';
                eventAlertService.error('Unable to load config keys.');
            }).finally(() => {
                vm.isLoadingKeys = false;
            });
        }

        function fetchConfigValue() {
            vm.isLoading = true;
            vm.normalizedConfigKey = vm.form.configKey || '';

            dealerConfigService.getConfigValue(vm.dealerId, vm.selectedTripType.dealerTripTypeId, vm.normalizedConfigKey).then((configValue) => {
                vm.form.configValue = configValue;
                vm.tripTypeStatus = configValue?.status ?? 1;
                vm.step = steps.edit;
                vm.primaryLabel = labels.update;
            }).catch(() => {
                vm.errors.loadValue = 'Unable to load config value.';
                eventAlertService.error(vm.errors.loadValue);
            }).finally(() => {
                vm.isLoading = false;
            });
        }

        function saveConfigValue() {
            vm.isLoading = true;

            const dealerConfigData = {
                dealerId: vm.dealerId,
                dealerTripTypeId: vm.selectedTripType.dealerTripTypeId,
                tripTypeId: vm.selectedTripType.systemTripTypeId,
                configKey: vm.normalizedConfigKey,
                configValue: vm.form.configValue,
                status: vm.tripTypeStatus || 1
            };

            dealerConfigService.saveConfigValue(dealerConfigData).then(() => {
                    let configKeyExists = (vm.availableConfigKeys || []).some((availableConfigKey) => availableConfigKey.toLowerCase() === dealerConfigData.configKey.toLowerCase());

                    if (!configKeyExists) {
                        vm.availableConfigKeys.push(dealerConfigData.configKey);
                        vm.availableConfigKeys.sort(compareConfigKeys);
                    }

                    eventAlertService.createAlert('Dealer config updated.');

                    if (vm.addUpdateAnotherConfigKey) {
                        resetToSelectStep();
                        
                        return;
                    }

                    $uibModalInstance.close(dealerConfigData);
                }).catch((error) => {
                    vm.errors.updateValue = error?.data?.message ?? 'Unable to update config value.';
                    eventAlertService.error(vm.errors.updateValue);
                }).finally(() => {
                    vm.isLoading = false;
                });
        }

        function resetToSelectStep() {
            vm.form.configKey = '';
            vm.form.configValue = '';
            vm.normalizedConfigKey = '';
            vm.tripTypeStatus = null;
            vm.step = steps.select;
            vm.primaryLabel = labels.next;
            vm.errors = {};
            vm.filteredConfigKeys = vm.availableConfigKeys;
        }

        function normalizeConfigKey(configKey) {
            let normalizedKey = (configKey || '').trim();

            if (!normalizedKey) {
                return '';
            }

            let matchingConfigKey = (vm.availableConfigKeys || []).find((availableConfigKey) => {
                return availableConfigKey.toLowerCase() === normalizedKey.toLowerCase();
            });

            return matchingConfigKey || normalizedKey;
        }

        function createTripTypeOptions(tripTypes) {
            let configOptions = [];

            (tripTypes || []).forEach((tripType) => {
                configOptions.push({
                    label: tripType.name,
                    dealerTripTypeId: tripType.id,
                    systemTripTypeId: tripType.systemTripTypeId
                });
            });

            return configOptions;
        }

        loadConfigKeys();
    }
})();

(function () {
    'use strict';

    CopyTripTypesModalController.$inject = ["$uibModalInstance", "locationService", "modalService", "eventAlertService", "currentLocation", "currentLocationTripTypes", "$state"];
    angular
        .module('redcap.location')
        .controller('CopyTripTypesModalController', CopyTripTypesModalController);

    function CopyTripTypesModalController($uibModalInstance, locationService, modalService, eventAlertService, currentLocation, currentLocationTripTypes, $state) {
        let vm = this;

        vm.currentLocation = currentLocation;
        vm.selectedDealer = null;
        vm.dealers = [];
        vm.availableTripTypes = [];
        vm.selectedTripTypes = [];
        vm.isLoadingTripTypes = false;
        vm.isLoadingDealers = true;
        vm.copying = false;
      
        vm.init = function() {
            locationService.getActiveDealersMinimalData(false).then((dealers) => {
                vm.dealers = dealers.filter((dealer) => dealer.id !== vm.currentLocation.id);
            }).catch((error) => {
                eventAlertService.createAlert('Error loading dealers', 'danger');
            }).finally(() => {
                vm.isLoadingDealers = false;
            });
        };

        vm.init();

        vm.onDealerSelected = function(dealer) {
            if (!dealer) {
                vm.availableTripTypes = [];
                vm.selectedTripTypes = [];

                return;
            }

            vm.selectedTripTypes = [];
            vm.loadAvailableTripTypes();
        };

        vm.loadAvailableTripTypes = function() {
            vm.isLoadingTripTypes = true;
            vm.availableTripTypes = [];

            locationService.getLocationTripTypeInstances(vm.selectedDealer.id).then((selectedDealerTripTypes) => {
                vm.availableTripTypes = selectedDealerTripTypes.filter((tripType) => {
                    return !currentLocationTripTypes.some((existingTripType) => existingTripType.systemTripTypeId === tripType.systemTripTypeId);
                }).map((tripType) => {
                    return {
                        id: tripType.id,
                        name: tripType.name,
                        selected: false
                    };
                });
            }).catch((error) => {
                eventAlertService.createAlert('Error loading trip types', 'danger');
            }).finally(() => {
                vm.isLoadingTripTypes = false;
            });
        };

        vm.toggleTripType = function(tripType) {
            tripType.selected = !tripType.selected;
            vm.updateSelectedTripTypes();
        };

        vm.updateSelectedTripTypes = function() {
            vm.selectedTripTypes = vm.availableTripTypes.filter((tripType) => {
                return tripType.selected;
            });
        };

        vm.isNextEnabled = function() {
            return vm.selectedDealer && vm.selectedTripTypes.length > 0;
        };

        vm.next = function() {
            if (!vm.isNextEnabled()) {
                return;
            }

            const confirmMessage = `Are you sure you wish to copy these trip type instances from dealer ${vm.selectedDealer.name} to dealer ${vm.currentLocation.name}?`;

            modalService.showYesNo('Confirm Copy', confirmMessage, 'No', 'Yes', false).then((confirmed) => {
                if (confirmed) {
                    vm.copyTripTypes();
                }
            });
        };

        vm.copyTripTypes = function() {
            vm.copying = true;
            let tripTypeIds = vm.selectedTripTypes.map(tt => tt.id);
            
            let copyData = {
                sourceDealerId: vm.selectedDealer.id,
                targetDealerId: vm.currentLocation.id,
                tripTypeInstanceIds: tripTypeIds
            };

            locationService.copyTripTypeInstances(copyData).then((response) => {
                $uibModalInstance.close(true);
                $state.go('tab-general', {dealerId: vm.currentLocation.id}, {reload: true});
            }).catch((error) => {
                vm.copying = false;
                eventAlertService.createAlert('Error copying trip type instances: ' + (error.data?.message || 'Unknown error'), 'danger');
            });
        };
        
        vm.cancel = function() {
            $state.go('tab-general', {dealerId: vm.currentLocation.id}, {reload: true});
            $uibModalInstance.close(false);
        };
    }
})();

(function () {
    'use strict';

    loanerService.$inject = ["SYSTEM_ENUMS", "$filter", "rcApi", "$state", "$timeout", "modalService", "rcLocalStorageService"];
    angular
        .module('redcap.loaner')
        .factory('loanerService', loanerService);

    function loanerService(SYSTEM_ENUMS, $filter, rcApi, $state, $timeout, modalService, rcLocalStorageService) {

        let BASEPATH = 'loaner/';

        return {
            getVehicles: getVehicles,
            getContract: getContract,
            getContracts: getContracts,
            getContractsList: getContractsList,
            editReservation: editReservation,
            saveReservation: saveReservation,
            searchCustomers: searchCustomers,
            searchVehicles: searchVehicles,
            getVehicleIssues: getVehicleIssues,
            searchTrips: searchTrips,
            searchAppointments: searchAppointments,
            sendCustomerReminder: sendCustomerReminder,
            getLocations: getLocations,
            getBusinessSources: getBusinessSources,
            getAdvisors: getAdvisors,
            validateDOB: validateDOB,
            contractActionClicked: contractActionClicked,
            getContractTotalDays: getContractTotalDays,
            isLoanerVehiclePreferredVehicle: isLoanerVehiclePreferredVehicle,
            getLoanerPreferenceSettingForVehicle: getLoanerPreferenceSettingForVehicle,
            calculateEstChargeInDollars: calculateEstChargeInDollars,
            calculateEstChargeInPoints: calculateEstChargeInPoints,
            removePointsFromActions: removePointsFromActions,
            removeCreateInvoiceFromActions: removeCreateInvoiceFromActions,
            getContractsListForDropdown: getContractsListForDropdown,
            formatContractForDropdown: formatContractForDropdown,
            getInvoiceStatusText: getInvoiceStatusText,
            getPaymentStatusText: getPaymentStatusText,
            disableActionDropdown: disableActionDropdown,
            removeLoanerFromTrip: removeLoanerFromTrip,
			formatLocationForDropdown: formatLocationForDropdown,
            saveVehicle: saveVehicle,
            getVehicle: getVehicle,
            updateStatusVehicle: updateStatusVehicle,
            updateVehicle: updateVehicle,
            getStatuses: getStatuses,
            getVehicleClasses: getVehicleClasses,
            loanerConfigurations: loanerConfigurations,
            loanerListModeChanged: loanerListModeChanged
        };

        function getVehicles(filters) {
            return rcApi.post(BASEPATH + filters.dealerId  + '/vehicles', filters);
        }

        function getLocations(dealerId, loanerSystem, centerId) {
            return rcApi.post(BASEPATH + dealerId + '/locations',
                {
                    loanerSystem: loanerSystem,
                    centerId: centerId
                });
        }

        function getBusinessSources(dealerId, locationId, loanerSystem, centerId) {
            return rcApi.post(BASEPATH + dealerId + '/businessSources',
                {
                    locationId: locationId,
                    loanerSystem: loanerSystem,
                    centerId: centerId
                });
        }

        function getAdvisors(dealerId, locationId, loanerSystem, centerId) {
            return rcApi.post(BASEPATH + dealerId + '/advisors',
                {
                    locationId: locationId,
                    loanerSystem: loanerSystem,
                    centerId: centerId
                });
        }

        function getVehicleIssues(dealerId, vehicleId) {
            return rcApi.get(BASEPATH + dealerId + '/vehicles/' + vehicleId + '/issues');
        }

        function getContract(dealerId, externalContractId) {
            return rcApi.get(BASEPATH + dealerId + '/' + externalContractId + '/details');
        }

        function getContracts(filters, cancellationToken) {
            return rcApi.get(BASEPATH + filters.dealerId + '/contracts', filters, cancellationToken);
        }

        function getContractsList(filters) {
            return rcApi.get(BASEPATH + filters.dealerId + '/contracts/list', filters);
        }

        function getContractsListForDropdown(filters) {
            return rcApi.get(BASEPATH + filters.dealerId + '/contracts/list/dropdown', filters);
        }

        function saveReservation(dealerId, reservation) {
            return rcApi.post(BASEPATH + dealerId + '/reservations', reservation);
        }

        function editReservation(dealerId, reservationId, reservation) {
            return rcApi.put(BASEPATH + dealerId + '/reservations/' + reservationId, reservation);
        }

        function searchCustomers(dealerId, searchString, cancellationToken) {
            return rcApi.post(BASEPATH + dealerId + '/customers/search',
                {
                    searchString: searchString
                }, cancellationToken);
        }

        function searchVehicles(searchString, dealerId, reservationId, cancellationToken) {
            return rcApi.post(BASEPATH + dealerId + '/' + reservationId + '/vehicles/search',
                {
                    searchString: searchString
                }, cancellationToken);
        }

        function saveVehicle(vehicle, dealerId) {
            return rcApi.post(BASEPATH + dealerId + '/vehicle', vehicle);
        }

        function updateVehicle(vehicle, vehicleId, dealerId) {
            return rcApi.post(BASEPATH + dealerId + '/vehicle/' + vehicleId, vehicle);
        }

        function loanerConfigurations(dealerId) {
            return rcApi.get(BASEPATH + dealerId + '/dealerConfig');
        }

        function getVehicle(dealerId, vehicleId) {
            return rcApi.get(BASEPATH + dealerId + '/vehicle/' + vehicleId);
        }

        function updateStatusVehicle(dealerId, vehicleId, newStatus, dateStatus) {
            return rcApi.post(BASEPATH + dealerId + '/vehicle/' + vehicleId + "/status?newStatus=" + newStatus + "&dateStatus=" + dateStatus);
        }

        function getStatuses(dealerId) {
            return rcApi.get(BASEPATH + dealerId + '/vehicle/statuses');
        }

        function getVehicleClasses(dealerId) {
            return rcApi.get(BASEPATH + dealerId + '/vehicle/vehicleClases');
        }

        function searchTrips(dealerId, searchString, page, pageSize, cancellationToken) {
            return rcApi.post(BASEPATH + dealerId + '/trips/search',
                {
                    searchString: searchString,
                    oage: page || 0,
                    pageSize: pageSize || 25
                }, cancellationToken);
        }

        function searchAppointments(dealerId, searchString, cancellationToken) {
            return rcApi.get(BASEPATH + dealerId + '/appointments/search',
                {
                    searchString: searchString
                }, cancellationToken);
        }

        function sendCustomerReminder(dealerId, reservationId) {
            return rcApi.post(BASEPATH + dealerId + '/reservations/' + reservationId + '/sendreminder');
        }

        function validateDOB(date) {
            let minAge = 21;
            let age = moment().diff(moment(date), 'years');

            if (age < minAge) {
                return {
                    isValid: false,
                    message: "You must be 21 to create a contract."
                };
            } else {
                return {
                    isValid: true
                };
            }
        }

        function createInvoiceFromContract(contract, dealer) {
            let days = contract && contract.duration && contract.duration.days || 0;
            let dailyCost = contract && contract.costSettings && contract.costSettings.dailyCost || 0;

            if (contract && contract.duration && contract.duration.hours) {
                days++;
            }

            return $state.go('payment-create', {
                location: {
                    id: dealer.id,
                    name: dealer.name
                },
                customer: {
                    firstName: contract.customerFirstName || contract.customer.firstName,
                    lastName: contract.customerLastName || contract.customer.lastName,
                    mobilePhone: contract.customerPhone || contract.customer.phoneNumber
                },
                lineItems: [{
                    type: SYSTEM_ENUMS.invoiceLineItemTypes.loanerUpcharge,
                    value: angular.extend({id: contract.externalContractId}, contract || {}),
                    amount: (days * dailyCost || 0).toFixed(2),
                    externalContractId: contract.externalContractId,
                    externalReservationId: contract.externalContractId,
                    id: contract.externalContractId,
                    externalCustomerId: contract.externalCustomerId
                }]
            });
        }

        function setPaymentStatus(contract, dealer, status) {
            return rcApi.post(BASEPATH + dealer.id + '/' + contract.externalContractId + '/setPaymentStatus',
                {
                    status: status
                });
        }

        function contractActionClicked(contract, dealer) {
            let loanerActionEnum = SYSTEM_ENUMS.loanerActionsEnum;

            if (contract.selectedAction === loanerActionEnum.CreateInvoice) {
                return createInvoiceFromContract(contract, dealer);
            } else if (contract.selectedAction === loanerActionEnum.MarkAsInvoiced) {
                return setPaymentStatus(contract, dealer, SYSTEM_ENUMS.loanerPaymentStatusEnum.Invoiced);
            } else if (contract.selectedAction === loanerActionEnum.MarkAsPaid) {
                return setPaymentStatus(contract, dealer, SYSTEM_ENUMS.loanerPaymentStatusEnum.Paid);
            } else if (contract.selectedAction === loanerActionEnum.MarkAsPaidWithPoints) {
                return setPaymentStatus(contract, dealer, SYSTEM_ENUMS.loanerPaymentStatusEnum.PaidWithPoints);
            } else if (contract.selectedAction === loanerActionEnum.MarkAsPaidWaived) {
                return setPaymentStatus(contract, dealer, SYSTEM_ENUMS.loanerPaymentStatusEnum.Waived);
            }
        }


        function getContractTotalDays (duration) {
            if (!duration) return null;

            let days = duration.days;
            let hours = duration.hours;

            if (hours && hours > 0) {
                days++;
            }

            return days;
        }

        function isLoanerVehiclePreferredVehicle (contract, loanerPreferences) {
            let cflTransportationTypes = SYSTEM_ENUMS.cflTransportationTypes;
            
            loanerPreferences = contract.loanerPreferences || loanerPreferences;

            if (loanerPreferences &&
                loanerPreferences.transportationType === cflTransportationTypes.chooseLoaner &&
                loanerPreferences.vehiclePreferences && 
                loanerPreferences.vehiclePreferences.length > 0 && 
                contract.vehicleModel || contract.loanerVehicle) {
                    let contractModel = contract.vehicleModel ? contract.vehicleModel.toLowerCase() : contract.loanerVehicle && contract.loanerVehicle.model ? contract.loanerVehicle.model.toLowerCase() : null;

                    if (loanerPreferences.vehiclePreferences[0].model.toLowerCase() === contractModel) {
                        return 1;
                    } else if (loanerPreferences.vehiclePreferences[1].model.toLowerCase() === contractModel) {
                        return 2;
                    }
            } 
            
            return 0;
        }

        function getLoanerPreferenceSettingForVehicle (settingsVehicles, contract, loanerPreferences) {
            if (!contract.costSettings) {
                let rank = isLoanerVehiclePreferredVehicle (contract, loanerPreferences);
                
                loanerPreferences = contract.loanerPreferences || loanerPreferences;

                if (rank > 0) {
                    let modelCode = $filter('filter')(loanerPreferences.vehiclePreferences, {rank: rank})[0].modelCode;
                    let result = $filter('filter')(settingsVehicles, {model: modelCode});

                    if (result && result.length > 0) {
                        contract.costSettings = result[0];

                        return result[0];
                    }

                    return null;
                }

                return null;
            } else {
                return contract.costSettings;
            }
        }

        function calculateEstChargeInDollars(duration, dailyDollars) {
            let days = getContractTotalDays(duration);
           
            return dailyDollars * days;

        }

        function calculateEstChargeInPoints(duration, dailyPoints) {
            let days = getContractTotalDays(duration);
            
            return dailyPoints * days;
        }

        function removePointsFromActions(actions) {
            let i;
            let length = actions.length;
            let loanerActionEnum = SYSTEM_ENUMS.loanerActionsEnum;

            for (i = 0; i < length; i++) {
                if (actions[i].value === loanerActionEnum.MarkAsPaidWithPoints) {
                    actions.splice(i, 1);
                    break;
                }
            }
        }

        function removeCreateInvoiceFromActions(actions) {
            let i;
            let length = actions.length;
            let loanerActionEnum = SYSTEM_ENUMS.loanerActionsEnum;

            for (i = 0; i < length; i++) {
                if (actions[i].value === loanerActionEnum.CreateInvoice) {
                    actions.splice(i, 1);
                    break;
                }
            }
        }

        function removeLoanerFromTrip(dealerId, tripId) {
            return modalService.showYesNo("Confirm Loaner Removal", "This will remove the loaner contract from this trip and require that you manually obtain the customer’s credentials and signature on the agreement.  This action will not cancel the trip or loaner reservation/contract.  Are you sure you want to disassociate the loaner reservation/contract from the trip?", "Cancel", "Yes", true)
                .then((confirmed) => {
                    if (confirmed) {
                        return rcApi.put(BASEPATH + dealerId + '/remove/trip/' + tripId).then(() => { return true; });
                    } else return false;
                });
        }

        function formatContractForDropdown(contract) {
            let vehicle = contract.vehicleMake ? `${contract.vehicleYear || ''} ${contract.vehicleMake || ''} ${contract.vehicleModel || ''}` : 'No Vehicle Assigned';

            return `#${contract.contractNumber} ${contract.customerName} ${vehicle}`;
        }

        function getInvoiceStatusText(status) {
            switch (status) {
                case 1:
                    return 'Draft';
                case 2:
                    return 'Sent';
                case 3:
                    return 'Paid';
                case 4:
                    return 'Info';
                case 5:
                    return 'Authorized';
                case 6:
                    return 'Failed Delivery';
                default:
                    return 'Unknown';
            }
        }

        function getPaymentStatusText(status) {
            switch (status) {
                
                case SYSTEM_ENUMS.loanerPaymentStatusEnum.Paid:
                    return 'Paid';
                case SYSTEM_ENUMS.loanerPaymentStatusEnum.PaidWithPoints:
                    return 'Paid with points';
                case SYSTEM_ENUMS.loanerPaymentStatusEnum.Waived:
                    return 'Waived';
                case SYSTEM_ENUMS.loanerPaymentStatusEnum.Invoiced:
                    return 'Invoiced';
                case SYSTEM_ENUMS.loanerPaymentStatusEnum.Unpaid:
                default:
                    return 'Unpaid';
            }
        }

        function disableActionDropdown(contract) {
            if (!contract) return true;

            return contract.invoices && contract.invoices.length;
        }
        
        function formatLocationForDropdown (location, service) {
            return location.name + ' (' + service + ' ' + location.id + ')';
        }

        function loanerListModeChanged (listController, newMode) {
            if (newMode !== listController.searchMode) {
                listController.showAdvancedSearch = false;
                $timeout(() => {
                    listController.isLoading = true;
                    rcLocalStorageService.set('selectedLoanerMode', newMode);
                    $state.go(newMode);
                }, 250);
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('redcap.inspect')
        .directive('qrCode', qrCodeDirective);

    function qrCodeDirective() {
        return {
            restrict: 'E',
            scope: {
                url: '=',
                containerId: '@',
                logoPath: '@?',
                options: '=?'
            },
            controller: 'QrCodeController',
            controllerAs: 'qrVm',
            bindToController: true,
            template: '<div class="qr-code-wrapper white-bg" ng-show="isLoaded"><div id="{{qrVm.containerId}}" class="full-width-height position-relative"></div></div>',
            link: function(scope, element, attrs, ctrl) {
                scope.isLoaded = false;
                
                scope.$watch('qrVm.url', (newVal) => {
                    if (newVal) {
                        ctrl.generateQrCode(
                            ctrl.containerId,
                            ctrl.url,
                            ctrl.logoPath,
                            ctrl.options
                        );
                        scope.isLoaded = true;
                    }
                });
            }
        };
    }
})();

(function() {
    'use strict';

    inspectionService.$inject = ["rcApi", "$q", "INSPECT_CONSTANTS", "permissions", "rcUtilService", "modalService"];
    angular
        .module('redcap.inspect')
        .factory('inspectionService', inspectionService);

    function inspectionService(rcApi, $q, INSPECT_CONSTANTS, permissions, rcUtilService, modalService) {
        let INSPECT_BASEPATH = 'inspect/';

        return {
            getAvailableInspectionForms: getAvailableInspectionForms,
            getInspectionSections: getInspectionSections,
            changeInspectionForm: changeInspectionForm,
            getRecsAndObservations: getRecsAndObservations,
            getAutoCompleteSettings: getAutoCompleteSettings,
            getTaskRecommendations: getTaskRecommendations,
            initRecommendations: initRecommendations,
            updateTaskStatus: updateTaskStatus,
            updateTaskStatusBulk: updateTaskStatusBulk,
            saveTaskMeasurement: saveTaskMeasurement,
            getPossibleAnswerTypes: getPossibleAnswerTypes,
            searchObservations: searchObservations,
            searchRecommendations: searchRecommendations,
            getDefaultRODetailTab: getDefaultRODetailTab,
            hasIncompleteMeasurements: hasIncompleteMeasurements,
			initROTotals: initROTotals,
            calculateROTotals: calculateROTotals,
            updateInspectionStatus: updateInspectionStatus,
            proceedWithInspectionChange: proceedWithInspectionChange,
            getFixedTaxesAndFeesTotal: getFixedTaxesAndFeesTotal,
            isFixedTaxApplicable: isFixedTaxApplicable,
            mapAnswerTypeToSeverity: mapAnswerTypeToSeverity
        };

        function getAvailableInspectionForms(dealerId) {
            return rcApi.get(INSPECT_BASEPATH + dealerId + '/availableinspectionforms');
        }

        function getInspectionSections(dealerId, roId) {
            return rcApi.get(INSPECT_BASEPATH + dealerId + '/ro/' + roId + '/sections');
        }
        
        function changeInspectionForm(dealerId, roId, inspectionFormId) {
            const data = {
                inspectionFormId: inspectionFormId
            };

            return rcApi.post(INSPECT_BASEPATH + dealerId + '/ro/' + roId + '/changeinspectionform', data);
        }

        function getRecsAndObservations(dealerId, taskId) {            
            return rcApi.get(INSPECT_BASEPATH + dealerId + '/task/' + taskId + '/recsandobservations');
        }

        function searchRecommendations(dealerId, searchTerm, addSearchTermAsResult) {
            const promise = rcApi.get(INSPECT_BASEPATH + dealerId + '/recommendations/search', {searchText: searchTerm});

            return processObsRecsResults(promise, searchTerm, addSearchTermAsResult);
        }

        function searchObservations(dealerId, searchTerm, addSearchTermAsResult) {
            const promise = rcApi.get(INSPECT_BASEPATH + dealerId + '/observations/search', {searchText: searchTerm});

            return processObsRecsResults(promise, searchTerm, addSearchTermAsResult);
        }

        function updateInspectionStatus(dealerId, roId, status) {
            return rcApi.post(`${INSPECT_BASEPATH}${dealerId}/ro/${roId}/inspectionstatus/${status}`);
        }

        function processObsRecsResults (promise, searchTerm, addSearchTermAsResult) {
            if (addSearchTermAsResult) {
                return promise.then((results) => {
                    results.unshift({
                        id: rcUtilService.getRandomNumber(),
                        name: searchTerm
                    });
    
                    return results;
                });               
            } else {
                return promise;
            }
        }

        function getTaskRecommendations(dealerId, roId, taskId) {
            return rcApi.get(INSPECT_BASEPATH + dealerId + '/ro/' + roId + '/task/' + taskId + '/recommendations');
        }

        function updateTaskStatus(dealerId, data) {
            return rcApi.post(INSPECT_BASEPATH + dealerId + '/task/status', data);
        }

        function updateTaskStatusBulk(dealerId, data) {
            return rcApi.post(INSPECT_BASEPATH + dealerId + '/task/status/bulk', data);
        }

        function saveTaskMeasurement(dealerId, measurementResult) {
            return rcApi.post(INSPECT_BASEPATH + dealerId + '/task/measurements', measurementResult);
        }

        function getPossibleAnswerTypes () {
            const answerTypes = INSPECT_CONSTANTS.roTaskAnswerType;

            return [answerTypes.pass, answerTypes.fail, answerTypes.caution, answerTypes.na];
        }

        function getAutoCompleteSettings(forRecommendations, callingVM, setSearchTermInSelection, customPlaceHolder, defaultResults, allowManualAdd) {
            let manualSearchValue = '';

            return {
                width: '100%',
                placeholder: customPlaceHolder ? customPlaceHolder : forRecommendations ? 'Correction' : 'Concern/Complaint',
                minimumInputLength: defaultResults ? 0 : 3,
                allowClear: false,
                selectOnClose: true,
                ajax: {
                    type: 'GET',
                    dataType: 'json',
                    data: function (parameters) {
                        let query = {
                            search: parameters.term,
                        };

                        return query;
                    },
                    transport: function (params, success, failure) {                        
                        if (callingVM.cancelPromise) {
                            callingVM.cancelPromise.resolve([]);
                        }

                        callingVM.cancelPromise = $q.defer();
                        
                        let promise = null;
                        
                        if ((params && params.data.search) || !defaultResults) {
                            if (defaultResults && params.data.search.length < 3) {
                                promise = $q.resolve([{id: -999, text: 'PLEASE ENTER 3 OR MORE CHARACTERS', displayName: 'PLEASE ENTER 3 OR MORE CHARACTERS'}]);
                            } else {
                                promise = forRecommendations ? searchRecommendations(callingVM.dealerId, params.data.search, callingVM.cancelPromise.promise) :
                                                               searchObservations(callingVM.dealerId, params.data.search, callingVM.cancelPromise.promise);
                            }
                        } else {
                            promise = $q.resolve(defaultResults);
                        }

                        promise.then(success, failure).finally(() => {
                            callingVM.cancelPromise = null;
                        });                        
                    },
                    delay: 500,
                    processResults: function (data, params) {
                        manualSearchValue = params.term;

                        if (allowManualAdd && params.term) {
                            data.unshift({
                                id: rcUtilService.getRandomNumber() * -1,
                                isManual: true,
                                name: params.term
                            });
                        }

                        return {
                            results: data.map(item => ({
                                id: item.id,
                                name: item.name,
                                isManual: item.isManual
                            }))
                        };
                    }
                },
                templateSelection: function (item) {
                    if (!setSearchTermInSelection) {
                        return null;
                    } else {
                        return item.name;
                    }
                },
                templateResult: function (item) {
                    if (item.loading) {
                        return 'Searching...';
                    }

                    if (item.isManual) {
                        let $new = $('<span class="text-normal-case font-italic text-color-gray">Hit ENTER to save freeform text</span>');

                        $new.on('click', (e) => {
                            e.preventDefault();
                            angular.element('#' + (forRecommendations ? 'recommendation-search' : 'observation-search')).trigger({
                                type: 'select2:select',
                                params: {
                                    data: item
                                }
                            });

                            if (forRecommendations) {
                                angular.element('#recommendation-search').select2('close');
                            } else {
                                angular.element('#observation-search').select2('close');
                            }
                        });

                        return $new;
                    }

                    return item.name;
                }
            };
        }

        function createNewShopNote(ro, recommendation) {
            return {
                uiId: recommendation.shopNotes.length + 1,
                note: '',
                noteType: 2, // CAZ - copied comment from previous code - TODO: Confirm this is the proper value. Appears to be what happens in the MP2 UI, but I don't know what it corresponds to
                repairOrderId: ro.id,
                recommendationResultId: recommendation.id
            };
        }

        function initRecommendations(ro, recommendations) {
            recommendations.forEach(rec => {
                rec.media = rec.media || [];
                rec.imagesToAdd = rec.imagesToAdd || [];
                rec.shopNotes = rec.shopNotes || [];

                rec.shopNotes.forEach(note => {
                    note.repairOrderId = ro.id;
                    note.recommendationResultId = rec.id;
                });
                
                rec.shopNotes.push(createNewShopNote(ro, rec));
            });            
        }

        function getDefaultRODetailTab () {
            return permissions.isTechnician() && (!permissions.isServiceAdvisor() && !permissions.isPartsAssociate()) ?  INSPECT_CONSTANTS.detailTabType.inspection : INSPECT_CONSTANTS.detailTabType.services;
        }

        function hasIncompleteMeasurements (task) {
            let measurementInputTypeEnum = INSPECT_CONSTANTS.measurementInputType;
            let hasMeasurements = task.inputOptions && task.inputOptions.length > 0;     
            
            if (!hasMeasurements) return false;

            let hasIncompleteMeasurements = _.some(task.inputOptions, (inputOption) => {
                return (inputOption.inputType === measurementInputTypeEnum.manual && (!inputOption.inputResponse || inputOption.inputResponse.length === 0)) ||
                       (inputOption.inputType === measurementInputTypeEnum.range && !inputOption.choiceResponseId);    
            });
            
            return hasIncompleteMeasurements;
        }
		

        function initROTotals () {
            return {
                    approvedAmounts: {
                        totalLabor: 0,
                        laborHours: 0,
                        totalParts: 0,
                        totalRetail: 0,
                        totalCustomerPay: 0,
                        totalTaxes: 0,
                        totalFees: 0,
                        totalShopSupplies: 0,
                        totalLineItemCount: 0
                    },
                    pendingAmounts: {
                        totalLabor: 0,
                        laborHours: 0,
                        totalParts: 0,
                        totalRetail: 0,
                        totalCustomerPay: 0,
                        totalTaxes: 0,
                        totalFees: 0,
                        totalShopSupplies: 0,
                        totalLineItemCount: 0
                    },
                    totalCombinedCustomerPay: 0
                };
        }

        function calculateLineItemTotals (lineItem, roTotals) { 
            if (!lineItem.useFlatPrice) {
                roTotals.totalLabor += lineItem.pricing.labor;
            }
            
            roTotals.laborHours += lineItem.laborHours;
            roTotals.totalParts += lineItem.pricing.parts;
            roTotals.totalRetail += lineItem.pricing.totalAmount;
            roTotals.totalFees += lineItem.pricing.fee;
            roTotals.totalLineItemCount ++;

            if (!lineItem.pricing.waiveShopSupplies) {
                roTotals.totalShopSupplies += lineItem.pricing.shopSupplies;
            }
        }

        function calculateROTotals (ro, lineItems, roTotals) {
            let lineItemStatus = INSPECT_CONSTANTS.lineItemStatus;

            lineItems.forEach((lineItem) => {
                if (lineItem.authorizationStatus === lineItemStatus.approved) {
                    calculateLineItemTotals(lineItem, roTotals.approvedAmounts);
                } else if (lineItem.authorizationStatus === lineItemStatus.open || lineItem.authorizationStatus === lineItemStatus.new) { 
                    roTotals.pendingAmounts.totalTaxes += lineItem.pricing.tax;
                    calculateLineItemTotals(lineItem, roTotals.pendingAmounts);
                }
            });

            if (ro.roTax > 0 && roTotals.approvedAmounts.totalLineItemCount > 0) {
                roTotals.approvedAmounts.totalTaxes += ro.roTax;
            }

            roTotals.approvedAmounts.totalCustomerPay = roTotals.approvedAmounts.totalRetail + roTotals.approvedAmounts.totalFees + roTotals.approvedAmounts.totalTaxes + roTotals.approvedAmounts.totalShopSupplies;
            roTotals.pendingAmounts.totalCustomerPay = roTotals.pendingAmounts.totalRetail + roTotals.pendingAmounts.totalFees + roTotals.pendingAmounts.totalTaxes + roTotals.pendingAmounts.totalShopSupplies;
            roTotals.totalCombinedCustomerPay = roTotals.approvedAmounts.totalCustomerPay + roTotals.pendingAmounts.totalCustomerPay;
            roTotals.approvedAmounts.laborHours = parseFloat(roTotals.approvedAmounts.laborHours.toFixed(2));
            roTotals.pendingAmounts.laborHours = parseFloat(roTotals.pendingAmounts.laborHours.toFixed(2));
        }

        async function proceedWithInspectionChange(currentStatus) {
            if (currentStatus === INSPECT_CONSTANTS.inspectionStatus.complete) {
                const confirm = await modalService.showYesNo('Inspection will be reopened', 'The Inspection is currently in a "Completed" state.  If you edit the Inspection it will be placed back to "In Progress".   Do you want to continue?', 'No', 'Yes');

                return confirm;
            } else {
                return true;
            }
        }
        
        function getFixedTaxesAndFeesTotal(shopTaxes, lineItems, itemizationEnabled, totals = null) {
            let fixedTaxesAndFees = [];
            let totalLabor = totals?.labor || 0;
            let totalParts = totals?.parts || 0;
            let totalAmount = totals?.totalAmount || 0;

            if (!itemizationEnabled || !shopTaxes || !lineItems) {
                return fixedTaxesAndFees;
            }

            lineItems.forEach(lineItem => {
                totalLabor += lineItem.pricing.labor || 0;
                totalParts += lineItem.pricing.parts || 0;
                totalAmount += lineItem.pricing.totalAmount || 0;
            });

            shopTaxes.forEach(tax => {
                if (isFixedTaxApplicable(tax, totalLabor, totalParts, totalAmount)) {
                    fixedTaxesAndFees.push({
                        description: tax.shopTaxFeeName,
                        amount: tax.fixedTax?.fixedAmount
                    });
                }
            });

            return fixedTaxesAndFees;
        }

        function isFixedTaxApplicable(shopTax, totalLabor, totalParts, totalAmount) {
            switch (shopTax.taxFeeApplyType) {
                case 1: // 'partsIsGreaterThan':
                    return totalParts > (shopTax.onlyApplyTaxIfGreaterThan || 0);
                case 2: // 'laborIsGreaterThan':
                    return totalLabor > (shopTax.onlyApplyTaxIfGreaterThan || 0);
                case 3: // 'totalIsGreaterThan':
                    return totalAmount > (shopTax.onlyApplyTaxIfGreaterThan || 0);
                default:
                    return true;
            }
        }

        function mapAnswerTypeToSeverity(answerType) {
            switch (answerType) {
                case INSPECT_CONSTANTS.roTaskAnswerType.pass:
                case INSPECT_CONSTANTS.roTaskAnswerType.na:
                    return INSPECT_CONSTANTS.severity.none;

                case INSPECT_CONSTANTS.roTaskAnswerType.fail:
                    return INSPECT_CONSTANTS.severity.addressImmediately;

                case INSPECT_CONSTANTS.roTaskAnswerType.caution:
                    return INSPECT_CONSTANTS.severity.addressSoon;

                default:
                    return INSPECT_CONSTANTS.severity.none;
            }
        }
    }           
})();

(function () {
    "use strict";

    angular
        .module("redcap.inspect")
        .factory("inspectModalService", ['$q', '$uibModal', '$aside', inspectModalService]);

    function inspectModalService($q, $uibModal, $aside) {
        return {
            showEditLineItem: showEditLineItem,
            assignTo: assignTo,
            showMediaViewer: showMediaViewer,
            changeInspectionForm: changeInspectionForm,
            createRo: createRo,
            compareToDms: compareToDms,
            importPartsQuote: importPartsQuote,
            showCustomerAuthorization: showCustomerAuthorization
        };

        function compareToDms(dealerId, ro) {
            const deferred = $q.defer();
            const modal = $uibModal.open({
                    templateUrl: 'app/areas/inspect/views/modals/compare-to-dms-modal.view.html',
                    controllerAs: 'vm',
                    windowClass: 'compare-to-dms-modal',
                    controller: 'InspectCompareToDmsController',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        resolvedRo: function () { return ro; },
                        resolvedDealerId: function () { return dealerId; }
                    }
                });

            return modal.result;
        }

        function showEditLineItem(ro, lineItem, dealerId, defaultTab) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/inspect/views/modals/edit-line-item-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'edit-line-item-modal',
                controller: 'EditLineItemModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedRo: function () { return ro; },
                    resolvedLineItem: function () { return lineItem; },
                    resolvedDealerId: function() { return dealerId; },
                    resolvedDefaultTab: function() { return defaultTab || 0; }
                }
            });

            return modal.result;
        }

        function showMediaViewer(ro, dealerId, lineItem) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/inspect/views/modals/media-viewer-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'media-viewer-modal',
                controller: 'MediaViewerModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedRo: function () { return ro; },
                    resolvedDealerId: function () { return dealerId; },
                    resolvedLineItem: function () { return lineItem; }
                }
            });

            return modal.result;
        }

        function assignTo(ro, dealerId) {
            let deferred = $q.defer();
                let modal = $uibModal.open({
                templateUrl: 'app/areas/inspect/views/modals/assign-to-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'assign-to-modal',
                controller: 'AssignToModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedRo: function () { return ro; },
                    resolvedDealerId: function() { return dealerId; }
                }
            });
         
            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }  

        function changeInspectionForm(ro, dealerId) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/inspect/views/modals/change-inspection-form-modal.view.html',
                controllerAs: 'vm',
                controller: 'ChangeInspectionFormModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedRo: function () { return ro; },
                    resolvedDealerId: function() { return dealerId; }
                }
            });

            return modal.result;
        }
        
        function importPartsQuote(ro, dealerId) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/inspect/views/modals/import-parts-quote-modal.view.html',
                controllerAs: 'vm',
                controller: 'ImportPartsQuoteModalController',
                backdrop: 'static',
                keyboard: false,
                size: '60-percent',
                windowClass: 'allow-content-overlay',
                resolve: {
                    resolvedRo: function () { return ro; },
                    resolvedDealerId: function() { return dealerId; } 
                }
            });            
            
            return modal.result;           
        }

        function createRo(dealer) {
            let modal = $uibModal.open({
                templateUrl: 'app/areas/inspect/views/modals/create-ro-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'create-ro-modal',
                controller: 'CreateRoModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    resolvedDealer: function() { return dealer; }
                }
            });

            return modal.result;
        }

        function showCustomerAuthorization(repairOrder, selectedLineItems) {
            let modal = $aside.open({
                templateUrl: 'app/shared/components/authorizations/partials/authorize-services-modal.html',
                container: 'body',
                placement: 'bottom',
                animation: false,
                backdrop: 'static',
                show: false,
                html: true,
                keyboard: false,
                size: '60-percent',
                controllerAs: 'vm',
                windowClass: 'aside-centered',
                controller: ['$uibModalInstance', 'resolvedRo', 'resolvedSelectedLines', function($uibModalInstance, resolvedRo, resolvedSelectedLines) {
                    let vm = this;
                    let saveFn = null;

                    vm.repairOrder = resolvedRo;
                    vm.selectedLineItems = resolvedSelectedLines;

                    vm.registerStepProcessor = (fn) => { saveFn = fn; };

                    vm.save = function() {
                        vm.isLoading = true;

                        saveFn().then(() => { vm.servicesSaved = true; }).finally(() => { vm.isLoading = false; });
                    };

                    vm.close = function() {
                        $uibModalInstance.close(vm.servicesSaved);
                    };
                }],
                resolve: {
                    resolvedRo: function() { return repairOrder; },
                    resolvedSelectedLines: function() { return selectedLineItems; }
                },
            });
            
            return modal.result;
        }
    }
})();

(function () {
    'use strict';

    inspectActionService.$inject = ["$state", "$rootScope", "$timeout", "INSPECT_CONSTANTS", "roService", "modalService", "inspectModalService", "liberatedAsideService"];
    angular
        .module('redcap.inspect')
        .factory('inspectActionService', inspectActionService);

    function inspectActionService($state, $rootScope, $timeout, INSPECT_CONSTANTS, roService, modalService, inspectModalService, liberatedAsideService) {
        return {
            triggerAction: triggerAction
        };

        function triggerAction (actionType, dealerId, ro, bypassEvents) {           
            if (!actionType) return;
            
            let action = _.find(INSPECT_CONSTANTS.inspectActions, (a) => { return a.id === actionType; });            
            let actionPromise = null;

            switch (action.id) {
                case INSPECT_CONSTANTS.actionEnum.addRecommendation:
                    actionPromise = liberatedAsideService.showAddLineItem(ro, dealerId, null, null);
                    break;

                case INSPECT_CONSTANTS.actionEnum.assignTo:        
                    actionPromise = inspectModalService.assignTo(ro, dealerId).then((updateSuccessful) => {
                        if (updateSuccessful && !bypassEvents) {
                            $rootScope.$broadcast('selectRoTab', ro);
                        }

                        return updateSuccessful;
                    });                               
                    break;

                case INSPECT_CONSTANTS.actionEnum.changeInspectionForm:        
                    actionPromise = inspectModalService.changeInspectionForm(ro, dealerId);                               
                    break;

                case INSPECT_CONSTANTS.actionEnum.sendForPayment:
                    if (!ro.dmsRepairOrderNumber) {
                        actionPromise = modalService.showYesNo('RO not in DMS yet', 'Please push updates to the DMS before choosing Send to Payments.', null, 'Ok', true, true);                        
                    } else {
                        actionPromise = createInvoice(dealerId, ro.id);
                    }
                    
                    break;

                case INSPECT_CONSTANTS.actionEnum.updateFromDms:
                    actionPromise = updateFromDMS(dealerId, ro);
                    break; 
                
                case INSPECT_CONSTANTS.actionEnum.printInspectionSummary:
                    actionPromise = liberatedAsideService.showInspectionSummary(ro);
                    break;    

                case INSPECT_CONSTANTS.actionEnum.updateRo: 
                    actionPromise = updateRo(dealerId, ro);
                    break;
            }        

            if (actionPromise) {
                return actionPromise;
            } else {
                return Promise.resolve(false);
            }
        }

        async function updateRo(dealerId, ro) {
            const lineItems = await roService.getRoLineItems(dealerId, ro.id);
            const serviceOperations = lineItems.map(li => li.serviceOperations).flat();
    
            if (serviceOperations) {
                let approvedLines = serviceOperations.filter((line) => line.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.approved);
                let opcodeMissingLines = approvedLines.filter((line) => !line.opCode || line.opCode === '');
                let allLinesMissingOpCode = approvedLines.length > 0 && opcodeMissingLines.length === approvedLines.length;

                if (approvedLines && approvedLines.length > 0) {
                    let body = opcodeMissingLines.length > 0 
                        ? `Are you sure you want to push the updates to DMS?<br>
                        Please note the following issue(s) that may result in incorrect totals or missing items:<br>
                        <ul>
                            <li>One or more items do not have an Op Code.</li>
                        </ul>` 
                        : `Are you sure you want to push updates to ALL approved services to the DMS (${approvedLines.length} services total)?`;
                    const confirmed = await modalService.showYesNo('Confirm', body, 'No', 'Yes', false);
        
                    if (confirmed && !allLinesMissingOpCode) {                
                        return roService.updateRoInDms(dealerId, ro.id).catch((err) => {
                            const errors = [err.data?.message || ''];
                            
                            modalService.showError('Sorry, there was a problem pushing the update to the DMS.', errors);
                        });
                    } else {
                        return Promise.resolve(false);
                    }
                }
            }
            
            let body = `At least one approved service must be available to update the RO.`;

            await modalService.showError(body, body, true);
            
            return Promise.resolve(false);
        }

        async function createInvoice(dealerId, roId, bypassWarnings) {
            let invoiceResponse = await roService.createInvoice(dealerId, roId, bypassWarnings);

            if (invoiceResponse.invoiceId) {
                $state.go('payment-edit', {invoiceId: invoiceResponse.invoiceId});
            } else {
                if (bypassWarnings) return Promise.resolve(false); // we've already pressed the confirm button, so don't show the modal again

                let modalTitle = 'Please note the following issue(s) that may result in incorrect totals or missing items:';
                let messagesHtml = invoiceResponse.messages.map((message) => { return `<li>${message}</li>`; }).join('');
                let warningHtml = `<div>${modalTitle}</div> <ul>${messagesHtml}</ul>`;                
                let confirmed = await modalService.showYesNo('Are you sure you want to create an Invoice?', warningHtml, 'No', 'Yes', false);

                if (confirmed) {
                    await createInvoice(dealerId, roId, true);
                } else {
                    return Promise.resolve(false);
                }
            }
        }

        async function updateFromDMS(dealerId, ro) {
            let body = `Are you sure you want to pull all updates from the DMS?`;
            const confirmed = await modalService.showYesNo('Confirm', body, 'No', 'Yes', false);

            if (confirmed) {                
                return inspectModalService.compareToDms(dealerId, ro);
            } else {
                return Promise.resolve(false);
            }
        }
    }
})();

(function () {
    'use strict';

    LineItemRecommendationController.$inject = ["INSPECT_CONSTANTS", "inspectionService", "authService", "appointmentUtilService", "appointmentService", "locationService", "modalService", "SYSTEM_ENUMS", "azureBlob", "$q", "roService", "$timeout", "rcUtilService"];
    angular
        .module('redcap.inspect')
        .component('lineItemRecommendation', {
            bindings: {
                lineItem: '<',
                ro: '<',
                dealerId: '<',
                showMediaViewer: '='
            },
            templateUrl: 'app/areas/inspect/views/components/line-item-recommendation.view.html',
            controller: LineItemRecommendationController,
            controllerAs: 'vm'
        });

    function LineItemRecommendationController(INSPECT_CONSTANTS, inspectionService, authService, appointmentUtilService, appointmentService, locationService, modalService, SYSTEM_ENUMS, azureBlob, $q, roService, $timeout, rcUtilService) {
        this.$onInit = function() {
            let vm = this;
            let pageSize = 25;

            const isOcr = vm.lineItem.sourceType === SYSTEM_ENUMS.lineItemSource.originalCustomerRequest || vm.lineItem.sourceType === SYSTEM_ENUMS.lineItemSource.checkIn;

            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.answerTypes = INSPECT_CONSTANTS.roTaskAnswerType;
            vm.inspectActions = INSPECT_CONSTANTS.inspectActions;
            vm.measurementUnitTypes = INSPECT_CONSTANTS.measurementUnitType;
            vm.possibleAnswerTypes = inspectionService.getPossibleAnswerTypes();
            vm.lineItemSeverities = SYSTEM_ENUMS.lineItemSeverity;
            vm.lineItem.correctionRequired = !isOcr;
            vm.lineItem.complaintRequired = !isOcr;            

            vm.updateTaskStatus = function(status) {                
                // TODO: Update the status associated with the task for this line item.
                // inspectionService.updateTaskStatus(vm.ro.status.organizationUnitCacheKey, task.taskResponse, vm.ro.vin, task.taskId, vm.ro.id);                
            };

            vm.formatForSelection = function (item) {
                return appointmentUtilService.formatOpCodeForDropDown(item);
            };

            vm.formatForDropdown = function (item) {
                return appointmentUtilService.formatOpCodeForDropDown(item);
            };

            vm.opCodeSearchQuery = {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    let query = {
                        search: parameters.term,
                        dealerId: vm.dealerId,
                        page: parameters.page,
                        pageSize: pageSize
                    };
    
                    return query;
                },
                transport: function (params, success, failure) {
                    let data = params.data;

                    return locationService.searchLocationOpCodes(vm.dealerId, 0, data.search, data.page, data.pageSize, true).then(success, failure);
                },
                delay: 800,
                processResults: function (data) {
                    return {
                        results: data,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            };

            vm.tagClicked = function(tag, lineItem, forComplaints) {
                lineItem.isEditingComplaint = forComplaints;
                lineItem.isEditingCorrection = !forComplaints;
                lineItem.tagToEdit = tag;
                lineItem.tagContent = tag.name;
            };
    
            vm.closeTagEdit = function(shouldSave, lineItem) {
                if (shouldSave) {
                    const elementId = (lineItem.isEditingComplaint ? '#observation_search' : '#recommendation_search') + `_${lineItem.id}`;
                    const collectionToEdit = lineItem.isEditingComplaint ? lineItem.complaints : lineItem.corrections;
                    const indexToEdit = collectionToEdit.findIndex((c) => c === lineItem.tagToEdit.name);
    
                    // Because the tag-inputs component does not send the event that triggered the click, we have to manually find the element based on the index :/
                    const tagElement = document.querySelectorAll(`${elementId} li span`)[indexToEdit];
    
                    // Since the tags component doesn't provide a direct way to edit tags, we update each portion of the tag manually here.
                    $timeout(() => {
                        lineItem.tagToEdit.name = lineItem.tagContent;
                        collectionToEdit[indexToEdit] = lineItem.tagContent;
                        tagElement.innerHTML = lineItem.tagContent;
                    }, 0);            
                }
    
                lineItem.isEditingComplaint = false;
                lineItem.isEditingCorrection = false;            
            };

            vm.onTagRemoved = function(lineItem, isComplaint) {
                if (isComplaint) {
                    lineItem.isEditingComplaint = false;
                } else {
                    lineItem.isEditingCorrection = false;
                }
            };

            vm.addNote = function() {
                if (!vm.lineItem.newNote || !vm.lineItem.newNote.length) return;

                vm.lineItem.notes = vm.lineItem.notes || [];

                let currentUser = authService.getCurrentUser();
               
                vm.lineItem.notes.push({message: vm.lineItem.newNote, id: null, dateCreated: moment.utc(new Date()).toISOString(), authorName: currentUser.fullName});

                vm.lineItem.newNote = '';
            };

            vm.addRecommendationImage = function($model, file, $files, $event, $id, reference, container, forceAdd) {
                vm.addingImage = true;
                let deferred = $q.defer();

                vm.imageType = appointmentUtilService.getImageTypes();
                let currentUser = authService.getCurrentUser();

                appointmentService.getImageToken(vm.dealerId, vm.imageType.recommendedMaintenance)
                    .then((result) => {
                        let config = {
                            baseUrl: result.url,
                            file: file,
                            complete: function () {
                                $model.imageId = result.imageId;
                                $model.url = result.url;
                                $model.imageType = vm.imageType.recommendedMaintenance;
                                $model.fileExtension = file.type;
                                $model.dateTaken = new Date();                                
                                
                                vm.isLoading = false;
                                vm.imageToUpload = {};
                                deferred.resolve(_.cloneDeep($model));
                                let mediaObject = [{
                                    mediaUrl: $model.url,
                                    fileExtension: $model.fileExtension,
                                    azureImageId: $model.imageId,
                                    createdByUserId: currentUser.userId,
                                    durationSeconds: rcUtilService.getMediaDuration(file.$ngfDuration)
                                }];
            
                                roService.saveRecMedia(vm.dealerId, vm.ro.id, vm.lineItem.id, mediaObject)
                                    .then((response) => {
                                        return roService.getRecMedia(vm.dealerId, vm.ro.id, vm.lineItem.id);
                                    })
                                    .then((mediaResponse) => {
                                        vm.lineItem.mediaItems = mediaResponse;
                                    })
                                    .catch((error) => {
                                        console.error('Error saving or fetching media', error);
                                    });

                                vm.addingImage = false;

                                vm.imageToUpload = {};
                            },
                            error: function(err) {
                                deferred.reject(err);
                                vm.isLoading = false;
                            },
                            blockSize: 4000000000
                        };

                        azureBlob.upload(config);
                });
  
                return deferred.promise; 
            };

            vm.mediaBtnClicked = function () {
                vm.showMediaViewer = true;
            };

            vm.openImageModal = function(image, mediaType) {
                modalService.showImageViewer(image.mediaUrl, 'Recommendation Image', mediaType);
            };

            vm.searchObservations = function(searchTerm) {
                return inspectionService.searchObservations(vm.dealerId, searchTerm, true);
            };
    
            vm.searchRecommendations = function(searchTerm) {
                return inspectionService.searchRecommendations(vm.dealerId, searchTerm, true);
            };
        };
    }
})();

(function () {
    'use strict';

    LineItemEstimateController.$inject = ["$q", "$timeout", "rcUtilService", "employeeService", "permissions", "roService", "dealerInspectionService", "SYSTEM_ENUMS", "locationService", "INSPECT_CONSTANTS", "modalService"];
    angular
        .module('redcap.inspect')
        .component('lineItemEstimate', {
            bindings: {
                dealerId: '<',
                lineItem: '<',
                ro: '<'
            },
            templateUrl: 'app/areas/inspect/views/components/line-item-estimate.view.html',
            controller: LineItemEstimateController,
            controllerAs: 'vm'
        });

    function LineItemEstimateController($q, $timeout, rcUtilService, employeeService, permissions, roService, dealerInspectionService, SYSTEM_ENUMS, locationService, INSPECT_CONSTANTS, modalService) {
        this.$onInit = function() {
            let vm = this;
            
            vm.today = Date.now();
            vm.roId = vm.ro.id;
            vm.lineItem.pricing.taxesPendingUpdate = false;
            vm.isFixedTaxRate = false;
            vm.payTypes = SYSTEM_ENUMS.payType;
            vm.dmsSystemEnum = SYSTEM_ENUMS.dmsSystemEnum;
            vm.lineItemStatuses = INSPECT_CONSTANTS.lineItemStatus;
            vm.assignmentRoles = INSPECT_CONSTANTS.assignmentRoles;
           
            vm.partsAssociateFilter = function (user) {
                return user.roles.some((r) => {
                    return r.toLowerCase() === SYSTEM_ENUMS.roleNames.partsAssociate.toLowerCase();
                });
            };

            function init() {
                vm.loadingPricing = true;

                const partsStatusPromise = dealerInspectionService.getPartsStatus(vm.dealerId).then((partsAvailability) => {
                    vm.partsAvailability = partsAvailability;
                });

                const laborRatePromise = roService.getLaborRateOptions(vm.dealerId, vm.ro.id).then((laborRateSettings) => {
                    vm.laborRateSettings = laborRateSettings;                    
                });

                const dealerUsersPromise = loadDealerUsers();

                const dealerDetailsPromise = locationService.getLocationDetails(vm.dealerId).then((dealerDetails) => {
                    vm.dealerDetails = dealerDetails;
                });

                const promises = [partsStatusPromise, laborRatePromise, dealerUsersPromise, dealerDetailsPromise];
                
                Promise.all(promises).then(() => {
                    setupPricing();
                    handlePartsSearch();
                    setOpcodeSearchStyling();
                    loadDealerUsers();
                }).finally(() => {
                    vm.loadingPricing = false;
                });

                loadPartsAvailability();
            }

            function loadDealerUsers() {
                const partsAssociateIds = (vm.lineItem.parts).map(part => part.partsAssociateId).filter((id, index, ids) => id && ids.indexOf(id) === index);

                return employeeService.getConfiguredEmployeesByLocation(vm.dealerId, partsAssociateIds).then((users) => {
                    vm.dealerUsers = users;

                    initializePartsAssociates();
                });
            }

            function loadPartsAvailability() {
                if (vm.lineItem) {
                    if (!vm.lineItem.parts) return;

                    vm.lineItem.parts.forEach((part) => {
                        loadPartAvailability(part);
                    });
                }
            }

            function initializePartsAssociates() {
                vm.lineItem.parts.forEach((part) => {
                    part.selectedPartsAssociate = vm.dealerUsers.find(u => u.id === part.partsAssociateId);
                });
            }

            function loadPartAvailability(part) {
                roService.getPartAvailability(vm.dealerId, vm.roId, part.id).then(result => {
                    if (result) {
                        part.quantityOnHand = result.quantityOnHand;
                        part.quantityOnHold = result.quantityOnHold;
                        part.bin = result.bin;
                    }
                }).catch(error => {
                    part.dmsError = error;
                }).finally(() => {
                    part.isDmsLoaded = true;
                });
                
                return part;
            }

            function setupPricing() {
                vm.lineItem.selectedPayType = getPayType(vm.lineItem.pricing.payType);
                const isManualRate = vm.lineItem.pricing.isManualLaborRate;

                setupLaborRateSelection(isManualRate);

                vm.lineItem.laborCharge = isManualRate ? vm.lineItem.pricing.labor : vm.lineItem.laborHours * vm.lineItem.laborRate;
                vm.lineItem.partsCharge = _.sum(_.map(vm.lineItem.parts, (part) => {
                    return (part.quantity * part.displayPrice); 
                }));

                vm.lineItem.pricing.taxesAndFees = vm.lineItem.pricing.fee;
                
                if (!vm.lineItem.pricing.isTaxExempt) {
                    vm.lineItem.pricing.taxesAndFees += vm.lineItem.pricing.tax;
                }

                if (!vm.lineItem.pricing.waiveShopSupplies) {
                    vm.lineItem.pricing.taxesAndFees += vm.lineItem.pricing.shopSupplies;
                }

                vm.updateTotalCharge(true);
            }

            function setupLaborRateSelection(isManualRate) {
                const manualCustomRate = vm.laborRateSettings.customLaborRateOptions.find(rate => rate.isManualLaborRate);
                const manualMatrixRate = vm.laborRateSettings.matrixRateOptions.find(rate => rate.isManualLaborRate);

                if (vm.lineItem.pricing.customRateId) {
                    vm.lineItem.selectedFixedRate = isManualRate ? manualCustomRate : vm.laborRateSettings.customLaborRateOptions.find(rate => rate.id === vm.lineItem.pricing.customRateId);
                } else if (vm.lineItem.pricing.laborMatrixId) {
                    vm.lineItem.selectedLaborMatrix = isManualRate ? manualMatrixRate : vm.laborRateSettings.matrixRateOptions.find(rate => rate.id === vm.lineItem.pricing.laborMatrixId);
                } else if (vm.isCustomerPayType()) {
                    if (vm.lineItem.authorizationStatus !== INSPECT_CONSTANTS.lineItemStatus.na) { // This is to find out if the line item has come from DMS or not so that we can avoid the default selection of labor rate or Labor Matrix 
                        // Handle customer pay type defaults
                        if (vm.laborRateSettings.useMatrixRate) {
                            vm.lineItem.selectedLaborMatrix = isManualRate ? manualMatrixRate : vm.laborRateSettings.matrixRateOptions.find(rate => rate.isDefault);
                            vm.onLaborMatrixChanged(true);
                        } else {
                            vm.lineItem.selectedFixedRate = isManualRate ? manualCustomRate : vm.laborRateSettings.customLaborRateOptions.find(rate => rate.isDefault);

                            if (vm.lineItem.selectedFixedRate?.rate) {
                                vm.lineItem.laborRate = vm.lineItem.selectedFixedRate.rate;
                            }
                        }
                    }
                }
            }

            function getPayType(payTypeId) {
                let payType = vm.laborRateSettings.defaultPayTypes.find(rate => rate.payType === payTypeId);
                    
                if (!payType) {
                    // Fall back to customer pay type (ID 1)
                    payType = vm.laborRateSettings.defaultPayTypes.find(rate => rate.payType === vm.payTypes.customer);
                }
                    
                return payType;
            }

            vm.partsAssociateChanged = function(part) {
                part.partsAssociateId = part.selectedPartsAssociate?.id;
            };

            vm.showPartsAssociate = function() {
                return vm.ro.dmsSystem === vm.dmsSystemEnum.DealerTrack;
            };

            vm.onNoLaborChargeClicked = function() {
                if (vm.lineItem.noLaborCharge) {
                    if (vm.lineItem.noPartsCharge) {
                        vm.lineItem.pricing.flatRetailAmount = 0;
                    } else {
                        vm.lineItem.pricing.flatRetailAmount = vm.lineItem.partsCharge;
                    }  
                } else {
                    if (!vm.lineItem.pricing.isManualLaborRate) {
                        vm.lineItem.laborCharge = vm.lineItem.laborHours * vm.lineItem.laborRate;
                    }
                    
                    if (vm.lineItem.noPartsCharge) {
                        vm.lineItem.pricing.flatRetailAmount = vm.lineItem.laborCharge;
                    } else {
                        vm.lineItem.pricing.flatRetailAmount = vm.lineItem.laborCharge + vm.lineItem.partsCharge;
                    }
                }
            };

            vm.onNoPartsChargeClicked = function() {
                if (vm.lineItem.noPartsCharge) {
                    if (vm.lineItem.noLaborCharge) {
                        vm.lineItem.pricing.flatRetailAmount = 0;
                    } else {
                        vm.lineItem.pricing.flatRetailAmount = vm.lineItem.laborCharge;
                    }
                } else {
                    vm.lineItem.partsCharge = _.sum(_.map(vm.lineItem.parts, (part) => {
                        return (part.quantity * part.displayPrice); 
                    })); 

                    if (vm.lineItem.noLaborCharge) {
                        vm.lineItem.pricing.flatRetailAmount = vm.lineItem.partsCharge;
                    } else {
                        vm.lineItem.pricing.flatRetailAmount = vm.lineItem.laborCharge + vm.lineItem.partsCharge;
                    }

                    vm.updateTotalCharge();
                }
            };

            vm.onUseFlatPriceClicked = function() {
                vm.updateTotalCharge();
            };

            vm.onLaborMatrixChanged = function(initializing) {
                if (vm.isCustomerPayType()) {
                    if (vm.lineItem.selectedLaborMatrix) {
                        setLaborRateFromSelectedMatrixRate();
                    }
                }

                vm.calculateLaborCharge(initializing);
            };

            function setLaborRateFromSelectedMatrixRate() {
                vm.lineItem.pricing.isManualLaborRate = vm.lineItem.selectedLaborMatrix.isManualLaborRate;

                if (vm.lineItem.pricing.isManualLaborRate) {
                    return;
                }

                for (let i = 0; i < vm.lineItem.selectedLaborMatrix.matrix.length; i++) {
                    for (let j = 0; j < vm.lineItem.selectedLaborMatrix.matrix[i].length; j++) {
                        let currentLaborHour = Math.floor(vm.lineItem.laborHours * 10) / 10;
                        let matrixLaborHour = parseFloat(i + '.' + j);

                        if (currentLaborHour === matrixLaborHour) {
                            vm.lineItem.laborRate = vm.lineItem.selectedLaborMatrix.matrix[i][j];
                            
                            return;
                        }
                    }
                }
            }

            vm.calculateLaborCharge = function(initializing) {                
                let laborHours = Number(vm.lineItem.laborHours);
                let rate = Number(vm.lineItem.laborRate);

                if (!vm.lineItem.noLaborCharge && !vm.lineItem.pricing.isManualLaborRate) {
                    vm.lineItem.laborCharge = _.round(laborHours * rate, 2);
                }
                
                vm.updateTotalCharge(initializing);
            };

            vm.onFixedRateChanged = function() {
                if (vm.lineItem.selectedFixedRate?.isManualLaborRate) {
                    vm.lineItem.pricing.isManualLaborRate = true;
                    vm.lineItem.laborCharge = vm.lineItem.pricing.labor || 0;
                } else {
                    vm.lineItem.pricing.isManualLaborRate = false;

                    if (vm.lineItem.selectedFixedRate?.rate) {
                        vm.lineItem.laborRate = vm.lineItem.selectedFixedRate.rate;
                    }
                }

                vm.calculateLaborCharge();
            };

            vm.onPayTypeChanged = function(initializing) {  
                const payType = vm.lineItem.selectedPayType;

                if (vm.isCustomerPayType()) {
                    if (!vm.lineItem.selectedFixedRate) {
                        // Handle matrix rate selection
                        if (vm.lineItem.selectedLaborMatrix?.isManualLaborRate) {
                            if (setupManualLaborRate()) return;
                        } else {
                            if (!vm.lineItem.selectedLaborMatrix && vm.laborRateSettings.useMatrixRate) {
                                vm.lineItem.selectedLaborMatrix = vm.laborRateSettings.matrixRateOptions.find(rate => rate.isDefault);
                            }

                            vm.lineItem.pricing.isManualLaborRate = false;
                            vm.onLaborMatrixChanged(initializing);
                        }
                    } else {
                        // Handle fixed rate selection
                        if (!vm.lineItem.selectedFixedRate && !vm.laborRateSettings.useMatrixRate && vm.laborRateSettings.customLaborRateOptions) {
                            vm.lineItem.selectedFixedRate = vm.laborRateSettings.customLaborRateOptions.find(rate => rate.isDefault);
                        }

                        if (vm.lineItem.selectedFixedRate?.isManualLaborRate) {
                            if (setupManualLaborRate()) return;
                        } else {
                            vm.lineItem.pricing.isManualLaborRate = false;

                            if (vm.lineItem.selectedFixedRate?.rate) {
                                vm.lineItem.laborRate = vm.lineItem.selectedFixedRate.rate;
                            }
                        }
                    } 
                } else {
                    // Non-customer pay type
                    vm.lineItem.pricing.isManualLaborRate = false;
                    vm.lineItem.laborRate = payType.rate || vm.lineItem.laborRate;
                }

                vm.calculateLaborCharge(initializing);
            };

            
            function setupManualLaborRate() {
                vm.lineItem.pricing.isManualLaborRate = true;
                vm.lineItem.laborCharge = vm.lineItem.pricing.labor || 0;
                
                return true;
            }

            vm.updateTotalCharge = function(skipTaxFlag, partToUpdate) {
                if (partToUpdate) {
                    const partPrice = parseFloat(partToUpdate.displayPrice || 0);

                    if (partPrice !== partToUpdate.retailPrice) {
                        partToUpdate.overridePrice = partPrice;
                    } else {
                        partToUpdate.overridePrice = null;
                    }

                    partToUpdate.total = parseFloat(partToUpdate.quantity || 0) * partPrice;

                    vm.lineItem.partsCharge = _.sum(_.map(vm.lineItem.parts, (part) => {
                        return (parseFloat(part.quantity || 0) * parseFloat(part.displayPrice || 0)); 
                    }));
                }

                if (!skipTaxFlag) {
                    vm.lineItem.pricing.taxesPendingUpdate = true;
                }

                let feeTotal = 0;

                if (!vm.lineItem.pricing.waiveShopSupplies) {
                    feeTotal += vm.lineItem.pricing.shopSupplies;
                }

                if (!vm.lineItem.useFlatPrice) {
                    if (vm.lineItem.noLaborCharge && vm.lineItem.noPartsCharge) {
                        vm.lineItem.pricing.flatRetailAmount = 0;
                    } else if (vm.lineItem.noLaborCharge) {
                        vm.lineItem.pricing.flatRetailAmount = parseFloat(vm.lineItem.partsCharge);
                    } else if (vm.lineItem.noPartsCharge) {
                        vm.lineItem.pricing.flatRetailAmount = parseFloat(vm.lineItem.laborCharge);
                    } else {
                        vm.lineItem.pricing.flatRetailAmount = parseFloat(vm.lineItem.laborCharge) + parseFloat(vm.lineItem.partsCharge);
                    }
                }

                if (!vm.lineItem.pricing.isTaxExempt) {
                    feeTotal += (vm.lineItem.pricing.tax || 0);
                }

                feeTotal += parseFloat(vm.lineItem.pricing.fee) || 0;
                vm.lineItem.pricing.taxesAndFees = feeTotal;
            };

            vm.removePart = function(partToRemove) {
                partToRemove.removingPart = true;
                let partId = partToRemove.id;
                
                vm.removingPart = true;
                roService.removePart(vm.dealerId, vm.ro.id, vm.lineItem.id, partId).then((result) => {
                    if (result) {
                        _.remove(vm.lineItem.parts, (part) => { return part.id === partId; });
                        vm.updateTotalCharge(true, partToRemove);
                    } else {
                        console.error('There was an error removing the part', result);
                    }
                }).finally(() => { vm.removingPart = false; });
            };

            vm.isCustomerPayType = function() {
                return vm.lineItem.selectedPayType && 
                       (vm.lineItem.selectedPayType.payType === vm.payTypes.customer || 
                        vm.lineItem.selectedPayType.payType === vm.payTypes.serviceContract);
            };

            vm.validation = {
                validateDecimal: function (value, decimals) {
                    if (!value) {
                        return {value: 0};
                    }

                    const num = parseFloat(value);
                    
                    if (isNaN(num) || num < 0) {
                        return {value: 0};
                    }
                    
                    return {value: parseFloat(num.toFixed(decimals))};
                }
            };

            function handlePartsSearch() {               
                // The templateSelection event on the select2 settings gets fired twice (which is a bug in select2), 
                //  so we explicitly handle this event here, which only gets fired once. 
                $timeout(() => {
                    let $search = angular.element('#parts-search');

                    $search.off('select2:select');

                    $search.on('select2:select', (selection) => {
                        let selectedPart = selection.params.data;
                        let partData;

                        if (selectedPart.isManual) {
                            partData = {
                                description: selectedPart.description,
                                manufacturer: 'NA',
                                overridePrice: 0,
                                retailPrice: null,
                                partNumber: selectedPart.description,
                                quantity: 1,
                                partsAssociateId: vm.ro.partsAssociate?.id
                            };
                            
                            partData.total = partData.quantity * partData.overridePrice;
                        } else {
                            partData = {
                                description: selectedPart.description,
                                manufacturer: selectedPart.manufacturer,
                                overridePrice: selectedPart.overridePrice,
                                retailPrice: selectedPart.retailPrice,
                                partNumber: selectedPart.partNumber,
                                total: 0,                                
                                dmsPartId: selectedPart.dmsPartId,
                                partsAssociateId: vm.ro.partsAssociate?.id
                            };
                        }

                        vm.addingPart = true;

                        if (vm.showPartsAssociate() && !vm.ro.partsAssociate && permissions.isPartsAssociate()) {
                            assignCurrentUserAsPartsAssociate();
                        }

                        roService.addPart(vm.dealerId, vm.ro.id, vm.lineItem.id, partData).then((addedPart) => {   
                            addedPart.isDmsLoaded = true;
                            addedPart.selectedPartsAssociate = vm.dealerUsers.find((u) => u.id === addedPart.partsAssociateId);

                            vm.lineItem.parts.push(addedPart);

                            vm.updateTotalCharge(true, addedPart);
                        }).finally(() => { vm.addingPart = false; });

                        // This clears the text input from the autocomplete search.  Select2 does not offer a better way to do this :(
                        $search.val('').trigger('change');
                    });
                }, 0);
            }

            function assignCurrentUserAsPartsAssociate() {
                roService.assignCurrentUserToRole(vm.dealerId, vm.ro, vm.assignmentRoles.partsAssociate, 'There is no Parts Associate currently assigned. Click OK to assign yourself', modalService)
                    .then(assignedUser => {
                        if (assignedUser) {
                            vm.ro.partsAssociate = assignedUser;
                            
                            vm.lineItem.parts.forEach(part => {
                                if (!part.partsAssociateId) {
                                    part.selectedPartsAssociate = assignedUser;
                                    part.partsAssociateId = assignedUser.id;
                                }
                            });
                        }
                    });
            }

            function setOpcodeSearchStyling() {
                let $search = angular.element('#opcode-search');

                $search .on('select2:open', (e) => {
                    let inputEl = angular.element('.select2-selection.select2-selection--multiple');
                    let ddEl = angular.element('.select2-dropdown.select2-dropdown--below');
                    let width = inputEl.outerWidth();

                    ddEl.css('max-width', width + 'px');
                  });
            }

            // TODO: SEE IF WE CAN MOVE THIS SO IT'S NOT DUPLICATED
            vm.partsSearchSettings = {
                width: '100%',
                placeholder: 'Search parts',
                minimumInputLength: 3,
                maximumSelectionLength: 1,
                allowClear: false,
                ajax: {
                    type: 'GET',
                    dataType: 'json',
                    data: function(parameters) {
                        let query = {
                            search: parameters.term,
                        };

                        return query;
                    },
                    transport: function(params, success, failure) {
                        if (vm.cancelPromise) {
                            vm.cancelPromise.resolve([]);
                        }

                        vm.cancelPromise = $q.defer();

                        roService.searchParts(vm.dealerId, params.data.search, vm.cancelPromise.promise).then((parts) => {
                            parts.forEach((part) => {
                                part.id = part.dmsPartId || part.partNumber;
                            });

                            success(parts);
                        }, failure).finally(() => {
                            vm.cancelPromise = null;
                        });
                    },
                    delay: 1250,
                    processResults: function(data, params) {
                        data.push({
                            isManual: true,
                            description: params.term
                        });

                        return {
                            results: data
                        };
                    }
                },
                templateSelection: function(evt, item) {
                    return null;
                },
                templateResult: function(item) {
                    if (item.loading) {
                        return 'Searching...';
                    }

                    if (item.isManual) {
                        let $newPart = $('<span class="theme-link no-underline text-normal-case">Can\'t find it?  </span><span class="theme-link create-new">Enter Manually.</span>');
                        
                        $newPart.on('click', (e) => {
                            e.preventDefault();
                            vm.showPartSave = true;
                            let $search = angular.element('#parts-search');
                            
                            $search.trigger({
                                type: 'select2:select',
                                params: {
                                    data: item
                                }
                            });

                            $search.select2('close');
                        });
                        
                        return $newPart;
                    }

                    const partDescription = $(`<div>${item.description}</div>`);

                    if (item.partNumber) {
                        const partNumber = $(`<div class="font-size-10">${item.partNumber}</div>`);
                        
                        partDescription.append(partNumber);
                    }

                    return partDescription;
                }
            };

            vm.printSummary = function () {
                rcUtilService.printToPDF('print-to-pdf', 'repeating-footer', 'PartList-' + vm.ro.id);
            };
            
            vm.getAvailablePartsAssociates = (part) => {
                return (vm.dealerUsers).filter((user) => {
                    const isAssignedPartAssociate = part.selectedPartsAssociate?.id === user.id;

                    return vm.partsAssociateFilter(user) && (!user.isDisabled || isAssignedPartAssociate);
                });
            };

            init();
        };
    }
})();
(function () {
    'use strict';

    InspectTabShopNotesController.$inject = ["$rootScope", "roService", "modalService", "rcUtilService"];
    angular
    .module('redcap.inspect')
        .component('inspectionShopNotes', {
            bindings: {
                dealerId: '<',
                ro: '<',
                lineItems: '='
            },
            templateUrl: 'app/areas/inspect/views/ro-detail/inspect-tab-shopnotes.view.html',
            controller: InspectTabShopNotesController,
            controllerAs: 'vm'
        });

    function InspectTabShopNotesController($rootScope, roService, modalService, rcUtilService) {
        this.$onInit = function() {
            const vm = this;

            vm.isLoading = true;        

            init();

            function init() {
                getShopNotes();
            }

            function getShopNotes() {
                vm.isLoading = true;

                return roService.getRoShopNotes(vm.dealerId, vm.ro.id)
                    .then((response) => {
                        vm.shopNotes = response;

                        vm.shopNotes.forEach((note) => {
                            note.lineItem = vm.lineItems.find((li) => li.id === note.serviceOperationId);
                        });
                    }).finally(() => {
                        $rootScope.$broadcast('updateShopNotesCount', vm.shopNotes.length);
                        vm.isLoading = false;
                    });
            }            

            vm.addShopNote = function () {
                if (vm.newNote) {
                    return roService.addShopNote(vm.dealerId, vm.ro.id, vm.newNote).then((savedNote) => {
                        vm.shopNotes.unshift(savedNote);
                        vm.newNote = '';                    
                    });
                }
            };

            vm.formatMessage = function(data) {
                return rcUtilService.formatNewLineHtml(data);
            };

            vm.deleteShopNote = function (noteId) {
                modalService.showYesNo(
                    'Please confirm',
                    'Are you sure you want to delete this Shop Note?',
                    'No',
                    'Yes'
                ).then((deleteConfirmed) => {
                    if (deleteConfirmed) {
                        return roService.deleteShopNote(vm.dealerId, vm.ro.id, noteId).then((response) => {
                            if (response) {
                                getShopNotes();
                            }
                        });
                    }
                });
            };
        };
    }
})();
(function () {
    'use strict';

    InspectTabServicesController.$inject = ["$rootScope", "$sce", "$filter", "localStorageService", "inspectActionService", "INSPECT_CONSTANTS", "SYSTEM_ENUMS", "modalService", "roService", "inspectModalService", "eventAlertService", "permissions", "inspectionService"];
    angular
        .module('redcap.inspect')
        .component('inspectionServices', {
            bindings: {
                dealerId: '<',
                ro: '=',
                lineItems: '=',
                dealerHasPaymentsEnabled: '<'
            },
            templateUrl: 'app/areas/inspect/views/ro-detail/inspect-tab-services.view.html',
            controller: InspectTabServicesController,
            controllerAs: 'vm'
        });

    function InspectTabServicesController($rootScope, $sce, $filter, localStorageService, inspectActionService, INSPECT_CONSTANTS, SYSTEM_ENUMS, modalService, roService, inspectModalService, eventAlertService, permissions, inspectionService) {
        this.$onInit = function() {
            let vm = this;
            const userCanUpdateLineStatus = permissions.isAdminLevelUser() || permissions.isServiceAdvisor();            
            const statusesThatCanBeApproved = [INSPECT_CONSTANTS.lineItemStatus.new, INSPECT_CONSTANTS.lineItemStatus.open, INSPECT_CONSTANTS.lineItemStatus.na, INSPECT_CONSTANTS.lineItemStatus.deferred, INSPECT_CONSTANTS.lineItemStatus.pendingReApproval, INSPECT_CONSTANTS.lineItemStatus.needsReApproval];

            vm.pendingTotalsOpen = false;
            vm.lineItemSeverity = SYSTEM_ENUMS.lineItemSeverity;
            vm.lineItemSourceType = SYSTEM_ENUMS.lineItemSource;
            vm.answerType = INSPECT_CONSTANTS.roTaskAnswerType;
            vm.showHidden = localStorageService.get('inspectServicesTabShowHidden') || false;
            vm.pendingServicesTableOpen = true;
            vm.approvedServicesTableOpen = true;
            vm.lineItemStatus = INSPECT_CONSTANTS.lineItemStatus;
            vm.lineItemStatusText = INSPECT_CONSTANTS.lineItemStatusText;
            vm.inspectActions = formActionDropdownOptions();
            vm.canSendForPayments = vm.dealerHasPaymentsEnabled && permissions.hasUserPermission(SYSTEM_ENUMS.permissionTypes.payments);
            vm.isTechnician = permissions.isTechnician() && !userCanUpdateLineStatus;
            
            let initialRoShopNotesCount = vm.ro.shopNotesCount;

            init();
            
            vm.onActionSelected = function() {
                const action = INSPECT_CONSTANTS.inspectServiceActions.find((a) => { return a.id === vm.selectedAction; });

                // Handle lineitem-specific actions in this component.  PS: We really need to reconsider all of this action-dropdown stuff...
                // hopefully we can break away from this concept and go back to buttons at some point.
                if (action) {
                    triggerServiceSpecificAction(action);
                } else {
                    inspectActionService.triggerAction(vm.selectedAction, vm.dealerId, vm.ro).then((result) => {
                        if (result) {
                            eventAlertService.createAlert('Operation completed successfully!');
                            init();                            
                        }
                    }).catch((err) => {
                        eventAlertService.createAlert('An error occurred, please try again.');
                    });
                }
                
                // Remove focus and clear drop down so the minified label will go away
                vm.selectedAction = null;
                angular.element(document.activeElement).trigger('blur');
            };

            vm.onLineItemSelected = function(lineItem) {
                inspectModalService.showEditLineItem(vm.ro, lineItem, vm.dealerId, 1).then((dataSaved) => {

                    if (dataSaved) {
                        init();
                    }
                });
            };

            vm.checkAllItems = function(forPending, shouldCheck) {
                vm.lineItems.forEach(lineItem => {
                    const condition = forPending ? vm.lineItemsRequiringAction(lineItem) : vm.lineItemsNotRequiringAction(lineItem);

                    if (condition) {
                         if (vm.showHidden || !lineItem.isHidden) {
                            lineItem.isChecked = shouldCheck;
                         }
                    }
                });
            };

            vm.sendToPayments = function() {
                vm.creatingInvoice = true;

                inspectActionService.triggerAction(INSPECT_CONSTANTS.actionEnum.sendForPayment, vm.dealerId, vm.ro).then((result) => {      
                    
                }).finally(() => { vm.creatingInvoice = false; });
            };

            vm.lineItemsRequiringAction = function(lineItem) {
                if (!vm.showHidden && lineItem.isHidden) return false;

                return lineItemRequiresAttention(lineItem);
            };

            vm.lineItemsNotRequiringAction = function(lineItem) {
                if (!vm.showHidden && lineItem.isHidden) return false;

                return !lineItemRequiresAttention(lineItem);
            };

            // **** Action Dropdown methods

            vm.formatActionForDropDown = function (action) {
                if (action.id ===  INSPECT_CONSTANTS.actionEnum.showHidden) {
                    return `${action.name} (${ getHiddenCount() })`;
                } else {
                    return action.name;
                }
            };
            
            vm.shouldDisableAction = function (action) {
                const actionEnum = INSPECT_CONSTANTS.actionEnum;
                const actionId = action.id;
                const selectedLines = vm.lineItems.filter((line) => line.isChecked);

                if (action.requiresDms && vm.ro.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.None) {
                    return true;
                }

                switch (actionId) {
                    case actionEnum.assignTo:
                    case actionEnum.updateRo:
                    case actionEnum.addRecommendation:
                    case actionEnum.importPartsQuote:
                        return false;
                    
                    case actionEnum.deleteLineItem: 
                        return selectedLines.length === 0;

                    case actionEnum.updateFromDms:
                        return !vm.ro.dmsRepairOrderNumber;

                    case actionEnum.printInspectionSummary:
                        return vm.ro.inspectionStatus === INSPECT_CONSTANTS.inspectionStatus.notStarted;

                    case actionEnum.showHidden:
                        return vm.showHidden || getHiddenCount() === 0;
                    case actionEnum.hideHidden:
                        return !vm.showHidden || getHiddenCount() === 0;

                    case actionEnum.hideSelected:
                        return !selectedLines.some((line) => line.authorizationStatus === vm.lineItemStatus.deferred && !line.isHidden);
                    
                    case actionEnum.unhideSelected:
                        return !selectedLines.some((line) => line.isHidden);
                    
                    case actionEnum.sendForApproval: {                        
                        return !selectedLines.some((line) => statusesThatCanBeApproved.includes(line.authorizationStatus)) || vm.isTechnician;
                    }

                    case actionEnum.approve: {                        
                        return !selectedLines.some((line) => statusesThatCanBeApproved.includes(line.authorizationStatus)) || vm.isTechnician;
                    }

                    case actionEnum.defer: {
                        const deferStatuses = [vm.lineItemStatus.approved, vm.lineItemStatus.na, vm.lineItemStatus.new, vm.lineItemStatus.open, vm.lineItemStatus.pendingReApproval, vm.lineItemStatus.needsReApproval];
                        
                        return !selectedLines.some((line) => deferStatuses.includes(line.authorizationStatus)) || vm.isTechnician;
                    }
                    
                    case actionEnum.approveOnThisDevice: {                        
                        return !selectedLines.some((line) => statusesThatCanBeApproved.includes(line.authorizationStatus)) || vm.isTechnician;
                    }

                    case actionEnum.sendForPayment:
                        return !vm.sendForPaymentsEnabled();
                    default:
                        return true;
                }
            };

            vm.sendForPaymentsEnabled = function() {
                return vm.canSendForPayments && vm.lineItems?.some((line) => line.authorizationStatus === vm.lineItemStatus.approved);
            };

            function getHiddenCount() {
                return vm.lineItems.filter((line) => line.isHidden).length;
            }

            function lineItemRequiresAttention(lineItem) {
                return lineItem.authorizationStatus === vm.lineItemStatus.deferred || (!lineItem.hasPreviousApproval && statusesThatCanBeApproved.includes(lineItem.authorizationStatus));
            }

            async function triggerServiceSpecificAction (action) {
                switch (action.id) {
                    case INSPECT_CONSTANTS.actionEnum.deleteLineItem:
                        await deleteLineItems();
                        break;

                    case INSPECT_CONSTANTS.actionEnum.sendForApproval:
                        await sendForApproval();
                        break;
    
                    case INSPECT_CONSTANTS.actionEnum.hideSelected:        
                        await toggleHiddenItems(true);                           
                        break;

                    case INSPECT_CONSTANTS.actionEnum.unhideSelected:        
                        await toggleHiddenItems(false);                           
                        break;
    
                    case INSPECT_CONSTANTS.actionEnum.showHidden:   
                    case INSPECT_CONSTANTS.actionEnum.hideHidden:     
                        vm.showHidden = !vm.showHidden; 
                        uncheckAllLineItems();        
                        calculatePendingLineItemCount();           
                        break;
                    
                    case INSPECT_CONSTANTS.actionEnum.approve:
                        updateLineItemStatus(vm.lineItemStatus.approved);
                        break;  
                    
                    case INSPECT_CONSTANTS.actionEnum.defer:
                        updateLineItemStatus(vm.lineItemStatus.deferred);
                        break;

                    case INSPECT_CONSTANTS.actionEnum.importPartsQuote:
                        await importPartsQuote(vm.lineItemStatus.deferred);
                        break;
                    
                    case INSPECT_CONSTANTS.actionEnum.approveOnThisDevice:
                        approveOnThisDevice();
                        break;
                }
            }

            // **** Service Action functions

            async function importPartsQuote() {
                try {
                    const quoteSaved = await inspectModalService.importPartsQuote(vm.ro, vm.dealerId);

                    if (quoteSaved) {
                        eventAlertService.createAlert('Parts imported successfully!');

                        init();
                    }
                } catch (e) {
                    eventAlertService.createAlert('Error occurred while imported parts. Please try again.');
                }                
            }

            async function sendForApproval() {
                const servicesToAuthorize = vm.lineItems.filter(lineItem => lineItem.isChecked && statusesThatCanBeApproved.includes(lineItem.authorizationStatus))
                                                       .map(lineItem => ({id: lineItem.id,  authorizationStatus: lineItem.authorizationStatus}));
                let count = servicesToAuthorize.length;
                let phoneNumber = vm.ro.customer.phone;   
                const authMessage = `This is ${vm.ro.dealerName}. We need approval to perform services on your vehicle. Please click the link to review. Thank you. {Link}`;
                
                try {  
                    let customerData = {
                        name: vm.ro.customer.name,
                        phoneNumber: phoneNumber,
                        alternateFirstName: vm.ro.alternateCustomer ? vm.ro.alternateCustomer.firstName : null,
                        alternateLastName: vm.ro.alternateCustomer ? vm.ro.alternateCustomer.lastName : null,
                        alternatePhone: vm.ro.alternateCustomer ? vm.ro.alternateCustomer.phone : null
                    };
                    let modal = await modalService.showSendForApproval(
                        'Send Authorization',
                        `You are sending ${count} service(s) to the recipient(s) below for authorization.`,
                        vm.dealerId, vm.ro.id, servicesToAuthorize, customerData, authMessage);

                    if (modal.success && !modal.cancel) {
                        eventAlertService.createAlert('Sent Successfully!');
                        init();
                    }
                } catch (error) {                    
                    eventAlertService.createAlert('An unexpected error occurred, please try again.');
                }
            }

            async function toggleHiddenItems(shouldHide) {
                const selectedLineItems = vm.lineItems.filter((line) => line.isChecked);

                if (shouldHide) {
                    const nonDeferredSelected = selectedLineItems.some((line) => line.authorizationStatus !== vm.lineItemStatus.deferred);

                    if (nonDeferredSelected) {
                        const confirmed = await modalService.showYesNo('Confirm', 'Note deferred and non-deferred items were selected. Only deferred items can be hidden', 'Cancel', 'OK', false);
                    
                        if (!confirmed) {
                            return;
                        }                    
                    }
                } 

                selectedLineItems.forEach(lineItem => {
                    lineItem.isHidden = shouldHide;                    
                });

                const model = selectedLineItems.map((line) => {
                    return {
                        lineItemId: line.id,
                        isHidden: line.isHidden
                    };
                });

                await roService.updateLineItemHiddenStatus(vm.dealerId, vm.ro.id, model);

                calculatePendingLineItemCount();
                uncheckAllLineItems();
            }

            async function updateLineItemStatus(newStatus) {
                const selectedLines = vm.lineItems.filter((line) => line.isChecked && line.authorizationStatus !== newStatus);
                const statusMessage = newStatus === vm.lineItemStatus.approved ? 'APPROVE' : 'DEFER';
                const confirmed = await modalService.showYesNo('Confirm', `Are you sure you want to ${statusMessage} the selected ${selectedLines.length} service(s) on behalf of the customer?`, 'No', 'Yes', false);

                if (confirmed) {
                    const promises = [];
                    
                    selectedLines.forEach((line) => {
                        const statusPromise = roService.updateAuthorizationStatus(vm.dealerId, vm.ro.id, line.id, newStatus).then((success) => {
                            if (success) {
                                line.authorizationStatus = newStatus;

                                if (newStatus === vm.lineItemStatus.approved) {
                                    line.isHidden = false;
                                }
                            }
                        });

                        promises.push(statusPromise);
                    });

                    Promise.all(promises).then(() => {
                        eventAlertService.createAlert('Status updated successfully');
                        calculatePendingLineItemCount();
                        init();
                    }).catch((err) => {
                        console.log(err);
                        eventAlertService.createAlert('An error occurred updating status');
                    });
                }
            }

            async function deleteLineItems() {
                const selectedLineItems = vm.lineItems.filter((line) => line.isChecked);
                const hasDeferredItems = selectedLineItems.some((line) => line.authorizationStatus === vm.lineItemStatus.deferred);
                const hasApprovedItems = selectedLineItems.some((line) => line.authorizationStatus === vm.lineItemStatus.approved);               
                
                let msg = `Are you sure you want to delete the selected services? Any items pushed to the RO in the DMS will also be deleted.${
                    hasDeferredItems || hasApprovedItems ? ` Note one or more services are either Accepted or Deferred` : ''}`;

                const confirm = modalService.showYesNo("Confirm", msg, "No", "Yes", false);

                confirm.then((confirmed) => {
                    if (confirmed) {
                        const promises = [];

                        vm.loadingLineItems = true;

                        selectedLineItems.forEach((line) => {                            
                            const removeServicePromise = roService.removeLineItem(vm.dealerId, vm.ro.id, line.id, true).then(() => {
                                if (vm.ro.inspectionForm?.isAdHoc && !vm.lineItems.some((li) => li.sourceType === vm.lineItemSourceType.adHoc)) {                   
                                    vm.ro.inspectionStatus = vm.inspectionStatusTypes.notStarted;                   
                                }
                            });

                            promises.push(removeServicePromise);     
                        });

                        Promise.all(promises).then(() => {
                            vm.loadingLineItems = false;
                            eventAlertService.createAlert('Services deleted Successfully');
                            init();
                        }).catch(async (err) => {
                            console.log(err);
                            
                            let bodyTitle = `${selectedLineItems.length > 1 ? `One or more lines cannot be deleted` : `The selected line cannot be deleted`}. Possible reasons are listed below. If you feel this is an error, please contact support.`;
                            let messageHtml = `<li>The RO is COMPLETE or there is only one remaining line on the RO.</li>
                                                <li>The line(s) has parts or sublets.</li>
                                                <li>The line(s) has a status of PARTIAL_CLOSE and the pay type is CUSTOMER.</li>`;
                            let body = `<div>${bodyTitle}</div> <br/> <ul>${messageHtml}</ul>`;

                            if (err?.data?.exceptionMessage) {
                                body = body + ` <hr> <div><strong>DMS response is below:</strong></div> <div>${err.data.exceptionMessage}</div>`;
                            }
                    
                            await modalService.showYesNo('Delete Line(s)', body, null, 'OK');                  

                            vm.loadingLineItems = false;
                        });                      
                    } 
                });
            }

            function calculatePendingLineItemCount() {
                vm.pendingItemCount = vm.lineItems.filter((li) => (vm.showHidden || (!vm.showHidden && !li.isHidden)) && 
                                                                  lineItemRequiresAttention(li)).length;
            }

            function uncheckAllLineItems () {
                vm.lineItems.forEach(lineItem => {
                    lineItem.isChecked = false;
                });
            }

            function formActionDropdownOptions() {
                let actions = (INSPECT_CONSTANTS.inspectActions.concat(INSPECT_CONSTANTS.inspectServiceActions)).sort((a, b) => a.displayOrder - b.displayOrder);
                let batchOfActions = [];
                let count = actions.length;

                actions.forEach((action) => {
                    batchOfActions.push(action);

                    if (action.isEndOfSection) {
                        batchOfActions.push({id: (count = count + 1), name: '-'.repeat(50)});
                    }
                });

                return batchOfActions;
            }

            function approveOnThisDevice() {
                let servicesToAuthorize = vm.lineItems.filter(lineItem => lineItem.isChecked && statusesThatCanBeApproved.includes(lineItem.authorizationStatus)).map(lineItem => lineItem.id);
                
                inspectModalService.showCustomerAuthorization(vm.ro, servicesToAuthorize).then((result) => {
                    if (result) {
                        eventAlertService.createAlert('Authorization completed successfully!');
                        init();
                    }
                });
            }

            function init() {
                vm.loadingLineItems = true;
                vm.roTotals = inspectionService.initROTotals();
                // Refresh the RO to ensure any recommendations that have been added via the inspection form are represented
                const roPromise = roService.getRo(vm.dealerId, vm.ro.id).then((result) => {
                    vm.ro = result;
                });
                
                const roLineItemPromise = roService.getRoLineItems(vm.dealerId, vm.ro.id).then((roLineItemResult) => {
                    vm.lineItems = roLineItemResult.map(li => li.serviceOperations).flat();
                });

                const promises = [roPromise, roLineItemPromise];

                Promise.all(promises).then(() =>  {
                    vm.pendingItemCount = 0;
                    // Initialize each line item
                    vm.lineItems.forEach((lineItem) => {
                        // TODO: Return to this and use the property directly off of the lineItem.
                        lineItem.taskAnswer = lineItem.severity === 1 ? vm.answerType.caution : lineItem.severity === 2 ? vm.answerType.fail : vm.answerType.pass;

                        if (lineItem.pricing.flatRetailAmount == null) {
                            lineItem.pricing.flatRetailAmount = 0;
                        }
                        
                        // Initialize tool-tips for last DMS update
                        if (lineItem.lastPushToDms && (!lineItem.lastPullFromDms || lineItem.lastPushToDms > lineItem.lastPullFromDms)) {
                            lineItem.lastDmsUpdate = lineItem.lastPushToDms;
                            lineItem.tooltip = vm.ro.dmsRepairOrderNumber  ? `Pushed to RO <br> ${$filter('fromNow')(lineItem.lastPushToDms)}` : null;
                        } else if (lineItem.lastPullFromDms) {
                            lineItem.lastDmsUpdate = lineItem.lastPullFromDms;
                            lineItem.tooltip = vm.ro.dmsRepairOrderNumber  ? `Pulled from RO <br> ${$filter('fromNow')(lineItem.lastPullFromDms)}` : null;
                        }
                    });

                    inspectionService.calculateROTotals(vm.ro, vm.lineItems, vm.roTotals);
                    
                    vm.loadingLineItems = false;

                    if (initialRoShopNotesCount !== vm.ro.shopNotesCount) {
                        $rootScope.$broadcast('updateShopNotesCount', vm.ro.shopNotesCount);
                        initialRoShopNotesCount = vm.ro.shopNotesCount;
                    }
                });  
            }
        };
    }
})();

(function () {
    'use strict';

    InspectTabInspectionController.$inject = ["localStorageService", "$rootScope", "liberatedAsideService", "rcUtilService", "inspectActionService", "INSPECT_CONSTANTS", "SYSTEM_ENUMS", "inspectionService", "inspectModalService", "roService", "permissions", "modalService", "eventAlertService"];
    angular
        .module('redcap.inspect')
        .component('inspectionDetail', {
            bindings: {
                ro: '<',
                lineItems: '=',
                dealerId: '<'
            },
            templateUrl: 'app/areas/inspect/views/ro-detail/inspect-tab-inspection.view.html',
            controller: InspectTabInspectionController,
            controllerAs: 'vm'
        });

    function InspectTabInspectionController(
        localStorageService,
        $rootScope,
        liberatedAsideService,
        rcUtilService,
        inspectActionService,
        INSPECT_CONSTANTS,
        SYSTEM_ENUMS,
        inspectionService,
        inspectModalService,
        roService,
        permissions,
        modalService,
        eventAlertService) {
        this.$onInit = function() {
            let vm = this;

            vm.answerTypes = INSPECT_CONSTANTS.roTaskAnswerType;
            vm.inspectActions = _.cloneDeep(INSPECT_CONSTANTS.inspectActions);
            vm.measurementUnitTypes = INSPECT_CONSTANTS.measurementUnitType;
            vm.inspectionStatusTypes = INSPECT_CONSTANTS.inspectionStatus;
            vm.possibleAnswerTypes = inspectionService.getPossibleAnswerTypes();
            vm.filters = {};
            vm.assignmentRoles = INSPECT_CONSTANTS.assignmentRoles;

            function loadSavedRecommendationsForSection (inspectionSection) {
                inspectionSection.tasks.forEach(task => {
                    task.lineItems = vm.lineItems.filter(op => op.inspectionTask?.inspectionTaskId === task.taskId);
                });                
            }

            function stopEvents (evt) {
                rcUtilService.stopEvents(evt);
            }

            vm.showAddLineItemAside = function (evt, task, inspectionSection) {
                stopEvents(evt);

                liberatedAsideService.showAddLineItem(vm.ro, vm.dealerId, task, inspectionSection).then((lineItemSaveResponse) => {
                    if (lineItemSaveResponse) {
                        inspectionService.updateInspectionStatus(vm.dealerId, vm.ro.id, vm.inspectionStatusTypes.inProgress).then(() => {
                            vm.ro.inspectionStatus = vm.inspectionStatusTypes.inProgress;
                        });
                    }                    
                });

                checkAndAssignTechForRO();
            };

            function checkAndAssignTechForRO() {
                if (!vm.ro.technician && permissions.isTechnician()) {
                    assignCurrentUserAsTech();
                }
            }

            vm.loadInspectionSection = function(inspectionSection, forceRefresh) {
                if (inspectionSection.isOpen && (forceRefresh || inspectionSection.id != vm.selectedInspectionSection?.id)) {
                    vm.selectedInspectionSection = inspectionSection;

                    loadSavedRecommendationsForSection(inspectionSection);
                    storeLastSelections();
                }
            };

            function storeLastSelections () {
                localStorageService.set('inspectTabLastOpenedSectionId' + vm.ro.id, vm.selectedInspectionSection?.id);
            }

            function init() {
                vm.isLoading = true;

                if (!vm.ro.inspectionForm) {
                    // if no inspection form is set, check to see if there is only one form and if that is the case, set it.
                    inspectionService.getAvailableInspectionForms(vm.dealerId).then((forms) => {
                        if (forms.length === 1) {                           
                            const inspectionForm = forms[0];
                            
                            inspectionService.changeInspectionForm(vm.dealerId, vm.ro.id, inspectionForm.id).then((result) => {
                                vm.ro.inspectionForm = inspectionForm;
                                
                                initInspectionForm();
                            });
                        } else {
                            vm.isLoading = false;
                        }
                    });
                } else {
                    initInspectionForm();                  
                }                
            }
            
            vm.onActionSelected = async function() {
                if (vm.selectedAction === INSPECT_CONSTANTS.actionEnum.passAll) {
                    await vm.updateTaskStatusBulk(null, vm.answerTypes.pass);

                    vm.selectedAction = null;
                } else {
                    inspectActionService.triggerAction(vm.selectedAction, vm.dealerId, vm.ro).then((saved) => {
                        // Refresh the component if the inspection form was changed.
                        if (saved && vm.selectedAction === INSPECT_CONSTANTS.actionEnum.changeInspectionForm) {
                            init();
                        }
                    }).finally(() => {                        
                        vm.selectedAction = null;
                    });
                }
            };
            
            vm.filterInspectActions = function() {
                return function(action) {
                    let actionsToRemove = [INSPECT_CONSTANTS.actionEnum.updateRo, INSPECT_CONSTANTS.actionEnum.sendForPayment];
                
                    if (!vm.ro.inspectionForm) {
                        actionsToRemove.push(INSPECT_CONSTANTS.actionEnum.passAll);
                    }
    
                    return !actionsToRemove.includes(action.id);
                };                
            };

            vm.updateTaskStatus = async function(evt, updateToStatus, section, task) {
                stopEvents(evt);

                if (!await inspectionService.proceedWithInspectionChange(vm.ro.inspectionStatus)) {
                    return;
                }          

                if (updateToStatus === vm.answerTypes.pass && inspectionService.hasIncompleteMeasurements(task)) {
                    // If the user clicked a single task and it has incomplete measurements, show the add line item modal for that task.
                    vm.showAddLineItemAside(evt, task, section);

                    return;
                }

                vm.updatingInspection = true;

                inspectionService.updateTaskStatus(vm.dealerId, {repairOrderId: vm.ro.id, taskId: task.taskId, taskStatusType: updateToStatus}).then(() => {
                    processTaskStatusUpdates([task], [section], updateToStatus);
                    
                    if (updateToStatus === vm.answerTypes.caution || updateToStatus === vm.answerTypes.fail) {
                        vm.showAddLineItemAside(evt, task, section);
                    } else if (updateToStatus === vm.answerTypes.pass || updateToStatus === vm.answerTypes.na) {
                        checkAndAssignTechForRO();
                    }
                }).finally(() => {
                    vm.updatingInspection = false;                    
                });
            };

            vm.updateTaskStatusBulk = async function(evt, updateToStatus, section) {
                if (evt) stopEvents(evt);

                let sectionsToCheck = section ? [section] : vm.inspectionSections;
                let tasksToUpdate = sectionsToCheck.flatMap((section) => section.tasks).filter((task) => !task.taskResponse);

                if (!tasksToUpdate.length) return;

                if (updateToStatus === vm.answerTypes.pass) {
                    const incompleteTasks = tasksToUpdate.filter((task) => inspectionService.hasIncompleteMeasurements(task));

                    if (incompleteTasks.length) {
                        const incompleteTaskNames = incompleteTasks.reduce((combinedItems, task) => { return `${combinedItems} <li>${task.name}</li>`;}, '');
     
                        modalService.showYesNo('Cannot Pass Tasks', 'The following tasks require measurements to be entered before they can be passed: <ul class="margin-top">' + incompleteTaskNames + '</ul>', null, 'OK');

                        return;
                    }
                }

                vm.updatingInspection = true;

                try {
                    await inspectionService.updateTaskStatusBulk(vm.dealerId, {repairOrderId: vm.ro.id, taskIds: tasksToUpdate.map((task) => task.taskId), taskStatusType: updateToStatus});

                    processTaskStatusUpdates(tasksToUpdate, sectionsToCheck, updateToStatus);

                    return true;
                } catch (e) {
                    eventAlertService.createAlert('An error occurred while updating status, please try again.');

                    return false;
                } finally {
                    vm.updatingInspection = false;
                }
            };

            vm.adHocLinesFilter = function(li) {
                return li.sourceType === SYSTEM_ENUMS.lineItemSource.adHoc;
            };

            vm.deleteLineItem = function (lineToRemove) {
                const confirm = modalService.showYesNo('Please Confirm', 'Are you sure you wish to remove this recommendation?', 'No', 'Yes');
    
                confirm.then((confirmed) => {
                    if (confirmed) {   
                        roService.removeLineItem(vm.dealerId, vm.ro.id, lineToRemove.id).then((result) => { 
                            rcUtilService.removeFromArray(vm.lineItems, (li) => li.id === lineToRemove.id);

                            if (vm.ro.inspectionForm?.isAdHoc && !vm.lineItems.some(vm.adHocLinesFilter)) {                   
                                vm.ro.inspectionStatus = vm.inspectionStatusTypes.notStarted;                   
                            }
                        }).catch((err) => {
                            console.error('Failed to remove redcap line item', err);
                        });    
                    }
                });
            };

            vm.editLineItem = function (li) {
                inspectModalService.showEditLineItem(vm.ro, li, vm.dealerId);
            };

            vm.updateLineSeverity = function(answerType, lineItem) {
                lineItem.severity = inspectionService.mapAnswerTypeToSeverity(answerType);

                roService.updateLineItemSeverity(vm.dealerId, vm.ro.id, lineItem.id, lineItem.severity);
            };

            vm.mapAnswerTypeToSeverity = function (answerType) {
                return inspectionService.mapAnswerTypeToSeverity(answerType);
            };

            vm.completeInspection = async function() {
                if (!vm.ro.inspectionForm?.isAdHoc) {
                    const hasIncompleteTasks = vm.inspectionSections.flatMap((section) => section.tasks).some((task) => !task.taskResponse);

                    if (hasIncompleteTasks) {
                        const updateRemainingTasks = await modalService.showYesNo('Inspection Incomplete', 'All Inspection Tasks must have a response (Pass/Fail/Caution/NA) before the Inspection can be completed. \n\n Would you like to mark the remaining items as NA and then Complete the Inspection?', 'No, continue inspection manually', 'Yes, mark remaining as NA', true, false);
    
                        if (updateRemainingTasks) {
                            const updateSuccessful = await vm.updateTaskStatusBulk(null, vm.answerTypes.na);
    
                            if (!updateSuccessful) return;
                        } else {
                            return;
                        }
                    }
                }             

                vm.updatingInspection = true;

                inspectionService.updateInspectionStatus(vm.dealerId, vm.ro.id, vm.inspectionStatusTypes.complete).then((completedData) => {
                    vm.ro.inspectionStatus = vm.inspectionStatusTypes.complete;
                    vm.ro.inspectionCompletedDate = completedData.inspectionCompletedDate;
                    vm.ro.inspectionCompletedByName =  completedData.inspectionCompletedByName;
                }).finally(() => {
                    vm.updatingInspection = false;
                }).catch((e) => {
                    eventAlertService.createAlert('An error occurred while completing the Inspection. Please try again.');
                });
            };

            function processTaskStatusUpdates(tasks, sections, updateToStatus) {
                tasks.forEach((task) => {
                    task.taskResponse = updateToStatus;
                });

                vm.ro.inspectionStatus = vm.inspectionStatusTypes.inProgress;

                sections.forEach((section) => updateAllPassedSetting(section));
            }

            function assignCurrentUserAsTech() {
                roService.assignCurrentUserToRole(vm.dealerId, vm.ro, vm.assignmentRoles.technician, 'There is no Technician currently assigned. Click OK to assign yourself', modalService)
                    .then(assignedUser => {
                        if (assignedUser) {
                            vm.ro.technician = assignedUser;
                        }
                    });
            }

            function updateAllPassedSetting(inspectionSection) {
                let allPassed = !inspectionSection.tasks.some((task) => {
                    return task.taskResponse !== vm.answerTypes.pass;
                });

                inspectionSection.allTasksPassed = allPassed;
            }

            function initInspectionForm() {
                if (!vm.ro.inspectionForm.isAdHoc) {
                    inspectionService.getInspectionSections(vm.dealerId, vm.ro.id).then((sections) => {
                        vm.inspectionSections = sections;
                        const lastOpenedSectionId = localStorageService.get('inspectTabLastOpenedSectionId' + vm.ro.id) || null;
    
                        vm.inspectionSections.forEach(section => {
                            updateAllPassedSetting(section);
                        });
    
                        // if they had a previous selection, select it
                        let sectionToOpen = null;
    
                        if (lastOpenedSectionId) {
                            const matchingSection = vm.inspectionSections.find(section => section.id === lastOpenedSectionId);
    
                            if (matchingSection) {
                                matchingSection.isOpen = true;
                                sectionToOpen = matchingSection;
                            }  
                        }    
                        
                        if (!sectionToOpen && vm.inspectionSections.length) {
                            vm.inspectionSections[0].isOpen = true;
                            sectionToOpen = vm.inspectionSections[0];
                        }
    
                        if (sectionToOpen) {
                            vm.loadInspectionSection(sectionToOpen, true);
                        }
                        
                        vm.isLoading = false;
                    });  
                } else {
                    vm.isLoading = false;
                }             
            }

            init();

            $rootScope.$on('taskStatusUpdated', (event, data) => {
                if (data && data.ro === vm.ro.id) {
                    const inspectionSection = data.inspectionSection;

                    updateAllPassedSetting(inspectionSection);                
                } 
            });

            vm.shouldDisableAction = function(action) {
                if (action.requiresDms && (vm.ro.dmsSystem === SYSTEM_ENUMS.dmsSystemEnum.None || !vm.ro.dmsRepairOrderNumber)) {
                    return true;
                }

                return false;
            };
            
            vm.showVehicleOverview = function(evt) {
                stopEvents(evt);

                liberatedAsideService.showVehicleOverview(vm.ro, vm.dealerId);
            };         
        };        
    }
})();

(function () {
    'use strict';

    InspectSearchOpCodesController.$inject = ["$timeout", "$rootScope", "locationService", "modalService"];
    angular
        .module('redcap.inspect')
        .component('inspectSearchOpCodes', {
            bindings: {
                lineItem: '<',
                dealerId: '<',
                departmentId: '<',
                disabled: '=',
                onOpCodeSelected: '&',
                dropdownParent: '@?'
            },
            templateUrl: 'app/areas/inspect/views/components/inspect-search-op-codes.component.view.html',
            controller: InspectSearchOpCodesController,
            controllerAs: 'vm'
        });

    function InspectSearchOpCodesController($timeout, $rootScope, locationService, modalService) {
        this.$onInit = function () {
            let vm = this;
            let initalizingOpcode = true;
            const pageSize = 25;

            vm.formatForSelection = function () {
                return _.get(vm.lineItem.selectedOpCode, 'opCode', null);
            };

            vm.formatForDropdown = function (item) {
                if (item.opCode) {
                    return `${item.opCode} : ${item.dashboardDescription}`;
                }

                return null;
            };

            vm.opCodeSelected = async function (opCodeResponse) {
                if (initalizingOpcode) return;

                const selectedOpCode = opCodeResponse[0];

                if (selectedOpCode?.opCode) {
                    vm.lineItem.selectedOpCode = selectedOpCode;

                    if ((selectedOpCode.laborHours > 0 && vm.lineItem.laborHours !== selectedOpCode.laborHours) ||
                        (selectedOpCode.retailPrice > 0 && (vm.lineItem.pricing?.flatRetailAmount ?? vm.lineItem.flatRetailAmount) !== selectedOpCode.retailPrice)) {
                            let applyPricingFromOpCode = true;

                            if (vm.lineItem.laborHours > 0) {
                                applyPricingFromOpCode = await modalService.showYesNo('Use Op Code values?', 'This Op Code includes preset hours and pricing. </br>Do you want to use those values?', 'Keep current values', 'Update Line');
                            }
                            
                            if (applyPricingFromOpCode) {
                                vm.lineItem.laborHours = selectedOpCode.laborHours;
                                vm.lineItem.useFlatPrice = true;
                                
                                // Pricing is only available when editing a line item, and this component can be used when adding or editing a line item.
                                if (vm.lineItem.pricing) {
                                    vm.lineItem.pricing.flatRetailAmount = selectedOpCode.retailPrice;
                                    // TODO: Uncomment below whenever we implement PROD-17602 (will likely need to set the useFlatLabor and useFlatParts fields as well)
                                    // vm.lineItem.pricing.parts = selectedOpCode.partsPrice;
                                    // vm.lineItem.pricing.labor = selectedOpCode.laborPrice;
                                } else {
                                    vm.lineItem.flatRetailAmount = selectedOpCode.retailPrice;
                                    vm.lineItem.partsAmount = selectedOpCode.partsPrice;
                                    vm.lineItem.laborAmount = selectedOpCode.laborPrice;
                                }                                
                                
                                if (vm.onOpCodeSelected) {
                                    vm.onOpCodeSelected();
                                }
                            }
                    }                    
                } else {
                    vm.lineItem.selectedOpCode = null;
                }
            };

            vm.opCodeSearchQuery = {
                type: 'GET',
                dataType: 'json',
                data: function (parameters) {
                    const query = {
                        search: parameters.term,
                        dealerId: vm.dealerId,
                        page: parameters.page,
                        pageSize: pageSize
                    };

                    return query;
                },
                transport: function (params, success, failure) {
                    const data = params.data;

                    return locationService.searchLocationOpCodes(vm.dealerId, vm.departmentId, data.search, data.page, data.pageSize, true).then(success, failure);
                },
                delay: 800,
                processResults: function (data) {
                    const filteredResults = data.filter(obj => Object.keys(obj).includes("opCode"));

                    return {
                        results: filteredResults,
                        pagination: {
                            more: data.length === pageSize
                        }
                    };
                }
            };

            function init() {
                const opCode = vm.lineItem.opCode;

                if (opCode) {
                    $timeout(() => {
                        // the last parameter is set to true indicating that we should be looking for an exact match for the opcode
                        locationService.searchLocationOpCodes(vm.dealerId, 0, opCode, 0, 10, true, true).then((fuzzyMatches) => {
                            const match = fuzzyMatches.find(fuzzy => fuzzy.id === opCode);

                            $rootScope.$broadcast('searchOpCodeInitialized');
                            vm.lineItem.selectedOpCode = match;

                            initalizingOpcode = false;
                        });
                    }, 0);
                } else {
                    $rootScope.$broadcast('searchOpCodeInitialized');
                    initalizingOpcode = false;
                }
            }

            init();
        };
    }
})();

(function () {
    'use strict';

    InspectRoDetailController.$inject = ["$scope", "$timeout", "$rootScope", "$stateParams", "$state", "SYSTEM_ENUMS", "INSPECT_CONSTANTS", "inspectionService", "roService", "messagesService", "locationService", "rcUtilService"];
    angular
        .module('redcap.inspect')
        .component('inspectRoDetail', {
            bindings: {
                roId: '<',
                hasMessaging: '<',
                dealerId: '<',
                roTab: '=',
                hasDealerPaymentsPermission: '<'
            },
            templateUrl: 'app/areas/inspect/views/ro-detail/inspect-ro-detail.component.view.html',
            controller: InspectRoDetailController,
            controllerAs: 'vm'
        });

    function InspectRoDetailController($scope, $timeout, $rootScope, $stateParams, $state, SYSTEM_ENUMS, INSPECT_CONSTANTS, inspectionService, roService, messagesService, locationService, rcUtilService) {
        this.$onInit = function() {
            let vm = this;
           
            vm.customerHeaderOpen = true;
            vm.messagingPanelMobileClass = "inspect-messaging-enabled";
            vm.messagingPanelModes = SYSTEM_ENUMS.messagingPanelModes;
            vm.tabs = null;
            vm.isLoading = true;
            vm.dealerHasPaymentsEnabled = vm.hasDealerPaymentsPermission || false;
            const defaultTab = inspectionService.getDefaultRODetailTab();

            vm.getOdometerAbbreviation = rcUtilService.getOdometerAbbreviation;

            init();

            function init() {                
                vm.dealerId = vm.dealerId || $stateParams.dealerId;
                vm.roId = vm.roId || $stateParams.roId;
                vm.roTab.activeInspectTab = vm.roTab.activeInspectTab || defaultTab;
                
                let queryParams = {
                    tabType: INSPECT_CONSTANTS.tabTypes.roDetail,
                    dealerId: vm.dealerId,
                    roId: vm.roId,
                    customerName: $stateParams.customerName || 'Customer'
                };

                let shopNoteCount = 0;

                const getRoPromise = roService.getRo(vm.dealerId, vm.roId).then((ro) => {
                    vm.ro = ro;
                    shopNoteCount = vm.ro.shopNotesCount ? vm.ro.shopNotesCount : 0;

                    if (vm.roTab) {
                        const customerName = vm.roTab.customerName || rcUtilService.formatCustomerName(vm.ro.customer);

                        if (customerName) {
                            vm.roTab.customerName = customerName;
                            vm.roTab.lastName = rcUtilService.getCustomerLastName(customerName);
                        }

                        if (vm.ro.dmsRepairOrderNumber && vm.roTab.roNumber !== vm.ro.dmsRepairOrderNumber) {
                            vm.roTab.roNumber = vm.ro.dmsRepairOrderNumber;
                            vm.roTab.roNumberSuffix = rcUtilService.getRoNumberSuffix(vm.ro.dmsRepairOrderNumber);
                        }
                    }

                    vm.removeMessagingTabs = !vm.hasMessaging || !vm.ro.customer;                  

                    if (!vm.removeMessagingTabs && (vm.ro.customer.phone || vm.ro.customer.dmsCustomerNumber)) {
                        initMessaging();
                    }
                });

                const getLineItemsPromise = roService.getRoLineItems(vm.dealerId, vm.roId).then((lineItems) => {
                    vm.lineItems = lineItems.flatMap((li) => li.serviceOperations);
                });

                const promises = [getRoPromise, getLineItemsPromise];

                const promisesResult = Promise.all(promises);
                
                promisesResult.finally(() => {                                        
                    vm.tabs = [
                        {
                            id: 1,
                            title: 'Inspection',
                            route: 'inspect-detail-tabs-inspection(' + JSON.stringify(queryParams) + ')',
                            tabType: INSPECT_CONSTANTS.detailTabType.inspection,
                            active: vm.roTab.activeInspectTab === INSPECT_CONSTANTS.detailTabType.inspection
                        },
                        {
                            id: 2,
                            title: 'Services',
                            route: 'inspect-detail-tabs-services(' + JSON.stringify(queryParams) + ')',
                            tabType: INSPECT_CONSTANTS.detailTabType.services,
                            active: vm.roTab.activeInspectTab === INSPECT_CONSTANTS.detailTabType.services
                        },            
                        {
                            id: 3,
                            title: `Shop Notes (${shopNoteCount})`,
                            route: 'inspect-detail-tabs-shop-notes(' + JSON.stringify(queryParams) + ')',
                            tabType: INSPECT_CONSTANTS.detailTabType.shopNotes,
                            active: vm.roTab.activeInspectTab === INSPECT_CONSTANTS.detailTabType.shopNotes                        
                        },
                        {
                            id: 4,
                            title: 'History',
                            route: 'inspect-detail-tabs-authorizations(' + JSON.stringify(queryParams) + ')',
                            tabType: INSPECT_CONSTANTS.detailTabType.authHistory,
                            active: vm.roTab.activeInspectTab === INSPECT_CONSTANTS.detailTabType.authHistory
                        }
                    ]; 

                    vm.isLoading = false;
                });
                
                return promisesResult;
            }

            vm.detailTabChanged = function(tab) {
                vm.roTab.activeInspectTab = tab.tabType; 
                $state.go('inspect', {activeInspectTab: tab.tabType}, {reload: false, inherit: true});
            };

            vm.enableMessaging = function(enable) {
                if (enable) {
                    angular.element('body').addClass(vm.messagingPanelMobileClass);
                } else {
                    angular.element('body').removeClass(vm.messagingPanelMobileClass);
                }
            };

            vm.closeMessagingPanel = function() {
                vm.removeMessagingTabs = true;
            };

            function contactUpdated() {
                $timeout(() => {
                    // PROD-15811 ensure taht the messaging panel always has 
                    // the latest hasMessaging permission for current dealer
                    $rootScope.$broadcast('messagePaneHasMessagingUpdate', vm.hasMessaging);
                    $rootScope.$broadcast('messagePaneContactUpdate', vm.contact);
                }, 2000);
            }

            function initMessaging() {
                vm.isLoadingContact = true;

                const contactFilter = {
                    dealer: vm.dealerId,                
                    allowDisabledDealers: true
                };

                if (vm.ro.customer.dmsCustomerNumber) {
                    contactFilter.dmsCustomerId = vm.ro.customer.dmsCustomerNumber;
                } else {
                    contactFilter.query = vm.ro.customer.phone.replace(/\D/g, '');
                }

                messagesService.getContacts(contactFilter).then((contacts) => {
                    let contact = contacts && contacts.length ? contacts[0] : null;

                    if (contact) {
                        messagesService.getContact(contact.id).then((rcContact) => {
                           
                            if (vm.ro.customer.phone && (rcContact.mobilePhone && rcContact.mobilePhone !== vm.ro.customer.phone)) {
                                rcContact.mobilePhone = vm.ro.customer.phone;

                                messagesService.updateContact(contact.id, rcContact).then((updatedContact) => {
                                    vm.contact = updatedContact;

                                    contactUpdated();
                                });
                            } else {
                                vm.contact = rcContact;

                                contactUpdated();
                            }
                        }).finally(() => {
                            vm.isLoadingContact = false;
                        });
                    } else {
                        let newContact = {
                            firstName: vm.ro.customer.firstName,
                            lastName: vm.ro.customer.lastName,
                            mobilePhone: vm.ro.customer.phone,
                            dmsCustomerId: vm.ro.customer.dmsCustomerNumber,
                            dealerId: vm.dealerId
                        };

                        newContact.lastName = newContact.lastName || vm.ro.customer.businessName || '';
                       
                        messagesService.addContact(newContact).then((savedContact) => {
                            vm.contact = savedContact;
                            vm.isLoadingContact = false;

                            contactUpdated();
                        }).catch((err) => {
                            console.error('Error adding contact', err);
                            vm.isLoadingContact = false;
                        });
                    }
                });
            }

            $rootScope.$on('lineItemAdded', (event, data) => {
                if (data && data.ro.id === parseInt(vm.roId)) {
                    init();
                }
            });

            $scope.$on('$destroy', (event, next, current) => {
                vm.enableMessaging(false);
            });
            
            $rootScope.$on('updateShopNotesCount', (event, newCount) => {
                const shopNotesTab = vm.tabs.find(tab => tab.tabType === INSPECT_CONSTANTS.detailTabType.shopNotes);

                if (shopNotesTab) {
                    shopNotesTab.title = `Shop Notes (${newCount})`;
                }
            });
        };
    }
})();

(function () {
    'use strict';

    InspectOriginalCustomerRequestsController.$inject = ["$rootScope", "$timeout", "inspectModalService", "SYSTEM_ENUMS", "INSPECT_CONSTANTS"];
    angular
        .module('redcap.inspect')
        .component('inspectOriginalCustomerRequests', {
            bindings: {
                ro: '<',
                dealerId: '<',
                lineItems: '='
            },
            templateUrl: 'app/areas/inspect/views/components/inspect-original-customer-requests.component.view.html',
            controller: InspectOriginalCustomerRequestsController,
            controllerAs: 'vm'
        });

    function InspectOriginalCustomerRequestsController($rootScope, $timeout, inspectModalService, SYSTEM_ENUMS, INSPECT_CONSTANTS) {
        this.$onInit = function() {
            let vm = this;
            
            
            function init() {
                vm.isLoading = true;
                vm.showOriginalRequests = true;
                vm.lineItemStatusText = INSPECT_CONSTANTS.lineItemStatusText;
                vm.isLoading = false;
            }

            init();

            vm.originalRequestsFilter = function(li) {
                return li.sourceType === SYSTEM_ENUMS.lineItemSource.originalCustomerRequest || li.sourceType === SYSTEM_ENUMS.lineItemSource.checkIn;
            };

            vm.originalRequestClicked = function (originalRequest) {
                const matchingLineItem = vm.lineItems.find(so => so.id === originalRequest.id);

                if (matchingLineItem) {
                    inspectModalService.showEditLineItem(vm.ro, matchingLineItem, vm.dealerId);
                }
            };

            vm.updateIsVisible = function () {
                vm.showOriginalRequests = !vm.showOriginalRequests;
            };            
        };
    }
})();
(function () {
    'use strict';

    InspectMyRecommendationsController.$inject = ["$timeout", "$rootScope", "inspectModalService", "SYSTEM_ENUMS", "INSPECT_CONSTANTS"];
    angular
        .module('redcap.inspect')
        .component('inspectMyRecommendations', {
            bindings: {
                ro: '<',
                dealerId: '<',
                lineItems: '='
            },
            templateUrl: 'app/areas/inspect/views/components/inspect-my-recommendations.component.view.html',
            controller: InspectMyRecommendationsController,
            controllerAs: 'vm'
        });

    function InspectMyRecommendationsController($timeout, $rootScope, inspectModalService, SYSTEM_ENUMS, INSPECT_CONSTANTS) {
        this.$onInit = function() {
            let vm = this;            

            function init() {
                vm.isLoading = true;
                vm.showMyRecs = true;
                vm.lineItemStatusText = INSPECT_CONSTANTS.lineItemStatusText;
                vm.isLoading = false;
            }

            init();           

            vm.myRecommendationsFilter = function(li) {
                return li.sourceType === SYSTEM_ENUMS.lineItemSource.adHoc || 
                       (li.sourceType === SYSTEM_ENUMS.lineItemSource.inspection && li.inspectionTask?.inspectionTaskId != null);
            };

            vm.recommendationClicked = function ($event, selectedRec) {
                inspectModalService.showEditLineItem(vm.ro, selectedRec, vm.dealerId);
            };

            vm.updateIsVisible = function () {
                vm.showMyRecs = !vm.showMyRecs;
            };
        };
    }
})();
(function () {
    'use strict';

    InspectMediaViewerController.$inject = ["SYSTEM_ENUMS", "appointmentUtilService", "roService"];
    angular
        .module('redcap.inspect')
        .component('inspectMediaViewer', {
            bindings: {
                lineItem: '<',
                ro: '<'
            },
            templateUrl: 'app/areas/inspect/views/components/inspect-media-viewer.component.view.html',
            controller: InspectMediaViewerController,
            controllerAs: 'vm'
        });

    function InspectMediaViewerController(SYSTEM_ENUMS, appointmentUtilService, roService) {
        this.$onInit = function() {
            let vm = this;

            vm.lineItem.availImages = null;
            vm.lineItem.existingImages = null;
            vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
            vm.lineItem.selectedMediaItems = {
                selected: [],
                deselected: []
            };

            vm.selectedImageClicked = function (image) {
                image.selected = !image.selected;

                if (image.selected) {
                    vm.lineItem.selectedMediaItems.deselected.push(image);
                } else {
                    vm.lineItem.selectedMediaItems.deselected = vm.lineItem.selectedMediaItems.deselected.filter((item) => {
                        return item.id !== image.id;
                    });
                }
            };

            vm.newImageClicked = function (image) {
                image.selected = !image.selected;

                if (image.selected) {
                    vm.lineItem.selectedMediaItems.selected.push(image);
                } else {
                    vm.lineItem.selectedMediaItems.selected = vm.lineItem.selectedMediaItems.selected.filter((item) => {
                        return item.id !== image.id;
                    });
                }
            };

            vm.getMediaType = function(fileExtension) {
                return appointmentUtilService.getMediaType(fileExtension);
            };

            vm.hasNoMedia = function () {
                return (!vm.lineItem.mediaItems || vm.lineItem.mediaItems.length === 0) && (!vm.roMedia || vm.roMedia.length === 0);
            };

            function setMediaOnLine() {
                vm.lineItem.availImages = vm.roMedia.filter(img => img.serviceOperationId !== vm.lineItem.id);
                vm.lineItem.existingImages = vm.roMedia.filter(img => img.serviceOperationId === vm.lineItem.id);
            }

            function init() {
                vm.isLoading = true;

                roService.getRoMedia(vm.ro.dealerId, vm.ro.id).then((roMedia) => {
                    vm.roMedia = roMedia;

                    setMediaOnLine();
                }).finally(() => {
                    vm.isLoading = false;
                });
            }

            init();
        };
    }
})();
(function () {
    'use strict';

    InspectListController.$inject = ["$rootScope", "$scope", "$stateParams", "$timeout", "rcUtilService", "inspectModalService", "inspectActionService", "locationService", "rcLocalStorageService", "searchTemplateUtilService", "systemService", "roService", "permissions", "SYSTEM_ENUMS", "INSPECT_CONSTANTS", "SAVED_SEARCHES_PLACEHOLDER", "$interval", "$filter"];
    angular
        .module('redcap.inspect')
        .component('inspectList', {
            bindings: {
                selectedTabType: '<',
                hasDealerPaymentsPermission: '<'
            },
            templateUrl: 'app/areas/inspect/views/inspect-list.view.html',
            controller: InspectListController,
            controllerAs: 'vm'
        });

    function InspectListController($rootScope,
        $scope,
        $stateParams,
        $timeout,
        rcUtilService,
        inspectModalService,
        inspectActionService,
        locationService,
        rcLocalStorageService,
        searchTemplateUtilService,
        systemService,
        roService,
        permissions,
        SYSTEM_ENUMS,
        INSPECT_CONSTANTS,
        SAVED_SEARCHES_PLACEHOLDER,
        $interval,
        $filter) {
        this.$onInit = function() {
            let vm = this;
            let itemsPerPage = 15;
            let pageIndex = 0;
            let sortEnum = {
                ro: 1,
                customerName: 2,
                status: 3,
                flag: 4,
                departmentName: 5
            };
            let defaultDateRange = {
                startDate: moment(new Date()),
                endDate: moment(new Date())
            };
            let _autoRefreshInterval;
            let _autoRefreshCountDown;
            let AUTOREFRESH_DURATION = 30000;
            let roleEnum = {
                technician: SYSTEM_ENUMS.roleNames.technician,
                serviceAdvisor: SYSTEM_ENUMS.roleNames.serviceAdvisor
            };
            
            vm.showAdvancedSearch  = false;
            const $searchEl = angular.element('#inspect_search');
            const routeSheetColumnMapping = {
                customer: function(ro) {
                    return rcUtilService.formatCustomerName(ro);
                },
                vehicle: function(ro) {
                    return ro.year + ' ' + ro.make + ' ' + ro.model;
                },
                promiseTime: function(ro) {
                    if (ro.promiseDate) {
                        return moment(ro.promiseDate).format('MM/DD/YYYY hh:mm A');
                    }
                },
                elapsed: function(ro) {
                    let diffSeconds = moment().diff(moment(ro.createdAt), 'seconds');

                    return rcUtilService.calcDuration(diffSeconds);
                }
            };

            vm.repairOrders = [];
            vm.routeSheetTabActive = true;
            
            searchTemplateUtilService.initSearchTemplateData(vm);

            vm.searchTemplateData = {
                currentSearchTemplate: rcLocalStorageService.get('selectedInspectSearchTemplate') || null
            };
           
            vm.showSortable = false;
            
            vm.serviceAdvisorsFilterSettings = {
                showCheckAll: false,
                showUncheckAll: false,
                idProp: 'id',
                displayProp: 'label',
                buttonClasses: 'ellipsis-overflow'
            };

            vm.assignedFilterSettings = {
                showCheckAll: false,
                showUncheckAll: false,
                idProp: 'id',
                displayProp: 'label',
                buttonClasses: 'ellipsis-overflow'
            };

            vm.technicianFilterSettings = {
                showCheckAll: false,
                showUncheckAll: false,
                idProp: 'id',
                displayProp: 'label',
                buttonClasses: 'ellipsis-overflow'
            };

            vm.timeframes = [                
                {value: 5, text: 'Last 30 days'},
                {value: 4, text: 'Last 7 days'},              
                {value: 0, text: 'Today'},            
                {value: 3, text: 'Custom...'}
            ];

            vm.serviceAdvisorsDropdownLabels = {
                buttonDefaultText: 'Filter by service advisor'
            };

            vm.assignedDropdownLabels = {
                buttonDefaultText: 'Filter by assigned'
            };

            vm.technicianDropdownLabels = {
                buttonDefaultText: 'Filter by technician'
            };

            vm.sortOrder = SYSTEM_ENUMS.sortOrder;

            vm.statusFilterSettings = {
                showCheckAll: false,
                showUncheckAll: false,
                idProp: 'id',
                displayProp: 'name',
                buttonClasses: 'ellipsis-overflow'
            };

            vm.statusDropdownLabels = {
                buttonDefaultText: 'Filter by status'
            };

            vm.showCalendar = function () {
                return vm.filters.timeframeFilter === 3;
            };

            vm.checkboxFilterEvents = {
                onSelectionChanged: function () {
                    updateDirtyFlag();
                    if (!vm.showAdvancedSearch) vm.filtersChanged();
                }
            };

            vm.dateRangePickerOptions = {
                eventHandlers: {
                    'apply.daterangepicker': function(event, picker) { 
                        vm.filtersChanged(); 
                    }
                }
            };

            vm.clearCustomTimeFrame = function () {
                vm.filters.timeframeFilter = 0;
                vm.filters.startDate = null;
                vm.filters.endDate = null;
                vm.filtersChanged();               
            };

            function getSuffix(length) {
                return length > 1 ? ' SELECTIONS' : ' SELECTION';
            }

            function createFilterMessage() {
                vm.filterCount = 0;
                vm.filterMessage = '';
                vm.requiredFilterMessage = "";

                if (vm.selectedLocation) {
                    let name = vm.selectedLocation ? vm.selectedLocation.name : '1 Dealer';

                    vm.requiredFilterMessage += name;
                    rcUtilService.buildFilterMessage('Location', name, vm);
                }

                if (vm.filters.search && vm.filters.search.length > 0) {
                    vm.requiredFilterMessage += vm.filters.search;
                    rcUtilService.buildFilterMessage('Name/RO', vm.filters.search, vm);
                }

                if (vm.filters.showInactive) {
                    rcUtilService.buildFilterMessage('Show Inactive', 'Yes', vm);
                }

                 if (vm.filters.showAllOpen) {
                    rcUtilService.buildFilterMessage('Show active', 'Yes', vm);
                }

                if (vm.filters.showOnlyMine) {
                    rcUtilService.buildFilterMessage('Only Mine', 'Yes', vm);
                }

                if (vm.filters.timeframeFilter === 3) {
                    if (vm.filters.customTimeframe != defaultDateRange) {
                        rcUtilService.buildFilterMessage('Time Frame', 'Custom date range', vm);
                    }
                } else {
                    let msg = _.find(vm.timeframes, (item) => { return item.value === vm.filters.timeframeFilter; });

                    if (msg) {
                        rcUtilService.buildFilterMessage('Time Frame:', msg.text, vm);
                    }
                }

                if (vm.filters.serviceAdvisors && vm.filters.serviceAdvisors.length > 0) {
                    let serviceAdvisorsLength = vm.filters.serviceAdvisors.length;

                    rcUtilService.buildFilterMessage('Service Advisors', serviceAdvisorsLength + getSuffix(serviceAdvisorsLength), vm);
                }

                if (vm.filters.assignedTo && vm.filters.assignedTo.length > 0) {
                    let assignedToLength = vm.filters.assignedTo.length;

                    rcUtilService.buildFilterMessage('Assigned To', assignedToLength + getSuffix(assignedToLength), vm);
                }

                if (vm.filters.technicians && vm.filters.technicians.length > 0) {
                    let techniciansLength = vm.filters.technicians.length;

                    rcUtilService.buildFilterMessage('Technicians', techniciansLength + getSuffix(techniciansLength), vm);
                }

                if (vm.filters.statuses && vm.filters.statuses.length > 0) {
                    let statusesLength = vm.filters.statuses.length;

                    rcUtilService.buildFilterMessage('Statuses', statusesLength + getSuffix(statusesLength), vm);
                }
            }

            vm.timeframeChanged = function (preventListReload) {
                if (vm.filters.timeframeFilter === 3) {
                    const dateRangePicker = $('#timeframe_range').data('daterangepicker');

                    if (dateRangePicker) {
                        $timeout(() => {
                            dateRangePicker.toggle();
                        }, 1);
                    }
                } else {
                    vm.filters.customTimeframe.startDate = vm.filters.timeframeFilter ? null : defaultDateRange.startDate;
                    vm.filters.customTimeframe.endDate = vm.filters.timeframeFilter ? null : defaultDateRange.startDate;
                }

                if (!preventListReload)
                    vm.filtersChanged();
            };

            vm.clearSearchCriteria = function () {
                vm.resetFilters();
            };

            vm.resetFilters = function() {
                vm.filters = {
                    isActive: true,
                    isOpen: false,
                    statuses: [],
                    serviceAdvisors: [],
                    assignedTo: [],
                    technicians: [],
                    search: null,
                    searchString: null,
                    sortBy: sortEnum.ro,
                    sortDirection: vm.sortOrder.descending,
                    pageIndex: 0,
                    pageSize: itemsPerPage,
                    isCpo: false,
                    isTrainingRo: false,
                    timeframeFilter: 0,
                    showStatusColorAcrossRow: false
                };

                vm.templateName = null;
                searchTemplateUtilService.clearSearchTemplate(vm);

                vm.filters.customTimeframe = defaultDateRange;
                vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

                storeFilters();
                vm.filtersChanged();
                
            };

            function storeFilters () {
                rcLocalStorageService.set('selectedInspectDealer', vm.selectedLocation);
                rcLocalStorageService.set('selectedInspectFilters', vm.filters);
                rcLocalStorageService.set('selectedInspectSearchTemplate', vm.searchTemplateData.currentSearchTemplate);
            }
            
            vm.selectedLocationChanged = function() {
                if (!vm.showAdvancedSearch) {
                    $rootScope.$broadcast('selectedDealerChanged', vm.selectedLocation);
                }

                updateFilterOptions();

                if (!vm.showAdvancedSearch) {
                    vm.resetFilters();
                }
            };

            vm.showFilterMessage = function() {
                return vm.filterCount > 0 && vm.filterMessage !== '';
            };

            vm.clearSearchField = function() {
                vm.filters.search = null;

                if ($searchEl) {
                    $timeout(() => {
                        $searchEl.trigger('blur');
                    }, 0);
                }
                
                if (!vm.showAdvancedSearch) {
                    vm.filtersChanged();
                }
            };

            function updateDirtyFlag() {
                if (vm.searchTemplateData.currentSearchTemplate) {
                    vm.searchTemplateData.isTemplateDirty = true;
                }
            }

            vm.close = function () {
                vm.selectedLocation  = vm.locationBeforeAdvandedSearch;
                searchTemplateUtilService.advancedFilterModalClosed(vm);
            };
            
            vm.saveBtnClicked = function () {
                saveSearchTemplate(false);
            };
    
            vm.saveAsBtnClicked = function () {
                saveSearchTemplate(true);
            };

            function saveSearchTemplate(saveAs) {
                if (saveAs) {
                    vm.searchTemplateData.currentSearchTemplate.id = null;
                }
                
                vm.preferences.routeSheetColumns = vm.allColumns;
                vm.preferences.orderedColumns = _.map(vm.allColumns, (col) => { return col.name; });

                searchTemplateUtilService.saveSearchTemplateClicked(vm, {
                    selectedInspectLocation: vm.selectedLocation,
                    selectedInspectFilters: vm.filters,
                    selectedInspectPreferences: angular.toJson(vm.preferences),
                    templateName: vm.searchTemplateData.savedSearchName
                }, SYSTEM_ENUMS.searchTemplateTypes.inspect);
            }

            function finishLoadingTemplate(changingDealer) { 
                let template = vm.searchTemplateData.currentSearchTemplate.template;
              
                vm.selectedLocation = template.selectedInspectLocation;
                vm.filters = template.selectedInspectFilters;
                parsePreferences(template.selectedInspectPreferences);

                if (changingDealer) {
                    $rootScope.$broadcast('selectedDealerChanged', vm.selectedLocation);
                    updateFilterOptions();
                }

                if (!vm.showAdvancedSearch) {
                    loadRouteSheet();
                }
            }

            vm.loadSearchTemplate = function (item, model) {
                if (item && item.template && item.template.templateName !== SAVED_SEARCHES_PLACEHOLDER) {
                    let template = item.template;
                    let templateDealer = $filter('filter')(vm.dealers, {id: template.selectedInspectLocation.id}, true);
                    let changingDealer = false;
                    let selectedDealerId = vm.selectedLocation != null ? vm.selectedLocation.id : null;

                    if (templateDealer && templateDealer.id !== selectedDealerId) {
                        changingDealer = true;
                    }

                    vm.selectedLocation = null;
                    vm.isLoading = true;
                    vm.searchTemplateData.isTemplateDirty = false;
                    vm.searchTemplateData.currentSearchTemplate = item;
                    rcLocalStorageService.set('selectedInspectSearchTemplate', vm.searchTemplateData.currentSearchTemplate);
                    vm.searchTemplateData.savedSearchName = template.templateName;
                    vm.templateName = template.templateName;
                    
                    if (templateDealer && templateDealer.length > 0) {
                        vm.selectedLocation = templateDealer[0];
                    }

                    finishLoadingTemplate(changingDealer);
                            
                } else if (item && item.template && item.template.templateName === SAVED_SEARCHES_PLACEHOLDER) { 
                    rcLocalStorageService.set('selectedInspectSearchTemplate', null);
                    searchTemplateUtilService.clearSearchTemplate(vm);
                    vm.resetFilters();
                } else {
                    rcLocalStorageService.set('selectedInspectSearchTemplate', null);
                    searchTemplateUtilService.clearSearchTemplate(vm);

                    if (!vm.showAdvancedSearch) {
                        loadRouteSheet();
                    }
                }
            };

            function loadSearchTemplates() {
                systemService.getSearchTemplates(SYSTEM_ENUMS.searchTemplateTypes.inspect).then((templates) => {
                    vm.searchTemplateData.searchTemplates = templates;
                    loadLastTemplateAndFilters();
                });
            }

            function loadLastTemplateAndFilters () {
                if (vm.searchTemplateData.currentSearchTemplate) {
                    let searchItem = _.find(vm.searchTemplateData.searchTemplates, (item) => { return item.template.templateName === vm.searchTemplateData.currentSearchTemplate.template.templateName; });

                    if (searchItem) {
                        vm.loadSearchTemplate(searchItem);
                    } else {
                        vm.searchTemplateData.currentSearchTemplate = null;
                        loadRouteSheet();
                    }
                } else {
                    loadRouteSheet();
                }
            }

            vm.filtersChanged = function() {
                updateDirtyFlag();

                pageIndex = 0;
                vm.showAdvancedSearch = false;
                
                vm.columnsToDisplay = _.filter(vm.allColumns, (col) => { return col.show; });

                loadRouteSheet();
            };

            vm.displayMore = function() {
                pageIndex++;
                loadRouteSheet(true, false, pageIndex);                  
            };

            vm.toggleAutoRefresh = function()  {
                if (!vm.autoRefresh) {
                    clearRefreshInterval();
                } else {
                    vm.setRefreshInterval();
                }
    
                rcLocalStorageService.set('route-refresh', vm.autoRefresh);
            };

            function clearRefreshInterval() {
                if (angular.isDefined(_autoRefreshInterval)) {
                    $interval.cancel(_autoRefreshInterval);
                    _autoRefreshInterval = undefined;
                }
    
                if (angular.isDefined(_autoRefreshCountDown)) {
                    $interval.cancel(_autoRefreshCountDown);
                    _autoRefreshCountDown = undefined;
                }
            }

            vm.searchRos = function (searchString) {
                if (!vm.selectedLocation.id || !searchString) {
                    return [];
                }
                
                vm.isLoading = true;
                vm.selectedRepairOrder = null;
    
                roService.searchRepairOrdersFromDms(vm.selectedLocation.id, searchString).then((response) => {
                    if (response) {
                        vm.roNumberSearch = '';
                        vm.searchExpanded = !vm.searchExpanded;
                        vm.onRoSelected(response);
                    } else {
                        vm.canLoadMore = false;
                        vm.repairOrders = [];
                        vm.searchExpanded = true;
                    }
                }).catch((error) => {
                    console.error('Error occurred while importing repair orders:', error);
                    vm.searchExpanded = true;
                }).finally(() => {
                    vm.isLoading = false;
                });
            };

             vm.setRefreshInterval = function() {       
                if (!_autoRefreshInterval && vm.autoRefresh && !vm.searchExpanded) {
                    let countdown = (AUTOREFRESH_DURATION / 1000);
    
                    _autoRefreshInterval = $interval(() => {
                        loadRouteSheet(false, true, 0, false);
                    }, AUTOREFRESH_DURATION);
    
                    vm.refreshCountdown = countdown;
                    _autoRefreshCountDown = $interval(() => { vm.refreshCountdown--; }, 1000, 0);
                }
            }; 

            function loadRouteSheet(fromPaging, fromAutoRefresh, startIndex, roToSelect) {    
                storeFilters();
                createFilterMessage();

                if (vm.isLoadingMore)
                    return;

                if (!vm.selectedLocation) {
                    vm.repairOrders = [];
                    vm.columnsToDisplay = null;
                    vm.canLoadMore = false;
                    vm.isLoading = false;

                    return;
                }

                vm.isLoading = !fromPaging;
                vm.isLoadingMore = fromPaging;

                startIndex = startIndex || 0;
         
                const serviceAdvisorsArray = [];

                if (vm.filters.serviceAdvisors && vm.filters.serviceAdvisors.length > 0) {
                    vm.filters.serviceAdvisors.forEach((u) => {
                        serviceAdvisorsArray.push(u.id);
                    });
                }

                const assignedToArray = [];

                if (vm.filters.assignedTo && vm.filters.assignedTo.length > 0) {
                    vm.filters.assignedTo.forEach((u) => {
                        assignedToArray.push(u.id);
                    });
                }

                const technicianArray = [];

                if (vm.filters.technicians && vm.filters.technicians.length > 0) {
                    vm.filters.technicians.forEach((u) => {
                        technicianArray.push(u.id);
                    });
                } 
                
                let filters = {
                    isActive: !vm.filters.showInactive,
                    isOpen: vm.filters.showAllOpen,
                    statusIds: _.map(vm.filters.statuses, (s) => { return s.id; }),
                    serviceAdvisors: serviceAdvisorsArray,
                    assignedTo: assignedToArray,
                    technician: technicianArray,
                    searchString: vm.filters.search?.trim(),
                    sortField: vm.filters.sortBy || sortEnum.ro,
                    sortDirection: vm.filters.sortDirection,
                    pageIndex: startIndex,
                    pageSize: itemsPerPage,
                    isCpo: false,
                    isTrainingRo: false,
                    fromDate: vm.filters.customTimeframe.startDate,
                    toDate: vm.filters.customTimeframe.endDate,
                    timeframe: vm.filters.timeframeFilter,
                    showOnlyMine: vm.filters.showOnlyMine
                };
                
                clearRefreshInterval();
               
                roService.getRouteSheet(vm.selectedLocation.id, filters).then((repairOrders) => {
                    if (!repairOrders.length) {
                        vm.canLoadMore = false;

                        if (startIndex === 0) {
                            vm.repairOrders = [];
                        }
                    } else {
                        let preferencesPromise = Promise.resolve();

                        if (!fromPaging && !vm.searchTemplateData.currentSearchTemplate) {
                            preferencesPromise = roService.getUserPreferences(vm.selectedLocation.id).then((preferenceResponse) => {
                                parsePreferences(preferenceResponse);
                            });
                        }

                        preferencesPromise.then(() => {
                            repairOrders.forEach((ro) => {
                                ro.inspectActions = filterInspectActions(ro);

                                processColumns(ro);
                            });

                            vm.repairOrders = startIndex === 0 ? repairOrders : vm.repairOrders.concat(repairOrders);

                            if (roToSelect) {                                    
                                vm.onRoSelected(roToSelect);                                
                            }    

                            if (fromAutoRefresh) {
                                $scope.$broadcast('routeSheetAutoRefreshed');
                            }

                            vm.canLoadMore = repairOrders.length === itemsPerPage;             
                        });                        
                    }
                }).catch((err) => {
                    rcLocalStorageService.set('selectedInspectDealer', null);
                    vm.autoRefresh = false;
                }).finally(() => {
                    if (vm.autoRefresh === undefined) {
                        vm.autoRefresh = rcLocalStorageService.get('route-refresh', vm.autoRefresh) || false;
                    }

                    if (vm.autoRefresh && !vm.showAdvancedSearch) {
                        vm.setRefreshInterval();
                    }
                    
                    // The list can sometimes load "too" quickly, creating a jarring visual for the user.  Adding
                    //  an artificial timeout here for a smoother UX.
                    $timeout(() => {
                        vm.isLoading = false;
                        vm.isLoadingMore = false;
                    }, 500);                    
                });
            }

            vm.onRoSelected = function(ro) {
                $rootScope.$emit('selectRoTab', ro);
            };

            vm.onActionSelected = function(ro) {
                inspectActionService.triggerAction(ro.selectedAction, vm.selectedLocation.id, ro, true).then((success) => {
                    if (success && ro.selectedAction === INSPECT_CONSTANTS.actionEnum.assignTo) {
                        loadRouteSheet();                        
                    }
                }).finally(() => {
                    ro.selectedAction = null;
                });
            };

            vm.expandSearch = function() {
                vm.searchTemplateBeforeAdvancedSearch = _.cloneDeep(vm.searchTemplateData);
                vm.locationBeforeAdvandedSearch = _.cloneDeep(vm.selectedLocation);
                vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);
                vm.showAdvancedSearch  = !vm.showAdvancedSearch;
                
                if (!vm.showAdvancedSearch) {
                    vm.setRefreshInterval();

                    return;
                }

                if (vm.autoRefresh) {
                    clearRefreshInterval();
                }
            };

            function processColumns(ro) {
                vm.columnsToDisplay.forEach((col) => {
                    if (col.name.toLowerCase() === 'dmsrepairordernumber' && !ro.dmsRepairOrderNumber) {
                        ro.dmsRepairOrderNumber = 'Pending';
                    }

                    if (!Object.prototype.hasOwnProperty.call(ro, col.name)) {
                        let expression = routeSheetColumnMapping[col.name];

                        if (typeof expression === 'function') {
                            ro[col.name] = expression(ro);
                        } else {
                            // This code should technically never be reached, but it's here to alert devs to an issue if they
                            //  change the name of a property from the server and it doesn't correlate to a property in the user preferences list.
                            ro[col.name] = 'UNKNOWN';
                        }   
                    } else if (col.isPhoneNumber) {
                        ro[col.name] = $filter('tel')(ro[col.name]);
                    } else if (col.isApproval) {
                        if (ro.pendingLineItemCount) {
                            ro[col.tooltip] = `${ro.pendingLineItemCount} Service(s)`;    
                        } else if (ro.approvedLineItemCount || ro.deferredLineItemCount) {
                            ro[col.tooltip] = `${ro.approvedLineItemCount} Appr, ${ro.deferredLineItemCount} Def`;
                        }
                        
                        if (ro.approvalTimestamp) {
                            ro[col.tooltip] += `\n${$filter('fromNow')(ro.approvalTimestamp)}`;
                        }
                    } else if (col.name.toLowerCase() === 'vin') {
                        if (ro[col.name] && ro[col.name].length > 8) {
                            ro[col.tooltip] = ro.vin;
                            ro[col.name] = ro[col.name].slice(-8);
                        }
                    } else if (col.name.toLowerCase() === 'statusname') {
                        ro[col.tooltip] = ro.statusName;

                        if (ro.statusModifiedDate) {
                            let diffSeconds = moment().diff(moment(ro.statusModifiedDate), 'seconds');
                            let statusElapsed = rcUtilService.calcDuration(diffSeconds);

                            ro[col.tooltip] += `\n`;
                            ro[col.name] += `<br>` + statusElapsed;
                        }
                    } else if (col.name.toLowerCase() === 'inspectionstatusname') {
                        ro[col.tooltip] = ro.inspectionStatusName;
 
                        if (ro.inspectionDate) {
                            let timeInfo = '';

                            if (ro.inspectionCompletedDate) {
                                timeInfo = $filter('localTimeOfDay')(ro.inspectionCompletedDate, 'MM/DD/YY h:mm A');                                
                            } else {
                                let diffSeconds = moment().diff(moment(ro.inspectionDate), 'seconds');

                                timeInfo = rcUtilService.calcDuration(diffSeconds);
                            }                           
                           
                            ro[col.tooltip] += `\n`;
                            ro[col.name] += `<br><span class='text-notransform'>` + timeInfo + '</span>';
                        }
                    }
                });
            }

            function getAbbreviatedDisplayName (col) {
                let origDisplayName = col.displayName.toLowerCase();

                switch (origDisplayName) {
                    case "dms customer":
                        return "CUST ID";
                    case "odometer":
                        return "ODO";
                    case "promise time":
                        return "PROMISED";
                    case "assigned to":
                        return "assigned";
                    default:
                        return col.displayName;
                }
            }

            function parsePreferences(preferenceResponse) {
                const currentSortCol = vm.sortOptions.find(c => c.id ===  vm.filters.sortBy); 

                vm.preferences = JSON.parse(preferenceResponse);
                                
                vm.allColumns = vm.preferences.routeSheetColumns;
                vm.columnsToDisplay = vm.allColumns.filter((col) => { return col.show; });
               
                vm.columnsToDisplay.forEach((col) => {
                    col.displayName = getAbbreviatedDisplayName(col);
                    col.isSortable = vm.sortOptions.some(sortOption => sortOption.name === col.name); 
                    col.isMobile = vm.mobileDisplayColumns.some(mobileOption => mobileOption.name === col.name); 
                    col.isActive = col.name === currentSortCol.name;

                    if (col.name.toLowerCase() === 'statusname') {
                        col.backgroundProperty = 'statusColor';
                        col.foregroundProperty = 'statusTextColor';
                    } else if (col.name.toLowerCase() === 'shopflagname') {
                        col.backgroundProperty = 'shopFlagColor';
                        col.foregroundProperty = 'shopFlagTextColor';
                    } else {
                        col.backgroundProperty = null;
                        col.useWhiteForeground = false;
                    }
                });
            }

            vm.columnsFilterClicked = function() {
                vm.showSortable = !vm.showSortable;
                updateDirtyFlag();
            };

            vm.columnFilterClicked = function() {
                updateDirtyFlag();
            };

            vm.onColumnReorder = function(e, ui) {
                updateDirtyFlag();
                _.forEach(vm.allColumns, (col, index) => {
                    col.order = index;
                });

                _.forEach(vm.columnsToDisplay, (col, index) => {
                    col.order = index;
                });
            };

            vm.applyBtnClicked = function() {
                vm.searchTemplateBeforeAdvancedSearch = null;
                vm.filtersBeforeAdvancedSearch = null;
                vm.showAdvancedSearch = false;
                vm.showSortable = false;
                vm.filtersChanged();

                if (vm.preferences) {
                    vm.preferences.routeSheetColumns = vm.allColumns;
                    vm.preferences.orderedColumns = _.map(vm.allColumns, (col) => { return col.name; });
                }

                if (!vm.searchTemplateData.currentSearchTemplate && vm.preferences) {
                    roService.saveUserPreferences(vm.selectedLocation.id, angular.toJson(vm.preferences)).then(() => { 
                        if (vm.roNumberSearch && vm.roNumberSearch !== '') {
                            vm.searchRos(vm.roNumberSearch);
                        } else {
                            vm.filtersChanged();
                        }
                    });
                } else {
                    vm.filtersChanged();
                }

                vm.setRefreshInterval();
            };

            vm.addRo = function () {
                clearRefreshInterval();
                inspectModalService.createRo(vm.selectedLocation).then((savedRo) => {
                    if (savedRo) {
                        loadRouteSheet(false, false, null, savedRo);
                    }

                    vm.setRefreshInterval();
                });
            };

            function filterInspectActions() {
                let actionsToRemove = [INSPECT_CONSTANTS.actionEnum.updateRo, INSPECT_CONSTANTS.actionEnum.changeInspectionForm, INSPECT_CONSTANTS.actionEnum.printInspectionSummary, INSPECT_CONSTANTS.actionEnum.passAll];
                
                if (!permissions.hasUserPermission(SYSTEM_ENUMS.permissionTypes.payments) || !vm.hasDealerPaymentsPermission) {
                    actionsToRemove.push(INSPECT_CONSTANTS.actionEnum.sendForPayment);
                }

                return INSPECT_CONSTANTS.inspectActions.filter((action) => { return !actionsToRemove.includes(action.id); });
            }

			vm.sortableColumnClicked = function(clickedCol) {
                let ascending = vm.sortOrder.ascending;
                let descending = vm.sortOrder.descending;

                if (clickedCol.isSortable) {
                    if (clickedCol.isActive) {
                        if (vm.filters.sortDirection === descending) {
                            vm.filters.sortDirection = ascending;
                        } else {
                            vm.filters.sortDirection = descending;
                        }
                    } else {
                        const currActive = vm.columnsToDisplay.find(curColl => curColl.isActive === true);

                        if (currActive) {
                            currActive.isActive = false;
                        } 

                        clickedCol.isActive = true;
                        
                        const sortCol = vm.sortOptions.find(c => c.name === clickedCol.name); 
                        
                        if (sortCol) {
                            vm.filters.sortDirection = ascending;
                            vm.filters.sortBy = sortCol.id;
                        }
                    }

                    vm.filtersChanged();
                }
            };

            function init() {
                // CAZ added so that we don't keep wiping out the saved dealer in filters
                vm.selectedLocation = rcLocalStorageService.get('selectedInspectDealer') || null;
                let savedFilters = rcLocalStorageService.get('selectedInspectFilters') || null;
               
                vm.filters = {
                    sortBy: savedFilters?.sortBy || sortEnum.ro,
                    sortDirection: savedFilters?.sortDirection || vm.sortOrder.descending,
                    showInactive: savedFilters?.showInactive || false,
                    showAllOpen: savedFilters?.showAllOpen || false,
                    showStatusColorAcrossRow: savedFilters?.showStatusColorAcrossRow || false,
                    showOnlyMine: savedFilters?.showOnlyMine || false,
                    customTimeframe: savedFilters?.customTimeframe || defaultDateRange,
                    serviceAdvisors: savedFilters?.serviceAdvisors || [],
                    assignedTo: savedFilters?.assignedTo || [],
                    technicians: savedFilters?.technicians || [],
                    statuses: savedFilters?.statuses || [],
                    search: savedFilters?.search || null,
                    timeframeFilter: savedFilters?.timeframeFilter  || 0                   
                };
                

                if (!vm.filters.customTimeframe || !vm.filters.customTimeframe.startDate) {
                    vm.filters.customTimeframe = {startDate: moment(), endDate: moment()};
                } else {
                    vm.filters.customTimeframe = {startDate: moment(vm.filters.customTimeframe.startDate), endDate: moment(vm.filters.customTimeframe.endDate)};
                }

                
                if (!vm.filters.timeframeFilter) {
                    vm.filters.customTimeframe = defaultDateRange;
                }

                vm.sortOptions = [
                    {
                        id: sortEnum.ro,
                        name: 'dmsRepairOrderNumber',
                        displayName: 'RO'
                    },
                    {
                        id: sortEnum.customerName,
                        name: 'customer',
                        displayName: 'Customer Name'
                    },
                    {
                        id: sortEnum.status,
                        name: 'statusName',
                        displayName: 'Inspection Status'
                    },                   
                    {
                        id: sortEnum.flag,
                        name: 'shopFlagName',
                        displayName: 'Shop Flag'
                    },
                    {
                        id: sortEnum.departmentName,
                        name: 'departmentName',
                        displayName: 'Department'
                    }
                ];

                vm.mobileDisplayColumns = [
                    {name: 'dmsRepairOrderNumber'},
                    {name: 'serviceAdvisorName'},
                    {name: 'customer'},
                    {name: 'statusName'},
                    {name: 'shopFlagName'},
                    {name: 'technicianName'},
                    {name: 'vehicle'}
                ];

                vm.isLoading = true;

                locationService.getLocationsForDropDown(true, false, SYSTEM_ENUMS.permissionTypes.inspect).then((dealers) => {
                    vm.dealers = dealers;

                    let queryStringDealerId = $stateParams['dealerId'];
                    let storageServiceDealer = rcLocalStorageService.get('selectedInspectDealer') || null;
                    let qsDealer = null;
                    
                    if (queryStringDealerId) {
                        let matchingDealer = _.filter(dealers, (d) => { return d.id === parseInt(queryStringDealerId); });

                        if (matchingDealer && matchingDealer.length > 0) {
                            qsDealer = matchingDealer[0];
                        }
                    }

                    if (vm.dealers.length === 1) {
                        vm.selectedLocation = vm.dealers[0];
                    } else {
                        vm.selectedLocation = qsDealer || storageServiceDealer;
                    }

                    createFilterMessage();
                    updateFilterOptions(true);                    
                });

                $scope.$watch('vm.selectedTabType', (newValue) => {
                    vm.routeSheetTabActive = vm.selectedTabType === INSPECT_CONSTANTS.tabTypes.routeSheet;

                    if (vm.routeSheetTabActive) {
                        loadRouteSheet(false, false, null);                        
                    }
                });

                $rootScope.$on('dealerLoadedFromRoute', (e, dealerId) => {
                   
                    if (vm.dealers.length > 1) {
                        vm.selectedLocation = _.find(vm.dealers, {id: dealerId});
                    } else {
                        vm.selectedLocation = vm.dealers[0];
                    }
                });
            }

            function updateFilterOptions(initializing) {
                if (vm.selectedLocation) {
                    return roService.getDealerFilterOptions(vm.selectedLocation.id).then((options) => {
                        vm.filters.roStatuses = options.roStatuses;
                        
                        vm.filters.dealerUsers = options.dealerUsers
                                            .map(user => ({
                                                ...user,
                                                label: user.fullName.toUpperCase()
                                            }))
                                            .sort((a, b) => a.label.localeCompare(b.label));
    
                        vm.filters.techniciansList = vm.filters.dealerUsers.filter((u) => { return u.roles.some((r) => r === roleEnum.technician); });
                        vm.filters.serviceAdvisorsList = vm.filters.dealerUsers.filter((u) => { return u.roles.some((r) => r === roleEnum.serviceAdvisor); });

                        if (initializing) {
                            loadSearchTemplates();
                        }
                    });
                } else {
                    if (initializing) {
                        vm.isLoading = false;
                        loadSearchTemplates();
                    }
                    
                    return;
                }        
            }

            init();
        };
    }
})();

/* global QRCode */
(function () {
    'use strict';

    angular
        .module('redcap.inspect')
        .controller('QrCodeController', QrCodeController);

    function QrCodeController() {
        let vm = this;

        vm.generateQrCode = (containerId, url, logoPath, options) => {
            const container = document.getElementById(containerId);
            
            if (!container) return;
            container.innerHTML = '';

            new QRCode(container, Object.assign({
                text: url,
                width: 96,
                height: 96,
                colorDark: "black",
                colorLight: "white",
                correctLevel: QRCode.CorrectLevel.H
            }, options));

            container.removeAttribute('title');

            if (logoPath) {
                const oldLogo = container.querySelector('.qr-logo');
                
                if (oldLogo) oldLogo.remove();
                const logo = document.createElement('img');
                
                logo.src = logoPath;
                logo.className = 'qr-logo';
                container.appendChild(logo);
            }
        };
    }
})();

(function () {
    'use strict';

    InspectBaseController.$inject = ["$uibModalStack", "$rootScope", "$stateParams", "$state", "$timeout", "appointmentUtilService", "tripService", "rcLocalStorageService", "inspectionService", "INSPECT_CONSTANTS", "roService", "permissions", "$window", "rcUtilService", "locationService", "SYSTEM_ENUMS"];
    angular
        .module('redcap.inspect')
        .controller('InspectBaseController', InspectBaseController);

    function InspectBaseController($uibModalStack, $rootScope, $stateParams, $state, $timeout, appointmentUtilService, tripService, rcLocalStorageService, inspectionService, INSPECT_CONSTANTS, roService, permissions, $window, rcUtilService, locationService, SYSTEM_ENUMS) {
        let vm = this;
        const cachedROLimit = 15;

        vm.tabIdPrefix = "tab_";
        vm.dealerId = null;
        vm.tabbedRos = [];
        vm.tabType = INSPECT_CONSTANTS.tabTypes;
        vm.hasMessaging = false;
        vm.hasDealerPaymentsPermission = false;

        vm.onTabSelected = function(tabType, roTab) {
            vm.selectedTabType = tabType;

            if (roTab) {
                if (vm.dealerId !== roTab.dealerId) {
                    vm.dealerId = roTab.dealerId;
                    dealerUpdated();
                }

                addRoDetailTab(roTab.dealerId, roTab.roId, roTab.customerName, true, roTab.roNumber);
            } else {
                // if we're not on an ro tab, we go to the base inspect page, which is the routesheet.
                cacheSelections();

                $state.go('inspect', {tabType: vm.selectedTabType, dealerId: vm.dealerId}, {reload: false});
            }
        };

        function resizeScrollTabs () {
            // this will make the scroll tabs redraw
            $window.dispatchEvent(new Event("resize"));
        }
        
        function cacheSelections () {
            let params = {
                tabType: vm.selectedTabType,
                dealerId: vm.dealerId
            };

            rcLocalStorageService.set('cachedInspectSettings', params);
            rcLocalStorageService.set('cachedInspectSettingsByDealer-' + vm.dealerId, {tabbedRos: vm.tabbedRos});
        }
        
        function isStateParamInvalid (paramName) {
            return (!$stateParams[paramName] || $stateParams[paramName] === undefined);
        }

        function loadCachedROs () {
            if (vm.tabbedRos && vm.tabbedRos.length > 0) {
                vm.tabbedRos.forEach((roToOpen, idx) => {
                    roToOpen.uniqueId = appointmentUtilService.getUniqueDOMID();
                    addRoDetailTab(vm.dealerId, roToOpen.roId, roToOpen.customerName, false, roToOpen.activeInspectTab, roToOpen.roNumber);
                });

                // Default the selected tab to the routesheet
                vm.selectedTabType = vm.tabType.routeSheet;
            }
        }
        
        function dealerUpdated () {
            if (vm.dealerId) {
                tripService.hasMessaging(vm.dealerId).then((result) => {
                    vm.hasMessaging = result;
                    $timeout(() => {
                        $rootScope.$broadcast('messagePaneHasMessagingUpdate', result);
                    }, 1);
                });

                getDealerPaymentsPermission(vm.dealerId).then((result) => {
                    vm.hasDealerPaymentsPermission = result;
                    $timeout(() => {
                        $rootScope.$broadcast('dealerPaymentsPermissionUpdate', result);
                    }, 1);
                });
            }
        }

        function init() {
            let storageServiceParams = rcLocalStorageService.get('cachedInspectSettings') || {};
            let dealerId = $stateParams.dealerId || storageServiceParams.dealerId;
            
            vm.tabbedRos = (rcLocalStorageService.get('cachedInspectSettingsByDealer-' + dealerId) || {}).tabbedRos || [];
            
            if (vm.dealerId !== dealerId) {
                vm.dealerId = dealerId;
                dealerUpdated();
            }
            
            loadCachedROs();            

            if (isStateParamInvalid('tabType')) {
                vm.selectedTabType = +(storageServiceParams.tabType || vm.tabType.routeSheet);
            } else {
                vm.selectedTabType = +($stateParams.tabType);
            }
            
            if (vm.selectedTabType === vm.tabType.roDetail) {
                let roDetailStateParams = ['dealerId', 'roId'];
                let areParamsValid = !_.some(roDetailStateParams, (paramKey) => {
                    return $stateParams[paramKey] == null || $stateParams[paramKey] == undefined;
                });

                if (areParamsValid) {                   
                    addRoDetailTab(+$stateParams.dealerId, +$stateParams.roId, $stateParams.customerName, true);
                } else {
                    vm.selectedTabType = vm.tabType.routeSheet;
                }
            } else {
                if (vm.dealerId) {
                    $rootScope.$broadcast('dealerLoadedFromRoute', vm.dealerId);
                }

                vm.onTabSelected(INSPECT_CONSTANTS.tabTypes.routeSheet);
            }
           
            cacheSelections();
        }


        function addRoDetailTab(dealerId, repairOrderId, customerName, selectTab, activeInspectTab, roNumber) {
            let existingTab = vm.tabbedRos.find((tab) => { return tab.roId === repairOrderId; });
            let tabToSet = null;
            const defaultTab = inspectionService.getDefaultRODetailTab();

            vm.selectedTabType = vm.tabType.loading;
            vm.dealerId = dealerId;

            if (!existingTab) {      
                let newTab = {
                    roId: repairOrderId,
                    uniqueId: appointmentUtilService.getUniqueDOMID(),
                    dealerId: dealerId,
                    customerName: customerName,
                    lastName: rcUtilService.getCustomerLastName(customerName),
                    tabType: vm.tabType.roDetail,
                    canClose: true,
                    activeInspectTab: activeInspectTab || defaultTab,
                    roNumber: roNumber || 'Pending',
                    roNumberSuffix: rcUtilService.getRoNumberSuffix(roNumber || 'Pending')
                };
                
                vm.tabbedRos.unshift(newTab);

                if (vm.tabbedRos.length > cachedROLimit) {
                    vm.tabbedRos = vm.tabbedRos.slice(0, cachedROLimit);
                }

                tabToSet = newTab;
                resizeScrollTabs();
            } else {
                tabToSet = existingTab;
            }  
            
            // Wrap in timeout to ensure angular recompiles the ro-detail component with the new selectedTab.
            if (selectTab) {
                $timeout(() => {                    
                    vm.selectedTab = tabToSet;
                    vm.selectedTabType = vm.tabType.roDetail;

                    cacheSelections();

                    $state.go($state.current, vm.selectedTab, {location: true, inherit: true, notify: false});
                }, 0);
            }
        }

        vm.closeTab = function(tab) {
            rcLocalStorageService.remove('approvedServicesTableOpen' + tab.roId);
            rcLocalStorageService.remove('pendingServicesTableOpen' + tab.roId);
            rcLocalStorageService.remove('inspectServicesTabShowHidden' + tab.roId);
            rcLocalStorageService.remove('inspectTabLastOpenedSectionId' + tab.roId);
            
            _.remove(vm.tabbedRos, {roId: tab.roId});
            
            if (vm.selectedTab && vm.selectedTab.roId === tab.roId) {
                if (vm.tabbedRos.length) {
                    let newTab = vm.tabbedRos[vm.tabbedRos.length - 1];

                    addRoDetailTab(newTab.dealerId, newTab.roId, newTab.customerName, true, newTab.activeInspectTab, newTab.roNumber);
                } else {
                    vm.selecedTab = null;
                    vm.onTabSelected(INSPECT_CONSTANTS.tabTypes.routeSheet);
                }
            }

            cacheSelections();
            resizeScrollTabs();
        };

        $rootScope.$on('selectedDealerChanged', (e, selectedDealer) => {
           
            let origSelectedId = vm.dealerId;

            vm.dealerId = selectedDealer != null ? selectedDealer.id : null;

            $state.go('inspect', {tabType: vm.selectedTabType, dealerId: vm.dealerId}, {notify: false});

            // only load new tabs if we actually changed dealers
            if (origSelectedId && parseInt(origSelectedId) !== vm.dealerId) {
                let cachedRoTabs = rcLocalStorageService.get('cachedInspectSettingsByDealer-' + vm.dealerId) || {};

                vm.tabbedRos = cachedRoTabs?.tabbedRos || [];                
                
                loadCachedROs();                
            }
           
            dealerUpdated();
        });

        $rootScope.$on('selectRoTab', (e, ro) => {
            // The shape of the ro can be slightly different based on where it's coming from (routesheet, ro detail component, create ro modal)
            const customerName = rcUtilService.formatCustomerName(ro.customer || ro);
            
            addRoDetailTab(ro.dealerId, ro.id, customerName, true, null, ro.dmsRepairOrderNumber);
        });

        $window.onpopstate = function(event) {
            const isInspect = $window.location.href.includes('inspect');

            if ($state.current.name === 'inspect' || isInspect) {       
                const urlParams = new URLSearchParams($window.location.search);
                const tabType = urlParams.get('tabType') || 0;
                const roId = urlParams.get('roId') || 0;

                if ($uibModalStack && $uibModalStack.getTop()) {
                    let top = $uibModalStack.getTop();

                    $uibModalStack.dismiss(top.key);
                }

                if (isInspect) {
                    if (roId > 0) {    
                        const params = { 
                            tabType: tabType,
                            dealerId: urlParams.get('dealerId') || null,
                            roId: roId,
                            customerName: urlParams.get('customerName') || '',
                            activeInspectTab: urlParams.get('activeInspectTab') || INSPECT_CONSTANTS.detailTabType.inspection
                        };
    
                        vm.onTabSelected(tabType, params);
                    } else {
                        vm.onTabSelected(INSPECT_CONSTANTS.tabTypes.routeSheet);
                    }
                }                
            }
        };

        vm.onTabsReordered = function(e, ui) {
            let newIdx = ui.item.index() - 1; // this is not zero based so we have to subtract 1
            let roId = ui.item[0].id.replace(vm.tabIdPrefix, "");
            // what is the current index of this RO in the cached tabs
            let currIdx = vm.tabbedRos.findIndex((tab) => { return parseInt(tab.roId) === parseInt(roId); });
            
            // update the position in the tabs
            vm.tabbedRos.splice(newIdx, 0, vm.tabbedRos.splice(currIdx, 1)[0]);
            cacheSelections(); // store the new order
        };

        vm.sortableSettings = {
            stop: vm.onTabsReordered
        };

        function getDealerPaymentsPermission(dealerId) {               
                return locationService.hasRole(dealerId, SYSTEM_ENUMS.permissionTypes.payments).then((result) => {
                    vm.hasDealerPaymentsPermission = result;

                    return result;
                }).catch(() => {
                    
                });
        }

        init();
    }
})();

(function () {
    'use strict';

    angular.module('redcap.driver', []);
})();
(function () {
    'use strict';

    driverService.$inject = ["$q", "$rootScope", "rcApi", "SYSTEM_ENUMS"];
    angular
        .module('redcap.driver')
        .factory('driverService', driverService);

    function driverService($q, $rootScope, rcApi, SYSTEM_ENUMS) {

        let DRIVER_BASEPATH = 'driver/';

        return {
            subscribeChanged: subscribeChanged,
            getDrivers: getDrivers,
            getAccountDrivers: getAccountDrivers,
            getDriver: getDriver,
            addDriver: addDriver,
            updateDriver: updateDriver,
            messageDriver: messageDriver,
            updatePassword: updatePassword,
            updateSettings: updateSettings,
            sendWelcomeSms: sendWelcomeSms,
            getCompanies: getCompanies,
            isNetworkDriver: isNetworkDriver,
            bulkImportDrivers: bulkImportDrivers,
            updateCertifications: updateCertifications,
            getCertifications: getCertifications,

            // validation
            driverUserNameIsValid: driverUserNameIsValid,
            moveDriversBetweenDealers: moveDriversBetweenDealers
        };

        function subscribeChanged (scope, callback) {
            $rootScope.$on('DriverService.changed', callback);
        }

        function getDrivers(filter, cancellationToken) {
            if (filter)
                return rcApi.post(DRIVER_BASEPATH + 'search', filter, cancellationToken);

            return rcApi.get(DRIVER_BASEPATH);
        }

        function getAccountDrivers(accountId) {
            return rcApi.get(DRIVER_BASEPATH + 'account/' + accountId);
        }

        function getDriver(driverId) {
            return rcApi.post('driver' + '?driverId=' + driverId);
        }

        function addDriver(newDriver) {
            return rcApi.post(DRIVER_BASEPATH, newDriver)
                        .then ((result) => {
                            $rootScope.$emit('DriverService.changed', newDriver);

                            return result;
                        });
        }

        function updateDriver(updatedDriver) {
            return rcApi.post(DRIVER_BASEPATH + "updatedDriver", updatedDriver)
                        .then((response) => {
                            if (response === true)
                                $rootScope.$emit('DriverService.changed', updatedDriver);

                            return response;
                        });
        }

        function messageDriver(driverId, message) {
            return rcApi.post(DRIVER_BASEPATH + 'message', {driverId: driverId, message: message});
        }

        function updatePassword(driverId, password, requiresPasswordChange) {
            return rcApi.put(DRIVER_BASEPATH + driverId + '/password', {userId: driverId, newPassword: password, requiresPasswordChange: requiresPasswordChange});
        }

        function getCompanies() {
            return rcApi.get(DRIVER_BASEPATH + '/driverCompanies');
        }

        function updateSettings(driverId, settings) {
            return rcApi.post(DRIVER_BASEPATH + driverId + '/settings', settings);
        }

        function updateCertifications(driverId, certifications) {
            return rcApi.post(DRIVER_BASEPATH + driverId + '/certifications', certifications);
        }

        function getCertifications(driverId, homeDealerId) {
            let driverParam = '';
            let homeDealerParam = '';

            // driverId and homeDealerId will never both have values
            if (driverId) {
                driverParam = '?dispatchDriverId=' + driverId;
            }

            if (homeDealerId) {
                homeDealerParam = '?homeDealerId=' + homeDealerId;
            }

            return rcApi.get(DRIVER_BASEPATH + 'certifications/all' + driverParam + homeDealerParam);
        }

        function bulkImportDrivers(base64FileData) {
            return rcApi.post(DRIVER_BASEPATH + 'bulkimport', {base64FileData: base64FileData});   
        }

        function sendWelcomeSms(driverList) {
            let promises = [];

            driverList.forEach((driverId) => {
                let promise = rcApi.get(DRIVER_BASEPATH + driverId + '/sendSms');
                
                promises.push(promise);
            });

            return $q.all(promises).then((statuses) => {
                let finalStatus = true;
                
                statuses.forEach((status) => {
                    finalStatus &= status;
                });
                
                return finalStatus;
            });
        }

        function driverUserNameIsValid(userName) {
            return rcApi.get(DRIVER_BASEPATH + 'driverUserNameIsValid', {userName: userName});
        }

        function isNetworkDriver(driverCompanies, currentCompanyId, defaultValue) {
            let currentCompany = driverCompanies.find((c) => {
                return c.id === currentCompanyId;
            });

            if (currentCompany) {
                return currentCompany.type !== SYSTEM_ENUMS.driverCompanyType.internal;
            } else {
                return defaultValue;
            }
        }

        function moveDriversBetweenDealers(ids, targetDealerId, sourceDealerId) {
            return rcApi.post(DRIVER_BASEPATH + 'moveDrivers', {ids: ids, targetDealerId: targetDealerId, sourceDealerId: sourceDealerId});
        }
    }
})();

(function () {
    'use strict';

    DriverTabSettingsController.$inject = ["driverService", "resolvedDriver", "eventAlertService"];
    angular
        .module('redcap.driver')
        .controller('DriverTabSettingsController', DriverTabSettingsController);

    function DriverTabSettingsController(driverService, resolvedDriver, eventAlertService) {
        var vm = this;
        vm.currentDriver = resolvedDriver;

        vm.updateDriver = function () {
            driverService.updateSettings(resolvedDriver.id, { isDisabled: resolvedDriver.isDisabled, canAcceptConflict: resolvedDriver.canAcceptConflict, suppressConflictingTripNotifications: resolvedDriver.suppressConflictingTripNotifications })
                .then(function (result) {
                    if (result) { eventAlertService.createAlert('Driver Settings Successfully Updated.'); }
                });
        };
    }
})();

(function () {
    'use strict';

    DriverTabSecurityController.$inject = ["$log", "$scope", "$filter", "userService", "driverService", "inputMapper", "toastr", "SYSTEM_ENUMS", "resolvedDriver", "eventAlertService"];
    angular
        .module('redcap.driver')
        .controller('DriverTabSecurityController', DriverTabSecurityController);

    function DriverTabSecurityController($log, $scope, $filter, userService, driverService, inputMapper, toastr, SYSTEM_ENUMS, resolvedDriver, eventAlertService) {
        var vm = this;

        vm.currentDriver = resolvedDriver;
        vm.password = '';
        vm.passwordConfirm = '';
        vm.changingPassword = false;
        vm.requiresPasswordChange = true;

        vm.updatePassword = function () {
            vm.changingPassword = true;
            driverService.updatePassword(vm.currentDriver.id, vm.password, vm.requiresPasswordChange).then(function (response) {
                eventAlertService.createAlert('Driver Password Successfully Changed.');
                // if we don't put a timeout
                // a small overlap exists and both red buttons get a spinner for a brief moment
                setTimeout(function () {
                    vm.changingPassword = false;
                    $scope.DriverEditForm.$setPristine(true);
                }, 1000);
            })
            .catch(function(fallback) {
                vm.changingPassword = false;
            });
        };

        vm.passwordRemoteValidation = function() {
            return userService.checkPassword(vm.password);
        };

    }
})();

(function () {
    'use strict';

    DriverTabLocationsController.$inject = ["$log", "$scope", "driverService", "locationService", "webworkerService", "resolvedDriver", "resolvedLocationList", "resolvedCompanyList", "permissions", "eventAlertService", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "mapObjectFactory", "modalService"];
    angular
        .module('redcap.driver')
        .controller('DriverTabLocationsController', DriverTabLocationsController);

    function DriverTabLocationsController($log, $scope, driverService, locationService, webworkerService, resolvedDriver, resolvedLocationList, resolvedCompanyList, 
            permissions, eventAlertService, SYSTEM_ENUMS, HERE_MAPS_CONFIG, mapObjectFactory, modalService) {
        var vm = this,
            displayLimit = 50,
            circleExists = false,
            perimeterStyle = HERE_MAPS_CONFIG.perimeterStyle;

        function createSelectedLocations() {
            var locations = [];
            _.forEach(resolvedDriver.allowedDealers, function (allowed) {
                for (var i = 0, length = resolvedLocationList.length; i < length; i++) {
                    var resolvedLocation = resolvedLocationList[i];
                    if (allowed.id === resolvedLocation.id || allowed === resolvedLocation.id) {
                        locations.push(resolvedLocation);
                        break;
                    }
                }
            });

            return locations;
        }

        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.currentDriver = resolvedDriver;
        vm.currentDriver.serviceArea = vm.currentDriver.serviceArea || { dealers: [] };
        vm.serviceAreaMiles = (Math.round(resolvedDriver.serviceArea.serviceAreaRadius / 1609.34)) || 0;
        vm.locationDisplayLimit = 0;
        vm.employeeDisplayLimit = displayLimit;
        vm.companies = resolvedCompanyList;
        vm.resolvedLocations = resolvedLocationList;
        vm.supportedLocations = resolvedLocationList;
        vm.selectedLocations = createSelectedLocations();
        vm.markers = [];


        if (!vm.currentDriver.isDedicated &&  _.get(vm.currentDriver, 'serviceArea.serviceAreaLocation', undefined)) {
            vm.driverHomeBase = {
                lat: vm.currentDriver.serviceArea.serviceAreaLocation.lat,
                lng: vm.currentDriver.serviceArea.serviceAreaLocation.lng
            };

            updateMap();
        }

        vm.autoCompleteOptions = {
            country: 'us,can'
        };

        vm.mapOptions = {
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            forceHideRecenter: true,
            showControls: true,
            draggable: true,
            resize: true
        };

        vm.sliderOptions = {
            enforceStep: false,
            step: 10,
            floor: 0,
            ceil: 200,
            showSelectionBar: true,
            showTicks: false,
            onEnd: function(id) {
                updateMap();
            }
        };

        vm.onMapReady = function (hereMap) {
            vm.hereMap = hereMap;
            vm.hereMap && vm.hereMap.setStyle(HERE_MAPS_CONFIG.normalViewSettings);

            $scope.$on('resizeHereMap', function () {
                if (vm.hereMap)
                    vm.hereMap.refresh();
            });
        };

        _.forEach(resolvedLocationList, function (location) {
            location.locationHtml = location.name;
            switch (location.status) {
                case 1:
                    location.statusText = 'Active';
                    break;
                case 2:
                    location.statusText = 'QA';
                    break;
                case 3:
                    location.statusText = 'Install';
                    break;
                default:
                    location.statusText = 'Disabled';
                    break;
            }
        });

        vm.dedicatedChanged = function() {
            if (!vm.currentDriver.isDedicated) {
                vm.driverHomeBase = {
                    lat: vm.currentDriver.serviceArea.serviceAreaLocation.lat,
                    lng: vm.currentDriver.serviceArea.serviceAreaLocation.lng
                };

                updateMap();
            }
        };

        vm.locationsFilter = function (locationName) {
            if (locationName.length >= 1) {
                webworkerService.filter(resolvedLocationList, locationName, false, 'locationHtml')
                    .then (function (result) {
                        vm.locationDisplayLimit = result.length;
                        finish(result);
                    });
            } else {
                vm.locationDisplayLimit = displayLimit;
                finish(resolvedLocationList);
            }

            function finish (locations) {
                vm.supportedLocations = _.cloneDeep(locations);
                _.forEach(vm.selectedLocations, function (location) {
                    _.remove(vm.supportedLocations, function (loc) { return loc.id === location.id; });
                });
            }
        };

        vm.locationSelected = function (item, model) {
            vm.selectedLocations.push(item);
            _.remove(vm.supportedLocations, function (location) { return location.id === item.id; });
            vm.selectedLocation = null;
        };

        vm.resetFields = function () {
            vm.selectedLocation = null;
            vm.selectedLocations = createSelectedLocations();
        };

        vm.isNetworkDriver = function() {
            return driverService.isNetworkDriver(vm.companies, vm.currentDriver.companyId, false);
        };

        vm.updateDriver = function () {
            if (vm.currentDriver.isDedicated) {
                vm.currentDriver.allowedDealers = _.map(vm.selectedLocations, 'id');
            } else {
                _.forEach(vm.currentDriver.serviceArea.dealers, function(dealer) {
                    // Setting these because the server expects these values
                    dealer.dealerId = dealer.id;
                    dealer.isDealerBlocked = dealer.isBlocked;
                });

                var serviceAreaInMeters = vm.serviceAreaMiles * 1609.34;
                vm.currentDriver.serviceAreaLocations = { dealers: vm.currentDriver.serviceArea.dealers };
                vm.currentDriver.radiusInMeters = serviceAreaInMeters;
                vm.currentDriver.homeBaseAddress = vm.currentDriver.serviceArea.serviceAddress;
                vm.currentDriver.homeBaseLocation = { lat: vm.driverHomeBase.lat, lng: vm.driverHomeBase.lng };
                vm.currentDriver.allowedDealers = null;
            }

            vm.currentDriver.profilePicture = null;
            $log.debug(vm.currentDriver);

            driverService.updateDriver(vm.currentDriver).then(function (response) {
                eventAlertService.createAlert('Driver Locations Successfully Updated.', 2000, function() {
                    eventAlertService.createAlert('Please verify the driver’s trip access on the Permissions tab.', 100000);
                });

                // Update the locations
                vm.currentDriver.allowedAccounts = _.map(vm.selectedLocations, function (location) {
                    location.id = location.id;
                    return _.pick(location, 'id', 'name');
                });
            });
        };

        vm.removeLocation = function (id) {
            if (vm.isOnlyDealerAdmin === true && vm.selectedLocations.length === 1) {
                modalService.showYesNo('Error', 'The driver must have at least one assigned location.', null, 'OK');
                return;
            }
            _.pullAllBy(vm.selectedLocations, [{'id': id}], 'id');
        };

        vm.driverCompanyChanged = function() {
            // Automatically set "IsDedicated = true" any time the driver company is "Internal".
            if (!vm.isNetworkDriver()) {
                vm.currentDriver.isDedicated = true;
            } else {
                // Dns Drivers cannot be set to "vetted" since this setting should only apply to non-Dns "Internal" drivers.
                vm.currentDriver.isDnsVetted = false;
            }
        };

        // Make the initial call to ensure dedicated is set properly.
        vm.driverCompanyChanged();

        vm.homeLocationUpdated = function(formattedAddress) {
            if (formattedAddress) {
                vm.driverHomeBase = vm.driverHomeBase || {};

                vm.driverHomeBase.streetAddress = formattedAddress.location.streetAddress;
                vm.driverHomeBase.city = formattedAddress.location.city;
                vm.driverHomeBase.state = formattedAddress.location.state;
                vm.driverHomeBase.zip = formattedAddress.location.zip;
                vm.driverHomeBase.lat = formattedAddress.location.lat;
                vm.driverHomeBase.lng = formattedAddress.location.lng;

                updateMap();
            }
        };

        function updateMap() {
            // Ensure the map has loaded before updating.
            setTimeout(function() {
                if (!vm.driverHomeBase || !vm.driverHomeBase.lat || !vm.driverHomeBase.lng || !vm.serviceAreaMiles)
                    return;

                var pinOptions = {
                    hidePopup: true,
                    draggable: false,
                    useImagesInPin: true
                };

                vm.markers = [];

                if (circleExists)
                    vm.hereMap.removeCircle();

                var venueMarker = mapObjectFactory.createHereMarker(vm.driverHomeBase.lat, vm.driverHomeBase.lng, SYSTEM_ENUMS.destinationType.customer, null, pinOptions);
                vm.markers.push(venueMarker);

                var serviceAreaInMeters = vm.serviceAreaMiles * 1609.34;

                locationService.getDealersInServiceArea(serviceAreaInMeters, vm.driverHomeBase.lat, vm.driverHomeBase.lng, vm.currentDriver.redCapDriverId).then(function(dealers) {
                    vm.currentDriver.serviceArea.dealers = dealers;

                    _.forEach(vm.currentDriver.serviceArea.dealers, function(dealer) {
                        var dealerMarker = mapObjectFactory.createHereMarker(dealer.lat, dealer.lng, SYSTEM_ENUMS.destinationType.dealer, null, pinOptions);
                        vm.markers.push(dealerMarker);
                    });

                    vm.hereMap.updateMarkers(vm.markers, true);
                    vm.hereMap.addCircle(vm.driverHomeBase.lat, vm.driverHomeBase.lng, serviceAreaInMeters, perimeterStyle.circleStyle);
                    circleExists = true;                
                });            
            }, 500);
        }

        vm.driverBlockedToggleChanged = function(location) {
            if (location.isDriverBlocked)
                location.isDriverPreferred = false;
        };

        vm.dealerBlockedToggleChanged = function(location) {
            if (location.isBlocked)
                location.isDriverPreferred = false;
        };

        vm.driverPreferredToggleChanged = function(location) {
            if (location.isDriverPreferred) {
                location.isDriverBlocked = false;
                location.isBlocked = false;
            }
        };
    }
})();

(function () {
    'use strict';

    DriverTabGeneralController.$inject = ["$log", "$transition$", "driverService", "resolvedDriver", "eventAlertService", "permissions", "appointmentUtilService"];
    angular
        .module('redcap.driver')
        .controller('DriverTabGeneralController', DriverTabGeneralController);

    function DriverTabGeneralController($log, $transition$, driverService, resolvedDriver, eventAlertService, permissions, appointmentUtilService) {
        let vm = this;

        vm.currentDriver = resolvedDriver;
        vm.message = '';
        vm.messageStatus = '';
        vm.messageSent = false;
        vm.sendingMesssage = false;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.showMessageDriver = permissions.isSysAdmin() || permissions.isRedCapAdmin() || permissions.isDeveloper();

        if ($transition$.params().driverAdded &&  $transition$.params().driverAdded === 'true') {
            vm.driverAdded = true;
        }

        vm.profilePic = {
            profileImageUpload: null,
            profileImage: null
        };

        vm.clickFileInput = function() {
            angular.element(document.querySelector('#fileInput')).click();
        };

        vm.validation = {
            phoneNumberRequired: function (number) {
                return appointmentUtilService.validatePhoneNumber(number);
            }
        };


        init();

        vm.updateDriver = function () {
            if (vm.profilePic.profileImage) {
                vm.currentDriver.profilePicture = vm.profilePic.profileImage;
            } else {
                vm.currentDriver.profilePicture = null;
            }

            vm.allowedDealers = _.cloneDeep(vm.currentDriver.allowedDealers);
            vm.currentDriver.allowedDealers = null;    // general tab should not be allowed to modify these

            $log.debug(vm.currentDriver);
            driverService.updateDriver(vm.currentDriver).then((response) => {
                vm.currentDriver.allowedDealers = vm.allowedDealers;
                eventAlertService.createAlert('User Data Successfully Updated.');
            });
        };

        vm.clearSent = function() {
            vm.messageSent = false;
        };

        vm.sendMessage = function() {
            vm.sendingMessage = true;
            driverService.messageDriver(vm.currentDriver.id, vm.message)
                .then((result) => {
                    if (result === true)
                        vm.messageStatus = 'Message Sent';
                    else
                        vm.messageStatus = 'Unable to send message.';
                }).catch((error) => {
                    vm.messageStatus = 'Unable to send message.';
                }).finally(() => {
                    vm.messageSent = true;
                    vm.sendingMessage = false;
                }
            );
        };

        function init() {
            if (vm.currentDriver.payModifierPerHour && _.isNumber(vm.currentDriver.payModifierPerHour)) {
                vm.currentDriver.payModifierPerHour = vm.currentDriver.payModifierPerHour.toFixed(2);
            }
        }
    }
})();

(function () {
    'use strict';

    DriverTabCertificationsController.$inject = ["$log", "$scope", "resolvedDriver", "driverService", "resolvedCertifications", "eventAlertService"];
    angular
        .module('redcap.driver')
        .controller('DriverTabCertificationsController', DriverTabCertificationsController);

    function DriverTabCertificationsController($log, $scope, resolvedDriver, driverService, resolvedCertifications, eventAlertService) {
        var vm = this;
        
        vm.certifications = resolvedCertifications;
        vm.driver = resolvedDriver;

        vm.updateDriverCertifications = function() {
            vm.isLoading = true;
            var selectedCerts = _.filter(vm.certifications, function (cert) { return cert.isSelected; });  
            var selectedIds = _.map(selectedCerts, function(cert) { return cert.id; });

            driverService.updateCertifications(vm.driver.redCapDriverId, selectedIds).then(function(result) {
                eventAlertService.createAlert('Permissions saved successfully.');
                vm.isLoading = false;
            }, function(err) {
                eventAlertService.createAlert('An error occurred while saving Permissions. Please try again.');
                vm.isLoading = false;
            });
        };
    }
})();

(function () {
    'use strict';

    DriverListController.$inject = ["$scope", "$state", "$timeout", "permissions", "rcLocalStorageService", "driverService", "resolvedLocationList", "rcUtilService"];
    angular
        .module('redcap.driver')
        .controller('DriverListController', DriverListController);

    function DriverListController($scope, $state, $timeout, permissions, rcLocalStorageService, driverService, resolvedLocationList, rcUtilService) {
        let vm = this;
        let displayLimit = 30;
        let page = 0;
        let multiSelectConfig = {
            '.chosen-select': {},
            '.chosen-select-deselect': {allow_single_deselect: true},
            '.chosen-select-no-single': {disable_search_threshold: 10},
            '.chosen-select-no-results': {no_results_text: 'Oops, nothing found!'},
            '.chosen-select-width': {width: "95%"}
        };

        let initialFilters = { 
            searchInput: [],
            filterByLocations: [],
            activeStatus: 'true',
            hasPhoto: ''
        };

        let initialSort = {
            sortDirection: "asc",
            sortBy: null
        };

        let savedFilterKey = "driverListSavedFilterKey";
        let savedSortKey = "driverListSavedSortKey";
        let existingFilters = rcLocalStorageService.get(savedFilterKey) || {};
        let existingSort = rcLocalStorageService.get(savedSortKey) || {};

        for (let selector in multiSelectConfig) {
            $(selector).chosen(multiSelectConfig[selector]);
        }

        vm.showAdvancedSearch  = false;
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        
        _.forEach(resolvedLocationList, (location) => {
            location.displayText = rcUtilService.formatLocationForDropdown(location);
        });
        
        vm.locations = resolvedLocationList;
        vm.filteredDrivers = [];
        vm.canShowMore = true;

        vm.sorting = {
            driver: 0,
            name: 1,
            network: 2,
            company: 3,
            dedicated: 4,
            disabled: 5
        };

        vm.sortClicked = function (type) {
            if (vm.sort.sortBy !== type || vm.sort.sortDirection !== 'asc') {
                vm.sort.sortDirection = "asc";
            } else {
                vm.sort.sortDirection = "desc";
            }

            vm.sort.sortBy = type;

            refreshSearch();
        };

        function refreshSearch() {
            if (vm.isLoading)
                return $timeout(refreshSearch, 100);

            page = 0;
            vm.filteredDrivers = [];
            vm.canShowMore = true;
            vm.searchDrivers();
        }

        vm.goToEditDriver = function (driverId) {
            $state.go('driver-tab-general', {driverId: encodeURIComponent(driverId)});
        };

        vm.searchDrivers = function () {
            if (vm.isLoading)
                return;

            vm.isLoading = true;
            let filter = {
                query: _.map(vm.filters.searchInput, (item) => { return item.text; }),
                dealerIds: vm.locations.length > 1 ?  vm.filters.filterByLocations : [],
                isWithPhoto: vm.filters.hasPhoto === '' ? null : vm.filters.hasPhoto === 'true',
                activeOnly: vm.filters.activeStatus === 'all' ? null : vm.filters.activeStatus === 'true',
                page: page,
                pageSize: displayLimit,
                sortType: vm.sort.sortBy,
                sortAsc: vm.sort.sortDirection === 'asc'
            };

            if (vm.isOnlyDealerAdmin === true) {
                filter.hideDNSDrivers = true;

                if (filter.dealerIds.length === 0) {
                    _.forEach(vm.locations, (loc) => {
                        filter.dealerIds.push(loc.id);
                        vm.forceDealerFilter = true;
                    });
                }
            }

            driverService.getDrivers(filter).then((result) => {
                
                if (vm.forceDealerFilter) {
                    filter.dealerIds = [];
                    vm.filters.filterByLocations = null;
                    vm.forceDealerFilter = false;
                }

                if (result.length === 0 || result.length < displayLimit) {
                    vm.canShowMore = false;
                }

                if (result.length > 0) {
                    vm.filteredDrivers = vm.filteredDrivers.concat(result);
                }

                vm.isLoading = false;
                page++;
                vm.filterMessage = createFilterMessage();
            }, (error) => {
                vm.isLoading = false;
            });

        };

        function createFilterMessage() {
            let message = '';

            vm.filterCount = 0;

            if (vm.filters.searchInput && vm.filters.searchInput.length > 0) {
                vm.filterCount++;
                message += '<i><b>Keyword</b>: ';
                message += vm.filters.searchInput.map((input) => { return input['text']; });
                message += '</i>&nbsp;&nbsp;';
            }

            if (vm.locations.length > 1 && vm.filters.filterByLocations && vm.filters.filterByLocations.length > 0) {
                let tempLocs = [];

                vm.filterCount++;
                _.forEach(vm.filters.filterByLocations, (locationId) => {
                    tempLocs.push(_.find(vm.locations, (location) => { return location.id === locationId; }));
                });
                message += '<i><b>Location</b>: ';
                message += tempLocs.map((location) => { return location['name']; });
                message += '</i>&nbsp;&nbsp;';
            }

            if (vm.filters.hasPhoto !== '') {
                vm.filterCount++;
                message += '<i>' + (vm.filters.hasPhoto === 'true' ? 'with photos' : 'without photos') + '</i>';
            }

            if (vm.filters.activeStatus !== 'all') {
                vm.filterCount++;
                message += '<i><b> ' + (vm.filters.activeStatus === 'true' ? 'active drivers' : 'inactive drivers') + '</b></i>';
            }

            if (message.length > 0)
                message = 'Showing results for ' + message;

            return message;
        }

        vm.driverTokenChanged = function () {
            rcLocalStorageService.set(savedFilterKey, vm.filters);
            refreshSearch();
        };

        driverService.subscribeChanged($scope, () => {
            refreshSearch();
        });

        vm.toggleShowSearchOptions = function () {
            vm.filtersBeforeAdvancedSearch  = _.cloneDeep(vm.filters);

            if (vm.showAdvancedSearch) {
                vm.searchDrivers();
            }

            vm.showAdvancedSearch  = !vm.showAdvancedSearch;
        };

        vm.applyBtnClicked = function () {
            vm.filtersBeforeAdvancedSearch = null;
            vm.showAdvancedSearch = false;
            vm.searchDrivers();
        };

        vm.close = function () {
            // set the filters back because they didn't apply them.
            vm.filters = vm.filtersBeforeAdvancedSearch;
            vm.showAdvancedSearch = false;
        };

        function init() {
            vm.filters = _.extend({}, initialFilters, existingFilters);
            vm.sort = _.extend({}, initialSort, existingSort);
        }

        init();

    }

})();

(function () {
    'use strict';

    DriverEditController.$inject = ["$state", "$scope", "resolvedDriver"];
    angular
        .module('redcap.driver')
        .controller('DriverEditController', DriverEditController);

    function DriverEditController($state, $scope, resolvedDriver) {
        var vm = this;
        vm.tabs = '';

        vm.currentDriver = resolvedDriver;

        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });

        vm.initTabContainers = function () {

            vm.tabs = [{
                title: 'General',
                route: 'driver-tab-general',
                active: false
            },
            {
                title: 'Security',
                route: 'driver-tab-security',
                active: false
            },
            {
                title: 'Permissions',
                route: 'driver-tab-certifications',
                active: false
            },
            {
                title: 'Locations',
                route: 'driver-tab-locations',
                active: false
            },
            {
                title: 'Settings',
                route: 'driver-tab-settings',
                active: false
            }];

            vm.tabs.forEach(function (tab) {
                tab.active = $state.name === tab.route;
            });
        };

        vm.initTabContainers();

    }
})();

(function () {
    'use strict';

    DriverAddController.$inject = ["$q", "$scope", "$state", "$timeout", "$filter", "toastr", "webworkerService", "modalService", "resolvedCompanyList", "appointmentUtilService", "driverService", "locationService", "resolvedLocationList", "fileReaderService", "permissions", "SYSTEM_ENUMS"];
    angular
        .module('redcap.driver')
        .controller('DriverAddController', DriverAddController);

    function DriverAddController($q, $scope, $state, $timeout, $filter, toastr, webworkerService, modalService, resolvedCompanyList, 
        appointmentUtilService, driverService, locationService, resolvedLocationList, fileReaderService, permissions, SYSTEM_ENUMS) {
        var vm = this,
            displayLimit = 25;
        
        vm.certifications = [];
        vm.companyTypes = SYSTEM_ENUMS.driverCompanyType;
        vm.companies = resolvedCompanyList;
        vm.driverAddMode = '1';
        vm.showDriverImport = permissions.isSysAdmin() || permissions.isRedCapAdmin();
        vm.isOnlyDealerAdmin = permissions.isOnlyDealerAdmin();
        vm.forceDisplayLocationSelection = false;
        vm.hasSelectedCertification = false;  

        _.forEach(resolvedLocationList, function (location) {
            location.locationHtml = locationService.getLocationHTML(location, true);
        });

        vm.locations = resolvedLocationList;
        vm.validation = {
            phoneNumberRequired: function (number) {
                return appointmentUtilService.validatePhoneNumber(number);
            }
        };
        
        vm.companySelected = function() {
            updateCertificationList();
        };

        vm.hasSelectedCertification = function() {  
            return vm.certifications.some(function(certification) {  
                return certification.isSelected;  
            });  
        };          

        vm.showCertifications = function() {          
            return vm.companyId && (!vm.isInternalCompany() || vm.homeDealer);
        };

        vm.locationsFilter = function (locationName) {
            if (locationName.length >= 1) {
                webworkerService.filter(resolvedLocationList, locationName, false, 'locationHtml')
                    .then(function (result) {
                        vm.locations = result;
                        vm.locationDisplayLimit = result.length;
                    });
            } else {
                vm.locationDisplayLimit = displayLimit;
            }
        };

        vm.locationSelected = function (item, model) {
            vm.homeDealer = item.id;
            updateCertificationList();
        };

        vm.createDriver = function () {
            var newDriver = {
                password: vm.password,
                firstName: vm.firstName,
                lastName: vm.lastName,
                userName: vm.userName,
                email: vm.emailAddress,
                sendWelcomeEmail: vm.sendWelcomeEmail,
                homeDealer: vm.homeDealer,
                suppressPay: vm.suppressPay,
                mobilePhone: vm.mobilePhone,
                companyId: vm.companyId,
                isDedicated: vm.isDedicated,
                isDnsVetted: vm.isDnsVetted
            };

            var selectedCerts = _.filter(vm.certifications, function (cert) { return cert.isSelected; });  

            var selectedIds = _.map(selectedCerts, function(cert) { return cert.id; });
            newDriver.certifications = selectedIds;
            newDriver.isNetworkDriver = vm.isNetworkDriver();
            driverService.addDriver(newDriver).then(function (response) {
                toastr.success('New Driver Successfully Added. Redirecting in 2 seconds...');
                // close panel
                $scope.$dismiss();

                vm.resetFields();

                $timeout(function () {
                    $state.go('driver-tab-general', { driverId: response, driverAdded: true });
                }, 2000);
            }, function (errorResponse) {
                // Showing the error is already happening via the api service
            });
        };

        vm.resetFields = function () {
            vm.fieldsDisabled = true;
            vm.userName = '';
            vm.password = '';
            vm.passwordConfirm = '';
            vm.firstName = ''; 
            vm.lastName = '';
            vm.mobilePhone = '';
            vm.sendWelcomeEmail = false;
            vm.homeDealer = null;
            vm.locationDisplayLimit = displayLimit;
            vm.emailAddress = '';
            vm.isDedicated = false;
            vm.isDnsVetted = false;
        };

        vm.driverIdRemoteValidation = function () {
            var deferred = $q.defer(),
                remoteCheck = function () {
                    driverService.driverUserNameIsValid(vm.userName).then(function (response) {
                        vm.fieldsDisabled = !response.isValid;
                        deferred.resolve(response);
                    });
                };

            if (vm.isInternalCompany()) {
                // first check if it's a valid phone number 
                var isValidPhoneNumber = appointmentUtilService.validatePhoneNumber(vm.userName);
                if (isValidPhoneNumber.isValid === false) {

                    deferred.resolve(isValidPhoneNumber);
                } else {
                    remoteCheck();
                }
            } else {
                remoteCheck();
            }

            

            return deferred.promise;
        };
        
        vm.chooseImportFile = function(file) {
            vm.bulkImport = {};
            var reader = new FileReader();
            vm.readingFile = true;
            reader.readAsDataURL(file);

            reader.onload = function() {
                vm.readingFile = false;

                vm.bulkImport = {
                    file: file,
                    base64FileData: reader.result,
                    fileName: file.name
                };                
            };
        };

        vm.importDrivers = function() {
            var confirm = modalService.showYesNo('Please Confirm', 'You are about to import all records in the import file into the system, are you sure you want to proceed?', 'No', 'Yes');
            confirm.then(function (confirmed) {
                if (confirmed) {
                    vm.importCompleted = false;
                    vm.isLoadingData = true;

                    driverService.bulkImportDrivers(vm.bulkImport.base64FileData).then(function(uploadResults) {   
                        vm.importCompleted = true;
                                       
                        var csvFile = uploadResults;
                        var filename = 'driver_upload_completed.csv';
                        fileReaderService.saveToDisk(csvFile, filename);
                    }).catch(function(err) { 
                        console.error(err);
                    }).finally(function() {
                        vm.isLoadingData = false;
                        vm.bulkImport = {};
                    });
                }
            });           
        };

        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });

        vm.isNetworkDriver = function() {
            return driverService.isNetworkDriver(vm.companies, vm.companyId, true);
        };

        vm.resetFields();

        vm.intrnalCompanyId = $filter('filter')(vm.companies, { type: vm.companyTypes.internal }, true)[0].id;

        if (vm.isOnlyDealerAdmin) {
            vm.companyId = vm.transportationType = $filter('filter')(vm.companies, { type: vm.companyTypes.internal }, true)[0].id;
            vm.isDedicated = true;
        }

        
        vm.isInternalCompany = function () { 
            return vm.companyId === vm.intrnalCompanyId;
        };

        // determine if we need to display the home location drop down 
        // or just set to the only dealer for Dealer Admins.
        if (vm.isOnlyDealerAdmin === true && vm.locations.length > 1) {
            vm.forceDisplayLocationSelection = true;
        } else if (vm.isOnlyDealerAdmin === true && vm.locations.length === 1) {
            vm.selectedLocation = vm.locations[0];
            vm.locationSelected(vm.selectedLocation);
        }

        function updateCertificationList() {
            vm.loadingCertifications = true;
            var getCerts = null;

            if (vm.isInternalCompany()) {
                if (vm.homeDealer) {
                    getCerts = driverService.getCertifications(null, vm.homeDealer);
                }
            } else {
                getCerts = driverService.getCertifications();
            }

            if (getCerts) {
                getCerts.then(function(certifications) {
                    vm.certifications = certifications;
                    vm.loadingCertifications = false;
                });
            }            
        }
    }
})();

(function () {
    'use strict';

    angular.module('redcap.enrollment', []);
})();


(function () {
    'use strict';

    functions.$inject = ["$log", "$q", "enrollmentService", "userService"];
    angular
        .module('redcap.enrollment')
        .factory('enrollmentValidationService', functions);

    function functions($log, $q, enrollmentService, userService) {

        return {
            validateDealerName: validateDealerName,
            validateDealerAddress: validateDealerAddress,
            validateUserName: validateUserName,
            validatePassword: validatePassword,
            validateDriver: validateDriver,
            validateEnrollment: validateEnrollment,
            validateEnrollmentCode: validateEnrollmentCode
        };

        function validateDealerName(name) {
            return enrollmentService.hasDuplicateName(name);
        }

        function validateDealerAddress(location) {
            var address = location.address,
                city = location.city,
                state = location.state,
                zip = location.zip;
            return enrollmentService.hasDuplicateAddress(address, city, state, zip);
        }

        function validateUserName(name) {
            return enrollmentService.hasDuplicateUser(name);
        }

        function validatePassword(password) {
            return userService.checkPassword(password);
        }

        function validateDriver(mobilePhone) {
            return enrollmentService.driverUserNameIsValid(mobilePhone);
        }

        function validateEnrollment(dealerName, oemDealerId) {
            return enrollmentService.hasDuplicateEnrollment(dealerName, oemDealerId);
        }

        function validateEnrollmentCode(oemDealerId) {
            return enrollmentService.hasGoodCode(oemDealerId);
        }
    }
})();

(function () {
    'use strict';

    enrollmentService.$inject = ["$q", "$log", "$http", "$rootScope", "$location", "localStorageService", "rcApi"];
    angular
        .module('redcap.enrollment')
        .factory('enrollmentService', enrollmentService);

    function enrollmentService($q, $log, $http, $rootScope, $location, localStorageService, rcApi) {

        var ENROLLMENT_BASEPATH = 'dealerEnrollment/';

        return {
            hasKey: hasKey,
            checkEnrollmentCode: checkEnrollmentCode,
            getConfigValues: getConfigValues,
            getTwilioNumbers: getTwilioNumbers,
            completeEnrollment: completeEnrollment,
            contractDetails: contractDetails,
            signContract: signContract,

            // validation
            hasDuplicateEnrollment: hasDuplicateEnrollment,
            hasDuplicateName: hasDuplicateName,
            hasDuplicateAddress: hasDuplicateAddress,
            hasDuplicateUser: hasDuplicateUser,
            driverUserNameIsValid: driverUserNameIsValid,
            hasGoodCode: hasGoodCode,
            isInRedCapArea: isInRedCapArea,
            getTimezone: getTimezone,

            // admin pieces
            getCode: getCode,
            updateCodes: updateCodes,
            addCodes: addCodes,
            deleteCodes: deleteCodes,
            resendInvites: resendInvites,
            getConfigs: getConfigs,
            getPrograms: getPrograms,

            getSsoDealer: getSsoDealer,
            editSsoDealer: editSsoDealer,
            createSsoDealer: createSsoDealer,
            getUberUpdateMessage: getUberUpdateMessage,
            getDistanceFromLatLonInKm: getDistanceFromLatLonInKm
        };

        function hasKey(guid) {
            var deferred = $q.defer();

            var savedKey = getKey();

            if (savedKey) {
                isValidKey(guid, savedKey).then (function (result) {
                    deferred.resolve(result);
                });
            } else
                deferred.reject(false);

            return deferred.promise;
        }

        function checkEnrollmentCode(configId, model) {
            var deferred = $q.defer();
            var path = configId + '/login';

            rcApi.post(ENROLLMENT_BASEPATH + path, model)
                .then(function (result) {
                    if (result.success) {
                        localStorageService.set('enrollmentKey', result.key);
                        $log.debug('enrollment-service: checkEnrollmentCode() - getting authorization key');
                    }

                    deferred.resolve(result);
                });
            return deferred.promise;
        }

        function getConfigValues(id) {
            return rcApi.get(ENROLLMENT_BASEPATH + id);
        }

        function getTimezone(lat, lng) {
            var deferred = $q.defer();
            rcApi.get(ENROLLMENT_BASEPATH + 'timezone', { lat: lat, lng: lng })
                    .then(function (result) {
                        deferred.resolve(result.timeZoneId);
                    });

            return deferred.promise;
        }

        function hasDuplicateEnrollment(dealerName, oemDealerId) {
            return rcApi.get(ENROLLMENT_BASEPATH + 'code/hasEnrollmentDuplicate', { dealerName: dealerName, oemDealerId: oemDealerId });
        }

        function hasDuplicateName(dealerName) {
            var savedKey = localStorageService.get('enrollmentKey');

            return rcApi.get(ENROLLMENT_BASEPATH + 'hasNameDuplicate',
                {
                    dealerName: dealerName,
                    key: savedKey
                }
            );
        }

        function hasDuplicateAddress(address, city, state, zip) {
            var savedKey = localStorageService.get('enrollmentKey');

            var model = {
                key: savedKey
            };
            if (address) model.address = address;
            if (city) model.city = city;
            if (state) model.state = state;
            if (zip) model.zip = zip;

            return rcApi.get(ENROLLMENT_BASEPATH + 'hasAddressDuplicate', model);
        }

        function hasDuplicateUser(userName) {
            var savedKey = localStorageService.get('enrollmentKey');

            return rcApi.get(ENROLLMENT_BASEPATH + 'hasUsernameDuplicate',
                {
                    userName: userName,
                    key: savedKey
                }
            );
        }

        function driverUserNameIsValid(driverId) {
            var savedKey = localStorageService.get('enrollmentKey');

            return rcApi.get(ENROLLMENT_BASEPATH + 'driverUserNameIsValid',
                {
                    driverId: driverId,
                    key: savedKey
                }
            );
        }

        function hasGoodCode(oemDealerId) {
            return rcApi.get(ENROLLMENT_BASEPATH + oemDealerId + '/validate');
        }

        function isInRedCapArea(lat, lng) {
            var savedKey = localStorageService.get('enrollmentKey');
            return rcApi.get(ENROLLMENT_BASEPATH + 'isInRedCapArea',
                {
                    lat: lat,
                    lng: lng,
                    key: savedKey
                }
            );
        }

        function getTwilioNumbers(lat, lng) {
            return rcApi.get('twilio', { lat: lat, lng: lng });
        }

        function completeEnrollment(guid, model) {
            return rcApi.post(ENROLLMENT_BASEPATH + guid + '?key=' + getKey(), model);
        }

        function contractDetails(guid) {
            return rcApi.get(ENROLLMENT_BASEPATH + 'contract/' + guid);
        }

        function signContract(guid, model) {
            return rcApi.put(ENROLLMENT_BASEPATH + 'contract/' + guid, model);
        }

        function getCode(code) {
            return rcApi.get(ENROLLMENT_BASEPATH + 'code/' + (code || ''));
        }

        function updateCodes(codeList) {
            return rcApi.put(ENROLLMENT_BASEPATH + 'code', codeList)
                        .then(function(result) {
                            $rootScope.$broadcast('EnrollmentService.changed', result);
                            return result;
                        });
        }

        function addCodes(codeList) {
            return rcApi.post(ENROLLMENT_BASEPATH + 'code', codeList)
                        .then(function(result) {
                            $rootScope.$broadcast('EnrollmentService.changed', result);
                            return result;
                        });

        }

        function deleteCodes(codeList) {
            return rcApi.remove(ENROLLMENT_BASEPATH + 'code', codeList)
                        .then(function(result) {
                            $rootScope.$broadcast('EnrollmentService.changed', result);
                            return result;
                        });
        }

        function resendInvites(codeList) {
            return rcApi.post(ENROLLMENT_BASEPATH + 'code/sendInvite', codeList);
        }

        function getConfigs() {
            return rcApi.get(ENROLLMENT_BASEPATH + 'configs');
        }

        function getPrograms() {
            return rcApi.get(ENROLLMENT_BASEPATH + 'program');
        }

        function getSsoDealer(partnerDealerId) {
            return rcApi.get(ENROLLMENT_BASEPATH + 'sso/' + partnerDealerId);
        }

        function editSsoDealer(partnerDealerId, dealer) {
            return rcApi.put(ENROLLMENT_BASEPATH + 'sso/' + partnerDealerId, dealer);
        }

        function createSsoDealer(dealer) {
            return rcApi.post(ENROLLMENT_BASEPATH + 'sso', dealer);
        }

        function getUberUpdateMessage() {
            return rcApi.get(ENROLLMENT_BASEPATH + 'sso/uberUpdateMessage');
	}

        function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            var R = 6371,   // Radius of the earth in km
                dLat = deg2rad(lat2-lat1),  // deg2rad below
                dLon = deg2rad(lon2-lon1),
                a =
                    Math.sin(dLat/2) * Math.sin(dLat/2) +
                    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                    Math.sin(dLon/2) * Math.sin(dLon/2),
                c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)),
                d = R * c;  // Distance in km

            return d;
        }

        // private
        function deg2rad(deg) {
            return deg * (Math.PI/180);
        }

        function getKey() {
            var savedKey = localStorageService.get('enrollmentKey');
            $log.debug('enrollment-service: getKey() - returning key');
            return savedKey;
        }

        function isValidKey(configId, key) {
            $log.debug('enrollment-service: isValidKey() - validating key');
            return rcApi.post(ENROLLMENT_BASEPATH + configId + '/keyValidation', {
                code: key
            });
        }
    }

})();

(function () {
    'use strict';

        modalMessage.$inject = ["$log", "$uibModal"];
    angular
        .module('redcap.enrollment')
        .directive('modalMessage', modalMessage);

        function modalMessage($log, $uibModal) {
            var scope, vm;    
            
            return {
                restrict: 'E',
                priority: 1,
                scope: {
                    show: '=',
                    finished: '=',
                    configId: '=',
                    guid: '=',
                    messageHeader: '=',
                    messageBody: '=?',
                    messageFooter: '=?'
                },
                link: function (scope, elem, attrs) {
                    
                    function createTemplate() {
                        var templateHtml = '';

                        templateHtml += 
                                '    <div class="modal-body text-center padding-xl">';

                        if (!scope.finished)
                            templateHtml += '<img src="assets/images/loading.gif" />';
                        else 
                            templateHtml += '<span class="fa fa-check fa-3x"></span>';

                        templateHtml += '<h2 class="modal-title">' + scope.messageHeader + '</h2>';

                        if (!_.isNil(scope.messageBody))
                            templateHtml += 
                                '    <h4>' +
                                        scope.messageBody +  
                                '    </h4></div>';
                        
                        if (!_.isNil(scope.messageFooter))
                            templateHtml += 
                                '   <div class="modal-footer" style="text-align:center">' + scope.messageFooter + '</div>';

                        return templateHtml;
                    }

                    var show = function(templateMessage) {
                        var loadingModal = $uibModal.open({
                            contollerAs: 'vm',
                            controller: ["$scope", "$uibModalInstance", "$state", function ($scope, $uibModalInstance, $state) {
                                $scope.close = function() { 
                                    $state.go('enrollment-welcome', { configId: scope.configId, guid: scope.guid });
                                    $uibModalInstance.dismiss();
                                 };

                                scope.$watch('show', function(loading) {
                                    if(!loading && !_.isNil(loading))
                                        $uibModalInstance.dismiss();
                                });
                            }],
                            backdrop: 'static',
                            keyboard: false,
                            template: templateMessage
                                        
                        });
                    };

                    // add watch!
                    scope.$watch('show', function(loading) {
                        if(loading && !_.isNil(loading))
                            show(createTemplate());
                    });
                }
            };

        }

})();
(function () {
    'use strict';

    SSOEnrollmentController.$inject = ["$log", "$scope", "$state", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "resolvedDealer", "resolvedConfigId", "locationService", "enrollmentService", "mapObjectFactory"];
    angular
        .module('redcap.enrollment')
        .controller('SSOEnrollmentController', SSOEnrollmentController);

    function SSOEnrollmentController($log, $scope, $state, SYSTEM_ENUMS, HERE_MAPS_CONFIG, resolvedDealer, resolvedConfigId, locationService, enrollmentService, mapObjectFactory) {
        var vm = this, 
            venueMarker, 
            dealerOrigLatLng = {
                lat: resolvedDealer.lat,
                lng: resolvedDealer.lng
            },
            circleExists = false,
            pinRadius = 150,
            perimeterStyle = HERE_MAPS_CONFIG.perimeterStyle,
            circlePreviousStateGood = null;

        vm.dealer = resolvedDealer;
        vm.markers = [];
        vm.isProcessing = true;
        vm.showMapCover = true;

        vm.mapOptions = {
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            showControls: true,
            draggable: true,
            resize: true,
            coords: {
                latitude: vm.dealer.lat,
                longitude: vm.dealer.lng
            }
        };

        vm.placesOptions = {
            watchEnter: true,
            country: 'us',
            startLat: dealerOrigLatLng.lat,
            startLng: dealerOrigLatLng.lng
        };

        // These are required in order for the map to be interactive.
        vm.mapListeners = {
            drag: function () {

            },
            resize: function () {

            }
        };

        vm.onMapReady = function (hereMap) {
            vm.hereMap = hereMap;
            vm.hereMap && vm.hereMap.setMapStyle(HERE_MAPS_CONFIG.satelliteViewSettings);
            vm.hereMap.setZoom(19);

            $scope.$on('resizeHereMap', function () {
                if (vm.hereMap)
                    vm.hereMap.refresh();
            });
        };

        vm.createDealer = function () {
            if (vm.isProcessing) return;

            vm.isProcessing = true;
            var coordinate = vm.hereMap.getMarkers()[0].getGeometry();
            vm.dealer.lat = coordinate.lat;
            vm.dealer.lng = coordinate.lng;

            locationService.getTimezone(vm.dealer.lat, vm.dealer.lng)
                    .then(function (timezoneDetail) {
                        var postObj = {
                            dealer      : vm.dealer,
                            timezoneId  : timezoneDetail.timeZoneId
                        };

                        enrollmentService.createSsoDealer(postObj)
                                 .then(function (result) {
                                    // post message back to parent
                                    window.parent.postMessage(result, '*');

                                    // send user to enrollment Ok page
                                    $state.go('enrollment-sso-ok', { configId: resolvedConfigId, partnerDealerId: vm.dealer.id });
                                 }, function (error) {
                                    if (error.status === 404) {
                                        alert(error.message);
                                        vm.isProcessing = false;
                                    }
                                    if (error.status === 409) {
                                        alert("This location has already been enrolled.");
                                        vm.isProcessing = false;
                                    }
                                    else
                                        $state.go('enrollment-sso-ok', { configId: resolvedConfigId, errorId: 4 });
                                 });
                    }, function () {
                        // do nothing
                    }, function () {
                        vm.isProcessing = false;
                    });
        };

        vm.placeUpdated = function(formattedAddress) {
            if (formattedAddress) {
                dealerOrigLatLng.lat = formattedAddress.location.lat;
                dealerOrigLatLng.lng = formattedAddress.location.lng;

                vm.dealer.streetAddress     = formattedAddress.location.streetAddress;
                vm.dealer.city              = formattedAddress.location.city;
                vm.dealer.state             = formattedAddress.location.state;
                vm.dealer.zip               = formattedAddress.location.zip;
                vm.dealer.lat               = formattedAddress.location.lat;
                vm.dealer.lng               = formattedAddress.location.lng;

                var pinOptions = {
                    hidePopup: true,
                    draggable: false,
                    useImagesInPin: true
                };

                vm.markers = [];
                venueMarker = mapObjectFactory.createHereMarker(vm.dealer.lat, vm.dealer.lng, SYSTEM_ENUMS.destinationType.enrollPodGood, null, pinOptions);
                vm.markers.push(venueMarker);
                vm.hereMap.updateMarkers(vm.markers, true);

                vm.hereMap.getMap().addEventListener('drag', function () {
                    var coordinate = vm.hereMap.getCenter(),
                        distance = enrollmentService.getDistanceFromLatLonInKm(dealerOrigLatLng.lat, dealerOrigLatLng.lng, coordinate.lat, coordinate.lng),
                        circleStateGood = distance < pinRadius / 1000;

                    if (circleStateGood !== circlePreviousStateGood) {
                        vm.hereMap.removeCircle();

                        if (circleStateGood) {
                            vm.hereMap.addCircle(dealerOrigLatLng.lat, dealerOrigLatLng.lng, pinRadius, perimeterStyle.circleStyleGood);
                        } else {
                            vm.hereMap.addCircle(dealerOrigLatLng.lat, dealerOrigLatLng.lng, pinRadius, perimeterStyle.circleStyleBad);
                        }

                        circlePreviousStateGood = circleStateGood;
                    }

                    vm.dealer.lat = coordinate.lat;
                    vm.dealer.lng = coordinate.lng;

                    vm.hereMap.getMarkers()[0].setGeometry({ lat: vm.dealer.lat, lng: vm.dealer.lng });
                });

                vm.hereMap.getMap().addEventListener('dragend', function () {
                    var coordinate = vm.hereMap.getCenter(),
                        distance = enrollmentService.getDistanceFromLatLonInKm(dealerOrigLatLng.lat, dealerOrigLatLng.lng, coordinate.lat, coordinate.lng);
                        
                    vm.showDistanceWarning = distance > pinRadius / 1000;
                    vm.showDistanceOk = !vm.showDistanceWarning;

                    vm.isProcessing = false;
                });

                if (circleExists)
                    vm.hereMap.removeCircle();

                vm.hereMap.addCircle(dealerOrigLatLng.lat, dealerOrigLatLng.lng, pinRadius, perimeterStyle.circleStyle);
                circleExists = true;
                circlePreviousStateGood = null;
                vm.hereMap.setZoom(19);

                vm.showMapCover = false;
            }
        };
    }
})();

(function () {
    'use strict';

    SSOEnrollmentProvisionedController.$inject = ["resolvedAllowedStartTime", "$scope", "$interval"];
    angular
        .module('redcap.enrollment')
        .controller('SSOEnrollmentProvisionedController', SSOEnrollmentProvisionedController);

    function SSOEnrollmentProvisionedController(resolvedAllowedStartTime, $scope, $interval) {
        var vm = this;

        var currentTimeUTC = moment.utc().toDate().toUTCString();
        var duration = moment.duration(resolvedAllowedStartTime.diff(currentTimeUTC));
        var minutes = duration.asMinutes();

        var timeInterval = $interval(function (){

            currentTimeUTC = moment.utc().toDate().toUTCString();
            duration = moment.duration(resolvedAllowedStartTime.diff(currentTimeUTC));
            minutes = duration.asMinutes();

            if (duration > 0)
                vm.allowedStartTime = Math.floor(minutes);
            else 
                vm.stop();
        }, 1000);
        
        vm.stop = function (){
            if (angular.isDefined(timeInterval)) {
                $interval.cancel(timeInterval);
                timeInterval = undefined;
            }
        };

        $scope.$on('$destroy', function() {
            vm.stop();
        });
    }
})();

(function () {
    'use strict';

    SSOEnrollmentOkController.$inject = ["resolvedError", "resolvedPartnerDealerId", "resolvedUberUpdateMessage"];
    angular
        .module('redcap.enrollment')
        .controller('SSOEnrollmentOkController', SSOEnrollmentOkController);

    function SSOEnrollmentOkController(resolvedError, resolvedPartnerDealerId, resolvedUberUpdateMessage) {
        var vm = this;
            vm.partnerDealerId = resolvedPartnerDealerId;

        var errors = {
            dealerNotEnrolled: 1,
            multiDealersNotEnrolled: 2,
            noDealerObj: 3,
            unknownError: 4,
            authenticationError: 5
        };

        switch (resolvedError) {
            case errors.dealerNotEnrolled:
                vm.title = 'Something Went Wrong';
                vm.content = 'Your dealership does not appear to be enrolled.  Please enroll through your Delivery Setup.';
                break;
            case errors.multiDealersNotEnrolled:
                vm.title = 'Something Went Wrong';
                vm.content = 'Your dealership does not appear to be enrolled.  Please enroll through your Delivery Setup.';
                break;
            case errors.noDealerObj:
                vm.title = 'Oops... Something went wrong.';
                vm.content = 'Expected dealer values were not provided for enrollment. ';
                break;
            case errors.unknownError:
                vm.title = 'An unknown error has occurred.';
                vm.content = 'Please retry the previous action.';
                break;
            case errors.authenticationError:
                vm.title = 'Oops... Something went wrong.';
                vm.content = 'Please retry the previous action.';
                break;
            default:
                vm.title = 'Dealer enrollment complete';
                vm.content = 'Your Delivery Subscription Request has been sent. When the process is completed you will receive a visual notification on your screen and the delivery icon will appear near the bottom of your RepairLink Order Detail Screen';
                vm.content2 = resolvedUberUpdateMessage;
                break;
        }
    }
})();

(function () {
    'use strict';

    SSOEnrollmentEditController.$inject = ["$log", "$scope", "$state", "SYSTEM_ENUMS", "HERE_MAPS_CONFIG", "resolvedPartnerDealer", "enrollmentService", "mapObjectFactory"];
    angular
        .module('redcap.enrollment')
        .controller('SSOEnrollmentEditController', SSOEnrollmentEditController);

    function SSOEnrollmentEditController($log, $scope, $state, SYSTEM_ENUMS, HERE_MAPS_CONFIG, resolvedPartnerDealer, enrollmentService, mapObjectFactory) {
        var vm = this, 
            venueMarker, 
            dealerOrigLatLng = {
                lat: resolvedPartnerDealer.location.lat,
                lng: resolvedPartnerDealer.location.lng
            },
            circleExists = false,
            pinRadius = 150,
            perimeterStyle = HERE_MAPS_CONFIG.perimeterStyle,
            circlePreviousStateGood = null;

        vm.dealer = { name: resolvedPartnerDealer.name, lat: resolvedPartnerDealer.location.lat, lng: resolvedPartnerDealer.location.lng };
        vm.markers = [];
        vm.isProcessing = true;
        vm.showMapCover = true;

        vm.mapOptions = {
            defaultMapMode: HERE_MAPS_CONFIG.mapModes.overview,
            showControls: true,
            draggable: true,
            resize: true,
            coords: {
                latitude: vm.dealer.lat,
                longitude: vm.dealer.lng
            }
        };

        // These are required in order for the map to be interactive.
        vm.mapListeners = {
            drag: function () {

            },
            resize: function () {

            }
        };

        vm.placesOptions = {
            watchEnter: true,
            country: 'us',
            startLat: dealerOrigLatLng.lat,
            startLng: dealerOrigLatLng.lng
        };

        vm.onMapReady = function (hereMap) {
            vm.hereMap = hereMap;
            vm.hereMap && vm.hereMap.setMapStyle(HERE_MAPS_CONFIG.satelliteViewSettings);
            vm.hereMap.setZoom(19);

            $scope.$on('resizeHereMap', function () {
                if (vm.hereMap)
                    vm.hereMap.refresh();
            });
        };

        vm.createDealer = function () {
            vm.isProcessing = true;
            enrollmentService.editSsoDealer(resolvedPartnerDealer.oemDealerId, vm.dealer)
                             .then(function (result) {
                                // post message back to parent
                                window.parent.postMessage(result, '*');

                                // send user to enrollment Ok page
                                $state.go('enrollment-sso-ok', { configId: resolvedPartnerDealer.adminConfigId, partnerDealerId: resolvedPartnerDealer.oemDealerId });
                             }, function (error) {
                                $state.go('enrollment-sso-ok', { configId: resolvedPartnerDealer.adminConfigId, errorId: 4 });
                             });
        };

        vm.placeUpdated = function(formattedAddress) {
            if (formattedAddress) {
                dealerOrigLatLng.lat = formattedAddress.location.lat;
                dealerOrigLatLng.lng = formattedAddress.location.lng;

                vm.dealer.streetAddress     = formattedAddress.location.streetAddress;
                vm.dealer.city              = formattedAddress.location.city;
                vm.dealer.state             = formattedAddress.location.state;
                vm.dealer.zip               = formattedAddress.location.zip;
                vm.dealer.lat               = formattedAddress.location.lat;
                vm.dealer.lng               = formattedAddress.location.lng;

                var pinOptions = {
                    hidePopup: true,
                    draggable: false,
                    useImagesInPin: true
                };

                vm.markers = [];
                venueMarker = mapObjectFactory.createHereMarker(vm.dealer.lat, vm.dealer.lng, SYSTEM_ENUMS.destinationType.enrollPodGood, null, pinOptions);
                vm.markers.push(venueMarker);
                vm.hereMap.updateMarkers(vm.markers, true);

                vm.hereMap.getMap().addEventListener('drag', function () {
                    var coordinate = vm.hereMap.getCenter();
                    
                    var distance = enrollmentService.getDistanceFromLatLonInKm(dealerOrigLatLng.lat, dealerOrigLatLng.lng, coordinate.lat, coordinate.lng);
                    var circleStateGood = distance < pinRadius / 1000;

                    if (circleStateGood !== circlePreviousStateGood) {
                        vm.hereMap.removeCircle();

                        if (circleStateGood) {
                            vm.hereMap.addCircle(dealerOrigLatLng.lat, dealerOrigLatLng.lng, pinRadius, perimeterStyle.circleStyleGood);
                        } else {
                            vm.hereMap.addCircle(dealerOrigLatLng.lat, dealerOrigLatLng.lng, pinRadius, perimeterStyle.circleStyleBad);
                        }

                        circlePreviousStateGood = circleStateGood;
                    }

                    vm.dealer.lat = coordinate.lat;
                    vm.dealer.lng = coordinate.lng;

                    vm.hereMap.getMarkers()[0].setGeometry({ lat: vm.dealer.lat, lng: vm.dealer.lng });
                });

                vm.hereMap.getMap().addEventListener('dragend', function () {
                    var coordinate = vm.hereMap.getCenter();
                    
                    var distance = enrollmentService.getDistanceFromLatLonInKm(dealerOrigLatLng.lat, dealerOrigLatLng.lng, coordinate.lat, coordinate.lng);
                    vm.showDistanceWarning = distance > pinRadius / 1000;
                    vm.showDistanceOk = !vm.showDistanceWarning;

                    vm.isProcessing = false;
                });

                if (circleExists)
                    vm.hereMap.removeCircle();

                vm.hereMap.addCircle(dealerOrigLatLng.lat, dealerOrigLatLng.lng, pinRadius, perimeterStyle.circleStyle);
                circleExists = true;
                circlePreviousStateGood = null;
                vm.hereMap.setZoom(19);

                vm.showMapCover = false;
            }
        };
    }
})();

(function () {
    'use strict';

    EnrollmentController.$inject = ["$log", "$state", "$scope", "localStorageService"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentController', EnrollmentController);

    function EnrollmentController($log, $state, $scope, localStorageService) {
        var vm = this;

        vm.mobileNavCollapsed = true;
        vm.config = {};
    }
})();

(function () {
    'use strict';

    EnrollmentWizardController.$inject = ["$log", "$window", "$rootScope", "$scope", "$state", "$timeout", "$q", "$sce", "$filter", "inputMapper", "toastr", "enrollmentService", "enrollmentValidationService", "SYSTEM_ENUMS", "SYSTEM_VARIABLES", "USER_TITLES", "resolvedConfig", "NgMap"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentWizardController', EnrollmentWizardController);

    function EnrollmentWizardController($log, $window, $rootScope, $scope, $state, $timeout, $q, $sce, $filter, inputMapper, toastr, enrollmentService, enrollmentValidationService, SYSTEM_ENUMS, SYSTEM_VARIABLES, USER_TITLES, resolvedConfig, NgMap) {
        var vm = this;
        // see file enrollment-wizard-variables.
        angular.module('redcap.enrollment').enrollmentWizardControllerVariables(vm, SYSTEM_ENUMS, USER_TITLES, resolvedConfig);

        //*** Config Section *** //
        $scope.$parent.vm.config = resolvedConfig;
        vm.config = resolvedConfig;
        vm.systemVariables = SYSTEM_VARIABLES;
        vm.config.softwareLicenseContract = typeof resolvedConfig.softwareLicenseContract === 'object' ? resolvedConfig.softwareLicenseContract : $sce.trustAsHtml(resolvedConfig.softwareLicenseContract);
        vm.config.admDriverNetworkContract = typeof resolvedConfig.admDriverNetworkContract === 'object' ? resolvedConfig.admDriverNetworkContract : $sce.trustAsHtml(resolvedConfig.admDriverNetworkContract);
        vm.config.recruitingContract = typeof resolvedConfig.recruitingContract === 'object' ? resolvedConfig.recruitingContract : $sce.trustAsHtml(resolvedConfig.recruitingContract);
        vm.config.showDealerNetworkOptions = false;
        
        // add the steps required from configs
        var map = {};
        for (var t = 0, templatesLength = vm.templates.length; t < templatesLength; t++) {
            var template = vm.templates[t];
            for (var s = 0, stepsLength = resolvedConfig.enrollmentSteps.length; s < stepsLength; s++) {
                var step = resolvedConfig.enrollmentSteps[s];
                if (template.name == step.name || template.name === 'Sales Team' && step.name === 'Drivers') {
                    map[step.name] = step;
                    break;
                }
            }
        }
        vm.config.enrollmentSteps = map;
        
        $timeout(function() {
            if (vm.config.hideContract) {
                $rootScope.$broadcast('removeStep', 7);
                vm.validationTemplates.splice(7, 1);
                delete vm.agreementForm;
            }

            // test drive workflow specific changes
            if (vm.config.program === vm.programType.TEST_DRIVE) {
                if (vm.config.hideVehicles) {
                    for (var i = 0, length = vm.config.tripTypes.length; i < length; i++)
                        vm.form.tripTypes.push(vm.config.tripTypes[i].id);

                    $rootScope.$broadcast('removeStep', 5);
                    vm.validationTemplates.splice(5, 1);
                    delete vm.vehiclesForm;
                }

                vm.form.dealerDriverSystem = 0;
                vm.form.advisors = [];
                $rootScope.$broadcast('removeStep', 4);
                vm.validationTemplates.splice(4, 1);
                delete vm.advisorsForm;
            } else {
                $rootScope.$broadcast('removeStep', 5);
                vm.validationTemplates.splice(5, 1);
                delete vm.vehiclesForm;
            }
        }, 10);

        //*** End Config *** //

        // programmatically change step
        vm.goto = function(index) {
            $rootScope.$broadcast('gotoStep', index);
        };

        var maxIndex = 0;
        vm.stepChanging = function(event, currentIndex, newIndex) {
            // if going backward and current step == max step, allow to go back. They cannot go past max step.
            if (currentIndex == maxIndex && newIndex < currentIndex)
                return true;

            // if a http (remote validation) is occurring, wait and trigger the step change again.
            if ($scope.isDataLoading) {
                $timeout(function () {
                    $('.wizard').steps('next');
                }, 200);
                return false;
            }

            // validation for store location.
            if (currentIndex == 0) {
                if (_.isNil(vm.form.storeInformation.timeZoneId)) {
                    vm.cantContinueMessage = 'We are unable to serve your area at the moment. Please check your address and call us at the number below.';
                    return false;
                }
                    
                vm.contContinueMessage = null;

                // check if dealer in redcap network
                enrollmentService.isInRedCapArea(vm.form.storeInformation.location.lat, vm.form.storeInformation.location.lng)
                    .then(function (isTrue) {
                        if (isTrue) {
                            vm.form.dealerDriverSystem = vm.config.program === vm.programType.TEST_DRIVE || vm.config.suppressDriverOptions ? 0 : '';
                            vm.config.showDealerNetworkOptions = true;
                        } else {
                            vm.form.dealerDriverSystem = 0;
                        }
                    });
            }
                
            // split out the "vm." and remove it
            var listOk;
            var formName = vm.validationTemplates[currentIndex].form.split('.')[1];
                

            if (formName === 'driversForm' && vm.form.dealerDriverSystem === '') {
                vm.driver.missingMessage = 'A driver network must be selected.';
                return false;
            }

            // list forms validation
            if (formName === 'driversForm' || formName === 'advisorsForm' || formName === 'storeHoursForm') {
                listOk = validateListForm(formName);

                if (!listOk)
                    return false;    
            }
            
            if (formName === 'vehiclesForm') {
                listOk = validateListForm(formName);
                if (listOk) {
                    maxIndex = newIndex > maxIndex ? newIndex : maxIndex;   // increment if going to next page
                }
                return listOk;
            }
        
            // all other forms
            if (vm[formName].$invalid) {
                angular.forEach(vm[formName], function(value, key) {
                    if (typeof value === 'object' && value.hasOwnProperty('$modelValue')) {
                        angular.element('#' + value.$name).trigger('blur');
                    }
                });
            }

            // allow summary to passthrough
            if (typeof formName === 'undefined' || vm[formName].$valid) {
                $log.debug('Changing step from: ' + formName);
                maxIndex = newIndex > maxIndex ? newIndex : maxIndex;   // increment if going to next page
                return true;
            }
            
            return false;
        };

        vm.stepChanged = function(event, currentIndex, newIndex) { $timeout(vm.refreshStyles(vm.config.styleClass), 1); };

        vm.finishing = function(event, currentIndex) {
            // disable the finish button
            var button = $("#wizard").find('a[href="#finish"]'),
                i;
            button.attr("href", '#finish-disabled');
            button.parent().addClass("disabled");

            $scope.$apply(function() { vm.finish.show = true; });

            // delete ImgUpload so it isn't sent in the payload
            for (i = vm.form.advisors.length - 1; i >= 0; i--) {
                if (!_.isUndefined(vm.form.advisors[i].profileImgUpload)) 
                    delete vm.form.advisors[i].profileImgUpload;
            }
            for (i = vm.form.drivers.length - 1; i >= 0; i--) {
                if (!_.isUndefined(vm.form.drivers[i].profileImgUpload))
                    delete vm.form.drivers[i].profileImgUpload;
            }

            // delete the closed days from the store hours
            for (i = vm.form.storeHours.hours.length - 1; i >= 0; i--) {
                if (vm.form.storeHours.hours[i].closed)
                    vm.form.storeHours.hours.splice(i, 1);
            }

            // cc list
            vm.form.ccUsers = vm.formatCC();

            return true;
        };

        vm.finished = function () {
            $log.debug(vm.form);
            enrollmentService.completeEnrollment(vm.config.guid, vm.form)
                .then (function (result) {
                    vm.finish.show = false;
                    vm.inputForm.$setPristine(true);
                    $timeout(function() {
                        vm.finish = {
                            show: true,
                            isFinished: true,
                            messageHeader: 'Congratulations!',
                            messageBody: 'Your location has been setup. <br />Please check your inbox for details.',
                            messageFooter: 'You can close this window at any time.'
                        };
                    }, 500);
                }, function (errorMessage) {
                    toastr.error('We encountered an error in processing your request. Please double check and try again. If you receive this message again. Please call us at the number below.');
                    vm.finish.show = false;
                    // enable the finish button
                    var button = $("#wizard").find('a[href="#finish-disabled"]');
                    button.attr("href", '#finish');
                    button.parent().removeClass();
                });
        };

        // public functions used in advisor to CRUD the advisor list
        var advisorTemp = { firstName: '', lastName: '', officePhone: '', mobilePhone: '', emailAddress: '' };
        var driverTemp = { firstName: '', lastName: '', mobilePhone: '', emailAddress: ''};
        vm.advisor = {
            maxIndex: 2,
            add: function () {
                var advisor = angular.copy(advisorTemp);
                advisor.index = vm.advisor.maxIndex;
                vm.advisor.maxIndex++;

                vm.form.advisors.push(advisor);
                vm.advisor.missingMessage = '';
            },
            delete: function (advisor) {
                var index = vm.form.advisors.indexOf(advisor);
                vm.form.advisors.splice(index, 1);
            },
            missingMessage: ''
        };

        // functions used in advisor to CRUD the driver list
        vm.driver = {
            maxIndex: 2,
            add: function () {
                var driver = angular.copy(driverTemp);
                driver.index = vm.driver.maxIndex;
                vm.driver.maxIndex++;

                vm.form.drivers.push(driver);
                vm.driver.missingMessage = '';
            },
            delete: function (driver) {
                var index = vm.form.drivers.indexOf(driver);
                vm.form.drivers.splice(index, 1);
            },
            missingMessage: ''
        };

        vm.formatCC = function() {
            return inputMapper.mapFromTags(vm.emailCCListMap, ";");
        };

        vm.tripTypes = {
            change: function ($event, tripTypeId) {
                if ($event.target.checked) 
                    return vm.form.tripTypes.push(tripTypeId);
                
                if (vm.form.tripTypes.indexOf(tripTypeId) >= 0)
                    vm.form.tripTypes.splice(vm.form.tripTypes.indexOf(tripTypeId), 1);

            },
            contains: function (tripTypeId) {
                return vm.form.tripTypes.indexOf(tripTypeId) >= 0;
            }
        };

        // used to provide a readable text in summary
        vm.setTimeZone = function (value) {

            _.forEach(vm.systemEnums.timeZones, function(timeZone) {
                if (timeZone.value === value) vm.timeZone = timeZone;
            });

        };

        vm.showDmsSystem = function () {
            var dmsSystems = vm.systemEnums.dmsSystem;
            for (var i = 0, length = dmsSystems.length; i < length; i++) {
                if (vm.form.storeInformation.dmsSystem === dmsSystems[i].value)
                    return dmsSystems[i].text;
            }
        };

        vm.validation = {
            timeZones: _.map(vm.systemEnums.timeZones, 'value'),
            url: function (url) {
                if (url.indexOf('?') >= 0)
                    return { isValid: false, message: 'Please remove everything after "?"' };

                var regexp = /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
                
                return { isValid: regexp.test(url), message: 'Must be a valid url.' };
            },
            file: function (file) {
                $log.debug(file);
                return { isValid: !_.isNil(file), message: 'Image is required' };
            },
            phone: function (fieldValue) {
                fieldValue = fieldValue.replace(/\D/g,'');
                return { isValid: fieldValue.length === 10, message: 'Field is required.' };
            },
            dealerName: function () {
                return enrollmentValidationService.validateDealerName(vm.form.storeInformation.dealerName);
            },
            dealerAddress: function () {
                var deferred = $q.defer();

                $timeout(function() {
                    var location = {
                        address: vm.form.storeInformation.location.streetAddress,
                        city: vm.form.storeInformation.location.city,
                        state: vm.form.storeInformation.location.state,
                        zip: vm.form.storeInformation.location.zip
                    };

                    enrollmentValidationService.validateDealerAddress(location)
                        .then(function (result) {
                            deferred.resolve(result);
                        });
                }, 200);
                
                return deferred.promise;
            },
            dealerHours: function (fieldValue, startTime, endTime, isClosed) {            
                if (!isClosed) {
                    if (!fieldValue) {
                        return { isValid: false, message: 'Start time and end time is required.' };
                    }

                    if (startTime >= endTime) {
                        return { isValid: false, message: 'Open hours must be before closing hours.' };
                    }
                }

                return { isValid: true };
            },
            date: function (dateToValidate) {
                var date = new Date(dateToValidate);

                if (isNaN(date.getDate()))
                    return { isValid: !isNaN(date.getDate()), message: 'Invalid Date' };

                return { isValid: date > new Date(), message: 'Please enter a date in the future.'}; 
            },
            employeeTitle: function (value) {
                return { isValid: vm.titles.indexOf(value) >= 0, message: 'Employee Title is required.' };
            },
            username: function(obj, type) {
                var deferred = $q.defer();

                var found = false;
                if (type === 'advisor') {
                    if (vm.form.champion.emailAddress.toLowerCase() === obj.emailAddress.toLowerCase())
                        found = true;
                }

                _.forEach(vm.form.advisors, function (advisor) {
                    if (advisor.emailAddress.toLowerCase() === obj.emailAddress.toLowerCase() && advisor.$$hashKey !== obj.$$hashKey)
                        found = true;
                });

                if (found)
                    deferred.resolve({ isValid: false, message: 'Address already used.' });
                else
                    enrollmentValidationService.validateUserName(obj.emailAddress)
                        .then(function (result) {
                            deferred.resolve(result);
                        });
                
                return deferred.promise;
            },
            password: function(password) {
                return enrollmentValidationService.validatePassword(password);
            },
            driver: function(driver) {
                var driverText = vm.config.program === vm.programType.TEST_DRIVE ? 'Sales Team member' : 'driver';
                var dupValidation = {
                    isValid: false,
                    message: 'Please use a real and unique mobile number for each ' + driverText + ' as credentials and logins will be tied to this field.'
                };

                var deferred = $q.defer();

                var phoneValidation = vm.validation.phone(driver.mobilePhone);
                if (!phoneValidation.isValid)
                    deferred.resolve(phoneValidation);
                else {
                    var found = false;
                    _.forEach(vm.form.drivers, function (d) {
                        if (d.mobilePhone === driver.mobilePhone && d.$$hashKey !== driver.$$hashKey)
                            found = true;
                    });

                    if (found)
                        deferred.resolve(dupValidation);
                    else
                        enrollmentValidationService.validateDriver(driver.mobilePhone)
                            .then (function (result) {
                                if (result.isValid)
                                    deferred.resolve(result);
                                else    // this overrides the default text from the API so that "drivers" and "sales team" can be differentiated
                                    deferred.resolve(dupValidation);
                            });
                }

                return deferred.promise;
            },
            passwordConfirmation: function (password, confirmation) {
                return { isValid: password === confirmation, message: 'Password confirmation does not match.'};
            }
        };

        vm.copyProgramChampionForBilling = function ($event) {
            var isSet = $event.target.checked;
            if (isSet) {
                vm.form.billingContact.firstName = vm.form.champion.firstName;
                vm.form.billingContact.lastName = vm.form.champion.lastName;
                vm.form.billingContact.emailAddress = vm.form.champion.emailAddress;
                vm.form.billingContact.contactPhone = vm.form.champion.officePhone;
            } else {
                vm.form.billingContact.firstName = null;
                vm.form.billingContact.lastName = null;
                vm.form.billingContact.emailAddress = null;
                vm.form.billingContact.contactPhone = null;
            }

            angular.element('#billingPhone').triggerHandler('click');
            vm.isCopyingProgramChampionForBilling = isSet;
        };

        function validateListForm(formName) {
            var type = formName.replace('sForm', '');
            if (type === 'driver' && vm.form.dealerDriverSystem == 1) {
                vm.form.drivers = [];
                return true;
            }
            
            if (type === 'vehicle') {
                if (vm.form.tripTypes.length === 0) {
                    $scope.$apply(function () {
                        vm[type].missingMessage = 'Must have at least one ' + type + '.';
                    });
                    return false;
                }
            } else if (type === 'storeHour') {
                var foundOpenDay = $filter('filter')(vm.form.storeHours.hours, { closed: false }, false);
                
                if (!foundOpenDay.length) {
                    $scope.$apply(function () {
                        vm[type].missingMessage = 'Must have at least one open day';
                    });
                    return false;
                }

                var stepValid = true;
                // check to see if hours are are good
                for (var i = foundOpenDay.length - 1; i >= 0; i--) {
                    var day = foundOpenDay[i];
                    var isValid = !(_.isNil(day.startTime) || _.isNil(day.endTime));
                        isValid &= vm.validation.dealerHours(true, day.startTime, day.endTime, day.closed).isValid;
                    if (!isValid) {
                        var elem = angular.element('#errorMessage' + day.dayOfWeekId);
                        elem.text('Open hours must be before closing hours');
                    }
                    stepValid &= isValid;
                }
                if (!stepValid)
                    return false;
            } else {

                if (vm.form[formName.replace('Form', '')].length === 0) {
                    $scope.$apply(function () {
                        vm[type].missingMessage = 'Must have at least one ' + type + '.';
                    });
                    return false;
                } 
            } 

            $scope.$apply(function () {
                vm[type].missingMessage = '';
            });
            return true;
        }

        function selectTwilio(twilioNumbers) {
            if (twilioNumbers.length == 0) {   // place was found. no numbers available
                vm.cantContinueMessage = 'We\'ve encountered a problem and are unable to handle your enrollment at this time. Please contact us at the number below.';
                return;
            }

            vm.cantContinueMessage = null;
        }

        vm.placeUpdated = function (formattedAddress) {
            if (formattedAddress) {
                var bounds = new google.maps.LatLngBounds();
                bounds.extend(new google.maps.LatLng(formattedAddress.location.lat, formattedAddress.location.lng));

                vm.form.storeInformation.location = formattedAddress.location;
                var marker = {
                    title: vm.form.storeInformation.dealerName || 'Dealer Location',
                    location: [
                        vm.form.storeInformation.location.lat,
                        vm.form.storeInformation.location.lng
                    ]
                };
                vm.marker = marker;

                NgMap.getMap().then(function (map) {
                    map.setCenter(bounds.getCenter());
                    if (map.getZoom() > 16) map.setZoom(12); 
                });

                enrollmentService.getTimezone(vm.form.storeInformation.location.lat, vm.form.storeInformation.location.lng)
                    .then(function (result) {
                        vm.form.storeInformation.timeZoneId = result;
                    });
            }
        };

        vm.storeNameUpdated = function () {
            if (vm.marker)
                vm.marker.title = vm.form.storeInformation.dealerName;
        };

        vm.closedChanged = function(day) {
            if(!day.closed && (!day.startTime || !day.endTime)) {
                day.startTime = vm.storeHour.days[0].minutesFromMidnight;
                day.endTime = vm.storeHour.days[0].minutesFromMidnight;    
            }
        };

        vm.addBlackout = function (dateToAdd) {
            if (!vm.validation.date(dateToAdd).isValid)
                return;

            var date = moment(dateToAdd).format("YYYY-MM-DDTHH:mm:ss");
            if (jQuery.inArray(date, vm.form.storeHours.blackouts) === -1) {
                vm.form.storeHours.blackouts.push(date);
            }
        };

        vm.sortByDate = function (date1, date2) {
            date1 = new Date(date1);
            date2 = new Date(date2);
            return date1 < date2;
        };

        $scope.$watch('vm.placesObj.twilioNumbers', function(newVal) {
            if (newVal) {
                selectTwilio(newVal);
            }
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.enrollment')
        .enrollmentWizardControllerVariables = function(vm, SYSTEM_ENUMS, USER_TITLES, resolvedConfig) {

            var routePrefix = 'app/areas/enrollment/views/';

            // progress bar css
            var progressbarElem = angular.element(document.querySelector('.pace .pace-progress'));
            progressbarElem.addClass(resolvedConfig.styleClass);
            
            vm.refreshStyles = function(styleClass) {
                // {re}-apply classes to steps 
                // remove any existing custom classes
                var elems = document.querySelectorAll('.wizard > .steps .current');
                angular.forEach(elems, function (elem) {
                    var aElem = angular.element(elem);
                    aElem.removeClass('done-' + styleClass);
                    aElem.removeClass('disabled-' + styleClass);

                    // add the custom classes
                    aElem.addClass('current-' + styleClass);    
                });

                elems = document.querySelectorAll('.wizard > .steps .done');
                angular.forEach(elems, function (elem) {
                    var aElem = angular.element(elem);
                    aElem.removeClass('current-' + styleClass);
                    aElem.removeClass('disabled-' + styleClass);

                    // add the custom classes
                    aElem.addClass('done-' + styleClass);    
                });

                elems = document.querySelectorAll('.wizard > .steps .disabled');
                angular.forEach(elems, function (elem) {
                    var aElem = angular.element(elem);
                    aElem.removeClass('done-' + styleClass);
                    aElem.removeClass('current-' + styleClass);

                    // add the custom classes
                    aElem.addClass('disabled-' + styleClass);    
                });
            };

            vm.systemEnums = SYSTEM_ENUMS;
            vm.titles = USER_TITLES;
            vm.tempChampion = {};
            vm.storeHour = { days: [] };
            vm.finish = {
                show: false,
                isFinished: false,
                messageHeader: 'Please wait.',
                messageBody: 'Do not navigate away from this page. <br /> We are setting up your account.<br /><br />This may take a few minutes.'
            };

            vm.form = {
                dealerDriverSystem: '',
                storeInformation: {
                    location: {
                        lat: 26.114249, 
                        lng: -80.1368509
                    },
                    dmsSystem: 0
                },
                storeHours: {
                    hours: [],
                    blackouts: []
                },
                advisors: [
                    { index: 0, firstName: '', lastName: '', officePhone: '', mobilePhone: '', emailAddress: '' }, 
                    { index: 1, firstName: '', lastName: '', officePhone: '', mobilePhone: '', emailAddress: '' }
                ],
                drivers: [
                    { index: 0, firstName: '', lastName: '', mobilePhone: '', emailAddress: '' },
                    { index: 1, firstName: '', lastName: '', mobilePhone: '', emailAddress: '' }
                ],
                agreement: {},
                champion: {},
                billingContact: {},
                tripTypes: []
            };

            // create hours
            var dayNames = SYSTEM_ENUMS.dayNames;
            for (var dayOfWeek = 0; dayOfWeek < dayNames.length; dayOfWeek++) {
                vm.form.storeHours.hours.push(
                    {
                        title: dayNames[dayOfWeek],
                        dayOfWeekId: dayOfWeek,
                        startTime: 540,
                        endTime: 1080,
                        closed: false
                    }
                );
            }  

            vm.markers = [];

            vm.programType = {
                SERVICE: 0,
                TEST_DRIVE: 1
            };

            vm.vehicle = {};

            vm.templates = [
                {
                    name: 'Store Information',
                    form: 'vm.storeInformationForm',
                    route: routePrefix + 'enrollment-store.view.html'
                },
                {
                    name: 'Store Hours',
                    form: 'vm.storeHoursForm',
                    route: routePrefix + 'enrollment-hours.view.html'
                },
                {
                    name: 'Program Champion',
                    form: 'vm.programChampionForm',
                    route: routePrefix + 'enrollment-champion.view.html'
                },
                {
                    name: 'Billing Contact',
                    form: 'vm.billingContactForm',
                    route: routePrefix + 'enrollment-billingcontact.view.html'
                },
                {
                    name: 'BDC & Advisors',
                    form: 'vm.advisorsForm',
                    route: routePrefix + 'enrollment-advisor.view.html'
                },
                {
                    name: 'Vehicles',
                    form: 'vm.vehiclesForm',
                    route: routePrefix + 'enrollment-vehicle.view.html'
                },
                {
                    name: 'Drivers',
                    form: 'vm.driversForm',
                    route: routePrefix + 'enrollment-driver.view.html'
                },
                {
                    name: 'Agreement',
                    form: 'vm.agreementForm',
                    route: routePrefix + 'enrollment-agreement.view.html'
                },
                {
                    name: 'Summary',
                    form: '',
                    route: routePrefix + 'enrollment-summary.view.html'
                }
            ];

            if (resolvedConfig.program === vm.programType.TEST_DRIVE)
                vm.templates[6].name = 'Sales Team';

            vm.validationTemplates = angular.copy(vm.templates);

            applyStyles(resolvedConfig.styleClass);

            vm.minutesFromMidnightToAmPm = function(totalMinutes) {
                var hours = Math.floor(totalMinutes / 60);
                var minutes = totalMinutes % 60;
                var ampm = hours >= 12 ? 'PM' : 'AM';
                var ampmHours = hours > 12 ? hours - 12 : hours < 1 ? 12 : hours;

                return {
                    minutesFromMidnight: totalMinutes,
                    militaryHours: (hours < 10 ? '0' + hours : hours) + ':' + (minutes == 0 ? '00' : minutes),
                    ampmHours: (ampmHours < 10 ? '0' + ampmHours : ampmHours) + ':' + (minutes == 0 ? '00' : minutes) + ' ' + ampm
                };
            };

            createHoursDropdown();

            // this can be rethought and apply single style at root node.
            function applyStyles(styleClass) {
                // apply classes to buttons
                var actionElem = document.querySelector('.wizard > .actions');
                angular.element(actionElem).addClass('actions-' + styleClass);

                // apply the class across all steps
                var stepElem = document.querySelector('.wizard > .steps');
                angular.element(stepElem).addClass('steps-' + styleClass);

                stepElem = document.querySelector('.wizard > .content');
                angular.element(stepElem).addClass('content-' + styleClass);

                vm.refreshStyles(styleClass);

            }

            function createHoursDropdown() {
                var variations = 30;    // interval minutes between each option

                for (var totalMinutes = 0; totalMinutes < 24 * 60; totalMinutes += variations) { // count minutes up until midnight next day
                    vm.storeHour.days.push(vm.minutesFromMidnightToAmPm(totalMinutes));
                }
            }
        };
})();
(function () {
    'use strict';

    EnrollmentWelcomeController.$inject = ["$log", "$q", "$scope", "$state", "$sce", "enrollmentService", "enrollmentValidationService", "resolvedConfig"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentWelcomeController', EnrollmentWelcomeController);

    function EnrollmentWelcomeController($log, $q, $scope, $state, $sce, enrollmentService, enrollmentValidationService, resolvedConfig) {
        var vm = this;
        
        $scope.$parent.vm.config = resolvedConfig;
        vm.config = resolvedConfig;

        // progress bar css
        var progressbarElem = angular.element(document.querySelector('.pace .pace-progress'));
        progressbarElem.addClass(vm.config.styleClass);

        vm.config.landingPageContent = typeof resolvedConfig.landingPageContent === 'object' ? resolvedConfig.landingPageContent : $sce.trustAsHtml(resolvedConfig.landingPageContent);
        
        vm.form = { code: '' };
        vm.processing = false;

        if (vm.config.landingPageVideoUrl) {
            vm.video = $sce.trustAsResourceUrl(vm.config.landingPageVideoUrl);
        }

        vm.validation = {
            code: function() {
                vm.processing = true;
                enrollmentValidationService.validateEnrollmentCode(vm.form.code)
                    .then(function (result) {
                        if (!result.isValid) {
                            vm.message = result.message;
                            vm.processing = false;
                        } else
                            vm.checkEnrollment();
                    });
            },
            hasError: function () {
                return angular.element(document.querySelector('#codeError')).text().length > 1;
            },
            clearError: function () {
                vm.message = '';
            }
        };

        vm.checkEnrollment = function() {
            enrollmentService.checkEnrollmentCode(resolvedConfig.id, vm.form)
                .then(function (result) {
                    if (result.success) {
                        vm.message = null;
                        $log.debug('Rerouting... enrollment-wizard');
                        $state.go('enrollment-wizard', { configId: resolvedConfig.id, guid: vm.config.guid || result.guid });
                    } else {
                        vm.message = result.message;
                        vm.processing = false;
                    } 
                });
        };
    }
})();
(function () {
    'use strict';

    EnrollmentMobileController.$inject = ["$log", "$state", "$scope", "resolvedConfig"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentMobileController', EnrollmentMobileController);

    function EnrollmentMobileController($log, $state, $scope, resolvedConfig) {
        var vm = this;

        vm.mobileNavCollapsed = true;

        vm.config = resolvedConfig;
    }
})();

(function () {
    'use strict';

    EnrollmentListController.$inject = ["$log", "$scope", "$timeout", "$filter", "$location", "toastr", "enrollmentService", "modalService", "inputMapper", "resolvedEnrollmentList", "resolvedEnrollmentPrograms", "localStorageService"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentListController', EnrollmentListController);

    function EnrollmentListController($log, $scope, $timeout, $filter, $location, toastr, enrollmentService, modalService, inputMapper, resolvedEnrollmentList, resolvedEnrollmentPrograms, localStorageService) {
        var vm = this,
            _status = localStorageService.get('enrollmentStatusInput'),     // this catches status of 0
            allSelected = false,
            displayLimit = 30;
            
        vm.searchInput  = localStorageService.get('enrollmentSearchInput') || [];
        vm.programInput = localStorageService.get('enrollmentProgramInput') || 'ALL PROGRAMS';
        vm.statusInput  = _.isNil(_status) ? -1 : _status;
        vm.visibleCodes = [];
        vm.programList = resolvedEnrollmentPrograms;
        vm.programList.unshift('ALL PROGRAMS');

        vm.status = {
            disabled: 0,
            active: 1,
            started: 127,
            completed: 255
        };

        vm.statusList = [{ label: 'ALL STATUSES', value: -1 }];
        for (var key in vm.status) {
            if (!vm.status.hasOwnProperty(key)) continue;

            vm.statusList.push({ label: key.charAt(0).toUpperCase() + key.slice(1), value: vm.status[key] });
        }

        var searchCodesComparator = function (value, index, array) {
            if (vm.searchInput.length < 1 && vm.programInput === 'ALL PROGRAMS' && vm.statusInput === -1)
                return true;

            vm.displayLimit = displayLimit;
            var bKeyWordSearch = false,
                bProgramSearch = false,
                bStatusSearch = false;

            bProgramSearch = vm.programInput === 'ALL PROGRAMS' || value.programName === vm.programInput;
            bStatusSearch = vm.statusInput === -1 || value.status === vm.statusInput;

            // return only those codes which have field(s) that match ANY vm.searchInput terms
            bKeyWordSearch =  _.every(vm.searchInput, function (searchItem) {
                var searchKeyword = searchItem.text.toLowerCase();
                return _.includes(_.toString(value.oemDealerId).toLowerCase(), searchKeyword) ||
                    _.includes(_.toString(value.dealerName).toLowerCase(), searchKeyword);
            });

            return bKeyWordSearch && bProgramSearch && bStatusSearch;
        };

        function createFilterMessage() {
            var message = '';
            if (vm.searchInput && vm.searchInput.length > 0) {
                message += '<i><b>Keyword</b>: ';
                message += vm.searchInput.map(function (input) { return input['text']; });
                message += '</i>&nbsp;&nbsp;';
            }
            if (vm.programInput !== 'ALL PROGRAMS') 
                message += '<i><b>Program</b>: ' + vm.programInput + '</i>&nbsp;&nbsp;';

            if (vm.statusInput !== -1) 
                message += '<b>Status</b>: <i>' + _.result(_.find(vm.statusList, function (status) { return status.value === vm.statusInput; }), 'label') + '</i>';
            

            if (message.length > 0)
                message = 'Showing results for ' + message;

            return message;
        }

        var searchCodes = function () {
            vm.visibleCodes = _.filter(vm.codes, searchCodesComparator);
            vm.filterMessage = createFilterMessage();
        };

        vm.displayLimit = displayLimit;
        vm.selectedCodes = [];
        vm.root = $location.protocol() + '://' + $location.host() + ($location.host().toLowerCase() === 'localhost' ? ':' + $location.port() : '');

        vm.enrollmentTokenChanged = function (token) {
            var setValue;
            switch (token) {
                case 'enrollmentSearchInput' :
                    setValue = vm.searchInput;
                    break;
                case 'enrollmentProgramInput' :
                    setValue = vm.programInput;
                    break;
                case 'enrollmentStatusInput' :
                    setValue = vm.statusInput;
                    break;
            }
            
            localStorageService.set(token, setValue);
            searchCodes();
        };


        vm.selectAll = function($event) {
            allSelected = !allSelected;

            _.forEach(vm.visibleCodes, function(code) {
                code.checked = allSelected;

                if (allSelected)
                    vm.selectedCodes.push(code);
            });

            if (!allSelected)
                vm.selectedCodes = [];
        };

        vm.pushCode = function(code) {
            if (code.checked)
                return vm.selectedCodes.push(code);

            else {
                var index = vm.selectedCodes.indexOf(code);
                if (index >= 0)
                    vm.selectedCodes.splice(index, 1);
            }

            $log.debug(vm.selectedCodes);
        };

        vm.updateCodes = function(status) {
            var action = status === vm.status.disabled ? 'Disabling' : 'Activating',
                confirm = modalService.showYesNo(action + ' codes', 'Clicking "Confirm" will update the status of ' + vm.selectedCodes.length + ' code' + (vm.selectedCodes.length > 1 ? 's' : '') + '.', 'Cancel', 'Confirm');

            confirm.then(function (confirmed) {
                if (!confirmed) 
                    return;

                _.forEach(vm.selectedCodes, function(code) {
                    code.status = status;
                });

                enrollmentService.updateCodes(vm.selectedCodes)
                    .then(function(result) {
                        var successMessage = 'Status' + (vm.selectedCodes.length > 1 ? 'es' : '') + ' changed successfully';
                        toastr.success(successMessage);
                        vm.selectedCodes = [];
                    }, function (errorMessage) {
                        toastr.error(errorMessage);
                    });
                });

        };

        vm.deleteCodes = function() {
            var confirm = modalService.showYesNo('Deleting codes', 'Clicking "Confirm" will delete ' + vm.selectedCodes.length + ' code' + (vm.selectedCodes.length > 1 ? 's' : '') + '.', 'Cancel', 'Confirm');

            confirm.then(function (confirmed) {
                if (!confirmed)
                    return;

                enrollmentService.deleteCodes(vm.selectedCodes)
                    .then(function(result) {
                        toastr.success('Codes deleted successfully.');
                    }, function (errorMessage) {
                        toastr.error(errorMessage);
                });
            });
        };

        vm.resendInvites = function() {
            enrollmentService.resendInvites(vm.selectedCodes)
                .then(function(result) {
                    toastr.success('Invite emails have been sent.');
                }, function (errorMessage) {
                    toastr.error(errorMessage);
                });
        };

        vm.resendInvite = function(codeObj) {
            var model = [codeObj];
            $log.debug(model);
            enrollmentService.resendInvites(model)
                .then(function(result) {
                    toastr.success('Invite email has been sent.');
                }, function (errorMessage) {
                    toastr.error(errorMessage);
                });
        };

        vm.displayMore = function() {
            $timeout(function () { vm.displayLimit += displayLimit / 5; }, 10);
        };

        function initEnrollmentList() {
            enrollmentService.getCode()
                .then(function (codes) {
                    vm.displayLimit = displayLimit;
                    formatEnrollmentList(codes);
                });
        }

        function formatEnrollmentList(codes) {
            _.forEach(codes, function (code) {
                code.statusLabel = getLabel(code);
                code.statusText = getStatusText(code);
                code.checked = false;
            });

            vm.codes = codes;
            searchCodes();
        }

        function getLabel(code) {
            switch (code.status) {
                case vm.status.disabled:
                    return 'label-danger';
                case vm.status.active:
                    return 'label-success';
                case vm.status.started:
                    return 'label-warning';
                case vm.status.completed:
                    if (code.enrollmentContractSigned == null )
                        return 'label-warning';

                    return 'label-default';
            }
        }

        function getStatusText(code) {
            switch (code.status) {
                case vm.status.disabled:
                    return 'Disabled';
                case vm.status.active:
                    return 'Active';
                case vm.status.started:
                    return 'Started';
                case vm.status.completed:
                    if (code.enrollmentContractSigned == null )
                        return 'Started';

                    return 'Completed';
            }
        }

        // this will unregister itself when the scope is destroyed, nothing to manually clean up
        $scope.$on('EnrollmentService.changed', function (event, data) {
            initEnrollmentList();
            //TODO: refreshing the entire list is a stop gap - we can look into using "data" to refresh an individual item at some point later on
        });

        formatEnrollmentList(resolvedEnrollmentList);
    }

})();

(function () {
    'use strict';

    EnrollmentEditController.$inject = ["$log", "$scope", "$state", "toastr", "enrollmentService", "resolvedCode"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentEditController', EnrollmentEditController);

    function EnrollmentEditController($log, $scope, $state, toastr, enrollmentService, resolvedCode) {
        var vm = this;
        
        vm.currentCode = resolvedCode;
        
        vm.updateCode = function() {
            var codes = [vm.currentCode];
            $log.debug(codes);

            enrollmentService.updateCodes(codes)
                .then(function(result) {
                    
                    toastr.success('Enrollment updated successfully');
                    // close panel
                    vm.resetFields();
                    $state.go('enrollment-list');
                }, function (errorMessage) {
                    toastr.error(errorMessage);
                });
        };

        vm.resetFields = function() {
            vm.currentCode = {};
        };

        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });
    }
})();

(function () {
    'use strict';

    EnrollmentWelcomeController.$inject = ["$log", "$q", "$scope", "$state", "$sce", "enrollmentService", "enrollmentValidationService", "resolvedConfig", "resolvedContract", "resolvedEmail"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentContractController', EnrollmentWelcomeController);

    function EnrollmentWelcomeController($log, $q, $scope, $state, $sce, enrollmentService, enrollmentValidationService, resolvedConfig, resolvedContract, resolvedEmail) {
        var vm = this;
        
        $scope.$parent.vm.config = resolvedConfig;
        vm.message = '';
        vm.isLoading = false;
        vm.config = resolvedConfig;
        vm.config.showNetwork = resolvedContract.showNetworkAgreement;
        vm.config.softwareLicenseContract = typeof resolvedConfig.softwareLicenseContract === 'object' ? resolvedConfig.softwareLicenseContract : $sce.trustAsHtml(resolvedConfig.softwareLicenseContract);
        vm.config.admDriverNetworkContract = typeof resolvedConfig.admDriverNetworkContract === 'object' ? resolvedConfig.admDriverNetworkContract : $sce.trustAsHtml(resolvedConfig.admDriverNetworkContract);
        vm.config.recruitingContract = typeof resolvedConfig.recruitingContract === 'object' ? resolvedConfig.recruitingContract : $sce.trustAsHtml(resolvedConfig.recruitingContract);
        vm.contract = {
            email: resolvedEmail
        };

        // progress bar css
        var progressbarElem = angular.element(document.querySelector('.pace .pace-progress'));
        progressbarElem.addClass(vm.config.styleClass);

        vm.print = function(divName) {
            var printContents = document.getElementById(divName).innerHTML;
            var popupWin = window.open('', '_blank', 'width=400,height=600');
            popupWin.document.open();
            popupWin.document.write('<html><head><title>Service Agreement</title><style>body { font-size: 5pt; }</style></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        };

        vm.signForm = function() {
            vm.isLoading = true;
            var signature = $scope.accept();
            if (signature.isEmpty || !signature.dataUrl) {
                vm.message = 'Invalid signature. Please sign the form.';
                vm.isLoading = false;
                return;
            }

            if (vm.contract.fullName == null || vm.contract.fullName == '') {
                vm.message = 'Full Name is required.';
                vm.isLoading = false;
                return;
            }

            if (vm.contract.companyTitle == null || vm.contract.companyTitle == '') {
                vm.message = 'Company Title is required.';
                vm.isLoading = false;
                return;
            }

            vm.message = '';
            vm.contract.signatureImage = signature.dataUrl;
            enrollmentService.signContract(resolvedConfig.guid, vm.contract)
                .then(function (valid) {
                    if (!valid) {
                        vm.message = 'An error has occurred. Please try again or contact us at ' + resolvedConfig.programPhoneNumber;
                        vm.isLoading = false;
                    } else
                        $state.go('enrollment-contract-thankyou', { configId: resolvedConfig.id });
                }, function (errorMessage) {
                    vm.message = 'An error has occurred. Please contact us at ' + resolvedConfig.programPhoneNumber;
                    vm.isLoading = false;
                });
        };
    }
})();
(function () {
    'use strict';

    EnrollmentContractCompleteController.$inject = ["$log", "$scope", "$location", "$state", "resolvedConfig"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentContractCompleteController', EnrollmentContractCompleteController);

    function EnrollmentContractCompleteController($log, $scope, $location, $state, resolvedConfig) {
        var vm = this;

        $scope.$parent.vm.config = resolvedConfig;
        vm.config = resolvedConfig;
    }
})();

(function () {
    'use strict';

    EnrollmentAddController.$inject = ["$log", "$state", "$scope"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentAddController', EnrollmentAddController);

    function EnrollmentAddController($log, $state, $scope) {
        var vm = this;

        vm.tabs = [{
            title: 'Single Code',
            route: 'enrollment-add-single',
            active: false
        },
        {
            title: 'Batch',
            route: 'enrollment-add-batch',
            active: false
        }];

        vm.initTabContainers = function() {
            vm.tabs.forEach(function (tab) {
                tab.active = $state.name === tab.route;
            });
        };

        // required listener for form
        $scope.$on('form.locator', function (event, formCtrl) {
            vm.childScopeForm = formCtrl;
        });

        vm.initTabContainers();
    }
})();

(function () {
    'use strict';

    EnrollmentAddSingleController.$inject = ["$log", "$scope", "toastr", "enrollmentService", "enrollmentValidationService", "resolvedConfigList"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentAddSingleController', EnrollmentAddSingleController);

    function EnrollmentAddSingleController($log, $scope, toastr, enrollmentService, enrollmentValidationService, resolvedConfigList) {
        var vm = this;
        vm.configList = resolvedConfigList;    

        vm.acceptableConfigs = _.map(vm.configList, 'id').join();
        
        vm.validation = {
            validateEnrollment: function () {
                var dealerName = vm.form.dealerName | '';
                var oemDealerId = vm.form.oemDealerId | '';

                return enrollmentValidationService.validateEnrollment(dealerName, oemDealerId);
            }
        };

        vm.addCode = function() {
            var codeList = [vm.form];

            enrollmentService.addCodes(codeList).then(function (response) {
                    toastr.success('New Code(s) Successfully Added.');
                    // close panel
                    $scope.$dismiss();

                    vm.resetFields();
                });
        };

        vm.resetFields = function() {
            vm.form = {
                code: null,
                dealerName: null,
                inviteEmail: null,
                configId: null
            };
        };

    }
})();

(function () {
    'use strict';

    EnrollmentAddBatchController.$inject = ["$q", "$state", "$scope", "toastr", "enrollmentService", "enrollmentValidationService", "resolvedConfigList"];
    angular
        .module('redcap.enrollment')
        .controller('EnrollmentAddBatchController', EnrollmentAddBatchController);

    function EnrollmentAddBatchController($q, $state, $scope, toastr, enrollmentService, enrollmentValidationService, resolvedConfigList) {
        var vm = this;
        vm.configList = resolvedConfigList;

        vm.acceptableConfigs = _.map(vm.configList, 'id').join();

        vm.csv = {
            content: ''
        };
        vm.form = {
            configId: null,
            codes: []
        };

        vm.validation = {
            validateCode: function () {
                return enrollmentValidationService.validateCode(vm.form.code);
            }
        };

        vm.addCode = function() {
            var codeList = vm.form.codes;

            enrollmentService.addCodes(codeList)
                .then(function (response) {
                    toastr.success('New Code(s) Successfully Added.');
                    // close panel
                    $scope.$dismiss();

                    vm.resetFields();

                    $state.go('enrollment-list');
                });
        };

        vm.resetFields = function() {
            vm.form = {
                code: null,
                dealerName: null,
                configId: null
            };
        };

        $scope.$watch('vm.csv.content', function (newVal) {
            if (newVal && newVal.length > 0) {
                processCsv(newVal)
                    .then(function (result) {
                        if (result.hasErrors)
                            toastr.error(result.errors);

                        vm.form.codes = result.acceptedValues;
                    });
            }
        });

        function processCsv(arr) {
            var deferred = $q.defer();

            var localArr = [];
            var hasErrors = false;
            var errorMessage = 'These dealer(s) already exist and will be omitted: ';

            var promises = [];

            _.forEach(arr, function (col) {
                promises.push(
                    enrollmentValidationService.validateEnrollment(col[0], col[1])
                        .then(function (result) {
                            if (result.isValid)
                                localArr.push({ dealerName: col[0], oemDealerId: col[1], configId: vm.form.configId, inviteEmail: '' });
                            else {
                                hasErrors = true;
                                errorMessage += '"' + col[0] + '", ';
                            }
                        })
                );
            });

            $q.all(promises)
                .then(function() {
                    deferred.resolve({
                        hasErrors: hasErrors,
                        errors: errorMessage.substring(0, errorMessage.length - 2),
                        acceptedValues: localArr
                    });
                });

            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "$urlServiceProvider", "SYSTEM_ENUMS"];
    angular
        .module('redcap.consumer.trip')
        .config(routeConfig);

    function routeConfig($stateProvider, $urlServiceProvider, SYSTEM_ENUMS) {

        // match URLs in ui-router regardless of trailing forward slashes in URI
        $urlServiceProvider.config.strictMode(false);
        $urlServiceProvider.config.caseInsensitive(true);

        let consumerBase = '';
        let baseConsumerState = {
            abstract: true,
            url: '/consumer',
            public: true,
            data: {
                onError: {
                    toState: 'consumerError'
                }
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            }
        };

        $stateProvider
            .state('consumer', baseConsumerState)

            .state('track', {
                parent: baseConsumerState,
                url: consumerBase + '/:tripId/track?key',
                templateUrl: 'app/areas/consumer/trip/views/track.view.html',
                controller: 'ConsumerTrackTripController as vm',
                params: {
                    trip: null
                },
                resolve: {
                    pageTitle: function () {
                        return 'Track Your Ride';
                    },
                    resolvedKey: ["$transition$", function ($transition$) {
                        if ($transition$.params().trip) return $transition$.params().trip.urlKey;

                        return $transition$.params().key;
                    }],
                    resolvedTrip: ["$transition$", "$state", "consumerTripService", "resolvedKey", function ($transition$, $state, consumerTripService, resolvedKey) {
                        if ($transition$.params().trip) return $transition$.params().trip;

                        return consumerTripService.getTrip($transition$.params().tripId, resolvedKey)
                            .then((resolvedTrip) => {
                                return resolvedTrip;
                            }, (error) => {
                                $state.go('404NotFound');
                            });
                    }],
                    resolvedDealerBranding: ["consumerService", "resolvedTrip", "$transition$", "$rootScope", function (consumerService, resolvedTrip, $transition$, $rootScope) {
                        'ngInject';

                        return consumerService.getDealerBranding(resolvedTrip.dealer.id, resolvedTrip.tripTypeId).then(
                            (resolvedDealerBranding) => {
                                let adminConfig = resolvedDealerBranding.adminConfig;

                                adminConfig.clientClass = 'consumer-page consumer-appointment-page'; // Add custom class to body
                                adminConfig.hideToastr = true; // Don't show toastr messages
                                $rootScope.config = adminConfig;

                                return resolvedDealerBranding;
                            },
                            () => { return {}; });
                    }],
                    resolvedDealerConfig: ["consumerTripService", "resolvedTrip", "resolvedKey", function (consumerTripService, resolvedTrip, resolvedKey) {
                        'ngInject';

                        return consumerTripService.getDealerConfig(resolvedTrip.id, resolvedKey).then(
                            (resolvedDealerConfig) => {
                                // Add custom class to body
                                return resolvedDealerConfig;
                            },
                            () => { return {}; });
                    }]
                }
            })

            .state('summary', {
                parent: baseConsumerState,
                url: consumerBase + '/:tripId/summary?key',
                templateUrl: 'app/areas/consumer/trip/views/summary.view.html',
                controller: 'ConsumerTripSummaryController as vm',
                redirectTo: function(trans) {
                   return trans.injector().getAsync('resolvedTrip')
                        .then((resolvedTrip) => {
                            return trans.injector().getAsync('resolvedKey')
                                .then((resolvedKey) => {
                                    if (resolvedTrip.state === SYSTEM_ENUMS.driverTripStates.complete) {
                                        if (resolvedTrip.hasSurvey && !resolvedTrip.hasSurveyResponse) {
                                            return {state: 'survey', params: {tripId: resolvedTrip.id, key: resolvedKey}};
                                        }
                                    }

                                    if (resolvedTrip.dealerAppointmentId && resolvedTrip.systemTripTypeId === SYSTEM_ENUMS.systemTripType.mobileGarage) {
                                        return {state: 'consumer-appointment-confirmation', params: {appointmentId: resolvedTrip.dealerAppointmentId, dealerId: resolvedTrip.dealer.id, key: resolvedTrip.dealerAppointmentEditKey}};
                                    }
                                });
                        });
                },
                resolve: {
                    pageTitle: function () {
                        return 'Trip Summary';
                    },
                    resolvedKey: ["$transition$", function ($transition$) {
                        if ($transition$.params().trip) return $transition$.params().trip.urlKey;

                        return $transition$.params().key;
                    }],
                    resolvedTrip: ["$transition$", "$state", "consumerTripService", "resolvedKey", function ($transition$, $state, consumerTripService, resolvedKey) {
                        if ($transition$.params().trip) return $transition$.params().trip;

                        return consumerTripService.getTrip($transition$.params().tripId, resolvedKey)
                            .then((resolvedTrip) => {
                                return resolvedTrip;
                            }, (error) => {
                                $state.go('404NotFound');
                            });
                    }],
                    resolvedDealerBranding: ["consumerService", "resolvedTrip", "$rootScope", function (consumerService, resolvedTrip, $rootScope) {
                        'ngInject';

                        return consumerService.getDealerBranding(resolvedTrip.dealer.id, resolvedTrip.tripTypeId).then(
                            (resolvedDealerBranding) => {
                                let adminConfig = resolvedDealerBranding.adminConfig;

                                adminConfig.clientClass = 'consumer-page consumer-appointment-page';
                                adminConfig.hideToastr = true;
                                $rootScope.config = adminConfig;

                                return resolvedDealerBranding;
                            },
                            () => { return {}; });
                    }],
                    resolvedDealerConfig: ["consumerTripService", "resolvedTrip", "resolvedKey", function (consumerTripService, resolvedTrip, resolvedKey) {
                        'ngInject';

                        return consumerTripService.getDealerConfig(resolvedTrip.id, resolvedKey).then(
                            (resolvedDealerConfig) => {
                                // Add custom class to body
                                return resolvedDealerConfig;
                            },
                            () => { return {}; });
                    }]
                }
            })

            .state('survey', {
                parent: baseConsumerState,
                url: consumerBase + '/:tripId/survey?key',
                templateUrl: 'app/areas/consumer/trip/views/survey.view.html',
                controller: 'ConsumerTripSurveyController as vm',
                params: {
                    trip: null
                },
                resolve: {
                    pageTitle: function () {
                        return 'Trip Survey';
                    },
                    resolvedKey: ["$transition$", function ($transition$) {
                        if ($transition$.params().trip) return $transition$.params().trip.urlKey;

                        return $transition$.params().key;
                    }],
                    resolvedTrip: ["$transition$", "$state", "consumerTripService", "resolvedKey", function ($transition$, $state, consumerTripService, resolvedKey) {
                        if ($transition$.params().trip) return $transition$.params().trip;

                        return consumerTripService.getTrip($transition$.params().tripId, resolvedKey)
                            .then((resolvedTrip) => {
                                return resolvedTrip;
                            }, (error) => {
                                $state.go('404NotFound');
                            });
                    }]
                    ,
                    resolvedSurvey: ["$transition$", "$state", "consumerTripService", "resolvedKey", function ($transition$, $state, consumerTripService, resolvedKey) {
                        let tripId = $transition$.params().trip ? $transition$.params().trip.id : $transition$.params().tripId;

                        return consumerTripService.getSurvey(tripId, resolvedKey);
                    }],
                    resolvedDealerBranding: ["consumerService", "resolvedTrip", "$transition$", "$rootScope", function (consumerService, resolvedTrip, $transition$, $rootScope) {
                        'ngInject';

                        return consumerService.getDealerBranding(resolvedTrip.dealer.id, resolvedTrip.tripTypeId).then(
                            (resolvedDealerBranding) => {
                                let adminConfig = resolvedDealerBranding.adminConfig;

                                adminConfig.clientClass = 'consumer consumer-appointment-page'; // Add custom class to body
                                adminConfig.hideToastr = true; // Don't show toastr messages
                                $rootScope.config = adminConfig;

                                return resolvedDealerBranding;
                            },
                            () => { return {}; });
                    }],
                    resolvedDealerConfig: ["consumerTripService", "resolvedTrip", "resolvedKey", function (consumerTripService, resolvedTrip, resolvedKey) {
                        'ngInject';

                        return consumerTripService.getDealerConfig(resolvedTrip.id, resolvedKey).then(
                            (resolvedDealerConfig) => {
                                // Add custom class to body
                                return resolvedDealerConfig;
                            },
                            () => { return {}; });
                    }]
                }
            })

            .state('book', {
                parent: baseConsumerState,
                url: consumerBase + '/book/:tripTypeInstanceId/:tripWorkflowId/:serviceOrderId?isTest',
                templateUrl: 'app/areas/consumer/trip/views/book.view.html',
                controller: 'ConsumerBookTripController as vm',
                resolve: {
                    pageTitle: function () {
                        return 'Request Your Ride';
                    },
                    resolvedTripTypeInstance: ["$transition$", "consumerBookingService", function ($transition$, consumerBookingService) {
                        return consumerBookingService.getTripTypeInstance($transition$.params().tripTypeInstanceId);
                    }],
                    resolvedTripWorkflow: ["$transition$", "consumerBookingService", function ($transition$, consumerBookingService) {
                        if ($transition$.params().tripWorkflowId)
                            return consumerBookingService.getTripWorkflow($transition$.params().tripWorkflowId);
                        else
                            return null;
                    }],
                    resolvedServiceOrder: ["$transition$", "$state", "consumerBookingService", function ($transition$, $state, consumerBookingService) {
                        if ($transition$.params().serviceOrderId)
                            return consumerBookingService.getServiceOrder($transition$.params().serviceOrderId, $transition$.params().tripWorkflowId).then((serviceOrder) => {
                                serviceOrder.isTestTrip = !!$transition$.params().isTest;

                                if (serviceOrder.inviteExpired === true) {
                                    $state.go('consumerInviteExpired', {serviceOrderId: $transition$.params().serviceOrderId,
                                                                         tripTypeInstanceId: $transition$.params().tripTypeInstanceId,
                                                                         tripWorkflowId: $transition$.params().tripWorkflowId});
                                }

                                return serviceOrder;
                            });
                        else
                            return {isTestTrip: $transition$.params().isTest ? $transition$.params().isTest : false};
                    }],
                    resolvedDealerBranding: ["consumerService", "resolvedServiceOrder", "$transition$", "$rootScope", function (consumerService, resolvedServiceOrder, $transition$, $rootScope) {
                        'ngInject';

                        return consumerService.getDealerBranding(resolvedServiceOrder.dealerId, $transition$.params().tripTypeInstanceId).then(
                            (resolvedDealerBranding) => {
                                // Add custom class to body
                                $rootScope.config = {clientClass: 'consumer-page'};

                                return resolvedDealerBranding;
                            },
                            () => { return {}; });
                    }]
                }
            })

            .state('404NotFound', {
                parent: baseConsumerState,
                url: consumerBase + '/404NotFound',
                templateUrl: 'app/areas/consumer/shared/layouts/not-found.view.html',
                controller: 'NotFoundController as vm',
                resolve: {
                    pageTitle: function () {
                        return 'Page Not Found';
                    }
                }
            })

            .state('consumerInviteExpired', {
                parent: baseConsumerState,
                url: consumerBase + '/invalid/:tripTypeInstanceId/:tripWorkflowId/:serviceOrderId',
                templateUrl: 'app/areas/consumer/trip/views/invalid.view.html',
                controller: 'ConsumerInviteExpiredContoller as vm',
                resolve: {
                    pageTitle: function () {
                        return 'Invalid or Expired';
                    },
                    resolvedTripTypeInstance: ["$transition$", "consumerBookingService", function ($transition$, consumerBookingService) {
                        return consumerBookingService.getTripTypeInstance($transition$.params().tripTypeInstanceId);
                    }],
                    resolvedServiceOrder: ["$transition$", "consumerBookingService", function ($transition$, consumerBookingService) {
                        if ($transition$.params().serviceOrderId)
                            return consumerBookingService.getServiceOrder($transition$.params().serviceOrderId, $transition$.params().tripWorkflowId).then((serviceOrder) => {
                                serviceOrder.isTestTrip = $transition$.params().isTest ? $transition$.params().isTest : false;

                                return serviceOrder;
                            });
                        else
                            return {isTestTrip: $transition$.params().isTest ? $transition$.params().isTest : false};
                    }],
                    resolvedDealerBranding: ["consumerService", "resolvedServiceOrder", "$transition$", "$rootScope", function (consumerService, resolvedServiceOrder, $transition$, $rootScope) {
                        'ngInject';

                        return consumerService.getDealerBranding(resolvedServiceOrder.dealerId, $transition$.params().tripTypeInstanceId).then(
                            (resolvedDealerBranding) => {
                                // Add custom class to body
                                $rootScope.config = {clientClass: 'consumer-page'};

                                return resolvedDealerBranding;
                            },
                            () => { return {}; });
                    }]
                }
            })

            .state('consumerError', {
                parent: baseConsumerState,
                url: consumerBase + '/error',
                templateUrl: 'app/areas/consumer/shared/layouts/error.view.html',
                controller: 'ErrorController as vm',
                params: {
                    url: null
                }
            });

        $urlServiceProvider.rules.otherwise(consumerBase + '/404NotFound');
    }

})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider"];
    angular.module('redcap.consumer')
        .config(routeConfig);

    function routeConfig($stateProvider) {

        let sharedBase = {
            parent: 'consumer',
            url: '',
            abstract: true,
            public: true,
            data: {},
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            }
        };

        let termsPage = {
            parent: sharedBase,
            url: '/terms/:dealerId/:tripTypeId/:tripTypeInstanceId?appType',
            params: {
                tripTypeId: {value: null, squash: true},
                tripTypeInstanceId: {value: null, squash: true}
            },
            templateUrl: 'app/areas/consumer/shared/components/terms/terms.view.html',
            controller: 'ConsumerTermsController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Terms and Conditions';
                },
                dealerBranding: ["consumerService", "$transition$", "$rootScope", function (consumerService, $transition$, $rootScope) {
                    'ngInject';

                    return consumerService.getDealerBranding($transition$.params()['dealerId'], $transition$.params()['tripTypeInstanceId']).then(
                        (resolvedDealerBranding) => {
                            // Add custom class to body
                            $rootScope.config = {clientClass: 'consumer-page terms-page'};

                            return resolvedDealerBranding;
                        },
                        () => { return {}; });
                }]
            }
        };

        let faqPage = {
            parent: sharedBase,
            url: '/faq/:dealerId/:tripTypeId/:tripTypeInstanceId?appType',
            params: {
                tripTypeId: {value: null, squash: true},
                tripTypeInstanceId: {value: null, squash: true}
            },
            templateUrl: 'app/areas/consumer/shared/components/faq/faq.view.html',
            controller: 'ConsumerFAQController as vm',
            resolve: {
                pageTitle: function () {
                    return 'FAQs';
                },
                dealerBranding: ["consumerService", "$transition$", "$rootScope", function (consumerService, $transition$, $rootScope) {
                    'ngInject';

                    return consumerService.getDealerBranding($transition$.params()['dealerId'], $transition$.params()['tripTypeInstanceId']).then(
                        (resolvedDealerBranding) => {
                            // Add custom class to body
                            $rootScope.config = {clientClass: 'consumer-page faq-page'};

                            return resolvedDealerBranding;
                        },
                        () => { return {}; });
                }]
            }
        };

        let privacyPage = {
            parent: sharedBase,
            url: '/privacy/:dealerId/:tripTypeId/:tripTypeInstanceId?appType',
            params: {
                tripTypeId: {value: null, squash: true},
                tripTypeInstanceId: {value: null, squash: true}
            },
            templateUrl: 'app/areas/consumer/shared/components/privacy/privacy.view.html',
            controller: 'ConsumerPrivacyController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Privacy';
                },
                dealerBranding: ["consumerService", "$transition$", "$rootScope", function (consumerService, $transition$, $rootScope) {
                    'ngInject';

                    return consumerService.getDealerBranding($transition$.params()['dealerId'], $transition$.params()['tripTypeInstanceId']).then(
                        (resolvedDealerBranding) => {
                            // Add custom class to body
                            $rootScope.config = {clientClass: 'consumer-page privacy-page'};

                            return resolvedDealerBranding;
                        },
                        () => { return {}; });
                }]
            }
        };

        $stateProvider
            .state('consumer-shared-base', sharedBase)
            .state('consumer-terms-page', termsPage)
            .state('consumer-faq-page', faqPage)
            .state('consumer-privacy-page', privacyPage);

    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.consumer')
        .controller('ErrorController', ErrorController);

    function ErrorController() {
        var vm = this;
    }
})();

(function () {
    'use strict';

    NotFoundController.$inject = ["$q", "$log", "$scope"];
    angular
        .module('redcap.consumer')
        .controller('NotFoundController', NotFoundController);

    function NotFoundController($q, $log, $scope) {
        var vm = this;
    }
})();
(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider"];
    angular.module('redcap.consumer.payments')
        .config(routeConfig);

    function routeConfig($stateProvider) {

        let paymentBase = {
            parent: 'consumer',
            url: '/invoice/:invoiceGuid?isTest',
            abstract: true,
            public: true,
            data: {
                onError: {
                    toState: 'consumerError'
                }
            },
            params: {
                verbiage: null,
                invoice: null,
                paymentInfo: null,
                bookingInfo: null,
                emailAddress: null
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                resolvedInvoice: ['consumerPaymentService', '$transition$', '$rootScope', function (consumerPaymentService, $transition$, $rootScope) {
                    "ngInject";
                    let config = {
                        clientClass: 'consumer'
                    };

                    $rootScope.config = config;
                    if ($transition$.params()['invoice']) return $transition$.params()["invoice"];

                    return consumerPaymentService.getInvoiceByGuid($transition$.params()['invoiceGuid']);
                }],
                verbiage: ['resolvedInvoice', 'consumerPaymentService', '$transition$', function (resolvedInvoice, consumerPaymentService, $transition$) {
                    "ngInject";
                    if ($transition$.params()['verbiage']) return $transition$.params()["verbiage"];

                    return consumerPaymentService.getVerbiage(resolvedInvoice.locationId);
                }],
                offeredTripTypes: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getTripTypes($transition$.params()['invoiceGuid']).then((val) => {
                        return val;
                    });
                }],
                isPartsOnDemand: ['offeredTripTypes', 'SYSTEM_ENUMS', function (offeredTripTypes, SYSTEM_ENUMS) {
                    if (offeredTripTypes && offeredTripTypes.length) {
                        let POD = _.find(offeredTripTypes, (item) => {
                            return item.systemTripTypeId == SYSTEM_ENUMS.systemTripType.partsOnDemand;
                        });

                        return  POD != null;
                    }

                    return false;
                }],
                deliveryLineItem: ['resolvedInvoice', 'SYSTEM_ENUMS', function (resolvedInvoice, SYSTEM_ENUMS) {
                    if (resolvedInvoice != null && resolvedInvoice.lineItems != null) {
                        return _.find(resolvedInvoice.lineItems, (item) => {
                            return item.type == SYSTEM_ENUMS.invoiceLineItemTypes.delivery.id;
                        });
                    }
                }],
                deliveryDiscountLineItem: ['deliveryLineItem', 'SYSTEM_ENUMS', function (deliveryLineItem, SYSTEM_ENUMS) {
                    if (deliveryLineItem != null && deliveryLineItem.childLineItems != null) {
                        return _.find(deliveryLineItem.childLineItems, (item) => {
                            return item.type == SYSTEM_ENUMS.invoiceLineItemTypes.discount.id;
                        });
                    }
                }],
                deliveryChargeType: ['deliveryLineItem', function (deliveryLineItem) {
                    if (deliveryLineItem != null && deliveryLineItem.deliveryOptions != null) {
                        return deliveryLineItem.deliveryOptions.chargeType;
                    } else {
                        return null;
                    }
                }],
                deliveryStyleValues: ['resolvedInvoice', function (resolvedInvoice) {
                    return resolvedInvoice.styleValues;
                }],
                isTest: ['$transition$', function ($transition$) {
                    "ngInject";

                    return $transition$.params().isTest ? $transition$.params().isTest : false;

                }]
            }
        };

        let paymentLandingPage = {
            parent: paymentBase,
            url: '',
            templateUrl: 'app/areas/consumer/payments/views/landing.view.html',
            controller: 'PaymentLandingController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Your vehicle is ready';
                },
                dealerHours: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getDealerHours($transition$.params()['invoiceGuid']);
                }],
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }]
            },
            onEnter: ['resolvedInvoice', '$transition$', '$state', function (resolvedInvoice, $transition$, $state) {
                if (resolvedInvoice.status === 3 || resolvedInvoice.status === 5) {
                    $state.go('payment-success', $transition$.params());
                }
            }]
        };

        let paymentReviewChargesPage = {
            parent: paymentBase,
            url: '/review',
            templateUrl: 'app/areas/consumer/payments/views/review-charges.view.html',
            controller: 'PaymentReviewChargesController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Review your charges';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }]
            },
            onEnter: ['$transition$', '$state', function ($transition$, $state) {
                if (!$transition$.params()['paymentInfo']) {
                    $state.go('payment-landing', $transition$.params());
                }
            }]
        };

        let paymentCreditCardPage = {
            parent: paymentBase,
            url: '/pay',
            templateUrl: 'app/areas/consumer/payments/views/credit-card.view.html',
            controller: 'PaymentCreditCardController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Pay your bill';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }],
                cardsOnFile: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getCardsOnFile($transition$.params()["invoiceGuid"], $transition$.params()["emailAddress"]);
                }],
                initializationToken: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getInitializationToken($transition$.params()["invoiceGuid"], $transition$.params()["emailAddress"]);
                }]
            },
            onEnter: ['$transition$', '$state', function ($transition$, $state) {
                if (!$transition$.params()['paymentInfo']) {
                    $state.go('payment-landing', $transition$.params());
                }
            }]
        };

        let deliveryOptionsPage = {
            parent: paymentBase,
            url: '/delivery',
            templateUrl: 'app/areas/consumer/payments/views/delivery-options.view.html',
            controller: 'DeliveryOptionsController as vm',
            params: {
                result: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Delivery Options';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }],
                dealerHours: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getDealerHours($transition$.params()['invoiceGuid']);
                }],
                offeredTripTypes: ['offeredTripTypes', function (offeredTripTypes) {
                    "ngInject";

                    return offeredTripTypes;
                }]
            },
            onEnter: ['deliveryChargeType', '$transition$', '$state', 'SYSTEM_ENUMS', function (deliveryChargeType, $transition$, $state, SYSTEM_ENUMS) {
                if (!$transition$.params()['paymentInfo'] && deliveryChargeType != SYSTEM_ENUMS.invoiceChargeTypes.billToAccount) {
                    $state.go('payment-landing', $transition$.params());
                }
            }]
        };

        let deliveryConfirmationPage = {
            parent: paymentBase,
            url: '/confirmation',
            templateUrl: 'app/areas/consumer/payments/views/confirmation.view.html',
            controller: 'PaymentConfirmationController as vm',
            params: {
                result: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Delivery Confirmation';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }],
                dealerHours: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getDealerHours($transition$.params()['invoiceGuid']);
                }]
            },
            onEnter: ['deliveryChargeType', '$transition$', '$state', 'SYSTEM_ENUMS', function (deliveryChargeType, $transition$, $state, SYSTEM_ENUMS) {
                if (!$transition$.params()['paymentInfo'] && deliveryChargeType != SYSTEM_ENUMS.invoiceChargeTypes.billToAccount) {
                    $state.go('payment-landing', $transition$.params());
                }
            }]
        };

        let paymentSuccessPage = {
            parent: paymentBase,
            url: '/success',
            templateUrl: 'app/areas/consumer/payments/views/success.view.html',
            controller: 'PaymentSuccessController as vm',
            params: {
                result: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Pay your bill';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }],
                paymentResult: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return $transition$.params()['result'] || consumerPaymentService.getPaymentResult($transition$.params()['invoiceGuid']);
                }]
            }
        };

        let paymentSuccessNoBookingPage = {
            parent: paymentBase,
            url: '/done',
            templateUrl: 'app/areas/consumer/payments/views/success-no-booking.view.html',
            controller: 'PaymentSuccessNoBookingController as vm',
            params: {
                result: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Pay your bill';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }],
                paymentResult: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return $transition$.params()['result'] || consumerPaymentService.getPaymentResult($transition$.params()['invoiceGuid']);
                }]
            },
            onEnter: ['resolvedInvoice', '$transition$', '$state', 'paymentResult', function (resolvedInvoice, $transition$, $state, paymentResult) {
                if ((resolvedInvoice.status !== 3 || resolvedInvoice.status !== 5) && !paymentResult) {
                    $state.go('payment-landing', $transition$.params());
                }
            }]
        };

        let paymentBookingPage = {
            parent: paymentBase,
            url: '/booking',
            templateUrl: 'app/areas/consumer/payments/views/book-trip.view.html',
            controller: 'PaymentBookTripController as vm',
            params: {
                result: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Pay your bill';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }]

            },
            onEnter: ['$transition$', '$state', 'offeredTripTypes', function ($transition$, $state, offeredTripTypes) {
                if (!offeredTripTypes || !offeredTripTypes.length) {
                    $state.go('payment-success', $transition$.params(), {reload: true});
                }
            }]
        };

        let paymentBringItInPage = {
            parent: paymentBase,
            url: '/comein',
            templateUrl: 'app/areas/consumer/payments/views/bring-it-in.view.html',
            controller: 'PaymentBringItInController as vm',
            params: {
                result: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Pay your bill';
                },
                invoice: ['resolvedInvoice', function (resolvedInvoice) {
                    "ngInject";

                    return resolvedInvoice;
                }],
                dealerHours: ['$transition$', 'consumerPaymentService', function ($transition$, consumerPaymentService) {
                    "ngInject";

                    return consumerPaymentService.getDealerHours($transition$.params()['invoiceGuid']);
                }]
            },
            onEnter: ['resolvedInvoice', '$transition$', '$state', function (resolvedInvoice, $transition$, $state) {
            }]
        };

        let periProcessed = {
            parent: 'consumer',
            url: '/peri-verify',
            templateUrl: 'app/areas/consumer/payments/views/partials/peri-verify.view.html',
            controller: 'periVerifyController as vm',
            params: {
                result: null
            },
            data: {
                displayName: 'Pay your bill'
            },
            resolve: {
                pageTitle: function () {
                    return 'Pay your bill';
                }
            }
        };

        $stateProvider
            .state('payment-base', paymentBase)
            .state('payment-landing', paymentLandingPage)
            .state('payment-review-charges', paymentReviewChargesPage)
            .state('payment-credit-card', paymentCreditCardPage)
            .state('payment-success', paymentSuccessPage)
            .state('payment-success-no-booking', paymentSuccessNoBookingPage)
            .state('payment-booking', paymentBookingPage)
            .state('payment-delivery-options', deliveryOptionsPage)
            .state('payment-confirmation', deliveryConfirmationPage)
            .state('payment-bring-it-in', paymentBringItInPage)
            .state('payment-peri-processed', periProcessed);
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider"];
    angular.module('redcap.consumer.loaner')
        .config(routeConfig);

    function routeConfig($stateProvider) {

        let loanerBase = {
            parent: 'consumer',
            url: '/loaner/:userGuid/:dealerId',
            abstract: true,
            public: true,
            data: {},
            params: {
                user: null,
                verbiage: null,
                redirecting: false,
                branding: null,
                terms: null,
                license: null,
                insurance: null,
                card: null,
                fromState: null,
                transportationType: null,
                vehiclePreferences: null,
                usePoints: null,
                loanerPreferences: null,
                paymentMethodValid: null,
                credentialsValid: null,
                credentialsError: null,
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                resolvedUser: ['consumerLoanerService', '$transition$', 'SYSTEM_ENUMS', function (consumerLoanerService, $transition$) {
                    "ngInject";

                    if ($transition$.params()['user']) return $transition$.params()["user"];

                    return consumerLoanerService.getUser($transition$.params()['userGuid'], $transition$.params()['dealerId']).then((response) => {
                        $transition$.targetState().params()['user'] = response;

                        return response;
                    });
                }],
                dealerBranding: ["consumerService", "$transition$", "$rootScope", function (consumerService, $transition$, $rootScope) {
                    'ngInject';
                    if ($transition$.params()['branding']) return $transition$.params()["branding"];

                    return consumerService.getDealerBranding($transition$.params()['dealerId'], null, true).then(
                        (resolvedDealerBranding) => {
                            let adminConfig = resolvedDealerBranding.adminConfig;

                            adminConfig.clientClass = 'consumer consumer-appointment-page consumer-loaner-page'; // Add custom class to body
                            adminConfig.hideToastr = true; // Don't show toastr messages
                            $rootScope.config = adminConfig;
                            $transition$.targetState().params()['branding'] = resolvedDealerBranding;

                            return resolvedDealerBranding;
                        },
                        () => { return {}; });
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', function (resolvedUser, $transition$, $state, consumerLoanerService) {
            }]
        };

        let loanerLandingPage = {
            parent: loanerBase,
            url: '',
            templateUrl: 'app/areas/consumer/loaner/views/landing.view.html',
            controller: 'LoanerLandingController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', function (resolvedUser, $transition$, $state) {
                //If we have a complete profile
                if (resolvedUser.profileComplete) {
                    //If contract is started, drop us on the confirmation page
                    if (!resolvedUser.isStartContractLoanerTasksComplete) {
                         $state.go('loaner-profile-complete', {fromStart: true, userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']});
                    } else if (resolvedUser.isContractStarted === true) {
                         $state.go('loaner-signature-complete', {fromStart: true, userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']});
                    } 
                }
            }]
        };

        let loanerDriverInfo = {
            parent: loanerBase,
            url: '/insurance',
            templateUrl: 'app/areas/consumer/loaner/views/driver-info.view.html',
            controller: 'LoanerDriverInfoController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', function (resolvedUser, $transition$, $state) {

            }]
        };


        let loanerCreditCard = {
            parent: loanerBase,
            url: '/payment',
            templateUrl: 'app/areas/consumer/loaner/views/credit-card.view.html',
            controller: 'LoanerConsumerCreditCardController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedToken: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', function (resolvedUser, $transition$, $state, consumerLoanerService) {
                    return consumerLoanerService.getClientToken($transition$.params()['userGuid'], $transition$.params()['dealerId']);
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', function (resolvedUser, $transition$, $state, consumerLoanerService) {
                if (!$transition$.params()['license'] || !$transition$.params()['insurance']) {
                    $state.go('loaner-landing', {userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']});
                }
            }]
        };

        let loanerConfirmation = {
            parent: loanerBase,
            url: '/confirm',
            templateUrl: 'app/areas/consumer/loaner/views/confirmation.view.html',
            controller: 'LoanerConsumerConfirmationController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', 'SYSTEM_ENUMS', function (resolvedUser, $transition$, $state, consumerLoanerService, SYSTEM_ENUMS) {
                let transitionType = $transition$.params()['transportationType'];
                    let types = SYSTEM_ENUMS.cflTransportationTypes;
                    let bypass = false;

                if (transitionType && transitionType === types.lyftCredit) {
                    bypass = true;
                }

                if (bypass === false && (!$transition$.params()['license'] || !$transition$.params()['insurance'] || (resolvedUser.isCreditCardRequired && !$transition$.params()['card']))) {
                    $state.go('loaner-landing', {userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']});
                }
            }]
        };

        let loanerSignature = {
            parent: loanerBase,
            url: '/sign',
            templateUrl: 'app/areas/consumer/loaner/views/signature.view.html',
            controller: 'LoanerConsumerSignatureController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                checkStatus: ['consumerLoanerService', '$transition$', function (consumerLoanerService, $transition$) {
                    return consumerLoanerService.beforeContractSigned($transition$.params()['dealerId'], $transition$.params()['userGuid'])
                        .then((beforeSuccess) => {
                            // If beforeSuccess is false, then there is an issue with the contract getting to the "Signed" state
                            if (!beforeSuccess) {
                                // Something failed, redirect to error page (don't allow user to continue)
                                throw {redirectState: 'loaner-error', redirectParams: {userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']}};
                            }

                            return true;
                        })
                        .catch((error) => {
                            throw {redirectState: 'loaner-error', redirectParams: {userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']}};
                        });
                }],
                resolvedIssues: ['consumerLoanerService', 'checkStatus', '$transition$', function(consumerLoanerService, checkStatus, $transition$) {
                    // If checkStatus is true, then we're in the correct state to get the issues
                    if (checkStatus) {
                        return consumerLoanerService.getVehicleIssues($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                    }
                }],
                resolvedTerms: ['consumerLoanerService', 'checkStatus', '$transition$', function (consumerLoanerService, checkStatus, $transition$) {
                    // If checkStatus is true, then we're in the correct state to get the terms
                    if (checkStatus) {
                        return consumerLoanerService.getTerms($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                    }
                }],
                resolvedVehicle: ['consumerLoanerService', 'checkStatus', '$transition$', function (consumerLoanerService, checkStatus, $transition$) {
                    // If checkStatus is true, then we're in the correct state to get the vehicle
                    if (checkStatus) {
                        return consumerLoanerService.getVehicle($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                    }
                }],
                resolvedContractLink: ['consumerLoanerService', 'checkStatus', '$transition$', function (consumerLoanerService, checkStatus, $transition$) {
                    // If checkStatus is true, then we're in the correct state to get the contract link
                    if (checkStatus) {
                        return consumerLoanerService.getContractPdfLink($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                    }
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', function (resolvedUser, $transition$, $state, consumerLoanerService) {
                if (resolvedUser.contractSignedDate) {
                   $state.go('loaner-signature-complete', {userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']});
                }
            }]
        };

        let loanerSignatureComplete = {
            parent: loanerBase,
            url: '/signed',
            templateUrl: 'app/areas/consumer/loaner/views/signature-complete.view.html',
            controller: 'LoanerConsumerSignatureCompleteController as vm',
            params: {
                signatureImageUrl: null,
                issues: null,
                terms: null
            },
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedIssues: ['consumerLoanerService', '$transition$', function (consumerLoanerService, $transition$) {
                    return consumerLoanerService.getVehicleIssues($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                }],
                resolvedVehicle: ['consumerLoanerService', '$transition$', function (consumerLoanerService, $transition$) {
                    return consumerLoanerService.getVehicle($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                }],
                resolvedContractLink: ['consumerLoanerService', '$transition$', function (consumerLoanerService, $transition$) {
                    return consumerLoanerService.getContractPdfLink($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                }]

            },
            onEnter: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', function (resolvedUser, $transition$, $state, consumerLoanerService) {
                //if (!$transition$.params()['license'] || !$transition$.params()['insurance'] || !$transition$.params()['card']) {
                //    $state.go('loaner-landing', { userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId'] });
                //}
            }]
        };

        let loanerProfileComplete = {
            parent: loanerBase,
            params: {
                fromStart: false
            },
            url: '/complete',
            templateUrl: 'app/areas/consumer/loaner/views/profile-complete.view.html',
            controller: 'LoanerConsumerProfileCompleteController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', 'consumerLoanerService', 'SYSTEM_ENUMS', function (resolvedUser, $transition$, $state, consumerLoanerService, SYSTEM_ENUMS) {
                let transitionType = $transition$.params()['transportationType'];
                    let types = SYSTEM_ENUMS.cflTransportationTypes;
                    let bypass = false;

                if (transitionType && transitionType === types.lyftCredit) {
                    bypass = true;
                }

                if (transitionType && transitionType === types.lyftCredit) {
                    bypass = true;
                }
                
                if ($transition$.params()['fromStart'] === true || bypass === true) return;

                if (!$transition$.params()['license'] || !$transition$.params()['insurance'] || (resolvedUser.isCreditCardRequired && !$transition$.params()['card'])) {
                    $state.go('loaner-landing', {userGuid: $transition$.params()['userGuid'], dealerId: $transition$.params()['dealerId']});
                }
            }]
        };

        let loanerCflTransportation = {
            parent: loanerBase,
            url: '/transportation',
            templateUrl: 'app/areas/consumer/loaner/views/cfl-transportation.view.html',
            controller: 'LoanerCflTransportationController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', function (resolvedUser, $transition$, $state) {

            }]
        };

        let loanerCflVehicleSelection = {
            parent: loanerBase,
            url: '/vehicles',
            templateUrl: 'app/areas/consumer/loaner/views/cfl-vehicle-selection.view.html',
            controller: 'LoanerCflVehicleSelectionController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                user: ['resolvedUser', function (resolvedUser) {
                    "ngInject";

                    return resolvedUser;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedVehicleChoices: ['consumerLoanerService', '$transition$', function (consumerLoanerService, $transition$) {
                    return consumerLoanerService.getVehicleChoices($transition$.params()['dealerId'], $transition$.params()['userGuid']);
                }]
            },
            onEnter: ['resolvedUser', '$transition$', '$state', function (resolvedUser, $transition$, $state) {

            }]
        };


        let loanerError = {
            parent: loanerBase,
            public: true,
            url: '/error',
            templateUrl: 'app/areas/consumer/loaner/views/error.view.html',
            controller: 'LoanerErrorController as vm',
            params: {
                error: null,
                title: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Loaner Error';
                },
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            }
        };

        $stateProvider
            .state('loaner-base', loanerBase)
            .state('loaner-landing', loanerLandingPage)
            .state('loaner-error', loanerError)
            .state('loaner-driver-info', loanerDriverInfo)
            .state('loaner-credit-card-info', loanerCreditCard)
            .state('loaner-confirmation', loanerConfirmation)
            .state('loaner-signature', loanerSignature)
            .state('loaner-profile-complete', loanerProfileComplete)
            .state('loaner-signature-complete', loanerSignatureComplete)
            .state('loaner-cfl-transportation', loanerCflTransportation)
            .state('loaner-cfl-vehicleselection', loanerCflVehicleSelection);
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider"];
    angular.module('redcap.consumer.ownercare')
        .config(routeConfig);

    function routeConfig($stateProvider) {

        let ownerCareBase = {
            parent: 'consumer',
            url: '/ownercare/:eventGuid/:dealerId',
            abstract: true,
            public: true,
            data: {},
            params: {
                event: null,
                verbiage: null,
                redirecting: false,
                branding: null,
                terms: null
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                resolvedEvent: ['consumerOwnercareService', '$transition$', 'SYSTEM_ENUMS', function (consumerOwnercareService, $transition$, SYSTEM_ENUMS) {
                    "ngInject";
                    if ($transition$.params()['event']) return $transition$.params()["event"];

                    return consumerOwnercareService.getEvent($transition$.params()['eventGuid'], $transition$.params()['dealerId']).then((event) => {
                        if (event && event.postResponse) {
                            event.postResponse.failedRecommendations = event.postResponse.failedRecommendations || [];
                            event.postResponse.cautionRecommendations = event.postResponse.cautionRecommendations || [];
                            event.postResponse.originalCautioned = [];
                            event.postResponse.originalFailed = [];

                            for (let originalRequest in event.postResponse.originalCustomerRequests) {
                                let origReq = event.postResponse.originalCustomerRequests[originalRequest];

                                for (let recommendation in origReq.recommendations) {
                                    let rec = origReq.recommendations[recommendation];

                                    switch (rec.status) {
                                        case SYSTEM_ENUMS.ownerCareItemStatus.caution:
                                            event.postResponse.originalCautioned.push(angular.extend({isOriginalConcern: true}, rec));
                                            break;
                                        case SYSTEM_ENUMS.ownerCareItemStatus.fail:
                                            event.postResponse.originalFailed.push(angular.extend({isOriginalConcern: true}, rec));
                                            break;
                                    }
                                }
                            }

                            if (!event.postResponse.isComplete) {
                                let allItems = [].concat(event.postResponse.originalFailed,
                                    event.postResponse.failedRecommendations,
                                    event.postResponse.originalCautioned,
                                    event.postResponse.cautionRecommendations);

                                allItems.forEach((item) => {
                                    item.isApproved = null;
                                });
                            }
                        }

                        $transition$.targetState().params()['event'] = event;

                        return event;
                    });
                }],
                resolvedVerbiage: ['consumerOwnercareService', '$transition$', function (consumerOwnercareService, $transition$) {
                    "ngInject";
                    if ($transition$.params()['verbiage']) return $transition$.params()["verbiage"];
                    let verbiage = consumerOwnercareService.getVerbiage($transition$.params()['dealerId']);

                    $transition$.targetState().params()['verbiage'] = verbiage;

                    return verbiage;
                }],
                resolvedTerms: ['consumerOwnercareService', '$transition$', function (consumerOwnercareService, $transition$) {
                    "ngInject";
                    if ($transition$.params()['terms']) return $transition$.params()["terms"];
                    let terms = consumerOwnercareService.getTerms($transition$.params()['dealerId']);

                    $transition$.targetState().params()['terms'] = terms;

                    return terms;
                }],
                dealerBranding: ["consumerOwnercareService", "$transition$", "$rootScope", function (consumerOwnercareService, $transition$, $rootScope) {
                    'ngInject';
                    if ($transition$.params()['branding']) return $transition$.params()["branding"];

                    return consumerOwnercareService.getDealerBranding($transition$.params()['dealerId']).then(
                        (resolvedDealerBranding) => {
                            let adminConfig = resolvedDealerBranding.adminConfig;

                            adminConfig.clientClass = 'consumer consumer-appointment-page'; // Add custom class to body
                            adminConfig.hideToastr = true; // Don't show toastr messages
                            $rootScope.config = adminConfig;
                            $transition$.targetState().params()['branding'] = resolvedDealerBranding;

                            return resolvedDealerBranding;
                        },
                        () => { return {}; });
                }]
            },
            onEnter: ['resolvedEvent', '$transition$', '$state', 'consumerOwnercareService', function (resolvedEvent, $transition$, $state, consumerOwnercareService) {
                if (!resolvedEvent || !resolvedEvent.postResponse) {
                    $state.go('ownercare-error', angular.extend({error: 'We are unable to locate this inspection report.'}, $transition$.params()));
                } else if (!resolvedEvent.isSuccessStatusCode) {
                    $state.go('ownercare-error', angular.extend({error: resolvedEvent.error}, $transition$.params()));
                } else if (resolvedEvent.postResponse.isComplete) {
                    if (!$transition$.params()['redirecting']) {
                        let params = {
                            redirecting: true,
                            approvedServices: consumerOwnercareService.getApprovedServices(resolvedEvent)
                        };

                        $state.go('ownercare-done', angular.extend(params, $transition$.params()));
                    }
                } else if (resolvedEvent.postResponse.isExpired) {
                    $state.go('ownercare-error', angular.extend({error: 'This link has expired and is no longer available.  '}, $transition$.params()));
                }
            }]
        };

        let ownerCareLandingPage = {
            parent: ownerCareBase,
            url: '',
            templateUrl: 'app/areas/consumer/ownercare/views/landing.view.html',
            controller: 'OwnerCareLandingController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                event: ['resolvedEvent', function (resolvedEvent) {
                    "ngInject";

                    return resolvedEvent;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedEvent', '$transition$', '$state', function (resolvedEvent, $transition$, $state) {

            }]
        };

        let ownerCareSummary = {
            parent: ownerCareBase,
            url: '/summary',
            templateUrl: 'app/areas/consumer/ownercare/views/summary.view.html',
            controller: 'OwnerCareSummaryController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                event: ['resolvedEvent', function (resolvedEvent) {
                    "ngInject";

                    return resolvedEvent;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedEvent', '$transition$', '$state', function (resolvedEvent, $transition$, $state) {

            }]
        };

        let ownerCareServices = {
            parent: ownerCareBase,
            url: '/services',
            templateUrl: 'app/areas/consumer/ownercare/views/services.view.html',
            controller: 'OwnerCareServicesController as vm',
            resolve: {
                pageTitle: function () {
                    return '';
                },
                event: ['resolvedEvent', function (resolvedEvent) {
                    "ngInject";

                    return resolvedEvent;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedEvent', '$transition$', '$state', function (resolvedEvent, $transition$, $state) {

            }]
        };

        let ownerCareServiceDetails = {
            parent: ownerCareBase,
            public: true,
            url: '/services/detail',
            templateUrl: 'app/areas/consumer/ownercare/views/service-details.view.html',
            controller: 'OwnerCareServiceDetailsController as vm',
            params: {
                recommendation: null,
                tabId: 0,
                decline: false
            },
            resolve: {
                pageTitle: function () {
                    return '';
                },
                event: ['resolvedEvent', function (resolvedEvent) {
                    "ngInject";

                    return resolvedEvent;
                }],
                recommendation: ['$transition$', function($transition$) {
                    "ngInject";

                    return $transition$.params()['recommendation'];
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['resolvedEvent', '$transition$', '$state', function (resolvedEvent, $transition$, $state) {
                if ($transition$.params()['recommendation'] === null || $transition$.params()['tabId'] === null) {
                    $state.go('ownercare-services', $transition$.params());
                }
            }]
        };

        let ownerCareReview = {
            parent: ownerCareBase,
            public: true,
            url: '/services/review',
            templateUrl: 'app/areas/consumer/ownercare/views/review.view.html',
            controller: 'OwnerCareReviewController as vm',
            params: {
                approvedServices: null
            },
            resolve: {
                pageTitle: function () {
                    return '';
                },
                event: ['resolvedEvent', function (resolvedEvent) {
                    "ngInject";

                    return resolvedEvent;
                }],
                taxesAndFees: ['$transition$', 'consumerOwnercareService', function ($transition$, consumerOwnercareService) {
                    "ngInject";
                    if (!$transition$.params()['approvedServices']) return;
                    let approvedServices = $transition$.params()['approvedServices'];

                    return consumerOwnercareService.getTaxesAndFees($transition$.params()["eventGuid"], approvedServices, $transition$.params()['dealerId']);
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }]
            },
            onEnter: ['$transition$', '$state', function ($transition$, $state) {
                if (!$transition$.params()['approvedServices']) {
                    $state.go('ownercare-services', $transition$.params());
                }
            }]
        };

        let ownerCareDone = {
            parent: ownerCareBase,
            public: true,
            url: '/services/done',
            templateUrl: 'app/areas/consumer/ownercare/views/done.view.html',
            controller: 'OwnerCareDoneController as vm',
            params: {
                approvedServices: null,
                taxesAndFees: null,
                total: null
            },
            resolve: {
                pageTitle: function () {
                    return '';
                },
                event: ['resolvedEvent', function (resolvedEvent) {
                    "ngInject";

                    return resolvedEvent;
                }],
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                taxesAndFees: ['$transition$', 'consumerOwnercareService', function ($transition$, consumerOwnercareService) {
                    "ngInject";
                    if ($transition$.params()['taxesAndFees']) return $transition$.params()['taxesAndFees'];

                    if (!$transition$.params()['approvedServices']) return;
                    let approvedServices = $transition$.params()['approvedServices'];

                    return consumerOwnercareService.getTaxesAndFees($transition$.params()["eventGuid"], approvedServices, $transition$.params()['dealerId']);
                }]
            },
            onEnter: ['$transition$', '$state', function ($transition$, $state) {
                if (!$transition$.params()['approvedServices']) {
                    $state.go('ownercare-services', $transition$.params());
                }
            }]
        };

        let ownerCareError = {
            parent: 'consumer',
            public: true,
            url: '/ownercare/:eventGuid/:dealerId/error',
            templateUrl: 'app/areas/consumer/ownercare/views/error.view.html',
            controller: 'OwnerCareErrorController as vm',
            params: {
                error: null
            }
        };

        $stateProvider
            .state('ownercare-base', ownerCareBase)
            .state('ownercare-landing', ownerCareLandingPage)
            .state('ownercare-summary', ownerCareSummary)
            .state('ownercare-services', ownerCareServices)
            .state('ownercare-service-details', ownerCareServiceDetails)
            .state('ownercare-review', ownerCareReview)
            .state('ownercare-done', ownerCareDone)
            .state('ownercare-error', ownerCareError)
            ;
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider"];
    angular.module('redcap.consumer.inspect')
        .config(routeConfig);

    function routeConfig($stateProvider) {
        let inspectionMediaUploadBase = {
            parent: 'consumer',
            url: '/inspection/:dealerId/ro/:roId',
            abstract: true,
            public: true,
            params: {
                dealerId: null,
                roId: null,
                key: null
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                resolvedKey: ["$transition$", function ($transition$) {
                    'ngInject';
                    
                    return $transition$.params().key;
                }],
            }
        };

        let inspectionMediaUploadTaskPage = {
            parent: inspectionMediaUploadBase,
            url: '/task/:taskId/media-upload?key&taskName',
            abstract: false,
            public: true,
            params: {
                taskId: null
            },
            templateUrl: 'app/areas/consumer/inspect/views/inspection-media-upload.view.html',
            controller: 'InspectionMediaUploadController as vm',
            resolve: {
                resolvedLineItems: ["consumerInspectService", "$transition$", function (consumerInspectService, $transition$) {
                    'ngInject';
                    
                    return consumerInspectService.getLineItems(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }],
                resolvedRo: ["consumerRepairOrderAuthorizationsService", "$transition$", function(consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';
                    
                    return consumerRepairOrderAuthorizationsService.getRepairOrder(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }]
            }
        };

        let inspectionMediaUploadRecPage = {
            parent: inspectionMediaUploadBase,
            url: '/lineitem/:lineItemId/media-upload?key',
            abstract: false,
            public: true,
            params: {
                lineItemId: null
            },
            templateUrl: 'app/areas/consumer/inspect/views/inspection-media-upload.view.html',
            controller: 'InspectionMediaUploadController as vm',
            resolve: {
                resolvedLineItems: ["consumerInspectService", "$transition$", function (consumerInspectService, $transition$) {
                    'ngInject';
                    
                    return consumerInspectService.getLineItems(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }],
                resolvedRo: ["consumerRepairOrderAuthorizationsService", "$transition$", function(consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';
                    
                    return consumerRepairOrderAuthorizationsService.getRepairOrder(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }]
            }
        };

        let inspectionMediaUploadListPage = {
            parent: inspectionMediaUploadBase,
            url: '/media-upload/list?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/inspect/views/inspection-media-upload-list.view.html',
            controller: 'InspectionMediaUploadListController as vm',
            resolve: {
                resolvedLineItems: ["consumerInspectService", "$transition$", function (consumerInspectService, $transition$) {
                    'ngInject';
                    
                    return consumerInspectService.getLineItems(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }],
                resolvedRo: ["consumerRepairOrderAuthorizationsService", "$transition$", function(consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRepairOrder(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }],
                resolvedConfig: ["$transition$", "$injector", "rcConfigService", function ($transition$, $injector, rcConfigService) {
                    let configId = $transition$.params().configId;

                    if (!configId && $injector.has && $injector.has('$state')) {
                        let $state = $injector.get('$state');
                        
                        configId = $state && $state.params && $state.params.configId;
                    }

                    if (!configId && window && window.$rootScope && window.$rootScope.config) {
                        configId = window.$rootScope.config.id;
                    }

                    configId = configId || 1;
                    
                    return rcConfigService.getConfigValues(configId);
                }]
            }
        };

        let vehicleOverviewMediaUploadPage = {
            parent: inspectionMediaUploadBase,
            url: '/vehicle-overview/media-upload?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/inspect/views/vehicle-overview-media-upload.view.html',
            controller: 'VehicleOverviewMediaUploadController as vm',
            resolve: {
                resolvedRo: ["consumerRepairOrderAuthorizationsService", "$transition$", function(consumerRepairOrderAuthorizationsService, $transition$) {
                    'ngInject';

                    return consumerRepairOrderAuthorizationsService.getRepairOrder(
                        $transition$.params()['dealerId'],
                        $transition$.params()['roId'],
                        $transition$.params().key
                    );
                }]
            }
        };  

       $stateProvider
            .state('consumer-inspection-media-upload-base', inspectionMediaUploadBase)
            .state('consumer-inspection-media-upload-task', inspectionMediaUploadTaskPage)
            .state('consumer-inspection-media-upload-rec', inspectionMediaUploadRecPage)
            .state('consumer-inspection-media-upload-list', inspectionMediaUploadListPage)
            .state('consumer-vehicle-overview-media-upload', vehicleOverviewMediaUploadPage);
    }
})();
(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE"];
    angular.module('redcap.consumer.appointments')
        .config(routeConfig);

    function routeConfig($stateProvider, CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE) {

        let appointmentBase = {
            parent: 'consumer',
            url: '/appointment/:dealerId',
            abstract: true,
            public: true,
            data: {
                onError: {
                    toState: 'consumerError'
                }
            },
            params: {
                dealerId: null
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                hasAccess: ["consumerAppointmentService", "$transition$", "$state", function (consumerAppointmentService, $transition$, $state) {
                    'ngInject';

                    return consumerAppointmentService.hasAccess($transition$.params()['dealerId']).then(
                        (result) => {
                            if (result === false) {
                                $state.go('consumerError');
                            }
                        },
                        (error) => {
                            $state.go('consumerError');
                        });
                }],
                dealerBranding: ["consumerAppointmentService", "$transition$", "$rootScope", function (consumerAppointmentService, $transition$, $rootScope) {
                    'ngInject';

                    return consumerAppointmentService.getDealerBranding($transition$.params()['dealerId']).then(
                        (resolvedDealerBranding) => {
                            let adminConfig = resolvedDealerBranding.adminConfig;

                            adminConfig.clientClass = 'consumer-appointment-page'; // Add custom class to body
                            adminConfig.hideToastr = true; // Don't show toastr messages
                            $rootScope.config = adminConfig;

                            return resolvedDealerBranding;
                        },
                        (error) => { return {}; });
                }],
                dealerDepartments: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getDepartments($transition$.params().dealerId);
                }],
                locationTransportationTypes: ["$transition$", "locationService", function ($transition$, locationService) {
                    'ngInject';

                    return locationService.getLocationTransportationTypes($transition$.params().dealerId);
                }],
                dealerOpCodes: ["$transition$", "consumerAppointmentService", function($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getLocationOpCodes($transition$.params().dealerId);
                }]
            }
        };

        let appointmentHomeworkBase = {
            parent: 'consumer',
            url: '/appointment/:dealerId',
            abstract: true,
            public: true,
            data: {
                onError: {
                    toState: 'consumerError'
                }
            },
            params: {
                dealerId: null
            },
            views: {
                'layout@': {
                    templateUrl: 'app/areas/consumer/shared/layouts/content-only.view.html',
                    controller: 'ConsumerController as vm'
                }
            },
            resolve: {
                hasAccess: ["consumerAppointmentService", "$transition$", "$state", function (consumerAppointmentService, $transition$, $state) {
                    'ngInject';

                    return consumerAppointmentService.hasAccess($transition$.params()['dealerId']).then(
                        (result) => {
                            if (result === false) {
                                $state.go('consumerError');
                            }
                        },
                        (error) => {
                            $state.go('consumerError');
                        });
                }],
                resolvedVehicleConditions: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getVehicleConditionImages($transition$.params()['dealerId'], $transition$.params()['appointmentId'], 
                    $transition$.params().key);
                }],
                resolvedDealerBranding: ["consumerAppointmentService", "$transition$", "$rootScope", function (consumerAppointmentService, $transition$, $rootScope) {
                    'ngInject';

                    return consumerAppointmentService.getAppointmentHomeworkBranding($transition$.params()['dealerId']).then(
                        (resolvedDealerBranding) => {
                            let adminConfig = resolvedDealerBranding.adminConfig;

                            adminConfig.clientClass = 'consumer consumer-appointment-page'; // Add custom class to body
                            adminConfig.hideToastr = true; // Don't show toastr messages
                            $rootScope.config = adminConfig;

                            return resolvedDealerBranding;
                        },
                        (error) => { return {}; });
                }],
                resolvedLocationTransportationTypes: ["$transition$", "locationService", function ($transition$, locationService) {
                    'ngInject';

                    return locationService.getLocationTransportationTypes($transition$.params().dealerId);
                }],
                resolvedDealerOpCodes: ["$transition$", "consumerAppointmentService", function($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getLocationOpCodes($transition$.params().dealerId);
                }],
                resolvedAppointment: ["consumerAppointmentService", "$transition$", "resolvedDealerOpCodes", "appointmentClass", "SYSTEM_ENUMS", "appointmentUtilService", function (consumerAppointmentService, $transition$, resolvedDealerOpCodes, appointmentClass, SYSTEM_ENUMS, appointmentUtilService) {
                    'ngInject';

                    return consumerAppointmentService.getAppointment($transition$.params().dealerId, $transition$.params().appointmentId, $transition$.params().key).then(
                        (result) => {
                            let appointment = appointmentClass.new(result);
                            
                            appointment = consumerAppointmentService.postProcessAPIAppointment(appointment, resolvedDealerOpCodes);
            
                            return appointment;
                        },
                    (error) => { return null; });
                }],
                resolvedConsumerTripTypes: ["consumerAppointmentService", "resolvedLocationTransportationTypes", function (consumerAppointmentService, resolvedLocationTransportationTypes) {
                    'ngInject';

                    return consumerAppointmentService.getConsumerTripTypes(resolvedLocationTransportationTypes);
                }],
                resolvedKey: ["$transition$", function ($transition$) {
                    'ngInject';

                    return $transition$.params().key;
                }]
            }
        };

        let appointmentLandingPage = {
            parent: appointmentBase,
            url: '',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/appointments/views/landing.view.html',
            controller: 'ConsumerAppointmentLandingController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Let\'s service your vehicle';
                },
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedDealerDepartments: ["dealerDepartments", function (dealerDepartments) {
                    'ngInject';

                    return dealerDepartments;
                }],
                resolvedConsumerTripTypes: ["consumerAppointmentService", "locationTransportationTypes", function (consumerAppointmentService, locationTransportationTypes) {
                    'ngInject';

                    return consumerAppointmentService.getConsumerTripTypes(locationTransportationTypes);
                }]
            }
        };

        let appointmentBookingPage = {
            parent: appointmentBase,
            url: '/book/:appointmentId?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/appointments/views/booking.view.html',
            controller: 'ConsumerAppointmentBookingController as vm',
            params: {
                appointment: null,
                appointmentId: null,
                tripType: null,
                pickupLocation: null,
                displayedTripLocations: null,
                eventData: null,
                customer: null,
                department: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Appointment Booking';
                },
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedDealerDepartments: ["dealerDepartments", function (dealerDepartments) {
                    'ngInject';

                    return dealerDepartments;
                }],
                resolvedConsumerTripTypes: ["consumerAppointmentService", "locationTransportationTypes", function (consumerAppointmentService, locationTransportationTypes) {
                    'ngInject';

                    return consumerAppointmentService.getConsumerTripTypes(locationTransportationTypes);
                }],
                resolvedAppointmentStatuses: ["settingsService", function(settingsService) {
                    'ngInject';

                    return settingsService.getAppointmentStatuses();
                }],
                resolvedRequiredDMSFields: ["consumerAppointmentService", "$transition$", "$state", function (consumerAppointmentService, $transition$, $state) {
                    'ngInject';

                    return consumerAppointmentService.getDMSRequiredFields($transition$.params()['dealerId']);
                }],
                resolvedDealerIntegrations: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getDealerIntegrations($transition$.params()['dealerId']);
                }],
                resolvedKey: ["$transition$", function ($transition$) {
                    'ngInject';

                    return $transition$.params().key;
                }]
            },
            onEnter: ['$transition$', '$state', function ($transition$, $state) {
                'ngInject';

                if (!$transition$.params()['appointment'] && !$transition$.params()['appointmentId']) {
                    $state.go('consumer-appointment-landing', $transition$.params());
                }
            }]
        };

        let appointmentGhostGarageBookingPage = {
            parent: appointmentBase,
            url: '/gbook/:appointmentId?key',
            abstract: false,
            public: true,
            templateUrl: 'app/areas/consumer/appointments/views/ghostgarage-booking.view.html',
            controller: 'ConsumerAppointmentGhostGarageBookingController as vm',
            params: {
                appointment: null,
                appointmentId: null,
                tripType: null,
                pickupLocation: null,
                eventData: null,
                customer: null
            },
            resolve: {
                pageTitle: function () {
                    return 'Appointment Booking';
                },
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedDealerDepartments: ["dealerDepartments", function (dealerDepartments) {
                    'ngInject';

                    return dealerDepartments;
                }],
                resolvedConsumerTripTypes: ["consumerAppointmentService", "locationTransportationTypes", function (consumerAppointmentService, locationTransportationTypes) {
                    'ngInject';

                    return consumerAppointmentService.getConsumerTripTypes(locationTransportationTypes);
                }],
                resolvedAppointmentStatuses: ["settingsService", function(settingsService) {
                    'ngInject';

                    return settingsService.getAppointmentStatuses();
                }],
                resolvedRequiredDMSFields: ["consumerAppointmentService", "$transition$", "$state", function (consumerAppointmentService, $transition$, $state) {
                    'ngInject';

                    return consumerAppointmentService.getDMSRequiredFields($transition$.params()['dealerId']);
                }],
                resolvedDealerIntegrations: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getDealerIntegrations($transition$.params()['dealerId']);
                }],
                resolvedKey: ["$transition$", function ($transition$) {
                    'ngInject';

                    return $transition$.params().key;
                }]
            }
        };

        let appointmentConfirmationPage = {
            parent: appointmentBase,
            url: '/confirm/:appointmentId?key',
            abstract: false,
            public: true,
            params: {
                appointment: null,
                displayedTripLocations: null
            },
            templateUrl: 'app/areas/consumer/appointments/views/confirmation.view.html',
            controller: 'ConsumerAppointmentConfirmationController as vm',
            resolve: {
                pageTitle: function () {
                    return 'Appointment Confirmation';
                },
                resolvedDealerBranding: ["dealerBranding", function (dealerBranding) {
                    'ngInject';

                    return dealerBranding;
                }],
                resolvedConsumerTripTypes: ["consumerAppointmentService", "locationTransportationTypes", function (consumerAppointmentService, locationTransportationTypes) {
                    'ngInject';

                    return consumerAppointmentService.getConsumerTripTypes(locationTransportationTypes);
                }],
                resolvedDealerIntegrations: ["consumerAppointmentService", "$transition$", function (consumerAppointmentService, $transition$) {
                    'ngInject';

                    return consumerAppointmentService.getDealerIntegrations($transition$.params()['dealerId']);
                }],
                resolvedAppointmentStatuses: ["settingsService", function (settingsService) {
                    'ngInject';

                    return settingsService.getAppointmentStatuses();
                }],
                resolvedRideShareCredit: ["$transition$", "consumerAppointmentService", function ($transition$, consumerAppointmentService) {
                    'ngInject';

                    return consumerAppointmentService.getRideShareCredit($transition$.params()['dealerId'], $transition$.params()['appointmentId'], 
                    $transition$.params().key);
                }],
                resolvedKey: ["$transition$", function ($transition$) {
                    'ngInject';

                    return $transition$.params().key;
                }]
            },
            onEnter: ['$transition$', '$state', function ($transition$, $state) {
                'ngInject';

                // If we don't have either an appointment object or an appointmentId, go to the landing
                if (!$transition$.params()['appointment'] && !$transition$.params()['appointmentId']) {
                    $state.go('consumer-appointment-landing', $transition$.params());
                }
            }]
        };

        $stateProvider
            .state('consumer-appointment-base', appointmentBase)
            .state('consumer-appointment-homework-base', appointmentHomeworkBase)
            .state('consumer-appointment-landing', appointmentLandingPage)
            .state('consumer-appointment-ghostgarage-booking', appointmentGhostGarageBookingPage)
            .state('consumer-appointment-booking', appointmentBookingPage)
            .state('consumer-appointment-confirmation', appointmentConfirmationPage);
    }
})();

(function () {
    'use strict';

    authService.$inject = ["$rootScope", "$q", "$log", "$state", "$http", "$interval", "toastr", "localStorageService", "userService", "API_SETTINGS", "permissions", "rcConfigService", "SYSTEM_ENUMS", "AZUREBTC_POLICIES"];
    angular
        .module('redcap')
        .factory('authService', authService);

    function authService($rootScope, $q, $log, $state, $http, $interval, toastr, localStorageService, userService, API_SETTINGS, permissions, rcConfigService, SYSTEM_ENUMS, AZUREBTC_POLICIES) {
        let serviceBase = API_SETTINGS.apiServiceBaseUri;
        let _isCallbackBusy = false;
        let _refreshAccessTokenIntervalPromise;
        let _refreshAccessTokenFailedCount = 0;
        let _tutorialCheckedTime = null;
        let _dashboardUpdateTimePromise = null;
        let _authData = {
            token: null,
            token_expireSeconds: 0,
            refresh_token_time: 0,
            userInfo: null,
            refreshToken: null,
            refreshToken_expires: null,
            useRefreshTokens: false,
            isFramedIn: false
        };
        let _authError = {
            redirectLink: '',
            message: ''
        };

        return {
            login: login,
            loginFrame: loginFrame,
            logout: logout,
            authData: _authData,
            authError: _authError,
            initializeLoginData: initializeLoginData,
            isAuthenticated: isAuthenticated,
            isFramedIn: function isFramedIn() { return _authData.isFramedIn; },
            isAllowedMessagesFramedIn: isAllowedMessagesFramedIn,
            getCurrentUser: getCurrentUser,
            isValidAdminConfig: isValidAdminConfig,
            redirectToDefaultPage: redirectToDefaultPage,
            loginToken: loginToken,
            handleLoginError: handleLoginError,
            configureMSAL: configureMSAL
        };

        function initializeLoginData(username, configId) {
            return {
                userName: username,
                password: '',
                useRefreshTokens: true,
                rememberToggle: !!username,
                adminConfigId: configId,
                autofillHack: 0
            };
        }

        function login(loginData) {
            $log.debug('auth-service: login(): ', loginData);
            
            // reset failed token refresh count
            _refreshAccessTokenFailedCount = 0;

            let data = "grant_type=password&username=" + encodeURIComponent(loginData.userName)  + "&password=" + loginData.password;

            data += "&adminProgramId=" + loginData.adminConfigId;

            if (loginData.useRefreshTokens) {
                data = data + "&client_id=" + API_SETTINGS.clientId + "&client_secret=" + API_SETTINGS.clientSecret;
            }

            let deferred = $q.defer();

            $rootScope.isDataLoading = true;

            $http.post(serviceBase + 'OAuth/Token', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((response) => {
                populateAuthDataFromResponse(response.data, loginData.useRefreshTokens, loginData.adminConfigId, false);

                if (loginData.useRefreshTokens) {
                    // if using refresh tokens, start interval timer to refresh access tokens
                    startRefreshAccessTokenInterval(10);
                }

                $rootScope.isDataLoading = false;
                deferred.resolve(_authData);

            }).catch((err, status) => {
                let errMsg = err && err.data && err.data.error_description || 'Login failure';

                $rootScope.isDataLoading = false;
                deferred.reject(err.data);
            });

            return deferred.promise;
        }

        function loginToken(loginData, token) {

            $log.debug('auth-service: login(): ', loginData);

            // reset failed token refresh count
            _refreshAccessTokenFailedCount = 0;

            let data = "grant_type=password&username=&password=";

            data += "&adminProgramId=" + loginData.adminConfigId;

            if (loginData.useRefreshTokens) {
                data = data + "&client_id=" + API_SETTINGS.clientId + "&client_secret=" + API_SETTINGS.clientSecret;
            }

            let deferred = $q.defer();

            $rootScope.isDataLoading = true;

            $http.post(serviceBase + 'OAuth/Token', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded', 'SolidToken': token}}).then((response) => {
                populateAuthDataFromResponse(response.data, loginData.useRefreshTokens, loginData.adminConfigId);

                if (loginData.useRefreshTokens) {
                    // if using refresh tokens, start interval timer to refresh access tokens
                    startRefreshAccessTokenInterval(10);
                }

                $rootScope.isDataLoading = false;
                deferred.resolve(_authData);

            }).catch((err, status) => {
                let errMsg = err && err.data && err.data.error_description || 'Login failure';

                $rootScope.isDataLoading = false;
                deferred.reject(err.data);
            });

            return deferred.promise;
        }
        

        function loginFrame(loginData) {

            $log.debug('auth-service: loginFrame(): ', loginData);

            // reset failed token refresh count
            _refreshAccessTokenFailedCount = 0;

            let data = "grant_type=password&username=" + loginData.userName + "&password=" + loginData.password;
            
            data = data + "&client_id=" + API_SETTINGS.frameId + "&client_secret=" + API_SETTINGS.frameSecret;

            let deferred = $q.defer();

            $rootScope.isDataLoading = true;

            $http.post(serviceBase + 'OAuth/Token', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((response) => {

                populateAuthDataFromResponse(response.data, loginData.useRefreshTokens, loginData.adminConfigId, true);

                if (loginData.useRefreshTokens) {
                    // if using refresh tokens, start interval timer to refresh access tokens
                    startRefreshAccessTokenInterval(10);
                }

                $rootScope.isDataLoading = false;
                deferred.resolve(_authData);

            }).catch((err, status) => {
                let errMsg = err && err.data && err.data.error_description || 'Login failure';

                $rootScope.isDataLoading = false;
                deferred.reject(errMsg);
            });

            return deferred.promise;
        }

        function logout() {
            $log.debug('auth-service: logout()');

            localStorageService.remove('authorizationData');

            cancelRefreshAccessTokenInterval();
        }

        function getCurrentUser() {
            return _authData.userInfo;
        }

        function isValidAdminConfig(adminConfigId) {
            let deferred = $q.defer();
            let authData = localStorageService.get('authorizationData');

            if (authData && authData.adminConfigId) {

                if (authData.adminConfigId != adminConfigId) {
                    $log.debug('Admin Program forcibly changed! Logging out...');
                    deferred.reject();
                } else {
                    deferred.resolve();
                }

            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function isAuthenticated() {
            // $log.debug('auth-service: isAuthenticated() - called');

            let deferred = $q.defer();

            if (!_authData || !_authData.token) {
                let savedAuthData = localStorageService.get('authorizationData');

                if (savedAuthData) {
                    $log.debug('auth-service: isAuthenticated() - authData restored from local storage');
                    _authData = savedAuthData;
                }
            }

            let forceTokenRefresh = !permissions.arePermissionsSet();

            if (_authData) {
                if (_authData.useRefreshTokens) {
                    let refreshByMoment = moment().utc();
                    let accessTokenExpiresMoment = moment(_authData.token_expires);
                    let refreshTokenExpiresMoment = moment(_authData.refreshToken_expires);

                    // $log.debug('auth-service: isAuthenticated() - Current UTC = ' + moment().utc().toISOString());
                    // $log.debug('auth-service: isAuthenticated() - accessTokenExpiresMoment = ' + accessTokenExpiresMoment.toISOString());
                    // $log.debug('auth-service: isAuthenticated() - refreshTokenExpiresMoment = ' + refreshTokenExpiresMoment.toISOString());

                    if (moment(accessTokenExpiresMoment).isAfter(refreshTokenExpiresMoment)) {
                        refreshByMoment = refreshTokenExpiresMoment;
                    } else {
                        refreshByMoment = accessTokenExpiresMoment;
                    }

                    // $log.debug('auth-service: isAuthenticated() - refreshByMoment = ' + refreshByMoment.toISOString());

                    let refreshByMomentLapsed = moment().utc().isAfter(refreshByMoment.subtract(30, 'seconds'));

                    if (refreshByMomentLapsed) {

                        let refreshTokenExpired = moment().utc().isAfter(refreshTokenExpiresMoment.subtract(15, 'seconds'));

                        if (refreshTokenExpired) {
                            $log.debug('auth-service: isAuthenticated() - we had auth data, but the refresh token has expired; Result: NOT Authenticated');
                            logout();
                            deferred.reject();
                        } else {
                            $log.debug('auth-service: isAuthenticated() - we have auth data and valid refresh token; Refresh the access token...');

                            refreshAccessToken().then(() => {
                                deferred.resolve();
                            }, (err) => {
                                deferred.reject(err);
                            });
                        }
                    } else {
                        // we still have a valid access token - make sure the Interval is still set
                        if (_refreshAccessTokenIntervalPromise) {
                            // we are still authenticated with no risk of not refreshing the access token
                            // tell the UI router or calling code we are good
                            $log.debug('auth-service: isAuthenticated() - we have auth data and the access token is still valid; Result: Authenticated');

                            if (forceTokenRefresh) {
                                refreshAccessToken().then(() => {
                                    deferred.resolve();
                                }, (err) => {
                                    deferred.reject(err);
                                });
                            } else {
                                deferred.resolve();
                            }
                        } else {
                            // we still have an access token, but no refresh token Interval set -
                            // allow the current access token to be used, but immediately refresh it
                            $log.debug('auth-service: isAuthenticated() - we have auth data and the access token is still valid, but no $interval was set; Result: Authenticated with refresh needed');

                            refreshAccessToken().then(() => {
                                deferred.resolve();
                            }, (err) => {
                                deferred.reject(err);
                            });
                        }
                    }
                } else {
                    $log.debug('auth-service: isAuthenticated() - we had auth data, but no refresh token; Result: NOT Authenticated');
                    logout();
                    deferred.reject();
                }
            } else {
                $log.debug('auth-service: isAuthenticated() - no auth data in local storage; Result: NOT Authenticated');
                logout();
                deferred.reject();
            }

            return deferred.promise;
        }

        function refreshAccessToken() {
            $log.debug('auth-service: refreshAccessToken() - attempting to get new access token');

            let deferred = $q.defer();
            let savedAuthData = localStorageService.get('authorizationData');

            if (savedAuthData) {

                let data = "grant_type=refresh_token&refresh_token=" + savedAuthData.refreshToken + "&client_id=" + API_SETTINGS.clientId + "&client_secret=" + API_SETTINGS.clientSecret;

                $http.post(serviceBase + 'OAuth/Token', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((response) => {

                    localStorageService.remove('authorizationData');

                    // $log.debug('auth-service: Token Refreshed: ', response);

                    populateAuthDataFromResponse(response.data, true, savedAuthData.adminConfigId, savedAuthData.isFramedIn);

                    $log.debug('auth-service: Access Token has been refreshed.');
                    //toastr.success('Your token was successfully refreshed.');

                    // reset failed token refresh count
                    _refreshAccessTokenFailedCount = 0;

                    // ensure token is refreshed by making sure interval is still set OR
                    // start it if this is being called from ui router resolve : authenticate
                    if (!_refreshAccessTokenIntervalPromise) {
                        startRefreshAccessTokenInterval(10);
                    }

                    deferred.resolve(_authData);

                }).catch((err, status) => {

                    _refreshAccessTokenFailedCount++;

                    $log.debug('auth-service: Error on refresh access token post: ', err.data, status);
                    $log.debug('auth-service: Refresh access token failure count: ', _refreshAccessTokenFailedCount);

                    if (err && err.data && err.data.error_description) {
                        toastr.error('Authentication Error: ' + err.data.error_description);
                    } else {
                        toastr.error('Unknown Authentication Error Occurred!');
                    }

                    if (_refreshAccessTokenFailedCount < 60) {
                        startRefreshAccessTokenInterval(10);    // restart the interval to try again
                    } else {
                        $log.debug('Too many re-authentication failures have occurred. Cancelling interval. User must manually log back in.');
                        toastr.error('Too many re-authentication failures have occurred. You must manually log back in.');
                    }

                    err.isFramedIn = savedAuthData.isFramedIn;
                    deferred.reject(err.data);
                });
            } else {
                $log.debug('WARNING: NO AUTH DATA EXISTS INCLUDING REFRESH TOKEN FROM LOCAL STORAGE');
                logout();

                deferred.reject();
            }

            return deferred.promise;
        }

        function refreshAccessTokenCallback() {
            if (_isCallbackBusy) {
                return;
            }

            _isCallbackBusy = true;

            // check to see if we need to refresh the access token by calling the isAuthenticated() function
            isAuthenticated().then(() => {
                _isCallbackBusy = false;
            });
        }

        function populateAuthDataFromResponse(response, useRefreshTokens, adminConfigId, isFramedIn) {
            // set access token expiry time date/time UTC stamp
            let accessTokenExpiresUtc = moment().utc().add(response.expires_in, 'seconds');
            // get refresh token expiration date/time UTC stamp
            let refreshTokenExpires = response["as:refresh_token_expires"];

            if (!_tutorialCheckedTime) {
                _tutorialCheckedTime = localStorageService.get('tutorialCheckedTime');
            }

            _authData.token = response.access_token;
            _authData.token_expireSeconds = response.expires_in;
            _authData.token_expires = accessTokenExpiresUtc;
            _authData.adminConfigId = adminConfigId;
            _authData.isFramedIn = isFramedIn;
            _authData.requiresPasswordChange = response.requiresPasswordChange == 'true';

            _authData.userInfo = {};

            if (response.userId) {
                _authData.userInfo.userId = response.userId;
            }

            if (response.userName) {
                _authData.userInfo.username = response.userName;
            }

            if (response.fullName) {
                _authData.userInfo.fullName = response.fullName;
            }

            if (response.profileImageUrl) {
                _authData.userInfo.profileImageUrl = response.profileImageUrl;
            }

            if (response.title) {
                _authData.userInfo.title = response.title;
            }

            if (response.enableManageMySchedule.toLowerCase() === "true" || response.enableManageMySchedule === true) {
                permissions.setEnableManageMySchedule(true);
            } else {
                permissions.setEnableManageMySchedule(false);
            }

            permissions.setRoles(response.roles);
            permissions.setUserPermissions(response.userPermissions);
            permissions.setDealerPermissions(response.dealerPermissions);
            permissions.setPermissionsMarketingURLs(response.permissionMarketingURLs);
            permissions.setDisabledProductsToShowInNav(response.disabledProductsToShowInNav);

            if (useRefreshTokens && refreshTokenExpires) {
                // If refresh_token isn't supplied in the response, use existing refresh token
                _authData.refreshToken = response.refresh_token ? response.refresh_token : _authData.refreshToken;
                _authData.refreshToken_expires = refreshTokenExpires;
                _authData.useRefreshTokens = true;
            } else {
                _authData.refreshToken = null;
                _authData.refreshToken_expires = null;
                _authData.useRefreshTokens = false;
            }

            if (!_dashboardUpdateTimePromise) {
                _dashboardUpdateTimePromise = rcConfigService.getDashboardUpdatedTime();
            }
            
            _dashboardUpdateTimePromise.then((lastUpdatedTime) => {
                if (lastUpdatedTime && (!_tutorialCheckedTime || moment.utc(lastUpdatedTime).diff(_tutorialCheckedTime, 'minutes') > 0)) {
                    _tutorialCheckedTime = moment().utc();
                    localStorageService.set('tutorialCheckedTime', _tutorialCheckedTime);

                    userService.getUnseenTutorials().then((unseenTutorials) => {
                        _authData.userInfo.unseenTutorials = unseenTutorials;
                    });
                }
            }).finally(() => {
                _dashboardUpdateTimePromise = null;
            });

            localStorageService.set('authorizationData', _authData);
        }

        function cancelRefreshAccessTokenInterval() {
            // cancel any $interval for token refresh in the authService
            if (_refreshAccessTokenIntervalPromise) {
                let cancelResult = $interval.cancel(_refreshAccessTokenIntervalPromise);

                if (cancelResult) {
                    _refreshAccessTokenIntervalPromise = null;
                    _isCallbackBusy = false;
                    $log.debug('auth-service: refresh access token $interval has been cancelled');

                    return true;
                } else {

                    return false;
                }
            } else {
                return true;
            }
        }

        function startRefreshAccessTokenInterval(intervalSeconds) {
            if (_authData && _authData.refreshToken && cancelRefreshAccessTokenInterval()) {

                if (!intervalSeconds) {
                    intervalSeconds = 5;
                }

                $log.debug('auth-service: refresh access token $interval started. Interval: ' + intervalSeconds + ' second(s)');
                _refreshAccessTokenIntervalPromise = $interval(refreshAccessTokenCallback, intervalSeconds * 1000, 0, false);
            }
        }

        function isAllowedMessagesFramedIn() {
            return permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.frameIn_allowMessages);
        }

        function redirectToDefaultPage(configId) {
            function redirect() {
                let redirectPage = 'trip-list';

                if (permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.appointments)) {
                    redirectPage = 'appointment-list';
                } else if (permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.inspect)) {
                    redirectPage = 'inspect';
                } else if (permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.payments)) {
                    redirectPage = 'payments-list';
                } else if (permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.transportation)) {
                    redirectPage = 'trip-list';
                } else if (permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.messaging)) {
                    redirectPage = 'contact-list';
                } else if (permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.reports)) {
                    redirectPage = 'report-list';
                } 
                
                $state.go(redirectPage, {configId: configId});
           
            }

            let cachedMenuItem = localStorageService.get('selectedMenu');
            let embeddedProductName = localStorageService.get('selectedMenuProductName');

            if (cachedMenuItem && embeddedProductName !== null) {
                $state.go(cachedMenuItem, {configId: configId, fromCachedMenu: true, embeddedProduct: '1', productName: embeddedProductName});
            } else if (cachedMenuItem) {
                $state.go(cachedMenuItem, {configId: configId, fromCachedMenu: true});
            } else {
                this.isAuthenticated().then(() => {
                    redirect();
                }, () => {
                    $state.go('login', {configId: configId});
                });
            }
        }

        function handleLoginError(errorMessageReceived, vm) {
            if (errorMessageReceived.error === 'incorrect_adminconfig') {
                alert('Redirecting you to the proper site. Please update your bookmarks.');
                window.location = errorMessageReceived.error_description;
            } else if (errorMessageReceived.error === 'account_disabled') {
                vm.error.redirectLink = '';
                vm.error.message = '<b>Your account is disabled or is incomplete. Please contact support.</b>';
            } else {
                vm.error.redirectLink = '';
                vm.error.message = '<b>Incorrect email or password. Please try again.</b>';
            }
        }

        function configureMSAL(msalConfig, resolvedMsalConfig) {
            msalConfig.auth.clientId = resolvedMsalConfig.clientId;
            msalConfig.auth.authority = msalConfig.auth.authority.replaceAll("{tenant}", resolvedMsalConfig.tenant);
            msalConfig.auth.knownAuthorities = [AZUREBTC_POLICIES.authorityDomain.replaceAll("{tenant}", resolvedMsalConfig.tenant)];
        }
    }
})();

(function () {
    'use strict';

    authAzureService.$inject = ["$rootScope", "$q", "$log", "$state", "$http", "$interval", "toastr", "API_SETTINGS", "AZUREBTC_POLICIES", "SYSTEM_ENUMS", "consumerApi"];
    angular
        .module('redcap')
        .factory('authAzureService', authAzureService);

    function authAzureService($rootScope, $q, $log, $state, $http, $interval, toastr, API_SETTINGS, AZUREBTC_POLICIES, SYSTEM_ENUMS, consumerApi) {

        // Browser check variables
        // If you support IE, our recommendation is that you sign-in using Redirect APIs
        // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
        let serviceBase = API_SETTINGS.apiServiceBaseUri;
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ");
        const msie11 = ua.indexOf("Trident/");
        const msedge = ua.indexOf("Edge/");
        const isIE = msie > 0 || msie11 > 0;
        const isEdge = msedge > 0;
        const hash = window.location.hash;
        const isRedirect = hash.indexOf("id_token") > -1 || hash.indexOf("access_token") > -1 || hash.indexOf("error") > -1;
        let accountId = null;

        var msalConfig = {
            auth: {
                clientId: AZUREBTC_POLICIES.clientId, // "4f450601-8cc2-4565-badb-3b01280f86eb",
                authority: AZUREBTC_POLICIES.authorities.signUpSignIn.authority, // Choose hrdsignin as your default authority.
                knownAuthorities: [AZUREBTC_POLICIES.authorityDomain], // Mark your B2C tenant's domain as trusted.
                navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
                redirectUri: "/handleLogin", // This is the base URL of your application. It is used to redirect back after authentication.
            },
            cache: {
                cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure.
                storeAuthStateInCookie: false, // set this to true if you have to support IE
            },
            system: {
                loggerOptions: {
                    loggerCallback: (level, message, containsPii) => {
                        if (containsPii) {
                            return;
                        }
                        switch (level) {
                            case msal.LogLevel.Error:
                                console.error(message);
                                return;
                            case msal.LogLevel.Info:
                                console.info(message);
                                return;
                            case msal.LogLevel.Verbose:
                                console.debug(message);
                                return;
                            case msal.LogLevel.Warning:
                                console.warn(message);
                                return;
                        }
                    },
                },
            },
        };

        const loginRequest = {
            scopes: ["openid"]
        };


        function signOut () {

            getSolidConfig().then((resolvedMsalConfig) => {
                msalConfig.auth.clientId = resolvedMsalConfig.clientId;
                msalConfig.auth.authority = msalConfig.auth.authority.replaceAll("{tenant}", resolvedMsalConfig.tenant);
                msalConfig.auth.knownAuthorities = [AZUREBTC_POLICIES.authorityDomain.replaceAll("{tenant}", resolvedMsalConfig.tenant)];
                
                const myMSALObj = new msal.PublicClientApplication(msalConfig);
                
                myMSALObj.initialize().then(() => {

                const currentAccounts = myMSALObj.getAllAccounts();
                if (currentAccounts.length > 1) {
                    // Add choose account code here
                } else if (currentAccounts.length === 1) {
                    let account = currentAccounts[0];
                    myMSALObj.logout(account);
                }
                    
                });
            });
        }
        
        function validateUserIsMigrated(username, hideToastr) {
            $log.debug('auth-service:  ValidateUserIsMigrated(): ', username);
            return consumerApi.post(serviceBase + 'public/solid/ValidateUserIsMigrated', { username: username }, null, hideToastr);
        }

        function startMigration(username, url) {
            $log.debug('auth-service:  startMigration(): ', username);
            return consumerApi.post(serviceBase + 'public/solid/startMigration', { username: username, url: url });
        }

        function getSolidConfig() {
            return consumerApi.get(serviceBase + 'public/solid/GetSolidConfig');
        }

        return {
            msalConfig: msalConfig,
            loginRequest: loginRequest,
            validateUserIsMigrated: validateUserIsMigrated,
            startMigration: startMigration,
            signOut: signOut,
            getSolidConfig: getSolidConfig,
        };

    }
})();     

(function () {
    'use strict';

    angular.module('redcap.auth', []);
})();


(function () {
    'use strict';

    PrivacyPolicyController.$inject = ["rcUtilService"];
    angular
        .module('redcap.auth')
        .controller('PrivacyPolicyController', PrivacyPolicyController);

    function PrivacyPolicyController(rcUtilService) {
        let vm = this;
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.auth')
        .controller('AccessDeniedController', AccessDeniedController);

    function AccessDeniedController() {
        var vm = this;
    }
})();

(function () {
    'use strict';

    NewUserController.$inject = ["$log", "$scope", "$location", "$state", "toastr", "enrollmentValidationService", "userService", "resolvedConfig", "resolvedUser", "SYSTEM_ENUMS"];
    angular
        .module('redcap.auth')
        .controller('NewUserController', NewUserController);

    function NewUserController($log, $scope, $location, $state, toastr, enrollmentValidationService, userService, resolvedConfig, resolvedUser, SYSTEM_ENUMS) {
        let vm = this;

        vm.user = resolvedUser;
        vm.message = '';
        vm.profileImageUpload = '';
        vm.profileImage = '';
        vm.solidMigrationStatus = SYSTEM_ENUMS.solidMigrationStatus;

        vm.validation = {
            password: function(password) {
                $scope.$broadcast('angularValidation.revalidate', 'confirmPassword');

                return enrollmentValidationService.validatePassword(password);
            },
            phone: function (fieldValue) {
                fieldValue = fieldValue.replace(/\D/g, '');

                return {isValid: fieldValue.length === 10, message: 'Field is required.'};
            },
            passwordConfirmation: function (password, confirmation) {
                return {isValid: password === confirmation, message: 'Password confirmation does not match.'};
            },
            profileImage: function () {
                vm.message = '';
                angular.element(document.querySelector('#fileInput')).click();
            }
        };

        vm.confirm = function(invalid) {
            if (invalid) return;
            
            if (vm.profileImageUpload.length === 0) {
                vm.message = 'Profile Picture is required.';

                return;
            }

            vm.message = '';
            vm.user.profilePicture = vm.profileImage;
            $log.debug(vm.user);
            
            userService.confirmOnboarding(vm.user)
                .then((result) => {
                    if (result) 
                        $state.go('new-user-complete', {configId: resolvedConfig.id, guid: vm.user.id});
                    else 
                        toastr.error('Something went wrong while confirming your account. Please contact your program team.');    
                }, (errorMessage) => {
                    toastr.error(errorMessage);
                });
        };
    }
})();

(function () {
    'use strict';

    NewUserCompleteController.$inject = ["$log", "$scope", "$location", "$state", "resolvedConfig"];
    angular
        .module('redcap.auth')
        .controller('NewUserCompleteController', NewUserCompleteController);

    function NewUserCompleteController($log, $scope, $location, $state, resolvedConfig) {
        var vm = this;

        vm.complete = function () {
            window.location = "http://" + resolvedConfig.url;
        };
    }
})();

(function () {
    'use strict';

    MobileAppDownloadController.$inject = ["$log", "$state", "$scope", "SYSTEM_VARIABLES", "resolvedConfig", "detectUtils"];
    angular
        .module('redcap.auth')
        .controller('MobileAppDownloadController', MobileAppDownloadController);

    function MobileAppDownloadController($log, $state, $scope, SYSTEM_VARIABLES, resolvedConfig, detectUtils) {
        var vm = this;

        vm.mobileNavCollapsed = true;
        vm.config = resolvedConfig;
        
        vm.iosAppLink = SYSTEM_VARIABLES.iosAppLink;
        vm.androidAppLink = SYSTEM_VARIABLES.androidAppLink;

        if (detectUtils.isIOS())
            window.location = vm.iosAppLink;
        
        if (detectUtils.isAndroid())
            window.location = vm.androidAppLink;
    }
})();

(function () {
    'use strict';

    LoginController.$inject = ["$timeout", "$state", "modalService", "authService", "authAzureService", "localStorageService", "configId", "referrer", "referrerQS", "SYSTEM_ENUMS", "resolvedMsalConfig"];
    angular
        .module('redcap.auth')
        .controller('LoginController', LoginController);

    function LoginController($timeout, $state, modalService, authService, authAzureService, localStorageService, configId, referrer, referrerQS, SYSTEM_ENUMS, resolvedMsalConfig) {
        let vm = this;
        let username = localStorageService.get('username') || '';

        vm.solidMigrationStatus = SYSTEM_ENUMS.solidMigrationStatus;
        vm.accountStatus = null;
        vm.migrateToSolidDate = null;
        vm.migrateDaysLeft = null;
        vm.showIcons = false;
        vm.error = authService.authError;
        vm.loginData = authService.initializeLoginData(username, configId);
        vm.showPassword = false;
        vm.showLoginFields = false;
        vm.isUsernameReadonly = true;

        vm.toggleShowPassword = function() {
            vm.showPassword = !vm.showPassword;
        };

        vm.enableUsernameInput = function() {
            vm.isUsernameReadonly = false;
        };

        function displayMaterialIcons () {
            $timeout(() => {
                vm.showIcons = true;
            }, 750);
        }

        vm.login = function () {
            vm.isDataLoading = true;
            authService.login(vm.loginData).then((response) => {
                vm.error.message = '';

                if (vm.loginData.rememberToggle) {
                    localStorageService.set('username', authService.getCurrentUser().username);
                } else {
                    localStorageService.remove('username');
                }

                // **** redirect sections ***** //
                if (response.vanityUrl) {
                    window.location = response.vanityUrl;

                    return;
                } else if (response.requiresPasswordChange) {
                    $state.go('changepasswordForced', {configId: configId});
                } else if (referrer) {
                    window.location = referrer + referrerQS;

                    return;
                } else {
                    authService.redirectToDefaultPage(configId);
                }
            }).catch((errorMessage) => {
                authService.handleLoginError(errorMessage, vm);
            }).finally(() => {
                vm.isDataLoading = false;
            });
                
        };

        vm.validateUserIsMigrated = function () {
            vm.isDataLoading = true;

            if (vm.loginData) {
                authAzureService.validateUserIsMigrated(vm.loginData.userName, true).then(async (response) => {
                    vm.error.message = '';
                    vm.accountStatus = response.accountStatus;
                    vm.showLoginFields = vm.accountStatus === vm.solidMigrationStatus.notStarted || vm.accountStatus === vm.solidMigrationStatus.dealerSolidMFADisabled;
                    vm.migrateToSolidDate = moment.utc(response.migrateToSolidDate).local().toDate();
                    vm.migrateDaysLeft = moment(vm.migrateToSolidDate).diff(moment(), 'days');
                    displayMaterialIcons();

                    if (vm.accountStatus == vm.solidMigrationStatus.completed) {
                        await vm.redirectToLogin();
                    }
                }).catch((error) => {
                    vm.error.message = 'There was a problem locating your account.';
                }).finally(() => {
                    vm.isDataLoading = false;
                });
            }
        };

        vm.startMigration = function () {
            vm.isDataLoading = true;

            if (vm.loginData) {
                authAzureService.startMigration(vm.loginData.userName, window.location.href.replace(window.location.pathname, '')).then(async (response) => {
                    if (response) {
                        if (response.solidMigrationStatus === vm.solidMigrationStatus.userExists) {
                            await vm.redirectToLogin();
                        } else {
                            localStorageService.set('RedcapProgramId', configId);
                            window.location.href = response.url;
                        }
                    } else {
                        vm.error.message = 'Migration failed. Please try again later.';
                    }
                }).catch((error) => {
                    vm.error.message = 'An error occurred during migration: ' + error.message;
                }).finally(() => {
                    vm.isDataLoading = false;
                });
            }
        };

        vm.skipMigration = function () {
            let confirm = modalService.showYesNo('MFA', 'You are strongly encouraged to set up MFA as early as possible. Once the deadline has passed you will not be able to access the system until setup has been completed.<br><br>Are you sure you want to skip MFA setup?', 'Cancel', 'Yes');
            
            confirm.then((confirmed) => {
                if (confirmed) {
                    vm.showLoginFields = true;
                    displayMaterialIcons();
                }

                return;
            });
        };

        //SOLID IMPLEMENTATION
        let msalConfig = authAzureService.msalConfig;

        authService.configureMSAL(msalConfig, resolvedMsalConfig);

        const myMSALObj = new msal.PublicClientApplication(msalConfig);

        myMSALObj.initialize();

        vm.redirectToLogin = async function () {
            console.log("Redirecting to login with SOLID");
            sessionStorage.removeItem('msal.interaction.status');
            localStorageService.set('RedcapProgramId', configId);

            if (referrer) {
                localStorageService.set('postLoginRedirect', referrer + (referrerQS || ''));
            }

            let requestParameters = {...authAzureService.loginRequest, extraQueryParameters: {
                login_hint: encodeURIComponent(vm.loginData.userName)
            }};

            await myMSALObj.loginRedirect(requestParameters);
        };
    }
})();

(function () {
    'use strict';

    ForgotPasswordController.$inject = ["$state", "userService", "toastr", "resolvedConfig", "modalService"];
    angular
        .module('redcap.auth')
        .controller('ForgotPasswordController', ForgotPasswordController);

    function ForgotPasswordController($state, userService, toastr, resolvedConfig, modalService) {
        let vm = this;
     
        vm.method = "email";
       
        
        vm.back = function () {
            $state.go('login', {configId: resolvedConfig.id});
        };
       
        function successModal(msg) {
            modalService.showYesNo('Sent', msg, null, 'Ok')
            .then(() => {
                $state.go('login', {configId: resolvedConfig.id});
            });
        }

        vm.send = function () {
         
            if (vm.method === "email") {
                userService.emailTempPassword(vm.emailAddress).then((response) => {
                }).finally((err) => {
                    successModal('A password reset message will be sent to the email address on file if we have an active account matching that User ID.');
                });
            } else {
                userService.textTempPassword(vm.emailAddress).then((response) => {
                }).finally((err) => {
                    successModal('A password reset message will be sent to phone number on file if we have an active account matching that User ID.');
                });
            }
        };
        
    }
})();

(function () {
    'use strict';

    ForgotEmailController.$inject = ["$state", "userService", "toastr", "resolvedConfig", "modalService"];
    angular
        .module('redcap.auth')
        .controller('ForgotEmailController', ForgotEmailController);

    function ForgotEmailController($state, userService, toastr, resolvedConfig, modalService) {
        var vm = this;
        
        vm.validation = {
            phone: function (fieldValue) {
                fieldValue = fieldValue.replace(/\D/g,'');
                var isValid = fieldValue.length === 10;
                return { isValid: isValid, message: !isValid ? ' ' : 'Field is required.' };
            }
        };
        
        vm.back = function () {
            $state.go('login', { configId: resolvedConfig.id });
        };
        
        vm.send = function () {
            
            userService.forgotUserName(vm.mobilePhone).then(function (response) {
                if (!response.message) {
                    modalService.showYesNo('Sent', 'Your registered email address has been texted to your mobile phone.', null, 'Ok')
                        .then(function() {
                            $state.go('login', { configId: resolvedConfig.id });
                        });
                } else {
                    toastr.error(response.message);
                } 
            });
            
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.auth')
        .controller('AccessDeniedController', AccessDeniedController);

    function AccessDeniedController() {
        var vm = this;
    }
})();

(function () {
    'use strict';

    webworkerService.$inject = ["$q", "$log", "Webworker"];
    angular
        .module('redcap')
        .factory('webworkerService', webworkerService);

    function webworkerService ($q, $log, Webworker) {

        return {
            filter: filterWorker 
        };

        function filterWorker (array, search, perfectMatch, param) {
            var worker = new Webworker.create(filterFunc, { async: true });
            return worker.run(array, search, perfectMatch, param);
        }

        function filterFunc (array, search, perfectMatch, param) {
            var searchVal = perfectMatch ? search : search.toLowerCase();

            filterList(array);

            function fullSearch (arr) {
                var tempList = [];
                arr.forEach(function (obj) {
                    for (var prop in obj) {
                        if (perfectMatch && obj[prop] === searchVal) {
                            tempList.push(obj);
                            break;
                        } else if (obj[prop].toLowerCase().indexOf(searchVal) > -1) {
                            tempList.push(obj);
                            break;
                        }
                    }
                });

                return tempList;
            }

            function filterList (arr) {
                var matchArr = [];

                if (param && perfectMatch)
                    matchArr = arr.filter(function (e) { return e[param] === searchVal; });
                else if (param)
                    matchArr = arr.filter(function (e) { return e[param].toLowerCase().indexOf(searchVal) > -1; });
                else
                    matchArr = fullSearch(arr);
                
                complete(matchArr);
            }    
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('redcap.services')
        .factory('vinScanService', vinScanService);

    function vinScanService() {
        let scanner = null;              // Dynamsoft.CVR.CaptureVisionRouter
        let cameraView = null;           // Dynamsoft.DCE.CameraView
        let cameraEnhancer = null;       // Dynamsoft.DCE.CameraEnhancer
        let loading = false;

        return {
            showVinScanner,
            destroyScannerInstance,
            isLoading: function () { return loading; }
        };

        function showVinScanner(containerElement) {
            return new Promise(async (resolve, reject) => {
                try {
                    const router = await getScannerInstance();
                    await ensureCameraAttached(containerElement);

                    // Create a fresh receiver each time
                    const resultReceiver = new Dynamsoft.CVR.CapturedResultReceiver();
                    let done = false;
                    resultReceiver.onDecodedBarcodesReceived = async (result) => {
                        if (done) return; // prevent multiple fires
                        done = true;

                        try { await router.stopCapturing(); } catch (_) { }
                        try { await cameraEnhancer.close(); } catch (_) { }
                        try { router.removeResultReceiver(resultReceiver); } catch (_) { }

                        const vin = extractVINFromCapturedResult(result);

                        if (!vin) {
                            return reject(new Error('No valid VIN found. Please try again.'));
                        }
                        resolve(vin);
                    };
                    router.addResultReceiver(resultReceiver);

                    // Open camera & start pipeline
                    await cameraEnhancer.open();
                    await router.startCapturing("ReadSingleBarcode");
                } catch (ex) {
                    console.log('VIN scan error:', ex);
                    reject(ex);
                }
            });
        }

        async function destroyScannerInstance() {
            try {
                if (scanner) {
                    try { await scanner.stopCapturing(); } catch (_) { }
                }
                if (cameraEnhancer) {
                    try { await cameraEnhancer.close(); } catch (_) { }
                }
                // Dispose in reverse order of creation
                try { if (scanner) await scanner.dispose(); } catch (_) { }
                try { if (cameraEnhancer) await cameraEnhancer.dispose(); } catch (_) { }
                try { if (cameraView) await cameraView.dispose(); } catch (_) { }

                scanner = null;
                cameraEnhancer = null;
                cameraView = null;
            } catch (_) {
                // swallow – best-effort cleanup
            }
        }

        async function getScannerInstance() {
            if (scanner) return scanner;

            loading = true;
            try {
                scanner = await Dynamsoft.CVR.CaptureVisionRouter.createInstance();

                // Configure: your formats for VINs
                const settings = await scanner.getSimplifiedSettings("ReadSingleBarcode");
                settings.barcodeSettings.barcodeFormatIds =
                    Dynamsoft.DBR.EnumBarcodeFormat.BF_CODE_39 |
                    Dynamsoft.DBR.EnumBarcodeFormat.BF_QR_CODE |
                    Dynamsoft.DBR.EnumBarcodeFormat.BF_DATAMATRIX;
                await scanner.updateSettings("ReadSingleBarcode", settings);

                // Reduce duplicate firing
                if (scanner.getRuntimeSettings) {
                    const rs = await scanner.getRuntimeSettings();
                    rs.expectedBarcodesCount = 1;
                    rs.duplicateFilter = 1000; // ms
                    await scanner.updateRuntimeSettings(rs);
                }

                return scanner;
            } finally {
                loading = false;
            }
        }

        async function ensureCameraAttached(containerElement) {
            if (!cameraView) {
                cameraView = await Dynamsoft.DCE.CameraView.createInstance();
            }
            if (!cameraEnhancer) {
                cameraEnhancer = await Dynamsoft.DCE.CameraEnhancer.createInstance(cameraView);
            }

            // Mount the UI into container
            if (containerElement) {
                await cameraView.setUIElement(containerElement);
            }

            // Wire the enhancer as the router’s image source
            if (scanner) {
                await scanner.setInput(cameraEnhancer);
            }
        }

        // Turn the CVR result into a string we can VIN-parse
        function extractVINFromCapturedResult(capturedResult) {
            if (!capturedResult) return null;

            // CVR v11 gives you decoded barcodes array. Grab the first text.
            // Fallbacks are just safety nets.
            let text = null;
            try {
                const barcodes = capturedResult.barcodeResultItems || capturedResult.barcodeResults || [];
                if (barcodes.length > 0) {
                    text = barcodes[0].text || barcodes[0].barcodeText || null;
                }
            } catch (_) { }

            return extractVIN(text);
        }

        function extractVIN(vinString) {
            if (!vinString) return null;

            const commaIndex = vinString.indexOf(',');
            if (commaIndex !== -1) {
                // remove extra data of QR codes
                vinString = vinString.substring(0, commaIndex);
            }

            // Extract 17-char VIN
            const vinRegex = /[A-HJ-NPR-Z0-9]{17}/i;
            const match = vinString.match(vinRegex);
            return match ? match[0] : null;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("redcap")
        .factory("timeUtilService", timeUtilService);

    function timeUtilService() {
        let _hourIntervalsInDay = generateTimeIntervals();
        let _days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        let _shortDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        let _months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        return {
            hourIntervalsInDay: _hourIntervalsInDay,
            days: _days,
            shortDays: _shortDays,
            months: _months,
            toTimeFormat: toTimeFormat,
            toLocalTimeFormat: toLocalTimeFormat,
            toSpecificTimeFormat: toSpecificTimeFormat,
            validateEndTimeGreaterThanStartTime: validateEndTimeGreaterThanStartTime,
            validateTimesDoNotOverlap: validateTimesDoNotOverlap,
            filterAvailableHours: filterAvailableHours,
            createHoursDropdown: createHoursDropdown,
            getTotalMinutes: getTotalMinutes

        };

        function toTimeFormat(timeSpanString) {
            let found = _.findIndex(_hourIntervalsInDay, (o) => { return o.value === timeSpanString; });

            if (found > -1) {
                return _hourIntervalsInDay[found].label;
            } else {
                return 'N/A';
            }
        }

        function toLocalTimeFormat(momentUtcTime, format) {
            return moment.utc(momentUtcTime).local().format(format);
        }

        function toSpecificTimeFormat(momentUtcTime, timeZoneId, format) {
            return moment.tz(momentUtcTime, timeZoneId).format(format);
        }

        function generateTimeIntervals(interval) {
            let hoursInDay = [];

            // Default interval to 30 minutes
            if (!interval) {
                interval = 30;
            }

            // 30 minute increments in a 24 hour day = 48 slots
            let time = ''; let hour; let value; let suffix;

            for (let i = 0; i < 48; i++) {
                hour = Math.floor(i / 2);
                value = hour;
                hour = hour > 12 ? hour - 12 : hour;
                suffix = i >= 24 ? ' PM' : ' AM';
                time = (hour === 0 ? '12' : hour.toString()) + ':' + (i % 2 === 0 ? '00' : '30') + suffix;

                if (value < 10) {
                    value = '0' + value.toString();
                }

                value = value + ':' + (i % 2 === 0 ? '00' : '30') + ':00';
                hoursInDay.push({
                    label: time,
                    value: value
                });
            }

            return hoursInDay;
        }

        function validateEndTimeGreaterThanStartTime(startTime, endTime, otherField) {
            if (endTime && startTime) {
                let startIndex = _.findIndex(_hourIntervalsInDay, (o) => { return o.value === startTime; });
                let endIndex = _.findIndex(_hourIntervalsInDay, (o) => { return o.value === endTime; });

                if (endIndex > startIndex) {
                    return true;
                } else {
                    let placement = otherField === 'End Time' ? 'before' : 'after';

                    return {isValid: false, message: '- must be ' + placement + ' ' + otherField};
                }
            }

            return false;
        }

        function validateTimesDoNotOverlap(times) {
            let valid = true; let lastEndIndex;

            _.forEach(times, (time) => {
                // If start and end time is null, the time frame is all day.
                // Overlaps still need to be accounted for in this scenario - so for simplicity's sake in the validation logic
                // set the start and end time to the first and last hour interval of the day
                if (!time.startTime && !time.endTime) {
                    time.startTime = _hourIntervalsInDay[0].value;
                    time.endTime = _hourIntervalsInDay[_hourIntervalsInDay.length - 1].value;
                }

                time.startTimeIndex = _.findIndex(_hourIntervalsInDay, (o) => { return o.value === time.startTime; });
                time.endTimeIndex = _.findIndex(_hourIntervalsInDay, (o) => { return o.value === time.endTime; });
            });
            times.sort((a, b) => { return a.startTimeIndex - b.startTimeIndex; });

            for (let i = 0; i < times.length; i++) {
                if (lastEndIndex) {
                    // Is the current start time in the previous range?
                    if (times[i].startTimeIndex < lastEndIndex.index && (times[i].userLimitType === lastEndIndex.userLimitType || times[i].userLimitType === 'all')) {
                        valid = false;
                        break;
                    }
                }

                lastEndIndex = {index: times[i].endTimeIndex, userLimitType: times[i].userLimitType};
            }

            return valid;
        }

        function filterAvailableHours(value, index, array) {
            // `this` has been supplanted by the context of the referencing controller in the `apply` invocation
            let startTime = this.startTime; let startIndex = 0;

            if (startTime) {
                startIndex = _.findIndex(_hourIntervalsInDay, (o) => { return o.value === startTime; });
            }

            return index > startIndex;
        }

        function createHoursDropdown(interval) {
            let hoursData = [];

            for (let totalMinutes = 0; totalMinutes < 24 * 60; totalMinutes += interval) { // count minutes up until midnight next day
                let hours = Math.floor(totalMinutes / 60);
                let minutes = totalMinutes % 60;
                let ampm = hours >= 12 ? 'PM' : 'AM';
                let ampmHours = hours > 12 ? hours - 12 : hours < 1 ? 12 : hours;

                hoursData.push({
                    minutesFromMidnight: totalMinutes,
                    militaryHours: (hours < 10 ? '0' + hours : hours) + ':' + (minutes === 0 ? '00' : minutes),
                    ampmHours: (ampmHours < 10 ? '0' + ampmHours : ampmHours) + ':' + (minutes === 0 ? '00' : minutes) + ' ' + ampm
                });
            }

            return hoursData;
        }

        function getTotalMinutes (time) {
            // Input time format is HH:mm:ss
            let timeParts = time.split(':');
            let hours = parseInt(timeParts[0], 10);
            let minutes = parseInt(timeParts[1], 10);
            let seconds = parseInt(timeParts[2], 10);

            // Calculate total minutes
            let totalMinutes = (hours * 60) + minutes + (seconds / 60);

            return totalMinutes;
        }
    }

})();

(function () {
    'use strict';

    systemService.$inject = ["rcApi", "SAVED_SEARCHES_PLACEHOLDER", "rcLocalStorageService"];
    angular
        .module('redcap')
        .factory('systemService', systemService);

    function systemService(rcApi, SAVED_SEARCHES_PLACEHOLDER, rcLocalStorageService) {
        let SYSTEM_BASEPATH = 'system/';

        return {
            getUnreadNotificationCount: getUnreadNotificationCount,
            getAdminConfigOverrides: getAdminConfigOverrides,
            saveSearchTemplate: saveSearchTemplate,
            getSearchTemplates: getSearchTemplates,
            deleteSearchTemplate: deleteSearchTemplate,
            getLastSearchTemplate: getLastSearchTemplate,
            findLastSearchTemplateInCollection: findLastSearchTemplateInCollection
        };

        function getUnreadNotificationCount() {
            return rcApi.get(SYSTEM_BASEPATH + 'notifications/unread');
        }

        function getAdminConfigOverrides(adminConfigId) {
            return rcApi.get(SYSTEM_BASEPATH + 'config/' + adminConfigId + '/overrides');
        }

        function saveSearchTemplate(template, templateId, isGlobal, templateType) {
            let path = SYSTEM_BASEPATH + 'searchtemplates';

            return rcApi.post(path, {template: template, templateId: templateId, isGlobal: isGlobal, templatetype: templateType});
        }

        function getSearchTemplates(templateType) {
            return rcApi.get(SYSTEM_BASEPATH + 'searchtemplates', {templateType: templateType}).then((templates) => {
                return templates;
            });
        }

        function deleteSearchTemplate(templateId) {
            return rcApi.remove(SYSTEM_BASEPATH + 'searchtemplates/' + templateId);
        }

        function getLastSearchTemplate (templateKey) {
            return rcLocalStorageService.get(templateKey) || null;
        }

        function findLastSearchTemplateInCollection(lastSearchTemplate, collectionToSearch) {
            return _.find(collectionToSearch, (item) => { return item.template.templateName === lastSearchTemplate.template.templateName; });
        }
    }
})();

(function () {
    'use strict';

    signalRService.$inject = ["$q", "$log", "$window", "$rootScope", "$timeout", "toastr", "localStorageService", "API_SETTINGS"];
    angular
        .module('redcap.services')
        .factory('signalRService', signalRService);

    function signalRService($q, $log, $window, $rootScope, $timeout, toastr, localStorageService, API_SETTINGS) {
        let BASEPATH = API_SETTINGS.apiServiceBaseUri;

            BASEPATH = BASEPATH.substring(0, BASEPATH.length - 1);
        let retryAttempt = 0;

        let HUB = {
            Trips: 'tripHub',
            TripCommunications: 'tripCommunicationsHub',
            ContactMessages: 'contactMessagesHub',
            Contacts: 'contactsHub',
            System: 'systemMessagesHub',
            DriverTrackingHub: 'driverTrackingHub',
            CampaignBatchHub: 'campaignBatchHub',
            ConsumerLoanerHub: 'consumerLoanerHub',
            InspectionMediaHub: 'inspectionMediaHub'
        };

        return {
            registerConsumerLoanerListener: consumerLoanerListener,
            registerTripsListener: tripsListener,
            registerTripCommunicationsListener: tripCommunicationsListener,
            registerContactMessagesListener: contactMessagesListener,
            registerContactsListener: contactsListener,
            registerSystemListener: systemListener,
            registerDriverTrackingListener: driverTrackingListener,
            registerCampaignBatchListener: campaignBatchListener,
            registerInspectionMediaListener: inspectionMediaListener,
            registerVehicleOverviewMediaListener: vehicleOverviewMediaListener,
            events: {           // some constant strings for the registered broadcast that server will call
                trips: {
                    broadcastTripUpdated: 'broadcastTripUpdated',
                    updateType: {
                        healthChange: 1,
                        modelChange: 2,
                        stateChange: 3,
                        driverChange: 4
                    }
                },
                tripCommunications: {
                    broadcastMessageReceived: 'broadcastMessageReceived'
                },
                loaner: {
                    broadcastTsdMessageReceived: 'broadcastTsdMessageReceived'
                },
                contactMessages: {
                    broadcastMessageReceived: 'broadcastMessageReceived'
                },
                drivers: {
                    broadcastDriverLocation: 'broadcastDriverLocation'
                },
                contacts: {
                    broadcastContactUpdate: 'broadcastContactUpdate'
                },
                system: {
                    broadcastNewMessage: 'broadcastNewMessage',
                    broadcastFailedMessage: 'broadcastFailedMessage',
                    broadcastNotificationCount: 'broadcastNotificationCount',
                    broadcastInternalNotificationCount: 'broadcastInternalNotificationCount'
                },
                driverTracking: {
                    driverPositionChanged: 'driverPositionChanged',
                    tripStateChanged: 'tripStateChanged',
                    driverLocationOnlyChanged: 'driverLocationOnlyChanged'
                },
                campaignBatch: {
                    broadcastCampaignBatchUpdate: 'broadcastCampaignBatchUpdate'
                },
                inspectionMedia: {
                    broadcastMediaUploaded: 'broadcastMediaUploaded',
                    broadcastMediaDeleted: 'broadcastMediaDeleted'
                },
                vehicleOverviewMedia: {
                    broadcastMediaUploaded: 'broadcastMediaUploaded',
                    broadcastMediaDeleted: 'broadcastMediaDeleted'
                }
            }
        };

        function consumerLoanerListener(externalCustomerId) {
            return new Hub(HUB.ConsumerLoanerHub, externalCustomerId);
        }

        function tripsListener(tripId) {
            return new Hub(HUB.Trips, tripId);
        }

        function tripCommunicationsListener(tripId) {
            return new Hub(HUB.TripCommunications, tripId);
        }

        function contactMessagesListener(contactId) {
            return new Hub(HUB.ContactMessages, contactId);
        }

        function contactsListener(contactId) {
            return new Hub(HUB.Contacts, contactId);
        }

        function systemListener() {
            return new Hub(HUB.System);
        }

        function driverTrackingListener(tripId) {
            return new Hub(HUB.DriverTrackingHub, tripId);
        }

        function campaignBatchListener(campaignId) {
            return new Hub(HUB.CampaignBatchHub, campaignId);
        }

        function inspectionMediaListener(lineItemId) {
            return new Hub(HUB.InspectionMediaHub, lineItemId);
        }

        function vehicleOverviewMediaListener(roId) {
            return new Hub(HUB.InspectionMediaHub, roId); //Need to check whether we need to create a new hub for vehicle overview media or not. For now, using the same hub as inspection media.
        }

        // private functions
        function Hub(hubName, entityId) {
            let proxy = init(hubName, entityId);
            let allowReconnect = true;

            // detach when the window is closed.
            $window.onbeforeunload = disconnect;

            return {
                on: function (eventName, callback) {
                    proxy.on(eventName, (result) => {
                        $rootScope.$apply(() => {
                            if (callback) {
                                callback(result);
                            }
                        });
                    });

                    return this;
                },
                invoke: function (methodName, callback) {
                    proxy.invoke(methodName).done((result) => {
                            $rootScope.$apply(() => {
                                if (callback) {
                                    callback(result);
                                }
                        });
                    });

                    return this;
                },
                alterGroupItems: function (itemToRemove, itemToAdd, callback) {
                    proxy.invoke('SwitchGroups', itemToRemove, itemToAdd).done((result) => {
                            $rootScope.$apply(() => {
                                if (callback) {
                                    callback(result);
                                }
                        });
                    });

                    return this;
                },
                start: function () {
                    if (!proxy.hasSubscriptions())
                        throw 'Listener started with no subscriptions. "on()" method must be called first with callbacks';

                    startConnection();
                },
                disconnect: disconnect
            };

            function startConnection() {
                let start = function () {
                    proxy.connection.start()
                        .done((data) => {
                            $log.debug('connected to hub. ConnectionId: ' + proxy.connection.id);
                            retryAttempt = 0;
                        })
                        .fail((ex) => {
                            $log.debug('connection to hub failed: ' + ex.message);
                        });
                };

                start();
                proxy.connection.reconnecting(() => {
                    proxy.connection.stop();
                    $timeout(start, 5000);
                });
            }

            function disconnect() {
                allowReconnect = false;

                if (proxy.connection && proxy.connection.state && proxy.connection.state !== 4)
                    proxy.connection.stop();
            }

            function init(hubName, entityId) {
                let authData            = localStorageService.get('authorizationData');
                let connection          = $.hubConnection(BASEPATH);

                    connection.logging  = true;
                    connection.jsonp    = true;

                if (entityId) {
                    connection.qs       = {
                        'access_token': authData && authData.token,
                        'entityId': entityId
                    };
                } else {
                    connection.qs = {'access_token': authData && authData.token};
                }

                connection.disconnected(() => {
                    if (allowReconnect)
                        $timeout(startConnection, 10000);
                });
                connection.error((error) => {
                    console.log('Attempt ' + retryAttempt + ' on ' + hubName + ' - ' + error);

                    if (retryAttempt >= 5) {
                        disconnect();
                    }

                    authData                    = localStorageService.get('authorizationData');
                    connection.qs.access_token  = authData && authData.token;
                    retryAttempt++;
                });

                let proxy = connection.createHubProxy(hubName);

                return proxy;
            }
        }

    }

})();

(function () {
    "use strict";

    searchTemplateUtilService.$inject = ["$timeout", "$filter", "systemService", "modalService"];
    angular
        .module("redcap")
        .factory("searchTemplateUtilService", searchTemplateUtilService);

    function searchTemplateUtilService($timeout, $filter, systemService, modalService) {
        return {
            deleteSearchTemplateClicked: deleteSearchTemplateClicked,
            saveSearchTemplateClicked: saveSearchTemplateClicked,
            clearSearchTemplate: clearSearchTemplate,
            initSearchTemplateData: initSearchTemplateData,
            displaySaveBtn: displaySaveBtn,
            displaySaveAsBtn: displaySaveAsBtn,
            enableSaveBtns: enableSaveBtns,
            advancedFilterModalClosed: advancedFilterModalClosed
        };

        function clearTemplateMessage (listController) {
            // clear the message after user can see it 
            $timeout(() => {
                listController.templateMessage = null;
            }, 7000);
        }

        //
        // listController is the vm controller of the list page with saved searches displayed
        // clearSearchCriteria, clearSearchTemplate should exist on each list page that has
        // saved searches
        // 
        function deleteSearchTemplateClicked(listController) {
            listController.showAdvancedSearch = false;
            let confirm = modalService.showYesNo('Delete Search Template?', 'Are you sure you want to delete this Search Template?  This action cannot be undone.', 'No', 'Yes', true);

            confirm.then((confirmed) => {
                if (confirmed) {
                    listController.searchTemplateData.isProcessingTemplate = true;
                    let templateId = listController.searchTemplateData.currentSearchTemplate.id;

                    systemService.deleteSearchTemplate(templateId).then((success) => {
                        listController.searchTemplateData.isProcessingTemplate = false;

                        if (success) {
                            listController.templateMessage = 'Search successfully deleted.';
                            clearTemplateMessage(listController);
                            _.remove(listController.searchTemplateData.searchTemplates, (template) => {
                                return template.id === templateId;
                            });

                            listController.searchTemplateData.savedSearchName = null;
                            listController.clearSearchCriteria();
                            clearSearchTemplate(listController);
                            
                        } else {
                            listController.templateMessage = 'Error deleting saved search. Please try again.';
                            clearTemplateMessage(listController);
                        }

                        listController.showAdvancedSearch = true;
                    }, (err) => {
                        listController.searchTemplateData.isProcessingTemplate = false;
                        listController.templateMessage = 'An error occurred deleting the search.';
                        clearTemplateMessage(listController);
                        listController.showAdvancedSearch = true;
                    });
                }
            });
        }

        function saveSearchTemplateClicked(listController, template, templateType) {
            return new Promise((resolve, reject) => {
                listController.searchTemplateData.isProcessingTemplate = true;
                let existingTemplateId = listController.searchTemplateData.currentSearchTemplate ? listController.searchTemplateData.currentSearchTemplate.id : null;

                systemService.saveSearchTemplate(template, existingTemplateId, listController.isGlobalTemplate, templateType).then((savedTemplate) => {
                    listController.templateMessage = 'Search saved successfully.';
                    clearTemplateMessage(listController);
                    listController.searchTemplateData.currentSearchTemplate = savedTemplate;
                    listController.searchTemplateData.isProcessingTemplate = false;

                    if (!existingTemplateId) {
                        listController.searchTemplateData.searchTemplates.push(savedTemplate);
                    } else {
                        // update the existing template in the list of templates
                        let existingTemplate = _.find(listController.searchTemplateData.searchTemplates, (template) => {
                            return template.id === existingTemplateId;
                        });

                        if (existingTemplate) {
                            existingTemplate.template = savedTemplate.template;
                        }
                    }

                    resolve();
                }, (err) => {
                    listController.searchTemplateData.isProcessingTemplate = false;
                    listController.templateMessage = 'Error saving search. Please try again.';
                    clearTemplateMessage(listController);
                    reject();
                });
                
            });
        }

        function clearSearchTemplate (listController) {
            listController.keywordFilter = null;
            listController.searchTemplateData.currentSearchTemplate = null;
            listController.searchTemplateData.savedSearchName = null;
        }

        function initSearchTemplateData (listController) {
            listController.searchTemplateData = {
                searchTemplates: [],
                currentSearchTemplate: null,
                savedSearchName: null,
                isProcessingTemplate: false,
                isTemplateDirty: false
            };
        }

        function displaySaveBtn (listController) {
            if (listController.searchTemplateData.currentSearchTemplate === null) 
                return true;
            
            if (listController.searchTemplateData.currentSearchTemplate && 
                listController.searchTemplateData.currentSearchTemplate.template && 
                listController.searchTemplateData.currentSearchTemplate.template.templateName === listController.searchTemplateData.savedSearchName) 
                return true;

            return false;
        }

        function displaySaveAsBtn (listController) {
            if (listController.searchTemplateData.currentSearchTemplate === null
                || !listController.searchTemplateData.currentSearchTemplate.template) return false;
            
            if (listController.searchTemplateData.currentSearchTemplate && 
                listController.searchTemplateData.currentSearchTemplate.template.templateName !== listController.searchTemplateData.savedSearchName) return true;

            return false;
        }

        function enableSaveBtns (listController) {
            
            if (listController.searchTemplateData.savedSearchName  && listController.searchTemplateData.savedSearchName.length > 0) {
                // does the name already exist? 
                let existingTemplates = listController.searchTemplateData.searchTemplates;
                let currentTemplate = listController.searchTemplateData.currentSearchTemplate ? listController.searchTemplateData.currentSearchTemplate.template : null;
                let exists = false;

                if (currentTemplate && currentTemplate.templateName.toLowerCase() === listController.searchTemplateData.savedSearchName.toLowerCase()) {
                    listController.templateExists = false;

                    return true;
                }

                _.forEach(existingTemplates, (template) => {
                    if (template.template.templateName.toLowerCase() === listController.searchTemplateData.savedSearchName.toLowerCase()) {
                        exists = true;
                        listController.templateExists = true;
                    }
                });

                if (exists) {
                    return false;
                }

                listController.templateExists = false;

                return true;

            } else {
                listController.templateExists = false;

                return false;
            }
        }

        function advancedFilterModalClosed(listController) {
            if (listController.searchTemplateBeforeAdvancedSearch.currentSearchTemplate) {
                // only update this if they didn't delete the template
                let searchItem = _.find(listController.searchTemplateData.searchTemplates, (item) => { return item.template.templateName === listController.searchTemplateBeforeAdvancedSearch.currentSearchTemplate; });
                
                if (searchItem) {
                    listController.searchTemplateData.currentSearchTemplate = searchItem;
                } else {
                    clearSearchTemplate(listController);
                }
            } else {
                clearSearchTemplate(listController);
            }

            listController.filters = listController.filtersBeforeAdvancedSearch;
            listController.showAdvancedSearch = false;
        }
            
    }
})();

(function () {
    "use strict";

    roService.$inject = ["rcApi", "employeeService", "dealerInspectionService", "authService", "rcUtilService", "azureBlob", "appointmentUtilService", "appointmentService", "SYSTEM_ENUMS"];
    angular
        .module("redcap")
        .factory("roService", roService);

    function roService(rcApi, employeeService, dealerInspectionService, authService, rcUtilService, azureBlob, appointmentUtilService, appointmentService, SYSTEM_ENUMS) {        
        const _dealerSettings = {
            dealerId: null,
            dealerUsers: null,
            roStatuses: null
        };

        return {
            getRo: getRo,
            getRoAssignments: getRoAssignments,            
            getRoLineItems: getRoLineItems,
            updateRoAssignments: updateRoAssignments,
            addLineItem: addLineItem,
            removeLineItem: removeLineItem,
            updateLineItem: updateLineItem,
            updateLineItemPricing: updateLineItemPricing,
            updateAuthorizationStatus: updateAuthorizationStatus,
			createRepairOrder: createRepairOrder,
            updateLineItemHiddenStatus: updateLineItemHiddenStatus,
            getAuthorizationHistory: getAuthorizationHistory,
            getAuthorizationGroup: getAuthorizationGroup,
            searchRepairOrdersFromDms: searchRepairOrdersFromDms,
            sendAuthorizationsToCustomer: sendAuthorizationsToCustomer,
            createInvoice: createInvoice,
            searchCustomers: searchCustomers,
            getUserPreferences: getUserPreferences,
            saveUserPreferences: saveUserPreferences,
            getRouteSheet: getRouteSheet,
            getDealerFilterOptions: getDealerFilterOptions,
            compareToDms: compareToDms,
            updateRoInDms: updateRoInDms,
            pullFromDms: pullFromDms,
            saveRecMedia: saveRecMedia,
            deleteRecMedia: deleteRecMedia,
            getRecMedia: getRecMedia,
            getRoMedia: getRoMedia,
            updateLineItemMedia: updateLineItemMedia,
            searchParts: searchParts,
            removePart: removePart,
            addPart: addPart,
            addPartsBulk: addPartsBulk,
            getLaborRateOptions: getLaborRateOptions,
            calculateTax: calculateTax,            
            buildCustomerNameForTab: buildCustomerNameForTab,
            calculateDefaultLaborRate: calculateDefaultLaborRate,
            getPartsQuote: getPartsQuote,
            updatePartsQuotePricing: updatePartsQuotePricing,           
            getPartAvailability: getPartAvailability,
            addMediaImpression: addMediaImpression,
            signAuthorization: signAuthorization,
            getActiveTerms: getActiveTerms,
            assignCurrentUserToRole: assignCurrentUserToRole,
            createSignature: createSignature,
            getMediaUploadLink: getMediaUploadLink,
            getRoShopNotes: getRoShopNotes,
            addShopNote: addShopNote,
            deleteShopNote: deleteShopNote,
            getCustomerVehicles: getCustomerVehicles,
            deleteLineItemFromDMS: deleteLineItemFromDMS,
            dmsRequiresHangTag: dmsRequiresHangTag,
            isOpenOrPendingAuthGroup: isOpenOrPendingAuthGroup,
            uploadMedia: uploadMedia,
            getVehicleOverview: getVehicleOverview,
            getMedia: getMedia,
            saveMedia: saveMedia,
            deleteMedia: deleteMedia,
            updateLineItemSeverity: updateLineItemSeverity
        };

        function dmsRequiresHangTag(dealerDmsSystem) {
            switch (dealerDmsSystem) {
                case SYSTEM_ENUMS.dmsSystemEnum.CDK:
                    return true;
            }

            return false;
        }

        function getPartAvailability(dealerId, roId, partId) {
            return rcApi.get(getBasePath(dealerId, roId) + `/dms/parts/availability/${partId}`);
        }

        function pullFromDms(dealerId, repairOrderId) {
            return rcApi.post(getBasePath(dealerId, repairOrderId) + `/dms/pull`);
        }

        function searchParts(dealerId, searchTerm, cancelToken) {
            return rcApi.get(getBasePath(dealerId, '') + 'dms/parts/search?searchTerm=' + searchTerm, cancelToken);
        }

        function removePart(dealerId, repairOrderId, serviceOperationId, partId) {
            return rcApi.remove(getBasePath(dealerId, repairOrderId) + `/rec/${serviceOperationId}/part/` + partId);
        }

        function addPart(dealerId, repairOrderId, serviceOperationId, part) {
            return rcApi.post(getBasePath(dealerId, repairOrderId) + `/rec/${serviceOperationId}/part`, part);
        }

        function addPartsBulk(dealerId, repairOrderId, parts) {
            return rcApi.post(getBasePath(dealerId, repairOrderId) + `/parts`, parts);
        }

        function getLaborRateOptions(dealerId, repairOrderId) {
            return rcApi.get(getBasePath(dealerId, repairOrderId) + '/lineitems/labor-rate-settings');
        }

        function updateRoInDms(dealerId, repairOrderId) {
            return rcApi.post(getBasePath(dealerId, repairOrderId) + `/dms/update`, null, null, true);
        }

        function compareToDms(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + '/dms/compare');
        }

        function searchCustomers(dealerId, searchString) {
             return rcApi.get('dealer/' + dealerId + '/customers/search?searchText=' + searchString);
        }

        function getCustomerVehicles(dealerId, customerId) {
            return rcApi.get(`${getBasePath(dealerId, '')}customer/${customerId}/vehicles`);
        }

        function searchRepairOrdersFromDms(dealerId, searchString) {
            return rcApi.get(getBasePath(dealerId, '') + 'searchdms/' + searchString);
        }

        function getBasePath(dealerId, roId) {
            return `v2/${dealerId}/ro/${roId}`;
        }

        function getRo(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId));
        }

        function getRoAssignments(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + '/assignments');            
        }

        function saveRecMedia(dealerId, roId, serviceOperationId, mediaModels) {
            rcUtilService.clearFileData(mediaModels);

            return rcApi.post(getBasePath(dealerId, roId) + `/rec/${serviceOperationId}/media`, mediaModels);            
        }

        function deleteRecMedia(dealerId, roId, serviceOperationId, mediaIds) {
            return rcApi.remove(getBasePath(dealerId, roId) + `/rec/${serviceOperationId}/media/delete`,  mediaIds);            
        }

        function getRecMedia(dealerId, roId, serviceOperationId) {
            return rcApi.get(getBasePath(dealerId, roId) + `/rec/${serviceOperationId}/media`);            
        }

        function getRoMedia(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + `/media`);            
        }

        function updateRoAssignments(dealerId, roId, assignmentsModel) {
            return rcApi.put(getBasePath(dealerId, roId) + '/assignments', assignmentsModel);
        }

        function getRoLineItems(dealerId, roId) {    
            return rcApi.get(getBasePath(dealerId, roId) + '/lineitems');
        }

        function sendAuthorizationsToCustomer(dealerId, roId, servicesToAuthorize, phoneNumber, alternateContact, messageBody) {
            const servicesToAuthorizeModel = {
                dealerId: dealerId,
                roId: roId,
                servicesToAuthorize: servicesToAuthorize,
                phoneNumber: phoneNumber,
                alternateContact: alternateContact,
                messageBody: messageBody
            };

            return rcApi.post(getBasePath(dealerId, roId) + '/sendtocustomer', servicesToAuthorizeModel);
        }

        function signAuthorization(dealerId, roId, signatureData) {
            return rcApi.post(getBasePath(dealerId, roId) + '/signature', signatureData);
        }

        function getActiveTerms(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + '/terms');
        }

        function createSignature(dealerId, roId, fullName) {
            return rcApi.get(getBasePath(dealerId, roId) + `/createsignature?fullName=${fullName}`);
        }

        function createInvoice(dealerId, roId, bypassWarnings) {
            const params = '?bypasswarnings=' + (!!bypassWarnings);

            return rcApi.post(getBasePath(dealerId, roId) + '/invoice' + params);
        }

        function removeImageDataFromLineItemModel(lineItemModel) {
            rcUtilService.clearFileData(lineItemModel.images);
            rcUtilService.clearFileData(lineItemModel.imagesToAdd);
            rcUtilService.clearFileData(lineItemModel.mediaItems);
        }

        function addLineItem(dealerId, roId, lineItemModel) {
            removeImageDataFromLineItemModel(lineItemModel);

            return rcApi.post(getBasePath(dealerId, roId) + '/lineitems', lineItemModel);
        }
        
        function updateLineItem(dealerId, roId, serviceOperationId, lineItemModel) {
            removeImageDataFromLineItemModel(lineItemModel);

            return rcApi.put(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}`, lineItemModel);
        }

        function removeLineItem(dealerId, roId, serviceOperationId, hideToastr) {
            return rcApi.remove(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}`, null, null, hideToastr);
        }

        function deleteLineItemFromDMS(dealerId, roId, serviceOperationId) {
            return rcApi.remove(`${getBasePath(dealerId, roId)}/rolineitems/${serviceOperationId}`);
        }

        function updateLineItemPricing(dealerId, roId, serviceOperationId, lineItemPricingModel) {
            return rcApi.put(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}/pricing`, lineItemPricingModel);
        }

        function updatePartsQuotePricing(dealerId, roId, serviceOperationId, partsTotal) {
            return rcApi.put(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}/partQuotePricing/${partsTotal}`);
        }

        function calculateTax(dealerId, roId, serviceOperationId, estimate) {
            return rcApi.put(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}/calculate-tax-and-fees`, estimate);
        }

        function calculateDefaultLaborRate(dealerId, roId, serviceOperationId, laborHours) {
            return rcApi.put(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}/calculate-default-labor`, laborHours);
        }

        function updateAuthorizationStatus(dealerId, roId, serviceOperationId, status) {
            return rcApi.post(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}/authorize/${status}`);
        }     
        
        function updateLineItemSeverity(dealerId, roId, serviceOperationId, severity) {
            return rcApi.put(`${getBasePath(dealerId, roId)}/lineitems/${serviceOperationId}/severity`, severity);
        }   

        function createRepairOrder(dealerId, repairOrderModel) {
            return rcApi.post(`v2/${dealerId}/ro`, repairOrderModel);
        }

        function updateLineItemHiddenStatus(dealerId, roId, lineItems) {
            return rcApi.post(`v2/${dealerId}/ro/${roId}/lineItems/hiddenStatus`, lineItems); 
        }
        
        function getAuthorizationHistory(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + '/authorizations');
        }

        function getAuthorizationGroup(dealerId, roId, authorizationGroupId) {
            return rcApi.get(`${getBasePath(dealerId, roId)}/authorizations/${authorizationGroupId}`);
        }

        function getUserPreferences(dealerId) {
            return rcApi.get(`${getBasePath(dealerId, '')}routesheet/user/preferences`);
        }

        function saveUserPreferences(dealerId, preferenceJson) {
            const routeSheetUserPreference = {
                dealerId: dealerId,
                preferenceJson: preferenceJson
            };

            return rcApi.post(`${getBasePath(dealerId, '')}routesheet/user/preferences`, routeSheetUserPreference);
        }

        function getRouteSheet(dealerId, filterData) {
            return rcApi.post(`${getBasePath(dealerId, '')}routesheet`, filterData);
        }

        function addMediaImpression(dealerId, roId, mediaItemId) {
            return rcApi.post(`${getBasePath(dealerId, roId)}/media/${mediaItemId}/impression`);
        }

        function getMediaUploadLink(dealerId, roId, lineItemId, taskId, taskName) {
            let query = [];
            
            if (lineItemId) query.push(`lineItemId=${lineItemId}`);
            if (taskId) query.push(`taskId=${taskId}`);
            if (taskName) query.push(`taskName=${encodeURIComponent(taskName)}`);
            
            let queryString = query.length ? '?' + query.join('&') : '';
            
            return rcApi.get(getBasePath(dealerId, roId) + `/media-upload-link${queryString}`);
        }

        function getDealerFilterOptions(dealerId) {
            if (_dealerSettings.dealerId === dealerId && _dealerSettings.roStatuses && _dealerSettings.shopFlags && _dealerSettings.dealerUsers) {
                return Promise.resolve(_dealerSettings);
            } else {
                _dealerSettings.dealerId = dealerId;
                
                const statusPromise = dealerInspectionService.getRoStatuses(dealerId).then((statuses) => { 
                    _dealerSettings.roStatuses = statuses;
                });

                const shopFlagPromise = dealerInspectionService.getShopFlags(dealerId).then((shopFlags) => { 
                    _dealerSettings.shopFlags = shopFlags;
                });

                const userPromise = employeeService.getConfiguredEmployeesByLocation(dealerId).then((dealerUsers) => {
                    _dealerSettings.dealerUsers = dealerUsers;
                });

                return Promise.all([statusPromise, shopFlagPromise, userPromise]).then(() => {
                    return _dealerSettings;
                });
            }
        }

        function buildCustomerNameForTab(firstName, lastName) {
            let customerName = lastName;

            if (lastName && firstName) {
                customerName += ', ';
            }

            if (firstName) {
                customerName += firstName;
            }

            return customerName;
        }
        
        function updateLineItemMedia(dealerId, roId, lineItem) {
            let mediaToDelete = [];
            let deletePromise;

            if (lineItem.selectedMediaItems.deselected && lineItem.selectedMediaItems.deselected.length > 0) {
                lineItem.selectedMediaItems.deselected.forEach((media) => {
                    mediaToDelete.push(media.id);
                });

                deletePromise = deleteRecMedia(dealerId, roId, lineItem.id, mediaToDelete);
            }            

            let addPromises = [];

            lineItem.selectedMediaItems.selected.forEach((media) => {
                let currentUser = authService.getCurrentUser();

                let mediaObject = [{
                    mediaUrl: media.mediaUrl,
                    fileExtension: media.fileExtension,
                    azureImageId: media.azureImageId,
                    appointmentPictureType: media.appointmentPictureType,
                    createdByUserId: currentUser.userId,
                    duration: media.duration,
                }];

                addPromises.push(saveRecMedia(dealerId, roId, lineItem.id, mediaObject));
            });

            if (deletePromise) {
                return Promise.all(addPromises.concat(deletePromise));
            } else {
                return Promise.all(addPromises);
            }
        }

        function getPartsQuote(dealerId, quoteId) {
            return rcApi.get(`v2/${dealerId}/ro/dms/parts/quote/${quoteId}`);
        }

        function getRoShopNotes(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + '/shopnotes');
        }

        function addShopNote(dealerId, roId, note) {
            return rcApi.post(getBasePath(dealerId, roId) + '/shopnotes', JSON.stringify(note));  //Note is stringified cause it also accepts list of notes(with line breaks),removing this will cause parsing exception.
        }

        function deleteShopNote(dealerId, roId, noteId) {
            return rcApi.remove(getBasePath(dealerId, roId) + '/shopnotes/' + noteId);
        }

        function assignCurrentUserToRole(dealerId, ro, roleType, confirmationMessage, modalService) {
            return employeeService.getConfiguredEmployeesByLocation(dealerId).then(dealerUsers => {    
                let currentUserEmployeeRecord = dealerUsers.find((u) => { return u.identityUserId == authService.getCurrentUser().userId; });                                

                if (currentUserEmployeeRecord) {
                    return modalService.showYesNo('Confirm', confirmationMessage, 'Cancel', 'OK', true).then((confirmed) => {
                        if (confirmed) {
                            let assignmentModel = {
                                statusId: ro.statusId,
                                shopFlagId: ro.shopFlagId,
                                serviceAdvisorId: ro.serviceAdvisor?.id,
                                technicianId: ro.technician?.id,
                                assignedToUserId: ro.assignedTo?.id,
                                partsAssociateId: ro.partsAssociate?.id
                            };

                            assignmentModel[roleType + 'Id'] = currentUserEmployeeRecord.id;

                            return updateRoAssignments(dealerId, ro.id, assignmentModel).then(() => currentUserEmployeeRecord);
                        }
                        
                        return null;
                    });
                }
                
                return Promise.resolve(null);
            });
        }

        function isOpenOrPendingAuthGroup(item, INSPECT_CONSTANTS) {
            if (!item.authorizations.length) return false;
            
            return item.authorizations.every(auth =>
                auth.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.open ||
                auth.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.pendingReApproval
            );
        }

        // TODO: refactor this and the drag-drop-image component completely, but for now, this function should allow us to re-use a common
        //  upload function instead of repeating it everrrrrywhere.
        function uploadMedia($model, file, $files, $event, $imageType, reference, container, forceAdd, dealerId) {
            const imageTypes = appointmentUtilService.getImageTypes();

            let imageType = imageTypes[$imageType] || imageTypes.recommendedMaintenance;

            return new Promise((resolve, reject) => {
                
                appointmentService.getImageToken(dealerId, imageType).then((result) => {
                    const config = {
                        baseUrl: result.url,
                        file: file,
                        complete: function () {
                            let currentUser = authService.getCurrentUser();

                            $model.azureImageId = result.imageId;
                            $model.url = result.url;
                            $model.mediaUrl = result.url;
                            $model.mediaType = appointmentUtilService.getMediaType(file.type);
                            $model.fileExtension = file.type;
                            $model.dateTaken = new Date();
                            $model.durationSeconds = rcUtilService.getMediaDuration(file.$ngfDuration);
                            $model.createdByUserId = currentUser.userId;
                            $model.reference = reference;
                            $model.imageType = imageType;

                            resolve(angular.copy($model));
                        },
                        error: function (err) {
                            console.error('Image upload failed', err);
                            reject(err);
                        },
                        blockSize: 4000000 
                    };

                    azureBlob.upload(config);
                }).catch((err) => {
                    console.error('Failed to retrieve image token', err);
                    reject(err);
                }); 
            });
        }

        function getVehicleOverview(dealerId, roId) {
            return rcApi.get(getBasePath(dealerId, roId) + '/vehicle-overview');
        }

        function getMedia(dealerId, roId, pictureType) {
            const params = {
                pictureType: pictureType
            };

            return rcApi.get(getBasePath(dealerId, roId) + '/media', params);
        }

        function saveMedia(dealerId, roId, mediaItems) {
             rcUtilService.clearFileData(mediaItems);

            return rcApi.post(getBasePath(dealerId, roId) + '/media', mediaItems);
        }

        function deleteMedia(dealerId, roId, mediaIds) {
            return rcApi.remove(getBasePath(dealerId, roId) + '/media', mediaIds); 
        }
    }
})();

(function () {
    "use strict";

    repairOrderService.$inject = ["$q", "$log", "$filter", "$http", "$rootScope", "rcApi"];
    angular
        .module("redcap")
        .factory("repairOrderService", repairOrderService);

    function repairOrderService($q, $log, $filter, $http, $rootScope, rcApi) {

        let REPAIR_ORDERS_BASEPATH = "repairorders/";

        return {
            getOpenRepairOrders: getOpenRepairOrders,
            getRepairOrderDetails: getRepairOrderDetails,
            getRepairOrderPayments: getRepairOrderPayments,
            getDealersForDropdown: getDealersForDropdown,
            sendSmsInvoice: sendSmsInvoice,
            formatForDropdown: formatForDropdown,
            loanerDealersForDropDown: loanerDealersForDropDown
        };

        function loanerDealersForDropDown() {
            return rcApi.get(REPAIR_ORDERS_BASEPATH + '/loanerDealersForDropDown');
        }

        function getOpenRepairOrders(search, locationId, advisorId, page, pageSize, cancelPromise, requirePayments) {
            return rcApi.get(REPAIR_ORDERS_BASEPATH + 'list', {
                search: search || null,
                locationId: locationId,
                advisorId: advisorId || null,
                page: page || 0,
                pageSize: pageSize || 25,
                requirePayments: requirePayments
            }, cancelPromise);
        }

        function getRepairOrderDetails(repairOrderId) {
            return rcApi.get(REPAIR_ORDERS_BASEPATH + repairOrderId + "/details");
        }

        function getRepairOrderPayments(repairOrderId) {
            return rcApi.get(REPAIR_ORDERS_BASEPATH + repairOrderId + '/payments');
        }

        function getDealersForDropdown(requiredPermission, requiresPayments) {
            let permissionParam = '';

            if (requiredPermission) {
                permissionParam = '?requiredPermission=' + requiredPermission;
            }

            if (requiresPayments === false) {
                permissionParam += '&requiresPayments=false';
            }
            
            return rcApi.get(REPAIR_ORDERS_BASEPATH + '/dealersForDropdown' + permissionParam);
        }

        function sendSmsInvoice(repairOrderId, message, customerPhone, amount) {
            return rcApi.post(REPAIR_ORDERS_BASEPATH + '/sendInvoice',
                {
                    repairOrderId: repairOrderId,
                    message: message,
                    customerPhone: customerPhone,
                    amount: amount
                });
        }

        function formatForDropdown(repairOrder) {
            let str = '#' + repairOrder.roNumber + ' ' +
                repairOrder.roStatus + ' ' +
                (repairOrder.updatedDate ? '(' + moment(repairOrder.updatedDate).format('MM/DD/YYYY') + ') - ' : '(NA)-') +
                repairOrder.customerFirstName + ' ' +
                repairOrder.customerLastName + ', ';

            if (repairOrder.vehicleYear) {
                str += repairOrder.vehicleYear + '';
            }

            if (repairOrder.vehicleMake) {
                str += repairOrder.vehicleMake + '';
            }

            if (repairOrder.vehicleModel) {
                str += repairOrder.vehicleModel;
            }

            if (!repairOrder.vehicleMake && !repairOrder.vehicleModel && !repairOrder.vehicleYear) {
                str += "No Vehicle Selected";
            }

            return str;
        }
    }

})();

(function () {
    'use strict';

    rcApi.$inject = ["$log", "$http", "$rootScope", "$timeout", "$q", "$state", "toastr", "localStorageService", "API_SETTINGS", "DASHBOARD_VERSION"];
    angular
        .module('redcap.services')
        .service('rcApi', rcApi);

    function rcApi($log, $http, $rootScope, $timeout, $q, $state, toastr, localStorageService, API_SETTINGS, DASHBOARD_VERSION) {
        let loadingTimeout = null;
        let versionUpdateCalled = false;

        return {
            get: get,
            post: post,
            put: put,
            remove: remove,
            postFile: postFile
        };

        function get(url, params, cancelPromise, headers, hideToastr, shouldCacheRequest) {
            let getRequest = {method: 'GET', url: url, params: params, warningAfter: 2000};

            if (cancelPromise) {
                getRequest.timeout = cancelPromise;
            }
            
            if (shouldCacheRequest) {
                getRequest.cache = shouldCacheRequest;
            }

            getRequest.headers = headers || {};

            return doHttpRequest(getRequest, hideToastr);
        }

        function post(url, data, headers, hideToastr, cancelPromise) {
            let postRequest = {method: 'POST', url: url, data: data, warningAfter: 2000};

            if (cancelPromise) {
                postRequest.timeout = cancelPromise;
            }

            postRequest.headers = headers || {};

            return doHttpRequest(postRequest, hideToastr);
        }

        function postFile(url, data, hideToastr) {
            return doHttpRequest({
                method: 'POST',
                url: url,
                data: data,
                warningAfter: 60000,
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular.identity
            }, hideToastr);
        }

        function put(url, data, cancelPromise, headers) {
            let putRequest = {method: 'PUT', url: url, data: data, warningAfter: 2000};

            putRequest.headers = headers || {};

            return doHttpRequest(putRequest, cancelPromise);
        }

        function remove(url, data, headers, hideToastr) {
            let deleteRequest = {method: 'DELETE', url: url, data: data, warningAfter: 2000};

            deleteRequest.headers = headers || {};

            _.extend(deleteRequest.headers, {'Content-Type': 'application/json'});
           
            return doHttpRequest(deleteRequest, hideToastr);
        }

        function addRequest() {
            if ($rootScope.requestCount == null)
                $rootScope.requestCount = 0;

            $rootScope.requestCount++;
            if ($rootScope.requestCount > 0)
                $rootScope.isDataLoading = true;
        }

        function removeRequest() {
            $rootScope.requestCount--;

            if ($rootScope.requestCount == 0) {
                loadingTimeout && $timeout.cancel(loadingTimeout);
                loadingTimeout = $timeout(() => {               // this will give animations at least 1 second to complete
                    $rootScope.isDataLoading = false;
                }, 1000);
            }
        }

        function checkVersion(response) {
            if (!response) return; // No need to check anything if null

            // Get the dashboard version from the response headers
            let version = response.headers('DashboardVersion');

            // Compare the client's version with the API version to see if update is needed
            if (!versionUpdateCalled && version) {
                let local = DASHBOARD_VERSION.split('.');
                let remote = version.split('.');

                while (local.length < remote.length) local.push('0');
                while (remote.length < local.length) remote.push('0');

                for (let i = 0; i < local.length; i++) {
                    if (parseInt(local[i]) > parseInt(remote[i]))   // if at any time, the local version exceeds the remote, skip the sub versions
                        break;

                    if (parseInt(remote[i]) > parseInt(local[i])) {
                        versionUpdateCalled = true; // Ensure that the 'newVersionAvailable' doesn't get called more than once. (Prevent multiple popups)
                        $rootScope.$broadcast('newVersionAvailable', {current: DASHBOARD_VERSION, new: version});
                    }
                }
            }
        }

        function doHttpRequest(req, hideToastr) {
            if (req.url.indexOf(API_SETTINGS.apiServiceBaseUri) === -1) {
                req.url = API_SETTINGS.apiServiceBaseUri + req.url;
            }

            $log.debug('rcApi - doHttp: ' + req.method + ' - req.url: ' + req.url);

            req.headers = req.headers || {};
            let authData = localStorageService.get('authorizationData');

            if (authData) {
                req.headers.Authorization = 'Bearer ' + authData.token;
            } else {
                $log.debug('rcApi - doHttp: Unexpected NO AUTH DATA FOUND for url: ' + req.url);
            }

            // Add timeout to request
            addRequest(req);

            return $http(req)
                .then((resp_success) => {
                    checkVersion(resp_success); // Check for newer version coming from API
                    let data = resp_success.data;
                    let result = data == null ? null : data.result || data;

                    return result;
                })
                .catch((resp_error) => {
                    if (resp_error) {
                        let responseData = resp_error.data || {};

                        $log.error('rcApi-$http.catch(resp_error): status="' + resp_error.status + '", statusText="' + resp_error.statusText + '"');

                        if (responseData.modelState) {
                            responseData.modelErrors = parseModelErrors(responseData.modelState);
                        } else {
                            responseData.modelErrors = [];
                            responseData.modelErrors.push(responseData.message || resp_error.statusText);
                        }

                        if (resp_error.status !== -1 && hideToastr !== true && ($rootScope.config && !$rootScope.config.hideToastr))
                            toastr.error(_.join(responseData.modelErrors, '<br/>'), {allowHtml: true, timeOut: 5000});
                    } else {
                        $log.error('rcApi: unknown error');

                        if (hideToastr !== true && ($rootScope.config && !$rootScope.config.hideToastr)) {
                            toastr.error('Unknwon error', {timeOut: 5000});
                        }
                    }

                    return $q.reject(resp_error);
                })
                .finally((response) => {
                    removeRequest();
                });
        }

        function parseModelErrors(modelState) {
            let errors = [];

            for (let key in modelState) {
                for (let i = 0; i < modelState[key].length; i++) {
                    errors.push(modelState[key][i]);
                }
            }

            return errors;
        }
    }
})();

(function () {
    'use strict';

    adminService.$inject = ["$q", "$log", "$state", "rcApi", "localStorageService"];
    angular
        .module('redcap')
        .factory('rcConfigService', adminService);

    function adminService($q, $log, $state, rcApi, localStorageService) {

        let ADMIN_BASEPATH = 'adminConfig/';

        return {
            getConfigValues: getConfigValues,
            setFavicon: setFavicon,
            getDashboardUpdatedTime: getDashboardUpdatedTime
        };

        function getConfigValues(id) {
            let deferred = $q.defer();

            rcApi.get(ADMIN_BASEPATH + id)
                .then((resultConfig) => {
                    deferred.resolve(resultConfig);
                }, (errorMessage) => {
                    $state.go('login', {configId: 1});
                });

            return deferred.promise;
        }

        function setFavicon(favicon) {
            let link = document.createElement('link');

            link.rel = 'shortcut icon';
            link.href = favicon;

            if (favicon.indexOf('.ico') > -1) {
                link.type = 'image/x-icon';
                appendFavicon();
            }

            if (favicon.indexOf('.png') > -1) {
                link.type = 'image/png';
                appendFavicon();
            }

            function appendFavicon() {
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        }

        function getDashboardUpdatedTime() {
            return rcApi.get('appversion/dashboardUpdatedTime');
        }
    }
})();

(function () {
    "use strict";

    rcUtilService.$inject = ["API_SETTINGS", "SYSTEM_ENUMS"];
    angular
        .module("redcap")
        .factory("rcUtilService", rcUtilService);

    function rcUtilService(API_SETTINGS, SYSTEM_ENUMS) {
        const prodAPI = 'https://api.redcapvalet.com/';
        
        return {
            isEmpty: isEmpty,
            isValidEmail: isValidEmail,
            ease: ease,
            numberWithDecimal: numberWithDecimal,
            vehicleKeyDown: vehicleKeyDown,
            isValidYear: isValidYear,
            escapeRegExp: escapeRegExp,
            replaceAll: replaceAll,
            isFormValid: isFormValid,
            isValidID: isValidID,
            getRODisplayText: getRODisplayText,
            calcDuration: calcDuration,
            isValidPhone: isValidPhone,
            formatLocationForDropdown: formatLocationForDropdown,
            isProd: isProd,
            supportsVideoCapture: supportsVideoCapture,
            getMediaRecorder: getMediaRecorder,
            isValidNumber: isValidNumber,
            buildFilterMessage: buildFilterMessage,
            getItemByProperty: getItemByProperty,
            setFuelLevel: setFuelLevel,
            noBarCodeDetected: noBarCodeDetected,
            isValidVin: isValidVin,
			populateConsumerHeaders: populateConsumerHeaders,
            stopEvents: stopEvents,
            getRandomNumber: getRandomNumber,
            getMediaDuration: getMediaDuration,
            showHideMobileMessagingPanel: showHideMobileMessagingPanel,
            formatNewLineHtml: formatNewLineHtml,
            formatCustomerName: formatCustomerName,
            getCustomerLastName: getCustomerLastName,
            getRoNumberSuffix: getRoNumberSuffix,
            printToPDF: printToPDF,
            clearFileData: clearFileData,
            removeFromArray: removeFromArray,
            getWorkflowDisplayName: getWorkflowDisplayName,
            isInvalidTwilioPhoneNumberError: isInvalidTwilioPhoneNumberError,
            moveAccountsBetweenDealers: moveAccountsBetweenDealers,
            getOdometerAbbreviation: getOdometerAbbreviation
        };

        function clearFileData(files) {
            if (files?.length > 0) {
                for (let idx = 0; idx < files.length; idx++) {
                    files[idx].fileData = null;
                }
            }
        }

        function removeFromArray(array, shouldRemove) {
            if (!array?.length || typeof shouldRemove !== 'function') return;

            for (let i = array.length - 1; i >= 0; i--) {
                if (shouldRemove(array[i])) {
                    array.splice(i, 1);
                }
            }
        }

        function isEmpty(value) {
            if (_.isUndefined(value) || value === null || value === '') {
                return true;
            }

            return false;
        }

        function isValidEmail(value) {
            let emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email = value;

            if (emailRegEx.test(email)) {
                return true;
            } else {
                return {isValid: false, message: 'A valid email must be specified'};
            }
        }

        function isValidVin(vin) {
            let regex = /^[^oqiOQI]*$/;
            let validAlphaNumericRegex = /^[A-Z0-9]+$/i;
            // Using VIN checksum validation, introduced in PROD-10658
            const transliterationTable = {
                'A': 1, 'B': 2, 'C': 3, 'D': 4, 'E': 5, 'F': 6, 'G': 7, 'H': 8,
                'J': 1, 'K': 2, 'L': 3, 'M': 4, 'N': 5, 'P': 7, 'R': 9,
                'S': 2, 'T': 3, 'U': 4, 'V': 5, 'W': 6, 'X': 7, 'Y': 8, 'Z': 9,
                '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9
            };
        
            const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

            function getTransliteratedValue(char) {
                return Object.prototype.hasOwnProperty.call(transliterationTable, char.toUpperCase()) 
                    ? transliterationTable[char.toUpperCase()] 
                    : -1;
            }

            if (vin && vin.length > 0) {

                if (vin.length !== 17) {
                    return {isValid: false, message: 'Must be at least 17 characters.'};
                } else if (!validAlphaNumericRegex.test(vin)) {
                    return {isValid: false, message: 'VIN must be alphanumeric.'};
                } else if (!regex.test(vin)) {
                    return {isValid: false, message: 'O, Q, and I are invalid characters'};
                }
                
                let sum = 0;

                for (let i = 0; i < vin.length; i++) {
                    const charValue = getTransliteratedValue(vin[i]);

                    if (charValue === -1) {
                        return {isValid: true, message: 'VIN not valid. Try again.'};
                    }

                    sum += charValue * weights[i];
                }
            
                let remainder = sum % 11;
                let checkDigit = vin[8].toUpperCase();
                let checkDigitValue = checkDigit === 'X' ? 10 : parseInt(checkDigit, 10);
                let isValid = remainder === checkDigitValue;
            

                if (!isValid) {
                    return {isValid: true, message: 'VIN not valid. Try again.'};
                } else if (regex.test(vin) && vin.length === 17 && isValid) {
                    return {isValid: true, message: ''};
                }
            }
        }

        function ease(startCoord, endCoord, durationMs, onStep, onComplete) {
            onStep = onStep || console.log;

            onComplete = onComplete || function () { };

            let raf = window.requestAnimationFrame || function (f) { window.setTimeout(f, 16); };

            let stepCount = durationMs / 16;
            let valueIncrementLat = (endCoord.lat - startCoord.lat) / stepCount;
            let valueIncrementLng = (endCoord.lng - startCoord.lng) / stepCount;
            let sinValueIncrement = Math.PI / stepCount;
            let currentValueLat = startCoord.lat;
            let currentValueLng = startCoord.lng;
            let currentSinValue = 0;

            function step() {
                currentSinValue += sinValueIncrement;
                currentValueLat += valueIncrementLat * (Math.pow(Math.sin(currentSinValue), 2)) * 2;
                currentValueLng += valueIncrementLng * (Math.pow(Math.sin(currentSinValue), 2)) * 2;

                if (currentSinValue < Math.PI) {
                    onStep({lat: currentValueLat, lng: currentValueLng});
                    raf(step);
                } else {
                    onStep(endCoord);
                    onComplete();
                }
            }

            raf(step);
        }

        function isValidPhone(value) {
            let fieldValue = value ? value.replace(/\D/g, '') : '';

            return {isValid: fieldValue.length === 10, message: 'A valid phone number is required.'};
        }

        function numberWithDecimal(e) {
            if (e.keyCode === 9) return;

            if (e.keyCode === 190 || e.keyCode === 110) {
                return;
            }

            if (!(e.keyCode > 95 && e.keyCode < 106
                || e.keyCode > 47 && e.keyCode < 58
                || e.keyCode === 8)) {
                e.preventDefault();
            }
        }

        function vehicleKeyDown(e) {
            if (e.keyCode === 9) return;

            if (!(e.keyCode > 95 && e.keyCode < 106
                || e.keyCode > 47 && e.keyCode < 58
                || e.keyCode === 8)) {
                e.preventDefault();
            }
        }

        function isValidYear(value, minYear, maxYear) {
            if (!value || value === '') {
                return {isValid: false, message: ''};
            }

            let year = parseInt(value);

            if (year < minYear || year > maxYear) {
                return {isValid: false, message: ''};
            } else {
                return true;
            }
        }

        function escapeRegExp(str) {
            return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        }

        function replaceAll(str, find, replace) {
            return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
        }

        function isFormValid(form) {
            if (!form || form.$valid) return true;

            angular.forEach(form.$error.required, (field) => {
                field.$setDirty();
            });

            return false;
        }

        function isValidID(valueToCheck) {
            if (valueToCheck) {
                let pattern = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
                let isGUID = valueToCheck.match(pattern);

                return !isGUID;
            }

            return false;
        }

        function getRODisplayText(roNumber) {
            if (isValidID(roNumber)) {
                return roNumber;
            } else {
                return null;
            }
        }

        function formatNewLineHtml(message) {
            return message.replace(/\n/g, '<br>');
        }

        function calcDuration(totalSeconds, useRelativeTime, useOriginalIfInvalid, limitToDays) {
            if (totalSeconds === 0) {
                return 'now';
            }

            if (!totalSeconds || !_.isNumber(totalSeconds))
                return useOriginalIfInvalid ? totalSeconds : '';

            let inPast = totalSeconds < 0;

            if (useRelativeTime)
                totalSeconds = Math.abs(totalSeconds);

            let totalHours = totalSeconds / 3600;
            let totalDays = totalHours >= 24 ? totalSeconds / 86400 : 0;
            let totalMinutes = totalSeconds / 60;
            let minutes = Math.ceil(totalMinutes % 60);
            let hours = totalDays > 0 ? Math.floor(totalHours % 24) : Math.floor(totalHours);
            let days = Math.floor(totalDays);
            let duration = '';

            if (days > 0) {
                duration = days + 'd ';

                let quarterMinutes = '';

                if (minutes > 0) {                    
                    // The requirements call for minutes to be represented as a fraction of an hour rounded to the nearest quarter
                    const minuteFraction = Math.round((minutes / 60) * 100);
                    const fractionOfQuarter = (minuteFraction / 25).toFixed(0);
                    let nearestQuarter = fractionOfQuarter * 25;   

                    // Trim the trailing 0 so we can show 1.5h instead of 1.50h
                    if (nearestQuarter === 50) {
                        nearestQuarter = 5;
                    }

                    if (nearestQuarter == 100) {
                        hours++;
                    } else if (nearestQuarter > 0) {
                        quarterMinutes = `.${nearestQuarter}`;
                    }                    
                }

                duration += `${hours}${quarterMinutes}h`;                
            } else {
                if (hours > 0)
                    duration += hours + 'h  ';

                if (minutes > 0)
                    duration += minutes + 'm';
            }

            if (useRelativeTime) {
                if (hours == 0 && minutes == 0)
                    duration = 'now';
                else
                    duration = inPast ? duration + ' ago' : ' in ' + duration;
            }

            return duration;
        }

        function formatLocationForDropdown(location) {
            let formatted = location.name;

            if (location.oemDealerId || location.status)
                formatted += ' (';

            if (location.oemDealerId) {
                formatted += location.oemDealerId;

                if (location.status) {
                    formatted += ' ';
                }
            }

            if (location.status) {
                switch (location.status) {
                    case 1:
                        formatted += 'Active';
                        break;
                    case 2:
                        formatted += 'QA';
                        break;
                    case 3:
                        formatted += 'Install';
                        break;
                    default:
                        formatted += 'Disabled';
                        break;
                }
            }

            if (location.oemDealerId || location.status)
                formatted += ')';

            return formatted;
        }

        function isProd() {
            return API_SETTINGS.apiServiceBaseUri === prodAPI;
        }

        function supportsVideoCapture() {
            return new Promise((resolve, reject) => {
                try {
                    navigator.mediaDevices
                        .getUserMedia(
                            {
                                video: {
                                    facingMode: 'environment'
                                },
                                audio: true
                            })
                        .then((stream) => {
                            try {
                                let recorder = getMediaRecorder(stream);
                                let recorderExists = recorder != null;
                                
                                // Stop the recording icon from showing
                                stream.getTracks().forEach((track) => track.stop());
                                
                                resolve(recorderExists);
                            } catch (streamError) {
                                resolve(false);
                            }                            
                        })
                        .catch((err) => {
                            resolve(false);
                        });
                } catch (e) {
                    resolve(false);
                }
            });
        }

        function getMediaRecorder(stream, recorderInfo) {
            let mediaRecorder = null;

            recorderInfo = recorderInfo || {};
            
            try {
                recorderInfo.mimeType = 'video/webm';
                mediaRecorder = new MediaRecorder(stream, {mimeType: recorderInfo.mimeType});
            } catch (err1) {
                try {
                    // Fallback for iOS
                    recorderInfo.mimeType = 'video/mp4';
                    mediaRecorder = new MediaRecorder(stream, {mimeType: recorderInfo.mimeType});
                } catch (err2) {
                   // No video is supported
                }
            }

            return mediaRecorder;
        }

        function isValidNumber(val) {
            return !isNaN(val) && _.isNumber(val);
        }

        /* parent should be the calling controller */
        // For large popups (e.g. msg,appts tabs) the maxPopUpLength is 43 chars 
        function buildFilterMessage(title, value, parent, isLowercase, autowrapText, maxPopUpLength) { 
            parent.filterMessage += '<div class=\'text-wrap\'><b>' + title + '</b>: '; 
            parent.filterMessage += '<span' + (isLowercase ? ' class="lowercase">' : '>'); 

            if (Array.isArray(value)) {
                value = value.join(', ');
            }
           
            if (value.length + title.length + 2 > maxPopUpLength && autowrapText) {
                let remainingValue  = `${title}: ${value}`;
                let lines = [];  

                while (remainingValue.length > maxPopUpLength) {
                    let index = remainingValue.substring(0, maxPopUpLength).lastIndexOf(',');

                    if (index === -1) {
                        // if we can't find a comman to break on, use a space
                        index = remainingValue.substring(0, maxPopUpLength).lastIndexOf(' ');
                    }

                    let lineValue = remainingValue.substring(!lines.length ? title.length + 2 : 0, index + 1);

                    remainingValue = remainingValue.substring(index + 1, remainingValue.length);
                    lines.push(lineValue); 
                } 

                lines.push(remainingValue);
                lines.forEach((val, index) => {
                    parent.filterMessage += val;
                    if (index < lines.length - 1) parent.filterMessage += '</div>';
                });
            } else { 
                parent.filterMessage += value;
            }

            parent.filterMessage += '</span></br>';
            parent.filterCount += 1;

        } 

        function getItemByProperty(filterArr, resolvedGroup, filterProp) {
            let tempArr = [];

            _.forEach(filterArr, (filter) => {
                let item = _.find(resolvedGroup, (resolvedItem) => { 
                    return resolvedItem[filterProp] === filter; 
                });

                tempArr.push(item);
            });

            return tempArr;
        }

        function setFuelLevel(fuelLevel) {
            if (fuelLevel >= 0 && fuelLevel < 25) {
                return 1;
            }

            if (fuelLevel >= 25 && fuelLevel < 50) {
                return 2;
            }

            if (fuelLevel >= 50 && fuelLevel < 75) {
                return 3;
            }

            if (fuelLevel >= 75 && fuelLevel < 100) {
                return 4;
            }

            if (fuelLevel === 100) {
                return 5;
            }
        }

        function noBarCodeDetected(vm, err) {
            if (err === 'No bar codes detected') {
                vm.scanError = "License scan was unsuccessful.  Please retry scanning or enter license details manually.";
            } else {
                throw err;
            }
        }

        function populateConsumerHeaders (allTripTypes) {
            let headers = [];

            _.forEach(allTripTypes, (tripType) => {
                headers[tripType.value] = tripType.text;
            });

            return headers;
        }

        function stopEvents (evt) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }
        }

        function getRandomNumber() {
            return Math.ceil(Math.random() * 999999);
        }

        function getMediaDuration(duration) {
            return isNaN(duration) ? null : Math.round(duration);
        }

        function showHideMobileMessagingPanel (showPanel) {
            if (showPanel) {
                angular.element('body').addClass('mobile-tablet-messaging-enabled');
            } else {
                angular.element('body').removeClass('mobile-tablet-messaging-enabled');
            }
        }

        function formatCustomerName(customer) {
            if (!customer) return null;

            if (typeof customer === 'string')
                return customer;

            const first = customer.firstName || customer.customerFirstName || '';
            const last = customer.lastName || customer.customerLastName || '';
            const business = customer.businessName || customer.customerBusinessName || '';

            if (first.trim() === '' && last.trim() === '') {
                return business;
            }
            
            return `${last}, ${first}`.trim().replace(/^, |, $/, '');
        }

         function getCustomerLastName(customerName) {
            if (!customerName) {
                return '';
            }

            const nameParts = customerName.split(',');

            return nameParts[0]?.trim() || '';
        }

        function getRoNumberSuffix(roNumber) {
            if (!roNumber || roNumber === 'Pending') {
                return 'Pending';
            }

            const numStr = roNumber.toString().trim();

            return numStr.length > 4 ? numStr.slice(-4) : numStr;
        }

        function getWorkflowDisplayName(flow) {
            let displayName = flow.friendlyName || flow.name || 'Unknown Workflow';

            if (flow.systemTripTypeId === SYSTEM_ENUMS.systemTripType.pickup) {
                if (flow.startsAtDealer === true) {
                    displayName += ' - START AT DEALER';
                } else if (flow.startsAtDealer === false) {
                    displayName += ' - START AT CUSTOMER';
                } else if (flow.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoanerDealerFirst || flow.id === SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoanerDealerFirst) {
                   displayName += ' - START AT DEALER';
                } else if (flow.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoaner || flow.id === SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoaner || 
                          flow.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.serviceDropoffWithoutLoaner || flow.id === SYSTEM_ENUMS.tripWorkflowTypes.serviceDropoffWithoutLoaner || 
                          flow.tripWorkFlowId === SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoanerRecall || flow.id === SYSTEM_ENUMS.tripWorkflowTypes.servicePickupNoLoanerRecall) {
                   displayName += ' - START AT CUSTOMER';
                }
            }
            
            return displayName.toUpperCase();
        }

        function isInvalidTwilioPhoneNumberError(error) {
            if (!error?.data) {
                return false;
            }

            let errorMessage = error.data.message || '';
            let hasInvalidPhoneError = (errorMessage.includes('21211') || (errorMessage.toLowerCase().includes('invalid') && errorMessage.toLowerCase().includes('phone')));

            return hasInvalidPhoneError;
        }

        function getOdometerAbbreviation(mileageType) {
            return SYSTEM_ENUMS.odometerTypes.find(o => o.type === mileageType)?.abbreviation || 'MI';
        }

        function moveAccountsBetweenDealers(modalService, getActiveAccounts, moveAccounts, currentLocationId, $state, redirectState, accountLabel, locationService) {
            return locationService.getLocationsForTripListDropDown(false).then((dealerships) => {
                const targetDealers = dealerships.filter(dealership => dealership.id !== currentLocationId);

                const onConfirm = () => {
                    return modalService.showYesNo(
                        `Move Active ${accountLabel}s`,
                        `Are you sure you want to move all active ${accountLabel.toLowerCase()}s to the selected dealership? This will remove all active ${accountLabel.toLowerCase()}s from the current dealership?`,
                        'Cancel',
                        'Continue',
                        false,
                        false
                    );
                };

                return modalService.showDealerList(targetDealers, onConfirm, 'Move To').then((selectedDealership) => {
                    if (!selectedDealership) return;

                    const activeAccounts = getActiveAccounts();
                    const accountIds = (accountLabel && accountLabel.toLowerCase() === 'driver')
                        ? activeAccounts.map(d => d.driverId)
                        : activeAccounts.map(u => u.id);

                    return moveAccounts(accountIds, selectedDealership.id, currentLocationId)
                        .then((result) => {
                            if (result === true) {
                                return modalService.showYesNo(
                                    `Active ${accountLabel}s Moved`,
                                    `All active ${accountLabel.toLowerCase()}s were moved to <b>${selectedDealership.name}</b>. Would you like to view the ${accountLabel.toLowerCase()} admin page for the new company?`,
                                    'No',
                                    'Yes',
                                    false,
                                    false
                                ).then((redirect) => {
                                    if (redirect) {
                                        $state.go(redirectState, {
                                            locationId: selectedDealership.id
                                        });
                                    } else {
                                        $state.reload();
                                    }
                                });
                            }

                            return modalService.showError('An error has occurred moving the requested accounts. Please try again. If the problem persists, please submit a support ticket.');
                        });
                });
            });
        }
    }

    /*
     * Note: if you have a class no-print on a div it will not print out
     */
    function printToPDF(divIdToPrint, repeatingFooterId, outputFileName) {
        // we use cloneNode and add the printing class so that we can show
        // items on the print screen that we DO NOT want on the modal
        const divToPrint = document.getElementById(divIdToPrint).cloneNode(true);
        const footerToPrint = document.getElementById(repeatingFooterId).cloneNode(true);
        
        footerToPrint.classList.add("printing");
        footerToPrint.classList.add("subpages");
        divToPrint.classList.add("printing");

        let footerPdfOptions = {
            margin: 0,
            filename: 'footer-' + outputFileName + '.png',
            image: {type: 'png', quality: 1},
            html2canvas: {scale: 1, useCORS: true},
            jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait', autoPrint: true},
            pagebreak: {mode: ['avoid-all', 'css', 'legacy']}
        };

        let footerImg = null;

        const footerPromise = html2pdf().set(footerPdfOptions).from(footerToPrint).toImg().outputImg().then(img => {
            footerImg = img;
        });

        const promises = [footerPromise];
        
        Promise.all(promises).then(() => {
            
            let pdfOptions = {
                margin: [.75, .75, .75, .75],
                filename: outputFileName + '.pdf',
                image: {type: 'png', quality: 1},
                autoPaging: 'text',
                html2canvas: {scale: .99, useCORS: true},
                jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait'},
                pagebreak: {mode: ['avoid-all', 'css', 'legacy']}
            };

            html2pdf().from(divToPrint).set(pdfOptions).toPdf().get('pdf').then((pdf) => {
                let totalPages = pdf.internal.getNumberOfPages();
                let pageWidth = pdf.internal.pageSize.getWidth();
                let pageHeight = pdf.internal.pageSize.getHeight();

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);

                    if (i === 1) {
                        pdf.text('Page ' + i + ' of ' + totalPages, (pageWidth - 1), (pageHeight - 0.2));
                    } else {
                        pdf.addImage(footerImg, 'png', .25, (pageHeight - .5), 8, .3); 
                        pdf.text('Page ' + i + ' of ' + totalPages, (pageWidth - 1), (pageHeight - 0.2));
                    }
                }

                window.open(pdf.output('bloburl'), '_blank');
            });
        });
    }

})();

(function () {
    'use strict';

    rcLocalStorageService.$inject = ["authService", "localStorageService"];
    angular
        .module('redcap.services')
        .service('rcLocalStorageService', rcLocalStorageService);

    function rcLocalStorageService(authService, localStorageService) {
        return {
            get: get,
            set: set,
            remove: remove
        };

        function get(key) {
            let keySuffix = ":" +  authService.getCurrentUser().userId;

            return localStorageService.get(key + keySuffix);
        }

        function set(key, value) {
            let keySuffix = ":" +  authService.getCurrentUser().userId;

            localStorageService.set(key + keySuffix, value);
        }

        function remove(key) {
            let keySuffix = ":" +  authService.getCurrentUser().userId;

            localStorageService.remove(key + keySuffix);
        }
    }
})();

(function () {
    'use strict';
    promiseTimeService.$inject = ["appointmentService"];
    angular
        .module('redcap.services')
        .factory('promiseTimeService', promiseTimeService);

    function promiseTimeService(appointmentService) {
        return {
            generateHoursFromDate: generateHoursFromDate,
            totalMinutesToTime: totalMinutesToTime,
            getPromiseTime: getPromiseTime,
            getDepartmentHours: getDepartmentHours,
            setHours: setHours,
            isPromiseDateSelectable: isPromiseDateSelectable,
            getFirstAndLastHoursFromApptDataList: getFirstAndLastHoursFromApptDataList
        };

        function generateHoursFromDate(date, apptDateTime, deptHoursMap, department) {
            if (!date) return null;
            let map = deptHoursMap[date.day()];
            let hours = [];

            if (!map || !map.isOpen) return null;
            let time = map.startTimeShort || 0;
            let deptMinutes = department && department.appointmentDuration && moment('1/1/2000 ' + department.appointmentDuration, 'M/D/YYYY HH:mm').minutes();

            if (!deptMinutes || isNaN(deptMinutes)) {
                deptMinutes = 15;
            }

            let apptTime = moment(apptDateTime);

            if (apptTime.isSameOrAfter(date)) {

                let duration = moment.duration(apptTime.diff(date));
                let minutes = duration.asMinutes();
                let additionalOffset = deptMinutes - (minutes % deptMinutes);

                minutes += additionalOffset;
                time = minutes;
            }

            let endTime = map.endTimeShort || 0;

            while (time <= endTime) {
                hours.push(totalMinutesToTime(time));
                time += deptMinutes;
            }

            return hours;
        }

        function totalMinutesToTime(minutes) {
            let hours = Math.floor(minutes / 60);
            let mins = minutes % 60;
            let amPm = hours >= 12 ? "PM" : "AM";

            hours = hours % 12;

            if (hours === 0) {
                hours = 12;
            }

            return `${(hours + '').padStart(2, '0')}:${(mins + '').padStart(2, '0')} ${amPm}`;
        }

        function setHours(hours, time) {
            if (hours && hours.length) {
                let hasHoursMatch = hours.some((hour) => {
                    return hour === time;
                });

                if (!hasHoursMatch) {
                    hours.push(time);
                }
            } else {
                hours = hours || [];
                hours.push(time);
            }
        }

        function getPromiseTime(apptTime, duration, durationMeasurement, deptHoursMap, department) {
            let blockTime = moment(apptTime);
            //the default promise date is configured default additional days
            let promiseDateTime = blockTime.add(duration, durationMeasurement);
            let timePart = durationMeasurement === 'days' ? blockTime.format('hh:mm A') : promiseDateTime.format('hh:mm A');

            for (let i = 0; i < 7; i++) {
                //try each day of the week to make sure dealership is open.
                //if not open in 7 days, we can quit checking.
                let tempPromiseDateTime = promiseDateTime.add(i, 'days');
                let hours = generateHoursFromDate(tempPromiseDateTime, apptTime, deptHoursMap, department);

                if (hours && hours.length) {

                    let promiseTime = hours[0];

                    if (hours.some(val => val == timePart)) {
                        promiseTime = timePart;
                    }

                    return {
                        hours: hours,
                        promiseTime: promiseTime,
                        promiseDate: tempPromiseDateTime
                    };
                }
            }

        }

        function getDepartmentHours(dealerId, departmentId) {
            return appointmentService.getDepartmentHours(dealerId, departmentId).then((days) => {
                let deptHours = {};

                for (let i = 0; i < days.length; i++) {
                    let day = days[i];

                    deptHours[day.dayOfWeekId] = day;
                }

                return deptHours;
            });
        }

        function isPromiseDateSelectable (blockTime, date, deptHours) {
            let apptDate = moment(blockTime).startOf('day');
                let map = deptHours[date.day()];

            if (map && map.isOpen && date.startOf('day') >= apptDate) {
                return true;
                
            }
           
            return false;
        }

        function getFirstAndLastHoursFromApptDataList(appointmentDataList) {
            if (!appointmentDataList || appointmentDataList.length === 0) {
                return {firstHour: null, lastHour: null};
            }
        
            let sortedByTripStartDateTime = appointmentDataList.slice().sort((a, b) => {
                return new Date(a.tripStartDateTime) - new Date(b.tripStartDateTime);
            });
        
            let sortedByPromiseDateTime = appointmentDataList.slice().sort((a, b) => {
                return new Date(a.promiseDateTime) - new Date(b.promiseDateTime);
            });
        
            return {
                firstHour: sortedByTripStartDateTime[0].tripStartDateTime,
                lastHour: sortedByPromiseDateTime[sortedByPromiseDateTime.length - 1].promiseDateTime
            };
        }
    }
})();

(function () {
    angular
        .module('redcap.services')
        .factory('permissions',
            ["$rootScope", "$q", "$filter", "rcApi", "SYSTEM_ENUMS", ($rootScope, $q, $filter, rcApi, SYSTEM_ENUMS) => {
                let _roleList = null;
                    let _userPermissions = null;
                    let _allDealerPermissions = null;
                    let _permissionsMarketingURLS = null;
                    let _permissionMarketingConfigs = null;
                    let _disabledProductsToShowInNav = null;
                    let _enableManageMySchedule = false;

                function itemInList(listToCheck, itemsString) {
                    if (!listToCheck || !itemsString) return false;

                    let itemList = itemsString.trim().split(',');
                  
                    return _.some(itemList, (checkedItem) => {
                        return _.includes(listToCheck, checkedItem);
                    });
                }

                function getPermissionMarketingConfigByName(permissionName) {
                    return $filter('filter')(_permissionMarketingConfigs, {name: permissionName})[0];
                }

                return {
                    arePermissionsSet: function () {
                        return _userPermissions !== null &&
                            _allDealerPermissions !== null &&
                            _roleList !== null;
                    },
                    getUserPermissions: function () {
                        return _userPermissions;
                    },
                    setUserPermissions: function (permissions) {
                        _userPermissions = permissions ? permissions.split(',') : [];

                        $rootScope.$broadcast('permissionsChanged');
                    },
                    setDealerPermissions: function (permissions) {
                        _allDealerPermissions = permissions ? permissions.split(',') : [];
                        $rootScope.$broadcast('permissionsChanged');
                    },
                    setDisabledProductsToShowInNav: function (newValue) {
                        _disabledProductsToShowInNav = newValue ? newValue.split(',') : [];
                    },
                    getDisabledProductsToShowInNav: function () {
                        return _disabledProductsToShowInNav;
                    },
                    setEnableManageMySchedule: function (newValue) {
                        _enableManageMySchedule = newValue;
                    },
                    getEnableManageMySchedule: function () {
                        return _enableManageMySchedule;
                    },
                    setPermissionsMarketingURLs: function (permissions) {
                        _permissionsMarketingURLS = {};
                        let allPermissionURLs = permissions ? permissions.split(',') : [];

                        _.forEach(allPermissionURLs, (permissionURL) => {
                            let nameURL = permissionURL.split(';');

                            _permissionsMarketingURLS[nameURL[0]] = nameURL[1];
                        });


                        $rootScope.$broadcast('permissionsChanged');

                    },
                    setRoles: function (roles) {
                        _roleList = [];

                        if (roles) {
                            _roleList = roles.split(',');
                        }

                        $rootScope.$broadcast('permissionsChanged');
                    },
                    hasMarketingPagePermission: function (permissions) {
                        return itemInList(_disabledProductsToShowInNav, permissions);
                    },
                    hasPermission: function (permissions, checkMarketingPages) {
                        if (this.isSysAdmin() || this.isDeveloper() || itemInList(_userPermissions, SYSTEM_ENUMS.permissionTypes.all)) {
                            return true;
                        }

                        let userHasPermission = itemInList(_userPermissions, permissions);
                            let dealerHasPermission = itemInList(_allDealerPermissions, permissions);

                        if (!checkMarketingPages) {
                            return userHasPermission && dealerHasPermission;
                        } else {
                            let hasMarketingPermission = this.hasMarketingPagePermission(permissions);

                            return hasMarketingPermission || userHasPermission && dealerHasPermission;
                        }
                    },
                    hasDealerPermission: function (permissions) {
                        if (this.isSysAdmin() || this.isDeveloper() || itemInList(_allDealerPermissions, SYSTEM_ENUMS.permissionTypes.all)) {
                            return true;
                        }

                        return itemInList(_allDealerPermissions, permissions);
                    },
                    hasUserPermission: function (permissions) {
                        if (this.isSysAdmin() || this.isDeveloper() || itemInList(_userPermissions, SYSTEM_ENUMS.permissionTypes.all)) {
                            return true;
                        }

                        return itemInList(_userPermissions, permissions);
                    },
                    hasRole: function (roles) {
                        return itemInList(_roleList, roles);
                    },                    
                    isSysAdmin: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.systemAdmin);
                    },
                    isDeveloper: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.developerUser);
                    },
                    isRedCapAdmin: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.redCapAdmin);
                    },
                    isServiceAdvisor: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.serviceAdvisor);
                    },
                    isTechnician: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.technician);
                    },
                    isPartsAssociate: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.partsAssociate);
                    },
                    isDealerAdmin: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.dealerAdmin);
                    },
                    isAppointmentAdmin: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.appointmentAdmin);  
                    }, 
                    isOverrideTripRule: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.overrideTripRules);
                    },
                    isOverrideApptCapacity: function () {
                        return this.hasRole(SYSTEM_ENUMS.roleNames.overrideApptCapacity);
                    },
                    isAdminLevelUser: function () {
                        return this.isSysAdmin() || this.isRedCapAdmin() || this.isDeveloper();
                    },
                    isSysAdminOrRedCapAdmin: function () {
                        return this.isSysAdmin() || this.isRedCapAdmin();
                    },
                    isOnlyDealerAdmin: function () {
                        return this.isDealerAdmin() && !(this.isSysAdmin() || this.isRedCapAdmin() || this.isDeveloper());
                    },
                    allowCustomerMessaging: function () {
                        const rolesForMessaging = [
                            SYSTEM_ENUMS.roleNames.systemAdmin,
                            SYSTEM_ENUMS.roleNames.serviceAdvisor,
                            SYSTEM_ENUMS.roleNames.dealerAdmin,
                            SYSTEM_ENUMS.roleNames.developerUser,
                            SYSTEM_ENUMS.roleNames.redCapAdmin,
                            SYSTEM_ENUMS.roleNames.appointmentAdmin,
                            SYSTEM_ENUMS.roleNames.partsAssociate
                        ].join(',');

                        return this.hasRole(rolesForMessaging);
                    },
                    getPermissionMarketingURL: function (permission) {
                        return _permissionsMarketingURLS ? _permissionsMarketingURLS[permission] : '';
                    },
                    getPermissionMarketingConfig: function (permission) {
                        let d = $q.defer();
                            let permissionName = permission;

                        if (_permissionMarketingConfigs) {
                            d.resolve(getPermissionMarketingConfigByName(permissionName));
                        } else {
                            rcApi.get('permissionsMarketingConfigs')
                                .then((resultConfig) => {
                                    _permissionMarketingConfigs = resultConfig;
                                    d.resolve(getPermissionMarketingConfigByName(permissionName));
                                }, (errorMessage) => { });

                        }

                        return d.promise;
                    },
                    getPermissionsMarketingConfigs: function () {
                        return _permissionMarketingConfigs;
                    },
                    canEditUser: function(userToEditRoles, userId, currentUserId) {
                        if (this.isSysAdmin() || this.isDeveloper()) {
                            return true;
                        } else if (this.isRedCapAdmin()) {
                            return !_.some(userToEditRoles, (role) => {
                                return role === SYSTEM_ENUMS.roleNames.systemAdmin || role === SYSTEM_ENUMS.roleNames.redCapAdmin || role === SYSTEM_ENUMS.roleNames.developerUser;
                            });
                        } else if (this.hasRole(SYSTEM_ENUMS.roleNames.programAdmin)) {
                            return !_.some(userToEditRoles, (role) => {
                                return role === SYSTEM_ENUMS.roleNames.systemAdmin || role === SYSTEM_ENUMS.roleNames.redCapAdmin || role === SYSTEM_ENUMS.roleNames.developerUser || role === SYSTEM_ENUMS.roleNames.programAdmin;
                            });
                        } else if (this.isDealerAdmin()) {
                            return !_.some(userToEditRoles, (role) => {
                                return role === SYSTEM_ENUMS.roleNames.systemAdmin || role === SYSTEM_ENUMS.roleNames.redCapAdmin || role === SYSTEM_ENUMS.roleNames.developerUser || role === SYSTEM_ENUMS.roleNames.programAdmin || role === SYSTEM_ENUMS.roleNames.dealerAdmin;
                            });
                        } else {
                            return userId === currentUserId;
                        }
                    }
                };
            }]
        );
})();

(function () {
    'use strict';

    angular
        .module('redcap.services')
        .factory('pdf417Service', pdf417Service);

    function pdf417Service() {
        var reader = null;

        var DLAbbrDesMap = {
            'DCA': 'Jurisdiction-specific vehicle class',
            'DCB': 'Jurisdiction-specific restriction codes',
            'DCD': 'Jurisdiction-specific endorsement codes',
            'DBA': 'Document Expiration Date',
            'DCS': 'Customer Last Name',
            'DAC': 'Customer First Name',
            'DBD': 'Document Issue Date',
            'DBB': 'Date of Birth',
            'DBC': 'Physical Description - Sex',
            'DAY': 'Physical Description - Eye Color',
            'DAU': 'Physical Description - Height',
            'DAG': 'Address - Street 1',
            'DAI': 'Address - City',
            'DAJ': 'Address - Jurisdiction Code',
            'DAK': 'Address - Postal Code',
            'DAQ': 'Customer ID Number',
            'DCF': 'Document Discriminator',
            'DCG': 'Country Identification',
            'DDE': 'Family Name Truncation',
            'DDF': 'First Names Truncation',
            'DDG': 'Middle Names Truncation',
            'DAH': 'Address - Street 2',
            'DAZ': 'Hair Color',
            'DCI': 'Place of birth',
            'DCJ': 'Audit information',
            'DCK': 'Inventory Control Number',
            'DBN': 'Alias / AKA Family Name',
            'DBG': 'Alias / AKA Given Name',
            'DBS': 'Alias / AKA Suffix Name',
            'DCU': 'Name Suffix',
            'DCE': 'Physical Description Weight Range',
            'DCL': 'Race / Ethnicity',
            'DCM': 'Standard vehicle classification',
            'DCN': 'Standard endorsement code',
            'DCO': 'Standard restriction code',
            'DCP': 'Jurisdiction-specific vehicle classification description',
            'DCQ': 'Jurisdiction-specific endorsement code description',
            'DCR': 'Jurisdiction-specific restriction code description',
            'DDA': 'Compliance Type',
            'DDB': 'Card Revision Date',
            'DDC': 'HazMat Endorsement Expiration Date',
            'DDD': 'Limited Duration Document Indicator',
            'DAW': 'Weight(pounds}',
            'DAX': 'Weight(kilograms}',
            'DDH': 'Under 18 Until',
            'DDI': 'Under 19 Until',
            'DDJ': 'Under 21 Until',
            'DDK': 'Organ Donor Indicator',
            'DDL': 'Veteran Indicator',
            // old standard
            'DAA': 'Customer Full Name',
            'DAB': 'Customer Last Name',
            'DAE': 'Name Suffix',
            'DAF': 'Name Prefix',
            'DAL': 'Residence Street Address1',
            'DAM': 'Residence Street Address2',
            'DAN': 'Residence City',
            'DAO': 'Residence Jurisdiction Code',
            'DAP': 'Residence Postal Code',
            'DAR': 'License Classification Code',
            'DAS': 'License Restriction Code',
            'DAT': 'License Endorsements Code',
            'DAV': 'Height in CM',
            'DBE': 'Issue Timestamp',
            'DBF': 'Number of Duplicates',
            'DBH': 'Organ Donor',
            'DBI': 'Non-Resident Indicator',
            'DBJ': 'Unique Customer Identifier',
            'DBK': 'Social Security Number',
            'DBL': 'Date Of Birth',
            'DBM': 'Social Security Number',
            'DCH': 'Federal Commercial Vehicle Codes',
            'DBO': 'Customer Last Name',
            'DBP': 'Customer First Name',
            'DBQ': 'Customer Middle Name(s}',
            'DBR': 'Name Suffix',
            'PAA': 'Permit Classification Code',
            'PAB': 'Permit Expiration Date',
            'PAC': 'Permit Identifier',
            'PAD': 'Permit IssueDate',
            'PAE': 'Permit Restriction Code',
            'PAF': 'Permit Endorsement Code',
            'ZVA': 'Court Restriction Code',
            'DCT': 'Customer First Name',
            'DAD': 'Customer Middle Name(s}'
        };

        return {
            parseString: parseString,
            parseStringAsObject: parseStringAsObject,
            readBarcode: readBarcode
        };

        function parseString(str) {
            var lines = str.split('\n');
            var abbrs = Object.keys(DLAbbrDesMap);
            var map = {};
            lines.forEach(function (line, i) {
                var abbr;
                var content;
                if (i === 1) {
                    abbr = 'DAQ';
                    content = line.substring(line.indexOf(abbr) + 3);
                } else {
                    abbr = line.substring(0, 3);
                    content = line.substring(3).trim();
                }
                if (abbrs.includes(abbr)) {
                    map[abbr] = content;
                }
            });
            return map;
        }

        function parseStringAsObject(str) {
            var map = parseString(str);
            return {
                firstName: map['DAC'] || map['DBP'] || map['DCT'],
                lastName: map['DCS'] || map['DCB'] || map['DBO'],
                middleName: map['DDG'] || map['DBQ'] || map['DAD'],
                dateOfBirth: figureOutTheDate(map['DBB'] || map['DBL']),
                address1: map['DAG'] || map['DAL'],
                address2: map['DAH'] || map['DAM'],
                city: map['DAI'] || map['DAN'],
                state: map['DAJ'] || map['DAO'],
                zip: map['DAK'] || map['DAP'],
                country: map['DCG'],
                licenseNumber: map['DAQ'],
                expiration: figureOutTheDate(map['DBA']),
                map: map
            };
        }

        function figureOutTheDate(theDate) {
            var tmpDate = new moment(theDate);
            if (tmpDate.isValid()) {
                return tmpDate.toDate();
            }

            tmpDate = new moment(theDate, 'YYYYMMDD');
            if (tmpDate.isValid() && tmpDate.year() > 1900) {
                return tmpDate.toDate();
            }

            tmpDate = new moment(theDate, 'MMDDYYYY');
            if (tmpDate.isValid() && tmpDate.year() > 1900) {
                return tmpDate.toDate();
            }

            return null;
        }

        function readBarcode($files) {
            return new Promise(function (resolve, reject) {
                try {
                    if (!reader) {
                        Dynamsoft.CVR.CaptureVisionRouter.createInstance().then(function (router) {
                            reader = router;

                            reader.getSimplifiedSettings("ReadSingleBarcode").then(function (settings) {
                                // PDF417 only (driver's license)
                                settings.barcodeSettings.barcodeFormatIds = Dynamsoft.DBR.EnumBarcodeFormat.BF_PDF417;
                                reader.updateSettings("ReadSingleBarcode", settings).then(function () {
                                    readFiles($files).then(function (result) {
                                        if (!result || !result.length) {
                                            return reject('No bar codes detected');
                                        }
                                        return resolve(result);
                                    }).catch(function (err) { return reject(err); });
                                }).catch(function (err) {
                                    return reject(err);
                                });
                            }).catch(function (err) {
                                return reject(err);
                            });

                        }).catch(function (err) { return reject(err); });
                    } else {
                        return readFiles($files).then(function (result) {
                            if (!result || !result.length) {
                                return reject('No bar codes detected');
                            }
                            return resolve(result);
                        }).catch(function (err) { return reject(err); });
                    }
                } catch (ex) {
                    return reject(ex);
                }
            });
        }

        function readFiles($files) {
            var items = [];
            var promises = [];

            for (var i = 0; i < $files.length; ++i) {
                var file = $files[i];
                // capture() returns a CapturedResult for this one image
                promises.push(reader.capture(file, "ReadSingleBarcode"));
            }

            return Promise.all(promises).then(function (capturedResults) {
                for (var i = 0; i < capturedResults.length; i++) {
                    var cvr = capturedResults[i];
                    var itemsArr = (cvr && cvr.decodedBarcodesResult?.barcodeResultItems) || [];

                    // Keep only PDF417
                    var pdf417s = itemsArr.filter(function (item) {
                        // item may expose format (enum) and/or formatString depending on version
                        var fmtStr = item.formatString || item.barcodeFormatString;
                        var fmtEnum = item.format || item.barcodeFormat; // fallback
                        return (fmtStr && fmtStr.toUpperCase() === 'PDF417') ||
                            (fmtEnum === Dynamsoft.DBR.EnumBarcodeFormat.BF_PDF417);
                    });

                    for (var j = 0; j < pdf417s.length; j++) {
                        var r = pdf417s[j];
                        var text = r.text || r.barcodeText || '';
                        if (text) {
                            items.push(parseStringAsObject(text));
                        }
                    }
                }
                return items || [];
            });
        }
    }
})();

(function () {
    'use strict';

    modalService.$inject = ["$transitions", "$uibModal", "$q", "$rootScope", "$filter", "$window", "authService", "userService", "$uibModalStack", "hereMapsService", "SYSTEM_ENUMS", "vinScanService", "driversLicenseScanService", "roService", "locationService"];
    angular
        .module('redcap.services')
        .factory('modalService', modalService);

    function modalService($transitions, $uibModal, $q, $rootScope, $filter, $window, authService, userService, $uibModalStack, hereMapsService, SYSTEM_ENUMS, vinScanService, driversLicenseScanService, roService, locationService) {
        return {
            showHelpModal: showHelpModal,
            showImageViewer: showImageViewer,
            showCustomTerms: showCustomTerms,
            showContactDriverHelp: showContactDriverHelp,
            showError: showError,
            showDetailedErrorDlg: showDetailedErrorDlg,
            showYesNo: showYesNo,
            showTripCancel: showTripCancel,
            showAppointmentCancel: showAppointmentCancel,
            showAppointmentNoShow: showAppointmentNoShow,
            showNewServiceOrderWarning: showNewServiceOrderWarning,
            showTutorial: showTutorial,
            showManageLocations: showManageLocations,
            processLyftRefunds: processLyftRefunds,
            showFeatureUpgradeMessage: showFeatureUpgradeMessage,
            arriveAppointment: arriveAppointment,
            showLandlineWarning: showLandlineWarning,
            showVoIPWarning: showVoIPWarning,
            showOptedOutWarning: showOptedOutWarning,
            showAddAddressModal: showAddAddressModal,
            showCopyDriverTasksResults: showCopyDriverTasksResults,
            showVinScanModal: showVinScanModal,
            showLicenseScanModal: showLicenseScanModal,
            showBenefitBatchUpdateConfirm: showBenefitBatchUpdateConfirm,
            closeTopModal: closeTopModal,
            showDuplicateCustomerModal: showDuplicateCustomerModal,
            showGenericApptError: showGenericApptError,
            sendDriverMessage: sendDriverMessage,
            showDetailedCheckInErrorDlg: showDetailedCheckInErrorDlg,
            showPhotoCapture: showPhotoCapture,
            showPhoneCapture: showPhoneCapture,
            selectDefaultTripTypeUser: selectDefaultTripTypeUser,
            formatListForModal: formatListForModal,
            showSendForApproval: showSendForApproval,
            showReturnTripDetails: showReturnTripDetails,
            showVinNotFound: showVinNotFound,
            showDealerList: showDealerList,
            selectServiceAdvisor: selectServiceAdvisor
        };

        function closeTopModal() {
            let top = $uibModalStack.getTop();

            if (top) {
                $uibModalStack.dismiss(top.key);
            }
        }

        function showError(body, errors, hideClose) {
            let title = 'Error';
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/error.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.title = title;
                    vm.body = body;
                    vm.errors = errors;
                    vm.hideClose = hideClose;

                    vm.close = function (choice) {
                        $uibModalInstance.close(choice);
                    };
                }],
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'yes-no-modal',
                windowClass: 'yes-no-dialog'
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showDetailedErrorDlg(error, isDMSError, hideClose) {
            let title = isDMSError ? 'DMS Error' : 'Error';
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/detailederror.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.title = title;
                    vm.error = error;
                    vm.hideClose = hideClose;
                    vm.isDMSError = isDMSError;

                    vm.close = function (choice) {
                        $uibModalInstance.close(choice);
                    };
                }],
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'yes-no-modal',
                windowClass: 'yes-no-dialog'
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showDetailedCheckInErrorDlg(error, isDMSError, hideClose) {
            let title = isDMSError ? 'DMS Error' : 'Error';
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/detailedcheckinerror.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.title = title;
                    vm.error = error;
                    vm.hideClose = hideClose;
                    vm.isDMSError = isDMSError;

                    vm.close = function (choice) {
                        $uibModalInstance.close(choice);
                    };
                }],
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'yes-no-modal',
                windowClass: 'yes-no-dialog'
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showYesNo(title, body, noText, yesText, hideClose, showCancelButton) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/yesno.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.title = title;
                    vm.body = body;
                    vm.noText = noText;
                    vm.yesText = yesText;
                    vm.hideClose = hideClose;
                    vm.showCancel = showCancelButton;

                    vm.close = function (choice) {
                        $uibModalInstance.close(choice);
                    };
                }],
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'yes-no-modal',
                windowClass: 'yes-no-dialog'
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }
        
        function showSendForApproval(title, body, dealerId, roId, servicesToAuthorize, customerData, authMessage) {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/sendforapproval.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;
                    
                    vm.title = title;
                    vm.body = body;
                    vm.alternateCustomer = {
                        firstName: customerData.alternateFirstName,
                        lastName: customerData.alternateLastName,
                        phone: customerData.alternatePhone
                    }; 
                    vm.customer = {
                        name: customerData.name,
                        phone: customerData.phoneNumber
                    };
                    vm.messageBody = authMessage;

                    vm.close = function () {
                        $uibModalInstance.close({success: true, error: null, cancel: true});
                    };

                    vm.save = function () {                         
                        if (vm.isAlternateChecked && (!vm.alternateCustomer.firstName || !vm.alternateCustomer.lastName || !vm.alternateCustomer.phone)) {
                            return showError('Please enter the alternate contact information.', null, true);              
                        }

                        vm.isLoading = true;                        
                        const alternateContact = vm.isAlternateChecked ? vm.alternateCustomer : null;
                        const customerPhone = vm.isCustomerChecked ? vm.customer.phone : null;
                        
                        roService.sendAuthorizationsToCustomer(dealerId, roId, servicesToAuthorize, customerPhone, alternateContact, vm.messageBody).then(() => {
                            vm.isLoading = false;
                            $uibModalInstance.close({success: true, error: null, cancel: false});
                        }).catch((error) => {
                            vm.isLoading = false;
                            $uibModalInstance.close({success: false, error: error, cancel: false});
                        });
                    };
                }],
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'yes-no-modal',
                windowClass: 'yes-no-dialog'
            });

            return modal.result;
        }

        function showTripCancel(cancellationReasons, trip, bookingRules) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/canceltrip.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.trip = trip;
                    vm.reasons = cancellationReasons;
                    vm.bookingRules = bookingRules;
                    vm.formData = {
                        cancellationReason: null,
                        otherDescription: null,
                        notifyCustomer: false
                    };

                    if (vm.trip.rideProviderType !== SYSTEM_ENUMS.rideProviderType.lyft && vm.trip.rideProviderType !== SYSTEM_ENUMS.rideProviderType.uber) {
                        vm.cancelWarningMessage = 'Note this trip may have a Driver Return segment. You may cancel this trip, however we will not cancel the Driver Return if in progress.';
                    }

                    vm.nevermind = function (choice) {
                        $uibModalInstance.close(null);
                    };

                    vm.cancelTrip = function () {
                        if ($scope.cancelForm.$valid) {
                            $uibModalInstance.close(vm.formData);
                        }
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showAppointmentCancel(cancellationReasons, appt) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/cancelappointment.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.appt = appt;
                    vm.reasons = cancellationReasons;
                    vm.formData = {
                        cancellationReason: null,
                        otherDescription: null,
                        notifyCustomer: false
                    };

                    vm.nevermind = function (choice) {
                        $uibModalInstance.close(null);
                    };

                    vm.cancelAppointment = function () {
                        if ($scope.cancelForm.$valid) {
                            $uibModalInstance.close(vm.formData);
                        }
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showAppointmentNoShow(appt) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/noshowappointment.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.appt = appt;
                    vm.formData = {
                        notifyCustomer: true
                    };

                    vm.nevermind = function (choice) {
                        $uibModalInstance.close(null);
                    };

                    vm.noshowAppointment = function () {
                        if ($scope.cancelForm.$valid) {
                            $uibModalInstance.close(vm.formData);
                        }
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showNewServiceOrderWarning(roNumber) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/newserviceorderwarning.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.formData = {
                        roNumber: roNumber
                    };

                    vm.close = function (choice) {
                        $uibModalInstance.close(false);
                    };

                    vm.createServiceOrder = function () {
                        $uibModalInstance.close(true);
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showPhotoCapture(handleCaptureFn, mediaType, mediaLimit) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/show-photo-capture.html',
                controllerAs: 'vm',
                windowClass: 'top-modal camera-active',
                controller: ["$scope", "$uibModalInstance", "rcUtilService", "$interval", "toastr", "$log", function ($scope, $uibModalInstance, rcUtilService, $interval, toastr, $log) {
                    let vm = this;

                    vm.photoCount = 0;
                    vm.videoCount = 0;
                    vm.isVideo = mediaType === '2';
                    vm.isRecording = false;
                    vm.messages = [];
                    vm.componentIsSupported = true;
                    vm.videoTimer = '';
                    vm.videoTimerSeconds = 0;
                    vm.mediaType = mediaType;
                    vm.isRecording = false;
                    vm.isRecordingPaused = false;
                    vm.videoTimerSeconds = 0;
                    vm.videoTimer = '00:00';

                    let width = window.innerWidth;
                    let height = window.innerHeight;
                    let streaming = false; // streaming indicates whether or not we're currently streaming from the camera
                    let videoEl = null;
                    let canvasEl = null;
                    let audioEl = null;
                    let cameraStream = null;
                    let mediaRecorder = null;
                    let blobsRecorded = [];
                    let recorderMimeType = null;
                    let videoTimerInterval = null;

                    $uibModalInstance.rendered.then((rendered) => {
                        vm.init();
                    });

                    $uibModalInstance.closed.then((closed) => {
                        stopRecording();

                        try {
                            // Turn off camera
                            videoEl.pause();
                            videoEl.srcObject.getTracks().forEach((track) => track.stop());
                            videoEl.src = '';
                        } catch (e) {
                            console.error('ERROR TURNING OFF CAMERA VIDEO: ', e);
                        }
                    });

                    vm.finished = function () {
                        $uibModalInstance.close();
                    };

                    vm.init = function () {
                        videoEl = document.getElementById("photo-capture-surface");
                        canvasEl = document.getElementById("photo-capture-canvas");
                        audioEl = document.getElementById("camera-sound");

                        try {
                            navigator.permissions.query({name: 'camera'})
                                .then((permissionStatus) => {
                                    return requestCameraWithPrePrompt(permissionStatus.state === 'prompt');
                                })
                                .catch(() => {
                                    return requestCameraWithPrePrompt(false);
                                })
                                .then((stream) => {
                                    cameraStream = stream;
                                    videoEl.srcObject = cameraStream;
                                    videoEl.play();
                                })
                                .catch((err) => {
                                    $log.error('Error accessing camera and microphone', err);
                                });

                            videoEl.addEventListener(
                                "canplay",
                                (ev) => {
                                    if (!streaming) {
                                        height = videoEl.videoHeight / (videoEl.videoWidth / width);

                                        videoEl.setAttribute("width", width);
                                        videoEl.setAttribute("height", height);
                                        canvasEl.setAttribute("width", width);
                                        canvasEl.setAttribute("height", height);
                                        streaming = true;
                                    }
                                },
                                false
                            );

                            clearphoto();
                        } catch (exe) {
                            console.error('ERROR: IN INIT METHOD:', exe);
                        }
                    };

                    function requestCameraWithPrePrompt(showPrePrompt) {
                        if (showPrePrompt) {
                            toastr.info('To avoid being asked for camera access repeatedly, select "Always allow" in your browser settings for this site.', 'Camera Permission', {
                                timeOut: 8000,
                                extendedTimeOut: 3000,
                                closeButton: true,
                                positionClass: 'toast-top-full-width',
                                tapToDismiss: true
                            });
                        }
                        
                        return navigator.mediaDevices.getUserMedia({
                            video: {facingMode: 'environment'},
                            audio: true
                        });
                    }

                    function clearphoto() {
                        let context = canvasEl.getContext("2d");

                        context.fillStyle = "#AAA";
                        context.fillRect(0, 0, canvasEl.width, canvasEl.height);
                    }

                    function stopRecording() {
                        try {
                            if (videoTimerInterval) {
                                $interval.cancel(videoTimerInterval);
                                vm.videoTimerSeconds = 0;
                                videoTimerInterval = null;
                                vm.videoTimer = '00:00';
                            }

                            if (vm.isRecording) {
                                mediaRecorder.stop();
                                vm.isRecording = false;
                                vm.isRecordingPaused = false;
                            }
                        } catch (e) {
                            console.log('there was an error trying to stop recording');
                        }
                    }

                    function processCapture(fileBlob) {
                        if (handleCaptureFn) {
                            handleCaptureFn(fileBlob);

                            if (mediaLimit === "1") {
                                vm.finished();
                            }
                        }
                    }

                    function startTimer() {
                        if (!videoTimerInterval) {
                            videoTimerInterval = $interval(() => {
                                vm.videoTimer = new Date(vm.videoTimerSeconds * 1000).toISOString().substring(14, 19);
                                vm.videoTimerSeconds++;

                                if (vm.videoTimerSeconds >= 300) {
                                    stopRecording();
                                    vm.showRecordingLimit = true;
                                }
                            }, 1000);
                        }
                    }

                    function stopTimer() {
                        if (videoTimerInterval) {

                            $interval.cancel(videoTimerInterval);
                            videoTimerInterval = null;
                        }
                    }

                    vm.togglePauseResume = function () {
                        if (vm.isRecording && !vm.isRecordingPaused) {
                            mediaRecorder.pause();
                            vm.isRecordingPaused = true;
                            stopTimer();
                        } else if (vm.isRecording && vm.isRecordingPaused) {
                            mediaRecorder.resume();
                            vm.isRecordingPaused = false;
                            startTimer();
                        }
                    };

                    // Capture a photo by fetching the current contents of the video
                    // and drawing it into a canvas, then converting that to a PNG
                    // format data URL. By drawing it on an offscreen canvas and then
                    // drawing that to the screen, we can change its size and/or apply
                    // other changes before drawing it.
                    vm.takePicture = function () {
                        try {
                            // Take Photo
                            if (!vm.isVideo) {
                                let context = canvasEl.getContext("2d");

                                if (width && height) {
                                    canvasEl.width = width;
                                    canvasEl.height = height;
                                    context.drawImage(videoEl, 0, 0, width, height);

                                    // Play camera sound
                                    try {
                                        audioEl.play();
                                    } catch (audioErr) {
                                        // do nothing for now
                                    }

                                    canvasEl.toBlob((blob) => {
                                        vm.photoCount++;

                                        processCapture(blob);
                                    });
                                } else {
                                    clearphoto();
                                }
                            } else {
                                // Record video
                                if (!vm.isRecording) {
                                    let recorderInfo = {mimeType: ''};

                                    mediaRecorder = rcUtilService.getMediaRecorder(cameraStream, recorderInfo);
                                    recorderMimeType = recorderInfo.mimeType;
                                    blobsRecorded = []; // Clear previous blobs
                                    mediaRecorder.addEventListener('dataavailable', (e) => {
                                        // Only push blobs when not paused
                                        if (e.data && e.data.size > 0 && !vm.isRecordingPaused) {
                                            blobsRecorded.push(e.data);
                                        }
                                    });

                                    mediaRecorder.addEventListener('stop', () => {
                                        let videoBlob = new Blob(blobsRecorded, {type: recorderMimeType});

                                        vm.videoCount++;
                                        processCapture(videoBlob);
                                    });

                                    mediaRecorder.start(1000);
                                    vm.isRecording = true;
                                    vm.isRecordingPaused = false;
                                    vm.videoTimerSeconds = 0;
                                    startTimer();
                                } else {
                                    // If paused and user clicks main button again, stop recording
                                    stopRecording();
                                }
                            }
                        } catch (e) {
                            console.error('error capturing photo: ', e);
                        }
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showImageViewer(image, title, type, downloadLinkFn, deleteAction, disableDownload) {
            let deferred = $q.defer();
            let imageType = type || 1;
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/imageviewer.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;
                  
                    vm.mediaTypes = SYSTEM_ENUMS.mediaTypes;
                    vm.image = image;
                    vm.type = imageType;
                    vm.title = title;
                    vm.downloadLinkFn = downloadLinkFn;
                    vm.deleteAction = deleteAction;
                    vm.videoError = false;
                    vm.disableDownload = disableDownload;

                    vm.handleVideoError = function() {
                        vm.videoError = true;
                    };
                    
                    vm.downloadClicked = function () {
                        if (!downloadLinkFn) {
                            return vm.image;
                        }

                        vm.downloadLoading = true;

                        downloadLinkFn().then((promiseResult) => {
                            vm.dlResult = promiseResult;
                        }).finally(() => {
                            vm.downloadLoading = false;
                            $window.open(vm.dlResult);
                        });
                    };

                    vm.close = function (choice) {
                        $uibModalInstance.close(false);
                    };

                    vm.delete = function () {
                        showYesNo(
                            'Delete Media',
                            'Are you sure you want to delete the selected media?',
                            'No',
                            'Yes',
                            false,
                            false
                        ).then((confirmed) => {
                            if (confirmed) {
                                vm.deleteAction();
                                vm.close();
                            }
                        });
                    };

                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showCustomTerms(terms) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/customterms.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.terms = terms;

                    vm.close = function (choice) {
                        $uibModalInstance.close(false);
                    };

                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showHelpModal(icon, iconAlt, title, helpText, closeOnStateChange, yesText) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/helpmodal.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.icon = icon;
                    vm.iconAlt = iconAlt;
                    vm.title = title;
                    vm.helpText = helpText;
                    vm.yesText = yesText;

                    vm.close = function (choice) {
                        $uibModalInstance.close(choice);
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            if (closeOnStateChange) {
                let listener = $transitions.onStart({}, () => {
                    modal && modal.close();
                    listener && listener();
                });
            }

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showTutorial(tutorial, allowCloseWithoutViewing) {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/slideshow.html',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'tutorial-modal',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.tutorial = tutorial;
                    vm.disableClose = !allowCloseWithoutViewing && (tutorial.viewingRequired && (tutorial.slides.length > 1 || tutorial.slides[0].isVideo));

                    vm.afterSlideChange = function (currentSlideIndex) {
                        vm.message = vm.tutorial.slides[currentSlideIndex].message;

                        if (vm.tutorial.viewingRequired && vm.tutorial.slides.length === currentSlideIndex + 1) {
                            vm.disableClose = false;
                        }

                        $rootScope.$broadcast('stopVideo');
                    };

                    $rootScope.$on('videoEnded', () => {
                        vm.disableClose = false;
                    });

                    vm.close = function (choice) {
                        // Ensure the modal and UI are closed before trying to show another modal.
                        $uibModalInstance.closed.then(() => {
                            userService.setSeenTutorial(tutorial.id);

                            let user = authService.getCurrentUser();

                            _.remove(user.unseenTutorials, (t) => {
                                return t.id === tutorial.id;
                            });

                            if (!allowCloseWithoutViewing) {
                                showYesNo('View Later', 'This tutorial can be accessed from the Training and User Guides section under Support', null, 'Ok');
                            }
                        });

                        $uibModalInstance.close(choice);
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });
        }

        function showFeatureUpgradeMessage(message, title) {
            $uibModal.open({
                templateUrl: 'app/shared/modal/upgrade-message.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.message = message || 'You do not have access to this feature. Please contact support to enable access.';
                    vm.title = title || 'Upgrade to Gain Access';

                    vm.close = function () {
                        $uibModalInstance.close();
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });
        }

        function showManageLocations(dealerId, favoriteLocations, placesOptions, selectedForDeletion, newLocations, forVenues, dealerLocation) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/managelocations.html',
                controllerAs: 'vm',
                windowTopClass: 'locations-modal',
                windowClass: 'top-modal locations-dialog',
                controller: ["$scope", "$uibModalInstance", "SYSTEM_ENUMS", function ($scope, $uibModalInstance, SYSTEM_ENUMS) {
                    newLocations = newLocations || [];

                    let vm = this;
                    let formData = {
                        deletedLocations: null,
                        newLocations: newLocations
                    };

                    let map;
                    let forceClose = false;

                    vm.favoriteLocations = _.cloneDeep(favoriteLocations);
                    vm.options = placesOptions;
                    vm.newLocationName = null;
                    vm.mapCoords = {
                        lat: null,
                        lng: null
                    };

                    initializeNewLocation();
                    getAddressFromLatLng(dealerLocation.lat, dealerLocation.lng);

                    vm.newLocationAddressUpdated = function (formattedAddress) {
                        if (formattedAddress && formattedAddress.location && formattedAddress.location.lat) {
                            vm.newLocation.formattedAddress = formattedAddress;

                            setCenter(formattedAddress.location.lat, formattedAddress.location.lng);
                        }
                    };

                    vm.addFavoriteLocation = function () {
                        if ($scope.manageLocationsForm.$valid) {
                            if (!vm.newLocation.formattedAddress || !vm.newLocation.formattedAddress.location) {
                                vm.invalidAddress = true;

                                return;
                            } else {
                                vm.invalidAddress = false;
                            }

                            let loc = vm.newLocation.formattedAddress.location;
                            let newLocation = {
                                name: vm.newLocation.name,
                                dealerId: dealerId,
                                streetNumber: loc.streetNumber,
                                address: loc.streetAddress,
                                city: loc.city,
                                state: loc.state,
                                zip: loc.zip,
                                countryShortCode: loc.countryShortCode,
                                lat: loc.lat,
                                lng: loc.lng,
                                new: true,
                                isVenueLocation: forVenues
                            };

                            newLocations.push(newLocation);
                            vm.favoriteLocations.push(newLocation);
                            $scope.manageLocationsForm.$setPristine();
                            $scope.manageLocationsForm.$setUntouched();
                            $scope.manageLocationsForm.$isSubmitted = false;
                            initializeNewLocation();
                        }
                    };

                    vm.cancel = function (choice) {
                        let locationsToDelete = locationsSelectedForDeletion();

                        formData = {
                            cancelled: true,
                            locationsToDelete: locationsToDelete,
                            newLocations: newLocations
                        };

                        $uibModalInstance.close(formData);
                    };

                    vm.save = function () {
                        let locationsToDelete = locationsSelectedForDeletion();

                        formData = {
                            cancelled: false,
                            locationsToDelete: locationsToDelete,
                            newLocations: newLocations
                        };

                        $uibModalInstance.close(formData);
                    };

                    vm.toggleSelection = function (item) {
                        item.isRowSelected = !item.isRowSelected;
                    };

                    vm.mapLoaded = function (redcapMap) {
                        map = redcapMap;
                    };

                    $scope.$on('modal.closing', (event, reason, closed) => {
                        if (!forceClose) {
                            event.preventDefault();
                        } else {
                            return;
                        }

                        let confirm = null;

                        if (formData.cancelled && (formData.locationsToDelete.length > 0 || formData.newLocations.length > 0)) {
                            confirm = showYesNo('Please Confirm', 'You had unsaved changes, are you sure you wish to cancel?', 'No', 'Yes');
                        } else if (!formData.cancelled && formData.locationsToDelete.length > 0) {
                            confirm = showYesNo('Please Confirm', 'Are you sure you wish to delete the selected locations?  This will remove the location from all trip types for which it is used.', 'No', 'Yes');
                        } else {
                            forceClose = true;
                            $uibModalInstance.close(formData);

                            return;
                        }

                        confirm.then((confirmed) => {
                            if (confirmed) {
                                forceClose = true;
                                $uibModalInstance.close(formData);
                            }
                        });
                    });


                    function getAddressFromLatLng(lat, lng) {
                        hereMapsService.reverseGeocode(parseFloat(lat), parseFloat(lng)).then((location) => {
                            if (location) {
                                vm.newLocation.formattedAddress = {location: location};
                                vm.newLocation.address = location.name || location.formattedAddress || (location.streetAddress + ' ' + location.city + ', ' + location.state);
                            }

                            vm.newLocation.formattedAddress.location.lat = lat;
                            vm.newLocation.formattedAddress.location.lng = lng;
                        });
                    }

                    function initializeNewLocation() {
                        vm.newLocation = {
                            name: null,
                            address: null,
                            formattedAddress: null
                        };
                    }

                    function locationsSelectedForDeletion() {
                        let selectedForDeletion = [];

                        selectedForDeletion = $filter('filter')(vm.favoriteLocations, {isRowSelected: true});

                        return selectedForDeletion;
                    }

                    if (newLocations) {
                        _.forEach(newLocations, (item) => {
                            vm.favoriteLocations.push(item);
                        });
                    }

                    if (selectedForDeletion) {
                        _.forEach(selectedForDeletion, (delItem) => {
                            _.forEach(vm.favoriteLocations, (item) => {
                                if (item.id === delItem.id) {
                                    item.isRowSelected = true;
                                }
                            });
                        });
                    }

                    // Map management
                    let venueMarker;

                    vm.mapOptions = {
                        forceHideRecenter: true,
                        showControls: true,
                        eventListeners: {
                            // HERE attaches these "drag" events to *both* the map and the marker,
                            //  so we have to determine the event target and udpate the map accordingly.
                            dragend: function (evt) {
                                let setMarkerToCenter = true;

                                if (isMarkerEvent(evt)) {
                                    let markerPosition = evt.target.getGeometry();

                                    map.setCenter(markerPosition);
                                    setMarkerToCenter = false;
                                }

                                updatePosition(true, setMarkerToCenter);
                            },
                            drag: function (evt) {
                                let setMarkerToCenter = false;

                                if (!isMarkerEvent(evt)) {
                                    setMarkerToCenter = true;
                                }

                                updatePosition(false, setMarkerToCenter);
                            }
                        }
                    };

                    function isMarkerEvent(evt) {
                        if (evt.target.getData) {
                            let targetData = evt.target.getData();

                            return targetData.objectType === SYSTEM_ENUMS.hereObjectType.marker;
                        }

                        return false;
                    }

                    function loadMap() {
                        let markerData = {
                            stopType: SYSTEM_ENUMS.destinationType.genericDropoff,
                            address: dealerLocation,
                            lat: dealerLocation.lat,
                            lng: dealerLocation.lng,
                            options: {
                                hidePopup: true,
                                draggable: true
                            }
                        };

                        $scope.$broadcast('updateMapObjects', [markerData]);

                        venueMarker = map.getMarkers()[0];
                    }

                    function setCenter(lat, lng) {
                        let center = {lat: lat, lng: lng};

                        map.setCenter(center);
                        venueMarker.setGeometry(center);

                        vm.mapCoords.lat = lat;
                        vm.mapCoords.lng = lng;
                    }

                    function updatePosition(setAddress, setMarkerToCenter) {
                        let mapCenter = map.getCenter();

                        if (setMarkerToCenter) {
                            venueMarker.setGeometry(mapCenter);
                            vm.mapCoords.lat = mapCenter.lat;
                            vm.mapCoords.lng = mapCenter.lng;
                        } else {
                            let markerPosition = venueMarker.getGeometry();

                            vm.mapCoords.lat = markerPosition.lat;
                            vm.mapCoords.lng = markerPosition.lng;
                        }

                        if (setAddress)
                            getAddressFromLatLng(vm.mapCoords.lat, vm.mapCoords.lng);

                        // Ensure the mapCoord labels get update in the UI.
                        $scope.$digest();
                    }

                    $rootScope.$on('modalLoaded', () => {
                        setTimeout(() => { loadMap(); }, 500);
                    });
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.rendered.then(() => {
                $rootScope.$emit('modalLoaded');
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }


        function arriveAppointment(appt, departments) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/appointments/arrive-appointment.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["rcUtilService", "$uibModalInstance", "appointmentUtilService", "appointmentService", "locationService", "APPOINTMENT_APPOINTMENTSTATUS", function (rcUtilService, $uibModalInstance, appointmentUtilService, appointmentService, locationService, APPOINTMENT_APPOINTMENTSTATUS) {
                    let vm = this;

                    vm.dealerId = appt.dealerId;
                    vm.isSaving = false;
                    vm.errors = [];
                    vm.appt = appt;

                    vm.initializing = true;

                    function hasDataChanged() {
                        let fullAppt = vm.fullAppointment;

                        if (vm.mobilePhone !== fullAppt.customerPhone ||
                            vm.selectedDepartmentId !== fullAppt.departmentId ||
                            vm.selectedAdvisor.id !== fullAppt.dealerEmployeeId
                        ) return true;

                        return false;
                    }

                    function closeForm(cancelled) {
                        let formData = {};

                        if (cancelled) {
                            formData.cancelled = true;
                        }

                        $uibModalInstance.close(formData);
                    }

                    vm.resetErrors = function () {
                        vm.errors = [];
                    };

                    vm.setAdvisor = function () {
                        if (vm.dealerEmployeeId) {
                            let advisor = $filter('filter')(vm.serviceAdvisors, {id: vm.dealerEmployeeId}, true);

                            if (advisor && advisor.length) {
                                vm.selectedAdvisor = advisor[0];
                            }

                        } else {
                            vm.selectedAdvisor = null;
                        }
                    };

                    // need to get the department advisors with their availability
                    vm.loadDepartmentAdvisors = function (initalizing) {
                        let deptId = vm.selectedDepartmentId;

                        if (deptId) {
                            vm.loadingAdvisors = true;
                            locationService.getLocationDepartmentAvailAdvisor(vm.dealerId, deptId).
                                then((result) => {
                                    vm.serviceAdvisors = result.advisors;

                                    if (vm.serviceAdvisors.length === 1) {
                                        vm.selectedAdvisor = vm.serviceAdvisors[0];
                                    } else if (initalizing) {
                                        vm.setAdvisor();
                                    }

                                    vm.initializing = false;
                                    vm.loadingAdvisors = false;
                                });
                        } else {
                            vm.serviceAdvisors = null;
                            vm.selectedAdvisor = null;
                            vm.advisorChanged();
                        }
                    };

                    vm.departmentChanged = function () {
                        vm.serviceAdvisors = null;
                        vm.selectedAdvisor = null;
                        vm.loadDepartmentAdvisors();
                    };

                    vm.getAdvisorAvailTime = function (advisor) {
                        let fullAppt = vm.fullAppointment;

                        return appointmentService.getAdvisorAvailTime(fullAppt, advisor);
                    };

                    vm.cancel = function () {
                        closeForm(true);
                    };

                    vm.validation = {
                        isValidDepartment: function () {
                            return appointmentUtilService.validateDepartment(vm.dealerDepartments, vm.selectedDepartmentIdepartmentId);
                        }
                    };

                    vm.invalidForm = function () {
                        return rcUtilService.isEmpty(vm.mobilePhone) || !vm.selectedDepartmentId || !vm.selectedAdvisor;
                    };

                    vm.arriveAppointment = function () {
                        if (hasDataChanged()) {
                            vm.fullAppointment.customerPhone = vm.mobilePhone;
                            vm.fullAppointment.departmentId = vm.selectedDepartmentId;
                            vm.fullAppointment.dealerEmployeeId = vm.selectedAdvisor.id;
                            vm.fullAppointment.serviceAdvisorNumber = vm.selectedAdvisor.employeeNumber;
                            vm.fullAppointment.appointmentStatus = APPOINTMENT_APPOINTMENTSTATUS.checkingIn;
                            vm.fullAppointment.disableNotifications = true;
                            vm.fullAppointment.disableSendLoanerHomework = true;
                            vm.isSaving = true;
                            appointmentService.createOrUpdateAppointment(vm.dealerId, vm.fullAppointment, true)
                            .then((result) => {
                                if (result && !result.errors && !result.dmsSyncError) {
                                    vm.errors = [];
                                    closeForm();
                                } else if (result && result.dmsSyncError) {
                                    vm.errors = [result.dmsSyncError];
                                } else if (result && result.errors && result.errors.length > 0) {
                                    vm.errors = result.errors;
                                } else {
                                    vm.errors = ['Sorry, there was a problem saving your appointment.'];
                                }

                                vm.isSaving = false;
                            });

                        } else {
                            appointmentService.arriveAppointment(vm.dealerId, appt.id).then((result) => {
                                vm.isSaving = false;
                            }, (errorResponse) => {
                                vm.isSaving = false;
                            });
                        }

                        // check to see if any of the data changed, and if so, update the appointment
                        // if not just update the status
                        closeForm(false);
                    };

                    vm.initializing = true;
                    appointmentService.getAppointment(vm.dealerId, vm.appt.id).then((appointment) => {
                        vm.fullAppointment = appointment;
                        vm.mobilePhone = vm.fullAppointment.customerPhone;
                        vm.dealerDepartments = departments;
                        vm.selectedDepartmentId = vm.fullAppointment.departmentId;
                        vm.serviceAdvisors = null;
                        vm.dealerEmployeeId = vm.fullAppointment.dealerEmployeeId;
                        vm.loadDepartmentAdvisors(true);
                    });

                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function sendDriverMessage(driver) {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/messages/send-driver-message.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", "driverService", function ($scope, $uibModalInstance, driverService) {
                    let vm = this;

                    vm.sendMessage = function () {
                        vm.sendingMessage = true;
                        driverService.messageDriver(driver.username, vm.message)
                            .then((result) => {
                                if (result === true)
                                    vm.messageStatus = 'Message Sent';
                                else
                                    vm.messageStatus = 'Unable to send message.';
                            }).catch((error) => {
                                vm.messageStatus = 'Unable to send message.';
                            }).finally(() => {
                                vm.messageSent = true;
                                vm.sendingMessage = false;
                            }
                            );
                    };

                    vm.cancel = function () {
                        $uibModalInstance.close();
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            return modal.result;
        }

        function processLyftRefunds(recalls) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/lyft-refunds.html',
                windowClass: 'top-modal',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", "rideProviderService", "toastr", function ($uibModalInstance, rideProviderService, toastr) {
                    let vm = this;

                    vm.refunds = '';

                    vm.close = function () {
                        $uibModalInstance.close();
                    };

                    vm.submit = function () {
                        vm.isLoading = true;
                        rideProviderService.applyRefunds(vm.refunds).then((result) => {
                            vm.isLoading = false;

                            if (!result.notFoundTrips.length) {
                                toastr.success('All refunds were added successfully');
                                $uibModalInstance.close();
                            } else {
                                vm.notFoundTrips = result.notFoundTrips.toString();
                            }
                        },
                            (err) => {
                                vm.isLoading = false;
                                vm.error = err;
                            });
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showLandlineWarning() {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/landline-warning.html',
                backdrop: 'static',
                windowClass: 'top-modal',
                keyboard: false
            });

            modal.result.then(() => {
                deferred.resolve();
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showVoIPWarning() {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/voip-warning.html',
                backdrop: 'static',
                windowClass: 'top-modal',
                keyboard: false
            });

            modal.result.then(() => {
                deferred.resolve();
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showOptedOutWarning(phoneDetail) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/optedout-warning.html',
                backdrop: 'static',
                windowClass: 'top-modal',
                keyboard: false,
                controllerAs: 'vm',
                controller: function () {
                    let vm = this;

                    vm.detail = phoneDetail;
                }
            });

            modal.result.then(() => {
                deferred.resolve();
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showAddAddressModal(addressInput) {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/add-address/add-address-modal.view.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                backdrop: 'static',
                resolve: {
                    resolvedAddress: function () {
                        return addressInput;
                    }
                },
                controller: ["$uibModalInstance", "SYSTEM_ENUMS", function ($uibModalInstance, SYSTEM_ENUMS) {
                    let vm = this;

                    vm.usStates = SYSTEM_ENUMS.usStates;
                    vm.canadianProvinces = SYSTEM_ENUMS.canadianProvinces;
                    vm.address = {
                        city: null,
                        streetAddress: addressInput,
                        state: null,
                        zip: null,
                        countryShortCode: 'USA',
                        lat: null,
                        lng: null
                    };

                    vm.close = $uibModalInstance.close;

                    vm.saveAddress = function () {
                        vm.address.formattedAddress = vm.address.streetAddress + ', ' + vm.address.city + ', ' + vm.address.state + ' ' + vm.address.zip;
                        $uibModalInstance.close(vm.address);
                    };
                }]
            });

            return modal.result;
        }

        function showCopyDriverTasksResults(results) {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/copy-tasks-results.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                backdrop: 'static',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.excludedWorkflows = results.excludedWorkflows;

                    vm.close = $uibModalInstance.close;
                }]
            });

            return modal.result;
        }

        function showDuplicateCustomerModal(customers) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/appointments/duplicate-customer.modal.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                backdrop: 'static',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    _.forEach(customers, (customer) => {
                        customer.uniqueId = (customer.customerId || '0') + '|' + (customer.custNo || '0');
                    });

                    vm.customers = customers;
                    vm.chosenCustomer = vm.customers[0].uniqueId;

                    vm.newCustomer = function () { $uibModalInstance.close(null); };

                    vm.selectedCustomer = function () {
                        let chosenCustomer = _.find(vm.customers, (c) => {
                            return c.uniqueId === vm.chosenCustomer;
                        });

                        $uibModalInstance.close(chosenCustomer);
                    };
                }]
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showVinScanModal() {
            return new Promise((resolve, reject) => {
                let modal = $uibModal.open({
                    templateUrl: 'app/shared/modal/vin-scanner.html',
                    controllerAs: 'vm',
                    windowClass: 'top-modal',
                    controller: ["$scope", "$timeout", "$uibModalInstance", function ($scope, $timeout, $uibModalInstance) {
                        let vm = this;

                        vm.title = "VIN Scan";
                        vm.loading = vinScanService.isLoading;

                        vm.cancel = function () {
                            $uibModalInstance.close();
                        };

                        $timeout(() => {
                            let containerElement = angular.element('#vin-scan-modal-body')[0];

                            vinScanService.showVinScanner(containerElement).then((vin) => {
                                $uibModalInstance.close();

                                return resolve(vin);

                            }).catch((ex) => {
                                alert('VIN scan error: ' + ex);
                                $uibModalInstance.close();

                                return reject(ex);
                            });
                        });

                        // Ensure scanner is destroyed on any modal close
                        $uibModalInstance.closed.then(() => {
                            vinScanService.destroyScannerInstance();
                        });
                    }]
                });

            });

        }

        function showVinNotFound(vin, location, ymm, bookingType) {
            return $uibModal.open({
                templateUrl: 'app/shared/modal/vin-not-found.html',
                windowClass: 'top-modal',
                controller: ["$scope", "$uibModalInstance", function($scope, $uibModalInstance) {
                $scope.vin = vin;
                $scope.ymm = ymm;
                $scope.dealerName = location ? location.name : null;
                $scope.bookingType = bookingType;

                $scope.confirm = function() { 
                    $uibModalInstance.close(true); 
                };

                $scope.cancel = function() { 
                    $uibModalInstance.dismiss(); 
                    };
                }]
            }).result;
        }

        function showLicenseScanModal() {
            return new Promise((resolve, reject) => {
                let modal = $uibModal.open({
                    templateUrl: 'app/shared/modal/vin-scanner.html',
                    controllerAs: 'vm',
                    windowClass: 'top-modal',
                    controller: ["$scope", "$timeout", "$uibModalInstance", function ($scope, $timeout, $uibModalInstance) {
                        let vm = this;

                        vm.title = "License Scan";
                        vm.loading = vinScanService.isLoading;

                        vm.cancel = function () {
                            vinScanService.destroyScannerInstance();
                            $uibModalInstance.close();
                        };

                        $timeout(() => {
                            let containerElement = angular.element('#vin-scan-modal-body')[0];

                            driversLicenseScanService.showDriversLicenseScanner(containerElement).then((result) => {
                                driversLicenseScanService.destroyScannerInstance();
                                $uibModalInstance.close();

                                return resolve(result);

                            }).catch((ex) => {
                                return reject(ex);
                            });
                        });
                    }]
                });

            });
        }

        function showBenefitBatchUpdateConfirm() {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/benefitbatchupdateconfirm.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.selectAll = function () {
                        $uibModalInstance.close({skipModified: false});
                    };

                    vm.skipModified = function () {
                        $uibModalInstance.close({skipModified: true});
                    };

                    vm.dismiss = function () {
                        $uibModalInstance.dismiss();
                    };
                }],
                backdrop: 'static',
                keyboard: false
            });

            return modal.result;
        }

        function showGenericApptError() {
            this.showYesNo('Error', 'Sorry, there was a problem saving your appointment.', null, 'OK');
        }

        function showPhoneCapture() {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/show-phone-capture.html',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'top-modal',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.phoneCapture = '';
                    vm.isPhoneValid = false;

                    vm.close = function (response) {
                        $uibModalInstance.close(response);
                    };
                }]
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showReturnTripDetails(roDetails, loanerNumber, loanerCustomer, loanerDate) {
            let title = 'Validate Trip Details';
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/returntripdetails.html',
                controllerAs: 'vm',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.title = title;

                    if (roDetails) {
                        vm.roDetails = roDetails;
                        vm.appointmentDateTime = moment(vm.roDetails.updatedDate).format('MMM. DD, YYYY');
                    }

                    if (loanerNumber) {
                        vm.loanerNumber = loanerNumber;
                        vm.loanerCustomer = loanerCustomer;
                        vm.loanerDate = moment(loanerDate).format('MMM. DD, YYYY');
                    }

                    vm.close = function (choice) {
                        $uibModalInstance.close(choice);
                    };

                }],
                backdrop: 'static',
                keyboard: false,
                windowTopClass: 'yes-no-modal',
                windowClass: 'yes-no-dialog'
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function selectDefaultTripTypeUser(triptypes) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/select-default-trip-type-user.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                backdrop: 'static',
                controller: ["$uibModalInstance", "$scope", "triptypes", function ($uibModalInstance, $scope, triptypes) {
                    let vm = this;

                    $scope.triptypes = triptypes;

                    vm.userActive = '';

                    vm.chooseEmployee = function (user, dealerId) {
                        let index = triptypes.findIndex((trip) => trip.dealerId === dealerId);

                        triptypes[index].userSelected = user;
                    };

                    vm.areAllDropdownsFilled = function () {
                        return triptypes.every((trip) => trip.userSelected);
                    };

                    vm.close = function (response) {
                        $uibModalInstance.close(response);
                    };

                    vm.getSystemTripTypeName = function () {
                        if (triptypes) {
                            _.forEach(triptypes, (trip) => {
                                trip.descriptionTripTypesName = trip.dealerTripTypeNames
                                    .filter((item, index) => trip.dealerTripTypeNames.indexOf(item) === index) //Remove duplicates
                                    .join(", "); //Join the array into a string
                            });
                        }
                    };

                    vm.filterTripTypeEmployees = function () {
                        if (triptypes) {
                            _.forEach(triptypes, (trip) => {
                                trip.filteredEmployees = [];
                                trip.employees.forEach((employee) => {
                                    const hasProgramAdminRole = employee.roles.some(role => role === SYSTEM_ENUMS.roleNames.programAdmin);
                                    const hasSystemAdminRole = employee.roles.some(role => role === SYSTEM_ENUMS.roleNames.systemAdmin);
                                    const hasRedCapAdminRole = employee.roles.some(role => role === SYSTEM_ENUMS.roleNames.redCapAdmin);
                                    const hasProgramAdminFullAccess = (hasSystemAdminRole || hasRedCapAdminRole) && hasProgramAdminRole;
                                    const isValid = (hasProgramAdminFullAccess || !hasProgramAdminRole);

                                    if (isValid) {
                                        trip.filteredEmployees.push(employee);
                                    }
                                });

                                trip.filteredEmployees = _.orderBy(trip.filteredEmployees, [user => user.firstName.toLowerCase(), user => user.lastName.toLowerCase()], ['asc', 'asc']);
                            });
                        }
                    };

                    vm.getSystemTripTypeName();
                    vm.filterTripTypeEmployees();
                }],
                resolve: {
                    triptypes: function () {
                        return triptypes;
                    }
                }
            });

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }

        function showContactDriverHelp() {
            $uibModal.open({
                templateUrl: 'app/shared/modal/contactdriverhelp.html',
                controllerAs: 'vm',
                windowClass: 'top-modal modal-width-px-800',
                controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                    let vm = this;

                    vm.close = function (choice) {
                        $uibModalInstance.close(false);
                    };

                }],
                backdrop: 'static',
                keyboard: false
            });
        }

        function formatListForModal(heading, items) {

            let html = `<h4>${heading}</h4>`;

            if (!items || !items.length) {
                return html;
            }

            html += '<ul>';

            for (let i = 0; i < items.length; i++) {
                let item = items[i];

                html += `<li>${item}</li>`;
            }

            html += '</ul>';

            return html;
        }

        function selectServiceAdvisor(locations, title, body, currentUser, reassignmentRulesByLocationId) {
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/select-service-advisor.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                backdrop: 'static',
                keyboard: false,
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;

                    vm.title = title || 'Select New Service Advisors';
                    vm.body = body || 'This user is currently assigned as the service advisor on existing service orders.To reassign them, please choose the new service advisor for each location below.';
                    vm.locationDepartments = [];
                    vm.currentUser = currentUser;
                    vm.reassignmentRulesByLocationId = reassignmentRulesByLocationId;
                    vm.selectedAdvisors = {};
                    vm.loadingDepartments = true;
                    vm.loadingAdvisors = {};

                    function advisorMatchesUser(advisor, user, allowIdentityIdFallback) {
                        return !!user && (
                            advisor.id === user.id ||
                            advisor.employeeId === user.id ||
                            advisor.identityUserId === user.identityUserId ||
                            (allowIdentityIdFallback && advisor.identityUserId === user.id)
                        );
                    }

                    function buildLocDeptRow(location, department, includeDealerEmployee) {
                        const row = {
                            locationId: location.id,
                            locationName: location.name,
                            locationCity: location.city,
                            departmentId: department ? department.id : null,
                            departmentName: department ? department.name : null,
                            serviceAdvisors: [],
                            key: department ? (location.id + '_' + department.id) : (location.id + '_nodept')
                        };

                        if (includeDealerEmployee !== false) {
                            row.dealerEmployee = location.dealerEmployee;
                        }

                        return row;
                    }

                    let departmentPromises = locations.map((location) => {
                        let locationReassignmentRules = vm.reassignmentRulesByLocationId[location.id];
                        let allDepartmentIds = locationReassignmentRules.departmentIds;
                        let departmentIdsToReassign = allDepartmentIds.filter((departmentId) => { return departmentId != null; });
                        let shouldShowLocationLevelRow = locationReassignmentRules.requiresLocationLevelSelection || allDepartmentIds.some((departmentId) => { return departmentId == null; });

                        return locationService.getLocationDepartments(location.id, true).then((departments) => {
                                let departmentsToDisplay = departments || [];

                                departmentsToDisplay = departmentIdsToReassign.length > 0
                                    ? departmentsToDisplay.filter((dept) => { return departmentIdsToReassign.includes(dept.id); })
                                    : [];

                                let locationRows = departmentsToDisplay.map((dept) => { return buildLocDeptRow(location, dept); });

                                if (shouldShowLocationLevelRow || locationRows.length === 0) {
                                    locationRows.push(buildLocDeptRow(location, null));
                                }

                                vm.locationDepartments.push(...locationRows);
                            }).catch(() => {
                                vm.locationDepartments.push(buildLocDeptRow(location, null, false));
                            });
                    });

                    $q.all(departmentPromises).then(() => {
                        vm.loadingDepartments = false;
                        
                        vm.locationDepartments.forEach((locationDepartmentRow) => {
                            vm.loadingAdvisors[locationDepartmentRow.key] = true;

                            let advisorRequest = locationDepartmentRow.departmentId
                                ? locationService.getLocationDepartmentAvailAdvisor(locationDepartmentRow.locationId, locationDepartmentRow.departmentId, true)
                                : locationService.getServiceAdvisors(locationDepartmentRow.locationId, null, true, false, true);

                            advisorRequest.then((response) => {
                                let advisorList = response?.advisors || response;
                                let availableAdvisors = advisorList.filter((advisor) => {
                                    let isCurrentUser = advisorMatchesUser(advisor, vm.currentUser, true);
                                    let isCurrentLocationEmployee = advisorMatchesUser(advisor, locationDepartmentRow.dealerEmployee);

                                    return !isCurrentUser && !isCurrentLocationEmployee;
                                });

                                availableAdvisors.forEach((advisor) => {
                                    if (!advisor.fullName) {
                                        advisor.fullName = (advisor.firstName && advisor.lastName)
                                            ? (advisor.firstName + ' ' + advisor.lastName)
                                            : (advisor.name || ('Advisor ' + advisor.id));
                                    }
                                });

                                locationDepartmentRow.serviceAdvisors = availableAdvisors;
                            }).catch(() => {
                                locationDepartmentRow.serviceAdvisors = [];
                            }).finally(() => {
                                vm.loadingAdvisors[locationDepartmentRow.key] = false;
                            });
                        });
                    });

                    vm.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };

                    vm.save = function() {
                        let result = {};
                        
                        vm.locationDepartments.forEach((locationDepartmentRow) => {
                            if (vm.selectedAdvisors[locationDepartmentRow.key]) {
                                let locationKey = locationDepartmentRow.locationId;
                                
                                if (!result[locationKey]) {
                                    result[locationKey] = [];
                                }
                                
                                result[locationKey].push({
                                    locationId: locationDepartmentRow.locationId,
                                    departmentId: locationDepartmentRow.departmentId,
                                    advisor: vm.selectedAdvisors[locationDepartmentRow.key]
                                });
                            }
                        });
                        
                        $uibModalInstance.close(result);
                    };

                    vm.isAllSelectedValid = function() {
                        let hasUnavailableLocations = vm.locationDepartments.some((locationDepartmentRow) => {
                            return !vm.loadingAdvisors[locationDepartmentRow.key] && !locationDepartmentRow.serviceAdvisors.length;
                        });
                        
                        let allRequiredSelected = vm.locationDepartments.every((locationDepartmentRow) => {
                            if (vm.loadingAdvisors[locationDepartmentRow.key]) {
                                return true;
                            }

                            return vm.selectedAdvisors[locationDepartmentRow.key]?.id;
                        });

                        return !vm.loadingDepartments && !hasUnavailableLocations && vm.locationDepartments.length > 0 && allRequiredSelected;
                    };
                }]
            });

            return modal.result;
        }
        
        function showDealerList(dealerships, onConfirm, title) {
            let deferred = $q.defer();
            let modal = $uibModal.open({
                templateUrl: 'app/shared/modal/dealer-list-modal.html',
                controllerAs: 'vm',
                windowClass: 'top-modal',
                controller: ["$uibModalInstance", function ($uibModalInstance) {
                    let vm = this;
                    
                    vm.dealerships = dealerships;
                    vm.title = title || 'Select Dealership';

                    vm.submit = function () {
                        if (!onConfirm) {
                            $uibModalInstance.close(vm.selectedDealership);
                            
                            return;
                        }

                        onConfirm(vm.selectedDealership).then((confirmed) => {
                            if (confirmed) {
                                $uibModalInstance.close(vm.selectedDealership);
                            }
                        });
                    };

                    vm.cancel = function () {
                        $uibModalInstance.close();
                    };
                }],
                backdrop: 'static',
                keyboard: false
            }); 

            modal.result.then((result) => {
                deferred.resolve(result);
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }
    }
})();
(function () {
    'use strict';

    liberatedAsideService.$inject = ["$aside"];
    angular
        .module('redcap.services')
        .factory('liberatedAsideService', liberatedAsideService);

    function liberatedAsideService($aside) {
        let _openedAside = null;
            let _standardOptions = {
                container: 'body',
                placement: 'bottom',
                animation: false,
                backdrop: 'static', // prevents modal from being closed by clicking background
                show: false,
                html: true,
                keyboard: false,
                size: 'md',
            };

        return {
            showAddLineItem: showAddLineItem,
            closeLiberatedAside: closeLiberatedAside,
            showInspectionSummary: showInspectionSummary,
            showVehicleOverview: showVehicleOverview
        };

        /*
         * close the opened aside
         */
        function closeLiberatedAside (data) {
            if (_openedAside) {
                angular.element('body').removeClass('liberated-aside');
                _openedAside.close(data);
            }
        }

        /* 
         * if there is an aside open already, close it
         * then open the new one
         */
        function openLiberatedAside (options) {
            if (_openedAside) {
                closeLiberatedAside();
            }

            angular.element('body').addClass('liberated-aside');
            _openedAside = $aside.open(options);
      
            return _openedAside.result;
        }

        function showAddLineItem(ro, dealerId, task, inspectionSection) {
            let options = _standardOptions;
            
            options.templateUrl = 'app/shared/asides/inspect/partials/add-recommendation.html';
            options.windowClass = 'aside-centered';
            options.controller = 'AddLineItemController as vm';
            options.resolve = {
                resolvedDealerId: function () {
                    return dealerId;
                },
                resolvedRo: function () {
                    return ro;
                },
                resolvedTask: function () {
                    return task;
                },
                resolvedInspectionSection: function () {
                    return inspectionSection;
                }
            };

            return openLiberatedAside(options);
        }

        function showInspectionSummary(ro, fromConsumer, consumerKey) {
            const options = _standardOptions;

            options.templateUrl = 'app/areas/inspect/views/modals/inspection-summary-modal.view.html';
            options.windowClass = 'aside-centered aside-centered-top';
            options.controller = 'InspectionSummaryModalController as vm';
            options.resolve = {
                resolvedRo: function () { return ro; },
                resolvedFromConsumer: function() { return fromConsumer; },
                resolvedConsumerKey: function() { return consumerKey; }
            };

            openLiberatedAside(options);
        }

        function showVehicleOverview(ro, dealerId) {
            const options = _standardOptions;

            options.templateUrl = 'app/areas/inspect/views/modals/vehicle-overview-modal.view.html';
            options.windowClass = 'aside-centered aside-centered-top';
            options.controller = 'VehicleOverviewModalController as vm';
            options.resolve = {
                resolvedRo: function () { return ro; },
                resolvedDealerId: function() { return dealerId; }
            };
            
            openLiberatedAside(options);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.services')
        .factory('inputMapper', inputMapper);

    function inputMapper() {
        return {
            mapToTags: mapToTags,
            mapFromTags: mapFromTags,
            mapToTagsFromStringArray: mapToTagsFromStringArray,
            mapFromTagsToStringArray: mapFromTagsToStringArray
        };

        function mapToTags(commaDelimitedString, separator) {
            if (commaDelimitedString) {
                return mapToTagsFromStringArray(commaDelimitedString.split(separator || ','));
            }
        }

        function mapFromTags(objectArray, separator) {
            return _.map(objectArray, 'text').join(separator || ',');
        }

        function mapToTagsFromStringArray(stringArray, separator) {
            return _.flatMap(stringArray, function (textVal) {
                return { 'text': textVal };
            });
        }

        function mapFromTagsToStringArray(objectArray, separator) {
            var result = mapFromTags(objectArray, separator).split(separator || ',');

            if (result.length === 1 && result[0] === '')
                result = [];

            return result;
        }
    }
})();
(function () {
    'use strict';

    hereMapsService.$inject = ["$http", "HERE_MAPS_CONFIG"];
    angular
        .module('redcap.services')
        .service('hereMapsService', hereMapsService);


    function hereMapsService($http, HERE_MAPS_CONFIG) {
        let _supportedCountryCodes = 'USA,CAN,PRI';

        return {
            reverseGeocode: reverseGeocode,
            getPlacePredictions: getPlacePredictions,
            getPlaceDetails: getPlaceDetails,
            formatLocation: formatLocation
        };

        function reverseGeocode(lat, lng) {
            let params = {
                at: [lat, lng].join(','),
                limit: '1',
                lang: 'en-gb',
                apiKey: HERE_MAPS_CONFIG.apiKey
            };

            return $http.get('https://revgeocode.search.hereapi.com/v1/revgeocode', {params: params})
                .then((rawResponse) => {
                    let formattedResult = convertToCamelCase(rawResponse);

                    let address = _.get(formattedResult, 'data.items[0].address', undefined);

                    if (address === undefined) {
                        return null;
                    }

                    return formatLocation(address, null, {lat: lat, lng: lng});
                }, (error) => {
                    console.error('Error occurred while geocoding location', error);
                });
        }

        function getPlacePredictions(text, lat, lng) {
            return new Promise((resolve, reject) => {
                if (!lat || !lng) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        resolve(getPlaces(text, position.coords.latitude, position.coords.longitude));
                    });
                } else {
                    resolve(getPlaces(text, lat, lng));
                }
            });
        }

        function getPlaceDetails(placeId) {
            return $http.get('https://lookup.search.hereapi.com/v1/lookup?apiKey=' + HERE_MAPS_CONFIG.apiKey + '&id=' + placeId).then((response) => {
                let placeDetails = response.data;

                let formattedAddress = formatLocation(placeDetails.address, placeDetails.title, placeDetails.position);

                formattedAddress.phone = _.get(response, 'data.contacts.phone[0].value', undefined);

                return formattedAddress;
            }, (error) => {
                console.error('Error occurred while getting places', error);
            });
        }

        function getPlaces(text, lat, lng) {
            if (!text || !text.length) return [];

            let queryString = text + '&at=' + lat + ',' + lng + '&limit=10&in=countryCode:' + _supportedCountryCodes + '&lang=en&apiKey=' + HERE_MAPS_CONFIG.apiKey;

            return $http.get('https://autosuggest.search.hereapi.com/v1/autosuggest?q=' + queryString)
                .then((response) => {
                    if (response.status === 0) {
                        console.error('Error occurred while getting places', response);

                        return [];
                    }

                    return _.filter(response.data.items, (item) => { return item.address; }).slice(0, 5);
                }, (error) => {
                    console.error('Error occurred while getting places', error);
                });
        }

        function toFullStreetAddress(addressObj, friendlyName) {
            let address = '';

            if (addressObj.streetAddress) {
                address += ' ' + addressObj.streetAddress;
            }

            if (addressObj.city) {
                address += ', ' + addressObj.city + ',';
            }

            if (addressObj.state) {
                address += ' ' + addressObj.state;
            }

            if (addressObj.zip) {
                address += ' ' + addressObj.zip;
            }

            if (addressObj.countryShortCode) {
                address += ', ' + addressObj.countryShortCode;
            }

            if (friendlyName && !_.includes(address.toLowerCase(), friendlyName.toLowerCase())) {
                address = friendlyName + ' ' + address;
            }

            return address.trim();
        }

        function formatLocation(addressObj, friendlyName, latLng) {
            if (!addressObj) { return {}; }

            let houseNumber = addressObj.houseNumber || addressObj.house || '';

            let address = {
                streetAddress: (addressObj.address1 || addressObj.streetAddress || (houseNumber + ' ' + (addressObj.street || ''))).trim(),
                streetNumber: houseNumber,
                city: addressObj.city,
                state: addressObj.stateCode || addressObj.state,
                zip: addressObj.zip || addressObj.postalCode,
                countryShortCode: addressObj.countryCode || addressObj.country,
                lat: addressObj.lat ? addressObj.lat : latLng ? latLng.lat : null,
                lng: addressObj.lng ? addressObj.lng : latLng ? latLng.lng : null
            };

            address.formattedAddress = addressObj.label || toFullStreetAddress(address, friendlyName);
            address.name = friendlyName ? friendlyName : (address.formattedAddress.split(',')[0] + ', ' + address.city + ', ' + address.state);
            address.streetAddress = address.streetAddress.length ? address.streetAddress : address.name;

            return address;
        }

        function convertToCamelCase(obj) {
            let newObj; let origKey; let newKey; let value;

            if (obj === null || obj === undefined) {
                return obj;
            }

            if (obj instanceof Array) {
                return _.map(obj, (value) => {
                    if (typeof value === 'object') {
                        value = convertToCamelCase(value);
                    }

                    return value;
                });
            } else {
                newObj = {};

                for (origKey in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, origKey)) {
                        newKey = _.camelCase(origKey);
                        value = obj[origKey];

                        if (value instanceof Array || (value !== null && value.constructor === Object)) {
                            value = convertToCamelCase(value);
                        }

                        newObj[newKey] = value;
                    }
                }
            }

            return newObj;
        }
    }
})();

(function () {
    'use strict';

    fileReader.$inject = ["$q", "$log"];
    angular
        .module('redcap.services')
        .factory('fileReaderService', fileReader);

    function fileReader($q, $log) {
 
        let onLoad = function(reader, deferred, scope) {
            return function () {
                scope.$apply(() => {
                    deferred.resolve(reader.result);
                });
            };
        };
 
        let onError = function (reader, deferred, scope) {
            return function () {
                scope.$apply(() => {
                    deferred.reject(reader.result);
                });
            };
        };
 
        let onProgress = function(reader, scope) {
            return function (event) {
                scope.$broadcast("fileProgress",
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        };
 
        let getReader = function(deferred, scope) {
            let reader = new FileReader();

            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);

            return reader;
        };
 
        let readAsDataURL = function (file, scope) {
            let deferred = $q.defer();
             
            let reader = getReader(deferred, scope);
         
            reader.readAsDataURL(file);
             
            return deferred.promise;
        };

        let readAsText = function (file, scope) {
            let deferred = $q.defer();

            let reader = getReader(deferred, scope);

            reader.readAsText(file);

            return deferred.promise;
        };
 
        let csvToArray = function(strData, strDelimiter) {
            strDelimiter = strDelimiter || ",";

        
            let objPattern = new RegExp(
                
                    // Delimiters.
                    "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

                    // Quoted fields.
                    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

                    // Standard fields.
                    "([^\"\\" + strDelimiter + "\\r\\n]*))"
                ,
                "gi"
                );

            let arrData = [[]]; 

            let arrMatches = null;

            while ((arrMatches = objPattern.exec(strData)) !== null) {
                let strMatchedDelimiter = arrMatches[1];

                if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
                    // Since we have reached a new row of data,
                    // add an empty row to our data array.
                    arrData.push([]);
                }

                let strMatchedValue;

                if (arrMatches[2]) {
                    strMatchedValue = arrMatches[ 2 ].replace(new RegExp("\"\"", "g"), "\"");
                } else {
                    // We found a non-quoted value.
                    strMatchedValue = arrMatches[3];
                }

                arrData[arrData.length - 1].push(strMatchedValue);
            }

            // Return the parsed data.
            return arrData;
        };

        let saveToDisk = function(fileContents, filename) {
            let file = new Blob([fileContents], {type: 'text/csv'});
                let save = document.createElement('a');

            save.download = filename;
            save.href =   window.webkitURL.createObjectURL(file);
            save.target = '_blank';

            let evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });

            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        };

        return {
            readAsDataUrl: readAsDataURL,
            readAsText: readAsText,
            csvToArray: csvToArray,
            saveToDisk: saveToDisk
        };
    }

})();

(function () {
    'use strict';

    eventAlertService.$inject = ["$rootScope"];
    angular
        .module('redcap.services')
        .factory('eventAlertService', eventAlertService);

    function eventAlertService($rootScope) {

        return {
            createAlert: createAlert
        };

        function createAlert(message, duration, callBack, alertType) {
            duration = isNaN(duration) ? 3000 : duration;

            $rootScope.$broadcast('event-alert', { message: message, duration: duration, callBack: callBack, alertType: alertType });    
        }
    }
})();

(function () {
    'use strict';

    driversLicenseScanService.$inject = ["pdf417Service"];
    angular
        .module('redcap.services')
        .factory('driversLicenseScanService', driversLicenseScanService);

    function driversLicenseScanService(pdf417Service) {
        let scanner = null;
            let loading = false;

        return {
            showDriversLicenseScanner: showDriversLicenseScanner,
            destroyScannerInstance: destroyScannerInstance,
            isLoading: function () { return loading; }
        };

        function showDriversLicenseScanner(containerElement) {
            return new Promise((resolve, reject) => {
                getScannerInstance().then((scanner) => {
                    if (containerElement) {
                        scanner.setUIElement(containerElement);
                    }
                    
                    scanner.onUnduplicatedRead = function(txt, result) {
                        resolve(pdf417Service.parseStringAsObject(txt), txt, result);
                    };

                    scanner.show();
                }).catch((ex) => {
                    reject(ex);
                });
            });
            
        }

        function destroyScannerInstance() {
            if (scanner) {
                scanner.destroy();
                scanner = null;
            }
        }

        function getScannerInstance() {
            return new Promise((resolve, reject) => {
                try {
                    if (scanner) {
                        return resolve(scanner);
                    }

                    loading = true;
                    Dynamsoft.CVR.CaptureVisionRouter.createInstance().then((result) => {
                        scanner = result;
                        scanner.getSimplifiedSettings("ReadSingleBarcode").then((settings) => {
                            //check for licenses only
                            settings.barcodeSettings.barcodeFormatIds = Dynamsoft.DBR.EnumBarcodeFormat.BF_PDF417;
                            scanner.updateSettings("ReadSingleBarcode", settings).then(() => {
                                loading = false;

                                return resolve(scanner);
                            }).catch((err) => {
                                loading = false;

                                return reject(err);
                            });
                        });
                    }).catch((err) => {
                        loading = false;

                        return reject(err);
                    });
                } catch (err) {
                    loading = false;

                    return reject(err);
                }
            });
        }
    }
})();

/**!
 * AngularJS Azure blob upload service with http post and progress.
 * @author  Stephen Brannan - twitter: @kinstephen
 * @version 1.0.1
 */
(function () {

    let azureBlobUpload = angular.module('azureBlobUpload', []);

    azureBlobUpload.factory('azureBlob',
        ['$log', '$http', azureBlob]);

    function azureBlob($log, $http) {
        let DefaultBlockSize = 1024 * 32; // Default to 32KB

        /* config: {
          baseUrl: // baseUrl for blob file uri (i.e. http://<accountName>.blob.core.windows.net/<container>/<blobname>),
          sasToken: // Shared access signature querystring key/value prefixed with ?,
          file: // File object using the HTML5 File API,
          progress: // progress callback function,
          complete: // complete callback function,
          error: // error callback function,
          blockSize: // Use this to override the DefaultBlockSize
        } */
        

        let initializeState = function (config) {
            let blockSize = DefaultBlockSize;

            if (config.blockSize) {
                blockSize = config.blockSize;
            }

            let maxBlockSize = blockSize; // Default Block Size
            let numberOfBlocks = 1;
            let file = config.file;
            let fileSize = file.size;

            if (fileSize < blockSize) {
                maxBlockSize = fileSize;
                $log.log("max block size = " + maxBlockSize);
            }

            if (fileSize % maxBlockSize == 0) {
                numberOfBlocks = fileSize / maxBlockSize;
            } else {
                numberOfBlocks = parseInt(fileSize / maxBlockSize, 10) + 1;
            }

            $log.log("total blocks = " + numberOfBlocks);

            return {
                maxBlockSize: maxBlockSize, //Each file will be split in 256 KB.
                numberOfBlocks: numberOfBlocks,
                totalBytesRemaining: fileSize,
                currentFilePointer: 0,
                blockIds: new Array(),
                blockIdPrefix: 'block-',
                bytesUploaded: 0,
                submitUri: null,
                file: file,
                baseUrl: config.baseUrl,
                sasToken: config.sasToken,
                fileUrl: config.baseUrl + (config.sasToken || ''),
                progress: config.progress,
                complete: config.complete,
                error: config.error,
                cancelled: false
            };
        };        

        let commitBlockList = function (state) {
            let uri = state.fileUrl + '&comp=blocklist';

            $log.log(uri);

            let requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';

            for (let i = 0; i < state.blockIds.length; i++) {
                requestBody += '<Latest>' + state.blockIds[i] + '</Latest>';
            }

            requestBody += '</BlockList>';
            $log.log(requestBody);

            $http.put(uri, requestBody,
                {
                    headers: {
                        'x-ms-blob-content-type': state.file.type
                    }
                }).then((response) => {
                    $log.log(response.data);
                    $log.log(response.status);
                    if (state.complete) state.complete(response.data, response.status, response.headers, response.config);
                }, (response) => {
                    $log.log(response.data);
                    $log.log(response.status);
                    if (state.error) state.error(response.data, response.status, response.headers, response.config);
                });
        };

        let uploadFileInBlocks = function (reader, state) {
            if (!state.cancelled) {
                if (state.totalBytesRemaining > 0) {
                    $log.log("current file pointer = " + state.currentFilePointer + " bytes read = " + state.maxBlockSize);

                    let fileContent = state.file.slice(state.currentFilePointer, state.currentFilePointer + state.maxBlockSize);
                    let blockId = state.blockIdPrefix + pad(state.blockIds.length, 6);
                    
                    $log.log("block id = " + blockId);

                    state.blockIds.push(btoa(blockId));
                    reader.readAsArrayBuffer(fileContent);

                    state.currentFilePointer += state.maxBlockSize;
                    state.totalBytesRemaining -= state.maxBlockSize;

                    if (state.totalBytesRemaining < state.maxBlockSize) {
                        state.maxBlockSize = state.totalBytesRemaining;
                    }
                } else {
                    commitBlockList(state);
                }
            }
        };

        let pad = function (number, length) {
            let str = '' + number;
            
            while (str.length < length) {
                str = '0' + str;
            }
            
            return str;
        };

        let upload = function (config) {
            let state = initializeState(config);

            let reader = new FileReader();
            
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE && !state.cancelled) { // DONE == 2
                    let uri = state.fileUrl + '&comp=block&blockid=' + state.blockIds[state.blockIds.length - 1];
                    let requestData = new Uint8Array(evt.target.result);

                    $log.log(uri);
                    $http.put(uri, requestData,
                        {
                            headers: {
                                'x-ms-blob-type': 'BlockBlob',
                                'Content-Type': state.file.type
                            },
                            transformRequest: []
                        }).then((response) => {
                        $log.log(response.data);
                        $log.log(response.status);
                        state.bytesUploaded += requestData.length;

                        let percentComplete = ((parseFloat(state.bytesUploaded) / parseFloat(state.file.size)) * 100).toFixed(2);
                        
                        if (state.progress) state.progress(percentComplete, response.data, response.status, response.headers, response.config);

                        uploadFileInBlocks(reader, state);
                    }, (response) => {
                        $log.log(response.data);
                        $log.log(response.status);

                        if (state.error) state.error(response.data, response.status, response.headers, response.config);
                    });
                }
            };

            uploadFileInBlocks(reader, state);

            return {
                cancel: function () {
                    state.cancelled = true;
                }
            };
        };

        return {
            upload: upload
        };
    }

})();

(function() {

    'use strict';

    authInterceptor.$inject = ["$q", "$log", "$injector"];
    angular
    .module('redcap.services')
    .factory('authInterceptor', authInterceptor);

    function _isUnauthorized(rejection) {
        return rejection.status === 401 || _isInvalidGrant(rejection);
    }

    function _isInvalidGrant(rejection) {
        return rejection.status === 400 && rejection.data && rejection.data.error === 'invalid_grant';
    }

    function authInterceptor($q, $log, $injector) {

        let $http;
        let $state;
        let $transition$;
        let authService;
        let localStorageService;

        let _redirectToLogin = function() {
            $state = $state || $injector.get('$state');
            let configId = null;

            if ($transition$ || $injector.has('$transition$')) {
                $transition$ = $transition$ || $injector.get('$transition$');
                configId = $transition$.params().configId;
            }

            if (configId === null) {
                if ($state && $state.params && $state.params.configId) {
                    configId = $state.params.configId;
                }
            }
            
            $state.go('login', {configId: configId || 1});
        };

        let _responseError = function (rejection) {

            let deferred = $q.defer();

            authService = authService || $injector.get('authService');
            localStorageService = localStorageService || $injector.get('localStorageService');
            
            // if a 401 (unauthorized endpoint access)
            if (_isUnauthorized(rejection)) {

                let isInvalidGrant = _isInvalidGrant(rejection);
                let tokenExpired = false;

                $log.debug('auth-intercept: caught a 401!');

                let authData = localStorageService.get('authorizationData');

                if (authData) {
                    $log.debug('auth-intercept: there is auth data:', authData);

                    tokenExpired = moment().utc().isAfter(authData.token_refreshTime);
                    $log.debug('auth-intercept: tokenExpired: ', tokenExpired);
                } else {
                    // do nothing
                    $log.debug('auth-intercept: there is no auth data, what to do?');
                    authService.logout();
                }

                if (tokenExpired || isInvalidGrant) {

                    $log.debug('auth-intercept: Token is Expired. Logging out and redirecting user to login.');

                    // ensure logout
                    authService.logout();

                    // boot to login
                    _redirectToLogin();

                    deferred.reject(rejection);
                } else {
                    // if Auth is ok, this is a rejection from the API with additional requirements (i.e. key). 
                    // Pass back rejection to error handling code on original call
                    deferred.reject(rejection);
                }
            } else {
                deferred.reject(rejection);
            }

            return deferred.promise;
        };

        let _retryHttpRequest = function (config, deferred) {

            $log.debug('auth-intercept: retryHttpRequest(): ', config);

            $http = $http || $injector.get('$http');
            $http(config).then((response) => {
                deferred.resolve(response);
            }, (response) => {
                deferred.reject(response);
            });
        };

        return {
            responseError: _responseError
        };
    }

})();


(function () {
    'use strict';

    appointmentUtilService.$inject = ["rcUtilService", "SYSTEM_ENUMS", "INSPECT_CONSTANTS", "APPOINTMENT_RECALL_OPCODE_TYPE", "APPOINTMENT_PHOTOTYPE", "APPOINTMENT_APPOINTMENTSTATUS", "APPOINTMENT_TRANSPORTATION_TYPE", "APPOINTMENT_TRANSPORTATION_TYPE_GROUP", "APPOINTMENT_CUSTOMERTYPE", "TAGGED_INPUT_MAX_SUGGESTIONS", "$filter", "$state", "localStorageService", "authService", "appointmentLineItemClass"];
    angular
        .module('redcap')
        .factory('appointmentUtilService', appointmentUtilService);

    function appointmentUtilService(rcUtilService, SYSTEM_ENUMS, INSPECT_CONSTANTS, APPOINTMENT_RECALL_OPCODE_TYPE, APPOINTMENT_PHOTOTYPE, APPOINTMENT_APPOINTMENTSTATUS,
        APPOINTMENT_TRANSPORTATION_TYPE, APPOINTMENT_TRANSPORTATION_TYPE_GROUP, APPOINTMENT_CUSTOMERTYPE, TAGGED_INPUT_MAX_SUGGESTIONS, $filter, $state, localStorageService, authService, appointmentLineItemClass) {
        let _uniqueID = 0;
        const _decimalRegex = '^[0-9]+(\\.[0-9]{1,2})?$';
        const _revalidate = 'angularValidation.revalidate';

        return {
            getTripLocations: getTripLocations,
            getNoteMaxLength: getNoteMaxLength,
            getCustomerFirstNameMaxLength: getCustomerFirstNameMaxLength,
            getCustomerLastNameMaxLength: getCustomerLastNameMaxLength,
            getOpCodeMaxLength: getOpCodeMaxLength,
            getOpCodeDescriptionMaxLength: getOpCodeDescriptionMaxLength,
            getRecommendedMaintenanceName: getRecommendedMaintenanceName,
            getFirstAvailableTimeSlot: getFirstAvailableTimeSlot,
            generateUID: generateUID,
            validatePhoneNumber: validatePhoneNumber,
            validateDecimal: validateDecimal,
            validateRecalls: validateRecalls,
            validateDashboardOpCode: validateDashboardOpCode,
            validateCombinedCustomerNameLength: validateCombinedCustomerNameLength,
            getDashboardCheckedLineItems: getDashboardCheckedLineItems,
            opCodesEnabledForDept: opCodesEnabledForDept,
            departmentGenericEnabled: departmentGenericEnabled,
            processDashboardViewLineItems: processDashboardViewLineItems,
            processDashboardOpCodeSearchSelected: processDashboardOpCodeSearchSelected,
            processPreviouslyDeclinedLineItems: processPreviouslyDeclinedLineItems,
            getUniqueDOMID: getUniqueDOMID,
            filterOpCodesForDisplay: filterOpCodesForDisplay,
            formatOpCodeSearchForSelection: formatOpCodeSearchForSelection,
            formatOpCodeForDropDown: formatOpCodeForDropDown,
            addDashboardOtherLineItem: addDashboardOtherLineItem,
            processDashboardRecMaintChecked: processDashboardRecMaintChecked,
            processDashboardAuthorizationUpdated: processDashboardAuthorizationUpdated,
            processDashboardLineItemUpdated: processDashboardLineItemUpdated,
            processDashboardRecMaintItemUpdated: processDashboardRecMaintItemUpdated,
            getImageTypes: getImageTypes,
            getMediaType: getMediaType,
            isAdvisorUnmapped: isAdvisorUnmapped,
            displayCountyCountry: displayCountyCountry,
            displayAddressFields: displayAddressFields,
            displayLanguage: displayLanguage,
            isYMMSameAsOriginalApptYMM: isYMMSameAsOriginalApptYMM,
            updateYMM: updateYMM,
            getPendingLineItemTotalEstimate: getPendingLineItemTotalEstimate,
            dataURItoBlob: dataURItoBlob,
            createNewRecallLineItem: createNewRecallLineItem,
            getRecMainTooltip: getRecMainTooltip,
            getRecMaintTitle: getRecMaintTitle,
            removePreviouslyDeclinedRecMaint: removePreviouslyDeclinedRecMaint,
            preProcesPreviouslyDeclinedServices: preProcesPreviouslyDeclinedServices,
            getActiveApptProduct: getActiveApptProduct,
            getProductSuffix: getProductSuffix,
            validateDepartment: validateDepartment,
            validateUniqueNoteForDuplicateOpCodes: validateUniqueNoteForDuplicateOpCodes,
            opCodeSelected: opCodeSelected,
            isCheckedIn: isCheckedIn,
            isCheckingIn: isCheckingIn,
            processVehicleConditions: processVehicleConditions,
			getDisplayMake: getDisplayMake,
            getDisplayModel: getDisplayModel,
            removePipedData: removePipedData,
            displayServiceHistory: displayServiceHistory,
            createTripCustomer: createTripCustomer,
            createNewLineItem: createNewLineItem,
            processServicesUpdated: processServicesUpdated,
            customerNameRequired: customerNameRequired,
            getShuttleDescription: getShuttleDescription,
            getCreditDescription: getCreditDescription,
            isTripTypePickupOrMobile: isTripTypePickupOrMobile,
            getMatchingDepartmentOpCode: getMatchingDepartmentOpCode,
            isLineItemCustomerRequest: isLineItemCustomerRequest,
            isLineItemUserRequest: isLineItemUserRequest,
            getDisplayLineItemDescription: getDisplayLineItemDescription,
			convertVehicleConditionToImages: convertVehicleConditionToImages,
            getDeptOpCodes: getDeptOpCodes,
			transportationTripTypeMap: transportationTripTypeMap,
            getSystemSeverity: getSystemSeverity,
            revalidateLineItem: revalidateLineItem,
            gotoCheckInSummary: gotoCheckInSummary,
            isCheckInSkipped: isCheckInSkipped,
            setLastBookedDepartment: setLastBookedDepartment,
            getDefaultTranportationType: getDefaultTranportationType,
            getPickupDropOffOption: getPickupDropOffOption,
            createNewCustomerEntry: createNewCustomerEntry,
            buildAppointmentTypeAheadData: buildAppointmentTypeAheadData,
            flattenCustomersForTypeAhead: flattenCustomersForTypeAhead,
            buildCustomerTypeAheadData: buildCustomerTypeAheadData,
            buildVehicleTypeAheadData: buildVehicleTypeAheadData,
            clearTypeAheadSelection: clearTypeAheadSelection
        };

        function createNewCustomerEntry(overrides) {
            const base = {
                customerId: -998,
                customerFirstName: '',
                customerLastName: '',
                displayMessage: '[NEW CUSTOMER]'
            };

            return angular.extend({}, base, overrides || {});
        }

        function buildAppointmentTypeAheadData (appointments) {
            const typeAheadData = buildTypeAheadData(appointments,
                (appt) => String(appt.id || appt.appointmentId),
                (appt) => {
                    const statusPrefixHtml = appt.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.draft ? '<b>DRAFT</b> ' : appt.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.canceled ? '<b>CANCELED</b> ' : '';
                    const personName = appt.customerCompany || `${appt.customerFirstName} ${appt.customerLastName}`;
                    const vehicle = appt.year && appt.makeName && appt.modelName ? `${appt.year} ${appt.makeName} ${appt.modelName}` : '';
                    const vin = appt.vin ? `(${appt.vin})` : '';
                    const dateStr = appt.apptDateTime ? moment(appt.apptDateTime).format('ddd MMM DD hh:mmA') : '';

                    return `${statusPrefixHtml}${personName}${vehicle ? ' - ' + vehicle : ''}${vin ? ' ' + vin : ''}${dateStr ? ' - ' + dateStr : ''}`;
                }
            );

            const suggestions = typeAheadData.suggestions.map((suggestion) => {
                return {
                    ...suggestion.item,
                    id: suggestion.id,
                    name: suggestion.name
                };
            });

            return {
                suggestions: suggestions,
                map: typeAheadData.map
            };
        }

        function flattenCustomersForTypeAhead (customerResults) {
            return customerResults.flatMap((customer) =>
                customer.customerVehicles?.length ? customer.customerVehicles.map((vehicle) => ({...customer, vehicle})) : [customer]
            );
        }

        function buildTypeAheadData (items, buildSuggestionId, formatFn, buildSelectedLabel, filterFn) {
            items = items || [];

            const map = {};
            const suggestions = (filterFn ? items.filter(filterFn) : items).map((item, idx) => {
                const id = buildSuggestionId(item, idx);
                const name = formatFn(item);

                map[id] = item;

                return buildSelectedLabel ? {id, name, item, selectedLabel: buildSelectedLabel(item)} : {id, name, item};
            });

            return {suggestions, map};
        }

        function buildCustomerTypeAheadData (customers, searchTerm, formatFn, addCreateNewRecordOption) {
            const buildCustomerSuggestionId = (customer) => customer.customerId == -999
                ? `${customer.customerId}:${searchTerm || 'no-search'}`
                : `${customer.customerId}:${customer.vehicle?.vehicleId || 'no-vehicle'}`;
            const existingCustomerVehicleIds = new Set();
            const uniqueCustomers = (customers || []).filter((customer) => {
                const id = buildCustomerSuggestionId(customer);

                if (existingCustomerVehicleIds.has(id)) return false;
                existingCustomerVehicleIds.add(id);

                return true;
            });

            const data = buildTypeAheadData(
                uniqueCustomers,
                buildCustomerSuggestionId,
                formatFn,
                getCustomerSelectedLabel
            );

            if (addCreateNewRecordOption && searchTerm.length >= 3) {
                const newCust = addCreateNewRecordOption(searchTerm);
                const id = `create-new:${searchTerm}`;
                const name = formatFn(newCust);

                data.map[id] = newCust;
                data.suggestions.push({id, name, item: newCust, selectedLabel: getCustomerSelectedLabel(newCust)});
            }

            return data;
        }

        function getCustomerSelectedLabel (customer) {
            const isBusiness = customer.customerIsBusiness == true || customer.customerType == APPOINTMENT_CUSTOMERTYPE.business;

            return customer.customerId == -998 ? 'Create a New Record.' : isBusiness ? customer.customerLastName : `${customer.customerFirstName} ${customer.customerLastName}`;
        }

        function buildVehicleTypeAheadData (vehicles, searchTerm, formatFn) {
            const safeSearchTerm = (searchTerm || '').toLowerCase();

            return buildTypeAheadData(
                vehicles,
                (v, i) => `${v.vehicleId}:${i}`,
                formatFn,
                null,
                (v) => v.vehicleId == -998 || `${v.year} ${v.makeName || v.make} ${v.model} ${v.vin}`.toLowerCase().includes(safeSearchTerm)
            );
        }

        function clearTypeAheadSelection (target, selectedProp, queryProp) { target[selectedProp] = []; target[queryProp] = ''; }

        function dataURItoBlob (dataURI) {
            const binary = atob(dataURI.split(',')[1]);
            const array = [];

            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }

            return new Blob([new Uint8Array(array)], {type: 'image/png'});
        }

        function updateYMM(origValue, appointment) {
            if (!appointment) return;

            const vin = appointment.vin && appointment.vin.length >= 8 ? '#' + appointment.vin.slice(-8) : 'N/A';

            if (origValue) {
                const new1 = rcUtilService.replaceAll(origValue, '[YEAR]', appointment.year);
                const new2 = rcUtilService.replaceAll(new1, '[MAKE]', appointment.make);
                const new3 = rcUtilService.replaceAll(new2, '[MODEL]', appointment.model);
                const new4 = rcUtilService.replaceAll(new3, '[MILES]', $filter('number')(appointment.mileage) || '0');
                const new5 = rcUtilService.replaceAll(new4, '[VIN8]', vin);
                const new6 = rcUtilService.replaceAll(new5, '[MILEAGETYPE]', appointment.mileageType.abbreviation || 'MI');

                return new6;
            } else {
                return '';
            }
        }

        function getTripLocations(validationResponse) {
            const dispLocations = [];

            if (validationResponse.tripStops) {
                validationResponse.tripStops.forEach((stop, idx) => {
                    const loc = stop.location;

                    loc.address = {streetAddress: loc.addr1, city: loc.city, state: loc.state, zip: loc.zip, countryShortCode: loc.countryShortCode, name: loc.name};
                    loc.stopType = stop.locationDescription;
                    loc.estimatedArrival = stop.estimatedArrival;

                    if (validationResponse.encodedRoutes[idx]) {
                        loc.encodedPolyline = validationResponse.encodedRoutes[idx];
                    }

                    dispLocations.push(loc);
                });                
            }

            return dispLocations;
        }

        function getNoteMaxLength(dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            if (dmsSystem === dmsEnum.CDK || dmsSystem === dmsEnum.DealerTrack) {
                return 250;
            } else if (dmsSystem === dmsEnum.ReynoldsPOWER) {
                return 300;
            } else if (dmsSystem === dmsEnum.ReynoldsERA) {
                return 1200;
            } else if (dmsSystem === dmsEnum.None) {
                return 1200;
            }
        }

        function getCustomerFirstNameMaxLength(dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            if (dmsSystem === dmsEnum.ReynoldsPOWER || dmsSystem === dmsEnum.ReynoldsERA) {
                return 35;
            } else if (dmsSystem === dmsEnum.DealerTrack) {
                return 15;
            } else {
                return 20;
            }
        }

        function getCustomerLastNameMaxLength(dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            if (dmsSystem === dmsEnum.ReynoldsPOWER || dmsSystem === dmsEnum.ReynoldsERA) {
                return 35;
            } else {
                return 50;
            }
        }

        function getOpCodeMaxLength(dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            if (dmsSystem === dmsEnum.CDK) {
                return 20;
            } else if (dmsSystem === dmsEnum.DealerTrack) {
                return 10;
            } else if (dmsSystem === dmsEnum.ReynoldsPOWER || dmsSystem === dmsEnum.ReynoldsERA) {
                return 15;
            } else if (dmsSystem === dmsEnum.None) {
                return 20;
            }
        }

        function getOpCodeDescriptionMaxLength(dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            if (dmsSystem === dmsEnum.CDK) {
                return 250;
            } else if (dmsSystem === dmsEnum.DealerTrack) {
                return 200;
            } else if (dmsSystem === dmsEnum.ReynoldsPOWER || dmsSystem === dmsEnum.ReynoldsERA) {
                return 20;
            } else if (dmsSystem === dmsEnum.None) {
                return 250;
            }
        }

        function getRecommendedMaintenanceName(recMaint, mileageType) {
            const mAbbr = mileageType.abbreviation ? mileageType.abbreviation : 'MI';
            const mType = mileageType.type ? mileageType.type : 0;
            
            return recMaint.interval + ' ' + mAbbr.toUpperCase() + ' MAINTENANCE PACKAGE - EVERY ' + recMaint.intervalMonth + ' MONTHS / ' + (mType === 0 ? recMaint.intervalMile : recMaint.intervalKm) + ' ' + mAbbr.toUpperCase();
        }

        function getFirstAvailableTimeSlot(slots, predicate) {
            // Select the first slot that is found to be available
            if (typeof predicate !== 'function') {
                predicate = function (slot) { return !slot.unavailable; };
            }

            return _.find(slots, predicate);
        }

        // Use this for validation-service when needing a unique id to compare array based validations on rather than relying on indexes
        function generateUID(prependText, id) {
            if (!prependText) {
                prependText = '';
            }

            // If an id is passed in, use it. Otherwise generate a random one
            // This provides a major performance benefit when using track by uid expressions on ng-repeats, preventing complete re-rendering
            // of views when array data is refreshed
            if (!id || typeof id !== 'number') {
                id = rcUtilService.getRandomNumber();
            }

            prependText = prependText.toString() + '_' + id;

            return prependText;
        }

        function validatePhoneNumber (number) {
            let valid;
           
            if (number && number.length === 10) {
                valid = true;
            } else if (!number) {
                valid = true;
            } else {
                valid = false;
            }

            return {isValid: valid, message: 'Invalid phone number'};            
        }
        
        function validateDecimal (value, lineItem, exactDecimalPlaces) {
            // If we're validating an automatic line that isn't enabled, we can shortcut validation
            if (lineItem) {
                if (lineItem.isAutomatic && !lineItem.isEnabled) {
                    return {isValid: true, message: ' '};
                } else if (!lineItem.isAutomatic && !lineItem.showInDashboard && !lineItem.showInConsumer) {
                    return {isValid: true, message: ' '};
                }
            }

            let decRegEx = new RegExp(_decimalRegex);
            
            if (exactDecimalPlaces && parseInt(exactDecimalPlaces) > 0) {
                decRegEx = new RegExp(_decimalRegex.replace('{1,2}', '{' + exactDecimalPlaces + '}'));
            }

            let isValid = decRegEx.test(value);
            let decimalFormat = '';

            for (let i = 0; i < (exactDecimalPlaces || 2); i++) {
                decimalFormat += '#';
            }

            return {isValid: isValid, message: 'Invalid format (#.' + decimalFormat + ')'};
        }

        // Validate there are not too many recalls on an appointment
        function validateRecalls(dealerRecallOpCodes, currentDepartmentId, lineItems, noteMaxLength, validatingRecallsFlag) {
            const allRecallMfrNum = [];
            const departmentRecallOpCode = $filter('filter')(dealerRecallOpCodes, {dealerDepartmentId: parseInt(currentDepartmentId)}, true);
            let noteCountLength = 0;            
           
            if (!departmentRecallOpCode || departmentRecallOpCode.length === 0) {
                if (validatingRecallsFlag)
                    validatingRecallsFlag = false;

                return {isValid: true, message: ''};
            }

            if (departmentRecallOpCode[0].recallOpCodeType === APPOINTMENT_RECALL_OPCODE_TYPE.delimited) {     
                if (lineItems) {           
                    lineItems.forEach((lineItem, index) => {
                        let mfNum = null;
                        
                        if (lineItem.isRecall) {
                            // dashboard pages
                            mfNum = lineItem.manufacturerNumber;
                        } else if (lineItem.checked) {
                            // consumer pages
                            mfNum = lineItem.manufacturerNumber;
                        }

                        if (mfNum) {
                            allRecallMfrNum.push(mfNum);
                            noteCountLength += mfNum.toString().length;
                        }
                    });
                }

                // Include the length of the added commas for the delimited list
                if (allRecallMfrNum.length > 0) {
                    noteCountLength += (allRecallMfrNum.length - 1);
                }

                if (noteCountLength + 'recall:'.length > noteMaxLength) {   // count characters of csv list and the prepended word 'recall:'
                    validatingRecallsFlag = false;

                    return {isValid: false, message: 'Too many recalls'};
                }
            }

            validatingRecallsFlag = false;

            return {isValid: true, message: ''};
        }

        function validateDashboardOpCode (lineItems, dealerOpCodes, opCode, lineItem, dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;
            const maxLength = getOpCodeMaxLength(dmsEnum);

            if (dmsSystem === dmsEnum.None) {
                return {isValid: true, message: ''};
            }

            if (lineItem.selectedOpCode && lineItem.selectedOpCode.length === 1) {
                opCode = lineItem.selectedOpCode[0];
            }

            // If we're validating a line that isn't enabled, we're fine to have a NULL op code
            if (!lineItem.checked) {
                return {isValid: true, message: ''};
            }

            if (!opCode || opCode === '') {
                return {isValid: false, message: 'Field is required.'};
            }

            // Validate this op code has not been used yet
            let found = -1;

            let match = function (o, i) { 
                return o !== lineItem && o.checked === true && 
                       o.dealerDepartmentId === lineItem.dealerDepartmentId && 
                       o.opCode && o.opCode.toLowerCase() === opCode.toLowerCase(); 
            };

            if (dmsSystem === dmsEnum.ReynoldsERA || dmsSystem === dmsEnum.ReynoldsPOWER) {
                if (lineItem.isRecommendedMaintenance || lineItem.isGeneric || !lineItem.dealerAppointmentServiceOpCodeId) {
                    // Ensure we aren't entering a duplicate that is already checked on the mapped lines
                    found = _.findIndex(dealerOpCodes, match);

                    if (found === -1) {
                        found = _.findIndex(lineItems, match);
                    }
                }
                
                if (found > -1) {
                    return {isValid: false, message: 'Must be unique'};
                }
            }

            if (opCode.length > maxLength) {
                return {isValid: false, message: 'Cannot be greater than ' + maxLength + ' characters.'};
            }

            if (dmsSystem === dmsEnum.CDK) {
                if (opCode.indexOf(' ') > -1) {
                    return {isValid: false, message: 'Cannot contain spaces.'};
                }

                if (opCode.indexOf('|') > -1) {
                    return {isValid: false, message: 'Cannot contain \'|\'.'};
                }

                if (opCode.indexOf('*') > -1) {
                    return {isValid: false, message: ' cannot contain \'*\'.'};
                }

                if (_.startsWith(opCode, 'DNX') || _.startsWith(opCode, 'DGP') || _.startsWith(opCode, 'DTG')) {
                    return {isValid: false, message: 'Cannot start with DTG, DNS, or DNX'};
                }

                return {isValid: true, message: ''};
            } else {
                return {isValid: true, message: ''};
            }
        }

        function validateCombinedCustomerNameLength (dmsSystem, firstName, lastName, isBusiness) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;
            
            if (dmsSystem !== dmsEnum.ReynoldsPOWER && dmsSystem !== dmsEnum.ReynoldsERA) {
                return {isValid: true, message: 'None'};
            } else {
                const firstNameLength = firstName ? firstName.length : 0;
                const lastNameLength = lastName ? lastName.length : 0;
                const combinedLength = firstNameLength + lastNameLength;

                if (isBusiness === false) {
                    return {isValid: combinedLength <= 35, message: 'First and last name must not exceed 35 char combined.'};
                } else {
                    return {isValid: combinedLength <= 35, message: 'Customer and business name must not exceed 35 char combined.'};
                }
            }
        }

        function getDashboardCheckedLineItems (lineItems, dealerOpCodes) {
            const checkedLineItems = [].concat(
                $filter('filter')(lineItems, {isRecall: true}, true),
                $filter('filter')(lineItems, {checked: true, isGeneric: true}, true),
                $filter('filter')(dealerOpCodes, {checked: true}, true),
                $filter('filter')(lineItems, {checked: true, isOther: true}, true)
            );

            return checkedLineItems;
        }

        function getUniqueDOMID () {
            _uniqueID++;

            return 'other' + _uniqueID;
        }

        function opCodesEnabledForDept(opCodesToCheck, deptId, isDashboard) {
            const deptOpCodes = $filter('filter')(opCodesToCheck, {dealerDepartmentId: parseInt(deptId)}, true);
            let isEnabled;

            if (isDashboard) {
                isEnabled = deptOpCodes?.length > 0 && deptOpCodes[0].showInDashboard;
            } else {
                isEnabled = deptOpCodes?.length > 0 && deptOpCodes[0].showInConsumer;
            }
            
            return isEnabled;
        }

       function departmentGenericEnabled(allGenericOpCodes, deptId) {
            const genericOpCodes = $filter('filter')(allGenericOpCodes, {dealerDepartmentId: parseInt(deptId)}, true);
            const genericEnabled = genericOpCodes && genericOpCodes.length > 0 ? genericOpCodes[0].showInConsumer : false;

            return genericEnabled;
        }

        function processDashboardViewLineItems (lineItems, deptId, dealerOpCodesAll, dealerOpCodes, allRecMaintOpCodes, allRecallOpCodes) {
            const recMaintEnabledDashboard = opCodesEnabledForDept(allRecMaintOpCodes, deptId, true);
            const recMaintEnabledConsumer = opCodesEnabledForDept(allRecMaintOpCodes, deptId, false);
            const recallsEnabledDashboard = opCodesEnabledForDept(allRecallOpCodes, deptId, true);
            const recallsEnabledConsumer = opCodesEnabledForDept(allRecallOpCodes, deptId, false);

            if (lineItems) {
                lineItems.forEach((item) => {
                    const itemOpCodeId = item.dealerAppointmentServiceOpCodeId;
                    let opCode;

                    if (itemOpCodeId && dealerOpCodes) {
                        opCode = $filter('filter')(dealerOpCodes, {id: itemOpCodeId, dealerDepartmentId: deptId}, true)[0];

                        if (!opCode) {
                            opCode = $filter('filter')(dealerOpCodes, {id: itemOpCodeId}, true)[0];
                        }

                        if (!opCode && dealerOpCodesAll) {
                            opCode = $filter('filter')(dealerOpCodesAll, {id: itemOpCodeId}, true)[0];
                        }
                    } 
                    
                    item.uniqueDOMId = getUniqueDOMID();

                    if (recallsEnabledDashboard === false && recallsEnabledConsumer === false && item.isRecall === true) {
                        item.isRecall = false;
                        item.isOther = true;

                        if (opCode) {
                            opCode.isRecall = false;
                            opCode.isOther = true;
                            opCode.showInDashboard = true;
                        }
                    }

                    if (recMaintEnabledDashboard === false && recMaintEnabledConsumer === false && item.isRecommendedMaintenance === true) {
                        item.isRecommendedMaintenance = false;
                        item.isOther = true;

                        if (opCode) {
                            opCode.isRecommendedMaintenance = false;
                            opCode.isOther = true;
                            opCode.showInDashboard = true;
                        }
                    }

                    if (!opCode) {
                        return true;
                    }

                    // Set up the view model arrays properly
                    opCode.note = item.note;
                    opCode.retailPrice = item.retailPrice;
                    opCode.laborHours = item.laborHours;
                    opCode.payType = item.payType;

                    if (opCode.isAutomatic) {
                        opCode.opCodeDescription = item.dashboardDescription;
                    }

                    opCode.checked = item.checked;
                    opCode.isGeneric = item.isGeneric;

                    if (item.isGeneric) {
                        opCode.genericName = item.genericName;
                    }

                    if (item.checked) {
                        if (item.createdByUser) {
                            opCode.createdByUser = item.createdByUser;
                        } else if (item.createdBy) {
                            opCode.createdByUser = item.createdBy;
                        }
                    }
                    
                    if (recallsEnabledDashboard || recallsEnabledConsumer) {
                        opCode.isRecall = item.isRecall;
                    }

                    if (recMaintEnabledDashboard || recMaintEnabledConsumer) {
                        opCode.isRecommendedMaintenance = item.isRecommendedMaintenance;
                    }
                });       
            }     
        }

        function processPreviouslyDeclinedLineItems (declinedServices, dealerOpCodesAll, dealerOpCodes, isDashboard) {
            if (declinedServices) {
                declinedServices.forEach((item) => {
                    let opCode;

                    if (item.opCode) {
                        opCode = $filter('filter')(dealerOpCodes, {opCode: item.opCode}, true)[0];

                        if (!opCode) {
                            opCode = $filter('filter')(dealerOpCodesAll, {opCode: item.opCode}, true)[0];
                        }

                        if (opCode) {
                            item.dealerOpCode = opCode;
                            item.payType = opCode.payType || 'C';
                            item.laborHours = opCode.laborHours;
                            item.retailPrice = opCode.retailPrice;
                            item.serviceType = opCode.serviceType;
                            item.dispatchCode = opCode.dispatchCode;

                            if (isDashboard && (!item.note || item.note.length === 0)) {
                                item.note = opCode.defaultDashboardNote;
                            } else if (!isDashboard && (!item.note || item.note.length === 0)) {
                                item.note = opCode.defaultConsumerNote;
                            }

                            item.name = (isDashboard ? opCode.dashboardName : opCode.consumerName) || opCode.name;
                            
                            if (item.note) {
                                item.name += ` - ${item.note}`;
                            }
                        }
                    }

                    item.uniqueDOMId = getUniqueDOMID();                
                });
            }
        }

        function processDashboardOpCodeSearchSelected (lineItem, selectedItem, dmsSystem, defaultDispatchCode, isUpsell) {
            if (selectedItem && selectedItem.length === 1) {
                const data = selectedItem[0];

                if (!data.customValue) {
                    lineItem.dashboardName = data.dashboardName;
                    lineItem.dashboardDescription = data.dashboardDescription;
                    lineItem.name = data.name;
                    lineItem.overrideName = data.dashboardName || data.name;
                    lineItem.note = data.defaultDashboardNote;
                    lineItem.laborHours = data.laborHours;
                    lineItem.opCode = data.opCode;
                    lineItem.dispatchCode = data.dispatchCode;
                    lineItem.opCodeDescription = data.dashboardDescription || data.text || data.description;
                    lineItem.payType = data.payType;
                    lineItem.retailPrice = data.retailPrice;
                    lineItem.serviceType = data.serviceType;
                } else {
                    lineItem.overrideName = data.text;
                    lineItem.opCode = data.text;

                    if (!lineItem.opCodeDescription) {
                        lineItem.opCodeDescription = data.text;
                    }
                }

                lineItem.dateCreated = moment.utc();
                lineItem.isUpsell = isUpsell;
            } else {
                // Item was cleared, clear out previously autofilled data
                lineItem.selectedOpCode = null;
                lineItem.dashboardName = null;
                lineItem.dashboardDescription = null;
                lineItem.name = null;
                lineItem.note = null;
                lineItem.overrideName = null;
                lineItem.laborHours = 0;
                lineItem.opCode = null;
                lineItem.dispatchCode = defaultDispatchCode;
                lineItem.opCodeDescription = null;
                lineItem.payType = null;
                lineItem.retailPrice = 0;
                lineItem.serviceType = null;
                lineItem.dateCreated = moment.utc();
                lineItem.isUpsell = isUpsell;
            }
        }

        // takes in the currently selected department id
        // the op code
        // original line items on the appointment ( if we're editing )
        // previously declined items
        // and currently selected items on the appoitnment 
        // and uses this criteria to determine if the op code should be currently displayed w/ a checkbox or not
        function filterOpCodesForDisplay (selectedDepartmentId, showPreviouslyDeclinedServices, itemToCheck, originalAppointmentLineItems, previouslyDeclinedItems, currentAppointmentLineItems) {
            let existing = false;
            let current = false;
            let previouslyDeclined = false;
            const opCodeId = itemToCheck.id;
            const opCode = itemToCheck.opCode;
            
            // was it an original appointment line item that we still need to show even if dept mismatched?
            if (originalAppointmentLineItems && originalAppointmentLineItems.length > 0) {
                existing = $filter('filter')(originalAppointmentLineItems, {dealerAppointmentServiceOpCodeId: opCodeId, isAutomatic: false}, true);
                // if it was an existing line item, but is also in the current line items
                // we don't need to include it
                let testCurrent = null;

                if (currentAppointmentLineItems && currentAppointmentLineItems.length > 0) {
                    testCurrent = $filter('filter')(currentAppointmentLineItems, {opCode: opCode, isAutomatic: false}, true);

                    if (testCurrent && testCurrent.length > 0) {
                        existing = null;
                    }
                }
            }

            // is it a line item they added and switched departments w/ a mismatch?
            if (currentAppointmentLineItems && currentAppointmentLineItems.length > 0) {
                current = $filter('filter')(currentAppointmentLineItems, {dealerAppointmentServiceOpCodeId: opCodeId, isAutomatic: false}, true);
            }
            
            // if it matches a previously declined service, filter it out.
            if (showPreviouslyDeclinedServices && previouslyDeclinedItems && previouslyDeclinedItems.length > 0) {
                previouslyDeclined = $filter('filter')(previouslyDeclinedItems, {opCode: opCode}, true);

                if (previouslyDeclined && previouslyDeclined.length > 0) {
                    return false;
                }
            }

            return (itemToCheck.showInDashboard && itemToCheck.dealerDepartmentId === selectedDepartmentId) ||
                   (existing && existing.length > 0) ||
                   (current && current.length > 0);
        }

        function formatOpCodeSearchForSelection (item) {
            if (!item.customValue) {
                return item.opCode;
            }

            return item.text;
        }

        function formatOpCodeForDropDown (item) {
            if (!item.customValue) {
                return item.opCode + ': ' + item.dashboardDescription;
            }

            return item.text;
        }

        function addDashboardOtherLineItem (lineItems, dealerId, checkIt) {
            const otherLineItem = appointmentLineItemClass.new({
                dealerId: dealerId ? dealerId : null,
                opCode: '',
                genericName: null,
                note: null,
                isAutomatic: false,
                isGeneric: false,
                isRecall: false,
                isRecommendedMaintenance: false,
                isOther: true,
                dealerAppointmentServiceOpCodeId: null,
                consumerName: null,
                dashboardName: null,
                consumerDescription: null,
                dashboardDescription: null,
                payType: 'C',
                retailPrice: 0
            });

            otherLineItem.id = 0;
            otherLineItem.checked = Boolean(checkIt);
            otherLineItem.uniqueDOMId = getUniqueDOMID();
            otherLineItem.selectedOpCode = null;

            lineItems.push(otherLineItem);
        }

        function processDashboardRecMaintChecked (appointment, originalLineItems, dmsSystem, dealerRecommendedMaintenanceOpCodes, recMaint, isUpsell) {
            const currDepartment = appointment.departmentId;
            const currentUserId = authService.getCurrentUser().userId;

            const populateCommonProperties = function (newOne, copyFrom) {
                newOne.payType = copyFrom.payType;
                newOne.retailPrice = copyFrom.retailPrice;
                newOne.laborHours = copyFrom.laborHours;
                newOne.overrideName = getRecommendedMaintenanceName(copyFrom, appointment.mileageType);
                newOne.opCodeDescription = newOne.overrideName.substr(0, getOpCodeDescriptionMaxLength(dmsSystem));
                newOne.note = copyFrom.intervalMile + ' ' + appointment.mileageType.abbreviation + ' service.';
                newOne.checked = copyFrom.checked;
                newOne.createdByUser.id = currentUserId;
                newOne.createdByUser.isConsumerUser = false;
                newOne.dateCreated = moment.utc();
                newOne.isUpsell = isUpsell;
            };
            
            let existingIndex = _.findIndex(originalLineItems, (l) => { return l.isRecommendedMaintenance; });

            if (existingIndex > -1) {
                // Shallow copy the line, in the case we've toggled the line on and off, there is no reason to not send the original already saved line
                const existingRecMaint = appointmentLineItemClass.new(originalLineItems[existingIndex]);

                populateCommonProperties(existingRecMaint, recMaint);

                // Clear out any existing before adding back to the line items
                _.remove(originalLineItems, {isRecommendedMaintenance: true});
                
                originalLineItems.push(existingRecMaint);
            } else {
                // Create a new line
                const deptRecMaint = $filter('filter')(dealerRecommendedMaintenanceOpCodes, {dealerDepartmentId: parseInt(currDepartment)}, true);
                const newRecMaint = appointmentLineItemClass.new(deptRecMaint[0]);

                // The id of the rec maint op code does not need to be copied over
                newRecMaint.dealerAppointmentServiceOpCodeId = newRecMaint.id;
                newRecMaint.id = null;
                
                populateCommonProperties(newRecMaint, recMaint);
                
                originalLineItems.push(newRecMaint);
            }
        }

        function processDashboardRecMaintItemUpdated(itemsToSearch, recMaint) {
            const existingIndex = _.findIndex(itemsToSearch, (l) => { return l.isRecommendedMaintenance === true; });
            
            if (existingIndex > -1) {
                itemsToSearch[existingIndex].note = recMaint.note;
                itemsToSearch[existingIndex].payType = recMaint.payType;
                itemsToSearch[existingIndex].laborHours = recMaint.laborHours;
                itemsToSearch[existingIndex].retailPrice = recMaint.retailPrice;
                itemsToSearch[existingIndex].dispatchCode = recMaint.dispatchCode;
                itemsToSearch[existingIndex].serviceType = recMaint.serviceType;
                itemsToSearch[existingIndex].severity = recMaint.severity;
            }
        }

        function getIndexByServiceOpCodeId(collection, lineItem) {
            return collection.findIndex((l) => { return l.dealerAppointmentServiceOpCodeId === lineItem.id; });
        }

        function getIsOtherIndex(collection, lineItem) {
            // For new isOther items
            if ((!lineItem.id || lineItem.id == -1) && !lineItem.dealerAppointmentId && lineItem.uniqueDOMId) {
                return collection.findIndex((l) => l.isOther === true && l.opCode === lineItem.opCode && l.uniqueDOMId === lineItem.uniqueDOMId);
            }

            // For existing isOther items
            if (lineItem.id) {
                return collection.findIndex((l) => l.isOther === true && l.opCode === lineItem.opCode && l.id === lineItem.id);
            }

            // Fallback
            return collection.findIndex((l) => l.isOther === true && l.opCode === lineItem.opCode);
        }

        function processDashboardAuthorizationUpdated (authorizations, lineItem) {
            const existingIndex = getIndexByServiceOpCodeId(authorizations, lineItem);

            if (existingIndex > -1) {
                authorizations[existingIndex].note = lineItem.note;
                authorizations[existingIndex].retailPrice = lineItem.retailPrice;
                authorizations[existingIndex].laborHours = lineItem.laborHours;
                authorizations[existingIndex].payType = lineItem.payType;
                authorizations[existingIndex].dispatchCode = lineItem.dispatchCode;
                authorizations[existingIndex].serviceType = lineItem.serviceType;
                authorizations[existingIndex].severity = lineItem.severity;
            }
        }

        function processDashboardLineItemUpdated (appointment, lineItem) {
            let  existingIndex = -1;
            
            if (!lineItem.isOther && lineItem.id) {
                existingIndex = getIndexByServiceOpCodeId(appointment.lineItems, lineItem);
            } else if (lineItem.isOther) {
                existingIndex = getIsOtherIndex(appointment.lineItems, lineItem);
            }

            if (existingIndex > -1) {
                appointment.lineItems[existingIndex].note = lineItem.note;
                appointment.lineItems[existingIndex].retailPrice = lineItem.retailPrice;
                appointment.lineItems[existingIndex].laborHours = lineItem.laborHours;
                appointment.lineItems[existingIndex].payType = lineItem.payType;
                appointment.lineItems[existingIndex].dispatchCode = lineItem.dispatchCode;
                appointment.lineItems[existingIndex].serviceType = lineItem.serviceType;
            }
        }
 
        function getImageTypes () {
            return {
                'commonServices': APPOINTMENT_PHOTOTYPE.commonServices,
                'recommendedMaintenance': APPOINTMENT_PHOTOTYPE.recommendedMaintenance,
                'recall': APPOINTMENT_PHOTOTYPE.recall,
                'vehicleOverview': APPOINTMENT_PHOTOTYPE.vehicleOverview,
            };
        }

        function getMediaType (fileExtension) {
            const mediaTypes = SYSTEM_ENUMS.mediaTypes;

            if (fileExtension && fileExtension.split('/')[0] === 'image')
                return mediaTypes.photo;
            
            if (fileExtension && fileExtension.split('/')[0] === 'video')
                return mediaTypes.video;
            
            return mediaTypes.notSet;
        }

        function displayCountyCountry (editingExistingAppointment, displayAdditionalFields, dmsRequiredFields) {
            if (!dmsRequiredFields) return false;
            
            if (dmsRequiredFields.customerCountry || 
                dmsRequiredFields.customerCounty) { 

                if (!editingExistingAppointment || 
                    displayAdditionalFields) {
                    return true;
                }
            }

            return false;
        }

        function displayLanguage (editingExistingAppointment, displayAdditionalFields, dmsRequiredFields) {
            if (!dmsRequiredFields) return false;

            if (dmsRequiredFields.language) {
                if (!editingExistingAppointment || 
                    displayAdditionalFields) {
                    return true;
                }
            }

            return false;
        }

        function displayAddressFields (editingExistingAppointment, displayAdditionalFields, dmsRequiredFields) {
            if (!dmsRequiredFields) return false;

            if (dmsRequiredFields.customerCity ||
                dmsRequiredFields.customerState ||
                dmsRequiredFields.customerZip ||
                dmsRequiredFields.customerAddress) {
                    
                if (!editingExistingAppointment || 
                    displayAdditionalFields) {
                    return true;
                }
            }

            return false;
        }

        function isAdvisorUnmapped (appt) {
            return Boolean(appt.serviceAdvisorNumber && !appt.dealerEmployeeId);
        }

        function isYMMSameAsOriginalApptYMM (year, make, model, originalYear, originalMake, originalModel) {
            const cmpMake = make ? make.toLowerCase() : null;
            const cmpModel = model ? model.toLowerCase() : null;
            const origMake = originalMake ? originalMake.toLowerCase() : null;
            const origModel = originalModel ? originalModel.toLowerCase() : null;

            if (!originalYear && !origMake && !origModel) {
                return true;
            }

            if (typeof originalYear === 'string' && !Number.isNaN(originalYear)) {
                originalYear = parseInt(originalYear);
            }

            if (year !== originalYear || 
                cmpMake !== origMake ||
                cmpModel !== origModel) {
                return false;
            }

            return true;
        }

        function getPendingLineItemTotalEstimate (lineItems) {
            let total = 0;

            if (lineItems) {
                lineItems.forEach((service) => {
                    if (service.approved === true || service.authorizationStatus === INSPECT_CONSTANTS.lineItemStatus.approved) {
                        total += parseFloat(service.retailPrice) || 0;
                    }
                });
            }

            return total;
        }

        function createNewRecallLineItem (recallLineItem, recall) {
            const newRecallLineItem  = appointmentLineItemClass.new(recallLineItem);

            // The id of the recall op code does not need to be copied over
            newRecallLineItem.dealerAppointmentServiceOpCodeId = newRecallLineItem.id;
            newRecallLineItem.id = null;
            newRecallLineItem.manufacturerNumber = recall.manufacturerNumber;
            newRecallLineItem.note = null;
            newRecallLineItem.isOther = false;
            newRecallLineItem.payType = 'W';
            newRecallLineItem.checked = recall.checked;
            newRecallLineItem.nhtsaId = recall.nhtsaId;
            newRecallLineItem.recallDisplayName = recall.displayName;

            return newRecallLineItem;
        }

        function getRecMainTooltip (apps) {
            let toolTip = '';

            if (apps) {
                apps.forEach((app, i) => {
                    toolTip += app.taxonomy.literalName;

                    if (i !== apps.length - 1) {
                        toolTip += ', ';
                    }
                });
            }

            return toolTip;
        }

        function getRecMaintTitle (recMaint, appointment) {
            let title = '';
            const mileageType = appointment.mileageType?.abbreviation?.toUpperCase() || 'MI';

            title = recMaint.interval;
            title += ' ';
            title += mileageType;
            title += ' MAINTENANCE PACKAGE - EVERY ';
            title += recMaint.intervalMonth;
            title += ' MONTHS / ';
            
            if (mileageType === 'MI') {
                title += recMaint.intervalMile + ' MI ';
            } else {
                title += recMaint.intervalKm + ' KM ';
            }

            return title;
        }

        function removePreviouslyDeclinedRecMaint (appointment, recMaintData, previouslyDeclinedItems) {
            const recMaintsToRemove = [];

            if (previouslyDeclinedItems) {
                previouslyDeclinedItems.forEach((item) => {
                    if (item.isRecommendedMaintenance === true) {
                        // find it in the rec data and splice it
                        recMaintData.forEach((recMaint, idx) => {
                            if (item.opCodeDescription === getRecMaintTitle(recMaint, appointment).trim()) {
                                recMaintsToRemove.push(idx);
                            }
                        });
                    }
                });
            }

            for (let i = recMaintsToRemove.length - 1; i >= 0; i--) {
                recMaintData.splice(recMaintsToRemove[i], 1);
            }
        }

        function preProcesPreviouslyDeclinedServices (appointmentToBook, previouslyDeclinedItems) {
            const declinedItemsToUpdate = [];

            if (previouslyDeclinedItems) {
                previouslyDeclinedItems.forEach((item) => {
                    // it's getting added to the appointment
                    // need to create a line item w/ the proper data and add it to the appointment
                    if (item.checked) {
                        let dealerOpCode = item.dealerOpCode;
                            let newAppointmentDetail = appointmentLineItemClass.new({
                                dealerId: appointmentToBook.dealerId,
                                opCode: item.opCode,
                                note: item.note,
                                payType: item.payType,
                                retailPrice: item.retailPrice,
                                serviceType: item.serviceType,
                                laborHours: item.laborHours,
                                manufacturerNumber: item.manufacturerNumber,
                                nhtsaId: item.nhtsaId,
                                recallDisplayName: item.recallDisplayName,
                                isAutomatic: dealerOpCode ? dealerOpCode.isAutomatic : false,
                                isGeneric: dealerOpCode ? dealerOpCode.isGeneric : false,
                                isRecall: item.isRecall,
                                opCodeDescription: item.opCodeDescription,
                                overrideName: item.opCodeDescription,
                                isRecommendedMaintenance: item.isRecommendedMaintenance,
                                dealerAppointmentServiceOpCodeId: dealerOpCode ? dealerOpCode.id : null,
                                consumerName: dealerOpCode ? dealerOpCode.consumerName : '',
                                dashboardName: dealerOpCode ? dealerOpCode.dashboardName : '',
                                consumerDescription: dealerOpCode ? dealerOpCode.consumerDescription : '',
                                dashboardDescription: dealerOpCode ? dealerOpCode.dashboardDescription : ''
                            });
                        
                        delete newAppointmentDetail.id;
                        newAppointmentDetail.dateCreated = moment.utc();
                        newAppointmentDetail.isUpsell = false;
                        appointmentToBook.lineItems.push(newAppointmentDetail);

                        // need to remove it from declined items
                        declinedItemsToUpdate.push({
                            id: item.id,
                            deleted: true,
                            decline: item.isDeclined
                        });
                    } else if (item.isDeleted || item.isDeclined) {
                        declinedItemsToUpdate.push({
                            id: item.id,
                            deleted: item.isDeleted,
                            decline: item.isDeclined
                        });
                    }
                });
            }
            
            appointmentToBook.previouslyDeclinedItems = declinedItemsToUpdate;
        }

        function getActiveApptProduct (currPath) {
            const parentAppointmentLists = ['checkin-list', 'auth-list', 'inspect'];
            let activeProduct = currPath ? parentAppointmentLists.find((route) => currPath.includes(route)) || 'appointment-list' : 'appointment-list';

            return activeProduct;
        }

        function getProductSuffix (product) {
            const adjProduct = getActiveApptProduct(product);

            return adjProduct === 'appointment-list' ? '' : '-' + adjProduct;
        }

        function validateDepartment (allDepartments, departmentId) {
            const dept =  $filter('filter')(allDepartments, {id: departmentId}, true);

            return Array.isArray(dept) && dept.length > 0;
        }

        // if there are line items with the same op code, validate that they have unique
        // customer notes
        function validateUniqueNoteForDuplicateOpCodes(allLineItems, lineItemToCheck) {
            const sameOpCodes =  $filter('filter')(allLineItems, {opCode: lineItemToCheck.opCode}, true);
            const valid = {isValid: true, message: ''};

            if (sameOpCodes && sameOpCodes.length > 1) {
                let isNoteUnique = true;
                const noteToCheck = lineItemToCheck.note.trim();

                sameOpCodes.forEach((currOpCode) => {
                    if (lineItemToCheck.uniqueDOMId && currOpCode.uniqueDOMId !== lineItemToCheck.uniqueDOMId && noteToCheck === currOpCode.note.trim()) {
                        isNoteUnique = false;
                    } else if (lineItemToCheck.id && currOpCode.id !== lineItemToCheck.id && noteToCheck === currOpCode.note.trim()) {
                        isNoteUnique = false;
                    }
                });

                if (isNoteUnique) {
                    return valid;
                } else {
                    return {isValid: false, message: 'Please enter a unique complaint when using an opcode more than once.'};
                }
            } else {
                return valid;
            }            
        }

        function opCodeSelected (item) {
            return !!(item.opCode && item.opCode.length > 3);
        }

        function isCheckingIn (appointment) {
            return appointment.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.checkingIn;            
        }

        function isCheckedIn (appointment) {
            const status = appointment.appointmentStatus;
            const allStatuses = APPOINTMENT_APPOINTMENTSTATUS;

            return status === allStatuses.checkedIn ||
                status === allStatuses.completed ||
                status === allStatuses.inProgress ||
                status === allStatuses.repairOrderCreated;            
        }

        function processVehicleConditions (issues, imageArrayIsEmpty) {
            let vehicleConditions = [];

            if (issues.length > 0) {
                issues.forEach((currIssue, i) => {
                    currIssue.index = i;

                    if (currIssue.images.length === 0) {
                        if (imageArrayIsEmpty) {
                            currIssue.images = [];
                        } else {
                            currIssue.images = new Array(1).fill({});
                        }                        
                    } else {
                        currIssue.images.push({});
                    }
                });

                vehicleConditions = issues;
            }

            return vehicleConditions;            
        }

		function getDisplayMake (appt) {
            if (appt.makeName && appt.makeName !== '') 
                return appt.makeName;
            else 
                return appt.make;
        }

        function getDisplayModel (appt) {
            if (appt.modelName && appt.modelName !== '') 
                return appt.modelName;
            else 
                return appt.model;           
        }

        function gotoCheckInSummary (appt, showAuthCompleteBanner) {
            $state.go('appointment-details' + '-checkin-list', { 
                locationId: appt.dealerId,
                customerId: appt.customerId,
                appointmentId: appt.id,
                showAuthCompleteBanner: showAuthCompleteBanner
            });
        }

        function removePipedData(apptId) {
            if (apptId) {
                return apptId.split('|').shift();
            }

            return apptId;
        }

        function displayServiceHistory (appt, dmsSystem) {
            const dmsSystemEnum = SYSTEM_ENUMS.dmsSystemEnum;

            return dmsSystem !== dmsSystemEnum.None && appt.vin && appt.vin.length === 17;
        }

        function createTripCustomer (appt) {
            appt.tripCustomer = {
                firstName: appt.customerFirstName,
                lastName: appt.customerLastName,
                companyName: appt.customerCompany,
                phoneNumber: appt.customerPhone,
                email: appt.customerEmail
            };
        }

        function createNewLineItem(lineItem) {
            const newAppointmentDetail = appointmentLineItemClass.new({
                dealerId: lineItem.dealerId,
                opCode: lineItem.opCode,
                genericName: lineItem.genericName,
                note: lineItem.note,
                payType: lineItem.payType,
                retailPrice: lineItem.retailPrice,
                serviceType: lineItem.serviceType,
                laborHours: lineItem.laborHours,
                manufacturerNumber: lineItem.manufacturerNumber,
                isAutomatic: lineItem.isAutomatic,
                isGeneric: lineItem.isGeneric,
                isRecall: lineItem.isRecall,
                isRecommendedMaintenance: lineItem.isRecommendedMaintenance,
                dealerAppointmentServiceOpCodeId: lineItem.id,
                consumerName: lineItem.consumerName || lineItem.name,
                dashboardName: lineItem.dashboardName || lineItem.name,
                consumerDescription: lineItem.consumerDescription,
                dashboardDescription: lineItem.dashboardDescription
            });

            return newAppointmentDetail;
        }

        function processServicesUpdated(newValue, appt, originalAppointmentLineItems, dealer, dealerOpCodes, recalls, recMaintData) {
            appt.lineItems = [];

            const selectedServices = newValue;
            const recallsModified = selectedServices.recallsChanged;
            const lineItems = selectedServices.checkedLineItems;
            const importedLineItems = selectedServices.checkedImportedLineItems;
            const selectedRecMaint = selectedServices.selectedRecMaint;
            const dashboardRecRecMaint = selectedServices.dashboardRecRecMaint;
            const genericLineItem = dealerOpCodes.genericOpCodes[0];
            const recallLineItem = dealerOpCodes.recallOpCodes[0];
            const recMaintLineItem = dealerOpCodes.recommendedMaintenanceOpCodes[0];

            if (recalls?.length) {
                recalls.forEach((recall) => {
                    let existingIndex = -1;

                    if (recall.checked) {
                        // Check the parent original line items
                        existingIndex = originalAppointmentLineItems.findIndex((l) => { return l.manufacturerNumber === recall.manufacturerNumber; });

                        if (existingIndex > -1) {
                            // Shallow copy the line, in the case we've toggled the line on and off, there is no reason to not send the original already saved line
                            const existingRecall = appointmentLineItemClass.new(originalAppointmentLineItems[existingIndex]);
                            
                            // Throw back on the recall data for the UI
                            existingRecall.checked = recall.checked;
                            existingRecall.id = null;
                            existingRecall.nhtsaId = recall.nhtsaId;
                            existingRecall.recallDisplayName = recall.displayName;
                            existingRecall.manufacturerNumber = recall.manufacturerNumber;
                            existingRecall.pricePrefix = recallLineItem.pricePrefix;
                            appt.lineItems.push(existingRecall);
                        } else {
                            // Create a new line
                            let newRecallLineItem = createNewRecallLineItem(recallLineItem, recall);

                            newRecallLineItem.pricePrefix = recallLineItem.pricePrefix;

                            appt.lineItems.push(newRecallLineItem);
                        }
                    }
                });
            }

            if (recallsModified) {
                const allRecalls = $filter('filter')(appt.lineItems, {isRecall: true}, true);

                if (allRecalls) {
                    allRecalls.forEach((lineItem) => {
                        lineItem.id = null;
                    });
                }
            }

            // handle rec maint
            if (recMaintData) {
                recMaintData.forEach((recMaint) => {
                    if (recMaint.checked && parseInt(recMaint.interval) === parseInt(selectedRecMaint)) {
                        // Check the parent original line items
                        const existingIndex = originalAppointmentLineItems.findIndex((l) => { return l.isRecommendedMaintenance; });

                        if (existingIndex > -1) {
                            // Shallow copy the line, in the case we've toggled the line on and off, there is no reason to not send the original already saved line
                            const existingRecMaint = appointmentLineItemClass.new(originalAppointmentLineItems[existingIndex]);
                            const overrideName = getRecommendedMaintenanceName(recMaint, appt.mileageType);
                            const overrideDescription = getRecMainTooltip(recMaint.applications);
                            const opCodeDescription = overrideName.substr(0, getOpCodeDescriptionMaxLength(dealer.dmsSystem));
                            const hasChanged = overrideName === existingRecMaint.overrideName;
                                
                            existingRecMaint.overrideName = overrideName;
                            existingRecMaint.overrideDescription = overrideDescription;
                            existingRecMaint.opCodeDescription = opCodeDescription;
                            existingRecMaint.note = recMaint.interval + ' mile service.';
                            existingRecMaint.checked = recMaint.checked;
                            existingRecMaint.pricePrefix = recMaintLineItem.pricePrefix;

                            if (hasChanged) {
                                existingRecMaint.id = null;
                            }

                            appt.lineItems.push(existingRecMaint);
                        } else {
                            // Create a new line
                            const newRecMaint = appointmentLineItemClass.new(recMaintLineItem);
                            
                            // The id of the rec maint op code does not need to be copied over
                            newRecMaint.dealerAppointmentServiceOpCodeId = newRecMaint.id;
                            newRecMaint.id = null;
                            newRecMaint.overrideName = getRecommendedMaintenanceName(recMaint, appt.mileageType);
                            newRecMaint.overrideDescription = getRecMainTooltip(recMaint.applications);
                            newRecMaint.note = recMaint.interval + ' mile service.';
                            newRecMaint.opCodeDescription = newRecMaint.overrideName.substr(0, getOpCodeDescriptionMaxLength(dealer.dmsSystem));
                            newRecMaint.checked = recMaint.checked;
                            newRecMaint.pricePrefix = recMaintLineItem.pricePrefix;
                            
                            appt.lineItems.push(newRecMaint);
                        }
                    }
                });
            }
            
            if (dashboardRecRecMaint) {
                dashboardRecRecMaint.forEach((lineItem) => {
                    appt.lineItems.push(lineItem);
                });
            }

            if (lineItems) {
                lineItems.forEach((lineItem) => {
                    const appointmentDetail = createNewLineItem(lineItem);

                    appointmentDetail.apptId = appt.apptId;
                    appointmentDetail.dealerAppointmentId = appt.id;
                    appointmentDetail.pricePrefix = lineItem.pricePrefix;
                    
                    if (lineItem.isGeneric === true) {
                        appointmentDetail.dealerAppointmentServiceOpCodeId = genericLineItem.id;
                    }

                    if (originalAppointmentLineItems && originalAppointmentLineItems.length > 0) {
                        if (!lineItem.isGeneric) {
                            let originalLineItem = $filter('filter')(originalAppointmentLineItems, {dealerAppointmentServiceOpCodeId: lineItem.id}, true);

                            if (originalLineItem && originalLineItem.length > 0) {
                                appointmentDetail.id = originalLineItem[0].id;
                                appointmentDetail.createdByUser = originalLineItem[0].createdByUser; 
                            }
                        } 
                    }

                    appt.lineItems.push(appointmentDetail);                
                });
            }

            if (importedLineItems) {
                importedLineItems.forEach((lineItem) => {
                    const appointmentDetail = createNewLineItem(lineItem);

                    appointmentDetail.apptId = appt.apptId,
                    appointmentDetail.dealerAppointmentId = appt.id;
                    
                    if (originalAppointmentLineItems && originalAppointmentLineItems.length > 0) {
                        if (!lineItem.isGeneric) {
                            let originalLineItem = $filter('filter')(originalAppointmentLineItems, {opCode: lineItem.opCode}, true);

                            if (originalLineItem && originalLineItem.length > 0) {
                                appointmentDetail.id = originalLineItem[0].id;
                                appointmentDetail.createdByUser = originalLineItem[0].createdByUser; 
                            }
                        } else {
                            appointmentDetail.dealerAppointmentServiceOpCodeId = genericLineItem.id;
                        }
                    }

                    appt.lineItems.push(appointmentDetail);                
                });
            }
        }

        function customerNameRequired (dmsSystem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            if (dmsSystem === dmsEnum.ReynoldsERA
                || dmsSystem === dmsEnum.DealerTrack)
                return true;

            return false;
        }

        function getShuttleDescription (dealerTransportationTypes) {
            const apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
            const shuttleType = $filter('filter')(dealerTransportationTypes, {dealerSystemTransportationTypeId: apptTransportationTypes.shuttle}, true);
            const defaultShuttleDescription = 'Shuttle OnDemand';
        
            if (shuttleType && shuttleType.length > 0) {
                if (shuttleType[0].dashboardDescription.toLowerCase() === defaultShuttleDescription.toLowerCase()) {
                    return 'SHUTTLE';
                } else {
                    return shuttleType[0].dashboardDescription;
                }
            }
        }

        function getCreditDescription (dealerTransportationTypes) {
            const apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
            const rideShareType = $filter('filter')(dealerTransportationTypes, {dealerSystemTransportationTypeId: apptTransportationTypes.rideshareCredits}, true);
            const defaultRideShareDescription = 'Rideshare Credits';

            if (rideShareType && rideShareType.length > 0) {
                if (rideShareType[0].dashboardDescription.toLowerCase() === defaultRideShareDescription.toLowerCase()) {
                    return 'RIDESHARE CREDITS';
                } else {
                    return rideShareType[0].dashboardDescription;
                }
            }
        }

        function isTripTypePickupOrMobile(tripType) {
            if (!tripType) return false;

            const apptTransprotationTypes = APPOINTMENT_TRANSPORTATION_TYPE;
            
            return tripType.isPickup || tripType.dealerSystemTransportationTypeId === apptTransprotationTypes.mobileGarage;
        }

        function getMatchingDepartmentOpCode(allOpCodes, currLineItem, apptDeptId) {            
            // first try by id
            let deptOpCode = $filter('filter')(allOpCodes, {id: currLineItem.id}, true);

            // if id doesn't work, try just op code
            if (!deptOpCode || (deptOpCode && deptOpCode.length === 0)) {
                deptOpCode = $filter('filter')(allOpCodes, {opCode: currLineItem.opCode, dealerDepartmentId: apptDeptId}, true);
            }

            if (deptOpCode && deptOpCode.length > 0) {
                return deptOpCode[0];
            }

            return null;
        }

        function isLineItemCustomerRequest(lineItem) {
            return lineItem.createdByUser && lineItem.createdByUser.isConsumerUser;
        }

        function isLineItemUserRequest(lineItem) {
            return lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false;
        }		

        // this code takes all of the vehicle images we were previously displaying a 
        // different way on the auth pages, and makes them useable in the summary image component
        function convertVehicleConditionToImages(vehicleConditions) {
            const imagesToReturn = [];

            if (vehicleConditions) {
                vehicleConditions.forEach((condition) => {
                    if (condition.images) {
                        const desc = condition.description;

                        condition.images.forEach((image) => {
                            if (image.url) {
                                const newImg = {
                                    path: image.url,
                                    caption: desc,
                                    type: getMediaType(image.fileExtension),
                                    description: desc,
                                    dateTaken: image.dateTaken
                                };

                                imagesToReturn.push(newImg);
                            }
                        });
                    }
                });
            }

            return imagesToReturn;
        }    

        function getDeptOpCodes (opCodesToFilter, departmentId) {
            return $filter('filter')(opCodesToFilter, {dealerDepartmentId: parseInt(departmentId)}, true);
        }

		function transportationTripTypeMap(transportationType) {
            const apptTransportationTypes = APPOINTMENT_TRANSPORTATION_TYPE;

            switch (transportationType) {
                case apptTransportationTypes.dropOff:
                    return SYSTEM_ENUMS.systemTripType.dropoff;

                case apptTransportationTypes.dropOffLoaner:
                    return SYSTEM_ENUMS.systemTripType.dropoff;

                case apptTransportationTypes.pickupLoaner:
                    return SYSTEM_ENUMS.systemTripType.pickup;

                case apptTransportationTypes.pickupNoLoaner:
                    return SYSTEM_ENUMS.systemTripType.pickup;

                case apptTransportationTypes.mobileGarage:
                    return SYSTEM_ENUMS.systemTripType.mobileGarage;

                default:
                    return null;
            } 
        }

        function getSystemSeverity(severity) {
            const severities = SYSTEM_ENUMS.lineItemSeverity;
            let systemSeverity = null;
            let list = null;
           
            if (severity) {
                let list = $filter('filter')(severities, {value: severity}, true);

                if (list && list.length > 0) {
                    systemSeverity = list[0];
                }
            } 

            return systemSeverity;
        }

        function revalidateLineItem (scope, dmsSystem, lineItem) {
            const dmsEnum = SYSTEM_ENUMS.dmsSystemEnum;

            scope.$broadcast(_revalidate, 'lineItem-retailprice-' + lineItem.uniqueDOMId);
            scope.$broadcast(_revalidate, 'lineItem-laborhours-' + lineItem.uniqueDOMId);
            scope.$broadcast(_revalidate, 'lineItem-paytype-' + lineItem.uniqueDOMId);
            
            if (lineItem.isOther) {
                scope.$broadcast(_revalidate, 'opcode-' + lineItem.uniqueDOMId);
            }

            if (dmsSystem === dmsEnum.CDK) {
                scope.$broadcast(_revalidate, 'lineItem-dispatchcode-' + lineItem.uniqueDOMId);
            } else if (dmsSystem === dmsEnum.DealerTrack) {
                scope.$broadcast(_revalidate, 'lineItem-servicetype-' + lineItem.uniqueDOMId);
            }       
        }

        function isCheckInSkipped (appt, authorizations) {
            let authToView = authorizations && authorizations.length > 0 ? authorizations[0] : null;
           
            return appt.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.repairOrderCreated && !authToView;
        }

        function setLastBookedDepartment (locationId, departmentId) {
            localStorageService.set('lastBookedDealer', locationId);
            localStorageService.set('lastBookedDepartment', departmentId);
        }

        function getDefaultTranportationType(transportationTypeId, dealerTransportationTypes) {
            let filteredType = $filter('filter')(dealerTransportationTypes, {id: transportationTypeId}, true);
            
            return filteredType && filteredType.length > 0 ? filteredType[0] : null;
         }

        function getPickupDropOffOption(appointment) {
            let _apptTypeGroups = APPOINTMENT_TRANSPORTATION_TYPE_GROUP;
            
            if (appointment.transportationType && appointment.transportationType.dealerSystemTransportationTypeId === APPOINTMENT_TRANSPORTATION_TYPE.mobileGarage) {
                return _apptTypeGroups.mobile;
            } else {
                return appointment.transportationType ? appointment.transportationType.isPickup ? _apptTypeGroups.pickup : _apptTypeGroups.dropoff : _apptTypeGroups.dropoff;
            }
        }

        function getDisplayLineItemDescription(lineItem) {
            if (lineItem.dashboardDescription) {
                return lineItem.dashboardDescription;
            }

            if (lineItem.overrideName && lineItem.opCodeDescription && lineItem.overrideName !== lineItem.opCodeDescription) {
                return lineItem.opCodeDescription;
            }

            return null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.providers', []);
})();

(function () {
    'use strict';

    angular
        .module('redcap.providers')
        .provider('rcAside', function rcAsideProvider() {
            this.name = 'rcAside';

            this.showAside = function ($aside, $log, area, template, controller, resolve, backdrop, hasNoFooter, customClass, isFullAside, templateUrl) {
                this.size = 'lg';

                if (isFullAside && isFullAside === true) {
                    customClass += ' full-aside';
                }

                let options = {
                    templateUrl: templateUrl || 'app/areas/' + area + '/views/' + template,
                    container: 'body',
                    placement: 'bottom',
                    animation: false,
                    backdrop: backdrop == undefined ? 'static' : backdrop, // prevents modal from being closed by clicking background
                    show: false,
                    html: true,
                    keyboard: false,
                    size: this.size,
                    controller: controller,
                    windowClass: !hasNoFooter ? 'has-fixed-footer aside-centered' : 'aside-centered'
                };

                if (customClass) { 
                    options.windowClass += " " + customClass;
                }

                if (resolve) {
                    options.resolve = resolve;
                }

                this.aside = $aside.open(options);
                this.aside.result
                    .then(() => {
                        //do nothing at the moment
                    })
                    .catch((reason) => {
                        //aside closed, bootstrap's promise calls reject, so catch that to avoid console errors
                    });
            };

            this.destroyAside = function ($log) {
                $log.debug('start: destroying aside - cleaning up memory');
                this.aside.dismiss();
            };

            this.$get = function () {
                return {};
            };
        });
})();

(function () {
    'use strict';

    SummaryMessageTabController.$inject = ["SYSTEM_ENUMS", "permissions", "$rootScope"];
    angular
        .module('redcap')
        .component('rcSummaryMessageTab', {
            bindings: {
                trip: '<',
                appointment: '<',
                contact: '<',
                disableNotesTab: '<',
                disableCustomerTab: '<',
                activeTab: '<',
                ro: '<',
                mobileClass: '=',
                messageTemplates: '<'
            },
            templateUrl: 'app/shared/messages/views/message-tabs.view.html',
            controller: SummaryMessageTabController
        });

    function SummaryMessageTabController(SYSTEM_ENUMS, permissions, $rootScope) {
        this.$onInit = function() {
            let vm = this;
            let hasTrip = false;
            let isAdmin = permissions.isSysAdmin() || permissions.isRedCapAdmin();

            vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
           
            vm.hide = function() {
                angular.element('body').removeClass(vm.mobileClass);
            };

            vm.initMessageTabContainers = function() {
                if (vm.trip || (vm.appointment && vm.appointment.tripId)) {
                    hasTrip = true;
                }

                if (hasTrip) {
                    vm.messagingTabs = [
                        
                    ];

                    if (vm.disableCustomerTab != true) {
                        vm.messagingTabs.push(
                            {
                                title: 'CUSTOMER',
                                route: 'messages-customer',
                                active: true,
                                id: 'tab_customer',
                                tabType: SYSTEM_ENUMS.messagingPanelModes.driverCustomer
                            }
                        );
                    }

                    if (vm.trip && vm.trip.id && !vm.trip.providerRideId) {
                        vm.messagingTabs.push(
                            {
                                title: 'DRIVER',
                                route: 'messages-driver',
                                active: false,
                                id: 'tab_driver',
                                tabType: SYSTEM_ENUMS.messagingPanelModes.dealerDriver
                            },
                            {
                                title: 'MONITOR',
                                route: 'messages-monitor',
                                active: false,
                                id: 'tab_monitor',
                                tabType: SYSTEM_ENUMS.messagingPanelModes.customerDriver
                            });
                    }

                    // The notes tab is only visible to admins
                    if (isAdmin && vm.disableNotesTab !== 1 && vm.trip && vm.trip.id) {
                        vm.messagingTabs.push({
                            title: 'NOTES',
                            route: 'messages-notes',
                            active: false,
                            id: 'tab_notes',
                            tabType: SYSTEM_ENUMS.messagingPanelModes.tripNotes
                        });
                    }

                    // only display under trips .. 
                    // this component is also used in appointments
                    if (isAdmin && vm.trip) {
                        vm.messagingTabs.push({
                            title: 'DEALER INFO',
                            route: 'messages-dealer-info',
                            active: false,
                            id: 'dealer_info',
                            tabType: SYSTEM_ENUMS.messagingPanelModes.dealerInfo
                        });
                    }

                    if (hasTrip) {
                        vm.messagingTabs.push({
                            title: 'INTERNAL',
                            route: 'messages-internal',
                            active: vm.disableCustomerTab,
                            id: 'tab_internal',
                            tabType: SYSTEM_ENUMS.messagingPanelModes.internal
                        });
                    }

                    if (vm.activeTab) {
                        _.forEach(vm.messagingTabs, (tab) => { tab.active = tab.tabType === vm.activeTab; });
                    }
                } else {

                    vm.messagingTabs = [
                        
                    ];

                    if (vm.disableCustomerTab != true) {
                        vm.messagingTabs.push(
                            {
                                title: 'CUSTOMER',
                                route: 'messages-customer',
                                active: true,
                                id: 'tab_customer',
                                tabType: SYSTEM_ENUMS.messagingPanelModes.driverCustomer
                            }
                        );
                    }
                
                    vm.messagingTabs.push(
                        {
                            title: 'INTERNAL',
                            route: 'messages-internal',
                            active: vm.disableCustomerTab,
                            id: 'tab_internal',
                            tabType: SYSTEM_ENUMS.messagingPanelModes.internal
                        }
                    );
                }
            };

            vm.initMessageTabContainers();

            vm.currentTab = _.filter(vm.messagingTabs, (tab) => { return tab.active; })[0].tabType;

            vm.tabChanged = function(newTabType) {
                if (vm.currentTab === newTabType) return;
                vm.currentTab = newTabType;
                if (newTabType !== SYSTEM_ENUMS.messagingPanelModes.internal) return;
                $rootScope.$broadcast('messagesTabChanged', newTabType);
            };

        };
    }
})();
(function () {
    'use strict';

    angular.module('redcap.filters', []);
})();

(function () {
    'use strict';

    percentage.$inject = ["$filter"];
    angular
        .module('redcap.filters')
        .filter('tel', telFilter)
        .filter('timeOfDay', timeOfDayFilter)
        .filter('alphaNumRange', ['ALPHANUMERIC', alphaNumRange])
        .filter('trustUrl', ['$sce', trustUrl])
        .filter('duration', ['rcUtilService', duration])
        .filter('localDate', localDateFilter)
        .filter('percentage', percentage)
        .filter('localTime', localTime)
        .filter('localTimeOfDay', localTimeOfDay)
        .filter('titleCase', titleCase)
        .filter('sentenceCase', sentenceCase)
        .filter('time', timeFilter)
        .filter('fromNow', ['rcUtilService', fromNow])
        .filter('mpAnswerTypeCss', ['INSPECT_CONSTANTS', mpAnswerTypeCss])
        .filter('mpMeasurementUnitType', ['INSPECT_CONSTANTS', mpMeasurementUnitType]);

    function telFilter() {
        return function (tel) {
            if (!tel) { return ''; }

            let value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            let country; let city; let number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return tel;
            }

            if (country == 1) {
                country = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (country + " (" + city + ") " + number).trim();
        };
    }

    function timeOfDayFilter() {
        return function (date) {
            return moment(date).calendar();
        };
    }

    function localTimeOfDay() {
        return function (date, format) {
            if (format) {
                return moment.utc(date).local().format(format);
            } else {
                return moment.utc(date).local().calendar();
            }            
        };
    }

    function timeFilter() {
        return function (dateTime, format) {
            if (!format) {
                return moment(dateTime).format('h:mmA');
            }

            return moment(dateTime).format(format);
        };
    }

    function localDateFilter() {
        return function (date, format) {
            return date ? moment.utc(date).local().format(format ? format : 'M/D/YYYY h:mmA') : '';
        };
    }

    function alphaNumRange(ALPHANUMERIC) {
        return function (startChar, stopChar) {
            let data = ALPHANUMERIC.split('');
                let start = data.indexOf(startChar);
                let stop = data.indexOf(stopChar);

            return !~start || !~stop ? null : data.slice(start, stop + 1);
        };
    }

    function trustUrl($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }

    function fromNow(rcUtilService) {
        return function(dateTimeUtc) {
            let totalSeconds = moment.utc(dateTimeUtc).diff(moment.utc(), 'seconds');

            return duration(rcUtilService)(totalSeconds, true, false, true);
        };        
    }

    function duration(rcUtilService) {
        return function(totalSeconds, useRelativeTime, useOriginalIfInvalid, limitToDays) {
            return rcUtilService.calcDuration(totalSeconds, useRelativeTime, useOriginalIfInvalid, limitToDays);
        };
    }

    function percentage($filter) {
        return function (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        };
    }

    function localTime() {
        return function (input) {
            return moment(input).local().format();
        };
    }

    function titleCase() {
        return function (input) {
            input = input || '';

            return input.replace(/\w\S*/g, (txt) => {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        };
    }

    function sentenceCase() {
        return function (input) {
            input = input || '';

            return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
        };
    }

    function mpAnswerTypeCss(INSPECT_CONSTANTS) {
        return function(answerType) {
            switch (answerType) {
                case INSPECT_CONSTANTS.roTaskAnswerType.pass:
                    return 'success';

                case INSPECT_CONSTANTS.roTaskAnswerType.caution:
                    return 'warning';

                case INSPECT_CONSTANTS.roTaskAnswerType.fail:
                    return 'danger';

                case INSPECT_CONSTANTS.roTaskAnswerType.na:
                    return 'gray';
            }
        };
    }
    
    function mpMeasurementUnitType(INSPECT_CONSTANTS) {
		return function(input) {
			const numberInput = Number(input);

            switch (numberInput) {
				case INSPECT_CONSTANTS.measurementUnitType.thirtySecondths:
					return '/32';
                case INSPECT_CONSTANTS.measurementUnitType.millimeters:
					return 'mm';
                case INSPECT_CONSTANTS.measurementUnitType.poundsPerSquareInch:
					return 'psi';
                case INSPECT_CONSTANTS.measurementUnitType.farads:
					return 'F';
                case INSPECT_CONSTANTS.measurementUnitType.coulomb:
                        return 'C';
                case INSPECT_CONSTANTS.measurementUnitType.percent:
					return '%';
                case INSPECT_CONSTANTS.measurementUnitType.coldCrankingAmps:
                    return 'CCA';
                case INSPECT_CONSTANTS.measurementUnitType.none: // corresponds to "None"
				default:
                    return '';
			}
		};
	}
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.user')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {
        let userList = {
            parent: 'app',
            url: '/users',
            userPermission: SYSTEM_ENUMS.permissionTypes.users,
            data: {
                displayName: 'Users'
            },
            templateUrl: 'app/areas/user/views/user-list.view.html',
            controller: 'UserListController as vm',
            resolve: {
                resolvedLocationList: ['locationService', function (locationService) {
                    return locationService.getLocationsForDropDown(false, false);
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'Users - ' + parentTitle;
                }],
                resolvedRoles: ['userRolesService', function (userRolesService) {
                    return userRolesService.getRolesForUserFilter();
                }]
            }
        };

        let userEdit = {
            abstract: true,
            parent: userList,
            url: '/:userId/:userAdded',
            params: {
                userId: {squash: true, value: null},
                userAdded: {squash: true, value: null}
            },
            onEnter: ['$aside', '$log', 'user', function ($aside, $log, user) {
                rcAsideProvider.showAside($aside, $log, 'user', 'user-edit.view.html', 'UserEditController as vm', {
                    resolvedUser: function () {
                        return user;
                    }
                }, undefined, 'true', 'scroll-y-hidden');
            }],
            onExit: ['$log', 'userService', function ($log, userService) {
                rcAsideProvider.destroyAside($log);
                userService.clearCache();
            }],
            resolve: {
                user: ['userService', '$transition$', function (userService, $transition$) {
                    let editUserId = $transition$.params().userId;

                    return userService.getUser(editUserId);
                }]
            }
        };

        let userTabs = {
            parent: userEdit,
            abstract: true,
            resolve: {
            }
        };

        $stateProvider
            .state('user-list', userList)

            .state('user-add', {
                parent: userList,
                url: '/add',
                onEnter: ["$aside", "$log", function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'user', 'user-add.view.html', 'UserAddController as vm', {
                        resolvedLocationList: ['locationService', function (locationService) {
                            return locationService.getLocationsForDropDown(false, false);
                        }]
                    }, undefined, true, 'aside-sm');
                }],
                onExit: ["$log", function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'New User - ' + parentTitle;
                    }]
                }
            })

            .state('user-edit', userEdit)

            .state('user-tabs', userTabs)

            .state('user-tab-general', {
                parent: userTabs,
                url: '/general',
                views: {
                    'user-tab-general@': {
                        templateUrl: 'app/areas/user/views/user-tab-general.view.html',
                        controller: 'UserTabGeneralController as vm'
                    }
                },
                resolve: {
                    resolvedUser: ["user", function (user) {
                        return user;
                    }],
                    pageTitle: ["user", "parentTitle", function (user, parentTitle) {
                        return 'User Details (' + user.fullName + ') - ' + parentTitle;
                    }]
                }
            })

            .state('user-tab-security', {
                parent: userTabs,
                url: '/security',
                views: {
                    'user-tab-security@': {
                        templateUrl: 'app/areas/user/views/user-tab-security.view.html',
                        controller: 'UserTabSecurityController as vm'
                    }
                },
                resolve: {
                    resolvedUser: ["user", function (user) {
                        return user;
                    }],
                    resolvedRoles: ["resolvedUser", "userRolesService", function (resolvedUser, userRolesService) {
                        "ngInject";

                        return userRolesService.getUserRoles(resolvedUser.id);
                    }],
                    pageTitle: ["user", "parentTitle", function (user, parentTitle) {
                        return 'User Security (' + user.fullName + ') - ' + parentTitle;
                    }]
                }
            })

            .state('user-software-help', {
                parent: 'user-tab-security',
                url: '/softwareHelp',
                onEnter: ["$aside", "$log", function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'support', 'software-help.view.html', 'SoftwareHelpController as vm', {
                        resolvedPreviousPage: function () {
                            return 'user-tab-security';
                        },
                        resolvedTicketType: function () {
                            return "ADD USER";
                        }
                    });
                }],
                onExit: ["$log", "supportService", function ($log, supportService) {
                    supportService.clearCache();
                }],
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return  'Help (Software) - ' + parentTitle;
                    }]
                }
            })

            .state('user-tab-locations', {
                parent: userTabs,
                url: '/locations',
                views: {
                    'user-tab-locations@': {
                        templateUrl: 'app/areas/user/views/user-tab-locations.view.html',
                        controller: 'UserTabLocationsController as vm'
                    }
                },
                resolve: {
                    resolvedUser: ["user", function (user) {
                        return user;
                    }],
                    pageTitle: ["user", "parentTitle", function (user, parentTitle) {
                        return 'User Locations (' + user.fullName + ') - ' + parentTitle;
                    }]
                }
            })

            .state('user-tab-settings', {
                parent: userTabs,
                url: '/settings',
                views: {
                    'user-tab-settings@': {
                        templateUrl: 'app/areas/user/views/user-tab-settings.view.html',
                        controller: 'UserTabSettingsController as vm'
                    }
                },
                resolve: {
                    resolvedUser: ["user", function (user) {
                        return user;
                    }],
                    pageTitle: ["user", "parentTitle", function (user, parentTitle) {
                        return 'User Settings (' + user.fullName + ') - ' + parentTitle;
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

        wizard.$inject = ["$log"];
    angular
        .module('redcap')
        .directive('wizard', wizard);

        function wizard($log) {
            var scope, vm;    
            
            return {
                restrict: 'EA',
                priority: 1,
                controller: ["$scope", function ($scope) {
                    scope = $scope;
                    vm = scope.vm;
                }],
                compile: function(element, attr) {

                    var steps = element.steps({
                        headerTag: 'h3', 
                        bodyTag: attr.bodyTag,
                        transitionEffect: 'slide',
                        transitionEffectSpeed: 500,
                        onStepChanging: function (event, currentIndex, nextIndex) {
                            return vm.stepChanging(event, currentIndex, nextIndex);
                        },
                        onStepChanged: function (event, currentIndex, nextIndex) {
                            return vm.stepChanged(event, currentIndex, nextIndex);
                        },
                        onFinishing: function (event, currentIndex) {
                            return vm.finishing(event, currentIndex);
                        },
                        onFinished: function (event, currentIndex) {
                            return vm.finished();
                        },
                        stepsOrientation: attr.stepOrientation || 'horizontal'
                    });

                    return {
                        pre: function (scope, element, attr) {
                            if (attr.stepOrientation !== 'vertical') {  // if steps are horizontal, the width should be dynamic
                                var steps = scope.vm.templates.length;
                                var widthPer = Math.floor(10000 / steps) / 100;
                                angular.element(document.querySelector('.wizard > .steps > ul > li')).css('width', widthPer + '%');
                            }
                        },
                        post: function (scope, element, attr) {
                            scope.$on('gotoStep', function(event, args) {
                                var elem = angular.element(document.querySelector('#steps-uid-0-t-' + args));
                                elem.click();
                            });

                            scope.$on('removeStep', function (event, args) {
                                element.steps('remove', args);
                            });
                        }
                    };
                }
            };

        }

})();
(function () {
    'use strict';

    unsavedFormAlert.$inject = ["$state"];
    angular
        .module('redcap.directives')
        .directive('form', unsavedFormAlert);

    function unsavedFormAlert($state) {
        return {
            restrict: 'E',
            require: '^form',
            priority: 0,
            link: function (scope, element, attrs, formCtrl) {
                var noCheck = attrs.hasOwnProperty('allowUnsaved');

                // add property to form used for submit action
                formCtrl.$isSubmitted = false;

                scope.$emit('form.locator', formCtrl);

                var warnMessage = 'You have unsaved changes - are you sure you want to leave the page?';
                
                window.onbeforeunload = function (event) {
                    if (!isClean() && !noCheck) {
                        return warnMessage;
                    }
                };

                formCtrl.isOkToRemove = function () {
                    if (continueOn()) {
                        formCtrl.$isSubmitted = true;
                        return true;
                    }
                    
                    return false;
                }; 

                function isClean() {
                    if (formCtrl.$isSubmitted)
                        return true;

                    if (formCtrl.$pristine) 
                        return true;
                }

                function continueOn() {
                    if (isClean() && !noCheck)
                        return true;

                    var shouldContinue = confirm(warnMessage);
                    if (shouldContinue)
                        return true;
                        
                    return false;
                }
            }
        };
        
    }
     
})();
(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('uiSelectOptionsTitle', ['$timeout', '$compile', uiSelectOptionsTitle]);

    function uiSelectOptionsTitle($timeout, $compile) {
        return {
            restrict: 'A',
            priority: 1000,
            scope: {
                uiSelectOptionsTitle: '@'
            },
            link: function($scope, element, attr) {
                let locationElem = $('<div class="chosen-option-hover"></div>');

                let changeToolTipLoc = function (targetElem) {
                    let offset = elem.offset();
                    let tooltipX = targetElem.width() + 50;
                    let tooltipY = offset.top - 90;

                    locationElem.css({top: tooltipY, left: tooltipX, zIndex: 500});
                    // $timeout(function () { debugger; }, 500);    // uncomment to style
                };

                let showTooltip = function() {
                    hideTooltip();

                    if ($scope.uiSelectOptionsTitle && $scope.uiSelectOptionsTitle.length > 0) {
                        let target = $(element);

                        locationElem.html($scope.uiSelectOptionsTitle);
    
                        // find the parent container
                        while (!target.hasClass('ui-select-container')) {
                            target = target.parent();
                        }
    
                        // append the div to the parent container
                        target.parent().parent().parent().append(locationElem);
                        changeToolTipLoc(target);   
                    }
                };

                const hideTooltip = function () {
                    $('div.chosen-option-hover').remove();
                };

                let elem = $(element);
                
                elem = elem.parent().parent();
                elem.on('mouseenter', showTooltip)
                    .on('mouseleave', hideTooltip);

                $compile($scope)(element);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('redcap.appointment')
        .factory('typeaheadSelectionService', typeaheadSelectionService);

    function typeaheadSelectionService() {
        return {
            resolveSelection: resolveSelection
        };

        function resolveSelection(tag, map, suggestions) {
            map = map || {};
            suggestions = suggestions || [];

            const findSuggestionById = (id) => suggestions.find((s) => String(s.id) === String(id));
            const findSuggestionByName = (name) => suggestions.find((s) => s.name === String(name));
            const lookupMap = (key) => map[String(key)] || map[key];
            const lookup = (key) => findSuggestionById(key)?.item || lookupMap(key);

            if (tag?.id) return lookup(tag.id);
            if (tag?.name) return findSuggestionByName(tag.name)?.item || lookup(findSuggestionByName(tag.name)?.id);

            return lookup(tag) || findSuggestionByName(tag)?.item || lookup(findSuggestionByName(tag)?.id);
        }
    }
})();

(function () {
    'use strict';

    tripCircles.$inject = ["$timeout", "$window", "MOMENTJS_FORMAT", "SYSTEM_ENUMS"];
    angular
        .module('redcap.directives')
        .directive('tripCircles', tripCircles);

    function tripCircles($timeout, $window, MOMENTJS_FORMAT, SYSTEM_ENUMS) {
        let xmlns = 'http://www.w3.org/2000/svg';

        let stopTypes = {
                dealer: 0,
                customer: 1,
                other: 2,
                accepted: 10
            };
            let plannedRowY = 50;
            let estimatedRowY = 66;
            let smallText = 11;

        return {
            restrict: 'E',
            template: '<svg xmlns="' + xmlns + '" id="trip-state-circles-svg" preserveAspectRatio="none"></svg>',
            replace: true,
            scope: {
                stops: '<',
                currentStep: '<',
                tripType: '<'
            },
            link: init
        };

        function p(x, y) {
            return x + ' ' + y + ' ';
        }

        function rectangle(x, y, w, h, r1, r2, r3, r4) {  //roundedRectangle(x, y, width, height, upper_left_corner, upper_right_corner, lower_right_corner, lower_left_corner)
            let strPath = 'M' + p(x + r1, y);                                                       //A

            strPath += 'L' + p(x + w - r2, y) + 'Q' + p(x + w, y) + p(x + w, y + r2);               //B
            strPath += 'L' + p(x + w, y + h - r3) + 'Q' + p(x + w, y + h) + p(x + w - r3, y + h);   //C
            strPath += 'L' + p(x + r4, y + h) + 'Q' + p(x, y + h) + p(x, y + h - r4);               //D
            strPath += 'L' + p(x, y + r1) + 'Q' + p(x, y) + p(x + r1, y);                           //A
            strPath += 'Z';

            return strPath;
        }

        function createCircles(tripType, stops, currentStep, element) {
            element.html('');
            let spread = 20; let multiplier = 3;
                let rect = document.createElementNS(xmlns, 'rect');
                let hideDealerStops = false;

            if (tripType === SYSTEM_ENUMS.systemTripType.mobileGarage) {
                hideDealerStops = true;
            }

            let stopCnt = 0;

            if (hideDealerStops === true) {
                let filteredStops = stops.filter(x => x.stopType !== stopTypes.dealer);

                stopCnt = filteredStops.length;
            } else {
                stopCnt = stops.length;
            }

            rect.setAttributeNS(null, 'x', 0);
            rect.setAttributeNS(null, 'y', 0);
            rect.setAttributeNS(null, 'height', 25);
            rect.setAttributeNS(null, 'width', ((stops == null ? 0 : stopCnt + 1) * 55));
            rect.setAttributeNS(null, 'rx', 3);
            rect.setAttributeNS(null, 'ry', 3);
            rect.setAttributeNS(null, 'class', 'state-circle-complete');
            rect.setAttributeNS(null, 'fill-opacity', 0.6);
            element.append(rect);

            let rectWidth = 0;
                let roundedBorderRight = 10;

            switch (currentStep) {
                case 0:
                    break;
                case 1:
                    rectWidth = 22;
                    break;
                case 2:
                    rectWidth = 50;
                    break;
                case 3:
                    rectWidth = 80;
                    break;
                case 4:
                    rectWidth = 110;
                    break;
                case 5:
                    rectWidth = 140;
                    break;
                case 6:
                    rectWidth = 170;
                    break;
                case 7:
                    rectWidth = 200;
                    break;
                case 8:
                    rectWidth = 225;
                    break;
                default:
                    break;
            }

            if (currentStep >= (stops == null ? 0 : stopCnt) * 2 + 2) {
                roundedBorderRight = 3;
                rectWidth = ((stops == null ? 0 : stopCnt) + 1) * 55;
            }

            let rectPath = rectangle(0, 0, rectWidth, 25, 3, roundedBorderRight, roundedBorderRight, 3);
                let path = document.createElementNS(xmlns, 'path');

            path.setAttributeNS(null, 'd', rectPath);
            path.setAttributeNS(null, 'class', 'state-circle-complete');
            if (rectWidth > 0)
                element.append(path);

            element.append(createCircle(10, 20, 13, 0, '#fff', 1));
            element.append(createStateImg(stopTypes.accepted, '15px', '15px', 12, 5));

            // estimated times
            let text = document.createElementNS(xmlns, 'text');

            text.setAttributeNS(null, 'font-size', 11);
            text.setAttributeNS(null, 'x', 0 + 2);
            text.setAttributeNS(null, 'fill', 'grey');
            text.setAttributeNS(null, 'y', plannedRowY);
            //text.setAttributeNS(null, 'class', 'hidden-xs visible-sm visible-md visible-lg');//todomx add visible-sm to show on mobile
            let t = document.createTextNode('Planned');

            text.appendChild(t);
            element.append(text);

            //  scheduled/actual times
            text = document.createElementNS(xmlns, 'text');
            text.setAttributeNS(null, 'font-size', smallText);
            text.setAttributeNS(null, 'x', 0 + 2);
            text.setAttributeNS(null, 'fill', 'grey');
            text.setAttributeNS(null, 'y', estimatedRowY);
            text.setAttributeNS(null, 'class', 'estimated-time'); //todomx
            t = document.createTextNode('Actual');
            text.appendChild(t);
            element.append(text);

            for (let i = 0, length = (stops == null ? 0 : stops.length); i < length; i++) {
                let stop = stops[i];
                    let dist = (i + 1) * multiplier * spread;

                if (stop.stopType !== stopTypes.dealer || (stop.stopType === stopTypes.dealer && hideDealerStops === false)) {
                    stop.localEstimatedTime = utcToLocal(stop.estimatedArrival);
                    stop.localScheduledTime = stop.scheduledArrival ? utcToLocal(stop.scheduledArrival) : null;
                    stop.localActualTime = stop.actualArrival ? utcToLocal(stop.actualArrival) : null;

                    let g = document.createElementNS(xmlns, 'g');

                    g.setAttributeNS(null, 'class', 'image-leaf');
                    g.append(createCircle(10, dist + 12 + 7, 13, 0, '#fff', 1));
                    g.append(createStateImg(stop.stopType, '15px', '15px', dist + 12, 5));
                    element.append(g);

                    // estimated times
                    g = document.createElementNS(xmlns, 'g');
                    g.setAttributeNS(null, 'class', 'text-leaf');
                    text = document.createElementNS(xmlns, 'text');
                    text.setAttributeNS(null, 'font-size', smallText);
                    text.setAttributeNS(null, 'x', dist + 2);
                    text.setAttributeNS(null, 'fill', 'grey');
                    text.setAttributeNS(null, 'y', plannedRowY);
                    t = document.createTextNode(stop.localEstimatedTime ? stop.localEstimatedTime.replace('M', '') : '');
                    text.appendChild(t);
                    g.appendChild(text);
                    element.append(g);

                    //  scheduled/actual times
                    g = document.createElementNS(xmlns, 'g');
                    g.setAttributeNS(null, 'class', 'text-leaf');
                    text = document.createElementNS(xmlns, 'text');
                    text.setAttributeNS(null, 'font-size', smallText);
                    text.setAttributeNS(null, 'x', stop.actualArrival ? dist + 2 : dist - 1);
                    text.setAttributeNS(null, 'y', estimatedRowY);
                    text.setAttributeNS(null, 'class', 'estimated-time');//todomx

                    if (stop.actualArrival) {
                        text.setAttributeNS(null, 'fill', stop.estimatedArrival < stop.actualArrival ? 'red' : 'grey');
                        $(g).append($('<title>Actual Arrival: ' + utcToLocalDateTime(stop.actualArrival) + '</title>'));
                        t = document.createTextNode(stop.localActualTime ? stop.localActualTime.replace('M', '') : '');
                    } else {
                        text.setAttributeNS(null, 'fill', stop.estimatedArrival < stop.scheduledArrival ? 'red' : 'grey');
                        if (stop.scheduledArrival) $(g).append($('<title>Estimated Arrival: ' + utcToLocalDateTime(stop.scheduledArrival) + '</title>'));
                        t = document.createTextNode(stop.localScheduledTime ? '(' + stop.localScheduledTime.replace('M', '') + ')' : '');
                    }

                    text.appendChild(t);
                    g.append(text);
                    element.append(g);
                }
            }
        }

        function onResize(element) {
            let parent = element.parent();

            element.attr({
                width: parent.width(),
                height: parent.height()
            });
        }

        function utcToLocal(momentUtcTime) {
            if (typeof momentUtcTime.getMonth !== 'function')
                return moment.utc(momentUtcTime + 'Z', MOMENTJS_FORMAT).local().format('hh:mmA');
            else
                return moment.utc(momentUtcTime).local().format('hh:mmA');
        }

        function utcToLocalDateTime(momentUtcTime) {
            return moment.utc(momentUtcTime + 'Z', MOMENTJS_FORMAT).local().format('MMM DD hh:mm A');
        }

        function stateCircleColor(currentStep, circleStep) {
            return 'state-circle' + (currentStep > circleStep ? '-complete' : '');
        }

        function stateTextColor(currentStep, circleStep) {
            return currentStep > circleStep ? '#FFF' : '#000';
        }

        function createCircle(radius, cx, cy, fillOpacity, stroke, strokeWidth) {
            let circle = document.createElementNS(xmlns, 'circle');

            circle.setAttributeNS(null, 'r', radius);
            circle.setAttributeNS(null, 'fill-opacity', fillOpacity);
            circle.setAttributeNS(null, 'cx', cx);
            circle.setAttributeNS(null, 'cy', cy);
            circle.setAttributeNS(null, 'stroke', stroke);
            circle.setAttributeNS(null, 'stroke-width', strokeWidth);

            return circle;
        }

        function createStateImg(type, width, height, x, y) {
            let stepImg = document.createElementNS(xmlns, 'image');

            stepImg.setAttributeNS(null, 'x', x);
            stepImg.setAttributeNS(null, 'y', y);
            stepImg.setAttributeNS(null, 'width', width);
            stepImg.setAttributeNS(null, 'height', height);

            switch (type) {
                case stopTypes.dealer:
                    stepImg.setAttributeNS(null, 'href', '/assets/images/Dealer Trip Circle.svg');
                    break;
                case stopTypes.accepted:
                    stepImg.setAttributeNS(null, 'href', '/assets/images/Accepted Trip Circle.svg');
                    break;
                case stopTypes.customer:
                default:
                    stepImg.setAttributeNS(null, 'href', '/assets/images/Customer Trip Circle.svg');
                    break;
            }

            return stepImg;
        }

        function init(scope, element) {
            while (element.firstChild) {    // quick way to remove all children and refresh the node
                element.removeChild(element.firstChild);
            }

            scope.$watch('stops', (newValue, oldValue) => {
                if (newValue && newValue !== oldValue)
                    createCircles(scope.tripType, newValue, scope.currentStep, element);
            });

            scope.$watch('currentStep', (newValue, oldValue) => {
                if (newValue && newValue !== oldValue)
                    createCircles(scope.tripType, scope.stops, newValue, element);
            });

            createCircles(scope.tripType, scope.stops, scope.currentStep, element);

            angular.element($window).on('resize', () => {
                onResize(element);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('textboxResize', textboxResize);

    textboxResize.$inject = ['$timeout'];

    function textboxResize($timeout) {

        var directive = {
            restrict: 'A',
            link: function textboxResizeLink(scope, element) {

                element.css({ 'height': 'auto', 'overflow-y': 'hidden' });
                $timeout(function () {
                    element.css('height', element[0].scrollHeight + 'px');
                }, 100, false);

                element.on('input', function () {
                    element.css({ 'height': 'auto', 'overflow-y': 'hidden' });
                    element.css('height', element[0].scrollHeight + 'px');

                });
            }
        };

        return directive;
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
     
     .directive("ngTextTruncate", ["$compile", "ValidationServices", "CharBasedTruncation", "WordBasedTruncation",
        function($compile, ValidationServices, CharBasedTruncation, WordBasedTruncation) {
        return {
            restrict: "A",
            scope: {
                text: "=ngTextTruncate",
                charsThreshould: "@ngTtCharsThreshold",
                wordsThreshould: "@ngTtWordsThreshold",
                customMoreLabel: "@ngTtMoreLabel",
                customLessLabel: "@ngTtLessLabel"
            },
            controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
                $scope.toggleShow = function() {
                    $scope.open = !$scope.open;
                };

                $scope.useToggling = $attrs.ngTtNoToggling === undefined;
            }],
            link: function($scope, $element, $attrs) {
                $scope.open = false;

                ValidationServices.failIfWrongThreshouldConfig($scope.charsThreshould, $scope.wordsThreshould);

                let CHARS_THRESHOLD = parseInt($scope.charsThreshould);
                let WORDS_THRESHOLD = parseInt($scope.wordsThreshould);

                $scope.$watch("text", () => {
                    $element.empty();
                    
                    if (CHARS_THRESHOLD) {
                        if ($scope.text && CharBasedTruncation.truncationApplies($scope, CHARS_THRESHOLD)) {
                            CharBasedTruncation.applyTruncation(CHARS_THRESHOLD, $scope, $element);

                        } else {
                            $element.append($scope.text);
                        }
                    } else {
                        if ($scope.text && WordBasedTruncation.truncationApplies($scope, WORDS_THRESHOLD)) {
                            WordBasedTruncation.applyTruncation(WORDS_THRESHOLD, $scope, $element);

                        } else {
                            $element.append($scope.text);
                        }
                    }
                });
            }
        };
    }])


    .factory("ValidationServices", () => {
        return {
            failIfWrongThreshouldConfig: function(firstThreshould, secondThreshould) {
                if (! firstThreshould && ! secondThreshould || firstThreshould && secondThreshould) {
                    throw "You must specify one, and only one, type of threshould (chars or words)";
                }
            }
        };
    })


    .factory("CharBasedTruncation", ["$compile", function($compile) {
        return {
            truncationApplies: function($scope, threshould) {
                return $scope.text.length > threshould;
            },

            applyTruncation: function(threshould, $scope, $element) {
                if ($scope.useToggling) {
                    let el = angular.element("<span>" + 
                                                    $scope.text.substr(0, threshould) + 
                                                    "<span ng-show='!open'>...</span>" +
                                                    "<span class='btn-link ngTruncateToggleText' " +
                                                        "ng-click='toggleShow()'" +
                                                        "ng-show='!open'>" +
                                                        " " + ($scope.customMoreLabel ? $scope.customMoreLabel : "More") +
                                                    "</span>" +
                                                    "<span ng-show='open'>" + 
                                                        $scope.text.substring(threshould) + 
                                                        "<span class='btn-link ngTruncateToggleText'" +
                                                              "ng-click='toggleShow()'>" +
                                                            " " + ($scope.customLessLabel ? $scope.customLessLabel : "Less") +
                                                        "</span>" +
                                                    "</span>" +
                                                "</span>");

                    $compile(el)($scope);
                    $element.append(el);

                } else {
                    $element.append($scope.text.substr(0, threshould) + "...");

                }
            }
        };
    }])


    .factory("WordBasedTruncation", ["$compile", function($compile) {
        return {
            truncationApplies: function($scope, threshould) {
                return $scope.text.split(" ").length > threshould;
            },

            applyTruncation: function(threshould, $scope, $element) {
                let splitText = $scope.text.split(" ");

                if ($scope.useToggling) {
                    let el = angular.element("<span>" + 
                                                    splitText.slice(0, threshould).join(" ") + " " + 
                                                    "<span ng-show='!open'>...</span>" +
                                                    "<span class='btn-link ngTruncateToggleText' " +
                                                        "ng-click='toggleShow()'" +
                                                        "ng-show='!open'>" +
                                                        " " + ($scope.customMoreLabel ? $scope.customMoreLabel : "More") +
                                                    "</span>" +
                                                    "<span ng-show='open'>" + 
                                                        splitText.slice(threshould, splitText.length).join(" ") + 
                                                        "<span class='btn-link ngTruncateToggleText'" +
                                                              "ng-click='toggleShow()'>" +
                                                            " " + ($scope.customLessLabel ? $scope.customLessLabel : "Less") +
                                                        "</span>" +
                                                    "</span>" +
                                                "</span>");

                    $compile(el)($scope);
                    $element.append(el);

                } else {
                    $element.append(splitText.slice(0, threshould).join(" ") + "...");
                }
            }
        };
    }]);
})();
(function() {
    'user strict';

    angular
        .module('redcap.directives')
        .directive('textEllipse', textEllipseDirective);

    textEllipseDirective.$inject = ['$compile', '$timeout'];

    function textEllipseDirective($compile, $timeout) {
        let directive = {
            restrict: 'A',
            scope: {
                textMaxLines: '@?',
                useArrowIcons: '=?'
            },
            link: link
        };

        function link(scope, element, attrs) {

            function initialize() {
                scope.collapsed = true;

                scope.toggle = function() {
                    scope.collapsed = !scope.collapsed;
                };

                // Calculate the number of lines used
                let originalHtml = String(element.html());
                let lineHeight = parseFloat(window.getComputedStyle(element[0]).lineHeight);
                let textHeight = element[0].offsetHeight;
                let linesUsed = Math.round(textHeight / lineHeight);
                let maxLines = parseInt(scope.textMaxLines) || 3;
               
                if (linesUsed > maxLines) {
                    let originalText = element.text();
                    let lastWord = '';

                    // Create a temporary element to find the split point
                    let tempElement2 = angular.element('<div style="position:absolute; visibility:hidden; height:auto; width:' + element[0].offsetWidth + 'px;"></div>');

                    angular.element(document.body).append(tempElement2);

                    const words = originalText.split(/\s+/);
                    let accumulatedText = '';

                    for (let i = 0; i < words.length; i++) {
                        let testText = accumulatedText ? `${accumulatedText} ${words[i]}` : words[i];

                        if (scope.useArrowIcons == true) {
                            tempElement2.html(testText + '... <i class= "material-icons md-24 cursor-pointer">expand_more</i>'); // account for the "more" text
                        } else {
                            tempElement2.html(testText + '... (more)'); // account for the "more" text
                        }

                        if (tempElement2[0].offsetHeight / lineHeight > maxLines) {
                            lastWord = words[i - 1]; // get the last word that fits 
                            break;
                        }

                        accumulatedText = testText;
                    }

                    let htmlSplitIndex = mapTextIndexToHtmlIndex(originalHtml, accumulatedText.length);

                    let firstPart = originalHtml.substring(0, htmlSplitIndex);
                    let secondPart = originalHtml.substring(htmlSplitIndex);

                    // Remove the temporary element
                    tempElement2.remove();

                    // Build the HTML string
                    let returnString = '<span>' + firstPart + '</span>';
                    
                     
                    if (scope.useArrowIcons == true) {
                        returnString += '<span ng-if="!collapsed">' + secondPart + '</span>';
                        returnString += '<span ng-click="toggle()"><i class= "material-icons md-24 cursor-pointer align-bottom line-height-18">{{collapsed ? "expand_more" : "expand_less"}}</i></span>';
                    } else {
                        returnString += '<span ng-if="collapsed">...</span>';
                        returnString += '<span ng-if="!collapsed">' + secondPart + '</span>';
                        returnString += '<br ng-if="!collapsed">';
                        returnString += '<span class="collapse-text-toggle" ng-click="toggle()">{{collapsed ? "more" : "less"}}</span>';
                    }

                    // Clear the element's content
                    element.empty();

                    // Compile the HTML string and link it with the scope
                    let compiledContent = $compile(returnString)(scope);

                    element.append(compiledContent);
                } else {
                    element.empty();
                    element.html(originalHtml);
                }
            }

            $timeout(initialize, 0);
        }

        return directive;
    }

    // Maps a plain-text character position to the equivalent index in an HTML string, skipping over tags.
    function mapTextIndexToHtmlIndex(html, textIndex) {
        let textCount = 0;
        let inTag = false;

        for (let i = 0; i < html.length; i++) {
            if (textCount >= textIndex) return i;

            if (html[i] === '<') {
                inTag = true;
            } else if (inTag && html[i] === '>') {
                inTag = false;
            } else if (!inTag) {
                textCount++;
            }
        }

        return html.length;
    }
    
})();
(function () {
    'use strict';

    Select2Directive.$inject = ["$timeout"];
    angular
        .module('redcap.directives')
        .directive('select2', Select2Directive);

    /**
     * @name scope.initValue
     * @description
     * An object literal representation of the initial object used to prepopulated the selected item.
     * Requires an "id" or "text" property to be set on the model
     * @param {$timeout} $timeout passed in
     * @name scope.onChange
     *
     * @description
     * A callback function raised on the user selection event that takes two parameters.
     * The first parameter may be named anything and is isolated scope to the control. (If nested in an ng-repeater,
     * the parameter is isolated to the item the control repeated on)
     * The second parameter is injected programmatically directive side, and *must* be named "selectedResult" in the view.
     * It will either be an array (if the multiple tag is specified) or an object literal of the selected row from the result set.
     *
     * @returns {results}
     * Example:
     * ```
     * VIEW
     * <div ng-repeat="item in items">
     *   <select select2 on-change="ctrl.onUserChanged(item, selectedResult)"></select>
     * </div>
     *
     * CONTROLLER
     * ctrl.onUserChanged = function (item, selectedResultParameterHereCanBeNamedAnything) {
     *   // logic
     * };
     * ```
     */
    function Select2Directive($timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                uid: '@',
                id: '@?',
                name: '@?',
                initValue: '=?',
                placeholder: '@',
                onChange: '&',
                minInputLength: '=?',
                allowAnyInputOnEmptyResults: '=?',
                query: '=',
                formatForSelection: '=',
                formatForDropdown: '=',
                dropdownParent: '@?'
            },
            link: function (scope, element, attr, ngModel) {
                element.attr('multiple', '');
                element.attr('class', 'select2-single form-control');
                element.on('change', (e) => {
                    // Fire off our on change with the selected object
                    scope.$apply(() => {
                        let data = element.select2('data');

                        scope.onChange({'selectedResult': data});
                    });
                });
                scope.$on('$destroy', () => {
                    element.select2('destroy');
                    element.off('change');
                });
                let defaultSelect2Options = {
                    width: '100%',
                    dropdownAutoWidth: true,
                    minimumInputLength: scope.minInputLength || 3,
                    maximumSelectionLength: 1,
                    allowClear: true,
                    tags: scope.allowAnyInputOnEmptyResults || false,
                    createTag: function (params) {
                        let term = params?.term?.trim() || '';

                        if (!term) {
                            return null;
                        }

                        return {
                            id: `${term}_custom`,
                            text: term,
                            customValue: true
                        };
                    },
                    placeholder: scope.placeholder || null,
                    ajax: scope.query,
                    templateSelection: function (item) {
                        if (!item.id) return item.text;

                        return scope.formatForSelection(item);
                    },
                    templateResult: function (item) {
                        if (item.loading) {
                            return 'Searching...';
                        }

                        return scope.formatForDropdown(item);
                    }
                };

                // Add dropdownParent if specified to contain dropdown within modal
                if (scope.dropdownParent) {
                    defaultSelect2Options.dropdownParent = $(scope.dropdownParent);
                }

                if (scope.initValue && scope.initValue.id && scope.initValue.id !== "") {
                    if (ngModel) {
                        ngModel.$setViewValue([scope.formatForSelection(scope.initValue)]);
                    }

                    scope.initValue.selected = true;
                    defaultSelect2Options.data = [scope.initValue];
                } else {
                    $timeout(() => {
                        element.val(null).trigger('change');
                    }, 100);
                }

                // If we've set an id using any sort of angular interpolation, the select2 constructor has issues
                if (scope.id && element.attr('id').indexOf('{{') > -1) {
                    element.attr('id', scope.id);
                }

                element.select2(defaultSelect2Options);
            }
        };
    }
})();

(function () {
    'use strict';

    selectlabel.$inject = ["$timeout"];
    angular
        .module('redcap.directives')
        .directive('selectlabel', selectlabel);

    function selectlabel($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, el, attrs, ngModel) {
                let label = el.prev();
                let onClass = "on";
                let idsWithValidZeroValue = "vehicle_transmission,vehicle2_transmission,is_new";

                el.on('focus', () => {
                    activate();
                });

                el.on('blur', () => {
                    deactivate();
                });

                el.on('change', () => {
                    if (isEmptyVal()) {
                        deactivate();
                    } else {
                        activate();
                    }
                });

                let isEmpty = function(value) {
                    if (value && !_.isUndefined(value) && (value.value || value.text || value.id)) {
                        if (value.value === 0 && (value.text === "Automatic" || value.text === "USED" || value.text === 'MI')) { 
                            // we shouldn't have made transmission value 0 for automatic, but will be a pain to change it everywhere now
                            return false;
                        } else if (value.value === 0) {
                            return true; // for all the other selects this is the null value
                        }

                        if (value.value || value.id) {
                            return false;
                        }
                    }

                    if (value == null) {
                        value = ngModel && ngModel != null ? ngModel.$viewValue : el.val();
                    }

                    return !el[0].validity.badInput && !((value != null) && (!angular.isString(value) || value !== '') && (!angular.isArray(value) || !value.isEmpty()) && (angular.isString(value) || angular.isArray(value) || (el.val() && el.val().trim().length > 0 || !isNaN(value))));
                };
                
                let isEmptyVal = function () {
                    if (el.val() === "" || (el.val() === "0" && !_.includes(idsWithValidZeroValue, el[0].id))) {
                        return true;
                    }

                    return false;
                };
                
                let activate = function() {
                    label.addClass(onClass);
                    el.addClass(onClass);

                    if (isEmptyVal()) {
                        el.addClass("watermark");
                    } else {
                        el.removeClass("watermark");
                    }
                };
                
                let deactivate = function() {
                    if (isEmptyVal()) {
                        label.removeClass(onClass);
                        el.removeClass(onClass);
                    }
  
                    el.removeClass("watermark");
                };

                // Watch for disabled state changes. Supports both ng-disabled and a plain disabled attribute.
                if (attrs.ngDisabled) {
                    scope.$watch(attrs.ngDisabled, (newVal) => {
                        if (ngModel) {
                            return ngModel.$formatters.push((value) => {
                                if (isEmpty(value)) {
                                    deactivate();
                                } else {
                                    activate();
                                }

                                return value;
                            });
                        } else if (!isEmpty()) {
                            if (newVal) {
                                // When disabled, force active styles
                                activate();
                            } else {
                                // When enabled, rely on value status
                                if (isEmptyVal()) {
                                    deactivate();
                                } else {
                                    activate();
                                }
                            }
                        }
                        
                    });
                } else {
                    attrs.$observe('disabled', (newVal) => {
                        if (newVal !== undefined && newVal !== null && newVal !== false && newVal !== "false") {
                            // When disabled, force active styles
                            activate();
                        } else {
                            // When enabled, rely on value status
                            if (isEmptyVal()) {
                                deactivate();
                            }
                        }
                    });
                }

                if (ngModel) {
                    return ngModel.$formatters.push((value) => {
                      if (isEmpty(value)) {
                        deactivate();
                      } else {
                        activate();
                      }

                      return value;
                    });
                } else if (!isEmpty()) {
                    return activate();
                }
            }
        };
    }
})();

(function () {
    'use strict';

        scrollableTabs.$inject = ["$timeout", "$window"];
    angular
        .module('redcap')
        .directive('scrollableTabs', scrollableTabs);

        function scrollableTabs($timeout, $window) {
            return {
                restrict: 'EA',
                scope: {
                    selectedItem: '&',
                    scrollClicked: '&'
                },
                link: function (scope, element, attributes) {
                    element.addClass('scrollable-tabs-container');

                    let parentElement = document.getElementById(element[0].id);
                    let ulElement;
                    let leftArrow = null;
                    let rightArrow = null;
                    let angularList;
                    let angularWindow;
                    let scrollAmount = 300; // default px to scroll
                    let cnt = 0;
                    
                    function getBaseElement () {
                        ulElement = parentElement.querySelector('ul');

                        if (ulElement && ulElement.parentNode) {
                            initScrollTabs();
                        } else {
                            if (cnt < 100) {
                                cnt++;
                                $timeout(() => {
                                    getBaseElement();
                                }, 100);
                            } else {
                                console.log('did not find parent node');
                            }
                        }
                    }

                    
                    getBaseElement();
                    

                    function initScrollTabs () {
                        angularList = angular.element(ulElement);
                        angularWindow = angular.element($window);
                        
                        
                        if (attributes.scrollAmount) {
                            scrollAmount = attributes.scrollAmount;
                        }
                    
                        if (ulElement) {
                            //el.parentNode.insertBefore(pad, el);
                            // create left arrow (ulElement);
                            leftArrow = $(document.createElement('div'));
                            leftArrow.attr('class', 'left-arrow material-icons md-28');
                            leftArrow.append(document.createTextNode('chevron_left'));
                            ulElement.parentNode.insertBefore(leftArrow.get(0), ulElement);

                            // create right arrow (ulElement);
                            rightArrow = $(document.createElement('div'));
                            rightArrow.attr('class', 'right-arrow material-icons md-28');
                            rightArrow.append(document.createTextNode('chevron_right'));

                            try {
                                parentElement.insertBefore(rightArrow.get(0), ulElement.nextSibling);
                            } catch (ex) {
                                if (ulElement.nextSibling.parentNode) {
                                    ulElement.nextSibling.parentNode.insertBefore(rightArrow.get(0), ulElement.nextSibling);
                                }
                            }
                            

                            // gives the list time to finish it's initial draw
                            $timeout(() => {
                                manageArrowIcons();
                            }, 250);

                            rightArrow[0].addEventListener('click', scrollTabsRight);
                            leftArrow[0].addEventListener('click', scrollTabsLeft);
                            angularList.on('scroll', debounce(manageArrowIcons, 10));
                            angularWindow.on('resize', debounce(manageArrowIcons, 50));
                            
                        }
                    }

                    // returns a fn that will trigger 'time' amount after it stops getting called.
                    function debounce(fn, time) {
                        let timeout;

                        // every time this returned fn is called, it clears and re-sets the timeout
                        return function() {
                            let context = this;
                            // set args so we can access it inside of inner function
                            let args = arguments;

                            let later = function() {
                                timeout = null;
                                fn.apply(context, args);
                            };

                            $timeout.cancel(timeout);
                            timeout = $timeout(later, time);
                        };
                    }
                    
                    function manageArrowIcons() {
                        let scrollpos = Math.ceil(ulElement.scrollLeft);

                        if (scrollpos >= 20) {
                            leftArrow[0].classList.add("active");
                        } else {
                            leftArrow[0].classList.remove("active");
                        }

                        let maxScrollValue = ulElement.scrollWidth - ulElement.clientWidth;
                         
                        if (scrollpos >= maxScrollValue) {
                            rightArrow[0].classList.remove("active");
                        } else {
                            rightArrow[0].classList.add("active");
                        }
                    }

                    
                    function scrollTabsLeft() {
                        ulElement.scrollLeft = Math.ceil(ulElement.scrollLeft) - parseInt(scrollAmount);

                        if (scope.scrollClicked) {
                            scope.scrollClicked();
                        }
                    }

                    function scrollTabsRight() {
                        ulElement.scrollLeft = Math.ceil(ulElement.scrollLeft) + parseInt(scrollAmount);

                        if (scope.scrollClicked) {
                            scope.scrollClicked();
                        }
                    }

                    function cleanUp() {
                        angularWindow.off('resize', debounce(manageArrowIcons, 50));
                        angularList.off('scroll', debounce(manageArrowIcons, 10));
                        rightArrow[0].removeEventListener('click', scrollTabsRight);
                        leftArrow[0].removeEventListener('click', scrollTabsLeft);
                    }
                    

                    /*
                     * The id for the selected item should be used for the li item id 
                     * in the format tab_{{id}}
                     */
                    scope.$watch(scope.selectedItem, (newValue, oldValue) => {
                        if (!newValue) return;
                        let tabEl = document.getElementById("tab_" + newValue);

                        if (tabEl) {
                            tabEl.scrollIntoView();
                        }
                    }, true); 

                    scope.$on('$destroy', cleanUp);
                }

            };
        }

})();
(function() {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('resizer', ['$window', '$interval', '$rootScope', function ($window, $interval, $rootScope) {
            let direction = {
                    vertical: 'vertical',
                    horizontal: 'horizontal'
            };

            return {
                link: link,
                restrict: 'E',
                template: '<div id="resizer" class="resizer-bar" ng-class="[direction, classes]" title="{{toggleTitle}}" ng-click="resize()">' +
                    '</div>',
                replace: true,
                scope: {
                    vlines: '@',
                    direction: '@',
                    attachElementId: '@',
                    dependentElementId: '@',
                    classes: '@',
                    collapse: '@',
                    xoffset: '@',
                    yoffset: '@',
                    framedIn: '@',
                    callback: '&?'
                }
            };

            function link(scope, element, attrs) {
                let intervalCheck = null;
                let buffer = 15;
                let isDisplayed = true;
                let collapse = scope.collapse || true;
                let lines = scope.vlines === "true" || false;

                if (lines) {
                    element.addClass('vertical-lines');
                }

                scope.toggleTitle = (collapse == isDisplayed) ? 'collapse' : 'expand';

                scope.resize = function() {
                    isDisplayed = !isDisplayed;

                    if (scope.callback !== undefined) {
                        scope.callback({maximize: !isDisplayed});

                        if (isDisplayed) {
                            element.removeClass('collapsed');
                        } else {
                            element.addClass('collapsed');  
                        }                      
                    } else if (!isDisplayed) {  // collapse it
                        angular.element('#' + scope.attachElementId).addClass('hidden');
                        angular.element('#' + scope.dependentElementId).addClass('col-sm-12').addClass('col-md-12').addClass('col-lg-12').addClass('col-xl-12');
                        element.addClass("collapsed");
                    } else {
                        angular.element('#' + scope.attachElementId).removeClass('hidden');
                        angular.element('#' + scope.dependentElementId).removeClass('col-sm-12').removeClass('col-md-12').removeClass('col-lg-12').removeClass('col-xl-12');
                        element.removeClass("collapsed");
                    }

                    scope.toggleTitle = (collapse == isDisplayed) ? 'collapse' : 'expand';
                };

                function onResize() {
                    let element = angular.element('#resizer');

                    if (scope.direction === direction.vertical) {
                        
                        element.css('left', (getAttachElementMargin(scope.direction) + getAttachElementSize(scope.direction)) / 2);
                        let offset = buffer;

                        if (scope.framedIn === '1') {
                            offset = offset - 50;
                        }

                        if (scope.yoffset) {
                            offset = offset + parseInt(scope.yoffset);
                        }

                        element.css('top', getAttachElementSize(direction.horizontal) + offset);
                        
                    } else {
                        if (isDisplayed) {
                            let topDisplayed = (getAttachElementMargin(scope.direction) + getAttachElementSize(scope.direction)) / 2;

                            if (scope.verticalOffset) {
                                topDisplayed = topDisplayed + parseInt(scope.verticalOffset);
                            }

                            if (scope.yoffset) {
                                topDisplayed = topDisplayed + parseInt(scope.yoffset);
                            }

                            element.css('top', topDisplayed);
                            element.css('left', getAttachElementSize(direction.vertical) + buffer);
                            element.css('margin-left',  (scope.xoffset || 0) + 'px');
                        } else {
                            let top = (getDependentElementMargin(scope.direction) + getDependentElementSize(scope.direction)) / 2;

                            if (scope.verticalOffset) {
                                top = top + parseInt(scope.verticalOffset);
                            }

                            if (scope.yoffset) {
                                top = top + parseInt(scope.yoffset);
                            }

                            element.css('top', top);
                            element.css('left', element.width() / 2);
                            element.css('margin-left',  0 + 'px');
                        }                            
                    }
                }

                function getAttachElementSize(_direction) {
                    let element = angular.element('#' + scope.attachElementId);

                    return (_direction === direction.vertical ? element.width() : element.height()) + getAttachElementPadding(_direction);
                }

                function getAttachElementMargin(_direction) {
                    let element = angular.element('#' + scope.attachElementId);

                    return _direction === direction.vertical ? parseInt(element.css('marginLeft')) : parseInt(element.css('marginTop'));
                }

                function getAttachElementPadding(_direction) {
                    let element = angular.element('#' + scope.attachElementId);

                    return _direction === direction.vertical
                            ? parseInt(element.css('padding-left')) + parseInt(element.css('padding-right'))
                            : parseInt(element.css('padding-top')) + parseInt(element.css('padding-bottom'));
                }

                function getDependentElementSize(_direction) {
                    let element = angular.element('#' + scope.dependentElementId);

                    return (_direction === direction.vertical ? element.width() : element.height()) + getDependentElementPadding(_direction);
                }

                function getDependentElementMargin(_direction) {
                    let element = angular.element('#' + scope.attachElementId);

                    return _direction === direction.vertical ? parseInt(element.css('marginLeft')) : parseInt(element.css('marginTop'));
                }

                function getDependentElementPadding(_direction) {
                    let element = angular.element('#' + scope.dependentElementId);

                    return _direction === direction.vertical
                            ? parseInt(element.css('padding-left')) + parseInt(element.css('padding-right'))
                            : parseInt(element.css('padding-top')) + parseInt(element.css('padding-bottom'));
                }

                function cleanUp() {
                    if (angular.isDefined(intervalCheck)) {
                        $interval.cancel(intervalCheck);
                    }

                    angular.element($window).off('resize', onResize);
                }

                intervalCheck = $interval(onResize, 500, false);
                angular.element($window).on('resize', (evt, params) => {
                    onResize();
                });

                $rootScope.$on('respositionResizer', (evt, params) => {
                    scope.verticalOffset = params.verticalOffset;
                    onResize();
                });

                scope.$on('$destroy', cleanUp);
            }
        }
    ]);
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('redcapSort', redcapSort);

    redcapSort.$inject = ['$timeout'];

    function redcapSort($timeout) {
        function getModelValue(defaultObject, attrs, itemName) {
            let attrStr = attrs[itemName];
            let attrModelParts = attrStr && attrStr.length && attrStr.split('.') || [];
            let attrModel = defaultObject;

            for (let i = 0; i < attrModelParts.length; i++) {
                attrModel = attrModel[attrModelParts[i]];
            }

            return attrModel;
        }

        function getDebounceDelay(scope, attrs) {
            let options = attrs.ngModelOptions && scope.$eval(attrs.ngModelOptions);

            return parseInt(attrs.redcapSortDebounce, 10) || options?.debounce || 0;
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {                
                let columns = [];
                let loading = false;
                let pendingSort = null;
                let ele = angular.element(element[0]);
                let attrEnabled = attrs['redcapSortEnabled'] || 'true';
                let attrModel = getModelValue(scope, attrs, 'redcapSortModel');
                let callback = getModelValue(scope, attrs, 'redcapSortCallback');
                let debounceDelay = getDebounceDelay(scope, attrs);

                if (attrEnabled === 'false') {
                    return;
                }

                if (typeof attrModel !== 'object') {
                    attrModel = {};
                }

                if (typeof callback !== 'function') {
                    callback = null;
                }

                columns = ele.find('thead').find('th');

                function onClickFn(evt, directionOverride) {
                    if (loading) {
                        return;
                    }

                    loading = true;

                    let col = angular.element(evt.target);
                    
                    // is this a material icon in the header?  if so we need to get the parent 
                    if (col[0].className.indexOf('sortable-header-icon') > -1) {
                        col = angular.element(col[0].parentElement);
                    }

                    columns.removeClass('active');
                    columns.removeClass('sort-asc');
                    columns.removeClass('sort-desc');

                    let sortField = col.attr('sort-column') || col.text();

                    if (attrModel.sortBy === sortField) {
                        if (attrModel.sortDirection === 'desc') {
                            attrModel.sortDirection = 'asc';
                        } else {
                            attrModel.sortDirection = 'desc';
                        }
                    } else {
                        attrModel.sortDirection = 'asc';
                    }

                    if (directionOverride) {
                        attrModel.sortDirection = directionOverride;
                    }

                    attrModel.sortBy = sortField;
                    col.addClass('active');
                    col.addClass('sort-' + attrModel.sortDirection);

                    if (!callback) {
                        return;
                    }

                    if (pendingSort) {
                        $timeout.cancel(pendingSort);
                        pendingSort = null;
                    }

                    pendingSort = $timeout(() => {
                        pendingSort = null;
                        loading = true;
                        let result = callback(attrModel.sortBy, attrModel.sortDirection);

                        if (result?.finally) {
                            result.finally(() => {
                                loading = false;
                            });
                        }
                    }, debounceDelay);
                }

                for (let i = 0; i < columns.length; i++) {

                    let column = angular.element(columns[i]);

                    if (column.attr('ignore-sort') !== undefined) {
                        column.addClass('ignore-sort');
                        columns.splice(i, 1);
                        i--;
                    }

                    let colText = column.attr('sort-column') || column.text();

                    if (attrModel.sortBy === colText) {
                        onClickFn({target: column}, attrModel.sortDirection);
                    }
                }

                columns.on('click', onClickFn);
                columns.addClass('sortable');

                scope.$on('$destroy', () => {
                    if (pendingSort) {
                        $timeout.cancel(pendingSort);
                    }

                    columns.off('click', onClickFn);
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('rangeDisplay', RangeDisplayDirective);

    function RangeDisplayDirective() {
        return {
            restrict: 'E',
            templateUrl: 'app/shared/directives/templates/range-display.html',
            link: function(scope, element, attrs) {
                var value = attrs['value'],
                    fuellevel = parseInt(attrs['fuellevel']);

                scope.fuellevel = fuellevel;
                var bar = element.find('.range-bar-value');
                bar.width(value + '%');
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('preventBubbling', preventBubbling);

    function preventBubbling() {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on('click', function (e) {
                    e.stopPropagation();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    prevalidateForm.$inject = ["ValidationService", "$timeout"];
    angular
        .module('redcap.directives')
        .directive('prevalidateForm', prevalidateForm);

    function prevalidateForm(ValidationService, $timeout) {
        return {
            restrict: 'A',
            require: '^form',
            link: function (scope, element, attrs, formCtrl) {
                
                scope.preValidateTimeout && $timeout.cancel(scope.preValidateTimeout);
                
                // We delay the the execution of the validation to allow the DOM to finish
                //  rendering.  This allows the checkFormValidity function to execute properly. 
                scope.preValidateTimeout = $timeout(function() {
                    var vs = new ValidationService();                
                    vs.checkFormValidity(formCtrl);
                    formCtrl.$setPristine(true);
                }, 50);                  
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('phoneTypeIndicator', PhoneTypeIndicatorDirective);

    function PhoneTypeIndicatorDirective() {
        return {
            restrict: 'E',
            scope: {
                phoneNumber: '='
            },
            templateUrl: "app/shared/directives/templates/phone-type-indicator.html",
            bindToController: true,
            controllerAs: 'vm',
            controller: ["$scope", "$timeout", "SYSTEM_ENUMS", "messagesService", function($scope, $timeout, SYSTEM_ENUMS, messagesService) {
                this.$onInit = function() {
                    let vm = this;

                    vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;
                    vm.isPopoverOpen = false;

                    $scope.$watch('vm.phoneNumber', (newValue, oldValue) => {
                            if (newValue && newValue.length === 10) {
                                messagesService.checkPhoneNumberType(newValue)
                                    .then((response) => {
                                        vm.phoneNumber = response.phoneNumber,
                                        vm.phoneNumberType = response.type;
                                    });

                                if (newValue !== oldValue) {
                                    vm.isPopoverOpen = true;
                                    $timeout(() => {
                                            vm.isPopoverOpen = false;
                                        }, 2000);
                                }
                            } else {
                                vm.phoneNumberType = vm.phoneTypes.unknown;
                            }

                        });
                };
            }]
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('phoneDetailIndicator', PhoneDetailIndicatorDirective);

    function PhoneDetailIndicatorDirective() {
        return {
            restrict: 'E',
            scope: {
                detail: '='
            },
            templateUrl: "app/shared/directives/templates/phone-detail-indicator.html",
            bindToController: true,
            controllerAs: 'vm',
            controller: ["$scope", "$timeout", "SYSTEM_ENUMS", function($scope, $timeout, SYSTEM_ENUMS) {
                this.$onInit = function() {
                    var vm = this;

                    vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;

                    vm.isPopoverOpen = false;

                    $scope.$watch(function() { return '' + vm.detail.type + vm.detail.isOptedOut; },
                        function() {
                            vm.isPopoverOpen = true;
                            $timeout(function() {
                                    vm.isPopoverOpen = false;
                                },
                                2000);
                        });
                };
            }]
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('ngSubmit', ngSubmit);

    function ngSubmit() {
        return {
            require: '?form',
            priority: 10,
            link: {
                pre: function (scope, elem, attrs, form) {
                    elem.on('submit', function(event) {
                        form.$isSubmitted = true;
                    });
                }
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('redcap.directives')
        .directive('ngOptionsTitle', ['$timeout', '$compile', '$interval', ngOptionsTitle]);
    function ngOptionsTitle($timeout, $compile, $interval) {
        return {
            restrict: 'A',
            priority: 1000,
            scope: {
                ngOptionsTitle: '<',
                ngOptionsPlaceholder: '<?',
                id: '@'
            },
            link: function($scope, element, attr) {
                var locationElem = $('<div class="chosen-option-hover"></div>'),
                    clickElem,
                    inputElem,
                    waitInterval;
                var changeToolTipLoc = function (event) {
                    var targetElem = $(event.target),
                        pos = targetElem.offset(),
                        holder = clickElem.parent().offset(),
                        tooltipX = pos.left - holder.left + targetElem.width() + 50,
                        tooltipY = pos.top - holder.top + (targetElem.height() / 2) - 48;
                    locationElem.css({top: tooltipY, left: tooltipX});
                    // $timeout(function () { debugger; }, 500);    // uncomment to style
                };
                var showTooltip = function(event) {
                    hideTooltip();
                    var target = $(event.target),
                        html = target.attr('data-title');
                    if (html && html.length > 0) {
                        locationElem.html(html);
                        clickElem.parent().append(locationElem);
                        changeToolTipLoc(event);
                    }
                };
                var hideTooltip = function () {
                    $('div.chosen-option-hover').remove();
                };
                $timeout(function () {
                    $(element).find('option').each(function (index, elem) {
                        elem = $(elem);
                        if (index - ($scope.ngOptionsPlaceholder || 0) > -1) {
                            var object = $scope.ngOptionsTitle[index - $scope.ngOptionsPlaceholder],
                                 text = '<b>RC:</b> ' + object.id + '<br />';

                            if (object.oemDealerId) {
                              text = text  + '<b>OEM:</b> ' + (object.oemDealerId || '') + '<br />';
                            }

                            if (object.adminProgramName) {
                              text = text  + '<b>PRG:</b> ' + object.adminProgramName + '<br />';
                            }

                            if (object.statusText) {
                              text = text  + '<b>STATUS:</b> ' + object.statusText + '<br />';
                            }

                            if (object.address) {
                              text = text  + '<b>ADDR:</b><br/>' + object.address + '<br />' + object.city + ', ' + object.state;
                            }
                            
                            elem.addClass('display-title-tooltip');
                            elem.attr('title', text);
                            $compile(elem)($scope);
                        }
                    });
                });
                var ngOptionsGenerated = false;
                function fixChildOptions() {
                    var children = clickElem.find('li');
                            children.each(function (item, elem) {
                                elem = $(elem);
                                elem.attr('data-title', elem.attr('title'));
                                elem.removeAttr('title');
                            });
                            children.on('mousemove', changeToolTipLoc)
                                    .on('mouseenter', showTooltip)
                                    .on('mouseleave', hideTooltip);
                }
                waitInterval = $interval(function () {
                    if (ngOptionsGenerated && angular.isDefined(waitInterval)) {
                        $interval.cancel(waitInterval);
                        waitInterval = undefined;
                    }
                    clickElem = angular.element(document.querySelector('div#' + $scope.id + '_chosen'));
                    inputElem = angular.element(document.querySelector('.chosen-search-input'), clickElem);
                    if (clickElem.length > 0) {
                        ngOptionsGenerated = true;
                        clickElem.on('click', function () {
                            fixChildOptions(clickElem);
                        });
                        clickElem.on("keyup", function () {
                            fixChildOptions(clickElem);
                        });
                    }
                }, 500);
                element.on('destroy', function () {
                    if (angular.isDefined(waitInterval)) {
                        $interval.cancel(waitInterval);
                        waitInterval = undefined;
                    }
                });
            }
        };
    }
})();
(function() {
    'use strict';
    
    angular
        .module('redcap.directives')
        .directive('minimizeNavTitles', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
            return {
                link: link,
                restrict: 'A'
            };

            function link (scope, element, attrs) {
                var $nav        = element,
                    $vlinks     = angular.element('nav .visible-links'),
                    $navheader  = angular.element('nav .navbar-header'),
                    $navtitles  = element.find('span.nav-title'),
                    $profile    = angular.element('nav .profile-menu'),
                    $mobile     = angular.element('nav.mobile-tablet-navbar-fixed');

                function updateNav() {
                    if ($mobile.width() > 0) return;
                    
                    // unhide everything so you can calculate with width necessary
                    angular.forEach($navtitles, function (element) {
                        angular.element(element).removeClass('hidden');
                    });

                    var navspace =  element.width() - parseInt($nav.css('padding-left')) 
                                                   - parseInt($nav.css('padding-right')) 
                                                   - $profile.width()
                                                   - $navheader.width()
                                                   - 100;                                  // 100 is a buffer for overflow

                    var vlinksWidth = $vlinks.width();

                    // The visible list is overflowing the nav
                    if(vlinksWidth > navspace) {
                        angular.forEach($navtitles, function (element) {
                            angular.element(element).addClass('hidden');
                        });
                    }
                }
                  
                // Window listeners
                $(window).resize(function() {
                    updateNav();
                });
                  
                $rootScope.$on('unread-count.updated', function() {
                    updateNav();
                });

                $timeout(updateNav, 1000);
            }
        }
    ]);
})();
// this directive should be used in conjunction with afkl-lazy-load

(function () {
    'use strict';

     lazyLoadFail.$inject = ["$parse"];
    angular
        .module('redcap.directives')
        .directive('lazyLoadFail', lazyLoadFail);
     
    function lazyLoadFail($parse){
        return {
            restrict: 'A',
            scope: {
                lazyLoadFail: '@'
            },
            link: function(scope, element, attrs) {
                return attrs.$observe("afklLazyImageLoaded", function (value) {                    
                    if (value === 'fail') {
                        var imgElem = element.find('img');

                        if (imgElem && imgElem.attr('src')) {
                            imgElem.attr('src', scope.lazyLoadFail);
                        } else {
                            var lazyOptions = attrs.afklLazyImageOptions ? $parse(attrs.afklLazyImageOptions)(scope) : {};
                        
                            if (lazyOptions.background) {
                                element[0].style.backgroundImage = "url('" + scope.lazyLoadFail + "')";
                            }                            
                        }
                    }

                    if (!value)
                        element.removeClass('spinner').removeClass('spinner-absolute');
                });
            }         
        };
     }        
})();
(function() {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('inputvalidationPhoneTypeIndicator', InputValidationPhoneTypeIndicatorDirective);

    function InputValidationPhoneTypeIndicatorDirective() {
        return {
            restrict: 'E',
            scope: {
                phoneNumber: '=',
                appointment: '='
            },
            templateUrl: "app/shared/directives/templates/inputvalidation-phone-type-indicator.html",
            bindToController: true,
            controllerAs: 'vm',
            controller: ["$scope", "$q", "$timeout", "SYSTEM_ENUMS", "messagesService", function($scope, $q, $timeout, SYSTEM_ENUMS, messagesService) {
                this.$onInit = function() {
                    var vm = this;

                    vm.phoneTypes = SYSTEM_ENUMS.phoneTypes;

                    $scope.$watch('vm.phoneNumber',
                        function(newValue, oldValue) {
                            if (newValue && newValue.length === 10) {
                                messagesService.checkPhoneNumberType(newValue)
                                    .then(function(response) {
                                        vm.phoneNumber = response.phoneNumber,
                                            vm.phoneNumberType = response.type;
                                        if (vm.appointment) {
                                            vm.appointment.invalidPhone = false;
                                        }
                                    });
                            } else {
                                vm.phoneNumberType = vm.phoneTypes.unknown;
                                if (vm.appointment) {
                                    vm.appointment.invalidPhone = true;
                                }
                            }

                        });
                };
            }]
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('injectScript', injectScript);

    function injectScript() {
        
        let updateScripts = function (element) {
            return function (scripts) {
                element.empty();
                angular.forEach(scripts.split(', '),  (source, key) => {
                    let scriptTag = angular.element(document.createElement('script'));

                    source = '//@ sourceURL=' + key + '\n' + source;
                    scriptTag.text(source);
                    element.append(scriptTag);
                });
            };
        };

        return {
            restrict: 'E',
            scope: {
                scripts: '@?'
            },
            link: function (scope, element, attrs) {
                if (scope.scripts) {
                    scope.$watch('scripts', updateScripts(element));
                } else {
                    let signalRScriptTag = document.createElement('script');

                    signalRScriptTag.setAttribute('src', 'https://cdn.jsdelivr.net/npm/signalr@2.4.1/jquery.signalR.js');
                    element.append(signalRScriptTag);
                }
            }
        };

    }
})();

(function() {
    'user strict';

    angular
        .module('redcap.directives')
        .directive('infiniteScrollTop', infiniteScrollTopDirective);

    function infiniteScrollTopDirective() {
        var directive = {
            restrict: 'A',
            scope: {
                infiniteScrollTop: '&',
                infiniteScrollTopDisabled: '='
            },
            link: link
        };

        function link(scope, element, attrs) {
            element.on('scroll', _.debounce(function() {
                var scrollTop = element[0].scrollTop;
                
                if(scrollTop < 10 && !scope.infiniteScrollTopDisabled) {
                    scope.infiniteScrollTop();
                }

            }, 500));
        }

        return directive;
    }
})();
(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('iframeOnload', iframeOnload);

    function iframeOnload() {
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function (scope, element, attrs) {
                element.on('load', function () {
                    return scope.callBack();
                });
            }
        };
    }
})();
(function() {
    'use strict';
    
    angular
        .module('redcap.directives')
        .directive('iboxTitle', ['$window', '$interval', function ($window, $interval) {
            return {
                link: link,
                restrict: 'C',
                scope: {
                    resizeClass: '@?',      // this is the class of the element that will be shifted. Marked as option, but is required for the directive to work
                    noPadding: '&?',
                    resizeMargin: '&?'
                }
            };
    
            function link(scope, element, attrs) {
                if (_.isNil(scope.resizeClass))
                    return;

                var basePadding = scope.noPadding ? 0 : 10;
                var resizeType = scope.resizeMargin ? 'margin' : 'padding';
                var intervalCheck = null;
                
                function onResize(){
                    var newHeight = getElementHeight();
                    var currentPadding = currentIboxPaddingTop() - basePadding;
                    
                    if (!_.isNaN(newHeight) && newHeight != currentPadding || newHeight == 0)
                        angular.element('.' + scope.resizeClass).css(resizeType + '-top', newHeight + basePadding);
                }
    
                function cleanUp() {
                    if (angular.isDefined(intervalCheck)) {
                        $interval.cancel(intervalCheck);
                    }
                    angular.element($window).off('resize', onResize);
                }

                function getElementHeight() {
                    return element.height() + 
                           parseInt(element.css('padding-top').replace('px', '')) +
                           parseInt(element.css('padding-bottom').replace('px', ''));
                }

                function currentIboxPaddingTop() {
                    if (angular.element('.' + scope.resizeClass).css('padding-top'))
                        return angular.element('.' + scope.resizeClass).css('padding-top').replace('px', '');
                    
                    return 0;
                }
    
                intervalCheck = $interval(onResize, 500, false);
                angular.element($window).on('resize', onResize);
                scope.$on('$destroy', cleanUp);
            }
        }
    ]);
})();
(function () {
    'use strict';

    taskCircles.$inject = ["$timeout"];
    angular
        .module('redcap.directives')
        .directive('taskCircles', taskCircles);

    function taskCircles($timeout) {
        return {
            restrict: 'E',
            template: '<div class="homework-task-list margin-top-30">' +
                    '<div class="row margin-bottom-20" ng-repeat="item in tasks track by $index" ng-if="!item.hide">' +
                        '<div class="col-xs-1">' +
                            '<span class="circle-text">{{$index + 1}}</span>' +
                        '</div>' +
                        '<div class="col-xs-10 padding-top-sm margin-left-20"><strong>{{ item.text }}</strong></div>' +
                    '</div>' +
                '</div>',
            replace: true,
            scope: {
                tasks: '<'
            }
            // link: init
        };

        function init(scope, element) {
            
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('herePlaces',
            ["$log", "hereMapsService", "locationService", "modalService", "permissions", ($log, hereMapsService, locationService, modalService, permissions) => {
                return {
                    require: 'ngModel',
                    scope: {
                        ngModel: '=',
                        options: '=?',
                        handleSelected: '&',
                        details: '=',
                        mapFields: '=',
                        latitude: '=',
                        longitude: '=',
                        allowCreateNew: '='
                    },
                    link: function (scope, element, attrs, model) {
                        if (!scope.options) {
                            scope.options = {
                                types: ['establishment', 'geocode']
                            };
                        }

                        let items = [];
                        let isResultsListVisible = false;
                        let createNewId = 'create-new';
                        let minimumRequiredChars = 3;
                        let resultsEl = document.getElementById('places-results');
                        let $resultsEl = null;

                        if (!resultsEl || !resultsEl.length) {
                            resultsEl = document.createElement('ul');
                            resultsEl.className = 'places-results';
                            resultsEl.id = 'places-results';

                            toggleResultsVisibility(false);

                            element.attr('autocomplete', 'off');
                            element.after(resultsEl);

                            $resultsEl = angular.element(resultsEl);
                        }

                        // Handle keyboard navigation of results list
                        element.on('keyup', (e) => {
                            if (isResultsListVisible) {
                                if (e.which === 40 || e.which === 38) { // down (40) or up (38)
                                    let activeItem = $resultsEl.find('li.active');

                                    if (activeItem.length) {
                                        let newItem = e.which === 38 ? activeItem.prev() : activeItem.next();

                                        if (newItem.length) {
                                            activeItem.removeClass('active');
                                            newItem.focus().addClass('active');
                                        }
                                    } else {
                                        $resultsEl.find('li:first').focus().addClass('active');
                                    }

                                    return;
                                }

                                if (enterPressed(e)) {
                                    let activeItm = $resultsEl.find('li.active');

                                    if (activeItm.length) {
                                        selectItem(activeItm.attr('id'));
                                    }

                                    e.preventDefault();
                                }
                            }

                            if (!element.val().length) {
                                toggleResultsVisibility(false);
                            }
                        });

                        element.on('input', (e) => {
                            if (enterPressed(e)) {
                                e.preventDefault();

                                return;
                            }
                        });

                        element.on('keydown', (e) => {
                            if (enterPressed(e)) {
                                e.preventDefault();

                                return;
                            }
                        });

                        // Handle actual place search, with a slight delay to prevent hitting the HERE api with every keypress.
                        element.on('input focus', _.debounce((e) => {
                            if (enterPressed(e)) {
                                return;
                            }

                            let searchTerm = element.val() || '';

                            // Prevent place prediction search if the user hasn't entered the minimum number of characters.
                            if (searchTerm.length < minimumRequiredChars) {
                                if (searchTerm.length > 0) {
                                    resultsEl.innerHTML = '<li>Please enter at least 3 characters to search.</li>';
                                    toggleResultsVisibility(true);
                                }
                                
                                return;
                            }

                            hereMapsService.getPlacePredictions(searchTerm, scope.options.startLat, scope.options.startLng).then((results) => {
                                items = results;

                                if (scope.allowCreateNew && (permissions.isSysAdmin() || permissions.isRedCapAdmin() || permissions.isDealerAdmin())) {
                                    items = items || [];
                                    items.push({id: createNewId, title: 'Can\'t find? Create new...', highlightedVicinity: ''});
                                }

                                let html = results.length ? '' : '<li>No results could be found, please refine your search.</li>';

                                _.forEach(items, (r) => {   
                                    let formattedTitle = _.get(r, 'address.label');

                                    if (formattedTitle) {
                                        let highlights = _.get(r, 'highlights.address.label[0]');

                                        if (highlights) {
                                            formattedTitle = formattedTitle.slice(0, highlights.start) + '<strong>' + formattedTitle.slice(highlights.start, highlights.end) + '</strong>' + formattedTitle.slice(highlights.end);
                                        }

                                        html += '<li id="' + r.id + '">' + formattedTitle.replace('<br/>', ' ') + '</li>';
                                    } else if (r.id === createNewId) {
                                        html += '<li id="' + r.id + '">' + r.title + '</li>';
                                    }
                                });

                                resultsEl.innerHTML = html;
                                toggleResultsVisibility(true);

                                $resultsEl.off('click', 'li');
                                $resultsEl.on('click', 'li', (el) => {
                                    let elementId = el.toElement ? el.toElement.id : el.target.id;

                                    selectItem(elementId);
                                });
                            });
                        }, 400));

                        function selectItem(itemId) {
                            let selectedItem = _.find(items, (item) => { return item.id === itemId; });

                            if (selectedItem) {
                                if (selectedItem.id === createNewId) {
                                    toggleResultsVisibility(false);
                                    modalService.showAddAddressModal(element.val()).then((address) => {
                                        let formattedAddress = hereMapsService.formatLocation(address, null);

                                        processAddress(formattedAddress);
                                    });                                    
                                } else {
                                    hereMapsService.getPlaceDetails(selectedItem.id).then((placeDetails) => {
                                        processAddress(placeDetails);
                                    });
                                }
                            }
                        }

                        function processAddress(placeDetails) {
                            let formattedAddress = {location: placeDetails, name: placeDetails.name};

                            scope.details = formattedAddress;

                            if (scope.mapFields) {
                                mapFields(formattedAddress, scope.mapFields);
                            }
                            
                            if ('fetchTwilioNumbers' in attrs) {
                                setTwilioValues(formattedAddress, scope);
                            }

                            scope.handleSelected({formattedAddress: formattedAddress});
                            model.$setViewValue(formattedAddress.location.formattedAddress);
                            element.val(formattedAddress.location.formattedAddress);
                            toggleResultsVisibility(false);
                        }

                        function enterPressed(e) {
                            return e.which === 13 || e.keyCode === 13;
                        }

                        function outsideClickListener(event) {
                            if (!resultsEl.contains(event.target) && isResultsListVisible) {
                                toggleResultsVisibility(false);
                            }
                        }

                        function toggleResultsVisibility(isVisible) {
                            let visible = isVisible ? 'block' : 'none';

                            resultsEl.setAttribute('style', 'display: ' + visible);
                            isResultsListVisible = isVisible;

                            if (isVisible) {
                                resultsEl.style.width = element[0].offsetWidth + 'px';
                                document.addEventListener('click', outsideClickListener);
                            } else
                                document.removeEventListener('click', outsideClickListener);
                        }
                    }
                };

                function mapFields(address, map) {
                    /*  map the fields based on this format
                    *   {
                    *       fieldToSet: 'fieldFromFormattedAddress',
                    *       altPhone: 'phone',
                    *       customAddress: 'location.streetAddress'
                    *   }
                    */
                    for (let field in map) {
                        //if is complex object do the mapping
                        if (Object.prototype.hasOwnProperty.call(map, field)) {
                            let array = map[field].split(".");
                            let temp = address[array[0]];

                            for (let i = 1, len = array.length; i < len; i++) {
                                temp = temp[array[i]];
                            }

                            address[field] = temp;
                        }
                    }
                }

                function setTwilioValues(address, scope) {
                    scope.details = scope.details || {};

                    if (_.isNull(address.location.lat) || _.isNull(address.location.lng)) {
                        scope.details.twilioNumbers = [];
                    } else {
                        locationService.get800Number().then((twilioNumber) => {
                            scope.details.twilioNumber = twilioNumber;
                        });
                    }
                }
            }]);
})();

(function() {
    'use strict';

    hasPermission.$inject = ["permissions"];
    hasNoPermissionDisabled.$inject = ["permissions"];
    hasRole.$inject = ["permissions"];
    angular
        .module('redcap.directives')
        .directive('hasPermission', hasPermission)
        .directive('hasNoPermissionDisabled', hasNoPermissionDisabled)
        .directive('hasRole', hasRole);

    function hasPermission(permissions) {
        return {
            link: function(scope, element, attrs) {
                if (!_.isString(attrs.hasPermission)) {
                    throw 'hasPermission value must be a string';
                }

                var toggleVisibilityBasedOnPermissions = function() {
                    var canSee = attrs.userOnlyPermission ? permissions.hasUserPermission(attrs.hasPermission) : permissions.hasPermission(attrs.hasPermission, true);

                    if (canSee) {
                        element.show();
                    } else {
                        element.hide();
                    }
                };

                toggleVisibilityBasedOnPermissions();

                scope.$on('permissionsChanged', toggleVisibilityBasedOnPermissions);
            }
        };
    }

    function hasNoPermissionDisabled(permissions) {
        return {
            link: function(scope, element, attrs) {
                
                if (!_.isString(attrs.hasNoPermissionDisabled)) {
                    throw 'hasNoPermissionDisabled value must be a string';
                }

                var addDisabledStyleBasedOnPermissions = function() {
                    var hasPermission = attrs.userOnlyPermission ? permissions.hasUserPermission(attrs.hasNoPermissionDisabled) : permissions.hasPermission(attrs.hasNoPermissionDisabled);
                    if (!hasPermission) {
                        element.addClass('marketing');
                    } else {
                        element.removeClass('marketing');
                    }
                };

                addDisabledStyleBasedOnPermissions();

                scope.$on('permissionsChanged', addDisabledStyleBasedOnPermissions);
            }
        };
    }

    function hasRole(permissions) {
        return {
            link: function(scope, element, attrs) {
                if (!_.isString(attrs.hasRole)) {
                    throw 'hasPermission value must be a string';
                }

                var toggleVisibilityBasedOnRole = function() {
                    if (permissions.hasRole(attrs.hasRole)) {
                        element.show();
                    } else {
                        element.hide();
                    }
                };

                toggleVisibilityBasedOnRole();

                scope.$on('permissionsChanged', toggleVisibilityBasedOnRole);
            }
        };
    }

})();
(function () {
    'use strict';

    handleVideoEvents.$inject = ["$rootScope"];
    angular
        .module('redcap.directives')
        .directive('handleVideoEvents', handleVideoEvents);

    function handleVideoEvents($rootScope) {
        return function ($scope, $element) {
            $element[0].addEventListener('ended', function () {
                $rootScope.$broadcast('videoEnded');
            });

            $rootScope.$on('stopVideo', function() {
                $element[0].pause();
            });
        };
    }
})();
(function() {
    'use strict';

    FormatCurrencyDirective.$inject = ["$timeout"];
    FormatCurrencyWithDollarDirective.$inject = ["$timeout"];
    PercentageDirective.$inject = ["$timeout"];
    angular
        .module('redcap.directives')
        .directive('formatCurrency', FormatCurrencyDirective)
        .directive('formatCurrencyWithDollar', FormatCurrencyWithDollarDirective)
        .directive('percentage', PercentageDirective);

    function FormatCurrencyDirective($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 100,
            link: function($scope, element, attrs, ngModelController) {
                let input = element[0];

                element.on('blur', () => {
                    formatToCurrency();
                });

                // Format the initial value
                $timeout(() => {
                    formatToCurrency();
                });

                function formatToCurrency() {
                    let value = ngModelController.$modelValue;

                    if (value && !isNaN(parseFloat(value)) && isFinite(value)) {
                        let formatted = parseFloat(value).toString();

                        input.value = formatted;
                    }
                }
            }
        };
    }

    function FormatCurrencyWithDollarDirective($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 100,
            link: function($scope, element, attrs, ngModelController) {
                let input = element[0];

                ngModelController.$formatters.push((value) => {
                    if ((value === 0 || value) && !isNaN(parseFloat(value)) && isFinite(value)) {
                        return '$' + parseFloat(value).toFixed(2);
                    }

                    return value;
                });

                ngModelController.$parsers.push((value) => {
                    if (typeof value === 'string') {
                        return value.replace('$', '');
                    }

                    return value;
                });

                ngModelController.$parsers.push((inputValue) => {
                    if (inputValue === undefined) return '';
                    let transformedInput = inputValue.replace(/[^0-9.]/g, '');
                    
                    if (transformedInput !== inputValue) {
                        ngModelController.$setViewValue(transformedInput);
                        ngModelController.$render();
                    }                
                    
                    return transformedInput;
                });

                element.on('blur', () => {
                    let value = ngModelController.$modelValue;

                    if ((value === 0 || value) && !isNaN(parseFloat(value)) && isFinite(value)) {
                        input.value = '$' + parseFloat(value).toFixed(2);
                    }
                });

                element.on('focus', () => {
                    let value = ngModelController.$modelValue;

                    if (typeof value === 'string') {
                        input.value = value.replace('$', '');
                    }
                });

                $timeout(() => {
                    let value = ngModelController.$modelValue;

                    if ((value === 0 || value) && !isNaN(parseFloat(value)) && isFinite(value)) {
                        input.value = '$' + parseFloat(value).toFixed(2);
                    }
                });
            }
        };
    }

    function PercentageDirective($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelController) {
                let input = element[0];
                let precision = 2;

                if (attrs.precision) {
                    precision = parseInt(attrs.precision);
                }
    
                ngModelController.$parsers.push((inputValue) => {
                    if (inputValue === undefined) return '';
                    let transformedInput = inputValue.replace(/[^0-9.]/g, '');
                    
                    if (transformedInput !== inputValue) {
                        ngModelController.$setViewValue(transformedInput);
                        ngModelController.$render();
                    }                
                    
                    return transformedInput;
                });

                ngModelController.$formatters.push((value) => {
                    if ((value === 0 || value) && !isNaN(parseFloat(value)) && isFinite(value)) {
                        return parseFloat(value).toFixed(precision) + '%';
                    }

                    return value;
                });

                ngModelController.$parsers.push((value) => {
                    if (typeof value === 'string') {
                        return value.replace('%', '');
                    }

                    return value;
                });

                element.on('blur', () => {
                    let value = ngModelController.$modelValue;

                    if ((value === 0 || value) && !isNaN(parseFloat(value)) && isFinite(value)) {
                        input.value = parseFloat(value).toFixed(precision) + '%';
                    }
                });

                element.on('focus', () => {
                    let value = ngModelController.$modelValue;

                    if (typeof value === 'string') {
                        input.value = value.replace('%', '');
                    }
                });

                $timeout(() => {
                    let value = ngModelController.$modelValue;

                    if ((value === 0 || value) && !isNaN(parseFloat(value)) && isFinite(value)) {
                        input.value = parseFloat(value).toFixed(precision) + '%';
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

     fileInput.$inject = ["$log", "fileReaderService"];
    angular
        .module('redcap.directives')
        .directive('fileInput', fileInput);
     
        /* This directive is intended to be used wth ui-cropper. 
        --------------------------- USAGE ------------------------
        
        the variable used for file-input="variable" should be the 
        same as the "image" variable that the ui-croppers directive
        uses.

        example:
        <input type="file" file-input="vm.selectedImage">
        <ui-cropper image="vm.selectedImage" result-image="vm.croppedImage"></ui-cropper>

        */

     function fileInput($log, fileReaderService){
         return {
           restrict: 'A',
           scope: {
               fileInput: '='
           },
           link: function (scope, element, attrs) {
    
                var updateModel = function () {
                    var file = element[0].files[0];

                    if ((attrs.fileType || 'img') == 'img') {
                        scope.$apply(function () {
                            var file = element[0].files[0];

                            if (file) {
                                fileReaderService.readAsDataUrl(file, scope)
                                    .then(function(result) {
                                        // sets the variable set in file-input to the base64 encoded image
                                        scope.fileInput = result;
                                    });
                            } else {
                                scope.fileInput = '';
                            }
                        });

                    } else if (attrs.fileType == 'csv') {

                        scope.$apply(function() {
                            fileReaderService.readAsText(file, scope)
                                .then(function(result) {
                                    scope.fileInput = fileReaderService.csvToArray(result);
                                });
                        });

                    } else {
                        $log.debug('Unsupported file type: ' + scope.fileType);
                    }

                };

                // binds the change event to the input element for when a new file is selected                
                element.bind('change', updateModel);
            }
         };
     }        
})();
(function () {
    'use strict';

        fakeModal.$inject = ["$timeout", "$window"];
    angular
        .module('redcap')
        .directive('fakeModal', fakeModal);

        // note, this will take anything within a class of "modal-content" and display as a fake dialog
        function fakeModal($timeout, $window) {
            return {
                restrict: 'EA',
                scope: {
                    customClass: '<'
                },
                link: function (scope, element, attributes) {
                   
                    
                    // dynamically create two new div layers that
                    // are wrappers we need with modal dialog classes for proper styling
                    let modalFadeIn = $(document.createElement('div'));
                    let modalDlg = $(document.createElement('div'));
                    let dlgClass = 'modal-dialog';

                    element.addClass('modal-open');
                    modalFadeIn.attr('class', 'modal fade in fake-modal');

                    if (scope.customClass) {
                        dlgClass = "modal-dialog " + scope.customClass;
                    }

                    modalDlg.attr('class', dlgClass);
                    modalFadeIn.append(modalDlg);
                    element.append(modalFadeIn);

                    // get the 'modal-content' and append it to the two new layers
                    let parentElement = document.getElementById(element[0].id);
                    let modalContent = parentElement.querySelector('.modal-content');

                    modalDlg.append(modalContent);

                    // create the backdrop
                    let backdrop = $(document.createElement('div'));
                    
                    backdrop.attr('class', 'modal-backdrop fade in');
                    element.append(backdrop);

                    // we must move the parentEl to be the first item on the bodyEl
                    // this fixes zindexing issues w/ the modal background fade in and the site menu
                    let bodyEl = document.getElementsByTagName('body')[0];

                    bodyEl.append(parentElement);
                    
                }

            };
        }

})();
(function () {
    'use strict';

    expandableInput.$inject = ["$timeout"];
    angular
        .module('redcap.directives')
        .directive('expandableInput', expandableInput);

    function expandableInput($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                const input = element[0];
                let initialWidth = null;                

                element.on('focus', () => {
                    const leftPosition = input.offsetLeft;
                    
                    if (!initialWidth)
                        initialWidth = `${input.offsetWidth}px`;
                    
                    // Set the necessary styles to ensure the input stays in place when switched to being "absolutely" positioned.
                    input.style.minWidth = initialWidth;
                    input.style.width = initialWidth;
                    input.style.left = `${leftPosition}'px'`;

                    input.classList.add('focused');

                    // This feels hacky, but we have to stagger the application these styles to ensure the width is set before changing the 
                    //  position.  The "better-placeholder" class (which is on almost all of our inputs)  has a transition time of 500ms, so 
                    //  we allow that to complete before updating position.
                    $timeout(() => {
                        input.style.position = 'absolute';     
                        input.style.width = `calc(100% - ${leftPosition}px)`;
                    }, 500);
                });

                element.on('blur', () => {
                    input.style.width = initialWidth;                    

                    $timeout(() => {
                        input.style.position = 'inherit';
                        input.classList.remove('focused');
                    }, 500);
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('eventAlert', ['$timeout', eventAlert]);

    function eventAlert($timeout) {
        return {
            restrict: 'E',
            scope: {
                message: '@',
                show: '@',
                type: '@',
                alertType: '@'
            },
            template: '<div ng-if="show" ng-class="alertType">{{message}}</div>',
            link: function (scope, element, attrs) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                scope.$on('event-alert', function (event, data) {
                    data.message = data.message || "Success";
                    scope.duration = data.duration || 3000;
                    scope.message = data.message;
                    scope.callBack = data.callBack;
                    scope.show = true;
                    scope.alertType = data.alertType;
                    element
                        .addClass('animated slideInLeft')
                        .one(animationEnd, function () {
                            element.removeClass('animated slideInLeft');
                            $timeout(function () {
                                element.addClass('animated fadeOut')
                                    .one(animationEnd, function () {
                                        element.removeClass('animated fadeOut');
                                        scope.show = false;
                                        if (!scope.$$phase) {
                                            scope.$apply();
                                        }
                                        // Call the callback function at the end of the animation
                                        if (scope.callBack) {
                                            scope.callBack();
                                        }
                                    });
                            }, scope.duration);
                        });
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('driverName', ['$timeout', driverName]);

    function driverName($timeout) {
        return {
            restrict: 'E',
            scope: {
                driver: '<',
                nameClass: '@'
            },
            template: '<span class="vertical-align"><i ng-if="driver.isDnsVetted" title="Vetted Driver" class="material-icons no-underline color-vetted font-bold font-size-16 cursor-default margin-right-sm">verified</i> <span class="{{nameClass}}">{{ driver.name }}</span></span>',
            link: function (scope, element, attrs) {
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('customOnChange', customOnChange);

    function customOnChange() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.customOnChange);
                element.bind('change', onChangeHandler);
            }
        };
    }
})();
(function () {
    'use strict';

     asideParent.$inject = ["$rootScope"];
    angular
        .module('redcap.directives')
        .directive('asideParent', asideParent);
     
     function asideParent($rootScope){
        return {
            restrict: 'A',
            scope: {
                childScopeForm: "=asideParent"
            },
            link: function(scope, element, attrs) {
                var isListenerDeregistered = false;
                $rootScope.$on('$stateChangeStart', function (event, toState, toParam) {
                    isListenerDeregistered = !isListenerDeregistered;
                    if (typeof scope.childScopeForm !== 'undefined' && !isListenerDeregistered) {
        
                        if (!scope.childScopeForm.isOkToRemove()) {
                            event.preventDefault();
                            return false;
                        }
                    }
                });
            }         
        };
     }        
})();
(function () {
    'use strict';

    fillHeight.$inject = ["$window", "$document", "$interval", "$timeout"];
    angular
        .module('redcap.directives')
        .directive('fillHeight', fillHeight);

    function fillHeight($window, $document, $interval, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var intervalCheck = null;

                if (attrs.debounceWait === 0) {
                    angular.element($window).on('resize', windowResize);
                } else {
                    // allow debounce wait time to be passed in.
                    // if not passed in, default to a reasonable 250ms
                    angular.element($window).on('resize', debounce(onWindowResize, attrs.debounceWait || 250));
                }
                
                // returns a fn that will trigger 'time' amount after it stops getting called.
                function debounce(fn, time) {
                    var timeout;
                    // every time this returned fn is called, it clears and re-sets the timeout
                    return function() {
                        var context = this;
                        // set args so we can access it inside of inner function
                        var args = arguments;
                        var later = function() {
                            timeout = null;
                            fn.apply(context, args);
                        };
                        $timeout.cancel(timeout);
                        timeout = $timeout(later, time);
                    };
                }
                
                function onWindowResize() {
                    var footerElement = angular.element($document[0].getElementById(attrs.footerElementId));
                    var footerElementHeight;

                    if (footerElement.length === 1) {
                        footerElementHeight = footerElement[0].offsetHeight
                              + getTopMarginAndBorderHeight(footerElement)
                              + getBottomMarginAndBorderHeight(footerElement);
                    } else {
                        footerElementHeight = 0;
                    }

                    var elementOffsetTop = element.offset().top;
                    var elementBottomMarginAndBorderHeight = getBottomMarginAndBorderHeight(element);

                    var additionalPadding = attrs.additionalPadding || 0;

                    var elementHeight = $window.innerHeight
                                        - elementOffsetTop
                                        - elementBottomMarginAndBorderHeight
                                        - footerElementHeight
                                        - additionalPadding;
                    element.css('height', elementHeight + 'px');
                }

                function getTopMarginAndBorderHeight(element) {
                    var footerTopMarginHeight = getCssNumeric(element, 'margin-top');
                    var footerTopBorderHeight = getCssNumeric(element, 'border-top-width');
                    return footerTopMarginHeight + footerTopBorderHeight;
                }

                function getBottomMarginAndBorderHeight(element) {
                    var footerBottomMarginHeight = getCssNumeric(element, 'margin-bottom');
                    var footerBottomBorderHeight = getCssNumeric(element, 'border-bottom-width');
                    return footerBottomMarginHeight + footerBottomBorderHeight;
                }

                function getCssNumeric(element, propertyName) {
                    return parseInt(element.css(propertyName), 10) || 0;
                }

                function cleanUp() {
                    if (angular.isDefined(intervalCheck)) { 
                        $interval.cancel(intervalCheck);
                    }

                    if (attrs.debounceWait === 0) 
                        angular.element($window).off('resize', windowResize);
                    else
                        angular.element($window).off('resize', debounce(onWindowResize, attrs.debounceWait || 250));
                }

                intervalCheck = $interval(onWindowResize, 600, false);
                scope.$on('$destroy', cleanUp);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('redcap.directives')
        .directive('allowNullOption', allowNullOption)
        .directive('dynamicPlaceholderOption', dynamicPlaceholderOption);
     
     function allowNullOption(){
         return {
           restrict: 'A',        
           template: '<option value="">{{ defaultText }}</option>',
           link: function(scope, element, attrs) {
               scope.defaultText = attrs.allowNullOption || 'Select...';               
           }         
         };
     }

     function dynamicPlaceholderOption() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var placeholderText = attrs.dynamicPlaceholderOption || 'Select...';
                var nullOption = angular.element('<option value="" disabled selected hidden>' + placeholderText + '</option>');
                element.prepend(nullOption);
                
                scope.$watch(attrs.ngModel, function(newValue) {
                    if (newValue === null || newValue === undefined) {
                        element.val('');
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.trip')
        .config(routeConfig);

    function resolveContact(trip, messagesService) {
        if (!trip?.dealer?.id) {
            return null;
        }

        let phoneNumber = (trip.customerPhone || '').replace(/\D/g, '');

        if (phoneNumber && phoneNumber.length === 10) {
            return messagesService.getContacts({dealer: trip.dealer.id, query: phoneNumber, allowDisabledDealers: true}).then((contacts) => {
                if (contacts && contacts.length) {
                    return contacts[0];
                }

                let customerName = (trip.customerName || '').split(' ');

                return {
                    id: 0,
                    dealerId: trip.dealer.id,
                    firstName: customerName[0] || null,
                    lastName: customerName[1] || null,
                    email: trip.customerEmail || null,
                    mobilePhone: trip.customerPhone || null
                };
            });
        }

        return null;
    }

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {
        let tripMain = {
            parent: 'app',
            url: '/trips',
            permission: SYSTEM_ENUMS.permissionTypes.transportation,
            abstract: true,
            data: {},
            templateUrl: 'app/shared/layouts/content-only/content-only.view.html'
        };

            let tripListBase = {
                parent: 'app',
                url: '/triplist',
                topLevel: true,
                data: {
                    displayName: 'Trips'
                },
                permission: SYSTEM_ENUMS.permissionTypes.transportation,
                templateUrl: 'app/areas/trip/views/trip-main.view.html',
                controller: 'TripMainController as vm',
                resolve: {
                    resolvedSystemTripTypes: ['tripService', function (tripService) {
                        return tripService.getSystemTripTypes();
                    }],
                    resolvedAllowedTripTypes: ['tripService', function (tripService) {
                        return tripService.getAvailableTripTypes();
                    }],
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'Trips - ' + parentTitle;
                    }],
                    resolvedConfig: ['resolvedConfig', function (resolvedConfig) {
                        return resolvedConfig;
                    }]
                }
            };

            let tripDetail = {
                abstract: true,
                parent: tripListBase,
                url: '/:tripId?rmt&activeMessageTab',
                onEnter: ['$aside', '$log', '$transition$', 'authService', 'trip', 'hasMessaging', 'resolvedLocationList', function ($aside, $log, $transition$, authService, trip, hasMessaging, resolvedLocationList) {
                    rcAsideProvider.showAside($aside, $log, 'trip', 'trip-detail.view.html', 'TripDetailController as vm', {
                        resolvedTrip: [function () {
                            return trip;
                        }],
                        resolvedBookingRules: ['bookingService', function (bookingService) {
                            let rulesData = {
                                dealerId: trip.dealer.id,
                                tripTypeId: trip.dealerTripTypeId,
                                systemTripTypeId: trip.systemTripTypeId,
                                modelId: trip.vehicle ? trip.vehicle.id : null
                            };

                            return bookingService.getRules(rulesData);
                        }],
                        hasMessaging: [function () {
                            return hasMessaging;
                        }],
                        resolvedParams: [function () {
                            let rmtVal = authService.isFramedIn() && !authService.isAllowedMessagesFramedIn() ? "1" : $transition$.params().rmt;

                            return {
                                rmt: rmtVal,
                                activeMessageTab: $transition$.params().activeMessageTab
                            };
                        }],
                        resolvedLocationList: [function () {
                            return resolvedLocationList;
                        }]
                    },
                    'static',
                    true,
                    'trip-summary-aside transparent',
                    authService.isFramedIn());
                }],
                views: {
                    'messages-customer@': {
                        templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                        controller: 'MessagesCustomerTabController as vm'
                    },
                    'messages-driver@': {
                        templateUrl: 'app/shared/messages/views/messages-driver-tab.view.html',
                        controller: 'MessagesDriverTabController as vm'
                    },
                    'messages-monitor@': {
                        templateUrl: 'app/shared/messages/views/messages-monitor-tab.view.html',
                        controller: 'MessagesMonitorTabController as vm'
                    },
                    'messages-notes@': {
                        templateUrl: 'app/shared/messages/views/messages-notes-tab.view.html',
                        controller: 'MessagesNotesTabController as vm'
                    },
                    'messages-dealer-info@': {
                        templateUrl: 'app/shared/messages/views/messages-dealer-info-tab.view.html',
                        controller: 'MessagesDealerInfoTabController as vm'
                    },
                    'messages-internal@': {
                        templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                        controller: 'MessagesInternalTabController as vm'
                    }
                },
                onExit: ['$log', '$rootScope', function ($log, $rootScope) {
                    rcAsideProvider.destroyAside($log);
                    $rootScope.$broadcast('Trip.asideClosed');
                }],
                resolve: {
                    trip: ['tripService', '$transition$', function (tripService, $transition$) {
                        return tripService.getTrip($transition$.params().tripId);
                    }],
                    appointment: function() {
                        return null;
                    },
                    contact: ['trip', 'messagesService', function (trip, messagesService) {
                        return resolveContact(trip, messagesService);
                    }],
                    hasMessaging: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.hasMessaging(trip.dealer.id);
                    }],
                    resolvedTripMessages: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getTripMessages(trip.id);
                    }],
                    resolvedLocationList: ['$transition$', function ($transition$) {
                        return $transition$.params().locationList;
                    }]
                }
            };

            let tripDetailTabs = {
                parent: tripDetail,
                abstract: true,
                resolve: {}
            };

            let tripsAddBase = {
                parent: tripListBase,
                abstract: true,
                onEnter: ['$aside', '$log', 'trip', '$transition$', '$filter', 'authService', 'resolvedLocationList', 'resolvedSystemTripType', 'resolvedConfig', 'resolvedParentTrip',
                    function ($aside, $log, trip, $transition$, $filter, authService, resolvedLocationList, resolvedSystemTripType, resolvedConfig, resolvedParentTrip) {
                        rcAsideProvider.showAside($aside, $log, 'trip', 'trip-add.view.html', 'TripAddController as vm', {
                            resolvedLocationList: [function () {
                                _.forEach(resolvedLocationList, (location) => {
                                    switch (location.status) {
                                        case 1:
                                            location.statusText = 'Active';
                                            break;
                                        case 2: 
                                            location.statusText = 'QA';
                                            break;
                                        case 3: 
                                            location.statusText = 'Install';
                                            break;
                                        default:
                                            location.statusText = 'Disabled';
                                            break;
                                    }
                                });

                                return resolvedLocationList;
                            }],
                            resolvedLocation: [function () {
                                if ($transition$.params().locationId) {
                                    return $filter('filter')(resolvedLocationList, {id: parseInt($transition$.params().locationId)}, true)[0];
                                } else {
                                    return null;
                                }
                            }],
                            resolvedConfig: function () {
                                return resolvedConfig;
                            },
                            resolvedUser: ['profileService', function (profileService) {
                                "ngInject";

                                return profileService.getUser();
                            }],
                            resolvedSystemTripType: [function () {
                                return resolvedSystemTripType;
                            }],
                            resolvedTripType: [function () {
                                if (resolvedSystemTripType && $transition$.params().tripTypeInstanceId) {
                                    return $filter('filter')(resolvedSystemTripType.dealerTripTypes, {id: parseInt($transition$.params().tripTypeInstanceId)}, true)[0];
                                } else {
                                    return null;
                                }
                            }],
                            resolvedServiceOrder: ['bookingService', function (bookingService) {
                                if ($transition$.params().serviceOrderId) {
                                    return bookingService.getServiceOrder($transition$.params().locationId, $transition$.params().serviceOrderId);
                                } else {
                                    return null;
                                }
                            }],
                            resolvedFavoriteLocations: ['locationService', function (locationService) {
                                if ($transition$.params().locationId) {
                                    return locationService.getVenues($transition$.params().locationId);
                                } else {
                                    return null;
                                }
                            }],
                            resolvedTripWorkFlows: ['tripService', function (tripService) {
                                    return tripService.getTripWorkFlows();
                            }],
                            resolvedParentTrip: [function () {
                                return resolvedParentTrip;
                            }],
                            resolvedRO: ['bookingService', function (bookingService) {
                                if (resolvedParentTrip) {
                                    return bookingService.roSearchLight(resolvedParentTrip.customerPhone, $transition$.params().locationId, resolvedParentTrip.systemTripTypeId, true);
                                } else {
                                    return null;
                                }
                            }],
                            resolvedParams: [function () {
                                let data = {};

                                if (resolvedParentTrip) {
                                    data = {
                                        firstName: resolvedParentTrip.customerFirstName,
                                        lastName: resolvedParentTrip.customerLastName,
                                        phoneNumber: resolvedParentTrip.customerPhone,
                                        emailAddress: resolvedParentTrip.customerEmail,
                                        vehicleYear: resolvedParentTrip.vehicle.year,
                                        vehicleMake: resolvedParentTrip.vehicle.make,
                                        vehicleModel: resolvedParentTrip.vehicle.model,
                                        vehicleVIN: resolvedParentTrip.vehicle.vin,
                                        vehicleTransmission: resolvedParentTrip.vehicle.isManual ? 1 : 0,
                                        hasLoaner: resolvedParentTrip.hasLoaner,
                                        loanerReservationId: resolvedParentTrip.externalReservationId,
                                        roNumber: resolvedParentTrip.roNumber,
                                        externalConfirmationToken: resolvedParentTrip.externalConfirmationToken
                                    };
                                } else {
                                        data = {
                                        reference: $transition$.params().reference,
                                        firstName: $transition$.params().first,
                                        lastName: $transition$.params().last,
                                        phoneNumber: $transition$.params().phone,
                                        emailAddress: $transition$.params().email,
                                        vehicleYear: $transition$.params().year,
                                        vehicleMake: $transition$.params().make,
                                        vehicleModel: $transition$.params().model,
                                        vehicleVIN: $transition$.params().vin,
                                        vehicleTransmission: $transition$.params().trans ? $transition$.params().trans.toLowerCase() === 'a' ? 0 : $transition$.params().trans.toLowerCase() === 'm' ? 1 : null : null,
                                        hasLoaner: $transition$.params().trans
                                            ? $transition$.params().loaner === '0'
                                                ? 0
                                                : $transition$.params().loaner === '1'
                                                    ? 1
                                                    : null
                                            : null,
                                        apptDateTime: $transition$.params().appt,
                                        tripType: $transition$.params().tripType,
                                        locationId: $transition$.params().locationId,
                                        loanerReservationId: $transition$.params().loaner === '1' ? $transition$.params().loanerReservationId : null,
                                        roNumber: $transition$.params().roNumber,
                                        tripWorkflowType: $transition$.params().tripWkfl,
                                        streetAddress: $transition$.params().st,
                                        city: $transition$.params().city,
                                        state: $transition$.params().state,
                                        zip: $transition$.params().zip,
                                        countryShortCode: $transition$.params().country,
                                        lat: $transition$.params().lat,
                                        lng: $transition$.params().lng,
                                        externalConfirmationToken: $transition$.params().externalConfirmationToken
                                    };
                                }

                                return data;
                            }],
                            resolvedTrip: function () {
                                return null;
                            },
                            resolvedTripChildren: function () {
                                return null;
                            },
                            resolvedBookingRules: function () {
                                return null;
                            }
                        },
                    undefined, true, 'transparent', authService.isFramedIn());
                }],
                views: {
                    'messages-customer@': {
                        templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                        controller: 'MessagesCustomerTabController as vm'
                    },
                    'messages-driver@': {
                        templateUrl: 'app/shared/messages/views/messages-driver-tab.view.html',
                        controller: 'MessagesDriverTabController as vm'
                    },
                    'messages-monitor@': {
                        templateUrl: 'app/shared/messages/views/messages-monitor-tab.view.html',
                        controller: 'MessagesMonitorTabController as vm'
                    },
                    'messages-notes@': {
                        templateUrl: 'app/shared/messages/views/messages-notes-tab.view.html',
                        controller: 'MessagesNotesTabController as vm'
                    },
                    'messages-dealer-info@': {
                        templateUrl: 'app/shared/messages/views/messages-dealer-info-tab.view.html',
                        controller: 'MessagesDealerInfoTabController as vm'
                    },
                    'messages-internal@': {
                        templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                        controller: 'MessagesInternalTabController as vm'
                    }
                },
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    parentTitle: ['parentTitle', function (parentTitle) {
                        return parentTitle;
                    }], trip: ['$transition$', function ($transition$) {
                        if ($transition$.params().locationId) {
                            let trip = {
                                dealer: {
                                    id: $transition$.params().locationId,
                                }
                            };

                            return trip;
                        } else {
                            return null;
                        }
                    }],
                    appointment: function() {
                        return null;
                    },
                    contact: function() {
                        return null;
                    },
                    hasMessaging: ['tripService', '$transition$', function (tripService, $transition$) {
                        if ($transition$.params().locationId) {
                            return tripService.hasMessaging(parseInt($transition$.params().locationId));
                        } else {
                            return null;
                        }
                    }],
                    resolvedLocationList: ['locationService', '$transition$', function (locationService, $transition$) {
                        if ($transition$.params().locationList) {
                            return $transition$.params().locationList;
                        } else {
                            return locationService.getActiveDealersMinimalData(false, SYSTEM_ENUMS.permissionTypes.transportation);
                        }
                    }],
                    resolvedSystemTripType: ['bookingService', '$transition$', function (bookingService, $transition$) {
                        if ($transition$.params().systemTripTypeId) {
                            return bookingService.getLocationTripType($transition$.params().locationId, $transition$.params().systemTripTypeId);
                        } else {
                            return null;
                        }
                    }],
                    resolvedConfig: ['resolvedConfig', function (resolvedConfig) {
                        return resolvedConfig;
                    }],
                    resolvedParentTrip: ['tripService', '$transition$', function (tripService, $transition$) {
                        if ($transition$.params().parentTripId) {
                            return tripService.getTrip($transition$.params().parentTripId);
                        } else {
                            return null;
                        }
                    }],
                }
            };

            let tripsAdd = {
                parent: tripsAddBase,
                url: '/add/:locationId/:systemTripTypeId/:tripTypeInstanceId/:serviceOrderId?reference&first&last&phone&email&year&make&model&vin&trans&loaner&appt&triptype&loanerReservationId&tripWkfl&roNumber&st&city&state&zip&country&lat&lng&parentTripId&externalConfirmationToken',
                params: {
                    locationId: {squash: true, value: null},
                    systemTripTypeId: {squash: true, value: null},
                    tripTypeInstanceId: {squash: true, value: null},
                    serviceOrderId: {squash: true, value: null},
                    loanerReservationId: null,
                    roNumber: null,
                    locationList: null,
                    externalConfirmationToken: null
                },
                resolve: {
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'New Trip - ' + parentTitle;
                    }]
                }
            };


            let tripsEditBase = {
                parent: tripListBase,
                abstract: true,
                params: {
                    tripId: {squash: true, value: null}
                },
                onEnter: ['$aside', '$log', 'trip', 'locList', 'sysTripType', 'resolvedConfig', '$filter', function ($aside, $log, trip, locList, sysTripType, resolvedConfig, $filter) {
                    rcAsideProvider.showAside($aside, $log, 'trip', 'trip-add.view.html', 'TripAddController as vm', {
                        resolvedTrip: [function () {
                            return trip;
                        }],
                        resolvedConfig: [function () {
                            return resolvedConfig;
                        }],
                        resolvedLocationList: [function () {
                            return locList;
                        }],
                        resolvedSystemTripType: [function () {
                            return sysTripType;
                        }],
                        resolvedLocation: [function () {
                            if (trip) {
                                return $filter('filter')(locList, {id: parseInt(trip.dealer.id)}, true)[0];
                            } else {
                                return null;
                            }
                        }],
                        resolvedUser: ['profileService', function (profileService) {
                            "ngInject";

                            return profileService.getUser();
                        }],
                        resolvedTripType: [function () {
                            if (trip) {
                                return $filter('filter')(sysTripType.dealerTripTypes, {id: parseInt(trip.dealerTripTypeId)}, true)[0];
                            } else {
                                return null;
                            }
                        }],
                        resolvedServiceOrder: ['bookingService', function (bookingService) {
                            if (trip) {
                                return bookingService.getServiceOrder(trip.dealer.id, trip.dealerServiceOrderId);
                            } else {
                                return null;
                            }
                        }],
                        resolvedBookingRules: ['bookingService', function (bookingService) {
                            if (trip) {
                                let rulesData = {
                                    dealerId: trip.dealer.id,
                                    tripTypeId: trip.dealerTripTypeId,
                                    systemTripTypeId: trip.systemTripTypeId,
                                    modelId: trip.vehicle ? trip.vehicle.id : null
                                };

                                return bookingService.getRules(rulesData);
                            } else {
                                return null;
                            }
                        }],
                        resolvedFavoriteLocations: ['locationService', function (locationService) {
                            if (trip.dealer.id) {
                                return locationService.getVenues(trip.dealer.id);
                            } else {
                                return null;
                            }
                        }],
                        resolvedTripWorkFlows: ['tripService', function (tripService) {
                            if (trip.dealer.id) {
                                return tripService.getTripWorkFlows();
                            } else {
                                return null;
                            }

                        }],
                        resolvedParams: [function () {
                            return null;
                        }],
                        resolvedParentTrip: [function () {
                            return null;
                        }],
                        resolvedRO: [function () {
                            return null;
                        }],
                    },
                    undefined, true, 'transparent');
                }],
                views: {
                    'messages-customer@': {
                        templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                        controller: 'MessagesCustomerTabController as vm'
                    },
                    'messages-driver@': {
                        templateUrl: 'app/shared/messages/views/messages-driver-tab.view.html',
                        controller: 'MessagesDriverTabController as vm'
                    },
                    'messages-monitor@': {
                        templateUrl: 'app/shared/messages/views/messages-monitor-tab.view.html',
                        controller: 'MessagesMonitorTabController as vm'
                    },
                    'messages-notes@': {
                        templateUrl: 'app/shared/messages/views/messages-notes-tab.view.html',
                        controller: 'MessagesNotesTabController as vm'
                    },
                    'messages-dealer-info@': {
                        templateUrl: 'app/shared/messages/views/messages-dealer-info-tab.view.html',
                        controller: 'MessagesDealerInfoTabController as vm'
                    },
                    'messages-internal@': {
                        templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                        controller: 'MessagesInternalTabController as vm'
                    }
                },
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    trip: ['tripService', '$transition$', function (tripService, $transition$) {
                        return tripService.getTrip($transition$.params().tripId);
                    }],
                    appointment: function() {
                        return null;
                    },
                    contact: ['trip', 'messagesService', function (trip, messagesService) {
                        return resolveContact(trip, messagesService);
                    }],
                    hasMessaging: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.hasMessaging(trip.dealer.id);
                    }],
                    resolvedTripMessages: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getTripMessages(trip.id);
                    }],
                    locList: ['locationService', '$transition$', function (locationService, $transition$) {
                        if ($transition$.params().locationList) {
                            return $transition$.params().locationList;
                        } else {
                            return locationService.getActiveDealersMinimalData(false, SYSTEM_ENUMS.permissionTypes.transportation);
                        }
                    }],
                    sysTripType: ['trip', 'bookingService', function (trip, bookingService) {
                        if (trip) {
                            return bookingService.getLocationTripType(trip.dealer.id, trip.systemTripTypeId);
                        } else {
                            return null;
                        }
                    }],
                    resolvedconfig: ['resolvedConfig', function (resolvedConfig) {
                        return resolvedConfig;
                    }]
                }
            };

            let tripsEdit = {
                parent: tripsEditBase,
                url: '/:tripId/edit',
                params: {
                    tripId: {squash: true, value: null},
                    locationList: null
                },
                resolve: {
                    pageTitle: ['trip', 'parentTitle', function (trip, parentTitle) {
                        return 'Edit Trip (' + trip.id + ') - ' + parentTitle;
                    }]
                }
            };

            let messagingSideTabs = {
                parent: tripDetail,
                abstract: true,
                resolve: {
                }
            };


        $stateProvider
            .state('trip', tripMain)

            // creating dummy route in order to easily redirect to new route in $stateChangeStart event
            .state('old-trip-list', {
                parent: tripMain,
                url: ''
            })

            .state('trip-list', tripListBase)

            .state('trip-add-base', tripsAddBase)

            .state('trip-add', tripsAdd)

            .state('trip-edit-base', tripsEditBase)

            .state('edit-trip', tripsEdit)

            .state('trip-detail', tripDetail)

            .state('trip-detail-tabs', tripDetailTabs)

            .state('trip-side-tabs', messagingSideTabs)

            .state('trip-tab-trip', {
                parent: tripDetailTabs,
                url: '/summary',
                params: {
                    locationList: null
                },
                views: {
                    'trip-tab-trip@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-summary.view.html',
                        controller: 'TripTabSummaryController as vm'
                    }
                },
                resolve: {
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }],
                    tabTrip: ['trip', function (trip) {
                        return trip;
                    }],
                    resolvedBookingRules: ['bookingService', 'tabTrip', function (bookingService, tabTrip) {
                        if (tabTrip) {
                            let rulesData = {
                                dealerId: tabTrip.dealer.id,
                                tripTypeId: tabTrip.dealerTripTypeId,
                                systemTripTypeId: tabTrip.systemTripTypeId,
                                modelId: tabTrip.vehicle ? tabTrip.vehicle.id : null
                            };

                            return bookingService.getRules(rulesData);
                        } else {
                            return null;
                        }
                    }],
                    pageTitle: ['trip', 'parentTitle', function(trip, parentTitle) {
                        let tripId = trip && trip.id ? ' (' + trip.id + ')' : '';

                        return 'Trip Details' + tripId + ' - ' + parentTitle;
                    }]
                }
            })

            .state('trip-tab-vehicles', {
                parent: tripDetailTabs,
                url: '/vehicles',
                views: {
                    'trip-tab-vehicles@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-vehicles.view.html',
                        controller: 'TripTabVehiclesController as vm'
                    }
                },
                resolve: {
                    pageTitle: ['trip', 'parentTitle', function (trip, parentTitle) {
                        let tripId = trip && trip.id ? ' (' + trip.id + ')' : '';

                        return 'Trip Vehicle Details' + tripId + ' - ' + parentTitle;
                    }],
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }],
                    resolvedVehicles: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getTripVehicles(trip.id);
                    }]
                }
            })

            .state('trip-tab-tasks', {
                parent: tripDetailTabs,
                url: '/tasks',
                views: {
                    'trip-tab-tasks@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-tasks.view.html',
                        controller: 'TripTabTasksController as vm'
                    }
                },
                resolve: {
                    pageTitle: ['trip', 'parentTitle', function (trip, parentTitle) {
                        let tripId = trip && trip.id ? ' (' + trip.id + ')' : '';

                        return 'Trip Tasks' + tripId + ' - ' + parentTitle;
                    }],
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }],
                    resolvedTaskResponses: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getDriverTaskResponses(trip.id);
                    }]
                }
            })

            .state('trip-tab-ratings', {
                parent: tripDetailTabs,
                url: '/ratings',
                views: {
                    'trip-tab-ratings@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-ratings.view.html',
                        controller: 'TripTabRatingsController as vm'
                    }
                },
                resolve: {
                    pageTitle: ['trip', 'parentTitle', function (trip, parentTitle) {
                        let tripId = trip && trip.id ? ' (' + trip.id + ')' : '';

                        return 'Trip Ratings' + tripId + ' - ' + parentTitle;
                    }],
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }],
                    resolvedSurveys: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getSurveys(trip.id);
                    }],
                    resolvedDriver: ['trip', 'tripService', function (trip, tripService) {
                        if ((trip.driver && trip.driver.id) && !trip.providerRideId) {
                            return tripService.getDriverDetails(trip.id).then((result) => { return result; }).catch((err) => { return null; });
                        } else {
                            return null;
                        }
                    }]
                }
            })

            .state('trip-tab-log', {
                parent: tripDetailTabs,
                url: '/log',
                views: {
                    'trip-tab-log@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-log.view.html',
                        controller: 'TripTabLogController as vm'
                    }
                },
                resolve: {
                    pageTitle: ['trip', 'parentTitle', function (trip, parentTitle) {
                        let tripId = trip && trip.id ? ' (' + trip.id + ')' : '';

                        return 'Trip Log' + tripId + ' - ' + parentTitle;
                    }],
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }]
                }
            })

            .state('trip-tab-audit', {
                parent: tripDetailTabs,
                url: '/audit?expandTimeDetails&expandBillingDetails&expandAll',
                views: {
                    'trip-tab-audit@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-audit.view.html',
                        controller: 'TripTabAuditController as vm'
                    }
                },
                resolve: {
                    pageTitle: ['trip', 'parentTitle', '$transition$', function (trip, parentTitle, $transition$) {
                        let tripId = trip && trip.id ? ' (' + trip.id + ')' : '';

                        return 'Trip Audit' + tripId + ' - ' + parentTitle;
                    }],
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }],
                    resolvedTripChildren: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getTripChildren(trip.id);
                    }],
                    resolvedWorkflow: ['trip', 'tripService', function (trip, tripService) {
                        return tripService.getWorkflow(trip.id);
                    }],
                    resolvedParams: ['$transition$', function ($transition$) {
                        return {
                            expandTimeDetails: $transition$.params().expandTimeDetails === "1",
                            expandBillingDetails: $transition$.params().expandBillingDetails === "1",
                            expandAll: $transition$.params().expandAll === "1"
                        };
                    }]
                }
            })

            .state('trip-tab-help', {
                parent: tripDetailTabs,
                url: '/help',
                views: {
                    'trip-tab-help@': {
                        templateUrl: 'app/areas/trip/views/partials/trip-tab-help.view.html',
                        controller: 'TripTabHelpController as vm'
                    }
                },
                resolve: {
                    pageTitle: ['resolvedTrip', 'parentTitle', function (resolvedTrip, parentTitle) {
                        let tripId = resolvedTrip && resolvedTrip.id ? ' (' + resolvedTrip.id + ')' : '';

                        return 'Trip Help' + tripId + ' - ' + parentTitle;
                    }],
                    resolvedTrip: ['trip', function (trip) {
                        return trip;
                    }]
                }
            })

            .state('lyft-credit-edit', {
                parent: tripListBase,
                url: '/:id/:isTest/edit',
                onEnter: ["$aside", "$log", "credit", function ($aside, $log, credit) {
                    rcAsideProvider.showAside($aside, $log, 'trip', 'lyft-credit-edit.view.html', 'LyftCreditEditController as vm', {
                        resolvedCredit: function () {
                            return credit;
                        }
                    },
                    'static',
                    true,
                    'aside-sm');
                }],
                onExit: ["$log", function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    credit: ["rideProviderService", "$transition$", function (rideProviderService, $transition$) {
                        let id = $transition$.params().id;
                            let isTest = $transition$.params().isTest === "1";

                        return rideProviderService.getCredit(id, isTest);
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Edit Ride Share Credit - ' + parentTitle;
                    }]
                }
            })

            .state('lyft-campaign-edit', {
                parent: tripListBase,
                url: '/benefits/campaigns/:id/edit',
                onEnter: ["$aside", "$log", "campaign", function($aside, $log, campaign) {
                    rcAsideProvider.showAside($aside, $log, 'trip', 'lyft-campaign-edit.view.html', 'LyftCampaignEditController as vm', {
                        resolvedCampaign: function() {
                            return campaign;
                        }
                    },
                    'static',
                    true,
                    'aside-sm');
                }],
                onExit: ["$log", function($log) { 
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    campaign: ["rideProviderService", "$transition$", function(rideProviderService, $transition$) {
                        let campaignId = $transition$.params().id;

                        return rideProviderService.getCampaign(campaignId);
                    }],
                    pageTitle: ["parentTitle", function(parentTitle) {
                        return 'Edit Ride Share Campaign - ' + parentTitle;
                    }]
                }
            })
;
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider"];
    angular.module('redcap.profile')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider) {
        $stateProvider
            .state('profile', {
                parent: 'app',
                url: '/profile',
                data: {
                    displayName: 'My Profile'
                },
                templateUrl: 'app/areas/profile/views/profile.view.html',
                controller: 'ProfileController as vm',
                onExit: ["$log", "profileService", function ($log, profileService) {
                    profileService.clearCache();
                }],
                resolve: {
                    resolvedUser: ["profileService", function (profileService) {
                        "ngInject";

                        return profileService.getUser();
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        "ngInject";

                        return 'My Profile - ' + parentTitle;
                    }]
                }
            })

            .state('changepassword', {
                parent: 'app',
                url: '/changepassword',
                data: {
                    displayName: 'Change Password'
                },
                templateUrl: 'app/areas/profile/views/changepassword.view.html',
                controller: 'ChangePasswordController as vm',
                resolve: {
                    resolvedUser: ["profileService", function (profileService) {
                        "ngInject";

                        return profileService.getUser();
                    }],
                    configId: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.id;
                    }],
                    isForced: function () {
                        return false;
                    },
                    pageTitle: ["parentTitle", function (parentTitle) {
                        "ngInject";

                        return 'Change Password - ' + parentTitle;
                    }]
                }
            })

            .state('changepasswordForced', {
                parent: 'public',
                url: '/changepasswordRequired',
                data: {
                    displayName: 'Change Password'
                },
                templateUrl: 'app/areas/profile/views/changepasswordForced.view.html',
                controller: 'ChangePasswordController as vm',
                resolve: {
                    resolvedUser: ["profileService", function (profileService) {
                        "ngInject";

                        return profileService.getUser();
                    }],
                    configId: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.id;
                    }],
                    isForced: function () {
                        return true;
                    },
                    pageTitle: ["parentTitle", function (parentTitle) {
                        "ngInject";

                        return 'Change Password - ' + parentTitle;
                    }]
                },
            });

            $stateProvider.state('myschedule', {
                parent: 'profile',
                params: {
                    referrer: null
                },
                url: '/myschedule',
                onEnter: ['$aside', '$log', '$transition$', '$location', function ($aside, $log, $transition$) {
                    rcAsideProvider.showAside($aside, $log, 'location', 'location-tab-advisors.view.html', 'LocationTabAdvisorsController as vm', {
                        $transition$: $transition$,
                        resolvedLocation: function () {
                            return null;
                        },
                        resolvedDealerTripTypes: function () {
                            return null;
                        },
                        resolvedHasCheckIn: function () {
                            return false;
                        }, 
                        resolvedDMSData: function () {
                            return null;
                        },
                        resolvedServiceAdvisors: function () {
                            return null;
                        },
                        currentState: function () {
                            // this injection is for manage departments dropdown, unused here
                            return null;
                        },
                        ctrlOptions: function () {
                            return {
                                individualScheduleView: true,
                                adminView: false
                            };
                        },
                        pageTitle: function () {
                            return 'Manage My Schedule';
                        }
                    }, null, true);
                }],
                onExit: ["$log", function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {}

            });
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider"];
    angular.module('redcap.support')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider) {
        $stateProvider
            .state('driver-help', {
                parent: 'tutorial-list',
                url: '/driverHelp',
                onEnter: ["$aside", "$log", function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'support', 'driver-help.view.html', 'DriverHelpController as vm', {

                    }, null, true, 'aside-sm');
                }],
                onExit: ["$log", "supportService", function ($log, supportService) {
                    supportService.clearCache();
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return  'Tutorial and Help (Drivers) - ' + parentTitle;
                    }]
                }
            })

            .state('software-help', {
                parent: 'tutorial-list',
                url: '/softwareHelp',
                onEnter: ["$aside", "$log", function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'support', 'software-help.view.html', 'SoftwareHelpController as vm', {
                            resolvedPreviousPage: function () {
                                return 'tutorial-list';
                            },
                            resolvedTicketType: function () {
                                return null;
                            }
                    }, null, true, 'aside-sm');
                }],
                onExit: ["$log", "supportService", function ($log, supportService) {
                    supportService.clearCache();
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return  'Tutorial and Help (Software) - ' + parentTitle;
                    }]
                }
            })

            .state('tutorial-list', {
                parent: 'app',
                url: '/tutorialList/:productId',
                data: {
                    displayName: 'Training &amp; User Guides'
                },
                templateUrl: 'app/areas/support/views/tutorial-list.view.html',
                controller: 'TutorialListController as vm',
                resolve: {
                    resolvedSupportTrainingConfigs: ['supportService', function (supportService) {
                        return supportService.getSupportTrainingConfigs();
                    }],
                    resolvedSupportTrainingConfig: ['$transition$', 'supportService', 'SYSTEM_ENUMS', 
                        function ($transition$, supportService, SYSTEM_ENUMS) {
                            let productId = $transition$.params().productId;

                            return supportService.getSupportTrainingConfig(productId)
                                        .then((service) => {
                                            switch (service.productName) {
                                                case SYSTEM_ENUMS.products.Product_Appointment.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Appointment.overrideVal; 
                                                    break;
                                                case SYSTEM_ENUMS.products.Product_Inspect.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Inspect.overrideVal; 
                                                    break;
                                                case SYSTEM_ENUMS.products.Product_Loaner.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Loaner.overrideVal; 
                                                    break;
                                                case SYSTEM_ENUMS.products.Product_Messaging.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Messaging.overrideVal; 
                                                    break;
                                                case SYSTEM_ENUMS.products.Product_Payment.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Payment.overrideVal; 
                                                    break;
                                                case SYSTEM_ENUMS.products.Product_Report.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Report.overrideVal; 
                                                    break;
                                                case SYSTEM_ENUMS.products.Product_Transportation.originalVal:
                                                    service.productName = SYSTEM_ENUMS.products.Product_Transportation.overrideVal; 
                                                    break;
                                            }

                                            return service;
                                        });
                            }
                    ],
                    resolvedTutorials: ['$transition$', 'userService', function ($transition$, userService) {
                        return userService.getTutorialBySupportConfigId($transition$.params().productId);
                    }],
                    pageTitle: ['resolvedSupportTrainingConfig', 'parentTitle', function (resolvedSupportTrainingConfig, parentTitle) {
                        return resolvedSupportTrainingConfig.productName + ' Support & Training - ' + parentTitle;
                    }]
                },
                onExit: ["$log", "supportService", function ($log, supportService) {
                    supportService.clearCache();
                }]
            });
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.reports')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {

        let reportsBase = {
            parent: 'app',
            url: '/reports',
            abstract: true,
            permission: SYSTEM_ENUMS.permissionTypes.reports,
            data: {},
            templateUrl: 'app/shared/layouts/content-only/content-only.view.html'
        };

        let reportsList = {
            parent: reportsBase,
            url: '',
            topLevel: true,
            data: {
                displayName: 'Reports'
            },
            templateUrl: 'app/areas/reports/views/report.list.html',
            controller: 'ReportListController as vm',
            resolve: {
                reportList: ["reportService", function (reportService) {
                    "ngInject";

                    return reportService.getList();
                }],
                appointmentLocationList: ["locationService", function (locationService) {
                    "ngInject";

                    return locationService.getLocationsForDropDown(true, true, SYSTEM_ENUMS.permissionTypes.inspect);
                }],
                pageTitle: ["parentTitle", function (parentTitle) {
                    "ngInject";

                    return 'Reports - ' + parentTitle;
                }]
            }
        };

        let reportEdit = {
            parent: reportsList,
            url: '/edit/:reportId',
            data: {
                displayName: 'Reports'
            },
            onEnter: ['$aside', '$log', 'report', 'reportService', function ($aside, $log, report, reportService) {
                rcAsideProvider.showAside($aside, $log, 'reports', 'report.edit.html', 'ReportEditController as vm', {
                    resolvedReport: function () {
                        return report;
                    },
                    resolvedPermissions: function() {
                        return reportService.getPermissions();
                    },
                    resolvedPrograms: function () {
                        return reportService.getPrograms();
                    }
                }, undefined, true, 'aside-sm');
            }],
            onExit: ['$log', function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                report: ['reportService', '$transition$', function (reportService, $transition$) {
                    return reportService.getReport($transition$.params().reportId);
                }],
                pageTitle: ['report', 'parentTitle', function (report, parentTitle) {
                    return 'Edit Report: ' + report.name + ' - ' + parentTitle;
                }]
            }
        };

        let reportAdd = {
            parent: reportsList,
            url: '/add',
            data: {
                displayName: 'Reports'
            },
            onEnter: ['$aside', '$log', 'reports', 'reportService', function ($aside, $log, reports, reportService) {
                rcAsideProvider.showAside($aside, $log, 'reports', 'report.add.html', 'ReportAddController as vm', {
                    resolvedReports: function () {
                        return reports;
                    },

                    resolvedPermissions: function () {
                        return reportService.getPermissions();
                    },

                    resolvedPrograms: function () {
                        return reportService.getPrograms();
                    }
                }, undefined, true, 'aside-sm');
            }],
            onExit: ['$log', function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                reports: ['reportService', function (reportService) {
                    return reportService.getUnaddedReports();
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'New Report - ' + parentTitle;
                }]
            }
        };

        $stateProvider
            .state('report-base', reportsBase)
            .state('report-list', reportsList)
            .state('report-edit', reportEdit)
            .state('report-add', reportAdd);
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.appointment')
        .config(routeConfig);

    function getContact(appointment, contacts) {
        let contact = null;

        if (contacts.length) {
            contact = contacts[0];
        } else {
            contact = {
                id: 0,
                dealerId: appointment.dealerId,
                firstName: appointment.customerFirstName,
                lastName: appointment.customerLastName,
                email: appointment.customerEmail,
                mobilePhone: appointment.customerPhone
            };
        }

        return contact;
    }

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {

        let parentAppointmentLists = ['appointment-list', 'checkin-list', 'inspect'];
        let idx = 0;
        let messageTab = {
            templateUrl: 'app/areas/appointment/views/right-rail-tabs/appointment-messages-tab.view.html',
            controller: 'AppointmentMessagesTabController as vm'
        };
        let scriptTab = {
            templateUrl: 'app/areas/appointment/views/right-rail-tabs/appointment-script-tab.view.html',
            controller: 'AppointmentScriptTabController as vm'
        };
        let faqTab = {
            templateUrl: 'app/areas/appointment/views/right-rail-tabs/appointment-faq-tab.view.html',
            controller: 'AppointmentFAQTabController as vm'
        };
        let customerDriverMonitorViews = {
            'messages-customer@': {
                templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                controller: 'MessagesCustomerTabController as vm'
            },
            'messages-driver@': {
                templateUrl: 'app/shared/messages/views/messages-driver-tab.view.html',
                controller: 'MessagesDriverTabController as vm'
            },
            'messages-monitor@': {
                templateUrl: 'app/shared/messages/views/messages-monitor-tab.view.html',
                controller: 'MessagesMonitorTabController as vm'
            },
            'messages-internal@': {
                templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                controller: 'MessagesInternalTabController as vm'
            }
        };
        let messageTabViews = [
            {
                'appointment-messages@': messageTab
            },
            {
                'appointment-messages-checkin-list@': messageTab
            }
        ];
        let scriptTabViews = [
            {
                'appointment-scripts@': scriptTab
            },
            {
                'appointment-scripts-checkin-list@': scriptTab
            }
        ];
        let faqTabViews = [
            {
                'appointment-faq@': faqTab
            },
            {
                'appointment-faq-checkin-list@': faqTab
            }
        ];

        _.forEach(parentAppointmentLists, (currParentList) => {
            let isApptList = currParentList === 'appointment-list';
            let stateSuffix = isApptList ? '' : '-' + currParentList;
            let mainUrl = '/appointment';
            let permission = SYSTEM_ENUMS.permissionTypes.appointments;

            if (currParentList === 'checkin-list') {
                mainUrl = '/checkin';
                permission = SYSTEM_ENUMS.permissionTypes.checkIn;
            }

            $stateProvider.state('appointment-main'  + stateSuffix, {
                parent: 'app',
                url: mainUrl,
                permission: permission,
                abstract: true,
                data: {},
                templateUrl: 'app/shared/layouts/content-only/content-only.view.html'
            });

            if (currParentList !== 'inspect') {
                $stateProvider.state(currParentList, {
                        parent: 'appointment-main'  + stateSuffix,
                        url: '/:mode',
                        topLevel: true,
                        data: {
                            displayName: 'Appointments'
                        },
                        params: {
                            mode: {squash: true, value: null}
                        },
                        templateUrl: 'app/areas/appointment/views/appointment-list.view.html',
                        controller: 'AppointmentListController as vm',
                        resolve: {
                            resolvedLocationList: ['locationService', function (locationService) {
                                return locationService.getLocationsForDropDown(true, false, permission, SYSTEM_ENUMS.systemTripType.appointment);
                            }],
                            resolvedLocation: ['resolvedLocationList', 'rcLocalStorageService', '$filter', function (resolvedLocationList, rcLocalStorageService, $filter) {
                                let loc = !resolvedLocationList || resolvedLocationList.length === 0 ? null : resolvedLocationList[0];
                                let lastDealer = rcLocalStorageService.get('selectedAppointmentDealer');
                                let matchedDealer  = lastDealer ? $filter('filter')(resolvedLocationList, {id: lastDealer.id || lastDealer}, true) : null;

                                if (!lastDealer || matchedDealer.length === 0) {
                                    lastDealer = loc;
                                }

                                return lastDealer || loc;
                            }],
                            resolvedDepartments: ['resolvedLocation', 'locationService', function (resolvedLocation, locationService) {
                                if (resolvedLocation) {
                                    return locationService.getLocationDepartments(resolvedLocation.id);
                                } else {
                                    return null;
                                }
                            }],
                            resolvedAppointmentStatuses: ['settingsService', function(settingsService) {
                                return settingsService.getAppointmentStatuses();
                            }],
                            resolvedLocationTransportationTypes: ['resolvedLocation', 'locationService', function (resolvedLocation, locationService) {
                                if (resolvedLocation) {
                                    return locationService.getLocationTransportationTypes(resolvedLocation.id);
                                } else {
                                    return [];
                                }
                            }],
                            resolvedLocationOpCodes: ['resolvedLocation', 'locationService', function (resolvedLocation, locationService) {
                                if (resolvedLocation) {
                                    return locationService.getLocationOpCodes(resolvedLocation.id);
                                } else {
                                    return [];
                                }
                            }],
                            hasAccess: ['appointmentService', 'resolvedLocation', function (appointmentService, resolvedLocation) {
                                if (resolvedLocation) {
                                    return appointmentService.hasAccess(resolvedLocation.id);
                                } else {
                                    return false;
                                }
                            }],
                            pageTitle: ['parentTitle', function (parentTitle) {
                                return 'Appointments - ' + parentTitle;
                            }],
                            resolvedMobileGarageMarketingContent: ['settingsService', function(settingsService) {
                                return settingsService.getMobileGarageMarketingContent();
                            }]
                        }
                    });
                

                    $stateProvider.state('appointment-details' + stateSuffix, {
                        abstract: false,
                        parent: currParentList,
                        params: {
                            showAuthCompleteBanner: {squash: true, value: null}
                        },
                        url: '/:locationId/details/:appointmentId',
                        onEnter: ['$aside', '$log', 'appointment', 'hasMessaging', 'resolvedAppointmentRideShareCredit', 'resolvedLocationTransportationTypes', 'resolvedLocationTripTypeInstances',
                        'resolvedAppointmentStatuses', 'resolvedDepartments', 'resolvedLocationOpCodes', 'resolvedDealerHasCheckin', 'resolvedDealerHasInspect', '$transition$', 
                        function ($aside, $log, appointment, hasMessaging, resolvedAppointmentRideShareCredit, resolvedLocationTransportationTypes, resolvedLocationTripTypeInstances, resolvedAppointmentStatuses, resolvedDepartments, resolvedLocationOpCodes, resolvedDealerHasCheckin, resolvedDealerHasInspect, $transition$) {
                            rcAsideProvider.showAside($aside, $log, 'appointment', 'appointment-detail-tabs.view.html', 'AppointmentDetailTabsController as vmPnl', {
                                resolvedAppointment: [function () {
                                    return appointment;
                                }],
                                resolvedLocationTransportationTypes: [function () {
                                    return resolvedLocationTransportationTypes;
                                }],
                                resolvedLocationTripTypeInstances: [function () {
                                    return resolvedLocationTripTypeInstances;
                                }],
                                resolvedAppointmentStatuses: [function () {
                                    return resolvedAppointmentStatuses;
                                }],
                                resolvedDepartments: [function() {
                                    return resolvedDepartments;
                                }],
                                resolvedLocationOpCodes: [function () {
                                    return resolvedLocationOpCodes;
                                }],
                                resolvedAppointmentRideShareCredit: [function () {
                                    return resolvedAppointmentRideShareCredit;
                                }],
                                resolvedDealerHasCheckin: [function () {
                                    return resolvedDealerHasCheckin;
                                }],
                                resolvedDealerHasInspect: [function () {
                                    return resolvedDealerHasInspect;
                                }],
                                hasMessaging: [function () {
                                    return hasMessaging;
                                }],
                                $transition$: function () {
                                    return $transition$;
                                }
                            }, null, true,
                            'appt-wizard transparent');
                        }],
                        views: customerDriverMonitorViews,
                        onExit: ['$log', function ($log) {
                            rcAsideProvider.destroyAside($log);
                        }],
                        resolve: {
                            appointment: ['$transition$', '$q', 'appointmentService', function ($transition$, $q, appointmentService) {
                                let deferred = $q.defer();

                                appointmentService.getAppointment($transition$.params().locationId, $transition$.params().appointmentId).then((appointment) => {
                                    deferred.resolve(appointment);
                                });

                                return deferred.promise;
                            }],
                            trip: function () {
                                return null;
                            },
                            contact: ['appointment', 'hasMessaging', 'messagesService', function (appointment, hasMessaging, messagesService) {
                               let phoneNumber = (appointment.customerPhone || '').replace(/\D/g, '');

                                if (hasMessaging && appointment.dealerId && phoneNumber && phoneNumber.length === 10) {
                                    return messagesService.getContacts({dealer: appointment.dealerId, query: phoneNumber, allowDisabledDealers: true}).then((contacts) => {
                                        return getContact(appointment, contacts || []);
                                    }); 
                                }

                                return getContact(appointment, []);
                            }],
                            resolvedLocationTransportationTypes: ['$q', 'appointment', 'locationService', function ($q, appointment, locationService) {
                                if (appointment.dealerId) {
                                    let deferred = $q.defer();

                                    locationService.getLocationTransportationTypes(appointment.dealerId).then((response) => {
                                        deferred.resolve(response);
                                    });

                                    return deferred.promise;
                                } else {
                                    return [];
                                }
                            }],
                            resolvedLocationTripTypeInstances: ['$q', 'appointment', 'locationService', function ($q, appointment, locationService) {
                                if (appointment.dealerId) {
                                    let deferred = $q.defer();

                                    locationService.getLocationTripTypeInstances(appointment.dealerId).then((response) => {
                                        deferred.resolve(response);
                                    });

                                    return deferred.promise;
                                } else {
                                    return [];
                                }
                            }],
                            resolvedDepartments: ['$q', 'appointment', 'locationService', function ($q, appointment, locationService) {
                                if (appointment.dealerId) {
                                    let deferred = $q.defer();

                                    locationService.getLocationDepartments(appointment.dealerId, true).then((response) => {
                                        deferred.resolve(response);
                                    });

                                    return deferred.promise;
                                } else {
                                    return [];
                                }
                            }],
                            resolvedDealerHasCheckin: ['$transition$', '$q', 'locationService', function ($transition$, $q, locationService) {
                                let deferred = $q.defer();

                                locationService.hasRole($transition$.params().locationId, SYSTEM_ENUMS.permissionTypes.checkIn).then((response) => {
                                    deferred.resolve(response);
                                });

                                return deferred.promise;
                                
                            }],
                            resolvedDealerHasInspect: ['$transition$', '$q', 'locationService', function ($transition$, $q, locationService) {
                                let deferred = $q.defer();
                                      
                                locationService.hasRole($transition$.params().locationId, SYSTEM_ENUMS.permissionTypes.inspect).then((response) => {
                                    deferred.resolve(response); // true or false
                                });

                                 return deferred.promise;
                           }],
                            resolvedAppointmentRideShareCredit: ['$transition$', '$q', 'appointment', 'authorizationService', function ($transition$, $q, appointment, authorizationService) {
                                if ($transition$.params().appointmentRideShareCredit) {
                                    return $transition$.params().appointmentRideShareCredit;
                                } else {
                                    let deferred = $q.defer();

                                    authorizationService.getAppointmentRideShareCredit(appointment.dealerId, $transition$.params().appointmentId).then((response) => {
                                        deferred.resolve(response);
                                    });

                                    return deferred.promise;
                                }
                            }],
                            hasMessaging: ['appointment', 'tripService', function (appointment, tripService) {
                                return tripService.hasMessaging(appointment.dealerId);
                            }],
                            resolvedLocationOpCodes: ['appointment', 'locationService', function (appointment, locationService) {
                                if (appointment.dealerId) {
                                    return locationService.getLocationOpCodes(appointment.dealerId);
                                } else {
                                    return [];
                                }
                            }],
                            pageTitle: ['$transition$', 'parentTitle', function ($transition$, parentTitle) {
                                return 'Appointment Details: ' + $transition$.params().appointmentId  + ' - ' + parentTitle;
                            }]
                        }
                    });

                    $stateProvider.state('appointment-checkin' + stateSuffix, {
                        abstract: false,
                        parent: currParentList,
                        params: {
                            appointment: {squash: true, value: null}, 
                            departments: {squash: true, value: null},
                            department: {squash: true, value: null},                           
                            hasMessaging: {squash: true, value: null},
                            currentStep: {squash: true, value: null}
                        },
                        url: '/:locationId/checkin/:appointmentId?currentStep',
                        onEnter: ['$aside', '$log', 'hasMessaging', 'appointment', 'resolvedAdvisors', 'resolvedDepartments', 'resolvedContact', 'resolvedAppointmentStatuses', 'resolvedCheckinUrl', '$transition$', function ($aside, $log, hasMessaging, appointment, resolvedAdvisors, resolvedDepartments, resolvedContact, resolvedAppointmentStatuses, resolvedCheckinUrl, $transition$) {
                            rcAsideProvider.showAside($aside, $log, 'checkin', 'checkin.view.html', 'CheckInController as vm', {
                                resolvedAppointment: [function () {
                                    return appointment;
                                }],
                                resolvedAppointmentStatuses: [function () {
                                    return resolvedAppointmentStatuses;
                                }],
                                resolvedContact: [function () {
                                    return resolvedContact;
                                }],
                                resolvedDepartments: [function() {
                                    return resolvedDepartments;
                                }],
                                resolvedAdvisors: [function() {
                                    return resolvedAdvisors;
                                }],
                                resolvedCheckinUrl: [function() {
                                    return resolvedCheckinUrl;
                                }],
                                hasMessaging: [function () {
                                    return hasMessaging;
                                }],
                                $transition$: function () {
                                    return $transition$;
                                }
                            }, null, true,
                            'appt-wizard transparent', false, 'app/areas/checkin/checkin.view.html');
                        }],
                        views: customerDriverMonitorViews,
                        onExit: ['$log', function ($log) {
                            rcAsideProvider.destroyAside($log);
                        }],
                        resolve: {
                            appointment: ['$transition$', '$q', 'appointmentService', function ($transition$, $q, appointmentService) {
                                return appointmentService.getAppointment($transition$.params().locationId, $transition$.params().appointmentId);
                            }],
                            resolvedContact: ['appointment', '$q', 'messagesService', function (appointment, $q, messagesService) {
                                let phoneNumber = appointment.customerPhone;

                                if (phoneNumber && phoneNumber.length === 10) {
                                    let deferred = $q.defer();

                                    messagesService.getContacts({dealer: appointment.dealerId, query: phoneNumber.replace(/\D/g, ''), allowDisabledDealers: true})
                                    .then((contacts) => {
                                        let contact = getContact(appointment, contacts);

                                        deferred.resolve(contact);
                                    });

                                    return deferred.promise;
                                } else {
                                    return getContact(appointment, []);
                                }
                            }],
                            resolvedDepartments: ['$transition$', '$q', 'appointment', 'locationService', function ($transition$, $q, appointment, locationService) {
                                if ($transition$.params().departments) {
                                    return $transition$.params().departments;
                                } else if (appointment.dealerId) {
                                    let deferred = $q.defer();

                                    locationService.getLocationDepartments(appointment.dealerId, true).then((response) => {
                                        deferred.resolve(response);
                                    });

                                    return deferred.promise;
                                } else {
                                    return [];
                                }
                            }],
                            resolvedAdvisors: ['appointment', 'locationService', function (appointment, locationService) {
                                if (appointment.departmentId) {
                                    return locationService.getLocationDepartmentAvailAdvisor(appointment.dealerId, appointment.departmentId, true).then((response) => {
                                        return response?.advisors || [];                                        
                                    });
                                } else {
                                    return Promise.resolve([]);
                                }
                            }],
                            hasMessaging: ['$transition$', '$q', 'appointment', 'tripService', function ($transition$, $q, appointment, tripService) {
                                if ($transition$.params().hasMessaging) {
                                    return $transition$.params().hasMessaging;
                                } else {
                                    let deferred = $q.defer();

                                    tripService.hasMessaging(appointment.dealerId).then((response) => {
                                        deferred.resolve(response);
                                    });

                                    return deferred.promise;
                                }
                            }],    
                            trip: function () {
                                return null;
                            },
                            contact: ['resolvedContact', function (resolvedContact) {
                                return resolvedContact;
                            }],                         
                            isTestModeEnabled: ['appointment', 'locationService', function (appointment, locationService) {
                                return locationService.isTestModeEnabled(appointment.dealerId);
                            }],
                            resolvedCheckinUrl: ['$window', '$state', '$transition$', 'appointment', function ($window, $state, $transition$, appointment) {
                                let currentStep = $transition$.params().currentStep || 1;
                                let configId = $transition$.params().configId;
                                let relativeUrl = $state.href(
                                    'appointment-checkin' + stateSuffix,
                                    {
                                        configId: configId,
                                        locationId: appointment.dealerId,
                                        appointmentId: appointment.id,
                                        currentStep: currentStep
                                    }
                                );

                                return $window.location.origin + relativeUrl;
                            }],
                            pageTitle: ['$transition$', 'parentTitle', function ($transition$, parentTitle) {
                                return 'Checking In Appointment ' + $transition$.params().appointmentId  + ' - ' + parentTitle;
                            }]
                        }
                    });

                    $stateProvider.state('appointment-base' + stateSuffix, {
                        parent: currParentList,
                        abstract: true,
                        onEnter: ['$aside', '$log', '$transition$', function ($aside, $log, $transition$) {
                            rcAsideProvider.showAside($aside, $log, 'appointment', 'appointment.view.html', 'AppointmentController as vm', {
                                $transition$: $transition$,
                                resolvedLocationList: ['locationService', function (locationService) {
                                    return locationService.getLocationsForDropDown(true, false, SYSTEM_ENUMS.permissionTypes.appointments, SYSTEM_ENUMS.systemTripType.appointment);
                                }],
                                resolvedAppointmentStatuses: ['settingsService', function(settingsService) {
                                    return settingsService.getAppointmentStatuses();
                                }],
                                resolvedDmsRequiredFields: ['appointmentService', function (appointmentService) {
                                    if ($transition$.params().locationId)
                                        return appointmentService.getDMSRequiredFields($transition$.params().locationId);

                                    return null;
                                }]
                            },
                            'static',
                            true,
                            'appt-wizard transparent');
                        }],
                        onExit: ['$log', function ($log) {
                            rcAsideProvider.destroyAside($log);
                        }],
                        resolve: {
                        }
                    });
                    
                    $stateProvider.state('appointment-add' + stateSuffix, {
                        parent: 'appointment-base' + stateSuffix,
                        url: '/add/:locationId/:appointmentId/:editClicked',
                        params: {
                            locationId: {squash: true, value: null},
                            appointmentId: {squash: true, value: null},
                            customerId: {squash: true, value: null},
                            editClicked: {squash: true, value: null},
                            vin: {squash: true, value: null},
                            autoNewCustomer: {squash: true, value: null}
                        },
                        resolve: {
                            pageTitle: ['parentTitle', '$transition$', function (parentTitle, $transition$) {
                                return ($transition$.params().editClicked === "1" ? 'Edit' : 'New') + ' Appointment' + ($transition$.params().editClicked === "1" ? $transition$.params().appointmentId : '') + ' - ' + parentTitle;
                            }]
                        }
                    });                
                }                
                
                $stateProvider.state('appointment-tabs' + stateSuffix, {
                    parent: 'appointment-add' + stateSuffix,
                    abstract: true,
                    resolve: {
                        pageTitle: ['parentTitle', function (parentTitle) {
                            return 'New Appointment - ' + parentTitle;
                        }]
                    }
                });
                
                $stateProvider.state('appointment-messages' + stateSuffix, {
                    parent: 'appointment-tabs' + stateSuffix,
                    url: '',
                    views: messageTabViews[idx]

                });
                
                $stateProvider.state('appointment-scripts' + stateSuffix, {
                    parent: 'appointment-tabs' + stateSuffix,
                    url: '',
                    views: scriptTabViews[idx]
                });
                
                $stateProvider.state('appointment-faq' + stateSuffix,  {
                    parent: 'appointment-tabs' + stateSuffix,
                    url: '',
                    views: faqTabViews[idx]
                });

                idx++;

            });

    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider"];
    angular.module('redcap.productmarketing')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider) {

        var marketing = {
            parent: 'app',
            url: '/marketing/:marketingArea',
            topLevel: false,
            data: {
                displayName: 'Marketing'
            },
            params:{ 
                marketingArea: { squash: true, value: null }
            },
            templateUrl: 'app/areas/productmarketing/views/embedded.view.html',
            controller: 'ProductMarketingEmbeddedController as vm',
            resolve: {
                pageTitle: ['$stateParams', function ($stateParams) {
                    return 'Marketing - ' + _.startCase($stateParams.marketingArea);
                }],
                resolvedMarketingURL: ['$stateParams', 'permissions', function ($stateParams, permissions) {
                    'ngInject';
                    var permissionId = $stateParams.marketingArea,
                        url = permissions.getPermissionMarketingURL(permissionId);
                    return url;
                }],
                resolvedMarketingConfig: ['$stateParams', 'permissions', function ($stateParams, permissions) {
                    'ngInject';
                    var permissionId = $stateParams.marketingArea;
                    return permissions.getPermissionMarketingConfig(permissionId);
                }]
                
            }
        };
        

        $stateProvider
        .state('marketing', marketing)
        .state('inquire', {
            parent: 'marketing',
            url: '/inquire',
            params: {
                permissionId: { squash: true, value: null }
            },
            onEnter: ['$aside', '$log', 'user', 'resolvedMarketingConfig', function ($aside, $log, user, resolvedMarketingConfig) {
                rcAsideProvider.showAside($aside, $log, 'productmarketing', 'inquire.view.html', 'InquireController as vm', {
                    resolvedUser: function () {
                        "ngInject";
                        return user;
                    },
                    marketingConfig: function () {
                        "ngInject";
                        return resolvedMarketingConfig;
                    }
                });
            }],
            onExit: ['$log', 'supportService', function ($log, supportService) {
                supportService.clearCache();
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                pageTitle: ["parentTitle", function (parentTitle) {
                    return  parentTitle + 'Inquired';
                }],
                user: ['profileService', function (profileService) {
                    "ngInject";
                    return profileService.getUser();
                }]
            }
        });
     
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.payments')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {

        let paymentsBase = {
            parent: 'app',
            url: '/invoices',
            abstract: true,
            permission: SYSTEM_ENUMS.permissionTypes.payments,
            data: {},
            templateUrl: 'app/shared/layouts/content-only/content-only.view.html'
        };

        let invoiceList = {
            parent: paymentsBase,
            url: '',
            topLevel: true,
            data: {
                displayName: 'Payments'
            },
            templateUrl: 'app/areas/payments/views/list.view.html',
            controller: 'PaymentsListController as vm',
            resolve: {
                resolvedInvoices: ["paymentService", "localStorageService", function (paymentService, localStorageService) {
                    "ngInject";
                    let searchText = localStorageService.get('paymentFilterSearchText') || "";
                        let selectedLocationId = localStorageService.get('paymentFilterByLocation') || null;
                        let createdBy = localStorageService.get('paymentFilterByCreator') || null;
                        let selectedInvoiceStatus = localStorageService.get('paymentFilterByInvoiceStatus') || null;
                        let selectedStatus = localStorageService.get('paymentFilterBySelectedStatus') || null;
                        let sortFilterDirection = localStorageService.get('paymenyFilterByDirection') || "asc";
                        let sortFilterType = localStorageService.get('paymenyFilterByType') || "Customer";

                    return paymentService.getInvoices(searchText, selectedLocationId, createdBy, selectedInvoiceStatus, selectedStatus, null, null, sortFilterDirection, sortFilterType);
                }],
                resolvedLocations: ["repairOrderService", function (repairOrderService) {
                    "ngInject";

                    return repairOrderService.getDealersForDropdown(SYSTEM_ENUMS.permissionTypes.payments);
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'Payments - ' + parentTitle;
                }]
            }
        };

        let createPaymentAside = {
            abstract: false,
            url: '/create',
            parent: invoiceList,
            onEnter: ['$aside', '$log', 'locations', function ($aside, $log, locations) {
                rcAsideProvider.showAside($aside, $log, 'payments', 'payment-create.view.html', 'PaymentCreateController as vm', {
                    resolvedLocations: function () {
                        "ngInject";

                        return locations;
                    }
                }, undefined, true, 'aside-sm');
            }],
            onExit: ['$log', function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                locations: ['resolvedLocations', function (resolvedLocations) {
                    "ngInject";

                    return resolvedLocations;
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    "ngInject";

                    return 'New Invoice - ' + parentTitle;
                }]
            },
            params: {
                location: null,
                customer: null,
                lineItems: null
            }
        };

        let editPaymentsAside = {
            abstract: true,
            url: '/:invoiceId?',
            parent: invoiceList,
            onEnter: ['$aside', '$log', 'invoice', 'contact', 'hasMessaging', function ($aside, $log, invoice, hasMessaging) {
                rcAsideProvider.showAside($aside, $log, 'payments', 'aside.view.html', 'PaymentAsideController as vm', {
                    resolvedInvoice: function () {
                        return invoice;
                    },
                    hasMessaging: [function () {
                        return hasMessaging;
                    }]
                }, null, true, 'transparent');
            }],
            views: {
                'messages-customer@': {
                    templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                    controller: 'MessagesCustomerTabController as vm'
                },
                'messages-internal@': {
                    templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                    controller: 'MessagesInternalTabController as vm'
                }
            },
            onExit: ['$log', function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                invoice: ['paymentService', '$transition$', '$q', function (paymentService, $transition$, $q) {
                    "ngInject";

                    let deferred = $q.defer();

                    paymentService.getInvoice($transition$.params()["invoiceId"]).then((invoice) => {
                        if (invoice.customerFirstName && invoice.customerLastName)
                            invoice.fullName = invoice.customerFirstName + ' ' + invoice.customerLastName;
                        if (invoice.customerFirstName === 'undefined' || invoice.customerFirstName == null)
                            invoice.fullName = invoice.customerLastName;
                        if (invoice.customerLastName === 'undefined' || invoice.customerLastName == null)
                            invoice.fullName = invoice.customerFirstName;
                        deferred.resolve(invoice);
                    });

                    return deferred.promise;
                }],
                contact: ['invoice', 'messagesService', function (invoice, messagesService) {
                    return messagesService.getContact(invoice.contactId);
                }],
                hasMessaging: ['invoice', 'tripService', function (invoice, tripService) {
                    return tripService.hasMessaging(invoice.dealerId);
                }],
                trip: function () {
                    return null;
                },
                appointment: function () {
                    return null;
                }
            }
        };

        let paymentsEdit = {
            parent: editPaymentsAside,
            url: '/edit',
            data: {
                displayName: 'Payments'
            },
            views: {
                'payment-edit@': {
                    templateUrl: 'app/areas/payments/views/payment-edit.view.html',
                    controller: 'PaymentEditController as vm'
                }
            },
            resolve: {
                resolvedInvoice: ["invoice", function (invoice) {
                    "ngInject";

                    return invoice;
                }],
                hasMessaging: ["hasMessaging", function (hasMessaging) {
                    "ngInject";

                    return hasMessaging;
                }],
                pageTitle: ['invoice', 'parentTitle', function (invoice, parentTitle) {
                    return 'Invoice Details (' + invoice.fullName + ') - ' + parentTitle;
                }]
            }
        };

        let paymentsSendLink = {
            parent: editPaymentsAside,
            url: '/send-link',
            params: {
                invoiceId: {squash: true, value: null},
                fromPaymentList: {squash: true, value: false}
            },
            data: {
                displayName: 'Payments'
            },
            views: {
                'payment-send-link@': {
                    templateUrl: 'app/areas/payments/views/payment-send-link.view.html',
                    controller: 'PaymentSendLinkController as vm'
                },
                'payment-edit@': {
                    templateUrl: 'app/areas/payments/views/payment-send-link.view.html',
                    controller: 'PaymentSendLinkController as vm'
                }
            },
            resolve: {
                resolvedInvoice: ["invoice", function (invoice) {
                    "ngInject";

                    return invoice;
                }],
                pageTitle: ['invoice', 'parentTitle', function (invoice, parentTitle) {
                    return 'Send Payment Link: ' + invoice.id + ' (' + invoice.fullName + ') - ' + parentTitle;
                }]
            }
        };

        let paymentsEditLineItems = {
            parent: editPaymentsAside,

            url: '/items',
            data: {
                displayName: 'Payments'
            },
            views: {
                'payment-edit-items@': {
                    templateUrl: 'app/areas/payments/views/payment-edit-items.view.html',
                    controller: 'PaymentEditItemsController as vm'
                },
                'payment-edit@': {
                    templateUrl: 'app/areas/payments/views/payment-edit-items.view.html',
                    controller: 'PaymentEditItemsController as vm'
                }
            },
            resolve: {
                resolvedInvoice: ["invoice", function (invoice) {
                    "ngInject";

                    return invoice;
                }],
                pageTitle: ['invoice', 'parentTitle', function (invoice, parentTitle) {
                    return 'Edit Line Item: ' + invoice.id + ' (' + invoice.fullName + ') - ' + parentTitle;
                }]
            }
        };

        let cenposLoader = {
            parent: 'app',
            url: '/cenopos-loader',
            permission: SYSTEM_ENUMS.permissionTypes.payments,
            views: {
                'payment-cenpos-loader@': {
                    templateUrl: 'app/areas/payments/views/cenpos-loader.view.html',
                    controller: 'PaymentCenposLoaderController as vm'
                }
            },
            resolve: {
                resolvedInvoice: function () {
                    return null;
                }
            }
        };

        let cenposProcessed = {
            url: '/cenpos-processed',
            templateUrl: '/cenpos-process.view.html',
            controller: 'PaymentCenposProcessedController as vm'
        };

        let periProcessed = {
            parent: paymentsBase,
            url: '/peri-dashboard-verify',
            templateUrl: 'app/areas/payments/views/partials/peri-dashboard-verify.view.html',
            controller: 'periDashboardVerifyController as vm'
        };

        $stateProvider
            .state('payments-base', paymentsBase)
            .state('payments-list', invoiceList)
            .state('payment-aside', editPaymentsAside)
            .state('payment-edit', paymentsEdit)
            .state('payment-create', createPaymentAside)
            .state('payment-cenpos-loader', cenposLoader)
            .state('payment-cenpos-processed', cenposProcessed)
            .state('payment-peri-dashboard-processed', periProcessed)
            .state('payment-send-link', paymentsSendLink)
            .state('payment-edit-items', paymentsEditLineItems);
    }
})();

(function() {

angular
    .module('redcap.messages')
    .constant('MESSAGES_ENUM', {
        contactMessageTypes: {
            customer: 0,
            internal: 1,
            driver: 2
        },
        acknowledgementTypes: {
            none: 0,
            manual: 1,
            reply: 2
        }
    });
})();
(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "MESSAGES_ENUM", "SYSTEM_ENUMS"];
    angular
        .module('redcap.messages')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, MESSAGES_ENUM, SYSTEM_ENUMS) {

        let contactList = {
            parent: 'app',
            url: '/contacts',
            data: {
                displayName: 'Messages'
            },
            templateUrl: 'app/areas/messages/views/contact-list.view.html',
            controller: 'ContactListController as vm',
            permission: SYSTEM_ENUMS.permissionTypes.messaging,
            resolve: {
                resolvedLocations: ['locationService', function (locationService) {
                    return locationService.getLocationsForDropDown(true, false, SYSTEM_ENUMS.permissionTypes.messaging);
                }],
                resolvedImpersonations: ['messagesService', function (messagesService) {
                    return messagesService.getImpersonations();
                }],
                resolvedMessageTemplates: ['messagesService', function(messagesService) {
                    return messagesService.getMessageTemplates();
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'Messages - ' + parentTitle;
                }]
            }
        };

        let contactAdd = {
            parent: contactList,
            url: '/add',
            onEnter: ['$aside', '$log', 'contact', 'resolvedLocations', 'resolvedMessageTemplates', function ($aside, $log, contact, resolvedLocations, resolvedMessageTemplates) {
                rcAsideProvider.showAside($aside, $log, 'messages', 'contact-add.view.html', 'ContactAddController as vm', {
                    resolvedContact: function () {
                        return contact;
                    },
                    resolvedLocations: function () {
                        return resolvedLocations;
                    },
                    resolvedMessageTemplates: function() {
                        return resolvedMessageTemplates;
                    }
                }, undefined, true, 'aside-sm');
            }],
            onExit: ['$log', '$rootScope', function ($log, $rootScope) {
                rcAsideProvider.destroyAside($log);
                $rootScope.$broadcast('Contact.asideClosed');
            }],
            resolve: {
                contact: [function () {
                    return {id: 0, firstName: '', lastName: '', mobilePhone: '', dmsCustomerId: '', email: ''};
                }],
                resolvedLocations: ['resolvedLocations', function (resolvedLocations) {
                    return resolvedLocations;
                }],
                resolvedMessageTemplates: ['resolvedMessageTemplates', function(resolvedMessageTemplates) {
                    return resolvedMessageTemplates;
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'New Contact - ' + parentTitle;
                }]
            }
        };

        let contactDetail = {
            parent: contactList,
            abstract: true,
            dsr: true,
            sticky: true,
            topLevel: true,
            url: '/{contactId:int}',
            onEnter: ['$aside', '$log', 'contact', 'resolvedLocations', 'resolvedMessageTemplates', 'hasMessaging', 'resolvedServiceAdvisors', function ($aside, $log, contact, resolvedLocations, resolvedMessageTemplates, hasMessaging, resolvedServiceAdvisors) {
                rcAsideProvider.showAside($aside, $log, 'messages', 'contact-detail.view.html', 'ContactDetailController as vm', {
                    resolvedContact: function () {
                        return contact;
                    },
                    resolvedLocations: function () {
                        return resolvedLocations;
                    },
                    resolvedMessageTemplates: function() {
                        return resolvedMessageTemplates;
                    },
                    resolvedServiceAdvisors: function () {
                        return resolvedServiceAdvisors;
                    },
                    hasMessaging: function () {
                        return hasMessaging;
                    }
                });
            }],
            onExit: ['$log', '$rootScope', 'contact', function ($log, $rootScope, contact) {
                rcAsideProvider.destroyAside($log);
                $rootScope.$broadcast('Contact.updated', contact);
                $rootScope.$broadcast('Contact.asideClosed');
            }],
            resolve: {
                contact: ['messagesService', '$transition$', '$q', function (messagesService, $transition$, $q) {
                    let deferred = $q.defer();
                    let contactId = $transition$.params().contactId;

                    messagesService.getContact(contactId).then((contact) => {
                        if (contact.firstName && contact.lastName)
                            contact.fullName = contact.firstName + ' ' + contact.lastName;
                        if (contact.firstName === 'undefined' || contact.firstName == null)
                            contact.fullName = contact.lastName;
                        if (contact.lastName === 'undefined' || contact.lastName == null)
                            contact.fullName = contact.firstName;

                        deferred.resolve(contact);
                    });

                    return deferred.promise;
                }],
                resolvedLocations: ['resolvedLocations', function (resolvedLocations) {
                    return resolvedLocations;
                }],
                resolvedMessageTemplates: ['resolvedMessageTemplates', function(resolvedMessageTemplates) {
                    return resolvedMessageTemplates;
                }],
                hasMessaging: ['contact', 'tripService', function (contact, tripService) {
                    return tripService.hasMessaging(contact.dealerId);
                }],
                resolvedServiceAdvisors: ['contact', 'locationService', function (contact, locationService) {
                    return locationService.getServiceAdvisors(contact.dealerId, true);
                }]
            }
        };

        let contactDetailCustomer = {
            parent: contactDetail,
            url: '',
            dsr: true,
            sticky: true,
            views: {
                'contact-detail-customer@': {
                    templateUrl: 'app/areas/messages/views/partials/contact-tab-messages.view.html',
                    controller: 'ContactTabMessagesController as vm'
                }
            },
            resolve: {
                messageType: function() {
                    return MESSAGES_ENUM.contactMessageTypes.customer;
                },
                pageTitle: ['contact', 'parentTitle', function (contact, parentTitle) {
                    return 'Contact Details (' + contact.fullName + ') - ' + parentTitle;
                }]
            }
        };

        let contactDetailInternal = {
            parent: contactDetail,
            url: '/internal',
            dsr: true,
            sticky: true,
            views: {
                'contact-detail-internal@': {
                    templateUrl: 'app/areas/messages/views/partials/contact-tab-messages.view.html',
                    controller: 'ContactTabMessagesController as vm'
                }
            },
            resolve: {
                messageType: function () {
                    return MESSAGES_ENUM.contactMessageTypes.internal;
                },
                pageTitle: ['contact', 'parentTitle', function (contact, parentTitle) {
                    return 'Internal Contact Details (' + contact.fullName + ') - ' + parentTitle;
                }]
            }
        };

        $stateProvider
            .state('contact-list', contactList);

        $stateProvider
            .state('contact-add', contactAdd);

        $stateProvider
            .state('contact-detail', contactDetail);

        $stateProvider
            .state('contact-detail-customer', contactDetailCustomer);

        $stateProvider
            .state('contact-detail-internal', contactDetailInternal);
    }
})();


(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.location')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {
        const locationList = {
            parent: 'app',
            url: '/locations',
            data: {
                displayName: 'Locations'
            },
            templateUrl: 'app/areas/location/views/location-list.view.html',
            controller: 'LocationListController as vm',
            userPermission: SYSTEM_ENUMS.permissionTypes.locations,
            resolve: {
                resolvedAdminConfigs: ['locationService', function (locationService) {
                    return locationService.getAdminPrograms();
                }],
                resolvedTimezones: ['locationService', function (locationService) {
                    return locationService.getTimezoneNames();
                }],
                pageTitle: ['parentTitle', function(parentTitle) {
                    return 'Locations - ' + parentTitle;
                }]
            }
        };

        const locationEdit = {
            abstract: true,
            parent: locationList,
            url: '/:locationId',
            onEnter: ['$aside', '$log', 'location', 'dealerHasCheckin', 'dealerTripTypes', '$transition$', function ($aside, $log, location, dealerHasCheckin, dealerTripTypes, $transition$) {
                rcAsideProvider.showAside($aside, $log, 'location', 'location-edit.view.html', 'LocationEditController as vm', {
                    $transition$: $transition$,
                    resolvedLocation: function () {
                        return location;
                    },
                    resolvedDealerTripTypes: ['SYSTEM_ENUMS', function (SYSTEM_ENUMS) {
                        dealerTripTypes = _.reject(dealerTripTypes, (el) => { return el.systemTripTypeId === SYSTEM_ENUMS.systemTripType.personalDriver || el.systemTripTypeId === SYSTEM_ENUMS.systemTripType.recalls; });

                        return dealerTripTypes;
                    }],
                    resolvedHasCheckin: function () {
                        return dealerHasCheckin;
                    }
                }, undefined, 'true', 'scroll-y-hidden');
            }],
            onExit: ['$log', 'locationService', function ($log, locationService) {
                rcAsideProvider.destroyAside($log);
                locationService.clearCache();
            }],
            resolve: {
                location: ['locationService', '$transition$', function (locationService, $transition$) {
                    let locationId = $transition$.params().locationId;
                    
                    return locationService.getLocation(locationId);
                }],
                dealerTripTypes: ['$transition$', 'locationService', 'SYSTEM_ENUMS', function ($transition$, locationService,) {
                    return locationService.getLocationTripTypeInstances($transition$.params().locationId);
                }],
                dealerHasCheckin: ['locationService', '$transition$', function (locationService, $transition$) {
                    let locationId = $transition$.params().locationId;

                    return locationService.hasRole(locationId, SYSTEM_ENUMS.permissionTypes.checkIn);
                }]
            }
        };

        const locationTabs = {
            parent: locationEdit,
            abstract: true,
            url: '/:tripTypeId',
            resolve: {
                pageTitle: ['location', 'parentTitle', function(location, parentTitle) {
                    return location.name + ' - ' + parentTitle;
                }]
            }
        };

        $stateProvider.state('location-list', locationList)

        .state('location-add', {
            parent: locationList,
            url: '/add',
            onEnter: ["$aside", "$log", "parentTitle", function ($aside, $log, parentTitle) {
                rcAsideProvider.showAside($aside, $log, 'location', 'location-add.view.html', 'LocationAddController as vm', {
                    resolvedAdminPrograms: ["locationService", function (locationService) {
                        "ngInject";

                        return locationService.getAdminPrograms();
                    }],
                    resolvedProductPackages: ["locationService", function(locationService) {
                        "ngInject";

                        return locationService.getProductPackages();
                    }],
                    resolvedLocations: ["locationService", function(locationService) {
                        "ngInject";

                        return locationService.getLocations();
                    }],
                    resolvedDriverCompanies: ["locationService", function (locationService) {
                        "ngInject";

                        return locationService.getDriverCompanies();
                    }],
                    resolvedDriverPrograms: ["locationService", function (locationService) {
                        "ngInject";

                        return locationService.getDriverPrograms();
                    }]
                }, undefined, true);
            }],
            onExit: ["$log", function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                pageTitle: ["parentTitle", function (parentTitle) {
                    return 'New Location - ' + parentTitle;
                }]
            }
        })

        .state('location-edit', locationEdit)

        .state('location-tabs', locationTabs)

        .state('tab-general', {
            parent: locationTabs,
            url: '/general',
            views: {
                'tab-general@': {
                    templateUrl: 'app/areas/location/views/location-tab-general.view.html',
                    controller: 'LocationTabGeneralController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedAdminPrograms: ["locationService", function (locationService) {
                    return locationService.getAdminPrograms();
                }],
                resolvedLocationUsers: ["location", "employeeService", function (location, employeeService) {
                    return employeeService.getEmployeesByLocation(location.id);
                }],
                resolvedTimezones: ["locationService", function (locationService) {
                    return locationService.getTimezones();
                }],
                resolvedProductPackages: ["locationService", function(locationService) {
                    return locationService.getProductPackages();
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'General Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-logos', {
            parent: locationTabs,
            url: '/logos',
            views: {
                'tab-logos@': {
                    templateUrl: 'app/areas/location/views/location-tab-logos.view.html',
                    controller: 'LocationTabLogosController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                locationLogos: ["locationService", "$transition$", function (locationService, $transition$) {
                    return locationService.getLocationLogos($transition$.params().locationId);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Logos (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-hours', {
            parent: locationTabs,
            url: '/hours',
            views: {
                'tab-hours@': {
                    templateUrl: 'app/areas/location/views/location-tab-hours.view.html',
                    controller: 'LocationTabHoursController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                locationHours: ["locationService", "$transition$", function (locationService, $transition$) {
                    return locationService.getLocationHours($transition$.params().locationId);
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Hours (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-departments', {
            parent: locationTabs,
            url: '/departments/add/?advDeptId',
            views: {
                'tab-departments@': {
                    templateUrl: 'app/areas/location/views/location-tab-departments.view.html',
                    controller: 'LocationTabDepartmentsController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDMSData: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDMS($transition$.params().locationId);
                }],
                resolvedServiceAdvisors: ["locationService", "$transition$", function (locationService, $transition$) {
                    return locationService.getServiceAdvisors($transition$.params().locationId, null, true, true);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }],
                resolvedTripType: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getTripTypeBookingTab($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedLocationDepartments: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDepartments($transition$.params().locationId);
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Departments (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-appointmentcapacity', {
            parent: locationTabs,
            url: '/appointment/capacity/',
            views: {
                'tab-appointmentcapacity@': {
                    templateUrl: 'app/areas/location/views/appointments/capacity.view.html',
                    controller: 'LocationAppointmentCapacityController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedLocationAppointmentConstraints: ["$transition$", "constraintService", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", function ($transition$, constraintService, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE) {
                    return constraintService.getConstraintsByType($transition$.params().locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointment);
                }],
                resolvedLocationTransportationConstraints: ["$transition$", "constraintService", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", function ($transition$, constraintService, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE) {
                    return constraintService.getConstraintsByType($transition$.params().locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.transportation);
                }],
                resolvedLocationBufferConstraints: ["$transition$", "constraintService", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", function ($transition$, constraintService, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE) {
                    return constraintService.getConstraintsByType($transition$.params().locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.appointmentBuffer);
                }],
                resolvedLocationTransportationTypes: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationTransportationTypes($transition$.params().locationId);
                }],
                resolvedTripTypeInstances: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedDepartments: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDepartments($transition$.params().locationId, true);
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Capacity (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-advisors', {
            parent: locationTabs,
            url: '/advisors/manage/',
            views: {
                'tab-advisors@': {
                    templateUrl: 'app/areas/location/views/location-tab-advisors.view.html',
                    controller: 'LocationTabAdvisorsController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedDMSData: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDMS($transition$.params().locationId);
                }],
                resolvedServiceAdvisors: ["locationService", "$transition$", function (locationService, $transition$) {
                    return locationService.getServiceAdvisors($transition$.params().locationId, null, true, true);
                }],
                ctrlOptions: function () {
                    return {
                        individualScheduleView: false,
                        adminView: true
                    };
                },
                currentState: function () {
                    // this injection is for manage departments dropdown, unused here
                    return null;
                },
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Manage Advisors - ' + parentTitle;
                }]
            }
        })

        .state('tab-capacity', {
            parent: locationTabs,
            url: '/capacity',
            views: {
                'tab-capacity@': {
                    templateUrl: 'app/areas/location/views/location-tab-capacity.view.html',
                    controller: 'LocationTabCapacityController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedLocationList: ['locationService', function (locationService) {
                    return locationService.getLocationsForDropDown(true, false);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedDealerCapacityGroups: ["locationService", "$transition$", function (locationService, $transition$) {
                    return locationService.getCapacityGroups($transition$.params().locationId);
                }],
                locationCapacities: ["locationService", "$transition$", function (locationService, $transition$) {
                    return locationService.getCapacities($transition$.params().locationId);
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Driver Capacity (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-integrations', {
            parent: locationTabs,
            url: '/integrations',
            views: {
                'tab-integrations@': {
                    templateUrl: 'app/areas/location/views/location-tab-integrations.view.html',
                    controller: 'LocationTabIntegrationsController as vm'
                }
            },
            resolve: {
                resolvedDMSData: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDMS($transition$.params().locationId);
                }],
                resolvedIntegrationData: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getIntegrations($transition$.params().locationId);
                }],
                resolvedTripTypInstances: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.hasRole($transition$.params().locationId, SYSTEM_ENUMS.permissionTypes.checkIn);
                }],
                resolvedRideProviderTripTypeInstanceDetails: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getRideProviderTripTypeInstances($transition$.params().locationId);
                }],
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Integrations (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-api', {
            parent: locationTabs,
            url: '/api',
            views: {
                'tab-api@': {
                    templateUrl: 'app/areas/location/views/location-tab-api.view.html',
                    controller: 'LocationTabAPIController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedPartnerPrograms: ["$q", "locationService", function ($q, locationService) {
                    let deferred = $q.defer();

                    locationService.getPartnerPrograms()
                        .then((result) => {
                            let partnerPrograms = Object.keys(result).map((k) => { return {value: parseInt(k), text: result[k]}; });

                            deferred.resolve(partnerPrograms);
                        });

                        return deferred.promise;
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'API Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-users', {
            parent: locationTabs,
            url: '/users',
            views: {
                'tab-users@': {
                    templateUrl: 'app/areas/location/views/location-tab-users.view.html',
                    controller: 'LocationTabUsersController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerEmployees: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getEmployees($transition$.params().locationId);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'User Access (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-user-permissions', {
            parent: locationTabs,
            url: '/userpermissions',
            views: {
                'tab-user-permissions@': {
                    templateUrl: 'app/areas/location/views/location-tab-user-permissions.view.html',
                    controller: 'LocationTabUserPermissionsController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                dealerId: ["$transition$", function ($transition$) {
                    return $transition$.params().locationId;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'User Access (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-drivers', {
            parent: locationTabs,
            url: '/drivers',
            views: {
                'tab-drivers@': {
                    templateUrl: 'app/areas/location/views/location-tab-drivers.view.html',
                    controller: 'LocationTabDriversController as vm'
                }
            },
            resolve: {
                resolvedDealerDrivers: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getDrivers($transition$.params().locationId);
                }],    
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }],                                     
                resolvedDriverCompanies: ["locationService", function (locationService) {
                    "ngInject";

                    return locationService.getDriverCompanies();
                }],
                resolvedDriverPrograms: ["locationService", function (locationService) {
                    "ngInject";

                    return locationService.getDriverPrograms();
                }],
                resolvedLocation: ["location", function(location) {
                    return location;
                }],
                pageTitle: ["parentTitle", "location", function (parentTitle, location) {
                    return 'Driver Access (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-booking', {
            parent: locationTabs,
            url: '/booking',
            views: {
                'tab-booking@': {
                    templateUrl: 'app/areas/location/views/location-tab-booking.view.html',
                    controller: 'LocationTabBookingController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedTripType: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getTripTypeBookingTab($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedAssociatedConfigs: ["$transition$", "SYSTEM_ENUMS", "resolvedTripType", "appointmentService", function($transition$, SYSTEM_ENUMS, resolvedTripType, appointmentService) {
                    if (resolvedTripType.systemTripTypeId === SYSTEM_ENUMS.systemTripType.appointment) {
                        return appointmentService.getBookingConfig($transition$.params().locationId);
                    } else {
                        return null;
                    }
                }],
                resolvedLocationTransportationTypes: ["$transition$", "locationService", "SYSTEM_ENUMS", "resolvedTripType", function ($transition$, locationService, SYSTEM_ENUMS, resolvedTripType) {
                    if (resolvedTripType.systemTripTypeId === SYSTEM_ENUMS.systemTripType.appointment) {
                        return locationService.getLocationTransportationTypes($transition$.params().locationId);
                    } else {
                        return null;
                    }
                }],
                tripProfileLookups: ["tripTypeService", function (tripTypeService) {
                    return tripTypeService.getTripProfiles();
                }],
                vehicleMakesModels: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getVehicleMakesModels($transition$.params().locationId);
                }],
                resolvedEmployees: ["$transition$", "employeeService", function ($transition$, employeeService) {
                    return employeeService.getConfiguredEmployeesByLocation($transition$.params().locationId);
                }],
                resolvedServiceAreaTypes: ["tripTypeService", function (tripTypeService) {
                    return tripTypeService.getServiceAreaTypes();
                }],
                resolvedVenues: ["$transition$", "locationService", function($transition$, locationService) {
                    return locationService.getVenues($transition$.params().locationId, true);
                }],
                resolvedDepartments: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDepartments($transition$.params().locationId, true);
                }],
                pageTitle: ["resolvedTripType", "location", "parentTitle", function (resolvedTripType, location, parentTitle) {
                    return 'Booking Settings: ' + resolvedTripType.name + ' (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-lineitems', {
            parent: locationTabs,
            url: '/lineitems',
            views: {
                'tab-lineitems@': {
                    templateUrl: 'app/areas/location/views/location-tab-lineitems.view.html',
                    controller: 'LocationTabLineItemsController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedTripType: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getTripTypeBookingTab($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedSystemOpCodes: ["locationService", function (locationService) {
                    return locationService.getSystemOpCodes();
                }],
                resolvedLocationOpCodes: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationOpCodes($transition$.params().locationId);
                }],
                resolvedLocationOpCodeConstraints: ["$transition$", "constraintService", "APPOINTMENT_CONSTRAINT_DEFINITION_TYPE", function ($transition$, constraintService, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE) {
                    return constraintService.getConstraintsByType($transition$.params().locationId, null, null, APPOINTMENT_CONSTRAINT_DEFINITION_TYPE.opCode);
                }],
                resolvedDepartments: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDepartments($transition$.params().locationId);
                }],
                resolvedDepartmentsWithAdvisors: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDepartments($transition$.params().locationId, true);
                }],
                resolvedDMSData: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getLocationDMS($transition$.params().locationId);
                }],
                pageTitle: ["resolvedTripType", "location", "parentTitle", function (resolvedTripType, location, parentTitle) {
                    return 'Line Item Settings: ' + resolvedTripType.name + ' (' + location.name + ') - ' + parentTitle;
                }],
                ctrlOptions: function () {
                    return {
                        adminView: false
                    };
                }
            }
        })

       .state('tab-tasks', {
           parent: locationTabs,
            url: '/tasks',
            views: {
                'tab-tasks@': {
                    templateUrl: 'app/areas/location/views/location-tab-tasks.view.html',
                    controller: 'LocationTabTasksController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedWorkFlows: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getLocationTripTypeWorkFlows($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedTaskTypes: ["$q", "locationService", function ($q, locationService) {
                    let deferred = $q.defer();

                    locationService.getTaskTypes()
                        .then((result) => {
                            let taskTypes = Object.keys(result).map((k) => { return {value: parseInt(k), text: result[k]}; });

                            deferred.resolve(taskTypes);
                        });

                    return deferred.promise;
                }],
                resolvedVehicleTypes: ["$q", "locationService", function ($q, locationService) {
                    let deferred = $q.defer();

                    locationService.getVehicleTypes()
                        .then((result) => {
                            let vehicleTypes = Object.keys(result).map((k) => { return {value: parseInt(k), text: result[k]}; });

                            deferred.resolve(vehicleTypes);
                        });

                    return deferred.promise;
                }],
                resolvedLocationsWithTripType: ["$transition$", "$q", "tripTypeService", function($transition$, $q, tripTypeService) {
                    let deferred = $q.defer();

                    tripTypeService.getDealersWithTripType($transition$.params().tripTypeId)
                        .then((dealers) => {
                            deferred.resolve(dealers);
                        });

                    return deferred.promise;
                }],
                pageTitle: ["$q", "tripTypeService", "location", "parentTitle", "$transition$", function ($q, tripTypeService, location, parentTitle, $transition$) {
                    let deferred = $q.defer();

                    tripTypeService.getTripTypeBookingTab($transition$.params().locationId, $transition$.params().tripTypeId)
                        .then((tripType) => {
                            deferred.resolve('Trip Tasks: ' + tripType.name + ' (' + location.name + ') - ' + parentTitle);
                        });

                    return deferred.promise;
                }]
            }
        })

        .state('tab-incentives', {
            parent: locationTabs,
             url: '/incentives',
             views: {
                 'tab-incentives@': {
                     templateUrl: 'app/areas/location/views/location-tab-incentives.view.html',
                     controller: 'LocationTabIncentivesController as vm'
                 }
             },
             resolve: {
                 resolvedLocation: ["location", function (location) {
                     return location;
                 }],
                 resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                 }],
                 resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                 }], 
                 resolvedIncentives: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getIncentives($transition$.params().locationId, $transition$.params().tripTypeId);
                 }],
                 pageTitle: function () {
                    return 'Incentive Settings';
                 }
             }
         })

        .state('tab-survey', {
            parent: locationTabs,
            url: '/survey',
            views: {
                'tab-survey@': {
                    templateUrl: 'app/areas/location/views/location-tab-survey.view.html',
                    controller: 'LocationTabSurveyController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedEmployees: ["$transition$", "employeeService", function ($transition$, employeeService) {
                    return employeeService.getConfiguredCCListEmployeesByLocation($transition$.params().locationId);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedTripType: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getTripTypeSurveyTab($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedSurveys: ["tripTypeService", function (tripTypeService) {
                    return tripTypeService.getSurveys();
                }],
                pageTitle: ["resolvedTripType", "location", "parentTitle", function (resolvedTripType, location, parentTitle) {
                    return 'Survey Settings: ' + resolvedTripType.name + ' (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-notifications', {
            parent: locationTabs,
            url: '/notifications',
            views: {
                'tab-notifications@': {
                    templateUrl: 'app/areas/location/views/location-tab-notifications.view.html',
                    controller: 'LocationTabNotificationsController as vm'
                }
            },
            resolve: {
                resolvedTripType: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getTripTypeNotificationsTab($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedNotifications: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    let notifications = null;

                    notifications = tripTypeService.getLocationTripTypeNotifications($transition$.params().locationId, $transition$.params().tripTypeId)
                        .catch((resp_error) => {
                            // notificatons are not on all trip types so we just continue on if there aren't any
                        });

                    return notifications;
                }],
                resolvedTripProfiles: ["tripTypeService", "$filter", function (tripTypeService, $filter) {
                    return tripTypeService.getTripProfiles().then((profiles) => {
                        return $filter('filter')(profiles, {type: 3});
                    });
                }],
                resolvedWorkFlows: ["$transition$", "tripTypeService", function ($transition$, tripTypeService) {
                    return tripTypeService.getLocationTripTypeWorkFlows($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedEmployees: ["$transition$", "employeeService", function ($transition$, employeeService) {
                    return employeeService.getConfiguredCCListEmployeesByLocation($transition$.params().locationId);
                }],
                resolvedInviteNotificationTemplates: ["$transition$", "tripTypeService", function($transition$, tripTypeService) {
                    return tripTypeService.getInviteNotificationTemplates($transition$.params().locationId, $transition$.params().tripTypeId);
                }],
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                pageTitle: ["resolvedTripType", "location", "parentTitle", function (resolvedTripType, location, parentTitle) {
                    return 'Notification Settings:  ' + resolvedTripType.name + ' (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('tab-ui', {
            parent: locationTabs,
            url: '/ui',
            views: {
                'tab-ui@': {
                    templateUrl: 'app/areas/location/views/location-tab-ui.view.html'
                }
            }
        })

        .state('tab-hours-other', {
            parent: locationTabs,
            url: '/hours-other',
            views: {
                'tab-hours-other@': {
                    templateUrl: 'app/areas/location/views/location-tab-hours-other.view.html'
                }
            }
        })

        .state('location-product-base',
        {
            parent: locationTabs,
            url: '/product/:productPermissionId',
            abstract: true
        })

        .state('location-product-settings', {
            parent: 'location-product-base',
            url: '/settings',
            views: {
                'location-product-settings@': {
                    templateUrl: 'app/areas/location/views/products/settings.view.html',
                    controller: 'LocationProductSettingsController as vm'
                }
            },
            resolve: {
                resolvedSettings: ["$transition$", "productSettingsService", function ($transition$, productSettingsService) {
                    return productSettingsService.getSettings($transition$.params().locationId, $transition$.params().productPermissionId);
                }],
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-product-automation', {
            parent: 'location-product-base',
            url: '/automation',
            views: {
                'location-product-automation@': {
                    templateUrl: 'app/areas/location/views/products/automation.view.html',
                    controller: 'LocationProductAutomationController as vm'
                }
            },
            resolve: {
                resolvedSettings: ["$transition$", "productSettingsService", function ($transition$, productSettingsService) {
                    return productSettingsService.getAutomationSettings($transition$.params().locationId, $transition$.params().productPermissionId);
                }],
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Automation (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-loaner-settings-notifications', {
            parent: 'location-product-base',
            url: '/loaner/settings/notifications',
            views: {
                'location-loaner-settings-notifications@': {
                    templateUrl: 'app/areas/location/views/loaner/settings/tab-loaner-notifications.view.html',
                    controller: 'LocationTabLoanerSettingsNotificationsController as vm'
                }
            },
            resolve: {
                resolvedSettings: ["$transition$", "loanerSettingsService", function ($transition$, loanerSettingsService) {
                    return loanerSettingsService.getNotificationSettings($transition$.params().locationId);
                }],
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Loaner Notification Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-loaner-settings-preferences', {
            parent: 'location-product-base',
            url: '/loaner/settings/preferences',
            views: {
                'location-loaner-settings-preferences@': {
                    templateUrl: 'app/areas/location/views/loaner/settings/tab-loaner-preferences.view.html',
                    controller: 'LocationTabLoanerSettingsPreferencesController as vm'
                }
            },
            resolve: {
                resolvedSettings: ["$transition$", "loanerSettingsService", function ($transition$, loanerSettingsService) {
                    return loanerSettingsService.getSettings($transition$.params().locationId);
                }],
                resolvedVehicleMakes: ["$transition$", "loanerSettingsService", function ($transition$, loanerSettingsService) {
                    return loanerSettingsService.getMakes($transition$.params().locationId);
                }],
                resolvedTripTypInstances: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Loaner Preferences (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-checkin-general', {
            parent: locationTabs,
            url: '/checkinGeneral',
            params: {
                productPermissionId: 16
            },
            views: {
                'location-checkin-general@': {
                    templateUrl: 'app/areas/location/views/checkin/general.view.html',
                    controller: 'LocationCheckinGeneralController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'CheckIn Settings: ' + ' (' + location.name + ') - ' + parentTitle;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedMediaConfigItems: ["$transition$", "locationService", function ($transition$, locationService) {
                    return locationService.getPredifinedMediaConfigs($transition$.params().locationId);
                }]
            }
        })

        // **** Inspect states ****
        .state('location-config-inspect-general', {
            parent: 'location-product-base',
            url: '/inspect/general',
            views: {
                'location-config-inspect-general@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-general.view.html',
                    controller: 'LocationTabInspectGeneralController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-config-inspect-formbuilder', {
            parent: 'location-product-base',
            url: '/inspect/formbuilder',
            views: {
                'location-config-inspect-formbuilder@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-formbuilder.view.html',
                    controller: 'LocationTabInspectFormBuilderController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                resolvedDealersWithInspect: ["dealerInspectionService", function (dealerInspectionService) {
                    return dealerInspectionService.getDealersWithCopyableInspectionForms();
                }],
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })
        
        .state('location-config-inspect-status', {
            parent: 'location-product-base',
            url: '/inspect/rostatus',
            views: {
                'location-config-inspect-status@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-rostatus.view.html',
                    controller: 'LocationTabInspectRoStatusController as vm'
                }
            },
            resolve: {                
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })
        
        .state('location-config-inspect-shopsupplies', {
            parent: 'location-product-base',
            url: '/inspect/shopsupplies',
            views: {
                'location-config-inspect-shopsupplies@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-roshopsupplies.view.html',
                    controller: 'LocationTabInspectRoShopSuppliesController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-config-inspect-shopflags', {
            parent: 'location-product-base',
            url: '/inspect/shopflags',
            views: {
                'location-config-inspect-shopflags@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-shopflags.view.html',
                    controller: 'LocationTabInspectShopFlagsController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-config-inspect-taxes', {
            parent: 'location-product-base',
            url: '/inspect/taxes',
            views: {
                'location-config-inspect-taxes@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-taxes.view.html',
                    controller: 'LocationTabInspectTaxesController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })
        
        .state('location-config-inspect-laborrates', {
            parent: 'location-product-base',
            url: '/inspect/laborrates',
            views: {
                'location-config-inspect-laborrates@': {
                    templateUrl: 'app/areas/location/views/inspect/tab-inspect-laborrates.view.html',
                    controller: 'LocationTabInspectLaborRatesController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        })

        .state('location-config-inspect-partsavailability', {
           parent: 'location-product-base',
           url: '/inspect/parts',
           views: {
               'location-config-inspect-partsavailability@': {
                   templateUrl: 'app/areas/location/views/inspect/tab-inspect-partsavailability.view.html',
                   controller: 'LocationTabInspectPartsAvailabilityController as vm'
                }
            },
            resolve: {
                resolvedLocation: ["location", function (location) {
                    return location;
                }],
                resolvedDealerTripTypes: ["dealerTripTypes", function (dealerTripTypes) {
                    return dealerTripTypes;
                }],
                resolvedHasCheckIn: ["dealerHasCheckin", function (dealerHasCheckin) {
                    return dealerHasCheckin;
                }], 
                pageTitle: ["location", "parentTitle", function (location, parentTitle) {
                    return 'Inspect Settings (' + location.name + ') - ' + parentTitle;
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.loaner')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {
        let loanerMain = {
                parent: 'app',
                url: '/loaners',
                permission: SYSTEM_ENUMS.permissionTypes.loaner,
                abstract: true,
                data: {},
                templateUrl: 'app/shared/layouts/content-only/content-only.view.html'
            };
            let fleetList = {
                parent: loanerMain,
                url: '/fleet',
                topLevel: true,
                data: {
                    displayName: 'Fleet'
                },
                //permission: SYSTEM_ENUMS.permissionTypes.contract,
                templateUrl: 'app/areas/loaner/views/vehicles/vehicles-list.view.html',
                controller: 'LoanerVehiclesListController as vm',
                resolve: {
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'Fleet - ' + parentTitle;
                    }],
                    searchMode: ['authService', 'localStorageService', function(authService, localStorageService) {
                        let currentUser = authService.getCurrentUser();

                        return localStorageService.get('selectedLoanerMode:' + currentUser.userId) || 'loaner-contracts-list';
                    }]
                },
                onEnter: ['searchMode', '$state', '$transition$', function (searchMode, $state, $transition$) {
                    // Use saved search mode only if we are on the list page
                    if ($state.name === 'loaner-vehicles-list' && $state.name !== searchMode) {
                        let params = {configId: $transition$.params().configId};
                        
                        $state.go(searchMode, params);
                    }
                }]
            };
            let contractList = {
                parent: loanerMain,
                url: '/contracts',
                topLevel: true,
                data: {
                    displayName: 'Contracts'
                },
                permission: SYSTEM_ENUMS.permissionTypes.contract,
                templateUrl: 'app/areas/loaner/views/contracts/contracts-list.view.html',
                controller: 'LoanerContractsListController as vm',
                resolve: {
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'Contracts - ' + parentTitle;
                    }],
                    searchMode: ['authService', 'localStorageService', function(authService, localStorageService) {
                        let currentUser = authService.getCurrentUser();

                        return localStorageService.get('selectedLoanerMode:' + currentUser.userId) || 'loaner-contracts-list';
                    }]
                },
                onEnter: ['searchMode', '$state', '$transition$', function (searchMode, $state, $transition$) {
                    // Use saved search mode only if we are on the list page
                    if ($state.name === 'loaner-contracts-list' && $state.name !== searchMode) {
                        let params = {configId: $transition$.params().configId};

                        $state.go(searchMode, params);
                    }
                }]
            };
            
            let reservationAdd = {
                abstract: false,
                url: '/create',
                parent: contractList,
                onEnter: ['$aside', '$log',  function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'loaner', 'reservations/reservations-add.view.html', 'LoanerReservationsAddController as vmPnl', {
                        resultedThingie: function() {
                            return null;
                        }
                    });
                }],
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'New Reservation - ' + parentTitle;
                    }]
                }
            };

            let reservationEdit = {
                abstract: false,
                parent: contractList,
                reloadOnSearch: false,
                url: '/:locationId/edit/:reservationId?activeTab',
                params: {
                    activeTab: {squash: true, value: null}
                },
                onEnter: ['$aside', '$log', '$transition$', 'resolvedLocation', function ($aside, $log, $transition$, resolvedLocation) {
                    rcAsideProvider.showAside($aside, $log, 'loaner', 'reservations/reservations-edit.view.html', 'LoanerReservationsEditController as vmPnl', {
                        $transition$: function () {
                            return $transition$;
                        },
                        resolvedLocation: function () {
                            return resolvedLocation;
                        },
                        activeTab: function () {
                            return 0;
                        },
                        resolvedParams: function () {
                            return {
                                activeTab: $transition$.params().activeTab,
                            };
                        }
                    }, null, true, 'transparent');
                }],
                views: {
                    'messages-customer@': {
                        templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                        controller: 'MessagesCustomerTabController as vm',
                    },
                    'messages-internal@': {
                        templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                        controller: 'MessagesInternalTabController as vm',
                    }
                },
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    resolvedLocation: ['$transition$', 'locationService', function ($transition$, locationService) {
                        return locationService.getLocationDetails($transition$.params().locationId);
                    }],
                    pageTitle: ['$transition$', 'parentTitle', function ($transition$, parentTitle) {
                        return 'Edit Reservation: ' + $transition$.params().reservationId + parentTitle;
                    }],
                    trip: function() {
                        return null;
                    },
                    appointment: function() {
                        return null;
                    },
                    contact: function() {
                        return null;
                    },
                    hasMessaging: ['$transition$', 'tripService', function ($transition$, tripService) {
                        return tripService.hasMessaging($transition$.params().locationId);
                    }]
                }
            };

            let contractAdd = {
                abstract: false,
                url: '/create',
                parent: contractList,
                onEnter: ['$aside', '$log', function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'loaner', 'contracts/contracts-new.view.html', 'LoanerContractsNewController as vm', {
                        resolvedLocations: ['repairOrderService', function (repairOrderService) {
                            return repairOrderService.getDealersForDropdown(SYSTEM_ENUMS.permissionTypes.loaner, false);
                        }]
                    });
                }],
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'New Contract - ' + parentTitle;
                    }]
                }
            };

            let vehicleAdd = {
                abstract: false,
                parent: fleetList,
                url: '/create',
                onEnter: ['$aside', '$log', '$transition$',  function ($aside, $log, $transition$) {
                    rcAsideProvider.showAside($aside, $log, 'loaner', 'vehicles/vehicles-add.view.html', 'LoanerVehiclesAddController as vm', {
                        $transition$: function () {
                            return $transition$;
                        },
                        resolvedLocations: ['repairOrderService', function (repairOrderService) {
                            return repairOrderService.getDealersForDropdown(SYSTEM_ENUMS.permissionTypes.loaner, false);
                        }],
                        resolvedDealerConfigurations: function () {
                            return null;
                        },
                        resolvedLocation: function () {
                            return null;
                        }
                    }, null, true, 'aside-sm');
                }],
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ['parentTitle', function (parentTitle) {
                        return 'New Vehicle - ' + parentTitle;
                    }]
                }
            };

            let vehicleEdit = {
                abstract: false,
                parent: fleetList,
                url: '/:locationId/edit/:vehicleId',
                onEnter: ['$aside', '$log', '$transition$', 'resolvedLocation', 'resolvedDealerConfigurations', function ($aside, $log, $transition$, resolvedLocation, resolvedDealerConfigurations) {
                    rcAsideProvider.showAside($aside, $log, 'loaner', 'vehicles/vehicles-add.view.html', 'LoanerVehiclesAddController as vm', {
                        $transition$: function () {
                            return $transition$;
                        },
                        resolvedLocations: ['repairOrderService', function (repairOrderService) {
                            return repairOrderService.getDealersForDropdown(SYSTEM_ENUMS.permissionTypes.loaner, false);
                        }],
                        resolvedDealerConfigurations: function () {
                            return resolvedDealerConfigurations;
                        },
                        resolvedLocation: function () {
                            return resolvedLocation;
                        }
                    }, null, true, 'aside-sm');
                }],
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {  
                    resolvedLocation: ['locationService', '$transition$', function (locationService, $transition$) {
                        let locationId = $transition$.params().locationId;

                        return locationService.getLocation(locationId);
                    }],   
                    resolvedDealerConfigurations: ['loanerService', '$transition$', function (loanerService, $transition$) {
                        return loanerService.loanerConfigurations($transition$.params().locationId);
                    }],     
                    pageTitle: ['$transition$', 'parentTitle', function ($transition$, parentTitle) {
                        return 'Edit Vehicle: ' + $transition$.params().vehicleId + parentTitle;
                    }]
                }
            };

            let vehicleSummary = {
                abstract: false,
                parent: fleetList,
                url: '/:locationId/summary/:vehicleId',
                onEnter: ['$aside', '$log', '$transition$', 'resolvedStatuses', function ($aside, $log, $transition$, resolvedStatuses) {
                    rcAsideProvider.showAside($aside, $log, 'loaner', 'vehicles/vehicles-summary.view.html', 'LoanerVehiclesSummaryController as vm', {
                        $transition$: function () {
                            return $transition$;
                        },
                        resolvedStatuses: function () {
                            return resolvedStatuses;
                        }
                    }, null, true, 'aside-sm');
                }],
                onExit: ['$log', function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {   
                    resolvedStatuses: ['loanerService', '$transition$', function (loanerService, $transition$) {
                        let locationId = $transition$.params().locationId;

                        return loanerService.getStatuses(locationId);
                    }],     
                    pageTitle: ['$transition$', 'parentTitle', function ($transition$, parentTitle) {
                        return 'Summary Vehicle: ' + $transition$.params().vehicleId + parentTitle;
                    }]
                }
            };

        $stateProvider
            .state('loaner', loanerMain)
            .state('loaner-vehicles-list', fleetList)
            .state('loaner-contracts-list', contractList)
            .state('loaner-contracts-add', contractAdd)
            .state('loaner-reservation-add', reservationAdd)
            .state('loaner-reservation-edit', reservationEdit)
            .state('loaner-vehicle-add', vehicleAdd)
            .state('loaner-vehicle-edit', vehicleEdit)
            .state('loaner-vehicle-summary', vehicleSummary);

            
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.inspect')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {
        let inspectBase = {
            parent: 'app',
            url: '/inspect?tabType&dealerId&roId&customerName&activeInspectTab',
            topLevel: true,
            permission: SYSTEM_ENUMS.permissionTypes.inspect,
            reloadOnSearch: false,
            data: {
                displayName: 'Inspect'
            },
            params: {
                tabType: {squash: true, value: null},
                dealerId: {squash: true, value: null},
                roId: {squash: true, value: null},
                customerName: {squash: true, value: null},
                activeInspectTab: {squash: true, value: null}
            },
            views: {
                '': {
                    templateUrl: 'app/areas/inspect/views/inspect-base.view.html',
                    controller: 'InspectBaseController as vm'
                },
                'messages-customer@inspect': {
                    templateUrl: 'app/shared/messages/views/messages-customer-tab.view.html',
                    controller: 'MessagesCustomerTabController as vm'
                },
                // 'messages-driver@': {
                //     templateUrl: 'app/shared/messages/views/messages-driver-tab.view.html',
                //     controller: 'MessagesDriverTabController as vm'
                // },
                // 'messages-monitor@': {
                //     templateUrl: 'app/shared/messages/views/messages-monitor-tab.view.html',
                //     controller: 'MessagesMonitorTabController as vm'
                // },
                'messages-notes@inspect': {
                    templateUrl: 'app/shared/messages/views/messages-notes-tab.view.html',
                    controller: 'MessagesNotesTabController as vm'
                },
                'messages-dealer-info@inspect': {
                    templateUrl: 'app/shared/messages/views/messages-dealer-info-tab.view.html',
                    controller: 'MessagesDealerInfoTabController as vm'
                },
                'messages-internal@inspect': {
                    templateUrl: 'app/shared/messages/views/messages-internal-tab.view.html',
                    controller: 'MessagesInternalTabController as vm'
                }
            },
            resolve: {
                // TODO: Do we need these resolves other than hasMessaging?
                appointment: function () {
                    return null;
                },
                trip: function () {
                    return null;
                },
                contact: function () {
                    return null;
                },
                hasMessaging: ['tripService', '$transition$', 'localStorageService', function (tripService, $transition$, localStorageService) {
                    let urlDealerId = $transition$.params().dealerId;
                    let storageServiceParams = localStorageService.get('cachedInspectSettings') || {};
                    let dealerId = urlDealerId || storageServiceParams.dealerId;
                    
                    if (dealerId) {
                        return tripService.hasMessaging(dealerId);
                    } else { 
                        return false;
                    }
                }]
            },
            userPermission: SYSTEM_ENUMS.permissionTypes.inspect
        };

        $stateProvider.state('inspect', inspectBase);
    
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.driver')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {
        let driverList = {
            parent: 'app',
            url: '/drivers',
            userPermission: SYSTEM_ENUMS.permissionTypes.drivers,
            data: {
                displayName: 'Drivers'
            },
            templateUrl: 'app/areas/driver/views/driver-list.view.html',
            controller: 'DriverListController as vm',
            resolve: {
                resolvedLocationList: ['locationService', function (locationService) {
                    return locationService.getLocationsForDropDown(false, false);
                }],
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'Drivers - ' + parentTitle;
                }]
            }
        };

        let driverEdit = {
            abstract: true,
            parent: driverList,
            url: '/:driverId/:driverAdded',
            params: {
                driverId: {squash: true, value: null},
                driverAdded: {squash: true, value: null}
            },
            onEnter: ['$aside', '$log', 'driver', function ($aside, $log, driver) {
                rcAsideProvider.showAside($aside, $log, 'driver', 'driver-edit.view.html', 'DriverEditController as vm', {
                    resolvedDriver: function () {
                        return driver;
                    }
                }, undefined, 'true', 'scroll-y-hidden');
            }],
            onExit: ['$log', 'driverService', function ($log, driverService) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                driver: ['driverService', '$transition$', function (driverService, $transition$) {
                    let editdriverId = $transition$.params().driverId;

                    return driverService.getDriver(editdriverId);
                }]
            }
        };

        let driverTabs = {
            parent: driverEdit,
            abstract: true,
            resolve: {
            }
        };

        $stateProvider
            .state('driver-list', driverList)

            .state('driver-add', {
                parent: driverList,
                url: '/add',
                onEnter: ["$aside", "$log", function ($aside, $log) {
                    rcAsideProvider.showAside($aside, $log, 'driver', 'driver-add.view.html', 'DriverAddController as vm', {
                        resolvedLocationList: ['locationService', function (locationService) {
                            return locationService.getLocationsForDropDown(false, false);
                        }],
                        resolvedCompanyList: ['driverService', function (driverService) {
                            return driverService.getCompanies();
                        }]
                    }, undefined, true);
                }],
                onExit: ["$log", function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'New Driver - ' + parentTitle;
                    }]
                }
            })

            .state('driver-edit', driverEdit)

            .state('driver-tabs', driverTabs)

            .state('driver-tab-general', {
                parent: driverTabs,
                url: '/general',
                views: {
                    'driver-tab-general@': {
                        templateUrl: 'app/areas/driver/views/driver-tab-general.view.html',
                        controller: 'DriverTabGeneralController as vm'
                    }
                },
                resolve: {
                    resolvedDriver: ["driver", function (driver) {
                        return driver;
                    }],
                    pageTitle: ["driver", "parentTitle", function (driver, parentTitle) {
                        return 'Driver Details (' + driver.name + ') - ' + parentTitle;
                    }]
                }
            })

            .state('driver-tab-security', {
                parent: driverTabs,
                url: '/security',
                views: {
                    'driver-tab-security@': {
                        templateUrl: 'app/areas/driver/views/driver-tab-security.view.html',
                        controller: 'DriverTabSecurityController as vm'
                    }
                },
                resolve: {
                    resolvedDriver: ["driver", function (driver) {
                        return driver;
                    }],
                    pageTitle: ["driver", "parentTitle", function (driver, parentTitle) {
                        return 'Driver Security (' + driver.name + ') - ' + parentTitle;
                    }]
                }
            })

            .state('driver-tab-locations', {
                parent: driverTabs,
                url: '/locations',
                views: {
                    'driver-tab-locations@': {
                        templateUrl: 'app/areas/driver/views/driver-tab-locations.view.html',
                        controller: 'DriverTabLocationsController as vm'
                    }
                },
                resolve: {
                    resolvedDriver: ["driver", function (driver) {
                        return driver;
                    }],
                    resolvedCompanyList: ['driverService', function (driverService) {
                        return driverService.getCompanies();
                    }],
                    resolvedLocationList: ["driver", "locationService", function (driver, locationService) {
                        return locationService.getLocations({excludeBlocked: true, driverId: driver.redCapDriverId, pageSize: 99999});
                    }],
                    pageTitle: ["driver", "parentTitle", function (driver, parentTitle) {
                        return 'Driver Locations (' + driver.name + ') - ' + parentTitle;
                    }]
                }
            })

            .state('driver-tab-settings', {
                parent: driverTabs,
                url: '/settings',
                views: {
                    'driver-tab-settings@': {
                        templateUrl: 'app/areas/driver/views/driver-tab-settings.view.html',
                        controller: 'DriverTabSettingsController as vm'
                    }
                },
                resolve: {
                    resolvedDriver: ["driver", function (driver) {
                        return driver;
                    }],
                    pageTitle: ["driver", "parentTitle", function (driver, parentTitle) {
                        return 'Driver Settings (' + driver.name + ') - ' + parentTitle;
                    }]
                }
            })
            
            
            .state('driver-tab-certifications', {
                parent: driverTabs,
                url: '/certifications',
                views: {
                    'driver-tab-certifications@': {
                        templateUrl: 'app/areas/driver/views/driver-tab-certifications.view.html',
                        controller: 'DriverTabCertificationsController as vm'
                    }
                },
                resolve: {
                    resolvedDriver: ["driver", function(driver) {
                        return driver;
                    }],
                    resolvedCertifications: ["driver", "driverService", function (driver, driverService) {
                        return driverService.getCertifications(driver.redCapDriverId);
                    }],
                    pageTitle: ["driver", "parentTitle", function (driver, parentTitle) {
                        return 'Driver Certifications (' + driver.name + ') - ' + parentTitle;
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

        routeConfig.$inject = ["$stateProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular.module('redcap.enrollment')
        .config(routeConfig);

    function routeConfig($stateProvider, rcAsideProvider, SYSTEM_ENUMS) {

        var enrollmentList = {
            parent: 'app',
            url: '/enrollments',
            data: {
                displayName: 'Enrollment'
            },
            templateUrl: 'app/areas/enrollment/views/enrollment-list.view.html',
            controller: 'EnrollmentListController as vm',
            userPermission: SYSTEM_ENUMS.permissionTypes.enrollment,
            resolve: {
                resolvedEnrollmentList: ['enrollmentService', function(enrollmentService) {
                    "ngInject";
                    return enrollmentService.getCode();
                }],
                resolvedEnrollmentPrograms: ['enrollmentService', function(enrollmentService) {
                    "ngInject";
                    return enrollmentService.getPrograms();
                }],
                pageTitle: ['parentTitle', function(parentTitle) {
                    return 'Enrollments - ' + parentTitle;
                }]
            }
        };

        var enrollmentAdd = {
            abstract: true,
            parent: enrollmentList,
            onEnter: ['$aside', '$log', function ($aside, $log) {
                rcAsideProvider.showAside($aside, $log, 'enrollment', 'enrollment-add.view.html', 'EnrollmentAddController as vm');
            }],
            onExit: ['$log', function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                pageTitle: ['parentTitle', function (parentTitle) {
                    return 'New Enrollment - ' + parentTitle;
                }]
            }
        };

        $stateProvider


            // ***************** MOBILE ****************** //
            .state('enrollment-mobile-parent', {
                abstract: true,
                public: true,
                views: {
                    'layout@': {
                        templateUrl: 'app/shared/layouts/content-only/content-only.view.html',
                        controller: 'EnrollmentController as vm'
                    }
                }
            })

            .state('enrollment-mobile',  {
                parent: 'enrollment-mobile-parent',
                public: true,
                url: '/:configId/enrollment-mobile?guid',
                templateUrl: 'app/areas/enrollment/views/enrollment-mobile.view.html',
                controller: 'EnrollmentMobileController as vm',
                resolve: {
                    redirectDesktop: ["$q", "$timeout", "$state", "$transition$", "deviceDetector", function ($q, $timeout, $state, $transition$, deviceDetector) {
                        var deferred = $q.defer();

                        $timeout(function () {
                            if (!deviceDetector.isMobile()) {
                                deferred.reject();
                                $state.go('enrollment-welcome', { configId: $transition$.params().configId, guid: $transition$.params().guid });
                            } else
                                deferred.resolve();
                        });

                        return deferred.promise;
                    }],
                    resolvedConfig: ["$state", "$transition$", "enrollmentService", function ($state, $transition$, enrollmentService) {
                        var configId = $transition$.params().configId;
                        return enrollmentService.getConfigValues(configId)
                            .then(function (result) {
                                if (_.isNil($transition$.params().guid))
                                    $state.go('enrollment-welcome', { configId: configId });

                                result.guid = $transition$.params().guid;
                                return result;
                            });
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Enrollment';
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Welcome - ' + parentTitle;
                    }]
                }
            })


            // ***************** DESKTOP ****************** //
            .state('enrollment-desktop-parent', {
                abstract: true,
                public: true,
                views: {
                    'layout@': {
                        templateUrl: 'app/shared/layouts/enrollment/enrollment-topnav.view.html',
                        controller: 'EnrollmentController as vm'
                    }
                }
            })

            .state('enrollment-sso', {
                parent: 'public',
                public: true,
                url: '/sso-enrollment?dId&dName&st&city&state&zip&lat&lng&redId',
                templateUrl: 'app/areas/enrollment/views/sso-enroll.view.html',
                controller: 'SSOEnrollmentController as vm',
                resolve: {
                    resolvedDealer: ["$transition$", "$rootScope", "$state", "resolvedConfig", "authService", function ($transition$, $rootScope, $state, resolvedConfig, authService) {
                        authService.isAuthenticated();

                        $rootScope.config = resolvedConfig;

                        var dealer = {
                            id:                 $transition$.params().dId,
                            name:               $transition$.params().dName,
                            streetAddress:      $transition$.params().st,
                            city:               $transition$.params().city,
                            state:              $transition$.params().state,
                            zip:                $transition$.params().zip,
                            countryShortCode:   $transition$.params().country || 'USA',
                            lat:                $transition$.params().lat,
                            lng:                $transition$.params().lng
                        };

                        if (typeof dealer.id === 'undefined' ||
                            typeof dealer.name === 'undefined' ||
                            typeof dealer.streetAddress === 'undefined' ||
                            typeof dealer.city === 'undefined' ||
                            typeof dealer.state === 'undefined' ||
                            typeof dealer.zip === 'undefined' ||
                            typeof dealer.lat === 'undefined' ||
                            typeof dealer.lng === 'undefined')
                            {
                                $state.go('access-denied');
                            }

                        return dealer;
                    }],
                    resolvedConfigId: ["$state", "$transition$", "enrollmentService", function ($state, $transition$, enrollmentService) {
                        return $transition$.params().configId;
                    }]
                }
            })

            .state('enrollment-sso-edit', {
                parent: 'public',
                public: true,
                url: '/sso-enrollment/:dealerId/edit',
                templateUrl: 'app/areas/enrollment/views/sso-enroll.view.html',
                controller: 'SSOEnrollmentEditController as vm',
                resolve: {
                    resolvedPartnerDealer: ["$transition$", "enrollmentService", "authService", function ($transition$, enrollmentService, authService) {
                        authService.isAuthenticated();
                        return enrollmentService.getSsoDealer($transition$.params().dealerId);
                    }]
                }
            })

            .state('enrollment-sso-ok',  {
                parent: 'public',
                public: true,
                url: '/sso-enrollment-complete?errorId?partnerDealerId',
                templateUrl: 'app/areas/enrollment/views/sso-enroll-ok.view.html',
                controller: 'SSOEnrollmentOkController as vm',
                resolve: {
                    resolvedError: ["$transition$", function($transition$) {
                        var stringErrorId = $transition$.params().errorId;
                        if (stringErrorId && stringErrorId !== '')
                            return parseInt(stringErrorId);

                        return null;
                    }],
                    resolvedPartnerDealerId: ["$transition$", function ($transition$) {
                        return $transition$.params().partnerDealerId || null;
                    }],
                    resolvedUberUpdateMessage: ['enrollmentService', function (enrollmentService) {
                        return enrollmentService.getUberUpdateMessage() || '';
                    }]
                }
            })

            .state('enrollment-provisioned', {
                parent: 'public',
                public: true,
                url: '/sso-enrollment-provisioned?allowedStartTime',
                templateUrl: 'app/areas/enrollment/views/sso-enroll-provisioned.view.html',
                controller: 'SSOEnrollmentProvisionedController as vm',
                resolve: {
                    resolvedAllowedStartTime: ["$transition$", function($transition$) {
                        var allowedStartTime = $transition$.params().allowedStartTime;

                        return moment.utc(allowedStartTime);
                    }]
                }
            })

            .state('enrollment-welcome', {
                parent: 'enrollment-desktop-parent',
                public: true,
                url: '/:configId/welcome?guid',
                templateUrl: 'app/areas/enrollment/views/welcome.view.html',
                controller: 'EnrollmentWelcomeController as vm',
                resolve: {
                    redirectMobile: ["$q", "$timeout", "$state", "$transition$", "deviceDetector", function ($q, $timeout, $state, $transition$, deviceDetector) {
                        var deferred = $q.defer();

                        $timeout(function () {
                            if (deviceDetector.isMobile()) {
                                deferred.reject();
                                $state.go('enrollment-mobile', { configId: $transition$.params().configId, guid: $transition$.params().guid });
                            } else
                                deferred.resolve();
                        });

                        return deferred.promise;
                    }],
                    resolvedConfig: ["$transition$", "enrollmentService", function ($transition$, enrollmentService) {
                        var configId = $transition$.params().configId;
                        return enrollmentService.getConfigValues(configId)
                            .then(function (result) {
                                result.guid = $transition$.params().guid;
                                return result;
                            });
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Enrollment';
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Welcome - ' + parentTitle;
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })

            .state('enrollment-wizard', {
                parent: 'enrollment-desktop-parent',
                public: true,
                url: '/:configId/enroll?guid',
                templateUrl: 'app/areas/enrollment/views/enrollment.view.html',
                controller: 'EnrollmentWizardController as vm',
                resolve: {
                    redirectMobile: ["$q", "$timeout", "$state", "$transition$", "deviceDetector", function ($q, $timeout, $state, $transition$, deviceDetector) {
                        var deferred = $q.defer();

                        $timeout(function () {
                            if (deviceDetector.isMobile()) {
                                deferred.reject();
                                $state.go('enrollment-mobile', { configId: $transition$.params().configId, guid: $transition$.params().guid });
                            } else
                                deferred.resolve();
                        });

                        return deferred.promise;
                    }],
                    resolvedConfig: ["$state", "$transition$", "enrollmentService", function ($state, $transition$, enrollmentService) {
                        var configId = $transition$.params().configId;
                        return enrollmentService.getConfigValues(configId)
                            .then(function (result) {
                                if (_.isNil($transition$.params().guid))
                                    $state.go('enrollment-welcome', { configId: configId });

                                result.guid = $transition$.params().guid;
                                return result;
                            });
                    }],
                    resolvedKey: ["$state", "$transition$", "$q", "resolvedConfig", "enrollmentService", function ($state, $transition$, $q, resolvedConfig, enrollmentService) {
                        var deferred = $q.defer();

                        enrollmentService.hasKey(resolvedConfig.id)
                            .then(function (result) {
                                if (!result) {
                                    $state.go('enrollment-welcome', { configId: resolvedConfig.id, guid: resolvedConfig.guid });
                                    deferred.reject();
                                } else
                                    deferred.resolve();
                            }, function (rejected) {
                                $state.go('enrollment-welcome', { configId: resolvedConfig.id, guid: resolvedConfig.guid });
                                deferred.reject();
                            });

                        return deferred.promise;
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Enrollment';
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Enroll Dealership - ' + parentTitle;
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })

            .state('enrollment-contract', {
                parent: 'enrollment-desktop-parent',
                public: true,
                url: '/:configId/contract/:guid?email',
                templateUrl: 'app/areas/enrollment/views/enrollment-contract.view.html',
                controller: 'EnrollmentContractController as vm',
                resolve: {
                    resolvedContract: ["$q", "$transition$", "$state", "enrollmentService", function ($q, $transition$, $state, enrollmentService) {
                        var guid = $transition$.params().guid;
                        var deferred = $q.defer();

                        enrollmentService.contractDetails(guid)
                            .then(function (result) {
                                if (result.contractSigned) {
                                    $state.go('enrollment-signed', { configId: $transition$.params().configId, guid: guid });
                                    deferred.reject();
                                } else  {
                                    deferred.resolve(result);
                                }
                            }, function (rejected) {
                                deferred.reject();
                            });

                        return deferred.promise;
                    }],
                    resolvedConfig: ["$transition$", "enrollmentService", function ($transition$, enrollmentService) {
                        var configId = $transition$.params().configId;
                        return enrollmentService.getConfigValues(configId)
                            .then(function (result) {
                                result.guid = $transition$.params().guid;
                                return result;
                            });
                    }],
                    resolvedEmail: ["$transition$", function ($transition$) {
                        return $transition$.params().email;
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Enrollment';
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Agreement - ' + parentTitle;
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })

            .state('enrollment-contract-thankyou', {
                parent: 'enrollment-desktop-parent',
                public: true,
                url: '/:configId/contract-complete',
                templateUrl: 'app/areas/enrollment/views/enrollment-contract-thankyou.view.html',
                controller: 'EnrollmentContractCompleteController as vm',
                resolve: {
                    resolvedConfig: ["$transition$", "enrollmentService", function ($transition$, enrollmentService) {
                        var configId = $transition$.params().configId;
                        return enrollmentService.getConfigValues(configId)
                            .then(function (result) {
                                result.guid = $transition$.params().guid;
                                result.title = 'Setup Complete';
                                result.body = 'Thank you for completing the process to setup your dealership. The contracts you signed have been emailed to you.';
                                return result;
                            });
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Enrollment';
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Setup Complete - ' + parentTitle;
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })

            .state('enrollment-signed', {
                parent: 'enrollment-desktop-parent',
                public: true,
                url: '/:configId/contract-signed',
                templateUrl: 'app/areas/enrollment/views/enrollment-contract-thankyou.view.html',
                controller: 'EnrollmentContractCompleteController as vm',
                resolve: {
                    resolvedConfig: ["$transition$", "enrollmentService", function ($transition$, enrollmentService) {
                        var configId = $transition$.params().configId;
                        return enrollmentService.getConfigValues(configId)
                            .then(function (result) {
                                result.guid = $transition$.params().guid;
                                result.title = 'You\'re all set.';
                                result.body = 'You have submitted your contract. Please check your email for a signed copy.';
                                return result;
                            });
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Enrollment';
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Setup Complete - ' + parentTitle;
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })


            // ***************** ADMIN ****************** //
            .state('enrollment-list', enrollmentList)

            .state('enrollment-edit', {
                parent: enrollmentList,
                url: '/:guid/edit',
                onEnter: ["$aside", "$log", "code", function ($aside, $log, code) {
                    rcAsideProvider.showAside($aside, $log, 'enrollment', 'enrollment-edit.view.html', 'EnrollmentEditController as vm', {
                        resolvedCode: function () {
                            return code;
                        }
                    });
                }],
                onExit: ["$log", function ($log) {
                    rcAsideProvider.destroyAside($log);
                }],
                resolve: {
                    code: ["enrollmentService", "$transition$", function (enrollmentService, $transition$) {
                        var guid = $transition$.params().guid;
                        return enrollmentService.getCode(guid);
                    }],
                    pageTitle: ["parentTitle", "code", function (parentTitle, code) {
                        return code.dealerName + ' - ' + parentTitle;
                    }]
                }
            })

            .state('enrollment-add', enrollmentAdd)

            .state('enrollment-add-single', {
                parent: enrollmentAdd,
                url: '/add-single',
                views: {
                    'enrollment-add-single@': {
                        templateUrl: 'app/areas/enrollment/views/enrollment-add-single.view.html',
                        controller: 'EnrollmentAddSingleController as vm'
                    }
                },
                resolve: {
                    resolvedConfigList: ["enrollmentService", function (enrollmentService) {
                        "ngInject";
                        return enrollmentService.getConfigs();
                    }]
                }
            })

            .state('enrollment-add-batch', {
                parent: enrollmentAdd,
                url: '/add-batch',
                views: {
                    'enrollment-add-batch@': {
                        templateUrl: 'app/areas/enrollment/views/enrollment-add-batch.view.html',
                        controller: 'EnrollmentAddBatchController as vm'
                    }
                },
                resolve: {
                    resolvedConfigList: ["enrollmentService", function (enrollmentService) {
                        "ngInject";
                        return enrollmentService.getConfigs();
                    }]
                }
            });
        }
})();

(function () {
    'use strict';

    consumerApi.$inject = ["$log", "$http", "$rootScope", "$timeout", "$q", "$state", "toastr", "consumerAuthService", "localStorageService", "API_SETTINGS"];
    angular
        .module('redcap.consumer')
        .service('consumerApi', consumerApi);

    function consumerApi($log, $http, $rootScope, $timeout, $q, $state, toastr, consumerAuthService, localStorageService, API_SETTINGS) {
        let loadingTimeout = null;

        return {
            get: get,
            post: post,
            put: put,
            remove: remove,
            postFile: postFile
        };

        function get(url, params, cancelPromise, headers, hideToastr) {
            let getRequest = {method: 'GET', url: url, params: params, warningAfter: 2000};

            if (cancelPromise) {
                getRequest.timeout = cancelPromise;
            }

            getRequest.headers = headers || {};

            return doHttpRequest(getRequest, hideToastr);
        }

        function post(url, data, headers, hideToastr, cancelPromise) {
            let postRequest = {method: 'POST', url: url, data: data, warningAfter: 2000};

            if (cancelPromise) {
                postRequest.timeout = cancelPromise;
            }

            postRequest.headers = headers || {};

            return doHttpRequest(postRequest, hideToastr);
        }

        function postFile(url, data, hideToastr) {
            return doHttpRequest({
                method: 'POST',
                url: url,
                data: data,
                warningAfter: 60000,
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular.identity
            }, hideToastr);
        }

        function put(url, data, cancelPromise, headers) {
            let putRequest = {method: 'PUT', url: url, data: data, warningAfter: 2000};

            putRequest.headers = headers || {};

            return doHttpRequest(putRequest, cancelPromise);
        }

        function remove(url, data, headers) {
            let deleteRequest = {method: 'DELETE', url: url, data: data, warningAfter: 2000};

            deleteRequest.headers = headers || {};

            Object.assign(deleteRequest.headers, {'Content-Type': 'application/json'});

            return doHttpRequest(deleteRequest);
        }

        function addRequest() {
            if ($rootScope.requestCount == null)
                $rootScope.requestCount = 0;

            $rootScope.requestCount++;
            if ($rootScope.requestCount > 0)
                $rootScope.isDataLoading = true;
        }

        function removeRequest() {
            $rootScope.requestCount--;

            if ($rootScope.requestCount == 0) {
                loadingTimeout && $timeout.cancel(loadingTimeout);
                loadingTimeout = $timeout(() => {               // this will give animations at least 1 second to complete
                    $rootScope.isDataLoading = false;
                }, 1000);
            }
        }

        function completeHttpRequest(req, hideToastr, authData) {
            req.headers.Authorization = 'Bearer ' + authData.token;

            // Add timeout to request
            addRequest(req);

            return $http(req).then((resp_success) => {
                let data = resp_success.data;
                let result = data == null ? null : data.result || data;

                return result;
            }).catch((resp_error) => {
                if (resp_error) {
                    let responseData = resp_error.data || {};

                    $log.error('rcApi-$http.catch(resp_error): status="' + resp_error.status + '", statusText="' + resp_error.statusText + '"');

                    if (responseData.modelState) {
                        responseData.modelErrors = parseModelErrors(responseData.modelState);
                    } else {
                        responseData.modelErrors = [];
                        // Use the exception message if it exists, otherwise use the message
                        let message = responseData.exceptionMessage || responseData.message;

                        responseData.modelErrors.push(message || resp_error.statusText);
                    }

                    if (resp_error.status !== -1 && hideToastr !== true && ($rootScope.config && !$rootScope.config.hideToastr))
                        toastr.error(_.join(responseData.modelErrors, '<br/>'), {allowHtml: true, timeOut: 5000});
                } else {
                    $log.error('rcApi: unknown error');

                    if (hideToastr !== true && ($rootScope.config && !$rootScope.config.hideToastr)) {
                        toastr.error('Unknown error', {timeOut: 5000});
                    }
                }

                return $q.reject(resp_error);
            }).finally((response) => {
                removeRequest();
            });
        }

        function doHttpRequest(req, hideToastr) {
            if (req.url.indexOf(API_SETTINGS.apiServiceBaseUri) === -1) {
                req.url = API_SETTINGS.apiServiceBaseUri + req.url;
            }

            $log.debug('rcApi - doHttp: ' + req.method + ' - req.url: ' + req.url);

            req.headers = req.headers || {};

            return consumerAuthService.isAuthenticated().then((_authData) => {
                return completeHttpRequest(req, hideToastr, _authData);
            }, () => {
                return consumerAuthService.login().then((_authData) => {
                    return completeHttpRequest(req, hideToastr, _authData);
                });
            });
        }

        function parseModelErrors(modelState) {
            let errors = [];

            for (let key in modelState) {
                for (let i = 0; i < modelState[key].length; i++) {
                    errors.push(modelState[key][i]);
                }
            }

            return errors;
        }
    }
})();

(function () {
    'use strict';

    consumerAuthService.$inject = ["$rootScope", "$q", "$log", "$state", "$http", "$interval", "toastr", "localStorageService", "API_SETTINGS", "permissions"];
    angular
        .module('redcap.consumer.components')
        .factory('consumerAuthService', consumerAuthService);

    function consumerAuthService($rootScope, $q, $log, $state, $http, $interval, toastr, localStorageService, API_SETTINGS, permissions) {
        var serviceBase = API_SETTINGS.apiServiceBaseUri,
            _isCallbackBusy = false,
            _refreshAccessTokenIntervalPromise,
            _refreshAccessTokenFailedCount = 0,
            _tutorialCheckedTime = null,
            _authData = {
                token: null,
                token_expireSeconds: 0,
                refresh_token_time: 0,
                refreshToken: null,
                refreshToken_expires: null,
                useRefreshTokens: false
            };

        return {
            login: login,
            logout: logout,
            authData: _authData,
            isAuthenticated: isAuthenticated
        };

        function login() {

            // reset failed token refresh count
            _refreshAccessTokenFailedCount = 0;

            var data = "grant_type=password&username=consumer@getredcap.com&password=cpECRcFkg4QedLXsuIhQ"
                     + "&client_id=" + API_SETTINGS.clientId + "&client_secret=" + API_SETTINGS.clientSecret;

            var deferred = $q.defer();

            $rootScope.isDataLoading = true;

            $http.post(serviceBase + 'OAuth/Token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                .then(function (response) {
                    populateAuthDataFromResponse(response.data, true);

                    startRefreshAccessTokenInterval(10);

                    $rootScope.isDataLoading = false;
                    deferred.resolve(_authData);

                }).catch(function (err, status) {
                    var errMsg = err && err.data && err.data.error_description || 'Login failure';
                    $rootScope.isDataLoading = false;
                    deferred.reject(err.data);
                });

            return deferred.promise;
        }

        function logout() {
            $log.debug('auth-service: logout()');

            localStorageService.remove('publicAuthorizationData');

            cancelRefreshAccessTokenInterval();
        }

        function isAuthenticated() {
            // $log.debug('auth-service: isAuthenticated() - called');

            var deferred = $q.defer();

            if (!_authData || !_authData.token) {
                var savedAuthData = localStorageService.get('publicAuthorizationData');

                if (savedAuthData) {
                    $log.debug('auth-service: isAuthenticated() - authData restored from local storage');
                    _authData = savedAuthData;
                }
            }

            var forceTokenRefresh = !permissions.arePermissionsSet();

            if (_authData) {
                if (_authData.useRefreshTokens) {
                    var refreshByMoment = moment().utc(),
                        accessTokenExpiresMoment = moment(_authData.token_expires),
                        refreshTokenExpiresMoment = moment(_authData.refreshToken_expires);

                    // $log.debug('auth-service: isAuthenticated() - Current UTC = ' + moment().utc().toISOString());
                    // $log.debug('auth-service: isAuthenticated() - accessTokenExpiresMoment = ' + accessTokenExpiresMoment.toISOString());
                    // $log.debug('auth-service: isAuthenticated() - refreshTokenExpiresMoment = ' + refreshTokenExpiresMoment.toISOString());

                    if (moment(accessTokenExpiresMoment).isAfter(refreshTokenExpiresMoment)) {
                        refreshByMoment = refreshTokenExpiresMoment;
                    } else {
                        refreshByMoment = accessTokenExpiresMoment;
                    }

                    // $log.debug('auth-service: isAuthenticated() - refreshByMoment = ' + refreshByMoment.toISOString());

                    var refreshByMomentLapsed = moment().utc().isAfter(refreshByMoment.subtract(30, 'seconds'));

                    if (refreshByMomentLapsed) {

                        var refreshTokenExpired = moment().utc().isAfter(refreshTokenExpiresMoment.subtract(15, 'seconds'));

                        if (refreshTokenExpired) {
                            $log.debug('auth-service: isAuthenticated() - we had auth data, but the refresh token has expired; Result: NOT Authenticated');
                            deferred.reject();
                        } else {
                            $log.debug('auth-service: isAuthenticated() - we have auth data and valid refresh token; Refresh the access token...');

                            refreshAccessToken().then(function (authData) {
                                _authData = authData;
                                deferred.resolve(authData);
                            }, function (err) {
                                deferred.reject(err);
                            });
                        }
                    } else {
                        // we still have a valid access token - make sure the Interval is still set
                        if (_refreshAccessTokenIntervalPromise) {
                            // we are still authenticated with no risk of not refreshing the access token
                            // tell the UI router or calling code we are good
                            $log.debug('auth-service: isAuthenticated() - we have auth data and the access token is still valid; Result: Authenticated');

                            if (forceTokenRefresh) {
                                refreshAccessToken().then(function (authData) {
                                    _authData = authData;
                                    deferred.resolve(authData);
                                }, function (err) {
                                    deferred.reject(err);
                                });
                            } else {
                                deferred.resolve(_authData);
                            }
                        } else {
                            // we still have an access token, but no refresh token Interval set -
                            // allow the current access token to be used, but immediately refresh it
                            $log.debug('auth-service: isAuthenticated() - we have auth data and the access token is still valid, but no $interval was set; Result: Authenticated with refresh needed');

                            refreshAccessToken().then(function (authData) {
                                _authData = authData;
                                deferred.resolve(authData);
                            }, function (err) {
                                deferred.reject(err);
                            });
                        }
                    }
                } else {
                    $log.debug('auth-service: isAuthenticated() - we had auth data, but no refresh token; Result: NOT Authenticated');
                    deferred.reject();
                }
            } else {
                $log.debug('auth-service: isAuthenticated() - no auth data in local storage; Result: NOT Authenticated');
                deferred.reject();
            }

            return deferred.promise;
        }

        function refreshAccessToken() {
            $log.debug('auth-service: refreshAccessToken() - attempting to get new access token');

            var deferred = $q.defer(),
                savedAuthData = localStorageService.get('publicAuthorizationData');

            if (savedAuthData) {

                var data = "grant_type=refresh_token&refresh_token=" + savedAuthData.refreshToken + "&client_id=" + API_SETTINGS.clientId + "&client_secret=" + API_SETTINGS.clientSecret;

                $http.post(serviceBase + 'OAuth/Token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {

                    localStorageService.remove('publicAuthorizationData');

                    // $log.debug('auth-service: Token Refreshed: ', response);

                    populateAuthDataFromResponse(response.data, true);

                    $log.debug('auth-service: Access Token has been refreshed.');
                    //toastr.success('Your token was successfully refreshed.');

                    // reset failed token refresh count
                    _refreshAccessTokenFailedCount = 0;

                    // ensure token is refreshed by making sure interval is still set OR
                    // start it if this is being called from ui router resolve : authenticate
                    if (!_refreshAccessTokenIntervalPromise) {
                        startRefreshAccessTokenInterval(10);
                    }

                    deferred.resolve(_authData);

                }).catch(function (err, status) {

                    _refreshAccessTokenFailedCount++;

                    $log.debug('auth-service: Error on refresh access token post: ', err.data, status);
                    $log.debug('auth-service: Refresh access token failure count: ', _refreshAccessTokenFailedCount);

                    if (err && err.data && err.data.error_description) {
                        toastr.error('Authentication Error: ' + err.data.error_description);
                    } else {
                        toastr.error('Unknown Authentication Error Occurred!');
                    }

                    if (_refreshAccessTokenFailedCount < 60) {
                        startRefreshAccessTokenInterval(10);    // restart the interval to try again
                    } else {
                        $log.debug('Too many re-authentication failures have occurred. Cancelling interval. User must manually log back in.');
                        toastr.error('Too many re-authentication failures have occurred. You must manually log back in.');
                    }

                    deferred.reject(err.data);
                });
            } else {
                $log.debug('WARNING: NO AUTH DATA EXISTS INCLUDING REFRESH TOKEN FROM LOCAL STORAGE');
                logout();

                deferred.reject();
            }

            return deferred.promise;
        }

        function refreshAccessTokenCallback() {
            if (_isCallbackBusy) {
                return;
            }

            _isCallbackBusy = true;

            // check to see if we need to refresh the access token by calling the isAuthenticated() function
            isAuthenticated().then(function () {
                _isCallbackBusy = false;
            });
        }

        function populateAuthDataFromResponse(response, useRefreshTokens) {
                // set access token expiry time date/time UTC stamp
            var accessTokenExpiresUtc = moment().utc().add(response.expires_in, 'seconds'),
                // get refresh token expiration date/time UTC stamp
                refreshTokenExpires = response["as:refresh_token_expires"];

            if (!_tutorialCheckedTime) {
                _tutorialCheckedTime = localStorageService.get('tutorialCheckedTime');
            }
            _authData.token = response.access_token;
            _authData.token_expireSeconds = response.expires_in;
            _authData.token_expires = accessTokenExpiresUtc;
            _authData.requiresPasswordChange = response.requiresPasswordChange == 'true';

            _authData.userInfo = {};

            if (response.userId) {
                _authData.userInfo.userId = response.userId;
            }

            if (response.userName) {
                _authData.userInfo.username = response.userName;
            }

            if (response.fullName) {
                _authData.userInfo.fullName = response.fullName;
            }

            if (response.profileImageUrl) {
                _authData.userInfo.profileImageUrl = response.profileImageUrl;
            }

            if (response.title) {
                _authData.userInfo.title = response.title;
            }

            permissions.setRoles(response.roles);
            permissions.setUserPermissions(response.userPermissions);
            permissions.setDealerPermissions(response.dealerPermissions);
            permissions.setPermissionsMarketingURLs(response.permissionMarketingURLs);
            permissions.setDisabledProductsToShowInNav(response.disabledProductsToShowInNav);

            if (useRefreshTokens && refreshTokenExpires) {
                // If refresh_token isn't supplied in the response, use existing refresh token
                _authData.refreshToken = response.refresh_token ? response.refresh_token : _authData.refreshToken;
                _authData.refreshToken_expires = refreshTokenExpires;
                _authData.useRefreshTokens = true;
            } else {
                _authData.refreshToken = null;
                _authData.refreshToken_expires = null;
                _authData.useRefreshTokens = false;
            }

            localStorageService.set('publicAuthorizationData', _authData);
        }

        function cancelRefreshAccessTokenInterval() {
            // cancel any $interval for token refresh in the authService
            if (_refreshAccessTokenIntervalPromise) {
                var cancelResult = $interval.cancel(_refreshAccessTokenIntervalPromise);

                if (cancelResult) {
                    _refreshAccessTokenIntervalPromise = null;
                    _isCallbackBusy = false;
                    $log.debug('auth-service: refresh access token $interval has been cancelled');
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }

        function startRefreshAccessTokenInterval(intervalSeconds) {
            if (_authData && _authData.refreshToken && cancelRefreshAccessTokenInterval()) {

                if (!intervalSeconds) {
                    intervalSeconds = 5;
                }

                $log.debug('auth-service: refresh access token $interval started. Interval: ' + intervalSeconds + ' second(s)');
                _refreshAccessTokenIntervalPromise = $interval(refreshAccessTokenCallback, intervalSeconds * 1000, 0, false);
            }
        }

    }
})();

(function () {
    'use strict';

    CheckInController.$inject = ["$state", "$transition$", "messagesService", "roService", "locationService", "resolvedAdvisors", "permissions", "resolvedContact", "resolvedAppointment", "resolvedDepartments", "appointmentUtilService", "appointmentService", "modalService", "APPOINTMENT_APPOINTMENTSTATUS", "SYSTEM_ENUMS", "INSPECT_CONSTANTS", "SYSTEM_VARIABLES", "resolvedCheckinUrl"];
    angular
        .module('redcap.appointment')
        .controller('CheckInController', CheckInController);

    function CheckInController($state, $transition$, messagesService, roService, locationService, resolvedAdvisors, permissions, resolvedContact, resolvedAppointment, resolvedDepartments, appointmentUtilService, appointmentService, modalService, APPOINTMENT_APPOINTMENTSTATUS, SYSTEM_ENUMS, INSPECT_CONSTANTS, SYSTEM_VARIABLES, resolvedCheckinUrl) {
        let vm = this;
        let initialCheckinData = { };
        let dealerHasInspect = false;

        const activeProduct = appointmentUtilService.getActiveApptProduct($state.name);
        const productSuffix = appointmentUtilService.getProductSuffix(vm.activeProduct);

        vm.appointment = resolvedAppointment;
        vm.dealerDepartments = resolvedDepartments;
        vm.contact = resolvedContact;
        vm.serviceAdvisors = resolvedAdvisors;
        vm.tabTypes = INSPECT_CONSTANTS.tabTypes;
        vm.soleraLogoUrl = SYSTEM_VARIABLES.soleraLogoUrl;
        vm.checkinUrl = resolvedCheckinUrl;
        vm.checkinComplete = false;

        vm.registerStepProcessor = (fn) => { vm.processStep = fn; };

        vm.getCustomerName = function () {
            return roService.buildCustomerNameForTab(vm.appointment.customerFirstName, vm.appointment.customerLastName);
        };

        vm.checkInStepTypes = {
            verifyCustomer: 1,
            verifyVehicle: 2,
            addServices: 3,
            transportationOptions: 4,
            authorizeServices: 5
        };        

        vm.checkinSettings = {
            roHistoryPanelOpen: false
        };
        
        vm.checkInSteps = [
            {
                stepType: vm.checkInStepTypes.verifyCustomer,
                nextStepType: vm.checkInStepTypes.verifyVehicle
            },
            {
                stepType: vm.checkInStepTypes.verifyVehicle,
                nextStepType: vm.checkInStepTypes.addServices
            },
            {
                stepType: vm.checkInStepTypes.addServices,
                nextStepType: vm.checkInStepTypes.transportationOptions
            },
            {
                stepType: vm.checkInStepTypes.transportationOptions,
                nextStepType: vm.checkInStepTypes.authorizeServices
            },
            {
                stepType: vm.checkInStepTypes.authorizeServices,
                isLastStep: true
            }
        ]; 

        vm.hasCheckInDataChanged = function() {
            return initialCheckinData.vin !== vm.appointment.vin || initialCheckinData.customerPhone !== vm.appointment.customerPhone || initialCheckinData.mileage !== vm.appointment.mileage || initialCheckinData.dealerEmployeeId !== vm.appointment.dealerEmployeeId;
        };

        vm.nextClicked = async function () {
            if (vm.processStep) {
                vm.isLoading = true;
             
                try {
                    const stepDetails = await vm.processStep();
                    
                    // Reset the processStep function to enforce the requirement that it should be set in child components.
                    vm.processStep = null;
                    vm.checkinComplete = stepDetails?.checkinComplete;

                    const nextStep = vm.checkInSteps.find((step) => step.stepType === vm.currentStep.nextStepType);
                    
                    if (nextStep) {
                        setInitialCheckinData();

                        vm.previousStep = vm.currentStep;
                        vm.currentStep = nextStep;

                       updateCurrentStepInCheckInUrl(vm.currentStep.stepType);
                    } else {
                        vm.checkinComplete = true;
                    }
                } catch (e) {
                    console.log('Error occurred while processing step: ', e);
                } finally {
                    vm.isLoading = false;
                }
            } else {
                console.error('The processStep function must be defined in each child component within the checkin');
            }
        };

        vm.backClicked = function() {
            const currentIndex = vm.checkInSteps.findIndex((step) => step.stepType === vm.currentStep.stepType);

            vm.currentStep = vm.checkInSteps[currentIndex - 1];

            updateCurrentStepInCheckInUrl(vm.currentStep.stepType);
        };

        vm.updateContactForMessagingPanel = function () {
            if (vm.appointment.customerPhone?.length === 10) {
                messagesService.getContacts({dealer: vm.appointment.dealerId, query: vm.appointment.customerPhone.replace(/\D/g, ''), allowDisabledDealers: true}).then((contacts) => {
                    if (contacts.length) {
                        vm.contact = contacts[0];
                    } else {
                        vm.contact = {
                            id: 0,
                            dealerId: vm.appointment.location?.id || vm.appointment.dealerId,
                            firstName: vm.appointment.customerFirstName,
                            lastName: vm.appointment.customerLastName,
                            email: vm.appointment.customerEmail,
                            mobilePhone: vm.appointment.customerPhone
                        };
                    }
                });
            }
        };

        vm.showGoToInspectBtn = function () {
            return vm.checkinComplete && dealerHasInspect && permissions.hasPermission(SYSTEM_ENUMS.permissionTypes.inspect);
        };

        vm.showCancelBtn = function() {
            return vm.appointment.appointmentStatus !== APPOINTMENT_APPOINTMENTSTATUS.checkedIn && 
                   vm.appointment.appointmentStatus !== APPOINTMENT_APPOINTMENTSTATUS.repairOrderCreated &&
                   !vm.appointment.lineItems.some((li) => li.signOffRequested);
        };

        vm.showNextBtn = function() {
            return !vm.checkinComplete;
        };

        vm.showBackBtn = function () {
            return vm.currentStep.stepType !== vm.checkInSteps[0].stepType && !vm.checkinComplete;
        };

        vm.closeCheckin = function () {
            returnToParentList();
        };

        vm.cancelCheckin = function () {
            modalService.showYesNo('Confirm Cancel',
                'Are you sure you want to cancel this Checkin?',
                'No',
                'Yes',
                false).then((success) => {
                    if (success) {
                        appointmentService.setAppointmentStatus(vm.appointment.dealerId, vm.appointment.id, APPOINTMENT_APPOINTMENTSTATUS.new).then((result) => {
                            $state.go('appointment-details' + productSuffix, {
                                locationId: vm.appointment.dealerId,
                                appointmentId: vm.appointment.id
                            });
                        });
                    }
                });

        };

        function returnToParentList() {
            $state.go(activeProduct);
        }

        // This is used to determine if changes have been made to customer or vehicle data so we can update the appointment as needed during the checkin flow.
        function setInitialCheckinData() {
            initialCheckinData = {
                vin: vm.appointment.vin,
                customerPhone: vm.appointment.customerPhone,
                mileage: vm.appointment.mileage,
                dealerEmployeeId: vm.appointment.dealerEmployeeId,
                year: vm.appointment.year ? parseInt(vm.appointment.year) : null,
                make: vm.appointment.make,
                model: vm.appointment.model
            };
        }

        function init() {
            setInitialCheckinData();

            locationService.hasRole(vm.appointment.dealerId, SYSTEM_ENUMS.permissionTypes.inspect).then((hasInspect) => {
                dealerHasInspect = hasInspect;
            });

            if (vm.appointment.appointmentStatus === APPOINTMENT_APPOINTMENTSTATUS.checkedIn) {
                vm.checkinComplete = true;
                vm.currentStep = vm.checkInSteps[vm.checkInSteps.length - 1];
            } else {
                const currentStep = $transition$.params().currentStep;

                if (currentStep) {
                    const targetStep = vm.checkInSteps.find((step) => step.stepType === parseInt(currentStep));

                    vm.currentStep = targetStep || vm.checkInSteps[0];
                } else {
                    vm.currentStep = vm.checkInSteps[0];
                }
            }

            if (vm.appointment.appointmentStatus !== APPOINTMENT_APPOINTMENTSTATUS.arrived && vm.appointment.appointmentStatus !== APPOINTMENT_APPOINTMENTSTATUS.checkingIn && vm.appointment.appointmentStatus !== APPOINTMENT_APPOINTMENTSTATUS.checkedIn) {            
                vm.appointment.appointmentStatus = APPOINTMENT_APPOINTMENTSTATUS.checkingIn;
            }

            // TODO: See if these are needed
            vm.requireDispatchCode = true;
            vm.yearMakeModelMismatch = false; // only seems to be set in appointment-customervehicle.controller.js, booking.controller.js, and ghostgarage.  Instead of putting this on the VM here... just put it on the appointment and pass the appointment to sub components
        }

        function updateCurrentStepInCheckInUrl(currentStepType) {
            if (vm.checkinComplete || !vm.checkinUrl) {
                return;
            }

            const url = new URL(vm.checkinUrl);

            url.searchParams.set('currentStep', currentStepType);
            vm.checkinUrl = url.href;
        }

        init();
    }

})();

(function () {
    'use strict';

    PublicController.$inject = ["$log", "$rootScope", "resolvedConfig"];
    angular
        .module('redcap')
        .controller('PublicController', PublicController);

    function PublicController($log, $rootScope, resolvedConfig) {
        var vm = this;
        $rootScope.config = resolvedConfig;
    }
})();

(function () {
    'use strict';

    HandleLoginController.$inject = ["$state", "authService", "authAzureService", "localStorageService", "configId", "resolvedMsalConfig"];
    angular
        .module('redcap')
        .controller('HandleLoginController', HandleLoginController);

    function HandleLoginController($state, authService, authAzureService, localStorageService, configId, resolvedMsalConfig) {
        let vm = this;
        let username = localStorageService.get('username') || '';
        let msalConfig = authAzureService.msalConfig;
        let accountId = null;
        const hash = window.location.hash;
        const search = window.location.search;
        const hashParams = new URLSearchParams(hash.replace('#', '?'));
        const searchParams = new URLSearchParams(search);
        
        vm.error = authService.authError;
        vm.loginData = authService.initializeLoginData(username, configId);
        authService.configureMSAL(msalConfig, resolvedMsalConfig);

        const myMSALObj = new msal.PublicClientApplication(msalConfig);
      
        myMSALObj.initialize().then(() => {
            myMSALObj.handleRedirectPromise(hash).then(handleResponse).catch(err => {
                console.error(err);
            });
            
            const currentAccounts = myMSALObj.getAllAccounts();

            if (currentAccounts.length > 1) {
                // Add choose account code here
            } else if (currentAccounts.length === 1) {
                accountId = currentAccounts[0].homeAccountId;
            }

            if (hashParams.has('error') || searchParams.has('error')) {
                // Handle error from MSAL
                $state.go('login', {configId: configId});

                return;
            } else if (currentAccounts.length === 0 && hash === '') {
                // No accounts found and no hash, redirect to login
                console.log("No accounts found, redirecting to login.");
                myMSALObj.loginRedirect(authAzureService.loginRequest);
            }
        });

        function handleResponse(response) {
            if (response !== null) {
                accountId = response.account.homeAccountId;

                authService.loginToken(vm.loginData, response.idToken).then((response) => {
                    vm.error.message = '';

                    if (vm.loginData.rememberToggle) {
                        localStorageService.set('username', authService.getCurrentUser().username);
                    } else {
                        localStorageService.remove('username');
                    }

                    let returnUrl = localStorageService.get('postLoginRedirect');

                    localStorageService.remove('postLoginRedirect');

                    // **** redirect sections ***** //
                    if (response.vanityUrl) {
                        window.location = response.vanityUrl;

                        return;
                    } else if (returnUrl) {
                        window.location = returnUrl;

                        return;
                    } else {
                        authService.redirectToDefaultPage(configId);
                    }
                }).catch(async (errorMessage) => {
                    authService.handleLoginError(errorMessage, vm);
                    
                    $state.go('login', {configId: configId});
                });
            }
        }
    }
})();

(function () {
    'use strict';

    runBlock.$inject = ["$log", "$location", "$rootScope", "$timeout", "$state", "$transitions", "$window", "SYSTEM_ENUMS", "deviceDetector", "authService", "toastr", "modalService", "userService", "permissions", "localStorageService"];
    angular
        .module('redcap')
        .run(runBlock);

    function runBlock($log, $location, $rootScope, $timeout, $state, $transitions, $window, SYSTEM_ENUMS, deviceDetector, authService, toastr, modalService, userService, permissions, localStorageService) {
        initAppSettings();

        let preventNavigation = function (trans, routeName, showUpgradeMsg) {
            if (authService.getCurrentUser() && permissions.getUserPermissions()) {
                trans.abort();

                if (showUpgradeMsg) {
                    modalService.showFeatureUpgradeMessage();
                } else {
                    $log.error('Unauthorized access attempt to: ' + routeName);
                    toastr.error('Unauthorized');
                }
            }
        };

        // $trace.enable('TRANSITION'); // Uncomment to enable router debug tracing
        let preventPreloader = ['trip-tab-trip', 'trip-tab-tasks', 'trip-tab-vehicles', 'trip-tab-ratings', 'trip-tab-messages', 'trip-tab-audit', 'trip-tab-help'];

        let requiresAuth = {
            to: function (state) {
                // Don't require auth on login page, prevent loop
                if (state.name === 'login') return false;

                // If state isn't public or parent's state isn't public, require auth
                return !state.public && (!state.parent || !state.parent.public);
            }
        };

        function initAppSettings() {
            // Used to house global information that we only want to check once per app-load
            window.serviceSuiteSettings = {};

            window.serviceSuiteSettings.isTouchDevice = 'ontouchstart' in window || (navigator.maxTouchPoints > 1);            
        }

        function getPermission(productName) {
            switch (productName) {
                case "autopoint-dealer-settings":
                case "inspection-form-editor":
                case "inspect":
                    return SYSTEM_ENUMS.permissionTypes.inspect;
                case "check-in":
                    return SYSTEM_ENUMS.permissionTypes.checkIn;
            }
        }

        // gets the base parent for a state, so we can see if it's consumer
        function getParentName(toState) {
            if (toState.parent.parent && toState.parent.parent.name) {
                return getParentName(toState.parent);
            } else {
                return toState.parent.name;
            }
        }

        // this ensures that any route that is not decorated with "public:true" will be required to check authenticattion
        $transitions.onBefore(requiresAuth, (trans) => {
            let toState = trans.$to();
            let toParams = trans.params();

            authService.isAuthenticated().then(() => {
                let next = toState;

                if (toParams.embeddedProduct === '1') {
                    next.permission = getPermission(toParams.productName.toLowerCase());
                }

                while (next) {
                    let shouldPrevent = (next.permission && !permissions.hasPermission(next.permission)) ||
                                        (next.userPermission && !permissions.hasUserPermission(next.userPermission));

                    if (shouldPrevent) {
                        if (permissions.hasMarketingPagePermission(next.permission)) {
                            // if we are showing them disabled products, go to the marketing page
                            trans.abort();

                            if (toState.topLevel) {
                                localStorageService.set('selectedMenu', toState.name);

                                if (toParams.embeddedProduct === '1') {
                                    localStorageService.set('selectedMenuProductName', toParams.productName);
                                } else {
                                    localStorageService.set('selectedMenuProductName', null);
                                }
                            }

                            $state.go('marketing', {configId: toParams.configId, marketingArea: next.permission}, {reload: true});
                        } else if (toParams && toParams.fromCachedMenu) {
                            event.preventDefault();
                            localStorageService.remove('selectedMenu');
                            authService.redirectToDefaultPage(toParams.configId);
                        } else {
                            preventNavigation(trans, toState.name, true);
                        }

                        return;
                    }

                    next = next.parent;
                }

                let currentUser = authService.getCurrentUser();

                if (!currentUser.unseenTutorials) {
                    userService.getUnseenTutorials().then((unseenTutorials) => {
                        currentUser.unseenTutorials = unseenTutorials;

                        showTutorial(currentUser, toState);
                    });
                } else {
                    showTutorial(currentUser, toState);
                }
            }).catch((err) => {
                $log.debug('stateChangeStart: authService.isAuthenticated() - redirecting to login');
                trans.abort(); // Stop the current transition

                if (err && err.isFramedIn) {
                    $log.debug('authentication error caught in sso application. Redirecting...');

                    return $state.go('enrollment-sso-ok', {configId: toParams.configId, errorId: 5});
                }

                $state.go('login', {configId: toParams.configId || 1,
                                     referrer: $location.path(),
                                     authSessionId: $location.search().authSessionId,
                                     authSessionData: $location.search().authSessionData
                });
            });
        });

        $transitions.onStart({}, (trans) => {
            let toState     = trans.$to();
            let fromState   = trans.$from();

            // Redirecting to new trips list screen in case people have old url bookmarked
            if (toState.name === 'old-trip-list') {
                window.location.href = window.location.href.replace('/trips', '/triplist');
                trans.abort();

                return;
            }

            if (!fromState || !fromState.name || !_.includes(preventPreloader, fromState.name) || !_.includes(preventPreloader, toState.name)) {
                $rootScope.preloader = true;
            }

            // Set state name for OnEnter methods
            $state.name = toState.name;
        });

        $transitions.onError({}, (trans) => {
            let rejection = trans.error();

            // If not an error, don't logout just return
            // https://ui-router.github.io/ng1/docs/latest/enums/transition.rejecttype.html
            if (rejection.type !== 6) {
                return;
            }

            let toState     = trans.$to();
            let toParams    = trans.params();
            let errorPath   = trans.$from(); //PROD-9443 DO NOT LOG OUT... JUST GO TO PREVIOUS PAGE
            let errorArgs   =  {configId: toParams.configId || 1};

            // Check to see if current state or parent state has error handling
            if ((toState.data && toState.data.onError) ||
                (toState.parent && toState.parent.data && toState.parent.data.onError)) {
                    errorPath = toState.data.onError ? toState.data.onError.toState : toState.parent.data.onError.toState;
                    errorArgs = (toState.data.onError ? toState.data.onError.args : toState.parent.data.onError.args) || {};
            }

            $rootScope.preloader = false;

            if (errorPath === 'login') {
                authService.logout();
            }

            //this prevents infinite loop
            if (toState.name === errorPath) {
                return;
            }

            $state.go(errorPath, errorArgs);
        });

        $transitions.onSuccess({}, (trans) => {
            let toState         = trans.$to();
            let fromState       =   trans.$from();
            let toParams        = trans.params();
            let authSessionId   = $location.search().authSessionId;
            let authSessionData = $location.search().authSessionData;
            let bodyEl = angular.element('body');
			let pageWrapperEl = angular.element("#page-wrapper");
            
            $rootScope.preloader = false;

            if (toState.resolve && toState.resolve.pageTitle) {
                let resolvePromise = trans.injector().getAsync('pageTitle');

                resolvePromise.then((resolveData) => {
                    document.title = resolveData ? resolveData : 'Service Suite';
                }).catch(() => {
                    document.title = 'Service Suite';
                });
            } else {
                document.title = 'Service Suite';
            }

            document.body.scrollTop = document.documentElement.scrollTop = 0;
            

            if (deviceDetector.isMobile()) {
                bodyEl.addClass('mobile-device');
                bodyEl.addClass('force-redraw-fix');
                $timeout(() => {
                    bodyEl.removeClass('force-redraw-fix');
                }, 1);
            }

            // add the frame class to the body
            if ((authSessionId && authSessionData) || authService.isFramedIn()) {
                bodyEl.addClass('frame-in');
            }

            const parentName = getParentName(toState);

            if (!parentName.includes('consumer')) {
                bodyEl.addClass('flexified-dashboard');
                pageWrapperEl.addClass('full-width-height').addClass('flex-column').removeClass('flex-fill');
            } else {
                bodyEl.removeClass('flexified-dashboard');
                pageWrapperEl.removeClass('full-width-height').removeClass('flex-column').addClass('flex-fill');
            }

            if (fromState) {
                pageWrapperEl.removeClass(fromState.name);
            }

            pageWrapperEl.addClass(toState.name);
            
            if (toState.topLevel) {
                localStorageService.set('selectedMenu', toState.name);

                if (toParams.embeddedProduct === '1') {
                    localStorageService.set('selectedMenuProductName', toParams.productName);
                } else {
                    localStorageService.set('selectedMenuProductName', null);
                }
            }
        });

        $rootScope.$on('newVersionAvailable', (sender, versionInfo) => {
            console.info("New version info: ", versionInfo);
            let modal = modalService.showYesNo('New Version Available', 'The system has been updated and requires the browser to be refreshed. We apologize for any inconvenience.', null, 'Refresh now', true);

            modal.then((refreshNow) => {
                if (refreshNow) {
                    window.location.reload(true);
                }
            });
        });

        function showTutorial(currentUser, toState) {
            if (currentUser.unseenTutorials && currentUser.unseenTutorials.length > 0) {
                let tutorialToShow = _.find(currentUser.unseenTutorials, (t) => {
                    return t.triggerState === toState.name || t.triggerState === 'global';
                });

                if (tutorialToShow) {
                    $timeout(() => {
                        modalService.showTutorial(tutorialToShow);
                    }, 1200);
                }
            }
        }

        angular.element(() => {
            let bodyElem = angular.element('body');
            let windowElem = angular.element(window);
            
            // Minimalize menu when screen is less than 768px
            windowElem.on("load resize", () => {
                if (angular.element(document).width() < 769) {
                    bodyElem.addClass('body-small');
                } else {
                    bodyElem.removeClass('body-small');
                }
            });
        });
    }
})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "$urlServiceProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "$uiRouterProvider", "rcAsideProvider", "SYSTEM_ENUMS"];
    angular
        .module('redcap')
        .config(routeConfig);

    function routeConfig($stateProvider, $urlServiceProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $uiRouterProvider, rcAsideProvider, SYSTEM_ENUMS) {
        let stickyStatesPlugin = window["@uirouter/sticky-states"].StickyStatesPlugin;
        let deepStateRedirectPlugin = window["@uirouter/dsr"].DSRPlugin;
        
        $uiRouterProvider.plugin(stickyStatesPlugin);
        $uiRouterProvider.plugin(deepStateRedirectPlugin);

        // match URLs in ui-router regardless of trailing forward slashes in URI
        $urlServiceProvider.config.strictMode(false);
        $urlServiceProvider.config.caseInsensitive(true);

        $stateProvider
            .state('handleLogin', {
                abstract: false,
                public: true,
                url: '/handlelogin',
                views: {
                    'layout@': {
                        templateUrl: 'app/shared/layouts/handle-login/handle-login.view.html',  //Updated with loading spinner
                        controller: 'HandleLoginController as vm'
                    }
                },
                resolve: {
                    configId: ["localStorageService", function (localStorageService) {
                        return localStorageService.get('RedcapProgramId');
                    }],
                    referrer: ["$transition$", function($transition$) {
                        return $transition$.params().referrer;
                    }],
                    referrerQS: function () {
                        return window.location.search;
                    },
                    resolvedMsalConfig: ["authAzureService", function(authAzureService) {
                        return authAzureService.getSolidConfig();
                    }]
                }
            })
            
            .state('public', {
                abstract: true,
                url: '/:configId',
                views: {
                    'layout@': {
                        templateUrl: 'app/shared/layouts/content-only/content-only.view.html',
                        controller: 'PublicController as vm'
                    }
                },
                resolve: {
                    resolvedConfig: ["$transition$", "rcConfigService", function ($transition$, rcConfigService) {
                        let configId = $transition$.params().configId;

                        return rcConfigService.getConfigValues(configId);
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Service Suite';
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })

            .state('access-denied',  {
                parent: 'public',
                public: true,
                url: '/access-denied',
                views: {
                    'layout@': {
                        templateUrl: 'app/areas/auth/views/access-denied.view.html',
                        controller: 'AccessDeniedController as vm'
                    }
                },
                resolve: {
                    config: ["$rootScope", "resolvedConfig", function ($rootScope, resolvedConfig) {
                        $rootScope.config = resolvedConfig;

                        return resolvedConfig;
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'oops - ' + parentTitle;
                    }]
                }
            })

            .state('not-found',  {
                parent: 'public',
                public: true,
                url: '/not-found',
                views: {
                    'layout@': {
                        templateUrl: 'app/areas/auth/views/not-found.view.html',
                        controller: 'NotFoundController as vm'
                    }
                },
                resolve: {
                    config: ["$rootScope", "resolvedConfig", function ($rootScope, resolvedConfig) {
                        $rootScope.config = resolvedConfig;

                        return resolvedConfig;
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return '404 Not Found - ' + parentTitle;
                    }]
                }
            })

            /*************************/
            /********** AUTH *********/
            /*************************/
            .state('login', {
                parent: 'public',
                public: true,
                url: '/login?authSessionId&authSessionData',
                params: {
                    referrer: null,
                    authSessionId: null,
                    authSessionData: null
                },
                templateUrl: 'app/areas/auth/views/login.view.html',
                controller: 'LoginController as vm',
                resolve: {
                    configId: ["$q", "$state", "$location", "resolvedConfig", function ($q, $state, $location, resolvedConfig) {
                        let currHost = $location.host();

                        if (currHost.indexOf('localhost') === -1 && currHost.indexOf('redcapvalet.com') === -1 && currHost !== resolvedConfig.dashUrl) {
                            return $state.go('not-found', {configId: resolvedConfig.id});
                        }

                        return resolvedConfig.id;

                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Login - ' + parentTitle;
                    }],
                    referrer: ["$transition$", function($transition$) {
                        return $transition$.params().referrer;
                    }],
                    referrerQS: function () {
                        return window.location.search;
                    },
                    resolvedLogin: ["$stateParams", "$q", "authService", "resolvedConfig", "referrer", function ($stateParams, $q, authService, resolvedConfig, referrer) {
                        let deferred = $q.defer();

                        // 3rd party frame in found
                        if ($stateParams.authSessionId && $stateParams.authSessionData) {
                            let loginData = {
                                userName: $stateParams.authSessionId,
                                password: $stateParams.authSessionData,
                                adminConfigId: resolvedConfig.id,
                                useRefreshTokens: true
                            };

                            authService.loginFrame(loginData).then((response) => {
                                if (referrer) {
                                    window.location = referrer + '?authSessionId=' + loginData.userName + '&authSessionData=' + loginData.password;
                                }

                                deferred.resolve();
                            })
                            .catch((errorMessage) => {
                                if (errorMessage.error === 'incorrect_adminconfig') {
                                    alert('Redirecting you to the proper site. Please update your bookmarks.');
                                    window.location = errorMessage.error_description;
                                }

                                deferred.reject();
                            });
                        } else {
                            deferred.resolve();
                        }

                        return deferred.promise;
                    }],
                    resolvedMsalConfig: ["authAzureService", function(authAzureService) {
                        return authAzureService.getSolidConfig();
                    }]
                }
            })

            .state('forgotpassword', {
                parent: 'public',
                public: true,
                url: '/forgotpassword',
                templateUrl: 'app/areas/auth/views/forgotpassword.view.html',
                controller: 'ForgotPasswordController as vm',
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Forgot Password - ' + parentTitle;
                    }]
                }
            })

            .state('privacypolicy', {
                parent: 'public',
                public: true,
                url: '/privacypolicy',
                templateUrl: 'app/areas/auth/views/privacypolicy.view.html',
                controller: 'PrivacyPolicyController as vm',
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Privacy Policy - ' + parentTitle;
                    }]
                }
            })

            .state('forgotemail', {
                parent: 'public',
                public: true,
                url: '/forgotemail',
                templateUrl: 'app/areas/auth/views/forgotemail.view.html',
                controller: 'ForgotEmailController as vm',
                resolve: {
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Forgot Email - ' + parentTitle;
                    }]
                }
            })

            .state('firstTimeUser', {
                parent: 'public',
                public: true,
                url: '/new-user/:guid',
                templateUrl: 'app/areas/auth/views/new-user.view.html',
                controller: 'NewUserController as vm',
                resolve: {
                    resolvedConfigId: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.configId;
                    }],
                    resolvedUser: ["$q", "$transition$", "userService", "resolvedConfig", function ($q, $transition$, userService, resolvedConfig) {
                        let deferred = $q.defer();
                        let guid = $transition$.params().guid;

                        userService.getOnboardingUser(guid)
                            .then((result) => {
                                deferred.resolve(result);
                            }, (error) => {
                                window.location = 'https://' + resolvedConfig.url;
                                deferred.reject();
                            });

                        return deferred.promise;
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Register - ' + parentTitle;
                    }]
                }
            })

            .state('new-user-complete', {
                parent: 'public',
                public: true,
                url: '/new-user-complete/:guid',
                templateUrl: 'app/areas/auth/views/new-user-complete.view.html',
                controller: 'NewUserCompleteController as vm',
                resolve: {
                    resolvedConfigId: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.configId;
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Registration Complete - ' + parentTitle;
                    }]
                }
            })

            .state('mobile-app-download',  {
                parent: 'public',
                public: true,
                url: '/download',
                templateUrl: 'app/areas/auth/views/mobile-app-download.view.html',
                controller: 'MobileAppDownloadController as vm',
                resolve: {
                    redirectDesktop: ["$q", "$timeout", "$state", "$transition$", "deviceDetector", function ($q, $timeout, $state, $transition$, deviceDetector) {
                        let deferred = $q.defer();

                        $timeout(() => {
                            if (!deviceDetector.isMobile()) {
                                deferred.reject();
                                $state.go('login', {configId: $transition$.params().configId});
                            } else {
                                deferred.resolve();
                            }
                        });

                        return deferred.promise;
                    }],
                    pageTitle: ["parentTitle", function (parentTitle) {
                        return 'Cardrop Download - ' + parentTitle;
                    }]
                }
            })

            /******************************/
            /********** APP ***************/
            /******************************/
            .state('app', {
                abstract: true,
                url: '/:configId',
                params: {
                    fromCachedMenu: null
                },
                views: {
                    'layout@': {
                        templateUrl: 'app/shared/layouts/main/main-topnav.view.html',
                        controller: 'MainController as vm'
                    }
                },
                resolve: {
                    resolvedConfig: ["$transition$", "rcConfigService", function ($transition$, rcConfigService) {
                        let configId = $transition$.params().configId;

                        return rcConfigService.getConfigValues(configId);
                    }],
                    resolvedOverrides: ["systemService", "resolvedConfig", function (systemService, resolvedConfig) {
                        return systemService.getAdminConfigOverrides(resolvedConfig.id);
                    }],
                    resolveAdmin: ["$transition$", "authService", function ($transition$, authService) {
                        let configId = $transition$.params().configId;

                        return authService.isValidAdminConfig(configId);
                    }],
                    resolvedSupportConfigs: ["supportService", "authService", function (supportService, authService) {
                        // Ensure that we are authenticated before getting config
                        // Needed because base resolves get called before refresh token resolve
                        return authService.isAuthenticated().then(() => {
                            return supportService.getSupportTrainingConfigs();
                        });
                    }],
                    parentTitle: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.programName + ' Service Suite';
                    }],
                    favicon: ["resolvedConfig", "rcConfigService", function(resolvedConfig, rcConfigService) {
                        return rcConfigService.setFavicon(resolvedConfig.faviconUrl);
                    }]
                }
            })
            
            .state('default', {
                parent: 'public',
                public: true,
                url: '/default',
                templateUrl: 'app/shared/layouts/content-only/content-only.view.html',
                controller: 'LoginController as vm',
                resolve: {
                    configId: ["resolvedConfig", function (resolvedConfig) {
                        return resolvedConfig.id;
                    }],
                    redirect: ["authService", "configId", function (authService, configId) {
                        authService.redirectToDefaultPage(configId);
                    }],
                    referrer: function() {
                        return null;
                    },
                    resolvedMsalConfig: ["authAzureService", function(authAzureService) {
                        return authAzureService.getSolidConfig();
                    }]
                }
            });
        let idx = 0;

        $stateProvider.state('venue-mappings', {
            parent: 'location-list',
            params: {
                referrer: null
            },
            url: '/venue-mappings',
            onEnter: ['$aside', '$log', '$transition$', '$location', function ($aside, $log, $transition$, $location) {
                rcAsideProvider.showAside($aside, $log, 'location', 'location-venue-mappings.view.html', 'VenueMappingsController as vm', {
                    $transition$: $transition$,
                    $location: $location
                });
            }],
            onExit: ["$log", function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
            }
        });

        $stateProvider.state('systemsurvey-management', {
            parent: 'location-list',
            params: {
                referrer: null
            },
            url: '/systemsurvey-management',
            onEnter: ['$aside', '$log', '$transition$', '$location', 'resolvedSurveys', function ($aside, $log, $transition$, $location, resolvedSurveys) {
                rcAsideProvider.showAside($aside, $log, 'location', 'location-system-survey-management.view.html', 'SystemSurveyManagementController as vm', {
                    $location: $location,
                    $transition$: $transition$,
                    resolvedSurveys: function() { return resolvedSurveys; }
                });
            }],
            onExit: ["$log", function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
                resolvedSurveys: ['tripTypeService', function (tripTypeService) {
                    return tripTypeService.getSurveys(true);
                }]
            }
        });

        $stateProvider.state('uber-serviceability', {
            parent: 'location-list',
            params: {
                referrer: null
            },
            url: '/uber-serviceability',
            onEnter: ['$aside', '$log', '$transition$', '$location', function ($aside, $log, $transition$, $location) {
                rcAsideProvider.showAside($aside, $log, 'location', 'location-uber-serviceability.view.html', 'UberServiceabilityController as vm', {
                    $transition$: $transition$,
                    $location: $location
                });
            }],
            onExit: ["$log", function ($log) {
                rcAsideProvider.destroyAside($log);
            }],
            resolve: {
            }
        });
        
        $urlServiceProvider.rules.otherwise('/1/default');
    }

})();
(function () {
    'use strict';

    angular
        .module('redcap.constants', [])
        .constant('MAX_MATRIX_ROWS', 31)
        .constant('MAX_MATRIX_COLUMNS', 10)
        .constant('API_SETTINGS', {
            apiServiceBaseUri: window.__env.apiUrl,
            clientId: 'rcAdminDashboard',
            clientSecret: 'abc@123',
            frameId: '14b3132dcbab298ebaa62d4a5e9053477e36f724181ab39c60ccaf2953adc87d',
            frameSecret: '7d750c279b306dd178884bea2fd2288a776b36106458f0f8ae7afce6cc545486'
        })

        .constant('AZUREBTC_POLICIES', {
            names: {
                signUpSignIn: 'b2c_1a_hrdsignin_v2',
                forgotPassword: 'B2C_1A_RESETPASSWORD',
                invitation: 'B2C_1A_ACCEPTINVITATION',
            },
            authorities: {
                signUpSignIn: {
                    authority: 'https://{tenant}.b2clogin.com/{tenant}.onmicrosoft.com/b2c_1a_hrdsignin_v2/v2.0',
                },
                forgotPassword: {
                    authority: 'https://{tenant}.b2clogin.com/{tenant}.onmicrosoft.com/B2C_1A_RESETPASSWORD/v2.0',
                },
                invitation: {
                    authority: 'https://{tenant}.b2clogin.com/{tenant}.onmicrosoft.com/B2C_1A_ACCEPTINVITATION/v2.0',
                },
            },
            authorityDomain: '{tenant}.b2clogin.com',
            clientId: "4f450601-8cc2-4565-badb-3b01280f86eb"
        })

        //PROD
        // .constant('AZUREBTC_POLICIES', {
        //     names: {
        //         signUpSignIn: 'b2c_1a_hrdsignin_v2',
        //         forgotPassword: 'B2C_1A_RESETPASSWORD',
        //         invitation: 'B2C_1A_ACCEPTINVITATION',
        //     },
        //     authorities: {
        //         signUpSignIn: {
        //             authority: 'https://SoleraNAB2B.b2clogin.com/SoleraNAB2B.onmicrosoft.com/b2c_1a_hrdsignin_v2/v2.0',
        //         },
        //         forgotPassword: {
        //             authority: 'https://SoleraNAB2B.b2clogin.com/SoleraNAB2B.onmicrosoft.com/B2C_1A_RESETPASSWORD/v2.0',
        //         },
        //         invitation: {
        //             authority: 'https://SoleraNAB2B.b2clogin.com/SoleraNAB2B.onmicrosoft.com/B2C_1A_ACCEPTINVITATION/v2.0',
        //         },
        //     },
        //     authorityDomain: 'SoleraNAB2B.b2clogin.com',
        //     clientId: "dc997343-7555-4b02-ab15-6bc99c82d528"
        // })

        .constant('HERE_MAPS_CONFIG', {
            app_id: 'ZBRqdb0KKP9Fl5sCM3io',
            app_code: 'Py59uEGJ-F-_F7ZXRcTiXw',
            satelliteViewSettings: {
                scheme: 'satellite.day',
                type: 'aerial',
                metadataQueryParams: {
                    style: 'default'
                }
            },
            normalViewSettings: {
                scheme: 'normal.day',
                type: 'base',
                metadataQueryParams: {
                    style: 'default',
                    pois: ''
                }
            },
            tripStatus: {
                pending: 0,
                accepted: 1,
                arrived: 2,
                pickedUp: 3,
                droppedOff: 4,
                canceled: 5,
                unknown: 6
            },
            apiKey: 'FfhFAghg-1naRTNfVPKPO4YJONfdBjZsOPdNVyApbGg',
            mapModes: {
                overview: 1,
                followMode: 2,
                userControlled: 3
            },
            markerTypes: {
                dealer: 1,
                customer: 2
            },
            perimeterStyle: {
                circleStyle: {
                    strokeColor: 'rgba(102, 27, 209, 0.9)', // Color of the perimeter
                    lineWidth: 2,
                    fillColor: 'rgba(122, 193, 255, 0.25)'  // Color of the circle
                },
                circleStyleBad: {
                    strokeColor: 'rgba(102, 27, 209, 0.9)',
                    lineWidth: 2,
                    fillColor: 'rgba(255, 0, 0, 0.25)'
                },
                circleStyleGood: {
                    strokeColor: 'rgba(102, 27, 209, 0.9)',
                    lineWidth: 2,
                    fillColor: 'rgba(0, 219, 51, 0.25)'
                }
            }
        })
        .constant('INSPECT_CONSTANTS', {
            tabTypes: {
                routeSheet: 1,
                roDetail: 2,
                loading: 3
            },
            detailTabType: {
                inspection: 1,
                services: 2,
                authHistory: 3,
                shopNotes: 4
            },
            userRole: {
                technician: 1,
                serviceAdvisor: 2,
                serviceManager: 3,
                parts: 4
            },
            roTaskAnswerType: {
                pass: 1,
                caution: 2,
                fail: 3,
                na: 10
            },
            severity: {
                none: 0,
                addressSoon: 1,
                addressImmediately: 2
            },
            severityTypeText: {
                1: 'Pass',
                2: 'Caution',
                3: 'Fail',
                10: 'NA'
            },
            measurementInputType: {
                manual: 1,
                range: 2
            },
            measurementInputTypeText: {
                1: 'Manual',
                2: 'Range'
            },
            measurementUnitType: {
                thirtySecondths: 1,
                millimeters: 2,
                poundsPerSquareInch: 3,
                farads: 4,
                coulomb: 5,
                percent: 6,
                coldCrankingAmps: 7
            },
            measurementUnitTypeText: {
                1: '/32',
                2: 'mm',
                3: 'psi',
                4: 'F',
                5: 'C',
                6: '%',
                7: 'CCA'
            },
            actionEnum: {
                assignTo: 1,
                sendForPayment: 2,
                addRecommendation: 3,
                changeInspectionForm: 4,
                updateRo: 5,
                updateFromDms: 6,
                passAll: 7,
                printInspectionSummary: 8,
                sendForApproval: 9,
                showHidden: 10,
                hideHidden: 11,
                hideSelected: 12,
                unhideSelected: 13,
                approve: 14,
                defer: 15,
                importPartsQuote: 16,
                approveOnThisDevice: 17,
                deleteLineItem: 18
            },
            inspectActions: [
                {
                    id: 1,
                    name: 'Route and Assign To',
                    iconName: 'subject',
                    displayOrder: 1,
                    isEndOfSection: false
                },
                {
                    id: 2,
                    name: 'Send for Payment',
                    iconName: 'send_for_payment',
                    displayOrder: 17,
                    isEndOfSection: false,
                    requiresDms: true
                },
                {
                    id: 3,
                    name: 'Add Recommendation',
                    iconName: 'alt_route',
                    displayOrder: 5,
                    isEndOfSection: false
                },
                {
                    id: 4,
                    name: 'Change Inspection Form',
                    iconName: 'assignment',
                    displayOrder: 16,
                    isEndOfSection: false
                },
                {
                    id: 5,
                    name: 'Push all approved to DMS',
                    iconName: 'send',
                    displayOrder: 2,
                    isEndOfSection: false,
                    requiresDms: true
                },
                {
                    id: 6,
                    name: 'Update all services from DMS',
                    iconName: 'sync_alt',
                    displayOrder: 3,
                    isEndOfSection: false,
                    requiresDms: true
                },
                {
                    id: 7,
                    name: 'Pass All',
                    iconName: 'pass_all',
                    displayOrder: 15,
                    isEndOfSection: false
                },
                {
                    id: 8,
                    name: 'View/Print Report',
                    iconName: 'edit',
                    displayOrder: 4,
                    isEndOfSection: true
                }
            ],
            inspectionStatus: {
                notStarted: 1,
                inProgress: 2,
                complete: 3
            },
            inspectServiceActions: [
                {
                    id: 9,
                    name: 'Send Selected For Approval',
                    iconName: 'send',
                    displayOrder: 6,
                    isEndOfSection: false
                },
                {
                    id: 10,
                    name: 'Show Hidden',
                    iconName: 'unfold_more_double',
                    displayOrder: 13,
                    isEndOfSection: false
                },
                {
                    id: 11,
                    name: 'Hide Hidden',
                    iconName: 'unfold_more_double',
                    displayOrder: 14,
                    isEndOfSection: true
                },
                {
                    id: 12,
                    name: 'Hide Selected Rec(s)',
                    iconName: 'compress',
                    displayOrder: 11,
                    isEndOfSection: false
                },
                {
                    id: 13,
                    name: 'Unhide Selected Rec(s)',
                    iconName: 'compress',
                    displayOrder: 12,
                    isEndOfSection: false
                },
                {
                    id: 14,
                    name: 'Approve Selected Rec(s)',
                    iconName: 'order_approve',
                    displayOrder: 9,
                    isEndOfSection: false
                },
                {
                    id: 15,
                    name: 'Defer Selected Rec(s)',
                    iconName: 'inactive_order',
                    displayOrder: 10,
                    isEndOfSection: true
                },
                {
                    id: 16,
                    name: 'Import Parts Quote',
                    iconName: 'import',
                    displayOrder: 18,
                    isEndOfSection: false,
                    requiresDms: true
                },
                {
                    id: 17,
                    name: 'Approve On This Device',
                    iconName: 'order_approve',
                    displayOrder: 8,
                    isEndOfSection: false
                }, 
                {
                    id: 18,
                    name: 'Delete Selected Rec(s)',
                    iconName: 'order_approve',
                    displayOrder: 7,
                    isEndOfSection: false
                },
            ],
            assignmentRoles: {
                technician: 'technician',
                serviceAdvisor: 'serviceAdvisor',
                partsAssociate: 'partsAssociate',
                assignedToUser: 'assignedToUser'
            },
            lineItemStatus: {
                open: 1,
                approved: 2,
                deferred: 3,
                alreadyCompleted: 4,                
                doneElsewhere: 5,
                notNeeded: 6,
                new: 7,
                na: 9,
                
                // This value indicates that the retail price of the line has changed since it was originally sent to the customer, and that the 
                // service has been sent to the customer for a new approval.
                pendingReApproval: 10,
                
                // It's possible that the retail price of a service operation has changed since it was sent for authorization.  When this happens,
                // the status of the line is set to NeedsReapproval.  Once the service advisor sends the line for approval, the status will be PendingReApproval
                needsReApproval: 11
            },
            lineItemStatusText: {
                1: 'Pending',
                2: 'Approved',
                3: 'Deferred',
                4: 'Already Completed',
                5: 'Done Elsewhere',
                6: 'Not Needed',
                7: 'New',
                9: 'N/A',
                10: 'Pending Reapproval',
                11: 'Needs Reapproval'
            }
        })
        .constant('PAYMENT_PROVIDER_ENVIRONMENT', {
            Production: 3,
            Staging: 2,
            QA: 1,
            Development: 0
        })
        .constant('CENPOS_SETTINGS', {
            url: 'https://www4.cenpos.net/POSIntegration/POSIntegration-HTML5/',
            devUrl: 'https://webstaging.cenpos.net/POSIntegration/POSIntegration-HTML5/',
            simpleWebPayUrl: 'https://www.cenpos.net/simplewebpay/cards',
            simpleWebPayDevUrl: 'https://webstaging.cenpos.net/simplewebpay/cards',
        })
        .constant('CARDCONNECT_SETTINGS',
            {
                url: 'https://boltgw.cardconnect.com/itoke/ajax-tokenizer.html'
            })
        .constant('SYSTEM_ENUMS', {
              roleNames: {
                systemAdmin: 'SystemAdmin',
                developerUser: 'DeveloperUser',
                redCapAdmin: 'RedCapAdmin',
                serviceAdvisor: 'ServiceAdvisor',
                technician: 'Technician',
                partsAssociate: 'PartsAssociate',
                dealerAdmin: 'DealerAdmin',
                appointmentAdmin: 'AppointmentAdmin',
                overrideTripRules: 'OverrideTripRules',
                overrideApptCapacity: 'OverrideApptCapacity',
                programAdmin: 'ProgramAdmin',
                dealerUser: 'DealerUser',
                departmentAdmin: 'DepartmentAdmin',
                serviceAdvisorAdmin: 'ServiceAdvisorAdmin',
                capacitiesAdmin: 'CapacitiesAdmin',
                opCodeAdmin: 'OpCodeAdmin',
                driverUser: 'DriverUser',
                serviceManager: 'ServiceManager'
            },
            brandingTypes: [
                {value: 0, text: 'RedCap'},
                {value: 1, text: 'None'},
                {value: 2, text: 'Auto Dealer'}
            ],
            locationTypes: [
                {value: 1, text: 'Dealership'},
                {value: 2, text: 'Virtual Location'},
                {value: 3, text: 'GM Inventory Location'}
            ],
            timeZones: [
                {value: 0, text: 'Eastern'},
                {value: 1, text: 'Central'},
                {value: 2, text: 'Mountain'},
                {value: 3, text: 'Pacific'}
            ],
            bookingWindows: [
                {value: 0, text: 'Any time'},
                {value: 3, text: 'Day of Appointment'}
            ],
            dealerStatuses: [
                {value: 1, text: 'Active'},
                {value: 2, text: 'QA'},
                {value: 3, text: 'Install'},
                {value: 4, text: 'Disabled'}
            ],
            tripStatuses: [
                {value: 'ALL STATUS', text: 'All Status'},
                {value: 'NO ACTIVITY', text: 'No Activity'},
                {value: 'INVITE SENT', text: 'Invite Sent'},
                {value: 'PICKUP EXPERIENCE', text: 'Pickup Experience'},
                {value: 'DROPOFF EXPERIENCE', text: 'Dropoff Expereience'}
            ],
            transmissions: [
                {value: 0, text: 'Automatic'},
                {value: 1, text: 'Manual'}
            ],
            tripViewTypes: {
                list: 1,
                schedule: 2,
                detail: 3,
                add: 4
            },
            dealerBranding: {
                autoDealer: 2
            },
            rideProviderType: {
                lyft: 1,
                uber: 2,
                silentDispatch: 3,
                redcap: 4,
                uberDirect: 5
            },
            permissionTypes: {
                transportation: 'Transportation',
                messaging: 'Messaging',
                appointments: 'Appointments',
                welcomePoint: 'WelcomePoint',
                inspect: 'Inspect',
                cpo: 'CPO',
                payments: 'Payments',
                reports: 'Reports',
                marketing: 'Marketing',
                users: 'Users',
                locations: 'Locations',
                drivers: 'Drivers',
                enrollment: 'Enrollment',
                lyftRefunds: 'LyftRefunds',
                frameIn_allowMessages: 'FramedIn-AllowMessages',
                showDisabledProductsInNav: 'ShowDisabledProductsInNav',
                loaner: 'Loaner',
                checkIn: 'CheckIn',
                authorizations: 'Authorizations',
                all: 'All',
                loanerManagement: 'Loaner Management',
            },
            productPermission: {
                transportation: 1,
                messaging: 2,
                appointments: 3,
                welcomePoint: 4,
                inspect: 5,
                payments: 6,
                reports: 7,
                marketing: 8,
                users: 9,
                locations: 10,
                drivers: 11,
                enrollment: 12,
                lyftRefunds: 13,
                cpo: 14,
                loaner: 15,
                checkIn: 16,
                authorizations: 17
            },
            products: {
                loaner: 'Loaner Management',
                Product_Report: {
                    originalVal: 'Reports',
                    overrideVal: 'Reports'
                },
                Product_Loaner: {
                    originalVal: 'Loaners',
                    overrideVal: 'Loaners'
                },
                Product_Messaging: {
                    originalVal: 'Messaging',
                    overrideVal: 'Messaging'
                },
                Product_Transportation: {
                    originalVal: 'Transportation',
                    overrideVal: 'Transportation'
                },
                Product_Marketing: {
                    originalVal: 'Marketing',
                    overrideVal: 'Marketing'
                },
                Product_Appointment: {
                    originalVal: 'Appointments',
                    overrideVal: 'Appointments'
                },
                Product_WelcomePoint: {
                    originalVal: 'WelcomePoint',
                    overrideVal: 'WelcomePoint'
                },
                Product_Inspect: {
                    originalVal: 'Inspect',
                    overrideVal: 'Inspect'
                },
                Product_CPO: {
                    originalVal: 'CPO',
                    overrideVal: 'CPO'
                },
                Product_Payment: {
                    originalVal: 'Payments',
                    overrideVal: 'Payments'
                },
                Product_Authorizations: {
                    originalVal: 'Authorizations',
                    overrideVal: 'Authorizations'
                },
                Product_CheckIn: {
                    originalVal: 'Check In',
                    overrideVal: 'Check In'
                }

            },
            tripWorkflowTypes: {
                servicePickupNoLoaner: 1,
                servicePickupWithLoaner: 2,
                serviceDropoffWithoutLoaner: 3,
                serviceDropoffWithLoaner: 4,
                roundTripTestDriver: 5,
                personalDriverOneWay: 6,
                personalDriverRoundTrip: 7,
                servicePickupNoLoanerRecall: 8,
                servicePickupWithLoanerRecall: 9,
                servicePickupNoLoanerDealerFirst: 10,
                nnewVehicleDeliveryNoTrade: 12,
                newVehicleDeliveryWithTrade: 13,
                lyftToDealership: 14,
                lyftFromDealership: 15,
                lyftRoadsideAssistance: 16,
                moveAVehicle: 17,
                swapTwoVehicles: 18,
                pickupDealerTrade: 19,
                swapDealerTrade: 20,
                sendADealerTrade: 21,
                partsOnDemandToDealer: 22,
                partsOnDemandFromDealer: 23,
                lyftDriverReturn: 24,
                appointmentWithTrip: 25,
                appointmentWithoutTrip: 26,
                partsOnDemandToFromAny: 27,
                mobileGarage: 28
            },
            workflowTaskTypes: {
                information: 1,
                photo: 2,
                vinScan: 3,
                loanerStartEndContract: 4,
                loanerVinScan: 7,
                customerVehicleTasks: 8,
                loanerVehicleTasks: 9,
                otherVehicleTasks: 10,
                customerVehicleTasksMulti: 14,
            },
            measurementTypes: {
                imperical: 0,
                metric: 1
            },
            odometerTypes: [
                {type: 0, abbreviation: 'MI', description: 'miles'},
                {type: 1, abbreviation: 'KM', description: 'kilometers'}
            ],
            healthStatus: {
                unknown: 0,
                ok: 1,
                warning: 2,
                danger: 3,
                noDriverAccepted: 4,
                driverNoLocation: 5,
                similarTrip: 6,
                differentDropoff: 7,
                costDeviation: 8,
                driverDidntWait: 9
            },
            systemTripTypes: [
                {
                    value: 1,
                    badgeText: 'SP',
                    overrideName: 'SERVICE PICKUP',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: false,
                    supportsServiceNeeds: true,
                    supportsStartAtCustomer: true,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false, // for test drives and/or recalls
                    supportsHomeAddress: false,
                    requiresGroupSelection: false, // currently only for recall groups possibly might include other things later
                    placeHolders: {
                        customerLocation: 'PICK UP LOCATION',
                        customerDate: 'PICK UP DATE',
                        customerTime: 'PICK UP TIME',
                        loanerPlaceHolder: 'Select loaner or no loaner'
                    },
                    tripOptions: [
                        {text: 'Loaner provided', startsAtDealer: false, tripWorkFlowId: 2},
                        {text: 'No loaner - come to dealer first', startsAtDealer: true, tripWorkFlowId: 10},
                        {text: 'No loaner - go to customer first', startsAtDealer: false, tripWorkFlowId: 1}
                    ]
                },
                {
                    value: 2,
                    badgeText: 'SR',
                    overrideName: 'SERVICE RETURN',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: false,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    placeHolders: {
                        customerLocation: 'DROP OFF LOCATION',
                        customerDate: 'DROP OFF DATE',
                        customerTime: 'DROP OFF TIME',
                        loanerPlaceHolder: 'Select loaner or no loaner'
                    },
                    tripOptions: [
                        {text: 'Loaner provided', startsAtDealer: false, tripWorkFlowId: 4},
                        {text: 'No loaner', startsAtDealer: false, tripWorkFlowId: 3}

                    ]
                },
                {
                    value: 8,
                    badgeText: 'TD',
                    overrideName: 'TEST DRIVE DELIVERY',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: false,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: false,
                    supportsVehicleTrim: true,
                    requiresVehicleSelection: true,
                    requiresGroupSelection: false,
                    supportsHomeAddress: true,
                    placeHolders: {
                        customerLocation: 'TEST DRIVE LOCATION',
                        customerDate: 'DELIVERY DATE',
                        customerTime: 'DELIVERY TIME',
                        loanerPlaceHolder: null
                    },
                    tripOptions: null
                },
                {
                    value: 10,
                    badgeText: 'PD',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: false,
                    supportsStartAtCustomer: false,
                    supportsServiceNeeds: false,
                    supportsLoanerVehicle: false,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    placeHolders: {
                        customerLocation: 'PICK UP LOCATION',
                        customerDate: 'PICK UP DATE',
                        customerTime: 'PICK UP TIME',
                        loanerPlaceHolder: 'Loaner placeholder',
                        dropOffLocation: 'DROP OFF LOCATION'
                    },
                    tripOptions: null
                },
                {
                    value: 11,
                    badgeText: 'RP',
                    overrideName: 'RECALL PICKUP',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: false,
                    supportsServiceNeeds: true,
                    supportsStartAtCustomer: true,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: true,
                    requiresGroupSelection: true,
                    placeHolders: {
                        customerLocation: 'PICK UP LOCATION',
                        customerDate: 'PICK UP DATE',
                        customerTime: 'PICK UP TIME',
                        loanerPlaceHolder: 'Select loaner or no loaner'
                    },
                    tripOptions: [
                        {text: 'Loaner provided', startsAtDealer: false, tripWorkFlowId: 9},
                        {text: 'No lonaer - go to customer first', startsAtDealer: false, tripWorkFlowId: 8}
                    ]
                },
                {
                    value: 12,
                    badgeText: 'RO',
                    icon: null,
                    supportsSecondVehicle: false,
                    forceDisableDispatching: true,
                    supportsLyftAPI: true,
                    lyft: {
                        supportsServiceArea: true,
                        supportsRideTypes: true,
                        supportsSandboxOptions: true
                    },
                    supportsVehicleAssignment: false,
                    supportsDriverAssignment: false,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: false,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    tripWorkFlowId: 16,
                    placeHolders: {
                        customerLocation: 'PICK UP LOCATION',
                        customerDate: 'PICK UP DATE',
                        customerTime: 'PICK UP TIME',
                        dropOffLocation: 'DROP OFF LOCATION'
                    }
                },
                {
                    value: 13,
                    badgeText: 'SO',
                    icon: null,
                    forceDisableDispatching: true,
                    supportsSecondVehicle: false,
                    supportsLyftAPI: true,
                    lyft: {
                        supportsServiceArea: true,
                        supportsRideTypes: true,
                        supportsSandboxOptions: true
                    },
                    supportsVehicleAssignment: false,
                    supportsDriverAssignment: false,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    overrideROSearchTripTypeId: 2,
                    placeHolders: {
                        customerLocation: 'LOCATION',
                        loanerPlaceHolder: 'Select to or from'
                    },
                    tripOptions: [
                        {text: 'Give customer a ride TO your location', startsAtDealer: false, tripWorkFlowId: 14},
                        {text: 'Give customer a ride FROM your location', startsAtDealer: true, tripWorkFlowId: 15}
                    ]
                },
                {
                    value: 15,
                    badgeText: 'CD',
                    overrideName: 'Concierge Delivery',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: true,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    firstVehicleLabel: 'SOLD VEHICLE',
                    secondVehicleLabel: 'CUSTOMER TRADE',
                    placeHolders: {
                        customerLocation: 'DROP OFF LOCATION',
                        customerDate: 'DROP OFF DATE',
                        customerTime: 'DROP OFF TIME',
                        loanerPlaceHolder: 'Select type of trip'
                    },
                    tripOptions: [
                        {text: 'Deliver a sold vehicle and pick up a trade', startsAtDealer: false, tripWorkFlowId: 13},
                        {text: 'Deliver a sold vehicle', startsAtDealer: false, tripWorkFlowId: 12}

                    ]
                },
                {
                    value: 16,
                    badgeText: 'IT',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: true,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    firstVehicleLabel: 'MOVE VEHICLE',
                    secondVehicleLabel: 'SWAP WITH VEHICLE',
                    supportsFavoriteLocations: true,
                    placeHolders: {
                        customerLocation: 'DROP OFF LOCATION',
                        customerDate: 'DROP OFF DATE',
                        customerTime: 'DROP OFF TIME',
                        loanerPlaceHolder: 'Select type of trip'
                    },
                    tripOptions: [
                        {
                            text: 'Move a vehicle',
                            startsAtDealer: false,
                            tripWorkFlowId: 17,
                            placeHolders: {
                                customerLocation: 'Pick up location',
                                dropOffLocation: 'Drop off location'
                            }
                        },
                        {
                            text: 'Swap vehicles between locations',
                            startsAtDealer: false,
                            tripWorkFlowId: 18,
                            placeHolders: {
                                customerLocation: 'Pick up location',
                                dropOffLocation: 'Drop off location'
                            }
                        }
                    ]
                },
                {
                    value: 17,
                    badgeText: 'DT',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: true,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    firstVehicleLabel: 'DELIVER VEHICLE',
                    secondVehicleLabel: 'SWAP WITH VEHICLE',
                    supportsFavoriteLocations: true,
                    placeHolders: {
                        customerLocation: 'PICK UP LOCATION',
                        customerDate: 'PICK UP DATE',
                        customerTime: 'PICK UP TIME',
                        loanerPlaceHolder: 'Select type of trip'
                    },
                    tripOptions: [
                        {
                            text: 'Send a dealer trade',
                            startsAtDealer: true,
                            tripWorkFlowId: 21,
                            customerFieldsLabel: 'DELIVER TO',
                            placeHolders: {
                                customerLocation: 'My location',
                                dropOffLocation: 'Delivery location'
                            }
                        },
                        {
                            text: 'Pick up a dealer trade',
                            startsAtDealer: false,
                            tripWorkFlowId: 19,
                            customerFieldsLabel: 'PICK UP FROM',
                            placeHolders: {
                                customerLocation: 'Pick up location',
                                dropOffLocation: 'My location'
                            }
                        },
                        {
                            text: 'Swap dealer trades',
                            startsAtDealer: true,
                            tripWorkFlowId: 20,
                            customerFieldsLabel: 'DELIVER TO/PICK UP FROM',
                            placeHolders: {
                                customerLocation: 'My location',
                                dropOffLocation: 'Pick up/delivery location'
                            }
                        }
                    ]
                },
                {
                    value: 18,
                    badgeText: 'PO',
                    icon: null,
                    forceDisableDispatching: true,
                    supportsSecondVehicle: false,
                    supportsLyftAPI: true,
                    lyft: {
                        supportsServiceArea: true,
                        supportsRideTypes: false
                    },
                    supportsVehicleAssignment: false,
                    supportsDriverAssignment: false,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: true,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    overrideROSearchTripTypeId: 2,
                    placeHolders: {
                        customerLocation: 'LOCATION',
                        loanerPlaceHolder: 'Select type of delivery'
                    },
                    tripOptions: [
                        {
                            text: 'Deliver parts TO our location',
                            startsAtDealer: false,
                            tripWorkFlowId: 22,
                            customerFieldsLabel: 'PARTS PROVIDER',
                            placeHolders:
                            {
                                customerLocation: 'PICKUP LOCATION',
                                firstName: 'BUSINESS NAME'
                            }
                        },
                        {
                            text: 'Deliver parts FROM our location',
                            startsAtDealer: true,
                            tripWorkFlowId: 23,
                            customerFieldsLabel: 'PARTS RECIPIENT',
                            hideSmsInvite: true,
                            placeHolders:
                            {
                                customerLocation: 'DROPOFF LOCATION'
                            }
                        },
                        {
                            text: 'Deliver parts TO/FROM any location',
                            startsAtDealer: false,
                            tripWorkFlowId: 27,
                            serviceAdvisorOverrideFieldsLabel: 'PARTS PROVIDER',
                            customerFieldsLabel: 'PARTS RECIPIENT',
                            hideSmsInvite: true,
                            placeHolders:
                            {
                                customerLocation: 'PICKUP LOCATION',
                                dropOffLocation: 'DELIVERY LOCATION'
                            }
                        }
                    ]
                },
                {
                    value: 19,
                    badgeText: null,
                    icon: 'assets/images/lyft-small.png',
                    supportsSecondVehicle: false,
                    forceDisableDispatching: true,
                    supportsLyftAPI: true,
                    supportsVehicleAssignment: false,
                    supportsDriverAssignment: false,
                    supportsServiceNeeds: false,
                    supportsStartAtCustomer: false,
                    supportsLoanerVehicle: false,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false,
                    requiresGroupSelection: false,
                    supportsHomeAddress: false,
                    tripWorkFlowId: 24,
                    placeHolders: {
                        customerLocation: 'PICK UP LOCATION',
                        customerDate: 'PICK UP DATE',
                        customerTime: 'PICK UP TIME',
                        dropOffLocation: 'DROP OFF LOCATION'
                    }
                },
                {
                    value: 20,
                    badgeText: 'LO',
                    icon: null,
                    supportsLyftAPI: true,
                    overrideROSearchTripTypeId: 2
                },
                {
                    value: 21,
                    badgeText: 'AP',
                    icon: null,
                    supportsLyftAPI: false
                },
                {
                    value: 22,
                    badgeText: 'MS',
                    overrideName: 'MOBILE SERVICE',
                    icon: null,
                    supportsVehicleAssignment: true,
                    supportsDriverAssignment: true,
                    supportsSecondVehicle: false,
                    supportsServiceNeeds: true,
                    supportsStartAtCustomer: true, // TODO: confirm this
                    supportsLoanerVehicle: false,
                    supportsVehicleTrim: false,
                    requiresVehicleSelection: false, // for test drives and/or recalls
                    supportsHomeAddress: false,
                    requiresGroupSelection: false, // currently only for recall groups possibly might include other things later
                    tripOptions: null,
                    placeHolders: {
                        customerLocation: 'SERVICE LOCATION',
                        customerDate: 'SERVICE DATE',
                        customerTime: 'SERVICE TIME'
                    }
                }
            ],
            driverTripStates: {
                dispatching: 1,
                accepted: 2,
                enrouteToPickup: 3,
                atPickup: 4,
                enrouteToStop: 5,
                atStop: 6,
                enrouteToDropoff: 7,
                atDropoff: 8,
                reviewingCharges: 9,
                survey: 10,
                complete: 11,
                canceled: 12,
                returningViaChase: 13,
                vehicleReady: 14
            },
            systemTripType: {
                pickup: 1,
                dropoff: 2,
                testdrives: 8,
                personalDriver: 10,
                recalls: 11,
                lyftRoadSideAssistance: 12,
                lyftShuttleService: 13,
                deliverSoldVehicle: 15,
                inventoryTransport: 16,
                dealerTrade: 17,
                partsOnDemand: 18,
                lyftDriverReturn: 19,
                lyftCredit: 20,
                appointment: 21,
                mobileGarage: 22
            },
            stopType: {
                pickup: 0,
                dropoff: 1,
                stop: 2
            },
            providerRideTypes: {
                'lyft': 0,
                'lyft_line': 1,
                'lyft_plus': 2,
                'lyft_luxsuv': 3,
                'lyft_lux': 4,
                'lyft_premier': 5,
                'uber_delivery': 6
            },
            surveyQuestionType: {
                textBox: 0,
                dropdown: 1,
                textArea: 2,
                radio: 3,
                checkbox: 4
            },
            destinationType: {
                dealer: 0,
                customer: 1,
                other: 2,
                driverLocation: 3,
                genericPickup: 4,
                genericDropoff: 5,
                enrollPodGood: 6,
                enrollPodBad: 7
            },
            dmsSystemEnum: {
                None: 0,
                CDK: 1,
                DealerTrack: 2,
                ReynoldsPOWER: 3,
                ReynoldsERA: 4,
                AutoMate: 5,
                Motive: 6,
                Tekion: 7, 
                Other: 9
            },
            dmsSystem: [
                {value: 0, text: 'None'},
                {value: 1, text: 'CDK'},
                {value: 2, text: 'DealerTrack'},
                {value: 3, text: 'Reynolds - POWER'},
                {value: 4, text: 'Reynolds - ERA'},
                {value: 5, text: 'Auto/Mate'},
                {value: 6, text: 'Motive'},
                {value: 7, text: 'Tekion'},
                {value: 9, text: 'Other'}
            ],
            dmsPackageLevelEnum: {
                Basic: 0,
                Premium: 1,
                Inspect: 2
            },
            dmsPackageLevels: [
                {value: 0, text: 'Basic'},
                {value: 1, text: 'Premium'},
                {value: 2, text: 'Inspect'},
            ],
            motiveDataSourceEnum: {
                Mock: 0,
                AutoSoft: 1,
                AutoMate: 2,
                Dominion: 3,
                Quorum: 4,
                PBS: 5
            },
            motiveDataSource: [
                {value: 0, text: 'Mock'},
                {value: 1, text: 'AutoSoft'},
                {value: 2, text: 'AutoMate'},
                {value: 3, text: 'Dominion'},
                {value: 4, text: 'Quorum'},
                {value: 5, text: 'PBS'}
            ],
            loanerManagementSystems: [
                {value: 0, text: 'None'},
                {value: 1, text: 'RedCap'},
                {value: 2, text: 'DealerWare'},
                {value: 3, text: 'TSD Legacy'},
                {value: 4, text: 'ARS'},
                {value: 5, text: 'TSD'}
            ],
            loanerActionsEnum: {
                CreateInvoice: 1,
                MarkAsInvoiced: 2,
                MarkAsPaid: 3,
                MarkAsPaidWithPoints: 4,
                MarkAsWaived: 5
            },
            loanerPaymentStatusEnum: {
                Unpaid: 0,
                Paid: 1,
                PaidWithPoints: 2,
                Waived: 3,
                Invoiced: 4
            },
            loanerActions: [
                {value: 1, text: 'Create Invoice'},
                {value: 2, text: 'Mark As Invoiced'},
                {value: 3, text: 'Mark As Paid'},
                {value: 4, text: 'Mark As Paid With Points'},
                {value: 5, text: 'Mark As Waived'}
            ],
            loanerManagementSystemsEnum: {
                None: 0,
                RedCap: 1,
                DealerWare: 2,
                TSD: 3,
                ARS: 4,
                TSDNew: 5
            },
            vehicleTransmissions: [
                {value: 0, text: 'Automatic'},
                {value: 1, text: 'Manual'}
            ],
            mapPinType: {
                dealership: 'dealership',
                customer: 'customer',
                stop: 'stop',
                driver: 'driver'
            },
            dmsPushTypesEnum: {
                None: 0,
                ConsumerAndApi: 1,
                ConsumerApiAndDash: 2
            },
            dmsPushTypes: [
                {value: 0, text: 'No'},
                {value: 1, text: 'Consumer and API'},
                {value: 2, text: 'Consumer, API and Dash'}
            ],
            tripCommunicationParticipantTypes: {
                driver: 1,
                customer: 2,
                dealer: 3
            },
            messagingPanelModes: {
                driverCustomer: 1,
                dealerDriver: 2,
                dealerCustomer: 3,
                customerDriver: 4,
                tripNotes: 5,
                dealerInfo: 6,
                internal: 7
            },
            appointmentLanguages: [
                {value: 'EN', text: 'ENGLISH'},
                {value: 'FR', text: 'FRENCH'},
                {value: 'SP', text: 'SPANISH'}
            ],
            supportedCountries: [
                {value: 'US', text: 'UNITED STATES'},
                {value: 'CA', text: 'CANADA'}
            ],
            lineItemSeverity: [
                {value: 0, text: 'None', cssClass: 'color-none'},
                {value: 1, text: 'Address Soon', cssClass: 'color-caution', icon: 'warning', tooltip: 'This item needs to be addressed now or very soon.', customerMessage: 'This item needs to be addressed soon.'},
                {value: 2, text: 'Address Immediately', cssClass: 'color-urgent', icon: 'error', tooltip: 'This item is critical and must be addressed immediately.', customerMessage: 'This item needs to be addressed immediately.'}
            ],
            appointmentServiceSeverity: [
                {value: 0, text: 'None', cssClass: 'color-none'},
                {value: 1, text: 'Address Soon', cssClass: 'color-caution', icon: 'warning', tooltip: 'This item needs to be addressed now or very soon.', customerMessage: 'This item needs to be addressed soon.'},
                {value: 2, text: 'Address Immediately', cssClass: 'color-urgent', icon: 'error', tooltip: 'This item is critical and must be addressed immediately.', customerMessage: 'This item needs to be addressed immediately.'}
            ],
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            calendarMonths: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            usStates: ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MH', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'PW', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'],
            usStateNames: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire,', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
            canadianProvinces: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'],
            useTripNameOverrides: false,
            invoiceLineItemTypes: {
                repairOrder: {id: 1, text: 'Repair Order'},
                loanerIncidentals: {id: 2, text: 'Loaner Incidentals'},
                partsAndAccessories: {id: 3, text: 'Parts and Accessories'},
                transportation: {id: 4, text: 'Transportation'},
                deposit: {id: 5, text: 'Deposit'},
                downPayment: {id: 6, text: 'Down Payment'},
                delivery: {id: 8, text: 'Delivery'},
                discount: {id: 9, text: 'Discount'},
                other: {id: 10, text: 'Other'},
                loanerUpcharge: {id: 11, text: 'Loaner Upcharge'}
            },
            invoiceStatus: {
                draft: 1,
                unpaid: 2,
                paid: 3,
                cancelled: 8
            },
            invoiceChargeTypes: {
                creditCard: 0,
                billToAccount: 1
            },
            reportTypes: {
                powerBI: 1,
                externalLink: 2,
                autopointSSO: 3,
                fabricServiceSuite: 4
            },
            phoneTypes: {
                unknown: 0,
                landline: 1,
                mobile: 2,
                voip: 3
            },
            paymentProcessorsEnum: {
                none: 0,
                cenPos: 1,
                cardConnect: 2,
                peri: 3
            },
            paymentProcessors: [
                {value: 0, text: 'None'},
                {value: 1, text: 'CenPos'},
                {value: 2, text: 'CardConnect'},
                {value: 3, text: 'Peri'}
            ],
            cenposStatus: {
                approved: 0,
                is3DSecureTransaction: 21
            },
            ownerCareRecommendationTypes: {
                details: 0,
                image: 1,
                video: 2,
                audio: 3
            },
            ownerCareItemStatus: {
                pass: 0,
                caution: 1,
                fail: 2
            },
            reportRoles: {
                everyone: 0,
                programAdmin: 1,
                systemAdmin: 2
            },
            hereObjectType: {
                map: 0,
                marker: 1,
                circle: 2,
                driver: 3
            },
            cflTransportationTypes: {
                firstAvailable: 1,
                chooseLoaner: 2,
                lyftCredit: 3
            },
            // TODO: WHY IS IT USING THIS AND NOT DISPLAY OR FRIENDLY NAME IN THE DB???
            consumerTripTypeNames: {
                pickup: {value: 1, text: 'Service Pickup'},
                dropoff: {value: 2, text: 'Service Dropoff'},
                testDrive: {value: 8, text: 'Test Drive'},
                recall: {value: 11, text: 'Recall'},
                vehicleDelivery: {value: 15, text: 'Concierge Delivery'},
                dealerTrade: {value: 17, text: 'Dealer Trade'},
                mobileGarage: {value: 22, text: 'Mobile Service'}
            },
            routeTypes: {
                estimated: 1,
                actual: 2
            },
            mediaTypes: {
                notSet: 0,
                photo: 1,
                video: 2
            },
            rideProviderCreditTypes: {
                repairOrder: 1,
                roadsideAssistance: 2,
                newVehicleSale: 3,
                specialEvent: 4,
                bulkUpload: 5,
                appointment: 6,
                loanerContract: 7
            },
            rideProviderBenefitTypes: {
                credits: 0,
                fixedFare: 1,
                fixedDiscount: 2,
                variableDiscount: 3
            },
            rideProviderGeoRestrictionTypes: {
                none: 0,
                pickupOrDropoff: 1,
                pickupAndDropoff: 2
            },
            lyftSandboxFlowTypes: [
                {name: 'Canceled By Driver After Accept', value: 0},
                {name: 'Canceled By Driver After Arrival', value: 1},
                {name: 'No Drivers Available', value: 2},
                {name: 'Passenger No Show', value: 3},
                {name: 'Cleaning Fee', value: 4}
            ],
            dispatchSystemTypes: {
                redCap: 1,
                silentDispatch: 2
            },
            rideProviderBenefitBatchStatuses: {
                notStarted: 0,
                processing: 1,
                processed: 2
            },
            driverCompanyType: {
                internal: 1,
                dns: 2,
                citron: 3
            },
            serviceGroupTypes: {
                previouslyDeclined: 1,
                recall: 2,
                recommendedMaintenance: 3,
                common: 4,
                manuallyAdded: 5
            },
            transportationViewModeEnum: {
                trip_list_no_map: 1,
                trip_list_with_map: 2,
                credits_list: 3,
                dispatch_list: 4
            },
            transportationViewModes: [
                {value: 1, icon: 'list', text: 'List', tooltip: 'Trip List View', hideFramedIn: false, broadcastEvent: 'tripListMapModeUpdated'},
                {value: 2, icon: 'chrome_reader_mode', text: 'Split', tooltip: 'Trip Map View', hideFramedIn: false, broadcastEvent: 'tripListMapModeUpdated'},
                {value: 3, icon: 'credit_card', text: 'Vouchers', tooltip: 'Manage Credits', hideFramedIn: true, broadcastEvent: 'tripListModeUpdated'},
                {value: 4, icon: 'headset_mic', text: 'Dispatch', tooltip: 'Dispatch Trips View', hideFramedIn: false, broadcastEvent: 'tripListMapModeUpdated'}
            ],
            appointmentAuthorizationStatusEnum: {
                pending: 1,
                ready: 2,
                complete: 3
            },
            appointmentAuthorizationStatus: [
                {value: 1, text: 'Pending'},
                {value: 2, text: 'Ready'},
                {value: 3, text: 'Complete'}
            ],
            searchTemplateTypes: {
                trip: 1,
                lyftCredit: 2,
                appointmentCalendar: 3,
                appointmentSortable: 4,
                appointmentCheckin: 5,
                appointmentAuthorization: 6,
                message: 7,
                payment: 8,
                contract: 9,
                fleet: 10,
                inspect: 11
            },
            uberPackageSize: [
                {value: 0, text: 'small'},
                {value: 1, text: 'medium'},
				{value: 2, text: 'large'},
				{value: 3, text: 'xlarge'}
            ],
            payType: {
                customer: 1,
                internal: 2,
                warranty: 3,
                serviceContract: 4
            },
            recommendationType: {
                inspection: 1,
                adHoc: 2,
                workRequestDiagnostic: 3
            },
            lineItemSource: {
                originalCustomerRequest: 1,
                inspection: 2,
                adHoc: 3,
                checkIn: 4
            },
            inspectStatusRole: {
                'BDCUser': 'BDC User',
                'ServiceManager': 'Manager',
                'Technician': 'Technician',
                'PartsAssociate': 'Parts',
                'ServiceAdvisor': 'Advisor'
            },
            sortOrder: {
                ascending: 0,
                descending: 1
            },            
            taxTypes: [
                {name: 'Fixed Taxes or Fee', value: true},
                {name: 'Variable Tax', value: false}
            ],
            taxFeeApplyType: [
                {name: 'Part Is Greater Than', value: 1},
                {name: 'Labor Is Greater Than', value: 2},
                {name: 'Total Is Greater Than', value: 3}
            ],
            matrixRateTypes: {
                rate: 1,
                price: 2
            },
            rateTypes: {
                fixed: 1,
                matrix: 2
            },
            eventNames: {
                locationTabCanChange: 'locationTabCanChange'
            },
            hiddenRoles: ["cpo", "marketing", "welcomepoint", "authorizations"],
            solidMigrationStatus: {
                notStarted: 0,
                inProgress: 1,
                completed: 2,
                dueDatePassed: 3,
                userExists: 4,
                userCreated: 5,
                dealerSolidMFADisabled: 6
            },
            dmsEnvironmentEnum: {
                staging: 1,
                production: 2
            },
            dmsEnvironmentTypes: [
                {value: 1, text: 'Staging'},
                {value: 2, text: 'Production'}
            ],
            UberRideTypes: {
                uberX: 'UberX',
                uberXL: 'UberXL',
                uberBlack: 'Black',
                uberBlackSUV: 'Black SUV',
                uberAssist: 'Assist',
                uberComfort: 'Comfort',
                uberWAV: 'WAV',
                uberPet: 'Uber Pet',
            }
        })

        .constant('LoanerErrors',
        {
            reservationNotFound: "Couldn't find Reservation"
            //Add any additional errors here to be handled
        })
        .constant('SYSTEM_VARIABLES', {
            androidAppLink: 'https://play.google.com/store/apps/details?id=com.ionicframework.redcapdriverapp828621',
            iosAppLink: 'https://itunes.apple.com/us/app/car-drop/id1122815951',
            googleStoreImage: 'https://redcapstorage.blob.core.windows.net/automotivelogos/play-store.png',
            appleStoreImage: 'https://redcapstorage.blob.core.windows.net/automotivelogos/apple-store.jpeg',
            soleraLogoUrl: 'https://redcapstorage.blob.core.windows.net/automotivelogos/solera_symbol_150_black.png'
        })
       .constant('AUTOPOINT_PRODUCT_TYPE', {
            welcomePoint: 1,
            multiPoint: 2,
            cpo: 3,
            checkinandinspectreport: 4,
            inspectionFormEditor: 5,
            welcomePointAdminSettings: 6,
            apDealerSettings: 7
        })
        .constant('APPOINTMENTSTATUS_LABELS', {
            canceled: 'Canceled',
            walkin: 'Walk In',
            new: 'Booked',
            draft: 'Draft',
            imported: 'Imported',
            checkedIn: 'Checked In',
            arrived: 'Arrived',
            repairOrderCreated: 'RO Created',
            noShow: 'No Show',
            checkingIn: 'Checking In'
        })
        .constant('APPOINTMENT_SEARCHTYPE', {
            customerId: 1,
            customerPhone: 2
        })
        .constant('TAGGED_INPUT_MAX_SUGGESTIONS', 500)
        .constant('APPOINTMENT_APPOINTMENTSTATUS', {
            new: 1,
            canceled: 2,
            walkIn: 16,
            checkingIn: 15,
            checkedIn: 3,
            inProgress: 4,
            completed: 5,
            arrived: 6,
            imported: 7,
            draft: 12,
            repairOrderCreated: 13,
            noShow: 14
        })
        .constant('APPOINTMENT_CUSTOMERTYPE', {
            notSet: 0,
            individual: 1,
            business: 2
        })
        .constant('APPOINTMENT_PHOTOTYPE', {
            commonServices: 0,
            recommendedMaintenance: 1,
            recall: 2,
            vehicleCondition: 3,
            authorizedService: 4,
            preDefinedMedia: 5,
            vehicleOverview: 6
        })
        .constant('APPOINTMENT_TRANSPORTATION_TYPE_GROUP', {
            pickup: 'pickup',
            dropoff: 'dropoff',
            mobile: 'mobile'
        })
        .constant('APPOINTMENT_TRANSPORTATION_TYPE', {
            dropOff: 1,
            waiter: 2,
            shuttle: 3,
            dropOffLoaner: 4,
            pickupLoaner: 5,
            pickupNoLoaner: 6,
            rideshareCredits: 7,
            mobileGarage: 8
        })
        .constant('APPOINTMENT_PAYTYPES', [
            {value: 'C', text: 'Customer'},
            {value: 'I', text: 'Internal'},
            {value: 'W', text: 'Warranty'},
            {value: 'S', text: 'Service Contract'}
        ])
        .constant('APPOINTMENT_RECALL_OPCODE_TYPE', {
            delimited: 1,
            prefix: 2,
            tsbId: 3
        })
        .constant('CONSTRAINT_REASON_CODES', {
            Appointment_DateAlreadyPassed: 0,
            Appointment_TimeAlreadyPassed: 1,
            Appointment_TimeBeforeBuffer: 2,
            Appointment_TimeBeforeBuffer_Loaner: 3,
            Appointment_TimeAlreadyBookedForAdvisor: 4,
            Appointment_TimeAlreadyBookedForAllAdvisors: 5,
            Dealership_OutsideHours: 6,
            Dealership_Closed: 7,
            Dealership_Holiday: 8,
            Transportation_UnavailablePickupTime: 9,
            BusinessClosed: 10,
            UnderCapacity: 11,
            UnderCapacityDueToScheduledLaborHours: 12,
            UnderCapacityDueToAdvisorOff: 13,
            UnderCapacityDueToAllAdvisorsOff: 14,
            UnderCapacityDueToTechnicianOff: 15,
            AllServicesMustBeInDepartmentOpCodeList: 16,
            ServiceCannotExceedNumberOfOccurrenceLimitPerDay: 17,
            ServiceCannotExceedNumberOfOccurrenceLimitPerHour: 18,
            TransportationCannotExceedNumberOfOccurrenceLimitPerDay: 19,
            TransportationCannotExceedNumberOfOccurrenceLimitPerHour: 20,
            AppointmentCannotExceedNumberOfOccurrenceLimitPerDay: 21,
            AppointmentCannotExceedNumberOfOccurrenceLimitPerHour: 22,
            LoanerNotAvailable: 23
        })
        .constant('APPOINTMENT_CONSTRAINT_DEFINITION_TYPE', {
            advisorOff: 1,
            advisorSchedule: 2,
            businessClosed: 3,
            opCode: 4,
            technicianOff: 5,
            transportation: 6,
            appointment: 7,
            loaner: 8,
            appointmentBuffer: 9
        })
        .constant('CONSUMER_APPS_TYPE', {
            serviceValet: 0,
            payment: 1,
            appointment: 2,
            ownerCare: 3
        })
        .constant('CONSUMER_APPOINTMENT_BOOKING_EXPERIENCE', {
            standard: 1,
            ghostGarage: 2,
            multipleDepartments: 3
        })
        .constant('MEDIA_TYPES', {
            notSet: 0,
            photo: 1,
            video: 2
        })
        .constant('APPOINTMENT_SERVICE_SYSTEM_OPCODE_TYPE', {
            generic: 1,
            recall: 2,
            maintenance: 3,
            automaticPickup: 4,
            automaticLoaner: 5,
            automaticSMSOpt: 6,
            customAutomaticOpCode: 7
        })
        .constant('FIELD_IS_REQUIRED', 'Field is required.')
        .constant('SAVED_SEARCHES_PLACEHOLDER', 'SAVED SEARCHES')
        .constant('OLDER_VEHICLES', 'OLDER VEHICLES')
        .constant('NON_EDITABLE_USERROLES_CSV', 'ProgramAPI,ReynoldsAPI')
        .constant('USER_TITLES', ['BDC Representative', 'General Manager', 'Sales Manager', 'Sales Representative', 'Service Advisor', 'Service Manager', 'Service Director'])
        .constant('ALPHANUMERIC', 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890')
        .constant('MOMENTJS_FORMAT', 'YYYY-MM-DD"T"HH:mm:ss.fffffff"Z"')
        .constant('DASHBOARD_VERSION', '0.207.00');
})();

(function () {
    'use strict';

    config.$inject = ["$logProvider", "$locationProvider", "$compileProvider", "$httpProvider", "$translateProvider", "$uibTooltipProvider", "HERE_MAPS_CONFIG", "toastrConfig", "localStorageServiceProvider", "HereMapsConfigProvider"];
    angular
        .module('redcap')
        .config(config);

    function config($logProvider, $locationProvider, $compileProvider, $httpProvider, $translateProvider, $uibTooltipProvider, HERE_MAPS_CONFIG, toastrConfig, localStorageServiceProvider, HereMapsConfigProvider) {

        // CLEAN URLS
        $locationProvider.hashPrefix('!');
        $locationProvider.html5Mode({ enabled: true, requireBase: false });

        $httpProvider.interceptors.push('authInterceptor');

        $uibTooltipProvider.options({
            placement: 'auto bottom'
        });

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|sms|tel|mailto|chrome-extension):/);

        configLogging();
        configLocalStorage();
        configToastr();
        configTranslation();
        configHereMaps();

        function configLogging() {
            // console level is default and outuputs all levels

            $httpProvider.interceptors.push('logToServerInterceptor');

            var consoleOptions = JL.createConsoleAppender('consoleAppender')
                                   .setOptions({
                                        onceOnly: ['$digest', 'defined'],
                                        level: 1000          //
                                        // level: 4000       // production level value
            });
            var ajaxOptions = JL.createAjaxAppender('ajaxAppender')
                                .setOptions({
                                    onceOnly: ['$digest', 'defined'],
                                    level: 4000,
                                    batchSize: 5
            });

            // sets global javascript errors to server
            // JL.setOptions({
            //     onceOnly: ['$digest', 'defined'],
            //     appenders: ajaxOptions,
            //     defaultAjaxUrl: API_SETTINGS.apiServiceBaseUri + 'jsnlog.logger'
            // });
            // sets angular ($log) errors based on level to console or server
            JL('Angular').setOptions({
                onceOnly: ['$digest', 'defined'],
                appenders: consoleOptions   //[consoleOptions, ajaxOptions]
            });
            // logs angular ($http) exceptions to server
            // JL('Angular.Ajax').setOptions({
            //     onceOnly: ['$digest', 'defined'],
            //     appenders: ajaxOptions
            // });

            window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
                return false;
            };
        }

        function configLocalStorage() {
            var cookieDomainName = window.location.hostname;
            if (cookieDomainName === 'localhost') cookieDomainName = '';
            localStorageServiceProvider
                .setPrefix('rcValetDashboard')
                .setStorageCookie(90, '/')
                .setStorageCookieDomain(cookieDomainName);
        }

        function configToastr() {
            angular.extend(toastrConfig, {
                allowHtml: true,
                autoDismiss: false,
                closeButton: false,
                closeHtml: '<button>&times;</button>',
                containerId: 'toast-container',
                iconClasses: {
                    error: 'toast-error',
                    info: 'toast-info',
                    success: 'toast-success',
                    warning: 'toast-warning'
                },
                maxOpened: 0,
                messageClass: 'toast-message',
                newestOnTop: true,
                onHidden: null,
                onShown: null,
                positionClass: 'toast-top-right',
                preventDuplicates: false,
                preventOpenDuplicates: false,
                progressBar: false,
                tapToDismiss: true,
                target: 'body',
                templates: {
                    toast: 'directives/toast/toast.html',
                    progressbar: 'directives/progressbar/progressbar.html'
                },
                "showDuration": "400",
                "hideDuration": "800",
                "timeOut": "4000",
                "extendedTimeOut": "1000",
                titleClass: 'toast-title',
                toastClass: 'toast',
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            });
        }

        function configTranslation() {
            $translateProvider.useStaticFilesLoader({
                prefix: '/assets/translation/',
                suffix: '.txt'
            });

            $translateProvider.preferredLanguage('en');
            $translateProvider.useSanitizeValueStrategy('escape');
        }

        function configHereMaps() {
            HereMapsConfigProvider.setOptions({
                apiKey: HERE_MAPS_CONFIG.apiKey,
                apiVersion: '3.1',
                useHTTPS: true,
                useCIT: false,
                mapTileConfig: HERE_MAPS_CONFIG.normalViewSettings
            });
        }
    }
})();

(function () {
    'use strict';

    function classPropertyIterator(model, classObj) {
        for (let prop in model) {
            try {
                if (classObj[prop] !== undefined) {
                    classObj[prop] = model[prop];
                }
            } catch (err) {
                console.error(err);
            }
        }

        return classObj;
    }

    // TODO: we shouldn't ever be managing client-side code like this.  It creates an extremely tight coupling between client and server and
    //  makes the code much more difficult to maintain.  We should remove all references to this in the future, and instead let the object
    //  coming from the server be used directly.  A separate object can be created to only house the properties necessary to create an initial appointment
    angular.module('redcap.appointment.classes', [])
        .value('appointmentClass', {
            new: function (model) {
                const injector = angular.injector(['ng', 'redcap.constants']);
                const enums = injector.get('SYSTEM_ENUMS');

                let a = {
                    // Domain specific properties
                    id: null,
                    dealerId: 0, // this is the .location property I'm setting in the UI
                    dealerName: null,
                    dealerTimeZoneId: null,
                    dealerLat: null,
                    dealerLng: null,
                    dealerDMSSystem: null,
                    dealerEnableDispatchControls: false,
                    apptId: null, // string
                    vehicleId: '',
                    vin: '',
                    make: '',
                    makeName: '',
                    year: '',
                    model: '',
                    subModel: '',
                    modelName: '',
                    licensePlate: '',
                    mileage: null, // int?
                    dmsMileage: null, // int?
                    contactId: null, //int?
                    customerId: '',
                    customerPhone: '',
                    customerEmail: '',
                    customerAddress1: '',
                    customerAddress2: '',
                    customerCity: '',
                    customerState: '',
                    customerZip: '',
                    customerLanguage: null,
                    language: '',
                    customerCounty: '',
                    customerCityStateZip: '',
                    customerCountryShortCode: 'US',
                    apptDateTime: null, // DateTime?
                    apptDate: '',
                    apptOpenDateTime: null, // DateTime?
                    apptTime: '',
                    promiseDateTime: null, // DateTime?
                    dealerTransportationTypeId: null, // int?
                    transType: '',
                    serviceAdvisorNumber: '',
                    xTimeAppointmentId: '',
                    comments: '',
                    customerType: null,
                    customerCompany: '',
                    customerFirstName: '',
                    customerLastName: '',
                    dealerAddress: {
                        streetAddress: null,
                        city: null,
                        state: null,
                        zip: null,
                        countryShortCode: null
                    },
                    dealerEmployeeId: null, //int?
                    dealerEmployeeFirstName: null,
                    dealerEmployeeLastName: null,
                    dealerEmployeeOfficePhone: null,
                    dealerServiceOrderId: null, //int?
                    dealerServiceOrderTripId: null, //int?
                    tripWorkflowId: null, //int?
                    doNotEmailCustomer: null, //bool?
                    doNotTextCustomer: null, //bool?
                    departmentId: null, //int?
                    appointmentStatus: 0,
                    statusLastChanged: '',
                    bookingSource: null, //int?
                    bookingSourceDescription: null, //string
                    recallOpCodeType: null, // int?
                    recallOpCode: null, // string
                    recallPrefix: null, // string
                    importedAppointmentFields: false, // bool
                    createdByIdentityUserId: null, //string
                    createdByIdentityUserFirstName: null, //string
                    createdByIdentityUserLastName: null, //string
                    cancellationDate: null, //DateTime?
                    cancellationReason: null, //string
                    cancellationIdentityUserId: null, // string - FK reference, ensure it's null if not set
                    cancellationIdentityUserFirstName: null,
                    cancellationIdentityUserLastName: null,
                    cancellationSource: null, //int?
                    dateCreated: new Date(), // This gets overwritten on the server, but is required bc the binding model expects it... because it's used for both edits and creates.  We need to redo all of this,
                    tripNote: null,
                    lineItems: [],
                    canEdit: false, // bool
                    canCancel: false, // bool
                    canArrive: false,
                    canCheckIn: false,
                    canChangeDriver: false,
                    tripPickupTime: null,
                    tripPickupLocation: null,
                    tripDriver: null,
                    tripStateName: null,
                    tripState: null,
                    tripStops: null,
                    isManual: null, // bool
                    tripExpectedStartTime: null,
                    tripExpectedEndTime: null,
                    loanerContractId: null, // long?
                    loanerConfirmationNumber: null, // string
                    tripId: null,
                    addingNew: false,
                    mobileSmsOptedIn: false,
                    canUseDefaultDepartment: false,
                    defaultDealerDepartmentId: null,
                    mileageType: enums.odometerTypes.find((ot) => ot.type === enums.measurementTypes.imperical),
                    urlKey: null,
                    disableNotifications: false,
                    overrideTimeSlot: false,
                    bypassValidation: false,
                    pendingRideDetails: null,
                    isWalkin: false,
                    dmsOutOfSync: false,
                    dmsSyncError: null,
                    disableDMSPush: false,
                    lengthOfLoan: null,
                    repairOrderId: null,
                    multiPointDealerId: null,
                    isCheckinSkipped: false,
                    dmsApptNumber: null
                };

                return classPropertyIterator(model, a);
            }
        })
        .value('appointmentLineItemClass', {
            new: function (model) {
                let a = {
                    // Domain specific properties
                    id: null, // int
                    dealerId: null, // int
                    apptId: null, // string
                    opCode: '',
                    opCodeDescription: '',
                    dispatchCode: null, // string
                    genericName: null,
                    overrideName: null,
                    overrideDescription: null,
                    note: '',
                    serviceType: null, // string
                    payType: 'C', // string
                    retailPrice: 0, // decimal?
                    laborHours: 1, // decimal?
                    dealerAppointmentId: null, // int?
                    dealerAppointmentServiceOpCodeId: null, // int?,
                    dealerAppointmentServiceOpCode: null,
                    isAutomatic: null, // bool
                    isEnabled: null, // bool
                    isGeneric: null, // bool
                    isRecall: null, // bool
                    isRecommendedMaintenance: null, // bool
                    isOther: false,
                    manufacturerNumber: '', // string
                    nhtsaId: null, 
                    recallDisplayName: null, 
                    // View model specific properties,
                    consumerName: null,
                    dashboardName: null,
                    consumerDescription: null,
                    dashboardDescription: null,
                    dashSortOrder: null,
                    consumerSortOrder: null,
                    uniqueCnt: null,
                    createdByUser: {
                        firstName: null,
                        lastName: null,
                        isConsumerUser: null,
                        id: null
                    }
                };

                return classPropertyIterator(model, a);
            }
        })
        .value('appointmentServiceOpCodeClass', {
            new: function (model) {
                let a = {
                    // Domain specific properties
                    id: null,
                    overrideName: null,
                    consumerName: null,
                    dashboardName: null,
                    consumerDescription: null,
                    dashboardDescription: null,
                    showInConsumer: false, // default
                    showInDashboard: false, // default
                    recallOpCodeType: null, // int?
                    opCode: '',
                    defaultConsumerNote: '',
                    defaultDashboardNote: '',
                    showDefaultConsumerNote: false,
                    prefix: null, // string
                    dispatchCode: null,
                    serviceType: null,
                    payType: 'C', // default
                    retailPrice: 0, // default
                    laborHours: 1, // default
                    isAutomatic: false,
                    isEnabled: false,
                    isGeneric: false,
                    isRecall: false,
                    isRecommendedMaintenance: false,
                    dealerId: null,
                    dealerSystemAppointmentServiceId: null,
                    defaultDealerDepartmentId: null,
                    isDeleted: false,
                    dealerDepartmentId: null,
                    // View model specific properties
                    name: '',
                    description: '',
                    dashSortOrder: null,
                    consumerSortOrder: null
                };

                a = classPropertyIterator(model, a);

                // Default values for the UI
                if (!a.consumerName) {
                    a.consumerName = a.name;
                }

                if (!a.dashboardName) {
                    a.dashboardName = a.name;
                }

                if (!a.consumerDescription) {
                    a.consumerDescription = a.description;
                }

                if (!a.dashboardDescription) {
                    a.dashboardDescription = a.description;
                }

                return a;
            }
        })
        .value('appointmentRecurrenceOptionClass', {
            new: function (model) {
                let a = {
                    repeatAnnually: false, // boolean
                    repeatDaily: false, // boolean
                    repeatOnTheDate: false, // boolean
                    repeatMonday: false,
                    repeatTuesday: false,
                    repeatWednesday: false,
                    repeatThursday: false,
                    repeatFriday: false,
                    repeatSaturday: false,
                    repeatSunday: false,
                    recurrenceDay: null, // number
                    recurrenceNthDayOfWeek: null, //number
                    recurrenceDayOfWeek: null, //number;
                    recurrenceMonth: null, //number;
                    startDate: null, // date
                    startTime: null, // time
                    endDate: null, // date
                    endTime: null, // time

                    text: null //string;
                };

                return classPropertyIterator(model, a);
            }
        });
})();

(function () {
    'use strict';

    angular.module('logToServer', [])
            .service('$log', function () {
                this.log = function (msg) {
                    JL('Angular').trace(msg);
                };

                this.debug = function (msg) {
                    JL('Angular').debug(msg);
                };

                this.info = function (msg) {
                    JL('Angular').info(msg);
                };

                this.warn = function (msg) {
                    JL('Angular').warn(msg);
                };

                this.error = function (msg) {
                    JL('Angular').error(msg);
                };
            })
            .factory('$exceptionHandler', function () {
                return function (exception, cause) {
                    JL('Angular').fatalException(cause, exception);
                    setTimeout(function() {
                        throw exception;
                    }, 0);        
                };
            })
            .factory('logToServerInterceptor', ['$q', function ($q) {

                var myInterceptor = {
                    'request': function (config) {
                        config.msBeforeAjaxCall = new Date().getTime();
                        return config;
                    },
                    'response': function (response) {
                        if (response.config.warningAfter) {
                            var msAfterAjaxCall = new Date().getTime();
                            var timeTakenInMs = msAfterAjaxCall - response.config.msBeforeAjaxCall;
                            if (timeTakenInMs > response.config.warningAfter) {
                                JL('Angular.Ajax').warn({ "timeTakenInMs": timeTakenInMs, config: response.config, data: response.data });
                            }
                        }

                        return response;
                    },
                    'responseError': function (rejection) {
                        var errorMessage = "timeout";
                        if (rejection && rejection.status && rejection.data) {
                            errorMessage = rejection.data.ExceptionMessage;
                        }

                        JL('Angular.Ajax').fatalException({ errorMessage: errorMessage, status: rejection.status, config: rejection.config }, rejection.data);
                        return $q.reject(rejection);
                    }
                };

                return myInterceptor;
            }]);
})();
angular.module('redcap').run(['$templateCache', function($templateCache) {$templateCache.put('app/areas/checkin/checkin.view.html','<div class="row display-flex full-height margin-right-none" aside-parent="vm.childScopeForm" id="appointment-checkin-modal"><form name="checkInForm" class="col-md-8 col-xs-12 padding-right-none separate-left-aside-panel" id="appointment-checkin-content"><div class="display-flex flex-column overflow-hidden full-height"><div ng-if="!vm.checkinSettings.roHistoryPanelOpen" class="text-uppercase font-size-16 font-bold padding flex-fullwidth-50h border-radius-top-7 theme-bg display-flex align-items-center"><qr-code url="vm.checkinUrl" container-id="qrcode-checkin-{{vm.appointment.id}}" logo-path="{{vm.soleraLogoUrl}}" ng-if="vm.checkinUrl" class="hidden-xs hidden-sm"></qr-code><div ng-if="!vm.checkinUrl && !vm.checkinComplete" class="display-flex content-center width-px-96 height-px-96 hidden-xs hidden-sm"><img src="assets/images/ajax-loader.gif"></div><div class="margin-left-md">Checking In {{ vm.appointment.customerFirstName }} {{vm.appointment.customerLastName}}</div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white color-default"><vehicle-ro-history ng-if="vm.checkinSettings.roHistoryPanelOpen" vin="vm.appointment.vin" make="vm.appointment.make" model="vm.appointment.model" year="vm.appointment.year" dealer-id="vm.appointment.dealerId"></vehicle-ro-history><div class="padding" ng-if="!vm.checkinSettings.roHistoryPanelOpen"><checkin-verify-customer ng-if="vm.currentStep.stepType === vm.checkInStepTypes.verifyCustomer" appointment="vm.appointment" appointment-statuses="vm.appointmentStatuses" dealer-departments="vm.dealerDepartments" service-advisors="vm.serviceAdvisors" customer-phone-changed="vm.updateContactForMessagingPanel" register-step-fn="vm.registerStepProcessor" has-checkin-data-changed="vm.hasCheckInDataChanged()"></checkin-verify-customer><checkin-verify-vehicle ng-if="vm.currentStep.stepType === vm.checkInStepTypes.verifyVehicle" appointment="vm.appointment" service-advisors="vm.serviceAdvisors" is-loading="vm.isLoading" register-step-fn="vm.registerStepProcessor"></checkin-verify-vehicle><checkin-add-services ng-if="vm.currentStep.stepType === vm.checkInStepTypes.addServices" appointment="vm.appointment" dealer-departments="vm.dealerDepartments" has-checkin-data-changed="vm.hasCheckInDataChanged()" is-loading="vm.isLoading" register-step-fn="vm.registerStepProcessor" checkin-settings="vm.checkinSettings"></checkin-add-services><checkin-transportation-options ng-if="vm.currentStep.stepType === vm.checkInStepTypes.transportationOptions" appointment="vm.appointment" is-loading="vm.isLoading" departments="vm.dealerDepartments" register-step-fn="vm.registerStepProcessor"></checkin-transportation-options><authorize-services ng-if="vm.currentStep.stepType === vm.checkInStepTypes.authorizeServices" appointment="vm.appointment" is-loading="vm.isLoading" show-checkin-summary="vm.checkinComplete" register-step-fn="vm.registerStepProcessor"></authorize-services></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 padding-top-md"><div class="padding-md"><div ng-if="vm.checkinSettings.roHistoryPanelOpen" class="text-right padding-left-none"><button type="button" class="btn btn-primary text-uppercase" ng-click="vm.checkinSettings.roHistoryPanelOpen = false">BACK</button></div><div class="display-flex content-center" ng-if="!vm.checkinSettings.roHistoryPanelOpen"><span class="spinner-text" ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"> Processing</span> <span class="display-flex content-center flex-right flex-gap-sm"><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeCheckin()" ng-disabled="vm.isLoading">Close</button> <button type="button" class="btn btn-default text-uppercase" ng-if="vm.showCancelBtn()" ng-click="vm.cancelCheckin()" ng-disabled="vm.isLoading">Cancel</button> <button type="button" class="btn btn-default text-uppercase" ng-if="vm.showBackBtn()" ng-click="vm.backClicked()" ng-disabled="vm.isLoading">Back</button> <button type="button" class="btn btn-primary text-uppercase" ladda="vm.isLoading" ng-if="vm.showNextBtn()" ng-click="vm.nextClicked()" ng-disabled="!checkInForm.$valid">{{ vm.currentStep.isLastStep ? \'Complete\' : \'Next\' }}</button> <button type="button" class="btn btn-primary text-uppercase margin-right-sm" ng-if="vm.showGoToInspectBtn()" ui-sref="inspect({ tabType: vm.tabTypes.roDetail, dealerId: vm.appointment.dealerId, activeInspectTab: vm.detailTabTypes.services, customerName: vm.getCustomerName(), roId: vm.appointment.repairOrderId})">GO TO INSPECT</button></span></div></div></div></div></form><div id="appointments-messaging" class="col-md-4 col-xs-12 margin-left-md border-radius-top-7 separate-right-aside-panel message-component-rail flex-grow padding-none overflow-y-hidden"><div class="display-flex flex-column overflow-hidden full-height white-bg"><div class="flex-fullwidth-50h border-radius-top-7 visible-xs visible-sm theme-bg padding"><div class="padding-left-md"><aside-header constructed-title="vm.getCheckInTitle()"></aside-header></div></div><rc-summary-message-tab appointment="vm.appointment" disable-notes-tab="1" mobile-class="vm.messagePanelMobileClass"></rc-summary-message-tab></div></div></div>');
$templateCache.put('app/shared/modal/benefitbatchupdateconfirm.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.dismiss()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Update Batch?</h4></div><div class="modal-body">Individuals in this campaign have been modified. You can exclude them from this update or include them. If included, we can only extend dates, increase trips and/or benefit amounts, not decrease. If the changes are less than what they were given, they will be skipped and added to the error log.</div><div class="modal-footer"><button type="button" ng-click="vm.dismiss()" class="btn btn-default" data-dismiss="modal">Cancel</button> <button type="button" ng-click="vm.selectAll()" class="btn btn-default" data-dismiss="modal">All</button> <button type="button" ng-click="vm.skipModified()" class="btn btn-default" data-dismiss="modal">Skip Modified</button></div>');
$templateCache.put('app/shared/modal/cancelappointment.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.nevermind()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Cancel Appointment</h4></div><form role="form" id="cancelForm" name="cancelForm" ng-submit="vm.cancelAppointment()" novalidate=""><div class="modal-body"><div class="margin-bottom" ng-if="vm.reasons">Please tell us why you are cancelling:<br><span class="ng-hide validation text-danger" ng-show="cancelForm.$isSubmitted && cancelForm.cancellation_reason.$error.required">*Field is required</span><div class="form-group margin-top-xs"><select id="cancellation_reason" name="cancellation_reason" class="form-control" ng-model="vm.formData.cancellationReason" ng-required="true"><option value="">Select a reason...</option><option ng-repeat="r in vm.reasons" value="{{r}}">{{r}}</option></select></div><div class="form-group" ng-show="vm.formData.cancellationReason"><span class="ng-hide validation text-danger" ng-show="cancelForm.$isSubmitted && cancelForm.cancellation_reason_other.$error.required">*Field is required</span> <textarea id="cancellation_reason_other" class="resize-none" name="cancellation_reason_other" ng-model="vm.formData.otherDescription" ng-required="true" placeholder="Cancellation Reason"></textarea></div></div><div class="margin-bottom" ng-if="!vm.reasons"><p>Are you sure you wish to cancel this appointment?</p></div><div class="display-flex content-center inline-block"><input type="checkbox" class="checkbox margin-top-none inline" id="notifyCustomer" name="notifyCustomer" ng-model="vm.formData.notifyCustomer"> <label for="notifyCustomer" class="font-normal margin-left-sm margin-bottom-none inline-block">Notify Customer Of Cancellation</label></div></div><div class="modal-footer"><button type="button" ng-click="vm.nevermind()" class="btn btn-default" data-dismiss="modal">NEVERMIND</button> <button type="submit" class="btn btn-primary">CANCEL APPOINTMENT</button></div></form>');
$templateCache.put('app/shared/modal/canceltrip.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.nevermind()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Cancel Reservation</h4></div><form role="form" id="cancelForm" name="cancelForm" ng-submit="vm.cancelTrip()" novalidate=""><div class="modal-body"><div class="margin-bottom" ng-if="vm.reasons">Please tell us why you are cancelling:<br><span class="ng-hide validation text-danger" ng-show="cancelForm.$isSubmitted && cancelForm.cancellation_reason.$error.required">*Field is required</span><div class="form-group margin-top-xs"><select id="cancellation_reason" name="cancellation_reason" class="form-control" ng-model="vm.formData.cancellationReason" ng-required="true"><option value="">Select a reason...</option><option ng-repeat="r in vm.reasons" value="{{r}}">{{r}}</option></select></div><div class="form-group" ng-show="vm.formData.cancellationReason"><span class="ng-hide validation text-danger" ng-show="cancelForm.$isSubmitted && cancelForm.cancellation_reason_other.$error.required">*Field is required</span> <textarea id="cancellation_reason_other" name="cancellation_reason_other" class="resize-none" ng-model="vm.formData.otherDescription" ng-required="true" placeholder="Cancellation Reason"></textarea></div></div><div class="margin-bottom" ng-if="!vm.reasons"><p>Are you sure you wish to cancel this trip?</p></div><div class="margin-bottom text-danger" ng-if="vm.cancelWarningMessage"><p>{{ vm.cancelWarningMessage }}</p></div><div class="display-flex content-center inline-block"><input type="checkbox" class="checkbox margin-top-none inline" id="notifyCustomer" name="notifyCustomer" ng-model="vm.formData.notifyCustomer"> <label for="notifyCustomer" class="font-normal margin-left-sm margin-bottom-none inline-block">Notify Customer Of Cancellation</label></div><div ng-if="vm.trip.canPushToDms"><div class="form-inline form-group inline"><input type="checkbox" class="checkbox inline" id="pushToDms" name="pushToDms" ng-model="vm.formData.pushToDms"> <label for="pushToDms" class="inline">Cancel on <span ng-if="vm.bookingRules.isXTimeEnabled">XTime</span> <span ng-if="!vm.bookingRules.isXTimeEnabled">DMS</span></label></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.nevermind()" class="btn btn-default" data-dismiss="modal">NEVERMIND</button> <button type="submit" class="btn btn-primary">CANCEL TRIP</button></div></form>');
$templateCache.put('app/shared/modal/contactdriverhelp.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Contact Driver</h4></div><div class="modal-body text-center padding-left-none padding-right-none"><img width="100%" src="https://redcapstorage.blob.core.windows.net/campaigncontent/contact-driver.png"></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CLOSE</button></div>');
$templateCache.put('app/shared/modal/copy-tasks-results.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal">&times;</button><h4 class="modal-title"><span>Copy Task Results</span></h4></div><div class="modal-body">This location has been updated. <span ng-if="vm.excludedWorkflows.length">The trip type instances below were not found in the selected dealer and were not updated in the current location.<br><br></span><ul ng-if="vm.excludedWorkflows.length"><li ng-repeat="workflow in vm.excludedWorkflows">{{ workflow.name }}</li></ul></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CLOSE</button></div>');
$templateCache.put('app/shared/modal/customterms.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Terms</h4></div><div class="modal-body text-center"><div id="terms-display" ng-bind-html="vm.terms"></div></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CLOSE</button></div>');
$templateCache.put('app/shared/modal/dealer-list-modal.html','<div class="modal-header"><h3 class="modal-title">{{vm.title}}</h3></div><div class="modal-body"><form name="dealerListForm" class="form"><div class="form-group"><select data-placeholder-text-single="\'Select dealership...\'" class="form-control" name="selectedDealership" chosen="{width: \'100%\'}" search-contains="true" ng-model="vm.selectedDealership" ng-options="dealer as dealer.name for dealer in vm.dealerships"><option value=""></option></select></div></form></div><div class="modal-footer"><button class="btn btn-primary" ng-click="vm.submit()" ng-disabled="!vm.selectedDealership">OK</button> <button class="btn btn-default" ng-click="vm.cancel()">Cancel</button></div>');
$templateCache.put('app/shared/modal/detailedcheckinerror.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><div class="modal-body"><div ng-bind-html="vm.error"></div><div ng-if="vm.isDMSError === true" class="margin-top">The check in has been completed in our system but has not been saved or updated in the DMS. You can try editing the services or other details to correct the problem or contact Client Success for further assistance.</div></div><div class="modal-footer"><button type="button" ng-click="vm.close(true)" class="btn btn-primary" data-dismiss="modal">OK</button></div>');
$templateCache.put('app/shared/modal/detailederror.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><div class="modal-body"><div ng-bind-html="vm.error"></div><div ng-if="vm.isDMSError === true" class="margin-top">The appointment has been booked in our system but has not been saved or updated in the DMS. You can try editing the appointment to correct the problem or contact Client Success for further assistance.</div></div><div class="modal-footer"><button type="button" ng-click="vm.close(true)" class="btn btn-primary" data-dismiss="modal">OK</button></div>');
$templateCache.put('app/shared/modal/error.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><div class="modal-body" ng-if="vm.body"><p>{{ vm.body }}</p><ul class="list-unstyled"><li ng-repeat="error in vm.errors"><span ng-if="error.data"><strong>{{error.statusText}}:</strong> {{ error.data.exceptionMessage}}</span> <span ng-if="!error.data">{{error}}</span></li></ul></div><div class="modal-footer"><button type="button" ng-click="vm.close(true)" class="btn btn-primary" data-dismiss="modal">OK</button></div>');
$templateCache.put('app/shared/modal/helpmodal.html','<div class="modal-header help-modal"></div><div class="help-modal modal-body text-center"><div ng-if="vm.iconAlt"><span class="trip-type-badge trip-type-badge-black">{{ vm.iconAlt }}</span></div><div ng-if="vm.icon"><img ng-src="{{vm.icon}}"></div><div class="margin-top text-uppercase text-bold">{{vm.title}}</div><div class="margin-top help-text" ng-bind-html="vm.helpText"></div></div><div class="modal-footer help-modal"><button type="button" ng-click="vm.close(false)" class="btn btn-default" data-dismiss="modal">CLOSE</button> <a ng-click="vm.close(true)" class="btn btn-primary" data-dismiss="modal" ng-if="vm.yesText">{{vm.yesText}}</a></div>');
$templateCache.put('app/shared/modal/imageviewer.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title"><span ng-if="!vm.title">Trip Media</span> <span ng-if="vm.title">{{vm.title}}</span></h4></div><div class="modal-body text-center"><img ng-if="vm.type === vm.mediaTypes.photo" class="trip-image-viewer" ng-src="{{vm.image}}"><video id="videoViewer" ng-if="vm.type === vm.mediaTypes.video && !vm.videoError" controls="" class="border-default" ng-src="{{ vm.image | trustUrl }}" error="vm.handleVideoError()">Sorry, your browser doesn\'t support embedded videos.Click the link below to download it.</video><p ng-if="vm.videoError">Your browser doesn\'t support embedding this video. Click the link below to download it.</p></div><div class="modal-footer"><a href="{{ vm.image }}" class="padding-md" target="download" ng-if="!vm.downloadLinkFn && !vm.disableDownload">Download full size media</a> <a href="" class="padding-md" target="download" ng-if="vm.downloadLinkFn && !vm.disableDownload" ng-click="vm.downloadClicked()"><span ng-if="!vm.downloadLoading">Download full size media</span> <span ng-if="vm.downloadLoading">Generating link <img src="assets/images/ajax-loader.gif"></span></a> <button ng-show="vm.deleteAction" type="button" ng-click="vm.delete()" class="btn btn-default" data-dismiss="modal">DELETE</button> <button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CLOSE</button></div>');
$templateCache.put('app/shared/modal/landline-warning.html','<div class="modal-header ng-hide"></div><div class="modal-body padding-bottom-none"><div class="row"><div class="col-sm-1 col-xs-2"><i class="material-icons md-36">warning</i></div><div class="col-sm-11 col-xs-10"><p><b><span class="text-danger">NOTE:</span> <span>PHONE NUMBER IS A LANDLINE AND CANNOT RECEIVE TEXT MESSAGES. CLICK CANCEL TO CHANGE THE NUMBER OR CONTINUE WITHOUT NOTIFICATIONS.</span></b></p></div></div></div><div class="modal-footer border-none"><button type="button" ng-click="$dismiss()" class="btn btn-default" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="$close(true)" class="btn btn-primary">CONTINUE</button></div>');
$templateCache.put('app/shared/modal/lyft-refunds.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Ride Provider Refunds</h4></div><div class="modal-body text-center"><div class="form-group"><label class="control-label">Paste in a CSV string in the format of RideId,RefundDetails,RefundAmount (including headers) into the text box below:</label> <textarea class="form-control resize-none" ng-model="vm.refunds" rows="4"></textarea></div><div ng-if="vm.notFoundTrips">The following trips where not added successfully: {{vm.notFoundTrips}}</div></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CLOSE</button> <button type="button" ng-click="vm.submit()" class="btn btn-primary" ladda="vm.isLoading">SUBMIT</button></div>');
$templateCache.put('app/shared/modal/managelocations.html','<div class="modal-header"><h4 class="modal-title text-uppercase">Manage Locations</h4></div><form role="form" id="manageLocationsForm" name="manageLocationsForm" ng-submit="vm.addFavoriteLocation()" novalidate=""><div class="modal-body"><div id="add-location-row" class="form-group"><div class="row"><div class="col-xs-4 padding-sm first-col"><input type="text" ng-attr-placeholder="LOCATION ADDRESS" id="location_address" name="location_address" ng-model="vm.newLocation.address" class="form-control" details="vm.places" ng-required="true" here-places="" options="vm.options" handle-selected="vm.newLocationAddressUpdated(formattedAddress)"> <span class="ng-hide validation text-danger" ng-show="manageLocationsForm.$isSubmitted && manageLocationsForm.location_address.$error.required">*Required</span> <span class="ng-hide validation text-danger" ng-show="manageLocationsForm.$isSubmitted && vm.invalidAddress">*Invalid Address</span></div><div class="col-xs-3 padding-sm"><input type="text" id="location_name" name="location_name" ng-model="vm.newLocation.name" class="form-control" clean="true" placeholder="LOCATION NAME" ng-required="true"> <span class="ng-hide validation text-danger" ng-show="manageLocationsForm.$isSubmitted && manageLocationsForm.location_name.$error.required">*Required</span></div><div class="col-xs-2 padding-sm"><div class="form-group"><label class="col-sm-3 control-label padding-md">LAT</label><div class="col-sm-8 margin-top-md"><p class="form-control-static padding-none">{{ vm.mapCoords.lat }}</p></div></div></div><div class="col-xs-2 padding-sm"><div class="form-group"><label class="col-sm-3 control-label padding-md">LNG</label><div class="col-sm-8 margin-top-md"><p class="form-control-static padding-none">{{ vm.mapCoords.lng }}</p></div></div></div><div class="col-xs-1 padding-sm pull-right"><button type="submit" id="add-new-location" class="btn btn-block pull-right margin-right" alt="Add Location">+</button></div></div></div><div id="location-map" options="vm.mapOptions" redcap-map="" map-loaded="vm.mapLoaded"></div><table id="manage-locations-table" class="table table-fixed margin-top" ng-if="vm.favoriteLocations.length"><thead><tr><th data-sort-ignore="true" class="col-xs-5">Name (Address)</th><th data-sort-ignore="true" class="col-xs-2">Lat</th><th data-sort-ignore="true" class="col-xs-2">Lng</th><th data-sort-ignore="true" class="col-xs-3">Action</th></tr></thead><tbody><tr ng-repeat="data in vm.favoriteLocations"><td class="col-xs-5">{{ ::data.name }} ({{::data.address }}, {{::data.city }} {{::data.state }} {{::data.zip }} )</td><td class="col-xs-2">{{ ::data.lat }}</td><td class="col-xs-2">{{ ::data.lng }}</td><td class="col-xs-3 check_col"><input ng-if="!data.new" type="checkbox" class="checkbox inline" ng-checked="data.isRowSelected" ng-click="vm.toggleSelection(data)"><span ng-if="!data.new">&nbsp;DELETE</span> <span ng-if="data.new">NEW (UNSAVED)</span></td></tr></tbody></table></div><div class="modal-footer"><button type="button" ng-click="vm.cancel()" class="btn btn-default" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.save()" class="btn btn-primary">SAVE</button></div></form>');
$templateCache.put('app/shared/modal/newserviceorderwarning.html','<div class="modal-header ng-hide"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><form role="form" id="acknowledge_warning" name="acknowledge_warning" ng-submit="vm.createServiceOrder()" novalidate=""><div class="modal-body"><div class="row"><div class="col-sm-1 col-xs-2"><i class="material-icons">warning</i></div><div class="col-sm-11 col-xs-10"><p>You are about to create a new record (#{{vm.formData.roNumber}}). This will affect reporting and is not recommended. Are you sure you want to do this?</p></div></div></div><div class="modal-footer border-none"><button type="button" ng-click="vm.close(false)" class="btn btn-default" data-dismiss="modal">CANCEL</button> <button type="submit" class="btn btn-primary">CONTINUE</button></div></form>');
$templateCache.put('app/shared/modal/noshowappointment.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.nevermind()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">MARK THIS APPOINTMENT AS A NO SHOW?</h4></div><form role="form" id="cancelForm" name="cancelForm" ng-submit="vm.noshowAppointment()" novalidate=""><div class="modal-body"><div class="margin-bottom"><p>Are you sure you wish to mark this appointment as a no show?</p></div><div class="form-inline form-group inline"><input type="checkbox" class="checkbox inline" id="notifyCustomer" name="notifyCustomer" ng-model="vm.formData.notifyCustomer"> <label for="notifyCustomer" class="inline font-normal">Send customer missed appointment notification</label></div></div><div class="modal-footer"><button type="button" ng-click="vm.nevermind()" class="btn btn-default" data-dismiss="modal">NEVERMIND</button> <button type="submit" class="btn btn-primary">MARK AS NO SHOW</button></div></form>');
$templateCache.put('app/shared/modal/optedout-warning.html','<div class="modal-header ng-hide"></div><div class="modal-body padding-bottom-none"><div class="row"><div class="col-sm-1 col-xs-2"><i class="material-icons md-36">warning</i></div><div class="col-sm-11 col-xs-10"><p><b><span class="text-danger">NOTE:</span> <span>CUSTOMER HAS OPTED OUT OF TEXT MESSAGES AND WILL NOT RECEIVE TRIP NOTIFICATIONS. TO OPT IN, CUSTOMER MUST TEXT \'START\' TO {{ vm.detail.dealerPhone | tel }}</span></b></p></div></div></div><div class="modal-footer border-none"><button type="button" ng-click="$dismiss()" class="btn btn-default" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="$close(true)" class="btn btn-primary">CONTINUE</button></div>');
$templateCache.put('app/shared/modal/returntripdetails.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><div class="modal-body"><div ng-bind-html="vm.error"></div><div class="">The records below have been found and will be associated with this trip. If these are not the correct records or records were not found, please select the correct items on the next screen.</div><ul class="margin-top"><li ng-if="vm.roDetails"><b>RO #{{vm.roDetails.roNumber}}</b> - {{vm.roDetails.statusCodeDesc}} {{vm.appointmentDateTime}} for {{vm.roDetails.customerName1}} {{vm.roDetails.customerName2}} {{vm.roDetails.year}} {{vm.roDetails.make}} {{vm.roDetails.model}}</li><li ng-if="!vm.roDetails"><b>RO not found</b></li><li ng-if="vm.loanerNumber"><b>Loaner Agreement #{{vm.loanerNumber}}</b> - Opened {{vm.loanerDate}} for {{vm.loanerCustomer}}</li><li ng-if="!vm.loanerNumber"><b>Loaner Agreement not found</b></li></ul></div><div class="modal-footer"><button type="button" ng-click="vm.close(true)" class="btn btn-primary" data-dismiss="modal">OK</button></div>');
$templateCache.put('app/shared/modal/select-default-trip-type-user.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title upper-case">Select New Default User</h4></div><form role="form" id="selectActiveUserForm" name="" ng-submit="" novalidate=""><div id="selectActiveUserForm" class="modal-body overflow-y-auto modal-user-active"><div class="form-group margin-bottom-none"><div class="row"><div class="col-xs-12"><p class="margin-bottom-none">This user is set as the Default User at the locations/trip types below. Please select an active user from the dropdown to set as the default for these trip types. If you need additional assistance, please contact the Client Success Team.</p></div><div class="padding-bottom-none"><div ng-repeat="n in triptypes track by $index" class="col-xs-12 margin-top-md"><div class="col-sm-12 padding-none"><div class="col-sm-7 padding-none margin-top-md"><p class="bold">{{triptypes[$index].dealerName}}</p><p class="m-b-md text-capitalize">Trips: &nbsp; {{triptypes[$index].descriptionTripTypesName}}</p></div><div class="col-sm-5 margin-top-md margin-bottom-20 fake-required"><select data-placeholder-text-single="\'Select employee...\'" class="form-control" name="DefaultServiceAdvisor" chosen="{width: \'100%\'}" search-contains="true" max-shown-results="100" ng-model="employee" ng-change="vm.chooseEmployee(employee, triptypes[$index].dealerId)" ng-options="employee.id as employee.fullName for employee in triptypes[$index].filteredEmployees" validation="required:alt=Field is required."><option value=""></option></select></div></div><div class="block hr-line-fine"></div></div></div></div></div></div><div class="modal-footer"><div ng-if="!vm.areAllDropdownsFilled()" class="text-danger pull-left margin-top-sm">Please select a user for each dealer.</div><button type="submit" ng-click="vm.close(triptypes)" class="btn btn-primary" ng-disabled="!vm.areAllDropdownsFilled()">OK</button> <button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CANCEL</button></div></form>');
$templateCache.put('app/shared/modal/select-service-advisor.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()" aria-hidden="true">&times;</button><h4 class="modal-title">{{ vm.title }}</h4></div><div class="modal-body"><p>{{ vm.body }}</p><hr><div ng-if="vm.loadingDepartments" class="text-center padding-lg"><img src="assets/images/ajax-loader.gif"> Loading departments...</div><div class="form-group display-flex flex-row content-center padding-left-none padding-bottom-sm flex-xs-column" ng-repeat="locDept in vm.locationDepartments" ng-if="!vm.loadingDepartments"><label class="flex-percent-50 flex-xs-percent-100 padding-left-none margin-bottom-none"><strong ng-if="locDept.departmentName">{{locDept.locationName}} ({{locDept.locationCity}}): {{locDept.departmentName}}</strong> <strong ng-if="!locDept.departmentName">{{locDept.locationName}} ({{locDept.locationCity}})</strong></label><div class="flex-percent-50 flex-xs-percent-100"><div ng-if="vm.loadingAdvisors[locDept.key]" class="text-center"><img src="assets/images/ajax-loader.gif"> Loading advisors...</div><ui-select class="full-width" ng-model="vm.selectedAdvisors[locDept.key]" required="" ng-if="!vm.loadingAdvisors[locDept.key] && locDept.serviceAdvisors && locDept.serviceAdvisors.length > 0"><ui-select-match placeholder="Select a service advisor...">{{ $select.selected.fullName }}</ui-select-match><ui-select-choices repeat="advisor in locDept.serviceAdvisors | filter: $select.search"><span ng-bind-html="advisor.fullName | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-if="!vm.loadingAdvisors[locDept.key] && (!locDept.serviceAdvisors || locDept.serviceAdvisors.length === 0)" class="alert alert-warning"><i class="material-icons">warning</i> No service advisors available for this location/department.</div></div></div></div><div class="modal-footer border-top-none"><button type="button" ng-click="vm.cancel()" class="btn btn-default text-uppercase">Cancel</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ng-disabled="!vm.isAllSelectedValid()">OK</button></div>');
$templateCache.put('app/shared/modal/sendforapproval.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><div class="modal-body" ng-if="vm.body"><div ng-bind-html="vm.body" class="padding-bottom-md"></div><div class="display-flex flex-column margin-top-md"><div class="display-flex align-items-center flex-gap-sm"><span><input type="checkbox" ng-model="vm.isCustomerChecked"></span> <span class="padding-right-sm">Customer:</span> <span>{{ vm.customer.name }} &nbsp; {{ vm.customer.phone | tel }}</span></div><div class="display-flex flex-row-nowrap margin-top-md"><div class="display-flex align-items-center flex-gap-sm flex-static-size"><span><input type="checkbox" ng-model="vm.isAlternateChecked"></span> <span class="padding-right-sm">Alternate:</span><div class="flex-percent-33"><div class="block relative"><input type="text" class="form-control better-placeholder" ng-required="vm.isAlternateChecked" placeholder="First Name" ng-model="vm.alternateCustomer.firstName"></div></div><div class="flex-percent-33"><div class="block relative"><input type="text" class="form-control better-placeholder" ng-required="vm.isAlternateChecked" placeholder="Last Name" ng-model="vm.alternateCustomer.lastName"></div></div><div class="flex-percent-33"><div class="block relative"><input type="text" class="form-control better-placeholder" ng-required="vm.isAlternateChecked" placeholder="Mobile Phone" ng-model="vm.alternateCustomer.phone" mask="(999) 999-9999" mask-restrict="reject" clean="true"></div></div></div></div></div><div class="block relative margin-top-lg"><textarea class="form-control better-placeholder resize-none" id="messageText" placeholder="Message Text" rows="3" ng-model="vm.messageBody"></textarea></div></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">Cancel</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ladda="vm.isLoading" ng-disabled="!vm.isCustomerChecked && !vm.isAlternateChecked || (vm.isAlternateChecked && (!vm.alternateCustomer.firstName|| !vm.alternateCustomer.lastName || vm.alternateCustomer.phone.length !=10))" data-dismiss="modal">Send</button></div>');
$templateCache.put('app/shared/modal/show-phone-capture.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title text-uppercase">Contact Driver</h4></div><form role="form" id="tripSettingsForm" name="" ng-submit="" novalidate=""><div class="modal-body"><div class="form-group"><div class="row margin-bottom"><div class="col-xs-12"><p>We\'ll give you a call and connect you with the driver. Please enter your phone number below to get started.</p></div><div class="col-xs-12"><div class="visible-xs override-xs-padding-top-md">Phone number</div><input type="text" id="phone_number" name="phone_number" ng-model="vm.phoneCapture" class="form-control better-placeholder" required="" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="min_len:10|required:alt=Required"></div></div></div></div><div class="modal-footer"><button type="submit" ng-click="vm.close(vm.phoneCapture)" class="btn btn-primary" ng-disabled="vm.phoneCapture.length !== 10">OK</button> <button type="button" ng-click="vm.close(null)" class="btn btn-default" data-dismiss="modal">CANCEL</button></div></form>');
$templateCache.put('app/shared/modal/show-photo-capture.html','<div class="photo-capture"><div class="camera"><div ng-if="vm.showRecordingLimit" class="time-limit-modal"><div class="overlay"></div><div class="centered-content inner-modal"><div class="modal-header"><h4 class="modal-title">Recording Limit</h4></div><div class="modal-body">Videos can be up to 1 minute long. They will automatically stop recording and save once the limit has been reached</div><div class="modal-footer"><button type="button" ng-click="vm.showRecordingLimit = false" class="btn btn-primary" data-dismiss="modal">OK</button></div></div></div><div class="bottom-shadow"></div><div class="media-counter"><div class="photo-count" ng-if="!vm.mediaType || vm.mediaType === \'2\'"><i class="material-icons">video_library</i> {{ vm.videoCount }}</div><div class="photo-count" ng-if="!vm.mediaType || vm.mediaType === \'1\'"><i class="material-icons">photo_library</i> {{ vm.photoCount }}</div></div><video id="photo-capture-surface" autoplay="" playsinline="" muted="">Video stream not available.</video><audio id="camera-sound" src="../../../assets/sounds/camera-shutter.wav" preload="auto"></audio><div class="camera-controls text-center text-uppercase relative"><button class="pause-resume-button transparent-icon-button" ng-if="vm.isRecording" ng-click="vm.togglePauseResume()" title="{{ vm.isRecordingPaused ? \'Resume Recording\' : \'Pause Recording\' }}"><i class="material-icons font-size-30 control-white">{{ vm.isRecordingPaused ? \'play_circle_filled\' : \'pause_circle_filled\' }}</i></button><button id="capture-screen-btn" ng-click="vm.takePicture()" ng-class="{ \'is-recording\': vm.isRecording, \'paused\': vm.isRecordingPaused }" ng-disabled="vm.isLoading" title="{{ vm.isRecording ? \'Stop Recording\' : \'Start Recording\' }}" class="relative"><div ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"><div class="font-bold text-uppercase">Saving</div></div><div ng-if="!vm.isLoading && vm.isRecording"><i class="material-icons font-size-30">stop</i><div class="margin-top-sm">{{ vm.videoTimer }}</div></div></button><div class="capture-mode-toggle" ng-if="!vm.mediaType"><span class="mode-name" ng-click="vm.isVideo = false" ng-class="{\'selected\': !vm.isVideo }">Photo</span><switch ng-model="vm.isVideo" class="small-switch"></switch><span class="mode-name" ng-click="vm.isVideo = true" ng-class="{\'selected\': vm.isVideo }">Video</span></div></div><button ng-click="vm.finished()" id="done-capturing">Done</button></div><canvas id="photo-capture-canvas"></canvas></div>');
$templateCache.put('app/shared/modal/slideshow.html','<div class="modal-header border-none"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title text-capitalize" ng-if="vm.tutorial.title">{{ vm.tutorial.title }}: {{ vm.message }}</h4></div><div class="modal-body padding-top-none" ng-class="{\'padding-bottom-none\': vm.tutorial.slides.length === 1}"><ui-carousel class="tutorial" slides="vm.tutorial.slides" dots="true" on-after-change="vm.afterSlideChange(currentSlide)"><carousel-item><div ng-show="!item.isVideo"><img src="{{item.contentPath}}"></div><div ng-show="item.isVideo" class="video-wrapper"><video controls="" handle-video-events=""><source src="{{item.contentPath | trustUrl}}"></video></div></carousel-item><carousel-prev><button><i class="material-icons">keyboard_arrow_left</i></button></carousel-prev><carousel-next><button><i class="material-icons">keyboard_arrow_right</i></button></carousel-next></ui-carousel></div><div class="modal-footer border-none"><span ng-if="vm.disableClose">Complete the tutorial to close.</span> <button type="button" ng-click="!vm.disableClose && vm.close(true)" class="btn btn-default" ng-class="{\'disabled\':vm.disableClose}" data-dismiss="modal">Close</button></div>');
$templateCache.put('app/shared/modal/upgrade-message.html','<div class="modal-header help-modal"></div><div class="help-modal modal-body text-center"><div class="text-uppercase font-size-20 text-bold"><strong>{{vm.title}}</strong></div><div class="margin-top help-text" ng-bind-html="vm.message"></div></div><div class="modal-footer help-modal"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">OK</button></div>');
$templateCache.put('app/shared/modal/vin-not-found.html','<div class="modal-header"><h3>VIN Not Found</h3></div><div class="modal-body"><p>No record of this VIN.</p><p ng-if="bookingType === \'appointment-messages\'">Book an appointment for <strong>{{vin}}</strong><span ng-if="ymm">, {{ymm}}</span> at <strong>{{dealerName}}</strong>?</p><p ng-if="bookingType !== \'appointment-messages\'">Book a walk-in for <strong>{{vin}}</strong><span ng-if="ymm">, {{ymm}}</span> at <strong>{{dealerName}}</strong>?</p></div><div class="modal-footer"><button class="btn btn-primary" ng-click="confirm()">Continue</button> <button class="btn btn-default" ng-click="cancel()">Cancel</button></div>');
$templateCache.put('app/shared/modal/vin-scanner.html','<div id="vin-scan-modal-body"><div class="modal-header"><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="full-width-height position-relative"><svg class="dce-bg-loading position-absolute margin-auto" viewbox="0 0 1792 1792"><path d="M1760 896q0 176-68.5 336t-184 275.5-275.5 184-336 68.5-336-68.5-275.5-184-184-275.5-68.5-336q0-213 97-398.5t265-305.5 374-151v228q-221 45-366.5 221t-145.5 406q0 130 51 248.5t136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5q0-230-145.5-406t-366.5-221v-228q206 31 374 151t265 305.5 97 398.5z"></path></svg><svg class="dce-bg-camera position-absolute margin-auto" viewbox="0 0 2048 1792"><path d="M1024 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zm704-416q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zm-704 1152q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"></path></svg><div class="dce-video-container full-width-height position-absolute"></div><div class="dce-scanarea position-absolute pointer-none"><div class="dce-scanlight full-width position-absolute"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.cancel()" ng-disabled="vm.loading()" class="btn btn-default">Close</button></div></div>');
$templateCache.put('app/shared/modal/voip-warning.html','<div class="modal-header ng-hide"></div><div class="modal-body padding-bottom-none"><div class="row"><div class="col-sm-1 col-xs-2"><i class="material-icons md-36">warning</i></div><div class="col-sm-11 col-xs-10"><p><b><span class="text-danger">NOTE:</span> <span>PHONE NUMBER IS A VoIP NUMBER AND MAY NOT BE ABLE TO RECEIVE TEXT MESSAGES. CLICK CANCEL TO CHANGE THE NUMBER OR CONTINUE POSSIBLY WITHOUT NOTIFICATIONS.</span></b></p></div></div></div><div class="modal-footer border-none"><button type="button" ng-click="$dismiss()" class="btn btn-default" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="$close(true)" class="btn btn-primary">CONTINUE</button></div>');
$templateCache.put('app/shared/modal/yesno.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close(null)" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title" ng-if="vm.title">{{ vm.title }}</h4></div><div class="modal-body" ng-if="vm.body"><p ng-bind-html="vm.body"></p></div><div class="modal-footer"><button type="button" ng-if="vm.showCancel" ng-click="vm.close(null)" class="btn btn-default text-uppercase" data-dismiss="modal">Cancel</button> <button type="button" ng-if="vm.noText" ng-click="vm.close(false)" class="btn btn-default" data-dismiss="modal">{{ vm.noText }}</button> <button type="button" ng-click="vm.close(true)" class="btn btn-primary" data-dismiss="modal">{{ vm.yesText }}</button></div>');
$templateCache.put('app/areas/appointment/components/appointment-service-center-title.component.view.html','<h4 class="panel-title margin-top"><div class="hidden-xs black margin-bottom-sm">SERVICE CENTER LOCATION</div><div class="visible-xs padding-bottom-xs black margin-bottom-sm">SERVICE CENTER LOCATION</div><div class="appt-summary border-top"><div class="row"><div class="col-xs-12"><div class="margin-top text-uppercase"><strong>{{vm.appointment.dealerName}}</strong></div></div></div></div></h4>');
$templateCache.put('app/areas/appointment/views/appointment-authorization-history.view.html','<div class="margin-bottom-30 authorization-history-view"><authorization-history-item-view ng-model="vm.authorizations" appointment="vm.appointment" index="vm.authorizationToView" is-dashboard="true" page-params="vm.pageParams" active-product="vm.activeProduct"></authorization-history-item-view><br><br><br><br></div><div class="footer fixed_full"><div class="row padding-md"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-primary text-uppercase" ng-click="vm.close()">CLOSE</button></span></div></div></div>');
$templateCache.put('app/areas/appointment/views/appointment-detail-tabs.view.html','<div class="row display-flex full-height margin-right-none" aside-parent="vm.childScopeForm" id="appointment-summary-modal"><div class="col-md-8 col-xs-12 padding-right-none separate-left-aside-panel" id="appointment-summary-content"><div class="display-flex flex-column overflow-hidden full-height"><div id="appointment-detail-header" class="flex-fullwidth-50h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><aside-header ng-model="vmPnl.customerData" show-print-option="vmPnl.getViewMode() === vmPnl.viewModes.summary ? true : false" print-clicked="vmPnl.printSummary()"></aside-header></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white"><form name="inputForm" role="form" class="form" novalidate=""><div class="appointment-modal-holder"><appointment-summary ng-if="vmPnl.getViewMode() === vmPnl.viewModes.summary" ng-model="vmPnl.appointment" location-transportation-types="vmPnl.locationTransportationTypes" ,="" credit="vmPnl.rideShareCredit" appointment-statuses="vmPnl.appointmentStatuses" location-department="vmPnl.locationDepartment"></appointment-summary><div class="padding" ng-if="vmPnl.repairOrder && vmPnl.getViewMode() === vmPnl.viewModes.checkedIn || vmPnl.getViewMode() === vmPnl.viewModes.arrived"><checkin-summary repair-order="vmPnl.repairOrder"></checkin-summary></div></div></form></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 no-print"><div class="row padding-md content-center margin-top-sm"><div class="col-xs-12"><ng-if="!vmpnl.appointment.cancellationdate" event-alert=""><div ng-if="vmPnl.appointment.cancellationDate" class="inline-block margin-top-sm padding-top-md danger border-top-none align-bottom text-uppercase" title="REASON: {{vmPnl.appointment.cancellationReason}}"><i class="align-bottom material-icons margin-right-xs md-18">event_busy</i><b class="inline-block margin-bottom-xs"><span ng-if="vmPnl.appointment.cancellationReason.toLowerCase() == vmPnl.dmsCancelReason">{{vmPnl.appointment.cancellationReason}}</span><span ng-if="vmPnl.appointment.cancellationReason.toLowerCase() != vmPnl.dmsCancelReason && vmPnl.appointment.cancellationIdentityUserLastName">CANCELED BY {{ ::vmPnl.appointment.cancellationIdentityUserFirstName }} {{ ::vmPnl.appointment.cancellationIdentityUserLastName }}</span></b></div><div class="ng-hide text-uppercase inline margin-top" ng-show="vmPnl.updatingAppt"><img src="assets/images/ajax-loader.gif"> Checking In...</div><span class="pull-right padding-right-md padding-top-sm"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-click="vmPnl.returnToParentList();" ladda="vm.nextBusy">CLOSE</button> <button ng-if="vmPnl.showInspectBtn()" type="button" class="btn btn-primary text-uppercase" ui-sref="inspect({ tabType: vmPnl.tabTypes.roDetail, dealerId: vmPnl.appointment.dealerId, roId: vmPnl.appointment.repairOrderId, activeInspectTab: vmPnl.detailTabTypes.services, customerName: vmPnl.getCustomerName() })">GO TO INSPECT</button> <button ng-if="vmPnl.showCancelBtn()" type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vmPnl.cancelClicked()" ladda="vm.nextBusy">CANCEL</button> <button type="button" ng-if="vmPnl.showEditBtn()" class="btn text-uppercase btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vmPnl.editClicked()" ng-disabled="vmPnl.nextBusy">EDIT</button> <button type="button" ng-if="vmPnl.showArrivedBtn()" class="btn btn-primary text-uppercase margin-right-xs" ladda="vmPnl.updatingAppt" ng-class="config.styleClass" ng-click="vmPnl.arrivedClicked()" ng-disabled="vmPnl.nextBusy">ARRIVED</button> <button type="button" ng-if="vmPnl.showCheckInBtn()" class="btn btn-primary text-uppercase margin-right-xs" ladda="vmPnl.updatingAppt" ng-class="config.styleClass" ng-click="vmPnl.checkInClicked()" ng-disabled="vmPnl.nextBusy">CHECK IN</button></span></ng-if="!vmpnl.appointment.cancellationdate"></div></div></div></div></div><div id="appointments-messaging" ng-show="vmPnl.customerData" class="ng-hide col-md-4 col-xs-12 margin-left-md border-radius-top-7 separate-right-aside-panel message-component-rail flex-grow padding-none overflow-y-hidden"><div class="display-flex flex-column overflow-hidden full-height white-bg"><div class="flex-fullwidth-50h border-radius-top-7 visible-xs visible-sm theme-bg padding padding-right-md"><aside-header ng-model="vmPnl.customerData" show-print-option="vmPnl.getViewMode() === vmPnl.viewModes.summary ? true : false"></aside-header></div><rc-summary-message-tab appointment="vmPnl.appointment" disable-notes-tab="1" mobile-class="vmPnl.messagePanelMobileClass"></rc-summary-message-tab></div></div></div><div id="repeating-footer" class="pdf-to-print"><div class="font-bold font-size-11 margin-none"><b>APPOINTMENT SUMMARY FOR:</b></div><div class="font-size-11 margin-none">APPT# {{ vmPnl.appointment.id }} <span class="ro-name">{{ vmPnl.appointment.customerFirstName }} {{ vmPnl.appointment.customerLastName }}</span></div></div>');
$templateCache.put('app/areas/appointment/views/appointment-list.view.html','<div ng-cloak="" class="no-soup" ng-if="vm.hasAccess === false"><div class="row"><div class="centered-content"><span ng-if="vm.allLocations && vm.allLocations.length > 0"><h3>INVALID LOGIN</h3>Your login information is not valid. Please contact support for assistance.</span> <span ng-if="!vm.allLocations || vm.allLocations.length === 0"><h3>CONFIGURATION ISSUE</h3>The dealer(s) you have access to have not been configured for appointments.<br>Please contact the client success team.</span></div></div></div><div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-if="vm.showMobileGarageMarketingContent === true" id="mobile-marketing-content"><div class="row appointment-marketing-container"><div class="col-xs-12" ng-bind-html="vm.mobileMarketingContent"></div></div></div><div ng-cloak="" id="appointments" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none" ng-class="{\'checkin-list\': vm.isCheckInView(), \'appointment-list\': vm.isAppointmentView()}"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-column"><div class="display-flex flex-row"><div class="flex-percent-50 flex-sm-row hidden-sm hidden-xs"><div class="display-flex flex-column flex-xs-row"><div class="flex-percent-50" ng-if="vm.isAppointmentView()"><rc-list-mode-selector ng-model="vm.searchModeIcon" available-modes="vm.selectableViewModes" css-class="rc-list-selector" on-select-event="vm.searchModeChanged()"></rc-list-mode-selector></div></div></div><div class="flex-sm-percent-80 flex-xs-percent-80 flex-grow visible-xs visible-sm padding-right-md" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div><div class="flex-percent-10 max-width-px-30 visible-xs visible-sm"><rc-list-advanced-filter-toggle ng-disabled="!vm.filters.selectedLocation || !vm.filters.selectedDepartment" ng-disabled-message="vm.disabledFilterMsg" filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.appointmentCount" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)" align-right="1"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 max-width-px-30 visible-xs visible-sm" ng-if="!vm.showAdvancedSearch"><a ng-click="vm.addAppointment()" class="max-width-px-30 margin-top-xs visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div></div><div class="display-flex flex-column full-width"><div class="display-flex flex-row flex-sm-column"><div class="flex-width-200 flex-sm-percent-100 hidden-xs hidden-sm"><div class="block relative padding-right-sm padding-left-md" ng-class="{\'padding-left-none\': !vm.isAppointmentView()}" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-250 flex-grow max-width-px-400 flex-sm-percent-100 hidden-xs hidden-sm"><div class="block relative padding-left-sm padding-right-sm override-sm-padding-left-none override-xs-padding-right-none override-sm-padding-right-none override-sm-padding-top-sm"><div class="field-wrapper"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-options="l as l.name for l in vm.allLocations track by l.id" ng-model="vm.filters.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.searchingAppointments"></select></div></div></div><div class="flex-width-300 flex-grow max-width-px-400 flex-sm-percent-100"><div class="appointment-list-search block relative text-notransform override-sm-padding-top-sm override-sm-padding-left-none"><div id="appt-list-typeahead-container"><typeahead-tagged-input selected-items="vm.selectedTypeAheadAppt" search-query="vm.typeAheadSearchQuery" is-searching="vm.searchingTypeAheadAppts" placeholder="Search phone, name, or VIN" min-length="3" max-results-to-show="100" on-register="vm.registerApptTypeAhead(ctrl)" on-search="vm.refreshTypeAheadAppts($query)" on-selected="vm.typeAheadApptSelected($tag)" on-removed="vm.typeAheadApptRemoved()"></typeahead-tagged-input></div><span class="input-append-icon z-index-30" ng-if="vm.isCheckInView()"><button class="btn btn-text-only padding-top-xs padding-right-none" ng-click="vm.openVinScan()" title="Scan VIN"><i class="material-symbols-outlined">barcode_scanner</i></button></span></div><span class="padding-left-xs text-danger" ng-if="vm.showVinError && vm.isCheckInView()">VIN not recognized. Use manual search.</span></div><div class="flex-width-200 flex-sm-percent-100 hidden-xs hidden-sm" ng-if="(vm.isLocationConfigured() === true && vm.filters.searchMode !== vm.searchModes.mobileGarage)"><div class="block relative padding-left-sm padding-right-sm override-sm-padding-left-none override-xs-padding-right-none override-sm-padding-right-none override-sm-padding-top-sm"><div class="field-wrapper"><label for="departmentFilter">Department</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="departmentFilter" name="departmentFilter" ng-options="dept.id as dept.name for dept in vm.filters.locationDepartments | filter:vm.activeDepartmentsFilter" ng-model="vm.filters.selectedDepartment" ng-change="vm.selectedDepartmentChanged()" ng-disabled="vm.searchingAppointments"><option value="">Department</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 hidden-xs hidden-sm" ng-if="vm.isLocationConfigured() === true && vm.filters.searchMode === vm.searchModes.mobileGarage"><div class="block relative padding-left-sm padding-right-sm override-sm-padding-left-none override-sm-padding-top-sm"><div class="field-wrapper"><label for="departmentFilter">Department</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="departmentFilter" name="departmentFilter" ng-options="dept.id as dept.name for dept in vm.mobileGarageDepartments" ng-model="vm.filters.selectedDepartment" ng-change="vm.selectedDepartmentChanged()" ng-disabled="vm.searchingAppointments"><option value="">Department</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 hidden-xs hidden-sm" ng-if="(vm.isLocationConfigured() === true && vm.showTimeFrameFilter)" ng-hide="vm.showCalendar() === true"><div class="block relative padding-right-sm field-wrapper"><label for="dateRangeFilter">SELECT A TIME FRAME</label><select ng-model-options="{ debounce: 750 }" selectlabel="" class="form-control" name="dateRangeFilter" id="dateRangeFilter" ng-model="vm.filters.filterByTimeFrame" ng-change="vm.timeFrameChanged()" ng-options="t.value as t.text for t in vm.timeframes"></select></div></div><div class="flex-width-200 flex-sm-percent-100 hidden-xs hidden-sm" ng-hide="vm.showCalendar() === false"><div class="block relative padding-left-sm padding-right-sm field-wrapper"><span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearCustomTimeFrame()">close</span> <input date-range-picker="" ng-model-options="{ debounce: 750 }" type="text" id="timeframe_range" class="form-control date-picker" options="vm.dateRangePickerOptions" placeholder="CUSTOM TIMEFRAME..." ng-model="vm.filters.filterByCustomTimeframe"></div></div><div class="flex-width-50 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" ng-disabled-message="vm.disabledFilterMsg" filter-message="vm.filterMessage" record-count="vm.appointmentCount" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)"></rc-list-advanced-filter-toggle></div></div><div ng-if="vm.filters.selectedLocation" class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters required-filter-message="vm.requiredFilterMessage" required-filter-count="2" filter-count="vm.filterCount" record-count="vm.appointmentCount" filter-message="vm.filterMessage"></rc-list-mobile-filters></div></div><div class="display-flex flex-column hidden-sm hidden-xs"><div class="display-flex flex-row"><div class="flex-width-200 flex-sm-percent-100 text-nowrap display-flex content-center" ng-if="vm.hasAccess === true"><a ng-click="vm.addAppointment()" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass">+ <span>NEW</span></a></div></div></div></div></div><div class="mobile-display visible-xs visible-sm padding-md" ng-class="{\'visible-sm\': vm.isAppointmentView() && vm.filters.searchMode !== vm.searchModes.classic}" ng-if="vm.isAppointmentView() && vm.filters.searchMode !== vm.searchModes.classic && vm.filters.searchMode !== vm.searchModes.mobileGarage"><appt-list-date-picker appt-list="vm"></appt-list-date-picker></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" ng-if="vm.filters.searchMode === vm.searchModes.classic" id="classic-appointments-container"><table id="appointment-list-table" class="table table-layout-fixed small-columns fixed-header-table appointments-list classic" ng-class="{\'today\': vm.isSearchToday()}"><thead class="hidden-xs"><tr class="text-uppercase"><th data-sort-ignore="true" class="first-col text-center text-nowrap padding-left-none padding-right-none"><div class="padding-bottom-sm max-width-px-150"><appt-list-date-picker appt-list="vm"></appt-list-date-picker></div></th><th data-sort-ignore="true" class="align-bottom"><span>Customer/Vehicle</span></th><th data-sort-ignore="true" class="align-bottom">Contact</th><th class="align-bottom">Advisor</th><th data-sort-ignore="true" ng-if="vm.filters.showServicesColumn === true" class="align-bottom">Services</th><th data-sort-ignore="true" class="align-bottom">Promise Time</th><th data-sort-ignore="true" class="align-bottom">Status</th><th data-sort-ignore="true" class="type align-bottom">Type</th><th data-sort-ignore="true" class="type align-bottom">Booked By</th><th data-sort-ignore="true" class="action align-bottom"><span ng-if="vm.showActionColumn()">Actions</span></th></tr></thead><tbody><tr ng-if="!vm.searchingAppointments && vm.currentAppointmentSlots && vm.currentAppointmentSlots.length > 0" ng-repeat="data in vm.currentAppointmentSlots" ng-class="{\'closed\': data.isClosed, \'has-appt\' : data.appointments.length > 0, \'has-dropdown\': vm.hasDropDown(data.appointments)}"><td class="first-col" rowspan="data.appointments.length === 0 ? 1 : data.appointments.length"><div class="row"><div class="col-sm-6 col-xs-12 time text-right">{{ ::data.blockTime | date:"h:mma" }}</div></div></td><td ng-if="data.isClosed" ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center"><div class="appt"><b>CLOSED</b></div></td><td ng-if="!data.isClosed" class="ellipsis-overflow"><div class="appt text-uppercase ellipsis-overflow {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><b><span>{{ ::appt.customerFirstName }} {{ ::appt.customerLastName }}</span></b> <span ng-if="appt.year !== \'0\'"><span class="hidden-xs"><br></span><div class="inline ellipsis-overflow classic-vehicle">{{ ::appt.year }} {{ ::appt.makeName }} {{ ::appt.modelName }}</div></span><div class="visible-xs"><span ng-if="appt.dealerEmployeeFirstName">{{::appt.dealerEmployeeFirstName}}</span> {{::appt.dealerEmployeeLastName}}<span class="padding-left-sm"><b>{{vm.getMobileTripType(appt) }} ({{ vm.getApptStatusTopLabel(appt) }} <span ng-if="vm.getApptStatusBottomLabel(appt)">{{ vm.getApptStatusBottomLabel(appt)}}</span>)</b></span></div></div></td><td class="hidden-xs" ng-if="!data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><span ng-if="appt.customerPhone != \'0\'">{{ ::appt.customerPhone | tel }}<br></span> <span ng-if="::appt.customerEmail">{{ ::appt.customerEmail}}</span></div></td><td class="hidden-xs" ng-if="!data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><span ng-if="vm.isAdvisorUnmapped(appt)">UNMAPPED USER</span> <span ng-if="!vm.isAdvisorUnmapped(appt) && !appt.dealerEmployeeFirstName">NOT ASSIGNED</span> <span ng-if="appt.dealerEmployeeFirstName">{{::appt.dealerEmployeeFirstName.charAt(0)}}.</span> {{::appt.dealerEmployeeLastName}} <span ng-if="appt.departmentId"><br>{{::vm.getDepartmentName(appt.departmentId)}}</span></div></td><td class="hidden-xs" ng-if="vm.filters.showServicesColumn === true && !data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><div ng-if="!vm.showCheckInSkipped(appt) && appt.servicesBreakdowns && appt.servicesBreakdowns.length > 0" ng-repeat="lineItem in appt.servicesBreakdowns | limitTo:vm.maxServicesToShow"><div class="font-size-10 text-uppercase overflow-hidden ellipsis-overflow max-width-px-200">{{ lineItem.opCode }}&nbsp;-&nbsp; <span class="description">{{ lineItem.opCodeDescription || \'NA\' }}</span></div><div class="display-flex flex-row line-height-10" ng-class="{\'padding-bottom-sm\': !$last}"><div class="flex-percent-33 font-size-9 text-color-med-gray">PAY:&nbsp;{{ lineItem.payType || \'NA\' }}</div><div class="flex-percent-33 font-size-9 text-color-med-gray">HRS:&nbsp;{{ lineItem.laborHours || \'NA\' }}</div><div class="flex-percent-33 font-size-9 text-color-med-gray">EST:&nbsp;{{ lineItem.retailPrice || \'NA\' }}</div></div></div><div ng-if="!vm.showCheckInSkipped(appt) && appt.servicesBreakdowns && appt.servicesBreakdowns.length > vm.maxServicesToShow"><div class="font-size-10 text-normal-case padding-top-md overflow-hidden ellipsis-overflow max-width-px-200" popover-placement="top" ng-mouseenter="vm.activePopoverAppt = appt" ng-mouseleave="vm.activePopoverAppt = null" uib-popover-template="\'addl-op-codes-popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter">+ <span class="padding-left-xs">{{ appt.servicesBreakdowns.length - vm.maxServicesToShow }} more service<span ng-if="appt.servicesBreakdowns.length - vm.maxServicesToShow > 1">s</span></span>...</div></div></div></td><td class="hidden-xs" ng-if="!data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><span ng-if="appt.promiseDateTime">{{::appt.promiseDateTime | date: \'MM/dd/yyyy\' }}</span><br><span ng-if="appt.promiseDateTime">{{::appt.promiseDateTime | date: \'h:mma\' }}</span></div></td><td class="hidden-xs" ng-if="!data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><span ng-if="appt.dmsOutOfSync === true"><i class="material-icons md-18 theme-link appt-list-icon" uib-popover="DMS updates pending. Open for more details" popover-trigger="mouseenter">warning</i></span>{{ vm.getApptStatusTopLabel(appt) }} <span ng-if="!vm.showCheckInSkipped(appt) && appt.opCodes && appt.opCodes.length > 0" ng-bind-html="vm.getLinesCountText(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)" popover-placement="top" uib-popover-template="\'op-codes-popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter"></span> <span ng-if="vm.showCheckInSkipped(appt)"><br>(Check-in Skipped)</span> <span ng-if="vm.getApptStatusBottomLabel(appt)"><br>{{ vm.getApptStatusBottomLabel(appt)}}</span> <span ng-if="vm.isCanceled(appt)" title="{{appt.cancellationReason}}">by<br>{{appt.cancelledByIdentityUserFirstName}} {{appt.cancelledByIdentityUserLastName}}</span></div></td><td class="type hidden-xs" ng-if="!data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)" ng-bind-html="vm.getTransportationTypeLabel(appt)"></div></td><td class="type hidden-xs" ng-if="!data.isClosed"><div class="appt text-uppercase {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-click="vm.viewAppointment(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><span ng-if="(appt.createdByIdentityUserFirstName != \'\' && appt.createdByIdentityUserLastName != \'\')">{{appt.createdByIdentityUserFirstName }} {{ appt.createdByIdentityUserLastName}}</span> <span ng-if="(appt.createdByIdentityUserFirstName == \'\' || appt.createdByIdentityUserLastName == \'\')">{{appt.bookingSource }}</span></div></td><td class="action hidden-xs"><div ng-if="!data.isClosed && vm.showActionColumn()" class="appt {{appt.cssClass}}" ng-class="{\'is_hovered\':appt.isHovered}" ng-repeat="appt in data.appointments | filter:vm.localAppointmentFilter" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><select class="form-control" ng-model="appt.selectedAction" ng-if="vm.showCancelOption(appt) || vm.showCheckInOption(appt) || vm.showArriveOption(appt)" ng-change="vm.actionSelected(appt)" ng-disabled="vm.updatingAppt"><option value="">Action</option><option ng-if="vm.showArriveOption(appt)" value="3">Arrive</option><option ng-if="vm.showCheckInOption(appt)" value="2">Check-in</option><option ng-if="vm.showCancelOption(appt)" value="1">Cancel</option><option ng-if="vm.showNoShowOption(appt)" value="4">No show</option></select></div></td></tr></tbody><tfoot><tr ng-if="vm.searchingAppointments || vm.loadingDepartments"><td colspan="8" class="text-center text-uppercase no-results"><div class="margin-top text-center"><img src="assets/images/ajax-loader.gif"> <strong>Loading</strong></div></td></tr><tr ng-if="vm.filters.selectedDepartment && !vm.loadingDepartments && !vm.isClosed && vm.isLocationConfigured() && !vm.searchingAppointments && !vm.searchError && (!vm.currentAppointmentSlots || vm.currentAppointmentSlots.length === 0) && vm.filters.selectedLocation"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results" ng-bind-html="vm.noResultsText"></td></tr><tr ng-if="vm.filters.selectedDepartment && !vm.searchingAppointments && vm.searchError"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results" ng-bind-html="vm.errorText"></td></tr><tr ng-if="vm.filters.selectedDepartment && vm.isClosed && vm.isLocationConfigured() && !vm.searchingAppointments && !vm.searchError && (!vm.currentAppointmentSlots || vm.currentAppointmentSlots.length === 0 ) && vm.filters.selectedLocation"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results" ng-bind-html="vm.closedText"></td></tr><tr ng-if="!vm.searchingAppointments && vm.currentAppointmentSlots.length === 0 && !vm.filters.selectedLocation"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results" ng-bind-html="vm.selectLocText"></td></tr><tr ng-if="!vm.searchingAppointments && vm.isLocationConfigured() && vm.filters.selectedLocation && !vm.filters.selectedDepartment"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results" ng-bind-html="vm.selectDeptText"></td></tr><tr ng-if="!vm.isLocationConfigured() && vm.filters.locationDepartments.length > 0"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results" ng-bind-html="vm.locNotConfigured"></td></tr><tr ng-if="!vm.isLocationConfigured() && (!vm.filters.locationDepartments || vm.filters.locationDepartments.length === 0)"><td ng-attr-colspan="{{ vm.filters.showServicesColumn === true ? 9 : 8}}" class="text-center text-uppercase no-results"><strong><br><br>The selected location does not have any departments configured. Please contact your account administrator.</strong></td></tr></tfoot></table></div><div class="flex-grow flex-percent-90 overflow-hidden" ng-if="vm.filters.searchMode !== vm.searchModes.classic && vm.filters.searchMode !== vm.searchModes.mobileGarage"><div class="full-width-height padding-right-20 padding-bottom-50 overflow-y-auto list-table-wrapper" id="list-appointments-container"><table id="appointment-list-table-new" class="table table-hover table-layout-fixed small-columns fixed-header-table appointments-list time-customer-sorted" infinite-scroll="vm.pagedSearch()" infinite-scroll-container="\'#list-appointments-container\'" infinite-scroll-distance="1" infinite-scroll-disabled="vm.searchingAppointments || vm.isLoadingMore || !vm.canLoadMore" infinite-scroll-immediate-check="false" ng-class="{\'today\': vm.isSearchToday()}" ng-model-options="{ debounce: 750 }" redcap-sort="true" redcap-sort-model="vm.sort" redcap-sort-callback="vm.sortChanged"><thead class="hidden-xs hidden-sm"><tr class="text-uppercase"><th sort-column="Customer" class="text-uppercase header_Customer">Customer/Vehicle</th><th sort-column="Contact" class="text-uppercase header_Contact">Contact</th><th sort-column="Appointment" class="text-uppercase header_Appointment">Appointment</th><th sort-column="Advisor" class="text-uppercase header_Advisor">Advisor/Dept</th><th sort-column="Status" class="text-uppercase header_Status">Status</th><th sort-column="Type" class="text-uppercase type header_Type">Type</th><th sort-column="Booked" class="text-uppercase type header_Booked">Booked By</th><th class="text-uppercase action"><span ng-if="vm.showActionColumn()">Actions</span></th></tr></thead><tbody><tr ng-if="!vm.searchingAppointments && vm.searchResults && vm.searchResults.length > 0" ng-repeat="appt in vm.searchResults | filter: vm.localAppointmentFilter | orderBy: vm.frontEndSort:vm.getSortDirection()" ng-class="{\'has-dropdown\': vm.hasDropDown(vm.searchResults)}" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><td class="appt text-uppercase min-height-px-50" ng-class="{\'is_hovered\':appt.isHovered, \'last\': $index === vm.searchResults.length -1}"><span class="hidden-xs" ng-click="vm.viewAppointment(appt)"><b><span>{{ ::appt.customerFirstName }} {{ ::appt.customerLastName }}</span></b> <span ng-if="appt.year !== \'0\'"><br>{{ ::appt.year }} {{ ::appt.makeName }} {{ ::appt.modelName }}</span></span><div class="row visible-xs" ng-click="vm.viewAppointment(appt)"><div class="col-xs-6"><b><span>{{ ::appt.customerFirstName }} {{ ::appt.customerLastName }}</span></b></div><div class="col-xs-2"></div><div class="col-xs-4"><b>{{ ::appt.apptDateTime | date: \'shortTime\' }}</b></div></div><div class="row visible-xs" ng-click="vm.viewAppointment(appt)"><div class="col-xs-6 ellipsis-overflow"><span ng-if="appt.year !== \'0\'">{{ ::appt.year }} {{ ::appt.makeName }}{{ ::appt.modelName }}</span></div><div class="col-xs-2"></div><div class="col-xs-4">{{ ::appt.apptDateTime | date: \'EEE, MMM dd\' }}</div></div><div class="row visible-xs" ng-click="vm.viewAppointment(appt)"><div class="col-xs-6"><span ng-if="vm.isAdvisorUnmapped(appt)">UNMAPPED USER</span> <span ng-if="!vm.isAdvisorUnmapped(appt) && !appt.dealerEmployeeFirstName">NOT ASSIGNED</span> <span ng-if="appt.dealerEmployeeFirstName">{{::appt.dealerEmployeeFirstName}}</span> {{::appt.dealerEmployeeLastName}} <span ng-if="appt.departmentId"><br>{{::vm.getDepartmentName(appt.departmentId)}}</span><br><span ng-if="appt.dmsOutOfSync === true"><i class="material-icons md-18 theme-link appt-list-icon" uib-popover="DMS updates pending. Open for more details" popover-trigger="mouseenter">warning</i></span>{{ vm.getApptStatusTopLabel(appt) }} <span ng-if="!vm.showCheckInSkipped(appt) && appt.opCodes && appt.opCodes.length > 0" ng-bind-html="vm.getLinesCountText(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)" popover-placement="top" uib-popover-template="\'op-codes-popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter"></span> <span ng-if="vm.showCheckInSkipped(appt)"><br>(Check-in Skipped)</span> <span ng-if="vm.getApptStatusBottomLabel(appt)"><br>{{ vm.getApptStatusBottomLabel(appt)}}</span> <span ng-if="vm.isCanceled(appt)" title="{{appt.cancellationReason}}">by<br>{{appt.cancelledByIdentityUserFirstName}} {{appt.cancelledByIdentityUserLastName}}</span></div><div class="col-xs-2"></div><div class="col-xs-4"></div></div><div class="row visible-xs margin-top-md"><div class="col-xs-12" ng-if="vm.showActionColumn()"><select class="form-control" ng-model="appt.selectedAction" ng-if="vm.showCancelOption(appt) || vm.showCheckInOption(appt) || vm.showArriveOption(appt)" ng-change="vm.actionSelected(appt)" ng-disabled="vm.updatingAppt"><option value="">Action</option><option ng-if="vm.showArriveOption(appt)" value="3">Arrive</option><option ng-if="vm.showCheckInOption(appt)" value="2">Check-in</option><option ng-if="vm.showCancelOption(appt)" value="1">Cancel</option><option ng-if="vm.showNoShowOption(appt)" value="4">No show</option></select></div></div></td><td class="appt min-height-px-50 text-uppercase hidden-xs ellipsis-overflow" ng-click="vm.viewAppointment(appt)" ng-class="{\'is_hovered\':appt.isHovered}"><span ng-if="appt.customerPhone != \'0\'">{{ ::appt.customerPhone | tel }}<br></span> <span ng-if="::appt.customerEmail">{{ ::appt.customerEmail}}</span></td><td class="appt min-height-px-50 text-uppercase hidden-xs" ng-click="vm.viewAppointment(appt)" ng-class="{\'is_hovered\':appt.isHovered}"><b>{{ ::appt.apptDateTime | date: \'shortTime\' }}</b><br>{{ ::appt.apptDateTime | date: \'EEE, MMM dd\' }}</td><td class="appt min-height-px-50 text-uppercase hidden-xs ellipsis-overflow" ng-click="vm.viewAppointment(appt)" ng-class="{\'is_hovered\':appt.isHovered}"><span ng-if="vm.isAdvisorUnmapped(appt)">UNMAPPED USER</span> <span ng-if="!vm.isAdvisorUnmapped(appt) && !appt.dealerEmployeeFirstName">NOT ASSIGNED</span> <span ng-if="appt.dealerEmployeeFirstName">{{::appt.dealerEmployeeFirstName}}</span> {{::appt.dealerEmployeeLastName}} <span ng-if="appt.departmentId"><br>{{::vm.getDepartmentName(appt.departmentId)}}</span></td><td class="appt min-height-px-50 text-uppercase hidden-xs ellipsis-overflow appt-status-col" ng-click="vm.viewAppointment(appt)" ng-class="{\'is_hovered\':appt.isHovered}"><span ng-if="appt.dmsOutOfSync === true"><i class="material-icons md-18 theme-link appt-list-icon" uib-popover="DMS updates pending. Open for more details" popover-trigger="mouseenter">warning</i></span>{{ vm.getApptStatusTopLabel(appt) }} <span ng-if="!vm.showCheckInSkipped(appt) && appt.opCodes && appt.opCodes.length > 0" ng-bind-html="vm.getLinesCountText(appt)" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)" uib-popover-template="\'op-codes-popover.html\'" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter"></span> <span ng-if="vm.showCheckInSkipped(appt)"><br>(Check-in Skipped)</span> <span ng-if="vm.getApptStatusBottomLabel(appt)"><br>{{ vm.getApptStatusBottomLabel(appt)}}</span> <span ng-if="vm.isCanceled(appt)" title="{{appt.cancellationReason}}">by<br>{{appt.cancelledByIdentityUserFirstName}} {{appt.cancelledByIdentityUserLastName}}</span></td><td class="type appt min-height-px-50 text-uppercase hidden-xs ellipsis-overflow" ng-click="vm.viewAppointment(appt)" ng-class="{\'is_hovered\':appt.isHovered}"><span ng-bind-html="vm.getTransportationTypeLabel(appt)"></span></td><td class="type appt min-height-px-50 text-uppercase hidden-xs" ng-click="vm.viewAppointment(appt)" ng-class="{\'is_hovered\':appt.isHovered}"><span ng-if="(appt.createdByIdentityUserFirstName != \'\' && appt.createdByIdentityUserLastName != \'\')">{{appt.createdByIdentityUserFirstName }} {{ appt.createdByIdentityUserLastName}}</span> <span ng-if="(appt.createdByIdentityUserFirstName == \'\' || appt.createdByIdentityUserLastName == \'\')">{{appt.bookingSource }}</span> <span ng-if="!vm.isAdminUser && !vm.filters.selectedLocation && appt.dealerName"><br>{{appt.dealerName}}</span></td><td class="action appt min-height-px-50 hidden-xs" ng-class="{\'is_hovered\':appt.isHovered}"><select class="form-control" ng-model="appt.selectedAction" ng-if="vm.showCancelOption(appt) || vm.showCheckInOption(appt) || vm.showArriveOption(appt)" ng-change="vm.actionSelected(appt)" ng-disabled="vm.updatingAppt"><option value="">Action</option><option ng-if="vm.showArriveOption(appt)" value="3">Arrive</option><option ng-if="vm.showCheckInOption(appt)" value="2">Check-in</option><option ng-if="vm.showCancelOption(appt)" value="1">Cancel</option><option ng-if="vm.showNoShowOption(appt)" value="4">No show</option></select></td></tr></tbody><tfoot><tr ng-if="vm.searchingAppointments || vm.loadingDepartments"><td colspan="8" class="text-center text-uppercase no-results"><div class="margin-top text-center"><img src="assets/images/ajax-loader.gif"> <strong>Loading</strong></div></td></tr><tr ng-if="vm.isLoadingMore && !vm.searchingAppointments"><td colspan="8" class="text-center text-uppercase no-results"><div class="margin-top text-center"><img src="assets/images/ajax-loader.gif"> <strong>Loading More</strong></div></td></tr><tr ng-if="!vm.loadingDepartments && vm.isLocationConfigured() && !vm.isClosed && !vm.searchingAppointments && !vm.isLoadingMore && !vm.canLoadMore && vm.searchResults"><td colspan="8" class="text-center text-uppercase no-results"><div class="margin-top text-center text-uppercase"><strong>YOU HAVE REACHED THE END OF THE LIST.</strong></div></td></tr><tr ng-if="!vm.searchingAppointments && vm.searchError"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.errorText"></td></tr><tr ng-if="vm.isClosed && vm.isLocationConfigured() && !vm.searchingAppointments && !vm.searchError && (!vm.searchResults || vm.searchResults.length === 0 ) && vm.filters.selectedLocation"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.closedText"></td></tr><tr ng-if="!vm.searchResults && vm.searchResults.length === 0 && !vm.filters.selectedLocation"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.selectLocText"></td></tr><tr ng-if="!vm.isLocationConfigured()"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.locNotConfigured"></td></tr></tfoot></table></div></div><div class="padding-right-20 overflow-hidden flex-grow flex-percent-90 list-table-wrapper" ng-if="vm.filters.searchMode === vm.searchModes.mobileGarage"><div id="mobile-garage-wrapper" class="display-flex flex-row full-width-height"><div class="display-flex flex-percent-50 overflow-y-auto flex-xs-percent-100" id="mobile-garage-content"><table id="appointment-mobile-garage-table" class="table table searchable-list appointments-list classic" ng-class="{\'today\': vm.isSearchToday()}"><thead><tr class="text-uppercase"><th data-sort-ignore="true" class="first-col text-uppercase text-center text-nowrap padding-left-none padding-right-none"><div class="padding-bottom-sm max-width-px-150"><appt-list-date-picker appt-list="vm"></appt-list-date-picker></div></th><th class="mg-list-header" id="driver-col-{{driver.id}}" ng-repeat="driver in vm.mobileTechnicians">{{driver.name}}</th><th>&nbsp;</th></tr></thead><tbody ng-if="!vm.searchingAppointments && vm.currentAppointmentSlots && vm.currentAppointmentSlots.length > 0"><tr ng-repeat="data in vm.currentAppointmentSlots" ng-class="{\'closed\': data.isClosed, \'has-appt\' : data.appointments.length > 0, \'has-dropdown\': vm.hasDropDown(data.appointments)}"><td class="first-col" rowspan="data.appointments.length === 0 ? 1 : data.appointments.length"><div class="row"><div class="col-sm-6 col-xs-12 time text-right">{{ ::data.blockTime | date:"h:mma" }}</div></div></td><td class="mg-list-column" ng-if="!data.isClosed" ng-repeat="driver in vm.mobileTechnicians"><div class="new-appt-card overflow-hidden" ng-repeat="appt in data.appointments | filter:mobileGarageAppointmentFilter($index) as filteredAppts" ng-click="vm.viewAppointment(appt)" ng-style="::{\'height\': appt.cardHeight, \'left\': vm.getMGApptCardLeft(appt, $index, driver), \'z-index\': data.appointments.length - $index}" ng-class="{\'new-appt-card-shadow\': filteredAppts.length > 1, \'new-appt-card-single\': filteredAppts.length === 1 }" uib-popover-template="\'op-codes-popover.html\'" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" id="tappable-item-{{appt.id}}" ng-mouseenter="vm.setApptHover(appt, true)" ng-mouseleave="vm.setApptHover(appt, false)"><div class="overflow-y-auto full-height"><div><b>{{ ::appt.pickUpTripArrivalTime | date: \'shortTime\' }} - {{ ::appt.estimatedEndDateTime | date: \'shortTime\' }}</b></div><div><b>APPT: {{ ::appt.apptDateTime | date: \'shortTime\' }}</b></div><div class="text-uppercase"><b>{{ ::appt.customerFirstName }}&nbsp;{{ ::appt.customerLastName }}</b></div><div class="text-uppercase">{{ ::appt.year }} {{ ::appt.makeName }} {{ ::appt.modelName }}</div><div ng-if="appt.customerPhone != \'0\'">{{ ::appt.customerPhone | tel }}</div><div class="margin-top-md mg-card-address-container" ng-if="appt.customerStop"><i class="material-icons mg-address-icon">location_on</i><div class="mg-address"><div class="text-uppercase" ng-if="appt.customerStop.name">{{::appt.customerStop.name}}</div><div class="text-uppercase" ng-if="appt.customerStop.streetAddress">{{::appt.customerStop.streetAddress}}</div><div class="text-uppercase" ng-if="appt.customerStop.city">{{::appt.customerStop.city}}</div><div ng-if="appt.customerStop.zip">{{::appt.customerStop.zip}}</div></div></div><div class="margin-top-30">Advisor: {{ appt.dealerEmployeeFirstName}} {{ appt.dealerEmployeeLastName}}</div></div></div></td><td>&nbsp;</td></tr></tbody><tfoot><tr ng-if="vm.searchingAppointments || vm.loadingDepartments"><td colspan="8" class="text-center text-uppercase no-results"><div class="margin-top text-center"><img src="assets/images/ajax-loader.gif"> <strong>Loading</strong></div></td></tr><tr ng-if="vm.filters.selectedDepartment && !vm.loadingDepartments && vm.filters.selectedDepartment && !vm.isClosed && vm.isLocationConfigured() && !vm.searchingAppointments && !vm.searchError && (!vm.currentAppointmentSlots || vm.currentAppointmentSlots.length === 0) && vm.filters.selectedLocation"><td colspan="8" class="text-center text-uppercase no-results">YOU HAVE REACHED THE END OF THE LIST.</td></tr><tr ng-if="vm.filters.selectedDepartment && !vm.searchingAppointments && vm.searchError"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.errorText"></td></tr><tr ng-if="vm.filters.selectedDepartment && vm.isClosed && vm.isLocationConfigured() && !vm.searchingAppointments && !vm.searchError && (!vm.currentAppointmentSlots || vm.currentAppointmentSlots.length === 0 ) && vm.filters.selectedLocation"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.closedText"></td></tr><tr ng-if="!vm.searchingAppointments && vm.currentAppointmentSlots.length === 0 && !vm.filters.selectedLocation"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.selectLocText"></td></tr><tr ng-if="!vm.loadingDepartments && !vm.searchingAppointments && vm.isLocationConfigured() && vm.filters.selectedLocation && !vm.filters.selectedDepartment"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.selectDeptText"></td></tr><tr ng-if="!vm.loadingDepartments && !vm.searchingAppointments && vm.filters.selectedLocation && !vm.isLocationConfigured()"><td colspan="8" class="text-center text-uppercase no-results" ng-bind-html="vm.locNotConfigured"></td></tr></tfoot></table></div><div id="map-container" class="display-flex flex-percent-50 padding-none hidden-xs"><div id="trip-map" class="full-width-height block relative padding-bottom-xs" map-resize="" fill-height=""><div id="mobile-garage-map" driver-tracking="" fill-height="" options="vm.mapOptions" map-loaded="vm.mapLoaded"></div></div></div></div></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height min-height-px-350"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm" popover-trigger="mouseenter" uib-popover-template="\'filter-popover.html\'">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div ng-if="vm.isAppointmentView()" class="flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm visible-sm visible-xs"><rc-list-mode-selector ng-model="vm.searchModeIcon" available-modes="vm.selectableViewModes" css-class="rc-list-selector" on-select-event="vm.searchModeChanged()"></rc-list-mode-selector></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-class="{\'flex-width-200\': (vm.isLocationConfigured() === true && vm.showTimeFrameFilter), \'flex-width-400\': !(vm.isLocationConfigured() === true && vm.showTimeFrameFilter)}"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div class="field-wrapper"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-options="l as l.name for l in vm.allLocations track by l.id" ng-model="vm.filters.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.searchingAppointments"></select></div></div></div><div class="flex-width-400 flex-sm-percent-100 padding-right-sm"><div class="appointment-list-search block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div id="appt-list-typeahead-container-mobile" class="position-relative"><typeahead-tagged-input class="appointment-list-typeahead" selected-items="vm.selectedTypeAheadAppt" search-query="vm.typeAheadSearchQuery" is-searching="vm.searchingTypeAheadAppts" placeholder="Search phone, name, or VIN" min-length="3" max-results-to-show="100" debounce-delay="300" on-register="vm.registerApptTypeAhead(ctrl)" on-search="vm.refreshTypeAheadAppts($query)" on-selected="vm.typeAheadApptSelected($tag)" on-removed="vm.typeAheadApptRemoved()"></typeahead-tagged-input></div><span class="input-append-icon z-index-30 padding-right-sm" ng-if="vm.isCheckInView()"><button class="btn btn-text-only padding-top-xs padding-right-none" ng-click="vm.openVinScan()" title="Scan VIN"><i class="material-symbols-outlined">barcode_scanner</i></button></span></div><span class="padding-left-xs text-danger" ng-if="vm.showVinError && vm.isCheckInView()">VIN not recognized. Use manual search.</span></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-if="(vm.isLocationConfigured() === true && vm.filters.searchMode !== vm.searchModes.mobileGarage)"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div class="field-wrapper"><label for="departmentFilter">Department</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="departmentFilter" name="departmentFilter" ng-options="dept.id as dept.name for dept in vm.filters.locationDepartments | filter:vm.activeDepartmentsFilter" ng-model="vm.filters.selectedDepartment" ng-change="vm.selectedDepartmentChanged()" ng-disabled="vm.searchingAppointments"><option value="">Department</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-if="vm.isLocationConfigured() === true && vm.filters.searchMode === vm.searchModes.mobileGarage"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div class="field-wrapper"><label for="departmentFilter">Department</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="departmentFilter" name="departmentFilter" ng-options="dept.id as dept.name for dept in vm.mobileGarageDepartments" ng-model="vm.filters.selectedDepartment" ng-change="vm.selectedDepartmentChanged()" ng-disabled="vm.searchingAppointments"><option value="">Department</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 padding-right-sm" ng-if="(vm.isLocationConfigured() === true && vm.showTimeFrameFilter)" ng-hide="vm.showCalendar() === true"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none field-wrapper"><label for="dateRangeFilter">SELECT A TIME FRAME</label><select ng-model-options="{ debounce: 750 }" selectlabel="" class="form-control" name="dateRangeFilter" id="dateRangeFilter" ng-model="vm.filters.filterByTimeFrame" ng-change="vm.timeFrameChanged()" ng-options="t.value as t.text for t in vm.timeframes"></select></div></div><div class="flex-width-200 flex-sm-percent-100" ng-hide="vm.showCalendar() === false"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none field-wrapper"><span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearCustomTimeFrame()">close</span> <input date-range-picker="" ng-model-options="{ debounce: 750 }" type="text" id="timeframe_range" class="form-control date-picker" options="vm.dateRangePickerOptions" placeholder="CUSTOM TIMEFRAME..." ng-model="vm.filters.filterByCustomTimeframe"></div></div></div><div class="display-flex flex-row flex-sm-column"><div class="flex-width-200 flex-sm-percent-100 visible-sm visible-xs paddint-top-xs padding-right-sm" ng-if="vm.filters.searchMode !== vm.searchModes.classic && vm.filters.searchMode !== vm.searchModes.authorizations"><div class="block relative padding-right-sm padding-left-none override-xs-padding-none field-wrapper" ng-class="{\'margin-top-md\': !(vm.isLocationConfigured() === true && vm.showTimeFrameFilter)}"><div class="field-wrapper"><label for="sortByFilter">Sort by column</label><select ng-model-options="{ debounce: 750 }" allow-null-option="Sort by column" class="form-control" id="sortByFilter" name="sortByFilter" ng-model="vm.selectedMobileSort" ng-change="vm.mobileSortChanged()" ng-options="col for col in vm.classicSortColumns" ng-disabled="vm.searchingAppointments"></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 padding-right-sm" ng-class="{\'override-xs-margin-top-sm\': vm.filters.searchMode === vm.searchModes.classic, \'override-xs-margin-top-none\': vm.filters.searchMode !== vm.searchModes.classic}"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div class="chosen-field-wrapper"><label class="label selected margin-left-none">ADVISORS</label></div><div ng-dropdown-multiselect="" events="vm.advisorFilterEvents" disabled="vm.loadingAdvisors || vm.searchingAppointments || !vm.filters.serviceAdvisors || vm.filters.serviceAdvisors.length === 0" options="vm.filters.serviceAdvisors" selected-model="vm.filters.selectedAdvisorsFilter" checkboxes="true" extra-settings="vm.advisorFilterSettings" translation-texts="vm.advisorDropdownLabels"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-if="vm.isAppointmentView() && vm.isLocationConfigured() === true && vm.filters.searchMode !== vm.searchModes.mobileGarage"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-xs-margin-bottom-none override-sm-margin-top-none field-wrapper"><label for="trip_type">APPOINTMENT TYPE</label><select id="trip_type" class="form-control" ng-model="vm.filters.pickupDropoff" ng-model-options="{ debounce: 750 }" selectlabel="" ng-disabled="vm.searchingAppointments || !vm.filters.selectedDepartment || vm.filters.pickUpTransportationTypes.length == 0 || vm.filters.dropOffTransportationTypes.length == 0"><option value="">All appt types</option><option value="{{vm.transTypeGroups.dropoff}}">Customer drop off</option><option value="{{vm.transTypeGroups.pickup}}">Dealership pick up</option><option value="{{vm.transTypeGroups.mobile}}" ng-if="vm.mobileTransportationTypes && vm.mobileTransportationTypes.length > 0">Mobile service</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-if="vm.isAppointmentView() && vm.filters.searchMode !== vm.searchModes.mobileGarage && vm.isLocationConfigured() === true && !vm.filters.pickupDropoff || vm.filters.pickupDropoff === vm.transTypeGroups.mobile"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-xs-margin-bottom-none override-sm-margin-top-none field-wrapper"><label for="typeFilter">TRANSPORTATION TYPES</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="true" class="form-control" id="typeFilter" name="typeFilter" ng-model="vm.filters.selectedTypeFilter"><option value="">All transportation</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-if="vm.isAppointmentView() && vm.isLocationConfigured() === true && vm.filters.pickupDropoff === vm.transTypeGroups.dropoff"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none field-wrapper"><label for="typeFilter">TRANSPORTATION TYPES</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="typeFilter" name="typeFilter" ng-options="type.id as type.dashboardDescription for type in vm.filters.dropOffTransportationTypes" ng-model="vm.filters.selectedTypeFilter" ng-disabled="vm.searchingAppointments"><option value="">All transportation</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-if="vm.isAppointmentView() && vm.isLocationConfigured() === true && vm.filters.pickupDropoff === vm.transTypeGroups.pickup"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none field-wrapper"><label for="typeFilter">TRANSPORTATION TYPES</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="typeFilter" name="typeFilter" ng-options="type.id as type.dashboardDescription for type in vm.filters.pickUpTransportationTypes" ng-model="vm.filters.selectedTypeFilter" ng-disabled="vm.searchingAppointments"><option value="">All transportation</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-class="{\'override-xs-margin-top-md\': vm.isCheckInView(), \'override-xs-margin-top-none\': !vm.isCheckInView()}"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-sm override-sm-margin-top-none field-wrapper" ng-class="{\'override-xs-margin-bottom-none\': vm.isCheckInView()}"><label for="statusFilter" class="on selected">STATUSES</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="statusFilter" name="statusFilter" ng-options="status.code as status.description for status in vm.statuses" ng-model="vm.filters.selectedStatusFilter" ng-disabled="vm.searchingAppointments"><option value="">All (excl canceled)</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-none override-sm-margin-top-md padding-right-sm" ng-if="vm.isAppointmentView()"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><input ng-model="vm.filterByOpCodes" class="form-control better-placeholder" ng-model-options="{ debounce: 350 }" placeholder="OPCODE(S)"></div></div></div><div class="display-flex flex-row" ng-class="{\'padding-bottom-lg\': vm.filters.searchMode !== vm.searchModes.classic}"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vm.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md"><rc-list-template-save-search-delete-btns list-controller="vm" current-search-template="vm.searchTemplateData.currentSearchTemplate" is-processing-template="vm.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vm.canManageGlobalTemplates" template-message="vm.templateMessage" save-btn-clicked="vm.saveBtnClicked()" save-as-btn-clicked="vm.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div><div ng-if="vm.filters.searchMode === vm.searchModes.classic" class="display-flex flex-row padding-bottom-lg"><div class="flex-width-150 flex-xs-percent-100 flex-sm-percent-100 margin-top-sm content-center padding-right-sm"><div class="block relative padding-left-sm padding-right-sm xs-nopadding text-nowrap"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showServicesColumn" ng-model="vm.filters.showServicesColumn"> <span class="font-normal padding-left-sm">Show \'Services\' Column</span></label></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vm.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm" ng-click="vm.resetFilters(true);vm.close();">Reset Filters</div><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase margin-right-sm" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal><script type="text/ng-template" id="filter-popover.html"><div class=\'black\'>Location:<br/>{{vm.filters.selectedLocation.name}}</div></script><script type="text/ng-template" id="addl-op-codes-popover.html"><div class="appt-list-tooltip" ng-repeat="lineItem in vm.activePopoverAppt.servicesBreakdowns track by $index" ng-if="$index >= vm.maxServicesToShow"> <div class="margin-top-sm text-uppercase">{{ lineItem.opCode }}&nbsp;-&nbsp; <span class="description">{{ lineItem.opCodeDescription || \'NA\' }}</span> </div> <table> <tbody> <tr> <td>PAY:&nbsp;{{ lineItem.payType || \'NA\' }}</td> <td>HRS:&nbsp;{{ lineItem.laborHours || \'NA\' }}</td> <td>EST:&nbsp;{{ lineItem.retailPrice || \'NA\' }}</td> </tr> </tbody> </table> </div></script><script type="text/ng-template" id="op-codes-popover.html"><div class="appt-list-tooltip" ng-if="vm.currentTooltipBlock && vm.currentTooltipBlock.gettingTooltip">Loading services...</div> <div class="appt-list-tooltip" ng-if="vm.currentTooltipBlock && !vm.currentTooltipBlock.gettingTooltip" ng-repeat="lineItem in vm.currentTooltipBlock.tooltip.lineItems"> <div class="margin-top-sm text-uppercase">{{ lineItem.opCode }}&nbsp;-&nbsp; <span class="description">{{ lineItem.opCodeDescription || \'NA\' }}</span> </div> <table> <tbody> <tr> <td>PAY:&nbsp;{{ lineItem.payType || \'NA\' }}</td> <td>HRS:&nbsp;{{ lineItem.hours || \'NA\' }}</td> <td>EST:&nbsp;{{ lineItem.estimate || \'NA\' }}</td> </tr> </tbody> </table> </div></script>');
$templateCache.put('app/areas/appointment/views/appointment.view.html','<div class="row display-flex full-width-height margin-none" id="appointment-form"><div class="col-md-8 col-xs-12 border-radius-top-7 padding-none separate-left-aside-panel booking-content"><div class="display-flex flex-column overflow-hidden full-height border-radius-top-7"><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-none"><form role="form" id="bookApptForm" name="bookApptForm" class="full-height"><input type="hidden" id="fake-input" name="fake-input" validation="required" ng-model="vm.fakeInput"><div ng-if="vm.loadingAppointment"><div class="tab-loading-overlay"><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading...</div></div></div></div><div ng-if="vm.roHistoryPanelOpen" id="appointment-ro-history" class="bg-white"><vehicle-ro-history vin="vm.appointment.vin" make="vm.appointment.make" model="vm.appointment.model" year="vm.appointment.year" dealer-id="vm.appointment.location.id"></vehicle-ro-history></div><div ng-if="!vm.loadingAppointment && !vm.roHistoryPanelOpen" class="display-flex content-center theme-bg"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-15 override-sm-padding-none">New Appointment</div></div><div class="flex-percent-30 pull-right padding-right-md text-nowrap visible-xs visible-sm"><div id="enable-messages-link" class="theme-link pull-right padding-top-md padding-right-lg" ng-click="vm.enableMessaging(true)"><i class="material-icons md-24">forum</i></div></div></div><uib-accordion close-others="true" class="appointments-wizard" ng-if="!vm.loadingAppointment" ng-hide="vm.roHistoryPanelOpen"><div ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.chooseLocation || vm.accordion.selectedStep === vm.accordion.steps.summary}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep === vm.accordion.steps.chooseLocation" is-disabled="true"><ng-include src="\'app/areas/appointment/views/partials/appointment-choose-location.view.html\'" ng-controller="AppointmentChooseLocationController as vmLocPnl"></ng-include></div></div><div class="ng-hide margin-bottom-lg" ng-show="vm.accordion.selectedStep > vm.accordion.steps.chooseLocation || vm.accordion.selectedStep === vm.accordion.steps.summary" ng-class="{\'hide-border\': vm.accordion.selectedStep === vm.accordion.steps.customerVehicle || vm.accordion.selectedStep === vm.accordion.steps.summary}"><div uib-accordion-group="" class="panel-default margin-top-none" is-open="vm.accordion.selectedStep === vm.accordion.steps.customerVehicle" is-disabled="true"><ng-include src="\'app/areas/appointment/views/partials/appointment-customer-vehicle.view.html\'" ng-controller="AppointmentCustomerVehicleController as vmCustomerPnl"></ng-include></div></div><div class="ng-hide" ng-show="vm.accordion.selectedStep > vm.accordion.steps.customerVehicle || vm.accordion.selectedStep === vm.accordion.steps.summary" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.scheduleTransportation || vm.accordion.selectedStep === vm.accordion.steps.summary}"><div uib-accordion-group="" class="panel-default" is-disabled="true" is-open="vm.accordion.selectedStep === vm.accordion.steps.scheduleTransportation"><ng-include src="\'app/areas/appointment/views/partials/appointment-schedule-transportation.view.html\'" ng-controller="AppointmentScheduleTransportationController as vmSchedulePnl"></ng-include></div></div><div class="ng-hide" ng-show="vm.accordion.selectedStep > vm.accordion.steps.scheduleTransportation || vm.accordion.selectedStep === vm.accordion.steps.summary" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.summary || vm.accordion.selectedStep === vm.accordion.steps.summary}"><div uib-accordion-group="" class="panel-default" is-disabled="true" is-open="vm.accordion.selectedStep === vm.accordion.steps.summary"><ng-include src="\'app/areas/appointment/views/partials/appointment-booking-summary.view.html\'" ng-controller="AppointmentBookingSummaryController as vmSummaryPnl"></ng-include></div></div></uib-accordion></form></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2"><div class="row padding-md padding-right-lg"><div class="col-md-12 col-sm-12 col-xs-12 text-right padding-left-none margin-top-md" ng-if="vm.roHistoryPanelOpen"><button type="button" class="btn btn-primary text-uppercase" ng-class="config.styleClass" ng-click="vm.roHistoryPanelOpen = false">BACK</button></div><div class="col-md-8 col-sm-12 col-xs-12 padding-right-none" ng-if="!vm.roHistoryPanelOpen && (vm.appointment.appointmentStatus === vm.appointmentCanceledStatusId || vm.loadingCustomerDetails || vm.retrievingRecalls || vm.retrievingMaint || (vm.accordion.selectedStep === vm.accordion.steps.summary && vm.showNextBtn() === true && vm.customerPhoneType.type !== vm.phoneTypes.landline))"><div ng-if="vm.appointment.appointmentStatus === vm.appointmentCanceledStatusId" class="text-danger margin-top-md"><div class="col-xs-12 padding-none text-uppercase" title="REASON: {{vm.appointment.cancellationReason}}"><i class="material-icons">event_busy</i> <b>CANCELED BY {{ vm.appointment.cancellationIdentityUserFirstName }} {{ vm.appointment.cancellationIdentityUserLastName }}</b></div></div><div ng-if="vm.retrievingRecalls || vm.retrievingMaint" class="text-uppercase margin-top-md"><img src="assets/images/ajax-loader.gif"> Retrieving Vehicle Data...</div><div ng-if="vm.loadingCustomerDetails" class="text-uppercase margin-top-md"><img src="assets/images/ajax-loader.gif"> Searching existing customers...</div><div ng-if="vm.accordion.selectedStep === vm.accordion.steps.summary && vm.showNextBtn() === true && vm.customerPhoneType.type !== vm.phoneTypes.landline"><label class="font-normal"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" class="margin-none" id="confirmTextOptIn" name="confirmTextOptIn" ng-click="$event.stopPropagation();" ng-model="vm.appointment.mobileSmsOptedIn"></div><div class="col-xs-11 padding-left-sm"><span id="customer-text-opt-in">I have confirmed my customer agrees to receive text messages about their appointment, vehicle service, and transportation. They understand they may receive several messages a day and can opt out at any time by replying STOP in their messaging app.</span></div></div></label></div><div class="col-xs-12 validation text-danger margin-bottom-md" ng-if="vm.bookClicked && !vm.appointment.mobileSmsOptedIn && vm.customerPhoneType.type !== vm.phoneTypes.landline">*Customer must agree to receive text messages before continuing.</div></div><div class="col-md-4 col-sm-12 col-xs-12 text-right padding-left-none padding-right-none margin-top-md pull-right" ng-if="!vm.roHistoryPanelOpen"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ladda="vm.closeBusy" ng-click="vm.closeClicked()">CLOSE</button> <span ng-if="vm.showBackBtn()"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-click="vm.backClicked()">BACK</button></span> <span ng-if="vm.showCheckInBtn()"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ladda="vm.updatingAppt" ng-class="config.styleClass" ng-click="vm.checkInClicked()">CHECK IN</button></span> <span ng-if="vm.showNextBtn()"><button type="button" class="btn btn-primary margin-right-xs" ng-class="config.styleClass" ng-click="vm.nextClicked()" ng-disabled="vm.disableNext || vm.isFormInvalid() || vm.closeBusy" ladda="vm.nextBusy">{{vm.getNextBtnText()}}</button></span> <span ng-if="vm.showEditBtn()"><button type="button" class="btn text-uppercase btn-primary" ng-class="config.styleClass" ng-click="vm.editClicked()">EDIT</button></span></div></div></div></div></div><div id="appt-messages" class="col-md-4 col-xs-12 padding-none separate-right-aside-panel margin-left-md border-radius-top-7 tab-flex-container"><div class="border-radius-top-7 display-flex flex-column overflow-hidden full-height theme-bg"><div class="flex-fullwidth-20h border-radius-top-7 visible-xs visible-sm theme-bg padding-left-20 padding-right-md"><div class="display-flex content-center theme-bg padding-top-8"><div class="flex-percent-70 pull-left text-bold font-size-16 text-uppercase"><div class="padding-left-15 override-sm-padding-none">New Appointment</div></div><div class="flex-percent-30 pull-right padding-right-md text-nowrap visible-xs visible-sm"><div id="disable-messages-link" class="theme-link pull-right padding-top-md padding-right-md" ng-click="vm.enableMessaging(false)"><i class="material-icons md-24">comments_disabled</i></div></div></div></div><div class="tab-inner-div border-radius-top-7"><uib-tabset class="aside-right-tabs"><uib-tab ng-repeat="tab in vm.tabs" heading="{{::tab.title}}" active="tab.active" ui-sref="{{tab.route}}" disable="tab.disabled" ng-hide="vm.accordion.selectedStep === vm.accordion.steps.summary && vm.resolvedAppointmentId && !vm.editingExistingAppointment && tab.title !== \'MESSAGE\'"><span ui-view="{{::tab.route}}"><div class="tab-loading-overlay bg-white color-default"><div class="centered-content loading-container text-center bg-white"><img src="assets/images/ajax-loader.gif"><div class="black">Loading...</div></div></div></span></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/areas/auth/views/access-denied.view.html','<div class="frame-in"><div ng-cloak="" id="wrapper" class="top-navigation"><div class="navbar-header"><nav id="frame_navbar" class="navbar navbar-fixed-top"><center><h2>Let\'s Start Booking Some Deliveries!</h2></center></nav></div></div><img src="..//assets/images/map-bg.png"><div id="content" class="content {{$state.name}}" ng-class="config.styleClass"><p>Oops! We don\'t have any deliveries to report or track. Please come back after you have booked some parts delivieries!</p><p>OE Connections makes it easy for you to quickly get your parts to your customer without the normal wait. Book Hot Shot Deliveries right from the parts fulfillment page and track progress in real time! Simply click Hot Shot Delivery when fulfilling your orders, tell us where to drop off your parts, and we\'ll handle the rest!</p><br><br><p><center><a href="" class="text-uppercase">Learn More!</a></center></p></div></div>');
$templateCache.put('app/areas/auth/views/forgotemail.view.html','<div class="login-page-container"><div class="display-flex flex-column full-width-height"><div class="login-box flex-grow full-width-height text-nowrap"><center><img class="logo-image margin-bottom-30" ng-src="{{config.loginLogo}}"></center><form role="form" name="ForgotEmailForm" class="form" ng-submit="ForgotEmailForm.$valid && vm.send()"><br><h3>Forgot Login Email Address</h3><p class="whitespace-normal">Enter your mobile number and we will send you a text message with the email address you are registered with to your mobile device.</p><br><div class="form-group relative"><input id="mobilePhone" name="mobilePhone" type="text" class="form-control better-placeholder" required="" placeholder="MOBILE" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.mobilePhone):alt=Invalid Phone Number" ng-model="vm.mobilePhone" autofocus=""></div><br><div class="form-actions"><button type="button" class="btn btn-w-m btn-default" ng-class="config.styleClass" ng-click="vm.back()">Back</button> <button type="submit" class="btn btn-w-m btn-primary pull-right" ng-class="config.styleClass" ladda="isDataLoading">Send</button></div></form></div></div></div>');
$templateCache.put('app/areas/auth/views/forgotpassword.view.html','<div class="login-page-container"><div class="display-flex flex-column full-width-height"><div class="login-box flex-grow full-width-height text-nowrap"><center><img class="logo-image margin-bottom-30" ng-src="{{config.loginLogo}}"></center><form role="form" name="ForgotPasswordForm" class="form" ng-submit="ForgotPasswordForm.$valid && vm.send()"><br><h3>Forgot Password</h3><p class="whitespace-normal">Enter the email address associated with your account to receive a temporary password via the selected notification method below.</p><br><br><div class="form-group"><p><b>Notification Method</b></p><div class="display-flex flex-row"><div class="display-flex flex-percent-50"><label class="align-text-bottom"><input class="align-text-bottom" id="notifyEmail" type="radio" name="notificationMethod" value="email" ng-model="vm.method" checked=""> Email</label></div><div class="display-flex flex-percent-50"><label class="align-text-bottom"><input class="align-text-bottom" id="nofityText" type="radio" name="notificationMethod" value="text" ng-model="vm.method"> Text</label></div></div></div><div class="form-group relative"><input id="emailAddress" name="emailAddress" type="email" class="form-control better-placeholder" required="" placeholder="EMAIL ADDRESS" validation="email:alt=A valid Email Address is required" ng-model="vm.emailAddress" autofocus=""></div><br><div class="form-actions"><button type="button" class="btn btn-w-m btn-default" ng-class="config.styleClass" ng-click="vm.back()">Back</button> <button type="submit" class="btn btn-w-m btn-primary pull-right" ng-class="config.styleClass" ladda="isDataLoading">Send</button></div></form></div></div></div>');
$templateCache.put('app/areas/auth/views/login.view.html','<div class="login-page-container"><div class="display-flex flex-column full-width-height"><div class="login-box flex-grow full-width-height text-nowrap" ng-class="{\'has-error\': vm.error.message != \'\'}"><div class="display-flex flex-column content-center margin-top-auto margin-bottom-auto min-height-px-500"><img class="logo-image margin-bottom-30" ng-src="{{config.loginLogo}}"><div class="messageBox margin-top"><div ng-if="!vm.showLoginFields && vm.accountStatus === vm.solidMigrationStatus.inProgress"><div class="display-flex flex-column flex-grow flex-percent-90 inline-block"><h3 class="multiline-title margin-top">Multifactor Authentication (MFA) is Coming!</h3><h4 class="multiline-title margin-top">You have until <b>{{ vm.migrateToSolidDate | date:\'MMMM d, y\' }}</b> ({{vm.migrateDaysLeft < 0 ? 0 : vm.migrateDaysLeft}}), to set it up.</h4><p class="multiline margin-top">MFA will help keep your account secure by confirming your identity using Microsoft Authenticator or a code sent via text message when you log in.<br><br>You must have your own Username/Password and a mobile device to complete setup which will take about 5 minutes.<br><br>You may choose to skip until {{ vm.migrateToSolidDate | date:\'MMMM d, y\' }}, however we encourage you to set this up before time runs out as there are no exceptions.</p></div></div><div ng-if="!vm.showLoginFields && vm.accountStatus === vm.solidMigrationStatus.dueDatePassed"><div class="display-flex flex-column flex-grow flex-percent-90 inline-block"><h3 class="multiline-title margin-top">Multifactor Authentication (MFA) <span>is Required</span></h3><h4 class="multiline-title margin-top">You must set up MFA in order to log into Service Suite.</h4><p class="multiline margin-top">MFA will help keep your account secure by confirming your identity using Microsoft Authenticator or a code sent via text message when you log in.<br><br>You must have your own Username/Password and a mobile device to complete setup, which will take about 5 minutes.<br><br>Click CONTINUE below to begin.</p></div></div></div><form class="margin-top" role="form" ng-submit="vm.validateUserIsMigrated()" allow-unsaved=""><div ng-if="vm.error.message != \'\'" class="margin-bottom ng-binding"><div ng-if="vm.error.redirectLink != \'\'">Oops! You don\'t have access to this site. Please login at <a href="{{ vm.error.redirectLink }}">{{ vm.error.redirectLink }}</a></div><div ng-if="vm.error.redirectLink == \'\'" ng-bind-html="vm.error.message" class="font-size-12"></div></div><div class="form-group relative"><input type="email" class="form-control better-placeholder" id="email_address" required="" autocomplete="username" ng-model="vm.loginData.userName" placeholder="EMAIL ADDRESS" ng-readonly="vm.isUsernameReadonly" ng-focus="vm.enableUsernameInput()" ng-click="vm.enableUsernameInput()" ng-disabled="vm.accountStatus !== null"></div><div class="form-group relative" ng-if="vm.accountStatus === null || vm.accountStatus === vm.solidMigrationStatus.completed"><button type="submit" class="btn btn-primary full-width" ladda="vm.isDataLoading">Continue</button></div><div ng-if="!vm.showLoginFields && (vm.accountStatus === vm.solidMigrationStatus.inProgress || vm.accountStatus === vm.solidMigrationStatus.dueDatePassed)"><div class="form-actions" ng-if="vm.accountStatus !== vm.solidMigrationStatus.dueDatePassed"><div class="row"><div class="col-xs-6 text-left margin-top-md text-nowrap"><button type="button" ng-click="vm.skipMigration()" class="btn pull-right btn-default block full-width" ng-disabled="vm.isDataLoading">Skip</button></div><div class="col-xs-6 margin-top-md text-nowrap"><button type="button" ng-click="vm.startMigration()" class="btn pull-right btn-primary block full-width" ladda="vm.isDataLoading">Continue</button></div></div></div><div class="form-group relative" ng-if="vm.accountStatus == vm.solidMigrationStatus.dueDatePassed"><button type="button" ng-click="vm.startMigration()" class="btn btn-primary full-width" ladda="vm.isDataLoading">Continue</button></div></div></form><form role="form" ng-submit="vm.login()" allow-unsaved=""><div ng-if="vm.showLoginFields || vm.accountStatus === vm.solidMigrationStatus.notStarted"><div class="form-group relative" ng-if="!vm.showPassword"><input type="password" class="form-control better-placeholder" id="password" placeholder="PASSWORD" autocomplete="current-password" required="" ng-model="vm.loginData.password"> <i ng-click="vm.toggleShowPassword()" class="material-icons material-icons-large material-icons-outlined login-eye" ng-class="{\'invisible\': !vm.showIcons}" title="Show Password">remove_red_eye</i></div><div class="form-group relative" ng-if="vm.showPassword"><input type="type" class="form-control better-placeholder" placeholder="PASSWORD" required="" ng-model="vm.loginData.password"> <i ng-class="{\'invisible\': !vm.showIcons}" ng-click="vm.toggleShowPassword()" class="material-icons material-icons-large login-eye" title="Show Password">remove_red_eye</i></div><div class="form-actions"><div class="row"><div class="col-xs-6 text-left margin-top-md text-nowrap"><label class="text-uppercase margin-none display-flex content-center"><input type="checkbox" class="checkbox inline" ng-model="vm.loginData.rememberToggle" value="true" id="rememberMe"> Remember Me</label></div><div class="col-xs-6"><button type="submit" ladda="isDataLoading" class="pull-right btn btn-primary block full-width margin-bottom" ng-class="config.styleClass">Login</button></div></div></div></div><div class="form-inline no-wrap hidden-xs"><div class="form-group inline"><div class="display-flex flex-row text-uppercase margin-top"><div class="flex-percent-50 text-left margin-right" ng-if="!vm.showLoginFields && (vm.accountStatus === vm.solidMigrationStatus.dueDatePassed || vm.accountStatus === vm.solidMigrationStatus.inProgress)"><a class="alt-theme-link font-size-12" target="new" href="https://redcapstorage.blob.core.windows.net/help-page-content/MFA/Service Suite MFA Support Guide.pdf"><b>MFA Help</b></a></div><div class="flex-percent-50 text-left margin-right" ng-if="vm.showLoginFields"><a class="alt-theme-link font-size-12" ui-sref="forgotpassword"><b>Forgot password?</b></a></div><div ng-class="{\'flex-percent-100\': !vm.showLoginFields && !(vm.accountStatus === vm.solidMigrationStatus.dueDatePassed || vm.accountStatus === vm.solidMigrationStatus.inProgress), \'flex-percent-50\': vm.showLoginFields || (vm.accountStatus === vm.solidMigrationStatus.dueDatePassed || vm.accountStatus === vm.solidMigrationStatus.inProgress)}" class="text-right margin-left"><a class="alt-theme-link font-size-12" target="new" ui-sref="privacypolicy"><b>Privacy Policy</b></a></div></div></div></div><i class="material-icons material-icons-large login-eye invisible" title="Show Password">remove_red_eye</i></form></div></div><div class="static-footer visible-xs text-nowrap"><div class="display-flex flex-row text-uppercase margin-bottom"><div class="flex-percent-50 text-left margin-left" ng-if="!vm.showLoginFields && (vm.accountStatus === vm.solidMigrationStatus.dueDatePassed || vm.accountStatus === vm.solidMigrationStatus.inProgress)"><a class="alt-theme-link font-size-16" target="new" href="https://redcapstorage.blob.core.windows.net/help-page-content/MFA/Service Suite MFA Support Guide.pdf"><b>MFA Help</b></a></div><div class="flex-percent-50 text-left margin-left" ng-if="vm.showLoginFields || (vm.accountStatus !== vm.solidMigrationStatus.dueDatePassed && vm.accountStatus !== vm.solidMigrationStatus.inProgress)"><a class="alt-theme-link font-size-16" ui-sref="forgotpassword"><b>Forgot password?</b></a></div><div ng-class="{\'flex-percent-100\': !vm.showLoginFields && !(vm.accountStatus === vm.solidMigrationStatus.dueDatePassed || vm.accountStatus === vm.solidMigrationStatus.inProgress), \'flex-percent-50\': vm.showLoginFields || (vm.accountStatus === vm.solidMigrationStatus.dueDatePassed || vm.accountStatus === vm.solidMigrationStatus.inProgress)}" class="text-right margin-right"><a class="alt-theme-link font-size-16" target="new" ui-sref="privacypolicy"><b>Privacy Policy</b></a></div></div></div></div></div>');
$templateCache.put('app/areas/auth/views/mobile-app-download.view.html','<div class="middle-box middle-box-wide forgotpasswordscreen container"><div><nav class="navbar navbar-fixed-top" ng-class="config.styleClass"><div style="padding-top: 15px;"><div class="logo" ng-style="{ \'background-image\': \'url(\' + config.loginLogo + \')\' }"></div></div></nav><div style="padding-top: 30px;"><h2 class="text-center"><p>{{ config.programName }}</p><p>Driver app installation</p></h2><div class="form-group row text-center"><img src="https://redcapstorage.blob.core.windows.net/automotivelogos/car-drop.png"></div><div class="form-group row text-center"><h3>Visit your app store to install the CarDrop driver application.</h3></div><div class="form-group row text-center"><a href="{{ vm.iosAppLink }}"><img src="https://redcapstorage.blob.core.windows.net/automotivelogos/apple-store.jpeg"></a></div><div class="form-group row text-center"><a href="{{ vm.androidAppLink }}"><img src="https://redcapstorage.blob.core.windows.net/automotivelogos/play-store.png"></a></div></div></div></div>');
$templateCache.put('app/areas/auth/views/new-user-complete.view.html','<div class="middle-box middle-box-wide forgotpasswordscreen"><div><div class="logo" ng-style="{ \'background-image\': \'url(\' + config.loginLogo + \')\' }"></div><div class="form form-horizontal newuser-box" ng-submit="vm.confirm()" style="margin-top: 20px; border: 1px solid #e7e7e7;"><h2 class="text-center">Profile Created!</h2><p class="text-center">Thank you for completing your profile. Your account has been successfully created.</p><hr><div class="form-actions text-center"><button type="submit" class="btn btn-w-m btn-primary" ng-class="config.styleClass" ng-click="vm.complete()">Login</button></div></div></div></div>');
$templateCache.put('app/areas/auth/views/new-user.view.html','<div class="vh-h100 overflow-x-hidden"><div class="middle-box middle-box-wide forgotpasswordscreen"><div><div class="full-width theme-bg padding-md"><center><img src="{{config.logo}}"></center></div><form role="form" id="confirmUserForm" name="confirmUserForm" class="form form-horizontal newuser-box border-default" ng-submit="vm.confirm(confirmUserForm.$invalid)"><h2 class="text-center">Confirm your profile</h2><p class="text-center">Confirm we have the information to complete your account setup. Be sure you\'re smiling, customers will see your photo!</p><hr><div class="form-group"><div class="row text-center"><div class="profilePicCropArea text-center ng-hide margin-auto" ng-show="vm.profileImageUpload"><ui-cropper image="vm.profileImageUpload" result-image="vm.profileImage"></ui-cropper></div><div class="ng-hide" ng-show="!vm.profileImageUpload"><img ng-src="{{ vm.user.profilePicture }}"></div></div><div class="row"><div class="col-sm-4 col-sm-offset-4 col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-4"><button type="button" class="form-control" ng-click="vm.validation.profileImage()">Choose Image</button> <input type="file" id="fileInput" name="fileInput" ng-model="vm.fileInput" file-input="vm.profileImageUpload" ng-hide="true"></div><div class="col-xs-12 text-center"><div class="col-sm-12 validation validation-code text-danger" ng-if="vm.message.length > 0">{{ vm.message }}</div></div></div></div><br><div class="form-group"><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">User Name</label><div class="col-sm-7 col-xs-8 static-text">{{ vm.user.email }}</div></div><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">First Name</label><div class="col-sm-7 col-xs-8"><input id="firstName" name="firstName" required="" type="text" class="form-control" placeholder="FIRST NAME" validation="required" ng-model="vm.user.firstName" autofocus=""></div></div><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">Last Name</label><div class="col-sm-7 col-xs-8"><input id="lastName" name="lastName" type="text" class="form-control" placeholder="LAST NAME" required="" validation="required" ng-model="vm.user.lastName"></div></div><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">Office Phone</label><div class="col-sm-7 col-xs-8"><input id="officePhone" name="officePhone" type="text" class="form-control" placeholder="OFFICE PHONE" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" validation="required|custom:vm.validation.phone(vm.user.officePhone)" ng-model="vm.user.officePhone"></div></div><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">Mobile Phone</label><div class="col-sm-7 col-xs-8"><input id="mobilePhone" name="mobilePhone" type="text" class="form-control" placeholder="MOBILE PHONE" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" validation="required|custom:vm.validation.phone(vm.user.mobilePhone)" ng-model="vm.user.mobilePhone"></div></div></div><div ng-if="vm.user.solidAccountStatus !== vm.solidMigrationStatus.dueDatePassed"><hr><h2 class="text-center">Create your password</h2><p class="text-center">Create a password for your account. Your password must be at least 8 characters, contain one capital letter and one numeric.</p><div class="form-group"><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">Password</label><div class="col-sm-7 col-xs-8"><input id="password" name="password" type="password" class="form-control" required="" placeholder="PASSWORD" validation="required|remote:vm.validation.password(vm.user.password)" ng-model="vm.user.password"></div></div><div class="row form-group"><label class="col-sm-4 col-xs-4 control-label">Confirm Password</label><div class="col-sm-7 col-xs-8"><input id="confirmPassword" name="confirmPassword" type="password" required="" class="form-control" placeholder="CONFIRM PASSWORD" validation="required|custom:vm.validation.passwordConfirmation(vm.user.password, vm.user.confirmPassword)" ng-model="vm.user.confirmPassword"></div></div></div></div><br><div class="form-actions text-center"><button type="submit" class="btn btn-w-m btn-primary" ng-class="config.styleClass" ladda="isDataLoading">Confirm</button></div></form></div></div></div>');
$templateCache.put('app/areas/auth/views/not-found.view.html','<div class="header row ibox-content"><div class="col-xs-12 text-center"><strong>Page Not Found</strong></div></div><div class="centered-content text-center not-found-msg"><i class="material-icons">error_outline</i><div>The page you\'re trying to reach could not be found.</div></div>');
$templateCache.put('app/areas/auth/views/privacypolicy.view.html','<div class="overflow-y-auto vh-h100 padding-top-lg padding-bottom-md"><link rel="stylesheet" type="text/css" href="https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/css/v2/otnotice-layout-left-aligned-menu.css"><div id="otnotice-2d30dc16-2639-44a7-8095-9053b7a71ba9" class="otnotice"></div><script src="https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js" type="text/javascript" charset="UTF-8" id="otprivacy-notice-script" document-language="true" language="en">\r\n        settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vZ2xvYmFsZHNhci5zb2xlcmEuY29tL3JlcXVlc3QvdjEvcHJpdmFjeU5vdGljZXMvc3RhdHMvdmlld3MiLCJjb250ZW50QXBpVXJsIjoiaHR0cHM6Ly9nbG9iYWxkc2FyLnNvbGVyYS5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvY29udGVudCIsIm1ldGFkYXRhQXBpVXJsIjoiaHR0cHM6Ly9nbG9iYWxkc2FyLnNvbGVyYS5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0="\r\n    </script><script type="text/javascript" charset="UTF-8">\r\n        // To ensure external settings are loaded, use the Initialized promise:\r\n        OneTrust.NoticeApi.Initialized.then(function() {\r\n            OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/storage-container/20bbc57b-6134-4535-8062-a1745b771851/privacy-notices/2d30dc16-2639-44a7-8095-9053b7a71ba9/published/privacynotice.json"]);\r\n        });\r\n    </script></div>');
$templateCache.put('app/areas/driver/views/driver-add.view.html','<div class="row display-flex flex-column overflow-hidden full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New Driver</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-lg flex-grow flex-percent-90 col-xs-12 bg-white border-none"><div class="row padding-top-md padding-bottom-lg"><div class="col-sm-4"><div class="block relative"><select ng-if="vm.showDriverImport" ng-model="vm.driverAddMode" class="form-control batch-select better-placeholder" placeholder="Add Mode"><option value="1">Add a single driver</option><option value="2">Import a batch of drivers</option></select></div></div></div><div ng-show="vm.driverAddMode === \'1\'"><h3>Driver Information</h3><p>Complete the fields provided to add the Driver. Most fields are required.</p><hr><form role="form" id="DriverAddForm" name="DriverAddForm" class="form" ng-submit="DriverAddForm.$valid && vm.createDriver()" novalidate=""></form><div class="row"><div class="col-sm-4" ng-if="!vm.isOnlyDealerAdmin"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Select the Driver\'s Company" popover-placement="right" popover-trigger="outsideClick">Driver Company</span></label><ui-select class="fake-required" search-enabled="false" ng-model="vm.companyId" ng-required="true" on-select="vm.companySelected()"><ui-select-match placeholder="Select a company in the list...">{{ $select.selected.value.name }}</ui-select-match><ui-select-choices repeat="company.value.id as (key, company) in vm.companies"><div><span ng-bind-html="company.value.name"></span></div></ui-select-choices></ui-select></div></div><div class="col-sm-4" ng-if="vm.isInternalCompany()"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter the Driver\'s User Name - 10 Digit Phone Number" popover-placement="right" popover-trigger="outsideClick">Login User Name - 10 Digit Phone Number</span></label> <input type="text" id="driver_userName" name="driver_userName" mask-restrict="reject" mask="(999) 999-9999" clean="true" ng-model="vm.userName" ng-disabled="!vm.companyId" class="form-control" required="" validation="required|remote:vm.driverIdRemoteValidation():"></div></div><div class="col-sm-4" ng-if="!vm.isInternalCompany()"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter the Driver\'s User Name" popover-placement="right" popover-trigger="outsideClick">Login User Name</span></label> <input type="text" id="driver_userName" name="driver_userName" ng-model="vm.userName" class="form-control" ng-disabled="!vm.companyId" required="" validation="required|remote:vm.driverIdRemoteValidation()"></div></div><div class="col-sm-3 margin-top-20" ng-if="vm.companyId && !vm.userName"><span ng-if="vm.companyId && !vm.userName" class="font-size-12 text-danger">Please enter a Login User Name<br>to enable all form fields.</span></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter Driver\'s first name." popover-placement="right" popover-trigger="outsideClick">First Name</span></label> <input type="text" id="first_name" name="first_name" ng-model="vm.firstName" ng-disabled="vm.fieldsDisabled" class="form-control" required="" validation="required"></div></div><div class="col-sm-4"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter Driver\'s last name." popover-trigger="outsideClick">Last Name</span></label> <input type="text" id="last_name" name="last_name" ng-model="vm.lastName" ng-disabled="vm.fieldsDisabled" class="form-control" required="" validation="required"></div></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter Driver\'s email address." popover-placement="right" popover-trigger="outsideClick">Email Address</span></label> <input type="email" id="email_address" name="email_address" ng-model="vm.emailAddress" ng-disabled="vm.fieldsDisabled" class="form-control" required="" validation="email:alt=Must be a valid email address."></div></div><div class="col-sm-4"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter Driver\'s mobile phone number to associate to their account." popover-trigger="outsideClick">Mobile Number</span></label> <input type="text" id="mobile_number" name="mobile_number" mask-restrict="reject" mask="(999) 999-9999" clean="true" ng-model-options="{ debounce: 750 }" ng-model="vm.mobilePhone" ng-disabled="vm.fieldsDisabled" class="form-control" required="" validation="required|custom: vm.validation.phoneNumberRequired(vm.mobilePhone):alt=*"></div></div></div><div class="display-flex content-center margin-top-20"><switch id="welcome_email" name="welcome_email" ng-model="vm.sendWelcomeEmail" disabled="vm.fieldsDisabled" class="green small-switch"></switch><label for="welcome_email" class="control-label padding-left-md margin-top-sm">Send Welcome Message</label></div><div class="display-flex content-center margin-top-20" ng-if="!vm.isOnlyDealerAdmin"><switch id="suppresspay" name="suppress_pay" ng-model="vm.suppressPay" disabled="vm.fieldsDisabled" class="green small-switch"></switch><label for="suppress_pay" class="control-label padding-left-md margin-top-sm">Suppress Pay</label></div><div class="display-flex content-center margin-top-20" ng-if="vm.isNetworkDriver() && !vm.isOnlyDealerAdmin"><switch id="is_dedicated" name="is_dedicated" ng-model="vm.isDedicated" disabled="vm.fieldsDisabled" class="green small-switch"></switch><label for="is_dedicated" class="control-label padding-left-md margin-top-sm">Is Dedicated</label></div><div class="display-flex content-center margin-top-20" ng-if="!vm.isNetworkDriver() && !vm.isOnlyDealerAdmin"><switch id="is_vetted" name="is_vetted" ng-model="vm.isDnsVetted" disabled="vm.fieldsDisabled" class="green small-switch"></switch><label for="is_vetted" class="control-label padding-left-md margin-top-sm">Is DNS Vetted</label></div><div class="row margin-top" ng-if="!vm.isNetworkDriver() || vm.forceDisplayLocationSelection === true"><div class="col-sm-8"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Select the Driver\'s home Dealership." popover-placement="right" popover-trigger="outsideClick">Home Dealership</span></label><ui-select class="fake-required" ng-model="vm.selectedLocation" on-select="vm.locationSelected($item, $model)" ng-disabled="vm.fieldsDisabled"><ui-select-match placeholder="Select or search a location in the list...">{{ $select.selected.name }}</ui-select-match><ui-select-choices refresh="vm.locationsFilter($select.search)" refresh-delay="250" repeat="location in vm.locations | limitTo: vm.locationDisplayLimit track by location.id"><div><span ng-bind-html="location.locationHtml | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div></div><div class="margin-top-xs text-danger font-size-12" ng-if="vm.companyId && vm.userName && !vm.showCertifications()">Please select a Home Dealer.</div><div class="margin-top-lg" ng-if="vm.companyId && vm.showCertifications()"><h3>Driver Permissions</h3><p>Select the trips below this driver will be expected to execute. This driver can only be assigned or receive offers for the items that are selected. At least one item below must be selected to continue.</p><hr><p class="text-danger" ng-show="!vm.hasSelectedCertification() && vm.showCertifications()">At least one certification must be selected before saving.</p><div ng-if="vm.showCertifications()" class="display-flex content-center margin-top-20" ng-repeat="certification in vm.certifications"><input type="checkbox" class="margin-none" id="cert_{{ certification.id }}" name="cert_{{ certification.name }}" ng-model="certification.isSelected" ng-disabled="vm.loadingCertifications"> <label class="control-label margin-none padding-left-md"><span class="cursor-pointer hover-underline" uib-popover="Toggle the {{ certifcation.name }} permission" popover-trigger="outsideClick">{{ certification.name }}</span></label></div></div></div><div ng-if="vm.driverAddMode == 2"><h3>Batch user Upload</h3><p>Select the file you want to upload and the user you want to copy settings from. Click <a class="theme-link" href="https://redcapstorage.blob.core.windows.net/misc/UserImportTemplate.csv">SampleUserFile.CSV</a> to download an empty file in the proper format.</p><hr><form role="form" id="UserAddForm" name="UserAddForm" class="form" ng-submit="UserAddForm.$valid && vm.importUsers()" novalidate=""><div class="btn btn-default margin-right-md margin-bottom" ngf-select="vm.chooseImportFile($file)" ng-model="vm.bulkImport.file" ng-disabled="vm.isLoadingData" required="">Browse...</div><span>{{ vm.bulkImport.fileName }}</span> <img src="assets/images/ajax-loader.gif" ng-if="vm.readingFile"><div class="col-sm-4 padding-left-none"><select select2="" id="userCopy" name="userCopy" placeholder="Select user to copy from" min-input-length="3" format-for-selection="vm.formatForUserSelection" format-for-dropdown="vm.formatForUserDropdown" allow-any-input-on-empty-results="false" query="vm.userSearchQuery" ng-model="vm.importUser"></select></div><div class="margin-top" ng-if="vm.isLoadingData"><span>Processing...</span> <img src="assets/images/ajax-loader.gif"></div><div class="margin-top" ng-if="vm.importCompleted">The import process has completed. Please check your email for a full summary of the results. A spreadsheet with saved Id\'s for each record should have automatically downloaded from this page. If the SavedId is 0 in the spreadsheet it indicates that the record was already added or failed to add. These details should be available in the summary email.</div><div ng-if="vm.importResults"><hr><h4>RESULTS</h4><div class="margin-bottom">SUCCESSFUL RECORDS: {{ vm.importResults.successfulRecordCount }}</div><div class="margin-bottom">SKIPPED RECORDS: {{ vm.importResults.skippedUsers.length }} <span>(These users were already added)</span></div><ul ng-if="vm.importResults.skippedUsers.length > 0"><li ng-repeat="skippedUser in vm.importResults.skippedUsers">{{ skippedUser }}</li></ul><div ng-if="vm.importResults.genericErrors" class="margin-bottom text-danger"><div ng-repeat="importError in vm.importResults.genericErrors"><div>Error occurred while trying to parse the file: {{ importError.errorMessage }}</div></div></div><div ng-if="vm.importResults.errors" class="text-danger"><div class="margin-bottom">FAILED RECORDS: {{ vm.importResults.errors.length }}</div><div ng-repeat="importError in vm.importResults.errors"><div>Error occurred for user: {{ importError.userEmail }}, {{ importError.errorMessage }}</div></div></div></div></form></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 padding-right-20 text-right"><div class="display-flex full-width-height content-center"><div class="pull-right full-width"><div ng-if="vm.driverAddMode == 1"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="driver-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.createDriver()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || DriverAddForm.$invalid || (!vm.isNetworkDriver() && !vm.homeDealer) || (vm.forceDisplayLocationSelection && !vm.homeDealer) || !vm.hasSelectedCertification()">NEXT</button></div><div ng-if="vm.driverAddMode == 2"><button type="button" class="btn btn-default" ng-class="config.styleClass" ui-sref="user-list">Close</button> <button type="button" ng-click="vm.importUsers()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.isLoadingData" ng-disabled="UserAddForm.$invalid">Upload</button></div></div></div></div></div>');
$templateCache.put('app/areas/driver/views/driver-edit.view.html','<div class="display-flex overflow-hidden vh-h100 flex-column separate-left-aside-panel"><div class="flex-fullwidth-50h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><div class="modal-header padding-t-b-0 padding-top-none padding-bottom-none"><div class="row"><div class="col-xs-12 col-sm-7 padding-sm padding-top-none padding-bottom-none"><h2 class="modal-title ellipsis-overflow">Edit Driver:<driver-name class="inline-block margin-left-sm" ng-if="vm.currentDriver.name != \'\'" driver="vm.currentDriver"></driver-name><span ng-if="vm.currentDriver.name == \'\'">{{ vm.currentDriver.id }} (Login)</span></h2></div></div></div></div><div class="overflow-y-hidden overflow-x-hidden flex-percent-100 col-xs-12 bg-white padding-none"><div class="flex-fill full-height" fill-height="" aside-parent="vm.childScopeForm"><div id="driver-tab-container" scrollable-tabs="" class="margin-none bg-white font-normal" scroll-amount="150"><uib-tabset class="invisible-tabs scrollable full-height tab-content-padding-none"><uib-tab ng-repeat="tab in vm.tabs" heading="{{tab.title}}" active="tab.active" ui-sref="{{tab.route}}" disable="tab.disabled"><span class="full-width-height" ui-view="{{tab.route}}"><div class="padding"><img src="assets/images/ajax-loader.gif"> Loading...</div></span></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/areas/driver/views/driver-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="drivers" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-row full-width visible-sm visible-xs"><div class="flex-sm-percent-60 flex-xs-percent-60 flex-grow visible-xs visible-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search..." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.userTokenChanged()" on-tag-removed="vm.userTokenChanged()"></tags-input></div></div><div class="flex-percent-10 visible-xs visible-sm padding-left-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.filteredDrivers.length" toggle-advanced-search="vm.toggleShowSearchOptions()" align-right="true" search-tray-displayed="vm.showAdvancedSearch"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm" ng-if="!vm.showAdvancedSearch"><a ui-sref="driver-add" class="margin-left-md visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters filter-count="vm.filterCount" record-count="vm.filteredDrivers.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div><div class="flex-percent-80 flex-xs-percent-100 flex-sm-percent-100"><div class="display-flex flex-row hidden-xs hidden-sm"><div class="flex-width-300 flex-grow max-width-px-400 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-right-sm override-xs-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search..." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.driverTokenChanged(\'driverSearchInput\')" on-tag-removed="vm.driverTokenChanged(\'driverSearchInput\')"></tags-input><div class="inline-block text-danger" ng-show="vm.filterMessage != \'\'" ng-bind-html="vm.filterMessage"></div></div></div><div class="flex-width-300 flex-grow max-width-px-400 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div id="location-search-container" class="field-wrapper"><select data-placeholder-text-multiple="\'Filter by location(s)\'" class="form-control" name="locationFilter" id="locationFilter" multiple="" chosen="{width: \'100%\'}" ng-model="vm.filters.filterByLocations" max-shown-results="100" ng-options="l.id as l.displayText for l in vm.locations" ng-change="vm.driverTokenChanged(\'driverFilterByLocation\')"><option value=""></option></select></div></div></div><div class="flex-width-300 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm field-wrapper override-xs-padding-none"><label for="hasPhotoFilter">PHOTO</label><select class="form-control" selectlabel="" name="hasPhotoFilter" ng-model="vm.filters.hasPhoto" ng-change="vm.driverTokenChanged(\'driverFilterByPhoto\')"><option value="">With and without photo</option><option value="true">With Photos</option><option value="false">Without Photos</option></select></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm field-wrapper override-xs-padding-none"><label for="statusFilter">STATUS</label><select class="form-control" name="statusFilter" ng-model="vm.filters.activeStatus" selectlabel="" ng-change="vm.driverTokenChanged()"><option value="true">Active</option><option value="false">Inactive</option><option value="all">All</option></select></div></div></div></div><div class="flex-percent-20 text-right pad-left-15 override-xs-side-padding-none flex-xs-percent-100 override-xs-margin-top-md override-xs-text-left hidden-sm hidden-xs"><a ui-sref="driver-add" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass"><span class="hidden-xs">+</span> NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="driver-table-wrapper"><table class="table table-hover searchable-list table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll="vm.searchDrivers()" infinite-scroll-container="\'#driver-table-wrapper\'" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore" infinite-scroll-distance="1"><thead><tr><th class="user-profile-pic" data-sort-ignore="true">Photo</th><th class="visible-xs"><span class="padding-left-sm">Driver Info</span></th><th data-toggle="true" data-type="alpha" ng-click="vm.sortClicked(vm.sorting.driver)" class="cursor-pointer hidden-xs">Driver <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.driver ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.name)" class="cursor-pointer hidden-xs">Name <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.name ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.company)" class="cursor-pointer hidden-xs">Company <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.company ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-if="vm.isOnlyDealerAdmin === false" ng-click="vm.sortClicked(vm.sorting.dedicated)" class="cursor-pointer hidden-xs">Dedicated <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.dedicated ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-if="vm.isOnlyDealerAdmin === false" ng-click="vm.sortClicked(vm.sorting.vetted)" class="cursor-pointer hidden-xs">Vetted <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.vetted ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.disabled)" class="cursor-pointer hidden-xs">Disabled <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.disabled ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th></tr></thead><tbody><tr ng-repeat="data in vm.filteredDrivers | limitTo: vm.displayLimit track by (data.id + $index)" class="list-name" ng-click="vm.goToEditDriver(data.id)"><td class="user-profile-pic clip-overflow"><img class="img-circle" ng-src="{{ ::data.profilePicture }}"></td><td><div class="visible-xs"><b>Driver ID</b>: {{ ::data.id }}<br><b>Driver Name</b>: {{ ::data.name }}<div class="phone-number" ng-if="data.mobilePhone"><i class="fa fa-mobile padding-right-xs"></i>{{ ::data.mobilePhone|tel }}</div><div class="phone-number" ng-if="data.email"><i class="fa fa-envelope padding-right-xs"></i>{{ ::data.email }}</div><b>Company</b>: {{ ::data.companyName }}</div><div class="user-name hidden-xs">{{ ::data.id }} <span ng-if="data.mobilePhone"><br><i class="fa fa-mobile padding-right-xs"></i>{{ ::data.mobilePhone|tel }}</span> <span class="phone-number" ng-if="data.email"><br><i class="fa fa-envelope apdding-right-xs"></i>{{ ::data.email }}</span></div></td><td class="user-name hidden-xs">{{ ::data.name }}</td><td class="user-name hidden-xs">{{ ::data.companyName }}</td><td ng-if="vm.isOnlyDealerAdmin === false" class="user-name hidden-xs"><span class="fa fa-check" ng-if="data.isDedicated"></span></td><td ng-if="vm.isOnlyDealerAdmin === false" class="user-name hidden-xs"><span class="fa fa-check" ng-if="data.isDnsVetted"></span></td><td class="user-name hidden-xs"><span class="fa fa-check" ng-if="data.isDisabled"></span></td></tr></tbody></table><rc-list-standardized-footer record-count="vm.filteredDrivers.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore"></rc-list-standardized-footer></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search..." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.driverTokenChanged(\'driverSearchInput\')" on-tag-removed="vm.driverTokenChanged(\'driverSearchInput\')"></tags-input><div class="inline-block text-danger" ng-show="vm.filterMessage != \'\'" ng-bind-html="vm.filterMessage"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div id="location-search-container" class="field-wrapper"><select data-placeholder-text-multiple="\'Filter by location(s)\'" class="form-control" name="locationFilter" id="locationFilter" multiple="" chosen="{width: \'100%\'}" ng-model="vm.filters.filterByLocations" max-shown-results="100" ng-options="l.id as l.displayText for l in vm.locations" ng-change="vm.driverTokenChanged(\'driverFilterByLocation\')"><option value=""></option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top-md override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="hasPhotoFilter">PHOTO</label><select class="form-control" selectlabel="" name="hasPhotoFilter" ng-model="vm.filters.hasPhoto" ng-change="vm.driverTokenChanged(\'driverFilterByPhoto\')"><option value="">With and without photo</option><option value="true">With Photos</option><option value="false">Without Photos</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="statusFilter">STATUS</label><select class="form-control" name="statusFilter" ng-model="vm.filters.activeStatus" selectlabel="" ng-change="vm.driverTokenChanged()"><option value="true">Active</option><option value="false">Inactive</option><option value="all">All</option></select></div></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/driver/views/driver-tab-certifications.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>Driver Permissions</h3><p>Select the trips below this driver will be expected to execute. This driver can only be assigned or receive offers for the items that are selected.</p><hr><form role="form" name="DriverCertificationEditForm" class="form" ng-submit="DriverCertificationEditForm.$valid && vm.updateDriverCertifications()" novalidate=""><div class="text-danger validation" ng-if="!vm.certifications.length"><p>This driver is not affiliated with any locations.</p><p>Please go to the locations tab to add locations before assigning permissions.</p></div><div class="display-flex content-center padding-bottom-md" ng-repeat="certification in vm.certifications"><label class="display-flex flex-percent-100 margin-none padding-bottom-md"><span class="cursor-pointer padding-left-md hover-underline display-flex flex-percent-30 flex-xs-percent-60 flex-sm-percent-50" uib-popover="Toggle the {{ certifcation.name }} permission" popover-trigger="outsideClick"><span class="full-width text-right padding-right-md">{{ certification.name }}</span></span> <input type="checkbox" class="inline margin-none" id="cert_{{ certification.id }}" name="cert_{{ certification.name }}" ng-model="certification.isSelected"></label></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row flex-xs-column full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-100"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-100"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="user-list">Close</button> <button type="button" ng-click="vm.updateDriverCertifications()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.isLoading" ng-disabled="vm.fieldsDisabled || DriverCertificationEditForm.$invalid">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/driver/views/driver-tab-general.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><div ng-if="vm.driverAdded === true"><h3>Driver Has Been Created!</h3><p>The new driver has been created. Follow the steps below and the tabs above to complete the setup:<br><ol class="user-added"><li>Security - Select the security tab above to set the driver\'s password.</li><li>Locations - Select the locations tab above to choose which locations the driver receive/execute trips for.</li><li>Settings - Select the Settings tab to set additional items.</li></ol></p><hr></div><div ng-if="vm.driverAdded !== true"><h3>Driver Information</h3><p>Complete the fields provided to add the Driver. Most fields are required.</p><hr></div><form role="form" name="DriverEditForm" class="form" ng-submit="DriverEditForm.$valid && vm.updateDriver()" novalidate="" prevalidate-form=""><div class="form-group"><div class="col-sm-3">&nbsp;</div><div class="col-sm-6"><div class="row"><div class="col-sm-8 text-center"><div class="profilePicCropArea ng-hide" ng-show="vm.profilePic.profileImageUpload"><ui-cropper image="vm.profilePic.profileImageUpload" result-image="vm.profilePic.profileImage"></ui-cropper></div><div class="ng-hide" ng-show="!vm.profilePic.profileImageUpload"><img ng-src="{{ vm.currentDriver.profilePicture }}"></div></div></div><div class="row padding-md"><div class="col-sm-6 col-sm-offset-1"><center><button type="button" class="form-control btn-default btn-150" ng-click="vm.clickFileInput()">SELECT IMAGE</button> <input type="file" id="fileInput" name="fileInput" file-input="vm.profilePic.profileImageUpload" ng-hide="true"></center></div></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The driver\'s login ID" popover-trigger="outsideClick">Username</span></label><div class="col-sm-4 static-text">{{ vm.currentDriver.id }}</div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver\'s first name." popover-trigger="outsideClick">First Name</span></label><div class="col-sm-4"><input type="text" id="first_name" name="first_name" ng-model="vm.currentDriver.firstName" required="" class="form-control" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver\'s last name." popover-trigger="outsideClick">Last Name</span></label><div class="col-sm-4"><input type="text" id="last_name" name="last_name" ng-model="vm.currentDriver.lastName" class="form-control" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver\'s email address." popover-trigger="outsideClick">Email Address</span></label><div class="col-sm-4"><input type="text" id="email_address" name="email_address" ng-model="vm.currentDriver.email" class="form-control" required="" validation="email:alt=Must be a valid email address."></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver\'s mobile phone number." popover-trigger="outsideClick">Mobile Phone</span></label><div class="col-sm-4"><input type="text" id="mobile_phone" name="mobile_phone" ng-model="vm.currentDriver.mobilePhone" required="" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom: vm.validation.phoneNumberRequired(vm.currentDriver.mobilePhone):alt=*"></div></div><div class="form-group" ng-if="vm.showMessageDriver"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Contact the driver via Zendesk." popover-trigger="outsideClick">Message Driver</span></label><div class="col-sm-4 text-right"><textarea rows="4" class="full-width form-control resize-none" ng-model="vm.message" ng-change="vm.clearSent()" placeholder="Enter the message you would like to send to the driver."></textarea><br><span class="text-danger" ng-show="vm.messageSent">{{ vm.messageStatus }}</span></div></div><div class="form-group" ng-if="vm.showMessageDriver"><label class="col-sm-3 control-label"></label><div class="col-sm-4 text-right"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-disabled="vm.message.length < 1 || vm.sendingMessage || vm.messageSent" ng-click="vm.sendMessage()">Send</button></div></div><div class="form-group row" ng-if="!vm.isOnlyDealerAdmin"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Hide pay information for this driver in the driver app." popover-trigger="outsideClick">Hide Pay Information</span></label><div class="col-sm-4"><switch id="suppress_pay" name="suppress_pay" ng-model="vm.currentDriver.suppressPay" class="green"></switch></div></div><div class="form-group row" ng-if="!vm.isOnlyDealerAdmin"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="A value that will be added/subtracted from the base hourly pay for the Driver." popover-trigger="outsideClick">Hourly Pay Modifier</span></label><div class="col-sm-2"><input type="text" id="driver_mod" min="0.01" step=".01" name="driverPayModifier" ng-model="vm.currentDriver.payModifierPerHour" class="form-control text-uppercase" placeholder="AMOUNT" validation="numeric_signed"></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row flex-xs-column full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-100"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-100"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="driver-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.updateDriver()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="DriverEditForm.$invalid">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/driver/views/driver-tab-locations.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><form role="form" name="DriverEditForm" class="form" ng-submit="DriverEditForm.$valid && vm.updateDriver()" novalidate=""><div ng-if="!vm.isOnlyDealerAdmin"><h3>Driver Company</h3><p>Company that this driver is affiliated with</p><hr><div class="form-group margin-bottom-none"><div class="col-sm-3"><ui-select search-enabled="false" ng-model="vm.currentDriver.companyId" ng-change="vm.driverCompanyChanged()"><ui-select-match placeholder="Select a company in the list...">{{ $select.selected.value.name }}</ui-select-match><ui-select-choices repeat="company.value.id as (key, company) in vm.companies"><div><span ng-bind-html="company.value.name"></span></div></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2 col-xs-4 padding-top-switch"><label for="is_dedicated" class="control-label padding-top-sm"><span class="cursor-pointer hover-underline" uib-popover="When enabled, the driver will only receive offers or be assigned trips from the locations specified below. When disabled, the driver will receive offers from locations within their service area." popover-trigger="outsideClick">Dedicated</span></label></div><div class="col-sm-3 col-xs-3 padding-top-switch"><switch id="is_dedicated" name="is_dedicated" ng-change="vm.dedicatedChanged()" ng-model="vm.currentDriver.isDedicated" disabled="vm.fieldsDisabled || !vm.isNetworkDriver()" class="green small-switch"></switch></div></div><div class="form-group margin-top"><div class="col-sm-2 col-xs-4"><label for="is_vetted" class="control-label padding-top-sm"><span class="cursor-pointer hover-underline" uib-popover="When enabled, the driver will be marked as a DNS Vetted Driver." popover-trigger="outsideClick">Vetted</span></label></div><div class="col-sm-3 col-xs-3"><switch id="is_vetted" name="is_vetted" ng-model="vm.currentDriver.isDnsVetted" disabled="vm.fieldsDisabled || vm.isNetworkDriver()" class="green small-switch"></switch></div></div><div ng-hide="vm.currentDriver.isDedicated" ng-show="!vm.currentDriver.isDedicated"><div class="form-group"><label for="home_location" class="control-label col-sm-2 text-align-left"><span class="cursor-pointer hover-underline" uib-popover="The base location for the driver" popover-trigger="outsideClick">Home Location</span></label><div class="col-sm-6"><input type="text" id="home_location" name="home_location" ng-disabled="vm.currentDriver.isDedicated || vm.fieldsDisabled" ng-change="vm.homeLocationChanged()" ng-model="vm.currentDriver.serviceArea.serviceAddress" class="form-control better-placeholder" details="vm.places" here-places="" options="vm.autoCompleteOptions" handle-selected="vm.homeLocationUpdated(formattedAddress)" allow-create-new="false"></div></div><div class="form-group"><label for="home_location" class="control-label col-sm-2 text-align-left"><span class="cursor-pointer hover-underline" uib-popover="The radius (from the users home location) to use when fetching dealers in range.">Service Area (mi)</span></label><div class="col-sm-6"><rzslider class="rc-slider" rz-slider-model="vm.serviceAreaMiles" rz-slider-options="vm.sliderOptions"></rzslider></div></div><div class="driver-locations-map" id="map-container"><div id="public-map" class="map-fullHeight position-relative" map-resize=""><div id="map" class="full-width display-contents height-px-400" driver-tracking="" fill-height="" options="vm.mapOptions" map-loaded="vm.onMapReady"></div></div></div><div class="form-group"><div class="col-sm-12"><div class="table-responsive overflow-visible"><table class="table table-hover"><thead><tr><th data-toggle="true" data-type="alpha"><span class="cursor-pointer hover-underline" popover-placement="right" uib-popover="The dealerships this driver is associated to." popover-trigger="outsideClick">Selected Location(s)</span></th><th>Blocked By Driver</th><th>Blocked By Location</th><th>Preferred By Location</th></tr></thead><tbody><tr ng-repeat="location in vm.currentDriver.serviceArea.dealers" class="list-name"><td class="location-name" title="{{location.oemDealerId}}">{{location.name}} ({{location.city}})</td><td class="driver-name"><switch id="IsDealerBlocked-{{$index}}" name="IsDealerBlocked-{{$index}}" ng-model="location.isBlocked" ng-change="vm.dealerBlockedToggleChanged(location)" class="green"></switch></td><td class="driver-name"><switch id="isDriverBlocked-{{$index}}" name="isDriverBlocked-{{$index}}" ng-model="location.isDriverBlocked" ng-change="vm.driverBlockedToggleChanged(location)" class="green"></switch></td><td class="driver-name"><switch id="isPreferred-{{$index}}" name="isPreferred-{{$index}}" ng-model="location.isDriverPreferred" ng-change="vm.driverPreferredToggleChanged(location)" class="green"></switch></td></tr></tbody></table></div></div></div></div></div><div class="margin-top-30" ng-if="vm.currentDriver.isDedicated"><div><h3>Driver Dealers</h3><p>Grant driver access to one or more dealer(s).</p><hr></div><div class="form-group" ng-if="vm.resolvedLocations.length > 0"><div class="col-sm-10"><ui-select ng-model="vm.selectedLocation" on-select="vm.locationSelected($item, $model)" ng-disabled="vm.fieldsDisabled"><ui-select-match placeholder="Select or search a location in the list...">{{ $select.selected.name }}</ui-select-match><ui-select-choices refresh="vm.locationsFilter($select.search)" refresh-delay="250" repeat="location in vm.supportedLocations | limitTo: vm.locationDisplayLimit track by location.id"><div><span ui-select-options-title="<b>RC:</b> {{location.id}}<br /><b>OEM:</b> {{location.oemDealerId}}<br /><b>PRG:</b>{{location.adminProgramName}}<br /><b>STATUS:</b> {{location.statusText}}<br /><b>ADDR:</b><br/>{{location.address}}<br />{{location.city}}, {{location.state}}" ng-bind-html="location.locationHtml | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-10"><div class="table-responsive overflow-visible"><table class="table table-hover"><thead><tr><th data-toggle="true" data-type="alpha"><span class="cursor-pointer hover-underline" popover-placement="right" uib-popover="The dealerships this driver is associated to." popover-trigger="outsideClick">Selected Location(s)</span></th><th class="col-sm-1 text-center">Remove</th></tr></thead><tbody><tr ng-repeat="location in vm.selectedLocations" class="list-name"><td class="location-name ellipsis-overflow max-width-px-200" title="{{location.oemDealerId}}">{{location.name}} ({{location.city}})</td><td class="text-center" ng-click="vm.removeLocation(location.id)"><span class="fa fa-times-circle"></span></td></tr></tbody></table></div></div></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row flex-xs-column full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-100"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-100"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="driver-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.updateDriver()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/driver/views/driver-tab-security.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>Driver Security</h3><p>Driver password.</p><hr><form role="form" name="DriverEditForm" class="form validation-relative" novalidate=""><input class="ng-hide" type="text" id="username" name="username" autocomplete="username" value="{{vm.currentDriver.userName}}"><div class="row"><div class="col-sm-8"><div class="form-group"><label class="col-sm-5 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver\'s new password." popover-trigger="outsideClick">Change Password</span></label><div class="col-sm-6"><input type="password" id="user_password" name="user_password" ng-model="vm.password" autocomplete="new-password" class="form-control" validation="required|remote:vm.passwordRemoteValidation()" friendly-name="Login Password"></div></div><div class="form-group"><label class="col-sm-5 control-label"><span class="cursor-pointer hover-underline" uib-popover="Re-enter to confirm the driver\'s new password." popover-trigger="outsideClick">Confirm Password</span></label><div class="col-sm-6"><input type="password" id="user_passwordconfirm" name="user_passwordconfirm" autocomplete="new-password" ng-model="vm.passwordConfirm" class="form-control" validation="match:vm.password:alt=Must match Login Password"></div></div><div class="form-group"><label class="col-sm-5"></label><div class="col-sm-6"><input type="checkbox" id="user_passwordChangeRequired" name="user_passwordChangeRequired" ng-model="vm.requiresPasswordChange"> <label for="user_passwordChangeRequired" class="control-label"><span class="cursor-pointer hover-underline">Force Password Change</span></label> &nbsp;&nbsp; <button type="button" ladda="vm.changingPassword && isDataLoading" class="btn btn-default" ng-class="config.styleClass" ng-click="DriverEditForm.$valid && vm.updatePassword()" ng-disabled="DriverEditForm.$invalid">Change Password</button></div></div></div><div class="col-sm-4 col-xs-12"><b>Password Requirements:</b><ul><li>Minimum 8 characters</li><li>One uppercase character</li><li>One lowercase character</li><li>One numeric character</li></ul></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row flex-xs-column full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-100"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-100"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="driver-list">Close</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/driver/views/driver-tab-settings.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>Driver Settings</h3><p>Specific driver settings.</p><hr><form role="form" name="DriverEditForm" class="form" ng-submit="DriverEditForm.$valid && vm.updateDriver()" novalidate=""><div class="display-flex content-center padding-left-md padding-bottom-md"><label class="display-flex flex-percent-100 margin-none padding-bottom-md"><span class="cursor-pointer hover-underline padding-left-md display-flex flex-percent-30 flex-xs-percent-60 flex-sm-percent-50" uib-popover="Disable the driver\'s account to prevent them from logging in." popover-trigger="outsideClick"><span class="full-width text-right padding-right-md">Account Disabled</span></span> <input type="checkbox" id="account_disabled" name="account_disabled" class="inline margin-none" ng-model="vm.currentDriver.isDisabled"></label></div><div class="display-flex content-center padding-left-md padding-bottom-md"><label class="display-flex flex-percent-100 margin-none padding-bottom-md"><span class="cursor-pointer hover-underline padding-left-md display-flex flex-percent-30 flex-xs-percent-60 flex-sm-percent-50" uib-popover="Allows a driver to accept a trip that conflicts with another trip." popover-trigger="outsideClick"><span class="full-width text-right padding-right-md">Accept Conflicting Trips</span></span> <input type="checkbox" id="accept_conflicting" name="accept_conflicting" class="inline margin-none" ng-model="vm.currentDriver.canAcceptConflict"></label></div><div class="display-flex content-center padding-left-md padding-bottom-md"><label class="display-flex flex-percent-100 margin-none"><span class="cursor-pointer hover-underline padding-left-md display-flex flex-percent-30 flex-xs-percent-60 flex-sm-percent-50" uib-popover="Prevent notifications from being sent for an offer that has a conflict with another trip." popover-trigger="outsideClick"><span class="full-width text-right padding-right-md">Suppress Notifications for Conflicting Trips</span></span> <input type="checkbox" id="suppress_conflicting" name="suppress_conflicting" class="inline margin-none" ng-model="vm.currentDriver.suppressConflictingTripNotifications"></label></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row flex-xs-column full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-100"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-100"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="driver-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.updateDriver()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-add-batch.view.html','<div class="form-horizontal"><h3>Enrollment Code</h3><p>Complete the fields provided to add a new enrollment code. Most fields are required.</p><hr><form role="form" name="EnrollmentAddBatchForm" class="form" ng-submit="EnrollmentAddBatchForm.$valid && vm.addCode()" novalidate=""><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The enrollment program workflow that will be used." popover-trigger="outsideClick">Program Name</span></label><div class="col-sm-4"><select class="form-control" name="programName" ng-model="vm.form.configId" ng-options="config.id as config.programName for config in vm.configList" validation="required|in:{{vm.acceptableConfigs}}:alt=Please pick a value from the list"></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The file with the dealer names and codes you\\\'d like to associate to them." popover-trigger="outsideClick">File</span></label><div class="col-sm-4"><input type="file" id="csvFile" name="csvFile" ng-model="vm.csv.content" class="form-control" file-input="vm.csv.content" file-type="csv" accept=".csv" ng-disabled="vm.form.configId == null" validation="required:alt=Please select a file to upload"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer">Import Preview</span></label><div class="col-sm-4" ng-if="vm.form.codes.length > 0"><div class="row"><div class="col-sm-6"><u><b>Dealer Name</b></u></div><div class="col-sm-6"><u><b>OEM Dealer Id</b></u></div></div><div class="row" ng-repeat="code in vm.form.codes"><div class="col-sm-6">{{ code.dealerName }}</div><div class="col-sm-6">{{ code.oemDealerId }}</div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.form.codes.length == 0">Add</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="enrollment-list">Close</button></div></form></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-add-single.view.html','<div class="form-horizontal"><h3>Enrollment Code</h3><p>Complete the fields provided to add a new enrollment code. Most fields are required.</p><hr><form role="form" name="EnrollmentAddSingleForm" class="form" ng-submit="EnrollmentAddSingleForm.$valid && vm.addCode()" novalidate=""><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The Dealer that will be assigned this code." popover-trigger="outsideClick">Dealer name</span></label><div class="col-sm-4"><input type="text" name="dealerName" class="form-control" ng-model="vm.form.dealerName" validation="required|remote:vm.validation.validateEnrollment()"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The Dealer\'s OEM Dealer Id." popover-trigger="outsideClick">OEM Dealer Id</span></label><div class="col-sm-4"><input type="text" name="code" class="form-control" ng-model="vm.form.oemDealerId" validation="required|remote:vm.validation.validateEnrollment()"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The email address that will receive an invitation to enroll email." popover-trigger="outsideClick">Invite Email Address</span></label><div class="col-sm-4"><input type="text" name="inviteEmail" class="form-control" ng-model="vm.form.inviteEmail" validation="required|email"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The enrollment program workflow that will be used." popover-trigger="outsideClick">Program Name</span></label><div class="col-sm-4"><select class="form-control" name="programName" ng-model="vm.form.configId" ng-options="config.id as config.programName for config in vm.configList" validation="required|in:{{vm.acceptableConfigs}}:alt=Please pick a value from the list"></select></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="EnrollmentAddSingleForm.$invalid">Add</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="enrollment-list">Close</button></div></form></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-add.view.html','<div class="modal-header padding-t-b-0"><div class="row"><div class="col-xs-12 col-sm-7"><h2 class="modal-title ellipsis-overflow">Add New Enrollment</h2></div></div></div><div aside-parent="vm.childScopeForm"><uib-tabset><uib-tab ng-repeat="tab in vm.tabs" heading="{{tab.title}}" active="tab.active" ui-sref="{{tab.route}}" disable="tab.disabled"><span ui-view="{{tab.route}}"><div>Loading...</div></span></uib-tab></uib-tabset></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-advisor.view.html','<div class="col-sm-12"><label class="step-header">BDC & Advisors</label><br>{{ vm.config.enrollmentSteps[\'BDC & Advisors\'].content }}<hr></div><div class="col-sm-12 alert alert-danger" ng-if="vm.advisor.missingMessage.length > 0">{{ vm.advisor.missingMessage }}</div><div class="col-sm-12" ng-repeat="advisor in vm.form.advisors track by advisor.index"><div class="row no-gutter"><div class="col-sm-11"><div class="col-sm-3"><label for="advisorTitle"><span class="cursor-pointer hover-underline" uib-popover="Enter the company title of an advisor." popover-placement="right" popover-trigger="outsideClick">Company Title</span></label><select class="form-control" id="advisorTitle{{advisor.index}}" name="advisorTitle{{advisor.index}}" ng-model="advisor.userTitle" ng-options="title for title in vm.titles" validation="required|custom:vm.validation.employeeTitle(advisor.userTitle)" validation-error-to="#advisor-error-{{advisor.index}}"></select></div><div class="col-sm-2"><label for="advisorFirstName"><span class="cursor-pointer hover-underline" uib-popover="Enter the first name of an advisor." popover-placement="right" popover-trigger="outsideClick">First Name</span></label> <input type="text" class="form-control" id="advisorFirstName{{advisor.index}}" name="advisorFirstName{{advisor.index}}" ng-model="advisor.firstName" validation="required" validation-error-to="#advisor-error-{{advisor.index}}"></div><div class="col-sm-2"><label for="advisorLastName"><span class="cursor-pointer hover-underline" uib-popover="Enter the the advisor\'s last name." popover-placement="right" popover-trigger="outsideClick">Last Name</span></label> <input type="text" class="form-control" id="advisorLastName{{advisor.index}}" name="advisorLastName{{advisor.index}}" ng-model="advisor.lastName" validation="required" validation-error-to="#advisor-error-{{advisor.index}}"></div><div class="col-sm-2"><label for="advisorOfficePhone"><span class="cursor-pointer hover-underline" uib-popover="What is the advisor\'s office phone number?" popover-placement="right" popover-trigger="outsideClick">Office Phone</span></label> <input type="text" class="form-control" id="advisorOfficePhone{{advisor.index}}" name="advisorOfficePhone{{advisor.index}}" ng-model="advisor.officePhone" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(advisor.officePhone)" validation-error-to="#advisor-error-{{advisor.index}}"></div><div class="col-sm-3"><label for="advisorEmailAddress"><span class="cursor-pointer hover-underline" uib-popover="What is the advisor\'s email address?" popover-placement="right" popover-trigger="outsideClick">Email Address</span></label> <input type="text" class="form-control" id="advisorEmailAddress{{advisor.index}}" name="advisorEmailAddress{{advisor.index}}" ng-model="advisor.emailAddress" validation="required|email|remote:vm.validation.username(advisor, \'advisor\')" validation-error-to="#advisor-error-{{advisor.index}}"><div ng-if="vm.advisorsForm[\'advisorEmailAddress\' + advisor.index].$processing" class="spinner spinner-absolute pull-left"></div></div></div><div class="col-sm-1 padding-top-lg"><a ng-click="vm.advisor.delete(advisor)">delete</a></div></div><div class="row"><div id="advisor-error-{{advisor.index}}" class="col-sm-12 validation text-danger"></div></div><hr></div><div class="col-sm-12"><a ng-click="vm.advisor.add()">Add More Users</a></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-agreement.view.html','<div class="form-group"><label class="step-header">Agreement</label><br>Review our software licensing agreement, covering the terms of use for the application and use of driver networks (if you are a driver network). Enter the email of the individual that will be signing the agreement. Once the enrollment process is complete, they will receive an email for a link to electronically sign the agreement.<hr></div><div class="form-group vh-h50"><div ng-bind-html="vm.config.softwareLicenseContract"></div><div ng-if="vm.form.dealerDriverSystem != 0" ng-bind-html="vm.config.admDriverNetworkContract"></div><div ng-if="vm.form.dealerDriverSystem != 0" ng-bind-html="vm.config.recruitingContract"></div></div><hr><div class="alert alert-danger" ng-if="vm.agreementForm.missingMessage.length > 0">{{ vm.agreementForm.missingMessage }}</div><div class="form-group no-gutter vertical-align"><div class="col-sm-5"><input type="text" class="form-control" id="contractSignerEmail" name="contractSignerEmail" ng-model="vm.form.contractSignerEmail" placeholder="Email address of signer" validation-error-to="#agreementEmailError" validation="required|email"></div></div><div class="row"><div id="agreementEmailError" class="col-sm-10 validation text-danger"></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-billingcontact.view.html','<div class="col-sm-12"><label class="step-header">Billing Contact</label><br>{{ vm.config.enrollmentSteps[\'Billing Contact\'].content }}<hr></div><div class="col-sm-12"><div class="form-group"><label for="billingContactCheckbox"><input id="billingContactCheckbox" type="checkbox" name="billingContactCheckbox" ng-click="vm.copyProgramChampionForBilling($event)"> Use same info as Program Champion</label></div></div><div class="col-sm-6"><div class="form-group"><label for="billingFirstName"><span class="cursor-pointer hover-underline" uib-popover="Enter the first name of the contact for billing." popover-placement="right" popover-trigger="outsideClick">First Name</span></label> <input type="text" class="form-control" id="billingFirstName" name="billingFirstName" ng-model="vm.form.billingContact.firstName" ng-disabled="vm.isCopyingProgramChampionForBilling" validation="required"></div><div class="form-group"><label for="billingLastName"><span class="cursor-pointer hover-underline" uib-popover="Enter the last name of the contact for billing." popover-placement="right" popover-trigger="outsideClick">Last Name</span></label> <input type="text" class="form-control" id="billingLastName" name="billingLastName" ng-model="vm.form.billingContact.lastName" ng-disabled="vm.isCopyingProgramChampionForBilling" validation="required"></div></div><div class="col-sm-6"><div class="form-group"><label for="billingPhone"><span class="cursor-pointer hover-underline" uib-popover="What is the billing contact\'s phone number?" popover-placement="right" popover-trigger="outsideClick">Contact Phone</span></label> <input type="text" class="form-control" id="billingPhone" name="billingPhone" ng-model="vm.form.billingContact.contactPhone" ng-disabled="vm.isCopyingProgramChampionForBilling" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.form.billingContact.contactPhone)"></div><div class="form-group"><label for="billingEmailAddress"><span class="cursor-pointer hover-underline" uib-popover="What is the billing contact\'s email address?" popover-placement="right" popover-trigger="outsideClick">Email Address</span></label> <input type="text" class="form-control" id="billingEmailAddress" name="billingEmailAddress" ng-model="vm.form.billingContact.emailAddress" ng-disabled="vm.isCopyingProgramChampionForBilling" validation="required|email"><div ng-if="vm.billingContactForm.bililngEmailAddress.$processing" class="spinner spinner-absolute pull-left"></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-champion.view.html','<div class="col-sm-12"><label class="step-header">Program Champion</label><br>{{ vm.config.enrollmentSteps[\'Program Champion\'].content }}<hr></div><div class="col-sm-6"><div class="form-group"><label for="championFirstName"><span class="cursor-pointer hover-underline" uib-popover="Enter the first name of the champion." popover-placement="right" popover-trigger="outsideClick">First Name</span></label> <input type="text" class="form-control" id="championFirstName" name="championFirstName" ng-model="vm.form.champion.firstName" validation="required"></div><div class="form-group"><label for="championLastName"><span class="cursor-pointer hover-underline" uib-popover="Enter the last name of the champion." popover-placement="right" popover-trigger="outsideClick">Last Name</span></label> <input type="text" class="form-control" id="championLastName" name="championLastName" ng-model="vm.form.champion.lastName" validation="required"></div><div class="form-group"><label for="champtionTitle"><span class="cursor-pointer hover-underline" uib-popover="Enter the company title of the champion." popover-placement="right" popover-trigger="outsideClick">Company Title</span></label><select class="form-control" id="championTitle" name="championTitle" ng-model="vm.form.champion.userTitle" ng-options="title for title in vm.titles" validation="required|custom:vm.validation.employeeTitle(vm.form.champion.userTitle)"></select></div></div><div class="col-sm-6"><div class="form-group"><label for="championOfficePhone"><span class="cursor-pointer hover-underline" uib-popover="What is the champion\'s office phone number?" popover-placement="right" popover-trigger="outsideClick">Office Phone</span></label> <input type="text" class="form-control" id="championOfficePhone" name="championOfficePhone" ng-model="vm.form.champion.officePhone" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.form.champion.officePhone)"></div><div class="form-group"><label for="championMobilePhone"><span class="cursor-pointer hover-underline" uib-popover="What is the champion\'s mobile phone number?" popover-placement="right" popover-trigger="outsideClick">Mobile Phone</span></label> <input type="text" class="form-control" id="championMobilePhone" name="championMobilePhone" ng-model="vm.form.champion.mobilePhone" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.form.champion.mobilePhone)"></div><div class="form-group"><label for="championEmailAddress"><span class="cursor-pointer hover-underline" uib-popover="What is the champion\'s email address?" popover-placement="right" popover-trigger="outsideClick">Email Address</span></label> <input type="text" class="form-control" id="championEmailAddress" name="championEmailAddress" ng-model="vm.form.champion.emailAddress" validation="required|email|remote:vm.validation.username(vm.form.champion, \'champion\'):alt=User already exists"><div ng-if="vm.programChampionForm.championEmailAddress.$processing" class="spinner spinner-absolute pull-left"></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-contract-thankyou.view.html','<div class="middle-box middle-box-wide forgotpasswordscreen"><div><div class="form form-horizontal newuser-box" ng-submit="vm.confirm()" style="margin-top: 20px; border: 1px solid #e7e7e7;"><h2 class="text-center">{{ vm.config.title }}</h2><p class="text-center">{{ vm.config.body }}</p></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-contract.view.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-10 col-xs-offset-1"><div class="row form-group"><h3>{{ vm.config.programName }} Agreement</h3><div class="col-xs-8 col-sm-10 padding-left-none">Please read the agreement below, sign and provide your full name. Once you click accept, we will email you a copy of the fully executed agreement. If you have any questions, please call us at {{ vm.config.programPhoneNumber }}</div><div class="col-xs-4 col-sm-2 padding-right-none pull-right"><input type="button" class="form-control btn btn-default" value="Print" ng-click="vm.print(\'contract-agreement\')"></div></div><div class="form-group row"><div class="col-xs-12 vh-h60 contract-area" id="contract-agreement"><div ng-bind-html="vm.config.softwareLicenseContract"></div><div ng-if="vm.config.showNetwork" ng-bind-html="vm.config.admDriverNetworkContract"></div><div ng-if="vm.config.showNetwork" ng-bind-html="vm.config.recruitingContract"></div></div></div><form ng-submit="vm.signForm()"><div class="form-group row text-center"><div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 col-sm-offset-1 col-md-offset-2 col-lg-offset-3"><div class="signature-container"><signature-pad accept="accept" clear="clear" height="200" width="1100"></signature-pad><div class="col-xs-12 text-center">Sign here</div></div><div class="row"><div class="col-xs-6 padding-top-sm padding-right-none"><input class="form-control" type="text" name="signerName" placeholder="Full Name" ng-model="vm.contract.fullName"></div><div class="col-xs-6 padding-top-sm padding-left-none"><input class="form-control" type="text" name="signerTitle" placeholder="Title in Company" ng-model="vm.contract.companyTitle"></div><div class="col-xs-12" ng-if="vm.message.length > 0">{{ vm.message }}</div></div></div></div><div class="row padding-top-md"><div class="col-xs-6 col-sm-4 col-md-2 col-lg-1 col-sm-offset-2 col-md-offset-3 col-lg-offset-4"><button class="btn btn-primary btn-full-width" ladda="vm.isLoading" type="submit" ng-class="vm.config.styleClass">Accept</button></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-3"><input class="form-control hidden-md hidden-lg" type="button" ng-click="clear()" value="Clear"> <input class="form-control hidden-xs hidden-sm" type="button" ng-click="clear()" value="Clear Signature"></div></div></form></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-driver.view.html','<div class="col-sm-12"><label class="step-header">{{ vm.config.program === vm.programType.SERVICE ? \'Drivers\' : \'Sales Team\' }}</label><br>{{ vm.config.enrollmentSteps[\'Drivers\'].content }}<div class="padding-top-md">{{ vm.config.program === vm.programType.SERVICE ? \'Drivers\' : \'Sales Team members\' }} are required to have an Apple or Android device.</div><div><img src="{{ vm.systemVariables.appleStoreImage }}"><img src="{{ vm.systemVariables.googleStoreImage }}" class="margin-left-md"></div><hr></div><div class="col-sm-12" ng-if="vm.config.program == vm.programType.SERVICE && vm.config.showDealerNetworkOptions && !vm.config.suppressDriverOptions"><div><label><input type="radio" ng-model="vm.form.dealerDriverSystem" value="0"> I am using my staff only</label><div style="padding-left: 15px">Choose this option if your current staff will be responsible for service pick up and deliver. This option will not incur individual pick up and delivery charges.</div></div><div class="padding-top-md"><label><input type="radio" ng-model="vm.form.dealerDriverSystem" value="1"> I am using a {{ vm.config.programName }} network</label><div style="padding-left: 15px">Choose this option if you will use our drivers for an additional fee for each pick up and delivery.</div></div><div class="padding-top-md"><label><input type="radio" ng-model="vm.form.dealerDriverSystem" value="2"> I am using both</label><div style="padding-left: 15px">Choose this option if you will use your drivers as the first option, and then our network when your drivers are not available.</div></div><hr></div><div class="col-sm-12 alert alert-danger" ng-if="vm.driver.missingMessage.length > 0">{{ vm.driver.missingMessage }}</div><div class="col-sm-12" ng-if="vm.form.dealerDriverSystem !== \'1\' && vm.form.dealerDriverSystem !== \'\'" ng-repeat="driver in vm.form.drivers track by driver.index"><div class="row no-gutter"><div class="col-sm-11"><div class="col-sm-4"><label for="driverFirstName"><span class="cursor-pointer hover-underline" uib-popover="Enter the first name of adriver." popover-placement="right" popover-trigger="outsideClick">First Name</span></label> <input type="text" class="form-control" id="driverFirstName{{driver.index}}" name="driverFirstName{{driver.index}}" ng-model="driver.firstName" validation="required" validation-error-to="#driver-error-{{driver.index}}"></div><div class="col-sm-4"><label for="driverLastName"><span class="cursor-pointer hover-underline" uib-popover="Enter the the driver\'s last name." popover-placement="right" popover-trigger="outsideClick">Last Name</span></label> <input type="text" class="form-control" id="driverLastName{{driver.index}}" name="driverLastName{{driver.index}}" ng-model="driver.lastName" validation="required" validation-error-to="#driver-error-{{driver.index}}"></div><div class="col-sm-4"><label for="driverMobilePhone"><span class="cursor-pointer hover-underline" uib-popover="What is the driver\'s mobile phone number?" popover-placement="right" popover-trigger="outsideClick">Mobile Phone</span></label> <input type="text" class="form-control" id="driverMobilePhone{{driver.index}}" name="driverMobilePhone{{driver.index}}" ng-model="driver.mobilePhone" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|remote:vm.validation.driver(driver):alt=Please a use real and unique mobile number for each driver as credentials and logins will be tied to this field." validation-error-to="#driver-error-{{driver.index}}"><div ng-if="vm.driversForm[\'driverMobilePhone\' + driver.index].$processing" class="spinner spinner-absolute pull-left"></div></div></div><div class="col-sm-1 padding-top-lg"><a ng-click="vm.driver.delete(driver)">delete</a></div></div><div class="row"><div id="driver-error-{{driver.index}}" class="col-sm-12 validation text-danger"></div></div><hr></div><div class="col-sm-12" ng-if="vm.form.dealerDriverSystem !== \'1\' && vm.form.dealerDriverSystem !== \'\'"><a ng-click="vm.driver.add()">Add More Drivers</a></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-edit.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title ellipsis-overflow">Edit Enrollment: {{ vm.currentCode.dealerName }}</h2></div><div class="modal-body" aside-parent="vm.childScopeForm"><h3>Details</h3><p></p><hr><form role="form" name="EnrollmentEditForm" class="form" ng-submit="EnrollmentEditForm.$valid && vm.updateCode()" novalidate=""><div class="form-group row"><label class="col-sm-3 control-label">OEM Dealer Id</label><div class="col-sm-4">{{ vm.currentCode.oemDealerId }}</div></div><div class="form-group row"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The email address that will receive an invitation to enroll email." popover-trigger="outsideClick">Invite Email Address</span></label><div class="col-sm-4"><input type="text" name="inviteEmail" class="form-control" ng-model="vm.currentCode.inviteEmail" validation="required|email"></div></div><div class="form-group row"><label class="col-sm-3 control-label">Resend Invitation Email</label><div class="col-sm-4"><switch id="resendInvite" name="resendInvite" ng-model="vm.currentCode.resendInviteEmail" class="green"></switch></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || EnrollmentEditForm.$invalid">Update</button> <button type="button" class="btn btn-default" ng-click="vm.resetFields()">Reset</button> <button type="button" class="btn btn-default" ng-click="$dismiss()" ui-sref="enrollment-list">Close</button></div></form></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-hours.view.html','<div class="col-sm-12"><label class="step-header">Booking Hours</label><br>{{ vm.config.enrollmentSteps[\'Store Hours\'].content }}<hr><div class="col-sm-12 alert alert-danger" ng-if="vm.storeHour.missingMessage.length > 0">{{ vm.storeHour.missingMessage }}</div></div><div class="col-sm-11"><div class="form-group"><div class="row form-group" ng-repeat="day in vm.form.storeHours.hours"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the earliest pick up and lastest drop off for {{ day.title }}, or denote if the dealership is closed." popover-trigger="outsideClick">{{ day.title }}</span></label><div class="col-sm-3"><select class="form-control" id="{{day.title}}From" name="{{day.title}}From" ng-model="day.startTime" ng-options="hour.minutesFromMidnight as hour.ampmHours for hour in vm.storeHour.days" ng-disabled="day.closed" validation-error-to="#errorMessage{{ $index }}" validation="custom:vm.validation.dealerHours(day.startTime, day.startTime, day.endTime, day.closed)"></select></div><div class="col-sm-1 text-center">to</div><div class="col-sm-3"><select class="form-control" id="{{day.title}}To" name="{{day.title}}To" ng-model="day.endTime" ng-options="hour.minutesFromMidnight as hour.ampmHours for hour in vm.storeHour.days" ng-disabled="day.closed" validation-error-to="#errorMessage{{ $index }}" validation="custom:vm.validation.dealerHours(day.endTime, day.startTime, day.endTime, day.closed)"></select></div><div class="col-sm-2"><label class="checkbox-inline"><input type="checkbox" name="closed" ng-model="day.closed" ng-change="vm.closedChanged(day)">Closed</label></div><div class="col-sm-11 col-sm-offset-3"><div id="errorMessage{{ $index }}" class="validation text-danger"></div></div></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-list.view.html','<div id="enrollments" class=""><div class="row"><div class="col-sm-12"><div class="ibox"><div class="ibox-title" resize-class="ibox-content"><div class="row"><div class="col-lg-10 col-md-8 col-sm-10 col-xs-9"><div class="row padding-none"><div class="col-lg-4 col-md-6 col-sm-6 col-xs-12"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search.." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.searchInput" on-tag-added="vm.enrollmentTokenChanged(\'enrollmentSearchInput\')" on-tag-removed="vm.enrollmentTokenChanged(\'enrollmentSearchInput\')"></tags-input></div><div class="col-lg-2 col-md-3 col-sm-3 hidden-xs"><select class="form-control" name="programFilter" ng-model="vm.programInput" ng-options="program for program in vm.programList track by program" ng-change="vm.enrollmentTokenChanged(\'enrollmentProgramInput\')"></select></div><div class="col-lg-2 col-md-3 col-sm-3 hidden-xs"><select class="form-control" name="statusFilter" ng-model="vm.statusInput" ng-options="status.value as status.label for status in vm.statusList" ng-change="vm.enrollmentTokenChanged(\'enrollmentStatusInput\')"></select></div></div></div><div class="col-lg-1 col-md-2 col-xs-l pull-right"><a ui-sref="enrollment-add-single" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass"><span class="hidden-xs">+</span> NEW</a></div></div><div class="row text-danger filtermessage" ng-show="vm.filterMessage != \'\'"><span class="col-md-11" ng-bind-html="vm.filterMessage"></span></div><div class="row padding-top-md"><div class="col-md-12"><button class="btn btn-default btn-xs" ng-class="config.styleClass" ng-click="vm.updateCodes(vm.status.disabled)" ng-disabled="vm.selectedCodes.length == 0">Disable</button> <button class="btn btn-default btn-xs" ng-class="config.styleClass" ng-click="vm.updateCodes(vm.status.active)" ng-disabled="vm.selectedCodes.length == 0">Activate</button> <button class="btn btn-default btn-xs" ng-class="config.styleClass" ng-click="vm.deleteCodes()" ng-disabled="vm.selectedCodes.length == 0">Delete</button></div></div></div><div class="ibox-content"><div class="table-responsive table-borderless"><table class="table footable table-hover searchable-list" infinite-scroll="vm.displayMore()" infinite-scroll-distance="2"><thead><tr><td><input type="checkbox" ng-click="vm.selectAll()"></td><th data-toggle="true">Status</th><th data-toggle="true">Dealer Name</th><th data-toggle="true" data-type="alpha" class="hidden-md-down">OEM Dealer Id</th><th data-toggle="true" class="hidden-md-down">Invite Email</th><th data-toggle="true">Program Name</th><th data-sort-ignore="true" class="text-center">Users <span class="hidden-md-down">Enrolled</span></th><th data-sort-ignore="true" class="text-center">Drivers <span class="hidden-md-down">Enrolled</span></th><th data-toggle="true"><span class="hidden-md-down">Enrollment</span> Completed</th><th data-toggle="true"><span class="hidden-md-down">Agreements</span> Signed</th></tr></thead><tbody><tr ng-repeat="data in vm.visibleCodes | limitTo: vm.displayLimit" class="list-name"><td><input type="checkbox" ng-model="data.checked" ng-change="vm.pushCode(data)"></td><td ui-sref="enrollment-edit({ guid: data.guid })"><span class="label" ng-class="data.statusLabel">{{ data.statusText }}</span></td><td ui-sref="enrollment-edit({guid: data.guid})">{{ data.dealerName }}</td><td ui-sref="enrollment-edit({guid: data.guid})" class="hidden-md-down">{{ data.oemDealerId }}</td><td ui-sref="enrollment-edit({guid: data.guid})" class="hidden-md-down">{{ data.inviteEmail }}</td><td ui-sref="enrollment-edit({guid: data.guid})">{{ data.programName }}</td><td class="text-center"><span ng-if="data.dealerId == null">N/A</span> <span ng-if="data.dealerId != null" class="hover-underline" ui-sref="tab-users({guid: data.guid, locationId: data.dealerId, tripTypeId: 0})">{{ data.enrolledUserCount }} / {{ data.userCount }}</span></td><td class="text-center"><span ng-if="data.dealerId == null">N/A</span> <span ng-if="data.dealerId != null" class="hover-underline" ui-sref="tab-drivers({guid: data.guid, locationId: data.dealerId, tripTypeId: 0})">{{ data.enrolledDriverCount }} / {{ data.driverCount }}</span></td><td>{{ data.enrollmentCompleted | date:\'longDate\' }}</td><td>{{ data.enrollmentContractSigned | date:\'longDate\' }}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-mobile.view.html','<div class="container vh-h100 top-navigation" style="background-color: #eee; overflow: hidden" ui-view=""><nav class="navbar navbar-fixed-top" ng-class="\'navbar-\' + vm.config.styleClass" role="navigation"><div class="col-sm-12"><img ng-src="{{vm.config.logo}}" class="img-responsive center-block"></div></nav><div class="row row-centered" style="height: 100%"><div class="col-sm-12 margin-top-h50"><h4>Oops! This page is not available on a mobile device. Please visit us on your tablet or desktop.</h4></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-store.view.html','<div class="col-sm-12"><label class="step-header">Store Information</label><br>{{ vm.config.enrollmentSteps[\'Store Information\'].content }}<hr></div><div class="col-sm-6"><div class="alert alert-danger" ng-if="vm.cantContinueMessage">{{ vm.cantContinueMessage }}</div><div class="form-group"><label for="address"><span class="cursor-pointer hover-underline" uib-popover="Enter the store\'s address." popover-placement="right" popover-trigger="outsideClick">Address</span></label> <input type="text" id="address" name="address" ng-model="vm.form.storeInformation.address" class="form-control" details="vm.placesObj" validation="required|remote:vm.validation.dealerAddress():alt=A valid address is required" here-places="" fetch-twilio-numbers="" handle-selected="vm.placeUpdated(formattedAddress)" map-fields="{\'mainPhone\':\'phone\', \'servicePhone\': \'phone\'}"><div ng-if="vm.storeInformationForm.address.$processing" class="spinner spinner-absolute pull-left"></div></div><div class="form-group"><label for="dealerName"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealership name that will display to customers." popover-placement="right" popover-trigger="outsideClick">Dealer Display Name</span></label> <input type="text" class="form-control" id="dealerName" name="dealerName" ng-model="vm.form.storeInformation.dealerName" ng-change="vm.storeNameUpdated()" validation="required|remote:vm.validation.dealerName():alt=A valid dealer name is required"><div ng-if="vm.storeInformationForm.dealerName.$processing" class="spinner spinner-absolute pull-left"></div></div><div class="form-group"><label for="legalName"><span class="cursor-pointer hover-underline" uib-popover="Enter the legal name of the dealership. This will be used for internal purposes only." popover-placement="right" popover-trigger="outsideClick">Dealer Legal Name</span></label> <input type="text" class="form-control" id="legalName" name="legalName" ng-model="vm.form.storeInformation.legalName" validation="required"></div><div class="form-group"><label for="entityType"><span class="cursor-pointer hover-underline" uib-popover="Enter the legal entity type of the dealership (i.e. LLC, Inc., etc)." popover-placement="right" popover-trigger="outsideClick">Type of organization</span></label> <input type="text" class="form-control" id="entityType" name="entityType" ng-model="vm.form.storeInformation.entityType" validation="required"></div><div class="form-group"><label for="mainPhone"><span class="cursor-pointer hover-underline" uib-popover="Enter the store\'s main phone number." popover-placement="right" popover-trigger="outsideClick">Main Phone Number</span></label> <input type="text" class="form-control" id="mainPhone" name="mainPhone" ng-model="vm.form.storeInformation.mainPhone" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.form.storeInformation.mainPhone)"></div><div class="form-group"><label for="servicePhone"><span class="cursor-pointer hover-underline" uib-popover="Enter the store\'s service phone number." popover-placement="right" popover-trigger="outsideClick">Service Phone Number</span></label> <input type="text" class="form-control" id="servicePhone" name="servicePhone" ng-model="vm.form.storeInformation.servicePhone" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.form.storeInformation.servicePhone)"></div><div class="form-group"><label for="website"><span class="cursor-pointer hover-underline" uib-popover="Enter the store\'s website address." popover-placement="right" popover-trigger="outsideClick">Web site URL</span></label> <input type="text" class="form-control" id="website" name="website" ng-model="vm.form.storeInformation.website" validation="required|custom:vm.validation.url(vm.form.storeInformation.website):alt=Must be a valid URL."></div><div class="form-group" ng-if="vm.config.program === vm.programType.SERVICE"><label for="dmsSystem"><span class="cursor-pointer hover-underline" uib-popover="Select the DMS System your dealership uses." popover-placement="right" popover-trigger="outsideClick">DMS System</span></label><select class="form-control" id="dmsSystem" name="dmsSystem" ng-model="vm.form.storeInformation.dmsSystem" ng-options="dms.value as dms.text for dms in vm.systemEnums.dmsSystem"></select></div></div><br><div class="col-sm-6"><ng-map class="map map-md" zoom="16" center="26.114249, -80.1368509" control-size="25"><marker position="{{vm.marker.location}}" title="{{vm.marker.title}}"></marker></ng-map></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-summary.view.html','<div class="col-sm-12 row"><label class="step-header">Summary</label><br>{{ vm.config.enrollmentSteps[\'Summary\'].content }}<hr></div><div class="row row-eq-height"><div class="col-sm-12 form-group"><h3>Store Information - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(0)"><i>edit</i></span></h3><div class="row"><div class="col-sm-3"><strong>Dealer Name:</strong></div><div class="col-sm-9">{{ vm.form.storeInformation.dealerName }}</div></div><div class="row"><div class="col-sm-3"><strong>Legal Name:</strong></div><div class="col-sm-9">{{ vm.form.storeInformation.legalName }} {{ vm.form.storeInformation.entityType }}</div></div><div class="row"><div class="col-sm-3"><strong>Address:</strong></div><div class="col-sm-9">{{ vm.form.storeInformation.location.streetAddress }}, {{ vm.form.storeInformation.location.city }} {{ vm.form.storeInformation.location.state }}</div></div><div class="row"><div class="col-sm-3"><strong>Main Phone Number:</strong></div><div class="col-sm-9">{{ vm.form.storeInformation.mainPhone }}</div></div><div class="row"><div class="col-sm-3"><strong>Service Phone Number:</strong></div><div class="col-sm-9">{{ vm.form.storeInformation.servicePhone }}</div></div><div class="row"><div class="col-sm-3"><strong>Web site URL:</strong></div><div class="col-sm-9">{{ vm.form.storeInformation.website }}</div></div><div class="row" ng-if="vm.config.program === vm.programType.SERVICE"><div class="col-sm-3"><strong>DMS System:</strong></div><div class="col-sm-9">{{ vm.showDmsSystem() }}</div></div></div></div><hr><div class="row row-eq-height"><div class="col-sm-12 form-group"><h3>Store Hours - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(1)"><i>edit</i></span></h3><div class="row" ng-repeat="day in vm.form.storeHours.hours"><div class="col-sm-3"><strong>{{ day.title }}</strong></div><div class="col-sm-9" ng-if="!day.closed">{{ vm.minutesFromMidnightToAmPm(day.startTime).ampmHours }} to {{ vm.minutesFromMidnightToAmPm(day.endTime).ampmHours }}</div><div class="col-sm-9" ng-if="day.closed">Closed</div></div></div></div><hr><div class="row row-eq-height"><div class="col-sm-12 form-group"><h3>Program Champion - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(2)"><i>edit</i></span></h3><div class="row"><div class="col-sm-3"><strong>Company Title:</strong></div><div class="col-sm-9">{{ vm.form.champion.userTitle }}</div></div><div class="row"><div class="col-sm-3"><strong>Name:</strong></div><div class="col-sm-9">{{ vm.form.champion.firstName }} {{ vm.form.champion.lastName }}</div></div><div class="row"><div class="col-sm-3"><strong>Office Phone Number:</strong></div><div class="col-sm-9">{{ vm.form.champion.officePhone }}</div></div><div class="row"><div class="col-sm-3"><strong>Mobile Phone Number:</strong></div><div class="col-sm-9">{{ vm.form.champion.mobilePhone }}</div></div><div class="row"><div class="col-sm-3"><strong>Email Address:</strong></div><div class="col-sm-9">{{ vm.form.champion.emailAddress }}</div></div></div></div><hr><div class="row row-eq-height"><div class="col-sm-12 form-group"><h3>BillingContact - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(3)"><i>edit</i></span></h3><div class="row"><div class="col-sm-3"><strong>Name:</strong></div><div class="col-sm-9">{{ vm.form.billingContact.firstName }} {{ vm.form.billingContact.lastName }}</div></div><div class="row"><div class="col-sm-3"><strong>Phone Number:</strong></div><div class="col-sm-9">{{ vm.form.billingContact.contactPhone }}</div></div><div class="row"><div class="col-sm-3"><strong>Email Address:</strong></div><div class="col-sm-9">{{ vm.form.billingContact.emailAddress }}</div></div></div></div><hr><div class="row row-eq-height" ng-repeat="advisor in vm.form.advisors"><div class="col-sm-12 form-group"><h3>BDC Advisor {{ $index + 1 }} - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(4)"><i>edit</i></span></h3><div class="row"><div class="col-sm-3"><strong>Company Title:</strong></div><div class="col-sm-9">{{ advisor.userTitle }}</div></div><div class="row"><div class="col-sm-3"><strong>Name:</strong></div><div class="col-sm-9">{{ advisor.firstName }} {{ advisor.lastName }}</div></div><div class="row"><div class="col-sm-3"><strong>Office Phone Number:</strong></div><div class="col-sm-9">{{ advisor.officePhone }}</div></div><div class="row"><div class="col-sm-3"><strong>Email Address:</strong></div><div class="col-sm-9">{{ advisor.emailAddress }}</div></div></div></div><hr ng-if="vm.form.advisors.length > 0"><div class="row row-eq-height" ng-if="vm.config.program == vm.programType.TEST_DRIVE && !vm.config.hideVehicles"><div class="col-sm-12 form-group"><h3>Vehicles - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(4)"><i>edit</i></span></h3><div class="row" ng-repeat="tripType in vm.config.tripTypes"><div class="col-sm-9" ng-if="vm.tripTypes.contains(tripType.id)"><strong>{{ tripType.name }}</strong></div></div></div></div><hr ng-if="vm.config.program == vm.programType.TEST_DRIVE && !vm.config.hideVehicles"><div class="row row-eq-height" ng-repeat="driver in vm.form.drivers"><div class="col-sm-12 form-group"><h3>Driver {{ $index + 1 }} - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(5)"><i>edit</i></span></h3><div class="row"><div class="col-sm-3"><strong>Name:</strong></div><div class="col-sm-9">{{ driver.firstName }} {{ driver.lastName }}</div></div><div class="row"><div class="col-sm-3"><strong>Mobile Phone Number:</strong></div><div class="col-sm-9">{{ driver.mobilePhone }}</div></div></div></div><hr ng-if="vm.form.drivers.length > 0 && !vm.config.hideContract"><div class="row row-eq-height" ng-if="!vm.config.hideContract"><div class="col-sm-12 form-group"><h3>Agreement - <span class="cursor-pointer text-danger" title="edit" ng-click="vm.goto(6)"><i>edit</i></span></h3><div class="row"><div class="col-sm-3"><strong>Signer Email:</strong></div><div class="col-sm-9">{{ vm.form.contractSignerEmail }}</div></div></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment-vehicle.view.html','<div class="form-group"><label class="step-header">Vehicles</label><br>{{ vm.config.enrollmentSteps[\'Vehicles\'].content }}</div><hr><div class="col-sm-6"><div class="alert alert-danger" ng-if="vm.vehicle.missingMessage.length > 0">{{ vm.vehicle.missingMessage }}</div><div class="col-sm-12" ng-repeat="tripType in vm.config.tripTypes"><label class="checkbox-inline"><input type="checkbox" ng-click="vm.tripTypes.change($event, tripType.id)">{{ tripType.name }}</label></div></div>');
$templateCache.put('app/areas/enrollment/views/enrollment.view.html','<div id="wizard" class="wrapper wrapper-content"><div class="row"><div class="col-sm-12"><form name="vm.inputForm" wizard="" templates="vm.templates" step-changing="vm.stepChanging" step-orientation="vertical" body-tag="fieldset" novalidate=""><h3>{{ vm.templates[0].name }}</h3><fieldset ng-include="vm.templates[0].route" ng-form="{{ vm.templates[0].form }}" novalidate=""></fieldset><h3>{{ vm.templates[1].name }}</h3><fieldset ng-include="vm.templates[1].route" ng-form="{{ vm.templates[1].form }}" novalidate=""></fieldset><h3>{{ vm.templates[2].name }}</h3><fieldset ng-include="vm.templates[2].route" ng-form="{{ vm.templates[2].form }}" novalidate=""></fieldset><h3>{{ vm.templates[3].name }}</h3><fieldset ng-include="vm.templates[3].route" ng-form="{{ vm.templates[3].form }}" novalidate=""></fieldset><h3>{{ vm.templates[4].name }}</h3><fieldset ng-include="vm.templates[4].route" ng-form="{{ vm.templates[4].form }}" novalidate=""></fieldset><h3>{{ vm.templates[5].name }}</h3><fieldset ng-include="vm.templates[5].route" ng-form="{{ vm.templates[5].form }}" novalidate=""></fieldset><h3>{{ vm.templates[6].name }}</h3><fieldset ng-include="vm.templates[6].route" ng-form="{{ vm.templates[6].form }}" novalidate=""></fieldset><h3>{{ vm.templates[7].name }}</h3><fieldset ng-include="vm.templates[7].route" ng-form="{{ vm.templates[7].form }}" novalidate=""></fieldset><h3>{{ vm.templates[8].name }}</h3><fieldset ng-include="vm.templates[8].route" ng-form="{{ vm.templates[8].form }}" novalidate=""></fieldset></form></div></div><div class="row wizard-phone"><div class="wizard-phone-container wizard-phone-left">&nbsp;</div><div class="wizard-phone-container wizard-phone-right"><strong>Need help? Call {{ vm.config.programPhoneNumber }}</strong></div></div><modal-message show="vm.finish.show" guid="vm.config.guid" config-id="vm.config.id" finished="vm.finish.isFinished" message-header="vm.finish.messageHeader" message-body="vm.finish.messageBody" message-footer="vm.finish.messageFooter"></modal-message></div>');
$templateCache.put('app/areas/enrollment/views/sso-enroll-ok.view.html','<div class="frame-in"><div ng-cloak="" id="wrapper" class="top-navigation"><div class="navbar-header"><nav id="frame_navbar" class="navbar navbar-fixed-top"><center><h2>{{ vm.title }}</h2></center></nav></div></div><div id="content" class="content {{$state.name}}" ng-class="config.styleClass"><br><p>{{ vm.content }}</p><p>{{ vm.content2 }}</p><p ng-if="vm.partnerDealerId != null">To update your parts pickup location, <a ui-sref="enrollment-sso-edit({ dealerId: vm.partnerDealerId })">click here</a></p><br></div></div>');
$templateCache.put('app/areas/enrollment/views/sso-enroll-provisioned.view.html','<div class="frame-in"><div ng-cloak="" id="wrapper" class="top-navigation"><div class="navbar-header"><nav id="frame_navbar" class="navbar navbar-fixed-top"><center><h2>Your Registration is Complete!</h2></center></nav></div></div><div id="content" class="content {{$state.name}}" ng-class="config.styleClass"><center><br><br><p>We are configuring your account and will be ready shortly. Please check back in\u2026</p><br><p></p><h1><b>{{ vm.allowedStartTime }}</b></h1><p></p><p>minutes.</p></center></div></div>');
$templateCache.put('app/areas/enrollment/views/sso-enroll.view.html','<div class="frame-in"><div class="navbar-header"><nav id="frame_navbar" class="navbar navbar-fixed-top"><center><h2>Let\u2019s setup your parts store location.</h2></center></nav></div><div id="content" class="content {{$state.name}}" ng-class="config.styleClass"><br><br><p></p><h4 class="bold text-uppercase">Step 1:</h4>Enter the address of your parts department and choose your location from the list provided.<p></p><div class="row"><div class="col-xs-5"><input type="text" id="gplaces" name="gplaces" ng-model="vm.gplaces" class="form-control better-placeholder" placeholder="DEALER LOCATION" required="" details="vm.places" validation="required" here-places="" options="vm.placesOptions" allow-create-new="false" handle-selected="vm.placeUpdated(formattedAddress)" fetch-twilio-numbers=""></div></div><br><div class="enroll-step-2"><p></p><h4 class="bold text-uppercase">STEP 2:</h4>Move the map so the pin is placed at your Parts Department delivery door. It is important to set the pin at your door so the delivery drivers know where to meet you to pick up the parts.<p></p><div id="map-container" class="max-height-px400" fill-height=""><div id="public-map" class="map-fullHeight" map-resize=""><div id="map" class="full-width display-contents" fill-height="" heremaps="" options="vm.mapOptions" map-ready="vm.onMapReady" events="vm.mapListeners" ng-attr-controls="{{::vm.mapOptions.showControls === true ? \'right-bottom\' : undefined}}"></div></div></div><div ng-if="vm.showMapCover" class="enroll-overlay"></div><div ng-if="vm.showMapCover" class="enroll-overlay-text">You must first enter your parts department address above.</div></div><br><p><div class="row"><div class="col-sm-9 text-align-right">&nbsp; <span class="text-uppercase bold font-size-14 text-color-green" ng-if="vm.showDistanceOk"><span class="material-icons md-24 align-bottom">done</span>Thank you for verifying your location</span> <span class="text-uppercase bold font-size-14 text-color-red" ng-if="vm.showDistanceWarning"><span class="material-icons md-24 align-bottom">clear</span>Your pin is too far from the address entered.<br>Please change the address or move the pin to your parts delivery door.</span></div><div class="col-sm-2 form-actions padding-top-sm"><button ladda="isDataLoading" ng-disabled="vm.isProcessing || vm.showDistanceWarning" class="btn btn-primary block full-width margin-bottom" ng-class="config.styleClass" ng-click="vm.createDealer()">Continue</button></div><div class="col-sm-1"></div></div></p></div></div>');
$templateCache.put('app/areas/enrollment/views/welcome.view.html','<div class="wrapper wrapper-content"><div class="row text-center"><div class="videogular-container padding-bottom-lg" ng-if="vm.config.landingPageVideoUrl"><iframe ng-src="{{ vm.video }}" width="100%" height="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe></div></div><div class="row"><div class="videogular-content" ng-bind-html="vm.config.landingPageContent"></div></div><div class="row padding-top-lg"><div class="videogular-content"><form name="inputForm" ng-submit="vm.validation.code()" novalidate=""><div class="row"><div class="col-sm-12"><label>Enter your {{ vm.config.dealerIdLabel }}</label></div></div><div class="row"><div class="col-sm-3"><input type="text" name="code" id="code" class="form-control" ng-model="vm.form.code" ng-change="vm.validation.clearError()" validation="required" validation-error-to="codeError"></div></div><div class="form-group row"><div class="col-sm-12 validation validation-code text-danger" ng-if="!vm.validation.hasError()">{{ vm.message }}</div><div id="codeError" class="col-sm-12 validation validation-code text-danger"></div></div><div class="form-actions"><button type="submit" ladda="isDataLoading || vm.processing" ng-disabled="inputForm.$invalid" class="btn btn-primary" ng-class="vm.config.styleClass">Get Started</button></div></form></div></div></div>');
$templateCache.put('app/areas/inspect/views/inspect-base.view.html','<div id="inspect" class="display-flex flex-column overflow-hidden full-width-height"><div id="menu-container" class="height-px-50 flex-fullwidth-50h content-center"><div id="inspect-base-tabs" class="content-center height-px-50" scrollable-tabs="" selected-item="vm.selectedTab.roId" ng-if="vm.tabbedRos"><ul id="menu" ui-sortable="vm.sortableSettings" class="height-px-50 content-center margin-left-sm margin-right-sm margin-top-none margin-bottom-none"><li class="text-nowrap content-center height-px-50 ui-state-disabled" ng-class="{\'active\': vm.selectedTabType === vm.tabType.routeSheet }" ng-click="vm.onTabSelected(vm.tabType.routeSheet)">Route Sheet</li><li id="{{vm.tabIdPrefix}}{{roTab.roId}}" class="text-nowrap content-center height-px-50" ng-repeat="roTab in vm.tabbedRos track by roTab.roId + \'-\' + roTab.uniqueId" ng-click="vm.onTabSelected(vm.tabType.roDetail, roTab)" ng-class="{ \'active\': vm.selectedTabType === vm.tabType.roDetail && vm.selectedTab.roId === roTab.roId, \'can-close\': roTab.canClose }"><div class="padding-left inline"><div class="hidden-xs" title="RO# {{roTab.roNumber}}">{{ roTab.customerName }}</div><div class="visible-xs"><div class="inline-block ellipsis-overflow max-width-px-60 align-middle">{{ roTab.lastName }}</div>({{ roTab.roNumberSuffix }})</div></div><i ng-if="roTab.canClose" ng-click="vm.closeTab(roTab)" class="font-size-14 line-height-14 margin-left-sm material-icons">close</i></li></ul></div></div><div id="inspect-content" class="display-flex overflow-hidden full-width-height"><inspect-list class="full-width panel margin-md margin-top-none padding-xs display-flex flex-column overflow-hidden padding-right-20 override-sm-margin-none override-xs-margin-none override-xs-padding-right-none" ng-show="vm.selectedTabType === vm.tabType.routeSheet" selected-tab-type="vm.selectedTabType" has-dealer-payments-permission="vm.hasDealerPaymentsPermission"></inspect-list><div class="inspect-content-wrapper full-width panel margin-md padding-none margin-top-none border-none display-flex flex-column overflow-hidden" ng-if="vm.selectedTabType === vm.tabType.roDetail && vm.dealerId"><inspect-ro-detail ro-id="vm.selectedTab.roId" dealer-id="vm.dealerId" ro-tab="vm.selectedTab" has-messaging="vm.hasMessaging" has-dealer-payments-permission="vm.hasDealerPaymentsPermission"></inspect-ro-detail></div></div></div>');
$templateCache.put('app/areas/inspect/views/inspect-list.view.html','<div id="inspect-list" class="display-flex flex-column overflow-hidden full-height"><div class="search-list-header search-filters white-bg override-xs-padding-none override-sm-padding-none"><div class="display-flex flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-xs-margin-bottom-xs"><div class="flex-percent-80 flex-xs-percent-100 flex-sm-percent-100"><div class="display-flex flex-row full-width visible-xs visible-sm margin-bottom-sm"><div class="flex-sm-percent-90 flex-xs-percent-90 flex-grow visible-xs visible-sm padding-right-md override-sm-padding-left-sm"><div class="block relative padding-left-none padding-right-sm override-xs-padding-none" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 max-width-px-30 visible-xs visible-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.repairOrders.length" toggle-advanced-search="vm.expandSearch()" reset-filters="vm.resetFilters(true)" align-right="true"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 max-width-px-30 visible-xs visible-sm margin-top-sm" ng-if="!vm.showSearchTray && vm.selectedLocation"><a ng-click="vm.addRo()" class="margin-left-md visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row flex-xs-column"><div class="flex-width-200 flex-grow flex-xs-percent-100 flex-sm-percent-100 margin-top-sm hidden-sm hidden-xs"><div class="block relative padding-left-none padding-right-sm xs-nopadding max-width-100-percent" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-200 flex-grow flex-xs-percent-100 flex-sm-percent-50 margin-top-sm hidden-sm hidden-xs" ng-if="vm.dealers.length > 1"><div class="block relative padding-left-sm padding-right-sm xs-nopadding max-width-100-percent override-sm-padding-left-none padding-right-none"><div class="field-wrapper"><label for="locationFilter">LOCATION</label><select selectlabel="" class="form-control" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-options="l as l.name for l in vm.dealers track by l.id" ng-model="vm.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.isLoading"></select></div></div></div><div class="flex-width-300 flex-grow flex-xs-percent-100 flex-sm-percent-50 margin-top-sm"><div class="block relative padding-left-sm padding-right-sm xs-nopadding text-notransform override-xs-padding-left-none override-xs-padding-right-none"><input type="text" id="inspect_search" name="inspect_search" maxlength="32" autocomplete="nope" ng-keyup="$event.keyCode === 13 && vm.filtersChanged()" ng-model="vm.filters.search" class="form-control better-placeholder" clean="true" placeholder="Search by RO, name, phone" ng-disabled="vm.isLoading || !vm.selectedLocation"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 flex-xs-percent-100 flex-sm-percent-100 margin-top-sm hidden-sm hidden-xs" ng-hide="vm.showCalendar() === true"><div class="block relative padding-left-sm padding-right-sm xs-nopadding"><div class="field-wrapper"><label for="dateRangeFilter">TIMEFRAME</label><select selectlabel="" id="dateRangeFilter" ng-disabled="vm.isLoading || vm.filters.showAllOpen" disable-search="true" class="form-control ng-show" name="dateRangeFilter" ng-model="vm.filters.timeframeFilter" ng-change="vm.timeframeChanged(t)" ng-options="t.value as t.text for t in vm.timeframes"></select></div></div></div><div class="flex-width-250 flex-xs-percent-100 flex-sm-percent-100 margin-top-sm hidden-sm hidden-xs" ng-hide="vm.showCalendar() === false"><div class="block relative padding-left-sm padding-right-sm xs-nopadding"><input options="vm.dateRangePickerOptions" id="timeframe_range" date-range-picker="" class="form-control date-picker min-width-px-200" placeholder="DATE RANGE..." type="text" ng-model="vm.filters.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearCustomTimeFrame()">close</span></div></div><div class="flex-width-150 flex-xs-percent-100 flex-sm-percent-100 margin-top-sm content-center padding-right-sm hidden-sm hidden-xs"><div class="block relative padding-left-sm padding-right-sm xs-nopadding text-nowrap"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showInactive" ng-model="vm.filters.showInactive" ng-disabled="vm.isLoading || !vm.selectedLocation" ng-change="vm.filtersChanged()"> <span class="font-normal padding-left-sm">Show Closed</span></label></div></div><div class="flex-width-150 flex-xs-percent-100 flex-sm-percent-100 margin-top-sm content-center padding-right-sm hidden-sm hidden-xs"><div class="block relative padding-left-sm padding-right-sm xs-nopadding text-nowrap"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showOnlyMine" ng-model="vm.filters.showOnlyMine" ng-disabled="vm.isLoading || !vm.selectedLocation || !vm.filters.dealerUsers" ng-change="vm.filtersChanged()"> <span class="font-normal padding-left-sm">Only Mine</span></label></div></div><div class="flex-width-150 flex-xs-percent-100 flex-sm-percent-100 margin-top-sm content-center padding-right-sm hidden-sm hidden-xs"><div class="block relative padding-left-sm padding-right-sm xs-nopadding text-nowrap"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showAllOpen" ng-model="vm.filters.showAllOpen" ng-disabled="!vm.selectedLocation" ng-change="vm.filtersChanged()"> <span class="font-normal padding-left-sm">Show All Open</span></label></div></div><div class="flex-width-150 hidden-xs hidden-sm margin-top-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.repairOrders.length" toggle-advanced-search="vm.expandSearch()" reset-filters="vm.resetFilters(true)"></rc-list-advanced-filter-toggle></div></div><div ng-if="vm.selectedLocation" class="display-flex flex-row flex-sm-column visible-xs visible-sm override-sm-padding-left-sm"><rc-list-mobile-filters required-filter-message="vm.requiredFilterMessage" required-filter-count="2" filter-count="vm.filterCount" record-count="vm.repairOrders.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div></div><div class="flex-percent-20 text-right pad-left-15 override-xs-side-padding-none flex-xs-percent-100 flex-sm-percent-100 margin-top-sm xs-text-left content-center hidden-sm hidden-xs" ng-if="vm.selectedLocation"><div class="pull-right vertical-align"><i class="material-icons info-icon margin-right-md margin-bottom-md" uib-popover="Auto-Refresh: Automatically updates the page with the latest data." popover-append-to-body="true" popover-placement="top" popover-trigger="mouseenter">info_outline</i> <span id="refresh-countdown" ng-if="vm.autoRefresh">{{ vm.refreshCountdown }}</span><switch class="green" id="route-auto-refresh" name="routeAutoRefresh" ng-model="vm.autoRefresh" ng-change="vm.toggleAutoRefresh()" disabled="vm.searchExpanded" title="Auto Refresh"></switch><a ng-click="vm.addRo()" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass"><span class="hidden-xs">+</span> <span>NEW</span></a></div></div></div></div><div class="padding-right-20 overflow-y-auto flex-percent-85 overflow-x-auto margin-bottom-md" id="inspect-list-table-wrapper"><div ng-if="vm.isLoading" class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading...</div></div><table ng-if="!vm.isLoading" id="inspect-list-table" class="block table searchable-list padding-bottom-md" ng-class="{\'table-hover\': !vm.filters.showStatusColorAcrossRow, \'tiny-columns\': vm.columnsToDisplay.length > 15, \'small-columns\': vm.columnsToDisplay.length > 8 && vm.columnsToDisplay.length < 15 , \'med-columns\': vm.columnsToDisplay.length <= 8 }" infinite-scroll="vm.displayMore()" infinite-scroll-immediate-check="true" infinite-scroll-listen-for-event="routeSheetAutoRefreshed" infinite-scroll-distance="1" infinite-scroll-container="\'#inspect-list-table-wrapper\'" infinite-scroll-disabled="!vm.routeSheetTabActive || vm.isLoading || vm.isLoadingMore || !vm.canLoadMore"><thead ng-if="vm.selectedLocation && vm.repairOrders && vm.repairOrders.length && vm.columnsToDisplay"><tr class="text-uppercase"><th class="visible-xs"></th><th class="hidden-xs" ng-repeat="col in vm.columnsToDisplay" ng-click="vm.sortableColumnClicked(col)" title="{{ col.displayName | uppercase }}" ng-class="{ \'text-center\': col.name == \'statusName\' || col.name == \'shopFlagName\', \'sortable\': col.isSortable, \'active\': col.isActive, \'sort-desc\': col.isActive && vm.filters.sortDirection === vm.sortOrder.descending, \'sort-asc\': col.isActive && vm.filters.sortDirection === vm.sortOrder.ascending}">{{ col.displayName | uppercase }}</th><th class="hidden-xs">Action</th></tr></thead><tbody ng-if="vm.columnsToDisplay"><tr ng-repeat="ro in vm.repairOrders track by ro.id" class="list-name text-uppercase position-relative" ng-style="vm.filters.showStatusColorAcrossRow && ro.statusColor ? {\'background-color\': ro.statusColor, \'color\': ro.statusTextColor} : null" id="{{ro.id}}" ng-if="vm.repairOrders && vm.repairOrders.length > 0" ng-click="vm.onRoSelected(ro)"><td class="visible-xs padding-left-none padding-right-none padding-top-none"><div ng-repeat="col in vm.columnsToDisplay" ng-if="col.isMobile" class="data align-middle cursor-pointer" ng-style="::{ \'background-color\': col.backgroundProperty ? ro[col.backgroundProperty] || \'transparent\' : \'transparent\', \'color\': col.foregroundProperty ? ro[col.foregroundProperty] : \'inherit\'}" ng-class="{ \'text-center\': col.name == \'statusName\'}"><div class="padding-sm"><span><b>{{::col.displayName}}:</b></span> <span ng-bind-html="ro[col.name] != null ? ro[col.name] : \'N/A\'"></span></div></div></td><td ng-repeat="col in vm.columnsToDisplay" class="data align-middle cursor-pointer hidden-xs" title="{{ ::ro[col.tooltip] || ro[col.name] }}" ng-style="::{ \'background-color\': col.backgroundProperty ? ro[col.backgroundProperty] || \'transparent\' : \'transparent\', \'color\': col.foregroundProperty ? ro[col.foregroundProperty] : \'inherit\'}" ng-class="{ \'text-center\': col.name == \'statusName\' || col.name == \'shopFlagName\', \'text-notransform\': col.name === \'elapsed\' }"><span ng-if="col.name === \'mediaCount\'">{{ ro[col.name] || 0 }}</span> <span ng-if="col.name !== \'mediaCount\'" ng-bind-html="ro[col.name] || \'N/A\'"></span></td><td class="align-middle cursor-pointer action-dropdown hidden-xs"><div class="field-wrapper min-width-px-90"><label for="selectAction{{ro.id}}">ACTION</label><select class="form-control" id="selectAction{{ro.id}}" name="selectAction{{ro.id}}" ng-click="$event.stopPropagation()" ng-model="ro.selectedAction" ng-options="action.id as action.name for action in ro.inspectActions track by action.id" ng-change="vm.onActionSelected(ro)"><option value="">Action</option></select></div></td></tr></tbody><tfoot><tr class="full-viewport-width"><td colspan="100%" class="full-viewport-width"><div class="text-center margin-top text-uppercase font-bold"><div ng-if="vm.isLoadingMore"><img src="assets/images/ajax-loader.gif"> Loading...</div><div ng-if="!vm.isLoadingMore && !vm.selectedLocation">Please select a Location from the Location dropdown to load the Repair Order list.</div><div ng-if="!vm.isLoadingMore && vm.selectedLocation && !vm.repairOrders.length">There are no RO\'s that match the selected criteria.</div><div ng-if="!vm.isLoadingMore && vm.selectedLocation && !vm.canLoadMore">You have reached the end of the list.</div></div></td></tr></tfoot></table></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height min-height-px-430"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm" popover-trigger="mouseenter" uib-popover-template="\'filter-popover.html\'">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25 min-height-px-250"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-sm override-sm-margin-top" ng-if="vm.dealers.length > 1"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="field-wrapper"><label for="locationFilter">LOCATION</label><select selectlabel="" class="form-control" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-options="l as l.name for l in vm.dealers track by l.id" ng-model="vm.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.isLoading"></select></div></div></div><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-sm override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-xs text-notransform" ng-class="{\'padding-left-xs\': vm.dealers.length > 1}"><input type="text" id="inspect_search" name="inspect_search" maxlength="32" autocomplete="nope" ng-model="vm.filters.search" class="form-control better-placeholder" clean="true" placeholder="Search by RO, name, phone" ng-disabled="vm.isLoading || !vm.selectedLocation"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md" ng-hide="vm.showCalendar() === true"><div class="block relative override-xs-padding-none override-sm-padding-none padding-left-xs"><div class="field-wrapper"><label for="dateRangeFilter">TIMEFRAME</label><select selectlabel="" id="dateRangeFilter" ng-disabled="vm.isLoading || vm.filters.showAllOpen" disable-search="true" class="form-control ng-show" name="dateRangeFilter" ng-model="vm.filters.timeframeFilter" ng-options="t.value as t.text for t in vm.timeframes"></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top" ng-hide="vm.showCalendar() === false"><div class="block relative override-xs-padding-none override-sm-padding-none padding-left-xs"><input options="vm.dateRangePickerOptions" id="timeframe_range" date-range-picker="" class="form-control date-picker min-width-px-190" placeholder="DATE RANGE..." type="text" ng-model="vm.filters.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearCustomTimeFrame()">close</span></div></div><div class="flex-width-150 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-lg padding-left-md"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showInactive" ng-model="vm.filters.showInactive" ng-disabled="vm.isLoading || !vm.selectedLocation || vm.filters.showAllOpen"> <span class="font-normal padding-left-sm">Show Closed</span></label></div></div><div class="flex-width-145 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showOnlyMine" ng-model="vm.filters.showOnlyMine" ng-disabled="vm.isLoading || !vm.selectedLocation || !vm.filters.dealerUsers"> <span class="font-normal padding-left-sm">Only Mine</span></label></div></div><div class="flex-width-150 flex-grow flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showAllOpen" ng-model="vm.filters.showAllOpen" ng-disabled="!vm.selectedLocation"> <span class="font-normal padding-left-sm">Show All Open</span></label></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="chosen-field-wrapper"><label class="label selected margin-left-none">Service Advisor</label></div><div ng-dropdown-multiselect="" events="vm.checkboxFilterEvents" disabled="vm.isLoading || !vm.filters.serviceAdvisorsList || vm.filters.serviceAdvisorsList.length === 0" options="vm.filters.serviceAdvisorsList" selected-model="vm.filters.serviceAdvisors" checkboxes="true" extra-settings="vm.serviceAdvisorsFilterSettings" translation-texts="vm.serviceAdvisorsDropdownLabels"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="chosen-field-wrapper"><label class="label selected margin-left-none">TECHNICIAN</label></div><div ng-dropdown-multiselect="" events="vm.checkboxFilterEvents" disabled="vm.isLoading || !vm.filters.techniciansList || vm.filters.techniciansList.length === 0" options="vm.filters.techniciansList" selected-model="vm.filters.technicians" checkboxes="true" extra-settings="vm.technicianFilterSettings" translation-texts="vm.technicianDropdownLabels"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="chosen-field-wrapper"><label class="label selected margin-left-none">ASSIGNED TO</label></div><div ng-dropdown-multiselect="" events="vm.checkboxFilterEvents" disabled="vm.isLoading || !vm.filters.dealerUsers || vm.filters.dealerUsers.length === 0" options="vm.filters.dealerUsers" selected-model="vm.filters.assignedTo" checkboxes="true" extra-settings="vm.assignedFilterSettings" translation-texts="vm.assignedDropdownLabels"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="chosen-field-wrapper"><label class="label selected margin-left-none">STATUS</label></div><div ng-dropdown-multiselect="" events="vm.checkboxFilterEvents" disabled="vm.isLoading || !vm.filters.roStatuses || vm.filters.roStatuses.length === 0" options="vm.filters.roStatuses" selected-model="vm.filters.statuses" checkboxes="true" extra-settings="vm.statusFilterSettings" translation-texts="vm.statusDropdownLabels"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="customer-search text-notransform"><input type="text" id="repairOrderSearch" name="repairOrderSearch" ng-model="vm.roNumberSearch" class="form-control better-placeholder" ng-disabled="!vm.selectedLocation.dmsEnabled" placeholder="IMPORT RO#" ng-change="vm.importFound = true" ng-keyup="$event.keyCode === 13 && vm.searchRos(vm.roNumberSearch)"></div><div class="text-danger" ng-if="vm.roNumberSearch.length > 0 && vm.importFound === false">No Results match {{ vm.roNumberSearch }}</div></div></div><div class="flex-width-200 flex-sm-percent-100 margin-top-md margin-bottom-md visible-xs visible-sm override-xs-margin-bottom-none"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><div class="field-wrapper"><label for="statusFilter">SORT BY</label><select selectlabel="" class="form-control" id="sortByFilter" name="sortByFilter" ng-options="sortBy.id as sortBy.name for sortBy in vm.sortOptions" ng-model="vm.filters.sortBy" ng-change="vm.filtersChanged()" ng-disabled="vm.isLoading || !vm.selectedLocation"><option value="">Sort By</option></select></div></div></div><div class="flex-width-250 flex-grow flex-sm-percent-100 margin-top-md margin-bottom-md visible-xs visible-sm"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><label class="text-nowrap display-flex"><input type="checkbox" class="margin-none" name="showStatusColorAcrossRow" ng-model="vm.filters.showStatusColorAcrossRow" ng-disabled="!vm.selectedLocation"> <span class="font-normal padding-left-sm">Show Status Color Across Entire Row</span></label></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md hidden-xs hidden-sm"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><select selectlabel="" class="form-control" id="mockFilter" name="mockFilter" ng-click="vm.columnsFilterClicked()" ng-mousedown="$event.preventDefault()" placeholder="Saved Searches" ng-model="vm.mockSelection" ng-disabled="vm.isLoading"><option value="" disabled="" selected="">Columns {{ vm.showSortable ? \'(Click to retract)\' : \'(Click to expand)\' }}</option></select><ul id="inspect-list-sort-config" ui-sortable="" ng-show="vm.showSortable" ng-model="vm.allColumns" ui-sortable-stop="vm.onColumnReorder" class="list-unstyled overflow-y-auto form-control dropdown-shadow position-absolute"><li ng-repeat="col in vm.allColumns" class="inspect-list-sort-row"><label class="checkbox-flex"><div><i class="material-icons link">menu</i> <input type="checkbox" name="showCol{{col.name}}" ng-model="col.show" ng-change="vm.columnFilterClicked()" ng-disabled="vm.isLoading || !vm.selectedLocation"></div><div class="font-normal text-uppercase">{{ col.displayName }}</div></label></li></ul></div></div><div class="flex-width-250 flex-grow flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top padding-left-md"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><label class="text-nowrap display-flex margin-top-md"><input type="checkbox" class="margin-none" name="showStatusColorAcrossRow" ng-model="vm.filters.showStatusColorAcrossRow" ng-disabled="!vm.selectedLocation"> <span class="font-normal padding-left-sm">Show Status Color Across Entire Row</span></label></div></div></div><div class="display-flex flex-row padding-bottom-lg margin-top-md override-sm-margin-top-none"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left"><div class="block relative padding-right-sm"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vm.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-none override-xs-margin-none"><rc-list-template-save-search-delete-btns list-controller="vm" current-search-template="vm.searchTemplateData.currentSearchTemplate" is-processing-template="vm.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vm.canManageGlobalTemplates" template-message="vm.templateMessage" save-btn-clicked="vm.saveBtnClicked()" save-as-btn-clicked="vm.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vm.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm" ng-click="vm.resetFilters(true);vm.close();">Reset Filters</div><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal><script type="text/ng-template" id="filter-popover.html"><div class=\'black\'>Location:<br/>{{vm.selectedLocation.name}}</div></script>');
$templateCache.put('app/areas/location/views/dealer-config-modal.view.html','<div class="display-flex flex-column vh-h93"><div class="modal-header"><h2 class="modal-title inline no-transform" id="dealerConfigModalLabel">{{vm.title}}</h2></div><div class="modal-body flex-grow overflow-y-auto" aside-parent="vm.childScopeForm"><form role="form" name="dealerConfigForm" class="form margin-bottom-lg" ng-submit="vm.handlePrimaryAction()" novalidate=""><div ng-if="vm.step === vm.steps.select"><div class="display-flex flex-row"><div class="form-group flex-grow flex-percent-50"><ui-select name="tripType" class="saved-search-typeahead fake-required" ng-model="vm.selectedTripType" ng-change="vm.tripTypeChanged()" reset-search-input="true" search-enabled="true" ng-required="true" placeholder="Trip Type"><ui-select-match placeholder="Trip Type">{{$select.selected.label}}</ui-select-match><ui-select-choices class="position-absolute" repeat="option in vm.availableTripTypes track by option.dealerTripTypeId"><span ng-bind="option.label"></span></ui-select-choices></ui-select></div><div class="form-group flex-grow flex-percent-50" ng-class="{\'has-error\': dealerConfigForm.configKey.$invalid && dealerConfigForm.$submitted}"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><ui-select name="configKey" class="saved-search-typeahead fake-required" ng-model="vm.form.configKey" on-select="vm.onConfigKeySelected($item, $model)" reset-search-input="true" search-enabled="true" ng-required="true" placeholder="Config Key"><ui-select-match placeholder="Config Key">{{$select.selected}}</ui-select-match><ui-select-choices class="position-absolute" repeat="key in vm.filteredConfigKeys track by key" refresh="vm.filterConfigKeys($select.search)" refresh-delay="250"><span ng-bind="key"></span></ui-select-choices><ui-select-no-choice><div class="padding-left padding-right-sm padding-top-sm padding-bottom-sm"><div class="ng-hide" ng-show="!vm.isLoadingKeys" ng-click="vm.addConfigKey($select)"><span class="theme-link no-underline text-normal-case">Can\'t find it?</span><div class="theme-link create-new inline"><span class="text-notransform">Create new config key.</span></div></div><div class="ng-hide" ng-show="vm.isLoadingKeys">Searching...</div></div></ui-select-no-choice></ui-select></div><div class="text-danger" ng-if="dealerConfigForm.configKey.$invalid && dealerConfigForm.$submitted">Config key is required.</div><div class="text-danger" ng-if="vm.errors.loadKeys">{{ vm.errors.loadKeys }}</div><div class="text-danger" ng-if="vm.errors.loadValue">{{ vm.errors.loadValue }}</div></div></div></div><div ng-if="vm.step === vm.steps.edit"><div class="form-group"><label>Config Key: {{ vm.normalizedConfigKey }}</label></div><div class="form-group" ng-class="{\'has-error\': vm.errors.updateValue}"><textarea id="dealer-config-value" rows="15" name="configValue" class="form-control resize-none" ng-model="vm.form.configValue" ng-required="false"></textarea><div class="text-danger" ng-if="vm.errors.updateValue">{{ vm.errors.updateValue }}</div></div></div></form></div><div class="modal-footer"><div class="pull-left" ng-if="vm.step === vm.steps.edit"><label class="cursor-pointer margin-bottom-none text-normal-case display-flex align-items-center"><input type="checkbox" ng-model="vm.addUpdateAnotherConfigKey" ng-disabled="vm.isLoading"> <span class="margin-left-sm font-normal margin-top-sm">Add/Update another config key</span></label></div><button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.isLoading">Cancel</button> <button type="button" class="btn btn-primary" ladda="vm.isLoading" ng-click="vm.handlePrimaryAction()" ng-disabled="vm.disablePrimaryAction()">{{ vm.primaryLabel }}</button></div></div>');
$templateCache.put('app/areas/location/views/location-add.view.html','<div class="row display-flex full-width-height margin-none"><div class="col-md-12 col-xs-12 border-radius-top-7 padding-none separate-left-aside-panel"><form role="form" name="locationAddForm" class="full-height" id="locationAddForm" autocomplete="off" novalidate=""><div class="display-flex flex-column overflow-hidden full-height border-radius-top-7"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New Location</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-md flex-grow flex-percent-90 col-xs-12 bg-white border-none"><div class="padding-md"><div class="padding-top-md padding-bottom-lg"><select ng-if="vm.showDealerImport" ng-model="vm.dealerAddMode" class="form-control import-dropdown"><option value="1">Add a single dealer</option><option value="2">Import a batch of dealers</option></select></div><div ng-if="vm.dealerAddMode == 1"><h3>Location Information</h3><p>Complete the fields provided to add the location. All fields are required.</p><hr><div class="form-group relative"><input type="text" id="gplaces" name="gplaces" ng-model="vm.gplaces" class="form-control better-placeholder" placeholder="DEALER LOCATION" required="" details="vm.places" validation="required" here-places="" allow-create-new="true" handle-selected="vm.placeUpdated(formattedAddress)" map-fields="{\'salesPhoneNumber\':\'phone\', \'servicePhoneNumber\': \'phone\'}" fetch-twilio-numbers=""> <span ng-if="vm.gplaces && vm.hasDuplicateAddress" class="text-danger col-sm-12 padding-left-none padding-bottom-xs">Warning: Dealer address already exists.</span></div><div class="form-group relative"><input type="text" id="dealer_name" name="dealer_name" ng-model="vm.placesObj.name" class="form-control better-placeholder" ng-disabled="vm.fieldsDisabled" required="" placeholder="DEALER NAME" validation="required:alt=A valid dealer name is required" ng-change="vm.nameUpdated()"> <span ng-if="vm.hasDuplicateName" class="text-danger col-sm-12">Warning: Dealer name already exists.</span></div><div class="row"><div class="col-sm-4"><div class="form-group relative"><input required="" type="text" id="phone_sales" name="phone_sales" ng-model="vm.placesObj.salesPhoneNumber" class="form-control better-placeholder" placeholder="SALES PHONE" ng-disabled="vm.fieldsDisabled" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom:vm.validation.phone(vm.placesObj.salesPhoneNumber):alt=*"></div></div><div class="col-sm-4"><div class="form-group relative"><input type="text" id="phone_service" name="phone_service" ng-model="vm.placesObj.servicePhoneNumber" class="form-control better-placeholder" placeholder="SERVICE PHONE" ng-disabled="vm.fieldsDisabled" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" validation="required|custom:vm.validation.phone(vm.placesObj.servicePhoneNumber):alt=*"></div></div><div class="col-sm-4"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="The phone number that will be used to send text notifications for this dealer." popover-placement="right" popover-trigger="outsideClick">SMS Phone</span></label><br>{{ vm.placesObj.twilioNumber }} <span class="text-danger" ng-if="vm.placesObj.twilioNumber == null && vm.smsNumberQueried">No 800 numbers. Please try again in a few minutes</span><div ng-show="vm.hasDuplicateSMSPhone" class="text-danger">Warning: The SMS phone is already assigned to another dealer.</div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group relative"><input type="text" id="website_url" name="website" required="" ng-model="vm.placesObj.website" class="form-control better-placeholder" placeholder="WEBSITE URL" ng-disabled="vm.fieldsDisabled" validation="required|custom:vm.validation.url(vm.placesObj.website):alt=*"></div></div><div class="col-sm-6"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="What time zone is the dealer located in?" popover-placement="right" popover-trigger="outsideClick">Time Zone</span></label><br>{{ vm.placesObj.timeZone }}</div></div></div><div class="row"><div class="col-sm-6"><div class="form-group relative"><input type="text" id="oem_dealer_id" name="dealer_id" ng-model="vm.placesObj.oemDealerId" class="form-control better-placeholder" placeholder="OEM DEALER ID" ng-disabled="vm.fieldsDisabled" validation="alpha_dash"></div></div><div class="col-sm-6"><div class="form-group field-wrapper"><label for="location_type">SELECT A LOCATION TYPE</label><select required="" selectlabel="" class="form-control" name="location_type" id="location_type" ng-model="vm.placesObj.locationType" ng-options="locationTypes.value as locationTypes.text for locationTypes in vm.systemEnums.locationTypes" ng-disabled="vm.fieldsDisabled" validation="required|in:{{vm.validation.acceptableLocationTypes}}:alt=Please pick a value from the list"><option value="">Select a location type</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group field-wrapper"><label for="copy_from_dealer">DEALER TO COPY FROM</label><select selectlabel="" required="" name="copy_from_dealer" id="copy_from_dealer" class="form-control" ng-disabled="vm.fieldsDisabled" ng-model="vm.dealerIdToCopy" ng-change="vm.validation.checkCopyFrom()" ng-options="location.id as location.name for location in vm.locationList | filter:{isCopyable:true}" validation="required|in:{{vm.validation.acceptableCopyFromDealers}}:alt=Please pick a value from the list"><option value="">Dealer to copy from</option></select></div></div><div class="col-sm-6"><div class="form-group field-wrapper"><label for="admin_config">SELECT A PROGRAM</label><select required="" selectlabel="" class="form-control" name="admin_config" id="admin_config" ng-model="vm.adminConfigId" ng-options="program.id as program.programName for program in vm.adminPrograms" ng-disabled="vm.fieldsDisabled || vm.dealerIdToCopy !== null" validation="required|in:{{vm.validation.acceptableAdminPrograms}}:alt=Please pick a value from the list"><option value="">Select a program</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group field-wrapper"><label for="status">SELECT A STATUS</label><select selectlabel="" required="" class="form-control" name="status" id="status" ng-model="vm.placesObj.status" ng-options="status.value as status.text for status in vm.systemEnums.dealerStatuses" ng-disabled="vm.fieldsDisabled" validation="required|in:{{vm.validation.acceptableStatuses}}:alt=Please pick a value from the list"><option value="">Select a status</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group field-wrapper"><label for="driverCompany" class="control-label visible-xs-inline">DRIVER COMPANY(S)</label><select ng-if="vm.driverCompanies" data-placeholder-text-multiple="\'Select driver company(s)...\'" class="form-control" ng-options-title="vm.driverCompanies" id="driverCompany" name="driverCompany" multiple="" chosen="{width: \'100%\'}" max-shown-results="100" ng-disabled="vm.fieldsDisabled" ng-model="vm.placesObj.driverCompanyIds" ng-options="driverCompany.id as driverCompany.name for driverCompany in vm.driverCompanies"></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group field-wrapper"><label for="driverCompany" class="control-label visible-xs-inline">DRIVER PROGRAM(S)</label><select ng-if="vm.driverPrograms" data-placeholder-text-multiple="\'Select driver program(s)...\'" class="form-control" ng-options-title="vm.driverPrograms" id="driverProgram" name="driverProgram" multiple="" chosen="{width: \'100%\'}" max-shown-results="100" ng-disabled="vm.fieldsDisabled" ng-model="vm.placesObj.driverProgramIds" ng-options="driverProgram.id as driverProgram.name for driverProgram in vm.driverPrograms"></select></div></div></div></div><div ng-if="vm.dealerAddMode == 2"><h3>Batch Dealer Upload</h3><p>Select the file you want to upload and the Dealer you want to copy settings from. Click <a class="theme-link" href="https://redcapstorage.blob.core.windows.net/misc/AccountImportTemplate.csv">SampleDealerFile.CSV</a> to download an empty file in the proper format.</p><hr><div class="btn btn-default margin-right-md margin-bottom" ngf-select="vm.chooseImportFile($file)" ng-model="vm.bulkImport.file" ng-disabled="vm.isLoadingData" required="">Browse...</div><span>{{ vm.bulkImport.fileName }}</span> <img src="assets/images/ajax-loader.gif" ng-if="vm.readingFile"><div><select id="dealer_template" chosen="{width: \'30%\'}" name="dealer_template" selectlabel="" max-shown-results="100" class="form-control has-label" allow-null-option="Select dealer to copy from" required="" ng-model="vm.copyFromDealer" ng-options="dealer as dealer.name for dealer in vm.copyFromDealerList track by dealer.id"></select></div><div class="margin-top" ng-if="vm.isLoadingData"><span>Processing...</span> <img src="assets/images/ajax-loader.gif"></div><div class="margin-top" ng-if="vm.importCompleted">The import process has completed. Please check your email for a full summary of the results. A spreadsheet with saved Id\'s for each record should have automatically downloaded from this page. If the SavedId is 0 in the spreadsheet it indicates that the record was already added or failed to add. These details should be available in the summary email.</div><div ng-if="vm.importResults"><hr><h4>RESULTS</h4><div class="margin-bottom">SUCCESSFUL RECORDS: {{ vm.importResults.successfulRecordCount }}</div><div class="margin-bottom">SKIPPED RECORDS: {{ vm.importResults.skippedDealers.length }}</div><ul ng-if="vm.importResults.skippedDealers.length > 0"><li ng-repeat="skippedDealer in vm.importResults.skippedDealers">{{ skippedDealer }}</li></ul><div ng-if="vm.importResults.genericErrors" class="margin-bottom text-danger"><div ng-repeat="importError in vm.importResults.genericErrors"><div>Error occurred while trying to parse the file: {{ importError.errorMessage }}</div></div></div><div ng-if="vm.importResults.errors" class="text-danger"><div class="margin-bottom">FAILED RECORDS: {{ vm.importResults.errors.length }}</div><div ng-repeat="importError in vm.importResults.errors"><div>Error occurred for Dealer: {{ importError.dealerName }}, {{ importError.detail || importError.errorMessage }}</div></div></div></div></div></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2"><div class="display-flex full-width-height content-center"><div class="text-right padding-right-md full-width padding-right-20"><div ng-if="vm.dealerAddMode == 1"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.createLocation()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || inputForm.$invalid">Add</button></div><div ng-if="vm.dealerAddMode == 2"><button type="button" class="btn btn-default" ng-class="config.styleClass" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.importDealers()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.isLoadingData" ng-disabled="DealerAddForm.$invalid">Upload</button></div></div></div></div></div></form></div></div>');
$templateCache.put('app/areas/location/views/location-edit.view.html','<div class="display-flex overflow-hidden vh-h100 flex-column separate-left-aside-panel"><div class="flex-fullwidth-50h border-radius-top-7 theme-bg padding override-xs-side-padding-md" ng-mouseover="vm.subMenuHover(false)"><div class="modal-header padding-t-b-0"><div class="row"><div class="col-xs-12 col-sm-7 padding-sm padding-top-none padding-bottom-none"><h2 class="modal-title ellipsis-overflow padding-top-none padding-bottom-none">{{ vm.currentLocation.name }}</h2></div></div></div></div><div class="overflow-y-hidden overflow-x-hidden flex-percent-100 col-xs-12 bg-white padding-none"><div id="location-tabs" class="flex-fill full-height" fill-height="" aside-parent="vm.childScopeForm"><div id="location-tab-container" scrollable-tabs="" class="margin-none bg-white font-normal" scroll-clicked="vm.subMenuClick(true)" scroll-amount="150"><uib-tabset class="invisible-tabs scrollable full-height tab-content-padding-none" ng-mouseleave="vm.subMenuHover(false)"><li class="uib-tab" uib-dropdown="" ng-click="vm.subMenuClick()" ng-mouseover="vm.subMenuHover(true)"><button type="button" class="dropdown-tab" uib-dropdown-toggle="">{{ vm.tripTypeName }} <span class="caret"></span></button></li><uib-tab ng-repeat="tab in vm.tabs track by tab.route" heading="{{tab.title}}" active="tab.active" ui-sref="{{tab.route}}" class="text-uppercase" disable="tab.disabled" ng-click="vm.tabChanged($event, tab)" ng-mouseover="vm.subMenuHover(false)"><span class="full-width-height" ui-view="{{tab.route}}" ng-mouseover="vm.subMenuHover(false)"><div class="height-px-70 padding"><img src="assets/images/ajax-loader.gif"><div class="inline">&nbsp;Loading...</div></div></span></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/areas/location/views/location-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="locations" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none" ng-class="{\'expanded\': vm.showSearchTray === true}"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-row full-width visible-sm visible-xs"><div class="flex-sm-percent-60 flex-xs-percent-60 flex-grow visible-xs visible-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search" min-length="1" replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.locationTokenChanged()" on-tag-removed="vm.locationTokenChanged()"></tags-input></div></div><div class="flex-percent-10 visible-xs visible-sm padding-left-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.totalDealersCount" toggle-advanced-search="vm.toggleShowSearchOptions()" align-right="true" search-tray-displayed="vm.showSearchTray"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm" ng-if="!vm.showSearchTray && !vm.isOnlyDealerAdmin"><a ui-sref="location-add" class="margin-left-md visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters filter-count="vm.filterCount" record-count="vm.totalDealersCount" filter-message="vm.filterMessage"></rc-list-mobile-filters></div><div class="flex-percent-80 flex-xs-percent-100 flex-sm-percent-100"><div class="display-flex flex-row flex-xs-column hidden-sm hidden-xs"><div class="flex-width-300 flex-grow max-width-px-400 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-right-sm override-xs-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search" min-length="1" replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.locationTokenChanged()" on-tag-removed="vm.locationTokenChanged()"></tags-input><div class="inline-block text-danger" ng-show="vm.filterMessage != \'\'" ng-bind-html="vm.filterMessage"></div></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div class="field-wrapper"><label for="programFilter">SELECT A PROGRAM</label><select selectlabel="" class="form-control" name="programFilter" id="programFilter" ng-options="adminProgram for adminProgram in vm.adminPrograms" ng-model="vm.filters.selectedProgram" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div class="field-wrapper"><label for="programFilter">SELECT A STATUS</label><select selectlabel="" class="form-control" name="statusFilter" id="statusFilter" ng-options="status for status in vm.statuses" ng-model="vm.filters.selectedStatus" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div class="field-wrapper"><label for="timezoneFilter">SELECT A TIME ZONE</label><select selectlabel="" class="form-control" name="timezoneFilter" id="timezoneFilter" ng-options="timezone for timezone in vm.timezones" ng-model="vm.filters.selectedTimezone" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div class="field-wrapper"><label for="countryFilter">SELECT A COUNTRY</label><select selectlabel="" class="form-control" name="countryFilter" id="countryFilter" ng-options="country for country in vm.countries" ng-model="vm.filters.selectedCountry" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-percent-20 hidden-xs hidden-sm"><div class="text-uppercase text-align-left margin-top-sm padding-left-sm" ng-class="{\'no-filter-msg\': vmList.showFilterMessage() === false}"><span ng-if="vm.filteredLocations && vm.filteredLocations.length">{{vm.totalDealersCount || 0}}</span> <span ng-if="!vm.filteredLocations || !vm.filteredLocations.length">0</span> RECORD<span ng-if="vm.totalDealersCount !== 1">S</span></div></div></div></div><div ng-hide="vm.isOnlyDealerAdmin" class="flex-percent-20 text-right pad-left-15 override-xs-side-padding-none flex-xs-percent-100 override-xs-margin-top-md override-xs-text-left hidden-sm hidden-xs"><a ui-sref="location-add" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass">+ NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="location-table-wrapper"><table class="table table-hover searchable-list table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll-container="\'#location-table-wrapper\'" ng-mousemove="vm.removeSelectedId()" infinite-scroll-distance="1" infinite-scroll="vm.searchLocations()" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore"><thead class="hidden-xs"><tr><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.status)" class="cursor-pointer">Status <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.status ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.program)" class="cursor-pointer">Program <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.program ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.name)" class="cursor-pointer">Name <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.name ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.location)" class="cursor-pointer">Location <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.location ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.oem)" class="cursor-pointer hidden-md-down">OEM ID <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.oem ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.id)" class="cursor-pointer">ID <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.status ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.dms)" class="cursor-pointer hidden-md-down">DMS <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.dms ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.timezone)" class="cursor-pointer hidden-md-down">Timezone <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.timezone ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th></tr></thead><tbody><tr ng-repeat="data in vm.filteredLocations | limitTo: vm.displayLimit" class="list-name" ui-sref="tab-general({locationId: data.id, tripTypeId: 0})"><td class="location-name status-col hidden-xs"><span class="label" ng-class="data.statusLabel">{{ ::data.statusText}}</span></td><td class="location-name"><span class="label status-col visible-xs" ng-class="data.statusLabel">{{ ::data.statusText}}</span> <span class="hidden-xs">{{ ::data.adminProgramName }}</span> <span class="visible-xs-block"><b>{{ ::data.name }}</b></span> <span class="visible-xs-inline">{{ ::data.city }}, {{ ::data.state }}</span></td><td class="location-name hidden-xs">{{ ::data.name }}</td><td class="location-name hidden-xs">{{ ::data.city }}, {{ ::data.state }}</td><td class="location-name hidden-md-down">{{ ::data.oemDealerId }}</td><td class="location-name">{{ ::data.id }}</td><td class="location-name hidden-md-down">{{ ::data.dms }}</td><td class="location-name hidden-md-down">{{ ::data.timezoneId }}</td></tr></tbody></table><rc-list-standardized-footer record-count="vm.filteredLocations.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore"></rc-list-standardized-footer></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none font-size-14"><tags-input class="full-width" id="filter_search" name="item_search" placeholder="Keyword(s) to search" min-length="1" replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.locationTokenChanged()" on-tag-removed="vm.locationTokenChanged()"></tags-input></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top-md margin-top-sm"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="programFilter">SELECT A PROGRAM</label><select selectlabel="" class="form-control" name="programFilter" id="programFilter" ng-options="adminProgram for adminProgram in vm.adminPrograms" ng-model="vm.filters.selectedProgram" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="programFilter">SELECT A STATUS</label><select selectlabel="" class="form-control" name="statusFilter" id="statusFilter" ng-options="status for status in vm.statuses" ng-model="vm.filters.selectedStatus" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="timezoneFilter">SELECT A TIME ZONE</label><select selectlabel="" class="form-control" name="timezoneFilter" id="timezoneFilter" ng-options="timezone for timezone in vm.timezones" ng-model="vm.filters.selectedTimezone" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="countryFilter">SELECT A COUNTRY</label><select selectlabel="" class="form-control" name="countryFilter" id="countryFilter" ng-options="country for country in vm.countries" ng-model="vm.filters.selectedCountry" ng-change="vm.filterChanged()"></select></div></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/location/views/location-system-survey-management.view.html','<div class="display-flex flex-column full-height"><div class="modal-header padding-t-b-0"><h2 class="modal-title">Survey Details</h2><p>View and manage all system surveys. You can deactivate surveys that are no longer in use.</p></div><div class="modal-body overflow-y-auto"><div class="form-group"><div class="display-flex flex-xs-column"><div class="flex-grow margin-right-md"><select class="form-control" name="SurveyId" ng-model="vm.selectedSurveyObj" ng-change="vm.onSurveyChange()" ng-options="survey as (survey.name + (!survey.isActive ? \' (Inactive)\' : \'\')) for survey in vm.surveys track by survey.id"><option value="">Select Survey</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide venue-location-spinner" ng-show="vm.isLoading"></div><div class="flex-grow"><label class="checkbox-inline hours-checkbox padding-top-sm padding-left-25" ng-if="vm.canDeactivate && !vm.isLoading"><input type="checkbox" ng-model="vm.isDeactivated" ng-change="vm.toggleSurveyActive(vm.isDeactivated)"> Deactivate Survey</label></div></div></div><div class="padding-top-sm" ng-if="vm.selectedSurveyObj && vm.selectedSurveyObj.id"><h4 ng-if="!vm.isLoading">Survey Questions</h4><ol class="padding-left-20" ng-if="!vm.isLoading"><li ng-repeat="question in vm.surveyQuestions">{{question.question}}</li></ol><p ng-if="!vm.isLoading && (!vm.surveyQuestions || vm.surveyQuestions.length === 0)">No questions found for this survey.</p></div><div class="padding-top-md" ng-if="vm.selectedSurveyObj && vm.selectedSurveyObj.id && !vm.isLoading"><h4>Dealers With This Survey</h4><div class="form-group"><div ng-if="vm.dealerAssociations.length > 0"><ol class="padding-left-20"><li ng-repeat="dealer in vm.dealerAssociations">{{dealer.name}}</li></ol></div><div ng-if="vm.dealerAssociations.length === 0">No dealers found for this survey.</div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.close()">Close</button></div></div>');
$templateCache.put('app/areas/location/views/location-tab-advisors.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div ng-class="{\'padding-lg\': !vm.isManageMySchedule}" fill-height=""><form role="form" id="inputForm" name="inputForm" class="display-flex flex-column form-horizontal self-serve-form tab-advisors" ng-class="{\'padding-none\': vm.isManageMySchedule}" novalidate=""><div class="flex-percent-100 self-serve-only padding-none"><div class="modal-header padding-t-b-0 self-serve-only margin-bottom-md"><h2 class="modal-title padding-left-sm">Manage My Schedule</h2></div></div><div class="display-flex flex-column margin-left-sm margin-bottom" ng-class="{\'padding-top-md\': vm.isManageMySchedule, \'padding-left-lg\': vm.isManageMySchedule}"><div class="flex-percent-60 flex-xs-percent-75 field-wrapper max-width-px-300"><div ng-if="vm.resolvedLocationList && vm.resolvedLocationList.length > 0"><label for="selectedLocation">SELECT A LOCATION</label><select selectlabel="" class="form-control" id="selectedLocation" name="selectedLocation" allow-null-option="Select a location" ng-options="l as l.name for l in vm.resolvedLocationList track by l.id" ng-model="vm.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.loadingLocations"></select></div><div class="flex-percent-100" ng-if="vm.resolvedLocationList && vm.resolvedLocationList.length === 0"><h5>We\'re sorry, but you aren\'t associated with any dealers that have this feature enabled.</h5></div><div class="flex-percent-60 flex-xs-percent-75 max-width-px-300 field-wrapper" ng-if="vm.ctrlOptions.adminView"><label for="selectedAdvisor">SELECT AN ADVISOR</label><select selectlabel="" class="form-control" id="selectedAdvisor" name="selectedAdvisor" allow-null-option="Select an advisor" ng-options="adv as (adv.firstName + \' \' + adv.lastName + (adv.departmentIds.length > 1 ? \' *\' : \'\')) for adv in vm.advisors | orderBy:\'firstName\' track by adv.id" ng-model="vm.selectedAdvisor" ng-change="vm.selectedAdvisorChanged()" ng-disabled="vm.loadingLocations || !vm.selectedLocation"></select><div class="margin-top-sm" ng-if="vm.selectedAdvisor.departments">Assigned to <span ng-repeat="department in vm.selectedAdvisor.departments"><span class="text-danger cursor-pointer" ng-click="vm.gotoDept(department.id)">{{ department.name }}<span ng-if="!$last">, &nbsp</span></span></span></div><div class="margin-top-sm" ng-if="vm.selectedAdvisor && !vm.selectedAdvisor.departments">Advisor has not been assigned to a <span ng-class="{ \'text-danger cursor-pointer\' : vm.hasDeptAccess }" ng-click="vm.gotoDept()">Department</span></div></div></div><div class="margin-top text-danger text-justify" ng-if="!vm.isMappedAdvisor">This advisor must be mapped to an advisor in the DMS before they can be used.<br><br>If you have Dealer Admin access, this can be done on the User\u2019s Location tab in User Admin.<br><br>If you have any questions please reach out to our support team.</div><div ng-if="vm.getDepartmentAdvisorHoursError" class="text-danger">You are not set up in any departments at this location.</div><div ng-if="vm.selectedAdvisor && vm.isMappedAdvisor && (vm.selectedAdvisor.departmentId || vm.selectedAdvisor.departments)"><h3 class="margin-top-30">{{vm.ctrlOptions.adminView ? \'Advisor \' : \'\'}}Hours</h3><p>Select the department to use for the Advisor\'s hours, or select \'Custom\' to create an individualized schedule for this advsior.</p><hr class="margin-top-none margin-bottom"><div class="margin-bottom-20"><div class="flex-percent-60 max-width-px-300 field-wrapper"><label for="selectedDepartment">Select advisor hrs dept</label><select selectlabel="" class="form-control" id="selectedDepartment" name="selectedDepartment" allow-null-option="Select advisor hrs dept" ng-options="department.id as department.name for department in vm.departments" ng-model="vm.currentAdvisor.departmentId" ng-change="vm.selectedDepartmentChanged()" ng-disabled="vm.loadingLocations || !vm.selectedLocation"></select></div></div><div class="display-flex row content-center margin-bottom-20" ng-repeat="daySchedule in vm.currentAdvisor.schedule"><div class="flex-width-70 text-right padding-top-sm margin-right-md margin-left-md"><label class="hidden-xs" for="{{vm.myUniqueId}}-daylabel-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}">{{vm.daysOfWeek[daySchedule.dayOfWeek]}}</label> <label class="visible-xs text-capitalize">{{vm.shortDaysOfWeek[$index].toLowerCase()}}</label></div><div class="flex-width-120 field-wrapper margin-right-sm"><label for="{{vm.myUniqueId}}-starttime-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}">START TIME</label><select selectlabel="" id="{{vm.myUniqueId}}-starttime-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}" name="{{vm.myUniqueId}}-starttime-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}" class="form-control" ng-model="daySchedule.startTime" ng-options="time.value as time.label for time in vm.hoursInDay" ng-disabled="daySchedule.isOff || vm.currentAdvisor.departmentId == null || vm.currentAdvisor.departmentId > 0" ng-change="vm.runStartEndTimeValidation(daySchedule.dayOfWeek)" validation="required:alt=Field is Required|custom: vm.validation.valStartEndTime(daySchedule, \'Start Time\'):alt=Start & End Time required"><option value="">Start time</option></select></div><div class="flex-width-50 padding-top-sm text-center">to</div><div class="flex-width-120 field-wrapper margin-right-sm margin-left-md"><label for="{{vm.myUniqueId}}-endtime-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}">END TIME</label><select selectlabel="" id="{{vm.myUniqueId}}-endtime-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}" name="{{vm.myUniqueId}}-endtime-{{vm.daysOfWeek[daySchedule.dayOfWeek]}}" class="form-control" ng-model="daySchedule.endTime" ng-options="time.value as time.label for time in vm.hoursInDay" ng-disabled="daySchedule.isOff || vm.currentAdvisor.departmentId == null || vm.currentAdvisor.departmentId > 0" ng-change="vm.runStartEndTimeValidation(daySchedule.dayOfWeek)" validation="required:alt=Field is Required|custom: vm.validation.valStartEndTime(daySchedule, \'End Time\'):alt=Start & End Time required"><option value="">End time</option></select></div><div class="flex-width-100"><label class="font-normal"><input type="checkbox" name="closed" ng-model="daySchedule.isOff" ng-change="vm.closedChanged(daySchedule)" ng-disabled="vm.currentAdvisor.departmentId == null || vm.currentAdvisor.departmentId > 0"><span class="padding-left-xs">Off</span></label></div></div></div></div><div class="display-flex row margin-bottom margin-left-sm margin-top-md" ng-if="vm.selectedAdvisor && vm.isMappedAdvisor && (vm.selectedAdvisor.departments || vm.selectedAdvisor.departmentId)" ng-class="{ \'padding-left-lg\': vm.isManageMySchedule}"><div class="flex-percent-80"><h3>Time Off</h3><p>Please enter any dates/times the advisor is off.</p><hr class="margin-top-md margin-bottom-md"><constraint definition-type="vm.constraintDefinitionType.advisorOff" on-add="vm.addAdvisorOffConstraint(constraint)"></constraint><div class="days-closed-constraint margin-top margin-bottom-md"><div class="display-flex flex-row" ng-repeat="constraint in vm.advisorOffConstraints | filter: { isDeleted: false } track by constraint.uid"><div class="flex-percent-50 margin-bottom-sm">{{vm.constraintToString(constraint)}}</div><div class="flex-percent-50 margin-bottom-sm"><a href="#" class="theme-link" ng-click="vm.deleteAdvisorOffConstraint(constraint)">DELETE</a></div></div></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="vm.close()">Close</button> <button type="submit" class="btn btn-primary" ng-click="vm.updateAdvisor()" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="inputForm.$invalid || !vm.locationId || !vm.currentAdvisor || !vm.isMappedAdvisor">Update</button></div></div></div></div><location-sub-menu ng-if="vm.dealerTripTypes" trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-api.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg" fill-height=""><h3>Dealer API Programs</h3><p>Allow Dealer to be accessible through Partner API Programs.</p><hr><form role="form" name="LocationEditForm" class="form" ng-submit="LocationEditForm.$valid && vm.updateLocation()" novalidate=""><div class="form-group"><div class="col-sm-10"><ui-select ng-model="vm.currentProgram" on-select="vm.programSelected($item, $model)"><ui-select-match placeholder="Select or search a Partner Program in the list...">{{ $select.selected.text }}</ui-select-match><ui-select-choices refresh="vm.programFilter($select.search)" refresh-delay="250" repeat="program in vm.programs | limitTo: vm.programDisplayLimit track by program.value"><div><span ng-bind-html="program.text | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-10"><div class="table-responsive overflow-visible"><table class="table table-hover"><thead><tr><th data-toggle="true" data-type="alpha"><span class="cursor-pointer hover-underline" popover-placement="right" uib-popover="The Partner Programs that will have access to this dealer." popover-trigger="outsideClick">Selected Program(s)</span></th><th class="col-sm-1">Remove</th></tr></thead><tbody><tr ng-repeat="program in vm.selectedPrograms" class="list-name"><td class="location-name">{{program.text}}</td><td class="text-center"><span class="fa fa-times-circle" ng-click="vm.removeProgram(program.value)"></span></td></tr></tbody></table></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" class="btn btn-primary" ng-click="vm.updateLocation()" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="LocationEditForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-booking.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg" id="location-form"><form role="form" name="inputForm" class="form booking-tab" ng-submit="vm.updateBooking(inputForm.$valid)" novalidate=""><h3>Booking Settings</h3><p>Manage the settings and configuration for {{ vm.currentTripType.name }}</p><hr><div class="form-group"><label class="col-sm-4 control-label">Active</label><div class="col-sm-4"><switch id="active" name="active" ng-model="vm.currentTripType.active" class="green"></switch></div></div><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.partsOnDemand"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable/Disable booking Parts OnDemand To/From Any Location." popover-trigger="outsideClick">Allow To/From Any Location</span></label><div class="col-sm-4"><switch id="enableToFromAnyLocation" name="enableToFromAnyLocation" ng-model="vm.specificConfigs.EnableToFromAnyLocation.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.lyftCredit"><label class="col-sm-4 control-label">Bulk Upload</label><div class="col-sm-4"><switch id="lyftcredit-bulkupload" name="lyftcredit-bulkupload" ng-model="vm.specificConfigs.EnableLyftBenefitBulkUpload.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.appointment"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Allow Booking Stand Alone Service Valet Trips outside of appointments" popover-trigger="outsideClick">Allow Booking Stand Alone Trips</span></label><div class="col-sm-4"><switch id="standalone" name="standalone" ng-model="vm.specificConfigs.AllowBookingStandAloneTrips.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.appointment"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Default to previous service advisor that the customer used on their last RO." popover-trigger="outsideClick">Default to Previous Service Advisor</span></label><div class="col-sm-4"><switch id="previous_advisor" name="previous_advisor" ng-model="vm.specificConfigs.DefaultToPreviousAdvisor.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.appointment"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="The default timeframe before the customer\'s vehicle is returned. This value is that same as Length of Loan on the Loaners General tab. Changing this value will also change the value on the Loaner product." popover-trigger="outsideClick">Default Promise Time Duration</span></label><div class="col-sm-1"><input id="promise-time-duration" required="" name="promise_time-duration" ng-model="vm.associatedConfigs.promiseTimeDuration" class="form-control no-spinners" type="number"></div></div><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.appointment"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Manage My Schedule menu item under self service for Service Advisors" popover-trigger="outsideClick">Enable Self Service Manage My Schedule</span></label><div class="col-sm-4"><switch id="manageMySchedule" name="manageMySchedule" ng-model="vm.specificConfigs.EnableManageMySchedule.value" class="green"></switch></div></div><div ng-if="vm.constSystemTripType.value !== vm.systemTripType.lyftCredit"><div class="form-group" ng-if="vm.constSystemTripType.value == vm.systemTripType.pickup || vm.constSystemTripType.value == vm.systemTripType.testdrives || vm.constSystemTripType.value == vm.systemTripType.deliverSoldVehicle"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Use this URL to access the consumer booking experience." popover-trigger="outsideClick">URL</span></label><div class="col-sm-4" ng-if="vm.constSystemTripType.value == vm.systemTripType.pickup || vm.constSystemTripType.value == vm.systemTripType.testdrives || vm.constSystemTripType.value == vm.systemTripType.deliverSoldVehicle"><p class="form-control-static">&lt;domain&gt;/book/{{ vm.locationId }}/v{{ vm.tripTypeId }}<div class="form-control-static" ng-if="vm.constSystemTripType.value == vm.systemTripType.testdrives && vm.specificConfigs.IsGeneric.value === true"><b>Note:</b> Querystring parameters for Year, Make, Model are required.</div><div class="form-control-static" ng-if="vm.constSystemTripType.value == vm.systemTripType.deliverSoldVehicle"><b>Note:</b> Querystring parameters for First Name, Last Name, Year, Make, Model, Vin and Stock Number are required.</div></p></div><div class="col-sm-6" ng-if="vm.constSystemTripType.value == vm.systemTripType.appointment"><p class="form-control-static">&lt;domain &gt;/consumer/appointment/{{ vm.locationId }}/</p></div></div><div ng-if="vm.constSystemTripType.value !== vm.systemTripType.appointment"><div class="form-group" ng-if="vm.displayServiceArea(inputForm);"><label for="ServiceAreaType" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Select the type of the service area." popover-trigger="outsideClick">Service Area Type</span></label><div class="col-sm-2"><select class="form-control" name="ServiceAreaType" ng-options="item.value.toString() as item.text for item in vm.serviceAreaTypes" ng-model="vm.commonConfigs.ServiceAreaType.value" ng-disabled="vm.fieldsDisabled"></select></div></div><div class="form-group" ng-if="vm.displayServiceArea(inputForm)"><label for="ServiceAreaData" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s service area radius in kilometers. Customer locations outside of this radius are not serviceable." popover-trigger="outsideClick">Service Area Radius</span></label><div class="col-sm-2" ng-if="!vm.commonConfigs.ServiceAreaType.value || vm.commonConfigs.ServiceAreaType.value == 1"><input type="text" id="ServiceAreaData" name="ServiceAreaData" ng-model="vm.commonConfigs.ServiceAreaData.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|numeric"> (kilometers)</div><div class="col-sm-6" ng-if="vm.commonConfigs.ServiceAreaType.value && vm.commonConfigs.ServiceAreaType.value == 2"><textarea id="ServiceAreaData" name="ServiceAreaData" ng-model="vm.commonConfigs.ServiceAreaData.value" ng-disabled="vm.fieldsDisabled" class="form-control resize-none" validation="required:alt=Field is required."></textarea> (list of latitude/longitudes)</div></div><div class="form-group" ng-if="vm.constSystemTripType.supportsLyftAPI"><label for="costDeviation" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the maximum allowable deviation between estimated cost and actual cost" popover-trigger="outsideClick">Cost Deviation %</span></label><div class="col-sm-2"><input type="number" min="0" id="costDeviation" name="costDeviation" ng-model="vm.commonConfigs.ChargePercentThreshold.value" ng-disabled="vm.fieldsDisabled" class="form-control no-spinners" required=""> (percentage)<div ng-if="vm.isEmpty(vm.commonConfigs.ChargePercentThreshold.value)" class="validation text-danger">Field is required.<br>Must be 0 or greater.</div></div></div><div class="form-group" ng-if="vm.constSystemTripType.supportsLyftAPI && vm.constSystemTripType.value != vm.systemTripType.lyftDriverReturn"><label for="spendingCap" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the maximum amount that can be spent on this trip type per month. Cannot be a negative number." popover-trigger="outsideClick">Monthly Spending Cap</span></label><div class="col-sm-2"><input type="number" min="0" id="spendingCap" name="spendingCap" ng-model="vm.commonConfigs.MonthlySpendingCap.value" ng-disabled="vm.fieldsDisabled" class="form-control no-spinners" clean="true"> (dollars)</div></div><div ng-if="vm.isMobileGarage() === false" class="margin-top-30"><div class="form-group"><label for="ChargeConfigType" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Select the Charge Config." popover-trigger="outsideClick">Charge Config</span></label><div class="col-sm-4"><select class="form-control" name="ChargeConfigType" ng-options="item.value.toString() as item.text for item in vm.chargeConfigTypes" ng-model="vm.commonConfigs.ChargeConfigId.value"></select></div></div></div><div ng-if="!vm.constSystemTripType.supportsLyftAPI"><div ng-if="vm.isMobileGarage() === false"><div class="form-group"><label for="customerCharge" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the customer charge rate per hour" popover-trigger="outsideClick">Customer Charge Per Hour</span></label><div class="col-sm-2"><input type="text" id="customerCharge" name="customerCharge" ng-model="vm.CustomerChargeRatePerHour" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (dollars)</div></div><div class="form-group"><label for="customertimeBasedMinimum" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter minimum time in minutes if exists" popover-trigger="outsideClick">Customer Minimum Time</span></label><div class="col-sm-2"><input type="text" id="customertimeBasedMinimum" name="customertimeBasedMinimum" ng-model="vm.commonConfigs.CustomerTimeBasedMinimumThreshold.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (minutes)</div></div><div class="form-group"><label for="customerMinimum" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the customer charge minimum" popover-trigger="outsideClick">Customer Charge Minimum</span></label><div class="col-sm-2"><input type="text" id="customerMinimum" name="customerMinimum" ng-model="vm.commonConfigs.CustomerChargeMinimum.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (dollars)</div></div><div class="form-group margin-bottom-30"><label for="serviceFeePercent" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the service fee to be applied on the trip time cost" popover-trigger="outsideClick">Service Fee Percent</span></label><div class="col-sm-2"><input type="text" id="serviceFeePercent" name="serviceFeePercent" ng-model="vm.commonConfigs.ServiceFeePercent.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (percent)</div></div><div class="margin-top-30"><div class="form-group"><label for="DriverPayConfigType" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Select the Driver Pay Config." popover-trigger="outsideClick">Driver Pay Config</span></label><div class="col-sm-4"><select class="form-control" name="DriverPayConfigType" ng-options="item.value.toString() as item.text for item in vm.chargeConfigTypes" ng-model="vm.commonConfigs.DriverPayConfigId.value"></select></div></div></div><div class="form-group"><label for="driverPay" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver pay rate per hour" popover-trigger="outsideClick">Driver Pay Per Hour</span></label><div class="col-sm-2"><input type="text" id="driverPay" name="driverPay" ng-model="vm.DriverPayRatePerHour" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (dollars)</div></div><div class="form-group"><label for="drivertimeBasedMinimum" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter minimum time in minutes if exists" popover-trigger="outsideClick">Driver Minimum Time</span></label><div class="col-sm-2"><input type="text" id="drivertimeBasedMinimum" name="drivertimeBasedMinimum" ng-model="vm.commonConfigs.DriverTimeBasedMinimumThreshold.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (minutes)</div></div><div class="form-group margin-bottom-30"><label for="driverMinimum" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the driver pay minimum" popover-trigger="outsideClick">Driver Pay Minimum</span></label><div class="col-sm-2"><input type="text" id="driverMinimum" name="driverMinimum" ng-model="vm.commonConfigs.DriverPayMinimum.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (dollars)</div></div><div class="form-group margin-bottom-30"><label for="cancelFee" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the fee for a cancelled trip. Leave blank or enter 0 to apply the minimum charge instead." popover-trigger="outsideClick">Cancel Fee</span></label><div class="col-sm-2"><input type="text" id="cancelFee" name="cancelFee" ng-model="vm.commonConfigs.CancelFee.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="numeric"> (dollars)</div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Use Actual trip times (instead of estimates) for billing calculations" popover-trigger="outsideClick">Use Actual Trip Times for Billing</span></label><div class="col-sm-7"><switch id="UseActualTripTimes" name="UseActualTripTimes" ng-model="vm.commonConfigs.UseActualTimesForBilling.value" class="green"></switch></div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Allow driver to skip to \'At Dealership\' if near Dealer" popover-trigger="outsideClick">Allow Skip-to "At Dealer"</span></label><div class="col-sm-7"><switch id="SkipWorkflowToDealer" name="SkipWorkflowToDealer" ng-model="vm.commonConfigs.SkipWorkflowToDealer.value" class="green"></switch></div></div></div></div><div ng-if="vm.isMobileGarage() === false"><div class="form-group"><label for="VenueLocation" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose a specific location pickups and dropoffs" popover-trigger="outsideClick">Pickup/Dropoff Location</span></label><div class="col-sm-3" ng-if="vm.dealerVenues && vm.dealerVenues.length > 0"><select class="form-control" name="VenueLocation" ng-options="venue.id.toString() as venue.name for venue in vm.dealerVenues" ng-model="vm.commonConfigs.DefaultVenueId.value"><option value=""></option></select></div><div class="col-sm-2 margin-top-md"><a href="#" class="theme-link" ng-click="vm.manageVenues()">Manage Locations</a></div></div><div class="form-group form-inline" ng-if="vm.specificConfigs.PreventLateAtNightForEarlyBooking !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Prevent booking trips before 11 AM the next day after 8 PM the previous day." popover-trigger="outsideClick">Prevent Booking Trips Before 11AM after 8PM.</span></label><div class="col-sm-7"><switch id="PreventLateAtNightForEarlyBooking" name="PreventLateAtNightForEarlyBooking" ng-model="vm.specificConfigs.PreventLateAtNightForEarlyBooking.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.specificConfigs.AppointmentBookingConfig !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="For Appointment, choose how the pick up time should be tied to the appointment time." popover-trigger="outsideClick">Booking Window</span></label><div class="col-sm-2"><select class="form-control" name="BookingWindows" ng-options="item.value.toString() as item.text for item in vm.bookingWindows" ng-model="vm.specificConfigs.AppointmentBookingConfig.value" ng-disabled="vm.fieldsDisabled" validation="required|in:{{vm.validation.acceptableBookingWindows}}:alt=Field is required."></select></div></div><div class="form-group" ng-if="vm.specificConfigs.MinutesBeforeAppointmentTimeToDenyBooking !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="For Appointments, choose how the pick up time should be tied to the appointment time." popover-trigger="outsideClick">Booking Date Buffer</span></label><div class="col-sm-2"><input type="text" name="MinutesBeforeAppointmentTimeToDenyBooking" id="MinutesBeforeAppointmentTimeToDenyBooking" ng-model="vm.specificConfigs.MinutesBeforeAppointmentTimeToDenyBooking.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|numeric"> (minutes)</div></div></div><div class="form-group" ng-if="vm.specificConfigs.DefaultServiceAdvisorId !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable for test drive trips, a valid user must be assigned." popover-trigger="outsideClick">Default User ID</span></label><div class="col-sm-2"><select data-placeholder-text-single="\'Select employee...\'" class="form-control" name="DefaultServiceAdvisor" chosen="{width: \'100%\'}" search-contains="true" max-shown-results="100" ng-model="vm.specificConfigs.DefaultServiceAdvisorId.value" ng-options="employee.id as employee.fullName for employee in vm.resolvedEmployees" validation="required:alt=Field is required."><option value=""></option></select></div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Allow the service advisors to bypass booking rules when booking a trip." popover-trigger="outsideClick">Bypass Booking Rules</span></label><div class="col-sm-7"><switch id="EnableBypassBookingRules" name="EnableBypassBookingRules" ng-model="vm.commonConfigs.EnableBypassBookingRules.value" class="green"></switch></div></div><div class="form-group form-inline" ng-if="vm.specificConfigs.AllowDealerLocationManagement !== undefined && (vm.constSystemTripType.value == vm.systemTripType.dealerTrade || vm.constSystemTripType.value == vm.systemTripType.inventoryTransport)"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Dealer can manage inventory locations in their to/from drop downs." popover-trigger="outsideClick">Dealer Can Manage Inventory Locations</span></label><div class="col-sm-7"><switch id="AllowDealerLocationManagement" name="AllowDealerLocationManagement" ng-model="vm.specificConfigs.AllowDealerLocationManagement.value" class="green"></switch></div></div><div class="form-group form-inline" ng-if="vm.specificConfigs.DefaultNoLoanerStartAtDealer !== undefined && vm.isMobileGarage() === false"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Options for first stop when there is no loaner involved in the trip." popover-trigger="outsideClick">No Loaner 1st Stop Options</span></label><div class="col-sm-7"><select class="form-control" name="firstStopOptions" ng-options="item.value as item.text for item in vm.noLoanerFirstStopOptions" ng-model="vm.selectedFirstOption" validation="required:alt=Field is required"></select></div></div><div class="form-group form-inline" ng-if="!vm.constSystemTripType.supportsLyftAPI"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Allow Drivers To Start Trips Early." popover-trigger="outsideClick">Allow Drivers To Start Trips Early</span></label><div class="col-sm-7"><switch id="DefaultCanAccessEarly" name="DefaultCanAccessEarly" ng-model="vm.commonConfigs.DefaultCanAccessEarly.value" class="green"></switch></div></div><div ng-if="vm.constSystemTripType.lyft"><div class="form-group" ng-if="vm.constSystemTripType.lyft.supportsRideTypes" ng-repeat="rideType in vm.providerRideTypes"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Show {{rideType.name}} rides" popover-trigger="outsideClick">Show {{rideType.name}} rides</span></label><div class="col-sm-7"><switch id="hidelyft{{rideType.value}}" name="hidelyft{{rideType.value}}" ng-model="vm.lyftRideSettings[$index].value" class="green"></switch></div></div></div><div class="form-group form-inline" ng-if="vm.specificConfigs.SuppressVehicleVIN !== undefined && vm.constSystemTripType.value != vm.systemTripType.dealerTrade"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Require the vehicle VIN number to be entered." popover-trigger="outsideClick">Vehicle VIN<br><span class="font-normal">(Dashboard Only)</span></span></label><div class="col-sm-7"><switch id="SuppressVehicleVIN" name="SuppressVehicleVIN" ng-model="vm.suppressConfigsSwitch.vehicleVIN" class="green"></switch></div></div><div ng-if="!vm.constSystemTripType.supportsLyftAPI && vm.isMobileGarage() === false"><div class="form-group" ng-if="vm.commonConfigs.TripCutoffMinutes !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the amount of time to buffer before the earliest available time." popover-trigger="outsideClick">Pick Up Buffer</span></label><div class="col-sm-2"><input type="text" id="TripCutoffMinutes" name="TripCutoffMinutes" ng-model="vm.commonConfigs.TripCutoffMinutes.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|numeric"> (minutes)</div></div><div class="form-group" ng-if="vm.commonConfigs.DealerLocationMinutesStart !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the average amount of time a driver should spend at the dealership at the start of the trip. This time is added to the total trip time." popover-trigger="outsideClick">Driver Time At Dealership - Start</span></label><div class="col-sm-2"><input type="text" id="DealerLocationMinutesStart" name="DealerLocationMinutesStart" ng-model="vm.commonConfigs.DealerLocationMinutesStart.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|numeric"> (minutes)</div></div><div class="form-group" ng-if="vm.commonConfigs.DealerLocationMinutesEnd !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the average amount of time a driver should spend at the dealership at then end of the trip. This time is added to the total trip time." popover-trigger="outsideClick">Driver Time At Dealership - End<br><span class="font-normal">(For round trips)</span></span></label><div class="col-sm-2"><input type="text" id="DealerLocationMinutesEnd" name="DealerLocationMinutesEnd" ng-model="vm.commonConfigs.DealerLocationMinutesEnd.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|numeric"> (minutes)</div></div><div class="form-group" ng-if="vm.displayDriverTimeWithCustomer()"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the average amount of time a driver should spend with the customer. This time is added to the total trip time." popover-trigger="outsideClick">Driver Time With Customer</span></label><div class="col-sm-2"><input type="text" id="CustomerLocationMinutes" name="CustomerLocationMinutes" ng-model="vm.commonConfigs.CustomerLocationMinutes.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|numeric"> (minutes)</div></div></div><div class="form-group" ng-if="vm.commonConfigs.VehicleModelId !== undefined && vm.currentTripType.systemTripTypeId === vm.systemTripType.testdrives && vm.specificConfigs.IsGeneric.value != true"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose the model assigned to this trip type experience." popover-trigger="outsideClick">Vehicle Model</span></label><div class="col-sm-2"><select class="form-control" name="VehicleModelId" ng-options="item.modelId.toString() as item.title for item in vm.vehicleMakesModels" ng-model="vm.commonConfigs.VehicleModelId.value" ng-disabled="vm.fieldsDisabled" allow-null-option="None"></select></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the email address(es) that will receive copies of the customer survey submissions." popover-trigger="outsideClick">Survey Recipient(s)</span></label><div class="col-sm-4"><ui-select id="surveyRecipient" multiple="" ng-model="vm.EmailSurveyListMap"><ui-select-match placeholder="Select employee(s)...">{{$item.fullName}}</ui-select-match><ui-select-choices repeat="employee.id as employee in vm.resolvedEmployees | propsFilter: {fullName: $select.search}"><div ng-bind-html="employee.fullName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group" ng-if="vm.constSystemTripType.value === vm.systemTripType.lyftShuttleService"><label for="write_sod_price_to_ro" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Writes customer SOD trip cost to the RO" popover-trigger="outsideClick">Write SOD Cost to RO</span></label><div class="col-sm-2"><switch id="write_sod_price_to_ro" name="write_sod_price_to_ro" ng-model="vm.specificConfigs.WriteSodTripCostToRo.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.constSystemTripType.value === vm.systemTripType.lyftShuttleService && vm.specificConfigs.WriteSodTripCostToRo.value"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Search dealer opcodes to autofill fields" popover-trigger="outsideClick">OpCode for SOD Line on RO</span></label><div class="col-sm-4"><select select2="" id="booking-opcode-search" name="booking-opcode-search" on-change="vm.opCodeSearchSelected(selectedResult)" init-value="vm.sodTripOpCode" placeholder="Search OpCode" min-input-length="1" format-for-selection="vm.formatForSelection" format-for-dropdown="vm.formatForDropdown" query="vm.opCodeSearchQuery" ng-model="vm.sodTripOpCode"></select></div></div><div class="form-group" ng-if="vm.currentTripType.supportsInvites == true && !vm.constSystemTripType.supportsLyftAPI"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose how many hours to wait until a text message or email invitation expires. Customers will not be able to book a ride past the expiration." popover-trigger="outsideClick">Invite Expiration<span class="font-normal"></span></span></label><div class="col-sm-2"><select class="form-control" name="InviteExpirationMinutes" ng-options="(item*60).toString() as item for item in vm.inviteHours" ng-model="vm.commonConfigs.InviteExpirationMinutes.value" validation="required|in_list:{{ vm.validation.acceptableMinutes }}:alt=Please select an item from the list"></select>(hours)</div><div class="col-sm-2" style="padding-top:10px">{{ vm.showConvertedMinutes(vm.commonConfigs.InviteExpirationMinutes) }}</div></div><div class="form-group" ng-if="vm.currentTripType.supportsInvites == true && vm.constSystemTripType.supportsLyftAPI"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose how many hours to wait until a text message or email invitation expires. Customers will not be able to book a ride past the expiration." popover-trigger="outsideClick">Invite Expiration</span></label><div class="col-sm-2"><select class="form-control" name="LyftInviteExpirationHours" ng-options="item.toString() as item for item in vm.lyftHours" ng-model="vm.commonConfigs.LyftInviteExpirationHours.value" validation="required|alt=Please select an item from the list"></select><span class="help-block margin-bottom-none">(select 0 for no expiration)</span></div><div class="col-sm-2" style="padding-top:10px">{{ vm.showConvertedHours(vm.commonConfigs.LyftInviteExpirationHours) }}</div></div><div class="form-group" ng-if="vm.constSystemTripType.supportsLyftAPI"><label for="costDeviation" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Show Cost and Surge in DriverQ" popover-trigger="outsideClick">Show Cost in DriverQ</span></label><div class="col-sm-2"><switch id="show_driverq_price" name="show_driverq_price" ng-model="vm.specificConfigs.ShowDriverRidePriceSurge.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.commonConfigs.DispatchNumber !== undefined && !vm.constSystemTripType.supportsLyftAPI"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dispatch number to display in the driver app. Most trips should be set to: 7863528600" popover-trigger="outsideClick">Dispatch Number</span></label><div class="col-sm-2"><input type="text" mask-restrict="reject" mask="(999) 999-9999" id="DispatchNumber" name="DispatchNumber" ng-model="vm.commonConfigs.DispatchNumber.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|custom:vm.validation.phone(vm.commonConfigs.DispatchNumber.value)"></div></div><div ng-if="!vm.constSystemTripType.supportsLyftAPI"><div ng-if="vm.specificConfigs.AllowCustomerToEditTrips !== undefined || vm.specificConfigs.ConsumerPageDisplayHasLoaner !== undefined || vm.specificConfigs.ConsumerPageDefaultHasLoanerSelection !== undefined"><h3 class="margin-top-30">Consumer Booking Specific</h3><p>Manage the settings and configurations for consumer booking pages</p><hr></div><div class="form-group" ng-if="vm.specificConfigs.AllowCustomerToEditTrips !== undefined && vm.constSystemTripType.value !== vm.systemTripType.dealerTrade && vm.constSystemTripType.value !== vm.systemTripType.inventoryTransport"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Allow customers to edit trips once they have booked them." popover-trigger="outsideClick">Can <span ng-if="vm.constSystemTripType.value !== vm.systemTripType.mobileGarage">Book, Edit, and</span>Cancel Trips</span></label><div class="col-sm-7"><switch id="AllowCustomerToEditTrips" name="AllowCustomerToEditTrips" ng-model="vm.specificConfigs.AllowCustomerToEditTrips.value" class="green"></switch></div></div><div ng-if="vm.constSystemTripType.value !== vm.systemTripType.mobileGarage"><div class="form-group" ng-if="vm.specificConfigs.ConsumerPageDisplayHasLoaner !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Display the Has Loaner question options on the Consumer Booking Pages." popover-trigger="outsideClick">Display Has Loaner Section</span></label><div class="col-sm-7"><switch id="ConsumerPageDisplayHasLoaner" name="ConsumerPageDisplayHasLoaner" ng-model="vm.specificConfigs.ConsumerPageDisplayHasLoaner.value" class="green"></switch></div></div><div class="form-group form-inline" ng-if="vm.specificConfigs.SuppressChooseLoanerOptions !== undefined"><div class="col-sm-4 control-label"><label><span class="cursor-pointer hover-underline" uib-popover="Display the Has Loaner question options on the Consumer Booking Pages." popover-trigger="outsideClick">Display Has Loaner Section</span></label><br><span class="error danger normal">Verify verbiage on page before<br>changing this setting</span></div><div class="col-sm-7"><switch id="SuppressChooseLoanerOptions" name="SuppressChooseLoanerOptions" ng-model="vm.suppressConfigsSwitch.chooseLoanerOptions" class="green"></switch></div></div><div class="form-group" ng-if="vm.specificConfigs.HasLoanerDefault !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Default has loaner selection on consumer booking pages. If has loaner section is not displayed, value will default to this selection." popover-trigger="outsideClick">Default "I Need A Loaner" to "Yes"</span></label><div class="col-sm-7"><switch id="HasLoanerDefault" name="HasLoanerDefault" ng-model="vm.specificConfigs.HasLoanerDefault.value" class="green"></switch></div></div><div class="form-group" ng-if="vm.specificConfigs.EnableConsumerLandingPage !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable A/B Landing Page - Make and appointment or come get my vehicle." popover-trigger="outsideClick">Enable A/B Landing Page<br><span class="font-normal">(In Store Appt vs. Get My Vehicle)</span></span></label><div class="col-sm-7"><switch id="EnableConsumerLandingPage" name="EnableConsumerLandingPage" ng-model="vm.specificConfigs.EnableConsumerLandingPage.value" class="green"></switch><div class="switch-note inline">Note: This can also be turned on via query string parameter (?landing=1).</div></div></div><div class="form-group" ng-if="vm.specificConfigs.LandingPageSecondChoiceURL !== undefined"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the URL to use for the dealer\'s Appointment Scheduling page" popover-trigger="outsideClick">Dealer\'s Appointment Scheduling URL</span></label><div class="col-sm-3"><input type="text" id="LandingPageSecondChoiceURL" name="LandingPageSecondChoiceURL" ng-model="vm.specificConfigs.LandingPageSecondChoiceURL.value" ng-disabled="vm.fieldsDisabled" class="form-control" validation="custom:vm.validation.url(vm.specificConfigs.LandingPageSecondChoiceURL.value):alt=*"></div></div></div></div></div></div><div ng-if="vm.constSystemTripType.value === vm.systemTripType.appointment"><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Allow the service advisors to bypass booking rules when booking a Service Valet Pick Up trip through Appointments. This setting uses the same setting as the \'Service Pick Up No Service Order\' service valet setting." popover-trigger="outsideClick">Bypass Booking Rules</span></label><div class="col-sm-7"><switch id="EnableBypassBookingRules" name="EnableBypassBookingRules" ng-model="vm.associatedConfigs.enableBypassBookingRules" class="green"></switch></div></div><div class="form-group margin-bottom" ng-if="vm.loadingSelectedDepartment === false"><label for="apptConsumerBookingDepartment" class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Select the department that will be used for consumer pages, imports, and initial load of dashboard booking." popover-trigger="outsideClick">Default Department</span></label><div class="col-sm-4 field-wrapper"><label for="selectedDepartment">DEFAULT DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0" name="apptConsumerBookingDepartment" class="form-control" ng-model="vm.selectedDepartment" ng-options="dept as dept.name for dept in vm.dealerDepartments track by dept.id" ng-change="vm.departmentSelected()"><option value="">Default department</option></select><div ng-if="!vm.selectedDepartment" class="text-danger text-uppercase">Consumer page will not work until this is set!</div><div ng-if="!vm.dealerDepartments || vm.dealerDepartments.length === 0" class="text-danger">Departments have not been configured.<br>Please configure your departments in the department tab.</div></div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="If enabled, this setting will determine how many days after an appointment is booked that is will be marked as a no show if the customer does not check in." popover-trigger="outsideClick">Mark No Shows After Specified Days</span></label><div class="col-sm-7"><switch id="AutomaticallyMarkAppointmentsAsNoShow" name="AutomaticallyMarkAppointmentsAsNoShow" ng-model="vm.specificConfigs.AutomaticallyMarkAppointmentsAsNoShow.value" class="green"></switch></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.AutomaticallyMarkAppointmentsAsNoShow.value"><label class="col-sm-4 control-label"># of Days</label><div class="col-sm-1 margin-bottom"><input type="text" validation="between_num:1,100:alt=Required<br/>(1-100)" name="AppointmentsNoShowAfterDays" ng-model="vm.specificConfigs.AppointmentsNoShowAfterDays.value" class="form-control" required=""></div></div><h3 class="margin-top-30">Consumer Booking Specific</h3><p>Manage the settings and configurations for consumer booking pages</p><hr><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Use this URL to access the consumer booking experience." popover-trigger="outsideClick">URL</span></label><div class="col-sm-6" ng-if="vm.constSystemTripType.value == vm.systemTripType.appointment"><p class="form-control-static">&lt;domain &gt;/consumer/appointment/{{ vm.locationId }}/</p></div></div><div class="form-group margin-bottom"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Use this URL to access the consumer booking experience." popover-trigger="outsideClick">Booking Experience</span></label><div class="col-sm-6 margin-bottom"><label class="radio-inline font-size-11"><input type="radio" name="booking-experience" value="{{vm.consumer_appt_booking_exp.standard}}" ng-model="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value"> <span class="add-participant-radio-label">Single Department (Classic)</span></label> <label class="radio-inline font-size-11"><input type="radio" name="booking-experience" value="{{vm.consumer_appt_booking_exp.multipleDepartments}}" ng-model="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value"> <span class="add-participant-radio-label">Multiple Departments</span></label> <label class="radio-inline font-size-11"><input type="radio" name="booking-experience" value="{{vm.consumer_appt_booking_exp.ghostGarage}}" ng-model="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value"> <span class="add-participant-radio-label">Ghost Garage</span></label></div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Display a map or banner image in the consumer booking header." popover-trigger="outsideClick">Show Map Instead of Banner on Mobile</span></label><div class="col-sm-7"><switch id="ShowMapOnMobile" name="ShowMapOnMobile" ng-model="vm.specificConfigs.ConsumerMobileDisplayMap.value" class="green"></switch></div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Hide map when framed in." popover-trigger="outsideClick">Hide Map in Header When Framed in</span></label><div class="col-sm-7"><switch id="FramedInHideMap" name="FramedInHideMap" ng-model="vm.specificConfigs.FramedInHideMap.value" class="green"></switch></div></div><div class="form-group form-inline"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Display price in consumer screens." popover-trigger="outsideClick">Display Price in Consumer Screens</span></label><div class="col-sm-7"><switch id="DisplayConsumerPrices" name="DisplayConsumerPrices" ng-model="vm.specificConfigs.DisplayConsumerPrices.value" class="green"></switch></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value != vm.consumer_appt_booking_exp.ghostGarage"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Title of other services on consumer booking page." popover-trigger="outsideClick">Consumer Other Services Title</span></label><div class="col-sm-2 margin-bottom"><input type="text" id="ApptConsumerOtherServicesTitle" name="ApptConsumerOtherServicesTitle" ng-model="vm.specificConfigs.ApptConsumerOtherServicesTitle.value" ng-disabled="vm.fieldsDisabled" class="form-control"></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value == vm.consumer_appt_booking_exp.ghostGarage"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Title of other services on consumer booking page." popover-trigger="outsideClick">Consumer Services Title</span></label><div class="col-sm-2 margin-bottom"><input type="text" id="ApptAlternateConsumerServicesTitle" name="ApptAlternateConsumerServicesTitle" ng-model="vm.specificConfigs.ApptConsumerAlternateServicesTitle.value" ng-disabled="vm.fieldsDisabled" class="form-control"></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value != vm.consumer_appt_booking_exp.ghostGarage"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Title to display on the consumer landing page." popover-trigger="outsideClick">Landing Page Title</span></label><div class="col-sm-5 margin-bottom"><input type="text" id="LandingPageMobileTitle" name="LandingPageMobileTitle" placeholder="LANDING PAGE TITLE" ng-model="vm.specificConfigs.LandingPageMobileTitle.value" class="form-control text-uppercase"></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value != vm.consumer_appt_booking_exp.ghostGarage"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Optional description to display under title on consumer landing page." popover-trigger="outsideClick">Landing Page Verbiage</span></label><div class="col-sm-5 margin-bottom text-uppercase"><textarea id="LandingPageMobileDescription" name="LandingPageMobileDescription" ng-model="vm.specificConfigs.LandingPageMobileDescription.value" ng-disabled="vm.fieldsDisabled" placeholder="LANDING PAGE VERBIAGE" class="form-control resize-none"></textarea></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value == vm.consumer_appt_booking_exp.ghostGarage"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Title to display on the consumer landing page." popover-trigger="outsideClick">Landing Page Title</span></label><div class="col-sm-5 margin-bottom"><input type="text" id="LandingPageMobileTitle" name="LandingPageMobileTitle" placeholder="LANDING PAGE TITLE" ng-model="vm.specificConfigs.ApptConsumerAltBookingServicesTitle.value" class="form-control text-uppercase"></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value == vm.consumer_appt_booking_exp.ghostGarage"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Optional description to display under title on consumer landing page." popover-trigger="outsideClick">Landing Page Verbiage</span></label><div class="col-sm-5 margin-bottom text-uppercase"><textarea id="ApptConsumerAltBookingServicesParagraph" name="ApptConsumerAltBookingServicesParagraph" ng-model="vm.specificConfigs.ApptConsumerAltBookingServicesParagraph.value" rows="5" ng-disabled="vm.fieldsDisabled" class="form-control resize-none" placeholder="LANDING PAGE VERBIAGE"></textarea></div></div><div class="form-group margin-bottom" ng-if="vm.specificConfigs.ApptConsumerBookingExperienceMethod.value == vm.consumer_appt_booking_exp.multipleDepartments"><label class="col-sm-4 control-label margin-top-md"><span class="cursor-pointer hover-underline" uib-popover="All departments are listed here. If the switch is enabled, the department will be displayed on the consumer landing page. Rank will determine which order the departments are displayed in on the consumer landing page. Title and description are optional fields which will display on the consumer landing page. Note: if no departments have been configured to be shown in consumer, your default department will be displayed in consumer." popover-trigger="outsideClick">Department Order And Details</span></label><div class="col-sm-5 margin-bottom text-uppercase"><div ng-if="vm.loadingDepartments" class="padding-md"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> LOADING</span></div><department-landingpage-settings ng-if="!vm.loadingDepartments && vm.orderedDepartments" ng-repeat="dept in vm.orderedDepartments | filter: {isDisabled: false}" ng-model="dept" index="$index"></department-landingpage-settings></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.updateBooking(inputForm.$valid)" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-capacity.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg" fill-height=""><h3>Driver Capacity Settings</h3><p>Please enter driver capacity per day of the week.<span ng-if="vm.isOnlyDealerAdmin"><br><br><span class="text-danger">If you need to make a change, please contact customer support.</span></span></p><hr><form role="form" id="vm.inputForm" name="vm.inputForm" class="form-horizontal" ng-submit="vm.updateCapacities()" novalidate=""><div><div class="col-sm-11 row form-group"><div class="col-sm-3 col-xs-1"></div><div class="col-sm-3 col-xs-3 text-center" ng-repeat="tripTypeGroup in vm.tripTypeGroupings"><label class="control-label"><span>{{tripTypeGroup.name}}</span></label></div></div><div class="col-sm-11 row form-group" ng-repeat="capacityGroup in vm.tripCapacities"><label class="control-label col-sm-3 col-xs-12"><span>{{capacityGroup.dayOfWeek}}</span></label><div class="col-sm-3 col-xs-4 text-center" ng-repeat="capacity in capacityGroup.capacities"><input type="number" name="{{capacityGroup.dayOfWeek}}-{{capacity.tripTypeGroupDescription}}-Capacity" ng-disabled="vm.isOnlyDealerAdmin" class="form-control no-spinners" placeholder="Unlimited" ng-model="capacity.capacity" validation="custom:vm.validateNumber(capacity.capacity):alt=*"></div></div><div class="col-sm-11 row form-group text-danger"><div class="col-sm-3"></div><div class="col-sm-8">NOTE existing capacity settings for selected locations will be replaced with the group settings. This cannot be undone without manually updating each dealer individually.</div></div><div class="col-sm-11 row form-group"><div class="col-lg-3 hidden-xs hidden-sm hidden-md"></div><div class="col-sm-3 col-md-3 hidden-xs hidden-lg" ng-repeat-start="tripTypeGroup in vm.tripTypeGroupings"></div><div class="col-sm-9 col-md-9 col-lg-3 col-xs-12 text-center" ng-repeat-end="tripTypeGroup in vm.tripTypeGroupings"><label class="control-label"><div class="margin-bottom">{{tripTypeGroup.name}} Grouping</div></label><ui-select ng-model="vm.selectedLocation[tripTypeGroup.id]" class="margin-bottom" on-select="vm.locationSelected($item, tripTypeGroup.id)" ng-disabled="vm.isOnlyDealerAdmin"><ui-select-match placeholder="SEARCH LOCATION">{{ $select.selected.name }}</ui-select-match><ui-select-choices refresh="vm.locationsFilter($select.search)" refresh-delay="250" repeat="location in vm.locations | limitTo: vm.locationDisplayLimit track by location.id"><div><span ng-bind-html="location.name | highlight: $select.search"></span></div></ui-select-choices></ui-select><table class="table table-hover"><thead><tr><th>Selected Location(s)</th><th ng-if="!vm.isOnlyDealerAdmin">Remove</th></tr></thead><tbody ng-if="(vm.dealerCapacityGroups|filter:{tripTypeGroup:tripTypeGroup.id}).length > 0"><tr ng-repeat="groupLocation in vm.dealerCapacityGroups|filter:{tripTypeGroup:tripTypeGroup.id}"><td class="text-left">{{ groupLocation.name }}</td><td ng-if="!vm.isOnlyDealerAdmin" class="text-center"><span class="fa fa-times-circle cursor-pointer" ng-click="vm.removeLocation(groupLocation)"></span></td></tr></tbody><tbody ng-if="(vm.dealerCapacityGroups|filter:{tripTypeGroup:tripTypeGroup.id}).length == 0"><tr><td colspan="2">No groupings found</td></tr></tbody></table></div></div></div><input type="text" name="allDaysClosedValidator" ng-model="vm.inputForm.closeValidator" ng-show="false"></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.updateCapacities()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.inputForm.$invalid" ng-if="!vm.isOnlyDealerAdmin">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-departments.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><form role="form" id="inputForm" name="inputForm" class="form-horizontal self-serve-form tab-departments validation-relative" ng-submit="vm.updateDepartment()" novalidate=""><div class="flex-percent-100 margin-bottom"><div class="modal-header self-serve-only padding-none margin-none"><h2 class="modal-title margin-none padding-none">Manage Departments</h2></div><div class="display-flex row margin-bottom-md margin-left-sm"><div class="flex-percent-60 flex-xs-percent-75 field-wrapper max-width-px-300"><label for="selectedDeparment">SELECT A DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-disabled="!vm.locationId && !vm.selectedLocation" name="selectedDepartment" class="form-control text-uppercase" ng-model="vm.selectedDepartment" ng-options="dept as (dept.name + (dept.isDisabled ? \' [DISABLED]\' : \'\')) for dept in vm.departments | filter: vm.showDisabledDepartments ? {} : {isDisabled: false} track by dept.id" ng-change="vm.departmentChanged()"><option value="">Select a department</option></select></div><div class="col-xs-3 m-t-xs" ng-if="!vm.loadingDepartment"><label class="checkbox-inline hours-checkbox no-top-padding"><input type="checkbox" ng-model="vm.showDisabledDepartments" ng-disabled="vm.loadingDepartment">&nbsp;Show Disabled</label></div><div class="flex-percent-40 flex-xs-percent-20 margin-top-sm padding-left-md" ng-if="vm.loadingDepartment"><img src="assets/images/ajax-loader.gif"> <span>LOADING...</span></div></div><div ng-if="vm.selectedDepartment" class="display-flex row margin-bottom-md margin-left-sm"><div class="flex-percent-60 flex-xs-percent-75 max-width-px-300"><div class="block relative"><input type="text" id="department-name" name="department-name" ng-disabled="vm.loadingDepartment" class="form-control better-placeholder" ng-model="vm.currentDepartment.name" placeholder="DEPARTMENT NAME" required="" validation="required|custom: vm.validation.valDepartmentName():alt=*"></div></div></div><div ng-if="vm.selectedDepartment && vm.dmsData.dmsSystem === vm.dmsProviderTypes.Tekion" class="display-flex row margin-bottom-md margin-left-sm"><div class="flex-percent-60 flex-xs-percent-75 field-wrapper max-width-px-300"><label for="dms-departments">DMS Department</label><select id="dms-departments" placeholder="DMS Department" name="dms-departments" required="" selectlabel="" class="form-control" ng-disabled="vm.loadingDepartment || !vm.hasDmsDepartments" ng-model="vm.currentDepartment.dmsServiceShopId" ng-options="shop.dmsServiceShopId as (shop.name + ((shop.dealerDepartmentId != null && shop.dealerDepartmentId != vm.currentDepartment.id) ? \' (Unavailable)\' : \'\')) for shop in vm.dmsServiceShops"></select></div></div><div ng-if="vm.selectedDepartment" class="display-flex row margin-bottom-md margin-left-sm"><div class="flex-percent-40 flex-xs-percent-75 field-wrapper max-width-px-300"><label for="duration">BOOKING INCREMENTS</label><select required="" selectlabel="" id="duration" name="duration" allow-null-option="Booking increments" class="form-control text-uppercase" ng-model="vm.currentDepartment.appointmentDuration" ng-disabled="vm.loadingDepartment" ng-options="duration.value as duration.label + \' min\' for duration in vm.appointmentDurations" validation="required:alt=Field is Required"></select></div><div class="flex-percent-40 flex-xs-percent-75 max-width-px-300 padding-left-15"><label class="checkbox-inline hours-checkbox no-top-padding"><input ng-disabled="vm.selectedDepartment.id === vm.defaultDepartment.id" type="checkbox" ng-model="vm.currentDepartment.isDisabled">&nbsp; <span popover-enable="vm.selectedDepartment.id === vm.defaultDepartment.id" uib-popover="This is the default department and cannot be disabled." popover-append-to-body="true" popover-trigger="mouseenter">Disabled</span></label></div></div><div ng-if="vm.selectedDepartment"><h3 class="margin-top-30">Advisors</h3><p>Select the advisors for this department for appointments.</p><hr class="margin-top-md margin-bottom-md"><div class="display-flex flex-row margin-bottom"><div class="flex-percent-25 flex-grow max-width-px-300"><label for="available-advisors">Available</label><select multiple="" id="available-advisors" name="available-advisors" class="form-control" ng-model="vm.advisorsToMove" ng-options="adv as (adv.firstName + \' \' + adv.lastName + (adv.inMultipleDepts ? \' *\' : \'\')) for adv in vm.availableAdvisors track by adv.id"></select></div><div class="flex-width-100 text-center"><button id="move-btn" type="button" class="btn btn-white" ng-click="vm.selectAdvisor()" ng-disabled="vm.advisorsToMove.length === 0 || vm.loadingDepartment">MOVE</button></div><div class="flex-percent-25 flex-grow max-width-px-300"><label for="selected-advisors">Assigned</label><select multiple="" id="selected-advisors" name="selected-advisors" class="form-control" ng-model="vm.advisorsToMove" ng-options="adv as (adv.firstName + \' \' + adv.lastName + (adv.inMultipleDepts ? \' *\' : \'\')) for adv in vm.assignedAdvisors track by adv.id"></select></div><div class="flex-percent-25 flex-grow text-danger padding-left-sm" ng-if="vm.isDefaultDepartmentWithoutAdvisors()">Required:<br><br>This is your default department.<br>You must have at least one advisor in it.</div></div><p class="margin-top-sm">* Multiple Departments</p><h3 class="margin-top-30">Hours</h3><p>Enter the hours for this department available for appointments.</p><div class="margin-bottom-20"><hr class="margin-top-md margin-bottom-md"><label class="checkbox-inline hours-checkbox padding-top-none"><input type="checkbox" name="use-general-service-hours" ng-model="vm.currentDepartment.useDealerHours"> Use General Service Department Hours</label></div><div class="display-flex row margin-bottom-20" ng-repeat="daySchedule in vm.currentDepartment.schedule"><div class="flex-width-70 text-right padding-top-sm margin-right-md margin-left-md"><label class="hidden-xs" for="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}">{{daySchedule.day}}</label> <label class="visible-xs text-capitalize">{{vm.shortDaysOfWeek[$index].toLowerCase()}}</label></div><div class="flex-width-120 field-wrapper margin-right-sm" ng-if="daySchedule.isClosed || vm.currentDepartment.useDealerHours"><label for="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}">OPEN TIME</label><select selectlabel="" id="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}" name="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}" class="form-control" ng-model="daySchedule.startTime" ng-options="time.value as time.label for time in vm.hoursInDay" ng-change="vm.revalidateOpenTime(daySchedule.day)" ng-disabled="vm.loadingDepartment || daySchedule.isClosed || vm.currentDepartment.useDealerHours"><option value="">Open time</option></select></div><div class="flex-width-120 field-wrapper margin-right-sm" ng-if="!(daySchedule.isClosed || vm.currentDepartment.useDealerHours)"><label for="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}">OPEN TIME</label><select selectlabel="" id="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}" name="{{vm.myUniqueId}}-starttime-{{daySchedule.day}}" class="form-control" ng-disabled="vm.loadingDepartment" ng-model="daySchedule.startTime" ng-change="vm.revalidateCloseTime(daySchedule.day)" ng-options="time.value as time.label for time in vm.hoursInDay" required="" validation="required:alt=Field is Required|custom: vm.validation.valStartEndTime(daySchedule, \'End Time\'):alt=Start & End Time required"><option value="">Open time</option></select></div><div class="flex-width-50 padding-top-sm text-center">to</div><div class="flex-width-120 field-wrapper margin-left-sm margint-right-sm" ng-if="daySchedule.isClosed || vm.currentDepartment.useDealerHours"><label for="{{vm.myUniqueId}}-endtime-{{daySchedule.day}}">CLOSE TIME</label><select selectlabel="" id="{{vm.myUniqueId}}-endtime-{{daySchedule.day}}" name="{{vm.myUniqueId}}-endtime-{{daySchedule.day}}" class="form-control" ng-model="daySchedule.endTime" ng-options="time.value as time.label for time in vm.hoursInDay" ng-change="vm.revalidateOpenTime(daySchedule.day)" ng-disabled="vm.loadingDepartment || daySchedule.isClosed || vm.currentDepartment.useDealerHours" validation="required:alt=Field is Required|custom: vm.validation.valStartEndTime(daySchedule, \'Start Time\'):alt=Start & End Time required"><option value="">Close time</option></select></div><div class="flex-width-120 field-wrapper margin-left-sm margint-right-sm" ng-if="!(daySchedule.isClosed || vm.currentDepartment.useDealerHours)"><label for="{{vm.myUniqueId}}-endtime-{{daySchedule.day}}">CLOSE TIME</label><select selectlabel="" id="{{vm.myUniqueId}}-endtime-{{daySchedule.day}}" name="{{vm.myUniqueId}}-endtime-{{daySchedule.day}}" class="form-control" ng-disabled="vm.loadingDepartment" ng-model="daySchedule.endTime" ng-options="time.value as time.label for time in vm.hoursInDay" ng-change="vm.revalidateOpenTime(daySchedule.day)" required="" validation="required:alt=Field is Required|custom: vm.validation.valStartEndTime(daySchedule, \'Start Time\'):alt=Start & End Time required"><option value="">Close time</option></select></div><div class="flex-width-100 flex-grow margin-left-20"><label class="checkbox-inline hours-checkbox"><input type="checkbox" name="closed" ng-model="daySchedule.isClosed" ng-change="vm.closedChanged(daySchedule)" ng-disabled="vm.currentDepartment.useDealerHours || vm.loadingDepartment"><span class="padding-left-xs">Closed</span></label></div></div><div class="display-flex row margin-bottom margin-left-sm margin-top-md" ng-if="vm.selectedDepartment"><div class="flex-percent-80"><h3>Days Closed</h3><p>Please enter any dates the dealer will not be open.</p><hr class="margin-top-md margin-bottom-md"><constraint definition-type="vm.constraintDefinitionType.businessClosed" on-add="vm.addBusinessClosedConstraint(constraint)"></constraint><div class="days-closed-constraint row margin-top margin-bottom-md"><div class="display-flex flex-row margin-left-md padding-left-sm" ng-repeat="constraint in vm.businessClosedConstraints | filter: { isDeleted: false } track by constraint.uid"><div class="flex-percent-50 margin-bottom-sm">{{vm.constraintToString(constraint)}}</div><div class="flex-percent-50 margin-bottom-sm"><a href="#" class="theme-link" ng-click="vm.deleteBusinessClosedConstraint(constraint)">DELETE</a></div></div></div></div></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md padding-right-20"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="vm.close()">Close</button> <button type="button" ng-click="vm.updateDepartment()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="inputForm.$invalid || vm.isDefaultDepartmentWithoutAdvisors()">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-drivers.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg" fill-height=""><h3>Driver Information</h3><p>Drivers associated to this dealer.</p><hr><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.saveChanges()" novalidate=""><div class="form-group" ng-if="!vm.isOnlyDealerAdmin"><label class="col-sm-2 control-label" style="text-align: left !important;"><span class="cursor-pointer hover-underline" uib-popover="Which Driver Company(s) does this dealer support" popover-trigger="outsideClick">Driver Company(s)</span></label><div class="col-sm-9"><select data-placeholder-text-multiple="\'Select driver company(s)...\'" class="form-control" id="driverCompany" name="driverCompany" multiple="" chosen="{width: \'100%\'}" max-shown-results="100" on-change="vm.companiesChanged()" ng-disabled="vm.fieldsDisabled" ng-model="vm.currentLocation.driverCompanyIds" ng-options="driverCompany.id as driverCompany.name for driverCompany in vm.driverCompanies"></select></div></div><div class="form-group" ng-if="!vm.isOnlyDealerAdmin"><label class="col-sm-2 control-label" style="text-align: left !important;"><span class="cursor-pointer hover-underline" uib-popover="Which Driver Programs(s) does this dealer support" popover-trigger="outsideClick">Driver Program(s)</span></label><div class="col-sm-9"><select data-placeholder-text-multiple="\'Select driver program(s)...\'" class="form-control" id="driverProgram" name="driverProgram" multiple="" chosen="{width: \'100%\'}" max-shown-results="100" ng-disabled="vm.fieldsDisabled" ng-model="vm.currentLocation.driverProgramIds" ng-options="driverProgram.id as driverProgram.name for driverProgram in vm.driverPrograms"></select></div></div><div class="form-group"><div class="col-sm-12"><div class="table-responsive"><table class="table footable table-hover"><thead><tr><th data-sort-ignore="true">Photo</th><th data-sort-ignore="true"></th><th data-toggle="true" data-type="alpha">Driver</th><th data-toggle="true">Name</th><th data-sort-ignore="true">Company</th><th data-sort-ignore="true" ng-if="vm.showSpecialColumns()">Dedicated</th><th data-sort-ignore="true">Vetted</th><th data-sort-ignore="true" ng-if="vm.showSpecialColumns()">Preferred</th><th data-sort-ignore="true" ng-if="vm.showSpecialColumns()">Blocked</th></tr></thead><tbody><tr ng-repeat="driver in vm.dealerDrivers" class="list-name"><td class="user-profile-pic" ui-sref="driver-tab-general({ driverId: driver.id })"><img class="img-circle" ng-src="{{ ::driver.profilePicture }}"></td><td class="spacer"></td><td class="user-name" ui-sref="driver-tab-general({ driverId: driver.id })">{{ ::driver.id }}<br><div class="phone-number" ng-if="driver.mobilePhone"><i class="fa fa-mobile"></i>{{ ::driver.mobilePhone|tel }}</div></td><td class="driver-name" ui-sref="driver-tab-general({ driverId: driver.id })">{{ ::driver.name }}</td><td class="driver-name" ui-sref="driver-tab-general({ driverId: driver.id })">{{ ::driver.companyName }}</td><td class="driver-name" ui-sref="driver-tab-general({ driverId: driver.id })" ng-if="vm.showSpecialColumns()"><span class="fa fa-check" ng-if="driver.isDedicated"></span></td><td class="driver-name" ui-sref="driver-tab-general({ driverId: driver.id })"><span class="fa fa-check" ng-if="driver.isDnsVetted"></span></td><td class="driver-name" ng-if="vm.showSpecialColumns()" title="{{vm.getSwitchTitle(driver, \'Preferred\')}}"><switch id="isPreferred-{{$index}}" name="isPreferred-{{$index}}" ng-change="vm.preferredToggleChanged(driver)" disabled="driver.isDedicated" ng-model="driver.isPreferred" class="green" ng-if="vm.isDNSDriver(driver)"></switch></td><td class="driver-name" ng-if="vm.showSpecialColumns()" title="{{vm.getSwitchTitle(driver, \'Blocked\')}}"><switch id="isBlocked-{{$index}}" name="isBlocked-{{$index}}" ng-change="vm.blockedToggleChanged(driver)" disabled="driver.isDedicated" ng-model="driver.isBlocked" class="green" ng-if="vm.isDNSDriver(driver)"></switch></td></tr></tbody></table></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md padding-right-20"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.moveActiveDrivers()" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ladda="isDataLoading" ng-if="vm.isAdmin">Move Active Drivers</button> <button type="button" ng-click="vm.saveChanges()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-general.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>Location Information</h3><p class="">Update the dealer\'s location and general information.</p><hr><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.updateLocation()" prevalidate-form="" novalidate=""><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s friendly display name." popover-trigger="outsideClick">Dealer Name</span></label><div class="col-sm-8"><input type="text" class="form-control" name="locationName" ng-model="vm.currentLocation.name" ng-disabled="vm.isOnlyDealerAdmin" required="" validation="required:alt=A valid dealer name is required" ng-change="vm.nameUpdated()"><div ng-if="vm.hasDuplicateName" class="text-danger">Warning: Dealer name already exists.</div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s physical address." popover-trigger="outsideClick">Address</span></label><div class="col-sm-8"><input type="text" id="gplaces" name="gplaces" ng-model="vm.autocomplete" class="form-control" details="vm.placesObj" here-places="" handle-selected="vm.placeUpdated(formattedAddress)" ng-disabled="vm.isOnlyDealerAdmin" required="" allow-create-new="true" validation="required" options="vm.placesOptions" fetch-twilio-numbers=""><div ng-if="vm.hasDuplicateAddress" class="text-danger">Warning: Dealer address already exists.</div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s sale\'s phone number." popover-trigger="outsideClick">Sales Phone</span></label><div class="col-sm-8"><input type="text" class="form-control" name="salesPhoneNumber" ng-model="vm.currentLocation.salesPhoneNumber" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" validation="required|custom:vm.validation.phone(vm.currentLocation.salesPhoneNumber)"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s service phone number." popover-trigger="outsideClick">Service Phone</span></label><div class="col-sm-8"><input type="text" class="form-control" name="servicePhoneNumber" ng-model="vm.currentLocation.servicePhoneNumber" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" validation="required|custom:vm.validation.phone(vm.currentLocation.servicePhoneNumber)"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s website address." popover-trigger="outsideClick">Website URL</span></label><div class="col-sm-8"><input type="text" name="website" class="form-control" ng-model="vm.currentLocation.website" required="" validation="required|custom:vm.validation.url(vm.currentLocation.website)"></div></div><div class="form-group"><label class="col-sm-3 control-label">SMS Phone</label><div class="col-sm-8" ng-if="!vm.show800Numbers"><p class="form-control-static">{{ vm.currentLocation.twilioNumber | tel }} <a ng-if="!vm.isOnlyDealerAdmin" class="padding-sm cursor-pointer theme-link" ng-click="vm.updateSms()">CHANGE</a></p><div ng-if="vm.hasDuplicateSMSPhone" class="text-danger">Warning: The SMS phone is already assigned to another dealer.</div></div><div class="col-sm-8" ng-show="vm.show800Numbers && vm.twilioNumbers.length > 1"><select class="form-control" name="twilioNumber" ng-options="s for s in vm.twilioNumbers" required="" ng-model="vm.currentLocation.twilioNumber" validation="required" ng-change="vm.updateSMSPhone()"></select><div ng-show="vm.hasDuplicateSMSPhone" class="text-danger">Warning: The SMS phone is already assigned to another dealer.</div></div><div class="col-sm-8 text-danger" ng-show="vm.show800Numbers && vm.twilioNumbers.length <= 1">No 800 numbers. Please try again in a few minutes</div></div><div ng-if="!vm.isOnlyDealerAdmin"><div class="form-group"><label class="col-sm-3 control-label">Timezone</label><div class="col-sm-8"><select class="form-control" name="timezone" ng-options="s for s in vm.timeZones" ng-model="vm.currentLocation.timeZoneId" ng-change="vm.updateTimezone()" validation="in: {{ vm.validation.acceptableTimeZones }}:alt=Please select an item from the list"></select>{{ vm.currentLocation.timezoneName }}</div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s OEM reference ID. If this is not for an OEM program, enter &quot;NA&quot;" popover-trigger="outsideClick">OEM Dealer ID</span></label><div class="col-sm-8"><input type="text" class="form-control" name="oemDealerId" ng-model="vm.currentLocation.oemDealerId" validation="alpha_dash"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s second OEM reference ID. If this is not for an OEM program, enter &quot;NA&quot;" popover-trigger="outsideClick">OEM Dealer ID 2</span></label><div class="col-sm-8"><input type="text" class="form-control" name="oemDealerId2" ng-model="vm.currentLocation.oemDealerId2" validation="alpha_dash"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s Billing Dealer ID" popover-trigger="outsideClick">Billing Dealer ID</span></label><div class="col-sm-8"><input type="text" class="form-control" name="billingDealerId" ng-model="vm.currentLocation.billingDealerId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s OEM Geo Id 1" popover-trigger="outsideClick">OEM Geo 1</span></label><div class="col-sm-8"><input type="text" class="form-control" name="oemGeo1" ng-model="vm.currentLocation.oemGeo1"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s OEM Geo Id 2" popover-trigger="outsideClick">OEM Geo 2</span></label><div class="col-sm-8"><input type="text" class="form-control" name="oemGeo2" ng-model="vm.currentLocation.oemGeo2"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s OEM Geo Id 3" popover-trigger="outsideClick">OEM Geo 3</span></label><div class="col-sm-8"><input type="text" class="form-control" name="oemGeo1" ng-model="vm.currentLocation.oemGeo3"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the dealer\'s Uber Store ID if there is one" popover-trigger="outsideClick">Uber Store ID</span></label><div class="col-sm-8"><input type="text" class="form-control" name="uberStoreId" ng-model="vm.currentLocation.uberStoreId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Is this a dealer location or an virtual location?" popover-trigger="outsideClick">Location Type</span></label><div class="col-sm-8"><select class="form-control" name="locationType" ng-options="s.value as s.text for s in vm.locationTypes" ng-model="vm.currentLocation.locationType" required="" validation="required"></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What Program should be this dealer be branded with?" popover-trigger="outsideClick">Program</span></label><div class="col-sm-8"><select class="form-control" name="adminProgram" ng-options="s.id as s.programName for s in vm.adminPrograms" required="" ng-model="vm.currentLocation.adminConfigId" validation="required"></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the status of the dealer?" popover-trigger="outsideClick">Status</span></label><div class="col-sm-8"><select class="form-control" name="status" ng-options="s.value as s.text for s in vm.statuses" required="" ng-model="vm.currentLocation.status" validation="required"></select></div></div><div class="form-group" ng-if="vm.canPauseObfuscation"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Pause GLBA deletion/obfuscation for this dealer only. Use for legal holds or customer data requests." popover-trigger="outsideClick">Pause Data Deletion</span></label><div class="col-sm-8"><switch id="pauseDataDeletion" name="pauseDataDeletion" ng-model="vm.isDataObfuscationPaused" ng-change="vm.toggleDataObfuscationPause()" disabled="vm.pauseToggleBusy" class="green"></switch></div></div><div class="form-group" ng-if="!vm.isOnlyDealerAdmin"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the Go Live date for this dealer?" popover-trigger="outsideClick">Go Live Date</span></label><div class="col-sm-8"><div class="input-group date" data-provide="datepicker" data-date-format="mm/dd/yyyy" data-date-autoclose="true"><input type="text" id="goLiveDate" class="form-control disabled-date" ng-model="vm.currentLocation.goLiveDate" readonly="" name="goLiveDate"> <span class="input-group-addon location-calendar"><i class="glyphicon glyphicon-calendar"></i></span></div></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Who is the point of contact for this dealer?" popover-trigger="outsideClick">Point of Contact</span></label><div class="col-sm-8"><select data-placeholder-text-single="\'Select employee...\'" class="form-control" name="pocUser" chosen="{width: \'100%\'}" search-contains="true" ng-model="vm.currentLocation.pocUserId" max-shown-results="100" ng-options="employee.identityUserId as employee.fullName for employee in vm.locationEmployees"><option value=""></option></select></div></div><div ng-if="!vm.isOnlyDealerAdmin"><div class="form-group"><label class="col-sm-3 control-label">Enable Dispatch Controls</label><div class="col-sm-8"><switch id="dispatchControls" name="dispatchControls" ng-model="vm.currentLocation.enableDispatchControls" class="green"></switch></div></div><div class="form-group"><label class="col-sm-3 control-label">Test Mode</label><div class="col-sm-8"><switch id="testMode" name="testMode" ng-model="vm.currentLocation.enableTestMode" class="green"></switch></div></div><div class="form-group"><label class="col-sm-3 control-label">Receive Weekly Report</label><div class="col-sm-8"><switch id="receiveWeeklyReport" name="receiveWeeklyReport" ng-model="vm.currentLocation.receiveWeeklyReport" class="green"></switch></div></div><div class="form-group" ng-if="vm.showMFAToggle"><label class="col-sm-3 control-label">Disable MFA</label><div class="col-sm-8"><switch id="disableSolidMFA" name="disableSolidMFA" ng-model="vm.currentLocation.disableSolidMFA" class="green"></switch></div></div><div ng-if="vm.isDeveloper"><div class="form-group"><label class="col-sm-3 control-label">Copyable</label><div class="col-sm-8"><switch id="isCopyable" name="isCopyable" ng-model="vm.currentLocation.isCopyable" class="green"></switch></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Created By</label><div class="col-sm-8"><p class="form-control-static">{{ vm.currentLocation.createdByText }} {{ (vm.currentLocation.dateCreated != null ? " at " : "") }} {{ vm.currentLocation.dateCreated | date: \'fullDate\' }}</p></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What package has this dealer subscribed to?" popover-trigger="outsideClick">Product Package</span></label><div class="col-sm-8"><select data-placeholder-text-single="\'Select product package...\'" class="form-control" required="" name="productPackage" validation="required" ng-model="vm.currentLocation.productId" ng-options="package.id as package.name for package in vm.productPackages"><option value=""></option></select></div></div><br></div><div class="form-group margin-top" ng-if="!vm.isOnlyDealerAdmin"><div class="col-sm-1">&nbsp;</div><div class="col-sm-10"><h3>Products</h3><p>Update the dealer\'s assigned products and settings for if the product displays in the menu when disabled.</p><hr></div></div><div class="row margin-bottom" ng-if="!vm.isOnlyDealerAdmin"><div class="col-md-3 col-sm-3 col-xs-3">&nbsp;</div><div class="col-md-1 col-sm-1 col-xs-2 margin-bottom"><b><br>Enable</b></div><div class="col-md-2 col-sm-2 col-xs-4 margin-bottom padding-right-none"><b><br>Display Marketing</b></div></div><div class="form-group" ng-repeat="role in vm.currentLocation.assignedRoles | orderBy : \'name\'" ng-if="!vm.isOnlyDealerAdmin && !role.isHidden"><div class="row"></div><label class="col-sm-3 col-xs-3 control-label" for="has{{role.name}}"><span ng-if="role.name.toLowerCase() !== vm.systemEnums.permissionTypes.payments.toLowerCase()">{{role.name}}</span> <span ng-if="role.name.toLowerCase() === vm.systemEnums.permissionTypes.payments.toLowerCase()" class="cursor-pointer hover-underline" uib-popover="Enable Payments? Must have CenPos integration configured" popover-trigger="outsideClick">{{role.name}}</span></label><div class="col-md-1 col-sm-1 col-xs-2"><label ng-if="!vm.isLoading"><switch id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green" disabled="role.isDisabled" ng-change="vm.switchClicked(role)"></switch></label></div><div class="col-md-2 col-sm-1 col-xs-4"><label><div ng-cloak="" ng-show="role.assigned === true" class="ng-hide"><switch id="fakeShowWhenDisabled{{role.name}}" name="fakeShowWhenDisabled{{role.name}}" class="green" disabled="true"></switch></div><div ng-cloak="" ng-show="role.assigned === false" class="ng-hide"><switch id="showWhenDisabled{{role.name}}" name="showWhenDisabled{{role.name}}" ng-model="role.showWhenDisabled" class="green"></switch></div></label></div></div><div class="display-flex flex-row margin-top-md" ng-if="vm.isSystemAdmin"><button type="button" ng-if="vm.canOpenDealerConfig()" class="btn btn-default col-sm-offset-2 margin-right-md" ng-click="vm.openDealerConfig()">Add/Update Dealer Config</button> <button type="button" class="btn btn-w-m btn-default" ng-click="vm.openCopyTripTypesModal()">COPY TRIP TYPE INSTANCES</button></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.updateLocation()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="inputForm.$invalid">Update</button></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu></div>');
$templateCache.put('app/areas/location/views/location-tab-hours.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>Booking Hours</h3><p>Enter the hours available for this dealer. Booking hours are used to determine the earliest available pick up time for consumers by looking at the dealerships booking hours + Googles estimated travel time.</p><hr><form role="form" id="vm.inputForm" name="vm.inputForm" class="form-horizontal" ng-submit="vm.updateHours()" novalidate="" fill-height=""><div class="alert alert-danger" ng-if="vm.inputForm.allDaysClosedValidator.$invalid">Please select at least one open day.</div><div class="form-group" ng-repeat="day in vm.locationHours"><div class="col-sm-11"><label class="col-sm-2 col-xs-12 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the earliest pick up and lastest drop off for {{day.title}}, or denote if the dealer is closed." popover-trigger="outsideClick">{{day.title}}</span></label><div class="col-sm-3 col-xs-4 padding-right-none"><select class="form-control" name="{{day.title}}From" ng-model="day.startTime" ng-model-options="{ debounce: 800 }" ng-options="hour.minutesFromMidnight as hour.ampmHours for hour in vm.hoursData" ng-disabled="day.closed" ng-change="vm.revalidate(\'{{day.title}}To\')" validation-error-to="#errorMessage{{$index}}" ng-class="{\'ng-invalid ng-invalid-validation\': vm.validateTime00clock(day.startTime, day.endTime, day.closed)}" validation="custom:validateTimes(day.startTime, day.startTime, day.endTime, day.closed);alt=*"></select></div><div class="col-sm-1 col-xs-1 to-col text-center margin-top-md padding-right-none">to</div><div class="col-sm-3 col-xs-4 padding-right-none"><select class="form-control" name="{{day.title}}To" ng-model="day.endTime" ng-model-options="{ debounce: 800 }" ng-options="hour.minutesFromMidnight as hour.ampmHours for hour in vm.hoursData" ng-disabled="day.closed" validation-error-to="#errorMessage{{$index}}" ng-change="vm.revalidate(\'{{day.title}}From\')" ng-class="{\'ng-invalid ng-invalid-validation\': vm.validateTime00clock(day.startTime, day.endTime, day.closed)}" validation="custom:validateTimes(day.endTime, day.startTime, day.endTime, day.closed, false);alt=*"></select></div><div class="col-sm-2 col-xs-3 padding-right-none"><label class="checkbox-inline hours-checkbox"><input type="checkbox" name="closed" ng-model="day.closed" ng-change="vm.closedChanged(day)">Closed</label></div><div class="col-sm-11"><div class="col-sm-2"></div><div class="col-sm-6"><div class="validation text-danger" ng-if="vm.validateTime00clock(day.startTime, day.endTime, day.closed)">*Open and close time can not be the same time.</div></div></div></div><div class="col-sm-11"><div class="col-sm-2"></div><div class="col-sm-6"><div id="errorMessage{{$index}}" class="validation text-danger"></div></div></div></div><div><br><h3>Blackout Dates</h3><p>Please enter any dates the dealer will not be open.</p><hr><div class="form-group"><div class="col-sm-3 col-xs-7"><div class="input-group date" data-provide="datepicker" data-date-start-date="{{ vm.today.format(\'MM-DD-YYYY\') }}" data-date-format="mm/dd/yyyy"><input type="text" class="form-control" ng-model="blackoutDate" readonly="" name="blackoutDate" validation="custom:vm.validateDate(blackoutDate):alt=*" validation-error-to="#errorMessageBlackout"> <span class="input-group-addon location-calendar"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="errorMessageBlackout" class="col-sm-11 margin-top-md padding-none validation text-danger">Must use a valid date</div></div><div class="col-sm-3"><button class="btn btn-default" name="blackoutDateAdd" type="button" ng-disabled="vm.blackoutEnteredValid === false" ng-click="vm.addBlackout(blackoutDate)">Add Blackout</button></div></div><div class="table-responsive"><table id="blackout-hours" class="table table-condensed overflow-visible" ng-if="vm.blackouts && vm.blackouts.length"><thead><tr><th class="col-sm-5"><span class="cursor-pointer hover-underline" popover-placement="right" uib-popover="The date the dealer is closed." popover-trigger="outsideClick">Blackout Date</span></th><th class="col-sm-1 text-center">Remove</th><th class="col-sm-6"></th></tr></thead><tbody><tr ng-repeat="blackout in vm.blackouts | orderBy:vm.sortByDate"><td>{{blackout | date:\'longDate\'}}</td><td class="text-center"><a href="#" class="theme-link" ng-click="vm.deleteBlackout($index);">DELETE</a></td><td></td></tr></tbody></table></div></div><input type="text" name="allDaysClosedValidator" ng-model="vm.inputForm.closeValidator" ng-show="false"></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.updateHours()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-incentives.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div id="incentives" class="padding-lg" fill-height=""><div><h3>Incentives</h3><div><p>Schedule Incentives for certain times and days of the week.</p><strong>All times are in the {{ vm.location.timeZoneId }} Time Zone.</strong><hr></div></div><form role="form" id="incentiveForm" name="incentiveForm" ng-submit="vm.saveIncentives()" novalidate=""><br><div ng-if="vm.scheduledIncentives.length === 0"><button class="btn btn-primary" ng-click="vm.addIncentive()">Add Incentive</button></div><div ng-repeat="scheduledIncentive in vm.scheduledIncentives"><div class="display-flex flex-row flex-sm-column margin-top-sm margin-bottom-30 margin-left-md"><div class="display-flex text-nowrap flex-sm-percent-100"><label ng-repeat="dayOfWeek in scheduledIncentive.daysOfWeek" class="checkbox-inline hours-checkbox incentive-dayofweek-checkbox text-uppercase font-normal"><input type="checkbox" name="incentive-dow-{{dayOfWeek.index}}-{{scheduledIncentive.id}}" ng-change="vm.dowChanged(dayOfWeek, scheduledIncentive)" k="" ng-model="dayOfWeek.checked">{{ dayOfWeek.day }}</label> <input type="hidden" validation-error-to="#day-required-{{scheduledIncentive.id}}" ng-model="scheduledIncentive" name="days-of-week-{{scheduledIncentive.id}}" validation="custom:vm.validateDays(scheduledIncentive):alt=At least one day must be selected"><div id="day-required-{{scheduledIncentive.id}}" class="text-danger validation margin-top-20"></div></div><div class="display-flex flex-row flex-sm-percent-100 full-width margin-top-xs override-sm-padding-top"><div class="padding-left-lg flex-width-50 margin-top-xs">FROM</div><div class="padding-left-md flex-width-200 field-wrapper"><label>START TIME</label><select selectlabel="" name="incentive-starttime-{{scheduledIncentive.id}}" class="form-control" ng-model="scheduledIncentive.startTime" ng-options="time.value as time.label for time in vm.hoursInDay" ng-change="vm.startTimeChanged(scheduledIncentive.id)" validation="required|custom:vm.validateTimes(scheduledIncentive):alt=*"><option value="">Start time</option></select></div><div class="flex-width-30 padding-left-md margin-top-xs">TO</div><div class="flex-width-200 field-wrapper padding-left-sm"><label for="incentive-endtime">END TIME</label><select selectlabel="" name="incentive-endtime-{{scheduledIncentive.id}}" class="form-control" ng-model="scheduledIncentive.endTime" ng-options="time.value as time.label for time in vm.hoursInDay | filter: vm.availableEndHours" ng-change="vm.endTimeChanged(scheduledIncentive.id)" validation="required|custom:vm.validateTimes(scheduledIncentive):alt=*"><option value="">End time</option></select></div><div class="flex-width-150 padding-left-md"><div class="block relative"><input name="incentive-amount-{{scheduledIncentive.id}}" class="form-control no-spinners better-placeholder" placeholder="AMOUNT" type="number" ng-model="scheduledIncentive.incentiveAmount" validation="required"></div></div><div class="flex-width-150 field-wrapper padding-left-md"><label>TYPE</label><select selectlabel="" name="incentive-incentiveType-{{scheduledIncentive.id}}" class="form-control" ng-model="scheduledIncentive.incentiveType" ng-options="incentiveType.value as incentiveType.label for incentiveType in vm.incentiveTypes" validation="required"><option value="">Type</option></select></div><div class="flex-width-50 padding-left-md padding-top-sm"><i class="material-icons theme-link inline" style="font-size:2em" ng-click="vm.removeIncentive(scheduledIncentive.id)">remove</i></div></div></div><div class="display-flex flex-row" ng-if="$index === vm.scheduledIncentives.length - 1"><div class="flex-percent-100 margin-right-lg"><div type="button" class="theme-link text-right margin-right-lg text-uppercase" ng-class="config.styleClass" ng-click="vm.addIncentive()" ng-disabled="!vm.enableAdd">Add New</div></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.saveIncentives()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="!incentiveForm.$valid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.location"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-integrations.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto overflow-x-hidden"><div class="row padding"><div class="sidebar col-sm-2"><div class="padding-left-md padding-top-md"><ul id="integrations-tabs" class="vertical-nav m-0 p-0"><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.DMS }"><a href="#" ng-click="vm.loadDmsTab()" class="vertical-nav-link text-uppercase">DMS</a></li><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.XTime }"><a href="#" ng-click="vm.tab = vm.tabs.XTime" class="vertical-nav-link text-uppercase">XTime</a></li><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.Payments }"><a href="#" ng-click="vm.tab = vm.tabs.Payments" class="vertical-nav-link text-uppercase">Payments</a></li><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.AutoPoint }"><a href="#" ng-click="vm.tab = vm.tabs.AutoPoint" class="vertical-nav-link text-uppercase">AutoPoint</a></li><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.LoanerManagement }"><a href="#" ng-click="vm.tab = vm.tabs.LoanerManagement" class="vertical-nav-link text-uppercase">Loaner Management</a></li><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.DigniFi }"><a href="#" ng-click="vm.tab = vm.tabs.DigniFi" class="vertical-nav-link text-uppercase">DigniFi</a></li><li class="vertical-nav-item" ng-class="{ \'selected\': vm.tab === vm.tabs.OnDemand }"><a href="#" ng-click="vm.tab = vm.tabs.OnDemand" class="vertical-nav-link text-uppercase">OnDemand</a></li></ul></div></div><div class="col-sm-9 padding-md"><form class="form-horizontal full-height" name="inputForm" ng-submit="vm.updateDMS()" novalidate="" prevalidate-form=""><input type="hidden" id="location-fake-input" name="fake-input" validation="required" ng-model="vm.fakeInput"><div ng-show="vm.tab === vm.tabs.DMS"><h3>DMS Settings</h3><p>If this is a DMS integrated dealer, choose the dealer\'s DMS and enter their configuration settings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose the dealer\'s DMS integration. If the dealer is not using DMS integration, choose None." popover-trigger="outsideClick">DMS</span></label><div class="col-sm-6"><select class="form-control" name="dmsSystem" ng-change="vm.resetDMS()" ng-model="vm.dmsEntry.dmsSystem" ng-options="s.value as s.text for s in vm.dmsSystemTypes"></select></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Is this the new CDK implementation?" popover-trigger="outsideClick">Is new CDK Implementation</span></label><div class="col-sm-6"><select class="form-control" name="isNewCdk" ng-model="vm.dmsEntry.isNewCdk" ng-options="s.value as s.text for s in vm.booleanOptions"></select></div></div></div><div class="form-group margin-bottom" ng-if="vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.None"><label class="col-sm-3 control-label" ng-switch="vm.dmsEntry.dmsSystem"><span ng-switch-when="1|5" ng-switch-when-separator="|" class="cursor-pointer hover-underline" uib-popover="Enter the DMS ID generated by the DMS provider." popover-trigger="outsideClick">DMS ID</span> <span ng-switch-when="2" class="cursor-pointer hover-underline" uib-popover="Enter the Company Number generated by the DMS provider." popover-trigger="outsideClick">Company Number</span> <span ng-switch-when="3|4" ng-switch-when-separator="|" class="cursor-pointer hover-underline" uib-popover="Enter the Dealer Number generated by the DMS provider." popover-trigger="outsideClick">Dealer Number</span></label><div class="col-sm-6"><input type="text" class="form-control" name="dmsDealerId" ng-model="vm.dmsEntry.dmsDealerId" validation="required"></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.Motive"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Select the Motive Source" popover-trigger="outsideClick">Source</span></label><div class="col-sm-6"><select class="form-control" name="dmsDispatchMakeCode" validation="required" ng-model="vm.dmsEntry.dmsDataSource" ng-options="s.value as s.text for s in vm.motiveDataSources"><option value=""></option></select></div></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.DealerTrack"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the Enterprise Code generated by the DMS provider." popover-trigger="outsideClick">Enterprise Code</span></label><div class="col-sm-6"><input type="text" class="form-control" name="dmsEnterpriseId" ng-model="vm.dmsEntry.dmsEnterpriseId" validation="required"></div></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.ReynoldsPOWER || vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.ReynoldsERA"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the Store Number generated by the DMS provider." popover-trigger="outsideClick">Store Number</span></label><div class="col-sm-6"><input type="text" class="form-control" name="dmsStoreId" ng-model="vm.dmsEntry.dmsStoreId" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the Branch Number generated by the DMS provider." popover-trigger="outsideClick">Branch Number</span></label><div class="col-sm-6"><input type="text" class="form-control" name="dmsBranchId" ng-model="vm.dmsEntry.dmsBranchId" validation="required"></div></div></div><div ng-if="vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.None || vm.dmsEntry.isXTimeEnabled"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Tooltip text TBD." popover-trigger="outsideClick">Initialize</span></label><div class="col-sm-6"><select class="form-control" name="initializeData" ng-model="vm.dmsEntry.initializeData" ng-options="s.value as s.text for s in vm.booleanOptions"></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="This feature is to toggle the ability to push an appointment when a trip is booked via Consumer and API. It does not affect the Appointment Scheduler." popover-trigger="outsideClick">Push Appts to DMS<div class="font-size-10">(Standalone trips only)</div></span></label><div class="col-sm-6" ng-if="!vm.dmsEntry.isXTimeEnabled && vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.Tekion"><select class="form-control" name="dmsPushType" ng-model="vm.dmsEntry.dmsPushType" ng-options="s.value as s.text for s in vm.dmsPushTypes"></select></div><div class="col-sm-6" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.Tekion"><select class="form-control" name="dmsPushTypeDisabled" disabled="disabled"><option disabled="disabled" selected="">No</option></select></div><div class="col-sm-6" ng-if="vm.dmsEntry.isXTimeEnabled"><select class="form-control" name="dmsPushTypeDisabled" disabled="disabled"><option disabled="disabled" selected="">XTime integrated. DMS Push disabled</option></select></div></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK && vm.dmsEntry.dmsPushType > 0 && !vm.dmsEntry.isXTimeEnabled"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the Dispatch Code generated by the DMS provider. Only applicable to dealers subscribed to DMS Appointment Insert integration" popover-trigger="outsideClick">Dispatch Code</span></label><div class="col-sm-6"><select class="form-control" name="dmsDispatchCode" ng-model="vm.dmsEntry.dmsDispatchCode"><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select></div><div class="col-sm-2"><button type="button" class="btn btn-default" name="dmsDispatchCode" ng-click="vm.lookupDispatchCodes()">Lookup Codes</button></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Does this delear require dispatch codes?" popover-trigger="outsideClick">Require Dispatch Code</span></label><div class="col-sm-6 margin-top-sm"><input type="checkbox" ng-model="vm.dmsEntry.requireDispatchCode" name="requireDispatchCode" class="checkbox-inline"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the Dispatch Make Code generated by the DMS provider. Only applicable to dealers subscribed to DMS Appointment Insert integration. If left empty, we will attempt to fill this automatically if initialize is set to true" popover-trigger="outsideClick">Dispatch Make Code</span></label><div class="col-sm-6"><select class="form-control" name="dmsDispatchMakeCode" ng-model="vm.dmsEntry.dmsDispatchMakeCode"><option value="">Empty</option><option value="{{item}}" ng-repeat="item in vm.dispatchMakeCodes">{{item}}</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the Labor Type for booking appointments provided by the DMS provider. Only applicable to dealers subscribed to DMS Appointment Insert integration" popover-trigger="outsideClick">Labor Type</span></label><div><div class="col-sm-6"><select class="form-control" name="dmsLaborType" ng-model="vm.dmsEntry.dmsLaborType"><option value="{{item.value}}" ng-repeat="item in vm.laborTypes">{{item.value}} {{item.text ? \'-\' : \'\'}} {{item.text}}</option></select></div><div class="col-sm-2"><button type="button" class="btn btn-default" name="dmsLaborTypes" ng-click="vm.lookupLaborTypes()">Lookup Codes</button></div></div></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.Tekion"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Product Package" popover-trigger="outsideClick">Product Package</span></label><div class="col-sm-6"><select class="form-control" name="productPackageLevel" ng-model="vm.dmsEntry.productPackageLevel"><option ng-value="item.value" ng-repeat="item in vm.productPackageLevels">{{item.text}}</option></select></div></div></div><div class="margin-bottom" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.DealerTrack && vm.dmsEntry.dmsPushType > 0 && !vm.dmsEntry.isXTimeEnabled"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the service type generated by the DMS provider. Only applicable to dealers subscribed to DMS Appointment Insert integration" popover-trigger="outsideClick">Service Type</span></label><div class="col-sm-6"><select class="form-control" name="dmsServiceTypes" ng-model="vm.dmsEntry.dmsServiceType" validation="required"><option value="{{item}}" ng-repeat="item in vm.serviceTypes">{{item}}</option></select></div><div class="col-sm-2"><button type="button" class="btn btn-default" name="dmsServiceType" ng-click="vm.lookupServiceTypes()">Lookup Types</button></div></div></div><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK || vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.DealerTrack"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="How often should we pull data from the DMS?" popover-trigger="outsideClick">Import Interval</span></label><div class="col-sm-6"><select class="form-control" name="dmsImportInterval" ng-model="vm.dmsEntry.dmsImportIntervalInSeconds" ng-options="i.value as i.text for i in vm.dmsIntervals" validation="required|in:{{vm.validation.acceptableDmsIntervals}}:alt=Field is required."></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Create RO" popover-trigger="outsideClick">Enable Create RO</span></label><div class="col-sm-1"><switch id="createRepairOrderEnabled" name="createRepairOrderEnabled" ng-model="vm.dmsEntry.createRepairOrderEnabled" class="green"></switch></div></div><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK && vm.dmsEntry.createRepairOrderEnabled && vm.hasCheckIn"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Fortellis Subscriber Id for repair orders. This may be the same or different from the parts search subscriber Id." popover-trigger="outsideClick">Repair Orders Subscriber Id</span></label><div class="col-sm-6"><input class="form-control better-placeholder" name="fortellisRepairOrderSubscriberId" ng-model="vm.dmsEntry.fortellisRepairOrderSubscriberId" type="text" placeholder="Fortellis Subscriber Id" maxlength="100"></div></div><div class="form-group" has-role="{{vm.rolesEnums.roleNames.systemAdmin}}" ng-if="vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.None && vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.ReynoldsERA && vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.ReynoldsPOWER"><div class="col-sm-offset-3 col-sm-6"><button type="button" class="btn btn-default" ladda="vm.importingOpCodes" name="importOpCodes" ng-click="vm.importOpCodes()" ng-disabled="vm.importingOpCodes"><span>Import OpCodes</span></button></div></div><hr ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.DealerTrack && vm.dmsEntry.dmsPushType > 0"><tekion-settings ng-model="vm" dms-system="vm.dmsEntry.dmsSystem" dms-transportation-types="vm.dmsEntry.dmsTransportationTypes" dealer-transportation-types="vm.dmsEntry.dealerTransportationTypes"></tekion-settings><div class="margin-top" ng-if="vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.None"><br><br><h3 for="fields">Loaner Identification (ROs)</h3><p>In order to properly identify loaner assignment from the DMS, complete the appointment and RO data mappings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Tooltip text TBD." popover-trigger="outsideClick">Appt Map</span></label><div class="col-sm-6"><select class="form-control" name="hasLoanerDataElementAppt" ng-init="vm.dmsEntry.hasLoanerDataElementAppt = vm.dmsEntry.hasLoanerDataElementAppt || null" ng-change="vm.apptMapChanged()" ng-model="vm.dmsEntry.hasLoanerDataElementAppt" ng-options="s.value as s.text for s in vm.identificationTypesAppt" validation="required"></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Tooltip text TBD." popover-trigger="outsideClick">Appt Data</span></label><div class="col-sm-6" ng-if="vm.dmsEntry.hasLoanerDataElementAppt !== 4 && vm.dmsEntry.hasLoanerDataElementAppt !==6"><input class="form-control" name="hasLoanerDataPatternAppt" ng-model="vm.dmsEntry.hasLoanerDataPatternAppt" type="text" validation="required"><div class="validation-hasLoanerDataPatternAppt validation text-danger"></div></div><div class="col-sm-6" ng-if="vm.dmsEntry.hasLoanerDataElementAppt === 4"><select class="form-control" name="hasLoanerDataPatternAppt" ng-model="vm.dmsEntry.hasLoanerDataPatternAppt" ng-options="s.value.toString() as s.text for s in vm.booleanOptions"></select></div><div class="inline-block" style="width:50%" ng-if="vm.dmsEntry.hasLoanerDataElementAppt === 6"><div class="col-xs-8"><select class="form-control" name="hasLoanerDataPatternAppt" ng-model="vm.dmsEntry.hasLoanerDataPatternAppt" ng-options="deliveryOption for deliveryOption in vm.apptDeliveryOptions"></select></div><div class="col-xs-4"><button type="button" class="btn btn-default" name="dmsDeliveryOptions" ng-click="vm.lookupApptDeliveryOptions()">Lookup Options</button></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Tooltip text TBD." popover-trigger="outsideClick">RO Map</span></label><div class="col-sm-6"><select class="form-control" name="hasLoanerDataElementRO" ng-init="vm.dmsEntry.hasLoanerDataElementRO = vm.dmsEntry.hasLoanerDataElementRO || null" ng-change="vm.roMapChanged()" ng-model="vm.dmsEntry.hasLoanerDataElementRO" ng-options="s.value as s.text for s in vm.identificationTypesRO" validation="required"></select></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Tooltip text TBD." popover-trigger="outsideClick">RO Data</span></label><div class="col-sm-6" ng-if="vm.dmsEntry.hasLoanerDataElementRO !== 4 && vm.dmsEntry.hasLoanerDataElementRO !== 6"><input class="form-control" name="hasLoanerDataPatternRO" ng-model="vm.dmsEntry.hasLoanerDataPatternRO" type="text" validation="required"><div class="validation-hasLoanerDataPatternRO validation text-danger"></div></div><div class="col-sm-6" ng-if="vm.dmsEntry.hasLoanerDataElementRO === 4"><select class="form-control" name="hasLoanerDataPatternRO" ng-model="vm.dmsEntry.hasLoanerDataPatternRO" ng-options="s.value.toString() as s.text for s in vm.booleanOptions"></select></div><div class="inline-block" style="width:50%" ng-if="vm.dmsEntry.hasLoanerDataElementRO === 6"><div class="col-xs-8"><select class="form-control" name="hasLoanerDataPatternRO" ng-model="vm.dmsEntry.hasLoanerDataPatternRO" ng-options="deliveryOption for deliveryOption in vm.roDeliveryOptions"></select></div><div class="col-xs-4"><button type="button" class="btn btn-default" name="dmsDeliveryOptions" ng-click="vm.lookupRoDeliveryOptions()">Lookup Options</button></div></div></div></div><div class="margin-top" ng-if="vm.dmsEntry.dmsSystem !== vm.dmsSystemEnum.None"><br><br><h3 for="fields">Custom Fields (For Appointment Product Only)</h3><p>The fields below may be required by this dealership\'s DMS and must be properly configured in order to book and update appointments. The Address, County, Country, and Language fields will be displayed in the booking UI and required. The Dealer Defined fields are not displayed, but require default values when enabled.</p><hr><div class="text-danger margin-bottom-30" ng-if="!vm.hasAppointments">Appointments has been disabled for this dealer. Enable it in the appointments admin to configure these fields.</div><div class="margin-bottom" ng-if="vm.hasAppointments"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable the Address, City, State, Zip fields?" popover-trigger="outsideClick">Address, City, State, Zip</span></label><div class="col-sm-6"><switch id="cityStateZipEnabled" name="cityStateZipEnabled" ng-model="vm.dmsEntry.cityStateZipEnabled" class="green"></switch></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable the County field?" popover-trigger="outsideClick">County</span></label><div class="col-sm-6"><switch id="countyEnabled" name="countyEnabled" ng-model="vm.dmsEntry.countyEnabled" class="green"></switch></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable the Country field?" popover-trigger="outsideClick">Country</span></label><div class="col-sm-6"><switch id="countryEnabled" name="countryEnabled" ng-model="vm.dmsEntry.countryEnabled" class="green"></switch></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable the Language field?" popover-trigger="outsideClick">Language</span></label><div class="col-sm-6"><switch id="cdkLanguageEnabled" name="cdkLanguageEnabled" ng-model="vm.dmsEntry.cdkLanguageEnabled" class="green"></switch></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Update the Password field?" popover-trigger="outsideClick">Password</span></label><div class="col-sm-1"><switch id="updateCDKPasswordEnabled" name="updateCDKPasswordEnabled" ng-model="vm.dmsEntry.updateCDKPasswordEnabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.updateCDKPasswordEnabled"><input class="form-control better-placeholder" name="updatedCDKPasswordEnabled" ng-model="vm.dmsEntry.updatedCDKPasswordEnabled" type="password" placeholder="ENTER PASSWORD" maxlength="15"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #1 field?" popover-trigger="outsideClick">Dealer Defined #1</span></label><div class="col-sm-1"><switch id="cdkDealerDefined1Enabled" name="cdkDealerDefined1Enabled" ng-model="vm.dmsEntry.cdkDealerDefined1Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined1Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined1Default" ng-model="vm.dmsEntry.cdkDealerDefined1Default" type="text" placeholder="DEFAULT VALUE" maxlength="25" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #2 field?" popover-trigger="outsideClick">Dealer Defined #2</span></label><div class="col-sm-1"><switch id="cdkDealerDefined2Enabled" name="cdkDealerDefined2Enabled" ng-model="vm.dmsEntry.cdkDealerDefined2Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined2Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined2Default" ng-model="vm.dmsEntry.cdkDealerDefined2Default" type="text" placeholder="DEFAULT VALUE" maxlength="25" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #3 field?" popover-trigger="outsideClick">Dealer Defined #3</span></label><div class="col-sm-1"><switch id="cdkDealerDefined3Enabled" name="cdkDealerDefined3Enabled" ng-model="vm.dmsEntry.cdkDealerDefined3Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined3Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined3Default" ng-model="vm.dmsEntry.cdkDealerDefined3Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #4 field?" popover-trigger="outsideClick">Dealer Defined #4</span></label><div class="col-sm-1"><switch id="cdkDealerDefined4Enabled" name="cdkDealerDefined4Enabled" ng-model="vm.dmsEntry.cdkDealerDefined4Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined4Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined4Default" ng-model="vm.dmsEntry.cdkDealerDefined4Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #5 field?" popover-trigger="outsideClick">Dealer Defined #5</span></label><div class="col-sm-1"><switch id="cdkDealerDefined5Enabled" name="cdkDealerDefined5Enabled" ng-model="vm.dmsEntry.cdkDealerDefined5Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined5Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined1Default" ng-model="vm.dmsEntry.cdkDealerDefined5Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #6 field?" popover-trigger="outsideClick">Dealer Defined #6</span></label><div class="col-sm-1"><switch id="cdkDealerDefined6Enabled" name="cdkDealerDefined6Enabled" ng-model="vm.dmsEntry.cdkDealerDefined6Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined6Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined6Default" ng-model="vm.dmsEntry.cdkDealerDefined6Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #7 field?" popover-trigger="outsideClick">Dealer Defined #7</span></label><div class="col-sm-1"><switch id="cdkDealerDefined7Enabled" name="cdkDealerDefined7Enabled" ng-model="vm.dmsEntry.cdkDealerDefined7Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined7Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined7Default" ng-model="vm.dmsEntry.cdkDealerDefined7Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #8 field?" popover-trigger="outsideClick">Dealer Defined #8</span></label><div class="col-sm-1"><switch id="cdkDealerDefined8Enabled" name="cdkDealerDefined8Enabled" ng-model="vm.dmsEntry.cdkDealerDefined8Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined8Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined8Default" ng-model="vm.dmsEntry.cdkDealerDefined8Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Dealer Defined #9 field?" popover-trigger="outsideClick">Dealer Defined #9</span></label><div class="col-sm-1"><switch id="cdkDealerDefined9Enabled" name="cdkDealerDefined9Enabled" ng-model="vm.dmsEntry.cdkDealerDefined9Enabled" class="green"></switch></div><div class="col-sm-3" ng-if="vm.dmsEntry.cdkDealerDefined9Enabled"><input class="form-control better-placeholder" name="cdkDealerDefined9Default" ng-model="vm.dmsEntry.cdkDealerDefined9Default" type="text" placeholder="DEFAULT VALUE" maxlength="62" required="" validation="required"></div></div></div><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.AutoMate && vm.hasMobileGarage"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="If the dealer wants to mark appointments as mobile garage set this value" popover-trigger="outsideClick">Mobile Garage Delivery Flag</span></label><div class="col-xs-4"><select class="form-control" name="mobileGarageDeliveryFlags" ng-model="vm.dmsEntry.mobileGarageDeliveryFlag" ng-options="deliveryOption for deliveryOption in vm.mobileGarageDeliveryOptions"><option value="">None</option></select></div><div class="col-xs-4"><button type="button" class="btn btn-default" name="dmsDeliveryOptionsMobileGarage" ng-click="vm.lookupMobileGarageDeliveryOptions()">Lookup Options</button></div></div><div ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.AutoMate"><hr><h3>AutoMate Publish / Subscribe Configuration</h3><p class="text-muted">When enabled, this dealer will receive real-time event notifications from AutoMate (Customers, Vehicles, Appointments, and Repair Orders). Subscriptions are registered automatically on enable and removed on disable when no other dealers share the same AutoMate Dealer ID.</p><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable AutoMate real-time pub/sub event delivery for this dealer." popover-trigger="outsideClick">Enable Pub/Sub</span></label><div class="col-sm-6"><switch id="isPubSubEnabled" name="isPubSubEnabled" ng-model="vm.dmsEntry.isPubSubEnabled" class="green"></switch></div></div><div ng-if="vm.dmsEntry.isPubSubEnabled"><div class="form-group"><div class="col-sm-6"><button type="button" class="btn btn-default" ladda="vm.autoMatePubSubLoading" ng-click="vm.loadAutoMateSubscriptions()" ng-disabled="vm.autoMatePubSubLoading">Refresh Subscriptions</button></div></div><div class="form-group"><div class="col-sm-12"><div class="panel panel-default"><div class="panel-heading justify-content display-flex align-items-center cursor-pointer" ng-click="vm.autoMatePubSubExpanded = !vm.autoMatePubSubExpanded"><span class="panel-title">Active Subscriptions</span> <i class="material-icons md-20">{{vm.autoMatePubSubExpanded ? \'expand_more\' : \'chevron_right\'}}</i></div><div class="panel-body" ng-show="vm.autoMatePubSubExpanded"><div ng-if="vm.autoMatePubSubLoading" class="text-center text-muted"><img src="assets/images/ajax-loader.gif"> Loading...</div><div ng-if="!vm.autoMatePubSubLoading && vm.autoMatePubSubSubscriptions.length === 0"><p class="text-muted"><em>No active subscriptions found.</em></p></div><table class="table table-condensed table-bordered" ng-if="!vm.autoMatePubSubLoading && vm.autoMatePubSubSubscriptions.length > 0"><thead><tr><th>Operation</th><th>Type</th><th>Callback URL</th><th></th></tr></thead><tbody><tr ng-repeat="sub in vm.autoMatePubSubSubscriptions"><td>{{sub.operation}}</td><td>{{sub.type}}</td><td><small class="text-muted">{{sub.callback}}</small></td><td><a href="#" class="theme-link" ng-click="vm.deleteAutoMateSubscription(sub.operation, sub.type)">DELETE</a></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class="m-t-lg"><h3 for="fields">Custom Fields (For Check-In and Inspect Products Only)</h3><p>The fields below may be required by this dealership\'s DMS and must be properly configured in order to book and update repair orders.</p><hr><div class="m-b"><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Fortellis Environment Type." popover-trigger="outsideClick">Repair Orders Environment</span></label><div class="col-sm-6"><select class="form-control" placeholder="Environment" name="fortellisRepairOrderEnvironmentType" ng-model="vm.dmsEntry.fortellisRepairOrderEnvironmentType" ng-options="s.value as s.text for s in vm.dmsEnvironmentTypes"></select></div></div></div><div class="m-b"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Create RO" popover-trigger="outsideClick">Enable Parts Search</span></label><div class="col-sm-1"><switch id="partsSearchEnabled" name="partsSearchEnabled" ng-model="vm.dmsEntry.partsSearchEnabled" class="green"></switch></div></div><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK && vm.dmsEntry.partsSearchEnabled"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Fortellis Subscriber Id for parts search. This may be the same of different from the repair order subscriber Id." popover-trigger="outsideClick">Parts Search Subscriber Id</span></label><div class="col-sm-6"><input class="form-control better-placeholder" name="fortellisPartsSearchSubscriberId" ng-model="vm.dmsEntry.fortellisPartsSearchSubscriberId" type="text" placeholder="Fortellis Subscriber Id" maxlength="100"></div></div><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK && vm.dmsEntry.partsSearchEnabled"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Fortellis Department Id for parts search." popover-trigger="outsideClick">Parts Search Department Id</span></label><div class="col-sm-6"><input class="form-control better-placeholder" name="fortellisPartsSearchDepartmentId" ng-model="vm.dmsEntry.fortellisPartsSearchDepartmentId" type="text" placeholder="Department Id" maxlength="100"></div></div><div class="form-group" ng-if="vm.dmsEntry.dmsSystem === vm.dmsSystemEnum.CDK && vm.dmsEntry.partsSearchEnabled"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Fortellis Environment Type." popover-trigger="outsideClick">Parts Search Environment</span></label><div class="col-sm-6"><select class="form-control" placeholder="Environment" name="fortellisPartsSearchEnvironmentType" ng-model="vm.dmsEntry.fortellisPartsSearchEnvironmentType" ng-options="s.value as s.text for s in vm.dmsEnvironmentTypes"></select></div></div></div></div><div><br><br><h3>DMS Event Log</h3><p>Recent DMS events are listed below</p><table class="table table-hover"><thead><tr><th>Date/Time</th><th>Message</th><th>Error Code</th></tr></thead><tbody><tr ng-repeat="record in vm.dmsImportRecords"><td>{{record.createdDate | localDate}}</td><td>{{record.message}}</td><td>{{record.errorCode}}</td></tr><tr ng-if="!vm.dmsImportRecordsLoading && (!vm.dmsImportRecords || !vm.dmsImportRecords.length)"><td colspan="3">No DMS Import records are available</td></tr><tr ng-if="vm.dmsImportRecordsLoading"><td colspan="3">Loading ...</td></tr></tbody></table></div></div><div id="xtimeIntegrationFields" ng-show="vm.tab === vm.tabs.XTime"><h3>XTIME Settings</h3><p>If this is an XTIME integrated dealer, choose the dealer\'s XTIME setting and enter their configuration settings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Is the Dealer XTime Integrated?" popover-trigger="outsideClick">XTime Integrated?</span></label><div class="col-sm-6"><switch id="isXTimeEnabled" name="isXTimeEnabled" ng-model="vm.dmsEntry.isXTimeEnabled" class="green"></switch></div></div><div ng-if="vm.dmsEntry.isXTimeEnabled"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the XTime Dealer ID?" popover-trigger="outsideClick">XTime Dealer ID</span></label><div class="col-sm-6"><input type="text" ng-model="vm.dmsEntry.xTimeDealerId" ng-required="vm.dmsEntry.isXTimeEnabled" class="form-control" name="xTimeDealerId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the XTime Dealer Code?" popover-trigger="outsideClick">XTime Dealer Code</span></label><div class="col-sm-6"><input type="text" ng-model="vm.dmsEntry.xTimeDealerCode" ng-required="vm.dmsEntry.isXTimeEnabled" class="form-control" name="xTimeDealerCode"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enabling will automatically push customer generated appointments and updates generated by customers and dashboard users to XTime." popover-trigger="outsideClick">Push Appts To XTime</span></label><div class="col-sm-6"><select class="form-control" name="dmsPushType" ng-model="vm.dmsEntry.dmsPushType" ng-options="s.value as s.text for s in vm.dmsPushTypes"></select></div></div></div></div><div id="paymentsTab" ng-show="vm.tab === vm.tabs.Payments"><payment-settings ng-model="vm.dmsEntry.paymentConfiguration" dms-entry="vm.dmsEntry"></payment-settings></div><div id="autoPointFields" ng-show="vm.tab === vm.tabs.AutoPoint"><h3>AUTOPOINT Settings</h3><p>If this is an AUTOPOINT integrated dealer, choose the dealer\'s AUTOPOINT setting and enter their configuration settings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Is the Dealer AutoPoint Integrated?" popover-trigger="outsideClick">AutoPoint Integrated?</span></label><div class="col-sm-6"><switch id="isAutoPointEnabled" name="isAutoPointEnabled" ng-model="vm.integrationData.autoPoint.isAutoPointEnabled" class="green"></switch></div></div><div ng-if="vm.integrationData.autoPoint.isAutoPointEnabled"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the AutoPoint Dealer ID?" popover-trigger="outsideClick">AutoPoint Dealer ID</span></label><div class="col-sm-6"><input ng-model="vm.integrationData.autoPoint.autoPointDealerId" ng-required="vm.integrationData.autoPoint.isAutoPointEnabled" class="form-control no-spinners" name="autoPointDealerId" id="autoPointDealerId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the AutoPoint Shop ID?" popover-trigger="outsideClick">AutoPoint Shop ID</span></label><div class="col-sm-6"><input type="number" ng-model="vm.integrationData.autoPoint.autoPointShopId" ng-required="vm.integrationData.autoPoint.isAutoPointEnabled" class="form-control no-spinners" name="autoPointShopId" id="autoPointShopId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the AutoPoint OrgUnitCacheKey?" popover-trigger="outsideClick">AutoPoint OrgCacheKey</span></label><div class="col-sm-6"><input type="text" ng-model="vm.integrationData.autoPoint.autoPointOrgCacheKey" ng-required="vm.integrationData.autoPoint.isAutoPointEnabled" class="form-control no-spinners" name="autoPointOrgCacheKey" id="autoPointOrgCacheKey"></div></div></div></div><div id="loanerManagementFields" ng-show="vm.tab === vm.tabs.LoanerManagement"><loaner-integration ng-model="vm.integrationData.loaner" dealer-id="vm.locationId"></loaner-integration></div><div id="digniFiFields" ng-show="vm.tab === vm.tabs.DigniFi"><h3>DigniFi Widget Settings</h3><p>To enable DigniFi\'s Prequalification Widget to display on this dealer\'s customer pages, configure it below.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable DigniFi?" popover-trigger="outsideClick">Enable</span></label><div class="col-sm-6"><switch id="enableDigniFi" name="enableDigniFi" ng-model="vm.integrationData.digniFi.isDigniFiEnabled" class="green"></switch></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the DigniFi Dealer ID?" popover-trigger="outsideClick">DigniFi Dealer ID</span></label><div class="col-sm-2"><input type="text" ng-model="vm.integrationData.digniFi.digniFiDealerId" ng-required="vm.integrationData.digniFi.isDigniFiEnabled" class="form-control better-placeholder" name="digniFiDealerId" placeholder="Dealer Id"></div></div></div><div id="onDemandFields" ng-show="vm.tab === vm.tabs.OnDemand"><div class="margin-bottom-30"><h3>Provider Settings</h3><hr><div ng-if="vm.rideProviderTripTypeInstanceDetails.dealerUberOrgId != null"><b>Uber Organization StoreId:</b> {{ vm.rideProviderTripTypeInstanceDetails.dealerUberOrgId }}</div><div ng-if="vm.rideProviderTripTypeInstanceDetails.dealerUberOrgId == null"><div class="col-sm-6">Uber Organization Id has not been created</div><div class="col-sm-6"><button type="button" class="btn btn-primary" ladda="isDataLoading" ng-click="vm.createUberOrganization(vm.locationId)">Create Now</button></div></div></div><br><br><br><div class="margin-bottom-30 margin-top-30"><h3>Provider Conversion</h3><p><b>NOTE: Do not use this utility with trips that are in progress.</b></p><hr><div ng-if="vm.rideProviderTripTypeInstanceDetails.dealerTripTypes != null && vm.rideProviderTripTypeInstanceDetails.dealerTripTypes.length > 0"><div ng-repeat="tripTypeInstance in vm.rideProviderTripTypeInstanceDetails.dealerTripTypes"><div class="form-group"><label class="col-sm-5 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable Uber for trip type" popover-trigger="outsideClick">{{tripTypeInstance.name}}</span> ( <span ng-if="tripTypeInstance.rideProviderType == vm.rideProviderTypes.lyft">Lyft is enabled</span> <span ng-if="tripTypeInstance.rideProviderType != vm.rideProviderTypes.lyft">Uber is enabled</span> )</label><div class="col-sm-3"><button class="btn btn-primary" ng-disabled="vm.changingRideProvider || vm.disableConvertRideProvider" ng-click="vm.changeTripTypeRideProvider(tripTypeInstance, vm.rideProviderTypes.uber)" ng-if="tripTypeInstance.rideProviderType == vm.rideProviderTypes.lyft">Convert To Uber</button> <button class="btn btn-primary" ng-disabled="vm.changingRideProvider || vm.disableConvertRideProvider" ng-click="vm.changeTripTypeRideProvider(tripTypeInstance, vm.rideProviderTypes.lyft)" ng-if="tripTypeInstance.rideProviderType != vm.rideProviderTypes.lyft">Convert To Lyft</button></div></div></div></div><div ng-if="vm.rideProviderTripTypeInstanceDetails.dealerTripTypes == null || vm.rideProviderTripTypeInstanceDetails.dealerTripTypes.length == 0"><p>There are no trip types to convert.</p></div></div><br><br><br><div class="margin-bottom-30 margin-top-30"><h3>Bulk Uber Organization Creator</h3><p>Place a comma delimited list of dealer ids to bulk create Uber organization ids</p><hr><div class="form-group"><div class="col-sm-6"><textarea ng-model="vm.dealerIds" class="form-control resize-none" name="dealerIds"></textarea></div><div class="col-sm-6"><button class="btn btn-primary" ng-click="vm.createUberOrganizations(vm.dealerIds)">Create</button></div></div></div></div></form></div></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list" type="button">Close</button> <button class="btn btn-primary" ng-click="vm.updateDMS()" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="inputForm.$invalid" type="submit">Update</button></div></div></div></div><location-sub-menu trip-types="vm.tripTypeIntances" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-lineitems.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><form role="form" id="locationLineItemForm" name="locationLineItemForm" class="form-horizontal tab-lineitems self-serve-form" novalidate=""><div class="col-xs-11 margin-bottom self-serve-only"><div class="modal-header self-serve-only padding-none margin-none" ng-if="vm.ctrlOptions.adminView"><h2 class="modal-title margin-none padding-none">Manage Services</h2></div><div class="row margin-bottom-md" ng-if="vm.ctrlOptions.adminView"><div class="col-sm-5 field-wrapper" ng-if="vm.resolvedLocationList"><label for="selectedLocation">SELECT A LOCATION</label><select selectlabel="" class="form-control" id="selectedLocation" name="selectedLocation" allow-null-option="Select a location" ng-options="l as l.name for l in vm.resolvedLocationList track by l.id" ng-model="vm.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.loadingDepartments"></select></div></div></div><div class="row" ng-if="vm.initializingLocation"><div class="col-xs-12 margin-left-20"><img src="assets/images/ajax-loader.gif"> <span>Loading...</span></div></div><div ng-if="vm.selectedLocation && !vm.initializingLocation"><div class="col-xs-12 text-danger margin-bottom" ng-if="vm.showServiceTypeError()">ERROR RETRIEVING DMS SERVICE TYPES</div><div class="col-xs-12 margin-bottom ng-hide" ng-show="!vm.showServiceTypeError()"><h3 class="line-item-mapping-heading margin-top-30" ng-click="vm.displayAutomaticOpCodes = !vm.displayAutomaticOpCodes"><i class="material-icons md-24 ng-scope" ng-if="!vm.displayAutomaticOpCodes">expand_more</i> <i class="material-icons md-24 ng-scope" ng-if="vm.displayAutomaticOpCodes">expand_less</i> Automatic OpCodes</h3><div ng-show="vm.displayAutomaticOpCodes" ng-class="ng-hide" class="padding-bottom-md"><p class="padding-left-25">The opcodes below are automatically added to an appointment when applicable. They are not displayed on the consumer booking experience.</p><hr class="margin-top-sm margin-bottom-md"><div class="row bold margin-bottom-md automatic-row-header"><div class="col-xs-3 padding-right-none desc-header"></div><div class="col-xs-1 padding-right-none header-col">OP CODE</div><div class="col-xs-2 padding-right-none pay-type-header"></div><div class="col-xs-1 padding-right-none"></div><div class="col-xs-1 padding-right-none"></div><div class="col-xs-2 padding-right-none header-col" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)">DISP CODE</div><div class="col-xs-2 padding-right-none header-col" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)">SERV TYPE</div><div class="col-xs-1 padding-right-none"></div><div class="col-xs-1 padding-left-none">ENABLED</div></div><div class="list-unstyled margin-bottom"><uib-accordion class="line-item-mapping automatic-op-codes"><div class="group-2" uib-accordion-group="" ng-repeat="lineItem in vm.mergedOpCodeList | filter: { isAutomatic: true, isDeleted: false } track by lineItem.uid" is-open="lineItem.isOpen"><uib-accordion-heading><div class="panel-heading" ng-click="vm.headerClicked($event, (locationLineItemForm.$invalid || vm.hasInvalidAutomaticLineItems()) && lineItem.isValid);"><div class="padding-none"><div class="panel-title"><div class="row read-only-row text-uppercase"><div class="col-xs-3 padding-right-none">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem)" class="text-danger validation font-normal">*Invalid Form Data</span></div><div class="col-xs-1 padding-none">{{lineItem.opCode}}</div><div class="col-xs-2 padding-right-none">&nbsp;</div><div class="col-xs-1 padding-right-none">&nbsp;</div><div class="col-xs-1 padding-right-none">&nbsp;</div><div class="col-xs-2 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)">{{lineItem.dispatchCode}}</div><div class="col-xs-2 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)">{{lineItem.serviceType}}</div><div class="col-xs-1 padding-right-none">&nbsp;</div><div class="col-xs-1 padding-right-none collapsed-row" ng-click="$event.stopPropagation();$event.preventDefault();"><switch id="automatic-consumer-collasped-{{::lineItem.uid}}" name="automatic-consumer-collasped-{{::lineItem.uid}}" ng-model="lineItem.isEnabled" class="green" ng-change="vm.headerSwitched(lineItem.isEnabled, lineItem)"></switch></div></div></div></div></div></uib-accordion-heading><div class="panel-body"><div class="row edit-row" ng-click="$event.stopPropagation();$event.preventDefault();"><div class="col-xs-3 padding-right-none text-uppercase font-bold padding-top-sm">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem)" class="text-danger validation font-normal"><br>*Invalid Form Data</span></div><div class="col-xs-1 padding-none" ng-class="{\'fake-required-select2\': lineItem.isEnabled === true}"><select select2="" id="opcode-{{::lineItem.uid}}" name="opcode-{{::lineItem.uid}}" on-change="vm.opCodeSearchSelected(lineItem, selectedResult)" init-value="lineItem.selectedOpCode" placeholder="Opcode" min-input-length="1" format-for-selection="vm.formatForSelection" format-for-dropdown="vm.formatForDropdown" query="vm.opCodeSearchQuery" ng-if="vm.select2Ready && (vm.dmsSystem === vm.dmsEnum.CDK || vm.dmsSystem === vm.dmsEnum.DealerTrack || vm.dmsSystem === vm.dmsEnum.AutoMate || vm.dmsSystem === vm.dmsEnum.Motive || vm.dmsSystem === vm.dmsEnum.Tekion)" ng-model="lineItem.selectedOpCode" validation-error-to="#automatic-opcode-error-{{::lineItem.uid}}" validation="custom: vm.validation.valOpCode(lineItem):alt=OpCode"></select><input type="text" id="opcode-{{::lineItem.uid}}" name="opcode-{{::lineItem.uid}}" class="form-control normal better-placeholder" ng-if="::(vm.dmsSystem === vm.dmsEnum.ReynoldsPOWER || vm.dmsSystem === vm.dmsEnum.ReynoldsERA || vm.dmsSystem === vm.dmsEnum.None)" ng-model="lineItem.opCode" validateonempty="true" ng-class="{\'fake-required\': lineItem.isEnabled === true}" validation="custom: vm.validation.valOpCode(lineItem):alt=OpCode" placeholder="OPCODE" validation-error-to="#automatic-opcode-error-{{::lineItem.uid}}" ng-maxlength="::vm.getOpCodeMaxLength()"><div id="automatic-opcode-error-{{::lineItem.uid}}" class="validation text-danger"></div></div><div class="col-xs-2 field-wrapper padding-right-none">&nbsp;</div><div class="col-xs-1 padding-right-none">&nbsp;</div><div class="col-xs-1 padding-right-none">&nbsp;</div><div class="col-xs-2 padding-right-none field-wrapper" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)"><label for="dispatchcode-{{::lineItem.uid}}">DISP CODE</label><select selectlabel="" id="dispatchcode-{{::lineItem.uid}}" name="dispatchcode-{{::lineItem.uid}}" class="form-control normal" ng-model="lineItem.dispatchCode" ng-class="{\'fake-required\': vm.requireDispatchCode === true}" validation="custom: vm.validation.valRequiredIfEnabled(lineItem.dispatchCode, lineItem):alt=Field is Required"><option value="">Disp code</option><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide code-spinner" ng-show="vm.loadingDispatchCodes"></div><div class="col-xs-2 padding-right-none field-wrapper" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)"><label for="dmsServiceTypes-{{::lineItem.uid}}">SERVICE TYPE</label><select selectlabel="" validation="custom: vm.validation.valRequiredIfEnabled(lineItem.serviceType, lineItem):alt=Field is Required" class="form-control" name="dmsServiceTypes-{{::lineItem.uid}}" ng-model="lineItem.serviceType"><option value="">Service type</option><option value="{{item}}" ng-repeat="item in vm.serviceTypes">{{item}}</option></select></div><div class="col-xs-1 padding-right-none">&nbsp;</div><div class="col-xs-1"><center><switch id="automatic-isenabled-{{::lineItem.uid}}" name="automatic-isenabled-{{::lineItem.uid}}" ng-model="lineItem.isEnabled" class="green line-item-autoswitch" ng-change="vm.headerSwitched(lineItem.isEnabled, lineItem)"></switch></center></div></div><div class="row"><div class="col-xs-12 margin-top-md"><input type="text" id="automatic-lineItem-dashboard-description-{{::lineItem.uid}}" name="automatic-lineItem-dashboard-description-{{::lineItem.uid}}" class="form-control better-placeholder last-input" ng-model="lineItem.dashboardDescription" validation="required:alt=Field is Required" placeholder="DESCRIPTION"></div></div><a href="#" class="pull-right margin-top theme-link" ng-if="lineItem.dealerSystemAppointmentServiceId === vm.systemOpcodeType.customAutomaticOpCode" ng-click="vm.deleteLine(lineItem)">DELETE</a></div></div></uib-accordion><a ng-if="!vm.showServiceTypeError() && vm.displayOtherOpCodes && !vm.hasInvalidAutomaticLineItems()" href="#" id="automatic-add-new-service" class="pull-right theme-link" ng-click="vm.addNewLine(true)">ADD NEW</a></div></div><hr><div class="row padding-md margin-bottom"><div class="col-xs-10 col-sm-4 padding-left-none field-wrapper"><label for="departmentFilter">FILTER BY DEPARTMENT</label><select selectlabel="" class="form-control normal text-uppercase" id="departmentFilter" name="departmentFilter" ng-options="dept.id as dept.name for dept in vm.locationDepartments | filter: {isDisabled: false}" ng-model="vm.departmentFilter" ng-change="vm.departmentChanged(locationLineItemForm)" required=""><option value="">Filter by department</option></select></div><div class="col-xs-10 col-sm-4"><input type="text" id="textsearch" name="textsearch" autocomplete="nope" ng-model-options="{ debounce: 1000 }" ng-model="vm.textFilter" ng-change="vm.textFilterChanged()" class="form-control no-spinners better-placeholder" placeholder="SEARCH OPCODES/DESCRIPTIONS"></div><div class="col-xs-10 col-sm-4 field-wrapper"><label for="showInFilter">FILTER BY DISPLAYED IN</label><select selectlabel="" class="form-control normal text-uppercase" id="showInFilter" name="showInFilter" ng-options="type.value as type.text for type in vm.showInFilters" ng-model="vm.showInFilter" ng-change="vm.showInFilterChanged()"><option value="">Filter by displayed in</option></select></div></div><div class="row padding-md margin-bottom" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)"><div class="col-xs-6 col-sm-3 padding-left-none field-wrapper"><label for="default-dispatchcode-{{::vm.selectedDepartment.id}}">DEFAULT DISP CODE</label><select selectlabel="" class="form-control" id="default-dispatchcode-{{::vm.selectedDepartment.id}}" name="default-dispatchcode-{{::vm.selectedDepartment.id}}" ng-model="vm.selectedDepartment.defaultDispatchCode" ng-class="{\'last-input\': !lineItem.showInDashboard && !lineItem.showInConsumer}"><option value="">Default disp code</option><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide code-spinner" ng-show="vm.loadingDispatchCodes"></div><div class="col-xs-6 col-sm-3 padding-left-none" id="def-dis-label">(optional)</div></div><div ng-if="vm.departmentFilter"><div ng-if="!vm.isOnlyDealerAdmin"><h3 class="line-item-mapping-heading" ng-click="vm.displayGenericOpCodes = !vm.displayGenericOpCodes"><i class="material-icons md-24 ng-scope" ng-if="!vm.displayGenericOpCodes">expand_more</i> <i class="material-icons md-24 ng-scope" ng-if="vm.displayGenericOpCodes">expand_less</i> Generic and Deferred OpCodes</h3><div ng-show="vm.displayGenericOpCodes" class="ng-hide"><p class="padding-left-25">The opcodes below are used to support the generic free-form field on the consumer booking experience and to enable recalls, maintenance, and deferred options on both the consumer and dealer booking screens.</p><hr class="margin-top-sm margin-bottom-md"><div class="row bold margin-bottom-md"><div class="col-xs-3 padding-right-none desc-header"></div><div class="col-xs-1 padding-right-none">OP CODE</div><div class="col-xs-2 padding-right-none pay-type-header">PAY TYPE</div><div class="col-xs-1 padding-right-none">RETAIL EST</div><div class="col-xs-1 padding-right-none" ng-click="vm.sort(vm.sorting.laborHours)">TIME</div><div class="col-xs-2 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)">DISP CODE</div><div class="col-xs-2 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)">SERV TYPE</div><div class="col-xs-1 padding-right-none">DASH</div><div class="col-xs-1 padding-left-none">CONSUMER</div></div><div class="list-unstyled margin-bottom"><uib-accordion class="line-item-mapping"><div class="group-1" uib-accordion-group="" ng-repeat="lineItem in vm.mergedOpCodeList | filter: vm.filterGenericItems track by lineItem.uid" is-open="lineItem.isOpen"><uib-accordion-heading><div class="panel-heading" ng-click="vm.headerClicked($event, (locationLineItemForm.$invalid || vm.hasInvalidLineItems()) && lineItem.isValid);"><div class="padding-none"><div class="panel-title"><div class="row read-only-row text-uppercase"><div class="col-xs-3 padding-right-none"><span ng-if="lineItem.isGeneric==true" title="This is for the text area the consumer enters \'What is wrong with your vehicle\' in the consumer booking page.">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem) && !lineItem.isOpen" class="text-danger validation font-normal"><br>*Invalid Form Data</span></span> <span ng-if="lineItem.isRecommendedMaintenance==true" title="This is for Recommended Maintenance Items">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem) && !lineItem.isOpen" class="text-danger validation font-normal"><br>*Invalid Form Data</span></span> <span ng-if="lineItem.isRecommendedMaintenance == false && lineItem.isGeneric == false">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem) && !lineItem.isOpen" class="text-danger validation font-normal"><br>*Invalid Form Data</span></span></div><div class="col-xs-1 padding-none">{{lineItem.opCode}}</div><div class="col-xs-2 padding-right-none">{{lineItem.payType || \'N/A\'}}</div><div class="col-xs-1 padding-right-none">{{lineItem.retailPrice | currency}}</div><div class="col-xs-1 padding-right-none">{{lineItem.laborHours | number:2}}</div><div class="col-xs-2 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)">{{lineItem.dispatchCode}}</div><div class="col-xs-2 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)">{{lineItem.serviceType}}</div><div class="col-xs-1 padding-right-none collapsed-row" ng-click="$event.stopPropagation();$event.preventDefault();"><switch ng-if="::(lineItem.isGeneric === false)" id="generic-dashboard-collapsed-{{::lineItem.uid}}" name="generic-dashboard-collapsed-{{::lineItem.uid}}" ng-model="lineItem.showInDashboard" class="green" ng-change="vm.headerSwitched(lineItem.showInDashboard, lineItem)"></switch><span ng-if="::(lineItem.isGeneric === true)">&nbsp;&nbsp;N/A</span></div><div class="col-xs-1 padding-right-none collapsed-row" ng-click="$event.stopPropagation();$event.preventDefault();"><switch id="generic-consumer-collasped-{{::lineItem.uid}}" name="generic-consumer-collasped-{{::lineItem.uid}}" ng-model="lineItem.showInConsumer" class="green" ng-change="vm.headerSwitched(lineItem.showInConsumer, lineItem)"></switch></div></div></div></div></div></uib-accordion-heading><div class="panel-body"><div class="row edit-row" ng-click="$event.stopPropagation();$event.preventDefault();"><div class="col-xs-3 padding-right-none text-uppercase" ng-if="lineItem.dealerSystemAppointmentServiceId"><span class="font-bold padding-top-md inline-block" ng-if="lineItem.isGeneric==true" title="This is for the text area the consumer enters \'What is wrong with your vehicle\' in the consumer booking page.">{{lineItem.name}}</span> <span ng-if="lineItem.isRecommendedMaintenance==true" title="This is for Recommended Maintenance Items"><b>{{lineItem.name}}</b></span> <span ng-if="lineItem.isRecommendedMaintenance == false && lineItem.isGeneric == false"><b>{{lineItem.name}}</b></span></div><div class="col-xs-3" ng-if="!lineItem.dealerSystemAppointmentServiceId"><input type="text" id="generic-name-{{::lineItem.uid}}" name="generic-name-{{::lineItem.uid}}" ng-keydown="$event.stopPropagation();" class="form-control better-placeholder" ng-model="lineItem.name" validation="required:alt=Field is Required" placeholder="NAME"></div><div class="col-xs-1 padding-none" ng-class="{\'fake-required-select2\': lineItem.showInConsumer === true || lineItem.showInDashboard === true}"><select select2="" id="opcode-{{::lineItem.uid}}" name="opcode-{{::lineItem.uid}}" on-change="vm.opCodeSearchSelected(lineItem, selectedResult)" init-value="lineItem.selectedOpCode" placeholder="Opcode" min-input-length="1" format-for-selection="vm.formatForSelection" format-for-dropdown="vm.formatForDropdown" query="vm.opCodeSearchQuery" validation-error-to="#generic-opcode-error-{{::lineItem.uid}}" ng-if="vm.select2Ready && (vm.dmsSystem === vm.dmsEnum.CDK || vm.dmsSystem === vm.dmsEnum.DealerTrack || vm.dmsSystem === vm.dmsEnum.AutoMate || vm.dmsSystem === vm.dmsEnum.Motive || vm.dmsSystem === vm.dmsEnum.Tekion)" ng-model="lineItem.selectedOpCode" validation="custom: vm.validation.valOpCode(lineItem):alt=OpCode"></select><input type="text" id="opcode-{{::lineItem.uid}}" name="opcode-{{::lineItem.uid}}" class="form-control normal better-placeholder" ng-if="::(vm.dmsSystem === vm.dmsEnum.ReynoldsPOWER || vm.dmsSystem === vm.dmsEnum.ReynoldsERA || vm.dmsSystem === vm.dmsEnum.None)" ng-model="lineItem.opCode" validateonempty="true" validation="custom: vm.validation.valOpCode(lineItem):alt=OpCode" placeholder="OPCODE" ng-class="{\'fake-required\': lineItem.showInConsumer === true || lineItem.showInDashboard === true}" validation-error-to="#generic-opcode-error-{{::lineItem.uid}}" ng-maxlength="::vm.getOpCodeMaxLength()"><div id="generic-opcode-error-{{::lineItem.uid}}" class="validation text-danger"></div></div><div class="col-xs-2 field-wrapper padding-right-none"><label for="generic-paytype-{{::lineItem.uid}}">PAY TYPE</label><select selectlabel="" class="form-control normal text-uppercase" id="generic-paytype-{{::lineItem.uid}}" name="generic-paytype-{{::lineItem.uid}}" ng-options="type.value as type.text for type in vm.paymentTypes" ng-model="lineItem.payType"><option value="">Pay type</option></select></div><div class="col-xs-1 padding-right-none"><input type="text" id="retailprice-{{::lineItem.uid}}" name="retailprice-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.retailPrice" ng-pattern="vm.decimalRegex" step="0.01" validation="custom: vm.validation.valDecimal(lineItem.retailPrice, lineItem):alt=RetailPrice" placeholder="RETAIL EST"></div><div class="col-xs-1 padding-right-none"><input type="number" id="laborhours-{{::lineItem.uid}}" name="laborhours-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.laborHours" ng-class="{\'last-input\': !lineItem.showInDashboard && !lineItem.showInConsumer && (vm.dmsSystem === vm.dmsEnum.ReynoldsPOWER || vm.dmsSystem === vm.dmsEnum.ReynoldsERA || vm.dmsSystem === vm.dmsEnum.None)}" ng-pattern="vm.decimalRegex" validation="custom: vm.validation.valDecimal(lineItem.laborHours, lineItem):alt=LaborHours" placeholder="TIME EST"></div><div class="col-xs-2 padding-right-none field-wrapper" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)"><label for="dispatchcode-{{::lineItem.uid}}">DISP CODE</label><select selectlabel="" id="dispatchcode-{{::lineItem.uid}}" name="dispatchcode-{{::lineItem.uid}}" class="form-control normal" ng-model="lineItem.dispatchCode" ng-class="{\'fake-required\': vm.requireDispatchCode === true}" validation="custom: vm.validation.valRequiredIfEnabled(lineItem.dispatchCode, lineItem):alt=Field is Required"><option value="">Disp code</option><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide code-spinner" ng-show="vm.loadingDispatchCodes"></div><div class="col-xs-2 padding-right-none field-wrapper" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)"><label for="dmsServiceTypes-{{::lineItem.uid}}">SERVICE TYPE</label><select selectlabel="" validation="custom: vm.validation.valRequiredIfEnabled(lineItem.serviceType, lineItem):alt=Field is Required" class="form-control" name="dmsServiceTypes-{{::lineItem.uid}}" ng-model="lineItem.serviceType" ng-class="{\'last-input\': !lineItem.showInDashboard && !lineItem.showInConsumer}"><option value="">Service type</option><option value="{{item}}" ng-repeat="item in vm.serviceTypes">{{item}}</option></select></div><div class="col-xs-1 padding-right-none"><span ng-if="lineItem.isGeneric === true">N/A</span><switch ng-if="lineItem.isGeneric === false" id="generic-dashboard-{{::lineItem.uid}}" name="generic-dashboard-{{::lineItem.uid}}" ng-model="lineItem.showInDashboard" class="green" ng-change="vm.headerSwitched(lineItem.showInDashboard, lineItem)"></switch></div><div class="col-xs-1"><switch id="generic-consumer-{{::lineItem.uid}}" name="generic-consumer-{{::lineItem.uid}}" ng-model="lineItem.showInConsumer" class="green" ng-change="vm.headerSwitched(lineItem.showInConsumer, lineItem)"></switch></div></div><div class="row margin-top-md" ng-if="lineItem.isGeneric === true"><div class="col-xs-3 padding-right-none text-uppercase">&nbsp;</div><div class="col-xs-3 padding-left-none"><label class="dash-checkbox-label font-normal display-consumer-complaint"><input type="checkbox" class="form-check-input inline" ng-model-options="{debounce: 750}" ng-checked="lineItem.allowMultipleCount > 1" ng-click="vm.toggleMultipleItems(lineItem)"> Allow Multiple Lines</label> <span class="cursor-pointer hover-underline" uib-popover="Allows consumers to enter individual issues/requests vs one large block of text. When enabled, ensure there are enough opcodes in the DMS for the number specified using the specified prefix above. The format is: Prefix, Prefix1, Prefix2, Prefix3..." popover-trigger="outsideClick"><i class="material-icons info-icon">info_outline</i></span></div><div class="col-xs-1"><select selectlabel="" class="form-control normal" id="generic-multiple-line-count" name="generic-multiple-line-count" ng-options="count as count for count in vm.lineItemCounts track by count" ng-model="lineItem.allowMultipleCount"></select></div></div><div class="row" ng-if="lineItem.isRecall"><div class="col-xs-7 margin-top recall-radio-left"><input type="radio" ng-model="lineItem.recallOpCodeType" ng-change="vm.recallOpCodeTypeChanged(lineItem.uid)" ng-value="vm.recallOpCodeType.delimited"> <span class="radio-label">Use generic opcode and submit delimited list of Manufacturer Numbers on one service line</span></div><div class="col-xs-2 margin-top recall-radio-right"><input type="text" class="form-control better-placeholder" ng-model="lineItem.opCode" placeholder="OP CODE"></div></div><div class="row" ng-if="lineItem.isRecall"><div class="col-xs-7 margin-top recall-radio-left"><input type="radio" ng-model="lineItem.recallOpCodeType" ng-change="vm.recallOpCodeTypeChanged(lineItem.uid)" ng-value="vm.recallOpCodeType.prefix"> <span class="radio-label">Append prefix to Manufacturer Number and submit one service line for each recall</span></div><div class="col-xs-2 margin-top recall-radio-right"><input type="text" class="form-control better-placeholder" id="prefix-{{::lineItem.uid}}" name="prefix-{{::lineItem.uid}}" ng-model="lineItem.recallPrefix" placeholder="PREFIX" validation="custom: vm.validation.valPrefix(lineItem):alt=Prefix"></div></div><div class="row" ng-if="lineItem.isRecall"><div class="col-xs-11 margin-top"><input type="radio" ng-model="lineItem.recallOpCodeType" ng-change="vm.recallOpCodeTypeChanged(lineItem.uid)" ng-value="vm.recallOpCodeType.tsbId"> <span class="radio-label">Use Manufacturer Numbers as the opcode and submit one service line for each recall</span></div></div><div class="row" ng-if="!lineItem.isRecall"><div class="col-xs-3 margin-top-md"><input type="text" id="generic-lineItem-dashboard-name-{{::lineItem.uid}}" ng-disabled="!lineItem.showInDashboard" name="generic-lineItem-dashboard-name-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.dashboardName" placeholder="DASH TITLE"></div><div class="col-xs-9 margin-top-md padding-left-none"><input type="text" id="generic-lineItem-dashboard-description-{{::lineItem.uid}}" ng-disabled="!lineItem.showInDashboard" ng-class="{\'last-input\': !lineItem.showInConsumer && lineItem.isGeneric, \'fake-required\': lineItem.showInDashboard === true}" name="generic-lineItem-dashboard-description-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.dashboardDescription" validation="required:alt=Field is Required" placeholder="DASH DESCRIPTION"></div></div><div class="row margin-top-md" ng-if="!lineItem.isRecall"><div class="col-xs-3 margin-top-md"><input type="text" id="generic-lineItem-consumer-name-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="generic-lineItem-consumer-name-{{lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.consumerName" placeholder="CONSUMER TITLE"></div><div class="col-xs-7 margin-top-md padding-left-none"><input type="text" id="generic-lineItem-consumer-description-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="generic-lineItem-consumer-description-{{lineItem.uid}}" ng-class="{\'last-input\': lineItem.isGeneric, \'fake-required\': lineItem.showInConsumer === true}" class="form-control better-placeholder" ng-model="lineItem.consumerDescription" validation="required:alt=Field is Required" placeholder="CONSUMER DESCRIPTION"></div><div class="col-xs-2 margin-top-md padding-left-none"><input type="text" id="pricePrefix-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="pricePrefix-{{::lineItem.uid}}" validation-error-to="#pricePrefix-error-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.pricePrefix" ng-change="vm.revalidatePricePrefix()" validation="custom: vm.validation.valPricePrefix(lineItem):alt=Prefix" ng-class="{\'fake-required\': vm.displayConsumerPrices && lineItem.showInConsumer === true}" placeholder="Price Prefix"><div id="pricePrefix-error-{{::lineItem.uid}}" class="validation text-danger"></div></div></div><div class="row margin-top-md" ng-if="!lineItem.isGeneric"><div class="col-sm-2 col-xs-6 text-uppercase margin-top-md padding-right-none min-width-px-175">Book appointments to</div><div class="col-sm-3 col-xs-6 field-wrapper padding-left-none"><label for="generic-default-department-{{::lineItem.uid}}">DEFAULT DEPARTMENT</label><select selectlabel="" ng-class="{\'last-input\': lineItem.defaultDealerDepartmentId === null}" class="form-control normal" id="generic-default-department-{{::lineItem.uid}}" name="generic-default-department-{{::lineItem.uid}}" ng-options="dept.id as dept.name for dept in vm.departmentsWithAdvisors | filter: {isDisabled: false}" ng-model="lineItem.defaultDealerDepartmentId"><option value="">Default department</option></select></div><div class="col-sm-3 col-xs-6 text-uppercase padding-left-none veh-odom margin-top-md padding-right-md text-right">If vehicle odometer is below</div><div class="col-sm-2 col-xs-3 field-wrapper padding-left-none"><input type="text" id="generic-default-department-odomenter-{{::lineItem.uid}}" name="generic-default-department-odomenter-{{::lineItem.uid}}" ng-class="{\'last-input\': lineItem.defaultDealerDepartmentId !== null}" inputmode="numeric" mask="9?9?9?9?9?9?9?9?9" mask-restrict="reject" ng-model-options="{ debounce: 750 }" class="form-control no-spinners better-placeholder" ng-model="lineItem.thresholdOdometer" ng-disabled="lineItem.defaultDealerDepartmentId === null" placeholder="Optional mileage"></div><div class="col-sm-2 col-xs-3 padding-left-none" ng-if="!lineItem.isRecommendedMaintenance"><input type="text" id="pricePrefix-{{::lineItem.uid}}" validation-error-to="#pricePrefix-error-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="pricePrefix-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.pricePrefix" ng-change="vm.revalidatePricePrefix()" validation="custom: vm.validation.valPricePrefix(lineItem):alt=Prefix" ng-class="{\'fake-required\': vm.displayConsumerPrices && lineItem.showInConsumer === true}" placeholder="Price Prefix"><div id="pricePrefix-error-{{::lineItem.uid}}" class="validation text-danger"></div></div></div><div class="row margin-top-sm margin-bottom-sm" ng-if="lineItem.defaultDealerDepartmentId"><div class="col-xs-12 validation text-danger">Please make sure this service is available in the {{vm.getDepartmentName(lineItem.defaultDealerDepartmentId)}} department.</div></div></div></div><div class="group-2" uib-accordion-group=""><uib-accordion-heading ng-click="$event.stopPropagation();$event.preventDefault();"><div class="panel-heading cursor-default" ng-click="$event.stopPropagation();$event.preventDefault();"><div class="padding-none"><div class="panel-title"><div class="row read-only-row text-uppercase"><div class="col-xs-3 padding-right-none"><span title="Choose when to show/hide previously deferred op codes">Previously Deferred</span></div><div class="col-xs-1 padding-none"></div><div class="col-xs-2 padding-right-none"></div><div class="col-xs-2 padding-right-none"></div><div class="col-xs-1 padding-right-none" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK || vm.dmsSystem === vm.dmsEnum.DealerTrack)"></div><div class="col-xs-1 padding-right-none collapsed-row" ng-click="$event.stopPropagation();$event.preventDefault();"><switch id="declinedServicesDash-{{vm.departmentFilter}}" name="declinedServicesDash-{{vm.departmentFilter}}" ng-model="vm.selectedDepartment.showPreviouslyDeclinedServicesDashboard" class="green"></switch></div><div class="col-xs-1 padding-right-none collapsed-row" ng-click="$event.stopPropagation();$event.preventDefault();"><switch id="declinedServicesConsumer-{{vm.departmentFilter}}" name="declinedServicesConsumer-{{vm.departmentFilter}}" ng-model="vm.selectedDepartment.showPreviouslyDeclinedServicesConsumer" class="green"></switch></div></div></div></div></div></uib-accordion-heading></div></uib-accordion></div></div></div><h3 class="line-item-mapping-heading margin-top-30" ng-click="vm.displayOtherOpCodes = !vm.displayOtherOpCodes"><i class="material-icons md-24 ng-scope" ng-if="!vm.displayOtherOpCodes">expand_more</i> <i class="material-icons md-24 ng-scope" ng-if="vm.displayOtherOpCodes">expand_less</i> All Other OpCodes</h3><div ng-show="vm.displayOtherOpCodes" class="ng-hide"><p class="padding-left-25">Configure the opcodes displayed on the consumer booking experience and when booking in the dealer dashboard below.</p><hr class="margin-top-sm margin-bottom-md"><div class="row bold margin-bottom-md"><div class="col-xs-3 padding-right-none desc-header cursor-pointer" ng-click="vm.sort(vm.sorting.name)">DESCRIPTION <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.name ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none cursor-pointer" ng-click="vm.sort(vm.sorting.opCode)">OP CODE <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.opCode ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none pay-type-header cursor-pointer" ng-click="vm.sort(vm.sorting.payType)">PAY TYPE <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.payType ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none cursor-pointer" ng-click="vm.sort(vm.sorting.retailPrice)">RETAIL EST <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.retailPrice ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none cursor-pointer" ng-click="vm.sort(vm.sorting.laborHours)">TIME <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.laborHours ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none cursor-pointer dd-disp-code" ng-click="vm.sort(vm.sorting.dispatchCode)" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)">DISP CODE <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.dispatchCode ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none cursor-pointer" ng-click="vm.sort(vm.sorting.serviceType)" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)">SERV TYPE <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.serviceType ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none cursor-pointer" ng-click="vm.sort(vm.sorting.dashSortOrder)">DASH <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.dashSortOrder ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 order-header"></div><div class="col-xs-1 padding-left-none padding-right-none cursor-pointer" ng-click="vm.sort(vm.sorting.consumerSortOrder)">CONSUMER <i class="fa fa-sort" ng-class="vm.sortType === vm.sorting.consumerSortOrder ? (vm.sortAsc ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></div><div class="col-xs-1 padding-right-none"></div></div><div class="list-unstyled"><uib-accordion class="line-item-mapping"><div class="group-3" uib-accordion-group="" ng-repeat="lineItem in vm.mergedOpCodeList | filter: vm.filterDisplayedItems track by lineItem.uid" is-open="lineItem.isOpen"><uib-accordion-heading><div class="panel-heading" ng-click="vm.headerClicked($event, (locationLineItemForm.$invalid || vm.hasInvalidLineItems()) && lineItem.isValid);"><div class="padding-none"><div class="panel-title"><div class="row read-only-row text-uppercase"><div class="col-xs-3 padding-right-none padding-top-md">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem)" class="text-danger validation font-normal">*Invalid Form Data</span></div><div class="col-xs-1 padding-right-none padding-left-none padding-top-md">{{lineItem.opCode}}</div><div class="col-xs-1 padding-right-none padding-top-md">{{lineItem.payType || \'N/A\'}}</div><div class="col-xs-1 padding-right-none padding-top-md">{{lineItem.retailPrice | currency}}</div><div class="col-xs-1 padding-right-none padding-top-md">{{lineItem.laborHours | number:2}}</div><div class="col-xs-1 padding-right-none padding-top-md dd-disp-code" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)">{{lineItem.dispatchCode}}</div><div class="col-xs-1 padding-right-none padding-top-md" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)">{{::lineItem.serviceType}}</div><div class="col-xs-1 padding-right-none collapsed-row switch-col-dash padding-top-md" ng-click="$event.stopPropagation();$event.preventDefault();"><switch id="dashboard-collapsed-{{::lineItem.uid}}" name="dashboard-collapsed-{{::lineItem.uid}}" ng-model="lineItem.showInDashboard" class="green" ng-change="vm.headerSwitched(lineItem.showInDashboard, lineItem)"></switch></div><div class="col-xs-1 padding-left-none order-col" ng-click="$event.stopPropagation();$event.preventDefault();"><input type="number" id="DashSortOrder-{{::lineItem.uid}}" name="DashSortOrder-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.dashSortOrder" min="1" placeholder="ORDER"></div><div class="col-xs-1 padding-right-none padding-left-none collapsed-row switch-col-cons padding-top-md" ng-click="$event.stopPropagation();$event.preventDefault();"><switch id="consumer-collasped-{{::lineItem.uid}}" name="consumer-collasped-{{::lineItem.uid}}" ng-model="lineItem.showInConsumer" class="green" ng-change="vm.headerSwitched(lineItem.showInConsumer, lineItem)"></switch></div><div class="col-xs-1 padding-left-none order-col" ng-click="$event.stopPropagation();$event.preventDefault();"><input type="number" id="ConsumerSortOrder-{{::lineItem.uid}}" name="ConsumerSortOrder-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.consumerSortOrder" min="1" placeholder="ORDER"></div></div></div></div></div></uib-accordion-heading><div class="panel-body"><div ng-if="lineItem.isOpen"><div class="row edit-row" ng-click="$event.stopPropagation();$event.preventDefault();"><div class="col-xs-3 padding-right-none text-uppercase font-bold" ng-if="lineItem.dealerSystemAppointmentServiceId">{{lineItem.name}} <span ng-if="!vm.isLineItemValid(lineItem)" class="text-danger validation font-normal font-normal">*Invalid Form Data</span></div><div class="col-xs-3" ng-if="!lineItem.dealerSystemAppointmentServiceId"><input type="text" id="name-{{::lineItem.uid}}" name="name-{{::lineItem.uid}}" ng-keydown="$event.stopPropagation();" class="form-control better-placeholder" ng-model="lineItem.name" validation="required:alt=Field is Required" placeholder="NAME"></div><div class="col-xs-1 padding-none" ng-class="{\'fake-required-select2\': lineItem.showInConsumer === true || lineItem.showInDashboard === true}"><select select2="" id="opcode-{{::lineItem.uid}}" name="opcode-{{::lineItem.uid}}" on-change="vm.opCodeSearchSelected(lineItem, selectedResult)" init-value="lineItem.selectedOpCode" placeholder="Opcode" min-input-length="1" format-for-selection="vm.formatForSelection" format-for-dropdown="vm.formatForDropdown" query="vm.opCodeSearchQuery" ng-if="vm.select2Ready && (vm.dmsSystem === vm.dmsEnum.CDK || vm.dmsSystem === vm.dmsEnum.DealerTrack || vm.dmsSystem === vm.dmsEnum.AutoMate || vm.dmsSystem === vm.dmsEnum.Motive || vm.dmsSystem === vm.dmsEnum.Tekion)" ng-model="lineItem.selectedOpCode" validation-error-to="#opcode-error-{{::lineItem.uid}}" validation="custom: vm.validation.valOpCode(lineItem):alt=OpCode"></select><input type="text" id="opcode-{{::lineItem.uid}}" name="opcode-{{::lineItem.uid}}" class="form-control normal better-placeholder" ng-if="::(vm.dmsSystem === vm.dmsEnum.ReynoldsPOWER || vm.dmsSystem === vm.dmsEnum.ReynoldsERA || vm.dmsSystem === vm.dmsEnum.None)" ng-model="lineItem.opCode" validateonempty="true" ng-class="{\'fake-required\': lineItem.showInConsumer === true || lineItem.showInDashboard === true}" validation="custom: vm.validation.valOpCode(lineItem):alt=OpCode" placeholder="OPCODE" validation-error-to="#opcode-error-{{::lineItem.uid}}" ng-maxlength="::vm.getOpCodeMaxLength()"><div id="opcode-error-{{::lineItem.uid}}" class="validation text-danger"></div></div><div class="col-xs-1 field-wrapper padding-right-none"><label for="paytype-{{::lineItem.uid}}">PAY TYPE</label><select selectlabel="" class="form-control normal text-uppercase" id="paytype-{{::lineItem.uid}}" name="paytype-{{::lineItem.uid}}" ng-options="type.value as type.text for type in vm.paymentTypes" ng-model="lineItem.payType"><option value="">Pay type</option></select></div><div class="col-xs-1 padding-right-none"><input type="text" id="retailprice-{{::lineItem.uid}}" name="retailprice-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.retailPrice" ng-pattern="vm.decimalRegex" step="0.01" validation="custom: vm.validation.valDecimal(lineItem.retailPrice, lineItem):alt=RetailPrice" placeholder="RETAIL EST"></div><div class="col-xs-1 padding-right-none"><input type="number" id="laborhours-{{::lineItem.uid}}" name="laborhours-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.laborHours" ng-pattern="vm.decimalRegex" validation="custom: vm.validation.valDecimal(lineItem.laborHours, lineItem):alt=LaborHours" placeholder="TIME EST"></div><div class="col-xs-1 padding-right-none dd-disp-code field-wrapper" ng-if="::(vm.dmsSystem === vm.dmsEnum.CDK)"><label for="dmsServiceTypes-{{::lineItem.uid}}">DISP CODE</label><select selectlabel="" id="dispatchcode-{{::lineItem.uid}}" name="dispatchcode-{{::lineItem.uid}}" class="form-control normal" ng-class="{\'fake-required\': vm.requireDispatchCode === true}" ng-model="lineItem.dispatchCode" validation="custom: vm.validation.valRequiredIfEnabled(lineItem.dispatchCode, lineItem):alt=Field is Required"><option value="">Disp code</option><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide code-spinner" ng-show="vm.loadingDispatchCodes"></div><div class="col-xs-1 padding-right-none field-wrapper" ng-if="::(vm.dmsSystem === vm.dmsEnum.DealerTrack)"><label for="dmsServiceTypes-{{::lineItem.uid}}">SERVICE TYPE</label><select selectlabel="" validation="custom: vm.validation.valRequiredIfEnabled(lineItem.serviceType, lineItem):alt=Field is Required" class="form-control" name="dmsServiceTypes-{{::lineItem.uid}}" ng-model="lineItem.serviceType"><option value="">Service type</option><option value="{{item}}" ng-repeat="item in vm.serviceTypes">{{item}}</option></select></div><div class="col-xs-1 line-item-switch padding-right-none switch-col-dash"><switch id="dashboard-{{::lineItem.uid}}" name="dashboard-{{::lineItem.uid}}" ng-model="lineItem.showInDashboard" class="green" ng-change="vm.headerSwitched(lineItem.showInDashboard, lineItem)"></switch></div><div class="col-xs-1 padding-left-none order-col"><input type="number" id="DashSortOrder-{{::lineItem.uid}}" name="DashSortOrder-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.dashSortOrder" min="1" placeholder="ORDER"></div><div class="col-xs-1 padding-right-none padding-left-none switch-col-cons"><switch id="consumer-{{::lineItem.uid}}" name="consumer-{{::lineItem.uid}}" ng-model="lineItem.showInConsumer" class="green" ng-change="vm.headerSwitched(lineItem.showInConsumer, lineItem)"></switch></div><div class="col-xs-1 padding-left-none order-col"><input type="number" id="ConsumerSortOrder-{{::lineItem.uid}}" name="ConsumerSortOrder-{{::lineItem.uid}}" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.consumerSortOrder" min="1" placeholder="ORDER"></div></div><div class="row"><div class="col-xs-3 margin-top-md"><input type="text" id="lineItem-dashboard-name-{{::lineItem.uid}}" ng-disabled="!lineItem.showInDashboard" name="lineItem-dashboard-name-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.dashboardName" placeholder="DASH TITLE"></div><div class="col-xs-9 margin-top-md padding-left-none"><input type="text" id="lineItem-dashboard-description-{{::lineItem.uid}}" ng-disabled="!lineItem.showInDashboard" name="lineItem-dashboard-description-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.dashboardDescription" ng-class="{\'fake-required\': lineItem.showInDashboard === true}" validation="required:alt=Field is Required" placeholder="DASH DESCRIPTION"></div></div><div class="row"><div class="col-xs-12 margin-top-md"><input type="text" id="lineItem-dashboard-complaint-{{::lineItem.uid}}" ng-disabled="!lineItem.showInDashboard" name="lineItem-dashboard-complaint-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.defaultDashboardNote" ng-model-options="{ debounce: 750 }" maxlength="{{vm.getNoteMaxLength()}}" placeholder="DEFAULT DASH CUSTOMER COMPLAINT/NOTES"></div></div><div class="row margin-top-sm"><div class="col-xs-3 margin-top-md"><input type="text" id="lineItem-consumer-name-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="lineItem-consumer-name-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.consumerName" placeholder="CONSUMER TITLE"></div><div class="col-xs-7 margin-top-md padding-left-none"><input type="text" id="lineItem-consumer-description-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="lineItem-consumer-description-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.consumerDescription" validation="required:alt=Field is Required" ng-class="{\'fake-required\': lineItem.showInConsumer === true}" placeholder="CONSUMER DESCRIPTION"></div><div class="col-xs-2 margin-top-md padding-left-none"><input type="text" id="pricePrefix-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="pricePrefix-{{::lineItem.uid}}" validation-error-to="#pricePrefix-error-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.pricePrefix" ng-change="vm.revalidatePricePrefix()" validation="custom: vm.validation.valPricePrefix(lineItem):alt=Prefix" ng-class="{\'fake-required\': vm.displayConsumerPrices && lineItem.showInConsumer === true}" placeholder="Price Prefix"><div id="pricePrefix-error-{{::lineItem.uid}}" class="validation text-danger"></div></div></div><div class="row margin-bottom"><div class="col-xs-10 margin-top-md"><input type="text" id="lineItem-consumer-complaint-{{::lineItem.uid}}" ng-disabled="!lineItem.showInConsumer" name="lineItem-consumer-complaint-{{::lineItem.uid}}" class="form-control better-placeholder" ng-model="lineItem.defaultConsumerNote" ng-model-options="{ debounce: 750 }" maxlength="{{vm.getNoteMaxLength()}}" placeholder="DEFAULT CONSUMER CUSTOMER COMPLAINT/NOTES"></div><div class="col-xs-2 margin-top padding-left-none"><label class="dash-checkbox-label font-normal display-consumer-complaint"><input type="checkbox" class="form-check-input inline" ng-model="lineItem.showDefaultConsumerNote"><span class="padding-left-sm">DISPLAY FIELD</span></label></div></div><div class="row margin-bottom"><div class="col-xs-12 padding-left-none"><div class="col-sm-2 col-xs-6 text-uppercase margin-top-md padding-right-none min-width-px-175">Book appointments to</div><div class="col-sm-3 col-xs-6 field-wrapper padding-left-none"><label for="default-department-{{::lineItem.uid}}">DEFAULT DEPARTMENT</label><select selectlabel="" class="form-control normal text-uppercase" id="default-department-{{::lineItem.uid}}" name="default-department-{{::lineItem.uid}}" ng-class="{\'last-input\': lineItem.defaultDealerDepartmentId === null}" ng-options="dept.id as dept.name for dept in vm.departmentsWithAdvisors | filter: {isDisabled: false}" ng-model="lineItem.defaultDealerDepartmentId"><option value="">Default department</option></select></div><div class="col-sm-3 col-xs-6 veh-odom text-uppercase padding-right-none margin-top-md text-right">If vehicle odometer is below</div><div class="col-sm-2 col-xs-2 padding-left-md"><input type="text" id="default-department-odomenter-{{::lineItem.uid}}" name="default-department-odomenter-{{::lineItem.uid}}" placeholder="OPTIONAL MILEAGE" ng-class="{\'last-input\': lineItem.defaultDealerDepartmentId !== null}" inputmode="numeric" mask="9?9?9?9?9?9?9?9?9" mask-restrict="reject" ng-model-options="{ debounce: 750 }" class="form-control no-spinners better-placeholder" ng-model="lineItem.thresholdOdometer" ng-disabled="lineItem.defaultDealerDepartmentId === null"></div></div></div><div class="row margin-top-sm margin-bottom-20" ng-if="lineItem.defaultDealerDepartmentId"><div class="col-xs-12 validation text-danger">Please make sure this service is available in the {{vm.getDepartmentName(lineItem.defaultDealerDepartmentId)}} department.</div></div><div class="capacity-heading"><span class="font-bold text-uppercase">CAPACITY</span> <span class="font-bold inline">&nbsp;({{(lineItem.constraints | filter: { isDeleted: false, isNew: false, departmentId: vm.departmentFilter }).length}} items)</span></div><div class="row padding-top-sm" ng-repeat="constraint in lineItem.constraints | filter: { departmentId: vm.departmentFilter }:true track by constraint.uid" ng-class="{\'first-row\': $index === 0, \'last-row\': $last}"><input ng-if="$first" type="hidden" name="constraints-valid-{{lineItem.uid}}-{{vm.departmentFilter}}" ng-model="vm.deptConstraintsAreValid" validation="custom: vm.validation.valConstraints(lineItem.constraints, vm.validation.filterPredicate(vm.departmentFilter)):alt=There was an overlap in the times for this constraint. Please adjust the selected constraints."><constraint ng-show="!constraint.isDeleted" definition-type="vm.constraintDefinitionType.opCode" uid="constraint.uid" init-value="constraint" on-add="vm.addOpCodeConstraint(constraint, lineItem, uid)" on-remove="vm.removeOpCodeConstraint(constraint, lineItem)" on-change="vm.constraintChange(elementsToRevalidate, lineItem.uid, vm.departmentFilter)"></constraint></div><div class="row"><div class="display-flex flex-column flex-percent-100 margin-right-md"><a href="#" class="theme-link text-right margin-right-lg padding-right-lg" ng-if="!vm.isLastOpCodeConstraintBlank(lineItem)" ng-click="vm.addNewOpCodeConstraint(lineItem, vm.departmentFilter)">ADD NEW</a></div></div><a href="#" class="pull-right margin-top theme-link" ng-if="!lineItem.dealerSystemAppointmentServiceId" ng-click="vm.deleteLine(lineItem)">DELETE</a></div></div></div></uib-accordion></div></div><a ng-if="!vm.showServiceTypeError() && vm.displayOtherOpCodes" href="#" id="add-new-service" class="pull-right theme-link" ng-click="vm.addNewLine()">ADD NEW</a></div><div ng-if="!vm.departmentFilter"><div class="text-danger">Please select a department in order to update Op Codes.</div></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md padding-right-20"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-primary" ng-if="vm.selectedLocation" ng-class="config.styleClass" ladda="vm.manualSaveInProgress" ng-disabled="locationLineItemForm.$invalid || vm.hasInvalidLineItems();" ng-click="vm.updateLineItems(locationLineItemForm.$valid, null, { source: \'manual\' })">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-logos.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg" fill-height=""><h3>Logos</h3><p>Below are the logos for this dealer.</p><hr><div class="form-group"><label class="col-sm-2 control-label">Desktop Logo</label><div class="col-sm-7"><img data-ng-if="vm.locationLogos.headerLogo" data-ng-src="{{vm.locationLogos.headerLogo}}"></div></div><br><br><div class="form-group"><label class="col-sm-2 control-label">Mobile Logo</label><div class="col-sm-7"><img data-ng-if="vm.locationLogos.headerLogoMobile" data-ng-src="{{vm.locationLogos.headerLogoMobile}}"></div></div><br><br><div ng-if="vm.locationLogos.footerLogo" class="form-group"><label class="col-sm-2 control-label">Footer Logo</label><div class="col-sm-7"><img data-ng-src="{{vm.locationLogos.footerLogo}}"></div></div><br><br><div ng-if="vm.locationLogos.footerLogoMobile" class="form-group"><label class="col-sm-2 control-label">Footer Logo Mobile</label><div class="col-sm-7"><img data-ng-src="{{vm.locationLogos.footerLogoMobile}}"></div></div></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-notes.view.html','<div><div><h3>Notes</h3><p>Manage the trip notes that are automatically delivered to each driver for {{ vm.currentTripType.name }} for this dealer.</p><hr></div><div class="form-group" ng-repeat="response in vm.responses"><label class="control-label">{{response.question}}</label> <textarea class="form-control resize-none" ng-model="response.response"></textarea></div></div><div class="modal-footer"><event-alert></event-alert><button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-click="vm.updateResponses(vm.responses)">Update</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button></div>');
$templateCache.put('app/areas/location/views/location-tab-notifications.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div id="notifications-tab" class="padding-lg" fill-height=""><form name="inputForm" class="form-horizontal" ng-submit="vm.updateClicked()" novalidate=""><div class="col-sm-12 text-left margin-top" ng-if="!vm.loadingTripWorkflowTemplates && vm.hasNotifications() == false"><span>No notifications exist for this trip type.</span></div><div ng-if="vm.hasNotifications()"><div ng-if="vm.showWebhooks"><div class="col-sm-12"><h3>Webhooks</h3><p>Manage the webhooks setting for {{ vm.currentTripType.name }}.</p></div><div class="col-sm-12 list-unstyled"><uib-accordion class="notification"><div uib-accordion-group=""><uib-accordion-heading><div class="panel-heading"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title">Enable Webhooks for {{ vm.currentTripType.name }}</div></div><div class="input-group-btn"><switch ng-model="vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" class="green" ng-click="$event.stopPropagation();$event.preventDefault();vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.isDirty=true;"></switch></div></div></div></uib-accordion-heading><div class="panel-body"><div class="form-horizontal"><div class="form-group"><label class="col-sm-3 text-left">Webhook Authentication</label><div class="col-sm-12"><select class="form-control" ng-model="vm.webhookAuthenticationType" ng-disabled="!vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" ng-change="vm.webhookTypeChanged()"><option value="None">None</option><option value="Basic">Basic</option><option value="OAuth">OAuth</option></select></div></div></div></div><div class="panel-body"><div class="form-horizontal"><div class="form-group"><b class="col-sm-3 text-left">Webhook URL</b><div class="col-sm-12"><p class="line-item-label">This will post trip updates to the given webhook url below.</p><input type="text" class="form-control" ng-model="vm.currentTripType.tripTypeCommonConfigs.WebhookUrl.value" ng-disabled="!vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" ng-change="vm.currentTripType.tripTypeCommonConfigs.WebhookUrl.isDirty=true"></div></div></div></div><div class="panel-body" ng-if="vm.webhookAuthenticationType == \'OAuth\'"><div class="form-horizontal"><div class="form-group"><b class="col-sm-3 text-left">OAuth URL</b><div class="col-sm-12"><p class="line-item-label">This url will be used for OAuth authentication by webhooks.</p><input type="text" class="form-control" ng-model="vm.currentTripType.tripTypeCommonConfigs.OAuthUrl.value" ng-disabled="!vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" ng-change="vm.currentTripType.tripTypeCommonConfigs.OAuthUrl.isDirty=true"></div></div></div></div><div ng-if="vm.webhookAuthenticationType == \'Basic\' || vm.webhookAuthenticationType == \'OAuth\'"><div class="panel-body"><div class="form-horizontal"><div class="form-group"><b class="col-sm-3 text-left"><span ng-if="vm.webhookAuthenticationType == \'Basic\'">Webhook Username</span> <span ng-if="vm.webhookAuthenticationType == \'OAuth\'">OAuth Client ID</span></b><div class="col-sm-12"><p class="line-item-label" ng-if="vm.webhookAuthenticationType == \'Basic\'">This username will be used for basic authentication by webhooks</p><p class="line-item-label" ng-if="vm.webhookAuthenticationType == \'OAuth\'">This username will be used for OAuth authentication by webhooks</p><input type="text" class="form-control" ng-model="vm.currentTripType.tripTypeCommonConfigs.WebhookUsername.value" ng-disabled="!vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" ng-change="vm.currentTripType.tripTypeCommonConfigs.WebhookUsername.isDirty=true"></div></div></div></div><div class="panel-body"><div class="form-horizontal"><div class="form-group"><b class="col-sm-3 text-left"><span ng-if="vm.webhookAuthenticationType == \'Basic\'">Webhook Password</span> <span ng-if="vm.webhookAuthenticationType == \'OAuth\'">OAuth Client Secret</span></b><div class="col-sm-12"><p class="line-item-label" ng-if="vm.webhookAuthenticationType == \'Basic\'">This password will be used for basic authentication by webhooks</p><p class="line-item-label" ng-if="vm.webhookAuthenticationType == \'OAuth\'">This password will be used for OAuth authentication by webhooks</p><input type="text" class="form-control" ng-model="vm.currentTripType.tripTypeCommonConfigs.WebhookPassword.value" ng-disabled="!vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" ng-change="vm.currentTripType.tripTypeCommonConfigs.WebhookPassword.isDirty=true"></div></div></div></div><div class="panel-body" ng-if="vm.webhookAuthenticationType == \'OAuth\'"><div class="form-horizontal"><div class="form-group"><b class="col-sm-3 text-left">OAuth Scope</b><div class="col-sm-12"><p class="line-item-label">This scope will be used for OAuth authentication by webhooks</p><input type="text" class="form-control" ng-model="vm.currentTripType.tripTypeCommonConfigs.WebhookScope.value" ng-disabled="!vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value" ng-change="vm.currentTripType.tripTypeCommonConfigs.WebhookScope.isDirty=true"></div></div></div></div></div></div></uib-accordion><uib-accordion class="notification" ng-if="vm.currentTripType.tripTypeCommonConfigs.EnableWebhooks.value"><div uib-accordion-group=""><uib-accordion-heading><div class="panel-heading"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title">Send Customer SMS Via Webhooks</div></div><div class="input-group-btn"><switch ng-model="vm.currentTripType.tripTypeCommonConfigs.SendCustomerSMSViaWebhooks.value" class="green" ng-click="$event.stopPropagation();$event.preventDefault();vm.currentTripType.tripTypeCommonConfigs.SendCustomerSMSViaWebhooks.isDirty=true;"></switch></div></div></div></uib-accordion-heading><div class="panel-body">Please note, if this is enabled SMS CCs will not be sent</div></div></uib-accordion></div></div><div class="col-sm-12"><h3>Notifications</h3><p>Manage the notification settings for {{ vm.currentTripType.name }}.</p></div><div class="col-sm-12 list-unstyled" ng-repeat="template in vm.resolvedInviteNotificationTemplates"><uib-accordion class="notification"><div uib-accordion-group=""><uib-accordion-heading><div class="panel-heading"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title">{{template.dealerSystemNotificationVM.name}} - {{template.dealerSystemNotificationVM.recipientTypeText}} {{template.dealerSystemNotificationVM.sendMethodText}} <small ng-show="template.discriminator == 1">- Customized</small> <small ng-show="template.ccList">- CC(s)</small></div></div><div class="input-group-btn"><switch ng-model="template.isEnabled" class="green" ng-click="$event.stopPropagation();$event.preventDefault();" disabled="true"></switch></div></div></div></uib-accordion-heading><div class="panel-body">{{template.dealerSystemNotificationVM.description}}<div class="form-horizontal"><div class="form-group" ng-show="template.dealerSystemNotificationVM.sendMethod === 1"><label class="col-sm-1 control-label">Subject</label><div class="col-sm-12"><input type="text" class="form-control" ng-model="template.subject" disabled=""></div></div><div class="form-group" ng-show="template.dealerSystemNotificationVM.contentSource === 0"><div class="col-sm-1 text-left"><label class="control-label pull-left">Body</label></div><div class="col-sm-12"><textarea class="form-control resize-none" ng-model="template.body" rows="4" disabled=""></textarea></div></div><div class="form-group" ng-show="template.dealerSystemNotificationVM.contentSource === 1"><div class="col-sm-12">Template: {{template.body}}</div></div><div class="form-group" ng-show="template.dealerSystemNotificationVM.allowCC"><div class="col-sm-1 text-left"><label class="control-label">CC</label></div><div class="col-sm-12"><textarea class="form-control resize-none" ng-model="template.ccList" disabled=""></textarea></div></div></div></div></div></uib-accordion></div><label class="col-sm-12 text-left margin-top"><span uib-popover="Enter the email address(es) that will receive copies of the SA notifications." popover-trigger="outsideClick">Bulk CCs</span></label><div class="col-sm-12"><div class="form-group"><div class="col-sm-12"><ui-select multiple="" ng-model="vm.BulkEmailNotificationListMap"><ui-select-match placeholder="Select employee(s)...">{{$item.fullName}}</ui-select-match><ui-select-choices repeat="employee.id as employee in vm.resolvedEmployees | propsFilter: {fullName: $select.search}"><div ng-bind-html="employee.fullName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div id="work-flows" class="btn-group ng-hide col-sm-10 margin-top" ng-show="vm.resolvedWorkFlows && vm.resolvedWorkFlows.length > 1"><button class="btn btn-white" type="button" ng-class="{\'btn-default\' : (flow.id == vm.currentWorkFlowId)}" ng-repeat="flow in vm.resolvedWorkFlows" ng-click="vm.setWorkFlow(flow.id)">{{ vm.getWorkflowDisplayName(flow)}}</button></div><div ng-if="vm.loadingTripWorkflowTemplates == true" class="col-sm-12 margin-bottom margin-top"><img src="assets/images/ajax-loader.gif"> Loading ...</div><div class="col-sm-12 margin-bottom" ng-repeat="templateGroup in vm.resolvedTripWorkflowNotificationTemplateGroups"><h3>{{templateGroup.name}} Notifications</h3><div ng-repeat="template in templateGroup.notificationTemplateViewModels" class="list-unstyled"><uib-accordion class="notification"><div uib-accordion-group=""><uib-accordion-heading><div class="panel-heading"><div class="input-group"><div class="col-md-10 padding-none"><div class="panel-title">{{template.dealerSystemNotificationVM.name}} - {{template.dealerSystemNotificationVM.sendMethodText}} <small ng-show="template.discriminator == 1">- Customized</small> <small ng-show="template.ccList">- CC(s)</small></div></div><div class="input-group-btn"><switch ng-init="template.isEnabled = template.isEnabled && template.dealerSystemNotificationVM.isEnabled" ng-model="template.isEnabled" disabled="!template.dealerSystemNotificationVM.isEnabled || vm.uberEnabled" class="green" ng-click="$event.stopPropagation();$event.preventDefault();template.isDirty=true;" uib-popover="Disabled at system level" popover-trigger="mouseenter" popover-enable="!template.dealerSystemNotificationVM.isEnabled" popover-append-to-body="true"></switch></div></div></div></uib-accordion-heading><div class="panel-body">{{template.dealerSystemNotificationVM.description}}<div class="form-horizontal"><div class="form-group" ng-show="template.dealerSystemNotificationVM.sendMethod === 1"><label class="col-sm-1 control-label">Subject</label><div class="col-sm-12"><input type="text" class="form-control" ng-model="template.subject" ng-disabled="!template.dealerSystemNotificationVM.isEnabled" ng-change="template.isDirty=true"></div></div><div class="form-group" ng-show="template.dealerSystemNotificationVM.contentSource === 0 || template.dealerSystemNotificationVM.contentSource === 2"><div ng-show="template.dealerSystemNotificationVM.contentSource === 0" class="col-sm-1 text-left"><label class="control-label pull-left">Body</label></div><div ng-show="template.dealerSystemNotificationVM.contentSource === 2" class="col-sm-1 text-left"><label class="control-label pull-left">URL</label></div><div class="col-sm-12"><textarea class="form-control resize-none" rows="3" ng-model="template.body" ng-disabled="!template.dealerSystemNotificationVM.isEnabled || vm.uberEnabled" ng-change="template.isDirty=true"></textarea></div></div><div class="form-group" ng-show="template.dealerSystemNotificationVM.contentSource === 1"><div class="col-sm-12 template-info"><b>Template</b><br><div ng-if="vm.isDeveloper == false">{{template.body}}</div><div ng-if="vm.isDeveloper == true"><input type="text" class="form-control" ng-model="template.body" ng-change="template.isDirty=true"></div></div></div><div class="form-group" ng-show="!vm.resolvedLocation.isCopyable && template.dealerSystemNotificationVM.allowCC"><div class="col-sm-1 text-left"><label class="control-label">CC</label></div><div class="col-sm-12"><ui-select multiple="" ng-model="template.ccList" ng-disabled="!template.dealerSystemNotificationVM.isEnabled" ng-change="template.isDirty=true"><ui-select-match placeholder="Select employee(s)...">{{$item.fullName}}</ui-select-match><ui-select-choices repeat="employee in vm.resolvedEmployees | propsFilter: {fullName: $select.search}"><div ng-bind-html="employee.fullName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group" ng-show="template.hasTimeBasedTrigger"><div class="col-sm-12"><div class="text-nowrap">Send reminder <input type="text" id="notification-time-trigger" ng-model="template.timeBasedTrigger" class="form-control" ng-disabled="!template.dealerSystemNotificationVM.isEnabled" ng-change="template.isDirty=true"> minutes prior to Customer Expected Time.</div></div></div><a href="#" class="pull-right theme-link" ng-click="vm.resetTemplateToDefault(template)" ng-if="template.discriminator == 1">Reset to Default</a></div></div></div></uib-accordion></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.updateClicked()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.resolvedLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-survey.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div class="form-horizontal"><h3>Customer Survey</h3><label class="text-left margin-top"><span uib-popover="Enter the email address(es) that will receive copies of the customer survey submissions." popover-trigger="outsideClick">Bulk CCs</span></label><div class="form-group"><div class="col-sm-12"><ui-select multiple="" ng-model="vm.BulkEmailSurveyListMap"><ui-select-match placeholder="Select employee(s)...">{{$item.fullName}}</ui-select-match><ui-select-choices repeat="employee.id as employee in vm.resolvedEmployees | propsFilter: {fullName: $select.search}"><div ng-bind-html="employee.fullName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><hr><p>Choose the survey that will be presented to the customer at the end of the trip.</p><hr><div class="form-group"><div class="col-sm-5"><select class="form-control" name="SurveyId" ng-model="vm.commonConfigs.SurveyId.value" ng-options="survey.id.toString() as survey.name for survey in vm.customerSurveys" ng-change="vm.getSurveyQuestions()"></select></div></div><div class="form-group"><div class="col-sm-12"><ol><li ng-repeat="question in vm.selectedSurveyQuestions">{{question.question}}</li></ol></div></div><br><h3>Driver Survey</h3><p>Choose the survey that will be presented to the driver at the end of the trip.</p><hr><div class="form-group"><div class="col-sm-5"><select class="form-control" name="DriverSurveyId" ng-model="vm.commonConfigs.DriverSurveyId.value" ng-options="survey.id.toString() as survey.name for survey in vm.driverSurveys" ng-change="vm.getDriverSurveyQuestions()"></select></div></div><div class="form-group"><div class="col-sm-12"><ol><li ng-repeat="question in vm.selectedDriverSurveyQuestions">{{question.question}}</li></ol></div></div></div></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-click="vm.updateSurveyId()">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-tasks.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div id="task" class="padding-lg" fill-height=""><div class="col-sm-10"><h3>Tasks</h3><div><p>Turn tasks on/off for each segment and provide dealer specific responses.<hr></p></div></div><form role="form" name="inputForm" novalidate="" class="validation-relative"><br><div id="work-flows" class="btn-group ng-hide col-sm-10" ng-show="vm.resolvedWorkFlows && vm.resolvedWorkFlows.length > 1"><button class="btn btn-white" type="button" ng-class="{\'btn-default\' : (flow.id == vm.currentWorkFlowId)}" ng-repeat="flow in vm.resolvedWorkFlows" ng-click="vm.setWorkFlow(flow.id)">{{ vm.getWorkflowDisplayName(flow) }}</button></div><div class="row margin-bottom-md form-inline col-sm-10" ng-if="!vm.location.isCopyable && vm.locationsWithTripType.length"><div class="col-xs-12"><div class="form-group margin-right-md field-wrapper"><label for="locationSelect">COPY TASKS FROM ANOTHER DEALER</label><select class="form-control" selectlabel="" id="locationSelect" name="locationSelect" ng-model="vm.selectedLocation" ng-options="location.id as location.name for location in vm.locationsWithTripType"><option value="">Copy tasks from another dealer</option></select></div><button type="button" class="btn btn-default" ng-click="vm.copyTasks(vm.selectedLocation)" ng-disabled="!vm.selectedLocation || vm.tasksUpdating">Copy Tasks</button> <label class="checkbox-line margin-left-md margin-top-md"><input id="copy-all-workflows" type="checkbox" ng-model="vm.copyAllWorkflows"> <span class="font-normal margin-bottom-xs margin-left-xs">Copy tasks for all workflows</span></label></div></div><div class="row margin-bottom-md form-inline col-sm-10"><div class="col-xs-12"><button type="button" class="btn btn-default" ng-click="vm.addConsolidatedTasks()" ng-disabled="!vm.needsConsolidatedTasks">Add Consolidated Tasks</button></div></div><div class="col-sm-10" ng-repeat="nav in vm.resolvedWorkFlowTasks"><h3 ng-show="nav.tasks && nav.tasks.length > 0" class="ng-hide">{{ nav.friendlyState }}</h3><ul ui-sortable="" ng-model="nav.tasks" class="list-unstyled"><li ng-repeat="task in nav.tasks"><div class="panel panel-default"><div class="panel-heading padding-left-15"><div class="input-group"><div class="input-group-btn"><div class="reorder-container display-flex inline" ng-class="{\'padding-right-sm\': task.id === 0 && !vm.isVehicleTask(task)}"><i class="material-icons font-size-22 cursor-pointer">menu</i></div></div><div class="col-md-8 task-heading"><div class="panel-title padding-left-sm padding-top-xs" ng-if="task.id !== 0 || vm.isVehicleTask(task)">{{task.heading}}</div><input type="text" class="form-control col-md-3" ng-if="task.id === 0 && !vm.isVehicleTask(task)" ng-model="task.heading" placeholder="Task Header" required="required"></div><div class="input-group-btn"><switch id="{{ vm.getSwitchId(task) }}" name="{{ vm.getSwitchId(task) }}" ng-model="task.switchedOn" class="green"></switch></div></div></div><div class="panel-heading" ng-if="(task.message && task.message != \' \') || task.switchedOn"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label task-type padding-right-none">Task Type</label><div class="col-sm-3 padding-left-none"><select class="form-control" name="taskType" ng-model="task.taskType" ng-options="taskType.value as taskType.text for taskType in vm.taskTypes" ng-change="vm.onTaskTypeChanged(task)" ng-disabled="task.id != 0"></select></div><div class="col-sm-3"><select class="form-control" name="vinTaskType" ng-if="task.taskType == vm.workflowTaskTypes.vinScan" ng-model="task.vehicleType" ng-options="vehicleType.value as vehicleType.text for vehicleType in vm.vehicleTypes"></select></div><div class="col-sm-4" ng-if="task.switchedOn && task.defaultMessage && task.defaultMessage != task.message && task.id != 0"><div class="pull-right"><a class="theme-link" href="#" ng-click="vm.useDefaultMessage(task)">Use Default Message</a></div></div></div><textarea class="form-control resize-none" name="taskMessage_{{vm.validationCnt}}_{{ task.questionId }}" ng-model="task.message" required="" ng-readonly="!task.switchedOn" ng-disabled="!task.switchedOn" validation="required:alt=Required"></textarea><div class="vehicle-task-options" ng-if="vm.isVehicleTask(task) || task.taskType === vm.workflowTaskTypes.customerVehicleTasksMulti"><label class="checkbox-inline"><input type="checkbox" ng-model="task.includesVinScan" ng-disabled="task.taskType === vm.workflowTaskTypes.customerVehicleTasksMulti"> <span>Scan VIN</span></label> <label class="checkbox-inline" ng-if="task.taskType === vm.workflowTaskTypes.customerVehicleTasksMulti"><input type="checkbox" ng-model="task.includesRepairOrder"> <span>Repair Order</span></label> <label class="checkbox-inline"><input type="checkbox" ng-model="task.includesMileage"> <span>Mileage</span></label> <label class="checkbox-inline"><input type="checkbox" ng-model="task.includesFuelLevel"> <span>Fuel Level</span></label> <label class="checkbox-inline"><input type="checkbox" ng-model="task.includesVehicleExterior"> <span>Vehicle Condition</span></label> <label class="checkbox-inline"><input type="checkbox" ng-model="task.includesDamageIssues"> <span>Damage and Issues</span></label> <label class="checkbox-inline" ng-if="task.taskType === vm.workflowTaskTypes.loanerVehicleTasks"><input type="checkbox" ng-model="task.includesDriversLicense"> <span>Verify Driver\'s License</span></label></div><task-selections ng-model="task" ng-if="task.taskType == 12 || task.taskType == 13" selection-task-validation=""></task-selections></div></div></div></li></ul><div ng-if="nav.tasks && nav.tasks.length > 0"><div class="text-right task-bottom-spacer"><a class="theme-link" ng-click="vm.addNewTask(nav.id)" href="#">Add new task to {{ nav.friendlyState }} segment</a></div><div ng-if="!$last" class="task-bottom-spacer"><hr></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-click="vm.updateTasks()" ng-disabled="!inputForm.$valid || vm.tasksUpdating">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.location"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-ui.view.html','<div class="col-sm-10" ng-controller="TabSurveyController as vm"><div class="form-group info-location"><h3>UI</h3><p>Illum consequat decima augue modo quam. Feugait sit parum eorum aliquip decima. Lectores autem iriure anteposuerit anteposuerit facer.</p><hr></div></div>');
$templateCache.put('app/areas/location/views/location-tab-user-permissions.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-100 overflow-y-auto"><form role="form" name="inputForm" class="form-horizontal full-width-height" novalidate=""><div class="flex-fullwidth-175h display-flex flex-column margin-left-md margin-top-md"><div class="margin-left-md"><h3>User Permissions</h3><p>Users permissions associated with this dealer.</p><hr class="margin-sm"></div><div class="margin-top-md margin-bottom-md" ng-if="!vm.isOnlyDealerAdmin"><div class="col-sm-2 col-xs-6"><label class="control-label">Show only dealer products:</label></div><div class="col-xs-3 col-sm-10"><span><switch id="showOnlyDealerProducts" ng-model="vm.showOnlyDealerProducts" class="green" ng-change="vm.getPermissions()"></switch></span></div></div><hr class="margin-sm"></div><div class="flex overflow-y-hidden overflow-x-auto margin-top-auto"><div class="col-sm-12"><div id="user-permissions-table-container" class="overflow-y-auto"><div ng-if="vm.isLoading"><div class="inline"><img src="assets/images/ajax-loader.gif"> Loading...</div></div><table class="table footable table-hover table-striped fixed-header-table overflow-y-auto" ng-if="!vm.isLoading"><thead><tr><th data-sort-ignore="true">User</th><th ng-repeat="feature in vm.features" ng-if="feature.isHidden === false"><center>{{feature.name | limitTo : 7}}</center></th></tr></thead><tbody><tr ng-repeat="user in vm.dealerEmployees" class="list-name"><td><div>{{ user.firstName }} {{ user.lastName}}</div><div>{{ user.email}}</div></td><td ng-repeat="feature in vm.features" ng-if="feature.isHidden === false"><center><input type="checkbox" id="feature-{{feature.id}}-{{user.id}}" name="feature-{{feature.id}}-{{user.id}}" ng-model="user.roles[feature.id]"></center></td></tr></tbody></table></div></div></div></form></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.submitDisabled()" ng-click="vm.saveChanges()">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-tab-users.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg" fill-height=""><h3>User Information</h3><p>Users associated to this dealer.</p><hr><form role="form" name="inputForm" class="form-horizontal" novalidate=""><div class="form-group"><div class="col-sm-12"><div class="table-responsive"><table class="table footable table-hover"><thead><tr><th data-sort-ignore="true">Photo</th><th data-sort-ignore="true"></th><th data-toggle="true" data-type="alpha">User</th><th data-toggle="true">Name</th><th data-toggle="true">Active</th><th data-toggle="true">Enrolled</th><th data-sort-ignore="true">Resend Email</th></tr></thead><tbody><tr ng-repeat="user in vm.dealerEmployees" class="list-name"><td class="user-profile-pic" ui-sref="user-tab-general({ userId: user.id })"><img class="img-circle" ng-src="{{ ::user.profilePicture }}"></td><td class="spacer" ui-sref="user-tab-general({ userId: user.id })"></td><td class="hidden">dealerEmployeeId: {{ ::user.dealerEmployeeId }}</td><td class="user-name" ui-sref="user-tab-general({ userId: user.id })">{{ ::user.userName }}<br><div class="phone-number" ng-if="user.mobilePhone"><i class="fa fa-mobile"></i>{{ ::user.mobilePhone|tel }}</div><div class="phone-number" ng-if="user.officePhone"><i class="fa fa-phone"></i>{{ ::user.officePhone|tel }}</div></td><td class="user-name" ui-sref="user-tab-general({ userId: user.id })">{{ ::user.fullName }}</td><td class="user-name" ui-sref="user-tab-general({ userId: user.id })"><span class="fa" ng-class="{ \'fa-check\': user.isActive }"></span></td><td class="user-name" ui-sref="user-tab-general({ userId: user.id })"><span class="fa" ng-class="{ \'fa-check\': user.isOnboarded }"></span></td><td class="user-name"><switch id="sendWelcomeEmail-{{$index}}" name="sendWelcomeEmail-{{$index}}" disabled="user.isOnboarded" ng-model="user.sendWelcomeEmail" class="green"></switch></td></tr></tbody></table></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.moveActiveUsers()" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ladda="isDataLoading" ng-if="vm.isAdmin">Move Active Users</button> <button type="button" ng-click="vm.sendWelcomeEmails()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.submitDisabled()">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/location-uber-serviceability.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">UBER Serviceability</h2><p>Choose an address using the search field below to determine UBER serviceability for the location.</p></div><div class="modal-body padding-t-b-0 text-uppercase"><div class="row margin-top"><div class="col-sm-6"><div class="form-group"><input type="text" ng-attr-placeholder="SEARCH FOR ADDRESS" id="location_address" name="location_address" ng-model="vm.address" class="form-control better-placeholder" details="vm.places" ng-required="true" here-places="" options="vm.options" handle-selected="vm.placeUpdated(formattedAddress)" autocomplete="off"> <img src="assets/images/ajax-loader.gif" class="ng-hide venue-location-spinner" ng-show="vm.loadingDealers"></div></div></div><div class="form-group margin-top-lg" ng-if="vm.results"><div class="row"><label class="col-sm-2 col-xs-2 control-label text-right">Address:</label><div class="col-sm-4 col-xs-4">{{ vm.results.address }}</div></div><div class="row margin-top-sm"><label class="col-sm-2 col-xs-2 control-label text-right">Serviceable:</label><div class="col-sm-4 col-xs-4">{{ vm.results.is_serviceable ? \'Yes\' : \'No\' }}</div></div><div class="row margin-top-sm"><label class="col-sm-2 col-xs-2 control-label text-right">Dropoff zip codes:</label><div class="col-sm-9 col-xs-9 text-break"><span ng-repeat="zip in vm.results.serviceable_dropoff_zip_codes track by $index">{{ zip }}<span ng-if="!$last">,</span></span></div></div></div><div class="form-group" ng-if="vm.error"><div class="row"><div class="col-sm-12 text-danger">{{ vm.error }}</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.close()">Close</button></div></div>');
$templateCache.put('app/areas/location/views/location-venue-mappings.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">Pickup/Dropoff Points</h2><p>Use this screen to specify pickup and dropoff locations around your property to help drivers arrive on time where expected. Setting locations is highly recommended for rideshare and delivery providers. When setting a pickup/dropoff point, zoom in as much as possible on your property and place the pin at the exact location where drivers should park and wait for their customer.</p></div><div class="modal-body padding-t-b-0 text-uppercase"><div ng-if="vm.isAdmin" class="row margin-top"><div class="col-sm-6"><div class="form-group field-wrapper"><label for="dealer">SELECT LOCATION</label><select selectlabel="" required="" name="dealer" id="dealer" class="form-control" ng-model="vm.selectedDealerId" ng-change="vm.selectedDealerChanged()" ng-options="dealer.id as dealer.name for dealer in vm.dealers"><option value="">Select location</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide venue-location-spinner" ng-show="vm.loadingDealers"></div></div></div><div ng-repeat="dealer in vm.dealerVenues" class="border-top padding-top-lg"><h3>{{ dealer.dealerName }}</h3><div ng-repeat="tt in dealer.tripTypes" class="row venue-item"><div class="col-sm-4">{{ tt.tripTypeName }}</div><div class="col-sm-4"><span ng-if="tt.venue"><strong>LAT:</strong>{{ tt.venue.lat }}/<strong>LNG:</strong>{{ tt.venue.lng }}</span> <span ng-if="!tt.venue">NOT SET</span></div><div class="col-sm-4"><button class="btn btn-default" ng-click="vm.setVenueForTripType(tt.dealerTripTypeId, dealer)">SET LOCATION</button></div></div><br><br></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.close()">Close</button></div></div><div class="venue-mapping-popup" ng-if="vm.currentDealer"><div class="content-centered popup-body"><h3>{{ vm.currentDealer.dealerName }} - {{ vm.currentTripType.tripTypeName }} Pickup/Dropoff Point</h3><p>You can set a new location using the steps below. If you have setup other locations, you can reuse them by selecting from the COPY FROM dropdown.</p><ol><li class="margin-bottom">Verify the address is correct for this Pickup/Dropoff point. For example, if your service department is at a different address than your main location, then enter that address.</li><li class="margin-bottom">Drag the map below to position the pin inside the blue circle exactly where drivers need to arrive for this location. If you need to place the pin outside the circle, the address must be changed to reposition the circle. You can zoom in and out of the map for greater accuracy.</li><li>Once you are done, click the UPDATE button below.</li></ol><venue-mapping venue="vm.currentDealer.venue || vm.currentDealer" copy-from-venues="vm.existingVenues" on-save="vm.saveVenue" on-cancel="vm.cancelVenueSetting"></venue-mapping></div></div>');
$templateCache.put('app/areas/messages/views/contact-add.view.html','<div id="messages"><div class="aside-wrapper flex-fill border-radius-top-7"><div class="display-flex flex-column overflow-hidden full-height border-radius-top-7"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New Contact</div></div></div><div class="aside-body flex-fill"><div class="row" style="flex: 1 0 auto;"><div class="col-sm-12 padding-left-none margin-top"><uib-accordion close-others="true" class="trips-wizard" style="flex-grow: 1; overflow: hidden;height: 100%"><div class="ng-hide" ng-show="vm.currentStep >= vm.steps.location" ng-class="{\'hide-border\':vm.currentStep === vm.steps.location}"><div uib-accordion-group="" class="panel-default" is-open="vm.currentStep === vm.steps.location" is-disabled="true"><uib-accordion-heading><h4 class="panel-title"><span class="hidden-xs">LOCATION</span> <span class="visible-xs margin-bottom" ng-show="vm.currentStep === vm.steps.location">LOCATION</span><div class="selected-accordion-location inline"><div class="ng-hide small-accordion-header text-uppercase inline" ng-show="vm.selectedLocation">{{ vm.selectedLocation.name }}</div><div class="ng-hide accordion-clear-step" ng-show="vm.selectedLocation" ng-style="{ \'visibility\': vm.locations.length > 1 ? \'visible\' : \'hidden\' }" ng-click="vm.clearSelectedLocation()"><i class="material-icons">edit</i></div></div></h4></uib-accordion-heading><div id="chooseLocationForm" class="row"><div class="col-sm-8 col-xs-12 col-lg-6 padding-none" ng-if="vm.locations.length > vm.locationSearchThreshold"><div class="form-group field-wrapper"><label for="locationFilter">SELECT A LOCATION</label><select data-placeholder-text-single="\'Find a location\'" selectlabel="" class="form-control" name="locationFilter" id="locationFilter" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vm.selectedLocation" max-shown-results="100" ng-options="l as l.name for l in vm.locations" ng-change="vm.onSelectLocation()"><option value="">Select a location</option></select></div></div><div ng-if="vm.thresholdLocations"><div class="row margin-top-md"><div class="col-xs-11 padding-none"><table id="zip-filtered-locations"><tr ng-repeat="location in vm.thresholdLocations" ng-class="{\'border-bottom\': $index < vm.thresholdLocations.length - 1 }"><td class="padding-md loc-icon" ng-click="vm.selectLocation(location)"></td><td class="padding-md loc-details" ng-click="vm.selectLocation(location)"><div class="theme-link"><strong>{{location.name}}</strong></div><div>{{location.address}}, {{location.city}}, {{location.zip}}</div></td></tr></table></div></div></div></div></div></div><div class="ng-hide" ng-show="vm.currentStep >= vm.steps.contact" ng-class="{\'hide-border\':vm.currentStep === vm.steps.contact}"><div uib-accordion-group="" class="panel-default" is-open="vm.currentStep === vm.steps.contact" is-disabled="true"><uib-accordion-heading><h4 class="panel-title">CONTACT<div class="inline pull-right"><span class="ng-hide small-accordion-header text-uppercase" ng-show="vm.selectedContact">{{ vm.selectedContact.firstName }} {{ vm.selectedContact.lastName }} {{ vm.selectedContact.mobilePhone | tel }}</span><div class="ng-hide accordion-clear-step" ng-show="vm.selectedContact" ng-click="vm.clearSelectedContact()"><i class="material-icons">edit</i></div></div></h4></uib-accordion-heading><div id="chooseCustomerForm"><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><span class="control-label font-bold" ng-if="!vm.isCreatingNew">SEARCH FOR RO</span></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><select id="rosearch" name="rosearch" multiple="" ng-model="vm.repairOrderId" ui-select2="vm.repairOrderSearchOptions" class="select2-single form-control"></select></div></div></div><div class="row"><div class="col-sm-6 col-xs-12 col-lg-6 padding-none"><div class="form-group"><div class="control-label font-bold">OR SEARCH FOR CUSTOMER</div></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-lg-6 padding-none"><div class="form-group"><select id="phonesearch" name="phonesearch" multiple="" ng-model="vm.contactId" ui-select2="vm.phoneSearchOptions" class="select2-single form-control"></select></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><div class="control-label font-bold">OR ENTER INFORMATION</div></div></div></div><form role="form" name="contactForm" ng-submit="vm.selectContact()" novalidate="" class="form"><div class="row"><div class="form-group padding-left-none"><div class="col-sm-4 col-xs-12 padding-left-none override-xs-side-padding-none block relative"><input type="text" name="firstName" ng-model="vm.firstName" class="form-control better-placeholder" placeholder="FIRST NAME" required="" validation="required"></div><div class="col-sm-4 padding-left-none col-xs-12 override-xs-side-padding-none override-xs-padding-top-md"><div class="block relative"><input type="text" name="lastName" ng-model="vm.lastName" class="form-control better-placeholder" placeholder="LAST NAME" required="" validation="required"></div></div><div class="col-sm-4 padding-left-none col-xs-12 override-xs-side-padding-none override-xs-padding-top-md"><div class="block relative"><input type="text" name="mobilePhone" ng-model="vm.mobilePhone" placeholder="MOBILE PHONE" inputmode="numeric" pattern="(?:\\(\\d{3}\\)|\\d{3})[- ]?\\d{3}[- ]?\\d{4}" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" ng-change="vm.checkPhoneType(vm.mobilePhone)" required="" validation="required"></div><phone-detail-indicator detail="vm.phoneDetail"></phone-detail-indicator></div></div></div></form></div></div></div></uib-accordion></div></div></div><div class="aside-footer display-flex flex-justify-right padding-md flex-gap-sm"><button type="button" class="btn btn-default text-uppercase" ng-click="$dismiss()" ng-class="config.styleClass" ui-sref="contact-list">Close</button> <button type="button" class="btn btn-primary text-uppercase" ng-show="vm.selectedLocation" ng-disabled="!vm.firstName || !vm.lastName || !vm.mobilePhone" ng-click="vm.selectContact()">Next</button></div></div></div></div>');
$templateCache.put('app/areas/messages/views/contact-detail.view.html','<div id="messages"><div class="aside-wrapper display-flex border-radius-top-7 flex-column"><div class="aside-header border-radius-top-7 gray-bg"><div class="row" style="height: 100%;"><div class="col-xs-12"><div class="contact-details margin-top margin-bottom" ng-show="!vm.isEditingContact"><div class="row"><div class="col-sm-11 col-xs-10" ng-mouseenter="vm.contactHovering = true" ng-mouseleave="vm.contactHovering = false"><div class="contact-name"><h4 class="text-uppercase"><rc-contact-name contact="vm.contact"></rc-contact-name></h4><div type="button" class="padding-left-sm inline text-uppercase cursor-pointer hidden-xs" ng-click="vm.editContact()" title="Edit"><i class="material-icons md-14">mode_edit</i></div></div><div class="row contact-phone"><div class="col-xs-12"><span ng-if="vm.contact.mobilePhone">{{ vm.contact.mobilePhone | tel }}</span> <span ng-if="!vm.contact.mobilePhone">(No Mobile Phone Number)</span> <i class="material-icons md-14 text-danger align-text-bottom theme-link" ng-show="!vm.contact.isOptedOut && vm.contact.phoneNumberType === vm.phoneTypes.landline" uib-popover="This is a Landline and cannot receive text messages." popover-trigger="mouseenter">phonelink_erase</i> <i class="material-icons md-14 text-danger align-text-bottom theme-link" ng-show="!vm.contact.isOptedOut && vm.contact.phoneNumberType === vm.phoneTypes.voip" uib-popover="This is a VoIP number and may not be able to receive text messages." popover-trigger="mouseenter">phonelink_erase</i> <i class="material-icons md-14 text-danger align-text-bottom theme-link" ng-show="vm.contact.isOptedOut" uib-popover="Customer has opted out of text messages. To opt into messages, customer must text START to {{ vm.contact.dealerPhone | tel }}." popover-trigger="mouseenter">speaker_notes_off</i><br><span class="text-uppercase">{{ vm.contact.dealerName }}</span><div class="text-uppercase">{{ vm.contact.primaryFollowerName }}</div></div></div></div><div class="col-sm-1 col-sm-1 visible-xs-block pull-right contact-more"><div class="icon-wrapper" ng-click="vm.toggleMobileActionFollowers()"><i class="material-icons md-24" title="Show Tools">more_vert</i></div></div></div></div><div ng-if="vm.isEditingContact" class="panel-body" id="edit-contact-form"><form name="createContactForm" class="clearfix padding-top-sm padding-bottom-xs black" ng-submit="vm.updateContact()" novalidate=""><div class="row padding-bottom-xs"><div class="col-sm-12"><div class="row"><div class="form-group col-sm-2 margin-bottom-md"><label for="firstName" class="sr-only">First Name</label> <input id="firstName" type="text" class="form-control better-placeholder" ng-model="vm.editingContact.firstName" placeholder="FIRST NAME"></div><div class="form-group col-sm-2 margin-bottom-md"><label for="lastName" class="sr-only">Last Name</label> <input id="lastName" type="text" class="form-control better-placeholder" ng-model="vm.editingContact.lastName" placeholder="LAST NAME"></div><div class="form-group col-sm-2 margin-bottom-md"><label class="sr-only" for="mobilePhone">Mobile Phone</label> <input type="text" id="mobilePhone" name="mobilePhone" ng-model="vm.editingContact.mobilePhone" placeholder="MOBILE PHONE" class="form-control better-placeholder" mask-restrict="reject" ng-change="vm.checkPhoneType(vm.editingContact.mobilePhone)" mask="(999) 999-9999" clean="true" validation="required"><phone-detail-indicator detail="vm.phoneDetail"></phone-detail-indicator></div><div class="form-group col-sm-2 margin-bottom-md"><label for="email" class="sr-only">Email</label> <input id="email" type="email" class="form-control better-placeholder" ng-model="vm.editingContact.email" placeholder="EMAIL"></div><div class="form-group col-sm-2 margin-bottom-md"><label for="dmsCustomerId" class="sr-only">DMS Customer ID</label> <input id="dmsCustomerId" type="text" class="form-control better-placeholder" ng-model="vm.editingContact.dmsCustomerId" placeholder="DMS ID"></div><div class="form-group col-sm-2 margin-bottom-md field-wrapper"><label for="serviceAdvisorFilter">PRIMARY FOLLOWER</label><select selectlabel="" class="form-control" id="serviceAdvisorFilter" name="serviceAdvisorFilter" allow-null-option="No primary follower" ng-options="l.identityUserId as l.firstName + \' \' + l.lastName for l in vm.serviceAdvisors" ng-model="vm.editingContact.primaryFollowerId"></select></div></div><div class="row"><div class="col-sm-12"><button type="submit" class="btn btn-primary text-uppercase" ng-disabled="createContactForm.$invalid" ladda="vm.isContactUpdating">Save</button> <button type="button" class="btn black btn-default text-uppercase" ng-click="vm.cancelEditContact()">Cancel</button></div></div></div></div></form></div><div class="aside-right-tabs message-tabs" style="position: absolute; bottom: 0; right: 0; margin-bottom: -11px"><ul class="nav nav-tabs"><li ng-repeat="tab in vm.tabs" class="uib-tab" ui-sref-active="active"><a href="#" class="text-uppercase" ui-sref="{{tab.route}}"><span ng-if="vm.contact.hasUnread && tab.route === \'contact-detail-customer\'"><i class="theme-link material-icons message-tab-icon">lens</i></span> <span ng-if="vm.contact.hasUnreadInternal && tab.route === \'contact-detail-internal\'"><i class="theme-link material-icons message-tab-icon">lens</i></span> {{tab.title}}</a></li></ul></div></div></div></div><div id="contact-detail-aside-body" class="aside-body"><div class="row" style="height: 100%" ui-view="contact-detail-customer" ng-show="vm.isTabActive(\'contact-detail-customer\')"></div><div class="row" style="height: 100%" ui-view="contact-detail-internal" ng-show="vm.isTabActive(\'contact-detail-internal\')"></div></div></div></div>');
$templateCache.put('app/areas/messages/views/contact-list-item.view.html','<td class="icon text-center hidden-xs lens-sort"><i ng-if="contact.acknowledgement === vm.acknowledgementTypes.none" class="material-icons md-18 align-middle" ng-class="{ \'theme-link\': contact.isEscalated }" uib-popover="{{contact.isEscalated ? \'Escalated\' : \'Not Escalated\'}}" popover-trigger="mouseenter">notifications_active</i> <i ng-if="contact.acknowledgement === vm.acknowledgementTypes.manual" class="material-icons md-18 align-middle" uib-popover="Escalation Silenced" popover-trigger="mouseenter">notifications_off</i> <i ng-if="contact.acknowledgement === vm.acknowledgementTypes.reply" class="material-icons md-18 align-middle" uib-popover="Replied" popover-trigger="mouseenter">reply</i></td><td class="icon text-center hidden-xs read-sort"><span ng-if="contact.hasUnreadMessages"><span ng-if="(contact.isMyContact || contact.isImpersonating)"><i class="material-icons md-14 theme-link align-middle unread-messages" ng-class="config.styleClass" uib-popover="Unread Messages" popover-trigger="mouseenter">lens</i></span> <span ng-if="(!contact.isMyContact && !contact.isImpersonating)"><i class="material-icons md-8 theme-link align-middle unread-messages" style="opacity: 0.50" ng-class="config.styleClass" uib-popover="Unread Messages" popover-trigger="mouseenter">lens</i></span></span></td><td class="icon text-center hidden-xs"><span ng-if="contact.isImpersonating" uib-tooltip="Displayed because you are watching {{ contact.impersonations[0] }}\'s contacts." tooltip-placement="right"><i class="material-icons md-14 align-middle">visibility</i></span></td><td class="text-uppercase"><div id="mobile-icons" class="visible-xs-block"><i ng-if="contact.acknowledgement === vm.acknowledgementTypes.none" class="material-icons md-18 align-middle" ng-class="{ \'theme-link\': contact.isEscalated }">notifications_active</i> <i ng-if="contact.acknowledgement === vm.acknowledgementTypes.manual" class="material-icons md-18 align-middle">notifications_off</i> <i ng-if="contact.acknowledgement === vm.acknowledgementTypes.reply" class="material-icons md-18 align-middle">reply</i> <span ng-if="contact.isImpersonating" uib-tooltip="Displayed because you are watching {{ contact.impersonations[0] }}\'s contacts." tooltip-placement="right"><i class="material-icons md-14 align-middle">visibility</i></span> <span ng-if="contact.hasUnreadMessages"><i class="material-icons md-14 theme-link lens align-middle" ng-class="config.styleClass">lens</i></span> <span ng-if="contact.isFlagged"><i class="material-icons md-18 theme-link align-middle" ng-class="config.styleClass">flag</i></span></div><strong><rc-contact-name contact="contact"></rc-contact-name></strong> <span class="visible-xs-inline pull-right">{{contact.lastMessageDate | date: "h:mma"}}</span> <span class="hidden-xs"><br><span>{{ contact.mobilePhone | tel }}</span> <i class="material-icons md-18 text-danger align-text-bottom" ng-show="!contact.isOptedOut && contact.phoneNumberType === vm.phoneTypes.landline" uib-popover="This is a Landline and cannot receive text messages." popover-trigger="mouseenter">phonelink_erase</i> <i class="material-icons md-18 text-danger align-text-bottom" ng-show="!contact.isOptedOut && contact.phoneNumberType === vm.phoneTypes.voip" uib-popover="This is a VoIP number and may not be able to receive text messages." popover-trigger="mouseenter">phonelink_erase</i> <i class="material-icons md-18 text-danger align-text-bottom" ng-show="contact.isOptedOut" uib-popover="Customer has opted out of text messages. To opt into messages, customer must text START to {{ contact.dealerPhone | tel }}." popover-trigger="mouseenter">speaker_notes_off</i></span><div class="visible-xs-block last-message ellipsis-overflow">{{ contact.lastMessage }}</div></td><td ng-if="vm.locations.length > 1" class="hidden-xs"><span class="text-uppercase">{{ contact.dealerName }}</span></td><td class="hidden-xs"><div class="last-message"><strong ng-if="contact.lastMessageStatus === 14">Failed:</strong> {{ contact.lastMessage }}</div></td><td class="hidden-xs">{{ contact.lastMessageDate | localDate: \'MM/DD/YY h:mmA\' }}</td><td class="text-uppercase hidden-xs">{{ contact.lastMessageBy }}</td><td class="action hidden-xs"><select class="form-control" ng-model="vm.selectedAction" ng-change="vm.onActionSelected(contact)" prevent-bubbling=""><option value="">Action</option><option ng-value="vm.actions.follow" ng-if="!contact.isFollowing">Follow</option><option ng-value="vm.actions.unfollow" ng-if="contact.isFollowing">Unfollow</option><option ng-value="vm.actions.markAsRead" ng-if="contact.hasUnreadMessages">Mark as Read</option><option ng-value="vm.actions.markAsUnread" ng-if="!contact.hasUnreadMessages">Mark as Unread</option><option ng-value="vm.actions.escalate" ng-if="!contact.isEscalated">Escalate</option><option ng-value="vm.actions.markAsAcknowledged" ng-if="contact.acknowledgement === vm.acknowledgementTypes.none">Mark as Answered</option><option ng-value="vm.actions.markAsUnacknowledged" ng-if="contact.acknowledgement !== vm.acknowledgementTypes.none">Mark as Unanswered</option><option ng-value="vm.actions.flag" ng-if="!contact.isFlagged">Flag</option><option ng-value="vm.actions.unflag" ng-if="contact.isFlagged">Unflag</option></select></td>');
$templateCache.put('app/areas/messages/views/contact-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="messages" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="position-relative display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md override-sm-margin-none"><div class="flex-percent-80 flex-sm-percent-100 flex-xs-percent-100"><div class="display-flex flex-row full-width visible-xs visible-sm"><div class="flex-sm-percent-80 flex-xs-percent-80 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.contacts.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)" align-right="true"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30" ng-if="!vm.showAdvancedSearch"><a ui-sref="contact-add" class="margin-left-md margin-top-xs visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row full-width visible-xs visible-sm margin-top-sm"><div class="flex-sm-percent-100 flex-xs-percent-60 flex-grow visible-xs visible-sm padding-right-md override-xs-padding-none override-sm-padding-none"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none text-notransform"><input type="text" class="form-control padding-right-md better-placeholder" ng-model="vm.filters.search" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshContacts()" placeholder="Customer Search"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div></div><div class="display-flex flex-row hidden-xs hidden-sm"><div class="flex-width-200"><div class="block relative padding-right-sm" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-200 max-width-px-400 flex-grow flex-xs-percent-100 override-xs-margin-top-md" ng-if="vm.locations.length > 1"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><div class="field-wrapper wizard-dropdown"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.filters.search" ng-change="vm.filterChanged()" class="form-control max-width-100-percent" chosen="{width: \'100%\'}" max-shown-results="100" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-model="vm.filters.location" ng-options="l as l.name for l in vm.locations track by l.id"></select></div></div></div><div class="flex-width-200 max-width-px-400 flex-grow flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input type="text" class="form-control padding-right-md better-placeholder" ng-model="vm.filters.search" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshContacts()" placeholder="Customer Search"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 hidden-xs hidden-sm"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none text-notransform"><div class="chosen-field-wrapper"><label class="label selected padding-left-none">FOLLOWING STATUS</label></div><div id="following_status_filter" ng-dropdown-multiselect="" ng-model-options="{ debounce: 750 }" events="vm.filterEvents" ng-disabled="vmList.isLoading" options="vm.searchScopes" selected-model="vm.filters.scopes" checkboxes="true" append-to-body="true" extra-settings="vm.searchScopeSettings" translation-texts="vm.searchScopeStrings"></div><div ng-if="vm.showServiceAdvisorWarning" class="text-danger">Your customers are hidden</div></div></div><div class="flex-percent-20 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.contacts.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)"></rc-list-advanced-filter-toggle></div></div><div ng-if="vm.isAdmin === true" class="display-flex flex-row flex-sm-column visible-xs visible-sm padding-bottom-md padding-bottom-none"><rc-list-mobile-filters ng-if="vm.filters.location" required-filter-message="vm.requiredFilterMessage" required-filter-count="1" filter-count="vm.filterCount" record-count="vm.contacts.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div><div ng-if="vm.isAdmin === false" class="display-flex flex-row flex-sm-column visible-xs visible-sm padding-bottom-md"><rc-list-mobile-filters filter-count="vm.filterCount" record-count="vm.contacts.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div></div><div class="flex-percent-20 text-right pad-left-15 override-xs-side-padding-none flex-xs-percent-100 override-xs-margin-top-md override-xs-text-left hidden-xs hidden-sm"><a ui-sref="contact-add" class="btn btn-primary new-btn" ng-class="config.styleClass"><span class="hidden-xs">+</span> NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="contact-table-wrapper"><table id="contacts-table" class="table table-hover searchable-list table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll-container="\'#contact-table-wrapper\'" ng-mousemove="vm.removeSelectedId()" infinite-scroll="vm.search()" infinite-scroll-distance="1" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore || !vm.contacts || vm.contacts.length === 0" redcap-sort="true" redcap-sort-model="vm.filters" redcap-sort-callback="vm.sortChanged"><thead class="hidden-xs"><tr class="text-uppercase"><th sort-column="Acknowledgement" class="icon text-center read-sort"><i class="material-icons md-18 align-middle sortable-header-icon">notifications_active</i></th><th sort-column="Read" class="icon text-center lens-sort"><i class="material-icons md-8 align-middle unread-messages sortable-header-icon" ng-class="config.styleClass">lens</i></th><th class="lens-sort" ignore-sort=""></th><th sort-column="Customer">Customer</th><th ng-show="vm.locations.length > 1" sort-column="Location">Location</th><th sort-column="LastMessage">Last Message</th><th sort-column="LastDate">Last Date</th><th sort-column="LastSender">Last Sender</th><th ignore-sort="">Action</th></tr></thead><tbody><tr id="fc-{{contact.id}}" ng-class="{\'selected\': vm.selectedId === \'fc-\' + contact.id, \'last\': $last}" ng-repeat="contact in vm.contacts | filter: { isFlagged : true }" ng-click="vm.openContact(contact.id, $event)" ng-include="\'app/areas/messages/views/contact-list-item.view.html\'" class="flagged"></tr><tr id="c-{{contact.id}}" ng-class="{\'selected\': vm.selectedId === \'c-\' + contact.id}" ng-repeat="contact in vm.contacts | filter: { isFlagged : false }" ng-click="vm.openContact(contact.id, $event)" ng-include="\'app/areas/messages/views/contact-list-item.view.html\'"></tr></tbody></table><rc-list-standardized-footer record-count="vm.invoices.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore"></rc-list-standardized-footer><div ng-if="vm.isAdmin && !vm.filters.location" class="text-uppercase full-width font-bold text-center" ng-show="!vm.isLoading">Please Select A Location</div></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25 min-height-px-250"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 max-width-px-400 flex-grow flex-sm-percent-100 override-xs-padding-top-md override-sm-padding-top" ng-if="vm.locations.length > 1"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><div class="field-wrapper wizard-dropdown"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.filters.search" ng-change="vm.filterChanged()" class="form-control max-width-100-percent" chosen="{width: \'100%\'}" max-shown-results="100" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-model="vm.filters.location" ng-options="l as l.name for l in vm.locations track by l.id"></select></div></div></div><div class="flex-width-200 max-width-px-400 flex-grow flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none text-notransform"><input type="text" class="form-control padding-right-md better-placeholder" ng-model="vm.filters.search" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshContacts()" placeholder="Customer Search"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-md override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><div class="chosen-field-wrapper"><label class="label selected padding-left-none">FOLLOWING STATUS</label></div><div id="following_status_filter" ng-dropdown-multiselect="" ng-model-options="{ debounce: 750 }" events="vm.filterEvents" ng-disabled="vmList.isLoading" options="vm.searchScopes" selected-model="vm.filters.scopes" checkboxes="true" append-to-body="true" extra-settings="vm.searchScopeSettings" translation-texts="vm.searchScopeStrings"></div><div ng-if="vm.showServiceAdvisorWarning" class="text-danger">Your customers are hidden</div></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md"><div class="flex-width-200 padding-left-sm flex-xs-percent-100 flex-sm-percent-100 override-sm-margin-top-none override-xs-margin-top-none override-xs-padding-none override-sm-padding-none"><div class="block relative field-wrapper override-xs-padding-none override-sm-padding-none"><label for="statusFilter">SELECT A STATUS</label><select selectlabel="" class="form-control" ng-model="vm.filters.status" ng-disabled="vm.filters.search" id="statusFilter" name="statusFilter" ng-change="vm.filterChanged()" ng-options="contactStatus.text for contactStatus in vm.contactStatuses track by contactStatus.value"></select></div></div><div class="flex-width-200 flex-xs-percent-100 flex-sm-percent-100"><div class="block relative padding-left-sm padding-right-sm field-wrapper override-xs-padding-none override-sm-padding-none override-xs-margin-top-none override-sm-margin-top"><label for="statusFilter">SELECT A TIME FRAME</label><select selectlabel="" class="form-control" ng-model="vm.filters.timeframe" ng-disabled="vm.filters.search" id="timeFilter" name="timeFilter" ng-change="vm.filterChanged()" ng-options="contactTimeframe.text for contactTimeframe in vm.contactTimeframes track by contactTimeframe.value"></select></div></div></div><div class="display-flex flex-row padding-bottom-lg"><div class="flex-width-200 padding-left-sm padding-right-sm flex-sm-percent-60 text-left margin-top-md override-xs-padding-none override-sm-padding-none override-xs-margin-top-none"><div class="block relative padding-right-sm"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vm.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md override-xs-margin-none"><rc-list-template-save-search-delete-btns list-controller="vm" current-search-template="vm.searchTemplateData.currentSearchTemplate" is-processing-template="vm.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vm.canManageGlobalTemplates" template-message="vm.templateMessage" save-btn-clicked="vm.saveBtnClicked()" save-as-btn-clicked="vm.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vm.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm" ng-click="vm.resetFilters(true);vm.close();">Reset Filters</div><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/messages/views/contact-name.view.html','<span><span ng-if="!$ctrl.contact.firstName && !$ctrl.contact.lastName">Unknown Contact</span> <span ng-if="$ctrl.contact.firstName">{{ $ctrl.contact.firstName }}</span> <span ng-if="$ctrl.contact.lastName">{{ $ctrl.contact.lastName }}</span></span>');
$templateCache.put('app/areas/messages/views/message-list.view.html','<div class="message-list margin-top-md margin-right-md margin-left-md flex-grow flex-percent-90"><div ng-if="$ctrl.messages.length === 0"><div class="speech-bubble-body full-width">No message history found.</div></div><div ng-repeat="message in $ctrl.messages | orderBy: \'dateCreated\' track by message.id" class="clearfix"><div ng-if="!message.isSeparator && !message.isDateBubble" class="speech-bubble" ng-class="{ to: $ctrl.addToClass(message), \'trip-note\': $ctrl.panelMode === $ctrl.messagingPanelModes.tripNotes }"><div ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.tripNotes"><div class="speech-bubble-header margin-bottom-sm margin-top-sm"><span>{{ message.noteTypeName }}</span></div><div class="speech-bubble-body full-width"><div ng-bind-html="message.note | message"></div><div class="margin-top-md speech-bubble-footer"><span class="font-italic">{{ message.dateCreated | time }}</span> <span class="font-italic">by {{ message.createdBy }}</span> <a ng-if="$ctrl.deletingNoteId !== message.id" class="text-uppercase float-right margin-left-md" ng-click="$ctrl.deleteNote(message.tripId, message.id)">Delete</a> <span ng-if="$ctrl.deletingNoteId === message.id" class="text-uppercase float-right disabled margin-left-md">Deleting...</span></div></div></div><div ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.dealerInfo"><div class="speech-bubble-body full-width"><div ng-bind-html="message.note | message"></div><div class="margin-top-md speech-bubble-footer"><span class="font-italic">{{ message.dateCreated | time }}</span> <span class="font-italic">by {{ message.createdBy }}</span> <a ng-if="$ctrl.deletingDealerNoteId !== message.id" class="text-uppercase float-right margin-left-md" ng-click="$ctrl.deleteDealerNote(message.id)">Delete</a> <span ng-if="$ctrl.deletingDealerNoteId === message.id" class="text-uppercase float-right disabled margin-left-md">Deleting...</span></div></div></div><div ng-if="$ctrl.panelMode !== $ctrl.messagingPanelModes.tripNotes && $ctrl.panelMode !== $ctrl.messagingPanelModes.dealerInfo && !message.isOptOutMessage"><div class="speech-bubble-header margin-bottom-sm margin-top-sm"><span>{{ message.createdBy }}&nbsp;&nbsp;</span> <span class="pull-right text-uppercase">{{ message.dateCreated | time }}</span></div><div class="speech-bubble-body full-width"><div class="image-grid" ng-if="message.media && message.media.length > 0"><div class="width-px-120" ng-repeat="media in message.media"><div ng-if="$ctrl.isImage(media)"><img class="image-container border-none position-relative margin-right-md overflow-hidden cursor-pointer text-align-center" ng-src="{{media.url}}" ng-click="$ctrl.openImageModal(media.url, media.fileName, $ctrl.mediaTypes.photo)"></div><div class="position-relative" ng-if="$ctrl.isVideo(media)"><video class="image-container border-none position-relative margin-right-md overflow-hidden cursor-pointer text-align-center" ng-src="{{media.url}}" ng-click="$ctrl.openImageModal(media.url, media.fileName, $ctrl.mediaTypes.video)"></video><span ng-click="$ctrl.openImageModal(media.url, media.fileName, $ctrl.mediaTypes.video)" class="overlay"><i class="material-icons md-48 position-relative padding-none margin-none">play_arrow</i></span></div><div ng-if="!$ctrl.isImage(media) && !$ctrl.isVideo(media)"><a ng-href="{{ media.url }}" target="_blank">{{ media.fileName }}</a></div></div></div><div ng-if="message.message" ng-bind-html="message.message | message"></div><div text-ellipse="" ng-if="message.body" ng-bind-html="message.body | message"></div><div ng-if="message.notificationStatus == 14" class="theme-link optout-text" uib-popover="Customer has opted out of text messages. To opt into messages, customer must text START to {{ message.dealerPhone | tel }}." popover-placement="bottom" popover-trigger="outsideClick"><i class="material-icons">error_outline</i> Message undelivered - Customer opted out</div></div></div><div ng-if="message.isOptOutMessage"><div class="speech-bubble-body full-width"><i class="material-icons optout-icon md-24 pull-left text-danger margin-right-md">speaker_notes_off</i><div><strong>Customer has opted out of Text Messaging. To opt back in, have the customer text START to {{ message.dealerPhone | tel }}</strong></div></div></div></div><div ng-if="message.isDateBubble" class="message-separator margin-bottom-md" ng-class="$root.config.styleClass"><div class="message-separator-text padding-top-none padding-bottom-none padding-left-15 padding-right-15">{{ ::$ctrl.getDateBubbleText(message.dateCreated) }}</div></div><div ng-if="message.isSeparator" class="message-separator theme-link margin-bottom-md" ng-class="$root.config.styleClass"><div class="message-separator-text padding-top-none padding-bottom-none padding-left-15 padding-right-15">Unread</div></div></div></div>');
$templateCache.put('app/areas/messages/views/messaging-panel.view.html','<div class="display-flex flex-column overflow-hidden bg-white" fill-height=""><div class="message-list-container flex-grow overflow-y-auto" infinite-scroll-top="$ctrl.displayMore()" infinite-scroll-top-disabled="!$ctrl.canShowMore"><div ng-if="$ctrl.canShowMore && $ctrl.isLoading" class="text-center" style="margin: 10px"><img src="assets/images/ajax-loader.gif"></div><rc-message-list ng-if="!$ctrl.isInitialLoad" messages="$ctrl.messages" last-read-date="$ctrl.contact.lastReadDate" panel-mode="$ctrl.panelMode"></rc-message-list></div><div ng-if="$ctrl.disableMessaging() !== true" class="flex-fullwidth-130h margin-top-auto padding-top-sm messaging-panel-footer color-default"><div class="padding-left-md padding-right-md padding-top-md row" ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.dealerCustomer || $ctrl.panelMode === $ctrl.messagingPanelModes.internal"><ui-select ng-model="$ctrl.selectedMessageTemplate" on-select="$ctrl.selectMessageTemplate()" class="col-md-10 margin-bottom-md margin-bottom-sm margin-left-none" ng-disabled="$ctrl.isSendDisabled"><ui-select-match placeholder="CHOOSE TEMPLATE">{{ $select.selected.name }}</ui-select-match><ui-select-choices repeat="messageTemplate in $ctrl.messageTemplates | filter: $select.search"><span ng-bind-html="messageTemplate.name | highlight: $select.search"></span></ui-select-choices></ui-select><img src="assets/images/ajax-loader.gif" class="template-spinner ng-hide" ng-show="$ctrl.isTemplatePopulating"></div><form id="createMessageForm" name="$ctrl.createMessageForm" ng-submit="$ctrl.sendMessage()" class="display-flex flex-column vh-v100" novalidate=""><div class="padding-left-md padding-right-md padding-bottom-sm padding-top-md row" ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.tripNotes"><div class="col-md-10 margin-bottom-md margin-bottom-sm margin-left-none"><select class="form-control" name="SelectedTripNoteType" ng-options="tripNoteType.id as tripNoteType.name for tripNoteType in $ctrl.tripNoteTypes" ng-model="$ctrl.selectedTripNoteType" allow-null-option="Select comment type" validation="required" required=""></select></div></div><div class="flex-grow padding-left-md padding-right-md" ng-class="{\'margin-top-sm\': $ctrl.panelMode !== $ctrl.messagingPanelModes.tripNotes}"><ul ng-if="$ctrl.messageAttachments.length > 0" class="list-unstyled attachments"><li ng-repeat="attachment in $ctrl.messageAttachments" class="attachment"><div class="icon-wrapper"><i class="material-icons md-24">description</i></div>{{ attachment.fileName }} <button type="button" class="close" ng-click="$ctrl.removeAttachment(attachment)">&times;</button></li></ul><textarea name="messageBody" required="" validation="required:alt=Field is required." message-editor="" on-enter="$ctrl.sendMessage()" class="form-control flex-fill padding-bottom-none resize-none" rows="3" ng-model="$ctrl.message" ng-disabled="$ctrl.isMessageSending || $ctrl.contact.phoneNumberType === $ctrl.phoneTypes.landline || $ctrl.isSendDisabled"></textarea><div class="height-px-15"><div class="text-right font-size-10" ng-show="$ctrl.message.trim().length > 0"><span><b>Shift+Enter</b> starts a new line</span></div></div></div><div class="flex-fullwidth-70h flex-wrap display-flex flex-row content-center"><div class="col-sm-6 col-xs-6" ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.dealerCustomer || $ctrl.panelMode === $ctrl.messagingPanelModes.internal"><button type="button" class="btn btn-link attach-file" ng-click="$ctrl.attachFile($ctrl.panelMode)" ng-disabled="$ctrl.isSendDisabled"><i class="material-icons">attach_file</i></button> <input id="attach-file{{$ctrl.panelMode}}" type="file" class="hide" ng-model="$ctrl.messageAttachments" message-attachment-selector=""></div><div class="text-right" ng-class="{\'col-sm-6 col-xs-6\': $ctrl.panelMode === $ctrl.messagingPanelModes.dealerCustomer || $ctrl.panelMode === $ctrl.messagingPanelModes.internal, \'col-sm-12 col-xs-12\': $ctrl.panelMode !== $ctrl.messagingPanelModes.dealerCustomer && $ctrl.panelMode !== $ctrl.messagingPanelModes.internal}"><span ng-if="$ctrl.isMessageSending" class="text-send text-uppercase">SENDING...</span> <button ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.dealerCustomer || $ctrl.panelMode === $ctrl.messagingPanelModes.internal" type="submit" class="btn btn-primary text-uppercase" ng-disabled="$ctrl.contact.phoneNumberType === $ctrl.phoneTypes.landline || $ctrl.isMessageSending || $ctrl.isSendDisabled">Send</button> <button ng-if="$ctrl.panelMode !== $ctrl.messagingPanelModes.dealerCustomer && $ctrl.panelMode !== $ctrl.messagingPanelModes.internal && $ctrl.panelMode !== $ctrl.messagingPanelModes.tripNotes && $ctrl.panelMode !== $ctrl.messagingPanelModes.dealerInfo" type="submit" class="btn btn-primary text-uppercase" ng-class="config.styleClass" ng-disabled="$ctrl.isMessageSending">Send</button> <button ng-if="$ctrl.panelMode === $ctrl.messagingPanelModes.tripNotes || $ctrl.panelMode === $ctrl.messagingPanelModes.dealerInfo" type="submit" class="btn btn-primary text-uppercase" ng-class="{ disabled: !$ctrl.createMessageForm.$valid}" ladda="$ctrl.isMessageSending">Add</button></div></div></form></div></div>');
$templateCache.put('app/areas/messages/views/out-of-office.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">Out Of Office Message</h2></div><div class="modal-body" aside-parent="vm.childScopeForm"><form role="form" name="outOfOfficeForm" class="form" ng-submit="vm.saveOutOfOffice(outOfOfficeForm.$valid)" novalidate=""><div class="form-group display-flex align-items-center content-center margin-bottom"><label class="control-label margin-right-20">Enable Out Of Office Message</label><switch id="closedNetwork" name="closedNetwork" ng-model="vm.outOfOffice.enabled" class="green"></switch></div><div class="row"><div class="form-group col-xs-12"><textarea id="outofoffice_message" rows="15" name="outofoffice_message" ng-model="vm.outOfOffice.message" class="form-control better-placeholder resize-none" ng-disabled="!vm.outOfOffice.enabled" validation="required" placeholder="Your out of office message"></textarea></div></div><div class="modal-footer margin-right-md"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.closeOutOfOffice()">Close</button> <button type="submit" class="btn btn-primary margin-right-md" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="!vm.validation.isFormValid()">Update</button></div></form></div>');
$templateCache.put('app/areas/messages/views/watch-selector.view.html','<form id="edit-watching-form" name="editWatchingForm" class="padding-md"><div class="modal-body"><h4 class="modal-title text-uppercase margin-bottom">Watch for Someone</h4><p>Add users to the list below to temporarily "watch" their messages. Removing users will delete your read history for any associated messages.</p><hr class="margin-top-md margin-bottom-md"><div class="form-group"><ui-select multiple="" ng-model="vm.selectedUsers" ng-click="vm.handleSelect()" on-select="vm.handleSelect()" focus-on="select"><ui-select-match placeholder="SEARCH FOR USER">{{ $item.firstName }} {{ $item.lastName }} &lt;{{ $item.email }}&gt;</ui-select-match><ui-select-choices repeat="user in vm.matchingUsers" refresh="vm.searchUsers($select)" refresh-delay="250"><div ng-bind-html="user.firstName + \' \' + user.lastName"></div><small>{{ user.email }}</small></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default text-uppercase" ng-click="$dismiss()">Close</button> <button type="button" class="btn btn-primary text-uppercase" ng-class="config.styleClass" ng-click="vm.update()">Update</button></div></form>');
$templateCache.put('app/areas/payments/views/aside.view.html','<div class="row display-flex full-height margin-right-none"><div id="payments-header" class="col-md-8 col-xs-12 padding-right-none separate-left-aside-panel"><div class="display-flex flex-column overflow-hidden full-height"><div class="flex-fullwidth-100h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><aside-header ng-model="vm.headerData"></aside-header></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white"><div id="payments-body"><span ui-view="{{vm.currentRoute}}"><div class="padding-md"><img class="padding-right-sm" src="assets/images/ajax-loader.gif"><span>Loading...</span></div></span></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 padding-right-lg padding-left-md padding-top-md"><div class="row"><div class="col-xs-12 text-right margin-top-md margin-bottom-md padding-right-none" ng-if="vm.paymentButtons && vm.paymentButtons.length > 0"><span ng-repeat="button in vm.paymentButtons"><button type="button" class="btn text-uppercase margin-right-xs" ng-class="[config.styleClass, button.style]" ng-disabled="(button.isValid && !button.isValid()) || (vm.confirmBusy && button.includeLadda)" ladda="vm.confirmBusy && button.includeLadda" ng-click="vm.buttonClicked(button.broadcastName, button.includeLadda)">{{button.text}}</button></span></div><div class="col-xs-12 margin-top-md margin-bottom-md text-right padding-right-none" ng-if="!vm.paymentButtons || vm.paymentButtons.length == 0"><button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="payments-list">Close</button></div></div></div></div></div><div id="payments-messaging" class="col-md-4 col-xs-12 margin-left-md border-radius-top-7 separate-right-aside-panel message-component-rail flex-grow padding-none overflow-y-hidden"><div class="display-flex flex-column overflow-hidden full-height white-bg"><div class="flex-fullwidth-100h border-radius-top-7 visible-xs visible-sm theme-bg padding padding-right-md"><aside-header ng-model="vm.headerData"></aside-header></div><rc-summary-message-tab contact="vm.contact" disable-notes-tab="1" active-tab="vm.activeMessageTab" mobile-class="vm.messagePanelMobileClass"></rc-summary-message-tab></div></div></div>');
$templateCache.put('app/areas/payments/views/cenpos-loader.view.html','<html ng-controller="PaymentCenposLoaderController as vm" ng-init="init()" style="display: none"><head></head><body><form ng-show="false" action="{{vm.formUrl}}" method="post" name="submitForm" id="submitForm" role="form" novalidate=""><input name="type" id="type" ng-model="vm.cenposSettings.type" required="" validation="required"> <input name="amount" ng-model="vm.cenposSettings.amount" required="" validation="required"> <input name="merchantid" ng-model="vm.cenposSettings.merchantid" required="" validation="required"> <input name="userid" ng-model="vm.cenposSettings.userid" required="" validation="required"> <input name="password" ng-model="vm.cenposSettings.password" required="" validation="required"> <input name="redirecttype" ng-model="vm.cenposSettings.redirecttype" required="" validation="required"> <input name="urlresponse" ng-model="vm.cenposSettings.urlresponse" required="" validation="required"> <input name="postresponse" ng-model="vm.cenposSettings.postresponse" required="" validation="required"> <input name="autosubmit" ng-model="vm.cenposSettings.autosubmit" required="" validation="required"> <input name="receipts" ng-model="vm.cenposSettings.receipts" required="" validation="required"> <input name="responsetype" ng-model="vm.cenposSettings.responsetype" required="" validation="required"> <input name="invoice" ng-model="vm.cenposSettings.invoiceId" required="" validation="required"> <input name="customercode" ng-model="vm.cenposSettings.contactId" required="" validation="required"></form><script type="text/javascript">\r\n            (function () {\r\n                document.addEventListener("DOMContentLoaded", function (event) {\r\n                    window.parent.angular.element(\'#frame\').scope().$emit(\'cenpos-loader:loaded\', this);\r\n                });\r\n            })();\r\n        </script></body></html>');
$templateCache.put('app/areas/payments/views/cenpos-process.view.html','<html style="display: none"><head></head><body><script type="text/javascript">\r\n            (function () {\r\n                document.addEventListener("DOMContentLoaded", function (event) {\r\n\r\n                    var result = window.location.search.substring(1)\r\n                        .split(\'&\')\r\n                        .reduce(function(result, next) {\r\n                            var pair = next.split(\'=\');\r\n                            pair[1] = (pair[1] === "null" || pair[1] === "undefined") ? null : pair[1];\r\n                            result[decodeURIComponent(pair[0].toLowerCase())] = pair[1] === null ? null : decodeURIComponent(pair[1]);\r\n\r\n                            return result;\r\n                        }, {});\r\n\r\n                    window.parent.angular.element(\'#frame\').scope().$emit(\'cenpos-loader:processed\', result);\r\n                });\r\n            })();\r\n        </script></body></html>');
$templateCache.put('app/areas/payments/views/details-tab.view.html','<div><div class="col-xs-12"><table class="table footable table-hover table-responsive table-borderless"><thead><tr><th>Code</th><th>Description</th><th class="text-right">Time</th><th class="text-right">Cost</th><th>C/W/I</th></tr></thead><tbody><tr ng-repeat="lineitem in vm.resolvedRepairOrder.lineItems"><td>{{lineitem.opCode}}</td><td><div>{{lineitem.description}}</div><div>{{lineitem.comments}}</div></td><td class="text-right">{{lineitem.time | number:2}}H</td><td class="text-right">{{lineitem.cost | currency}}</td><td>{{lineitem.billTo}}</td></tr><tr ng-if="!vm.resolvedRepairOrder || !vm.resolvedRepairOrder.lineItems || !vm.resolvedRepairOrder.lineItems.length"><td colspan="5">No line items were located for this repair order</td></tr></tbody><tfoot><tr><th class="text-right" colspan="2">Customer Total:</th><th class="text-right">{{ vm.resolvedRepairOrder.totalTime | number:2 }}H</th><th class="text-right">{{ vm.resolvedRepairOrder.customerTotal || 0 | currency }}</th></tr></tfoot></table></div></div>');
$templateCache.put('app/areas/payments/views/invoice-send.view.html','<form role="form" name="paymentForm" ng-submit="vm.submitForm()" novalidate="" class="form"><div class="row padding-md padding-bottom-none"><div id="sendTypeRow" class="col-xs-6 form-group inline"><input type="radio" ng-value="vm.sendTypes.sms" class="radio inline inline" ng-model="vm.sendType"> <label>Send SMS</label> &nbsp;&nbsp; <input type="radio" ng-value="vm.sendTypes.manual" class="radio inline" ng-model="vm.sendType"> <label>Enter Manually</label></div></div><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-6 form-group"><div class="input-group"><span class="input-group-addon">$</span> <input type="text" id="amount" min="0.01" step=".01" name="amount" ng-model="vm.amount" class="form-control" placeholder="PAYMENT AMOUNT" validation="required" mask-restrict="reject" mask="9?9?9?9?9?9?9?9?9.99"></div></div></div><div ng-if="vm.loadingData"><div class="row padding-md padding-top-none padding-bottom-none"><div class="form-group col-xs-6"><i class="fa fa-spin fa-spinner"></i> Loading saved card data</div></div></div><div ng-if="!vm.loadingData"><div ng-if="vm.sendType === vm.sendTypes.sms"><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-6 form-group"><input type="text" id="phoneNumber" name="phoneNumber" ng-model="vm.smsNumber" class="form-control" mask-restrict="reject" mask="(999) 999-9999" placeholder="(888) 123-1234" autocomplete="tel-national" validation="required"></div></div><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-10 form-group"><textarea name="smsText" id="smsText" ng-model="vm.smsText" class="form-control resize-none" rows="6" placeholder="TYPE YOUR MESSAGE HERE..." validation="required"></textarea></div></div></div><div ng-if="vm.sendType === vm.sendTypes.manual"><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-6 form-group"><div class="row col-xs-12" ng-repeat="card in vm.cardsOnFile"><label><input type="radio" name="cardToken" ng-model="vm.cardToken" ng-value="card.value" ng-change="vm.cardChanged()"> {{card.text}}</label></div><div class="text-right" ng-if="vm.cardToken && vm.cardToken !== \'0\'"><a ng-click="vm.deleteCard(vm.cardToken)">Delete Selected Token</a></div></div></div><div ng-show="vm.cardToken && vm.cardToken !== \'0\'"><div class="row padding-md padding-top-none padding-bottom-none"><div class="form-group col-xs-6"><label for="address" class="control-label">Billing Address :</label> <input type="text" id="address" name="address" ng-model="vm.billingAddress" placeholder="BILLING ADDRESS" class="form-control" validation="required" autocomplete="address-line1"></div></div><div class="row padding-md padding-top-none padding-bottom-none"><div class="form-group col-xs-6"><label for="city" class="control-label">City :</label> <input type="text" id="city" name="city" ng-model="vm.billingCity" placeholder="CITY" class="form-control" validation="required" autocomplete="address-level2"></div></div><div class="row padding-md padding-top-none padding-bottom-none"><div class="form-group col-xs-6"><label for="state" class="control-label">State :</label><select name="state" id="state" ng-model="vm.billingState" class="form-control input" validation="required" autocomplete="address-level1" ng-options="item as item for item in vm.usStates"><option value="" disabled="disabled" selected="selected">State</option></select></div></div><div class="row padding-md padding-top-none padding-bottom-none"><div class="form-group col-xs-6"><label for="zip" class="control-label">Zip Code :</label> <input type="text" id="zip" name="zip" ng-model="vm.billingZip" placeholder="ZIP CODE" class="form-control" validation="required" autocomplete="postal-code"></div></div></div><div class="row padding-md" ng-show="vm.cardToken === \'0\'"><div id="payment-provider" class="no-iframe-border col-xs-6"></div></div></div></div><div class="margin-bottom-20"><div class="row padding-md padding-top-none padding-bottom-none"><div class="form-group col-xs-6"><button type="submit" class="btn btn-primary" ng-if="vm.sendType === vm.sendTypes.sms || (vm.cardToken && vm.cardToken !== \'0\')" ladda="vm.submittingPayment">Submit</button> <button type="button" class="btn btn-primary" ng-if="vm.cardToken === \'0\' && vm.sendType === vm.sendTypes.manual" ng-click="vm.addCard()">Next</button></div></div></div></form><script src="https://code.jquery.com/jquery-migrate-1.4.1.min.js"></script><script src="https://www.cenpos.com/Plugins/porthole.min.js"></script><script src="https://www.cenpos.com/Plugins/jquery.simplewebpay.js"></script>');
$templateCache.put('app/areas/payments/views/list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="payments" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="flex-percent-80 flex-sm-percent-100 flex-xs-percent-100"><div class="display-flex flex-row full-width visible-xs visible-sm"><div class="flex-sm-percent-80 flex-xs-percent-80 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative padding-right-sm" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.invoices.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)" align-right="true" search-tray-displayed="vm.showAdvancedSearch"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30"><a ui-sref="payment-create" class="margin-left-md margin-top-xs visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row full-width visible-xs visible-sm margin-top-sm"><div class="flex-sm-percent-100 flex-xs-percent-100 flex-grow visible-xs visible-sm padding-none"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none text-notransform"><input class="form-search form-control better-placeholder" type="text" id="filter_search" name="item_search" placeholder="Customer or RO# search" ng-model="vm.filters.searchText" ng-keyup="$event.keyCode == 13 && vm.filterChanged()"></div></div></div><div class="display-flex flex-row hidden-xs hidden-sm"><div class="flex-width-200"><div class="block relative padding-right-sm" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-200 max-width-px-400 flex-grow flex-xs-percent-100 override-xs-margin-top-md" ng-if="vm.availableLocations.length > 1"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><div class="field-wrapper wizard-dropdown"><label class="label" ng-class="{\'selected\': vm.filters.selectedLocation}" ng-if="vm.filters.selectedLocation">LOCATION</label><select data-placeholder-text-single="\'Location\'" class="form-control" name="locationFilter" max-shown-results="100" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vm.filters.selectedLocation" ng-options="l as l.name for l in vm.availableLocations | orderBy: \'name\'" ng-change="vm.locationSelected()"><option value="">Location</option></select></div></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="serviceAdvisors">CREATED BY</label><select selectlabel="" class="form-control" name="serviceAdvisorFilter" id="serviceAdvisors" ng-model="vm.filters.createdBy" ng-options="createdBy.value as createdBy.text for createdBy in vm.createdByOptions" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-300 flex-grow max-width-px-400 hidden-xs hidden-sm"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none text-notransform"><input class="form-search form-control better-placeholder" type="text" id="filter_search" name="item_search" placeholder="Customer or RO# search" ng-model="vm.filters.searchText" ng-keyup="$event.keyCode == 13 && vm.filterChanged()"></div></div><div class="flex-percent-20 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.totalCount" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)"></rc-list-advanced-filter-toggle></div></div><div class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters filter-count="vm.filterCount" record-count="vm.totalCount" filter-message="vm.filterMessage"></rc-list-mobile-filters></div></div><div class="flex-percent-20 text-right pad-left-15 override-xs-side-padding-none flex-xs-percent-100 override-xs-margin-top-md override-xs-text-left hidden-xs hidden-sm"><a ui-sref="payment-create" class="btn btn-primary new-btn" ng-class="config.styleClass"><span class="hidden-xs">+</span> NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="payments-table-wrapper"><table id="payments-table" class="table table-hover searchable-list table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll="vm.displayMore()" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore" ng-class="{\'today\': vm.isSearchToday()}" infinite-scroll-distance="1" infinite-scroll-immediate-check="true" infinite-scroll-container="\'#payments-table-wrapper\'" redcap-sort="true" redcap-sort-model="vm.sort" redcap-sort-callback="vm.sortChanged"><thead class="hidden-xs"><tr class="text-uppercase"><th sort-column="Customer" class="text-uppercase header_Customer">Customer</th><th sort-column="Created" class="text-uppercase header_Created">Created</th><th sort-column="Status" class="text-uppercase header_Status">Status</th><th sort-column="Amount" class="text-uppercase text-right header_Amount">Amount</th><th class="text-uppercase items" ignore-sort="">Items</th><th class="text-uppercase action" ignore-sort="">Actions</th></tr></thead><tbody><tr ng-repeat="data in vm.invoices" ui-sref="payment-edit({invoiceId: data.id})"><td class="cursor-pointer"><div class="visible-xs max-width-100-percent padding-right-lg"><span class="visible-xs-inline pull-right">{{data.amount || 0 | currency}}</span> <strong><rc-contact-name class="text-uppercase" contact="{firstName: data.customerFirstName, lastName: data.customerLastName}"></rc-contact-name></strong><br><div class="visible-xs-block text-uppercase">Status: {{ data.status }}</div><div class="visible-xs-block ellipsis-overflow text-uppercase">{{vm.getLineItemTypes(data.lineItems)}}</div></div><strong class="hidden-xs"><rc-contact-name class="text-uppercase" contact="{firstName: data.customerFirstName, lastName: data.customerLastName}"></rc-contact-name></strong><br><div class="hidden-xs" ng-if="data.customerPhone">{{data.customerPhone | tel}}</div><div class="hidden-xs text-uppercase" ng-if="!data.customerPhone">(No phone number)</div><div class="hidden-xs text-uppercase" ng-if="data.customerEmail">{{data.customerEmail}}</div></td><td class="hidden-xs text-uppercase cursor-pointer"><strong>{{data.createdDate | localDate}}</strong><br><span>{{data.serviceAdvisor}}</span></td><td class="hidden-xs text-uppercase cursor-pointer"><span class="payments-label {{data.status.toLowerCase()}}">{{data.statusDescription}} <span ng-if="data.cardType">- {{data.cardType}}</span></span><br><span>{{data.lastUpdate | localTimeOfDay}}</span></td><td class="hidden-xs text-right cursor-pointer"><div class="padding-right-15">{{data.amount || 0 | currency}}</div></td><td class="hidden-xs text-uppercase cursor-pointer">{{vm.getLineItemTypes(data.lineItems)}}</td><td class="action hidden-xs"><div ng-if="vm.activeStatusAction !== 1"><select ng-if="data.statusCode === vm.invoiceStatusEnum.paid" ng-click="$event.stopPropagation()" class="form-control" ng-change="vm.actionSelected(data.id, $index)" ng-model="vm.selectedrow[$index]" ng-options="item.value as item.text for item in vm.getPaidActions(data)"></select><select ng-if="data.statusCode === vm.invoiceStatusEnum.refunded" ng-click="$event.stopPropagation()" class="form-control" ng-change="vm.actionSelected(data.id, $index)" ng-model="vm.selectedrow[$index]" ng-options="item.value as item.text for item in vm.refundActions"></select><select ng-if="data.statusCode !== vm.invoiceStatusEnum.paid && data.statusCode != vm.invoiceStatusEnum.refunded && data.statusCode !== vm.invoiceStatusEnum.cancelled && data.statusCode !== vm.invoiceStatusEnum.unpaid" ng-click="$event.stopPropagation()" class="form-control" ng-change="vm.actionSelected(data.id, $index)" ng-model="vm.selectedrow[$index]" ng-options="item.value as item.text for item in vm.otherStatusActions"></select><select ng-if="data.statusCode === vm.invoiceStatusEnum.unpaid" ng-click="$event.stopPropagation()" class="form-control" ng-change="vm.actionSelected(data.id, $index)" ng-model="vm.selectedrow[$index]" ng-options="item.value as item.text for item in vm.unpaidActions"></select><select ng-if="data.statusCode === vm.invoiceStatusEnum.cancelled" ng-click="$event.stopPropagation()" class="form-control" ng-change="vm.actionSelected(data.id, $index)" ng-model="vm.selectedrow[$index]" ng-options="item.value as item.text for item in vm.cancelledActions"></select></div><select ng-if="vm.activeStatusAction === 1" ng-click="$event.stopPropagation()" class="form-control" ng-change="vm.actionSelected(data.id, $index)" ng-model="vm.selectedrow[$index]" ng-options="item.value as item.text for item in vm.archivedActions"></select></td></tr></tbody></table><rc-list-standardized-footer record-count="vm.invoices.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore"></rc-list-standardized-footer></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-padding-top-md override-sm-padding-top" ng-if="vm.availableLocations.length > 1"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><div class="field-wrapper wizard-dropdown"><label class="label" ng-class="{\'selected\': vm.advancedFilterSelectedLocation, \'on\': vm.advancedFilterSelectedLocation}" ng-if="vm.advancedFilterSelectedLocation">LOCATION</label><select data-placeholder-text-single="\'Location\'" class="form-control" name="locationFilter" max-shown-results="100" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vm.advancedFilterSelectedLocation" ng-options="l as l.name for l in vm.availableLocations | orderBy: \'name\'"><option value="">Location</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="serviceAdvisors">CREATED BY</label><select selectlabel="" class="form-control" name="serviceAdvisorFilter" id="serviceAdvisors" ng-model="vm.filters.createdBy" ng-options="createdBy.value as createdBy.text for createdBy in vm.createdByOptions" ng-change="vm.filterChanged()"></select></div></div></div><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none text-notransform"><input class="form-search form-control better-placeholder" type="text" id="filter_search" name="item_search" placeholder="Customer or RO# search" ng-model="vm.filters.searchText" ng-keyup="$event.keyCode == 13 && vm.filterChanged()"></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md"><div class="flex-width-200 flex-sm-percent-100"><div class="block relative padding-left-sm field-wrapper override-xs-padding-none override-sm-padding-none padding-right-sm"><label for="statusFilter" class="on">STATUS</label><select selectlabel="" id="statusFilter" class="form-control" name="statusFilter" ng-model="vm.filters.selectedInvoiceStatus" ng-options="item.value as item.text for item in vm.invoiceStatuses" ng-change="vm.filterChanged()"></select></div></div><div class="flex-width-200 flex-sm-percent-100"><div class="block relative padding-left-sm padding-right-sm field-wrapper override-xs-padding-none override-sm-padding-none override-xs-margin-top-none override-sm-margin-top"><label for="status">ACTIVE STATUS</label><select selectlabel="" id="status" class="form-control" name="status" ng-model="vm.filters.selectedStatus" ng-options="status.value as status.text for status in vm.invoiceActiveStatuses" ng-change="vm.filterChanged()"></select></div></div></div><div class="display-flex flex-row padding-bottom-lg"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vm.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md"><rc-list-template-save-search-delete-btns list-controller="vm" current-search-template="vm.searchTemplateData.currentSearchTemplate" is-processing-template="vm.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vm.canManageGlobalTemplates" template-message="vm.templateMessage" save-btn-clicked="vm.saveBtnClicked()" save-as-btn-clicked="vm.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vm.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm" ng-click="vm.resetFilters(true);vm.close();">Reset Filters</div><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/payments/views/payment-create.view.html','<div class="row display-flex full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel flex-column overflow-hidden"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New Invoice</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-none"><uib-accordion close-others="true" class="trips-wizard payments margin-bottom-30" ng-class="{\'auto-height\': vm.zipMarkers }"><div class="ng-hide padding-left-md padding-right-md override-sm-padding-none" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.chooseLocation" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.chooseLocation}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseLocation" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.chooseLocation" src="\'app/areas/payments/views/partials/choose-location.view.html\'" ng-controller="PaymentChooseLocationController as vmPnl"></ng-include></div></div><div class="ng-hide padding-left-md padding-right-md override-sm-padding-none" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.chooseCustomer" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.chooseCustomer}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseCustomer" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.chooseCustomer" src="\'app/areas/payments/views/partials/choose-customer.view.html\'" ng-controller="PaymentChooseCustomerController as vmPnl"></ng-include></div></div><div class="ng-hide padding-left-md padding-right-md override-sm-padding-none" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.addItems" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.addItems}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.addItems" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.addItems" src="\'app/areas/payments/views/partials/add-items.view.html\'" ng-controller="PaymentAddItemsController as vmPnl"></ng-include></div></div></uib-accordion></div></div>');
$templateCache.put('app/areas/payments/views/payment-edit-items.view.html','<div class="override-xs-padding-none padding-md"><h5 class="margin-bottom text-uppercase">Edit Line Items</h5><form role="form" name="editItemsForm" id="editItemsForm" class="form text-uppercase" ng-submit="vm.save()" novalidate=""><div ng-repeat="item in vm.resolvedInvoice.lineItems | filter: lineItemFilter" class="row form-group"><div class="col-sm-3 col-xs-12 padding-right-none field-wrapper"><label for="type{{$index}}">CHOOSE ONE</label><select selectlabel="" class="form-control" name="type{{$index}}" required="required" ng-model="item.type" ng-options="opt.id as opt.text for opt in vm.lineItemOptions" validation="required"><option value="">Choose One</option></select></div><div class="col-sm-5 col-xs-12 override-xs-padding-top-md padding-right-none"><div ng-if="item.type === vm.lineItemTypes.repairOrder.id"><select name="repairOrder{{$index}}" multiple="" ui-select2="vm.getOptsWithInitialSelection(item.repairOrder)" ng-model="item.repairOrder.repairOrderId" type="text" class="form-control select2-single" required="required" data-index="{{$index}}"></select></div><div ng-if="item.type === vm.lineItemTypes.loanerUpcharge.id"><select name="loanerUpcharge{{$index}}" multiple="" ui-select2="vm.getLoanerUpchargeOptsWithInitialSelection(item.loanerUpcharge)" ng-model="item.loanerUpcharge.id" type="text" class="form-control select2-single" required="required" data-index="{{$index}}"></select></div><div ng-if="item.type !== vm.lineItemTypes.repairOrder.id && item.type !== vm.lineItemTypes.loanerUpcharge.Id && item.type !== vm.lineItemTypes.loanerUpcharge.id"><input name="description{{$index}}" type="text" class="form-control" ng-model="item.description" placeholder="Description" required="required" validation="required"></div><div ng-if="editItemsForm[\'repairOrder\' + $index].$error.required && editItemsForm[\'repairOrder\' + $index].$dirty" class="validation text-danger">Field is required.</div></div><div class="col-sm-3 col-xs-12 override-xs-padding-top-md padding-right-none"><div class="input-group"><span class="input-group-addon">$</span> <input name="amount{{$index}}" id="amount{{$index}}" class="form-control" ng-model="item.amount" type="text" mask="9?9?9?9?9?9?9?.99" mask-restrict="reject" required="required"></div><div ng-if="editItemsForm[\'amount\' + $index].$error.required" class="validation text-danger">Field is required.</div></div><div class="col-sm-1 col-xs-12"><span ng-if="vm.resolvedInvoice.lineItems.length > 1"><i class="material-icons text-danger cursor-pointer margin-top-md" style="font-size:2em" ng-click="vm.resolvedInvoice.lineItems.splice($index, 1)">remove</i></span> <span ng-if="$last"><i class="material-icons text-danger cursor-pointer margin-top-md" style="font-size:2em" ng-click="vm.resolvedInvoice.lineItems.push({type: null, amount: \'0.00\'})">add</i></span></div></div></form></div>');
$templateCache.put('app/areas/payments/views/payment-edit.view.html','<div class="override-xs-padding-none padding-md"><table id="payments-table" class="table border-bottom"><thead class="hidden-xs"><tr><th class="border-bottom-thick">TYPE</th><th class="border-bottom-thick">DESCRIPTION</th><th class="border-bottom-thick text-right">AMOUNT</th></tr></thead><tbody ng-repeat="item in vm.resolvedInvoice.lineItems" class="vertical-align-top"><tr><td class="mobile-left"><span class="item-description">{{item.typeDescription}}</span> <span class="visible-xs-inline"><br>{{item.description.replace(", ", "")}}</span></td><td class="hidden-xs"><span>{{item.description.replace(", ", "")}}</span><span ng-if="item.type == 8 && vm.resolvedInvoice.tripId != null">&nbsp;(<a ui-sref="trip-tab-trip({tripId: vm.resolvedInvoice.tripId})" ng-click="$dismiss()" ui-sref-opts="{reload: true}">#{{vm.resolvedInvoice.tripId}}</a>)</span></td><td class="text-right"><div ng-if="item.showLineItemAmount"><div ng-if="item.amountType == null || item.amountType == 0"><span ng-if="item.type == 8 && item.amount == 0">PENDING</span> <span ng-if="(item.type == 8 && item.amount > 0) || item.type != 8">{{ item.amount | currency }}</span></div><div class="text-right" ng-if="item.amountType == 1">{{ item.amount }} %</div></div></td></tr><tr ng-if="vm.resolvedInvoice.comeInDateTime != null"><td class="mobile-left"><span class="item-description">Customer Pick Up</span></td><td class="hidden-xs"><span>{{ vm.resolvedInvoice.comeInDateTime | date:\'EEE, MMMM dd At h:mm a\' }}</span></td><td class="text-right">{{ 0 | currency }}</td></tr><tr class="payment-lineitem-child" ng-repeat="itemChild in item.childLineItems" ng-if="item.childLineItems != null && item.childLineItems.length > 0"><td class="mobile-left"><span class="item-description">{{itemChild.typeDescription}}</span> <span class="visible-xs-inline"><br>{{itemChild.description}}</span></td><td class="hidden-xs"><div>{{itemChild.description}}</div><div ng-if="itemChild.type == 13 && !itemChild.isFlatRate" class="margin-top-sm"><span class="margin-right-md margin-top-sm">Labor: {{itemChild.laborTotal | currency}}</span> <span class="margin-top-sm">Parts: {{itemChild.partsTotal | currency}}</span></div><div ng-if="itemChild.type == 13 && itemChild.isFlatRate" class="margin-top-sm"><span class="margin-right-md">Flat Rate: {{itemChild.amount | currency}}</span></div></td><td class="text-right" ng-if="itemChild.amountType == null || itemChild.amountType == 0" ng-class="{ \'text-danger\': itemChild.type == 9 }"><div ng-if="item.type != 12 && item.type != 1"><span ng-if="item.amount > 0">{{ itemChild.type == 9 ? -itemChild.displayAmount : itemChild.displayAmount | currency }}</span> <span ng-if="item.amount == 0">PENDING</span></div><div ng-if="item.type == 12 || item.type == 1"><span>{{itemChild.amount | currency}}</span></div></td><td class="text-right" ng-if="itemChild.amountType == 1" ng-class="{ \'text-danger\': itemChild.type == 9 }"><span ng-if="item.amount > 0">{{ (((itemChild.type == 9 ? -itemChild.displayAmount : itemChild.displayAmount) / 100) * item.amount | currency) }}</span> <span ng-if="item.amount == 0">PENDING</span></td></tr><tr class="payment-lineitem-child" ng-if="item.childLineItems != null && item.childLineItems.length > 0"><td class="mobile-left"><span class="item-description" ng-if="item.type != 12 && item.type != 1">Total {{item.typeDescription}}</span> <span class="item-description" ng-if="item.type == 12 || item.type == 1">Subtotal {{item.typeDescription}}</span> <span class="visible-xs-inline"><br></span></td><td class="hidden-xs"></td><td class="text-right"><span ng-if="item.type == 8 && item.amount == 0">PENDING</span> <span ng-if="(item.type == 8 && item.amount > 0) || item.type != 8">{{ item.subTotal | currency }}</span></td></tr></tbody><tfoot id="payments-footer-row"><tr ng-if="vm.shopSupplies" class="payments-footer-row"><th class="hidden-xs"></th><th class="text-right mobile-left">ShopSupplies:</th><th class="text-right">{{vm.shopSupplies | currency}}</th></tr><tr ng-if="vm.fee" class="payments-footer-row"><th class="hidden-xs"></th><th class="text-right mobile-left">Fee:</th><th class="text-right">{{vm.fee | currency}}</th></tr><tr ng-if="vm.tax" class="payments-footer-row"><th class="hidden-xs"></th><th class="text-right mobile-left">Tax:</th><th class="text-right">{{vm.tax | currency}}</th></tr><tr><th class="hidden-xs"></th><th class="text-right mobile-left">Total:</th><th class="text-right">{{vm.resolvedInvoice.totalWithDelivery | currency}}</th></tr></tfoot></table><div class="row" ng-if="!vm.resolvedInvoice.isArchived"><div class="button-row col-xs-12" ng-if="vm.resolvedInvoice.status === vm.invoiceStatus.draft"><button class="btn btn-primary text-uppercase col-sm-2 col-xs-3 margin-right-md" ng-click="vm.sendLink()" ladda="vm.refreshing">Send Link</button> <button class="btn btn-primary text-uppercase col-sm-2 col-xs-3 margin-right-md" ng-click="vm.payNow()" ladda="vm.refreshing">Pay Now</button> <button class="btn btn-primary text-uppercase col-sm-2 col-xs-3 margin-right-md" ng-click="vm.editItems()" ladda="vm.refreshing">Edit</button> <span class="col-xs-3 hidden-xs"><select ng-model="vm.selectedAction" ng-change="vm.selectedActionChanged()" class="form-control" ng-disabled="vm.refreshing"><option value="" disabled="">More Actions</option><option value="1">Copy Payment Link</option><option value="2">Archive</option></select></span></div><div class="button-row col-xs-12" ng-if="vm.resolvedInvoice.status === vm.invoiceStatus.unpaid"><button class="btn btn-primary text-uppercase col-sm-2 col-xs-2 margin-right-md" ng-click="vm.sendLink()" ladda="vm.refreshing">Resend</button> <button class="btn btn-primary text-uppercase col-sm-2 col-xs-2 margin-right-md" ng-click="vm.payNow()" ladda="vm.refreshing">Pay Now</button> <span class="col-xs-3 hidden-xs"><select ng-model="vm.selectedAction" ng-change="vm.selectedActionChanged()" class="form-control" ng-disabled="vm.refreshing"><option value="" disabled="">More Actions</option><option value="1">Copy Payment Link</option><option value="2">Archive</option><option value="4">Cancel</option></select></span></div><div class="button-row col-xs-12" ng-if="vm.resolvedInvoice.status === vm.invoiceStatus.paid"><span class="col-xs-3 hidden-xs"><select ng-model="vm.selectedAction" ng-change="vm.selectedActionChanged()" class="form-control" ng-disabled="vm.refreshing"><option value="" disabled="">More Actions</option><option value="2">Archive</option><option value="3" ng-if="vm.canRefund">Refund</option></select></span></div><div class="button-row col-xs-12" ng-if="vm.resolvedInvoice.status === vm.invoiceStatus.refunded"><span class="col-xs-3 hidden-xs"><select ng-model="vm.selectedAction" ng-change="vm.selectedActionChanged()" class="form-control" ng-disabled="vm.refreshing"><option value="" disabled="">More Actions</option><option value="2">Archive</option></select></span></div><div class="button-row col-xs-12" ng-if="vm.resolvedInvoice.status === vm.invoiceStatus.cancelled"><button class="btn btn-primary text-uppercase col-sm-2 col-xs-2 margin-right-md" ng-click="vm.sendLink()" disabled="">Send Link</button> <button class="btn btn-primary text-uppercase col-sm-2 col-xs-2 margin-right-md" ng-click="vm.payNow()" disabled="">Pay Now</button> <button class="btn btn-primary text-uppercase col-sm-2 col-xs-2 margin-right-md" ng-click="vm.editItems()" disabled="">Edit</button> <span class="col-xs-3 hidden-xs"><select ng-model="vm.selectedAction" ng-change="vm.selectedActionChanged()" class="form-control" ng-disabled="vm.refreshing"><option value="" disabled="">More Actions</option><option value="1">Copy Payment Link</option><option value="2">Archive</option></select></span></div></div><div class="row" ng-if="vm.resolvedInvoice.isArchived"><div class="col-xs-12"><button class="btn btn-primary text-uppercase col-sm-2 col-xs-4" ng-click="vm.unarchive()">Unarchive</button></div></div><div class="margin-top-20 hidden-xs" ng-if="vm.showLink"><div class="panel panel-default"><div class="panel-heading">PAYMENT LINK <button type="button" class="close" aria-label="Close" ng-click="vm.showLink = false;"><span aria-hidden="true">&times;</span></button></div><div class="input-group" style="margin: 10px;"><input type="text" class="form-control" name="link" id="link" ng-model="vm.resolvedInvoice.consumerUrl" readonly=""> <span class="input-group-addon btn" ng-click="vm.copy()" popover-placement="left" uib-popover="Link Copied"><i class="material-icons" style="font-size:1.3em">file_copy</i></span></div></div></div><div class="margin-top-20 hidden-xs"><div class="panel panel-default"><div class="panel-heading">HISTORY</div><div ng-repeat="history in vm.resolvedInvoice.history" class="panel-body border-bottom"><div class="col-xs-3">{{history.createdDate | date}}</div><div class="col-xs-8">{{history.message}}</div></div></div></div></div>');
$templateCache.put('app/areas/payments/views/payment-send-link.view.html','<div class="override-xs-padding-none padding-md font-size-12"><div class="text-uppercase margin-bottom"><div><h5 class="margin-bottom-none">SEND TO {{vm.invoice.customerFirstName}} {{vm.invoice.customerLastName}}</h5></div><div>{{vm.invoice.customerPhone | tel}}</div></div><div class="row"><div class="col-xs-12"><textarea textbox-resize="" class="form-control better-placeholder resize-none" ng-model="vm.message" rows="3" required="" placeholder="MESSAGE TO SEND"></textarea></div><div ng-if="vm.submitted && !vm.message" class="text-danger col-xs-12">Field is required</div></div><div class="row padding-top-sm form-inline"><div class="col-sm-3 col-xs-12 text-nowrap margin-top-sm" ng-repeat="bookingType in vm.allowedBookingTypes"><span class="display-flex content-center margin-top-sm"><input type="checkbox" id="checkbox{{$index}}" ng-model="bookingType.allowed" ng-change="vm.bookingTypeChanged(bookingType)" ng-disabled="bookingType.disabled" class="checkbox margin-none"> <label for="checkbox{{$index}}" class="padding-left-sm font-normal -sm margin-bottom-none margin-right-md">Offer {{bookingType.dashboardDescription}}</label></span></div></div><div ng-if="vm.isPartsDeliverySelected()" class="form-group"><div class="row padding-top-lg"><div class="col-sm-12 col-xs-12"><input type="text" id="deliveryAddress" name="deliveryAddress" ng-model="vm.delivery.options.addressString" class="form-control better-placeholder" placeholder="Enter Delivery Address (Required for Parts On Demand estimate)" details="vm.delivery.options.addressDetails" here-places="" options="vm.delivery.config.hereMapOptions" ng-blur="vm.deliveryAddressUpdatedBlur(vm.delivery.options.addressString)" handle-selected="vm.deliveryAddressUpdated(formattedAddress)"></div></div><div class="row padding-top-md"><div class="col-sm-4 col-xs-12 text-nowrap field-wrapper"><label for="chargeTypes">CHARGE TYPE</label><select class="form-control" name="chargeTypes" id="chargeTypes" required="required" selectlabel="" ng-model="vm.delivery.options.chargeType" ng-options="item.value as item.text for item in vm.delivery.types.chargeTypes" validation="required"><option value="">Charge type</option></select></div><div class="col-sm-4 col-xs-12 text-nowrap field-wrapper"><label for="deliveryPayment">DELIVERY PAYMENT</label><select class="form-control" name="deliveryPayment" id="deliveryPayment" required="required" selectlabel="" ng-model="vm.delivery.options.paymentType" ng-change="vm.delivery.options.discountAmount = null; vm.updateDeliverySummary()" ng-options="item.value as item.text for item in vm.delivery.types.paymentTypes" validation="required"><option value="">Delivery payment</option></select></div><div class="col-sm-4 col-xs-12 text-nowrap"><div class="input-group" ng-if="vm.delivery.options.paymentType == 1"><span class="input-group-addon">$</span> <input name="amount" id="amount" class="form-control" ng-model="vm.delivery.options.discountAmount" required="required" type="text" placeholder="MAX Amount" mask="9?9?9?9?9?9?9?.99" ng-min="0" mask-restrict="reject" ng-model-options="{ updateOn: \'blur\' }" ng-change="vm.updateDeliverySummary()"></div><div class="input-group" ng-if="vm.delivery.options.paymentType == 2"><span class="input-group-addon">$</span> <input name="amount" id="amount" class="form-control" ng-model="vm.delivery.options.discountAmount" type="text" placeholder="Enter Amount" mask="9?9?9?9?9?9?9?.99" mask-restrict="reject" required="required" ng-model-options="{ updateOn: \'blur\' }" ng-change="vm.updateDeliverySummary()"></div><div class="input-group" ng-if="vm.delivery.options.paymentType == 3"><input name="amount" id="amount" class="form-control" ng-model="vm.delivery.options.discountAmount" type="text" placeholder="Enter Percentage" mask="9?9?" mask-restrict="reject" required="required" ng-model-options="{ updateOn: \'blur\' }" ng-max="100" ng-change="vm.updateDeliverySummary()"> <span class="input-group-addon">%</span></div><div ng-if="" class="validation text-danger">Field is required.</div></div></div><hr><div class="row padding-top-sm font-size-12 payment-delivery-summary" ng-repeat="item in vm.chargeItems"><hr ng-if="item.isTotal" class="margin-top-xs margin-bottom-xs"><div class="col-sm-10 col-xs-8 text-uppercase" ng-class="{\'bold padding-top-md\': item.isTotal}">{{item.description}}</div><div class="col-sm-2 col-xs-4 text-nowrap text-right" ng-class="{\'text-color-red\': item.amount < 0, \'bold padding-top-md\': item.isTotal}"><span ng-if="item.amount == \'PENDING\'">{{item.amount}}</span> <span ng-if="item.amount != \'PENDING\'">{{item.amount | currency }}</span></div></div></div><div class="row margin-top"><div class="col-sm-12"><div><label class="font-normal"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="smsAgreement" ng-model="vm.smsAgreement" required="" validation="required"></div><div class="col-xs-11 padding-left-sm padding-top-xs">I have confirmed my customer agrees to receive text messages about their appointment, vehicle service, and transportation. They understand that they may receive several messages a day and can opt out at any time by replying STOP in their messaging app.</div></div></label></div></div></div><div ng-if="vm.isPartsDeliverySelected()" class="form-group"><div class="row margin-top"><div class="col-sm-12"><div><label class="font-normal"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="agreeToTermsUber" ng-model="vm.customerAgreedToTermsUber" required="" validation="required"></div><div class="col-xs-11 text-uppercase padding-left-sm padding-top-xs"><span ng-if="vm.invoice.uberTermsText" ng-bind-html="vm.invoice.uberTermsLink" ng-click="vm.showTerms($event, vm.invoice.uberTermsText)"></span> <span ng-if="!vm.invoice.uberTermsText" ng-bind-html="vm.invoice.uberTermsLink"></span></div></div></label></div></div></div><div class="text-muted padding-top-lg text-uppercase">NOTE: Delivery costs are frequently updated and may be higher or lower when the delivery is actually booked by the customer.</div></div></div>');
$templateCache.put('app/areas/payments/views/payments-not-configured.view.html','<div class="row"><div class="col-xs-12 padding-lg">Dealer is not configured to accept payments at this time.</div></div>');
$templateCache.put('app/areas/payments/views/payments-tab.view.html','<div id="accordian" class="margin-left-20 margin-right-20 margin-top-20"><div class="row border-bottom"><h5 class="col-xs-2">Date</h5><h5 class="col-xs-2">Time</h5><h5 class="col-xs-2">Status</h5><h5 class="text-right col-xs-2">Amount</h5><h5 class="col-xs-2">By</h5><h5 class="col-xs-2"><button type="button" class="btn btn-primary btn-xs text-uppercase" ui-sref="repair-order-invoice-send">Add New</button></h5></div><div class="panel-group"><div ng-repeat="payment in vm.resolvedPayments" class="padding-bottom-md padding-top-md border-bottom"><div class="row panel-heading cursor-pointer" ng-click="vm.selectedPayment = $index" ng-class="{\'bg-muted\': vm.selectedPayment === $index}"><div class="col-xs-2">{{payment.dateCreated | localTime | date}}</div><div class="col-xs-2">{{payment.dateCreated | localTime | date:\'h:mm a\'}}</div><div class="col-xs-2">{{payment.status}}</div><div class="text-right col-xs-2">{{payment.amount | currency}}</div><div class="col-xs-2">{{payment.submittedBy}}</div><div class="col-xs-2" ng-if="payment.status === \'Pending\'"><a href="">Resend</a></div></div><div uib-collapse="vm.selectedPayment !== $index"><div class="row padding-top-sm padding-bottom-sm"><div class="col-xs-2"></div><div class="col-xs-4 text-uppercase">Payment Id</div><div class="col-xs-6">{{payment.paymentId}}</div></div><div class="row padding-top-sm padding-bottom-sm"><div class="col-xs-2"></div><div class="col-xs-4 text-uppercase">Transaction Id</div><div class="col-xs-6">{{payment.transactionId}}</div></div><div class="row padding-top-sm padding-bottom-sm"><div class="col-xs-2"></div><div class="col-xs-4 text-uppercase">Credit Card</div><div class="col-xs-6">{{payment.cardNumber}}</div></div><div class="row padding-top-sm padding-bottom-sm" ng-if="payment.status === \'Declined\'"><div class="col-xs-2"></div><div class="col-xs-4 text-uppercase">Declined Reason</div><div class="col-xs-6">{{payment.declinedReason}}</div></div></div></div></div><div class="col-xs-12 text-center" ng-if="!vm.resolvedPayments || !vm.resolvedPayments.length">No payments were located for this repair order</div></div>');
$templateCache.put('app/areas/payments/views/placeholder.view.html','Nothing to show here yet');
$templateCache.put('app/areas/support/views/driver-help.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">Driver Help</h2></div><div class="modal-body" aside-parent="vm.childScopeForm"><div class="text-uppercase margin-bottom">SUBMIT A SUPPORT TICKET</div><form role="form" id="submitHelpTicket" name="submitHelpTicket" class="form" ng-submit="vm.submitTicket()" novalidate=""><div class="form-group" ng-if="vm.sentSuccessfully"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-none"><hr><div class="text-uppercase margin-bottom">Thank you.</div>Your help ticket has been submitted.</div></div><div class="form-group" ng-if="!vm.sentSuccessfully"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-11 field-wrapper"><label for="helpticket_type">ISSUE TYPE</label><select selectlabel="" required="" class="form-control" id="helpticket_type" name="helpticket_type" ng-model="vm.helpTicket.type" validation="required"><option value="">Issue type...</option><option ng-repeat="type in vm.issueTypes" value="{{ type }}">{{ type }}</option></select></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-11 padding-md"><textarea required="" id="helpticket_description" name="helpticket_desscription" class="form-control resize-none" ng-model="vm.helpTicket.description" placeholder="ISSUE DESCRIPTION" validation="required"></textarea></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.submittingHelpTicket" ng-disabled="vm.fieldsDisabled || inputForm.$invalid" ng-if="!vm.sentSuccessfully">SUBMIT</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="tutorial-list">CLOSE</button></div></form></div>');
$templateCache.put('app/areas/support/views/software-help.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">Software Help</h2></div><div class="modal-body" aside-parent="vm.childScopeForm"><div class="text-uppercase margin-bottom">SUBMIT A SUPPORT TICKET</div><form role="form" id="submitHelpTicket" name="submitHelpTicket" class="form" ng-submit="vm.submitTicket()" novalidate=""><div class="form-group" ng-if="vm.sentSuccessfully"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-none"><hr><div class="text-uppercase margin-bottom">Thank you.</div>Your help ticket has been submitted.</div></div><div class="form-group" ng-if="!vm.sentSuccessfully"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 field-wrapper"><label for="helpticket_type">ISSUE TYPE</label><select selectlabel="" required="" class="form-control" id="helpticket_type" name="helpticket_type" ng-model="vm.helpTicket.type" validation="required"><option value="">Issue type</option><option ng-repeat="type in vm.issueTypes" value="{{ type }}">{{ type }}</option></select></div></div><div class="row margin-top"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><textarea required="" id="helpticket_description" name="helpticket_desscription" class="form-control better-placeholder resize-none" ng-model="vm.helpTicket.description" placeholder="{{vm.getDescription()}}" validation="required"></textarea></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.submittingHelpTicket" ng-disabled="vm.fieldsDisabled || inputForm.$invalid" ng-if="!vm.sentSuccessfully">SUBMIT</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="{{vm.previousPage}}">CLOSE</button></div></form></div>');
$templateCache.put('app/areas/support/views/tutorial-list.view.html','<script>\r\n    function loadScript(url, callback){ \r\n        var script = document.createElement("script");\r\n        script.type = "text/javascript"; \r\n        if (script.readyState){ \r\n            //IE \r\n            script.onreadystatechange = function() { \r\n                if (script.readyState === "loaded" || script.readyState === "complete") { \r\n                    script.onreadystatechange = null; \r\n                    callback(); \r\n                } \r\n            }; \r\n        } else { \r\n            //Others \r\n            script.onload = function() { \r\n                callback(); \r\n            }; \r\n        } \r\n        script.src = url; \r\n        document.getElementsByTagName("head")[0].appendChild(script);\r\n    }\r\n    \r\n    window.liveAgentInit = function() {\r\n        liveagent.init(\'https://d.la4-c2-dfw.salesforceliveagent.com/chat\', \'572f2000000PCUo\', \'00D3000000010ft\');\r\n    }\r\n\r\n    var url = \'https://c.la4-c2-dfw.salesforceliveagent.com/content/g/js/45.0/deployment.js\';\r\n    if (typeof(liveagent) == "object") {\r\n        delete liveagent;\r\n        delete liveAgentDeployment;\r\n        loadScript(url, liveAgentInit);\r\n    } else {\r\n        loadScript(url, liveAgentInit);\r\n    }\r\n</script><div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="tutorials" class="override-sm-margin-none full-height panel margin-md padding-10 display-flex flex-column overflow-hidden padding-bottom-none"><div class="search-list-header search-filters white-bg" ng-class="{\'expanded\': vm.showSearchTray === true}"><div class="display-flex flex-row margin-bottom-md margin-top-md flex-sm-column flex-xs-column full-width"><div class="flex-percent-70 flex-xs-percent-100"><div class="display-flex flex-row flex-sm-column flex-xs-column"><div class="flex-grow flex-xs-percent-100 flex-sm-percent-100 override-xs-margin-top-md text-uppercase padding-right"><h3 class="text-uppercase"><span>{{vm.config.productName}} SUPPORT &amp; TRAINING</span></h3><div class="block"><select class="form-control" id="selected_product" name="selected_product" ng-options="c as c.productName for c in vm.accessibleProducts track by c.id" ng-model="vm.selectedDropDownConfig" ng-change="vm.selectedConfigChanged()"></select></div></div><div class="flex-width-300 flex-xs-percent-100 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-lg"><strong>Helpdesk</strong><br>{{vm.config.helpDeskPhone}}<br><a href="mailto:{{vm.config.helpDeskEmail}}" class="theme-link">{{vm.config.helpDeskEmail}}</a></div><div class="flex-width-300 flex-xs-percent-100 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><strong>Hours of Operation</strong> <i class="material-icons theme-link padding-left-xs" ng-click="vm.openHoursOfOperation()" ng-if="vm.isSystemAdmin">create</i><div ng-bind-html="vm.config.hoursOfOperation"></div></div></div></div><div class="flex-percent-30 flex-xs-percent-100 flex-sm-percent-100 text-right" data-ng-init="vm.pageLoaded()"><div class="pull-right padding-right-md override-xs-padding-top-20"><div class="padding-bottom-md" ng-if="vm.config.softwareSupport"><a ui-sref="software-help" class="btn btn-primary margin-left-md support-btn" ng-class="config.styleClass">SOFTWARE SUPPORT</a></div><div ng-if="vm.config.driverSupport"><a ui-sref="driver-help" class="btn btn-primary margin-left-md support-btn" ng-class="config.styleClass">DRIVER SUPPORT</a></div><div class="ng-hide" ng-show="vm.config.liveChat && vm.config.productName.toLowerCase() !== \'marketing\'"><a id="liveagent_button_online_573f2000000PCeC" href="javascript://Chat" style="display: none;" class="btn btn-primary" onclick="liveagent.startChat(\'573f2000000PCeC\')">LIVE CHAT</a><div id="liveagent_button_offline_573f2000000PCeC" style="display: none;" class="text-danger text-left"><button type="submit" class="btn btn-primary" disabled="true">LIVE CHAT</button><br>Currently Unavailable</div><script type="text/javascript">\r\n\r\n                                if (!window._laq) { window._laq = []; }\r\n                                \r\n                                window._laq.push(function(){liveagent.showWhenOnline(\'573f2000000PCeC\', document.getElementById(\'liveagent_button_online_573f2000000PCeC\'));\r\n                                \r\n                                liveagent.showWhenOffline(\'573f2000000PCeC\', document.getElementById(\'liveagent_button_offline_573f2000000PCeC\'));\r\n                                \r\n                                });</script></div><div class="ng-hide" ng-show="vm.config.liveChat && vm.config.productName.toLowerCase() === \'marketing\'"><a id="liveagent_button_online_573f2000000PCe2" href="javascript://Chat" style="display: none;" class="btn btn-primary" onclick="liveagent.startChat(\'573f2000000PCe2\')">LIVE CHAT</a><div id="liveagent_button_offline_573f2000000PCe2" style="display: none;" class="text-danger text-left"><button type="submit" class="btn btn-primary" disabled="true">LIVE CHAT</button><br>Currently Unavailable</div><script type="text/javascript">\r\n\r\n                                if (!window._laq) { window._laq = []; }\r\n                                \r\n                                window._laq.push(function(){liveagent.showWhenOnline(\'573f2000000PCe2\', document.getElementById(\'liveagent_button_online_573f2000000PCe2\'));\r\n                                \r\n                                liveagent.showWhenOffline(\'573f2000000PCe2\', document.getElementById(\'liveagent_button_offline_573f2000000PCe2\'));\r\n                                \r\n                                });</script></div></div></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="tutorial-table-wrapper"><table id="tutorial-table" class="table table-hover searchable-list table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll="vm.search()" infinite-scroll-container="\'#tutorial-table-wrapper\'" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore"><thead class="hidden-xs"><tr class="text-uppercase"><th>Item</th><th class="hidden-xs">Type</th><th class="hidden-xs">Date</th><th class="hidden-xs">Description</th></tr></thead><tbody><tr ng-repeat="data in vm.resolvedTutorials | orderBy: dateCreated : true | limitTo: vm.displayLimit" ng-click="vm.showTutorial(data)"><td class="text-nowrap"><strong>{{ ::data.title}}</strong><div class="visible-xs margin-bottom-sm"><b>Type:</b> {{ ::vm.getTypeLabel(data.trainingType)}} <span ng-if="data.trainingType === 0">({{::vm.getMinutesSeconds(data.estimatedTime)}})</span><br><b>Date:</b> {{ ::data.dateCreated | date:\'MMMM dd, yyyy\'}} <b>Description:</b> {{ ::data.description }}</div></td><td class="text-nowrap hidden-xs">{{ ::vm.getTypeLabel(data.trainingType)}} <span ng-if="data.trainingType === 0">({{::vm.getMinutesSeconds(data.estimatedTime)}})</span></td><td class="text-nowrap hidden-xs">{{ ::data.dateCreated | date:\'MMMM dd, yyyy\'}}</td><td class="hidden-xs">{{ ::data.description }}</td></tr></tbody></table><rc-list-standardized-footer record-count="vm.resolvedTutorials.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore"></rc-list-standardized-footer></div></div></div>');
$templateCache.put('app/areas/reports/views/report.add.html','<div class="row display-flex full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel flex-column overflow-hidden"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New Report</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-none"><form role="form" class="padding padding-top-lg form-horizontal" name="reportForm" id="reportForm" novalidate=""><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose the Report Type." popover-trigger="outsideClick">Report Type</span></label><div class="col-sm-8"><select name="pbiReport" class="form-control" ng-model="vm.reportType" validation="required" required="" ng-options="type.id as type.text for type in vm.reportTypes"></select></div></div></div><div class="row override-xs-margin-none" ng-if="vm.reportType == vm.reportTypeEnum.powerBI"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose the Power BI Report." popover-trigger="outsideClick">PBI Report</span></label><div class="col-sm-8"><select name="pbiReport" class="form-control" ng-model="vm.pbiReport" validation="required" required="" ng-init="vm.pbiReport = (vm.reports | filter:{reportType: vm.reportType})[0].id" ng-options="report.id as report.name for report in vm.reports | filter:{reportType: vm.reportType}"></select></div></div></div><div class="row" ng-if="vm.reportType == vm.reportTypeEnum.fabricServiceSuite"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose the Fabric Service Suite Report." popover-trigger="outsideClick">Fabric Service Suite Report</span></label><div class="col-sm-4"><select name="pbiReport" class="form-control" ng-model="vm.pbiReport" validation="required" required="" ng-init="vm.pbiReport = (vm.reports | filter:{reportType: vm.reportType})[0].id" ng-options="report.id as report.name for report in vm.reports | filter:{reportType: vm.reportType}"></select></div></div></div><div class="row override-xs-margin-none" ng-if="vm.reportType == vm.reportTypeEnum.externalLink"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The URL to embed." popover-trigger="outsideClick">URL</span></label><div class="col-sm-8"><input class="form-control" type="text" name="url" ng-model="vm.url" required="" validation="required"></div></div></div><div class="row override-xs-margin-none" ng-if="vm.reportType === vm.reportTypeEnum.autopointSSO"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The ID of the report in MP2." popover-trigger="outsideClick">MP2 ID</span></label><div class="col-sm-8"><input class="form-control" type="text" name="mpId" required="" ng-model="vm.multipointReportId" validation="required"></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Name to show the user." popover-trigger="outsideClick">Display Name</span></label><div class="col-sm-8"><input class="form-control" type="text" name="displayName" ng-model="vm.displayName" required="" validation="required"></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Who can see the report?" popover-trigger="outsideClick">Permission Level</span></label><div class="col-sm-8"><select required="" class="form-control" name="role" ng-model="vm.role" ng-options="role.value as role.text for role in vm.permissionLevels" validation="required" ng-init="vm.role = vm.reportRoles.systemAdmin"></select></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Where should this item show in the list?" popover-trigger="outsideClick">Sort Order</span></label><div class="col-sm-8"><select required="" class="form-control" name="sortOrder" ng-model="vm.sortOrder" validation="required" ng-init="vm.sortOrder = \'1\'"><option ng-repeat="a in vm.numberOfReports track by $index">{{$index+1}}</option></select></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Which permissions have access to this report?" popover-trigger="outsideClick">Allowed Roles</span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.reportRolePermissions"><ui-select-match placeholder="Select or search a role in the list...">{{ $item.name }}</ui-select-match><ui-select-choices refresh-delay="250" repeat="role in vm.rolePermissions | filter:$select.search"><div><span ng-bind-html="role.name | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div></div><div class="row override-xs-margin-none margin-bottom"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Which programs have access to this report? Empty for every program" popover-trigger="outsideClick">Allowed Programs</span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.report.programs"><ui-select-match placeholder="Select or search a program in the list...">{{ $item.name }}</ui-select-match><ui-select-choices refresh-delay="250" repeat="program in vm.programs | filter:$select.search"><div><span ng-bind-html="program.name | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div></div><div class="row override-xs-margin-none" ng-if="vm.reportType == vm.reportTypeEnum.powerBI"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Should we hide the filters?" popover-trigger="outsideClick">Hide Filters</span></label><div class="col-sm-8"><switch name="hideFilters" ng-model="vm.hideFilters"></switch></div></div></div><div class="row" ng-if="vm.reportType == vm.reportTypeEnum.fabricServiceSuite"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Should we hide the filters?" popover-trigger="outsideClick">Hide Filters</span></label><div class="col-sm-4"><switch name="hideFilters" ng-model="vm.hideFilters"></switch></div></div></div></form></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 padding-right-lg text-right"><div class="display-flex full-width-height content-center"><div class="pull-right full-width"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="report-list">Close</button> <button type="button" ng-click="vm.addReport()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading">Save</button></div></div></div></div>');
$templateCache.put('app/areas/reports/views/report.edit.html','<div class="row display-flex full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel flex-column overflow-hidden"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">Update Report</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-none"><form role="form" class="padding padding-top-lg form-horizontal" name="reportForm" id="reportForm" novalidate=""><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Choose the Power BI Report." popover-trigger="outsideClick">PBI Report</span></label><div class="col-sm-8 padding-top-sm">{{vm.report.powerBiReportName || vm.report.name}}</div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Name to show the user." popover-trigger="outsideClick">Display Name</span></label><div class="col-sm-8"><input required="" class="form-control" type="text" name="displayName" ng-model="vm.report.name" validation="required"></div></div></div><div class="row override-xs-margin-none" ng-if="vm.report.reportType === vm.reportTypes.autopointSSO"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The ID of the report in MP2." popover-trigger="outsideClick">MP2 ID</span></label><div class="col-sm-4"><input class="form-control" type="text" name="mpId" required="" ng-model="vm.report.multipointReportId" validation="required"></div></div></div><div class="row override-xs-margin-none" ng-if="vm.report.reportType === vm.reportTypes.externalLink"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The URL to embed." popover-trigger="outsideClick">URL</span></label><div class="col-sm-8"><input type="text" required="" class="form-control" name="url" ng-model="vm.report.url" validation="required"></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Who can see the report?" popover-trigger="outsideClick">Permission Level</span></label><div class="col-sm-8"><select class="form-control" required="" name="role" ng-model="vm.report.role" ng-options="role.value as role.text for role in vm.permissionLevels"></select></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Where should this item show in the list?" popover-trigger="outsideClick">Sort Order</span></label><div class="col-sm-8"><select required="" class="form-control" name="sortOrder" ng-model="vm.report.sortOrder" validation="required" ng-options="sortOrder.value as sortOrder.text for sortOrder in vm.sortOrders"></select></div></div></div><div class="row override-xs-margin-none margin-bottom"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Which permissions have access to this report?" popover-trigger="outsideClick">Allowed Roles</span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.report.rolePermissions"><ui-select-match placeholder="Select or search a role in the list...">{{ $item.name }}</ui-select-match><ui-select-choices refresh-delay="250" repeat="role in vm.rolePermissions | filter:$select.search"><div><span ng-bind-html="role.name | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div></div><div class="row override-xs-margin-none margin-bottom"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Which programs have access to this report? Empty for every program" popover-trigger="outsideClick">Allowed Programs</span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.report.programs"><ui-select-match placeholder="Select or search a program in the list...">{{ $item.name }}</ui-select-match><ui-select-choices refresh-delay="250" repeat="program in vm.programs | filter:$select.search"><div><span ng-bind-html="program.name | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div></div><div class="row override-xs-margin-none" ng-if="vm.report.reportType === vm.reportTypes.powerBI"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Should we hide the filters?" popover-trigger="outsideClick">Hide Filters</span></label><div class="col-sm-8"><switch name="hideFilters" ng-model="vm.report.hideFilters"></switch></div></div></div><div class="row" ng-if="vm.report.reportType === vm.reportTypes.fabricServiceSuite"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Should we hide the filters?" popover-trigger="outsideClick">Hide Filters</span></label><div class="col-sm-4"><switch name="hideFilters" ng-model="vm.report.hideFilters"></switch></div></div></div><div class="row override-xs-margin-none"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Is the report enabled to be viewed?" popover-trigger="outsideClick">Is Active</span></label><div class="col-sm-8"><switch name="hideFilters" ng-model="vm.report.isActive"></switch></div></div></div></form></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 padding-right-lg text-right"><div class="display-flex full-width-height content-center"><div class="pull-right full-width"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="report-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.promptDelete()">Delete</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading">Update</button></div></div></div></div>');
$templateCache.put('app/areas/reports/views/report.list.html','<div class="visible-xs"><center><br><br><br><i class="material-icons material-icons-xlarge">error_outline</i><br><br><div>Please use the desktop or tablet experience to view reports.</div></center></div><div class="position-absolute display-flex flex-column overflow-hidden full-width-height hidden-xs"><div ng-cloak="" id="reports" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none" ng-class="{\'expanded\': vm.showSearchTray === true}"><div class="display-flex flex-row margin-bottom-md margin-top-md flex-sm-column flex-xs-column flex-sm-column full-width"><div class="flex-percent-50 flex-xs-percent-100 flex-sm-percent-100"><div class="display-flex flex-row flex-sm-column flex-xs-column flex-sm-column"><div class="flex-width-300 flex-xs-percent-100 flex-sm-percent-100 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-lg"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div class="report-dropdown field-wrapper" id="reportsDropdownContainer" ng-show="vm.reports && vm.reports.length !== 1"><label for="reportsDropdown">SELECT A REPORT</label><select required="" id="reportsDropdown" selectlabel="" name="reportsDropdown" class="form-control" data-allow-single-deselect="true" data-placeholder-text-single="\'Select a report\'" ng-model="vm.selectedReport" ng-options="r.id as r.name for r in vm.reports" ng-change="vm.reportSelected(r)"></select></div></div></div><div class="flex-width-300 flex-xs-percent-100 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top" ng-if="vm.reportObject.reportType === vm.sysEnums.reportTypes.autopointSSO"><select ng-if="vm.appointmentLocationList && vm.appointmentLocationList.length > 0" class="form-control" name="locationFilter" chosen="{width: \'100%\'}" ng-model="vm.apptDealer" max-shown-results="100" ng-options="l as l.name for l in vm.appointmentLocationList" ng-change="vm.appointmentLocationSelected()"><option value="">Select a dealer</option></select></div></div></div><div class="flex-percent-50 flex-xs-percent-100 flex-sm-percent-100 override-sm-margin-top"><div class="display-flex flex-row pull-right content-center"><span class="font-bold padding-right-md text-uppercase hidden-xs" ng-if="vm.report" has-role="{{vm.sysEnums.roleNames.systemAdmin}},{{vm.sysEnums.roleNames.redCapAdmin}}">Last Updated on {{ vm.getLastUpdatedDate() }}</span><div class="inline padding-right-xs"><button ng-if="vm.showPowerBIButtons" type="button" class="btn btn-default text-uppercase padding" ng-click="vm.fullScreen()" title="Full Screen" id="full_screen"><i class="material-icons">fullscreen</i></button></div><div class="inline padding-right-xs"><button ng-if="vm.showPowerBIButtons" type="button" class="btn btn-default text-uppercase" ng-click="vm.printReport()" title="Print" id="print"><i class="material-icons">print</i></button></div><div class="inline padding-right-xs"><a ui-sref="report-add" class="btn btn-primary text-uppercase" ng-class="config.styleClass" has-role="{{vm.sysEnums.roleNames.systemAdmin}}">Add <span class="hidden-sm-down">Report</span></a></div><a ui-sref="report-edit({reportId: vm.selectedReport})" class="btn btn-default text-uppercase" ng-class="config.styleClass" has-role="{{vm.sysEnums.roleNames.systemAdmin}}" ng-if="vm.selectedReport">Update <span class="hidden-sm-down">Report</span></a></div></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="report-wrapper"><div class="form-horizontal"><div id="report-container"></div></div></div></div></div>');
$templateCache.put('app/areas/trip/views/lyft-campaign-edit.view.html','<div id="lyft-credit-aside-wrapper" class="aside-wrapper appointments-wizard"><div class="lyft-credit aside-header gray-bg"><div class="row full-height"><div class="col-xs-12"><div class="contact-details margin-top margin-bottom"><div class="row margin-bottom-sm"><div class="col-xs-3 padding-right-none title">CAMPAIGN ID:</div><div class="col-xs-9 font-size-14 padding-left-none">{{ vm.campaign.campaignId }}</div></div><div class="row"><div class="col-xs-3 padding-right-none title">CLIENT ID:</div><div class="col-xs-9 font-size-14 padding-left-none">{{ vm.campaign.customerId }}</div></div></div></div></div></div><div id="lyft-credit-aside-body" class="aside-body" aside-parent="vm.childScopeForm"><div class="panel-group"><div class="panel-default panel"><div class="panel-heading clearfix"><h4 class="panel-title pull-left">CAMPAIGN DETAILS</h4></div><div class="panel-body border-top padding-left-none font-size-12"><div class="row margin-bottom-md"><div class="col-xs-3 padding-right-none"><strong>CAMPAIGN ID</strong></div><div class="col-xs-9">{{ vm.campaign.campaignId }}</div></div><div class="row margin-bottom-md"><div class="col-xs-3 padding-right-none"><strong>CLIENT ID</strong></div><div class="col-xs-9">{{ vm.campaign.customerId }}</div></div><div class="row margin-bottom-md"><div class="col-xs-3 padding-right-none"><strong>AMOUNT ISSUED</strong></div><div class="col-xs-9">{{ vm.campaign.amountIssued / 100 | currency }}</div></div><div class="row margin-bottom-md"><div class="col-xs-3 padding-right-none"><strong>AMOUNT REMAINING</strong></div><div class="col-xs-9">{{ vm.campaign.amountRemaining / 100 | currency }}</div></div><div class="row margin-bottom-md"><div class="col-xs-3 padding-right-none"><strong>CREDITS ISSUED</strong></div><div class="col-xs-9">{{ vm.campaign.creditsIssued }}</div></div><div class="row margin-bottom-md" ng-if="vm.campaign.batchStatus"><div class="col-xs-3 padding-right-none"><strong>STATUS</strong></div><div class="col-xs-9"><span ng-if="vm.campaign.batchStatus === vm.batchStatuses.processing">PROCESSING...</span> <span ng-if="vm.campaign.batchStatus === vm.batchStatuses.processed">PROCESSING COMPLETE</span> <a ng-click="vm.getErrorLog()" ng-if="vm.campaign.totalErrorCount && vm.campaign.batchStatus !== vm.batchStatuses.processing">ERRORS - {{ vm.campaign.newErrorCount }} NEW, {{ vm.campaign.totalErrorCount }} TOTAL (CLICK TO DOWNLOAD)</a></div></div><div class="row margin-bottom-md"><div class="col-xs-3 padding-right-none"><strong>ADD PARTICIPANT(S)</strong></div><div class="col-xs-9"><label class="radio-inline font-size-11"><input type="radio" name="add-participant" value="single" ng-model="vm.addParticipantType" ng-disabled="!vm.isEditable"> <span class="add-participant-radio-label">ADD INDIVIDUALS</span></label> <label class="radio-inline font-size-11"><input type="radio" name="add-participant" value="multiple" ng-model="vm.addParticipantType" ng-disabled="!vm.isEditable"> <span class="add-participant-radio-label">UPLOAD LIST</span></label></div></div><div ng-show="vm.addParticipantType === \'single\'" class="form-group margin-top-20"><form role="form" name="LyftCampaignAddParticipantForm" class="form-horizontal" novalidate=""><div class="row margin-bottom-md" ng-repeat="participant in vm.participants"><div class="col-sm-4 padding-right-none"><input type="text" id="first_name" name="first_name_{{$index}}" clean="true" autocomplete="nope" ng-model="participant.firstName" class="form-control better-placeholder fake-required" placeholder="FIRST NAME" ng-required="!vm.isEmptyParticipant(participant) && vm.addParticipantType === \'single\'" validation="{{ !vm.isEmptyParticipant(participant) && vm.addParticipantType === \'single\' ? \'required:alt=Required\' : \'\' }}" ng-disabled="!vm.isEditable"></div><div class="col-sm-4 padding-right-none"><input type="text" id="last_name" name="last_name_{{$index}}" clean="true" autocomplete="nope" ng-model="participant.lastName" class="form-control better-placeholder fake-required" placeholder="LAST NAME" ng-required="!vm.isEmptyParticipant(participant) && vm.addParticipantType === \'single\'" validation="{{ !vm.isEmptyParticipant(participant) && vm.addParticipantType === \'single\' ? \'required:alt=Required\' : \'\' }}" ng-disabled="!vm.isEditable"></div><div class="col-sm-3 padding-right-none margin-right-md"><input type="text" id="phone_number" name="phone_number_{{$index}}" clean="true" autocomplete="nope" ng-model="participant.phoneNumber" class="form-control better-placeholder fake-required" placeholder="PHONE" ng-required="!vm.isEmptyParticipant(participant) && vm.addParticipantType === \'single\'" validation="{{ !vm.isEmptyParticipant(participant) && vm.addParticipantType === \'single\'? \'required:alt=Required|custom:vm.validatePhone(participant.phoneNumber):alt=Invalid Phone Number\' : \'\' }}" mask-restrict="reject" mask="(999) 999-9999" ng-disabled="!vm.isEditable"></div><div class="margin-top-sm"><i class="material-icons theme-link md-24" ng-if="!$last" ng-click="vm.removeParticipant(participant)">remove</i> <i class="material-icons theme-link md-24" ng-if="$last" ng-click="vm.addParticipant()">add</i></div></div></form></div><div ng-if="vm.addParticipantType === \'multiple\'" class="form-group"><div class="row margin-bottom-md bulk-upload"><div class="col-sm-10 padding-right-none"><div class="btn btn-default margin-right-md margin-top-sm" ngf-select="vm.validateBatch($file)" ng-model="vm.campaign.batch" ng-disabled="!vm.isEditable">UPLOAD RECIPIENT LIST...</div><span>{{ vm.campaign.batch.file.name }}</span> <span ng-if="vm.isValidatingBatch">Validating...</span> <span ng-if="vm.campaign.batch.isUploaded && vm.campaign.batch.isValid"><i class="material-icons md-18">done</i> <span class="font-size-11">OK</span></span> <span ng-if="vm.campaign.batch.isUploaded && !vm.campaign.batch.isValid" class="text-danger inline-block margin-top"><i class="material-icons md-18 text-danger">clear</i> <span class="font-size-11">ERROR: MISSING DATA OR INCORRECT FORMAT</span></span></div></div></div></div></div><div class="panel-default panel"><div class="panel-heading clearfix"><h4 class="panel-title pull-left">CREDIT DETAILS</h4></div><div class="panel-body border-top padding-left-none font-size-12"><form role="form" name="LyftCampaignEditForm" class="form-horizontal col-xs-12 padding-left-none" novalidate=""><div ng-if="vm.campaign.benefitType === vm.benefitTypes.credits" class="margin-bottom-md"><div class="row margin-bottom-20"><div class="col-xs-3"><strong>TYPE OF CREDIT</strong></div><div class="col-xs-9"><span>SIMPLE CREDIT<span></span></span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.campaign.dateCreated | date }}</span></div><div class="col-sm-3"><label for="credits_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="credits_expiry" readonly="" name="credits_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="credits-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="credits-expiry-validation" class="validation text-danger"></div></div></div><div class="row"><div class="col-sm-3"><label for="credits_discountamount" class="control-label">AMOUNT ISSUED</label></div><div class="col-sm-3"><input type="text" id="credits_discountamount" name="credits_discountamount" ng-model="vm.campaign.benefit.discountAmount" class="form-control text-right" ng-disabled="!vm.isEditable" validation="required:alt=Required|between_num: {{ vm.originalDiscountAmount }}, 1000:alt=Must be valid amount between ${{ vm.originalDiscountAmount.toFixed(2) }} and $1000.00" format-currency=""></div></div></div><div ng-if="vm.campaign.benefitType === vm.benefitTypes.fixedFare"><div class="row margin-bottom-20"><div class="col-sm-3"><strong>TYPE OF CREDIT</strong></div><div class="col-sm-3"><span>FIXED FARE RIDES</span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.campaign.dateCreated | date }}</span></div><div class="col-sm-3"><label for="fixedfare_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="fixedfare_expiry" readonly="" name="fixedfare_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="fixedfare-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="fixedfare-expiry-validation" class="validation text-danger"></div></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><label for="fixedfare_numrides" class="control-label">NUMBER OF RIDES</label></div><div class="col-sm-3"><input type="text" id="fixedfare_numrides" name="fixedfare_numrides" ng-model="vm.campaign.benefit.numRides" class="form-control text-right" ng-disabled="!vm.isEditable" validation="required:alt=Required|min_num:{{ vm.originalNumRides }}:alt=Rides remaining must be {{ vm.originalNumRides }} or higher"></div></div><div class="row margin-bottom-20"><div class="col-sm-3"><strong class="benefit-key">FARE PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.campaign.benefit.flatFarePerRide | currency }}</span></div></div><div class="row margin-bottom-20"><div class="col-sm-3 padding-right-none"><strong class="benefit-key">MAX EXPENSE PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.campaign.benefit.liabilityPerRide | currency }}</span></div></div></div><div ng-if="vm.campaign.benefitType === vm.benefitTypes.fixedDiscount"><div class="row margin-bottom-20"><div class="col-sm-3"><strong>TYPE OF CREDIT</strong></div><div class="col-sm-4"><span>$ DISCOUNT RIDES</span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.campaign.dateCreated | date }}</span></div><div class="col-sm-3"><label for="fixeddiscount_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="fixeddiscount_expiry" readonly="" name="fixeddiscount_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="fixeddiscount-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="fixeddiscount-expiry-validation" class="validation text-danger"></div></div></div><div class="row margin-bottom-md"><div class="col-sm-3 padding-right-none"><label for="fixeddiscount_numrides" class="control-label">NUMBER OF RIDES</label></div><div class="col-sm-3"><input type="text" id="fixeddiscount_numrides" name="fixeddiscount_numrides" ng-model="vm.campaign.benefit.numRides" class="form-control text-right" ng-disabled="!vm.isEditable" validation="required:alt=Required|min_num:{{ vm.originalNumRides }}:alt=Rides remaining must be {{ vm.originalNumRides }} or higher"></div></div><div class="row margin-bottom-20"><div class="col-sm-3 padding-right-none"><strong class="benefit-key">$ DISCOUNT PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.campaign.benefit.liabilityPerRide | currency }}</span></div></div></div><div ng-if="vm.campaign.benefitType === vm.benefitTypes.variableDiscount"><div class="row margin-bottom-20"><div class="col-sm-3"><strong>TYPE OF CREDIT</strong></div><div class="col-sm-4"><span>% DISCOUNT RIDES</span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.campaign.dateCreated | date }}</span></div><div class="col-sm-3"><label for="variablediscount_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="variablediscount_expiry" readonly="" name="variablediscount_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="variablediscount-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="variablediscount-expiry-validation" class="validation text-danger"></div></div></div><div class="row margin-bottom-md"><div class="col-sm-3 padding-right-none"><label for="variablediscount_numrides" class="control-label">NUMBER OF RIDES</label></div><div class="col-sm-3"><input type="text" id="variablediscount_numrides" name="variablediscount_numrides" ng-model="vm.campaign.benefit.numRides" class="form-control" ng-disabled="!vm.isEditable" validation="required:alt=Required|min_num:{{ vm.originalNumRides }}:alt=Rides remaining must be {{ vm.originalNumRides }} or higher"></div></div><div class="row margin-bottom-20"><div class="col-sm-3 padding-right-none"><strong class="benefit-key">% DISCOUNT PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.campaign.benefit.discountRatio }}%</span></div></div></div><div class="row margin-top"><div class="col-xs-12"><textarea class="form-control better-placeholder resize-none" ng-model="vm.campaign.referenceNote" placeholder="REFERENCE NOTE" ng-disabled="!vm.isEditable">\r\n                            </textarea></div></div></form></div></div><div class="panel panel-default"><div class="panel-body"><div ng-if="vm.error" class="text-danger">{{vm.error}}</div><div ng-if="vm.expired" class="text-danger margin-top">This campaign is expired and cannot be edited.</div><div ng-if="vm.campaign.isTest" class="text-danger margin-top">Unable to update campaign. Please contact the Client Success Team for further assistance.</div></div></div><div class="panel-default panel"><div class="panel-heading clearfix"><h4 class="panel-title pull-left">USE RESTRICTIONS</h4></div><div class="panel-body border-top padding-left-none font-size-12"><div class="time-restrictions margin-bottom-20"><h5>DAY/TIME</h5><ul ng-if="vm.campaign.timeRestrictions.length" class="list-unstyled"><li class="text-uppercase margin-bottom-sm" ng-repeat="timeRestriction in vm.campaign.timeRestrictions">{{ vm.daysOfWeek[timeRestriction.dayOfWeek] }} {{ (timeRestriction.startTime | time).replace(\'M\', \'\') }} - {{ (timeRestriction.endTime | time).replace(\'M\', \'\') }}</li></ul><div ng-if="!vm.campaign.timeRestrictions.length" class="text-uppercase">No Day/Time Restrictions</div></div><div class="geo-restrictions"><h5>GEOLOCATION</h5><div class="row margin-bottom-md"><div class="col-sm-12"><span ng-if="vm.campaign.geoRestrictionType === 0">APPLIES ON TRIPS THAT START AND END AT ANY LOCATION</span> <span ng-if="vm.campaign.geoRestrictionType === 1">APPLIES ON TRIPS THAT AT LEAST START OR END AT ONE OF THE LOCATIONS LISTED BELOW</span> <span ng-if="vm.campaign.geoRestrictionType === 2">APPLIES ON TRIPS THAT BOTH START AND END AT LOCATIONS LISTED BELOW</span></div></div><div ng-if="vm.campaign.geoRestrictions.length" ng-repeat="geoRestriction in vm.campaign.geoRestrictions" class="row"><div class="col-sm-7 text-uppercase">{{ geoRestriction.address }}</div><div class="col-sm-5">{{ geoRestriction.radiusInMeters }} M</div></div></div></div></div><div class="panel panel-default"><div class="panel-body padding-left-none padding-right-none"><div ng-if="vm.error" class="text-danger">{{vm.error}}</div><div ng-if="vm.expired && !vm.campaign.isRevoked" class="text-danger margin-top">This campaign is expired and cannot be edited.</div><div ng-if="vm.campaign.isRevoked" class="text-danger margin-top">This campaign has been revoked and cannot be edited.</div></div></div><div class="modal-footer"><div class="footer col-xs-12 border-none text-right margin-bottom"><button type="button" class="btn btn-default" ng-click="$dismiss()" ui-sref="trip-list">Close</button> <button type="button" ng-if="vm.isEditable" class="btn btn-default" ng-click="vm.revokeCampaign()">Revoke</button> <button type="button" ng-if="vm.isEditable" class="btn btn-primary" ng-click="vm.updateCampaign()" ng-disabled="!vm.canSubmit()">Update</button></div></div></div></div></div>');
$templateCache.put('app/areas/trip/views/lyft-credit-edit.view.html','<div id="lyft-credit-aside-wrapper" class="aside-wrapper appointments-wizard"><div class="lyft-credit aside-header gray-bg"><div class="row full-height"><div class="col-xs-12"><div class="contact-details margin-top margin-bottom"><div class="row"><div class="col-sm-11 col-xs-10 override-xs-padding-top-md"><h4 class="text-uppercase">{{ ::vm.credit.customerFirstName}} {{ ::vm.credit.customerLastName}}</h4><div class="row contact-phone override-xs-padding-none"><div class="col-xs-12"><span ng-if="vm.credit.customerPhoneNumber">{{ ::vm.credit.customerPhoneNumber | tel }}</span><br><span class="text-uppercase">{{ ::vm.credit.dealerName }}</span></div></div></div></div></div></div></div></div><div id="lyft-credit-aside-body" class="aside-body" aside-parent="vm.childScopeForm"><form role="form" name="LyftCreditEditForm" class="form-horizontal col-xs-12 padding-left-none" novalidate=""><div class="panel-group"><div class="panel-default panel" ng-if="vm.credit.campaignId"><div class="panel-heading clearfix"><a ui-sref="lyft-campaign-edit({ id: vm.credit.rideProviderCampaignId })" class="pull-right campaign-link">VIEW/EDIT CAMPAIGN</a><h4 class="panel-title pull-left">CAMPAIGN DETAILS</h4></div><div class="panel-body border-top padding-left-none font-size-12"><div class="row margin-bottom-md"><div class="col-xs-3"><strong>CAMPAIGN ID</strong></div><div class="col-xs-9">{{ vm.credit.campaignId }}</div></div><div class="row" ng-if="vm.credit.customerId"><div class="col-xs-3"><strong>CLIENT ID</strong></div><div class="col-xs-9">{{ vm.credit.customerId }}</div></div></div></div><div class="panel-default panel"><div class="panel-heading"><h4 class="panel-title">CREDIT DETAILS</h4></div><div class="panel-body border-top padding-left-none font-size-12"><div ng-if="vm.credit.benefitType === vm.benefitTypes.credits" class="margin-bottom-md"><div class="row margin-bottom-20"><div class="col-xs-3"><strong>TYPE OF CREDIT</strong></div><div class="col-xs-9"><span>SIMPLE CREDIT<span></span></span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.dateCreated | date }}</span></div><div class="col-sm-3"><label for="credits_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy" data-date-start-date="{{ vm.originalEndTime.format(\'MM-DD-YYYY\') }}"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="credits_expiry" readonly="" name="credits_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="credits-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="credits-expiry-validation" class="validation text-danger"></div></div></div><div class="row"><div class="col-sm-3"><label for="credits_discountamount" class="control-label">AMOUNT ISSUED</label></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.discountAmount | currency }}</span></div><div class="col-sm-3"><strong class="benefit-key">BALANCE</strong></div><div class="col-sm-3 padding-left-none"><input type="text" id="credits_remainingamount" name="credits_remainingamount" ng-model="vm.credit.benefit.remainingAmount" ng-disabled="!vm.isEditable" class="form-control text-right" validation="required:alt=Required|between_num: {{ vm.originalRemainingAmount }}, 1000:alt=Must be valid amount between ${{ vm.originalRemainingAmount.toFixed(2) }} and $1000.00" format-currency=""></div></div></div><div ng-if="vm.credit.benefitType === vm.benefitTypes.fixedFare"><div class="row margin-bottom-20"><div class="col-sm-3"><strong>TYPE OF CREDIT</strong></div><div class="col-sm-3"><span>FIXED FARE RIDES</span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.credit.dateCreated | date }}</span></div><div class="col-sm-3"><label for="fixedfare_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy" data-date-start-date="{{ vm.originalEndTime.format(\'MM-DD-YYYY\') }}"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="fixedfare_expiry" readonly="" name="fixedfare_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="fixedfare-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="fixedfare-expiry-validation" class="validation text-danger"></div></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">RIDES ISSUED</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.numRides }}</span></div><div class="col-sm-3"><label for="fixedfare_remainingnumrides" class="control-label">RIDES REMAINING</label></div><div class="col-sm-3 padding-left-none"><input type="text" id="fixedfare_remainingnumrides" name="fixedfare_remainingnumrides" ng-model="vm.credit.benefit.remainingNumRides" ng-disabled="!vm.isEditable" class="form-control text-right" validation="required:alt=Required|min_num:{{ vm.originalRemainingNumRides }}:alt=Rides remaining must be {{ vm.originalRemainingNumRides }} or higher"></div></div><div class="row margin-bottom-20"><div class="col-sm-3"><strong class="benefit-key">FARE PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.flatFarePerRide | currency }}</span></div></div><div class="row margin-bottom-20"><div class="col-sm-3 padding-right-none"><strong class="benefit-key">MAX EXPENSE PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.liabilityPerRide | currency }}</span></div></div></div><div ng-if="vm.credit.benefitType === vm.benefitTypes.fixedDiscount"><div class="row margin-bottom-20"><div class="col-sm-3"><strong>TYPE OF CREDIT</strong></div><div class="col-sm-3"><span>$ DISCOUNT RIDES</span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.credit.dateCreated | date }}</span></div><div class="col-sm-3"><label for="fixeddiscount_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy" data-date-start-date="{{ vm.originalEndTime.format(\'MM-DD-YYYY\') }}"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="fixeddiscount_expiry" readonly="" name="fixeddiscount_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="fixeddiscount-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="fixeddiscount-expiry-validation" class="validation text-danger"></div></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">RIDES ISSUED</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.numRides }}</span></div><div class="col-sm-3"><label for="fixeddiscount_remainingnumrides" class="control-label">RIDES REMAINING</label></div><div class="col-sm-3"><input type="text" id="fixeddiscount_remainingnumrides" name="fixeddiscount_remainingnumrides" ng-model="vm.credit.benefit.remainingNumRides" ng-disabled="!vm.isEditable" class="form-control text-right" validation="required:alt=Required|min_num:{{ vm.originalRemainingNumRides }}:alt=Rides remaining must be {{ vm.originalRemainingNumRides }} or higher"></div></div><div class="row margin-bottom-20"><div class="col-sm-3 padding-right-none"><strong class="benefit-key">$ DISCOUNT PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.liabilityPerRide | currency }}</span></div></div></div><div ng-if="vm.credit.benefitType === vm.benefitTypes.variableDiscount"><div class="row margin-bottom-20"><div class="col-sm-3"><strong>TYPE OF CREDIT</strong></div><div class="col-sm-8"><span>% DISCOUNT RIDES</span></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">DATE ISSUED</strong></div><div class="col-sm-3 text-uppercase"><span class="benefit-value">{{ vm.credit.dateCreated | date }}</span></div><div class="col-sm-3"><label for="variablediscount_expiry" class="control-label">EXPIRATION</label></div><div class="col-sm-3 padding-left-none"><div class="input-group date" data-provide="datepicker" data-date-format="M d, yyyy" data-date-start-date="{{ vm.originalEndTime.format(\'MM-DD-YYYY\') }}"><input type="text" class="form-control text-uppercase" ng-model="vm.endTime" id="variablediscount_expiry" readonly="" name="variablediscount_expiry" ng-disabled="!vm.isEditable" validation="custom:vm.validateLaterDate():alt=Must be a date on or after {{ vm.originalEndTime.format(\'MMM DD, YYYY\') }}.|custom:vm.validateDate():alt=Expiration date cannot be over 90 days from start date." validation-error-to="variable-expiry-validation"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div><div id="variable-expiry-validation" class="validation text-danger"></div></div></div><div class="row margin-bottom-md"><div class="col-sm-3"><strong class="benefit-key">RIDES ISSUED</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.numRides }}</span></div><div class="col-sm-3"><label for="variablediscount_remainingnumrides" class="control-label">RIDES REMAINING</label></div><div class="col-sm-3 padding-left-none"><input type="text" id="variablediscount_remainingnumrides" name="variablediscount_remainingnumrides" ng-model="vm.credit.benefit.remainingNumRides" ng-disabled="!vm.isEditable" class="form-control text-right" validation="required:alt=Required|min_num:{{ vm.originalRemainingNumRides }}:alt=Rides remaining must be {{ vm.originalRemainingNumRides }} or higher"></div></div><div class="row margin-bottom-20"><div class="col-sm-3 padding-right-none"><strong class="benefit-key">% DISCOUNT PER RIDE</strong></div><div class="col-sm-3"><span class="benefit-value">{{ vm.credit.benefit.discountRatio}}%</span></div></div></div><div class="row"><div class="col-xs-12"><textarea class="form-control better-placeholder resize-none" ng-model="vm.credit.referenceNote" ng-disabled="!vm.isEditable" placeholder="REFERENCE NOTE"></textarea></div></div></div></div><div class="panel panel-default"><div class="panel-body padding-left-none padding-right-none"><div ng-if="vm.error" class="text-danger">{{vm.error}}</div><div ng-if="vm.expired" class="text-danger margin-top">This benefit is expired and cannot be edited.</div><div ng-if="vm.cancelled" class="text-danger margin-top">This benefit has been cancelled and cannot be edited.</div><div ng-if="vm.credit.preventEditOrDelete" class="text-danger margin-top">Unable to update benefit. Please contact the Client Success Team for further assistance.</div></div></div></div></form><div class="modal-footer"><div class="col-xs-12 border-none text-right"><button type="button" class="btn btn-default" ng-click="$dismiss()" ui-sref="trip-list">Close</button> <button ng-if="vm.isEditable" type="button" class="btn btn-default" ladda="vm.cancelling" ng-click="vm.cancelCredit()">REVOKE</button> <button ng-if="vm.isEditable" type="button" class="btn btn-primary" ladda="vm.updatingCredit" ng-click="vm.updateCredit()" ng-disabled="LyftCreditEditForm.$invalid || !LyftCreditEditForm.$dirty">Update</button></div></div></div></div>');
$templateCache.put('app/areas/trip/views/lyft-credits-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="contracts" class="credit-list panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-column"><div class="display-flex flex-row full-width"><div class="flex-percent-50 hidden-sm hidden-xs"><rc-list-mode-selector ng-model="vmList.parent_vm.selectedViewModeIcon" available-modes="vmList.parent_vm.availTripModes" css-class="rc-list-selector" on-select-event="vmList.tripListModeChanged()"></rc-list-mode-selector></div><div class="flex-sm-percent-60 flex-xs-percent-60 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative" ng-if="vmList.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vmList.searchTemplateData.currentSearchTemplate" search-templates="vmList.searchTemplateData.searchTemplates" on-select-event="vmList.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 visible-xs visible-sm"><rc-list-advanced-filter-toggle filter-count="vmList.filterCount" filter-message="vmList.filterMessage" record-count="vmList.filteredCredits.length" toggle-advanced-search="vmList.toggleShowSearchOptions()" reset-filters="vmList.clearFilters()" align-right="true" search-tray-displayed="vmList.showAdvancedSearch"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm" ng-if="!vmList.showAdvancedSearch"><a ng-if="!vmList.parent_vm.isFramedIn()" id="new-trip" ui-sref="trip-add" class="margin-left-md visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row full-width visible-xs visible-sm margin-top-sm"><div class="flex-sm-percent-100 flex-xs-percent-60 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative"><input type="text" id="customer-search" name="customer-search" class="form-control" ng-model="vmList.filters.customerFilter" ng-keyup="$event.keyCode === 13 && vmList.customerFilterUpdated()" ng-disabled="vmList.isLoading" placeholder="Customer search"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomerField()" ng-if="vmList.filters.customerFilter">close</span></div></div></div></div><div class="display-flex flex-column full-width"><div class="display-flex flex-row flex-sm-column hidden-xs hidden-sm"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative padding-right-sm padding-left override-xs-padding-none override-sm-padding-none" ng-if="vmList.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vmList.searchTemplateData.currentSearchTemplate" search-templates="vmList.searchTemplateData.searchTemplates" on-select-event="vmList.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-350 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md ng-show" ng-if="vmList.isLocationListEmpty() === true"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent"><input type="text" name="search" class="form-control" placeholder="All locations" ng-model="vmList.noLocationsText"><div id="location-search-overlay" ng-click="vmList.getDealerLocations()" ng-if="vmList.isLocationListEmpty() === true"></div><img src="assets/images/ajax-loader.gif" class="ng-hide location-spinner" ng-show="vmList.loadingLocations"></div></div><div class="flex-width-350 flex-grow max-width-px-400 flex-sm-percent-100 override-sm-margin-top" ng-if="vmList.isLocationListEmpty() === false && vmList.hasMultipleDealers === false"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input id="location-filter" class="form-control better-placeholder" placeholder="All locations" type="text" ng-disabled="true" ng-model="vmList.singleLocation.name"></div></div><div class="flex-width-350 flex-grow max-width-px-400 flex-sm-percent-100 override-sm-margin-top" ng-if="vmList.isLocationListEmpty() === false && vmList.hasMultipleDealers === true"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><select select2="" id="location-filter-single" name="location-filter-single" on-change="vmList.selectSingleLocation(selectedResult)" placeholder="All locations" min-input-length="1" init-value="vmList.selectedSingleLocation" format-for-selection="vmList.formatLocationForSelection" format-for-dropdown="vmList.formatLocationForDropdown" query="vmList.locationSearchQuery" ng-model="vmList.selectedSingleLocationId"></select></div></div><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative"><input type="text" id="customer-search" name="customer-search" class="form-control" ng-model="vmList.filters.customerFilter" ng-keyup="$event.keyCode === 13 && vmList.customerFilterUpdated()" ng-disabled="vmList.isLoading" placeholder="CUSTOMER SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomerField()" ng-if="vmList.filters.customerFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top-md override-xs-margin-top-md ng-show" ng-show="vmList.showCalendar() === false"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="dateRangeFilter">ISSUE DATE</label><select selectlabel="" id="dateRangeFilter" ng-disabled="vmList.isLoading" disable-search="true" class="form-control ng-show text-uppercase" name="dateRangeFilter" ng-model="vmList.filters.timeframeFilter" ng-change="vmList.listFilterChanged(true)" ng-options="t.value as t.text for t in vmList.timeframes"><option value="">All issue dates</option></select></div></div><div class="flex-width-300 flex-sm-percent-100 override-sm-margin-top-md override-xs-margin-top-md ng-hide padding-left-sm" ng-show="vmList.showCalendar() === true && !vmList.showAdvancedSearch"><div class="block relative"><input options="vmList.dateRangePickerOptions" date-range-picker="" id="timeframe_range" class="form-control date-picker" placeholder="CUSTOM TIMEFRAME" type="text" ng-model="vmList.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomTimeFrame()">close</span></div></div><div class="flex-width-120 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vmList.filterCount" filter-message="vmList.filterMessage" record-count="vmList.filteredCredits.length" toggle-advanced-search="vmList.toggleShowSearchOptions()" reset-filters="vmList.resetFilters()"></rc-list-advanced-filter-toggle></div></div><div class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters filter-count="vmList.filterCount" record-count="vmList.filteredCredits.length" filter-message="vmList.filterMessage"></rc-list-mobile-filters></div></div><div class="display-flex flex-column hidden-sm hidden-xs"><a id="new-trip" ui-sref="trip-add" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass"><span class="hidden-xs">+</span> NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="vouchers-table-wrapper"><table class="table table-hover table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll="vmList.displayMore()" infinite-scroll-distance="1" infinite-scroll-container="\'#vouchers-table-wrapper\'"><thead class="hidden-xs text-uppercase"><tr><th data-toggle="true" data-type="alpha">Customer</th><th data-toggle="true" data-type="numeric">Duration</th><th data-toggle="true" data-type="numeric">Time Left</th><th data-toggle="true" data-type="numeric">Budget/Balance</th><th data-toggle="true">Status</th><th data-toggle="true" class="hidden-xs">Used For</th><th data-toggle="true" data-type="alpha" class="hidden-xs">Issued By</th><th data-toggle="true" class="hidden-xs">Benefit Type</th><th ng-if="vmList.filters.showBulkUpload" data-toggle="true" data-type="alpha" class="hidden-x">Campaign ID</th><th ng-if="vmList.filters.showBulkUpload" data-toggle="true" data-type="alpha" class="hidden-xs">Client ID</th><th ng-if="vmList.resolvedLocationList.length > 1" data-toggle="true" data-type="alpha" class="hidden-xs">Location</th></tr></thead><tbody><tr ng-repeat="credit in vmList.filteredCredits | limitTo: vmList.displayLimit" class="list-name text-uppercase" ui-sref="lyft-credit-edit({ id: credit.id, isTest: credit.isTest === true ? 1 : 0 })"><td class="location-name"><span class="hidden-xs"><strong>{{ ::credit.customerFirstName}} {{ ::credit.customerLastName}}</strong></span><div class="visible-xs padding-left-sm"><div class="margin-top-sm"></div><strong>{{ ::credit.customerFirstName}} {{ ::credit.customerLastName}}</strong><div>{{ ::credit.customerPhoneNumber | tel }}</div><div class="margin-top-sm">{{ credit.benefit.remainingAmount | currency }} OF {{ credit.benefit.discountAmount | currency }} USED</div><div class="mobile-left ellipsis-overflow"><br>TIME LEFT: {{ credit.timeLeft | duration:false:true}}</div><div class="margin-bottom mobile-left ellipsis-overflow">USED FOR: {{ ::credit.creditType }} {{ ::credit.referenceNote}}</div></div></td><td class="location-name hidden-xs">{{ credit.daysValid }} Days<br>{{ ::credit.startTime | localDate:\'MMM D YYYY\' }} - {{ credit.endTime | localDate:\'MMM D YYYY\' }}</td><td class="location-name hidden-xs">{{ credit.timeLeft | duration:false:true}}</td><td class="location-name hidden-xs" ng-if="credit.benefitType === 0">{{ credit.benefit.discountAmount | currency }} / {{ credit.benefit.remainingAmount | currency }}<br><a href="#" class="theme-link ng-hide" ng-click="vmList.refreshCredit(credit, $event)" ng-disabled="vmList.isRefreshing || credit.preventEditOrDelete" ng-show="!credit.isRefreshing" ng-attr-title="{{credit.preventEditOrDelete ? \'Unable to update credit. Please contact the RedCap Client Success Team for further assistance.\' : \'\'}}" ng-class="{ \'disabled\': credit.preventEditOrDelete}">Refresh</a> <img src="assets/images/ajax-loader.gif" class="ng-hide" ng-show="credit.isRefreshing"></td><td class="location-name hidden-xs" ng-if="credit.benefitType !== 0">{{ credit.benefit.numRides }} / {{ credit.benefit.remainingNumRides }} Rides<br><a href="#" class="theme-link ng-hide" ng-click="vmList.refreshCredit(credit, $event)" ng-disabled="vmList.isRefreshing || credit.preventEditOrDelete" ng-show="!credit.isRefreshing" ng-attr-title="{{credit.preventEditOrDelete ? \'Unable to update credit. Please contact the RedCap Client Success Team for further assistance.\' : \'\'}}" ng-class="{ \'disabled\': credit.preventEditOrDelete}">Refresh</a> <img src="assets/images/ajax-loader.gif" class="ng-hide" ng-show="credit.isRefreshing"></td><td class="location-name hidden-xs">{{ credit.status }}</td><td class="location-name hidden-xs">{{ ::credit.creditType }}<br>{{ ::credit.referenceNote}}</td><td class="location-name hidden-xs">{{ ::credit.issuedBy }}<br>{{ ::credit.dateCreated | date }}</td><td class="location-name hidden-xs"><span ng-if="credit.benefitType === 0">SIMPLE CREDIT</span> <span ng-if="credit.benefitType === 1">FIXED FARE</span> <span ng-if="credit.benefitType === 2">FIXED DISCOUNT</span> <span ng-if="credit.benefitType === 3">VARIABLE DISCOUNT</span> ({{ ::vmList.providerType(credit.rideProviderType) }})</td><td class="location-name hidden-xs" ng-if="vmList.filters.showBulkUpload">{{ ::credit.campaignId }}</td><td class="location-name hidden-xs" ng-if="vmList.filters.showBulkUpload">{{ ::credit.customerId }}</td><td ng-if="vmList.resolvedLocationList.length > 1" class="location-name hidden-xs">{{ ::credit.dealerName }}</td></tr></tbody></table><rc-list-standardized-footer record-count="vmList.filteredCredits.length" is-loading="vmList.isLoading" can-show-more="vmList.canShowMore"></rc-list-standardized-footer></div></div></div><fake-modal id="fake-modal" ng-if="vmList.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vmList.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md visible-xs visible-sm"><rc-list-mode-selector ng-model="vmList.parent_vm.selectedViewModeIcon" available-modes="vmList.parent_vm.availTripModes" css-class="rc-list-selector" on-select-event="vmList.tripListModeChanged()"></rc-list-mode-selector></div><div class="flex-width-300 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top" ng-if="vmList.isLocationListEmpty() === true"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><input type="text" name="search" class="form-control" placeholder="All locations" ng-model="vmList.noLocationsText"><div id="location-search-overlay" ng-click="vmList.getDealerLocations()" ng-if="vmList.isLocationListEmpty() === true"></div><img src="assets/images/ajax-loader.gif" class="ng-hide location-spinner" ng-show="vmList.loadingLocations"></div></div><div class="flex-width-300 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top" ng-if="vmList.isLocationListEmpty() === false && vmList.hasMultipleDealers === false"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><input id="location-filter" class="form-control better-placeholder" placeholder="All locations" type="text" ng-disabled="true" ng-model="vmList.singleLocation.name"></div></div><div class="flex-width-300 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md ng-hide" ng-show="vmList.isLocationListEmpty() === false && vmList.hasMultipleDealers === true"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><select select2="" id="location-filter-single-2" name="location-filter-single-2" on-change="vmList.selectSingleLocation(selectedResult)" placeholder="All locations" min-input-length="1" init-value="vmList.selectedSingleLocation" format-for-selection="vmList.formatLocationForSelection" format-for-dropdown="vmList.formatLocationForDropdown" query="vmList.locationSearchQuery" ng-model="vmList.selectedSingleLocationId"></select></div></div><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><input type="text" id="customer-search" name="customer-search" class="form-control" ng-model="vmList.filters.customerFilter" ng-keyup="$event.keyCode === 13 && vmList.customerFilterUpdated()" ng-disabled="vmList.isLoading" placeholder="CUSTOMER SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomerField()" ng-if="vmList.filters.customerFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md ng-hide" ng-show="vmList.showCalendar() === false"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm field-wrapper"><label for="dateRangeFilter">ISSUE DATE</label><select selectlabel="" id="dateRangeFilter-2" ng-disabled="vmList.isLoading" disable-search="true" class="form-control ng-show text-uppercase" name="dateRangeFilter" ng-model="vmList.filters.timeframeFilter" ng-change="vmList.listFilterChanged(true)" ng-options="t.value as t.text for t in vmList.timeframes"><option value="">All issue dates</option></select></div></div><div class="flex-width-300 flex-sm-percent-100 override-sm-margin-top-md override-xs-margin-top-md ng-hide" ng-show="vmList.showCalendar() === true && vmList.showAdvancedSearch"><div class="block relative"><input options="vmList.dateRangePickerOptions" date-range-picker="" id="timeframe_range-2" class="form-control date-picker" placeholder="CUSTOM TIMEFRAME" type="text" ng-model="vmList.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomTimeFrame()">close</span></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md override-sm-margin-top-none override-xs-margin-top-none"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-sm override-sm-margin-top-sm"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm field-wrapper"><label for="creditTypefilter">TYPE</label><select selectlabel="" class="form-control text-uppercase" name="creditTypeFilter" ng-model="vmList.filters.creditTypeFilter" ng-options="l.value as l.text for l in vmList.creditTypes" ng-change="vmList.listFilterChanged()"><option value="">All types</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm field-wrapper"><label for="statusFilter">STATUS</label><select selectlabel="" class="form-control text-uppercase" name="statusFilter" ng-model="vmList.filters.creditStatusFilter" ng-options="l.value as l.text for l in vmList.creditStatuses" ng-change="vmList.listFilterChanged()"><option value="">All statuses</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><input type="text" name="campaignIdFilter" ng-model="vmList.filters.campaignIdFilter" class="form-control" placeholder="CAMPAIGN ID" ng-keydown="vmList.handleConfirmKeypress($event)"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCampaignIdField()" ng-if="vmList.filters.campaignIdFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm"><input type="text" name="customerIdFilter" ng-model="vmList.filters.customerIdFilter" class="form-control" placeholder="CLIENT ID" ng-keydown="vmList.handleConfirmKeypress($event)"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearClientIdField()" ng-if="vmList.filters.customerIdFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative override-xs-padding-none override-sm-padding-none padding-right-sm padding-left-sm"><div><label class="display-flex content-center margin-bottom-none padding-right-md">SHOW EXPIRED/CANCELED</label></div><div><ul class="radios-list list-inline inline"><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.showExpired" ng-value="true" id="showExpiredFilter" name="showExpiredFilterRadio"> <span class="font-normal">&nbsp;YES</span></label></li><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.showExpired" selected="" ng-value="false" id="showExpiredFilter" name="showExpiredFilterRadio"> <span class="font-normal">&nbsp;NO</span></label></li></ul></div></div></div></div><div class="display-flex flex-row padding-bottom-lg"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left margin-top-md"><div class="block relative padding-right-sm"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vmList.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md"><rc-list-template-save-search-delete-btns list-controller="vmList" current-search-template="vmList.searchTemplateData.currentSearchTemplate" is-processing-template="vmList.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vmList.canManageGlobalTemplates" template-message="vmList.templateMessage" save-btn-clicked="vmList.saveBtnClicked()" save-as-btn-clicked="vmList.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vmList.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm" ng-click="vmList.clearFilters();vmList.close();">Reset Filters</div><button type="button" ng-click="vmList.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vmList.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/trip/views/trip-add.view.html','<div class="row display-flex full-width-height margin-none" id="tripSettingsForm"><div class="col-md-8 col-xs-12 border-radius-top-7 padding-none separate-left-aside-panel booking-content"><form role="form" name="tripSettingsForm" class="full-height" id="tripSettingsForm" autocomplete="off" ng-submit="vm.submitWizardForm(tripSettingsForm.$valid)" novalidate=""><div class="display-flex flex-column overflow-hidden full-height border-radius-top-7"><div class="display-flex content-center theme-bg"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-15 override-sm-padding-none">New Experience</div></div><div class="flex-percent-30 pull-right padding-right-md text-nowrap visible-xs visible-sm"><div id="enable-messages-link" class="theme-link pull-right padding-top-md padding-right-lg" ng-click="vm.enableMessaging(true)"><i class="material-icons md-24">forum</i></div></div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-none"><div id="trips-body" class="full-height padding-left-15 padding-right-sm padding-top-md margin-bottom-none"><uib-accordion close-others="true" class="trips-wizard transportation" ng-class="{\'auto-height\': vm.zipMarkers }"><div class="ng-hide" ng-show="vm.tripWizard.activeLocationList.length > 1 && !vm.isFramedIn()" ng-class="{\'hide-border\':vm.accordion.selectedStep == vm.accordion.steps.chooseLocation}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseLocation" is-disabled="true"><ng-include src="\'app/areas/trip/views/partials/add-new-choose-location.view.html\'" ng-controller="TripAddChooseLocationController as vmPnl"></ng-include></div></div><div class="ng-hide" ng-show="vm.accordion.selectedStep > vm.accordion.steps.chooseLocation && !vm.isFramedIn()" ng-class="{\'hide-border\':vm.accordion.selectedStep == vm.accordion.steps.chooseTripType || !vm.productGroupsConfigured}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseTripType" is-disabled="true"><ng-include src="\'app/areas/trip/views/partials/add-new-choose-triptype.view.html\'" ng-controller="TripAddChooseTripTypeController as vmTypePnl"></ng-include></div></div><div ng-if="vm.accordion.selectedStep > vm.accordion.steps.chooseTripType && vm.accordion.selectedStep != vm.accordion.steps.lyftCreditSettings" ng-class="{\'hide-border\':vm.accordion.selectedStep == vm.accordion.steps.tripSettings}"><div uib-accordion-group="" class="panel-default" is-disabled="true" is-open="vm.accordion.selectedStep == vm.accordion.steps.tripSettings"><ng-include src="\'app/areas/trip/views/partials/add-new-settings.view.html\'" ng-controller="TripAddSettingsController as vmSettingsPnl"></ng-include></div></div><div ng-if="vm.accordion.selectedStep > vm.accordion.steps.chooseTripType && vm.accordion.selectedStep == vm.accordion.steps.lyftCreditSettings" ng-class="{\'hide-border\':vm.accordion.selectedStep == vm.accordion.steps.lyftCreditSettings}"><div uib-accordion-group="" class="panel-default" is-disabled="true" is-open="true"><ng-include src="\'app/areas/trip/views/partials/add-new-settings-lyft-credit.view.html\'" ng-controller="LyftCreditAddController as vmSettingsPnl"></ng-include></div></div></uib-accordion></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2"><div class="row padding-md padding-right-md"><div class="display-flex flex-row overflow-hidden"><div class="flex-grow flex-percent-75"><div class="booking-btn-checkboxes inline ng-hide" ng-show="(vm.theTrip.showTripSettingsForm == true && vm.loanerCriteriaSelected() == true) || vm.accordion.selectedStep == vm.accordion.steps.lyftCreditSettings"><div class="row btn-checkbox-row"><div class="col-xs-1 margin-top-md sms-checkin-col padding-left-none"><input type="checkbox" class="checkbox" id="smsOptIn" ng-model="vm.theTrip.smsOptIn" required=""></div><div class="col-xs-11 margin-top-md padding-left-none text-left"><label for="smsOptIn" class="font-normal">I have confirmed my customer agrees to receive text messages about their vehicle service, and transportation. They understand they may receive several messages a day and can opt out at any time by replying STOP in their messaging app.</label></div></div><div class="row btn-checkbox-row" ng-if="vm.theTrip.selectedSystemTripType.supportsDMSApptPush && vm.bookingRules.dmsPushType === 2"><div class="col-xs-1 margin-top-sm sms-checkin-col padding-left-none"><input type="checkbox" class="checkbox" id="createDMSAppointment" ng-model="vm.serviceOrder.createDMSAppointment"></div><div class="col-xs-11 margin-top-sm padding-left-none text-left"><label for="createDMSAppointment" class="font-normal"><span ng-if="!vm.resolvedTrip">Add</span> <span ng-if="vm.resolvedTrip">Update</span> <span ng-if="!vm.bookingRules.isXTimeEnabled">DMS</span> <span ng-if="vm.bookingRules.isXTimeEnabled">XTime</span> Appointment</label></div></div></div></div><div class="flex-grow flex-percent-25 padding-right-md text-right"><div class="margin-bottom-sm" ng-if="vm.showLyftSandBoxDropdown()"><select class="form-control sandbox-options" id="lyft-sandbox-option" name="lyftSandBoxOption" allow-null-option="Standard Flow" ng-options="option as option.name for option in vm.lyftSandboxFlowTypes track by option.value" ng-model="vm.theTrip.lyftSandboxFlowType"></select></div><div class="text-nowrap margin-top-md padding-right-md"><div class="inline" data-toggle="tooltip" title="{{vm.getBookTooltip()}}"><button ng-if="vm.serviceOrder && !vm.invitationSent && vm.serviceOrder.action > 0 && (vm.displayBookItPanel() || vm.displayEmailSMSPanel())" type="submit" class="btn btn-primary margin-right-xs" ng-class="config.styleClass" ladda="vm.bookingTrip || vm.gettingFormattedMessage || vm.sendingFormattedMessage" ng-disabled="vm.theTrip.validatingTrip || vm.hasUnresolvedErrors() || vm.fieldsDisabled || tripSettingsForm.$invalid || vm.disableSMSSend() || vm.showRideProviderMessage"><span ng-if="vm.displayBookItPanel()"><span class="ng-hide" ng-show="vm.resolvedTrip">UPDATE</span> <span class="ng-hide" ng-show="!vm.resolvedTrip">BOOK</span></span><span ng-if="vm.displayEmailSMSPanel()">SEND</span></button></div><button ng-if="vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.lyftCredit" type="submit" class="btn btn-primary margin-right-xs" ng-class="config.styleClass" ladda="vm.sendingCredit" ng-disabled="vmSettingsPnl.isLoading || tripSettingsForm.$invalid">SEND</button> <button ng-if="!vm.resolvedTrip" type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="trip-list">CLOSE</button> <button ng-if="vm.resolvedTrip" type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ui-sref="trip-tab-trip({tripId: vm.resolvedTrip.id})"><span class="ng-hide" ng-show="vm.resolvedTrip">CANCEL</span></button></div></div></div></div></div></div></form></div><div id="appt-messages" class="col-md-4 col-xs-12 padding-none separate-right-aside-panel margin-left-md border-radius-top-7 tab-flex-container"><div class="border-radius-top-7 display-flex flex-column overflow-hidden full-height theme-bg"><div class="flex-fullwidth-20h border-radius-top-7 visible-xs visible-sm theme-bg padding-left-20 padding-right-md"><div class="display-flex content-center theme-bg padding-top-8"><div class="flex-percent-70 pull-left text-bold font-size-16 text-uppercase"><div class="padding-left-15 override-sm-padding-none">New Experience</div></div><div class="flex-percent-30 pull-right padding-right-md text-nowrap visible-xs visible-sm"><div id="disable-messages-link" class="theme-link pull-right padding-top-md padding-right-md" ng-click="vm.enableMessaging(false)"><i class="material-icons md-24">comments_disabled</i></div></div></div></div><div class="tab-inner-div border-radius-top-7"><rc-summary-message-tab trip="vm.theTrip" disable-notes-tab="0" mobile-class="vm.messagePanelMobileClass"></rc-summary-message-tab></div></div></div></div>');
$templateCache.put('app/areas/trip/views/trip-detail.view.html','<div class="row display-flex full-height margin-right-none" id="tripsummary-modal"><div class="col-md-8 col-xs-12 padding-right-none separate-left-aside-panel border-radius-top-7 bg-white"><div class="display-flex flex-column overflow-hidden full-height"><div class="flex-fullwidth-100h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><aside-header ng-if="vm.headerData" ng-model="vm.headerData"></aside-header></div><div id="trip-summary-body" class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-bottom"><div aside-parent="vm.childScopeForm"><div id="trip-detail-header" scrollable-tabs="" class="margin-none bg-white font-normal"><uib-tabset class="full-height invisible-tabs scrollable"><uib-tab ng-repeat="tab in vm.tabs" heading="{{tab.title}}" active="tab.active" ui-sref="{{tab.route}}" disable="tab.disabled"><span id="trip-detail-tabs" class="flex-fill padding" ui-view="{{tab.route}}"><div class="tab-loading-overlay"><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading...</div></div></div></span></uib-tab></uib-tabset></div></div></div><div class="flex-fullwidth-70h flex-wrap display-flex flex-row flex-sm-column content-center z-index-2 padding-right-md"><div class="flex-container-hide-empty display-flex flex-percent-40 full-width text-left"><div class="row tab-section trip-health-warning border-top-none" ng-if="vm.trip.dmsUpdateError"><div class="col-xs-12 padding-md icon"><i class="material-icons">warning</i> <b><span class="text-danger text-uppercase">WARNING:</span>&nbsp;{{ vm.trip.dmsUpdateError }}</b></div></div><div ng-if="vm.trip.health.status > vm.healthStatus.ok && ((vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete && vm.trip.health.status <= vm.healthStatus.driverNoLocation) || vm.trip.health.status > vm.healthStatus.driverNoLocation)" class="row tab-section trip-health-warning danger border-top-none"><div class="col-xs-12"><i class="material-icons">warning</i> <b><span class="text-danger text-uppercase">WARNING:</span>&nbsp;{{ vm.getStatusText(vm.trip.health.status, true) }}</b></div></div><div ng-if="vm.trip.state === vm.tripStates.canceled" class="row tab-section trip-health-warning danger border-top-none"><div class="col-xs-12" title="REASON: {{vm.trip.cancelReason}}"><i class="material-icons">event_busy</i><b>CANCELED BY <span ng-if="vm.trip.cancelled.lastName">{{ ::vm.trip.cancelled.firstName }} {{ ::vm.trip.cancelled.lastName }}</span><span ng-if="!vm.trip.cancelled.lastName">CUSTOMER</span></b></div></div><div class="pull-left inline padding-top-md padding-left-md" ng-if="vm.cancellingTrip">Cancelling...&nbsp;&nbsp;</div><div class="pull-left inline padding-top-md padding-left-md" ng-if="vm.routingToAppt">Going to Appointment...&nbsp;&nbsp;</div></div><div class="flex-grow flex-percent-60 full-width text-right padding-right-md"><button type="button" ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.systemTripTypeId === vm.shortSystemTripType.pickup" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.bookReturnClicked()" ladda="vm.rebookingTrip"><span class="hidden-xs padding-right-sm margin-right-xs">BOOK</span>RETURN</button> <button type="button" ng-if="vm.trip.canEdit == true" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.editTripClicked()" ladda="vm.routingToAppt" ng-disabled="vm.cancellingTrip || vm.routingToAppt">EDIT<span class="hidden-xs padding-left-sm">TRIP</span></button> <button type="button" ng-if="vm.trip.canCancel == true" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.cancelTripClicked()" ladda="vm.cancellingTrip || vm.routingToAppt">CANCEL<span class="hidden-xs padding-left-sm">TRIP</span></button> <button type="button" ng-if="vm.trip.state === vm.tripStates.canceled" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.rebookClicked()" ladda="vm.rebookingTrip">REBOOK</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="trip-list">CLOSE</button></div></div></div></div><div id="trips-messaging" class="col-md-4 col-xs-12 margin-left-md border-radius-top-7 separate-right-aside-panel message-component-rail flex-grow padding-none overflow-y-hidden"><div class="display-flex flex-column overflow-hidden full-height white-bg"><div class="flex-fullwidth-70h visible-xs visible-sm padding theme-bg"><aside-header ng-if="vm.headerData" ng-model="vm.headerData"></aside-header></div><rc-summary-message-tab trip="vm.trip" disable-notes-tab="0" active-tab="vm.activeMessageTab" mobile-class="vm.messagePanelMobileClass"></rc-summary-message-tab></div></div></div>');
$templateCache.put('app/areas/trip/views/trip-list-tab-calendar.view.html','<div class="row"><div id="timelineContainer" google-chart="" chart="vm.calendarData" agc-on-ready="vm.calendarData.methods.ready(chartWrapper)" agc-on-select="vm.calendarData.methods.select(selectedItem, chart)" class="timeline trip" ng-style="vm.calendarHeight"></div></div>');
$templateCache.put('app/areas/trip/views/trip-list-tab-cards.view.html','<div ng-show="!vm.filteredTrips"><br><br>Loading ...</div><div infinite-scroll="vm.displayMore()" infinite-scroll-distance="2" class="row card-list"><div class="col-sm-6 col-md-3 col-lg-3" ng-repeat="data in vm.filteredTrips | limitTo: vmList.displayLimit track by data.id"><div ui-sref="trip-detail({tripId: data.id})" class="card-item"><div class="map-img" ng-style="{ \'background-image\': \'url(\' + data.tripMapUrl + \')\' }"></div><div class="padding-lg"><div><h3>{{data.typeName}}</h3></div><div ng-if="data.pickUpTime"><strong>Pick Up:</strong> {{data.pickUpTime | timeOfDay}}</div><div><strong>Customer:</strong> {{data.customerName}}</div><div><div ng-if="data.apptDate"><strong>{{data.isDMSImported ? \'DMS \' : \'\'}}Appt:</strong> {{data.apptDate | date:\'short\' }}</div><div ng-if="!data.apptDate"><strong>RO Number:</strong> {{data.roNumber}}</div></div><div class="margin-top-20"><strong>Now:</strong> {{data.stateName}}</div><div ng-if="data.departBy">Departing {{data.departBy | timeOfDay}}</div><div class="row margin-top-20 clear"><img class="col-sm-3 img-circle" ng-title="{{data.driver.name}}" ng-src="{{data.driverPhoto}}"><div ng-if="data.driver.id" class="col-sm-8 margin-top-md"><div><strong>{{data.driver.name}}</strong> <a ng-if="data.canRemoveDriver" ng-click="vm.unassignDriver(data)">(remove)</a></div><div>{{data.driver.mobilePhone | tel}}</div></div><div ng-if="!data.driver.id" class="col-sm-8 margin-top-md"><select class="form-control" name="driverSelect" allow-null-option="Not Assigned..." ng-change="vm.assignDriver(data)" ng-model="data.driver" ng-options="driver as driver.name for driver in vm.availableDrivers"></select></div></div></div><div class="card-item-footer clear"><span class="label pull-left" ng-class="{\'label-success\': data.status === 1, \'label-warning\':data.status === 2, \'label-danger\': data.status === 3}">{{vm.getStatusText(data.status)}}</span><div class="pull-right"><a href="#" class="padding-right-md"><strong>Open</strong></a> <a href="#"><strong>Cancel</strong></a></div></div></div></div></div>');
$templateCache.put('app/areas/trip/views/trip-list-tab-opportunities.view.html','<div class="table-responsive"><table class="table footable table-hover" infinite-scroll="vm.displayMore()" infinite-scroll-distance="2"><thead><tr><th data-toggle="true">Status</th><th data-toggle="true">State</th><th data-toggle="true">Type</th><th data-toggle="true">Assignee/Driver</th><th data-toggle="true">Customer</th><th data-toggle="true">Pick Up</th><th data-toggle="true">Location</th></tr></thead><tbody><tr ng-repeat="data in vm.filteredTrips | limitTo: vmList.displayLimit track by data.id" class="list-name" ui-sref="trip-tab-general({tripId: data.id})"><td><span class="label" ng-class="{\'label-success\': data.status === 1, \'label-warning\':data.status === 2, \'label-danger\': data.status === 3}">{{vm.getStatusText(data.status)}}</span></td><td><div><strong>{{data.stateName}}</strong></div><span ng-if="data.departBy">departing {{data.departBy | timeOfDay}}</span></td><td><div><strong>{{data.typePrimary}}</strong></div><div>{{data.typeSecondary}}</div></td><td class="user-profile-pic"><img class="img-circle" ng-src="{{data.serviceAdvisorPhoto}}" ng-attr-title="{{data.dealer.serviceAdvisorName}}"> <img class="img-circle" ng-src="{{data.driver.driverPhoto}}" ng-attr-title="{{data.driver.name}}"></td><td><div><strong>{{data.customerName}}</strong></div><div ng-if="data.apptDate">{{data.isDMSImported ? \'DMS \' : \'\'}}Appt: {{data.apptDate | date:\'short\'}}</div><div ng-if="!data.apptDate">RO Number: {{data.roNumber}}</div></td><td><div><strong>{{data.pickupDay}}</strong></div><div>{{data.pickupTime}}</div></td><td><div><strong>{{data.dealer.name}}</strong></div><span>{{data.dealer.phoneNumber | tel}}</span></td></tr></tbody></table></div>');
$templateCache.put('app/areas/trip/views/trip-list-tab-trips.view.html','<div class="table-responsive"><table class="table footable table-hover" infinite-scroll="vm.displayMore()" infinite-scroll-distance="2"><thead><tr><th data-toggle="true">Status</th><th data-toggle="true">State</th><th data-toggle="true">Type</th><th data-toggle="true">Assignee/Driver</th><th data-toggle="true">Customer</th><th data-toggle="true">Pick Up</th><th data-toggle="true">Location</th></tr></thead><tbody><tr ng-repeat="data in vm.filteredTrips | limitTo: vmList.displayLimit track by data.id" class="list-name" ui-sref="trip-tab-general({tripId: data.id})"><td><span class="label" ng-class="{\'label-success\': data.status === 1, \'label-warning\':data.status === 2, \'label-danger\': data.status === 3}">{{vm.getStatusText(data.status)}}</span></td><td><div><strong>{{data.stateName}}</strong></div><span ng-if="data.departBy">departing {{data.departBy | timeOfDay}}</span></td><td><div><strong>{{data.typePrimary}}</strong></div><div>{{data.typeSecondary}}</div></td><td class="user-profile-pic"><img class="img-circle" ng-src="{{data.serviceAdvisorPhoto}}" ng-attr-title="{{data.dealer.serviceAdvisorName}}"> <img class="img-circle" ng-src="{{data.driver.driverPhoto}}" ng-attr-title="{{data.driver.name}}"></td><td><div><strong>{{data.customerName}}</strong></div><div ng-if="data.apptDate">{{data.isDMSImported ? \'DMS \' : \'\'}}Appt: {{data.apptDate | date:\'short\'}}</div><div ng-if="!data.apptDate">RO Number: {{data.roNumber}}</div></td><td><div><strong>{{data.pickupDay}}</strong></div><div>{{data.pickupTime}}</div></td><td><div><strong>{{data.dealer.name}}</strong></div><span>{{data.dealer.phoneNumber | tel}}</span></td></tr></tbody></table></div>');
$templateCache.put('app/areas/trip/views/trip-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="trips" class="trip-list panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none" ng-class="{\'display-map\' : vmList.displayMap, \'dispatching-view\': vmList.isDispatchList() === true}"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-column"><div class="display-flex flex-row full-width"><div class="flex-percent-50 hidden-sm hidden-xs"><rc-list-mode-selector ng-model="vmList.parent_vm.selectedViewModeIcon" available-modes="vmList.parent_vm.availTripModes" css-class="rc-list-selector" on-select-event="vmList.tripListModeChanged()"></rc-list-mode-selector></div><div class="flex-sm-percent-60 flex-xs-percent-60 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative padding-right-sm padding-left override-xs-padding-none override-sm-padding-none" ng-if="vmList.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vmList.searchTemplateData.currentSearchTemplate" search-templates="vmList.searchTemplateData.searchTemplates" on-select-event="vmList.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 visible-xs visible-sm"><rc-list-advanced-filter-toggle filter-count="vmList.filterCount" filter-message="vmList.filterMessage" record-count="vmList.totalTripCount" toggle-advanced-search="vmList.toggleShowSearchOptions()" reset-filters="vmList.clearFilters()" align-right="true" search-tray-displayed="vmList.showAdvancedSearch"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm" ng-if="!vmList.showAdvancedSearch"><a ng-if="!vmList.parent_vm.isFramedIn()" id="new-trip" ng-click="vmList.addNew()" class="margin-left-md visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row full-width visible-xs visible-sm margin-top-sm"><div class="flex-sm-percent-100 flex-xs-percent-60 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative"><input type="text" name="search" class="form-control better-placeholder" ng-model="vmList.filters.keywordFilter" ng-keyup="$event.keyCode === 13 && vmList.keywordFilterUpdated()" ng-blur="vmList.keywordFilterUpdated()" ng-disabled="vmList.isLoading" placeholder="SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearKeywordField()" ng-if="vmList.filters.keywordFilter">close</span></div></div></div></div><div class="display-flex flex-column full-width"><div class="display-flex flex-row flex-sm-column hidden-xs hidden-sm"><div class="flex-width-200"><div class="block relative padding-right-sm padding-left override-xs-padding-none override-sm-padding-none" ng-if="vmList.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vmList.searchTemplateData.currentSearchTemplate" search-templates="vmList.searchTemplateData.searchTemplates" on-select-event="vmList.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-350 flex-grow max-width-px-400 hidden-xs hidden-sm" ng-if="vmList.showFakeLocationInput()"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent override-xs-margin-top-none override-sm-margin-top-none"><input type="text" name="search" class="form-control better-placeholder" id="location-search" placeholder="All locations" ng-model="vmList.noLocationsText" ng-disabled="vmList.filters.locationFilter.length > 1"><div id="location-search-overlay" ng-click="vmList.getDealerLocations()" ng-if="vmList.isLocationListEmpty() === true"></div><img src="assets/images/ajax-loader.gif" class="ng-hide location-spinner" ng-show="vmList.loadingLocations"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearAllLocations()" ng-if="vmList.filters.locationFilter && vmList.filters.locationFilter.length > 1">close</span></div></div><div class="flex-width-350 flex-grow max-width-px-400 hidden-xs hidden-sm" ng-show="(vmList.isLocationListEmpty() === false && !vmList.filters.singleLocationSelected) && vmList.hasMultipleDealers === false"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input id="location-filter" class="form-control better-placeholder" placeholder="All locations" type="text" ng-disabled="true" ng-model="vmList.filters.singleLocation.name"></div></div><div class="flex-width-350 flex-grow max-width-px-400 hidden-xs hidden-sm" ng-if="vmList.isLocationListEmpty() === false || vmList.filters.singleLocation" ng-show="(vmList.isLocationListEmpty() === false || vmList.filters.singleLocation) && vmList.hasMultipleDealers === true && vmList.filters.locationFilter.length < 2"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none override-xs-margin-top-none override-sm-margin-top-none"><select select2="" id="location-filter-single" name="location-filter-single" on-change="vmList.selectSingleLocation(selectedResult)" placeholder="All locations" min-input-length="1" init-value="vmList.selectedSingleLocationId" format-for-selection="vmList.formatLocationForSelection" format-for-dropdown="vmList.formatLocationForDropdown" query="vmList.locationSearchQuery" ng-model="vmList.selectedSingleLocationId"></select></div></div><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative"><input type="text" name="search" class="form-control better-placeholder" ng-model="vmList.filters.keywordFilter" ng-keyup="$event.keyCode === 13 && vmList.keywordFilterUpdated()" ng-blur="vmList.keywordFilterUpdated()" ng-disabled="vmList.isLoading" placeholder="Search"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearKeywordField()" ng-if="vmList.filters.keywordFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top-md override-xs-margin-top-md" ng-hide="vmList.showCalendar() === true"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="dateRangeFilter1">Timeframe</label><select selectlabel="" id="dateRangeFilter1" ng-disabled="vmList.isLoading" disable-search="true" class="form-control ng-show" name="dateRangeFilter1" ng-model="vmList.filters.timeframeFilter" ng-change="vmList.timeframeChanged(t)" ng-options="t.value as t.text for t in vmList.timeframes"><option value="">Timeframe</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top-md override-xs-margin-top-md" ng-hide="vmList.showCalendar() === false"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input options="vmList.dateRangePickerOptions" date-range-picker="" id="timeframe_range" class="form-control date-picker" placeholder="Custom timeframe" type="text" ng-model="vmList.filters.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomTimeFrame()">close</span></div></div><div class="flex-width-120 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vmList.filterCount" filter-message="vmList.filterMessage" record-count="vmList.totalTripCount" toggle-advanced-search="vmList.toggleShowSearchOptions()" reset-filters="vmList.clearFilters()"></rc-list-advanced-filter-toggle></div></div><div class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters filter-count="vmList.filterCount" record-count="vmList.totalTripCount" filter-message="vmList.filterMessage"></rc-list-mobile-filters></div></div><div class="display-flex flex-column hidden-sm hidden-xs"><div class="display-flex flex-row"><div class="flex-width-200 text-nowrap display-flex content-center"><span id="download_btn_container" ng-click="vmList.downloadInvoices()" ng-if="vmList.selectedInvoices.length && vmList.parent_vm.transportationViewMode === vmList.viewModes.trip_list_no_map"><i class="invoice-download material-icons md-18 link" title="Download Invoices">download</i></span> <span id="refresh-countdown" ng-if="vmList.isDispatchList() === true && vmList.autoRefresh">{{ vmList.refreshCountdown }}</span><switch class="green margin-top-sm" ng-if="vmList.isDispatchList() === true" id="toggle-auto-refresh" name="toggleAutoRefresh" ng-model="vmList.autoRefresh" ng-change="vmList.toggleAutoRefresh()" title="Auto Refresh"></switch><a ng-if="!vmList.parent_vm.isFramedIn()" id="new-trip" ng-click="vmList.addNew()" title="Add New" class="btn btn-primary margin-left-md new-btn hidden-xs hidden-sm" ng-class="config.styleClass">+ NEW</a></div></div></div></div></div><div ng-if="vmList.displayMap" class="padding-right-20 overflow-hidden flex-grow flex-percent-90 text-uppercase hidden-xs hidden-sm" ng-click="vmList.getMapDetails()"><div class="display-flex flex-row full-width-height border-bottom"><div class="display-flex flex-percent-100"><div class="padding-none trips-list-row full-width-height white-bg sort-by"><div uib-collapse="vmList.sortExpanded" class="navbar-collapse margin-none" id="search-sort" aria-expanded="false"><ul id="trip-list-sort" class="margin-top nav navbar-nav white-bg"><li><a class="margin-left-none padding-left-none"><strong>Sort by:</strong></a></li><li class="dropdown ellipsis-overflow" ng-class="{\'selected\': vmList.sortData.sortBy === vmList.sortByType.customerArrival }"><a aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.customerArrival)" class="dropdown-toggle bold padding-bottom-none" data-toggle="dropdown">Customer Arrival<i class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></a></li><li class="dropdown ellipsis-overflow" ng-class="{\'selected\': vmList.sortData.sortBy === vmList.sortByType.lastStop }"><a aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.lastStop)" class="dropdown-toggle bold padding-bottom-none" data-toggle="dropdown">Last Stop <i class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></a></li><li class="dropdown ellipsis-overflow" ng-class="{\'selected\': vmList.sortData.sortBy === vmList.sortByType.firstStop }"><a aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.firstStop)" class="dropdown-toggle bold padding-bottom-none" data-toggle="dropdown">First Stop <i class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></a></li><li class="dropdown ellipsis-overflow" ng-class="{\'selected\': vmList.sortData.sortBy === vmList.sortByType.bookedBy }"><a aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.bookedBy)" class="dropdown-toggle bold padding-bottom-none" data-toggle="dropdown">Booked by <i class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></a></li><li class="dropdown ellipsis-overflow" ng-class="{\'selected\': vmList.sortData.sortBy === vmList.sortByType.status }"><a aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.status)" class="dropdown-toggle bold padding-bottom-none" data-toggle="dropdown">Status <i class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></a></li><li class="dropdown ellipsis-overflow" ng-class="{\'selected\': vmList.showingAlerts }"><a aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.alerts)" class="dropdown-toggle bold padding-bottom-none" data-toggle="dropdown">Alerts</a></li></ul></div></div></div></div><div class="display-flex flex-row full-width-height"><div class="display-flex flex-percent-50"></div><div id="map-size-reference" class="display-flex flex-percent-50"></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" ng-if="vmList.parent_vm.transportationViewMode === vmList.viewModes.trip_list_no_map" id="trips-table-container"><table id="trips-table" class="no-map table table-hover table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll="vmList.displayMore()" infinite-scroll-container="\'#trips-table-container\'" infinite-scroll-distance="2" infinite-scroll-disabled="vmList.isLoadingMore || !vmList.canLoadMore" infinite-scroll-immediate-check="false"><thead class="hidden-xs"><tr class="text-uppercase"><th class="invoice xxs-col hidden-xs" ignore-sort=""><i class="invoice-download material-icons md-14">cloud_download</i></th><th class="health small-col hidden-xs" ignore-sort="">&nbsp;</th><div class="dropdown ellipsis-overflow"><th aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.customerName)" class="dropdown-toggle sortable bold" data-toggle="dropdown">Customer <i ng-if="vmList.sortData.sortBy === vmList.sortByType.customerName" class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></th></div><div class="dropdown ellipsis-overflow"><th aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.tripType)" class="dropdown-toggle sortable bold" data-toggle="dropdown">Type <i ng-if="vmList.sortData.sortBy === vmList.sortByType.tripType" class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></th></div><div class="dropdown ellipsis-overflow"><th aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.customerArrival)" class="dropdown-toggle sortable bold" data-toggle="dropdown">Route Times <i ng-if="vmList.sortData.sortBy === vmList.sortByType.customerArrival" class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></th></div><div class="dropdown ellipsis-overflow"><th aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.driver)" class="dropdown-toggle sortable bold" data-toggle="dropdown">Driver <i ng-if="vmList.sortData.sortBy === vmList.sortByType.driver" class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></th></div><div class="dropdown ellipsis-overflow"><th aria-expanded="false" role="button" href="#" ng-click="vmList.sortBy(vmList.sortByType.bookedBy)" class="dropdown-toggle sortable bold" data-toggle="dropdown">Booked By <i ng-if="vmList.sortData.sortBy === vmList.sortByType.bookedBy" class="fa bold" ng-class="{\'fa-angle-up\' : vmList.sortData.sortDirection === \'desc\', \'fa-angle-down\' : vmList.sortData.sortDirection === \'asc\'}"></i></th></div></tr></thead><tbody><tr ng-repeat="data in vmList.filteredTrips track by data.id" class="list-name text-uppercase" ng-init="$last && finished()" id="{{data.id}}" ng-if="vmList.filteredTrips && vmList.filteredTrips.length > 0"><td class="align-middle hidden-xs xxs-col"><i class="material-icons invoice-checkbox md-14" ng-click="vmList.toggleInvoice(data)" title="Download Invoice">{{!data.invoiceChecked ? \'check_box_outline_blank\' : \'check_box\'}}</i></td><td class="health small-col align-middle hidden-xs cursor-pointer" ng-click="vmList.openTrip(data.id, $event)"><span ng-if="::data.badgeText" class="trip-type-badge trip-type-badge-black">{{::data.badgeText}}</span> <span ng-if="::data.icon" class="trip-type-badge trip-type-icon"><img ng-src="{{ ::data.icon}}"></span> <i class="list-dot material-icons theme-link" ng-if="!data.isComplete && data.health.status > vmList.healthStatus.ok && data.health.status <= vmList.healthStatus.driverNoLocation" title="{{ ::data.health.reason }}">warning</i> <i ng-if="data.state == 12" class="list-dot material-icons footer-info danger" title="CANCELED BY {{ ::data.cancelled.firstName || \'CUSTOMER\' }} {{ ::data.cancelled.lastName }} REASON: {{ ::data.cancelReason }}">event_busy</i> <i class="list-dot material-icons footer-info danger" ng-if="data.duplicateTripIds && data.duplicateTripIds.length" title="POSSIBLE DUPLICATE TRIP OF #{{data.duplicateTripIds.join(\', #\')}}">warning</i></td><td class="data align-middle cursor-pointer" ng-click="vmList.openTrip(data.id, $event)"><div class="line-height-18"><div class="visible-xs-inline ellipsis-overflow float-right text-normal-case">{{ ::data.customerExpectedTime | date:\'h:mm a on M/d\' }}<br></div><div class="customer-name"><strong>{{ ::data.customerName}}</strong></div><div class="mobile-left-text visible-xs">{{ ::data.typeName}}</div><div class="mobile-left-text visible-xs">#{{ ::data.id}}</div><div class="hidden-xs">{{::data.customerPhone | tel }}</div><div class="hidden-xs">{{::data.vehicle.year }} {{ ::data.vehicle.make }} {{::data.vehicle.model }}</div><span class="visible-xs-inline mobile-badge-container"><i class="list-dot material-icons theme-link" ng-if="!data.isComplete && data.health.status > vmList.healthStatus.ok && data.health.status <= vmList.healthStatus.driverNoLocation" title="{{ ::data.health.reason }}">warning</i> <i ng-if="data.state == 12" class="list-dot material-icons footer-info danger" title="CANCELED BY {{ ::data.cancelled.firstName || \'CUSTOMER\' }} {{ ::data.cancelled.lastName }} REASON: {{ ::data.cancelReason }}">event_busy</i> <i class="list-dot material-icons footer-info danger" ng-if="data.duplicateTripIds && data.duplicateTripIds.length && !(!data.isComplete && data.health.status > vmList.healthStatus.ok && data.health.status <= vmList.healthStatus.driverNoLocation)" title="POSSIBLE DUPLICATE TRIP OF #{{data.duplicateTripIds.join(\', #\')}}">warning</i> <span ng-if="::data.badgeText" class="trip-type-badge trip-type-badge-black">{{::data.badgeText}}</span> <span ng-if="::data.icon" class="trip-type-badge trip-type-icon"><img ng-src="{{ ::data.icon}}"></span></span><div class="info-block trip-circles visible-xs-block"><trip-circles stops="data.stops" current-step="data.currentStep" state="data.state" trip-type="data.systemTripTypeId"></trip-circles></div></div></td><td class="data align-middle hidden-xs cursor-pointer" ng-click="vmList.openTrip(data.id, $event)"><div><strong>{{ ::data.workflowName}}</strong></div><div class="text-wrap line-height-18">#{{ ::data.id }} <span>{{ ::data.customerExpectedTime | date:\'EEE, MMM dd h:mma\' }}</span> <span>{{ ::(data.systemTripTypeId == 1 && data.dmsImported === true) ? (\'DMS Appt \' + data.apptTime | date: \'MMM dd h:mma\') : data.roNumber ? vmList.getRODisplayText(data) : \'\'}}</span></div></td><td class="times hidden-xs" ng-click="vmList.openTrip(data.id, $event)"><div class="info-block trip-circles"><trip-circles stops="data.stops" current-step="data.currentStep" trip-type="data.systemTripTypeId" state="data.state"></trip-circles></div></td><td class="driver data hidden-xs align-middle cursor-pointer" ng-click="vmList.openTrip(data.id, $event)"><table><tr><td><div class="img-xs img-xs-square spinner driver-photo new-trip-list" afkl-lazy-image="{{ ::data.driver.driverPhoto }}" afkl-lazy-image-options="{imgAttrs: [{class: \'img-xs img-xs-square\'}], \'nolazy\': true }" lazy-load-fail="assets/images/user-square.png"></div></td><td><strong>{{ ::data.driver.name.split(\' \')[0] }}</strong><div ng-if="::!data.lyftVehicle">&nbsp;</div><div ng-if="::data.lyftVehicle"><div>{{ ::data.lyftVehicle.make}} {{ ::data.lyftVehicle.model }}</div><div>{{ ::data.lyftVehicle.color }}<span ng-if="::data.lyftVehicle.licensePlate">| {{ ::data.lyftVehicle.licensePlate }}</span></div></div></td></tr></table></td><td class="data hidden-xs align-middle cursor-pointer" ng-click="vmList.openTrip(data.id, $event)"><div class="font-bold line-height-18"><span ng-if="::(data.created && data.created.firstName)">{{::data.created.firstName }} {{ ::data.created.lastName}}</span> <span ng-if="::(!data.created || !data.created.firstName)">{{::data.bookingSource }}</span></div><div class="line-height-18">{{ ::data.dealer.name }}</div></td></tr></tbody></table><rc-list-standardized-footer record-count="vmList.filteredTrips.length" is-loading="vmList.isLoadingMore || vmList.isLoading" can-show-more="vmList.canLoadMore"></rc-list-standardized-footer></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" ng-if="vmList.isDispatchList() === true" id="dispatch-table-container"><table id="dispatch-table" class="table table-hover table-layout-fixed fixed-header-table border-bottom no-map dispatch-list" infinite-scroll-container="\'#dispatch-table-container\'" infinite-scroll="vmList.displayMore()" infinite-scroll-distance="2" infinite-scroll-disabled="vmList.isLoadingMore || !vmList.canLoadMore" infinite-scroll-immediate-check="false" redcap-sort="true"><thead class="hidden-xs"><tr class="text-uppercase"><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.tripId)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.tripId }" class="small-col cursor-pointer text-nowrap line-height-18 sortable sort-{{vmList.getDispatchSortDir()}}" title="Trip ID">Trip ID</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.pickupTime)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.pickupTime }" class="times text-nowrap line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Pickup">Pickup</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.customerEta)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.customerEta }" class="cursor-pointer times clip-overflow line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Cust ETA">Cust ETA</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.dateCreated)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.dateCreated }" class="cursor-pointer times text-nowrap line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Created">Created</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.status)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.status }" class="cursor-pointer text-nowrap line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Status">Status</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.account)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.account }" class="cursor-pointer line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Account">Account</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.tripType)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.tripType }" title="Trip Type" class="cursor-pointer condenseable line-height-18 no-wrap hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}">Trip Type</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.driver)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.driver }" class="small-col cursor-pointer line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Driver">Driver</th><th class="xxs-col hidden-xs line-height-18 hidden-xs hidden-sm" title="Company">CO</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.driverCell)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.driverCell }" class="clip-overflow cursor-pointer line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Driver Cell">Driver Cell</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.customerName)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.customerName }" class="cursor-pointer clip-overflow line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Customer">Customer</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.pickupAddress)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.pickupAddress }" class="cursor-pointer clip-overflow line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="P/U Address">P/U Address</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.pickupCity)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.pickupCity }" class="cursor-pointer clip-overflow line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="P/U City">P/U City</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.state)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.state }" class="xs-col cursor-pointer text-nowrap line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="State">State</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.estPay)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.estPay }" class="xs-col cursor-pointer clip-overflow line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Est Pay">Est Pay</th><th data-toggle="true" ng-click="vmList.setDispatchSort(vmList.dispatchSortTypes.estCharge)" ng-class="{\'active\': vmList.dispatchSortType === vmList.dispatchSortTypes.estCharge }" class="xs-col cursor-pointer clip-overflow line-height-18 hidden-xs hidden-sm sortable sort-{{vmList.getDispatchSortDir()}}" title="Est Chg">Est Chg</th><th class="hidden-xs pointer-none line-height-18 hidden-xs hidden-sm" title="Logistic">Logistic</th></tr></thead><tbody><tr ng-repeat="data in vmList.filteredTrips track by data.id" class="list-name text-uppercase" ng-init="$last && finished()" id="{{data.id}}" ng-if="vmList.filteredTrips && vmList.filteredTrips.length > 0" ng-click="vmList.openTrip(data.id, $event)"><td class="small-col"><span class="hidden-xs hidden-sm">{{ data.id }}</span><div class="visible-xs visible-sm margin-top-md margin-bottom-md"><div class="margin-top-sm"><b>Trip ID</b>: {{ data.id }}</div><div class="margin-top-sm"><b>Pickup</b>: {{ data.expectedStartTime | date:\'MMM dd @ h:mma\' }}</div><div class="margin-top-sm"><b>Cust ETA</b>: {{ data.customerExpectedTime | date:\'MMM dd @ h:mma\' }}</div><div class="margin-top-sm"><b>Created</b>: {{ data.dateCreated | date:\'MMM dd @ h:mma\' }}</div><div class="margin-top-sm"><b>Status</b>: {{ data.stateName }}</div><div class="margin-top-sm"><b>Account</b>: <i ng-if="data.dealer.isAtRisk" title="High Risk Location" class="material-icons color-primary font-bold font-size-16 cursor-default margin-right-sm">error_outline</i> <span ng-class="{\'at-risk-dealer\': data.dealer.isAtRisk}">{{ data.dealer.name }}</span></div><div class="margin-top-sm"><b>Trip Type</b>: {{ data.workflowName }}</div><div class="margin-top-sm"><b>Driver</b>: {{data.driver.name}}</div><div class="margin-top-sm"><b>Driver Company</b>: {{ data.driver.company.companyNameShort }}</div><div class="margin-top-sm"><b>Driver Cell</b>: {{ data.driver.mobilePhone|tel }}</div><div class="margin-top-sm"><b>Customer</b>: {{ data.customerName }}</div><div class="margin-top-sm"><b>P/U Address</b>: {{ data.customerAddress.streetAddress }}</div><div class="margin-top-sm"><b>P/U City</b>: {{ data.customerAddress.city }}</div><div class="margin-top-sm"><b>P/U State</b>: {{ data.customerAddress.state }}</div><div class="margin-top-sm"><b>Est Pay</b>: {{ data.estimatedDriverPay | currency }}</div><div class="margin-top-sm"><b>Est Chg</b>: {{ data.estimatedCustomerCharge | currency }}</div><div class="margin-top-sm"><b>Logistic</b>: {{ data.logisticNote }}</div></div></td><td class="clip-overflow hidden-xs hidden-sm">{{ data.expectedStartTime | date:\'MMM dd @ h:mma\' }}</td><td class="clip-overflow hidden-xs hidden-sm">{{ data.customerExpectedTime | date:\'MMM dd @ h:mma\' }}</td><td class="clip-overflow hidden-xs hidden-sm">{{ data.dateCreated | date:\'MMM dd @ h:mma\' }}</td><td class="small-col ellipsis-overflow hidden-xs hidden-sm" title="{{ data.stateName }}">{{ data.stateName }}</td><td class="hidden-xs hidden-sm" title="{{ data.dealer.name }}"><i ng-if="data.dealer.isAtRisk" title="High Risk Location" class="material-icons color-primary font-bold font-size-16 cursor-default margin-right-sm">error_outline</i> <span ng-class="{\'at-risk-dealer\': data.dealer.isAtRisk}">{{ data.dealer.name }}</span></td><td class="condenseable ellipsis-overflow hidden-xs hidden-sm" title="{{ data.workflowName }}">{{ data.workflowName }}</td><td class="small-col condenseable clip-overflow hidden-xs hidden-sm" title="{{ data.driver.name }}"><driver-name driver="data.driver"></driver-name></td><td class="xxs-col hidden-xs hidden-sm">{{ data.driver.company.companyNameShort }}</td><td class="clip-overflow hidden-xs hidden-sm">{{ data.driver.mobilePhone|tel }}</td><td class="clip-overflow hidden-xs hidden-sm" title="{{ data.customerName }}">{{ data.customerName }}</td><td class="hidden-xs hidden-sm" title="{{ data.customerAddress.streetAddress }}">{{ data.customerAddress.streetAddress }}</td><td class="hidden-xs hidden-sm">{{ data.customerAddress.city }}</td><td class="xs-col hidden-xs hidden-sm">{{ data.customerAddress.state }}</td><td class="xs-col hidden-xs hidden-sm">{{ data.estimatedDriverPay | currency }}</td><td class="xs-col hidden-xs hidden-sm">{{ data.estimatedCustomerCharge | currency }}</td><td class="hidden-xs hidden-sm" title="{{ data.logisticNote }}">{{ data.logisticNote }}</td></tr></tbody></table><rc-list-standardized-footer record-count="vmList.filteredTrips.length" is-loading="vmList.isLoadingMore || vmList.isLoading" can-show-more="vmList.canLoadMore"></rc-list-standardized-footer></div><div class="overflow-hidden flex-grow flex-percent-90 list-table-wrapper" ng-if="vmList.parent_vm.transportationViewMode === vmList.viewModes.trip_list_with_map"><div class="display-flex flex-row full-width-height"><div class="display-flex flex-grow flex-percent-50 overflow-y-auto" id="trip-content"><div class="trip-scrollable full-width" afkl-image-container=""><div id="trip-list-items" class="trip-list table-hover" infinite-scroll="vmList.displayMore()" infinite-scroll-distance="2" infinite-scroll-container="\'#trip-content\'" ng-show="!vmList.showSearchOptions"><div ng-if="vmList.filteredTrips && vmList.filteredTrips.length > 0" class="display-flex flex-row row text-uppercase list-name full-width" ng-class="{\'selected\' : vmList.isHighlightedRow(this)}" ng-repeat="data in vmList.filteredTrips track by data.id" ng-click="vmList.getMapDetails(data, this)" ng-init="$last && finished()" id="{{::data.id}}"><div id="trips-table" class="visible-xs-block full-width padding-md" ui-sref="trip-tab-trip({ tripId: {{::data.id}} })"><div class="ellipsis-overflow float-right text-normal-case">{{ ::data.customerExpectedTime | date:\'h:mm a on M/d\' }}<br></div><div class="customer-name"><strong>{{ ::data.customerName}}</strong></div><div class="mobile-left-text">{{ ::data.typeName}}</div><div class="mobile-left-text">#{{ ::data.id}}</div><span class="mobile-badge-container"><i class="list-dot material-icons theme-link" ng-if="!data.isComplete && data.health.status > vmList.healthStatus.ok && data.health.status <= vmList.healthStatus.driverNoLocation" title="{{ ::data.health.reason }}">warning</i> <i ng-if="data.state == 12" class="list-dot material-icons footer-info danger" title="CANCELED BY {{ ::data.cancelled.firstName || \'CUSTOMER\' }} {{ ::data.cancelled.lastName }} REASON: {{ ::data.cancelReason }}">event_busy</i> <i class="list-dot material-icons footer-info danger" ng-if="data.duplicateTripIds && data.duplicateTripIds.length && !(!data.isComplete && data.health.status > vmList.healthStatus.ok && data.health.status <= vmList.healthStatus.driverNoLocation)" title="POSSIBLE DUPLICATE TRIP OF #{{data.duplicateTripIds.join(\', #\')}}">warning</i> <span ng-if="::data.badgeText" class="trip-type-badge trip-type-badge-black">{{::data.badgeText}}</span> <span ng-if="::data.icon" class="trip-type-badge margin-left-sm trip-type-icon"><img ng-src="{{ ::data.icon}}"></span></span><div class="info-block trip-circles visible-xs-block"><trip-circles stops="data.stops" current-step="data.currentStep" state="data.state" trip-type="data.systemTripTypeId"></trip-circles></div></div><div id="trip-cirles-display" class="no-gutter padding-right-none flex-percent-25 margin-right-md hidden-xs"><div class="display-flex flex-row row padding-none border-none margin-left-md"><div class="hidden-xs"><span ng-if="::data.badgeText" class="trip-type-badge trip-type-badge-black">{{ ::data.badgeText }}</span> <span ng-if="::data.icon" class="trip-type-badge trip-type-icon"><img ng-src="{{ ::data.icon}}"></span></div><div><div class="info-block trip-circles"><trip-circles stops="data.stops" current-step="data.currentStep" state="data.state" trip-type="data.systemTripTypeId"></trip-circles></div></div></div></div><div id="trip-info-display" class="display-flex flex-column flex-grow flex-percent-50 min-width-px-75 max-width-px-400 padding-left-none padding-right-none hidden-xs"><div class="info-block"><div class="ellipsis-overflow" title="{{ ::data.customerName }} {{ ::data.vehicle.year }} {{ ::data.vehicle.model }} {{ ::data.vehicle.isManual ? \'MT\' : \'AT\' }}"><span class="trip-label">{{ ::data.customerName }}</span> {{::data.vehicle.year }} {{ ::data.vehicle.make }} {{::data.vehicle.model }}</div><div class="ellipsis-overflow" title="{{ ::data.customerPhone }} {{ ::data.customerEmail }}"><span class="trip-label">{{ ::data.customerPhone | tel }}</span> {{ ::data.customerEmail }}</div><div class="ellipsis-overflow" title="#{{ ::data.id }} {{ ::data.workflowName }}"><span class="trip-label">#{{ ::data.id }}</span> <span>{{ ::data.workflowName }}</span></div><div class="ellipsis-overflow" title="{{ ::data.customerExpectedTime | date:\'MMM dd h:mma\' }}{{ data.systemTripTypeId == 1 && data.dmsImported === true ? (\' DMS Appt \' + (data.apptTime | date: \'MMM dd h:mma\')) : data.systemTripTypeId == 2 ? (\' RO \' + data.roNumber) : \'\' }} {{ ::data.roStatus }}"><span class="trip-label">{{ ::data.customerExpectedTime | date:\'EEE, MMM dd h:mma\' }}</span> <span>{{ data.systemTripTypeId == 1 && data.dmsImported === true ? (\'DMS Appt \' + (data.apptTime | date: \'MMM dd h:mma\')) : data.systemTripTypeId == 2 ? (\'(RO \' + data.roNumber + \') \' + data.roStatus ): \'\' }}</span></div><div class="ellipsis-overflow" title="{{ ::data.dealer.name }} {{::vmList.getBookedByToolTip(data)}}"><span class="trip-label">{{ ::data.dealer.name }}</span> <span ng-if="::(data.created && data.created.firstName)">BOOKED BY {{::data.created.firstName }} {{ ::data.created.lastName}}</span> <span ng-if="::(!data.created || !data.created.firstName)">{{::data.bookingSource }} BOOKED</span></div></div><div ng-if="data.state == 12" class="footer-info danger" title="CANCELED BY {{ ::data.cancelled.firstName }} {{ ::data.cancelled.lastName }} REASON: {{ ::data.cancelReason }}"><i class="material-icons text-left cancel-icon">event_busy</i><div class="cancel-reason inline"><b>CANCELED BY <span class="margin-none" ng-if="::data.cancelled.lastName">{{ ::data.cancelled.firstName }} {{ ::data.cancelled.lastName }}</span><span class="margin-none" ng-if="!data.cancelled.lastName">CUSTOMER</span><span>:&nbsp;{{ ::data.cancelReason }}</span></b></div></div><div ng-if="data.state !== 12 && data.health.status > vmList.healthStatus.ok && ((!data.isComplete && data.health.status <= vmList.healthStatus.driverNoLocation) || data.health.status > vmList.healthStatus.driverNoLocation)" class="footer-info" ng-class="{\'danger\': data.health.status > vmList.healthStatus.warning }" title="{{ ::data.health.reason }}"><i class="material-icons" ng-if="data.health.status !== vmList.healthStatus.warning">warning</i> <b>{{ vmList.getStatusText(data.health.status, true) }}</b></div><div ng-if="data.duplicateTripIds && data.duplicateTripIds.length" class="footer-info danger"><i class="material-icons">warning</i> <b>POSSIBLE DUPLICATE TRIP OF #{{data.duplicateTripIds.join(\', #\')}}</b></div></div><div class="flex-percent-25 hidden-xs" title="{{ ::data.driver.name }}"><div class="display-flex flex-justify-right flex-percent-15 flex-grow margin-left-md"><div><div class="img-xs img-xs-square spinner" afkl-lazy-image="{{ ::data.driver.driverPhoto }}" afkl-lazy-image-options="{imgAttrs: [{class: \'img-xs img-xs-square\'}], \'nolazy\': true }" lazy-load-fail="assets/images/user-square.png"></div><div class="padding-top-md driver-img-name"><b><center>{{ ::data.driver.name.split(\' \')[0] }}</center></b></div></div><div class="trip-list-arrow-col flex-percent-35" title="Open Trip Details"><div class="margin-top" ng-click="vmList.goToTripDetails($event, data.id)"><i class="material-icons padding-top-xs">keyboard_arrow_right</i></div></div></div></div></div></div><div class="full-width text-center margin-top"><rc-list-standardized-footer record-count="vmList.filteredTrips.length" is-loading="vmList.isLoadingMore || vmList.isLoading" can-show-more="vmList.canLoadMore"></rc-list-standardized-footer></div></div></div><div id="map-container" class="display-flex flex-percent-50 padding-none hidden-sm hidden-xs"><div id="trip-map" class="full-width block relative" map-resize=""><div id="trip-list-map" driver-tracking="" fill-height="" options="vmList.mapOptions" map-loaded="vmList.mapLoaded"></div></div><resizer ng-show="!vmList.showAdvancedSearch" direction="horizontal" classes="hidden-xs" attach-element-id="map-container" dependent-element-id="map-container" xoffset="-13" yoffset="100" callback="vmList.resizeMap(maximize)"></resizer></div></div></div></div></div><fake-modal id="fake-modal" class="ng-hide" ng-show="vmList.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vmList.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md visible-sm visible-xs"><rc-list-mode-selector ng-model="vmList.parent_vm.selectedViewModeIcon" available-modes="vmList.parent_vm.availTripModes" css-class="rc-list-selector" on-select-event="vmList.tripListModeChanged()"></rc-list-mode-selector></div><div class="flex-width-350 flex-grow max-width-px-400 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm hidden-xs hidden-sm" ng-if="vmList.showFakeLocationInput()"><div class="block relative override-xs-padding-none override-sm-padding-none"><input type="text" name="search" class="form-control better-placeholder" placeholder="All locations" ng-model="vmList.noLocationsText" ng-disabled="vmList.filters.locationFilter.length > 1"><div id="location-search-overlay" ng-click="vmList.getDealerLocations()" ng-if="vmList.isLocationListEmpty() === true"></div><img src="assets/images/ajax-loader.gif" class="ng-hide location-spinner" ng-show="vmList.loadingLocations"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearAllLocations()" ng-if="vmList.filters.locationFilter && vmList.filters.locationFilter.length > 1">close</span></div></div><div class="flex-width-350 flex-grow max-width-px-400 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm hidden-xs hidden-sm" ng-show="(vmList.isLocationListEmpty() === false && !vmList.filters.singleLocationSelected) && vmList.hasMultipleDealers === false"><div class="block relative override-xs-padding-none override-sm-padding-none"><input id="location-filter1" class="form-control better-placeholder" placeholder="All locations" type="text" ng-disabled="true" ng-model="vmList.filters.singleLocation.name"></div></div><div class="flex-width-350 flex-grow max-width-px-400 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm hidden-xs hidden-sm" ng-if="vmList.isLocationListEmpty() === false || vmList.filters.singleLocation" ng-show="(vmList.isLocationListEmpty() === false || vmList.filters.singleLocation) && vmList.hasMultipleDealers === true && vmList.filters.locationFilter.length < 2"><div class="block relative override-xs-padding-none override-sm-padding-none"><select select2="" id="location-filter-single-dlg" name="location-filter-single-dlg" on-change="vmList.selectSingleLocation(selectedResult)" placeholder="All locations" min-input-length="1" init-value="vmList.selectedSingleLocationId" format-for-selection="vmList.formatLocationForSelection" format-for-dropdown="vmList.formatLocationForDropdown" query="vmList.locationSearchQuery" ng-model="vmList.selectedSingleLocationId"></select></div></div><div class="flex-width-200 flex-grow max-width-px-400 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><input type="text" name="search" class="form-control better-placeholder" ng-model="vmList.filters.keywordFilter" ng-keyup="$event.keyCode === 13 && vmList.keywordFilterUpdated()" ng-blur="vmList.keywordFilterUpdated()" ng-disabled="vmList.isLoading" placeholder="Search"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearKeywordField()" ng-if="vmList.filters.keywordFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-hide="vmList.showCalendar() === true"><div class="block relative override-xs-padding-none override-sm-padding-none field-wrapper"><label for="dateRangeFilter">Timeframe</label><select selectlabel="" id="dateRangeFilter" ng-disabled="vmList.isLoading" disable-search="true" class="form-control ng-show" name="dateRangeFilter" ng-model="vmList.filters.timeframeFilter" ng-change="vmList.timeframeChanged(t)" ng-options="t.value as t.text for t in vmList.timeframes"><option value="">Timeframe</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm" ng-hide="vmList.showCalendar() === false"><div class="block relative override-xs-padding-none override-sm-padding-none"><input options="vmList.dateRangePickerOptions" date-range-picker="" id="timeframe_range" class="form-control date-picker" placeholder="Custom timeframe" type="text" ng-model="vmList.filters.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomTimeFrame()">close</span></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md override-xs-margin-top-none"><div class="flex-width-200 flex-sm-percent-100 flex-sm-percent-100 override-xs-margin-top-none override-sm-margin-top-none padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none text-notransform"><div class="chosen-field-wrapper"><label class="label selected padding-left-none margin-left-none">Status</label></div><div id="status_filter" ng-dropdown-multiselect="" ng-model-options="{ debounce: 750 }" events="vmList.statusFilterEvents" ng-disabled="vmList.isLoading" options="vmList.tripStatuses" selected-model="vmList.checkboxFilters.tripStatusCheckboxFilter" checkboxes="true" extra-settings="vmList.checkboxFilterSettings" translation-texts="vmList.tripStatusFilterStrings"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none field-wrapper"><label for="loanerFilter" class="on selected padding-left-sm margin-left-none">Loaner/No Loaner</label><select selectlabel="" ng-disabled="vmList.isLoading" ng-change="vmList.listFilterChanged()" class="form-control" name="loanerFilter" id="loanerFilter" ng-model="vmList.filters.loanerFilter" disable-search="true"><option value="">Loaner/No Loaner</option><option value="true">With Loaner</option><option value="false">Without Loaner</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-xs override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><div class="chosen-field-wrapper"><label class="label selected padding-left-none margin-left-none">Trip types</label></div><div ng-dropdown-multiselect="" id="tripsTripTypeFilter" ng-disabled="vmList.isLoading" ng-model-options="{ debounce: 750 }" events="vmList.tripTypeFilterEvents" options="vmList.tripTypes" selected-model="vmList.checkboxFilters.tripTypeCheckboxFilter" checkboxes="true" extra-settings="vmList.checkboxFilterSettings" translation-texts="vmList.tripTypeFilterStrings"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div id="userFilterContainer" class="block relative override-xs-padding-none override-sm-padding-none"><select name="userFilter" id="userFilter" ng-if="vmList.showAdvancedSearch" multiple="" ui-select2="vmList.userListSearchOptions" ng-model="vmList.filters.userFilter" placeholder="User" class="select2-single form-control"></select><img src="assets/images/ajax-loader.gif" class="ng-hide driver-spinner" ng-show="vmList.isLoadingUsers"></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md override-xs-margin-top-sm override-sm-margin-top-sm"><div ng-if="vmList.isSysAdmin" class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-none override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><div class="chosen-field-wrapper"><label class="label selected padding-left-none margin-left-none">Program</label></div><div ng-dropdown-multiselect="" ng-model-options="{ debounce: 750 }" events="vmList.programFilterEvents" ng-disabled="vmList.isLoading" options="vmList.resolvedProgramList" selected-model="vmList.checkboxFilters.programCheckboxFilter" checkboxes="true" extra-settings="vmList.programFilterSettings" translation-texts="vmList.programFilterStrings"></div></div></div><div ng-if="vmList.isSysAdmin" class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><div class="chosen-field-wrapper"><label class="label selected padding-left-none margin-left-none">DNS PROGRAM</label></div><div ng-dropdown-multiselect="" ng-model-options="{ debounce: 750 }" events="vmList.driverProgramFilterEvents" ng-disabled="vmList.isLoading" options="vmList.driverPrograms" selected-model="vmList.checkboxFilters.driverProgramCheckboxFilter" checkboxes="true" extra-settings="vmList.programFilterSettings" translation-texts="vmList.driverProgramFilterStrings"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><input ng-disabled="vmList.isLoading" type="text" name="customerFilter" ng-model="vmList.filters.customerFilter" class="form-control better-placeholder" placeholder="Customer"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearCustomerField()" ng-if="vmList.filters.customerFilter">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><input ng-disabled="vmList.isLoading" type="text" name="driverFilter" ng-model="vmList.filters.driverFilter" class="form-control better-placeholder" placeholder="DRIVER"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vmList.clearDriverField()" ng-if="vmList.filters.driverFilter">close</span></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm margin-top-md" ng-show="vmList.hasMultipleDealers === true && vmList.dealerListInitialized"><div class="block relative override-xs-padding-none override-sm-padding-none multiple-location-search"><div class="block relative"><select placeholder-text-multiple="\'All locations\'" class="form-control location-chosen-filter" ng-options-title="vmList.resolvedLocationList" ng-options-placeholder="1" id="locationListFilter" name="locationFilter" ng-change="vmList.multipleLocationSelected()" multiple="" max-shown-results="100" chosen="{width: \'100%\'}" ng-model="vmList.filters.locationFilter" ng-options="l.id as l.name for l in vmList.resolvedLocationList"></select><span class="inline-block position-absolute material-icons bold cursor-pointer ng-scope multi-location-close-button" ng-click="vmList.clearAllLocations()" ng-if="vmList.filters.locationFilter.length > 0">close</span></div></div></div><div class="display-flex flex-row flex-sm-column margin-top-md"><div class="block relative override-xs-padding-none override-sm-padding-none"><div class="display-flex vertical-align padding-right-sm override-xs-padding-none override-sm-padding-none padding-left-none margin-top-md"><div><label for="unassignedFilter" class="display-flex content-center margin-bottom-none padding-right-md">UNASSIGNED</label></div><div><ul class="radios-list list-inline inline"><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.driverFilterUnassigned" ng-value="true" id="unassignedFilter" name="unassignedFilterRadio"> <span class="font-normal">&nbsp;Yes</span></label></li><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.driverFilterUnassigned" selected="" ng-value="false" id="unassignedFilterNo" name="unassignedFilterRadioNo"> <span class="font-normal">&nbsp;No</span></label></li></ul></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><div class="display-flex vertical-align padding-right-sm override-xs-padding-none override-sm-padding-none padding-left margin-top-md"><div><label for="dnsOnlyFilter" class="display-flex content-center margin-bottom-none padding-right-md">DNS ONLY</label></div><div><ul class="radios-list list-inline inline"><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.dnsOnlyFilter" ng-value="true" id="dnsOnlyFilter" name="dnsOnlyRadio"> <span class="font-normal">&nbsp;Yes</span></label></li><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.dnsOnlyFilter" selected="" ng-value="false" id="dnsOnlyFilterNo" name="dnsOnlyRadioNo"> <span class="font-normal">&nbsp;No</span></label></li></ul></div></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md padding-right-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><div class="display-flex vertical-align padding-right-sm override-xs-padding-none override-sm-padding-none padding-left margin-top-md"><div><label for="includeTestTripsFilter" class="display-flex content-center margin-bottom-none padding-right-md">TEST TRIPS</label></div><div><ul class="radios-list list-inline inline"><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.includeTestTripsFilter" ng-value="true" id="includeTestTripsFilter" name="isTestTripRadio"> <span class="font-normal">&nbsp;Yes</span></label></li><li><label class="display-flex content-center margin-bottom-none padding-top-xs"><input type="radio" class="margin-none" ng-model="vmList.filters.includeTestTripsFilter" selected="" ng-value="false" id="includeTestTripsFilterNo" name="isTestTripRadioNo"> <span class="font-normal">&nbsp;No</span></label></li></ul></div></div></div></div></div><div class="display-flex flex-row padding-bottom-lg"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left margin-top-md"><div class="block relative padding-right-sm"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vmList.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md"><rc-list-template-save-search-delete-btns list-controller="vmList" current-search-template="vmList.searchTemplateData.currentSearchTemplate" is-processing-template="vmList.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vmList.canManageGlobalTemplates" template-message="vmList.templateMessage" save-btn-clicked="vmList.saveBtnClicked()" save-as-btn-clicked="vmList.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vmList.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm" ng-click="vmList.clearFilters();vmList.close();">Reset Filters</div><button type="button" ng-click="vmList.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vmList.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/trip/views/trip-main.view.html','<div><ng-include ng-cloak="" src="\'app/areas/trip/views/trip-list.view.html\'" ng-controller="TripListController as vmList" ng-if="vm.tripList"></ng-include><ng-include ng-cloak="" src="\'app/areas/trip/views/lyft-credits-list.view.html\'" ng-controller="LyftCreditListController as vmList" ng-if="!vm.tripList"></ng-include></div>');
$templateCache.put('app/areas/user/views/user-add.view.html','<div class="row display-flex flex-column overflow-hidden full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New User</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-lg flex-grow flex-percent-90 col-xs-12 bg-white border-none"><div class="padding-top-md padding-bottom-lg"><select ng-if="vm.showUserImport" ng-model="vm.userAddMode" class="form-control import-dropdown"><option value="1">Add a single user</option><option value="2">Upload a batch of users</option></select></div><div ng-if="vm.userAddMode == 1"><h3>User Information</h3><p>Complete the fields provided to add the User. Most fields are required.</p><hr><form role="form" id="UserAddForm" name="UserAddForm" class="form" ng-submit="UserAddForm.$valid && vm.createUser()" novalidate=""><div class="row"><div class="col-sm-8"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s email address to associate with their account." popover-placement="right" popover-trigger="outsideClick">Login User Name (Email Address)</span></label> <input type="text" id="user_name" name="user_name" ng-model="vm.userName" class="form-control" required="" validation="required|email|remote:vm.userNameRemoteValidationCheck()"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter user\'s first name." popover-placement="right" popover-trigger="outsideClick">First Name</span></label> <input type="text" id="first_name" name="first_name" ng-model="vm.firstName" required="" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required"></div></div><div class="col-sm-6"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter user\'s last name." popover-trigger="outsideClick">Last Name</span></label> <input type="text" id="last_name" name="last_name" ng-model="vm.lastName" required="" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter user\'s mobile phone." popover-placement="right" popover-trigger="outsideClick">Mobile Phone</span></label> <input type="text" id="mobile_phone" name="mobile_phone" ng-model="vm.mobilePhone" ng-disabled="vm.fieldsDisabled" class="form-control" mask-restrict="reject" required="" mask="(999) 999-9999" clean="true" validation="required|custom: vm.validation.phoneNumberRequired(vm.mobilePhone):alt=*"><phone-type-indicator phone-number="vm.mobilePhone" class="margin-top-20"></phone-type-indicator></div></div><div class="col-sm-6"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Enter user\'s office phone." popover-trigger="outsideClick">Office Phone</span></label> <input type="text" id="office_phone" name="office_phone" ng-model="vm.officePhone" ng-disabled="vm.fieldsDisabled" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true"></div></div></div><div class="row" ng-if="!vm.isOnlyDealerAdmin"><div class="col-sm-6"><div class="form-group"><label><span class="cursor-pointer hover-underline" uib-popover="Where should emails appear to be \'from\' when sent from this user?" popover-trigger="outsideClick">Outbound Email \'From\' Address</span></label> <input type="email" id="email_address" name="email_address" ng-model="vm.emailAddress" required="" ng-disabled="vm.fieldsDisabled" class="form-control" validation="email:alt=Must be a valid email address."></div></div><div class="col-sm-6"><div class="row"><div class="form-group"><div class="col-xs-1 hidden-xs xs-nopadding">&nbsp;</div><div class="col-xs-2 padding-top-switch"><switch id="enable_emailcc" name="enable_emailcc" ng-model="vm.enableEmailCC" disabled="vm.fieldsDisabled" class="green small-switch"></switch></div><div class="col-xs-8 padding-top-switch"><label for="enable_emailcc" class="control-label padding-top-sm">Enable Email CC</label></div></div></div><div class="row margin-top"><div class="form-group"><div class="col-xs-1 hidden-xs xs-nopadding">&nbsp;</div><div class="col-xs-2"><switch id="welcome_email" name="welcome_email" ng-model="vm.sendWelcomeEmail" disabled="vm.fieldsDisabled" class="green small-switch"></switch></div><div class="col-xs-8"><label for="welcome_email" class="control-label padding-top-sm">Send Welcome Email</label></div></div></div></div></div><div class="row margin-top" ng-if="vm.sendWelcomeEmail || vm.isOnlyDealerAdmin || vm.forceDisplayLocationSelection === true"><div class="col-sm-8"><div class="form-group"><label><span ng-if="!vm.isOnlyDealerAdmin" class="cursor-pointer hover-underline" uib-popover="Select the User\'s home Dealership." popover-placement="right" popover-trigger="outsideClick">Home Dealership</span><div ng-if="vm.isOnlyDealerAdmin"><h3>Home Location</h3><p class="font-normal">Select the home location for this user. You can add access to additional locations after clicking ADD below.</p></div></label><ui-select class="fake-required" ng-model="vm.selectedLocation" on-select="vm.locationSelected($item, $model)" ng-disabled="vm.fieldsDisabled"><ui-select-match class="fake-required" placeholder="Select or search a location in the list...">{{ $select.selected.name }}</ui-select-match><ui-select-choices refresh="vm.locationsFilter($select.search)" refresh-delay="250" repeat="location in vm.locations | limitTo: vm.locationDisplayLimit track by location.id"><div><span ng-bind-html="location.locationHtml | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div></div></form></div><div ng-if="vm.userAddMode == 2"><h3>Batch user Upload</h3><p>Select the file you want to upload and the user you want to copy settings from. Click <a class="theme-link" href="https://redcapstorage.blob.core.windows.net/misc/UserImportTemplate.csv">SampleUserFile.CSV</a> to download an empty file in the proper format.</p><hr><form role="form" id="UserAddForm" name="UserAddForm" class="form" ng-submit="UserAddForm.$valid && vm.importUsers()" novalidate=""><div class="btn btn-default margin-right-md margin-bottom" ngf-select="vm.chooseImportFile($file)" ng-model="vm.bulkImport.file" ng-disabled="vm.isLoadingData" required="">Browse...</div><span>{{ vm.bulkImport.fileName }}</span> <img src="assets/images/ajax-loader.gif" ng-if="vm.readingFile"><div class="col-sm-4 padding-left-none"><select select2="" id="userCopy" name="userCopy" placeholder="Select user to copy from" min-input-length="3" format-for-selection="vm.formatForUserSelection" format-for-dropdown="vm.formatForUserDropdown" allow-any-input-on-empty-results="false" query="vm.userSearchQuery" ng-model="vm.importUser"></select></div><div class="margin-top" ng-if="vm.isLoadingData"><span>Processing...</span> <img src="assets/images/ajax-loader.gif"></div><div class="margin-top" ng-if="vm.importCompleted">The import process has completed. Please check your email for a full summary of the results. A spreadsheet with saved Id\'s for each record should have automatically downloaded from this page. If the SavedId is 0 in the spreadsheet it indicates that the record was already added or failed to add. These details should be available in the summary email.</div><div ng-if="vm.importResults"><hr><h4>RESULTS</h4><div class="margin-bottom">SUCCESSFUL RECORDS: {{ vm.importResults.successfulRecordCount }}</div><div class="margin-bottom">SKIPPED RECORDS: {{ vm.importResults.skippedUsers.length }} <span>(These users were already added)</span></div><ul ng-if="vm.importResults.skippedUsers.length > 0"><li ng-repeat="skippedUser in vm.importResults.skippedUsers">{{ skippedUser }}</li></ul><div ng-if="vm.importResults.genericErrors" class="margin-bottom text-danger"><div ng-repeat="importError in vm.importResults.genericErrors"><div>Error occurred while trying to parse the file: {{ importError.errorMessage }}</div></div></div><div ng-if="vm.importResults.errors" class="text-danger"><div class="margin-bottom">FAILED RECORDS: {{ vm.importResults.errors.length }}</div><div ng-repeat="importError in vm.importResults.errors"><div>Error occurred for user: {{ importError.userEmail }}, {{ importError.errorMessage }}</div></div></div></div></form></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2 padding-right-20 text-right"><div class="display-flex full-height flex-percent-100 align-items-center pull-right"><div ng-if="vm.userAddMode == 1"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="user-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.createUser()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || UserAddForm.$invalid || (vm.sendWelcomeEmail && !vm.homeDealerId) || (vm.forceDisplayLocationSelection && !vm.homeDealerId)">NEXT</button></div><div ng-if="vm.userAddMode == 2"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ui-sref="user-list">Close</button> <button type="button" ng-click="vm.importUsers()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.isLoadingData" ng-disabled="UserAddForm.$invalid">Upload</button></div></div></div></div>');
$templateCache.put('app/areas/user/views/user-edit.view.html','<div class="display-flex overflow-hidden vh-h100 flex-column separate-left-aside-panel"><div class="flex-fullwidth-50h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><div class="modal-header padding-t-b-0 padding-top-none padding-bottom-none"><div class="row"><div class="col-xs-12 col-sm-7 padding-sm padding-top-none padding-bottom-none"><h2 class="modal-title ellipsis-overflow">Edit User: {{ vm.titleUser }}</h2></div></div></div></div><div class="overflow-y-hidden overflow-x-hidden flex-percent-100 col-xs-12 bg-white padding-none"><div class="flex-fill full-height" fill-height="" aside-parent="vm.childScopeForm"><div id="driver-tab-container" scrollable-tabs="" class="margin-none bg-white font-normal" scroll-amount="150"><uib-tabset class="invisible-tabs scrollable full-height tab-content-padding-none"><uib-tab ng-repeat="tab in vm.tabs" heading="{{tab.title}}" active="tab.active" ui-sref="{{tab.route}}" disable="tab.disabled"><span class="full-width-height" ui-view="{{tab.route}}"><div class="padding"><img src="assets/images/ajax-loader.gif"> Loading...</div></span></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/areas/user/views/user-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="users" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-row full-width visible-sm visible-xs"><div class="flex-sm-percent-60 flex-xs-percent-60 flex-grow visible-xs visible-sm"><div class="block relative override-xs-padding-none override-sm-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search..." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.filtersChanged()" on-tag-removed="vm.filtersChanged()"></tags-input></div></div><div class="flex-percent-10 visible-xs visible-sm padding-left-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.filteredUsers.length" toggle-advanced-search="vm.toggleShowSearchOptions()" align-right="true" search-tray-displayed="vm.showAdvancedSearch"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm" ng-if="!vm.showAdvancedSearch"><a ui-sref="user-add" class="margin-left-md visible-xs visible-sm theme-link" ng-class="config.styleClass"><i class="md-24 material-icons" title="Add New">add</i></a></div></div><div class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters filter-count="vm.filterCount" record-count="vm.filteredUsers.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div><div class="flex-percent-80 flex-xs-percent-100 flex-sm-percent-100"><div class="display-flex flex-row hidden-sm hidden-xs"><div class="flex-width-300 flex-grow max-width-px-400 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-right-sm override-xs-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search..." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.filtersChanged()" on-tag-removed="vm.filtersChanged()"></tags-input><div class="inline-block text-danger" ng-show="vm.filterMessage != \'\'" ng-bind-html="vm.filterMessage"></div></div></div><div class="flex-width-300 flex-grow max-width-px-400 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none max-width-100-percent"><div id="location-search-container" class="field-wrapper"><select data-placeholder-text-multiple="\'Filter by location(s)...\'" class="form-control" max-shown-results="100" name="locationFilter" multiple="" chosen="{width: \'100%\'}" ng-model="vm.filters.filterByLocations" ng-options="l.id as l.displayText for l in vm.locations" ng-change="vm.filtersChanged()"><option value=""></option></select></div></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm field-wrapper override-xs-padding-none"><label for="statusFilter">STATUS</label><select selectlabel="" class="form-control" name="statusFilter" ng-model="vm.filters.activeStatus" ng-change="vm.filtersChanged()"><option value="true">Active</option><option value="false">Inactive</option><option value="all">All</option></select></div></div><div class="flex-width-200 flex-xs-percent-100 override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm field-wrapper override-xs-padding-none"><label for="roleUserFilter">ROLE</label><select class="form-control" selectlabel="" id="roleUserFilter" name="roleUserFilter" ng-model="vm.filters.filterByUserRole" allow-null-option="Role" ng-options="role.id as role.displayText for role in vm.systemRoles" ng-change="vm.filtersChanged()"></select></div></div></div></div><div class="flex-percent-20 text-right pad-left-15 hidden-sm hidden-xs"><a ui-sref="user-add" class="btn btn-primary margin-left-md new-btn" ng-class="config.styleClass">+ NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="user-table-wrapper"><table class="table table-hover searchable-list table-layout-fixed small-columns fixed-header-table border-bottom" infinite-scroll-container="\'#user-table-wrapper\'" infinite-scroll="vm.searchUsers()" infinite-scroll-distance="1" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore"><thead><tr><th class="user-profile-pic" data-sort-ignore="true">Photo</th><th class="visible-xs"><span class="padding-left-sm">User Info</span></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.user)" class="padding-left-sm cursor-pointer hidden-xs" data-type="alpha">User <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.user ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-toggle="true" ng-click="vm.sortClicked(vm.sorting.name)" class="cursor-pointer hidden-xs">Name <i class="fa" ng-class="vm.sort.sortBy === vm.sorting.name ? (vm.sort.sortDirection === \'asc\' ? \'fa-sort-asc\' : \'fa-sort-desc\') : \'fa-sort\'" aria-hidden="true"></i></th><th data-sort-ignore="true" class="hidden-xs"></th></tr></thead><tbody><tr ng-repeat="data in vm.filteredUsers track by data.id" class="list-name" ui-sref="user-tab-general({userId: data.id})"><td class="user-profile-pic clip-overflow"><img class="img-circle" ng-src="{{ ::data.profilePicture }}"></td><td class="visible-xs"><b>User Name:</b> {{ ::data.userName }}<br><b>Full Name:</b> {{ ::data.fullName }}<br><div class="phone-number" ng-if="data.mobilePhone"><i class="fa fa-mobile padding-right-xs"></i>{{ ::data.mobilePhone|tel }}</div><div class="phone-number" ng-if="data.officePhone"><i class="fa fa-phone padding-right-xs"></i>{{ ::data.officePhone|tel }}</div></td><td class="padding-left-sm user-name hidden-xs">{{ ::data.userName }}<br><div class="phone-number" ng-if="data.mobilePhone"><i class="fa fa-mobile padding-right-xs"></i>{{ ::data.mobilePhone|tel }}</div><div class="phone-number" ng-if="data.officePhone"><i class="fa fa-phone padding-right-xs"></i>{{ ::data.officePhone|tel }}</div></td><td class="user-name hidden-xs">{{ ::data.fullName }}</td><td class="last-row hidden-xs">&nbsp;</td></tr></tbody></table><rc-list-standardized-footer record-count="vm.filteredUsers.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore"></rc-list-standardized-footer></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md"><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><tags-input id="filter_search" name="item_search" placeholder="Keyword(s) to search..." replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" ng-model="vm.filters.searchInput" on-tag-added="vm.filtersChanged()" on-tag-removed="vm.filtersChanged()"></tags-input><div class="inline-block text-danger" ng-show="vm.filterMessage != \'\'" ng-bind-html="vm.filterMessage"></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div id="location-search-container" class="field-wrapper"><select data-placeholder-text-multiple="\'Filter by location(s)...\'" class="form-control" max-shown-results="100" name="locationFilter" multiple="" chosen="{width: \'100%\'}" ng-model="vm.filters.filterByLocations" ng-options="l.id as l.displayText for l in vm.locations" ng-change="vm.filtersChanged()"><option value=""></option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top-md override-xs-margin-top-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="statusFilter1">STATUS</label><select selectlabel="" class="form-control" name="statusFilter1" ng-model="vm.filters.activeStatus" ng-change="vm.filtersChanged()"><option value="true">Active</option><option value="false">Inactive</option><option value="all">All</option></select></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-padding-top-none override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper"><label for="roleUserFilter1">ROLE</label><select class="form-control" selectlabel="" id="roleUserFilter1" name="roleUserFilter1" ng-model="vm.filters.filterByUserRole" allow-null-option="Role" ng-options="role.id as role.displayText for role in vm.systemRoles" ng-change="vm.filtersChanged()"></select></div></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal>');
$templateCache.put('app/areas/user/views/user-tab-general.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><div ng-if="vm.userAdded === true"><h3 class="text-danger">User Created! <b>Please follow the important steps below:</b></h3><p>The new user has been created. Follow the steps below and the tabs above to complete the setup:<br><ol class="user-added"><li>Security - Select the security tab above to set the user\'s password and to specify the roles and products the user will have access to.</li><li>Locations - Select the locations tab above to map the user to their DMS user and add access to additional locations.</li><li>Settings - Select the Settings tab to set additional items.</li></ol></p><hr></div><div ng-if="vm.userAdded !== true"><h3>User Information</h3><p>Complete the fields provided to add the User. Most fields are required.</p><hr></div><form role="form" name="UserEditForm" class="form" ng-submit="UserEditForm.$valid && vm.updateUser()" novalidate="" prevalidate-form=""><div class="form-group"><div class="col-sm-3">&nbsp;</div><div class="col-sm-6"><div class="row padding-md"><div class="col-sm-8 text-center"><div class="profilePicCropArea ng-hide" ng-show="vm.profilePic.profileImageUpload"><ui-cropper image="vm.profilePic.profileImageUpload" result-image="vm.profilePic.profileImage"></ui-cropper></div><div class="ng-hide" ng-show="!vm.profilePic.profileImageUpload"><img ng-src="{{ vm.currentUser.profilePicture }}"></div></div></div><div class="row"><div class="col-sm-6 col-sm-offset-1"><center><button type="button" class="form-control btn-default btn-150" ng-click="vm.clickFileInput()">SELECT IMAGE</button> <input type="file" id="fileInput" name="fileInput" file-input="vm.profilePic.profileImageUpload" ng-hide="true"></center></div></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="The user\'s email address that is used as their login name" popover-trigger="outsideClick">Login</span></label><div class="col-sm-4 static-text">{{vm.currentUser.userName}}</div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s first name." popover-trigger="outsideClick">First Name</span></label><div class="col-sm-4"><input type="text" id="first_name" name="first_name" ng-model="vm.currentUser.firstName" ng-disabled="vm.fieldsDisabled" required="" class="form-control" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s last name." popover-trigger="outsideClick">Last Name</span></label><div class="col-sm-4"><input type="text" id="last_name" name="last_name" ng-model="vm.currentUser.lastName" ng-disabled="vm.fieldsDisabled" class="form-control" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s mobile phone number." popover-trigger="outsideClick">Mobile Phone</span></label><div class="col-sm-4"><input type="text" id="mobile_phone" name="mobile_phone" ng-model="vm.currentUser.mobilePhone" ng-disabled="vm.fieldsDisabled" required="" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required|custom: vm.validation.phoneNumberRequired(vm.currentUser.mobilePhone):alt=*"><phone-type-indicator phone-number="vm.currentUser.mobilePhone"></phone-type-indicator></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s office phone number." popover-trigger="outsideClick">Office Phone</span></label><div class="col-sm-4"><input type="text" id="office_phone" name="office_phone" ng-model="vm.currentUser.officePhone" ng-disabled="vm.fieldsDisabled" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="custom: vm.validation.phoneNumberRequired(vm.currentUser.mobilePhone):alt=*"></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-40"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-60"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="user-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.updateUser()" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/user/views/user-tab-locations.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto" id="user-locations-tab-container"><div class="form-horizontal padding-lg"><h3>User Locations</h3><p>Grant user access to one or more location(s).</p><hr><form role="form" name="UserEditForm" class="form" novalidate=""><div class="form-group"><div class="col-sm-9"><ui-select ng-model="vm.currentLocation" on-select="vm.locationSelected($item, $model)" ng-disabled="vm.fieldsDisabled || vm.isSaving"><ui-select-match placeholder="Select or search a location in the list...">{{ $select.selected.name }}</ui-select-match><ui-select-choices refresh="vm.locationsFilter($select.search)" refresh-delay="250" repeat="location in vm.supportedLocations | limitTo: vm.locationDisplayLimit track by location.id"><div ui-select-options-title="<b>RC:</b> {{::location.id}}<br /><b>OEM:</b> {{::location.oemDealerId}}<br /><b>PRG:</b> {{::location.adminProgramName}}<br /><b>STATUS:</b> {{::location.statusText}}<br /><b>ADDR:</b><br/>{{::location.address}}<br />{{::location.city}}, {{::location.state}}" ng-bind-html="location.locationHtml | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-3" ng-if="!vm.isOnlyDealerAdmin"><select class="form-control" name="programFilter" ng-options="adminProgram.id as adminProgram.name for adminProgram in vm.adminPrograms" ng-model="vm.selectedProgram" ng-change="vm.addMultipleLocations(vm.selectedProgram)" ng-disabled="vm.isSaving"></select></div></div><div class="form-group"><div class="col-sm-12"><div class="margin-top-md" ng-if="vm.isInitialLoading"><img src="assets/images/ajax-loader.gif"> <span class="padding-left-xs">Loading user locations...</span></div><div id="user-locations-table-container" class="table-responsive overflow-visible" ng-if="!vm.isInitialLoading" infinite-scroll="vm.loadMoreLocations()" infinite-scroll-container="\'#user-locations-tab-container\'" infinite-scroll-distance="2"><table class="table footable table-hover table-vertical"><thead><tr><th data-sort-ignore="true" data-toggle="true" data-type="alpha" class="col-sm-3"><span class="cursor-pointer hover-underline" popover-placement="right" uib-popover="The dealerships this Employee has access to when logging in via the dashboard." popover-trigger="outsideClick">Selected Location(s)</span></th><th footable-sortable="" class="col-sm-1"><span class="cursor-pointer hover-underline">Program</span></th><th data-sort-ignore="true" class="col-sm-3"><span class="cursor-pointer hover-underline" uib-popover="This is a list of the imported DMS Employees from the store. Select the matching record for the employee you are viewing from the drop down list." popover-trigger="outsideClick">DMS Employee</span></th><th data-sort-ignore="true" class="col-sm-1"><span class="cursor-pointer hover-underline" uib-popover="Enable Automation for the user at the selected location?" popover-trigger="outsideClick">Automation</span></th><th data-sort-ignore="true" class="col-sm-3"><span class="cursor-pointer hover-underline" uib-popover="Add the current user to a bulk list" popover-trigger="outsideClick">Add to Bulk Lists</span></th><th data-sort-ignore="true" class="col-sm-1 text-center">Remove</th></tr></thead><tbody><tr ng-repeat="location in vm.selectedLocations | filter: vm.filterOnlyLocationsWithPermission track by location.id" class="list-name"><td class="location-name" title="{{::location.oemDealerId}}">{{::location.name}} ({{::location.city}})</td><td>{{::location.adminProgramName}}</td><td><ui-select ng-if="::location.dmsSystem !== 0" ng-model="location.dealerEmployee" ng-disabled="vm.isSaving"><ui-select-match placeholder="Search or select employee..." title="{{ vm.uiSelectEmployeesNgBindHtml($select.selected) }}">{{ vm.uiSelectEmployeesNgBindHtml($select.selected, true) }}</ui-select-match><ui-select-choices refresh="vm.loadEmployees(location, $select.search, false)" refresh-delay="250" repeat="employee in location.displayedEmployees track by employee.id" infinite-scroll="vm.loadEmployees(location, $select.search, true)" infinite-scroll-disabled="!location.hasMoreEmployees" infinite-scroll-distance="2"><div><span ng-bind-html="employee.employeeHtmlTruncated | highlight: $select.search" title="{{employee.employeeNumber}}"></span></div></ui-select-choices></ui-select><span ng-if="::location.dmsSystem === 0">No DMS Configured</span></td><td class="text-center"><input ng-if="::location.dmsSystem !== 0" type="checkbox" id="enable_automation_{{$index}}" name="enable_automation_{{$index}}" ng-model="location.dealerEmployee.enableAutomation" ng-disabled="vm.isSaving"></td><td><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.addToBulkSurveyList(location.id)" ng-disabled="vm.isSaving">SURVEYS</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.addToBulkNotificationList(location.id)" ng-disabled="vm.isSaving">NOTIFICATIONS</button></td><td class="text-center"><span class="fa fa-times-circle" ng-class="{\'text-muted\': vm.isSaving}" ng-click="!vm.isSaving && vm.removeLocation(location.id)"></span></td></tr></tbody></table><div class="centered-content loading-container text-center" ng-if="vm.isLoadingMore"><img src="assets/images/ajax-loader.gif"><div>Loading more locations...</div></div><div class="text-center padding-md" ng-if="!vm.hasMorePages && vm.selectedLocations.length > 0"><p>YOU HAVE REACHED THE END OF THE LIST</p></div></div></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-40"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-60"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="user-list" ng-disabled="vm.isSaving">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()" ng-disabled="vm.isSaving">Reset</button> <button type="button" ng-click="vm.updateUser()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.isSaving" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/user/views/user-tab-security.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>User Security</h3><p>User password and role membership.</p><hr><form role="form" name="UserEditForm" class="form validation-relative" novalidate=""><input class="ng-hide" type="text" id="username" name="username" autocomplete="username" value="{{vm.currentUser.userName}}"><div class="row"><div class="col-sm-8"><div class="form-group"><div class="col-sm-8"><button type="button" ladda="vm.sendingPasswordResetEmail" class="btn btn-default" ng-class="config.styleClass" ng-click="UserEditForm.$valid && vm.updatePassword()" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Send Password Reset Email</button> <button type="button" ng-if="vm.currentUser.solidUserId && vm.hasMFAPermissions" ladda="vm.sendingPasswordResetEmail" class="btn btn-default margin-left-md" ng-class="config.styleClass" ng-click="UserEditForm.$valid && vm.resetMFA()" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Reset MFA</button></div></div></div></div></form><hr><form role="form" id="UserEditForm2" name="UserEditForm2" class="form" ng-submit="UserEditForm2.$valid && vm.updateUser()" novalidate=""><div class="form-group"><label class="col-md-2 control-label hidden-sm hidden-xs"><span class="cursor-pointer hover-underline" uib-popover="Select one or more security role(s) for this user." popover-trigger="outsideClick">User Role(s)</span></label><div class="col-md-4 col-sm-6 col-xs-12"><div class="margin-bottom-md visible-sm"><label class="control-label"><span class="cursor-pointer hover-underline" uib-popover="Select one or more security role(s) for this user." popover-trigger="outsideClick">User Role(s)</span></label></div><h3 class="visible-xs padding-bottom-sm border-bottom margin-bottom-lg">User Role(s)</h3><div ng-repeat="role in vm.systemRoles | filter: vm.filterSystemRolesToDisplay" ng-if="role.isHidden === false" class="row"><label class="col-sm-7 col-xs-7 control-label margin-bottom-md" for="has{{role.name}}">{{role.displayText}}</label><div class="col-sm-4 col-xs-4 margin-bottom-sm" ng-if="vm.isRoleDisabled(role) === true"><label ng-click="vm.stopPropagation($event)"><switch id="has{{role.name}}" name="has{{role.name}}" disabled="true" ng-model="role.assigned" class="green"></switch></label> <i ng-if="role.name === vm.rolesEnums.dealerAdmin && vm.isRoleDisabled(role) === true && role.tooltip !== null && role.tooltip !== \'\'" class="material-icons md-16 text-color-gray padding-left-md padding-bottom-md" uib-popover-html="vm.popoverContent" popover-append-to-body="true" popover-placement="right" popover-is-open="vm.popoverIsOpen" popover-trigger="outsideClick">info_outline</i> <i ng-if="role.tooltip !== null && role.tooltip !== \'\' && (role.name !== vm.rolesEnums.dealerAdmin || (role.name === vm.rolesEnums.dealerAdmin && vm.isRoleDisabled(role) !== true))" class="material-icons md-16 text-color-gray padding-left-md padding-bottom-md" uib-popover="{{role.tooltip}}" popover-append-to-body="true" popover-placement="right" popover-trigger="mouseenter">info_outline</i></div><div class="col-sm-4 col-xs-4 margin-bottom-sm" ng-if="vm.isRoleDisabled(role) === false"><div class="display-flex content-center"><label disabled="role.name !== vm.rolesEnums.systemAdmin" ng-if="vm.isSystemAndRedCapAdmin" ng-click="vm.stopPropagation($event)"><switch disabled="role.name !== vm.rolesEnums.systemAdmin" id="has{{role.name}}" name="has{{role.name}}" ng-click="vm.roleClicked(role);" ng-model="role.assigned" class="green"></switch></label> <label class="inline" ng-if="vm.isSystemAndRedCapAdmin === false" ng-click="vm.stopPropagation($event)"><switch id="has{{role.name}}" name="has{{role.name}}" ng-click="vm.roleClicked(role);" ng-model="role.assigned" class="green"></switch></label> <label class="inline" ng-if="!vm.programAdmin && vm.verifyIfIsOnlyProgramAdminWithReports() === false" ng-click="vm.stopPropagation($event)"><switch id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green" disabled="false" ng-click="vm.roleClicked(role);"></switch></label> <label disabled="role.name !== vm.rolesEnums.systemAdmin && role.name !== vm.rolesEnums.redCapAdmin" ng-if="vm.redCapAdmin && !vm.systemAdmin" ng-click="vm.stopPropagation($event)"><switch disabled="role.name !== vm.rolesEnums.systemAdmin && role.name !== vm.rolesEnums.redCapAdmin" id="has{{role.name}}" name="has{{role.name}}" ng-click="vm.roleClicked(role);" ng-model="role.assigned" class="green"></switch></label> <label ng-disabled="role.name !== vm.rolesEnums.systemAdmin" ng-if="vm.systemAdmin && !vm.redCapAdmin" ng-click="vm.stopPropagation($event)"><switch disabled="role.name !== vm.rolesEnums.systemAdmin" id="has{{role.name}}" name="has{{role.name}}" ng-click="vm.roleClicked(role);" ng-model="role.assigned" class="green"></switch></label><div class="block relative"><i ng-if="vm.checkRoleCondition(role)" class="material-icons md-16 text-color-gray padding-left-md padding-bottom-md" uib-popover="{{role.tooltip}}" popover-append-to-body="true" popover-placement="bottom" popover-trigger="mouseenter">info_outline</i></div></div></div><div class="user-role-children" ng-repeat="childRole in vm.childRoles | filter: vm.filterChildRolesToDisplay(role)" ng-if="vm.isSystemAndRedCapAdmin && role.isHidden === false" ng-click="vm.stopPropagation($event)"><label class="col-sm-9 col-xs-9 user-role-label" for="has{{childRole.name}}" ng-class="{ \'margin-bottom-20\': $last, \'margin-none\': !$last }">{{childRole.displayText}}</label> <input type="checkbox" class="form-check-input col-sm-1 col-xs-1" id="has{{childRole.name}}" ng-disabled="true" ng-model="childRole.assigned"></div><div class="user-role-children" ng-repeat="childRole in vm.childRoles | filter: vm.filterChildRolesToDisplay(role)" ng-if="vm.systemAdmin && !vm.redCapAdmin && role.isHidden === false" ng-click="vm.stopPropagation($event)"><label class="col-sm-9 col-xs-9 user-role-label" for="has{{childRole.name}}" ng-class="{ \'margin-bottom-20\': $last, \'margin-none\': !$last }">{{childRole.displayText}}</label> <input type="checkbox" class="form-check-input col-sm-1 col-xs-1" id="has{{childRole.name}}" ng-disabled="true" ng-model="childRole.assigned"></div><div class="user-role-children" ng-repeat="childRole in vm.childRoles | filter: vm.filterChildRolesToDisplay(role)" ng-if="!vm.systemAdmin && vm.redCapAdmin && role.isHidden === false" ng-click="vm.stopPropagation($event)"><label class="col-sm-9 col-xs-9 user-role-label" for="has{{childRole.name}}" ng-class="{ \'margin-bottom-20\': $last, \'margin-none\': !$last }">{{childRole.displayText}}</label> <input type="checkbox" class="form-check-input col-sm-1 col-xs-1" id="has{{childRole.name}}" ng-disabled="true" ng-model="childRole.assigned"></div><div class="user-role-children" ng-repeat="childRole in vm.childRoles | filter: vm.filterChildRolesToDisplay(role)" ng-if="vm.isSystemAndRedCapAdmin === false && role.isHidden === false"><label class="col-sm-9 col-xs-9 user-role-label" for="has{{childRole.name}}" ng-class="{ \'margin-bottom-20\': $last, \'margin-none\': !$last }">{{childRole.displayText}}</label> <input type="checkbox" class="form-check-input col-sm-1 col-xs-1" id="has{{childRole.name}}" ng-disabled="!role.assigned" ng-model="childRole.assigned"></div><div class="user-role-children" ng-repeat="childRole in vm.childRoles | filter: vm.filterChildRolesToDisplay(role)" ng-if="!vm.programAdmin && vm.verifyIfIsOnlyProgramAdminWithReports() === false && role.isHidden === false"><label class="col-sm-9 col-xs-9 user-role-label" for="has{{childRole.name}}" ng-class="{ \'margin-bottom-20\': $last, \'margin-none\': !$last }">{{childRole.displayText}}</label> <input type="checkbox" class="form-check-input col-sm-1 col-xs-1" id="has{{childRole.name}}" ng-disabled="!role.assigned" ng-model="childRole.assigned"></div></div></div><label class="col-md-2 hidden-sm hidden-xs control-label"><span class="cursor-pointer hover-underline" uib-popover="Select one or more products that this user has access to" popover-trigger="outsideClick">Products</span></label><h3 class="visible-xs padding-bottom-sm border-bottom margin-bottom-lg">Products</h3><div class="col-md-4 col-sm-6 col-xs-12"><div class="margin-bottom-md visible-sm"><label class="control-label"><span class="cursor-pointer hover-underline" uib-popover="Select one or more products that this user has access to" popover-trigger="outsideClick">Products</span></label></div><div ng-repeat="role in vm.featureRoles | filter: vm.filterFeatureRolesToDisplay" ng-if="role.isHidden === false"><label class="col-sm-8 col-xs-8 control-label" for="has{{role.name}}">{{role.displayText}}</label><div class="col-sm-3 col-xs-3" ng-if="vm.isRoleDisabled(role) === true"><label><switch disabled="true" id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green"></switch></label></div><div class="col-sm-3 col-xs-3" ng-if="vm.isRoleDisabled(role) === false"><label ng-if="vm.isSystemAndRedCapAdmin" ng-click="vm.stopPropagation($event)"><switch disabled="true" id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green"></switch></label> <label ng-if="vm.isSystemAndRedCapAdmin === false && vm.verifyIfIsOnlyProgramAdminWithReports() === false"><switch id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green"></switch></label> <label ng-if="vm.redCapAdmin && !vm.systemAdmin" ng-click="vm.stopPropagation($event)"><switch disabled="true" id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green"></switch></label> <label ng-if="!vm.redCapAdmin && vm.systemAdmin" ng-click="vm.stopPropagation($event)"><switch disabled="true" id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green"></switch></label> <label ng-if="!vm.programAdmin && vm.verifyIfIsOnlyProgramAdminWithReports() === false"><switch disabled="false" id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green" ng-change="vm.switchClicked(role)"></switch></label> <label ng-if="vm.onlyProgramAdmin()" ng-click="vm.stopPropagation($event)"><switch disabled="true" id="has{{role.name}}" name="has{{role.name}}" ng-model="role.assigned" class="green"></switch></label></div></div></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row flex-xs-column full-width"><event-alert class="flex-container-hide-empty flex-percent-40 flex-xs-percent-100 text-left"></event-alert><div class="flex-grow flex-percent-60 flex-xs-percent-100"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="user-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.updateUser()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.sendingPasswordResetEmail">Update</button></div></div></div></div></div></div><script type="text/ng-template" id="dealerAdmin-popover-template.html"><div> {{vm.dealerAdminTooltip}} To set this role up, please open a <a ng-href="{{vm.absUrl}}/softwareHelp">support ticket.</a> </div></script>');
$templateCache.put('app/areas/user/views/user-tab-settings.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width-height" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="form-horizontal padding-lg"><h3>User Settings</h3><p>Specific user settings.</p><hr><form role="form" name="UserEditForm" class="form userEditForm" ng-submit="UserEditForm.$valid && vm.updateUser()" novalidate=""><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s outbound \'From\' email Address." popover-trigger="outsideClick">Outbound Email</span></label><div class="col-sm-4"><input type="email" id="email_address" name="email_address" ng-model="vm.currentUser.email" class="form-control" validation="required"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Disable the user\'s account to prevent them from logging in." popover-trigger="outsideClick">Account Disabled</span></label><div class="col-sm-4"><input type="checkbox" id="account_disabled" name="account_disabled" ng-model="vm.currentUser.isDisabled" ng-change="vm.selectDefaultTripTypeUser()"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="The user\'s account is locked out. They will be able to try again in 5 minutes, or instruct user to click \'Forgot Password\' link to reset their password." popover-trigger="outsideClick">Account Locked</span></label><div class="col-sm-4"><input type="checkbox" id="account_locked" name="account_locked" ng-model="vm.currentUser.accountLocked" disabled=""></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Require the user to change their password at the next login." popover-trigger="outsideClick">Require Password Change at Login</span></label><div class="col-sm-4"><input type="checkbox" id="requires_passwordchange" name="requires_passwordchange" ng-model="vm.currentUser.requiresPasswordChange"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable emailing a customer when they book, edit or cancel a trip." popover-trigger="outsideClick">Receive emails for book, edit,cancel,<br>and survey responses</span></label><div class="col-sm-4"><input type="checkbox" id="enable_emailcc" name="enable_emailcc" ng-model="vm.currentUser.enableEmailCC"></div></div><div class="form-group" ng-if="vm.showMFAToggle"><label class="col-sm-4 control-label">Disable MFA</label><div class="col-sm-4"><switch id="disableSolidMFA" name="disableSolidMFA" ng-model="vm.currentUser.disableSolidMFA" class="green"></switch></div></div></form></div></div><div class="flex-fullwidth-70h shadow-border-top"><div class="display-flex flex-row full-width text-right padding-right-20 content-center height-px-70"><div class="display-flex flex-row full-width"><div class="flex-grow flex-percent-30 flex-xs-percent-40"><event-alert></event-alert></div><div class="flex-grow flex-percent-70 flex-xs-percent-60"><button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="user-list">Close</button> <button type="button" class="btn btn-default margin-right-xs" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="button" ng-click="vm.updateUser()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.sendingPasswordResetEmail">Update</button></div></div></div></div></div></div>');
$templateCache.put('app/shared/components/appointments/approved-services-confirmation.component.view.html','<div class="row border-bottom margin-top"><div class="col-sm-11 col-xs-10"><h3 class="title"><div class="black"><strong>YOUR APPROVED SERVICES</strong></div></h3></div></div><div class="row total-estimate-row border-bottom margin-top-sm"><div class="col-sm-6 col-xs-6 margin-bottom-sm"><div class="text-uppercase"><strong>TOTAL ESTIMATE</strong></div></div><div class="col-sm-6 col-xs-6 margin-bottom-sm text-right"><strong>{{vm.getTotalEstimate() | currency}}</strong><br>(Not incl. taxes or fees)</div></div><div ng-repeat="lineItem in vm.services" class="approved-services row border-bottom margin-top-sm margin-bottom"><div class="col-sm-12 col-xs-12"><div class="text-uppercase margin-bottom" ng-if="lineItem.isRecall"><b>RECALL (#{{lineItem.manufacturerNumber}})</b><div class="margin-top-sm">{{lineItem.recallDisplayName}}</div></div><div class="text-uppercase margin-bottom" ng-if="lineItem.isRecommendedMaintenance"><b>RECOMMENDED MAINTENANCE</b><div class="margin-top-sm">{{lineItem.opCodeDescription}}</div></div><div class="text-uppercase" ng-if="lineItem.isGeneric"><b>CONSUMER SERVICE NEEDS</b><div class="margin-top-sm">{{lineItem.note}}</div></div><div class="text-uppercase" ng-if="lineItem.isOther"><b>{{lineItem.overrideName}}</b><div ng-if="lineItem.note && lineItem.note.length > 0"><div class="text-uppercase">{{lineItem.note}}</div></div><div class="text-uppercase" ng-if="!lineItem.note || lineIte.note.length === 0">NO CUSTOMER COMPLAINT ENTERED</div></div><div ng-if="lineItem.isGeneric === true || lineItem.isRecommendedMaintenance === true || lineItem.isRecall === true || lineItem.isOther === true"><div class="margin-top-sm margin-bottom-sm text-right"><b>{{(lineItem.retailPrice || 0) | currency }}</b></div></div><div ng-if="lineItem.isRecall === false && lineItem.isRecommendedMaintenance === false && lineItem.isGeneric === false && lineItem.isOther === false"><div ng-if="vm.isDashboard == true"><span class="text-uppercase"><b>{{lineItem.overrideName || lineItem.dealerAppointmentServiceOpCode.dashboardName || lineItem.dealerAppointmentServiceOpCode.name}}</b></span></div><div ng-if="vm.isDashboard == false"><span class="text-uppercase"><b>{{lineItem.overrideName || lineItem.dealerAppointmentServiceOpCode.consumerName || lineItem.dealerAppointmentServiceOpCode.name}}</b></span></div><div ng-if="lineItem.note && lineItem.note.length > 0"><div class="text-uppercase">{{ lineItem.note }}<br></div></div><div class="text-uppercase" ng-if="!lineItem.note || lineIte.note.length === 0">NO CUSTOMER COMPLAINT ENTERED</div><div class="margin-top-sm margin-bottom-sm text-right"><b>{{(lineItem.retailPrice || 0) | currency }}</b></div></div></div></div>');
$templateCache.put('app/shared/components/appointments/department-landingpage-settings.component.view.html','<div class="row margin-top-md" ng-class="{\'margin-top-30\': vm.index !== 0}"><div class="col-sm-6 col-xs-6 margin-top-md">{{vm.ngModel.name}}</div><div class="col-sm-4 col-xs-6"><switch id="dept_{{vm.ngModel.id}}_showInConsumer" name="dept_{{vm.ngModel.id}}_showInConsumer" ng-model="vm.ngModel.showInConsumer" class="green" title="SHOW IN CONSUMER"></switch></div><div class="col-sm-4 hidden-xs">&nbsp;</div></div><div class="row margin-top-md"><div class="col-sm-2 col-xs-2 padding-right-none text-capitalize"><input type="text" validation="between_num:1,100:alt=Required<br/>(1-100)" name="rank_{{vm.ngModel.id}}" class="better-placeholder form-control text-uppercase no-spinners" placeholder="RANK" ng-model="vm.ngModel.rank" ng-disabled="!vm.ngModel.showInConsumer" ng-required="vm.ngModel.showInConsumer"></div><div class="col-sm-10 col-xs-10"><input type="text" name="title_{{vm.ngModel.id}}" class="better-placeholder form-control text-uppercase" placeholder="DEPARTMENT TITLE" ng-model="vm.ngModel.consumerTitle" ng-disabled="!vm.ngModel.showInConsumer"></div></div><div class="row margin-top-md"><div class="col-sm-12 col-xs-12"><textarea name="description_{{vm.ngModel.id}}" ng-model="vm.ngModel.consumerDescription" rows="5" class="form-control resize-none" placeholder="DEPARTMENT DESCRIPTION" ng-disabled="!vm.ngModel.showInConsumer"></textarea></div></div>');
$templateCache.put('app/shared/components/appointments/dignifi.component.view.html','<img class="link" id="prequal-button" src="https://redcapstorage.blob.core.windows.net/automotivelogos/dignifi.jpg" ng-click="vm.openDigniFi()">');
$templateCache.put('app/shared/components/appointments/lineitem-image-display.component.view.html','<div ng-if="vm.images.length" class="image-grid w-85 h-85 margin-top padding-bottom-sm padding-left-none lineitem-image-display-component"><div class="grid-item" ng-repeat="file in vm.images track by $index"><div class="small-grey-boxes position-relative"><img class="image-container position-relative" ng-if="vm.getMediaType(file) === vm.mediaTypes.photo" ng-click="vm.openImage(file, vm.mediaTypes.photo)" ng-src="{{file.mediaUrl || file.url}}"><video class="image-container position-relative" ng-if="vm.getMediaType(file) === vm.mediaTypes.video" ng-click="vm.openImage(file, vm.mediaTypes.video)" ng-src="{{file.mediaUrl || file.url}}"></video><span class="overlay" ng-if="vm.getMediaType(file) === vm.mediaTypes.video" ng-click="vm.openImage(file, vm.mediaTypes.video)"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center font-size-10" ng-if="!vm.hideDate && file.dateTaken">{{ file.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div></div>');
$templateCache.put('app/shared/components/appointments/previously-declined-service-item.component.view.html','<div class="input-group full-width"><div class="row"><div class="col-xs-1 recall-checkbox padding-right-none" ng-if="!vm.isCheckin"><span class="severity-icon" ng-if="vm.enumSeverity" title="{{vm.enumSeverity.tooltip}}"><i class="material-icons {{vm.enumSeverity.cssClass}} cursor-pointer">{{vm.enumSeverity.icon}}</i></span></div><div class="col-sm-7 col-md-8 col-xs-6 display-flex padding-left-sm padding-right-none"><input type="checkbox" class="form-check-input margin-top-none" ng-click="vm.prevDeclinedLineItemToggled();" ng-disabled="vm.isDisabled === true" ng-value="vm.prevDeclined.id" ng-checked="vm.prevDeclined.checked"><div class="previously-declined text-uppercase margin-left-sm whitespace-normal word-break-wrap" ng-class="{\'mismatched\': vm.prevDeclined.departmentPrevDeclinedMismatch === true || vm.isDisabled === true}"><span><b>{{::vm.getName()}}</b></span> <span ng-if="vm.isDisabled === true" class="cursor-pointer hover-underline" uib-popover="This service is not available in the selected department." popover-trigger="outsideClick" popover-placement="right" popover-class="increase-popover-width2"><i class="material-icons info-icon">info_outline</i></span> <span ng-if="vm.prevDeclined.departmentPrevDeclinedMismatch === true" popover-class="increase-popover-width" class="cursor-pointer hover-underline" uib-popover="Not included in dept. defaults" popover-placement="right" popover-trigger="mouseenter"><i class="material-icons info-icon mismatched text-danger">info_outline</i></span> <span ng-if="vm.prevDeclined.note && vm.prevDeclined.note.length > 0">- {{vm.prevDeclined.note}}</span></div></div><div class="col-sm-4 col-md-3 col-xs-5 padding-left-none declined-service-radio-buttons padding-right-none" ng-class="{\'pull-right\': vm.isCheckin}"><label class="font-normal prev-line-item-delete-decline margin-none"><input type="checkbox" name="acceptDecline-{{vm.prevDeclined.id}}" ng-model="vm.prevDeclined.deletedDeclined" ng-value="vm.deletedDeclined.deleted" ng-click="vm.deleteClicked()"> <span class="declined-service-label">NOT INTERESTED</span></label></div><div class="col-sm-8 col-md-8 col-xs-12 whitespace-normal padding-right-none" ng-class="{\'consumer-declined-service\': !vm.isDashboard}" ng-if="vm.prevDeclined.checked"><div class="margin-bottom-sm">{{::vm.getDescription()}}</div></div></div><lineitem-edit-properties ng-if="vm.prevDeclined.checked && vm.isDashboard && !vm.prevDeclined.isRecommendedMaintenance" appointment="vm.appointment" is-rec-maint="false" is-prev-declined="true" ng-model="vm.prevDeclined" remove-padding="true" is-checkin="vm.isCheckin" dms-system="vm.dmsSystem" service-types="vm.serviceTypes" show-note="true" is-form-valid="vm.parent_vm.isFormValid()" ,="" is-validating-recalls="vm.validatingRecalls" require-dispatch-code="vm.requireDispatchCode"></lineitem-edit-properties></div>');
$templateCache.put('app/shared/components/appointments/vehicle-details-issues.component.view.html','<div class="appointments-wizard"><h4 class="panel-title margin-top-30"><div class="padding-bottom-xs margin-top-sm black">VEHICLE DETAILS</div></h4><div class="appt-summary margin-bottom border-top" ng-if="!vm.isCheckedIn() && !vm.isCheckingIn()"><div class="margin-top">PENDING CHECK IN</div></div><div class="row border-top" ng-if="vm.isCheckedIn() || vm.isCheckingIn()"><div class="col-xs-11"><div class="margin-top text-uppercase"><span class="appt-semi-bold">Odometer:</span> {{vm.appointment.mileage| number : fractionSize}} {{ vm.appointment.mileageType.abbreviation }}</div></div></div><h4 class="panel-title margin-top-30"><div class="padding-bottom-xs margin-top-sm black">VEHICLE PHOTOS</div></h4><div class="row border-top" ng-if="vm.isCheckedIn() || vm.isCheckingIn()"><div class="col-xs-11 margin-top"><div class="margin-top-sm text-uppercase"><span class="appt-semi-bold">DAMAGE AND ISSUES</span> <span class="padding-left-sm inline" ng-if="vm.loadingImages === false && vm.vehicleConditions">({{vm.vehicleConditions.length}} Item<span ng-if="vm.vehicleConditions.length !== 1">s</span>)</span> <span class="padding-left-sm theme-link inline" ng-if="vm.loadingImages === false && vm.vehicleConditions.length > 0" ng-click="vm.showDamageAndIssues = !vm.showDamageAndIssues">{{vm.showDamageAndIssues ? \'Hide\' : \'Show\'}}</span></div></div></div><div class="row" ng-repeat="condition in vm.vehicleConditions" ng-if="vm.vehicleConditions.length > 0 && vm.showDamageAndIssues"><div class="col-xs-11 margin-bottom-20 padding-top-md"><div class="row"><div class="col-xs-12 margin-bottom-md"><div>{{condition.description}}</div></div></div><div class="image-grid w-85 h-85" ng-if="condition.images && condition.images.length > 0"><div class="grid-item" ng-repeat="itemImage in condition.images track by $index"><div ng-if="itemImage.url"><div class="small-grey-boxes position-relative"><img class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.photo" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, condition.description, vm.mediaTypes.photo)"><video class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, condition.description, vm.mediaTypes.video)"></video><span ng-click="vm.openImageModal(itemImage.url, condition.description, vm.mediaTypes.video)" class="overlay" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center font-size-10" ng-if="itemImage.dateTaken">{{ itemImage.dateTaken | localDate:\'MMM D h:mm A\' }}</div><div class="text-center font-size-11">{{ itemImage.description }}</div></div></div></div><div ng-if="!condition.images || condition.images.length === 0"><div class="text-left font-size-11"><li>{{ condition.description }}</li></div></div></div></div><div class="row" ng-if="vm.isCheckedIn() || vm.isCheckingIn()"><div class="col-xs-11"><div class="text-uppercase"><span class="appt-semi-bold">ADDITIONAL PHOTOS</span> <span class="padding-left-sm inline" ng-if="vm.loadingImages === false && vm.predifinedImages">({{vm.totalPredifinedImages}} Item<span ng-if="vm.totalPredifinedImages !== 1">s</span>)</span> <span class="padding-left-sm theme-link inline" ng-if="vm.loadingImages === false && vm.predifinedImages && vm.predifinedImages.length > 0" ng-click="vm.showPredifinedMediaItems = !vm.showPredifinedMediaItems">{{vm.showPredifinedMediaItems ? \'Hide\' : \'Show\'}}</span></div></div></div><div class="row" ng-repeat="predifinedItem in vm.predifinedImages" ng-if="vm.showPredifinedMediaItems"><div class="col-xs-11 margin-bottom-20 padding-top-md"><div class="row"><div class="col-xs-12 margin-bottom-md"><b><div class="text-uppercase">{{predifinedItem.categoryDesc}}</div></b></div></div><div class="image-grid w-80 h-80 padding-bottom-md"><div class="grid-item" ng-repeat="itemImage in predifinedItem.images track by $index"><div ng-if="itemImage.imageId"><div class="small-grey-boxes position-relative"><img class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.photo" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url,predifinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.photo)"><video class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, predifinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.video)"></video><span ng-click="vm.openImageModal(itemImage.url, predifinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.video)" class="overlay" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center font-size-10" ng-if="itemImage.dateTaken">{{ itemImage.dateTaken | localDate:\'MMM D h:mm A\' }}</div><div class="text-center font-size-10">{{ itemImage.description }}</div></div></div></div></div></div></div>');
$templateCache.put('app/shared/components/appointments/vehicle-ro-history.component.view.html','<div class="vehicle-history-panel padding-left-md"><div class="row text-uppercase padding-lg border-bottom margin-right-none theme-bg"><div class="padding-left-none"><span class="font-size-14 font-bold">Service History</span></div><div class="padding-left-none"><span class="font-size-14">{{ vm.year }} {{ vm.make }} {{ vm.model }} ({{ vm.vin }})</span></div></div><div id="vehicle-history-list" class="padding-left-md padding-top-sm margin-top-md padding-right-20 bg-white"><div class="tab-content"><div ng-if="vm.loading"><img src="assets/images/ajax-loader.gif" class="margin-right-xs"> Loading</div><div class="panel-title padding-bottom-lg" ng-if="vm.roHistories.length == 0">No RO History found for this vehicle</div><div class="panel-title padding-bottom-lg" ng-repeat="ro in vm.roHistories track by $index"><div class="row border-bottom-thin margin-left-sm margin-right-md padding-bottom-sm" ng-init="$index < 10 && vm.getDetails(ro.roNumber)"><div class="col-sm-2 col-xs-3 padding-left-none"><b>RO#{{ ro.roNumber }}</b></div><div class="col-sm-2 hidden-xs text-uppercase padding-left-none">{{ ro.roClosed | date:\'MMM dd, yyyy\'}}</div><div class="col-xs-2 visible-xs hidden-sm hidden-md hidden-lg hidden-xl text-uppercase padding-left-none">{{ ro.roClosed | date:\'MM/dd/yyyy\'}}</div><div class="col-sm-3 col-xs-2 text-uppercase ellipsis-overflow">{{ ro.customerFirst }} {{ ro.customerLast }}</div><div class="col-sm-3 col-xs-2 text-uppercase ellipsis-overflow" title="Service Advisor">{{ (ro.advisorFirst && ro.advisorLast) ? (ro.advisorFirst + " " + ro.advisorLast) : "Advisor " + (ro.serviceAdvisorNumber || "NA") }}</div><div class="col-sm-2 col-xs-2 padding-left-none" ng-if="ro.odometer">{{ ro.odometer }}{{ vm.getOdometerAbbreviation(ro.mileageType).toLowerCase() }}</div></div><div class="row padding-left-sm margin-left-sm padding-top-sm" ng-if="$index >= 10 && ro.opCodes == null || ro.opCodes.length == 0"><a href="#" class="col-xs-12" ng-click="vm.getDetails(ro.roNumber, true)">Load RO Details</a></div><div class="row padding-left-sm margin-left-sm padding-top-sm" ng-repeat="opcode in ro.opCodes track by $index"><div class="col-xs-12"><b class="text-uppercase">{{ ("00"+($index + 1)).slice(-2) }}&nbsp;&nbsp;&nbsp;{{ opcode.opCode }}</b> - {{ opcode.opCodeDescription }}</div><div class="col-xs-12" ng-if="opcode.serviceRequest.length > 0">COMPLAINT: {{ opcode.serviceRequest }}</div></div></div></div></div></div>');
$templateCache.put('app/shared/components/asideHeader/aside-header.component.view.html','<div class="display-flex flex-row full-width text-uppercase padding-sm override-sm-padding-none"><div class="flex-percent-60"><div ng-if="vm.constructedTitle" class="text-uppercase ellipsis-overflow font-size-16 bold" ng-bind-html="vm.constructedTitle"></div><div class="text-uppercase ellipsis-overflow hidden-xs hidden-sm margin-bottom-20" ng-if="vm.ngModel.trip.workFlowId === vm.tripWorkflowTypes.partsOnDemandToFromAny"><span class="title">FROM: {{ vm.ngModel.trip.overrideServiceAdvisorFirstName }} {{ vm.ngModel.trip.overrideServiceAdvisorLastName }}<br></span> {{ vm.ngModel.trip.overrideServiceAdvisorMobile | tel }}</div><div class="text-uppercase ellipsis-overflow font-size-14 font-bold" ng-class="{\'inline\': vm.ngModel.trip.workFlowId === vm.tripWorkflowTypes.partsOnDemandToFromAny}"><span ng-if="vm.ngModel.trip.workFlowId === vm.tripWorkflowTypes.partsOnDemandToFromAny">TO:</span>{{ vm.ngModel.trip.customerName }}<span ng-if="vm.ngModel.trip.workFlowId === vm.tripWorkflowTypes.partsOnDemandToFromAny"><br></span></div><div ng-if="vm.ngModel.customer"><div class="block text-uppercase ellipsis-overflow font-size-14 bold" ng-if="!vm.ngModel.trip"><span class="padding-right-sm" ng-if="vm.ngModel.customer.firstName">{{vm.ngModel.customer.firstName}}</span>{{vm.ngModel.customer.lastName}}</div><div class="display-flex"><div class="position-relative padding-right-md" ng-if="vm.ngModel.customer.mobilePhone"><span ng-if="vm.ngModel.customer.mobilePhone">{{vm.ngModel.customer.mobilePhone | tel}}</span> <span class="margin-bottom-sm"><phone-type-indicator ng-if="vm.ngModel.customer.mobilePhone" phone-number="vm.ngModel.customer.mobilePhone"></phone-type-indicator></span></div><span ng-if="!vm.ngModel.customer.mobilePhone">(No Phone Number)</span> <i class="material-icons md-14 align-text-bottom" ng-if="!vm.ngModel.customer.mobilePhone" uib-popover="There is no phone number assigned to this contact" popover-append-to-body="true" popover-trigger="mouseenter">phonelink_erase</i></div><div ng-if="vm.ngModel.customer.emailAddress" class="padding-left-none hidden-xs">{{vm.ngModel.customer.emailAddress}}</div></div><div class="padding-left-none" ng-if="vm.ngModel.vehicle"><b>{{vm.ngModel.vehicle.year}} {{vm.ngModel.vehicle.make}} {{vm.ngModel.vehicle.model}} <span ng-if="vm.ngModel.vehicle.vin">({{vm.ngModel.vehicle.vin.slice(-8)}})</span></b></div><div ng-if="vm.ngModel.contract">Contract #{{vm.ngModel.contract.externalConfirmationToken}} <span ng-if="vm.ngModel.contract.isCancelled === false && vm.ngModel.contract.currentState && vm.ngModel.contract.currentState != \'\'">({{vm.ngModel.contract.currentState}})</span></div><div ng-if="vm.ngModel.dealer" class="visible-xs">{{vm.ngModel.dealer.name}}{{ (vm.ngModel.dealer.showOemId && vm.ngModel.dealer.oemDealerId) ? " (" + vm.ngModel.dealer.oemDealerId + ")" : "" }}</div><div ng-if="vm.ngModel.serviceAdvisor" class="visible-xs"><div ng-if="vm.ngModel.serviceAdvisor.lastName || vm.ngModel.serviceAdvisor.firstName">{{vm.ngModel.serviceAdvisor.firstName}} {{vm.ngModel.serviceAdvisor.lastName}}</div><div ng-if="vm.ngModel.serviceAdvisor.fullName">{{vm.ngModel.serviceAdvisor.fullName}}</div></div></div><div class="flex-percent-40 padding-top-none theme-bg text-nowrap text-right no-print"><div class="hidden-xs hidden-sm pull-right" ng-show="vm.showPrintOption"><div class="theme-link width-px-30" ng-click="vm.printClicked()" title="Print" id="print"><i class="material-icons md-24">print</i></div></div><div class="visible-xs visible-sm full-width"><div class="pull-right padding-left-xs"><span class="theme-link padding-right-sm" ng-show="vm.showPrintOption" ng-click="vm.printClicked()" title="Print" id="print"><i class="material-icons md-24">print</i></span> <span id="enable-messages-link" class="theme-link" ng-click="vm.enableMessaging(true)"><i class="material-icons md-24">forum</i></span> <span id="disable-messages-link" class="theme-link" ng-click="vm.enableMessaging(false)"><i class="material-icons md-24">comments_disabled</i></span></div></div><div class="hidden-xs"><div ng-if="vm.ngModel.invoice"><div ng-if="vm.ngModel.invoice.statusDescription" class="font-size-12 font-bold">{{vm.ngModel.invoice.statusDescription}} <span ng-if="vm.ngModel.invoice.cardType">- {{vm.ngModel.invoice.cardType}}</span></div></div><div ng-if="vm.ngModel.trip" class="font-size-14 font-bold ellipsis-overflow" title="{{ vm.ngModel.trip.customerExpectedTime | date:\'MM/dd/yy\' }} at {{ vm.ngModel.trip.customerExpectedTime | date:\'h:mma\' }} {{ vm.ngModel.trip.systemTripTypeId == 1 && vm.ngModel.trip.dmsImported == true ? (\'DMS APPT \' + (vm.ngModel.trip.apptDate | date: \'MM/dd/yy h:mma\')) : vm.ngModel.trip.systemTripTypeId == 2 ? (\'(RO \' + vm.ngModel.trip.roNumber + \') \' + vm.ngModel.trip.roStatus ): \'\' }} #{{ vm.ngModel.trip.id }}"><span>{{ vm.ngModel.trip.customerExpectedTime | date:\'MM/dd/yy\' }} at {{ vm.ngModel.trip.customerExpectedTime | date:\'h:mma\' }}</span> <span>{{ vm.ngModel.trip.systemTripTypeId == 1 && vm.ngModel.trip.dmsImported == true ? (\'DMS APPT \' + (vm.ngModel.trip.apptDate | date: \'MM/dd/yy h:mma\')) : vm.ngModel.trip.systemTripTypeId == 2 ? (\'(RO \' + vm.ngModel.trip.roNumber + \') \' + vm.ngModel.trip.roStatus ): \'\' }}</span> <span ng-if="vm.ngModel.trip.systemTripTypeId === vm.shortSystemTripType.partsOnDemand && vm.ngModel.trip.referenceNumber">(REF #{{vm.ngModel.trip.referenceNumber}})</span> #{{ vm.ngModel.trip.id }}</div><div ng-if="vm.ngModel.trip" class="text-uppercase text-right col-vcentered"><span title="vm.ngModel.trip.workflowName">{{ vm.ngModel.trip.workflowName }}</span> <span ng-if="::(vm.ngModel.trip.systemTripTypeId == vm.shortSystemTripType.pickup || vm.shortSystemTripType.dropoff == vm.ngModel.trip.systemTripTypeId || vm.shortSystemTripType.recalls == vm.ngModel.trip.systemTripTypeId || vm.ngModel.trip.systemTripTypeId == vm.shortSystemTripType.mobileGarage)"><span ng-if="vm.ngModel.hasLoanerPermission && vm.ngModel.trip.externalReservationId && vm.ngModel.trip.dealerAppointmentId"><br></span> <span ng-if="vm.ngModel.trip.dealerAppointmentId">APPT <a title="Appointment ID" class="theme-link" ui-sref="appointment-details({\'locationId\': vm.ngModel.trip.dealer.id, \'appointmentId\': vm.ngModel.trip.dealerAppointmentId})"><span ng-if="vm.ngModel.dealer.dmsSystem === vm.dmsProviderTypes.None">#{{vm.ngModel.trip.dealerAppointmentId}}</span> <span ng-if="vm.ngModel.dealer.dmsSystem !== vm.dmsProviderTypes.None"><span class="ellipsis-overflow max-width-px-110 inline-block col-vcentered padding-bottom-3" ng-if="!vm.ngModel.trip.dealerDMSApptNumber && vm.apptIdIsValid(vm.ngModel.trip.dealerDMSAppointmentId)">#{{ vm.removePipedData(vm.ngModel.trip.dealerDMSAppointmentId) }}</span> <span title="{{ vm.ngModel.trip.dealerDMSApptNumber }}" ng-if="vm.ngModel.trip.dealerDMSApptNumber">#{{ vm.ngModel.trip.dealerDMSApptNumber }}</span> <span ng-if="!vm.apptIdIsValid(vm.ngModel.trip.dealerDMSAppointmentId)">PENDING</span></span></a></span> <span ng-if="vm.ngModel.hasLoanerPermission && vm.ngModel.trip.externalReservationId"><span ng-if="vm.ngModel.trip.dealerAppointmentId">/</span> Loaner <a title="Loaner Reservation" class="theme-link inline" ng-if="vm.ngModel.trip.externalReservationId" ui-sref="loaner-reservation-edit({\'reservationId\': vm.ngModel.trip.externalReservationId, \'locationId\': vm.ngModel.trip.dealer.id})">#{{vm.ngModel.trip.loanerConfirmationNumber}}</a></span></span></div><div ng-if="vm.ngModel.dealer">{{vm.ngModel.dealer.name}}{{ (vm.ngModel.dealer.showOemId && vm.ngModel.dealer.oemDealerId) ? " (" + vm.ngModel.dealer.oemDealerId + ")" : "" }}</div><div ng-if="vm.ngModel.trip.loanerPreferences" class="text-uppercase ellipsis-overflow"><span ng-if="vm.ngModel.trip.loanerPreferences.transportationType == vm.cflTransportationTypes.lyftCredit && vm.ngModel.trip.dealerHasLoanerPreferencesEnabled === true">Preference: Lyft Credit <span class="theme-link" ng-if="vm.ngModel.trip.loanerRideProviderCredit" ui-sref="lyft-credit-edit({ id: vm.ngModel.trip.loanerRideProviderCredit.id, isTest: vm.ngModel.trip.loanerRideProviderCredit.isTest === true ? 1 : 0})">#{{vm.ngModel.trip.loanerRideProviderCredit.id}}</span></span> <span ng-if="vm.ngModel.trip.loanerPreferences.transportationType == vm.cflTransportationTypes.firstAvailable && vm.ngModel.trip.dealerHasLoanerPreferencesEnabled === true">Preference: 1st Available Loaner</span> <span ng-if="vm.ngModel.trip.loanerPreferences.transportationType == vm.cflTransportationTypes.chooseLoaner && vm.ngModel.trip.loanerPreferences.vehicles && vm.ngModel.trip.dealerHasLoanerPreferencesEnabled === true">Preference #1: {{vm.ngModel.trip.loanerPreferences.vehicles[0].model}}, Preference #2: {{vm.ngModel.trip.loanerPreferences.vehicles[1].model}}</span></div><div ng-if="vm.ngModel.serviceAdvisor"><div ng-if="vm.ngModel.serviceAdvisor.lastName || vm.ngModel.serviceAdvisor.firstName">{{vm.ngModel.serviceAdvisor.firstName}} {{vm.ngModel.serviceAdvisor.lastName}}</div><div ng-if="vm.ngModel.serviceAdvisor.fullName">{{vm.ngModel.serviceAdvisor.fullName}}</div></div><div ng-if="vm.ngModel.invoice"><div ng-if="vm.ngModel.invoice.id">Invoice #{{vm.ngModel.invoice.id}} <span ng-if="vm.ngModel.invoice.isArchived">(Archived)</span> <span ng-if="vm.ngModel.invoice.statusDescription">({{vm.ngModel.invoice.statusDescription}})</span></div></div><div ng-if="vm.ngModel.isTestTrip === true" class="font-bold text-uppercase"><b>TEST TRIP</b></div></div></div></div>');
$templateCache.put('app/shared/components/authorizations/authorization-history-list.view.html','<div><div class="row total-estimate-row margin-top-sm margin-bottom-sm"><div class="col-sm-12 col-xs-12 font-size-12"><div class="text-uppercase"><strong>AUTHORIZATION HISTORY</strong></div></div></div><div ng-if="vm.loadingAuthHistory"><img src="assets/images/ajax-loader.gif"></div><div ng-if="!vm.loadingAuthHistory"><div ng-if="!vm.authorizationHistory.length"><div>No Authorization History was found for this RO</div></div><div ng-repeat="authorization in vm.authorizationHistory" class="row"><div ng-if="authorization.signatureDataId" class="col-sm-12 col-xs-12 text-uppercase padding-bottom-sm"><span ng-click="vm.gotoAuthHistory($index, authorization)" class="theme-link"><span ng-if="vm.dashboardHistoryMode">{{authorization.displayText}}</span> <span ng-if="!vm.dashboardHistoryMode">{{authorization.createdDate | date:\'MMMM d\'}} at {{authorization.createdDate | date:\'h:mm a\'}} ({{(authorization.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.approved }).length}} APPROVED {{(authorization.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.deferred }).length}} DEFERRED)</span></span></div></div></div></div>');
$templateCache.put('app/shared/components/authorizations/authorize-pending-lineitem.component.view.html','<div class="pending-lineitem-authorization"><div class="pending-lineitem-content"><div><span class="display-flex line-height-14"><i ng-if="vm.showSeverityIcon()" class="material-icons md-14 {{vm.enumSeverity.cssClass}} cursor-pointer padding-right-xs" title="{{vm.enumSeverity.tooltip}}">{{vm.enumSeverity.icon}}</i> <span class="text-bold text-uppercase"><span text-ellipse="" use-arrow-icons="true"><span>{{ vm.computedName }}{{ vm.computedDescription }}</span> <span>{{ vm.formattedCorrection }}</span></span></span></span></div><div><div ng-if="vm.showSeverityIcon()" class="font-size-10 {{vm.enumSeverity.cssClass}}">{{ vm.enumSeverity.customerMessage }}</div><div class="line-item-addedby" ng-if="vm.lineItem.createdBy && vm.lineItem.createdBy.isConsumerUser">Original Customer Request</div><div class="line-item-addedby" ng-if="vm.lineItem.createdBy && !vm.lineItem.createdBy.isConsumerUser">Added by {{vm.lineItem.createdBy.firstName}} {{vm.lineItem.createdBy.lastName}}</div><div ng-if="vm.checkinSummary" class="display-flex flex-row full-width"><div class="line-item-addedby display-flex flex-percent-95 flex-shrink">ESTIMATE <b>{{vm.lineItem.retailPrice | currency }}</b></div></div></div><div><div class="text-uppercase" ng-if="vm.lineItem.complaintString"><div class="margin-top-sm"><b>COMPLAINT/CONCERN</b></div><div ng-if="vm.lineItem.formattedComplaint" text-ellipse="" use-arrow-icons="true">{{ vm.lineItem.formattedComplaint }}</div></div><lineitem-image-display ng-model="vm.lineItem"></lineitem-image-display><div class="margin-top display-flex" ng-if="!vm.checkinSummary"><div class="display-flex content-center flex-percent-50"><div>ESTIMATE <b>{{vm.lineItem.retailPrice || 0 | currency }}</b></div><div class="display-flex" ng-if="!vm.lineItem.hideBreakdown && vm.lineItem.itemizedPricingEnabled && !vm.inspectionSummary"><i ng-if="!vm.showPricingBreakdown" class="material-icons md-24 cursor-pointer" ng-click="vm.showPricingBreakdown = !vm.showPricingBreakdown">expand_more</i> <i ng-if="vm.showPricingBreakdown" class="material-icons md-24 cursor-pointer" ng-click="vm.showPricingBreakdown = !vm.showPricingBreakdown">expand_less</i></div></div><div class="flex-percent-50 display-flex"><div class="print-to-pdf-only" ng-if="vm.inspectionSummary"><input type="checkbox" class="checkbox inline margin-none" ng-checked="vm.lineItem.authorizationStatus === vm.authorizationStatus.approved"><div class="font-size-14 font-semi-bold padding-left-sm padding-right-lg inline margin-bottom-md">ACCEPT</div><input type="checkbox" class="checkbox inline margin-none" ng-checked="vm.lineItem.authorizationStatus === vm.authorizationStatus.deferred"><div class="font-size-14 font-semi-bold padding-left-sm inline margin-bottom-md padding-right-lg">DEFER</div><div class="inline-block border-bottom-dark min-width-px-75"></div></div><div ng-if="!vm.readOnly && !vm.inspectionSummary" class="display-flex flex-right content-center text-uppercase"><label class="display-flex margin-none"><input class="margin-none" type="radio" name="acceptDecline-{{vm.lineItem.uniqueDOMId}}" ng-model="vm.lineItem.approvalStatus" required="" ng-value="vm.isApproved.approved" ng-change="vm.approvedClicked()"><div class="margin-left-sm font-normal text-uppercase">Accept</div></label> <label class="display-flex margin-none padding-left-20"><input class="margin-none" type="radio" name="acceptDecline-{{vm.lineItem.uniqueDOMId}}" ng-model="vm.lineItem.approvalStatus" required="" ng-value="vm.isApproved.declined" ng-change="vm.declinedClicked()"><div class="margin-left-sm font-normal text-uppercase">Defer</div></label></div></div></div><div class="text-uppercase" ng-class="{\'max-width-px-500\': vm.limitWidth}" ng-if="vm.inspectionSummary || vm.showPricingBreakdown"><hr class="margin-top-md margin-bottom-md"><div class="display-flex"><div>Labor</div><div class="flex-right">{{ vm.lineItem.useFlatPrice ? \'FLAT\' : (vm.lineItem.noLaborCharge ? \'NO CHG\' : (vm.lineItem.pricing.labor | currency)) }}</div></div><div class="display-flex margin-top-sm"><div>Parts Total</div><div class="flex-right">{{ vm.lineItem.useFlatPrice ? \'FLAT\' : (vm.lineItem.noPartsCharge ? \'NO CHG\' : (vm.lineItem.pricing.parts | currency)) }}</div></div><div ng-if="vm.lineItem.parts.length"><hr class="margin-top-md margin-bottom-md"><div class="padding-left-md margin-top-sm display-flex" ng-repeat="part in vm.lineItem.parts"><div class="flex-percent-50 padding-right"><span ng-if="part.description">{{part.partNumber}} - {{part.description}}</span> <span ng-if="!part.description">{{part.partNumber}}</span></div><div class="flex-percent-50 flex-justify-right display-flex min-width-0"><div class="flex-grow ellipsis-overflow padding-right-15" uib-popover="{{part.quantity}} x {{(part.overridePrice >= 0 ? part.overridePrice : part.retailPrice) | currency}}" popover-placement="left" popover-trigger="click">{{part.quantity}} x <span ng-if="!vm.lineItem.noPartsCharge && !vm.lineItem.useFlatPrice">{{(part.overridePrice >= 0 ? part.overridePrice : part.retailPrice) | currency }}</span> <span ng-if="vm.lineItem.noPartsCharge || vm.lineItem.useFlatPrice">{{vm.lineItem.useFlatPrice ? \'(FLAT)\' : \'(NO CHG)\'}}</span></div><div class="flex-static-size text-right text-nowrap"><span ng-if="!vm.lineItem.noPartsCharge && !vm.lineItem.useFlatPrice">{{ part.total | currency }}</span><span ng-if="vm.lineItem.useFlatPrice">FLAT</span><span ng-if="vm.lineItem.noPartsCharge">NO CHG</span></div></div></div></div></div></div></div></div>');
$templateCache.put('app/shared/components/authorizations/lineitem-edit-properties.component.view.html','<div class="row line-item-edit component" ng-if="vm.showNote === true" ng-class="{\'remove-padding\': vm.removePadding === true }"><div class="col-xs-12 margin-none black padding-left-none" ng-if="vm.ngModel.isOther === true && vm.ngModel.id !== 0">{{vm.ngModel.opCodeDescription}}</div><div class="col-xs-12 col-sm-3 margin-top-sm padding-left-none line-item-select2 override-xs-padding-none" ng-if="vm.ngModel.isOther === true && vm.ngModel.id === 0"><select select2="" id="opcode-{{vm.myUniqueId}}" name="opcode-{{vm.myUniqueId}}" class="select2-placeholders" ng-focus="vm.ngModel.hasFocus = true" on-change="vm.opCodeSearchSelected(vm.ngModel, selectedResult)" placeholder="Search opcodes" validation-error-to="#searchError-{{vm.myUniqueId}}" min-input-length="1" init-value="vm.ngModel" allow-any-input-on-empty-results="vm.allowAnyInput" format-for-selection="vm.formatForSelection" format-for-dropdown="vm.formatForDropdown" query="vm.opCodeSearchQuery" ng-model="vm.ngModel.selectedOpCode" validation="custom: vm.validation.valOpCode():alt=*"></select><span class="text-danger validation whitespace-normal" id="searchError-{{vm.myUniqueId}}"></span></div><div class="col-xs-12 margin-bottom margin-top-sm hidden-xs padding-left-none padding-right-none" ng-class="{\'col-sm-12\': vm.ngModel.isOther === false || vm.ngModel.id !== 0, \'col-sm-9\': vm.ngModel.isOther === true && vm.ngModel.id === 0}"><input type="text" class="form-control better-placeholder" ng-if="vm.ngModel.checked" name="lineItem-note-{{vm.myUniqueId}}" id="lineItem-note-{{vm.myUniqueId}}" ng-model="vm.ngModel.note" ng-focus="vm.ngModel.hasFocus = true" placeholder="CUSTOMER COMPLAINT/NOTES" maxlength="{{::vm.getNoteMaxLength()}}"></div><div class="col-xs-12 margin-top-sm visible-xs override-xs-padding-none"><textarea class="form-control full-width better-placeholder resize-none" rows="3" name="lineItem-note-{{vm.myUniqueId}}" id="lineItem-note-{{vm.myUniqueId}}" ng-if="vm.ngModel.checked" ng-model="vm.ngModel.note" ng-focus="vm.ngModel.hasFocus = true" placeholder="CUSTOMER COMPLAINT/NOTES" maxlength="{{::vm.getNoteMaxLength()}}">\r\n        </textarea></div></div><div class="row margin-bottom line-item-edit component responsive-row" ng-class="{\'margin-top-sm\': vm.showNote === true, \'remove-padding\': vm.removePadding === true }"><div class="col-xs-12 padding-right-none override-xs-padding-none padding-left-none no-line-item-field field-wrapper {{::vm.getCSSClass()}}"><label for="lineItem-paytype-{{vm.myUniqueId}}">PAY TYPE</label><select selectlabel="" class="form-control normal" id="lineItem-paytype-{{vm.myUniqueId}}" name="lineItem-paytype-{{vm.myUniqueId}}" required="" validation-error-to="lineItem-paytype-error-{{vm.myUniqueId}}" ng-focus="vm.ngModel.hasFocus = true" ng-options="type.value as type.text for type in vm.paymentTypes" ng-model="vm.ngModel.payType"><option value="">Pay type</option></select><div ng-if="!vm.ngModel.payType" class="text-danger validation lineItem-validation-error2 pull-left">Field is required</div></div><div class="col-xs-12 padding-right-none override-xs-padding-none padding-left-sm line-item-field {{::vm.getCSSClass(true)}}"><input type="text" id="lineItem-retailprice-{{vm.myUniqueId}}" name="lineItem-retailprice-{{vm.myUniqueId}}" class="form-control normal better-placeholder no-spinners" ng-model="vm.ngModel.retailPrice" ng-pattern="vm.decimalRegex" required="" ng-focus="vm.ngModel.hasFocus = true" validation="custom: vm.validation.valDecimal(vm.ngModel.retailPrice, vm.ngModel, 0):alt=RetailPrice" placeholder="RETAIL EST"></div><div class="col-xs-12 padding-left-sm override-xs-padding-none line-item-field {{::vm.getCSSClass(true)}}" ng-class="{\'padding-right-none\': vm.dmsSystem === vm.dmsProviderTypes.CDK || vm.isCheckin || (vm.isCheckin === false && vm.dmsSystem === vm.dmsProviderTypes.None), \'last-col-flex\': vm.isCheckin === false && vm.dmsSystem === vm.dmsProviderTypes.None}"><input type="number" id="lineItem-laborhours-{{vm.myUniqueId}}" name="lineItem-laborhours-{{vm.myUniqueId}}" class="form-control normal better-placeholder no-spinners" ng-model="vm.ngModel.laborHours" validation-error-to="#lineItem-laborhours-error-{{vm.myUniqueId}}" ng-focus="vm.ngModel.hasFocus = true" validation="custom: vm.validation.valDecimal(vm.ngModel.laborHours, vm.ngModel):alt=*" placeholder="TIME EST"><div id="lineItem-laborhours-error-{{vm.myUniqueId}}" class="text-danger validation lineItem-validation-error pull-left"></div></div><div class="padding-left-sm field-wrapper col-xs-12 override-xs-padding-none padding-right-none {{::vm.getCSSClass()}}" ng-if="vm.dmsSystem === vm.dmsProviderTypes.CDK" ng-class="{\'last-col-flex\': vm.isCheckin === false}"><div><label for="lineItem-dispatchcode-{{vm.myUniqueId}}">DISP CODE</label><select selectlabel="" ng-if="vm.requireDispatchCode === true" ng-attr-id="lineItem-dispatchcode-{{vm.myUniqueId}}" ng-attr-name="lineItem-dispatchcode-{{vm.myUniqueId}}" class="form-control normal" ng-focus="vm.ngModel.hasFocus = true" ng-model="vm.ngModel.dispatchCode" validation="required:alt=Field is required" required="" placeholder="Disp code"><option value="">Disp code</option><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select><select selectlabel="" ng-if="vm.requireDispatchCode === false" ng-attr-id="lineItem-dispatchcode-{{vm.myUniqueId}}" ng-attr-name="lineItem-dispatchcode-{{vm.myUniqueId}}" class="form-control normal" ng-model="vm.ngModel.dispatchCode" placeholder="Disp code"><option value="">Disp code</option><option value="{{item}}" ng-repeat="item in vm.dispatchCodes">{{item}}</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide code-spinner-appt" ng-show="vm.parent_vm.isCodeLoading()"></div></div><div class="padding-left-sm field-wrapper col-xs-12 override-xs-padding-none padding-right-none {{::vm.getCSSClass()}}" ng-if="vm.dmsSystem === vm.dmsProviderTypes.DealerTrack" ng-class="{\'last-col-flex\': vm.isCheckin === false}"><label for="dmsServiceTypes-{{vm.myUniqueId}}">SERVICE TYPE</label><select selectlabel="" required="" validation="required" ng-focus="vm.ngModel.hasFocus = true" class="form-control normal better-placeholder" name="lineItem-servicetype-{{vm.myUniqueId}}" id="lineItem-servicetype-{{vm.myUniqueId}}" ng-model="vm.ngModel.serviceType"><option value="">Service type</option><option value="{{item}}" ng-repeat="item in vm.serviceTypes">{{item}}</option></select></div><div ng-if="vm.isCheckin" class="padding-left-sm line-item-field col-xs-12 padding-right-none override-xs-padding-none last-col-flex {{::vm.getCSSClass()}}"><ui-select ng-model="vm.ngModel.severity" class="severity-select icon-ui-select"><ui-select-match placeholder="Severity"><div class="display-flex content-center"><i ng-if="$select.selected.value.cssClass" class="material-icons md-14 {{ $select.selected.value.cssClass}}">{{ $select.selected.value.icon}}</i> <span class="severity-value padding-left-sm">{{ $select.selected.value.text }}</span></div></ui-select-match><ui-select-choices repeat="item.value.value as (key, item) in vm.lineItemSeverities"><div class="display-flex content-center"><i ng-if="item.value.cssClass" class="material-icons md-14 {{item.value.cssClass}}">{{item.value.icon}}</i> <span ng-if="!item.value.cssClass" class="no-icon"></span> <span ng-bind-html="item.value.text"></span></div></ui-select-choices></ui-select></div></div>');
$templateCache.put('app/shared/components/calendarPostItNote/calendar-post-it-note.component.view.html','<strong ng-if="vm.tripId">CONFIRMATION #{{ vm.tripId }}</strong><center><div class="panel panel-default calendar-panel" ng-class="{\'margin-top-30\': !vm.tripId, \'margin-top-sm\': vm.tripId}"><div class="panel-heading text-center appointment-banner"><h1>{{vm.caltitle}}</h1></div><div class="panel-body text-center"><h1><b>{{ vm.date | date: \'MMMM d\' }}</b></h1><h1>{{ vm.date | date: \'EEEE\' }}</h1><h1><b>{{ vm.date | date: \'shortTime\' }}</b></h1></div></div></center>');
$templateCache.put('app/shared/components/inspect/inspection-summary.view.html','<div id="print-to-pdf" class="print-to-pdf padding-sm read-only padding-bottom-none"><section class="margin-bottom-20 text-uppercase"><div data-html2canvas-ignore="" class="display-flex pull-right no-print"><div ng-if="vm.showPrintOption" type="button" class="btn btn-default margin-right-sm padding-bottom-sm padding-top-sm text-uppercase link" ng-click="vm.printSummary()" title="Print" id="print"><i class="material-icons md-18">print</i></div><div type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">Close</div></div><div class="font-bold font-size-16 margin-bottom-sm"><b>MULTIPOINT INSPECTION REPORT FOR:</b></div><div class="font-bold font-size-24 override-xs-margin-bottom-md">{{ vm.ro.customer.name }}</div><div class="font-size-16 font-bold override-xs-margin-bottom-md">RO# {{ vm.ro.dmsRepairOrderNumber }}</div><div class="font-bold font-size-16 override-xs-margin-bottom-md">{{ vm.ro.vehicle.year }} {{ vm.ro.vehicle.make }} {{ vm.ro.vehicle.model }}</div><div class="font-size-14">{{ vm.ro.vehicle.vin }}</div><div class="font-size-14" ng-if="vm.ro.odometerIn">{{vm.ro.odometerIn | number}} Miles</div><div class="font-size-14 text-normal-case margin-top">The results of your Multipoint Inspection are below. Issues that were found are indicated with either Red (Address Immediately) or Yellow (Address soon) along with recommendations to correct the issue. If you have any questions about this inspection, please speak to your Service Advisor.</div></section><div class="margin-bottom-20"><div class="text-uppercase font-bold font-size-18 display-flex content-center border-bottom margin-bottom-sm"><div class="font-size-18">INSPECTION DETAILS</div></div><div class="margin-bottom-20 font-size-15 display-flex flex-row"><div ng-if="vm.inspectionDate" ng-class="{\'flex-percent-33\': vm.inspectionDate && vm.ro.technician, \'flex-percent-50\': !vm.inspectionDate || !vm.ro.technician}"><span class="font-semi-bold">Completed On:</span> {{ vm.inspectionDate | date }}</div><div ng-class="{\'flex-percent-33\': vm.inspectionDate && vm.ro.technician, \'flex-percent-50\': !vm.inspectionDate || !vm.ro.technician}"><span class="font-semi-bold">Service Advisor:</span> {{ vm.ro.serviceAdvisor.fullName }}</div><div ng-class="{\'flex-percent-33\': vm.inspectionDate && vm.ro.technician, \'flex-percent-50\': !vm.inspectionDate || !vm.ro.technician}" ng-if="vm.ro.technician"><span class="font-semi-bold">Technician:</span> {{ vm.ro.technician.fullName }}</div></div></div><div class="margin-bottom-20" ng-repeat="task in vm.tasksWithMeasurements"><div class="font-semi-bold font-size-16 border-bottom margin-bottom-sm">{{task.name}} <span ng-if="task.inputOptions && task.inputOptions.length > 0">({{task.inputOptions[0].unitType | mpMeasurementUnitType}})</span></div><div class="flex-row-wrap flex-sm-column"><div class="margin-bottom-md flex-row-wrap-item flex-percent-50" ng-class="{\'padding-right-20\': !$odd}" ng-repeat="inputOption in task.inputOptions | orderBy: \'order\'"><div class="margin-bottom-sm font-size-12">{{ inputOption.name }} <span ng-if="inputOption.unitType !== vm.measurementUnitTypes.none"></span></div><div ng-if="task.measurementChoices.length" class="full-width"><div class="btn-group"><button ng-repeat="measurementChoice in task.measurementChoices | orderBy: \'order\'" class="font-size-10 text-nowrap font-semi-bold no-border padding-default btn-{{ measurementChoice.taskAnswerType.taskAnswerTypeId | mpAnswerTypeCss}}" ng-style="{\'width\': task.measurementButtonWidth}" ng-class="{ \'inactive\': measurementChoice.id !== inputOption.choiceResponseId, \'font-bold\': measurementChoice.id === inputOption.choiceResponseId, \'small-measurement\': task.measurementChoices.length > 10 }">{{ measurementChoice.name }}</button></div></div><div ng-if="!task.measurementChoices.length"><input class="inline-block form-control width-150"> <span class="padding-left-sm">{{ inputOption.unitType | mpMeasurementUnitType }}</span></div></div></div></div><div><div class="margin-bottom" ng-repeat="task in vm.tasksWithInputsOnly"><div class="font-semi-bold font-size-26 border-bottom margin-bottom-sm">{{task.name}}<span ng-if="task.inputOptions && task.inputOptions.length > 0 && task.inputOptions[0].unitType">({{task.inputOptions[0].unitType | mpMeasurementUnitType}})</span></div><div class="flex-row-wrap flex-sm-column"><div class="margin-bottom-md flex-row-wrap-item" ng-class="{\'padding-right-20\': !$odd, \'flex-percent-25\': task.inputOptions.length >= 4, \'flex-percent-30\': task.inputOptions.length == 3, \'flex-percent-30\': task.inputOptions.length == 2 }" ng-repeat="inputOption in task.inputOptions | orderBy: \'order\'"><div class="margin-bottom-sm font-size-12">{{ inputOption.name }} <span ng-if="inputOption.inputResponse" class="font-semi-bold">{{ inputOption.inputResponse }}</span><span ng-if="!inputOption.inputResponse" class="font-semi-bold">NA</span></div></div></div></div></div><section ng-class="{\'margin-bottom-30\': $last, \'margin-bottom\': !$last}" ng-repeat="summaryItem in vm.passFailSummary"><div class="margin-bottom-sm"><div class="font-size-16 font-semi-bold border-radius-md margin-bottom-sm padding-6 margin-left-none margin-right-none display-flex content-center btn-{{ summaryItem.passFailType | mpAnswerTypeCss }}"><div class="flex-grow flex-percent-45"><span class="text-uppercase">{{ vm.ro.answerTypeMapping[summaryItem.passFailType] }}</span><span ng-if="summaryItem.description">- {{summaryItem.description}}</span></div><div class="flex-right margin-right-sm">{{ summaryItem.items.length }} Item(s)</div></div><ul ng-if="summaryItem.items && summaryItem.items.length > 0" class="ul-col-2 unstyled padding-none full-width inline-block margin-none"><li class="block padding-none" ng-class="{\'padding-right-20\': !$odd}" ng-repeat="item in summaryItem.items"><div class="margin-bottom-md font-size-12 font-semi-bold display-flex content-center"><span class="material-icons md-12 margin-right-sm text-{{ summaryItem.passFailType | mpAnswerTypeCss }}">done</span><span>{{ item.name || item.formattedComplaint }}</span></div></li></ul></div></section><section class="margin-bottom-20" ng-if="vm.vehicleOverview && (vm.vehicleOverview.media.length > 0 || vm.vehicleOverview.notes.length > 0)"><div class="text-uppercase font-semi-bold font-size-16 border-bottom margin-bottom-md">Vehicle Overview</div><div class="font-size-12 text-muted margin-bottom-md">Photos, videos, and notes documenting the overall condition of the vehicle.</div><div ng-if="vm.vehicleOverview.media && vm.vehicleOverview.media.length > 0" class="margin-bottom-lg"><div class="image-grid w-100 h-100"><div class="grid-item" ng-repeat="media in vm.vehicleOverview.media track by media.id"><div class="small-grey-boxes position-relative"><img class="image-container position-relative" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.photo" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.photo)" ng-src="{{media.mediaUrl}}"><video class="image-container position-relative" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.video" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.video)" ng-src="{{media.mediaUrl}}"></video><span class="overlay" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.video" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.video)"><i class="material-icons">play_arrow</i></span></div></div></div></div><div ng-if="vm.vehicleOverview.notes && vm.vehicleOverview.notes.length > 0" class="margin-bottom-lg"><div ng-repeat="note in vm.vehicleOverview.notes" class="panel panel-default margin-bottom-sm pending-lineitem-authorization"><div class="panel-body padding-sm"><div class="font-size-11 text-uppercase font-semi-bold margin-bottom-xs">{{ note.dateCreated | fromNow }} <span ng-if="note.authorName">({{ note.authorName }})</span></div><div class="font-size-12 text-muted">{{ note.message }}</div></div></div></div></section><section ng-class="{\'margin-bottom-30\': $last, \'margin-bottom-20\': !$last}" ng-if="vm.originalCustomerRequests && vm.originalCustomerRequests.length > 0" ng-repeat="lineItem in vm.originalCustomerRequests"><div ng-if="$index === 0" class="text-uppercase font-semi-bold font-size-16 border-bottom margin-bottom-md">Original Requests</div><authorize-pending-lineitem ng-model="lineItem" read-only="true" is-dashboard="true" inspection-summary="true"></authorize-pending-lineitem></section><div ng-class="{\'margin-bottom-30\': $last, \'margin-bottom-20\': !$last}" ng-if="vm.inspectionRecommendations && vm.inspectionRecommendations.length > 0" ng-repeat="lineItem in vm.inspectionRecommendations"><div ng-if="$index === 0" class="text-uppercase font-semi-bold font-size-16 border-bottom margin-bottom-md">Issues and Recommendations</div><authorize-pending-lineitem ng-model="lineItem" read-only="true" is-dashboard="true" inspection-summary="true"></authorize-pending-lineitem></div><div class="inline-block margin-top-sm margin-botom-sm full-width padding-bottom-md"><div class="font-size-12 pull-right"><table class="text-right"><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="text-right" colspan="3"><b>Approved ({{vm.roTotals.approvedAmounts.totalLineItemCount}})</b></td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="padding-top-xs padding-bottom-none text-right">Labor</td><td class="padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.approvedAmounts.totalLabor | currency }}</td><td class="padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="padding-top-xs padding-bottom-none text-right">Parts</td><td class="padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.approvedAmounts.totalParts | currency }}</td><td class="padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalDiscount && vm.roItemizationEnabled"><td class="padding-top-xs padding-bottom-none text-right">Discount</td><td class="padding-top-xs padding-bottom-none text-right text-danger padding-left-sm">({{ vm.roTotals.approvedAmounts.totalDiscount | currency }})</td><td class="padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="border-none padding-top-xs padding-bottom-none text-right">Shop Supplies</td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.approvedAmounts.totalShopSupplies | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="border-none padding-top-xs padding-bottom-none text-right">Fees</td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.approvedAmounts.totalFees | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="border-none padding-top-xs padding-bottom-none text-right">Tax</td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.approvedAmounts.totalTaxes | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.approvedAmounts.totalLineItemCount > 0"><td class="border-none padding-top-xs padding-bottom-none text-right" ng-class="{\'semi-bold\': vm.roItemizationEnabled}">Total Approved<span ng-if="!vm.roItemizationEnabled">({{vm.roTotals.approvedAmounts.totalLineItemCount}})</span></td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm" ng-class="{\'semi-bold\': vm.roItemizationEnabled}">{{ vm.roTotals.approvedAmounts.totalCustomerPay | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalLineItemCount && vm.roItemizationEnabled"><td class="padding-top-md text-right padding-top-md" colspan="3"><b>Pending ({{vm.roTotals.pendingAmounts.totalLineItemCount}})</b></td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="padding-top-xs padding-bottom-none text-right">Labor</td><td class="padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.pendingAmounts.totalLabor | currency }}</td><td class="padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalLineItemCount > 0 && vm.roItemizationEnabled"><td class="padding-top-xs padding-bottom-none text-right">Parts</td><td class="padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.pendingAmounts.totalParts | currency }}</td><td class="padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalDiscount && vm.roItemizationEnabled"><td class="padding-top-xs padding-bottom-none text-right">Discount</td><td class="padding-top-xs padding-bottom-none text-right text-danger padding-left-sm">({{ vm.roTotals.pendingAmounts.totalDiscount | currency }})</td><td class="padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalLineItemCount && vm.roItemizationEnabled"><td class="border-none padding-top-xs padding-bottom-none text-right">Shop Supplies</td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.pendingAmounts.totalShopSupplies | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalLineItemCount && vm.roItemizationEnabled"><td class="border-none padding-top-xs padding-bottom-none text-right">Fees</td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.pendingAmounts.totalFees | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.pendingAmounts.totalLineItemCount && vm.roItemizationEnabled"><td class="border-none padding-top-xs padding-bottom-none text-right">Tax</td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm">{{ vm.roTotals.pendingAmounts.totalTaxes | currency }}</td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr><tr ng-if="vm.roTotals.pendingAmounts.totalLineItemCount > 0" class="no-hover text-uppercase"><td class="border-none padding-top-xs padding-bottom-none text-right" ng-class="{\'semi-bold\': vm.roItemizationEnabled}">Total Pending<span ng-if="!vm.roItemizationEnabled">({{vm.roTotals.pendingAmounts.totalLineItemCount}})</span></td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm" ng-class="{\'semi-bold\': vm.roItemizationEnabled}">{{ vm.roTotals.pendingAmounts.totalCustomerPay | currency }}</td></tr><tr class="no-hover text-uppercase"><td class="border-none padding-top-xs padding-bottom-none text-right" ng-class="{\'padding-top-sm\': vm.roItemizationEnabled}"><b>Total</b></td><td class="border-none padding-top-xs padding-bottom-none text-right padding-left-sm" ng-class="{\'padding-top-sm\': vm.roItemizationEnabled}"><b>{{ vm.roTotals.totalCombinedCustomerPay | currency }}</b></td><td class="border-none padding-top-xs padding-bottom-none">&nbsp;</td></tr></table></div></div><section class="margin-bottom-lg print-to-pdf-only" ng-if="vm.terms && vm.terms.length > 0"><div ng-repeat="term in vm.terms" class="display-flex flex-row margin-top"><div class="flex-percent-15 border-bottom-dark margin-right-20"></div><div class="flex-percent-85 font-size-16">{{term.terms}}</div></div></section><section class="padding-top-lg print-to-pdf-only"><div class="display-flex flex-row margin-top-lg"><div class="flex-percent-75 border-bottom-dark margin-right-15"><i class="material-icons">close</i></div><div class="flex-percent-25 border-bottom-dark"></div></div><div class="display-flex flex-row"><div class="flex-percent-75 font-size-14 margin-top-sm"><center>Signature</center></div><div class="flex-percent-25 font-size-14 margin-top-sm"><center>Date</center></div></div></section><section data-html2canvas-ignore="" class="margin-top-30 display-flex pull-right no-print"><div class="override-xs-margin-bottom-md padding-bottom-md"><div ng-if="vm.showPrintOption" type="button" class="btn btn-default text-uppercase link margin-right-sm padding-bottom-sm padding-bottom-sm" ng-click="vm.printSummary()" title="Print" id="print"><i class="material-icons md-18">print</i></div><div type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">Close</div></div></section></div><div id="repeating-footer" class="pdf-to-print"><div class="font-bold font-size-11 margin-none"><b>MULTIPOINT INSPECTION REPORT FOR:</b></div><div class="font-size-11 margin-none">RO# {{ vm.ro.dmsRepairOrderNumber }} <span class="ro-name">{{ vm.ro.customer.name }}</span> <span id="vehicle">{{ vm.ro.vehicle.year }} {{ vm.ro.vehicle.make }} {{ vm.ro.vehicle.model }}</span></div></div>');
$templateCache.put('app/shared/components/list-mobile-filters/list-mobile-filters.view.html','<div class="font-size-12 inline-block text-extra-muted ellipsis-overflow" uib-popover-template="\'mobile-filter-message-popover.html\'" popover-trigger="mouseenter"><span ng-if="vm.requiredFilterCount" class="padding-right-xs">{{vm.requiredFilterMessage}}.</span> <span ng-if="vm.getAdjustedFilterCount() > 0" class="padding-right-xs">{{vm.getAdjustedFilterCount()}} filter<span ng-if="vm.getAdjustedFilterCount() !== 1">s</span>.</span>{{vm.recordCount || 0}} result<span ng-if="vm.recordCount !== 1">s</span>.</div><script type="text/ng-template" id="mobile-filter-message-popover.html"><div> <div><b>Records:</b> <span>{{vm.recordCount || 0}}</span></div> <div ng-if="vm.filterCount > 0" ng-bind-html="vm.filterMessage"></div> <div ng-if="!vm.filterCount"><b>Filters:</b> NONE</div> </div></script>');
$templateCache.put('app/shared/components/list-select-saved-search/list-select-saved-search.view.html','<div class="field-wrapper"><label for="list-saved-searches-{{vm.myUniqueId}}">Saved Searches</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-change="vm.itemSelected(vm.currentSearchTemplate)" class="form-control" id="list-saved-searches-{{vm.myUniqueId}}" name="list-saved-searches-{{vm.myUniqueId}}" allow-null-option="Saved Searches" ng-model="vm.currentSearchTemplate" ng-options="searchTemplate.template.templateName for searchTemplate in vm.searchTemplates"></select></div>');
$templateCache.put('app/shared/components/list-standardized-footer/list-standardized-footer.view.html','<div class="text-uppercase full-width font-bold text-center" ng-show="vm.isLoading"><img src="assets/images/ajax-loader.gif"> Loading...</div><div class="text-uppercase full-width font-bold text-center" ng-show="!vm.isLoading && vm.recordCount === 0 && (vm.selectedLocation || !vm.locationRequired)">No Results Found.</div><div class="text-uppercase full-width font-bold text-center" ng-show="!vm.isLoading && !vm.selectedLocation && vm.locationRequired">Please Select A Location.</div><div class="text-uppercase full-width font-bold text-center" ng-show="!vm.isLoading && vm.recordCount !== 0 && !vm.canShowMore">You have reached the end of the list.</div>');
$templateCache.put('app/shared/components/list-mode-selector/list-mode-selector.view.html','<ui-select on-select="vm.tripListModeChanged()" ng-model="vm.ngModel" class="icon-ui-select {{vm.cssClass}}" search-enabled="false"><ui-select-match placeholder=""><i ng-if="vm.ngModel.icon" class="material-icons md-18">{{vm.ngModel.icon}}</i> <span class="icon-ui-label">{{vm.ngModel.text}}</span></ui-select-match><ui-select-choices repeat="item in vm.availableModes"><div><i ng-if="item.icon" class="material-icons md-18">{{item.icon}}</i><span class="icon-ui-label">{{item.text}}</span></div></ui-select-choices></ui-select>');
$templateCache.put('app/shared/components/list-template-save-search-delete-btns/list-template-save-search-delete-btns.view.html','<button class="btn btn-default" ng-if="vm.displaySaveBtn() === true" ng-disabled="vm.disableSaveBtn() === true" ng-click="vm.saveBtnClicked()">SAVE</button> <button class="btn btn-default margin-left-sm" ng-if="vm.displaySaveAsBtn() === true" ng-disabled="vm.disableSaveAsBtn() === true" ng-click="vm.saveAsBtnClicked()">SAVE AS</button> <button class="btn btn-default margin-left-sm" ng-disabled="vm.isProcessingTemplate" ng-click="vm.deleteSearchTemplate()" ng-if="vm.displaySaveAsBtn() === false && vm.currentSearchTemplate && vm.currentSearchTemplate.template && (!vm.currentSearchTemplate.isGlobal || vm.canManageGlobalTemplates)">DELETE</button><div class="margin-top-sm padding-left-sm text-danger validation text-uppercase">{{vm.templateMessage}}</div>');
$templateCache.put('app/shared/components/loaner/loaner-preference-summary.component.view.html','<div class="margin-bottom-30 row" ng-if="vm.transportationType === vm.cflTransportationTypes.firstAvailable"><div class="col-xs-5 padding-right-none">Preference:</div><div class="col-xs-7">1st Available <img class="loaner-pref-vehicle-image" src="https://redcapstorage.blob.core.windows.net/automotivelogos/vehicle-placeholder.png"></div></div><div class="margin-bottom-30 row" ng-if="vm.transportationType === vm.cflTransportationTypes.lyftCredit"><div class="col-xs-5 padding-right-none">Preference:</div><div class="col-xs-7">Rideshare Credits instead of loaner</div></div><div class="margin-bottom-md row" ng-if="vm.transportationType === vm.cflTransportationTypes.chooseLoaner"><div class="col-xs-5 padding-right-none">1st Preference:</div><div class="col-xs-7"><span class="summary-model-name">{{vm.vehicles[0].model}}</span> <img class="loaner-pref-vehicle-image" ng-src="{{vm.vehicles[0].imageUrl}}"></div></div><div class="margin-bottom-30 row" ng-if="vm.transportationType === vm.cflTransportationTypes.chooseLoaner"><div class="col-xs-5 padding-right-none">2nd Preference:</div><div class="col-xs-7"><span class="summary-model-name">{{vm.vehicles[1].model}}</span> <img class="loaner-pref-vehicle-image" ng-src="{{vm.vehicles[1].imageUrl}}"></div></div>');
$templateCache.put('app/shared/components/typeAheadTaggedInput/typeahead-tagged-input.view.html','<div class="typeahead-tagged-input position-relative z-index-20"><tags-input ng-model="$ctrl.selectedItems" text="$ctrl.searchQuery" replace-spaces-with-dashes="false" add-on-space="false" add-from-autocomplete-only="true" use-strings="true" key-property="{{$ctrl.keyProperty || \'id\'}}" display-property="{{$ctrl.displayProperty || \'name\'}}" placeholder="{{$ctrl.placeholder}}" max-tags="{{$ctrl.maxTags || 1}}" ng-disabled="$ctrl.isDisabled" ng-focus="$ctrl.onFocus()" ng-blur="$ctrl.onBlur()" on-tag-added="$ctrl.onSelected({$tag: $tag})" on-tag-removed="$ctrl.onTagRemoved()"><auto-complete class="no-top-margin font-size-11" source="$ctrl.search($query)" ng-hide="$ctrl.isSearching" highlight-matched-text="false" display-property="{{$ctrl.autocompleteDisplayProperty || $ctrl.displayProperty || \'name\'}}" min-length="{{$ctrl.minLength || 3}}" ng-attr-load-on-focus="{{$ctrl.loadOnFocus}}" ng-attr-load-on-empty="{{$ctrl.loadOnEmpty}}" max-results-to-show="{{$ctrl.maxResultsToShow}}" debounce-delay="{{$ctrl.debounceDelay || 300}}"></auto-complete></tags-input><div class="block position-absolute z-index-20 padding-left-md padding-right-md padding-top-sm padding-bottom-sm border-left border-right border-bottom full-width white-bg" ng-show="$ctrl.isFocused && !$ctrl.isSearching && $ctrl.effectiveMinLength > 0 && (!$ctrl.searchQuery || $ctrl.searchQuery.length < $ctrl.effectiveMinLength)"><div>Please enter {{$ctrl.effectiveMinLength}} or more characters</div><div ng-if="$ctrl.minLengthActionText && $ctrl.onMinLengthAction" class="margin-top-sm"><a href="" class="theme-link create-new text-normal-case" ng-mousedown="$ctrl.triggerMinLengthAction($event)" ng-click="$ctrl.triggerMinLengthAction($event)">{{$ctrl.minLengthActionText}}</a></div></div><div class="block position-absolute z-index-20 padding-left-md padding-right-md padding-top-sm padding-bottom-sm border-left border-right border-bottom full-width white-bg" ng-show="$ctrl.isSearching">Searching...</div><div class="block position-absolute z-index-20 padding-left-md padding-right-md padding-top-sm padding-bottom-sm border-left border-right border-bottom full-width white-bg font-size-11 margin-top-none" ng-show="$ctrl.showNoResults()">{{$ctrl.noResultsMessage}} \'{{$ctrl.searchQuery}}\'. <span ng-if="$ctrl.noResultsSubMessage">{{$ctrl.noResultsSubMessage}}</span></div><span class="input-append-icon" ng-show="$ctrl.showDropdownArrow && !$ctrl.isFocused"><button type="button" class="btn btn-text-only padding-top-none padding-right-none padding-bottom-20" ng-mousedown="$ctrl.openFromArrow()" title="Open dropdown"><i class="material-icons md-18">arrow_drop_down</i></button></span></div>');
$templateCache.put('app/shared/components/ui-select/ui-select-search.component.html','<div class="ui-select-search"><ui-select class="ui-select-typeahead" ng-model="vm.ngModel" on-select="vm.itemIsSelected()" search-enabled="!vm.searchDisabled && !vm.isSearching" ng-disabled="vm.ngModel || vm.disabled"><ui-select-match placeholder="{{vm.searchPlaceholder}}">{{vm.getDisplayMessage($select.selected)}}</ui-select-match><ui-select-choices minimum-input-length="3" repeat="item in vm.availableItems track by $index" refresh="vm.search($select.search)" refresh-delay="vm.refreshDelay" ui-disable-choice="item.isFound === false" class="fit-content"><div title="{{vm.itemTitle(item)}}" class="" ng-bind-html="vm.typeAheadFormat(item) | highlight: $select.search"></div></ui-select-choices><ui-select-no-choice class="fit-content"><div class=""><div class="ng-hide text-nowrap" ng-show="!vm.isSearching && !vm.searchDisabled">Please enter 3 or more characters</div><div class="ng-hide margin-top" ng-show="!vm.isSearching" ng-click="vm.forceAddNew($select)"><span class="theme-link create-new">Create a New Record.</span></div><div class="ng-hide" ng-show="vm.isSearching">Searching...</div></div></ui-select-no-choice></ui-select><img src="assets/images/ajax-loader.gif" class="ng-hide ui-select-spinner" ng-show="vm.isSearching || vm.showSpinner"><div class="ng-hide clear-ui-select" ng-if="!vm.disabled" ng-show="vm.addingNew || vm.ngModel && !vm.isLoading()" ng-click="vm.clearSelectedItem()"><i class="material-icons theme-hover">highlight_off</i></div></div>');
$templateCache.put('app/shared/components/venue-mapping/venue-mapping.component.html','<div><form autocomplete="off"><div id="add-location-row" class="form-group"><div class="row"><div class="col-xs-6 first-col"><input type="text" ng-attr-placeholder="LOCATION ADDRESS" id="location_address" name="location_address" ng-model="ctrl.newLocation.address" class="form-control" details="ctrl.places" ng-required="true" here-places="" options="ctrl.options" handle-selected="ctrl.placeUpdated(formattedAddress)" autocomplete="off"></div><div class="col-sm-6"><div class="form-group field-wrapper"><label for="copyFrom">COPY FROM (OPTIONAL)</label><select selectlabel="" name="copyfrom" id="copy-from" class="form-control" ng-model="ctrl.copyFromVenueId" ng-change="ctrl.copyFromVenueChanged()" ng-options="venue.id as venue.name for venue in ctrl.copyFromVenues"><option value="">Copy from (optional)</option></select></div></div></div></div><div id="map-container" class="max-height-px400" fill-height=""><div id="public-map" class="map-fullHeight" map-resize=""><div id="map" class="full-width display-contents" fill-height="" heremaps="" options="ctrl.mapOptions" map-ready="ctrl.onMapReady" events="ctrl.mapListeners" ng-attr-controls="{{::ctrl.mapOptions.showControls === true ? \'right-bottom\' : undefined}}"></div></div></div><br><div class="row"><div class="col-sm-8 padding-top-sm"><span ng-if="ctrl.outOfBounds" class="danger text-bold">The current selection is out of bounds. Please move the pin inside the circle.</span></div><div class="col-sm-4 text-right"><button ladda="ctrl.isProcessing" ng-disabled="ctrl.isProcessing || ctrl.showDistanceWarning || !ctrl.canSave" class="btn btn-primary margin-right-md" ng-class="config.styleClass" ng-click="ctrl.save()">UPDATE</button> <button ng-disabled="ctrl.isProcessing" class="btn btn-default" ng-class="config.styleClass" ng-click="ctrl.cancel()">CANCEL</button></div></div></form></div>');
$templateCache.put('app/shared/directives/redcap-map/redcap-map.html','<div class="map-loading-overlay" ng-class="{\'isLoading\': vm.isLoading, \'shown\': vm.loadingInTransition}"><div class="centered-content loading-container"><img src="assets/images/ajax-loader.gif"><div>Loading...</div></div></div><div class="map-wrap" ng-class="{\'driver-list-active\': vm.showNearbyDriversList}"><div ng-if="vm.showNearbyDriversList && vm.assigningDriver" class="driver-loading-overlay"><div class="centered-content"><div class="spinner margin-bottom-md"></div><div>Assigning Driver...</div></div></div><div ng-if="vm.showNearbyDriversList" id="nearby-driver-list" class="nearby-driver-list" ng-class="{\'assigning-driver\': vm.assigningDriver}"><div ng-if="vm.isSysAdmin && vm.hasDnsDrivers" class="margin-bottom-md"><label class="checkbox-inline"><input type="checkbox" name="dnsOnly" ng-model="vm.dnsDriversOnly" ng-change="vm.filterNearbyDrivers()"> DNS Only</label></div><div id="driver-{{driver.id}}-list-item" class="nearby-driver" ng-mouseenter="vm.listItemHover(driver.id, true)" ng-mouseleave="vm.listItemHover(driver.id, false)" ng-repeat="driver in vm.filteredNearbyDrivers"><div ng-if="driver.isPreferred" class="preferred" title="Driver is Preferred"><i class="material-icons">star</i></div><div class="margin-bottom"><div class="text-bold">{{driver.name}}</div><div ng-class="{\'theme-link\': vm.isSysAdmin && driver.isDnsDriver}" ng-click="vm.messageDriver(driver)">{{driver.phoneNumber | tel}}</div></div><div ng-if="driver.activeTrip || driver.conflictingTrips.length" class="margin-bottom"><div ng-if="driver.activeTrip" class="active-trip"><div><a target="_blank" ui-sref="trip-tab-trip({ tripId: {{::driver.activeTrip.id}}})">{{::driver.activeTrip.id}}</a> - <span>{{driver.activeTrip.estimatedStartTime | localTimeOfDay:\'h:mm a\' }} - {{driver.activeTrip.estimatedEndTime | localTimeOfDay:\'h:mm a\'}}</span> <i ng-if="driver.activeTrip.isConflict" title="Conflicts with selected trip" class="material-icons conflict">error_outline</i></div><div class="text-italic">{{ driver.activeTrip.friendlyName }}</div></div><div ng-if="driver.conflictingTrips.length"><div ng-repeat="conflictingTrip in driver.conflictingTrips"><a target="_blank" ui-sref="trip-tab-trip({ tripId: {{::conflictingTrip.id}}})">{{::conflictingTrip.id}}</a> - <span>{{conflictingTrip.estimatedStartTime | localTimeOfDay:\'h:mm a\'}} - {{conflictingTrip.estimatedEndTime | localTimeOfDay:\'h:mm a\'}}</span> <i title="Conflicts with selected trip" class="material-icons conflict">error_outline</i></div></div></div><div ng-if="driver.lastKnownLocation || driver.mostRecentCompletedTrip" class="margin-bottom"><div ng-if="driver.lastKnownLocation" class="text-italic">Last location {{ driver.lastKnownLocation.timestamp | fromNow }}</div><div ng-if="!driver.lastKnownLocation">Last location unknown</div><div ng-if="driver.mostRecentCompletedTrip" class="text-italic">Last trip {{ driver.mostRecentCompletedTrip.estimatedEndTime | fromNow }}</div></div><div ng-if="vm.canChangeDriver"><span class="theme-link text-uppercase text-bold" ng-disabled="driver.currentlyAssigned" ng-class="{\'disabled\': driver.currentlyAssigned}" title="{{ driver.currentlyAssigned ? \'Driver already assigned to this trip\' : \'\'}}" ng-click="vm.assignDriver(vm.selectedTrip.id, driver)">Assign</span></div></div></div><div class="map-container"><div class="panel panel-default recenter-map-overlay" ng-if="!vm.lockMapMode && vm.selectedTrip.isDriverActive && (vm.mapMode === vm.mapModes.followMode || vm.mapMode === vm.mapModes.overview)" ng-click="vm.toggleFollowMode()"><div class="panel-body cursor-pointer"><i class="material-icons theme-link">navigation</i> <span ng-if="vm.mapMode === vm.mapModes.overview">Overview Mode</span> <span ng-if="vm.mapMode === vm.mapModes.followMode">Follow Mode</span></div></div><div class="panel panel-default recenter-map-overlay" ng-if="vm.mapMode === vm.mapModes.userControlled && !vm.options.forceHideRecenter" ng-click="vm.recenter()"><div class="panel-body cursor-pointer"><i class="material-icons theme-link">navigation</i> <span>RECENTER</span></div></div><div class="trip-segment-overlay hidden-xs hidden-sm" ng-if="vm.options.showSegmentOverlay && vm.selectedTrip"><div><span ng-if="vm.selectedTrip.estimatedDistance"><strong>Route:</strong> {{ vm.selectedTrip.estimatedDistance.value | number:2 }}{{ vm.selectedTrip.estimatedDistance.type }}</span> <strong>Time:</strong> {{vm.selectedTrip.estimatedDuration | duration}}</div><div class="segments" ng-repeat="segment in vm.selectedTrip.stops"><img width="22" ng-src="{{segment.stopType === 0 ? \'/assets/images/Dealer Pin.png\' : \'/assets/images/Customer Pin.png\'}}"> <strong>{{segment.estimatedArrival | date:\'h:mma\'}}</strong> <span class="address" ng-if="segment.stopType != 1 && segment.address.name">{{segment.address.name}},</span> <span class="address" ng-if="!segment.address.name && segment.stopType == 0">Dealer location,</span> <span class="address" ng-if="segment.stopType == 1">{{ segment.address.streetAddress }},</span> <span class="address" ng-if="!segment.address.name && segment.stopType == 2">Destination,</span> <span class="zip">{{segment.address.zip}}</span></div><div class="state-info">{{vm.tripState.friendlyName}} <span ng-if="vm.selectedTrip.isDriverActive">(Last updated {{vm.tripState.lastUpdated}})</span></div></div><div ng-if="vm.options.fillHeight" fill-height="" footer-element-id="{{vm.options.footerElementId}}" heremaps="" options="vm.mapOptions" events="vm.mapListeners" map-ready="vm.onMapReady" ui-ready="vm.onUiReady" ng-attr-controls="{{::vm.options.showControls === true ? \'right-bottom\' : undefined}}"></div><div ng-if="!vm.options.fillHeight" heremaps="" options="vm.mapOptions" events="vm.mapListeners" map-ready="vm.onMapReady" ui-ready="vm.onUiReady" ng-attr-controls="{{::vm.options.showControls === true ? \'right-bottom\' : undefined}}"></div></div></div>');
$templateCache.put('app/shared/directives/templates/inputvalidation-phone-type-indicator.html','<span class="text-danger" ng-show="vm.phoneNumber.length > 0 && vm.phoneNumber.length < 10">Invalid phone number.</span> <span class="text-danger" ng-show="vm.phoneNumberType === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="vm.phoneNumberType === vm.phoneTypes.voip">Number is a VoIP</span>');
$templateCache.put('app/shared/directives/templates/phone-detail-indicator.html','<i class="material-icons md-18 text-danger input-append" ng-show="!vm.detail.isOptedOut && vm.detail.type === vm.phoneTypes.landline" uib-popover="This is a Landline and cannot receive text messages." popover-append-to-body="true" popover-trigger="mouseenter" popover-is-open="vm.isPopoverOpen && vm.detail.type == vm.phoneTypes.landline">phonelink_erase</i> <i class="material-icons md-18 text-danger input-append" ng-show="!vm.detail.isOptedOut && vm.detail.type === vm.phoneTypes.voip" uib-popover="This is a VoIP number and may not be able to receive text messages." popover-append-to-body="true" popover-trigger="mouseenter" popover-is-open="vm.isPopoverOpen && vm.detail.type === vm.phoneTypes.voip">phonelink_erase</i> <i class="material-icons md-18 text-danger input-append" ng-show="vm.detail.isOptedOut" uib-popover="Customer has opted out of text messages. To opt into messages, customer must text START to {{ vm.detail.dealerPhone | tel }}." popover-append-to-body="true" popover-trigger="mouseenter" popover-is-open="vm.isPopoverOpen && vm.detail.isOptedOut">speaker_notes_off</i>');
$templateCache.put('app/shared/directives/templates/phone-type-indicator.html','<i class="material-icons md-18 text-danger" ng-show="vm.phoneNumberType === vm.phoneTypes.landline" uib-popover="This is a Landline and cannot receive text messages." popover-append-to-body="true" popover-trigger="mouseenter" popover-is-open="vm.isPopoverOpen && vm.phoneNumberType == vm.phoneTypes.landline">phonelink_erase</i> <i class="material-icons md-18 text-danger" ng-show="vm.phoneNumberType === vm.phoneTypes.voip" uib-popover="This is a VoIP number and may not be able to receive text messages." popover-append-to-body="true" popover-trigger="mouseenter" popover-is-open="vm.isPopoverOpen && vm.phoneNumberType === vm.phoneTypes.voip">phonelink_erase</i>');
$templateCache.put('app/shared/directives/templates/range-display.html','<div class="range"><div class="range-bar"><div class="range-bar-value"></div></div><div class="range-steps"><div class="range-step"></div><div class="range-step"></div><div class="range-step"></div><div class="range-step"></div></div><div class="range-step-values"><div ng-class="{\'range-step-value-empty\': fuellevel === 1, \'range-step-value-bold\': fuellevel > 1}">E</div><div ng-class="{\'range-step-value-bold\':fuellevel >= 2 ,\'range-step-value\':fuellevel < 2}">&frac14;</div><div ng-class="{\'range-step-value-bold\':fuellevel>= 3 ,\'range-step-value\':fuellevel < 3}">&frac12;</div><div ng-class="{\'range-step-value-bold\':fuellevel >= 4 ,\'range-step-value\':fuellevel < 4}">&frac34;<div ng-class="{\'pull-right range-step-value-normal\':fuellevel <= 4 ,\'pull-right range-step-value-bold\':fuellevel === 5}">F</div></div></div></div>');
$templateCache.put('app/shared/layouts/content-only/content-only.view.html','<div ui-view=""></div>');
$templateCache.put('app/shared/layouts/enrollment/enrollment-topnav.view.html','<div id="wrapper" class="top-navigation" ng-class="vm.config.styleClass"><div class="row"><nav class="navbar navbar-fixed-top" ng-class="\'navbar-\' + vm.config.styleClass" role="navigation"><div class="navbar-header"><button aria-controls="navbar" aria-expanded="false" ng-click="vm.mobileNavCollapsed = !vm.mobileNavCollapsed" class="navbar-toggle collapsed" type="button"><i class="fa fa-reorder"></i></button> <a href="#" class="navbar-brand with-logo" ng-class="\'navbar-brand-\' + vm.config.styleClass"><img src="{{ vm.config.logo }}">{{ vm.config.logoText }}</a></div><div uib-collapse="vm.mobileNavCollapsed" class="navbar-collapse collapse" id="navbar"><ul class="nav navbar-nav"></ul><ul class="nav navbar-right top-navigation" ng-class="\'navbar-right-\' + vm.config.styleClass"><li uib-dropdown=""><span>{{ vm.config.programName }} Enrollment</span></li></ul></div></nav></div><div id="page-wrapper" class="gray-bg {{$state.name}}" ng-class="\'wrapper-content-\' + vm.config.styleClass"><div ui-view=""></div></div></div>');
$templateCache.put('app/shared/layouts/main/main-topnav.view.html','<div ng-cloak="" id="wrapper" class="top-navigation display-flex flex-column full-width-height" ng-class="config.styleClass"><div class="flex-fullwidth-navbar bg-pagewrapper"><div ng-cloak="" id="mobile-tablet-wrapper"><nav id="frame_navbar_mobile" class="navbar navbar-fixed-top mobile-tablet-navbar-fixed border-radius-none" ng-class="config.styleClass" role="navigation" ng-click="vm.navBarClicked()"><div class="display-flex flex-row full-width-height"><div class="display-flex content-center flex-percent-75 full-width-height"><a ng-if="vm.getActiveProductIcon() === null" href="#" class="navbar-brand with-logo padding-top-none display-flex content-center" ng-click="vm.menuClicked();"><img ng-src="{{ config.logo }}"></a> <span class="margin-left link margin-top-sm" ng-click="vm.menuClicked();" ng-if="vm.getActiveProductIcon() !== null"><i class="material-icons md-28" title="{{ getActiveProduct() }}">{{vm.getActiveProductIcon()}}</i></span></div><div class="display-flex content-center flex-percent-25 full-width-height" has-permission="{{ vm.permissionTypes.messaging }}"><div class="full-width-height text-right margin-right"><div class="inline-block full-height navbar-nav margin-none padding-left-20 font-size-20 border-left" ng-if="vm.mobileNavCollapsed !== false"><div class="display-flex full-width-height content-center"><a ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.messaging}" ng-click="vm.goto(\'contact-list\', true)" has-permission="{{ vm.permissionTypes.messaging }}" has-no-permission-disabled="{{ vm.permissionTypes.messaging }}"><b>{{ vm.notificationCount }}</b></a></div></div><i ng-if="vm.mobileNavCollapsed === false" class="material-icons link md-23 margin-top-md" ng-click="vm.menuClicked();">close</i></div></div></div><div uib-collapse="vm.mobileNavCollapsed" class="navbar-collapse collapse padding-none" ng-if="vm.menuWasClicked === true" id="navbar"><div class="display-flex full-width-height"><ul class="navbar-nav full-width" ng-class="config.styleClass"><li class="cursor-pointer padding-none" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.messaging}" ng-click="vm.goto(\'contact-list\', true)" has-permission="{{ vm.permissionTypes.messaging }}" has-no-permission-disabled="{{ vm.permissionTypes.messaging }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-18">mail</i> <a ui-sref="contact-list" ng-click="vm.menuClicked();">{{ vm.products.Product_Messaging.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.appointments}" ng-click="vm.goto(\'appointment-list\', true)" has-permission="{{ vm.permissionTypes.appointments }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-18" title="{{ vm.products.Product_Appointment.overrideVal }}">insert_invitation</i> <a ui-sref="appointment-list" ng-click="vm.menuClicked();">{{ vm.products.Product_Appointment.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ui-sref-active="active" ng-class="{\'active\': vm.cleanMarketingArea() === vm.permissionTypes.checkIn}" ng-click="vm.goto(\'checkin-list\', true)" has-permission="{{ vm.permissionTypes.checkIn }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-18" title="{{ vm.products.Product_CheckIn.overrideVal }}">assignment_turned_in</i> <a ui-sref="checkin-list" ng-click="vm.menuClicked();">{{ vm.products.Product_CheckIn.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ng-if="!vm.hasInspect()" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.authorizations}" ng-click="vm.goto(\'auth-list\', true)" has-permission="{{ vm.permissionTypes.authorizations }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-18" title="{{ vm.products.Product_Authorizations.overrideVal }}">input</i> <a ui-sref="auth-list" ng-click="vm.menuClicked();">{{ vm.products.Product_Authorizations.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.inspect}" ng-click="vm.goto(\'inspect\', true)" has-permission="{{ vm.permissionTypes.inspect }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-23" title="{{ vm.products.Product_Inspect.overrideVal }}">assignment</i> <a ui-sref="inspect" ng-click="vm.menuClicked();">{{ vm.products.Product_Inspect.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.payments}" ng-click="vm.goto(\'payments-list\', true)" has-permission="{{ vm.permissionTypes.payments }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-23" title="{{ vm.products.Product_Payment.overrideVal }}">credit_card</i> <a ui-sref="payments-list" ng-click="vm.menuClicked();">{{ vm.products.Product_Payment.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ng-class="{active: vm.isTransportationState()}" ng-click="vm.experiencesTransportationClicked();" has-permission="{{ vm.permissionTypes.transportation }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-23" title="{{ vm.products.Product_Transportation.overrideVal }}">drive_eta</i> <a>{{ vm.products.Product_Transportation.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ng-class="{\'active\': vm.isLoanerState()}" ng-click="vm.goto(\'loaner-contracts-list\', true)"><span class="navbar-link display-flex content-center"><i class="material-icons md-23" title="{{ vm.products.Product_Loaner.overrideVal }}">library_books</i> <a ui-sref="loaner-contracts-list" ng-click="vm.menuClicked();">{{ vm.products.Product_Loaner.overrideVal }}</a></span></li><li class="cursor-pointer padding-none" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.reports}" ng-click="vm.goto(\'report-list\', true)" has-permission="{{ vm.permissionTypes.reports }},{{ vm.permissionTypes.showDisabledProductsInNav }}"><span class="navbar-link display-flex content-center"><i class="material-icons md-23" title="{{ vm.products.Product_Report.overrideVal }}">assessment</i> <a ui-sref="report-list" ng-click="vm.menuClicked();">{{ vm.products.Product_Report.overrideVal }}</a></span></li><li class="mobile-menu-border-top cursor-pointer padding-none margin-top" ui-sref-active="active" ng-click="vm.myProfile()"><span class="navbar-link display-flex content-center"><a href="#">Profile</a></span></li><li class="mobile-menu-border-top cursor-pointer padding-none" ui-sref-active="active" ng-click="vm.changePassword()"><span class="navbar-link display-flex content-center"><a href="#">Change Password</a></span></li><li uib-dropdown="" class="mobile-menu-border-top" ng-if="vm.displaySettingsMenu()"><a href="" uib-dropdown-toggle="" class="inline-block full-width display-flex content-center">Settings <i class="material-icons md-18 expand-more">expand_more</i> <i class="material-icons md-18 expand-less">expand_less</i></a><ul uib-dropdown-menu="" role="menu"><li class="mobile-menu-border-top cursor-pointer padding-none" ng-click="vm.goto(\'location-list\', true)" has-permission="{{ vm.permissionTypes.locations }}" user-only-permission="true"><span class="navbar-link display-flex content-center"><a ui-sref-active="active" ui-sref="location-list">Locations</a></span></li><li class="mobile-menu-border-top cursor-pointer padding-none" ng-click="vm.goto(\'user-list\', true)" has-permission="{{ vm.permissionTypes.users }}" user-only-permission="true"><span class="navbar-link display-flex content-center"><a ui-sref-active="active" ui-sref="user-list">Users</a></span></li><li class="mobile-menu-border-top cursor-pointer padding-none" ng-click="vm.goto(\'driver-list\', true)" has-permission="{{ vm.permissionTypes.drivers }}" user-only-permission="true"><span class="navbar-link display-flex content-center"><a ui-sref-active="active" ui-sref="driver-list">Drivers</a></span></li></ul></li><li uib-dropdown="" class="mobile-menu-border-top cursor-pointer padding-none"><a href="" uib-dropdown-toggle="" class="inline-block full-width display-flex content-center">Help <i class="material-icons md-18 expand-more">expand_more</i> <i class="material-icons md-18 expand-less">expand_less</i></a><ul uib-dropdown-menu="" role="menu"><li class="mobile-menu-border-top" ng-repeat="config in vm.supportTrainingConfigs" has-permission="{{ config.requiredPermission.name }}" ng-click="vm.gotoTutorial(config.id)"><span class="navbar-link display-flex content-center"><a ui-sref-active="active" ui-sref="tutorial-list({productId: config.id})">{{config.productName}}</a></span></li></ul></li><li class="mobile-menu-border-top" ng-click="vm.privacyPolicy()"><span class="navbar-link display-flex content-center"><a href="#" target="new">Privacy Policy</a></span></li><li class="mobile-menu-border-top padding-bottom-100" ng-click="vm.logout()"><span class="navbar-link display-flex content-center"><a href="#">Logout</a></span></li></ul></div></div></nav></div><div id="non-tablet-wrapper"><nav id="frame_navbar" class="navbar navbar-fixed-top padding-right-none margin-md" ng-class="config.styleClass" role="navigation" ng-click="vm.navBarClicked()" minimize-nav-titles=""><div class="display-flex flex-row full-width-height"><div class="display-flex content-center flex-percent-75 flex-grow full-width-height"><div class="navbar-header"><ul class="nav navbar-top-links"><li uib-dropdown="" class="main-menu-toggle"><a href="" uib-dropdown-toggle="" class="margin-none padding-none"><img ng-src="{{ config.logo }}"><div class="align-middle margin-left inline link" ng-click="vm.menuClicked();" ng-if="vm.getNewMenuProductDisplayName() !== null"><i class="material-icons md-21" title="{{ vm.getNewMenuProductDisplayName() }}">{{vm.getActiveProductIcon()}}</i><div class="inline margin-left-sm font-size-14 text-uppercase padding-right-20">{{vm.getNewMenuProductDisplayName()}}</div></div></a><ul id="main-menu" uib-dropdown-menu="" role="menu" class="position-absolute top-px-40 ul-col-2 margin-md" ng-class="{\'min-width-px-340\': vm.showMessagingIcons()}"><li ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.messaging}" has-permission="{{ vm.permissionTypes.messaging }}" has-no-permission-disabled="{{ vm.permissionTypes.messaging }}"><span class="navbar-link"><a ui-sref="contact-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Messaging.overrideVal }}">forum</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Messaging.overrideVal }}</span></a></span></li><li ui-sref-active="active" ng-class="{\'active\': vm.cleanMarketingArea() === vm.permissionTypes.checkIn}" has-permission="{{ vm.permissionTypes.checkIn }}" has-no-permission-disabled="{{ vm.permissionTypes.checkIn }}"><span class="navbar-link"><a ui-sref="checkin-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_CheckIn.overrideVal }}">assignment_turned_in</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_CheckIn.overrideVal }}</span></a></span></li><li ng-class="{active: vm.isTransportationState()}" has-permission="{{ vm.permissionTypes.transportation }},{{ vm.permissionTypes.showDisabledProductsInNav }}" has-no-permission-disabled="{{ vm.permissionTypes.transportation }}"><span class="navbar-link"><a ng-click="vm.experiencesTransportationClicked()" class="display-flex content-center"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Transportation.overrideVal }}">drive_eta</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Transportation.overrideVal }} {{ $state }}</span></a></span></li><li ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.reports}" has-permission="{{ vm.permissionTypes.reports }},{{ vm.permissionTypes.showDisabledProductsInNav }}" has-no-permission-disabled="{{ vm.permissionTypes.reports }}"><span class="navbar-link"><a ui-sref="report-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Report.overrideVal }}">assessment</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Report.overrideVal }}</span></a></span></li><li ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.appointments}" has-permission="{{ vm.permissionTypes.appointments }}" has-no-permission-disabled="{{ vm.permissionTypes.appointments }}"><span class="navbar-link"><a ui-sref="appointment-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Appointment.overrideVal }}">insert_invitation</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Appointment.overrideVal }}</span></a></span></li><li ng-show="!vm.hasInspect()" class="ng-hide" ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.authorizations}" has-permission="{{ vm.permissionTypes.authorizations }}" has-no-permission-disabled="{{ vm.permissionTypes.authorizations }}"><span class="navbar-link"><a ui-sref="auth-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Authorizations.overrideVal }}">input</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Authorizations.overrideVal }}</span></a></span></li><li ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.inspect}" has-permission="{{ vm.permissionTypes.inspect }}" has-no-permission-disabled="{{ vm.permissionTypes.inspect }}"><span class="navbar-link"><a ui-sref="inspect" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Inspect.overrideVal }}">assignment</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Inspect.overrideVal }}</span></a></span></li><li ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.payments}" has-permission="{{ vm.permissionTypes.payments }}" has-no-permission-disabled="{{ vm.permissionTypes.payments }}"><span class="navbar-link"><a ui-sref="payments-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Payment.overrideVal }}">credit_card</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Payment.overrideVal }}</span></a></span></li><li ng-class="{\'active\': vm.isLoanerState() === true}" has-permission="{{ vm.permissionTypes.loaner }}" has-no-permission-disabled="{{ vm.permissionTypes.loaner }}"><span class="navbar-link"><a ui-sref="loaner-contracts-list" class="display-flex content-center" ng-click="vm.closeModal()"><i class="material-icons md-21 padding-right-md" title="{{ vm.products.Product_Loaner.overrideVal }}">library_books</i> <span class="nav-title text-uppercase font-size-10 padding-none">{{ vm.products.Product_Loaner.overrideVal }}</span></a></span></li><li id="bottom-profile-menu" class="position-absolute text-nowrap"><div class="padding-none profile-menu"><div class="inline" ng-if="vm.showMessagingIcons()"><button type="button" class="padding-left-md padding-right-15 navbar-btn go-mobile margin-none" ng-class="{ \'theme-link\': vm.isGoMobileEnabled }" ng-click="vm.toggleGoMobile()" has-permission="{{ vm.permissionTypes.messaging }}" uib-popover="Go Mobile - Currently {{ vm.isGoMobileEnabled ? \'Enabled\' : \'Disabled\' }}" popover-trigger="mouseenter" popover-append-to-body="true"><i class="material-icons md-21">stay_primary_portrait</i></button> <button type="button" class="navbar-btn go-mobile margin-none padding-right-15" ng-class="{ \'theme-link\': vm.isOutOfOffice }" ng-click="vm.openOutOfOffice()" uib-popover="Out Of Office {{ vm.isOutOfOffice ? \'Enabled\' : \'Disabled\' }}" popover-trigger="mouseenter" ng-disabled="vm.isAsideOpen" popover-append-to-body="true"><i class="material-icons md-21">transfer_within_a_station</i></button></div><button type="button" ng-if="vm.showSettingsSubMenu()" class="navbar-btn padding-right-15 margin-none" ng-click="vm.openSubMenu(vm.parentMenus.adminSettings)" uib-popover="Admin Settings" popover-trigger="mouseenter" popover-append-to-body="true"><i class="material-icons md-21">settings</i></button> <button type="button" class="navbar-btn padding-right-15 margin-none" ng-click="vm.openSubMenu(vm.parentMenus.myAccount)" uib-popover-template="\'account-tooltip-template.html\'" popover-trigger="mouseenter" popover-append-to-body="true"><i class="material-icons md-21">account_circle</i></button> <button type="button" class="navbar-btn padding-right-15 margin-none" ng-click="vm.openHelp()" uib-popover="Help" popover-trigger="mouseenter" popover-append-to-body="true"><i class="material-icons md-21">help</i></button> <button type="button" class="navbar-btn padding-right-15 margin-none" ng-click="vm.privacyPolicy()" uib-popover="Privacy Policy" popover-trigger="mouseenter" popover-append-to-body="true"><i class="material-icons md-21">privacy_tip</i></button> <button type="button" class="navbar-btn padding-right-15 margin-none" ng-click="vm.logout()" uib-popover="Logout" popover-trigger="mouseenter" popover-append-to-body="true"><i class="material-icons md-21">logout</i></button></div></li></ul></li></ul></div><div class="navbar-collapse collapse font-size-11" id="navbar"><ul ng-if="vm.currentParentMenu === vm.parentMenus.adminSettings" class="sub-menu nav navbar-nav visible-links text-uppercase"><li class="margin-top-none" has-permission="{{ vm.permissionTypes.locations }}" user-only-permission="true" ui-sref="location-list" ng-click="vm.closeModal()" ng-class="{\'active\': vm.isLocationList()}"><span class="margin-left-none padding-left-none">Locations</span></li><li class="margin-top-none" has-permission="{{ vm.permissionTypes.users }}" user-only-permission="true" ui-sref-active="active" ui-sref="user-list" ng-click="vm.closeModal()"><span class="margin-left-none">Users</span></li><li class="margin-top-none" has-permission="{{ vm.permissionTypes.drivers }}" user-only-permission="true" ui-sref-active="active" ui-sref="driver-list" ng-click="vm.closeModal()"><span class="margin-left-none">Drivers</span></li><li class="margin-top-none" ng-click="vm.gotoLyftRefunds()" has-permission="{{ vm.permissionTypes.lyftRefunds }}" user-only-permission="true"><span class="margin-left-none">Ride Provider Refunds</span></li><li ng-click="vm.uberServiceability();" ng-if="vm.isSysAdminOrRedCapAdmin" class="margin-top-none"><span class="margin-left-none">Uber Serviceability</span></li><li ng-click="vm.venueMapping();" has-permission="{{ vm.permissionTypes.transportation}}" ng-if="vm.isAdmin" class="margin-top-none" ng-class="{\'active\': vm.isVenueMapping()}"><span class="margin-left-none">Pickup/Dropoff Points</span></li><li ng-click="vm.systemSurveyManagement();" ng-if="vm.isSystemAdmin" class="margin-top-none"><span class="margin-left-none">Surveys</span></li></ul><ul ng-if="vm.currentParentMenu === vm.parentMenus.myAccount" class="sub-menu nav navbar-nav visible-links text-uppercase"><li ui-sref-active="active" ui-sref="profile" class="margin-top-xs" ng-click="vm.myProfile()"><span>Profile</span></li><li ui-sref-active="active" ui-sref="changepassword" class="margin-top-xs" ng-click="vm.changePassword()"><span>Change Password</span></li><li has-permission="{{ vm.permissionTypes.appointments}}" ng-if="vm.canAccessManageMySchedule()" ng-class="{\'active\': vm.isManageMySchedule()}" class="margin-top-xs" ng-click="vm.mySchedule()"><span>Manage My Schedule</span></li></ul></div></div><div class="display-flex content-center flex-width-50 full-width-height" has-permission="{{ vm.permissionTypes.messaging }}"><div class="full-width-height text-right margin-right"><div class="inline-block full-height navbar-nav margin-none padding-left-20 font-size-20 border-left"><div class="display-flex full-width-height content-center" popover-placement="left" uib-popover="Number of unread from customers with you as their advisor. (Your Customers)" popover-trigger="mouseenter"><a ui-sref-active="active" ng-class="{\'active\': vm.marketingArea === vm.permissionTypes.messaging}" ng-click="vm.goto(\'contact-list\', true)" has-permission="{{ vm.permissionTypes.messaging }}" has-no-permission-disabled="{{ vm.permissionTypes.messaging }}"><b>{{ vm.notificationCount }}</b></a></div></div></div></div></div></nav></div></div><div id="page-wrapper" class="display-flex gray-bg" ng-class="config.styleClass"><div ui-view=""></div></div></div><script type="text/ng-template" id="account-tooltip-template.html"><div>Account Settings for:<br/>{{vm.email}}</div></script>');
$templateCache.put('app/shared/layouts/handle-login/handle-login.view.html','<div class="login-page-container"><div class="display-flex flex-column full-width-height"><div class="login-box flex-percent-20"></div><div class="login-box flex-percent-80 full-width-height text-nowrap overflow-y-auto overflow-x-hidden margin-bottom-sm content-center"><div class="inline font-size-14 font-bold padding-top-sm"><img src="assets/images/ajax-loader.gif"> You are being redirected, please wait...</div></div></div></div>');
$templateCache.put('app/shared/messages/views/message-tabs.view.html','<div class="display-flex flex-column full-width-height"><div ng-if="$ctrl.ro" class="flex-fullwidth-130h row aside-header visible-xs-block visible-sm-block"><div id="ro-mobile-messaging-header" class="display-flex text-uppercase"><div class="display-flex flex-column flex-static-size margin-right-sm"><div class="title ellipsis-overflow text-bold">{{ $ctrl.contact.firstName }} {{ $ctrl.contact.lastName }}</div><div>{{ $ctrl.contact.phone }}</div><div class="max-width-px-150 text-break">{{ $ctrl.contact.email }}</div><div>{{ $ctrl.ro.vehicle.year }} {{ $ctrl.ro.vehicle.make }} {{ $ctrl.ro.vehicle.model }}</div><div ng-if="vm.ro.vin">{{$ctrl.ro.vin}}</div></div><div class="flex-fill hidden-sm text-right align-right"><div class="text-bold">RO# {{ $ctrl.ro.dmsRepairOrderNumber || \'UNKNOWN\' }}</div><div ng-if="vm.ro.referenceTag">Tag: #{{$ctrl.ro.referenceTag}}</div><div class="ellipsis-overflow" uib-popover="{{$ctrl.ro.serviceAdvisor.fullName || \'NA\'}}" popover-trigger="click">Adv: {{$ctrl.ro.serviceAdvisor.fullName || \'NA\'}}</div><div class="ellipsis-overflow" uib-popover="{{$ctrl.ro.technician.fullName || \'NA\'}}" popover-trigger="click">Tech: {{$ctrl.ro.technician.fullName || \'NA\'}}</div><div class="ellipsis-overflow" uib-popover="{{$ctrl.ro.shopFlag || \'NA\'}}" popover-trigger="click">Shop Flag: {{$ctrl.ro.shopFlag || \'NA\'}}</div><div class="theme-link" ng-click="$ctrl.hide()"><i class="material-icons md-24">comments_disabled</i></div></div></div></div><div class="display-flex flex-column overflow-hidden"><div id="message-tabs" scrollable-tabs="" class="margin-none font-normal invisible-tabs scrollable themed"><uib-tabset class="aside-right-tabs trips"><uib-tab ng-repeat="tab in $ctrl.messagingTabs" heading="{{tab.title}}" active="tab.active" id="{{tab.id}}" ng-click="$ctrl.tabChanged(tab.tabType)" ui-sref="{{tab.route}}"><ui-view name="{{tab.route}}" class="full-width-height" fill-height=""><div class="tab-loading-overlay"><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading...</div></div></div></ui-view></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/shared/messages/views/messages-customer-tab.view.html','<div class="trip-right-tab messaging full-width bg-white color-default"><div class="col-xs-12 padding-none flex-grow" ng-if="vm.contact"><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" contact="vm.contact" panel-mode="vm.messagingPanelModes.dealerCustomer" has-messaging="vm.hasMessaging"></rc-messaging-panel></div><div class="col-xs-12 flex-grow" ng-if="vm.contactError"><div class="speech-bubble-body full-width">{{ vm.contactError }}</div></div><div class="col-xs-12 flex-grow margin-top-sm" ng-if="!vm.contact && !vm.contactError"><div class="speech-bubble-body">Select a customer to access Messaging</div></div></div>');
$templateCache.put('app/shared/messages/views/messages-dealer-info-tab.view.html','<div class="trip-right-tab messaging full-width dealer-info-notes bg-white color-default"><div ng-if="vm.trip"><div class="col-xs-12 padding-none flex-grow"><div class="display-flex content-center padding-left-md margin-top-md"><input id="is_at_risk" type="checkbox" class="margin-none" ng-click="vm.toggleAtRiskDealer()" ng-value="vm.trip.dealer.isAtRisk" ng-model="vm.trip.dealer.isAtRisk"> <label for="is_at_risk" class="margin-none padding-left-sm font-normal">High Risk Location</label><div class="warning" ng-if="vm.atRiskError">{{ vm.atRiskError }}</div></div><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" trip="vm.trip" panel-mode="vm.messagingPanelModes.dealerInfo" has-messaging="vm.canAddNotes"></rc-messaging-panel></div><div class="col-xs-12 flex-grow" ng-if="!vm.trip"><div class="speech-bubble-body full-width">No trip selected.</div></div></div><div ng-if="!vm.trip"><div class="col-xs-12 flex-grow margin-top-sm" ng-if="!vm.trip.dealer.id"><div class="speech-bubble-body">Select a dealer to access Messaging</div></div></div></div>');
$templateCache.put('app/shared/messages/views/messages-driver-tab.view.html','<div class="trip-right-tab messaging full-width bg-white color-default"><div ng-if="vm.trip"><div class="col-xs-12 padding-none flex-grow" ng-if="vm.trip && vm.trip.driver.id"><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" trip="vm.trip" panel-mode="vm.messagingPanelModes.dealerDriver"></rc-messaging-panel></div><div class="col-xs-12 flex-grow margin-top-sm" ng-if="!vm.trip.driver.id"><div class="speech-bubble-body full-width">No driver assigned.</div></div></div></div>');
$templateCache.put('app/shared/messages/views/messages-internal-tab.view.html','<div class="trip-right-tab messaging full-width bg-white color-default"><div class="col-xs-12 padding-none flex-grow" ng-if="vm.contact"><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" contact="vm.contact" panel-mode="vm.messagingPanelModes.internal" has-messaging="vm.hasMessaging"></rc-messaging-panel></div><div class="col-xs-12 flex-grow" ng-if="vm.contactError"><div class="speech-bubble-body full-width">{{ vm.contactError }}</div></div><div class="col-xs-12 flex-grow margin-top-sm" ng-if="!vm.contact && !vm.contactError"><div class="speech-bubble-body">Select a customer to access Messaging</div></div></div>');
$templateCache.put('app/shared/messages/views/messages-monitor-tab.view.html','<div class="trip-right-tab messaging full-width bg-white color-default"><div ng-if="vm.trip"><div class="col-xs-12 padding-none flex-grow" ng-if="vm.trip"><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" trip="vm.trip" panel-mode="vm.messagingPanelModes.driverCustomer"></rc-messaging-panel></div><div class="col-xs-12 flex-grow" ng-if="vm.contactError"><div class="speech-bubble-body full-width">{{ vm.contactError }}</div></div></div></div>');
$templateCache.put('app/shared/messages/views/messages-notes-tab.view.html','<div class="trip-right-tab messaging full-width bg-white color-default"><div ng-if="vm.trip"><div class="col-xs-12 padding-none flex-grow" ng-if="vm.trip"><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" trip="vm.trip" panel-mode="vm.messagingPanelModes.tripNotes" has-messaging="vm.hasMessaging"></rc-messaging-panel></div><div class="col-xs-12 flex-grow" ng-if="!vm.trip"><div class="speech-bubble-body full-width">No trip selected.</div></div></div></div>');
$templateCache.put('app/shared/modal/add-address/add-address-modal.view.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Add Address</h4></div><form role="form" id="tripSettingsForm" name="addAddressForm" ng-submit="vm.saveAddress()" novalidate=""><div class="modal-body"><div class="form-group"><div class="row margin-bottom"><div class="col-xs-5 field-wrapper"><label for="country">COUNTRY</label><select selectlabel="" name="country" id="customer-country" ng-model="vm.address.countryShortCode" class="form-control input" required="" placeholder="Country"><option value="USA" selected="">Usa</option><option value="CAN">Canada</option></select></div></div><div class="row margin-bottom"><div class="col-xs-12"><div class="visible-xs override-xs-padding-top-md">ADDRESS</div><input type="text" id="customer-street" name="street" ng-model="vm.address.streetAddress" class="form-control better-placeholder" clean="true" placeholder="STREET" required="" validation="required:alt=Required"></div></div><div class="row margin-bottom"><div class="col-sm-5 col-xs-12"><div class="visible-xs override-xs-padding-top-md">CITY</div><input type="text" id="customer-city" name="city" ng-model="vm.address.city" class="form-control better-placeholder" clean="true" placeholder="CITY" required="" validation="required:alt=Required"></div><div ng-if="vm.address.countryShortCode === \'USA\'" class="col-sm-2 col-xs-12 field-wrapper"><label for="state">STATE</label><select selectlabel="" name="state" id="customer-state" ng-model="vm.address.state" class="form-control input" required="" validation="required:alt=Required" ng-options="item as item for item in vm.usStates"><option value="" disabled="disabled" selected="selected">State</option></select></div><div ng-if="vm.address.countryShortCode === \'CAN\'" class="col-sm-5 col-xs-12 field-wrapper text-uppercase"><label for="state">PROVINCE</label><select selectlabel="" name="state" id="customer-state" ng-model="vm.address.state" class="form-control input" required="" validation="required:alt=Required" ng-options="item as item for item in vm.canadianProvinces"><option value="" disabled="disabled" selected="selected">Province</option></select></div><div class="col-xs-12" ng-class="vm.address.countryShortCode == \'USA\' ? \'col-sm-5\' : \'col-sm-2\'"><div class="visible-xs override-xs-padding-top-md">ZIP</div><input ng-if="vm.address.countryShortCode === \'USA\'" type="text" id="customer-zip" name="zip" ng-model="vm.address.zip" class="form-control better-placeholder" clean="true" required="" placeholder="ZIP" mask-restrict="reject" mask="99999" validation="required:alt=Required"> <input ng-if="vm.address.countryShortCode !== \'USA\'" type="text" id="customer-zip" name="zip" ng-model="vm.address.zip" class="form-control better-placeholder" clean="true" required="" placeholder="ZIP" validation="required:alt=Required"></div></div><div class="row"><div class="col-sm-6 col-xs-12"><div class="visible-xs override-xs-padding-top-md">LAT</div><input type="text" id="customer-lat" name="lat" ng-model="vm.address.lat" class="form-control better-placeholder" clean="true" placeholder="LAT" required="" validation="required:alt=Required|numeric_signed"></div><div class="col-sm-6 col-xs-12"><div class="visible-xs override-xs-padding-top-md">LNG</div><input type="text" id="customer-lng" name="lng" ng-model="vm.address.lng" class="form-control better-placeholder" clean="true" placeholder="LNG" required="" validation="required:alt=Required|numeric_signed"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CANCEL</button> <button type="submit" ng-disabled="addAddressForm.$invalid" class="btn btn-primary">OK</button></div></form>');
$templateCache.put('app/shared/modal/appointments/arrive-appointment.html','<div class="modal-header"><h4 class="modal-title text-uppercase">CUSTOMER HAS ARRIVED</h4></div><form id="arrive-appointment-form" name="arrive-appointment-form" ng-submit="vm.arriveAppointment()"><div class="modal-body appointment-modal appointment-modal-arrive"><div ng-if="vm.errors.length < 1"><div class="row"><div class="col-xs-12"><input type="text" id="mobile_phone_number" name="mobile_phone_number" required="" inputmode="numeric" ng-model-options="{ debounce: 750 }" autocomplete="nope" ng-model="vm.mobilePhone" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="CUSTOMER PHONE" validation="required"></div></div><div class="row margin-top"><div class="col-xs-12 field-wrapper"><label for="selectedDepartment">DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0" name="selectedDepartment" required="" ng-model-options="{ debounce: 750 }" class="form-control" ng-model="vm.selectedDepartmentId" ng-options="dept.id as dept.name for dept in vm.dealerDepartments" validation="required|custom:vm.validation.isValidDepartment():alt=Please pick a value from the list" ng-change="vm.departmentChanged()"><option value="">Department</option></select></div></div><div class="row margin-top"><div class="col-xs-12 field-wrapper"><label for="advisor">CHOOSE ADVISOR</label><select selectlabel="" id="advisor" name="advisor" class="form-control" ng-model="vm.selectedAdvisor" ng-disabled="!vm.appt.departmentId || vm.loadingAdvisors" ng-model-options="{ debounce: 750 }" required="required" validation="required" ng-options="::(adv.firstName ? adv.firstName + \' \' + adv.lastName : adv.lastName) + vm.getAdvisorAvailTime(adv) for adv in vm.serviceAdvisors track by adv.id"><option value="">Choose advisor</option></select><img id="arrive-appointment-spinner" src="assets/images/ajax-loader.gif" class="ng-hide" ng-show="vm.loadingAdvisors"></div></div></div><div ng-if="vm.errors.length > 0"><ul class="list-unstyled"><li ng-repeat="error in vm.errors">{{error}}</li></ul></div></div><div class="modal-footer"><div class="row"><div class="col-xs-4 pull-left"><span class="spinner-text pull-left" ng-if="vm.isSaving || vm.initializing"><img src="assets/images/ajax-loader.gif"> <span ng-if="vm.isSaving">SAVING</span><span ng-if="vm.initializing">LOADING</span></span></div><div class="col-xs-8"><button type="submit" ng-if="vm.errors.length > 1" ng-click="vm.resetErrors()">TRY AGAIN</button> <button type="submit" ng-disabled="vm.invalidForm() || vm.isSaving" class="btn btn-primary" ng-if="vm.errors.length < 1">OK</button> <button type="button" ng-click="vm.cancel()" ng-disabled="vm.isSaving" class="btn btn-default" data-dismiss="modal">CANCEL</button></div></div></div></form>');
$templateCache.put('app/shared/modal/appointments/duplicate-customer.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.newCustomer()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Existing Customer(s) Found</h4></div><div class="modal-body"><div class="margin-bottom">Some of the customer details entered appear to match the existing customer(s) below. Please select the customer from the list below or click CANCEL to continue creating a new customer record:<br><div class="form-group"><table class="table table-hover customer-found"><thead class="hidden-xs"><tr><th class="customer-found-rb-col padding-left-none" data-toggle="false">&nbsp;</th><th class="customer-found-rb-name padding-left-none" data-toggle="false"><b>Name</b></th><th class="customer-found-rb-phone" data-toggle="false"><b>Phone</b></th><th class="customer-found-rb-email" data-toggle="false"><b>Email</b></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.uniqueId" class="list-name text-uppercase"><td class="customer-found-rb-col padding-left-none"><input type="radio" id="c{{ customer.uniqueId }}" name="customer-grp" ng-model="vm.chosenCustomer" value="{{ customer.uniqueId }}"></td><td class="customer-found-rb-name ellipsis-overflow padding-left-none"><label for="c{{ customer.uniqueId }}" class="font-normal ellipsis-overflow" title="{{customer.firstName}} {{customer.lastName}}">{{ customer.firstName }} {{ customer.lastName }}<span ng-if="!customer.firstName && !customer.lastName">N/A</span><span ng-if="customer.firstName === \'\' && customer.lastName === \'\'">N/A</span></label></td><td class="customer-found-rb-phone ellipsis-overflow"><label for="c{{ customer.uniqueId }}" class="font-normal ellipsis-overflow"><span ng-if="customer.phone != \'0\'">{{ customer.phone | tel }}</span></label><span ng-if="!customer.phone || customer.phone === \'0\' || customer.phone === \'\'">N/A</span></td><td class="customer-found-rb-email ellipsis-overflow"><label for="c{{ customer.uniqueId }}" class="font-normal ellipsis-overflow">{{ customer.email }}</label><span ng-if="!customer.email || customer.email === \'\'">N/A</span></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.newCustomer()" class="btn btn-default text-uppercase" data-dismiss="modal">Cancel</button> <button type="buttom" ng-click="vm.selectedCustomer()" class="btn btn-primary text-uppercase">SELECT CUSTOMER</button></div>');
$templateCache.put('app/shared/modal/messages/duplicate-phone.html','<div class="modal-header"><h4 class="modal-title">Duplicate Phone Number</h4></div><div class="modal-body"><p>The phone number entered is associated with a different contact. Are you sure you want to continue? Clicking Yes below will reassign the number to the new contact.</p></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="btn btn-default">No</button> <button type="button" ng-click="$close()" class="btn btn-primary">Yes</button></div>');
$templateCache.put('app/shared/modal/messages/send-driver-message.html','<div class="modal-header"><h4 class="modal-title">Send Driver Message</h4></div><div class="modal-body"><textarea rows="4" class="full-width form-control resize-none" ng-model="vm.message" placeholder="Enter the message you would like to send to the driver."></textarea><br><span class="text-danger" ng-show="vm.messageSent">{{ vm.messageStatus }}</span></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="btn btn-default">{{ vm.messageSent ? \'Close\' : \'Cancel\'}}</button> <button type="button" ng-if="!vm.messageSent" ng-click="vm.sendMessage()" ng-disabled="vm.message.length < 1 || vm.sendingMessage" class="btn btn-primary">Send</button></div>');
$templateCache.put('app/shared/components/visualDateTime/visual-date-time.component.view.html','<center><table class="visual-date-time"><tr class="header"><td class="text-uppercase" ng-repeat="day in vm.timeSlots.days" ng-if="day.displayTimeSlots" ng-class="vmSchedulePnl.getColClass($index);"><center><div class="text-center text-nowrap inline">{{ day.day | date:\'d EEE\'}}</div></center></td></tr><tr id="visual-time-slots" class="time-slots"><td ng-repeat="day in vm.timeSlots.days"><center><ul class="list-unstyled"><li ng-if="day.hoursOfOperation.isOpen" ng-repeat="s in day.displayTimeSlots"><a ng-if="s.disabled == true" class="btn btn-default pill-btn text-center" ng-class="{\'disabled\': s.disabled && !s.selected, \'selected\': s.disabled && s.selected}"><div class="time-btn">{{vm.getButtonLabel(s) | date:\' h:mm a\'}}</div></a><div uib-dropdown="" auto-close="always" ng-if="s.disabled == false"><button type="button" class="btn btn-default pill-btn text-center selected" ng-if="s.selected == true" uib-dropdown-toggle="" ng-click="vm.timeBubbleClicked(s, $event)" ng-class="{\'disabled\': s.disabled}"><div class="time-btn" ng-if="s.selected == true">{{vm.getButtonLabel(s) | date:\' h:mm a\'}}</div></button> <button type="button" class="btn btn-default pill-btn text-center" ng-if="s.selected == false" uib-dropdown-toggle="" ng-click="vm.timeBubbleClicked(s, $event)" ng-class="{\'disabled\': s.disabled}"><div class="time-btn">{{s.label}}</div></button><div ng-if="s.disabled == false" class="dropdown-menu custom-time-popup" uib-dropdown-menu=""><div class="time-selection-header"><div class="display-flex content-center"><b><span class="header-label text-nowrap padding-left-sm">{{vm.selectedTimeGroup.label}}</span></b><i class="material-icons md-16 custom-time-close">close</i></div></div><ul ng-if="vm.selectedTimeGroup"><li ng-repeat="item in vm.selectedTimeGroup.slots" ng-class="{\'disabled\': item.unavailable == true}" ng-click="vm.setSelectedTime(day, vm.selectedTimeGroup, item)"><span class="time" ng-class="{\'text-bold\': vm.isTimeSelected(item), \'theme-text\': vm.isTimeSelected(item), \'text-underline\':vm.isTimeSelected(item)}">{{ vm.getDropdownLabel(item) }}</span></li></ul></div></div></li><li ng-if="!day.hoursOfOperation.isOpen" class="closed" ng-repeat="s in day.displayTimeSlots"><a class="btn btn-default pill-btn text-center" ng-class="{disabled: s.disabled}"><div class="time-btn">CLOSED</div></a></li></ul></center></td></tr></table></center>');
$templateCache.put('app/shared/components/visualDateTime/visual-date.component.view.html','<div class="text-uppercase" id="visual-date-header"><i class="material-icons md-36 link" ng-click="vm.backArrowClicked()" ng-class="{\'disabled\': vm.disableBackArrrow()}">arrow_back</i> <span id="month-date" min-date="vm.minDate" moment-picker="vm.calendarDate" start-view="month" selectable="vm.isDateSelectable(date, type)" format="YYYY-MM-DD" change="vm.dateChanged(newValue, oldValue)">{{vm.monthDisplay}} {{vm.yearDisplay}} <i class="material-icons md-24 theme-link">event</i></span><i class="material-icons md-36 theme-link" ng-click="vm.forwardArrowClicked()">arrow_forward</i></div>');
$templateCache.put('app/shared/components/list-advanced-filter-toggle/list-advanced-filter-toggle.view.html','<div class="display-flex flex-row" ng-class="{\'pull-right\': vm.alignRight === true}"><div class="flex-fullwidth-20h display-flex margin-top-sm padding-left-sm override-xs-padding-none"><span class="filter-count text-uppercase hidden-sm hidden-xs" popover-trigger="none" popover-popup-close-delay="0" popover-is-open="vm.isPopoverOpen" popover-class="popover-filter-message" uib-popover-template="\'filter-message-popover.html\'"><i ng-click="vm.toggleAdvancedSearch()" ng-mouseenter="vm.onMouseEnter()" ng-mouseleave="vm.onMouseLeave()" ng-class="{\'inactive\': vm.showSearchTray === true, \'muted\': vm.ngDisabled}" class="md-24 material-icons theme-link">filter_list</i></span><span class="filter-count text-uppercase visible-sm visible-xs"><i ng-click="vm.toggleAdvancedSearch()" ng-hide="vm.searchTrayDisplayed" ng-class="{\'inactive\': vm.showSearchTray === true, \'muted\': vm.ngDisabled}" class="md-24 material-icons link">filter_list</i> <i ng-click="vm.toggleAdvancedSearch()" ng-show="vm.searchTrayDisplayed" ng-class="{\'inactive\': vm.showSearchTray === true, \'muted\': vm.ngDisabled}" class="md-24 material-icons theme-link">close</i></span></div></div><script type="text/ng-template" id="filter-message-popover.html"><div ng-mouseenter="vm.onMouseEnter()" ng-mouseleave="vm.onMouseLeave()"> <div ng-if="!vm.ngDisabled"> <div><b>Records:</b> <span>{{vm.recordCount || 0}}</span></div> <div ng-if="vm.filterCount > 0" ng-bind-html="vm.filterMessage"></div> <div ng-if="!vm.filterCount"><b>Filters:</b> NONE</div> <div ng-if="vm.filterCount > 0" class="theme-link margin-top-md text-uppercase" ng-click="vm.resetFilters()"><u>Reset Filters</u></div> </div> <div ng-if="vm.ngDisabled"> <span ng-if="!vm.ngDisabledMessage">Please select a location<br/> to use advanced filters.</span> <span ng-if="vm.ngDisabledMessage" ng-bind-html="vm.ngDisabledMessage"></span> </div> </div></script>');
$templateCache.put('app/areas/profile/views/changepassword.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height ng-scope"><div class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none overflow-y-auto"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="padding-lg border-none text-uppercase" resize-class="ibox-content"><h3>Change Password</h3></div><div ng-if="vm.isSolidUser" class="ibox-content border-top-none padding-bottom-none" fill-height="" additional-padding="11"><p>Initiate a password change following the instructions on the email.</p><hr><button type="button" ladda="vm.sendingPasswordResetEmail" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.updatePassword()">Send Password Reset Email</button></div><div ng-if="!vm.isSolidUser" class="ibox-content border-top-none padding-bottom-none" fill-height="" additional-padding="11"><div class="form-horizontal"><form role="form" name="ChangePasswordForm" class="form" ng-submit="ChangePasswordForm.$valid && vm.changePassword()" novalidate=""><input class="ng-hide" type="text" id="username" name="username" autocomplete="username" value="{{vm.currentUser.userName}}"><div class="row"><div class="col-sm-8"><div class="form-group"><label class="col-sm-6 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s current password." popover-trigger="outsideClick">Current Password</span></label><div class="col-sm-6"><input required="" type="password" id="current_password" name="current_password" autocomplete="current-password" ng-model="vm.currentPassword" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|remote:vm.passwordRemoteValidation(vm.currentPassword)" friendly-name="Current Password"> <span ng-if="vm.incorrectPwdSupplied == true" class="text-danger"><br>The password you supplied was incorrect. Please re-enter your current password.</span></div></div><div class="form-group"><label class="col-sm-6 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s new password." popover-trigger="outsideClick">New Password</span></label><div class="col-sm-6"><input required="" type="password" id="new_password" name="new_password" ng-model="vm.newPassword" autocomplete="new-password" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|remote:vm.passwordRemoteValidation(vm.newPassword)" friendly-name="New Password"></div></div><div class="form-group"><label class="col-sm-6 control-label"><span class="cursor-pointer hover-underline" uib-popover="Re-enter the user\'s new password." popover-trigger="outsideClick">Confirm Password</span></label><div class="col-sm-6"><input required="" type="password" id="confirm_password" name="confirm_password" ng-model="vm.confirmPassword" autocomplete="new-password" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|match:vm.newPassword:alt=Must match New Password" friendly-name="Confirm Password"></div></div></div><div class="col-sm-4"><b>Password Requirements:</b><ul><li>Minimum 8 characters</li><li>One uppercase character</li><li>One lowercase character</li><li>One numeric character</li></ul></div></div><div class="modal-footer margin-top"><br><event-alert></event-alert><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || ChangePasswordForm.$invalid">Update</button></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/areas/profile/views/changepasswordForced.view.html','<div class="panel margin-md override-sm-margin-none"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="padding-lg border-none" resize-class="ibox-content"><h3>Looks like you need to change your password. You\'ve either been issued a temporary password, or your account admin is requiring you change it at this time. Please choose a new password.</h3></div><div class="ibox-content border-top-none" fill-height=""><div class="row"><div class="form-horizontal"><form role="form" name="ChangePasswordForm" class="form" ng-submit="ChangePasswordForm.$valid && vm.changePassword()" novalidate=""><div class="row"><div class="col-sm-8"><div class="form-group"><label class="col-sm-6 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s current password." popover-trigger="outsideClick">Current Password</span></label><div class="col-sm-6"><input required="" type="password" id="current_password" name="current_password" autocomplete="current-password" ng-model="vm.currentPassword" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|remote:vm.passwordRemoteValidation(vm.currentPassword)" friendly-name="Current Password"></div></div><div class="form-group"><label class="col-sm-6 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s new password." popover-trigger="outsideClick">New Password</span></label><div class="col-sm-6"><input required="" type="password" id="new_password" name="new_password" ng-model="vm.newPassword" autocomplete="new-password" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|remote:vm.passwordRemoteValidation(vm.newPassword)" friendly-name="New Password"></div></div><div class="form-group"><label class="col-sm-6 control-label"><span class="cursor-pointer hover-underline" uib-popover="Re-enter the user\'s new password." popover-trigger="outsideClick">Confirm Password</span></label><div class="col-sm-6"><input required="" type="password" id="confirm_password" name="confirm_password" autocomplete="new-password" ng-model="vm.confirmPassword" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required|match:vm.newPassword:alt=Must match New Password" friendly-name="Confirm Password"></div></div></div><div class="col-sm-4"><b>Password Requirements:</b><ul><li>Minimum 8 characters</li><li>One uppercase character</li><li>One lowercase character</li><li>One numeric character</li></ul></div></div><div class="modal-footer margin-top"><br><event-alert></event-alert><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || ChangePasswordForm.$invalid">Update</button></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/areas/profile/views/profile.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height ng-scope"><div class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none overflow-y-auto"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="padding-lg padding-bottom-none text-uppercase" resize-class="ibox-content"><h3>My Profile</h3></div><div class="ibox-content border-none"><div class="form-horizontal"><form role="form" name="UserEditForm" class="form userEditForm" ng-submit="UserEditForm.$valid && vm.updateUser()" novalidate=""><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Pick the user\'s profile photo." popover-trigger="outsideClick">Profile Photo</span></label><div class="col-sm-6"><div class="profilePicCropArea" ng-if="vm.profilePic.profileImageUpload"><ui-cropper image="vm.profilePic.profileImageUpload" result-image="vm.profilePic.profileImage"></ui-cropper></div><div ng-if="!vm.profilePic.profileImageUpload"><img class="img-circle" ng-src="{{ vm.currentUser.profilePicture }}"></div><div>&nbsp;</div><div><input type="file" id="fileInput" file-input="vm.profilePic.profileImageUpload"></div></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s login (email address)." popover-trigger="outsideClick">Login</span></label><div class="col-sm-4 static-text">{{vm.currentUser.userName}}</div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s first name." popover-trigger="outsideClick">First Name</span></label><div class="col-sm-4"><input type="text" id="first_name" name="first_name" ng-model="vm.currentUser.firstName" ng-disabled="vm.fieldsDisabled" class="form-control" required="" validation="required"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s last name." popover-trigger="outsideClick">Last Name</span></label><div class="col-sm-4"><input type="text" id="last_name" name="last_name" required="" ng-model="vm.currentUser.lastName" ng-disabled="vm.fieldsDisabled" class="form-control" validation="required"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s mobile phone number." popover-trigger="outsideClick">Mobile Phone</span></label><div class="col-sm-4"><input required="" type="text" id="mobile_phone" name="mobile_phone" ng-model="vm.currentUser.mobilePhone" ng-disabled="vm.fieldsDisabled" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true" validation="required"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s office phone number." popover-trigger="outsideClick">Office Phone</span></label><div class="col-sm-4"><input type="text" id="office_phone" name="office_phone" ng-model="vm.currentUser.officePhone" ng-disabled="vm.fieldsDisabled" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the user\'s outbound \'From\' email Address." popover-trigger="outsideClick">Outbound Email</span></label><div class="col-sm-4"><input required="" type="email" id="email_address" name="email_address" ng-model="vm.currentUser.email" class="form-control" validation="required"></div></div><div class="form-group"><label class="col-sm-4 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enable emailing a customer when they book, edit or cancel a trip." popover-trigger="outsideClick">Receive emails for book, edit,cancel,<br>and survey responses</span></label><div class="col-sm-4"><input type="checkbox" id="enable_emailcc" name="enable_emailcc" ng-model="vm.currentUser.enableEmailCC"></div></div><div class="modal-footer"><event-alert></event-alert><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.resetFields()">Reset</button> <button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="vm.fieldsDisabled || UserEditForm.$invalid">Update</button><div class="dash-version padding-top-md text-black">v{{ vm.dashVersion }}</div></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/areas/productmarketing/views/embedded.view.html','<iframe ng-if="vm.marketingURL" ng-src="{{vm.marketingURL}}" style="width:100%;height:100%;" type="text/html" fill-height=""></iframe><div class="" ng-if="!vm.marketingURL.length === 0 && !vm.marketingConfig.marketingFormattedContent"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="ibox-content"><br><br><br><br><h2 class="modal-title"><center>We\'re sorry, you do not have access to this product.<br>Please contact the Client Success Team or your Account Manager for more information.</center></h2></div></div></div></div></div><div ng-if="(!vm.marketingUrl || vm.marketingURL.length === 0) && vm.marketingConfig.marketingFormattedContent"><div id="fixed_header_wrapper" fill-height="" additionalpadding="10"><div class="row search-list-header search-filters white-bg border-bottom fixed-header"><div class="ibox"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row search-container"><div class="col-xs-3 padding-right-none product-name-holder"><h3 class="text-uppercase product_name">{{vm.productName}}</h3></div><div class="col-xs-9 text-right padding-left-none"><div class="pull-right padding-right-md"><div class="padding-bottom-md"><h3 id="call_us" class="inline marketing">Call <span class="hidden-xs">us at</span> <span ng-if="!vm.marketingConfig.marketingPhone">866.337.9390</span><span ng-if="vm.marketingConfig.marketingPhone">{{vm.marketingConfig.marketingPhone}}</span> or</h3><a id="inquire_btn" ui-sref="inquire({permissionId: {{vm.marketingConfig.id}}})" class="btn btn-primary margin-left-md support-btn" ng-class="config.styleClass">INQUIRE</a></div></div></div></div></div></div></div><div class="below-fixed-header"><div class="row"><div class="col-xs-12 padding-left-none padding-right-none"><center><div class="formatted-marketing-content"><img class="marketing-header-img img-responsive" ng-src="{{vm.marketingConfig.marketingImgOrVideoURL}}"></div><div ng-bind-html="vm.marketingConfig.marketingFormattedContent"></div></center></div></div></div></div></div>');
$templateCache.put('app/areas/productmarketing/views/inquire.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">PRODUCT INTEREST FORM</h2></div><div class="modal-body overflow-auto" aside-parent="vm.childScopeForm"><div class="text-uppercase margin-bottom">THANK YOU FOR YOUR INTEREST IN ENHANCING YOUR SERVICE SUITE. PLEASE COMPLETE THE FORM BELOW AND OUR PERFORMANCE MANAGEMENT TEAM WILL CONTACT YOU AS SOON AS POSSIBLE.</div><form role="form" id="submitInquiry" name="submitInquiry" class="form margin-top-30" ng-submit="vm.submitInquiry()" novalidate=""><div ng-if="!vm.sentSuccessfully"><div class="row form-group"><div class="col-sm-7 col-xs-10"><div ng-dropdown-multiselect="" options="vm.productDropDownOptions" name="products" class="fake-required" ng-model="vm.ticket.products" selected-model="vm.ticket.products" checkboxes="true" extra-settings="vm.productDropDownSettings" translation-texts="vm.productDropDownStrings" validation="custom:vm.validation.productSelected(vm.ticket.products):alt=*"></div></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><input id="firstName" name="firstName" type="text" class="form-control" placeholder="FIRST NAME" required="" validation="required" ng-model="vm.ticket.firstName"></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><input id="lastName" name="lastName" type="text" class="form-control" placeholder="LAST NAME" required="" validation="required" ng-model="vm.ticket.lastName"></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><input id="phone" name="phone" type="text" class="form-control" placeholder="PHONE" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" validation="required|custom:vm.validation.phone(vm.ticket.phone):alt=*" ng-model="vm.ticket.phone"></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><input type="email" id="email" name="email" clean="true" autocomplete="nope" ng-model="vm.ticket.email" class="form-control" ng-keydown="$event.keyCode != 32 ? $event:$event.preventDefault()" placeholder="EMAIL ADDRESS" required="" validation="required:alt=Required|email"></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><input id="company" name="company" type="text" class="form-control" placeholder="COMPANY" required="" validation="required" ng-model="vm.ticket.company"></div></div><div class="row form-group"><div class="col-sm-7 col-xs-100"><div class="field-wrapper"><select selectlabel="" required="" class="form-control" name="state" id="state" ng-model="vm.ticket.state" ng-options="str for str in vm.usStates" validation="required:alt=Required"><option value="">State</option></select></div></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><select class="form-control fake-required" id="helpticket_type" name="helpticket_type" ng-model="vm.ticket.title" validation="required"><option value="">Title</option><option ng-repeat="type in vm.titles" value="{{ type }}">{{ type }}</option></select></div></div><div class="row form-group"><div class="col-sm-7 col-xs-10"><textarea id="comments" name="comments" class="form-control resize-none" ng-model="vm.ticket.comments" placeholder="ADDITIONAL INTERESTS, COMMENTS, ETC" rows="6"></textarea></div></div></div><div class="form-group" ng-if="vm.sentSuccessfully"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-none"><hr><div class="text-uppercase margin-bottom">Thank you.</div>Your request for information has been sent to our performance management team.</div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.submittingInquiry" ng-disabled="vm.fieldsDisabled || inputForm.$invalid" ng-if="!vm.sentSuccessfully">SUBMIT</button> <button type="button" class="btn btn-default" ng-class="config.styleClass" ui-sref="marketing({ marketingArea: vm.marketingConfig.name })">CLOSE</button></div></form></div>');
$templateCache.put('app/areas/appointment/components/appt-list-date-picker/appt-list-date-picker.component.view.html','<div class="block relative text-uppercase"><div class="display-flex flex-column"><div class="display-flex flex-row content-center max-height-px-20 hidden-sm hidden-xs font-bold"><i class="material-icons md-24 theme-link" ng-class="{\'disabled\':vm.apptList.searchingAppointments}" ng-click="vm.apptList.prevDayClicked()">keyboard_arrow_left</i><div ng-if="vm.apptList.filters.searchDate" id="search-date2" class="inline align-top full-width" moment-picker="vm.apptList.calendarDate" start-view="month" format="YYYY-MM-DD" ng-model-options="{ debounce: 750 }" change="vm.apptList.dateChanged(newValue, oldValue)"><center><div class="inline-block margin-top-sm">{{ vm.apptList.filters.searchDate.toDate() | date:"EEE MM/dd"}}</div></center></div><i class="material-icons md-24 theme-link" ng-class="{\'disabled\':vm.apptList.searchingAppointments}" ng-click="vm.apptList.nextDayClicked()">keyboard_arrow_right</i></div><div class="display-flex flex-row content-center max-height-px-20 visible-sm visible-xs font-bold flex-percent-100"><i class="material-icons md-24 theme-link flex-percent-10 text-left" ng-class="{\'disabled\':vm.apptList.searchingAppointments}" ng-click="vm.apptList.prevDayClicked()">keyboard_arrow_left</i><div ng-if="vm.apptList.filters.searchDate" id="search-date2" class="inline align-top full-width" moment-picker="vm.apptList.calendarDate" start-view="month" format="YYYY-MM-DD" ng-model-options="{ debounce: 750 }" change="vm.apptList.dateChanged(newValue, oldValue)"><center><div class="inline-block margin-top-sm margin-bottom-md" ng-if="vm.apptList.filters.searchMode !== vm.apptList.searchModes.mobileGarage">{{ vm.apptList.filters.searchDate.toDate() | date:"EEEE MM/dd/yyyy"}}</div><div class="inline-block margin-top-sm margin-bottom-md" ng-if="vm.apptList.filters.searchMode === vm.apptList.searchModes.mobileGarage">{{ vm.apptList.filters.searchDate.toDate() | date:"EEE MM/dd"}}</div></center></div><i class="material-icons md-24 theme-link flex-percent-10 text-right" ng-class="{\'disabled\':vm.apptList.searchingAppointments}" ng-click="vm.apptList.nextDayClicked()">keyboard_arrow_right</i></div><div class="display-flex flex-row content-center max-height-px-20 font-bold" ng-if="vm.apptList.isSearchToday() === false"><div class="min-width-px-24">&nbsp;</div><div class="inline align-top full-width"><center><button type="button" class="btn btn-white font-size-10 line-height-10 padding-sm margin-right-xs" ng-class="config.styleClass" ng-click="vm.apptList.todayClicked()">TODAY</button></center></div><div class="min-width-px-24">&nbsp;</div></div></div></div>');
$templateCache.put('app/areas/appointment/components/drag-drop-icon-only/drag-drop-icon-only.component.view.html','<div ng-if="!vm.supportsVideoCapture" ngf-select="" ngf-drop="" ng-model="vm.file" ngf-model-invalid="invalidFiles" ngf-model-options="vm.options" ngf-multiple="multiple" ngf-pattern="\'{{vm.pattern}}\'" ngf-accept="\'{{vm.pattern}}\'" ng-disabled="{{vm.buttonDisabled}}" ngf-capture="capture" ngf-drag-over-class="{accept:\'highlight\', reject:\'highlight-err\', pattern:\'{{vm.pattern}}\'}" ngf-validate="validateObj" ngf-resize="resizeObj" ngf-validate-after-resize="false" ngf-resize-if="resizeIfFn($file, $width, $height)" ngf-dimensions="dimensionsFn($file, $width, $height)" ngf-duration="durationFn($file, $duration)" ngf-keep="keepDistinct ? \'distinct\' : keep" ngf-fix-orientation="orientation" ngf-max-files="maxFiles" ngf-use-icon="useIcon" ngf-ignore-invalid="ignoreInvalid" ngf-run-all-validations="runAllValidations" ngf-allow-dir="allowDir" class="icon-only-image-container position-relative" ngf-change="vm.upload($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)" ngf-drop-available="dropAvailable"><div><div class="dragdrop-spinner-overlay" ng-if="vm.isLoading"><div class="spinner margin-bottom-md"></div></div></div><div class="text"><i ng-if="vm.useIcon" class="fa font-size-18 fa-camera"></i></div><input name="{{vm.name}}" ng-model="vm.ngModel.fileData" ng-required="vm.ngRequired" type="hidden" id="{{vm.id}}"></div><div ng-if="vm.supportsVideoCapture" ng-click="vm.launchCamera()" class="text"><i class="fa font-size-18 fa-camera"></i></div><div class="text-danger" ng-if="vm.ngModel.errorMessage">{{vm.ngModel.errorMessage}}</div>');
$templateCache.put('app/areas/appointment/components/summaries/appointment-summary.component.view.html','<div id="appoinment-summary-content" class="appointments-wizard"><div id="print-to-pdf" class="print-to-pdf"><div ng-if="vm.appointment.dmsOutOfSync === true" class="row inline-error-box text-uppercase margin-bottom-30"><div class="col-sm-10 col-xs-12"><div ng-if="!vm.appointment.dmsSyncError">AN ERROR OCCURRED PREVENTING UPDATES FROM BEING PUSHED TO THE DMS. YOU CAN ATTEMPT TO FIX BY EDITING THE APPOINTMENT AND CLICKING THROUGH THE SCREENS. IF THIS ISSUE PERSISTS, PLEASE CONTACT THE CLIENT SUCCESS TEAM.</div><div ng-if="vm.appointment.dmsSyncError" ng-bind-html="vm.appointment.dmsSyncError"></div><div ng-if="vm.appointment.dmsSyncError" class="margin-top">YOU CAN ATTEMPT TO FIX BY EDITING THE APPOINTMENT AND CLICKING THROUGH THE SCREENS OR CLICKING THE RESUBMIT BUTTON. IF THIS ISSUE PERSISTS, PLEASE CONTACT THE CLIENT SUCCESS TEAM.</div></div><div class="col-xs-12 col-sm-2"><button type="button" class="btn btn-primary margin-top-sm" ng-class="config.styleClass" ng-click="vm.resubmit()" ladda="vm.parent.nextBusy">RESUBUMIT</button></div></div><appointment-service-center-title ng-model="vm.appointment"></appointment-service-center-title><h4 id="customer-details" class="panel-title margin-top padding-bottom-none"><div class="hidden-xs black margin-bottom-sm">CUSTOMER DETAILS</div><div class="visible-xs padding-bottom-xs black margin-bottom-sm">CUSTOMER DETAILS</div><div class="appt-summary margin-bottom border-top text-uppercase"><div class="row"><div class="col-xs-12"><div class="margin-bottom margin-top text-danger" ng-if="::vm.isDraftAppointment()">Note, this is a DRAFT appointment. Click Edit below to complete booking.</div><div class="margin-top text-uppercase"><strong><span>{{vm.appointment.customerFirstName}} {{vm.appointment.customerLastName}}</span></strong></div><div class="text-uppercase" ng-if="vm.appointment.customerEmail">{{vm.appointment.customerEmail}}</div><div ng-if="vm.appointment.customerPhone">{{vm.appointment.customerPhone|tel}}</div><div class="margin-top"><div class="text-uppercase"><strong>{{vm.appointment.year}} {{vm.getDisplayMake(vm.appointment)}} {{vm.getDisplayModel(vm.appointment)}}</strong></div>VIN:<div class="inline" ng-if="vm.appointment.vin">{{vm.appointment.vin}}</div><div class="inline" ng-if="!vm.appointment.vin">N/A</div><div ng-if="vm.appointment.mileage">{{vm.appointment.mileage| number : fractionSize}} {{ vm.appointment.mileageType.abbreviation }}</div><div ng-if="!vm.appointment.mileage">ODOMETER: N/A</div></div></div></div><div class="row" ng-if="vm.appointment.createdByIdentityUserFirstName || vm.appointment.createdByIdentityUserLastName || vm.appointment.bookingSource"><div class="col-sm-8"><div class="margin-top margin-bottom text-uppercase"><strong>BOOKED BY</strong><br><span ng-if="(vm.appointment.createdByIdentityUserFirstName != \'\' && vm.appointment.createdByIdentityUserLastName != \'\')">{{vm.appointment.createdByIdentityUserFirstName }} {{ vm.appointment.createdByIdentityUserLastName}}</span> <span ng-if="(!vm.appointment.createdByIdentityUserFirstName || !vm.appointment.createdByIdentityUserLastName)">{{vm.appointment.bookingSourceDescription }}</span></div></div></div></div></h4><h4 class="panel-title margin-top padding-bottom-none"><div class="black margin-bottom-sm">APPOINTMENT DETAILS</div></h4><div class="appt-summary margin-bottom border-top"><div class="row margin-top"><div class="col-sm-4 col-xs-12 text-uppercase margin-bottom-sm padding-right-none"><div class="margin-bottom" ng-if="vm.pickupDropoff === vm.transTypeGroups.pickup"><strong>SERVICE PICKUP</strong> <a class="theme-link" ng-click="$dismiss()" ui-sref="trip-tab-trip({ tripId: {{::vm.appointment.tripId}}})" ng-if="vm.appointment.tripId">#{{ vm.appointment.tripId }}</a><br><span>{{vm.appointment.tripPickupTimeDisplay}}</span></div><div class="margin-bottom" ng-if="vm.pickupDropoff === vm.transTypeGroups.mobile"><strong>MOBILE SERVICE</strong> <a class="theme-link" ng-click="$dismiss()" ui-sref="trip-tab-trip({ tripId: {{::vm.appointment.tripId}}})" ng-if="vm.appointment.tripId">#{{ vm.appointment.tripId }}</a><br><span>{{vm.appointment.tripPickupTimeDisplay}}</span></div><div ng-if="vm.pickupDropoff === vm.transTypeGroups.dropoff"><strong>CUSTOMER DROPOFF</strong></div><div class="margin-bottom" ng-if="vm.pickupLocation.formattedLocation && vm.pickupDropoff !== vm.transTypeGroups.dropoff">{{ vm.pickupLocation.formattedLocation }}</div><div class="margin-bottom" ng-if="!vm.pickupLocation.formattedLocation && vm.appointment.tripPickupLocation && vm.pickupDropoff !== vm.transTypeGroups.dropoff">{{ vm.appointment.tripPickupLocation.streetAddress }}, {{ vm.appointment.tripPickupLocation.city }}, {{ vm.appointment.tripPickupLocation.state }} {{ vm.appointment.tripPickupLocation.zip }}</div><div id="appt-summary-datetime">{{ vm.appointment.apptDateTime | date:\'MMM dd, yyyy At h:mm a\' }}</div><div id="appt-summary-promise-datetime" ng-if="vm.appointment.promiseDateTime">EST COMP: {{ vm.appointment.promiseDateTime | date:\'MMM dd, yyyy At h:mm a\' }}</div><div>ADVISOR: <span ng-if="vm.isAdvisorUnmapped()">UNMAPPED USER</span> <span ng-if="!vm.isAdvisorUnmapped() && !vm.appointment.dealerEmployeeFirstName">NOT ASSIGNED</span> <span ng-if="vm.appointment.dealerEmployeeFirstName">{{ ::vm.appointment.dealerEmployeeFirstName }} {{ ::vm.appointment.dealerEmployeeLastName }}</span></div><div ng-if="vm.appointment.departmentId">DEPT: {{ vm.locationDepartment.name }}</div><div ng-if="vm.showAppointmentStatus()">STATUS: <b>{{ vm.getApptStatusLabel() }}</b></div><div ng-if="vm.appointment.statusLastChanged">UPDATED: {{vm.appointment.statusLastChanged | date:\'MM/dd\' }} at {{ vm.appointment.statusLastChanged | date:\'h:mm a\' }}</div><div ng-if="(vm.getApptStatusLabel().toUpperCase() === \'CANCELED\')" class="text-uppercase"><strong>BY {{ vm.appointment.cancellationIdentityUserFirstName }} {{ vm.appointment.cancellationIdentityUserLastName }}</strong></div><div class="ellipsis-overflow" ng-if="vm.appointment.dealerDMSSystem !== vm.dmsProviderTypes.None">DMS APPT ID: <span title="{{ vm.removePipedData(vm.appointment.apptId) }}" ng-if="!vm.appointment.dmsApptNumber && (vm.apptIdIsValid(vm.appointment.apptId) || vm.appointment.dealerDMSSystem === vm.dmsProviderTypes.Tekion)">{{ vm.removePipedData(vm.appointment.apptId) }}</span> <span title="{{ vm.appointment.dmsApptNumber }}" ng-if="vm.appointment.dmsApptNumber">{{ vm.appointment.dmsApptNumber }}</span> <span ng-if="!vm.apptIdIsValid(vm.appointment.apptId) && vm.appointment.dealerDMSSystem !== vm.dmsProviderTypes.Tekion">PENDING</span></div><div class="margin-top" ng-if="vm.pickupDropoff !== vm.transTypeGroups.mobile"><strong>TRANSPORTATION</strong></div><div ng-if="vm.transportationType && !vm.isHideRideShareCreditTransportationType() && vm.pickupDropoff !== vm.transTypeGroups.mobile">{{ vm.transportationType.dashboardDescription.replace(\'Loaner Requested\', \'Loaner\') }} <a class="theme-link" ui-sref="loaner-reservation-edit({\'reservationId\': vm.appointment.loanerContractId, \'locationId\': vm.appointment.location.id})" ng-if="vm.appointment.loanerConfirmationNumber">#{{ vm.appointment.loanerConfirmationNumber }}</a> <a ng-if="vm.transportationType.isShuttle && vm.appointment.tripId" class="theme-link" ng-click="$dismiss()" ui-sref="trip-tab-trip({ tripId: {{::vm.appointment.tripId}}})">#{{ vm.appointment.tripId }}</a></div><div ng-if="vm.credit" ng-class="{\'margin-top\': !vm.isHideRideShareCreditTransportationType()}">{{vm.getRideShareCreditsDescription()}} {{ vm.credit.creditAmount/100 | currency }}<br>{{ vm.credit.startTime | localDate:\'MMM D YYYY\' }} - {{ vm.credit.endTime | localDate:\'MMM D YYYY\' }}</div></div><div class="col-sm-8 col-xs-12 margin-top no-print"><div class="visible-xs border-bottom-xs padding-bottom-xs margin-bottom"><i ng-if="!vm.mobileMapVisible" class="material-icons md-24 pull-right appt-summarymap-toggle cursor-pointer no-print" ng-click="vm.mobileMapVisible = !vm.mobileMapVisible">expand_more</i> <i ng-if="vm.mobileMapVisible" class="material-icons md-24 pull-right appt-summarymap-toggle cursor-pointer no-print" ng-click="vm.mobileMapVisible = !vm.mobileMapVisible">expand_less</i></div><div id="summary-map-holder" ng-show="vm.mobileMapVisible" class="ng-hide" map-resize=""><div driver-tracking="" id="summary-map-holder-map" options="vm.summaryMapOptions" map-loaded="vm.onSummaryMapLoaded" dealer="vm.dealer"></div></div><div ng-show="!vm.mobileMapVisible" class="ng-hide theme-link" ng-click="vm.mobileMapVisible = !vm.mobileMapVisible"><center>SHOW MAP</center></div></div></div><div ng-if="vm.pickupDropoff !== vm.transTypeGroups.dropoff" class="row margin-top text-uppercase padding-bottom"><div ng-if="vm.pickupDropoff !== vm.transTypeGroups.dropoff" class="col-sm-1 col-xs-2"><img class="profile-photo" afkl-lazy-image-options="{ background: true}" ng-src="{{vm.appointment.tripDriver.driverPhoto || \'assets/images/user-square.png\'}}"></div><div class="col-sm-4 col-xs-8 ng-hide" ng-show="!vm.savingDriver"><strong ng-if="vm.pickupDropoff === vm.transTypeGroups.pickup">Your Driver</strong> <strong ng-if="vm.pickupDropoff === vm.transTypeGroups.mobile">Your Mobile Tech</strong><div ng-if="!vm.canEditDriver() && !vm.appointment.tripDriver.id">Unassigned</div><div ng-if="vm.canEditDriver() && !vm.appointment.tripDriver.id" class="theme-link" ng-show="!vm.changeDriver" ng-hide="vm.changeDriver == true" ng-click="vm.changeDriverClick()">Unassigned</div><div ng-if="vm.appointment.tripDriver.id && vm.canEditDriver() && vm.appointment.tripDriver.name" ng-show="!vm.changeDriver" ng-hide="vm.changeDriver == true" class="theme-link" ng-click="vm.changeDriverClick()"><div>{{ vm.appointment.tripDriver.name }}</div></div><div ng-if="vm.appointment.tripDriver.id && !vm.canEditDriver() && vm.appointment.tripDriver.name"><div>{{ vm.appointment.tripDriver.name }}</div></div><div class="ng-hide" ng-show="vm.changeDriver == true && vm.activeDrivers && !vm.savingDriver"><select id="assigned_driver" name="assigned_driver" class="form-control has-label" ng-model-options="{ debounce: 750 }" allow-null-option="Best available" ng-change="vm.driverSelectionModified(vm.appointment.tripDriver.id, vm.originalDriver)" ng-init="vm.originalDriver=vm.appointment.tripDriver.id" ng-model="vm.appointment.tripDriver" ng-options="driver as vm.formatDriverDropDown(driver, vm.appointment.tripDriver) disable when driver.id == -999 for driver in vm.activeDrivers track by driver.id"></select></div></div><div class="col-xs-8 ng-hide no-print" ng-show="vm.savingDriver"><img src="assets/images/ajax-loader.gif"> Updating...</div></div></div><div id="summary-services" class="row margin-top-lg"><div class="col-sm- 12 col-xs-12"><h4 class="panel-title black margin-bottom-sm padding-bottom-none">SERVICES</h4><div class="border-bottom padding-bottom-xs margin-bottom"><i ng-if="!vm.servicesVisible" class="material-icons md-24 pull-right appt-summarymap-toggle services-toggle no-print" ng-click="vm.servicesVisible = !vm.servicesVisible">expand_more</i> <i ng-if="vm.servicesVisible" class="material-icons md-24 pull-right appt-summarymap-toggle services-toggle no-print" ng-click="vm.servicesVisible = !vm.servicesVisible">expand_less</i></div><ul id="appt-summary-services-holder" ng-show="vm.servicesVisible" class="ng-hide"><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isRecall: true } as results track by lineItem.manufacturerNumber"><div class="text-uppercase bold">Recall - #{{lineItem.manufacturerNumber}} {{ lineItem.recallDisplayName}}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isRecommendedMaintenance: true }"><div class="text-uppercase bold">{{ lineItem.overrideName}}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isGeneric: false, isRecall: false, isRecommendedMaintenance: false, isOther: false, isAutomatic: false }"><div class="text-uppercase bold">{{lineItem.opCode}} - {{ lineItem.dashboardName || lineItem.opCodeDescription || lineItem.dealerAppointmentServiceOpCode.name}}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div><div ng-if="lineItem.dashboardDescription">{{ lineItem.dashboardDescription }}</div><div class="margin-top-md"><b>NOTE</b></div><div ng-if="lineItem.note">{{lineItem.note}}</div><div ng-if="!lineItem.note">NO COMMENTS</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isGeneric: true }"><div class="text-uppercase bold">{{\'CONSUMER SERVICE NEEDS \' + (lineItem.genericName ? \'- \' + lineItem.genericName : \'\') }}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div><b>NOTE</b></div><div ng-if="lineItem.note">{{lineItem.note}}</div><div ng-if="!lineItem.note">NO COMMENTS</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isOther: true, checked: true }"><div class="text-uppercase bold">{{lineItem.opCode}} - {{ lineItem.overrideName || lineItem.opCodeDescription }}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div><div ng-if="vm.getDisplayLineItemDescription(lineItem)">{{ vm.getDisplayLineItemDescription(lineItem) }}</div><div class="margin-top-md"><b>NOTE</b></div><div ng-if="lineItem.note">{{lineItem.note}}</div><div ng-if="!lineItem.note">NO COMMENTS</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isAutomatic: true }"><div class="text-uppercase bold">{{ lineItem.opCode }} - {{ lineItem.opCodeDescription || lineItem.note}}</div></li></ul></div></div></div></div>');
$templateCache.put('app/areas/appointment/components/summaries/appointment-transportation-summary.component.view.html','<div class="row border-bottom margin-top"><div class="col-sm-11 col-xs-10"><h3 class="font-size-14 font-bold"><div class="black"><strong>TRANSPORTATION</strong></div></h3></div></div><div class="row margin-top-sm"><div class="col-sm-11 col-xs-10 margin-bottom"><div id="appoinment-transportation-summary-content" class="appt-semi-bold"><div ng-if="vm.transportationType.isPickup === true">Service Pick Up #{{vm.appointment.tripId}}<div ng-if="vm.transportationType.hasLoaner === true && vm.appointment.loanerConfirmationNumber">Loaner <span ng-if="vm.appointment.loanerConfirmationNumber">&nbsp;#{{vm.appointment.loanerConfirmationNumber}}</span></div></div><div ng-if="vm.transportationType.isPickup === false">Customer Drop Off<div ng-if="vm.transportationType.dealerSystemTransportationTypeId === vm.apptTransportationTypes.dropOff">Customer Has Own Transportation</div><div ng-if="vm.transportationType.dealerSystemTransportationTypeId === vm.apptTransportationTypes.waiter">Customer Will Wait</div><div ng-if="vm.transportationType.dealerSystemTransportationTypeId === vm.apptTransportationTypes.dropOffLoaner">Customer is getting a loaner <span ng-if="vm.appointment.loanerConfirmationNumber">&nbsp;#{{vm.appointment.loanerConfirmationNumber}}</span></div><div ng-if="vm.transportationType.dealerSystemTransportationTypeId === vm.apptTransportationTypes.shuttle"><div>Shuttle <span ng-if="vm.pendingRideDetail.pendingBookLaterPhone">Invitation</span><span ng-if="!vm.appointment.tripId && !vm.pendingRideDetail.pendingBookLaterPhone">(Pending check-in completion)</span><span ng-if="vm.appointment.tripId">#{{vm.appointment.tripId}}</span></div><div ng-if="vm.pendingRideDetail && vm.pendingRideDetail.pendingRideDetail != null"><div ng-if="vm.pendingRideDetail.pendingRideDetail.dropoff.formattedAddress">To: {{vm.pendingRideDetail.pendingRideDetail.dropoff.formattedAddress}}</div></div></div></div><div class="margin-top" ng-if="vm.pendingRideDetail && vm.pendingRideDetail.pendingCreditDetail">{{vm.getRideShareCreditsDescription()}} {{ (vm.pendingRideDetail.pendingCreditDetail.creditAmount/100) | currency}} (Pending)<br>{{ vm.pendingRideDetail.pendingCreditDetail.startTime | localDate:\'MMM D YYYY\' }} - {{ vm.pendingRideDetail.pendingCreditDetail.endTime | localDate:\'MMM D YYYY\' }}<br></div></div></div></div>');
$templateCache.put('app/areas/appointment/components/summaries/checkin-summary.component.view.html','<div ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"> <strong>Loading</strong></div><div ng-if="!vm.isLoading"><div ng-if="!vm.hasPendingServices" class="text-center row margin-top"><i class="text-success material-icons authorization-success-checkbox">check_circle</i></div><div class="margin-top">Authorization {{vm.hasPendingServices ? \'In Progress\' : \'Complete\' }}! We will keep you informed of any updates. Please contact us if you have any questions. Thank you for servicing your vehicle with us!</div><div ng-if="vm.isLoading" class="margin-top display-flex content-center"><img src="assets/images/ajax-loader.gif" class="margin-right"> <strong>Loading</strong></div><div ng-if="!vm.isLoading"><div class="margin-top-30"><repair-order-vehicle-details-issues repair-order="vm.repairOrder"></repair-order-vehicle-details-issues></div><div ng-if="vm.hasApprovedServices" class="margin-top-lg margin-bottom-lg"><h3 class="font-size-14 text-uppercase border-bottom padding-bottom-md"><div class="black">Your Approved Services</div></h3><authorize-pending-lineitem ng-repeat="service in vm.services | filter: vm.approvedServicesFilter" ng-model="service" is-dashboard="true" read-only="true"></authorize-pending-lineitem></div><div ng-if="vm.hasPendingServices" class="margin-top-lg margin-bottom-lg"><h3 class="font-size-14 text-uppercase border-bottom padding-bottom-md"><div class="black">Services Pending Customer Authorization</div></h3><authorize-pending-lineitem ng-repeat="service in vm.services | filter: vm.openServicesFilter" ng-model="service" is-dashboard="true" read-only="true"></authorize-pending-lineitem></div><div class="margin-bottom"><authorization-history-list dealer-id="vm.repairOrder.dealerId" repair-order="vm.repairOrder" ng-click="vm.close()"></authorization-history-list></div></div></div>');
$templateCache.put('app/areas/appointment/views/partials/appointment-booking-summary.view.html','');
$templateCache.put('app/areas/appointment/views/partials/appointment-choose-location.view.html','<uib-accordion-heading ng-if="vmLocPnl.availableLocations && vmLocPnl.availableLocations.length > 0"><div class="display-flex flex-row full-width-height"><div class="flex-grow"><h4 class="panel-title location-title display-flex flex-row content-center"><div class="flex-grow algn-bottom"><span class="hidden-xs hidden-sm">SERVICE CENTER LOCATION</span> <span class="visible-xs visible-sm ng-hide padding-bottom-xs" ng-show="vm.accordion.selectedStep === vm.accordion.steps.chooseLocation || vm.accordion.selectedStep === vm.accordion.steps.summary">SERVICE CENTER LOCATION</span> <span class="ng-hide inline-block ellipsis-overflow max-width-px-300 text-uppercase visible-sm visible-xs" ng-show="vm.appointment.location && vm.accordion.selectedStep !== vm.accordion.steps.summary">{{vm.appointment.location.name}}</span></div><div class="flex-grow flex-percent-50 flex-sm-percent-25 content-center align-text-bottom"><div class="selected-accordion-location"><span class="ng-hide inline-block ellipsis-overflow max-width-px-300 padding-right-sm align-text-bottom text-uppercase hidden-sm hidden-xs" ng-show="vm.appointment.location && vm.accordion.selectedStep !== vm.accordion.steps.summary">{{vm.appointment.location.name}}</span><div class="ng-hide link pull-right content-center" ng-show="!vm.resolvedAppointmentId && !vm.appointment.appointmentId && vm.appointment.location && !vm.isLoading()" ng-click="vmLocPnl.clearSelectedLocation()"><i class="material-icons md-16">edit</i></div></div></div></h4><div class="ng-hide appt-summary border-top" ng-show="vm.accordion.selectedStep === vm.accordion.steps.summary"><div class="row"><div class="col-xs-12"><div class="margin-top text-uppercase"><strong>{{vm.appointment.location.name}}</strong></div></div></div></div></div></div></uib-accordion-heading><div ng-if="vm.accordion.selectedStep === vm.accordion.steps.chooseLocation"><div id="chooseLocationForm" class="wizard-dropdown"><div class="row" ng-if="vmLocPnl.availableLocations.length > vmLocPnl.locationSearchThreshold"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><select ng-if="vmLocPnl.availableLocations && vmLocPnl.availableLocations.length > 0" data-placeholder-text-single="\'Find a location\'" class="form-control" name="locationFilter" chosen="{width: \'100%\'}" max-shown-results="100" ng-model="vmLocPnl.selectedLocation" ng-options="l as l.name for l in vmLocPnl.availableLocations" ng-change="vmLocPnl.locationSelected()"><option value=""></option></select><div ng-if="!vmLocPnl.availableLocations || vmLocPnl.availableLocations.length === 0"><h4>NOT AVAILABLE</h4>Your location(s) are not configured for Appointments.</div></div></div></div><div ng-if="vmLocPnl.availableLocations.length <= vmLocPnl.locationSearchThreshold"><div class="row margin-top-md"><div class="col-xs-11 padding-none"><table id="zip-filtered-locations"><tr ng-repeat="location in vmLocPnl.availableLocations" ng-class="{\'border-bottom\': $index < vmPnl.zipFilteredLocationList.length - 1 }"><td class="padding-md loc-icon" ng-click="vmLocPnl.locationClicked(location)"></td><td class="padding-md loc-details" ng-click="vmLocPnl.locationClicked(location)"><div class="theme-link"><strong>{{location.name}}</strong></div><div>{{location.address}}, {{location.city}}, {{location.zip}}</div></td></tr></table></div></div></div></div></div>');
$templateCache.put('app/areas/appointment/views/partials/appointment-customer-vehicle.view.html','<uib-accordion-heading ng-if="!vm.roHistoryPanelOpen"><h4 class="panel-title display-flex flex-row content-center"><div class="flex-grow algn-bottom">CUSTOMER DETAILS</div><div class="flex-grow flex-percent-50 flex-sm-percent-25 content-center align-text-bottom"><div class="selected-accordion-location"><span class="ng-hide text-uppercase inline-block ellipsis-overflow max-width-px-300" ng-show="vm.accordion.selectedStep > vm.accordion.steps.customerVehicle && vm.accordion.selectedStep !== vm.accordion.steps.summary"><span>{{vm.appointment.customerFirstName}} {{vm.appointment.customerLastName}}</span> {{vm.appointment.year}} <span ng-if="vmCustomerPnl.selectedMake">{{vmCustomerPnl.selectedMake.make}}</span> <span ng-if="!vmCustomerPnl.selectedMake">{{vm.appointment.make}}</span> <span ng-if="vmCustomerPnl.selectedModel">{{vmCustomerPnl.selectedModel.model}}</span> <span ng-if="!vmCustomerPnl.selectedModel">{{vm.appointment.model}}</span></span><div class="ng-hide link pull-right content-center" ng-show="!vm.resolvedAppointmentId && vm.accordion.selectedStep > vm.accordion.steps.customerVehicle" ng-click="vmCustomerPnl.returnToCustomerStep()" "=""><i class="material-icons md-16">edit</i></div></div></div></h4><div class="ng-hide appt-summary margin-bottom border-top text-uppercase" ng-show="vm.accordion.selectedStep === vm.accordion.steps.summary"><div class="row"><div class="col-xs-12"><div class="margin-bottom margin-top text-danger" ng-if="vm.isDraftAppointment() && vm.showEditBtn()">Note, this is a DRAFT appointment. Click Edit below to complete booking.</div><div class="margin-top text-uppercase"><strong><span>{{vm.appointment.customerFirstName}} {{vm.appointment.customerLastName}}</span></strong></div><div class="text-uppercase" ng-if="vm.appointment.customerEmail">{{vm.appointment.customerEmail}}</div><div ng-if="vm.appointment.customerPhone">{{vm.appointment.customerPhone|tel}}</div><div class="margin-top"><div class="text-uppercase"><strong>{{vm.appointment.year}} <span ng-if="vmCustomerPnl.selectedMake">{{vmCustomerPnl.selectedMake.make}}</span> <span ng-if="!vmCustomerPnl.selectedMake">{{vm.appointment.make}}</span> <span ng-if="vmCustomerPnl.selectedModel">{{vmCustomerPnl.selectedModel.model}}</span> <span ng-if="!vmCustomerPnl.selectedModel">{{vm.appointment.model}}</span></strong></div>VIN:<div class="inline" ng-if="vm.appointment.vin">{{vm.appointment.vin}}</div><div class="inline" ng-if="!vm.appointment.vin">N/A</div><div ng-if="vm.appointment.mileage">{{vm.appointment.mileage| number : fractionSize}} {{ vm.appointment.mileageType.abbreviation }}</div><div ng-if="!vm.appointment.mileage">ODOMETER: N/A</div></div><div class="margin-top" ng-if="vm.currentVehicle.notes">NOTES: {{vm.appointment.notes }}</div></div></div><div class="row" ng-if="vm.appointment.createdByIdentityUserFirstName || vm.appointment.createdByIdentityUserLastName || vm.appointment.bookingSource"><div class="col-sm-8"><div class="margin-top margin-bottom text-uppercase"><strong>BOOKED BY</strong><br><span ng-if="(vm.appointment.createdByIdentityUserFirstName != \'\' && vm.appointment.createdByIdentityUserLastName != \'\')">{{vm.appointment.createdByIdentityUserFirstName }} {{ vm.appointment.createdByIdentityUserLastName}}</span> <span ng-if="(!vm.appointment.createdByIdentityUserFirstName || !vm.appointment.createdByIdentityUserLastName)">{{vm.appointment.bookingSourceDescription }}</span></div></div></div></div></uib-accordion-heading><div ng-if="vm.accordion.selectedStep === vm.accordion.steps.customerVehicle"><div class="text-danger" ng-if="vm.dealerDepartments.length === 0">Please configure departments for this dealer.</div><div ng-if="vm.dealerOpCodes.length === 0 && !vm.loadingOpCodes" class="text-danger">Error: The op codes for this dealer have not been mapped.</div><div ng-if="vm.dealerDepartments.length > 0 && vm.dealerOpCodes.length > 0" id="apptChooseCustomerForm" class="wizard-dropdown"><div class="row"><div class="col-sm-6 col-xs-12 padding-left-none"><div class="form-group customer-search"><div id="appointment-typeahead" class="position-relative" ng-if="!vm.customer"><typeahead-tagged-input selected-items="vmCustomerPnl.customerTypeAheadSelectedItems" search-query="vmCustomerPnl.customerTypeAheadSearchQuery" is-focused="vmCustomerPnl.isCustomerTypeAheadFocused" is-searching="vmCustomerPnl.searchingCustomers" placeholder="{{(vmCustomerPnl.customerTypeAheadSelectedItems && vmCustomerPnl.customerTypeAheadSelectedItems.length) ? \'\' : \'Search by phone, name, or VIN\'}}" min-length="3" key-property="id" display-property="selectedLabel" autocomplete-display-property="name" is-disabled="vm.customer" suggestions="vmCustomerPnl.customerTypeAheadSuggestions" on-register="vmCustomerPnl.registerCustomerTypeAhead(ctrl)" no-results-count="vmCustomerPnl.availableCustomers.length" no-results-message="No results found for" no-results-sub-message="{{vmCustomerPnl.isAutoSoft ? \'Please use the customer\\\'s full name.\' : \'\'}}" min-length-action-text="Create a New Record." on-min-length-action="vmCustomerPnl.forceAddCustomer()" should-ignore-suggestion="vmCustomerPnl.isCreateNewSuggestion(suggestion)" on-empty-focus="vmCustomerPnl.resetCustomerTypeAheadOnEmptyFocus()" on-search="vmCustomerPnl.refreshCustomers($query)" on-selected="vmCustomerPnl.customerTypeAheadSelected($tag)" on-removed="vmCustomerPnl.customerTypeAheadRemoved()"></typeahead-tagged-input><span class="input-append-icon z-index-30" ng-if="!vmCustomerPnl.searchingCustomers"><button type="button" class="btn btn-text-only padding-right-none padding-top-none" ng-click="vmCustomerPnl.openVinScan()" title="Scan VIN"><i class="material-symbols-outlined">barcode_scanner</i></button></span> <img src="assets/images/ajax-loader.gif" class="ng-hide input-append-icon z-index-30" ng-show="vmCustomerPnl.searchingCustomers"></div><div ng-if="vm.customer" class="position-relative"><input type="text" class="form-control better-placeholder text-notransform" disabled="" ng-value="(vm.selectedCustomer && vm.selectedCustomer.customerId === -998) ? \'CREATE A NEW RECORD\' : ((vm.appointment.customerIsBusiness ? (vm.appointment.customerLastName || \'\') : ((vm.appointment.customerFirstName || \'\') + (vm.appointment.customerFirstName && vm.appointment.customerLastName ? \' \' : \'\') + (vm.appointment.customerLastName || \'\'))) | uppercase)"></div><div class="ng-hide clear-customer" ng-if="!vm.resolvedAppointmentId" ng-show="vm.addingCustomer || vm.customer && !vm.isLoading()" ng-click="vmCustomerPnl.clearSelectedCustomer()"><i class="material-icons">highlight_off</i></div></div></div><div id="appts-business-checkbox" class="col-sm-6 col-xs-12 padding-left-none text-nowrap text-right" ng-if="vm.customer || vm.addingCustomer"><div class="col-xs-6 padding-left-none text-nowrap text-right"><input type="checkbox" class="checkbox" ng-model="vm.appointment.customerIsBusiness" ng-change="vmCustomerPnl.isBusinessUpdated()" value="true" id="isBusiness"> <span id="businessLabel">This is a business</span></div></div></div><div ng-if="vmCustomerPnl.loadingCustomer"><div class="form-group"><div class="row"><div class="col-xs-12"><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading ...</div></div></div></div></div></div><div ng-if="!vmCustomerPnl.loadingCustomer && ((vm.addingCustomer || vm.customer || vm.appointment.id) && parent_vm.accordion.selectedStep === customerVehicle)" class="validation-relative"><div class="form-group"><div class="row"><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none" ng-if="vm.appointment.customerType === vm.customerType.individual || vmCustomerPnl.customerNameRequired()"><input type="text" id="first_name" name="first_name" maxlength="{{vmCustomerPnl.getCustomerFirstNameMaxLength()}}" autocomplete="nope" required="" ng-model="vm.appointment.customerFirstName" class="form-control better-placeholder" clean="true" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}" validation="required:alt={{vm.fieldIsReqTxt}}|custom:vmCustomerPnl.validation.combinedCustomerNameLength():alt=*"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none" ng-if="vm.appointment.customerType !== vm.customerType.individual && !vmCustomerPnl.customerNameRequired()"><input type="text" id="first_name" name="first_name" maxlength="{{vmCustomerPnl.getCustomerFirstNameMaxLength()}}" autocomplete="nope" ng-model="vm.appointment.customerFirstName" validation="custom:vmCustomerPnl.validation.combinedCustomerNameLength():alt=*" class="form-control better-placeholder" clean="true" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none"><input type="text" id="last_name" name="last_name" autocomplete="nope" required="" maxlength="{{vmCustomerPnl.getCustomerLastNameMaxLength()}}" clear="true" ng-model="vm.appointment.customerLastName" class="form-control better-placeholder" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'LAST NAME\' : \'BUSINESS NAME\'}}" validation="min_len:2|max_len:50|required:alt={{vm.fieldIsReqTxt}}|custom:vmCustomerPnl.validation.combinedCustomerNameLength():alt=*"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none override-sm-padding-top"><div class="block relative"><input type="email" id="email" name="email" clean="true" autocomplete="nope" required="" ng-model="vm.appointment.customerEmail" class="form-control better-placeholder" ng-blur="vmCustomerPnl.emailUpdated(vm.appointment.customerEmail)" ng-model-options="{ debounce: 750 }" ng-change="vmCustomerPnl.emailUpdated(vm.appointment.customerEmail)" ng-keydown="$event.keyCode != 32 ? $event:$event.preventDefault()" placeholder="EMAIL ADDRESS" validation="required:alt={{vm.fieldIsReqTxt}}|email"></div></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none override-sm-padding-top"><div class="block relative"><input type="text" id="mobile_phone_number" name="mobile_phone_number" required="" inputmode="numeric" ng-model-options="{ debounce: 750 }" ng-blur="vmCustomerPnl.mobilePhoneUpdated(vm.appointment.customerPhone)" ng-change="vmCustomerPnl.mobilePhoneUpdated(vm.appointment.customerPhone)" autocomplete="nope" ng-model="vm.appointment.customerPhone" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="required"></div><span class="text-danger" ng-show="vm.appointment.customerPhone.length > 0 && vm.appointment.invalidPhone === true">Invalid phone number.</span> <span class="text-danger" ng-show="vm.customerPhoneType.type === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="vm.customerPhoneType.type === vm.phoneTypes.voip">Number is a VoIP</span></div></div></div><div class="row" ng-if="vmCustomerPnl.displayAddtionalFieldsLink()" ng-click="vmCustomerPnl.displayAdditionalFieldsClicked()"><div class="col-xs-12 text-right"><span id="additional-fields" class="link">Additional Fields <i ng-if="vmCustomerPnl.displayAdditionalFields" class="material-icons md-18 ng-scope">expand_less</i><i ng-if="!vmCustomerPnl.displayAdditionalFields" class="material-icons md-18 ng-scope">expand_more</i></span></div></div><div class="form-group" ng-if="vmCustomerPnl.displayAddressFields()" ng-class="{\'margin-bottom-30\': !vmCustomerPnl.displayCountyCountry() && !!vmCustomerPnl.displayLanguage()}"><div class="row"><div class="col-sm-4 col-xs-12 padding-left-none" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.customerAddress"><input type="text" id="customer_address" name="customer_address" maxlength="45" autocomplete="nope" validation="required" required="" ng-model="vm.appointment.customerAddress1" class="better-placeholder form-control" clean="true" placeholder="STREET ADDRESS"></div><div class="col-sm-4 col-xs-12 padding-left-none" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.customerCity"><input type="text" id="customer_city" name="customer_city" maxlength="30" autocomplete="nope" validation="required" required="" ng-model="vm.appointment.customerCity" class="better-placeholder form-control" clean="true" placeholder="CITY"></div><div class="col-sm-2 col-xs-12 padding-left-none field-wrapper" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.customerState"><label for="customer_state">STATE</label><select class="form-control" id="customer_state" name="customer_state" selectlabel="" required="" validation="required" ng-model="vm.appointment.customerState" ng-options="item as item for item in vmCustomerPnl.usStates"><option value="" selected="selected" disabled="">State</option></select></div><div class="col-sm-2 col-xs-12 padding-left-none" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.customerZip"><input type="text" id="customer_zip" name="customer_zip" validation="required" required="" autocomplete="nope" ng-model="vm.appointment.customerZip" class="better-placeholder form-control" mask-restrict="reject" mask="99999" clean="true" placeholder="ZIP"></div></div></div><div class="form-group margin-bottom-30" ng-if="vmCustomerPnl.displayCountyCountry() || vmCustomerPnl.displayLanguage()"><div class="row"><div class="col-sm-4 col-xs-12 padding-left-none" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.customerCounty && vmCustomerPnl.displayCountyCountry()"><input type="text" id="customer_county" name="customer_county" ng-maxlength="30" validation="required" required="" autocomplete="nope" ng-model="vm.appointment.customerCounty" class="better-placeholder form-control" clean="true" placeholder="COUNTY"></div><div class="col-sm-4 col-xs-12 padding-left-none field-wrapper" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.customerCountry && vmCustomerPnl.displayCountyCountry()"><label for="customer_country">COUNTRY</label><select class="form-control" id="customer_country" name="customer_country" selectlabel="" required="" validation="required" ng-model="vm.appointment.customerCountryShortCode" ng-options="s.value as s.text for s in vmCustomerPnl.supportedCountries"><option value="" selected="selected" disabled="">Country</option></select></div><div class="col-sm-4 col-xs-12 padding-left-none field-wrapper" ng-if="vmCustomerPnl.parent_vm.dmsRequiredFields.language && vmCustomerPnl.displayLanguage()"><label for="customer_language">LANGUAGE</label><select class="form-control" id="customer_language" name="customer_language" selectlabel="" required="" validation="required" ng-model="vm.appointment.customerLanguage" ng-options="s.value as s.text for s in vmCustomerPnl.appointmentLanguages"><option value="" selected="selected" disabled="">Language</option></select></div></div></div><div class="form-group override-xs-margin-bottom-none" id="customer-vehicle-details"><div class="row margin-bottom-20 visible-xs border-bottom-xs padding-bottom-xs"><h4 class="panel-title">VEHICLE DETAILS</h4></div><div class="row"><div class="col-md-4 col-sm-6 col-xs-12 padding-left-none"><div id="appointment-vehicle-typeahead" class="position-relative" ng-if="!vm.currentVehicle" ng-mousedown="vmCustomerPnl.onVehicleTypeAheadFocus()"><typeahead-tagged-input selected-items="vmCustomerPnl.vehicleTypeAheadSelectedItems" search-query="vmCustomerPnl.vehicleTypeAheadSearchQuery" is-focused="vmCustomerPnl.isVehicleTypeAheadFocused" placeholder="Select or enter new vehicle" min-length="0" load-on-focus="true" load-on-empty="true" debounce-delay="250" is-disabled="vmCustomerPnl.loadingCustomer || vm.addingCustomer" show-dropdown-arrow="true" on-register="vmCustomerPnl.registerVehicleTypeAhead(ctrl)" on-search="vmCustomerPnl.refreshVehicleSuggestions($query)" on-selected="vmCustomerPnl.vehicleTypeAheadSelected($tag)" on-removed="vmCustomerPnl.vehicleTypeAheadRemoved()"></typeahead-tagged-input></div><div ng-if="vm.currentVehicle" class="position-relative"><input type="text" class="form-control better-placeholder text-uppercase text-notransform" disabled="" ng-value="vm.currentVehicle.vehicleId === -998 ? \'[NEW VEHICLE]\' : (((vm.currentVehicle.year || vm.appointment.year || \'\') + \' \' + (vm.currentVehicle.makeName || vm.currentVehicle.make || vm.appointment.make || \'\') + \' \' + (vm.currentVehicle.model || vm.appointment.model || \'\')) + ((vm.currentVehicle.vin || vm.appointment.vin) ? (\' (\' + (vm.currentVehicle.vin || vm.appointment.vin) + \')\') : \'\'))"></div><div class="ng-hide clear-customer" ng-show="vm.currentVehicle && !vm.addingCustomer" ng-click="vmCustomerPnl.clearSelectedVehicle(true)"><i class="material-icons">highlight_off</i></div></div><div class="col-md-4 col-sm-6 col-xs-12 padding-left-none text-notransform" ng-if="vm.addingCustomerVehicle || vm.currentVehicle"><input type="text" id="vin" name="vin" clean="true" maxlength="17" autocomplete="nope" ng-model="vm.appointment.vin" class="form-control ellipsis-overflow override-padding-right-25 better-placeholder" placeholder="VIN" ng-model-options="{ debounce: 1000 }" ng-change="vmCustomerPnl.checkValidVin()" validation="max_len:17|custom:vmCustomerPnl.validation.validVin(vm.appointment.vin):alt=*"> <span class="input-append-icon"><button type="button" class="btn btn-text-only padding-top-none" ng-click="vmCustomerPnl.openVinScan()" title="Scan VIN"><i class="material-symbols-outlined">barcode_scanner</i></button></span> <span ng-if="vmCustomerPnl.isValidVin(vm.appointment.vin).isValid" class="validation text-danger">{{vmCustomerPnl.isValidVin(vm.appointment.vin).message}}</span> <span ng-if="vmCustomerPnl.showNoDecodedVinMessage" class="validation text-danger">Unable to decode VIN.</span></div><div class="col-md-2 col-sm-6 col-xs-12 padding-left-none override-sm-padding-top" ng-if="vm.addingCustomerVehicle || vm.currentVehicle"><div class="block relative"><input type="text" id="odometer" name="odometer" clean="true" autocomplete="nope" inputmode="numeric" required="required" validation="required|custom:vmCustomerPnl.validation.validOdometer(vm.appointment.mileage):alt=*" mask="9?9?9?9?9?9?" mask-restrict="reject" ng-model-options="{ debounce: 750 }" validation-error-to="#odometerError" ng-change="vmCustomerPnl.getRecommendedMaint()" ng-model="vm.appointment.mileage" class="form-control no-spinners better-placeholder" placeholder="ODOMETER"></div></div><div class="col-md-2 col-sm-6 col-xs-12 padding-left-none override-sm-padding-top" ng-if="vm.addingCustomerVehicle || vm.currentVehicle"><div class="block relative field-wrapper"><label for="odometer_type" class="on">Mi/Km</label><select id="odometer_type" name="odometer_type" ng-model="vm.appointment.mileageType" selectlabel="" required="required" ng-change="vmCustomerPnl.getRecommendedMaint()" ng-options="measurement as measurement.abbreviation for measurement in vm.odometerTypes track by measurement.type" class="form-control"></select></div></div><div class="col-md-offset-8 col-md-4 col-sm-12 col-xs-12 padding-left-none" ng-if="vm.addingCustomerVehicle || vm.currentVehicle"><span class="text-danger validation whitespace-normal" id="odometerError"></span></div></div></div><div class="form-group margin-bottom-none" ng-if="vm.addingCustomerVehicle || vm.currentVehicle"><div class="row" ng-if="!vmCustomerPnl.ymmOlderVehicles"><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none field-wrapper"><label for="vehicle_year">SELECT YEAR</label><select id="vehicle_year" ng-model="vm.appointment.year" name="vehicle_year" selectlabel="" required="" inputmode="numeric" ng-model-options="{ debounce: 400 }" class="form-control" ng-disabled="vmCustomerPnl.disableYear()" ng-options="year as year for year in vmCustomerPnl.vehicleYears track by year" ng-change="vmCustomerPnl.yearUpdated()" validation="required:alt={{vm.fieldIsReqTxt}}"><option value="" selected="selected" disabled="">Select year</option></select></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none field-wrapper"><label for="vehicle_make">SELECT MAKE</label><select id="vehicle_make" name="vehicle_make" selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="vmCustomerPnl.disableMake()" ng-options="make.make for make in vmCustomerPnl.vehicleMakes track by make.makeCode" ng-change="vmCustomerPnl.makeUpdated()" ng-model="vmCustomerPnl.selectedMake" class="form-control" validation="required:alt={{vm.fieldIsReqTxt}}"><option value="" selected="selected" disabled="">Select make</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vmCustomerPnl.updateVehicleMakes"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none override-sm-margin-top-md field-wrapper"><label for="vehicle_model">SELECT MODEL</label><select id="vehicle_model" name="vehicle_model" selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="vmCustomerPnl.disableModel()" ng-options="model.model for model in vmCustomerPnl.vehicleModels track by model.modelCode" ng-model="vmCustomerPnl.selectedModel" class="form-control" ng-change="vmCustomerPnl.modelUpdated()" validation="required:alt={{vm.fieldIsReqTxt}}"><option value="" selected="selected" disabled="">Select model</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vmCustomerPnl.updateVehicleModels"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none field-wrapper override-sm-margin-top"><label for="sub_model">SUB MODEL</label><select class="form-control" ng-model="vmCustomerPnl.selectedSubModel" ng-model-options="{ debounce: 800 }" selectlabel="" ng-disabled="vm.resolvedAppointmentId || vmCustomerPnl.decodingVin || vm.decodedVin || !vmCustomerPnl.selectedModel || vmCustomerPnl.updatingYears || vmCustomerPnl.updateVehicleModels || vmCustomerPnl.updateVehicleMakes || !vmCustomerPnl.vehicleSubModels || vmCustomerPnl.vehicleSubModels.length === 0" ng-options="submodel for submodel in vmCustomerPnl.vehicleSubModels" ng-change="vmCustomerPnl.subModelUpdated()" id="sub_model" name="sub_model"><option value="">Sub model</option></select></div></div><div class="row" ng-if="vmCustomerPnl.ymmOlderVehicles === true" ng-class="{\'older-vehicles\': vmCustomerPnl.ymmOlderVehicles === true}"><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none field-wrapper"><input type="text" ng-pattern="/^\\d+$/" id="vehicle_year" name="vehicle_year" ng-model="vm.appointment.year" class="form-control better-placeholder" clean="true" ng-keydown="vmCustomerPnl.vehicleKeyDown($event)" inputmode="numeric" pattern="[0-9]*" placeholder="YEAR" validation="required:alt={{vm.fieldIsReqTxt}}|custom:vmCustomerPnl.validation.valYear():alt=Invalid Year (1900 - {{vmCustomerPnl.maxVehicleYear}})"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none field-wrapper"><input type="text" id="vehicle_make" name="vehicle_make" ng-model="vm.appointment.make" class="form-control better-placeholder" placeholder="MAKE" required="" validation="required:alt={{vm.fieldIsReqTxt}}"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none override-sm-margin-top-md field-wrapper"><input type="text" id="vehicle_model" name="vehicle_model" ng-model="vm.appointment.model" class="form-control better-placeholder" placeholder="MODEL" required="" validation="required:alt={{vm.fieldIsReqTxt}}"></div><div class="col-md-3 col-sm-6 col-xs-12 padding-left-none field-wrapper override-sm-margin-top"><div id="newer-vehicles" class="theme-link text-uppercase" ng-click="vmCustomerPnl.switchYMMToDropDowns()">Newer Vehicles</div></div></div><div id="border-row" class="row margin-bottom-none margin-top-md" ng-if="(vm.addingCustomerVehicle || vm.currentVehicle) && vm.appointment.year && vm.appointment.make && vm.appointment.model && vmCustomerPnl.activeProduct === \'appointment-list\'"><div class="col-xs-12 padding-left-none"><hr></div></div></div><div class="form-group" ng-if="(vm.addingCustomerVehicle || vm.currentVehicle) && vm.appointment.year && vm.appointment.make && vm.appointment.model && vmCustomerPnl.activeProduct === \'appointment-list\'"><div class="row"><div class="col-sm-6 col-xs-8 field-wrapper padding-left-none"><label for="selectedDepartment">SELECT DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0" name="selectedDepartment" required="" ng-model-options="{ debounce: 750 }" class="form-control" ng-model="vm.appointment.departmentId" ng-options="dept.id as dept.name for dept in vm.dealerDepartments | filter: vm.activeDepartmentFilter" ng-change="vmCustomerPnl.departmentChanged()"><option value="">Select department</option></select><div class="error-section text-danger padding-md" ng-if="(vm.addingCustomerVehicle || vm.currentVehicle) && vm.appointment.year && vm.appointment.make && vm.appointment.model && vmCustomerPnl.activeProduct === \'appointment-list\' && !vm.appointment.departmentId"><div class="text-danger">Please select a department.</div></div></div><div class="col-sm-6 col-xs-4" ng-if="vmCustomerPnl.displayServiceHistory()"><div class="text-danger bold margin-bottom text-align-right text-uppercase cursor-pointer" ng-click="vm.openRoHistory(true)">vehicle service history</div></div></div><div class="row" ng-if="vm.hasMismatchedPreviouslyDeclinedItems() === true"><div class="col-xs-12 text-danger error-section margin-top-sm"><i class="material-icons info-icon mismatched text-danger schedule-page">info_outline</i><div id="mismatched-note">Note: one or more previously selected services are not included in the default set of the current department.</div></div></div><div class="row" ng-if="vm.appointment.departmentRecallForceUnchecked === true || vm.appointment.departmentRecMaintForceUnchecked === true"><div class="col-xs-12 text-danger error-section margin-top-sm"><i class="material-icons info-icon mismatched text-danger schedule-page">info_outline</i><div id="mismatched-note">Note: {{vmCustomerPnl.recallRecMaintUncheckedNote()}}</div></div></div><div class="row" ng-if="vm.appointment.departmentPrevDeclinedForceUnchecked === true"><div class="col-xs-12 text-danger error-section margin-top-sm"><i class="material-icons info-icon mismatched text-danger schedule-page">info_outline</i><div id="mismatched-note">Note: Previously deferred services are not available in this department.</div></div></div></div><div class="form-group" ng-if="(vm.addingCustomerVehicle || vm.currentVehicle) && vm.appointment.year && vm.appointment.make && vm.appointment.model && vmCustomerPnl.activeProduct === \'appointment-list\' && vm.appointment.departmentId"><div ng-if="vmCustomerPnl.yearMakeModelMismatch === true && vm.originalApptHasRecallsOrRecMaint" class="error-section text-danger padding-left-none">Vehicle has been changed, please reselect recalls and maintenance.</div><div class="appointment-booking row line-items"><div class="col-sm-12 list-unstyled padding-left-none" ng-if="vm.previouslyDeclinedServicesEnabled() === true && vm.previouslyDeclinedServices && vm.previouslyDeclinedServices.length > 0"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.prevDeclinedServicesChecked"><uib-accordion-heading><div class="panel-heading padding-none"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title"><span class="recalls-toggle inline-block cursor-pointer padding-right-md" ng-click="vmCustomerPnl.prevDeclinedServicesToggle();"><i class="material-icons md-24" ng-if="!vm.prevDeclinedServicesChecked">expand_more</i> <i class="material-icons md-24" ng-if="vm.prevDeclinedServicesChecked">expand_less</i></span> <span class="line-item-name text-uppercase" ng-click="vmCustomerPnl.prevDeclinedServicesToggle();">PREV<span class="hidden-xs">IOUSLY</span> DEFERRED SERVICES</span></div></div></div><div class="services-count recalls"><span class="text-right theme-text" ng-if="vm.previouslyDeclinedServices && vm.previouslyDeclinedServices.length > 0"><i class="material-icons theme-text">warning</i>{{vm.previouslyDeclinedServices.length}}</span> <span ng-if="vm.prevDeclinedServiceCount > 0" class="font-normal theme-text">&nbsp;({{vm.prevDeclinedServiceCount}} selected)&nbsp;</span></div></div></uib-accordion-heading><div class="panel-body padding-none"><div class="col-sm-12 padding-right-none padding-left-none"><div ng-repeat="pdItem in vm.previouslyDeclinedServices"><previously-declined-service-item ng-model="pdItem" dispatch-codes="vmCustomerPnl.parent_vm.dispatchCodes" service-types="vm.serviceTypes" recmaintdata="vm.recmaintdata" is-dashboard="true" appointment="vm.appointment" payment-types="vm.paymentTypes" dms-system="vm.appointment.dealerDMSSystem" dept-op-codes="vm.dealerDeptOpCodes" is-checkin="false"></previously-declined-service-item></div></div></div></div></uib-accordion></div><div class="col-sm-12 list-unstyled padding-left-none" ng-if="vm.recallsEnabled() === true && (vm.recalls || vm.noRecallsFound)"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.recallsChecked"><uib-accordion-heading><div class="panel-heading padding-none"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title"><span class="recalls-toggle inline-block cursor-pointer padding-right-md" ng-click="vmCustomerPnl.recallsToggle();"><i class="material-icons md-24" ng-if="!vm.recallsChecked">expand_more</i> <i class="material-icons md-24" ng-if="vm.recallsChecked">expand_less</i></span> <span class="line-item-name text-uppercase" ng-click="vmCustomerPnl.recallsToggle();">RECALLS</span></div></div></div><div class="services-count recalls"><span class="text-right theme-text" ng-if="vm.recalls && vm.recalls.length > 0"><i class="material-icons theme-text">warning</i>{{vm.recalls.length}}</span> <span ng-if="vm.recallsServiceCount > 0" class="font-normal theme-text">&nbsp;({{vm.recallsServiceCount}} selected)&nbsp;</span></div></div></uib-accordion-heading><div class="panel-body padding-none"><div class="display-flex flex-column flex-percent-100"><div class="font-normal" ng-if="vm.noRecallsFound || vm.recalls.length === 0">{{ vm.appointment.vin ? \'No recalls have been found for this vehicle.\' : \'Please specify the VIN for this vehicle to see open Recalls.\' }}</div><div ng-if="vmCustomerPnl.parent_vm.tooManyRecalls" class="text-danger">Too many recalls were added to this appointment. Please adjust the selected recalls.</div><div ng-repeat="recall in vm.recalls"><div class="display-flex flex-start margin-bottom-md"><div class="recall-checkbox"><input type="checkbox" class="form-check-input" ng-click="vmCustomerPnl.recallLineItemToggled(recall);" ng-value="recall.manufacturerNumber" ng-checked="recall.checked"></div><div class="flex-grow padding-left-sm word-break-wrap"><span class="line-item-name padding-left-none"><span class="text-bold text-uppercase">{{ recall.displayName }} (#{{recall.manufacturerNumber}})</span></span><div class="word-break-wrap" ng-if="recall.description">{{ recall.description }}</div></div></div></div></div></div></div></uib-accordion></div><div class="col-sm-12 list-unstyled padding-left-none" ng-if="vm.recMaintEnabled() === true && (vm.recMaintData || vm.noRecMaintFound)"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.recMaintChecked"><uib-accordion-heading><div class="panel-heading padding-none"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title"><span class="recalls-toggle inline-block cursor-pointer padding-right-md" ng-click="vmCustomerPnl.recMaintToggle();"><i class="material-icons md-24" ng-if="!vm.recMaintChecked">expand_more</i> <i class="material-icons md-24" ng-if="vm.recMaintChecked">expand_less</i></span> <span class="line-item-name text-uppercase" ng-click="vmCustomerPnl.recMaintToggle();">RECOMMENDED MAINTENANCE</span></div></div></div><div class="services-count"><span class="text-right theme-text">{{ vm.recMaintData.length }}</span> <span ng-if="vm.recMaintServiceCount > 0" class="font-normal theme-text">&nbsp;({{vm.recMaintServiceCount}} selected)&nbsp;</span></div></div></uib-accordion-heading><div class="panel-body padding-none"><div class="display-flex flex-column flex-percent-100"><div class="font-normal" ng-if="vm.noRecMaintFound || vm.recMaintData.length === 0">No recommended maintenance has been found for this vehicle.</div><div ng-repeat="recmaint in vm.recMaintData"><div class="input-group margin-bottom-md full-width"><div class="display-flex padding-left-none"><div class="flex-percent-10 max-width-px-18 padding-left-none"><input type="radio" class="form-check-input" name="selectedRecMaint_{{$index}}" ng-model="vm.selectedRecMaint" ng-click="vmCustomerPnl.recMaintItemToggle(recmaint, $event);" ng-value="recmaint.interval"></div><div class="flex-percent-90 flex-grow padding-left-none"><div class="padding-top-xs text-uppercase margin-bottom-none padding-left-none" title="{{::vm.getRecMainTooltip(recmaint.applications)}}"><b>{{::vm.getRecMaintTitle(recmaint)}}</b></div><div class="whitespace-normal padding-top-xs padding-left-none padding-top-xs" ng-if="vm.selectedRecMaint === recmaint.interval"><span ng-repeat="app in recmaint.applications">{{ app.taxonomy.literalName }}<span ng-if="!$last">,</span></span></div></div></div><div class="display-flex margin-top customer-complaint" ng-if="vm.selectedRecMaint === recmaint.interval"><div class="flex-percent-100"><lineitem-edit-properties ng-if="vm.selectedRecMaint === recmaint.interval" updateevent="recMaintItemUpdated" appointment="vm.appointment" is-rec-maint="true" ng-model="recmaint" is-checkin="false" require-dispatch-code="vmCustomerPnl.parent_vm.requireDispatchCode" dms-system="vm.appointment.dealerDMSSystem" dispatch-codes="vmCustomerPnl.parent_vm.dispatchCodes" service-types="vm.serviceTypes"></lineitem-edit-properties></div></div></div></div><div class="font-size-10" ng-if="vm.recMaintDisclaimer" ng-bind-html="vm.recMaintDisclaimer"></div></div></div></div></uib-accordion></div><div class="col-sm-12 list-unstyled padding-left-none common-services" ng-if="(vm.dealerOpCodes | filter: vm.filterOpCodesForDisplay).length > 0"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.commonServicesChecked"><uib-accordion-heading><div class="panel-heading padding-none"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title"><span class="recalls-toggle inline-block cursor-pointer padding-right-md" ng-click="vmCustomerPnl.commonServicesToggle();"><i class="material-icons md-24" ng-if="!vm.commonServicesChecked">expand_more</i> <i class="material-icons md-24" ng-if="vm.commonServicesChecked">expand_less</i></span> <span class="line-item-name text-uppercase" ng-click="vmCustomerPnl.commonServicesToggle();">COMMON SERVICES</span></div></div></div><div class="services-count theme-text font-normal">{{(vm.dealerOpCodes | filter: vm.filterOpCodesForDisplay).length}} <span ng-if="vm.commonServicesCount > 0" class="font-normal">&nbsp;({{vm.commonServicesCount}} selected)&nbsp;</span></div></div></uib-accordion-heading><div class="panel-body padding-none margin-top-sm"><div class="col-sm-12 padding-none"><div ng-repeat="lineItem in vm.dealerOpCodes | filter: vm.filterOpCodesForDisplay"><div class="input-group margin-bottom-md full-width"><div class="col-md-12 padding-none"><div class="panel-title padding-none margin-top-sm text-wrap"><div class="display-flex flex-start"><input type="checkbox" class="form-check-input" ng-click="vmCustomerPnl.lineItemToggle(lineItem);" ng-value="lineItem.id" ng-checked="lineItem.checked"><div class="padding-left-sm word-break-wrap"><span class="line-item-name padding-left-none"><span class="text-bold text-uppercase"><span text-ellipse="" use-arrow-icons="true">{{lineItem.dashboardName || lineItem.name}}</span></span> <span ng-if="lineItem.dealerDepartmentId !== vm.appointment.departmentId" class="cursor-pointer hover-underline" uib-popover="Not included in dept. defaults" popover-placement="bottom" popover-trigger="mouseenter"><i class="material-icons info-icon mismatched text-danger">info_outline</i></span></span><div class="line-item-addedby line-item-edit margin-none common-services" ng-if="::vmCustomerPnl.isCustomerRequest(lineItem)">Original Customer Request</div><div class="line-item-addedby line-item-edit margin-none common-services" ng-if="::vmCustomerPnl.isUserRequest(lineItem)">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div><div class="below-lineitem-checkbox whitespace-normal"><span class="line-item-description margin-left-none"><span text-ellipse="" use-arrow-icons="true"><span>{{lineItem.dashboardDescription || lineItem.description}}</span></span></span></div></div></div></div><lineitem-edit-properties ng-if="lineItem && lineItem.checked" updateevent="lineItemUpdated" appointment="vm.appointment" is-rec-maint="false" ng-model="lineItem" is-checkin="false" dms-system="vm.appointment.dealerDMSSystem" require-dispatch-code="vmCustomerPnl.parent_vm.requireDispatchCode" dispatch-codes="vmCustomerPnl.parent_vm.dispatchCodes" service-types="vm.serviceTypes" show-note="true" is-form-valid="vmCustomerPnl.alwaysEnableCustomerNote()" is-validating-recalls="false" blurevent="blurLineitem"></lineitem-edit-properties></div></div></div></div></div></div></uib-accordion></div><div class="col-sm-12 list-unstyled padding-left-none" ng-repeat="lineItem in vm.appointment.lineItems | filter: { isGeneric: true }"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="lineItem.checked"><uib-accordion-heading><div class="panel-heading padding-none"><div class="input-group"><div class="col-md-8 padding-none"><div class="panel-title"><input type="checkbox" class="form-check-input" ng-click="vmCustomerPnl.lineItemToggle(lineItem);" ng-value="lineItem.id" ng-checked="lineItem.checked"> <span class="line-item-name text-uppercase">CONSUMER SERVICE NEEDS</span><div class="line-item-addedby line-item-edit" ng-if="::vmCustomerPnl.isCustomerRequest(lineItem)">Original Customer Request</div><div class="line-item-addedby line-item-edit" ng-if="::vmCustomerPnl.isUserRequest(lineItem)">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div></div></div></div></div></uib-accordion-heading><div class="panel-body padding-none" ng-if="lineItem.checked"><lineitem-edit-properties ng-if="lineItem && lineItem.checked" updateevent="lineItemUpdated" appointment="vm.appointment" is-rec-maint="false" ng-model="lineItem" is-checkin="false" require-dispatch-code="vmCustomerPnl.parent_vm.requireDispatchCode" dms-system="vm.appointment.dealerDMSSystem" dispatch-codes="vmCustomerPnl.parent_vm.dispatchCodes" service-types="vm.serviceTypes" show-note="true" is-form-valid="vmCustomerPnl.alwaysEnableCustomerNote()" ,="" is-validating-recalls="false"></lineitem-edit-properties></div></div></uib-accordion></div><div class="col-sm-12 list-unstyled padding-left-none other-line-items" ng-repeat="lineItem in vm.appointment.lineItems | filter: { isOther: true }"><uib-accordion class="line-item" ng-class="{\'opcode-selected\': vmCustomerPnl.isOpCodeSelected(lineItem) }"><div uib-accordion-group="" is-disabled="true" is-open="lineItem.checked"><uib-accordion-heading><div class="panel-heading padding-none"><div class="input-group full-width"><div class="col-md-8 padding-none"><div class="panel-title max-width-percent-95"><input type="checkbox" class="form-check-input" ng-click="vmCustomerPnl.lineItemToggle(lineItem);" ng-value="lineItem.id" ng-checked="lineItem.checked"> <span class="inline-block padding-left-sm padding-right-xs max-width-percent-80 ellipsis-overflow text-uppercase newitem-label">{{lineItem.overrideName || lineItem.opCodeDescription || \'NEW ITEM\' }}</span> <span ng-if="lineItem.dealerDepartmentId !== vm.appointment.departmentId && (lineItem.overrideName || lineItem.opCodeDescription)" class="cursor-pointer hover-underline other-item-warning" uib-popover="Not included in dept. defaults" popover-placement="bottom" popover-trigger="mouseenter"><i class="material-icons info-icon mismatched text-danger">info_outline</i></span><div class="line-item-addedby line-item-edit" ng-if="::vmCustomerPnl.isCustomerRequest(lineItem)">Original Customer Request</div><div class="line-item-addedby line-item-edit" ng-if="::vmCustomerPnl.isUserRequest(lineItem)">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div></div></div></div></div></uib-accordion-heading><div class="panel-body padding-right-20 padding-top-none margin-top-sm" ng-if="lineItem.checked"><lineitem-edit-properties ng-if="lineItem && lineItem.checked" updateevent="lineItemUpdated" opcodeselectedevent="opCodeSearchSelected" appointment="vm.appointment" existing-services="vm.appointment.lineItems" op-codes="parent_vm.dealerOpCodes" is-rec-maint="false" remove-padding="true" ng-model="lineItem" is-checkin="false" require-dispatch-code="vmCustomerPnl.parent_vm.requireDispatchCode" dms-system="vm.appointment.dealerDMSSystem" dispatch-codes="vmCustomerPnl.parent_vm.dispatchCodes" service-types="vm.serviceTypes" show-note="true" is-form-valid="vmCustomerPnl.alwaysEnableCustomerNote()" ,="" is-validating-recalls="false"></lineitem-edit-properties></div><div ng-if="!$last" class="col-sm-11 col-xs-10"><span class="theme-link" ng-click="vmCustomerPnl.removeOtherLineItem(lineItem.uniqueDOMId)">DELETE SERVICE</span></div></div></uib-accordion></div></div></div></div></div><div ng-if="vm.appointment.departmentId && vm.appointment.noLineItemsSelected === true && (vm.addingCustomerVehicle || vm.currentVehicle) && vm.appointment.year && vm.appointment.make && vm.appointment.model && vmCustomerPnl.activeProduct === \'appointment-list\'" class="error-section text-danger margin-bottom">Please select at least one service from the list above.</div></div>');
$templateCache.put('app/areas/appointment/views/partials/appointment-schedule-transportation.view.html','<uib-accordion-heading><h4 class="panel-title"><div class="padding-bottom-xs">APPOINTMENT DETAILS<div class="inline pull-right"><div class="ng-hide accordion-clear-step" ng-show="vm.accordion.selectedStep === vm.accordion.steps.summary" ng-click="vmSchedulePnl.clearTransportation()"><i class="material-icons" ng-if="!vm.resolvedAppointmentId">edit</i></div></div><span ng-if="vm.accordion.selectedStep === vm.accordion.steps.scheduleTransportation && vm.lastServiceAdvisor" class="pull-right font-size-11 padding-right-20 font-normal hidden-xs">Prev Advisor: {{ vm.lastServiceAdvisor.firstName }} {{ vm.lastServiceAdvisor.lastName }}</span></div><span ng-if="vm.accordion.selectedStep === vm.accordion.steps.scheduleTransportation && vm.lastServiceAdvisor" class="padding-left-none font-size-11 padding-right-20 font-normal visible-xs">Prev Advisor: {{ vm.lastServiceAdvisor.firstName }} {{ vm.lastServiceAdvisor.lastName }}</span></h4><div class="ng-hide appt-summary margin-bottom border-top" ng-show="vm.accordion.selectedStep === vm.accordion.steps.summary"><div class="row margin-top"><div class="col-sm-4 col-xs-12 text-uppercase margin-bottom-sm"><div class="margin-bottom" ng-if="vm.appointment.pickupDropoff !== vmSchedulePnl.transTypeGroups.dropoff"><strong><span ng-if="vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.pickup">SERVICE PICKUP</span> <span ng-if="vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.mobile">MOBILE SERVICE</span></strong> <a ng-click="$dismiss()" ui-sref="trip-tab-trip({ tripId: {{::vm.appointment.tripId}}})" ng-if="vm.appointment.tripId">#{{ vm.appointment.tripId }}</a><br><span>{{vm.appointment.tripPickupTimeDisplay}}</span></div><div ng-if="vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.dropoff"><strong>CUSTOMER DROPOFF</strong></div><div class="margin-bottom" ng-if="vmSchedulePnl.pickupLocation.formattedLocation && vm.appointment.pickupDropoff !== vmSchedulePnl.transTypeGroups.dropoff">{{ vmSchedulePnl.pickupLocation.formattedLocation }}</div><div class="margin-bottom" ng-if="!vmSchedulePnl.pickupLocation.formattedLocation && vm.appointment.tripPickupLocation && vm.appointment.pickupDropoff !== vmSchedulePnl.transTypeGroups.dropoff">{{ vm.appointment.tripPickupLocation.streetAddress }}, {{ vm.appointment.tripPickupLocation.city }}, {{ vm.appointment.tripPickupLocation.state }} {{ vm.appointment.tripPickupLocation.zip }}</div><div id="appt-summary-datetime">{{ vm.appointment.apptDateTime | date:\'MMMM dd, yyyy At h:mm a\' }}</div><div ng-if="vmSchedulePnl.displayAdvisor">ADVISOR: <span ng-if="!vmSchedulePnl.selectedAdvisor">ANY</span> <span ng-if="vmSchedulePnl.selectedAdvisor">{{ vmSchedulePnl.selectedAdvisor.firstName }} {{ vmSchedulePnl.selectedAdvisor.lastName }}</span></div><div ng-if="vm.appointment.departmentId">DEPT: {{ vmSchedulePnl.getDepartmentName() }}</div><div ng-if="vm.showAppointmentStatus()">STATUS: <b>{{ vmSchedulePnl.getApptStatusLabel() }} <span ng-if="vm.appointment.statusLastChanged">{{vm.appointment.statusLastChanged | date:\'MM/dd\' }} at {{vm.appointment.statusLastChanged | date:\'h:mm a\' }}</span></b></div><div class="ellipsis-overflow" ng-if="vm.appointment.dealerDMSSystem !== vmSchedulePnl.dmsProviderTypes.None">DMS APPT ID: <span title="{{ vmSchedulePnl.removePipedData(vm.appointment.apptId) }}" ng-if="!vm.appointment.dmsApptNumber && (vmSchedulePnl.apptIdIsValid(vm.appointment.apptId) || vm.appointment.dealerDMSSystem === vmSchedulePnl.dmsProviderTypes.Tekion)">{{ vmSchedulePnl.removePipedData(vm.appointment.apptId) }}</span> <span title="{{ vm.appointment.dmsApptNumber }}" ng-if="vm.appointment.dmsApptNumber">{{ vm.appointment.dmsApptNumber }}</span> <span ng-if="!vmSchedulePnl.apptIdIsValid(vm.appointment.apptId) && vm.appointment.dealerDMSSystem !== vmSchedulePnl.dmsProviderTypes.Tekion">PENDING</span></div><div class="margin-top" ng-if="vm.pickupDropoff !== vm.transTypeGroups.mobile"><strong>TRANSPORTATION</strong></div><div ng-if="!vm.appointment.transportationType && vm.pickupDropoff !== vm.transTypeGroups.mobile">{{ vmSchedulePnl.getTransportationTypeLabel(vm.appointment.dealerTransportationTypeId) }}</div><div ng-if="vm.appointment.transportationType && vm.pickupDropoff !== vm.transTypeGroups.mobile">{{ vm.appointment.transportationType.dashboardDescription.replace(\'Loaner Requested\', \'Loaner\') }} <a ui-sref="loaner-reservation-edit({\'reservationId\': vm.appointment.loanerContractId, \'locationId\': vm.appointment.location.id})" ng-if="vm.appointment.loanerConfirmationNumber">#{{ vm.appointment.loanerConfirmationNumber }}</a></div></div><div class="col-sm-8 col-xs-12 margin-top-sm"><div class="visible-xs border-bottom-xs padding-bottom-xs margin-bottom"><i ng-if="!vmSchedulePnl.mobileMapVisible" class="material-icons md-24 pull-right appt-summarymap-toggle cursor-pointer" ng-click="vmSchedulePnl.mobileMapVisible = !vmSchedulePnl.mobileMapVisible">expand_more</i> <i ng-if="vmSchedulePnl.mobileMapVisible" class="material-icons md-24 pull-right appt-summarymap-toggle cursor-pointer" ng-click="vmSchedulePnl.mobileMapVisible = !vmSchedulePnl.mobileMapVisible">expand_less</i></div><div ng-if="vm.accordion.selectedStep === vm.accordion.steps.summary" id="summary-map-holder" ng-show="vmSchedulePnl.mobileMapVisible" class="ng-hide" map-resize=""><div driver-tracking="" id="summary-map-holder-map" options="vmSchedulePnl.summaryMapOptions" map-loaded="vmSchedulePnl.onSummaryMapLoaded" dealer="vm.appointment.location"></div></div><div ng-show="!vmSchedulePnl.mobileMapVisible" class="ng-hide theme-link" ng-click="vmSchedulePnl.mobileMapVisible = !vmSchedulePnl.mobileMapVisible"><center>SHOW MAP</center></div></div></div><div ng-if="vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.pickup" class="row margin-top-30 text-uppercase"><div class="col-sm-1 col-xs-2"><img class="profile-photo" afkl-lazy-image-options="{ background: true}" ng-src="{{vm.appointment.tripDriver.driverPhoto || \'assets/images/user-square.png\'}}"></div><div class="col-xs-8 ng-hide" ng-show="!vm.savingDriver"><strong ng-if="vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.pickup">Your Driver</strong> <strong ng-if="vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.mobile">Your Mobile Tech</strong><div ng-if="!vm.canEditDriver() && !vm.appointment.tripDriver.id">Unassigned</div><div ng-if="vm.canEditDriver() && !vm.appointment.tripDriver.id" class="theme-link" ng-show="!vm.changeDriver" ng-hide="vm.changeDriver == true" ng-click="vm.changeDriverClick()">Unassigned</div><div ng-if="vm.appointment.tripDriver.id && vm.canEditDriver() && vm.appointment.tripDriver.name" ng-show="!vm.changeDriver" ng-hide="vm.changeDriver == true" class="theme-link" ng-click="vm.changeDriverClick()"><div>{{ vm.appointment.tripDriver.name }}</div></div><div ng-if="vm.appointment.tripDriver.id && !vm.canEditDriver() && vm.appointment.tripDriver.name"><div>{{ vm.appointment.tripDriver.name }}</div></div><div class="ng-hide" ng-show="vm.changeDriver == true && vm.activeDrivers && !vm.savingDriver"><select id="assigned_driver" name="assigned_driver" class="form-control has-label" ng-model-options="{ debounce: 750 }" allow-null-option="Best available" ng-change="vm.driverSelectionModified(vm.appointment.tripDriver.id, vm.originalDriver)" ng-init="vm.originalDriver=vm.appointment.tripDriver.id" ng-model="vm.appointment.tripDriver" ng-options="driver as vm.formatDriverDropDown(driver, vm.appointment.tripDriver) disable when driver.id == -999 for driver in vm.activeDrivers track by driver.id"></select></div></div><div class="col-xs-8 ng-hide" ng-show="vm.savingDriver"><img src="assets/images/ajax-loader.gif"> Updating...</div></div><div class="row margin-top"><div class="col-sm- 12 col-xs-12 margin-top"><h4 class="panel-title">SERVICES</h4><div class="border-bottom padding-bottom-xs margin-bottom"><i ng-if="!vmSchedulePnl.servicesVisible" class="material-icons md-24 pull-right appt-summarymap-toggle services-toggle" ng-click="vmSchedulePnl.servicesVisible = !vmSchedulePnl.servicesVisible">expand_more</i> <i ng-if="vmSchedulePnl.servicesVisible" class="material-icons md-24 pull-right appt-summarymap-toggle services-toggle" ng-click="vmSchedulePnl.servicesVisible = !vmSchedulePnl.servicesVisible">expand_less</i></div><ul id="appt-summary-services-holder" ng-show="vmSchedulePnl.servicesVisible" class="ng-hide"><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isRecall: true } as results track by lineItem.manufacturerNumber"><div class="text-uppercase bold">Recall - #{{lineItem.manufacturerNumber}} {{ lineItem.recallDisplayName}}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isRecommendedMaintenance: true }"><div class="text-uppercase bold">{{ lineItem.overrideName}}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isGeneric: false, isRecall: false, isRecommendedMaintenance: false, isOther: false, isAutomatic: false }"><div class="text-uppercase bold">{{lineItem.opCode}} - {{ lineItem.dashboardName || lineItem.opCodeDescription || lineItem.dealerAppointmentServiceOpCode.name}}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div><div ng-if="lineItem.dashboardDescription">{{ lineItem.dashboardDescription }}</div><div class="margin-top-md"><b>NOTE</b></div><div ng-if="lineItem.note">{{lineItem.note}}</div><div ng-if="!lineItem.note">NO COMMENTS</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isOther: true, checked: true }"><div class="text-uppercase bold">{{lineItem.opCode}} - {{ lineItem.overrideName || lineItem.opCodeDescription }}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === false">Added by {{lineItem.createdByUser.firstName}} {{lineItem.createdByUser.lastName}}</div><div ng-if="vmSchedulePnl.getDisplayLineItemDescription(lineItem)">{{ vmSchedulePnl.getDisplayLineItemDescription(lineItem) }}</div><div class="margin-top-md"><b>NOTE</b></div><div ng-if="lineItem.note">{{lineItem.note}}</div><div ng-if="!lineItem.note">NO COMMENTS</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isGeneric: true }"><div class="text-uppercase bold">{{\'CONSUMER SERVICE NEEDS \' + (lineItem.genericName ? \'- \' + lineItem.genericName : \'\') }}</div><div class="line-item-addedby" ng-if="lineItem.createdByUser && lineItem.createdByUser.isConsumerUser === true">Original Customer Request</div><div><b>NOTE</b></div><div ng-if="lineItem.note">{{lineItem.note}}</div><div ng-if="!lineItem.note">NO COMMENTS</div></li><li ng-repeat="lineItem in vm.appointment.lineItems | filter: { isAutomatic: true }"><div class="text-uppercase bold">{{ lineItem.opCode }} - {{ lineItem.opCodeDescription || lineItem.note}}</div></li></ul></div></div><div class="row margin-top-30 ng-hide" ng-show="vm.accordion.selectedStep === vm.accordion.steps.summary && vm.showNextBtn() === true"><div class="col-xs-11 margin-top text-danger" ng-if="vm.customerPhoneType.type === vm.phoneTypes.landline">Note the customer phone number is a landline and is unable to receive text messages.</div><div class="col-xs-11 margin-top-md text-danger" ng-if="vm.customerPhoneType.isOptedOut === true && vm.appointment.mobileSmsOptedIn === true">Note customer has previously opted out of receiving text messages. Please inform them to send START to {{vm.customerPhoneType.dealerPhone | tel}} in order to receive text messages.</div></div></div></uib-accordion-heading><div ng-if="vm.accordion.selectedStep === vm.accordion.steps.scheduleTransportation" id="appt-scheduletransportation-form" name="appt-scheduletransportation-form"><div class="row padding-left-none margin-top"><div class="col-xs-12 padding-left-none field-wrapper col-sm-3"><label for="selectedDepartment">DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0" name="selectedDepartment" required="" ng-model-options="{ debounce: 750 }" class="form-control" ng-model="vm.appointment.departmentId" ng-options="dept.id as dept.name for dept in vm.dealerDepartments | filter: vm.activeDepartmentFilter" ng-disabled="vmSchedulePnl.gettingSlots" validation="required|custom:vmSchedulePnl.validation.isValidDepartment():alt=Please pick a value from the list" ng-change="vmSchedulePnl.departmentChanged()"><option value="">Department</option></select></div><div class="col-xs-12 padding-left-none field-wrapper col-sm-3"><label for="advisor">ANY ADVISOR</label><select selectlabel="" id="advisor" name="advisor" class="form-control" ng-model="vmSchedulePnl.selectedAdvisor" ng-model-options="{ debounce: 750 }" ng-disabled="vmSchedulePnl.gettingSlots" ng-change="vmSchedulePnl.calendarOptionsChanged()" ng-options="(adv.firstName ? adv.firstName + \' \' + adv.lastName : adv.lastName) for adv in vm.serviceAdvisors track by adv.id"><option value="" ng-if="vmSchedulePnl.canSelectAnyAdvisor">Any advisor</option></select></div><div class="col-xs-12 padding-left-none override-xs-margin-top-md field-wrapper col-sm-3" ng-show="vmSchedulePnl.dropOffTransportationTypes.length > 0 || vmSchedulePnl.pickUpTransportationTypes.length > 0 || vmSchedulePnl.mobileTransportationTypes.length > 0"><label for="trip_type">SELECT PICKUP/DROPOFF/MOBILE SERVICE</label><select id="trip_type" class="form-control" ng-model="vm.appointment.pickupDropoff" selectlabel="" required="" ng-disabled="vmSchedulePnl.gettingSlots" ng-model-options="{ debounce: 750 }" ng-change="vmSchedulePnl.pickupDropoffSelected()"><option value="">Select pickup/dropoff/mobile service</option><option value="{{vmSchedulePnl.transTypeGroups.dropoff}}" ng-if="vmSchedulePnl.dropOffTransportationTypes.length > 0 || vm.appointment.transportationType.isDropOff">Customer drop off</option><option value="{{vmSchedulePnl.transTypeGroups.pickup}}" ng-if="vmSchedulePnl.pickUpTransportationTypes.length > 0 || vm.appointment.transportationType.isPickup">Dealership pick up</option><option value="{{vmSchedulePnl.transTypeGroups.mobile}}" ng-if="vmSchedulePnl.mobileTransportationTypes.length > 0 || vm.appointment.transportationType === vmSchedulePnl.apptTransportationTypes.mobileGarage">Mobile service</option></select></div><div class="col-sm-3 col-xs-12 padding-left-none override-xs-margin-top-md field-wrapper" ng-if="vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.mobile"><label for="transport_type">TRANSPORTATION</label><select selectlabel="" id="transport_type" class="form-control" ng-model="vmSchedulePnl.fakeInput" ng-disabled="true"><option value="">Transportation</option></select></div><div class="col-sm-3 col-xs-12 padding-left-none override-xs-margin-top-md field-wrapper" ng-if="vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.dropoff"><label for="transport_type">TRANSPORTATION</label><select selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="vmSchedulePnl.gettingSlots" id="transport_type" class="form-control" ng-model="vm.appointment.transportationType" ng-change="vmSchedulePnl.transportationTypeSelected()" ng-options="type.dashboardDescription for type in vmSchedulePnl.dropOffTransportationTypes | filter:{ showInDashboard: true} track by type.dealerSystemTransportationTypeId"><option value="">Transportation</option></select></div><div class="col-sm-3 col-xs-12 padding-left-none override-xs-margin-top-md field-wrapper" ng-if="vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.pickup"><label for="transport_type">TRANSPORTATION</label><select selectlabel="" required="" ng-disabled="vmSchedulePnl.gettingSlots" id="transport_type" class="form-control" ng-model="vm.appointment.transportationType" ng-model-options="{ debounce: 750 }" ng-change="vmSchedulePnl.transportationTypeSelected()" ng-options="type.dashboardDescription for type in vmSchedulePnl.pickUpTransportationTypes track by type.dealerSystemTransportationTypeId"><option value="">Transportation</option></select></div></div><div class="row" ng-if="vm.hasMismatchedPreviouslyDeclinedItems() === true"><div class="col-xs-12 text-danger error-section margin-top-sm margin-bottom"><i class="material-icons info-icon mismatched text-danger schedule-page">info_outline</i><div id="mismatched-note">Note: one or more previously selected services are not included in the default set of the current department. You may keep them on the current appointment or click BACK and remove them.</div></div></div><div class="row padding-left-none margin-top override-xs-margin-top-none" ng-if="vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.pickup || vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.mobile"><div class="col-sm-3 col-xs-12 padding-left-none field-wrapper override-xs-margin-top-md" ng-if="vm.appointment.pickupDropoff.toLowerCase() !== vmSchedulePnl.transTypeGroups.mobile"><label for="transmission">TRANSMISSION</label><select selectlabel="" id="transmission" name="transmission" class="form-control" ng-model="vmSchedulePnl.selectedTransmission" required="" validation="required" ng-model-options="{ debounce: 750 }" ng-options="transmission as transmission.text for transmission in vmSchedulePnl.transmissions track by transmission.value" ng-change="vmSchedulePnl.transmissionTypeSelected()"><option value="">Transmission</option></select></div><div class="col-sm-3 col-xs-12 padding-left-none field-wrapper override-xs-margin-top-md" ng-if="vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.mobile"><label for="transmission">TRANSMISSION</label><select selectlabel="" disabled="" id="transmission" name="transmission" class="form-control" ng-model="vmSchedulePnl.selectedTransmission"><option value="">Transmission</option></select></div><div class="col-sm-9 col-xs-12 padding-left-none"><input type="text" ng-attr-placeholder="{{vmSchedulePnl.transportationName()}}" id="pickup_location" name="pickup_location" ng-model="vmSchedulePnl.pickupLocation.formattedLocation" class="form-control better-placeholder" required="" details="vmSchedulePnl.places" clean="true" autocomplete="false" validation="required:alt={{vm.fieldIsReqTxt}}" here-places="" options="vmSchedulePnl.options" ng-disabled="!vm.appointment.transportationType || vmSchedulePnl.gettingSlots" handle-selected="vmSchedulePnl.pickupLocationUpdated(formattedAddress)" allow-create-new="true"><div ng-if="vmSchedulePnl.pickupLocation.isInServiceArea === false" class="validation text-danger">Address is out of your service area.</div></div></div><div class="row padding-left-none margin-top"><div class="col-sm-6 padding-left-none" ng-if="vm.appointment.pickupDropoff.toLowerCase() === vmSchedulePnl.transTypeGroups.pickup"><textarea id="appt-driver-notes" class="form-control better-placeholder resize-none" rows="1" ng-model="vm.appointment.tripNote" placeholder="DRIVER NOTES"></textarea></div><div ng-show="(!vmSchedulePnl.isLoanerSelected() || vmSchedulePnl.selectedTimeSlot && vmSchedulePnl.selectedTimeSlot.blockTime) && !vmSchedulePnl.isMGSelected()"><div class="col-sm-3 padding-left-none override-xs-margin-top-sm"><div class="input-group"><input type="text" id="promise-date" class="form-control better-placeholder padding-left-none white-bg text-center" placeholder="EST COMP DATE" ng-model="vm.appointment.promiseDate" moment-picker="" ng-disabled="!vmSchedulePnl.selectedTimeSlot || !vmSchedulePnl.selectedTimeSlot.blockTime" disable="!vmSchedulePnl.selectedTimeSlot || !vmSchedulePnl.selectedTimeSlot.blockTime" readonly="readonly" start-view="month" format="ddd MM/DD/YY" min-date="moment(vmSchedulePnl.selectedTimeSlot.blockTime)" name="promise-date" selectable="vmSchedulePnl.isDateSelectable(date, type)" change="vmSchedulePnl.promiseDateChanged(newValue, oldValue)" required="required" validation="required:alt={{vm.fieldIsReqTxt}}" is-open="vmSchedulePnl.isPromiseTimePickerOpen"> <span class="input-group-addon appointment-calendar" ng-click="vmSchedulePnl.isPromiseTimePickerOpen = !vmSchedulePnl.isPromiseTimePickerOpen" ng-class="{ \'cursor-pointer\': vmSchedulePnl.selectedTimeSlot && vmSchedulePnl.selectedTimeSlot.blockTime, \'cursor-disabled\' : !vmSchedulePnl.selectedTimeSlot || !vmSchedulePnl.selectedTimeSlot.blockTime}"><i class="glyphicon glyphicon-calendar"></i></span></div></div><div class="col-sm-3 padding-left-none override-xs-margin-top-md"><select class="form-control better-placeholder" name="promise-time" ng-options="time as time for time in vmSchedulePnl.promiseTimeHours" ng-model="vm.appointment.promiseTime" placeholder="Est comp time" validation="required:alt={{vm.fieldIsReqTxt}}" ng-disabled="!vmSchedulePnl.selectedTimeSlot || !vmSchedulePnl.selectedTimeSlot.blockTime" required="required"><option></option></select></div></div><div ng-if="vmSchedulePnl.isLoanerSelected() && (!vmSchedulePnl.selectedTimeSlot || !vmSchedulePnl.selectedTimeSlot.blockTime)"><div class="col-sm-3 padding-left-none"><input name="loaner-contract-length" type="number" min="1" id="loaner-contract-length" required="required" ng-model-options="{debounce: 1000}" ng-change="vmSchedulePnl.lengthOfLoanChanged(\'{{vm.appointment.lengthOfLoan}}\', vm.appointment.lengthOfLoan)" ng-model="vm.appointment.lengthOfLoan" class="form-control better-placeholder no-spinners" placeholder="EST RETURN (DAYS)"></div><div class="col-sm-3 padding-left-none override-xs-margin-top-md" ng-if="vm.appointment.promiseDate && false">Est Promise Time: {{vm.appointment.promiseDate.format(\'MM/DD/YYYY\')}} at {{vm.appointment.promiseTime}}</div></div><div ng-show="vmSchedulePnl.isMGSelected()"><div class="col-sm-3 col-xs-12 padding-left-none field-wrapper"><label for="mobileTech">Any Technician</label><select selectlabel="" id="mobileTech" name="mobileTech" class="form-control" ng-model="vm.appointment.tripDriver" ng-model-options="{ debounce: 750 }" ng-disabled="vm.retrievingDrivers" ng-change="vmSchedulePnl.mobileTechChanged()" ng-options="driver as vm.formatDriverDropDown(driver) disable when driver.id == -999 for driver in vm.mobileTechs track by driver.id"><option value="">Any Technician</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide code-spinner-appt" ng-show="vm.retrievingDrivers"></div><div class="col-sm-3 padding-left-none"><div class="input-group"><input id="mg-buffer" type="number" min="1" class="form-control better-placeholder no-spinners" placeholder="Time to Customer" ng-required="vmSchedulePnl.isMGSelected()" ng-model="vmSchedulePnl.mobileGarageBuffer" ng-model-options="{debounce: 1000}" ng-change="vmSchedulePnl.mgBufferChanged(\'{{vmSchedulePnl.mobileGarageBuffer}}\', vmSchedulePnl.mobileGarageBuffer)" name="mg-buffer"></div></div><span class="estLaborText">Est Services: {{vmSchedulePnl.estLaborMinutes}} min</span></div></div><div class="inline-error-box form-group row text-uppercase margin-top" ng-if="vmSchedulePnl.tripErrors && vmSchedulePnl.tripErrors.length"><b>THIS TRIP BREAKS THE FOLLOWING BOOKING RULES. <span ng-if="(vmSchedulePnl.isAdminLevelUser === true || vmSchedulePnl.bookingRules.enableBypassBookingRules === true) && vmSchedulePnl.userHasOverrideRuleRole">CHECK TO CONFIRM.</span></b><ul class="text-left api-error-ul"><li ng-repeat="error in vmSchedulePnl.tripErrors" class="margin-bottom-sm"><input ng-if="(vmSchedulePnl.isAdminLevelUser === true || vmSchedulePnl.bookingRules.enableBypassBookingRules === true) && error.allowOverride && vmSchedulePnl.userHasOverrideRuleRole" type="checkbox" name="checkbox_{{error.code }}" id="checkbox_{{error.code}}" ng-model="error.isChecked" class="checkbox inline" ng-change="vmSchedulePnl.updateErrorCheckbox(error)" checklist-value="error.code"><label for="checkbox_{{error.code}}">{{error.message}}</label></li></ul></div><div id="appt-map-addedit-container" class="row margin-top" ng-if="vm.appointment.pickupDropoff !== vmSchedulePnl.transTypeGroups.dropoff && vmSchedulePnl.pickupLocation.formattedLocation && vm.accordion.selectedStep !== vm.accordion.steps.summary"><div class="col-xs-12 padding-none"><div id="appt-map-addedit" map-resize=""><div id="appt-map-addedit-map" driver-tracking="" options="vmSchedulePnl.mapOptions" map-loaded="vmSchedulePnl.onMapLoaded" map-ready="vmSchedulePnl.onMapReady" dealer="vm.appointment.location"></div></div><resizer vlines="true" direction="vertical" attach-element-id="appt-map-addedit" dependent-element-id="appt-map-addedit" yoffset="-66" callback="vmSchedulePnl.resizeMap(maximize)" collapse="false"></resizer></div></div><div class="row margin-top"><div class="hidden-xs col-sm-3">&nbsp;</div><div class="col-xs-12 col-sm-9 col-md-9 text-danger padding-right-none padding-left-none" ng-if="vmSchedulePnl.isPastAppt && !vmSchedulePnl.selectedTimeSlot"><div class="padding-md">This appointment was scheduled in the past ({{vm.appointment.apptDateTime | date:\'MM/dd/yy h:mm a\'}}). Please select a new date/time below.</div></div><div class="col-xs-12 col-sm-9 col-md-9 text-danger padding-right-none padding-left-none" ng-if="vmSchedulePnl.availTimeSlots && !vmSchedulePnl.selectedTimeSlot && !vmSchedulePnl.isPastAppt && !vmSchedulePnl.availabilityErrors">*Appointment Time Selection is required.</div><div id="calendar-slots-error" class="col-xs-12 col-sm-9 col-md-9 padding-right-none padding-left-none text-danger" ng-if="!vmSchedulePnl.gettingSlots && !vmSchedulePnl.availTimeSlots && !vmSchedulePnl.errorRetrievingSlots">*Please enter all values in the form above to see available times.</div></div><div class="row"><div class="col-md-3 margin-top padding-left-none"><span moment-picker="vmSchedulePnl.calendarOptions.date" start-view="month" format="YYYY-MM-DD" min-date="vmSchedulePnl.today" inline="true" change="vmSchedulePnl.dateChanged(newValue, oldValue)"></span></div><div class="col-md-9 override-xs-padding-none override-xs-margin-top-md"><div class="row calendar-main"><div class="col-sm-12 col-md-12 text-center padding-right-none padding-left-none loading-container" ng-if="vmSchedulePnl.gettingSlots"><img src="assets/images/ajax-loader.gif"> Loading...</div><div id="calendar-slots" class="col-sm-12 col-md-12 align-middle padding-right-none padding-left-none" ng-if="vmSchedulePnl.availTimeSlots && !vmSchedulePnl.gettingSlots && vmSchedulePnl.availTimeSlots"><table id="time-slots-table" class="margin-bottom-lg"><tr class="time-slots-tableheader"><td class="text-uppercase" ng-repeat="day in vmSchedulePnl.availTimeSlots.days" ng-class="vmSchedulePnl.getColClass($index);"><center><div class="text-center text-nowrap inline">{{ day.day | date:\'EEE M/d\'}}</div></center></td></tr><tr><td ng-repeat="day in vmSchedulePnl.availTimeSlots.days" ng-class="vmSchedulePnl.getColClass($index);"><center><ul class="list-unstyled" ng-class="{closed: !day.hoursOfOperation.isOpen}"><li ng-if="day.hoursOfOperation.isOpen" ng-repeat="s in day.timeSlotBlocks | filter: vmSchedulePnl.timeSlotFilter | distinct: vmSchedulePnl.distinctBy()" ng-class="{mgApptPill: s.appointmentDataList.length > 0, open: s.slots !== 0 && !s.unavailable, nonoverridable: s.unavailable && (!vmSchedulePnl.userHasOverrideApptRuleRole || vmSchedulePnl.allSlotsNonOverridable(s)), overridable: s.slots === 0 || (s.unavailable && vmSchedulePnl.userHasOverrideApptRuleRole), selected: vmSchedulePnl.selectedTimeSlot === s}" ng-style="::{\'height\': vmSchedulePnl.getMGApptTimeSlotHeight(s)}"><a class="btn btn-default pill-btn text-center" ng-click="vmSchedulePnl.selectTimeSlot(s)" popover-placement="right" uib-popover-template="\'mg-timeslot-popover.html\'" popover-append-to-body="true" popover-trigger="mouseenter" popover-class="appt-popover" popover-enable="s.appointmentDataList.length > 0" ng-mouseenter="vmSchedulePnl.timeSlotHover(s)"><span class="time wrap-text" ng-if="s.appointmentDataList.length > 0" ng-init="hours = vmSchedulePnl.getFirstLastHours(s.appointmentDataList)">{{ hours.firstHour | date:\'h:mm a\' }}<br>TO<br>{{ hours.lastHour | date:\'h:mm a\' }}<br>({{ s.appointmentDataList.length }} APPT<span ng-if="s.appointmentDataList.length > 1">S</span>)</span> <span class="time wrap-text" ng-if="s.appointmentDataList.length === 0">{{ (parent_vm.appointment.pickupDropoff === vmSchedulePnl.transTypeGroups.pickup ? s.pickupTime : s.blockTime) | date:\'h:mm a\' }}</span></a></li><li ng-if="!day.hoursOfOperation.isOpen" class="closed"><a class="btn btn-default pill-btn text-center"></a></li></ul></center></td></tr></table></div><div class="col-sm-12 col-md-9 padding-right-none padding-left-none text-danger" ng-if="!vmSchedulePnl.gettingSlots && !vmSchedulePnl.availTimeSlots && vmSchedulePnl.errorRetrievingSlots"><ul class="list-unstyled"><li class="padding-md" ng-repeat="item in vmSchedulePnl.availabilityErrors">{{item}}</li></ul></div></div></div></div></div><script type="text/ng-template" id="mg-timeslot-popover.html"><div class=\'margin-top-xs margin-bottom-xs padding-sm\' ng-if="vmSchedulePnl.currentTooltipBlock && vmSchedulePnl.currentTooltipBlock.gettingTooltip"><img src=\'assets/images/ajax-loader.gif\' /> LOADING </div> <div class="appt-schedule-tooltip" ng-if="vmSchedulePnl.currentTooltipBlock && !vmSchedulePnl.currentTooltipBlock.gettingTooltip" ng-repeat="appt in vmSchedulePnl.currentTooltipBlock.tooltip.appointments"> <div ng-class="$last ? \'padding-bottom-sm\' : \'padding-bottom-md\'"> <table class="appt-schedule-table text-uppercase" > <thead> <tr> <th> <b>{{ appt.tripDriver.name || \'Unassigned\' }}</b> </th> </tr> </thead> <tbody> <tr> <td>{{ appt.apptDateTime | date:\'h:mm a\' }}&nbsp;-&nbsp;{{ appt.promiseDateTime | date:\'h:mm a\' || \'N/A\' }}</td> </tr> <tr> <td> <b>{{ (appt.customerFirstName + " " + appt.customerLastName) || "N/A" }}</b> </td> </tr> <tr> <td> <i class="material-icons">location_on</i>{{ appt.tripPickupLocation.streetAddress || \'N/A\' }} </td> </tr> <tr> <td class="padding-left-15">{{ (appt.tripPickupLocation.city + ", " + appt.tripPickupLocation.zip) || "N/A" }}</td> </tr> <tr> <td>{{ vmSchedulePnl.getLineItemsCodes(appt.lineItems) }}</td> </tr> <tr> <td></td> </tr> </tbody> </table> </div> </div></script>');
$templateCache.put('app/areas/appointment/views/right-rail-tabs/appointment-faq-tab.view.html','<div class="appt-right-tab bg-white color-default position-absolute full-width overflow-x-hidden overflow-y-auto vh-h93"><div><div class="col-xs-12" ng-if="vm.content" ng-bind-html="vm.content"></div></div></div>');
$templateCache.put('app/areas/appointment/views/right-rail-tabs/appointment-messages-tab.view.html','<div class="appt-right-tab bg-white color-default messaging position-absolute full-width overflow-x-hidden overflow-y-hidden vh-h100"><div ng-if="vm.parent_vm"><div class="col-xs-12 padding-none flex-grow" ng-if="vm.parent_vm.contact"><rc-messaging-panel class="appt-messaging-pnl display-flex flex-column" contact="vm.parent_vm.contact" panel-mode="vm.messagingPanelModes.dealerCustomer" has-messaging="vm.parent_vm.appointment.location.hasMessaging"></rc-messaging-panel></div><div class="col-xs-12 flex-grow padding-top-md" ng-if="!vm.parent_vm.contact && !vm.contactError">Select a customer to access Messaging</div><div class="col-xs-12 flex-grow padding-top-md" ng-if="vm.contactError">{{ vm.contactError }}</div></div></div>');
$templateCache.put('app/areas/appointment/views/right-rail-tabs/appointment-script-tab.view.html','<div class="appt-right-tab bg-white color-default position-absolute full-width overflow-x-hidden overflow-y-auto vh-h93"><div><div class="col-xs-12" ng-if="vm.content" ng-bind-html="vm.content"></div></div></div>');
$templateCache.put('app/areas/checkin/components/service-card/checkin-service-card.view.html','<div><div class="display-flex text-uppercase"><label class="margin-bottom-none flex-start display-flex cursor-pointer" ng-class="{\'flex-xs-percent-50\': vm.service.serviceGroupType === vm.serviceGroupTypes.previouslyDeclined}"><input ng-if="!vm.serviceGroup.limitToOneSelection" type="checkbox" id="serviceSelect{{vm.service.domId}}" name="serviceSelect{{vm.service.domId}}" ng-model="vm.service.isSelected" ng-value="vm.service.id" ng-change="vm.serviceSelected()"> <input ng-if="vm.serviceGroup.limitToOneSelection" type="radio" id="serviceSelect{{vm.service.domId}}" name="serviceSelect{{vm.serviceGroupType}}" ng-model="vm.serviceGroup.selectedService" ng-value="vm.service" ng-click="vm.serviceSelected()"><div class="display-flex font-bold margin-left-md">{{ vm.service.dashboardName || vm.service.name || vm.service.opCodeDescription || \'New Item\' }} <i ng-if="vm.service.dealerDepartmentId !== vm.appointment.departmentId && vm.serviceGroup.showDeptDefaultWarning" class="margin-left-sm cursor-pointer material-icons text-danger font-size-18 align-middle" uib-popover="Not included in dept. defaults" popover-placement="right" popover-trigger="mouseenter">info_outline</i></div></label> <label ng-if="vm.service.serviceGroupType === vm.serviceGroupTypes.previouslyDeclined" class="flex-right flex-start margin-bottom-none display-flex cursor-pointer flex-xs-percent-50"><input type="checkbox" id="declineService{{vm.service.domId}}" name="declineService{{vm.service.domId}}" ng-model="vm.service.isDeclined" ng-value="vm.service.id" ng-checked="vm.service.isDeclined"><div class="margin-left-md">Not Interested</div></label></div><div class="margin-left-24"><div ng-if="vm.service.createdByUser && !vm.service.createdByUser.firstName">Original Customer Request</div><div ng-if="vm.service.createdByUser && vm.service.createdByUser.firstName">Added by {{vm.service.createdByUser.firstName}} {{vm.service.createdByUser.lastName}}</div><div>{{ vm.service.dashboardDescription || vm.service.description }}</div><div class="margin-top-md" ng-if="vm.serviceGroup.serviceGroupType !== vm.serviceGroupTypes.recall && (vm.service.isSelected || vm.serviceGroup.selectedService.domId === vm.service.domId)"><div class="display-flex content-center margin-bottom-sm flex-gap-sm"><div ng-if="vm.service.isSelected && vm.serviceGroup.serviceGroupType === vm.serviceGroupTypes.manuallyAdded"><select select2="" id="opcode-{{vm.service.domId}}" name="opcode-{{vm.service.domId}}" class="select2-placeholders" on-change="vm.opCodeSelected(selectedResult)" placeholder="Search opcodes" validation-error-to="#searchError-{{vm.service.domId}}" min-input-length="1" init-value="vm.service" allow-any-input-on-empty-results="true" format-for-selection="vm.formatOpCodeForSelection" format-for-dropdown="vm.formatOpCodeForDropdown" query="vm.opCodeSearchQuery" ng-model="vm.service.selectedOpCode" validation="custom: vm.validation.valOpCode():alt=*"></select></div><div ng-if="vm.serviceGroup.serviceGroupType !== vm.serviceGroupTypes.recommendedMaintenance" class="block relative flex-grow"><input type="text" class="form-control better-placeholder" name="lineItem-note-{{vm.service.domId}}" id="lineItem-note-{{vm.service.domId}}" ng-model="vm.service.note" placeholder="CUSTOMER COMPLAINT/NOTES" maxlength="{{::vm.maxNoteLength}}"></div></div><div class="display-flex flex-gap-sm"><div class="field-wrapper flex-percent-25"><label for="lineItem-paytype-{{vm.service.domId}}">PAY TYPE</label><select selectlabel="" class="form-control height-auto normal" id="lineItem-paytype-{{vm.service.domId}}" name="lineItem-paytype-{{vm.service.domId}}" required="" ng-options="type.value as type.text for type in vm.payTypes" ng-model="vm.service.payType"><option value="">Pay type</option></select></div><div class="block relative flex-percent-25"><input type="text" id="lineItem-retailprice-{{vm.service.domId}}" name="lineItem-retailprice-{{vm.service.domId}}" class="form-control better-placeholder no-spinners" ng-model="vm.service.retailPrice" format-currency-with-dollar="" required="" validation="custom: vm.validation.valDecimal(vm.service.retailPrice, 0):alt=Retail Price" placeholder="RETAIL EST"></div><div class="block relative flex-percent-25"><input type="number" id="lineItem-laborhours-{{vm.service.domId}}" name="lineItem-laborhours-{{vm.service.domId}}" class="form-control better-placeholder no-spinners" ng-model="vm.service.laborHours" validation="custom: vm.validation.valDecimal(vm.service.laborHours):alt=*" placeholder="TIME EST"></div><div ng-if="vm.appointment.dealerDMSSystem === vm.dmsProviderTypes.CDK" class="field-wrapper flex-percent-25"><label for="lineItem-dispatchcode-{{vm.service.domId}}">DISP CODE</label><select selectlabel="" ng-attr-id="lineItem-dispatchcode-{{vm.service.domId}}" ng-attr-name="lineItem-dispatchcode-{{vm.service.domId}}" class="form-control height-auto normal" ng-model="vm.service.dispatchCode" validation="required:alt=Field is required" ng-required="vm.requireDispatchCode" placeholder="Disp code"><option value="">Disp code</option><option ng-repeat="item in vm.dispatchCodes" value="{{item}}">{{item}}</option></select></div><div ng-if="vm.appointment.dealerDMSSystem === vm.dmsProviderTypes.DealerTrack" class="field-wrapper flex-percent-25"><label for="dmsServiceTypes-{{vm.service.domId}}">SERVICE TYPE</label><select selectlabel="" name="lineItem-servicetype-{{vm.service.domId}}" id="lineItem-servicetype-{{vm.service.domId}}" required="" validation="required" class="form-control height-auto normal" ng-model="vm.service.serviceType"><option value="">Service type</option><option ng-repeat="item in vm.dealerServiceTypes" value="{{item}}">{{item}}</option></select></div><div class="flex-percent-25"><ui-select ng-model="vm.service.severity" class="severity-select icon-ui-select"><ui-select-match placeholder="Severity"><div class="display-flex content-center"><i ng-if="$select.selected.value.cssClass" class="material-icons md-14 {{ $select.selected.value.cssClass}}">{{ $select.selected.value.icon}}</i> <span class="severity-value padding-left-sm">{{ $select.selected.value.text }}</span></div></ui-select-match><ui-select-choices repeat="item.value.value as (key, item) in vm.lineItemSeverities"><div class="display-flex content-center"><i ng-if="item.value.cssClass" class="material-icons md-14 {{item.value.cssClass}}">{{item.value.icon}}</i> <span ng-if="!item.value.cssClass" class="no-icon"></span> <span ng-bind-html="item.value.text"></span></div></ui-select-choices></ui-select></div></div><div ng-if="vm.serviceGroup.serviceGroupType !== vm.serviceGroupTypes.recommendedMaintenance" class="image-grid w-60 h-60 display-flex"><div class="grid-item margin-top"><drag-drop-image ng-model="vm.imageToUpload" class="small-white-boxes ng-show margin-top" use-icon="true" placeholder="Add Photo" on-load="vm.upload" ng-disabled="vm.addingImage" allow-video="true" drop-reference="vm.service" large="" loading-text="UPLOADING IMAGE" image-type="commonServices" is-version-2="true" hide-btn-text="true" use-small-button="false"></drag-drop-image></div><lineitem-image-display ng-model="vm.service" class="padding-left-none" hide-date="true"></lineitem-image-display></div></div></div></div>');
$templateCache.put('app/areas/checkin/components/transportation-options/checkin-transportation-options.view.html','<div><h3 class="font-size-14 text-uppercase border-bottom padding-bottom-md"><div class="black">Transportation <span ng-if="vm.tripBooking.selectedTransportationType.description">- {{ vm.tripBooking.selectedTransportationType.description}}</span></div></h3><div ng-if="vm.appointment.tripId"><div ng-if="vm.tripBooking.selectedTransportationType.isPickup">Vehicle dropped off via Service Pickup #{{vm.appointment.tripId}}<div ng-if="vm.appointment.loanerConfirmationNumber">Loaner #{{ vm.appointment.loanerConfirmationNumber }}</div></div><div ng-if="vm.tripBooking.selectedTransportationType.isMobileGarage">Vehicle serviced via Mobile Service #{{vm.appointment.tripId}}</div></div><div ng-if="!vm.appointment.tripId"><div ng-if="vm.tripBooking.supports.shuttleOnDemand"><div class="display-flex content-center max-width-percent-45"><label class="display-flex content-center margin-bottom-none font-normal"><input class="margin-top-none margin-left-none margin-right-sm" type="radio" name="dropOffTransportationType" ng-model="vm.tripBooking.selectedTransportationEnum" ng-value="vm.transportationTypeEnum.shuttle" ng-change="vm.tripBooking.updateTransportation()"> <span>Shuttle</span></label><div class="flex-right display-flex content-center" ng-if="vm.tripBooking.supports.testTrips && vm.tripBooking.selectedTransportationEnum === vm.transportationTypeEnum.shuttle"><input name="isTestTrip" type="checkbox" ng-model="vm.tripBooking.isTest" class="margin-top-none"> <label for="isTestTrip" class="margin-bottom-none margin-left-sm">Test Trip</label></div></div><div ng-if="vm.tripBooking.selectedTransportationEnum === vm.transportationTypeEnum.shuttle" class="margin-left margin-top-md margin-bottom"><div class="margin-bottom-md" ng-repeat="shuttleOption in vm.tripBooking.scheduleOptions"><label class="display-flex content-center font-normal"><input type="radio" class="margin-top-none margin-left-none margin-right-sm" required="" name="shuttleOnDemandType" ng-model="vm.tripBooking.selectedShuttleType" value="{{shuttleOption.type}}"> <span>{{shuttleOption.detail}}</span></label><div class="margin-top-md margin-bottom-md margin-left block relative" ng-if="shuttleOption.type == vm.shuttleScheduleTypes.later && vm.tripBooking.selectedShuttleType == vm.shuttleScheduleTypes.later"><input type="text" id="shuttleCustomerPhone" name="shuttleCustomerPhone" required="" inputmode="numeric" autocomplete="nope" ng-model="vm.authorizationOptions.authorizeServicesPhone" class="form-control better-placeholder max-width-px-200" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="required:alt=Required"><inputvalidation-phone-type-indicator ng-if="vm.appointment.customerPhone" phone-number="vm.appointment.customerPhone"></inputvalidation-phone-type-indicator></div><div class="margin-top-md margin-bottom-md margin-left max-width-percent-65" ng-if="shuttleOption.type == vm.shuttleScheduleTypes.now && vm.tripBooking.selectedShuttleType == vm.shuttleScheduleTypes.now"><div class="block relative"><input type="text" ng-attr-placeholder="ENTER ADDRESS" id="shuttleLocation" name="shuttleLocation" required="" ng-model="vm.tripBooking.formattedLocation" class="form-control better-placeholder" details="vm.places" validation="required:alt=Required" here-places="" options="vm.tripBooking.hereAutocompleteOptions" handle-selected="vm.tripBooking.locationUpdated(formattedAddress)" validation-error-to="shuttleLocError" allow-create-new="true"> <span id="shuttleLocError" class="validation text-danger"></span></div><div class="margin-top-md"><div class="alert alert-danger" ng-if="vm.tripBooking.bookingError">{{vm.tripBooking.bookingError}}</div><div class="field-wrapper"><label for="ridetype">Choose Shuttle type</label><select id="ridetype" selectlabel="" required="" ng-disabled="!vm.tripBooking.providerRides || vm.tripBooking.providerRides.length === 0" class="form-control" name="rideSelect" ng-options="providerRide as (providerRide.displayName + \' - \' + vm.duration(providerRide.eta) + \' - $\' + providerRide.estimatedCost.toFixed(2) ) for providerRide in vm.tripBooking.providerRides" ng-model="vm.tripBooking.selectedProviderRide" ng-change="vm.tripBooking.providerRideSelected()"><option value="">Choose Shuttle type</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vm.loadingShuttleEstimates"></div></div><div class="lyft-ride-options" ng-if="vm.lyftRides">* Prices may change in {{ vm.lyftPollCountDownTimer }} seconds if a trip is not booked.</div></div></div></div></div><div class="margin-top-md" ng-if="vm.tripBooking.supports.loaner"><label class="display-flex content-center font-normal"><input class="margin-top-none margin-left-none margin-right-sm" type="radio" name="dropOffTransportationType" ng-model="vm.tripBooking.selectedTransportationEnum" ng-value="vm.transportationTypeEnum.dropOffLoaner" ng-change="vm.tripBooking.updateTransportation()"> <span>Loaner</span> <span class="margin-left-xs" ng-if="vm.appointment.loanerConfirmationNumber">#{{ vm.appointment.loanerConfirmationNumber }}</span></label></div><div class="margin-top-md" ng-if="vm.tripBooking.supports.waiter"><label class="display-flex content-center font-normal"><input class="margin-top-none margin-left-none margin-right-sm" type="radio" name="dropOffTransportationType" ng-model="vm.tripBooking.selectedTransportationEnum" ng-value="vm.transportationTypeEnum.waiter" ng-change="vm.tripBooking.updateTransportation()"> <span>Wait</span></label></div><div class="margin-top-md" ng-if="vm.tripBooking.supports.dropoff"><label class="display-flex content-center font-normal"><input class="margin-top-none margin-left-none margin-right-sm" type="radio" name="dropOffTransportationType" ng-model="vm.tripBooking.selectedTransportationEnum" ng-value="vm.transportationTypeEnum.dropOff" ng-change="vm.tripBooking.updateTransportation()"> <span>Drop off only (no transportation)</span></label></div></div><div class="margin-top-md" ng-if="vm.tripBooking.supports.rideShareCredits && !vm.tripBooking.selectedTransportationType.isMobileGarage"><label class="display-flex content-center font-normal" uib-popover="{{vm.tripBooking.selectedTransportationEnum === vm.transportationTypeEnum.shuttle ? \'Credits cannot be offered while also offering a Shuttle Ride\' : \'\'}}" popover-trigger="mouseenter" popover-placement="bottom-left"><input class="margin-top-none margin-left-none margin-right-sm" type="checkbox" name="offerRideshareCredit" ng-disabled="vm.tripBooking.selectedTransportationEnum === vm.transportationTypeEnum.shuttle" ng-model="vm.tripBooking.offerRideshareCredit"> <span>Offer Rideshare Credits</span></label><div class="display-flex content-center" ng-if="vm.tripBooking.offerRideshareCredit"><div><input date-range-picker="" id="lyft-credit-date-picker" name="lyft-credit-date-picker" class="form-control date-picker" required="" placeholder="EFFECTIVE DATES..." options="vm.tripBooking.datePickerOptions" type="text" ng-model="vm.tripBooking.rideshareCredit.timeframe" validation="required:alt=Required"></div><div class="margin-left-md block relative"><input type="text" id="credit_amount" name="credit_amount" ng-model="vm.tripBooking.rideshareCredit.creditAmount" class="form-control better-placeholder" placeholder="CREDIT AMOUNT" required="" format-currency-with-dollar="" validation="required:alt= |between_num: 0.01, 1000:alt=Must be valid dollar amount between $0.01 and $1000.00"></div></div></div></div><div class="margin-top-lg"><h3 class="font-size-14 text-uppercase border-bottom padding-bottom-md"><div class="black">Estimated Completion <span ng-if="vm.tripBooking.supports.inspect">and Keytag</span></div></h3><div class="display-flex content-center"><div class="input-group"><input type="text" id="promise-date" class="form-control better-placeholder padding-left-none white-bg text-center" placeholder="EST COMP DATE" ng-model="vm.appointmentBooking.promiseDate" moment-picker="" ng-disabled="vm.isLoading" disable="vm.isLoading" readonly="readonly" start-view="month" format="ddd MM/DD/YY" min-date="moment(vm.appointment.apptDateTime)" name="promise-date" selectable="vm.appointmentBooking.isDateSelectable(date, type)" change="vm.appointmentBooking.promiseDateChanged(newValue, oldValue)" required="required" validation="required:alt=Required" is-open="vm.isPromiseTimePickerOpen"> <span class="input-group-addon appointment-calendar" ng-click="vm.isPromiseTimePickerOpen = !vm.isPromiseTimePickerOpen" ng-class="{ \'cursor-pointer\': !vm.isLoading, \'cursor-disabled\' : vm.isLoading}"><i class="glyphicon glyphicon-calendar"></i></span></div><div class="block relative margin-left-md flex-width-120"><select class="form-control better-placeholder" name="promise-time" ng-options="time as time for time in vm.appointmentBooking.promiseTimeHours" ng-model="vm.appointmentBooking.promiseTime" placeholder="Est comp time" ng-change="vm.appointmentBooking.setPromiseDateTime()" validation="required:alt=Required" required="required"><option value=""></option></select></div><div ng-if="vm.tripBooking.supports.inspect" class="margin-left-md block relative"><input type="text" class="form-control better-placeholder" name="keyTag" ng-model="vm.appointmentBooking.keyTag" ng-required="vm.appointmentBooking.dmsRequiresHangTag" placeholder="KEYTAG" ng-class="{\'better-placeholder-active\': vm.appointmentBooking.promiseTime}" validation="custom:vm.appointmentBooking.validation.keyTag()"></div></div></div><div class="margin-top-lg"><h3 class="font-size-14 text-uppercase border-bottom padding-bottom-md"><div class="black">Authorization</div></h3><div><label class="display-flex content-center"><input type="radio" name="authorizationLocation" class="margin-top-none margin-left-none margin-right-sm" ng-model="vm.authorizationOptions.selectedFlowType" ng-value="vm.authorizationOptions.flowType.sendToCustomer" required=""> <span class="font-normal">Send to customer and continue</span></label><div class="block relative margin-bottom margin-left" ng-if="vm.authorizationOptions.selectedFlowType == vm.authorizationOptions.flowType.sendToCustomer"><input type="text" id="customer_homework_phone" name="customer_homework_phone" required="" inputmode="numeric" autocomplete="nope" ng-model="vm.authorizationOptions.authorizeServicesPhone" class="form-control better-placeholder max-width-px-200" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="required:alt=Required"></div></div><div><label class="display-flex content-center"><input type="radio" name="authorizationLocation" class="margin-top-none margin-left-none margin-right-sm" ng-model="vm.authorizationOptions.selectedFlowType" ng-value="vm.authorizationOptions.flowType.thisDevice" required=""> <span class="font-normal">Authorize on this device</span></label></div></div>');
$templateCache.put('app/areas/checkin/components/verify-customer/checkin-verify-customer.view.html','<div class="row border-bottom"><div class="col-sm-11 col-xs-10"><h3 class="font-size-14 font-normal"><div class="black">CONFIRM CUSTOMER DETAILS</div></h3></div></div><div class="row margin-top text-uppercase"><div class="col-xs-11"><div class="font-bold">{{vm.appointment.customerFirstName}} {{vm.appointment.customerLastName}}</div><div>{{vm.appointment.customerEmail}}</div></div></div><div class="row"><div class="col-xs-8 col-sm-4 margin-top-sm"><input type="text" id="mobile_phone_number" name="mobile_phone_number" required="" inputmode="numeric" ng-change="vm.mobilePhoneUpdated(vm.appointment.customerPhone)" autocomplete="nope" ng-model="vm.appointment.customerPhone" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="required"><inputvalidation-phone-type-indicator ng-if="vm.appointment.customerPhone" phone-number="vm.appointment.customerPhone"></inputvalidation-phone-type-indicator></div></div><div class="row border-bottom margin-top-30"><div class="col-sm-11 col-xs-12"><h3 class="font-size-14 font-normal"><div class="black">CONFIRM OR SELECT SERVICE ADVISOR</div></h3></div></div><div class="row margin-top-sm"><div class="col-xs-12 field-wrapper margin-top-sm col-sm-3"><label for="selectedDepartment">DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0" name="selectedDepartment" ng-model="vm.appointment.departmentId" required="" class="form-control" ng-options="dept.id as dept.name for dept in vm.dealerDepartments | filter: vm.activeDepartmentFilter" validation="required|custom:vm.validation.isValidDepartment():alt=Please pick a value from the list" ng-change="vm.departmentChanged()"><option value="">Department</option></select></div><div class="col-xs-12 col-sm-6 margin-top-sm field-wrapper"><label for="advisor">CHOOSE ADVISOR</label><select selectlabel="" id="advisor" name="advisor" class="form-control" ng-model="vm.selectedAdvisor" ng-disabled="!vm.appointment.departmentId" required="required" validation="required" ng-change="vm.advisorChanged()" ng-options="(adv.firstName ? adv.firstName + \' \' + adv.lastName : adv.lastName) + vm.getAdvisorAvailTime(adv) for adv in vm.serviceAdvisors track by adv.id"><option value="">Choose advisor</option></select></div></div>');
$templateCache.put('app/areas/checkin/components/verify-vehicle/checkin-verify-vehicle.view.html','<div class="row border-bottom"><div class="col-sm-11 col-xs-10"><h3 class="font-size-14 font-normal"><div class="black">VEHICLE DETAILS</div></h3></div></div><div class="row margin-top text-uppercase"><div class="col-xs-11"><b><div>{{vm.appointment.year}} {{vm.appointment.make}} {{vm.appointment.model}}</div></b></div></div><div class="row"><div class="col-xs-9 col-sm-4 margin-top-sm override-xs-margin-bottom-md padding-right-none"><input type="text" id="vin" name="vin" clean="true" maxlength="17" autocomplete="nope" ng-model="vm.appointment.vin" class="form-control better-placeholder" placeholder="VIN" ng-model-options="{ debounce: 1000 }" ng-change="vm.checkValidVin()" required="" validation="required:max_len:17|custom:vm.validation.validVin(vm.appointment.vin):alt=*"> <span class="input-append-icon"><button type="button" class="btn btn-text-only padding-top-xs padding-right-none" ng-click="vm.openVinScan()" title="Scan VIN"><i class="material-symbols-outlined">barcode_scanner</i></button></span></div><div class="col-xs-7 col-sm-4 margin-top-sm padding-right-none"><input type="text" id="odometer" name="odometer" clean="true" autocomplete="nope" inputmode="numeric" required="required" validation="required|custom: vm.validation.validOdometer():alt={{vm.odometerError || \'*\'}}" mask="9?9?9?9?9?9?9?9?9" mask-restrict="reject" ng-model="vm.appointment.mileage" ng-change="vm.checkValidOdometer(vm.appointment.mileage)" class="form-control no-spinners better-placeholder" placeholder="ODOMETER"></div><div class="col-sm-2 col-xs-2 field-wrapper margin-top-sm override-xs-padding-right-none"><label for="odometer_type" class="on">Mi/Km</label><select id="odometer_type" name="odometer_type" ng-model="vm.appointment.mileageType" selectlabel="" placeholder="Mi/Km" required="required" ng-options="measurement as measurement.abbreviation for measurement in vm.odometerTypes track by measurement.type" class="form-control"></select></div></div><div class="row border-bottom margin-top-30"><div class="col-xs-12"><h3 class="font-size-14 font-normal text-uppercase"><div class="black">VEHICLE CONDITION</div></h3></div></div><div class="row margin-top"><div class="col-xs-11"><b><div>DAMAGE AND ISSUES</div></b><div>Indicate any specific issues found on the vehicle below</div></div></div><div class="row" ng-if="vm.vehicleConditions.length > 0"><div class="col-xs-12 margin-bottom padding-top-md" ng-repeat="issue in vm.vehicleConditions" ng-class="{\'border-top\': $index !== 0}"><div class="row"><div class="col-xs-12 margin-bottom-md">{{ issue.description }}<span class="pull-right theme-link multiple-generic-link generic-delete-link inline" ng-if="!vm.isLoading" ng-click="vm.removeVehicleCondition($index)">DELETE</span></div></div><div class="image-grid w-85 h-85"><div class="grid-item" ng-repeat="image in issue.images track by $index" ng-if="issue.images[$index].imageId"><div class="small-grey-boxes position-relative"><img class="position-relative image-container" ng-if="vm.getMediaType(issue.images[$index].fileExtension) === vm.mediaTypes.photo" ng-src="{{issue.images[$index].url}}" ng-click="vm.openImageModal(issue.images[$index].url, issue.description + \'#\' + ($index + 1), vm.mediaTypes.photo)"><video class="position-relative image-container" ng-if="vm.getMediaType(issue.images[$index].fileExtension) === vm.mediaTypes.video" ng-src="{{issue.images[$index].url}}" ng-click="vm.openImageModal(issue.images[$index].url, issue.description + \'#\' + ($index + 1), vm.mediaTypes.video)"></video><span ng-click="vm.openImageModal(issue.images[$index].url, issue.description + \'#\' + ($index + 1), vm.mediaTypes.video)" class="overlay" ng-if="vm.getMediaType(issue.images[$index].fileExtension) === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center font-size-10" ng-if="issue.images[$index].dateTaken">{{ issue.images[$index].dateTaken | localDate:\'MMM D h:mm A\' }}</div></div><div class="grid-item"><div ng-if="issue.description"><drag-drop-image ng-model="vm.imageToUpload" class="small-grey-boxes" use-icon="true" placeholder="Add Photo" repeat-container="issue.images" on-load="vm.upload" allow-video="true" drop-reference="issue" large="" loading-text="UPLOADING IMAGE" error-text="" media-limit="1" is-version-2="true"></drag-drop-image></div></div></div></div></div><div class="row margin-bottom"><div class="col-sm-10 col-xs-9 margin-top"><input type="text" id="description" name="description" class="form-control better-placeholder" ng-model="vm.newIssueDescription" placeholder="ENTER NEW ISSUE DESCRIPTION"></div><div class="col-sm-2 col-xs-3 padding-left-none margin-top"><button id="condition-add-new" type="button" class="btn btn-default text-uppercase" ng-click="vm.addDescription()" ng-disabled="!vm.newIssueDescription">Add</button></div></div><input type="hidden" id="image-validation" name="image-validation" validate-on-empty="true" validation="custom: vm.validation.validatePredefinedImages():alt=*" ng-model="vm.predefinedImages"><div class="row" ng-repeat="predefinedItem in vm.predefinedImages"><div class="col-xs-12 margin-bottom margin-top-20"><div class="row"><div class="col-xs-12 margin-bottom-md"><b><div class="text-uppercase">{{predefinedItem.categoryDesc}} - {{predefinedItem.mediaType === "1" ? \'PHOTOS\' : \'VIDEOS\'}}</div></b> <b class="font-normal text-danger" ng-show="predefinedItem.isRequired">REQUIRED</b><div>Capture the {{predefinedItem.mediaType === "1" ? \'images\' : \'videos\'}} specified below</div></div></div><div class="image-grid w-80 h-80"><div class="grid-item" ng-repeat="itemImage in predefinedItem.images track by $index"><div ng-if="itemImage.imageId"><div class="small-grey-boxes position-relative"><img class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.photo" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url,predefinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.photo, itemImage.id)"><video class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, predefinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.video, itemImage.id)"></video><span ng-click="vm.openImageModal(itemImage.url, predefinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.video, itemImage.id)" class="overlay" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div></div><div ng-if="!itemImage.imageId"><drag-drop-image ng-model="vm.imageToUpload" class="small-grey-boxes" use-icon="true" video-icon="predefinedItem.mediaType !== \'1\'" placeholder="{{predefinedItem.mediaType !== \'1\' ? \'Add Video\' : \'Add Photo\'}}" on-load="vm.uploadPredefinedImage" allow-video="true" drop-reference="itemImage" large="" loading-text="UPLOADING IMAGE" error-text="" media-type="{{predefinedItem.mediaType}}" media-limit="1" is-version-2="true"></drag-drop-image></div><div class="text-center font-size-10">{{ itemImage.description }}</div></div></div></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/booking.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><div class="form-horizontal" ng-class="{\'no-pickups\':!vm.defaultPickupTripType }"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.smsNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div class="margin-bottom-20 appointment-header-map" ng-if="vm.showTheMap()"><div consumer-appointment-map="" dealer="vm.dealer" ng-if="vm.appointment" pickup="vm.pickupLocation" ng-class="{\'hidden-xs\': vm.showMapInMobile === false}"></div><img ng-if="vm.showMapInMobile === false" ng-src="{{vm.headerImageUrl}}" class="visible-xs full-width"></div><div ng-if="vm.dealerConfigured() === false"><center><h2>An error has occurred loading the page.</h2><br><h3>Please contact your dealer at {{ vm.dealer.mainPhoneNumber | tel }} to book your appointment.</h3><br><span ng-if="!vm.apptConsumerDepartmentId || vm.apptConsumerDepartmentId.length === 0">Err: no_dept_conf</span> <span ng-if="!vm.genericLineItem || vm.genericLineItem.opCode === \'\'">Err: no_generic_conf</span></center></div><div ng-if="vm.dealerConfigured() === true" class="margin-left-20 margin-right-20 consumer-appointments-content"><div ng-if="!vm.appointment || vm.loading"><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-12 well-lg text-center"><img src="assets/images/ajax-loader.gif"> Loading Appointment Details...</div></div></div><div class="col-xs-12" ng-show="vm.currentState.id === vm.stateId.vehicle && !vm.loading"><div class="row margin-bottom-md"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.consumerCustomerInfoTitle">Vehicle Owner Information</div><div ng-bind-html="vm.loginEvent === \'guest\' ? vm.configValues.consumerCustomerInfoParagraphGuest : vm.configValues.consumerCustomerInfoParagraph"></div></div><div class="row"><div consumer-appointment-edit-vehicle-owner-information="" ng-if="vm.appointment" appointment="vm.appointment" dealer="vm.dealer" requiredfields="vm.requiredDMSFields" ghost-garage="0" form="vm.vehicleOwnerForm" vehicle-form-submitted="vm.vehicleFormSubmitted"></div></div><div class="row margin-bottom-30"><div consumer-appointment-edit-vehicle-information="" dealer="vm.dealer" ng-if="vm.appointment" appointment="vm.appointment" vehicles="vm.customerVehicles" initialvehicleselected="vm.vehicleSelected" vehicleformsubmitted="vm.vehicleFormSubmitted" ghost-garage="0" form="vm.vehicleInformationForm"></div></div></div><div class="col-xs-12" ng-show="vm.currentState.id === vm.stateId.services && !vm.loading" ng-class="{\'generic-service-disabled\': vm.genericConsumerServiceEnabled === false}"><div class="row margin-bottom"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.consumerMobileChooseServicesTitle"></div><div ng-bind-html="vm.updateYMM(vm.configValues.consumerMobileChooseServicesParagraph)"></div></div><div class="row margin-bottom-30"><div consumer-appointment-choose-services="" dealer-departments="vm.dealerDepartments" dealer="vm.dealer" dealeropcodes="vm.dealerOpCodes" gettingservices="vm.gettingServices()" disableserviceselection="vm.disableServiceSelection" otherservicestitle="vm.apptConsumerOtherServicesTitle" previouslydeclinedtitle="vm.apptPreviouslyDeclinedtitle" recalls="vm.recalls" recmaintdata="vm.recMaintData" recmaintdisclaimer="vm.recMaintDisclaimer" originallineitems="vm.originalAppointmentLineItems" previouslydeclinedservices="vm.previouslyDeclinedServices" dealer-integrations="vm.dealerIntegrations" ghost-garage="0" ranked-departments="vm.rankedDepartments" ng-if="vm.appointment" appointment="vm.appointment" form="vm.vehicleServicesForm"></div></div></div><div class="col-xs-12" ng-if="vm.currentState.id === vm.stateId.services && vm.currentState.submitted"><div class="row padding-md validation text-danger" ng-if="vm.vehicleServicesForm.$error.required.length > 0 || vm.vehicleServicesForm.$error.hasAnyServices">Please select at least one service<span ng-if="vm.genericConsumerServiceEnabled === true">, or describe services you need in the text box above</span>.</div><div class="row padding-md validation text-danger" ng-if="vm.vehicleServicesForm.$error.appointmentRecallsAreValid.length > 0">Too many recalls were added to this appointment. Please adjust the selected recalls.</div></div><div class="col-xs-12" ng-show="vm.currentState.id === vm.stateId.appointment && !vm.loading"><div class="row margin-bottom-30"><div class="text-uppercase consumer-header-text" ng-if="vm.appointment && vm.appointment.lineItems && vm.appointment.lineItems.length > 0" ng-bind-html="vm.configValues.consumerMobileDetailsTitle"></div><div ng-bind-html="vm.configValues.consumerMobileDetailsParagraph"></div><div consumer-appointment-edit-appointment-details="" dealer="vm.dealer" trip-types="vm.tripTypes" originalappointmenthasloaner="vm.originalAppointmentHasLoaner" config-values="vm.configValues" trip-type="vm.tripType" transmissions="vm.transmissions" pickup-location="vm.pickupLocation" lastserviceadvisor="vm.lastServiceAdvisor" defaulttopreviousadvisor="vm.defaultToPreviousAdvisor" ng-if="vm.appointment" detailsformsubmitted="vm.detailsFormSubmitted" ghost-garage="0" department="vm.department" department-hours="vm.departmentHours" department-constraints="vm.processedClosedConstraints" appointment="vm.appointment" form="vm.appointmentForm"></div></div></div><div class="col-xs-12" ng-if="vm.currentState.id === vm.stateId.confirmation"><div class="row margin-bottom-30"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.consumerBookingConfirmationTitle"></div><div ng-bind-html="vm.configValues.consumerBookingConfirmationParagraph"></div><div consumer-appointment-view-appointment-details="" ng-if="vm.appointment" trip-types="vm.tripTypes" dealer="vm.dealer" appointment="vm.appointment" trip-type="vm.tripType" previouslydeclinedservices="vm.previouslyDeclinedServices"></div><div class="padding-top-lg"><label class="full-width"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" name="confirm" ng-model="vm.confirmation" ng-required="vm.currentState.id === vm.stateId.confirmation" validation="required"></div><div class="col-xs-11 padding-left-none"><span ng-bind-html="vm.termsAndConditionsText"></span><div class="validation text-danger margin-bottom" ng-if="vm.showTermsWarning()">You must agree to the terms and conditions before continuing.</div></div></div></label></div><div ng-if="vm.customerPhoneType.type !== vm.phoneTypes.landline"><label class="full-width"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" name="confirmTextOptIn" ng-model="vm.appointment.mobileSmsOptedIn" ng-required="vm.currentState.id === vm.stateId.confirmation" validation="required"></div><div class="col-xs-11 padding-left-none"><span ng-bind-html="vm.textOptInText"></span><div class="validation text-danger margin-bottom" ng-if="vm.showTextOptInWarning()">You must agree to receive text messages before continuing.</div><div class="validation text-danger margin-bottom" ng-if="vm.customerPhoneType.isOptedOut === true && vm.appointment.mobileSmsOptedIn === true">Note customer has previously opted out of receiving text messages. Please inform them to send START to {{vm.customerPhoneType.dealerPhone | tel}} in order to receive text messages.</div></div></div></label></div><div class="validation text-danger margin-bottom" ng-if="vm.customerPhoneType.type === vm.phoneTypes.landline">Note the customer phone number is a landline and is unable to receive text messages.</div></div></div><div class="col-xs-12" ng-show="vm.currentState.id === vm.stateId.changeDepartment"><div class="row margin-bottom"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.consumerChooseDifferentDepartmentTitle"></div><div class="row"><div class="col-xs-10"><div ng-bind-html="vm.updateYMM(vm.configValues.consumerChooseDifferentDepartmentParagraph)"></div></div><div class="col-xs-2 text-right change-dept-cancelcol"><button id="back-btn" type="button" class="btn btn-rounded min-75" ng-click="vm.cancelChangeDepartment()">CANCEL</button></div></div></div><div class="row margin-bottom-30"><div consumer-appointment-landing-choose-department-transportation="" ng-repeat="department in vm.rankedDepartments | filter: {showInConsumer: true} | orderBy: \'rank\'" department="department" button-text="vm.chooseDeptButtonText" dealer="vm.dealer" transportation-types="vm.resolvedConsumerTripTypes" branding="vm.branding" appointment="vm.appointment" pickup="vm.pickupLocation" is-landing="false" dealer-op-codes="vm.dealerOpCodes" dealer-departments="vm.dealerDepartments" previously-declined-services="vm.previouslyDeclinedServices"></div></div></div><div class="col-xs-12" ng-if="!vm.loading && vm.currentState.id !== vm.stateId.changeDepartment"><div class="row" ng-if="vm.displayCapacityErrorMessaging"><div class="col-xs-1"></div><div class="col-xs-10 validation error">The previously selected date/time is no longer available due to recent changes.&nbsp;<div class="theme link inline" ng-click="vm.startOver()"><u><b>Click here</b></u></div>&nbsp;to start over and undo the changes or select an available date and time above and click NEXT below.</div><div class="col-xs-1"></div></div><div class="row margin-top-30 navigation-buttons" ng-if="!vm.validatingCapacity"><div ng-if="vm.currentState.id == vm.stateId.appointment" class="col-md-2 hidden-xs"></div><button id="back-btn" type="button" class="btn btn-rounded min-75" ng-click="vm.previousStep()" ng-if="vm.currentState.previousState != null">BACK</button> <button type="button" class="btn btn-rounded btn-primary min-75" ladda="vm.loading || vm.busy" ng-click="vm.nextStep()" ng-if="vm.currentState.nextState != null && !vm.displayCapacityErrorMessaging">NEXT</button> <button type="button" class="btn btn-rounded btn-primary min-75" ladda="vm.loading" ng-click="vm.createAppointment()" ng-if="vm.currentState.id === vm.stateId.confirmation && (vm.appointment.appointmentId == null || vm.appointment.appointmentId == \'\')">Book Appointment</button> <button type="button" class="btn btn-rounded btn-primary min-75" ladda="vm.loading" ng-click="vm.createAppointment()" ng-if="vm.currentState.id === vm.stateId.confirmation && (vm.appointment.appointmentId != null && vm.appointment.appointmentId != \'\')">Update&nbsp;Appointment</button></div></div></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/confirmation.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><div class="form-horizontal"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.smsNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div class="margin-bottom-20 appointment-header-map" ng-if="vm.showTheMap()"><div consumer-appointment-map="" dealer="vm.dealer" pickup="vm.pickupLocation" maxheight="vm.maxHeight" show-pickup="vm.tripType.isPickup" ng-class="{\'hidden-xs\': vm.showMapInMobile === false}"></div><img ng-if="vm.showMapInMobile === false" ng-src="{{vm.headerImageUrl}}" class="visible-xs full-width"></div><div class="margin-left-20 margin-right-20 consumer-appointments-content confirmation-page"><div ng-if="vm.loading"><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-12 well-lg text-center"><img src="assets/images/ajax-loader.gif"> Loading Appointment Details...</div></div></div><div ng-if="!vm.loading && vm.errorLoadingAppointment === true"><div class="row"><div class="col-xs-12"><div class="consumer-header-text">We\'re Sorry</div>There was an error loading the requested appointment.</div></div></div><div class="margin-top-30" ng-if="!vm.loading && vm.appointment"><div class="row"><div class="col-xs-12"><div ng-if="vm.appointment.appointmentStatus === vm.canceledStatus" class="text-uppercase consumer-header-text">Appointment Cancelled</div><div ng-if="vm.appointment.appointmentStatus !== vm.canceledStatus" class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.consumerBookingConfirmationTitle2"></div><p ng-if="vm.appointment.appointmentStatus !== vm.canceledStatus" ng-bind-html="vm.configValues.consumerMobileConfirmationParagraph"></p><p ng-if="vm.appointment.appointmentStatus === vm.canceledStatus" ng-bind-html="vm.configValues.apptConsumerCanceledParagraph"></p></div></div><div class="row margin-bottom-30"><div class="col-xs-12"><div consumer-appointment-view-appointment-details="" dealer="vm.dealer" trip-types="vm.tripTypes" appointment="vm.appointment" trip-type="vm.tripType" dealer-integrations="vm.dealerIntegrations" credit="vm.credit"></div></div></div><div><a target="_blank" class="theme-link font-size-12" ui-sref="consumer-terms-page({ dealerId: vm.dealer.dealerId, tripTypeId: vm.sysEnums.systemTripType.appointment, appType: vm.appTypes.appointment })"><u>Terms and Conditions</u></a></div><div ng-if="!vm.loading && vm.errorLoadingAppointment !== true" class="row margin-top-30 margin-bottom-30"><div class="col-xs-12 margin-bottom-30" ng-if="vm.appointment.appointmentStatus !== vm.canceledStatus"><button type="button" class="btn btn-rounded" ladda="vm.loadingCancel" ng-if="!vm.loadingEdit" ng-disabled="!vm.appointment.canCancel" ng-click="vm.cancelAppointment()">CANCEL</button> <button type="button" class="btn btn-rounded btn-primary" ladda="vm.loadingEdit" ng-if="!vm.loadingCancel" ng-disabled="!vm.appointment.canEdit" ng-click="vm.editAppointment()">EDIT</button></div><div ng-if="vm.appointment.dmsOutOfSync === true" class="consumer-out-of-sync pull-right"><i class="material-icons md-18" title="OUT OF SYNC WITH DMS">outline-warning</i></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/ghostgarage-booking.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><div class="form-horizontal ghost-garage-booking" ng-class="{\'no-pickups\':!vm.defaultPickupTripType }"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.smsNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div class="margin-bottom-20 appointment-header-map" ng-if="vm.showTheMap()"><div consumer-appointment-map="" dealer="vm.dealer" ng-if="vm.appointment" pickup="vm.pickupLocation" ng-class="{\'hidden-xs\': vm.showMapInMobile === false}"></div><img ng-if="vm.showMapInMobile === false" ng-src="{{vm.headerImageUrl}}" class="visible-xs full-width"></div><div ng-if="vm.dealerConfigured() === false"><center><h2>An error has occurred loading the page.</h2><br><h3>Please contact your dealer at {{ vm.dealer.mainPhoneNumber | tel }} to book your appointment.</h3><br><span ng-if="!vm.apptConsumerDepartmentId || vm.apptConsumerDepartmentId.length === 0">Err: no_dept_conf</span> <span ng-if="vm.genericLineItem.showInConsumer === true && vm.genericLineItem.opCode === \'\'">Err: no_generic_conf</span> <span ng-if="!vm.tripType">Err: no_pickup_triptype</span></center></div><div ng-if="vm.dealerConfigured() === true" class="margin-left-20 margin-right-20 consumer-appointments-content"><div ng-if="!vm.appointment || vm.loading"><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-12 well-lg text-center"><img src="assets/images/ajax-loader.gif"> Loading Appointment Details...</div></div></div><div class="col-xs-12" ng-show="vm.currentState.id === vm.stateId.services && !vm.loading" ng-class="{\'generic-service-disabled\': vm.genericConsumerServiceEnabled === false}"><div class="row margin-bottom" id="services-title-row"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.apptConsumerAltBookingServicesTitle"></div><div ng-bind-html="vm.updateYMM(vm.configValues.apptConsumerAltBookingServicesParagraph)"></div></div><div class="row margin-bottom-30"><div consumer-appointment-choose-services="" dealer-departments="vm.dealerDepartments" dealer="vm.dealer" dealeropcodes="vm.dealerOpCodes" gettingservices="vm.gettingServices()" otherservicestitle="vm.apptConsumerAlternateServicesTitle" previouslydeclinedtitle="vm.apptPreviouslyDeclinedtitle" recalls="vm.recalls" recmaintdata="vm.recMaintData" recmaintdisclaimer="vm.recMaintDisclaimer" originallineitems="vm.originalAppointmentLineItems" previouslydeclinedservices="vm.previouslyDeclinedServices" dealer-integrations="vm.dealerIntegrations" ghost-garage="1" ng-if="vm.appointment" appointment="vm.appointment" form="vm.vehicleServicesForm"></div></div></div><div class="col-xs-12" ng-if="vm.currentState.id === vm.stateId.services && vm.currentState.submitted"><div class="row padding-md validation text-danger" ng-if="vm.vehicleServicesForm.$error.required.length > 0 || vm.vehicleServicesForm.$error.hasAnyServices">Please select at least one service<span ng-if="vm.genericConsumerServiceEnabled === true">, or describe services you need in the text box above</span>.</div><div class="row padding-md validation text-danger" ng-if="vm.vehicleServicesForm.$error.appointmentRecallsAreValid.length > 0">Too many recalls were added to this appointment. Please adjust the selected recalls.</div></div><div class="col-xs-12" ng-show="vm.currentState.id === vm.stateId.appointment && !vm.loading"><div ng-cloak="" class="row margin-top" ng-if="vm.appointment && vm.appointment.lineItems && vm.appointment.lineItems.length > 0"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12 padding-top-md padding-left-none"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.apptConsumerAltPickupTitle"></div><div ng-bind-html="vm.configValues.apptConsumerAltPickupParagraph"></div></div></div><div class="row margin-bottom-30"><div consumer-appointment-edit-appointment-details="" dealer="vm.dealer" trip-types="vm.tripTypes" originalappointmenthasloaner="vm.originalAppointmentHasLoaner" config-values="vm.configValues" trip-type="vm.tripType" transmissions="vm.transmissions" pickup-location="vm.pickupLocation" defaulttopreviousadvisor="vm.defaultToPreviousAdvisor" ng-if="vm.appointment" ghost-garage="1" department="vm.appointment.department" department-hours="vm.departmentHours" department-constraints="vm.processedClosedConstraints" detailsformsubmitted="vm.detailsFormSubmitted" appointment="vm.appointment" form="vm.appointmentForm"></div></div></div><div class="col-sm-8 col-xs-12 ng-hide" ng-show="vm.currentState.id === vm.stateId.vehicle && !vm.loading"><div class="row margin-bottom-md"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.apptConsumerAltCustomerDetailsTitle"></div><div ng-bind-html="vm.configValues.apptConsumerAltCustomerDetailsParagraph"></div></div><div class="row"><div consumer-appointment-edit-vehicle-owner-information="" ng-if="vm.appointment" appointment="vm.appointment" dealer="vm.dealer" requiredfields="vm.requiredDMSFields" ghost-garage="1" form="vm.vehicleOwnerForm" vehicle-form-submitted="vm.vehicleFormSubmitted"></div></div><div class="row margin-bottom-30"><div consumer-appointment-edit-vehicle-information="" dealer="vm.dealer" ng-if="vm.appointment" appointment="vm.appointment" vehicleformsubmitted="vm.vehicleFormSubmitted" ghost-garage="1" form="vm.vehicleInformationForm"></div></div></div><div class="col-sm-4 col-xs-12 ng-hide" ng-show="vm.currentState.id === vm.stateId.vehicle && !vm.loading"><calendar-post-it-note title="vm.calendarTitle" date="vm.appointment.tripPickupTime || vm.appointment.apptDateTime"></calendar-post-it-note></div><div class="col-xs-12" ng-if="vm.currentState.id === vm.stateId.confirmation"><div class="row margin-bottom-30"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.consumerBookingConfirmationTitle"></div><div ng-bind-html="vm.configValues.consumerBookingConfirmationParagraph"></div><div consumer-appointment-view-appointment-details="" ng-if="vm.appointment" trip-types="vm.tripTypes" dealer="vm.dealer" appointment="vm.appointment" trip-type="vm.tripType" previouslydeclinedservices="vm.previouslyDeclinedServices"></div><div class="padding-top-lg"><label class="full-width"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" name="confirm" ng-model="vm.confirmation" ng-required="vm.currentState.id === vm.stateId.confirmation" validation="required"></div><div class="col-xs-11 padding-left-none"><span ng-bind-html="vm.termsAndConditionsText"></span><div class="validation text-danger margin-bottom" ng-if="vm.showTermsWarning()">You must agree to the terms and conditions before continuing.</div></div></div></label></div><div ng-if="vm.customerPhoneType.type !== vm.phoneTypes.landline"><label class="full-width"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" name="confirmTextOptIn" ng-model="vm.appointment.mobileSmsOptedIn" ng-required="vm.currentState.id === vm.stateId.confirmation" validation="required"></div><div class="col-xs-11 padding-left-none"><span ng-bind-html="vm.textOptInText"></span><div class="validation text-danger margin-bottom" ng-if="vm.showTextOptInWarning()">You must agree to receive text messages before continuing.</div><div class="validation text-danger margin-bottom" ng-if="vm.customerPhoneType.isOptedOut === true && vm.appointment.mobileSmsOptedIn === true">Note customer has previously opted out of receiving text messages. Please inform them to send START to {{vm.customerPhoneType.dealerPhone | tel}} in order to receive text messages.</div></div></div></label></div><div class="validation text-danger margin-bottom" ng-if="vm.customerPhoneType.type === vm.phoneTypes.landline">Note the customer phone number is a landline and is unable to receive text messages.</div></div></div><div class="col-md-1 hidden-xs" ng-show="vm.currentState.id === vm.stateId.appointment"></div><div class="col-xs-12" ng-if="!vm.loading && vm.hideButtons === false" ng-class="{\'col-md-10\': vm.currentState.id === vm.stateId.appointment }"><div class="row" ng-if="vm.displayCapacityErrorMessaging"><div class="col-xs-1"></div><div class="col-xs-10 validation error">The previously selected date/time is no longer available due to recent changes.&nbsp;<div class="theme link inline" ng-click="vm.startOver()"><u><b>Click here</b></u></div>&nbsp;to start over and undo the changes or select an available date and time above and click NEXT below.</div><div class="col-xs-1"></div></div><div class="row margin-top-30 navigation-buttons"><button id="back-btn" type="button" class="btn btn-rounded min-75" ng-click="vm.previousStep()" ng-if="vm.currentState.previousState != null">BACK</button> <button type="button" class="btn btn-rounded btn-primary min-75" ladda="vm.loading" ng-click="vm.nextStep()" ng-if="vm.currentState.nextState != null && !vm.displayCapacityErrorMessaging">NEXT</button> <button type="button" class="btn btn-rounded btn-primary min-75" ladda="vm.loading" ng-click="vm.createAppointment()" ng-if="vm.currentState.id === vm.stateId.confirmation && (vm.appointment.appointmentId == null || vm.appointment.appointmentId == \'\')">Book Appointment</button> <button type="button" class="btn btn-rounded btn-primary min-75" ladda="vm.loading" ng-click="vm.createAppointment()" ng-if="vm.currentState.id === vm.stateId.confirmation && (vm.appointment.appointmentId != null && vm.appointment.appointmentId != \'\')">Update&nbsp;Appointment</button></div></div></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/landing.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-class="{\'hideLoanerText\': !vm.displayLoanerSections}"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.smsNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div class="margin-bottom-20" ng-if="vm.loadingPage === true"><div class="padding-md"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> LOADING</span></div></div><div class="margin-bottom-20 appointment-header-map" ng-if="vm.showTheMap() && vm.loadingPage === false"><div consumer-appointment-map="" dealer="vm.dealer" pickup="vm.pickupLocation" ng-class="{\'hidden-xs\': vm.showMapInMobile === false}"></div><img ng-if="vm.showMapInMobile === false" ng-src="{{vm.headerImageUrl}}" class="visible-xs full-width"></div><div ng-if="vm.dealerConfigured() === false"><center><h2>An error has occurred loading the page.</h2><br><h3>Please contact your dealer at {{ vm.dealer.mainPhoneNumber | tel }} to book your appointment.</h3><br><span ng-if="!vm.apptConsumerDepartmentId || vm.apptConsumerDepartmentId.length === 0">Err: no_dept_conf</span> <span ng-if="!vm.genericLineItem || vm.genericLineItem.opCode === \'\'">Err: no_generic_conf</span></center></div><div ng-if="vm.dealerConfigured() === true" class="margin-left-20 margin-right-20 consumer-appointments-content"><div ng-if="vm.step == \'selectServiceType\'"><div ng-bind-html="vm.title" class="text-uppercase text-center consumer-header-text margin-bottom"></div><p ng-if="vm.description && vm.description.length > 0" class="margin-bottom-30" ng-bind-html="vm.description"></p><div class="row"><div class="col-xs-12" ng-if="vm.useStandardLandingPage() === false"><div consumer-appointment-landing-choose-department-transportation="" ng-if="vm.hasDeparmentRanking === false" department="vm.defaultDepartment" transportation-types="vm.resolvedConsumerTripTypes" branding="vm.branding" dealer="vm.dealer" dealer-departments="vm.dealerDepartments" is-landing="true"></div><div consumer-appointment-landing-choose-department-transportation="" ng-if="vm.hasDeparmentRanking === true" ng-repeat="department in vm.rankedDepartments | filter: {showInConsumer: true} | orderBy: \'rank\'" department="department" dealer="vm.dealer" transportation-types="vm.resolvedConsumerTripTypes" branding="vm.branding" dealer-departments="vm.dealerDepartments" is-landing="true"></div><div class="panel consumer-appt-panel"><div class="row"><div class="col-sm-9 col-xs-12"><div class="text-uppercase consumer-header-text margin-top-sm">VIEW OR EDIT AN EXISTING APPOINTMENT</div></div><div class="col-sm-3 col-xs-12 text-right override-xs-margin-top-md"><div><button class="btn btn-rounded btn-primary text-uppercase" ladda="vm.loading" ng-click="vm.getStarted(\'existing\')">Get started</button></div></div></div></div></div><div class="col-xs-12" ng-if="vm.useStandardLandingPage() === true"><ul class="appointment-landing-ul"><li ng-if="vm.defaultPickupTripType"><label class="radio-inline"><input type="radio" name="appointmentType" ng-model="vm.tripType" ng-value="vm.defaultPickupTripType"><div for="pickup" class="text-uppercase consumer-subheader-text font-bold margin-bottom" ng-bind-html="vm.firstChoiceTitle"></div><p ng-bind-html="vm.firstChoiceDescription"></p><div consumer-appointment-choose-pickup="" dealer="vm.dealer" department="vm.defaultDepartment" trip-type="vm.tripType" clean-input="true" ng-if="vm.tripType === vm.defaultPickupTripType"></div><div ng-if="vm.tripType === vm.defaultPickupTripType && vm.pickupLocation.isInServiceArea === false" class="padding-left-lg margin-top-sm validation text-danger radio-validation">We\'re sorry, this address is out of our pickup area. Please choose a different address or select YOU BRING IN YOUR VEHICLE below.</div><div class="margin-top" ng-if="vm.tripType === vm.defaultPickupTripType"><button class="btn btn-rounded btn-primary text-uppercase" ladda="vm.loading" ng-disabled="vm.disableGetStarted()" ng-click="vm.getStarted(vm.tripType)">Get started</button></div></label></li><li ng-if="vm.defaultDropoffTripType"><label class="radio-inline"><input type="radio" name="appointmentType" ng-model="vm.tripType" ng-value="vm.defaultDropoffTripType"><div for="dropoff" class="text-uppercase consumer-subheader-text font-bold margin-bottom" ng-bind-html="vm.secondChoiceTitle"></div><p ng-bind-html="vm.secondChoiceDescription"></p><div class="margin-top" ng-if="vm.tripType === vm.defaultDropoffTripType"><button class="btn btn-rounded btn-primary text-uppercase" ladda="vm.loading" ng-disabled="vm.disableGetStarted()" ng-click="vm.getStarted(vm.tripType)">Get started</button></div></label></li><li><label class="radio-inline"><input type="radio" name="appointmentType" ng-model="vm.tripType" ng-value="\'existing\'"><div for="existing" class="text-uppercase consumer-subheader-text font-bold margin-bottom" ng-bind-html="vm.thirdChoiceTitle"></div><p ng-bind-html="vm.thirdChoiceDescription"></p><div class="margin-top" ng-if="vm.tripType === \'existing\'"><button class="btn btn-rounded btn-primary text-uppercase" ladda="vm.loading" ng-disabled="vm.disableGetStarted()" ng-click="vm.getStarted(vm.tripType)">Get started</button></div></label></li></ul></div></div></div><div ng-if="vm.step == \'customerLogin\'" class="text-center"><div class="col-sm-12"><div consumer-appointment-customer-login="" loading="vm.loading" dealer="vm.dealer" flow="vm.flow" class="customer-login"></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/inspect/views/inspection-media-upload-list.view.html','<div class="media-upload-list-container"><div class="bg-primary-dark font-size-15 padding-md text-white display-flex flex-row justify-content align-items-center"><div><div class="text-bold">#{{vm.ro.dmsRepairOrderNumber || vm.ro.id}}</div><div class="font-size-13 text-uppercase">{{vm.ro.vehicle.year}} {{vm.ro.vehicle.make}} {{vm.ro.vehicle.model}}</div><div class="font-size-12">{{vm.ro.vehicle.vin | limitTo: 17}}</div></div><a class="text-warning font-size-13 font-bold cursor-pointer margin-bottom-30" ng-click="vm.goToInspect()">GO TO INSPECT</a></div><div class="col-xs-12 margin-sm padding-md font-size-14"><div class="display-flex flex-row border-bottom"><span class="text-align-left font-bold">TASK</span> <span class="text-align-right flex-fullwidth padding-right-sm font-bold">RECS</span></div><div class="display-flex border-bottom font-size-13 cursor-pointer align-items-center margin-top-20 padding-bottom-xs" ng-click="vm.openVehicleOverview()"><span class="text-align-left full-width-height text-uppercase">VEHICLE OVERVIEW</span></div><div class="display-flex border-bottom font-size-13 cursor-pointer align-items-center margin-top-20 padding-bottom-xs" ng-if="vm.adhocLineItems && vm.adhocLineItems.length" ng-click="vm.toggleNoTask()"><span class="text-align-left full-width-height">ORIGINAL AND GENERAL REQUESTS <span class="expand-icon" ng-class="{\'expanded\': vm.noTaskExpanded}"></span></span> <span class="text-align-right flex-fullwidth padding-right-sm">{{vm.adhocLineItems.length}}</span></div><div ng-if="vm.noTaskExpanded" class="padding-left-md"><div class="display-flex border-bottom font-size-13 cursor-pointer align-items-center margin-top-20" ng-repeat="lineItem in vm.adhocLineItems" ng-click="vm.openNoTaskLineItem(lineItem)"><span class="text-align-left full-width-height text-uppercase"><span ng-if="!lineItem.opCode">{{lineItem.name || lineItem.complaintString }}</span> <span ng-if="lineItem.opCode && !lineItem.complaintString">{{lineItem.opCode}} - {{lineItem.name}}</span> <span ng-if="lineItem.opCode && lineItem.complaintString">{{lineItem.opCode}} - {{lineItem.name}} - CUSTOMER STATES: {{lineItem.complaintString}}</span></span></div></div><div class="display-flex border-bottom font-size-13 cursor-pointer align-items-center margin-top-20 padding-bottom-xs" ng-repeat="task in vm.tasks"><span class="text-align-left full-width-height text-uppercase" ng-click="vm.openTask(task)">{{task.name}}</span> <span class="text-align-right flex-fullwidth padding-right-sm">{{task.lineItemCount || 0}}</span></div></div></div>');
$templateCache.put('app/areas/consumer/inspect/views/inspection-media-upload.view.html','<div class="min-height-100vh display-flex flex-column"><div class="bg-primary-dark font-size-15 padding-md text-white"><div class="text-bold">#{{vm.ro.dmsRepairOrderNumber || vm.ro.id}}</div><div class="font-size-13 text-uppercase">{{vm.ro.vehicle.year}} {{vm.ro.vehicle.make}} {{vm.ro.vehicle.model}}</div><div class="font-size-12">{{vm.ro.vehicle.vin | limitTo: 17}}</div></div><div class="margin-sm padding-md font-size-14 border-bottom text-uppercase"><strong>TASK: {{ vm.taskName }}</strong></div><div ng-if="vm.lineItems && vm.lineItems.length > 0"><div class="margin-bottom border-bottom" ng-repeat="lineItem in vm.lineItems"><div class="padding-md font-size-11 margin-left-sm text-uppercase"><strong>REC <span ng-if="lineItem.name">: {{lineItem.name}}</span><span ng-if="lineItem.formattedCorrection">: {{lineItem.formattedCorrection}}</span></strong><div class="display-flex flex-wrap padding-sm"><div class="text-center margin-top-sm" ng-repeat="media in lineItem.mediaItems track by $index"><div class="small-grey-boxes position-relative margin-right-md" ng-if="media.mediaUrl"><img class="position-relative image-container margin-right-none" ng-if="media.mediaType === vm.mediaTypes.photo" ng-click="vm.openImageModal(media, lineItem)" ng-src="{{media.mediaUrl}}"><video class="position-relative image-container margin-right-none" ng-if="media.mediaType === vm.mediaTypes.video" ng-click="vm.openImageModal(media, lineItem)" ng-src="{{media.mediaUrl}}"></video><span ng-click="vm.openImageModal(media, lineItem)" class="overlay" ng-if="media.mediaType === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div></div><drag-drop-image ng-model="lineItem.imageToUpload" class="small-white-boxes margin-top-sm ng-show" use-icon="true" placeholder="Add Photo" repeat-container="lineItem.mediaItems" on-load="vm.uploadMedia" ng-disabled="vm.addingImage" allow-video="true" drop-reference="lineItem.id" large="" loading-text="UPLOADING IMAGE" error-text="" is-version-2="true" hide-btn-text="true" use-small-button="false"></drag-drop-image></div></div></div></div><div ng-if="!vm.lineItems || vm.lineItems.length === 0" class="font-size-11 text-align-center padding-md margin-top-sm"><strong>A RECOMMENDATION IS REQUIRED TO ADD MEDIA</strong></div><div class="footer position-fixed"><button type="button" class="btn btn-warning block black border-radius-20 padding-lg margin-auto" ng-click="vm.close()">CLOSE</button></div></div>');
$templateCache.put('app/areas/consumer/inspect/views/vehicle-overview-media-upload.view.html','<div class="min-height-100vh display-flex flex-column"><div class="bg-primary-dark font-size-15 padding-md text-white"><div class="text-bold">#{{vm.ro.dmsRepairOrderNumber || vm.ro.id}}</div><div class="font-size-13 text-uppercase">{{vm.ro.vehicle.year}} {{vm.ro.vehicle.make}} {{vm.ro.vehicle.model}}</div><div class="font-size-12">{{vm.ro.vehicle.vin | limitTo: 17}}</div></div><div class="margin-sm padding-md font-size-14 border-bottom text-uppercase"><strong>VEHICLE OVERVIEW</strong></div><div class="padding-md font-size-11 text-uppercase color-gray"><strong>DOCUMENT OVERALL VEHICLE CONDITION. NOT TIED TO ANY SERVICE OR RECOMMENDATION.</strong></div><div class="padding-md"><div class="display-flex flex-wrap padding-sm"><div class="text-center margin-top-sm" ng-repeat="media in vm.vehicleOverviewMedia track by media.id"><div class="small-grey-boxes position-relative"><img class="image-container position-relative" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.photo" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.photo, media.id)" ng-src="{{media.mediaUrl}}"><video class="image-container position-relative" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.video" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.video, media.id)" ng-src="{{media.mediaUrl}}"></video><span class="overlay" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.video" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.video, media.id)"><i class="material-icons">play_arrow</i></span></div></div><drag-drop-image ng-model="vm.imageToUpload" class="small-white-boxes margin-top-sm ng-show" use-icon="true" placeholder="Add Photo" repeat-container="vm.vehicleOverviewMedia" on-load="vm.uploadVehicleOverviewMedia" on-complete="vm.mediaUploaded" ng-disabled="vm.addingImage" allow-video="true" drop-reference="vm.ro.id" large="" loading-text="UPLOADING IMAGE" dealer-id="vm.dealerId" image-type="vehicleOverview" key="vm.key" error-text="" is-version-2="true" hide-btn-text="true" use-small-button="false"></drag-drop-image></div></div><div class="footer position-fixed"><button type="button" class="btn btn-warning block black border-radius-20 padding-lg margin-auto" ng-click="vm.close()">CLOSE</button></div></div>');
$templateCache.put('app/areas/consumer/loaner/views/cfl-transportation.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h2 ng-bind-html="vm.configValues.cflChooseTransportationTitle"></h2><div class="margin-bottom-20" ng-bind-html="vm.configValues.cflChooseTransportationText"></div><div class="panel theme-panel" ng-if="vm.resolvedUser.enableLyftCreditAlternative === true"><center><div class="cfl-card-title margin-bottom" ng-bind-html="vm.configValues.cflLyftCreditTitle"></div></center><div class="margin-bottom font-size-12" ng-bind-html="vm.lyftCreditText"></div><div class="margin-bottom cfl-disabled-credits" ng-if="vm.resolvedUser.lyftCreditsDisabled === true" ng-bind-html="vm.disableLyftCreditMsg"></div><center><button type="button" class="margin-top-md btn btn-rounded btn-outline cfl-btn-select" ng-if="vm.resolvedUser.lyftCreditsDisabled === false" ng-class="{\'btn-primary\': vm.selectedTransportationType === vm.cflTransportationTypes.lyftCredit }" ng-click="vm.selectTransportationType(vm.cflTransportationTypes.lyftCredit)">SELECT</button></center></div><div class="panel theme-panel"><center><div class="cfl-card-title margin-bottom" ng-bind-html="vm.configValues.cflFirstAvailTitle"></div></center><div class="margin-bottom font-size-12" ng-bind-html="vm.configValues.cflFirstAvailText"></div><center><button type="button" class="margin-top-md btn btn-rounded btn-outline cfl-btn-select" ng-class="{\'btn-primary\': vm.selectedTransportationType === vm.cflTransportationTypes.firstAvailable }" ng-click="vm.selectTransportationType(vm.cflTransportationTypes.firstAvailable)">SELECT</button></center></div><div class="panel theme-panel" ng-class="{\'disabled-panel\': vm.resolvedUser.canChooseLoanerPreferences === false}"><center><div class="cfl-card-title margin-bottom" ng-bind-html="vm.configValues.cflChooseTitle"></div></center><div class="margin-bottom font-size-12" ng-bind-html="vm.configValues.cflChooseText"></div><center><button ng-if="vm.resolvedUser.canChooseLoanerPreferences === true" type="button" class="margin-top-md btn btn-rounded btn-outline cfl-btn-select" ng-class="{\'btn-primary\': vm.selectedTransportationType === vm.cflTransportationTypes.chooseLoaner }" ng-click="vm.selectTransportationType(vm.cflTransportationTypes.chooseLoaner)">SELECT</button> <button ng-if="vm.resolvedUser.canChooseLoanerPreferences === false" disabled="" class="margin-top-md btn btn-rounded btn-outline cfl-btn-select" ng-click="vm.selectTransportationType(vm.cflTransportationTypes.chooseLoaner)">NO LONGER AVAILABLE</button></center></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" back="vm.back()" next="vm.nextPage()" disabled="!vm.selectedTransportationType" loading="vm.loading" next-text="\'Next\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/cfl-vehicle-selection.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h2 ng-bind-html="vm.configValues.cflVehicleSelectionTitle"></h2><div class="margin-bottom-20" ng-bind-html="vm.configValues.cflVehicleSelectionText"></div><div class="panel theme-panel" ng-repeat="vehicle in vm.vehicleChoices | orderBy : \'rank\'" ng-click="vm.vehicleSelected(vehicle)"><center><div><img class="cfl-vehicle-image" ng-src="{{vehicle.imageUrl}}"> <span class="cfl-placeholder" ng-if="vm.firstSelection !== vehicle.modelCode && vm.secondSelection !== vehicle.modelCode">&nbsp;</span> <span class="cfl-preference-selection circle-text" ng-if="vm.firstSelection === vehicle.modelCode || vm.secondSelection === vehicle.modelCode"><span ng-if="vm.firstSelection === vehicle.modelCode">1</span> <span ng-if="vm.secondSelection === vehicle.modelCode">2</span></span></div><div class="theme-text font-size-11"><b>{{vehicle.model}}</b> - {{ vehicle.dailyCost | currency }}/day<span ng-if="vm.resolvedUser.enableLarPointsUpcharge && vehicle.dailyPoints && vehicle.dailyPoints > 0">&nbsp;or {{vehicle.dailyPoints}} points/day</span></div><div class="font-size-11 line-height-14"><i>{{vehicle.comment}}</i></div></center></div><div class="margin-top-30 row" ng-if="vm.resolvedUser.enableLarPointsUpcharge === true"><div class="col-xs-1"><input type="checkbox" ng-model="vm.usePoints" class="checkbox" name="usePoints" id="usePoints"></div><div class="col-xs-11 padding-left-sm"><label for="usePoints" class="theme-text font-size-11 line-height-14a"><span class="inline font-size-11 line-height-14" ng-bind-html="vm.configValues.cflUseRewardsPointsText"></span></label></div></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" back="vm.back()" next="vm.nextPage()" disabled="!vm.firstSelection || !vm.secondSelection" loading="vm.loading" next-text="\'Next\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/confirmation.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20 padding-bottom-md"><div ng-if="vm.loading"><div class="row padding-md padding-top-none padding-bottom-none"><div class="col-xs-12 well-lg text-center"><center><img src="assets/images/ajax-loader.gif"><br><div>COMPLETING LOANER RESERVATION</div><div>THIS CAN TAKE A MINUTE OR MORE</div></center></div></div></div><h2>CONFIRMATION</h2><div class="margin-bottom-20">Please review the information below. If you need to make any changes, click the BACK button.<contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" back="vm.back()" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'" class="no-consumer-footer-bottom-padding"></contact-footer></div><h3>Loaner Details</h3><div class="margin-bottom-md row"><div class="col-xs-5">Needed:</div><div class="col-xs-7">{{vm.resolvedUser.tripTime | date}} at {{vm.toLocalTimeFormat(vm.resolvedUser.tripTime, \'hh:mmA\')}}</div></div><div ng-if="vm.resolvedUser.enableLoanerPreferences === true"><loaner-preference-summary ng-model="vm.loanerPreferences"></loaner-preference-summary></div><div ng-if="vm.isLyftCredit() === false"><h3>Driver\'s License</h3><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Number:</div><div class="col-xs-7">{{vm.license.number}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">First Name:</div><div class="col-xs-7">{{vm.license.firstName}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Last Name:</div><div class="col-xs-7">{{vm.license.lastName}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Address:</div><div class="col-xs-7"><div>{{vm.license.addressLine1}}</div><div>{{vm.license.addressLine2}}</div><div>{{vm.license.addressCity}}, {{vm.license.addressState}} {{vm.license.addressZip}}</div></div></div><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Expiration:</div><div class="col-xs-7">{{vm.license.expiration | date}}</div></div><div class="margin-bottom-30 row"><div class="col-xs-5 padding-right-none">Date Of Birth:</div><div class="col-xs-7">{{vm.license.dateOfBirth | date}}</div></div><h3>Insurance</h3><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Carrier:</div><div class="col-xs-7">{{vm.insurance.carrier}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Policy Number:</div><div class="col-xs-7">{{vm.insurance.policy}}</div></div><div class="margin-bottom-md row" ng-if="vm.loanerClientType == vm.loanerManagementSystemsEnum.ARS"><div class="col-xs-5 padding-right-none">Phone Number:</div><div class="col-xs-7">{{vm.insurance.phoneNumber | tel}}</div></div><div class="margin-bottom-30 row"><div class="col-xs-5 padding-right-none">Expiration:</div><div class="col-xs-7">{{vm.insurance.expiration | date}}</div></div><div ng-if="vm.card"><h3>Credit Card</h3><div class="margin-bottom-md row"><div class="col-xs-5 padding-right-none">Card Number:</div><div class="col-xs-7">Ending in {{vm.card.details.lastFour}}</div></div></div><div ng-if="vm.cardProvided && !vm.card"><h3>Credit Card</h3><div class="margin-bottom-md row"><div class="col-xs-12">Credit card has been provided</div></div></div></div><div class="text-danger" ng-if="vm.error">{{vm.error}}</div></div></div><br><br></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/credit-card.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h2>CREDIT CARD</h2><div class="margin-bottom-20">Please provide payment information below. Your card will only be charged for incidentals such as damage, unpaid tolls, fuel, etc.</div><div class="text-danger margin-top-20" ng-if="vm.paymentMethodValid === false">Credit Card information is invalid. Please try again.</div><div ng-if="vm.loanerClientType == vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.DealerWare"><div id="creditcardform"></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" back="vm.back()" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'"></contact-footer></div><div ng-if="vm.loanerClientType == vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.ARS"><iframe id="arsIFrame" ng-src="{{vm.iframedURL}}" class="embedded-iframe" type="text/html" iframe-onload="vm.iFrameOnload()" fill-height="" additional-padding="10"></iframe></div><div ng-if="vm.loanerClientType == vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.TSDNew"><iframe id="tsdNewFrame" ng-src="{{vm.iframedURL}}" class="embedded-iframeTsd" type="text/html" iframe-onload="vm.iFrameOnloadTsd()" additional-padding="10"></iframe><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" back="vm.back()" next="vm.nextTSD()" next-text="\'Next\'"></contact-footer></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/driver-info.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h2 ng-bind-html="vm.configValues.loanerLicenseInsuranceTitle"></h2><div class="margin-bottom-20" ng-bind-html="vm.configValues.loanerLicenseInsuranceText"></div><h3 ng-bind-html="vm.configValues.loanerDriversLicenseTitle"></h3><div class="margin-bottom-20" ng-bind-html="vm.configValues.loanerDriversLicenseText"></div><div class="text-danger margin-top-20 margin-bottom-20" ng-if="vm.credentialsValid === false">We are unable to save your credentials. Please contact the dealership. LMS Error received: <i>"{{vm.credentialsError}}"</i></div><div class="form-group row"><div class="col-xs-12"><center><drag-drop-image ng-model="vm.license.photoBack" placeholder="Back of License" native-camera-only="true" on-load="vm.readAndUpload" ng-required="true" image-type="licenseBack" large="" loading-text="UPLOADING AND SCANNING LICENSE" error-text="License scan was unsuccessful. Please retry scanning or enter license details manually."></drag-drop-image><span class="text-danger" ng-if="vm.scanError">{{vm.scanError}}</span></center></div></div><div class="form-group row"><div class="col-xs-12"><center><drag-drop-image ng-model="vm.license.photoFront" placeholder="Front of License" native-camera-only="true" ng-required="true" large="" on-load="vm.upload" image-type="licenseFront" loading-text="UPLOADING"></drag-drop-image></center></div></div><div class="form-group row"><div class="col-xs-12"><input type="text" required="" validation="required" class="form-control better-placeholder" placeholder="LICENSE NUMBER" id="licenseNumber" name="licenseNumber" ng-model="vm.license.number"></div></div><div class="form-group row margin-none padding-left-none"><div class="col-xs-12 padding-left-none">Expiration</div></div><div class="form-group row"><div class="col-xs-4 field-wrapper margin-bottom-none"><label for="license_exp_year">YEAR</label><select selectlabel="" required="" class="form-control" name="license_exp_year" id="license_exp_year" validation-error-to="#dlYearError" ng-model="vm.licenseExpYear" ng-options="str for str in vm.expiresYears" validation="required:alt=Year is required" ng-change="vm.driversLicenseMonthYearUpdated()"><option value="">Year</option></select></div><div class="col-xs-4 padding-right-none padding-left-none field-wrapper margin-bottom-none"><label for="license_exp_month">MONTH</label><select selectlabel="" required="" validation="required:alt=Month is required" validation-error-to="#dlMonthError" ng-model-options="{ debounce: 750 }" class="form-control" name="license_exp_month" id="license_exp_month" ng-model="vm.licenseExpMonth" ng-options="str for str in vm.calendarMonths" ng-change="vm.driversLicenseMonthYearUpdated()"><option value="">Month</option></select></div><div class="col-xs-4 field-wrapper margin-bottom-none"><label for="license_exp_day">DAY</label><select selectlabel="" required="" validation="required:alt=Day is required" validation-error-to="#dlDayError" ng-disabled="!vm.licenseExpMonth || !vm.licenseExpYear || !vm.licenseExpDays" ng-model-options="{ debounce: 750 }" class="form-control" name="license_exp_day" id="license_exp_day" ng-model="vm.licenseExpDay" ng-options="str for str in vm.licenseExpDays" ng-change="vm.driversLicenseDayUpdated()"><option value="">Day</option></select></div><div id="dlexp-custom-error" class="col-xs-12 validation text-danger" ng-if="vm.dlExpired">License Is Expired</div><div id="dlYearError" class="col-xs-12 validation text-danger"></div><div id="dlMonthError" class="col-xs-12 validation text-danger"></div><div id="dlDayError" class="col-xs-12 validation text-danger"></div></div><div class="form-group row margin-none padding-left-none"><div class="col-xs-12 padding-left-none">Date Of Birth</div></div><div class="form-group row"><div class="col-xs-4 margin-bottom-none"><input type="text" ng-model-options="{ debounce: 750 }" validation-error-to="#dobYearError" ng-pattern="/^\\d+$/" id="dob_year" name="dob_year" ng-model="vm.dobYear" class="form-control better-placeholder" clean="true" ng-keydown="vm.vehicleKeyDown($event)" inputmode="numeric" pattern="[0-9]*" placeholder="YEAR" required="" validation="required:alt=Year is required|custom:vm.validation.valDOBYear():alt=Invalid Year ({{vm.minBirthDateYear}} - {{vm.maxBirthDateYear}})" ng-change="vm.updateDOBCalendarDays()"></div><div class="col-xs-4 margin-bottom-none padding-right-none padding-left-none field-wrapper"><label for="dob_month">MONTH</label><select selectlabel="" required="" validation-error-to="#dobMonthError" validation="required:alt=Month is required" ng-model-options="{ debounce: 750 }" class="form-control" name="dob_month" id="dob_month" ng-model="vm.dobMonth" ng-options="str for str in vm.calendarMonths" ng-change="vm.updateDOBCalendarDays()"><option value="">Month</option></select></div><div class="col-xs-4 field-wrapper margin-bottom-none"><label for="dob_day">DAY</label><select selectlabel="" required="" validation-error-to="#dobDayError" validation="required:alt=Day is required" ng-disabled="vm.isDOBYearInvalid() || !vm.dobMonth || !vm.dobDays" ng-model-options="{ debounce: 750 }" ng-change="vm.dobDayUpdated()" class="form-control" name="dob_day" id="dob_day" ng-model="vm.dobDay" ng-options="str for str in vm.dobDays"><option value="">Day</option></select></div><div id="dobYearError" class="col-xs-12 validation text-danger"></div><div id="dobMonthError" class="col-xs-12 validation text-danger"></div><div id="dobDayError" class="col-xs-12 validation text-danger"></div><div ng-if="vm.underAge" id="custom-error" class="col-xs-12 validation text-danger">You must be 21 to create a contract.</div></div><div class="form-group row"><div class="control-label col-sm-6 col-xs-12"><input placeholder="FIRST NAME" type="text" class="form-control better-placeholder" id="firstName" name="firstName" ng-model="vm.license.firstName" required="" validation="required"></div><div class="control-label col-sm-6 col-xs-12 override-xs-margin-top-md"><input placeholder="LAST NAME" type="text" class="form-control better-placeholder" id="lastName" name="lastName" ng-model="vm.license.lastName" required="" validation="required"></div></div><div class="form-group row"><div class="control-label col-xs-12"><input placeholder="ADDRESS LINE 1" type="text" class="form-control better-placeholder" id="addressLine1" name="addressLine1" ng-model="vm.license.addressLine1" required="" validation="required"></div></div><div class="form-group row"><div class="control-label col-xs-12"><input placeholder="ADDRESS LINE 2" type="text" class="form-control better-placeholder" name="addressLine2" ng-model="vm.license.addressLine2"></div></div><div class="form-group row"><div class="control-label col-xs-5"><input placeholder="CITY" type="text" class="form-control better-placeholder" id="addressCity" name="addressCity" ng-model="vm.license.addressCity" required="" validation="required"></div><div class="control-label col-xs-3 field-wrapper padding-right-none padding-left-none"><label for="state">STATE</label><select selectlabel="" name="state" id="state" ng-model="vm.license.addressState" class="form-control input" required="" validation="required" ng-options="item as item for item in vm.usStates"><option value="" disabled="disabled" selected="selected">State</option></select></div><div class="control-label col-xs-4"><input placeholder="ZIP" class="form-control better-placeholder no-spinners" id="addressZip" name="addressZip" type="text" pattern="[0-9]*" ng-model="vm.license.addressZip" required="" mask-restrict="reject" mask="99999"><div class="validation text-danger" ng-if="inputForm.addressZip.$invalid && (inputForm.addressZip.$dirty || inputForm.addressZip.$touched)">Invalid Zip</div></div></div><h3 ng-bind-html="vm.configValues.loanerInsuranceTitle"></h3><div class="margin-bottom-20" ng-bind-html="vm.configValues.loanerInsuranceText"></div><div class="form-group row"><div class="col-xs-12"><center><drag-drop-image ng-model="vm.insurance.photo" native-camera-only="true" placeholder="Insurance Card" ng-required="true" large="" on-load="vm.upload" image-type="insuranceFront" loading-text="UPLOADING"></drag-drop-image></center></div></div><div class="form-group row"><div class="control-label col-xs-12"><input placeholder="CARRIER" type="text" class="form-control better-placeholder" id="insuranceCarrier" name="insuranceCarrier" ng-model="vm.insurance.carrier" required="" validation="required"></div></div><div class="form-group row"><div class="control-label col-xs-12"><input placeholder="POLICY NUMBER" type="text" class="form-control better-placeholder" id="licensePolicy" name="licensePolicy" ng-model="vm.insurance.policy" required="" validation="required"></div></div><div class="row" ng-if="vm.loanerClientType == vm.loanerManagementSystemsEnum.ARS"><div class="col-xs-12"><label class="control-label full-width"><input type="text" name="carrierPhoneNumber" required="" inputmode="numeric" ng-model="vm.insurance.phoneNumber" class="form-control full-width better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="PHONE NUMBER" validation="required"></label></div></div><div class="form-group row margin-none padding-left-none"><div class="col-xs-12 padding-left-none">Expiration</div></div><div class="form-group row"><div class="col-xs-4 field-wrapper margin-bottom-none"><label for="license_exp_year">YEAR</label><select selectlabel="" required="" validation-error-to="#insYearError" class="form-control" name="insurance_exp_year" id="insurance_exp_year" ng-model="vm.insuranceExpYear" ng-options="str for str in vm.expiresYears" validation="required:alt=Year is required" ng-change="vm.insuranceMonthYearUpdated()"><option value="">Year</option></select></div><div class="col-xs-4 padding-right-none padding-left-none field-wrapper margin-bottom-none"><label for="insurance_exp_month">MONTH</label><select selectlabel="" required="" validation-error-to="#insMonthError" validation="required:alt=Month is required" ng-model-options="{ debounce: 750 }" class="form-control" name="insurance_exp_month" id="insurance_exp_month" ng-model="vm.insuranceExpMonth" ng-options="str for str in vm.calendarMonths" ng-change="vm.insuranceMonthYearUpdated()"><option value="">Month</option></select></div><div class="col-xs-4 field-wrapper margin-bottom-none"><label for="insurance_exp_day">DAY</label><select selectlabel="" required="" validation-error-to="#insDayError" validation="required:alt=Day is required" ng-disabled="!vm.insuranceExpMonth || !vm.insuranceExpYear || !vm.insuranceExpDays" ng-model-options="{ debounce: 750 }" class="form-control" name="insurance_exp_day" id="insurance_exp_day" ng-model="vm.insuranceExpDay" ng-options="str for str in vm.insuranceExpDays" ng-change="vm.insuranceDayUpdated()"><option value="">Day</option></select></div><div id="insexp-custom-error" class="col-xs-12 validation text-danger" ng-if="vm.insExpired">Insurance Is Expired</div><div id="insYearError" class="col-xs-12 validation text-danger"></div><div id="insMonthError" class="col-xs-12 validation text-danger"></div><div id="insDayError" class="col-xs-12 validation text-danger"></div></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" disabled="inputForm.$invalid || vm.underAge || vm.dlExpired || vm.insExpired" back="vm.back()" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/error.view.html','<div class="consumer-error text-center"><div class="sub-heading-text margin-left-20 margin-bottom-30"><i class="material-icons material-icons-large">warning</i> <span class="error-title">{{vm.title}}</span></div><div class="error-message margin-left-20 margin-bottom-30">{{vm.error}}</div><div class="error-contact">{{vm.dealershipName}}<br><span class="error-contact-phone"><a ng-href="tel:{{vm.dealershipPhone}}">{{vm.dealershipPhone | tel}}</a></span></div><contact-footer phone-number="vm.dealershipPhone" back="vm.goBack()" back-text="\'Back\'"></contact-footer></div>');
$templateCache.put('app/areas/consumer/loaner/views/landing.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h2 ng-bind-html="vm.configValues.loanerLandingTitle"></h2><div ng-if="vm.resolvedUser.isCancelled"><p>Sorry, this reservation/agreement is no longer valid. Please contact us if you have any questions.</p></div><div ng-if="!vm.resolvedUser.isCancelled"><div class="margin-bottom-20" ng-bind-html="vm.configValues.loanerLandingText"></div><task-circles tasks="vm.tasks"></task-circles><div class="homework-task-list margin-top-30"><div class="row margin-bottom-20"><div class="col-xs-1 text-center"><div style="width: 36px;"><input type="checkbox" name="primaryDriver" ng-model="vm.isPrimaryDriver" class="form-check-input" ng-required="vm.currentState.id === vm.stateId.confirmation" validation="required"></div></div><div class="col-xs-10 margin-left-20"><span ng-bind-html="vm.configValues.loanerLandingPrimaryDriver"></span></div></div></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'" disabled="!vm.isPrimaryDriver"></contact-footer></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/profile-complete.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20 padding-bottom-md"><h2 ng-bind-html="vm.dealerBranding.configValues.loanerProfileCompleteTitle"></h2><div class="margin-bottom-20" ng-if="vm.isLyftCredit() === true" ng-bind-html="vm.dealerBranding.configValues.rideshareLoanerProfileCompleteTitle"></div><div class="margin-bottom-20" ng-if="vm.isLyftCredit() === false" ng-bind-html="vm.dealerBranding.configValues.loanerProfileCompleteText"></div><div ng-if="!vm.params.fromStart"><h3>Loaner Details</h3><div class="margin-bottom-30 row"><div class="col-xs-5">Needed:</div><div class="col-xs-7">{{vm.resolvedUser.pickup | date}} at {{vm.resolvedUser.pickup | time}}</div></div><div ng-if="vm.resolvedUser.enableLoanerPreferences === true"><loaner-preference-summary ng-model="vm.resolvedUser.loanerPreferences"></loaner-preference-summary></div><div ng-if="vm.isLyftCredit() === false"><h3>Driver\'s License</h3><div class="margin-bottom-md row"><div class="col-xs-5">Number:</div><div class="col-xs-7">{{vm.license.number}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5">First Name:</div><div class="col-xs-7">{{vm.license.firstName}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5">Last Name:</div><div class="col-xs-7">{{vm.license.lastName}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5">Address:</div><div class="col-xs-7"><div>{{vm.license.addressLine1}}</div><div>{{vm.license.addressLine2}}</div><div>{{vm.license.addressCity}}, {{vm.license.addressState}} {{vm.license.addressZip}}</div></div></div><div class="margin-bottom-30 row"><div class="col-xs-5">Expiration:</div><div class="col-xs-7">{{vm.license.expiration | date}}</div></div><h3>Insurance</h3><div class="margin-bottom-md row"><div class="col-xs-5">Carrier:</div><div class="col-xs-7">{{vm.insurance.carrier}}</div></div><div class="margin-bottom-md row"><div class="col-xs-5">Policy Number:</div><div class="col-xs-7">{{vm.insurance.policy}}</div></div><div class="margin-bottom-md row" ng-if="vm.loanerClientType == vm.loanerManagementSystemsEnum.ARS"><div class="col-xs-5">Phone Number:</div><div class="col-xs-7">{{vm.insurance.phoneNumber | tel}}</div></div><div class="margin-bottom-30 row"><div class="col-xs-5">Expiration:</div><div class="col-xs-7">{{vm.insurance.expiration | date}}</div></div><div ng-if="vm.card"><h3>Credit Card</h3><div class="margin-bottom-md row"><div class="col-xs-5">Card Number:</div><div class="col-xs-7">Ending in {{vm.card.details.lastFour}}</div></div></div><div ng-if="vm.cardProvided && !vm.card"><h3>Credit Card</h3><div class="margin-bottom-md row"><div class="col-xs-12">Credit card has been provided</div></div></div></div></div><div ng-if="vm.params.fromStart"><h3>Loaner Details</h3><div class="row" ng-class="{\'margin-bottom-20\': vm.resolvedUser.enableLoanerPreferences === true, \'margin-bottom-md\': vm.resolvedUser.enableLoanerPreferences === false}"><div class="col-xs-5">Needed:</div><div class="col-xs-7">{{vm.resolvedUser.pickup | date}} at {{vm.resolvedUser.pickup | time}}</div></div><div ng-if="vm.resolvedUser.enableLoanerPreferences === true"><loaner-preference-summary ng-model="vm.resolvedUser.loanerPreferences"></loaner-preference-summary></div><div class="row margin-bottom-20 margin-top-30"><div class="col-xs-12">If you have any questions or need to change your driver\'s license, insurance, or credit card information please contact us at the number below. You can also send us a message by clicking the messaging icon above.</div></div><div class="row"><div class="col-xs-12 text-center"><a class="font-bold text-uppercase text-big" ng-href="tel:{{vm.dealerBranding.mainPhoneNumber}}">{{vm.dealerBranding.mainPhoneNumber | tel}}</a></div></div></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/signature-complete.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care margin-bottom-30"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="text-center margin-left-20 margin-right-20 margin-top-20"><i class="text-success material-icons authorization-success-checkbox">check_circle</i></div><div class="margin-left-20 margin-right-20 margin-top-20"><h2>LOANER AGREEMENT ACTIVE</h2><div class="margin-bottom-20"><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.loanerManagementSystemsEnum.ARS" ng-bind-html="vm.dealerBranding.configValues.loanerArsSignatureCompleteText"></div><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.DealerWare" ng-bind-html="vm.dealerBranding.configValues.loanerDealerWareSignatureCompleteText"></div><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.TSD" ng-bind-html="vm.dealerBranding.configValues.loanerTSDSignatureCompleteText"></div></div><h3>Loaner Information</h3><div class="margin-bottom-20"><div class="bold margin-bottom-md">{{vm.year}} {{vm.make}} {{vm.model}}</div><div class="bold margin-bottom-md">VIN: {{vm.vin}}</div><div class="bold margin-bottom-md">Odometer: {{vm.mileage | number}} Miles</div><div class="bold margin-bottom-30">Fuel:<div class="margin-bottom-20"><rzslider rz-slider-model="vm.fuel" rz-slider-options="vm.sliderOptions"></rzslider></div></div></div><div></div><consumer-damage-issues ng-model="vm.issues" route-params="vm.routeParams"></consumer-damage-issues><div class="margin-bottom-md" ng-if="vm.terms && vm.terms.length">You\'ve agreed to the following terms.</div><div ng-repeat="term in vm.terms" class="margin-bottom-md row"><div class="col-xs-2"><i class="material-icons material-icons-large theme-link">done</i></div><div class="col-xs-10">{{term.text}}</div></div><div class="margin-top-20"><div class="margin-bottom" ng-if="vm.contractSignedDate != null">Contract signed on {{ vm.contractSignedDate | localDate: \'MMM DD, YYYY\' }} at {{ vm.contractSignedDate | localDate: \'hh:mm a\' }}</div><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.loanerManagementSystemsEnum.DealerWare || vm.dealerBranding.configValues.loanerClientType === vm.loanerManagementSystemsEnum.ARS || vm.dealerBranding.configValues.loanerClientType === vm.loanerManagementSystemsEnum.TSDNew"><a ng-href="{{vm.contractLink}}" target="_blank" class="theme-link"><u>VIEW CONTRACT</u></a></div></div><div class="margin-bottom-30" ng-if="vm.imageUrl"><img ng-src="{{vm.imageUrl}}" style="border-bottom: 1px solid black; width: 100%"></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/loaner/views/signature.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Loaner Reservation\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.styleValues.headerImageUrl" dealer-id="vm.dealerBranding.dealerId" app-type="4"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.ARS"><ars-review ng-model="vm" form="inputForm"></ars-review></div><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.DealerWare"><dealerware-review ng-model="vm" form="inputForm"></dealerware-review></div><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.TSD"><tsd-review ng-model="vm" form="inputForm"></tsd-review></div><div ng-if="vm.dealerBranding.configValues.loanerClientType === vm.SYSTEM_ENUMS.loanerManagementSystemsEnum.TSDNew"><tsdnew-review ng-model="vm" form="inputForm"></tsdnew-review></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/payments/views/book-trip.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-payments-page"><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.invoice.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.invoice.headerImageUrl}}"></div><div class="margin-left-30 margin-right-30"><h2 ng-bind-html="vm.title"></h2><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="margin-top-20"><div class="row" ng-repeat="option in vm.offeredTripTypes"><div class="col-xs-12"><div ng-if="option.systemTripTypeId"><a class="btn btn-rounded btn-block btn-primary ladda-button margin-bottom-sm" ladda="" href="{{option.link}}"><span class="font-normal">{{option.heading}}</span></a><div class="padding-bottom-md text-normal-case text-wrap text-center btn-sub-text margin-bottom-20">{{option.text}}</div><div ng-if="option.bookLaterHeading"><button type="button" class="btn btn-rounded btn-block btn-primary ladda-button margin-bottom-sm" ladda="" ng-click="vm.bookLater(option)"><span class="font-normal">{{option.bookLaterHeading}}</span></button><div class="padding-bottom-md text-normal-case text-wrap text-center btn-sub-text margin-bottom-20">{{option.bookLaterText}}</div></div></div><div ng-if="!option.systemTripTypeId"><a class="btn btn-rounded btn-block btn-primary ladda-button margin-bottom-sm" ladda="" ui-sref="payment-bring-it-in"><span class="font-normal">{{option.heading}}</span></a><div class="padding-bottom-md text-normal-case text-wrap text-center btn-sub-text margin-bottom-20">{{option.text}}</div></div></div></div></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/payments/views/bring-it-in.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-payments-page"><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.invoice.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.invoice.headerImageUrl}}"></div><div class="margin-left-30 margin-right-30"><div class="consumer-header-text">Thank you for your business</div><div>Please let us know approximately when you plan to pick up your vehicle.</div><div class="margin-top-md form-horizontal"><div class="form-group row"><div class="col-xs-offset-2 col-xs-8"><select class="form-control" name="date" ng-model="vm.selectedDate" ng-change="vm.selectedDateChanged()" required="" validation="required" ng-options="item as item.text for item in vm.dates"></select></div></div><div class="form-group row"><div class="col-xs-offset-2 col-xs-8"><select class="form-control" name="date" ng-model="vm.selectedTime" required="" validation="required" ng-options="item as item for item in vm.times"><option value="">Select Time</option></select></div></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/payments/views/confirmation.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-appointments-height consumer-payments-page"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs" ng-src="{{vm.invoice.desktopHeaderImageUrl}}" style="width: 100%"> <img class="visible-xs" ng-src="{{vm.invoice.headerImageUrl}}" style="width: 100%"></div><div class="margin-left-30 margin-right-30" ng-if="!vm.data.html"><div class="consumer-header-text" ng-bind-html="vm.title"></div><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="payment-lineitems-list"><div class="row margin-top-30 font-bold border-bottom"><div class="col-xs-9 margin-bottom-md text-uppercase">Item</div><div class="col-xs-3 text-right margin-bottom-md text-uppercase">Amount</div></div><section class="row" ng-repeat="item in vm.invoice.lineItems"><div ng-if="item.type != 8"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{item.typeDescription}}</div><div>{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="item.showLineItemAmount">{{item.amount | currency}}</div></div><div ng-if="item.type == 8 && vm.delivery != null && !vm.delivery.isUpdating && vm.initComplete"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{item.typeDescription}} <span ng-if="vm.countDownInterval != null">(UPDATES IN {{ vm.delivery.refreshCountdown }})</span></div><div>{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="!vm.hasError">{{ item.amount | currency}}</div><div class="col-xs-12 margin-bottom-md margin-top-md closed-warning" ng-if="vm.hasError">We\'re sorry. We cannot deliver to this address. Please click the BACK button and change the address or contact us for assistance.</div><div ng-if="item.childLineItems != null && item.childLineItems.length > 0 && itemChild.amount > 0" ng-repeat="itemChild in item.childLineItems"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{itemChild.typeDescription}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="(itemChild.amountType == null || itemChild.amountType == 0) && !vm.hasError" ng-class="{ \'text-danger\': itemChild.type == 9 }">{{ itemChild.type == 9 ? -itemChild.displayAmount : itemChild.displayAmount | currency }}</div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="itemChild.amountType == 1 && !vm.hasError" ng-class="{ \'text-danger\': itemChild.type == 9 }">{{ (((itemChild.type == 9 ? -itemChild.displayAmount : itemChild.displayAmount) / 100) * item.amount | currency) }}</div></div><div ng-if="item.childLineItems != null && item.childLineItems.length > 0"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">Your {{item.typeDescription}} charge</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="!vm.hasError"><div class="font-bold">{{ item.subTotal | currency }}</div></div></div><div ng-if="!vm.hasError && item.deliveryOptions && item.deliveryOptions.rideProviderDetails && item.deliveryOptions.rideProviderDetails.etaSeconds > 0"><div class="col-xs-12 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold theme-link no-underline">Estimated Delivery Time: {{item.deliveryOptions.rideProviderDetails.etaSeconds | duration}}</div></div></div></div><div ng-if="item.type == 8 && vm.delivery != null && (vm.delivery.isUpdating == null || vm.delivery.isUpdating)" class="col-xs-12 margin-bottom-md margin-top-md"><div class="text-center"><img src="assets/images/ajax-loader.gif"><div>Updating...</div></div></div><div ng-if="item.type != 8 && item.childLineItems"><div ng-repeat="itemChild in item.childLineItems"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{itemChild.typeDescription}}</div><div>{{itemChild.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="!vm.hasError">{{ itemChild.amount | currency }}</div></div></div></section><section class="row" ng-if="vm.pickup != null"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">Customer Pick Up</div><div>{{ vm.pickup.formattedDateTime | date:\'EEE, MMMM d\'}} at {{ vm.pickup.time | date:\'h:mm a\'}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right">{{ 0.00 | currency}}</div></section><div ng-if="!vm.invoice.lineItems || !vm.invoice.lineItems.length"><div class="col-xs-12 margin-bottom-md margin-top-md text-center text-uppercase">No line items were found</div></div><div class="row margin-top-md"><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="vm.shopSupplies">ShopSupplies: {{vm.shopSupplies | currency}}</h3><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="vm.fee">Fee: {{vm.fee | currency}}</h3><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="vm.tax">Tax: {{vm.tax | currency}}</h3><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase">Total: {{vm.calculatedTotal | currency}}</h3></div></div><div class="form-group row" ng-if="vm.initComplete && !vm.hasError"><div class="col-xs-12"><label><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="customerAuthorized" ng-model="vm.customerAuthorized" required="" validation="required"> <span ng-if="vm.isPartsOnDemand" class="payments-checkbox-confirm-labe">I authorize charging the invoice above to {{ vm.isBillToAccount ? "my account" : "this card" }}. Note final delivery charges are calculated upon completion.</span> <span ng-if="!vm.isPartsOnDemand" class="payments-checkbox-confirm-label">I authorize charging {{vm.calculatedTotal | currency}} to {{ vm.isBillToAccount ? "my account" : "this card" }}</span></label></div></div><div ng-if="vm.processingErrorMessage != null" class="margin-bottom-20 closed-warning" style="border: 2px solid; padding: 5px;"><div class="text-center"><div class="font-bold">There was an issue while processing your request:</div><div>{{vm.processingErrorMessage}}</div></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" ng-if="!vm.isBillToAccount" next-text="vm.deliverySelected ? \'Pay & Book Delivery\' : \'Pay Invoice\'" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid || (vm.delivery != null && vm.delivery.isUpdating) || vm.hasError"></contact-footer><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" ng-if="vm.isBillToAccount" next-text="vm.deliverySelected ? \'Book Delivery\' : \'Process Invoice\'" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid || (vm.delivery != null && vm.delivery.isUpdating) || vm.hasError"></contact-footer></div></div><div ng-if="vm.data.html"><div class="margin-left-30 margin-right-30"><h2 ng-bind-html="vm.data.cardAdditionalSecurityTitle"></h2><div class="margin-bottom-20" ng-bind-html="vm.data.cardAdditionalSecurityParagraph"></div></div><div ng-bind-html="vm.data.html"></div><div class="margin-left-30 margin-right-30"><contact-footer phone-number="vm.data.invoice.mainPhoneNumber" back="vm.cancel3dSecure()"></contact-footer></div></div></form>');
$templateCache.put('app/areas/consumer/payments/views/credit-card.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><div class="tablet-size owner-care consumer-payments-page"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.invoice.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.invoice.headerImageUrl}}"></div><div ng-if="vm.invoice.providerType === vm.paymentProcessorsEnum.cenPos"><cenpos-payment params="vm.params" ng-model="vm.data"></cenpos-payment></div><div ng-if="vm.invoice.providerType === vm.paymentProcessorsEnum.cardConnect"><cardconnect-payment params="vm.params" ng-model="vm.data"></cardconnect-payment></div><div ng-if="vm.invoice.providerType === vm.paymentProcessorsEnum.peri"><peri-payment params="vm.params" ng-model="vm.data"></peri-payment></div></div></div></div><script src="https://code.jquery.com/jquery-migrate-1.4.1.min.js"></script><script src="https://www.cenpos.com/Plugins/porthole.min.js"></script><script src="https://www.cenpos.com/Plugins/jquery.simplewebpay.js"></script>');
$templateCache.put('app/areas/consumer/payments/views/delivery-options.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-appointments-height consumer-payments-page"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs" ng-src="{{vm.invoice.desktopHeaderImageUrl}}" style="width: 100%"> <img class="visible-xs" ng-src="{{vm.invoice.headerImageUrl}}" style="width: 100%"></div><div class="margin-left-30 margin-right-30"><div class="row" ng-repeat="option in vm.offeredTripTypes"><div class="col-xs-12"><div ng-if="option.systemTripTypeId && option.systemTripTypeId != vm.systemTripType.partsOnDemand"><div class="consumer-header-text">{{option.heading}}</div><div>{{option.text}}</div><div class="margin-top-md form-horizontal"><div class="form-group row"><div class="col-xs-12"><button type="button" class="btn btn-rounded btn-block btn-primary min-75" ladda="vm.loading" ng-click="vm.consumerOptionSelected(option)">Next</button></div></div></div><hr><div ng-if="option.bookLaterHeading"><div class="consumer-header-text">{{option.bookLaterHeading}}</div><div>{{option.bookLaterText}}</div><div class="margin-top-md form-horizontal"><div class="form-group row"><div class="col-xs-12"><button type="button" class="btn btn-rounded btn-block btn-primary min-75" ladda="vm.loading" ng-click="vm.consumerOptionSelected(option, true)">Next</button></div></div></div><hr></div></div><div ng-if="option.systemTripTypeId == vm.systemTripType.partsOnDemand"><div class="consumer-header-text">Deliver it to me</div><div>Once you complete the payment process, we will immediately dispatch delivery and route you to our tracking page. Please be sure someone is available to receive the parts.</div><div class="margin-top-md form-horizontal"><div class="form-group row" ng-if="vm.isDeliveryCurrentlyAvailable"><div class="col-xs-12"><input type="text" ng-attr-placeholder="Enter Delivery Address" id="deliveryAddress" name="deliveryAddress" ng-model="vm.delivery.address.formattedAddress" class="form-control" details="vm.delivery.addressDetails" here-places="" options="vm.delivery.hereMapOptions" handle-selected="vm.deliveryAddressUpdated(formattedAddress)"></div></div><div class="form-group row" ng-if="vm.isDeliveryCurrentlyAvailable"><div class="col-xs-12"><label><input type="checkbox" class="checkbox checkbox-inline" name="confirmAddress" ng-model="vm.data.confirmAddress" required="" validation="required"> Confirm delivery address above is correct</label></div></div><div class="form-group row"><div class="col-xs-12"><div ng-if="vm.deliveryErrorMessage" class="text-danger">{{vm.deliveryErrorMessage}}</div><button type="button" class="btn btn-rounded btn-primary btn-block min-75" ladda="vm.loading" ng-disabled="!vm.isDeliveryCurrentlyAvailable || !vm.data.confirmAddress || !vm.delivery.address" ng-click="vm.deliverySelected(option)">Next</button></div></div><div class="form-group row" ng-if="!vm.isDeliveryCurrentlyAvailable"><div class="col-xs-12"><label>Oops. Parts delivery is currently unavailable. Please try again during business hours to use our delivery service.</label></div></div></div><hr></div><div ng-if="option.systemTripTypeId == vm.systemTripType.partsOnDemand"><div class="consumer-header-text">I\'ll Pick It Up</div><div>Please confirm your estimated pick up time at our store. Hours of operation are {{ vm.times[0] }} to {{ vm.times[vm.times.length - 1]}}</div><div class="margin-top-md form-horizontal"><div class="form-group row"><div class="col-xs-12 col-sm-6"><select class="form-control" name="date" ng-model="vm.selectedDate" ng-change="vm.selectedDateChanged()" required="" validation="required" ng-options="item as item.text for item in vm.dates"></select></div><div class="col-xs-12 col-sm-6"><select class="form-control" name="date" ng-model="vm.selectedTime" required="" validation="required" ng-options="item as item for item in vm.times"><option value="">Select Time</option></select></div></div><div class="form-group row"><div class="col-xs-12"><button type="button" class="btn btn-rounded btn-block btn-primary min-75" ladda="vm.loading" ng-click="vm.pickUpSelected()">Next</button></div></div></div><hr></div></div></div><div class="form-group row"><div class="col-xs-12"><button type="button" class="btn btn-rounded btn-block btn-outline min-75" ladda="" ng-click="vm.back()">Back</button></div></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" loading="vm.loading" disabled="!inputForm.$valid"></contact-footer></div></form>');
$templateCache.put('app/areas/consumer/payments/views/landing.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-payments-page"><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.invoice.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.invoice.headerImageUrl}}"></div><div class="margin-left-30 margin-right-30"><div class="consumer-header-text" ng-bind-html="vm.title"></div><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="margin-bottom-20 closed-warning" ng-if="vm.isPartsOnDemand && !vm.isDeliveryCurrentlyAvailable" style="border: 2px solid; padding: 5px;">IMPORTANT DELIVERY NOTICE<br>Parts deliveries can only be booked during normal business hours. If you require delivery, please pay your invoice during these hours. You may continue the payment process if you are making other arrangements.<div class="margin-top-20 margin-bottom-20"><a class="text-center theme-link" ahref="#" ng-click="vm.showHours = !vm.showHours"><div ng-if="vm.showHours">CLICK HERE TO HIDE STORE HOURS</div><div ng-if="!vm.showHours">CLICK HERE TO SHOW STORE HOURS</div></a></div><table ng-if="vm.showHours" class="table"><tr ng-repeat="day in vm.formattedDealerHours"><td>{{day.name}}</td><td ng-if="!day.isClosed">{{day.startTime}}</td><td ng-if="!day.isClosed">{{day.endTime}}</td><td colspan="2" ng-if="day.isClosed">Closed</td></tr></table></div><task-circles tasks="vm.steps" ng-if="!vm.isInvoiceCancelled"></task-circles><div class="margin-top-30 margin-right-30" ng-if="!vm.isInvoiceCancelled"><div><label for="email"><strong>Please enter your email address to get started</strong></label></div><div class="row"><div class="col-xs-12"><input type="text" id="email" name="email" ng-model="vm.emailAddress" class="form-control better-placeholder" placeholder="YOUR@EMAIL.COM" required="required" validation="required|email"></div></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" loading="vm.loading" disabled="!inputForm.$valid" next-text="\'Start\'" ng-if="!vm.isInvoiceCancelled"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/payments/views/review-charges.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-payments-page"><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.invoice.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.invoice.headerImageUrl}}"></div><div class="margin-left-30 margin-right-30"><div class="consumer-header-text" ng-bind-html="vm.title"></div><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="payment-lineitems-list"><div class="row margin-top-30 font-bold border-bottom"><div class="col-xs-9 margin-bottom-md text-uppercase">Item</div><div class="col-xs-3 text-right margin-bottom-md text-uppercase">Amount</div></div><div ng-repeat="item in vm.visibleLineItems"><section class="row"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{item.typeDescription}}</div><div>{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="item.showLineItemAmount">{{item.amount | currency}}</div></section><section class="row" ng-repeat="childLineItem in item.childLineItems"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold margin-left-md">{{childLineItem.typeDescription}}</div><div class="margin-left-md">{{childLineItem.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="childLineItem.showLineItemAmount">{{childLineItem.amount | currency}}</div></section><section class="row" ng-if="!item.showLineItemAmount && item.subTotal"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold margin-left-md">{{item.typeDescription}}</div><div class="margin-left-md">{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right text-uppercase">Sub Total {{item.subTotal | currency}}</div></section></div><div ng-if="!vm.visibleLineItems || !vm.visibleLineItems.length"><div class="col-xs-12 margin-bottom-md margin-top-md text-center text-uppercase">No line items were found</div></div><div class="row margin-top-md"><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="vm.shopSupplies">ShopSupplies: {{vm.shopSupplies | currency}}</h3><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="vm.fee">Fee: {{vm.fee | currency}}</h3><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase" ng-if="vm.tax">Tax: {{vm.tax | currency}}</h3><h3 class="col-xs-12 margin-bottom-md margin-top-md text-right text-uppercase">Total: {{vm.invoice.total | currency}}</h3></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/payments/views/success-no-booking.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><div class="tablet-size owner-care"><consumer-header name="vm.invoice.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.invoice.dealerPhone" sms-number="vm.invoice.dealerSmsNumber" address="vm.invoice.dealerAddress" city="vm.invoice.dealerCity" state="vm.invoice.dealerState" zip="vm.invoice.dealerZip" lat="vm.invoice.dealerLat" lng="vm.invoice.dealerLng" dealer-id="vm.invoice.locationId" app-type="1"></consumer-header><div class="consumer-payments-page"><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.invoice.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.invoice.headerImageUrl}}"></div><div class="margin-left-30 margin-right-30"><div class="consumer-header-text" ng-bind-html="vm.title"></div><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="payment-lineitems-list"><div class="text-center row"><div class="icon-text-inline"><i class="text-success material-icons material-icons-xlarge">check_circle</i><div class="consumer-header-text padding-none">PAID</div></div><div class="col-xs-12 margin-top-md"><div>{{vm.result.amount | currency}} charged to card ending in ****{{vm.result.cardNumber}}</div><div>on {{vm.result.createdDateTime | date : \'M/d/yy\'}} at {{vm.result.createdDateTime | date : \'mediumTime\' }}. Transaction #{{vm.result.referenceId}}</div></div></div><div class="row margin-top-20 font-bold border-bottom text-uppercase"><div class="col-xs-9 margin-bottom-md">Item</div><div class="col-xs-3 text-right margin-bottom-md">Amount</div></div><div ng-repeat="item in vm.invoice.lineItems"><section class="row text-uppercase"><div class="col-xs-9 margin-bottom-md margin-top-md"><div class="font-bold">{{item.typeDescription}}</div><div>{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="item.showLineItemAmount">{{item.amount | currency}}</div></section></div><div ng-if="!vm.invoice.lineItems || !vm.invoice.lineItems.length"><div class="col-xs-12 margin-bottom-md margin-top-md text-center text-uppercase">No line items were found</div></div><div class="row margin-top-md"><h3 class="col-xs-12 text-right text-uppercase" ng-if="vm.shopSupplies">ShopSupplies: {{vm.shopSupplies | currency}}</h3><h3 class="col-xs-12 text-right text-uppercase" ng-if="vm.fee">Fee: {{vm.fee | currency}}</h3><h3 class="col-xs-12 text-right text-uppercase" ng-if="vm.tax">Tax: {{vm.tax | currency}}</h3><h3 class="col-xs-12 text-right text-uppercase">Total: {{vm.invoice.total | currency}}</h3></div></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/payments/views/success.view.html','<consumer-dealer-custom-styles configs="vm.deliveryStyleValues"></consumer-dealer-custom-styles><div class="tablet-size owner-care"><consumer-header name="vm.dealerInfo.dealerName" description="vm.deliveryStyleValues.headerText" phone-number="vm.dealerInfo.dealerPhone" sms-number="vm.dealerInfo.dealerSmsNumber" address="vm.dealerInfo.dealerAddress" city="vm.dealerInfo.dealerCity" state="vm.dealerInfo.dealerState" zip="vm.dealerInfo.dealerZip" lat="vm.dealerInfo.dealerLat" lng="vm.dealerInfo.dealerLng" dealer-id="vm.dealerInfo.locationId" app-type="1"></consumer-header><div class="consumer-payments-page"><div class="consumer-payments-height"><div class="margin-bottom-20 margin-left-negative-30 margin-right-negative-30 payments-header-img"><img class="hidden-xs full-width" ng-src="{{vm.dealerInfo.desktopHeaderImageUrl}}"> <img class="visible-xs full-width" ng-src="{{vm.dealerInfo.headerImageUrl}}"></div><div class="margin-left-30 margin-right-30"><div class="consumer-header-text" ng-bind-html="vm.title"></div><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="payment-lineitems-list"><div class="text-center row"><div class="icon-text-inline"><i class="text-success material-icons material-icons-xlarge">check_circle</i><div class="consumer-header-text padding-none"><span ng-if="vm.invoice.status == 3">PAID</span><span ng-if="vm.invoice.status != 3">THANK YOU</span></div></div><div class="col-xs-12 margin-top-md" ng-if="vm.paymentResult && !vm.isBillToAccount && vm.invoice.status == 3"><div>{{vm.paymentResult.amount | currency}} charged to card ending in ****{{vm.paymentResult.cardNumber}}</div><div>on {{vm.paymentResult.createdDateTime | date : \'M/d/yy\'}} at {{vm.paymentResult.createdDateTime | date : \'mediumTime\' }}. Transaction #{{vm.paymentResult.referenceId}}</div></div><div class="col-xs-12 margin-top-md" ng-if="vm.paymentResult && !vm.isBillToAccount && vm.invoice.status == 5"><div>{{vm.paymentResult.amount | currency}} has been authorized to card ending in ****{{vm.paymentResult.cardNumber}}</div><div>on {{vm.paymentResult.createdDateTime | date : \'M/d/yy\'}} at {{vm.paymentResult.createdDateTime | date : \'mediumTime\' }}. Transaction #{{vm.paymentResult.referenceId}}</div></div><div class="col-xs-12 margin-top-md" ng-if="vm.isBillToAccount">Billed to Account</div></div><div class="row margin-top-20" ng-if="vm.isValidPODDelivery"><div class="col-xs-12 text-center"><button type="button" class="btn btn-rounded btn-block padding-top-md padding-bottom-md btn-primary" ladda="" ui-sref="track({tripId:vm.tripId, key: vm.tripKey})">Track Your Delivery</button></div></div><div class="row margin-top-20" ng-if="!vm.isValidPODDelivery && vm.invoice.isPodCheckout && !vm.pickupDateTime"><div class="col-xs-12 text-center">There was an issue with booking your trip, please contact the dealership to resolve this issue.</div></div><div class="row margin-top-20" ng-if="!vm.invoice.isPodCheckout && vm.pickupDateTime != null"><div class="col-xs-12 text-center"><div>Customer Pick Up</div><div>{{vm.pickupDateTime | date:\'EEE, MMMM d\'}} at {{ vm.pickupDateTime | date:\'h:mm a\'}}</div></div></div><div class="row margin-top-20" ng-if="!vm.invoice.isPodCheckout && vm.pickupDateTime == null && vm.offeredTripTypes && vm.offeredTripTypes.length > 0"><div class="col-xs-12 text-center"><button type="button" class="btn btn-rounded btn-block btn-outline padding-top-md padding-bottom-md" ladda="" ui-sref="payment-booking">Delivery Options</button></div></div><div class="row margin-top-20 font-bold border-bottom"><div class="col-xs-9 margin-bottom-md text-uppercase">Item</div><div class="col-xs-3 text-right margin-bottom-md text-uppercase">Amount</div></div><div ng-repeat="item in vm.invoice.lineItems"><section class="row"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{item.typeDescription}}</div><div>{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right" ng-if="item.showLineItemAmount">{{(item.subTotal || item.amount) | currency}}</div></section><section class="row" ng-repeat="childItem in item.childLineItems"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{childItem.typeDescription}}</div><div>{{childItem.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right">{{(childItem.amount) | currency}}</div></section><section class="row" ng-if="!item.showLineItemAmount && item.subTotal"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">{{item.typeDescription}}</div><div>{{item.description}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right">Sub Total: {{item.subTotal | currency}}</div></section></div><section class="row" ng-if="vm.pickupDateTime != null"><div class="col-xs-9 margin-bottom-md margin-top-md text-uppercase"><div class="font-bold">Customer Pick Up</div><div>{{vm.pickupDateTime | date:\'EEE, MMMM d\'}} at {{ vm.pickupDateTime | date:\'h:mm a\'}}</div></div><div class="col-xs-3 margin-bottom-md margin-top-md text-right">{{ 0.00 | currency}}</div></section><div ng-if="!vm.invoice.lineItems || !vm.invoice.lineItems.length"><div class="col-xs-12 margin-bottom-md margin-top-md text-center">No line items were found</div></div><div class="row margin-top-md"><h3 class="col-xs-12 text-right text-uppercase" ng-if="vm.shopSupplies">ShopSupplies: {{vm.shopSupplies | currency}}</h3><h3 class="col-xs-12 text-right text-uppercase" ng-if="vm.fee">Fee: {{vm.fee | currency}}</h3><h3 class="col-xs-12 text-right text-uppercase" ng-if="vm.tax">Tax: {{vm.tax | currency}}</h3><h3 class="col-xs-12 text-right text-uppercase">Total: {{vm.invoice.totalWithDelivery | currency}}</h3></div></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/shared/layouts/content-only.view.html','<div class="consumer" ui-view=""></div>');
$templateCache.put('app/areas/consumer/shared/layouts/error.view.html','<div class="header row ibox-content"><div class="col-xs-12 text-center"><strong>Error Processing Request</strong></div></div><div class="centered-content text-center not-found-msg"><i class="material-icons">error_outline</i><div>There was an error while processing your request, please try your request again.</div></div>');
$templateCache.put('app/areas/consumer/shared/layouts/not-found.view.html','<div class="header row ibox-content"><div class="col-xs-12 text-center"><strong>Page Not Found</strong></div></div><div class="centered-content text-center not-found-msg"><i class="material-icons">error_outline</i><div>The page you\'re trying to reach could not be found.</div></div>');
$templateCache.put('app/areas/consumer/shared/views/dealer-details.view.html','<div class="modal-body padding-left-lg padding-right-lg m-b-64"><div class="text-center margin-bottom-md"><i class="material-icons material-icons-large28 cursor-pointer" ng-click="vm.close()">highlight_off</i></div><img ng-src="{{vm.dealerStaticMapUrl}}" class="full-width"><div class="row padding-top-lg margin-bottom-30"><a ng-href="{{vm.googleAddressLink}}" target="_blank" class="text-primary"><div class="col-xs-2 theme-link"><i class="material-icons material-icons-large">place</i></div><div class="col-xs-10 font-bold text-big"><div>{{vm.dealer.name}}</div><div>{{ vm.dealer.address }}</div><div>{{ vm.dealer.city }}, {{ vm.dealer.state }} {{ vm.dealer.zip }}</div></div></a></div><div class="row padding-top-md margin-bottom-30"><a ng-href="tel:{{vm.dealer.mainPhoneNumber}}" class="text-primary"><div class="col-xs-2 theme-link"><i class="material-icons material-icons-large">call</i></div><div class="col-xs-10 font-bold text-uppercase text-big">Call: {{ vm.dealer.mainPhoneNumber | tel }}</div></a></div><div class="row padding-top-md" ng-if="vm.dealer.smsNumber"><a ng-href="sms:{{vm.dealer.smsNumber}}" class="text-primary"><div class="col-xs-2 theme-link"><i class="material-icons material-icons-large">forum</i></div><div class="col-xs-10 font-bold text-uppercase text-big">Text: {{ vm.dealer.smsNumber | tel }}</div></a></div></div><div class="modal-footer details-footer"><div class="text-center"><div class="margin-bottom-md" ng-if="!vm.dealer.providerName || (vm.dealer.providerName && vm.dealer.providerName.toLowerCase() !== \'uber\')"><a ng-if="vm.dealer.externalTermsPageUrl === \'None\'" target="_blank" class="theme-link font-size-12" ui-sref="consumer-terms-page({ dealerId: vm.dealer.id, tripTypeId: vm.appInfo.tripTypeId, tripTypeInstanceId: vm.appInfo.tripTypeInstanceId, appType: vm.appInfo.appType, termsText: vm.appInfo.termsText })"><u>Terms and Conditions</u></a> <a ng-if="vm.dealer.externalTermsPageUrl !== \'None\'" target="_blank" class="theme-link font-size-12" ng-href="{{ vm.dealer.externalTermsPageUrl }}"><u>Terms and Conditions</u></a></div><div class="margin-bottom-md"><a ng-if="vm.dealer.externalPrivacyPageUrl === \'None\'" target="_blank" class="theme-link font-size-12" ui-sref="consumer-privacy-page({ dealerId: vm.dealer.id, tripTypeId: vm.appInfo.tripTypeId, tripTypeInstanceId: vm.appInfo.tripTypeInstanceId, appType: vm.appInfo.appType})"><u>Privacy</u></a> <a ng-if="vm.dealer.externalPrivacyPageUrl !== \'None\'" target="_blank" class="theme-link font-size-12" ng-href="{{ vm.dealer.externalPrivacyPageUrl }}"><u>Privacy</u></a></div></div></div>');
$templateCache.put('app/areas/checkin/components/add-services/checkin-add-services.view.html','<div class="display-flex content-center border-bottom margin-bottom-md"><h3 class="font-size-14 font-normal"><div class="black">SERVICES</div></h3><div ng-if="vm.canViewServiceHistory" class="text-danger bold text-uppercase cursor-pointer flex-right" ng-click="vm.checkinSettings.roHistoryPanelOpen = true">Vehicle service history</div></div><div><div class="text-break" ng-repeat="serviceGroup in vm.serviceGroups" ng-if="!vm.isLoading && (serviceGroup.showIfEmpty || (vm.services | filter: { serviceGroupType: serviceGroup.serviceGroupType }).length > 0)"><uib-accordion class="gray-body rounded-sm no-padding-body accordion-margin-bottom-md"><div uib-accordion-group="" is-disabled="true" is-open="serviceGroup.isExpanded"><uib-accordion-heading><div class="display-flex content-center"><span ng-click="serviceGroup.isExpanded = !serviceGroup.isExpanded"><i class="material-icons md-24 block" ng-if="!serviceGroup.isExpanded">expand_more</i> <i class="material-icons md-24 block" ng-if="serviceGroup.isExpanded">expand_less</i></span> <span class="text-uppercase" ng-click="serviceGroup.isExpanded = !serviceGroup.isExpanded">{{::serviceGroup.name}}</span><div class="flex-right padding-right-md display-flex content-center"><i ng-if="serviceGroup.showWarning" class="material-icons md-14 theme-link margin-right-sm">warning</i><div ng-bind="(vm.services | filter: { serviceGroupType: serviceGroup.serviceGroupType }).length"></div><div ng-if="(vm.services | filter: { isSelected: true, serviceGroupType: serviceGroup.serviceGroupType }).length > 0" ng-bind="\'(\' + (vm.services | filter: { isSelected: true, serviceGroupType: serviceGroup.serviceGroupType }).length + \' selected)\'" class="margin-left-sm"></div></div></div></uib-accordion-heading><div class="panel-body padding-none"><checkin-service-card ng-repeat="service in vm.services | filter: { serviceGroupType: serviceGroup.serviceGroupType }" service="service" service-group="serviceGroup" class="block margin-bottom-md" ng-class="{\'border-bottom padding-bottom-md\': !$last}" department="vm.selectedDepartment" dealer-service-types="vm.dealerServiceTypes" dispatch-codes="vm.dispatchOpCodes" require-dispatch-code="vm.requireDispatchCode" appointment="vm.appointment" services="vm.services" checkin-settings="vm.checkinSettings"></checkin-service-card><div ng-if="serviceGroup.serviceGroupType === vm.serviceGroupTypes.recommendedMaintenance && vm.recMaintDisclaimer" ng-bind-html="vm.recMaintDisclaimer" class="margin-top-sm font-size-10 margin-bottom-md"></div><div ng-if="!(vm.services | filter: { serviceGroupType: serviceGroup.serviceGroupType }).length" class="margin-bottom">No {{serviceGroup.name}} were found for this vehicle.</div></div></div></uib-accordion></div><div ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"> <strong>Loading</strong></div><div ng-if="!vm.isLoading"><input type="hidden" ng-model="vm.checkinSettings" id="services-validation" name="services-validation" validation="custom: vm.validateServices():alt=*"><div ng-if="!vm.checkinSettings.selectedServicesCount" class="text-danger margin-bottom-sm">*Please select at least one service from the list above.</div></div></div>');
$templateCache.put('app/areas/inspect/views/components/inspect-media-viewer.component.view.html','<div class="inspect-media-viewer"><div ng-if="vm.isLoading"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> LOADING...</span></div><div ng-if="!vm.isLoading"><div class="row margin-bottom text-uppercase" ng-if="vm.hasNoMedia()"><div class="col-xs-12">THERE IS NO EXISTING MEDIA.</div></div><div class="row border-bottom margin-bottom text-uppercase" ng-if="vm.lineItem.existingImages && vm.lineItem.existingImages.length > 0"><div class="col-xs-12 text-bold margin-bottom-sm">Previously Added Media <span class="font-normal">(click to select for removal)</span></div></div><div class="existing-image-grid" ng-if="vm.lineItem.existingImages && vm.lineItem.existingImages.length > 0"><div class="grid-item margin-bottom" ng-repeat="image in vm.lineItem.existingImages track by $index"><div class="small-grey-boxes position-relative" ng-class="{\'selected\': image.selected}"><video class="link" ng-src="{{image.mediaUrl}}" ng-if="image.mediaType === vm.mediaTypes.video" ng-click="vm.selectedImageClicked(image)"></video><img class="link" ng-src="{{image.mediaUrl}}" ng-if="image.mediaType === vm.mediaTypes.photo" ng-click="vm.selectedImageClicked(image)"><div class="selected-overlay link" ng-if="image.selected" ng-click="vm.selectedImageClicked(image)"></div><i class="theme-text link md-36 image-selected material-icons" ng-if="image.selected" ng-click="vm.selectedImageClicked(image)">cancel</i></div></div></div><div class="row border-bottom margin-bottom margin-top text-uppercase" ng-if="vm.lineItem.availImages && vm.lineItem.availImages.length > 0"><div class="col-xs-12 text-bold margin-bottom-sm">Available Media <span class="font-normal">(click to select to add)</span></div></div><div class="romedia-image-grid margin-top" ng-if="vm.lineItem.availImages && vm.lineItem.availImages.length > 0"><div class="grid-item margin-bottom" ng-repeat="image in vm.lineItem.availImages track by $index"><div class="small-grey-boxes position-relative" ng-class="{\'selected\': image.selected}"><video class="link" ng-src="{{image.mediaUrl}}" ng-if="image.mediaType === vm.mediaTypes.video" ng-click="vm.newImageClicked(image)"></video><img class="link" ng-src="{{image.mediaUrl}}" ng-if="image.mediaType === vm.mediaTypes.photo" ng-click="vm.newImageClicked(image)"><div class="selected-overlay link" ng-if="image.selected" ng-click="vm.newImageClicked(image)"></div><i class="theme-text link md-36 image-selected material-icons" ng-if="image.selected" ng-click="vm.newImageClicked(image)">check_circle</i></div></div></div></div></div>');
$templateCache.put('app/areas/inspect/views/components/inspect-my-recommendations.component.view.html','<div class="override-xs-margin-bottom-sm"><div class="display-flex content-center text-color-dark-gray font-size-12 font-bold"><i class="inline pull-left material-icons material-icons-large ng-scope link" ng-click="vm.updateIsVisible();" ng-if="vm.showMyRecs">expand_less</i><i class="inline pull-left material-icons material-icons-large ng-scope link" ng-click="vm.updateIsVisible();" ng-if="!vm.showMyRecs">expand_more</i> MY RECOMMENDATIONS</div><div class="margin-bottom-sm margin-left-sm" ng-if="!vm.isLoading && vm.showMyRecs && !(vm.lineItems | filter: vm.myRecommendationsFilter).length">No Recommendations</div><div ng-if="!vm.isLoading && (vm.lineItems | filter: vm.myRecommendationsFilter).length && vm.showMyRecs" class="margin-left-sm margin-top-md margin-bottom-md link" ng-repeat="rec in vm.lineItems | filter: vm.myRecommendationsFilter" ng-click="vm.recommendationClicked($event, rec)"><div class="ellipsis-overflow font-size-12">{{rec.formattedCorrection}}</div><div class="font-size-11 text-color-med-gray margin-left-sm">Status: {{ vm.lineItemStatusText[rec.authorizationStatus] || \'Unknown\' }}</div></div></div>');
$templateCache.put('app/areas/inspect/views/components/inspect-original-customer-requests.component.view.html','<div class="override-xs-margin-bottom-sm"><div class="display-flex content-center text-color-dark-gray font-size-12 font-bold"><i class="inline pull-left material-icons material-icons-large ng-scope link" ng-click="vm.updateIsVisible();" ng-if="vm.showOriginalRequests">expand_less</i><i class="inline pull-left material-icons material-icons-large ng-scope link" ng-click="vm.updateIsVisible();" ng-if="!vm.showOriginalRequests">expand_more</i> ORIGINAL REQUESTS</div><div class="margin-bottom-sm margin-left-sm" ng-if="!vm.isLoading && !(vm.lineItems | filter:vm.originalRequestsFilter).length">No Original Requests</div><div ng-if="!vm.isLoading && (vm.lineItems | filter:vm.originalRequestsFilter).length && vm.showOriginalRequests" class="margin-top-md margin-bottom-md link margin-left-sm" ng-repeat="req in vm.lineItems | filter:vm.originalRequestsFilter" ng-click="vm.originalRequestClicked(req)"><div class="ellipsis-overflow font-size-12"><span><strong ng-if="req.opCode">{{ req.opCode }} -</strong> <strong ng-if="req.name">{{req.name}}<span ng-if="req.formattedComplaint">:</span></strong> <span ng-if="req.formattedComplaint">{{req.formattedComplaint}}</span></span></div><div class="font-size-11 text-color-med-gray margin-left-sm">Status: {{ vm.lineItemStatusText[req.authorizationStatus] || \'Unknown\' }}</div></div></div>');
$templateCache.put('app/areas/inspect/views/components/inspect-search-op-codes.component.view.html','<div class="font-normal"><select select2="" id="opcode-search{{vm.lineItem.id}}" name="opcode-search{{vm.lineItem.id}}" placeholder="Opcode" on-change="vm.opCodeSelected(selectedResult)" min-input-length="1" allow-any-input-on-empty-results="false" format-for-selection="vm.formatForSelection" format-for-dropdown="vm.formatForDropdown" query="vm.opCodeSearchQuery" ng-model="vm.lineItem.selectedOpCode" ng-disabled="vm.disabled" class="select2-single form-control" dropdown-parent="{{vm.dropdownParent}}"></select></div>');
$templateCache.put('app/areas/inspect/views/components/line-item-estimate.view.html','<div class="no-print" ng-class="{\'parts-associate-required\': vm.showPartsAssociate() }"><div ng-if="vm.lineItem.authorizationStatus === vm.lineItemStatuses.needsReApproval" class="alert alert-warning display-flex content-center margin-bottom padding-md border-radius-md fit-content"><i class="material-icons md-16 margin-right-md">warning</i> Customer approval out of date. This line needs to be sent to the customer again in order for the latest changes to be approved.</div><div class="row margin-bottom"><div class="col-sm-7 col-xs-12"><inspect-search-op-codes line-item="vm.lineItem" dealer-id="vm.dealerId" department-id="vm.ro.dealerDepartmentId" disabled="!vm.lineItem" on-op-code-selected="vm.updateTotalCharge()" dropdown-parent=".modal-content"></inspect-search-op-codes></div></div><div class="row border-bottom-psuedo"><div class="col-xs-10 text-bold">Labor</div><div class="col-xs-1 text-bold padding-left-none text-right padding-right-none">Total</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-top-md align-middle vertical-align"><div class="col-xs-7 padding-right-none"><div class="row align-middle"><div class="col-xs-4 field-wrapper width-percent-32 padding-right-md"><label for="payType{{vm.lineItem.id}}">Pay Type</label><select selectlabel="" class="form-control" id="payType{{vm.lineItem.id}}" name="payType{{vm.lineItem.id}}" ng-disabled="vm.lineItem.noLaborCharge" ng-options="payType as payType.name for payType in vm.laborRateSettings.defaultPayTypes" ng-model="vm.lineItem.selectedPayType" ng-change="vm.onPayTypeChanged();" validation="required:alt=Required" required=""></select></div><div class="col-xs-3 field-wrapper padding-left-none"><div class="full-width" ng-if="vm.isCustomerPayType() && !vm.laborRateSettings.useMatrixRate"><label for="payType{{vm.lineItem.id}}">Rate Type</label><select selectlabel="" class="form-control" id="fixedRate{{vm.lineItem.id}}" name="fixedRate{{vm.lineItem.id}}" ng-disabled="vm.lineItem.noLaborCharge" ng-options="fixedRate as fixedRate.name for fixedRate in vm.laborRateSettings.customLaborRateOptions" allow-null-option="Rate Type" ng-model="vm.lineItem.selectedFixedRate" ng-change="vm.onFixedRateChanged();" ng-required="vm.lineItem.authorizationStatus !== vm.lineItemStatuses.na"></select></div><div class="full-width" ng-if="vm.isCustomerPayType() && vm.laborRateSettings.useMatrixRate"><label for="payType{{vm.lineItem.id}}">Rate Type</label><select selectlabel="" class="form-control" id="laborMatrix{{vm.lineItem.id}}" name="laborMatrix{{vm.lineItem.id}}" ng-disabled="vm.lineItem.noLaborCharge" ng-options="laborMatrix as laborMatrix.name for laborMatrix in vm.laborRateSettings.matrixRateOptions" allow-null-option="Rate Type" ng-model="vm.lineItem.selectedLaborMatrix" ng-change="vm.onLaborMatrixChanged();" ng-required="vm.lineItem.authorizationStatus !== vm.lineItemStatuses.na"></select></div></div><div class="padding-left-none padding-right-none col-xs-2"><input type="number" min="0" step="any" class="form-control better-placeholder no-spinners" placeholder="HOURS" ng-model="vm.lineItem.laborHours" ng-disabled="vm.lineItem.noLaborCharge" ng-change="vm.onLaborMatrixChanged();" name="hours" validation="required" required=""></div><div class="col-xs-3"><input class="form-control better-placeholder no-spinners" placeholder="Rate" ng-model="vm.lineItem.laborRate" ng-disabled="vm.lineItem.noLaborCharge" ng-change="vm.calculateLaborCharge();" ng-readonly="(vm.lineItem.selectedLaborMatrix && vm.isCustomerPayType()) || vm.lineItem.pricing.isManualLaborRate" ng-class="{\'strike-through\': vm.lineItem.pricing.isManualLaborRate}" name="rate" validation="numeric" required="" format-currency-with-dollar=""></div></div></div><div class="col-xs-3 text-nowrap"><label class="display-flex content-center margin-bottom-none"><span class="font-normal">No Labor Charge&nbsp;</span> <input class="margin-right-sm margin-top-none" type="checkbox" name="noLaborCharge{{vm.lineItem.id}}" value="vm.lineItem.noLaborCharge" ng-model="vm.lineItem.noLaborCharge" ng-change="vm.onNoLaborChargeClicked()"></label>&nbsp;</div><div class="col-xs-1 padding-left-none text-right inline padding-right-none text-bold"><div ng-if="vm.lineItem.pricing.isManualLaborRate"><input type="text" min="0" class="form-control better-placeholder no-spinners text-right" ng-model="vm.lineItem.laborCharge" name="manualLaborTotal{{vm.lineItem.id}}" ng-change="vm.updateTotalCharge()" placeholder="Labor Total" validation="numeric" ng-disabled="vm.lineItem.noLaborCharge || vm.lineItem.useFlatPrice" ng-model-options="{ debounce: 400 }" format-currency-with-dollar=""></div><div ng-if="!vm.lineItem.pricing.isManualLaborRate"><span ng-class="{ \'strike-through\': vm.lineItem.noLaborCharge || vm.lineItem.useFlatPrice}">{{vm.lineItem.laborCharge || 0 | currency}}</span></div></div><div class="col-xs-1">&nbsp;</div></div><div class="row border-bottom-psuedo margin-top-20"><div class="col-xs-11 text-bold">Parts</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-top-md align-middle vertical-align"><div class="col-xs-5 padding-right-none"><select name="partsSearch" multiple="" id="parts-search" ui-select2="vm.partsSearchSettings" ng-model="vm.partsSearch" class="select2-single form-control"></select></div><div class="col-xs-2"><div ng-if="vm.addingPart"><img src="assets/images/ajax-loader.gif"></div></div><div class="text-nowrap padding-left-none" ng-class="{\'col-xs-3\': (!vm.lineItem.parts || vm.lineItem.parts.length === 0), \'col-xs-4\': vm.lineItem.parts.length > 0, \'has-parts\': vm.lineItem.parts.length > 0}"><label id="no-parts-charge" ng-class="{\'display-flex\': (!vm.lineItem.parts || vm.lineItem.parts.length === 0)}"><span class="font-normal">No Parts Charge&nbsp;</span> <input class="margin-right-sm margin-top-none" type="checkbox" name="noPartsCharge{{vm.lineItem.id}}" value="vm.lineItem.noPartsCharge" ng-model="vm.lineItem.noPartsCharge" ng-change="vm.onNoPartsChargeClicked()"> &nbsp;</label></div><div class="col-xs-1 padding-left-none text-right padding-right-none text-bold inline" ng-class="{ \'strike-through\': vm.lineItem.useFlatPrice}" ng-if="!vm.lineItem.parts || vm.lineItem.parts.length === 0">{{ vm.lineItem.partsCharge || 0 | currency }}</div><div class="col-xs-1">&nbsp;</div></div><div ng-if="vm.lineItem.parts.length"><div class="display-grid gap-8 col-parts-list border-bottom padding-bottom-sm margin-top margin-bottom-md text-bold"><div>Part No/Desc</div><div class="text-center">QOH</div><div class="text-center">BIN</div><div class="text-center">Hold</div><div>Avail</div><div>Qty</div><div>Price</div><div ng-if="::vm.showPartsAssociate()">Parts Associate</div><div></div><div><i class="material-icons md-18 position-relative link" ng-click="vm.printSummary()"><div class="padding-top-sm padding-left-xs">print</div></i></div></div><div class="display-grid gap-8 col-parts-list relative margin-top" ng-repeat="part in vm.lineItem.parts"><div class="display-grid col-40-60-percent content-center" title="{{ part.partNumber }} - {{ part.description && part.description.trim() || \'Description not available\' }}"><div class="ellipsis-overflow">{{ part.partNumber }}</div><div class="margin-left-sm"><input type="text" class="better-placeholder form-control" placeholder="Description" ng-model="part.description" name="description{{part.id}}" validation-error-to="#validation-messages" validation="required:alt=Description, availability, and quantity are required fields." required="" expandable-input=""></div></div><div class="text-center">{{ part.isDmsLoaded ? part.quantityOnHand : \'\' }}</div><div class="ellipsis-overflow text-center">{{ part.isDmsLoaded ? part.bin : \'\' }}</div><div class="text-center">{{ part.isDmsLoaded ? (part.quantityOnHold == 0 ? \'NO\' : part.quantityOnHold) : \'\' }}</div><div class="field-wrapper"><label for="in_stock{{part.id}}" class="on">AVAILABILITY</label><select selectlabel="" required="" class="form-control" ng-model="part.partsAvailabilityId" id="in_stock{{part.id}}" allow-null-option="AVAILABILITY" name="in_stock{{part.id}}" validation-error-to="#validation-messages" validation="required:alt=Description, availability, and quantity are required fields." ng-change="vm.updateTotalCharge(true, part)" ng-options="s.id as s.name for s in vm.partsAvailability"></select></div><div><input type="number" min="1" class="form-control better-placeholder no-spinners text-align-right" placeholder="QTY" ng-model="part.quantity" name="quantity{{part.id}}" clean="true" required="" validation-error-to="#validation-messages" validation="required:alt=Description, availability, and quantity are required fields." mask="9?9?9?9?9?9?9?9?9" mask-restrict="reject" ng-change="vm.updateTotalCharge(false, part)"></div><div class="block relative"><input type="text" class="form-control better-placeholder text-right no-spinners" placeholder="Price" ng-model="part.displayPrice" name="price{{part.id}}" ng-change="vm.updateTotalCharge(false, part)" validation="numeric" ng-model-options="{ debounce: 400 }" format-currency-with-dollar=""></div><div class="field-wrapper" ng-if="::vm.showPartsAssociate()"><label for="partsAssociate{{part.id}}" class="on">Parts Associate</label><select selectlabel="" class="form-control" ng-model="part.selectedPartsAssociate" ng-change="vm.partsAssociateChanged(part)" id="partsAssociate{{part.id}}" name="partsAssociate{{part.id}}" ng-options="u as u.fullName for u in vm.getAvailablePartsAssociates(part) track by u.id"></select></div><div class="text-right">{{ part.quantity * part.displayPrice | currency }}</div><div><div ng-if="part.removingPart"><img src="assets/images/ajax-loader.gif"></div><span ng-if="!part.removingPart" class="cursor-pointer" title="Remove Part" ng-disabled="vm.addingPart || vm.removingPart" ng-click="vm.removePart(part)"><b><i class="material-icons width-10 md-24 theme-link">remove</i></b></span></div></div><div class="row validation text-notransform text-right padding-right-md margin-right-md margin-top-sm" id="validation-messages"></div><div class="display-grid gap-8 col-parts-list margin-top"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div ng-if="::vm.showPartsAssociate()"></div><div class="parts-subtotal text-right no-right-padding inline"><b ng-class="{ \'strike-through\': vm.lineItem.noPartsCharge || vm.lineItem.useFlatPrice}">{{ vm.lineItem.partsCharge || 0 | currency }}</b></div><div></div></div></div><div class="row border-bottom-psuedo margin-top-20"><div class="col-xs-11 text-bold">Retail</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-top-md align-middle vertical-align text-nowrap"><div class="col-xs-3"><label class="display-flex content-center margin-bottom-none"><span class="font-normal">Use flat price</span>&nbsp; <input class="margin-right-sm margin-top-none" type="checkbox" name="useFlatPrice{{vm.lineItem.id}}" value="vm.lineItem.useFlatPrice" ng-model="vm.lineItem.useFlatPrice" ng-change="vm.onUseFlatPriceClicked()"></label></div><div class="col-xs-7 padding-left-none"><div class="row"><div class="col-xs-6 padding-left-none padding-right-none"><input type="text" min="0" ng-disabled="!vm.lineItem.useFlatPrice" name="flatRetailAmount{{vm.lineItem.id}}" ng-model="vm.lineItem.pricing.flatRetailAmount" class="form-control better-placeholder no-spinners" ng-change="vm.updateTotalCharge(false)" placeholder="RETAIL PRICE" validation="numeric" ng-model-options="{ debounce: 400 }" format-currency-with-dollar=""></div></div></div><div class="col-xs-1 padding-left-none text-right padding-right-none text-bold inline">{{ vm.lineItem.pricing.flatRetailAmount || 0 | currency }}</div><div class="col-xs-1">&nbsp;</div></div><div class="row border-bottom-psuedo margin-top-20"><div class="col-xs-11 text-bold">Taxes/Fees</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-top-md align-middle vertical-align"><div class="col-xs-10 block"><div class="row align-middle padding-right-none full-width"><div class="col-xs-5 padding-right-none margin-top-md"><div class="row"><div class="col-xs-7 col-estimate-taxes text-nowrap padding-right-none">TAX <span ng-if="vm.isFixedTaxRate && vm.lineItem.pricing.tax == 0" title="Taxes are computed as a flat rate at the RO level">NA</span> <span ng-if="!vm.isFixedTaxRate && vm.lineItem.pricing.tax == 0">{{vm.lineItem.pricing.tax | currency}}</span> <span ng-if="vm.lineItem.pricing.tax" ng-class="{\'strike-through\': vm.lineItem.pricing.isTaxExempt}">{{ vm.lineItem.pricing.tax | currency }}</span><span class="text-danger font-normal" ng-if="vm.lineItem.pricing.taxesPendingUpdate"><br>PENDING</span></div><div class="col-xs-4 text-nowrap padding-right-none"><label class="display-flex content-center margin-bottom-none"><span class="font-normal">Exempt</span>&nbsp; <input class="margin-right-sm margin-top-none" type="checkbox" name="taxExempt{{vm.lineItem.id}}" value="vm.lineItem.pricing.isTaxExempt" ng-model="vm.lineItem.pricing.isTaxExempt" ng-change="vm.updateTotalCharge(vm.lineItem.pricing.isTaxExempt);"></label></div></div></div><div class="col-xs-5 padding-left-none padding-right-none"><div class="row"><div class="col-xs-7 margin-top-md text-nowrap padding-left-none"><label class="margin-bottom-none font-normal">Shop Supplies</label> <span ng-class="{ \'strike-through\': vm.lineItem.pricing.waiveShopSupplies}">{{ vm.lineItem.pricing.shopSupplies | currency }}</span></div><div class="col-xs-5 margin-top-md text-nowrap"><label class="display-flex content-center margin-bottom-none pull-right"><span class="font-normal">Waive</span>&nbsp; <input class="margin-right-sm margin-top-none" type="checkbox" name="waiveShopSupplies{{vm.lineItem.id}}" value="vm.lineItem.pricing.waiveShopSupplies" ng-model="vm.lineItem.pricing.waiveShopSupplies" ng-change="vm.updateTotalCharge(vm.lineItem.pricing.waiveShopSupplies);"></label></div></div></div><div class="col-xs-2 text-nowrap padding-right-none"><input class="form-control better-placeholder no-spinners" name="fee" ng-model="vm.lineItem.pricing.fee" ng-change="vm.updateTotalCharge(false);" placeholder="ADD FEE" validation="numeric" ng-model-options="{ debounce: 400 }" format-currency-with-dollar=""></div></div></div><div class="col-xs-1 padding-left-none inline text-right padding-right-none text-bold">{{vm.lineItem.pricing.taxesAndFees | currency}}<span class="text-danger font-normal" ng-if="vm.lineItem.pricing.taxesPendingUpdate"><br>Pending</span></div><div class="col-xs-1">&nbsp;</div></div></div><div id="print-to-pdf" class="print-to-pdf"><div class="print-to-pdf-only"><div class="font-size-16"><b>{{ vm.today | date:\'MMM dd, yyyy\'}}<br><span class="font-size-14">{{vm.dealerDetails.name}}<br>{{vm.dealerDetails.servicePhoneNumber | tel}}<br>RO #{{vm.ro.dmsRepairOrderNumber || \'PENDING\'}}</span><br><br><u>Customer</u></b><br><span class="font-size-14">{{vm.ro.customer.firstName}} {{vm.ro.customer.lastName}}<br>{{vm.ro.vehicle.year}} {{vm.ro.vehicle.make}} {{vm.ro.vehicle.model}}</span><br><span class="font-size-14" ng-if="vm.ro.vehicle.vin">{{vm.ro.vehicle.vin}}<br></span><br><b><u>Advisor</u></b><br><span class="font-size-14">{{vm.ro.serviceAdvisor.firstName}} {{vm.ro.serviceAdvisor.lastName}}<br>{{vm.ro.serviceAdvisor.officePhone | tel}}</span></div><table id="print-parts-summary" class="table full-width margin-top-lg"><thead><tr><td class="padding-top-none padding-bottom-none"><center>Part #</center></td><td class="padding-top-none padding-bottom-none"><center>Desc</center></td><td class="padding-top-none padding-bottom-none"><center>QOH</center></td><td class="padding-top-none padding-bottom-none"><center>BIN</center></td><td class="padding-top-none padding-bottom-none"><center>QTY</center></td><td class="padding-top-none padding-bottom-none"><center>Price</center></td><td class="padding-top-none padding-bottom-none"><center>Total</center></td></tr></thead><tr ng-repeat="part in vm.lineItem.parts"><td class="border-none padding-top-none padding-bottom-none">{{ part.partNumber }}</td><td class="border-none padding-top-none padding-bottom-none">{{ part.description}}</td><td class="border-none padding-top-none padding-bottom-none"><center>{{ part.isDmsLoaded ? part.quantityOnHand : \'\' }}</center></td><td class="border-none padding-top-none padding-bottom-none">{{ part.isDmsLoaded ? part.bin : \'\' }}</td><td class="border-none padding-top-none padding-bottom-none"><center>{{part.quantity}}</center></td><td class="border-none padding-top-none padding-bottom-none text-right">{{part.displayPrice | currency}}</td><td class="border-none padding-top-none padding-bottom-none text-right">{{ part.quantity * part.displayPrice | currency }}</td></tr><tr><td colspan="5" class="border-none padding-top-none padding-bottom-none"></td><td class="total-cell text-right padding-top-none padding-bottom-none"><b>Total</b></td><td class="total-cell text-right padding-top-none padding-bottom-none"><div class="text-right no-right-padding inline"><b ng-class="{ \'strike-through\': vm.lineItem.noPartsCharge || vm.lineItem.useFlatPrice}">{{ vm.lineItem.partsCharge || 0 | currency }}</b></div></td></tr></table></div></div><div id="repeating-footer" class="print-to-pdf"><div class="font-bold font-size-11 margin-none"><b>Parts List For:</b></div><div class="font-size-11 margin-none">RO# {{ vm.ro.dmsRepairOrderNumber || \'PENDING\' }} <span class="ro-name">{{ vm.ro.customer.name }}</span> <span id="vehicle">{{ vm.ro.vehicle.year }} {{ vm.ro.vehicle.make }} {{ vm.ro.vehicle.model }}</span></div></div>');
$templateCache.put('app/areas/inspect/views/components/line-item-recommendation.view.html','<div class="ng-hide" ng-show="!vm.showMediaViewer"><div class="row margin-bottom"><div class="col-xs-5"><ui-select ng-model="vm.lineItem.severity" class="severity-select icon-ui-select"><ui-select-match placeholder="Severity"><div class="display-flex content-center"><i ng-if="$select.selected.value.cssClass" class="material-icons md-14 {{ $select.selected.value.cssClass}}">{{ $select.selected.value.icon}}</i> <span class="severity-value padding-left-sm">{{ $select.selected.value.text }}</span></div></ui-select-match><ui-select-choices repeat="item.value.value as (key, item) in vm.lineItemSeverities"><div class="display-flex content-center"><i ng-if="item.value.cssClass" class="material-icons md-14 {{item.value.cssClass}}">{{item.value.icon}}</i> <span ng-if="!item.value.cssClass" class="no-icon"></span> <span ng-bind-html="item.value.text"></span></div></ui-select-choices></ui-select></div></div><div class="margin-bottom"><tags-input id="observation_search_{{vm.lineItem.id}}" name="observation_search_{{vm.lineItem.id}}" placeholder="Observation/Concern/Complaint" min-length="3" replace-spaces-with-dashes="false" add-on-space="false" use-strings="true" enable-editing-last-tag="true" key-property="name" display-property="name" ng-model="vm.lineItem.complaints" on-tag-clicked="vm.tagClicked($tag, vm.lineItem, true)" class="editable-tags gray-pills" on-tag-removed="vm.onTagRemoved(vm.lineItem, true)" ng-class="{\'required\': vm.lineItem.complaintRequired}" validation="{{vm.lineItem.complaintRequired ? \'required\': \'\'}}"><auto-complete source="vm.searchObservations($query)" highlight-matched-text="false" display-property="name" debounce-delay="300"></auto-complete></tags-input></div><div class="margin-bottom display-flex content-center flex-gap-md" ng-if="vm.lineItem.isEditingComplaint"><div class="block relative flex-percent-50 flex-grow"><input type="text" name="editComplaint_{{vm.lineItem.id}}" class="form-control better-placeholder" ng-model="vm.lineItem.tagContent" placeholder="Edit Complaint" ng-keyup="$event.keyCode === 13 && vm.closeTagEdit(true, vm.lineItem)"></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(true, vm.lineItem)">Save</button></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(false, vm.lineItem)">Cancel</button></div></div><div class="margin-bottom"><tags-input id="recommendation_search_{{vm.lineItem.id}}" name="recommendation_search_{{vm.lineItem.id}}" placeholder="Recommendation/Correction" min-length="3" replace-spaces-with-dashes="false" add-on-space="false" use-strings="true" enable-editing-last-tag="true" key-property="name" display-property="name" ng-model="vm.lineItem.corrections" on-tag-clicked="vm.tagClicked($tag, vm.lineItem, false)" class="editable-tags gray-pills" on-tag-removed="vm.onTagRemoved(vm.lineItem, false)" ng-class="{\'required\': vm.lineItem.correctionRequired}" validation="{{vm.lineItem.correctionRequired ? \'required\': \'\'}}"><auto-complete source="vm.searchRecommendations($query)" highlight-matched-text="false" display-property="name" debounce-delay="300"></auto-complete></tags-input></div><div class="margin-bottom display-flex content-center flex-gap-md" ng-if="vm.lineItem.isEditingCorrection"><div class="block relative flex-percent-50 flex-grow"><input type="text" name="editCorrection_{{vm.lineItem.id}}" class="form-control better-placeholder" ng-model="vm.lineItem.tagContent" placeholder="Edit Correction" ng-keyup="$event.keyCode === 13 && vm.closeTagEdit(true, vm.lineItem)"></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(true, vm.lineItem)">Save</button></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(false, vm.lineItem)">Cancel</button></div></div><div class="margin-bottom"><div class="block relative"><input type="text" id="cause" name="cause_{{vm.lineItem.id}}" class="form-control better-placeholder" ng-model="vm.lineItem.cause" placeholder="CAUSE"></div></div><div class="margin-bottom display-flex content-center flex-gap-md"><div class="block relative flex-percent-50 flex-grow"><input type="text" id="new-shop-note" name="shopNote_{{vm.lineItem.id}}" class="form-control better-placeholder" ng-model="vm.lineItem.newNote" placeholder="ENTER SHOP NOTE"></div><button type="button" class="btn btn-default" ng-click="vm.addNote()"><span>ADD</span></button></div><div class="margin-bottom"><div class="font-size-14 display-flex content-center margin-bottom-sm cursor-pointer" ng-click="vm.lineItem.shopNotesExpanded = !vm.lineItem.shopNotesExpanded"><span class="font-bold">Shop Notes ({{vm.lineItem.notes.length || 0 }})</span> <i ng-if="vm.lineItem.notes.length && vm.lineItem.shopNotesExpanded" class="material-icons md-23 theme-link" title="Close Notes">expand_less</i> <i ng-if="vm.lineItem.notes.length && !vm.lineItem.shopNotesExpanded" class="material-icons md-23 theme-link" title="Open Notes">expand_more</i></div><div ng-show="vm.lineItem.shopNotesExpanded"><div ng-repeat="shopNote in vm.lineItem.notes" class="margin-bottom-md"><div class="text-uppercase font-bold">{{ shopNote.dateCreated | fromNow }} ({{ shopNote.authorName }})</div><div>{{ shopNote.message }}</div></div></div></div><div class="row border-bottom-psuedo margin-top text-uppercase"><div class="col-xs-12 text-bold">MEDIA</div></div><div class="rec-modal display-flex flex-gap-md"><lineitem-image-display ng-model="vm.lineItem" class="padding-left-none"></lineitem-image-display><div class="display-flex flex-right margin-top"><div class="border-none w-45 h-34"><div><drag-drop-image ng-model="vm.imageToUpload" class="small-white-boxes ng-show" use-icon="true" placeholder="Add Photo" repeat-container="vm.lineItem.mediaItems" on-load="vm.addRecommendationImage" ng-hide="vm.addingImage" allow-video="true" drop-reference="vm.lineItem.id" large="" loading-text="UPLOADING IMAGE" error-text="" is-version-2="true" hide-btn-text="true" use-small-button="true"></drag-drop-image></div><div class="recs-image-spinner ng-hide" ng-show="vm.addingImage"><img src="assets/images/ajax-loader.gif"></div></div><div class="inspect-media-btn padding-right-none"><i class="material-icons md-24 link" ng-click="vm.mediaBtnClicked()">apps</i></div></div></div><div class="display-flex margin-top" ng-if="vm.loadingMedia"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> LOADING</span></div></div><div ng-if="vm.showMediaViewer"><inspect-media-viewer line-item="vm.lineItem" ro="vm.ro"></inspect-media-viewer></div>');
$templateCache.put('app/areas/inspect/views/modals/assign-to-modal.view.html','<div class="assign-to-modal"><div class="modal-header text-uppercase"><h5 class="margin-bottom-none">Route and Assign To</h5></div><div class="modal-body padding-bottom-sm" ng-if="!vm.loading"><div class="row margin-bottom"><div class="col-xs-12 field-wrapper"><label for="status" ng-class="{\'on z-index-2\': vm.selectedStatus}">STATUS</label><ui-select ng-model="vm.selectedStatus" search-enabled="false" class="icon-ui-select" ng-disabled="vm.saving || vm.loading" ng-change="vm.statusChanged()"><ui-select-match placeholder="STATUS"><div class="display-flex content-center"><div class="status-dot margin-right-sm" ng-style="{ \'background-color\': vm.selectedStatus.colorHex }"></div><i ng-if="vm.selectedStatus.hasNotification" class="material-icons md-14 margin-right-sm">notifications</i> <span>{{ vm.selectedStatus.name }}</span></div></ui-select-match><ui-select-choices repeat="s in vm.statuses"><div class="display-flex content-center"><i class="material-icons md-14" ng-style="{ \'color\': \'{{ s.colorHex || \'gray\' }}\' }">lens</i> <i ng-if="s.hasNotification" class="material-icons md-14">notifications</i> <span ng-if="!s.hasNotification" class="no-icon"></span>{{s.name}}</div></ui-select-choices></ui-select></div></div><div class="row margin-bottom"><div class="col-xs-12 field-wrapper"><label for="shop_flag" ng-class="{\'on z-index-2\': vm.selectedShopFlag}">SHOP FLAG</label><ui-select ng-model="vm.selectedShopFlag" search-enabled="false" class="icon-ui-select" ng-disabled="vm.saving || vm.loading"><ui-select-match placeholder="SHOP FLAG"><div class="display-flex content-center"><div class="status-dot margin-right-sm" ng-style="{ \'background-color\': vm.selectedShopFlag.color }"></div><span>{{ vm.selectedShopFlag.name }}</span></div></ui-select-match><ui-select-choices repeat="s in vm.shopFlags track by s.id"><div class="display-flex content-center"><i class="material-icons md-14" ng-style="{ \'color\': \'{{ s.color || \'gray\' }}\' }">lens</i> <span>{{s.name}}</span></div></ui-select-choices></ui-select></div></div><div class="row margin-bottom"><div class="col-xs-12"><div class="block relative field-wrapper"><label for="assignedTo">ASSIGN TO</label><select class="form-control" id="assignedTo" name="assignedTo" selectlabel="" ng-model="vm.assignedTo" ng-disabled="vm.saving || vm.loading" ng-options="u as u.fullName for u in vm.dealerUsers track by u.id"><option value="" selected="selected">Assign to</option></select></div></div></div><div class="row margin-bottom"><div class="col-xs-12"><div class="block relative field-wrapper"><label for="advisor">ADVISOR</label><select class="form-control" id="advisor" name="advisor" selectlabel="" ng-model="vm.selectedAdvisor" ng-disabled="vm.saving || vm.loading" ng-options="u as u.fullName for u in vm.dealerUsers | filter: vm.advisorFilter track by u.id"><option value="" selected="selected">Advisor</option></select></div></div></div><div class="row margin-bottom"><div class="col-xs-12"><div class="block relative field-wrapper"><label for="technician">TECHNICIAN</label><select class="form-control" id="technician" name="technician" selectlabel="" ng-model="vm.selectedTechnician" ng-disabled="vm.saving || vm.loading" ng-options="u as u.fullName for u in vm.dealerUsers | filter: vm.technicianFilter track by u.id"><option value="" selected="selected">Technician</option></select></div></div></div><div class="row margin-bottom" ng-show="vm.ro.dmsSystem === vm.dmsSystemEnum.DealerTrack"><div class="col-xs-12 field-wrapper"><label for="partsAssociate">Parts / Counter Associate</label><select class="form-control" id="partsAssociate" name="partsAssociate" selectlabel="" ng-model="vm.selectedPartsAssociate" ng-disabled="vm.saving || vm.loading || vm.loadingPartsAssociates" ng-options="u as u.fullName for u in vm.dealerUsers | filter: vm.partsAssociateFilter track by u.id"><option value="" selected="selected">Parts / Counter Associate</option></select></div></div><div class="modal-footer padding-right-none"><div class="col-sm-4 col-xs-12"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving || vm.loading"><img src="assets/images/ajax-loader.gif"> {{ vm.saving ? \'Saving...\' : \'Loading...\' }}</span></div><div class="col-sm-8 col-xs-12 pull right text-uppercase padding-right-none"><button type="button" class="btn btn-default" ng-click="vm.cancel()" ng-disabled="vm.saving || vm.loading"><span>Cancel</span></button>&nbsp; <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="vm.saving || vm.loading"><span>Save</span></button></div></div></div></div>');
$templateCache.put('app/areas/inspect/views/modals/change-inspection-form-modal.view.html','<div class="assign-to-modal"><div class="modal-header text-uppercase"><div><div><h5 class="margin-bottom-none">Update Inspection Form</h5></div></div></div><div class="modal-body padding-bottom-sm"><div class="row margin-bottom"><div class="col-xs-12 ng-hide" ng-show="vm.loading"><span class="pull-left padding-top-sm text-uppercase"><img src="assets/images/ajax-loader.gif"> LOADING...</span></div><div class="col-xs-12 field-wrapper ng-hide" ng-show="!vm.loading"><label for="Form">SELECT A FORM</label><select class="form-control" id="form" name="form" selectlabel="" required="" validation="required" ng-model="vm.formSelection" ng-change="vm.onFormChange(vm.formSelection)" ng-options="s as s.name for s in vm.availForms track by s.id"><option value="" selected="" disabled="">Select a form</option></select></div></div></div><div class="modal-footer"><div class="col-sm-4 col-xs-12"><span class="pull-left padding-top-sm text-uppercase ng-hide" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> SAVING...</span></div><div class="col-sm-8 col-xs-12 pull right text-uppercase"><button type="button" class="btn btn-default" ng-click="vm.cancel()" ng-disabled="vm.saving || vm.loading"><span>Cancel</span></button>&nbsp; <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="vm.saving || vm.loading || !vm.canSave()"><span>Save</span></button></div></div></div>');
$templateCache.put('app/areas/inspect/views/modals/compare-to-dms-modal.view.html','<div class="compare-to-dms-modal"><div class="modal-header text-uppercase"><div><h5 class="margin-bottom-none">Update RO# {{vm.dmsId}} {{vm.customerName}} from DMS</h5></div></div><div class="modal-body"><div ng-if="vm.loading"><div class="display-flex content-center"><img src="assets/images/ajax-loader.gif" class="spinner">&nbsp; Loading record from the DMS</div></div><div ng-if="!vm.loading && !vm.error"><div class="row margin-bottom-md" ng-if="vm.recordsToAdd"><div class="col-md-12">{{vm.recordsToAdd}} new service line{{ vm.recordsToAdd > 1 ? \'s \' :\'\' }} will be imported.</div></div><div class="row margin-bottom-md" ng-if="vm.recordsToUpdate"><div class="col-md-12">{{vm.recordsToUpdate}} existing service line{{ vm.recordsToUpdate > 1 ? \'s \' :\'\' }} will be imported.</div></div><div class="row margin-bottom-md" ng-if="vm.recordsToDelete"><div class="col-md-12">{{vm.recordsToDelete}} service line{{ vm.recordsToDelete > 1 ? \'s \' :\'\' }} no longer in the DMS will be indicated.</div></div><div class="row margin-bottom-md" ng-if="!vm.recordsToAdd && !vm.recordsToDelete && !vm.recordsToUpdate"><div class="col-md-12">Nothing to update at this time</div></div><div class="row margin-bottom-md" ng-if="vm.recordsToAdd || vm.recordsToDelete || vm.recordsToUpdate"><div class="col-md-12">Would you like to import these updates?</div></div></div><div ng-if="!vm.loading && vm.error"><div class="row margin-bottom-md"><div class="col-md-12 text-danger">Error: {{vm.error}}</div></div></div></div><div class="modal-footer"><div class="row" ng-if="vm.recordsToAdd || vm.recordsToDelete || vm.recordsToUpdate"><button type="button" class="btn btn-primary text-uppercase margin-right-md ladda-button" ladda="vm.syncing" ng-click="vm.syncDmsLines()">Yes</button> <button type="button" class="btn btn-default text-uppercase margin-right-md ladda-button" ladda="vm.syncing" ng-click="vm.close()">No</button></div><div class="row" ng-if="!vm.recordsToAdd && !vm.recordsToDelete && !vm.recordsToUpdate"><button type="button" class="btn btn-primary text-uppercase margin-right-md ladda-button" ng-click="vm.close()">Close</button></div></div></div>');
$templateCache.put('app/areas/inspect/views/modals/create-ro-modal.view.html','<div class="assign-to-modal"><div class="modal-header text-uppercase"><div><div><h5 class="margin-bottom-none">ADD NEW REPAIR ORDER</h5></div></div></div><form name="inputForm" id="inputForm" role="form" class="form" ng-submit="vm.save(inputForm.$valid)" novalidate=""><div class="modal-body padding-bottom-sm"><div class="row border-bottom"><div class="col-xs-11 text-bold">CUSTOMER</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-bottom margin-top"><div class="col-xs-6 field-wrapper text-notransform"><ui-select-search ng-model="vm.customerSearch" disabled="!vm.selectedRepairOrder.isNew" item-selected="vm.customerSelected(item)" add-new-selected="vm.newCustomer()" new-item-display-text="[New customer]" search-function="vm.searchCustomers(searchString)" format-selection="vm.customerFormat(item)" selected-item-display-text="vm.customerSelectedFormat(item)" process-results="vm.processCustomerResults(results)" search-placeholder="Search name, mobile, VIN" search-cleared="vm.customerSearchCleared()"></ui-select-search></div></div><div class="row margin-bottom margin-top"><div class="col-xs-3"><input type="text" ng-model="vm.ro.firstName" class="form-control better-placeholder" placeholder="FIRST NAME" name="first_name" validation="custom:vm.validation.firstName(vm.ro.firstName):alt=Required" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.lastName" class="form-control better-placeholder" placeholder="LAST NAME" required="" name="last_name" validation="required" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3 padding-left-none"><input type="text" id="mobile_phone_number" name="mobile_phone_number" inputmode="numeric" ng-model-options="{ debounce: 750 }" ng-model="vm.ro.mobilePhone" autocomplete="nope" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" placeholder="MOBILE PHONE" validation="required:alt=&nbsp;|custom:vm.validation.phone(vm.ro.mobilePhone):alt=Invalid Phone Number" ng-disabled="!vm.ro.isNewCustomer" ng-change="vm.phoneUpdated()"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.email" id="customer_email_address" name="email_address" class="form-control better-placeholder" placeholder="EMAIL ADDRESS" validation="email:alt=Must be a valid email address." ng-disabled="!vm.ro.isNewCustomer"></div></div><div class="row margin-bottom margin-top"><div class="col-xs-3"><input type="text" ng-model="vm.ro.address1" class="form-control better-placeholder" placeholder="ADDRESS" name="address" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.address2" class="form-control better-placeholder" placeholder="ADDRESS2" name="address2" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3 padding-left-none"><input type="text" id="city" name="city" ng-model="vm.ro.city" class="form-control better-placeholder" placeholder="CITY" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3 padding-left-none field-wrapper" ng-if="vm.ro.countryShortCode !== \'CA\'"><label for="state">STATE</label><select selectlabel="" name="state" id="state" ng-model="vm.ro.state" class="form-control input" ng-options="item as item for item in vm.usStates" ng-disabled="!vm.ro.isNewCustomer"><option value="" disabled="disabled" selected="selected">State</option></select></div><div class="col-xs-3 padding-left-none field-wrapper" ng-if="vm.ro.countryShortCode === \'CA\'"><label for="state">PROVINCE</label><select selectlabel="" name="state" id="state" ng-model="vm.ro.state" class="form-control input" ng-options="item as item for item in vm.canadianProvinces" ng-disabled="!vm.ro.isNewCustomer"><option value="" disabled="disabled" selected="selected">Province</option></select></div></div><div class="row margin-bottom margin-top"><div class="col-xs-3" ng-if="vm.ro.countryShortCode !== \'CA\'"><input type="text" id="zip" name="zip" autocomplete="nope" ng-model="vm.ro.zip" class="better-placeholder form-control" ng-model-options="{ debounce: 750 }" mask="99999" clean="true" placeholder="ZIP" validation="custom:vm.validation.zip(vm.ro.zip):alt=Invalid Zip Code" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3" ng-if="vm.ro.countryShortCode === \'CA\'"><input type="text" id="zip" name="zip" autocomplete="nope" ng-model="vm.ro.zip" class="better-placeholder form-control" placeholder="ZIP" ng-disabled="!vm.ro.isNewCustomer"></div><div class="col-xs-3 padding-left-none field-wrapper"><label for="customer_country">COUNTRY</label><select class="form-control" id="customer_country" name="customer_country" selectlabel="" ng-model-options="{ debounce: 750 }" ng-change="vm.countryChanged()" ng-model="vm.ro.countryShortCode" ng-options="s.value as s.text for s in vm.supportedCountries" ng-disabled="!vm.ro.isNewCustomer"><option value="" selected="selected" disabled="">Country</option></select></div></div><div class="row border-bottom margin-top-30"><div class="col-xs-11 text-bold">VEHICLE</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-bottom margin-top"><div class="col-xs-6 field-wrapper"><ui-select-search ng-model="vm.vehicleSearch" search-disabled="true" show-spinner="vm.searchingVehicles" disabled="!vm.selectedRepairOrder.isNew || !vm.hasVehicleSelections" available-items="vm.availableVehicles" item-selected="vm.vehicleSelected(item)" add-new-selected="vm.newVehicle()" new-item-display-text="[NEW VEHICLE]" format-selection="vm.vehicleFormat(item)" selected-item-display-text="vm.vehicleFormat(item)" search-placeholder="SELECT VEHICLE" search-cleared="vm.vehicleSearchCleared()"></ui-select-search></div></div><div class="row margin-bottom margin-top"><div class="col-xs-3 text-notransform"><input type="text" id="vin" name="vin" clean="true" maxlength="17" autocomplete="nope" ng-model="vm.ro.vin" class="form-control better-placeholder" placeholder="VIN" ng-model-options="{ debounce: 1000 }" ng-change="vm.checkValidVin()" required="" validation="required|custom:vm.validation.vin(vm.ro.vin):alt=VIN must be 17 characters" ng-disabled="!vm.ro.isNewVehicle"></div><div class="col-xs-3 padding-left-none"><input type="text" id="odometer" name="odometer" clean="true" autocomplete="nope" inputmode="numeric" required="required" validation="required" mask="9?9?9?9?9?9?9?9?9" mask-restrict="reject" ng-model-options="{ debounce: 750 }" ng-model="vm.ro.odometer" class="form-control no-spinners better-placeholder" placeholder="ODOMETER"></div><div class="col-xs-3 padding-left-none field-wrapper field-wrapper-always-on"><label for="odometer_type" class="on">Mi/Km</label><select id="odometer_type" name="odometer_type" ng-model="vm.ro.odometerType" selectlabel="" ng-options="measurement.type as measurement.abbreviation for measurement in vm.odometerTypes track by measurement.type" class="form-control" ng-disabled="!vm.ro.isNewVehicle"></select></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.hangTagNumber" ng-required="vm.dmsRequiresHangTag" class="form-control better-placeholder" placeholder="TAG #" name="tag"></div></div><div class="row"><div class="col-xs-3"><input type="text" ng-model="vm.ro.year" disabled="" class="form-control better-placeholder" placeholder="YEAR" name="year"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.make" disabled="" class="form-control better-placeholder" placeholder="MAKE" name="make"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.model" disabled="" class="form-control better-placeholder" placeholder="MODEL" name="model"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.subModel" disabled="" class="form-control better-placeholder" placeholder="SUB MODEL" name="subModel"></div></div><div class="row margin-top margin-bottom"><div class="col-xs-3"><input type="text" ng-model="vm.ro.engine" class="form-control better-placeholder" placeholder="ENGINE" name="engine"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.style" class="form-control better-placeholder" placeholder="STYLE" name="style"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.color" class="form-control better-placeholder" placeholder="COLOR" name="color"></div><div class="col-xs-3 padding-left-none"><input type="text" ng-model="vm.ro.licensePlate" class="form-control better-placeholder" placeholder="PLATE" name="plate"></div></div><div class="row border-bottom margin-top-30"><div class="col-xs-11 text-bold">ADVISOR/INSPECTION</div><div class="col-xs-1">&nbsp;</div></div><div class="row margin-top margin-bottom"><div class="col-xs-4 field-wrapper"><label for="advisor">ADVISOR</label><select class="form-control text-uppercase" id="advisor" name="advisor" selectlabel="" ng-model="vm.ro.serviceAdvisorEmployeeId" ng-disabled="vm.loadingUsers || !vm.serviceAdvisors" ng-options="u.id as u.fullName for u in vm.serviceAdvisors track by u.id"><option value="" selected="selected" disabled="">Advisor</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide inspection-form-spinner" ng-show="vm.loadingUsers"></div><div class="col-xs-4 field-wrapper padding-left-none"><label for="Form">INSPECTION FORM</label><select class="form-control text-uppercase" id="form" name="form" selectlabel="" required="" ng-disabled="!vm.availForms || vm.loadingForms === true" validation="required" ng-model="vm.ro.inspectionFormId" ng-options="s.id as s.name for s in vm.availForms track by s.id"><option value="" selected="selected" disabled="">INSPECTION FORM</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide inspection-form-spinner" ng-show="vm.loadingForms"></div></div></div><div class="modal-footer"><div class="col-sm-6 col-xs-12"><span class="pull-left padding-top-sm text-uppercase ng-hide" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> SAVING...</span> <span class="pull-left padding-top-sm text-uppercase ng-hide text-danger" ng-show="vm.errorDecodingVin">UNABLE TO DECODE THE ENTERED VIN</span> <span class="pull-left padding-top-sm text-uppercase ng-hide text-danger" ng-show="vm.errorSaving">AN ERROR HAS OCCURRED, PLEASE TRY AGAIN.</span></div><div class="col-sm-6 col-xs-12 pull right text-uppercase"><button type="button" class="btn btn-default" ng-click="vm.cancel()" ng-disabled="vm.saving || vm.loading"><span>Cancel</span></button>&nbsp; <button type="submit" class="btn btn-primary" ng-disabled="vm.saving || vm.loading"><span>Save</span></button></div></div></form></div>');
$templateCache.put('app/areas/inspect/views/modals/edit-line-item-modal.view.html','<form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.save()"><div class=""><div class="modal-header text-uppercase display-flex align-items-center"><qr-code url="vm.mediaUploadUrl" container-id="qrcode-{{vm.lineItem.id}}" logo-path="{{vm.soleraLogoUrl}}" ng-if="vm.mediaUploadUrl"></qr-code><div ng-if="!vm.mediaUploadUrl" class="display-flex content-center width-px-96 height-px-96"><img src="assets/images/ajax-loader.gif"> LOADING</div><div class="margin-bottom-none margin-left-md padding-left-sm" title="{{ vm.lineItem.description }}"><strong ng-if="vm.lineItem.description">{{ vm.lineItem.description }}<span ng-if="vm.lineItem.formattedCorrection">:</span></strong> <span>{{ vm.lineItem.formattedCorrection }}</span></div></div><div class="modal-body padding-bottom-sm rec-modal"><div class="angularui-bootstrap-tabs"><uib-tabset><uib-tab heading="REC" index="0" active="vm.activeTab[0]" select="vm.setActiveTab(0)"><line-item-recommendation line-item="vm.lineItem" dealer-id="vm.dealerId" show-media-viewer="vm.showMediaViewer" ro="vm.ro"></line-item-recommendation></uib-tab><uib-tab heading="ESTIMATE" index="1" active="vm.activeTab[1]" select="vm.setActiveTab(1)" ng-if="!vm.isTechnician"><line-item-estimate line-item="vm.lineItem" ro="vm.ro" dealer-id="vm.dealerId"></line-item-estimate></uib-tab></uib-tabset></div></div><div class="modal-footer"><div class="col-sm-4 col-xs-12"><button type="button" class="btn btn-default float-left margin-right" ng-click="vm.calculateTaxes()" ng-if="vm.activeTab[1] === true && (!vm.lineItem.pricing.isTaxExempt || !vm.lineItem.pricing.waiveShopSupplies)" ng-disabled="vm.saving"><span>Calculate Taxes</span></button> <span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span> <span class="pull-left padding-top-sm text-uppercase" ng-show="vm.updating"><img src="assets/images/ajax-loader.gif"> Loading...</span></div><div class="col-sm-8 col-xs-12"><button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.saving || vm.updating || vm.addingImage"><span>CLOSE</span></button> <button ng-if="!vm.showMediaViewer" type="submit" class="btn btn-primary" ng-disabled="inputForm.$invalid || vm.saving"><span>SAVE</span></button> <button ng-if="vm.showMediaViewer" type="button" class="btn btn-primary" ng-click="vm.updateMedia()" ng-disabled="vm.saving"><span>UPDATE</span></button></div></div></div></form>');
$templateCache.put('app/areas/inspect/views/modals/import-parts-quote-modal.view.html','<div><div class="modal-header text-uppercase"><div><div><h5 class="margin-bottom-none">Import Parts Quote</h5></div></div></div><div class="modal-body padding-bottom-sm"><input type="search" class="form-control" ng-="" placeholder="Enter quote #" ng-model="vm.partsQuoteSearch" ng-model-options="{ debounce: 750 }" ng-change="vm.getPartsQuote()"></div><div class="modal-body max-height-px400"><div class="display-grid gap-16 col-3-1-half-3 margin-top text-bold text-uppercase border-bottom padding-bottom-sm" ng-if="vm.partsQuote.length > 0"><div>Part No/Desc</div><div>Price</div><div>Qty</div><div>Line</div></div><div class="margin-top display-grid gap-16 col-3-1-half-3 height-px-34" ng-repeat="part in vm.partsQuote"><div class="ellipsis-overflow" title="{{ part.partNumber }} - {{ part.partDescription && part.partDescription.trim() || \'Description not available\' }}">{{ part.partNumber }} - {{ part.partDescription && part.partDescription.trim() || \'Description not available\' }}</div><div>{{ part.unitSalePrice | currency }}</div><div>{{ part.soldQuantity }}</div><div ng-dropdown-multiselect="" class="overflow-auto" disabled="vm.isLoading" options="vm.lineItems" selected-model="part.lineItems" checkboxes="true" extra-settings="vm.lineItemDropdownSettings" translation-texts="{buttonDefaultText: \'Opcode\'}"></div></div><div ng-if="(vm.partsQuote.length === 0 && vm.partsQuoteSearch && !vm.isLoading)">No Results Found</div></div><div class="modal-footer"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving || vm.isLoading"><img src="assets/images/ajax-loader.gif"> {{ vm.isLoading ? \'Loading...\' : \'Saving...\' }}</span> <span class="padding-right-md validation text-danger" ng-if="!vm.isFormValid()">Please select at least one OpCode.</span><event-alert></event-alert><button type="button" class="btn btn-default" ng-disabled="vm.saving" ng-click="vm.cancel()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.saving" ng-click="vm.saveChanges()">Save</button></div></div>');
$templateCache.put('app/areas/inspect/views/modals/inspection-summary-modal.view.html','<div class="padding-md"><inspection-summary ro="vm.ro" from-consumer="vm.fromConsumer" consumer-key="vm.consumerKey"></inspection-summary></div>');
$templateCache.put('app/areas/inspect/views/modals/media-viewer-modal.view.html','<div class="media-viewer-modal"><div class="modal-header text-uppercase"><div><div><h5 class="margin-bottom-none">MEDIA LIBRARY</h5></div></div></div><div class="modal-body padding-bottom-sm"><inspect-media-viewer line-item="vm.lineItem" ro="vm.ro"></inspect-media-viewer></div><div class="modal-footer"><div class="col-sm-4 col-xs-12"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> SAVING...</span></div><div class="col-sm-8 col-xs-12 pull right text-uppercase"><button type="button" class="btn btn-default" ng-click="vm.cancel()" ng-disabled="vm.saving"><span>Cancel</span></button>&nbsp; <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="vm.saving" ladda="vm.saving"><span>Update</span></button></div></div></div>');
$templateCache.put('app/areas/inspect/views/modals/vehicle-overview-modal.view.html','<div class="modal-header text-uppercase display-flex align-items-center"><qr-code url="vm.mediaUploadUrl" container-id="qrcode-vehicle-overview" logo-path="{{vm.soleraLogoUrl}}" ng-if="vm.mediaUploadUrl"></qr-code><div ng-if="!vm.mediaUploadUrl && vm.isLoading" class="display-flex content-center width-px-96 height-px-96"><img src="assets/images/ajax-loader.gif">Loading...</div><h3 class="modal-title text-uppercase font-bold margin-bottom-none margin-left-md padding-left-sm">Vehicle Overview</h3></div><div class="modal-body"><div ng-if="vm.isLoading" class="text-center padding"><img src="assets/images/ajax-loader.gif"> Loading...</div><div ng-if="!vm.isLoading"><div class="margin-bottom-lg"><repair-order-vehicle-details-issues repair-order="vm.ro" ng-if="vm.checkInCompleted"></repair-order-vehicle-details-issues><div ng-if="!vm.checkInCompleted"><h4 class="margin-top-30 margin-bottom-sm padding-bottom-md border-bottom font-size-14 font-bold black text-uppercase">Vehicle Details</h4><p class="font-bold margin-bottom-xs">No check-in information available for this RO.</p><p class="color-gray margin-bottom-none">This repair order was created without completing the check-in process, so vehicle details, damage, and check-in photos are not available.</p></div></div><div class="margin-bottom-lg"><h4 class="margin-top-30 margin-bottom-sm padding-bottom-md border-bottom font-size-14 font-bold black text-uppercase">Inspection Media</h4><div class="font-size-11 margin-bottom-sm color-gray">Photos and videos added here are visible to the customer and are not tied to a recommendation.</div><div class="image-grid w-80 h-80 margin-top padding-bottom-sm padding-left-none"><div class="grid-item"><drag-drop-image ng-model="vm.imageToUpload" class="small-white-boxes ng-show margin-top" use-icon="true" placeholder="Add Photo" repeat-container="vm.vehicleOverview.media" on-load="vm.uploadVehicleOverviewMedia" on-complete="vm.mediaUploaded" ng-disabled="vm.addingImage" allow-video="true" drop-reference="vm.ro.id" large="" loading-text="UPLOADING IMAGE" dealer-id="vm.dealerId" image-type="vehicleOverview" error-text="" is-version-2="true" hide-btn-text="true" use-small-button="false"></drag-drop-image><div class="recs-image-spinner ng-hide" ng-show="vm.isSaving"><img src="assets/images/ajax-loader.gif"></div></div><div class="grid-item" ng-repeat="media in vm.vehicleOverview.media track by media.id"><div class="small-grey-boxes position-relative"><img class="image-container position-relative" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.photo" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.photo, media.id)" ng-src="{{media.mediaUrl}}"><video class="image-container position-relative" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.video" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.video, media.id)" ng-src="{{media.mediaUrl}}"></video><span class="overlay" ng-if="vm.getMediaType(media.fileExtension) === vm.mediaTypes.video" ng-click="vm.openMediaModal(media.mediaUrl, media.description, vm.mediaTypes.video, media.id)"><i class="material-icons">play_arrow</i></span></div></div></div><div ng-if="!vm.vehicleOverview.media || vm.vehicleOverview.media.length === 0" class="text-center padding-sm"><div class="text-uppercase font-size-11 font-bold color-gray">No media added yet</div></div></div><div class="margin-bottom-lg"><h4 class="margin-top-30 margin-bottom-sm padding-bottom-md border-bottom font-size-14 font-bold black text-uppercase">Notes</h4><div class="margin-bottom display-flex align-items-center flex-gap-md margin-top-md"><div class="flex-grow"><input type="text" class="form-control" ng-model="vm.newNote" placeholder="Enter note" ng-keypress="$event.keyCode == 13 && vm.addNote()"></div><button type="button" class="btn btn-default" ng-click="vm.addNote()" ng-disabled="!vm.newNote || vm.isSaving">Add</button></div><div ng-if="vm.vehicleOverview.notes && vm.vehicleOverview.notes.length > 0"><div ng-repeat="note in vm.vehicleOverview.notes" class="margin-bottom"><div class="margin-bottom-xs text-uppercase font-bold font-size-11 color-gray">{{ note.dateCreated | fromNow }} <span ng-if="note.authorName">({{ note.authorName }})</span></div><div class="display-flex"><div class="flex-percent-90"><div ng-bind-html="vm.formatMessage(note.message)"></div></div><div class="flex-percent-10 flex-right text-right"><a href="#" class="theme-link text-uppercase" ng-click="vm.deleteNote(note.id)">Delete</a></div></div></div></div><div ng-if="!vm.vehicleOverview.notes || vm.vehicleOverview.notes.length === 0" class="text-center padding-sm"><div class="text-uppercase font-size-11 font-bold color-gray">No notes added yet</div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default text-uppercase" ng-click="vm.close()">Close</button></div>');
$templateCache.put('app/areas/inspect/views/ro-detail/inspect-ro-detail.component.view.html','<div id="inspect-ro-detail" class="white-bg inspect-detail display-flex overflow-hidden full-width-height"><div id="inspect-ro-detail-left" class="flex-grow flex-percent-80 overflow-hidden"><div class="padding flex-fullwidth padding-top-md" ng-if="vm.ro && !vm.isLoading"><div class="display-flex flex-row"><div class="display-flex flex-percent-100 margin-top"><div class="title text-bold text-uppercase margin-top-sm"><i class="material-icons md-14 align-middle unread-messages" ng-style="{ \'color\': \'{{vm.ro.statusColor}}\'}">lens</i> RO #{{ vm.ro.dmsRepairOrderNumber || \'PENDING\' }} {{ vm.ro.status | uppercase }}</div>&nbsp;<div class="margin-top-xs inline"><i ng-click="vm.customerHeaderOpen = !vm.customerHeaderOpen;" class="margin-top-xs theme-link inline material-icons material-icons-large" ng-if="vm.customerHeaderOpen">expand_less</i> <i ng-click="vm.customerHeaderOpen = !vm.customerHeaderOpen;" class="margin-top-xs theme-link inline material-icons material-icons-large" ng-if="!vm.customerHeaderOpen">expand_more</i></div></div></div><div class="display-flex flex-row ng-hide" ng-show="vm.customerHeaderOpen"><div class="flex-grow flex-percent-50 padding-right-none aside-header text-uppercase"><div ng-if="vm.ro.customer">{{ vm.ro.customer.phone | tel }}</div><div ng-if="vm.ro.customer">{{ vm.ro.customer.email }}</div><div>{{ vm.ro.vehicle.year }} {{ vm.ro.vehicle.make }} {{ vm.ro.vehicle.model }}</div><div ng-if="vm.ro.vehicle">{{vm.ro.vehicle.vin}}</div><div ng-if="vm.ro.odometerIn">{{vm.ro.odometerIn | number : fractionSize}} {{ vm.getOdometerAbbreviation(vm.ro.mileageType) }}</div></div><div class="flex-grow flex-percent-50 padding-left-none aside-header text-right text-uppercase"><div class="hidden-xs padding-right-sm"><div ng-if="vm.ro.referenceTag">Tag: #{{vm.ro.referenceTag}}</div><div>Advisor: {{vm.ro.serviceAdvisor.fullName || \'NA\'}}</div><div>Tech: {{vm.ro.technician.fullName || \'NA\'}}</div><div>Shop Flag: {{vm.ro.shopFlag || \'NA\'}}</div></div><div class="visible-xs visible-sm"><div ng-if="vm.removeMessagingTabs === false" class="theme-link pull-right" ng-click="vm.enableMessaging(true)"><i class="material-icons md-24">forum</i></div></div></div></div></div><div class="padding-md margin-top" ng-if="vm.isLoading || !vm.ro"><span ng-if="!vm.isLoading && !vm.ro" class="text-danger text-uppercase">AN ERROR HAS OCCURRED LOADING THE REPAIR ORDER. PLEASE TRY AGAIN.<br><br>If this continues, please contact our Client Success team.</span> <span class="spinner-text" ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"> LOADING</span></div><div id="ro-detail-tabs" scrollable-tabs="" class="inner-page-tabs full-width-height display-flex overflow-hidden bg-white" fill-height="" ng-class="{\'no-messaging-panel\': vm.removeMessagingTabs === true}" ng-if="!vm.isLoading && vm.ro"><uib-tabset class="flex-fill"><uib-tab ng-repeat="tab in vm.tabs" index="tab.id" heading="{{tab.title}}" disable="tab.disabled" active="tab.active" select="vm.detailTabChanged(tab)"><span class="flex-fill"><inspection-detail ng-if="tab.id === 1 && vm.ro && tab.active" class="full-width-height overflow-hidden display-flex flex-row" ro="vm.ro" dealer-id="vm.dealerId" line-items="vm.lineItems"></inspection-detail><inspection-services ng-if="tab.id === 2 && vm.ro && tab.active" class="full-width-height" ro="vm.ro" dealer-id="vm.dealerId" dealer-has-payments-enabled="vm.dealerHasPaymentsEnabled" line-items="vm.lineItems"></inspection-services><authorization-history-list ng-if="tab.id === 4 && vm.ro && tab.active" class="overflow-y-auto padding" dealer-id="vm.dealerId" repair-order="vm.ro" dashboard-history-mode="true"></authorization-history-list><inspection-shop-notes ng-if="tab.id === 3 && vm.ro && tab.active" class="full-width-height" dealer-id="vm.dealerId" ro="vm.ro" line-items="vm.lineItems"></inspection-shop-notes></span></uib-tab></uib-tabset></div></div><div id="inspect-messaging-panel" ng-if="vm.removeMessagingTabs === false" class="hidden-xs hidden-sm border-left message-component-rail overflow-hidden flex-grow flex-percent-20"><div ng-if="!vm.isLoadingContact && vm.contact"><rc-summary-message-tab mobile-class="vm.messagingPanelMobileClass" disable-notes-tab="0" contact="vm.ro.customer" ro="vm.ro" active-tab="vm.activeMessageTab"></rc-summary-message-tab></div><div id="message-panel-loading" class="overflow-x-hidden" ng-if="vm.isLoadingContact"><div class="row margin-top margin-left"><div class="col-xs-11 text-uppercase"><img src="assets/images/ajax-loader.gif"> Loading...</div></div></div><div id="message-panel-nocontact" class="overflow-x-hidden" ng-if="!vm.isLoadingContact && vm.ro.customer && !vm.ro.customer.phone"><div class="row margin-top margin-left"><div class="col-xs-12 text-uppercase"><b>MESSAGING</b><br><br>No customer phone number provided.<br>Phone number is required for messaging.<br><div class="visible-xs visible-sm theme-link" ng-click="vm.enableMessaging(false)"><i class="material-icons md-24">comments_disabled</i></div></div></div><div id="nocontact-footer" class="shadow-border-top"><button class="btn btn-default text-uppercase pull-right" ng-click="vm.closeMessagingPanel()">CLOSE</button></div></div></div></div>');
$templateCache.put('app/areas/inspect/views/ro-detail/inspect-tab-inspection.view.html','<div class="tab-section full-width-height"><div ng-if="vm.isLoading" class="padding"><img src="assets/images/ajax-loader.gif"> LOADING</div><div ng-if="!vm.isLoading" id="inspection-tab-container" class="display-flex flex-row position-relative overflow-hidden full-width-height"><div class="display-flex flex-column full-width-height"><div class="visible-sm visible-xs padding-lg padding-bottom-none"><div class="field-wrapper overflow-hidden"><label for="selectAction">ACTION</label><select selectlabel="" allow-null-option="Action" class="form-control" id="selectAction" name="selectAction" ng-model="vm.selectedAction" ng-options="action.id as action.name disable when vm.shouldDisableAction(action) for action in vm.inspectActions | filter:vm.filterInspectActions() track by action.id" ng-change="vm.onActionSelected()"></select></div></div><div class="display-flex flex-grow padding-lg flex-sm-column flex-gap-lg flex-sm-gap-sm overflow-y-auto"><div class="display-flex flex-column flex-gap-sm flex-static-size flex-percent-25 min-width-200 overflow-hidden override-xs-overflow override-sm-overflow overflow-y-auto"><div class="field-wrapper margin-bottom hidden-sm hidden-xs"><label for="selectAction">ACTION</label><select selectlabel="" allow-null-option="Action" class="form-control" id="selectAction" name="selectAction" ng-model="vm.selectedAction" ng-options="action.id as action.name disable when vm.shouldDisableAction(action) for action in vm.inspectActions | filter:vm.filterInspectActions() track by action.id" ng-change="vm.onActionSelected()"></select></div><inspect-original-customer-requests class="padding-sm border-default border-radius-sm border-color-darkgray" ro="vm.ro" dealer-id="vm.dealerId" line-items="vm.lineItems"></inspect-original-customer-requests><inspect-my-recommendations ng-if="!vm.ro.inspectionForm || !vm.ro.inspectionForm.isAdHoc" class="padding-sm border-default border-radius-sm border-color-darkgray" ro="vm.ro" dealer-id="vm.dealerId" line-items="vm.lineItems"></inspect-my-recommendations></div><div class="padding-top-none flex-grow flex-percent-100 margin-bottom"><div ng-click="vm.showVehicleOverview($event)" class="section-default margin-bottom-md font-bold text-12 padding border-default border-radius-md cursor-pointer text-uppercase">Vehicle Overview</div><div ng-if="!vm.ro.inspectionForm.id && !vm.isLoading" class="text-uppercase">An Inspection form has not been set for this RO. Please set the default inspection form from the Configuration.</div><div ng-if="vm.ro.inspectionForm && vm.ro.inspectionForm.isAdHoc" class="padding-bottom-lg"><div class="font-bold font-size-14 text-center padding border-radius-lg bg-muted" ng-if="!(vm.lineItems | filter: vm.adHocLinesFilter).length">There are currently no Recommendations for this Inspection.<br>Click the <span class="theme-link" ng-click="vm.showAddLineItemAside($event)">Add New</span> button to add a new Recommendation.</div><div ng-repeat="lineItem in vm.lineItems | filter: vm.adHocLinesFilter" class="font-bold font-size-11 inspection-item display-flex flex-gap-sm content-center margin-left-none margin-right-none"><div ng-click="vm.editLineItem(lineItem)" class="flex-grow flex-percent-45 font-bold font-size-12 link">{{ lineItem.formattedComplaint }}</div><div class="btn-group"><button ng-repeat="answerType in vm.possibleAnswerTypes" ng-click="vm.updateLineSeverity(answerType, lineItem)" class="btn-75 no-shadow no-border padding-default btn-{{ answerType | mpAnswerTypeCss}} text-uppercase pass-fail-btns" ng-class="{ \'inactive\':lineItem.severity !== vm.mapAnswerTypeToSeverity(answerType), \'font-bold\': lineItem.severity === vm.mapAnswerTypeToSeverity(answerType) }">{{ vm.ro.answerTypeMapping[answerType] }}</button></div><div ng-click="vm.deleteLineItem(lineItem)" class="margin-left flex-right cursor-pointer display-flex flex-align-self-center"><span class="material-icons font-size-18">cancel</span></div></div></div><uib-accordion ng-if="vm.ro.inspectionForm && !vm.ro.inspectionForm.isAdHoc" fill-height="" id="inspection-accordion" close-others="true"><div uib-accordion-group="" class="section-default" ng-repeat="inspectionSection in vm.inspectionSections" is-open="inspectionSection.isOpen" panel-class="section" ng-click="vm.loadInspectionSection(inspectionSection)"><uib-accordion-heading><div class="section-title with-button small-title"><i class="inline pull-left material-icons material-icons-large" ng-if="inspectionSection.isOpen">expand_less</i> <i class="inline pull-left material-icons material-icons-large" ng-if="!inspectionSection.isOpen">expand_more</i> {{inspectionSection.name}} <span class="padding-left-sm" ng-if="inspectionSection.isOpen && vm.loadingRecommendations === true"><img src="assets/images/ajax-loader.gif"></span><div class="flex-right font-size-11 text-uppercase"><button ng-disabled="inspectionSection.allTasksPassed" ng-click="vm.updateTaskStatusBulk($event, vm.answerTypes.pass, inspectionSection);" class="bg-none no-shadow no-border inactive rounded margin-right-md padding-bottom-sm padding-top-sm"><i ng-class="{\'color-success\': inspectionSection.allTasksPassed }" title="Pass all Tasks that don\'t already have a response." class="material-icons link md-24 task-icon">check_circle</i></button></div></div></uib-accordion-heading><div ng-if="inspectionSection.isOpen" class="font-bold font-size-11 inspection-item display-flex flex-wrap flex-gap-sm content-center" ng-click="vm.showAddLineItemAside($event, task, inspectionSection)" ng-repeat="task in inspectionSection.tasks"><div class="flex-grow flex-percent-45 font-bold font-size-12 link">{{ task.name }}</div><div class="btn-group"><button ng-repeat="answerType in vm.possibleAnswerTypes" ng-click="vm.updateTaskStatus($event, answerType, inspectionSection, task)" class="btn-75 no-shadow no-border padding-default btn-{{ answerType | mpAnswerTypeCss}} text-uppercase pass-fail-btns" ng-class="{ \'inactive\':task.taskResponse !== answerType, \'font-bold\': task.taskResponse === answerType }">{{ vm.ro.answerTypeMapping[answerType] }}</button></div><div ng-click="vm.showAddLineItemAside($event, task, inspectionSection)" ng-if="task.lineItems && task.lineItems.length > 0" class="flex-percent-100"><div ng-repeat="lineItem in task.lineItems" class="margin-bottom-sm"><div class="font-normal cursor-pointer" ng-click="vm.showAddLineItemAside($event, task, inspectionSection)"><span>{{ lineItem.formattedComplaint }}</span></div></div></div></div></div></uib-accordion></div><div ng-if="vm.isLoading" class="padding-lg"><strong><img src="assets/images/ajax-loader.gif"> Loading...</strong></div></div><div class="flex-fullwidth-64h shadow-border-top"><div class="display-flex flex-row align-items-center full-width full-height padding"><div class="flex-percent-50"><event-alert ng-if="vm.ro.inspectionStatus !== vm.inspectionStatusTypes.complete"></event-alert><div ng-if="vm.ro.inspectionStatus === vm.inspectionStatusTypes.complete && !vm.updatingInspection" class="display-flex content-center"><i class="text-success material-icons margin-right-sm font-size-16">check_circle</i>Inspection completed on {{ vm.ro.inspectionCompletedDate | date }} by {{ vm.ro.inspectionCompletedByName}}</div></div><div class="flex-right display-flex gap-10"><button ng-if="vm.ro.inspectionStatus !== vm.inspectionStatusTypes.complete" title="{{ vm.ro.inspectionStatus !== vm.inspectionStatusTypes.inProgress ? \'The Inspection has not been started yet. It must be started before it can be completed.\' : \'\'}}" class="btn text-uppercase" ng-class="{\'btn-primary\': !vm.ro.inspectionForm.isAdHoc, \'btn-default\': vm.ro.inspectionForm.isAdHoc}" ng-click="vm.completeInspection()" ng-disabled="vm.ro.inspectionStatus !== vm.inspectionStatusTypes.inProgress || vm.updatingInspection" ladda="vm.updatingInspection">Complete Inspection</button> <button ng-if="vm.ro.inspectionForm.isAdHoc" title="Add New Recommendation" class="btn btn-primary text-uppercase" ng-click="vm.showAddLineItemAside($event)">Add New</button></div></div></div></div></div></div>');
$templateCache.put('app/areas/inspect/views/ro-detail/inspect-tab-services.view.html','<div id="inspect-services" class="tab-section full-height"><div class="display-flex flex-column full-width-height"><div class="display-flex flex-column flex-grow overflow-y-auto padding-lg"><div ng-if="vm.loadingLineItems"><img src="assets/images/ajax-loader.gif"> LOADING</div><div ng-if="!vm.loadingLineItems"><div class="margin-bottom field-wrapper"><label for="selectAction">ACTION</label><select id="services-action-select" selectlabel="" allow-null-option="Action" class="form-control text-notransform" name="selectAction" ng-model="vm.selectedAction" ng-options="action.id as vm.formatActionForDropDown(action) disable when vm.shouldDisableAction(action) for action in vm.inspectActions track by action.id" ng-change="vm.onActionSelected()"></select></div><div><table class="table table-hover new-style margin-bottom-30" cellpadding="0" cellspacing="0"><thead><tr class="text-uppercase"><th class="col-width-20"><input class="margin-left-sm" id="check-all-pending" type="checkbox" name="check-all-pending" title="CHECK/UNCHECK ALL PENDING SERVICES" ng-model="vm.checkAllPending" ng-change="vm.checkAllItems(true, vm.checkAllPending)"></th><th class="col-width-20 padding-right-none padding-left-none"></th><th sort-column="OPCODE"><div class="ellipsis-overflow col-width-70">OPCODE</div></th><th sort-column="DESCRIPTION"><div class="ellipsis-overflow col-width-500">PENDING SERVICES</div></th><th sort-column="SOURCE"><div class="ellipsis-overflow col-width-80">SOURCE</div></th><th ignore-sort=""><div class="text-center col-width-70">SEVERITY</div></th><th sort-column="CUSTACC"><div class="ellipsis-overflow col-width-90">STATUS</div></th><th sort-column="DMS"><div class="ellipsis-overflow col-width-90">DMS UPDATE</div></th><th sort-column="HOURS"><div class="col-width-20">HOURS</div></th><th sort-column="LABOR"><div class="text-right col-width-60">LABOR</div></th><th sort-column="PARTS"><div class="text-right col-width-60">PARTS</div></th><th sort-column="TOTAL"><div class="text-right col-width-60">TOTAL</div></th><th class="col-width-30" ignore-sort=""><div class="display-flex content-center pull-right"><i class="material-icons md-24 link" ng-if="!vm.pendingServicesTableOpen" ng-click="vm.pendingServicesTableOpen = !vm.pendingServicesTableOpen;">expand_more</i> <i class="material-icons md-24 link" ng-if="vm.pendingServicesTableOpen" ng-click="vm.pendingServicesTableOpen = !vm.pendingServicesTableOpen;">expand_less</i></div></th></tr></thead><tbody ng-if="vm.pendingServicesTableOpen"><tr ng-click="vm.onLineItemSelected(lineItem)" ng-repeat="lineItem in vm.lineItems | filter: vm.lineItemsRequiringAction as pendingLineItems track by lineItem.id" class="text-uppercase cursor-pointer"><td class="col-width-20" ng-click="$event.stopPropagation()"><input class="margin-left-sm" type="checkbox" name="serviceline" ng-model="lineItem.isChecked" ng-click="$event.stopPropagation()"></td><td class="col-width-20 padding-right-none padding-left-none"><i class="material-icons md-14 margin-top-sm" ng-if="lineItem.isHidden">visibility_off</i></td><td><div class="ellipsis-overflow col-width-70">{{ lineItem.opCode }}</div></td><td><div class="block col-width-500"><strong ng-if="lineItem.description || lineItem.name">{{ lineItem.description || lineItem.name }}<span ng-if="lineItem.formattedCorrection">:</span></strong> <span>{{ lineItem.formattedCorrection }}</span></div></td><td><div title="{{ lineItem.sourceTypeName }}" class="block col-width-80 ellipsis-overflow">{{ lineItem.sourceTypeName }}</div></td><td><div class="text-center col-width-70"><i ng-if="vm.lineItemSeverity[lineItem.severity].icon" class="material-icons {{ vm.lineItemSeverity[lineItem.severity].cssClass }}">{{ vm.lineItemSeverity[lineItem.severity].icon }}</i></div></td><td ng-class="{ \'text-success\': lineItem.authorizationStatus === vm.lineItemStatus.approved, \'text-danger\': lineItem.authorizationStatus === vm.lineItemStatus.deferred }"><div class="ellipsis-overflow col-width-90">{{ vm.lineItemStatusText[lineItem.authorizationStatus] || UNKNOWN }}</div></td><td><div class="ellipsis-overflow col-width-90 text-lowercase"><span class="display-flex nowrap" ng-if="vm.ro.dmsRepairOrderNumber && lineItem.lastDmsUpdate">{{ lineItem.lastDmsUpdate | fromNow }} <span popover-trigger="mouseenter" uib-popover-html="lineItem.tooltip" popover-placement="right" class="pull-right padding-right-md padding-top-xs"><i class="material-icons padding-left-md">info_outline</i></span></span></div></td><td><div class="col-width-20">{{ lineItem.laborHours || 0 }}</div></td><td><div class="text-right col-width-60">{{ lineItem.useFlatPrice ? \'FLAT\' : (lineItem.noLaborCharge ? \'NO CHG\' : (lineItem.pricing.labor | currency)) }}</div></td><td><div class="text-right col-width-60">{{ lineItem.useFlatPrice ? \'FLAT\' : (lineItem.noPartsCharge ? \'NO CHG\' : (lineItem.pricing.parts | currency)) }}</div></td><td><div class="text-right col-width-60">{{ lineItem.pricing.totalAmount | currency }}</div></td><td></td></tr><tr class="no-hover" ng-if="pendingLineItems.length === 0"><td colspan="13">THERE ARE NO PENDING SERVICES</td></tr></tbody></table></div><div><table class="table table-hover new-style" cellpadding="0" cellspacing="0"><thead><tr class="text-uppercase"><th class="col-width-20"><input class="margin-left-sm" id="check-all-avail" type="checkbox" name="check-all-avail" title="CHECK/UNCHECK ALL APPROVED SERVICES" ng-model="vm.checkAllApproved" ng-change="vm.checkAllItems(false, vm.checkAllApproved)"></th><th class="col-width-20 padding-right-none padding-left-none">&nbsp;</th><th sort-column="OPCODE"><div class="ellipsis-overflow col-width-70">OPCODE</div></th><th sort-column="DESCRIPTION"><div class="ellipsis-overflow col-width-500">APPROVED SERVICES</div></th><th sort-column="SOURCE"><div class="ellipsis-overflow col-width-80">SOURCE</div></th><th ignore-sort=""><div class="text-center col-width-70">SEVERITY</div></th><th sort-column="CUSTACC"><div class="ellipsis-overflow col-width-90">STATUS</div></th><th sort-column="DMS"><div class="ellipsis-overflow col-width-90">DMS UPDATE</div></th><th sort-column="HOURS"><div class="col-width-20">HOURS</div></th><th class="text-right" sort-column="LABOR"><div class="text-right col-width-60">LABOR</div></th><th class="text-right" sort-column="PARTS"><div class="text-right col-width-60">PARTS</div></th><th sort-column="TOTAL"><div class="text-right col-width-60">TOTAL</div></th><th class="col-width-30" ignore-sort=""><div class="display-flex content-center pull-right"><i class="material-icons md-24 link" ng-if="!vm.approvedServicesTableOpen" ng-click="vm.approvedServicesTableOpen = !vm.approvedServicesTableOpen;">expand_more</i> <i class="material-icons md-24 link" ng-if="vm.approvedServicesTableOpen" ng-click="vm.approvedServicesTableOpen = !vm.approvedServicesTableOpen;">expand_less</i></div></th></tr></thead><tbody ng-if="vm.approvedServicesTableOpen"><tr ng-click="vm.onLineItemSelected(lineItem)" ng-repeat="lineItem in vm.lineItems | filter: vm.lineItemsNotRequiringAction as approvedServices track by lineItem.id" class="text-uppercase cursor-pointer"><td class="col-width-20" ng-click="$event.stopPropagation()"><input class="margin-left-sm" type="checkbox" name="serviceline" ng-model="lineItem.isChecked" ng-click="$event.stopPropagation()"></td><td class="icon-col"><i class="margin-left-sm material-icons md-14 hidden-icon" ng-if="lineItem.isHidden">visibility_off</i></td><td><div class="ellipsis-overflow col-width-70">{{ lineItem.opCode }}</div></td><td><div class="block col-width-500"><strong ng-if="lineItem.description || lineItem.name">{{ lineItem.description || lineItem.name }}<span ng-if="lineItem.formattedCorrection">:</span></strong> <span>{{ lineItem.formattedCorrection }}</span></div></td><td><div title="{{ lineItem.sourceTypeName }}" class="block col-width-80 ellipsis-overflow">{{ lineItem.sourceTypeName }}</div></td><td><div class="text-center col-width-70"><i ng-if="vm.lineItemSeverity[lineItem.severity].icon" class="material-icons {{ vm.lineItemSeverity[lineItem.severity].cssClass }}">{{ vm.lineItemSeverity[lineItem.severity].icon }}</i></div></td><td title="{{lineItem.authorizationStatus === vm.lineItemStatus.needsReApproval ? \'This service was changed after it was authorized or sent for authorization. The current price is not covered by the customer\\\'s last authorization.\' : \'\'}}" ng-class="{ \'text-success\': lineItem.authorizationStatus === vm.lineItemStatus.approved, \'text-danger\': lineItem.authorizationStatus === vm.lineItemStatus.deferred }"><div class="ellipsis-overflow col-width-90">{{ vm.lineItemStatusText[lineItem.authorizationStatus] || UNKNOWN }}</div></td><td><div class="ellipsis-overflow col-width-90 text-lowercase"><span class="display-flex nowrap" ng-if="vm.ro.dmsRepairOrderNumber && lineItem.lastDmsUpdate">{{ lineItem.lastDmsUpdate | fromNow }} <span popover-trigger="mouseenter" uib-popover-html="lineItem.tooltip" popover-placement="right" class="pull-right padding-right-md padding-top-xs"><i class="material-icons padding-left-md">info_outline</i></span></span></div></td><td><div class="col-width-20">{{ lineItem.laborHours || 0 }}</div></td><td><div class="text-right col-width-60">{{ lineItem.useFlatPrice ? \'FLAT\' : (lineItem.noLaborCharge ? \'NO CHG\' : (lineItem.pricing.labor | currency)) }}</div></td><td><div class="text-right col-width-60">{{ lineItem.useFlatPrice ? \'FLAT\' : (lineItem.noPartsCharge ? \'NO CHG\' : (lineItem.pricing.parts | currency)) }}</div></td><td><div class="text-right col-width-60">{{ lineItem.pricing.totalAmount | currency }}</div></td><td></td></tr><tr class="no-hover border-bottom" ng-if="approvedServices.length === 0"><td colspan="13">THERE ARE NO APPROVED SERVICES</td></tr><tr class="border-top no-hover text-uppercase" ng-if="approvedServices.length"><td class="border-none" colspan="7"></td><td class="text-right border-bottom">{{vm.roTotals.approvedAmounts.totalLineItemCount}} Item<span ng-if="vm.roTotals.totalApprovedLineItems > 1">s</span></td><td class="border-bottom">{{ vm.roTotals.approvedAmounts.laborHours }}</td><td class="text-right border-bottom">{{ vm.roTotals.approvedAmounts.totalLabor | currency }}</td><td class="text-right border-bottom">{{ vm.roTotals.approvedAmounts.totalParts | currency }}</td><td class="border-bottom text-right">{{ vm.roTotals.approvedAmounts.totalRetail | currency }}</td><td class="border-none"></td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.totalDiscount"><td class="padding-top-none padding-bottom-none" colspan="10"></td><td class="padding-top-none padding-bottom-none text-right">Discount</td><td class="padding-top-none padding-bottom-none text-right text-danger">({{ vm.roTotals.approvedAmounts.totalDiscount | currency }})</td><td class="padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="approvedServices.length"><td class="border-none padding-top-none padding-bottom-none" colspan="9"></td><td class="border-none padding-bottom-none text-right" colspan="2">Shop Supplies</td><td class="border-none padding-bottom-none text-right">{{ vm.roTotals.approvedAmounts.totalShopSupplies | currency }}</td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="approvedServices.length"><td class="border-none padding-top-none padding-bottom-none" colspan="10"></td><td class="border-none padding-top-none padding-bottom-none text-right">Fees</td><td class="border-none padding-top-none padding-bottom-none text-right">{{ vm.roTotals.approvedAmounts.totalFees | currency }}</td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="approvedServices.length"><td class="border-none padding-top-none padding-bottom-none" colspan="10"></td><td class="border-none padding-top-none padding-bottom-none text-right">Tax</td><td class="border-none padding-top-none padding-bottom-none text-right">{{ vm.roTotals.approvedAmounts.totalTaxes | currency }}</td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="approvedServices.length"><td class="border-none padding-top-none padding-bottom-none" colspan="9"></td><td class="border-none padding-top-none text-right" ng-class="{ \'padding-bottom-none\': !vm.pendingTotalsOpen }" colspan="2"><b>Total Approved</b></td><td class="border-none padding-top-none text-right" ng-class="{ \'padding-bottom-none\': !vm.pendingTotalsOpen }"><b>{{ vm.roTotals.approvedAmounts.totalCustomerPay | currency }}</b></td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="vm.pendingTotalsOpen"><td class="border-none" colspan="7"></td><td class="text-right border-bottom">{{vm.roTotals.pendingAmounts.totalLineItemCount}} Item<span ng-if="vm.roTotals.totalPendingLineItems > 1">s</span></td><td class="border-bottom">{{ vm.roTotals.pendingAmounts.laborHours }}</td><td class="text-right border-bottom">{{ vm.roTotals.pendingAmounts.totalLabor | currency }}</td><td class="text-right border-bottom">{{ vm.roTotals.pendingAmounts.totalParts | currency }}</td><td class="border-bottom text-right">{{ vm.roTotals.pendingAmounts.totalRetail | currency }}</td><td class="border-none"></td></tr><tr class="no-hover text-uppercase" ng-if="vm.roTotals.totalPendingDiscount && vm.pendingTotalsOpen"><td class="padding-top-none padding-bottom-none" colspan="9"></td><td class="padding-top-none padding-bottom-none text-right" colspan="2">Pending Discount</td><td class="padding-top-none padding-bottom-none text-right text-danger">({{ vm.roTotals.pendingAmounts.totalDiscount | currency }})</td><td class="padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="vm.pendingTotalsOpen"><td class="border-none padding-top-none padding-bottom-none" colspan="8"></td><td class="border-none padding-bottom-none text-right" colspan="3">Pending Shop Supplies</td><td class="border-none padding-bottom-none text-right">{{ vm.roTotals.pendingAmounts.totalShopSupplies | currency }}</td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="vm.pendingTotalsOpen"><td class="border-none padding-top-none padding-bottom-none" colspan="9"></td><td class="border-none padding-top-none padding-bottom-none text-right" colspan="2">Pending Fees</td><td class="border-none padding-top-none padding-bottom-none text-right">{{ vm.roTotals.pendingAmounts.totalFees | currency }}</td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr class="no-hover text-uppercase" ng-if="vm.pendingTotalsOpen"><td class="border-none padding-top-none padding-bottom-none" colspan="9"></td><td class="border-none padding-top-none padding-bottom-none text-right" colspan="2">Pending Tax</td><td class="border-none padding-top-none padding-bottom-none text-right">{{ vm.roTotals.pendingAmounts.totalTaxes | currency }}</td><td class="border-none padding-top-none padding-bottom-none"></td></tr><tr ng-if="vm.roTotals.pendingAmounts.totalLineItemCount > 0" class="no-hover text-uppercase"><td class="border-none padding-top-none padding-bottom-none" colspan="9"></td><td class="border-none padding-top-none padding-bottom-none text-right" colspan="2"><b>Total Pending</b></td><td class="border-none padding-top-none padding-bottom-none text-right"><b>{{ vm.roTotals.pendingAmounts.totalCustomerPay | currency }}</b></td><td class="border-none padding-top-none padding-bottom-none padding-left-none"><div class="display-flex content-center"><i class="material-icons md-18 link" ng-if="!vm.pendingTotalsOpen" ng-click="vm.pendingTotalsOpen = !vm.pendingTotalsOpen;">expand_more</i> <i class="material-icons md-18 link" ng-if="vm.pendingTotalsOpen" ng-click="vm.pendingTotalsOpen = !vm.pendingTotalsOpen;">expand_less</i></div></td></tr><tr class="no-hover text-uppercase" ng-if="approvedServices.length"><td class="border-none padding-top-none padding-bottom-none" colspan="10"></td><td class="border-none padding-top-none padding-bottom-none text-right"><b>Total</b></td><td class="border-none padding-top-none padding-bottom-none text-right"><b>{{ vm.roTotals.totalCombinedCustomerPay | currency }}</b></td><td class="border-none padding-top-none padding-bottom-none"></td></tr></tbody></table></div></div></div><div class="flex-fullwidth-64h shadow-border-top"><div class="display-flex flex-row full-width full-height padding"><div class="flex-grow flex-percent-50"><event-alert></event-alert></div><div class="text-right flex-grow"><button class="btn btn-default text-uppercase" ng-if="vm.sendForPaymentsEnabled()" ng-click="vm.sendToPayments()" ladda="vm.creatingInvoice">SEND TO PAYMENTS</button></div></div></div></div></div>');
$templateCache.put('app/areas/inspect/views/ro-detail/inspect-tab-shopnotes.view.html','<div class="tab-section full-height overflow-y-auto padding-right"><div class="display-flex align-items-center max-width-percent-65 override-max-width-100 margin-top override-xs-text-left override-xs-align-items-normal"><div class="flex-grow padding-left-30 override-xs-side-padding-md align-bottom"><div class="block relative"><textarea class="form-control better-placeholder resize-none" id="shopNoteInput" rows="2" ng-model="vm.newNote" placeholder="Add New Note"></textarea></div></div><div class="margin-left-md align-bottom override-xs-margin-none override-xs-side-padding-md override-xs-padding-top-sm"><button class="btn btn-default" id="addShopNoteButton" ng-click="vm.addShopNote()" ng-disabled="!vm.newNote">Add</button></div></div><div ng-if="vm.isLoading" class="margin-top padding-left-30 override-xs-side-padding-md"><img src="assets/images/ajax-loader.gif"> LOADING</div><div ng-if="!vm.isLoading" class="margin-top padding-left-30 override-xs-side-padding-md max-width-percent-65 override-max-width-100"><div class="padding-bottom-md" ng-if="vm.shopNotes.length > 0"><div class="display-flex flex-column margin-bottom" ng-repeat="note in vm.shopNotes"><div class="display-flex align-items-center margin-bottom-xs text-uppercase max-width-calc-90-percent flex-row-nowrap"><span class="ellipsis-overflow"><strong ng-if="note.lineItem.description" title="{{ ::note.lineItem.description }}">{{::note.lineItem.description}} <span ng-if="note.lineItem.formattedCorrection">:</span></strong> <span title="{{ ::note.lineItem.formattedCorrection }}">{{::note.lineItem.formattedCorrection}}</span></span><div class="text-nowrap" ng-class="{\'margin-left-none\': !note.lineItem, \'margin-left-sm\': note.lineItem}">{{ note.dateCreated | fromNow }} ({{ note.authorName }})</div></div><div class="display-flex flex-percent-100 flex-row full-width"><div class="display-flex flex-percent-90 text-uppercase"><div ng-bind-html="vm.formatMessage(note.message)" class="font-normal"></div></div><div class="display-flex flex-percent-10"><div class="full-width text-right"><a href="#" class="theme-link" ng-click="vm.deleteShopNote(note.id)">DELETE</a></div></div></div></div></div><div class="override-xs-margin-none" ng-if="vm.shopNotes.length === 0"><div>No shop notes were found for this RO.</div></div></div></div>');
$templateCache.put('app/areas/loaner/components/additional-drivers/additional-drivers.component.view.html','<div id="insuranceInfo" class="padding-top-md"><div class="row"><div class="col-md-3 text-uppercase bold font-size-11 font-bold">Additional Drivers</div><div class="col-md-9"><div class="row margin-bottom-md"><div class="col-md-12"><a id="additional-driver" class="bold theme-link font-size-11 text-uppercase" href="#" ng-click="vm.ngModel.push({country: \'United States of America\'})">+ Add additional driver</a></div></div><div class="row" ng-if="!vm.ngModel || !vm.ngModel.length"><div class="col-md-12">No additional drivers</div></div><div ng-repeat="driver in vm.ngModel" class="border-top border-top-gray"><div class="margin-bottom-md margin-top-md" ng-if="!driver.shouldDelete"><div class="row margin-bottom-md"><div class="col-md-6"><label class="control-label full-width"><input type="text" name="addl_first_name{{$index}}" ng-model="driver.firstName" placeholder="FIRST NAME" class="form-control full-width better-placeholder" required="required" validation="required" ng-disabled="vm.isValidToDisable"></label></div><div class="col-md-6"><label class="control-label full-width"><input type="text" name="addl_last_name{{$index}}" ng-model="driver.lastName" placeholder="LAST NAME" class="form-control full-width better-placeholder" required="required" validation="required" ng-disabled="vm.isValidToDisable"></label></div></div><div class="row margin-bottom-md"><div class="col-md-6"><label class="control-label full-width"><div class="input-group loaner" moment-picker="driver.dateOfBirth" format="MM/DD/YYYY" start-view="month" change="vm.validateDOB(driver)"><div class="input-group-input col-xs-10 padding-left-none padding-right-none"><input name="addl_dob{{$index}}" placeholder="DATE OF BIRTH" class="date-control form-control full-width better-placeholder" ng-model-options="{ debounce: 750 }" pattern="(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/\\d{4}" ng-change="vm.validateDOB(driver)" ng-model="driver.dateOfBirth" ng-disabled="vm.isValidToDisable" required="required" validation="required:alt=Required"></div><div class="input-group-addon-container"><span class="input-group-addon appointment-calendar loaner" ng-disabled="vm.isValidToDisable" ng-class="{ \'cursor-pointer\': !vm.isValidToDisable, \'cursor-disabled\' : vm.isValidToDisable}"><i class="glyphicon glyphicon-calendar"></i></span></div></div><span class="validation text-danger" ng-if="driver.invalidDOB">You must be 21 to create a contract.</span></label></div><div class="col-md-6"><label class="control-label full-width"><input type="text" name="addl_country{{$index}}" ng-model="driver.country" class="form-control full-width better-placeholder" placeholder="COUNTRY" required="required" validation="required" ng-disabled="vm.isValidToDisable"></label></div></div><div class="row"><div class="col-md-6"><label class="control-label full-width"><input type="text" name="addl_licensenumber{{$index}}" ng-model="driver.licenseNumber" class="form-control full-width better-placeholder" placeholder="LICENSE NUMBER" required="required" ng-disabled="vm.isValidToDisable"></label></div><div class="col-md-2"><label class="control-label full-width field-wrapper"><label for="addl_state">STATE</label><select selectlabel="" class="form-control" id="addl_state" name="addl_state{{$index}}" ng-model="driver.licenseState" ng-options="str for str in vm.usStates" required="required" ng-disabled="vm.isValidToDisable"><option value="">State</option></select></label></div><div class="col-md-4 padding-left-none"><label class="control-label full-width"><div class="input-group loaner" moment-picker="driver.licenseExpiration" format="MM/DD/YYYY" start-view="month" change="vm.validateDLExp(driver)"><div class="input-group-input col-xs-10 padding-left-none padding-right-none"><input name="addl_dlexp{{$index}}" placeholder="EXPIRATION DATE" class="date-control form-control full-width better-placeholder" ng-change="vm.validateDLExp(driver)" ng-model-options="{ debounce: 750 }" pattern="(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/\\d{4}" ng-model="driver.licenseExpiration" ng-disabled="vm.isValidToDisable" required="required" validation="required:alt=Required"></div><div class="input-group-addon-container"><span class="input-group-addon appointment-calendar loaner" ng-disabled="vm.isValidToDisable" ng-class="{ \'cursor-pointer\': !vm.isValidToDisable, \'cursor-disabled\' : vm.isValidToDisable}"><i class="glyphicon glyphicon-calendar"></i></span></div></div><span class="validation text-danger" ng-if="driver.dlExpired">License is expired</span></label></div></div><div class="row margin-bottom-md"><div class="col-md-6"><label class="control-label full-width"><input type="text" id="phone_number" name="phone_number_{{$index}}" clean="true" autocomplete="nope" ng-model="driver.phone" class="form-control better-placeholder fake-required" placeholder="PHONE" ng-required="true" validation="required" ng-disabled="vm.isValidToDisable" mask-restrict="reject" mask="(999) 999-9999"></label></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-12"><a href="#" ng-click="vm.removeClicked(driver)" class="pull-right"><i id="license-remove-icon" class="material-icons padding-top-sm">remove</i> <span id="license-remove">Remove</span></a></div></div></div></div></div></div></div>');
$templateCache.put('app/areas/loaner/components/contract-details/contract-details.component.view.html','<div id="loanerVehicleIssues"><div class="row"><div class="col-md-2 text-uppercase bold">Contract</div><div class="col-md-1">VIN:</div><div class="col-md-8">{{vm.ngModel.vin}}</div></div><div class="row"><div class="col-md-offset-2 col-md-1">Desc</div><div class="col-md-8">{{vm.ngModel.year}} {{vm.ngModel.make}} {{vm.ngModel.model}} {{vm.ngModel.color}}</div></div><div class="row"><div class="col-md-offset-2 col-md-1">Issues</div><div class="col-md-8">{{vm.issues.length}} issues reported</div></div><div class="row"><div class="col-md-offset-2 col-md-1">Fuel</div><div class="col-md-8">Start {{vm.issues.fuelPercentageStart}}% End {{vm.issues.fuelPercentageEnd}}%</div></div><div class="row"><div class="col-md-offset-2 col-md-1">Mileage</div><div class="col-md-8">Start {{vm.issues.mileageStart}} End {{vm.issues.mileageEnd}}</div></div></div>');
$templateCache.put('app/areas/loaner/components/customer-info/customer-info.component.view.html','<div id="loanerCustomerInfo"><div class="row margin-bottom"><div class="col-md-3 text-uppercase bold font-size-11 font-bold">Primary Driver</div><div class="col-md-9 text">{{vm.ngModel.firstName}} {{vm.ngModel.lastName}} {{vm.ngModel.phone | tel}}</div></div></div>');
$templateCache.put('app/areas/loaner/components/credit-card/credit-card.component.view.html','<div class="row margin-bottom-md margin-top-md"><div class="col-md-3 text-uppercase bold font-size-11 font-bold">Credit Card</div><div class="col-md-9"><div ng-if="vm.ngModel"><div class="row"><div class="col-xs-12 margin-bottom-md text-bold">{{vm.ngModel.lastFour === "0000" ? "Credit card on file" : "Card Number ending in " + vm.ngModel.lastFour }}</div></div></div><div class="row" ng-if="!vm.ngModel"><div class="col-md-12">No credit card on file</div></div></div></div>');
$templateCache.put('app/areas/loaner/components/drag-drop-image/drag-drop-image.component.view.html','<div ng-if="!vm.supportsVideoCapture && !vm.checkingForVideoCapture" ngf-select="" ngf-drop="" ng-model="vm.file" ngf-model-invalid="invalidFiles" ngf-model-options="vm.options" ngf-multiple="multiple" ngf-pattern="\'{{vm.validationPattern}}\'" ngf-accept="\'{{vm.pattern}}\'" ng-disabled="{{vm.buttonDisabled}}" ngf-capture="capture" ngf-drag-over-class="{accept:\'highlight\', reject:\'highlight-err\', pattern:\'{{vm.validationPattern}}\'}" ngf-validate="validateObj" ngf-resize="resizeObj" ngf-validate-after-resize="false" ngf-resize-if="resizeIfFn($file, $width, $height)" ngf-dimensions="dimensionsFn($file, $width, $height)" ngf-duration="durationFn($file, $duration)" ngf-keep="keepDistinct ? \'distinct\' : keep" ngf-fix-orientation="orientation" ngf-max-files="maxFiles" ngf-media-limit="mediaLimit" ngf-media-type="mediaType" ngf-use-icon="useIcon" ngf-video-icon="videoIcon" ngf-ignore-invalid="ignoreInvalid" ngf-run-all-validations="runAllValidations" ngf-allow-dir="allowDir" class="camera-select position-relative" ng-class="{ \'small\': vm.useSmallButton, \'for-card\': vm.forCard, \'small-grey-boxes\': !vm.forCard }" ngf-change="vm.upload($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)" ngf-drop-available="dropAvailable"><div class="image-container" ng-if="!vm.alwaysShowIcon && vm.file && vm.file.$ngfBlobUrl"><img ngf-src="!vm.file.$error && vm.file && vm.file.$ngfBlobUrl"><div class="dragdrop-spinner-overlay" ng-if="vm.isLoading"><div class="text"><div class="spinner margin-bottom-md"></div><div ng-if="!vm.useSmallButton">{{vm.loadingText || \'Loading\'}}</div></div></div></div><div class="image-container" ng-if="vm.alwaysShowIcon || vm.file.$error || !vm.file || !vm.file.$ngfBlobUrl" ng-class="{\'flex-centered-col\': !vm.useSmallButton}"><i ng-if="vm.useIcon" class="material-icons md-28">{{ vm.videoIcon ? \'videocam\' : \'photo_camera\'}}</i><div><div ng-if="!vm.hideBtnText" ng-class="{\'margin-top-sm\':vm.useIcon}">{{ vm.placeholder }}</div><div ng-if="!vm.useIcon">Click to upload image</div><div ng-if="vm.ngRequired" class="validation text-danger" ng-class="{\'theme-link disabled\': vm.isCancelled || vm.isCompleted || vm.isContractStarted}">Required</div></div></div><input name="fileData" ng-model="vm.ngModel.fileData" ng-required="vm.ngRequired" type="hidden" id="{{vm.id}}"></div><div ng-if="vm.supportsVideoCapture" ng-click="vm.launchCamera()" class="camera-select small-grey-boxes"><div class="image-container font-bold" ng-class="{ \'small\': vm.useSmallButton, \'flex-centered-col\': !vm.useSmallButton }"><i class="material-icons">{{ vm.videoIcon ? \'videocam\' : \'photo_camera\'}}</i><div ng-if="!vm.hideBtnText">{{ vm.placeholder ? vm.placeholder : \'Add Photo\' }}</div></div></div><div class="text-danger" ng-if="vm.ngModel.errorMessage">{{vm.ngModel.errorMessage}}</div>');
$templateCache.put('app/areas/loaner/components/drivers-license/drivers-license.component.view.html','<div id="driversLicenseInfo" class="padding-top-md"><div class="row margin-bottom-md"><div class="col-md-3 text-uppercase bold font-size-11 font-bold">Driver\'s License</div><div class="col-md-9"><div class="text-danger margin-bottom-20" ng-if="vm.ngModel.credentialsValid === false">We are unable to save the credentials. Please contact support. Error received: <i>"{{vm.ngModel.credentialsError}}"</i></div><div class="row margin-bottom-md"><div class="col-md-6 text-uppercase" ng-if="!vm.ngModel.photoFront.fileData || !vm.ngModel.photoFront.url"><drag-drop-image id="front-image" ng-model="vm.ngModel.photoFront" native-camera-only="true" ng-required="true" placeholder="Front Image" image-type="licenseFront" is-cancelled="vm.isCancelled" is-completed="vm.isCompleted" is-contract-started="vm.isContractStarted"></drag-drop-image></div><div class="col-md-6 text-uppercase image-container" ng-if="vm.ngModel.photoFront.fileData && vm.ngModel.photoFront.url"><img class="loaner-photo" ng-src="{{vm.ngModel.photoFront.url}}" ng-click="vm.openImage(vm.ngModel.photoFront,\'front\')"></div><div class="col-md-6 text-uppercase" ng-if="!vm.ngModel.photoBack.fileData || !vm.ngModel.photoBack.url"><drag-drop-image id="back-image" ng-model="vm.ngModel.photoBack" ng-required="true" native-camera-only="true" image-type="licenseBack" placeholder="Back Image" on-load="vm.readBarcode" loading-text="SCANNING LICENSE" error-text="License scan was unsuccessful. Please retry scanning or enter license details manually." is-cancelled="vm.isCancelled" is-completed="vm.isCompleted" is-contract-started="vm.isContractStarted"></drag-drop-image><span class="text-danger" ng-if="vm.scanError">{{vm.scanError}}</span></div><div class="col-md-6 text-uppercase image-container" ng-if="vm.ngModel.photoBack.fileData && vm.ngModel.photoBack.url"><img class="loaner-photo" ng-src="{{vm.ngModel.photoBack.url}}" ng-click="vm.openImage(vm.ngModel.photoBack,\'back\')"></div></div><div class="row"><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input name="licenseNumber" type="text" class="form-control full-width better-placeholder" required="" validation="required" placeholder="LICENSE NUMBER" ng-model="vm.ngModel.number" ng-disabled="vm.isValidToDisable"></label></div><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><div class="input-group loaner" moment-picker="vm.currentDLEDay" format="MM/DD/YYYY" start-view="month" change="vm.updateDate(\'dle\')"><div class="input-group-input col-xs-10 padding-left-none padding-right-none"><input id="dlExpiration" name="dlExpiration" placeholder="EXPIRATION DATE" class="date-control form-control full-width better-placeholder" ng-change="vm.updateDate(\'dleTyped\')" ng-model-options="{ debounce: 750 }" pattern="(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/\\d{4}" ng-model="vm.ngModel.expiration" ng-disabled="vm.isValidToDisable" required="required" validation="required:alt=Required"></div><div class="input-group-addon-container"><span class="input-group-addon appointment-calendar loaner" ng-disabled="vm.isValidToDisable" ng-class="{ \'cursor-pointer\': !vm.isValidToDisable, \'cursor-disabled\': vm.isValidToDisable}"><i class="glyphicon glyphicon-calendar"></i></span></div></div><span class="validation text-danger" ng-if="vm.ngModel.dlExpired">License is expired</span></label></div></div><div class="row"><div class="col-md-12" ng-if="vm.useFullName"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input type="text" name="full_name" required="" validation="required" class="form-control full-width better-placeholder" placeholder="FULL NAME" ng-model="vm.ngModel.fullName" ng-disabled="vm.isValidToDisable"></label></div><div ng-if="!vm.useFullName"><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input name="first_name" required="" validation="required" type="text" class="form-control full-width better-placeholder" placeholder="FIRST NAME" ng-model="vm.ngModel.firstName" ng-disabled="vm.isValidToDisable"></label></div><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input name="last_name" type="text" required="" validation="required" class="form-control full-width better-placeholder" placeholder="LAST NAME" ng-model="vm.ngModel.lastName" ng-disabled="vm.isValidToDisable"></label></div></div></div><div class="row"><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><div class="input-group loaner" moment-picker="vm.currentDOBDay" format="MM/DD/YYYY" start-view="month" change="vm.updateDate(\'dob\')"><div class="input-group-input col-xs-10 padding-left-none padding-right-none"><input id="dob" name="dob" placeholder="DATE OF BIRTH" class="date-control form-control full-width better-placeholder" ng-change="vm.updateDate(\'dobTyped\')" ng-model-options="{ debounce: 750 }" pattern="(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/\\d{4}" ng-model="vm.ngModel.dateOfBirth" ng-disabled="vm.isValidToDisable" required="required" validation="required:alt=Required"></div><div class="input-group-addon-container"><span class="input-group-addon appointment-calendar loaner" ng-disabled="vm.isValidToDisable" ng-class="{ \'cursor-pointer\': !vm.isValidToDisable, \'cursor-disabled\' : vm.isValidToDisable}"><i class="glyphicon glyphicon-calendar"></i></span></div></div><span class="validation text-danger" ng-if="vm.ngModel.invalidDOBMessage">{{vm.ngModel.invalidDOBMessage}}</span></label></div></div><div class="row"><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input name="address1" type="text" class="form-control full-width better-placeholder" required="" validation="required" placeholder="STREET ADDRESS" ng-model="vm.ngModel.addressLine1" ng-disabled="vm.isValidToDisable"></label></div><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input type="text" class="form-control full-width better-placeholder" placeholder="STREET ADDRESS 2" ng-model="vm.ngModel.addressLine2" ng-disabled="vm.isValidToDisable"></label></div></div><div class="row"><div class="col-md-6"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input name="city" type="text" class="form-control full-width better-placeholder" required="" validation="required" placeholder="CITY" ng-model="vm.ngModel.addressCity" ng-disabled="vm.isValidToDisable"></label></div><div class="col-md-2"><label class="control-label full-width field-wrapper" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><label for="addl_state">STATE</label><select selectlabel="" class="form-control" id="addl_state" name="addl_state" ng-model="vm.ngModel.state" ng-options="str for str in vm.usStates" required="required" ng-disabled="vm.isValidToDisable"><option value="">State</option></select></label></div><div class="col-md-4"><label class="control-label full-width" ng-class="{\'control-label-margin\': vm.needsControlMargin() === true}"><input name="zip" type="text" class="form-control full-width better-placeholder" required="" validation="required" placeholder="ZIP" ng-model="vm.ngModel.addressZip" mask-restrict="reject" mask="99999" ng-disabled="vm.isValidToDisable"></label></div></div></div></div></div>');
$templateCache.put('app/areas/loaner/components/insurance/insurance.component.view.html','<div id="insuranceInfo" class="padding-top-md"><div class="row"><div class="col-md-3 text-uppercase bold font-size-11 font-bold">Insurance</div><div class="col-md-9"><div class="row"><div class="col-md-6 text-uppercase" ng-if="!vm.ngModel.photo.fileData || !vm.ngModel.photo.url"><drag-drop-image ng-required="true" native-camera-only="true" ng-model="vm.ngModel.photo" placeholder="Insurance Card" image-type="insuranceFront" is-cancelled="vm.isCancelled" is-completed="vm.isCompleted" is-contract-started="vm.isContractStarted"></drag-drop-image></div><div class="col-md-6 text-uppercase image-container" ng-if="vm.ngModel.photo.fileData && vm.ngModel.photo.url"><img class="loaner-photo" ng-src="{{vm.ngModel.photo.url}}" ng-click="vm.openImage()"></div><div class="col-md-6"><div class="row"><div class="col-xs-12"><label class="control-label full-width"><input type="text" name="carrier" required="" validation="required" class="form-control full-width better-placeholder" placeholder="CARRIER" ng-model="vm.ngModel.carrier" ng-disabled="vm.isValidToDisable"></label></div></div><div class="row"><div class="col-xs-12"><label class="control-label full-width"><input type="text" name="policynumber" required="" validation="required" class="form-control full-width better-placeholder" placeholder="POLICY NUMBER" ng-model="vm.ngModel.policyNumber" ng-disabled="vm.isValidToDisable"></label></div></div><div class="row" ng-if="vm.loanerClient == vm.loanerManagementSystemsEnum.ARS"><div class="col-xs-12"><label class="control-label full-width"><input type="text" name="carrierPhoneNumber" required="" inputmode="numeric" ng-model="vm.ngModel.phoneNumber" class="form-control full-width better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="PHONE NUMBER" validation="required" ng-disabled="vm.isValidToDisable"></label></div></div><div class="row"><div class="col-xs-12"><label class="control-label full-width"><div class="input-group loaner" moment-picker="vm.currentEDDay" format="MM/DD/YYYY" start-view="month" change="vm.updateDate(\'ed\')"><div class="input-group-input col-xs-10 padding-left-none padding-right-none"><input id="insexp" name="insexp" placeholder="EXPIRATION DATE" class="date-control form-control full-width better-placeholder" ng-change="vm.updateDate(\'edTyped\')" ng-model-options="{ debounce: 750 }" pattern="(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/\\d{4}" ng-model="vm.ngModel.expiration" ng-disabled="vm.isValidToDisable" required="required" validation="required:alt=Required"></div><div class="input-group-addon-container"><span class="input-group-addon appointment-calendar loaner" ng-disabled="vm.isValidToDisable" ng-class="{ \'cursor-pointer\': !vm.isValidToDisable, \'cursor-disabled\' : vm.isValidToDisable}"><i class="glyphicon glyphicon-calendar"></i></span></div></div><span class="validation text-danger" ng-if="vm.ngModel.insExpired">Insurance is expired</span></label></div></div></div></div></div></div></div>');
$templateCache.put('app/areas/loaner/components/loaner-summary/loaner-summary.component.view.html','<div id="loanerSummaryComponent" class="text-uppercase"><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 font-size-11 font-bold">Contract Status</div><div class="col-sm-8 font-size-11r">{{vm.resolvedContract.currentState | titleCase}}</div></div><div class="row margin-bottom-md margin-top-md"><div class="col-sm-3 font-size-11 font-bold">License</div><div class="col-sm-8 font-size-11">{{vm.customer.hasDriversLicense ? \'Complete\' : \'Pending\' }} <span class="theme-link margin-left-20" ng-click="vm.resendLink()" ng-if="!vm.validCompletedCanceled && !vm.isContractStarted"><u>SEND CUSTOMER FORM</u></span></div></div><div class="row margin-bottom-md margin-top-md"><div class="col-sm-3 font-size-11 font-bold">Insurance</div><div class="col-sm-8 font-size-11">{{vm.customer.hasProfileInsurance ? \'Complete\' : \'Pending\' }}</div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.resolvedContract.isCreditCardRequired || vm.resolvedContract.creditCard"><div class="col-sm-3 font-size-11 font-bold">Credit Card</div><div class="col-sm-8 font-size-11">{{vm.getCreditCardStatus()}}</div></div><div class="row margin-bottom-md margin-top-md"><div class="col-sm-3 font-size-11 font-bold">Signature</div><div class="col-sm-8 font-size-11">{{vm.getSignatureStatus()}}</div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.resolvedContract.appointmentId"><div class="col-sm-3 font-size-11 font-bold">Appointment</div><div class="col-sm-8 font-size-11"><a class="theme-link decorate-underline" ui-sref="appointment-details({locationId: {{::vm.tripModel.locationId}}, appointmentId: {{::vm.resolvedContract.appointmentId}}})">#{{vm.resolvedContract.appointmentDmsId || vm.resolvedContract.appointmentId}}</a> <span ng-if="vm.resolvedContract.appointmentDateTime">{{vm.resolvedContract.appointmentDateTime | localDate}}</span></div></div><div class="row margin-bottom-md margin-top-md"><div class="col-sm-3 font-size-11 font-bold">Pickup</div><div class="col-sm-8 font-size-11"><a class="theme-link decorate-underline" ui-sref="trip-tab-trip({ tripId: {{::vm.resolvedContract.pickupTripId}}})" ng-if="vm.resolvedContract.pickupTripId">#{{vm.resolvedContract.pickupTripId}}</a> <span ng-if="!vm.resolvedContract.pickupTripInProgress && vm.resolvedContract.pickupTripId"><span ng-if="vm.resolvedContract.pickupTripDateTime">{{vm.resolvedContract.pickupTripDateTime | localDate}}</span> <span ng-if="!vm.resolvedContract.pickupTripDateTime">{{vm.resolvedContract.pickup | date}}</span></span> <span ng-if="vm.resolvedContract.pickupTripInProgress && vm.resolvedContract.pickupTripId">{{ vm.resolvedContract.pickupTripStatus}} - <span ng-if="vm.resolvedContract.pickupTripETASeconds">ETA {{ vm.calcETATime(vm.resolvedContract.pickupTripETASeconds) | time}}</span> <span ng-if="!vm.resolvedContract.pickupTripETASeconds"><span ng-if="vm.resolvedContract.pickupTripDateTime">{{ vm.toLocalTimeFormat(vm.resolvedContract.pickupTripDateTime, \'hh:mmA\') }}</span> <span ng-if="!vm.resolvedContract.pickupTripDateTime">{{vm.resolvedContract.pickup | date}}</span></span></span> <i ng-if="vm.resolvedContract.pickupTripId && !vm.resolvedContract.pickupTripCompleted" class="material-icons cursor-pointer theme-link md-14 vertical-align-sub" ng-click="vm.removeLoaner(vm.resolvedContract.pickupTripId)" title="Remove Loaner">highlight_off</i> <a class="theme-link decorate-underline" ui-sref="trip-add(vm.pickupTripModel)" ng-if="!vm.resolvedContract.pickupTripId" ng-class="{\'theme-link disabled\': vm.validCompletedCanceled}">BOOK</a></div></div><div class="row margin-bottom-md margin-top-md"><div class="col-sm-3 font-size-11 font-bold">Dropoff</div><div class="col-sm-8 font-size-11"><a class="theme-link decorate-underline" ui-sref="trip-tab-trip({ tripId: {{::vm.resolvedContract.returnTripId}}})" ng-if="vm.resolvedContract.returnTripId">#{{vm.resolvedContract.returnTripId}}</a> <span ng-if="vm.resolvedContract.returnTripDateTime && vm.resolvedContract.returnTripId">{{vm.resolvedContract.returnTripDateTime | localDate}}</span> <span ng-if="!vm.resolvedContract.returnTripDateTime && vm.resolvedContract.returnTripId">{{vm.resolvedContract.dropoff | date}}</span> <i ng-if="vm.resolvedContract.returnTripId && !vm.resolvedContract.returnTripCompleted" class="material-icons cursor-pointer theme-link md-14 vertical-align-sub" ng-click="vm.removeLoaner(vm.resolvedContract.returnTripId)" title="Remove Loaner">highlight_off</i> <a class="theme-link decorate-underline" ui-sref="trip-add(vm.returnTripModel)" ng-if="!vm.resolvedContract.returnTripId" ng-class="{\'theme-link disabled\': vm.validCompletedCanceled}">BOOK</a></div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.resolvedContract.serviceVehicle"><div class="col-sm-3 font-size-11 font-bold">Service Vehicle</div><div class="col-sm-8 font-size-11">{{vm.resolvedContract.serviceVehicle.year}} {{vm.resolvedContract.serviceVehicle.make}} {{vm.resolvedContract.serviceVehicle.model}} <span ng-if="vm.resolvedContract.serviceVehicle.vin">(VIN #{{vm.resolvedContract.serviceVehicle.vin}})</span> <span ng-if="vm.resolvedContract.serviceVehicle.odometer">({{vm.resolvedContract.serviceVehicle.odometer.value | number}}) Mi</span></div></div><div class="row margin-bottom-sm margin-top-sm" ng-if="vm.loanerPreferences.vehiclePreferences && vm.loanerPreferences.vehiclePreferences.length > 0" ng-repeat="vehicle in vm.loanerPreferences.vehiclePreferences | orderBy : \'rank\'"><div class="col-sm-3 font-size-11 font-bold"><span ng-if="vehicle.rank === 1">First&nbsp;</span><span ng-if="vehicle.rank === 2">Second&nbsp;</span> Preference</div><div class="col-sm-8 font-size-11"><span class="summary-model-name">{{vehicle.model}}</span> <img class="loaner-pref-vehicle-image" ng-src="{{vehicle.imageUrl}}"><br></div></div><div class="row margin-bottom-md margin-top-sm" ng-if="vm.loanerPreferences.transportationType === vm.cflTransportationTypes.firstAvailable && vm.enableLoanerPrefs == true"><div class="col-sm-3 font-size-11 font-bold">Loaner Preference</div><div class="col-sm-8 font-size-11">First Available <img class="loaner-pref-vehicle-image" src="https://redcapstorage.blob.core.windows.net/automotivelogos/vehicle-placeholder.png"></div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.loanerPreferences.transportationType === vm.cflTransportationTypes.lyftCredit && vm.enableLoanerPrefs == true"><div class="col-sm-3 font-size-11 font-bold">Loaner Preference</div><div class="col-sm-8 font-size-11">Lyft Credit <span class="theme-link" ng-if="vm.resolvedContract.rideProviderCredit" ui-sref="lyft-credit-edit({ id: vm.resolvedContract.rideProviderCredit.id, isTest: vm.resolvedContract.rideProviderCredit.isTest === true ? 1 : 0})">#{{vm.resolvedContract.rideProviderCredit.id}}</span></div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.loanerPreferences.transportationType !== vm.cflTransportationTypes.lyftCredit"><div class="col-sm-3 font-size-11 font-bold">Loaner Vehicle</div><div class="col-sm-8 font-size-11" ng-if="vm.resolvedContract.loanerVehicle.id">{{vm.resolvedContract.loanerVehicle.model}}<span ng-if="vm.resolvedContract.loanerVehicle.stockNumber">&nbsp;#{{vm.resolvedContract.loanerVehicle.stockNumber}}</span> <span ng-if="vm.loanerPreferences.vehiclePreferences && vm.loanerPreferences.vehiclePreferences.length > 0 && vm.resolvedContract.loanerVehicle.model.toLowerCase() === vm.loanerPreferences.vehiclePreferences[0].model.toLowerCase()">&nbsp;(1st Preference)</span> <span ng-if="vm.loanerPreferences.vehiclePreferences && vm.loanerPreferences.vehiclePreferences.length > 0 && vm.resolvedContract.loanerVehicle.model.toLowerCase() === vm.loanerPreferences.vehiclePreferences[1].model.toLowerCase()">&nbsp;(2nd Preference)</span></div><div class="col-sm-8 font-size-11" ng-if="!vm.resolvedContract.loanerVehicle.model">Pending</div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.loanerPreferences.transportationType === vm.cflTransportationTypes.chooseLoaner && vm.enableUpchargeFee == true && vm.enableLarPointsUpcharge == true"><div class="col-sm-3 font-size-11 font-bold">Pay With Points</div><div class="col-sm-8 font-size-11"><span ng-if="vm.loanerPreferences.usePoints === false">No</span> <span ng-if="vm.loanerPreferences.usePoints === true">Yes</span></div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.loanerPreferences.transportationType === vm.cflTransportationTypes.chooseLoaner && vm.enableUpchargeFee == true"><div class="col-sm-3 font-size-11 font-bold">Est Upcharge</div><div class="col-sm-8 font-size-11"><span ng-if="vm.isLoanerVehiclePreferredVehicle() !== 0 && vm.getContractTotalDays() > 0">{{::vm.getContractTotalDays()}} DAYS @ ${{::vm.getDailyDollars()}}<span ng-if="::vm.enableLarPointsUpcharge">&nbsp;OR {{::vm.getDailyPoints()}}pts</span>&nbsp;PER DAY = ${{::vm.getEstDollars()}}<span ng-if="::vm.enableLarPointsUpcharge">/{{::vm.getEstPoints()}}PTS</span></span> <span ng-if="vm.isLoanerVehiclePreferredVehicle() === 0">Pending</span></div></div><div class="row margin-bottom-md margin-top-md" ng-if="vm.enableUpchargeFee == true"><div class="col-sm-3 font-size-11 font-bold">Upcharge Status</div><div class="col-sm-3 font-size-11"><div ng-if="!vm.resolvedContract.invoices || !vm.resolvedContract.invoices.length" class="text-uppercase" ui-sref="loaner-reservation-edit({\'reservationId\': vm.resolvedContract.externalContractId, \'locationId\': vm.filters.location.id})">{{vm.getPaymentStatusText(vm.resolvedContract.paymentStatus)}}</div><div ng-repeat="invoice in vm.resolvedContract.invoices" class="text-uppercase"><a ui-sref="payment-edit({invoiceId: invoice.id})">#{{invoice.id}} {{vm.getInvoiceStatusText(invoice.status)}}</a></div><div class="field-wrapper margin-top"><label for="action">ACTION</label><select selectlabel="" class="form-control loaner-action" name="action" id="action" ng-disabled="vm.disableActionDropdown(vm.resolvedContract)" ng-model="vm.resolvedContract.selectedAction" ng-change="vm.actionClicked(vm.resolvedContract)" ng-options="action.value as action.text for action in vm.loanerActions"><option value="">Action</option></select></div></div></div></div>');
$templateCache.put('app/areas/loaner/components/loaner-vehicle/loaner-vehicle.component.view.html','<div ng-show="!vm.vehicle || !vm.vehicle.id">No Vehicle has been assigned to this reservation</div><div ng-show="vm.vehicle && vm.vehicle.id" class="row"><div class="col-xs-12 margin-bottom"><div class="row margin-bottom"><div class="col-xs-12"><h4 class="text-uppercase black">DETAILS</h4></div></div><div class="row margin-bottom-md text-uppercase"><div class="col-xs-2"><b>VEHICLE</b></div><div class="col-xs-10">{{vm.vehicle.year}} {{vm.vehicle.make}} {{vm.vehicle.model}}</div></div><div class="row margin-bottom-md"><div class="col-xs-2"><b>STOCK #</b></div><div class="col-xs-10">{{vm.vehicle.stockNumber}}</div></div><div class="row margin-bottom-md"><div class="col-xs-2"><b>VIN</b></div><div class="col-xs-10">{{vm.vehicle.vin}}</div></div><div class="row margin-bottom-md"><div class="col-xs-2"><b>ODOMETER</b></div><div class="col-xs-10" ng-if="vm.dealerCountry.measurementType === vm.measurementTypes.imperical">{{ vm.vehicle.odometer.value | number : fractionSize }}mi</div><div class="col-xs-10" ng-if="vm.dealerCountry.measurementType === vm.measurementTypes.metric">{{ vm.vehicle.mileageInKm | number : fractionSize }}km</div></div><div class="row margin-bottom-md"><div class="col-xs-2"><b>FUEL</b></div><div class="col-xs-3" ng-if="vm.vehicle.fuelInLiters || vm.fuelCapacity"><div class="margin-top-md"><range-display value="{{vm.vehicle.fuelInLiters/vm.vehicle.fuelCapacity * 100}}" fuellevel="{{vm.levelFuel}}"></range-display></div></div></div><div class="row margin-top"><div class="col-xs-12"><h4 class="text-uppercase black">Issues</h4></div></div><div ng-if="!vm.loadingIssues"><div class="row" ng-if="!vm.vehicle.issues || !vm.vehicle.issues.length"><div class="col-xs-12">No issues to display</div></div><div class="loaner-issue-row"><div class="row"><div class="col-xs-12 margin-top-md"><div class="inline" ng-repeat="issue in vm.vehicle.issues"><div class="loaner-issue-thumbnail" ng-repeat="image in issue.images"><div><img ng-src="{{image.url}}" class="max-height margin-top-md" ng-click="vm.openImage(image)"><div class="text-center">{{issue.createdDateTime | date : \'MM/dd/yyyy\'}}</div><div class="text-center" ng-if="issue.description.toLowerCase().trim() != \'none\'">{{ issue.description }}</div></div></div></div></div></div></div></div><div ng-if="vm.loadingIssues" class="margin-top"><img src="assets/images/ajax-loader.gif"> Loading ...</div></div></div>');
$templateCache.put('app/areas/loaner/components/vehicle-info/vehicle-info.component.view.html','<div id="loanerVehicleIssues"><div class="row"><div class="col-md-3 text-uppercase bold header">Service Vehicle</div><div class="col-md-9"><div class="row"><div class="col-xs-12"><label class="control-label full-width">VIN <input type="text" class="form-control full-width" ng-model="vm.ngModel.vin"></label></div></div><div class="row"><div class="col-xs-4"><label class="control-label full-width"><span class="text-uppercase">Year</span> <input type="text" class="form-control full-width" ng-model="vm.ngModel.year"></label></div><div class="col-xs-4"><label class="control-label full-width"><span class="text-uppercase">Make</span> <input type="text" class="form-control full-width" ng-model="vm.ngModel.make"></label></div><div class="col-xs-4"><label class="control-label full-width"><span class="text-uppercase">Model</span> <input type="text" class="form-control full-width" ng-model="vm.ngModel.model"></label></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/ownercare/views/done.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.configValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Inspection Report\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" app-type="3"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><div class="text-center padding-bottom-sm"><div class="consumer-header-text padding-bottom-none">{{vm.title}}</div><div class="margin-bottom-20">{{vm.event.vehicle.year}} {{vm.event.vehicle.model}}</div></div><div class="margin-bottom-20">{{vm.paragraph}}</div><div class="sub-heading-text margin-bottom-md">Approved Services</div><div ng-repeat="item in vm.approvedServices" class="row margin-bottom-md"><div class="col-xs-9">{{item.name}}</div><div class="col-xs-3 text-right">{{item.total | currency}}</div></div><div ng-if="!vm.approvedServices || !vm.approvedServices.length" class="row margin-bottom-md"><div class="col-xs-9">No items selected</div><div class="col-xs-3 text-right">{{0 | currency}}</div></div><div class="row border-bottom border-bottom-gray margin-bottom-md"><div class="col-xs-9 margin-bottom-md">Est Taxes and Fees</div><div class="col-xs-3 text-right margin-bottom-md">{{vm.feeTotal | currency}}</div></div><div class="row font-bold"><div class="col-xs-9">Estimate Total</div><div class="col-xs-3 text-right">{{vm.total | currency}}</div></div><div class="margin-top-30 row"><div class="col-xs-12" ng-bind-html="vm.footerParagraph"></div></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/ownercare/views/error.view.html','<div class="owner-care tablet-size"><div class="margin-left-20 margin-right-20 flex-container-center" style="height:100vh"><div class="card align-middle full-width"><div class="card-content text-normal-case full-width"><div class="sub-heading-text text-center"><i class="material-icons material-icons-large">warning</i></div><div class="sub-heading-text">Oops...</div><div>{{vm.error}} Please contact your dealership for assistance.</div></div></div></div></div>');
$templateCache.put('app/areas/consumer/ownercare/views/landing.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.configValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Inspection Report\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" app-type="3"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h2 ng-bind-html="vm.title"></h2><div class="margin-bottom-20" ng-bind-html="vm.paragraph"></div><div class="homework-task-list margin-top-30"><div class="row margin-bottom-20"><div class="col-xs-1"><span class="circle-text">1</span></div><div class="col-xs-10 padding-top-sm margin-left-20"><strong>Review issues found</strong></div></div><div class="row margin-bottom-20"><div class="col-xs-1"><span class="circle-text">2</span></div><div class="col-xs-10 padding-top-sm margin-left-20"><strong>Approve or Defer</strong></div></div><div class="row margin-bottom-20"><div class="col-xs-1"><span class="circle-text">3</span></div><div class="col-xs-10 padding-top-sm margin-left-20"><strong>Final Confirmation</strong></div></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/ownercare/views/review.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.configValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Inspection Report\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" app-type="3"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><div class="text-center padding-bottom-sm"><div class="consumer-header-text padding-bottom-none">{{vm.title}}</div><div class="margin-bottom-20">{{vm.event.vehicle.year}} {{vm.event.vehicle.model}}</div></div><div class="margin-bottom-20">{{vm.paragraph}}</div><div class="sub-heading-text margin-bottom-md">Approved Services</div><div ng-repeat="item in vm.approvedServices" class="row margin-bottom-md"><div class="col-xs-9">{{item.name}}</div><div class="col-xs-3 text-right">{{item.total | currency}}</div></div><div ng-if="!vm.approvedServices || !vm.approvedServices.length" class="row margin-bottom-md"><div class="col-xs-9">No items selected</div><div class="col-xs-3 text-right">{{0 | currency}}</div></div><div class="row border-bottom border-bottom-gray margin-bottom-md"><div class="col-xs-9 margin-bottom-md">Est Taxes and Fees</div><div class="col-xs-3 margin-bottom-md text-right">{{vm.feeTotal | currency}}</div></div><div class="row font-bold"><div class="col-xs-9">Estimate Total</div><div class="col-xs-3 text-right">{{vm.total | currency}}</div></div><div class="margin-top-30 row"><div class="col-xs-1"><input type="checkbox" ng-model="vm.approve" class="checkbox" name="approve" id="approve" required=""></div><div class="col-xs-11"><label for="approve">By checking this box, you signify you have reviewed, understand, meet and agree to pay according to the <a target="_blank" ui-sref="consumer-terms-page({ dealerId: vm.dealerBranding.dealerId, appType: 3 })" class="theme-link">Terms and Conditions</a></label></div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'" back="vm.back()" disabled="!inputForm.$valid"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/ownercare/views/service-details.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.configValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Inspection Report\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" app-type="3"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20"><div ng-if="vm.isDeclining" class="margin-top-20"><div class="text-center padding-bottom-sm"><div class="consumer-header-text padding-bottom-none">Confirm Defer</div></div><div class="margin-bottom-20">Are you sure you want to defer this service?. Please review the material below to ensure you are ready to defer.</div></div><div class="service-details-header margin-left-negative-20 margin-right-negative-20"><div class="margin-left-20 margin-right-20 padding-bottom-md"><div class="sub-heading-text margin-bottom-20">{{vm.recommendation.name}}</div><div class="margin-bottom-md"><a class="info-icon sub-heading-text margin-right-20 white-bg" ng-if="vm.recommendation.attachedVideo && vm.recommendation.attachedVideo.length" ng-class="{\'active\': vm.selectedTab === vm.types.video}" ng-click="vm.setTab(vm.types.video)"><i class="material-icons material-icons-outlined text-primary">videocam</i> <span>{{vm.item.attachedVideo.length}}</span></a> <a class="info-icon sub-heading-text margin-right-20 white-bg" ng-if="vm.recommendation.attachedPhoto && vm.recommendation.attachedPhoto.length" ng-class="{\'active\': vm.selectedTab === vm.types.image}" ng-click="vm.setTab(vm.types.image)"><i class="material-icons material-icons-outlined text-primary">photo_camera</i> <span>{{vm.recommendation.attachedPhoto.length}}</span></a> <a class="info-icon sub-heading-text margin-right-20 white-bg" ng-if="vm.recommendation.attachedAudio && vm.recommendation.attachedAudio.length" ng-class="{\'active\': vm.selectedTab === vm.types.audio}" ng-click="vm.setTab(vm.types.audio)"><i class="material-icons material-icons-outlined text-primary">volume_up</i> <span>{{vm.recommendation.attachedAudio.length}}</span></a> <a class="info-icon sub-heading-text margin-right-20 white-bg" ng-if="vm.recommendation.additionalInformationArticle" ng-class="{\'active\': vm.selectedTab === vm.types.details}" ng-click="vm.setTab(vm.types.details)"><i class="material-icons material-icons-outlined text-primary">paste</i> <span>1</span></a></div></div></div><div class="media-window-full-width"><media-window items="vm.media"></media-window></div><div ng-if="vm.selectedTab === 0 && vm.recommendation.additionalInformationArticle"><div class="margin-bottom-md sub-heading-text">{{vm.recommendation.additionalInformationArticle.name}}</div><div class="margin-bottom-md">{{vm.recommendation.additionalInformationArticle.advantage}}</div><div class="margin-bottom-md">{{vm.recommendation.additionalInformationArticle.significance}}</div></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" back="vm.back()" back-text="\'Ok\'" ng-if="!vm.isDeclining"></contact-footer><contact-footer phone-number="vm.invoice.mainPhoneNumber" back="vm.back()" back-text="\'Cancel\'" next-text="\'Defer\'" next="vm.decline()" ng-if="vm.isDeclining"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/ownercare/views/services.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.configValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Inspection Report\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" app-type="3"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><div class="text-center padding-bottom-sm"><div class="consumer-header-text padding-bottom-none">{{vm.title}}</div><div class="margin-bottom-20">{{vm.event.vehicle.year}} {{vm.event.vehicle.model}}</div></div><button type="button" class="btn btn-block btn-primary btn-rounded margin-bottom-20" ng-click="vm.approveAll()">Approve All Items</button><service-card ng-repeat="item in vm.event.originalFailed" item="item"></service-card><service-card ng-repeat="item in vm.event.originalCautioned" item="item"></service-card><service-card ng-repeat="item in vm.event.failedRecommendations" item="item"></service-card><service-card ng-repeat="item in vm.event.cautionRecommendations" item="item"></service-card><contact-footer disabled="!inputForm.$valid" phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" back="vm.back()" loading="vm.loading" next-text="\'Next\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/ownercare/views/summary.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.configValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size owner-care"><consumer-header name="vm.dealerBranding.name" description="\'Inspection Report\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" app-type="3"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><div class="text-center padding-bottom-sm"><div class="consumer-header-text padding-bottom-none">Inspection Summary</div><div class="margin-bottom-20">{{vm.event.vehicle.year}} {{vm.event.vehicle.model}}</div></div><div class="card-group"><div class="position-absolute middle right-0 margin-right-md" style="z-index: 1000"><i class="material-icons material-icons-large cursor-pointer" ng-click="vm.nextPage()">keyboard_arrow_right</i></div><div class="cards"><summary-card title-text="\'Item(s) Failed\'" sub-text="\'Requiring immediate attention!\'" items="vm.failedItems" card-type="vm.statuses.fail"></summary-card><summary-card title-text="\'Item(s) Cautioned\'" sub-text="\'Requiring action in the near future\'" items="vm.cautionedItems" card-type="vm.statuses.caution"></summary-card></div></div><summary-card title-text="\'Item(s) Passed\'" sub-text="\'Based on our comprehensive inspection\'" items="vm.event.passedTasks" collapsable="true" collapsed="true" card-type="vm.statuses.pass"></summary-card><summary-card title-text="\'Original Concern(s)\'" items="vm.event.originalCustomerRequests" collapsable="true" collapsed="true"></summary-card><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.nextPage()" loading="vm.loading" next-text="\'Review Service Items\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/loaner/views/contracts/contracts-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="contracts" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-column"><div class="display-flex flex-row full-width"><div class="flex-percent-50 hidden-sm hidden-xs"><rc-list-mode-selector ng-model="vm.searchModeIcon" available-modes="vm.selectableViewModes" css-class="rc-list-selector" on-select-event="vm.listModeChanged()"></rc-list-mode-selector></div><div class="flex-sm-percent-90 flex-xs-percent-90 flex-grow visible-xs visible-sm padding-right-md padding-right-none"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.contracts.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)" align-right="true"></rc-list-advanced-filter-toggle></div></div></div><div class="display-flex flex-column full-width"><div class="display-flex flex-row flex-xs-column"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md hidden-xs hidden-sm"><div class="block relative padding-right-sm padding-left override-xs-padding-none override-sm-padding-none" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-200 flex-grow hidden-sm hidden-xs" ng-if="vm.locations.length > 1"><div class="block relative padding-left-sm padding-right-sm max-width-100-percent"><div class="field-wrapper wizard-dropdown"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.isLoading || vm.filters.search" ng-change="vm.selectedLocationChanged()" class="form-control" chosen="{width: \'100%\'}" max-shown-results="100" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-model="vm.filters.location" ng-options="l as l.displayText for l in vm.locations | orderBy: \'name\' track by l.id"></select></div></div></div><div class="flex-width-200 flex-grow flex-sm-percent-50 flex-xs-percent-100 override-sm-margin-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input type="text" class="form-control padding-right-md better-placeholder" ng-model="vm.filters.search" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshContracts(true)" placeholder="SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md hidden-xs hidden-sm"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="statusFilter" class="on">SELECT A STATUS</label><select selectlabel="" class="form-control" name="statusFilter" id="statusFilter" ng-model="vm.filters.status" ng-disabled="vm.isLoading || vm.filters.search" ng-change="vm.statusChanged()" ng-options="t.value as t.text for t in vm.contractStatuses"><option value="">All statuses</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top-md hidden-xs hidden-sm" ng-hide="vm.showCalendar() === true"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="dateRangeFilter">TIMEFRAME</label><select selectlabel="" class="form-control" name="dateRangeFilter" id="dateRangeFilter" ng-model="vm.filters.timeframe" ng-change="vm.timeframeChanged()" ng-disabled="vm.filters.search" ng-options="t.value as t.text for t in vm.timeframes"></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top-md hidden-xs hidden-sm" ng-hide="vm.showCalendar() === false"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="timeframe_range">TIMEFRAME</label> <input date-range-picker="" id="timeframe_range" name="timeframe_range" class="form-control date-picker" type="text" options="vm.dateRangePickerOptions" placeholder="CUSTOM TIMEFRAME" ng-model="vm.filters.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearCustomTimeFrame()">close</span></div></div><div class="flex-width-120 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.contracts.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)"></rc-list-advanced-filter-toggle></div></div><div ng-if="vm.filters.location" class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters required-filter-message="vm.requiredFilterMessage" required-filter-count="1" filter-count="vm.filterCount" record-count="vm.contracts.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper override-sm-padding-none override-xs-padding-none override-xs-overflow-x-hidden" id="contracts-table-wrapper"><table id="contracts-table" class="table table-hover searchable-list table-layout-fixed large-columns fixed-header-table border-bottom" ng-mousemove="vm.removeSelectedId()" infinite-scroll="vm.refreshContracts()" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore" infinite-scroll-distance="1" infinite-scroll-container="\'#contracts-table-wrapper\'" redcap-sort="vm.isLoading" redcap-sort-model="vm.filters" redcap-sort-callback="vm.sortChanged"><thead class="hidden-xs"><tr class="text-uppercase"><th ignore-sort="">Customer</th><th class="hidden-xs" ignore-sort="">Status/ID</th><th class="hidden-xs" ignore-sort="">Cust Vehicle</th><th class="hidden-xs" ng-if="vm.enableLoanerPrefs" ignore-sort="">Preferences</th><th class="hidden-xs" ignore-sort="">Loaner<span ng-if="vm.enableLoanerPrefs">&nbsp;(Pref)</span></th><th class="hidden-xs" sort-column="pickup">Pickup</th><th class="hidden-xs" sort-column="dropoff">Dropoff</th><th class="hidden-xs" ignore-sort="">Advisor</th><th class="hidden-xs" ignore-sort="">Paperwork</th><th class="hidden-xs" ignore-sort="">Duration</th><th class="hidden-xs" ignore-sort=""><span ng-if="vm.enableUpchargeFee">Est Charge</span></th><th class="width-px-160 hidden-xs" ignore-sort="">&nbsp;</th></tr></thead><tbody><tr ng-repeat="contract in vm.contracts"><td ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})"><div class="hidden-xs"><div class="text-uppercase"><strong>{{contract.customerName}}</strong></div><div>{{contract.customerPhone | tel }}</div></div><div class="visible-xs text-uppercase padding-md"><div><b>Customer Name:</b> {{contract.customerName}}</div><div><b>Customer Phone:</b> {{contract.customerPhone | tel}}</div><div ng-if="contract.customerVehicle"><div><b>Customer Vehicle:</b></div><span ng-if="contract.customerVehicle.year">{{contract.customerVehicle.year.slice(-2)}}</span> <span class="text-uppercase" ng-if="contract.customerVehicle.model">{{contract.customerVehicle.model}}</span><div ng-if="contract.customerVehicle.mileage">{{contract.customerVehicle.mileage}} MI</div><div ng-if="!contract.customerVehicle.mileage">&nbsp;</div></div><div><b>Contract Status:</b> {{contract.status}}</div><div><b>Contract State:</b> {{contract.currentState}}</div><div><b>Contract Number:</b> {{contract.contractNumber}}</div><div><b>Advisor:</b> {{contract.serviceAdvisorName}}</div><div class="paperwork-status"><b>Paperwork:</b> <span ng-if="contract.customerHasPaperworkComplete" class="text-success">COMPLETE</span> <span ng-if="!contract.customerHasPaperworkComplete" class="text-danger">INCOMPLETE</span></div><div><b>Duration:</b> <span ng-if="contract.duration"><span ng-if="contract.duration.days">{{contract.duration.days}}d</span><span ng-if="contract.duration.hours">&nbsp;{{contract.duration.hours}}h</span></span></div></div></td><td ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" class="text-uppercase col-xs-1 hidden-xs">{{contract.status}} {{contract.currentState}}<br>{{contract.contractNumber}}</td><td class="hidden-xs" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ignore-sort=""><div ng-if="contract.customerVehicle"><span ng-if="contract.customerVehicle.year">{{contract.customerVehicle.year.slice(-2)}}</span> <span class="text-uppercase" ng-if="contract.customerVehicle.model">{{contract.customerVehicle.model}}</span><div ng-if="contract.customerVehicle.mileage">{{contract.customerVehicle.mileage}} MI</div><div ng-if="!contract.customerVehicle.mileage">&nbsp;</div></div></td><td class="hidden-xs" ng-if="vm.enableLoanerPrefs" ignore-sort=""><div ng-if="!contract.loanerPreferences" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})">N/A</div><div ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ng-if="contract.loanerPreferences.transportationType === vm.cflTransportationTypes.chooseLoaner && contract.loanerPreferences.vehiclePreferences && contract.loanerPreferences.vehiclePreferences.length > 0"><div>#1 {{contract.loanerPreferences.vehiclePreferences[0].model}}</div><div>#2 {{contract.loanerPreferences.vehiclePreferences[1].model}}</div></div><div ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ng-if="contract.loanerPreferences.transportationType === vm.cflTransportationTypes.firstAvailable"><div>1st Avail Loaner</div></div><div ng-if="contract.loanerPreferences.transportationType === vm.cflTransportationTypes.lyftCredit">Lyft Credits <span class="theme-link" ng-if="contract.rideProviderId" ui-sref="lyft-credit-edit({ id: contract.rideProviderId, isTest: contract.isRideProviderTest === true ? 1 : 0})"><br>#{{contract.rideProviderId}}</span></div></td><td class="hidden-xs" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})">{{contract.vehicleYear != 0 ? contract.vehicleYear : ""}} {{contract.vehicleMake}} {{contract.vehicleModel}}<span ng-if="::vm.isLoanerVehiclePreferredVehicle(contract) > 0">&nbsp;{{::vm.isLoanerVehiclePreferredVehicle(contract) === 1 ? \'(1st)\' : \'(2nd)\' }}</span> <span ng-if="contract.vehicleStockNumber">(#{{contract.vehicleStockNumber}})</span></td><td class="hidden-xs"><div ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ng-if="contract.tripStartETA">{{contract.tripStartETA | localDate}}</div><div ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ng-if="!contract.tripStartETA">{{(contract.actualPickup || contract.pickup) | date}}</div><div ng-if="contract.tripId"><span class="theme-link" ui-sref="trip-tab-trip({ tripId: {{contract.tripId}} })">#{{contract.tripId}}</span> <i class="material-icons cursor-pointer theme-link md-14 vertical-align-sub" ng-click="vm.removeLoaner(vm.filters.location.id, contract)" title="Remove Loaner">highlight_off</i></div><div ng-if="!contract.tripId" class="theme-link" ng-click="vm.addTrip(vm.getTripModel(contract))">BOOK</div></td><td class="hidden-xs"><div ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ng-if="contract.returnETA">{{contract.returnETA | localDate}}</div><div ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})" ng-if="!contract.returnETA">{{(contract.estCompDate || contract.actualDropoff || contract.dropoff) | date}}</div><div ng-if="contract.returnTripId"><span ui-sref="trip-tab-trip({ tripId: {{contract.returnTripId}} })" class="theme-link">#{{contract.returnTripId}}</span></div><div ng-if="!contract.returnTripId" class="theme-link" ng-click="vm.validateStarted(contract)">BOOK</div></td><td class="hidden-xs" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})">{{contract.serviceAdvisorName}}</td><td class="paperwork-status hidden-xs" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})"><span ng-if="contract.customerHasPaperworkComplete" class="text-success">COMPLETE</span> <span ng-if="!contract.customerHasPaperworkComplete" class="text-danger">INCOMPLETE</span></td><td class="hidden-xs" ignore-sort="" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})"><span ng-if="contract.duration"><span ng-if="contract.duration.days">{{contract.duration.days}}d</span><span ng-if="contract.duration.hours">&nbsp;{{contract.duration.hours}}h</span></span></td><td class="hidden-xs" ignore-sort=""><div ng-if="vm.enableUpchargeFee && vm.isLoanerVehiclePreferredVehicle(contract) > 0" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})">${{::vm.getEstDollars(contract)}} <span ng-if="vm.enableLarPointsUpcharge">/ {{::vm.getEstPoints(contract)}}pts</span></div><div ng-if="!contract.invoices || !contract.invoices.length" class="text-uppercase" ui-sref="loaner-reservation-edit({\'reservationId\': contract.externalContractId !== 0 ? contract.externalContractId : contract.contractNumber, \'locationId\': vm.filters.location.id})">{{vm.getPaymentStatusText(contract.loanerPaymentStatus)}}</div><div ng-repeat="invoice in contract.invoices" class="text-uppercase"><a ui-sref="payment-edit({invoiceId: invoice.id})">#{{invoice.id}} {{vm.getInvoiceStatusText(invoice.status)}}</a></div></td><td class="hidden-xs" ignore-sort=""><div class="field-wrapper"><label for="action">ACTION</label><select selectlabel="" required="" class="form-control loaner-action" name="action" id="action" ng-disabled="vm.disableActionDropdown(contract)" ng-model="contract.selectedAction" ng-change="vm.actionClicked(contract)" ng-options="action.value as action.text for action in vm.loanerActions"><option value="">Action</option></select></div></td></tr></tbody></table><div class="padding-bottom-lg"><rc-list-standardized-footer record-count="vm.contracts.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore" location-required="true" selected-location="vm.filters.location"></rc-list-standardized-footer></div></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm" popover-trigger="mouseenter" uib-popover-template="\'filter-popover.html\'">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md override-xs-padding-top-none"><div class="flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md visible-sm visible-xs"><rc-list-mode-selector ng-model="vm.searchModeIcon" available-modes="vm.selectableViewModes" css-class="rc-list-selector" on-select-event="vm.listModeChanged()"></rc-list-mode-selector></div><div class="flex-width-300 flex-sm-percent-100 override-sm-margin-top-md override-xs-margin-top-md" ng-if="vm.locations.length > 1"><div class="block relative padding-left-none padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="field-wrapper wizard-dropdown"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.isLoading || vm.filters.search" ng-change="vm.selectedLocationChanged()" class="form-control" chosen="{width: \'100%\'}" max-shown-results="100" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-model="vm.filters.location" ng-options="l as l.displayText for l in vm.locations | orderBy: \'name\' track by l.id"></select></div></div></div><div class="flex-width-300 flex-sm-percent-100 override-sm-margin-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><input type="text" class="form-control padding-right-md better-placeholder" ng-model="vm.filters.search" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshContracts(true)" placeholder="SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="statusFilter1">SELECT A STATUS</label><select selectlabel="" class="form-control" name="statusFilter1" id="statusFilter1" ng-model="vm.filters.status" ng-disabled="vm.isLoading || vm.filters.search" ng-change="vm.statusChanged()" ng-options="t.value as t.text for t in vm.contractStatuses"><option value="">All statuses</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top" ng-hide="vm.showCalendar() === true"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="dateRangeFilter">TIMEFRAME</label><select selectlabel="" class="form-control" name="dateRangeFilter" id="dateRangeFilter" ng-model="vm.filters.timeframe" ng-change="vm.timeframeChanged()" ng-disabled="vm.filters.search" ng-options="t.value as t.text for t in vm.timeframes"></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top" ng-hide="vm.showCalendar() === false"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper"><label for="timeframe_range">TIMEFRAME</label> <input date-range-picker="" id="timeframe_range" name="timeframe_range" class="form-control date-picker" type="text" options="vm.dateRangePickerOptions" placeholder="CUSTOM TIMEFRAME" ng-model="vm.filters.customTimeframe"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearCustomTimeFrame()">close</span></div></div></div><div class="display-flex flex-row flex-sm-column"><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top"><div class="block relative padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><label for="customerMakeFilter">CUSTOMER MAKE</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.isLoading || vm.filters.search || !vm.filters.customerMakesFilter.length" ng-change="vm.filterChanged()" class="form-control" chosen="{width: \'100%\'}" max-shown-results="100" id="customerMakeFilter" name="customerMakeFilter" ng-model="vm.filters.customerMake" ng-options="cm as cm for cm in vm.filters.customerMakesFilter"><option value="">Customer make</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none field-wrapper margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><label for="loanerMakeFilter">LOANER MAKE</label><select selectlabel="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.isLoading || vm.filters.search || !vm.filters.loanerMakesFilter.length" ng-change="vm.filterChanged()" class="form-control full-width" chosen="{width: \'100%\'}" max-shown-results="100" id="loanerMakeFilter" name="loanerMakeFilter" ng-model="vm.filters.loanerMake" ng-options="lm as lm for lm in vm.filters.loanerMakesFilter"><option value="">Loaner make</option></select></div></div><div class="flex-width-200 flex-sm-percent-100 override-sm-margin-top"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none field-wrapper margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><label for="appointmentType">LOANER APPT TYPE</label><select selectlabel="" class="form-control" name="loanerAppointmentType" id="loanerAppointmentType" ng-model="vm.filters.loanerAppointmentType" ng-change="vm.filterChanged()" ng-options="t.value as t.text for t in vm.loanerAppointmentTypes"><option value="">Loaner appt type</option></select></div></div></div><div class="display-flex flex-row padding-bottom-lg min-height-px-130"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left margin-top-md override-xs-margin-top-sm"><div class="block relative padding-right-sm"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vm.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md override-xs-margin-top-sm"><rc-list-template-save-search-delete-btns list-controller="vm" current-search-template="vm.searchTemplateData.currentSearchTemplate" is-processing-template="vm.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vm.canManageGlobalTemplates" template-message="vm.templateMessage" save-btn-clicked="vm.saveBtnClicked()" save-as-btn-clicked="vm.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vm.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm override-xs-padding-left-sm" ng-click="vm.resetFilters(true);vm.close();">Reset Filters</div><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase margin-right-xs" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal><script type="text/ng-template" id="filter-popover.html"><div class=\'black\'>Location:<br/>{{vm.filters.location.name}}</div></script>');
$templateCache.put('app/areas/loaner/views/contracts/contracts-new.view.html','<div class="row modal-body"><uib-accordion close-others="true" class="trips-wizard margin-bottom-30" ng-class="{\'auto-height\': vm.zipMarkers }"><div class="ng-hide" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.chooseLocation" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.chooseLocation}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseLocation" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.chooseLocation" src="\'app/areas/loaner/views/contracts/partials/choose-location.view.html\'" ng-controller="ContractsChooseLocationController as vmPnl"></ng-include></div></div><div class="ng-hide" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.chooseCustomer" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.chooseCustomer}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseCustomer" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.chooseCustomer" src="\'app/areas/loaner/views/contracts/partials/choose-customer.view.html\'" ng-controller="ContractsChooseCustomerController as vmPnl"></ng-include></div></div><div class="ng-hide" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.pickupDateTime" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.pickupDateTime}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.pickupDateTime" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.pickupDateTime" src="\'app/areas/loaner/views/contracts/partials/choose-time.view.html\'" ng-controller="ContractsChooseTimeController as vmPnl"></ng-include></div></div></uib-accordion></div>');
$templateCache.put('app/areas/loaner/views/vehicles/vehicles-add.view.html','<div class="row modal-body" ng-if="vm.loadingTab"><div class="padding-md"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> LOADING</span></div></div><div class="row display-flex full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel flex-column overflow-hidden" ng-if="!vm.loadingTab"><div class="flex-fullwidth-50h theme-bg border-radius-top-7"><div class="flex-percent-70 pull-left text-bold font-size-16 padding text-uppercase"><div class="padding-left-md override-xs-padding-none">New Fleet Vehicle</div></div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white border-none"><uib-accordion close-others="true" class="trips-wizard margin-bottom-30" ng-class="{\'auto-height\': vm.zipMarkers }"><div class="ng-hide padding-left-md padding-right-md override-sm-padding-none" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.chooseLocation" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.chooseLocation}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.chooseLocation" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.chooseLocation" src="\'app/areas/loaner/views/vehicles/partials/choose-location.view.html\'" ng-controller="VehiclesChooseLocationController as vmPnl"></ng-include></div></div><div class="ng-hide padding-left-md padding-right-md override-sm-padding-none" ng-show="vm.accordion.selectedStep >= vm.accordion.steps.vehicleDetails" ng-class="{\'hide-border\':vm.accordion.selectedStep === vm.accordion.steps.vehicleDetails}"><div uib-accordion-group="" class="panel-default" is-open="vm.accordion.selectedStep == vm.accordion.steps.vehicleDetails" is-disabled="true"><ng-include ng-if="vm.accordion.selectedStep >= vm.accordion.steps.vehicleDetails" src="\'app/areas/loaner/views/vehicles/partials/vehicle-add-details.view.html\'" ng-controller="VehicleAddDetailsController as vmPnl"></ng-include></div></div></uib-accordion></div></div>');
$templateCache.put('app/areas/loaner/views/vehicles/vehicles-list.view.html','<div class="position-absolute display-flex flex-column overflow-hidden full-width-height"><div ng-cloak="" id="fleets" class="panel margin-md padding-xs display-flex flex-column overflow-hidden padding-bottom-none override-sm-padding-top-none override-sm-padding-none override-sm-margin-none"><div class="search-list-header search-filters white-bg override-sm-margin-none override-sm-padding-none"><div class="display-flex override-sm-shadow-border-bottom flex-row margin-bottom-md margin-top-md flex-xs-column flex-sm-column override-sm-padding-md"><div class="display-flex flex-column"><div class="display-flex flex-row full-width"><div class="flex-percent-50 hidden-sm hidden-xs"><rc-list-mode-selector ng-model="vm.searchModeIcon" available-modes="vm.selectableViewModes" css-class="rc-list-selector" on-select-event="vm.listModeChanged()"></rc-list-mode-selector></div><div class="flex-sm-percent-80 flex-xs-percent-80 flex-grow visible-xs visible-sm padding-right-md"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none max-width-100-percent" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.contracts.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)" align-right="true"></rc-list-advanced-filter-toggle></div><div class="flex-percent-10 visible-xs visible-sm max-width-px-30" ng-if="!vm.showAdvancedSearch"><a ng-click="vm.addVehicle()" ui-sref="loaners-add-vehicle" class="margin-left-md margin-top-xs visible-xs visible-sm theme-link" ng-class="config.styleClass" ng-show="vm.filters.loanerProviderType !== vm.loanerManagementSystemsEnum.TSDNew"><i class="md-24 material-icons" title="Add New">add</i></a></div></div></div><div class="display-flex flex-column full-width"><div class="display-flex flex-row flex-xs-column"><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md hidden-xs hidden-sm"><div class="block relative padding-right-sm padding-left override-xs-padding-none override-sm-padding-none" ng-if="vm.searchTemplateData.searchTemplates"><rc-list-select-saved-search current-search-template="vm.searchTemplateData.currentSearchTemplate" search-templates="vm.searchTemplateData.searchTemplates" on-select-event="vm.loadSearchTemplate(item, model)"></rc-list-select-saved-search></div></div><div class="flex-width-200 flex-grow hidden-xs hidden-sm" ng-if="vm.locations.length > 1"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-left-none max-width-100-percent"><div class="field-wrapper wizard-dropdown"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control max-width-100-percent" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-options="l as l.name for l in vm.locations | orderBy: \'name\' track by l.id" ng-disabled="vm.loadingMakes || vm.isLoading || vm.filters.search" max-shown-results="100" chosen="{width: \'100%\'}" ng-model="vm.filters.location" ng-change="vm.selectedLocationChanged()"></select></div></div></div><div class="flex-width-200 flex-grow flex-sm-percent-50 flex-xs-percent-100"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="override-sm-margin-top"><input type="text" class="form-control better-placeholder" ng-model="vm.filters.search" ng-disabled="!vm.filters.location" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshVehicles()" placeholder="SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md hidden-xs hidden-sm"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="chosen-field-wrapper"><label class="label selected margin-none padding-left-md">STATUS</label></div><div ng-dropdown-multiselect="" options="vm.filters.statusesFilter" selected-model="vm.filters.status" checkboxes="true" disabled="vm.filters.statusesFilter.length === 0 || vm.filters.search || vm.loadingMakes || vm.isLoading" extra-settings="vm.searchStatusSettings" events="vm.searchSStatusEvents" translation-texts="vm.searchStatusStrings"></div><img src="assets/images/ajax-loader.gif" class="vehicle-spinner" ng-show="vm.loadingMakes"></div></div><div class="flex-percent-20 hidden-xs hidden-sm"><rc-list-advanced-filter-toggle filter-count="vm.filterCount" filter-message="vm.filterMessage" record-count="vm.vehicles.length" toggle-advanced-search="vm.toggleShowSearchOptions()" reset-filters="vm.resetFilters(true)"></rc-list-advanced-filter-toggle></div></div><div ng-if="vm.filters.location" class="display-flex flex-row flex-sm-column visible-xs visible-sm"><rc-list-mobile-filters required-filter-message="vm.requiredFilterMessage" required-filter-count="1" filter-count="vm.filterCount" record-count="vm.vehicles.length" filter-message="vm.filterMessage"></rc-list-mobile-filters></div></div><div class="display-flex flex-column hidden-sm hidden-xs"><a ng-click="vm.addVehicle()" ui-sref="loaners-add-vehicle" class="btn btn-primary margin-left-md new-btn override-sm-margin-none override-xs-margin-none" ng-class="config.styleClass" ng-show="vm.filters.loanerProviderType !== vm.loanerManagementSystemsEnum.TSDNew">+ NEW</a></div></div></div><div class="padding-right-20 padding-bottom-50 overflow-y-auto flex-grow flex-percent-90 list-table-wrapper" id="vehicle-table-wrapper"><table id="vehicles-table" infinite-scroll-distance="1" infinite-scroll-container="\'#vehicle-table-wrapper\'" class="table table-hover searchable-list table-layout-fixed med-columns fixed-header-table border-bottom" ng-mousemove="vm.removeSelectedId()" infinite-scroll="vm.refreshVehicles()" infinite-scroll-disabled="vm.isLoading || !vm.canShowMore"><thead class="hidden-xs"><tr class="text-uppercase"><th>Vehicle</th><th ng-if="vm.showColumns.color">Color</th><th ng-if="vm.showColumns.vehicleGroup">Vehicle Group</th><th>Odometer</th><th>Fuel Level</th><th>Status</th><th>Lic Plate</th><th>VIN</th><th ng-if="vm.showColumns.location">Location</th><th ng-if="vm.showColumns.stockNumber">Stock Number</th></tr></thead><tbody><tr ng-repeat="vehicle in vm.vehicles"><td class="data align-middle cursor-pointer text-uppercase" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id, \'locationId\': vm.filters.location.id})"><div class="hidden-xs">{{vehicle.year}} {{vehicle.make}} {{vehicle.model}}</div><div class="visible-xs padding-md"><div><b>Vehicle:</b> {{vehicle.year}} {{vehicle.make}} {{vehicle.model}}</div><div ng-if="vm.showColumns.color"><b>Color:</b> {{vehicle.color | titleCase}}</div><div ng-if="vm.showColumns.vehicleGroup"><b>Vehicle Group:</b> {{vehicle.vehicleClass | titleCase}}</div><div><b>Odometer:</b> {{vehicle.odometer.value | number : fractionSize}} {{vehicle.odometer.type}}</div><div><b>Fuel Level:</b> {{vm.getFuelPercentage(vehicle)}}%</div><div><b>Status:</b> {{vehicle.status | titleCase}}</div><div><b>Lic Plate:</b> {{vehicle.license}}</div><div><b>VIN:</b> {{vehicle.vin}}</div><div ng-if="vm.showColumns.location"><b>Location:</b> {{vehicle.physicalLocation}}</div><div ng-if="vm.showColumns.stockNumber"><b>Stock #:</b> {{vehicle.stockNumber}}</div></div></td><td class="data align-middle cursor-pointer hidden-xs" ng-if="vm.showColumns.color" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id , \'locationId\': vm.filters.location.id})">{{vehicle.color | titleCase}}</td><td class="data align-middle cursor-pointer hidden-xs" ng-if="vm.showColumns.vehicleGroup" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id , \'locationId\': vm.filters.location.id})">{{vehicle.vehicleClass | titleCase}}</td><td class="data align-middle cursor-pointer hidden-xs" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id , \'locationId\': vm.filters.location.id})">{{vehicle.odometer.value | number : fractionSize}} {{vehicle.odometer.type}}</td><td class="text-uppercase data align-middle cursor-pointer hidden-xs" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id, \'locationId\': vm.filters.location.id})">{{vm.getFuelPercentage(vehicle)}}%</td><td class="data align-middle cursor-pointer hidden-xs" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id, \'locationId\': vm.filters.location.id})">{{vehicle.status | titleCase}}</td><td class="data align-middle cursor-pointer hidden-xs" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id, \'locationId\': vm.filters.location.id})">{{vehicle.license}}</td><td class="data align-middle cursor-pointer hidden-xs" ui-sref="loaner-vehicle-summary({\'vehicleId\': vehicle.id === 999 || vehicle.id === 0 ? vehicle.vin : vehicle.id, \'locationId\': vm.filters.location.id})">{{vehicle.vin}}</td><td class="text-uppercase data align-middle cursor-pointer hidden-xs" ng-if="vm.showColumns.location">{{vehicle.physicalLocation}}</td><td class="text-uppercase data align-middle cursor-pointer hidden-xs" ng-if="vm.showColumns.stockNumber">{{vehicle.stockNumber}}</td></tr></tbody></table><rc-list-standardized-footer record-count="vm.vehicles.length" is-loading="vm.isLoading" can-show-more="vm.canShowMore" location-required="true" selected-location="vm.filters.location"></rc-list-standardized-footer></div></div></div><fake-modal id="fake-modal" ng-if="vm.showAdvancedSearch" custom-class="\'modal-md fake-modal\'"><div class="modal-content bg-transparent"><div class="row display-flex full-height margin-right-none"><div class="padding-right-none display-flex flex-column overflow-hidden full-width-height"><div class="flex-fullwidth-50h border-radius-top-7 modal-header"><button type="button" class="close" ng-click="vm.close()">&times;</button><h4 class="modal-title"><div class="display-flex content-center"><i class="md-24 material-icons padding-right-sm" popover-trigger="mouseenter" uib-popover-template="\'filter-popover.html\'">filter_list</i> FILTER</div></h4></div><div class="overflow-visible override-sm-overflow-y-scroll overflow-x-hidden flex-grow flex-percent-90 full-width bg-white padding-md override-sm-padding-left-25"><div class="display-flex flex-row flex-sm-column padding-top-md override-xs-padding-top-none"><div class="flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top-md visible-sm visible-xs"><rc-list-mode-selector ng-model="vm.searchModeIcon" available-modes="vm.selectableViewModes" css-class="rc-list-selector" on-select-event="vm.listModeChanged()"></rc-list-mode-selector></div><div class="flex-width-300 flex-sm-percent-100 override-sm-padding-top-md override-xs-padding-top-sm" ng-if="vm.locations.length > 1"><div class="block relative padding-left-none padding-right-sm override-xs-padding-none override-sm-padding-none override-xs-margin-top-sm"><div class="field-wrapper wizard-dropdown"><label for="locationFilter">LOCATION</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control max-width-100-percent" id="locationFilter" name="locationFilter" allow-null-option="Location" ng-options="l as l.name for l in vm.locations | orderBy: \'name\' track by l.id" ng-disabled="vm.loadingMakes || vm.isLoading || vm.filters.search" max-shown-results="100" chosen="{width: \'100%\'}" ng-model="vm.filters.location" ng-change="vm.selectedLocationChanged()"></select></div></div></div><div class="flex-width-300 flex-sm-percent-100 override-sm-padding-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none override-xs-margin-top-none"><input type="text" class="form-control better-placeholder" ng-model="vm.filters.search" ng-disabled="!vm.filters.location" ng-keyup="$event.keyCode == 13 && !vm.showAdvancedSearch && vm.refreshVehicles()" placeholder="SEARCH"> <span class="inline-block position-absolute material-icons bold cursor-pointer search-close-button ng-scope" ng-click="vm.clearSearchField()" ng-if="vm.filters.search">close</span></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative padding-left-sm padding-right-sm override-xs-padding-none override-sm-padding-none"><div class="chosen-field-wrapper"><label class="label selected margin-none padding-left-md">STATUS</label></div><div ng-dropdown-multiselect="" options="vm.filters.statusesFilter" selected-model="vm.filters.status" checkboxes="true" disabled="vm.filters.statusesFilter.length === 0 || vm.filters.search || vm.loadingMakes || vm.isLoading" extra-settings="vm.searchStatusSettings" events="vm.searchSStatusEvents" translation-texts="vm.searchStatusStrings"></div><img src="assets/images/ajax-loader.gif" class="vehicle-spinner" ng-show="vm.loadingMakes"></div></div></div><div class="display-flex flex-row flex-sm-column"><div class="flex-width-200 flex-sm-percent-100"><div class="block relative override-xs-padding-none override-sm-padding-none margin-top-md padding-right-sm"><div class="chosen-field-wrapper"><label class="label selected margin-none padding-left-sm" for="makeFilter">SELECT MAKE</label></div><select class="form-control" selectlabel="" id="makeFilter" name="makeFilter" chosen="{width: \'100%\'}" max-shown-results="100" ng-model="vm.filters.make" ng-disabled="vm.loadingMakes || vm.isLoading || vm.filters.search" ng-options="item as item for item in vm.filters.makesFilter" ng-change="vm.makesFilterChanged()"><option value="">All makes</option></select><img src="assets/images/ajax-loader.gif" class="vehicle-spinner" ng-show="vm.loadingMakes"></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div class="chosen-field-wrapper"><label class="label selected margin-none padding-left-md" for="makeFilter">SELECT MODEL</label></div><select class="form-control" selectlabel="" id="modelFilter" name="modelFilter" ng-disabled="vm.loadingMakes || vm.isLoading || !vm.filters.location || vm.filters.search" max-shown-results="100" chosen="{width: \'100%\'}" ng-model="vm.filters.model" ng-options="item as item for item in vm.filters.modelsFilter" ng-change="vm.filterChanged()"><option value="">All models</option></select><img src="assets/images/ajax-loader.gif" class="vehicle-spinner" ng-show="vm.loadingMakes"></div></div><div class="flex-width-200 flex-sm-percent-100 override-xs-margin-top-md override-sm-margin-top"><div class="block relative padding-right-sm padding-left-sm override-xs-padding-none override-sm-padding-none margin-top-md override-xs-margin-top-none override-sm-margin-top-none"><div class="chosen-field-wrapper"><label class="label selected margin-none padding-left-md">SELECT GROUP</label></div><select class="form-control" id="groupFilter" name="groupFilter" ng-disabled="vm.loadingMakes || vm.isLoading || vm.filters.search" max-shown-results="100" chosen="{width: \'100%\'}" ng-model="vm.filters.group" ng-options="item as item for item in vm.filters.vehicleClasses" ng-change="vm.filterChanged()"><option value="">All groups</option></select></div></div></div><div class="display-flex flex-row padding-bottom-lg min-height-px-130"><div class="flex-width-200 padding-right-sm flex-sm-percent-60 text-left margin-top-md"><div class="block relative padding-right-sm"><input type="text" name="savedsearch" class="form-control better-placeholder inline" ng-model="vm.searchTemplateData.savedSearchName" placeholder="SAVE VIEW AS.."></div></div><div class="flex-percent-30 flex-sm-percent-40 text-left margin-top-xs padding-left-sm"><div class="margin-top-md"><rc-list-template-save-search-delete-btns list-controller="vm" current-search-template="vm.searchTemplateData.currentSearchTemplate" is-processing-template="vm.searchTemplateData.isProcessingTemplate" can-manage-global-templates="vm.canManageGlobalTemplates" template-message="vm.templateMessage" save-btn-clicked="vm.saveBtnClicked()" save-as-btn-clicked="vm.saveAsBtnClicked()"></rc-list-template-save-search-delete-btns></div></div></div></div><div class="flex-fullwidth-70h bg-white border-radius-bottom-7 shadow-border-top z-index-2"><div class="row padding-md content-center margin-top-sm"><div class="full-width text-right padding-left-20 padding-right-20"><div ng-if="vm.filterCount > 0" class="theme-link pull-left margin-top-md text-uppercase padding-left-sm override-xs-padding-left-sm" ng-click="vm.resetFilters(true);vm.close();">Reset Filters</div><button type="button" ng-click="vm.close()" class="btn btn-default text-uppercase margin-right-xs" data-dismiss="modal">CANCEL</button> <button type="button" ng-click="vm.applyBtnClicked()" class="btn btn-primary text-uppercase" data-dismiss="modal">APPLY</button></div></div></div></div></div></div></fake-modal><script type="text/ng-template" id="filter-popover.html"><div class=\'black\'>Location:<br/>{{vm.filters.location.name}}</div></script>');
$templateCache.put('app/areas/loaner/views/vehicles/vehicles-summary.view.html','<div class="row display-flex full-height margin-right-none" aside-parent="vm.childScopeForm"><div class="col-md-12 col-xs-12 padding-right-none separate-left-aside-panel"><div class="display-flex flex-column overflow-hidden full-height"><div class="flex-fullwidth-50h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><div class="text-uppercase ellipsis-overflow font-size-16 font-bold"><h3><div>{{vm.resolvedVehicle.year}} {{vm.resolvedVehicle.make}} {{vm.resolvedVehicle.model}}</div><div ng-if="vm.resolvedVehicle.vin">{{vm.resolvedVehicle.vin}}</div></h3></div></div><div class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white"><div class="padding"><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">STOCK #</div><div class="col-sm-8 font-size-11">{{vm.resolvedVehicle.stockNumber}}</div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">LIC PLATE</div><div class="col-sm-8 font-size-11">{{vm.resolvedVehicle.license}}</div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">TRIM</div><div class="col-sm-8 font-size-11">{{vm.resolvedVehicle.trimId}}</div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">COLOR</div><div class="col-sm-8 font-size-11">{{vm.resolvedVehicle.color ? vm.resolvedVehicle.color : \'NA\' }}</div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">{{vm.resolvedContract && (vm.resolvedContract.contract.currentState.toLowerCase() == \'booked\' || vm.resolvedContract.contract.currentState.toLowerCase() == \'started\') ? \'CURRENT\' : \'LATEST\' }} AGREEMENT</div><div ng-if="vm.loadingContract == true"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-8 font-size-11" ng-if="vm.loadingContract == false" ng-show="vm.resolvedContract"><a class="theme-link" ng-click="$dismiss()" ui-sref="loaner-reservation-edit({\'reservationId\': vm.resolvedContract.contract.id, \'locationId\': vm.locationId})">#{{ vm.resolvedContract.contract.id }}</a> {{vm.resolvedContract.contract.currentState}}</div><div class="col-sm-8 font-size-11" ng-if="vm.loadingContract == false" ng-show="!vm.resolvedContract">NA</div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">APPOINTMENT</div><div ng-if="vm.loadingContract == true"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-8 font-size-11" ng-if="vm.loadingContract == false"><a class="theme-link" ng-click="$dismiss()" ui-sref="appointment-details({locationId: {{::vm.locationId}}, appointmentId: {{::vm.resolvedContract.appointmentId}}})" ng-if="vm.resolvedContract && vm.resolvedContract.appointmentId">#{{ vm.resolvedContract.appointmentId }}</a><spam ng-if="!(vm.resolvedContract && vm.resolvedContract.appointmentId)">NA</spam></div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">TRIP</div><div ng-if="vm.loadingContract == true"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-8 font-size-11" ng-if="vm.loadingContract == false"><a class="theme-link" ng-click="$dismiss()" ui-sref="trip-tab-trip({ tripId: {{::vm.resolvedContract.pickupTripId}}})" ng-if="vm.resolvedContract && vm.resolvedContract.pickupTripId">#{{ vm.resolvedContract.pickupTripId }}</a><spam ng-if="!(vm.resolvedContract && vm.resolvedContract.pickupTripId)">NA</spam></div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">EXPECTED RETURN</div><div class="col-sm-8 font-size-11">{{vm.resolvedVehicle.availableDate ? (vm.resolvedVehicle.availableDate | date) : (vm.resolvedVehicle.inServiceDate | date)}}</div></div><div class="row margin-top margin-bottom-md margin-top-md"><div class="col-sm-3 bold font-size-11 font-bold">STATUS</div><div class="col-sm-3 font-size-11"><div class="field-wrapper" ng-show="vm.loanerProviderType !== vm.loanerManagementSystemsEnum.TSDNew && vm.statusList.length > 0"><label for="status">Select Status</label><select selectlabel="" ng-model-options="{ debounce: 750 }" class="form-control" id="status" name="status" ng-options="status as status for status in vm.statusList" ng-model="vm.newStatus" ng-change="vm.statusChanged()" ng-disabled="vm.resolvedVehicle.status.toLowerCase() === \'rented\'"><option></option></select></div><div ng-show="vm.loanerProviderType === vm.loanerManagementSystemsEnum.TSDNew">{{vm.resolvedVehicle.status}}</div></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md text-uppercase padding-xs" ng-show="vm.newStatus.toLowerCase() === \'grounded\' || vm.newStatus.toLowerCase() === \'sold\'"><div class="input-group"><input type="text" id="dateStatus" class="form-control better-placeholder padding-left-none white-bg" placeholder="{{\'DATE \' + vm.newStatus}}" ng-model="vm.dateStatus" moment-picker="" start-view="month" format="ddd MM/DD/YY" min-date="moment(vm.today)" name="dateStatus" required="required" validation="required:alt=Required" is-open="vm.isPromiseTimePickerOpen"> <span class="input-group-addon appointment-calendar" ng-click="vm.isPromiseTimePickerOpen = !vm.isPromiseTimePickerOpen"><i class="glyphicon glyphicon-calendar"></i></span></div></div></div></div></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2"><div class="row padding-md margin-top-md"><div class="col-xs-12"><event-alert></event-alert><span class="pull-right margin-right-md"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-show="vm.loanerProviderType !== vm.loanerManagementSystemsEnum.TSDNew" ng-disabled="vm.loading" ng-click="vm.update()">Update</button> <button type="button" class="btn btn-primary text-uppercase" ng-class="config.styleClass" ng-show="vm.loanerProviderType !== vm.loanerManagementSystemsEnum.TSDNew" ng-disabled="vm.loading" ng-click="vm.edit()">Edit</button></span></div></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/trip/views/book.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form role="form" name="tripBookForm" id="tripBookForm" class="form" ng-submit="!vm.tripBooked && vm.bookTrip(tripBookForm.$valid)" novalidate="" fill-height=""><consumer-header name="vm.dealerBranding.name" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" trip-type-id="vm.systemTripTypes.lyftShuttleService" show-terms="vm.showTerms" app-type="4"></consumer-header><div id="public-map" class="map-fitwithfooter" map-resize=""><div id="map" class="full-width display-contents" fill-height="" heremaps="" options="vm.mapOptions" events="vm.mapListeners" map-ready="vm.onMapReady"></div></div><div id="track-footer" class="footer floating-container"><div ng-if="vm.alertMsg" ng-click="vm.clearAlert()" class="floating margin-bottom alert-msg"><h3 class="title"><i class="material-icons text-danger">error_outline</i> {{vm.alertMsg.title}}</h3><p>{{vm.alertMsg.description}} <a ng-if="vm.alertMsg.phoneNumber" href="tel:{{vm.alertMsg.phoneNumber}}">{{ vm.alertMsg.phoneNumber | tel }}</a></p></div><div ng-if="vm.lyftAlertMsg" ng-click="vm.clearLyftAlert()" class="floating margin-bottom alert-msg"><h3 class="title"><i class="material-icons text-danger">error_outline</i> OOPS...Unable to book</h3><p>Please try again. If you are unable to continue, Please contact the dealership at <a href="tel:{{vm.lyftAlertMsg.phoneNumber}}">{{ vm.lyftAlertMsg.phoneNumber | tel }}</a></p><p class="text-muted"><i>Error ({{vm.lyftAlertMsg.error}})</i></p></div><div ng-if="vm.consumerBookingDisclaimer" class="floating"><div class="row section padding-left-none padding-right-none"><div class="col-xs-1 recall-checkbox padding-sm padding-right-none"><input type="checkbox" class="checkbox margin-none" name="smsOptIn" ng-model="vm.smsOptIn" required="" validation="required"></div><div class="col-xs-11 padding-left-none padding-top-xs"><p>{{vm.consumerBookingDisclaimer}}</p></div><div class="col-xs-12" ng-if="vm.missingOptIn && !vm.smsOptIn"><div class="col-xs-12 text-danger">Agreeing to text updates is required to continue.</div></div></div></div><div class="floating"><div ng-click="vm.showPlacesSearch(true)" class="trip-input dim section" ng-class="{\'error\': vm.failedValidations.pickup }"><span class="location-info pickup" ng-if="vm.pickup"><strong>Pickup</strong> {{ vm.pickup.dealerName || vm.pickup.formattedAddress || vm.pickup.streetAddress}}</span> <span ng-if="!vm.pickup" ng-class="{ \'text-danger\': vm.formInvalid }">{{ vm.formInvalid ? \'Pickup required\' : \'Enter Pickup Location\' }}</span> <i ng-if="vm.canGetCurrentLocation && vm.canEditField(true)" ng-click="vm.useCurrentLocation($event)" class="material-icons my-location">my_location</i></div><div ng-click="vm.showPlacesSearch()" class="trip-input dim section" ng-class="{\'error\': vm.failedValidations.dropoff }"><span class="location-info dropoff" ng-if="vm.dropoff"><strong>Dropoff</strong> {{ vm.dropoff.dealerName || vm.dropoff.formattedAddress || vm.dropoff.streetAddress}}</span> <span ng-if="!vm.dropoff" ng-class="{ \'text-danger\': vm.formInvalid }">{{ vm.formInvalid ? \'Dropoff required\' : \'Enter Dropoff location\' }}</span></div></div><button ladda="vm.bookingTrip" type="submit" class="floating btn-primary" ng-style="{\'pointer-events\': !vm.smsOptIn || vm.canBook() ? \'auto\' : \'none\'}" ng-class="{\'disabled\': !vm.canBook()}">{{ vm.tripBooked ? \'Success!\' : \'Request\' }}</button></div><div ng-show="vm.searchVisible" class="location-search"><div class="search-header"><h3><i ng-click="vm.searchVisible = false" class="material-icons">arrow_back</i> Enter location information</h3></div><hr><div><div class="location-search-input"><input type="text" ng-attr-placeholder="{{ vm.isDropoffField() ? \'DROPOFF LOCATION\' : \'PICKUP LOCATION\'}}" id="customerLocation" class="form-control" name="customer_location" ng-model="vm.trip.customerLocation" details="vm.places" validation="required:alt=Required" here-places="" options="vm.placesOptions" handle-selected="vm.locationUpdated(formattedAddress)"> <a href="#" ng-click="vm.clearInput(true)"><i class="material-icons">close</i></a></div><hr><div class="location-search-input" ng-if="vm.systemTripType == vm.systemTripTypes.lyftRoadSideAssistance"><input type="text" ng-if="vm.systemTripType == vm.systemTripTypes.lyftRoadSideAssistance" ng-attr-placeholder="DROPOFF LOCATION" id="dropoffLocation" class="form-control" name="dropoffLocation" ng-model="vm.trip.dropoffLocation" details="vm.places" validation="required:alt=Required" here-places="" options="vm.placesOptions" handle-selected="vm.dropoffLocationUpdated(formattedAddress)"> <a href="#" ng-click="vm.clearInput(false, true)"><i class="material-icons">close</i></a></div><hr></div></div></form>');
$templateCache.put('app/areas/consumer/trip/views/invalid.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><form role="form" name="tripBookForm" id="tripBookForm" class="form" ng-submit="!vm.tripBooked && vm.bookTrip(tripBookForm.$valid)" novalidate="" fill-height=""><consumer-header name="vm.dealerBranding.name" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" trip-type-id="vm.systemTripTypes.lyftShuttleService" app-type="4"></consumer-header><div id="public-map" class="position-relative" map-resize=""><div id="map" fill-height="" heremaps="" options="vm.mapOptions" map-ready="vm.onMapReady" events="vm.mapListeners"></div></div><div id="track-footer" class="footer floating-container"><div ng-if="vm.alertMsg" class="floating margin-bottom alert-msg"><h3 class="title"><i class="material-icons text-danger">error_outline</i> {{ vm.alertMsg.title }}</h3><p>{{vm.alertMsg.description}} <a ng-if="vm.alertMsg.phoneNumber" href="tel:{{vm.alertMsg.phoneNumber}}">{{ vm.alertMsg.phoneNumber | tel }}</a></p></div></div></form>');
$templateCache.put('app/areas/consumer/trip/views/summary.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><div ng-if="vm.configValues.googleFontNames" ng-repeat="font in vm.configValues.googleFontNames.split(\';\')"><link ng-href="https://fonts.googleapis.com/css?family={{ font }}" rel="stylesheet"></div><link rel="stylesheet" ng-if="vm.configValues.cssOverridesFile !== \'None\'" ng-href="{{ vm.configValues.cssOverridesFile }}"><form class="form-horizontal trip-summary"><consumer-header name="vm.dealerBranding.name" description="vm.headers[vm.trip.systemTripTypeId]" description-image="vm.isProviderTrip ? \'../../../../assets/images/lyft-small.png\' : \'\'" description-image-class="vm.isProviderTrip ? \'lyft-logo\' : \'\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" trip-type-id="vm.trip.systemTripTypeId" trip-type-instance-id="vm.trip.tripTypeId" external-terms-page-url="vm.configValues.externalTermsPageURL" external-privacy-page-url="vm.configValues.externalPrivacyPageURL" show-terms="vm.showTerms" app-type="vm.appTypes.serviceValet" ng-show="!vm.isInFrame"></consumer-header><div class="margin-bottom-20 consumer-jumbotron-container position-relative" ng-show="!vm.isInFrame"><div driver-tracking="" options="vm.mapOptions" map-resize="" class="hidden-xs"></div><img ng-src="{{ vm.configValues.mobileHeaderImageUrl }}" class="mobile-header-img visible-xs"></div><div ng-if="vm.cancellingTrip" class="absolute-center has-shadow loader text-center"><img src="assets/images/spinner.gif"><h3>Cancelling Trip</h3></div><div class="margin-left-20 margin-right-20 consumer-appointments-content"><div ng-if="vm.trip.state === vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text">Thank You!</div><div ng-if="vm.trip.hasSurvey && vm.trip.hasSurveyResponse">We have received your survey and appreciate the feedback.</div></div></div></div><div class="row margin-bottom-30" ng-if="vm.trip.state === vm.tripStates.canceled"><div class="col-xs-12"><div class="text-uppercase consumer-header-text">Reservation #{{ vm.trip.id }}</div><div>Oops, it seems this reservation has been canceled.</div></div></div><div class="row margin-bottom-30"><ng-switch on="vm.trip.systemTripTypeId"><div class="col-xs-12" ng-switch-when="1"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-service-pickup.view.html\'"></div></div><div class="col-xs-12" ng-switch-when="2"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-service-dropoff.view.html\'"></div></div><div class="col-xs-12" ng-switch-when="8"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-test-drive.view.html\'"></div></div><div class="col-xs-12" ng-switch-when="11"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-recall.view.html\'"></div></div><div class="col-xs-12" ng-switch-when="15"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-vehicle-delivery.view.html\'"></div></div><div class="col-xs-12" ng-switch-when="17"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-dealer-trade.view.html\'"></div></div><div class="col-xs-12" ng-switch-when="22"><div ng-include="\'app/areas/consumer/trip/views/partials/summary-service-mobilegarage.view.html\'"></div></div></ng-switch></div><div class="row margin-top-30 padding-bottom-lg" ng-if="vm.allowEditCancel() === true && vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="col-xs-12"><button type="button" ng-if="vm.trip.canCancel" ng-click="vm.cancelTrip()" class="btn btn-rounded min-75">CANCEL</button> <button type="button" ng-if="vm.trip.canEdit && vm.trip.systemTripTypeId !== 22" ng-click="vm.editTrip()" class="btn btn-rounded btn-primary min-75">EDIT</button></div></div><div class="row margin-top-30 padding-bottom-lg" ng-if="vm.allowEditCancel() === false && vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="col-xs-12 margin-top margin-bottom"><b>Please call {{ vm.dealerBranding.salesPhoneNumber | tel}} if you need to cancel or make changes to your reservation.</b></div></div><div ng-if="vm.isInFrame" class="row"><div class="col-xs-12"><div class="text-center"><div class="margin-bottom-md"><a ng-if="vm.configValues.externalTermsPageUrl === \'None\'" target="_blank" class="theme-link font-size-12" ui-sref="consumer-terms-page({ dealerId: vm.trip.dealer.id, tripTypeId: vm.trip.systemTripTypeId, tripTypeInstanceId: vm.trip.tripTypeId, appType: vm.appTypes.serviceValet })"><u>Terms and Conditions</u></a> <a ng-if="vm.configValues.externalTermsPageUrl !== \'None\'" target="_blank" class="theme-link font-size-12" ng-href="{{ vm.configValues.externalTermsPageUrl }}"><u>Terms and Conditions</u></a></div><div class="margin-bottom-md"><a ng-if="vm.configValues.externalPrivacyPageUrl === \'None\'" target="_blank" class="theme-link font-size-12" ui-sref="consumer-privacy-page({ dealerId: vm.trip.dealer.id, tripTypeId: vm.trip.systemTripTypeId, tripTypeInstanceId: vm.trip.tripTypeId, appType: vm.appTypes.serviceValet })"><u>Privacy</u></a> <a ng-if="vm.configValues.externalPrivacyPageUrl !== \'None\'" target="_blank" class="theme-link font-size-12" ng-href="{{ vm.configValues.externalPrivacyPageUrl }}"><u>Privacy</u></a></div></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/trip/views/survey.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><div ng-if="vm.configValues.googleFontNames" ng-repeat="font in vm.configValues.googleFontNames.split(\';\')"><link ng-href="https://fonts.googleapis.com/css?family={{ font }}" rel="stylesheet"></div><link rel="stylesheet" ng-if="vm.configValues.cssOverridesFile !== \'None\'" ng-href="{{ vm.configValues.cssOverridesFile }}"><consumer-header name="vm.dealerBranding.name" description="vm.isProviderTrip ? \'Powered by \' : vm.headers[vm.trip.systemTripTypeId]" description-image="vm.isProviderTrip ? \'../../../../assets/images/\' + vm.providerName + \'-small.png\' : \'\'" description-image-class="vm.isProviderTrip ? vm.providerName + \'-logo\' : \'\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" trip-type-id="vm.trip.systemTripTypeId" trip-type-instance-id="vm.trip.tripTypeId" external-terms-page-url="vm.configValues.externalTermsPageURL" external-privacy-page-url="vm.configValues.externalPrivacyPageURL" show-terms="vm.showTerms" provider-name="vm.providerName" app-type="vm.appTypes.serviceValet"></consumer-header><div class="margin-bottom-20 consumer-jumbotron-container position-relative" ng-show="!vm.isInFrame"><div driver-tracking="" options="vm.mapOptions" class="hidden-xs"></div><img ng-src="{{ vm.configValues.mobileHeaderImageUrl }}" class="mobile-header-img visible-xs"></div><div class="survey padding-md"><h3 class="padding-top-md text-center">Tell us about it!</h3><p class="text-center">{{ vm.survey.mobileSurveyCopy }}</p><form role="form" name="surveyForm" class="form padding-top-md" ng-submit="!vm.surveySubmitted && vm.submitSurvey(surveyForm.$valid)" novalidate=""><div class="form-group" ng-repeat="question in vm.survey.questions"><div class="question">{{question.question}}</div><input ng-if="question.questionTypeId === vm.surveyQuestionType.textBox" type="text" ng-model="question.responseValue" name="question{{$index}}" class="form-control" validation="required"> <textarea ng-if="question.questionTypeId === vm.surveyQuestionType.textArea" ng-model="question.responseValue" name="question{{$index}}" class="form-control resize-none" validation="required"></textarea><select ng-if="question.questionTypeId === vm.surveyQuestionType.dropdown" ng-model="question.responseValue" name="question{{$index}}" class="form-control" ng-required="true" validation="required"><option value=""></option><option ng-repeat="option in question.options" ng-selected="{{option.isDefault}}" value="{{option.optionValue}}">{{option.optionText}}</option></select></div><button class="has-shadow" ladda="vm.submittingSurvey" type="submit">{{ vm.surveySubmitted ? \'Success\' : \'Submit\' }}</button></form></div>');
$templateCache.put('app/areas/consumer/trip/views/track.view.html','<consumer-dealer-custom-styles configs="vm.dealerBranding.styleValues"></consumer-dealer-custom-styles><div ng-if="vm.configValues.googleFontNames" ng-repeat="font in vm.configValues.googleFontNames.split(\';\')"><link ng-href="https://fonts.googleapis.com/css?family={{ font }}" rel="stylesheet"></div><link rel="stylesheet" ng-if="vm.configValues.cssOverridesFile !== \'None\'" ng-href="{{ vm.configValues.cssOverridesFile }}"><div ng-if="vm.searchingForDriver() && !vm.cancellingTrip && !vm.dialogShown" class="absolute-center has-shadow loader text-center"><img src="assets/images/spinner.gif"><h3>Searching for driver</h3></div><consumer-header name="vm.dealerBranding.name" description="vm.headerDescription" description-image="vm.isProviderTrip ? \'../../../../assets/images/\' + vm.providerName + \'-small.png\' : \'\'" description-image-class="vm.isProviderTrip ? vm.providerName + \'-logo\' : \'\'" phone-number="vm.dealerBranding.mainPhoneNumber" sms-number="vm.dealerBranding.smsNumber" address="vm.dealerBranding.address" city="vm.dealerBranding.city" state="vm.dealerBranding.state" zip="vm.dealerBranding.zip" lat="vm.dealerBranding.lat" lng="vm.dealerBranding.lng" image="vm.dealerBranding.bannerUrl" dealer-id="vm.dealerBranding.dealerId" trip-type-id="vm.trip.systemTripTypeId" trip-type-instance-id="vm.trip.tripTypeId" external-terms-page-url="vm.configValues.externalTermsPageURL" external-privacy-page-url="vm.configValues.externalPrivacyPageURL" show-terms="vm.showTerms" provider-name="vm.providerName" app-type="vm.appTypes.serviceValet"></consumer-header><div id="public-map" class="position-relative" map-resize=""><div id="map" driver-tracking="" options="vm.mapOptions"></div></div><div id="track-footer" class="footer floating-container"><div ng-if="vm.tripCanceled" class="floating alert-msg"><h3 class="title"><i class="material-icons text-danger">error_outline</i> {{ vm.noDrivers() ? \'Unable to locate driver\' : \'Shuttle Canceled\'}}</h3><p ng-if="!vm.noDrivers() && vm.trip.cancellationReason">{{vm.trip.cancellationReason}}</p><p>If you still need a ride, please contact the dealership at: <a href="tel:{{vm.trip.dealer.phoneNumber}}">{{vm.trip.dealer.phoneNumber | tel}}</a></p></div><div ng-if="!vm.tripCanceled && vm.tripComplete" class="floating alert-msg padding-none"><div class="trip-input section"><h3 class="title">{{vm.tripCompleteMsg.title}}</h3><p>{{vm.tripCompleteMsg.body}}</p></div><div ng-if="vm.trip.hasSurvey" class="trip-input section"><div ng-if="!vm.trip.hasSurveyResponse" ng-click="vm.goToSurvey()">Please tell us how we did<div class="survey-stars"><i class="material-icons">star_border</i> <i class="material-icons">star_border</i> <i class="material-icons">star_border</i> <i class="material-icons">star_border</i> <i class="material-icons">star_border</i></div></div><div ng-if="vm.trip.hasSurveyResponse"><h3 class="title"><i class="material-icons">check_circle_outline</i> Survey Complete</h3></div></div><div ng-if="vm.trip.hasSurveyResponse && vm.configValues.desktopSurveyCompleteCopyText" class="trip-input section" ng-bind-html="vm.configValues.desktopSurveyCompleteCopyText"></div></div><div ng-if="!vm.tripCanceled && !vm.tripComplete" class="floating"><div ng-if="vm.stateDescription" class="trip-input section text-center text-uppercase">{{ vm.stateDescription }} <span ng-if="vm.eta && vm.eta > 0">(ETA {{vm.eta | duration}})</span></div><div class="driver-info row no-gutter section" ng-if="!vm.searchingForDriver() && vm.isProviderTrip"><div class="col-xs-3 centered"><div class="spinner img-wrap" afkl-lazy-image="{{ ::vm.trip.lyftVehicle.imageUrl }}" lazy-load-fail="assets/images/user-square.png"></div></div><div class="col-xs-6 text-center vehicle-info"><div><strong>{{vm.trip.driver.name}}</strong></div><div>{{vm.trip.lyftVehicle.make}} {{ vm.trip.lyftVehicle.model }}</div><div>{{ vm.trip.lyftVehicle.color }}<span ng-if="vm.trip.lyftVehicle.licensePlate">| {{ vm.trip.lyftVehicle.licensePlate }}</span></div></div><div class="col-xs-3 centered"><div class="spinner img-wrap profile" afkl-lazy-image="{{ vm.trip.driver.driverPhoto }}" lazy-load-fail="assets/images/user-square.png"></div></div></div><div class="driver-info row no-gutter section" ng-if="!vm.searchingForDriver() && !vm.isProviderTrip"><div class="col-xs-6 text-right"><img class="profile-photo" id="track-driver-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div><div class="col-xs-6 text-left" id="track-driver-info"><div id="track-driver-name"><strong ng-if="vm.trip.systemTripTypeId === vm.systemTripTypes.mobileGarage">Your Mobile Tech</strong> <strong ng-if="vm.trip.systemTripTypeId !== vm.systemTripTypes.mobileGarage">Your Driver</strong></div><div>{{vm.trip.driver.name}}</div></div></div><div class="trip-input section"><span class="location-info pickup"><strong><span ng-if="vm.trip.systemTripTypeId !== vm.systemTripTypes.mobileGarage">Pickup</span><span ng-if="vm.trip.systemTripTypeId === vm.systemTripTypes.mobileGarage">Service Location</span></strong> <span>{{vm.pickup.dealerName || vm.pickup.streetAddress}}</span></span></div><div class="trip-input section" ng-if="vm.trip.systemTripTypeId !== vm.systemTripTypes.mobileGarage"><span class="location-info dropoff"><strong>Dropoff</strong> {{vm.dropoff.dealerName || vm.dropoff.streetAddress}}</span></div><div class="contact-controls row section" ng-if="!vm.searchingForDriver()"><div ng-class="{ \'col-xs-4\': vm.trip.canCancel, \'col-xs-6\': !vm.trip.canCancel }" class="text-center"><a ng-class="{ disabled: vm.cancellingTrip}" ng-click="vm.messageDriver()" href="#"><div><i class="material-icons">chat_bubble_outline</i></div>TEXT</a></div><div ng-class="{ \'col-xs-4\': vm.trip.canCancel, \'col-xs-6\': !vm.trip.canCancel }" class="text-center"><a ng-class="{ disabled: vm.cancellingTrip}" ng-click="vm.callDriver()" href="#"><div><i class="material-icons">phone</i></div>CALL</a></div><div ng-if="vm.allowEditCancel() && vm.trip.canCancel && !vm.cancellingTrip && !vm.tripCanceled" ng-click="vm.cancelTrip()" class="col-xs-4 text-center"><div><i class="material-icons">cancel</i></div>CANCEL</div><div ng-if="vm.cancellingTrip" class="col-xs-4 text-center"><div class="spinner spinner-relative"></div><div class="cancelling-text">CANCELLING</div></div></div></div><button id="cancel-trip" ng-if="vm.searchingForDriver() && vm.allowEditCancel()" ng-click="vm.cancelTrip()" ladda="vm.cancellingTrip" type="button" class="floating">Cancel Trip</button></div>');
$templateCache.put('app/areas/location/views/appointments/capacity.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div id="location-form" class="padding-lg" fill-height=""><form role="form" name="inputForm" class="form-horizontal form booking-tab self-serve-form tab-capacities"><div ng-if="::(!vm.isSelfServe() && vm.locationId)"><h3>Capacity And Transportation Options</h3><p class="text-justify">Items that do not have capacity specified are unlimited until limits are added. Please pay close attention to gaps. For example, an item is set from 8:00am to 12:00pm and 1:00pm-6:00pm, this leaves 12:00pm-1:00pm with unlimited capacity. Also, capacities apply from the selected start time to immediately before the selected end time. For example, if you set Appointment capacity to 0 from 1:00pm to 2:00pm, all times between 1:00pm and 1:59pm will show as unavailable but 2:00pm will be available. Any per hour capacity applied to a 1/2 hour interval will be divided in half and rounded up. This also applies when a department opens or closes on the half hour.<br><br>The BUFFER field on the All Appointments and Loaner sections allow you to set a period of time before an Appointment or Appointment with a Loaner can be booked to give you time to prepare. When booking an appointment with a loaner, the greater of the buffers will apply.</p><hr></div><div ng-if="::vm.isSelfServe()" class="modal-header padding-none margin-none"><h2 class="modal-title margin-none padding-none">Manage Capacity And Transportation Options</h2></div><div class="text-center" ng-if="!vm.loaded"><img src="assets/images/ajax-loader.gif"> Loading...</div><div ng-if="vm.loaded"><div class="row margin-bottom" ng-if="vm.autoSaveInProgress || vm.updatingLocation || vm.isLoadingData() || vm.resolvedLocationList"><div class="col-sm-5 field-wrapper margin-top" ng-if="vm.resolvedLocationList"><label for="selectedLocation">SELECT A LOCATION</label><select selectlabel="" class="form-control" id="selectedLocation" name="selectedLocation" allow-null-option="Select a location" ng-options="l as l.name for l in vm.resolvedLocationList track by l.id" ng-model="vm.selectedLocation" ng-change="vm.selectedLocationChanged()" ng-disabled="vm.loadingDepartments"></select></div><div class="col-sm-5 margin-top" ng-if="vm.autoSaveInProgress || vm.updatingLocation || vm.isLoadingData()"><span ng-if="vm.autoSaveInProgress || vm.updatingLocation" class="pull-left text-uppercase margin-top-sm"><img src="assets/images/ajax-loader.gif"> SAVING LOCATION SETTINGS ...</span> <span ng-if="vm.isLoadingData()" class="text-uppercase"><img src="assets/images/ajax-loader.gif"> LOADING LOCATION SETTINGS ...</span></div></div><div class="row margin-bottom" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0"><div class="col-sm-5 col-xs-12 margin-bottom field-wrapper"><label for="selectedDepartment">SELECT A DEPARTMENT</label><select selectlabel="" id="selectedDepartment" ng-if="vm.dealerDepartments && vm.dealerDepartments.length > 0" name="selectedDepartment" ng-model-options="{ debounce: 750 }" class="form-control" ng-model="vm.selectedDepartmentId" ng-options="dept.id as dept.name for dept in vm.dealerDepartments | filter: {isDisabled: false}" ng-change="vm.departmentSelected()"><option value="">Select a department</option></select></div><div class="col-sm-8">&nbsp;</div></div><div class="row margin-bottom" ng-if="vm.dealerDepartments && vm.dealerDepartments.length === 0"><div class="col-sm-10 col-xs-12 margin-bottom text-danger">You must configure a department before setting up capacity.<br><br>Please go to the department configuration screen.</div></div><div ng-if="vm.locationId && vm.appointmentConstraints && vm.constraints && vm.selectedDepartment && vm.departmentTransportationTypes && !vm.isLoadingData()"><div class="col-xs-12 padding-left-none appointment-booking-accordion"><div id="all_appointments_container" class="panel panel-default"><div class="panel-heading border-bottom-none padding-bottom-none"><div class="row read-only-row text-uppercase"><div class="col-xs-12 capacity-heading">All Appointments</div></div><div class="row read-only-row margin-top"><div class="col-xs-3 min-width-px-150 max-width-px-150 padding-left-15 padding-right-md"><input name="buffer-appt" class="min-width-px-145 form-control no-spinners better-placeholder" ng-model-options="{ debounce: 750 }" placeholder="BUFFER (HRS)" type="text" inputmode="numeric" ng-model="vm.allApptsBuffer.constraintDataParsed.BufferHours" ng-change="vm.bufferConstraintChanged(vm.allApptsBuffer.constraintDataParsed)"></div></div></div><div class="panel-body"><div class="row col-xs-12 padding-right-none padding-left-none text-nowrap department-capacity-group"><div id="appt-constraints-valid-{{vm.selectedDepartment.id}}" class="text-danger validation"></div><div class="col-sm-12 constraint-row margin-none padding-right-none padding-left-md" ng-show="vm.isAppointmentItemOpen(vm.selectedDepartment)" ng-class="{\'padding-bottom-md\':$last}"><div ng-repeat="constraint in vm.appointmentConstraints | filter: { departmentId: vm.selectedDepartment.id } : true track by constraint.uid" ng-class="{\'first-row\': $index === 0, \'last-row\': $last}"><input ng-if="$first" type="hidden" name="appt-constraints-valid-{{vm.selectedDepartment.id}}" validation-error-to="appt-constraints-valid-{{vm.selectedDepartment.id}}" ng-model="vm.selectedDepartment.appointmentConstraintsAreValid" validation="custom: vm.validation.valConstraints(vm.appointmentConstraints, vm.validation.filterPredicate(vm.selectedDepartment.id)):alt=There was an overlap in the times for this constraint. Please adjust the selected constraints."><constraint ng-show="!constraint.isDeleted" definition-type="vm.constraintDefinitionType.appointment" is-saving="vm.saving" uid="constraint.uid" init-value="constraint" on-add="vm.addAppointmentConstraint(constraint, uid)" on-remove="vm.removeAppointmentConstraint(constraint)" on-change="vm.appointmentConstraintChange(elementsToRevalidate, vm.selectedDepartment.id)"></constraint></div></div><div class="col-sm-12 below-line-item-row padding-right-lg" ng-show="vm.isAppointmentItemOpen(vm.selectedDepartment)"><a href="#" class="pull-right theme-link" ng-click="vm.addNewAppointmentConstraint(vm.selectedDepartment.id)">ADD NEW</a></div></div></div></div></div><div class="col-xs-12 appointment-booking-accordion text-nowrap padding-left-none"><div ng-if="vm.departmentTransportationTypes"><div class="row margin-bottom-md read-only-row text-uppercase"><div class="col-xs-10"></div><div class="col-xs-1 collapsed-row switch-row-header" ng-click="$event.stopPropagation();$event.preventDefault();"><div><b>DASH</b></div></div><div class="col-xs-1 collapsed-row switch-row-header" ng-click="$event.stopPropagation();$event.preventDefault();"><div><b>CONSUMER</b></div></div></div></div></div><div class="col-xs-12 padding-left-none appointment-booking-accordion text-nowrap"><div id="other_triptypes_container" class="panel panel-default" ng-repeat="transportationType in vm.departmentTransportationTypes | filter: vm.filterTransportationTypes | orderBy: \'orderInUI\' track by transportationType.id" ng-class="{\'appointment-capacity-toggle-row\': !transportationType.hideConsumerToggle || !transportationType.hideDashboardToggle}"><div class="panel-heading border-bottom-none"><div class="row read-only-row text-uppercase"><div class="col-xs-10 capacity-heading" ng-class="{\'margin-bottom-md\': vm.isSelfServe()}" ng-bind="::transportationType.name"></div><div ng-if="transportationType.isDisabled === true && !vm.isSelfServe()" class="col-xs-10 validation text-danger text-normal">{{transportationType.name}} is disabled at the system level.</div><div class="col-xs-1 collapsed-row switch-row" ng-class="\'\'" ng-click="$event.stopPropagation();$event.preventDefault();"><div><switch id="dashboard-collapsed-{{$index}}" name="dashboard-collapsed-{{$index}}" ng-model="transportationType.showInDashboard" class="green" ng-change="vm.dashboardHeaderSwitched(transportationType)" ng-hide="transportationType.hideDashboardToggle" disabled="transportationType.isDisabled || vm.isSelfServe() || (vm.isOnlyDealerAdmin && !vm.isAdminUser)"></switch></div></div><div class="col-xs-1 collapsed-row switch-row" ng-click="$event.stopPropagation();$event.preventDefault();"><div><switch id="consumer-collapsed-{{$index}}" name="consumer-collapsed-{{$index}}" ng-model="transportationType.showInConsumer" class="green" ng-change="vm.consumerHeaderSwitched(transportationType)" ng-hide="transportationType.hideConsumerToggle" disabled="transportationType.isDisabled || vm.isSelfServe() || (vm.isOnlyDealerAdmin && !vm.isAdminUser)"></switch></div></div><div class="col-xs-12 pull-right text-danger" ng-if="!transportationType.showInConsumer && vm.isPickupLoaner(transportationType) && !vm.isSelfServe() && (!vm.isOnlyDealerAdmin || vm.isAdminUser)"><div class="pull-right">*Verify verbiage on consumer booking page does not reference loaners.</div></div></div><div class="display-flex flex-row read-only-row margin-bottom margin-bottom-sm" ng-if="vm.hasBufferConstraint(transportationType)"><div class="max-width-px-150 flex-percent-40 flex-xs-percent-100 flex-sm-percent-100 flex-grow padding-left-none padding-right-md margin-top-xs"><div class="block relative"><input name="buffer-appt" class="min-width-px-145 form-control no-spinners better-placeholder" ng-model-options="{ debounce: 750 }" placeholder="{{ transportationType.isMobileGarage ? \'TRAVEL TIME\' : \'BUFFER (HRS)\' }}" type="text" inputmode="numeric" ng-model="transportationType.deptConstraintData.BufferHours" ng-change="vm.bufferConstraintChanged(transportationType.deptConstraintData, transportationType)"></div></div><i class="material-icons info-icon security" ng-if="transportationType.isMobileGarage" uib-popover="Default driving to customer time in minutes added to the beginning of each appointment." popover-append-to-body="true" popover-placement="right" popover-trigger="mouseenter">info_outline</i></div></div><div class="panel-body padding-left-md" ng-if="transportationType.hideCapacitySettings === false"><div class="col-sm-12 padding-right-none constraint-container trans-type-container"><div class="row department-capacity-group"><div id="overlapError{{transportationType.id}}" class="validation text-danger"></div><div class="col-sm-12 constraint-row margin-none padding-right-none padding-left-none" ng-show="vm.isTransportationItemOpen(transportationType, vm.selectedDepartment)"><div ng-repeat="constraint in transportationType.constraints | filter: { departmentId: vm.selectedDepartment.id } : true track by constraint.uid" ng-class="{\'first-row\': $index === 0, \'padding-bottom-md\':$last }"><input ng-if="$first" type="hidden" name="constraints-valid-{{transportationType.uid}}-{{vm.selectedDepartment.id}}" ng-model="vm.selectedDepartment.constraintsAreValid" validation-error-to="#overlapError{{transportationType.id}}" validation="custom: vm.validation.valConstraints(transportationType.constraints, vm.validation.filterPredicate(vm.selectedDepartment.id)):alt=There was an overlap in the times for this constraint. Please adjust the selected constraints."><constraint ng-if="transportationType.showInConsumer === true || transportationType.showInDashboard === true || constraint.isNew === false" ng-show="!constraint.isDeleted" transportation-type="transportationType" is-saving="vm.saving" definition-type="vm.constraintDefinitionType.transportation" uid="constraint.uid" init-value="constraint" on-add="vm.addTransportationConstraint(constraint, transportationType, uid)" on-remove="vm.removeTransportationConstraint(constraint, transportationType)" on-change="vm.constraintChange(elementsToRevalidate, transportationType.uid, vm.selectedDepartment.id)"></constraint></div></div><div class="col-sm-12 text-danger padding-left-none" ng-if="transportationType.showInConsumer === false && transportationType.showInDashboard === false">No capacity settings can be added until enabled in either Consumer or Dashboard.</div><div class="col-sm-12" ng-show="vm.isTransportationItemOpen(transportationType, vm.selectedDepartment) && (transportationType.showInConsumer === true || transportationType.showInDashboard === true)"><a href="#" class="pull-right theme-link" ng-click="vm.addNewTransportationConstraint(transportationType, vm.selectedDepartment.id)">ADD NEW</a></div></div></div></div></div></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md padding-right-20"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading || vm.saving || vm.autoSaveInProgress" ng-disabled="inputForm.$invalid || !vm.selectedDepartmentId" ng-click="vm.updateBtnClicked(inputForm.$valid)">Update</button></div></div></div></div><location-sub-menu trip-types="vm.tripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/checkin/general.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div id="location-form" class="padding-lg" fill-height=""><form role="form" name="inputForm" class="form-horizontal form booking-tab"><div><h3>Predefined Walkaround Photos</h3><p>Create and manage groups of required photos for check-in. Order each section using the ORDER field. In the LIST OF PHOTOS field, type a placeholder (e.g. "Driver\u2019s Seat") and hit enter. The order of the placeholders determines the sequence in which they will be collected during check-in.</p><hr></div><div class="text-center" ng-if="!vm.loaded"><img src="assets/images/ajax-loader.gif"> Loading...</div><div ng-if="vm.loaded"><b class="font-normal">REQUIRED</b><div ng-repeat="lineItem in vm.mediaconfigItems track by $index"><div class="row margin-top-sm opcode-form-row"><div class="col-sm-1 col-xs-2 padding-right-none"><switch name="switch_{{$index}}" ng-model="lineItem.isRequired" class="green"></switch></div><div class="col-sm-1 col-xs-2 padding-right-none"><div class="block relative"><input type="number" name="order" class="form-control normal better-placeholder no-spinners" ng-model="lineItem.order" min="1" placeholder="ORDER" required="" ng-disabled="vm.isSaving"></div></div><div class="col-sm-3 col-xs-2 padding-right-none"><div class="block relative"><input type="text" name="categoryName" ng-model="lineItem.categoryDesc" placeholder="SECTION NAME" class="form-control normal better-placeholder" required="" ng-disabled="vm.isSaving"></div></div><div class="col-sm-2 col-xs-2 padding-right-none"><div class="field-wrapper"><label for="yourselect">Select type</label><select selectlabel="" class="form-control" ng-model="lineItem.mediaType" required="" ng-disabled="vm.isSaving"><option value="1">Photos</option><option value="2">Videos</option></select></div></div><div class="col-sm-4 col-xs-3 padding-right-none"><tags-input ng-show="lineItem.mediaType !== \'2\'" class="fake-required" name="item_search" placeholder="LIST OF PHOTOS" replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" required="" ng-model="lineItem.detailDescs" ng-disabled="vm.isSaving"></tags-input><tags-input ng-show="lineItem.mediaType === \'2\'" class="fake-required" name="item_search" placeholder="LIST OF VIDEOS" replace-spaces-with-dashes="false" add-on-space="false" enable-editing-last-tag="true" required="" ng-model="lineItem.detailDescs" ng-disabled="vm.isSaving"></tags-input><div class="checkInsettings-addnew" ng-show="$index == vm.mediaconfigItems.length-1"><a href="#" class="pull-right theme-link" ng-click="vm.onAdd(lineItem)">ADD NEW</a></div></div><div class="col-sm-1 col-xs-1 padding-left-none"><button type="button" class="btn btn-text-only" ng-click="vm.onRemove(lineItem)"><i class="material-icons material-icons-large28 theme-link">remove</i></button></div></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap"><div class="flex-percent-50 full-width text-left"><div ng-if="!vm.resolvedLocationList && (vm.autoSaveInProgress || vm.updatingLocation)" class="pull-left text-uppercase margin-top-sm"><img src="assets/images/ajax-loader.gif"> SAVING CURRENT CHANGES ...</div><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md padding-right-20"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading || vm.saving || vm.autoSaveInProgress" ng-disabled="inputForm.$invalid && !vm.isEmptyForm()" ng-click="vm.saveMediaConfig(inputForm.$valid)">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/loaner/views/reservations/reservations-add.view.html','<div class="modal-body" aside-parent="vm.childScopeForm"><h3>Reservation Details</h3><loaner-customer-info ng-model="vmPnl.customer"></loaner-customer-info><loaner-vehicle-info ng-model="vmPnl.loaner"></loaner-vehicle-info><loaner-drivers-license ng-model="vmPnl.driversLicense"></loaner-drivers-license><loaner-insurance ng-model="vmPnl.insurance"></loaner-insurance><loaner-credit-card ng-model="vmPnl.creditCard"></loaner-credit-card></div><div class="aside-footer"><div class="row padding-md"><div class="col-xs-12"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-contracts-list">Close</button> <button type="button" class="btn btn-primary text-uppercase" ng-class="config.styleClass" ng-click="vmPnl.save()">Save</button></div></div></div>');
$templateCache.put('app/areas/loaner/views/reservations/reservations-edit.view.html','<div class="row display-flex full-height margin-right-none" aside-parent="vm.childScopeForm"><div class="col-md-8 col-xs-12 padding-right-none separate-left-aside-panel" id="loaner-content"><div class="display-flex flex-column overflow-hidden full-height"><div class="flex-fullwidth-100h border-radius-top-7 theme-bg padding override-xs-side-padding-md"><aside-header ng-if="vmPnl.headerData" ng-model="vmPnl.headerData"></aside-header></div><div class="overflow-y-hidden overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white"><form name="inputForm" role="form" class="form" novalidate=""><uib-tabset id="loaner-details" class="invisible-tabs" ng-if="vmPnl.loadingTab === false"><uib-tab heading="SUMMARY" index="0" active="vmPnl.activeTab[0]" ng-click="vmPnl.clickTab(0)"><div class="display-flex full-width-height" fill-height=""><div class="display-flex flex-column full-width-height overflow-y-auto padding-bottom-lg"><div class="padding-bottom-lg margin-right-md"><div class="col-xs-12 padding-none"><div class="loaner-modal-holder padding-none margin-top"><loaner-summary ng-model="vmPnl.resolvedContract" loaner-preferences="vmPnl.loanerPreferences"></loaner-summary></div></div></div></div></div></uib-tab><uib-tab heading="DRIVER(S)" index="1" active="vmPnl.activeTab[1]" ng-click="vmPnl.clickTab(1)"><div class="display-flex full-width-height" fill-height=""><div class="display-flex flex-column full-width-height overflow-y-auto padding-bottom-lg"><div class="padding-bottom-lg margin-right-md"><div class="col-xs-12 padding-none"><div class="loaner-modal-holder padding-none margin-top" ng-if="vmPnl.loadingTab === false"><loaner-customer-info ng-model="vmPnl.customer"></loaner-customer-info><loaner-drivers-license ng-model="vmPnl.driversLicense" use-full-name="true" is-cancelled="vmPnl.resolvedContract.isCancelled" is-completed="vmPnl.resolvedContract.isCompleted" is-contract-started="vmPnl.resolvedContract.isContractStarted"></loaner-drivers-license><loaner-insurance ng-model="vmPnl.insurance" loaner-client="vmPnl.resolvedContract.loanerClient" is-cancelled="vmPnl.resolvedContract.isCancelled" is-completed="vmPnl.resolvedContract.isCompleted" is-contract-started="vmPnl.resolvedContract.isContractStarted"></loaner-insurance><loaner-credit-card ng-model="vmPnl.creditCard" reservation-id="vmPnl.resolvedContract.id"></loaner-credit-card><loaner-additional-drivers ng-model="vmPnl.additionalDrivers" is-cancelled="vmPnl.resolvedContract.isCancelled" is-completed="vmPnl.resolvedContract.isCompleted" is-contract-started="vmPnl.resolvedContract.isContractStarted"></loaner-additional-drivers></div></div></div></div></div></uib-tab><uib-tab heading="VEHICLE" index="2" active="vmPnl.activeTab[2]" ng-click="vmPnl.clickTab(2)" ng-hide="vmPnl.hideVehicleTab"><div class="display-flex full-width-height" fill-height=""><div class="display-flex flex-column full-width-height overflow-y-auto padding-bottom-lg"><div class="padding-bottom-lg margin-right-md"><div class="col-xs-12 padding-none"><div class="loaner-modal-holder padding-none margin-top" ng-if="vmPnl.loadingTab === false"><loaner-vehicle ng-model="vmPnl.vehicle" dealer-country="vmPnl.dealer.location.country" location-id="vmPnl.locationId" reservation-id="vmPnl.reservationId"></loaner-vehicle></div></div></div></div></div></uib-tab></uib-tabset></form></div><div class="flex-fullwidth-70h bg-white shadow-border-top z-index-2"><div class="row padding-md margin-top-md"><div class="col-xs-12"><event-alert></event-alert><div ng-if="vmPnl.resolvedContract.isCancelled" class="tab-section trip-health-warning danger border-top-none inline text-uppercase"><i class="material-icons">event_busy</i> <b><span>{{vmPnl.resolvedContract.cancelledBy}}</span></b></div><span class="pull-right margin-right-md"><button type="button" class="btn btn-100 btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-contracts-list">Close</button> <button type="button" ng-show="vmPnl.selectedIndex === 1" class="btn btn-100 btn-primary text-uppercase" ng-class="config.styleClass" ng-click="vmPnl.save()" ng-disabled="(vmPnl.selectedIndex === 1 && inputForm.$invalid) || vmPnl.insuranceSectionInvalid() || vmPnl.driversLicenseSectionInvalid() || vm.additionalDrivers.hasExpiredDrivers" ladda="vmPnl.saving">Save</button></span></div></div></div></div></div><div id="loaner-messaging" class="col-md-4 col-xs-12 margin-left-md border-radius-top-7 separate-right-aside-panel message-component-rail flex-grow padding-none overflow-y-hidden"><div class="display-flex flex-column overflow-hidden full-height theme-bg"><div class="bg-white full-width-height"><div class="flex-fullwidth-70h visible-xs visible-sm padding theme-bg"><aside-header ng-if="vmPnl.headerData" ng-model="vmPnl.headerData"></aside-header></div><rc-summary-message-tab contact="vmPnl.contact" disable-notes-tab="1"></rc-summary-message-tab></div></div></div></div>');
$templateCache.put('app/areas/location/views/loaner/ars-integration.view.html','<div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the ARS Dealership ID" popover-trigger="outsideClick">ARS Dealership Id</span></label><div class="col-sm-4"><input type="text" class="form-control" name="dealershipId" ng-model="vm.ngModel.dealerNumber" validation="required"></div></div>');
$templateCache.put('app/areas/location/views/loaner/contract-terms.view.html','<h3>Loaner Management Settings</h3><p>If this is a Loaner Management enabled dealer, choose the dealer\'s Loaner Management setting and enter their configuration settings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the dealer\'s payment provider?" popover-trigger="outsideClick">Integration Provider</span></label><div class="col-sm-6"><select class="form-control" name="integrationProvider" ng-change="vm.providerChanged()" ng-model="vm.ngModel.providerType" ng-options="p.value as p.text for p in vm.providers" validation="in_list:0,1,2,3"></select></div></div><dealerware-integration ng-model="vm.ngModel" ng-if="vm.ngModel.providerType === 2"></dealerware-integration>');
$templateCache.put('app/areas/location/views/loaner/dealerware-integration.view.html','<div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the DealerWare Location ID" popover-trigger="outsideClick">DealerWare Location Id</span></label><div class="col-sm-4"><select class="form-control" name="locationId" ng-model="vm.ngModel.locationId" ng-options="location.id as location.displayText for location in vm.locations" ng-change="vm.getAdvisors()" validation="required"></select></div><div class="col-sm-3"><button type="button" ng-click="vm.getLocations()" class="btn btn-default text-uppercase btn-150">Load Locations</button></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the DealerWare Service Advisor ID to be used as the default Service Advisor" popover-trigger="outsideClick">Default Service Advisor Id</span></label><div class="col-sm-4"><select class="form-control" name="defaultServiceAdvisorId" ng-model="vm.ngModel.defaultServiceAdvisorId" ng-options="advisor.id as advisor.name for advisor in vm.advisors" validation="required"></select></div><div class="col-sm-3"><button type="button" ng-click="vm.getAdvisors()" class="btn btn-default text-uppercase btn-150">Load Advisors</button></div></div>');
$templateCache.put('app/areas/location/views/loaner/loaner-integration.view.html','<h3>Loaner Management Settings</h3><p>If this is a Loaner Management enabled dealer, choose the dealer\'s Loaner Management setting and enter their configuration settings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the dealer\'s payment provider?" popover-trigger="outsideClick">Integration Provider</span></label> <input type="hidden" id="loaner-fake-input" name="fake-input" validation="required" ng-model="vm.fakeInput"><div class="col-sm-4"><select class="form-control" name="integrationProvider" ng-change="vm.providerChanged()" ng-model="vm.ngModel.providerType" ng-options="p.value as p.text for p in vm.providers"></select></div></div><div ng-switch="vm.ngModel.providerType"><div ng-switch-when="2"><dealerware-integration ng-model="vm.ngModel" dealer-id="vm.dealerId"></dealerware-integration></div><div ng-switch-when="3"><tsd-integration ng-model="vm.ngModel" dealer-id="vm.dealerId"></tsd-integration></div><div ng-switch-when="4"><ars-integration ng-model="vm.ngModel" dealer-id="vm.dealerId"></ars-integration></div><div ng-switch-when="5"><tsdnew-integration ng-model="vm.ngModel" dealer-id="vm.dealerId"></tsdnew-integration></div></div>');
$templateCache.put('app/areas/location/views/loaner/tsd-integration.view.html','<div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the TSD Center ID" popover-trigger="outsideClick">TSD Center Id</span></label><div class="col-sm-4"><input type="text" class="form-control" name="centerId" ng-model="vm.ngModel.centerId" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the TSD Location ID" popover-trigger="outsideClick">TSD Location Id</span></label><div class="col-sm-4"><select class="form-control" name="locationId" ng-model="vm.ngModel.locationId" ng-options="location.id as location.displayText for location in vm.locations" ng-change="vm.getAdvisors()" validation="required"></select></div><div class="col-sm-3"><button type="button" ng-click="vm.getLocations()" class="btn btn-default text-uppercase btn-150">Load Locations</button></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the TSD Service Advisor ID to be used as the default Service Advisor" popover-trigger="outsideClick">Default Service Advisor Id</span></label><div class="col-sm-4"><select class="form-control" name="defaultServiceAdvisorId" ng-model="vm.ngModel.defaultServiceAdvisorId" ng-options="advisor.id as advisor.name for advisor in vm.advisors" validation="required"></select></div><div class="col-sm-3"><button type="button" ng-click="vm.getAdvisors()" class="btn btn-default text-uppercase btn-150">Load Advisors</button></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the TSD Business Source to be used as the default Business Source" popover-trigger="outsideClick">Business Source</span></label><div class="col-sm-4"><select class="form-control" name="defaultBusinessSourceId" ng-model="vm.ngModel.defaultBusinessSourceId" ng-options="businessSource.id as businessSource.name for businessSource in vm.businessSources" validation="required"></select></div><div class="col-sm-3"><button type="button" ng-click="vm.getBusinessSources()" class="btn btn-default text-uppercase btn-150">Load Sources</button></div></div>');
$templateCache.put('app/areas/location/views/loaner/tsdnew-integration.view.html','<div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the TSD Dealer Number" popover-trigger="outsideClick">TSD Dealer Number</span></label><div class="col-sm-4"><input type="text" class="form-control" name="tsdDealerNumber" ng-model="vm.ngModel.tsdDealerNumber" validation="required"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Enter the TSD Oem Name" popover-trigger="outsideClick">TSD Oem Name</span></label><div class="col-sm-4"><input type="text" class="form-control" name="TsdOemName" ng-model="vm.ngModel.tsdOemName" validation="required"></div></div>');
$templateCache.put('app/areas/location/views/modals/copy-trip-types-modal.view.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">\xD7</button><h4 class="modal-title inline text-uppercase">Copy Trip Type Instance</h4></div><div class="modal-body full-height" aside-parent="vm.childScopeForm"><form role="form" name="copyTripTypesForm" class="form" novalidate=""><div class="display-flex"><div class="form-group full-width"><select class="form-control" ng-model="vm.selectedDealer" ng-options="dealer as dealer.name for dealer in vm.dealers track by dealer.id" ng-change="vm.onDealerSelected(vm.selectedDealer)" required=""><option value="">Select Dealer to Copy From</option></select></div></div><div ng-if="vm.isLoadingTripTypes" class="display-flex"><div class="display-flex align-items-center full-width"><img src="assets/images/ajax-loader.gif"> <span class="font-normal margin-left-sm">Loading trip types...</span></div></div><div ng-if="vm.selectedDealer && !vm.isLoadingTripTypes"><div class="display-flex"><div class="form-group full-width"><label class="control-label">Select Trip Type Instance(s) to Copy</label><p ng-if="vm.availableTripTypes.length > 0" class="font-normal">Below is a list of all the trip type instances available from the selected dealer which are not currently present on the dealer you are copying to.</p><div ng-if="vm.availableTripTypes.length === 0" class="font-normal">No trip types available to copy. The selected dealer either has no trip types or all of their trip types already exist in "{{vm.currentLocation.name}}".</div><div ng-if="vm.availableTripTypes.length > 0" class="margin-top padding-bottom-lg"><div ng-repeat="tripType in vm.availableTripTypes" class="margin-bottom-sm"><label class="dash-checkbox-label font-normal"><input type="checkbox" ng-model="tripType.selected" ng-change="vm.updateSelectedTripTypes()"> <span class="padding-left-sm">{{tripType.name}}</span></label></div></div></div></div></div></form></div><div class="footer fixed-full text-right"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><button type="button" class="btn btn-default margin-right-xs" ng-click="vm.cancel()">Cancel</button> <button type="button" class="btn btn-primary margin-right-md" ng-click="vm.next()" ng-disabled="!vm.isNextEnabled() || vm.copying" ladda="vm.copying">Next</button></div>');
$templateCache.put('app/areas/location/views/modals/import-matrix-laborrates-modal.view.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.close()" data-dismiss="modal" aria-hidden="true" ng-hide="vm.hideClose">&times;</button><h4 class="modal-title">Import Matrix</h4></div><div class="modal-body"><div class="display-flex flex-wrap form-group text-left"><div class="flex-xs-percent-100 field-wrapper margin-right-sm override-xs-margin-none width-percent-12"><label for="matrix_rate_type" class="on">RATE</label><select selectlabel="" class="form-control" name="matrixRateType" ng-options="matrix.value as matrix.label for matrix in vm.matrixRateTypes" ng-model="vm.matrixRateType" ng-change="vm.onMatrixRateTypeChange(vm.matrixRateType)" dynamic-placeholder-option="Rate" ng-required="true"></select></div><div class="flex-percent-60 flex-xs-percent-100 padding-left-none position-relative override-xs-margin-top-sm"><input type="text" class="form-control better-placeholder" ng-model="vm.matrixName" placeholder="Enter a name for this matrix rate" required=""></div></div><div class="form-group"><label class="control-label margin-bottom-none">Paste CSV data with header row (HRS,0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9) followed by rows containing hour values and corresponding labor rates:</label><p class="font-normal text-muted">(Export your .xls spreadsheet to CSV and then open it in notepad to get the data in this format.)</p><textarea class="form-control resize-none fake-required" ng-model="vm.csvMatrixData" rows="20" required=""></textarea></div><div ng-if="vm.error">Error importing matrix: {{vm.error}}</div></div><div class="modal-footer"><button type="button" ng-click="vm.close()" class="btn btn-default" data-dismiss="modal">CLOSE</button> <button type="button" ng-click="vm.importMatrix()" class="btn btn-primary" ladda="vm.loading" ng-disabled="vm.loading || !vm.csvMatrixData || !vm.matrixName">SUBMIT</button></div>');
$templateCache.put('app/areas/location/views/products/automation.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.save()" novalidate="" id="task"><div ng-repeat="setting in vm.settings" ng-if="!setting.isDeleted" class="panel-default"><uib-accordion class="notification"><div uib-accordion-group=""><uib-accordion-heading><div class=""><div class="row margin-left-none margin-top-md"><div class="col-xs-8" style="padding-left: 0px"><div class="">{{setting.title}}</div></div><div class="col-xs-4"><div class="text-right"><switch id="{{ setting.enabledKey }}" name="{{ setting.enabledKey }}" ng-model="setting.enabled" class="green"></switch><a href="#" class="adjust-top margin-right-md theme-link text-uppercase padding-left-sm" ng-if="setting.canDelete" ng-click="vm.settings.splice($index, 1)">Delete</a></div></div></div></div></uib-accordion-heading><div class="panel-body"><div class="form-horizontal"><div class="form-group"><div class="col-sm-10">{{setting.description}}</div><div class="col-sm-2 text-right"><input class="form-control" type="{{setting.inputType}}" ng-model="setting.inputValue" placeholder="{{setting.subText}}" ng-if="setting.inputType != null" required="required"></div></div><div class="form-group"><div class="col-sm-1 text-left"><label class="control-label pull-left">Body</label></div><div class="col-sm-12 padding-top-sm"><textarea class="form-control resize-none" placeholder="Status notification" ng-model="setting.value" rows="4" ng-readonly="!setting.enabled" required="required"></textarea></div></div></div></div></div></uib-accordion></div><div class="row"><div class="col-xs-12 text-right"><a class="theme-link text-uppercase" href="#" ng-click="vm.addBlankROStatusNotification()">Add new RO Status Notification</a></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.saving" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.location"></location-sub-menu>');
$templateCache.put('app/areas/location/views/products/settings.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><form role="form" name="inputForm" class="form-horizontal padding-top-md" ng-submit="vm.save()" novalidate="" id="task"><div ng-repeat="setting in vm.settings"><div class="form-group"><label class="col-sm-2 control-label"><span>{{setting.description}}</span></label><div class="col-sm-2" ng-if="setting.inputType !== \'text\'"><input type="{{setting.inputType}}" name="{{setting.key}}" class="form-control no-spinners" ng-model="setting.value" required="" validation="required"> {{setting.subText}}</div><div class="col-sm-6" g-if="setting.inputType !== \'text\'"></div><div class="col-sm-8" ng-if="setting.inputType === \'text\'"><textarea class="form-control resize-none" name="{{setting.key}}" ng-model="setting.value" ng-disabled="setting.enabled === false" ng-if="setting.inputType === \'text\'" validation="required"></textarea> {{setting.subText}}</div><div class="col-sm-1 margin-top-md" ng-if="setting.enabled !== null"><switch id="{{ setting.enabledKey }}" name="{{ setting.enabledKey }}" ng-model="setting.enabled" class="green"></switch></div></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.saving" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.location"></location-sub-menu>');
$templateCache.put('app/areas/location/views/submenu/location-submenu.view.html','<div id="location-sub-menu" ng-mouseleave="vm.subMenMouseLeave(false)"><ul role="menu" uib-dropdown-menu=""><li><a href="#" ng-click="vm.tripTypeSwitch(\'General Settings\', 0);">General Settings</a></li><li ng-if="vm.appointmentTripType && (vm.isAppointmentAdmin || vm.isAdminLevelUser)" ng-class="{\'disabled\':!vm.productEnabled.Appointments}"><a href="#" ng-click="vm.tripTypeSwitch(\'Appointments\', vm.appointmentTripType.id, vm.productType.appointments);">Appointments</a></li><li ng-if="vm.showCheckIn()" ng-class="{\'disabled\':!vm.productEnabled.CheckIn}"><a href="#" ng-click="vm.tripTypeSwitch(\'Check In\', 0, vm.productType.checkIn);">Check In</a></li><li ng-if="vm.showInspect()" ng-class="{\'disabled\':!vm.productEnabled.Inspect}"><a href="#" ng-click="vm.tripTypeSwitch(\'Inspect\', 0, vm.productType.inspect);">Inspect</a></li><li ng-if="!vm.isOnlyDealerAdmin" ng-class="{\'disabled\':!vm.productEnabled.LoanerManagement}"><a href="#" ng-click="vm.tripTypeSwitch(\'Loaner Management\', 0, vm.productType.loaner);">Loaner Management</a></li><li ng-class="{\'disabled\':!vm.productEnabled.Messaging}"><a href="#" ng-click="vm.tripTypeSwitch(\'Messaging\', 0, vm.productType.messaging);">Messaging</a></li><li ng-if="!vm.isOnlyDealerAdmin" class="divider"></li><li ng-if="!vm.isOnlyDealerAdmin" class="dropdown-submenu" ng-class="{\'disabled\':!vm.productEnabled.Transportation}"><a href="#" class="dropdown-toggle" data-toggle="dropdown">Transportation</a><ul class="dropdown-menu"><li ng-repeat="type in vm.tripTypes" ng-if="type.systemTripTypeId !== vm.systemTripTypes.appointment"><a href="#" ng-click="vm.tripTypeSwitch(type.name, type.id);"><span>{{ type.name }}</span></a></li></ul></li></ul></div>');
$templateCache.put('app/areas/messages/views/partials/contact-tab-messages.view.html','<div class="col-sm-3 margin-top hidden-xs"><div class="followers sidebar-widget margin-bottom-20" ng-if="vm.contact.id !== 0"><h4 class="text-uppercase">Followers</h4><ul class="list-unstyled"><li ng-repeat="follower in vm.contact.followers | filter: { type: vm.messageType }" class="margin-bottom-md" ng-mouseenter="vm.followerHovering[follower.id] = true" ng-mouseleave="vm.followerHovering[follower.id] = false"><div style="display: flex;"><div class="follower-name">{{ follower.firstName.charAt(0) }}. {{ follower.lastName }}</div><button type="button" class="btn btn-link text-uppercase theme-link" ng-show="vm.contact.followers.length > 1 && vm.followerHovering[follower.id]" ng-click="vm.removeFollower(follower)">Remove</button></div></li></ul><ui-select id="followers-ui-select" ng-model="vm.selectedDealerUser" on-select="vm.selectDealerUser()"><ui-select-match placeholder="ADD SOMEONE">{{ $select.selected.firstName }} {{ $select.selected.lastName }}</ui-select-match><ui-select-choices repeat="dealerUser in vm.dealerUserSearchResults" refresh="vm.searchDealerUsers($select)" refresh-delay="250"><span class="text-uppercase">{{ dealerUser.firstName }} {{ dealerUser.lastName }}</span></ui-select-choices></ui-select></div><div class="actions sidebar-widget margin-bottom-20"><h4 class="text-uppercase">Actions</h4><ul class="list-unstyled"><li><button type="button" class="btn btn-link text-uppercase padding-none theme-link font-size-12 font-normal" ng-click="vm.sendMobileLink(vm.contact)">Send Me Mobile Link</button></li><li ng-if="vm.messageType === vm.messageTypes.customer && vm.contact.acknowledgement === vm.acknowledgementTypes.none"><button type="button" class="btn btn-link text-uppercase padding-none theme-link font-size-12 font-normal" ng-click="vm.acknowledge(vm.contact)">Mark As Answered</button></li><li ng-if="vm.messageType === vm.messageTypes.customer && vm.contact.acknowledgement !== vm.acknowledgementTypes.none"><button type="button" class="btn btn-link text-uppercase padding-none theme-link font-size-12 font-normal" ng-click="vm.unacknowledge(vm.contact)">Mark As Unanswered</button></li></ul></div></div><div class="col-sm-9 col-xs-12 border-left padding-left-none" style="display: flex; flex-direction: column; height: 100%"><div class="flex-fill"><div class="message-list-container-{{vm.messageType}} clearfix margin-top" infinite-scroll-top="vm.getMessages(vm.contact.id)" infinite-scroll-top-disabled="vm.isLoading || !vm.canShowMore || vm.contact.id === 0" ng-if="vm.contact.id !== 0" style="flex-grow: 1; overflow: hidden; overflow-y: scroll; height: 100%;"><div ng-if="vm.canShowMore && vm.isLoading" class="text-center" style="margin: 10px"><img src="assets/images/ajax-loader.gif"></div><div ng-if="vm.isLoading && vm.isInitialLoad" class="loading-overlay"><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading...</div></div></div><rc-message-list ng-if="!vm.isInitialLoad" messages="vm.messages" last-read-date="vm.contact.lastReadDate" panel-mode="vm.panelMode"></rc-message-list></div><div class="messaging-panel-footer color-default padding-md" ng-if="vm.hasMessaging"><div class="row"><ui-select ng-model="vm.selectedMessageTemplate" on-select="vm.selectMessageTemplate()" search-enabled="false" skip-focusser="true" ng-disabled="vm.isSendDisabled()" class="col-xs-12 col-sm-7 col-md-5 margin-left-none"><ui-select-match placeholder="CHOOSE TEMPLATE">{{ $select.selected.name }}</ui-select-match><ui-select-choices repeat="messageTemplate in vm.messageTemplates | filter: $select.search"><span ng-bind-html="messageTemplate.name | highlight: $select.search"></span></ui-select-choices></ui-select><img src="assets/images/ajax-loader.gif" class="template-spinner visible-xs ng-hide" ng-show="vm.isTemplatePopulating"> <img src="assets/images/ajax-loader.gif" class="template-spinner hidden-xs ng-hide" ng-show="vm.isTemplatePopulating"></div><form id="createMessageForm" name="createMessageForm" ng-submit="vm.sendMessage()" role="form" class="margin-top margin-bottom" novalidate=""><div><ul ng-if="vm.messageAttachments.length > 0" class="list-unstyled attachments"><li ng-repeat="attachment in vm.messageAttachments" class="attachment"><div class="icon-wrapper"><i class="material-icons md-24">description</i></div>{{ attachment.fileName }} <button type="button" class="close" ng-click="vm.removeAttachment(attachment)">&times;</button></li></ul><textarea required="" name="messageBody" class="form-control resize-none" rows="3" message-editor="" on-enter="vm.sendMessage()" ng-model="vm.newMessage" ng-disabled="vm.isSendDisabled()"></textarea><div class="height-px-15"><div class="text-right font-size-10" ng-show="vm.newMessage.trim().length > 0"><span><b>Shift+Enter</b> starts a new line</span></div></div></div><div class="row"><div class="col-xs-2 margin-top"><button type="button" class="btn btn-link attach-file" ng-click="vm.attachFile(vm.panelMode)" ng-disabled="vm.isSendDisabled()"><i class="material-icons">attach_file</i></button> <input id="attach-file{{vm.panelMode}}" type="file" class="hide" ng-model="vm.messageAttachments" message-attachment-selector=""></div><div class="col-xs-10 text-right margin-top"><span ng-if="vm.isMessageSending" class="text-send text-uppercase">SENDING...</span> <button type="button" class="btn btn-white text-uppercase" ng-class="config.styleClass" ng-click="vm.closeAside()">Close</button> <button type="submit" class="btn btn-primary text-uppercase" ng-class="config.styleClass" ng-disabled="vm.isSendDisabled()">Send</button></div></div></form></div></div></div><div id="mobile-action-followers" class="col-xs-12" ng-class="{\'show\': vm.parent.showMobileActionFollowers, \'hide\': !vm.parent.showMobileActionFollowers}"><div class="followers sidebar-widget margin-bottom-20" ng-if="vm.contact.id !== 0"><h4 class="text-uppercase">Followers</h4><ul class="list-unstyled"><li ng-repeat="follower in vm.contact.followers | filter: { type: vm.messageType }" class="margin-bottom-md" ng-mouseenter="vm.followerHovering[follower.id] = true" ng-mouseleave="vm.followerHovering[follower.id] = false"><div style="display: flex;"><div class="follower-name">{{ follower.firstName.charAt(0) }}. {{ follower.lastName }}</div><button type="button" class="btn btn-link text-uppercase theme-link" ng-show="vm.contact.followers.length > 1 && vm.followerHovering[follower.id]" ng-click="vm.removeFollower(follower)">Remove</button></div></li></ul><ui-select ng-model="vm.selectedDealerUser" on-select="vm.selectDealerUser()"><ui-select-match placeholder="ADD SOMEONE">{{ $select.selected.firstName }} {{ $select.selected.lastName }}</ui-select-match><ui-select-choices repeat="dealerUser in vm.dealerUserSearchResults" refresh="vm.searchDealerUsers($select)" refresh-delay="250"><span class="text-uppercase">{{ dealerUser.firstName }} {{ dealerUser.lastName }}</span></ui-select-choices></ui-select></div><div ng-if="vm.messageType === vm.messageTypes.customer" class="actions sidebar-widget margin-bottom-20"><h4 class="text-uppercase">Actions</h4><ul class="list-unstyled"><li ng-if="vm.contact.acknowledgement === vm.acknowledgementTypes.none"><button type="button" class="btn btn-link text-uppercase padding-none" ng-click="vm.acknowledge(vm.contact)">Mark As Answered</button></li><li ng-if="vm.contact.acknowledgement !== vm.acknowledgementTypes.none"><button type="button" class="btn btn-link text-uppercase padding-none" ng-click="vm.unacknowledge(vm.contact)">Mark As Unanswered</button></li></ul></div></div>');
$templateCache.put('app/areas/payments/views/modals/cardconnect-pay-now-modal.view.html','<div class=""><div class="modal-header text-uppercase" ng-show="!vm.processedComplete"><div><div><h5 class="margin-bottom-none">COLLECT PAYMENT</h5></div><div>Total: {{vm.invoice.total | currency}}</div></div></div><div class="modal-body padding-bottom-sm"><div class="row text-center margin-bottom-20" ng-show="vm.processedComplete && !vm.saving"><div ng-if="vm.paymentResult.result === 0"><div style="line-height:48px"><i class="material-icons md-24 text-success margin-bottom-sm align-middle">check_circle</i><h3 class="inline">PAYMENT APPROVED</h3></div></div><div ng-if="vm.paymentResult.result !== 0"><div style="line-height:48px"><i class="material-icons theme-text md-24 margin-bottom-sm align-middle">cancel</i><h3 class="inline">PAYMENT FAILED</h3></div><div><h4>{{vm.paymentResult.message}}</h4></div></div></div><div class="row" ng-if="!vm.processedComplete || vm.paymentResult.result !== 0"><div class="form-group row"><label class="col-xs-10 col-xs-push-1 col-sm-push-0 col-sm-3 control-label margin-top-md"><span class="cursor-pointer hover-underline" uib-popover="Please select the terminal to use." popover-trigger="outsideClick">Terminal</span></label><div class="col-xs-10 col-xs-push-1 col-sm-push-0 col-sm-9"><select class="form-control" name="terminal" ng-model="vm.terminal" ng-options="s.name for s in vm.terminals"></select></div></div></div></div><div class="modal-footer"><div class="col-sm-3 col-xs-12"><span class="pull-left padding-top-sm" ng-show="vm.saving">Waiting for terminal ...</span></div><div class="col-sm-12 col-xs-12 text-center"><button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.saving"><span ng-if="vm.paymentResult.result === 0 && vm.processedComplete && !vm.saving">OK</span> <span ng-if="vm.paymentResult.result !== 0 || !vm.processedComplete || vm.saving">CLOSE</span></button></div><div class="col-sm-3 col-xs-4"><button type="button" ng-click="vm.collectPayment(vm.terminal, true)" class="btn btn-primary" ng-disabled="!vm.terminal" ng-if="vm.paymentResult.result !== 0 || !vm.processedComplete || vm.saving" ladda="vm.saving">Manual <span class="hidden-xs">Entry</span></button></div><div class="col-sm-3 col-xs-4"><button type="button" ng-click="vm.collectPayment(vm.terminal, false)" class="btn btn-primary" ng-disabled="!vm.terminal" ng-if="vm.paymentResult.result !== 0 || !vm.processedComplete || vm.saving" ladda="vm.saving">Swipe <span class="hidden-xs">Card</span></button></div></div></div>');
$templateCache.put('app/areas/payments/views/modals/cenpos-pay-now-modal.view.html','<div class=""><div class="modal-header text-uppercase" ng-show="!vm.processedComplete"><div ng-if="!vm.saving"><div><h5 class="margin-bottom-none">COLLECT PAYMENT</h5></div><div>Total: {{vm.invoice.total | currency}}</div></div></div><div class="modal-body padding-bottom-sm" ng-class="{\'cenpos-payment-background\': !vm.processedComplete}"><div class="row" ng-if="!vm.processedComplete"><iframe id="frame" class="col-xs-12 border-none" style="height: 600px;" name="frame"></iframe><form ng-show="false" action="{{vm.formUrl}}" method="post" target="frame" name="submitForm" id="submitForm" role="form" novalidate=""><input name="type" id="type" ng-model="vm.cenposSettings.type" required="" validation="required"> <input name="amount" ng-model="vm.cenposSettings.amount" required="" validation="required"> <input name="merchantid" ng-model="vm.cenposSettings.merchantid" required="" validation="required"> <input name="userid" ng-model="vm.cenposSettings.userid" required="" validation="required"> <input name="password" ng-model="vm.cenposSettings.password" required="" validation="required"> <input name="redirecttype" ng-model="vm.cenposSettings.redirecttype" required="" validation="required"> <input name="urlresponse" ng-model="vm.cenposSettings.urlresponse" required="" validation="required"> <input name="postresponse" ng-model="vm.cenposSettings.postresponse" required="" validation="required"> <input name="autosubmit" ng-model="vm.cenposSettings.autosubmit" required="" validation="required"> <input name="receipts" ng-model="vm.cenposSettings.receipts" required="" validation="required"> <input name="responsetype" ng-model="vm.cenposSettings.responsetype" required="" validation="required"> <input name="invoice" ng-model="vm.cenposSettings.invoiceId" required="" validation="required"> <input name="customercode" ng-model="vm.cenposSettings.contactId" required="" validation="required"></form></div><div class="row text-center" ng-show="vm.processedComplete && !vm.saving"><div ng-if="vm.paymentResult.result === \'0\'"><div style="line-height:48px"><i class="material-icons md-24 text-success margin-bottom-sm align-middle">check_circle</i><h3 class="inline">PAYMENT APPROVED</h3></div></div><div ng-if="vm.paymentResult.result !== \'0\'"><div style="line-height:48px"><i class="material-icons theme-text md-24 margin-bottom-sm align-middle">cancel</i><h3 class="inline">PAYMENT FAILED</h3></div><div><h4>{{vm.paymentResult.message}}</h4></div></div></div><div class="row text-center" ng-show="vm.processedComplete && vm.saving">Saving...</div></div><div class="modal-footer" ng-if="vm.processedComplete"><div class="row"><div class="col-sm-3 hidden-xs"></div><div class="col-sm-12 col-xs-12 text-center"><button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.saving"><span ng-if="vm.paymentResult.result === \'0\' && vm.processedComplete && !vm.saving">OK</span> <span ng-if="vm.paymentResult.result !== \'0\' || !vm.processedComplete || vm.saving">CLOSE</span></button></div><div class="col-sm-3 col-xs-4"><button type="button" class="btn btn-primary" ng-click="vm.retry()" ng-show="vm.paymentResult.result === \'-1\'" ng-disabled="vm.saving">RETRY</button></div></div></div></div>');
$templateCache.put('app/areas/payments/views/modals/get-link-modal.view.html','<div class=""><div class="modal-header"><h5 class="margin-bottom-none">COPY LINK</h5></div><div class="modal-body"><div class="input-group"><input type="text" class="form-control" name="link" id="link" ng-model="vm.invoice.consumerUrl" readonly=""> <span class="input-group-addon btn" ng-click="vm.copy()" popover-placement="left" uib-popover="Link Copied"><i class="material-icons" style="font-size:1.3em">file_copy</i></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()">CLOSE</button></div></div>');
$templateCache.put('app/areas/payments/views/modals/peri-pay-now-modal.view.html','<div class=""><div class="modal-header text-uppercase" ng-show="!vm.processedComplete"><div><div><h5 class="margin-bottom-none">COLLECT PAYMENT</h5></div><div>Total: {{vm.invoice.total | currency}}</div></div></div><div class="modal-body padding-bottom-sm" ng-if="vm.currentState !== vm.PAYMENT_VIEW_STATES.MANUAL_ENTRY"><div class="row" ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.SELECT_TERMINAL"><div class="col-xs-12"><div class="form-group field-wrapper"><label for="terminal_select">INPUT METHOD</label><select class="form-control text-uppercase" name="terminal_select" id="terminal_select" ng-model="vm.terminal" required="" selectlabel="" ng-disabled="vm.terminals.length === 1" ng-options="(s.type !== \'manualEntry\' ? \'Tap or Swipe: \' + s.name : s.name) for s in vm.terminals"><option value="">INPUT METHOD</option></select><div ng-if="vm.terminals.length === 1" class="text-danger text-right">No devices found. Enter manually on screen.</div></div></div></div><div ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.SUCCESS"><div style="line-height:48px"><i class="material-icons md-24 text-success margin-bottom-sm align-middle">check_circle</i><h3 class="inline">PAYMENT APPROVED</h3></div></div><div ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.FAILURE"><div style="line-height:48px"><i class="material-icons md-24 theme-text margin-bottom-sm align-middle">cancel</i><h3 class="inline">PAYMENT FAILED</h3></div><div><h4>{{vm.paymentResult.message}}</h4></div></div><div ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.ERROR"><div style="line-height:48px"><i class="material-icons md-24 theme-text margin-bottom-sm align-middle">cancel</i><h3 class="inline">PAYMENT ERROR</h3></div><div><h4>Your payment was either canceled or has been declined. Please click below to try the transaction again.</h4><h4 ng-if="vm.paymentResult.message">Error from payment processor: {{vm.paymentResult.message}}</h4></div></div><div ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.VERIFYING"><div class="text-center padding-bottom-lg"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> Loading...</span></div></div></div><div ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.MANUAL_ENTRY"><peri-dashboard-payment params="vm.manualEntryParams" transaction-data="vm.transactionData"></peri-dashboard-payment></div><div class="modal-footer" ng-if="vm.terminal.terminalId !== \'manualEntry\'"><div class="col-xs-12"><button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.saving"><span ng-if="vm.paymentResult.result === 0 && vm.processedComplete && !vm.saving">OK</span> <span ng-if="vm.paymentResult.result !== 0 || !vm.processedComplete || vm.saving">CANCEL</span></button> <button type="button" ng-click="vm.collectPayment(vm.terminal, false)" class="btn btn-primary" ng-disabled="!vm.terminal" ng-if="vm.paymentResult.result !== 0 || !vm.processedComplete || vm.saving" ladda="vm.saving">Tap/Swipe <span class="hidden-xs">Card</span></button></div></div><div class="modal-footer" ng-if="vm.terminal.terminalId === \'manualEntry\' && vm.currentState !== vm.PAYMENT_VIEW_STATES.MANUAL_ENTRY"><div ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.SUCCESS" class="col-sm-12 text-center"><button type="button" class="btn btn-default" ng-click="vm.close()">Close</button></div><div ng-if="vm.currentState !== vm.PAYMENT_VIEW_STATES.SUCCESS && vm.currentState !== vm.PAYMENT_VIEW_STATES.VERIFYING"><div class="col-xs-12 text-right"><button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.saving"><span ng-if="vm.paymentResult.result !== 0 || !vm.processedComplete || vm.saving">CANCEL</span></button> <button type="button" ng-click="vm.selectManuallEntryPayment()" class="btn btn-primary"><span ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.SELECT_TERMINAL">Next</span> <span ng-if="vm.currentState !== vm.PAYMENT_VIEW_STATES.SELECT_TERMINAL">Try Again</span></button></div></div></div></div>');
$templateCache.put('app/areas/payments/views/modals/peri-refund-modal.view.html','<div class=""><div class="modal-header text-uppercase"><h5 class="margin-bottom-none">Refund Payment</h5></div><div class="modal-body"><div ng-if="!vm.paymentDetailsError && !vm.refundResolved"><div ng-if="vm.loading">Please wait while we look up the payment information...</div><div ng-if="!vm.loading && !vm.refunding">Are you sure you want to refund ${{vm.paymentDetails.amount}} to {{vm.paymentDetails.cardHolderName}}\'s <span ng-if="vm.paymentDetails.cardType">{{vm.paymentDetails.cardType}}</span><span ng-if="!vm.paymentDetails.cardType" ng-class="{ \'margin-right-md\': vm.paymentDetails.protectedCardNumber }">card</span><span ng-if="vm.paymentDetails.protectedCardNumber">&nbsp;ending in {{vm.paymentDetails.protectedCardNumber}}</span><span>?</span></div><div ng-if="!vm.loading && vm.refunding" class="display-flex content-center"><img src="assets/images/ajax-loader.gif" class="margin-right"> <strong>Processing refund, please wait...</strong></div></div><div ng-if="vm.paymentDetailsError && !vm.refundResolved"><div class="display-flex content-center"><div class="display-flex align-items-start text-left"><i class="material-icons md-24 text-danger margin-right-sm">cancel</i><div><h3 class="margin-top-none margin-bottom-none">Unable to load payment details.</h3><div class="margin-top-sm margin-bottom-none text-left">{{vm.paymentDetailsError}}</div></div></div></div></div><div ng-if="vm.refundResolved && vm.success" class="text-center"><div class="display-flex content-center align-items-center"><i class="material-icons md-24 text-success margin-right">check_circle</i><h3 class="margin-top-none margin-bottom-none">Refunded successfully.</h3></div></div><div ng-if="vm.refundResolved && vm.error" class="text-center"><div class="display-flex content-center"><div class="display-flex align-items-start text-left"><i class="material-icons md-24 text-danger margin-right-sm">cancel</i><div><h3 class="margin-top-none margin-bottom-none margin-top-xs">Refund failed.</h3><div class="margin-top-sm margin-bottom-none text-left">{{vm.error}}</div></div></div></div></div></div><div class="modal-footer"><div ng-if="!vm.loading && !vm.refunding && !vm.paymentDetailsError && !vm.refundResolved"><button type="button" class="btn btn-primary" ng-click="vm.issueRefund()">Yes</button> <button type="button" class="btn btn-default" ng-click="vm.close()">No</button></div><div ng-if="vm.paymentDetailsError || vm.refundResolved"><button type="button" class="btn btn-default" ng-click="vm.close(vm.success)">Close</button></div></div></div>');
$templateCache.put('app/areas/payments/views/modals/refund-modal.view.html','<div class=""><div class="modal-header text-uppercase"><h5 class="margin-bottom-none">Refund Payment</h5></div><div class="modal-body">Coming Soon</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()">CLOSE</button></div></div>');
$templateCache.put('app/areas/payments/views/partials/add-items.view.html','<uib-accordion-heading><h4 class="panel-title override-xs-padding-bottom-sm">ITEMS</h4></uib-accordion-heading><div id="payments-body"><form role="form" name="editItemsForm" id="editItemsForm" class="form padding-none text-uppercase" ng-submit="vmPnl.submitForm()" novalidate=""><div ng-repeat="item in vmPnl.invoice.items" class="row form-group"><div class="col-sm-3 col-xs-12 padding-none field-wrapper override-xs-padding-right-15"><label for="type{{$index}}">TYPE</label><select selectlabel="" class="form-control" name="type{{$index}}" id="type{{$index}}" required="required" ng-model="item.type" ng-options="opt.text for opt in vmPnl.lineItemOptions" validation="required"><option value="">Choose One</option></select></div><div class="col-sm-5 col-xs-4 padding-right-none override-xs-padding-none"><div ng-if="item.type === vmPnl.lineItemTypes.repairOrder"><select required="" name="repairOrder{{$index}}" id="repairOrder{{$index}}" multiple="" ui-select2="vmPnl.getOptsWithInitialSelection(item.value)" ng-model="item.repairOrderId" type="text" class="form-control select2-single" data-index="{{$index}}"></select><input type="hidden" name="createNew{{$index}}" id="createNew{{$index}}" ng-model="item.value.createNew"> <input type="hidden" name="roNumber{{$index}}" id="roNumber{{$index}}" ng-model="item.value.roNumber"></div><div ng-if="item.type === vmPnl.lineItemTypes.loanerUpcharge"><select name="loanerUpcharge{{$index}}" multiple="" ui-select2="vmPnl.getLoanerUpchargeOptsWithInitialSelection(item.value)" ng-model="item.id" type="text" class="form-control select2-single" required="required" data-index="{{$index}}"></select></div><div ng-if="item.type !== vmPnl.lineItemTypes.repairOrder && item.type !== vmPnl.lineItemTypes.loanerUpcharge"><input name="description{{$index}}" type="text" class="form-control better-placeholder" ng-model="item.description" placeholder="DESCRIPTION" required="required" validation="required"></div><div ng-if="editItemsForm[\'repairOrder\' + $index].$error.required && editItemsForm[\'repairOrder\' + $index].$dirty" class="validation text-danger">Field is required.</div></div><div class="col-sm-3 col-xs-6"><div class="input-group"><span class="input-group-addon">$</span> <input name="amount{{$index}}" id="amount{{$index}}" class="form-control" ng-model="item.amount" type="text" mask="9?9?9?9?9?9?9?.99" mask-restrict="reject" required="required"></div><div ng-if="editItemsForm[\'amount\' + $index].$error.required" class="validation text-danger">Field is required.</div></div><div class="col-sm-1 col-xs-2 padding-none"><span ng-if="vmPnl.invoice.items.length > 1"><i class="material-icons text-danger cursor-pointer margin-top-md" style="font-size:2em" ng-click="vmPnl.invoice.items.splice($index, 1)">remove</i></span> <span ng-if="$last"><i class="material-icons text-danger cursor-pointer margin-top-md" style="font-size:2em" ng-click="vmPnl.invoice.items.push({type: null, amount: \'0.00\'})">add</i></span></div><div class="col-xs-12 border-bottom visible-xs padding-top-md"></div></div><div class="row"><div class="col-sm-offset-8 col-xs-offset-7 col-sm-3 col-xs-5 override-xs-padding-top-md"><h4>Total: {{vmPnl.getTotal() | currency}}</h4></div></div><div class="aside-footer"><div class="row padding-md"><div class="col-xs-12"><button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="payments-list">Close</button> <button type="submit" class="btn btn-primary text-uppercase" ng-disabled="editItemsForm.$invalid" ladda="vmPnl.submitting">Create Invoice</button></div></div></div></form></div>');
$templateCache.put('app/areas/payments/views/partials/choose-customer.view.html','<uib-accordion-heading><div class="panel-titleoverride-xs-padding-bottom-sm override-xs-padding-top-sm"><div class="display-flex content-center"><div class="flex-percent-30 hidden-xs"><span>BILL TO</span></div><div class="flex-percent-70 hidden-xs"><div class="selected-accordion-location text-right"><span class="ng-hide small font-size-16 font-bold text-uppercase padding-right-sm" ng-show="vm.invoice.customer"><span class="black">{{vm.invoice.customer.firstName}} {{vm.invoice.customer.lastName}} {{vm.invoice.customer.mobilePhone | tel}}</span></span><div class="link pull-right content-center" ng-show="vm.invoice.customer && !vm.isLoading()" ng-click="vm.clearBillTo(vmPnl)"><i class="material-icons md-16">edit</i></div></div></div><div class="flex-percent-100 visible-xs"><span ng-if="vm.accordion.selectedStep === vm.accordion.steps.chooseCustomer">BILL TO</span><div ng-if="vm.accordion.selectedStep !== vm.accordion.steps.chooseCustomer" class="selected-accordion-location"><span class="ng-hide small font-size-16 font-bold text-uppercase" ng-show="vm.invoice.customer"><span class="black">{{vm.invoice.customer.firstName}} {{vm.invoice.customer.lastName}} {{vm.invoice.customer.mobilePhone | tel}}</span></span><div class="link pull-right content-center" ng-show="vm.invoice.customer && !vm.isLoading()" ng-click="vm.clearBillTo(vmPnl)"><i class="material-icons md-16">edit</i></div></div></div></div></div></uib-accordion-heading><div id="paymentChooseCustomerForm" class="padding-bottom-lg"><div class="row"><div class="col-xs-8 col-lg-6 padding-none override-xs-padding-right-15"><div class="form-group"><span class="control-label font-bold" ng-if="!vm.isCreatingNew">SEARCH FOR RO</span></div></div></div><div class="row"><div class="col-sm-8 col-xs-12 padding-none override-xs-padding-right-15"><div class="form-group"><select name="roselect" id="roselect" multiple="" ui-select2="vm.repairOrderSearchOptions" ng-model="vmPnl.repairOrderId" class="select2-single"></select></div></div></div><div class="row"><div class="col-sm-8 col-xs-12 col-lg-6 padding-none override-xs-padding-right-15"><div class="form-group"><span class="control-label font-bold"><span ng-if="!vm.isCreatingNew">OR</span> SEARCH FOR CUSTOMER</span></div></div></div><div class="row"><div class="col-sm-8 col-xs-12 col-lg-6 padding-none override-xs-padding-right-15"><div class="form-group"><select class="select2-single" multiple="multiple" ui-select2="vmPnl.phoneSearchOptions" name="phoneSelect" id="phoneselect" placeholder="MOBILE PHONE" ng-model="vmPnl.contactId"></select></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none override-xs-padding-right-15"><div class="form-group"><span class="control-label font-bold">OR ENTER INFORMATION</span></div></div></div><form role="form" name="paymentForm" ng-submit="vmPnl.submitForm()" novalidate="" class="form"><div class="row override-xs-padding-bottom-100"><div class="form-group"><div class="col-xs-12 col-sm-4 padding-left-none override-xs-side-padding-none override-xs-padding-right-15"><div class="block relative"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.firstName" name="firstName" id="firstName" placeholder="FIRST NAME" required="" validation="required"></div></div><div class="col-xs-12 padding-left-none col-sm-4 override-xs-side-padding-none override-xs-padding-top-md override-xs-padding-right-15"><div class="block relative"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.lastName" name="lastName" id="lastName" placeholder="LAST NAME" required="" validation="required"></div></div><div class="col-xs-12 padding-left-none col-sm-4 override-xs-side-padding-none override-xs-padding-top-md override-xs-padding-right-15"><div class="block relative"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.mobilePhone" name="mobilePhone" id="mobilePhone" inputmode="numeric" pattern="(?:\\(\\d{3}\\)|\\d{3})[- ]?\\d{3}[- ]?\\d{4}" placeholder="MOBILE PHONE" required="" validation="required" mask="(999) 999-9999"></div></div></div></div><div class="aside-footer"><div class="row padding-md"><div class="col-xs-12"><button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="payments-list">Close</button> <button type="submit" class="btn btn-primary text-uppercase" ng-disabled="paymentForm.$invalid">Next</button></div></div></div></form></div>');
$templateCache.put('app/areas/payments/views/partials/choose-location.view.html','<uib-accordion-heading><div class="display-flex override-xs-padding-bottom-sm override-xs-padding-top-sm flex-row full-width-height"><div class="flex-grow"><h4 class="panel-title location-title display-flex flex-row content-center"><div class="flex-grow flex-percent-50 align-bottom"><span class="hidden-xs hidden-sm">LOCATION</span> <span class="visible-xs visible-sm padding-bottom-sm" ng-show="vm.accordion.selectedStep === vm.accordion.steps.chooseLocation">LOCATION</span> <span class="text-uppercase max-width-percent-95 ellipsis-overflow visible-sm visible-xs" ng-show="vm.invoice.location">{{vm.invoice.location.name}}</span></div><div class="flex-grow flex-percent-50 flex-sm-percent-25 content-center align-text- bottom"><div class="selected-accordion-location"><span class="inline-block ellipsis-overflow padding-right-sm align-text-bottom text-uppercase hidden-sm hidden-xs" ng-show="vm.invoice.location">{{vm.invoice.location.name}}</span><div class="ng-hide link pull-right content-center" ng-show="vm.invoice.location && !vm.isLoading()" ng-click="vm.clearSelectedLocation()"><i class="material-icons md-16">edit</i></div></div></div></h4></div></div></uib-accordion-heading><div id="chooseLocationForm" class="row"><div class="col-xs-12 col-sm-8 col-lg-6 padding-none override-xs-padding-right-15" ng-if="vm.locations.length > vm.locationSearchThreshold"><div class="form-group text-uppercase"><select data-placeholder-text-single="\'Find a location\'" class="form-control" name="locationFilter" max-shown-results="100" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vm.invoice.location" ng-options="l as l.name for l in vm.locations" ng-change="vm.locationSelected()"><option value="">Find a location</option></select></div></div><div ng-if="vm.thresholdLocations"><div class="row margin-top-md"><div class="col-xs-11 padding-none"><table id="zip-filtered-locations"><tr ng-repeat="location in vm.thresholdLocations" ng-class="{\'border-bottom\': $index < vm.thresholdLocations.length - 1 }"><td class="padding-md loc-icon" ng-click="vm.selectLocation(location)"></td><td class="padding-md loc-details" ng-click="vm.selectLocation(location)"><div class="theme-link"><strong>{{location.name}}</strong></div><div>{{location.address}}, {{location.city}}, {{location.zip}}</div></td></tr></table></div></div></div></div><div class="aside-footer"><div class="row padding-md"><div class="col-xs-12"><button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="payments-list">Close</button></div></div></div>');
$templateCache.put('app/areas/payments/views/partials/peri-dashboard-verify.view.html','<div class="font-size-18 centered-content"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> Please wait while we verify your payment.</span></div>');
$templateCache.put('app/areas/payments/views/partials/peri-payment.view.html','<div><div class="text-center padding-bottom-lg" ng-if="vm.currentState === vm.PAYMENT_VIEW_STATES.INITIAL_LOADING"><div><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> Loading...</span></div></div><iframe ng-show="vm.currentState === vm.PAYMENT_VIEW_STATES.IN_PROGRESS" id="smsIFrame" ng-src="{{vm.url}}" class="embedded-iframe" type="text/html" iframe-onload="vm.iFrameOnload()" fill-height=""></iframe></div>');
$templateCache.put('app/areas/support/views/modals/hours-of-operation.view.html','<div class="modal-header padding-t-b-0"><h2 class="modal-title">Hours of Operation</h2></div><div class="modal-body" aside-parent="vm.childScopeForm"><form role="form" name="hoursOfOperationForm" class="form" ng-submit="vm.saveHoursOfOperation(hoursOfOperationForm.$valid)" novalidate=""><div class="display-flex flex-column full-width"><div class="form-group"><textarea id="hours_of_operation" rows="15" name="hours_of_operation" ng-model="vm.hoursOfOperation" class="form-control full-width better-placeholder resize-none" validation="required" required=""></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="vm.closeHoursOfOperation()">Close</button> <button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="isDataLoading" ng-disabled="hoursOfOperationForm.$invalid">Update</button></div></form></div>');
$templateCache.put('app/areas/trip/views/modals/duplicate-active-trip-modal.view.html','<div class="modal-header"><h5 class="margin-bottom-none text-uppercase">DUPLICATE TRIPS FOUND</h5></div><div class="modal-body"><div class="row margin-bottom-md"><div class="col-xs-12">One or more rides are currently booked or in progress for this customer. Please click the link(s) below or search for the customer in the trip list to find the trips.</div></div><div class="row margin-bottom-md" ng-repeat="tripId in vm.activeTripIds"><div class="col-xs-12"><a ui-sref="trip-tab-trip({ tripId: tripId })" ui-sref-opts="{ reload: true }" ng-click="vm.close()">{{tripId}}</a></div></div><div class="row"><div class="col-xs-12">Click OK below if you would like to book this trip anyway.</div></div></div><div class="modal-footer"><button type="button" class="btn" ng-click="vm.close(true)">OK</button> <button type="button" class="btn btn-primary" ng-click="vm.close()">CANCEL</button></div>');
$templateCache.put('app/areas/trip/views/modals/lyft-duplicate-trip-modal.view.html','<div class="modal-header"><h5 class="margin-bottom-none text-uppercase">Duplicate Ride Detected</h5></div><div class="modal-body"><div class="row margin-bottom-md">Our records indicate that a ride is already booked or in progress for this customer. Please search for additional rides under the customer\'s name<span ng-if="vm.tripId">[or click the link below]</span>. If you are unable to locate this ride or think this is incorrect, please contact our Client Success Team using the Support options above.</div><div class="row" ng-if="vm.tripId"><a ui-sref="trip-tab-trip({ tripId: vm.tripId })" ui-sref-opts="{ reload: true }" ng-click="vm.close()">Ride Provider Trip ID {{vm.lyftTripId}}</a></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.close()">OK</button></div>');
$templateCache.put('app/areas/trip/views/modals/set-billing-time.view.html','<div class="modal-header"><h3 class="modal-title">Adjust Trip Time</h3><div>TRIP #{{vm.trip.id}}</div></div><form name="setBillingTimeForm" ng-submit="vm.save()" autocomplete="off" role="form" novalidate=""><div class="modal-body text-uppercase"><div class="row form-group"><div class="col-sm-6 col-xs-6"><div class="row"><div class="col-sm-12"><label class="pull-left" for="startDate">Trip Start</label><div class="pull-right"><i>({{ vm.trip.dealerTimeZone }})</i></div></div><div class="col-sm-6 col-xs-6"><input name="startDate" type="date" id="start-date" ng-change="vm.billingTimeChanged()" class="form-control text-uppercase" ng-model="vm.charge.startDate" required="required"></div><div class="col-sm-6 col-xs-6"><input name="startTime" type="time" id="start-time" ng-change="vm.billingTimeChanged()" class="form-control text-uppercase" ng-model="vm.charge.startDate" required="required"></div></div><div class="row margin-top"><div class="col-sm-12"><label for="endDate">Trip End</label></div><div class="col-sm-6 col-xs-6"><input name="endDate" type="date" id="end-date" ng-change="vm.billingTimeChanged()" class="form-control text-uppercase" ng-model="vm.charge.endDate" required="required"></div><div class="col-sm-6 col-xs-6"><input name="endTime" type="time" id="end-time" ng-change="vm.billingTimeChanged()" step="60" class="form-control text-uppercase" ng-model="vm.charge.endDate" required="required"></div></div></div><div class="col-sm-6 col-xs-6"><div class="row margin-bottom"><div class="col-sm-4 col-xs-4"></div><div class="col-sm-4 col-xs-4">Before</div><div class="col-sm-4 col-xs-4">After</div></div><div class="row margin-bottom"><div class="col-sm-4 col-xs-4">Total Time</div><div class="col-sm-4 col-xs-4">{{ vm.charge.totalTime | duration }}</div><div class="col-sm-4 col-xs-4"><span ng-if="vm.updatedBilling.totalTime">{{ vm.updatedBilling.totalTime | duration }}</span> <span ng-if="!vm.updatedBilling.totalTime">--</span></div></div><div class="row margin-bottom"><div class="col-sm-4 col-xs-4">Dealer Charge</div><div class="col-sm-4 col-xs-4">{{ vm.charge.chargeAmount | currency}}</div><div class="col-sm-4 col-xs-4"><span ng-if="vm.updatedBilling.chargeAmount">{{ vm.updatedBilling.chargeAmount | currency }}</span> <span ng-if="!vm.updatedBilling.chargeAmount">--</span></div></div><div class="row margin-bottom"><div class="col-sm-4 col-xs-4">Driver Pay</div><div class="col-sm-4 col-xs-4">{{ vm.charge.driverPayAmount | currency }}</div><div class="col-sm-4 col-xs-4"><span ng-if="vm.updatedBilling.driverPayAmount">{{ vm.updatedBilling.driverPayAmount | currency }}</span> <span ng-if="!vm.updatedBilling.driverPayAmount">--</span></div></div></div></div><div class="row form-group"><div class="col-sm-12 col-xs-12"><label for="chargeComment">Comments</label> <input name="chargeComment" placeholder="ENTER COMMENTS" type="text" ng-model="vm.charge.comment" class="form-control" required="required" validation="required"></div></div><div class="row"><div class="col-sm-12 col-xs-12"><span class="text-danger">Times must be entered in the dealer\'s local time zone.</span></div></div></div><div class="modal-footer"><div class="pull-left footer-msg"><span ng-if="!vm.calculatingBilling && vm.validationMsg" class="text-danger text-uppercase">{{ vm.validationMsg }}</span> <span ng-if="vm.calculatingBilling"><img src="assets/images/ajax-loader.gif"></span></div><button type="button" ng-click="$dismiss()" class="btn" data-dismiss="modal">Cancel</button> <button type="submit" class="btn btn-primary" data-dismiss="modal" ng-disabled="setBillingTimeForm.$invalid || vm.validationMsg" ladda="vm.saving">Save</button></div></form>');
$templateCache.put('app/areas/trip/views/modals/set-charge.view.html','<div class="modal-header"><h3 class="modal-title">{{ vm.charge.existingChargeId ? \'Edit\' : \'Add\'}} Charge/Pay Item</h3><div>TRIP #{{vm.trip.id}}</div></div><form name="setChargeForm" ng-submit="vm.save()" role="form" novalidate=""><div class="modal-body text-uppercase"><div class="row form-group"><div class="col-sm-6 col-xs-6"><div>Charge Type</div><select class="form-control" name="chargeType" required="required" ng-model="vm.charge.type" ng-disabled="vm.charge.existingChargeId" ng-options="opt.id as opt.text for opt in vm.chargeTypeOptions" validation="required"><option value="">Choose One</option><option ng-repeat="opt in vm.chargeTypeOptions" value="{{opt.id}}" ng-selected="opt.id == vm.charge.type">{{ opt.text }}</option></select></div><div class="col-sm-3 col-xs-3"><div>Dealer Charge</div><div class="input-group"><span class="input-group-addon">$</span> <input name="chargeAmount" id="chargeAmount" class="form-control" ng-model="vm.charge.chargeAmount" type="text" mask="W?9?9?9?9?9?9?9?.99" mask-restrict="reject" required="required" validation="required" validation-error-to="charge-amount-error"></div><div id="charge-amount-error" class="validation text-danger">Field is required.</div></div><div class="col-sm-3 col-xs-3"><div>Driver Pay</div><div class="input-group"><span class="input-group-addon">$</span> <input name="driverPay" id="driverPay" class="form-control" ng-model="vm.charge.driverPayAmount" type="text" mask="W?9?9?9?9?9?9?9?.99" mask-restrict="reject" required="required" validation="required" validation-error-to="pay-amount-error"></div><div id="pay-amount-error" class="validation text-danger">Field is required.</div></div></div><div class="row form-group"><div class="col-sm-12 col-xs-12"><div>Comment</div><input name="chargeComment" placeholder="ENTER COMMENTS" type="text" ng-model="vm.charge.comment" class="form-control" required="required" validation="required"></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="btn" data-dismiss="modal">Cancel</button> <button type="button" ng-if="vm.charge.existingChargeId" ng-click="vm.deleteCharge()" class="btn" ladda="vm.deleting" ng-disabled="setChargeForm.$invalid || vm.deleting || vm.saving" data-dismiss="modal">Delete</button> <button type="submit" class="btn btn-primary" data-dismiss="modal" ladda="vm.saving" ng-disabled="setChargeForm.$invalid || vm.deleting || vm.saving">Save</button></div></form>');
$templateCache.put('app/areas/trip/views/partials/add-new-choose-location.view.html','<uib-accordion-heading><div class="display-flex flex-row full-width-height"><div class="flex-grow"><h4 class="panel-title location-title display-flex flex-row align-items-center content-center padding-none"><div class="flex-grow flex-percent-50 flex-sm-percent-75 align-bottom padding-bottom-md override-sm-padding-none"><span class="hidden-xs hidden-sm">LOCATION</span> <span class="visible-xs visible-sm ng-hide" ng-show="vmPnl.parent_vm.accordion.selectedStep === vmPnl.steps.chooseLocation">LOCATION</span> <span ng-if="vm.theTrip.dealerLocation" class="small-accordion-header text-uppercase visible-sm visible-xs">{{vm.theTrip.dealerLocation.name}}</span></div><div class="flex-grow flex-percent-50 flex-sm-percent-25 content-center align-bottom"><div class="selected-accordion-location"><div ng-if="vm.theTrip.dealerLocation" class="padding-top-sm inline-block ellipsis-overflow padding-right-sm small-accordion-header text-uppercase hidden-sm hidden-xs trips-header">{{vm.theTrip.dealerLocation.name}}</div><div class="accordion-clear-step ng-hide link pull-right override-sm-padding-top-sm" ng-show="!vm.resolvedTrip && vm.theTrip.dealerLocation && !vm.isLoading()" ng-click="vmPnl.clearSelectedLocation()"><i class="material-icons md-16">edit</i></div></div></div></h4></div></div></uib-accordion-heading><div id="chooseLocationForm"><div class="row" ng-if="vmPnl.availableLocations.length > vmPnl.locationSearchThreshold"><div class="col-xs-12 col-sm-8 col-lg-6"><div class="form-group field-wrapper relative text-notransform"><label for="locationFilter">Find a location</label><select ng-options-title="vmPnl.availableLocations" ng-options-placeholder="1" data-placeholder-text-single="\'Find a location\'" selectlabel="" class="form-control" name="locationFilter" id="locationFilter" max-shown-results="100" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vmPnl.selectedLocation" ng-options="l as l.name for l in vmPnl.availableLocations" ng-change="vmPnl.locationSelected()"><option value="">Find a location</option></select></div></div><div class="col-sm-3 col-xs-2 hidden-xs"><div class="form-group"><div class="visible-xs override-xs-padding-top-md">ZIP CODE</div><input type="text" placeholder="ZIP" id="zip_code" name="zip_code" ng-model="vmPnl.zip" inputmode="numeric" pattern="[0-9]*" class="form-control better-placeholder" ng-keydown="vmPnl.onZipCodeKeyPress($event)" ng-blur="vmPnl.onZipCodeBlur($event)" mask-restrict="reject" mask="99999"></div></div></div><div class="ng-hide" ng-show="vmPnl.loadingStep2"><b>Loading...</b></div><div ng-if="vmPnl.zipFilteredLocationList"><div class="row margin-top-md"><div class="col-xs-11 padding-none"><table id="zip-filtered-locations"><tr ng-repeat="location in vmPnl.zipFilteredLocationList" ng-class="{\'border-bottom\': $index < vmPnl.zipFilteredLocationList.length - 1 }"><td ng-if="!vmPnl.locationListLogos || vmPnl.locationListLogos.length === 0" class="padding-md loc-icon" ng-click="vmPnl.locationSelected(location)"></td><td ng-if="vmPnl.locationListLogos && vmPnl.locationListLogos.length > 0" class="padding-md loc-icon-logo" ng-click="vmPnl.locationSelected(location)"><center><img ng-src="{{vmPnl.getLocationListLogo(location.adminProgramId)}}" class="location-list-logo"></center></td><td class="padding-md loc-details" ng-click="vmPnl.locationSelected(location)"><div class="theme-link"><strong>{{location.name}}</strong></div><div>{{location.address}}, {{location.city}}, {{location.zip}}</div></td></tr></table></div></div></div><div id="no-zips-found" ng-if="vmPnl.noLocationsForZipFound" class="centered-content"><div class="row margin-top-md"><div class="col-xs-12 padding-none text-center"><b><span class="trip-label test-nowrap">WE COULDN\'T FIND ANY LOCATIONS THAT MATCHED YOUR SEARCH.</span><br>CHANGE YOUR SEARCH OR SELECT ONE FROM THE LIST.</b></div></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/add-new-choose-triptype.view.html','<uib-accordion-heading><h4 class="panel-title text-uppercase" ng-if="vmTypePnl.loading || !vm.productGroupsConfigured"><div><br><br><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><br>Loading ...<br><br><br></div></div></h4><h4 id="trip-type-title" ng-repeat="group in vm.experiencesPanelGroups" ng-if="group.productGroups && group.productGroups.length" class="panel-title location-title display-flex padding-none" ng-show="!vmTypePnl.loading && vm.theTrip.preventBooking != true && ((vmTypePnl.selectedSystemTripType && vmTypePnl.selectedSystemTripType.dealerTripTypes[0].marketingGroupId == group.marketingGroupId) || vmTypePnl.isOpen() || vmTypePnl.getSelectedPanelGroup(group))" ng-class="{\'hidden-xs\': group.marketingGroupId === 0, \'align-items-center content-center flex-row\': vmTypePnl.selectedDealerTripType, \'flex-column\': !vmTypePnl.selectedDealerTripType }"><div class="padding-bottom-md override-sm-padding-none" ng-class="{\'padding-top-20\': $index !== 0, \'flex-percent-100\': !vmTypePnl.selectedDealerTripType, \'flex-percent-50 flex-sm-percent-75\': vmTypePnl.selectedDealerTripType}"><span class="hidden-xs hidden-sm group-title">{{group.description}}&nbsp;</span> <span class="visible-xs visible-sm ng-hide group-title" ng-show="vmTypePnl.isOpen()">{{group.description}}</span> <span class="small-accordion-header text-uppercase hidden-md visible-sm visible-xs top-0 override-sm-padding-bottom-sm"><div ng-if="vmTypePnl.getSelectedPanelGroup(group)" id="selected-product-name-mob">{{ vm.theTrip.selectedProductGroup.displayName}}</div></span></div><div class="content-center align-bottom flex-percent-50 flex-sm-percent-25" ng-if="vmTypePnl.getSelectedPanelGroup(group)"><div class="selected-accordion-location selected-accordion-location display-flex content-center pull-right"><div class="padding-top-none inline-block ellipsis-overflow padding-right-sm small-accordion-header text-uppercase hidden-sm hidden-xs trips-header ng-binding ng-scope"><img class="trip-type-icon hidden-xs" ng-if="vm.theTrip.selectedProductGroup.icon" ng-src="{{ vm.theTrip.selectedProductGroup.icon}}"> <span ng-if="vm.theTrip.selectedProductGroup.badgeText" class="trip-type-badge light-gray hidden-xs hidden-sm">{{ vm.theTrip.selectedProductGroup.badgeText }}</span>{{ vm.theTrip.selectedProductGroup.displayName}}</div><div class="accordion-clear-step link pull-right override-sm-padding-top-sm" ng-show="!vm.resolvedTrip && !vm.isLoading()" ng-click="vmTypePnl.clearProductGroup()"><i class="material-icons md-16">edit</i></div></div></div><div class="flex-percent-100" ng-show="!vmTypePnl.selectedDealerTripType && vmTypePnl.isOpen() && !vmTypePnl.loading"><div class="choose-trip-type-list row"><div class="col-xs-12"><ul><li ng-if="group.productGroups" ng-repeat="productGroup in group.productGroups" ng-mouseover="open=true" ng-mouseleave="open=false"><img class="trip-type-icon" ng-if="productGroup.icon" ng-src="{{productGroup.icon}}"><div ng-if="productGroup.badgeText" class="trip-type-badge">{{ productGroup.badgeText }}</div><span ng-if="!productGroup.isFake && !productGroup.isDisabled && !productGroup.needsConfiguration" class="name" ng-click="vmTypePnl.productGroupSelected(productGroup)">{{ productGroup.displayName }}</span> <span ng-if="productGroup.isFake && !productGroup.needsConfiguration && !productGroup.isDisabled" class="name disabledTripType" ng-click="vm.displayProductGroupHelpModal(productGroup)">{{ productGroup.displayName }}</span> <span ng-if="productGroup.needsConfiguration && !productGroup.isDisabled" class="name disabledTripType" ng-click="vm.displayProductGroupConfigurationModal(productGroup)">{{ productGroup.displayName }}</span> <span ng-if="productGroup.isDisabled" class="name disabledTripType" ng-click="vm.displayProductGroupUpgradeModal(productGroup)">{{ productGroup.displayName }}</span><div class="inline help-icon theme-link padding-left-sm" ng-show="open"><i class="material-icons" ng-click="vm.displayProductGroupHelpModal(productGroup)">info_outline</i></div><div class="inline theme-link" ng-class="{\'lyftSpending\': !productGroup.lyftSpending.isOverSpendingCap, \'lyftSpending-over\': productGroup.lyftSpending.isOverSpendingCap}" ng-if="productGroup.lyftSpending && productGroup.lyftSpending.showLyftSpending" ng-show="open"><i class="material-icons" ng-if="productGroup.lyftSpending.isOverSpendingCap">warning</i> ({{ productGroup.lyftSpending.totalActualCharges + productGroup.lyftSpending.totalPendingCharges | currency }} of {{ productGroup.lyftSpending.monthlySpendingCap | currency }} used)</div></li></ul></div></div></div></h4></uib-accordion-heading>');
$templateCache.put('app/areas/trip/views/partials/add-new-settings-book-it.view.html','<div class="form-group" ng-if="vmSettingsPnl.displayServiceAdvisorOverrideFields()"><div class="row override-xs-padding-top-md margin-bottom-sm" ng-if="vm.theTrip.selectedTripOption.serviceAdvisorOverrideFieldsLabel"><div class="col-xs-12 override-xs-padding-top-md override-sm-padding-top-md">{{ vm.theTrip.selectedTripOption.serviceAdvisorOverrideFieldsLabel }}</div></div><div class="row"><div class="col-xs-12 col-sm-3 override-xs-margin-top-md"><input type="text" id="overrides_first_name" name="overrides_first_name" clean="true" autocomplete="nope" ng-model="vm.serviceOrder.overrideServiceAdvisorFirstName" class="form-control better-placeholder" placeholder="FIRST NAME" required="" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md" ng-if="!vmSettingsPnl.hideLastName"><input type="text" id="overrides_last_name" name="overrides_last_name" autocomplete="nope" ng-model="vm.serviceOrder.overrideServiceAdvisorLastName" class="form-control better-placeholder" placeholder="LAST NAME" required="" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md"><input type="text" id="overrides_phone_number" name="overrides_phone_number" required="" inputmode="numeric" ng-model-options="{ debounce: 750 }" autocomplete="nope" ng-model="vm.serviceOrder.overrideServiceAdvisorMobile" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="required|custom: vmSettingsPnl.validation.phoneNumberRequired(vm.serviceOrder.overrideServiceAdvisorMobile):alt=*" ng-change="vm.overridesPhoneChanged(vm.serviceOrder.overrideServiceAdvisorMobile)"> <span class="text-danger" ng-if="tripSettingsForm.phone_number.$error[\'passenger.phone_number\']">{{tripSettingsForm.overrides_phone_number.$error[\'passenger.phone_number\'] | sentenceCase}}</span> <span class="text-danger" ng-show="!vm.overridesPhoneDetail.isOptedOut && vm.overridesPhoneDetail.type === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="!vm.overridesPhoneDetail.isOptedOut && vm.overridesPhoneDetail.type === vm.phoneTypes.voip">Number is a VoIP</span> <span class="text-danger" ng-show="vm.overridesPhoneDetail.isOptedOut">Customer opted out of text messaging</span></div></div><div class="row margin-top" ng-if="vmSettingsPnl.isPartsOnDemandToFromAny()"><div class="col-sm-3 col-xs-12"><input type="text" id="reference_number" name="reference_number" autocomplete="nope" ng-model="vm.theTrip.referenceNumber" ng-disabled="vm.isFramedIn()" class="form-control better-placeholder" placeholder="REFERENCE NUMBER" required="" validation="required:alt=Required"></div><div class="col-sm-6 col-xs-12 override-xs-margin-top-md"><input type="text" ng-attr-placeholder="{{vmSettingsPnl.placeHolderText.customerLocation}}" id="customer_location" name="customer_location" ng-disabled="vm.theTrip.selectedSystemTripType.supportsLoanerVehicle == true && vm.serviceOrder.hasLoaner == null" ng-change="vmSettingsPnl.customerLocChanged()" required="" ng-model="vm.theTrip.customerFormattedLocation" class="form-control better-placeholder" details="vm.places" validation="required:alt=Required" here-places="" options="vmSettingsPnl.options" handle-selected="vmSettingsPnl.customerLocationUpdated(formattedAddress)" validation-error-to="customerLocError" allow-create-new="true"> <span id="customerLocError" class="validation text-danger"></span></div></div></div><div class="form-group margin-top" ng-if="vm.displayCustomerInfoFields()"><div class="row override-xs-padding-top-md margin-bottom-sm" ng-if="vm.theTrip.selectedTripOption.customerFieldsLabel"><div class="col-xs-12 override-xs-padding-top-md override-sm-padding-top-md">{{ vm.theTrip.selectedTripOption.customerFieldsLabel }}</div></div><div class="row"><div class="col-xs-12 override-xs-margin-top-md" ng-class="{\'col-sm-6\': vmSettingsPnl.hideLastName, \'col-sm-3\': !vmSettingsPnl.hideLastName}"><input type="text" id="first_name" name="first_name" clean="true" required="" autocomplete="nope" ng-model="vm.serviceOrder.customerInfo.firstName" class="form-control better-placeholder" placeholder="{{vm.serviceOrder.customerInfo.isBusiness === false ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md" ng-if="!vmSettingsPnl.hideLastName"><input type="text" id="last_name" name="last_name" placeholder="{{vm.serviceOrder.customerInfo.isBusiness === false ? \'LAST NAME\' : \'BUSINESS NAME\'}}" required="" autocomplete="nope" ng-model="vm.serviceOrder.customerInfo.lastName" class="form-control better-placeholder" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md"><input type="text" id="phone_number" name="phone_number" required="" inputmode="numeric" ng-model-options="{ debounce: 750 }" autocomplete="nope" ng-model="vm.serviceOrder.customerInfo.phoneNumber" class="form-control better-placeholder" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" validation="required|custom: vmSettingsPnl.validation.phoneNumberRequired(vm.serviceOrder.customerInfo.phoneNumber):alt=*" ng-change="vm.phoneChanged(vm.serviceOrder.customerInfo.phoneNumber)"> <span class="text-danger" ng-if="tripSettingsForm.phone_number.$error[\'passenger.phone_number\']">{{tripSettingsForm.phone_number.$error[\'passenger.phone_number\'] | sentenceCase}}</span> <span class="text-danger" ng-show="!vm.customerPhoneDetail.isOptedOut && vm.customerPhoneDetail.type === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="!vm.customerPhoneDetail.isOptedOut && vm.customerPhoneDetail.type === vm.phoneTypes.voip">Number is a VoIP</span> <span class="text-danger" ng-show="vm.customerPhoneDetail.isOptedOut">Customer opted out of text messaging</span></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md" ng-if="!vm.theTrip.selectedSystemTripType.supportsLyftAPI"><input type="email" id="email" name="email" required="" clean="true" autocomplete="nope" ng-model="vm.serviceOrder.customerInfo.email" class="form-control better-placeholder" placeholder="EMAIL ADDRESS" validation="required:alt=Required|custom:vm.validation.validEmail(vm.serviceOrder.customerInfo.email):alt=*"></div></div></div><div class="form-group" ng-if="(!vm.theTrip.selectedSystemTripType.supportsLyftAPI && !vm.tripWizard.vehicle && !vm.theTrip.dealerTripTypeInstance.vehicle && !vm.serviceOrder.recallId) || vm.bookingRules.isGeneric == true"><div class="row override-xs-padding-top-md" ng-if="vm.theTrip.selectedSystemTripType.firstVehicleLabel && vm.serviceOrder.hasLoaner == \'yes\'"><div class="col-xs-12 override-xs-padding-top-md override-sm-padding-top-md">{{ vm.theTrip.selectedSystemTripType.firstVehicleLabel }}</div></div><div class="row margin-top-sm override-xs-margin-top-none margin-bottom" ng-if="vmSettingsPnl.isPickupDropoff() && vm.bookingRules.disableVehicleVIN == false"><div class="col-sm-3 col-xs-12"><input type="text" id="vehicle_vin" name="vehicle_vin" ng-model="vm.serviceOrder.vehicleInfo.vin" validation="required:alt=Required|custom:vm.validation.validVin(vm.serviceOrder.vehicleInfo.vin):alt=*" class="form-control better-placeholder" clean="true" placeholder="VIN" required="" maxlength="17"></div></div><div class="row margin-top-sm override-xs-margin-top-none" ng-class="{\'override-xs-margin-top-md\': !(vm.theTrip.selectedSystemTripType.firstVehicleLabel && vm.serviceOrder.hasLoaner == \'yes\')}"><div class="col-sm-2 col-xs-12 override-xs-margin-top-md" ng-if="vmSettingsPnl.displayFirstVehicleStockNumber()"><input type="text" id="vehicle_stocknumber" name="vehicle_stocknumber" ng-model="vm.serviceOrder.vehicleInfo.stockNumber" class="form-control better-placeholder" clean="true" placeholder="STOCK #" required="" validation="required"></div><div class="col-xs-12 override-xs-margin-top-md" ng-class="{\'col-sm-2\': vmSettingsPnl.isTransportOrDelivery(), \'col-sm-4\': !vmSettingsPnl.isTransportOrDelivery()}" ng-if="!vmSettingsPnl.isPickupDropoff() && !vmSettingsPnl.isMobileGarage() && (vm.bookingRules.disableVehicleVIN == false || vm.bookingRules.isGeneric === true)"><input type="text" id="vehicle_vin" name="vehicle_vin" ng-model="vm.serviceOrder.vehicleInfo.vin" validation="required:alt=Required|custom:vm.validation.validVin(vm.serviceOrder.vehicleInfo.vin):alt=*" class="form-control better-placeholder" clean="true" placeholder="VIN" required="" maxlength="17"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="vm.bookingRules.isGeneric === true"><label for="is_new">NEW OR USED</label><select selectlabel="" required="" class="form-control bookingDD" ng-model="vm.serviceOrder.vehicleInfo.isVehicleNew" id="is_new" name="is_new" ng-options="option as option.text for option in vm.newUsedOptions track by option.value"><option value="">New or used</option></select></div><div ng-if="vm.bookingRules.isGeneric === true" class="hidden-xs col-sm-3 genric-test-drive-spacer">&nbsp;</div><div class="col-xs-12 override-xs-margin-top-md" ng-class="{\'field-wrapper\': vm.bookingRules.requiresMakeModelDropdown && vm.requiresYearDropDown, \'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}" ng-if="vm.bookingRules.requiresMotorDataDropdown == false"><label for="vehicle_year" ng-if="(vm.bookingRules.requiresMakeModelDropdown && vm.requiresYearDropDown) || vm.bookingRules.requiresMotorDataDropdown">YEAR</label> <input type="text" ng-pattern="/^\\d+$/" id="vehicle_year" name="vehicle_year" ng-model="vm.serviceOrder.vehicleInfo.year" class="form-control better-placeholder" clean="true" ng-keydown="vmSettingsPnl.vehicleKeyDown($event)" inputmode="numeric" pattern="[0-9]*" placeholder="YEAR" required="" validation="required:alt=Required|custom:vmSettingsPnl.validation.valYear():alt=Invalid Year (1950 - {{vmSettingsPnl.maxVehicleYear}})" ng-if="vm.bookingRules.requiresMakeModelDropdown == false || vm.requiresYearDropDown == false"><select class="form-control bookingDD" ng-if="vm.bookingRules.requiresMakeModelDropdown && vm.requiresYearDropDown" selectlabel="" ng-model="vm.serviceOrder.xTimeYear" id="vehicle_year" name="vehicle_year" ng-model-options="{ debounce: 400 }" ng-options="year.year for year in vm.dmsVehicleYearMakeModels track by year.year" ng-change="vmSettingsPnl.vehicleSelectionChanged()" required="" validation="required:alt=Required"><option value="">Year</option></select></div><div class="col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="vm.bookingRules.requiresMotorDataDropdown == true" ng-class="{\'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}"><label for="vehicle_year">YEAR</label><select id="vehicle_year" ng-model="vm.serviceOrder.motorYear" name="vehicle_year" selectlabel="" required="" inputmode="numeric" ng-model-options="{ debounce: 400 }" class="form-control" ng-options="year as year for year in vm.motorVehicleYears track by year" ng-change="vm.motorYearUpdated()" validation="required:alt=Required"><option value="">Year</option></select></div><div class="col-xs-12 override-xs-margin-top-md" ng-class="{\'field-wrapper\': vm.dmsVehicleYearMakeModels, \'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}" ng-if="vm.bookingRules.requiresMotorDataDropdown == false"><label for="vehicle_make" ng-if="vm.dmsVehicleYearMakeModels || vm.bookingRules.requiresMotorDataDropdown">MAKE</label> <input type="text" id="vehicle_make" name="vehicle_make" ng-model="vm.serviceOrder.vehicleInfo.make" class="form-control better-placeholder" placeholder="MAKE" required="" validation="required:alt=Required" ng-if="!vm.bookingRules.requiresMakeModelDropdown || !vm.dmsVehicleYearMakeModels"><select selectlabel="" required="" class="form-control bookingDD" ng-if="vm.dmsVehicleYearMakeModels" id="vehicle_make" name="vehicle_make" ng-model="vm.serviceOrder.dmsMake" ng-model-options="{ debounce: 750 }" ng-change="vmSettingsPnl.vehicleSelectionChanged()" ng-options="make.make for make in vm.serviceOrder.xTimeYear.makes track by make.makeCode" ng-disabled="vm.requiresYearDropDown && !vm.serviceOrder.xTimeYear" validation="required:alt=Required"><option value="">Make</option></select></div><div class="col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="vm.bookingRules.requiresMotorDataDropdown == true" ng-class="{\'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}"><label for="vehicle_make">MAKE</label><select id="vehicle_make" name="vehicle_make" selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.disableMotorMake()" ng-options="make.make for make in vm.motorVehicleMakes track by make.makeCode" ng-change="vm.motorMakeUpdated()" ng-model="vm.serviceOrder.dmsMake" class="form-control" validation="required:alt=Required"><option value="" selected="selected" disabled="">Select make</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vm.updateVehicleMakes"></div><div class="col-xs-12 override-xs-margin-top-md" ng-class="{\'field-wrapper\': vm.dmsVehicleYearMakeModels, \'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}" ng-if="vm.bookingRules.requiresMotorDataDropdown == false"><input type="text" id="vehicle_model" name="vehicle_model" ng-model="vm.serviceOrder.vehicleInfo.model" class="form-control better-placeholder" placeholder="MODEL" required="" validation="required:alt=Required" ng-if="!vm.bookingRules.requiresMakeModelDropdown || !vm.dmsVehicleYearMakeModels"> <label for="vehicle_model" ng-if="vm.dmsVehicleYearMakeModels || vm.bookingRules.requiresMotorDataDropdown">MODEL</label><select selectlabel="" required="" class="form-control bookingDD" ng-if="vm.dmsVehicleYearMakeModels" ng-disabled="!vm.serviceOrder.dmsMake" ng-model="vm.serviceOrder.dmsModel" ng-change="vmSettingsPnl.vehicleSelectionChanged()" ng-model-options="{ debounce: 750 }" id="vehicle_model" name="vehicle_model" ng-options="model.model.toUpperCase() for model in vm.serviceOrder.dmsMake.models track by model.modelCode.toUpperCase()" validation="required:alt=Required"><option value="">Model</option></select></div><div class="col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="vm.bookingRules.requiresMotorDataDropdown == true" ng-class="{\'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}"><label for="vehicle_model">MODEL</label><select id="vehicle_model" name="vehicle_model" selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="vm.disableMotorModel()" ng-options="model.model for model in vm.motorVehicleModels track by model.modelCode" ng-model="vm.serviceOrder.dmsModel" class="form-control" ng-change="vm.motorModelUpdated()" validation="required:alt=Required"><option value="" selected="selected" disabled="">Select model</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vm.updateVehicleModels"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md" ng-if="vm.bookingRules.isGeneric === true"><input type="text" class="form-control bookingDD better-placeholder" id="vehicle_style" name="vehicle_style" ng-model="vm.serviceOrder.vehicleInfo.genericStyle" placeholder="TRIM"></div><div class="col-xs-12 override-xs-margin-top-md field-wrapper" ng-class="{\'col-sm-3\':vm.systemTripTypeSelectedIsPickupOrDropOffMG(), \'col-sm-2\':!vm.systemTripTypeSelectedIsPickupOrDropOffMG()}"><label for="vehicle_transmission">TRANSMISSION</label><select required="" selectlabel="" class="form-control bookingDD" id="vehicle_transmission" name="vehicle_transmission" ng-model="vm.serviceOrder.vehicleInfo.transmission" ng-options="transmission as transmission.text for transmission in vmSettingsPnl.transmissions track by transmission.value" validation="required:alt=Required|custom: vmSettingsPnl.validation.valTransmissions()" ng-change="vmSettingsPnl.transmissionChanged()"><option value="">Transmission</option></select></div></div></div><div class="form-group" ng-if="vm.theTrip.selectedSystemTripType.supportsSecondVehicle == true && vm.serviceOrder.hasLoaner == \'yes\'"><div class="row margin-bottom-sm" ng-if="vm.theTrip.selectedSystemTripType.secondVehicleLabel"><div class="col-xs-12 override-xs-padding-top-md override-sm-padding-top-md">{{vm.theTrip.selectedSystemTripType.secondVehicleLabel}}</div></div><div class="row"><div class="col-sm-2 col-xs-12 override-xs-margin-top-md" ng-if="vmSettingsPnl.displaySecondVehicleStockNumber()"><input type="text" id="vehicle2_stocknumber" name="vehicle2_stocknumber" ng-model="vm.serviceOrder.vehicle2Info.stockNumber" class="form-control better-placeholder" clean="true" placeholder="STOCK #" required="" validation="required"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md"><input type="text" id="vehicle2_year" name="vehicle2_year" inputmode="numeric" pattern="[0-9]*" ng-model="vm.serviceOrder.vehicle2Info.year" class="form-control better-placeholder" clean="true" ng-keydown="vmSettingsPnl.vehicleKeyDown($event)" placeholder="YEAR" required="" validation="required:alt=Required|custom:vmSettingsPnl.validation.valYear2():alt=Invalid Year (1950 - {{vmSettingsPnl.maxVehicleYear}})"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md" ng-class="{\'override-xs-margin-top-md\': vmSettingsPnl.displaySecondVehicleStockNumber()}"><input type="text" id="vehicle2_make" name="vehicle2_make" ng-model="vm.serviceOrder.vehicle2Info.make" class="form-control better-placeholder" placeholder="MAKE" required="" validation="required:alt=Required"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md"><input type="text" id="vehicle2_model" name="vehicle2_model" ng-model="vm.serviceOrder.vehicle2Info.model" class="form-control better-placeholder" placeholder="MODEL" required="" validation="required:alt=Required"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md field-wrapper"><label for="vehicle2_transmission">TRANSMISSION</label><select selectlabel="" required="" class="form-control bookingDD" id="vehicle2_transmission" name="vehicle2_transmission" ng-model="vm.serviceOrder.vehicle2Info.transmission" ng-options="transmission as transmission.text for transmission in vmSettingsPnl.transmissions track by transmission.value" validation="required:alt=Required|custom: vmSettingsPnl.validation.valTransmissions()"><option value="">Transmission</option></select></div></div></div><div class="form-group"><div class="row margin-top-sm override-xs-margin-top-none"><div class="col-xs-12 col-sm-3 override-xs-margin-top-md" ng-if="vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.partsOnDemand && !vmSettingsPnl.isPartsOnDemandToFromAny()"><input type="text" id="reference_number" name="reference_number" autocomplete="nope" ng-model="vm.theTrip.referenceNumber" ng-disabled="vm.isFramedIn()" class="form-control better-placeholder" placeholder="REFERENCE NUMBER" required="" validation="required:alt=Required"></div><div class="col-xs-12 override-xs-margin-top-md" ng-if="!vmSettingsPnl.isPartsOnDemandToFromAny()" ng-class="{\'col-sm-6\': (!vmSettingsPnl.isMobileGarage() && !vm.theTrip.selectedSystemTripType.supportsFavoriteLocations) || vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftRoadSideAssistance || vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.partsOnDemand, \'col-sm-5\': vmSettingsPnl.isMobileGarage(), \'col-sm-9\': vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.theTrip.selectedSystemTripType.id !== vm.shortSystemTripType.lyftRoadSideAssistance && vm.theTrip.selectedSystemTripType.id !== vm.shortSystemTripType.partsOnDemand, \'col-sm-3\': vm.theTrip.selectedSystemTripType.supportsFavoriteLocations, \'override-xs-margin-top-md\': vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.theTrip.selectedSystemTripType.id !== vm.shortSystemTripType.lyftRoadSideAssistance}"><div ng-if="!vm.displayPickupLocationFavoriteLocations()"><input type="text" placeholder="{{vmSettingsPnl.placeHolderText.customerLocation}}" required="" id="customer_location" name="customer_location" ng-disabled="vm.theTrip.selectedSystemTripType.supportsLoanerVehicle == true && vm.serviceOrder.hasLoaner == null" ng-model="vm.theTrip.customerFormattedLocation" class="form-control better-placeholder" details="vm.places" validation="required:alt=Required" here-places="" options="vmSettingsPnl.options" handle-selected="vmSettingsPnl.customerLocationUpdated(formattedAddress)" allow-create-new="true" validation-error-to="customerLocError1"> <span id="customerLocError1" class="validation text-danger"></span> <span id="customerLocError2" ng-if="vmSettingsPnl.locationError2 !== null" class="validation text-danger">{{ vmSettingsPnl.locationError2 }}</span></div><div class="field-wrapper" ng-if="vm.displayPickupLocationFavoriteLocations()"><label for="customer_location">{{vmSettingsPnl.placeHolderText.customerLocation}}</label><select selectlabel="" required="" class="form-control bookingDD" id="customer_location" name="customer_location" ng-model="vm.theTrip.customerFormattedLocation" ng-options="location as ((location.displayName || location.name) + (location.displayName ? \'\' : \' (\' + location.address + \')\')) for location in vmSettingsPnl.displayFavoriteLocations track by location.id" validation="required:alt=Required" ng-change="vmSettingsPnl.favoriteCustomerLocationSelected(vm.theTrip.customerFormattedLocation)"><option value="">{{vmSettingsPnl.placeHolderText.customerLocation}}</option></select></div></div><div class="col-sm-1 col-xs-12 override-xs-margin-top-md" ng-if="vmSettingsPnl.isMobileGarage()"><input required="" type="text" min="0" ng-model-options="{ debounce: 750 }" inputmode="numeric" ng-keydown="vmSettingsPnl.hourKeyDown($event)" class="form-control better-placeholder no-spinners" placeholder="EST HRS" ng-model="vm.theTrip.hoursNeeded" name="hours" ng-change="vmSettingsPnl.hoursUpdated();" validation-error-to="est-hours-error" validation="required|custom:vmSettingsPnl.validation.valEstHours(vm.theTrip.hoursNeeded):alt=*"> <span class="inline validation text-danger text-nowrap" id="est-hours-error"></span></div><div class="col-xs-12 override-xs-margin-top-md" ng-class="{\'col-sm-5\': vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftRoadSideAssistance, \'col-sm-9\': vmSettingsPnl.isPartsOnDemandToFromAny(), \'col-sm-3\': vm.theTrip.selectedSystemTripType.id !== vm.shortSystemTripType.lyftRoadSideAssistance && !vmSettingsPnl.isPartsOnDemandToFromAny()}" ng-if="vm.theTrip.selectedSystemTripType.supportsFavoriteLocations || vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftRoadSideAssistance || vmSettingsPnl.isPartsOnDemandToFromAny()"><div ng-if="!vm.displayDropOffLocationFavoriteLocations()"><input type="text" required="" id="dropoff_location" placeholder="{{vmSettingsPnl.placeHolderText.dropOffLocation}}" name="dropoff_location" ng-model="vm.theTrip.dropoffFormattedLocation" class="form-control better-placeholder" details="vm.places" here-places="" handle-selected="vmSettingsPnl.dropoffLocationUpdated(formattedAddress)" allow-create-new="true" ng-change="vmSettingsPnl.dropOffLocChanged()" options="vmSettingsPnl.options" validation="required:alt=Required" validation-error-to="dropoffLocError"> <span id="dropoffLocError" class="validation text-danger"></span></div><div class="field-wrapper" ng-if="vm.displayDropOffLocationFavoriteLocations()"><label for="dropoff_location">{{vmSettingsPnl.placeHolderText.dropOffLocation}}</label><select selectlabel="" required="" class="form-control bookingDD" id="dropoff_location" name="dropoff_location" ng-model="vm.theTrip.dropoffFormattedLocation" ng-options="location as ((location.displayName || location.name) + (location.displayName ? \'\' : \' (\' + location.address + \')\')) for location in vmSettingsPnl.displayFavoriteLocations track by location.id" validation="required:alt=Required" ng-change="vmSettingsPnl.favoriteDropoffLocationSelected(vm.theTrip.dropoffFormattedLocation)"><option value="">{{vmSettingsPnl.placeHolderText.dropOffLocation}}</option></select></div><div ng-if="vmSettingsPnl.updatingFavoriteLocations" class="text-danger text-uppercase pull-right">UPDATING...</div></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="!vm.theTrip.selectedSystemTripType.supportsLyftAPI"><label for="customer_date">DATE</label><select selectlabel="" required="" id="customer_date" name="customer_date" class="form-control" validation="required:alt=Required" ng-model="vm.theTrip.customerDate" ng-change="vmSettingsPnl.customerDateChanged()" ng-disabled="vmSettingsPnl.disableDateField()"><option value="">Date</option><option ng-repeat="day in vm.theTrip.availableBookingDays" value="{{day | date:\'MM/dd/yyyy\'}}" ng-selected="(day && day.getDate() == vm.theTrip.customerDate.getDate() && day.getMonth() == vm.theTrip.customerDate.getMonth())">{{ day | date:\'MM/dd EEEE\'}}</option></select></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="!vm.theTrip.selectedSystemTripType.supportsLyftAPI"><label for="customer_time">TIME</label><select selectlabel="" required="" id="customer_time" name="customer_time" ng-disabled="vmSettingsPnl.disableTimeField()" class="form-control" validation="required:alt=Required" ng-model="vm.theTrip.customerTime" ng-change="vmSettingsPnl.customerTimeChanged()"><option value="">Time</option><option ng-repeat="time in vm.theTrip.availableBookingHours" value="{{ time }}" ng-selected="time == vm.theTrip.customerTime">{{ vmSettingsPnl.availableTimeText(time) }}</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide time-spinner" ng-show="vmSettingsPnl.updatingTimes"></div></div></div><div ng-if="vm.theTrip.selectedSystemTripType.supportsLyftAPI"><div class="row" ng-if="vm.showRideProviderMessage"><div class="col-xs-9 alert alert-danger margin-left-sm margin-right-sm">{{vm.rideProviderMessage}}<div ng-if="vm.rideProviderMessage">If you\'d like to retry with the same address, click <a href="#" ng-click="vmSettingsPnl.retryGetProviderRides(); $event.preventDefault()" class="alert-link"><u>here</u></a><img ng-if="vmSettingsPnl.processingEstimates" src="assets/images/ajax-loader.gif" class="inline-block margin-left-sm"></div></div></div><div ng-if="!vm.showRideProviderMessage"><div class="form-group" ng-if="vmSettingsPnl.lyftRides && vm.theTrip.selectedSystemTripType.value !== vm.shortSystemTripType.partsOnDemand"><div class="row lyft-ride-options margin-top-md override-xs-margin-top-md"><button type="button" ng-class="{\'selected\': lyftRide.selected}" class="lyft-ride" ng-click="vmSettingsPnl.providerRideSelected(lyftRide)" ng-repeat="lyftRide in vmSettingsPnl.lyftRides | orderBy: \'estimatedCost\'"><h3>{{ lyftRide.displayName }}</h3><div>{{ lyftRide.eta | duration: true:true }}</div><div>{{ lyftRide.estimatedCost | currency }}</div></button></div><div class="row padding-top-sm lyft-ride-options font-size-10">* Prices may change in {{ vmSettingsPnl.lyftPollCountDownTimer }} seconds if a trip is not booked.</div><div class="row padding-top-sm lyft-ride-options text-danger padding-top-none" ng-if="vm.rideAlertMessage">* {{ vm.rideAlertMessage }}</div></div><div class="form-group" ng-if="vmSettingsPnl.lyftRides && vm.theTrip.selectedSystemTripType.value === vm.shortSystemTripType.partsOnDemand"><div class="row lyft-ride-options-placeholder margin-top-md override-xs-margin-top-md"><div class="override-xs-padding-top-md col-xs-9"><button type="button" class="lyft-ride full-width single-result" ng-class="{\'selected\': lyftRide.selected}" ng-click="vmSettingsPnl.providerRideSelected(providerRide)" ng-repeat="providerRide in vmSettingsPnl.lyftRides | orderBy:\'estimatedCost\'"><div class="col-xs-4 text-left provider-logo"><img class="{{ vmSettingsPnl.getRideProviderDetails(providerRide).class }}" ng-src="{{ vmSettingsPnl.getRideProviderDetails(providerRide).logo }}" alt=""></div><div class="col-xs-6 provider-text"><div><span ng-if="providerRide.hasEtd">Estimated delivery time is</span>{{ providerRide.etd | duration: true:true }}</div></div><div class="col-xs-2 text-right provider-price"><h2>{{ providerRide.estimatedCost | currency }}</h2></div></button></div></div></div><div class="form-group" ng-if="!vmSettingsPnl.lyftRides"><div class="row margin-top-md override-xs-margin-top-md lyft-ride-options-placeholder"><div class="override-xs-padding-top-md col-xs-12" ng-class="{\'col-sm-9\':vm.theTrip.selectedSystemTripType.id !== vm.shortSystemTripType.lyftRoadSideAssistance, \'col-sm-11\':vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftRoadSideAssistance}"><div type="button" class="lyft-ride full-width text-center"><div ng-if="!vmSettingsPnl.processingEstimates" class="margin-top-sm">ENTER ADDRESS ABOVE FOR OPTIONS, PRICING AND ETA</div><img ng-if="vmSettingsPnl.processingEstimates" class="centered-content" src="assets/images/ajax-loader.gif"></div></div></div></div></div></div><div class="form-group" ng-if="(vm.theTrip.selectedSystemTripType.supportsHomeAddress == true && vm.theTrip.bookingRules.suppressHomeAddressField == false) || (vm.theTrip.selectedSystemTripType.supportsVehicleTrim && vm.theTrip.availableVehicleTrims.length > 0)"><div class="row"><div class="col-sm-6 col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="vm.theTrip.selectedSystemTripType.supportsVehicleTrim && vm.theTrip.availableVehicleTrims.length > 0"><label for="vehicle_style">VEHICLE TRIM STYLE</label><select selectlabel="" required="" class="form-control bookingDD" id="vehicle_style" name="vehicle_style" ng-model="vm.serviceOrder.vehicleInfo.style" validation="required:alt=Required" ng-options="style.name for style in vm.theTrip.availableVehicleTrims track by style.id"><option value="">Vehicle trim style</option></select></div><div class="col-sm-6 col-xs-12 override-xs-margin-top-md" ng-if="(vm.theTrip.selectedSystemTripType.supportsHomeAddress == true && vm.bookingRules.disableHomeAddress == false)"><input required="" type="text" ng-attr-placeholder="HOME ADDRESS" id="home_address" name="home_address" autocomplete="nope" ng-model="vm.theTrip.customerHomeFormattedLocation" class="form-control better-placeholder" clean="true" details="vm.places" validation="required:alt=Required" here-places="" handle-selected="vmSettingsPnl.customerHomeAddressLocationUpdated(formattedAddress)"></div></div></div><div class="form-group"><div class="row margin-top-sm override-xs-margin-top-none"><div ng-hide="vm.isFramedIn()" class="col-xs-12 override-xs-margin-top-md field-wrapper" ng-class="{\'col-sm-9\': vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.theTrip.selectedSystemTripType.id !== vmSettingsPnl.tripTypes.partsOnDemand, \'col-sm-6\': !vm.theTrip.selectedSystemTripType.supportsLyftAPI || ( vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.partsOnDemand)}"><label for="service_advisor">USER</label><select required="" selectlabel="" id="service_advisor" name="service_advisor" class="form-control has-label" validation="required:alt=Required" ng-model="vm.theTrip.serviceAdvisor" ng-change="vm.serviceAdvisorChanged()" ng-options="advisor as advisor.firstName + \' \' + advisor.lastName for advisor in vm.serviceAdvisors | orderBy:\'firstName\' track by advisor.id"><option value="">User</option></select><div class="text-danger" ng-if="tripSettingsForm.service_advisor.$error[\'serviceAdvisor.phone_number\']">{{ tripSettingsForm.service_advisor.$error[\'serviceAdvisor.phone_number\'] }}</div></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md field-wrapper" ng-if="vm.theTrip.selectedProviderRide.rideProviderType == vm.rideProviderTypes.uberDirect && vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.partsOnDemand"><label for="package_size">PACKAGE SIZE</label><div class="display-flex content-center" style="align-items: center;"><select required="" selectlabel="" id="package_size" name="package_size" class="form-control has-label text-uppercase" validation="required:alt=Required" ng-model="vm.packageSizeSelected" ng-options="l as l.text for l in vm.packageSize" ng-change="vm.packageSizeSelectedChange()"><option value="">Package Size</option></select><span class="margin-left-xs cursor-pointer display-flex content-center"><i class="material-icons md-18" aria-label="Package size details" role="button" tabindex="0" ng-click="vm.openPackageSizeModal()">info_outline</i></span></div><script type="text/ng-template" id="packageSizeModal.html"><div class="modal-header"> <button type="button" class="close" ng-click="vm.close()" aria-hidden="true">&times;</button> <h4 class="modal-title">Package Size Details</h4> </div> <div class="modal-body"> <div class="table-responsive"> <table class="table table-bordered margin-none"> <thead> <tr> <th>Delivery Order Size / Dimension + Weight</th> <th>Description</th> <th>Sizing Limit (in CM)</th> </tr> </thead> <tbody> <tr> <td>Small</td> <td>You can carry it with one hand (e.g., bottle of water)</td> <td>20.32 L x 7.62 D x 15.24 H</td> </tr> <tr> <td>Medium</td> <td class="whitespace-normal">You need a tote bag to carry these items (e.g., multiple sweaters and pants, or multiple grocery items for a grocery bag)</td> <td>37.5 L x 17.78 D x 30.48 H</td> </tr> <tr> <td>Large</td> <td>You need two hands to carry it (e.g., computer monitor)</td> <td>48.26 L x 22.86 D x 38.1 H</td> </tr> <tr> <td>X-Large</td> <td class="whitespace-normal">You will need to make multiple trips to/from a vehicle to transport (e.g., grocery order)</td> <td>63.5 L x 38.1 D x 38.1 H</td> </tr> <tr> <td>Length | Height | Depth</td> <td>[optional] Length in cm | Height in cm | Depth in cm</td> <td>2W: 82,369 cm3 | 4W: 2,118,912 cm3</td> </tr> </tbody> </table> </div> <div class="margin-top-sm"> <strong>Weight Limits:</strong> <span><strong>2W</strong>: 11,340 grams</span> | <span><strong>4W</strong>: 453,592 grams</span> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="vm.close()">Close</button> </div></script></div><div ng-if="vm.displayDriverDropDown()" class="col-xs-12 ng-hide field-wrapper" ng-show="vm.enableDispatchControls()" ng-class="{\'col-sm-9\': vm.theTrip.selectedSystemTripType.supportsLyftAPI, \'col-sm-6\': !vm.theTrip.selectedSystemTripType.supportsLyftAPI && !vm.showCanStartEarlyCheckbox(), \'col-md-3\': !vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.showCanStartEarlyCheckbox(), \'col-sm-3\': !vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.showCanStartEarlyCheckbox()}"><label for="assigned_driver">{{vmSettingsPnl.getDriverPlaceHolder()}}</label><select id="assigned_driver" chosen="{width: \'100%\'}" max-shown-results="100" name="assigned_driver" selectlabel="" class="form-control has-label" ng-disabled="vmSettingsPnl.disableDriversField()" allow-null-option="Best available" ng-change="vmSettingsPnl.driverSelectionModified(vm.theTrip.assignedDriver, vm.originalDriver)" ng-init="vm.originalDriver=vm.trip.driver" ng-model="vm.theTrip.assignedDriver" ng-options="driver as vm.formatDriverDropDown(driver, vm.theTrip.assignedDriver) disable when driver.id == -999 for driver in vm.theTrip.activeDrivers track by driver.id"></select><img src="assets/images/ajax-loader.gif" class="ng-hide driver-spinner2" ng-show="vmSettingsPnl.retrievingDrivers"></div><div class="col-xs-12 col-md-3 col-sm-3" ng-if="vm.showCanStartEarlyCheckbox()"><div class="form-group inline margin-none pull-right"><span class="display-flex content-center"><input type="checkbox" class="checkbox margin-none" id="canAccessEarly" ng-model="vm.theTrip.canAccessEarly"> <label for="canAccessEarly" class="padding-left-sm margin-top-sm text-nowrap"><span>Early start&nbsp;</span></label> <span class="margin-top-sm"><i class="material-icons md-20" uib-popover="Check this box to allow driver to start trip more than 90 minutes before first stop. Inform driver to refresh their trip after checking." popover-placement="left" popover-append-to-body="true" popover-trigger="mouseenter">info_outline</i></span></span></div></div></div></div><div class="form-group"><div class="row margin-top-sm override-xs-margin-top-none" ng-if="vm.theTrip.selectedSystemTripType.supportsServiceNeeds"><div class="col-xs-12 col-sm-6"><textarea class="form-control better-placeholder resize-none" rows="2" ng-model="vm.serviceOrder.customerDescriptionOfProblem" placeholder="SERVICE NEEDS"></textarea></div><div class="col-sm-6 col-xs-12 override-xs-margin-top-md"><textarea class="form-control better-placeholder resize-none" rows="2" ng-model="vm.theTrip.tripNote" placeholder="DRIVER NOTES"></textarea></div></div><div class="row margin-top-sm override-xs-margin-top-none" ng-if="!vm.theTrip.selectedSystemTripType.supportsServiceNeeds"><div class="col-xs-12" ng-class="{\'col-sm-9\': vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.theTrip.selectedSystemTripType.id !== vm.shortSystemTripType.lyftRoadSideAssistance, \'col-sm-11\': vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftRoadSideAssistance, \'col-sm-12\': !vm.theTrip.selectedSystemTripType.supportsLyftAPI}"><textarea ng-if="vm.theTrip.selectedSystemTripType.value !== vm.shortSystemTripType.partsOnDemand || (vm.theTrip.selectedProviderRide && vm.theTrip.selectedProviderRide.rideProviderType == vm.rideProviderTypes.lyft)" class="form-control better-placeholder resize-none" rows="2" ng-model="vm.theTrip.tripNote" maxlength="{{vm.theTrip.selectedSystemTripType.supportsLyftAPI ? (vm.theTrip.selectedSystemTripType.value !== vm.shortSystemTripType.partsOnDemand ? 100 : 64) : 999999}}" placeholder="DRIVER NOTES"></textarea><div ng-if="vm.theTrip.selectedSystemTripType.value === vm.shortSystemTripType.partsOnDemand && vm.theTrip.selectedProviderRide && (vm.theTrip.selectedProviderRide.rideProviderType == vm.rideProviderTypes.uber || vm.theTrip.selectedProviderRide.rideProviderType == vm.rideProviderTypes.uberDirect)"><textarea class="form-control driver-notes resize-none" rows="2" ng-model="vm.theTrip.tripNote" maxlength="280" placeholder="PICKUP NOTES"></textarea> <textarea class="form-control driver-notes resize-none" rows="2" ng-model="vm.theTrip.dropoffNote" maxlength="280" placeholder="DROPOFF NOTES"></textarea></div></div></div></div><div class="form-group" ng-if="vm.bookingRules.disableDriversLicense == false && (vm.serviceOrder.hasLoaner == \'yes\' || vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.testdrives)"><div class="row"><div class="col-sm-6 col-xs-12 override-xs-margin-top-md"><input type="text" id="dl_number" name="dl_number" ng-model="vm.serviceOrder.dlInfo.number" class="form-control better-placeholder" required="" clean="true" placeholder="DRIVERS LICENSE NUMBER" validation="required:alt=Required"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md field-wrapper"><label for="dl_state">STATE</label><select selectlabel="" required="" class="form-control" name="dl_state" id="dl_state" ng-model="vm.serviceOrder.dlInfo.issuingState" ng-options="str for str in vmSettingsPnl.usStates" validation="required:alt=Required"><option value="">State</option></select></div><div class="col-sm-2 col-xs-12 field-wrapper"><label for="dl_expmonth">EXP. MONTH</label><select selectlabel="" required="" class="form-control" name="dl_expmonth" id="dl_expmonth" ng-model="vm.serviceOrder.dlInfo.expirationMonth" ng-options="str for str in vmSettingsPnl.calendarMonths" validation-error-to="#dl-custom-error" validation="required:alt=Required|custom: vmSettingsPnl.validation.dlDate()" ng-change="vmSettingsPnl.revalidateInput(\'dl_expyear\')"><option value="">Exp. month</option></select><span id="dl-custom-error" class="validation text-danger"></span></div><div class="col-sm-2 col-xs-12 field-wrapper"><label for="dl_expyear">EXP. YEAR</label><select selectlabel="" required="" class="form-control" name="dl_expyear" id="dl_expyear" ng-model="vm.serviceOrder.dlInfo.expirationYear" ng-options="str for str in vmSettingsPnl.calendarYears" validation-error-to="#dl-custom-error" validation="required:alt=Required|custom: vmSettingsPnl.validation.dlDate()" ng-change="vmSettingsPnl.revalidateInput(\'dl_expmonth\')"><option value="">Exp. year</option></select></div></div></div><div class="form-group" ng-if="vm.bookingRules.disableInsurance == false && (vm.serviceOrder.hasLoaner == \'yes\' || vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.testdrives)"><div class="row margin-top-sm override-xs-margin-top-none"><div class="col-sm-5 col-xs-12"><input type="text" id="ins_carrier" name="ins_carrier" ng-model="vm.serviceOrder.insInfo.carrier" class="form-control better-placeholder" required="" clean="true" placeholder="INSURANCE CARRIER" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md"><input type="text" id="ins_policynum" name="ins_policynum" ng-model="vm.serviceOrder.insInfo.policyNumber" class="form-control better-placeholder" clean="true" placeholder="POLICY NUMBER" required="" validation="required:alt=Required"></div><div class="col-sm-2 col-xs-12 override-xs-margin-top-md field-wrapper"><label for="ins_expmonth">EXP. MONTH</label><select selectlabel="" required="" class="form-control" name="ins_expmonth" id="ins_expmonth" ng-model="vm.serviceOrder.insInfo.expirationMonth" ng-options="str for str in vmSettingsPnl.calendarMonths" validation-error-to="#ins-custom-error" validation="required:alt=Required|custom: vmSettingsPnl.validation.insDate()" ng-change="vmSettingsPnl.revalidateInput(\'ins_expyear\')"><option value="">Exp. month</option></select><span id="ins-custom-error" class="validation text-danger"></span></div><div class="col-sm-2 col-xs-12 field-wrapper"><label for="ins_expyear">EXP. YEAR</label><select selectlabel="" required="" class="form-control" name="ins_expyear" id="ins_expyear" ng-model="vm.serviceOrder.insInfo.expirationYear" ng-options="str for str in vmSettingsPnl.calendarYears" validation-error-to="#ins-custom-error" validation="required:alt=Required|custom: vmSettingsPnl.validation.insDate()" ng-change="vmSettingsPnl.revalidateInput(\'ins_expmonth\')"><option value="">Exp. year</option></select></div></div></div><div class="form-inline form-group inline" ng-if="vm.bookingRules.enableDashboardTermsAndConditions == true && vm.displayTerms()"><div class="row margin-top-sm"><div class="col-xs-12"><div ng-if="vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.partsOnDemand"><div class="override-xs-padding-top-md margin-bottom-sm"><label for="agree-parts-weight" class="full-width"><div class="row"><div class="col-xs-1 rideprovider-checkbox padding-right-none"><input type="checkbox" class="checkbox inline margin-bottom" id="agree-parts-weight" name="agreeToPartsWeight" ng-model="vm.theTrip.agreedToPartsWeight" required="true" validation="required:alt=Please agree to the terms before booking"></div><div class="col-xs-11 padding-left-none"><span for="agree-parts-weight" class="checkbox-lyfts inline text-uppercase" ng-if="!(vm.theTrip.selectedProviderRide.rideProviderType == vm.rideProviderTypes.uberDirect)">I UNDERSTAND {{vm.rideProvider || \'THE RIDE PROVIDER\'}} WILL NOT ACCEPT PARTS OVER 50 LBS</span> <span for="agree-parts-weight" class="checkbox-lyfts inline text-uppercase" ng-if="(vm.theTrip.selectedProviderRide.rideProviderType == vm.rideProviderTypes.uberDirect)">I ACKNOWLEDGE INACCURATE PACKAGE SIZE SELECTION CAN RESULT IN CANCELLATION FEES.</span></div></div></label></div></div><div ng-if="vm.theTrip.selectedSystemTripType.supportsLyftAPI"><div class="margin-top-xs" ng-if="vm.bookingRules.lyftTermsLink"><label class="checkbox-lyfts"><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="agreeToTermsLyft" ng-model="vm.theTrip.agreedToTermsLyft" required="" validation="required"> <span class="checkbox-lyfts" ng-if="vm.bookingRules.lyftTermsText" ng-bind-html="vm.bookingRules.lyftTermsLink" ng-click="vm.showTerms($event, vm.bookingRules.lyftTermsText)"></span> <span class="checkbox-lyfts" ng-if="!vm.bookingRules.lyftTermsText" ng-bind-html="vm.bookingRules.lyftTermsLink"></span></label></div><div ng-if="vm.bookingRules.uberTermsLink"><label class="full-width"><div class="row"><div class="col-xs-1 rideprovider-checkbox padding-right-none"><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="agreeToTermsUber" ng-model="vm.theTrip.agreedToTermsUber" required="" validation="required"></div><div class="col-xs-11 padding-left-none"><span class="checkbox-lyfts" ng-if="vm.bookingRules.uberTermsText" ng-bind-html="vm.bookingRules.uberTermsLink" ng-click="vm.showTerms($event, vm.bookingRules.uberTermsText)"></span> <span class="checkbox-lyfts" ng-if="!vm.bookingRules.uberTermsText" ng-bind-html="vm.bookingRules.uberTermsLink"></span></div></div></label></div></div></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/add-new-settings-lyft-credit.view.html','<div ng-if="vm.productGroupsConfigured" class="lyft-credit-add"><uib-accordion-heading><h4 class="panel-title settings-title">SETTINGS</h4></uib-accordion-heading><ng-form name="vmSettingsPnl.addCreditForm"><div class="row"><div class="col-sm-4 col-xs-12 override-xs-margin-top-md field-wrapper margin-bottom-none"><label for="lyft_credit_type">CREDIT FOR...</label><select class="form-control bookingDD" ng-model="vmSettingsPnl.lyftCredit.creditType" id="lyft_credit_type" ng-change="vmSettingsPnl.creditTypeChanged()" required="" selectlabel="" name="lyft_credit_type" ng-options="creditType.name for creditType in vmSettingsPnl.creditTypeOptions track by creditType.id" validation="required:alt=Required"><option value="">Credit for...</option></select></div><div class="col-sm-8 col-xs-12 bulk-upload" ng-if="vmSettingsPnl.lyftCredit.creditType.id === vmSettingsPnl.creditTypes.bulkUpload"><div><button type="button" class="btn btn-default margin-right-md" ngf-select="vmSettingsPnl.validateBatch($file)" ng-model="vmSettingsPnl.lyftCredit.batch">UPLOAD RECIPIENT LIST...</button> <span>{{ vmSettingsPnl.lyftCredit.batch.file.name }}</span> <span ng-if="vmSettingsPnl.isValidatingBatch">Validating...</span> <span ng-if="vmSettingsPnl.lyftCredit.batch.isUploaded && vmSettingsPnl.lyftCredit.batch.isValid"><i class="material-icons md-18">done</i> OK</span> <span ng-if="vmSettingsPnl.lyftCredit.batch.isUploaded && !vmSettingsPnl.lyftCredit.batch.isValid" class="text-danger inline-block"><i class="material-icons md-18">clear</i> ERROR: MISSING DATA OR INCORRECT FORMAT</span></div></div></div><div class="row margin-top-sm" ng-if="vmSettingsPnl.lyftCredit.creditType.id !== vmSettingsPnl.creditTypes.bulkUpload"><div class="col-sm-8 lyft-refnote-ronum" ng-if="vmSettingsPnl.lyftCredit.creditType.id === vmSettingsPnl.creditTypes.repairOrder"><select id="credit_type_reference" name="credit_type_reference" multiple="" required="" ui-select2="vmSettingsPnl.repairOrderSearchOptions" ng-model="vmSettingsPnl.lyftCredit.repairOrder" placeholder="RO number" type="text" class="form-control select2-single" validation-error-to="roNumberError" validation="required:alt=Required"></select><span id="roNumberError" class="validation text-danger"></span></div><div class="col-sm-8 lyft-refnote-ronum" ng-if="vmSettingsPnl.lyftCredit.creditType.id !== vmSettingsPnl.creditTypes.repairOrder"><input type="text" id="credit_type_reference" name="credit_type_reference" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.referenceNote" class="form-control better-placeholder" placeholder="REFERENCE NOTE"></div></div><div class="row margin-top-sm" ng-if="vmSettingsPnl.lyftCredit.creditType.id !== vmSettingsPnl.creditTypes.bulkUpload"><div class="col-sm-4 col-xs-6 lyft-credit-namephone"><input type="text" id="first_name" name="first_name" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.firstName" class="form-control better-placeholder" placeholder="FIRST NAME" required="" validation="required:alt=Required"></div><div class="col-sm-4 col-xs-6 lyft-credit-namephone"><input type="text" id="last_name" name="last_name" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.lastName" class="form-control better-placeholder" placeholder="LAST NAME" required="" validation="required:alt=Required"></div><div class="col-sm-4 col-xs-6 lyft-credit-namephone"><input type="text" id="phone_number" name="phone_number" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.phoneNumber" ng-change="vmSettingsPnl.phoneChanged(vmSettingsPnl.lyftCredit.phoneNumber)" class="form-control better-placeholder" placeholder="PHONE" required="" validation="required:alt=Required|custom:vmSettingsPnl.validation.phone(vmSettingsPnl.lyftCredit.phoneNumber):alt=*" mask-restrict="reject" mask="(999) 999-9999"><phone-type-indicator phone-number="vmSettingsPnl.lyftCredit.phoneNumber"></phone-type-indicator></div></div><div class="row margin-top-sm" ng-if="vmSettingsPnl.lyftCredit.creditType.id === vmSettingsPnl.creditTypes.bulkUpload"><div class="col-sm-3 col-xs-12"><input type="text" id="first_name" name="first_name" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.customerId" class="form-control better-placeholder" placeholder="CLIENT ID" required="" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md"><input type="text" id="last_name" name="last_name" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.campaignId" class="form-control better-placeholder" placeholder="CAMPAIGN ID" required="" validation="required:alt=Required"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md"><input type="text" id="bulkupload_referencenote" name="bulkupload_referencenote" clean="true" autocomplete="nope" ng-model="vmSettingsPnl.lyftCredit.referenceNote" class="form-control better-placeholder" placeholder="REFERENCE NOTE"></div></div></ng-form><div class="row margin-top-sm"><div class="col-sm-2 col-xs-6 field-wrapper lyft-credit-daterange"><label for="dateRangeFilter">VALID FOR</label><select selectlabel="" class="form-control" name="simpleTimeFrame" id="simpleTimeFrame" required="" ng-model="vmSettingsPnl.lyftCredit.simpleTimeframe" ng-change="vmSettingsPnl.simpleTimeFrameChanged()" ng-disabled="vm.filters.search" ng-options="t.value as t.text for t in vmSettingsPnl.simpleTimeOptions" validation="required:alt=Required">><option value="">Valid for</option></select></div><div class="col-sm-3 col-xs-6 lyft-credit-daterange" ng-if="vmSettingsPnl.lyftCredit.simpleTimeframe === \'custom\'"><input date-range-picker="" id="lyft-credit-date-picker" name="lyft-credit-date-picker" class="form-control date-picker" required="" placeholder="EFFECTIVE DATES..." options="vmSettingsPnl.datePickerOptions" type="text" ng-model="vmSettingsPnl.lyftCredit.timeframe"> <span id="lyft-credit-adddate-icon" ng-click="vmSettingsPnl.showDatePicker()"><i class="glyphicon glyphicon-calendar"></i></span> <span class="text-danger validation" ng-if="!vmSettingsPnl.lyftCredit.timeframe.startDate && vm.formSubmitted">Required</span></div><div class="col-sm-3 col-xs-6" ng-if="vmSettingsPnl.lyftCredit.type === vmSettingsPnl.benefitTypes.credits"><input type="text" id="credit_amount" name="credit_amount" ng-model="vmSettingsPnl.lyftCredit.creditAmount" class="form-control better-placeholder lyft-credit-input" placeholder="CREDIT AMOUNT" required="" format-currency="" validation="required:alt= |between_num: 0.01, 1000:alt=Must be between $0.01 and $1000.00"></div><div class="col-sm-3 col-xs-6 lyft-credit-input2" ng-if="vmSettingsPnl.lyftCredit.type === vmSettingsPnl.benefitTypes.fixedFare"><input type="text" id="flat_fare_per_ride" name="flat_fare_per_ride" ng-model="vmSettingsPnl.lyftCredit.flatFarePerRide" class="form-control better-placeholder" placeholder="FLAT FARE PER RIDE" required="" format-currency="" validation="required:alt=Required|between_num: 0.01, 1000:alt=Must be between $0.01 and $1000.00"></div><div class="col-sm-4 col-xs-6 lyft-credit-input2" ng-if="vmSettingsPnl.lyftCredit.type === vmSettingsPnl.benefitTypes.fixedDiscount"><input type="text" id="liability_per_ride" name="liability_per_ride" ng-model="vmSettingsPnl.lyftCredit.liabilityPerRide" class="form-control better-placeholder" placeholder="DISCOUNT IN $" required="" format-currency="" validation="required:alt=Required|between_num: 0.01, 1000:alt=Must be between $0.01 and $1000.00"></div><div class="col-sm-3 col-xs-6 lyft-credit-input3" ng-if="vmSettingsPnl.lyftCredit.type === vmSettingsPnl.benefitTypes.variableDiscount"><input type="text" id="discount_ratio" name="discount_ratio" ng-model="vmSettingsPnl.lyftCredit.discountRatio" class="form-control better-placeholder" placeholder="DISCOUNT %" required="" validation="required:alt=Required|numeric:alt=Must be a valid percentage|between_num: 1, 100:alt=Must be between 1 and 100"></div><div class="col-sm-3 col-xs-6 lyft-credit-input3" ng-if="vmSettingsPnl.lyftCredit.type !== vmSettingsPnl.benefitTypes.credits"><input type="text" id="num_rides" name="num_rides" ng-model="vmSettingsPnl.lyftCredit.numRides" class="form-control better-placeholder" placeholder="# OF RIDES" required="" validation="required:alt=Required|numeric:alt=Must be a valid number"></div><div class="col-sm-3 col-xs-6 lyft-credit-input3" ng-if="vmSettingsPnl.lyftCredit.type === vmSettingsPnl.benefitTypes.fixedFare || vmSettingsPnl.lyftCredit.type === vmSettingsPnl.benefitTypes.variableDiscount"><input type="text" id="liability_per_ride" name="liability_per_ride" ng-model="vmSettingsPnl.lyftCredit.liabilityPerRide" class="form-control better-placeholder" placeholder="MAX RIDE COST" required="" format-currency="" validation="required:alt=Required|between_num: 0.01, 1000:alt=Must be between $0.01 and $1000.00"></div></div><div class="row margin-top-sm" ng-if="vmSettingsPnl.lyftCredit.timeframe.endDate"><div class="col-xs-12 margin-top-md"><span class="text-uppercase">VALID UNTIL {{vmSettingsPnl.lyftCredit.timeframe.endDate._d | date:\'EEE, MMM dd\'}} AT 11:59 PM</span></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/add-new-settings-send-smsemail.view.html','<div class="form-group margin-top"><div ng-hide="vm.isFramedIn()" class="row margin-bottom override-xs-margin-top-md"><div class="col-xs-3 field-wrapper"><label for="service_advisor">USER</label><select required="" selectlabel="" id="service_advisor" name="service_advisor" class="form-control has-label" validation="required:alt=Required" ng-model="vm.theTrip.serviceAdvisor" ng-options="advisor as advisor.firstName + \' \' + advisor.lastName for advisor in vm.serviceAdvisors track by advisor.id"></select></div></div></div><div class="form-group margin-top margin-bottom-none"><div class="row"><div class="col-xs-12 margin-bottom-md" ng-class="{\'col-sm-6\': vmSettingsPnl.hideLastName, \'col-sm-3\': !vmSettingsPnl.hideLastName}"><input type="text" id="first_name" name="first_name" ng-model="vm.serviceOrder.customerInfo.firstName" class="form-control better-placeholder" clean="true" required="" placeholder="{{ vmSettingsPnl.firstNamePlaceHolder || vm.serviceOrder.customerInfo.isBusiness === false ? \'FIRST NAME\' : \'CUSTOMER NAME\' }}" validation="required:alt=Required" ng-blur="vm.getFormattedInvitationMessage()"></div><div class="col-sm-3 col-xs-12 margin-bottom-md" ng-if="!vmSettingsPnl.hideLastName"><input type="text" id="last_name" name="last_name" ng-model="vm.serviceOrder.customerInfo.lastName" class="form-control better-placeholder" placeholder="{{vm.serviceOrder.customerInfo.isBusiness === false ? \'LAST NAME\' : \'BUSINESS NAME\'}}" required="" validation="required:alt=Required" ng-blur="vm.getFormattedInvitationMessage()"></div><div class="col-sm-3 col-xs-12 margin-bottom-md" ng-if="vm.serviceOrder.action == vm.action.sms"><input type="text" id="phone_number" name="phone_number" ng-model="vm.serviceOrder.customerInfo.phoneNumber" class="form-control better-placeholder" required="" mask-restrict="reject" mask="(999) 999-9999" clean="true" placeholder="MOBILE PHONE" ng-change="vm.phoneChanged(vm.serviceOrder.customerInfo.phoneNumber)" validation="required:alt=Required" ng-blur="vm.getFormattedInvitationMessage()"> <span class="text-danger" ng-show="!vm.customerPhoneDetail.isOptedOut && vm.customerPhoneDetail.type === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="!vm.customerPhoneDetail.isOptedOut && vm.customerPhoneDetail.type === vm.phoneTypes.voip">Number is a VoIP</span> <span class="text-danger" ng-show="vm.customerPhoneDetail.isOptedOut">Customer opted out of text messaging</span></div><div class="col-sm-3 col-xs-12 margin-bottom-md" ng-if="vm.serviceOrder.action == vm.action.email"><input type="email" id="email" name="email" ng-model="vm.serviceOrder.customerInfo.email" class="form-control better-placeholder" required="" placeholder="EMAIL ADDRESS" validation="required:alt=Required|email" ng-blur="vm.getFormattedInvitationMessage()"></div><div class="col-sm-3 col-xs-12 margin-bottom-md margin-top-xs override-xs-margin-top-md" ng-if="vm.theTrip.selectedSystemTripType.id == 2 || vm.theTrip.selectedSystemTripType.supportsLyftAPI"><div class="btn btn-default" ng-click="vm.getFormattedInvitationMessage()" ng-disabled="!vm.theTrip.serviceAdvisor || !vm.serviceOrder.customerInfo.lastName || !vm.serviceOrder.customerInfo.firstName || (vm.serviceOrder.action == vm.action.email && !vm.serviceOrder.customerInfo.email) || (vm.serviceOrder.action == vm.action.sms && !vm.serviceOrder.customerInfo.phoneNumber)"><span ng-if="!vm.theTrip.invitationMessage">Next</span> <span ng-if="vm.theTrip.invitationMessage">Update</span></div></div></div></div><div class="form-group" ng-if="vm.theTrip.selectedSystemTripType.id == 1"><div class="row margin-top-sm"><div class="col-sm-3 col-xs-12 field-wrapper"><label for="appt_date">APPT DATE</label><select selectlabel="" id="appt_date" name="appt_date" class="form-control" required="" validation="required:alt=Required" ng-model="vm.serviceOrder.apptDate" ng-change="vmSettingsPnl.apptDateChanged()"><option value="">Appt date</option><option ng-repeat="day in vm.serviceOrder.availableApptDays" ng-init="$last && vmSettingsPnl.apptDateChanged()" value="{{day | date:\'MM/dd/yyyy\'}}" ng-selected="(day && day.getDate() == vm.serviceOrder.apptDate.getDate() && day.getMonth() == vm.serviceOrder.apptDate.getMonth())">{{ day | date:\'MM/dd EEEE\'}}</option></select></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md field-wrapper"><label for="appt_time">APPT TIME</label><select selectlabel="" id="appt_time" name="appt_time" class="form-control" required="" validation="required:alt=Required" ng-model="vm.serviceOrder.apptTime" ng-change="vmSettingsPnl.apptTimeChanged()" ng-disabled="vmSettingsPnl.disableApptTimeField()"><option value="">Appt time</option><option ng-repeat="time in vm.serviceOrder.availableApptHours" value="{{ time }}" ng-selected="time == vm.serviceOrder.apptTime">{{ time }}</option></select></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md"><div class="btn btn-default" ng-click="vm.getFormattedInvitationMessage()" ng-disabled="!vm.theTrip.serviceAdvisor || !vm.serviceOrder.customerInfo.lastName || !vm.serviceOrder.customerInfo.firstName || (vm.serviceOrder.action == vm.action.email && !vm.serviceOrder.customerInfo.email) || (vm.serviceOrder.action == vm.action.sms && !vm.serviceOrder.customerInfo.phoneNumber)"><span ng-if="!vm.theTrip.invitationMessage">Next</span> <span ng-if="vm.theTrip.invitationMessage">Update</span></div></div></div></div><div class="form-group" ng-if="vm.theTrip.invitationSubject"><div class="row"><div class="col-xs-12 margin-bottom"><input type="text" id="invitation_subject" required="" name="invitation_subject" ng-model="vm.theTrip.invitationSubject" class="form-control better-placeholder" placeholder="EMAIL SUBJECT" validation="required:alt=Required"></div></div></div><div class="form-group ng-hide" ng-show="vm.theTrip.invitationMessage"><div class="row override-xs-margin-top-md"><div class="col-xs-12 margin-bottom"><textarea name="invitation_copy" id="invitation_copy" class="form-control better-placeholder resize-none" required="" ng-model="vm.theTrip.invitationMessage" validation="required:alt=Required"></textarea></div></div></div><div class="form-group ng-hide" ng-show="vm.invitationSent"><div class="row margin-bottom"><div class="col-xs-12">Invitation sent successfully.</div></div></div><div class="form-group form-inline inline" ng-if="!vm.invitationSent && !vm.theTrip.invitationMessage"><div class="row margin-bottom override-xs-margin-top-md"><div class="col-xs-12"><div class="text-uppercase">Note: Fill in the fields above and click \'Next\' to view the message your customer will be sent.</div></div></div></div><div class="form-group" ng-if="vm.bookingRules.enableDashboardTermsAndConditions && vm.displayTerms()"><div class="row margin-bottom"><div class="col-xs-12"><div ng-if="vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.partsOnDemand"><div class="margin-bottom"><label for="agree-parts-weight" class="inline text-uppercase lyft-weight"><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" id="agree-parts-weight" name="agreeToPartsWeight" ng-model="vm.theTrip.agreedToPartsWeight" required="true" validation="required:alt=Please agree to the terms before booking"> <span>I UNDERSTAND {{vm.rideProvider || \'THE RIDE PROVIDER\'}} WILL NOT ACCEPT PARTS OVER 50 LBS</span></label></div></div><div ng-if="!vm.theTrip.selectedSystemTripType.supportsLyftAPI"><input type="checkbox" class="checkbox inline margin-bottom" id="agree-tos" name="agreeToTos" ng-model="vm.theTrip.agreedToTos" required="true" validation="required:alt=Please agree to the terms before booking"> <label ng-if="(!vm.bookingRules.termsOfUseCopy || vm.bookingRules.termsOfUseCopy.length == 0)" class="inline text-uppercase" for="agree-tos" ng-bind-html="vm.bookingRules.termsAndConditionsLinkText"></label> <span ng-if="vm.bookingRules.termsOfUseCopy && vm.bookingRules.termsOfUseCopy.length > 0" ng-click="vmSettingsPnl.displayCustomTerms()" class="cursor-pointer inline text-uppercase" for="agree-tos" ng-bind-html="vm.bookingRules.termsAndConditionsLinkText"></span></div><div ng-if="vm.theTrip.selectedSystemTripType.supportsLyftAPI"><div ng-if="vm.bookingRules.lyftTermsLink"><label><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="agreeToTermsLyft" ng-model="vm.theTrip.agreedToTermsLyft" required="" validation="required"> <span ng-if="vm.bookingRules.lyftTermsText" ng-bind-html="vm.bookingRules.lyftTermsLink" ng-click="vm.showTerms($event, vm.bookingRules.lyftTermsText)"></span> <span ng-if="!vm.bookingRules.lyftTermsText" ng-bind-html="vm.bookingRules.lyftTermsLink"></span></label></div><div ng-if="vm.bookingRules.uberTermsLink"><label><input type="checkbox" class="checkbox checkbox-inline payment-checkbox" name="agreeToTermsUber" ng-model="vm.theTrip.agreedToTermsUber" required="" validation="required"> <span ng-if="vm.bookingRules.uberTermsText" ng-bind-html="vm.bookingRules.uberTermsLink" ng-click="vm.showTerms($event, vm.bookingRules.uberTermsText)"></span> <span ng-if="!vm.bookingRules.uberTermsText" ng-bind-html="vm.bookingRules.uberTermsLink"></span></label></div></div></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/add-new-settings.view.html','<div ng-if="vm.productGroupsConfigured"><uib-accordion-heading><div class="display-flex flex-row flex-xs-column full-width-height"><div class="flex-grow override-trip-margin-right-sm"><h4 class="panel-title settings-title display-flex flex-row align-items-center content-center"><div class="flex-grow flex-percent-50 flex-sm-percent-75 align-bottom padding-bottom-md override-sm-padding-none"><span class="hidden-sm hidden-xs" ng-hide="vm.theTrip.tripOptId != null">SETTINGS</span> <span class="small-accordion-header visible-xs visible-sm" ng-if="vmSettingsPnl.displayNewRecordHeader()">NEW RECORD</span> <span class="small-accordion-header text-uppercase visible-xs visible-sm" ng-if="vmSettingsPnl.displaySelectedVehicle() && vm.bookingRules.isGeneric == false">{{ vm.theTrip.dealerTripTypeInstance.vehicle.year + \' \' + vm.theTrip.dealerTripTypeInstance.vehicle.make + \' \' + vm.theTrip.dealerTripTypeInstance.vehicle.model }}</span> <span class="small-accordion-header text-uppercase visible-xs visible-sm" ng-if="vm.serviceOrder.id && !vmSettingsPnl.displaySelectedVehicle()"><span class="ng-hide" ng-show="vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.pickup || vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.recalls">APPT</span> <span class="ng-hide" ng-show="vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftShuttleService || vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.dropoff || (vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.mobileGarage && (vm.serviceOrder.roNumber !== NULL))">RO#: {{ vm.serviceOrder.roNumber}}</span> <span class="ng-hide" ng-show="vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.pickup || vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.recalls">: {{ vm.serviceOrder.appointmentDateTime | date: \'EEE, MMM d\'}} at {{ vm.serviceOrder.appointmentDateTime | date: \'hh:mm a\'}}</span></span></div><div class="flex-grow flex-percent-50 flex-sm-percent-25 content-center align-bottom"><div class="selected-accordion-location"><div class="small-accordion-header padding-top-sm inline-block ellipsis-overflow padding-right-sm small-accordion-header text-uppercase hidden-sm hidden-xs" ng-if="vmSettingsPnl.displayNewRecordHeader()">NEW RECORD</div><div class="small-accordion-header text-uppercase padding-top-sm inline-block ellipsis-overflow padding-right-sm small-accordion-header text-uppercase hidden-sm hidden-xs" ng-if="vmSettingsPnl.displaySelectedVehicle() && vm.bookingRules.isGeneric == false">{{ vm.theTrip.dealerTripTypeInstance.vehicle.year + \' \' + vm.theTrip.dealerTripTypeInstance.vehicle.make + \' \' + vm.theTrip.dealerTripTypeInstance.vehicle.model }}</div><div class="padding-top-sm inline-block ellipsis-overflow padding-right-sm small-accordion-header text-uppercase hidden-sm hidden-xs" ng-if="vm.serviceOrder.id && !vmSettingsPnl.displaySelectedVehicle()"><span class="ng-hide" ng-show="vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.pickup || vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.recalls">APPT</span><div class="ng-hide" ng-show="vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.lyftShuttleService || vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.dropoff || (vm.theTrip.selectedSystemTripType.id === vm.shortSystemTripType.mobileGarage && (vm.serviceOrder.roNumber !== NULL))">RO#: {{ vm.serviceOrder.roNumber}}</div><span class="ng-hide" ng-show="vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.pickup || vm.theTrip.selectedSystemTripType.id == vm.shortSystemTripType.recalls">: {{ vm.serviceOrder.appointmentDateTime | date: \'EEE, MMM d\'}} at {{ vm.serviceOrder.appointmentDateTime | date: \'hh:mm a\'}}</span></div><div class="accordion-clear-step ng-hide link pull-right" ng-show="!vm.resolvedTrip && vm.theTrip.dealerLocation.dmsEnabled == true && !vm.isLoading()" ng-if="vmSettingsPnl.displayNewRecordHeader()" ng-click="vmSettingsPnl.clearNewServiceOrder()"><i class="material-icons md-16">edit</i></div><div class="accordion-clear-step ng-hide link pull-right" ng-show="!vm.resolvedTrip && !vm.isLoading()" ng-if="vmSettingsPnl.displaySelectedVehicle()" ng-click="vmSettingsPnl.clearModelSelectedDealerTripTypeInstance()"><i class="material-icons md-16">edit</i></div><div class="accordion-clear-step ng-hide link pull-right" ng-show="!vm.resolvedTrip && !vm.isLoading()" ng-if="vm.serviceOrder.id" ng-click="vmSettingsPnl.clearNewServiceOrder()"><i class="material-icons md-16">edit</i></div></div></div></h4><div id="showhide-map" class="theme-link text-uppercase ng-hide visible-xs-block display-flex align-items-center justify-content" ng-show="vmSettingsPnl.displayMap()" ng-click="vmSettingsPnl.toggleMobileMap()"><span ng-show="vmSettingsPnl.mobileMapVisible">Hide</span><span ng-show="!vmSettingsPnl.mobileMapVisible">Show</span> Map</div></div></div></uib-accordion-heading><div class="row" ng-if="vm.theTrip.selectedSystemTripType == null && vm.theTrip.selectedProductGroup && vm.theTrip.selectedProductGroup.systemTripTypes.length > 1 && (vm.theTrip.selectedProductGroup.supportsDMSSearch == false || (vm.theTrip.selectedProductGroup.supportsDMSSearch == true && (vm.selectedSearchServiceOrder != null || vm.productGroupSelectedRONewServiceOrder == true) ))"><div class="col-xs-4"><select ng-disabled="{{vm.resolvedTrip}}" class="form-control" id="productGroupSelectionDropdown" name="productGroupSelectionDropdown" allow-null-option="{{vm.theTrip.selectedProductGroup.placeholderText}}" ng-model="vm.theTrip.selectedSystemTripType" ng-options="type as type.name for type in vm.theTrip.selectedProductGroup.systemTripTypes track by type.id" ng-change="vmSettingsPnl.productGroupTripTypeSelected(vm.theTrip.selectedSystemTripType)"></select></div></div><div class="row" ng-class="{\'show-map\': vmSettingsPnl.mobileMapVisible, \'hide-map\': !vmSettingsPnl.mobileMapVisible}"><div class="col-xs-12 margin-bottom-md override-xs-padding-top-md padding-left-none padding-right-sm"><div id="trip-map-addedit" map-resize=""><div id="trip-map-addedit-map" driver-tracking="" options="vm.mapOptions" map-loaded="vm.mapLoaded" dealer="vm.theTrip.dealerLocation"></div></div></div></div><div class="row ng-hide padding-left-none tab-loading-overlay margin-top" ng-show="vm.isLoading()"><div class="col-xs-12 margin-top"><div class="centered-content loading-container text-center margin-top"><img src="assets/images/ajax-loader.gif"><div>Loading...<br><br><br><br></div></div></div></div><div class="row"><div class="col-xs-12" ng-if="vm.theTrip.apiErrors || vm.theTrip.errors"><div class="inline-error-box form-group" ng-if="vm.theTrip.apiErrors"><b>ERROR SAVING.</b> {{vm.theTrip.apiErrors}}</div><div class="inline-error-box form-group" ng-if="(vm.theTrip.errors && vm.theTrip.errors.length) && !vm.showRideProviderMessage"><div class="margin-bottom"><b>THIS TRIP BREAKS THE FOLLOWING BOOKING RULES. <span ng-if="(vmSettingsPnl.isAdminLevelUser === true || vm.bookingRules.enableBypassBookingRules === true) && vm.userHasOverrideRuleRole">CHECK TO CONFIRM.</span></b></div><ul class="text-left api-error-ul"><li ng-repeat="error in vm.theTrip.errors"><input ng-if="(vmSettingsPnl.isAdminLevelUser === true || vm.bookingRules.enableBypassBookingRules === true) && error.allowOverride && vm.userHasOverrideRuleRole" type="checkbox" name="checkbox_{{error.code}}" id="checkbox_{{error.code}}" ng-model="error.isChecked" class="checkbox inline" ng-change="vmSettingsPnl.updateErrorCheckbox(error)" checklist-value="error.code"> <label for="checkbox_{{error.code}}">{{error.message | sentenceCase}}</label></li></ul></div></div><div ng-if="(!vm.theTrip.selectedSystemTripType.requiresGroupSelection) && vm.theTrip.selectedSystemTripType.requiresVehicleSelection === true" class="col-sm-6 col-xs-12 ng-hide booking-insert" ng-show="!vm.theTrip.vehicleModelId"><div ng-if="!vm.tripWizard.recall" class="form-group margin-none"><div class="row padding-md padding-top-none"><div class="ng-hide col-xs-11 padding-right-none override-xs-padding-top-md field-wrapper" ng-show="!vm.theTrip.dealerTripTypeInstance"><label for="dealertriptype-vehicle">SELECT A MODEL</label><select class="form-control" id="dealertriptype-vehicle" name="dealertriptype-vehicle" selectlabel="" ng-model="vm.testDriveTempDTT" ng-change="vmSettingsPnl.dealerTripTypeInstanceModelSelected(dtt)"><option value="">Select a model...</option><option ng-repeat="dtt in vm.theTrip.selectedSystemTripType.dealerTripTypes" value="{{dtt.id}}" ng-selected="dtt.vehicle.id == vm.theTrip.vehicleModelId">{{ dtt.vehicle.year + \' \' + dtt.vehicle.make + \' \' + dtt.vehicle.model }}</option></select></div></div></div></div><div class="col-xs-12 form-group included-form booking-insert" ng-if="vm.displayIntegratedSearch() || vm.showTestTripCheckbox() || vm.theTrip.selectedSystemTripType.supportsLoanerVehicle || vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.mobileGarage"><div id="trip-select2-row" class="row"><div class="col-xs-11" ng-show="vm.displayROSearch()" ng-class="{ \'col-sm-3\': (vm.displayROSearch() === true && vm.displayAllLoanerFields() === true) || vm.theTrip.selectedSystemTripType.id !== vmSettingsPnl.tripTypes.pickup, \'col-sm-4\': vm.displayROSearch() === false || (!vm.displayAllLoanerFields() && vm.theTrip.selectedSystemTripType.id !== vmSettingsPnl.tripTypes.mobileGarage) }"><div class="row"><div id="roselect-container" class="col-xs-12 col-sm-11 form-group"><select name="roselect" id="roselect" multiple="" ui-select2="vmSettingsPnl.repairOrderSearchOptions" ng-model="item.dealerServiceOrderId" class="select2-single form-control"></select><div class="ng-hide clear-disabled-roselect" ng-show="vm.serviceOrder" ng-click="vmSettingsPnl.clearSelectedRO()"><i class="material-icons">highlight_off</i></div></div></div></div><div class="col-sm-3 col-xs-12 ng-hide override-xs-margin-top-md" ng-if="vm.bookingRules.disableVehicleVIN == false && vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.mobileGarage" ng-show="vm.displayBookItPanel()"><input type="text" id="vehicle_vin" name="vehicle_vin" ng-model="vm.serviceOrder.vehicleInfo.vin" validation="min_len:17|required:alt=Required" class="form-control better-placeholder" clean="true" placeholder="VIN" required="" minlength="17" maxlength="17"></div><div ng-class="{ \'col-sm-3\': (vm.displayROSearch() === true && vm.displayAllLoanerFields() === true) || vm.theTrip.selectedSystemTripType.id !== vmSettingsPnl.tripTypes.pickup, \'col-sm-4\': vm.displayROSearch() === false || !vm.displayAllLoanerFields(), \'col-xs-11\': true, \'padding-right-none\': true}" ng-if="vm.theTrip.selectedSystemTripType.supportsLoanerVehicle" class="ng-hide" ng-show="!vm.isLoading() && vm.theTrip.showTripSettingsForm == true"><div id="loaner-requirements" ng-hide="vm.theTrip.tripOptId != null"><div ng-disabled="{{vm.resolvedTrip}}" class="col-xs-12 form-group override-xs-padding-top-md field-wrapper" ng-if="vm.theTrip.selectedSystemTripType.requiresGroupSelection === true"><label for="recall">SELECT A SERVICE</label><select required="" ng-disabled="{{vm.resolvedTrip}}" class="form-control" selectlabel="" id="recall" name="recall" ng-model="vm.tripWizard.recall" ng-options="l as l.description for l in vm.theTrip.dealerTripTypeInstance.recalls"><option value="">Select a service...</option></select></div><div class="col-xs-12 form-group override-xs-padding-top-md field-wrapper" ng-if="vm.theTrip.selectedSystemTripType.requiresGroupSelection === true"><label for="recall-vehicle">SELECT A MODEL</label><select selectlabel="" required="" class="form-control" id="recall-vehicle" name="recall-vehicle" allow-null-option="Select a model..." ng-model="vm.tripWizard.vehicle" ng-options="m as m.description for m in vm.tripWizard.recall.models" ng-change="vmSettingsPnl.recallModelSelected()"></select></div><div class="col-xs-12 form-group override-xs-margin-top-md field-wrapper" ng-if="vm.theTrip.tripOptions && vm.theTrip.tripOptions.length"><label for="dealertriptype-tripoptions">{{vm.theTrip.selectedSystemTripType.placeHolders.loanerPlaceHolder}}</label><select class="form-control no-transform" selectlabel="" required="" id="dealertriptype-tripoptions" name="dealertriptype-tripoptions" validation="required:alt=Required" allow-null-option="{{vm.theTrip.selectedSystemTripType.placeHolders.loanerPlaceHolder}}" ng-options="option as option.text for option in vm.theTrip.tripOptions track by option.tripWorkFlowId" ng-model="vm.theTrip.selectedTripOption" ng-change="vmSettingsPnl.tripOptionSelected()"></select></div></div></div><div ng-class="{ \'col-sm-3\': (vm.displayROSearch() === true && vm.displayAllLoanerFields() === true) || vm.theTrip.selectedSystemTripType.id !== vmSettingsPnl.tripTypes.pickup, \'col-sm-4\': vm.displayROSearch() === false || !vm.displayAllLoanerFields() }" ng-if="vm.hasLoanerPermission === true && vm.theTrip.selectedTripOption && vm.theTrip.selectedTripOption.hasLoaner === \'yes\' && vmSettingsPnl.loanerTripTypes.includes(vm.theTrip.selectedSystemTripType.id) && vmSettingsPnl.displayContractLoaner"><div id="loaner-contract-selection"><div class="col-xs-12 override-xs-padding-top-md form-group padding-left-none padding-right-none fake-required-select2"><select name="loaner-contract-select" id="loaner-contract-select" ng-required="vm.hasLoanerPermission === true && vm.theTrip.selectedTripOption && vm.theTrip.selectedTripOption.hasLoaner === \'yes\' && vmSettingsPnl.loanerTripTypes.includes(vm.theTrip.selectedSystemTripType.id)" multiple="" ui-select2="vmSettingsPnl.loanerContractSearchOptions" required="" validation="required:alt=Required" validation-error-to="loanerContractError" ng-model-options="{ debounce: 250 }" ng-model="item.externalReservationId" class="select2-single form-control"></select><span id="loanerContractError" class="validation text-danger"></span><div class="ng-hide clear-disabled-roselect" ng-show="vm.serviceOrder.selectedLoanerContract" ng-click="vmSettingsPnl.clearSelectedLoanerContract()"><i class="material-icons">highlight_off</i></div></div></div></div><div class="col-sm-2 col-xs-12 col-lg-1 override-xs-padding-top-md" ng-if="vm.hasLoanerPermission === true && vm.theTrip.selectedTripOption && vm.theTrip.selectedTripOption.hasLoaner === \'yes\' && vm.theTrip.selectedSystemTripType.id === vmSettingsPnl.tripTypes.pickup"><div id="loaner-contract-length-container"><div class="col-xs-12 form-group padding-left-none padding-right-none"><input name="loaner-contract-length" type="number" min="1" id="loaner-contract-length" required="required" ng-model="vm.theTrip.lengthOfLoan" class="form-control better-placeholder no-spinners" placeholder="EST DAYS" validation="required:alt=Required"></div></div></div><div class="col-xs-12 col-sm-2 pull-right" ng-if="vm.showTestTripCheckbox()" ng-class="{\'margin-bottom\': vm.theTrip.selectedSystemTripType.supportsLyftAPI}"><div class="form-group inline margin-none pull-right" ng-class="{\'lyft-trip\': vm.theTrip.selectedSystemTripType.supportsLyftAPI}"><span class="display-flex content-center margin-top-sm"><input type="checkbox" class="checkbox margin-none" id="testTrip" ng-model="vm.theTrip.testTrip"> <label class="padding-left-sm margin-bottom-none margin-right-md" for="testTrip">Test Trip</label></span></div></div></div></div><div class="col-xs-12 included-form ng-hide" ng-show="((vm.theTrip.showTripSettingsForm == true && vm.loanerCriteriaSelected() == true) || vm.theTrip.selectedSystemTripType.id === 10) && !vm.isLoading()" id="new-trip-top-row"><div class="row"><div class="col-xs-12 col-sm-10 margin-top-md actions-row" ng-if="!vm.resolvedTrip && vm.theTrip.selectedSystemTripType.supportsInvites && (!vm.theTrip.selectedTripOption.hideSmsInvite || !vm.theTrip.selectedSystemTripType.supportsLyftAPI) && !vm.isFramedIn() && vmSettingsPnl.customerCanEditTrips() !== false"><div class="display-flex flex-row full-width"><div class="form-group inline padding-md booking-action flex-width-120"><span class="display-flex content-center"><input type="radio" class="checkbox margin-none" ng-model="vm.serviceOrder.action" ng-change="vm.serviceOrderActionUpdated()" ng-value="1"><label class="padding-left-sm margin-none">I\'ll book it</label></span></div><div ng-if="!vm.theTrip.selectedTripOption.hideSmsInvite" class="form-group inline padding-md booking-action flex-width-120"><span class="display-flex content-center"><input type="radio" class="checkbox margin-none" ng-model="vm.serviceOrder.action" ng-change="vm.serviceOrderActionUpdated()" ng-value="2"><label class="padding-left-sm margin-none">Send SMS</label></span></div><div id="invite-expires" ng-if="!vm.theTrip.selectedTripOption.hideSmsInvite && vm.theTrip.selectedSystemTripType.supportsLyftAPI && vm.lyftInviteExpirationHours > 0" class="form-group inline padding-md booking-action col-sm-4 col-xs-12 text-danger">Note invite expires in {{ vm.lyftInviteExpirationHours }} hours</div><div ng-if="!vm.theTrip.selectedSystemTripType.supportsLyftAPI" class="form-group inline padding-md booking-action flex-width-120"><span class="display-flex content-center"><input type="radio" class="checkbox margin-none" ng-model="vm.serviceOrder.action" ng-change="vm.serviceOrderActionUpdated()" ng-value="3"><label class="padding-left-sm margin-none">Send email</label></span></div></div></div><div ng-class="!vm.resolvedTrip && vm.theTrip.selectedSystemTripType.supportsInvites ? col-xs-3 : col-xs-12" class="pull-right ng-hide form-inline margin-top-md actions-row" ng-show="vm.displayThisIsABusiness()"><span class="display-flex content-center"><input type="checkbox" class="checkbox margin-none" ng-model="vm.serviceOrder.customerInfo.isBusiness" value="true" id="isBusiness"><label class="font-normal padding-left-sm margin-none">This is a business</label></span></div></div></div><div class="col-xs-12 booking-insert padding-left-none tab-loading-overlay" ng-if="vm.theTrip.selectedSystemTripType.id == 10 && (vm.loadingNewServiceOrder == true || vm.loadingBookingRules == true)"><div class="centered-content loading-container text-center"><img src="assets/images/ajax-loader.gif"><div>Loading ...<br><br><br><br></div></div></div><div class="col-xs-12 included-form adjust-top" ng-if="vm.loanerCriteriaSelected() == true && vm.displayBookItPanel() && vm.theTrip.showTripSettingsForm == true && vm.theTrip.preventBooking != true" ng-include="" src="\'app/areas/trip/views/partials/add-new-settings-book-it.view.html\'"></div><div class="col-xs-12 included-form adjust-top" ng-if="vm.loanerCriteriaSelected() == true && vm.displayEmailSMSPanel() && vm.theTrip.showTripSettingsForm == true" ng-include="" src="\'app/areas/trip/views/partials/add-new-settings-send-smsemail.view.html\'"></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-audit.view.html','<div class="row tab-section"><div class="col-sm-12 padding-md"><div><span class="black"><b>BOOKED BY</b></span> <span ng-if="vm.trip.created"><span ng-if="vm.trip.created.firstName">{{ vm.trip.created.firstName }} {{ vm.trip.created.lastName }}</span> <span ng-if="!vm.trip.created.firstName">{{::vm.trip.bookingSource }}</span> ON {{ vm.localCreatedDate | date: "MMMM dd \'at\' h:mma"}} <span ng-if="vm.getRODisplayText(vm.trip)" ng-bind-html="vm.getRODisplayText(vm.trip)"></span></span></div></div></div><div class="row tab-section" ng-if="vm.trip.updated && vm.trip.updated.id"><div class="col-sm-12 padding-md"><div><span class="black"><b>LAST MODIFIED&nbsp;</b><span ng-if="vm.trip.updated">BY {{ vm.trip.updated.firstName }} {{ vm.trip.updated.lastName }} ON {{ vm.localUpdateDate | date: "MMMM dd \'at\' h:mma"}}</span></span></div></div></div><div class="row tab-section" ng-if="vm.trip.cancelled && (vm.trip.cancelled.id || vm.trip.cancelReason)"><div class="col-sm-12 padding-md"><div><span class="text-danger"><b>CANCELED BY</b><span ng-if="vm.trip.cancelled"><span ng-if="vm.trip.cancelled.lastName">&nbsp;{{ vm.trip.cancelled.firstName }} {{ vm.trip.cancelled.lastName }} /</span><span ng-if="!vm.trip.cancelled.lastName">&nbsp;CUSTOMER /</span> REASON: {{ vm.trip.cancelReason }} <span ng-if="vm.localCanceledDate">ON {{ vm.localCanceledDate | date: "MMMM dd \'at\' h:mma"}}</span></span></span></div></div></div><div class="row tab-section" ng-if="(vm.trip.dispatchSystemType == vm.dispatchSystemTypes.silentDispatch && vm.trip.tripId && !vm.trip.providerRideId) || vm.trip.providerRideId || (vm.tripChildren && vm.tripChildren.length > 0)"><div class="col-sm-12 padding-md"><div ng-if="vm.trip.dispatchSystemType == vm.dispatchSystemTypes.silentDispatch && vm.trip.tripId && !vm.trip.providerRideId"><span class="black"><b>SILENT DISPATCH ID</b></span> {{vm.trip.tripId}}</div><div ng-if="vm.trip.providerRideId" class="text-normal-case"><span class="black"><b>{{vm.providerName}} RIDE ID</b></span> {{vm.trip.providerRideId}}</div><div ng-if="vm.tripChildren" ng-repeat="c in vm.tripChildren"><span ng-if="c.systemTripTypeId == 19" class="black"><b>PROVIDER DRIVER RETURN ID</b> <a class="theme-link" ui-sref="trip-tab-trip({tripId: c.id})" ui-sref-opts="{reload: true}">{{c.id}}</a></span></div></div></div><div class="row tab-section" ng-if="vm.trip.parentTripId"><div class="col-sm-12 padding-md"><span class="black"><b>SERVICE EXPERIENCE TRIP ID</b> <a class="theme-link" ui-sref="trip-tab-trip({tripId: vm.trip.parentTripId})" ui-sref-opts="{reload: true}">{{vm.trip.parentTripId}}</a></span></div></div><div class="row tab-section"><div class="col-xs-11 padding-md padding-right-none"><div ng-if="vm.isMobileGarage() === false" class="col-sm-4 col-xs-4 padding-none"><span class="black text-uppercase"><b>Mileage</b></span> <span ng-if="vm.workflow.actualTotalDistance"><span ng-if="vm.workflow.actualTotalDistance != null">{{ vm.workflow.actualTotalDistance.value | number:2 }} {{ vm.workflow.actualTotalDistance.type }},</span> <span ng-if="vm.workflow.actualTotalDistance == null">N/A,</span></span> PLANNED <span ng-if="vm.workflow.plannedTotalDistance != null">{{ vm.workflow.plannedTotalDistance.value | number:2 }} {{ vm.workflow.plannedTotalDistance.type }}</span> <span ng-if="vm.workflow.plannedTotalDistance == null">N/A</span></div><div class="col-sm-4 col-xs-4 padding-none"><span class="black"><b>TIME</b></span> <span ng-if="vm.actualTotalSeconds != 0 && vm.isMobileGarage() === false">{{ vm.actualTotalSeconds | duration }},</span> PLANNED {{ vm.plannedTotalSeconds | duration}}</div><div ng-if="vm.isMobileGarage() === false" class="col-sm-4 col-xs-4 padding-none"><span ng-if="vm.workflow.tripStartTime && !vm.workflow.tripEndTime">{{ vm.workflow.tripStartTime | date: "MMM dd At hh:mma" }} <b class="black">TO</b> Pending</span> <span ng-if="vm.workflow.tripStartTime && vm.workflow.tripEndTime">{{ vm.workflow.tripStartTime | date: "MMM dd At hh:mma" }} <b class="black">TO</b> {{ vm.workflow.tripEndTime | date: "MMM dd At hh:mma" }}</span></div></div><div class="col-xs-1 padding-md text-right"><div><i class="material-icons md-24 cursor-pointer" ng-if="!vm.showTimeDetails" ng-click="vm.showTimeDetailDiv()">expand_more</i> <i class="material-icons md-24 cursor-pointer" ng-if="vm.showTimeDetails" ng-click="vm.hideTimeDetailDiv()">expand_less</i></div></div></div><div class="row tab-section gray ng-hide" ng-show="vm.showTimeDetails"><div class="col-sm-4 col-xs-4 padding-md"><div><span class="black"><b>STEP</b></span></div></div><div class="col-sm-4 col-xs-4 padding-md pull-right"><div class="pull-right text-left full-width"><span class="black"><b>ACTUAL</b></span></div></div><div class="col-sm-4 col-xs-4 padding-md pull-right"><div class="pull-right text-left full-width"><span class="black"><b>PLANNED</b></span></div></div></div><div ng-show="vm.showTimeDetails"><div ng-repeat="step in vm.workflow.segments" class="row tab-section sub"><div class="col-sm-4 col-xs-4 padding-md"><div>{{ step.stateName }}</div></div><div class="col-sm-4 col-xs-4 padding-md pull-right"><div class="pull-right text-left full-width"><span ng-if="step.actual">{{ step.actual | date: "MMM dd At hh:mma" }}</span> <span ng-if="!step.actual && vm.workflow.tripManuallyCompleted" class="text-danger">NA</span> <span ng-if="step.actualMinutes !== null && step.actualMinutes >= 0">FOR {{ (step.actualMinutes * 60) | duration }}</span></div></div><div class="col-sm-4 col-xs-4 padding-md pull-right"><div class="pull-right text-left full-width">{{ step.planned | date: "MMM dd At hh:mma" }} <span ng-if="step.plannedMinutes !== null && step.plannedMinutes > 0">FOR {{ (step.plannedMinutes * 60) | duration }}</span></div></div></div><div class="row tab-section sub margin-bottom"><div class="col-sm-4 col-xs-4 padding-md"><div>TOTAL</div></div><div class="col-sm-4 col-xs-4 padding-md pull-right"><div class="pull-right text-left full-width"><span ng-if="vm.actualTotalSeconds != 0">{{ vm.actualTotalSeconds | duration }}</span></div></div><div class="col-sm-4 col-xs-4 padding-md pull-right"><div class="pull-right text-left full-width"><span ng-if="vm.plannedTotalSeconds != 0">{{ vm.plannedTotalSeconds | duration }}</span></div></div></div><div ng-if="vm.workflow.tripManuallyCompleted" class="text-danger font-bold text-uppercase margin-bottom"><i class="material-icons align-text-bottom m-s-r">warning</i> Trip Manually Completed By {{ vm.workflow.manuallyCompletedBy }}</div></div><div class="row tab-section" ng-if="vm.showBilling && vm.isMobileGarage() === false"><div class="col-xs-11 padding-md"><div class="col-sm-4 col-xs-4 padding-none"><span class="black"><b>TOTAL DEALER CHARGES</b></span></div><div class="col-sm-1 col-xs-1 padding-none"><span ng-if="!vm.billingPending">{{vm.calculateTotal(true) | currency }}</span> <span ng-if="vm.billingPending">PENDING</span></div><div class="col-sm-1 col-xs-1 padding-none"></div><div class="col-sm-3 col-xs-3" ng-if="!vm.trip.isLyftTrip"><span class="black"><b>TOTAL DRIVER PAY</b></span></div><div class="col-sm-1 col-xs-1 padding-none"><span ng-if="!vm.billingPending">{{vm.calculateTotal(false) | currency }}</span> <span ng-if="vm.billingPending">PENDING</span></div><div class="col-sm-2 col-xs-2 padding-none"></div></div><div class="col-xs-1 padding-md text-right" ng-if="vm.showMoreBilling && !vm.trip.isLyftTrip"><div><i class="material-icons md-24 cursor-pointer" ng-if="!vm.chargesVisible" ng-click="vm.chargesVisible = true">expand_more</i> <i class="material-icons md-24 cursor-pointer" ng-if="vm.chargesVisible" ng-click="vm.chargesVisible = false">expand_less</i></div></div></div><div ng-if="vm.chargesVisible"><div ng-if="vm.billingPending && !vm.trip.isLyftTrip"><div class="manual-complete-warning"><div class="float-left"><i class="material-icons">warning</i></div><div class="float-left"><div class="margin-bottom-30 text-danger">The trip must be completed before pay and charges can be calculated and edited. Use the fields below if you need to override DriverQ and manually complete a trip.</div></div></div><form name="completeTripForm" autocomplete="off" role="form" novalidate=""><div class="text-uppercase"><div class="row form-group"><div class="col-sm-12 margin-bottom search-italic">Times are in: <strong>{{ vm.trip.dealerTimeZone }}</strong> timezone</div><div class="col-sm-12 col-xs-12"><div class="row"><div class="col-sm-3 col-xs-3"><label for="startDate">Trip Start</label> <input name="startDate" type="date" id="start-date" ng-change="vm.calculateBillingTime()" class="form-control text-uppercase" ng-model="vm.billingTime.startDate" required="required"></div><div class="col-sm-3 col-xs-3"><div class="space-20"></div><input name="startTime" type="time" id="start-time" ng-change="vm.calculateBillingTime()" class="form-control text-uppercase" ng-model="vm.billingTime.startDate" required="required"></div><div class="col-sm-3 col-xs-3"><label>Trip Complete</label> <input name="endDate" type="date" id="end-date" ng-change="vm.calculateBillingTime()" class="form-control text-uppercase" ng-model="vm.billingTime.endDate" required="required"></div><div class="col-sm-3 col-xs-3"><div class="space-20"></div><input name="endTime" type="time" id="end-time" ng-change="vm.calculateBillingTime()" step="60" class="form-control text-uppercase" ng-model="vm.billingTime.endDate" required="required"></div></div></div></div><div class="row form-group"><div class="col-sm-3"><strong>Total Time</strong> {{ vm.billingTime.totalDuration | duration }}</div><div class="col-sm-3"><strong>Dealer Charge</strong> {{ vm.billingTime.customerChargeAmount | currency }}</div><div class="col-sm-3"><strong>Driver Pay</strong> {{ vm.billingTime.driverPayAmount | currency }}</div></div><div class="row form-group margin-bottom"><div class="col-sm-12 col-xs-12"><label for="comment">Comments</label> <input name="comment" placeholder="Enter comments" type="text" ng-model="vm.billingTime.comment" class="form-control" required="required" validation="required"></div></div></div><div class="row margin-bottom form-footer"><div class="col-xs-6 validation-message"><span ng-if="!vm.calculatingBilling && vm.validationMsg" class="text-danger text-uppercase">{{ vm.validationMsg }}</span> <span ng-if="vm.calculatingBilling"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-xs-6 text-right"><button type="button" ng-click="vm.showManualForm = false" class="btn">Cancel</button> <button type="submit" class="btn btn-primary" ng-click="vm.completeTrip()" ng-disabled="completeTripForm.$invalid || vm.validationMsg" ladda="vm.processingBilling">Complete Trip</button></div></div></form></div><div ng-if="!vm.billingPending"><div class="row tab-section"><div class="col-xs-11 padding-md"><div class="col-sm-4 col-xs-4 padding-none"><a ng-if="!vm.trip.isLyftTrip" ng-click="vm.editTripTime(vm.trip.chargeSummary.calculatedCharge)">Trip Time</a> <span ng-if="vm.trip.isLyftTrip">Trip Time</span></div><div class="col-sm-1 col-xs-1 padding-none">{{vm.trip.chargeSummary.calculatedCharge.customerCharge.amount | currency}}</div><div class="col-sm-4 col-xs-4"></div><div class="col-sm-1 col-xs-1 padding-none"><span ng-if="vm.trip.chargeSummary.calculatedCharge.driverPay">{{vm.trip.chargeSummary.calculatedCharge.driverPay.amount | currency}}</span></div></div></div><div ng-repeat="charge in vm.trip.chargeSummary.manualCharges" class="row tab-section"><div class="col-xs-11 padding-md"><div class="col-sm-4 col-xs-4 padding-none"><a ng-if="::vm.canEditCharge(charge)" ng-click="vm.editCharge(charge)">{{charge.customerCharge ? charge.customerCharge.chargeTypeDescription : charge.driverPay.chargeTypeDescription }}</a> <span ng-if="::!vm.canEditCharge(charge)">{{charge.customerCharge ? charge.customerCharge.chargeTypeDescription : charge.driverPay.chargeTypeDescription}}</span></div><div class="col-sm-1 col-xs-1 padding-none">{{charge.customerCharge.amount | currency}}</div><div class="col-sm-4 col-xs-4"></div><div class="col-sm-1 col-xs-1 padding-none">{{charge.driverPay.amount | currency}}</div></div></div><div ng-if="!vm.trip.isLyftTrip" class="row tab-section"><div class="col-xs-12 padding-md"><div class="col-sm-12 col-xs-12 padding-none"><div class="pull-right override-xs-side-padding-none"><button id="add-charge" class="btn btn-default margin-left-md" ng-click="vm.addCharge()">+</button></div></div></div></div><div class="margin-top-20 hidden-xs"><div class="panel panel-default"><div class="panel-heading panel-body"><div class="col-xs-10 padding-left-none">HISTORY</div><div class="col-xs-1">CHARGE</div><div class="col-xs-1 text-right">PAY</div></div><div ng-repeat="charge in vm.trip.chargeSummary.billingHistoryItems track by charge.id" class="panel-body border-bottom"><div class="col-xs-2 padding-left-none">{{ charge.dateCreated | date }}</div><div class="col-xs-2 padding-left-none">{{ charge.createdBy.firstName}} {{ charge.createdBy.lastName }}</div><div class="col-xs-3 padding-left-none">Item {{ charge.actionType.toLowerCase() === \'delete\' ? \'Deleted\' : charge.actionType + \'ed\'}} - {{ charge.comment }}</div><div class="col-xs-3 padding-left-none padding-right-none"><div ng-if="charge.chargeType === 1">Trip Time ({{ charge.tripDurationAfter | duration }})</div><div ng-if="charge.chargeType !== 1 && charge.chargeType !== 12">{{ charge.chargeTypeDescription }}</div><div ng-if="charge.chargeType === 12">{{ charge.chargeTypeDescription }} ({{ vm.trip.driverPayIncentive.incentiveType === 1 ? \'Flat Rate\' : \'Percentage\' }})</div></div><div class="col-xs-1 text-right">{{ charge.customerChargeAmount | currency }}</div><div class="col-xs-1 text-right">{{ charge.driverPayAmount | currency }}</div></div></div></div></div></div><div class="row tab-section" ng-if="vm.trip.proofOfDeliveryImage"><div class="col-xs-11 padding-top-md"><div class="col-sm-4 col-xs-4 padding-none"><span class="black"><b>PROOF OF DELIVERY</b></span></div></div></div><div class="grid-item" ng-if="vm.trip.proofOfDeliveryImage"><div class="small-grey-boxes padding-top-sm padding-bottom-md position-relative"><img class="image-container position-relative" ng-src="{{ vm.trip.proofOfDeliveryImage }}" ng-click="vm.openImageModal(vm.trip.proofOfDeliveryImage)" alt="Proof of Delivery"></div></div><div ng-if="vm.trip.taskResponses" class="row tab-section"><div class="row" ng-if="vm.trip.taskResponses.vehicleResponses.length > 0" ng-repeat="vehicleResponse in vm.trip.taskResponses.vehicleResponses"><div class="col-sm-12 padding-md"><div class="padding-top-none padding-bottom-none padding-left-15 padding-right-15"><span class="black"><b>{{vehicleResponse.vehicleTypeDesc}}</b></span> <span>#{{vehicleResponse.vin}} -</span> <span ng-if="vehicleResponse.year != \'\' || vehicleResponse.model != \'\' || vehicleResponse.make != \'\'">{{ vehicleResponse.year}} {{ vehicleResponse.make }} {{ vehicleResponse.model }}</span> <span ng-if="vehicleResponse.year == \'\' && vehicleResponse.model == \'\' && vehicleResponse.make == \'\'">Unknown</span> <span ng-if="!vehicleResponse.manuallyEntered"><span><i class="material-icons md-14 text-success">check_circle</i></span> SCANNED</span> <span ng-if="vehicleResponse.manuallyEntered"><span><i class="material-icons md-14 text-danger">error</i></span> MANUAL ENTRY</span></div></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-help.view.html','<div class="display-flex tab-section sub"><div class="text-uppercase margin-bottom"><span class="black"><b>SUBMIT</b></span> A SUPPORT TICKET FOR THIS TRIP. You will receive an email confirmation from our support team along with updates as your support ticket progresses. You may reply to the email at any time.</div></div><div class="display-flex tab-section ng-hide" ng-show="vm.submitTicket && !vm.sentSuccessfully"><form role="form" name="submitHelpTicket" id="submitHelpTicket" class="full-width validation-relative form" ng-submit="vm.submitTicket(submitHelpTicket.$valid)" novalidate=""><div class="full-width block relative field-wrapper margin-bottom margin-top-sm"><label for="helpticket_type">ISSUE TYPE</label><select selectlabel="" required="" class="form-control no-transform" id="helpticket_type" name="helpticket_type" ng-model="vm.helpTicket.type" validation="required"><option value="">Issue type</option><option ng-repeat="type in vm.issueTypes" value="{{type}}">{{ type }}</option></select></div><div class="full-width block relative margin-bottom-sm" ng-if="vm.isLostItemTicket()"><b><i>Did you know you can call the driver about lost items? Click <span class="theme-link" ng-click="vm.showContactDriverHelp()"><u>here</u></span> to see how.</i></b></div><div class="full-width block relative"><textarea required="" id="helpticket_description" name="helpticket_desscription" class="form-control better-placeholder resize-none" ng-model="vm.helpTicket.description" placeholder="{{vm.getIssueDescription()}}" validation="required"></textarea></div><div class="full-width block relative padding-top-md"><button type="submit" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.submittingHelpTicket">SUBMIT</button>&nbsp;</div></form></div><div class="display-flex tab-section ng-hide border-none" ng-show="vm.sentSuccessfully"><div class="full-width block relative padding-top-md">Thank you. Your help ticket has been submitted.</div></div>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-log.view.html','<div class="btn-group icon-tabs" id="trip-list-state-buttons"><button class="btn btn-white" type="button" ng-class="{\'btn-default\' : (vm.showAudits === true)}" ng-click="vm.setSelectedButton(true)"><i class="material-icons padding-right-none" title="TRIPS">list</i></button> <button class="btn btn-white" type="button" ng-class="{\'btn-default\' : (vm.showAudits !== true)}" ng-click="vm.setSelectedButton(false)"><i class="material-icons padding-right-none" title="DISPATCH">groups</i></button></div><div ng-if="vm.showAudits" class="table-responsive overflow-visible"><table class="table table-hover"><thead class="hidden-xs"><tr><th>Date/Time</th><th>Event</th><th>User</th><th>Details</th></tr></thead><tbody><tr ng-repeat="logRow in vm.tripAudits"><td class="hidden-xs">{{logRow.dateCreated | localDate }}</td><td class="hidden-xs">{{logRow.actionName}}</td><td class="hidden-xs">{{logRow.createdBy}}</td><td class="hidden-xs">{{logRow.detail}}</td><td class="visible-xs whitespace-normal"><b>Date/Time:</b> {{logRow.dateCreated | localDate }}<br><b>Event:</b> {{logRow.actionName}}<br><b>User:</b> {{logRow.createdBy}}<br><b>Details:</b> {{logRow.detail}}</td></tr></tbody></table></div><div ng-if="!vm.showAudits" class="table-responsive overflow-visible"><table class="table table-hover"><thead class="hidden-xs"><tr><th>Received Offer</th><th>Driver Name</th><th>Driver Username</th><th>Status</th><th class="text-center">Pay</th></tr></thead><tbody><tr ng-repeat="dispatchRow in vm.tripDispatches"><td class="hidden-xs">{{dispatchRow.availableAfter | localDate }}</td><td class="hidden-xs">{{dispatchRow.driverName}}</td><td class="hidden-xs">{{dispatchRow.driverUsername}}</td><td class="hidden-xs">{{dispatchRow.statusName}}</td><td class="hidden-xs text-right">{{dispatchRow.driverPay | currency }}</td><td class="visible-xs whitespace-normal"><b>Received Offer:</b> {{dispatchRow.availableAfter | localDate }}<br><b>Driver Name:</b> {{dispatchRow.driverName}}<br><b>Driver Username:</b> {{dispatchRow.driverUsername}}<br><b>Status:</b> {{dispatchRow.statusName}}<br><b>Pay:</b> {{dispatchRow.driverPay | currency }}<br></td></tr></tbody></table></div>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-ratings.view.html','<br><div class="margin-bottom"><div class="row"><div class="col-sm-10"><div class="section-sub-title"><b>WHAT DID THE CUSTOMER SAY?</b></div><div class="margin-bottom text-uppercase border-bottom padding-sm padding-left-none"><b>{{ vm.resolvedTrip.customerName }}</b></div><div ng-if="vm.resolvedSurveys[0].surveyExists && vm.resolvedSurveys[0].questions.length > 0" class="row padding-sm padding-left-none" ng-repeat="q in vm.resolvedSurveys[0].questions | orderBy: q.sortOrder"><div class="col-sm-6 text-uppercase"><b>{{q.question}}</b></div><div class="col-sm-6 text-uppercase"><b>{{ q.responseText || q.ResponseValue}}</b></div></div><div class="text-uppercase" ng-if="vm.resolvedSurveys[0].surveyExists && vm.resolvedSurveys[0].questions.length == 0"><b>This customer has not submitted a survey yet.</b></div><div class="text-uppercase" ng-if="!vm.resolvedSurveys[0].surveyExists"><b>No survey configured. Please contact you system administrator.</b></div></div></div></div><br><div ng-if="vm.resolvedDriver" class="margin-bottom"><div class="row"><div class="col-sm-2"><img class="driver-photo" ng-src="{{ vm.resolvedTrip.driver.driverPhoto }}"></div><div class="col-sm-10"><div class="section-sub-title"><b>WHAT DID THE DRIVER SAY?</b></div><div class="margin-bottom text-uppercase border-bottom padding-sm padding-left-none"><b>{{ vm.resolvedTrip.driver.name }}</b></div><div ng-if="vm.resolvedSurveys[1].surveyExists && vm.resolvedSurveys[1].questions.length > 0" class="row padding-sm padding-left-none" ng-repeat="q in vm.resolvedSurveys[1].questions | orderBy: q.sortOrder"><div class="col-sm-6 text-uppercase"><b>{{q.question}}</b></div><div class="col-sm-6 text-uppercase"><b>{{ q.responseText || q.ResponseValue}}</b></div></div><div class="text-uppercase" ng-if="vm.resolvedSurveys[1].surveyExists && vm.resolvedSurveys[1].questions.length === 0"><b>This driver has not submitted a survey yet.</b></div><div class="text-uppercase" ng-if="!vm.resolvedSurveys[1].surveyExists"><b>No survey configured. Please contact you system administrator.</b></div></div></div></div><div class="tab-section padding-md padding-left-none border-top" ng-if="vm.resolvedDriver && !vm.resolvedDriver.isDedicated"><div class="row padding-md"><div class="col-sm-6"><span class="black"><b>SET THE STATUS</b></span> FOR THIS DRIVER</div><div class="col-sm-6"><ul class="list-inline pull-right driver-ranking-list"><li><div class="cursor-pointer ng-hide driver-ranking-status" ng-class="{\'active\':vm.resolvedDriver.isAllowed == true}" ng-show="!vm.updatingDriverStatus" ng-click="vm.favoriteDriver()">FAVORITE</div></li><li><div class="cursor-pointer ng-hide driver-ranking-status" ng-class="{\'active\':vm.resolvedDriver.isAllowed == false && vm.resolvedDriver.isRestricted == false }" ng-show="!vm.updatingDriverStatus" ng-click="vm.standardizeDriver()">STANDARD</div></li><li><div class="cursor-pointer ng-hide driver-ranking-status" ng-class="{\'active\':vm.resolvedDriver.isRestricted == true}" ng-show="!vm.updatingDriverStatus" ng-click="vm.blacklistDriver()">BLACKLIST</div></li></ul></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-summary.view.html','<div class="full-height flex-fill"><div ng-if="vm.supportsSandboxAdvance && vm.trip.isTestTrip && vm.selectedSystemTripType.supportsLyftAPI" class="row hidden-xs"><div class="row"><div class="col-xs-8 padding-md"><b>PROVIDER RIDE OPTIONS</b> &nbsp;&nbsp;<span class="cursor-pointer theme-link" ng-if="!vm.showProviderRideSandboxOptions" ng-click="vm.showProviderRideSandboxOptionsDiv()">SHOW</span> <span class="cursor-pointer theme-link" ng-if="vm.showProviderRideSandboxOptions" ng-click="vm.showProviderRideSandboxOptionsDiv()">HIDE</span></div></div><div class="row gray ng-hide lyft-ride-options" ng-show="vm.showProviderRideSandboxOptions"><div class="col-xs-12 padding-md"><div class="col-xs-3"><button type="button" class="lyft-ride test-button" ng-click="vm.advanceProviderRide(\'accepted\')"><h4>Accepted</h4></button></div><div class="col-xs-3"><button type="button" class="lyft-ride test-button" ng-click="vm.advanceProviderRide(\'arrived\')"><h4>Arrived</h4></button></div><div class="col-xs-3"><button type="button" class="lyft-ride test-button" ng-click="vm.advanceProviderRide(\'pickedUp\')"><h4>Picked Up</h4></button></div><div class="col-xs-3"><button type="button" class="lyft-ride test-button" ng-click="vm.advanceProviderRide(\'arrivedDropoff\')"><h4>Dropped Off</h4></button><br><br><button type="button" class="lyft-ride test-button" ng-click="vm.advanceProviderRide(\'failed\')"><h4>Canceled</h4></button></div></div></div></div><div class="row padding-none margin-top-md"><div ng-if="vm.zenIncomplete" class="text-danger">Compiling final route data. Please check again shortly.</div><div id="trip-map-summary" class="col-xl-12 position-relative" driver-tracking="" options="vm.mapOptions" map-loaded="vm.mapLoaded" ui-ready="vm.uiReady"></div></div><div id="driver-summary" class="row tab-section min-height-px-250"><div id="trip-circles-row" class="col-md-5 col-sm-5 margin-top override-xs-padding-top-md col-xs-12 col-sm-push-7"><div class="row text-right pull-right"><div class="col-xs-12 padding-none pull-right text-right"><div><div class="trip-list trip-circle-container text-right pull-right"><trip-circles stops="vm.trip.stops" current-step="vm.trip.currentStep" state="vm.trip.state" trip-type="vm.trip.systemTripTypeId"></trip-circles></div></div></div></div></div><div id="driver-info-row" class="col-md-6 col-sm-6 col-xs-12 margin-top col-sm-pull-5"><div class="row padding-left-none"><div class="col-xs-3 padding-left-none padding-right-none driver-photo-col"><div class="spinner spinner-absolute afkl-lazy-bg-img" afkl-lazy-image="{{ vm.trip.driver.driverPhoto }}" afkl-lazy-image-options="{ background: true}" lazy-load-fail="assets/images/user-square.png"></div></div><div class="col-xs-5 col-sm-5 col-md-8 padding-left-none"><div ng-class="{ \'col-xs-12 col-md-6\': !vm.changeDriver, \'col-md-12\': vm.changeDriver, \'padding-left-none\':true }"><div ng-if="!vm.canEditDriver() && vm.trip.driver.id" class="text-nowrap"><driver-name class="text-nowrap" driver="vm.trip.driver"></driver-name></div><div ng-if="!vm.canEditDriver() && !vm.trip.driver.id">Dispatching</div><div ng-if="vm.canEditDriver() && vm.trip.driver.id" ng-show="!vm.changeDriver" ng-hide="vm.changeDriver == true" ng-click="vm.changeDriverClick()"><driver-name driver="vm.trip.driver" name-class="theme-link"></driver-name></div><div class="theme-link" ng-if="vm.canEditDriver() && !vm.trip.driver.id" ng-show="!vm.changeDriver" ng-hide="vm.changeDriver == true" ng-click="vm.changeDriverClick()">Dispatching</div><div class="ng-hide chosen-single-line field-wrapper" ng-if="!vm.trip.providerRideId" ng-show="vm.changeDriver == true && vm.activeDrivers && !vm.savingDriver"><label for="assigned_driver">DRIVER</label><select id="assigned_driver" name="assigned_driver" class="form-control has-label" chosen="{width: \'100%\'}" max-shown-results="100" allow-null-option="Best available" ng-change="vm.driverSelectionModified(vm.trip.driver, vm.originalDriver)" ng-init="vm.originalDriver=vm.trip.driver" ng-model="vm.trip.driver" ng-options="driver as vm.formatDriverDropDown(driver, vm.trip.driver) disable when driver.id == -999 for driver in vm.activeDrivers track by driver.userName"></select></div><div ng-if="vm.trip.driver.id && !vm.trip.providerRideId && !vm.trip.isComplete">{{vm.trip.driver.mobilePhone|tel}}</div><div ng-if="vm.trip.driver.id && vm.trip.providerRideId && !vm.trip.isComplete"><div ng-if="vm.trip.driver.pinBasedPhone"><div>{{vm.trip.driver.pinBasedPhone|tel}}</div><div ng-if="vm.trip.driver.pinBasedPhonePin">PIN: {{vm.trip.driver.pinBasedPhonePin}}</div></div><div ng-if="!vm.trip.driver.pinBasedPhone">{{vm.trip.driver.mobilePhone|tel}}</div></div><div ng-if="vm.showDriverContactLink()" class="theme-link" ng-click="vm.showPhoneCapture()">Contact Driver</div><div ng-if="vm.trip.lyftVehicle"><div>{{vm.trip.lyftVehicle.make}} {{ vm.trip.lyftVehicle.model }}</div><div ng-if="vm.trip.systemTripTypeId !== vm.shortSystemTripType.partsOnDemand">{{ vm.trip.lyftVehicle.color }}<span ng-if="vm.trip.lyftVehicle.licensePlate">| {{ vm.trip.lyftVehicle.licensePlate }}</span></div><div ng-if="vm.trip.systemTripTypeId === vm.shortSystemTripType.partsOnDemand && vm.trip.packageSize">PKG SIZE: {{ vm.trip.packageSize }}</div></div><div class="row ng-hide summary-links" ng-show="vm.savingDriver || (vm.changeDriver == true && !vm.activeDrivers && vm.retrievingDrivers)"><div class="col-xs-12 padding-right-none margin-top-sm"><div class="ng-hide" ng-show="vm.savingDriver"><img src="assets/images/ajax-loader.gif" class="ng-hide inline" ng-show="vm.savingDriver"><div class="inline">SAVING DRIVER ...</div></div><div class="ng-hide" ng-show="vm.changeDriver == true && !vm.activeDrivers && vm.retrievingDrivers"><img src="assets/images/ajax-loader.gif" class="ng-hide inline" ng-show="vm.retrievingDrivers"><div class="inline">LOADING <span ng-if="vm.trip.systemTripTypeId !== vm.shortSystemTripType.mobileGarage">DRIVERS</span><span ng-if="vm.trip.systemTripTypeId === vm.shortSystemTripType.mobileGarage">MOBILE TECHS</span> ...</div></div></div></div></div><div class="col-xs-12 col-md-6 padding-left-none"><div id="summary-startearly" class="col-xs-12 padding-none text-nowrap sumary-text" ng-if="!vm.changeDriver && (!vm.selectedSystemTripType.supportsLyftAPI && (!vm.bookingRules.defaultCanAccessEarly || !vm.trip.canAccessEarly))"><input type="checkbox" class="checkbox" ng-disabled="vm.trip.isInProgress||vm.trip.isComplete || vm.isTripCancelled()" ng-model="vm.trip.canAccessEarly" ng-change="vm.canAccessEarlyChanged()" value="true" id="canAccessEarly"> <span>Allow Early Start</span> <i class="material-icons md-18" uib-popover="Check this box to allow driver to start trip more than 90 minutes before first stop. Inform driver to refresh their trip after checking." popover-placement="bottom" popover-append-to-body="true" popover-trigger="mouseenter">info_outline</i><div id="updating-container" ng-if="vm.updatingCanAccessEarly"><img src="assets/images/ajax-loader.gif"> Saving</div><div ng-if="vm.tripUpdated === true" class="text-danger font-normal">Trip Updated</div></div></div></div><div id="car-photo" class="col-xs-3 padding-left-none driver-photo-col"><div class="vehicle-photo spinner spinner-absolute" afkl-lazy-image="{{ ::vm.trip.lyftVehicle.imageUrl }}" lazy-load-fail="assets/images/user-square.png"></div></div></div></div><div id="driver-incentive-row" class="col-xs-12 driver-incentive" ng-if="vm.canSeeIncentive"><div id="incentive-label" ng-class="{ \'theme-link\' : !vm.incentiveDisabled, \'disabled read-only\': vm.incentiveDisabled}" ng-if="!vm.settingDriverIncentive && !(vm.incentiveDisabled && !vm.trip.driverPayIncentive.amount)" ng-disabled="vm.incentiveDisabled" ng-click="vm.settingDriverIncentive = true">INCENTIVE <span ng-if="vm.trip.driverPayIncentive.incentiveType == 1 && vm.trip.driverPayIncentive.amount > 0">${{vm.trip.driverPayIncentive.amount || \'0.00\'}}</span> <span ng-if="vm.trip.driverPayIncentive.incentiveType == 2 && vm.trip.driverPayIncentive.amount > 0">{{vm.trip.driverPayIncentive.amount || \'0\'}}%</span></div><form ng-if="vm.settingDriverIncentive" role="form" id="incentiveForm" name="incentiveForm" class="form-horizontal" ng-submit="vm.saveDriverIncentive()"><div class="row"><div class="col-xs-4 col-sm-4 col-md-2 first-col field-wrapper"><select id="incentiveType" name="incentiveType" class="form-control" ng-model="vm.trip.driverPayIncentive.incentiveType" required="" ng-change="vm.trip.driverPayIncentive.amount = null" validation="required"><option value="">Type</option><option value="1">Flat Rate</option><option value="2">Percentage</option></select></div><div class="col-xs-5 col-sm-4 col-md-3 first-col"><input type="text" id="driver-incentive" min="0.00" step=".01" name="driverPayIncentive" ng-model="vm.trip.driverPayIncentive.amount" class="form-control text-uppercase better-placeholder" placeholder="AMOUNT" required="" validation="required|custom:vm.notSame():alt=The incentive amount must be different from the previous amount" validation-error-to="#incentive-same-error" mask-restrict="reject" mask="9?9?9?9?9?9?9?9?9.99" ng-disabled="vm.savingDriverIncentive || (vm.trip.driverPayIncentive && !vm.trip.driverPayIncentive.incentiveType)"><div id="incentive-same-error" class="text-danger validation"></div><small ng-if="vm.trip.driverPayIncentive && vm.trip.driverPayIncentive.incentiveType" class="margin-top-md">{{vm.trip.driverPayIncentive.incentiveType == 1 ? \'In dollars ($)\' : \'As a percentage (%)\'}}</small></div><div ng-if="!vm.savingDriverIncentive" class="col-sm-12 col-xs-12 col-md-4 second-col padding-left-none"><button type="submit" class="btn btn-default" ng-disabled="vm.savingDriverIncentive || !incentiveForm.$valid">OK</button> <button type="button" class="btn btn-default" ng-click="vm.cancelSetIncentive()" ng-disabled="vm.savingDriverIncentive">CANCEL</button></div><div ng-if="vm.savingDriverIncentive" class="col-sm-4"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> SAVING</span></div></div></form></div></div><div class="row tab-section padding-left-none override-sm-padding-left-15" ng-if="vm.trip.customerDescriptionOfProblem && vm.trip.customerDescriptionOfProblem.length > 0"><div class="col-xs-12 padding-left-none"><span class="title">SERVICE NEEDS:<br></span><div ng-text-truncate="vm.trip.customerDescriptionOfProblem" ng-tt-chars-threshold="210" class="font-normal"></div></div></div><div class="row tab-section padding-left-none" ng-if="vm.trip.tripNote && vm.trip.tripNote.length > 0"><div class="col-xs-12 padding-left-none"><span class="title">DRIVER NOTE:<br></span> <span class="font-normal">{{vm.trip.tripNote}}</span></div></div></div>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-tasks.view.html','<uib-accordion close-others="false" id="summary-tab-accordion"><div uib-accordion-group="" ng-if="vm.workflowGroupedTasks" class="section-default" ng-repeat="segment in vm.workflowGroupedTasks" is-open="segment.isOpen" panel-class="section"><uib-accordion-heading><div class="section-title padding-left-sm"><i class="inline pull-left material-icons material-icons-large" ng-if="segment.isOpen">expand_less</i> <i class="inline pull-left material-icons material-icons-large" ng-if="!segment.isOpen">expand_more</i> {{segment.friendlyState}}<div ng-if="!segment.wasSkipped" class="pull-right font-normal font-size-11 text-uppercase"><span ng-if="segment.startedDateTime && !segment.finishedDateTime">Started at</span> <span ng-if="segment.startedDateTime">{{segment.startedDateTime | localDate:\'MMM DD [At] h:mm A\'}}</span> <span ng-if="segment.startedDateTime && segment.finishedDateTime">to</span> <span ng-if="!segment.startedDateTime && segment.finishedDateTime">Completed at</span> <span ng-if="segment.finishedDateTime">{{segment.finishedDateTime | localDate:\'MMM DD [At] h:mm A\'}}</span> <span ng-if="segment.startedDateTime && segment.finishedDateTime">for {{vm.calculateDuration(segment) | duration}}</span> <span>({{vm.countMedia(segment)}} photos/videos)</span></div><div ng-if="segment.wasSkipped" class="pull-right font-normal font-size-11 text-uppercase"><span>Skipped</span></div></div></uib-accordion-heading><div><div class="row margin-bottom-md" ng-if="segment.tasks" ng-repeat="task in segment.tasks | orderBy: \'sortOrder\'"><div class="col-xs-1 padding-right-none trip-summary-checkbox"><i class="material-icons md-18" ng-if="segment.finishedDateTime && !segment.wasSkipped">check_box</i> <i class="material-icons md-18" ng-if="!segment.finishedDateTime || segment.wasSkipped">check_box_outline_blank</i></div><div class="col-xs-11 trip-summary-question-offset"><div class="trip-summary-title padding-bottom-none text-uppercase margin-bottom-sm"><b>{{task.heading}}</b></div><div class="trip-summary-title text-uppercase margin-bottom-md">{{task.response}}<div class="margin-top" ng-if="vm.workflowTaskTypes.vinScan === task.taskType && task.driverResponse && task.driverResponse.vehicle && task.driverResponse.vehicle.vin"><b>VIN:&nbsp;</b> {{task.driverResponse.vehicle.vin}}</div></div><rc-trip-summary-photos task="task"></rc-trip-summary-photos><rc-trip-summary-tasks task="task"></rc-trip-summary-tasks><rc-trip-summary-vehicle task="task"></rc-trip-summary-vehicle></div></div></div></div></uib-accordion>');
$templateCache.put('app/areas/trip/views/partials/trip-tab-vehicles.view.html','<div ng-if="vm.workflowGroupedVehicles.length" class="row padding-md" ng-repeat="segment in vm.workflowGroupedVehicles"><div class="col-xs-12"><div class="section-title border-bottom text-uppercase"><b>{{ segment.description }}</b></div><div class="row" ng-if="segment.vehicles" ng-repeat="vehicle in segment.vehicles"><div class="col-xs-12"><div class="section-sub-title padding-md padding-bottom-none text-uppercase"><b>{{ vehicle.description }}</b></div><div class="row padding-md"><div ng-if="vehicle.vin" class="col-sm-4 text-uppercase"><b>VIN</b></div><div class="col-sm-8">{{ vehicle.vin }}</div></div><div ng-if="vehicle.mileage" class="row padding-md"><div class="col-sm-4 text-uppercase"><b>Mileage</b></div><div class="col-sm-8">{{ vehicle.mileage | number }}</div></div><div ng-if="vehicle.fuel || vehicle.fuel === 0" class="row padding-md"><div class="col-sm-4 text-uppercase"><b>Fuel</b></div><div class="col-sm-2"><range-display value="{{ vehicle.fuel }}"></range-display></div></div><div ng-if="vehicle.customerCredentialsVerified" class="row padding-md"><div class="col-sm-4 text-uppercase"><b>Customer Credentials</b></div><div class="col-sm-8 text-uppercase">{{ vehicle.customerCredentialsVerified ? \'Verified\' : \'Unverified\' }}</div></div><div ng-if="vehicle.media.length" class="row padding-md"><div class="col-sm-12 text-uppercase"><b>Vehicle Exterior</b></div></div><div ng-if="vehicle.media.length"><div class="col-xs-12"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vehicle.media" class="text-center"><div ng-if="media.path"><img ng-if="media.type === vm.mediaTypes.photo" ng-click="vm.openMedia(media)" ng-src="{{ media.path }}"><div ng-if="media.type === vm.mediaTypes.video" ng-click="vm.openMedia(media)"><span class="material-icons video-icon">videocam</span></div><div class="text-uppercase text-center">{{ media.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div><div ng-if="!media.path"><span class="material-icons pending-icon">pending</span><div class="text-uppercase text-center">{{ media.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div></li></ul></div></div><div ng-if="vehicle.issueMedia.length" class="row padding-md"><div class="col-sm-12 text-uppercase"><b>Damage and Issues</b></div></div><div ng-if="vehicle.issueMedia.length"><div class="col-xs-12"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vehicle.issueMedia" class="text-center"><div ng-if="media.path"><img ng-if="media.type === vm.mediaTypes.photo" ng-click="vm.openMedia(media)" ng-src="{{ media.path }}"><div ng-if="media.type === vm.mediaTypes.video" ng-click="vm.openMedia(media)"><span class="material-icons video-icon">videocam</span></div><div class="text-uppercase text-center">{{ media.dateTaken | localDate:\'MMM D h:mm A\' }}</div><div class="text-center">{{ media.description }}</div></div><div ng-if="!media.path"><span class="material-icons pending-icon">pending</span><div class="text-uppercase text-center">{{ media.dateTaken | localDate:\'MMM D h:mm A\' }}</div><div class="text-center">{{ media.description }}</div></div></li></ul></div></div></div></div><div class="row" ng-if="segment.tasks" ng-repeat="task in segment.tasks"><div class="col-xs-12"><div class="section-sub-title padding-md padding-bottom-none text-uppercase"><b>{{ task.question }}</b></div><div class="padding-md" ng-if="task.media.length"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in task.media" class="text-center"><div ng-if="media.path"><img ng-if="media.type === vm.mediaTypes.photo" ng-click="vm.openMedia(media)" ng-src="{{ media.path }}"><div ng-if="media.type === vm.mediaTypes.video" ng-click="vm.openMedia(media)"><span class="material-icons video-icon">videocam</span></div><div class="text-uppercase text-center">{{ media.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div><div ng-if="!media.path"><div class="text-center">Pending Upload</div><div class="text-uppercase text-center">{{ media.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div></li></ul></div></div></div></div></div><div ng-if="!vm.workflowGroupedVehicles.length" class="row padding-md"><div class="padding-md text-uppercase"><i><b>No vehicle information has been uploaded yet.</b></i></div></div>');
$templateCache.put('app/areas/location/components/inspect/inspection-form-details.view.html','<div class="fade-in"><div><h4>Inspection Form Details</h4><div class="panel-title">Modify details, sections, and inspection tasks below</div><hr></div><form role="form" name="saveInspectionForm" class="form-horizontal text-uppercase" id="inspection-form-detail"><div ng-if="!vm.isLoading"><div class="display-flex"><div class="flex-percent-40"><div class="block relative"><input type="text" class="form-control better-placeholder" name="form.name" placeholder="FORM NAME" ng-model="vm.form.name" required=""></div></div><div class="flex-right display-flex content-center"><div class="margin-right-md"><span class="font-bold">Is Active?</span></div><switch id="is-form-active" name="is-form-active" ng-model="vm.form.isEnabled" class="green small-switch margin-right-20" disabled="vm.form.isDefault"></switch><i ng-if="(vm.form.id && !vm.form.publishedDate) || (vm.form.updatedDate && vm.form.publishedDate && vm.form.updatedDate > vm.form.publishedDate)" class="material-icons md-18 text-warning cursor-pointer margin-right-sm" title="Unpublished changes pending">error</i> <button type="button" ng-disabled="!vm.form.id" ng-click="vm.publishForm()" class="btn btn-default bg-transparent" title="{{!vm.form.id ? \'New forms must be saved before they can be published\' : \'\'}}">Publish</button></div></div><div class="block relative margin-top"><input type="text" class="form-control better-placeholder" name="form.description" placeholder="DESCRIPTION" ng-model="vm.form.description" required=""></div><div class="block margin-top" ng-model="vm.form.sections" ui-sortable="vm.sortableSettings"><div ng-repeat="section in vm.form.sections | orderBy: \'displayOrder\'" class="display-flex flex-wrap content-center padding-md gray-bg margin-bottom-20 border-radius-md border-default"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="margin-left flex-percent-35"><div class="block relative"><input type="text" class="form-control better-placeholder" name="section.name" placeholder="SECTION NAME" ng-model="section.name" required=""></div></div><div class="margin-left-30 flex-grow display-flex content-center">Include if ODO is between<div class="block relative margin-left-md margin-right-md"><input type="text" class="form-control better-placeholder width-px-60" validation="numeric" name="section.odometerMinValue" placeholder="MIN" ng-model="section.odometerMinValue" mask="9?9?9?9?9?9?" mask-restrict="reject"></div>AND<div class="block relative margin-left-md margin-right-md"><input type="text" class="form-control better-placeholder width-px-60" validation="numeric" name="section.odometerMaxValue" placeholder="MAX" ng-model="section.odometerMaxValue"></div>Miles</div><div class="flex-right"><a href="#" class="cursor-pointer text-right margin-right-md" ng-click="vm.showSectionEditFields(section)">Edit</a> <a href="#" class="cursor-pointer text-right" ng-click="vm.deleteSection(section)">Delete</a></div><div ng-show="section.isEditing" class="ng-hide display-flex flex-wrap flex-percent-100 margin-left-lg"><div class="margin-top display-flex flex-percent-100 flex-wrap" ng-model="section.tasks" ui-sortable="vm.sortableSettings"><div ng-repeat="task in section.tasks | orderBy: \'displayOrder\'" class="display-flex flex-percent-100 white-bg padding-md margin-bottom border-radius-md border-default"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="display-flex content-center flex-wrap flex-percent-100"><div class="margin-left flex-percent-45"><div class="block relative"><input type="text" class="form-control better-placeholder" name="task.name" placeholder="TASK NAME" ng-model="task.name" required=""></div></div><div class="flex-right"><a href="#" class="cursor-pointer text-right margin-right-md" ng-click="vm.showTaskEditFields(task)">Edit</a> <a href="#" class="cursor-pointer text-right" ng-click="vm.removeTaskFromSection(task, section)">Delete</a></div><div ng-show="task.isEditing" class="ng-hide display-flex flex-wrap flex-percent-100 margin-left margin-top"><div class="display-flex flex-percent-100 flex-gap-percent-10"><div class="flex-col flex-percent-45 flex-static-size"><div class="display-flex"><div class="flex-grow"><select name="observationSearch{{$parent.$index}}{{$index}}" multiple="" id="observation-search{{$parent.$index}}{{$index}}" ui-select2="vm.observationSearchSettings" ng-model="task.observationSearch" class="select2-single form-control" data-index="{{$parent.$index}}.{{$index}}" data-section-id="{{section.id || section.tempId}}" data-task-id="{{task.id || task.tempId}}"></select></div></div><div class="margin-top"><div ng-model="task.observations" ui-sortable="vm.sortableSettings"><div ng-repeat="observation in task.observations | orderBy: \'displayOrder\'" class="display-flex content-center padding-sm margin-bottom-sm border-radius-sm gray-bg"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="display-flex content-center flex-wrap flex-percent-100"><div class="margin-left-sm font-bold flex-percent-60" title="{{ observation.name }}">{{ observation.name }}</div><div class="flex-right margin-right-md"><a href="#" class="cursor-pointer text-right" ng-click="vm.removeObservationFromTask(task, observation)">Delete</a></div></div></div></div></div></div><div class="flex-col flex-percent-45 flex-static-size"><div class="display-flex"><div class="flex-grow"><select name="recommendationSearch{{$parent.$index}}{{$index}}" multiple="" id="recommendation-search{{$parent.$index}}{{$index}}" ui-select2="vm.recommendationSearchSettings" ng-model="task.recommendationSearch" class="select2-single form-control" data-index="{{$parent.$index}}.{{$index}}" data-section-id="{{section.id || section.tempId}}" data-task-id="{{task.id || task.tempId}}"></select></div></div><div class="margin-top"><div ng-model="task.recommendations" ui-sortable="vm.sortableSettings"><div ng-repeat="recommendation in task.recommendations| orderBy: \'displayOrder\'" class="display-flex content-center padding-sm margin-bottom-sm border-radius-sm gray-bg"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="display-flex content-center flex-wrap flex-percent-100"><div title="{{ recommendation.name }}" class="margin-left-sm font-bold flex-percent-60">{{ recommendation.name }}</div><div class="flex-right margin-right-md"><a href="#" class="cursor-pointer text-right" ng-click="vm.removeRecommendationFromTask(task, recommendation)">Delete</a></div></div></div></div></div></div></div><div class="display-flex flex-wrap flex-percent-100 margin-top-20"><div class="flex-percent-100"><div class="font-bold font-size-16">Measurements</div><hr class="margin-top-sm"></div><div ng-if="task.measurement" class="display-flex flex-percent-100"><div class="flex-col flex-percent-40 flex-static-size"><div ng-model="task.measurement.components" ui-sortable="vm.sortableSettings"><div ng-repeat="measurementComponent in task.measurement.components | orderBy: \'displayOrder\'" class="display-flex content-center padding-sm margin-bottom-sm border-radius-sm gray-bg"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="display-flex content-center flex-wrap flex-percent-100"><div class="margin-left-sm flex-percent-75"><div class="block relative"><input type="text" class="form-control better-placeholder" name="measurement.component" placeholder="COMPONENT" ng-model="measurementComponent.name" required=""></div></div><div class="flex-right margin-right-md"><a href="#" class="cursor-pointer text-right" ng-click="vm.removeComponentFromMeasurement(task, measurementComponent)">Delete</a></div></div></div></div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right" ng-click="vm.addComponentToMeasurement(task)">Add Component</a></div></div><div class="flex-col flex-grow display-flex margin-top-sm padding-left-md padding-right-md"><div class="flex-grow margin-right-sm"><div class="field-wrapper"><label for="measurementInputType">Type</label><select selectlabel="" class="form-control full-width text-uppercase" name="measurementInputType" ng-options="+type.id as type.name for type in vm.measurementInputTypes" ng-model="task.measurement.inputType" ng-change="vm.onMeasurementInputTypeChanged(task)" required=""><option value="">Type</option></select></div></div><div class="flex-grow"><div class="field-wrapper"><label for="measurementUnits">Units</label><select selectlabel="" class="form-control full-width text-uppercase" name="measurementUnits" ng-options="+unit.id as unit.name for unit in vm.measurementUnitTypes" ng-model="task.measurement.unitType" required=""><option value="">Units</option></select></div></div></div><div class="flex-col flex-percent-40 flex-static-size"><div ng-if="task.measurement.inputType === vm.measurementInputTypeEnum.range" ng-model="task.measurement.levels" ui-sortable="vm.sortableSettings"><div ng-repeat="measurementLevel in task.measurement.levels | orderBy: \'displayOrder\'" class="display-flex padding-sm margin-bottom-sm border-radius-sm gray-bg"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="display-flex flex-fill-height flex-percent-100"><div class="margin-left-sm flex-static-size width-60"><div class="block relative"><input type="text" class="form-control better-placeholder" name="measurementLevel.value" placeholder="VALUE" ng-model="measurementLevel.value" required=""></div></div><div class="margin-left-sm"><div class="field-wrapper"><label for="measurementLevelSeverity">Severity</label><select selectlabel="" class="form-control full-width text-uppercase" name="measurementLevelSeverity" ng-options="+severity.id as severity.name for severity in vm.severityTypes" ng-model="measurementLevel.severity" ng-change="vm.onSeverityChanged(measurementLevel)" required=""><option value="">Severity</option></select></div></div><div class="margin-left-sm flex-centered-col flex-static-size width-px-50 btn-{{ (measurementLevel.severity || 10) | mpAnswerTypeCss}}">{{ $index + 1 }}</div><div class="flex-right flex-grow flex-centered-col margin-left-md margin-right-md"><a href="#" class="cursor-pointer flex-right text-right" ng-click="vm.removeLevelFromMeasurement(task, measurementLevel)">Delete</a></div></div></div></div><div ng-if="task.measurement.inputType === vm.measurementInputTypeEnum.range" class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right" ng-click="vm.addLevelToMeasurement(task)">Add Measurement Level</a></div></div></div><div ng-if="!task.measurement"><a href="#" class="cursor-pointer text-right" ng-click="vm.createMeasurementForTask(task)">Add Measurement for Task</a></div></div></div></div></div></div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right" ng-click="vm.addTask(section, $index)">Add New Task</a></div></div></div></div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right" ng-click="vm.addSection()">Add New Section</a></div></div><div ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"> Loading...</div><div class="modal-footer"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.isSaving"><img src="assets/images/ajax-loader.gif"> Saving...</span><event-alert></event-alert><button type="button" class="btn btn-primary" ladda="vm.isSaving" ng-click="vm.saveForm()" ng-disabled="saveInspectionForm.$invalid">Save</button> <button type="button" class="btn btn-default" ng-click="vm.close()">Close</button></div></form></div>');
$templateCache.put('app/areas/location/components/constraint/constraint.component.view.html','<div class="constraints display-flex flex-row flex-sm-column flex-xs-column margin-top-none constraints-container padding-bottom-md border-bottom"><div class="flex-percent-50 flex-sm-percent-50 flex-sm-column flex-xs-column flex-xs-percent-100 constraint-row-left"><div class="display-flex flex-row flex-percent-100 full-height override-sm-text-pull-left override-xs-text-pull-left"><div class="max-width-px-150 flex-percent-40 flex-xs-percent-100 flex-sm-percent-100 flex-grow field-wrapper padding-left-none padding-right-md margin-top-xs" ng-if="$ctrl.definitionType == $ctrl.constraintDefinitionType.transportation || $ctrl.definitionType == $ctrl.constraintDefinitionType.appointment"><label>USERS</label><select selectlabel="" ng-if="$ctrl.initValue.isNew === true" name="recurrence-user-limittype-{{$ctrl.uid}}" class="form-control" ng-model="$ctrl.userLimitType" ng-change="$ctrl.inputChange()" ng-options="limitType.value as limitType.label for limitType in $ctrl.getActiveUserLimitTypes()" validation="custom: $ctrl.validation.valUserLimitType():alt=User Required"><option value="">Users</option></select><select selectlabel="" ng-if="$ctrl.initValue.isNew === false" name="recurrence-user-limittype-{{$ctrl.uid}}" class="form-control" ng-model="$ctrl.userLimitType" ng-change="$ctrl.inputChange()" ng-options="limitType.value as limitType.label for limitType in $ctrl.userLimitTypes" validation="custom: $ctrl.validation.valUserLimitType():alt=User Required"><option value="">Users</option></select></div><div class="flex-percent-50 flex-xs-percent-75 flex-sm-percent-75 flex-grow padding-right-md" ng-if="!$ctrl.isLimitPerHourPerDayConstraint"><input date-range-picker="" class="form-control date-picker" options="$ctrl.datepickerOptions" placeholder="DATE RANGE..." type="text" ng-model="$ctrl.dateRange"></div><div class="flex-percent-50 flex-grow padding-left-none margin-top-md" ng-class="{\'flex-sm-percent-50\': $ctrl.isLimitPerHourPerDayConstraint,\'flex-sm-percent-50\': $ctrl.isLimitPerHourPerDayConstraint, \'flex-sm-percent-25\': !$ctrl.isLimitPerHourPerDayConstraint,\'flex-sm-percent-25\': !$ctrl.isLimitPerHourPerDayConstraint}"><div ng-if="$ctrl.isLimitPerHourPerDayConstraint" class="inline"><label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle"><input type="checkbox" name="recurrence-dow-mon-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatMonday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">M</span></label> <label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle padding-left-md"><input type="checkbox" name="recurrence-dow-tue-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatTuesday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">T</span></label> <label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle padding-left-md"><input type="checkbox" name="recurrence-dow-wed-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatWednesday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">W</span></label> <label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle padding-left-md"><input type="checkbox" name="recurrence-dow-thu-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatThursday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">T</span></label> <label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle padding-left-md"><input type="checkbox" name="recurrence-dow-fri-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatFriday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">F</span></label> <label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle padding-left-md"><input type="checkbox" name="recurrence-dow-sat-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatSaturday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">S</span></label> <label class="hours-checkbox recurrence-dayofweek-checkbox text-uppercase font-normal margin-none align-middle padding-left-md"><input type="checkbox" name="recurrence-dow-sun-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.repeatSunday" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">S</span></label> <input type="hidden" class="pull-left inline" name="recurrence-dow-valid-{{$ctrl.uid}}" ng-model="$ctrl.repeatDayOfWeekValid" validation-error-to="#day-required-{{$ctrl.uid}}" validation="custom: $ctrl.validation.valRepeatDay():alt=Day Required"></div><div class="inline all-day text-nowrap"><label class="hours-checkbox text-uppercase font-normal margin-none align-middle"><input type="checkbox" name="closed-{{$ctrl.uid}}" class="margin-top-none override-margin-bottom-xs align-middle override-margin-right-xs" ng-model="$ctrl.allDay" ng-change="$ctrl.inputChange()"><span class="inline-block padding-top-xs padding-left-xs">All Day</span></label></div><div id="day-required-{{$ctrl.uid}}" class="text-danger validation margin-top-sm"></div></div></div></div><div class="display-flex flex-percent-50 constraint-row-right flex-wrap"><div class="display-flex flex-row flex-percent-100 flex-xs-percent-100 full-height margin-top-xs"><div class="flex-percent-15 flex-xs-percent-15 padding-left-md from-label margin-top-md">FROM</div><div class="max-width-px-110 flex-percent-25 flex-xs-percent-30 padding-left-none field-wrapper"><label>START TIME</label><select selectlabel="" name="recurrence-starttime-{{$ctrl.uid}}" class="form-control" ng-model="$ctrl.startTime" ng-change="$ctrl.inputChange()" ng-options="time.value as time.label for time in $ctrl.hoursInDay" ng-disabled="$ctrl.allDay" validation-error-to="#validation-error-{{$ctrl.uid}}" validation="custom: $ctrl.validation.valConstraintStartEndTime(\'End Time\'):alt=Start/End Time Required"><option value="">Start time</option></select><div class="validation text-danger" id="validation-error-{{$ctrl.uid}}"></div></div><div class="flex-width-30 padding-left-sm padding-right-sm margin-top-md">TO</div><div class="flex-percent-25 flex-xs-percent-30 field-wrapper padding-left-none"><label for="recurrence-endtime">END TIME</label><select selectlabel="" name="recurrence-endtime-{{$ctrl.uid}}" class="form-control" ng-model="$ctrl.endTime" ng-change="$ctrl.inputChange()" ng-options="time.value as time.label for time in $ctrl.hoursInDay | filter: $ctrl.availableEndHours" ng-disabled="$ctrl.allDay" validation-error-to="#validation-error-{{$ctrl.uid}}" validation="custom: $ctrl.validation.valConstraintStartEndTime(\'Start Time\'):alt=Start/End Time Required"><option value="">End time</option></select></div><div class="flex-percent-25 flex-xs-percent-20 padding-left-xs padding-right-xs" ng-if="$ctrl.isLimitPerHourPerDayConstraint"><div class="block relative"><input name="recurrence-limit-{{$ctrl.uid}}" class="form-control no-spinners better-placeholder max-height-px-35" placeholder="COUNT" type="number" ng-model="$ctrl.limit" ng-change="$ctrl.inputChange()" validation="custom: $ctrl.validation.valLimit():alt=Count Required"></div></div><div class="flex-percent-25 flex-xs-percent-20 field-wrapper padding-left-none" ng-if="$ctrl.isLimitPerHourPerDayConstraint"><label>FREQUENCY</label><select selectlabel="" name="recurrence-limittype-{{$ctrl.uid}}" class="form-control" ng-model="$ctrl.limitType" ng-change="$ctrl.inputChange()" ng-options="limitType.value as limitType.label for limitType in $ctrl.limitTypes" validation="custom: $ctrl.validation.valLimitType():alt=Frequency Required"><option value="">Frequency</option></select></div><div class="flex-percent-15 flex-xs-percent-15 padding-left-md" ng-if="!$ctrl.isLimitPerHourPerDayConstraint"><button type="button" class="btn btn-default" ng-class="config.styleClass" ng-click="$ctrl.add()" ng-disabled="!$ctrl.enableAdd">Add</button></div><div class="flex-percent-15 flex-xs-percent-15 margin-top-sm padding-left-none max-width-px-30" ng-if="$ctrl.isLimitPerHourPerDayConstraint"><i class="material-icons theme-link inline md-24" ng-click="$ctrl.remove()">remove</i></div></div></div></div><div class="row margin-bottom-md" ng-if="$ctrl.showRecurrenceOptions"><div class="col-sm-3"><select class="form-control=" name="recurrence-option-{{$ctrl.uid}}" validation="required:alt=Field is Required" ng-options="option as option.text for option in $ctrl.recurrenceOptions" ng-model="$ctrl.selectedRecurrenceOption"></select></div></div>');
$templateCache.put('app/areas/location/components/dms/tekion-settings.view.html','<div ng-if="vm.dmsSystem === vm.tekionDmsSystem"><div class="margin-top-30"><h3 for="fields">Transportation Mapping (DMS)</h3><p>Each Service Suite transportation type must be mapped to a Tekion transportation type.</p><hr></div><div class="row m-t-sm"><div 1="" class="form-group" ng-repeat="dealerTransportationType in vm.dealerTransportationTypes"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline">{{dealerTransportationType.dashboardDescription}}</span></label><div class="col-sm-3 margin-left-md"><select class="form-control" ng-model="dealerTransportationType.dealerDmsTransportationTypeId" ng-options="l.dmsTransportationTypeId as l.name for l in vm.dmsTransportationTypes" required="required"></select></div></div></div></div>');
$templateCache.put('app/areas/location/components/payments/settings.view.html','<div><h3>Payment Settings</h3><p>If this is a Payments integrated dealer, choose the dealer\'s Payment provider and enter their configuration settings.</p><hr><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the dealer\'s payment provider?" popover-trigger="outsideClick">Payment Provider</span></label><div class="col-sm-6"><select class="form-control" name="paymentProvider" ng-change="vm.resetPayments()" ng-model="vm.dmsEntry.paymentProcessor" ng-options="s.value as s.text for s in vm.paymentProcessors"></select></div></div><div ng-if="vm.dmsEntry.paymentProcessor === vm.paymentProcessorsEnum.cenPos"><payment-cenpos-settings ng-model="vm.ngModel"></payment-cenpos-settings></div><div ng-if="vm.dmsEntry.paymentProcessor === vm.paymentProcessorsEnum.cardConnect"><payment-card-connect-settings ng-model="vm.ngModel"></payment-card-connect-settings></div><div ng-if="vm.dmsEntry.paymentProcessor === vm.paymentProcessorsEnum.peri"><payment-peri-settings ng-model="vm.ngModel"></payment-peri-settings></div></div>');
$templateCache.put('app/shared/asides/inspect/partials/add-recommendation.html','<div class="row display-flex full-width-height margin-none border-radius-top-7 padding-none separate-left-aside-panel flex-column overflow-hidden rec-modal"><div class="display-flex flex-row modal-header border-bottom align-items-center" ng-class="{\'flex-xs-column\': vm.task.taskId}"><qr-code url="vm.mediaUploadUrl" container-id="qrcode-{{vm.task.taskId}}" logo-path="{{vm.soleraLogoUrl}}" ng-if="vm.task.taskId && vm.mediaUploadUrl"></qr-code><div ng-if="vm.task.taskId && !vm.mediaUploadUrl" class="display-flex content-center width-px-96 height-px-96"><img src="assets/images/ajax-loader.gif"> LOADING</div><div class="flex-grow ellipsis-overflow text-uppercase margin-left-md padding-left-sm" ng-class="{\'flex-percent-50\': !vm.isAdHoc}"><h3 class="ellipsis-overflow" title="{{vm.task.name || \'ADD RECOMMENDATION\' }}">{{vm.task.name || \'ADD RECOMMENDATION\'}}</h3></div><div class="flex-grow flex-percent-50 display-flex flex-column override-xs-align-items-center" ng-if="!vm.isAdHoc"><div class="btn-group flex-right"><button ng-repeat="answerType in vm.possibleAnswerTypes" ng-click="vm.updateTaskStatus(answerType)" class="text-uppercase btn-75 no-shadow no-border padding-default btn-{{ answerType | mpAnswerTypeCss}} text-uppercase pass-fail-btns" ng-class="{ \'inactive\':vm.task.taskResponse !== answerType, \'font-bold\': vm.task.taskResponse === answerType }">{{ vm.ro.answerTypeMapping[answerType] }}</button></div><div ng-if="inputForm.$dirty && (!vm.task.taskResponse || vm.isTaskInvalid())" class="font-bold text-right text-danger margin-top-xs"><span ng-if="!vm.task.taskResponse">Please select a Task Response</span> <span ng-if="vm.task.taskResponse && vm.isTaskInvalid()">Please choose a value higher than the highest measurement.</span></div></div></div><div id="add-recommendation-content" class="overflow-y-auto overflow-x-hidden padding-none flex-grow flex-percent-90 col-xs-12 bg-white"><form name="inputForm" role="form" class="display-flex flex-column flex-grow overflow-y-auto padding padding-lg" novalidate=""><input ng-if="!vm.isAdHoc" type="hidden" ng-model="vm.task.taskResponse" required=""><div class="flex-row-wrap flex-sm-column"><div class="flex-row-wrap-item flex-percent-50 padding-left-none margin-bottom-md override-sm-padding-none" ng-if="vm.task.inputOptions && vm.task.inputOptions.length" ng-repeat="inputOption in vm.task.inputOptions | orderBy: \'order\'" ng-class="{\'padding-right-20\': !$odd}"><div class="margin-bottom-sm text-bold text-uppercase">{{ inputOption.name }} <span ng-if="inputOption.unitType !== vm.measurementUnitTypes.none">(in {{ inputOption.unitType | mpMeasurementUnitType }})</span></div><div ng-if="vm.task.measurementChoices.length" class="full-width"><div class="btn-group"><button ng-repeat="measurementChoice in vm.task.measurementChoices | orderBy: \'order\'" ng-click="vm.updateTaskMeasurement(inputOption, measurementChoice)" class="text-uppercase no-border padding-default btn-{{ measurementChoice.taskAnswerType.taskAnswerTypeId | mpAnswerTypeCss}}" ng-style="{\'width\': vm.task.measurementButtonWidth}" ng-class="{ \'inactive\': measurementChoice.id !== inputOption.choiceResponseId, \'font-bold\': measurementChoice.id === inputOption.choiceResponseId }">{{ measurementChoice.name }}</button></div></div><div ng-if="!vm.task.measurementChoices.length"><input ng-blur="vm.updateTaskMeasurement(inputOption)" ng-model="inputOption.inputResponse" class="inline-block form-control width-150"> <span class="padding-left-sm">{{ inputOption.unitType | mpMeasurementUnitType }}</span></div></div></div><div ng-repeat="lineItem in vm.task.lineItems track by $index"><uib-accordion><div uib-accordion-group="" panel-class="section" class="border-top section-default" is-open="lineItem.isExpanded"><uib-accordion-heading><div class="display-flex flex-row content-center section-title"><div class="flex-percent-80 flex-sm-percent-75 flex-xs-percent-60 flex-grow" ng-click="vm.expandLineItem($event, lineItem)"><div class="text-uppercase font-bold" ng-click="vm.expandLineItem($event, lineItem)">Issue #{{($index + 1)}}</div></div><div class="flex-percent-10 flex-sm-percent-20 flex-xs-percent-40 text-right padding-left"><i class="material-icons cursor-pointer theme-link md-21 padding-right-none" ng-click="vm.removeLineItem($event, lineItem)" title="Remove Issue">highlight_off</i> <i ng-if="lineItem.isExpanded" class="material-icons md-23 theme-link" title="Close Details" ng-click="vm.expandLineItem($event, lineItem)">expand_less</i> <i ng-if="!lineItem.isExpanded" class="material-icons md-23 theme-link" title="Open Details" ng-click="vm.expandLineItem($event, lineItem)">expand_more</i></div></div></uib-accordion-heading><div class="margin-bottom-md"><div class="margin-bottom-md"><tags-input id="observation_search_{{lineItem.id}}" name="observation_search_{{lineItem.id}}" placeholder="Observation/Concern/Complaint" min-length="3" replace-spaces-with-dashes="false" add-on-space="false" use-strings="true" enable-editing-last-tag="false" key-property="name" display-property="name" ng-model="lineItem.complaints" on-tag-clicked="vm.tagClicked($tag, lineItem, true)" on-tag-removed="vm.onTagRemoved($tag, lineItem, true)" class="editable-tags gray-pills" ng-class="{\'required\': vm.task.taskResponse !== vm.roAnswerTypes.pass && vm.task.taskResponse !== vm.roAnswerTypes.na }" ng-required="vm.task.taskResponse !== vm.roAnswerTypes.pass && vm.task.taskResponse !== vm.roAnswerTypes.na"><auto-complete source="vm.searchObservations($query)" highlight-matched-text="false" display-property="name" debounce-delay="300"></auto-complete></tags-input><span class="text-danger validation" ng-if="vm.task.taskResponse !== vm.roAnswerTypes.pass && (!lineItem.complaints || lineItem.complaints.length === 0) && inputForm[\'observation_search_\' + lineItem.id].$touched">Field is required.</span></div><div class="margin-bottom-md display-flex content-center flex-gap-md" ng-if="lineItem.isEditingComplaint"><div class="block relative flex-percent-50 flex-grow"><input type="text" name="editComplaint_{{lineItem.id}}" class="form-control better-placeholder" ng-model="lineItem.tagContent" placeholder="Edit Complaint" ng-keyup="$event.keyCode === 13 && vm.closeTagEdit(true, lineItem)"></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(true, lineItem)">Save</button></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(false, lineItem)">Cancel</button></div></div><div class="margin-bottom-md"><tags-input id="recommendation_search_{{lineItem.id}}" name="recommendation_search_{{lineItem.id}}" placeholder="Recommendation/Correction" min-length="3" replace-spaces-with-dashes="false" add-on-space="false" use-strings="true" enable-editing-last-tag="true" key-property="name" display-property="name" ng-model="lineItem.corrections" on-tag-clicked="vm.tagClicked($tag, lineItem, false)" on-tag-removed="vm.onTagRemoved($tag, lineItem, false)" class="editable-tags gray-pills" ng-class="{\'required\': vm.task.taskResponse !== vm.roAnswerTypes.pass && vm.task.taskResponse !== vm.roAnswerTypes.na }" ng-required="vm.task.taskResponse !== vm.roAnswerTypes.pass && vm.task.taskResponse !== vm.roAnswerTypes.na"><auto-complete source="vm.searchRecommendations($query)" highlight-matched-text="false" display-property="name" debounce-delay="300"></auto-complete></tags-input><span class="text-danger validation" ng-if="vm.task.taskResponse !== vm.roAnswerTypes.pass && (!lineItem.corrections || lineItem.corrections.length === 0) && inputForm[\'recommendation_search_\' + lineItem.id].$touched">Field is required.</span></div><div class="padding-bottom-md display-flex content-center flex-gap-md" ng-if="lineItem.isEditingCorrection"><div class="block relative flex-percent-50 flex-grow"><input type="text" name="editCorrection_{{lineItem.id}}" class="form-control better-placeholder" ng-model="lineItem.tagContent" placeholder="Edit Correction" ng-keyup="$event.keyCode === 13 && vm.closeTagEdit(true, lineItem)"></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(true, lineItem)">Save</button></div><div><button type="button" class="btn btn-default text-uppercase" ng-click="vm.closeTagEdit(false, lineItem)">Cancel</button></div></div><div class="margin-bottom-md"><div class="block relative"><input id="cause_{{lineItem.id}}" class="form-control better-placeholder" ng-model="lineItem.cause" placeholder="Cause"></div></div><div class="margin-bottom-md"><div class="block relative"><input id="shop-note_{{lineItem.id}}" class="form-control better-placeholder" ng-model="lineItem.shopNote" placeholder="Add Shop Note"></div></div><div class="display-flex flex-gap-md"><div class="flex-percent-15"><ui-select ng-change="vm.severityChanged(lineItem)" ng-model="lineItem.severity" name="severity_{{lineItem.id}}" class="severity-select icon-ui-select fake-required" required=""><ui-select-match placeholder="Severity"><div class="display-flex content-center"><i ng-if="$select.selected.value.cssClass" class="material-icons md-14 {{ $select.selected.value.cssClass}}">{{$select.selected.value.icon}}</i> <span class="severity-value padding-left-sm">{{$select.selected.value.text}}</span></div></ui-select-match><ui-select-choices repeat="item.value.value as (key, item) in vm.lineItemSeverities"><div class="display-flex content-center"><i ng-if="item.value.cssClass" class="material-icons md-14 {{item.value.cssClass}}">{{item.value.icon}}</i> <span ng-if="!item.value.cssClass" class="no-icon"></span> <span ng-bind-html="item.value.text"></span></div></ui-select-choices></ui-select></div><div class="flex-percent-15"><div class="block relative"><input type="number" min="0" id="labor-{{lineItem.id}}" name="labor-{{lineItem.id}}" ng-model="lineItem.laborHours" ng-change="lineItem.isChanged = true; vm.unsavedChanges = true;" placeholder="LABOR HOURS" class="form-control better-placeholder no-spinners" validation="custom:vm.validation.valDecimal(lineItem.laborHours, 1):alt=*"></div></div><div class="flex-percent-70"><inspect-search-op-codes line-item="lineItem" dealer-id="vm.dealerId" disabled="!lineItem" dropdown-parent=".rec-modal"></inspect-search-op-codes></div></div><div class="margin-bottom w-80 h-80 display-flex"><div class="grid-item margin-top"><drag-drop-image ng-model="vm.imageToUpload" class="small-white-boxes ng-show margin-top" use-icon="true" placeholder="Add Photo" repeat-container="lineItem.mediaItems" on-load="vm.uploadLineItemImage" ng-disabled="vm.addingImage" allow-video="true" drop-reference="lineItem.id" large="" loading-text="UPLOADING IMAGE" error-text="" is-version-2="true" hide-btn-text="true" use-small-button="false"></drag-drop-image></div><lineitem-image-display ng-model="lineItem" class="padding-left-none"></lineitem-image-display></div></div></div></uib-accordion></div><div class="text-right margin-top-md border-top padding-top-md"><a class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-click="vm.addLineItem()" ng-show="!(vm.task.taskResponse === vm.roAnswerTypes.pass || vm.task.taskResponse === vm.roAnswerTypes.na)">Add New</a></div></form></div></div><div class="aside-footer display-flex content-center"><div ng-if="vm.savingChanges"><img class="margin-right-sm" src="assets/images/ajax-loader.gif">SAVING</div><div class="flex-right"><button type="button" class="btn btn-default text-uppercase btn-75" ng-click="vm.close()" ng-disabled="vm.savingChanges">CLOSE</button>&nbsp; <button type="button" class="btn btn-primary text-uppercase btn-75" ng-click="vm.save()" ng-disabled="vm.isSaveDisabled()">SAVE</button></div></div>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-formbuilder.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div class="position-relative"><div><h4>Form Builder</h4><div class="panel-title">Create, copy, and edit inspection forms below</div><hr></div><div class="row margin-bottom-md" ng-if="vm.dealersWithInspect && vm.dealersWithInspect.length > 0"><div class="col-sm-4 col-xs-12 padding-right-none"><div class="form-group margin-right-md field-wrapper"><label for="locationSelect">COPY FORMS FROM ANOTHER DEALER</label><select class="form-control" selectlabel="" id="locationSelect" name="locationSelect" ng-model="vm.copyFromDealer" ng-change="vm.copyFromDealerChanged()" ng-options="location.id as location.name for location in vm.dealersWithInspect"><option value="">Copy forms from another dealer</option></select></div></div><div class="col-sm-3 col-xs-12 padding-right-none"><div class="form-group margin-right-md field-wrapper"><label for="formSelect">SELECT FORM TO COPY</label><select class="form-control" allow-null-option="Select form to copy" selectlabel="" ng-disabled="!vm.copyFromDealer" id="formSelect" name="formSelect" ng-model="vm.formToCopy" ng-options="form.id as form.name for form in vm.copyableForms"><option value="">SELECT FORM TO COPY</option></select></div></div><div class="col-sm-1 col-xs-12"><button type="button" class="btn btn-default margin-top-xs" ng-click="vm.copySelectedForms()" ng-disabled="!vm.formToCopy || vm.copyingForms">Copy</button></div><div class="col-xs-1" ng-if="vm.copyingForms"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"></span></div></div><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.saveChanges()" id="task"><div ng-if="!vm.isLoading"><div class="block" ng-model="vm.inspectionForms" ui-sortable="vm.sortableSettings"><div ng-repeat="form in vm.inspectionForms | orderBy: \'displayOrder\'" class="display-flex content-center padding-md gray-bg margin-bottom-20 border-radius-md border-default text-uppercase"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer" ng-class="{\'disabled-link\': vm.isOnlyDealerAdmin}">menu</i></div><div class="margin-left font-bold flex-percent-25">{{ form.name }}</div><div class="margin-left flex-grow"><i ng-if="!form.publishedDate" class="material-icons md-18 text-warning cursor-pointer align-bottom" title="Unpublished changes pending">error</i> <span class="font-bold">Published:</span> {{ form.publishedDate ? (form.publishedDate | date) : \'NA\' }} <span ng-if="form.publishedBy" class="margin-left-md">By {{ form.publishedBy }}</span></div><div class="margin-left flex-percent-15"><span ng-if="form.isDefault">Is Default</span></div><div ng-if="form.publishedBy"><label class="display-flex content-center margin-bottom-none"><input class="margin-right-sm margin-top-none" type="checkbox" name="form-default_{{$index}}" ng-model="form.isDefault" ng-change="vm.updateDefaultForm(form.id)" ng-disabled="vm.isOnlyDealerAdmin"> <span class="font-normal text-uppercase padding-left-sm">DEFAULT</span>&nbsp;</label></div><div class="margin-left"><switch name="form-active_{{$index}}" ng-model="form.isEnabled" class="green small-switch" disabled="form.isDefault || vm.isOnlyDealerAdmin"></switch></div><div class="margin-left"><a href="#" class="cursor-pointer text-right theme-link" ng-class="{\'disabled-link\': vm.isOnlyDealerAdmin}" ng-click="!vm.isOnlyDealerAdmin && vm.loadForm(form.id)">EDIT</a></div><div class="margin-left"><a href="#" class="cursor-pointer text-right theme-link" ng-class="{\'disabled-link\': vm.isOnlyDealerAdmin}" ng-click="!vm.isOnlyDealerAdmin && vm.deleteForm(form.id, $index)">DELETE</a></div></div></div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-class="{\'disabled-link\': vm.isOnlyDealerAdmin}" ng-click="!vm.isOnlyDealerAdmin && vm.addNewInspectionForm()">Add Inspection Form</a></div></div><div ng-if="vm.isLoading"><img src="assets/images/ajax-loader.gif"> Loading...</div></form><inspection-form-details ng-if="vm.currentFormId || vm.isAddingNewForm" dealer-id="vm.dealerId" form-id="vm.currentFormId" display-order="vm.formCount + 1" on-close="vm.closeCurrentForm()" class="full-overlay white-bg"></inspection-form-details></div></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-md"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.saveChanges()" class="btn btn-primary" ladda="vm.isSaving" ng-disabled="inputForm.$invalid || vm.isOnlyDealerAdmin">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-general.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div><h4>General</h4><div class="panel-title">General settings for Inspect</div><hr></div><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.saveChanges()" id="task"><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="Display RO Itemization on customer Authorization" popover-trigger="outsideClick">Itemize Parts, Labor, Taxes, and Fees</span></label><div class="col-sm-8"><switch name="switch_showItemization" ng-model="vm.dealer.displayRoItemization" class="green small-switch"></switch></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.saveChanges()" class="btn btn-primary" ladda="vm.saving" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-laborrates.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.save()" novalidate=""><div><h4>Internal and Warranty Labor Rates</h4><div>Modify settings for Internal and Warranty Rates below</div><hr></div><div class="display-flex flex-wrap gap-10"><div class="relative width-percent-12"><input type="text" class="form-control better-placeholder" name="internal" placeholder="INTERNAL" ng-pattern="vm.decimalRegex" ng-model="vm.laborRateSettings.internalPayRate" validation="custom: vm.validation.valDecimal(vm.laborRateSettings.internalPayRate):alt=Invalid Format" format-currency-with-dollar="" required=""></div><div class="relative width-percent-12"><input type="text" class="form-control better-placeholder" name="warranty" placeholder="WARRANTY" ng-pattern="vm.decimalRegex" ng-model="vm.laborRateSettings.warrantyPayRate" validation="custom: vm.validation.valDecimal(vm.laborRateSettings.warrantyPayRate):alt=Invalid Format" format-currency-with-dollar="" required=""></div></div><div class="margin-top-lg"><h4>Customer Labor Rates</h4><div>Modify settings for Customer Rates below</div><hr></div><div class="display-flex gap-10 align-items-center"><div class="field-wrapper margin-right-md relative width-percent-20"><label for="rate_type">CUSTOMER RATE TYPE</label><select selectlabel="" class="form-control text-uppercase" name="customerRateType" ng-options="type.value as type.label for type in vm.customerRateTypes" ng-model="vm.selectedCustomerRateType" dynamic-placeholder-option="CUSTOMER RATE TYPE" ng-change="vm.confirmRateTypeChange()" ng-required="true"><option value="" disabled="" selected="" hidden=""></option></select></div><div class="relative width-percent-15"><input type="text" class="form-control better-placeholder" name="customerBaseRate" placeholder="BASE CUSTOMER RATE" ng-pattern="vm.decimalRegex" ng-model="vm.laborRateSettings.customerPayRate" ng-if="vm.selectedCustomerRateType === vm.SYSTEM_ENUMS.rateTypes.matrix && !vm.isLoading && !vm.isRateTypeChanging" validation="custom: vm.validation.valDecimal(vm.laborRateSettings.customerPayRate):alt=Invalid Format" format-currency-with-dollar="" required=""></div><div ng-if="vm.selectedCustomerRateType === vm.SYSTEM_ENUMS.rateTypes.matrix"><a href="#" class="cursor-pointer text-uppercase theme-link" ng-click="vm.importMatrixRates()" ng-if="vm.isAdminUser">IMPORT MATRIX(ES)</a></div></div><div class="margin-bottom" ng-if="vm.selectedCustomerRateType === vm.SYSTEM_ENUMS.rateTypes.fixed"><div ng-model="vm.fixedRates" ui-sortable="{ stop: vm.onReorder, handle: \'> .reorder-container\' }"><div class="display-flex flex-wrap gap-10 content-center margin-top-md padding-md gray-bg margin-bottom-20 border-radius-md border-default" ng-repeat="fixedRate in vm.fixedRates track by $index"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="relative width-percent-20"><input type="text" class="form-control better-placeholder" name="fixedRateName" placeholder="NAME" ng-model="fixedRate.name" required=""></div><div class="relative width-percent-12"><input type="text" class="form-control better-placeholder" name="fixedRate{{$index}}" placeholder="RATE" ng-pattern="vm.decimalRegex" ng-model="fixedRate.rate" validation="custom: vm.validation.valDecimal(fixedRate.rate):alt=Invalid Format" format-currency-with-dollar="" required=""></div><div><label class="display-flex content-center margin-bottom-none"><input class="margin-right-sm margin-top-none" type="checkbox" name="isDefault" ng-model="fixedRate.isDefault" ng-change="vm.setLaborRateDefault(fixedRate)" ng-disabled="vm.fixedRates.length === 1"> <span class="font-normal text-uppercase margin-left-sm">DEFAULT</span>&nbsp;</label></div><div class="flex-right"><a href="#" class="theme-link" ng-click="vm.deleteFixedRate(fixedRate, $index)">DELETE</a></div></div></div><div class="text-right"><a href="#" class="cursor-pointer theme-link" ng-click="vm.addFixedRate()">ADD NEW RATE</a></div></div><div class="margin-bottom" ng-if="vm.selectedCustomerRateType === vm.SYSTEM_ENUMS.rateTypes.matrix"><div ng-model="vm.matrixRates" ui-sortable="{ stop: vm.onReorder, handle: \'.reorder-container\' }"><div class="margin-top-md padding-md gray-bg margin-bottom border-radius-md border-default" ng-repeat="matrixRate in vm.matrixRates track by $index"><div class="display-flex gap-10 content-center flex-wrap"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="relative width-percent-20"><input type="text" class="form-control better-placeholder" name="matrixRateName" placeholder="NAME" ng-model="matrixRate.name" required=""></div><div class="field-wrapper margin-right-md relative width-percent-12"><label for="matrix_rate_type">RATE</label><select selectlabel="" class="form-control" name="matrixRateType" ng-options="matrix.value as matrix.label for matrix in vm.matrixRateTypes" ng-model="matrixRate.matrixRateType" ng-change="vm.onMatrixRateTypeChange(matrixRate)" dynamic-placeholder-option="Rate" ng-required="true"><option value="" disabled="" selected="" hidden=""></option></select></div><div><label class="display-flex content-center margin-bottom-none"><input class="margin-right-sm margin-top-none" type="checkbox" name="isDefault" ng-model="matrixRate.isDefault" ng-change="vm.setLaborRateDefault(matrixRate)" ng-disabled="vm.matrixRates.length === 1"> <span class="font-normal text-uppercase margin-left-sm">DEFAULT</span>&nbsp;</label></div><div class="flex-right"><a href="#" class="cursor-pointer margin-right-md theme-link" ng-click="vm.selectMatrixRate($index)">EDIT</a> <a href="#" class="cursor-pointer text-right theme-link" ng-click="vm.deleteMatrixRate(matrixRate, $index)">DELETE</a></div></div><div class="display-flex" ng-if="vm.currentMatrixRateIndex === $index"><div class="gap-10 content-center"><div class="flex-column margin-left-lg margin-top-md"><div class="display-flex border-bottom"><div class="matrix-cell"></div><div class="matrix-cell">0</div><div class="matrix-cell">0.1</div><div class="matrix-cell">0.2</div><div class="matrix-cell">0.3</div><div class="matrix-cell">0.4</div><div class="matrix-cell">0.5</div><div class="matrix-cell">0.6</div><div class="matrix-cell">0.7</div><div class="matrix-cell">0.8</div><div class="matrix-cell">0.9</div></div><div class="display-flex flex-column"><div class="padding-10 display-flex flex-wrap border-bottom" ng-repeat="(rIndex, row) in (matrixRate.matrixRateType === vm.SYSTEM_ENUMS.matrixRateTypes.rate ? matrixRate.rateMatrix : matrixRate.priceMatrix) track by $index"><div class="matrix-cell">{{$index}}</div><div class="matrix-cell" ng-repeat="(cIndex, col) in row track by $index"><div ng-if="cIndex == 0 && rIndex == 0">FREE</div><div class="relative" ng-if="!(cIndex == 0 && rIndex == 0)"><input class="form-control font-size-10 margin-right-md" name="matrixCell{{rIndex}}{{cIndex}}" ng-pattern="vm.decimalRegex" ng-model="row[cIndex]" validation="required:alt=Required|custom: vm.validation.valDecimal(row[cIndex]):alt=Invalid Format" validation-error-to="matrixCell{{rIndex}}{{cIndex}}" format-currency-with-dollar="" required=""></div></div></div></div></div></div></div></div></div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-click="vm.addMatrixRate()">ADD NEW MATRIX</a></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-md"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span> <span class="pull-left padding-top-sm text-uppercase" ng-show="vm.isLoading && !vm.saving"><img src="assets/images/ajax-loader.gif"> Loading...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ladda="vm.saving" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-partsavailability.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div><h4>Parts Availability Status</h4><div class="panel-title">Add, remove, and reorder parts availability status below.</div><hr></div><form role="form" name="inputForm" class="form-horizontal" id="task"><div class="block" ng-model="vm.partsStatus" ui-sortable="{ stop: vm.onColumnReorder, handle: \'> .reorder-container\' }"><div class="display-flex content-center padding-md gray-bg margin-bottom border-radius-md border-default ng-scope ui-sortable-handle" ng-repeat="status in vm.partsStatus track by $index"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="flex-grow margin-left-md margin-right-md"><div class="block relative"><input type="text" class="form-control text-uppercase better-placeholder" name="status" ng-change="vm.validation(status);" placeholder="STATUS" ng-readonly="status.isFixed" ng-model="vm.partsStatus[$index].name" ng-required="true"></div></div><div class="flex-grow margin-left-md margin-right-md"><div class="block relative"><input type="text" class="form-control text-uppercase better-placeholder" name="description" placeholder="DESCRIPTION" ng-model="vm.partsStatus[$index].description" ng-readonly="status.isFixed" ng-change="vm.validation(status);"></div></div><div class="width-px-50"><a href="#" ng-if="!status.isFixed" class="theme-link" ng-click="vm.removePartsStatus(status, $index)">DELETE</a></div></div><div class="text-danger" ng-if="!vm.isValid">{{vm.validationMsg}}</div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-click="vm.addNewStatus()">ADD NEW STATUS</a></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-15"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-disabled="vm.saving" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="submit" class="btn btn-primary" ng-disabled="!vm.isValid" ladda="vm.saving" ng-click="vm.saveChanges()">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-roshopsupplies.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div><h4>Shop Supplies</h4><h5 class="panel-title">Shop Supplies are calculated per service line from the basis you select (Parts, Labor, or Retail Total). The calculated fee is added to each line and rolled into the RO total.</h5><hr></div><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.save()" novalidate="" id="task"><div class="form-group"><div class="col-sm-3 col-xs-6"><input type="text" class="form-control better-placeholder" name="shopSupplyRate" ng-pattern="/^\\d+(\\.\\d{1,3})?%?$/" placeholder="RATE %" ng-model="vm.shopSupplies.shopSupplyRate" ng-required="true" validation="between_num:0,99.99:alt=Must be between 0 and 99.99" percentage=""></div></div><div class="form-group"><div class="field-wrapper col-sm-3 col-xs-6 padding-right-15"><label for="role_select">APPLY TO</label><select selectlabel="" class="form-control" name="shopSupplyCalculationType" ng-options="type.value as type.label for type in vm.shopSupplyCalculationTypes" ng-model="vm.shopSupplies.shopSupplyCalculationType" dynamic-placeholder-option="Apply to" ng-required="true"><option value="" disabled="" selected="" hidden=""></option></select></div></div><div class="form-group"><div class="col-sm-3 col-xs-6"><input type="text" class="form-control better-placeholder" name="shopSupplyMinimum" ng-pattern="/^\\$?\\d+(\\.\\d{1,3})?$/" placeholder="MIN CHARGE" ng-model="vm.shopSupplies.shopSupplyMinimum" ng-required="true" validation="between_num:0,9999.99:alt=Must be between 0 and 9999.99|custom:vm.validation.checkMinMaxValues():alt=Min charge must be less than max charge" format-currency-with-dollar=""></div></div><div class="form-group"><div class="col-sm-3 col-xs-6"><input type="text" class="form-control better-placeholder" name="shopSupplyMaximum" ng-pattern="/^\\$?\\d+(\\.\\d{1,3})?$/" placeholder="MAX CHARGE" ng-model="vm.shopSupplies.shopSupplyMaximum" ng-required="true" validation="between_num:0,9999.99:alt=Must be between 0 and 9999.99|custom:vm.validation.checkMinMaxValues():alt=Max charge must be greater than min charge" format-currency-with-dollar=""></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-disabled="vm.saving" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.save()" class="btn btn-primary" ladda="vm.saving" ng-disabled="inputForm.$invalid || vm.hasValidationErrors">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-rostatus.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div><h4>Statuses</h4><div>Add, remove and reorder statuses below</div><hr></div><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.save()"><div class="block" ng-model="vm.statuses" ui-sortable="{ stop: vm.onStatusReorder, handle: \'> .reorder-container\' }"><div class="display-flex content-center padding-md-plus gray-bg margin-bottom border-radius-md border-default flex-xs-column" ng-repeat="status in vm.statuses track by $index"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="flex-grow margin-left-md margin-right-md"><div class="block relative width-px-160"><input type="text" class="form-control text-uppercase better-placeholder" id="statusName{{$index}}" name="statusName{{$index}}" placeholder="STATUS NAME" ng-model="status.name" ng-readonly="status.isFixed" validation="required:alt=Required|custom:vm.validation.statusName(status):alt=Status already exists"></div></div><div class="field-wrapper margin-right-md"><label for="color_select_bg_{{$index}}" class="on text-uppercase">Background COLOR</label> <input id="color_select_bg_{{$index}}" type="color" placeholder="Background COLOR" class="form-control color-picker display-flex content-center width-px100" ng-model="status.colorHex"></div><div class="field-wrapper margin-right-md"><label for="color_select_text_{{$index}}" class="on text-uppercase">Text COLOR</label> <input id="color_select_text_{{$index}}" type="color" placeholder="Text COLOR" class="form-control color-picker display-flex content-center width-px100" ng-model="status.textColor"></div><div class="field-wrapper margin-right-md"><label for="role_select">USER ROLE</label><select selectlabel="" id="role_select{{$index}}" name="role_select{{$index}}" ng-model="status.roleId" class="form-control" ng-disabled="status.canSetRole" ng-options="role.id as role.displayName for role in vm.roles"><option value="">User role</option></select></div><div class="field-wrapper margin-right-md"><label for="assigned_user">ASSIGNED USER</label><select selectlabel="" id="assigned_user" name="assigned_user" ng-model="status.alwaysAssignedUserId" class="form-control" dynamic-placeholder-option="Assigned user" ng-options="user.id as user.fullName for user in vm.dealerUsers"><option value="">Assigned user</option></select></div><div class="margin-right-md"><label for="statusUpdate{{$index}}" class="display-flex content-center margin-none font-size-10"><input type="checkbox" id="statusUpdate{{$index}}" class="margin-right-sm cursor-pointer margin-none" name="statusUpdate{{$index}}" ng-model="status.customerStatusUpdate"> <span class="padding-left-sm text-uppercase">Customer status update</span></label></div><div class="width-px-50"><a href="#" class="cursor-pointer text-right theme-link" ng-if="!status.isFixed" ng-click="vm.deleteStatus(status, $index)">DELETE</a></div></div></div><div class="display-flex flex-percent-100 margin-top margin-bottom-md"><a href="#" class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-click="vm.addNewStatus()">ADD NEW STATUS</a></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span> <span class="pull-left padding-top-sm text-uppercase" ng-show="vm.isLoading && !vm.saving"><img src="assets/images/ajax-loader.gif"> Loading...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ladda="vm.saving" ng-disabled="!inputForm.$valid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-shopflags.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div><h4>Shop Flags</h4><div>Add, remove, and reorder shop flags below.</div><hr></div><form role="form" name="inputForm" class="form-horizontal" ng-submit="vm.save()" id="task"><div ng-model="vm.shopFlags" ui-sortable="{ stop: vm.onColumnReorder, handle: \'> .reorder-container\' }"><div class="display-flex content-center padding-md gray-bg margin-bottom border-radius-md border-default flex-xs-column" ng-repeat="shopFlag in vm.shopFlags track by $index"><div class="reorder-container display-flex"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="flex-grow margin-left-md margin-right-lg max-width-px-200 margin-bottom-xs"><div class="block relative"><input type="text" class="form-control display-flex better-placeholder" ng-model="vm.shopFlags[$index].name" placeholder="SHOP FLAG" ng-change="vm.shopFlagChanged(shopFlag);" required=""></div></div><div class="field-wrapper flex-grow margin-left-md margin-right-lg max-width-px-200 margin-bottom-xs"><label for="color_select_bg_{{$index}}" class="on text-uppercase">Background COLOR</label> <input id="color_select_bg_{{$index}}" type="color" class="form-control color-picker display-flex content-center" ng-model="vm.shopFlags[$index].color" ng-change="vm.shopFlagChanged(shopFlag)"></div><div class="field-wrapper flex-grow margin-left-md margin-right-lg max-width-px-200 margin-bottom-xs"><label for="color_select_text_{{$index}}" class="on text-uppercase">Text COLOR</label> <input id="color_select_text_{{$index}}" type="color" class="form-control color-picker display-flex content-center" ng-model="vm.shopFlags[$index].textColor" ng-change="vm.shopFlagChanged(shopFlag)"></div><div class="padding-left-none flex-right"><a href="#" class="theme-link" ng-click="vm.removeShopFlag(shopFlag, $index)">DELETE</a></div></div><div class="text-danger" ng-if="!vm.isValid">{{vm.validationMsg}}</div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-click="vm.addNewShopFlag()">ADD NEW SHOP FLAG</a></div></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-md"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-disabled="vm.saving" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.isValid" ladda="vm.saving" ng-click="vm.saveChanges()">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/inspect/tab-inspect-taxes.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div><h4>Taxes</h4><div class="panel-title">Add, remove, configure and reorder taxes below</div><hr></div><form role="form" name="inputForm" class="form-horizontal validation-relative" ng-submit="vm.saveChanges()" id="task"><div ng-model="vm.taxes" ui-sortable="{ stop: vm.onTaxesReorder, handle: \'.reorder-container\' }"><div class="content-center padding-md gray-bg margin-bottom border-radius-md border-default" ng-repeat="tax in vm.taxes track by $index"><div class="display-flex margin-bottom-md"><div class="reorder-container display-flex margin-top-sm"><i class="material-icons font-size-22 cursor-pointer">menu</i></div><div class="block relative margin-left-md margin-right-md flex-width-250"><input type="text" class="form-control text-uppercase better-placeholder" ng-disabled="!tax.isEnabled" name="shopTaxFeeName{{$index}}" ng-change="vm.revalidate(\'shopTaxFeeName{{$index}}\')" placeholder="NAME" ng-model="tax.shopTaxFeeName" ng-class="{\'fake-required\': tax.isEnabled}" validation="custom:vm.validation.shopTaxFeeName(tax):alt=Unique name required." better-placeholder=""></div><div class="block relative margin-right-md flex-width-100" ng-if="tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" ng-class="{\'fake-required\': tax.isEnabled}" ng-disabled="!tax.isEnabled" validate-on-empty="true" ng-pattern="/^\\$?\\d+(\\.\\d{1,3})?$/" ng-change="vm.revalidate(\'amount{{$index}}\')" validation="custom:vm.validation.fixedAmount(tax):alt=Valid amount is required" name="amount{{$index}}" placeholder="AMOUNT" ng-model="tax.fixedTax.fixedAmount" format-currency-with-dollar=""></div><div class="fake-required block relative margin-right-md flex-width-100" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="partsPercent{{$index}}" ng-disabled="!tax.isEnabled" ng-pattern="vm.decimalRegex" ng-change="vm.revalidate(\'partsPercent{{$index}}\')" placeholder="PARTS %" ng-model="tax.variableTax.partsPercent" validation="alt=numeric:alt=Enter 0 - 99.99|between_num: 0, 99.99:alt=Enter 0 - 99.99" percentage=""></div><div class="fake-required block relative margin-right-md flex-width-120" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="shopSupplies{{$index}}" ng-disabled="!tax.isEnabled" ng-change="vm.revalidate(\'shopSupplies{{$index}}\')" placeholder="SHOP SUPPLIES %" ng-model="tax.variableTax.shopSupplies" validation="alt=numeric:alt=Enter 0 - 99.99|between_num: 0, 99.99:alt=Enter 0 - 99.99" percentage=""></div><div class="fake-required block relative margin-right-md flex-width-100" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="discounts{{$index}}" ng-disabled="!tax.isEnabled" ng-change="vm.revalidate(\'discounts{{$index}}\')" placeholder="DISCOUNTS %" ng-model="tax.variableTax.discounts" validation="alt=numeric:alt=Enter 0 - 99.99|between_num: 0, 99.99:alt=Enter 0 - 99.99" percentage=""></div><div class="block relative margin-right-md flex-width-100" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="minTax{{$index}}" ng-disabled="!tax.isEnabled" ng-change="vm.revalidate(\'maxTax{{$index}}\')" placeholder="MIN TAX $" validation="custom:vm.validation.minTaxAmount(tax):alt=Max tax should be greater than min tax" ng-model="tax.variableTax.minAmount" validation-error-to="#maxTaxError{{$index}}" format-currency-with-dollar=""></div><div class="block relative margin-right-md flex-width-100" ng-if="tax.isFixedEnabled">&nbsp;</div><div class="block relative margin-right-md flex-width-100" ng-if="tax.isFixedEnabled">&nbsp;</div><div class="block relative margin-right-md flex-width-120" ng-if="tax.isFixedEnabled">&nbsp;</div><div class="block relative flex-width-150 margin-right-md"><div class="field-wrapper"><label for="taxFeeApplyType">Only Apply Tax If</label><select selectlabel="" ng-disabled="!tax.isEnabled" id="taxFeeApplyType{{$index}}" name="taxFeeApplyType{{$index}}" ng-model="tax.taxFeeApplyType" class="form-control text-uppercase better-placeholder" validate-on-empty="true" ng-change="vm.revalidate(\'onlyApplyTaxIfGreaterThan{{$index}}\')" validation="custom:vm.validation.taxFeeApplyType(tax):alt=Please select any option" ng-options="option.value as option.name for option in vm.taxFeeApplyTypes"><option value="">Only Apply Tax If</option></select></div></div><div class="flex-right pull-right-xs padding-top-sm"><switch id="taxIsEnabled" name="dispatchtaxIsEnabledControls" ng-model="tax.isEnabled" class="green" ng-change="vm.taxEnableUpdated(tax)"></switch></div></div><div class="display-flex padding-bottom-md"><div class="reorder-container display-flex min-width-px-22">&nbsp;</div><div class="block relative margin-left-md margin-right-md flex-width-250"><div class="field-wrapper"><label for="isFixedEnabled">Tax Type</label><select ng-disabled="!tax.isEnabled" selectlabel="" id="isFixedEnabled" name="isFixedEnabled{{$index}}" dynamic-placeholder-option="Tax Type" ng-model="tax.isFixedEnabled" class="form-control text-uppercase" ng-change="vm.revalidate(\'amount{{$index}}\')" ng-options="option.value as option.name for option in vm.taxTypes"><option value="" disabled="" selected="" hidden=""></option></select></div></div><div class="block relative margin-right-md flex-width-100" ng-if="tax.isFixedEnabled"></div><div class="block relative margin-right-md flex-width-100" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="labor{{$index}}" ng-disabled="!tax.isEnabled" ng-change="vm.revalidate(\'labor{{$index}}\')" placeholder="LABOR %" ng-model="tax.variableTax.laborPercent" validation="alt=numeric:alt=Enter 0 - 99.99|between_num: 0, 99.99:alt=Enter 0 - 99.99" percentage=""></div><div class="block relative margin-right-md flex-width-120" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="fees{{$index}}" ng-disabled="!tax.isEnabled" ng-change="vm.revalidate(\'fees{{$index}}\')" placeholder="FEES %" ng-model="tax.variableTax.fees" validation="alt=numeric:alt=Enter 0 - 99.99|between_num: 0, 99.99:alt=Enter 0 - 99.99" percentage=""></div><div class="block relative margin-right-md flex-width-100" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="total{{$index}}" ng-disabled="!tax.isEnabled" ng-change="vm.revalidate(\'total{{$index}}\')" placeholder="TOTAL RETAIL %" ng-model="tax.variableTax.totalPercent" validation="alt=numeric:alt=Enter 0 - 99.99|between_num: 0, 99.99:alt=Enter 0 - 99.99" percentage="" precision="4"></div><div class="block relative margin-right-md flex-width-100" ng-if="!tax.isFixedEnabled"><input type="text" class="form-control text-uppercase better-placeholder" name="maxTax{{$index}}" ng-disabled="!tax.isEnabled" placeholder="MAX TAX $" ng-change="vm.revalidate(\'minTax{{$index}}\')" validation="custom:vm.validation.maxTaxAmount(tax):alt=Max tax should be greater than min tax" validation-error-to="#maxTaxError{{$index}}" ng-model="tax.variableTax.maxAmount" format-currency-with-dollar=""> <span id="maxTaxError{{$index}}" class="text-danger validation"></span></div><div class="block relative margin-right-md flex-width-100" ng-if="tax.isFixedEnabled">&nbsp;</div><div class="block relative margin-right-md flex-width-100" ng-if="tax.isFixedEnabled">&nbsp;</div><div class="block relative margin-right-md flex-width-120" ng-if="tax.isFixedEnabled">&nbsp;</div><div class="block relative flex-width-150 margin-right-md"><input type="text" class="form-control text-uppercase better-placeholder" name="onlyApplyTaxIfGreaterThan{{$index}}" ng-disabled="!tax.isEnabled" placeholder="MIN $ AMOUNT" validate-on-empty="true" ng-pattern="/^\\$?\\d+(\\.\\d{1,3})?$/" validation="custom:vm.validation.minAmount(tax):alt=Valid amount is required" ng-model="tax.onlyApplyTaxIfGreaterThan" ng-class="{\'fake-required\': tax.isEnabled && tax.taxFeeApplyType}" format-currency-with-dollar=""></div><div class="flex-right pull-right-xs margin-top-sm padding-top-sm"><a href="#" class="theme-link" ng-click="vm.removeTaxes(tax, $index)">DELETE</a></div></div></div></div><div class="text-danger" ng-if="!vm.isValid">{{vm.validationMsg}}</div><div class="display-flex flex-percent-100 margin-top"><a href="#" class="cursor-pointer text-right flex-right text-uppercase theme-link" ng-click="vm.addNewTax()">ADD NEW TAX</a></div></form></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-md"><div class="flex-percent-50 full-width text-left"><span class="pull-left padding-top-sm text-uppercase margin-left-20" ng-show="vm.saving"><img src="assets/images/ajax-loader.gif"> Saving...</span><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" ng-click="vm.saveChanges()" class="btn btn-primary" ladda="vm.saving" ng-disabled="inputForm.$invalid">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/shared/components/authorizations/authorize-services/authorize-services.view.html','<div ng-if="!vm.isLoading"><h2 class="margin-top-md font-size-18 font-bold">{{vm.repairOrder.vehicle.year}} {{vm.repairOrder.vehicle.model}} (#{{vm.repairOrder.vehicle.vin | limitTo: -8}})</h2><div ng-if="vm.showCheckinSummary"><checkin-summary repair-order="vm.repairOrder"></checkin-summary></div><div ng-if="!vm.showCheckinSummary"><div>Please review the information below regarding your service appointment and ensure we have the correct information and services you would like performed. When complete please complete the authorization below.</div><div class="margin-top-30"><repair-order-vehicle-details-issues repair-order="vm.repairOrder"></repair-order-vehicle-details-issues></div><appointment-transportation-summary ng-if="vm.appointment" ng-model="vm.appointment" location-transportation-types="vm.dealerTransportationTypes"></appointment-transportation-summary><div class="row border-bottom margin-top"><div class="col-sm-11 col-xs-10"><h3 class="title"><div class="font-size-14black"><strong>SERVICES ({{vm.servicesToAuthorize.length}} PENDING APPROVAL)</strong></div></h3></div></div><div class="row margin-top"><div class="col-sm-12 col-xs-12 margin-bottom"><div ng-repeat="service in vm.servicesToAuthorize track by service.domId"><authorize-pending-lineitem ng-model="service" is-dashboard="true" itemize-tax="vm.recalculateFixedTaxesAndFees()"></authorize-pending-lineitem></div></div></div><div class="row"><div class="col-sm-12 col-xs-12 text-right"><div ng-if="!vm.itemizationEnabled">TOTAL ESTIMATE: <b>{{vm.getTotalEstimate() | currency}}</b><br>(Not incl. taxes or fees)</div><div ng-if="vm.itemizationEnabled"><div>Total parts &amp; labor: {{vm.getTotalEstimate() | currency}}</div><div ng-if="vm.fixedTaxesAndFees && vm.fixedTaxesAndFees.length"><div ng-repeat="fee in vm.fixedTaxesAndFees"><span>{{fee.description}}: {{fee.amount | currency}}</span></div></div><div><b>Total (Tax not incl.):</b> {{vm.getTotals() | currency}}</div></div></div></div><div class="row border-bottom margin-top-lg"><div class="col-sm-11 col-xs-10"><h3 class="title"><div class="font-size-14 black"><strong>CUSTOMER AUTHORIZATION</strong></div></h3></div></div><div class="row"><div class="col-xs-11 margin-top margin-bottom">Please ensure all of the information above is correct. In order to work on your vehicle and perform the selected services, you must agree to the terms and authorize the work by providing your signature below.</div></div><div ng-repeat="term in vm.terms" class="margin-bottom row"><div class="col-xs-2 col-sm-1"><switch name="switch_{{$index}}" ng-model="term.accepted" disabled="vm.fieldsDisabled" class="green small-switch auth" required="required"></switch></div><div class="col-xs-9 col-sm-10 message-top-auth">{{term.terms}}</div></div><div class="row m-t"><div class="col-xs-12"><div class="dashed-signature-container"><input type="hidden" ng-model="vm.dataurl" ng-required="!vm.isVerbalAuthorization"><signature-pad accept="accept" clear="vm.clear" height="220" width="768" dataurl="vm.dataurl"></signature-pad><div class="signature-x">x</div><div class="text-center"><span class="font-size-8">Sign your name with your finger</span></div></div><div href="#" ng-click="vm.clear()" class="pull-right cursor-pointer text-uppercase font-size-10 margin-top-sm margin-bottom">Clear Signature</div><div class="text-danger" ng-if="vm.error">{{vm.error}}</div></div></div><div class="row margin-top-sm margin-bottom"><div class="col-xs-12 margin-bottom-30"><label class="font-normal"><input type="checkbox" id="verbal-authorization" name="verbal-authorization" ng-model="vm.isVerbalAuthorization" ng-change="vm.verbalAuthorizationClicked()"> <span class="text-uppercase">Customer has provided verbal authorization</span></label></div></div></div></div>');
$templateCache.put('app/shared/components/authorizations/partials/authorization-group-modal.html','<div class="display-flex flex-column full-width-height"><div class="modal-header appointment-detail-header aside-header text-uppercase"><h3 class="font-bold margin-top-md margin-bottom-md font-size-16 line-height-1">Service Authorization</h3></div><div class="modal-body padding full-width-height overflow-y-auto"><div class="appointment-homework"><h3 class="title1">SERVICE AUTHORIZATION FOR</h3><h1 class="titleName">{{vm.repairOrder.customer.name}}</h1><h2 class="title2">{{vm.repairOrder.vehicle.year}} {{vm.repairOrder.vehicle.model}} <span ng-if="vm.repairOrder.vehicle.vin">(#{{vm.repairOrder.vehicle.vin | limitTo: -8}})</span></h2></div><div class="font-size-12 text-uppercase margin-bottom"><div ng-if="!vm.dashboardHistoryMode"><strong>{{vm.authorizationGroup.createdDate | date:\'MMMM d\'}} at {{vm.authorizationGroup.createdDate | date:\'h:mm a\'}} ({{(vm.authorizationGroup.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.approved }).length}} APPROVED {{(vm.authorizationGroup.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.deferred }).length}} DEFERRED)</strong></div></div><div class="margin-bottom" ng-repeat="authorization in vm.authorizationGroup.authorizations track by authorization.id"><div ng-if="vm.dashboardHistoryMode" class="margin-bottom-sm"><span class="font-bold">SENT:</span> {{authorization.sentDate | date:\'M/d/yy\'}} at {{authorization.sentDate | date:\'h:mma\'}} <span class="margin-left-sm"><span class="font-bold">COMPLETED:</span> <span ng-if="authorization.responseDate">{{authorization.responseDate | date:\'M/d/yy\'}} at {{authorization.responseDate | date:\'h:mma\'}}</span> <span ng-if="!authorization.responseDate">PENDING</span></span></div><authorize-pending-lineitem ng-model="authorization.serviceOperation" is-dashboard="true" limit-width="true" read-only="true"></authorize-pending-lineitem></div><div class="margin-top-30 display-flex content-center" ng-repeat="term in vm.authorizationGroup.agreedUponTerms"><div><i class="material-icons md-24">done</i></div><div>{{term}}</div></div><div class="margin-top-30 auth-history-signature position-relative" ng-if="vm.authorizationGroup.signatureData.imageUrl"><img ng-src="{{vm.authorizationGroup.signatureData.imageUrl}}"><div class="signature-x">x</div><div class="signature-line">&nbsp;</div></div><div class="margin-top-30 font-bold" ng-if="vm.authorizationGroup.isVerbalSignOff">Verbal Approval Obtained by {{vm.repairOrder.customer.firstName}} {{vm.repairOrder.customer.lastName}} on {{ vm.authorizationGroup.createdDate | date:\'MM/dd/yyyy \\\'at\\\' h:mm a\' }}</div></div><div class="padding shadow-border-top text-right"><button type="button" class="btn btn-default" ng-click="vm.close()">CLOSE</button></div></div>');
$templateCache.put('app/shared/components/authorizations/partials/authorize-services-modal.html','<div class="display-flex flex-column full-width-height"><div class="flex-fullwidth-50h modal-header text-uppercase"><div class="margin-top-md margin-bottom-md font-bold font-size-16 line-height-1">Authorize Services</div></div><div class="modal-body padding full-width-height overflow-y-auto overflow-x-hidden flex-grow"><form name="AuthorizeServiceForm"><authorize-services register-step-fn="vm.registerStepProcessor" repair-order="vm.repairOrder" selected-service-ids="vm.selectedLineItems" is-loading="vm.isLoading"></authorize-services></form></div><div class="display-flex content-center padding-md flex-gap-sm shadow-border-top"><button type="button" class="btn btn-default text-uppercase flex-right" ng-click="vm.close()">CLOSE</button> <button type="button" class="btn btn-primary text-uppercase flex-right margin-left-sm" ng-if="!vm.servicesSaved" ladda="vm.isLoading" ng-click="vm.save()" ng-disabled="!AuthorizeServiceForm.$valid">Complete</button></div></div>');
$templateCache.put('app/areas/trip/components/summary-image/summary-image.view.html','<div ng-if="vm.media.path"><div class="margin-bottom-md media-thumbnail" ng-click="vm.openMedia()"><img ng-src="{{ vm.media.path }}" alt="{{item.caption}}" ng-if="vm.media.type === vm.mediaTypes.photo"><video ng-src="{{ vm.media.path }}" ng-if="vm.media.type === vm.mediaTypes.video"></video><span class="overlay" ng-if="vm.media.type === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center" ng-if="vm.media.dateTaken">{{ vm.media.dateTaken | localDate:\'MMM D h:mm A\' }}</div><div class="text-center" ng-if="vm.media.description">{{ vm.media.description }}</div></div><div ng-if="!vm.media.path" style="width: 100px;"><div class="text-center">Pending Upload</div><div class="text-uppercase text-center">{{ vm.media.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div>');
$templateCache.put('app/areas/trip/components/summary-photos/summary-photos.view.html','<div ng-if="vm.task.taskType == 2"><div ng-if="vm.task.media.length"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vm.task.media" class="text-center"><rc-trip-summary-image media="media"></rc-trip-summary-image></li></ul></div></div>');
$templateCache.put('app/areas/trip/components/summary-tasks/summary-tasks.view.html','<div ng-if="vm.task.taskType == 11 || vm.task.taskType == 12 || vm.task.taskType == 13" class="padding-top-none"><div ng-if="vm.task.driverResponse.text">{{vm.task.driverResponse.text}}</div><div ng-if="vm.task.driverResponse"><ol type="A" class="padding-bottom-sm"><li ng-repeat="selectableValue in vm.task.items" class="position-relative"><i class="material-icons align-text position-absolute margin-left-negative-30" ng-if="selectableValue.selected">check</i> {{selectableValue.text}}</li></ol></div></div>');
$templateCache.put('app/areas/trip/components/summary-vehicle/summary-vehicle.view.html','<div ng-if="vm.task.taskType == 4 || vm.task.taskType == 8 || vm.task.taskType == 9 || vm.task.taskType == 10"><div ng-if="!vm.task.driverResponse || !vm.task.driverResponse.vehicle"><div class="row"><div class="col-xs-12">No vehicle info provided</div></div></div><div ng-if="vm.task.driverResponse && vm.task.driverResponse.vehicle"><div class="section-sub-title text-uppercase margin-bottom-20"><b>{{ vm.task.driverResponse.vehicle.description }}</b></div><div class="row margin-bottom-20" ng-if="vm.task.driverResponse.vehicle.vin && vm.task.taskOptions.includesVinScan"><div class="col-md-3 text-uppercase"><b>VIN</b></div><div class="col-md-9">{{ vm.task.driverResponse.vehicle.vin }}</div></div><div ng-if="vm.task.driverResponse.vehicle.mileage" class="row margin-bottom-20"><div class="col-md-3 text-uppercase"><b>Mileage</b></div><div class="col-md-9">{{ vm.task.driverResponse.vehicle.mileage | number }}</div></div><div ng-if="vm.task.driverResponse.vehicle.fuel || vm.task.driverResponse.vehicle.fuel === 0" class="row margin-bottom-20"><div class="col-md-3 text-uppercase"><b>Fuel</b></div><div class="col-md-2"><range-display value="{{ vm.task.driverResponse.vehicle.fuel }}" fuellevel="{{vm.getRangleDisplayFuelLevel(vm.task.driverResponse.vehicle.fuel)}}"></range-display></div></div><div ng-if="vm.task.driverResponse.vehicle.customerCredentialsVerified" class="row margin-bottom-20"><div class="col-md-3 text-uppercase"><b>Customer Credentials</b></div><div class="col-md-9 text-uppercase">{{ vm.task.driverResponse.vehicle.customerCredentialsVerified ? \'Verified\' : \'Unverified\' }}</div></div><div ng-if="vm.task.media.length" class="row margin-bottom-20"><div class="col-sm-12 text-uppercase"><b>Vehicle Exterior</b></div></div><div ng-if="vm.task.media.length"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vm.task.media" class="text-center"><rc-trip-summary-image media="media"></rc-trip-summary-image></li></ul></div><div ng-if="vm.task.vehicleIssues.length" class="row margin-bottom-20"><div class="col-sm-12 text-uppercase"><b>Damage and Issues</b></div></div><div ng-if="vm.task.vehicleIssues.length"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vm.task.vehicleIssues" class="text-center"><rc-trip-summary-image media="media"></rc-trip-summary-image></li></ul></div></div></div><div ng-if="vm.task.taskType == vm.workflowTaskTypes.customerVehicleTasksMulti"><div ng-if="!vm.task.driverResponse || !vm.task.driverResponse.vehicles"><div class="row"><div class="col-xs-12">No vehicle info provided</div></div></div><div ng-if="vm.task.driverResponse && vm.task.driverResponse.vehicles"><div ng-repeat="vehicle in vm.task.driverResponse.vehicles"><div class="section-sub-title text-uppercase margin-bottom-20"><b>{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model}}</b></div><div class="row margin-bottom-20" ng-if="vehicle.vin && vm.task.taskOptions.includesVinScan"><div class="col-md-3 text-uppercase"><b>VIN</b></div><div class="col-md-9">{{ vehicle.vin }}</div></div><div class="row margin-bottom-20" ng-if="vehicle.vin && vm.task.taskOptions.includesVinScan"><div class="col-md-3 text-uppercase"><b>Repair Order number</b></div><div class="col-md-9">{{ vehicle.repairOrderNumber }}</div></div><div ng-if="vehicle.mileage" class="row margin-bottom-20"><div class="col-md-3 text-uppercase"><b>Mileage</b></div><div class="col-md-9">{{ vehicle.mileage | number }}</div></div><div ng-if="vehicle.fuel || vehicle.fuel === 0" class="row margin-bottom-20"><div class="col-md-3 text-uppercase"><b>Fuel</b></div><div class="col-md-2"><range-display value="{{ vehicle.fuel }}" fuellevel="{{vm.getRangleDisplayFuelLevel(vehicle.fuel)}}"></range-display></div></div><div ng-if="vehicle.customerCredentialsVerified" class="row margin-bottom-20"><div class="col-md-3 text-uppercase"><b>Customer Credentials</b></div><div class="col-md-9 text-uppercase">{{ vehicle.customerCredentialsVerified ? \'Verified\' : \'Unverified\' }}</div></div><div ng-if="vm.task.media.length" class="row margin-bottom-20"><div class="col-sm-12 text-uppercase"><b>Vehicle Exterior</b></div></div><div ng-if="vm.task.media.length"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vehicle.media" class="text-center"><rc-trip-summary-image media="media"></rc-trip-summary-image></li></ul></div><div ng-if="vm.task.vehicleIssues.length" class="row margin-bottom-20"><div class="col-sm-12 text-uppercase"><b>Damage and Issues</b></div></div><div ng-if="vm.task.vehicleIssues.length"><ul class="trip-photo-list pull-left padding-left-none"><li ng-repeat="media in vehicle.vehicleIssues" class="text-center"><rc-trip-summary-image media="media"></rc-trip-summary-image></li></ul></div></div></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/partials/appointment-map.html','<div id="public-map" class="appointment-map"><div id="{{vm.mapName}}" class="map-fullHeight"><div id="appt-map-container" map-resize=""><div id="map" driver-tracking="" options="vm.mapOptions" events="vm.mapListeners" map-loaded="vm.onMapReady"></div></div><resizer vlines="true" direction="vertical" attach-element-id="appt-map-container" dependent-element-id="appt-map-container" yoffset="-15" callback="vm.resizeMap()" collapse="false" framed-in="{{vm.isInFrame}}"></resizer></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/partials/choose-pickup.view.html','<div class="relative" ng-class="{\'clean-input\': vm.cleanInput}"><i class="fa fa-2x fa-map-marker clean-input-marker" ng-if="vm.cleanInput"></i> <input type="text" id="gplaces_{{vm.inputName}}" name="gplaces_{{vm.inputName}}" ng-model="vm.location" class="form-control clean-input-text better-placeholder" required="" details="vm.places" validation="required" options="vm.placesOptions" here-places="" placeholder="{{vm.placeholder}}" handle-selected="vm.placeUpdated(formattedAddress)" map-fields="{\'salesPhoneNumber\':\'phone\', \'servicePhoneNumber\': \'phone\'}"></div>');
$templateCache.put('app/areas/consumer/appointments/views/partials/choose-services.view.html','<div class="row"><div class="col-xs-12" ng-class="{\'col-sm-8\': vm.dealerIntegrations.isDigniFiEnabled, \'col-sm-12\': !vm.dealerIntegrations.isDigniFiEnabled}"><form name="consumerServices" id="consumerServices" role="form"><div ng-if="vm.appointment.departmentLineItemMismatch" class="col-xs-12 panel"><div class="row theme-text"><div class="col-xs-12 padding-none">Some of the services that were previously selected on your appointment are no longer available, or have been modified and need to be reselected.<br>{{vm.getDepartmentMismatchCount()}} Service<span ng-if="vm.getDepartmentMismatchCount()>1">s</span>&nbsp;<div id="line-item-mismatch-toggle" ng-click="vm.expandLineItemMismatch = !vm.expandLineItemMismatch"><i class="material-icons md-18 theme-link" ng-if="vm.expandLineItemMismatch === false">expand_more</i><i class="material-icons md-18 theme-link" ng-if="vm.expandLineItemMismatch === true">expand_less</i></div><br><ul ng-if="vm.expandLineItemMismatch === true"><li ng-repeat="lineItem in vm.mismatchedLineItems"><span ng-if="lineItem.isGeneric === false">{{lineItem.consumerName || lineItem.dealerAppointmentServiceOpCode.name }}</span> <span ng-if="lineItem.isGeneric === true">Customer Entered Issue: {{lineItem.note }}</span></li><li ng-repeat="lineItem in vm.misMatchedDeclinedItems">{{lineItem.opCodeDescription }}</li></ul></div></div></div><input type="hidden" id="fake-input" name="fake-input" validation="required" ng-model="vm.fakeInput"><div class="col-xs-12 padding-left-none padding-right-none" ng-if="vm.genericConsumerServiceEnabled === true"><div ng-repeat="item in vm.genericConsumerServicesNotes" class="label-text service-label addtional-services-label" ng-class="{\'margin-top\': $index > 0}"><textarea class="form-control full-width better-placeholder resize-none" rows="{{vm.getConsumerNeedsRows()}}" id="additional-services-{{$index}}-{{item.uniqueCnt}}" name="additional-services-{{$index}}-{{item.uniqueCnt}}" ng-model="item.note" placeholder="{{::vm.getConsumerNeedPlaceHolderText($index)}}" ng-disabled="vm.disableserviceselection" ng-change="vm.serviceSelected()" ng-required="!vm.hasSelectedServices($index)" validation="custom:vm.hasSelectedServices($index):alt=Required" maxlength="{{vm.getNoteMaxLength()}}">\r\n                    </textarea><div class="row"><div class="col-xs-6"><div class="character-counter text-left">{{item.note.length || 0}}/{{vm.getNoteMaxLength()}} CHARACTERS</div></div><div class="col-xs-6"><div class="pull-right theme-link multiple-generic-link generic-delete-link inline" ng-click="vm.removeGenericLineItem($index)" ng-if="vm.genericConsumerServicesNotes.length > 1">DELETE</div><div class="pull-right theme-link multiple-generic-link inline" ng-click="vm.addGenericLineItem()" ng-if="vm.allowedGenericLineItemCount > 1 && $index === vm.genericConsumerServicesNotes.length - 1 && $index < vm.allowedGenericLineItemCount-1">ADD ANOTHER ITEM</div></div></div></div></div><div class="row"><div id="choose-services-header" class="col-sm-8 col-xs-12 text-uppercase consumer-header-text margin-top-30 margin-bottom padding-bottom-none" ng-class="{\'hide-title\': vm.genericConsumerServiceEnabled === false }" ng-if="(vm.containsServices || vm.recalls )"><span ng-if="vm.genericConsumerServiceEnabled === true">OR&nbsp;</span>CHOOSE FROM A LIST OF SERVICES BELOW</div><div class="col-sm-4 col-xs-12 margin-top-30 margin-bottom padding-bottom-none text-right" ng-if="vm.gettingservices"><div><img src="assets/images/ajax-loader.gif"> Loading data ...</div></div><div class="col-xs-12 error-section text-danger margin-left-md margin-bottom margin-top-sm" ng-if="vm.appointment.yearMakeModelMismatch === true && vm.appointment.originalApptHasRecallsOrRecMaint">Vehicle has been changed, please reselect recalls and maintenance.</div></div><div class="col-xs-12 error-section text-danger margin-left-md margin-bottom margin-top-sm" ng-if="vm.appointment.yearMakeModelMismatch === true && vm.appointment.originalApptHasRecallsOrRecMaint">Vehicle has been changed, please reselect recalls and maintenance.</div><div class="col-xs-12 padding-none" ng-if="(vm.containsServices || vm.showRecalls() || vm.showRecMaint() || vm.showPreviouslyDeclinedServices())"><div ng-if="!vm.gettingservices && vm.showPreviouslyDeclinedServices()" class="col-xs-12 padding-none"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.prevDeclinedServicesOpen"><uib-accordion-heading><div class="panel-heading img-rounded" ng-click="vm.prevDeclinedServicesToggle();"><div class="input-group"><div class="col-md-8 full-width"><div class="panel-title"><span class="line-item-name text-uppercase">PREVIOUSLY DEFERRED SERVICES</span></div></div></div><div class="recalls-count"><span class="text-right font-normal theme-text"><i class="material-icons theme-text">warning</i>&nbsp;{{vm.previouslydeclinedservices.length}}</span><span class="theme-text" ng-if="vm.getSelectedServicesToDisplay(vm.previouslydeclinedservices) > 0">&nbsp;({{vm.getSelectedServicesToDisplay(vm.previouslydeclinedservices)}} selected)</span> <span class="recalls-toggle theme-text"><i class="material-icons md-24" ng-if="!vm.prevDeclinedServicesOpen">expand_more</i> <i class="material-icons md-24" ng-if="vm.prevDeclinedServicesOpen">expand_less</i></span></div></div></uib-accordion-heading><div class="panel-body img-rounded padding-none"><div class="col-sm-12 margin-bottom padding-left-none" ng-bind-html="vm.previouslydeclinedtitle"></div><div class="col-sm-12 margin-bottom"><div ng-repeat="pdItem in vm.previouslydeclinedservices"><previously-declined-service-item ng-model="pdItem" recmaintdata="vm.recmaintdata" is-dashboard="false" appointment="vm.appointment" dms-system="vm.dealer.dmsSystem" disableserviceselection="vm.disableserviceselection" dept-op-codes="vm.filteredOpCodes" is-checkin="false"></previously-declined-service-item></div></div></div></div></uib-accordion></div><div ng-if="!vm.gettingservices && vm.showRecalls() && ((vm.recalls && vm.recalls.length > 0) || !vm.appointment.vin)" class="col-xs-12 padding-none"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.recallsOpen"><uib-accordion-heading><div class="panel-heading img-rounded" ng-click="vm.recallsToggle();"><div class="input-group"><div class="col-md-8 full-width"><div class="panel-title"><span class="line-item-name text-uppercase">RECALLS</span></div></div></div><div class="recalls-count"><span class="text-right font-normal theme-text"><i class="material-icons theme-text">warning</i>&nbsp;{{vm.recalls.length}}</span><span class="theme-text" ng-if="vm.getSelectedServicesToDisplay(vm.recalls) > 0">&nbsp;({{vm.getSelectedServicesToDisplay(vm.recalls)}} selected)</span> <span class="recalls-toggle theme-text"><i class="material-icons md-24" ng-if="!vm.recallsOpen">expand_more</i> <i class="material-icons md-24" ng-if="vm.recallsOpen">expand_less</i></span></div></div></uib-accordion-heading><div class="panel-body img-rounded padding-none"><div class="col-sm-12 margin-bottom"><div ng-if="!vm.appointment.vin">Please specify the VIN for your vehicle to see open Recalls.</div><div ng-if="vm.appointment.vin" ng-repeat="recall in vm.recalls"><div class="input-group margin-bottom full-width"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="checkbox" class="form-check-input" ng-disabled="vm.disableserviceselection" ng-click="vm.recallLineItemToggled(recall);" ng-value="recall.manufacturerNumber" ng-checked="recall.checked"></div><div class="col-sm-9 col-xs-7 padding-left-sm" ng-click="vm.recallLineItemToggled(recall);"><span class="recall line-item-name text-uppercase"><b>{{ recall.displayName }} (#{{recall.manufacturerNumber}})</b></span></div><div class="col-sm-2 col-xs-4 pull-right padding-left-sm" ng-click="vm.recallLineItemToggled(recall)" ng-if="vm.displayConsumerPrices"><div class="text-right"><span ng-if="vm.recallPrice && vm.recallPrice > 0">{{vm.recallPrefix}} <strong>${{vm.recallPrice | number:2}}</strong></span> <span ng-if="!vm.recallPrice || vm.recallPrice === 0"><strong>VARIES</strong></span></div></div></div></div></div></div></div></div></uib-accordion></div><div ng-if="vm.showRecMaint() && vm.recmaintdata && vm.recmaintdata.length > 0" class="col-xs-12 padding-none"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.recMaintOpen"><uib-accordion-heading><div class="panel-heading img-rounded" ng-click="vm.recMaintToggle();"><div class="input-group"><div class="col-md-8 full-width"><div class="panel-title"><span class="line-item-name text-uppercase">RECOMMENDED MAINTENANCE</span></div></div></div><div class="recmaint-count"><span class="text-right font-normal theme-text">{{ vm.recmaintdata.length }}</span><span class="theme-text" ng-if="vm.getSelectedServicesToDisplay(vm.recmaintdata) > 0">&nbsp;({{vm.getSelectedServicesToDisplay(vm.recmaintdata)}} selected)</span> <span class="recalls-toggle theme-text"><i class="material-icons md-24" ng-if="!vm.recMaintOpen">expand_more</i> <i class="material-icons md-24" ng-if="vm.recMaintOpen">expand_less</i></span></div></div></uib-accordion-heading><div class="panel-body padding-none img-rounded"><div class="col-sm-12 margin-bottom"><div ng-repeat="recmaint in vm.recmaintdata"><div class="input-group margin-bottom full-width"><div class="row"><div class="col-xs-1 recall-checkbox"><input type="radio" class="form-check-input" ng-disabled="vm.disableserviceselection" name="selectedRecMaint_{{$index}}" ng-model="vm.selectedRecMaint" ng-click="vm.recMaintItemToggle(recmaint, $event);" ng-value="recmaint.interval"></div><div class="col-sm-9 col-xs-7 padding-left-sm"><div class="recall line-item-name text-uppercase" title="{{vm.getRecMainTooltip(recmaint.applications)}}"><b>{{::vm.getRecMaintTitle(recmaint)}}</b></div><div class="recall line-item-name margin-bottom" ng-show="vm.selectedRecMaint === recmaint.interval"><span ng-repeat="app in recmaint.applications">{{ app.taxonomy.literalName }} <span ng-if="!$last">,</span></span></div></div><div class="col-sm-2 col-xs-4 pull-right padding-left-sm" ng-click="vm.recMaintItemToggle(recmaint)" ng-if="vm.displayConsumerPrices"><div class="text-right"><span ng-if="vm.recMaintPrice && vm.recMaintPrice > 0">{{vm.recMaintPrefix}} <strong>${{vm.recMaintPrice | number:2}}</strong></span> <span ng-if="!vm.recMaintPrice || vm.recMaintPrice === 0"><strong>VARIES</strong></span></div></div></div></div></div><div class="font-size-11 line-height-14 margin-top-xs" ng-if="vm.recmaintdisclaimer" ng-bind-html="vm.recmaintdisclaimer"></div></div></div></div></uib-accordion></div><div ng-if="vm.containsServices && vm.hasFilteredServices()" class="col-xs-12 padding-none word-break-wrap"><uib-accordion class="line-item"><div uib-accordion-group="" is-disabled="true" is-open="vm.servicesOpen"><uib-accordion-heading><div class="panel-heading" ng-click="vm.servicesToggle()"><div class="input-group"><div class="col-md-8 full-width"><div class="panel-title"><span class="line-item-name text-uppercase" ng-bind-html="vm.otherservicestitle"></span></div></div></div><div class="services-count" ng-if="vm.showServicesCount()"><span class="text-right theme-text">{{ vm.getServicesCount()}}</span><span class="theme-text" ng-if="vm.getSelectedServicesCount() > 0">&nbsp;({{vm.getSelectedServicesCount()}} selected)</span> <span class="lineitem-toggle theme-text"><i class="material-icons md-24" ng-if="!vm.servicesOpen">expand_more</i> <i class="material-icons md-24" ng-if="vm.servicesOpen">expand_less</i></span></div></div></uib-accordion-heading><div class="panel-body padding-none"><div class="col-sm-12 margin-bottom"><div ng-repeat="lineItem in vm.filteredOpCodes | filter: vm.filterConsumerAndExistingOpCodes"><div class="input-group margin-bottom full-width"><div class="row"><div class="col-xs-1 lineitem-checkbox"><input type="checkbox" class="form-check-input service-checkbox" ng-disabled="vm.disableserviceselection" ng-click="vm.serviceToggle(lineItem)" ng-value="lineItem.id" ng-checked="lineItem.checked"></div><div class="col-sm-9 col-xs-7 padding-left-sm" ng-click="vm.serviceToggle(lineItem)"><div class="label-text service-label"><div class="text-uppercase"><strong>{{lineItem.consumerName || lineItem.name || lineItem.overrideName}}</strong></div><div>{{lineItem.consumerDescription}}</div></div></div><div class="col-sm-2 col-xs-4 pull-right padding-left-sm" ng-click="vm.serviceToggle(lineItem)" ng-if="vm.displayConsumerPrices"><div class="text-right"><span ng-if="lineItem.retailPrice && lineItem.retailPrice > 0">{{lineItem.pricePrefix}} <strong>${{lineItem.retailPrice | number:2}}</strong></span> <span ng-if="!lineItem.retailPrice || lineItem.retailPrice === 0"><strong>VARIES</strong></span></div></div></div><div class="row margin-top-md" ng-if="lineItem.showDefaultConsumerNote && lineItem.checked"><div class="col-xs-1 lineitem-checkbox"></div><div class="col-xs-11 col-xs-10 padding-left-sm"><input type="text" class="form-control better-placeholder" ng-model="lineItem.note" placeholder="CUSTOMER COMMENTS" ng-model-options="{debounce: 1000}" ng-change="vm.noteUpdated(lineItem)" maxlength="{{vm.getNoteMaxLength()}}"></div></div></div></div><div ng-if="vm.showRecallsUnderCommonServices()"><div class="input-group margin-bottom full-width" ng-repeat="lineItem in vm.appointment.lineItems | filter: {isRecall: true, originallyChecked: true}"><div class="row"><div class="col-xs-1 lineitem-checkbox"><input type="checkbox" class="form-check-input service-checkbox" ng-disabled="vm.disableserviceselection" ng-click="vm.serviceToggle(lineItem)" ng-value="lineItem.id" ng-checked="lineItem.checked"></div><div class="col-sm-11 col-xs-10 padding-left-sm" ng-click="vm.serviceToggle(lineItem)"><div class="label-text service-label"><div class="text-uppercase"><strong>RECALL</strong> - {{lineItem.manufacturerNumber}} {{lineItem.displayName}}</div></div></div></div><div class="row margin-top-md" ng-if="lineItem.showDefaultConsumerNote && lineItem.checked"><div class="col-xs-1 lineitem-checkbox"></div><div class="col-xs-11 col-xs-10 padding-left-sm"><input type="text" class="form-control better-placeholder" ng-model="lineItem.note" placeholder="CUSTOMER COMMENTS" ng-model-options="{debounce: 1000}" ng-change="vm.noteUpdated(lineItem)" maxlength="{{vm.getNoteMaxLength()}}"></div></div></div></div><div ng-if="vm.showRecMaintUnderCommonServices()"><div class="input-group margin-bottom full-width" ng-repeat="lineItem in vm.appointment.lineItems | filter: {isRecommendedMaintenance: true, originallyChecked: true}"><div class="row"><div class="col-xs-1 lineitem-checkbox"><input type="checkbox" class="form-check-input service-checkbox" ng-disabled="vm.disableserviceselection" ng-click="vm.serviceToggle(lineItem)" ng-value="lineItem.id" ng-checked="lineItem.checked"></div><div class="col-sm-11 col-xs-10 padding-left-sm" ng-click="vm.serviceToggle(lineItem)"><div class="label-text service-label"><div class="text-uppercase"><strong>{{lineItem.opCodeDescription}}</strong></div></div></div></div><div class="row margin-top-md" ng-if="lineItem.showDefaultConsumerNote && lineItem.checked"><div class="col-xs-1 lineitem-checkbox"></div><div class="col-xs-11 col-xs-10 padding-left-sm"><input type="text" class="form-control better-placeholder" ng-model="lineItem.note" placeholder="CUSTOMER COMMENTS" ng-model-options="{debounce: 1000}" ng-change="vm.noteUpdated(lineItem)" maxlength="{{vm.getNoteMaxLength()}}"></div></div></div></div><div ng-repeat="lineItem in vm.unknownImportedOtherLineItems"><div class="input-group margin-bottom full-width"><div class="row"><div class="col-xs-1 lineitem-checkbox"><input type="checkbox" class="form-check-input service-checkbox" ng-disabled="vm.disableserviceselection" ng-click="vm.serviceToggle(lineItem)" ng-value="lineItem.id" ng-checked="lineItem.checked"></div><div class="col-sm-11 col-xs-10 padding-left-sm" ng-click="vm.serviceToggle(lineItem)"><div class="label-text service-label"><div class="text-uppercase"><strong>{{lineItem.opCode}}</strong></div><div>{{lineItem.opCodeDescription || lineItem.consumerDescription}}</div></div></div></div></div></div></div></div></div></uib-accordion></div><div id="text-uppercase" class="grey-panel panel col-xs-12" ng-if="vm.multipleDepartments === true && vm.rankedDepartments && vm.rankedDepartments.length > 1"><b>DON\'T SEE THE SERVICES YOU NEED?&nbsp;<div class="theme-link inline" ng-click="vm.changeDepartment()">CLICK HERE</div></b></div></div></form></div><div ng-if="vm.dealerIntegrations.isDigniFiEnabled" class="col-xs-12 col-sm-4 dignifi-container"><dignifi dealer-id="vm.dealerIntegrations.digniFiDealerId"></dignifi></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/partials/customer-login.view.html','<form name="loginCustomerForm" role="form" novalidate="" ng-submit="vm.submitForm()"><div ng-if="vm.currentState === vm.states.requestPhone"><div class="text-uppercase consumer-header-text"><span ng-if="vm.flow === \'existing\'">Let\'s Look Up Your Appointment</span> <span ng-if="!vm.flow">Returning Customer?</span></div><label ng-if="!vm.flow" class="control-label text-left">We can look up your existing information for faster booking. Please enter your mobile number OR email address below. &#42;If you are not a returning customer, please select CONTINUE AS GUEST to create your profile and book an appointment.&#42;</label> <label ng-if="vm.flow === \'existing\'" class="control-label text-left">Please enter your mobile number OR email address below so we can look up your appointment.</label><div class="row"><div class="col-md-offset-2 col-md-8 col-xs-12 margin-top"><input type="text" class="form-control better-placeholder" ng-disabled="vm.loading" name="loginPhoneEmail" validation="required|custom:vm.validation.validEmailOrPhone():alt=*" required="" placeholder="MOBILE # OR EMAIL" ng-model="vm.loginPhoneEmail"></div><div ng-if="!vm.flow" class="col-md-12 col-xs-12 padding-top-md"><div class="validation text-danger margin-bottom" ng-if="vm.sendCodeError">We are unable to find an account matching this information.<br>Please try again or select CONTINUE AS GUEST below</div><button type="submit" class="btn btn-rounded btn-primary min-75 margin-top" ladda="vm.loading" ng-disabled="!vm.loginPhoneEmail">Next</button></div><div ng-if="vm.flow === \'existing\'" class="col-md-12 col-xs-12 padding-top-md"><div class="validation text-danger margin-bottom" ng-if="vm.sendCodeError">The information you entered doesn\'t appear to be valid, or the phone number associated with the account is not a valid mobile number.<br>Please check it and try again.</div><button type="submit" class="btn btn-rounded btn-primary min-75 margin-top" ladda="vm.loading" ng-disabled="!vm.loginPhoneEmail">Next</button></div></div><div class="row margin-top" ng-if="!vm.loading"><div class="col-md-12 col-xs-12 padding-top-md text-uppercase"><a class="theme-link" ng-click="vm.continueAsGuest()" ng-if="!vm.flow">Continue as guest</a> <a class="theme-link" ng-click="vm.cancel()" ng-if="vm.flow">BACK</a></div></div></div><div ng-if="vm.currentState === vm.states.selectPhoneNumber"><div class="text-uppercase consumer-header-text">Verify Account</div><label class="control-label">Please select the correct phone number associated with the email address provided</label><div class="row"><div class="col-md-offset-3 col-md-6 col-xs-12 padding-top-md"><ul class="appointment-inline-ul"><li ng-repeat="p in vm.phones"><label><input type="radio" name="appointmentType" ng-model="vm.selectedPhone" ng-value="p"> (***) *** - {{ p | limitTo:4 : p.toString().length -4 }}</label></li></ul></div><div class="col-md-12 col-xs-12 padding-top-md"><div class="validation text-danger margin-bottom" ng-if="vm.sendCodeError">We\'re sorry, there was a problem sending your verification code.</div><button type="submit" class="btn btn-rounded btn-primary min-75" ladda="vm.loading" ng-disabled="!vm.selectedPhone">Next</button></div></div><div class="row" ng-if="!vm.loading"><div class="col-md-12 col-xs-12 padding-top-md text-uppercase"><a class="theme-link" ng-click="vm.cancel()">Cancel</a></div></div></div><div ng-if="vm.currentState === vm.states.verifyAccount"><div class="text-uppercase consumer-header-text"><i ng-if="vm.verifyCodeError" class="fa fa-warning"></i> Verify account</div><label class="control-label">We just sent a verification code to <b>(***) *** - {{vm.last4Phone}}</b>. Please enter the code below to retrieve your information.</label> <label class="error" ng-if="vm.verifyCodeError">{{vm.errorMessage != null && vm.errorMessage != \'\' ? vm.errorMessage : \'An error has occured, please try again.\' }}</label><div class="row"><div class="col-md-offset-3 col-md-6 col-xs-12 padding-top-md"><input type="text" class="text-center form-control margin-bottom" mask-restrict="reject" mask="999 999" clean="true" required="" placeholder="ENTER YOUR 6 DIGIT CODE" ng-model="vm.code"></div><div class="col-md-12 col-xs-12 padding-top-md"><button type="submit" class="btn btn-rounded btn-primary min-75" ng-disabled="vm.code == \'\' || vm.code == null" ladda="vm.loading">Next</button></div></div><div class="row" ng-if="!vm.loading"><div class="col-md-12 col-xs-12 padding-top-md text-uppercase"><a class="theme-link" ng-click="vm.cancel()">Cancel</a></div></div></div><div ng-if="vm.currentState === vm.states.selectAppointments"><div class="text-uppercase consumer-header-text"><i ng-if="vm.verifyCodeError" class="fa fa-warning"></i> LET\'S LOOK UP YOUR APPOINTMENT</div><label class="control-label"><span ng-if="vm.appointments.length > 1">The appointments associated with this account are listed below. Please choose the appointment you want to view or modify and click next.</span> <span ng-if="vm.appointments.length === 1">The appointment associated with this account is listed below. Click NEXT to edit or cancel this appointment or BACK to go back and create a new one.</span></label> <label class="error" ng-if="vm.verifyCodeError">{{vm.errorMessage != null && vm.errorMessage != \'\' ? vm.errorMessage : \'An error has occured, please try again.\' }}</label><div class="row"><div class="col-md-12 col-xs-12 padding-top-md"><ul class="appointment-inline-ul"><li ng-repeat="app in vm.appointments"><label><input ng-if="vm.appointments.length > 1" type="radio" name="appointmentType" ng-model="vm.selectedAppointment" ng-value="app.id"> {{ app.apptDateTime | date: \'longDate\' }} at {{ app.apptDateTime | date: \'shortTime\' }} - {{ app.year }} {{ app.make }} {{ app.model }}</label></li></ul></div><div class="col-md-12 col-xs-12 padding-top-md"><button type="submit" class="btn btn-rounded btn-primary min-75" ng-disabled="!vm.selectedAppointment" ladda="vm.loading">Next</button></div></div><div class="row" ng-if="!vm.loading"><div class="col-md-12 col-xs-12 padding-top-md"><a class="theme-link" ng-click="vm.cancel()">Back</a></div></div></div><div ng-if="vm.currentState === vm.states.noAppointments"><div class="text-uppercase consumer-header-text"><i ng-if="vm.verifyCodeError" class="fa fa-warning"></i> LET\'S LOOK UP YOUR APPOINTMENT</div><label class="control-label"><span>No appointments found.</span></label><div class="row"><div class="col-md-12 col-xs-12 padding-top-md"><button type="submit" class="btn btn-rounded btn-primary min-75" ladda="vm.loading">Create Appointment</button></div></div><div class="row" ng-if="!vm.loading"><div class="col-md-12 col-xs-12 padding-top-md"><a class="theme-link" ng-click="vm.cancel()">Back</a></div></div></div><div ng-if="vm.currentState === vm.states.invalidAccount"><div class="text-uppercase consumer-header-text"><i class="fa fa-warning"></i> Verify account</div><label class="control-label">We were unable to location your records.<br>Please try a different phone or continue as guest</label><div class="row"><div class="col-md-offset-3 col-md-6 col-xs-12 padding-top-md"><input type="text" class="form-control" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="" ng-model="vm.loginPhone"></div><div class="col-md-12 col-xs-12 padding-top-md"><button type="submit" class="btn btn-rounded btn-primary min-75" ladda="vm.loading">Next</button></div></div><div class="row" ng-if="!vm.loading"><div class="col-md-12 col-xs-12 padding-top-md"><button type="button" class="theme-link" ng-click="vm.continueAsGuest()">Continue as guest</button></div></div></div></form>');
$templateCache.put('app/areas/consumer/appointments/views/partials/edit-appointment-details.view.html','<form name="consumerAppointmentDetails" id="consumerAppointmentDetails" role="form" ng-class="{\'hideLoanerText\': !vm.displayLoanerSections}"><div ng-cloak="" ng-if="vm.appointment.lineItems.length === 0"><div class="row margin-top"><div ng-if="vm.ghostGarage === 1" class="col-md-1 hidden-xs"></div><div ng-class="{\'col-md-5 col-xs-12\': vm.ghostGarage === 0, \'col-md-10 col-xs-12 padding-top-md\': vm.ghostGarage === 1}"><span class="consumer-header-text"><br>UH OH!</span><br><br>It appears that services have not been selected. Please click back to selects services. If this issue persists, please contact the dealership.</div></div></div><div ng-cloak="" ng-if="vm.appointment.lineItems.length > 0 && vm.ghostGarage === 0" ng-class="{\'margin-top-md\': !vm.showRadioButtons}"><div class="row margin-top-md margin-bottom-sm" ng-if="vm.showRadioButtons === true"><div class="col-md-1 hidden-xs"></div><div class="col-md-12 col-xs-12 padding-top-md"><center><ul class="appointment-inline-ul list-inline text-uppercase"><li ng-if="vm.defaultPickUp && vm.pickupTransportationTypes && vm.defaultPickupTripType && vm.configValues.defaultPickupTripTypeId !== null"><label><input type="radio" name="appointmentType" ng-model="vm.transportation" ng-value="vm.transTypeGroups.pickup" class="consumer-transportation-radio" ng-disabled="vm.dealerSlotsLoading" ng-model-options="{ debounce: 800 }" ng-change="vm.transportationUpdated(true, true)"><div class="inline consumer-transportation-type" ng-bind-html="vm.configValues.landingFirstChoiceTitle"></div></label></li><li ng-if="vm.defaultDropOff && vm.dropOffTransportationTypes && vm.dropOffTransportationTypes.length > 0"><label><input type="radio" name="appointmentType" ng-model="vm.transportation" ng-value="vm.transTypeGroups.dropoff" class="consumer-transportation-radio" ng-disabled="vm.dealerSlotsLoading" ng-model-options="{ debounce: 800 }" ng-change="vm.transportationUpdated(true, true)" ng-if="vm.tripTypes.pickUpTransportationTypes && vm.tripTypes.pickUpTransportationTypes.length > 0"><div class="inline consumer-transportation-type" ng-bind-html="vm.configValues.landingSecondChoiceTitle"></div></label></li><li ng-if="vm.defaultMobile"><label><input type="radio" name="appointmentType" ng-model="vm.transportation" ng-value="vm.transTypeGroups.mobile" class="consumer-transportation-radio" ng-disabled="vm.dealerSlotsLoading" ng-model-options="{ debounce: 800 }" ng-change="vm.transportationUpdated(true, true)" ng-if="vm.tripTypes.mobileGarageType && vm.tripTypes.mobileGarageType.length > 0"><div class="inline consumer-transportation-type" ng-bind-html="vm.tripTypes.mobileGarageType[0].consumerDescription"></div></label></li></ul></center></div></div><div class="row" ng-if="vm.tripType.isPickup || vm.transportation === vm.transTypeGroups.mobile"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12"><div consumer-appointment-choose-pickup="" dealer="vm.dealer" place="vm.pickupLocation" trip-type="vm.tripType" department="vm.department"></div><div ng-if="vm.pickupLocation.isInServiceArea === false" class="validation text-danger">We\'re sorry, this address is out of our pickup area. Please choose a different address or select YOU BRING IN YOUR VEHICLE above.</div><div class="validation text-danger" ng-if="vm.tripLocationError && vm.tripLocationError.length > 0">{{vm.tripLocationError[0]}}</div></div></div><div class="row margin-top" ng-if="vm.tripType.isPickup || vm.transportation === vm.transTypeGroups.mobile"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12"><textarea class="form-control better-placeholder resize-none" rows="2" name="instructions" ng-model="vm.appointment.tripNote" placeholder="INSTRUCTIONS FOR THE DRIVER (GATE CODES, ETC)"></textarea></div></div><div class="row margin-top" ng-if="vm.tripType.isPickup"><div class="col-md-2 hidden-xs"></div><div class="col-md-5 col-xs-12"><span class="semi-bold">DOES YOUR VEHICLE HAVE A MANUAL TRANSMISSION?</span></div><div class="col-md-1 col-sm-5 col-xs-12 override-xs-padding-top-md"><label><input id="manual" type="radio" name="transmissionType" validation="required" ng-model="vm.selectedTransmission" value="1" ng-disabled="vm.dealerSlotsLoading" ng-change="vm.transmissionChanged()" ng-model-options="{ debounce: 800 }"> <span class="text-uppercase appt-radio-text">YES</span></label></div><div class="col-md-1 col-sm-5 col-xs-12"><label><input id="automatic" type="radio" name="transmissionType" validation="required" ng-model="vm.selectedTransmission" value="0" ng-disabled="vm.dealerSlotsLoading" ng-change="vm.transmissionChanged()" ng-model-options="{ debounce: 800 }"> <span class="text-uppercase appt-radio-text">NO</span></label></div></div><div class="row" ng-if="vm.detailsformsubmitted && vm.appointment.isManual === null && vm.tripType.isPickup"><div class="col-md-6 col-xs-12"></div><div class="col-md-6 col-xs-12"><div class="validation text-danger">Transmission selection is required.</div></div></div><div class="row margin-top" ng-if="vm.tripType.isPickup && vm.displayLoanerSections"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12"><span class="semi-bold" ng-bind-html="vm.configValues.consumerLoanerSectionTitle"></span></div></div><div class="row margin-top" ng-if="vm.tripType.isPickup && vm.displayLoanerSections"><div class="col-md-2 hidden-xs"></div><div class="col-md-3 col-sm-5 col-xs-12"><label><input type="radio" name="pickupTransportationType" ng-model="vm.needLoaner" value="true" ng-disabled="vm.dealerSlotsLoading" ng-change="vm.transportationUpdated(false, false)" ng-model-options="{ debounce: 800 }"> <span class="text-uppercase appt-radio-text" ng-bind-html="vm.configValues.consumerLoanerSectionRequireLoaner.toLowerCase() | sentenceCase"></span></label></div><div class="col-md-3 col-sm-5 col-xs-12"><label><input type="radio" name="pickupTransportationType" ng-model="vm.needLoaner" value="false" ng-disabled="vm.dealerSlotsLoading" ng-change="vm.transportationUpdated(false, false)" ng-model-options="{ debounce: 800 }"> <span class="text-uppercase appt-radio-text" ng-bind-html="vm.configValues.consumerLoanerSectionDoesNotNeed.toLowerCase() | sentenceCase"></span></label></div></div><div class="row margin-top" ng-if="vm.tripType.isDropOff"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12"><span class="semi-bold">WHAT TYPE OF TRANSPORTATION DO YOU NEED?</span></div></div><div class="row margin-top" ng-if="vm.tripType.isDropOff"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12"><div class="row consumer-dropoff-row"><div class="col-xs-6 col-md-2 consumer-dropoff-option padding-right-none padding-left-none" ng-repeat="type in vm.tripTypes.dropOffTransportationTypes | filter : {showInConsumer: true}" ng-class="{\'med-label\': type.consumerDescription.length > 10 && type.consumerDescription.length < 15, \'long-label\': type.consumerDescription.length > 15, \'small-label\': type.consumerDescription.length < 5, \'ng-hide\': !vm.displayLoanerSections && type.hasLoaner}"><input type="radio" id="{{type.id}}_radio" name="dropoffTransportationType" class="consumer-dropoff-radio" ng-model="vm.tripType" ng-value="type" ng-disabled="vm.dealerSlotsLoading" ng-change="vm.transportationUpdated(false, false, type)"> <label class="consumer-dropoff-label">{{ type.consumerDescription.toLowerCase() | sentenceCase }}</label></div></div></div></div><div class="row margin-top" ng-if="vm.tripType.isDropOff && vm.detailsformsubmitted && !vm.tripType"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12"><span class="validation text-danger">Transportation selection is required.</span></div></div><div class="row margin-top-30" ng-if="vm.transportation !== vm.transTypeGroups.mobile"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12 field-wrapper" ng-class="{\'col-sm-6\': vm.tripType.isPickup, \'col-sm-3\': vm.tripType.isDropOff}"><label for="advisor">ADVISOR <span ng-if="vm.canSelectAnyAdvisor">(optional)</span></label><select name="advisor" id="advisor" ng-model="vm.appointment.advisor" class="form-control padding-right-none" selectlabel="" placeholder="Advisor (optional)" ng-change="vm.getDealerSlots()" ng-model-options="{ debounce: 800 }" ng-options="(adv.firstName ? adv.firstName + \' \' + adv.lastName : adv.lastName) for adv in vm.advisors track by adv.id"><option value="" ng-if="vm.canSelectAnyAdvisor">Advisor (optional)</option></select></div></div><div class="row text-danger text-left padding-right-none" ng-if="!vm.tripLocationError && vm.availSlotErrors && !vm.dealerSlotsLoading"><div class="col-md-2 hidden-xs"></div><div class="col-md-8 col-xs-12 well-lg validation text-danger text-uppercase margin-bottom"><div ng-repeat="item in vm.availSlotErrors">{{item}}</div></div><div class="col-md-2 hidden-xs"></div></div><div class="row margin-top" ng-if="!vm.tripLocationError && vm.isApptPast === true && !vm.dealerSlotsLoading"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12 padding-top-md"><span class="validation text-danger">This appointment was scheduled in the past ({{vm.appointment.apptDateTime | date:\'MM/dd/yy h:mm a\'}}). Please select a new date/time below.</span></div></div><div class="row margin-top-sm" id="date-time-dropdowns"><div class="col-md-2 hidden-xs"></div><div class="col-md-3 col-xs-12 padding-right-none"><div class="input-group" start-view="month" selectable="vm.isDateSelectable(date, type)" min-date="vm.minCalendarDate" moment-picker="vm.currentMomentDay" change="vm.dateChanged(newValue, oldValue)" format="YYYY-MM-DD"><input class="form-control" ng-disabled="vm.dealerSlotsLoading || ((vm.tripType.isPickup === true || vm.transportation === vm.transTypeGroups.mobile) && !vm.pickupLocation)" placeholder="CHOOSE A DATE" ng-model="vm.selectedDay"> <span class="input-group-addon"><i class="material-icons md-18">calendar_month</i></span></div><div ng-if="vm.pickupLocation && !vm.selectedDay" class="validation text-danger">Please select a date.</div></div><div class="col-md-3 col-xs-12 padding-right-none field-wrapper override-xs-margin-top-md"><label for="time">SELECT TIME</label><select name="time" id="time" selectlabel="" ng-model-options="{ debounce: 800 }" ng-model="vm.time" class="form-control" ng-disabled="!vm.selectedDay || vm.dealerSlotsLoading || !vm.availTimeSlots" placeholder="CHOOSE A TIME" ng-options="time as (vm.tripType.isPickup ? time.pickupTime : time.blockTime) | date: \'shortTime\' for time in vm.times | filter: vm.timeSlotFilter | distinct: vm.distinctBy()" ng-change="vm.pickupTimeChanged()" required="required" validation="required"><option value="" disabled="">SELECT TIME</option></select><span ng-if="!vm.availTimeSlots && vm.selectedDay && !vm.dealerSlotsLoading" class="validation text-danger">No available appointments.</span></div></div><div class="row margin-top margin-bottom-30"><span ng-if="vm.dealerSlotsLoading"><center><br><br><img src="assets/images/ajax-loader.gif"></center></span><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12 ng-show" ng-if="vm.selectedDay" ng-show="vm.availTimeSlotsVisualPicker"><center><visual-date start-date="vm.selectedDay" business-hours="vm.departmentHours" closed-constraints="vm.departmentConstraints" days-displayed="vm.daysToDisplay" min-date="vm.minCalendarDate"></visual-date></center></div><div class="col-md-10 col-sm-11 col-xs-12 margin-top" ng-if="vm.pickupLocation.isInServiceArea === false || ((vm.tripType.isPickup === true || vm.transportation === vm.transTypeGroups.mobile) && !vm.pickupLocation)"><center><span class="validation text-danger">Please choose a valid pick up location</span></center></div></div><div class="row margin-top ng-hide" ng-show="vm.availTimeSlotsVisualPicker"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12"><visual-date-time ng-if="vm.availTimeSlotsVisualPicker" time-slots="vm.availTimeSlotsVisualPicker" transportation-type="vm.tripType" selected-day="vm.selectedDay" selected-time="vm.time" ,="" days-displayed="vm.daysToDisplay"></visual-date-time></div></div></div><div ng-cloak="" ng-if="vm.appointment.lineItems.length > 0 && vm.ghostGarage === 1"><div class="row margin-top"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12 padding-top-md"><div consumer-appointment-choose-pickup="" dealer="vm.dealer" place="vm.pickupLocation" trip-type="vm.tripType" department="vm.department"></div><div ng-if="vm.pickupLocation.isInServiceArea === false" class="validation text-danger">We\'re sorry, this address is out of our pickup area.<br>Please choose a different address.</div></div></div><div class="row margin-top"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12"><input type="text" class="form-control better-placeholder" ng-model="vm.appointment.tripNote" placeholder="INSTRUCTIONS FOR THE DRIVER (GATE CODES, ETC)"></div></div><div class="row margin-top" ng-if="vm.displayLoanerSections"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12"><span class="semi-bold" ng-bind-html="vm.configValues.consumerLoanerSectionTitle"></span></div></div><div class="row margin-top" ng-if="vm.displayLoanerSections"><div class="col-md-1 hidden-xs"></div><div class="col-md-3 col-xs-5"><label><input type="radio" name="pickupTransportationType" ng-model="vm.needLoaner" value="true" ng-change="vm.transportationUpdated(false, false)" ng-model-options="{ debounce: 800 }"> <span class="text-uppercase appt-radio-text" ng-bind-html="vm.configValues.consumerLoanerSectionRequireLoaner"></span></label></div><div class="col-md-3 col-xs-5"><label><input type="radio" name="pickupTransportationType" ng-model="vm.needLoaner" value="false" ng-change="vm.transportationUpdated(false, false)" ng-model-options="{ debounce: 800 }"> <span class="text-uppercase appt-radio-text" ng-bind-html="vm.configValues.consumerLoanerSectionDoesNotNeed"></span></label></div></div><div class="row margin-top" ng-if="vm.isApptPast === true && !vm.dealerSlotsLoading"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12 padding-top-md"><span class="validation text-danger">This appointment was scheduled in the past ({{vm.appointment.apptDateTime | date:\'MM/dd/yy h:mm a\'}}). Please select a new date/time below.</span></div></div><div ng-if="vm.currentMomentDay" class="row margin-top ng-hide" id="date-time-dropdowns" ng-show="vm.tripType.isDropOff === true || (vm.tripType.isPickup === true && vm.pickupLocation)"><div class="col-md-2 hidden-xs"></div><div class="col-md-3 col-xs-12 padding-right-none"><div class="input-group" start-view="month" selectable="vm.isDateSelectable(date, type)" min-date="vm.minCalendarDate" moment-picker="vm.currentMomentDay" change="vm.dateChanged(newValue, oldValue)" format="YYYY-MM-DD"><input class="form-control" ng-disabled="vm.dealerSlotsLoading || (vm.tripType.isPickup === true && !vm.pickupLocation)" placeholder="CHOOSE A DATE" ng-model="vm.selectedDay"> <span class="input-group-addon"><i class="material-icons md-18">calendar_month</i></span></div><div ng-if="vm.pickupLocation && !vm.selectedDay" class="validation text-danger">Please select a date.</div></div><div class="col-md-3 col-xs-12 padding-right-none field-wrapper override-xs-margin-top-md"><label for="time">SELECT TIME</label><select name="time" id="time" selectlabel="" ng-model-options="{ debounce: 800 }" ng-model="vm.time" class="form-control" ng-disabled="!vm.selectedDay || vm.dealerSlotsLoading || !vm.availTimeSlots" placeholder="CHOOSE A TIME" ng-options="time as (vm.tripType.isPickup ? time.pickupTime : time.blockTime) | date: \'shortTime\' for time in vm.times | filter: vm.timeSlotFilter | distinct: vm.distinctBy()" ng-change="vm.pickupTimeChanged()" required="required" validation="required"><option value="" disabled="">SELECT TIME</option></select><span ng-if="!vm.availTimeSlots && vm.selectedDay && !vm.dealerSlotsLoading" class="validation text-danger">No available appointments.</span></div></div><div class="row margin-top margin-bottom-30"><span ng-if="vm.dealerSlotsLoading"><center><br><br><img src="assets/images/ajax-loader.gif"></center></span><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12 ng-show" ng-if="vm.selectedDay" ng-show="vm.availTimeSlotsVisualPicker"><center><visual-date start-date="vm.selectedDay" business-hours="vm.departmentHours" closed-constraints="vm.departmentConstraints" days-displayed="vm.daysToDisplay" min-date="vm.minCalendarDate"></visual-date></center></div><div class="col-md-10 col-sm-11 col-xs-12" ng-if="!vm.pickupLocation"><span class="validation text-danger">Please choose a valid pick up location</span></div></div><div class="row margin-top ng-hide" ng-show="vm.availTimeSlotsVisualPicker"><div class="col-md-1 hidden-xs"></div><div class="col-md-10 col-xs-12"><visual-date-time ng-if="vm.availTimeSlotsVisualPicker" time-slots="vm.availTimeSlotsVisualPicker" transportation-type="vm.tripType" selected-day="vm.selectedDay" selected-time="vm.time" ,="" days-displayed="vm.daysToDisplay"></visual-date-time></div></div></div></form>');
$templateCache.put('app/areas/consumer/appointments/views/partials/edit-vehicle-information.view.html','<form name="consumerVehicleInformation" id="consumerVehicleInformation" role="form"><div ng-if="vm.ghostGarage === 0"><span id="radioError ng-hide" ng-show="!vm.vehicleSelected && vm.vehicleformsubmitted && vm.vehicles" class="radioError validation text-danger">Vehicle selection is required.<br></span><div class="margin-top" ng-if="vm.vehicles && vm.vehicles.length > 0"></div><div class="vehicle-row row" ng-if="vm.vehicles && vm.vehicles.length > 0" ng-repeat="vehicle in vm.vehicles"><div class="col-xs-12"><label><input class="select-vehicle-radio" type="radio" id="{{vehicle.id}}_radio" name="motoristVehicles" ng-model="vm.vehicleSelected" ng-value="vehicle" ng-change="vm.onSelectVehicle(vehicle)"> <span class="text-uppercase">{{ vehicle.year }} {{ vehicle.makeName || vehicle.make }} {{ vehicle.modelName|| vehicle.model }}<span ng-if="vehicle.vin">&nbsp;({{vehicle.vin}})</span><span ng-if="!vehicle.vin">&nbsp;(NO VIN)</span></span></label></div><div class="col-xs-12 existing-vehicle-mileage" ng-if="vm.vehicleSelected === vehicle"><input type="number" id="mileage_{{$index}}" name="mileage_{{$index}}" required="" class="inline form-control no-spinners existing-vehicle-mileage better-placeholder margin-bottom margin-top-sm margin-none" step="1" min="0" ng-model="vm.appointment.mileage" placeholder="ODOMETER"> <span class="margin-none text-danger text-validation ng-hide margin-left-20" ng-show="vm.vehicleSelected === vehicle && vm.vehicleformsubmitted === true && (!vm.appointment.mileage || vm.appointment.mileage == \'\')">Field is required.</span></div></div><div class="row margin-top-sm" ng-if="vm.vehicles && vm.vehicles.length > 0"><div class="col-xs-12 text-uppercase"><label><input class="select-vehicle-radio" type="radio" id="new_radio" name="motoristVehicles" ng-model="vm.vehicleSelected" ng-change="vm.onSelectVehicle(vm.newVehicle)" ng-value="vm.newVehicle"> Add New Vehicle</label></div></div><div class="row margin-top" ng-if="vm.vehicleSelected === vm.newVehicle || vm.vehicles == null || vm.vehicles.length == 0" ng-class="{\'older-vehicles\': vm.ymmOlderVehicles === true}"><div class="col-sm-2 col-md-1 col-xs-12 field-wrapper padding-right-none" ng-if="!vm.ymmOlderVehicles"><label for="year">YEAR</label><select name="year" id="year" selectlabel="" ng-model="vm.appointment.year" ng-model-options="{ debounce: 400 }" class="form-control" placeholder="Year" ng-init="vm.getYears()" ng-disabled="!vm.vehicleYears || vm.loadingYears" ng-options="year as year for year in vm.vehicleYears track by year" ng-change="vm.updateMakes()" required="required" validation="required"><option value="" disabled="">Year</option></select><span class="appointments-spinner" ng-if="vm.loadingYears"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-2 col-xs-12 padding-right-none" ng-if="vm.ymmOlderVehicles === true"><input type="text" ng-pattern="/^\\d+$/" id="vehicle_year" name="vehicle_year" ng-model="vm.appointment.year" class="form-control better-placeholder" clean="true" ng-keydown="vm.vehicleKeyDown($event)" inputmode="numeric" pattern="[0-9]*" placeholder="YEAR" required="" validation="required:alt=Required|custom:vm.validation.valYear():alt=Invalid Year"></div><div class="col-sm-3 col-xs-12 padding-right-none field-wrapper" ng-if="!vm.ymmOlderVehicles"><label for="make">MAKE</label><select name="make" id="make" class="form-control" placeholder="Make" selectlabel="" ng-model="vm.selectedMake" ng-model-options="{ debounce: 800 }" ng-disabled="!vm.appointment.year || vm.loadingMakes" ng-options="make.make for make in vm.makes track by make.makeCode" ng-change="vm.updateModels()" required="required" validation="required"><option value="" disabled="">Make</option></select><span class="appointments-spinner" ng-if="vm.loadingMakes"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-3 col-xs-12 padding-right-none" ng-if="vm.ymmOlderVehicles === true"><input type="text" id="vehicle_make" name="vehicle_make" ng-model="vm.appointment.make" class="form-control better-placeholder" placeholder="MAKE" required="" validation="required:alt=Required"></div><div class="col-sm-2 col-md-3 col-xs-12 padding-right-none field-wrapper" ng-if="!vm.ymmOlderVehicles"><label for="model">MODEL</label><select name="model" id="model" selectlabel="" ng-model="vm.selectedModel" ng-model-options="{ debounce: 800 }" class="form-control" placeholder="Model" ng-disabled="!vm.appointment.make || vm.loadingModels" ng-options="model.model for model in vm.models track by model.modelCode" ng-change="vm.modelSelected()" required="required" validation="required"><option value="" disabled="">Model</option></select><span class="appointments-spinner" ng-if="vm.loadingModels"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-2 col-md-3 col-xs-12 padding-right-none" ng-if="vm.ymmOlderVehicles === true"><input type="text" id="vehicle_model" name="vehicle_model" ng-model="vm.appointment.model" class="form-control better-placeholder" placeholder="MODEL" required="" validation="required:alt=Required"></div><div class="col-sm-2 col-xs-12 padding-right-none field-wrapper" ng-if="!vm.ymmOlderVehicles"><label for="style">STYLE</label><select name="style" id="style" selectlabel="" ng-model="vm.appointment.subModel" ng-model-options="{ debounce: 800 }" class="form-control" placeholder="Sub Model" ng-disabled="!vm.subModels || vm.loadingSubModels || vm.subModels.length === 0" ng-options="submodel for submodel in vm.subModels" ng-change="vm.updateStyle()"><option value="" disabled="">Sub Model</option></select><span class="appointments-spinner" ng-if="vm.loadingSubModels"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-2 col-xs-9 padding-right-none"><input type="number" id="mileage" name="mileage" class="form-control no-spinners better-placeholder" mask="9?9?9?9?9?9?" mask-restrict="reject" required="" validation="required:alt=Required" inputmode="numeric" ng-model="vm.appointment.mileage" placeholder="ODOMETER"></div><div class="col-sm-1 col-xs-2 padding-right-none field-wrapper"><label for="style">MI/KM</label><select id="odometer_type" selectlabel="" required="" name="odometer_type" ng-model="vm.appointment.mileageType" placeholder="Mi/Km" ng-options="measurement as measurement.abbreviation for measurement in vm.odometerTypes track by measurement.type" class="form-control"></select></div></div><div class="row margin-top" ng-if="vm.ymmOlderVehicles === true"><div class="col-sm-2 col-xs-12 padding-right-none field-wrapper"><div id="newer-vehicles" class="theme-link text-uppercase margin-top" ng-click="vm.switchYMMToDropDowns()">Newer Vehicles</div></div></div></div><div ng-if="vm.ghostGarage === 1"><div class="row margin-top-30"><div class="col-sm-12 col-xs-12 text-nowrap margin-top-30"><h3 class="font-size-14 font-bold margin-none">VEHICLE DETAILS</h3></div></div><div class="row margin-top" ng-class="{\'older-vehicles\': vm.ymmOlderVehicles === true}"><div class="col-sm-5 col-xs-12 field-wrapper padding-right-none" ng-if="!vm.ymmOlderVehicles"><label for="year">YEAR</label><select name="year" id="year" selectlabel="" ng-model="vm.appointment.year" ng-model-options="{ debounce: 400 }" class="form-control" placeholder="Year" ng-init="vm.getYears()" ng-disabled="!vm.vehicleYears || vm.loadingYears" ng-options="year as year for year in vm.vehicleYears track by year" ng-change="vm.updateMakes()" required="required" validation="required"><option value="" disabled="">Year</option></select><span class="appointments-spinner" ng-if="vm.loadingYears"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.ymmOlderVehicles === true"><input type="text" ng-pattern="/^\\d+$/" id="vehicle_year" name="vehicle_year" ng-model="vm.appointment.year" class="form-control better-placeholder" clean="true" ng-keydown="vm.vehicleKeyDown($event)" inputmode="numeric" pattern="[0-9]*" placeholder="YEAR" required="" validation="required:alt=Required|custom:vm.validation.valYear():alt=Invalid Year"></div><div class="col-sm-5 col-xs-12 padding-right-none field-wrapper" ng-if="!vm.ymmOlderVehicles"><label for="make">MAKE</label><select name="make" id="make" class="form-control" placeholder="Make" selectlabel="" ng-model="vm.selectedMake" ng-model-options="{ debounce: 800 }" ng-disabled="!vm.appointment.year || vm.loadingMakes" ng-options="make.make for make in vm.makes track by make.makeCode" ng-change="vm.updateModels()" required="required" validation="required"><option value="" disabled="">Make</option></select><span class="appointments-spinner" ng-if="vm.loadingMakes"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.ymmOlderVehicles === true"><input type="text" id="vehicle_make" name="vehicle_make" ng-model="vm.appointment.make" class="form-control better-placeholder" placeholder="MAKE" required="" validation="required:alt=Required"></div></div><div class="row margin-top"><div class="col-sm-5 col-xs-12 padding-right-none field-wrapper" ng-if="!vm.ymmOlderVehicles"><label for="model">MODEL</label><select name="model" id="model" selectlabel="" ng-model="vm.selectedModel" ng-model-options="{ debounce: 800 }" class="form-control text-uppercase" placeholder="Model" ng-disabled="!vm.appointment.make || vm.loadingModels" ng-options="model.model for model in vm.models track by model.modelCode" ng-change="vm.modelSelected()" required="required" validation="required"><option value="" disabled="">Model</option></select><span class="appointments-spinner" ng-if="vm.loadingModels"><img src="assets/images/ajax-loader.gif"></span></div><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.ymmOlderVehicles === true"><input type="text" id="vehicle_model" name="vehicle_model" ng-model="vm.appointment.model" class="form-control better-placeholder" placeholder="MODEL" required="" validation="required:alt=Required"></div><div class="col-sm-4 col-xs-9 padding-right-none ghost-garage-col"><input type="number" id="mileage" name="mileage" class="form-control no-spinners better-placeholder" mask="9?9?9?9?9?9?" mask-restrict="reject" required="" validation="required:alt=Required" inputmode="numeric" step="1" min="0" ng-model="vm.appointment.mileage" placeholder="ODOMETER"></div><div class="col-sm-1 col-xs-2 padding-right-none field-wrapper"><label for="style">MI/KM</label><select id="odometer_type" selectlabel="" required="" name="odometer_type" ng-model="vm.appointment.mileageType" placeholder="Mi/Km" ng-options="measurement as measurement.abbreviation for measurement in vm.odometerTypes track by measurement.type" class="form-control"></select></div></div><div class="row margin-top" ng-if="vm.ymmOlderVehicles === true"><div class="col-sm-4 col-xs-12 padding-right-none"><div id="newer-vehicles" class="theme-link text-uppercase margin-top" ng-click="vm.switchYMMToDropDowns()">Newer Vehicles</div></div></div></div></form>');
$templateCache.put('app/areas/consumer/appointments/views/partials/edit-vehicle-owner-information.view.html','<form name="consumerVehicleOwner" id="consumerVehicleOwner" role="form"><div ng-if="vm.ghostGarage === 0"><div class="row margin-top"><div id="appts-business-checkbox-consumer" class="col-sm-3 col-xs-12 text-nowrap"><input type="checkbox" class="checkbox" ng-model="vm.appointment.customerIsBusiness" ng-change="vm.isBusinessUpdated()" value="true" id="isBusiness"><span>This is a business</span></div></div><div class="row"><div class="col-sm-3 col-xs-12 padding-right-none" ng-if="vm.appointment.customerType === vm.customerType.individual || vm.customerNameRequired()"><input type="text" name="firstname" id="firstname" ng-model="vm.appointment.customerFirstName" class="form-control better-placeholder" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}" required="required" validation="required|custom:vm.validation.combinedCustomerNameLength():alt=*"></div><div class="col-sm-3 col-xs-12 padding-right-none" ng-if="vm.appointment.customerType !== vm.customerType.individual && !vm.customerNameRequired()"><input type="text" name="firstname" id="firstname" ng-model="vm.appointment.customerFirstName" class="form-control better-placeholder" validation="custom:vm.validation.combinedCustomerNameLength():alt=*" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}"></div><div class="col-sm-3 col-xs-12 padding-right-none override-xs-margin-top-md"><input type="text" name="lastname" id="lastname" ng-model="vm.appointment.customerLastName" class="form-control better-placeholder" maxlength="50" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'LAST NAME\' : \'BUSINESS NAME\'}}" required="required" validation="min_len:2|max_len:50|required|custom:vm.validation.combinedCustomerNameLength():alt=*"></div><div class="col-sm-3 col-xs-12 override-xs-margin-top-md padding-right-none"><input type="email" name="email" id="email" ng-model="vm.appointment.customerEmail" class="form-control better-placeholder" placeholder="YOUR@EMAIL.COM" required="required" validation="required|custom:vm.validation.validEmail():alt=*"></div><div class="col-sm-3 col-xs-12 padding-right-none override-xs-margin-top-md"><input type="text" name="mobilePhone" id="mobilePhone" ng-model="vm.appointment.customerPhone" inputmode="numeric" ng-model-options="{ debounce: 750 }" ng-blur="vm.mobilePhoneUpdated(vm.appointment.customerPhone)" ng-change="vm.mobilePhoneUpdated(vm.appointment.customerPhone)" class="form-control better-placeholder" placeholder="Mobile Phone" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="required" validation="required"> <span class="text-danger" ng-show="vm.appointment.customerPhone.length > 0 && vm.appointment.invalidPhone === true">Invalid phone number.</span> <span class="text-danger" ng-show="vm.customerPhoneType.type === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="vm.customerPhoneType.type === vm.phoneTypes.voip">Number is a VoIP</span></div></div><div class="row margin-top" ng-if="vm.displayAddressFields()"><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.requiredfields.customerAddress"><input type="text" id="customer_address" name="customer_address" maxlength="45" validation="required" required="" ng-model="vm.appointment.customerAddress1" class="better-placeholder form-control" clean="true" placeholder="STREET ADDRESS"></div><div class="col-sm-3 col-xs-12 padding-right-none override-xs-margin-top-md" ng-if="vm.requiredfields.customerCity"><input type="text" id="customer_city" name="customer_city" maxlength="30" autocomplete="nope" validation="required" required="" ng-model="vm.appointment.customerCity" class="better-placeholder form-control" clean="true" placeholder="CITY"></div><div class="col-sm-2 col-xs-12 padding-right-none override-xs-margin-top-md field-wrapper" ng-if="vm.requiredfields.customerState"><label for="customer_state">STATE</label><select class="form-control" id="customer_state" name="customer_state" selectlabel="" required="" ng-model="vm.appointment.customerState" ng-options="item as item for item in vm.usStates"><option value="" selected="selected" disabled="">State</option></select><span class="text-danger" ng-show="vm.vehicleFormSubmitted && !vm.appointment.customerState">Field is required</span></div><div class="col-sm-2 col-xs-12 padding-right-none override-xs-margin-top-md" ng-if="vm.requiredfields.customerZip"><input type="text" id="customer_zip" name="customer_zip" validation="required" required="" autocomplete="nope" ng-model="vm.appointment.customerZip" class="better-placeholder form-control" mask-restrict="reject" mask="99999" clean="true" placeholder="ZIP"></div></div><div class="row margin-top" ng-if="vm.displayCountyCountry() || vm.displayLanguage()"><div class="col-sm-4 col-xs-12 padding-right-none" ng-if="vm.requiredfields.customerCounty && vm.displayCountyCountry()"><input type="text" id="customer_county" name="customer_county" ng-maxlength="30" validation="required" required="" autocomplete="nope" ng-model="vm.appointment.customerCounty" class="better-placeholder form-control" clean="true" placeholder="COUNTY"></div><div class="col-sm-4 col-xs-12 padding-right-none override-xs-margin-top-md field-wrapper" ng-if="vm.requiredfields.customerCountry && vm.displayCountyCountry()"><label for="customer_country">COUNTRY</label><select class="form-control" id="customer_country" name="customer_country" selectlabel="" required="" ng-model="vm.appointment.customerCountryShortCode" ng-options="s.value as s.text for s in vm.supportedCountries"><option value="" selected="selected" disabled="">Country</option></select></div><div class="col-sm-4 col-xs-12 padding-right-none override-xs-margin-top-md field-wrapper" ng-if="vm.requiredfields.language && vm.displayLanguage()"><label for="customer_language">LANGUAGE</label><select class="form-control" id="customer_language" name="customer_language" selectlabel="" required="" ng-model="vm.appointment.customerLanguage" ng-options="s.value as s.text for s in vm.appointmentLanguages"><option value="" selected="selected" disabled="">Language</option></select></div></div></div><div ng-if="vm.ghostGarage === 1"><div class="row margin-top-30"><div class="col-sm-5 col-xs-12 text-nowrap"><h3 class="margin-none">CUSTOMER DETAILS</h3></div><div id="appts-business-checkbox-consumer" class="col-sm-3 col-xs-12 text-nowrap"><input type="checkbox" class="checkbox" ng-model="vm.appointment.customerIsBusiness" ng-change="vm.isBusinessUpdated()" value="true" id="isBusiness"><span>This is a business</span></div></div><div class="row"><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.appointment.customerType === vm.customerType.individual || vm.customerNameRequired()"><input type="text" name="firstname" id="firstname" ng-model="vm.appointment.customerFirstName" class="form-control better-placeholder" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}" required="required" validation="required"></div><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.appointment.customerType !== vm.customerType.individual && !vm.customerNameRequired()"><input type="text" name="firstname" id="firstname" ng-model="vm.appointment.customerFirstName" class="form-control better-placeholder" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'FIRST NAME\' : \'CUSTOMER NAME\'}}"></div><div class="col-sm-5 col-xs-12 padding-right-none override-xs-margin-top-md"><input type="text" name="lastname" id="lastname" ng-model="vm.appointment.customerLastName" class="form-control better-placeholder" maxlength="50" placeholder="{{vm.appointment.customerType === vm.customerType.individual ? \'LAST NAME\' : \'BUSINESS NAME\'}}" required="required" validation="min_len:2|max_len:50|required"></div></div><div class="row margin-top"><div class="col-sm-5 col-xs-12 override-xs-margin-top-md padding-right-none"><input type="email" name="email" id="email" ng-model="vm.appointment.customerEmail" class="form-control better-placeholder" placeholder="YOUR@EMAIL.COM" required="required" validation="required|custom:vm.validation.validEmail():alt=*"></div><div class="col-sm-5 col-xs-12 padding-right-none override-xs-margin-top-md"><input type="text" name="mobilePhone" id="mobilePhone" ng-model="vm.appointment.customerPhone" inputmode="numeric" ng-model-options="{ debounce: 750 }" ng-blur="vm.mobilePhoneUpdated(vm.appointment.customerPhone)" ng-change="vm.mobilePhoneUpdated(vm.appointment.customerPhone)" class="form-control better-placeholder" placeholder="Mobile Phone" mask-restrict="reject" mask="(999) 999-9999" clean="true" required="required" validation="required"> <span class="text-danger" ng-show="vm.appointment.customerPhone.length > 0 && vm.appointment.invalidPhone === true">Invalid phone number.</span> <span class="text-danger" ng-show="vm.customerPhoneType.type === vm.phoneTypes.landline">Number is a landline</span> <span class="text-danger" ng-show="vm.customerPhoneType.type === vm.phoneTypes.voip">Number is a VoIP</span></div></div><div class="row margin-top-30" ng-if="vm.displayAddressFields()"><div class="col-sm-5 col-xs-12 text-nowrap"><h3 class="margin-none">ADDRESS DETAILS</h3></div></div><div class="row margin-top" ng-if="vm.displayAddressFields()"><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.requiredfields.customerAddress"><input type="text" id="customer_address" name="customer_address" maxlength="45" validation="required" required="" ng-model="vm.appointment.customerAddress1" class="better-placeholder form-control" clean="true" placeholder="STREET ADDRESS"></div><div class="col-sm-5 col-xs-12 padding-right-none override-xs-margin-top-md" ng-if="vm.requiredfields.customerCity"><input type="text" id="customer_city" name="customer_city" maxlength="30" autocomplete="nope" validation="required" required="" ng-model="vm.appointment.customerCity" class="better-placeholder form-control" clean="true" placeholder="CITY"></div></div><div class="row margin-top" ng-if="vm.requiredfields.customerState || vm.requiredfields.customerZip"><div class="col-sm-5 col-xs-12 padding-right-none override-xs-margin-top-md field-wrapper" ng-if="vm.requiredfields.customerState"><label for="customer_state">STATE</label><select class="form-control" id="customer_state" name="customer_state" selectlabel="" required="" ng-model="vm.appointment.customerState" ng-options="item as item for item in vm.usStates"><option value="" selected="selected" disabled="">State</option></select></div><div class="col-sm-5 col-xs-12 padding-right-none override-xs-margin-top-md" ng-if="vm.requiredfields.customerZip"><input type="text" id="customer_zip" name="customer_zip" validation="required" required="" autocomplete="nope" ng-model="vm.appointment.customerZip" class="better-placeholder form-control" mask-restrict="reject" mask="99999" clean="true" placeholder="ZIP"></div></div><div class="row margin-top" ng-if="vm.displayCountyCountry() || vm.displayLanguage()"><div class="col-sm-5 col-xs-12 padding-right-none" ng-if="vm.requiredfields.customerCounty && vm.displayCountyCountry()"><input type="text" id="customer_county" name="customer_county" ng-maxlength="30" validation="required" required="" autocomplete="nope" ng-model="vm.appointment.customerCounty" class="better-placeholder form-control" clean="true" placeholder="COUNTY"></div><div class="col-sm-5 col-xs-12 padding-right-none override-xs-margin-top-md field-wrapper" ng-if="vm.requiredfields.customerCountry && vm.displayCountyCountry()"><label for="customer_country">COUNTRY</label><select class="form-control" id="customer_country" name="customer_country" selectlabel="" required="" ng-model="vm.appointment.customerCountryShortCode" ng-options="s.value as s.text for s in vm.supportedCountries"><option value="" selected="selected" disabled="">Country</option></select></div></div><div class="row margin-top" ng-if="vm.requiredfields.language && vm.displayLanguage()"><div class="col-sm-4 col-xs-12 padding-right-none override-xs-margin-top-md field-wrapper"><label for="customer_language">LANGUAGE</label><select class="form-control" id="customer_language" name="customer_language" selectlabel="" required="" ng-model="vm.appointment.customerLanguage" ng-options="s.value as s.text for s in vm.appointmentLanguages"><option value="" selected="selected" disabled="">Language</option></select></div></div></div></form>');
$templateCache.put('app/areas/consumer/appointments/views/partials/landing-choose-department-transportation.view.html','<div class="panel consumer-appt-panel"><div class="row"><div class="col-xs-12"><div ng-if="!vm.department.rank" class="text-uppercase consumer-header-text" font-bold="" margin-bottom="">{{vm.department.name}}</div><div ng-if="vm.department.rank && vm.department.consumerTitle && vm.department.consumerTitle.length > 0" class="text-uppercase consumer-header-text font-bold margin-bottom" ng-bind-html="vm.department.consumerTitle"></div><p ng-if="vm.department.rank && vm.department.consumerDescription && vm.department.consumerDescription.length > 0" ng-bind-html="vm.department.consumerDescription"></p></div></div><div class="row margin-top" ng-if="::vm.showRadioButtons()"><div class="col-md-4 col-xs-12" ng-if="vm.defaultPickupTransportationType" ng-class="{\'col-sm-5\': !vm.defaultMobileGarageTransortationType, \'col-sm-4\': vm.defaultMobileGarageTransortationType}"><label class="radio-inline"><input type="radio" name="appointmentType" ng-model="vm.tripType" ng-value="vm.defaultPickupTransportationType"><div for="pickup" class="text-uppercase consumer-subheader-text font-bold margin-bottom" ng-bind-html="vm.firstChoiceTitle"></div></label></div><div class="col-md-4 col-xs-12" ng-if="vm.defaultDropoffTransportationType" ng-class="{\'col-sm-5\': !vm.defaultMobileGarageTransortationType, \'col-sm-4\': vm.defaultMobileGarageTransortationType}"><label class="radio-inline"><input type="radio" name="appointmentType" ng-model="vm.tripType" ng-value="vm.defaultDropoffTransportationType"><div for="dropoff" class="text-uppercase consumer-subheader-text font-bold margin-bottom" ng-bind-html="vm.secondChoiceTitle"></div></label></div><div class="col-sm-4 col-xs-12" ng-if="vm.defaultMobileGarageTransortationType"><label class="radio-inline"><input type="radio" name="appointmentType" ng-model="vm.tripType" ng-value="vm.defaultMobileGarageTransortationType"><div for="mobile" class="text-uppercase consumer-subheader-text font-bold margin-bottom" ng-bind-html="vm.defaultMobileGarageTransortationType.consumerDescription"></div></label></div></div><div class="row margin-top"><div class="col-sm-9 col-xs-12" ng-if="vm.dealer"><div consumer-appointment-choose-pickup="" dealer="vm.dealer" place="vm.pickupLocation" clean-input="true" department="vm.department" trip-type="vm.tripType" ng-if="(vm.defaultPickupTransportationType && vm.tripType === vm.defaultPickupTransportationType) || (vm.defaultMobileGarageTransortationType && vm.tripType === vm.defaultMobileGarageTransortationType)"></div></div><div class="col-sm-3 col-xs-12 text-right override-xs-margin-top-md"><button class="btn btn-rounded btn-primary text-uppercase" ladda="vm.loading" ng-disabled="vm.disableGetStarted()" ng-click="vm.getStarted(vm.tripType)">{{vm.buttonText}}</button></div></div></div>');
$templateCache.put('app/areas/consumer/appointments/views/partials/message.view.html','<div class="modal-header"><h5 class="modal-title inline text-uppercase" id="exampleModalLabel">{{vm.title}}</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body">{{vm.message}}</div><div class="modal-footer" ng-if="!vm.buttons"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.close()">Ok</button></div><div class="modal-footer" ng-if="vm.buttons"><button ng-repeat="button in vm.buttons" type="button" class="btn" ng-class="button.class" data-dismiss="modal" ng-click="vm.resolve(button.result)">{{ button.text }}</button></div>');
$templateCache.put('app/areas/consumer/appointments/views/partials/view-appointment-details.view.html','<div class="row"><div class="col-sm-4 col-xs-12 visible-xs"><calendar-post-it-note caltitle="vm.isPickup ? \'WE PICK IT UP\' : vm.isMobile ? \'WE WILL ARRIVE\' : \'YOU BRING IT IN\'" date="vm.tripPickupDisplayTime || vm.appointment.apptDateTime"></calendar-post-it-note></div><div class="col-xs-12" ng-class="{\'col-sm-6\': vm.dealerIntegrations && vm.dealerIntegrations.isDigniFiEnabled, \'col-sm-8\': !vm.dealerIntegrations || (vm.dealerIntegrations && !vm.dealerIntegrations.isDigniFiEnabled ) }"><div class="padding-top-lg"><h3 class="text-uppercase">Owner And Vehicle Information</h3><div ng-if="vm.appointment.customerFirstName || vm.appointment.customerLastName">{{ vm.appointment.customerFirstName }} {{ vm.appointment.customerLastName }}</div><div>{{ vm.appointment.customerEmail }}</div><div>{{ vm.appointment.customerPhone | tel }}</div><div>{{ vm.appointment.year }} <span ng-if="vm.appointment.selectedDMSMake">{{vm.appointment.selectedDMSMake.makeName || vm.appointment.selectedDMSMake.make}}</span><span ng-if="!vm.appointment.selectedDMSMake">{{ vm.appointment.make }}</span> <span ng-if="vm.appointment.selectedDMSModel">{{vm.appointment.selectedDMSModel.model}}</span><span ng-if="!vm.appointment.selectedDMSModel">{{ vm.appointment.model }}</span></div><div ng-if="vm.appointment.mileage && vm.appointment.mileage !== 0 && vm.appointment.mileage !== \'\'">{{ vm.appointment.mileage | number : fractionSize }}{{ vm.appointment.mileageType.abbreviation }}</div></div><div class="padding-top-lg"><h3 class="text-uppercase">Services</h3><div class="padding-bottom-md" ng-if="vm.appointment.custom && vm.appointment.custom !== \'\'">{{ vm.appointment.custom }}</div><ul class="appointment-padded-ul margin-none"><li ng-repeat="service in vm.previouslydeclinedservices | filter: { checked: true } as results"><span ng-if="!service.isGeneric"><span class="text-uppercase"><span ng-if="service.isRecommendedMaintenance">{{service.dealerOpCode.consumerName || service.opCodeDescription || service.opCode}}</span> <span ng-if="!service.isRecall && !service.isRecommendedMaintenance">{{service.dealerOpCode.consumerName || service.overrideName || service.dealerAppointmentServiceOpCode.name || service.opCodeDescription || service.opCode }}</span></span></span> <span ng-if="!service.isGeneric && !service.isRecommendedMaintenance && !service.isRecommendedMaintenance && service.note.trim().length > 0"><br>{{ service.note }}</span></li></ul><ul class="appointment-padded-ul"><li ng-repeat="service in vm.appointment.lineItems | filter: { isRecall: true, checked: true } as results track by service.manufacturerNumber"><span class="text-uppercase">Recall - #{{service.manufacturerNumber}} {{service.recallDisplayName}}</span> <span ng-if="vm.dealer.configValues.displayConsumerPrices === \'true\'"><span class="pull-right" ng-if="service.retailPrice && service.retailPrice > 0">{{service.pricePrefix}} <strong>${{service.retailPrice | number:2}}</strong></span> <span class="pull-right" ng-if="!service.retailPrice || service.retailPrice === 0"><strong>VARIES</strong></span></span></li><li ng-repeat="service in vm.appointment.lineItems | filter: { isRecall: false, isAutomatic: false } as results"><span ng-if="!service.isGeneric"><span class="text-uppercase"><span ng-if="service.isRecommendedMaintenance">{{service.overrideName || service.opCodeDescription || service.opCode || service.dealerAppointmentServiceOpCode.name}}</span><span ng-if="!service.isRecall && !service.isRecommendedMaintenance">{{service.consumerName || service.overrideName || service.dealerAppointmentServiceOpCode.name || service.opCode}}</span></span></span> <span ng-if="!service.isGeneric && !service.isRecommendedMaintenance && !service.isRecommendedMaintenance && service.note.trim().length > 0"><br>{{ service.note }}</span> <span ng-if="service.isGeneric"><span class="text-uppercase">{{ service.genericName || \'ADDITIONAL SERVICES\'}}</span><span ng-if="service.note">:</span> {{ service.note }}</span> <span ng-if="vm.dealer.configValues.displayConsumerPrices === \'true\'"><span class="pull-right" ng-if="service.retailPrice && service.retailPrice > 0">{{service.pricePrefix}} <strong>${{service.retailPrice | number:2}}</strong></span> <span class="pull-right" ng-if="!service.retailPrice || service.retailPrice === 0"><strong>VARIES</strong></span></span></li></ul><span ng-if="vm.dealer.configValues.displayConsumerPrices === \'true\'"><span class="pull-right">TOTAL ESTIMATE (excl taxes & fees): <strong>${{::vm.getLineItemsTotal() | number:2}}</strong></span></span></div><div class="padding-top-lg"><h3 class="text-uppercase">Appointment<span ng-if="!vm.isMobile">&nbsp;and Transportation</span></h3><div ng-if="vm.isDropoff"><div>Please drop off your vehicle on:</div><strong><div class="text-uppercase">{{ vm.appointment.apptDateTime | date: \'fullDate\'}} <span class="text-lowercase">at</span> {{ vm.appointment.apptDateTime | date: \'h:mm a\' }} <span class="text-lowercase">at</span></div><div>{{ vm.dealer.address }}, {{ vm.dealer.city }}, {{ vm.dealer.state }} {{ vm.dealer.zip }}</div></strong></div><div ng-if="vm.isPickup"><div>We will pick up your vehicle on:</div><strong><div class="text-uppercase">{{ vm.tripPickupDisplayTime | date: \'fullDate\'}} <span class="text-lowercase">at</span> {{ vm.tripPickupDisplayTime | date: \'h:mm a\' }} <span class="text-lowercase">at</span></div><div>{{ vm.pickupLocation.streetAddress }}, {{ vm.pickupLocation.city }}, {{ vm.pickupLocation.state }} {{ vm.pickupLocation.zipCode }}</div></strong></div><div ng-if="vm.isMobile"><div>We will arrive to service your vehicle on:</div><strong><div class="text-uppercase">{{ vm.appointment.apptDateTime | date: \'fullDate\'}} <span class="text-lowercase">at</span> {{ vm.appointment.apptDateTime | date: \'h:mm a\' }} <span class="text-lowercase">at</span></div><div>{{ vm.pickupLocation.streetAddress }}, {{ vm.pickupLocation.city }}, {{ vm.pickupLocation.state }} {{ vm.pickupLocation.zipCode }}</div></strong></div><div class="margin-top" ng-if="vm.appointment.dealerEmployeeId"><strong>SERVICE ADVISOR</strong><div ng-if="vm.appointment.dealerEmployeeFirstName || vm.appointment.dealerEmployeeLastName">{{ vm.appointment.dealerEmployeeFirstName }} {{ vm.appointment.dealerEmployeeLastName }}</div><div ng-if="vm.appointment.dealerEmployeeOfficePhone">{{ vm.appointment.dealerEmployeeOfficePhone | tel }}</div><div ng-if="!vm.appointment.dealerEmployeeOfficePhone">{{ vm.dealer.mainPhoneNumber | tel }}</div></div><div class="margin-top" ng-if="!vm.isMobile"><strong>TRANSPORTATION</strong><br><span class="text-capitalize" ng-if="!vm.isHideRideShareCreditTransportationType()">{{vm.getTripTypeLabel()}}</span></div><div ng-if="vm.credit" ng-class="{\'margin-top\': !vm.isHideRideShareCreditTransportationType()}">{{vm.getCreditDescription()}} {{ vm.credit.creditAmount/100 | currency }}<br>{{ vm.credit.startTime | localDate:\'MMM D YYYY\' }} - {{ vm.credit.endTime | localDate:\'MMM D YYYY\' }}</div></div><div ng-if="::(vm.isPickup || vm.isMobile)" class="row padding-top-lg"><div class="driver-info col-xs-6 col-sm-6"><h3 ng-if="!vm.isMobile">Your Driver</h3><h3 ng-if="vm.isMobile">Your Mobile Tech</h3><div ng-if="::((vm.isPickup || vm.isMobile )&& vm.appointment.tripDriver.driverPhoto)" class="margin-top margin-bottom"><img class="profile-photo" ng-src="{{ ::vm.appointment.tripDriver.driverPhoto }}"></div><div ng-if="vm.appointment.tripDriver.name"><div>{{ vm.appointment.tripDriver.name }}</div><div>{{ vm.appointment.tripStateName }}</div></div><div ng-if="!vm.appointment.tripDriver.name"><span ng-if="vm.isPickup">Your driver has not been assigned.</span> <span ng-if="vm.isMobile">Your mobile tech has not been assigned.</span><br>Please check back soon.</div></div></div></div><div class="col-sm-4 col-xs-12 hidden-xs"><calendar-post-it-note caltitle="vm.isPickup ? \'WE PICK IT UP\' : vm.isMobile ? \'WE WILL ARRIVE\' : \'YOU BRING IT IN\'" date="vm.tripPickupDisplayTime || vm.appointment.apptDateTime"></calendar-post-it-note></div><div ng-if="vm.dealerIntegrations && vm.dealerIntegrations.isDigniFiEnabled" class="col-xs-12 col-sm-2 dignifi-container"><dignifi dealer-id="vm.dealerIntegrations.digniFiDealerId"></dignifi></div></div>');
$templateCache.put('app/areas/consumer/loaner/components/ars-review-component/ars-review.view.html','<div class="margin-bottom-20">Please review the information below regarding your loaner. You must agree to all the terms, sign and submit prior to receiving the loaner.</div><h3>Loaner Information</h3><div class="margin-bottom-20"><div class="bold margin-bottom-md">{{vm.year}} {{vm.make}} {{vm.model}}</div><div class="bold margin-bottom-md">VIN: {{vm.vin}}</div><div class="bold margin-bottom-md" ng-if="vm.mileage">Odometer: {{vm.mileage}}</div><div class="bold margin-bottom-30" ng-if="vm.fuel">Fuel:<div class="margin-bottom-20"><rzslider rz-slider-model="vm.fuel" rz-slider-options="vm.sliderOptions"></rzslider></div></div></div><consumer-damage-issues ng-model="vm.issues" route-params="vm.routeParams"></consumer-damage-issues><div class="margin-bottom-md">Please agree to the terms below, to continue.</div><div ng-repeat="term in vm.terms" class="margin-bottom-md row"><div class="col-xs-2"><switch name="switch_{{$index}}" ng-model="term.accepted" disabled="vm.fieldsDisabled" class="green" required="required"></switch></div><div class="col-xs-10">{{term.text}}</div></div><div class="margin-top-20 text-center"><a ng-href="{{vm.contractLink}}" class="theme-link">VIEW FULL CONTRACT</a></div><div class="row margin-top"><div class="col-xs-12"><div class="dashed-signature-container"><signature-pad accept="accept" clear="clear" height="220" width="768" dataurl="vm.dataurl"></signature-pad><div class="signature-x">x</div><div class="text-center"><span class="font-size-8">Sign your name with your finger</span></div></div><div href="#" ng-click="vm.clear()" class="pull-right cursor-pointer text-uppercase font-size-10 margin-top-sm margin-bottom">Clear Signature</div><div class="text-danger" ng-if="vm.error">{{vm.error}}</div></div></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" disabled="inputForm.$invalid" next="vm.nextPage()" loading="vm.saving" next-text="\'Next\'"></contact-footer>');
$templateCache.put('app/areas/consumer/loaner/components/damage-issues/damage-issues.component.view.html','<div class="bold" ng-class="{\'margin-bottom-md\': showItems, \'margin-bottom-20\': !showItems}">Damage/Issues: <a href="#" ng-click="showItems = !showItems" class="theme-link">{{vm.ngModel.length}} items</a></div><div ng-show="showItems" class="margin-bottom-20"><div ng-repeat="item in vm.ngModel" class="border-top border-top-gray"><div class="margin-top-md margin-bottom-md bold">{{item.description}}</div><div ng-if="!item.media.length" class="margin-left-20 margin-bottom-md">No images to display</div><div class="row"><div class="margin-left-20"><div ng-repeat="mediaItem in item.media" class="col-xs-12 margin-right-md margin-bottom-md"><img ng-if="mediaItem.mediaType === vm.mediaTypes.photo" ng-src="{{mediaItem.url}}" class="loaner-consumer-damage-image"><video ng-if="mediaItem.mediaType === vm.mediaTypes.video" controls=""><source ng-src="{{ mediaItem.url }}"></video><div class="text-center">{{image.description}}</div></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/loaner/components/dealerware-review-component/dealerware-review.view.html','<div class="margin-bottom-20">Please review the information below regarding your loaner. You must agree to all the terms, sign and submit prior to receiving the loaner.</div><h3>Loaner Information</h3><div class="margin-bottom-20"><div class="bold margin-bottom-md">{{vm.year}} {{vm.make}} {{vm.model}}</div><div class="bold margin-bottom-md">VIN: {{vm.vin}}</div><div class="bold margin-bottom-md" ng-if="vm.mileage">Odometer: {{vm.mileage}}</div><div class="bold margin-bottom-30" ng-if="vm.fuel">Fuel:<div class="margin-bottom-20"><rzslider rz-slider-model="vm.fuel" rz-slider-options="vm.sliderOptions"></rzslider></div></div></div><consumer-damage-issues ng-model="vm.issues" route-params="vm.routeParams"></consumer-damage-issues><div class="margin-bottom-md">Please agree to the terms below, to continue.</div><div ng-repeat="term in vm.terms" class="margin-bottom-md row"><div class="col-xs-2"><switch name="switch_{{$index}}" ng-model="term.accepted" disabled="vm.fieldsDisabled" class="green" required="required"></switch></div><div class="col-xs-10">{{term.text}}</div></div><div class="margin-top-20 text-center"><a ng-href="{{vm.contractLink}}" class="theme-link">VIEW FULL CONTRACT</a></div><div class="row margin-top"><div class="col-xs-12"><div class="dashed-signature-container"><signature-pad accept="accept" clear="clear" height="220" width="768" dataurl="vm.dataurl"></signature-pad><div class="signature-x">x</div><div class="text-center"><span class="font-size-8">Sign your name with your finger</span></div></div><div href="#" ng-click="vm.clear()" class="pull-right cursor-pointer text-uppercase font-size-10 margin-top-sm margin-bottom">Clear Signature</div><div class="text-danger" ng-if="vm.error">{{vm.error}}</div></div></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" disabled="inputForm.$invalid" next="vm.nextPage()" loading="vm.saving" next-text="\'Next\'"></contact-footer>');
$templateCache.put('app/areas/consumer/loaner/components/tsd-review-component/tsd-review.view.html','<div class="margin-bottom-20">Please review the information below and click NEXT. On the next page you will be able to review the full loaner agreement and sign/initial as needed. Please follow the directions to complete the agreement.</div><h3>Loaner Information</h3><div class="margin-bottom-20"><div class="bold margin-bottom-md">{{vm.year}} {{vm.make}} {{vm.model}}</div><div class="bold margin-bottom-md">VIN: {{vm.vin}}</div><div class="bold margin-bottom-md" ng-if="vm.mileage">Odometer: {{vm.mileage | number}} Miles</div><div class="bold margin-bottom-30" ng-if="vm.fuel">Fuel:<div class="margin-bottom-20"><rzslider rz-slider-model="vm.fuel" rz-slider-options="vm.sliderOptions"></rzslider></div></div></div><consumer-damage-issues ng-model="vm.issues" route-params="vm.routeParams"></consumer-damage-issues><div ng-if="vm.contractStarted"><div class="loader text-center margin-auto"><img src="assets/images/spinner.gif" class="margin-bottom-md"></div>Contract review/signature in progress. Click below if you need to reload the contract signature page.<br><div class="margin-top-20"><a ng-click="vm.signContract()" class="theme-link"><u>SIGN CONTRACT</u></a></div><div class="margin-top-md"><a ng-click="vm.completeSignContract()" class="theme-link"><u>Already signed? Click here to continue.</u></a></div></div><div class="text-danger" ng-if="vm.error">{{vm.error}}</div><contact-footer ng-if="!vm.contractStarted" phone-number="vm.dealerBranding.mainPhoneNumber" disabled="vm.inputForm.$invalid" next="vm.signContract()" loading="vm.saving" next-text="\'Next\'"></contact-footer>');
$templateCache.put('app/areas/consumer/loaner/components/tsdnew-review-component/tsdnew-review.view.html','<div class="margin-bottom-20">Please review the information below regarding your loaner. You must agree to all the terms, sign and submit prior to receiving the loaner.</div><h3>Loaner Information</h3><div class="margin-bottom-20"><div class="bold margin-bottom-md">{{vm.year}} {{vm.make}} {{vm.model}}</div><div class="bold margin-bottom-md">VIN: {{vm.vin}}</div><div class="bold margin-bottom-md" ng-if="vm.mileage">Odometer: {{vm.mileage}}</div><div class="bold margin-bottom-30" ng-if="vm.fuel">Fuel:<div class="margin-bottom-20"><rzslider rz-slider-model="vm.fuel" rz-slider-options="vm.sliderOptions"></rzslider></div></div></div><consumer-damage-issues ng-model="vm.issues" route-params="vm.routeParams"></consumer-damage-issues><div class="margin-bottom-md">Please agree to the terms below, to continue.</div><div ng-repeat="term in vm.terms" class="margin-bottom-md row"><div class="col-xs-2"><switch name="switch_{{$index}}" ng-model="term.accepted" disabled="vm.fieldsDisabled" class="green" required="required"></switch></div><div class="col-xs-10">{{term.text}}</div></div><div class="margin-top-20 text-center"><a ng-href="{{vm.contractLink}}" class="theme-link">VIEW FULL CONTRACT</a></div><div class="row margin-top"><div class="col-xs-12"><div class="dashed-signature-container"><signature-pad accept="accept" clear="clear" height="220" width="768" dataurl="vm.dataurl"></signature-pad><div class="signature-x">x</div><div class="text-center"><span class="font-size-8">Sign your name with your finger</span></div></div><div href="#" ng-click="vm.clear()" class="pull-right cursor-pointer text-uppercase font-size-10 margin-top-sm margin-bottom">Clear Signature</div><div class="text-danger" ng-if="vm.error">{{vm.error}}</div></div></div><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" disabled="inputForm.$invalid" next="vm.nextPage()" loading="vm.saving" next-text="\'Next\'"></contact-footer>');
$templateCache.put('app/areas/consumer/ownercare/components/service-card/view.html','<div class="card"><div class="card-content text-normal-case"><div class="sub-heading-text">{{vm.item.name}}</div><div class="position-relative"><div class="pull-right theme-link margin-right-20" ng-if="vm.item.isOriginalConcern"><b>Original Concern</b></div><div class="vertical-align"><b>Status: <span ng-if="vm.item.status === vm.status.pass"><i class="material-icons text-success align-text">check_circle</i> Passed</span> <span ng-if="vm.item.status === vm.status.caution"><i class="material-icons text-warning align-text">warning</i> Recommended</span> <span ng-if="vm.item.status === vm.status.fail"><i class="material-icons text-danger-red align-text">report</i> Failed</span></b></div></div><div ng-class="{\'margin-bottom-20\': vm.item.attachedPhoto || vm.item.attachedPhoto.length || vm.item.attachedVideo || vm.item.attachedVideo.length || vm.item.attachedAudio || vm.item.attachedAudio.length || vm.item.additionalInformationArticle}"><b>Technician Notes:</b> <span ng-if="vm.item.observations && vm.item.observations.length">{{vm.item.observations.join(\', \')}}</span> <span ng-if="!vm.item.observations || !vm.item.observations.length">None</span></div><a class="info-icon sub-heading-text margin-right-20" ng-click="vm.setScrollPosition()" ng-if="vm.item.attachedVideo && vm.item.attachedVideo.length" ui-sref="ownercare-service-details({recommendation: vm.item, tabId: vm.types.video})"><i class="material-icons material-icons-outlined text-primary">videocam</i> <span>{{vm.item.attachedVideo.length}}</span></a> <a class="info-icon sub-heading-text margin-right-20" ng-click="vm.setScrollPosition()" ng-if="vm.item.attachedPhoto && vm.item.attachedPhoto.length" ui-sref="ownercare-service-details({recommendation: vm.item, tabId: vm.types.image})"><i class="material-icons material-icons-outlined text-primary">photo_camera</i> <span>{{vm.item.attachedPhoto.length}}</span></a> <a class="info-icon sub-heading-text margin-right-20" ng-click="vm.setScrollPosition()" ng-if="vm.item.attachedAudio && vm.item.attachedAudio.length" ui-sref="ownercare-service-details({recommendation: vm.item, tabId: vm.types.audio})"><i class="material-icons material-icons-outlined text-primary">volume_up</i> <span>{{vm.item.attachedAudio.length}}</span></a> <a class="info-icon sub-heading-text margin-right-20" ng-click="vm.setScrollPosition()" ng-if="vm.item.additionalInformationArticle" ui-sref="ownercare-service-details({recommendation: vm.item, tabId: vm.types.details})"><i class="material-icons material-icons-outlined text-primary">paste</i> <span>1</span></a></div><div class="card-footer"><span class="footer-label text-normal-case sub-heading-text">COST: {{vm.item.price | currency}}</span> <span class="button-group"><label><input type="radio" name="item[{{vm.item.externalId}}]" value="1" ng-model="vm.item.isApproved" required="required"> <span>ACCEPT</span></label> <label><input type="radio" name="item[{{vm.item.externalId}}]" value="0" ng-model="vm.item.isApproved" required="required" disabled="disabled"> <span ng-click="vm.setScrollPosition()" ui-sref="ownercare-service-details({recommendation: vm.item, decline: true})">DEFERRED</span></label></span></div></div>');
$templateCache.put('app/areas/consumer/ownercare/components/media-window/view.html','<uib-carousel interval="0"><uib-slide ng-repeat="item in vm.items track by $index" index="vm.selectedIndex" ng-if="$index === vm.selectedIndex"><img ng-src="{{vm.getUrl(item)}}" ng-if="item.type === vm.types.image" alt="{{item.caption}}"><video ng-src="{{vm.getUrl(item)}}" ng-if="item.type === vm.types.video" controls=""></video></uib-slide></uib-carousel><div>{{vm.items[vm.selectedIndex].caption}}</div><div class="text-center margin-bottom-md flex-container-top"><div ng-repeat="item in vm.items" ng-click="vm.selectedIndex = $index" class="media-thumbnail inline-block" ng-class="{\'active\': vm.selectedIndex == $index}"><img ng-src="{{vm.getUrl(item)}}" alt="{{item.caption}}" ng-if="item.type === vm.types.image"><video ng-src="{{vm.getUrl(item)}}" no-controls="" ng-if="item.type === vm.types.video"></video><div>{{item.description}}</div></div></div>');
$templateCache.put('app/areas/consumer/ownercare/components/summary-card/view.html','<div class="card"><div class="separator-line"></div><div class="card-content text-normal-case"><div class="full-width"><div class="sub-heading-text position-relative"><div class="status-icon"><i class="material-icons text-success align-text" ng-if="vm.cardType === vm.statuses.pass">check_circle</i> <i class="material-icons text-warning align-text" ng-if="vm.cardType === vm.statuses.caution">warning</i> <i class="material-icons text-danger-red align-text" ng-if="vm.cardType === vm.statuses.fail">report</i></div><div class="card-heading">{{vm.items.length}} {{vm.title}}</div><div ng-if="vm.collapsable" class="pull-right"><i class="material-icons material-icons-large cursor-pointer line-height-1" ng-if="vm.collapsed" ng-click="vm.collapsed = !vm.collapsed">keyboard_arrow_down</i> <i class="material-icons material-icons-large cursor-pointer line-height-1" ng-if="!vm.collapsed" ng-click="vm.collapsed = !vm.collapsed">keyboard_arrow_up</i></div></div></div><div class="card-body"><div>{{vm.subText}}</div><ul class="no-indent padding-top-sm margin-right-20" ng-if="!vm.collapsable || !vm.collapsed"><li ng-repeat="item in vm.items">{{vm.getDescription(item)}}</li></ul></div></div></div>');
$templateCache.put('app/areas/consumer/payments/views/modals/secure3d.view.html','<div class="modal-header"><h5 class="margin-bottom-none">Verification</h5></div><div class="modal-body"><div ng-bind-html="vm.html"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()">CLOSE</button></div>');
$templateCache.put('app/areas/consumer/payments/views/partials/cardconnect-payment.view.html','<form name="inputForm" novalidate="" role="form"><div class="margin-left-30 margin-right-30"><div ng-if="vm.selectedToken === \'0\'"><div class="consumer-header-text" ng-bind-html="vm.data.newCardTitle"></div><div class="margin-bottom-20" ng-bind-html="vm.data.newCardParagraph"></div></div><div ng-if="vm.selectedToken && vm.selectedToken !== \'0\'"><div class="consumer-header-text" ng-bind-html="vm.data.billingAddressTitle"></div><div class="margin-bottom-20" ng-bind-html="vm.data.billingAddressParagraph"></div></div><div ng-if="!vm.selectedToken"><div class="consumer-header-text" ng-bind-html="vm.data.paymentTitle"></div><div class="margin-bottom-20" ng-bind-html="vm.data.paymentParagraph"></div></div><div ng-if="vm.data.cardsOnFile.length" class="row margin-top-20"><div class="col-xs-12 padding-right-20" ng-repeat="card in vm.data.cardsOnFile" ng-show="vm.selectedToken === card.tokenId || !vm.hideCards"><label class="font-normal"><input type="radio" name="card" ng-model="vm.selectedToken" required="" ng-value="card.tokenId" ng-change="vm.cardSelected()"> {{card.cardType}} ****{{card.cardNumber}} {{card.cardExpirationDate}}</label></div><div class="col-xs-12 padding-right-20 text-uppercase" ng-if="vm.selectedToken === \'0\' && vm.cardError"><label class="text-danger">Error: {{vm.cardError}}</label></div><div class="col-xs-12 padding-right-20 text-uppercase" ng-if="!vm.hideCards"><label class="font-normal"><input type="radio" name="card" ng-model="vm.selectedToken" value="0" ng-change="vm.cardSelected()"> USE ANOTHER CARD</label></div></div><div class="margin-top-md" id="payment-provider" ng-show="vm.selectedToken === \'0\'"><div class="text-danger">{{vm.ccError}}</div><form method="post" name="cardconnectForm" id="cardconnectForm"><iframe ng-src="{{vm.formUrl}}" class="col-xs-12 border-none padding-left-none padding-right-none" style="height: 200px;" name="frame"></iframe></form></div><div class="margin-top-md margin-left-md form-horizontal" id="billing-fields" ng-show="vm.selectedToken && vm.selectedToken !== \'0\'"><div class="form-group row" ng-if="vm.isNewCard"><div class="col-xs-7 padding-top-sm"><input type="text" class="form-control better-placeholder" placeholder="NAME ON CARD" name="nameOnCard" ng-model="vm.data.nameOnCard" required="" validation="required"></div></div><div class="form-group row"><div class="col-xs-7 padding-top-sm"><input type="text" class="form-control better-placeholder" placeholder="ADDRESS" name="billingAddress" ng-model="vm.billing.street" required="" validation="required"></div></div><div class="form-group row"><div class="col-xs-7 padding-top-sm"><input type="text" class="form-control better-placeholder" placeholder="CITY" name="billingCity" ng-model="vm.billing.city" required="" validation="required"></div></div><div class="form-group row"><div class="col-xs-3 field-wrapper padding-top-sm"><label for="billingState">STATE</label><select selectlabel="" class="form-control" id="billingState" name="billingState" ng-model="vm.billing.state" required="" validation="required" ng-options="state as state for state in vm.data.usStates"><option value="" disabled="disabled">State</option></select></div><div class="col-xs-4 padding-top-sm"><input type="text" class="form-control better-placeholder" placeholder="ZIP" name="billingZip" ng-model="vm.billing.zip" mask-restrict="reject" mask="99999" required="" validation="required"></div></div></div><contact-footer phone-number="vm.data.invoice.mainPhoneNumber" next="vm.next()" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid && (!vm.enableNext || vm.selectedToken !== \'0\')"></contact-footer></div></form>');
$templateCache.put('app/areas/consumer/payments/views/partials/cenpos-payment.view.html','<form name="inputForm" novalidate="" role="form" ng-submit="vm.next()"><div class="margin-left-30 margin-right-30"><div ng-if="vm.selectedToken === \'0\'"><div class="consumer-header-text" ng-bind-html="vm.data.newCardTitle"></div><div class="margin-bottom-20" ng-bind-html="vm.data.newCardParagraph"></div></div><div ng-if="vm.selectedToken && vm.selectedToken !== \'0\'"><div class="consumer-header-text" ng-bind-html="vm.data.billingAddressTitle"></div><div class="margin-bottom-20" ng-bind-html="vm.data.billingAddressParagraph"></div></div><div ng-if="!vm.selectedToken"><div class="consumer-header-text" ng-bind-html="vm.data.paymentTitle"></div><div class="margin-bottom-20" ng-bind-html="vm.data.paymentParagraph"></div></div><div ng-if="vm.data.cardsOnFile.length" class="row margin-top-20"><div class="col-xs-12 padding-right-20" ng-repeat="card in vm.data.cardsOnFile" ng-show="vm.selectedToken === card.tokenId || !vm.hideCards"><label style="font-weight: normal"><input type="radio" name="card" ng-model="vm.selectedToken" required="" ng-value="card.tokenId" ng-change="vm.cardSelected()"> {{card.cardType}} ****{{card.cardNumber}} {{card.cardExpirationDate}}</label><div class="margin-top-md form-horizontal" id="billing-fields" ng-if="vm.selectedToken && vm.selectedToken === card.tokenId"><div class="form-group row"><div class="col-xs-10"><input type="text" class="form-control better-placeholder" placeholder="ADDRESS" name="billingAddress" ng-model="vm.billing.street" required="" validation="required"></div></div><div class="form-group row"><div class="col-xs-10"><input type="text" class="form-control better-placeholder" name="billingCity" ng-model="vm.billing.city" required="" validation="required" placeholder="CITY"></div></div><div class="form-group row"><div class="col-xs-4 field-wrapper"><label for="billingState">STATE</label><select class="form-control" selectlabel="" name="billingState" ng-model="vm.billing.state" required="" validation="required" ng-options="state as state for state in vm.data.usStates"><option value="" disabled="disabled">State</option></select></div><div class="col-xs-6"><input type="text" class="form-control better-placeholder" name="billingZip" ng-model="vm.billing.zip" placeholder="ZIP" mask-restrict="reject" mask="99999" required="" validation="required"></div></div></div></div><div class="col-xs-12 padding-right-20 text-uppercase" ng-if="vm.selectedToken === \'0\' && vm.cardError"><label class="text-danger">Error: {{vm.cardError}}</label></div><div class="col-xs-12 padding-right-20 text-uppercase" ng-if="!vm.hideCards"><label style="font-weight: normal"><input type="radio" name="card" ng-model="vm.selectedToken" value="0" ng-change="vm.cardSelected()"> Add new card</label></div></div><div class="margin-top-md" id="{{vm.paymentName}}" ng-show="vm.selectedToken === \'0\'"></div><contact-footer phone-number="vm.invoice.mainPhoneNumber" next="vm.next()" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid && vm.selectedToken !== \'0\'"></contact-footer></div></form>');
$templateCache.put('app/areas/consumer/payments/views/partials/peri-payment.view.html','<div><div class="margin-left-30 margin-right-30"><div class="margin-top-30 ng-hide peri-loader" ng-show="vm.initialLoading"><div><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> Loading...</span></div></div><iframe ng-show="!vm.isInitialLoad" id="smsIFrame" ng-src="{{vm.url}}" class="embedded-iframe" type="text/html" iframe-onload="vm.iFrameOnload()" fill-height="" additional-padding="10"></iframe><div ng-show="vm.isInitialLoad"><div class="font-size-18 centered-content"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> Please wait while we verify your payment.</span></div></div></div><div class="margin-left-30 margin-right-30"><contact-footer phone-number="vm.invoice.mainPhoneNumber" back="vm.back()" loading="vm.loading" disabled="!inputForm.$valid && vm.selectedToken !== \'0\'"></contact-footer></div></div>');
$templateCache.put('app/areas/consumer/payments/views/partials/peri-verify.view.html','<div class="font-size-18 centered-content"><span class="spinner-text"><img src="assets/images/ajax-loader.gif"> Please wait while we verify your payment.</span></div>');
$templateCache.put('app/areas/consumer/repairorders/authorizations/components/authorization-history-summary.component.view.html','<div class="row total-estimate-row margin-top-sm margin-bottom-sm"><div class="col-sm-12 col-xs-12 font-size-12"><div class="text-uppercase"><strong>AUTHORIZATION HISTORY</strong></div></div></div><div ng-repeat="authorization in vm.authorizations" class="row"><div ng-if="authorization.signatureDataId" class="col-sm-12 col-xs-12 text-uppercase padding-bottom-sm"><span ng-click="vm.gotoAuthHistory($index, authorization)" class="theme-link">{{authorization.createdDate | date:\'MMMM d\'}} at {{authorization.createdDate | date:\'h:mm a\'}} ({{(authorization.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.approved }).length}} APPROVED {{(authorization.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.deferred }).length}} DEFERRED)</span></div></div>');
$templateCache.put('app/areas/consumer/repairorders/authorizations/components/vehicle-details-issues.component.view.html','<div class="appointments-wizard"><h4 class="panel-title border-bottom"><div class="padding-bottom-xs margin-top-sm font-size-14 font-bold black">VEHICLE DETAILS</div></h4><div><div class="margin-top-sm"><span class="appt-semi-bold">Odometer:</span> {{vm.repairOrder.odometerIn| number : fractionSize}} {{ vm.getOdometerAbbreviation(vm.repairOrder.mileageType) }}</div><div><span class="appt-semi-bold">Damage and Issues</span> <span class="padding-left-sm inline" ng-if="vm.vehicleConditions">({{vm.vehicleConditions.length}} Item<span ng-if="vm.vehicleConditions.length !== 1">s</span>)</span> <span class="padding-left-sm theme-link inline" ng-if="vm.vehicleConditions.length > 0" ng-click="vm.showDamageAndIssues = !vm.showDamageAndIssues">{{vm.showDamageAndIssues ? \'Hide\' : \'Show\'}}</span></div></div><div ng-if="vm.vehicleConditions.length > 0 && vm.showDamageAndIssues"><div class="margin-top-md" ng-repeat="condition in vm.vehicleConditions track by condition.id" ng-class="{\'padding-bottom-lg\': $last}"><div ng-class="{\'padding-top-20\': !$first}"><strong>{{condition.description}}</strong></div><div class="margin-top-md image-grid w-80 h-80" ng-if="condition.images.length > 0"><div class="grid-item" ng-repeat="itemImage in condition.images track by $index"><div ng-if="itemImage.url"><div class="small-grey-boxes position-relative"><img class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.photo" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, condition.description, vm.mediaTypes.photo)"><video class="position-relative image-container" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, condition.description, vm.mediaTypes.video)"></video><span ng-click="vm.openImageModal(itemImage.url, condition.description, vm.mediaTypes.video)" class="overlay" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center font-size-8 line-height-14" ng-if="itemImage.dateTaken">{{ itemImage.dateTaken | localDate:\'MMM D h:mm A\' }}</div></div></div></div></div></div><div><span class="appt-semi-bold">Additional Photos</span> <span class="padding-left-sm inline" ng-if="vm.predefinedImages">({{vm.totalpredefinedImages}} Item<span ng-if="vm.totalpredefinedImages !== 1">s</span>)</span> <span class="padding-left-sm theme-link inline" ng-if="vm.predefinedImages && vm.predefinedImages.length > 0" ng-click="vm.showPredefinedMediaItems = !vm.showPredefinedMediaItems">{{vm.showPredefinedMediaItems ? \'Hide\' : \'Show\'}}</span></div><div class="margin-bottom-20 margin-top" ng-repeat="predefinedItem in vm.predefinedImages" ng-if="vm.showPredefinedMediaItems" ng-class="{\'padding-bottom-lg\': $last}"><div class="text-uppercase font-size-12 font-bold" ng-class="{\'padding-top-20\': !$first}">{{predefinedItem.heading}}</div><div class="margin-top-md image-grid w-80 h-80"><div class="grid-item" ng-repeat="itemImage in predefinedItem.mediaItems track by $index"><div ng-if="itemImage.id"><div class="small-grey-boxes position-relative"><img class="position-relative image-container" ng-if="itemImage.type === vm.mediaTypes.photo" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url,predefinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.photo)"><video class="position-relative image-container" ng-if="itemImage.type === vm.mediaTypes.video" ng-src="{{itemImage.url}}" ng-click="vm.openImageModal(itemImage.url, predefinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.video)"></video><span ng-click="vm.openImageModal(itemImage.url, predefinedItem.categoryDesc + \' - \' + itemImage.description, vm.mediaTypes.video)" class="overlay" ng-if="vm.getMediaType(itemImage.fileExtension) === vm.mediaTypes.video"><i class="material-icons">play_arrow</i></span></div><div class="text-uppercase text-center font-size-8 padding-top-xs" ng-if="itemImage.dateTaken">{{ itemImage.dateTaken | localDate:\'MMM D h:mm A\' }}</div><div class="text-center font-size-10 line-height-10">{{ itemImage.description }}</div></div></div></div></div></div>');
$templateCache.put('app/areas/consumer/repairorders/authorizations/views/homework-authorization-history.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size appointment-homework margin-bottom-30"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.mainPhoneNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" image="vm.headerImageUrl" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div><div class="row margin-top"><div class="col-sm-12 col-xs-12 appointment-homework"><div class="margin-left-20 margin-right-20"><h3 class="title1">SERVICE AUTHORIZATION FOR</h3><h1 class="titleName">{{vm.repairOrder.customer.name}}</h1><h2 class="title2">{{vm.repairOrder.vehicle.year}} {{vm.repairOrder.vehicle.model}} <span ng-if="vm.repairOrder.vehicle.vin">(#{{vm.repairOrder.vehicle.vin | limitTo: -8}})</span></h2></div></div></div><div class="row margin-top margin-bottom"><div class="col-xs-12"><div class="margin-left-20 margin-right-20 font-size-12 text-uppercase"><strong>{{vm.authorizationGroup.createdDate | date:\'MMMM d\'}} at {{vm.authorizationGroup.createdDate | date:\'h:mm a\'}} ({{(vm.authorizationGroup.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.approved }).length}} APPROVED {{(vm.authorizationGroup.authorizations | filter: { authorizationStatus: vm.authorizationStatuses.deferred }).length}} DEFERRED)</strong></div></div></div><div class="text-normal-case"><div class="margin-top-sm row" ng-repeat="authorization in vm.authorizations"><div class="col-xs-12"><div class="margin-left-20 margin-right-20"><authorize-pending-lineitem ng-model="authorization" is-dashboard="false" read-only="true"></authorize-pending-lineitem></div></div></div><div class="margin-top row"><div class="col-xs-12"><div class="margin-left-20 margin-right-20" ng-if="vm.authorizationGroup.signatureData.imageId"><div class="auth-history-signature"><img ng-src="{{vm.authorizationGroup.signatureData.imageUrl}}"><div class="signature-x">x</div><div class="signature-line">&nbsp;</div></div></div></div></div><div class="margin-left-20 margin-right-20 margin-top"><contact-footer next="vm.back()" loading="vm.loading" next-text="\'BACK\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/repairorders/authorizations/views/homework-confirminfo.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size appointment-homework margin-bottom-30"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.mainPhoneNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" image="vm.headerImageUrl" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h3 class="title1" ng-bind-html="vm.configValues.homeworkConfirmInfoTitle1"></h3><h1 class="titleName">{{vm.repairOrder.customerFirstName}} {{vm.repairOrder.customerLastName}}</h1><h2 class="title2" ng-bind-html="vm.configValues.homeworkConfirmInfoTitle2"></h2><div class="text-center row margin-top"><i class="text-success material-icons authorization-success-checkbox">check_circle</i></div><div class="row margin-top"><div class="col-xs-12" ng-bind-html="vm.configValues.homeworkConfirmInfoParagraph"></div></div><div class="margin-bottom"><approved-services-confirmation ng-model="vm.authorizedServices" is-dashboard="false"></approved-services-confirmation></div><div class="margin-bottom" ng-if="vm.inspectionHasStarted"><a class="text-uppercase theme-link" ng-click="vm.showInspectionSummary()">View Full Inspection Report</a></div><div class="margin-bottom"><consumer-repair-order-authorization-history-summary ng-model="vm.authorizationHistory" repair-order-id="vm.repairOrder.id" key="vm.key"></consumer-repair-order-authorization-history-summary></div><br><br><div ng-if="vm.dealerIntegrations && vm.dealerIntegrations.isDigniFiEnabled" class="col-xs-12 dignifi-container text-align-center"><dignifi dealer-id="vm.dealerIntegrations.digniFiDealerId"></dignifi></div></div></div></div></form>');
$templateCache.put('app/areas/consumer/repairorders/authorizations/views/homework-landing.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><form name="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size appointment-homework margin-bottom-30"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.smsNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" image="vm.headerImageUrl" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div ng-if="!vm.loading"><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h3 class="title1" ng-bind-html="vm.configValues.homeworkLandingPageTitle1"></h3><h1 class="titleName">{{vm.ro.customer.name}}</h1><h2 class="title2" ng-bind-html="vm.configValues.homeworkLandingPageTitle2"></h2><div class="margin-bottom-20" ng-bind-html="vm.configValues.homeworkLandingPageParagraph"></div><task-circles tasks="vm.tasks"></task-circles><contact-footer phone-number="vm.dealerBranding.mainPhoneNumber" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/repairorders/authorizations/views/homework-services.view.html','<consumer-dealer-custom-styles configs="vm.dealer.styleValues"></consumer-dealer-custom-styles><form name="inputForm" id="inputForm" novalidate="" role="form" ng-submit="vm.nextPage()" class="tablet-size appointment-homework margin-bottom-30"><consumer-header name="vm.dealer.name" description="\'Service Appointment\'" phone-number="vm.dealer.mainPhoneNumber" sms-number="vm.dealer.mainPhoneNumber" address="vm.dealer.address" city="vm.dealer.city" state="vm.dealer.state" zip="vm.dealer.zip" lat="vm.dealer.lat" lng="vm.dealer.lng" ng-if="!vm.isInFrame" dealer-id="vm.dealer.dealerId" image="vm.headerImageUrl" app-type="vm.appTypes.appointment" trip-type-id="vm.sysEnums.systemTripType.appointment"></consumer-header><div><div class="text-normal-case"><div class="margin-left-20 margin-right-20 margin-top-20"><h3 class="title1" ng-bind-html="vm.configValues.homeworkServicesPageTitle1"></h3><h1 class="titleName">{{vm.repairOrder.customer.name}}</h1><h2 class="title2" ng-bind-html="vm.configValues.homeworkServicesPageTitle2"></h2><div class="margin-bottom-20" ng-bind-html="vm.configValues.homeworkServicesPageParagraph"></div><div class="margin-top-30"><repair-order-vehicle-details-issues class="margin-top-30" repair-order="vm.repairOrder" consumer-key="vm.resolvedKey"></repair-order-vehicle-details-issues></div><div class="row border-bottom margin-top"><div class="col-sm-11 col-xs-10"><h3 class="title"><div class="black"><strong>SERVICES ({{vm.pendingAuthorizations.length}} PENDING APPROVAL)</strong></div></h3></div></div><div class="row margin-top"><div class="col-sm-12 col-xs-12 margin-bottom"><div ng-repeat="lineItem in vm.pendingAuthorizations"><authorize-pending-lineitem ng-model="lineItem" is-dashboard="false" itemize-tax="vm.recalculateFixedTaxesAndFees()"></authorize-pending-lineitem></div></div></div><div class="row"><div ng-if="!vm.itemizationEnabled" class="col-sm-12 col-xs-12 text-right">TOTAL ESTIMATE: <b>{{vm.getTotalEstimate() | currency}}</b><br>(Not incl. taxes or fees)</div><div ng-if="vm.itemizationEnabled" class="col-sm-12 col-xs-12 text-right"><div>Total parts &amp; labor: {{vm.getTotalEstimate() | currency}}</div><div ng-if="vm.fixedTaxesAndFees && vm.fixedTaxesAndFees.length"><div ng-repeat="fee in vm.fixedTaxesAndFees"><span>{{fee.description}}: {{fee.amount | currency}}</span></div></div><div><b>Total (Tax not incl.):</b> {{vm.getTotals() | currency}}</div></div></div><div ng-if="vm.inspectionHasStarted" class="margin-top"><a class="theme-link text-uppercase" ng-click="vm.showInspectionSummary()">View the full inspection report</a></div><div class="row border-bottom margin-top-30"><div class="col-sm-11 col-xs-10"><h3 class="title"><div class="black"><strong>CUSTOMER AUTHORIZATION</strong></div></h3></div></div><div class="row"><div class="col-xs-11 margin-top">Please ensure all of the information above is correct. In order to work on your vehicle and perform the selected services, you must agree to the terms and authorize the work by providing your signature below.</div></div><div ng-repeat="term in vm.terms" class="margin-top margin-bottom-md row"><div class="col-xs-2 col-sm-1"><switch name="switch_{{$index}}" ng-model="term.accepted" disabled="vm.fieldsDisabled" class="green small-switch" required="required"></switch></div><div class="col-xs-9 col-sm-10">{{term.terms}}</div></div><div class="row margin-top"><div class="col-xs-12"><div class="dashed-signature-container"><input type="hidden" ng-model="vm.dataurl" required="required"><signature-pad accept="accept" clear="vm.clear" height="220" width="768" dataurl="vm.dataurl"></signature-pad><div class="signature-x">x</div><div class="text-center"><span class="font-size-8">Sign your name with your finger</span></div></div><div href="#" ng-click="vm.clear()" class="pull-right cursor-pointer text-uppercase font-size-10 margin-top-sm margin-bottom">Clear Signature</div><div class="text-danger" ng-if="vm.error || vm.errors">{{vm.error}} {{vm.errors}}</div></div></div><contact-footer back="vm.prevPage()" next="vm.nextPage()" loading="vm.loading" next-text="\'Next\'" disabled="inputForm.$invalid"></contact-footer></div></div></div></form>');
$templateCache.put('app/areas/consumer/shared/components/cancelReason/cancel-reason.view.html','<form name="cancelForm" id="cancelForm" role="form" class="form modal-body padding-left-lg padding-right-lg" ng-submit="vm.performCancel(cancelForm.$valid)"><div class="text-center margin-bottom-md"><i class="material-icons material-icons-large28 cursor-pointer" ng-click="vm.close()">highlight_off</i></div><div class="row"><h3 class="text-center text-uppercase">{{vm.title || \'Cancel Reservation\'}}</h3></div><div ng-if="vm.reasonRequired" class="row padding-top-lg margin-bottom-30"><p>Give us an idea why you are cancelling:</p><textarea name="reason" id="reason" class="full-width resize-none" rows="4" ng-model="vm.reason" validation="required"></textarea> <span ng-if="!vm.canceled && vm.submitted && !vm.reason" class="text-danger">This field is required.</span></div><div class="margin-top-30 margin-bottom-30 text-center" ng-if="!vm.reasonRequired"><h4>Are you sure you want to cancel?</h4></div><div class="row padding-top-lg margin-bottom-30 text-center"><button class="btn btn-rounded min-75" ng-click="vm.close()">Nevermind</button> <button type="submit" class="btn btn-primary btn-rounded min-75">{{vm.title || \'Cancel Reservation\'}}</button></div></form>');
$templateCache.put('app/areas/consumer/shared/components/contactfooter/contactfooter.view.html','<div class="consumer-footer margin-top-30 margin-bottom-30 {{vm.class}}" id="footer"><div class="action-buttons"><div ng-if="vm.back"><button type="button" class="btn btn-rounded btn-outline" ng-click="vm.back()">{{vm.backText || \'Back\'}}</button></div><div ng-if="vm.next"><button type="button" class="btn btn-rounded btn-primary" ng-click="vm.next()" ladda="vm.loading" ng-disabled="vm.disabled">{{vm.nextText || \'Next\'}}</button></div></div></div>');
$templateCache.put('app/areas/consumer/shared/components/faq/faq.view.html','<div ng-if="vm.dealer.styleValues.googleFontNames" ng-repeat="font in vm.dealer.styleValues.googleFontNames.split(\';\')"><link ng-href="https://fonts.googleapis.com/css?family={{ font }}" rel="stylesheet"></div><link rel="stylesheet" ng-if="vm.configValues.cssOverridesFile !== \'None\'" ng-href="{{ vm.dealer.styleValues.cssOverridesFile }}"><div class="consumer-payments-header header"><img class="dealer-logo" ng-src="{{vm.dealer.logo}}"><div class="margin-left-md inline-block"><div class="dealer-info dealer-name text-nowrap hidden-xs"><strong>{{vm.dealer.name}}</strong></div></div><div id="dealer-contact"><a class="float-right cursor-pointer dealer-name visible-xs" ng-href="tel:{{vm.dealer.salesPhoneNumber}}">Questions? {{vm.dealer.salesPhoneNumber | tel }}</a> <span class="float-right dealer-name hidden-xs">Questions? {{vm.dealer.salesPhoneNumber | tel }}</span></div></div><div class="holder-page bg-gradient"><div ng-if="vm.hasError">There was an issue with this request. Please contact us for more information.</div><div ng-bind-html="vm.faq"></div></div>');
$templateCache.put('app/areas/consumer/shared/components/header/consumerheader.view.html','<div class="consumer-header header" ng-class="{\'no-description\' : !vm.description}"><div class="consumer-payments-contact-icons margin-left-md inline-block"><i class="material-icons material-icons-large cursor-pointer position-absolute top-0" ng-click="vm.showDealerDetails()">menu</i></div><div class="margin-left-md inline-block text-uppercase dealer-name-container"><div class="dealer-name"><strong>{{vm.name}}</strong></div><div ng-if="vm.description" class="dealer-info">{{vm.description}} <img ng-if="vm.descriptionImage" ng-class="vm.descriptionImageClass" ng-src="{{vm.descriptionImage}}"></div></div><div class="sms-icon margin-right-20" ng-if="vm.smsNumber"><a class="circle-text float-right cursor-pointer" ng-href="sms:{{vm.smsNumber}}"><i class="material-icons material-icons-large">sms</i></a></div></div><div ng-if="vm.image"><img ng-src="{{vm.image}}" class="full-width"></div>');
$templateCache.put('app/areas/consumer/shared/components/privacy/privacy.view.html','<div ng-if="vm.dealer.styleValues.googleFontNames" ng-repeat="font in vm.dealer.styleValues.googleFontNames.split(\';\')"><link ng-href="https://fonts.googleapis.com/css?family={{ font }}" rel="stylesheet"></div><link rel="stylesheet" ng-if="vm.configValues.cssOverridesFile !== \'None\'" ng-href="{{ vm.dealer.styleValues.cssOverridesFile }}"><div class="consumer-payments-header header" ng-if="vm.privacy && vm.privacy.length > 0"><img class="dealer-logo" ng-src="{{vm.dealer.logo}}"><div class="margin-left-md inline-block"><div class="dealer-info dealer-name text-nowrap hidden-xs"><strong>{{vm.dealer.name}}</strong></div></div><div id="dealer-contact"><a class="float-right cursor-pointer dealer-name visible-xs" ng-href="tel:{{vm.dealer.salesPhoneNumber}}">Questions? {{vm.dealer.salesPhoneNumber | tel }}</a> <span class="float-right dealer-name hidden-xs">Questions? {{vm.dealer.salesPhoneNumber | tel }}</span></div></div><div class="holder-page bg-gradient" ng-if="vm.privacy && vm.privacy.length > 0"><div ng-if="vm.hasError">There was an issue with this request. Please contact us for more information.</div><div ng-bind-html="vm.privacy"></div></div>');
$templateCache.put('app/areas/consumer/shared/components/terms/terms.view.html','<div ng-if="vm.dealer.styleValues.googleFontNames" ng-repeat="font in vm.dealer.styleValues.googleFontNames.split(\';\')"><link ng-href="https://fonts.googleapis.com/css?family={{ font }}" rel="stylesheet"></div><link rel="stylesheet" ng-if="vm.configValues.cssOverridesFile !== \'None\'" ng-href="{{ vm.dealer.styleValues.cssOverridesFile }}"><div class="consumer-payments-header header"><img class="dealer-logo" ng-src="{{vm.dealer.logo}}"><div class="margin-left-md inline-block"><div class="dealer-info dealer-name text-nowrap hidden-xs"><strong>{{vm.dealer.name}}</strong></div></div><div id="dealer-contact"><a class="float-right cursor-pointer dealer-name visible-xs" ng-href="tel:{{vm.dealer.salesPhoneNumber}}">Questions? {{vm.dealer.salesPhoneNumber | tel }}</a> <span class="float-right dealer-name hidden-xs">Questions? {{vm.dealer.salesPhoneNumber | tel }}</span></div></div><div class="holder-page bg-gradient"><div ng-if="vm.hasError">There was an issue with this request. Please contact us for more information.</div><div ng-bind-html="vm.terms"></div></div>');
$templateCache.put('app/areas/loaner/views/contracts/partials/choose-customer.view.html','<uib-accordion-heading><h4 class="panel-title">CUSTOMER<div class="inline pull-right margin-top-md"><span class="ng-hide small-accordion-header text-uppercase" ng-show="vm.customer">{{vm.customer.firstName}} {{vm.customer.lastName}} {{vm.customer.mobilePhone | tel}}</span><div class="ng-hide accordion-clear-step" ng-show="vm.customer && !vm.isLoading()" ng-click="vm.clearBillTo(vmPnl)"><i class="material-icons">edit</i></div></div></h4></uib-accordion-heading><div id="paymentChooseCustomerForm"><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><span class="control-label font-bold">SEARCH FOR CUSTOMER</span></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><select class="select2-single" multiple="multiple" ui-select2="vmPnl.phoneSearchOptions" name="phoneSelect" id="phoneselect" placeholder="Mobile phone" ng-model="vmPnl.contactId"></select></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><span class="control-label font-bold">OR ENTER INFORMATION</span></div></div></div><form role="form" name="paymentForm" ng-submit="vmPnl.submitForm()" novalidate="" class="form"><div class="row"><div class="form-group"><div class="col-sm-3 padding-left-none"><input type="text" class="form-control" ng-model="vmPnl.firstName" name="firstName" id="firstName" placeholder="FIRST NAME" required="" validation="required"></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md"><input type="text" class="form-control" ng-model="vmPnl.lastName" name="lastName" id="lastName" placeholder="LAST NAME" required="" validation="required"></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md"><input type="text" class="form-control" ng-model="vmPnl.mobilePhone" name="mobilePhone" id="mobilePhone" placeholder="MOBILE PHONE" required="" validation="required" mask="(999) 999-9999"></div></div></div><div class="aside-footer"><div class="row padding-md"><div class="col-xs-12"><button type="submit" class="btn btn-primary text-uppercase" ng-disabled="paymentForm.$invalid">Next</button> <button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-contracts-list">Close</button></div></div></div></form></div>');
$templateCache.put('app/areas/loaner/views/contracts/partials/choose-location.view.html','<uib-accordion-heading><h4 class="panel-title">LOCATION <span class="inline pull-right margin-top-md"><span class="ng-hide small-accordion-header text-uppercase" ng-show="vm.location">{{vm.location.name}}</span> <span class="ng-hide accordion-clear-step" ng-show="vm.location && !vm.isLoading() && vm.resolvedLocations && vm.resolvedLocations.length > 1" ng-click="vm.clearSelectedLocation()"><i class="material-icons">edit</i></span></span></h4></uib-accordion-heading><div id="chooseLocationForm"><div class="display-flex flex-row" ng-if="vm.resolvedLocations.length > vmPnl.locationSearchThreshold"><div class="flex-percent-50 padding-none"><div class="form-group text-uppercase"><select data-placeholder-text-single="\'Find a location\'" class="form-control" name="locationFilter" max-shown-results="100" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vm.location" ng-options="l as l.name for l in vm.resolvedLocations" ng-change="vm.locationSelected()"><option value="">Find a location</option></select></div></div></div><div ng-if="vm.resolvedLocations.length <= vmPnl.locationSearchThreshold"><div class="display-flex flex-row margin-top-md"><div class="flex-percent-90 padding-none"><table id="zip-filtered-locations"><tr ng-repeat="location in vm.resolvedLocations"><td class="padding-md loc-icon" ng-click="vmPnl.locationClicked(location)"></td><td class="padding-md loc-details" ng-click="vmPnl.locationClicked(location)"><div class="theme-link"><strong>{{location.name}}</strong></div><div>{{location.address}}, {{location.city}}, {{location.zip}}</div></td></tr></table></div></div></div></div><div class="aside-footer"><div class="display-flex flex-row padding-md"><div class="flex-grow"><button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-contracts-list">Close</button></div></div></div>');
$templateCache.put('app/areas/loaner/views/contracts/partials/choose-time.view.html','<uib-accordion-heading><h4 class="panel-title">PICKUP DATE AND TIME<div class="inline pull-right"><span class="ng-hide small-accordion-header text-uppercase" ng-show="vm.pickupDate">{{vm.pickupDate | date}}</span><div class="ng-hide accordion-clear-step" ng-show="vm.pickupDate && !vm.isLoading()" ng-click="vm.clearBillTo(vmPnl)"><i class="material-icons">edit</i></div></div></h4></uib-accordion-heading><div id="paymentChooseCustomerForm"><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><span class="control-label font-bold">SEARCH FOR TRIP</span></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><select class="select2-single" multiple="multiple" ui-select2="vmPnl.searchTripsOptions" name="tripsSelect" id="tripsSelect" placeholder="Search by trip id, mobile # or name" ng-model="vmPnl.tripId"></select></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><span class="control-label font-bold">OR SEARCH FOR DMS APPOINTMENT</span></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><select class="select2-single" multiple="multiple" ui-select2="vmPnl.searchAppointmentsOptions" name="appointmentsSelect" id="appointmentsSelect" placeholder="Search by trip id, mobile # or name" ng-model="vmPnl.appointmentId"></select></div></div></div><div class="row"><div class="col-xs-8 col-lg-6 padding-none"><div class="form-group"><span class="control-label font-bold">OR ENTER INFORMATION</span></div></div></div><form role="form" name="paymentForm" ng-submit="vmPnl.submitForm()" novalidate="" class="form"><div class="row"><input type="hidden" ng-model="vmPnl.appointmentId"> <input type="hidden" ng-model="vmPnl.tripId"><div class="form-group"><div class="col-sm-3 padding-left-none"><input type="date" class="form-control" ng-model="vmPnl.pickupDate" name="pickupDate" id="pickupDate" placeholder="Pickup date" required="" validation="required"></div></div></div><div class="aside-footer"><div class="row padding-md"><div class="col-xs-12"><button type="submit" class="btn btn-primary text-uppercase" ng-disabled="paymentForm.$invalid" ladda="vmPnl.loading">Next</button> <button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-contracts-list">Close</button></div></div></div></form></div>');
$templateCache.put('app/areas/loaner/views/vehicles/partials/choose-location.view.html','<uib-accordion-heading><div class="display-flex flex-row full-width-height"><div class="flex-grow"><h4 class="panel-title location-title display-flex flex-row content-center"><div class="flex-grow flex-percent-50 align-bottom override-xs-padding-bottom-sm"><span class="hidden-xs hidden-sm">LOCATION</span> <span class="visible-xs visible-sm ng-hide" ng-show="vm.accordion.selectedStep === vm.accordion.steps.chooseLocation">LOCATION</span> <span ng-if="vm.location" class="text-uppercase inline-block ellipsis-overflow max-width-px-300 visible-sm visible-xs">{{vm.location.name}}</span></div><div class="flex-grow flex-percent-50 flex-sm-percent-25 content-center align-text-bottom"><div class="selected-accordion-location"><span ng-show="vm.location" class="inline-block ellipsis-overflow max-width-px-300 padding-right-sm align-text-bottom text-uppercase hidden-sm hidden-xs">{{vm.location.name}}</span><div class="ng-hide ink pull-right content-center" ng-show="vm.location && !vm.isLoading() && vm.resolvedLocations && vm.resolvedLocations.length > 1" ng-click="vm.clearSelectedLocation()"><i class="material-icons md-16">edit</i></div></div></div></h4></div></div></uib-accordion-heading><div id="chooseLocationForm"><div class="display-flex flex-row" ng-if="vm.resolvedLocations.length > vmPnl.locationSearchThreshold"><div class="flex-percent-50 padding-none"><div class="form-group text-uppercase"><select data-placeholder-text-single="\'Find a location\'" class="form-control" name="locationFilter" max-shown-results="100" chosen="{width: \'100%\', allow_single_deselect: true}" ng-model="vm.location" ng-options="l as l.name for l in vm.resolvedLocations | orderBy: \'name\'" ng-change="vm.locationSelected()"><option value="">Find a location</option></select></div></div></div><div ng-if="vm.resolvedLocations.length <= vmPnl.locationSearchThreshold"><div class="display-flex flex-row margin-top-md"><div class="flex-percent-90 padding-none"><table id="zip-filtered-locations"><tr ng-repeat="location in vm.resolvedLocations | orderBy: \'name\'"><td class="padding-md loc-icon" ng-click="vmPnl.locationClicked(location)"></td><td class="padding-md loc-details" ng-click="vmPnl.locationClicked(location)"><div class="theme-link"><strong>{{location.name}}</strong></div><div>{{location.address}}, {{location.city}}, {{location.zip}}</div></td></tr></table></div></div></div></div><div class="footer fixed_full"><div class="display-flex flex-row padding-md"><div class="flex-grow text-right padding-left-none"><button type="button" class="btn btn-default text-uppercase" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-vehicles-list">Close</button></div></div></div>');
$templateCache.put('app/areas/loaner/views/vehicles/partials/vehicle-add-details.view.html','<uib-accordion-heading><h4 class="panel-title"><span class="hidden-xs">VEHICLE DETAILS</span></h4></uib-accordion-heading><div id="vehicleDetailsForm"><form role="form" name="vehicleForm" ng-submit="vmPnl.submitForm()" novalidate="" class="form override-xs-padding-bottom-100"><div class="form-group"><div class="row"><div class="form-group margin-top-md override-xs-margin-bottom-none"><div class="col-sm-3 padding-left-none"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.stockNum" name="stockNum" id="stockNum" placeholder="STOCK#" required="" validation="required"></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md text-uppercase"><div class="block relative"><div class="input-group"><input type="text" id="available-on" class="form-control better-placeholder white-bg" placeholder="AVAILABLE ON" ng-model="vmPnl.availableOn" moment-picker="" start-view="month" format="ddd MM/DD/YY" min-date="moment(vmPnl.today)" name="available-on" required="required" validation="required:alt=Required" is-open="vmPnl.isPromiseTimePickerOpen"> <span class="input-group-addon appointment-calendar" ng-click="vmPnl.isPromiseTimePickerOpen = !vmPnl.isPromiseTimePickerOpen"><i class="glyphicon glyphicon-calendar"></i></span></div></div></div></div></div></div><div class="form-group"><div class="row"><div class="form-group margin-top-md override-xs-margin-bottom-none"><div class="col-sm-3 padding-left-none text-notransform"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.vin" name="vin" id="vin" placeholder="VIN" maxlength="17" required="" validation="required|custom:vmPnl.validation.validVin(vmPnl.vin):alt=*" ng-change="vmPnl.checkVin()"></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md field-wrapper"><label for="vehicle_year">YEAR</label><select id="vehicle_year" ng-model="vmPnl.year" name="vehicle_year" selectlabel="" required="" inputmode="numeric" ng-model-options="{ debounce: 400 }" class="form-control" ng-options="year as year for year in vmPnl.vehicleYears track by year" ng-change="vmPnl.yearUpdated()" validation="required:alt=Required"><option value="" selected="selected" disabled="">Select year</option></select></div><div class="col-sm-3 padding-left-none field-wrapper override-xs-margin-bottom-none"><label for="vehicle_make">MAKE</label><select id="vehicle_make" name="vehicle_make" selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="!vmPnl.vehicleMakes" ng-options="make.make for make in vmPnl.vehicleMakes track by make.makeCode" ng-change="vmPnl.makeUpdated()" ng-model="vmPnl.selectedMake" class="form-control" validation="required:alt=Required"><option value="" selected="selected" disabled="">Select make</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vmPnl.updatingVehicleMakes"></div></div></div></div><div class="form-group"><div class="row"><div class="form-group margin-top-md override-xs-margin-bottom-none"><div class="col-sm-3 padding-left-none field-wrapper"><label for="vehicle_model">MODEL</label><select id="vehicle_model" name="vehicle_model" selectlabel="" required="" ng-model-options="{ debounce: 750 }" ng-disabled="!vmPnl.vehicleModels" ng-options="model.model for model in vmPnl.vehicleModels track by model.modelCode" ng-change="vmPnl.modelUpdated()" ng-model="vmPnl.selectedModel" class="form-control" validation="required:alt=Required"><option value="" selected="selected" disabled="">Select model</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vmPnl.updatingVehicleModels"></div><div class="col-sm-3 padding-left-none field-wrapper"><label for="sub_model">TRIM</label><select class="form-control" ng-model="vmPnl.selectedTrim" ng-model-options="{ debounce: 750 }" selectlabel="" ng-disabled="!vmPnl.vehicleSubmo" ng-options="submodel for submodel in vmPnl.vehicleSubModels" ng-change="vmPnl.subModelUpdated()" id="sub_model" name="sub_model"><option value="">Select trim</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vmPnl.updatingVehicleSubModels"></div><div class="col-sm-3 padding-left-none field-wrapper override-xs-margin-bottom-none"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.color" name="color" id="color" ng-if="vmPnl.selectedColor === \'Other\'" placeholder="COLOR" required="" validation="required"> <label for="state" ng-show="vmPnl.selectedColor !== \'Other\'">COLOR</label><select class="form-control" id="state" name="color" selectlabel="" required="" validation="required" ng-if="vmPnl.selectedColor !== \'Other\'" ng-model="vmPnl.selectedColor" ng-options="item as item for item in vmPnl.vehicleColors"><option value="" selected="selected" disabled="">Color</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vmPnl.loadingColors"></div></div></div></div><div class="form-group"><div class="row"><div class="form-group margin-top-md override-xs-margin-bottom-none"><div class="col-sm-3 padding-left-none"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.licensePlate" name="licensePlate" id="licensePlate" placeholder="LICENSE PLATE" required="" validation="required"></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md field-wrapper override-xs-margin-bottom-none" ng-if="vmPnl.dealerConfigurations.loanerClientType === vmPnl.loanerManagementSystemsEnum.DealerWare"><label for="state">STATE</label><select class="form-control" id="state" name="state" selectlabel="" required="" validation="required" ng-model="vmPnl.state" ng-options="item as item for item in vmPnl.usStates"><option value="" selected="selected" disabled="">State</option></select></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md field-wrapper override-xs-margin-bottom-none" ng-if="vmPnl.dealerConfigurations.loanerClientType === vmPnl.loanerManagementSystemsEnum.ARS"><label for="vehicle_group">VEHICLE GROUP</label><select class="form-control" ng-model="vmPnl.vehicleGroup" ng-model-options="{ debounce: 750 }" selectlabel="" ng-options="item for item in vm.vehicleClasses" id="vehicle_group" name="vehicle_group"><option value="">Vehicle group</option></select><img src="assets/images/ajax-loader.gif" class="ng-hide vehicle-spinner" ng-show="vm.loadingVehicleGroups"></div></div></div></div><div class="form-group"><div class="row"><div class="form-group margin-top-md"><div class="col-sm-3 padding-left-none" ng-if="vmPnl.dealerConfigurations.loanerClientType === vmPnl.loanerManagementSystemsEnum.DealerWare"><input type="text" class="form-control better-placeholder" ng-model="vmPnl.tollTag" name="tollTag" id="tollTag" placeholder="TOLL TAG #" required="" validation="required"></div><div class="col-sm-3 padding-left-none override-xs-padding-top-md margin-top-sm" ng-if="vmPnl.dealerConfigurations.loanerClientType === vmPnl.loanerManagementSystemsEnum.DealerWare"><label class="font-normal align-middle"><input type="checkbox" id="tollTagVerified" name="tollTagVerified" ng-model="vmPnl.tollTagVerified"> <span class="font-size-12" id="tollTagVerified-text-opt-in">Toll Tag Verified</span></label></div></div></div></div><div class="footer fixed_full"><div class="row padding-md"><div class="col-xs-12 text-right padding-left-none"><button type="button" class="btn btn-default text-uppercase margin-right-xs" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="loaner-vehicles-list">Close</button> <button type="submit" class="btn btn-primary text-uppercase" ng-disabled="vehicleForm.$invalid || vmPnl.loading || vmPnl.invalidVin">Save</button></div></div></div></form></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-dealer-trade.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled"><div class="margin-bottom-30">We were looking forward to delivering your vehicle. If you would like to try again please call your dealer at {{ vm.trip.dealer.phoneNumber | tel }}. We hope to hear from you soon.</div></div><div ng-if="vm.trip.state === vm.tripStates.complete"><div ng-if="!vm.trip.hasSurvey" class="row"><div class="col-xs-12"><div>Your dealer trade has been completed, we hope you enjoyed the delivery experience.</div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text">Reservation Confirmation</div><div>You\'re all set, we look forward to seeing you soon!<br>Your dealer trade is confirmed.</div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><strong>Confirmation #{{ vm.trip.id }}</strong><div class="panel panel-default calendar-panel margin-top-md"><div class="panel-heading text-center appointment-banner"><h1>Dealer Trade</h1></div><div class="panel-body text-center"><h1><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d\' }}</b></h1><h1>{{ vm.trip.customerExpectedTime | date : \'EEEE\' }}</h1><h1><b>{{ vm.trip.customerExpectedTime | date : \'h:mma\' }}</b></h1><b ng-class="{ \'visible-xs\': !vm.isInFrame }">{{ vm.trip.customerAddress }}, {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</b><div class="padding-top-md" ng-class="{\'visible-xs\': !vm.isInFrame }"><img ng-src="{{vm.customerStaticMapUrl}}" class="full-width"></div></div></div></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg" ng-if="vm.trip.workflowId === 19"><h3>Contact Information</h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg" ng-if="vm.trip.workflowId !== 19"><h3>Contact Information</h3><div>{{ vm.trip.dealer.serviceAdvisorName }}</div><div>{{ vm.trip.dealer.serviceAdvisorEmail }}</div><div>{{ vm.trip.dealer.serviceAdvisorPhone | tel }}</div></div><div class="padding-top-lg"><h3>Transportation Options</h3><div><div><div ng-if="vm.trip.workflowId === 19"><strong>{{ vm.trip.customerAddress }} {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</strong></div><div ng-if="vm.trip.workflowId !== 19"><strong>{{ vm.trip.dealer.name }}</strong></div>Pick Up <span ng-if="vm.trip.vehicle.stockNumber">({{ vm.trip.vehicle.stockNumber }})</span> {{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}</div><div class="padding-top-md"><div ng-if="vm.trip.workflowId !== 19"><strong>{{ vm.trip.customerAddress }} {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</strong></div><div ng-if="vm.trip.workflowId === 19"><strong>{{ vm.trip.dealer.name }}</strong></div>Drop Off <span ng-if="vm.trip.vehicle.stockNumber">({{ vm.trip.vehicle.stockNumber }})</span> {{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}<div ng-if="vm.trip.workflowId === 20">Pick Up <span ng-if="vm.trip.vehicle2.stockNumber">({{ vm.trip.vehicle2.stockNumber }})</span> {{ vm.trip.vehicle2.year }} {{ vm.trip.vehicle2.make }} {{ vm.trip.vehicle2.model }}</div></div></div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3>Notes for Driver</h3><div>{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong>Need to change your delivery?</strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-6 col-sm-3"><h3>Your Driver</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your driver has not been assigned.<br>Please check back soon.</div></div><div class="col-xs-6 col-sm-9" ng-if="vm.trip.dealer.serviceAdvisorName"><h3>Your Advisor</h3><div>{{ vm.trip.dealer.serviceAdvisorName }}</div></div></div><div class="row padding-top-md"><div class="col-xs-6 col-sm-3"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div><div class="col-xs-6 col-sm-9"><img class="profile-photo" ng-src="{{ ::vm.trip.dealer.serviceAdvisorProfilePicture }}"></div></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-recall.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === true"><div class="margin-bottom-30">We were looking forward to picking up your vehicle for service. If you would like to try again please click the \'SCHEDULE A PICK UP\' button below. Hope to hear from you soon.</div><button type="button" class="btn btn-rounded btn-primary" ng-click="vm.reschedule()">SCHEDULE A PICK UP</button></div><div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === false"><div class="margin-bottom-30">We were looking forward to picking up your vehicle for service. If you would like to try again please call the dealer at {{ vm.dealerBranding.salesPhoneNumber | tel}}. Hope to hear from you soon.</div></div><div ng-if="vm.trip.state === vm.tripStates.complete"><div ng-if="!vm.trip.hasSurvey" class="row"><div class="col-xs-12"><div>We hope it was a great experience for you and look forward to servicing your vehicle in the future.</div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text">Recall Pick Up Confirmation</div><div>You\'re All Set.</div><div class="padding-top-md">Your service pick up has been booked. You will receive an email and text message confirmation.<br>Next Step: You will recieve a text message reminder 2 hours before your scheduled pick up time.</div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><strong>Confirmation #{{ vm.trip.id }}</strong><div class="panel panel-default calendar-panel margin-top-md"><div class="panel-heading text-center appointment-banner"><h1>RECALL</h1></div><div class="panel-body text-center"><h1><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d\' }}</b></h1><h1>{{ vm.trip.customerExpectedTime | date : \'EEEE\' }}</h1><h1><b>{{ vm.trip.customerExpectedTime | date : \'h:mma\' }}</b></h1><b ng-class="{ \'visible-xs\': !vm.isInFrame }">{{ vm.trip.customerAddress }}, {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</b><div class="padding-top-md" ng-class="{\'visible-xs\': !vm.isInFrame }"><img ng-src="{{vm.customerStaticMapUrl}}" class="full-width"></div></div></div></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg"><h3>Customer Information</h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg"><h3>Vehicle Information</h3><div><div>{{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}</div></div></div><div class="padding-top-lg"><h3>Services</h3><div>{{ vm.trip.recallName }}</div></div><div class="padding-top-lg" ng-if="vm.trip.customerDescriptionOfProblem.trim().length"><h3>Additional Services</h3><div>{{ vm.trip.customerDescriptionOfProblem }}</div></div><div class="padding-top-lg"><h3>Transportation Options</h3><div>We will pick up your vehicle on:<br>{{ vm.trip.customerExpectedTime | date : \'MMMM d, yyyy\' }} at {{ vm.trip.customerExpectedTime | date : \'h:mm a\' }} at:<br><br><span ng-if="vm.trip.customerLocationName">{{ vm.trip.customerLocationName }}<br></span> {{ vm.trip.customerAddress }}<br>{{ vm.trip.customerCity }} {{ vm.trip.customerState }}, {{ vm.trip.customerZip }}</div></div><div class="padding-top-lg" ng-if="vm.trip.maskedDriversLicenseNumber || vm.trip.insurancePolicyNumber"><h3>Your Release Information</h3><div ng-if="vm.trip.maskedDriversLicenseNumber"><div>License #: {{ vm.trip.maskedDriversLicenseNumber }}</div><div>Issuing State: {{ vm.trip.driversLicenseState }}</div><div ng-if="!vm.configValues.enableDriversLicenseVerification">Expires on {{ vm.trip.driversLicenseDate | date: \'MM/yyyy\' }}</div></div><div ng-if="vm.trip.insurancePolicyNumber"><div>Insurance Carrier: {{ vm.trip.insuranceCarrier }}</div><div>Policy #: {{ vm.trip.insurancePolicyNumber }}</div><div>Expires on {{ vm.trip.insuranceDate | date: \'MM/yyyy\' }}</div></div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3>Notes for Driver</h3><div>{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong>Need to change your pickup?</strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-6 col-sm-3"><h3>Your Driver</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your driver has not been assigned.<br>Please check back soon.</div></div><div class="col-xs-6 col-sm-9" ng-if="vm.trip.dealer.serviceAdvisorName"><h3>Your Advisor</h3><div>{{ vm.trip.dealer.serviceAdvisorName }}</div></div></div><div class="row padding-top-md"><div class="col-xs-6 col-sm-3"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div><div class="col-xs-6 col-sm-9"><img class="profile-photo" ng-src="{{ ::vm.trip.dealer.serviceAdvisorProfilePicture }}"></div></div></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-service-dropoff.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === true"><div class="margin-bottom-30">We were looking forward to delivering your vehicle. If you would like to try again please click the \'SCHEDULE A DROP OFF\' button below. Hope to hear from you soon.</div><button type="button" class="btn btn-rounded btn-primary" ng-click="vm.reschedule()">SCHEDULE A DROP OFF</button></div><div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === false"><div class="margin-bottom-30" ng-if="!vm.configValues.reviewTripCanceledText || vm.configValues.reviewTripCanceledText.length === 0">We were looking forward to delivering your vehicle. If you would like to try again please call the dealer at {{ vm.dealerBranding.salesPhoneNumber | tel}}. Hope to hear from you soon.</div><div class="margin-bottom-30" ng-if="vm.configValues.reviewTripCanceledText && vm.configValues.reviewTripCanceledText.length > 0" ng-bind-html="vm.configValues.reviewTripCanceledText"></div></div><div ng-if="vm.trip.state === vm.tripStates.complete"><div ng-if="!vm.trip.hasSurvey" class="row"><div class="col-xs-12"><div ng-bind-html="vm.configValues.reviewTripCompleteText"></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.reviewIntroTitle"></div><div><span ng-bind-html="vm.configValues.confirmPageSubTitle"></span> <span ng-if="vm.configValues.reviewIntroText.trim().length" class="hidden-xs"><br><span ng-bind-html="vm.configValues.reviewIntroText"></span></span> <span ng-if="vm.configValues.reviewIntroTextMobile.trim().length" class="visible-xs"><br><span ng-bind-html="vm.configValues.reviewIntroTextMobile"></span></span></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><strong>Confirmation #{{ vm.trip.id }}</strong><div class="panel panel-default calendar-panel margin-top-md"><div class="panel-heading text-center appointment-banner"><h1 ng-bind-html="vm.configValues.reviewCalendarTitle"></h1></div><div class="panel-body text-center"><h1><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d\' }}</b></h1><h1>{{ vm.trip.customerExpectedTime | date : \'EEEE\' }}</h1><h1><b>{{ vm.trip.customerExpectedTime | date : \'h:mma\' }}</b></h1><b ng-class="{ \'visible-xs\': !vm.isInFrame }">{{ vm.trip.customerAddress }}, {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</b><div class="padding-top-md" ng-class="{\'visible-xs\': !vm.isInFrame }"><img ng-src="{{vm.customerStaticMapUrl}}" class="full-width"></div></div></div></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewCustomerInfoTitle"></h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg" ng-if="vm.configValues.reviewHideVehicleInformation !== true"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewVehicleInfoTitle"></h3><div><div>{{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}</div></div></div><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewTransportationOptionsTitle"></h3><div><div ng-if="vm.configValues.reviewTransportationSubTitle.length > 0" ng-bind-html="vm.configValues.reviewTransportationSubTitle"></div><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d, yyyy\' }}</b> at <b>{{ vm.trip.customerExpectedTime | date : \'h:mm a\' }}</b> at:<br><br><span ng-if="vm.trip.customerLocationName">{{ vm.trip.customerLocationName }}<br></span> {{ vm.trip.customerAddress }}<br>{{ vm.trip.customerCity }} {{ vm.trip.customerState }}, {{ vm.trip.customerZip }}<div class="margin-top" ng-if="vm.trip.hasLoaner === true"><b>Loaner Requested</b></div></div></div><div class="padding-top-lg" ng-if="vm.trip.customerDescriptionOfProblem.trim().length"><h3>Services</h3><div class="padding-bottom-md">{{ vm.trip.customerDescriptionOfProblem }}</div></div><div class="padding-top-lg" ng-if="vm.trip.maskedDriversLicenseNumber || vm.trip.insurancePolicyNumber"><h3>Your Release Information</h3><div ng-if="vm.trip.maskedDriversLicenseNumber"><div>License #: {{ vm.trip.maskedDriversLicenseNumber }}</div><div>Issuing State: {{ vm.trip.driversLicenseState }}</div><div ng-if="!vm.configValues.enableDriversLicenseVerification">Expires on {{ vm.trip.driversLicenseDate | date: \'MM/yyyy\' }}</div></div><div ng-if="vm.trip.insurancePolicyNumber"><div>Insurance Carrier: {{ vm.trip.insuranceCarrier }}</div><div>Policy #: {{ vm.trip.insurancePolicyNumber }}</div><div>Expires on {{ vm.trip.insuranceDate | date: \'MM/yyyy\' }}</div></div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3>Notes for Driver</h3><div class="padding-bottom-md">{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong><span ng-bind-html="vm.configValues.reviewNeedChanges"></span></strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-6 col-sm-3"><h3>Your Driver</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your driver has not been assigned.<br>Please check back soon.</div></div><div class="col-xs-6 col-sm-9" ng-if="vm.trip.dealer.serviceAdvisorName"><h3>Your Advisor</h3><div>{{ vm.trip.dealer.serviceAdvisorName }}</div></div></div><div class="row padding-top-md"><div class="col-xs-6 col-sm-3"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div><div class="col-xs-6 col-sm-9"><img class="profile-photo" ng-src="{{ ::vm.trip.dealer.serviceAdvisorProfilePicture }}"></div></div></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-service-mobilegarage.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled"><div class="margin-bottom-30" ng-if="!vm.configValues.reviewTripCanceledText || vm.configValues.reviewTripCanceledText.length === 0">We were looking forward to servicing your vehicle. If you would like to try again please call the dealer at {{ vm.dealerBranding.salesPhoneNumber | tel}}. Hope to hear from you soon.</div><div class="margin-bottom-30" ng-if="vm.configValues.reviewTripCanceledText && vm.configValues.reviewTripCanceledText.length > 0" ng-bind-html="vm.configValues.reviewTripCanceledText"></div></div><div ng-if="vm.trip.state === vm.tripStates.complete"><div ng-if="!vm.trip.hasSurvey" class="row"><div class="col-xs-12"><div ng-bind-html="vm.configValues.reviewTripCompleteText"></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.reviewIntroTitle"></div><div><span ng-bind-html="vm.configValues.confirmPageSubTitle"></span> <span ng-if="vm.configValues.reviewIntroText.trim().length" class="hidden-xs"><br><span ng-bind-html="vm.configValues.reviewIntroText"></span></span> <span ng-if="vm.configValues.reviewIntroTextMobile.trim().length" class="visible-xs"><br><span ng-bind-html="vm.configValues.reviewIntroTextMobile"></span></span></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><calendar-post-it-note caltitle="vm.configValues.reviewCalendarTitle" date="vm.trip.customerExpectedTime" trip-id="vm.trip.id"></calendar-post-it-note></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewCustomerInfoTitle"></h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg" ng-if="vm.configValues.reviewHideVehicleInformation !== true"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewVehicleInfoTitle"></h3><div><div>{{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}</div></div></div><div class="padding-top-lg" ng-if="vm.trip.customerDescriptionOfProblem.trim().length"><h3 class="text-uppercase">Services</h3><div>{{ vm.trip.customerDescriptionOfProblem }}</div></div><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewTransportationOptionsTitle"></h3><div><div ng-if="vm.configValues.reviewTransportationSubTitle.length > 0" ng-bind-html="vm.configValues.reviewTransportationSubTitle"></div><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d, yyyy\' }}</b> at <b>{{ vm.trip.customerExpectedTime | date : \'h:mm a\' }}</b> at:<br><br><span ng-if="vm.trip.customerLocationName">{{ vm.trip.customerLocationName }}<br></span> {{ vm.trip.customerAddress }}<br>{{ vm.trip.customerCity }} {{ vm.trip.customerState }}, {{ vm.trip.customerZip }}</div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3 class="text-uppercase">Notes for Driver</h3><div>{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong><span ng-bind-html="vm.configValues.reviewNeedChanges"></span></strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-6 col-sm-3"><h3 class="text-uppercase">Your Mobile Tech</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your mobile technician has not been assigned.<br>Please check back soon.</div></div><div class="col-xs-6 col-sm-9" ng-if="vm.trip.dealer.serviceAdvisorName"><h3 class="text-uppercase">Your Advisor</h3><div>{{ vm.trip.dealer.serviceAdvisorName }}</div></div></div><div class="row padding-top-md"><div class="col-xs-6 col-sm-3"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div><div class="col-xs-6 col-sm-9"><img class="profile-photo" ng-src="{{ ::vm.trip.dealer.serviceAdvisorProfilePicture }}"></div></div></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-service-pickup.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === true"><div class="margin-bottom-30">We were looking forward to picking up your vehicle for service. If you would like to try again please click the \'SCHEDULE A PICK UP\' button below. Hope to hear from you soon.</div><button type="button" class="btn btn-rounded btn-primary" ng-click="vm.reschedule()">SCHEDULE A PICK UP</button></div><div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === false"><div class="margin-bottom-30" ng-if="!vm.configValues.reviewTripCanceledText || vm.configValues.reviewTripCanceledText.length === 0">We were looking forward to picking up your vehicle for service. If you would like to try again please call the dealer at {{ vm.dealerBranding.salesPhoneNumber | tel}}. Hope to hear from you soon.</div><div class="margin-bottom-30" ng-if="vm.configValues.reviewTripCanceledText && vm.configValues.reviewTripCanceledText.length > 0" ng-bind-html="vm.configValues.reviewTripCanceledText"></div></div><div ng-if="vm.trip.state === vm.tripStates.complete"><div ng-if="!vm.trip.hasSurvey" class="row"><div class="col-xs-12"><div ng-bind-html="vm.configValues.reviewTripCompleteText"></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.reviewIntroTitle"></div><div><span ng-bind-html="vm.configValues.confirmPageSubTitle"></span> <span ng-if="vm.configValues.reviewIntroText.trim().length" class="hidden-xs"><br><span ng-bind-html="vm.configValues.reviewIntroText"></span></span> <span ng-if="vm.configValues.reviewIntroTextMobile.trim().length" class="visible-xs"><br><span ng-bind-html="vm.configValues.reviewIntroTextMobile"></span></span></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><strong>CONFIRMATION #{{ vm.trip.id }}</strong><div class="panel panel-default calendar-panel margin-top-md"><div class="panel-heading text-center appointment-banner"><h1 ng-bind-html="vm.configValues.reviewCalendarTitle"></h1></div><div class="panel-body text-center"><h1><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d\' }}</b></h1><h1>{{ vm.trip.customerExpectedTime | date : \'EEEE\' }}</h1><h1><b>{{ vm.trip.customerExpectedTime | date : \'h:mma\' }}</b></h1><b ng-class="{ \'visible-xs\': !vm.isInFrame }">{{ vm.trip.customerAddress }}, {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</b><div class="padding-top-md" ng-class="{\'visible-xs\': !vm.isInFrame }"><img ng-src="{{vm.customerStaticMapUrl}}" class="full-width"></div></div></div></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewCustomerInfoTitle"></h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg" ng-if="vm.configValues.reviewHideVehicleInformation !== true"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewVehicleInfoTitle"></h3><div><div>{{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}</div></div></div><div class="padding-top-lg" ng-if="vm.trip.customerDescriptionOfProblem.trim().length"><h3 class="text-uppercase">Services</h3><div>{{ vm.trip.customerDescriptionOfProblem }}</div></div><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewTransportationOptionsTitle"></h3><div><div ng-if="vm.configValues.reviewTransportationSubTitle.length > 0" ng-bind-html="vm.configValues.reviewTransportationSubTitle"></div><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d, yyyy\' }}</b> at <b>{{ vm.trip.customerExpectedTime | date : \'h:mm a\' }}</b> at:<br><br><span ng-if="vm.trip.customerLocationName">{{ vm.trip.customerLocationName }}<br></span> {{ vm.trip.customerAddress }}<br>{{ vm.trip.customerCity }} {{ vm.trip.customerState }}, {{ vm.trip.customerZip }}<div class="margin-top" ng-if="vm.trip.hasLoaner === true && vm.trip.dealerHasLoanerPreferencesEnabled === false"><b>Loaner Requested</b></div></div></div><div class="margin-top-30" ng-if="vm.trip.hasLoaner === true && vm.trip.dealerHasLoanerPreferencesEnabled === true"><div ng-if="!vm.trip.loanerPreferences"><b>Loaner Requested (Preferences Pending)</b></div><div ng-if="vm.trip.loanerPreferences"><div class="margin-bottom"><b>Loaner Preference</b></div><loaner-preference-summary ng-model="vm.trip.loanerPreferences"></loaner-preference-summary></div></div><div class="padding-top-lg" ng-if="vm.trip.maskedDriversLicenseNumber || vm.trip.insurancePolicyNumber"><h3 class="text-uppercase">Your Release Information</h3><div ng-if="vm.trip.maskedDriversLicenseNumber"><div>License #: {{ vm.trip.maskedDriversLicenseNumber }}</div><div>Issuing State: {{ vm.trip.driversLicenseState }}</div><div ng-if="!vm.configValues.enableDriversLicenseVerification">Expires on {{ vm.trip.driversLicenseDate | date: \'MM/yyyy\' }}</div></div><div ng-if="vm.trip.insurancePolicyNumber"><div>Insurance Carrier: {{ vm.trip.insuranceCarrier }}</div><div>Policy #: {{ vm.trip.insurancePolicyNumber }}</div><div>Expires on {{ vm.trip.insuranceDate | date: \'MM/yyyy\' }}</div></div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3 class="text-uppercase">Notes for Driver</h3><div>{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong><span ng-bind-html="vm.configValues.reviewNeedChanges"></span></strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-6 col-sm-3"><h3 class="text-uppercase">Your Driver</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your driver has not been assigned.<br>Please check back soon.</div></div><div class="col-xs-6 col-sm-9" ng-if="vm.trip.dealer.serviceAdvisorName"><h3 class="text-uppercase">Your Advisor</h3><div>{{ vm.trip.dealer.serviceAdvisorName }}</div></div></div><div class="row padding-top-md"><div class="col-xs-6 col-sm-3"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div><div class="col-xs-6 col-sm-9"><img class="profile-photo" ng-src="{{ ::vm.trip.dealer.serviceAdvisorProfilePicture }}"></div></div></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-test-drive.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === true"><div class="margin-bottom-30">We were looking forward to delivering you a test drive. If you would like to try again please click the \'BOOK A TEST DRIVE\' button below. Hope to hear from you soon.</div><button type="button" class="btn btn-rounded btn-primary" ng-click="vm.reschedule()">BOOK A TEST DRIVE</button></div><div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === false"><div class="margin-bottom-30">We were looking forward to delivering you a test drive. If you would like to try again please call the dealer at {{ vm.dealerBranding.salesPhoneNumber | tel}}. Hope to hear from you soon.</div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text">Test Drive Reservation Confirmation</div><div class="visible-xs"><span ng-bind-html="vm.injectModelYear(vm.configValues.mobileReservationConfirmationIntroText)"></span></div><div class="hidden-xs"><div ng-bind-html="vm.injectModelYear(vm.configValues.reservationConfirmationIntroText)"></div></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><strong>Confirmation #{{ vm.trip.id }}</strong><div class="panel panel-default calendar-panel margin-top-md"><div class="panel-heading text-center appointment-banner"><h1>TEST DRIVE</h1></div><div class="panel-body text-center"><h1><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d\' }}</b></h1><h1>{{ vm.trip.customerExpectedTime | date : \'EEEE\' }}</h1><h1><b>{{ vm.trip.customerExpectedTime | date : \'h:mma\' }}</b></h1><b ng-class="{ \'visible-xs\': !vm.isInFrame }">{{ vm.trip.customerAddress }}, {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</b><div class="padding-top-md" ng-class="{\'visible-xs\': !vm.isInFrame }"><img ng-src="{{vm.customerStaticMapUrl}}" class="full-width"></div></div></div></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg"><h3>Customer Information</h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg"><h3>Vehicle Information</h3><div><div>{{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }} {{ vm.trip.vehicle.styleName }}</div><div><span ng-if="vm.trip.vehicle.isVehicleNew">New</span> <span ng-if="!vm.trip.vehicle.isVehicleNew">Pre-owned</span> <span ng-if="vm.trip.vehicle.stockNumber">(#{{ vm.trip.vehicle.stockNumber }})</span></div></div></div><div class="padding-top-lg"><h3>Transportation Options</h3><div>We will bring your test drive on:<br>{{ vm.trip.customerExpectedTime | date : \'MMMM d, yyyy\' }} at {{ vm.trip.customerExpectedTime | date : \'h:mm a\' }} at:<br><br><span ng-if="vm.trip.customerLocationName">{{ vm.trip.customerLocationName }}<br></span> {{ vm.trip.customerAddress }}<br>{{ vm.trip.customerCity }} {{ vm.trip.customerState }}, {{ vm.trip.customerZip }}</div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3>Notes for Driver</h3><div class="padding-bottom-md">{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong>Need to change your delivery?</strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-12"><h3>Your Vehicle Representative</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your driver has not been assigned.<br>Please check back soon.</div></div></div><div class="row padding-top-md"><div class="col-xs-12"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div></div></div>');
$templateCache.put('app/areas/consumer/trip/views/partials/summary-vehicle-delivery.view.html','<div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === true"><div class="margin-bottom-30">We were looking forward delivering your new vehicle. If you would like to try again please click the \'SCHEDULE DELIVERY\' button below. Hope to hear from you soon.</div><button type="button" class="btn btn-rounded btn-primary" ng-click="vm.reschedule()">SCHEDULE DELIVERY</button></div><div ng-if="vm.trip.state === vm.tripStates.canceled && vm.allowEditCancel() === false"><div class="margin-bottom-30" ng-if="!vm.configValues.reviewTripCanceledText || vm.configValues.reviewTripCanceledText.length === 0">We were looking forward to delivering your vehicle. If you would like to try again please call the dealer at {{ vm.dealerBranding.salesPhoneNumber | tel}}. Hope to hear from you soon.</div><div class="margin-bottom-30" ng-if="vm.configValues.reviewTripCanceledText && vm.configValues.reviewTripCanceledText.length > 0" ng-bind-html="vm.configValues.reviewTripCanceledText"></div></div><div ng-if="vm.trip.state === vm.tripStates.complete"><div ng-if="!vm.trip.hasSurvey" class="row"><div class="col-xs-12"><div ng-bind-html="vm.configValues.reviewTripCompleteText"></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled && vm.trip.state !== vm.tripStates.complete"><div class="row"><div class="col-xs-12"><div class="text-uppercase consumer-header-text" ng-bind-html="vm.configValues.reviewIntroTitle"></div><div class="hidden-xs" ng-bind-html="vm.configValues.reviewIntroText"></div><div class="visible-xs" ng-bind-html="vm.configValues.reviewIntroTextMobile"></div></div></div></div><div ng-if="vm.trip.state !== vm.tripStates.canceled"><div class="row"><div class="col-sm-4 col-sm-push-8 col-xs-12 margin-top-30"><strong>CONFIRMATION #{{ vm.trip.id }}</strong><div class="panel panel-default calendar-panel margin-top-md"><div class="panel-heading text-center calendar-panel appointment-banner"><h1>DELIVERY ON</h1></div><div class="panel-body text-center"><h1><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d\' }}</b></h1><h1>{{ vm.trip.customerExpectedTime | date : \'EEEE\' }}</h1><h1><b>{{ vm.trip.customerExpectedTime | date : \'h:mma\' }}</b></h1><b ng-class="{ \'visible-xs\': !vm.isInFrame }">{{ vm.trip.customerAddress }}, {{ vm.trip.customerCity }} {{ vm.trip.customerState }}</b><div class="padding-top-md" ng-class="{\'visible-xs\': !vm.isInFrame }"><img ng-src="{{vm.customerStaticMapUrl}}" class="full-width"></div></div></div></div><div class="col-sm-8 col-sm-pull-4 col-xs-12"><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewCustomerInfoTitle"></h3><div>{{ vm.trip.customerName }}</div><div>{{ vm.trip.customerEmail }}</div><div>{{ vm.trip.customerPhone | tel }}</div></div><div class="padding-top-lg" ng-if="vm.configValues.reviewHideVehicleInformation !== true"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewVehicleInfoTitle"></h3><div><div>{{ vm.trip.vehicle.year }} {{ vm.trip.vehicle.make }} {{ vm.trip.vehicle.model }}</div></div></div><div ng-if="vm.trip.vehicle2 && vm.trip.vehicle2.year !== null" class="padding-top-lg"><h3 class="text-uppercase">Trade In Information</h3><div><div>{{ vm.trip.vehicle2.year }} {{ vm.trip.vehicle2.make }} {{ vm.trip.vehicle2.model }}</div></div></div><div class="padding-top-lg"><h3 class="text-uppercase" ng-bind-html="vm.configValues.reviewTransportationOptionsTitle"></h3><div><div ng-if="vm.configValues.reviewTransportationSubTitle.length > 0" ng-bind-html="vm.configValues.reviewTransportationSubTitle"></div><b>{{ vm.trip.customerExpectedTime | date : \'MMMM d, yyyy\' }}</b> at <b>{{ vm.trip.customerExpectedTime | date : \'h:mm a\' }}</b> at:<br><br><span ng-if="vm.trip.customerLocationName">{{ vm.trip.customerLocationName }}<br></span> {{ vm.trip.customerAddress }}<br>{{ vm.trip.customerCity }} {{ vm.trip.customerState }}, {{ vm.trip.customerZip }}</div></div><div class="padding-top-lg" ng-if="vm.trip.tripNote.trim().length"><h3 class="text-uppercase">Notes for Driver</h3><div>{{ vm.trip.tripNote }}</div></div><div class="padding-top-lg" ng-if="vm.trip.state !== vm.tripStates.complete && !vm.configValues.allowCustomerToEditTrips"><strong><span ng-bind-html="vm.configValues.reviewNeedChanges"></span></strong><br>Please contact us at {{ vm.trip.dealer.phoneNumber | tel }}</div></div></div><div class="row padding-top-lg"><div class="driver-info col-xs-12"><h3>Your Driver</h3><div ng-if="vm.trip.driver.name"><div>{{ vm.trip.driver.name }}</div><div>{{ vm.trip.stateName }}</div></div><div ng-if="!vm.trip.driver.name">Your driver has not been assigned.<br>Please check back soon.</div></div></div><div class="row padding-top-md"><div class="col-xs-12"><img class="profile-photo" ng-src="{{ ::vm.trip.driver.driverPhoto }}"></div></div></div>');
$templateCache.put('app/areas/location/views/loaner/settings/tab-loaner-notifications.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div id="location-loaner-form"><form role="form" name="inputForm" class="form-horizontal form"><h3>Loaner Notifications</h3><div>Manage the settings for Loaner Notifications</div><div class="hr-line-solid"></div><div class="panel panel-default"><div class="panel-heading"><span class="text-bold">Loaner Homework Notification - SMS</span><div class="pull-right"><switch id="switch-sms-enabled" name="switch-sms-enabled" ng-model="vm.homework.isEnabled" class="green"></switch></div></div><div class="panel-body" ng-if="vm.homework.isEnabled"><div>Sent to a customer after a loaner booking to collect credentials and customer preferences.</div><div class="margin-top-md text-bold">Body</div><textarea ng-model="vm.homework.body" class="form-control resize-none" ng-required="vm.homework.isEnabled" ng-disabled="!vm.homework.isEnabled"></textarea></div></div><div class="panel panel-default"><div class="panel-heading"><span class="text-bold">Loaner Homework Reminder - SMS</span><div class="pull-right"><switch id="switch-sms-enabled" name="switch-sms-enabled" ng-model="vm.reminder.isEnabled" class="green"></switch></div></div><div class="panel-body" ng-if="vm.reminder.isEnabled"><div>Sent to a customer as a reminder if they have not completed the loaner homework.</div><div class="margin-top-md text-bold">Body</div><textarea ng-model="vm.reminder.body" class="form-control resize-none" ng-required="vm.reminder.isEnabled" ng-disabled="!vm.reminder.isEnabled"></textarea><div class="margin-top-md">If not completed, send as reminder <input type="number" min="1" maxlength="5" class="form-control" ng-required="vm.reminder.isEnabled" ng-disabled="!vm.reminder.isEnabled" ng-model="vm.reminder.time" mask-restrict="reject" mask="9?9?9?9?9" clean="true" placeholder="120"> minutes prior to appointment/pickup</div></div></div></form></div></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.saving" ng-disabled="inputForm.$invalid" ng-click="vm.saveChanges(inputForm.$valid)">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.currentLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/views/loaner/settings/tab-loaner-preferences.view.html','<div class="full-width-height overflow-hidden display-flex flex-row"><div class="display-flex flex-column full-width" fill-height=""><div class="display-flex flex-column flex-grow flex-percent-90 overflow-y-auto"><div class="padding-lg" fill-height=""><div id="location-loaner-settings-form" class="loaner-settings"><form role="form" name="inputForm" class="form-horizontal form"><div class="margin-bottom-30"><h3>General Settings</h3><div>Manage the settings and configuration for loaner management</div><div class="hr-line-solid"></div><div class="row margin-bottom-md margin-top-20"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="Should loaner capacity, from the Loaner Management System, be taken into account for trips and appointments with loaner vehicles?" popover-trigger="outsideClick">Enable Loaner Capacity</span></label><div class="col-sm-4"><switch id="switch-enable-loaner-capacity" name="switch-enable-loaner-capacity" ng-model="vm.resolvedSettings.useLoanerCapacity" class="green"></switch></div></div><div class="row margin-bottom-md margin-top-20"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="The default length the loaner will be out. This value is the same as Promise Time on the Appointments General tab. Changing this value will also change the value for the Appointments product." popover-trigger="outsideClick">Default Length of Loan</span></label><div class="col-sm-1"><input required="" type="number" name="length-of-loan" ng-model="vm.resolvedSettings.lengthOfLoan" class="form-control text-uppercase"></div></div></div><div class="margin-bottom-30"><h3>Class Capacity and Vehicle Preferences</h3><div>Manage the settings for Class Capacity and Vehicle Preferences during booking and loaner homework.</div><div class="hr-line-solid"></div><div class="row margin-bottom-md margin-top-20"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="Enables Custom Fit Loaner features in the Loaner Homework. When enabled, vehicles must be configured." popover-trigger="outsideClick">Enable Loaner Preferences</span></label><div class="col-sm-3"><switch id="switch-enable" name="switch-enabled" ng-model="vm.resolvedSettings.enableLoanerPreferences" class="green"></switch></div></div><div class="row margin-bottom-md" ng-if="vm.resolvedSettings.enableLoanerPreferences"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="When enabled, the customer will have the option to choose Lyft Credits instead of a loaner in the Loaner Homework. Credit Amount and Days to Expire are required." popover-trigger="outsideClick">Offer Rideshare Voucher Alternative</span></label><div class="col-sm-1"><switch id="switch-enable-lyft-credits" name="switch-enable-lyft-credits" ng-model="vm.resolvedSettings.enableLyftCreditAlternative" class="green" disabled="vm.hasLyftCredit === false"></switch></div><div class="col-sm-2" ng-if="vm.resolvedSettings.enableLyftCreditAlternative"><input type="number" class="better-placeholder form-control text-uppercase" ng-model="vm.resolvedSettings.lyftCreditAmount" required="required" placeholder="CREDIT AMOUNT"></div><div class="col-sm-2" ng-if="vm.resolvedSettings.enableLyftCreditAlternative"><input type="number" min="0" class="better-placeholder form-control text-uppercase" ng-model="vm.resolvedSettings.lyftCreditExpiration" required="required" placeholder="DAYS TO EXPIRE" mask-restrict="reject" mask="9?9?9?9?9" clean="true"></div><div class="col-sm-3 margin-top-md" ng-if="vm.hasLyftCredit === false">*Dealer does not have Lyft Credits</div></div><div class="row margin-bottom-md" ng-if="vm.resolvedSettings.enableLoanerPreferences"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="When enabled, loaner options in the Loaner Homework will show daily charges, and estimated charges will display on the loaner tab. The Daily Cost field on each loaner option below is required." popover-trigger="outsideClick">Enable Upcharge fee</span></label><div class="col-sm-3"><switch id="switch-enable-upcharge" name="switch-enable-upcharge" ng-change="vm.enableUpchargeChanged" ng-model="vm.resolvedSettings.enableUpchargeFee" class="green"></switch></div></div><div class="row margin-bottom-md" ng-if="vm.resolvedSettings.enableLoanerPreferences"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="When enabled, displays daily charges based on points in addition to dollar amounts. The Daily Points field on each loaner options below is required." popover-trigger="outsideClick">Enable LAR Points Upcharge</span></label><div class="col-sm-3"><switch id="switch-enable-lar-upcharge" name="switch-enable-lar-upcharge" disabled="!vm.resolvedSettings.enableUpchargeFee" ng-model="vm.resolvedSettings.enableLarPointsUpcharge" class="green"></switch></div></div><div class="row margin-bottom-20" ng-if="vm.resolvedSettings.enableLoanerPreferences"><label class="col-sm-2 padding-right-none control-label"><span class="cursor-pointer hover-underline" uib-popover="Prevents the customer from selecting loaner preferences too close to their appointment. The number of minutes prior to their appointment is required when enabled." popover-trigger="outsideClick">Expire Preference Selection</span></label><div class="col-sm-1"><switch id="switch-expire-selection" name="switch-expire-selection" ng-model="vm.resolvedSettings.enableSelectionExpiration" class="green"></switch></div><div class="col-sm-2" ng-if="vm.resolvedSettings.enableSelectionExpiration"><input type="number" class="form-control text-uppercase" ng-model="vm.resolvedSettings.selectionExpirationMinutes" required="required" placeholder="Minutes"></div></div><div class="row" ng-if="vm.resolvedSettings.enableLoanerPreferences"><label class="col-sm-2 control-label"><span class="cursor-pointer hover-underline" uib-popover="Class/Vehicle Options allows for the configuration of vehicles available to choose from in loaner preferences." popover-trigger="outsideClick">Class/Vehicle Options</span></label></div><div class="row" ng-repeat="vehicle in vm.resolvedSettings.vehicles" ng-if="vm.resolvedSettings.enableLoanerPreferences"><div class="col-sm-12"><loaner-settings-vehicle-config ng-model="vehicle" on-remove="vm.removeVehicle($index)" upcharge-enabled="vm.resolvedSettings.enableUpchargeFee" points-enabled="vm.resolvedSettings.enableLarPointsUpcharge" makes="vm.makes" dealer-id="vm.resolvedLocation.id"></loaner-settings-vehicle-config></div></div><div class="row" ng-if="vm.resolvedSettings.enableLoanerPreferences"><div class="col-sm-12"><button type="button" class="btn btn-text-only text-capitalize theme-link pull-right" ng-click="vm.addNewVehicle()">Add New</button></div></div></div></form></div></div></div><div class="flex-fullwidth-70h display-flex flex-row shadow-border-top full-width content-center flex-wrap padding-right-20"><div class="flex-percent-50 full-width text-left"><event-alert></event-alert></div><div class="flex-grow flex-percent-50 full-width text-right padding-right-md"><button type="button" class="btn btn-default margin-right-sm" ng-class="config.styleClass" ng-click="$dismiss()" ui-sref="location-list">Close</button> <button type="button" class="btn btn-primary" ng-class="config.styleClass" ladda="vm.saving" ng-disabled="inputForm.$invalid" ng-click="vm.saveChanges(inputForm.$valid)">Update</button></div></div></div></div><location-sub-menu trip-types="vm.dealerTripTypes" has-check-in="vm.hasCheckIn" current-location="vm.resolvedLocation"></location-sub-menu>');
$templateCache.put('app/areas/location/components/tasks/selections/selection.component.view.html','<div ng-if="vm.getItemCount() < 2" class="row"><span class="col-sm-12 margin-top-md text-danger">Must have 2 or more items</span></div><div ng-repeat="item in vm.ngModel.items" class="row form-group margin-top-20" ng-if="!item.disabled"><span class="col-xs-1 text-center padding-right-none task-radio-check-col"><input type="checkbox" class="radio-inline form-control-static text-center" ng-if="vm.ngModel.taskType == 12"> <input type="radio" class="radio-inline form-control-static text-center" name="{{vm.ngModel.questionId}}_radio" ng-if="vm.ngModel.taskType == 13"></span><div class="col-xs-10 padding-right-none padding-left-sm"><input class="form-control better-placeholder" type="text" ng-model="item.text" name="{{vm.ngModel.questionId}}_checkbox_{{$index}}" value="{{item.text}}" placeholder="TEXT TO DISPLAY FOR THIS ITEM" required="required"> <input type="hidden" ng-model="item.id"> <input type="hidden" ng-model="item.sortOrder"> <input type="hidden" ng-model="item.disabled"></div><div class="col-xs-1"><label class="control-label theme-link bg-transparent margin-top" ng-click="vm.ngModel.items.splice($index, 1)"><i class="material-icons theme-link centered-vertical inline" style="font-size:2em" title="REMOVE">remove</i></label></div></div><div class="row"><div class="col-xs-12 text-right"><span class="theme-link pull-right" ng-click="vm.ngModel.items.push({})">ADD NEW</span></div></div>');
$templateCache.put('app/areas/location/components/loaner/settings/vehicle-config/vehicle-config.view.html','<div class="margin-left-large margin-top-20 loaner-settings"><div class="row margin-bottom"><div class="col-sm-9"><div class="row"><div class="col-sm-2 padding-right-none"><input type="number" name="rank_{{vm.myUniqueId}}" validation="required" class="better-placeholder form-control" required="required" placeholder="RANK" ng-model="vm.ngModel.rank"></div><div class="col-sm-3 padding-right-none field-wrapper"><label for="make">Make</label><select selectlabel="" name="make_{{vm.myUniqueId}}" class="form-control" validation="required" required="required" ng-model="vm.ngModel.make" ng-change="vm.makeChanged();" ng-options="make.id as make.name for make in vm.makes"><option value="" disabled="" selected="">Make</option></select></div><div class="col-sm-3 padding-right-none field-wrapper"><label for="model">model</label><select selectlabel="" name="model_{{vm.myUniqueId}}" validation="required" class="form-control" required="required" ng-model="vm.ngModel.model" ng-options="model.id as model.name for model in vm.models"><option value="" disabled="" selected="">Model</option></select></div><div class="col-sm-2 padding-right-none" ng-if="!vm.upchargeEnabled"><input type="number" class="better-placeholder form-control" placeholder="DAILY COST" ng-model="vm.ngModel.dailyCost" ng-disabled="!vm.upchargeEnabled"></div><div class="col-sm-2 padding-right-none" ng-if="vm.upchargeEnabled"><input type="number" name="cost_{{vm.myUniqueId}}" class="better-placeholder form-control" validation="required" required="required" placeholder="DAILY COST" ng-model="vm.ngModel.dailyCost"></div><div class="col-sm-2" ng-if="!vm.pointsEnabled"><input type="number" class="better-placeholder form-control" placeholder="DAILY POINTS" ng-model="vm.ngModel.dailyPoints" ng-disabled="!vm.pointsEnabled"></div><div class="col-sm-2" ng-if="vm.pointsEnabled"><input type="number" name="points_{{vm.myUniqueId}}" class="better-placeholder form-control" validation="required" required="required" placeholder="DAILY POINTS" ng-model="vm.ngModel.dailyPoints"></div></div><div class="row margin-top-md"><div class="col-sm-12"><input type="text" class="better-placeholder form-control" placeholder="COMMENT" ng-model="vm.ngModel.comment"></div></div></div><div class="col-sm-3 margin-left-negative-20"><div class="col-sm-10"><drag-drop-image ng-model="vm.ngModel" native-camera-only="true" ng-required="true"></drag-drop-image></div><div class="col-sm-2 align-material-icon height-78" ng-if="!vm.canAdd"><button type="button" class="btn btn-text-only" ng-click="vm.onRemove(index)"><i class="material-icons material-icons-large28 theme-link">remove</i></button></div><div class="col-sm-2 align-material-icon height-78" ng-if="vm.canAdd"><button type="button" class="btn btn-text-only" ng-click="vm.onAdd(index)"><i class="material-icons material-icons-large28 theme-link">add</i></button></div></div></div></div>');
$templateCache.put('app/areas/location/components/payments/providers/cenpos/cenpos-settings.view.html','<div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the Merchant ID?" popover-trigger="outsideClick">Merchant ID</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.merchantId" ng-required="vm.paymentProcessor" class="form-control" name="cenPosMerchantId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the CenPos Encrypted Merchant?" popover-trigger="outsideClick">Encrypted Merchant Id</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.cenPosEncryptedMerchantId" ng-required="vm.paymentProcessor === vm.paymentProcessorsEnum.cenPos" class="form-control" name="cenPosEncryptedMerchantId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the CenPos Secret Key?" popover-trigger="outsideClick">Secret Key</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.cenPosSecretKey" ng-required="vm.paymentProcessor === vm.paymentProcessorsEnum.cenPos" class="form-control" name="cenPosSecretKey"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the CenPos User name?" popover-trigger="outsideClick">User Name</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.userName" class="form-control" name="cenPosUserName"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the CenPos User Password" popover-trigger="outsideClick">Set Password</span> <input type="checkbox" ng-model="vm.ngModel.setPassword" name="setCenPosPassword" class="checkbox-inline"></label><div class="col-sm-6"><input type="password" ng-model="vm.ngModel.password" class="form-control" name="cenPosPassword" ng-disabled="!vm.ngModel.setPassword"></div></div></div>');
$templateCache.put('app/areas/location/components/payments/providers/peri/peri-settings.view.html','<div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the Merchant ID?" popover-trigger="outsideClick">Merchant ID</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.merchantId" ng-required="vm.paymentProcessor" class="form-control" name="soleraMerchantId"></div></div></div>');
$templateCache.put('app/areas/location/components/payments/providers/cardconnect/cardconnect-settings.view.html','<div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the Merchant ID?" popover-trigger="outsideClick">Merchant ID</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.merchantId" ng-required="vm.ngModel.paymentProcessor" class="form-control" name="cardConnectMerchantId"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the CenPos User name?" popover-trigger="outsideClick">User Name</span></label><div class="col-sm-6"><input type="text" ng-model="vm.ngModel.userName" class="form-control" name="cardConnectUserName"></div></div><div class="form-group"><label class="col-sm-3 control-label"><span class="cursor-pointer hover-underline" uib-popover="What is the CenPos User Password" popover-trigger="outsideClick">Set Password</span> <input type="checkbox" ng-model="vm.ngModel.setPassword" name="setCardConnectPassword" class="checkbox-inline"></label><div class="col-sm-6"><input type="password" ng-model="vm.ngModel.password" class="form-control" name="cardConnectPassword" ng-disabled="!vm.ngModel.setPassword"></div></div><card-connect-terminals ng-model="vm.ngModel.terminals"></card-connect-terminals></div>');
$templateCache.put('app/areas/location/components/payments/providers/cardconnect/cardconnect-terminals.view.html','<div class="row form-group"><div class="col-xs-3"><label>Terminal Id</label></div><div class="col-xs-3"><label>Name</label></div><div class="col-xs-3"><label>Authorization Token</label></div><div class="col-xs-3 text-right"><label>Actions</label></div></div><div class="row form-group"><div class="col-xs-3"><input type="text" name="terminalId" ng-model="vm.terminalId" class="form-control"></div><div class="col-xs-3"><input type="text" name="terminalName" ng-model="vm.name" class="form-control"></div><div class="col-xs-3"><input type="text" name="terminalAuthorizationToken" ng-model="vm.authorizationToken" class="form-control"></div><div class="col-xs-3 text-right"><button type="button" ng-click="vm.addTerminal()">Add Terminal</button></div></div><div ng-repeat="terminal in vm.terminals" class="row form-group"><div class="col-xs-3">{{terminal.terminalId}}</div><div class="col-xs-3">{{terminal.name}}</div><div class="col-xs-3">{{terminal.authorizationToken}}</div><div class="col-xs-3 text-right"><a href="#" ng-click="vm.terminals.splice($index,1)">Remove</a></div></div>');}]);